/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3013);
	module.exports = __webpack_require__(1218);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(201);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(1719);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(3084);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(163);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(1007);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(1008);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2701)();
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return isArray(this._weekdays) ? this._weekdays :
	                this._weekdays['standalone'];
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(2694)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.22.2';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)(module)))

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 7 */
[3149, 1243, 1241, 167],
/* 8 */
[3150, 167],
/* 9 */
[3146, 538],
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(547), __esModule: true };

/***/ },
/* 11 */
[3148, 1240],
/* 12 */
/***/ function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCityAvgSpeed = exports.usAverageSpeed = exports.isVowel = exports.GOOGLE_MAP_API_KEY = exports.text_definition = undefined;
	exports.toCapitalize = toCapitalize;
	exports.isProdEnv = isProdEnv;
	exports.isQaEnv = isQaEnv;
	exports.timezonLabel = timezonLabel;
	exports.addPdfFooter = addPdfFooter;
	exports.formatMoney = formatMoney;
	exports.pushParamsToUrl = pushParamsToUrl;
	exports.initMomentTimezone = initMomentTimezone;
	exports.getTimezoneMoment = getTimezoneMoment;
	exports.downLoadCSVFunc = downLoadCSVFunc;
	exports.getUrlParameterByName = getUrlParameterByName;
	exports.splitNumber = splitNumber;
	exports.delayCallback = delayCallback;
	exports.debounceEventHandler = debounceEventHandler;
	exports.today = today;
	exports.str2FixedLength = str2FixedLength;
	exports.primaryColor = primaryColor;
	exports.buttonBlueColor = buttonBlueColor;
	exports.getMapVectorOptions = getMapVectorOptions;
	exports.getMutableCircleOptions = getMutableCircleOptions;
	exports.ordinal_suffix_of = ordinal_suffix_of;
	exports.getDayRangeTitle = getDayRangeTitle;
	exports.getTextSize = getTextSize;
	exports.getDemographicText = getDemographicText;
	exports.usStates = usStates;
	exports.imageDispalyUri = imageDispalyUri;
	exports.imageEmailUri = imageEmailUri;
	exports.imageSocialUri = imageSocialUri;
	exports.pdfReportFooterDataUri = pdfReportFooterDataUri;
	exports.pdfReportHeaderDataUri = pdfReportHeaderDataUri;
	exports.insightHeaderDataUri = insightHeaderDataUri;
	exports.audienceAnywhereLogoDataUri = audienceAnywhereLogoDataUri;
	exports.addPdfFont = addPdfFont;
	
	var _momentTimezone = __webpack_require__(110);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _debounce = __webpack_require__(1365);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _env = __webpack_require__(85);
	
	var _startsWith = __webpack_require__(1651);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { connect } from 'react-redux';
	
	//import isString from 'lodash/isString';
	function toCapitalize(str) {
	  if ((0, _isEmpty2.default)(str)) return "";
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	
	function isProdEnv() {
	  return (0, _startsWith2.default)(_env.apiBaseUrl, "https://app.audienceanywhere.com");
	}
	
	function isQaEnv() {
	  return (0, _startsWith2.default)(_env.apiBaseUrl, "https://qa.audienceanywhere.com");
	}
	
	function timezonLabel(tz) {
	  var data = {
	    "America/New_York": "Eastern Time",
	    "America/Chicago": "Central Time",
	    "America/Denver": "Mountain Time",
	    "America/Los_Angeles": "Pacific Time",
	    "America/Anchorage": "Alaska Time",
	    "Pacific/Honolulu": "Hawaii Time"
	  };
	
	  if (data[tz]) return data[tz];
	  return tz;
	}
	function addPdfFooter(pdf, bottom) {
	  pdf.setFillColor(127, 127, 127);
	  if (bottom) {
	    pdf.rect(0, bottom, 210, 15, "F");
	    pdf.addImage(pdfReportFooterDataUri(), "PNG", 15, bottom + 1, 20, 0);
	    pdf.setTextColor(255, 255, 255);
	    pdf.setFontSize(9);
	    pdf.setFontType("bold");
	    pdf.text(65, bottom + 5, "Copyright © " + (0, _momentTimezone2.default)().format("YYYY") + " Claritas, LLC. All rights reserved");
	  } else {
	    pdf.rect(0, 289, 210, 15, "F");
	    pdf.addImage(pdfReportFooterDataUri(), "PNG", 15, 290, 20, 0);
	    pdf.setTextColor(255, 255, 255);
	    pdf.setFontSize(9);
	    pdf.setFontType("bold");
	    pdf.text(65, 294, "Copyright © " + (0, _momentTimezone2.default)().format("YYYY") + " Claritas, LLC. All rights reserved");
	  }
	}
	
	function formatMoney(val, c, d, t) {
	  var n = val,
	      cc = isNaN(Math.abs(c)) ? 2 : Math.abs(c),
	      dd = d === undefined ? "." : d,
	      tt = t === undefined ? "," : t,
	      s = n < 0 ? "-" : "",
	      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(cc), 10)),
	      j = i.length > 3 ? i.length % 3 : 0;
	  return s + (j ? i.substr(0, j) + tt : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + tt) + (cc ? dd + Math.abs(n - i).toFixed(cc).slice(2) : "");
	}
	
	function pushParamsToUrl(url, name, value) {
	  if (value) {
	    if (url.indexOf("?") > -1) {
	      return url + "&" + name + "=" + value;
	    } else {
	      return url + "?" + name + "=" + value;
	    }
	  } else {
	    return url;
	  }
	}
	
	var DELAY_CALLBACK_TIMER = void 0;
	var DELAY_CALLBACK_TIMER_IS_SET = false;
	
	function setTimerDelay(t, cb, v) {
	  DELAY_CALLBACK_TIMER = setTimeout(function () {
	    cb(v);
	    DELAY_CALLBACK_TIMER_IS_SET = false;
	  }, t);
	}
	function initMomentTimezone() {
	  _momentTimezone2.default.tz.add(["America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4", "America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5", "America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5", "America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6", "America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6", "Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4"]);
	}
	function getTimezoneMoment(time, tz) {
	  return tz ? time.tz(tz) : time;
	}
	
	/**
	 * @description support IE
	 * @param string {string} csv file content
	 * @param csvFileName {string} csv file name
	 */
	function downLoadCSVFunc(string) {
	  var csvFileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "sample";
	
	  var csv_string = "";
	  if (window.navigator.msSaveOrOpenBlob) {
	    csv_string = "\uFEFF" + string;
	    var blob = new Blob([csv_string], { type: "text/csv" });
	    navigator.msSaveOrOpenBlob(blob, csvFileName + ".csv");
	  } else {
	    csv_string = "data:text/csv;charset=utf-8,\uFEFF" + string;
	
	    var encodeUri = encodeURI(csv_string);
	    var link = document.createElement("a");
	    link.setAttribute("href", encodeUri);
	    link.setAttribute("download", csvFileName + ".csv");
	    document.body.appendChild(link);
	    link.click();
	  }
	}
	
	function getUrlParameterByName(name, url) {
	  if (!url) url = window.location.href;
	  name = name.replace(/[[\]]/g, "\\$&");
	  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
	  var results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return "";
	  return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	
	/**
	 *
	 * @param {string} str
	 * @param {number} digit the number of digit default:3
	 * @returns {Function}
	 * @example
	 * splitNumber('12345')()=> '12,345'
	 * splitNumber('12345')(4) => '1,2345'
	 */
	function splitNumber(s) {
	  var str = "" + s;
	  return function () {
	    var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
	
	    var newStr = "";
	    var count = 0;
	    for (var i = str.length - 1; i >= 0; i--) {
	      if (count % digit === 0 && count !== 0) {
	        newStr = str.charAt(i) + "," + newStr;
	      } else {
	        newStr = str.charAt(i) + newStr;
	      }
	      count++;
	    }
	    return newStr;
	  };
	}
	
	// Delay callback for number in ms
	function delayCallback(t, cb, v) {
	  if (!DELAY_CALLBACK_TIMER_IS_SET) {
	    DELAY_CALLBACK_TIMER_IS_SET = true;
	    setTimerDelay(t, cb, v);
	  } else {
	    window.clearTimeout(DELAY_CALLBACK_TIMER);
	    setTimerDelay(t, cb, v);
	  }
	}
	
	function debounceEventHandler() {
	  var debounced = _debounce2.default.apply(undefined, arguments);
	  return function (e) {
	    e.persist();
	    return debounced(e);
	  };
	}
	
	function today() {
	  return (0, _momentTimezone2.default)();
	}
	
	function str2FixedLength(str, len) {
	  if (str.length >= len) return str;
	
	  var result = str;
	  for (var i = 0; i < len - str.length; i++) {
	    result += "-";
	  }
	
	  return result;
	}
	
	function primaryColor() {
	  return "#26A69A";
	}
	
	// login page `login` button color
	function buttonBlueColor() {
	  return "#00A3AD";
	}
	
	function getMapVectorOptions() {
	  var result = {
	    fillColor: "" + primaryColor(),
	    fillOpacity: 0.5,
	    strokeWeight: 0,
	    clickable: true,
	    editable: true,
	    zIndex: 1
	  };
	  return result;
	}
	
	function getMutableCircleOptions() {
	  var result = {
	    fillColor: "" + primaryColor(),
	    fillOpacity: 0.5,
	    strokeWeight: 1,
	    clickable: false,
	    editable: false,
	    zIndex: 1
	  };
	  return result;
	}
	
	function ordinal_suffix_of(i) {
	  var j = i % 10,
	      k = i % 100;
	  if (j === 1 && k !== 11) {
	    return i + "st";
	  }
	  if (j === 2 && k !== 12) {
	    return i + "nd";
	  }
	  if (j === 3 && k !== 13) {
	    return i + "rd";
	  }
	  return i + "th";
	}
	
	var text_definition = exports.text_definition = function text_definition(keyword) {
	  switch (keyword) {
	    case "segment_info":
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "span",
	          { className: "text-bold" },
	          "Note:"
	        ),
	        " we will add a prefix and suffix to the ",
	        _react2.default.createElement("br", null),
	        "segment name you enter. This will establish a ",
	        _react2.default.createElement("br", null),
	        "consistent naming convention that will make",
	        _react2.default.createElement("br", null),
	        "it easier for you to identify and catalog your",
	        _react2.default.createElement("br", null),
	        "segments.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          { className: "text-bold" },
	          "Example:"
	        ),
	        " If you name your segment:",
	        " ",
	        _react2.default.createElement("br", null),
	        "\"Bill's_Segment\", it will be saved as",
	        _react2.default.createElement("br", null),
	        "[Company_Name]_Bill's_Segment_[2017_0420]"
	      );
	    case "state_tips":
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "span",
	          { className: "text-bold" },
	          "Selecting Geographic Attributes:",
	          _react2.default.createElement("br", null),
	          "Us States and Cities"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "When selecting geographic attributes,",
	        _react2.default.createElement("br", null),
	        "remember:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "ul",
	          { className: "text-normal text-gray" },
	          _react2.default.createElement(
	            "li",
	            null,
	            "You can build your segment by selecting ",
	            _react2.default.createElement("br", null),
	            "either US States/Cities or US Zip Codes."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "If you make one radio button selection ",
	            _react2.default.createElement("br", null),
	            "and select attributes for that category. any",
	            _react2.default.createElement("br", null),
	            "selections made will be deleted if you then ",
	            _react2.default.createElement("br", null),
	            "select the other radio button."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "You can select an entire US State by ",
	            _react2.default.createElement("br", null),
	            "selecting its checkbox"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "You can select a US State name or its ",
	            _react2.default.createElement("br", null),
	            "row to display that state's cities for ",
	            _react2.default.createElement("br", null),
	            "selection."
	          )
	        )
	      );
	    case "state_category_tips":
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "span",
	          { className: "text-bold" },
	          "Selecting Geographic Attributes:",
	          _react2.default.createElement("br", null),
	          "Add a Location or Plot a Radius"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "When selecting geographic attributes,",
	        _react2.default.createElement("br", null),
	        "remember:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "ul",
	          { className: "text-normal text-gray" },
	          _react2.default.createElement(
	            "li",
	            null,
	            "You can build your segment by either ",
	            _react2.default.createElement("br", null),
	            "adding a location (US State(s)/City(s)",
	            _react2.default.createElement("br", null),
	            "or US Zip Code(s)) or by plotting a ",
	            _react2.default.createElement("br", null),
	            "custom radius."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "If you make location selections and ",
	            _react2.default.createElement("br", null),
	            "then decide to plot a custom radius,",
	            _react2.default.createElement("br", null),
	            "any location selections previously",
	            _react2.default.createElement("br", null),
	            "made will be deleted."
	          )
	        )
	      );
	    case "custom_variable_tip":
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Page reference varaibles allow",
	        _react2.default.createElement("br", null),
	        "users to further report on page",
	        _react2.default.createElement("br", null),
	        "level activity by labeling one to ",
	        _react2.default.createElement("br", null),
	        "many pages with a unique",
	        _react2.default.createElement("br", null),
	        "page reference. You can enter",
	        _react2.default.createElement("br", null),
	        "up to 5 page references."
	      );
	    case "passthrough_variable_tip":
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Pass Through variables allow",
	        _react2.default.createElement("br", null),
	        "a user to inject a unique ",
	        _react2.default.createElement("br", null),
	        "identifier into the tag at the time ",
	        _react2.default.createElement("br", null),
	        "the tag is fired. This data is ",
	        _react2.default.createElement("br", null),
	        "passed to AudienceAnywhere ",
	        _react2.default.createElement("br", null),
	        "and can be used for linkage or ",
	        _react2.default.createElement("br", null),
	        "to be passed back to the client ",
	        _react2.default.createElement("br", null),
	        "as part of a data extract."
	      );
	    default:
	      return null;
	  }
	};
	
	var GOOGLE_MAP_API_KEY = exports.GOOGLE_MAP_API_KEY = function GOOGLE_MAP_API_KEY() {
	  return "AIzaSyDkrzsX9d8zjHPr3LtS0ODYrMWXqhvd4J0";
	};
	
	var isVowel = exports.isVowel = function isVowel(word) {
	  return ["a", "e", "i", "o", "u"].indexOf(word.toLowerCase().charAt(0)) !== -1;
	};
	
	var usAverageSpeed = exports.usAverageSpeed = function usAverageSpeed() {
	  return [{
	    city: "Albuquerque, NM",
	    meters_per_sec_avg: 13.941435327278,
	    steps_avg: 7.48854166666667,
	    numroutes: 960,
	    steps_std: 2.6557577009088664,
	    meters_std: 7354.9073195960609,
	    steps_per_meter_std: 0.00038095070968466836,
	    filename: "albuquerquenm",
	    steps_per_meter_avg: 0.00064638395010794506,
	    seconds_avg: 977.59270833333471,
	    lat: 35.084490899999999,
	    lng: -106.6511367,
	    meters_per_sec_std: 3.2804076536019822,
	    seconds_std: 414.43824027727896,
	    meters_avg: 14177.33854166667
	  }, {
	    city: "Arlington, TX",
	    meters_per_sec_avg: 14.741567271896431,
	    steps_avg: 7.3081896551724101,
	    numroutes: 928,
	    steps_std: 3.106498349298946,
	    meters_std: 9465.6403316875603,
	    steps_per_meter_std: 0.00044110323245383508,
	    filename: "arlingtontx",
	    steps_per_meter_avg: 0.00064502490077968956,
	    seconds_avg: 938.95258620689572,
	    lat: 32.735686999999999,
	    lng: -97.108065600000003,
	    meters_per_sec_std: 5.0675345539225605,
	    seconds_std: 363.93432364131939,
	    meters_avg: 15041.245689655181
	  }, {
	    city: "Atlanta, GA",
	    meters_per_sec_avg: 13.711571207107065,
	    steps_avg: 8.0010752688172069,
	    numroutes: 930,
	    steps_std: 2.7056928631060591,
	    meters_std: 8621.3935487432736,
	    steps_per_meter_std: 0.0005004328813630859,
	    filename: "atlantaga",
	    steps_per_meter_avg: 0.00069288317048335545,
	    seconds_avg: 1037.9505376344086,
	    lat: 33.748995399999998,
	    lng: -84.387982399999999,
	    meters_per_sec_std: 3.5719262609105571,
	    seconds_std: 397.76056339997592,
	    meters_avg: 15158.873118279585
	  }, {
	    city: "Austin, TX",
	    meters_per_sec_avg: 12.524483951806204,
	    steps_avg: 8.7284482758620658,
	    numroutes: 928,
	    steps_std: 3.0574451485820919,
	    meters_std: 7073.201516899202,
	    steps_per_meter_std: 0.00083547584327973295,
	    filename: "austintx",
	    steps_per_meter_avg: 0.00096606331161212475,
	    seconds_avg: 906.86314655172328,
	    lat: 30.268735,
	    lng: -97.745209000000003,
	    meters_per_sec_std: 3.6977525324157647,
	    seconds_std: 368.3098245797932,
	    meters_avg: 12096.67780172413
	  }, {
	    city: "Baltimore, MD",
	    meters_per_sec_avg: 11.554901777578596,
	    steps_avg: 8.1344086021505273,
	    numroutes: 930,
	    steps_std: 2.5934003605847571,
	    meters_std: 7916.7106214458108,
	    steps_per_meter_std: 0.00062991937739106843,
	    filename: "baltimoremd",
	    steps_per_meter_avg: 0.00087483180871683315,
	    seconds_avg: 1061.66559139785,
	    lat: 39.294255,
	    lng: -76.614275000000006,
	    meters_per_sec_std: 3.7374569326588887,
	    seconds_std: 388.96175316350957,
	    meters_avg: 13196.518279569884
	  }, {
	    city: "Boston, MA",
	    meters_per_sec_avg: 9.3629079248321929,
	    steps_avg: 10.476084538375973,
	    numroutes: 899,
	    steps_std: 5.0264595900755706,
	    meters_std: 124479.06416905436,
	    steps_per_meter_std: 0.0013196860446127241,
	    filename: "bostonma",
	    steps_per_meter_avg: 0.0019682311475388075,
	    seconds_avg: 1610.1991101223587,
	    lat: 42.358919999999998,
	    lng: -71.057810000000003,
	    meters_per_sec_std: 3.8015980094240334,
	    seconds_std: 4961.036954855098,
	    meters_avg: 29856.642936596196
	  }, {
	    city: "Charlotte, NC",
	    meters_per_sec_avg: 14.263660324636771,
	    steps_avg: 8.3750000000000124,
	    numroutes: 960,
	    steps_std: 2.4780580374805612,
	    meters_std: 9790.6731030409173,
	    steps_per_meter_std: 0.00053593856553699616,
	    filename: "charlottenc",
	    steps_per_meter_avg: 0.00068896866874435631,
	    seconds_avg: 1143.836458333335,
	    lat: 35.231402000000003,
	    lng: -80.845840999999993,
	    meters_per_sec_std: 4.054939831463062,
	    seconds_std: 435.82644674567405,
	    meters_avg: 17497.094791666685
	  }, {
	    city: "Chicago, IL",
	    meters_per_sec_avg: 10.582704189843318,
	    steps_avg: 7.9374999999999947,
	    numroutes: 896,
	    steps_std: 1.857041559027506,
	    meters_std: 3994.1189585467982,
	    steps_per_meter_std: 0.00048697798413757762,
	    filename: "chicagoil",
	    steps_per_meter_avg: 0.0010975687853146516,
	    seconds_avg: 773.46093749999909,
	    lat: 41.879534999999997,
	    lng: -87.624332999999993,
	    meters_per_sec_std: 2.3884533991040069,
	    seconds_std: 232.46735010206882,
	    meters_avg: 8446.2790178571522
	  }, {
	    city: "Cleveland, OH",
	    meters_per_sec_avg: 15.844693485098533,
	    steps_avg: 7.969866071428573,
	    numroutes: 896,
	    steps_std: 2.6252292017900776,
	    meters_std: 8317.3500573446818,
	    steps_per_meter_std: 0.00042587323096523349,
	    filename: "clevelandoh",
	    steps_per_meter_avg: 0.00065789600094132736,
	    seconds_avg: 943.29910714285768,
	    lat: 41.499495400000001,
	    lng: -81.695408799999996,
	    meters_per_sec_std: 4.3285137643906646,
	    seconds_std: 357.82304518295945,
	    meters_avg: 15660.167410714279
	  }, {
	    city: "Colorado Springs, CO",
	    meters_per_sec_avg: 13.151293480836284,
	    steps_avg: 7.1404786680541132,
	    numroutes: 961,
	    steps_std: 2.5743193638911417,
	    meters_std: 10346.067190000265,
	    steps_per_meter_std: 0.00054027376882302897,
	    filename: "coloradospringsco",
	    steps_per_meter_avg: 0.00068080404057148066,
	    seconds_avg: 1080.967741935485,
	    lat: 38.833881599999998,
	    lng: -104.8213634,
	    meters_per_sec_std: 3.26357501523972,
	    seconds_std: 605.61532758013959,
	    meters_avg: 15077.99999999998
	  }, {
	    city: "Columbus, OH",
	    meters_per_sec_avg: 13.987383385437603,
	    steps_avg: 8.0534274193548434,
	    numroutes: 992,
	    steps_std: 2.7219199067168418,
	    meters_std: 7445.6912811555349,
	    steps_per_meter_std: 0.00064760913397474422,
	    filename: "columbusoh",
	    steps_per_meter_avg: 0.00077802661535210425,
	    seconds_avg: 932.3205645161288,
	    lat: 39.962207999999997,
	    lng: -83.000675999999999,
	    meters_per_sec_std: 4.0480580279944638,
	    seconds_std: 320.93501148182241,
	    meters_avg: 13958.290322580646
	  }, {
	    city: "Dallas, TX",
	    meters_per_sec_avg: 11.648143971811406,
	    steps_avg: 7.5541666666666609,
	    numroutes: 960,
	    steps_std: 2.6779101257586291,
	    meters_std: 5918.9182509520224,
	    steps_per_meter_std: 0.00087832581075097883,
	    filename: "dallastx",
	    steps_per_meter_avg: 0.0011254637668290425,
	    seconds_avg: 716.27708333333294,
	    lat: 32.781078000000001,
	    lng: -96.797111000000001,
	    meters_per_sec_std: 3.7348012207206143,
	    seconds_std: 268.10739038639991,
	    meters_avg: 9026.933333333307
	  }, {
	    city: "Denver, CO",
	    meters_per_sec_avg: 9.9855690688845016,
	    steps_avg: 6.512791991101226,
	    numroutes: 899,
	    steps_std: 2.1149070259467777,
	    meters_std: 4717.54041900027,
	    steps_per_meter_std: 0.00091751403774341844,
	    filename: "denverco",
	    steps_per_meter_avg: 0.00109569029327468,
	    seconds_avg: 750.25695216907684,
	    lat: 39.755088999999998,
	    lng: -104.988105,
	    meters_per_sec_std: 3.2165544595356224,
	    seconds_std: 270.92605694936441,
	    meters_avg: 7929.8553948832032
	  }, {
	    city: "Detroit, MI",
	    meters_per_sec_avg: 15.694255223323692,
	    steps_avg: 9.0851293103448256,
	    numroutes: 928,
	    steps_std: 3.209390681815647,
	    meters_std: 9263.4590939949467,
	    steps_per_meter_std: 0.00035656229799192936,
	    filename: "detroitmi",
	    steps_per_meter_avg: 0.00054386354481824315,
	    seconds_avg: 1270.2209051724135,
	    lat: 42.330165000000001,
	    lng: -83.045912999999999,
	    meters_per_sec_std: 3.5587783550202472,
	    seconds_std: 424.63952059782264,
	    meters_avg: 20744.991379310395
	  }, {
	    city: "El Paso, TX",
	    meters_per_sec_avg: 17.649628251606142,
	    steps_avg: 8.3454861111111018,
	    numroutes: 576,
	    steps_std: 2.3971897546516336,
	    meters_std: 26208.185069775103,
	    steps_per_meter_std: 0.00046133841145021748,
	    filename: "elpasotx",
	    steps_per_meter_avg: 0.00053098461496143645,
	    seconds_avg: 1468.4774305555543,
	    lat: 31.763210000000001,
	    lng: -106.49096900000001,
	    meters_per_sec_std: 5.4920241505060918,
	    seconds_std: 883.9854078144416,
	    meters_avg: 30064.836805555537
	  }, {
	    city: "Fort Worth, TX",
	    meters_per_sec_avg: 15.480976096188439,
	    steps_avg: 8.2479166666666792,
	    numroutes: 960,
	    steps_std: 2.6649925771413105,
	    meters_std: 10195.714271694524,
	    steps_per_meter_std: 0.00040221606891219051,
	    filename: "fortworthtx",
	    steps_per_meter_avg: 0.00055082219658140195,
	    seconds_avg: 1185.7458333333338,
	    lat: 32.754919999999998,
	    lng: -97.330335000000005,
	    meters_per_sec_std: 3.7867486564920805,
	    seconds_std: 442.63185528750512,
	    meters_avg: 19426.363541666673
	  }, {
	    city: "Fresno, CA",
	    meters_per_sec_avg: 14.118728133724886,
	    steps_avg: 7.6522177419354769,
	    numroutes: 992,
	    steps_std: 2.5945326200719272,
	    meters_std: 6380.7338668883494,
	    steps_per_meter_std: 0.0006399756266716346,
	    filename: "fresnoca",
	    steps_per_meter_avg: 0.00081746489998445421,
	    seconds_avg: 818.44455645161315,
	    lat: 36.7477272,
	    lng: -119.7723661,
	    meters_per_sec_std: 3.6197953831980603,
	    seconds_std: 311.40150777088854,
	    meters_avg: 12204.258064516122
	  }, {
	    city: "Honolulu, HI",
	    meters_per_sec_avg: 12.431046634588197,
	    steps_avg: 7.8922222222222214,
	    numroutes: 900,
	    steps_std: 2.7182376585500965,
	    meters_std: 5496.3319566527407,
	    steps_per_meter_std: 0.00072529534296536611,
	    filename: "honoluluhi",
	    steps_per_meter_avg: 0.0011783712917328808,
	    seconds_avg: 675.02444444444438,
	    lat: 21.306944399999999,
	    lng: -157.8583333,
	    meters_per_sec_std: 4.0856434366730916,
	    seconds_std: 257.59536062082486,
	    meters_avg: 9054.4055555555533
	  }, {
	    city: "Houston, TX",
	    meters_per_sec_avg: 12.356247613364097,
	    steps_avg: 8.4638671875000089,
	    numroutes: 1024,
	    steps_std: 2.5703518793946549,
	    meters_std: 5210.9274231166719,
	    steps_per_meter_std: 0.00058567609927918061,
	    filename: "houstontx",
	    steps_per_meter_avg: 0.0010432458760135049,
	    seconds_avg: 777.1728515625,
	    lat: 29.759955999999999,
	    lng: -95.362533999999997,
	    meters_per_sec_std: 3.5737133042616422,
	    seconds_std: 247.59957741945507,
	    meters_avg: 10114.251953124996
	  }, {
	    city: "Indianapolis, IN",
	    meters_per_sec_avg: 15.046395515895853,
	    steps_avg: 7.5234374999999902,
	    numroutes: 1024,
	    steps_std: 2.3403965501021813,
	    meters_std: 10493.838816007856,
	    steps_per_meter_std: 0.00049684784075555396,
	    filename: "indianapolisin",
	    steps_per_meter_avg: 0.00048623620072252375,
	    seconds_avg: 1290.0048828124995,
	    lat: 39.767015999999998,
	    lng: -86.156255000000002,
	    meters_per_sec_std: 3.7030387124744353,
	    seconds_std: 464.38038788117075,
	    meters_avg: 20432.520507812504
	  }, {
	    city: "Jacksonville, FL",
	    meters_per_sec_avg: 15.726717431813762,
	    steps_avg: 8.0625000000000036,
	    numroutes: 960,
	    steps_std: 2.6058908959960783,
	    meters_std: 10494.25197501545,
	    steps_per_meter_std: 0.0003494184812161103,
	    filename: "jacksonvillefl",
	    steps_per_meter_avg: 0.000497319012575588,
	    seconds_avg: 1288.5385416666657,
	    lat: 30.326221,
	    lng: -81.657928999999996,
	    meters_per_sec_std: 3.5713793517613075,
	    seconds_std: 495.54424065491372,
	    meters_avg: 21188.897916666683
	  }, {
	    city: "Kansas City, MO",
	    meters_per_sec_avg: 17.909740828722921,
	    steps_avg: 8.4637096774193523,
	    numroutes: 992,
	    steps_std: 2.4496325942904549,
	    meters_std: 10005.533130215776,
	    steps_per_meter_std: 0.00049130304292389199,
	    filename: "kansascitymo",
	    steps_per_meter_avg: 0.00055333608693120873,
	    seconds_avg: 1080.3417338709685,
	    lat: 39.099726500000003,
	    lng: -94.578566699999996,
	    meters_per_sec_std: 4.767443101988075,
	    seconds_std: 354.91260866631774,
	    meters_avg: 20510.203629032254
	  }, {
	    city: "Las Vegas, NV",
	    meters_per_sec_avg: 13.058263037475617,
	    steps_avg: 6.9017857142857153,
	    numroutes: 896,
	    steps_std: 2.6169531396331713,
	    meters_std: 5426.1532717524879,
	    steps_per_meter_std: 0.00045701094637136646,
	    filename: "lasvegasnv",
	    steps_per_meter_avg: 0.00073675438929509556,
	    seconds_avg: 825.26450892857156,
	    lat: 36.114646,
	    lng: -115.172816,
	    meters_per_sec_std: 3.3244409105725223,
	    seconds_std: 277.95821459888299,
	    meters_avg: 11203.91852678571
	  }, {
	    city: "Long Beach, CA",
	    meters_per_sec_avg: 12.847236152673821,
	    steps_avg: 6.5591397849462361,
	    numroutes: 837,
	    steps_std: 2.6471801781345703,
	    meters_std: 6342.2931739490796,
	    steps_per_meter_std: 0.00059420033531336054,
	    filename: "longbeachca",
	    steps_per_meter_avg: 0.00086891709047508779,
	    seconds_avg: 735.03942652329704,
	    lat: 33.766962300000003,
	    lng: -118.18923479999999,
	    meters_per_sec_std: 4.688526675439638,
	    seconds_std: 278.95017583217253,
	    meters_avg: 10162.750298685791
	  }, {
	    city: "Los Angeles, CA",
	    meters_per_sec_avg: 11.961242663634785,
	    steps_avg: 7.8810483870967731,
	    numroutes: 992,
	    steps_std: 3.3578925971392728,
	    meters_std: 8401.3225393698813,
	    steps_per_meter_std: 0.00091986931041232705,
	    filename: "losangelesca",
	    steps_per_meter_avg: 0.0011946798844173101,
	    seconds_avg: 721.05745967741905,
	    lat: 34.052187000000004,
	    lng: -118.243425,
	    meters_per_sec_std: 3.9499517020839785,
	    seconds_std: 366.31953777900776,
	    meters_avg: 9731.0131048387138
	  }, {
	    city: "Louisville, KY",
	    meters_per_sec_avg: 15.868336236965749,
	    steps_avg: 7.7373046874999973,
	    numroutes: 1024,
	    steps_std: 2.3749949757496904,
	    meters_std: 38450.447364539476,
	    steps_per_meter_std: 0.00044002303897612669,
	    filename: "louisvilleky",
	    steps_per_meter_avg: 0.00053418982280948766,
	    seconds_avg: 1416.7705078125007,
	    lat: 38.254237600000003,
	    lng: -85.759406999999996,
	    meters_per_sec_std: 4.3586622915787938,
	    seconds_std: 1397.0107120872572,
	    meters_avg: 26253.31640625
	  }, {
	    city: "Memphis, TN",
	    meters_per_sec_avg: 15.981125095440436,
	    steps_avg: 7.4233333333333329,
	    numroutes: 900,
	    steps_std: 2.2688366131804454,
	    meters_std: 10610.842011466972,
	    steps_per_meter_std: 0.00035185506467718872,
	    filename: "memphistn",
	    steps_per_meter_avg: 0.00042337927193693476,
	    seconds_avg: 1400.4066666666649,
	    lat: 35.142851999999998,
	    lng: -90.052350000000004,
	    meters_per_sec_std: 3.510577772431557,
	    seconds_std: 498.1069873149878,
	    meters_avg: 23311.288888888917
	  }, {
	    city: "Mesa, AZ",
	    meters_per_sec_avg: 14.547217658268291,
	    steps_avg: 5.6139112903225827,
	    numroutes: 992,
	    steps_std: 2.3067330098654173,
	    meters_std: 8201.4277815154783,
	    steps_per_meter_std: 0.00033048485425235443,
	    filename: "mesaaz",
	    steps_per_meter_avg: 0.00047836719219453014,
	    seconds_avg: 963.54737903225873,
	    lat: 33.422268500000001,
	    lng: -111.8226402,
	    meters_per_sec_std: 3.8185248935817424,
	    seconds_std: 363.98007809277317,
	    meters_avg: 14915.339717741919
	  }, {
	    city: "Miami, FL",
	    meters_per_sec_avg: 14.475377652357873,
	    steps_avg: 7.1822916666666634,
	    numroutes: 960,
	    steps_std: 2.2772161073366273,
	    meters_std: 8129.6196591344569,
	    steps_per_meter_std: 0.00067392240879745159,
	    filename: "miamifl",
	    steps_per_meter_avg: 0.00074842935879972192,
	    seconds_avg: 888.36249999999893,
	    lat: 25.774265700000001,
	    lng: -80.193658900000003,
	    meters_per_sec_std: 3.9976031119903852,
	    seconds_std: 350.87629887408241,
	    meters_avg: 13830.110416666665
	  }, {
	    city: "Milwaukee, WI",
	    meters_per_sec_avg: 12.965440558738486,
	    steps_avg: 7.6562500000000027,
	    numroutes: 960,
	    steps_std: 2.6906090305285213,
	    meters_std: 6850.4556797913483,
	    steps_per_meter_std: 0.00069923539250366356,
	    filename: "milwaukeewi",
	    steps_per_meter_avg: 0.00073961401387226454,
	    seconds_avg: 986.97395833333337,
	    lat: 43.040182000000001,
	    lng: -87.914479999999998,
	    meters_per_sec_std: 3.428295480383563,
	    seconds_std: 342.80223848766946,
	    meters_avg: 13466.533333333326
	  }, {
	    city: "Minneapolis, MN",
	    meters_per_sec_avg: 13.139937160022562,
	    steps_avg: 7.6548913043478271,
	    numroutes: 736,
	    steps_std: 2.558257908339999,
	    meters_std: 6098.7182972765368,
	    steps_per_meter_std: 0.00059366174400186272,
	    filename: "minneapolismn",
	    steps_per_meter_avg: 0.0010286455791363842,
	    seconds_avg: 706.38043478260897,
	    lat: 44.979965399999998,
	    lng: -93.263836100000006,
	    meters_per_sec_std: 4.6322734688989833,
	    seconds_std: 244.58436625287578,
	    meters_avg: 9983.8315217391373
	  }, {
	    city: "Nashville, TN",
	    meters_per_sec_avg: 14.4908382732867,
	    steps_avg: 7.8062499999999897,
	    numroutes: 960,
	    steps_std: 2.4511839832432027,
	    meters_std: 8273.8368166659766,
	    steps_per_meter_std: 0.00042053094176331443,
	    filename: "nashvilletn",
	    steps_per_meter_avg: 0.00063591926727781228,
	    seconds_avg: 1052.9062499999993,
	    lat: 36.165889900000003,
	    lng: -86.784443199999998,
	    meters_per_sec_std: 3.4621309335992265,
	    seconds_std: 399.56893817334196,
	    meters_avg: 15991.635416666642
	  }, {
	    city: "New York, NY",
	    meters_per_sec_avg: 7.853421200066788,
	    steps_avg: 6.6660156250000133,
	    numroutes: 1024,
	    steps_std: 2.4701101450720526,
	    meters_std: 2281.5505408086387,
	    steps_per_meter_std: 0.0011149269254682515,
	    filename: "newyorkny",
	    steps_per_meter_avg: 0.0018177175459248112,
	    seconds_avg: 552.52441406250023,
	    lat: 40.756053999999999,
	    lng: -73.986951000000005,
	    meters_per_sec_std: 1.5060777594448762,
	    seconds_std: 213.66775487142917,
	    meters_avg: 4535.7646484375009
	  }, {
	    city: "Oakland, CA",
	    meters_per_sec_avg: 14.536056344112735,
	    steps_avg: 8.8303571428571459,
	    numroutes: 896,
	    steps_std: 2.5130306851015112,
	    meters_std: 6532.4314615799367,
	    steps_per_meter_std: 0.00068565256072595929,
	    filename: "oaklandca",
	    steps_per_meter_avg: 0.0010491112243080575,
	    seconds_avg: 745.51227678571331,
	    lat: 37.804372200000003,
	    lng: -122.2708026,
	    meters_per_sec_std: 4.939932060870051,
	    seconds_std: 251.87072560927854,
	    meters_avg: 11584.455357142841
	  }, {
	    city: "Oklahoma City, OK",
	    meters_per_sec_avg: 15.778248128337609,
	    steps_avg: 8.2343750000000089,
	    numroutes: 960,
	    steps_std: 2.3268540714139974,
	    meters_std: 8788.3473171428486,
	    steps_per_meter_std: 0.0004429842865987101,
	    filename: "oklahomacityok",
	    steps_per_meter_avg: 0.00057011403458940137,
	    seconds_avg: 1145.842708333332,
	    lat: 35.467560200000001,
	    lng: -97.5164276,
	    meters_per_sec_std: 3.9323559062832403,
	    seconds_std: 377.09217451473097,
	    meters_avg: 18966.210416666665
	  }, {
	    city: "Omaha, NE",
	    meters_per_sec_avg: 14.664236707720816,
	    steps_avg: 7.7849462365591435,
	    numroutes: 837,
	    steps_std: 2.7024024228011507,
	    meters_std: 10531.315541369573,
	    steps_per_meter_std: 0.00043184280500769434,
	    filename: "omahane",
	    steps_per_meter_avg: 0.00062042362470656604,
	    seconds_avg: 1084.9378733572275,
	    lat: 41.254005999999997,
	    lng: -95.999257999999998,
	    meters_per_sec_std: 3.6194334952678595,
	    seconds_std: 590.07856987328512,
	    meters_avg: 16638.36798088413
	  }, {
	    city: "Philadelphia, PA",
	    meters_per_sec_avg: 9.064401935518914,
	    steps_avg: 7.8375378405650835,
	    numroutes: 991,
	    steps_std: 2.8002243042066612,
	    meters_std: 4776.2641081758775,
	    steps_per_meter_std: 0.0012869531165803129,
	    filename: "philadelphiapa",
	    steps_per_meter_avg: 0.0013992836935943331,
	    seconds_avg: 769.73662966700283,
	    lat: 39.951639,
	    lng: -75.163808000000003,
	    meters_per_sec_std: 2.7377981835871195,
	    seconds_std: 299.66485363718738,
	    meters_avg: 7507.5953582240136
	  }, {
	    city: "Phoenix, AZ",
	    meters_per_sec_avg: 12.590995350080592,
	    steps_avg: 6.4306640624999973,
	    numroutes: 1024,
	    steps_std: 2.7229657851494062,
	    meters_std: 7311.4212315179911,
	    steps_per_meter_std: 0.00047711960822137482,
	    filename: "phoenixaz",
	    steps_per_meter_avg: 0.00071868608626241123,
	    seconds_avg: 871.45605468749898,
	    lat: 33.448262999999997,
	    lng: -112.073821,
	    meters_per_sec_std: 3.3776378816005495,
	    seconds_std: 366.8286748051425,
	    meters_avg: 11841.049804687504
	  }, {
	    city: "Portland, OR",
	    meters_per_sec_avg: 10.291708245833147,
	    steps_avg: 8.5700431034482794,
	    numroutes: 928,
	    steps_std: 2.7879860919769741,
	    meters_std: 3737.8032620674799,
	    steps_per_meter_std: 0.00082081809935214268,
	    filename: "portlandor",
	    steps_per_meter_avg: 0.0013120313138782428,
	    seconds_avg: 761.28987068965455,
	    lat: 45.5234515,
	    lng: -122.6762071,
	    meters_per_sec_std: 2.9663687741619387,
	    seconds_std: 242.90971021982045,
	    meters_avg: 8107.8372844827436
	  }, {
	    city: "Raleigh, NC",
	    meters_per_sec_avg: 15.312020705744724,
	    steps_avg: 7.7399553571428639,
	    numroutes: 896,
	    steps_std: 2.8277178745223255,
	    meters_std: 8745.736181168144,
	    steps_per_meter_std: 0.00050709927854482024,
	    filename: "raleighnc",
	    steps_per_meter_avg: 0.00063697971020645341,
	    seconds_avg: 980.47767857142821,
	    lat: 35.772095999999998,
	    lng: -78.638614500000003,
	    meters_per_sec_std: 3.8896417327979744,
	    seconds_std: 403.74111893800085,
	    meters_avg: 15837.265624999991
	  }, {
	    city: "Sacramento, CA",
	    meters_per_sec_avg: 14.093627068374536,
	    steps_avg: 7.7998046875000044,
	    numroutes: 1024,
	    steps_std: 2.6038470600551533,
	    meters_std: 23845.943808000455,
	    steps_per_meter_std: 0.00075112167564576773,
	    filename: "sacramentoca",
	    steps_per_meter_avg: 0.00095259349543879357,
	    seconds_avg: 873.82812500000011,
	    lat: 38.5815719,
	    lng: -121.49439959999999,
	    meters_per_sec_std: 4.9815741961291629,
	    seconds_std: 864.23493519761723,
	    meters_avg: 14767.05859375002
	  }, {
	    city: "San Antonio, TX",
	    meters_per_sec_avg: 14.754022512836086,
	    steps_avg: 8.7721123829344414,
	    numroutes: 961,
	    steps_std: 2.9585843693716507,
	    meters_std: 6953.8849628259022,
	    steps_per_meter_std: 0.00047014620924206352,
	    filename: "sanantoniotx",
	    steps_per_meter_avg: 0.0007343012832218684,
	    seconds_avg: 968.87408949011399,
	    lat: 29.425037,
	    lng: -98.493722000000005,
	    meters_per_sec_std: 3.8636168599139395,
	    seconds_std: 315.97518983040868,
	    meters_avg: 14949.585848074921
	  }, {
	    city: "San Diego, CA",
	    meters_per_sec_avg: 13.839423846980219,
	    steps_avg: 8.0576036866359324,
	    numroutes: 868,
	    steps_std: 2.328579722581011,
	    meters_std: 5464.0512017789979,
	    steps_per_meter_std: 0.0005592012252357162,
	    filename: "sandiegoca",
	    steps_per_meter_avg: 0.00092272301307065325,
	    seconds_avg: 758.41820276497629,
	    lat: 32.718834000000001,
	    lng: -117.16384100000001,
	    meters_per_sec_std: 3.7556391397622209,
	    seconds_std: 253.5437810231154,
	    meters_avg: 10975.838709677419
	  }, {
	    city: "San Francisco, CA",
	    meters_per_sec_avg: 8.0595267486586106,
	    steps_avg: 7.2893145161290338,
	    numroutes: 992,
	    steps_std: 2.8673968008619437,
	    meters_std: 3147.3848083860844,
	    steps_per_meter_std: 0.00092790424324103898,
	    filename: "sanfranciscoca",
	    steps_per_meter_avg: 0.0015030185444430398,
	    seconds_avg: 713.18548387096769,
	    lat: 37.775205999999997,
	    lng: -122.419209,
	    meters_per_sec_std: 2.2018881060572841,
	    seconds_std: 266.99819889823556,
	    meters_avg: 5998.5645161290295
	  }, {
	    city: "San Jose, CA",
	    meters_per_sec_avg: 12.526090097951297,
	    steps_avg: 7.2993951612903283,
	    numroutes: 992,
	    steps_std: 2.5061135414905595,
	    meters_std: 4956.0081337784932,
	    steps_per_meter_std: 0.00064204518243296993,
	    filename: "sanjoseca",
	    steps_per_meter_avg: 0.0009316609834880981,
	    seconds_avg: 744.86895161290283,
	    lat: 37.320051999999997,
	    lng: -121.877636,
	    meters_per_sec_std: 3.0959007438038011,
	    seconds_std: 257.59610388815071,
	    meters_avg: 9821.0745967741859
	  }, {
	    city: "Seattle, WA",
	    meters_per_sec_avg: 10.736669644537304,
	    steps_avg: 8.5520833333333268,
	    numroutes: 960,
	    steps_std: 3.1962888792990021,
	    meters_std: 5243.1294735025704,
	    steps_per_meter_std: 0.00096502626851814144,
	    filename: "seattlewa",
	    steps_per_meter_avg: 0.0012239822606682587,
	    seconds_avg: 872.88645833333362,
	    lat: 47.620972999999999,
	    lng: -122.34727599999999,
	    meters_per_sec_std: 3.5633367706307904,
	    seconds_std: 551.59200498413441,
	    meters_avg: 9394.7322916666708
	  }, {
	    city: "Tucson, AZ",
	    meters_per_sec_avg: 11.828838166558729,
	    steps_avg: 6.394380853277843,
	    numroutes: 961,
	    steps_std: 2.4654972572755001,
	    meters_std: 7880.6402971559473,
	    steps_per_meter_std: 0.00042128884883527856,
	    filename: "tucsonaz",
	    steps_per_meter_avg: 0.0006139135539860105,
	    seconds_avg: 1113.834547346514,
	    lat: 32.221742900000002,
	    lng: -110.926479,
	    meters_per_sec_std: 2.0934493261193086,
	    seconds_std: 547.06195061001767,
	    meters_avg: 13686.797086368373
	  }, {
	    city: "Tulsa, OK",
	    meters_per_sec_avg: 19.454228621667401,
	    steps_avg: 8.8738095238095305,
	    numroutes: 420,
	    steps_std: 2.6054431295999767,
	    meters_std: 18390.191787058429,
	    steps_per_meter_std: 0.00027045931287338727,
	    filename: "tulsaok",
	    steps_per_meter_avg: 0.00043670127366806803,
	    seconds_avg: 1414.114285714285,
	    lat: 36.153981600000002,
	    lng: -95.992774999999995,
	    meters_per_sec_std: 3.2065638924118538,
	    seconds_std: 895.26973111024461,
	    meters_avg: 28038.747619047634
	  }, {
	    city: "Virginia Beach, VA",
	    meters_per_sec_avg: 13.641605444447723,
	    steps_avg: 6.7096774193548381,
	    numroutes: 868,
	    steps_std: 2.4656436770991799,
	    meters_std: 7400.185536808588,
	    steps_per_meter_std: 0.00041345495751575066,
	    filename: "virginiabeachva",
	    steps_per_meter_avg: 0.0006255930258064114,
	    seconds_avg: 964.55414746543829,
	    lat: 36.8529263,
	    lng: -75.977985000000004,
	    meters_per_sec_std: 3.3568573129464419,
	    seconds_std: 397.13026583863183,
	    meters_avg: 13751.006912442392
	  }, {
	    city: "Washington, DC",
	    meters_per_sec_avg: 8.614999553959132,
	    steps_avg: 8.3104838709677438,
	    numroutes: 992,
	    steps_std: 2.9266807322836597,
	    meters_std: 2739.4934607906584,
	    steps_per_meter_std: 0.00090772828251521609,
	    filename: "washingtondc",
	    steps_per_meter_avg: 0.0015226018487485811,
	    seconds_avg: 730.55846774193503,
	    lat: 38.895111800000002,
	    lng: -77.036365799999999,
	    meters_per_sec_std: 1.6147752365577543,
	    seconds_std: 240.97441069197808,
	    meters_avg: 6500.1491935483891
	  }];
	};
	
	var getCityAvgSpeed = exports.getCityAvgSpeed = function getCityAvgSpeed(address) {
	  var avgSpeeds = usAverageSpeed();
	  var result = 16.7 * 60 * 60;
	  (0, _map2.default)(avgSpeeds, function (avgSpeed) {
	    var city = avgSpeed.city;
	    if (address.indexOf(city) > -1) {
	      result = avgSpeed.meters_per_sec_avg * 60 * 60;
	    }
	  });
	
	  return result;
	};
	
	/*
	export const getPageHeight = ()=>{
	    const body = document.body;
	    const html = document.documentElement;
	
	    const height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
	}*/
	/*
	export function calculateWordDimensions(text, classes, escape) {
	    classes = classes || [];
	
	    if (escape === undefined) {
	        escape = true;
	    }
	
	    classes.push('textDimensionCalculation');
	
	    var div = document.createElement('div');
	    div.setAttribute('class', classes.join(' '));
	
	    if (escape) {
	        $(div).text(text);
	    } else {
	        div.innerHTML = text;
	    }
	
	    document.body.appendChild(div);
	
	    var dimensions = {
	        width : jQuery(div).outerWidth(),
	        height : jQuery(div).outerHeight()
	    };
	
	    div.parentNode.removeChild(div);
	
	    return dimensions;
	}*/
	function getDayRangeTitle(key) {
	  switch (key) {
	    case "today":
	      return "Today";
	    case "yesterday":
	      return "Yesterday";
	    case "last-7-days":
	      return "Last 7 Days";
	    case "last-30-days":
	      return "Last 30 Days";
	    case "last-60-days":
	      return "Last 60 Days";
	    case "last-90-days":
	      return "Last 90 days";
	    default:
	      return "";
	  }
	}
	function getTextSize(txt, font) {
	  var element = document.createElement("canvas");
	  var context = element.getContext("2d");
	  context.font = font;
	  var tsize = {
	    width: context.measureText(txt).width,
	    height: parseInt(context.font, 10)
	  };
	  return tsize;
	}
	
	function getDemographicText(key) {
	  var data = {
	    medianAge: "Average Age",
	    medianIncome: "Average Income",
	    children: "Presence of Children",
	    medianNumberOfPeople: "Average Number of People in Residence",
	    gender: "Gender",
	    homeOwnership: "Home Ownership",
	    marital: "Married"
	  };
	
	  return data[key];
	}
	function usStates() {
	  return {
	    AL: "Alabama",
	    AK: "Alaska",
	    AS: "American Samoa",
	    AZ: "Arizona",
	    AR: "Arkansas",
	    CA: "California",
	    CO: "Colorado",
	    CT: "Connecticut",
	    DE: "Delaware",
	    DC: "District Of Columbia",
	    FM: "Federated States Of Micronesia",
	    FL: "Florida",
	    GA: "Georgia",
	    GU: "Guam",
	    HI: "Hawaii",
	    ID: "Idaho",
	    IL: "Illinois",
	    IN: "Indiana",
	    IA: "Iowa",
	    KS: "Kansas",
	    KY: "Kentucky",
	    LA: "Louisiana",
	    ME: "Maine",
	    MH: "Marshall Islands",
	    MD: "Maryland",
	    MA: "Massachusetts",
	    MI: "Michigan",
	    MN: "Minnesota",
	    MS: "Mississippi",
	    MO: "Missouri",
	    MT: "Montana",
	    NE: "Nebraska",
	    NV: "Nevada",
	    NH: "New Hampshire",
	    NJ: "New Jersey",
	    NM: "New Mexico",
	    NY: "New York",
	    NC: "North Carolina",
	    ND: "North Dakota",
	    MP: "Northern Mariana Islands",
	    OH: "Ohio",
	    OK: "Oklahoma",
	    OR: "Oregon",
	    PW: "Palau",
	    PA: "Pennsylvania",
	    PR: "Puerto Rico",
	    RI: "Rhode Island",
	    SC: "South Carolina",
	    SD: "South Dakota",
	    TN: "Tennessee",
	    TX: "Texas",
	    UT: "Utah",
	    VT: "Vermont",
	    VI: "Virgin Islands",
	    VA: "Virginia",
	    WA: "Washington",
	    WV: "West Virginia",
	    WI: "Wisconsin",
	    WY: "Wyoming"
	  };
	}
	
	function imageDispalyUri() {
	  return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAWElEQVQ4T2NkoBAwMjAw/KfEDJgBIJoc8H/UAIbhFAbkpAGwHnITENxCXAYsYGBgiEdz1kIGBoYEdKfiMuABAwODPJpikJgiMQaAbJmPI1BALktElqM4DACjdhgHNiS3pAAAAABJRU5ErkJggg==";
	}
	
	function imageEmailUri() {
	  return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2UlEQVQ4T62T7Q0BURBFz1ZAB3RACXRABehAB2wFogJUQAeogO2ADqiA3M28ZHbtkuwzf14ymTlz5+MlRFoSmY8AS2DREJQK8GqYnKd5wA64AOsfwDnQByZlgGBboAXMgEcJ1AY2wBOYBuVeQRjoAegBY+BqEFXcA2dLljtvvQqgSieDSK5iVkAGDJyyWoDAXYN0TMHd+vZt1QKUrNWqupTIRuaT/2a+SoAkapB6Fah2ZKocVGmAAn8AUjuooatc3qjAR6emMEQFCyKZ36xwuX+5xOi/EPMVeANhqjUGqnm+lwAAAABJRU5ErkJggg==";
	}
	
	function imageSocialUri() {
	  return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAuklEQVQ4T6WT0Q3CMAxEXyeADWAENmCEMkI7CWwCbEA3YARGgA3YAHRSjSzLahqazyT3bF8uDXVrDZyBA3AD+qZOzx3YO81QC/jEgnMBHXAEtgFQ7MALX8BpnL8FBqCzDnaAbT504Cqa8JL5JYAuy1lbz7HVSaFdFuANrAK9B9KKmYkZQF1d5zxxNoJa3wAaRaZNgryJli4zUeIiqJQDjRJBKlQdZQ/y1hSDFH38O8oGWvyZ9J2Vj1+Uv7BZKw9frvwtAAAAAElFTkSuQmCC";
	}
	
	function aaClaritasLogoDataUri() {
	  return "data:image/png;base64,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";
	}
	
	function claritasLogoDataUri() {
	  return "data:image/png;base64,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";
	}
	function pdfReportFooterDataUri() {
	  return claritasLogoDataUri();
	}
	function pdfReportHeaderDataUri() {
	  return aaClaritasLogoDataUri();
	}
	
	function insightHeaderDataUri() {
	  return "data:image/png;base64,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";
	}
	function audienceAnywhereLogoDataUri() {
	  return "data:image/png;base64,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";
	}
	
	function addPdfFont(pdf) {
	  var font = "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";
	  pdf.addFileToVFS("Proxima-Nova-normal.ttf", font);
	  pdf.addFont("Proxima-Nova-normal.ttf", "Proxima-Nova", "normal");
	}

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactTapEventPlugin = __webpack_require__(3040);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _getMuiTheme = __webpack_require__(108);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _AcquireWebTheme = __webpack_require__(1170);
	
	var _AcquireWebTheme2 = _interopRequireDefault(_AcquireWebTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactTapEventPlugin2.default)(); // a dependency of MaterialUI
	
	var AcquireWebComponent = function (_Component) {
		_inherits(AcquireWebComponent, _Component);
	
		function AcquireWebComponent() {
			_classCallCheck(this, AcquireWebComponent);
	
			return _possibleConstructorReturn(this, (AcquireWebComponent.__proto__ || Object.getPrototypeOf(AcquireWebComponent)).apply(this, arguments));
		}
	
		_createClass(AcquireWebComponent, [{
			key: 'getChildContext',
			value: function getChildContext() {
				var _this2 = this;
	
				var colorProps = ['primary1Color', 'primary2Color', 'primary3Color', 'accent1Color', 'accent2Color'];
				colorProps.forEach(function (colorProp) {
					_AcquireWebTheme2.default.palette[colorProp] = _this2.getNavColor ? _this2.getNavColor() : _AcquireWebTheme2.default.palette[colorProp];
				});
	
				return {
					muiTheme: (0, _getMuiTheme2.default)(_AcquireWebTheme2.default)
				};
			}
		}]);
	
		return AcquireWebComponent;
	}(_react.Component);
	
	AcquireWebComponent.childContextTypes = {
		muiTheme: _propTypes2.default.object
	};
	
	exports.default = AcquireWebComponent;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2777);


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.11';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(132)(module)))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FullRow = exports.Col = exports.Row = exports.Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = exports.Container = function (_Component) {
		_inherits(Container, _Component);
	
		function Container() {
			_classCallCheck(this, Container);
	
			return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
		}
	
		_createClass(Container, [{
			key: 'getClass',
			value: function getClass() {
				var fluid = this.props.fluid;
	
				return 'container' + (fluid ? '-fluid' : '');
			}
		}, {
			key: 'render',
			value: function render() {
				var children = this.props.children;
	
				return _react2.default.createElement(
					'div',
					{ className: this.getClass() },
					' ',
					children,
					' '
				);
			}
		}]);
	
		return Container;
	}(_react.Component);
	
	Container.propTypes = {
		fluid: _propTypes2.default.bool,
		children: _propTypes2.default.object
	};
	
	var Row = exports.Row = function (_Component2) {
		_inherits(Row, _Component2);
	
		function Row() {
			_classCallCheck(this, Row);
	
			return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
		}
	
		_createClass(Row, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    children = _props.children,
				    style = _props.style,
				    className = _props.className;
	
				var classes = 'row ';
				if (className) classes += className;
	
				return _react2.default.createElement(
					'div',
					{ className: classes, style: style },
					' ',
					children,
					' '
				);
			}
		}]);
	
		return Row;
	}(_react.Component);
	
	Row.propTypes = {
		children: _propTypes2.default.any
	};
	
	var Col = exports.Col = function (_Component3) {
		_inherits(Col, _Component3);
	
		function Col() {
			_classCallCheck(this, Col);
	
			return _possibleConstructorReturn(this, (Col.__proto__ || Object.getPrototypeOf(Col)).apply(this, arguments));
		}
	
		_createClass(Col, [{
			key: 'getClasses',
			value: function getClasses() {
				var _this4 = this;
	
				var classes = '';
				var upper = function upper(str) {
					return str.charAt(0).toUpperCase() + str.slice(1);
				};
	
				['xs', 'sm', 'md', 'lg'].forEach(function (size) {
					if (_this4.props[size]) classes += 'col-' + size + '-' + _this4.props[size] + ' ';
	
					['offset', 'push', 'pull'].forEach(function (type) {
						var key = type + upper(size);
						if (_this4.props[key]) classes += 'col-' + size + '-' + type + '-' + _this4.props[key] + ' ';
					});
				});
				if (this.props.className) classes += this.props.className;
				return classes;
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    children = _props2.children,
				    style = _props2.style,
				    id = _props2.id;
	
				return id === undefined ? _react2.default.createElement(
					'div',
					{ className: this.getClasses(), style: style },
					' ',
					children,
					' '
				) : _react2.default.createElement(
					'div',
					{ className: this.getClasses(), style: style, id: id },
					' ',
					children,
					' '
				);
			}
		}]);
	
		return Col;
	}(_react.Component);
	
	Col.propTypes = {
		children: _propTypes2.default.any
	};
	
	var FullRow = exports.FullRow = function (_Component4) {
		_inherits(FullRow, _Component4);
	
		function FullRow() {
			_classCallCheck(this, FullRow);
	
			return _possibleConstructorReturn(this, (FullRow.__proto__ || Object.getPrototypeOf(FullRow)).apply(this, arguments));
		}
	
		_createClass(FullRow, [{
			key: 'render',
			value: function render() {
				var _props3 = this.props,
				    children = _props3.children,
				    style = _props3.style,
				    className = _props3.className;
	
	
				return _react2.default.createElement(
					Row,
					{ style: style, className: className },
					_react2.default.createElement(
						Col,
						{ xs: '12', sm: '12', md: '12', lg: '12' },
						' ',
						children,
						' '
					),
					' '
				);
			}
		}]);
	
		return FullRow;
	}(_react.Component);
	
	FullRow.propTypes = {
		children: _propTypes2.default.any
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	var _interopRequireWildcard = __webpack_require__(2996);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(2985));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(952));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(2986));
	
	exports.connect = _connect.default;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(639),
	    getTag = __webpack_require__(228),
	    isArguments = __webpack_require__(231),
	    isArray = __webpack_require__(29),
	    isArrayLike = __webpack_require__(106),
	    isBuffer = __webpack_require__(232),
	    isPrototype = __webpack_require__(230),
	    isTypedArray = __webpack_require__(296);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(144),
	    baseIteratee = __webpack_require__(60),
	    baseMap = __webpack_require__(641),
	    isArray = __webpack_require__(29);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseChildIndex = exports.getReactEventByType = exports.renderByOrder = exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.TOOLTIP_TYPES = exports.LEGEND_TYPES = exports.SCALE_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(295));
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(53));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _DataUtils = __webpack_require__(40);
	
	var _PureRender = __webpack_require__(26);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var PRESENTATION_ATTRIBUTES = {
	  'aria-current': _propTypes.default.string,
	  // state
	  'aria-details': _propTypes.default.any,
	  'aria-disabled': _propTypes.default.any,
	  // state
	  'aria-hidden': _propTypes.default.any,
	  // state
	  'aria-invalid': _propTypes.default.any,
	  // state
	  'aria-keyshortcuts': _propTypes.default.any,
	  'aria-label': _propTypes.default.any,
	  'aria-roledescription': _propTypes.default.any,
	  // Widget Attributes
	  'aria-autocomplete': _propTypes.default.any,
	  'aria-checked': _propTypes.default.any,
	  'aria-expanded': _propTypes.default.any,
	  'aria-haspopup': _propTypes.default.any,
	  'aria-level': _propTypes.default.any,
	  'aria-modal': _propTypes.default.any,
	  'aria-multiline': _propTypes.default.any,
	  'aria-multiselectable': _propTypes.default.any,
	  'aria-orientation': _propTypes.default.any,
	  'aria-placeholder': _propTypes.default.any,
	  'aria-pressed': _propTypes.default.any,
	  'aria-readonly': _propTypes.default.any,
	  'aria-required': _propTypes.default.any,
	  'aria-selected': _propTypes.default.any,
	  'aria-sort': _propTypes.default.any,
	  'aria-valuemax': _propTypes.default.any,
	  'aria-valuemin': _propTypes.default.any,
	  'aria-valuenow': _propTypes.default.any,
	  'aria-valuetext': _propTypes.default.any,
	  // Live Region Attributes
	  'aria-atomic': _propTypes.default.any,
	  'aria-busy': _propTypes.default.any,
	  'aria-live': _propTypes.default.any,
	  'aria-relevant': _propTypes.default.any,
	  // Drag-and-Drop Attributes
	  'aria-dropeffect': _propTypes.default.any,
	  'aria-grabbed': _propTypes.default.any,
	  // Relationship Attributes
	  'aria-activedescendant': _propTypes.default.any,
	  'aria-colcount': _propTypes.default.any,
	  'aria-colindex': _propTypes.default.any,
	  'aria-colspan': _propTypes.default.any,
	  'aria-controls': _propTypes.default.any,
	  'aria-describedby': _propTypes.default.any,
	  'aria-errormessage': _propTypes.default.any,
	  'aria-flowto': _propTypes.default.any,
	  'aria-labelledby': _propTypes.default.any,
	  'aria-owns': _propTypes.default.any,
	  'aria-posinset': _propTypes.default.any,
	  'aria-rowcount': _propTypes.default.any,
	  'aria-rowindex': _propTypes.default.any,
	  'aria-rowspan': _propTypes.default.any,
	  'aria-setsize': _propTypes.default.any,
	  alignmentBaseline: _propTypes.default.string,
	  angle: _propTypes.default.number,
	  baselineShift: _propTypes.default.string,
	  clip: _propTypes.default.string,
	  clipPath: _propTypes.default.string,
	  clipRule: _propTypes.default.string,
	  color: _propTypes.default.string,
	  colorInterpolation: _propTypes.default.string,
	  colorInterpolationFilters: _propTypes.default.string,
	  colorProfile: _propTypes.default.string,
	  colorRendering: _propTypes.default.string,
	  cursor: _propTypes.default.string,
	  direction: _propTypes.default.oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes.default.string,
	  dominantBaseline: _propTypes.default.string,
	  enableBackground: _propTypes.default.string,
	  fill: _propTypes.default.string,
	  fillOpacity: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  fillRule: _propTypes.default.oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes.default.string,
	  floodColor: _propTypes.default.string,
	  floodOpacity: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  font: _propTypes.default.string,
	  fontFamily: _propTypes.default.string,
	  fontSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  fontSizeAdjust: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  fontStretch: _propTypes.default.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes.default.oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes.default.oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes.default.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes.default.string,
	  glyphOrientationVertical: _propTypes.default.string,
	  imageRendering: _propTypes.default.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  letterSpacing: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  lightingColor: _propTypes.default.string,
	  lineHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  markerEnd: _propTypes.default.string,
	  markerMid: _propTypes.default.string,
	  markerStart: _propTypes.default.string,
	  mask: _propTypes.default.string,
	  opacity: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  overflow: _propTypes.default.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes.default.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes.default.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes.default.string,
	  stopOpacity: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  stroke: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  strokeDasharray: _propTypes.default.string,
	  strokeDashoffset: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  strokeLinecap: _propTypes.default.oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes.default.oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  strokeOpacity: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  strokeWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  textAnchor: _propTypes.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes.default.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes.default.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes.default.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes.default.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  writingMode: _propTypes.default.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes.default.string,
	  role: _propTypes.default.string,
	  focusable: _propTypes.default.string,
	  tabIndex: _propTypes.default.string,
	  style: _propTypes.default.object,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  dx: _propTypes.default.number,
	  dy: _propTypes.default.number,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number,
	  r: _propTypes.default.number,
	  // The radius of Rectangle
	  radius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array])
	};
	exports.PRESENTATION_ATTRIBUTES = PRESENTATION_ATTRIBUTES;
	var EVENT_ATTRIBUTES = {
	  onClick: _propTypes.default.func,
	  onMouseDown: _propTypes.default.func,
	  onMouseUp: _propTypes.default.func,
	  onMouseOver: _propTypes.default.func,
	  onMouseMove: _propTypes.default.func,
	  onMouseOut: _propTypes.default.func,
	  onMouseEnter: _propTypes.default.func,
	  onMouseLeave: _propTypes.default.func,
	  onTouchEnd: _propTypes.default.func,
	  onTouchMove: _propTypes.default.func,
	  onTouchStart: _propTypes.default.func,
	  onTouchCancel: _propTypes.default.func
	};
	exports.EVENT_ATTRIBUTES = EVENT_ATTRIBUTES;
	var REACT_BROWSER_EVENT_MAP = {
	  click: 'onClick',
	  mousedown: 'onMouseDown',
	  mouseup: 'onMouseUp',
	  mouseover: 'onMouseOver',
	  mousemove: 'onMouseMove',
	  mouseout: 'onMouseOut',
	  mouseenter: 'onMouseEnter',
	  mouseleave: 'onMouseLeave',
	  touchcancel: 'onTouchCancel',
	  touchend: 'onTouchEnd',
	  touchmove: 'onTouchMove',
	  touchstart: 'onTouchStart'
	};
	var SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold'];
	exports.SCALE_TYPES = SCALE_TYPES;
	var LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	exports.LEGEND_TYPES = LEGEND_TYPES;
	var TOOLTIP_TYPES = ['none'];
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	
	exports.TOOLTIP_TYPES = TOOLTIP_TYPES;
	
	var getDisplayName = function getDisplayName(Comp) {
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	
	  if (!Comp) {
	    return '';
	  }
	
	  return Comp.displayName || Comp.name || 'Component';
	};
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	
	
	exports.getDisplayName = getDisplayName;
	
	var findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray2.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react.default.Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	
	
	exports.findAllByType = findAllByType;
	
	var findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	  return result && result[0];
	};
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	
	
	exports.findChildByType = findChildByType;
	
	var withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types;
	
	  if ((0, _isArray2.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react.default.Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	
	
	exports.withoutType = withoutType;
	
	var getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction2.default)(el)) {
	    return null;
	  }
	
	  var props = _react.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2.default)(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	
	  return out;
	};
	
	exports.getPresentationAttributes = getPresentationAttributes;
	
	var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
	  return function (e) {
	    originalHandler(props, e);
	    return null;
	  };
	};
	/**
	 * get all the event attribute of svg element
	 * @param  {Object}   el           A react element or the props of a react element
	 * @param  {Function} newHandler   New handler of event
	 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
	 * @return {Object}                attributes or null
	 */
	
	
	var filterEventAttributes = function filterEventAttributes(el, newHandler) {
	  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!el || (0, _isFunction2.default)(el)) {
	    return null;
	  }
	
	  var props = _react.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2.default)(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
	    }
	  }
	
	  return out;
	};
	
	exports.filterEventAttributes = filterEventAttributes;
	
	var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	    return null;
	  };
	};
	
	var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject2.default)(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction2.default)(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandlerOfChild(props[i], data, index);
	    }
	  }
	
	  return out;
	};
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	
	
	exports.filterEventsOfChild = filterEventsOfChild;
	
	var validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	exports.validateWidthHeight = validateWidthHeight;
	
	var isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	exports.isSsr = isSsr;
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	
	var isSvgElement = function isSvgElement(child) {
	  return child && child.type && (0, _isString2.default)(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
	};
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	
	
	var filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react.default.Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString2.default)(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	
	exports.filterSvgElements = filterSvgElements;
	
	var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil2.default)(nextChild) && (0, _isNil2.default)(prevChild)) {
	    return true;
	  }
	
	  if (!(0, _isNil2.default)(nextChild) && !(0, _isNil2.default)(prevChild)) {
	    var _ref = nextChild.props || {},
	        nextChildren = _ref.children,
	        nextProps = _objectWithoutProperties(_ref, ["children"]);
	
	    var _ref2 = prevChild.props || {},
	        prevChildren = _ref2.children,
	        prevProps = _objectWithoutProperties(_ref2, ["children"]);
	
	    if (nextChildren && prevChildren) {
	      // eslint-disable-next-line no-use-before-define
	      return (0, _PureRender.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
	    }
	
	    if (!nextChildren && !prevChildren) {
	      return (0, _PureRender.shallowEqual)(nextProps, prevProps);
	    }
	
	    return false;
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	
	
	exports.isSingleChildEqual = isSingleChildEqual;
	
	var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	
	  if (count === 1) {
	    return isSingleChildEqual((0, _isArray2.default)(nextChildren) ? nextChildren[0] : nextChildren, (0, _isArray2.default)(prevChildren) ? prevChildren[0] : prevChildren);
	  }
	
	  for (var i = 0; i < count; i++) {
	    var nextChild = nextChildren[i];
	    var prevChild = prevChildren[i];
	
	    if ((0, _isArray2.default)(nextChild) || (0, _isArray2.default)(prevChild)) {
	      if (!isChildrenEqual(nextChild, prevChild)) {
	        return false;
	      }
	    } else if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	exports.isChildrenEqual = isChildrenEqual;
	
	var renderByOrder = function renderByOrder(children, renderMap) {
	  var elements = [];
	  var record = {};
	
	  _react.Children.forEach(children, function (child, index) {
	    if (child && isSvgElement(child)) {
	      elements.push(child);
	    } else if (child && renderMap[getDisplayName(child.type)]) {
	      var displayName = getDisplayName(child.type);
	      var _renderMap$displayNam = renderMap[displayName],
	          handler = _renderMap$displayNam.handler,
	          once = _renderMap$displayNam.once;
	
	      if (once && !record[displayName] || !once) {
	        var results = handler(child, displayName, index);
	
	        if ((0, _isArray2.default)(results)) {
	          elements = [elements].concat(_toConsumableArray(results));
	        } else {
	          elements.push(results);
	        }
	
	        record[displayName] = true;
	      }
	    }
	  });
	
	  return elements;
	};
	
	exports.renderByOrder = renderByOrder;
	
	var getReactEventByType = function getReactEventByType(e) {
	  var type = e && e.type;
	
	  if (type && REACT_BROWSER_EVENT_MAP[type]) {
	    return REACT_BROWSER_EVENT_MAP[type];
	  }
	
	  return null;
	};
	
	exports.getReactEventByType = getReactEventByType;
	
	var parseChildIndex = function parseChildIndex(child, children) {
	  var result = -1;
	
	  _react.Children.forEach(children, function (entry, index) {
	    if (entry === child) {
	      result = index;
	    }
	  });
	
	  return result;
	};
	
	exports.parseChildIndex = parseChildIndex;

/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;
	
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shouldComponentUpdate(props, state) {
	  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
	}
	
	function pureRenderDecorator(component) {
	  // eslint-disable-next-line no-param-reassign
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getClientInfo = exports.resetPassword = exports.sendPasswordRecoveryEmail = exports.getCurrentUserOptimizeDetail = exports.getCurrentUserProfile = exports.getUserAvatar = exports.getUserDetail = exports.getCurrentUserClients = exports.getUserClients = exports.validateSession = exports.sendLogin = exports.getAPIBuildNumber = exports.getDisabledFeatures = exports.setLoginErrorMessage = exports.clearClientInfo = exports.selectClient = exports.showForgotPassword = exports.logout = exports.setPassword = exports.setEmail = exports.closeLoginDialog = exports.showLoginDialog = exports.mountSession = exports.SET_LOGIN_ERROR_MESSAGE = exports.GET_DISABLED_FEATURES = exports.CLEAR_CLIENT_INFO = exports.GET_CLIENT_BYID = exports.GET_API_BUILD_NUMBER = exports.SEND_PASSWORD_RECOVERY = exports.SELECT_CLIENT = exports.OPTIMIZE_USER_DETAIL = exports.LOGIN_USER_DETAIL = exports.USER_AVATAR = exports.USER_CLIENTS = exports.RESET_PASSWORD = exports.SHOW_FORGOT_PASSWORD = exports.FORGOT_PASSWORD = exports.SESSION = exports.LOGOUT = exports.LOGIN = exports.MOUNT_SESSION = exports.SET_PASSWORD = exports.SET_EMAIL = exports.CLOSE_LOGIN_DIALOG = exports.SHOW_LOGIN_DIALOG = undefined;
	
	var _helpers = __webpack_require__(95);
	
	var _Api = __webpack_require__(45);
	
	var SHOW_LOGIN_DIALOG = exports.SHOW_LOGIN_DIALOG = "SHOW_LOGIN_DIALOG";
	var CLOSE_LOGIN_DIALOG = exports.CLOSE_LOGIN_DIALOG = "CLOSE_LOGIN_DIALOG";
	var SET_EMAIL = exports.SET_EMAIL = "SET_EMAIL";
	var SET_PASSWORD = exports.SET_PASSWORD = "SET_PASSWORD";
	var MOUNT_SESSION = exports.MOUNT_SESSION = "MOUNT_SESSION";
	var LOGIN = exports.LOGIN = "LOGIN";
	var LOGOUT = exports.LOGOUT = "LOGOUT";
	var SESSION = exports.SESSION = "SESSION";
	var FORGOT_PASSWORD = exports.FORGOT_PASSWORD = "FORGOT_PASSWORD";
	var SHOW_FORGOT_PASSWORD = exports.SHOW_FORGOT_PASSWORD = "SHOW_FORGOT_PASSWORD";
	var RESET_PASSWORD = exports.RESET_PASSWORD = "RESET_PASSWORD";
	var USER_CLIENTS = exports.USER_CLIENTS = "USER_CLIENTS";
	var USER_AVATAR = exports.USER_AVATAR = "USER_AVATAR";
	var LOGIN_USER_DETAIL = exports.LOGIN_USER_DETAIL = "LOGIN_USER_DETAIL";
	var OPTIMIZE_USER_DETAIL = exports.OPTIMIZE_USER_DETAIL = "OPTIMIZE_USER_DETAIL";
	var SELECT_CLIENT = exports.SELECT_CLIENT = "SELECT_CLIENT";
	var SEND_PASSWORD_RECOVERY = exports.SEND_PASSWORD_RECOVERY = "SEND_PASSWORD_RECOVERY";
	var GET_API_BUILD_NUMBER = exports.GET_API_BUILD_NUMBER = "GET_API_GUILD_NUMBER";
	var GET_CLIENT_BYID = exports.GET_CLIENT_BYID = "GET_CLIENT_BYID";
	var CLEAR_CLIENT_INFO = exports.CLEAR_CLIENT_INFO = "CLEAR_CLIENT_INFO";
	var GET_DISABLED_FEATURES = exports.GET_DISABLED_FEATURES = "GET_DISABLED_FEATURES";
	var SET_LOGIN_ERROR_MESSAGE = exports.SET_LOGIN_ERROR_MESSAGE = "SET_LOGIN_ERROR_MESSAGE";
	
	var mountSession = exports.mountSession = (0, _helpers.actionCreator)(MOUNT_SESSION);
	var showLoginDialog = exports.showLoginDialog = (0, _helpers.actionCreator)(SHOW_LOGIN_DIALOG);
	var closeLoginDialog = exports.closeLoginDialog = (0, _helpers.actionCreator)(CLOSE_LOGIN_DIALOG);
	var setEmail = exports.setEmail = (0, _helpers.actionCreator)(SET_EMAIL);
	var setPassword = exports.setPassword = (0, _helpers.actionCreator)(SET_PASSWORD);
	var logout = exports.logout = (0, _helpers.actionCreator)(LOGOUT);
	var showForgotPassword = exports.showForgotPassword = (0, _helpers.actionCreator)(SHOW_FORGOT_PASSWORD);
	var selectClient = exports.selectClient = (0, _helpers.actionCreator)(SELECT_CLIENT);
	var clearClientInfo = exports.clearClientInfo = (0, _helpers.actionCreator)(CLEAR_CLIENT_INFO);
	var setLoginErrorMessage = exports.setLoginErrorMessage = (0, _helpers.actionCreator)(SET_LOGIN_ERROR_MESSAGE);
	
	var getDisabledFeatures = exports.getDisabledFeatures = function getDisabledFeatures() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_DISABLED_FEATURES, "auth/disabled-features");
	  };
	};
	
	var getAPIBuildNumber = exports.getAPIBuildNumber = function getAPIBuildNumber() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_API_BUILD_NUMBER, "proxy/build-number");
	  };
	};
	
	var sendLogin = exports.sendLogin = function sendLogin(e, p) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, LOGIN, "login", {
	      method: "post",
	      body: JSON.stringify({ username: e, password: p })
	    }, {
	      success: function success() {
	        dispatch(getAPIBuildNumber());
	      }
	    });
	  };
	};
	
	var validateSession = exports.validateSession = function validateSession() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SESSION, "login");
	  };
	};
	
	var getUserClients = exports.getUserClients = function getUserClients(userId) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, USER_CLIENTS, "users/" + userId + "/clients");
	  };
	};
	
	var getCurrentUserClients = exports.getCurrentUserClients = function getCurrentUserClients() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, USER_CLIENTS, "clients/my");
	  };
	};
	
	var getUserDetail = exports.getUserDetail = function getUserDetail(userId) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, LOGIN_USER_DETAIL, "users/" + userId);
	  };
	};
	
	var getUserAvatar = exports.getUserAvatar = function getUserAvatar(fileName) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, USER_AVATAR, "avatars/" + fileName);
	  };
	};
	
	var getCurrentUserProfile = exports.getCurrentUserProfile = function getCurrentUserProfile() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, LOGIN_USER_DETAIL, "users/my-profile");
	  };
	};
	
	var getCurrentUserOptimizeDetail = exports.getCurrentUserOptimizeDetail = function getCurrentUserOptimizeDetail() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, OPTIMIZE_USER_DETAIL, "users/current", {}, {}, true);
	  };
	};
	
	var sendPasswordRecoveryEmail = exports.sendPasswordRecoveryEmail = function sendPasswordRecoveryEmail(email, secretKey) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SEND_PASSWORD_RECOVERY, "pub/send-recovery-link", {
	      method: "post",
	      body: JSON.stringify({ email: email, recaptchaResponse: secretKey })
	    });
	  };
	};
	
	var resetPassword = exports.resetPassword = function resetPassword(password, rePassword, requestKey) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, RESET_PASSWORD, "pub/reset-password", {
	      method: "post",
	      body: JSON.stringify({
	        password: password,
	        confirmPassword: rePassword,
	        requestKey: requestKey
	      })
	    });
	  };
	};
	
	var getClientInfo = exports.getClientInfo = function getClientInfo(id) {
	  return function (dispatch, getState) {
	    var url = "clients/" + id;
	
	    (0, _Api.callApi)(dispatch, getState, GET_CLIENT_BYID, url, {}, {
	      failure: function failure() {
	        window.location = "/dashboard";
	      }
	    });
	  };
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(105),
	    isObject = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 29 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(1681);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(405);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(3000);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(3001);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(957);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(3002);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(3003);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(3004);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(3005);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(958);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(477);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(3006);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(3007);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(3008);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(3009);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(3010);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(104);
	var core = __webpack_require__(217);
	var hide = __webpack_require__(565);
	var redefine = __webpack_require__(572);
	var ctx = __webpack_require__(563);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(87);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 36 */
[3246, 337, 977, 3024, 978, 980, 979, 483, 981, 982, 482],
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = exports.Toggle = exports.TimePicker = exports.TextField = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = exports.Tab = exports.Tabs = exports.Snackbar = exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = exports.SvgIcon = exports.Subheader = exports.Slider = exports.SelectField = exports.RefreshIndicator = exports.RaisedButton = exports.RadioButtonGroup = exports.RadioButton = exports.Popover = exports.Paper = exports.MuiThemeProvider = exports.MenuItem = exports.Menu = exports.makeSelectable = exports.ListItem = exports.List = exports.LinearProgress = exports.IconMenu = exports.IconButton = exports.GridTile = exports.GridList = exports.FontIcon = exports.FloatingActionButton = exports.FlatButton = exports.DropDownMenu = exports.Drawer = exports.Divider = exports.Dialog = exports.DatePicker = exports.CircularProgress = exports.Chip = exports.Checkbox = exports.CardText = exports.CardTitle = exports.CardMedia = exports.CardHeader = exports.CardActions = exports.Card = exports.BottomNavigationItem = exports.BottomNavigation = exports.Badge = exports.Avatar = exports.AutoComplete = exports.AppBar = undefined;
	
	var _AppBar2 = __webpack_require__(1657);
	
	var _AppBar3 = _interopRequireDefault(_AppBar2);
	
	var _AutoComplete2 = __webpack_require__(1659);
	
	var _AutoComplete3 = _interopRequireDefault(_AutoComplete2);
	
	var _Avatar2 = __webpack_require__(681);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	var _Badge2 = __webpack_require__(1662);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _BottomNavigation2 = __webpack_require__(1664);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(682);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	var _Card2 = __webpack_require__(1666);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardActions2 = __webpack_require__(683);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardHeader2 = __webpack_require__(685);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardMedia2 = __webpack_require__(686);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardTitle2 = __webpack_require__(688);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardText2 = __webpack_require__(687);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _Checkbox2 = __webpack_require__(41);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Chip2 = __webpack_require__(689);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	var _CircularProgress2 = __webpack_require__(690);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	var _DatePicker2 = __webpack_require__(1680);
	
	var _DatePicker3 = _interopRequireDefault(_DatePicker2);
	
	var _Dialog2 = __webpack_require__(30);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	var _Divider2 = __webpack_require__(691);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	var _Drawer2 = __webpack_require__(1684);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	var _DropDownMenu2 = __webpack_require__(692);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _FlatButton2 = __webpack_require__(51);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _FloatingActionButton2 = __webpack_require__(1689);
	
	var _FloatingActionButton3 = _interopRequireDefault(_FloatingActionButton2);
	
	var _FontIcon2 = __webpack_require__(420);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	var _GridList2 = __webpack_require__(1692);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(693);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	var _IconButton2 = __webpack_require__(189);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	var _IconMenu2 = __webpack_require__(1695);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _LinearProgress2 = __webpack_require__(1697);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _List2 = __webpack_require__(1699);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(422);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(694);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	var _Menu2 = __webpack_require__(695);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(235);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _MuiThemeProvider2 = __webpack_require__(48);
	
	var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);
	
	var _Paper2 = __webpack_require__(73);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	var _Popover2 = __webpack_require__(1703);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _RadioButton2 = __webpack_require__(107);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(426);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	var _RaisedButton2 = __webpack_require__(304);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _RefreshIndicator2 = __webpack_require__(1706);
	
	var _RefreshIndicator3 = _interopRequireDefault(_RefreshIndicator2);
	
	var _SelectField2 = __webpack_require__(696);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	var _Slider2 = __webpack_require__(1709);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	var _Subheader2 = __webpack_require__(698);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	var _SvgIcon2 = __webpack_require__(2);
	
	var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);
	
	var _Step2 = __webpack_require__(1713);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(1714);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(1716);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(697);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(1717);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	var _Snackbar2 = __webpack_require__(1712);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	var _Tabs2 = __webpack_require__(1724);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(703);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Table2 = __webpack_require__(236);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(699);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(700);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(701);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(427);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(702);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(305);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	var _TextField2 = __webpack_require__(154);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	var _TimePicker2 = __webpack_require__(1736);
	
	var _TimePicker3 = _interopRequireDefault(_TimePicker2);
	
	var _Toggle2 = __webpack_require__(1738);
	
	var _Toggle3 = _interopRequireDefault(_Toggle2);
	
	var _Toolbar2 = __webpack_require__(1740);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(706);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(707);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(708);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppBar = _AppBar3.default;
	exports.AutoComplete = _AutoComplete3.default;
	exports.Avatar = _Avatar3.default;
	exports.Badge = _Badge3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.Card = _Card3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardText = _CardText3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Chip = _Chip3.default;
	exports.CircularProgress = _CircularProgress3.default;
	exports.DatePicker = _DatePicker3.default;
	exports.Dialog = _Dialog3.default;
	exports.Divider = _Divider3.default;
	exports.Drawer = _Drawer3.default;
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.FloatingActionButton = _FloatingActionButton3.default;
	exports.FontIcon = _FontIcon3.default;
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.IconButton = _IconButton3.default;
	exports.IconMenu = _IconMenu3.default;
	exports.LinearProgress = _LinearProgress3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.MuiThemeProvider = _MuiThemeProvider3.default;
	exports.Paper = _Paper3.default;
	exports.Popover = _Popover3.default;
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.RefreshIndicator = _RefreshIndicator3.default;
	exports.SelectField = _SelectField3.default;
	exports.Slider = _Slider3.default;
	exports.Subheader = _Subheader3.default;
	exports.SvgIcon = _SvgIcon3.default;
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;
	exports.Snackbar = _Snackbar3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.TextField = _TextField3.default;
	exports.TimePicker = _TimePicker3.default;
	exports.Toggle = _Toggle3.default;
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;

/***/ },
/* 39 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLinearRegression = exports.findEntryInArray = exports.interpolateNumber = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(186));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(293));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(294));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(295));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	exports.mathSign = mathSign;
	
	var isPercent = function isPercent(value) {
	  return (0, _isString2.default)(value) && value.indexOf('%') === value.length - 1;
	};
	
	exports.isPercent = isPercent;
	
	var isNumber = function isNumber(value) {
	  return (0, _isNumber2.default)(value) && !(0, _isNaN2.default)(value);
	};
	
	exports.isNumber = isNumber;
	
	var isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString2.default)(value);
	};
	
	exports.isNumOrStr = isNumOrStr;
	var idCounter = 0;
	
	var uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	  return "".concat(prefix || '').concat(id);
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	
	
	exports.uniqueId = uniqueId;
	
	var getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString2.default)(percent)) {
	    return defaultValue;
	  }
	
	  var value;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if ((0, _isNaN2.default)(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	exports.getPercentValue = getPercentValue;
	
	var getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	exports.getAnyElementOfObject = getAnyElementOfObject;
	
	var hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray2.default)(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	exports.hasDuplicate = hasDuplicate;
	
	var interpolateNumber = function interpolateNumber(numberA, numberB) {
	  if (isNumber(numberA) && isNumber(numberB)) {
	    return function (t) {
	      return numberA + t * (numberB - numberA);
	    };
	  }
	
	  return function () {
	    return numberB;
	  };
	};
	
	exports.interpolateNumber = interpolateNumber;
	
	var findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
	  if (!ary || !ary.length) {
	    return null;
	  }
	
	  return ary.find(function (entry) {
	    return entry && (0, _get2.default)(entry, specifiedKey) === specifiedValue;
	  });
	};
	/**
	 * The least square linear regression
	 * @param {Array} data The array of points
	 * @returns {Object} The domain of x, and the parameter of linear function
	 */
	
	
	exports.findEntryInArray = findEntryInArray;
	
	var getLinearRegression = function getLinearRegression(data) {
	  if (!data || !data.length) {
	    return null;
	  }
	
	  var len = data.length;
	  var xsum = 0;
	  var ysum = 0;
	  var xysum = 0;
	  var xxsum = 0;
	  var xmin = Infinity;
	  var xmax = -Infinity;
	
	  for (var i = 0; i < len; i++) {
	    xsum += data[i].cx;
	    ysum += data[i].cy;
	    xysum += data[i].cx * data[i].cy;
	    xxsum += data[i].cx * data[i].cx;
	    xmin = Math.min(xmin, data[i].cx);
	    xmax = Math.max(xmax, data[i].cx);
	  }
	
	  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
	  return {
	    xmin: xmin,
	    xmax: xmax,
	    a: a,
	    b: (ysum - a * xsum) / len
	  };
	};
	
	exports.getLinearRegression = getLinearRegression;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(1667);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Tooltip = __webpack_require__(2719);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tooltip2['default'];
	module.exports = exports['default'];

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  className: _propTypes.default.string,
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ["children", "className"]);
	
	  var layerClass = (0, _classnames.default)('recharts-layer', className);
	  return _react.default.createElement("g", _extends({
	    className: layerClass
	  }, others), children);
	}
	
	Layer.propTypes = propTypes;
	var _default = Layer;
	exports.default = _default;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var DOMProperty = __webpack_require__(195);
	var ReactDOMComponentFlags = __webpack_require__(896);
	
	var invariant = __webpack_require__(21);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.API_UNAUTHORIZED = exports.API_INVALID = exports.API_FAILURE = exports.API_SUCCESS = exports.API_REQUEST = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.apiEndpoint = apiEndpoint;
	exports.optimzieApiEndpoint = optimzieApiEndpoint;
	exports.toQueryString = toQueryString;
	exports.callApi = callApi;
	
	var _merge = __webpack_require__(671);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _env = __webpack_require__(85);
	
	var _es6Promise = __webpack_require__(1389);
	
	var _es6Promise2 = _interopRequireDefault(_es6Promise);
	
	__webpack_require__(1032);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_es6Promise2.default.polyfill();
	
	var API_REQUEST = exports.API_REQUEST = "API_REQUEST";
	var API_SUCCESS = exports.API_SUCCESS = "API_SUCCESS";
	var API_FAILURE = exports.API_FAILURE = "API_FAILURE";
	var API_INVALID = exports.API_INVALID = "API_INVALID";
	var API_UNAUTHORIZED = exports.API_UNAUTHORIZED = "API_UNAUTHORIZED";
	
	function apiEndpoint(path) {
	  return _env.apiBaseUrl + "/" + path;
	}
	function optimzieApiEndpoint(path) {
	  return _env.optimizeApiBaseUrl + "/" + path;
	}
	
	function request(dispatch, type, handler) {
	  dispatch({
	    type: [API_REQUEST, type].join(".")
	  });
	  handler && handler();
	}
	
	function success(dispatch, type, payload, handler) {
	  dispatch({
	    type: [API_SUCCESS, type].join("."),
	    payload: payload
	  });
	  handler && handler(payload);
	}
	
	function failure(dispatch, type, payload, handler) {
	  dispatch({
	    type: [API_FAILURE, type].join("."),
	    payload: payload
	  });
	  handler && handler();
	}
	
	function invalid(dispatch, type, payload, handler) {
	  dispatch({
	    type: [API_INVALID, type].join("."),
	    payload: payload
	  });
	  handler && handler();
	}
	
	function unauthorized(dispatch, type, payload, handler) {
	  dispatch({
	    type: [API_UNAUTHORIZED, type].join("."),
	    payload: payload
	  });
	  handler && handler();
	}
	
	function headers(state) {
	  var token = state.app && state.app.token ? state.app.token : "";
	  return {
	    "Content-Type": "application/json",
	    Accept: "application/json",
	    Authorization: token
	    /*"Cache-Control": "no-cache",*/
	    /*"max-age": 0,*/
	  };
	}
	
	function handleFailure(dispatch, response, type, handlers) {
	  var json = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	  if (response.status === 401) {
	    unauthorized(dispatch, type, json, handlers.unauthorized);
	  } else if (response.status === 422) {
	    invalid(dispatch, type, json, handlers.invalid);
	  } else {
	    failure(dispatch, type, json, handlers.failure);
	  }
	}
	
	function flattenObj(x, path) {
	  var result = [];
	
	  path = path || [];
	  Object.keys(x).forEach(function (key) {
	    if (!x.hasOwnProperty(key)) return;
	
	    var newPath = path.slice();
	    newPath.push(key);
	
	    var vals = [];
	    if (_typeof(x[key]) === "object") {
	      vals = flattenObj(x[key], newPath);
	    } else {
	      vals.push({
	        path: newPath,
	        val: x[key]
	      });
	    }
	    vals.forEach(function (obj) {
	      return result.push(obj);
	    });
	  });
	
	  return result;
	}
	
	function toQueryString(obj) {
	  var parts = flattenObj(obj);
	
	  // convert to array notation:
	  parts = parts.map(function (varInfo) {
	    if (varInfo.path.length === 1) varInfo.path = varInfo.path[0];else {
	      var first = varInfo.path[0];
	      var rest = varInfo.path.slice(1);
	      varInfo.path = first + "[" + rest.join("][") + "]";
	    }
	    return varInfo;
	  });
	
	  // join the parts to a query-string url-component
	  var queryString = parts.map(function (varInfo) {
	    return encodeURIComponent(varInfo.path) + "=" + encodeURIComponent(varInfo.val);
	  }).join("&");
	  return queryString;
	}
	
	function callApi(dispatch, getState, type, endpoint) {
	  var opt = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var handlers = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	  var isOptimizeApi = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	
	  var options = (0, _merge2.default)({
	    endpoint: isOptimizeApi ? optimzieApiEndpoint(endpoint) : apiEndpoint(endpoint),
	    method: "GET",
	    headers: headers(getState())
	  }, opt);
	
	  request(dispatch, type, handlers.request);
	  return fetch(options.endpoint, options).then(function (response) {
	    var contentType = response.headers.get("content-type");
	    if (contentType && (contentType.indexOf("image") >= 0 || contentType.indexOf("stream") >= 0)) {
	      if (response.ok) {
	        response.blob().then(function (body) {
	          success(dispatch, type, body, handlers.success);
	        });
	      }
	    } else {
	      var _response = null;
	      var ContentType = response.headers.get("content-type");
	      if (ContentType && ContentType.match(/application\/json/)) {
	        _response = response.json();
	      } else {
	        _response = Promise.resolve(null);
	      }
	      return _response.then(function (json) {
	        if (response.ok) {
	          success(dispatch, type, json, handlers.success);
	          return Promise.resolve(json);
	        } else {
	          handleFailure(dispatch, response, type, handlers, json);
	        }
	      }).catch(function (error) {
	        if (response.ok) {
	          success(dispatch, type, {}, handlers.success);
	        } else {
	          handleFailure(dispatch, response, type, handlers);
	        }
	      });
	    }
	  }).catch(function (error) {
	    handleFailure(dispatch, { status: 400 }, type, handlers);
	  });
	}

/***/ },
/* 46 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1583),
	    findIndex = __webpack_require__(414);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getMuiTheme = __webpack_require__(108);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	MuiThemeProvider.propTypes =  false ? {
	  children: _propTypes2.default.element,
	  muiTheme: _propTypes2.default.object
	} : {};
	exports.default = MuiThemeProvider;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getConfigInsightsStandard = exports.configInsightsStandard = exports.getClientTags = exports.sendInviteBusinessUnitMember = exports.getBusinessUnitTeamMembers = exports.getClientUsers = exports.getClientBusiness = exports.suspendAndReactivate = exports.updateClientProfile = exports.getClientProfile = exports.getBusinessUnitOptions = exports.getTeamMember = exports.createClientBusinessUnit = exports.createClientProfile = exports.getClientSites = exports.getClientName = exports.search_clients = exports.send_invitation = exports.inviteBusinessMember = exports.invitation_client = exports.getIndustryOptions = exports.getAllClientsTable = exports.getClientsTable = exports.getTierOptions = exports.getAccountManage = exports.get_client_options = exports.BUSINESS_UNITS_LIST = exports.resetStandardConfig = exports.rollbackProfileStatus = exports.rollbackStatus = exports.SUSPEND_AND_REACTIVATE = exports.UPDATE_CLIENT_PROFILE = exports.GET_CLIENT_PROFILE = exports.RESET_STANDARD_CONFIG = exports.GET_INSIGHTS_STANDARD_CONFIG = exports.INSIGHTS_STANDARD_CONFIG = exports.GET_CLIENT_TAGS = exports.INVITATE_BUSINESS_UNIT_MEMBER = exports.GET_BUSINESS_UNIT_TEAM_MEMBER = exports.CLIENT_USERS = exports.INVITE_BUSINESS_MEMBER = exports.BUSINESS_UNIT_OPTIONS = exports.TEAM_MEMBER = exports.ROLLBACK_PROFILE_STATUS = exports.CREATE_CLIENT_PROFILE = exports.CLIENT_NAME = exports.SEARCH_CLIENTS = exports.ROLLBACK_STATUS = exports.CLIENT_OPTIONS = exports.ACCOUNT_MANAGER = exports.TIER_OPTIONS = exports.SEND_INVITATION = exports.GET_INDUSTRY_OPTIONS = exports.INVITATION_CLIENT = exports.GET_ALL_CLIENTS_TABLE = exports.GET_CLIENT_SITES = exports.GET_CLIENTS_TABLE = undefined;
	
	var _Api = __webpack_require__(45);
	
	var _Insights = __webpack_require__(58);
	
	var GET_CLIENTS_TABLE = exports.GET_CLIENTS_TABLE = "GET_CLIENTS_TABLE";
	var GET_CLIENT_SITES = exports.GET_CLIENT_SITES = "GET_CLIENT_SITES";
	var GET_ALL_CLIENTS_TABLE = exports.GET_ALL_CLIENTS_TABLE = "GET_ALL_CLIENT_TABLE";
	var INVITATION_CLIENT = exports.INVITATION_CLIENT = "INVITATION_CLIENT";
	var GET_INDUSTRY_OPTIONS = exports.GET_INDUSTRY_OPTIONS = "GET_INDUSTRY_OPTIONS";
	var SEND_INVITATION = exports.SEND_INVITATION = "SEND_INVITATION";
	var TIER_OPTIONS = exports.TIER_OPTIONS = "TIER_OPTIONS";
	var ACCOUNT_MANAGER = exports.ACCOUNT_MANAGER = "ACCOUNT_MANAGER";
	var CLIENT_OPTIONS = exports.CLIENT_OPTIONS = "CLIENT_OPTIONS";
	var ROLLBACK_STATUS = exports.ROLLBACK_STATUS = "ROLLBACK_STATUS";
	var SEARCH_CLIENTS = exports.SEARCH_CLIENTS = "SEARCH_CLIENTS";
	var CLIENT_NAME = exports.CLIENT_NAME = "CLIENT_NAME";
	var CREATE_CLIENT_PROFILE = exports.CREATE_CLIENT_PROFILE = "CREATE_CLIENT_PROFILE";
	var ROLLBACK_PROFILE_STATUS = exports.ROLLBACK_PROFILE_STATUS = "ROLLBACK_PROFILE_STATUS"; // rollback profile ajax status
	var TEAM_MEMBER = exports.TEAM_MEMBER = "TEAM_MEMBER";
	var BUSINESS_UNIT_OPTIONS = exports.BUSINESS_UNIT_OPTIONS = "BUSINESS_UNIT_OPTIONS";
	var INVITE_BUSINESS_MEMBER = exports.INVITE_BUSINESS_MEMBER = "INVITE_BUSINESS_MEMBER";
	var CLIENT_USERS = exports.CLIENT_USERS = "CLIENT_USERS";
	var GET_BUSINESS_UNIT_TEAM_MEMBER = exports.GET_BUSINESS_UNIT_TEAM_MEMBER = "GET_BUSINESS_UNIT_TEAM_MEMBER";
	var INVITATE_BUSINESS_UNIT_MEMBER = exports.INVITATE_BUSINESS_UNIT_MEMBER = "INVITATE_BUSINESS_UNIT_MEMBER";
	var GET_CLIENT_TAGS = exports.GET_CLIENT_TAGS = "GET_CLIENT_TAGS";
	// INSIGHTS_STANDARD_CONFIG
	var INSIGHTS_STANDARD_CONFIG = exports.INSIGHTS_STANDARD_CONFIG = "INSIGHTS_STANDARD_CONFIG";
	var GET_INSIGHTS_STANDARD_CONFIG = exports.GET_INSIGHTS_STANDARD_CONFIG = "GET_INSIGHTS_STANDARD_CONFIG";
	var RESET_STANDARD_CONFIG = exports.RESET_STANDARD_CONFIG = "RESET_STANDARD_CONFIG";
	
	// below is edit page's type
	var GET_CLIENT_PROFILE = exports.GET_CLIENT_PROFILE = "GET_CLIENT_PROFILE";
	var UPDATE_CLIENT_PROFILE = exports.UPDATE_CLIENT_PROFILE = "UPDATE_CLIENT_PROFILE";
	var SUSPEND_AND_REACTIVATE = exports.SUSPEND_AND_REACTIVATE = "SUSPEND_AND_REACTIVATE";
	
	var rollbackStatus = exports.rollbackStatus = function rollbackStatus() {
	  return { type: ROLLBACK_STATUS, value: false };
	};
	var rollbackProfileStatus = exports.rollbackProfileStatus = function rollbackProfileStatus() {
	  return { type: ROLLBACK_PROFILE_STATUS };
	};
	var resetStandardConfig = exports.resetStandardConfig = function resetStandardConfig() {
	  return { type: RESET_STANDARD_CONFIG };
	};
	
	// for edit/Business-Units page
	var BUSINESS_UNITS_LIST = exports.BUSINESS_UNITS_LIST = "BUSINESS_UNITS_LIST";
	
	var get_client_options = exports.get_client_options = function get_client_options() {
	  return function (dispatch, getState) {
	    var url = "roles/client-options";
	    (0, _Api.callApi)(dispatch, getState, CLIENT_OPTIONS, url);
	  };
	};
	
	var getAccountManage = exports.getAccountManage = function getAccountManage() {
	  return function (dispatch, getState) {
	    var url = "commons/account-manager-options";
	    (0, _Api.callApi)(dispatch, getState, ACCOUNT_MANAGER, url);
	  };
	};
	
	var getTierOptions = exports.getTierOptions = function getTierOptions() {
	  return function (dispatch, getState) {
	    var url = "commons/subscription-tier-options";
	    (0, _Api.callApi)(dispatch, getState, TIER_OPTIONS, url);
	  };
	};
	
	// for client search api and get client table list
	var getClientsTable = exports.getClientsTable = function getClientsTable(obj) {
	  return function (dispatch, getState) {
	    var url = "clients/search";
	    (0, _Api.callApi)(dispatch, getState, GET_CLIENTS_TABLE, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var getAllClientsTable = exports.getAllClientsTable = function getAllClientsTable(obj) {
	  return function (dispatch, getState) {
	    var url = "clients/search";
	    (0, _Api.callApi)(dispatch, getState, GET_ALL_CLIENTS_TABLE, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var getIndustryOptions = exports.getIndustryOptions = function getIndustryOptions() {
	  return function (dispatch, getState) {
	    var url = "commons/industry-options";
	    (0, _Api.callApi)(dispatch, getState, GET_INDUSTRY_OPTIONS, url);
	  };
	};
	
	var invitation_client = exports.invitation_client = function invitation_client(obj) {
	  return function (dispatch, getState) {
	    var url = "invitations/client";
	    (0, _Api.callApi)(dispatch, getState, GET_CLIENTS_TABLE, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var inviteBusinessMember = exports.inviteBusinessMember = function inviteBusinessMember(obj) {
	  return function (dispatch, getState) {
	    var url = "invitations/client-to-business-unit-member";
	    (0, _Api.callApi)(dispatch, getState, INVITE_BUSINESS_MEMBER, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var send_invitation = exports.send_invitation = function send_invitation(obj) {
	  return function (dispatch, getState) {
	    var url = "invitations/client";
	
	    (0, _Api.callApi)(dispatch, getState, SEND_INVITATION, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var search_clients = exports.search_clients = function search_clients(obj) {
	  return function (dispatch, getState) {
	    var url = "clients";
	    (0, _Api.callApi)(dispatch, getState, SEARCH_CLIENTS, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	var getClientName = exports.getClientName = function getClientName() {
	  return function (dispatch, getState) {
	    var url = "commons/client-options";
	    (0, _Api.callApi)(dispatch, getState, CLIENT_NAME, url);
	  };
	};
	
	var getClientSites = exports.getClientSites = function getClientSites(cid, useLocalWebsiteId) {
	  return function (dispatch, getState) {
	    var url = "clients/" + cid + "/site-options";
	    (0, _Api.callApi)(dispatch, getState, GET_CLIENT_SITES, url, {}, {
	      success: function success() {
	        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var localWebsiteId = window.localStorage.getItem('__websiteId__');
	        var hasLocalId = false;
	        data.forEach(function (it) {
	          if (localWebsiteId !== undefined && +it.value === +localWebsiteId) {
	            hasLocalId = true;
	          }
	        });
	        var dataWebsiteId = data[0] && data[0].value;
	        var finalWebsiteId = useLocalWebsiteId && hasLocalId ? +localWebsiteId || dataWebsiteId : dataWebsiteId;
	        if (finalWebsiteId) {
	          dispatch((0, _Insights.setReportWebSiteId)(finalWebsiteId));
	        }
	      }
	    });
	  };
	};
	
	var createClientProfile = exports.createClientProfile = function createClientProfile(obj) {
	  return function (dispatch, getState) {
	    var url = "clients";
	    // localStorage.setItem('createClientStartTime', new Date().getTime())
	    (0, _Api.callApi)(dispatch, getState, CREATE_CLIENT_PROFILE, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var createClientBusinessUnit = exports.createClientBusinessUnit = function createClientBusinessUnit(obj, clientId) {
	  return function (dispatch, getState) {
	    var url = "clients/" + clientId + "/business-units";
	    if (obj.accountManagerUserIds && obj.accountManagerUserIds.length > 0 && obj.accountManagerUserIds[0] === "") {
	      obj.accountManagerUserIds = undefined;
	    }
	    (0, _Api.callApi)(dispatch, getState, CREATE_CLIENT_PROFILE, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	// get data for `assign business assign to`
	var getTeamMember = exports.getTeamMember = function getTeamMember(id) {
	  return function (dispatch, getState) {
	    var url = void 0;
	    if (/^(system administrator|account manager|administrator|team member)/gi.test(getState().app.roleName)) {
	      url = "clients/" + id + "/team-member-options";
	    } else {
	      url = "commons/team-member-options";
	    }
	    (0, _Api.callApi)(dispatch, getState, TEAM_MEMBER, url);
	  };
	};
	
	// business unit options
	var getBusinessUnitOptions = exports.getBusinessUnitOptions = function getBusinessUnitOptions() {
	  return function (dispatch, getState) {
	    var url = "commons/business-unit-options";
	
	    (0, _Api.callApi)(dispatch, getState, BUSINESS_UNIT_OPTIONS, url);
	  };
	};
	
	// below is edit page's action
	var getClientProfile = exports.getClientProfile = function getClientProfile(id) {
	  return function (dispatch, getState) {
	    var url = "clients/" + id;
	
	    (0, _Api.callApi)(dispatch, getState, GET_CLIENT_PROFILE, url, {}, {
	      failure: function failure() {
	        window.location.href = "/dashboard";
	      }
	    });
	  };
	};
	
	var updateClientProfile = exports.updateClientProfile = function updateClientProfile(id, obj) {
	  return function (dispatch, getState) {
	    var url = "clients/" + id;
	
	    (0, _Api.callApi)(dispatch, getState, UPDATE_CLIENT_PROFILE, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var suspendAndReactivate = exports.suspendAndReactivate = function suspendAndReactivate(clientId, status) {
	  return function (dispatch, getState) {
	    var url = void 0;
	    if (/^(system administrator|account manager|administrator|team member)/gi.test(getState().app.roleName)) {
	      url = "clients/" + clientId + "/" + status;
	    }
	
	    (0, _Api.callApi)(dispatch, getState, SUSPEND_AND_REACTIVATE, url, {
	      method: "POST"
	    });
	  };
	};
	
	// for edit/Business-Units page
	var getClientBusiness = exports.getClientBusiness = function getClientBusiness(id) {
	  return function (dispatch, getState) {
	    var url = "clients/" + id + "/business-units";
	
	    (0, _Api.callApi)(dispatch, getState, BUSINESS_UNITS_LIST, url);
	  };
	};
	
	var getClientUsers = exports.getClientUsers = function getClientUsers(cid, req) {
	  return function (dispatch, getState) {
	    var url = "clients/" + cid + "/users";
	
	    (0, _Api.callApi)(dispatch, getState, CLIENT_USERS, url, {
	      method: "POST",
	      body: JSON.stringify(req)
	    });
	  };
	};
	
	var getBusinessUnitTeamMembers = exports.getBusinessUnitTeamMembers = function getBusinessUnitTeamMembers(clientId, businessId) {
	  return function (dispatch, getState) {
	    var url = "clients/" + clientId + "/business-units/" + businessId + "/team-members";
	
	    (0, _Api.callApi)(dispatch, getState, GET_BUSINESS_UNIT_TEAM_MEMBER, url);
	  };
	};
	
	var sendInviteBusinessUnitMember = exports.sendInviteBusinessUnitMember = function sendInviteBusinessUnitMember(obj) {
	  return function (dispatch, getState) {
	    var url = void 0;
	    if (/^\/clients\/edit\/Client-Team-Members/.test(getState().routing.location.pathname)) {
	      url = "invitations/client-to-business-unit-member";
	    } else {
	      url = "invitations/internal-to-business-unit-member";
	    }
	
	    (0, _Api.callApi)(dispatch, getState, INVITATE_BUSINESS_UNIT_MEMBER, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var getClientTags = exports.getClientTags = function getClientTags(clientId) {
	  return function (dispatch, getState) {
	    var url = "clients/" + clientId + "/tags";
	    (0, _Api.callApi)(dispatch, getState, GET_CLIENT_TAGS, url);
	  };
	};
	
	//INSIGHTS_STANDARD_CONFIG
	var configInsightsStandard = exports.configInsightsStandard = function configInsightsStandard(id, obj) {
	  return function (dispatch, getState) {
	    var url = "clients/" + id + "/insights-standard-config";
	    (0, _Api.callApi)(dispatch, getState, INSIGHTS_STANDARD_CONFIG, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	// GET INSIGHTS STANDARD CONFIG
	var getConfigInsightsStandard = exports.getConfigInsightsStandard = function getConfigInsightsStandard(id) {
	  return function (dispatch, getState) {
	    var url = "clients/" + id + "/insights-standard-config";
	    (0, _Api.callApi)(dispatch, getState, GET_INSIGHTS_STANDARD_CONFIG, url);
	  };
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(1686);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseDomainOfCategoryAxis = exports.getBandSizeOfAxis = exports.parseSpecifiedDomain = exports.MAX_VALUE_REG = exports.MIN_VALUE_REG = exports.getDomainOfStackGroups = exports.getStackedDataOfItem = exports.detectReferenceElementsDomain = exports.ifOverflowMatches = exports.getBaseValueOfBar = exports.getCateCoordinateOfBar = exports.getCateCoordinateOfLine = exports.getTicksOfScale = exports.calculateDomainOfTicks = exports.getStackGroupsByAxisId = exports.getStackedData = exports.offsetSign = exports.truncateByDomain = exports.findPositionOfBar = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.parseErrorBarsOfAxis = exports.getDomainOfErrorBars = exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getDomainOfDataByKey = exports.getValueByDataKey = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(67));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(293));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(295));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	var _max2 = _interopRequireDefault(__webpack_require__(670));
	
	var _min2 = _interopRequireDefault(__webpack_require__(672));
	
	var _flatMap2 = _interopRequireDefault(__webpack_require__(665));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _get2 = _interopRequireDefault(__webpack_require__(186));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _rechartsScale = __webpack_require__(3058);
	
	var d3Scales = _interopRequireWildcard(__webpack_require__(577));
	
	var _d3Shape = __webpack_require__(388);
	
	var _DataUtils = __webpack_require__(40);
	
	var _ReferenceDot = _interopRequireDefault(__webpack_require__(999));
	
	var _ReferenceLine = _interopRequireDefault(__webpack_require__(1000));
	
	var _ReferenceArea = _interopRequireDefault(__webpack_require__(998));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(250));
	
	var _Legend = _interopRequireDefault(__webpack_require__(488));
	
	var _ReactUtils = __webpack_require__(25);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil2.default)(obj) || (0, _isNil2.default)(dataKey)) {
	    return defaultValue;
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(dataKey)) {
	    return (0, _get2.default)(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction2.default)(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	
	
	exports.getValueByDataKey = getValueByDataKey;
	
	var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = (0, _flatMap2.default)(data, function (entry) {
	    return getValueByDataKey(entry, key);
	  });
	
	  if (type === 'number') {
	    var domain = flattenData.filter(function (entry) {
	      return (0, _DataUtils.isNumber)(entry) || parseFloat(entry, 10);
	    });
	    return domain.length ? [(0, _min2.default)(domain), (0, _max2.default)(domain)] : [Infinity, -Infinity];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil2.default)(entry);
	  }) : flattenData;
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	exports.getDomainOfDataByKey = getDomainOfDataByKey;
	
	var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
	      var range = axis.range; // ticks are distributed in a circle
	
	      for (var i = 0; i < len; i++) {
	        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
	        var cur = unsortedTicks[i].coordinate;
	        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
	        var sameDirectionCoord = void 0;
	
	        if ((0, _DataUtils.mathSign)(cur - before) !== (0, _DataUtils.mathSign)(after - cur)) {
	          var diffInterval = [];
	
	          if ((0, _DataUtils.mathSign)(after - cur) === (0, _DataUtils.mathSign)(range[1] - range[0])) {
	            sameDirectionCoord = after;
	            var curInRange = cur + range[1] - range[0];
	            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
	            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
	          } else {
	            sameDirectionCoord = before;
	            var afterInRange = after + range[1] - range[0];
	            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
	            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
	          }
	
	          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
	
	          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        } else {
	          var min = Math.min(before, after);
	          var max = Math.max(before, after);
	
	          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        }
	      }
	    } else {
	      // ticks are distributed in a single direction
	      for (var _i = 0; _i < len; _i++) {
	        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
	          index = ticks[_i].index;
	          break;
	        }
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	
	
	exports.calculateActiveTickIndex = calculateActiveTickIndex;
	
	var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var result;
	
	  switch (displayName) {
	    case 'Line':
	    case 'Area':
	    case 'Radar':
	      result = item.props.stroke;
	      break;
	
	    default:
	      result = item.props.fill;
	      break;
	  }
	
	  return result;
	};
	
	exports.getMainColorOfGraphicItem = getMainColorOfGraphicItem;
	
	var getLegendProps = function getLegendProps(_ref) {
	  var children = _ref.children,
	      formatedGraphicalItems = _ref.formatedGraphicalItems,
	      legendWidth = _ref.legendWidth,
	      legendContent = _ref.legendContent;
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend.default);
	
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData;
	
	  if (legendItem.props && legendItem.props.payload) {
	    legendData = legendItem.props && legendItem.props.payload;
	  } else if (legendContent === 'children') {
	    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
	      var item = _ref2.item,
	          props = _ref2.props;
	      var data = props.sectors || props.data || [];
	      return result.concat(data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || item.props.legendType,
	          value: entry.name,
	          color: entry.fill,
	          payload: entry
	        };
	      }));
	    }, []);
	  } else {
	    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
	      var item = _ref3.item;
	      var _item$props = item.props,
	          dataKey = _item$props.dataKey,
	          name = _item$props.name,
	          legendType = _item$props.legendType,
	          hide = _item$props.hide;
	      return {
	        inactive: hide,
	        dataKey: dataKey,
	        type: legendItem.props.iconType || legendType || 'square',
	        color: getMainColorOfGraphicItem(item),
	        value: name || dataKey,
	        payload: item.props
	      };
	    });
	  }
	
	  return _objectSpread({}, legendItem.props, _Legend.default.getWithHeight(legendItem, legendWidth), {
	    payload: legendData,
	    item: legendItem
	  });
	};
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	
	
	exports.getLegendProps = getLegendProps;
	
	var getBarSizeList = function getBarSizeList(_ref4) {
	  var globalSize = _ref4.barSize,
	      _ref4$stackGroups = _ref4.stackGroups,
	      stackGroups = _ref4$stackGroups === void 0 ? {} : _ref4$stackGroups;
	
	  if (!stackGroups) {
	    return {};
	  }
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	      var barItems = items.filter(function (item) {
	        return (0, _ReactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil2.default)(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	
	
	exports.getBarSizeList = getBarSizeList;
	
	var getBarPosition = function getBarPosition(_ref5) {
	  var barGap = _ref5.barGap,
	      barCategoryGap = _ref5.barCategoryGap,
	      bandSize = _ref5.bandSize,
	      _ref5$sizeList = _ref5.sizeList,
	      sizeList = _ref5$sizeList === void 0 ? [] : _ref5$sizeList,
	      maxBarSize = _ref5.maxBarSize;
	  var len = sizeList.length;
	  if (len < 1) return null;
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result; // whether or not is barSize setted by user
	
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	
	    if (sum >= bandSize && fullBarSize > 0) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = {
	      offset: offset - realBarGap,
	      size: 0
	    };
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = _toConsumableArray(res).concat([{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: prev
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = _toConsumableArray(res).concat([{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: newRes[newRes.length - 1].position
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	exports.getBarPosition = getBarPosition;
	
	var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps({
	    children: children,
	    items: items,
	    legendWidth: legendWidth,
	    legendHeight: legendHeight
	  });
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};
	
	exports.appendOffsetOfLegend = appendOffsetOfLegend;
	
	var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
	  var children = item.props.children;
	  var errorBars = (0, _ReactUtils.findAllByType)(children, _ErrorBar.default).filter(function (errorBarChild) {
	    var direction = errorBarChild.props.direction;
	    return (0, _isNil2.default)(direction) || (0, _isNil2.default)(axisType) ? true : axisType.indexOf(direction) >= 0;
	  });
	
	  if (errorBars && errorBars.length) {
	    var keys = errorBars.map(function (errorBarChild) {
	      return errorBarChild.props.dataKey;
	    });
	    return data.reduce(function (result, entry) {
	      var entryValue = getValueByDataKey(entry, dataKey, 0);
	      var mainValue = (0, _isArray2.default)(entryValue) ? [(0, _min2.default)(entryValue), (0, _max2.default)(entryValue)] : [entryValue, entryValue];
	      var errorDomain = keys.reduce(function (prevErrorArr, k) {
	        var errorValue = getValueByDataKey(entry, k, 0);
	        var lowerValue = mainValue[0] - Math.abs((0, _isArray2.default)(errorValue) ? errorValue[0] : errorValue);
	        var upperValue = mainValue[1] + Math.abs((0, _isArray2.default)(errorValue) ? errorValue[1] : errorValue);
	        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
	      }, [Infinity, -Infinity]);
	      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	
	exports.getDomainOfErrorBars = getDomainOfErrorBars;
	
	var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
	  var domains = items.map(function (item) {
	    return getDomainOfErrorBars(data, item, dataKey, axisType);
	  }).filter(function (entry) {
	    return !(0, _isNil2.default)(entry);
	  });
	
	  if (domains && domains.length) {
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	
	
	exports.parseErrorBarsOfAxis = parseErrorBarsOfAxis;
	
	var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    var dataKey = item.props.dataKey;
	
	    if (type === 'number' && dataKey) {
	      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
	    }
	
	    return getDomainOfDataByKey(data, dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {}; // Get the union set of category axis
	
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	        result.push(entry[i]);
	      }
	    }
	
	    return result;
	  }, []);
	};
	
	exports.getDomainOfItemsWithSameAxis = getDomainOfItemsWithSameAxis;
	
	var isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
	};
	/**
	 * Calculate the Coordinates of grid
	 * @param  {Array} ticks The ticks in axis
	 * @param {Number} min   The minimun value of axis
	 * @param {Number} max   The maximun value of axis
	 * @return {Array}       Coordinates
	 */
	
	
	exports.isCategorialAxis = isCategorialAxis;
	
	var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin, hasMax;
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	
	
	exports.getCoordinatesOfGrid = getCoordinatesOfGrid;
	
	var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type,
	      range = axis.range;
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
	  offset = axis.axisType === 'angleAxis' ? (0, _DataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line
	
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index,
	        offset: offset
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return {
	        coordinate: scale(entry) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  } // When axis has duplicated text, serial numbers are used to generate scale
	
	
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index,
	      offset: offset
	    };
	  });
	};
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	
	
	exports.getTicksOfAxis = getTicksOfAxis;
	
	var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler;
	
	  if ((0, _isFunction2.default)(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction2.default)(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction2.default)(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction2.default)(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	
	      if ((0, _isFunction2.default)(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {Object}   axis          The option of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	
	
	exports.combineEventHandlers = combineEventHandlers;
	
	var parseScale = function parseScale(axis, chartType) {
	  var scale = axis.scale,
	      type = axis.type,
	      layout = axis.layout,
	      axisType = axis.axisType;
	
	  if (scale === 'auto') {
	    if (layout === 'radial' && axisType === 'radiusAxis') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    if (layout === 'radial' && axisType === 'angleAxis') {
	      return {
	        scale: d3Scales.scaleLinear(),
	        realScaleType: 'linear'
	      };
	    }
	
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return {
	        scale: d3Scales.scalePoint(),
	        realScaleType: 'point'
	      };
	    }
	
	    if (type === 'category') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    return {
	      scale: d3Scales.scaleLinear(),
	      realScaleType: 'linear'
	    };
	  }
	
	  if ((0, _isString2.default)(scale)) {
	    var name = "scale".concat(scale.slice(0, 1).toUpperCase()).concat(scale.slice(1));
	    return {
	      scale: (d3Scales[name] || d3Scales.scalePoint)(),
	      realScaleType: d3Scales[name] ? name : 'point'
	    };
	  }
	
	  return (0, _isFunction2.default)(scale) ? {
	    scale: scale
	  } : {
	    scale: d3Scales.scalePoint(),
	    realScaleType: 'point'
	  };
	};
	
	exports.parseScale = parseScale;
	var EPS = 1e-4;
	
	var checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	exports.checkDomainOfScale = checkDomainOfScale;
	
	var findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	exports.findPositionOfBar = findPositionOfBar;
	
	var truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !(0, _DataUtils.isNumber)(domain[0]) || !(0, _DataUtils.isNumber)(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	  var result = [value[0], value[1]];
	
	  if (!(0, _DataUtils.isNumber)(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!(0, _DataUtils.isNumber)(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};
	/* eslint no-param-reassign: 0 */
	
	
	exports.truncateByDomain = truncateByDomain;
	
	var offsetSign = function offsetSign(series) {
	  var n = series.length;
	
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = (0, _isNaN2.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	      /* eslint-disable prefer-destructuring */
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	      /* eslint-enable prefer-destructuring */
	
	    }
	  }
	};
	
	exports.offsetSign = offsetSign;
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +getValueByDataKey(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	  return stack(data);
	};
	
	exports.getStackedData = getStackedData;
	
	var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
	  if (!data) {
	    return null;
	  } // reversing items to affect render order (for layering)
	
	
	  var items = reverseStackOrder ? _items.reverse() : _items;
	  var stackGroups = items.reduce(function (result, item) {
	    var _item$props2 = item.props,
	        stackId = _item$props2.stackId,
	        hide = _item$props2.hide;
	
	    if (hide) {
	      return result;
	    }
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || {
	      hasStack: false,
	      stackGroups: {}
	    };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: []
	      };
	      childGroup.items.push(item);
	      parentGroup.hasStack = true;
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: [item]
	      };
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	        return _objectSpread({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	
	
	exports.getStackGroupsByAxisId = getStackGroupsByAxisId;
	
	var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [(0, _min2.default)(ticks), (0, _max2.default)(ticks)];
	  }
	
	  return ticks;
	};
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	
	
	exports.calculateDomainOfTicks = calculateDomainOfTicks;
	
	var getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var realScaleType = opts.realScaleType,
	      type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	  var scaleType = realScaleType || opts.scale;
	
	  if (scaleType !== 'auto' && scaleType !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	    return {
	      niceTicks: tickValues
	    };
	  }
	
	  if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return {
	      niceTicks: _tickValues
	    };
	  }
	
	  return null;
	};
	
	exports.getTicksOfScale = getTicksOfScale;
	
	var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
	  var axis = _ref6.axis,
	      ticks = _ref6.ticks,
	      bandSize = _ref6.bandSize,
	      entry = _ref6.entry,
	      index = _ref6.index,
	      dataKey = _ref6.dataKey;
	
	  if (axis.type === 'category') {
	    // find coordinate of category axis by the value of category
	    if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNil2.default)(entry[axis.dataKey])) {
	      var matchedTick = (0, _DataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
	
	      if (matchedTick) {
	        return matchedTick.coordinate + bandSize / 2;
	      }
	    }
	
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = getValueByDataKey(entry, !(0, _isNil2.default)(dataKey) ? dataKey : axis.dataKey);
	  return !(0, _isNil2.default)(value) ? axis.scale(value) : null;
	};
	
	exports.getCateCoordinateOfLine = getCateCoordinateOfLine;
	
	var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
	  var axis = _ref7.axis,
	      ticks = _ref7.ticks,
	      offset = _ref7.offset,
	      bandSize = _ref7.bandSize,
	      entry = _ref7.entry,
	      index = _ref7.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	
	  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
	  return !(0, _isNil2.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	exports.getCateCoordinateOfBar = getCateCoordinateOfBar;
	
	var getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
	  var numericAxis = _ref8.numericAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	exports.getBaseValueOfBar = getBaseValueOfBar;
	
	var ifOverflowMatches = function ifOverflowMatches(props, value) {
	  var alwaysShow = props.alwaysShow;
	  var ifOverflow = props.ifOverflow;
	
	  if (alwaysShow) {
	    ifOverflow = 'extendDomain';
	  }
	
	  return ifOverflow === value;
	};
	
	exports.ifOverflowMatches = ifOverflowMatches;
	
	var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine.default);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot.default);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea.default);
	  var idKey = "".concat(axisType, "Id");
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = "".concat(valueKey, "1");
	    var key2 = "".concat(valueKey, "2");
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (specifiedTicks && specifiedTicks.length) {
	    finalDomain = specifiedTicks.reduce(function (result, tick) {
	      if ((0, _DataUtils.isNumber)(tick)) {
	        return [Math.min(result[0], tick), Math.max(result[1], tick)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	exports.detectReferenceElementsDomain = detectReferenceElementsDomain;
	
	var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	
	exports.getStackedDataOfItem = getStackedDataOfItem;
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [(0, _min2.default)(entry.concat([result[0]]).filter(_DataUtils.isNumber)), (0, _max2.default)(entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	exports.getDomainOfStackGroups = getDomainOfStackGroups;
	var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MIN_VALUE_REG = MIN_VALUE_REG;
	var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MAX_VALUE_REG = MAX_VALUE_REG;
	
	var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray2.default)(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	  /* eslint-disable prefer-destructuring */
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	    domain[0] = dataDomain[0] - value;
	  } else if ((0, _isFunction2.default)(specifiedDomain[0])) {
	    domain[0] = specifiedDomain[0](dataDomain[0]);
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else if ((0, _isFunction2.default)(specifiedDomain[1])) {
	    domain[1] = specifiedDomain[1](dataDomain[1]);
	  } else {
	    domain[1] = dataDomain[1];
	  }
	  /* eslint-enable prefer-destructuring */
	
	
	  return domain;
	};
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	
	
	exports.parseSpecifiedDomain = parseSpecifiedDomain;
	
	var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy2.default)(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	/**
	 * parse the domain of a category axis when a domain is specified
	 * @param   {Array}        specifiedDomain  The domain specified by users
	 * @param   {Array}        calculatedDomain The domain calculated by dateKey
	 * @param   {ReactElement} axisChild        The axis element
	 * @returns {Array}        domains
	 */
	
	
	exports.getBandSizeOfAxis = getBandSizeOfAxis;
	
	var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
	  if (!specifiedDomain || !specifiedDomain.length) {
	    return calculatedDomain;
	  }
	
	  if ((0, _isEqual2.default)(specifiedDomain, (0, _get2.default)(axisChild, 'type.defaultProps.domain'))) {
	    return calculatedDomain;
	  }
	
	  return specifiedDomain;
	};
	
	exports.parseDomainOfCategoryAxis = parseDomainOfCategoryAxis;

/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.clean = clean;
	exports.request = request;
	exports.success = success;
	exports.failure = failure;
	exports.invalid = invalid;
	exports.unauthorized = unauthorized;
	
	var _Api = __webpack_require__(45);
	
	var _join = __webpack_require__(1642);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _split = __webpack_require__(1650);
	
	var _split2 = _interopRequireDefault(_split);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clean(type) {
		if (type.indexOf('.')) {
			return (0, _split2.default)(type, '.')[1];
		} else {
			return type;
		}
	}
	
	function request(type) {
		return (0, _join2.default)([_Api.API_REQUEST, type], '.');
	}
	
	function success(type) {
		return (0, _join2.default)([_Api.API_SUCCESS, type], '.');
	}
	
	function failure(type) {
		return (0, _join2.default)([_Api.API_FAILURE, type], '.');
	}
	
	function invalid(type) {
		return (0, _join2.default)([_Api.API_INVALID, type], '.');
	}
	
	function unauthorized(type) {
		return (0, _join2.default)([_Api.API_UNAUTHORIZED, type], '.');
	}

/***/ },
/* 55 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.0' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 57 */
[3148, 2848],
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDistributionHeatMapData = exports.getCultureCodeReport = exports.getSegmentDistributionSystems = exports.getStates = exports.saveFavoritePage = exports.getFavoritePages = exports.setPageFavorite = exports.getInsightsMostPopularPages = exports.getSegmentDistributionDeviceTypeReport = exports.getSegmentDistributionDeviceModelReport = exports.getSegmentDistributionDetailReport = exports.getSegmentReportTop5OS = exports.getSegmentDistribution = exports.getTop20FrequencyBusiness = exports.getDomesticVisits = exports.getDomesticBusinessStats = exports.getDomesticConsumerStats = exports.getOverviewTrafficeReport = exports.sendAssistRequest = exports.downloadTagAudienceFile = exports.getTagAudienceFiles = exports.getAudienceFilesData = exports.getHeatMapData = exports.getStatsTopAttributes = exports.getStatsByPrimaryDevices = exports.getStatsByDemographic = exports.getStatsByTimeofDay = exports.getStatsByRegionalTraffic = exports.getStatsByPopularPage = exports.getStatsByTime = exports.getStatsByOsType = exports.getStatsByDeviceModel = exports.getStatsByDeviceType = exports.GET_CULTURE_CODE_REPORT = exports.clearAllDomesticStats = exports.clearAudienceFilesData = exports.clearAllStats = exports.setReportWebSiteId = exports.setReportDayRange = exports.setReportGranularity = exports.GET_SEGMENT_DISTRIBUTION_SYSTEMS = exports.GET_BY_STATES = exports.GET_HEATMAP_DATA = exports.SAVE_FAVORITE_PAGES = exports.GET_FAVORITE_PAGES = exports.SET_PAGE_FAVORITE = exports.GET_INSIGHTS_POPULAR_PAGES = exports.GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT = exports.GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT = exports.GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT = exports.GET_TOP_5_OS_BREAKDOWN_REPORT = exports.GET_SEGMENT_DISTRIBUTION = exports.GET_TOP_20_FREQUENCY_BUSINESSES = exports.GET_DOMESTIC_VISITS = exports.CLEAR_ALL_DOMESTIC_STATS = exports.DOMESTIC_BUSINESS_STATS = exports.DOMESTIC_CONSUMER_VISITS_REPORT = exports.OVERVIEW_TRAFFIC_REPORT = exports.SEND_ASSIST_REQUEST = exports.DOWNLOAD_AUDIENCE_FILES = exports.GET_TAG_AUDIENCE_FILES = exports.CLEAR_AUDIENCE_FILES_DATA = exports.GET_AUDIENCE_FILES_DATA = exports.CLEAR_ALL_STATS = exports.SET_REPORT_WEBSITE_ID = exports.SET_REPORT_GRANULARITY = exports.SET_REPORT_DAY_RANGE = exports.GET_HEAT_MAP_DATA = exports.STATS_TOP_ATTRIBUTES = exports.STATS_BY_PRIMARY_DEVICES = exports.STATS_BY_DEMOGRAPHIC = exports.STATS_BY_TIME_OF_DAY = exports.STATS_BY_REGIONAL_TRAFFIC = exports.STATS_BY_POPULAR_PAGE = exports.STATS_BY_TIME = exports.STATS_BY_OS_TYPE = exports.STATS_BY_DEVICE_MODEL = exports.STATS_BY_DEVICE_TYPE = undefined;
	
	var _Api = __webpack_require__(45);
	
	var _helpers = __webpack_require__(95);
	
	var _isNil = __webpack_require__(56);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { isUndefined, isEmpty } from 'lodash'
	var STATS_BY_DEVICE_TYPE = exports.STATS_BY_DEVICE_TYPE = "STATS_BY_DEVICE_TYPE";
	var STATS_BY_DEVICE_MODEL = exports.STATS_BY_DEVICE_MODEL = "STATS_BY_DEVICE_MODEL";
	var STATS_BY_OS_TYPE = exports.STATS_BY_OS_TYPE = "STATS_BY_OS_TYPE";
	var STATS_BY_TIME = exports.STATS_BY_TIME = "STATS_BY_TIME";
	var STATS_BY_POPULAR_PAGE = exports.STATS_BY_POPULAR_PAGE = "STATS_BY_POPULAR_PAGE";
	var STATS_BY_REGIONAL_TRAFFIC = exports.STATS_BY_REGIONAL_TRAFFIC = "STATS_BY_REGIONAL_TRAFFIC";
	var STATS_BY_TIME_OF_DAY = exports.STATS_BY_TIME_OF_DAY = "STATS_BY_TIME_OF_DAY";
	var STATS_BY_DEMOGRAPHIC = exports.STATS_BY_DEMOGRAPHIC = "STATS_BY_DEMOGHAPHIC";
	var STATS_BY_PRIMARY_DEVICES = exports.STATS_BY_PRIMARY_DEVICES = "STATS_BY_PRIMARY_DEVICES";
	var STATS_TOP_ATTRIBUTES = exports.STATS_TOP_ATTRIBUTES = "STATS_TOP_ATTRIBUTES";
	var GET_HEAT_MAP_DATA = exports.GET_HEAT_MAP_DATA = "GET_HEAT_MAP_DATA";
	var SET_REPORT_DAY_RANGE = exports.SET_REPORT_DAY_RANGE = "SET_REPORT_DAY_RANGE";
	var SET_REPORT_GRANULARITY = exports.SET_REPORT_GRANULARITY = "SET_REPORT_GRANULARITY";
	var SET_REPORT_WEBSITE_ID = exports.SET_REPORT_WEBSITE_ID = "SET_REPORT_WEBSITE_ID";
	var CLEAR_ALL_STATS = exports.CLEAR_ALL_STATS = "CLEAR_ALL_STATS";
	var GET_AUDIENCE_FILES_DATA = exports.GET_AUDIENCE_FILES_DATA = "GET_AUDIENCE_FILES_DATA";
	var CLEAR_AUDIENCE_FILES_DATA = exports.CLEAR_AUDIENCE_FILES_DATA = "CLEAR_AUDIENCE_FILES_DATA";
	var GET_TAG_AUDIENCE_FILES = exports.GET_TAG_AUDIENCE_FILES = "GET_TAG_AUDIENCE_FILES";
	var DOWNLOAD_AUDIENCE_FILES = exports.DOWNLOAD_AUDIENCE_FILES = "DOWNLOAD_AUDIENCE_FILES";
	var SEND_ASSIST_REQUEST = exports.SEND_ASSIST_REQUEST = "SEND_ASSIST_REQUEST";
	var OVERVIEW_TRAFFIC_REPORT = exports.OVERVIEW_TRAFFIC_REPORT = "OVERVIEW_TRAFFIC_REPORT";
	var DOMESTIC_CONSUMER_VISITS_REPORT = exports.DOMESTIC_CONSUMER_VISITS_REPORT = "DOMESTIC_CONSUMER_VISITS_REPORT";
	var DOMESTIC_BUSINESS_STATS = exports.DOMESTIC_BUSINESS_STATS = "DOMESTIC_BUSINESS_STATS";
	var CLEAR_ALL_DOMESTIC_STATS = exports.CLEAR_ALL_DOMESTIC_STATS = "CLEAR_ALL_DOMESTIC_STATS";
	var GET_DOMESTIC_VISITS = exports.GET_DOMESTIC_VISITS = "GET_DOMESTIC_VISITS";
	var GET_TOP_20_FREQUENCY_BUSINESSES = exports.GET_TOP_20_FREQUENCY_BUSINESSES = "GET_TOP_20_FREQUENCY_BUSINESSES";
	var GET_SEGMENT_DISTRIBUTION = exports.GET_SEGMENT_DISTRIBUTION = "GET_SEGMENT_DISTRIBUTION";
	var GET_TOP_5_OS_BREAKDOWN_REPORT = exports.GET_TOP_5_OS_BREAKDOWN_REPORT = "GET_TOP_5_OS_BREAKDOWN_REPORT";
	var GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT = exports.GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT = "GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT";
	var GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT = exports.GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT = "GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT";
	var GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT = exports.GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT = "GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT";
	var GET_INSIGHTS_POPULAR_PAGES = exports.GET_INSIGHTS_POPULAR_PAGES = "GET_INSIGHTS_POPULAR_PAGES";
	var SET_PAGE_FAVORITE = exports.SET_PAGE_FAVORITE = "SET_PAGE_FAVORITE";
	var GET_FAVORITE_PAGES = exports.GET_FAVORITE_PAGES = "GET_FAVORITE_PAGES";
	var SAVE_FAVORITE_PAGES = exports.SAVE_FAVORITE_PAGES = "SAVE_FAVORITE_PAGES";
	var GET_HEATMAP_DATA = exports.GET_HEATMAP_DATA = "GET_HEATMAP_DATA";
	
	var GET_BY_STATES = exports.GET_BY_STATES = "GET_BY_STATES";
	
	var GET_SEGMENT_DISTRIBUTION_SYSTEMS = exports.GET_SEGMENT_DISTRIBUTION_SYSTEMS = "GET_SEGMENT_DISTRIBUTION_SYSTEMS";
	
	var setReportGranularity = exports.setReportGranularity = (0, _helpers.actionCreator)(SET_REPORT_GRANULARITY);
	var setReportDayRange = exports.setReportDayRange = (0, _helpers.actionCreator)(SET_REPORT_DAY_RANGE);
	var setReportWebSiteId = exports.setReportWebSiteId = (0, _helpers.actionCreator)(SET_REPORT_WEBSITE_ID);
	var clearAllStats = exports.clearAllStats = (0, _helpers.actionCreator)(CLEAR_ALL_STATS);
	var clearAudienceFilesData = exports.clearAudienceFilesData = (0, _helpers.actionCreator)(CLEAR_AUDIENCE_FILES_DATA);
	var clearAllDomesticStats = exports.clearAllDomesticStats = (0, _helpers.actionCreator)(CLEAR_ALL_DOMESTIC_STATS);
	
	var GET_CULTURE_CODE_REPORT = exports.GET_CULTURE_CODE_REPORT = "GET_CULTURE_CODE_REPORT";
	
	var getStatsByDeviceType = exports.getStatsByDeviceType = function getStatsByDeviceType(siteId, dateRange, type, popUrl) {
	  var typeParam = type && type.toLowerCase() === "consumer" ? "c" : "b";
	
	  return function (dispatch, getState) {
	    var url = "insights/" + siteId + "/visits/by-device-type/" + dateRange + "?t=" + typeParam;
	    if (popUrl) {
	      url += "&p=" + popUrl;
	    }
	    (0, _Api.callApi)(dispatch, getState, STATS_BY_DEVICE_TYPE, url);
	  };
	};
	
	var getStatsByDeviceModel = exports.getStatsByDeviceModel = function getStatsByDeviceModel(siteId, dateRange, type) {
	  var typeParam = type && type.toLowerCase() === "consumer" ? "c" : "b";
	
	  return function (dispatch, getState) {
	    var url = "insights/" + siteId + "/visits/by-device-model/" + dateRange + "?t=" + typeParam;
	    (0, _Api.callApi)(dispatch, getState, STATS_BY_DEVICE_MODEL, url);
	  };
	};
	
	var getStatsByOsType = exports.getStatsByOsType = function getStatsByOsType(siteId, dateRange, type) {
	  var typeParam = type && type.toLowerCase() === "consumer" ? "c" : "b";
	
	  return function (dispatch, getState) {
	    var url = "insights/" + siteId + "/visits/by-os-type/" + dateRange + "?t=" + typeParam;
	    (0, _Api.callApi)(dispatch, getState, STATS_BY_OS_TYPE, url);
	  };
	};
	
	var getStatsByTime = exports.getStatsByTime = function getStatsByTime(siteId, dateRange, page, type) {
	  var typeParam = type ? type.toLowerCase() === "consumer" ? "c" : "b" : null;
	  var url = "insights/" + siteId + "/visits/time-series/" + dateRange;
	  if (typeParam) {
	    url += "?t=" + typeParam;
	  }
	  if (!(0, _isNil2.default)(page)) {
	    if (typeParam) url += "&p=" + page;else url += "?p=" + page;
	  }
	
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, STATS_BY_TIME, url);
	  };
	};
	
	var getStatsByPopularPage = exports.getStatsByPopularPage = function getStatsByPopularPage(siteId, dateRange, type) {
	  var typeParam = type ? type.toLowerCase() === "consumer" ? "c" : "b" : null;
	
	  return function (dispatch, getState) {
	    var url = typeParam ? "insights/" + siteId + "/visits/popular-pages/" + dateRange + "?t=" + typeParam : "insights/" + siteId + "/visits/popular-pages/" + dateRange;
	    (0, _Api.callApi)(dispatch, getState, STATS_BY_POPULAR_PAGE, url);
	  };
	};
	
	var getStatsByRegionalTraffic = exports.getStatsByRegionalTraffic = function getStatsByRegionalTraffic(siteId, dateRange, page, type) {
	  var typeParam = type ? type.toLowerCase() === "consumer" ? "c" : "b" : null;
	  var url = "insights/" + siteId + "/visits/by-states/" + dateRange;
	  if (typeParam) {
	    url += "?t=" + typeParam;
	  }
	  if (!(0, _isNil2.default)(page)) {
	    if (typeParam) url += "&p=" + page;else url += "?p=" + page;
	  }
	
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, STATS_BY_REGIONAL_TRAFFIC, url);
	  };
	};
	
	var getStatsByTimeofDay = exports.getStatsByTimeofDay = function getStatsByTimeofDay(siteId, dateRange, page, type) {
	  var typeParam = type ? type.toLowerCase() === "consumer" ? "c" : "b" : null;
	  var url = "insights/" + siteId + "/visits/by-time-of-day/" + dateRange;
	  if (typeParam) {
	    url += "?t=" + typeParam;
	  }
	  if (!(0, _isNil2.default)(page)) {
	    if (typeParam) url += "&p=" + page;else url += "?p=" + page;
	  }
	
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, STATS_BY_TIME_OF_DAY, url);
	  };
	};
	
	var getStatsByDemographic = exports.getStatsByDemographic = function getStatsByDemographic(siteId, dateRange, page, type, granularity) {
	  var typeParam = type ? type.toLowerCase() === "consumer" ? "c" : "b" : null;
	  var url = "insights/" + siteId + "/visits/demographic-stats/" + dateRange;
	  if (typeParam) {
	    url += "?t=" + typeParam;
	  }
	  if (!(0, _isNil2.default)(page)) {
	    if (typeParam) url += "&p=" + page;else url += "?p=" + page;
	  }
	  url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, STATS_BY_DEMOGRAPHIC, url);
	  };
	};
	
	var getStatsByPrimaryDevices = exports.getStatsByPrimaryDevices = function getStatsByPrimaryDevices(siteId, dateRange, page) {
	  var url = "insights/" + siteId + "/visits/by-primary-device-type/" + dateRange;
	  if (!(0, _isNil2.default)(page)) {
	    url += "?p=" + page;
	  }
	
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, STATS_BY_PRIMARY_DEVICES, url);
	  };
	};
	
	var getStatsTopAttributes = exports.getStatsTopAttributes = function getStatsTopAttributes(siteId, dateRange, page, type, granularity) {
	  var typeParam = type ? type.toLowerCase() === "consumer" ? "c" : "b" : null;
	  var url = "insights/" + siteId + "/visits/top-attributes/" + dateRange;
	  if (typeParam) {
	    url += "?t=" + typeParam;
	  }
	  if (!(0, _isNil2.default)(page)) {
	    if (typeParam) url += "&p=" + page;else url += "?p=" + page;
	  }
	  url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, STATS_TOP_ATTRIBUTES, url);
	  };
	};
	
	var getHeatMapData = exports.getHeatMapData = function getHeatMapData(siteId, dateRange, page, type) {
	  var typeParam = type ? type.toLowerCase() === "consumer" ? "c" : "b" : null;
	  var url = "insights/" + siteId + "/visits/heat-map/" + dateRange;
	  if (typeParam) {
	    url += "?t=" + typeParam;
	  }
	  if (!(0, _isNil2.default)(page)) {
	    if (typeParam) url += "&p=" + page;else url += "?p=" + page;
	  }
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_HEAT_MAP_DATA, url);
	  };
	};
	
	var getAudienceFilesData = exports.getAudienceFilesData = function getAudienceFilesData(tagId) {
	  return function (dispatch, getState) {
	    var url = "insights/" + tagId + "/insights-files";
	    (0, _Api.callApi)(dispatch, getState, GET_AUDIENCE_FILES_DATA, url);
	  };
	};
	
	var getTagAudienceFiles = exports.getTagAudienceFiles = function getTagAudienceFiles(tagId) {
	  return function (dispatch, getState) {
	    var url = "insights/insights-files/" + tagId;
	    (0, _Api.callApi)(dispatch, getState, GET_TAG_AUDIENCE_FILES, url);
	  };
	};
	
	var downloadTagAudienceFile = exports.downloadTagAudienceFile = function downloadTagAudienceFile(fileId) {
	  return function (dispatch, getState) {
	    var url = "insights/insights-files/" + fileId + "/download";
	    (0, _Api.callApi)(dispatch, getState, DOWNLOAD_AUDIENCE_FILES, url);
	  };
	};
	
	var sendAssistRequest = exports.sendAssistRequest = function sendAssistRequest(data) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SEND_ASSIST_REQUEST, "insights/assist/request", {
	      method: "POST",
	      body: JSON.stringify(data)
	    });
	  };
	};
	
	var getOverviewTrafficeReport = exports.getOverviewTrafficeReport = function getOverviewTrafficeReport(tagId, dateRange) {
	  var url = "insights/" + tagId + "/visits/overview/" + dateRange;
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, OVERVIEW_TRAFFIC_REPORT, url);
	  };
	};
	
	var getDomesticConsumerStats = exports.getDomesticConsumerStats = function getDomesticConsumerStats(tagId, dateRange, granularity) {
	  var url = "insights/" + tagId + "/visits/domestic-consumer-stats/" + dateRange;
	  url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, DOMESTIC_CONSUMER_VISITS_REPORT, url);
	  };
	};
	
	var getDomesticBusinessStats = exports.getDomesticBusinessStats = function getDomesticBusinessStats(tagId, dateRange, granularity) {
	  var url = granularity ? "insights/" + tagId + "/visits/domestic-business-stats/" + dateRange + "?granularity=" + granularity : "insights/" + tagId + "/visits/domestic-business-stats/" + dateRange;
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, DOMESTIC_BUSINESS_STATS, url);
	  };
	};
	
	var getDomesticVisits = exports.getDomesticVisits = function getDomesticVisits(tagId, dateRange, type, page) {
	  var typeParam = type ? type.toLowerCase() === "consumer" ? "c" : "b" : null;
	  var url = "insights/" + tagId + "/visits/" + dateRange;
	  if (typeParam) {
	    url += "?t=" + typeParam;
	  }
	  if (!(0, _isNil2.default)(page)) {
	    if (typeParam) url += "&p=" + page;else url += "?p=" + page;
	  }
	
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_DOMESTIC_VISITS, url);
	  };
	};
	
	var getTop20FrequencyBusiness = exports.getTop20FrequencyBusiness = function getTop20FrequencyBusiness(tagId, dateRange) {
	  var url = "insights/" + tagId + "/visits/top-companies/" + dateRange;
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_TOP_20_FREQUENCY_BUSINESSES, url);
	  };
	};
	
	var getSegmentDistribution = exports.getSegmentDistribution = function getSegmentDistribution(tagId, segment, dateRange, granularity, page) {
	  var url = page ? "insights/" + tagId + "/segment-distribution/" + segment + "/" + dateRange + "?page=" + page : "insights/" + tagId + "/segment-distribution/" + segment + "/" + dateRange;
	  window.localStorage.setItem("__segmentSysId__", segment);
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_SEGMENT_DISTRIBUTION, url);
	  };
	};
	
	var getSegmentReportTop5OS = exports.getSegmentReportTop5OS = function getSegmentReportTop5OS(tagId, segment, dateRange, segmentIds, granularity, page) {
	  var url = segmentIds ? "insights/" + tagId + "/segment-distribution/" + segment + "/by-os-type/" + dateRange + "?segments=" + segmentIds : "insights/" + tagId + "/segment-distribution/" + segment + "/by-os-type/" + dateRange;
	  if (page) {
	    url = (0, _utility.pushParamsToUrl)(url, "page", page);
	  }
	  if (granularity) {
	    url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	  }
	
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_TOP_5_OS_BREAKDOWN_REPORT, url);
	  };
	};
	
	var getSegmentDistributionDetailReport = exports.getSegmentDistributionDetailReport = function getSegmentDistributionDetailReport(tagId, segment, dateRange, segmentIds, page, granularity) {
	  //Age = 101, Gender = 102, Marital Status = 103, Home Owner = 201, Income = 202, Length of Residence = 206,State = 1
	  var ids = [1, 101, 102, 103, 201, 202, 206];
	  var url = segmentIds ? "insights/" + tagId + "/segment-distribution/" + segment + "/demographics/" + dateRange + "?segments=" + segmentIds : "insights/" + tagId + "/segment-distribution/" + segment + "/demographics/" + dateRange;
	  if (page) {
	    if (url.indexOf("?segments=") > 0) {
	      url += "&page=" + encodeURIComponent(page);
	    } else {
	      url += "?page=" + encodeURIComponent(page);
	    }
	  }
	  url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT, url);
	  };
	};
	
	var getSegmentDistributionDeviceModelReport = exports.getSegmentDistributionDeviceModelReport = function getSegmentDistributionDeviceModelReport(tagId, segment, dateRange, segmentIds, granularity, page) {
	  var url = segmentIds ? "insights/" + tagId + "/segment-distribution/" + segment + "/by-device-model/" + dateRange + "?segments=" + segmentIds : "insights/" + tagId + "/segment-distribution/" + segment + "/by-device-model/" + dateRange;
	  if (page) {
	    if (url.indexOf("?segments=") > 0) {
	      url += "&page=" + page;
	    } else {
	      url += "?page=" + page;
	    }
	  }
	  url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT, url);
	  };
	};
	
	var getSegmentDistributionDeviceTypeReport = exports.getSegmentDistributionDeviceTypeReport = function getSegmentDistributionDeviceTypeReport(tagId, segment, dateRange, segmentIds, granularity, page) {
	  var url = segmentIds ? "insights/" + tagId + "/segment-distribution/" + segment + "/by-device-type/" + dateRange + "?segments=" + segmentIds : "insights/" + tagId + "/segment-distribution/" + segment + "/by-device-type/" + dateRange;
	  if (page) {
	    if (url.indexOf("?segments=") > 0) {
	      url += "&page=" + page;
	    } else {
	      url += "?page=" + page;
	    }
	  }
	  url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT, url);
	  };
	};
	
	var getInsightsMostPopularPages = exports.getInsightsMostPopularPages = function getInsightsMostPopularPages(tagId, dateRange) {
	  var url = "insights/" + tagId + "/most-popular-pages/" + dateRange;
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_INSIGHTS_POPULAR_PAGES, url);
	  };
	};
	
	var setPageFavorite = exports.setPageFavorite = function setPageFavorite(tagId, dateRange, pageUrl, favorited) {
	  var url = "insights/" + tagId + "/toggle-favorite-page ";
	  var postData = {
	    pageUrl: pageUrl,
	    toggleAdd: favorited
	  };
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SET_PAGE_FAVORITE, url, {
	      method: "POST",
	      body: JSON.stringify(postData)
	    });
	  };
	};
	
	var getFavoritePages = exports.getFavoritePages = function getFavoritePages(tagId) {
	  var url = "insights/" + tagId + "/favorite-pages";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_FAVORITE_PAGES, url);
	  };
	};
	
	var saveFavoritePage = exports.saveFavoritePage = function saveFavoritePage(tagId, pages) {
	  var url = "insights/" + tagId + "/favorite-pages";
	  var postData = pages;
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SAVE_FAVORITE_PAGES, url, {
	      method: "POST",
	      body: JSON.stringify(postData)
	    }, {
	      success: function success() {
	        dispatch(getFavoritePages(tagId));
	      }
	    });
	  };
	};
	
	var getStates = exports.getStates = function getStates(siteId, dateRange, page, type) {
	  var typeParam = type ? type.toLowerCase() === "consumer" ? "c" : "b" : null;
	  var url = "insights/" + siteId + "/visits/by-states/" + dateRange;
	  if (page) {
	    url += "?p=" + page;
	  }
	  if (typeParam) {
	    if (page) url += "&t=" + typeParam;else url += "?t=" + typeParam;
	  }
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_BY_STATES, url);
	  };
	};
	
	var getSegmentDistributionSystems = exports.getSegmentDistributionSystems = function getSegmentDistributionSystems(siteId, callback) {
	  var url = "insights/" + siteId + "/segment-distribution/systems";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_SEGMENT_DISTRIBUTION_SYSTEMS, url).then(function (res) {
	      callback && callback(res);
	    });
	  };
	};
	
	var getCultureCodeReport = exports.getCultureCodeReport = function getCultureCodeReport(tagId, segment, dateRange, segments, page, granularity) {
	  var url = "insights/" + tagId + "/segment-distribution/" + segment + "/culturecode/" + dateRange;
	  if (segments) {
	    url += "?segments=" + segments;
	  }
	  if (page) {
	    if (url.includes("?")) url += "&page=" + encodeURIComponent(page);else url += "?page=" + page;
	  }
	  url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_CULTURE_CODE_REPORT, url);
	  };
	};
	
	var getDistributionHeatMapData = exports.getDistributionHeatMapData = function getDistributionHeatMapData(tagId, segment, dateRange, segmentIds, page, granularity) {
	  var url = "insights/" + tagId + "/segment-distribution/" + segment + "/heat-map/" + dateRange;
	  if (segmentIds) {
	    url += "?segments=" + segmentIds;
	  }
	  if (page) {
	    if (url.includes("?")) url += "&page=" + encodeURIComponent(page);else url += "?page=" + page;
	  }
	  url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_HEATMAP_DATA, url);
	  };
	};

/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 60 */
[3191, 1551, 1552, 151, 29, 1648],
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(628),
	    baseFilter = __webpack_require__(1537),
	    baseIteratee = __webpack_require__(60),
	    isArray = __webpack_require__(29);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInfoOutline = function ActionInfoOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z' })
	  );
	};
	ActionInfoOutline = (0, _pure2.default)(ActionInfoOutline);
	ActionInfoOutline.displayName = 'ActionInfoOutline';
	ActionInfoOutline.muiName = 'SvgIcon';
	
	exports.default = ActionInfoOutline;

/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAP = exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;
	
	var MARKER = exports.MARKER = "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var RECTANGLE = exports.RECTANGLE = "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var POLYLINE = exports.POLYLINE = "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var POLYGON = exports.POLYGON = "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var CIRCLE = exports.CIRCLE = "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var KML_LAYER = exports.KML_LAYER = "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var DIRECTIONS_RENDERER = exports.DIRECTIONS_RENDERER = "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var HEATMAP_LAYER = exports.HEATMAP_LAYER = "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var FUSION_TABLES_LAYER = exports.FUSION_TABLES_LAYER = "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var ANCHOR = exports.ANCHOR = "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var INFO_WINDOW = exports.INFO_WINDOW = "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var OVERLAY_VIEW = exports.OVERLAY_VIEW = "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var DRAWING_MANAGER = exports.DRAWING_MANAGER = "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var SEARCH_BOX = exports.SEARCH_BOX = "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var MARKER_CLUSTERER = exports.MARKER_CLUSTERER = "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var INFO_BOX = exports.INFO_BOX = "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var TRAFFIC_LAYER = exports.TRAFFIC_LAYER = "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
	
	var STREET_VIEW_PANORAMA = exports.STREET_VIEW_PANORAMA = "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

/***/ },
/* 64 */
[3147, 916],
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(2904);
	
	/**
	 * This method is like `_.flow` except that it creates a function that
	 * invokes the given functions from right to left.
	 *
	 * @static
	 * @since 3.0.0
	 * @memberOf _
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flow
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flowRight([square, _.add]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flowRight = createFlow(true);
	
	module.exports = flowRight;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2974)();
	}


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(146),
	    baseOrderBy = __webpack_require__(642),
	    baseRest = __webpack_require__(227),
	    isIterateeCall = __webpack_require__(182);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _curry2 = __webpack_require__(2957);
	
	var _curry3 = _interopRequireDefault(_curry2);
	
	var _noop2 = __webpack_require__(948);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _forEach2 = __webpack_require__(2960);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _bind2 = __webpack_require__(2955);
	
	var _bind3 = _interopRequireDefault(_bind2);
	
	var _isFunction2 = __webpack_require__(331);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _has2 = __webpack_require__(2962);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _reduce2 = __webpack_require__(2969);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _identity2 = __webpack_require__(244);
	
	var _identity3 = _interopRequireDefault(_identity2);
	
	var _mapKeys2 = __webpack_require__(2966);
	
	var _mapKeys3 = _interopRequireDefault(_mapKeys2);
	
	exports.addDefaultPrefixToPropTypes = addDefaultPrefixToPropTypes;
	exports.removeDefaultPrefix = removeDefaultPrefix;
	exports.collectProps = collectProps;
	exports.collectUncontrolledAndControlledProps = collectUncontrolledAndControlledProps;
	exports.default = enhanceElement;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	function addDefaultPrefixToPropTypes(propTypes /*: Object*/) {
	  return (0, _mapKeys3.default)(propTypes, function (value, key) {
	    return "default" + key.substr(0, 1).toUpperCase() + key.substr(1);
	  });
	}
	
	function removeDefaultPrefix(defaultKey) {
	  // default = 7
	  var key = defaultKey.substr(7);
	  return "" + key.substr(0, 1).toLowerCase() + key.substr(1);
	}
	
	function collectProps(propTypes /*: Object*/, props /*: Object*/) {
	  var keyTransform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity3.default;
	
	  return (0, _reduce3.default)(propTypes, function (acc, value, key) {
	    if ((0, _has3.default)(props, key)) {
	      var nextKey = keyTransform(key);
	      // eslint-disable-next-line no-param-reassign
	      acc[nextKey] = props[key];
	    }
	    return acc;
	  }, {});
	}
	
	function collectUncontrolledAndControlledProps(defaultUncontrolledPropTypes /*: Object*/, controlledPropTypes /*: Object*/, props /*: Object*/) {
	  return (0, _extends3.default)({}, collectProps(defaultUncontrolledPropTypes, props, removeDefaultPrefix), collectProps(controlledPropTypes, props));
	}
	
	function registerGoogleEventsFromReactProps(instance /*: Object*/, props /*: Object*/, eventMap /*: Object*/) {
	  var registered = (0, _reduce3.default)(eventMap, function (acc, googleEventName, onEventName) {
	    if ((0, _isFunction3.default)(props[onEventName])) {
	      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
	    }
	    return acc;
	  }, []);
	
	  return (0, _bind3.default)(_forEach3.default, null, registered, function (event) {
	    return google.maps.event.removeListener(event);
	  });
	}
	
	function registerEventsFromComponent(component, getInstanceFromComponent, eventMap) {
	  var instance = getInstanceFromComponent(component);
	  // eslint-disable-next-line no-param-reassign
	  component._unregisterEvents = registerGoogleEventsFromReactProps(instance, component.props, eventMap);
	}
	
	function unregisterEventsFromComponent(component, getInstanceFromComponent) {
	  // eslint-disable-next-line no-param-reassign
	  component._unregisterEvents();
	  // eslint-disable-next-line no-param-reassign
	  component._unregisterEvents = _noop3.default;
	}
	
	var enhanceWithPropTypes = (0, _curry3.default)(function (getInstanceFromComponent, controlledPropUpdaterMap, componentSpec) {
	  var _componentSpec$compon = componentSpec.componentDidUpdate,
	      _componentDidUpdate = _componentSpec$compon === undefined ? _noop3.default : _componentSpec$compon;
	
	  return (0, _extends3.default)({}, componentSpec, {
	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	      var _this = this;
	
	      (0, _forEach3.default)(controlledPropUpdaterMap, function (fn, key) {
	        var nextValue = _this.props[key];
	        if (nextValue !== prevProps[key]) {
	          fn(getInstanceFromComponent(_this), nextValue, _this);
	        }
	      });
	      _componentDidUpdate.call(this, prevProps, prevState);
	    }
	  });
	});
	
	var enhanceWithEventMap = (0, _curry3.default)(function (getInstanceFromComponent, eventMap, componentSpec) {
	  var _componentSpec$compon2 = componentSpec.componentDidMount,
	      _componentDidMount = _componentSpec$compon2 === undefined ? _noop3.default : _componentSpec$compon2,
	      _componentSpec$compon3 = componentSpec.componentDidUpdate,
	      _componentDidUpdate2 = _componentSpec$compon3 === undefined ? _noop3.default : _componentSpec$compon3,
	      _componentSpec$compon4 = componentSpec.componentWillUnmount,
	      _componentWillUnmount = _componentSpec$compon4 === undefined ? _noop3.default : _componentSpec$compon4;
	
	  return (0, _extends3.default)({}, componentSpec, {
	
	    _unregisterEvents: _noop3.default,
	
	    componentDidMount: function componentDidMount() {
	      _componentDidMount.call(this);
	      registerEventsFromComponent(this, getInstanceFromComponent, eventMap);
	    },
	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	      unregisterEventsFromComponent(this, getInstanceFromComponent);
	      _componentDidUpdate2.call(this, prevProps, prevState);
	      registerEventsFromComponent(this, getInstanceFromComponent, eventMap);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      unregisterEventsFromComponent(this, getInstanceFromComponent);
	      _componentWillUnmount.call(this);
	    }
	  });
	});
	
	var enhanceWithPublicMethod = (0, _curry3.default)(function (getInstanceFromComponent, publicMethodMap, componentSpec) {
	  return (0, _reduce3.default)(publicMethodMap, function (acc, fn, publicMethodName) {
	    // eslint-disable-next-line no-param-reassign
	    acc[publicMethodName] = function publicMethod() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return fn(getInstanceFromComponent(this), args, /* Use with caution */this);
	    };
	    return acc;
	  }, (0, _extends3.default)({}, componentSpec));
	});
	
	function enhanceElement(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap) {
	  return (0, _flowRight3.default)(enhanceWithPublicMethod(getInstanceFromComponent, publicMethodMap), enhanceWithEventMap(getInstanceFromComponent, eventMap), enhanceWithPropTypes(getInstanceFromComponent, controlledPropUpdaterMap));
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(2860);
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _CanvasRenderer = __webpack_require__(615);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _Logger = __webpack_require__(607);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _Window = __webpack_require__(1479);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html2canvas = function html2canvas(element, conf) {
	    var config = conf || {};
	    var logger = new _Logger2.default(typeof config.logging === 'boolean' ? config.logging : true);
	    logger.log('html2canvas ' + "$npm_package_version");
	
	    if (false) {
	        logger.error('onrendered option is deprecated, html2canvas returns a Promise with the canvas as the value');
	    }
	
	    var ownerDocument = element.ownerDocument;
	    if (!ownerDocument) {
	        return Promise.reject('Provided element is not within a Document');
	    }
	    var defaultView = ownerDocument.defaultView;
	
	    var defaultOptions = {
	        async: true,
	        allowTaint: false,
	        backgroundColor: '#ffffff',
	        imageTimeout: 15000,
	        logging: true,
	        proxy: null,
	        removeContainer: true,
	        foreignObjectRendering: false,
	        scale: defaultView.devicePixelRatio || 1,
	        target: new _CanvasRenderer2.default(config.canvas),
	        useCORS: false,
	        windowWidth: defaultView.innerWidth,
	        windowHeight: defaultView.innerHeight,
	        scrollX: defaultView.pageXOffset,
	        scrollY: defaultView.pageYOffset
	    };
	
	    var result = (0, _Window.renderElement)(element, _extends({}, defaultOptions, config), logger);
	
	    if (false) {
	        return result.catch(function (e) {
	            logger.error(e);
	            throw e;
	        });
	    }
	    return result;
	};
	
	html2canvas.CanvasRenderer = _CanvasRenderer2.default;
	
	module.exports = html2canvas;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(global, process) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.jsPDF=e()}(this,function(){"use strict";var t,w,e,I,i,o,a,c,A,T,d,p,F,n,r,s,l,q,E,P,g,m,y,h,v,b,x,S,u,k,_,f,C,O,B,j,R,D,M,z,N,L,U,H,W,V,G,Y,X,J,vt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},K=function(pt){var gt="1.3",mt={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};function yt(o){var a={};this.subscribe=function(t,e,n){if("function"!=typeof e)return!1;a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){pt.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}}}function wt(t,e,n,r){var i={};"object"===(void 0===t?"undefined":vt(t))&&(t=(i=t).orientation,e=i.unit||e,n=i.format||n,r=i.compress||i.compressPdf||r),e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();(""+n).toLowerCase();var tt,y,w,o,u,v,a,s,c,l,h,f=!!r&&"function"==typeof Uint8Array,et=i.textColor||"0 g",d=i.drawColor||"0 G",nt=i.fontSize||16,rt=i.charSpace||0,it=i.R2L||!1,ot=i.lineHeight||1.15,p=i.lineWidth||.200025,g="00000000000000000000000000000000",m=2,b=!1,x=[],at={},S={},k=0,_=[],C=[],I=[],A=[],T=[],F=0,q=0,E=0,P={title:"",subject:"",author:"",keywords:"",creator:""},O={},st=new yt(O),B=i.hotfixes||[],j=function(t){var e,n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]),s={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4","indianred ":"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgrey:"#d3d3d3",lightgreen:"#90ee90",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370d8",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#d87093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",rebeccapurple:"#663399",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"};if("string"==typeof n&&s.hasOwnProperty(n)&&(n=s[n]),"string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var c=parseInt(n.substr(1),16);n=c>>16&255,r=c>>8&255,i=255&c}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=N(n/255)+" "+a[0];break;case 3:default:e=L(n/255)+" "+a[0]}else if(void 0===o||"object"===(void 0===o?"undefined":vt(o))){if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[N(n/255),N(r/255),N(i/255),a[1]].join(" ");break;default:case 3:e=[L(n/255),L(r/255),L(i/255),a[1]].join(" ")}o&&0===o.a&&(e=["255","255","255",a[1]].join(" "))}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[N(n),N(r),N(i),N(o),a[2]].join(" ");break;case 3:default:e=[L(n),L(r),L(i),L(o),a[2]].join(" ")}return e},R=function(t){var e=function(t){return("0"+parseInt(t)).slice(-2)},n=t.getTimezoneOffset(),r=n<0?"+":"-",i=Math.floor(Math.abs(n/60)),o=Math.abs(n%60),a=[r,e(i),"'",e(o),"'"].join("");return["D:",t.getFullYear(),e(t.getMonth()+1),e(t.getDate()),e(t.getHours()),e(t.getMinutes()),e(t.getSeconds()),a].join("")},D=function(t){var e;return void 0===(void 0===t?"undefined":vt(t))&&(t=new Date),e="object"===(void 0===t?"undefined":vt(t))&&"[object Date]"===Object.prototype.toString.call(t)?R(t):/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t)?t:R(new Date),l=e},M=function(t){var e=l;return"jsDate"===t&&(e=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)}(l)),e},z=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),g=t},N=function(t){return t.toFixed(2)},L=function(t){return t.toFixed(3)},ct=function(t){t="string"==typeof t?t:t.toString(),b?_[o].push(t):(E+=t.length+1,A.push(t))},U=function(){return x[++m]=E,ct(m+" 0 obj"),m},H=function(t){ct("stream"),ct(t),ct("endstream")},W=function(){for(var t in ct("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),ct("/Font <<"),at)at.hasOwnProperty(t)&&ct("/"+t+" "+at[t].objectNumber+" 0 R");ct(">>"),ct("/XObject <<"),st.publish("putXobjectDict"),ct(">>")},V=function(){!function(){for(var t in at)at.hasOwnProperty(t)&&(e=at[t],st.publish("putFont",{font:e,out:ct,newObject:U}),!0!==e.isAlreadyPutted&&(e.objectNumber=U(),ct("<<"),ct("/Type /Font"),ct("/BaseFont /"+e.postScriptName),ct("/Subtype /Type1"),"string"==typeof e.encoding&&ct("/Encoding /"+e.encoding),ct("/FirstChar 32"),ct("/LastChar 255"),ct(">>"),ct("endobj")));var e}(),st.publish("putResources"),x[2]=E,ct("2 0 obj"),ct("<<"),W(),ct(">>"),ct("endobj"),st.publish("postPutResources")},G=function(t,e,n){S.hasOwnProperty(e)||(S[e]={}),S[e][n]=t},Y=function(t,e,n,r){var i="F"+(Object.keys(at).length+1).toString(10),o=at[i]={id:i,postScriptName:t,fontName:e,fontStyle:n,encoding:r,metadata:{}};return G(i,e,n),st.publish("addFont",o),i},lt=function(t,e){return function(t,e){var n,r,i,o,a,s,c,l,h;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&at[tt].metadata&&at[tt].metadata[i]&&at[tt].metadata[i].encoding&&(o=at[tt].metadata[i].encoding,!a&&at[tt].encoding&&(a=at[tt].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(c=!1,s=[],n=0,r=t.length;n<r;n++)(l=a[t.charCodeAt(n)])?s.push(String.fromCharCode(l)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(c=!0);t=s.join("")}for(n=t.length;void 0===c&&0!==n;)t.charCodeAt(n-1)>>8&&(c=!0),n--;if(!c)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((h=(l=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(h),s.push(l-(h<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},X=function(){(function(t,e){var n="string"==typeof e&&e.toLowerCase();if("string"==typeof t){var r=t.toLowerCase();mt.hasOwnProperty(r)&&(t=mt[r][0]/y,e=mt[r][1]/y)}if(Array.isArray(t)&&(e=t[1],t=t[0]),n){switch(n.substr(0,1)){case"l":t<e&&(n="s");break;case"p":e<t&&(n="s")}"s"===n&&(w=t,t=e,e=w)}b=!0,_[++k]=[],I[k]={width:Number(t)||u,height:Number(e)||v},C[k]={},J(k)}).apply(this,arguments),ct(N(p*y)+" w"),ct(d),0!==F&&ct(F+" J"),0!==q&&ct(q+" j"),st.publish("addPage",{pageNumber:k})},J=function(t){0<t&&t<=k&&(u=I[o=t].width,v=I[t].height)},K=function(t,e){var n,r;return t=void 0!==t?t:at[tt].fontName,e=void 0!==e?e:at[tt].fontStyle,r=t.toLowerCase(),void 0!==S[r]&&void 0!==S[r][e]?n=S[r][e]:void 0!==S[t]&&void 0!==S[t][e]?n=S[t][e]:console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),n||null==(n=S.times[e])&&(n=S.times.normal),n},Q=function(){b=!1,m=2,E=0,A=[],x=[],T=[],st.publish("buildDocument"),ct("%PDF-"+gt),ct("%ºß¬à"),function(){var t,e,n,r,i,o,a,s,c,l=[];for(a=pt.adler32cs||wt.API.adler32cs,f&&void 0===a&&(f=!1),t=1;t<=k;t++){if(l.push(U()),s=(u=I[t].width)*y,c=(v=I[t].height)*y,ct("<</Type /Page"),ct("/Parent 1 0 R"),ct("/Resources 2 0 R"),ct("/MediaBox [0 0 "+N(s)+" "+N(c)+"]"),st.publish("putPage",{pageNumber:t,page:_[t]}),ct("/Contents "+(m+1)+" 0 R"),ct(">>"),ct("endobj"),e=_[t].join("\n"),U(),f){for(n=[],r=e.length;r--;)n[r]=e.charCodeAt(r);o=a.from(e),(i=new Deflater(6)).append(new Uint8Array(n)),e=i.flush(),(n=new Uint8Array(e.length+6)).set(new Uint8Array([120,156])),n.set(e,2),n.set(new Uint8Array([255&o,o>>8&255,o>>16&255,o>>24&255]),e.length+2),e=String.fromCharCode.apply(null,n),ct("<</Length "+e.length+" /Filter [/FlateDecode]>>")}else ct("<</Length "+e.length+">>");H(e),ct("endobj")}x[1]=E,ct("1 0 obj"),ct("<</Type /Pages");var h="/Kids [";for(r=0;r<k;r++)h+=l[r]+" 0 R ";ct(h+"]"),ct("/Count "+k),ct(">>"),ct("endobj"),st.publish("postPutPages")}(),function(){st.publish("putAdditionalObjects");for(var t=0;t<T.length;t++){var e=T[t];x[e.objId]=E,ct(e.objId+" 0 obj"),ct(e.content),ct("endobj")}m+=T.length,st.publish("postPutAdditionalObjects")}(),V(),U(),ct("<<"),function(){for(var t in ct("/Producer (jsPDF "+wt.version+")"),P)P.hasOwnProperty(t)&&P[t]&&ct("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+lt(P[t])+")");ct("/CreationDate ("+l+")")}(),ct(">>"),ct("endobj"),U(),ct("<<"),function(){switch(ct("/Type /Catalog"),ct("/Pages 1 0 R"),s||(s="fullwidth"),s){case"fullwidth":ct("/OpenAction [3 0 R /FitH null]");break;case"fullheight":ct("/OpenAction [3 0 R /FitV null]");break;case"fullpage":ct("/OpenAction [3 0 R /Fit]");break;case"original":ct("/OpenAction [3 0 R /XYZ null null 1]");break;default:var t=""+s;"%"===t.substr(t.length-1)&&(s=parseInt(s)/100),"number"==typeof s&&ct("/OpenAction [3 0 R /XYZ null null "+N(s)+"]")}switch(c||(c="continuous"),c){case"continuous":ct("/PageLayout /OneColumn");break;case"single":ct("/PageLayout /SinglePage");break;case"two":case"twoleft":ct("/PageLayout /TwoColumnLeft");break;case"tworight":ct("/PageLayout /TwoColumnRight")}a&&ct("/PageMode /"+a),st.publish("putCatalog")}(),ct(">>"),ct("endobj");var t,e=E,n="0000000000";for(ct("xref"),ct("0 "+(m+1)),ct(n+" 65535 f "),t=1;t<=m;t++){var r=x[t];ct("function"==typeof r?(n+x[t]()).slice(-10)+" 00000 n ":(n+x[t]).slice(-10)+" 00000 n ")}return ct("trailer"),ct("<<"),ct("/Size "+(m+1)),ct("/Root "+m+" 0 R"),ct("/Info "+(m-1)+" 0 R"),ct("/ID [ <"+g+"> <"+g+"> ]"),ct(">>"),ct("startxref"),ct(""+e),ct("%%EOF"),b=!0,A.join("\n")},Z=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e},$=function(){for(var t=Q(),e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},ht=function(){return new Blob([$()],{type:"application/pdf"})},ut=((h=function(t,e){var n="dataur"===(""+t).substr(0,6)?"data:application/pdf;base64,"+btoa(Q()):0;switch(t){case void 0:return Q();case"save":if("object"===("undefined"==typeof navigator?"undefined":vt(navigator))&&navigator.getUserMedia&&(void 0===pt.URL||void 0===pt.URL.createObjectURL))return O.output("dataurlnewwindow");bt(ht(),e),"function"==typeof bt.unload&&pt.setTimeout&&setTimeout(bt.unload,911);break;case"arraybuffer":return $();case"blob":return ht();case"bloburi":case"bloburl":return pt.URL&&pt.URL.createObjectURL(ht())||void 0;case"datauristring":case"dataurlstring":return n;case"dataurlnewwindow":var r=pt.open(n);if(r||"undefined"==typeof safari)return r;case"datauri":case"dataurl":return pt.document.location.href=n;default:throw new Error('Output type "'+t+'" is not supported.')}}).foo=function(){try{return h.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!pt.console)throw new Error(n);pt.console.error(n,t),pt.alert&&alert(n)}},(h.foo.bar=h).foo),ft=function(t){return!0===Array.isArray(B)&&-1<B.indexOf(t)};switch(e){case"pt":y=1;break;case"mm":y=72/25.4;break;case"cm":y=72/2.54;break;case"in":y=72;break;case"px":y=1==ft("px_scaling")?.75:96/72;break;case"pc":case"em":y=12;break;case"ex":y=6;break;default:throw"Invalid unit: "+e}for(var dt in D(),z(),O.internal={pdfEscape:lt,getStyle:Z,getFont:function(){return at[K.apply(O,arguments)]},getFontSize:function(){return nt},getCharSpace:function(){return rt},getTextColor:function(){var t=et.split(" ");if(2===t.length&&"g"===t[1]){var e=parseFloat(t[0]);t=[e,e,e,"r"]}for(var n="#",r=0;r<3;r++)n+=("0"+Math.floor(255*parseFloat(t[r])).toString(16)).slice(-2);return n},getLineHeight:function(){return nt*ot},write:function(t){ct(1===arguments.length?t:Array.prototype.join.call(arguments," "))},getCoordinateString:function(t){return N(t*y)},getVerticalCoordinateString:function(t){return N((v-t)*y)},collections:{},newObject:U,newAdditionalObject:function(){var t=2*_.length+1,e={objId:t+=T.length,content:""};return T.push(e),e},newObjectDeferred:function(){return x[++m]=function(){return E},m},newObjectDeferredBegin:function(t){x[t]=E},putStream:H,events:st,scaleFactor:y,pageSize:{getWidth:function(){return u},getHeight:function(){return v}},output:function(t,e){return ut(t,e)},getNumberOfPages:function(){return _.length-1},pages:_,out:ct,f2:N,getPageInfo:function(t){return{objId:2*(t-1)+3,pageNumber:t,pageContext:C[t]}},getCurrentPageInfo:function(){return{objId:2*(o-1)+3,pageNumber:o,pageContext:C[o]}},getPDFVersion:function(){return gt},hasHotfix:ft},O.addPage=function(){return X.apply(this,arguments),this},O.setPage=function(){return J.apply(this,arguments),this},O.insertPage=function(t){return this.addPage(),this.movePage(o,t),this},O.movePage=function(t,e){if(e<t){for(var n=_[t],r=I[t],i=C[t],o=t;e<o;o--)_[o]=_[o-1],I[o]=I[o-1],C[o]=C[o-1];_[e]=n,I[e]=r,C[e]=i,this.setPage(e)}else if(t<e){for(n=_[t],r=I[t],i=C[t],o=t;o<e;o++)_[o]=_[o+1],I[o]=I[o+1],C[o]=C[o+1];_[e]=n,I[e]=r,C[e]=i,this.setPage(e)}return this},O.deletePage=function(){return function(t){0<t&&t<=k&&(_.splice(t,1),I.splice(t,1),--k<o&&(o=k),this.setPage(o))}.apply(this,arguments),this},O.setCreationDate=function(t){return D(t),this},O.getCreationDate=function(t){return M(t)},O.setFileId=function(t){return z(t),this},O.getFileId=function(){return g},O.setDisplayMode=function(t,e,n){if(s=t,c=e,-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(a=n))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+n+'" is not recognized.');return this},O.text=function(t,e,n,i){var r,o,a="";function s(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):"[object Array]"===Object.prototype.toString.call(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function c(t,e){var n;if("string"==typeof t)n=e(t)[0];else if("[object Array]"===Object.prototype.toString.call(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):"[object Array]"===Object.prototype.toString.call(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}var l=function(t,e){return"function"==typeof e.font.metadata.widthOfString?e.font.metadata.widthOfString(t,e.fontSize,e.charSpace):u(function(t,e){var n,r,i,o=(e=e||{}).widths?e.widths:e.font.metadata.Unicode.widths,a=o.fof?o.fof:1,s=e.kerning?e.kerning:e.font.metadata.Unicode.kerning,c=s.fof?s.fof:1,l=0,h=o[0]||a,u=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),u.push((o[i]||h)/a+(s[i]&&s[i][l]||0)/c),l=i;return u}(t,e))*e.fontSize};var h,u=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n};"number"==typeof t&&(h=n,n=e,e=t,t=h);var f=i,d=arguments[4],p=arguments[5];"object"===(void 0===f?"undefined":vt(f))&&null!==f||("string"==typeof d&&(p=d,d=null),"string"==typeof f&&(p=f,f=null),"number"==typeof f&&(d=f,f=null),i={flags:f,angle:d,align:p});var g=!1,m=!0;if("string"==typeof t)g=!0;else if("[object Array]"===Object.prototype.toString.call(t)){for(var y,w=t.concat(),v=[],b=w.length;b--;)("string"!=typeof(y=w.shift())||"[object Array]"===Object.prototype.toString.call(y)&&"string"!=typeof y[0])&&(m=!1);g=m}if(!1===g)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var x=at[tt].encoding;"WinAnsiEncoding"!==x&&"StandardEncoding"!==x||(t=c(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),lt(r,f)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var S=i.maxWidth||0,k=i.maxWidthAlgorythm||"first-fit";o=i.lineHeight||ot;var _=at[tt],C=this.internal.scaleFactor,I=i.charSpace||rt,A=l(" ",{font:_,charSpace:I,fontSize:nt})/C,T=function(t,e){var n=0,r=0,i=[],o=[],a=[],s=[],c=[];for(s=t.split(/ /g),n=0;n<s.length;n+=1)o.push(l(s[n],{font:_,charSpace:I,fontSize:nt})/C);for(n=0;n<s.length;n+=1)a=o.slice(r,n),e<=u(a)+A*(a.length-1)?(i.push(s.slice(r,0!==n?n-1:0).join(" ")),r=0!==n?n-1:0,n-=1):n===o.length-1&&i.push(s.slice(r,o.length).join(" "));for(c=[],n=0;n<i.length;n+=1)c=c.concat(i[n]);return c};if(0<S)switch(k){case"first-fit":default:t=function(t,e){var n=0,r=[];for(n=0;n<t.length;n+=1)r=r.concat(T(t[n],e));return r}(t,S)}var F={text:t,x:e,y:n,options:i,mutex:{pdfEscape:lt,activeFontKey:tt,fonts:at,activeFontSize:nt}};st.publish("preProcessText",F),t=F.text;d=(i=F.options).angle,C=this.internal.scaleFactor,this.internal.pageSize.getHeight();var q=[];if(d){d*=Math.PI/180;var E=Math.cos(d),P=Math.sin(d),O=function(t){return t.toFixed(2)};q=[O(E),O(P),O(-1*P),O(E)]}void 0!==(I=i.charSpace)&&(a+=I+" Tc\n");i.lang;var B=-1,j=i.renderingMode||i.stroke,R=this.internal.getCurrentPageInfo().pageContext;switch(j){case 0:case!1:case"fill":B=0;break;case 1:case!0:case"stroke":B=1;break;case 2:case"fillThenStroke":B=2;break;case 3:case"invisible":B=3;break;case 4:case"fillAndAddForClipping":B=4;break;case 5:case"strokeAndAddPathForClipping":B=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":B=6;break;case 7:case"addToPathForClipping":B=7}var D=R.usedRenderingMode||-1;-1!==B?a+=B+" Tr\n":-1!==D&&(a+="0 Tr\n"),-1!==B&&(R.usedRenderingMode=B);p=i.align||"left";var M=nt*o,z=this.internal.pageSize.getHeight(),N=this.internal.pageSize.getWidth(),L=(C=this.internal.scaleFactor,_=at[tt],I=i.charSpace||rt,S=i.maxWidth||0,f={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var U,H;v=s(t);"left"!==p&&(H=v.map(function(t){return l(t,{font:_,charSpace:I,fontSize:nt})/C}));var W,V=Math.max.apply(Math,H),G=0;if("right"===p){e-=H[0],t=[];var Y=0;for(b=v.length;Y<b;Y++)V-H[Y],0===Y?(W=e*C,U=(z-n)*C):(W=(G-H[Y])*C,U=-M),t.push([v[Y],W,U]),G=H[Y]}else if("center"===p){e-=H[0]/2,t=[];for(Y=0,b=v.length;Y<b;Y++)(V-H[Y])/2,0===Y?(W=e*C,U=(z-n)*C):(W=(G-H[Y])/2*C,U=-M),t.push([v[Y],W,U]),G=H[Y]}else if("left"===p){t=[];for(Y=0,b=v.length;Y<b;Y++)U=0===Y?(z-n)*C:-M,W=0===Y?e*C:0,t.push(v[Y])}else{if("justify"!==p)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(S=0!==S?S:N,Y=0,b=v.length;Y<b;Y++)U=0===Y?(z-n)*C:-M,W=0===Y?e*C:0,Y<b-1&&L.push(((S-H[Y])/(v[Y].split(" ").length-1)*C).toFixed(2)),t.push([v[Y],W,U])}}!0===("boolean"==typeof i.R2L?i.R2L:it)&&(t=c(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));F={text:t,x:e,y:n,options:i,mutex:{pdfEscape:lt,activeFontKey:tt,fonts:at,activeFontSize:nt}};st.publish("postProcessText",F),t=F.text,r=F.mutex.isHex;v=s(t);t=[];var X,J,K,Q=0,Z=(b=v.length,"");for(Y=0;Y<b;Y++)Z="","[object Array]"!==Object.prototype.toString.call(v[Y])?(X=parseFloat(e*C).toFixed(2),J=parseFloat((z-n)*C).toFixed(2),K=(r?"<":"(")+v[Y]+(r?">":")")):"[object Array]"===Object.prototype.toString.call(v[Y])&&(X=parseFloat(v[Y][1]).toFixed(2),J=parseFloat(v[Y][2]).toFixed(2),K=(r?"<":"(")+v[Y][0]+(r?">":")"),Q=1),void 0!==L&&void 0!==L[Y]&&(Z=L[Y]+" Tw\n"),0!==q.length&&0===Y?t.push(Z+q.join(" ")+" "+X+" "+J+" Tm\n"+K):1===Q||0===Q&&0===Y?t.push(Z+X+" "+J+" Td\n"+K):t.push(Z+K);t=0===Q?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var $="BT\n/"+tt+" "+nt+" Tf\n"+(nt*o).toFixed(2)+" TL\n"+et+"\n";return $+=a,$+=t,ct($+="ET"),this},O.lstext=function(t,e,n,r){console.warn("jsPDF.lstext is deprecated");for(var i=0,o=t.length;i<o;i++,e+=r)this.text(t[i],e,n);return this},O.line=function(t,e,n,r){return this.lines([[n-t,r-e]],t,e)},O.clip=function(){ct("W"),ct("S")},O.clip_fixed=function(t){ct("evenodd"===t?"W*":"W"),ct("n")},O.lines=function(t,e,n,r,i,o){var a,s,c,l,h,u,f,d,p,g,m;for("number"==typeof t&&(w=n,n=e,e=t,t=w),r=r||[1,1],ct(L(e*y)+" "+L((v-n)*y)+" m "),a=r[0],s=r[1],l=t.length,g=e,m=n,c=0;c<l;c++)2===(h=t[c]).length?(g=h[0]*a+g,m=h[1]*s+m,ct(L(g*y)+" "+L((v-m)*y)+" l")):(u=h[0]*a+g,f=h[1]*s+m,d=h[2]*a+g,p=h[3]*s+m,g=h[4]*a+g,m=h[5]*s+m,ct(L(u*y)+" "+L((v-f)*y)+" "+L(d*y)+" "+L((v-p)*y)+" "+L(g*y)+" "+L((v-m)*y)+" c"));return o&&ct(" h"),null!==i&&ct(Z(i)),this},O.rect=function(t,e,n,r,i){Z(i);return ct([N(t*y),N((v-e)*y),N(n*y),N(-r*y),"re"].join(" ")),null!==i&&ct(Z(i)),this},O.triangle=function(t,e,n,r,i,o,a){return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},O.roundedRect=function(t,e,n,r,i,o,a){var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},O.ellipse=function(t,e,n,r,i){var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return ct([N((t+n)*y),N((v-e)*y),"m",N((t+n)*y),N((v-(e-a))*y),N((t+o)*y),N((v-(e-r))*y),N(t*y),N((v-(e-r))*y),"c"].join(" ")),ct([N((t-o)*y),N((v-(e-r))*y),N((t-n)*y),N((v-(e-a))*y),N((t-n)*y),N((v-e)*y),"c"].join(" ")),ct([N((t-n)*y),N((v-(e+a))*y),N((t-o)*y),N((v-(e+r))*y),N(t*y),N((v-(e+r))*y),"c"].join(" ")),ct([N((t+o)*y),N((v-(e+r))*y),N((t+n)*y),N((v-(e+a))*y),N((t+n)*y),N((v-e)*y),"c"].join(" ")),null!==i&&ct(Z(i)),this},O.circle=function(t,e,n,r){return this.ellipse(t,e,n,n,r)},O.setProperties=function(t){for(var e in P)P.hasOwnProperty(e)&&t[e]&&(P[e]=t[e]);return this},O.setFontSize=function(t){return nt=t,this},O.setFont=function(t,e){return tt=K(t,e),this},O.setFontStyle=O.setFontType=function(t){return tt=K(void 0,t),this},O.getFontList=function(){var t,e,n,r={};for(t in S)if(S.hasOwnProperty(t))for(e in r[t]=n=[],S[t])S[t].hasOwnProperty(e)&&n.push(e);return r},O.addFont=function(t,e,n,r){Y(t,e,n,r=r||"Identity-H")},O.setLineWidth=function(t){return ct((t*y).toFixed(2)+" w"),this},O.setDrawColor=function(t,e,n,r){return ct(j({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2})),this},O.setFillColor=function(t,e,n,r){return ct(j({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2})),this},O.setTextColor=function(t,e,n,r){return et=j({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},O.setCharSpace=function(t){return rt=t,this},O.setR2L=function(t){return it=t,this},O.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},O.setLineCap=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return ct((F=e)+" J"),this},O.setLineJoin=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return ct((q=e)+" j"),this},O.output=ut,O.save=function(t){O.output("save",t)},wt.API)wt.API.hasOwnProperty(dt)&&("events"===dt&&wt.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(st,wt.API.events):O[dt]=wt.API[dt]);return function(){for(var t="helvetica",e="times",n="courier",r="normal",i="bold",o="italic",a="bolditalic",s=[["Helvetica",t,r,"WinAnsiEncoding"],["Helvetica-Bold",t,i,"WinAnsiEncoding"],["Helvetica-Oblique",t,o,"WinAnsiEncoding"],["Helvetica-BoldOblique",t,a,"WinAnsiEncoding"],["Courier",n,r,"WinAnsiEncoding"],["Courier-Bold",n,i,"WinAnsiEncoding"],["Courier-Oblique",n,o,"WinAnsiEncoding"],["Courier-BoldOblique",n,a,"WinAnsiEncoding"],["Times-Roman",e,r,"WinAnsiEncoding"],["Times-Bold",e,i,"WinAnsiEncoding"],["Times-Italic",e,o,"WinAnsiEncoding"],["Times-BoldItalic",e,a,"WinAnsiEncoding"],["ZapfDingbats","zapfdingbats",r,null],["Symbol","symbol",r,null]],c=0,l=s.length;c<l;c++){var h=Y(s[c][0],s[c][1],s[c][2],s[c][3]),u=s[c][0].split("-");G(h,u[0],u[1]||"")}st.publish("addFonts",{fonts:at,dictionary:S})}(),tt="F1",X(n,t),st.publish("initialized"),O}return wt.API={events:[]},wt.version="0.0.0", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return wt}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=wt,module.exports.jsPDF=wt):pt.jsPDF=wt,wt}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
	/** @preserve
	   * jsPDF - PDF Document creation from JavaScript
	   * Version 1.4.0 Built on 2018-05-21T16:49:19.312Z
	   *                           CommitID 48c1917315
	   *
	   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
	   *               2010 Aaron Spike, https://github.com/acspike
	   *               2012 Willow Systems Corporation, willow-systems.com
	   *               2012 Pablo Hess, https://github.com/pablohess
	   *               2012 Florian Jenett, https://github.com/fjenett
	   *               2013 Warren Weckesser, https://github.com/warrenweckesser
	   *               2013 Youssef Beddad, https://github.com/lifof
	   *               2013 Lee Driscoll, https://github.com/lsdriscoll
	   *               2013 Stefan Slonevskiy, https://github.com/stefslon
	   *               2013 Jeremy Morel, https://github.com/jmorel
	   *               2013 Christoph Hartmann, https://github.com/chris-rock
	   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	   *               2014 James Makes, https://github.com/dollaruw
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *               2014 Steven Spungin, https://github.com/Flamenco
	   *               2014 Kenneth Glassey, https://github.com/Gavvers
	   *
	   * Licensed under the MIT License
	   *
	   * Contributor(s):
	   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
	   *    kim3er, mfo, alnorth, Flamenco
	   */
	/**
	   * jsPDF AcroForm Plugin
	   * Copyright (c) 2016 Alexander Weidt, https://github.com/BiggA94
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	!function(n,t){var h,a,e=1,r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},s=function(t){return t*(e/1)},o=function(t,e){return"function"==typeof e.font.metadata.widthOfString?e.font.metadata.widthOfString(t,e.fontSize,e.charSpace):i(function(t,e){var n,r,i,o=(e=e||{}).widths?e.widths:e.font.metadata.Unicode.widths,a=o.fof?o.fof:1,s=e.kerning?e.kerning:e.font.metadata.Unicode.kerning,c=s.fof?s.fof:1,l=0,h=o[0]||a,u=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),u.push((o[i]||h)/a+(s[i]&&s[i][l]||0)/c),l=i;return u}(t,e))*e.fontSize};var i=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},c=function(t){var e=new T,n=U.internal.getHeight(t)||0,r=U.internal.getWidth(t)||0;return e.BBox=[0,0,r.toFixed(2),n.toFixed(2)],e},l=function(t,e,n){t=t||0;var r=1;if(r<<=e-1,1==(n=n||1))t=t|r;else t=t&~r;return t},u=function(t,e,n){n=n||1.3,t=t||0;return 1==e.readOnly&&(t=l(t,1)),1==e.required&&(t=l(t,2)),1==e.noExport&&(t=l(t,3)),1==e.multiline&&(t=l(t,13)),e.password&&(t=l(t,14)),e.noToggleToOff&&(t=l(t,15)),e.radio&&(t=l(t,16)),e.pushbutton&&(t=l(t,17)),e.combo&&(t=l(t,18)),e.edit&&(t=l(t,19)),e.sort&&(t=l(t,20)),e.fileSelect&&1.4<=n&&(t=l(t,21)),e.multiSelect&&1.4<=n&&(t=l(t,22)),e.doNotSpellCheck&&1.4<=n&&(t=l(t,23)),1==e.doNotScroll&&1.4<=n&&(t=l(t,24)),e.richText&&1.4<=n&&(t=l(t,25)),t},f=function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o={};return Array.isArray(e)?(e[0]=s(e[0]),e[1]=s(e[1]),e[2]=s(e[2]),e[3]=s(e[3])):(e=s(e),n=s(n),r=s(r),i=s(i)),o.lowerLeft_X=e||0,o.lowerLeft_Y=s(a)-n-i||0,o.upperRight_X=e+r||0,o.upperRight_Y=s(a)-n||0,[o.lowerLeft_X.toFixed(2),o.lowerLeft_Y.toFixed(2),o.upperRight_X.toFixed(2),o.upperRight_Y.toFixed(2)]},d=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=p(t,n);e.push("/Tx BMC"),e.push("q"),e.push("/F1 "+r.fontSize.toFixed(2)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push("BT"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var i=new c(t);return i.stream=e.join("\n"),i}},p=function(t,e,i,n){n=n||12,i=i||"helvetica";var r={text:"",fontSize:""},o=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" "),a=n,s=U.internal.getHeight(t)||0;s=s<0?-s:s;var c=U.internal.getWidth(t)||0;c=c<0?-c:c;var l=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return C(r,n+"px",i).width<=c-4}return!1};a++;t:for(;;){e="";var h=C("3",--a+"px",i).height,u=t.multiline?s-a:(s-h)/2,f=-2,d=u+=2,p=0,g=0,m=0;if(a<=0){a=12,e="(...) Tj\n",e+="% Width of Text: "+C(e,"1px").width+", FieldWidth:"+c+"\n";break}m=C(o[0]+" ",a+"px",i).width;var y="",w=0;for(var v in o){y=" "==(y+=o[v]+" ").substr(y.length-1)?y.substr(0,y.length-1):y;var b=parseInt(v);m=C(y+" ",a+"px",i).width;var x=l(b,y,a),S=v>=o.length-1;if(!x||S){if(x||S){if(S)g=b;else if(t.multiline&&s<(h+2)*(w+2)+2)continue t}else{if(!t.multiline)continue t;if(s<(h+2)*(w+2)+2)continue t;g=b}for(var k="",_=p;_<=g;_++)k+=o[_]+" ";switch(k=" "==k.substr(k.length-1)?k.substr(0,k.length-1):k,m=C(k,a+"px",i).width,t.Q){case 2:f=c-m-2;break;case 1:f=(c-m)/2;break;case 0:default:f=2}e+=f.toFixed(2)+" "+d.toFixed(2)+" Td\n",e+="("+k+") Tj\n",e+=-f.toFixed(2)+" 0 Td\n",d=-(a+2),m=0,p=g+1,w++,y=""}else y+=" "}break}return r.text=e,r.fontSize=a,r},C=function(t,e,n){n=n||"helvetica";var r=h.internal.getFont(n),i=o(t,{font:r,fontSize:parseFloat(e),charSpace:0});return{height:1.5*o("3",{font:r,fontSize:parseFloat(e),charSpace:0}),width:i}},g={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},m=function(){for(var t in h.internal.acroformPlugin.acroFormDictionaryRoot.Fields){var e=h.internal.acroformPlugin.acroFormDictionaryRoot.Fields[t];e.hasAnnotation&&w.call(h,e)}},y=function(t){h.internal.acroformPlugin.printedOut&&(h.internal.acroformPlugin.printedOut=!1,h.internal.acroformPlugin.acroFormDictionaryRoot=null),h.internal.acroformPlugin.acroFormDictionaryRoot||k.call(h),h.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)},w=function(t){var e={type:"reference",object:t};h.annotationPlugin.annotations[h.internal.getPageInfo(t.page).pageNumber].push(e)},v=function(){void 0!==h.internal.acroformPlugin.acroFormDictionaryRoot?h.internal.write("/AcroForm "+h.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R"):console.log("Root missing...")},b=function(){h.internal.events.unsubscribe(h.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete h.internal.acroformPlugin.acroFormDictionaryRoot._eventID,h.internal.acroformPlugin.printedOut=!0},x=function(t){var e=!t;t||(h.internal.newObjectDeferredBegin(h.internal.acroformPlugin.acroFormDictionaryRoot.objId),h.internal.out(h.internal.acroformPlugin.acroFormDictionaryRoot.getString()));t=t||h.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t){var r=t[n],i=r.Rect;r.Rect&&(r.Rect=f.call(this,r.Rect)),h.internal.newObjectDeferredBegin(r.objId);var o=r.objId+" 0 obj\n<<\n";if("object"===(void 0===r?"undefined":vt(r))&&"function"==typeof r.getContent&&(o+=r.getContent()),r.Rect=i,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=d.call(this,r);o+="/AP << /N "+a+" >>\n",h.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){for(var s in o+="/AP << ",r.appearanceStreamContent){var c=r.appearanceStreamContent[s];if(o+="/"+s+" ",o+="<< ",1<=Object.keys(c).length||Array.isArray(c))for(var n in c){var l;"function"==typeof(l=c[n])&&(l=l.call(this,r)),o+="/"+n+" "+l+" ",0<=h.internal.acroformPlugin.xForms.indexOf(l)||h.internal.acroformPlugin.xForms.push(l)}else"function"==typeof(l=c)&&(l=l.call(this,r)),o+="/"+n+" "+l+" \n",0<=h.internal.acroformPlugin.xForms.indexOf(l)||h.internal.acroformPlugin.xForms.push(l);o+=" >>\n"}o+=">>\n"}o+=">>\nendobj\n",h.internal.out(o)}e&&S.call(this,h.internal.acroformPlugin.xForms)},S=function(t){for(var e in t){var n=e,r=t[e];h.internal.newObjectDeferredBegin(r&&r.objId);var i="";"object"===(void 0===r?"undefined":vt(r))&&"function"==typeof r.getString&&(i=r.getString()),h.internal.out(i),delete t[n]}},k=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(h=this,q.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(g)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");e=h.internal.scaleFactor,a=h.internal.pageSize.getHeight(),h.internal.acroformPlugin.acroFormDictionaryRoot=new F,h.internal.acroformPlugin.acroFormDictionaryRoot._eventID=h.internal.events.subscribe("postPutResources",b),h.internal.events.subscribe("buildDocument",m),h.internal.events.subscribe("putCatalog",v),h.internal.events.subscribe("postPutPages",x),h.internal.acroformPlugin.isInitialized=!0}},_=function(t){if(Array.isArray(t)){var e=" [";for(var n in t){e+=t[n].toString(),e+=n<t.length-1?" ":""}return e+="]"}},I=function(t){return 0!==(t=t||"").indexOf("(")&&(t="("+t),")"!=t.substring(t.length-1)&&(t+=")"),t},A=function(){var t;Object.defineProperty(this,"objId",{get:function(){return t||(t=h.internal.newObjectDeferred()),t||console.log("Couldn't create Object ID"),t},configurable:!1})};A.prototype.toString=function(){return this.objId+" 0 R"},A.prototype.getString=function(){var t=this.objId+" 0 obj\n<<";return t+=this.getContent()+">>\n",this.stream&&(t+="stream\n",t+=this.stream,t+="\nendstream\n"),t+="endobj\n"},A.prototype.getContent=function(){var t="";return t+=function(t){var e="",n=Object.keys(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n){var i=n[r],o=t[i];o&&(Array.isArray(o)?e+="/"+i+" "+_(o)+"\n":e+=o instanceof A?"/"+i+" "+o.objId+" 0 R\n":"/"+i+" "+o+"\n")}return e}(this)};var T=function(){var e;A.call(this),this.Type="/XObject",this.Subtype="/Form",this.FormType=1,this.BBox,this.Matrix,this.Resources="2 0 R",this.PieceInfo,Object.defineProperty(this,"Length",{enumerable:!0,get:function(){return void 0!==e?e.length:0}}),Object.defineProperty(this,"stream",{enumerable:!1,set:function(t){e=t.trim()},get:function(){return e||null}})};r(T,A);var F=function(){A.call(this);var t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!0,configurable:!0,get:function(){return t}}),this.DA};r(F,A);var q=function t(){var e;A.call(this),Object.defineProperty(this,"Rect",{enumerable:!0,configurable:!1,get:function(){if(e)return e},set:function(t){e=t}});var n,r,i,o,a="";Object.defineProperty(this,"FT",{enumerable:!0,set:function(t){a=t},get:function(){return a}}),Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,set:function(t){n=t},get:function(){if(!n||n.length<1){if(this instanceof M)return;return"(FieldObject"+t.FieldNum+++")"}return"("==n.substring(0,1)&&n.substring(n.length-1)?n:"("+n+")"}}),Object.defineProperty(this,"DA",{enumerable:!0,get:function(){if(r)return"("+r+")"},set:function(t){r=t}}),Object.defineProperty(this,"DV",{enumerable:!0,configurable:!0,get:function(){if(i)return i},set:function(t){i=t}}),Object.defineProperty(this,"V",{enumerable:!0,configurable:!0,get:function(){if(o)return o},set:function(t){o=t}}),Object.defineProperty(this,"Type",{enumerable:!0,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,get:function(){return this.hasAnnotation?"/Widget":null}}),this.BG,Object.defineProperty(this,"hasAnnotation",{enumerable:!1,get:function(){return!!(this.Rect||this.BC||this.BG)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,configurable:!0,writable:!0}),Object.defineProperty(this,"page",{enumerable:!1,configurable:!0,writable:!0})};r(q,A);var E=function(){q.call(this),this.FT="/Ch",this.Opt=[],this.V="()",this.TI=0;var e=!1;Object.defineProperty(this,"combo",{enumerable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"edit",{enumerable:!0,set:function(t){1==t?(this._edit=!0,this.combo=!0):this._edit=!1},get:function(){return!!this._edit&&this._edit},configurable:!1}),this.hasAppearanceStream=!0};r(E,q);var P=function(){E.call(this),this.combo=!1};r(P,E);var O=function(){P.call(this),this.combo=!0};r(O,P);var B=function(){O.call(this),this.edit=!0};r(B,O);var j=function(){q.call(this),this.FT="/Btn"};r(j,q);var R=function(){j.call(this);var e=!0;Object.defineProperty(this,"pushbutton",{enumerable:!1,get:function(){return e},set:function(t){e=t}})};r(R,j);var D=function(){j.call(this);var e=!0;Object.defineProperty(this,"radio",{enumerable:!1,get:function(){return e},set:function(t){e=t}});var n,t=[];Object.defineProperty(this,"Kids",{enumerable:!0,get:function(){if(0<t.length)return t}}),Object.defineProperty(this,"__Kids",{get:function(){return t}}),Object.defineProperty(this,"noToggleToOff",{enumerable:!1,get:function(){return n},set:function(t){n=t}})};r(D,j);var M=function(t,e){q.call(this),this.Parent=t,this._AppearanceType=U.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(e),this.F=l(this.F,3,1),this.MK=this._AppearanceType.createMK(),this.AS="/Off",this._Name=e};r(M,q),D.prototype.setAppearance=function(t){if("createAppearanceStream"in t&&"createMK"in t)for(var e in this.__Kids){var n=this.__Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n._Name),n.MK=t.createMK()}else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!")},D.prototype.createOption=function(t){this.__Kids.length;var e=new M(this,t);return this.__Kids.push(e),n.addField(e),e};var z=function(){j.call(this),this.appearanceStreamContent=U.CheckBox.createAppearanceStream(),this.MK=U.CheckBox.createMK(),this.AS="/On",this.V="/On"};r(z,j);var N=function(){var e,n;q.call(this),this.DA=U.createDefaultAppearanceStream(),this.F=4,Object.defineProperty(this,"V",{get:function(){return e?I(e):e},enumerable:!0,set:function(t){e=t}}),Object.defineProperty(this,"DV",{get:function(){return n?I(n):n},enumerable:!0,set:function(t){n=t}});var r=!1;Object.defineProperty(this,"multiline",{enumerable:!1,get:function(){return r},set:function(t){r=t}});var i=!1;Object.defineProperty(this,"fileSelect",{enumerable:!1,get:function(){return i},set:function(t){i=t}});var o=!1;Object.defineProperty(this,"doNotSpellCheck",{enumerable:!1,get:function(){return o},set:function(t){o=t}});var a=!1;Object.defineProperty(this,"doNotScroll",{enumerable:!1,get:function(){return a},set:function(t){a=t}});var s=!1;Object.defineProperty(this,"MaxLen",{enumerable:!0,get:function(){return s},set:function(t){s=t}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,get:function(){return this.V||this.DV}})};r(N,q);var L=function(){N.call(this);var e=!0;Object.defineProperty(this,"password",{enumerable:!1,get:function(){return e},set:function(t){e=t}})};r(L,N);var U={CheckBox:{createAppearanceStream:function(){return{N:{On:U.CheckBox.YesNormal},D:{On:U.CheckBox.YesPushDown,Off:U.CheckBox.OffPushDown}}},createMK:function(){return"<< /CA (3)>>"},YesPushDown:function(t){var e=c(t),n=[],r=h.internal.getFont("zapfdingbats","normal").id;t.Q=1;var i=p(t,"3","ZapfDingbats",50);return n.push("0.749023 g"),n.push("0 0 "+U.internal.getWidth(t).toFixed(2)+" "+U.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+i.fontSize.toFixed(2)+" Tf 0 g"),n.push("BT"),n.push(i.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=c(t),n=h.internal.getFont("zapfdingbats","normal").id,r=[];t.Q=1;var i=U.internal.getHeight(t),o=U.internal.getWidth(t),a=p(t,"3","ZapfDingbats",.9*i);return r.push("1 g"),r.push("0 0 "+o.toFixed(2)+" "+i.toFixed(2)+" re"),r.push("f"),r.push("q"),r.push("0 0 1 rg"),r.push("0 0 "+(o-1).toFixed(2)+" "+(i-1).toFixed(2)+" re"),r.push("W"),r.push("n"),r.push("0 g"),r.push("BT"),r.push("/"+n+" "+a.fontSize.toFixed(2)+" Tf 0 g"),r.push(a.text),r.push("ET"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=c(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+U.internal.getWidth(t).toFixed(2)+" "+U.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:U.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=U.RadioButton.Circle.YesNormal,e.D[t]=U.RadioButton.Circle.YesPushDown,e},createMK:function(){return"<< /CA (l)>>"},YesNormal:function(t){var e=c(t),n=[],r=U.internal.getWidth(t)<=U.internal.getHeight(t)?U.internal.getWidth(t)/4:U.internal.getHeight(t)/4;r*=.9;var i=U.internal.Bezier_C;return n.push("q"),n.push("1 0 0 1 "+U.internal.getWidth(t)/2+" "+U.internal.getHeight(t)/2+" cm"),n.push(r+" 0 m"),n.push(r+" "+r*i+" "+r*i+" "+r+" 0 "+r+" c"),n.push("-"+r*i+" "+r+" -"+r+" "+r*i+" -"+r+" 0 c"),n.push("-"+r+" -"+r*i+" -"+r*i+" -"+r+" 0 -"+r+" c"),n.push(r*i+" -"+r+" "+r+" -"+r*i+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=c(t),n=[],r=U.internal.getWidth(t)<=U.internal.getHeight(t)?U.internal.getWidth(t)/4:U.internal.getHeight(t)/4,i=2*(r*=.9),o=i*U.internal.Bezier_C,a=r*U.internal.Bezier_C;return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+(U.internal.getWidth(t)/2).toFixed(2)+" "+(U.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+(U.internal.getWidth(t)/2).toFixed(2)+" "+(U.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=c(t),n=[],r=U.internal.getWidth(t)<=U.internal.getHeight(t)?U.internal.getWidth(t)/4:U.internal.getHeight(t)/4,i=2*(r*=.9),o=i*U.internal.Bezier_C;return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+(U.internal.getWidth(t)/2).toFixed(2)+" "+(U.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:U.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=U.RadioButton.Cross.YesNormal,e.D[t]=U.RadioButton.Cross.YesPushDown,e},createMK:function(){return"<< /CA (8)>>"},YesNormal:function(t){var e=c(t),n=[],r=U.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+(U.internal.getWidth(t)-2).toFixed(2)+" "+(U.internal.getHeight(t)-2).toFixed(2)+" re"),n.push("W"),n.push("n"),n.push(r.x1.x.toFixed(2)+" "+r.x1.y.toFixed(2)+" m"),n.push(r.x2.x.toFixed(2)+" "+r.x2.y.toFixed(2)+" l"),n.push(r.x4.x.toFixed(2)+" "+r.x4.y.toFixed(2)+" m"),n.push(r.x3.x.toFixed(2)+" "+r.x3.y.toFixed(2)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=c(t),n=U.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+U.internal.getWidth(t).toFixed(2)+" "+U.internal.getHeight(t).toFixed(2)+" re"),r.push("f"),r.push("q"),r.push("1 1 "+(U.internal.getWidth(t)-2).toFixed(2)+" "+(U.internal.getHeight(t)-2).toFixed(2)+" re"),r.push("W"),r.push("n"),r.push(n.x1.x.toFixed(2)+" "+n.x1.y.toFixed(2)+" m"),r.push(n.x2.x.toFixed(2)+" "+n.x2.y.toFixed(2)+" l"),r.push(n.x4.x.toFixed(2)+" "+n.x4.y.toFixed(2)+" m"),r.push(n.x3.x.toFixed(2)+" "+n.x3.y.toFixed(2)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=c(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+U.internal.getWidth(t).toFixed(2)+" "+U.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){return"/F1 0 Tf 0 g"}};U.internal={Bezier_C:.551915024494,calculateCross:function(t){var e,n,r=U.internal.getWidth(t),i=U.internal.getHeight(t),o=(n=i)<(e=r)?n:e;return{x1:{x:(r-o)/2,y:(i-o)/2+o},x2:{x:(r-o)/2+o,y:(i-o)/2},x3:{x:(r-o)/2,y:(i-o)/2},x4:{x:(r-o)/2+o,y:(i-o)/2+o}}}},U.internal.getWidth=function(t){var e=0;return"object"===(void 0===t?"undefined":vt(t))&&(e=s(t.Rect[2])),e},U.internal.getHeight=function(t){var e=0;return"object"===(void 0===t?"undefined":vt(t))&&(e=s(t.Rect[3])),e},n.addField=function(t){return k.call(this),t instanceof N?this.addTextField.call(this,t):t instanceof E?this.addChoiceField.call(this,t):t instanceof j?this.addButton.call(this,t):t instanceof M?y.call(this,t):t&&y.call(this,t),t.page=h.internal.getCurrentPageInfo().pageNumber,this},n.addButton=function(t){k.call(this);var e=t||new q;e.FT="/Btn",e.Ff=u(e.Ff,t,h.internal.getPDFVersion()),y.call(this,e)},n.addTextField=function(t){k.call(this);var e=t||new q;e.FT="/Tx",e.Ff=u(e.Ff,t,h.internal.getPDFVersion()),y.call(this,e)},n.addChoiceField=function(t){k.call(this);var e=t||new q;e.FT="/Ch",e.Ff=u(e.Ff,t,h.internal.getPDFVersion()),y.call(this,e)},"object"==(void 0===t?"undefined":vt(t))&&(t.ChoiceField=E,t.ListBox=P,t.ComboBox=O,t.EditBox=B,t.Button=j,t.PushButton=R,t.RadioButton=D,t.CheckBox=z,t.TextField=N,t.PasswordField=L,t.AcroForm={Appearance:U})}(K.API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),K.API.addHTML=function(t,p,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof p&&(s=p,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,y=e.scaleFactor,w=e.pageSize.getWidth(),v=e.pageSize.getHeight();if((s=s||{}).onrendered=function(c){p=parseInt(p)||0,g=parseInt(g)||0;var t=s.dim||{},l=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(v,c.height/y),h=t.w||Math.min(w,c.width/y)-p,u=s.format||"JPEG",f=s.imageCompression||"SLOW";if(c.height>v-l.top-l.bottom&&s.pagesplit){var d=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?l.top:g,i.left=0!==n?l.left:p,o=(w-l.left-l.right)*y<c.width,"content"===l.useFor?0===n?(t=Math.min((w-l.left)*y,c.width),e=Math.min((v-l.top)*y,c.height-n)):(t=Math.min(w*y,c.width),e=Math.min(v*y,c.height-n),i.top=0):(t=Math.min((w-l.left-l.right)*y,c.width),e=Math.min((v-l.bottom-l.top)*y,c.height-n)),o)for(;;){"content"===l.useFor&&(0===r?t=Math.min((w-l.left)*y,c.width):(t=Math.min(w*y,c.width-r),i.left=0));var s=[a=d(c,r,n,t,e),i.left,i.top,a.width/y,a.height/y,u,null,f];if(this.addImage.apply(this,s),(r+=t)>=c.width)break;this.addPage()}else s=[a=d(c,0,n,t,e),i.left,i.top,a.width/y,a.height/y,u,null,f],this.addImage.apply(this,s);if((n+=e)>=c.height)break;this.addPage()}m(h,n,null,s)}.bind(this);if("CANVAS"===c.nodeName){var r=new Image;r.onload=n,r.src=c.toDataURL("image/png"),c=r}else n()}else{var i=Math.random().toString(35),o=[c,p,g,h,e,u,i,f];this.addImage.apply(this,o),m(h,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"!=typeof rasterizeHTML){var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||w*y,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})}return null},
	/** @preserve
	   * jsPDF addImage plugin
	   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
	   *               2013 Chris Dowling, https://github.com/gingerchris
	   *               2013 Trinh Ho, https://github.com/ineedfat
	   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
	   *               2013 Norah Smith, https://github.com/burnburnrocket
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *               2014 James Robb, https://github.com/jamesbrobb
	   *
	   * 
	   */
	function(b){var x="addImage_",s={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]};b.getImageFileTypeByImageData=function(t){var e,n,r,i,o,a="UNKNOWN";for(o in s)for(r=s[o],e=0;e<r.length;e+=1){for(i=!0,n=0;n<r[e].length;n+=1)if(void 0!==r[e][n]&&r[e][n]!==t.charCodeAt(n)){i=!1;break}if(!0===i){a=o;break}}return a};var n=function t(e){var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream;if(e.n=n,r("<</Type /XObject"),r("/Subtype /Image"),r("/Width "+e.w),r("/Height "+e.h),e.cs===this.color_spaces.INDEXED?r("/ColorSpace [/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"):(r("/ColorSpace /"+e.cs),e.cs===this.color_spaces.DEVICE_CMYK&&r("/Decode [1 0 1 0 1 0 1 0]")),r("/BitsPerComponent "+e.bpc),"f"in e&&r("/Filter /"+e.f),"dp"in e&&r("/DecodeParms <<"+e.dp+">>"),"trns"in e&&e.trns.constructor==Array){for(var o="",a=0,s=e.trns.length;a<s;a++)o+=e.trns[a]+" "+e.trns[a]+" ";r("/Mask ["+o+"]")}if("smask"in e&&r("/SMask "+(n+1)+" 0 R"),r("/Length "+e.data.length+">>"),i(e.data),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,l={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(l.f=e.f),t.call(this,l)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),r("<< /Length "+e.pal.length+">>"),i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))),r("endobj"))},S=function(){var t=this.internal.collections[x+"images"];for(var e in t)n.call(this,t[e])},k=function(){var t,e=this.internal.collections[x+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},_=function(t){return"function"==typeof b["process"+t.toUpperCase()]},C=function(t){return"object"===(void 0===t?"undefined":vt(t))&&1===t.nodeType},I=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return n;!e&&/\.png(?:[?#].*)?$/i.test(n)&&(e="png")}if("CANVAS"===t.nodeName)var r=t;else{(r=document.createElement("canvas")).width=t.clientWidth||t.width,r.height=t.clientHeight||t.height;var i=r.getContext("2d");if(!i)throw"addImage requires canvas to be supported by browser.";i.drawImage(t,0,0,r.width,r.height)}return r.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},A=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};b.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},b.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},b.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},b.sHashCode=function(t){return t=t||"",Array.prototype.reduce&&t.split("").reduce(function(t,e){return(t=(t<<5)-t+e.charCodeAt(0))&t},0)},b.isString=function(t){return"string"==typeof t},b.validateStringAsBase64=function(t){return t=t||"",new RegExp("(?:^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$)").test(t)},b.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));base64,(.+?)$/g.exec(t)},b.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},b.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},b.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},b.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},b.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t));if("function"==typeof TextDecoder){var e=new TextDecoder("ascii");if("ascii"===e.encoding)return e.decode(t)}for(var n=this.isArrayBuffer(t)?t:new Uint8Array(t),r=20480,i="",o=Math.ceil(n.byteLength/r),a=0;a<o;a++)i+=String.fromCharCode.apply(null,n.slice(a*r,a*r+r));return i},b.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,c=0;c<s;c+=3)n+=r[(16515072&(e=i[c]<<16|i[c+1]<<8|i[c+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},b.createImageInfo=function(t,e,n,r,i,o,a,s,c,l,h,u,f){var d={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(d.f=o),c&&(d.dp=c),l&&(d.trns=l),h&&(d.pal=h),u&&(d.smask=u),f&&(d.p=f),d},b.addImage=function(t,e,n,r,i,o,a,s,c){var l="";if("string"!=typeof e){var h=o;o=i,i=r,r=n,n=e,e=h}if("object"===(void 0===t?"undefined":vt(t))&&!C(t)&&"imageData"in t){var u=t;t=u.imageData,e=u.format||e,n=u.x||n||0,r=u.y||r||0,i=u.w||i,o=u.h||o,a=u.alias||a,s=u.compression||s,c=u.rotation||u.angle||c}if(isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var f,d,p,g,m,y,w,v=function(){var t=this.internal.collections[x+"images"];return t||(this.internal.collections[x+"images"]=t={},this.internal.events.subscribe("putResources",S),this.internal.events.subscribe("putXobjectDict",k)),t}.call(this);if(!(f=A(t,v))&&(C(t)&&(t=I(t,e)),(null==(w=a)||0===w.length)&&(a="string"==typeof(y=t)&&b.sHashCode(y)),!(f=A(a,v)))){if(this.isString(t)&&(""!==(l=this.convertStringToImageData(t))?t=l:void 0!==(l=this.loadImageFile(t))&&(t=l)),e=this.getImageFileTypeByImageData(t),!_(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(f=this["process"+e.toUpperCase()](t,(m=0,(g=v)&&(m=Object.keys?Object.keys(g).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(g)),m),a,((p=s)&&"string"==typeof p&&(p=p.toUpperCase()),p in b.image_compression?p:b.image_compression.NONE),d)))throw new Error("An unkwown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var c=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),l=this.internal.getCoordinateString,h=this.internal.getVerticalCoordinateString;if(n=c[0],r=c[1],a[o]=i,s){s*=Math.PI/180;var u=Math.cos(s),f=Math.sin(s),d=function(t){return t.toFixed(4)},p=[d(u),d(f),d(-1*f),d(u),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,l(t),h(e+r),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([l(n),"0","0",l(r),"0","0","cm"].join(" "))):this.internal.write([l(n),"0","0",l(r),l(t),h(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,f,f.i,v,c),this},b.convertStringToImageData=function(t){var e,n="";this.isString(t)&&(null!==(e=this.extractInfoFromBase64DataURI(t))?b.validateStringAsBase64(e[3])&&(n=atob(e[3])):b.validateStringAsBase64(t)&&(n=atob(t)));return n};var c=function(t,e){return t.subarray(e,e+5)};b.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if(255===!t.charCodeAt(0)||216===!t.charCodeAt(1)||255===!t.charCodeAt(2)||224===!t.charCodeAt(3)||!t.charCodeAt(6)==="J".charCodeAt(0)||!t.charCodeAt(7)==="F".charCodeAt(0)||!t.charCodeAt(8)==="I".charCodeAt(0)||!t.charCodeAt(9)==="F".charCodeAt(0)||0===!t.charCodeAt(10))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=c(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=c(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},b.processJPG=function(){return this.processJPEG.apply(this,arguments)},b.loadImageFile=function(t,e,n){e=e||!0,n=n||function(){};var r="[object process]"===Object.prototype.toString.call("undefined"!=typeof process?process:0);return void 0!==("undefined"==typeof window?"undefined":vt(window))&&"object"===("undefined"==typeof location?"undefined":vt(location))&&"http"===location.protocol.substr(0,4)?function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e):r?function(t,e,n){e=e||!0;var r=__webpack_require__(2695);if(!0===e)return r.readFileSync(t).toString();r.readFile("image.jpg",function(t,e){n(e)})}(t,e,n):void 0},b.getImageProperties=function(t){var e,n,r="";if(C(t)&&(t=I(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=this.loadImageFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!_(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unkwown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}(K.API),
	/**
	   * jsPDF Annotations PlugIn
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	t=K.API,w={annotations:[],f2:function(t){return t.toFixed(2)},notEmpty:function(t){if(void 0!==t&&""!=t)return!0}},K.API.annotationPlugin=w,K.API.events.push(["addPage",function(t){this.annotationPlugin.annotations[t.pageNumber]=[]}]),t.events.push(["putPage",function(t){for(var e=this.annotationPlugin.annotations[t.pageNumber],n=!1,r=0;r<e.length&&!n;r++)switch((c=e[r]).type){case"link":if(w.notEmpty(c.options.url)||w.notEmpty(c.options.pageNumber)){n=!0;break}case"reference":case"text":case"freetext":n=!0}if(0!=n){this.internal.write("/Annots [");var i=this.annotationPlugin.f2,o=this.internal.scaleFactor,a=this.internal.pageSize.getHeight(),s=this.internal.getPageInfo(t.pageNumber);for(r=0;r<e.length;r++){var c;switch((c=e[r]).type){case"reference":this.internal.write(" "+c.object.objId+" 0 R ");break;case"text":var l=this.internal.newAdditionalObject(),h=this.internal.newAdditionalObject(),u=c.title||"Note";m="<</Type /Annot /Subtype /Text "+(d="/Rect ["+i(c.bounds.x*o)+" "+i(a-(c.bounds.y+c.bounds.h)*o)+" "+i((c.bounds.x+c.bounds.w)*o)+" "+i((a-c.bounds.y)*o)+"] ")+"/Contents ("+c.contents+")",m+=" /Popup "+h.objId+" 0 R",m+=" /P "+s.objId+" 0 R",m+=" /T ("+u+") >>",l.content=m;var f=l.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(d="/Rect ["+i((c.bounds.x+30)*o)+" "+i(a-(c.bounds.y+c.bounds.h)*o)+" "+i((c.bounds.x+c.bounds.w+30)*o)+" "+i((a-c.bounds.y)*o)+"] ")+" /Parent "+f,c.open&&(m+=" /Open true"),m+=" >>",h.content=m,this.internal.write(l.objId,"0 R",h.objId,"0 R");break;case"freetext":var d="/Rect ["+i(c.bounds.x*o)+" "+i((a-c.bounds.y)*o)+" "+i(c.bounds.x+c.bounds.w*o)+" "+i(a-(c.bounds.y+c.bounds.h)*o)+"] ",p=c.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+d+"/Contents ("+c.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+p+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(c.options.name){var g=this.annotations._nameMap[c.options.name];c.options.pageNumber=g.page,c.options.top=g.y}else c.options.top||(c.options.top=0);d="/Rect ["+i(c.x*o)+" "+i((a-c.y)*o)+" "+i((c.x+c.w)*o)+" "+i((a-(c.y+c.h))*o)+"] ";var m="";if(c.options.url)m="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /A <</S /URI /URI ("+c.options.url+") >>";else if(c.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /Dest ["+(t=this.internal.getPageInfo(c.options.pageNumber)).objId+" 0 R",c.options.magFactor=c.options.magFactor||"XYZ",c.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+c.options.top+"]";break;case"FitV":c.options.left=c.options.left||0,m+=" /FitV "+c.options.left+"]";break;case"XYZ":default:var y=i((a-c.options.top)*o);c.options.left=c.options.left||0,void 0===c.options.zoom&&(c.options.zoom=0),m+=" /XYZ "+c.options.left+" "+y+" "+c.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t)}},t.link=function(t,e,n,r,i){this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},t.getLineHeight=function(){return this.internal.getLineHeight()},function(t){var a=Object.keys({ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",fa:"Persian","fa-IR":"Persian/Iran",ur:"Urdu"}),l={1569:[65152],1570:[65153,65154,65153,65154],1571:[65155,65156,65155,65156],1572:[65157,65158],1573:[65159,65160,65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166,65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194,65193,65194],1584:[65195,65196,65195,65196],1585:[65197,65198,65197,65198],1586:[65199,65200,65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262,65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395,64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},h={1570:[65269,65270,65269,65270],1571:[65271,65272,65271,65272],1573:[65273,65274,65273,65274],1575:[65275,65276,65275,65276]},u={1570:[65153,65154,65153,65154],1571:[65155,65156,65155,65156],1573:[65159,65160,65159,65160],1575:[65165,65166,65165,65166]},f={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},e=[1570,1571,1573,1575],n=[1569,1570,1571,1572,1573,1575,1577,1583,1584,1585,1586,1608,1688],o=0,s=1,c=2,d=3;function p(t){return void 0!==t&&void 0!==l[t.charCodeAt(0)]}function g(t){return void 0!==t&&0<=n.indexOf(t.charCodeAt(0))}function m(t){return void 0!==t&&0<=e.indexOf(t.charCodeAt(0))}function y(t){return p(t)&&2<=l[t.charCodeAt(0)].length}function w(t,e,n,r){return p(t)?(r=r||{},l=Object.assign(l,r),!y(t)||!p(e)&&!p(n)||!p(n)&&g(e)||g(t)&&!p(e)||g(t)&&m(e)?(l=Object.assign(l,u),o):p(i=t)&&4==l[i.charCodeAt(0)].length&&p(e)&&!g(e)&&p(n)&&y(n)?(l=Object.assign(l,u),d):g(t)||!p(n)?(l=Object.assign(l,u),s):(l=Object.assign(l,u),c)):-1;var i}function v(t){t=t||"";var e,n,r="",i=0,o=0,a="",s="",c="";for(i=0;i<t.length;i+=1)a=t[i],s=t[i-1],c=t[i+1],p(a)?void 0!==s&&1604===s.charCodeAt(0)&&m(a)?(o=w(a,t[i-2],t[i+1],h),e=String.fromCharCode(h[a.charCodeAt(0)][o]),r=r.substr(0,r.length-1)+e):void 0!==s&&1617===s.charCodeAt(0)&&(void 0!==(n=a)&&void 0!==f[n.charCodeAt(0)])?(o=w(a,t[i-2],t[i+1],u),e=String.fromCharCode(f[a.charCodeAt(0)][o]),r=r.substr(0,r.length-1)+e):(o=w(a,s,c,u),r+=String.fromCharCode(l[a.charCodeAt(0)][o])):r+=a;return r.split("").reverse().join("")}t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang),i=[];if(0<=a.indexOf(r)){if("[object Array]"===Object.prototype.toString.call(e)){var o=0;for(i=[],o=0;o<e.length;o+=1)"[object Array]"===Object.prototype.toString.call(e[o])?i.push([v(e[o][0]),e[o][1],e[o][2]]):i.push([v(e[o])]);t.text=i}else t.text=v(e);void 0===n.charSpace&&(t.options.charSpace=0),!0===n.R2L&&(t.options.R2L=!1)}}])}(K.API),K.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},(
	/**
	   * jsPDF Canvas PlugIn
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	e=K.API).events.push(["initialized",function(){this.canvas.pdf=this}]),e.canvas={getContext:function(t){return(this.pdf.context2d._canvas=this).pdf.context2d},style:{}},Object.defineProperty(e.canvas,"width",{get:function(){return this._width},set:function(t){this._width=t,this.getContext("2d").pageWrapX=t+1}}),Object.defineProperty(e.canvas,"height",{get:function(){return this._height},set:function(t){this._height=t,this.getContext("2d").pageWrapY=t+1}}),
	/** ====================================================================
	   * jsPDF Cell plugin
	   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	   *               2013 Lee Driscoll, https://github.com/lsdriscoll
	   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	   *               2014 James Hall, james@parall.ax
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *
	   * 
	   * ====================================================================
	   */
	I=K.API,A={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1,d=function(t,e,n,r,i){A={x:t,y:e,w:n,h:r,ln:i}},p=function(){return A},F={left:0,top:0,bottom:0},I.setHeaderFunction=function(t){c=t},I.getTextDimensions=function(e){i=this.internal.getFont().fontName,o=this.table_font_size||this.internal.getFontSize(),a=this.internal.getFont().fontStyle;var t,n,r=19.049976/25.4;(n=document.createElement("font")).id="jsPDFCell";try{n.style.fontStyle=a}catch(t){n.style.fontWeight=a}n.style.fontSize=o+"pt",n.style.fontFamily=i;try{n.textContent=e}catch(t){n.innerText=e}return document.body.appendChild(n),t={w:(n.offsetWidth+1)*r,h:(n.offsetHeight+1)*r},document.body.removeChild(n),t},I.cellAddPage=function(){var t=this.margins||F;this.addPage(),d(t.left,t.top,void 0,void 0),T+=1},I.cellInitialize=function(){A={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1},I.cell=function(t,e,n,r,i,o,a){var s=p(),c=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var l=this.margins||F;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-l.bottom&&(this.cellAddPage(),c=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=p().y+p().h,c&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var h=0;h<i.length;h++){var u=i[h],f=this.getStringUnitWidth(u)*this.internal.getFontSize();this.text(u,t+n-f-3,e+this.internal.getLineHeight()*(h+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return d(t,e,n,r,o),this},I.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},I.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,c,l,h,u,f,d,p,g=[],m=[],y={},w={},v=[],b=[],x=!1,S=!0,k=12,_=F;if(_.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(S=!1),i.fontSize&&(k=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(k=16*i.css["font-size"]),i.margins&&(_=i.margins)),this.lnMod=0,A={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1,this.printHeaders=S,this.margins=_,this.setFontSize(k),this.table_font_size=k,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),w[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(p=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(y[o=g[a]]=n.map(p),v.push(this.getTextDimensions(m[a]||o).w),u=0,c=(h=y[o]).length;u<c;u+=1)l=h[u],v.push(this.getTextDimensions(l).w);w[o]=I.arrayMax(v),v=[]}if(S){var C=this.calculateLineHeight(g,w,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,w[o],C,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],C=this.calculateLineHeight(g,w,f),u=0,d=g.length;u<d;u+=1)o=g[u],this.cell(t,e,w[o],C,f[o],a+2,o.align);return this.lastCellPos=A,this.table_x=t,this.table_y=e,this},I.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},I.setTableHeaderRow=function(t){this.tableHeaderRow=t},I.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==c){var a=c(this,T);d(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
	/**
	   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
	   *
	   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	   */
	function(t){t.events.push(["initialized",function(){((this.context2d.pdf=this).context2d.internal.pdf=this).context2d.ctx=new e,this.context2d.ctxStack=[],this.context2d.path=[]}]),t.context2d={pageWrapXEnabled:!1,pageWrapYEnabled:!1,pageWrapX:9999999,pageWrapY:9999999,ctx:new e,f2:function(t){return t.toFixed(2)},fillRect:function(t,e,n,r){if(!this._isFillTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"f")}},strokeRect:function(t,e,n,r){if(!this._isStrokeTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"s")}},clearRect:function(t,e,n,r){if(!this.ctx.ignoreClearRect){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.save(),this.setFillStyle("#ffffff"),this.pdf.rect(i.x,i.y,i.w,i.h,"f"),this.restore()}},save:function(){this.ctx._fontSize=this.pdf.internal.getFontSize();var t=new e;t.copy(this.ctx),this.ctxStack.push(this.ctx),this.ctx=t},restore:function(){this.ctx=this.ctxStack.pop(),this.setFillStyle(this.ctx.fillStyle),this.setStrokeStyle(this.ctx.strokeStyle),this.setFont(this.ctx.font),this.pdf.setFontSize(this.ctx._fontSize),this.setLineCap(this.ctx.lineCap),this.setLineWidth(this.ctx.lineWidth),this.setLineJoin(this.ctx.lineJoin)},rect:function(t,e,n,r){this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.closePath()},beginPath:function(){this.path=[]},closePath:function(){this.path.push({type:"close"})},_getRGBA:function(t){var e,n,r,i;if(!t)return{r:0,g:0,b:0,a:0,style:t};if(this.internal.rxTransparent.test(t))i=r=n=e=0;else{var o=this.internal.rxRgb.exec(t);null!=o?(e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=1):null!=(o=this.internal.rxRgba.exec(t))?(e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=parseFloat(o[4])):(i=1,"#"!=t.charAt(0)&&((t=dt.colorNameToHex(t))||(t="#000000")),4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16))}return{r:e,g:n,b:r,a:i,style:t}},setFillStyle:function(t){var e=this._getRGBA(t);this.ctx.fillStyle=t,this.ctx._isFillTransparent=0===e.a,this.ctx._fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})},setStrokeStyle:function(t){var e=this._getRGBA(t);this.ctx.strokeStyle=e.style,this.ctx._isStrokeTransparent=0===e.a,this.ctx._strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))},fillText:function(t,e,n,r){if(!this._isFillTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(0<this.ctx._clip_path.length){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var c=1;try{c=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(c<.01)this.pdf.text(t,e,this._getBaseline(n),null,o);else{var l=this.pdf.internal.getFontSize();this.pdf.setFontSize(l*c),this.pdf.text(t,e,this._getBaseline(n),null,o),this.pdf.setFontSize(l)}0<this.ctx._clip_path.length&&a.push("Q")}},strokeText:function(t,e,n,r){if(!this._isStrokeTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(0<this.ctx._clip_path.length){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var c=1;try{c=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(1===c)this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o);else{var l=this.pdf.internal.getFontSize();this.pdf.setFontSize(l*c),this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o),this.pdf.setFontSize(l)}0<this.ctx._clip_path.length&&a.push("Q")}},setFont:function(t){if(this.ctx.font=t,null!=(c=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/.exec(t))){var e=c[1],n=(c[2],c[3]),r=c[4],i=c[5],o=c[6];r="px"===i?Math.floor(parseFloat(r)):"em"===i?Math.floor(parseFloat(r)*this.pdf.getFontSize()):Math.floor(parseFloat(r)),this.pdf.setFontSize(r),"bold"===n||"700"===n?this.pdf.setFontStyle("bold"):"italic"===e?this.pdf.setFontStyle("italic"):this.pdf.setFontStyle("normal");var a,s=(u=o).toLowerCase().split(/\s*,\s*/);a=-1!=s.indexOf("arial")?"Arial":-1!=s.indexOf("verdana")?"Verdana":-1!=s.indexOf("helvetica")?"Helvetica":-1!=s.indexOf("sans-serif")?"sans-serif":-1!=s.indexOf("fixed")?"Fixed":-1!=s.indexOf("monospace")?"Monospace":-1!=s.indexOf("terminal")?"Terminal":-1!=s.indexOf("courier")?"Courier":-1!=s.indexOf("times")?"Times":-1!=s.indexOf("cursive")?"Cursive":-1!=s.indexOf("fantasy")?"Fantasy":(s.indexOf("serif"),"Serif"),l="bold"===n?"bold":"normal",this.pdf.setFont(a,l)}else{var c=/\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/.exec(t);if(null!=c){var l,h=c[1],u=(c[2],c[3]);(l=c[4])||(l="normal"),h="em"===i?Math.floor(parseFloat(r)*this.pdf.getFontSize()):Math.floor(parseFloat(h)),this.pdf.setFontSize(h),this.pdf.setFont(u,l)}}},setTextBaseline:function(t){this.ctx.textBaseline=t},getTextBaseline:function(){return this.ctx.textBaseline},setTextAlign:function(t){this.ctx.textAlign=t},getTextAlign:function(){return this.ctx.textAlign},setLineWidth:function(t){this.ctx.lineWidth=t,this.pdf.setLineWidth(t)},setLineCap:function(t){this.ctx.lineCap=t,this.pdf.setLineCap(t)},setLineJoin:function(t){this.ctx.lineJoin=t,this.pdf.setLineJoin(t)},moveTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"mt",x:t=n[0],y:e=n[1]};this.path.push(r)},_wrapX:function(t){return this.pageWrapXEnabled?t%this.pageWrapX:t},_wrapY:function(t){return this.pageWrapYEnabled?(this._gotoPage(this._page(t)),(t-this.lastBreak)%this.pageWrapY):t},transform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},setTransform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},_getTransform:function(){return this.ctx._transform},lastBreak:0,pageBreaks:[],_page:function(t){if(this.pageWrapYEnabled){for(var e=this.lastBreak=0,n=0,r=0;r<this.pageBreaks.length;r++)if(t>=this.pageBreaks[r]){e++,0===this.lastBreak&&n++;var i=this.pageBreaks[r]-this.lastBreak;this.lastBreak=this.pageBreaks[r],n+=Math.floor(i/this.pageWrapY)}if(0===this.lastBreak)n+=Math.floor(t/this.pageWrapY)+1;return n+e}return this.pdf.internal.getCurrentPageInfo().pageNumber},_gotoPage:function(t){},lineTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"lt",x:t=n[0],y:e=n[1]};this.path.push(r)},bezierCurveTo:function(t,e,n,r,i,o){var a;t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),i=this._wrapX(i),o=this._wrapY(o),i=(a=this._matrix_map_point(this.ctx._transform,[i,o]))[0],o=a[1];var s={type:"bct",x1:t=(a=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=a[1],x2:n=(a=this._matrix_map_point(this.ctx._transform,[n,r]))[0],y2:r=a[1],x:i,y:o};this.path.push(s)},quadraticCurveTo:function(t,e,n,r){var i;t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),n=(i=this._matrix_map_point(this.ctx._transform,[n,r]))[0],r=i[1];var o={type:"qct",x1:t=(i=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=i[1],x:n,y:r};this.path.push(o)},arc:function(t,e,n,r,i,o){if(t=this._wrapX(t),e=this._wrapY(e),!this._matrix_is_identity(this.ctx._transform)){var a=this._matrix_map_point(this.ctx._transform,[t,e]);t=a[0],e=a[1];var s=this._matrix_map_point(this.ctx._transform,[0,0]),c=this._matrix_map_point(this.ctx._transform,[0,n]);n=Math.sqrt(Math.pow(c[0]-s[0],2)+Math.pow(c[1]-s[1],2))}var l={type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,anticlockwise:o};this.path.push(l)},drawImage:function(t,e,n,r,i,o,a,s,c){void 0!==o&&(e=o,n=a,r=s,i=c),e=this._wrapX(e),n=this._wrapY(n);var l,h=this._matrix_map_rect(this.ctx._transform,{x:e,y:n,w:r,h:i}),u=(this._matrix_map_rect(this.ctx._transform,{x:o,y:a,w:s,h:c}),/data:image\/(\w+).*/i.exec(t));l=null!=u?u[1]:"png",this.pdf.addImage(t,l,h.x,h.y,h.w,h.h)},_matrix_multiply:function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],a=e[4],s=e[5],c=n*t[0]+r*t[2],l=i*t[0]+o*t[2],h=a*t[0]+s*t[2]+t[4];return r=n*t[1]+r*t[3],o=i*t[1]+o*t[3],s=a*t[1]+s*t[3]+t[5],[n=c,r,i=l,o,a=h,s]},_matrix_rotation:function(t){return Math.atan2(t[2],t[0])},_matrix_decompose:function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o=Math.sqrt(e*e+n*n),a=(e/=o)*r+(n/=o)*i;r-=e*a,i-=n*a;var s=Math.sqrt(r*r+i*i);return a/=s,e*(i/=s)<n*(r/=s)&&(e=-e,n=-n,a=-a,o=-o),{scale:[o,0,0,s,0,0],translate:[1,0,0,1,t[4],t[5]],rotate:[e,n,-n,e,0,0],skew:[1,0,a,1,0,0]}},_matrix_map_point:function(t,e){var n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5],c=e[0],l=e[1];return[c*n+l*i+a,c*r+l*o+s]},_matrix_map_point_obj:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]);return{x:n[0],y:n[1]}},_matrix_map_rect:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]),r=this._matrix_map_point(t,[e.x+e.w,e.y+e.h]);return{x:n[0],y:n[1],w:r[0]-n[0],h:r[1]-n[1]}},_matrix_is_identity:function(t){return 1==t[0]&&(0==t[1]&&(0==t[2]&&(1==t[3]&&(0==t[4]&&0==t[5]))))},rotate:function(t){var e=[Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,e)},scale:function(t,e){var n=[t,0,0,e,0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},translate:function(t,e){var n=[1,0,0,1,t,e];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},stroke:function(){if(0<this.ctx._clip_path.length){var t;(t=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var e=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._stroke(!0),this.ctx._clip_path=this.path,this.path=e,this._stroke(!1),t.push("Q")}else this._stroke(!1)},_stroke:function(t){if(t||!this._isStrokeTransparent()){for(var e=[],n=this.path,r=0;r<n.length;r++){var i=n[r];switch(i.type){case"mt":e.push({start:i,deltas:[],abs:[]});break;case"lt":var o=[i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(o),e[e.length-1].abs.push(i);break;case"bct":o=[i.x1-n[r-1].x,i.y1-n[r-1].y,i.x2-n[r-1].x,i.y2-n[r-1].y,i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(o);break;case"qct":var a=n[r-1].x+2/3*(i.x1-n[r-1].x),s=n[r-1].y+2/3*(i.y1-n[r-1].y),c=i.x+2/3*(i.x1-i.x),l=i.y+2/3*(i.y1-i.y),h=i.x,u=i.y;o=[a-n[r-1].x,s-n[r-1].y,c-n[r-1].x,l-n[r-1].y,h-n[r-1].x,u-n[r-1].y];e[e.length-1].deltas.push(o);break;case"arc":0==e.length&&e.push({start:{x:0,y:0},deltas:[],abs:[]}),e[e.length-1].arc=!0,e[e.length-1].abs.push(i)}}for(r=0;r<e.length;r++){var f;if(f=r==e.length-1?"s":null,e[r].arc)for(var d=e[r].abs,p=0;p<d.length;p++){var g=d[p],m=360*g.startAngle/(2*Math.PI),y=360*g.endAngle/(2*Math.PI),w=g.x,v=g.y;this.internal.arc2(this,w,v,g.radius,m,y,g.anticlockwise,f,t)}else{w=e[r].start.x,v=e[r].start.y;t?(this.pdf.lines(e[r].deltas,w,v,null,null),this.pdf.clip_fixed()):this.pdf.lines(e[r].deltas,w,v,null,f)}}}},_isFillTransparent:function(){return this.ctx._isFillTransparent||0==this.globalAlpha},_isStrokeTransparent:function(){return this.ctx._isStrokeTransparent||0==this.globalAlpha},fill:function(t){if(0<this.ctx._clip_path.length){var e;(e=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var n=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(t,!0),this.ctx._clip_path=this.path,this.path=n,this._fill(t,!1),e.push("Q")}else this._fill(t,!1)},_fill:function(t,e){if(!this._isFillTransparent()){var n,r="function"==typeof this.pdf.internal.newObject2;n=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage();var i=[],o=window.outIntercept;if(r)switch(this.ctx.globalCompositeOperation){case"normal":case"source-over":break;case"destination-in":case"destination-out":var a=this.pdf.internal.newStreamObject(),s=this.pdf.internal.newObject2();s.push("<</Type /ExtGState"),s.push("/SMask <</S /Alpha /G "+a.objId+" 0 R>>"),s.push(">>");var c="MASK"+s.objId;this.pdf.internal.addGraphicsState(c,s.objId);var l="/"+c+" gs";n.splice(0,0,"q"),n.splice(1,0,l),n.push("Q"),window.outIntercept=a;break;default:var h="/"+this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];h&&this.pdf.internal.out(h+" gs")}var u=this.ctx.globalAlpha;if(this.ctx._fillOpacity<1&&(u=this.ctx._fillOpacity),r){var f=this.pdf.internal.newObject2();f.push("<</Type /ExtGState"),f.push("/CA "+u),f.push("/ca "+u),f.push(">>");c="GS_O_"+f.objId;this.pdf.internal.addGraphicsState(c,f.objId),this.pdf.internal.out("/"+c+" gs")}for(var d=this.path,p=0;p<d.length;p++){var g=d[p];switch(g.type){case"mt":i.push({start:g,deltas:[],abs:[]});break;case"lt":var m=[g.x-d[p-1].x,g.y-d[p-1].y];i[i.length-1].deltas.push(m),i[i.length-1].abs.push(g);break;case"bct":m=[g.x1-d[p-1].x,g.y1-d[p-1].y,g.x2-d[p-1].x,g.y2-d[p-1].y,g.x-d[p-1].x,g.y-d[p-1].y];i[i.length-1].deltas.push(m);break;case"qct":var y=d[p-1].x+2/3*(g.x1-d[p-1].x),w=d[p-1].y+2/3*(g.y1-d[p-1].y),v=g.x+2/3*(g.x1-g.x),b=g.y+2/3*(g.y1-g.y),x=g.x,S=g.y;m=[y-d[p-1].x,w-d[p-1].y,v-d[p-1].x,b-d[p-1].y,x-d[p-1].x,S-d[p-1].y];i[i.length-1].deltas.push(m);break;case"arc":0===i.length&&i.push({deltas:[],abs:[]}),i[i.length-1].arc=!0,i[i.length-1].abs.push(g);break;case"close":i.push({close:!0})}}for(p=0;p<i.length;p++){var k;if(p==i.length-1?(k="f","evenodd"===t&&(k+="*")):k=null,i[p].close)this.pdf.internal.out("h"),k&&this.pdf.internal.out(k);else if(i[p].arc){i[p].start&&this.internal.move2(this,i[p].start.x,i[p].start.y);for(var _=i[p].abs,C=0;C<_.length;C++){var I=_[C];if(void 0!==I.startAngle){var A=360*I.startAngle/(2*Math.PI),T=360*I.endAngle/(2*Math.PI),F=I.x,q=I.y;if(0===C&&this.internal.move2(this,F,q),this.internal.arc2(this,F,q,I.radius,A,T,I.anticlockwise,null,e),C===_.length-1&&i[p].start){F=i[p].start.x,q=i[p].start.y;this.internal.line2(E,F,q)}}else this.internal.line2(E,I.x,I.y)}}else{F=i[p].start.x,q=i[p].start.y;e?(this.pdf.lines(i[p].deltas,F,q,null,null),this.pdf.clip_fixed()):this.pdf.lines(i[p].deltas,F,q,null,k)}}window.outIntercept=o}},pushMask:function(){if("function"==typeof this.pdf.internal.newObject2){var t=this.pdf.internal.newStreamObject(),e=this.pdf.internal.newObject2();e.push("<</Type /ExtGState"),e.push("/SMask <</S /Alpha /G "+t.objId+" 0 R>>"),e.push(">>");var n="MASK"+e.objId;this.pdf.internal.addGraphicsState(n,e.objId);var r="/"+n+" gs";this.pdf.internal.out(r)}else console.log("jsPDF v2 not enabled")},clip:function(){if(0<this.ctx._clip_path.length)for(var t=0;t<this.path.length;t++)this.ctx._clip_path.push(this.path[t]);else this.ctx._clip_path=this.path;this.path=[]},measureText:function(n){var r=this.pdf;return{getWidth:function(){var t=r.internal.getFontSize(),e=r.getStringUnitWidth(n)*t/r.internal.scaleFactor;return e*=1.3333},get width(){return this.getWidth(n)}}},_getBaseline:function(t){var e=parseInt(this.pdf.internal.getFontSize()),n=.25*e;switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e;case"hanging":return t+e-n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}}};var E=t.context2d;function e(){this._isStrokeTransparent=!1,this._strokeOpacity=1,this.strokeStyle="#000000",this.fillStyle="#000000",this._isFillTransparent=!1,this._fillOpacity=1,this.font="12pt times",this.textBaseline="alphabetic",this.textAlign="start",this.lineWidth=1,this.lineJoin="miter",this.lineCap="butt",this._transform=[1,0,0,1,0,0],this.globalCompositeOperation="normal",this.globalAlpha=1,this._clip_path=[],this.ignoreClearRect=!1,this.copy=function(t){this._isStrokeTransparent=t._isStrokeTransparent,this._strokeOpacity=t._strokeOpacity,this.strokeStyle=t.strokeStyle,this._isFillTransparent=t._isFillTransparent,this._fillOpacity=t._fillOpacity,this.fillStyle=t.fillStyle,this.font=t.font,this.lineWidth=t.lineWidth,this.lineJoin=t.lineJoin,this.lineCap=t.lineCap,this.textBaseline=t.textBaseline,this.textAlign=t.textAlign,this._fontSize=t._fontSize,this._transform=t._transform.slice(0),this.globalCompositeOperation=t.globalCompositeOperation,this.globalAlpha=t.globalAlpha,this._clip_path=t._clip_path.slice(0),this.ignoreClearRect=t.ignoreClearRect}}Object.defineProperty(E,"fillStyle",{set:function(t){this.setFillStyle(t)},get:function(){return this.ctx.fillStyle}}),Object.defineProperty(E,"strokeStyle",{set:function(t){this.setStrokeStyle(t)},get:function(){return this.ctx.strokeStyle}}),Object.defineProperty(E,"lineWidth",{set:function(t){this.setLineWidth(t)},get:function(){return this.ctx.lineWidth}}),Object.defineProperty(E,"lineCap",{set:function(t){this.setLineCap(t)},get:function(){return this.ctx.lineCap}}),Object.defineProperty(E,"lineJoin",{set:function(t){this.setLineJoin(t)},get:function(){return this.ctx.lineJoin}}),Object.defineProperty(E,"miterLimit",{set:function(t){this.ctx.miterLimit=t},get:function(){return this.ctx.miterLimit}}),Object.defineProperty(E,"textBaseline",{set:function(t){this.setTextBaseline(t)},get:function(){return this.getTextBaseline()}}),Object.defineProperty(E,"textAlign",{set:function(t){this.setTextAlign(t)},get:function(){return this.getTextAlign()}}),Object.defineProperty(E,"font",{set:function(t){this.setFont(t)},get:function(){return this.ctx.font}}),Object.defineProperty(E,"globalCompositeOperation",{set:function(t){this.ctx.globalCompositeOperation=t},get:function(){return this.ctx.globalCompositeOperation}}),Object.defineProperty(E,"globalAlpha",{set:function(t){this.ctx.globalAlpha=t},get:function(){return this.ctx.globalAlpha}}),Object.defineProperty(E,"ignoreClearRect",{set:function(t){this.ctx.ignoreClearRect=t},get:function(){return this.ctx.ignoreClearRect}}),E.internal={},E.internal.rxRgb=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,E.internal.rxRgba=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/,E.internal.rxTransparent=/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/,E.internal.arc=function(t,e,n,r,i,o,a,s){for(var c=this.pdf.internal.scaleFactor,l=this.pdf.internal.pageSize.getHeight(),h=this.pdf.internal.f2,u=i*(Math.PI/180),f=o*(Math.PI/180),d=this.createArc(r,u,f,a),p=0;p<d.length;p++){var g=d[p];0===p?this.pdf.internal.out([h((g.x1+e)*c),h((l-(g.y1+n))*c),"m",h((g.x2+e)*c),h((l-(g.y2+n))*c),h((g.x3+e)*c),h((l-(g.y3+n))*c),h((g.x4+e)*c),h((l-(g.y4+n))*c),"c"].join(" ")):this.pdf.internal.out([h((g.x2+e)*c),h((l-(g.y2+n))*c),h((g.x3+e)*c),h((l-(g.y3+n))*c),h((g.x4+e)*c),h((l-(g.y4+n))*c),"c"].join(" ")),t._lastPoint={x:e,y:n}}null!==s&&this.pdf.internal.out(this.pdf.internal.getStyle(s))},E.internal.arc2=function(t,e,n,r,i,o,a,s,c){var l=e,h=n;c?(this.arc(t,l,h,r,i,o,a,null),this.pdf.clip_fixed()):this.arc(t,l,h,r,i,o,a,s)},E.internal.move2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.getHeight(),o=this.pdf.internal.f2;this.pdf.internal.out([o(e*r),o((i-n)*r),"m"].join(" ")),t._lastPoint={x:e,y:n}},E.internal.line2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.getHeight(),o=this.pdf.internal.f2,a={x:e,y:n};this.pdf.internal.out([o(a.x*r),o((i-a.y)*r),"l"].join(" ")),t._lastPoint=a},E.internal.createArc=function(t,e,n,r){var i=2*Math.PI,o=Math.PI/2,a=e;for((a<i||i<a)&&(a%=i),a<0&&(a=i+a);n<e;)e-=i;var s=Math.abs(n-e);s<i&&r&&(s=i-s);for(var c=[],l=r?-1:1,h=a;1e-5<s;){var u=h+l*Math.min(s,o);c.push(this.createSmallArc(t,h,u)),s-=Math.abs(u-h),h=u}return c},E.internal.getCurrentPage=function(){return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber]},E.internal.createSmallArc=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,c=a*a+s*s,l=c+a*i+s*o,h=4/3*(Math.sqrt(2*c*l)-l)/(a*o-s*i),u=a-h*s,f=s+h*a,d=u,p=-f,g=r+e,m=Math.cos(g),y=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:u*m-f*y,y2:u*y+f*m,x3:d*m-p*y,y3:d*y+p*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}}}(K.API),
	/** @preserve
	   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
	   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *               2014 Daniel Husar, https://github.com/danielhusar
	   *               2014 Wolfgang Gassler, https://github.com/woolfg
	   *               2014 Steven Spungin, https://github.com/flamenco
	   *
	   * 
	   * ====================================================================
	   */
	function(t){var T,F,i,a,s,c,l,h,q,v,f,u,d,n,E,P,p,g,m,O;T=function(){return function(t){return e.prototype=t,new e};function e(){}}(),v=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},u=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},d=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[{css_line_height_string:t}])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:3===(e=t.match(/([\d\.]+)(px)/)).length?n[t]=parseFloat(e[1])/16:n[t]=1},q=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=u((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=c[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=d(r("font-size"))||1,e["line-height"]=d(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&d(r("margin-top"))||0,e["margin-bottom"]=n&&d(r("margin-bottom"))||0,e["padding-top"]=n&&d(r("padding-top"))||0,e["padding-bottom"]=n&&d(r("padding-bottom"))||0,e["margin-left"]=n&&d(r("margin-left"))||0,e["margin-right"]=n&&d(r("margin-right"))||0,e["padding-left"]=n&&d(r("padding-left"))||0,e["padding-right"]=n&&d(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=l[r("cssFloat")]||"none",e.clear=h[r("clear")]||"none",e.color=r("color"),e},E=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},O=function(t,e){var n,r,i,o,a,s,c,l,h;for(n=[],r=[],i=0,h=t.rows[0].cells.length,c=t.clientWidth;i<h;)l=t.rows[0].cells[i],r[i]={name:l.textContent.toLowerCase().replace(/\s+/g,""),prompt:l.textContent.replace(/\r?\n/g,""),width:l.clientWidth/c*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var B={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},j=1;F=function(t,i,e){var n,r,o,a,s,c,l,h;for(r=t.childNodes,n=void 0,(s="block"===(o=q(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,c=r.length;a<c;){if("object"===(void 0===(n=r[a])?"undefined":vt(n))){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var u=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,F(u,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||B[n.nodeName])if(3===n.nodeType){var d=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)d=j+++". "+d;else{var p=o["font-size"],g=(3-.75*p)*i.pdf.internal.scaleFactor,m=.75*p*i.pdf.internal.scaleFactor,y=1.74*p/i.pdf.internal.scaleFactor;h=function(t,e){this.pdf.circle(t+g,e+m,y,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(d,o)}else"string"==typeof n&&i.addText(n,o);else{var w;if("IMG"===n.nodeName){var v=n.getAttribute("src");w=P[i.pdf.sHashCode(v)||v]}if(w){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=q(n),x=i.x,S=12/i.pdf.internal.scaleFactor,k=(b["margin-left"]+b["padding-left"])*S,_=(b["margin-right"]+b["padding-right"])*S,C=(b["margin-top"]+b["padding-top"])*S,I=(b["margin-bottom"]+b["padding-bottom"])*S;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-_:x+=k,i.pdf.addImage(w,x,i.y+C,n.width,n.height),w=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!B[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-k-_:0,i.y+n.height+C+I,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===q(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+k+_,"left"===b.float&&(i.x+=n.width+k+_)):i.y+=n.height+C+I}else if("TABLE"===n.nodeName)l=O(n,i),i.y+=10,i.pdf.table(i.x,i.y,l.rows,l.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:q(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)j=1,E(n,i,e)||F(n,i,e),i.y+=10;else if("LI"===n.nodeName){var A=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,E(n,i,e)||F(n,i,e),i.x=A}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",T(o))):E(n,i,e)||F(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(h)},P={},p=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function c(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function l(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;P[t]=P[t]||i}--s||c()},i.src=e}}for(;i--;)l(r[i].getAttribute("src"),r[i].width,r[i].height);return s||c()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},F(s,o,a);var c=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=c;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=c;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");F(s,o,a),o.pdf.margins_doc.bottom+=c,o.y=n},i=s.getElementsByTagName("span"),l=0;l<i.length;++l)-1<(" "+i[l].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),B.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,c,l;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),l="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(c=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",c.innerHTML='<iframe style="height:1px;width:1px" name="'+l+'" />',document.body.appendChild(c),(s=window.frames[l]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var h,u=new f(t,n,r,i);return p.call(this,e,u,i.elementHandlers,function(t){g(e,u,i.elementHandlers),F(e,u,i.elementHandlers),u.pdf.internal.events.publish("htmlRenderingFinished"),h=u.dispose(),"function"==typeof o?o(h):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),h||{x:u.x,y:u.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,c,l,h,u,f,d,p,g;for(12,u=this.pdf.internal.scaleFactor,o={},s=c=l=g=a=i=h=r=void 0,d=[f=[]],n=0,p=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(h=g["font-style"])])||(i=this.pdf.internal.getFont(r,h).metadata.Unicode,o[r+h]=i),l={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},c=this.pdf.getStringUnitWidth(a,l)*l.fontSize/u,"\u2028"==a)f=[],d.push(f);else if(p<n+c){for(s=this.pdf.splitTextToSize(a,p,l),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],d.push(f);n=this.pdf.getStringUnitWidth(f[0][0],l)*l.fontSize/u}else f.push([a,g]),n+=c;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<d.length;++m){var y=this.pdf.getStringUnitWidth(d[m][0][0],l)*l.fontSize/u;0<m&&(d[m][0][1]=T(d[m][0][1]));var w=p-y;if("right"===g["text-align"])d[m][0][1]["margin-left"]=w;else if("center"===g["text-align"])d[m][0][1]["margin-left"]=w/2;else if("justify"===g["text-align"]){var v=d[m][0][0].split(" ").length-1;d[m][0][1]["word-spacing"]=w/v,m===d.length-1&&(d[m][0][1]["word-spacing"]=0)}}return d},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=i?(e=parseInt(i[1]),n=parseInt(i[2]),r=parseInt(i[3])):("#"!=t.charAt(0)&&((t=dt.colorNameToHex(t))||(t="#000000")),e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)),"string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var o=parseInt(e.substr(1),16);e=o>>16&255,n=o>>8&255,r=255&o}var a=this.f3;return 0===e&&0===n&&0===r||void 0===n?a(e/255)+" g":[a(e/255),a(n/255),a(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,c,l,h,u,f,d;if(r=v(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),c=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,u=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,h=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,u=((e["margin-top"]||0)+(e["padding-top"]||0))*n),l=this.pdf.internal.write,o=i=void 0,this.y+=u,l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var p=0;s.length;){for(i=c=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(c=Math.max(c,a[i][1]["line-height"],a[i][1]["font-size"]),d=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-p,p=m),l(g+Math.max(e["margin-left"]||0,0)*n,(-12*c).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=c*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var y=[],w=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),w.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(v(y),w),l("ET","Q"),l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-d/2),l("ET","Q"),this.y+=h}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},c={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},l={none:"none",right:"right",left:"left"},h={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(K.API),K.API.addJS=function(t){return s=t,this.internal.events.subscribe("postPutResources",function(t){n=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(n+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),r=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+s+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==n&&void 0!==r&&this.internal.out("/Names <</JavaScript "+n+" 0 R>>")}),this},(
	/**
	   * jsPDF Outline PlugIn
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	l=K.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,c=[];for(r=0;r<s;r++){var l=t.internal.newObject();c.push(l);var h=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+h.objId+" 0 R /XYZ null null null]>> endobj")}var u=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<c.length;r++)t.internal.write("(page_"+(r+1)+")"+c[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+u+" 0 R"),t.internal.write(">>","endobj")}}]),l.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),l.events.push(["initialized",function(){var o=this;o.outline={createNamedDestinations:!1,root:{children:[]}},o.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},o.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=o,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},o.outline.genIds_r=function(t){t.id=o.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},o.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},o.outline.renderItems=function(t){for(var e=0;e<t.children.length;e++){var n=t.children[e];this.objStart(n),this.line("/Title "+this.makeString(n.title)),this.line("/Parent "+this.makeRef(t)),0<e&&this.line("/Prev "+this.makeRef(t.children[e-1])),e<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[e+1])),0<n.children.length&&(this.line("/First "+this.makeRef(n.children[0])),this.line("/Last "+this.makeRef(n.children[n.children.length-1])));var r=this.count=this.count_r({count:0},n);if(0<r&&this.line("/Count "+r),n.options&&n.options.pageNumber){var i=o.internal.getPageInfo(n.options.pageNumber);this.line("/Dest ["+i.objId+" 0 R /XYZ 0 "+this.ctx.pdf.internal.pageSize.getHeight()*this.ctx.pdf.internal.scaleFactor+" 0]")}this.objEnd()}for(e=0;e<t.children.length;e++)n=t.children[e],this.renderItems(n)},o.outline.line=function(t){this.ctx.val+=t+"\r\n"},o.outline.makeRef=function(t){return t.id+" 0 R"},o.outline.makeString=function(t){return"("+o.internal.pdfEscape(t)+")"},o.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},o.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},o.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
	/**@preserve
	   *  ====================================================================
	   * jsPDF PNG PlugIn
	   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
	   *
	   * 
	   * ====================================================================
	   */
	q=K.API,E=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},P=function(t,e,n,r){var i=5,o=b;switch(r){case q.image_compression.FAST:i=3,o=v;break;case q.image_compression.MEDIUM:i=6,o=x;break;case q.image_compression.SLOW:i=9,o=S}t=y(t,e,n,o);var a=new Uint8Array(g(i)),s=m(t),c=new Deflater(i),l=c.append(t),h=c.flush(),u=a.length+l.length+h.length,f=new Uint8Array(u+4);return f.set(a),f.set(l,a.length),f.set(h,a.length+l.length),f[u++]=s>>>24&255,f[u++]=s>>>16&255,f[u++]=s>>>8&255,f[u++]=255&s,q.arrayBufferToBinaryString(f)},g=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},m=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},y=function(t,e,n,r){for(var i,o,a,s=t.length/e,c=new Uint8Array(t.length+s),l=k(),h=0;h<s;h++){if(a=h*e,i=t.subarray(a,a+e),r)c.set(r(i,n,o),a+h);else{for(var u=0,f=l.length,d=[];u<f;u++)d[u]=l[u](i,n,o);var p=_(d.concat());c.set(d[p],a+h)}o=i}return c},h=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},v=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},b=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},x=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},S=function(t,e,n){var r,i,o,a,s=[],c=0,l=t.length;for(s[0]=4;c<l;c++)r=t[c-e]||0,i=n&&n[c]||0,o=n&&n[c-e]||0,a=u(r,i,o),s[c+1]=t[c]-a+256&255;return s},u=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},k=function(){return[h,v,b,x,S]},_=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=f(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},f=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},q.processPNG=function(t,e,n,r,i){var o,a,s,c,l,h,u=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,d=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof gt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,d=o.bits,u=o.colorSpace,c=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var p,g=(I=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),y=new Uint8Array(g),w=o.pixelBitlength-o.bits,v=0,b=0;v<g;v++){for(x=I[v],p=0;p<w;)m[b++]=x>>>p&255,p+=o.bits;y[v]=x>>>p&255}if(16===o.bits){g=(I=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),y=new Uint8Array(g*(32/o.pixelBitlength));for(var x,S=1<o.colors,k=b=v=0;v<g;)x=I[v++],m[b++]=x>>>0&255,S&&(m[b++]=x>>>16&255,x=I[v++],m[b++]=x>>>0&255),y[k++]=x>>>16&255;d=8}r!==q.image_compression.NONE&&E()?(t=P(m,o.width*o.colors,o.colors,r),h=P(y,o.width,1,r)):(t=m,h=y,f=null)}if(3===o.colorType&&(u=this.color_spaces.INDEXED,l=o.palette,o.transparency.indexed)){var _=o.transparency.indexed,C=0;for(v=0,g=_.length;v<g;++v)C+=_[v];if((C/=255)==g-1&&-1!==_.indexOf(0))s=[_.indexOf(0)];else if(C!==g){var I=o.decodePixels();for(y=new Uint8Array(I.length),v=0,g=I.length;v<g;v++)y[v]=_[I[v]];h=P(y,o.width,1)}}var A=function(t){var e;switch(t){case q.image_compression.FAST:e=11;break;case q.image_compression.MEDIUM:e=13;break;case q.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+A+" /Colors "+c+" /BitsPerComponent "+d+" /Columns "+o.width:"/Colors "+c+" /BitsPerComponent "+d+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(h&&this.isArrayBuffer(h)||this.isArrayBufferView(h))&&(h=this.arrayBufferToBinaryString(h)),this.createImageInfo(t,o.width,o.height,u,d,f,e,n,a,s,l,h,A)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},K.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
	/** @preserve
	   * jsPDF split_text_to_size plugin - MIT license.
	   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	   *               2014 Diego Casorran, https://github.com/diegocr
	   */
	C=K.API,O=C.getCharWidthsArray=function(t,e){e||(e={});var n,r=t.length,i=[];if(e.font){var o=e.fontSize,a=e.charSpace;for(n=0;n<r;n++)i.push(e.font.widthOfString(t[n],o,a)/o);return i}var s=e.widths?e.widths:this.internal.getFont().metadata.Unicode.widths,c=s.fof?s.fof:1,l=e.kerning?e.kerning:this.internal.getFont().metadata.Unicode.kerning,h=l.fof?l.fof:1,u=0,f=0,d=s[0]||c;for(n=0,r=t.length;n<r;n++)u=t.charCodeAt(n),i.push((s[u]||d)/c+(l[u]&&l[u][f]||0)/h),f=u;return i},B=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},j=C.getStringUnitWidth=function(t,e){return B(O.call(this,t,e))},R=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var c=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(c,o)),s=0,c=o),s+=e[o],o++;return c!==o&&i.push(t.slice(c,o)),i},D=function(t,e,n){n||(n={});var r,i,o,a,s,c,l=[],h=[l],u=n.textIndent||0,f=0,d=0,p=t.split(" "),g=O(" ",n)[0];if(c=-1===n.lineIndent?p[0].length+2:n.lineIndent||0){var m=Array(c).join(" "),y=[];p.map(function(t){1<(t=t.split(/\s*\n/)).length?y=y.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):y.push(t[0])}),p=y,c=j(m,n)}for(o=0,a=p.length;o<a;o++){var w=0;if(r=p[o],c&&"\n"==r[0]&&(r=r.substr(1),w=1),i=O(r,n),e<u+f+(d=B(i))||w){if(e<d){for(s=R(r,i,e-(u+f),e),l.push(s.shift()),l=[s.pop()];s.length;)h.push([s.shift()]);d=B(i.slice(r.length-(l[0]?l[0].length:0)))}else l=[r];h.push(l),u=d+c,f=g}else l.push(r),u+=f+d,f=g}if(c)var v=function(t,e){return(e?m:"")+t.join(" ")};else v=function(t){return t.join(" ")};return h.map(v)},C.splitTextToSize=function(t,e,n){n||(n={});var r,i=n.fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,c,l=[];for(s=0,c=r.length;s<c;s++)l=l.concat(D(r[s],a,o));return l},
	/** @preserve 
	  jsPDF standard_fonts_metrics plugin
	  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	  MIT license.
	  */
	M=K.API,N={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(z=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,c,l={},h=1,u=l,f=[],d="",p="",g=t.length-1;for(r=1;r!=g;)c=t[r],r+=1,"'"==c?o?(s=o.join(""),o=i):o=[]:o?o.push(c):"{"==c?(f.push([u,s]),u={},s=i):"}"==c?((a=f.pop())[0][a[1]]=u,s=i,u=a[0]):"-"==c?h=-1:s===i?n.hasOwnProperty(c)?(d+=n[c],s=parseInt(d,16)*h,h=1,d=""):d+=c:n.hasOwnProperty(c)?(p+=n[c],u[s]=parseInt(p,16)*h,h=1,s=i,p=""):p+=c;return l})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},L={Unicode:{Courier:N,"Courier-Bold":N,"Courier-BoldOblique":N,"Courier-Oblique":N,Helvetica:N,"Helvetica-Bold":N,"Helvetica-BoldOblique":N,"Helvetica-Oblique":N,"Times-Roman":N,"Times-Bold":N,"Times-BoldItalic":N,"Times-Italic":N}
	/** 
	    Resources:
	    Font metrics data is reprocessed derivative of contents of
	    "Font Metrics for PDF Core 14 Fonts" package, which exhibits the following copyright and license:
	    
	    Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated. All Rights Reserved.
	    
	    This file and the 14 PostScript(R) AFM files it accompanies may be used,
	    copied, and distributed for any purpose and without charge, with or without
	    modification, provided that all copyright notices are retained; that the AFM
	    files are not distributed without this file; that all modifications to this
	    file or any of the AFM files are prominently noted in the modified file(s);
	    and that this paragraph is not modified. Adobe Systems has no responsibility
	    or obligation to support the use of the AFM files.
	    
	    */},U={Unicode:{"Courier-Oblique":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":z("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":z("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:z("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:z("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":z("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":z("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},M.events.push(["addFont",function(t){var e,n,r,i="Unicode";(e=U[i][t.postScriptName])&&((n=t.metadata[i]?t.metadata[i]:t.metadata[i]={}).widths=e.widths,n.kerning=e.kerning),(r=L[i][t.postScriptName])&&((n=t.metadata[i]?t.metadata[i]:t.metadata[i]={}).encoding=r).codePages&&r.codePages.length&&(t.encoding=r.codePages[0])}]),H=K,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),H.API.events.push(["addFont",function(t){H.API.existsFileInVFS(t.postScriptName)?(t.metadata=H.API.TTFFont.open(t.postScriptName,t.fontName,H.API.getFileFromVFS(t.postScriptName),t.encoding),t.metadata.Unicode=t.metadata.Unicode||{encoding:{},kerning:{},widths:[]}):14<t.id.slice(1)&&console.error("Font does not exist in FileInVFS, import fonts or remove declaration doc.addFont('"+t.postScriptName+"').")}]),K.API.addSVG=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,c,l,h,u,f,d,p=(l=document,d=l.createElement("iframe"),h=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(u=l).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=h:f.appendChild(u.createTextNode(h)),u.getElementsByTagName("head")[0].appendChild(f),d.name="childframe",d.setAttribute("width",0),d.setAttribute("height",0),d.setAttribute("frameborder","0"),d.setAttribute("scrolling","no"),d.setAttribute("seamless","seamless"),d.setAttribute("class","jsPDF_sillysvg_iframe"),l.body.appendChild(d),d),g=(a=t,(c=((s=p).contentWindow||s.contentDocument).document).write(a),c.close(),c.getElementsByTagName("svg")[0]),m=[1,1],y=parseFloat(g.getAttribute("width")),w=parseFloat(g.getAttribute("height"));y&&w&&(r&&i?m=[r/y,i/w]:r?m=[r/y,r/y]:i&&(m=[i/w,i/w]));var v,b,x,S,k=g.childNodes;for(v=0,b=k.length;v<b;v++)(x=k[v]).tagName&&"PATH"===x.tagName.toUpperCase()&&((S=o(x.getAttribute("d").split(" ")))[0]=S[0]*m[0]+e,S[1]=S[1]*m[1]+n,this.lines.call(this,S[2],S[0],S[1],m));return this},K.API.putTotalPages=function(t){for(var e=new RegExp(t,"g"),n=1;n<=this.internal.getNumberOfPages();n++)for(var r=0;r<this.internal.pages[n].length;r++)this.internal.pages[n][r]=this.internal.pages[n][r].replace(e,this.internal.getNumberOfPages());return this},K.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],c=0,l=0,h=0,u=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var d=a.length;for(h=0;h<d;h+=1)n[a[h]].value=n[a[h]].defaultValue,n[a[h]].explicitSet=!1}if("object"===(void 0===t?"undefined":vt(t)))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(c=0;c<i.length;c+=1)if(u=!0,1===i[c].length&&"number"==typeof i[c][0])s.push(String(i[c]));else if(1<i[c].length){for(l=0;l<i[c].length;l+=1)"number"!=typeof i[c][l]&&(u=!1);!0===u&&s.push(String(i[c].join("-")))}n[r].value=String(s)}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
	/** ==================================================================== 
	   * jsPDF XMP metadata plugin
	   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
	   * 
	   * 
	   * ====================================================================
	   */
	W=K.API,Y=G=V="",W.addMetadata=function(t,e){return G=e||"http://jspdf.default.namespaceuri/",V=t,this.internal.events.subscribe("postPutResources",function(){if(V){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+G+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(V)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;Y=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else Y=""}),this.internal.events.subscribe("putCatalog",function(){Y&&this.internal.write("/Metadata "+Y+" 0 R")}),this},function(h,t){var e=h.API,m=[0];e.events.push(["putFont",function(t){!function(t,e,n){if(t.metadata instanceof h.API.TTFFont&&"Identity-H"===t.encoding){for(var r=t.metadata.Unicode.widths,i=t.metadata.subset.encode(m),o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();e("<<"),e("/Length "+o.length),e("/Length1 "+o.length),e(">>"),e("stream"),e(o),e("endstream"),e("endobj");var c=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+s+" 0 R"),e("/FontBBox "+h.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var l=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+c+" 0 R"),e("/W "+h.API.PDFObject.convert(r)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+l+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject)}]);e.events.push(["putFont",function(t){!function(t,e,n){if(t.metadata instanceof h.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var r=t.metadata.rawData,i="",o=0;o<r.length;o++)i+=String.fromCharCode(r[o]);var a=n();e("<<"),e("/Length "+i.length),e("/Length1 "+i.length),e(">>"),e("stream"),e(i),e("endstream"),e("endobj");var s=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+a+" 0 R"),e("/Flags 96"),e("/FontBBox "+h.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),o=0;o<t.metadata.hmtx.widths.length;o++)t.metadata.hmtx.widths[o]=parseInt(t.metadata.hmtx.widths[o]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/BaseFont/"+t.fontName+"/FontDescriptor "+s+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+h.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject)}]);var l=function(t){var e,n,r=t.text,i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},c=s.pdfEscape,l=s.activeFontKey,h=s.fonts,u=(s.activeFontSize,""),f=0,d="",p=h[n=l].encoding;if("Identity-H"!==h[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(d=r,n=l,"[object Array]"===Object.prototype.toString.call(r)&&(d=r[0]),f=0;f<d.length;f+=1)h[n].metadata.hasOwnProperty("cmap")&&(e=h[n].metadata.cmap.unicode.codeMap[d[f].charCodeAt(0)]),e?u+=d[f]:d[f].charCodeAt(0)<256&&h[n].metadata.hasOwnProperty("Unicode")?u+=d[f]:u+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===p?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(c(u,n)):"Identity-H"===p&&(g=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),m.push(n),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")}(u,h[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text,n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var c=0;for(c=0;c<e.length;c+=1)"[object Array]"===Object.prototype.toString.call(e[c])&&3===e[c].length?a.push([l(Object.assign({},s,{text:e[c][0]})).text,e[c][1],e[c][2]]):a.push(l(Object.assign({},s,{text:e[c]})).text);t.text=a}else t.text=l(Object.assign({},s,{text:e})).text}])}(K,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),X=K.API,J={},X.existsFileInVFS=function(t){return J.hasOwnProperty(t)},X.addFileToVFS=function(t,e){return J[t]=e,this},X.getFileFromVFS=function(t){return J.hasOwnProperty(t)?J[t]:null},function(t){if(t.URL=t.URL||t.webkitURL,t.Blob&&t.URL)try{return new Blob}catch(t){}var s=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||function(t){var s=function(t){return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1]},e=function(){this.data=[]},c=function(t,e,n){this.data=t,this.size=t.length,this.type=e,this.encoding=n},n=e.prototype,r=c.prototype,l=t.FileReaderSync,h=function(t){this.code=this[this.name=t]},i="NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "),o=i.length,a=t.URL||t.webkitURL||t,u=a.createObjectURL,f=a.revokeObjectURL,d=a,p=t.btoa,g=t.atob,m=t.ArrayBuffer,y=t.Uint8Array,w=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;for(c.fake=r.fake=!0;o--;)h.prototype[i[o]]=o+1;return a.createObjectURL||(d=t.URL=function(t){var e,n=document.createElementNS("http://www.w3.org/1999/xhtml","a");return n.href=t,"origin"in n||("data:"===n.protocol.toLowerCase()?n.origin=null:(e=t.match(w),n.origin=e&&e[1])),n}),d.createObjectURL=function(t){var e,n=t.type;return null===n&&(n="application/octet-stream"),t instanceof c?(e="data:"+n,"base64"===t.encoding?e+";base64,"+t.data:"URI"===t.encoding?e+","+decodeURIComponent(t.data):p?e+";base64,"+p(t.data):e+","+encodeURIComponent(t.data)):u?u.call(a,t):void 0},d.revokeObjectURL=function(t){"data:"!==t.substring(0,5)&&f&&f.call(a,t)},n.append=function(t){var e=this.data;if(y&&(t instanceof m||t instanceof y)){for(var n="",r=new y(t),i=0,o=r.length;i<o;i++)n+=String.fromCharCode(r[i]);e.push(n)}else if("Blob"===s(t)||"File"===s(t)){if(!l)throw new h("NOT_READABLE_ERR");var a=new l;e.push(a.readAsBinaryString(t))}else t instanceof c?"base64"===t.encoding&&g?e.push(g(t.data)):"URI"===t.encoding?e.push(decodeURIComponent(t.data)):"raw"===t.encoding&&e.push(t.data):("string"!=typeof t&&(t+=""),e.push(unescape(encodeURIComponent(t))))},n.getBlob=function(t){return arguments.length||(t=null),new c(this.data.join(""),t,"raw")},n.toString=function(){return"[object BlobBuilder]"},r.slice=function(t,e,n){var r=arguments.length;return r<3&&(n=null),new c(this.data.slice(t,1<r?e:this.data.length),n,this.encoding)},r.toString=function(){return"[object Blob]"},r.close=function(){this.size=0,delete this.data},e}(t);t.Blob=function(t,e){var n=e&&e.type||"",r=new s;if(t)for(var i=0,o=t.length;i<o;i++)Uint8Array&&t[i]instanceof Uint8Array?r.append(t[i].buffer):r.append(t[i]);var a=r.getBlob(n);return!a.slice&&a.webkitSlice&&(a.slice=a.webkitSlice),a};var e=Object.getPrototypeOf||function(t){return t.__proto__};t.Blob.prototype=e(new t.Blob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||window.content||window);var Q,Z,$,tt,et,nt,rt,it,ot,at,st,ct,lt,ht,bt=bt||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,c=function(){return s.URL||s.webkitURL||s},l=t.createElementNS("http://www.w3.org/1999/xhtml","a"),h="download"in l,u=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),d=function(t){(s.setImmediate||s.setTimeout)(function(){throw t},0)},p=function(t){setTimeout(function(){"string"==typeof t?c().revokeObjectURL(t):t.remove()},4e4)},g=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=g(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,h)return r=c().createObjectURL(t),void setTimeout(function(){var t,e;l.href=r,l.download=n,t=l,e=new MouseEvent("click"),t.dispatchEvent(e),a(),p(r),i.readyState=i.DONE});!function(){if((f||o&&u)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=c().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),p(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=g(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||window.content);"undefined"!=typeof module&&module.exports?module.exports.saveAs=bt:"undefined"!="function"&&null!==__webpack_require__(502)&&null!==__webpack_require__(1031)&&!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return bt}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	/*
	   * Copyright (c) 2012 chick307 <chick307@gmail.com>
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */,K.API.adler32cs=(nt="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,rt=null,it=function(){if(!nt)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(rt=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==rt&&t instanceof rt}}(),ot=null!==rt?function(t){return new rt(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},at=65521,st=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%at,r=(r+n)%at;return(r<<16|n)>>>0},ct=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%at,r=(r+n)%at;return(r<<16|n)>>>0},ht=(lt={}).Adler32=(((et=(tt=function(t){if(!(this instanceof tt))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=tt).from=((Q=function(t){if(!(this instanceof tt))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=st(1,t.toString())}).prototype=et,Q),tt.fromUtf8=((Z=function(t){if(!(this instanceof tt))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=ot(t.toString());this.checksum=st(1,e)}).prototype=et,Z),nt&&(tt.fromBuffer=(($=function(t){if(!(this instanceof tt))throw new TypeError("Constructor cannot called be as a function.");if(!it(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=ct(1,e)}).prototype=et,$)),et.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=st(this.checksum,t)},et.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=ot(t.toString());return this.checksum=st(this.checksum,e)},nt&&(et.updateBuffer=function(t){if(!it(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=ct(this.checksum,e)}),et.clone=function(){return new ht(this.checksum)},tt),lt.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return st(1,t.toString())},lt.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=ot(t.toString());return st(1,e)},nt&&(lt.fromBuffer=function(t){if(!it(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return ct(1,e)}),lt),
	/*
	   Copyright (c) 2013 Gildas Lormeau. All rights reserved.
	
	   Redistribution and use in source and binary forms, with or without
	   modification, are permitted provided that the following conditions are met:
	
	   1. Redistributions of source code must retain the above copyright notice,
	   this list of conditions and the following disclaimer.
	
	   2. Redistributions in binary form must reproduce the above copyright 
	   notice, this list of conditions and the following disclaimer in 
	   the documentation and/or other materials provided with the distribution.
	
	   3. The names of the authors may not be used to endorse or promote products
	   derived from this software without specific prior written permission.
	
	   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	   */
	function(t){var p=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ut(){var d=this;function c(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}d.build_tree=function(t){var e,n,r,i=d.dyn_tree,o=d.stat_desc.static_tree,a=d.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(d.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=d.dyn_tree,c=d.stat_desc.static_tree,l=d.stat_desc.extra_bits,h=d.stat_desc.extra_base,u=d.stat_desc.max_length,f=0;for(i=0;i<=p;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)u<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=u,f++),s[2*n+1]=i,n>d.max_code||(t.bl_count[i]++,o=0,h<=n&&(o=l[n-h]),a=s[2*n],t.opt_len+=a*(i+o),c&&(t.static_len+=a*(c[2*n+1]+o)));if(0!==f){do{for(i=u-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[u]--,f-=2}while(0<f);for(i=u;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>d.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=p;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=c(a[o]++,o))}(i,d.max_code,t.bl_count)}}function ft(t,e,n,r,i){var o=this;o.static_tree=t,o.extra_bits=e,o.extra_base=n,o.elems=r,o.max_length=i}ut._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ut.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ut.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ut.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ut.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ut.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ut.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ut.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ut.extra_lbits,257,286,p),ft.static_d_desc=new ft(ft.static_dtree,ut.extra_dbits,0,30,p),ft.static_bl_desc=new ft(null,ut.extra_blbits,0,19,7);function n(t,e,n,r,i){var o=this;o.good_length=t,o.max_lazy=e,o.nice_length=n,o.max_chain=r,o.func=i}var dt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],pt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""],gt=262;function mt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var c,l,h,u,f,d,p,g,i,m,y,w,v,a,b,x,S,k,_,C,I,A,T,F,q,E,P,O,B,j,s,R,D,M,z,N,L,o,U,H,W,V=this,G=new ut,Y=new ut,X=new ut;function J(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)R[2*t]=0;for(t=0;t<19;t++)D[2*t]=0;s[512]=1,V.opt_len=V.static_len=0,N=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<c?D[2*r]+=a:0!==r?(r!=i&&D[2*r]++,D[32]++):a<=10?D[34]++:D[36]++,i=r,(a=0)===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4))}function Q(t){V.pending_buf[V.pending++]=t}function Z(t){Q(255&t),Q(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Z(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<c)for(;tt(r,D),0!=--a;);else 0!==r?(r!=i&&(tt(r,D),a--),tt(16,D),$(a-3,2)):a<=10?(tt(17,D),$(a-3,3)):(tt(18,D),$(a-11,7));i=r,(a=0)===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4)}}function nt(){16==W?(Z(H),W=H=0):8<=W&&(Q(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(V.pending_buf[L+2*N]=t>>>8&255,V.pending_buf[L+2*N+1]=255&t,V.pending_buf[M+N]=255&e,N++,0===t?s[2*e]++:(o++,t--,s[2*(ut._length_code[e]+256+1)]++,R[2*ut.d_code(t)]++),0==(8191&N)&&2<P){for(n=8*N,r=I-S,i=0;i<30;i++)n+=R[2*i]*(5+ut.extra_dbits[i]);if(n>>>=3,o<Math.floor(N/2)&&n<Math.floor(r/2))return!0}return N==z-1}function it(t,e){var n,r,i,o,a=0;if(0!==N)for(;n=V.pending_buf[L+2*a]<<8&65280|255&V.pending_buf[L+2*a+1],r=255&V.pending_buf[M+a],a++,0===n?tt(r,t):(tt((i=ut._length_code[r])+256+1,t),0!==(o=ut.extra_lbits[i])&&$(r-=ut.base_length[i],o),tt(i=ut.d_code(--n),e),0!==(o=ut.extra_dbits[i])&&$(n-=ut.base_dist[i],o)),a<N;);tt(256,t),U=t[513]}function ot(){8<W?Z(H):0<W&&Q(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),U=8,o&&(Z(i),Z(~i)),V.pending_buf.set(g.subarray(r,r+i),V.pending),V.pending+=i}function e(t,e,n){var r,i,o=0;0<P?(G.build_tree(V),Y.build_tree(V),o=function(){var t;for(K(s,G.max_code),K(R,Y.max_code),X.build_tree(V),t=18;3<=t&&0===D[2*ut.bl_order[t]+1];t--);return V.opt_len+=3*(t+1)+5+5+4,t}(),r=V.opt_len+3+7>>>3,(i=V.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(D[2*ut.bl_order[r]+1],3);et(s,t-1),et(R,e-1)}(G.max_code+1,Y.max_code+1,o+1),it(s,R)),J(),n&&ot()}function st(t){e(0<=S?S:-1,I-S,t),S=I,c.flush_pending()}function ct(){var t,e,n,r;do{if(0===(r=i-T-I)&&0===I&&0===T)r=f;else if(-1==r)r--;else if(f+f-gt<=I){for(g.set(g.subarray(f,f+f),0),A-=f,I-=f,S-=f,n=t=v;e=65535&y[--n],y[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===c.avail_in)return;t=c.read_buf(g,I+T,r),3<=(T+=t)&&(w=((w=255&g[I])<<x^255&g[I+1])&b)}while(T<gt&&0!==c.avail_in)}function lt(t){var e,n,r=q,i=I,o=F,a=f-gt<I?I-(f-gt):0,s=j,c=p,l=I+258,h=g[i+o-1],u=g[i+o];B<=F&&(r>>=2),T<s&&(s=T);do{if(g[(e=t)+o]==u&&g[e+o-1]==h&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<l);if(n=258-(l-i),i=l-258,o<n){if(A=t,s<=(o=n))break;h=g[i+o-1],u=g[i+o]}}}while((t=65535&m[t&c])>a&&0!=--r);return o<=T?o:T}function ht(t){return t.total_in=t.total_out=0,t.msg=null,V.pending=0,V.pending_out=0,l=113,u=0,G.dyn_tree=s,G.stat_desc=ft.static_l_desc,Y.dyn_tree=R,Y.stat_desc=ft.static_d_desc,X.dyn_tree=D,X.stat_desc=ft.static_bl_desc,W=H=0,U=8,J(),function(){var t;for(i=2*f,t=y[v-1]=0;t<v-1;t++)y[t]=0;E=dt[P].max_lazy,B=dt[P].good_length,j=dt[P].nice_length,q=dt[P].max_chain,k=F=2,w=C=T=S=I=0}(),0}V.depth=[],V.bl_count=[],V.heap=[],s=[],R=[],D=[],V.pqdownheap=function(t,e){for(var n=V.heap,r=n[e],i=e<<1;i<=V.heap_len&&(i<V.heap_len&&mt(t,n[i+1],n[i],V.depth)&&i++,!mt(t,r,n[i],V.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},V.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=V,p=(f=1<<(d=n))-1,b=(v=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],y=[],z=1<<i+6,V.pending_buf=new Uint8Array(4*z),h=4*z,L=Math.floor(z/2),M=3*z,P=e,O=o,ht(t))},V.deflateEnd=function(){return 42!=l&&113!=l&&666!=l?-2:(V.pending_buf=null,g=m=y=null,V.dstate=null,113==l?-3:0)},V.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(dt[P].func!=dt[e].func&&0!==t.total_in&&(r=t.deflate(1)),P!=e&&(E=dt[P=e].max_lazy,B=dt[P].good_length,j=dt[P].nice_length,q=dt[P].max_chain),O=n,r)},V.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=l)return-2;if(i<3)return 0;for(f-gt<i&&(o=n-(i=f-gt)),g.set(e.subarray(o,o+i),0),S=I=i,w=((w=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)w=(w<<x^255&g[r+2])&b,m[r&p]=y[w],y[w]=r;return 0},V.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==l&&4!=e)return t.msg=pt[4],-2;if(0===t.avail_out)return t.msg=pt[7],-5;if(c=t,o=u,u=e,42==l&&(r=8+(d-8<<4)<<8,3<(i=(P-1&255)>>1)&&(i=3),r|=i<<6,0!==I&&(r|=32),l=113,Q((s=r+=31-r%31)>>8&255),Q(255&s)),0!==V.pending){if(c.flush_pending(),0===c.avail_out)return u=-1,0}else if(0===c.avail_in&&e<=o&&4!=e)return c.msg=pt[7],-5;if(666==l&&0!==c.avail_in)return t.msg=pt[7],-5;if(0!==c.avail_in||0!==T||0!=e&&666!=l){switch(a=-1,dt[P].func){case 0:a=function(t){var e,n=65535;for(h-5<n&&(n=h-5);;){if(T<=1){if(ct(),0===T&&0==t)return 0;if(0===T)break}if(I+=T,e=S+n,((T=0)===I||e<=I)&&(T=I-e,I=e,st(!1),0===c.avail_out))return 0;if(f-gt<=I-S&&(st(!1),0===c.avail_out))return 0}return st(4==t),0===c.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(T<gt){if(ct(),T<gt&&0==t)return 0;if(0===T)break}if(3<=T&&(w=(w<<x^255&g[I+2])&b,n=65535&y[w],m[I&p]=y[w],y[w]=I),0!==n&&(I-n&65535)<=f-gt&&2!=O&&(k=lt(n)),3<=k)if(e=rt(I-A,k-3),T-=k,k<=E&&3<=T){for(k--;w=(w<<x^255&g[++I+2])&b,n=65535&y[w],m[I&p]=y[w],y[w]=I,0!=--k;);I++}else I+=k,k=0,w=((w=255&g[I])<<x^255&g[I+1])&b;else e=rt(0,255&g[I]),T--,I++;if(e&&(st(!1),0===c.avail_out))return 0}return st(4==t),0===c.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(T<gt){if(ct(),T<gt&&0==t)return 0;if(0===T)break}if(3<=T&&(w=(w<<x^255&g[I+2])&b,r=65535&y[w],m[I&p]=y[w],y[w]=I),F=k,_=A,k=2,0!==r&&F<E&&(I-r&65535)<=f-gt&&(2!=O&&(k=lt(r)),k<=5&&(1==O||3==k&&4096<I-A)&&(k=2)),3<=F&&k<=F){for(n=I+T-3,e=rt(I-1-_,F-3),T-=F-1,F-=2;++I<=n&&(w=(w<<x^255&g[I+2])&b,r=65535&y[w],m[I&p]=y[w],y[w]=I),0!=--F;);if(C=0,k=2,I++,e&&(st(!1),0===c.avail_out))return 0}else if(0!==C){if((e=rt(0,255&g[I-1]))&&st(!1),I++,T--,0===c.avail_out)return 0}else C=1,I++,T--}return 0!==C&&(e=rt(0,255&g[I-1]),C=0),st(4==t),0===c.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(l=666),0==a||2==a)return 0===c.avail_out&&(u=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+U+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),U=7;else if(at(0,0,!1),3==e)for(n=0;n<v;n++)y[n]=0;if(c.flush_pending(),0===c.avail_out)return u=-1,0}}return 4!=e?0:1}}function i(){var t=this;t.next_in_index=0,t.next_out_index=0,t.avail_in=0,t.total_in=0,t.avail_out=0,t.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=p),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this,i=r.avail_in;return n<i&&(i=n),0===i?0:(r.avail_in-=i,t.set(r.next_in.subarray(r.next_in_index,r.next_in_index+i),e),r.next_in_index+=i,r.total_in+=i,i)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,c=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=c,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(c)):r.push(new Uint8Array(c.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(c.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
	/**
	   * CssColors
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	var ut,ft,dt={};dt._colorsTable={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4","indianred ":"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgrey:"#d3d3d3",lightgreen:"#90ee90",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370d8",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#d87093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"},dt.colorNameToHex=function(t){return t=t.toLowerCase(),void 0!==this._colorsTable[t]&&this._colorsTable[t]},function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.html2canvas=t()}}(function(){return function o(a,s,c){function l(n,t){if(!s[n]){if(!a[n]){var e="function"==typeof require&&require;if(!t&&e)return require(n,!0);if(h)return h(n,!0);var r=new Error("Cannot find module '"+n+"'");throw r.code="MODULE_NOT_FOUND",r}var i=s[n]={exports:{}};a[n][0].call(i.exports,function(t){var e=a[n][1][t];return l(e||t)},i,i.exports,o,a,s,c)}return s[n].exports}for(var h="function"==typeof require&&require,t=0;t<c.length;t++)l(c[t]);return l}({1:[function(t,P,O){(function(E){!function(t){var e="object"==typeof O&&O,n="object"==typeof P&&P&&P.exports==e&&P,r="object"==typeof E&&E;r.global!==r&&r.window!==r||(t=r);var i,o,y=2147483647,w=36,v=1,b=26,a=38,s=700,x=72,S=128,k="-",c=/^xn--/,l=/[^ -~]/,h=/\x2E|\u3002|\uFF0E|\uFF61/g,u={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},f=w-v,_=Math.floor,C=String.fromCharCode;function I(t){throw RangeError(u[t])}function d(t,e){for(var n=t.length;n--;)t[n]=e(t[n]);return t}function p(t,e){return d(t.split(h),e).join(".")}function A(t){for(var e,n,r=[],i=0,o=t.length;i<o;)55296<=(e=t.charCodeAt(i++))&&e<=56319&&i<o?56320==(64512&(n=t.charCodeAt(i++)))?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--):r.push(e);return r}function T(t){return d(t,function(t){var e="";return 65535<t&&(e+=C((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=C(t)}).join("")}function F(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function q(t,e,n){var r=0;for(t=n?_(t/s):t>>1,t+=_(t/e);f*b>>1<t;r+=w)t=_(t/f);return _(r+(f+1)*t/(t+a))}function g(t){var e,n,r,i,o,a,s,c,l,h,u,f=[],d=t.length,p=0,g=S,m=x;for((n=t.lastIndexOf(k))<0&&(n=0),r=0;r<n;++r)128<=t.charCodeAt(r)&&I("not-basic"),f.push(t.charCodeAt(r));for(i=0<n?n+1:0;i<d;){for(o=p,a=1,s=w;d<=i&&I("invalid-input"),u=t.charCodeAt(i++),(w<=(c=u-48<10?u-22:u-65<26?u-65:u-97<26?u-97:w)||c>_((y-p)/a))&&I("overflow"),p+=c*a,!(c<(l=s<=m?v:m+b<=s?b:s-m));s+=w)a>_(y/(h=w-l))&&I("overflow"),a*=h;m=q(p-o,e=f.length+1,0==o),_(p/e)>y-g&&I("overflow"),g+=_(p/e),p%=e,f.splice(p++,0,g)}return T(f)}function m(t){var e,n,r,i,o,a,s,c,l,h,u,f,d,p,g,m=[];for(f=(t=A(t)).length,e=S,o=x,a=n=0;a<f;++a)(u=t[a])<128&&m.push(C(u));for(r=i=m.length,i&&m.push(k);r<f;){for(s=y,a=0;a<f;++a)e<=(u=t[a])&&u<s&&(s=u);for(s-e>_((y-n)/(d=r+1))&&I("overflow"),n+=(s-e)*d,e=s,a=0;a<f;++a)if((u=t[a])<e&&++n>y&&I("overflow"),u==e){for(c=n,l=w;!(c<(h=l<=o?v:o+b<=l?b:l-o));l+=w)g=c-h,p=w-h,m.push(C(F(h+g%p,0))),c=_(g/p);m.push(C(F(c,0))),o=q(n,d,r==i),n=0,++r}++n,++e}return m.join("")}if(i={version:"1.2.4",ucs2:{decode:A,encode:T},decode:g,encode:m,toASCII:function(t){return p(t,function(t){return l.test(t)?"xn--"+m(t):t})},toUnicode:function(t){return p(t,function(t){return c.test(t)?g(t.slice(4).toLowerCase()):t})}},e&&!e.nodeType)if(n)n.exports=i;else for(o in i)i.hasOwnProperty(o)&&(e[o]=i[o]);else t.punycode=i}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],2:[function(t,e,n){var i=t("./log");function u(t,e){for(var n=3===t.nodeType?document.createTextNode(t.nodeValue):t.cloneNode(!1),r=t.firstChild;r;)!0!==e&&1===r.nodeType&&"SCRIPT"===r.nodeName||n.appendChild(u(r,e)),r=r.nextSibling;return 1===t.nodeType&&(n._scrollTop=t.scrollTop,n._scrollLeft=t.scrollLeft,"CANVAS"===t.nodeName?function(e,t){try{t&&(t.width=e.width,t.height=e.height,t.getContext("2d").putImageData(e.getContext("2d").getImageData(0,0,e.width,e.height),0,0))}catch(t){i("Unable to copy canvas content from",e,t)}}(t,n):"TEXTAREA"!==t.nodeName&&"SELECT"!==t.nodeName||(n.value=t.value)),n}e.exports=function(o,t,e,n,a,s,c){var l=u(o.documentElement,a.javascriptEnabled),h=t.createElement("iframe");return h.className="html2canvas-container",h.style.visibility="hidden",h.style.position="fixed",h.style.left="-10000px",h.style.top="0px",h.style.border="0",h.width=e,h.height=n,h.scrolling="no",t.body.appendChild(h),new Promise(function(e){var t,n,r,i=h.contentWindow.document;h.contentWindow.onload=h.onload=function(){var t=setInterval(function(){0<i.body.childNodes.length&&(!function t(e){if(1===e.nodeType){e.scrollTop=e._scrollTop,e.scrollLeft=e._scrollLeft;for(var n=e.firstChild;n;)t(n),n=n.nextSibling}}(i.documentElement),clearInterval(t),"view"===a.type&&(h.contentWindow.scrollTo(s,c),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||h.contentWindow.scrollY===c&&h.contentWindow.scrollX===s||(i.documentElement.style.top=-c+"px",i.documentElement.style.left=-s+"px",i.documentElement.style.position="absolute")),e(h))},50)},i.open(),i.write("<!DOCTYPE html><html></html>"),n=s,r=c,!(t=o).defaultView||n===t.defaultView.pageXOffset&&r===t.defaultView.pageYOffset||t.defaultView.scrollTo(n,r),i.replaceChild(i.adoptNode(l),i.documentElement),i.close()})}},{"./log":13}],3:[function(t,e,n){function r(t){this.r=0,this.g=0,this.b=0,this.a=null;this.fromArray(t)||this.namedColor(t)||this.rgb(t)||this.rgba(t)||this.hex6(t)||this.hex3(t)}r.prototype.darken=function(t){var e=1-t;return new r([Math.round(this.r*e),Math.round(this.g*e),Math.round(this.b*e),this.a])},r.prototype.isTransparent=function(){return 0===this.a},r.prototype.isBlack=function(){return 0===this.r&&0===this.g&&0===this.b},r.prototype.fromArray=function(t){return Array.isArray(t)&&(this.r=Math.min(t[0],255),this.g=Math.min(t[1],255),this.b=Math.min(t[2],255),3<t.length&&(this.a=t[3])),Array.isArray(t)};var i=/^#([a-f0-9]{3})$/i;r.prototype.hex3=function(t){var e;return null!==(e=t.match(i))&&(this.r=parseInt(e[1][0]+e[1][0],16),this.g=parseInt(e[1][1]+e[1][1],16),this.b=parseInt(e[1][2]+e[1][2],16)),null!==e};var o=/^#([a-f0-9]{6})$/i;r.prototype.hex6=function(t){var e=null;return null!==(e=t.match(o))&&(this.r=parseInt(e[1].substring(0,2),16),this.g=parseInt(e[1].substring(2,4),16),this.b=parseInt(e[1].substring(4,6),16)),null!==e};var a=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;r.prototype.rgb=function(t){var e;return null!==(e=t.match(a))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3])),null!==e};var s=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;r.prototype.rgba=function(t){var e;return null!==(e=t.match(s))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3]),this.a=Number(e[4])),null!==e},r.prototype.toString=function(){return null!==this.a&&1!==this.a?"rgba("+[this.r,this.g,this.b,this.a].join(",")+")":"rgb("+[this.r,this.g,this.b].join(",")+")"},r.prototype.namedColor=function(t){t=t.toLowerCase();var e=c[t];if(e)this.r=e[0],this.g=e[1],this.b=e[2];else if("transparent"===t)return this.r=this.g=this.b=this.a=0,!0;return!!e},r.prototype.isColor=!0;var c={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]};e.exports=r},{}],4:[function(t,e,n){var p=t("./support"),d=t("./renderers/canvas"),g=t("./imageloader"),m=t("./nodeparser"),r=t("./nodecontainer"),y=t("./log"),i=t("./utils"),w=t("./clone"),v=t("./proxy").loadUrlDocument,b=i.getBounds,x="data-html2canvas-node",S=0;function o(t,e){var n,r,i=S++;if((e=e||{}).logging&&(y.options.logging=!0,y.options.start=Date.now()),e.async=void 0===e.async||e.async,e.allowTaint=void 0!==e.allowTaint&&e.allowTaint,e.removeContainer=void 0===e.removeContainer||e.removeContainer,e.javascriptEnabled=void 0!==e.javascriptEnabled&&e.javascriptEnabled,e.imageTimeout=void 0===e.imageTimeout?1e4:e.imageTimeout,e.renderer="function"==typeof e.renderer?e.renderer:d,e.strict=!!e.strict,"string"==typeof t){if("string"!=typeof e.proxy)return Promise.reject("Proxy must be used when rendering url");var o=null!=e.width?e.width:window.innerWidth,a=null!=e.height?e.height:window.innerHeight;return v((n=t,r=document.createElement("a"),r.href=n,r.href=r.href,r),e.proxy,document,o,a,e).then(function(t){return k(t.contentWindow.document.documentElement,t,e,o,a)})}var s,c,l,h,u,f=(void 0===t?[document.documentElement]:t.length?t:[t])[0];return f.setAttribute(x+i,i),(s=f.ownerDocument,c=e,l=f.ownerDocument.defaultView.innerWidth,h=f.ownerDocument.defaultView.innerHeight,u=i,w(s,s,l,h,c,s.defaultView.pageXOffset,s.defaultView.pageYOffset).then(function(t){y("Document cloned");var e=x+u,n="["+e+"='"+u+"']";s.querySelector(n).removeAttribute(e);var r=t.contentWindow,i=r.document.querySelector(n),o="function"==typeof c.onclone?Promise.resolve(c.onclone(r.document)):Promise.resolve(!0);return o.then(function(){return k(i,t,c,l,h)})})).then(function(t){return"function"==typeof e.onrendered&&(y("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"),e.onrendered(t)),t})}o.CanvasRenderer=d,o.NodeContainer=r,o.log=y,o.utils=i;var a="undefined"==typeof document||"function"!=typeof Object.create||"function"!=typeof document.createElement("canvas").getContext?function(){return Promise.reject("No canvas support")}:o;function k(n,r,i,t,e){var o,a,s=r.contentWindow,c=new p(s.document),l=new g(i,c),h=b(n),u="view"===i.type?t:(o=s.document,Math.max(Math.max(o.body.scrollWidth,o.documentElement.scrollWidth),Math.max(o.body.offsetWidth,o.documentElement.offsetWidth),Math.max(o.body.clientWidth,o.documentElement.clientWidth))),f="view"===i.type?e:(a=s.document,Math.max(Math.max(a.body.scrollHeight,a.documentElement.scrollHeight),Math.max(a.body.offsetHeight,a.documentElement.offsetHeight),Math.max(a.body.clientHeight,a.documentElement.clientHeight))),d=new i.renderer(u,f,l,i,document);return new m(n,d,c,l,i).ready.then(function(){var t,e;return y("Finished rendering"),t="view"===i.type?_(d.canvas,{width:d.canvas.width,height:d.canvas.height,top:0,left:0,x:0,y:0}):n===s.document.body||n===s.document.documentElement||null!=i.canvas?d.canvas:_(d.canvas,{width:null!=i.width?i.width:h.width,height:null!=i.height?i.height:h.height,top:h.top,left:h.left,x:0,y:0}),e=r,i.removeContainer&&(e.parentNode.removeChild(e),y("Cleaned up container")),t})}function _(t,e){var n=document.createElement("canvas"),r=Math.min(t.width-1,Math.max(0,e.left)),i=Math.min(t.width,Math.max(1,e.left+e.width)),o=Math.min(t.height-1,Math.max(0,e.top)),a=Math.min(t.height,Math.max(1,e.top+e.height));n.width=e.width,n.height=e.height;var s=i-r,c=a-o;return y("Cropping canvas at:","left:",e.left,"top:",e.top,"width:",s,"height:",c),y("Resulting crop with width",e.width,"and height",e.height,"with x",r,"and y",o),n.getContext("2d").drawImage(t,r,o,s,c,e.x,e.y,s,c),n}e.exports=a},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(t,e,n){var r=t("./log"),i=t("./utils").smallImage;e.exports=function t(e){if(this.src=e,r("DummyImageContainer for",e),!this.promise||!this.image){r("Initiating DummyImageContainer"),t.prototype.image=new Image;var n=this.image;t.prototype.promise=new Promise(function(t,e){n.onload=t,n.onerror=e,n.src=i(),!0===n.complete&&t(n)})}}},{"./log":13,"./utils":26}],6:[function(t,e,n){var c=t("./utils").smallImage;e.exports=function(t,e){var n,r,i=document.createElement("div"),o=document.createElement("img"),a=document.createElement("span"),s="Hidden Text";i.style.visibility="hidden",i.style.fontFamily=t,i.style.fontSize=e,i.style.margin=0,i.style.padding=0,document.body.appendChild(i),o.src=c(),o.width=1,o.height=1,o.style.margin=0,o.style.padding=0,o.style.verticalAlign="baseline",a.style.fontFamily=t,a.style.fontSize=e,a.style.margin=0,a.style.padding=0,a.appendChild(document.createTextNode(s)),i.appendChild(a),i.appendChild(o),n=o.offsetTop-a.offsetTop+1,i.removeChild(a),i.appendChild(document.createTextNode(s)),i.style.lineHeight="normal",o.style.verticalAlign="super",r=o.offsetTop-i.offsetTop+1,document.body.removeChild(i),this.baseline=n,this.lineWidth=1,this.middle=r}},{"./utils":26}],7:[function(t,e,n){var r=t("./font");function i(){this.data={}}i.prototype.getMetrics=function(t,e){return void 0===this.data[t+"-"+e]&&(this.data[t+"-"+e]=new r(t,e)),this.data[t+"-"+e]},e.exports=i},{"./font":6}],8:[function(o,t,e){var a=o("./utils").getBounds,i=o("./proxy").loadUrlDocument;function n(e,t,n){this.image=null,this.src=e;var r=this,i=a(e);this.promise=(t?new Promise(function(t){"about:blank"===e.contentWindow.document.URL||null==e.contentWindow.document.documentElement?e.contentWindow.onload=e.onload=function(){t(e)}:t(e)}):this.proxyLoad(n.proxy,i,n)).then(function(t){return o("./core")(t.contentWindow.document.documentElement,{type:"view",width:t.width,height:t.height,proxy:n.proxy,javascriptEnabled:n.javascriptEnabled,removeContainer:n.removeContainer,allowTaint:n.allowTaint,imageTimeout:n.imageTimeout/2})}).then(function(t){return r.image=t})}n.prototype.proxyLoad=function(t,e,n){var r=this.src;return i(r.src,t,r.ownerDocument,e.width,e.height,n)},t.exports=n},{"./core":4,"./proxy":16,"./utils":26}],9:[function(t,e,n){function r(t){this.src=t.value,this.colorStops=[],this.type=null,this.x0=.5,this.y0=.5,this.x1=.5,this.y1=.5,this.promise=Promise.resolve(!0)}r.TYPES={LINEAR:1,RADIAL:2},r.REGEXP_COLORSTOP=/^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i,e.exports=r},{}],10:[function(t,e,n){e.exports=function(n,r){this.src=n,this.image=new Image;var i=this;this.tainted=null,this.promise=new Promise(function(t,e){i.image.onload=t,i.image.onerror=e,r&&(i.image.crossOrigin="anonymous"),i.image.src=n,!0===i.image.complete&&t(i.image)})}},{}],11:[function(t,e,n){var o=t("./log"),r=t("./imagecontainer"),i=t("./dummyimagecontainer"),a=t("./proxyimagecontainer"),s=t("./framecontainer"),c=t("./svgcontainer"),l=t("./svgnodecontainer"),h=t("./lineargradientcontainer"),u=t("./webkitgradientcontainer"),f=t("./utils").bind;function d(t,e){this.link=null,this.options=t,this.support=e,this.origin=this.getOrigin(window.location.href)}d.prototype.findImages=function(t){var e=[];return t.reduce(function(t,e){switch(e.node.nodeName){case"IMG":return t.concat([{args:[e.node.src],method:"url"}]);case"svg":case"IFRAME":return t.concat([{args:[e.node],method:e.node.nodeName}])}return t},[]).forEach(this.addImage(e,this.loadImage),this),e},d.prototype.findBackgroundImage=function(t,e){return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t,this.loadImage),this),t},d.prototype.addImage=function(n,r){return function(e){e.args.forEach(function(t){this.imageExists(n,t)||(n.splice(0,0,r.call(this,e)),o("Added image #"+n.length,"string"==typeof t?t.substring(0,100):t))},this)}},d.prototype.hasImageBackground=function(t){return"none"!==t.method},d.prototype.loadImage=function(t){if("url"===t.method){var e=t.args[0];return!this.isSVG(e)||this.support.svg||this.options.allowTaint?e.match(/data:image\/.*;base64,/i)?new r(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi,""),!1):this.isSameOrigin(e)||!0===this.options.allowTaint||this.isSVG(e)?new r(e,!1):this.support.cors&&!this.options.allowTaint&&this.options.useCORS?new r(e,!0):this.options.proxy?new a(e,this.options.proxy):new i(e):new c(e)}return"linear-gradient"===t.method?new h(t):"gradient"===t.method?new u(t):"svg"===t.method?new l(t.args[0],this.support.svg):"IFRAME"===t.method?new s(t.args[0],this.isSameOrigin(t.args[0].src),this.options):new i(t)},d.prototype.isSVG=function(t){return"svg"===t.substring(t.length-3).toLowerCase()||c.prototype.isInline(t)},d.prototype.imageExists=function(t,e){return t.some(function(t){return t.src===e})},d.prototype.isSameOrigin=function(t){return this.getOrigin(t)===this.origin},d.prototype.getOrigin=function(t){var e=this.link||(this.link=document.createElement("a"));return e.href=t,e.href=e.href,e.protocol+e.hostname+e.port},d.prototype.getPromise=function(e){return this.timeout(e,this.options.imageTimeout).catch(function(){return new i(e.src).promise.then(function(t){e.image=t})})},d.prototype.get=function(e){var n=null;return this.images.some(function(t){return(n=t).src===e})?n:null},d.prototype.fetch=function(t){return this.images=t.reduce(f(this.findBackgroundImage,this),this.findImages(t)),this.images.forEach(function(e,n){e.promise.then(function(){o("Succesfully loaded image #"+(n+1),e)},function(t){o("Failed loading image #"+(n+1),e,t)})}),this.ready=Promise.all(this.images.map(this.getPromise,this)),o("Finished searching images"),this},d.prototype.timeout=function(n,r){var i,t=Promise.race([n.promise,new Promise(function(t,e){i=setTimeout(function(){o("Timed out loading image",n),e(n)},r)})]).then(function(t){return clearTimeout(i),t});return t.catch(function(){clearTimeout(i)}),t},e.exports=d},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(t,e,n){var i=t("./gradientcontainer"),o=t("./color");function r(t){i.apply(this,arguments),this.type=i.TYPES.LINEAR;var e=r.REGEXP_DIRECTION.test(t.args[0])||!i.REGEXP_COLORSTOP.test(t.args[0]);e?t.args[0].split(/\s+/).reverse().forEach(function(t,e){switch(t){case"left":this.x0=0,this.x1=1;break;case"top":this.y0=0,this.y1=1;break;case"right":this.x0=1,this.x1=0;break;case"bottom":this.y0=1,this.y1=0;break;case"to":var n=this.y0,r=this.x0;this.y0=this.y1,this.x0=this.x1,this.x1=r,this.y1=n;break;case"center":break;default:var i=.01*parseFloat(t,10);if(isNaN(i))break;0===e?(this.y0=i,this.y1=1-this.y0):(this.x0=i,this.x1=1-this.x0)}},this):(this.y0=0,this.y1=1),this.colorStops=t.args.slice(e?1:0).map(function(t){var e=t.match(i.REGEXP_COLORSTOP),n=+e[2],r=0===n?"%":e[3];return{color:new o(e[1]),stop:"%"===r?n/100:null}}),null===this.colorStops[0].stop&&(this.colorStops[0].stop=0),null===this.colorStops[this.colorStops.length-1].stop&&(this.colorStops[this.colorStops.length-1].stop=1),this.colorStops.forEach(function(n,r){null===n.stop&&this.colorStops.slice(r).some(function(t,e){return null!==t.stop&&(n.stop=(t.stop-this.colorStops[r-1].stop)/(e+1)+this.colorStops[r-1].stop,!0)},this)},this)}r.prototype=Object.create(i.prototype),r.REGEXP_DIRECTION=/^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i,e.exports=r},{"./color":3,"./gradientcontainer":9}],13:[function(t,e,n){var r=function(){r.options.logging&&window.console&&window.console.log&&Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now()-r.options.start+"ms","html2canvas:"].concat([].slice.call(arguments,0)))};r.options={logging:!1},e.exports=r},{}],14:[function(t,e,n){var o=t("./color"),r=t("./utils"),i=r.getBounds,a=r.parseBackgrounds,s=r.offsetBounds;function c(t,e){this.node=t,this.parent=e,this.stack=null,this.bounds=null,this.borders=null,this.clip=[],this.backgroundClip=[],this.offsetBounds=null,this.visible=null,this.computedStyles=null,this.colors={},this.styles={},this.backgroundImages=null,this.transformData=null,this.transformMatrix=null,this.isPseudoElement=!1,this.opacity=null}function l(t){return-1!==t.toString().indexOf("%")}function h(t){return t.replace("px","")}function u(t){return parseFloat(t)}c.prototype.cloneTo=function(t){t.visible=this.visible,t.borders=this.borders,t.bounds=this.bounds,t.clip=this.clip,t.backgroundClip=this.backgroundClip,t.computedStyles=this.computedStyles,t.styles=this.styles,t.backgroundImages=this.backgroundImages,t.opacity=this.opacity},c.prototype.getOpacity=function(){return null===this.opacity?this.opacity=this.cssFloat("opacity"):this.opacity},c.prototype.assignStack=function(t){(this.stack=t).children.push(this)},c.prototype.isElementVisible=function(){return this.node.nodeType===Node.TEXT_NODE?this.parent.visible:"none"!==this.css("display")&&"hidden"!==this.css("visibility")&&!this.node.hasAttribute("data-html2canvas-ignore")&&("INPUT"!==this.node.nodeName||"hidden"!==this.node.getAttribute("type"))},c.prototype.css=function(t){return this.computedStyles||(this.computedStyles=this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null)),this.styles[t]||(this.styles[t]=this.computedStyles[t])},c.prototype.prefixedCss=function(e){var n=this.css(e);return void 0===n&&["webkit","moz","ms","o"].some(function(t){return void 0!==(n=this.css(t+e.substr(0,1).toUpperCase()+e.substr(1)))},this),void 0===n?null:n},c.prototype.computedStyle=function(t){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,t)},c.prototype.cssInt=function(t){var e=parseInt(this.css(t),10);return isNaN(e)?0:e},c.prototype.color=function(t){return this.colors[t]||(this.colors[t]=new o(this.css(t)))},c.prototype.cssFloat=function(t){var e=parseFloat(this.css(t));return isNaN(e)?0:e},c.prototype.fontWeight=function(){var t=this.css("fontWeight");switch(parseInt(t,10)){case 401:t="bold";break;case 400:t="normal"}return t},c.prototype.parseClip=function(){var t=this.css("clip").match(this.CLIP);return t?{top:parseInt(t[1],10),right:parseInt(t[2],10),bottom:parseInt(t[3],10),left:parseInt(t[4],10)}:null},c.prototype.parseBackgroundImages=function(){return this.backgroundImages||(this.backgroundImages=a(this.css("backgroundImage")))},c.prototype.cssList=function(t,e){var n=(this.css(t)||"").split(",");return 1===(n=(n=n[e||0]||n[0]||"auto").trim().split(" ")).length&&(n=[n[0],l(n[0])?"auto":n[0]]),n},c.prototype.parseBackgroundSize=function(t,e,n){var r,i,o=this.cssList("backgroundSize",n);if(l(o[0]))r=t.width*parseFloat(o[0])/100;else{if(/contain|cover/.test(o[0])){var a=t.width/t.height,s=e.width/e.height;return a<s^"contain"===o[0]?{width:t.height*s,height:t.height}:{width:t.width,height:t.width/s}}r=parseInt(o[0],10)}return i="auto"===o[0]&&"auto"===o[1]?e.height:"auto"===o[1]?r/e.width*e.height:l(o[1])?t.height*parseFloat(o[1])/100:parseInt(o[1],10),"auto"===o[0]&&(r=i/e.height*e.width),{width:r,height:i}},c.prototype.parseBackgroundPosition=function(t,e,n,r){var i,o,a=this.cssList("backgroundPosition",n);return i=l(a[0])?(t.width-(r||e).width)*(parseFloat(a[0])/100):parseInt(a[0],10),o="auto"===a[1]?i/e.width*e.height:l(a[1])?(t.height-(r||e).height)*parseFloat(a[1])/100:parseInt(a[1],10),"auto"===a[0]&&(i=o/e.height*e.width),{left:i,top:o}},c.prototype.parseBackgroundRepeat=function(t){return this.cssList("backgroundRepeat",t)[0]},c.prototype.parseTextShadows=function(){var t=this.css("textShadow"),e=[];if(t&&"none"!==t)for(var n=t.match(this.TEXT_SHADOW_PROPERTY),r=0;n&&r<n.length;r++){var i=n[r].match(this.TEXT_SHADOW_VALUES);e.push({color:new o(i[0]),offsetX:i[1]?parseFloat(i[1].replace("px","")):0,offsetY:i[2]?parseFloat(i[2].replace("px","")):0,blur:i[3]?i[3].replace("px",""):0})}return e},c.prototype.parseTransform=function(){if(!this.transformData)if(this.hasTransform()){var t=this.parseBounds(),e=this.prefixedCss("transformOrigin").split(" ").map(h).map(u);e[0]+=t.left,e[1]+=t.top,this.transformData={origin:e,matrix:this.parseTransformMatrix()}}else this.transformData={origin:[0,0],matrix:[1,0,0,1,0,0]};return this.transformData},c.prototype.parseTransformMatrix=function(){if(!this.transformMatrix){var t=this.prefixedCss("transform"),e=t?function(t){{if(t&&"matrix"===t[1])return t[2].split(",").map(function(t){return parseFloat(t.trim())});if(t&&"matrix3d"===t[1]){var e=t[2].split(",").map(function(t){return parseFloat(t.trim())});return[e[0],e[1],e[4],e[5],e[12],e[13]]}}}(t.match(this.MATRIX_PROPERTY)):null;this.transformMatrix=e||[1,0,0,1,0,0]}return this.transformMatrix},c.prototype.parseBounds=function(){return this.bounds||(this.bounds=this.hasTransform()?s(this.node):i(this.node))},c.prototype.hasTransform=function(){return"1,0,0,1,0,0"!==this.parseTransformMatrix().join(",")||this.parent&&this.parent.hasTransform()},c.prototype.getValue=function(){var t,e,n=this.node.value||"";return"SELECT"===this.node.tagName?(t=this.node,n=(e=t.options[t.selectedIndex||0])&&e.text||""):"password"===this.node.type&&(n=Array(n.length+1).join("•")),0===n.length?this.node.placeholder||"":n},c.prototype.MATRIX_PROPERTY=/(matrix|matrix3d)\((.+)\)/,c.prototype.TEXT_SHADOW_PROPERTY=/((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g,c.prototype.TEXT_SHADOW_VALUES=/(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g,c.prototype.CLIP=/^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/,e.exports=c},{"./color":3,"./utils":26}],15:[function(t,e,n){var s=t("./log"),c=t("punycode"),l=t("./nodecontainer"),f=t("./textcontainer"),d=t("./pseudoelementcontainer"),h=t("./fontmetrics"),u=t("./color"),p=t("./stackingcontext"),r=t("./utils"),g=r.bind,a=r.getBounds,m=r.parseBackgrounds,y=r.offsetBounds;function i(t,e,n,r,i){s("Starting NodeParser"),this.renderer=e,this.options=i,this.range=null,this.support=n,this.renderQueue=[],this.stack=new p(!0,1,t.ownerDocument,null);var o=new l(t,null);if(i.background&&e.rectangle(0,0,e.width,e.height,new u(i.background)),t===t.ownerDocument.documentElement){var a=new l(o.color("backgroundColor").isTransparent()?t.ownerDocument.body:t.ownerDocument.documentElement,null);e.rectangle(0,0,e.width,e.height,a.color("backgroundColor"))}o.visibile=o.isElementVisible(),this.createPseudoHideStyles(t.ownerDocument),this.disableAnimations(t.ownerDocument),this.nodes=U([o].concat(this.getChildren(o)).filter(function(t){return t.visible=t.isElementVisible()}).map(this.getPseudoElements,this)),this.fontMetrics=new h,s("Fetched nodes, total:",this.nodes.length),s("Calculate overflow clips"),this.calculateOverflowClips(),s("Start fetching images"),this.images=r.fetch(this.nodes.filter(R)),this.ready=this.images.ready.then(g(function(){return s("Images loaded, starting parsing"),s("Creating stacking contexts"),this.createStackingContexts(),s("Sorting stacking contexts"),this.sortStackingContexts(this.stack),this.parse(this.stack),s("Render queue created with "+this.renderQueue.length+" items"),new Promise(g(function(t){i.async?"function"==typeof i.async?i.async.call(this,this.renderQueue,t):0<this.renderQueue.length?(this.renderIndex=0,this.asyncRenderer(this.renderQueue,t)):t():(this.renderQueue.forEach(this.paint,this),t())},this))},this))}function o(t){return t.parent&&t.parent.clip.length}function w(){}i.prototype.calculateOverflowClips=function(){this.nodes.forEach(function(t){if(R(t)){D(t)&&t.appendToDOM(),t.borders=this.parseBorders(t);var e="hidden"===t.css("overflow")?[t.borders.clip]:[],n=t.parseClip();n&&-1!==["absolute","fixed"].indexOf(t.css("position"))&&e.push([["rect",t.bounds.left+n.left,t.bounds.top+n.top,n.right-n.left,n.bottom-n.top]]),t.clip=o(t)?t.parent.clip.concat(e):e,t.backgroundClip="hidden"!==t.css("overflow")?t.clip.concat([t.borders.clip]):t.clip,D(t)&&t.cleanDOM()}else M(t)&&(t.clip=o(t)?t.parent.clip:[]);D(t)||(t.bounds=null)},this)},i.prototype.asyncRenderer=function(t,e,n){n=n||Date.now(),this.paint(t[this.renderIndex++]),t.length===this.renderIndex?e():n+20>Date.now()?this.asyncRenderer(t,e,n):setTimeout(g(function(){this.asyncRenderer(t,e)},this),0)},i.prototype.createPseudoHideStyles=function(t){this.createStyles(t,"."+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+':before { content: "" !important; display: none !important; }.'+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER+':after { content: "" !important; display: none !important; }')},i.prototype.disableAnimations=function(t){this.createStyles(t,"* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}")},i.prototype.createStyles=function(t,e){var n=t.createElement("style");n.innerHTML=e,t.body.appendChild(n)},i.prototype.getPseudoElements=function(t){var e=[[t]];if(t.node.nodeType===Node.ELEMENT_NODE){var n=this.getPseudoElement(t,":before"),r=this.getPseudoElement(t,":after");n&&e.push(n),r&&e.push(r)}return U(e)},i.prototype.getPseudoElement=function(t,e){var n=t.computedStyle(e);if(!n||!n.content||"none"===n.content||"-moz-alt-content"===n.content||"none"===n.display)return null;for(var r,i,o=(r=n.content,(i=r.substr(0,1))===r.substr(r.length-1)&&i.match(/'|"/)?r.substr(1,r.length-2):r),a="url"===o.substr(0,3),s=document.createElement(a?"img":"html2canvaspseudoelement"),c=new d(s,t,e),l=n.length-1;0<=l;l--){var h=n.item(l).replace(/(\-[a-z])/g,function(t){return t.toUpperCase().replace("-","")});s.style[h]=n[h]}if(s.className=d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+" "+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER,a)return s.src=m(o)[0].args[0],[c];var u=document.createTextNode(o);return s.appendChild(u),[c,new f(u,c)]},i.prototype.getChildren=function(n){return U([].filter.call(n.node.childNodes,P).map(function(t){var e=[t.nodeType===Node.TEXT_NODE?new f(t,n):new l(t,n)].filter(L);return t.nodeType===Node.ELEMENT_NODE&&e.length&&"TEXTAREA"!==t.tagName?e[0].isElementVisible()?e.concat(this.getChildren(e[0])):[]:e},this))},i.prototype.newStackingContext=function(t,e){var n=new p(e,t.getOpacity(),t.node,t.parent);t.cloneTo(n),(e?n.getParentStack(this):n.parent.stack).contexts.push(n),t.stack=n},i.prototype.createStackingContexts=function(){this.nodes.forEach(function(t){var e,n;R(t)&&(this.isRootElement(t)||t.getOpacity()<1||(n=(e=t).css("position"),"auto"!==(-1!==["absolute","relative","fixed"].indexOf(n)?e.css("zIndex"):"auto"))||this.isBodyWithTransparentRoot(t)||t.hasTransform())?this.newStackingContext(t,!0):R(t)&&(O(t)&&T(t)||-1!==["inline-block","inline-table"].indexOf(t.css("display"))||B(t))?this.newStackingContext(t,!1):t.assignStack(t.parent.stack)},this)},i.prototype.isBodyWithTransparentRoot=function(t){return"BODY"===t.node.nodeName&&t.parent.color("backgroundColor").isTransparent()},i.prototype.isRootElement=function(t){return null===t.parent},i.prototype.sortStackingContexts=function(t){var n;t.contexts.sort((n=t.contexts.slice(0),function(t,e){return t.cssInt("zIndex")+n.indexOf(t)/n.length-(e.cssInt("zIndex")+n.indexOf(e)/n.length)})),t.contexts.forEach(this.sortStackingContexts,this)},i.prototype.parseTextBounds=function(a){return function(t,e,n){if("none"!==a.parent.css("textDecoration").substr(0,4)||0!==t.trim().length){if(this.support.rangeBounds&&!a.parent.hasTransform()){var r=n.slice(0,e).join("").length;return this.getRangeBounds(a.node,r,t.length)}if(a.node&&"string"==typeof a.node.data){var i=a.node.splitText(t.length),o=this.getWrapperBounds(a.node,a.parent.hasTransform());return a.node=i,o}}else this.support.rangeBounds&&!a.parent.hasTransform()||(a.node=a.node.splitText(t.length));return{}}},i.prototype.getWrapperBounds=function(t,e){var n=t.ownerDocument.createElement("html2canvaswrapper"),r=t.parentNode,i=t.cloneNode(!0);n.appendChild(t.cloneNode(!0)),r.replaceChild(n,t);var o=e?y(n):a(n);return r.replaceChild(i,n),o},i.prototype.getRangeBounds=function(t,e,n){var r=this.range||(this.range=t.ownerDocument.createRange());return r.setStart(t,e),r.setEnd(t,e+n),r.getBoundingClientRect()},i.prototype.parse=function(t){var e=t.contexts.filter(I),n=t.children.filter(R),r=n.filter(j(B)),i=r.filter(j(O)).filter(j(F)),o=n.filter(j(O)).filter(B),a=r.filter(j(O)).filter(F),s=t.contexts.concat(r.filter(O)).filter(T),c=t.children.filter(M).filter(E),l=t.contexts.filter(A);e.concat(i).concat(o).concat(a).concat(s).concat(c).concat(l).forEach(function(t){this.renderQueue.push(t),q(t)&&(this.parse(t),this.renderQueue.push(new w))},this)},i.prototype.paint=function(t){try{t instanceof w?this.renderer.ctx.restore():M(t)?(D(t.parent)&&t.parent.appendToDOM(),this.paintText(t),D(t.parent)&&t.parent.cleanDOM()):this.paintNode(t)}catch(t){if(s(t),this.options.strict)throw t}},i.prototype.paintNode=function(t){q(t)&&(this.renderer.setOpacity(t.opacity),this.renderer.ctx.save(),t.hasTransform()&&this.renderer.setTransform(t.parseTransform())),"INPUT"===t.node.nodeName&&"checkbox"===t.node.type?this.paintCheckbox(t):"INPUT"===t.node.nodeName&&"radio"===t.node.type?this.paintRadio(t):this.paintElement(t)},i.prototype.paintElement=function(n){var r=n.parseBounds();this.renderer.clip(n.backgroundClip,function(){this.renderer.renderBackground(n,r,n.borders.borders.map(N))},this),this.renderer.clip(n.clip,function(){this.renderer.renderBorders(n.borders.borders)},this),this.renderer.clip(n.backgroundClip,function(){switch(n.node.nodeName){case"svg":case"IFRAME":var t=this.images.get(n.node);t?this.renderer.renderImage(n,r,n.borders,t):s("Error loading <"+n.node.nodeName+">",n.node);break;case"IMG":var e=this.images.get(n.node.src);e?this.renderer.renderImage(n,r,n.borders,e):s("Error loading <img>",n.node.src);break;case"CANVAS":this.renderer.renderImage(n,r,n.borders,{image:n.node});break;case"SELECT":case"INPUT":case"TEXTAREA":this.paintFormValue(n)}},this)},i.prototype.paintCheckbox=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height),r={width:n-1,height:n-1,top:e.top,left:e.left},i=[3,3],o=[i,i,i,i],a=[1,1,1,1].map(function(t){return{color:new u("#A5A5A5"),width:t}}),s=S(r,o,a);this.renderer.clip(t.backgroundClip,function(){this.renderer.rectangle(r.left+1,r.top+1,r.width-2,r.height-2,new u("#DEDEDE")),this.renderer.renderBorders(b(a,r,s,o)),t.node.checked&&(this.renderer.font(new u("#424242"),"normal","normal","bold",n-3+"px","arial"),this.renderer.text("✔",r.left+n/6,r.top+n-1))},this)},i.prototype.paintRadio=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height)-2;this.renderer.clip(t.backgroundClip,function(){this.renderer.circleStroke(e.left+1,e.top+1,n,new u("#DEDEDE"),1,new u("#A5A5A5")),t.node.checked&&this.renderer.circle(Math.ceil(e.left+n/4)+1,Math.ceil(e.top+n/4)+1,Math.floor(n/2),new u("#424242"))},this)},i.prototype.paintFormValue=function(e){var t=e.getValue();if(0<t.length){var n=e.node.ownerDocument,r=n.createElement("html2canvaswrapper");["lineHeight","textAlign","fontFamily","fontWeight","fontSize","color","paddingLeft","paddingTop","paddingRight","paddingBottom","width","height","borderLeftStyle","borderTopStyle","borderLeftWidth","borderTopWidth","boxSizing","whiteSpace","wordWrap"].forEach(function(t){try{r.style[t]=e.css(t)}catch(t){s("html2canvas: Parse: Exception caught in renderFormValue: "+t.message)}});var i=e.parseBounds();r.style.position="fixed",r.style.left=i.left+"px",r.style.top=i.top+"px",r.textContent=t,n.body.appendChild(r),this.paintText(new f(r.firstChild,e)),n.body.removeChild(r)}},i.prototype.paintText=function(n){n.applyTextTransform();var t,e=c.ucs2.decode(n.node.data),r=this.options.letterRendering&&!/^(normal|none|0px)$/.test(n.parent.css("letterSpacing"))||(t=n.node.data,/[^\u0000-\u00ff]/.test(t))?e.map(function(t){return c.ucs2.encode([t])}):function(t){var e,n=[],r=0,i=!1;for(;t.length;)o=t[r],-1!==[32,13,10,9,45].indexOf(o)===i?((e=t.splice(0,r)).length&&n.push(c.ucs2.encode(e)),i=!i,r=0):r++,r>=t.length&&(e=t.splice(0,r)).length&&n.push(c.ucs2.encode(e));var o;return n}(e),i=n.parent.fontWeight(),o=n.parent.css("fontSize"),a=n.parent.css("fontFamily"),s=n.parent.parseTextShadows();this.renderer.font(n.parent.color("color"),n.parent.css("fontStyle"),n.parent.css("fontVariant"),i,o,a),s.length?this.renderer.fontShadow(s[0].color,s[0].offsetX,s[0].offsetY,s[0].blur):this.renderer.clearShadow(),this.renderer.clip(n.parent.clip,function(){r.map(this.parseTextBounds(n),this).forEach(function(t,e){t&&(this.renderer.text(r[e],t.left,t.bottom),this.renderTextDecoration(n.parent,t,this.fontMetrics.getMetrics(a,o)))},this)},this)},i.prototype.renderTextDecoration=function(t,e,n){switch(t.css("textDecoration").split(" ")[0]){case"underline":this.renderer.rectangle(e.left,Math.round(e.top+n.baseline+n.lineWidth),e.width,1,t.color("color"));break;case"overline":this.renderer.rectangle(e.left,Math.round(e.top),e.width,1,t.color("color"));break;case"line-through":this.renderer.rectangle(e.left,Math.ceil(e.top+n.middle+n.lineWidth),e.width,1,t.color("color"))}};var v={inset:[["darken",.6],["darken",.1],["darken",.1],["darken",.6]]};function b(a,s,c,l){return a.map(function(t,e){if(0<t.width){var n=s.left,r=s.top,i=s.width,o=s.height-a[2].width;switch(e){case 0:o=a[0].width,t.args=_({c1:[n,r],c2:[n+i,r],c3:[n+i-a[1].width,r+o],c4:[n+a[3].width,r+o]},l[0],l[1],c.topLeftOuter,c.topLeftInner,c.topRightOuter,c.topRightInner);break;case 1:n=s.left+s.width-a[1].width,i=a[1].width,t.args=_({c1:[n+i,r],c2:[n+i,r+o+a[2].width],c3:[n,r+o],c4:[n,r+a[0].width]},l[1],l[2],c.topRightOuter,c.topRightInner,c.bottomRightOuter,c.bottomRightInner);break;case 2:r=r+s.height-a[2].width,o=a[2].width,t.args=_({c1:[n+i,r+o],c2:[n,r+o],c3:[n+a[3].width,r],c4:[n+i-a[3].width,r]},l[2],l[3],c.bottomRightOuter,c.bottomRightInner,c.bottomLeftOuter,c.bottomLeftInner);break;case 3:i=a[3].width,t.args=_({c1:[n,r+o+a[2].width],c2:[n,r],c3:[n+i,r+a[0].width],c4:[n+i,r+o]},l[3],l[0],c.bottomLeftOuter,c.bottomLeftInner,c.topLeftOuter,c.topLeftInner)}}return t})}function x(t,e,n,r){var i=(Math.sqrt(2)-1)/3*4,o=n*i,a=r*i,s=t+n,c=e+r;return{topLeft:k({x:t,y:c},{x:t,y:c-a},{x:s-o,y:e},{x:s,y:e}),topRight:k({x:t,y:e},{x:t+o,y:e},{x:s,y:c-a},{x:s,y:c}),bottomRight:k({x:s,y:e},{x:s,y:e+a},{x:t+o,y:c},{x:t,y:c}),bottomLeft:k({x:s,y:c},{x:s-o,y:c},{x:t,y:e+a},{x:t,y:e})}}function S(t,e,n){var r=t.left,i=t.top,o=t.width,a=t.height,s=e[0][0]<o/2?e[0][0]:o/2,c=e[0][1]<a/2?e[0][1]:a/2,l=e[1][0]<o/2?e[1][0]:o/2,h=e[1][1]<a/2?e[1][1]:a/2,u=e[2][0]<o/2?e[2][0]:o/2,f=e[2][1]<a/2?e[2][1]:a/2,d=e[3][0]<o/2?e[3][0]:o/2,p=e[3][1]<a/2?e[3][1]:a/2,g=o-l,m=a-f,y=o-u,w=a-p;return{topLeftOuter:x(r,i,s,c).topLeft.subdivide(.5),topLeftInner:x(r+n[3].width,i+n[0].width,Math.max(0,s-n[3].width),Math.max(0,c-n[0].width)).topLeft.subdivide(.5),topRightOuter:x(r+g,i,l,h).topRight.subdivide(.5),topRightInner:x(r+Math.min(g,o+n[3].width),i+n[0].width,g>o+n[3].width?0:l-n[3].width,h-n[0].width).topRight.subdivide(.5),bottomRightOuter:x(r+y,i+m,u,f).bottomRight.subdivide(.5),bottomRightInner:x(r+Math.min(y,o-n[3].width),i+Math.min(m,a+n[0].width),Math.max(0,u-n[1].width),f-n[2].width).bottomRight.subdivide(.5),bottomLeftOuter:x(r,i+w,d,p).bottomLeft.subdivide(.5),bottomLeftInner:x(r+n[3].width,i+w,Math.max(0,d-n[3].width),p-n[2].width).bottomLeft.subdivide(.5)}}function k(s,c,l,h){var u=function(t,e,n){return{x:t.x+(e.x-t.x)*n,y:t.y+(e.y-t.y)*n}};return{start:s,startControl:c,endControl:l,end:h,subdivide:function(t){var e=u(s,c,t),n=u(c,l,t),r=u(l,h,t),i=u(e,n,t),o=u(n,r,t),a=u(i,o,t);return[k(s,e,i,a),k(a,o,r,h)]},curveTo:function(t){t.push(["bezierCurve",c.x,c.y,l.x,l.y,h.x,h.y])},curveToReversed:function(t){t.push(["bezierCurve",l.x,l.y,c.x,c.y,s.x,s.y])}}}function _(t,e,n,r,i,o,a){var s=[];return 0<e[0]||0<e[1]?(s.push(["line",r[1].start.x,r[1].start.y]),r[1].curveTo(s)):s.push(["line",t.c1[0],t.c1[1]]),0<n[0]||0<n[1]?(s.push(["line",o[0].start.x,o[0].start.y]),o[0].curveTo(s),s.push(["line",a[0].end.x,a[0].end.y]),a[0].curveToReversed(s)):(s.push(["line",t.c2[0],t.c2[1]]),s.push(["line",t.c3[0],t.c3[1]])),0<e[0]||0<e[1]?(s.push(["line",i[1].end.x,i[1].end.y]),i[1].curveToReversed(s)):s.push(["line",t.c4[0],t.c4[1]]),s}function C(t,e,n,r,i,o,a){0<e[0]||0<e[1]?(t.push(["line",r[0].start.x,r[0].start.y]),r[0].curveTo(t),r[1].curveTo(t)):t.push(["line",o,a]),(0<n[0]||0<n[1])&&t.push(["line",i[0].start.x,i[0].start.y])}function I(t){return t.cssInt("zIndex")<0}function A(t){return 0<t.cssInt("zIndex")}function T(t){return 0===t.cssInt("zIndex")}function F(t){return-1!==["inline","inline-block","inline-table"].indexOf(t.css("display"))}function q(t){return t instanceof p}function E(t){return 0<t.node.data.trim().length}function P(t){return t.nodeType===Node.TEXT_NODE||t.nodeType===Node.ELEMENT_NODE}function O(t){return"static"!==t.css("position")}function B(t){return"none"!==t.css("float")}function j(t){var e=this;return function(){return!t.apply(e,arguments)}}function R(t){return t.node.nodeType===Node.ELEMENT_NODE}function D(t){return!0===t.isPseudoElement}function M(t){return t.node.nodeType===Node.TEXT_NODE}function z(t){return parseInt(t,10)}function N(t){return t.width}function L(t){return t.node.nodeType!==Node.ELEMENT_NODE||-1===["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(t.node.nodeName)}function U(t){return[].concat.apply([],t)}i.prototype.parseBorders=function(o){var r,t=o.parseBounds(),e=(r=o,["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(t){var e=r.css("border"+t+"Radius"),n=e.split(" ");return n.length<=1&&(n[1]=n[0]),n.map(z)})),n=["Top","Right","Bottom","Left"].map(function(t,e){var n=o.css("border"+t+"Style"),r=o.color("border"+t+"Color");"inset"===n&&r.isBlack()&&(r=new u([255,255,255,r.a]));var i=v[n]?v[n][e]:null;return{width:o.cssInt("border"+t+"Width"),color:i?r[i[0]](i[1]):r,args:null}}),i=S(t,e,n);return{clip:this.parseBackgroundClip(o,i,n,e,t),borders:b(n,t,i,e)}},i.prototype.parseBackgroundClip=function(t,e,n,r,i){var o=[];switch(t.css("backgroundClip")){case"content-box":case"padding-box":C(o,r[0],r[1],e.topLeftInner,e.topRightInner,i.left+n[3].width,i.top+n[0].width),C(o,r[1],r[2],e.topRightInner,e.bottomRightInner,i.left+i.width-n[1].width,i.top+n[0].width),C(o,r[2],r[3],e.bottomRightInner,e.bottomLeftInner,i.left+i.width-n[1].width,i.top+i.height-n[2].width),C(o,r[3],r[0],e.bottomLeftInner,e.topLeftInner,i.left+n[3].width,i.top+i.height-n[2].width);break;default:C(o,r[0],r[1],e.topLeftOuter,e.topRightOuter,i.left,i.top),C(o,r[1],r[2],e.topRightOuter,e.bottomRightOuter,i.left+i.width,i.top),C(o,r[2],r[3],e.bottomRightOuter,e.bottomLeftOuter,i.left+i.width,i.top+i.height),C(o,r[3],r[0],e.bottomLeftOuter,e.topLeftOuter,i.left,i.top+i.height)}return o},e.exports=i},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,punycode:1}],16:[function(t,e,n){var a=t("./xhr"),r=t("./utils"),s=t("./log"),c=t("./clone"),l=r.decode64;function h(t,e,n){var r="withCredentials"in new XMLHttpRequest;if(!e)return Promise.reject("No proxy configured");var i=f(r),o=d(e,t,i);return r?a(o):u(n,o,i).then(function(t){return l(t.content)})}var i=0;function u(i,o,a){return new Promise(function(e,n){var t=i.createElement("script"),r=function(){delete window.html2canvas.proxy[a],i.body.removeChild(t)};window.html2canvas.proxy[a]=function(t){r(),e(t)},t.src=o,t.onerror=function(t){r(),n(t)},i.body.appendChild(t)})}function f(t){return t?"":"html2canvas_"+Date.now()+"_"+ ++i+"_"+Math.round(1e5*Math.random())}function d(t,e,n){return t+"?url="+encodeURIComponent(e)+(n.length?"&callback=html2canvas.proxy."+n:"")}n.Proxy=h,n.ProxyURL=function(t,e,n){var r="crossOrigin"in new Image,i=f(r),o=d(e,t,i);return r?Promise.resolve(o):u(n,o,i).then(function(t){return"data:"+t.type+";base64,"+t.content})},n.loadUrlDocument=function(t,e,n,r,i,o){return new h(t,e,window.document).then((a=t,function(e){var n,t=new DOMParser;try{n=t.parseFromString(e,"text/html")}catch(t){s("DOMParser not supported, falling back to createHTMLDocument"),n=document.implementation.createHTMLDocument("");try{n.open(),n.write(e),n.close()}catch(t){s("createHTMLDocument write not supported, falling back to document.body.innerHTML"),n.body.innerHTML=e}}var r=n.querySelector("base");if(!r||!r.href.host){var i=n.createElement("base");i.href=a,n.head.insertBefore(i,n.head.firstChild)}return n})).then(function(t){return c(t,n,r,i,o,0,0)});var a}},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(t,e,n){var o=t("./proxy").ProxyURL;e.exports=function(n,r){var t=document.createElement("a");t.href=n,n=t.href,this.src=n,this.image=new Image;var i=this;this.promise=new Promise(function(t,e){i.image.crossOrigin="Anonymous",i.image.onload=t,i.image.onerror=e,new o(n,r,document).then(function(t){i.image.src=t}).catch(e)})}},{"./proxy":16}],18:[function(t,e,n){var r=t("./nodecontainer");function i(t,e,n){r.call(this,t,e),this.isPseudoElement=!0,this.before=":before"===n}i.prototype.cloneTo=function(t){i.prototype.cloneTo.call(this,t),t.isPseudoElement=!0,t.before=this.before},(i.prototype=Object.create(r.prototype)).appendToDOM=function(){this.before?this.parent.node.insertBefore(this.node,this.parent.node.firstChild):this.parent.node.appendChild(this.node),this.parent.node.className+=" "+this.getHideClass()},i.prototype.cleanDOM=function(){this.node.parentNode.removeChild(this.node),this.parent.node.className=this.parent.node.className.replace(this.getHideClass(),"")},i.prototype.getHideClass=function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_"+(this.before?"BEFORE":"AFTER")]},i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE="___html2canvas___pseudoelement_before",i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER="___html2canvas___pseudoelement_after",e.exports=i},{"./nodecontainer":14}],19:[function(t,e,n){var c=t("./log");function r(t,e,n,r,i){this.width=t,this.height=e,this.images=n,this.options=r,this.document=i}r.prototype.renderImage=function(t,e,n,r){var i=t.cssInt("paddingLeft"),o=t.cssInt("paddingTop"),a=t.cssInt("paddingRight"),s=t.cssInt("paddingBottom"),c=n.borders,l=e.width-(c[1].width+c[3].width+i+a),h=e.height-(c[0].width+c[2].width+o+s);this.drawImage(r,0,0,r.image.width||l,r.image.height||h,e.left+i+c[3].width,e.top+o+c[0].width,l,h)},r.prototype.renderBackground=function(t,e,n){0<e.height&&0<e.width&&(this.renderBackgroundColor(t,e),this.renderBackgroundImage(t,e,n))},r.prototype.renderBackgroundColor=function(t,e){var n=t.color("backgroundColor");n.isTransparent()||this.rectangle(e.left,e.top,e.width,e.height,n)},r.prototype.renderBorders=function(t){t.forEach(this.renderBorder,this)},r.prototype.renderBorder=function(t){t.color.isTransparent()||null===t.args||this.drawShape(t.args,t.color)},r.prototype.renderBackgroundImage=function(o,a,s){o.parseBackgroundImages().reverse().forEach(function(t,e,n){switch(t.method){case"url":var r=this.images.get(t.args[0]);r?this.renderBackgroundRepeating(o,a,r,n.length-(e+1),s):c("Error loading background-image",t.args[0]);break;case"linear-gradient":case"gradient":var i=this.images.get(t.value);i?this.renderBackgroundGradient(i,a,s):c("Error loading background-image",t.args[0]);break;case"none":break;default:c("Unknown background-image type",t.args[0])}},this)},r.prototype.renderBackgroundRepeating=function(t,e,n,r,i){var o=t.parseBackgroundSize(e,n.image,r),a=t.parseBackgroundPosition(e,n.image,r,o);switch(t.parseBackgroundRepeat(r)){case"repeat-x":case"repeat no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+i[3],e.top+a.top+i[0],99999,o.height,i);break;case"repeat-y":case"no-repeat repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+i[0],o.width,99999,i);break;case"no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+a.top+i[0],o.width,o.height,i);break;default:this.renderBackgroundRepeat(n,a,o,{top:e.top,left:e.left},i[3],i[0])}},e.exports=r},{"./log":13}],20:[function(t,e,n){var r=t("../renderer"),i=t("../lineargradientcontainer"),o=t("../log");function a(t,e){r.apply(this,arguments),this.canvas=this.options.canvas||this.document.createElement("canvas"),this.options.canvas||(this.canvas.width=t,this.canvas.height=e),this.ctx=this.canvas.getContext("2d"),this.taintCtx=this.document.createElement("canvas").getContext("2d"),this.ctx.textBaseline="bottom",this.variables={},o("Initialized CanvasRenderer with size",t,"x",e)}function s(t){return 0<t.length}(a.prototype=Object.create(r.prototype)).setFillStyle=function(t){return this.ctx.fillStyle="object"==typeof t&&t.isColor?t.toString():t,this.ctx},a.prototype.rectangle=function(t,e,n,r,i){this.setFillStyle(i).fillRect(t,e,n,r)},a.prototype.circle=function(t,e,n,r){this.setFillStyle(r),this.ctx.beginPath(),this.ctx.arc(t+n/2,e+n/2,n/2,0,2*Math.PI,!0),this.ctx.closePath(),this.ctx.fill()},a.prototype.circleStroke=function(t,e,n,r,i,o){this.circle(t,e,n,r),this.ctx.strokeStyle=o.toString(),this.ctx.stroke()},a.prototype.drawShape=function(t,e){this.shape(t),this.setFillStyle(e).fill()},a.prototype.taints=function(e){if(null===e.tainted){this.taintCtx.drawImage(e.image,0,0);try{this.taintCtx.getImageData(0,0,1,1),e.tainted=!1}catch(t){this.taintCtx=document.createElement("canvas").getContext("2d"),e.tainted=!0}}return e.tainted},a.prototype.drawImage=function(t,e,n,r,i,o,a,s,c){this.taints(t)&&!this.options.allowTaint||this.ctx.drawImage(t.image,e,n,r,i,o,a,s,c)},a.prototype.clip=function(t,e,n){this.ctx.save(),t.filter(s).forEach(function(t){this.shape(t).clip()},this),e.call(n),this.ctx.restore()},a.prototype.shape=function(t){return this.ctx.beginPath(),t.forEach(function(t,e){"rect"===t[0]?this.ctx.rect.apply(this.ctx,t.slice(1)):this.ctx[0===e?"moveTo":t[0]+"To"].apply(this.ctx,t.slice(1))},this),this.ctx.closePath(),this.ctx},a.prototype.font=function(t,e,n,r,i,o){this.setFillStyle(t).font=[e,n,r,i,o].join(" ").split(",")[0]},a.prototype.fontShadow=function(t,e,n,r){this.setVariable("shadowColor",t.toString()).setVariable("shadowOffsetY",e).setVariable("shadowOffsetX",n).setVariable("shadowBlur",r)},a.prototype.clearShadow=function(){this.setVariable("shadowColor","rgba(0,0,0,0)")},a.prototype.setOpacity=function(t){this.ctx.globalAlpha=t},a.prototype.setTransform=function(t){this.ctx.translate(t.origin[0],t.origin[1]),this.ctx.transform.apply(this.ctx,t.matrix),this.ctx.translate(-t.origin[0],-t.origin[1])},a.prototype.setVariable=function(t,e){return this.variables[t]!==e&&(this.variables[t]=this.ctx[t]=e),this},a.prototype.text=function(t,e,n){this.ctx.fillText(t,e,n)},a.prototype.backgroundRepeatShape=function(t,e,n,r,i,o,a,s,c){var l=[["line",Math.round(i),Math.round(o)],["line",Math.round(i+a),Math.round(o)],["line",Math.round(i+a),Math.round(s+o)],["line",Math.round(i),Math.round(s+o)]];this.clip([l],function(){this.renderBackgroundRepeat(t,e,n,r,c[3],c[0])},this)},a.prototype.renderBackgroundRepeat=function(t,e,n,r,i,o){var a=Math.round(r.left+e.left+i),s=Math.round(r.top+e.top+o);this.setFillStyle(this.ctx.createPattern(this.resizeImage(t,n),"repeat")),this.ctx.translate(a,s),this.ctx.fill(),this.ctx.translate(-a,-s)},a.prototype.renderBackgroundGradient=function(t,e){if(t instanceof i){var n=this.ctx.createLinearGradient(e.left+e.width*t.x0,e.top+e.height*t.y0,e.left+e.width*t.x1,e.top+e.height*t.y1);t.colorStops.forEach(function(t){n.addColorStop(t.stop,t.color.toString())}),this.rectangle(e.left,e.top,e.width,e.height,n)}},a.prototype.resizeImage=function(t,e){var n=t.image;if(n.width===e.width&&n.height===e.height)return n;var r=document.createElement("canvas");return r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(n,0,0,n.width,n.height,0,0,e.width,e.height),r},e.exports=a},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(t,e,n){var i=t("./nodecontainer");function r(t,e,n,r){i.call(this,n,r),this.ownStacking=t,this.contexts=[],this.children=[],this.opacity=(this.parent?this.parent.stack.opacity:1)*e}(r.prototype=Object.create(i.prototype)).getParentStack=function(t){var e=this.parent?this.parent.stack:null;return e?e.ownStacking?e:e.getParentStack(t):t.stack},e.exports=r},{"./nodecontainer":14}],22:[function(t,e,n){function r(t){this.rangeBounds=this.testRangeBounds(t),this.cors=this.testCORS(),this.svg=this.testSVG()}r.prototype.testRangeBounds=function(t){var e,n,r=!1;return t.createRange&&(e=t.createRange()).getBoundingClientRect&&((n=t.createElement("boundtest")).style.height="123px",n.style.display="block",t.body.appendChild(n),e.selectNode(n),123===e.getBoundingClientRect().height&&(r=!0),t.body.removeChild(n)),r},r.prototype.testCORS=function(){return void 0!==(new Image).crossOrigin},r.prototype.testSVG=function(){var t=new Image,e=document.createElement("canvas"),n=e.getContext("2d");t.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{n.drawImage(t,0,0),e.toDataURL()}catch(t){return!1}return!0},e.exports=r},{}],23:[function(t,e,n){var r=t("./xhr"),i=t("./utils").decode64;function o(t){this.src=t,this.image=null;var n=this;this.promise=this.hasFabric().then(function(){return n.isInline(t)?Promise.resolve(n.inlineFormatting(t)):r(t)}).then(function(e){return new Promise(function(t){window.html2canvas.svg.fabric.loadSVGFromString(e,n.createCanvas.call(n,t))})})}o.prototype.hasFabric=function(){return window.html2canvas.svg&&window.html2canvas.svg.fabric?Promise.resolve():Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"))},o.prototype.inlineFormatting=function(t){return/^data:image\/svg\+xml;base64,/.test(t)?this.decode64(this.removeContentType(t)):this.removeContentType(t)},o.prototype.removeContentType=function(t){return t.replace(/^data:image\/svg\+xml(;base64)?,/,"")},o.prototype.isInline=function(t){return/^data:image\/svg\+xml/i.test(t)},o.prototype.createCanvas=function(r){var i=this;return function(t,e){var n=new window.html2canvas.svg.fabric.StaticCanvas("c");i.image=n.lowerCanvasEl,n.setWidth(e.width).setHeight(e.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(t,e)).renderAll(),r(n.lowerCanvasEl)}},o.prototype.decode64=function(t){return"function"==typeof window.atob?window.atob(t):i(t)},e.exports=o},{"./utils":26,"./xhr":28}],24:[function(t,e,n){var r=t("./svgcontainer");function i(n,t){this.src=n,this.image=null;var r=this;this.promise=t?new Promise(function(t,e){r.image=new Image,r.image.onload=t,r.image.onerror=e,r.image.src="data:image/svg+xml,"+(new XMLSerializer).serializeToString(n),!0===r.image.complete&&t(r.image)}):this.hasFabric().then(function(){return new Promise(function(t){window.html2canvas.svg.fabric.parseSVGDocument(n,r.createCanvas.call(r,t))})})}i.prototype=Object.create(r.prototype),e.exports=i},{"./svgcontainer":23}],25:[function(t,e,n){var r=t("./nodecontainer");function i(t,e){r.call(this,t,e)}function o(t,e,n){if(0<t.length)return e+n.toUpperCase()}(i.prototype=Object.create(r.prototype)).applyTextTransform=function(){this.node.data=this.transform(this.parent.css("textTransform"))},i.prototype.transform=function(t){var e=this.node.data;switch(t){case"lowercase":return e.toLowerCase();case"capitalize":return e.replace(/(^|\s|:|-|\(|\))([a-z])/g,o);case"uppercase":return e.toUpperCase();default:return e}},e.exports=i},{"./nodecontainer":14}],26:[function(t,e,n){n.smallImage=function(){return"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"},n.bind=function(t,e){return function(){return t.apply(e,arguments)}},
	/*
	   * base64-arraybuffer
	   * https://github.com/niklasvh/base64-arraybuffer
	   *
	   * Copyright (c) 2012 Niklas von Hertzen
	   * Licensed under the MIT license.
	   */
	n.decode64=function(t){var e,n,r,i,o,a,s,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=t.length,h="";for(e=0;e<l;e+=4)o=c.indexOf(t[e])<<2|(n=c.indexOf(t[e+1]))>>4,a=(15&n)<<4|(r=c.indexOf(t[e+2]))>>2,s=(3&r)<<6|(i=c.indexOf(t[e+3])),h+=64===r?String.fromCharCode(o):64===i||-1===i?String.fromCharCode(o,a):String.fromCharCode(o,a,s);return h},n.getBounds=function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=null==t.offsetWidth?e.width:t.offsetWidth;return{top:e.top,bottom:e.bottom||e.top+e.height,right:e.left+n,left:e.left,width:n,height:null==t.offsetHeight?e.height:t.offsetHeight}}return{}},n.offsetBounds=function(t){var e=t.offsetParent?n.offsetBounds(t.offsetParent):{top:0,left:0};return{top:t.offsetTop+e.top,bottom:t.offsetTop+t.offsetHeight+e.top,right:t.offsetLeft+e.left+t.offsetWidth,left:t.offsetLeft+e.left,width:t.offsetWidth,height:t.offsetHeight}},n.parseBackgrounds=function(t){var e,n,r,i,o,a,s,c=[],l=0,h=0,u=function(){e&&('"'===n.substr(0,1)&&(n=n.substr(1,n.length-2)),n&&s.push(n),"-"===e.substr(0,1)&&0<(i=e.indexOf("-",1)+1)&&(r=e.substr(0,i),e=e.substr(i)),c.push({prefix:r,method:e.toLowerCase(),value:o,args:s,image:null})),s=[],e=r=n=o=""};return s=[],e=r=n=o="",t.split("").forEach(function(t){if(!(0===l&&-1<" \r\n\t".indexOf(t))){switch(t){case'"':a?a===t&&(a=null):a=t;break;case"(":if(a)break;if(0===l)return l=1,void(o+=t);h++;break;case")":if(a)break;if(1===l){if(0===h)return l=0,o+=t,void u();h--}break;case",":if(a)break;if(0===l)return void u();if(1===l&&0===h&&!e.match(/^url$/i))return s.push(n),n="",void(o+=t)}o+=t,0===l?e+=t:n+=t}}),u(),c}},{}],27:[function(t,e,n){var r=t("./gradientcontainer");function i(t){r.apply(this,arguments),this.type="linear"===t.args[0]?r.TYPES.LINEAR:r.TYPES.RADIAL}i.prototype=Object.create(r.prototype),e.exports=i},{"./gradientcontainer":9}],28:[function(t,e,n){e.exports=function(r){return new Promise(function(t,e){var n=new XMLHttpRequest;n.open("GET",r),n.onload=function(){200===n.status?t(n.responseText):e(new Error(n.statusText))},n.onerror=function(){e(new Error("Network Error"))},n.send()})}},{}]},{},[4])(4)}),function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),c="_".charCodeAt(0),h=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===c?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new X(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new T(this),this.registerTTF()}return i.open=function(t,e,n,r){return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var c=0;function l(t){a[c++]=t}for(n=e=0;e<r;e+=4,n+=3)l((16711680&(i=h(t.charAt(e))<<18|h(t.charAt(e+1))<<12|h(t.charAt(e+2))<<6|h(t.charAt(e+3))))>>16),l((65280&i)>>8),l(255&i);return 2===o?l(255&(i=h(t.charAt(e))<<2|h(t.charAt(e+1))>>4)):1===o&&(l((i=h(t.charAt(e))<<10|h(t.charAt(e+1))<<4|h(t.charAt(e+2))>>2)>>8&255),l(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new d(this),this.name=new b(this),this.cmap=new m(this),this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new S(this),this.post=new w(this),this.os2=new y(this),this.loca=new A(this),this.glyf=new _(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var l,X=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var p;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,c,l,h,u,f,d;for(d in u=Object.keys(t).length,a=Math.log(2),l=16*Math.floor(Math.log(u)/a),i=Math.floor(l/a),c=16*u-l,(n=new X).writeInt(this.scalarType),n.writeShort(u),n.writeShort(l),n.writeShort(i),n.writeShort(c),r=16*u,s=n.pos+r,o=null,f=[],t)for(h=t[d],n.writeString(d),n.writeInt(p(h)),n.writeInt(s),n.writeInt(h.length),f=f.concat(h),"head"===d&&(o=s),s+=h.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-p(n.data),n.pos=o+8,n.writeUInt32(e),n.data},p=function(t){var e,n,r,i;for(t=k.call(t);t.length%4;)t.push(0);for(n=new X(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),u={}.hasOwnProperty,f=function(t,e){for(var n in e)u.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};l=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var d=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e}(),p=function(){function t(n,t){var e,r,i,o,a,s,c,l,h,u,f,d,p,g,m,y,w,v;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),h=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),u=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,p=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),c=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),l=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=y=0,v=i.length;y<v;s=++y)for(g=i[s],e=w=d=p[s];d<=g?w<=g:g<=w;e=d<=g?++w:--w)0===l[s]?o=e+c[s]:0!==(o=a[l[s]/2+(e-d)-(u-s)]||0)&&(o+=c[s]),this.codeMap[e]=65535&o}n.pos=h}return t.encode=function(t,e){var n,r,i,o,a,s,c,l,h,u,f,d,p,g,m,y,w,v,b,x,S,k,_,C,I,A,T,F,q,E,P,O,B,j,R,D,M,z,N,L,U,H,W,V,G,Y;switch(F=new X,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(p=0,g=function(){var t,e;for(e=[],d=t=0;t<256;d=++t)e.push(0);return e}(),y={0:0},i={},q=0,B=o.length;q<B;q++)null==y[W=t[r=o[q]]]&&(y[W]=++p),i[r]={old:t[r],new:y[t[r]]},g[r]=y[t[r]];return F.writeUInt16(1),F.writeUInt16(0),F.writeUInt32(12),F.writeUInt16(0),F.writeUInt16(262),F.writeUInt16(0),F.write(g),{charMap:i,subtable:F.data,maxGlyphID:p+1};case"unicode":for(A=[],h=[],y={},n={},m=c=null,E=w=0,j=o.length;E<j;E++)null==y[b=t[r=o[E]]]&&(y[b]=++w),n[r]={old:b,new:y[b]},a=y[b]-r,null!=m&&a===c||(m&&h.push(m),A.push(r),c=a),m=r;for(m&&h.push(m),h.push(65535),A.push(65535),C=2*(_=A.length),k=2*Math.pow(Math.log(_)/Math.LN2,2),u=Math.log(k/2)/Math.LN2,S=2*_-k,s=[],x=[],f=[],d=P=0,R=A.length;P<R;d=++P){if(I=A[d],l=h[d],65535===I){s.push(0),x.push(0);break}if(32768<=I-(T=n[I].new))for(s.push(0),x.push(2*(f.length+_-d)),r=O=I;I<=l?O<=l:l<=O;r=I<=l?++O:--O)f.push(n[r].new);else s.push(T-I),x.push(0)}for(F.writeUInt16(3),F.writeUInt16(1),F.writeUInt32(12),F.writeUInt16(4),F.writeUInt16(16+8*_+2*f.length),F.writeUInt16(0),F.writeUInt16(C),F.writeUInt16(k),F.writeUInt16(u),F.writeUInt16(S),U=0,D=h.length;U<D;U++)r=h[U],F.writeUInt16(r);for(F.writeUInt16(0),H=0,M=A.length;H<M;H++)r=A[H],F.writeUInt16(r);for(V=0,z=s.length;V<z;V++)a=s[V],F.writeUInt16(a);for(G=0,N=x.length;G<N;G++)v=x[G],F.writeUInt16(v);for(Y=0,L=f.length;Y<L;Y++)p=f[Y],F.writeUInt16(p);return{charMap:n,subtable:F.data,maxGlyphID:w+1}}},t}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new p(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=p.encode(t,e),(r=new X).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),w=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),v=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,c,l,h,u,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=l=0;0<=e?l<e:e<l;i=0<=e?++l:--l)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=h=0,u=n.length;h<u;i=++h)r=n[i],t.pos=r.offset,c=t.readString(r.length),o=new v(c,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);return this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5],this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,""),this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),S=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),k=[].slice,_=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,c,l,h;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new X(e.read(r))).readShort(),c=a.readShort(),h=a.readShort(),s=a.readShort(),l=a.readShort(),this.cache[t]=-1===o?new I(a,c,h,s,l):new C(a,o,c,h,s,l),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),C=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),I=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new X(k.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),A=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,l),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var c=new Array(4*n.length),l=0;l<n.length;++l)c[4*l+3]=255&n[l],c[4*l+2]=(65280&n[l])>>8,c[4*l+1]=(16711680&n[l])>>16,c[4*l]=(4278190080&n[l])>>24;return c},e}(),T=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t){var e,n,r,i,o,a,s,c,l,h,u,f,d,p,g;for(n in e=m.encode(this.generateCmap(),"unicode"),i=this.glyphsFor(t),u={0:0},g=e.charMap)u[(a=g[n]).old]=a.new;for(f in h=e.maxGlyphID,i)f in u||(u[f]=h++);return c=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(u),l=Object.keys(c).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=l.length;t<e;t++)o=l[t],n.push(c[o]);return n}(),r=this.font.glyf.encode(i,d,u),s=this.font.loca.encode(r.offsets,d),p={cmap:this.font.cmap.raw(),glyf:r.table,loca:s,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.raw()},this.font.os2.exists&&(p["OS/2"]=this.font.os2.raw()),this.font.directory.encode(p)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")}return""+r},a}()}(K),
	/*
	  # PNG.js
	  # Copyright (c) 2011 Devon Govett
	  # MIT LICENSE
	  # 
	  # 
	  */
	ut="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),ft=function(){var l,n,r;function i(t){var e,n,r,i,o,a,s,c,l,h,u,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),l=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===l&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(h=r-this.transparency.indexed.length))for(d=0;0<=h?d<h:h<d;0<=h?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(u=this.read(e)).indexOf(0),c=String.fromCharCode.apply(String,u.slice(0,s)),this.text[c]=String.fromCharCode.apply(String,u.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(E){var P=this.pixelBitlength/8,O=new Uint8Array(this.width*this.height*P),B=0,j=this;if(null==E&&(E=this.imgData),0===E.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,c,l,h,u,f,d,p,g,m,y,w,v,b,x,S,k,_,C=Math.ceil((j.width-t)/n),I=Math.ceil((j.height-e)/r),A=j.width==C&&j.height==I;for(y=P*C,g=A?O:new Uint8Array(y*I),l=E.length,o=m=0;m<I&&B<l;){switch(E[B++]){case 0:for(s=b=0;b<y;s=b+=1)g[o++]=E[B++];break;case 1:for(s=x=0;x<y;s=x+=1)i=E[B++],c=s<P?0:g[o-P],g[o++]=(i+c)%256;break;case 2:for(s=S=0;S<y;s=S+=1)i=E[B++],a=(s-s%P)/P,w=m&&g[(m-1)*y+a*P+s%P],g[o++]=(w+i)%256;break;case 3:for(s=k=0;k<y;s=k+=1)i=E[B++],a=(s-s%P)/P,c=s<P?0:g[o-P],w=m&&g[(m-1)*y+a*P+s%P],g[o++]=(i+Math.floor((c+w)/2))%256;break;case 4:for(s=_=0;_<y;s=_+=1)i=E[B++],a=(s-s%P)/P,c=s<P?0:g[o-P],0===m?w=v=0:(w=g[(m-1)*y+a*P+s%P],v=a&&g[(m-1)*y+(a-1)*P+s%P]),h=c+w-v,u=Math.abs(h-c),d=Math.abs(h-w),p=Math.abs(h-v),f=u<=d&&u<=p?c:d<=p?w:v,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+E[B-1])}if(!A){var T=((e+m*r)*j.width+t)*P,F=m*y;for(s=0;s<C;s+=1){for(var q=0;q<P;q+=1)O[T++]=g[F++];T+=(n-1)*P}}m++}}return E=(E=new gt(E)).getBytes(),1==j.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),O},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,c;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(c=o[t++])?c:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,c,l,h,u,f;if(r=this.colors,h=null,n=this.hasAlphaChannel,this.palette.length&&(h=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),l=(i=t.data||t).length,a=h||e,o=s=0,1===r)for(;o<l;)c=h?4*e[o/4]:s,u=a[c++],i[o++]=u,i[o++]=u,i[o++]=u,i[o++]=n?a[c++]:255,s=c;else for(;o<l;)c=h?4*e[o/4]:s,i[o++]=a[c++],i[o++]=a[c++],i[o++]=a[c++],i[o++]=n?a[c++]:255,s=c},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=ut.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return l=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,c;if(this.animation){for(c=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,c.push(e.image=l(r));return c}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,c=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],c.renderFrame(n,t),1<a&&i/a<s)return c.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),ut.PNG=ft;
	/*
	   * Extracted from pdf.js
	   * https://github.com/andreasgal/pdf.js
	   *
	   * Copyright (c) 2011 Mozilla Foundation
	   *
	   * Contributors: Andreas Gal <gal@mozilla.com>
	   *               Chris G Jones <cjones@mozilla.com>
	   *               Shaon Barman <shaon.barman@gmail.com>
	   *               Vivien Nicolas <21@vingtetun.org>
	   *               Justin D'Arcangelo <justindarc@gmail.com>
	   *               Yury Delendik
	   *
	   * 
	   */
	var pt=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),gt=function(){if("undefined"!=typeof Uint32Array){var F=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),q=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),E=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),P=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],O=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(pt.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&B("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&B("Bad encoding in flate stream"),i|=s<<r,r+=8}var c=e[i&(1<<n)-1],l=c>>16,h=65535&c;return(0==r||r<l||0==l)&&B("Bad encoding in flate stream"),this.codeBuf=i>>l,this.codeSize=r-l,this.bytesPos=a,h},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,c=2;a<=n;++a,s<<=1,c<<=1)for(var l=0;l<e;++l)if(t[l]==a){var h=0,u=s;for(r=0;r<a;++r)h=h<<1|1&u,u>>=1;for(r=h;r<i;r+=c)o[r]=a<<16|l;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[c++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=P,r=O;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(F.length),c=0;c<a;)s[F[c++]]=this.getBits(3);for(var l=this.generateHuffmanTable(s),h=0,u=(c=0,i+o),f=new Array(u);c<u;){var d=this.getCode(l);16==d?t(this,f,2,3,h):17==d?t(this,f,3,3,h=0):18==d?t(this,f,7,11,h=0):f[c++]=h=d}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,u))}else B("Unknown block type in flate stream");for(var p=(I=this.buffer)?I.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)p<=g+1&&(p=(I=this.ensureBuffer(g+1)).length),I[g++]=m;else{if(256==m)return void(this.bufferLength=g);var y=(m=q[m-=257])>>16;0<y&&(y=this.getBits(y));h=(65535&m)+y;m=this.getCode(r),0<(y=(m=E[m])>>16)&&(y=this.getBits(y));var w=(65535&m)+y;p<=g+h&&(p=(I=this.ensureBuffer(g+h)).length);for(var v=0;v<h;++v,++g)I[g]=I[g-w]}}}else{var b,x=this.bytes,S=this.bytesPos;void 0===(b=x[S++])&&B("Bad block header in flate stream");var k=b;void 0===(b=x[S++])&&B("Bad block header in flate stream"),k|=b<<8,void 0===(b=x[S++])&&B("Bad block header in flate stream");var _=b;void 0===(b=x[S++])&&B("Bad block header in flate stream"),(_|=b<<8)!=(65535&~k)&&B("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var C=this.bufferLength,I=this.ensureBuffer(C+k),A=C+k;this.bufferLength=A;for(var T=C;T<A;++T){if(void 0===(b=x[S++])){this.eof=!0;break}I[T]=b}this.bytesPos=S}},t}function B(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||B("Invalid header in flate stream"),8!=(15&n)&&B("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&B("Bad FCHECK in flate stream"),32&r&&B("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,pt.call(this)}}();return function(t){if("object"!=typeof t.console){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,c,l,h,u="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,c="",l=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,l[s++]=u.charAt(e)+u.charAt(n)+u.charAt(r)+u.charAt(i),a<t.length;);c=l.join("");var h=t.length%3;return(h?c.slice(0,h-3):c)+"===".slice(h||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,c=0,l=[];if(!t)return t;for(t+="";e=(a=u.indexOf(t.charAt(s++))<<18|u.indexOf(t.charAt(s++))<<12|(i=u.indexOf(t.charAt(s++)))<<6|(o=u.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,l[c++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return l.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,c=!{toString:null}.propertyIsEnumerable("toString"),h=(l=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!=typeof t&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(c)for(n=0;n<h;n++)s.call(t,l[n])&&r.push(l[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")})}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),K});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(191)))

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(1701);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropUp = function NavigationArrowDropUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' })
	  );
	};
	NavigationArrowDropUp = (0, _pure2.default)(NavigationArrowDropUp);
	NavigationArrowDropUp.displayName = 'NavigationArrowDropUp';
	NavigationArrowDropUp.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropUp;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
	var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _propTypes2.default.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ },
/* 76 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * input field component with label (url: /create-account)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author chargoyao
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property style {object} the styles of the element.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property labelStyle {object} the styles of label.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property borderColor {string} input's border color.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property inputStyle {object} input element style.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property inputType {string} input type.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property ifHasBorder {boolean} if add border
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property hintText {string} placeholder text.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property labelTitle {string} label title.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property initValue {string} init value
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property onBlur {function}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @function onChange {function} call function is fired when the textfield's value changes, this callback will pass two params: one is event object second is the input value.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property toolTipContainerStyle {object} tool tip container style
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property toolTipContainerBorderColor {style} tool tip container border color
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property toolTipContent {string} tip content, if you do not assign this props, tooltip container will be hidden.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property children , be supported.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property inputContainerId input container id
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property ifRequireField if true, lableTit will show `*`
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property inputContainerClassName input container class name
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var InputField = function (_Component) {
	  _inherits(InputField, _Component);
	
	  function InputField() {
	    _classCallCheck(this, InputField);
	
	    return _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).apply(this, arguments));
	  }
	
	  _createClass(InputField, [{
	    key: "getRootStyle",
	    value: function getRootStyle() {
	      var rootInitStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.rootInitStyle;
	
	      var rootStyle = this.props.style;
	      return Object.assign({}, rootInitStyle, rootStyle);
	    }
	  }, {
	    key: "getLabelStyle",
	    value: function getLabelStyle() {
	      var labelInitStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.labelStyle;
	
	      var labelStyle = this.props.labelStyle;
	
	      return Object.assign({}, labelInitStyle, labelStyle);
	    }
	  }, {
	    key: "getInputStyle",
	    value: function getInputStyle() {
	      var inputInitStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.inputInitStyle;
	
	      var inputStyle = this.props.inputStyle;
	
	      return Object.assign({}, inputInitStyle, inputStyle);
	    }
	  }, {
	    key: "getTooltipStyle",
	    value: function getTooltipStyle() {
	      var toolTipInitStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.toolTipInitStyle;
	
	      var tooltipStyle = this.props.toolTipContainerStyle;
	      // add container border
	      toolTipInitStyle.border = "1px solid " + (this.props.toolTipContainerBorderColor || this.props.initTooltipBorderColor);
	
	      return Object.assign({}, toolTipInitStyle, tooltipStyle);
	    }
	  }, {
	    key: "handleOnChange",
	    value: function handleOnChange(e, value) {
	      if (typeof this.props.onChange !== "undefined") {
	        this.props.onChange(e, value);
	      }
	      // if (typeof this.props.toolTipContent === 'undefined' && typeof this.props.children === 'undefined') {
	      //   this.refs.tooltipBox.style.display = 'none';
	      // } else {
	      //   this.refs.tooltipBox.style.display = 'block';
	      // }
	    }
	  }, {
	    key: "handleInputFocus",
	    value: function handleInputFocus(e) {
	      // if toolTipContent value is null , hidden tooltip
	      if (typeof this.props.toolTipContent === "undefined" && typeof this.props.children === "undefined") {
	        this.refs.tooltipBox.style.display = "none";
	      } else {
	        this.refs.tooltipBox.style.display = "block";
	      }
	
	      var toolTipRect = this.refs.tooltipBox.getClientRects();
	      if (toolTipRect.length > 0) {
	        // computed top value  30 is the padding value
	        this.refs.tooltipBox.style.top = "-" + (toolTipRect[0].height - 30) / 2 + "px";
	        // computed right value
	        this.refs.tooltipBox.style.right = "-" + (toolTipRect[0].width + 20) + "px";
	      }
	      if (this.props.maskInput && typeof this.props.maskInput === "function") {
	        this.refs.inputRef.value = this.refs.hiddenRef.value;
	      }
	
	      if (this.props.initValue && (0, _isEmpty2.default)(this.refs.hiddenRef.value)) {
	        this.refs.inputRef.value = this.props.initValue;
	      }
	    }
	  }, {
	    key: "handleInputBlur",
	    value: function handleInputBlur(e, value) {
	      this.refs.tooltipBox.style.display = "none";
	      if (typeof this.props.handleOnBlur === "function") {
	        this.props.handleOnBlur(e, value);
	      }
	      if (this.props.maskInput && typeof this.props.maskInput === "function") {
	        this.refs.hiddenRef.value = value;
	        this.refs.inputRef.value = this.props.maskInput(value);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "common-input clearfix", style: this.getRootStyle() },
	        _react2.default.createElement(
	          "p",
	          { style: this.getLabelStyle() },
	          this.props.labelTitle,
	          _react2.default.createElement(
	            "em",
	            {
	              style: {
	                display: this.props.ifRequireField ? "inline-block" : "none",
	                color: "red"
	              }
	            },
	            "*"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "input-border " + (this.props.inputContainerClassName || ""),
	            id: this.props.inputContainerId,
	            style: {
	              position: "relative",
	              height: "33px",
	              border: this.props.ifHasBorder ? "none" : "1px solid " + (this.props.borderColor || this.props.borderInitStyle)
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "input-tooltip-wrapper",
	              style: {
	                display: typeof this.props.toolTipContent === "undefined" ? "none" : "block"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "input-tooltip",
	                style: this.getTooltipStyle(),
	                ref: "tooltipBox"
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    width: this.props.labelTitle === "Confirm Password*" ? "202px" : "",
	                    height: this.props.labelTitle === "Confirm Password*" ? "40px" : "",
	                    lineHeight: this.props.toolTipContent === "Enter Confirm Password." ? "40px" : ""
	                  }
	                },
	                this.props.toolTipContent
	              ),
	              this.props.children,
	              _react2.default.createElement("i", {
	                style: {
	                  position: "absolute",
	                  width: "0.6em",
	                  height: "0.6em",
	                  left: "-0.39em",
	                  top: "50%",
	                  marginTop: "-0.3em",
	                  border: "1px solid " + (this.props.toolTipContainerBorderColor || this.props.initTooltipBorderColor),
	                  borderTop: "none",
	                  borderRight: "none",
	                  background: "white",
	                  transform: "rotate(45deg)"
	                }
	              })
	            )
	          ),
	          _react2.default.createElement("input", {
	            style: { display: "none" },
	            type: this.props.inputType || "text"
	          }),
	          _react2.default.createElement("input", { type: "hidden", ref: "hiddenRef" }),
	          _react2.default.createElement("input", {
	            maxLength: this.props.maxLength ? this.props.maxLength : 100,
	            type: this.props.inputType || "text",
	            defaultValue: this.props.initValue,
	            style: this.getInputStyle(),
	            autocomplete: "aa-" + this.props.inputContainerId,
	            ref: "inputRef",
	            onChange: function onChange(e) {
	              return _this2.handleOnChange(e, _this2.refs.inputRef.value);
	            },
	            placeholder: this.props.hintText,
	            onFocus: function onFocus(e) {
	              return _this2.handleInputFocus(e);
	            },
	            onBlur: function onBlur(e) {
	              return _this2.handleInputBlur(e, _this2.refs.inputRef.value);
	            },
	            onKeyDown: this.props.onKeyDown,
	            key: this.props.labelTitle
	          })
	        )
	      );
	    }
	  }]);
	
	  return InputField;
	}(_react.Component);
	
	InputField.defaultProps = {
	  rootInitStyle: {
	    marginBottom: "0.8em",
	    position: "relative"
	  },
	  labelStyle: {
	    color: "black",
	    fontSize: "16px"
	  },
	  borderInitStyle: "#B1B0B0",
	  inputInitStyle: {
	    border: "none",
	    height: "25px",
	    width: "98%",
	    paddingLeft: "10px",
	    fontSize: "16px",
	    color: "black"
	  },
	
	  toolTipInitStyle: {
	    position: "absolute",
	    display: "none",
	    top: "0",
	    right: "-14em",
	    padding: "15px",
	    borderRadius: "6px",
	    maxWidth: "18em",
	    background: "white"
	  },
	  initTooltipBorderColor: "#bdbaba"
	};
	
	InputField.propTypes = {
	  labelTitle: _propTypes2.default.string.isRequired
	};
	
	exports.default = InputField;

/***/ },
/* 78 */
[3147, 538],
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 80 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 82 */
[3225, 935],
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "configBezier", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configBezier;
	  }
	});
	Object.defineProperty(exports, "configSpring", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configSpring;
	  }
	});
	Object.defineProperty(exports, "translateStyle", {
	  enumerable: true,
	  get: function get() {
	    return _util.translateStyle;
	  }
	});
	Object.defineProperty(exports, "AnimateGroup", {
	  enumerable: true,
	  get: function get() {
	    return _AnimateGroup.default;
	  }
	});
	exports.default = void 0;
	
	var _Animate = _interopRequireDefault(__webpack_require__(984));
	
	var _easing = __webpack_require__(985);
	
	var _util = __webpack_require__(338);
	
	var _AnimateGroup = _interopRequireDefault(__webpack_require__(3028));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Animate.default;
	exports.default = _default;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createVisitorAudience = exports.createScaleAudience = exports.checkSegmentLimitExceeded = exports.getCategoryAudienceCounts = exports.saveSegment = exports.getZipcodeDetailCounts = exports.getZipcodeAudienceCount = exports.getPlottedAudienceCount = exports.getAudienceCount = exports.verifyAndContinue = exports.verifySegmentNameAndContinue = exports.verifySegmentName = exports.getDMAs = exports.getCounties = exports.getCities = exports.getAllStates = exports.getAllStateCities = exports.loadAttributes = exports.setTargetHouseholdOnly = exports.clearCategoryAudienceCounts = exports.clearCreateVisitorsAudienceInfo = exports.clearCreateScaleAudienceInfo = exports.clearZipcodeCount = exports.clearAudienceCount = exports.addRegionActive = exports.addMakeActive = exports.loading = exports.clearZipCode = exports.addZipCode = exports.setSegmentName = exports.clearAllZipCode = exports.setPlotValues = exports.clearAllDMA = exports.clearAllCounty = exports.clearAllSelectedCity = exports.clearAllRegionSelected = exports.clearAllAutoSelected = exports.clearAllSelectedState = exports.selectCultureLocale = exports.selectCultureRegion = exports.selectModel = exports.selectMake = exports.selectAllState = exports.selectState = exports.selectDMA = exports.selectCounty = exports.selectCity = exports.CLEAR_ALL_REGION = exports.CLEAR_ALL_AUTO = exports.SET_TARGET_HOUSEHOLD_ONLY = exports.CLEAR_CATEGORY_AUDIENCE_COUNTS = exports.CATEGORY_AUDIENCE_COUNTS = exports.CLEAR_ZIPCODE_COUNTS = exports.CLEAR_AUDIENCE_COUNT = exports.CLEAR_ZIPCODE_AUDIENCE_COUNT = exports.GET_ZIPCODE_DETAIL_COUNTS = exports.GET_ZIPCODE_AUDIENCE_COUNT = exports.GET_PLOTTED_AUDIENCE_COUNT = exports.GET_AUDIENCE_COUNT = exports.ADD_REGION_ACTIVE = exports.ADD_MAKE_ACTIVE = exports.LOADING = exports.GET_ALL_STATE_CITIES = exports.CHECK_SEGMENT_LIMIT = exports.VERIFY_SEGMENT_NAME = exports.SELECTED_CC_LOCALE = exports.SELECTED_CC_REGION = exports.SELECTED_MODEL = exports.SELECTED_MAKE = exports.CLEAR_ZIPCODE = exports.CLEAR_ALL_ZIPCODE = exports.ADD_ZIPCODE = exports.CLEAR_DMA = exports.CLEAR_COUNTY = exports.CLEAR_CITYS = exports.CLEAR_STATES = exports.SET_PLOT_VALUES = exports.SELECTED_ALL_STATE = exports.SELECTED_STATE = exports.GET_DMAS = exports.GET_COUNTY = exports.GET_CITY = exports.SELECTED_DMA = exports.SELECTED_COUNTY = exports.SELECTED_CITY = exports.CLEAR_CREATE_VISITORS_AUDIENCE_INFO = exports.CLEAR_CREATE_SCALE_AUDIENCE_INFO = exports.CREATE_AUDIENCE_AT_VISITORS = exports.CREATE_AUDIENCE_AT_SCALE = exports.SAVE_SEGMENT = exports.SET_SEGMENT_NAME = exports.selectSegment = exports.ALLSTATES = exports.SELECT_SEGMENT = exports.SEGMENTS_ATTR = undefined;
	
	var _helpers = __webpack_require__(95);
	
	var _Api = __webpack_require__(45);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEGMENTS_ATTR = exports.SEGMENTS_ATTR = "SEGMENT_ATTRS";
	var SELECT_SEGMENT = exports.SELECT_SEGMENT = "SELECT_SEGMENT";
	var ALLSTATES = exports.ALLSTATES = "ALLSTATES";
	var selectSegment = exports.selectSegment = (0, _helpers.actionCreator)(SELECT_SEGMENT);
	var SET_SEGMENT_NAME = exports.SET_SEGMENT_NAME = "RULE_NAME";
	var SAVE_SEGMENT = exports.SAVE_SEGMENT = "SAVE_SEGMENT";
	var CREATE_AUDIENCE_AT_SCALE = exports.CREATE_AUDIENCE_AT_SCALE = "CREATE_AUDIENCE_AT_SCALE";
	var CREATE_AUDIENCE_AT_VISITORS = exports.CREATE_AUDIENCE_AT_VISITORS = "CREATE_AUDIENCE_AT_VISITORS";
	var CLEAR_CREATE_SCALE_AUDIENCE_INFO = exports.CLEAR_CREATE_SCALE_AUDIENCE_INFO = "CLEAR_CREATE_SCALE_AUDIENCE_INFO";
	var CLEAR_CREATE_VISITORS_AUDIENCE_INFO = exports.CLEAR_CREATE_VISITORS_AUDIENCE_INFO = "CLEAR_CREATE_VISITORS_AUDIENCE_INFO";
	var SELECTED_CITY = exports.SELECTED_CITY = "SELECTED_CITY";
	var SELECTED_COUNTY = exports.SELECTED_COUNTY = "SELECTED_COUNTY";
	var SELECTED_DMA = exports.SELECTED_DMA = "SELECTED_DMA";
	var GET_CITY = exports.GET_CITY = "GET_CITY";
	var GET_COUNTY = exports.GET_COUNTY = "GET_COUNTY";
	var GET_DMAS = exports.GET_DMAS = "GET_DMAS";
	var SELECTED_STATE = exports.SELECTED_STATE = "SELECTED_STATE";
	var SELECTED_ALL_STATE = exports.SELECTED_ALL_STATE = "SELECTED_ALL_STATE";
	var SET_PLOT_VALUES = exports.SET_PLOT_VALUES = "SET_PLOT_VALUES";
	var CLEAR_STATES = exports.CLEAR_STATES = "CLEAR_STATES";
	var CLEAR_CITYS = exports.CLEAR_CITYS = "CLEAR_CITYS";
	var CLEAR_COUNTY = exports.CLEAR_COUNTY = "CLEAR_COUNTY";
	var CLEAR_DMA = exports.CLEAR_DMA = "CLEAR_DMA";
	var ADD_ZIPCODE = exports.ADD_ZIPCODE = "ADD_ZIPCODE";
	var CLEAR_ALL_ZIPCODE = exports.CLEAR_ALL_ZIPCODE = "CLEAR_ALL_ZIPCODE";
	var CLEAR_ZIPCODE = exports.CLEAR_ZIPCODE = "CLEAR_ZIPCODE";
	var SELECTED_MAKE = exports.SELECTED_MAKE = "SELECTED_MAKE";
	var SELECTED_MODEL = exports.SELECTED_MODEL = "SELECTED_MODEL";
	var SELECTED_CC_REGION = exports.SELECTED_CC_REGION = "SELECTED_CC_REGION";
	var SELECTED_CC_LOCALE = exports.SELECTED_CC_LOCALE = "SELECTED_CC_LOCALE";
	var VERIFY_SEGMENT_NAME = exports.VERIFY_SEGMENT_NAME = "VERIFY_SEGEMNT_NAME";
	var CHECK_SEGMENT_LIMIT = exports.CHECK_SEGMENT_LIMIT = "CHECK_SEGMENT_LIMIT";
	var GET_ALL_STATE_CITIES = exports.GET_ALL_STATE_CITIES = "GET_ALL_STATE_CITIES";
	var LOADING = exports.LOADING = "LOADING";
	var ADD_MAKE_ACTIVE = exports.ADD_MAKE_ACTIVE = "ADD_MAKE_ACTIVE";
	var ADD_REGION_ACTIVE = exports.ADD_REGION_ACTIVE = "ADD_REGION_ACTIVE";
	var GET_AUDIENCE_COUNT = exports.GET_AUDIENCE_COUNT = "GET_COUNT";
	var GET_PLOTTED_AUDIENCE_COUNT = exports.GET_PLOTTED_AUDIENCE_COUNT = "GET_PLOTTED_COUNT";
	var GET_ZIPCODE_AUDIENCE_COUNT = exports.GET_ZIPCODE_AUDIENCE_COUNT = "GET_ZIPCODE_COUNT";
	var GET_ZIPCODE_DETAIL_COUNTS = exports.GET_ZIPCODE_DETAIL_COUNTS = "GET_ZIPCODE_DETAIL_COUNTS";
	var CLEAR_ZIPCODE_AUDIENCE_COUNT = exports.CLEAR_ZIPCODE_AUDIENCE_COUNT = "CLEAR_ZIPCODE_COUNT";
	var CLEAR_AUDIENCE_COUNT = exports.CLEAR_AUDIENCE_COUNT = "CLEAR_AUDIENCE_COUNT";
	var CLEAR_ZIPCODE_COUNTS = exports.CLEAR_ZIPCODE_COUNTS = "CLEAR_ZIPCODE_COUNTS";
	var CATEGORY_AUDIENCE_COUNTS = exports.CATEGORY_AUDIENCE_COUNTS = "CATEGORY_AUDIENCE_COUNTS";
	var CLEAR_CATEGORY_AUDIENCE_COUNTS = exports.CLEAR_CATEGORY_AUDIENCE_COUNTS = "CLEAR_CATEGORY_AUDIENCE_COUNTS";
	var SET_TARGET_HOUSEHOLD_ONLY = exports.SET_TARGET_HOUSEHOLD_ONLY = "SET_TARGET_HOUSEHOLD_ONLY";
	var CLEAR_ALL_AUTO = exports.CLEAR_ALL_AUTO = "CLEAR_ALL_AUTO";
	var CLEAR_ALL_REGION = exports.CLEAR_ALL_REGION = "CLEAR_ALL_REGION";
	// action for selected state
	var selectCity = exports.selectCity = function selectCity(value, stateLabel, flag) {
	  return {
	    type: SELECTED_CITY,
	    value: value,
	    stateLabel: stateLabel,
	    flag: flag
	  };
	};
	var selectCounty = exports.selectCounty = function selectCounty(value, stateLabel, flag) {
	  return {
	    type: SELECTED_COUNTY,
	    value: value,
	    stateLabel: stateLabel,
	    flag: flag
	  };
	};
	var selectDMA = exports.selectDMA = function selectDMA(value, stateLabel, flag) {
	  return {
	    type: SELECTED_DMA,
	    value: value,
	    stateLabel: stateLabel,
	    flag: flag
	  };
	};
	var selectState = exports.selectState = function selectState(value, flag) {
	  return {
	    type: SELECTED_STATE,
	    value: value,
	    flag: flag
	  };
	};
	var selectAllState = exports.selectAllState = function selectAllState(value, flag) {
	  return {
	    type: SELECTED_ALL_STATE,
	    value: value,
	    flag: flag
	  };
	};
	var selectMake = exports.selectMake = function selectMake(value, flag) {
	  return {
	    type: SELECTED_MAKE,
	    value: value,
	    flag: flag
	  };
	};
	var selectModel = exports.selectModel = function selectModel(value, flag) {
	  return {
	    type: SELECTED_MODEL,
	    value: value,
	    flag: flag
	  };
	};
	var selectCultureRegion = exports.selectCultureRegion = function selectCultureRegion(value, flag) {
	  return {
	    type: SELECTED_CC_REGION,
	    value: value,
	    flag: flag
	  };
	};
	var selectCultureLocale = exports.selectCultureLocale = function selectCultureLocale(value, flag) {
	  return {
	    type: SELECTED_CC_LOCALE,
	    value: value,
	    flag: flag
	  };
	};
	var clearAllSelectedState = exports.clearAllSelectedState = (0, _helpers.actionCreator)(CLEAR_STATES);
	var clearAllAutoSelected = exports.clearAllAutoSelected = (0, _helpers.actionCreator)(CLEAR_ALL_AUTO);
	var clearAllRegionSelected = exports.clearAllRegionSelected = (0, _helpers.actionCreator)(CLEAR_ALL_REGION);
	var clearAllSelectedCity = exports.clearAllSelectedCity = (0, _helpers.actionCreator)(CLEAR_CITYS);
	var clearAllCounty = exports.clearAllCounty = (0, _helpers.actionCreator)(CLEAR_COUNTY);
	var clearAllDMA = exports.clearAllDMA = (0, _helpers.actionCreator)(CLEAR_DMA);
	var setPlotValues = exports.setPlotValues = (0, _helpers.actionCreator)(SET_PLOT_VALUES);
	var clearAllZipCode = exports.clearAllZipCode = (0, _helpers.actionCreator)(CLEAR_ALL_ZIPCODE);
	var setSegmentName = exports.setSegmentName = (0, _helpers.actionCreator)(SET_SEGMENT_NAME);
	var addZipCode = exports.addZipCode = (0, _helpers.actionCreator)(ADD_ZIPCODE);
	var clearZipCode = exports.clearZipCode = (0, _helpers.actionCreator)(CLEAR_ZIPCODE);
	var loading = exports.loading = (0, _helpers.actionCreator)(LOADING);
	var addMakeActive = exports.addMakeActive = (0, _helpers.actionCreator)(ADD_MAKE_ACTIVE);
	var addRegionActive = exports.addRegionActive = (0, _helpers.actionCreator)(ADD_REGION_ACTIVE);
	var clearAudienceCount = exports.clearAudienceCount = (0, _helpers.actionCreator)(CLEAR_AUDIENCE_COUNT);
	var clearZipcodeCount = exports.clearZipcodeCount = (0, _helpers.actionCreator)(CLEAR_ZIPCODE_AUDIENCE_COUNT);
	var clearCreateScaleAudienceInfo = exports.clearCreateScaleAudienceInfo = (0, _helpers.actionCreator)(CLEAR_CREATE_SCALE_AUDIENCE_INFO);
	var clearCreateVisitorsAudienceInfo = exports.clearCreateVisitorsAudienceInfo = (0, _helpers.actionCreator)(CLEAR_CREATE_VISITORS_AUDIENCE_INFO);
	var clearCategoryAudienceCounts = exports.clearCategoryAudienceCounts = (0, _helpers.actionCreator)(CLEAR_CATEGORY_AUDIENCE_COUNTS);
	var setTargetHouseholdOnly = exports.setTargetHouseholdOnly = (0, _helpers.actionCreator)(SET_TARGET_HOUSEHOLD_ONLY);
	
	var loadAttributes = exports.loadAttributes = function loadAttributes(cid) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SEGMENTS_ATTR, cid ? "attributes/tree?cid=" + cid : "attributes/tree");
	  };
	};
	
	var getAllStateCities = exports.getAllStateCities = function getAllStateCities() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_ALL_STATE_CITIES, "attributes/states-with-cities");
	  };
	};
	
	var getAllStates = exports.getAllStates = function getAllStates() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, ALLSTATES, "attributes/states");
	  };
	};
	
	var getCities = exports.getCities = function getCities(cityId) {
	  return function (dispatch, getState) {
	    dispatch(loading(true));
	    var startTime = new Date().getTime();
	    (0, _Api.callApi)(dispatch, getState, GET_CITY, "attributes/states/" + cityId + "/cities", { method: "GET" }, {
	      success: function success() {
	        dispatch(loading(false));
	        localStorage.setItem("spareTime", new Date().getTime() - startTime);
	      }
	    });
	  };
	};
	
	var getCounties = exports.getCounties = function getCounties() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_COUNTY, "attributes/counties");
	  };
	};
	
	var getDMAs = exports.getDMAs = function getDMAs() {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_DMAS, "attributes/dmas");
	  };
	};
	var verifySegmentName = exports.verifySegmentName = function verifySegmentName(clientId, name, id) {
	  var url = id && id > 0 ? "segments/lookup?clientId=" + clientId + "&name=" + name + "&id=" + id : "segments/lookup?clientId=" + clientId + "&name=" + name;
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, VERIFY_SEGMENT_NAME, url);
	  };
	};
	
	var verifySegmentNameAndContinue = exports.verifySegmentNameAndContinue = function verifySegmentNameAndContinue(clientId, name, id, newURL) {
	  var url = id && id > 0 ? "segments/lookup?clientId=" + clientId + "&name=" + name + "&id=" + id : "segments/lookup?clientId=" + clientId + "&name=" + name;
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, VERIFY_SEGMENT_NAME, url, { method: "GET" }, {
	      success: function success() {
	        dispatch((0, _reactRouterRedux.push)(newURL ? newURL : "/segment/confirm"));
	      }
	    });
	  };
	};
	
	var verifyAndContinue = exports.verifyAndContinue = function verifyAndContinue(clientId, name) {
	  var url = "clients/" + clientId + "/resource-limit-check?resource=segment";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, CHECK_SEGMENT_LIMIT, url, { method: "GET" }, {
	      success: function success() {
	        verifySegmentNameAndContinue(clientId, name, undefined);
	      }
	    });
	  };
	};
	
	var getAudienceCount = exports.getAudienceCount = function getAudienceCount(data, sid) {
	  var url = sid ? "segments/calculate-audience" + "?sid=" + sid : "segments/calculate-audience";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_AUDIENCE_COUNT, url, {
	      method: "POST",
	      body: JSON.stringify(data)
	    });
	  };
	};
	
	var getPlottedAudienceCount = exports.getPlottedAudienceCount = function getPlottedAudienceCount(data, sid) {
	  var url = sid ? "segments/calculate-audience" + "?sid=" + sid : "segments/calculate-audience";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_PLOTTED_AUDIENCE_COUNT, url, {
	      method: "POST",
	      body: JSON.stringify(data)
	    });
	  };
	};
	
	var getZipcodeAudienceCount = exports.getZipcodeAudienceCount = function getZipcodeAudienceCount(data, sid) {
	  var url = sid ? "segments/calculate-audience" + "?sid=" + sid : "segments/calculate-audience";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_ZIPCODE_AUDIENCE_COUNT, url, {
	      method: "POST",
	      body: JSON.stringify(data)
	    });
	  };
	};
	
	var getZipcodeDetailCounts = exports.getZipcodeDetailCounts = function getZipcodeDetailCounts(data, sid) {
	  var url = sid ? "segments/zipcode/counts" + "?sid=" + sid : "segments/zipcode/counts";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_ZIPCODE_DETAIL_COUNTS, url, {
	      method: "POST",
	      body: JSON.stringify(data)
	    });
	  };
	};
	
	var saveSegment = exports.saveSegment = function saveSegment(data) {
	  var url = "segments";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SAVE_SEGMENT, url, {
	      method: "POST",
	      body: JSON.stringify(data)
	    }, {
	      success: function success() {
	        dispatch(clearAudienceCount());
	        dispatch((0, _reactRouterRedux.push)("/segment/save_success"));
	      }
	    });
	  };
	};
	
	var getCategoryAudienceCounts = exports.getCategoryAudienceCounts = function getCategoryAudienceCounts(rules, sid) {
	  var url = sid ? "segments/calculate-audience" + "?sid=" + sid : "segments/calculate-audience";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, CATEGORY_AUDIENCE_COUNTS, url, {
	      method: "POST",
	      body: JSON.stringify(rules)
	    });
	  };
	};
	
	var checkSegmentLimitExceeded = exports.checkSegmentLimitExceeded = function checkSegmentLimitExceeded(clientId) {
	  var url = "clients/" + clientId + "/resource-limit-check?resource=segment";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, CHECK_SEGMENT_LIMIT, url);
	  };
	};
	
	var createScaleAudience = exports.createScaleAudience = function createScaleAudience(name, tagId, segmentId, dateRange, segments) {
	  var url = "insights/" + tagId + "/segment-distribution/" + segmentId + "/audience-at-scale/" + dateRange + "?name=" + name;
	  if (!(0, _isEmpty2.default)(segments)) {
	    url += "&segments=" + segments;
	  }
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, CREATE_AUDIENCE_AT_SCALE, url, {
	      method: "POST"
	    });
	  };
	};
	
	var createVisitorAudience = exports.createVisitorAudience = function createVisitorAudience(name, tagId, segmentId, dateRange, segments, granularity, page) {
	  var url = "insights/" + tagId + "/segment-distribution/" + segmentId + "/website-visitors/" + dateRange + "?name=" + name;
	  if (!(0, _isEmpty2.default)(segments)) {
	    url += "&segments=" + segments;
	  }
	  url = (0, _utility.pushParamsToUrl)(url, "granularity", granularity);
	  if (page) {
	    url = (0, _utility.pushParamsToUrl)(url, "page", page);
	  }
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, CREATE_AUDIENCE_AT_VISITORS, url, {
	      method: "POST"
	    });
	  };
	};

/***/ },
/* 85 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var apiBaseUrl = exports.apiBaseUrl = 'https://app.audienceanywhere.com/api';
	var optimizeApiBaseUrl = exports.optimizeApiBaseUrl = 'https://api-optimize.audienceanywhere.com';
	var uiBuildNumber = exports.uiBuildNumber = 2595638486;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(369)('wks');
	var uid = __webpack_require__(264);
	var Symbol = __webpack_require__(121).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 87 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 88 */
[3225, 650],
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _events = __webpack_require__(308);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(430);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(712);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.button.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	      }
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused,
	        style: {
	          overflow: 'hidden'
	        },
	        key: 'focusRipple'
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity,
	          key: 'touchRipple'
	        },
	        children
	      ) : undefined;
	
	      return [focusRipple, touchRipple, touchRipple ? undefined : children];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null
	      }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: function ref(node) {
	          return _this2.button = node;
	        },
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onClick: this.handleTouchTap,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      if (href) buttonProps.href = href;
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedButton.propTypes =  false ? {
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  disableFocusRipple: _propTypes2.default.bool,
	  disableKeyboardFocus: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  focusRippleColor: _propTypes2.default.string,
	  focusRippleOpacity: _propTypes2.default.number,
	  href: _propTypes2.default.string,
	  keyboardFocused: _propTypes2.default.bool,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onKeyUp: _propTypes2.default.func,
	  onKeyboardFocus: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	  touchRippleColor: _propTypes2.default.string,
	  touchRippleOpacity: _propTypes2.default.number,
	  type: _propTypes2.default.string
	} : {};
	exports.default = EnhancedButton;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 91 */
29,
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.ConnectedRouter = undefined;
	
	var _reducer = __webpack_require__(961);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(960);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _ConnectedRouter2 = __webpack_require__(3011);
	
	var _ConnectedRouter3 = _interopRequireDefault(_ConnectedRouter2);
	
	var _middleware = __webpack_require__(3012);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConnectedRouter = _ConnectedRouter3.default;
	exports.routerMiddleware = _middleware2.default;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inRangeOfSector = exports.formatAngleOfSector = exports.getAngleOfPoint = exports.distanceBetweenPoints = exports.formatAxisMap = exports.getMaxRadius = exports.polarToCartesian = exports.radianToDegree = exports.degreeToRadian = exports.RADIAN = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _DataUtils = __webpack_require__(40);
	
	var _ChartUtils = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var RADIAN = Math.PI / 180;
	exports.RADIAN = RADIAN;
	
	var degreeToRadian = function degreeToRadian(angle) {
	  return angle * Math.PI / 180;
	};
	
	exports.degreeToRadian = degreeToRadian;
	
	var radianToDegree = function radianToDegree(angleInRadian) {
	  return angleInRadian * 180 / Math.PI;
	};
	
	exports.radianToDegree = radianToDegree;
	
	var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	exports.polarToCartesian = polarToCartesian;
	
	var getMaxRadius = function getMaxRadius(width, height) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  };
	  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
	};
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	
	
	exports.getMaxRadius = getMaxRadius;
	
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height;
	  var startAngle = props.startAngle,
	      endAngle = props.endAngle;
	  var cx = (0, _DataUtils.getPercentValue)(props.cx, width, width / 2);
	  var cy = (0, _DataUtils.getPercentValue)(props.cy, height, height / 2);
	  var maxRadius = getMaxRadius(width, height, offset);
	  var innerRadius = (0, _DataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
	  var ids = Object.keys(axisMap);
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var domain = axis.domain,
	        reversed = axis.reversed;
	    var range;
	
	    if ((0, _isNil2.default)(axis.range)) {
	      if (axisType === 'angleAxis') {
	        range = [startAngle, endAngle];
	      } else if (axisType === 'radiusAxis') {
	        range = [innerRadius, outerRadius];
	      }
	
	      if (reversed) {
	        range = [range[1], range[0]];
	      }
	    } else {
	      range = axis.range;
	      var _range = range;
	
	      var _range2 = _slicedToArray(_range, 2);
	
	      startAngle = _range2[0];
	      endAngle = _range2[1];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        realScaleType = _parseScale.realScaleType,
	        scale = _parseScale.scale;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    var finalAxis = _objectSpread({}, axis, ticks, {
	      range: range,
	      radius: outerRadius,
	      realScaleType: realScaleType,
	      scale: scale,
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
	  var x1 = point.x,
	      y1 = point.y;
	  var x2 = anotherPoint.x,
	      y2 = anotherPoint.y;
	  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	};
	
	exports.distanceBetweenPoints = distanceBetweenPoints;
	
	var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
	  var x = _ref.x,
	      y = _ref.y;
	  var cx = _ref2.cx,
	      cy = _ref2.cy;
	  var radius = distanceBetweenPoints({
	    x: x,
	    y: y
	  }, {
	    x: cx,
	    y: cy
	  });
	
	  if (radius <= 0) {
	    return {
	      radius: radius
	    };
	  }
	
	  var cos = (x - cx) / radius;
	  var angleInRadian = Math.acos(cos);
	
	  if (y > cy) {
	    angleInRadian = 2 * Math.PI - angleInRadian;
	  }
	
	  return {
	    radius: radius,
	    angle: radianToDegree(angleInRadian),
	    angleInRadian: angleInRadian
	  };
	};
	
	exports.getAngleOfPoint = getAngleOfPoint;
	
	var formatAngleOfSector = function formatAngleOfSector(_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return {
	    startAngle: startAngle - min * 360,
	    endAngle: endAngle - min * 360
	  };
	};
	
	exports.formatAngleOfSector = formatAngleOfSector;
	
	var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
	  var startAngle = _ref4.startAngle,
	      endAngle = _ref4.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return angle + min * 360;
	};
	
	var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
	  var x = _ref5.x,
	      y = _ref5.y;
	
	  var _getAngleOfPoint = getAngleOfPoint({
	    x: x,
	    y: y
	  }, sector),
	      radius = _getAngleOfPoint.radius,
	      angle = _getAngleOfPoint.angle;
	
	  var innerRadius = sector.innerRadius,
	      outerRadius = sector.outerRadius;
	
	  if (radius < innerRadius || radius > outerRadius) {
	    return false;
	  }
	
	  if (radius === 0) {
	    return true;
	  }
	
	  var _formatAngleOfSector = formatAngleOfSector(sector),
	      startAngle = _formatAngleOfSector.startAngle,
	      endAngle = _formatAngleOfSector.endAngle;
	
	  var formatAngle = angle;
	  var inRange;
	
	  if (startAngle <= endAngle) {
	    while (formatAngle > endAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < startAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
	  } else {
	    while (formatAngle > startAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < endAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
	  }
	
	  if (inRange) {
	    return _objectSpread({}, sector, {
	      radius: radius,
	      angle: reverseFormatAngleOfSetor(formatAngle, sector)
	    });
	  }
	
	  return null;
	};
	
	exports.inRangeOfSector = inRangeOfSector;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(1022)('wks')
	  , uid    = __webpack_require__(1024)
	  , Symbol = __webpack_require__(116).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionCreator = exports.actionCreator = function actionCreator(type) {
	  return function (value) {
	    return { type: type, value: value };
	  };
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertError = function AlertError(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' })
	  );
	};
	AlertError = (0, _pure2.default)(AlertError);
	AlertError.displayName = 'AlertError';
	AlertError.muiName = 'SvgIcon';
	
	exports.default = AlertError;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values and color names.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	
	   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;
	
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tokenContainer = exports.menuItemContainer = exports.asyncContainer = exports.Typeahead = exports.Token = exports.MenuItem = exports.Menu = exports.AsyncTypeahead = undefined;
	
	var _AsyncTypeahead2 = __webpack_require__(2733);
	
	var _AsyncTypeahead3 = _interopRequireDefault(_AsyncTypeahead2);
	
	var _Menu2 = __webpack_require__(878);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(438);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Token2 = __webpack_require__(879);
	
	var _Token3 = _interopRequireDefault(_Token2);
	
	var _Typeahead2 = __webpack_require__(880);
	
	var _Typeahead3 = _interopRequireDefault(_Typeahead2);
	
	var _asyncContainer2 = __webpack_require__(881);
	
	var _asyncContainer3 = _interopRequireDefault(_asyncContainer2);
	
	var _menuItemContainer2 = __webpack_require__(882);
	
	var _menuItemContainer3 = _interopRequireDefault(_menuItemContainer2);
	
	var _tokenContainer2 = __webpack_require__(883);
	
	var _tokenContainer3 = _interopRequireDefault(_tokenContainer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AsyncTypeahead = _AsyncTypeahead3.default; /* eslint-disable object-curly-spacing */
	
	// Components
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.Token = _Token3.default;
	exports.Typeahead = _Typeahead3.default;
	
	// HOCs
	
	exports.asyncContainer = _asyncContainer3.default;
	exports.menuItemContainer = _menuItemContainer3.default;
	exports.tokenContainer = _tokenContainer3.default;
	
	/* eslint-enable object-curly-spacing */

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(39);
	
	var CallbackQueue = __webpack_require__(894);
	var PooledClass = __webpack_require__(158);
	var ReactFeatureFlags = __webpack_require__(899);
	var ReactReconciler = __webpack_require__(198);
	var Transaction = __webpack_require__(317);
	
	var invariant = __webpack_require__(21);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 100 */
46,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Surface", {
	  enumerable: true,
	  get: function get() {
	    return _Surface2.default;
	  }
	});
	Object.defineProperty(exports, "Layer", {
	  enumerable: true,
	  get: function get() {
	    return _Layer2.default;
	  }
	});
	Object.defineProperty(exports, "Legend", {
	  enumerable: true,
	  get: function get() {
	    return _Legend2.default;
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip2.default;
	  }
	});
	Object.defineProperty(exports, "ResponsiveContainer", {
	  enumerable: true,
	  get: function get() {
	    return _ResponsiveContainer2.default;
	  }
	});
	Object.defineProperty(exports, "Cell", {
	  enumerable: true,
	  get: function get() {
	    return _Cell2.default;
	  }
	});
	Object.defineProperty(exports, "Text", {
	  enumerable: true,
	  get: function get() {
	    return _Text2.default;
	  }
	});
	Object.defineProperty(exports, "Label", {
	  enumerable: true,
	  get: function get() {
	    return _Label2.default;
	  }
	});
	Object.defineProperty(exports, "LabelList", {
	  enumerable: true,
	  get: function get() {
	    return _LabelList2.default;
	  }
	});
	Object.defineProperty(exports, "Customized", {
	  enumerable: true,
	  get: function get() {
	    return _Customized2.default;
	  }
	});
	Object.defineProperty(exports, "Sector", {
	  enumerable: true,
	  get: function get() {
	    return _Sector2.default;
	  }
	});
	Object.defineProperty(exports, "Curve", {
	  enumerable: true,
	  get: function get() {
	    return _Curve2.default;
	  }
	});
	Object.defineProperty(exports, "Rectangle", {
	  enumerable: true,
	  get: function get() {
	    return _Rectangle2.default;
	  }
	});
	Object.defineProperty(exports, "Polygon", {
	  enumerable: true,
	  get: function get() {
	    return _Polygon2.default;
	  }
	});
	Object.defineProperty(exports, "Dot", {
	  enumerable: true,
	  get: function get() {
	    return _Dot2.default;
	  }
	});
	Object.defineProperty(exports, "Cross", {
	  enumerable: true,
	  get: function get() {
	    return _Cross2.default;
	  }
	});
	Object.defineProperty(exports, "Symbols", {
	  enumerable: true,
	  get: function get() {
	    return _Symbols2.default;
	  }
	});
	Object.defineProperty(exports, "PolarGrid", {
	  enumerable: true,
	  get: function get() {
	    return _PolarGrid2.default;
	  }
	});
	Object.defineProperty(exports, "PolarRadiusAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarRadiusAxis2.default;
	  }
	});
	Object.defineProperty(exports, "PolarAngleAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarAngleAxis2.default;
	  }
	});
	Object.defineProperty(exports, "Pie", {
	  enumerable: true,
	  get: function get() {
	    return _Pie2.default;
	  }
	});
	Object.defineProperty(exports, "Radar", {
	  enumerable: true,
	  get: function get() {
	    return _Radar2.default;
	  }
	});
	Object.defineProperty(exports, "RadialBar", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBar2.default;
	  }
	});
	Object.defineProperty(exports, "Brush", {
	  enumerable: true,
	  get: function get() {
	    return _Brush2.default;
	  }
	});
	Object.defineProperty(exports, "ReferenceLine", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceLine2.default;
	  }
	});
	Object.defineProperty(exports, "ReferenceDot", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceDot2.default;
	  }
	});
	Object.defineProperty(exports, "ReferenceArea", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceArea2.default;
	  }
	});
	Object.defineProperty(exports, "CartesianAxis", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianAxis2.default;
	  }
	});
	Object.defineProperty(exports, "CartesianGrid", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianGrid2.default;
	  }
	});
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function get() {
	    return _Line2.default;
	  }
	});
	Object.defineProperty(exports, "Area", {
	  enumerable: true,
	  get: function get() {
	    return _Area2.default;
	  }
	});
	Object.defineProperty(exports, "Bar", {
	  enumerable: true,
	  get: function get() {
	    return _Bar2.default;
	  }
	});
	Object.defineProperty(exports, "Scatter", {
	  enumerable: true,
	  get: function get() {
	    return _Scatter2.default;
	  }
	});
	Object.defineProperty(exports, "XAxis", {
	  enumerable: true,
	  get: function get() {
	    return _XAxis2.default;
	  }
	});
	Object.defineProperty(exports, "YAxis", {
	  enumerable: true,
	  get: function get() {
	    return _YAxis2.default;
	  }
	});
	Object.defineProperty(exports, "ZAxis", {
	  enumerable: true,
	  get: function get() {
	    return _ZAxis2.default;
	  }
	});
	Object.defineProperty(exports, "ErrorBar", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorBar2.default;
	  }
	});
	Object.defineProperty(exports, "LineChart", {
	  enumerable: true,
	  get: function get() {
	    return _LineChart2.default;
	  }
	});
	Object.defineProperty(exports, "BarChart", {
	  enumerable: true,
	  get: function get() {
	    return _BarChart2.default;
	  }
	});
	Object.defineProperty(exports, "PieChart", {
	  enumerable: true,
	  get: function get() {
	    return _PieChart2.default;
	  }
	});
	Object.defineProperty(exports, "Treemap", {
	  enumerable: true,
	  get: function get() {
	    return _Treemap2.default;
	  }
	});
	Object.defineProperty(exports, "Sankey", {
	  enumerable: true,
	  get: function get() {
	    return _Sankey2.default;
	  }
	});
	Object.defineProperty(exports, "RadarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadarChart2.default;
	  }
	});
	Object.defineProperty(exports, "ScatterChart", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterChart2.default;
	  }
	});
	Object.defineProperty(exports, "AreaChart", {
	  enumerable: true,
	  get: function get() {
	    return _AreaChart2.default;
	  }
	});
	Object.defineProperty(exports, "RadialBarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBarChart2.default;
	  }
	});
	Object.defineProperty(exports, "ComposedChart", {
	  enumerable: true,
	  get: function get() {
	    return _ComposedChart2.default;
	  }
	});
	Object.defineProperty(exports, "Funnel", {
	  enumerable: true,
	  get: function get() {
	    return _Funnel2.default;
	  }
	});
	Object.defineProperty(exports, "FunnelChart", {
	  enumerable: true,
	  get: function get() {
	    return _FunnelChart2.default;
	  }
	});
	Object.defineProperty(exports, "Trapezoid", {
	  enumerable: true,
	  get: function get() {
	    return _Trapezoid2.default;
	  }
	});
	
	__webpack_require__(3077);
	
	var _Surface2 = _interopRequireDefault(__webpack_require__(251));
	
	var _Layer2 = _interopRequireDefault(__webpack_require__(43));
	
	var _Legend2 = _interopRequireDefault(__webpack_require__(488));
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(341));
	
	var _ResponsiveContainer2 = _interopRequireDefault(__webpack_require__(3075));
	
	var _Cell2 = _interopRequireDefault(__webpack_require__(205));
	
	var _Text2 = _interopRequireDefault(__webpack_require__(161));
	
	var _Label2 = _interopRequireDefault(__webpack_require__(129));
	
	var _LabelList2 = _interopRequireDefault(__webpack_require__(115));
	
	var _Customized2 = _interopRequireDefault(__webpack_require__(3072));
	
	var _Sector2 = _interopRequireDefault(__webpack_require__(345));
	
	var _Curve2 = _interopRequireDefault(__webpack_require__(206));
	
	var _Rectangle2 = _interopRequireDefault(__webpack_require__(207));
	
	var _Polygon2 = _interopRequireDefault(__webpack_require__(344));
	
	var _Dot2 = _interopRequireDefault(__webpack_require__(162));
	
	var _Cross2 = _interopRequireDefault(__webpack_require__(1005));
	
	var _Symbols2 = _interopRequireDefault(__webpack_require__(489));
	
	var _PolarGrid2 = _interopRequireDefault(__webpack_require__(3076));
	
	var _PolarRadiusAxis2 = _interopRequireDefault(__webpack_require__(343));
	
	var _PolarAngleAxis2 = _interopRequireDefault(__webpack_require__(342));
	
	var _Pie2 = _interopRequireDefault(__webpack_require__(1002));
	
	var _Radar2 = _interopRequireDefault(__webpack_require__(1003));
	
	var _RadialBar2 = _interopRequireDefault(__webpack_require__(1004));
	
	var _Brush2 = _interopRequireDefault(__webpack_require__(996));
	
	var _ReferenceLine2 = _interopRequireDefault(__webpack_require__(1000));
	
	var _ReferenceDot2 = _interopRequireDefault(__webpack_require__(999));
	
	var _ReferenceArea2 = _interopRequireDefault(__webpack_require__(998));
	
	var _CartesianAxis2 = _interopRequireDefault(__webpack_require__(997));
	
	var _CartesianGrid2 = _interopRequireDefault(__webpack_require__(3060));
	
	var _Line2 = _interopRequireDefault(__webpack_require__(486));
	
	var _Area2 = _interopRequireDefault(__webpack_require__(484));
	
	var _Bar2 = _interopRequireDefault(__webpack_require__(485));
	
	var _Scatter2 = _interopRequireDefault(__webpack_require__(487));
	
	var _XAxis2 = _interopRequireDefault(__webpack_require__(203));
	
	var _YAxis2 = _interopRequireDefault(__webpack_require__(204));
	
	var _ZAxis2 = _interopRequireDefault(__webpack_require__(340));
	
	var _ErrorBar2 = _interopRequireDefault(__webpack_require__(250));
	
	var _LineChart2 = _interopRequireDefault(__webpack_require__(3065));
	
	var _BarChart2 = _interopRequireDefault(__webpack_require__(3062));
	
	var _PieChart2 = _interopRequireDefault(__webpack_require__(3066));
	
	var _Treemap2 = _interopRequireDefault(__webpack_require__(3071));
	
	var _Sankey2 = _interopRequireDefault(__webpack_require__(3069));
	
	var _RadarChart2 = _interopRequireDefault(__webpack_require__(3067));
	
	var _ScatterChart2 = _interopRequireDefault(__webpack_require__(3070));
	
	var _AreaChart2 = _interopRequireDefault(__webpack_require__(3061));
	
	var _RadialBarChart2 = _interopRequireDefault(__webpack_require__(3068));
	
	var _ComposedChart2 = _interopRequireDefault(__webpack_require__(3063));
	
	var _Funnel2 = _interopRequireDefault(__webpack_require__(1001));
	
	var _FunnelChart2 = _interopRequireDefault(__webpack_require__(3064));
	
	var _Trapezoid2 = _interopRequireDefault(__webpack_require__(1006));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteDateSelector = function (_AcquireWebComponent) {
	  _inherits(SiteDateSelector, _AcquireWebComponent);
	
	  function SiteDateSelector() {
	    _classCallCheck(this, SiteDateSelector);
	
	    return _possibleConstructorReturn(this, (SiteDateSelector.__proto__ || Object.getPrototypeOf(SiteDateSelector)).apply(this, arguments));
	  }
	
	  _createClass(SiteDateSelector, [{
	    key: "handleWebsiteChange",
	    value: function handleWebsiteChange(e) {
	      this.props.websiteIdChanged(e.value);
	    }
	  }, {
	    key: "handleDayRangeChange",
	    value: function handleDayRangeChange(e) {
	      this.props.dayRangeChanged(e.value);
	    }
	  }, {
	    key: "handleGranularityChange",
	    value: function handleGranularityChange(e) {
	      window.localStorage.setItem("__granularity__", e.value);
	      if (this.props.granularityChanged) {
	        this.props.granularityChanged(e.value);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!this.props.dayRange) {
	        if (this.props.dayRangeChanged) this.props.dayRangeChanged("last-7-days");
	      }
	      if (!this.props.granularity) {
	        if (this.props.granularityChanged) this.props.granularityChanged("scale");
	      }
	
	      if (this.props.websiteIdChanged && (0, _lodash.isUndefined)(this.props.siteId) && this.props.sites && !(0, _lodash.isEmpty)(this.props.sites)) {
	        this.props.websiteIdChanged(this.props.sites[0].value);
	      }
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      if (nextProps.siteId !== this.props.siteId || this.props.sites !== nextProps.sites) {
	        if ((0, _lodash.isUndefined)(nextProps.siteId) && !(0, _lodash.isEmpty)(nextProps.sites)) {
	          this.props.websiteIdChanged(nextProps.sites[0].value);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          sites = _props.sites,
	          type = _props.type,
	          siteId = _props.siteId,
	          showGranularity = _props.showGranularity;
	
	
	      var dayOptions = [{ value: "today", label: "Today" }, { value: "yesterday", label: "Yesterday" }, { value: "last-7-days", label: "Last 7 days" }, { value: "last-30-days", label: "Last 30 days" }, { value: "last-60-days", label: "Last 60 days" }, {
	        value: "last-90-days",
	        label: "Last 90 days" /*,
	                              { value: '180', label: 'Last 6 months' },
	                              { value: '360', label: 'Year to date' }*/
	      }];
	      var granularityOptions = [{ value: "precision", label: "Precision" }, { value: "scale", label: "Scale" }];
	      var site = (0, _lodash.find)(sites, function (s) {
	        return s.value === siteId;
	      });
	      var rows = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _Grid.Row,
	          {
	            style: Object.assign({
	              paddingRight: "10px",
	              paddingLeft: "0",
	              marginBottom: "0"
	            }, this.props.style)
	          },
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "8", sm: "8", md: "8", lg: "8", className: "date-site-container" },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "inline-block",
	                  width: type === "larger" ? "400px" : "300px"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "inline-block",
	                    position: "absolute",
	                    top: "10px"
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Website Name"
	                )
	              ),
	              this.props.websiteIdChanged ? _react2.default.createElement(_reactSelect2.default, {
	                className: type === "larger" ? "insights-site-selector website-selector left-130" : "insights-site-selector website-selector left-110",
	                name: "",
	                value: this.props.siteId ? this.props.siteId : 1,
	                clearable: false,
	                options: sites,
	                onChange: this.handleWebsiteChange.bind(this)
	              }) : _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "inline-block",
	                    position: "absolute",
	                    top: "10px",
	                    left: "150px"
	                  }
	                },
	                site ? site.label : ""
	              )
	            ),
	            !showGranularity && this.props.dayRange && _react2.default.createElement(
	              "div",
	              { style: { display: "inline-block", width: "250px" } },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "inline-block",
	                    position: "absolute",
	                    top: "10px"
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Date"
	                )
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                className: "insights-site-selector left-50",
	                name: "",
	                value: this.props.dayRange ? this.props.dayRange : "last-7-days",
	                clearable: false,
	                options: dayOptions,
	                onChange: this.handleDayRangeChange.bind(this)
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "4", sm: "4", md: "4", lg: "4", className: "pt-5 no-padding-right" },
	            this.props.handlePdfDownload && _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                className: "aw-btn pull-right",
	                onClick: function onClick() {
	                  _this2.props.handlePdfDownload();
	                }
	              },
	              this.props.downloadBtnText
	            ),
	            this.props.handleSegmentCreation && _react2.default.createElement(
	              _rcTooltip2.default,
	              { overlay: _react2.default.createElement(
	                  "div",
	                  null,
	                  "This feature is currently unavailable. Please reach out to your account manager to request an audience file."
	                ), placement: "top" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "aw-btn pull-right mr-20",
	                  style: { textTransform: "none", background: 'lightgray', cursor: 'no-drop' }
	                },
	                "Create an Audience"
	              )
	            )
	          )
	        ),
	        showGranularity && _react2.default.createElement(
	          _Grid.FullRow,
	          {
	            className: "no-padding-left light-grey-top-border light-grey-bottom-border"
	          },
	          this.props.dayRange && _react2.default.createElement(
	            "div",
	            { style: { display: "inline-block", width: "340px" } },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "inline-block"
	                }
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Date"
	              )
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              className: "insights-date-selector left-30",
	              name: "",
	              value: this.props.dayRange ? this.props.dayRange : "last-7-days",
	              clearable: false,
	              options: dayOptions,
	              onChange: this.handleDayRangeChange.bind(this)
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { display: " inline-block", width: "250px" } },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "inline-block",
	                  position: "absolute",
	                  top: "0px"
	                }
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Granularity"
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                className: "insights-granularity-selector left-30",
	                name: "",
	                value: this.props.granularity,
	                clearable: false,
	                options: granularityOptions,
	                onChange: this.handleGranularityChange.bind(this)
	              })
	            )
	          )
	        )
	      );
	
	      return rows;
	    }
	  }]);
	
	  return SiteDateSelector;
	}(_MaterialUI2.default);
	
	SiteDateSelector.propTypes = {
	  websiteIdChanged: _react2.default.PropTypes.func,
	  dayRangeChanged: _react2.default.PropTypes.func,
	  granularityChanged: _react2.default.PropTypes.func,
	  siteId: _react2.default.PropTypes.number,
	  sites: _react2.default.PropTypes.array,
	  dayRange: _react2.default.PropTypes.string,
	  type: _react2.default.PropTypes.string,
	  handlePdfDownload: _react2.default.PropTypes.func,
	  downloadBtnText: _react2.default.PropTypes.string,
	  showGranularity: _react2.default.PropTypes.bool.isRequired,
	  granularity: _react2.default.PropTypes.string.isRequired
	};
	
	SiteDateSelector.defaultProps = {
	  downloadBtnText: "Download",
	  showGranularity: false,
	  granularity: "scale"
	};
	
	exports.default = SiteDateSelector;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _playArrow = __webpack_require__(156);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	__webpack_require__(1450);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * page component
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property nextBeClick {function} this callback of click `next` button, pageNumber will be pass as params.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property pageCount {number} last page number
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property nextGroupBeClick {function} callback, next group button be click. pageNumber will be pass as params.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property previousGroupBeClick {function} callback, prev group button be click. pageNumber will be pass as params.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property previousBeClick {function} callback, previous button be click. pageNumber will be pass as params.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property pageBeClick {function} callback, page number be click, pageNumber will be pass as params.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property total {number} total value.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property hasNext {boolean} if has next page
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property hasPrevious {boolean} if has previous
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property style {obj} page root element style object.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property pagePlus {boolean} if true UI will be display same as px-93's UI.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property selectRows {function} callback , params: 1.pageNumber 2.row value.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property goToPage {function} callback params: pageNumber
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property pageSize {number}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// css
	
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.state = {
	      ifHasNextGroup: true, // next button display control, default has next group icon
	      ifHasPreGroup: false, // previous button display control, default no previous group icon
	      pageCount: [1, 2, 3, 4, 5, 6],
	      activeIndex: 1, //record pageNumber
	      open: false,
	      reactiveOpen: false,
	      rows: 10
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refs.goToPage.value = this.state.activeIndex;
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      // if pageCount less than six show pageCount length
	      if (nextProps.pageCount <= this.state.pageCount.length) {
	        var len = nextProps.pageCount;
	        var obj = [];
	        for (var i = 0; i < len; i++) {
	          obj.push(i + 1);
	        }
	        this.setState({
	          pageCount: obj,
	          ifHasNextGroup: false
	        });
	      }
	      if (nextProps.reactive_success && !nextProps.reactive_on_progress) {
	        this.setState({
	          reactiveSuccessOpen: true,
	          reactiveOpen: false
	        });
	      }
	      // if (typeof nextProps.pageNumber === 'number' && nextProps.pageNumber !== this.state.activeIndex) {
	      //   this.setState({
	      //     activeIndex: nextProps.pageNumber
	      //   }, () => {
	      //     this.refs.goToPage.value = this.state.activeIndex;
	      //   })
	      // }
	    }
	  }, {
	    key: "goToNext",
	    value: function goToNext() {
	      var _this2 = this;
	
	      // if activeIndex greater than total return
	      // if (this.state.activeIndex % 6 === 0) {
	      //   this.state.activeIndex++;
	      //   this.nextToGroup()
	      // } else {
	      //   this.props.nextBeClick(this.state.activeIndex++)
	      // }
	      this.setState({
	        activeIndex: ++this.state.activeIndex
	      }, function () {
	        _this2.props.nextBeClick(_this2.state.activeIndex);
	        _this2.refs.goToPage.value = _this2.state.activeIndex;
	      });
	    }
	  }, {
	    key: "nextToGroup",
	    value: function nextToGroup() {
	      var _this3 = this;
	
	      // when more than six add item
	      var count = [];
	      // add callback for setState function
	      count = this.state.pageCount.map(function (item) {
	        return item + 6;
	      }).filter(function (item) {
	        return item <= _this3.props.pageCount;
	      });
	      this.setState({
	        pageCount: count,
	        activeIndex: count[0]
	      }, function () {
	        if (_this3.state.pageCount[0] > 6) {
	          _this3.setState({
	            ifHasPreGroup: true //set pre group icon available
	          });
	        }
	        if (_this3.state.pageCount[_this3.state.pageCount.length - 1] === _this3.props.pageCount) {
	          _this3.setState({
	            ifHasNextGroup: false //set next group icon invalid
	          });
	        }
	        _this3.props.nextGroupBeClick(_this3.state.activeIndex);
	      });
	    }
	  }, {
	    key: "previousToGroup",
	    value: function previousToGroup() {
	      var _this4 = this;
	
	      var count = void 0;
	      if (this.state.pageCount.length < 6) {
	        count = [];
	        for (var i = 5; i >= 0; i--) {
	          count.push(this.state.pageCount[0] - 1 - i);
	        }
	      } else {
	        count = this.state.pageCount.map(function (item) {
	          return item - 6;
	        });
	      }
	      // add callback for setState function
	      this.setState({
	        pageCount: count,
	        activeIndex: count[0]
	      }, function () {
	        _this4.props.previousGroupBeClick(_this4.state.activeIndex);
	        // when click previous group icon and no previous page hidden icon
	        if (_this4.state.activeIndex === 1) {
	          _this4.setState({
	            ifHasPreGroup: false
	          });
	        }
	        if (_this4.state.pageCount[_this4.state.pageCount.length - 1] < _this4.props.pageCount) {
	          _this4.setState({
	            ifHasNextGroup: true //set next group icon invalid
	          });
	        }
	      });
	    }
	  }, {
	    key: "goToPrevious",
	    value: function goToPrevious() {
	      var _this5 = this;
	
	      // if (this.state.activeIndex % 6 === 1) {
	      //   this.previousToGroup()
	      // } else {
	      //   this.props.previousBeClick(--this.state.activeIndex);
	      // }
	      this.setState({
	        activeIndex: --this.state.activeIndex
	      }, function () {
	        _this5.props.previousBeClick(_this5.state.activeIndex);
	        _this5.refs.goToPage.value = _this5.state.activeIndex;
	      });
	    }
	  }, {
	    key: "handleClickPage",
	    value: function handleClickPage(page) {
	      this.props.pageBeClick(page);
	      this.setState({
	        activeIndex: page
	      });
	    }
	  }, {
	    key: "handleSelectRows",
	    value: function handleSelectRows(e, index, value) {
	      this.setState({
	        rows: value
	      });
	      this.props.selectRows(this.state.activeIndex, value);
	    }
	  }, {
	    key: "handlePageInput",
	    value: function handlePageInput(e) {
	      if (!/[0-9]$/g.test(e.target.value)) {
	        this.refs.goToPage.value = "";
	      }
	    }
	  }, {
	    key: "handlePageNumberConfirm",
	    value: function handlePageNumberConfirm(e) {
	      if (e.keyCode === 13) {
	        if (e.target.value <= this.props.pageCount && e.target.value > 0) {
	          this.props.goToPage(e.target.value);
	          this.setState({
	            activeIndex: +e.target.value
	          });
	        } else {
	          this.refs.goToPage.value = "";
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "page clearfix", style: this.props.style },
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            modal: false,
	            open: this.state.reactiveSuccessOpen,
	            contentStyle: { width: "480px" }
	          },
	          _react2.default.createElement(
	            "p",
	            {
	              style: {
	                color: "black",
	                textAlign: "center",
	                fontSize: "16px",
	                fontWeight: "bold"
	              }
	            },
	            "Depending on the audience size, ",
	            _react2.default.createElement("br", null),
	            "reactivation may take several hours before",
	            _react2.default.createElement("br", null),
	            "changing status from Pending to Active"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "btns",
	              style: { textAlign: "center", marginTop: "1em" }
	            },
	            _react2.default.createElement(_FlatButton2.default, {
	              label: "Close",
	              backgroundColor: "#00A3AD",
	              labelStyle: {
	                color: "#FFF",
	                padding: 0,
	                verticalAlign: "inherit",
	                textTransform: "capitalize"
	              },
	              onClick: function onClick() {
	                _this6.setState({
	                  reactiveSuccessOpen: false
	                }, function () {
	                  _this6.props.history.push("/segments/list/active");
	                });
	              },
	              hoverColor: "#00A3AD"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            modal: false,
	            open: this.state.open,
	            onRequestClose: this.handleClose,
	            contentStyle: { width: "39%" }
	          },
	          _react2.default.createElement(
	            "p",
	            {
	              style: {
	                color: "black",
	                textAlign: "center",
	                fontSize: "16px",
	                fontWeight: "bold"
	              }
	            },
	            "Click confirm to archive this audience"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "btns",
	              style: { textAlign: "center", marginTop: "1em" }
	            },
	            _react2.default.createElement(_FlatButton2.default, {
	              label: "Cancel",
	              backgroundColor: "#FFF",
	              labelStyle: { color: "black", textTransform: "capitalize" },
	              onClick: function onClick() {
	                _this6.setState({ open: false });
	              },
	              hoverColor: "#FFF",
	              className: "btn-aa-info mr-20"
	            }),
	            _react2.default.createElement(_FlatButton2.default, {
	              label: "Archive Segment",
	              backgroundColor: "#00A3AD",
	              labelStyle: {
	                color: "#FFF",
	                padding: "10px",
	                verticalAlign: "inherit",
	                textTransform: "capitalize"
	              },
	              onClick: function onClick() {
	                _this6.props.archiveFun();
	                setTimeout(function () {
	                  this.setState({ open: false });
	                }.bind(_this6), 1000);
	              },
	              hoverColor: "#00A3AD"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            modal: false,
	            open: this.state.reactiveOpen,
	            onRequestClose: this.handleClose,
	            contentStyle: { width: "39%" }
	          },
	          _react2.default.createElement(
	            "p",
	            {
	              style: {
	                color: "black",
	                textAlign: "center",
	                fontSize: "16px",
	                fontWeight: "bold"
	              }
	            },
	            "Click confirm to unarchive this audience"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "btns",
	              style: { textAlign: "center", marginTop: "1em" }
	            },
	            _react2.default.createElement(_FlatButton2.default, {
	              label: "Cancel",
	              backgroundColor: "#FFF",
	              labelStyle: { color: "black", textTransform: "capitalize" },
	              onClick: function onClick() {
	                _this6.setState({ reactiveOpen: false });
	              },
	              hoverColor: "#FFF",
	              className: "btn-aa-info mr-20"
	            }),
	            _react2.default.createElement(_FlatButton2.default, {
	              label: "Confirm",
	              backgroundColor: "#00A3AD",
	              disabled: this.props.reactive_on_progress,
	              labelStyle: {
	                color: "#FFF",
	                padding: 0,
	                verticalAlign: "inherit",
	                textTransform: "capitalize"
	              },
	              onClick: function onClick() {
	                _this6.props.unArchiveFun(_this6.props.segmentIds.values().next().value);
	              },
	              hoverColor: "#00A3AD"
	            })
	          )
	        ),
	        this.props.pagePlus ?
	        // for new page ui
	        _react2.default.createElement(
	          "div",
	          { className: "page-plus clearfix" },
	          this.props.segmentIds && this.props.archiveFun && _react2.default.createElement(
	            "a",
	            {
	              className: "btn btn-default btn-aa-default ml-20",
	              style: { float: "left" },
	              disabled: this.props.segmentIds.size <= 0,
	              onClick: function onClick() {
	                _this6.setState({ open: true });
	              }
	            },
	            "Archive"
	          ),
	          this.props.segmentIds && this.props.editFun && _react2.default.createElement(
	            "a",
	            {
	              className: "btn btn-default btn-aa-default ml-20",
	              style: { float: "left" },
	              disabled: this.props.segmentIds.size <= 0,
	              onClick: function onClick() {
	                _this6.props.editFun(_this6.props.segmentIds.values().next().value);
	              }
	            },
	            "Edit"
	          ),
	          this.props.segmentIds && this.props.unArchiveFun && _react2.default.createElement(
	            "a",
	            {
	              className: "btn btn-default btn-aa-default ml-20",
	              style: { float: "left" },
	              disabled: this.props.segmentIds.size <= 0,
	              onClick: function onClick() {
	                _this6.setState({ reactiveOpen: true });
	              }
	            },
	            "Reactivate"
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              onClick: function onClick() {
	                return _this6.goToNext();
	              },
	              style: {
	                display: this.state.activeIndex < this.props.pageCount ? "block" : "none"
	              }
	            },
	            this.props.pagePlus ? _react2.default.createElement(_playArrow2.default, {
	              style: {
	                width: "14px",
	                height: "14px",
	                border: "1px solid #B1B0B0",
	                background: "#E3E3E3"
	              }
	            }) : "Next"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "page-count" },
	            "of ",
	            this.props.pageCount > 0 ? this.props.pageCount : "1"
	          ),
	          this.props.pagePlus && _react2.default.createElement(
	            "div",
	            { className: "page-go-to clearfix" },
	            _react2.default.createElement(
	              "small",
	              null,
	              "Pages"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: function onChange(e) {
	                return _this6.handlePageInput(e);
	              },
	              ref: "goToPage",
	              onKeyUp: function onKeyUp(e) {
	                return _this6.handlePageNumberConfirm(e);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              onClick: function onClick() {
	                return _this6.goToPrevious();
	              },
	              style: { display: this.state.activeIndex > 1 ? "block" : "none" }
	            },
	            this.props.pagePlus ? _react2.default.createElement(_playArrow2.default, {
	              style: {
	                width: "14px",
	                height: "14px",
	                border: "1px solid #B1B0B0",
	                background: "#E3E3E3",
	                transform: "rotate(180deg)"
	              }
	            }) : "Pre"
	          )
	        ) : _react2.default.createElement(
	          "div",
	          { className: "page-normal" },
	          _react2.default.createElement(
	            "button",
	            {
	              onClick: function onClick() {
	                return _this6.goToNext();
	              },
	              style: { display: this.props.hasNext ? "block" : "none" }
	            },
	            this.props.pagePlus ? _react2.default.createElement(_playArrow2.default, {
	              style: {
	                width: "14px",
	                height: "14px",
	                border: "1px solid #B1B0B0",
	                background: "#E3E3E3"
	              }
	            }) : "Next"
	          ),
	          _react2.default.createElement(
	            "ul",
	            { className: "page-link clearfix" },
	            this.state.pageCount.map(function (item, index) {
	              return _react2.default.createElement(
	                "li",
	                {
	                  key: index,
	                  className: _this6.state.activeIndex === item ? "active" : "",
	                  onClick: function onClick() {
	                    return _this6.handleClickPage(item);
	                  }
	                },
	                item
	              );
	            })
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              onClick: function onClick() {
	                return _this6.goToPrevious();
	              },
	              style: { display: this.props.hasPrevious ? "block" : "none" }
	            },
	            this.props.pagePlus ? _react2.default.createElement(_playArrow2.default, {
	              style: {
	                width: "14px",
	                height: "14px",
	                border: "1px solid #B1B0B0",
	                background: "#E3E3E3",
	                transform: "rotate(180deg)"
	              }
	            }) : "Pre"
	          ),
	          this.props.total > 10 ? _react2.default.createElement(
	            "div",
	            { className: "page-count" },
	            this.props.pageSize * this.state.activeIndex - (this.props.pageSize - 1),
	            " ",
	            "-",
	            " ",
	            this.state.activeIndex * this.props.pageSize > this.props.total ? this.props.total : this.state.activeIndex * this.props.pageSize,
	            " ",
	            "of ",
	            this.props.total
	          ) : this.props.total > 0 ? _react2.default.createElement(
	            "div",
	            { className: "page-count" },
	            "1-",
	            this.props.total,
	            " of ",
	            this.props.total
	          ) : _react2.default.createElement(
	            "div",
	            { className: "page-count" },
	            "&nbps;"
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 104 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(180),
	    getRawTag = __webpack_require__(1590),
	    objectToString = __webpack_require__(1617);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 106 */
[3233, 28, 415],
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;
	
	var _RadioButton2 = __webpack_require__(425);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(426);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.default = _RadioButton3.default;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(1521);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(97);
	
	var _lightBaseTheme = __webpack_require__(1750);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(714);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(2683);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(2686);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(2687);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(3081);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(1751);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700,
	      opacity: 0.9
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme // To provide backward compatibility.
	  });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentClear = function ContentClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
	  );
	};
	ContentClear = (0, _pure2.default)(ContentClear);
	ContentClear.displayName = 'ContentClear';
	ContentClear.muiName = 'SvgIcon';
	
	exports.default = ContentClear;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.23
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(5)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.23",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
			
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var PooledClass = __webpack_require__(158);
	
	var emptyFunction = __webpack_require__(87);
	var warning = __webpack_require__(34);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _classCallCheck = _interopDefault(__webpack_require__(1034));
	var _createClass = _interopDefault(__webpack_require__(1035));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(1040));
	var _inherits = _interopDefault(__webpack_require__(1037));
	var _typeof = _interopDefault(__webpack_require__(503));
	var _objectWithoutProperties = _interopDefault(__webpack_require__(1039));
	var _objectSpread = _interopDefault(__webpack_require__(1038));
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(4));
	var shallowEqual = _interopDefault(__webpack_require__(175));
	var warning = _interopDefault(__webpack_require__(37));
	
	function defineProperty(object, property, attr) {
	  return Object.defineProperty(object, property, attr);
	} // Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	
	
	var passiveOption = function () {
	  var cache = null;
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, defineProperty({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (err) {//
	    }
	
	    cache = supportsPassiveOption;
	    return supportsPassiveOption;
	  }();
	}();
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	
	function mergeDefaultEventOptions(options) {
	  return _objectSpread({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function off(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = _objectWithoutProperties(props, ["children", "target"]);
	
	  Object.keys(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	
	    var type = _typeof(prop);
	
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({
	        capture: capture
	      }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(EventListener, _React$Component);
	
	  function EventListener() {
	    _classCallCheck(this, EventListener);
	
	    return _possibleConstructorReturn(this, (EventListener.__proto__ || Object.getPrototypeOf(EventListener)).apply(this, arguments));
	  }
	
	  _createClass(EventListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return !shallowEqual(this.props, nextProps);
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: "addListeners",
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: "removeListeners",
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: "applyListeners",
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return EventListener;
	}(React.Component);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: PropTypes.node,
	
	  /**
	   * The DOM target to listen to.
	   */
	  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
	} : {};
	
	exports.withOptions = withOptions;
	exports.default = EventListener;


/***/ },
/* 113 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(664));
	
	var _find2 = _interopRequireDefault(__webpack_require__(47));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(67));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _range2 = _interopRequireDefault(__webpack_require__(674));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(1653));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _Surface = _interopRequireDefault(__webpack_require__(251));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(341));
	
	var _Legend = _interopRequireDefault(__webpack_require__(488));
	
	var _Curve = _interopRequireDefault(__webpack_require__(206));
	
	var _Cross = _interopRequireDefault(__webpack_require__(1005));
	
	var _Sector = _interopRequireDefault(__webpack_require__(345));
	
	var _Dot = _interopRequireDefault(__webpack_require__(162));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(207));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _CartesianAxis = _interopRequireDefault(__webpack_require__(997));
	
	var _Brush = _interopRequireDefault(__webpack_require__(996));
	
	var _DOMUtils = __webpack_require__(346);
	
	var _DataUtils = __webpack_require__(40);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _PolarUtils = __webpack_require__(93);
	
	var _PureRender = __webpack_require__(26);
	
	var _Events = __webpack_require__(3080);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	var originCoordinate = {
	  x: 0,
	  y: 0
	};
	
	var generateCategoricalChart = function generateCategoricalChart(_ref) {
	  var chartName = _ref.chartName,
	      GraphicalChild = _ref.GraphicalChild,
	      _ref$eventType = _ref.eventType,
	      eventType = _ref$eventType === void 0 ? 'axis' : _ref$eventType,
	      axisComponents = _ref.axisComponents,
	      legendContent = _ref.legendContent,
	      formatAxisMap = _ref.formatAxisMap,
	      defaultProps = _ref.defaultProps,
	      propTypes = _ref.propTypes;
	
	  var CategoricalChartWrapper =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    /**
	     * Returns default, reset state for the categorical chart.
	     * @param {Object} props Props object to use when creating the default state
	     * @return {Object} Whole new state
	     */
	    function CategoricalChartWrapper(_props) {
	      var _this;
	
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoricalChartWrapper).call(this, _props));
	
	      _this.handleLegendBBoxUpdate = function (box) {
	        if (box && _this.legendInstance) {
	          var _this$state = _this.state,
	              dataStartIndex = _this$state.dataStartIndex,
	              dataEndIndex = _this$state.dataEndIndex,
	              updateId = _this$state.updateId;
	
	          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
	            props: _this.props,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex,
	            updateId: updateId
	          }));
	        }
	      };
	
	      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
	        var _this$props = _this.props,
	            syncId = _this$props.syncId,
	            layout = _this$props.layout;
	        var updateId = _this.state.updateId;
	
	        if (syncId === cId && chartId !== _this.uniqueChartId) {
	          var dataStartIndex = data.dataStartIndex,
	              dataEndIndex = data.dataEndIndex;
	
	          if (!(0, _isNil2.default)(data.dataStartIndex) || !(0, _isNil2.default)(data.dataEndIndex)) {
	            _this.setState(_objectSpread({
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex,
	              updateId: updateId
	            })));
	          } else if (!(0, _isNil2.default)(data.activeTooltipIndex)) {
	            var chartX = data.chartX,
	                chartY = data.chartY,
	                activeTooltipIndex = data.activeTooltipIndex;
	            var _this$state2 = _this.state,
	                offset = _this$state2.offset,
	                tooltipTicks = _this$state2.tooltipTicks;
	
	            if (!offset) {
	              return;
	            }
	
	            var viewBox = _objectSpread({}, offset, {
	              x: offset.left,
	              y: offset.top
	            }); // When a categotical chart is combined with another chart, the value of chartX
	            // and chartY may beyond the boundaries.
	
	
	            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	
	            var activePayload = _this.getTooltipContent(activeTooltipIndex);
	
	            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	            } : originCoordinate;
	
	            _this.setState(_objectSpread({}, data, {
	              activeLabel: activeLabel,
	              activeCoordinate: activeCoordinate,
	              activePayload: activePayload
	            }));
	          } else {
	            _this.setState(data);
	          }
	        }
	      };
	
	      _this.handleBrushChange = function (_ref2) {
	        var startIndex = _ref2.startIndex,
	            endIndex = _ref2.endIndex;
	
	        // Only trigger changes if the extents of the brush have actually changed
	        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
	          var updateId = _this.state.updateId;
	
	          _this.setState(function () {
	            return _objectSpread({
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex,
	              updateId: updateId
	            }));
	          });
	
	          _this.triggerSyncEvent({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          });
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        var mouse = _this.getMouseInfo(e);
	
	        if (mouse) {
	          var nextState = _objectSpread({}, mouse, {
	            isTooltipActive: true
	          });
	
	          _this.setState(nextState);
	
	          _this.triggerSyncEvent(nextState);
	
	          if ((0, _isFunction2.default)(onMouseEnter)) {
	            onMouseEnter(nextState, e);
	          }
	        }
	      };
	
	      _this.triggeredAfterMouseMove = function (e) {
	        var onMouseMove = _this.props.onMouseMove;
	
	        var mouse = _this.getMouseInfo(e);
	
	        var nextState = mouse ? _objectSpread({}, mouse, {
	          isTooltipActive: true
	        }) : {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2.default)(onMouseMove)) {
	          onMouseMove(nextState, e);
	        }
	      };
	
	      _this.handleItemMouseEnter = function (el) {
	        _this.setState(function () {
	          return {
	            isTooltipActive: true,
	            activeItem: el,
	            activePayload: el.tooltipPayload,
	            activeCoordinate: el.tooltipPosition || {
	              x: el.cx,
	              y: el.cy
	            }
	          };
	        });
	      };
	
	      _this.handleItemMouseLeave = function () {
	        _this.setState(function () {
	          return {
	            isTooltipActive: false
	          };
	        });
	      };
	
	      _this.handleMouseMove = function (e) {
	        if (e && (0, _isFunction2.default)(e.persist)) {
	          e.persist();
	        }
	
	        _this.triggeredAfterMouseMove(e);
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	        var nextState = {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2.default)(onMouseLeave)) {
	          onMouseLeave(nextState, e);
	        }
	      };
	
	      _this.handleOuterEvent = function (e) {
	        var eventName = (0, _ReactUtils.getReactEventByType)(e);
	
	        if (eventName && (0, _isFunction2.default)(_this.props[eventName])) {
	          var mouse = _this.getMouseInfo(e);
	
	          var handler = _this.props[eventName];
	          handler(mouse, e);
	        }
	      };
	
	      _this.handleClick = function (e) {
	        var onClick = _this.props.onClick;
	
	        if ((0, _isFunction2.default)(onClick)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onClick(mouse, e);
	        }
	      };
	
	      _this.handleMouseDown = function (e) {
	        var onMouseDown = _this.props.onMouseDown;
	
	        if ((0, _isFunction2.default)(onMouseDown)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseDown(mouse, e);
	        }
	      };
	
	      _this.handleMouseUp = function (e) {
	        var onMouseUp = _this.props.onMouseUp;
	
	        if ((0, _isFunction2.default)(onMouseUp)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseUp(mouse, e);
	        }
	      };
	
	      _this.handleTouchMove = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseMove(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchStart = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseDown(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchEnd = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseUp(e.changedTouches[0]);
	        }
	      };
	
	      _this.verticalCoordinatesGenerator = function (_ref3) {
	        var xAxis = _ref3.xAxis,
	            width = _ref3.width,
	            height = _ref3.height,
	            offset = _ref3.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis.default.getTicks(_objectSpread({}, _CartesianAxis.default.defaultProps, xAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(xAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.left, offset.left + offset.width);
	      };
	
	      _this.horizontalCoordinatesGenerator = function (_ref4) {
	        var yAxis = _ref4.yAxis,
	            width = _ref4.width,
	            height = _ref4.height,
	            offset = _ref4.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis.default.getTicks(_objectSpread({}, _CartesianAxis.default.defaultProps, yAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(yAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.top, offset.top + offset.height);
	      };
	
	      _this.axesTicksGenerator = function (axis) {
	        return (0, _ChartUtils.getTicksOfAxis)(axis, true);
	      };
	
	      _this.tooltipTicksGenerator = function (axisMap) {
	        var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	        var tooltipTicks = (0, _ChartUtils.getTicksOfAxis)(axis, false, true);
	        return {
	          tooltipTicks: tooltipTicks,
	          orderedTooltipTicks: (0, _sortBy2.default)(tooltipTicks, function (o) {
	            return o.coordinate;
	          }),
	          tooltipAxis: axis,
	          tooltipAxisBandSize: (0, _ChartUtils.getBandSizeOfAxis)(axis)
	        };
	      };
	
	      _this.renderCursor = function (element) {
	        var _this$state3 = _this.state,
	            isTooltipActive = _this$state3.isTooltipActive,
	            activeCoordinate = _this$state3.activeCoordinate,
	            activePayload = _this$state3.activePayload,
	            offset = _this$state3.offset;
	
	        if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
	          return null;
	        }
	
	        var layout = _this.props.layout;
	        var restProps;
	        var cursorComp = _Curve.default;
	
	        if (chartName === 'ScatterChart') {
	          restProps = activeCoordinate;
	          cursorComp = _Cross.default;
	        } else if (chartName === 'BarChart') {
	          restProps = _this.getCursorRectangle();
	          cursorComp = _Rectangle.default;
	        } else if (layout === 'radial') {
	          var _this$getCursorPoints = _this.getCursorPoints(),
	              cx = _this$getCursorPoints.cx,
	              cy = _this$getCursorPoints.cy,
	              radius = _this$getCursorPoints.radius,
	              startAngle = _this$getCursorPoints.startAngle,
	              endAngle = _this$getCursorPoints.endAngle;
	
	          restProps = {
	            cx: cx,
	            cy: cy,
	            startAngle: startAngle,
	            endAngle: endAngle,
	            innerRadius: radius,
	            outerRadius: radius
	          };
	          cursorComp = _Sector.default;
	        } else {
	          restProps = {
	            points: _this.getCursorPoints()
	          };
	          cursorComp = _Curve.default;
	        }
	
	        var key = element.key || '_recharts-cursor';
	
	        var cursorProps = _objectSpread({
	          stroke: '#ccc',
	          pointerEvents: 'none'
	        }, offset, restProps, (0, _ReactUtils.getPresentationAttributes)(element.props.cursor), {
	          payload: activePayload,
	          key: key,
	          className: 'recharts-tooltip-cursor'
	        });
	
	        return (0, _react.isValidElement)(element.props.cursor) ? (0, _react.cloneElement)(element.props.cursor, cursorProps) : (0, _react.createElement)(cursorComp, cursorProps);
	      };
	
	      _this.renderPolarAxis = function (element, displayName, index) {
	        var axisType = element.type.axisType;
	
	        var axisMap = _this.state["".concat(axisType, "Map")];
	
	        var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
	        return (0, _react.cloneElement)(element, _objectSpread({}, axisOption, {
	          className: axisType,
	          key: element.key || "".concat(displayName, "-").concat(index),
	          ticks: (0, _ChartUtils.getTicksOfAxis)(axisOption, true)
	        }));
	      };
	
	      _this.renderXAxis = function (element, displayName, index) {
	        var xAxisMap = _this.state.xAxisMap;
	        var axisObj = xAxisMap[element.props.xAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderYAxis = function (element, displayName, index) {
	        var yAxisMap = _this.state.yAxisMap;
	        var axisObj = yAxisMap[element.props.yAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderGrid = function (element) {
	        var _this$state4 = _this.state,
	            xAxisMap = _this$state4.xAxisMap,
	            yAxisMap = _this$state4.yAxisMap,
	            offset = _this$state4.offset;
	        var _this$props2 = _this.props,
	            width = _this$props2.width,
	            height = _this$props2.height;
	        var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	        var yAxisWithFiniteDomain = (0, _find2.default)(yAxisMap, function (axis) {
	          return (0, _every2.default)(axis.domain, Number.isFinite);
	        });
	        var yAxis = yAxisWithFiniteDomain || (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	        var props = element.props || {};
	        return (0, _react.cloneElement)(element, {
	          key: element.key || 'grid',
	          x: (0, _DataUtils.isNumber)(props.x) ? props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(props.y) ? props.y : offset.top,
	          width: (0, _DataUtils.isNumber)(props.width) ? props.width : offset.width,
	          height: (0, _DataUtils.isNumber)(props.height) ? props.height : offset.height,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          offset: offset,
	          chartWidth: width,
	          chartHeight: height,
	          verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
	          horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
	        });
	      };
	
	      _this.renderPolarGrid = function (element) {
	        var _this$state5 = _this.state,
	            radiusAxisMap = _this$state5.radiusAxisMap,
	            angleAxisMap = _this$state5.angleAxisMap;
	        var radiusAxis = (0, _DataUtils.getAnyElementOfObject)(radiusAxisMap);
	        var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	        var cx = angleAxis.cx,
	            cy = angleAxis.cy,
	            innerRadius = angleAxis.innerRadius,
	            outerRadius = angleAxis.outerRadius;
	        return (0, _react.cloneElement)(element, {
	          polarAngles: (0, _ChartUtils.getTicksOfAxis)(angleAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          polarRadius: (0, _ChartUtils.getTicksOfAxis)(radiusAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          key: element.key || 'polar-grid'
	        });
	      };
	
	      _this.renderBrush = function (element) {
	        var _this$props3 = _this.props,
	            margin = _this$props3.margin,
	            data = _this$props3.data;
	        var _this$state6 = _this.state,
	            offset = _this$state6.offset,
	            dataStartIndex = _this$state6.dataStartIndex,
	            dataEndIndex = _this$state6.dataEndIndex,
	            updateId = _this$state6.updateId; // TODO: update brush when children update
	
	        return (0, _react.cloneElement)(element, {
	          key: element.key || '_recharts-brush',
	          onChange: (0, _ChartUtils.combineEventHandlers)(_this.handleBrushChange, null, element.props.onChange),
	          data: data,
	          x: (0, _DataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	          width: (0, _DataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
	          startIndex: dataStartIndex,
	          endIndex: dataEndIndex,
	          updateId: "brush-".concat(updateId)
	        });
	      };
	
	      _this.renderReferenceElement = function (element, displayName, index) {
	        if (!element) {
	          return null;
	        }
	
	        var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
	            clipPathId = _assertThisInitialize.clipPathId;
	
	        var _this$state7 = _this.state,
	            xAxisMap = _this$state7.xAxisMap,
	            yAxisMap = _this$state7.yAxisMap,
	            offset = _this$state7.offset;
	        var _element$props = element.props,
	            xAxisId = _element$props.xAxisId,
	            yAxisId = _element$props.yAxisId;
	        return (0, _react.cloneElement)(element, {
	          key: element.key || "".concat(displayName, "-").concat(index),
	          xAxis: xAxisMap[xAxisId],
	          yAxis: yAxisMap[yAxisId],
	          viewBox: {
	            x: offset.left,
	            y: offset.top,
	            width: offset.width,
	            height: offset.height
	          },
	          clipPathId: clipPathId
	        });
	      };
	
	      _this.renderGraphicChild = function (element, displayName, index) {
	        var item = _this.filterFormatItem(element, displayName, index);
	
	        if (!item) {
	          return null;
	        }
	
	        var graphicalItem = (0, _react.cloneElement)(element, item.props);
	        var _this$state8 = _this.state,
	            isTooltipActive = _this$state8.isTooltipActive,
	            tooltipAxis = _this$state8.tooltipAxis,
	            activeTooltipIndex = _this$state8.activeTooltipIndex,
	            activeLabel = _this$state8.activeLabel;
	        var children = _this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip.default);
	        var _item$props = item.props,
	            points = _item$props.points,
	            isRange = _item$props.isRange,
	            baseLine = _item$props.baseLine;
	        var _item$item$props = item.item.props,
	            activeDot = _item$item$props.activeDot,
	            hide = _item$item$props.hide;
	        var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
	
	        if (hasActive) {
	          var activePoint, basePoint;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            activePoint = (0, _DataUtils.findEntryInArray)(points, "payload.".concat(tooltipAxis.dataKey), activeLabel);
	            basePoint = isRange && baseLine && (0, _DataUtils.findEntryInArray)(baseLine, "payload.".concat(tooltipAxis.dataKey), activeLabel);
	          } else {
	            activePoint = points[activeTooltipIndex];
	            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
	          }
	
	          if (!(0, _isNil2.default)(activePoint)) {
	            return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
	              item: item,
	              activePoint: activePoint,
	              basePoint: basePoint,
	              childIndex: activeTooltipIndex,
	              isRange: isRange
	            })));
	          }
	        }
	
	        if (isRange) {
	          return [graphicalItem, null, null];
	        }
	
	        return [graphicalItem, null];
	      };
	
	      _this.renderCustomized = function (element) {
	        return (0, _react.cloneElement)(element, _objectSpread({}, _this.props, _this.state));
	      };
	
	      var defaultState = _this.constructor.createDefaultState(_props);
	
	      var _updateId = 0;
	      _this.state = _objectSpread({}, defaultState, {
	        updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	        props: _props
	      }, defaultState, {
	        updateId: _updateId
	      })));
	      _this.uniqueChartId = (0, _isNil2.default)(_props.id) ? (0, _DataUtils.uniqueId)('recharts') : _props.id;
	      _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
	
	      if (_props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle2.default)(_this.triggeredAfterMouseMove, _props.throttleDelay);
	      }
	
	      return _this;
	    }
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        if (!(0, _isNil2.default)(this.props.syncId)) {
	          this.addListener();
	        }
	      }
	    }, {
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var _this$props4 = this.props,
	            data = _this$props4.data,
	            children = _this$props4.children,
	            width = _this$props4.width,
	            height = _this$props4.height,
	            layout = _this$props4.layout,
	            stackOffset = _this$props4.stackOffset,
	            margin = _this$props4.margin;
	        var updateId = this.state.updateId;
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _PureRender.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.constructor.createDefaultState(nextProps);
	          this.setState(_objectSpread({}, defaultState, {
	            updateId: updateId + 1
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	            props: nextProps
	          }, defaultState, {
	            updateId: updateId + 1
	          }))));
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          // update configuration in chilren
	          var hasGlobalData = !(0, _isNil2.default)(nextProps.data);
	          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
	          this.setState(function (prevState) {
	            return _objectSpread({
	              updateId: newUpdateId
	            }, _this2.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	              props: nextProps
	            }, prevState, {
	              updateId: newUpdateId
	            })));
	          });
	        } // add syncId
	
	
	        if ((0, _isNil2.default)(this.props.syncId) && !(0, _isNil2.default)(nextProps.syncId)) {
	          this.addListener();
	        } // remove syncId
	
	
	        if (!(0, _isNil2.default)(this.props.syncId) && (0, _isNil2.default)(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (!(0, _isNil2.default)(this.props.syncId)) {
	          this.removeListener();
	        }
	
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: "getAxisMap",
	      value: function getAxisMap(props, _ref5) {
	        var _ref5$axisType = _ref5.axisType,
	            axisType = _ref5$axisType === void 0 ? 'xAxis' : _ref5$axisType,
	            AxisComp = _ref5.AxisComp,
	            graphicalItems = _ref5.graphicalItems,
	            stackGroups = _ref5.stackGroups,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex;
	        var children = props.children;
	        var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis
	
	        var axes = (0, _ReactUtils.findAllByType)(children, AxisComp);
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, {
	            axes: axes,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, {
	            Axis: AxisComp,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        }
	
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: "getAxisMapByAxes",
	      value: function getAxisMapByAxes(props, _ref6) {
	        var _this3 = this;
	
	        var axes = _ref6.axes,
	            graphicalItems = _ref6.graphicalItems,
	            axisType = _ref6.axisType,
	            axisIdKey = _ref6.axisIdKey,
	            stackGroups = _ref6.stackGroups,
	            dataStartIndex = _ref6.dataStartIndex,
	            dataEndIndex = _ref6.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            stackOffset = props.stackOffset;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType); // Eliminate duplicated axes
	
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
	              scale = _child$props.scale,
	              ticks = _child$props.ticks;
	          var axisId = child.props[axisIdKey];
	
	          var displayedData = _this3.constructor.getDisplayedData(props, {
	            graphicalItems: graphicalItems.filter(function (item) {
	              return item.props[axisIdKey] === axisId;
	            }),
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	
	          var len = displayedData.length;
	
	          if (!result[axisId]) {
	            var domain, duplicateDomain, categoricalDomain;
	
	            if (dataKey) {
	              domain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	
	                if (allowDuplicatedCategory && duplicate) {
	                  duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale
	
	                  domain = (0, _range2.default)(0, len);
	                } else if (!allowDuplicatedCategory) {
	                  // remove duplicated category
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : _toConsumableArray(finalDomain).concat([entry]);
	                  }, []);
	                }
	              } else if (type === 'category') {
	                if (!allowDuplicatedCategory) {
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNil2.default)(entry) ? finalDomain : _toConsumableArray(finalDomain).concat([entry]);
	                  }, []);
	                } else {
	                  // eliminate undefined or null or empty string
	                  domain = domain.filter(function (entry) {
	                    return entry !== '' && !(0, _isNil2.default)(entry);
	                  });
	                }
	              } else if (type === 'number') {
	                var errorBarsDomain = (0, _ChartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function (item) {
	                  return item.props[axisIdKey] === axisId && !item.props.hide;
	                }), dataKey, axisType);
	
	                if (errorBarsDomain) {
	                  domain = errorBarsDomain;
	                }
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range2.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), type, true);
	            }
	
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
	
	              if (child.props.domain) {
	                domain = (0, _ChartUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial,
	              layout: layout
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: "getAxisMapByItems",
	      value: function getAxisMapByItems(props, _ref7) {
	        var graphicalItems = _ref7.graphicalItems,
	            Axis = _ref7.Axis,
	            axisType = _ref7.axisType,
	            axisIdKey = _ref7.axisIdKey,
	            stackGroups = _ref7.stackGroups,
	            dataStartIndex = _ref7.dataStartIndex,
	            dataEndIndex = _ref7.dataEndIndex;
	        var layout = props.layout,
	            children = props.children;
	        var displayedData = this.constructor.getDisplayedData(props, {
	          graphicalItems: graphicalItems,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	        var len = displayedData.length;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	        var index = -1; // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain;
	
	            if (isCategorial) {
	              domain = (0, _range2.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _ChartUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial,
	              layout: layout // specify scale when no Axis
	              // scale: isCategorial ? 'band' : 'linear',
	
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	    }, {
	      key: "getActiveCoordinate",
	      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
	        var layout = this.props.layout;
	        var entry = tooltipTicks.find(function (tick) {
	          return tick && tick.index === activeIndex;
	        });
	
	        if (entry) {
	          if (layout === 'horizontal') {
	            return {
	              x: entry.coordinate,
	              y: rangeObj.y
	            };
	          }
	
	          if (layout === 'vertical') {
	            return {
	              x: rangeObj.x,
	              y: entry.coordinate
	            };
	          }
	
	          if (layout === 'centric') {
	            var _angle = entry.coordinate;
	            var _radius = rangeObj.radius;
	            return _objectSpread({}, rangeObj, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle), {
	              angle: _angle,
	              radius: _radius
	            });
	          }
	
	          var radius = entry.coordinate;
	          var angle = rangeObj.angle;
	          return _objectSpread({}, rangeObj, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle), {
	            angle: angle,
	            radius: radius
	          });
	        }
	
	        return originCoordinate;
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: "getMouseInfo",
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var rangeObj = this.inRange(e.chartX, e.chartY);
	
	        if (!rangeObj) {
	          return null;
	        }
	
	        var _this$state9 = this.state,
	            xAxisMap = _this$state9.xAxisMap,
	            yAxisMap = _this$state9.yAxisMap;
	
	        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
	          var xScale = (0, _DataUtils.getAnyElementOfObject)(xAxisMap).scale;
	          var yScale = (0, _DataUtils.getAnyElementOfObject)(yAxisMap).scale;
	          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
	          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
	          return _objectSpread({}, e, {
	            xValue: xValue,
	            yValue: yValue
	          });
	        }
	
	        var _this$state10 = this.state,
	            ticks = _this$state10.orderedTooltipTicks,
	            axis = _this$state10.tooltipAxis,
	            tooltipTicks = _this$state10.tooltipTicks;
	        var pos = this.calculateTooltipPos(rangeObj);
	        var activeIndex = (0, _ChartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
	
	        if (activeIndex >= 0 && tooltipTicks) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
	          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeObj);
	          return _objectSpread({}, e, {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel,
	            activePayload: activePayload,
	            activeCoordinate: activeCoordinate
	          });
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @param  {String} activeLabel    Active label of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: "getTooltipContent",
	      value: function getTooltipContent(activeIndex, activeLabel) {
	        var _this$state11 = this.state,
	            graphicalItems = _this$state11.graphicalItems,
	            tooltipAxis = _this$state11.tooltipAxis;
	        var displayedData = this.constructor.getDisplayedData(this.props, this.state);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
	          return null;
	        } // get data by activeIndex when the axis don't allow duplicated category
	
	
	        return graphicalItems.reduce(function (result, child) {
	          var hide = child.props.hide;
	
	          if (hide) {
	            return result;
	          }
	
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter,
	              data = _child$props2.data,
	              tooltipType = _child$props2.tooltipType;
	          var payload;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            // graphic child has data props
	            payload = (0, _DataUtils.findEntryInArray)(data || displayedData, tooltipAxis.dataKey, activeLabel);
	          } else {
	            payload = displayedData[activeIndex];
	          }
	
	          if (!payload) {
	            return result;
	          }
	
	          return _toConsumableArray(result).concat([_objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey,
	            unit: unit,
	            formatter: formatter,
	            name: name || dataKey,
	            color: (0, _ChartUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _ChartUtils.getValueByDataKey)(payload, dataKey),
	            type: tooltipType,
	            payload: payload
	          })]);
	        }, []);
	      }
	    }, {
	      key: "getFormatItems",
	      value: function getFormatItems(props, currentState) {
	        var _this4 = this;
	
	        var graphicalItems = currentState.graphicalItems,
	            stackGroups = currentState.stackGroups,
	            offset = currentState.offset,
	            updateId = currentState.updateId,
	            dataStartIndex = currentState.dataStartIndex,
	            dataEndIndex = currentState.dataEndIndex;
	        var barSize = props.barSize,
	            layout = props.layout,
	            barGap = props.barGap,
	            barCategoryGap = props.barCategoryGap,
	            globalMaxBarSize = props.maxBarSize;
	
	        var _this$constructor$get = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get.numericAxisName,
	            cateAxisName = _this$constructor$get.cateAxisName;
	
	        var hasBar = this.constructor.hasBar(graphicalItems);
	        var sizeList = hasBar && (0, _ChartUtils.getBarSizeList)({
	          barSize: barSize,
	          stackGroups: stackGroups
	        });
	        var formatedItems = [];
	        graphicalItems.forEach(function (item, index) {
	          var displayedData = _this4.constructor.getDisplayedData(props, {
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }, item);
	
	          var _item$props2 = item.props,
	              dataKey = _item$props2.dataKey,
	              childMaxBarSize = _item$props2.maxBarSize;
	          var numericAxisId = item.props["".concat(numericAxisName, "Id")];
	          var cateAxisId = item.props["".concat(cateAxisName, "Id")];
	          var axisObj = axisComponents.reduce(function (result, entry) {
	            var _objectSpread4;
	
	            var axisMap = currentState["".concat(entry.axisType, "Map")];
	            var id = item.props["".concat(entry.axisType, "Id")];
	            var axis = axisMap && axisMap[id];
	            return _objectSpread({}, result, (_objectSpread4 = {}, _defineProperty(_objectSpread4, entry.axisType, axis), _defineProperty(_objectSpread4, "".concat(entry.axisType, "Ticks"), (0, _ChartUtils.getTicksOfAxis)(axis)), _objectSpread4));
	          }, {});
	          var cateAxis = axisObj[cateAxisName];
	          var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
	          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _ChartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	          var bandSize = (0, _ChartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	          var maxBarSize = (0, _isNil2.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	          var barPosition = hasBar && (0, _ChartUtils.getBarPosition)({
	            barGap: barGap,
	            barCategoryGap: barCategoryGap,
	            bandSize: bandSize,
	            sizeList: sizeList[cateAxisId],
	            maxBarSize: maxBarSize
	          });
	          var componsedFn = item && item.type && item.type.getComposedData;
	
	          if (componsedFn) {
	            var _objectSpread5;
	
	            formatedItems.push({
	              props: _objectSpread({}, componsedFn(_objectSpread({}, axisObj, {
	                displayedData: displayedData,
	                props: props,
	                dataKey: dataKey,
	                item: item,
	                bandSize: bandSize,
	                barPosition: barPosition,
	                offset: offset,
	                stackedData: stackedData,
	                layout: layout,
	                dataStartIndex: dataStartIndex,
	                dataEndIndex: dataEndIndex,
	                onItemMouseLeave: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseLeave, null, item.props.onMouseLeave),
	                onItemMouseEnter: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseEnter, null, item.props.onMouseEnter)
	              })), (_objectSpread5 = {
	                key: item.key || "item-".concat(index)
	              }, _defineProperty(_objectSpread5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_objectSpread5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_objectSpread5, "animationId", updateId), _objectSpread5)),
	              childIndex: (0, _ReactUtils.parseChildIndex)(item, props.children),
	              item: item
	            });
	          }
	        });
	        return formatedItems;
	      }
	    }, {
	      key: "getCursorRectangle",
	      value: function getCursorRectangle() {
	        var layout = this.props.layout;
	        var _this$state12 = this.state,
	            activeCoordinate = _this$state12.activeCoordinate,
	            offset = _this$state12.offset,
	            tooltipAxisBandSize = _this$state12.tooltipAxisBandSize;
	        var halfSize = tooltipAxisBandSize / 2;
	        return {
	          stroke: 'none',
	          fill: '#ccc',
	          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
	          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
	          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
	          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
	        };
	      }
	    }, {
	      key: "getCursorPoints",
	      value: function getCursorPoints() {
	        var layout = this.props.layout;
	        var _this$state13 = this.state,
	            activeCoordinate = _this$state13.activeCoordinate,
	            offset = _this$state13.offset;
	        var x1, y1, x2, y2;
	
	        if (layout === 'horizontal') {
	          x1 = activeCoordinate.x;
	          x2 = x1;
	          y1 = offset.top;
	          y2 = offset.top + offset.height;
	        } else if (layout === 'vertical') {
	          y1 = activeCoordinate.y;
	          y2 = y1;
	          x1 = offset.left;
	          x2 = offset.left + offset.width;
	        } else if (!(0, _isNil2.default)(activeCoordinate.cx) || !(0, _isNil2.default)(activeCoordinate.cy)) {
	          if (layout === 'centric') {
	            var cx = activeCoordinate.cx,
	                cy = activeCoordinate.cy,
	                innerRadius = activeCoordinate.innerRadius,
	                outerRadius = activeCoordinate.outerRadius,
	                angle = activeCoordinate.angle;
	            var innerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
	            var outerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
	            x1 = innerPoint.x;
	            y1 = innerPoint.y;
	            x2 = outerPoint.x;
	            y2 = outerPoint.y;
	          } else {
	            var _cx = activeCoordinate.cx,
	                _cy = activeCoordinate.cy,
	                radius = activeCoordinate.radius,
	                startAngle = activeCoordinate.startAngle,
	                endAngle = activeCoordinate.endAngle;
	            var startPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, startAngle);
	            var endPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, endAngle);
	            return {
	              points: [startPoint, endPoint],
	              cx: _cx,
	              cy: _cy,
	              radius: radius,
	              startAngle: startAngle,
	              endAngle: endAngle
	            };
	          }
	        }
	
	        return [{
	          x: x1,
	          y: y1
	        }, {
	          x: x2,
	          y: y2
	        }];
	      }
	    }, {
	      key: "calculateTooltipPos",
	      value: function calculateTooltipPos(rangeObj) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal') {
	          return rangeObj.x;
	        }
	
	        if (layout === 'vertical') {
	          return rangeObj.y;
	        }
	
	        if (layout === 'centric') {
	          return rangeObj.angle;
	        }
	
	        return rangeObj.radius;
	      }
	    }, {
	      key: "inRange",
	      value: function inRange(x, y) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal' || layout === 'vertical') {
	          var offset = this.state.offset;
	          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
	          return isInRange ? {
	            x: x,
	            y: y
	          } : null;
	        }
	
	        var _this$state14 = this.state,
	            angleAxisMap = _this$state14.angleAxisMap,
	            radiusAxisMap = _this$state14.radiusAxisMap;
	
	        if (angleAxisMap && radiusAxisMap) {
	          var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	          return (0, _PolarUtils.inRangeOfSector)({
	            x: x,
	            y: y
	          }, angleAxis);
	        }
	
	        return null;
	      }
	    }, {
	      key: "parseEventsOfWrapper",
	      value: function parseEventsOfWrapper() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip.default);
	        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchMove: this.handleTouchMove,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        } : {};
	        var outerEvents = (0, _ReactUtils.filterEventAttributes)(this.props, this.handleOuterEvent);
	        return _objectSpread({}, outerEvents, tooltipEvents);
	      }
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props          The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @param {Number} updateId       The update id
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: "updateStateOfAxisMapsOffsetAndStackGroups",
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
	        var _this5 = this;
	
	        var props = _ref8.props,
	            dataStartIndex = _ref8.dataStartIndex,
	            dataEndIndex = _ref8.dataEndIndex,
	            updateId = _ref8.updateId;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({
	          props: props
	        })) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset,
	            data = props.data,
	            reverseStackOrder = props.reverseStackOrder;
	
	        var _this$constructor$get2 = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get2.numericAxisName,
	            cateAxisName = _this$constructor$get2.cateAxisName;
	
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _ChartUtils.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
	        var axisObj = axisComponents.reduce(function (result, entry) {
	          var name = "".concat(entry.axisType, "Map");
	          return _objectSpread({}, result, _defineProperty({}, name, _this5.getAxisMap(props, _objectSpread({}, entry, {
	            graphicalItems: graphicalItems,
	            stackGroups: entry.axisType === numericAxisName && stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }))));
	        }, {});
	        var offset = this.calculateOffset(_objectSpread({}, axisObj, {
	          props: props,
	          graphicalItems: graphicalItems
	        }));
	        Object.keys(axisObj).forEach(function (key) {
	          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
	        });
	        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
	        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
	        var formatedGraphicalItems = this.getFormatItems(props, _objectSpread({}, axisObj, {
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex,
	          updateId: updateId,
	          graphicalItems: graphicalItems,
	          stackGroups: stackGroups,
	          offset: offset
	        }));
	        return _objectSpread({
	          formatedGraphicalItems: formatedGraphicalItems,
	          graphicalItems: graphicalItems,
	          offset: offset,
	          stackGroups: stackGroups
	        }, ticksObj, axisObj);
	      }
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: "addListener",
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: "removeListener",
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: "calculateOffset",
	      value: function calculateOffset(_ref9) {
	        var props = _ref9.props,
	            graphicalItems = _ref9.graphicalItems,
	            _ref9$xAxisMap = _ref9.xAxisMap,
	            xAxisMap = _ref9$xAxisMap === void 0 ? {} : _ref9$xAxisMap,
	            _ref9$yAxisMap = _ref9.yAxisMap,
	            yAxisMap = _ref9$yAxisMap === void 0 ? {} : _ref9$yAxisMap;
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush.default);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend.default);
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, {
	          left: margin.left || 0,
	          right: margin.right || 0
	        });
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, {
	          top: margin.top || 0,
	          bottom: margin.bottom || 0
	        });
	
	        var offset = _objectSpread({}, offsetV, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush.default.defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	          offset = (0, _ChartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _objectSpread({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	    }, {
	      key: "triggerSyncEvent",
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	        if (!(0, _isNil2.default)(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: "filterFormatItem",
	      value: function filterFormatItem(item, displayName, childIndex) {
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	
	        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
	          var entry = formatedGraphicalItems[i];
	
	          if (entry.item === item || entry.props.key === item.key || displayName === (0, _ReactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) {
	            return entry;
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: "renderAxis",
	
	      /**
	       * Draw axis
	       * @param {Object} axisOptions The options of axis
	       * @param {Object} element      The axis element
	       * @param {String} displayName  The display name of axis
	       * @param {Number} index        The index of element
	       * @return {ReactElement}       The instance of x-axes
	       */
	      value: function renderAxis(axisOptions, element, displayName, index) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height;
	        return _react.default.createElement(_CartesianAxis.default, _extends({}, axisOptions, {
	          className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
	          key: element.key || "".concat(displayName, "-").concat(index),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          },
	          ticksGenerator: this.axesTicksGenerator
	        }));
	      }
	      /**
	       * Draw grid
	       * @param  {ReactElement} element the grid item
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: "renderLegend",
	
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	      value: function renderLegend() {
	        var _this6 = this;
	
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	        var _this$props6 = this.props,
	            children = _this$props6.children,
	            width = _this$props6.width,
	            height = _this$props6.height;
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _ChartUtils.getLegendProps)({
	          children: children,
	          formatedGraphicalItems: formatedGraphicalItems,
	          legendWidth: legendWidth,
	          legendHeight: legendHeight,
	          legendContent: legendContent
	        });
	
	        if (!props) {
	          return null;
	        }
	
	        var item = props.item,
	            otherProps = _objectWithoutProperties(props, ["item"]);
	
	        return (0, _react.cloneElement)(item, _objectSpread({}, otherProps, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this6.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: "renderTooltip",
	      value: function renderTooltip() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip.default);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _this$state15 = this.state,
	            isTooltipActive = _this$state15.isTooltipActive,
	            activeCoordinate = _this$state15.activeCoordinate,
	            activePayload = _this$state15.activePayload,
	            activeLabel = _this$state15.activeLabel,
	            offset = _this$state15.offset;
	        return (0, _react.cloneElement)(tooltipItem, {
	          viewBox: _objectSpread({}, offset, {
	            x: offset.left,
	            y: offset.top
	          }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: "renderActivePoints",
	      value: function renderActivePoints(_ref10) {
	        var item = _ref10.item,
	            activePoint = _ref10.activePoint,
	            basePoint = _ref10.basePoint,
	            childIndex = _ref10.childIndex,
	            isRange = _ref10.isRange;
	        var result = [];
	        var key = item.props.key;
	        var _item$item$props2 = item.item.props,
	            activeDot = _item$item$props2.activeDot,
	            dataKey = _item$item$props2.dataKey;
	
	        var dotProps = _objectSpread({
	          index: childIndex,
	          dataKey: dataKey,
	          cx: activePoint.x,
	          cy: activePoint.y,
	          r: 4,
	          fill: (0, _ChartUtils.getMainColorOfGraphicItem)(item.item),
	          strokeWidth: 2,
	          stroke: '#fff',
	          payload: activePoint.payload,
	          value: activePoint.value,
	          key: "".concat(key, "-activePoint-").concat(childIndex)
	        }, (0, _ReactUtils.getPresentationAttributes)(activeDot), (0, _ReactUtils.filterEventAttributes)(activeDot));
	
	        result.push(this.constructor.renderActiveDot(activeDot, dotProps, childIndex));
	
	        if (basePoint) {
	          result.push(this.constructor.renderActiveDot(activeDot, _objectSpread({}, dotProps, {
	            cx: basePoint.x,
	            cy: basePoint.y,
	            key: "".concat(key, "-basePoint-").concat(childIndex)
	          }), childIndex));
	        } else if (isRange) {
	          result.push(null);
	        }
	
	        return result;
	      }
	    }, {
	      key: "renderClipPath",
	      value: function renderClipPath() {
	        var clipPathId = this.clipPathId;
	        var _this$state$offset = this.state.offset,
	            left = _this$state$offset.left,
	            top = _this$state$offset.top,
	            height = _this$state$offset.height,
	            width = _this$state$offset.width;
	        return _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
	          id: clipPathId
	        }, _react.default.createElement("rect", {
	          x: left,
	          y: top,
	          height: height,
	          width: width
	        })));
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this7 = this;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	          return null;
	        }
	
	        var _this$props7 = this.props,
	            children = _this$props7.children,
	            className = _this$props7.className,
	            width = _this$props7.width,
	            height = _this$props7.height,
	            style = _this$props7.style,
	            compact = _this$props7.compact,
	            others = _objectWithoutProperties(_this$props7, ["children", "className", "width", "height", "style", "compact"]);
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	        var map = {
	          CartesianGrid: {
	            handler: this.renderGrid,
	            once: true
	          },
	          ReferenceArea: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceLine: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceDot: {
	            handler: this.renderReferenceElement
	          },
	          XAxis: {
	            handler: this.renderXAxis
	          },
	          YAxis: {
	            handler: this.renderYAxis
	          },
	          Brush: {
	            handler: this.renderBrush,
	            once: true
	          },
	          Bar: {
	            handler: this.renderGraphicChild
	          },
	          Line: {
	            handler: this.renderGraphicChild
	          },
	          Area: {
	            handler: this.renderGraphicChild
	          },
	          Radar: {
	            handler: this.renderGraphicChild
	          },
	          RadialBar: {
	            handler: this.renderGraphicChild
	          },
	          Scatter: {
	            handler: this.renderGraphicChild
	          },
	          Pie: {
	            handler: this.renderGraphicChild
	          },
	          Funnel: {
	            handler: this.renderGraphicChild
	          },
	          Tooltip: {
	            handler: this.renderCursor,
	            once: true
	          },
	          PolarGrid: {
	            handler: this.renderPolarGrid,
	            once: true
	          },
	          PolarAngleAxis: {
	            handler: this.renderPolarAxis
	          },
	          PolarRadiusAxis: {
	            handler: this.renderPolarAxis
	          },
	          Customized: {
	            handler: this.renderCustomized
	          }
	        }; // The "compact" mode is mainly used as the panorama within Brush
	
	        if (compact) {
	          return _react.default.createElement(_Surface.default, _extends({}, attrs, {
	            width: width,
	            height: height
	          }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map));
	        }
	
	        var events = this.parseEventsOfWrapper();
	        return _react.default.createElement("div", _extends({
	          className: (0, _classnames.default)('recharts-wrapper', className),
	          style: _objectSpread({
	            position: 'relative',
	            cursor: 'default',
	            width: width,
	            height: height
	          }, style)
	        }, events, {
	          ref: function ref(node) {
	            _this7.container = node;
	          }
	        }), _react.default.createElement(_Surface.default, _extends({}, attrs, {
	          width: width,
	          height: height
	        }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map)), this.renderLegend(), this.renderTooltip());
	      }
	    }], [{
	      key: "getAxisNameByLayout",
	      value: function getAxisNameByLayout(layout) {
	        if (layout === 'horizontal') {
	          return {
	            numericAxisName: 'yAxis',
	            cateAxisName: 'xAxis'
	          };
	        }
	
	        if (layout === 'vertical') {
	          return {
	            numericAxisName: 'xAxis',
	            cateAxisName: 'yAxis'
	          };
	        }
	
	        if (layout === 'centric') {
	          return {
	            numericAxisName: 'radiusAxis',
	            cateAxisName: 'angleAxis'
	          };
	        }
	
	        return {
	          numericAxisName: 'angleAxis',
	          cateAxisName: 'radiusAxis'
	        };
	      }
	    }, {
	      key: "renderActiveDot",
	      value: function renderActiveDot(option, props) {
	        var dot;
	
	        if ((0, _react.isValidElement)(option)) {
	          dot = (0, _react.cloneElement)(option, props);
	        } else if ((0, _isFunction2.default)(option)) {
	          dot = option(props);
	        } else {
	          dot = _react.default.createElement(_Dot.default, props);
	        }
	
	        return _react.default.createElement(_Layer.default, {
	          className: "recharts-active-dot",
	          key: props.key
	        }, dot);
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component);
	
	  CategoricalChartWrapper.displayName = chartName;
	  CategoricalChartWrapper.propTypes = _objectSpread({
	    syncId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	    compact: _propTypes.default.bool,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number,
	    data: _propTypes.default.arrayOf(_propTypes.default.object),
	    layout: _propTypes.default.oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes.default.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes.default.number,
	    margin: _propTypes.default.shape({
	      top: _propTypes.default.number,
	      right: _propTypes.default.number,
	      bottom: _propTypes.default.number,
	      left: _propTypes.default.number
	    }),
	    barCategoryGap: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    barGap: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    barSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    maxBarSize: _propTypes.default.number,
	    style: _propTypes.default.object,
	    className: _propTypes.default.string,
	    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	    defaultShowTooltip: _propTypes.default.bool,
	    onClick: _propTypes.default.func,
	    onMouseLeave: _propTypes.default.func,
	    onMouseEnter: _propTypes.default.func,
	    onMouseMove: _propTypes.default.func,
	    onMouseDown: _propTypes.default.func,
	    onMouseUp: _propTypes.default.func,
	    reverseStackOrder: _propTypes.default.bool,
	    id: _propTypes.default.string
	  }, propTypes);
	  CategoricalChartWrapper.defaultProps = _objectSpread({
	    layout: 'horizontal',
	    stackOffset: 'none',
	    barCategoryGap: '10%',
	    barGap: 4,
	    margin: {
	      top: 5,
	      right: 5,
	      bottom: 5,
	      left: 5
	    },
	    reverseStackOrder: false
	  }, defaultProps);
	
	  CategoricalChartWrapper.createDefaultState = function (props) {
	    var children = props.children,
	        defaultShowTooltip = props.defaultShowTooltip;
	    var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush.default);
	    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	    return {
	      chartX: 0,
	      chartY: 0,
	      dataStartIndex: startIndex,
	      dataEndIndex: endIndex,
	      activeTooltipIndex: -1,
	      isTooltipActive: !(0, _isNil2.default)(defaultShowTooltip) ? defaultShowTooltip : false
	    };
	  };
	
	  CategoricalChartWrapper.hasBar = function (graphicalItems) {
	    if (!graphicalItems || !graphicalItems.length) {
	      return false;
	    }
	
	    return graphicalItems.some(function (item) {
	      var name = (0, _ReactUtils.getDisplayName)(item && item.type);
	      return name && name.indexOf('Bar') >= 0;
	    });
	  };
	
	  CategoricalChartWrapper.getDisplayedData = function (props, _ref11, item) {
	    var graphicalItems = _ref11.graphicalItems,
	        dataStartIndex = _ref11.dataStartIndex,
	        dataEndIndex = _ref11.dataEndIndex;
	    var itemsData = (graphicalItems || []).reduce(function (result, child) {
	      var itemData = child.props.data;
	
	      if (itemData && itemData.length) {
	        return _toConsumableArray(result).concat(_toConsumableArray(itemData));
	      }
	
	      return result;
	    }, []);
	
	    if (itemsData && itemsData.length > 0) {
	      return itemsData;
	    }
	
	    if (item && item.props && item.props.data && item.props.data.length > 0) {
	      return item.props.data;
	    }
	
	    var data = props.data;
	
	    if (data && data.length && (0, _DataUtils.isNumber)(dataStartIndex) && (0, _DataUtils.isNumber)(dataEndIndex)) {
	      return data.slice(dataStartIndex, dataEndIndex + 1);
	    }
	
	    return [];
	  };
	
	  return CategoricalChartWrapper;
	};
	
	var _default = generateCategoricalChart;
	exports.default = _default;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(53));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _last2 = _interopRequireDefault(__webpack_require__(669));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Label = _interopRequireDefault(__webpack_require__(129));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _ChartUtils = __webpack_require__(52);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  id: _propTypes.default.string,
	  data: _propTypes.default.arrayOf(_propTypes.default.object),
	  valueAccessor: _propTypes.default.func,
	  clockWise: _propTypes.default.bool,
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func])
	};
	var defaultProps = {
	  valueAccessor: function valueAccessor(entry) {
	    return (0, _isArray2.default)(entry.value) ? (0, _last2.default)(entry.value) : entry.value;
	  }
	};
	
	function LabelList(props) {
	  var data = props.data,
	      valueAccessor = props.valueAccessor,
	      dataKey = props.dataKey,
	      clockWise = props.clockWise,
	      id = props.id,
	      others = _objectWithoutProperties(props, ["data", "valueAccessor", "dataKey", "clockWise", "id"]);
	
	  if (!data || !data.length) {
	    return null;
	  }
	
	  return _react.default.createElement(_Layer.default, {
	    className: "recharts-label-list"
	  }, data.map(function (entry, index) {
	    var value = (0, _isNil2.default)(dataKey) ? valueAccessor(entry, index) : (0, _ChartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
	    var idProps = (0, _isNil2.default)(id) ? {} : {
	      id: "".concat(id, "-").concat(index)
	    };
	    return _react.default.createElement(_Label.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(entry), others, idProps, {
	      index: index,
	      value: value,
	      viewBox: _Label.default.parseViewBox((0, _isNil2.default)(clockWise) ? entry : _objectSpread({}, entry, {
	        clockWise: clockWise
	      })),
	      key: "label-".concat(index)
	    }));
	  }));
	}
	
	LabelList.propTypes = propTypes;
	LabelList.displayName = 'LabelList';
	
	var parseLabelList = function parseLabelList(label, data) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react.default.createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data
	    });
	  }
	
	  if (_react.default.isValidElement(label) || (0, _isFunction2.default)(label)) {
	    return _react.default.createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data,
	      content: label
	    });
	  }
	
	  if ((0, _isObject2.default)(label)) {
	    return _react.default.createElement(LabelList, _extends({
	      data: data
	    }, label, {
	      key: "labelList-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, data) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, LabelList).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      data: data,
	      key: "labelList-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabelList = parseLabelList(parentProps.label, data);
	  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
	};
	
	LabelList.renderCallByParent = renderCallByParent;
	LabelList.defaultProps = defaultProps;
	var _default = LabelList;
	exports.default = _default;

/***/ },
/* 116 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCampaignTopLocationClickStats = exports.getCampaignTopLinkStats = exports.getDisplayChannelStatsAggregated = exports.getSocialChannelStatsAggregated = exports.getEmailChannelStatsAggregated = exports.getDisplayChannelAggregated = exports.getSocialChannelAggregated = exports.getEmailChannelAggregated = exports.getCampaignChannelAggregated = exports.getCampaignGroupAggregated = exports.saveCampaignGroup = exports.getCampaignById = exports.getChannelCampaignList = exports.getCampaignCSV = exports.getTables = exports.setCampaignFilterValue = exports.setCampaignFilterEndDate = exports.setCampaignFilterStartDate = exports.setSegmentId = exports.setChannelCampaignId = exports.setReportDateRange = exports.clearSaveCampaignErrorMessage = exports.clearCampaignCsvData = exports.clearCampaignDetail = exports.CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE = exports.CLEAR_CMAPAIGNS_CSV_DATA = exports.CLEAR_CAMPAIGN_DETAIL = exports.SAVE_CAMPAIGN_GROUP = exports.SET_CAMPAIGN_FILTER_VALUE = exports.SET_CAMPAIGN_FILTER_END_DATE = exports.SET_CAMPAIGN_FILTER_START_DATE = exports.SET_SEGMENT_ID = exports.SET_CHANNEL_CAMPAIGN_ID = exports.SET_REPORT_DATE_RANGE = exports.GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED = exports.GET_CAMPAIGN_DISPLAY_AGGREGATED = exports.GET_CAMPAIGN_TOP_LOCATION_STATS = exports.GET_CAMPAIGN_TOP_LINK_STATS = exports.GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED = exports.GET_CAMPAIGN_SOCIAL_AGGREGATED = exports.GET_CAMPAIGN_EMAIL_STATS_AGGREGATED = exports.GET_CAMPAIGN_EMAIL_AGGREGATED = exports.GET_CAMPAIGN_DETAIL = exports.GET_CAMPAIGN_AGGREGATED_BY_CHANNEL = exports.GET_CAMPAIGN_GROUP_AGGREGATED = exports.GET_DISPLAY_CAMPAIGN_LIST = exports.GET_SOCIAL_CAMPAIGN_LIST = exports.GET_EMAIL_CAMPAIGN_LIST = exports.GET_CAMPAIGNS_CSV_DATA = exports.GET_CAMPAIGNS_TABLES = undefined;
	
	var _Api = __webpack_require__(45);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	var _helpers = __webpack_require__(95);
	
	var GET_CAMPAIGNS_TABLES = exports.GET_CAMPAIGNS_TABLES = 'GET_CAMPAIGNS_TABLES';
	var GET_CAMPAIGNS_CSV_DATA = exports.GET_CAMPAIGNS_CSV_DATA = "GET_CAMPAIGNS_CSV_DATA";
	var GET_EMAIL_CAMPAIGN_LIST = exports.GET_EMAIL_CAMPAIGN_LIST = "GET_EMAIL_CAMPAIGN_LIST";
	var GET_SOCIAL_CAMPAIGN_LIST = exports.GET_SOCIAL_CAMPAIGN_LIST = "GET_SOCIAL_CAMPAIGN_LIST";
	var GET_DISPLAY_CAMPAIGN_LIST = exports.GET_DISPLAY_CAMPAIGN_LIST = "GET_DISPLAY_CAMPAIGN_LIST";
	var GET_CAMPAIGN_GROUP_AGGREGATED = exports.GET_CAMPAIGN_GROUP_AGGREGATED = "GET_CAMPAIGN_GROUP_AGGREGATED";
	var GET_CAMPAIGN_AGGREGATED_BY_CHANNEL = exports.GET_CAMPAIGN_AGGREGATED_BY_CHANNEL = "GET_CAMPAIGN_AGGREGATED_BY_CHANNEL";
	var GET_CAMPAIGN_DETAIL = exports.GET_CAMPAIGN_DETAIL = "GET_CAMPAIGN_DETAIL";
	var GET_CAMPAIGN_EMAIL_AGGREGATED = exports.GET_CAMPAIGN_EMAIL_AGGREGATED = "GET_CAMPAIGN_EMAIL_AGGREGATED";
	var GET_CAMPAIGN_EMAIL_STATS_AGGREGATED = exports.GET_CAMPAIGN_EMAIL_STATS_AGGREGATED = "GET_CAMPAIGN_EMAIL_STATS_AGGREGATED";
	var GET_CAMPAIGN_SOCIAL_AGGREGATED = exports.GET_CAMPAIGN_SOCIAL_AGGREGATED = "GET_CAMPAIGN_SOCIAL_AGGREGATED";
	var GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED = exports.GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED = "GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED";
	var GET_CAMPAIGN_TOP_LINK_STATS = exports.GET_CAMPAIGN_TOP_LINK_STATS = "GET_CAMPAIGN_TOP_LINK_STATS";
	var GET_CAMPAIGN_TOP_LOCATION_STATS = exports.GET_CAMPAIGN_TOP_LOCATION_STATS = "GET_CAMPAIGN_TOP_LCOATION_STATS";
	var GET_CAMPAIGN_DISPLAY_AGGREGATED = exports.GET_CAMPAIGN_DISPLAY_AGGREGATED = "GET_CAMPAIGN_DISPLAY_AGGREGATED";
	var GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED = exports.GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED = "GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED";
	var SET_REPORT_DATE_RANGE = exports.SET_REPORT_DATE_RANGE = "SET_REPORT_DATE_RANGE";
	var SET_CHANNEL_CAMPAIGN_ID = exports.SET_CHANNEL_CAMPAIGN_ID = "SET_CHANNEL_CAMPAIGN_ID";
	var SET_SEGMENT_ID = exports.SET_SEGMENT_ID = "SET_SEGMENT_ID";
	var SET_CAMPAIGN_FILTER_START_DATE = exports.SET_CAMPAIGN_FILTER_START_DATE = "SET_CAMPAIGN_FILTER_START_DATE";
	var SET_CAMPAIGN_FILTER_END_DATE = exports.SET_CAMPAIGN_FILTER_END_DATE = "SET_CAMPAIGN_FILTER_END_DATE";
	var SET_CAMPAIGN_FILTER_VALUE = exports.SET_CAMPAIGN_FILTER_VALUE = "SET_CAMPAIGN_FILTER_VALUE";
	var SAVE_CAMPAIGN_GROUP = exports.SAVE_CAMPAIGN_GROUP = "SAVE_CAMPAIGN_GROUP";
	var CLEAR_CAMPAIGN_DETAIL = exports.CLEAR_CAMPAIGN_DETAIL = "CLEAR_CAMPAIGN_DETAIL";
	var CLEAR_CMAPAIGNS_CSV_DATA = exports.CLEAR_CMAPAIGNS_CSV_DATA = "CLEAR_CMAPAIGNS_CSV_DATA";
	var CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE = exports.CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE = "CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE";
	
	var clearCampaignDetail = exports.clearCampaignDetail = (0, _helpers.actionCreator)(CLEAR_CAMPAIGN_DETAIL);
	var clearCampaignCsvData = exports.clearCampaignCsvData = (0, _helpers.actionCreator)(CLEAR_CMAPAIGNS_CSV_DATA);
	var clearSaveCampaignErrorMessage = exports.clearSaveCampaignErrorMessage = (0, _helpers.actionCreator)(CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE);
	var setReportDateRange = exports.setReportDateRange = (0, _helpers.actionCreator)(SET_REPORT_DATE_RANGE);
	var setChannelCampaignId = exports.setChannelCampaignId = (0, _helpers.actionCreator)(SET_CHANNEL_CAMPAIGN_ID);
	var setSegmentId = exports.setSegmentId = (0, _helpers.actionCreator)(SET_SEGMENT_ID);
	var setCampaignFilterStartDate = exports.setCampaignFilterStartDate = (0, _helpers.actionCreator)(SET_CAMPAIGN_FILTER_START_DATE);
	var setCampaignFilterEndDate = exports.setCampaignFilterEndDate = (0, _helpers.actionCreator)(SET_CAMPAIGN_FILTER_END_DATE);
	var setCampaignFilterValue = exports.setCampaignFilterValue = (0, _helpers.actionCreator)(SET_CAMPAIGN_FILTER_VALUE);
	
	var getTables = exports.getTables = function getTables(obj) {
	  return function (dispatch, getState) {
	    var url = 'campaigns/search';
	
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGNS_TABLES, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var getCampaignCSV = exports.getCampaignCSV = function getCampaignCSV(obj) {
	  return function (dispatch, getState) {
	    var url = 'campaigns/search';
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGNS_CSV_DATA, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var getChannelCampaignList = exports.getChannelCampaignList = function getChannelCampaignList(channel, startDate, endDate) {
	  return function (dispatch, getState) {
	    var url = 'campaigns/channels/' + channel + '?from=' + startDate + '&to=' + endDate;
	    var dataType = void 0;
	    switch (channel) {
	      case "social":
	        dataType = GET_SOCIAL_CAMPAIGN_LIST;
	        break;
	      case "display":
	        dataType = GET_DISPLAY_CAMPAIGN_LIST;
	        break;
	      case "email":
	      default:
	        dataType = GET_EMAIL_CAMPAIGN_LIST;
	        break;
	    }
	    (0, _Api.callApi)(dispatch, getState, dataType, url);
	  };
	};
	
	var getCampaignById = exports.getCampaignById = function getCampaignById(id, redirect, clientId) {
	  return function (dispatch, getState) {
	    var url = 'campaigns/' + id;
	    if (redirect) {
	      (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_DETAIL, url, { method: "GET" }, {
	        success: function success() {
	          var search = '';
	          if (clientId) {
	            search = '?cid=' + clientId;
	          }
	          dispatch((0, _reactRouterRedux.push)('/campaigns/edit/' + id + search));
	        }
	      });
	    } else {
	      (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_DETAIL, url);
	    }
	  };
	};
	
	var saveCampaignGroup = exports.saveCampaignGroup = function saveCampaignGroup(data) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SAVE_CAMPAIGN_GROUP, "campaigns", {
	      method: 'POST',
	      body: JSON.stringify(data)
	    }, { success: function success() {
	        dispatch((0, _reactRouterRedux.push)("/campaigns"));
	      } });
	  };
	};
	
	var getCampaignGroupAggregated = exports.getCampaignGroupAggregated = function getCampaignGroupAggregated(campaignId, dateRange) {
	  return function (dispatch, getState) {
	    //callApi(dispatch, getState, GET_CAMPAIGN_GROUP_AGGREGATED, `campaigns/aggregated/${campaignId}/${dateRange}`);
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_GROUP_AGGREGATED, 'campaigns/' + campaignId + '/message-engagement-timeseries/' + dateRange);
	  };
	};
	
	var getCampaignChannelAggregated = exports.getCampaignChannelAggregated = function getCampaignChannelAggregated(campaignId, dateRange) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_AGGREGATED_BY_CHANNEL, 'campaigns/' + campaignId + '/message-engagement-by-channel/' + dateRange);
	  };
	};
	
	var getEmailChannelAggregated = exports.getEmailChannelAggregated = function getEmailChannelAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	  return function (dispatch, getState) {
	    var url = deploymentId === "aggregated" ? 'campaigns/' + groupCampaignId + '/email/activities-timeseries/' + dateRange : 'campaigns/' + groupCampaignId + '/email/activities-timeseries/' + dateRange + '?deploymentId=' + deploymentId;
	    if (channelCampaignId && channelCampaignId !== 'aggregated') {
	      url += '&channelCampaignId=' + channelCampaignId;
	    }
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_EMAIL_AGGREGATED, url);
	    //`campaigns/report/email/${groupdCampaignId}/${campaignId}/${dateRange}`);
	  };
	};
	
	var getSocialChannelAggregated = exports.getSocialChannelAggregated = function getSocialChannelAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	  return function (dispatch, getState) {
	    var url = deploymentId === "aggregated" ? 'campaigns/' + groupCampaignId + '/social/activities-timeseries/' + dateRange : 'campaigns/' + groupCampaignId + '/social/activities-timeseries/' + dateRange + '?deploymentId=' + deploymentId;
	    if (channelCampaignId && channelCampaignId !== 'aggregated') {
	      url += '&channelCampaignId=' + channelCampaignId;
	    }
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_SOCIAL_AGGREGATED, url);
	  };
	};
	
	var getDisplayChannelAggregated = exports.getDisplayChannelAggregated = function getDisplayChannelAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	  return function (dispatch, getState) {
	    var url = deploymentId === "aggregated" ? 'campaigns/' + groupCampaignId + '/display/activities-timeseries/' + dateRange : 'campaigns/' + groupCampaignId + '/display/activities-timeseries/' + dateRange + '?deploymentId=' + deploymentId;
	    if (channelCampaignId && channelCampaignId !== 'aggregated') {
	      url += '&channelCampaignId=' + channelCampaignId;
	    }
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_DISPLAY_AGGREGATED, url);
	  };
	};
	
	var getEmailChannelStatsAggregated = exports.getEmailChannelStatsAggregated = function getEmailChannelStatsAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	  return function (dispatch, getState) {
	    var url = deploymentId === "aggregated" ? 'campaigns/' + groupCampaignId + '/email/campaign-stats/' + dateRange : 'campaigns/' + groupCampaignId + '/email/campaign-stats/' + dateRange + '?deploymentId=' + deploymentId;
	    if (channelCampaignId && channelCampaignId !== 'aggregated') {
	      url += '&channelCampaignId=' + channelCampaignId;
	    }
	
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_EMAIL_STATS_AGGREGATED, url);
	  };
	};
	
	var getSocialChannelStatsAggregated = exports.getSocialChannelStatsAggregated = function getSocialChannelStatsAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	  return function (dispatch, getState) {
	    var url = deploymentId === "aggregated" ? 'campaigns/' + groupCampaignId + '/social/campaign-stats/' + dateRange : 'campaigns/' + groupCampaignId + '/social/campaign-stats/' + dateRange + '?deploymentId=' + deploymentId;
	    if (channelCampaignId && channelCampaignId !== 'aggregated') {
	      url += '&channelCampaignId=' + channelCampaignId;
	    }
	
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED, url);
	  };
	};
	
	var getDisplayChannelStatsAggregated = exports.getDisplayChannelStatsAggregated = function getDisplayChannelStatsAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	  return function (dispatch, getState) {
	    var url = deploymentId === "aggregated" ? 'campaigns/' + groupCampaignId + '/display/campaign-stats/' + dateRange : 'campaigns/' + groupCampaignId + '/display/campaign-stats/' + dateRange + '?deploymentId=' + deploymentId;
	    if (channelCampaignId && channelCampaignId !== 'aggregated') {
	      url += '&channelCampaignId=' + channelCampaignId;
	    }
	
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED, url);
	  };
	};
	
	var getCampaignTopLinkStats = exports.getCampaignTopLinkStats = function getCampaignTopLinkStats(groupCampaignId, channelCampaignId, dateRange, rowCount, type) {
	  return function (dispatch, getState) {
	    var url = rowCount ? 'campaigns/' + groupCampaignId + '/channel-campaigns/' + channelCampaignId + '/top-links-clicked/' + dateRange + '?limit=' + rowCount : 'campaigns/' + groupCampaignId + '/channel-campaigns/' + channelCampaignId + '/top-links-clicked/' + dateRange;
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_TOP_LINK_STATS, url);
	  };
	};
	
	var getCampaignTopLocationClickStats = exports.getCampaignTopLocationClickStats = function getCampaignTopLocationClickStats(groupCampaignId, channelCampaignId, dateRange, rowCount, type) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, GET_CAMPAIGN_TOP_LOCATION_STATS, 'campaigns/' + groupCampaignId + '/channel-campaigns/' + channelCampaignId + '/top-locations/' + dateRange + '?limit=' + (rowCount ? rowCount : ""));
	  };
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.searchByName = exports.getCreateCampaign = exports.getAttributes = exports.getSegmentArchiveData = exports.getSegmentWithRules = exports.copySegment = exports.archiveSegment = exports.reactiveSegment = exports.rollbackRequestSuccessToFalse = exports.clearReactiveStatus = exports.archiveSuccess = exports.getSegmentList = exports.recordActiveQueryParams = exports.selectedSegment = exports.clearSegmentWithRules = exports.RECORD_ACTIVE_QUERY_PARAMS = exports.SELECTED_SEGMENT = exports.SEARCH_BY_NAME = exports.CLEAR_SEGMENT_WITH_RULES = exports.ROLLBACK_VALUE = exports.CREATE_CAMPAIGN = exports.SEGMENT_WITH_RULES = exports.COPY_SEGMENT = exports.GET_ATTRIBUTES = exports.IF_ARCHIVE_SUCCESS = exports.REACTIVATE_SEGMENT = exports.CLEAR_REACTIVE_STATUS = exports.ARCHIVE_SEGMENT = exports.SEGMENT_ARCHIVE = exports.SEGMENT_LIST = undefined;
	
	var _Api = __webpack_require__(45);
	
	var _qs = __webpack_require__(192);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	var _helpers = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEGMENT_LIST = exports.SEGMENT_LIST = "SEGMENT_LIST";
	var SEGMENT_ARCHIVE = exports.SEGMENT_ARCHIVE = "SEGMENT_ARCHIVE";
	var ARCHIVE_SEGMENT = exports.ARCHIVE_SEGMENT = "ARCHIVE_SEGMENT";
	var CLEAR_REACTIVE_STATUS = exports.CLEAR_REACTIVE_STATUS = "CLEAR_REACTIVE_STATUS";
	var REACTIVATE_SEGMENT = exports.REACTIVATE_SEGMENT = "REACTIVATE_SEGMENT";
	var IF_ARCHIVE_SUCCESS = exports.IF_ARCHIVE_SUCCESS = "IF_ARCHIVE_SUCCESS";
	var GET_ATTRIBUTES = exports.GET_ATTRIBUTES = "GET_ATTRIBUTES";
	var COPY_SEGMENT = exports.COPY_SEGMENT = "COPY_SEGMENT";
	var SEGMENT_WITH_RULES = exports.SEGMENT_WITH_RULES = "SEGMENT_WITH_RULES";
	var CREATE_CAMPAIGN = exports.CREATE_CAMPAIGN = "CREATE_CAMPAIGN";
	var ROLLBACK_VALUE = exports.ROLLBACK_VALUE = "ROLLBACK_VALUE";
	var CLEAR_SEGMENT_WITH_RULES = exports.CLEAR_SEGMENT_WITH_RULES = "CLEAR_SEGMENT_WITH_RULES";
	var SEARCH_BY_NAME = exports.SEARCH_BY_NAME = "SEARCH_BY_NAME";
	var SELECTED_SEGMENT = exports.SELECTED_SEGMENT = "SELECTED_SEGMENT";
	var RECORD_ACTIVE_QUERY_PARAMS = exports.RECORD_ACTIVE_QUERY_PARAMS = "RECORD_ACTIVE_QUERY_PARAMS";
	
	var clearSegmentWithRules = exports.clearSegmentWithRules = (0, _helpers.actionCreator)(CLEAR_SEGMENT_WITH_RULES);
	// when user select checkbox record the segment id
	var selectedSegment = exports.selectedSegment = (0, _helpers.actionCreator)(SELECTED_SEGMENT);
	// record the query params
	var recordActiveQueryParams = exports.recordActiveQueryParams = (0, _helpers.actionCreator)(RECORD_ACTIVE_QUERY_PARAMS);
	
	var getSegmentList = exports.getSegmentList = function getSegmentList() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (dispatch, getState) {
	    var params = _qs2.default.stringify(data);
	    var url = "segments/list?" + params;
	    (0, _Api.callApi)(dispatch, getState, SEGMENT_LIST, url);
	  };
	};
	
	var archiveSuccess = exports.archiveSuccess = (0, _helpers.actionCreator)(IF_ARCHIVE_SUCCESS);
	var clearReactiveStatus = exports.clearReactiveStatus = (0, _helpers.actionCreator)(CLEAR_REACTIVE_STATUS);
	var rollbackRequestSuccessToFalse = exports.rollbackRequestSuccessToFalse = (0, _helpers.actionCreator)(ROLLBACK_VALUE);
	
	var reactiveSegment = exports.reactiveSegment = function reactiveSegment(id) {
	  return function (dispatch, getState) {
	    var url = "segments/restore/" + id;
	    (0, _Api.callApi)(dispatch, getState, REACTIVATE_SEGMENT, url, { method: "POST" });
	  };
	};
	var archiveSegment = exports.archiveSegment = function archiveSegment(id) {
	  return function (dispatch, getState) {
	    var url = "segments/archive/" + id;
	    (0, _Api.callApi)(dispatch, getState, ARCHIVE_SEGMENT, url, {
	      method: "POST"
	    }, {
	      success: function success() {
	        dispatch(archiveSuccess(id));
	      }
	    });
	  };
	};
	
	var copySegment = exports.copySegment = function copySegment(id) {
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, COPY_SEGMENT, "segments/copy", {
	      method: "POST",
	      body: JSON.stringify({ id: id })
	    }, {
	      success: function success() {
	        dispatch((0, _reactRouterRedux.push)("/segment/create"));
	      }
	    });
	  };
	};
	
	var getSegmentWithRules = exports.getSegmentWithRules = function getSegmentWithRules(id, cid) {
	  return function (dispatch, getState) {
	    var url = "segments/" + id + "/with-rules";
	    (0, _Api.callApi)(dispatch, getState, SEGMENT_WITH_RULES, url, {}, {
	      success: function success() {
	        if (cid) {
	          dispatch((0, _reactRouterRedux.push)("/segments/builder?id=" + id + "&cid=" + cid));
	        } else dispatch((0, _reactRouterRedux.push)("/segments/builder?id=" + id));
	      }
	    });
	  };
	};
	
	var getSegmentArchiveData = exports.getSegmentArchiveData = function getSegmentArchiveData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (dispatch, getState) {
	    var params = _qs2.default.stringify(data);
	    var url = "segments/list?" + params;
	    (0, _Api.callApi)(dispatch, getState, SEGMENT_ARCHIVE, url);
	  };
	};
	
	var getAttributes = exports.getAttributes = function getAttributes(id) {
	  return function (dispatch, getState) {
	    var url = "segments/" + id + "/segmentAttributes";
	    (0, _Api.callApi)(dispatch, getState, GET_ATTRIBUTES, url);
	  };
	};
	
	var getCreateCampaign = exports.getCreateCampaign = function getCreateCampaign(id, data) {
	  return function (dispatch, getState) {
	    var url = "segments/" + id + "/audience-files";
	    (0, _Api.callApi)(dispatch, getState, CREATE_CAMPAIGN, url, {
	      method: "POST",
	      body: JSON.stringify(data)
	    });
	  };
	};
	
	// search by name action
	var searchByName = exports.searchByName = function searchByName(obj) {
	  return function (dispatch, getState) {
	    var url = "segments/name-suggestions?keyword=" + obj.keyword + "&status=" + obj.status + "&clientId=" + obj.clientId;
	    if (obj.source) {
	      url += "&source=" + obj.source;
	    }
	    (0, _Api.callApi)(dispatch, getState, SEARCH_BY_NAME, url);
	  };
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearSuspendError = exports.getAccountManage = exports.reassingAccountManager = exports.getClientAssignments = exports.suspendUser = exports.updateRole = exports.updateProfile = exports.getTableList = exports.sendClientUserInvite = exports.sendInvite = exports.rollBackReassign = exports.rollBackStatus = exports.rollBackUpdateStatus = exports.getClientRoles = exports.getRoles = exports.CLEAR_SUSPEND_ERROR = exports.ACCOUNT_MANAGER = exports.TEAM_MEMBER_OPTIONS = exports.REASSIGN_ROLL_BACK = exports.REASSIGN_ACCOUNT_MANAGER = exports.CLIENT_ASSIGNMENTS = exports.SUSPEND_USER = exports.UPDATE_ROLE = exports.ROLLBACK_UPDATE_STATUS = exports.UPDATE_PROFILE = exports.GET_TABLE_LIST = exports.SET_STATUS_TO_FALSE = exports.SENDCLIENTINVITE = exports.SENDINVITE = exports.GETCLIENTROLES = exports.GETROLE = undefined;
	
	var _Api = __webpack_require__(45);
	
	// import { getSeconds } from "date-fns";
	
	var GETROLE = exports.GETROLE = "GETROLE";
	var GETCLIENTROLES = exports.GETCLIENTROLES = "GETCLIENTROLES";
	var SENDINVITE = exports.SENDINVITE = "SENDINVITE";
	var SENDCLIENTINVITE = exports.SENDCLIENTINVITE = "SENDCLIENTINVITE";
	var SET_STATUS_TO_FALSE = exports.SET_STATUS_TO_FALSE = "SET_STATUS_TO_FALSE";
	var GET_TABLE_LIST = exports.GET_TABLE_LIST = "GET_TABLE_LIST";
	var UPDATE_PROFILE = exports.UPDATE_PROFILE = "UPDATE_PROFILE";
	var ROLLBACK_UPDATE_STATUS = exports.ROLLBACK_UPDATE_STATUS = "ROLLBACK_UPDATE_STATUS";
	var UPDATE_ROLE = exports.UPDATE_ROLE = "UPDATE_ROLE";
	var SUSPEND_USER = exports.SUSPEND_USER = "SUSPEND_USER";
	var CLIENT_ASSIGNMENTS = exports.CLIENT_ASSIGNMENTS = "CLIENT_ASSIGNMENTS";
	var REASSIGN_ACCOUNT_MANAGER = exports.REASSIGN_ACCOUNT_MANAGER = "REASSIGN_ACCOUNT_MANAGER";
	var REASSIGN_ROLL_BACK = exports.REASSIGN_ROLL_BACK = "REASSIGN_ROLL_BACK";
	var TEAM_MEMBER_OPTIONS = exports.TEAM_MEMBER_OPTIONS = "TEAM_MEMBER_OPTIONS";
	var ACCOUNT_MANAGER = exports.ACCOUNT_MANAGER = "ACCOUNT_MANAGER";
	var CLEAR_SUSPEND_ERROR = exports.CLEAR_SUSPEND_ERROR = "CLEAR_SUSPEND_ERROR";
	
	var getRoles = exports.getRoles = function getRoles() {
	  return function (dispatch, getState) {
	    var url = "roles/internal-options";
	    (0, _Api.callApi)(dispatch, getState, GETROLE, url);
	  };
	};
	
	var getClientRoles = exports.getClientRoles = function getClientRoles() {
	  return function (dispatch, getState) {
	    var url = "roles/client-options";
	    (0, _Api.callApi)(dispatch, getState, GETCLIENTROLES, url);
	  };
	};
	
	var rollBackUpdateStatus = exports.rollBackUpdateStatus = function rollBackUpdateStatus() {
	  return {
	    type: ROLLBACK_UPDATE_STATUS,
	    value: false
	  };
	};
	var rollBackStatus = exports.rollBackStatus = function rollBackStatus() {
	  return {
	    type: SET_STATUS_TO_FALSE,
	    value: false
	  };
	};
	var rollBackReassign = exports.rollBackReassign = function rollBackReassign() {
	  return {
	    type: REASSIGN_ROLL_BACK,
	    value: false
	  };
	};
	
	var sendInvite = exports.sendInvite = function sendInvite(obj) {
	  return function (dispatch, getState) {
	    var url = "invitations/internal";
	    (0, _Api.callApi)(dispatch, getState, SENDINVITE, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var sendClientUserInvite = exports.sendClientUserInvite = function sendClientUserInvite(obj) {
	  return function (dispatch, getState) {
	    var url = "invitations/client-to-client";
	    (0, _Api.callApi)(dispatch, getState, SENDCLIENTINVITE, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var getTableList = exports.getTableList = function getTableList(obj, clientId) {
	  return function (dispatch, getState) {
	    var url = clientId && clientId !== "undefined" ? "clients/" + clientId + "/users" : "users/internal";
	    (0, _Api.callApi)(dispatch, getState, GET_TABLE_LIST, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var updateProfile = exports.updateProfile = function updateProfile(id, obj) {
	  return function (dispatch, getState) {
	    var url = "users/" + id + "/update";
	    (0, _Api.callApi)(dispatch, getState, UPDATE_PROFILE, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var updateRole = exports.updateRole = function updateRole(userId, roleId, isUpdateClient) {
	  return function (dispatch, getState) {
	    var url = void 0;
	    if (isUpdateClient === true) {
	      url = "users/" + userId + "/update-client-role-to/" + roleId;
	    } else {
	      if (/system administrator/gi.test(getState().app.roleName)) {
	        url = "users/" + userId + "/update-role-to/" + roleId;
	      } else if (/administrator/gi.test(getState().app.roleName)) {
	        url = "users/" + userId + "/update-client-role-to/" + roleId;
	      }
	    }
	
	    (0, _Api.callApi)(dispatch, getState, UPDATE_ROLE, url, {
	      method: "POST"
	    });
	  };
	};
	
	// below is for user status component
	var suspendUser = exports.suspendUser = function suspendUser(userId, status) {
	  var isClientUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  return function (dispatch, getState) {
	    var url = void 0;
	    if (isClientUser === true) {
	      if (/^(\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members|\/clients\/edit\/Client-Team-Members\/user-status)/g.test(getState().routing.location.pathname)) {
	        if (/^(system administrator|account manager)/gi.test(getState().app.roleName)) {
	          url = "users/" + userId + "/" + status + "/client";
	        } else {
	          url = "users/" + userId + "/" + status + "/business-unit-team-member";
	        }
	      } else {
	        url = "users/" + userId + "/" + status + "/client";
	      }
	    } else {
	      if (/^administrator/gi.test(getState().app.roleName)) {
	        url = "users/" + userId + "/" + status + "/client";
	      } else if (/^(system administrator|account manager)/gi.test(getState().app.roleName) && !/^\/client\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(getState().routing.location.pathname)) {
	        url = "users/" + userId + "/" + status;
	      }
	    }
	
	    (0, _Api.callApi)(dispatch, getState, SUSPEND_USER, url, {
	      method: "POST"
	    });
	  };
	};
	
	var getClientAssignments = exports.getClientAssignments = function getClientAssignments(id) {
	  return function (dispatch, getState) {
	    var url = void 0;
	    if (/^system administrator/gi.test(getState().app.roleName)) {
	      url = "users/" + id + "/clients";
	    } else if (/^administrator/gi.test(getState().app.roleName)) {
	      url = "users/" + id + "/business-units";
	    }
	    (0, _Api.callApi)(dispatch, getState, CLIENT_ASSIGNMENTS, url);
	  };
	};
	
	var reassingAccountManager = exports.reassingAccountManager = function reassingAccountManager(id, obj) {
	  return function (dispatch, getState) {
	    var url = void 0;
	    if (/^system administrator/gi.test(getState().app.roleName)) {
	      url = "users/" + id + "/clients/reassign";
	    } else if (/^(administrator|team member)/gi.test(getState().app.roleName)) {
	      url = "users/" + id + "/business-units/reassign";
	    }
	    (0, _Api.callApi)(dispatch, getState, REASSIGN_ACCOUNT_MANAGER, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    });
	  };
	};
	var getAccountManage = exports.getAccountManage = function getAccountManage(id) {
	  return function (dispatch, getState) {
	    var url = void 0;
	    if (/^system administrator/gi.test(getState().app.roleName)) {
	      url = "commons/account-manager-options";
	    } else if (/^administrator/gi.test(getState().app.roleName)) {
	      url = "clients/" + id + "/team-member-options";
	    }
	    (0, _Api.callApi)(dispatch, getState, ACCOUNT_MANAGER, url);
	  };
	};
	
	var clearSuspendError = exports.clearSuspendError = function clearSuspendError() {
	  return { type: CLEAR_SUSPEND_ERROR };
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(121);
	var core = __webpack_require__(55);
	var ctx = __webpack_require__(360);
	var hide = __webpack_require__(169);
	var has = __webpack_require__(136);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 121 */
104,
/* 122 */
[3162, 134, 553, 371, 135],
/* 123 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 124 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 125 */
/***/ function(module, exports) {

	'use strict';
	
	// http://dev.w3.org/csswg/css-color/
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HEX3 = /^#([a-f0-9]{3})$/i;
	var hex3 = function hex3(value) {
	    var match = value.match(HEX3);
	    if (match) {
	        return [parseInt(match[1][0] + match[1][0], 16), parseInt(match[1][1] + match[1][1], 16), parseInt(match[1][2] + match[1][2], 16), null];
	    }
	    return false;
	};
	
	var HEX6 = /^#([a-f0-9]{6})$/i;
	var hex6 = function hex6(value) {
	    var match = value.match(HEX6);
	    if (match) {
	        return [parseInt(match[1].substring(0, 2), 16), parseInt(match[1].substring(2, 4), 16), parseInt(match[1].substring(4, 6), 16), null];
	    }
	    return false;
	};
	
	var RGB = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
	var rgb = function rgb(value) {
	    var match = value.match(RGB);
	    if (match) {
	        return [Number(match[1]), Number(match[2]), Number(match[3]), null];
	    }
	    return false;
	};
	
	var RGBA = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
	var rgba = function rgba(value) {
	    var match = value.match(RGBA);
	    if (match && match.length > 4) {
	        return [Number(match[1]), Number(match[2]), Number(match[3]), Number(match[4])];
	    }
	    return false;
	};
	
	var fromArray = function fromArray(array) {
	    return [Math.min(array[0], 255), Math.min(array[1], 255), Math.min(array[2], 255), array.length > 3 ? array[3] : null];
	};
	
	var namedColor = function namedColor(name) {
	    var color = NAMED_COLORS[name.toLowerCase()];
	    return color ? color : false;
	};
	
	var Color = function () {
	    function Color(value) {
	        _classCallCheck(this, Color);
	
	        var _ref = Array.isArray(value) ? fromArray(value) : hex3(value) || rgb(value) || rgba(value) || namedColor(value) || hex6(value) || [0, 0, 0, null],
	            _ref2 = _slicedToArray(_ref, 4),
	            r = _ref2[0],
	            g = _ref2[1],
	            b = _ref2[2],
	            a = _ref2[3];
	
	        this.r = r;
	        this.g = g;
	        this.b = b;
	        this.a = a;
	    }
	
	    _createClass(Color, [{
	        key: 'isTransparent',
	        value: function isTransparent() {
	            return this.a === 0;
	        }
	    }, {
	        key: 'toString',
	        value: function toString() {
	            return this.a !== null && this.a !== 1 ? 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.a + ')' : 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')';
	        }
	    }]);
	
	    return Color;
	}();
	
	exports.default = Color;
	
	
	var NAMED_COLORS = {
	    transparent: [0, 0, 0, 0],
	    aliceblue: [240, 248, 255, null],
	    antiquewhite: [250, 235, 215, null],
	    aqua: [0, 255, 255, null],
	    aquamarine: [127, 255, 212, null],
	    azure: [240, 255, 255, null],
	    beige: [245, 245, 220, null],
	    bisque: [255, 228, 196, null],
	    black: [0, 0, 0, null],
	    blanchedalmond: [255, 235, 205, null],
	    blue: [0, 0, 255, null],
	    blueviolet: [138, 43, 226, null],
	    brown: [165, 42, 42, null],
	    burlywood: [222, 184, 135, null],
	    cadetblue: [95, 158, 160, null],
	    chartreuse: [127, 255, 0, null],
	    chocolate: [210, 105, 30, null],
	    coral: [255, 127, 80, null],
	    cornflowerblue: [100, 149, 237, null],
	    cornsilk: [255, 248, 220, null],
	    crimson: [220, 20, 60, null],
	    cyan: [0, 255, 255, null],
	    darkblue: [0, 0, 139, null],
	    darkcyan: [0, 139, 139, null],
	    darkgoldenrod: [184, 134, 11, null],
	    darkgray: [169, 169, 169, null],
	    darkgreen: [0, 100, 0, null],
	    darkgrey: [169, 169, 169, null],
	    darkkhaki: [189, 183, 107, null],
	    darkmagenta: [139, 0, 139, null],
	    darkolivegreen: [85, 107, 47, null],
	    darkorange: [255, 140, 0, null],
	    darkorchid: [153, 50, 204, null],
	    darkred: [139, 0, 0, null],
	    darksalmon: [233, 150, 122, null],
	    darkseagreen: [143, 188, 143, null],
	    darkslateblue: [72, 61, 139, null],
	    darkslategray: [47, 79, 79, null],
	    darkslategrey: [47, 79, 79, null],
	    darkturquoise: [0, 206, 209, null],
	    darkviolet: [148, 0, 211, null],
	    deeppink: [255, 20, 147, null],
	    deepskyblue: [0, 191, 255, null],
	    dimgray: [105, 105, 105, null],
	    dimgrey: [105, 105, 105, null],
	    dodgerblue: [30, 144, 255, null],
	    firebrick: [178, 34, 34, null],
	    floralwhite: [255, 250, 240, null],
	    forestgreen: [34, 139, 34, null],
	    fuchsia: [255, 0, 255, null],
	    gainsboro: [220, 220, 220, null],
	    ghostwhite: [248, 248, 255, null],
	    gold: [255, 215, 0, null],
	    goldenrod: [218, 165, 32, null],
	    gray: [128, 128, 128, null],
	    green: [0, 128, 0, null],
	    greenyellow: [173, 255, 47, null],
	    grey: [128, 128, 128, null],
	    honeydew: [240, 255, 240, null],
	    hotpink: [255, 105, 180, null],
	    indianred: [205, 92, 92, null],
	    indigo: [75, 0, 130, null],
	    ivory: [255, 255, 240, null],
	    khaki: [240, 230, 140, null],
	    lavender: [230, 230, 250, null],
	    lavenderblush: [255, 240, 245, null],
	    lawngreen: [124, 252, 0, null],
	    lemonchiffon: [255, 250, 205, null],
	    lightblue: [173, 216, 230, null],
	    lightcoral: [240, 128, 128, null],
	    lightcyan: [224, 255, 255, null],
	    lightgoldenrodyellow: [250, 250, 210, null],
	    lightgray: [211, 211, 211, null],
	    lightgreen: [144, 238, 144, null],
	    lightgrey: [211, 211, 211, null],
	    lightpink: [255, 182, 193, null],
	    lightsalmon: [255, 160, 122, null],
	    lightseagreen: [32, 178, 170, null],
	    lightskyblue: [135, 206, 250, null],
	    lightslategray: [119, 136, 153, null],
	    lightslategrey: [119, 136, 153, null],
	    lightsteelblue: [176, 196, 222, null],
	    lightyellow: [255, 255, 224, null],
	    lime: [0, 255, 0, null],
	    limegreen: [50, 205, 50, null],
	    linen: [250, 240, 230, null],
	    magenta: [255, 0, 255, null],
	    maroon: [128, 0, 0, null],
	    mediumaquamarine: [102, 205, 170, null],
	    mediumblue: [0, 0, 205, null],
	    mediumorchid: [186, 85, 211, null],
	    mediumpurple: [147, 112, 219, null],
	    mediumseagreen: [60, 179, 113, null],
	    mediumslateblue: [123, 104, 238, null],
	    mediumspringgreen: [0, 250, 154, null],
	    mediumturquoise: [72, 209, 204, null],
	    mediumvioletred: [199, 21, 133, null],
	    midnightblue: [25, 25, 112, null],
	    mintcream: [245, 255, 250, null],
	    mistyrose: [255, 228, 225, null],
	    moccasin: [255, 228, 181, null],
	    navajowhite: [255, 222, 173, null],
	    navy: [0, 0, 128, null],
	    oldlace: [253, 245, 230, null],
	    olive: [128, 128, 0, null],
	    olivedrab: [107, 142, 35, null],
	    orange: [255, 165, 0, null],
	    orangered: [255, 69, 0, null],
	    orchid: [218, 112, 214, null],
	    palegoldenrod: [238, 232, 170, null],
	    palegreen: [152, 251, 152, null],
	    paleturquoise: [175, 238, 238, null],
	    palevioletred: [219, 112, 147, null],
	    papayawhip: [255, 239, 213, null],
	    peachpuff: [255, 218, 185, null],
	    peru: [205, 133, 63, null],
	    pink: [255, 192, 203, null],
	    plum: [221, 160, 221, null],
	    powderblue: [176, 224, 230, null],
	    purple: [128, 0, 128, null],
	    rebeccapurple: [102, 51, 153, null],
	    red: [255, 0, 0, null],
	    rosybrown: [188, 143, 143, null],
	    royalblue: [65, 105, 225, null],
	    saddlebrown: [139, 69, 19, null],
	    salmon: [250, 128, 114, null],
	    sandybrown: [244, 164, 96, null],
	    seagreen: [46, 139, 87, null],
	    seashell: [255, 245, 238, null],
	    sienna: [160, 82, 45, null],
	    silver: [192, 192, 192, null],
	    skyblue: [135, 206, 235, null],
	    slateblue: [106, 90, 205, null],
	    slategray: [112, 128, 144, null],
	    slategrey: [112, 128, 144, null],
	    snow: [255, 250, 250, null],
	    springgreen: [0, 255, 127, null],
	    steelblue: [70, 130, 180, null],
	    tan: [210, 180, 140, null],
	    teal: [0, 128, 128, null],
	    thistle: [216, 191, 216, null],
	    tomato: [255, 99, 71, null],
	    turquoise: [64, 224, 208, null],
	    violet: [238, 130, 238, null],
	    wheat: [245, 222, 179, null],
	    white: [255, 255, 255, null],
	    whitesmoke: [245, 245, 245, null],
	    yellow: [255, 255, 0, null],
	    yellowgreen: [154, 205, 50, null]
	};
	
	var TRANSPARENT = exports.TRANSPARENT = new Color([0, 0, 0, 0]);

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(105),
	    getPrototype = __webpack_require__(409),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(174);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 128 */
53,
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(53));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _Text = _interopRequireDefault(__webpack_require__(161));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _DataUtils = __webpack_require__(40);
	
	var _PolarUtils = __webpack_require__(93);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var cartesianViewBoxShape = _propTypes.default.shape({
	  x: _propTypes.default.number,
	  y: _propTypes.default.number,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number
	});
	
	var polarViewBoxShape = _propTypes.default.shape({
	  cx: _propTypes.default.number,
	  cy: _propTypes.default.number,
	  innerRadius: _propTypes.default.number,
	  outerRadius: _propTypes.default.number,
	  startAngle: _propTypes.default.number,
	  endAngle: _propTypes.default.number
	});
	
	var propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes.default.oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
	  formatter: _propTypes.default.func,
	  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  offset: _propTypes.default.number,
	  position: _propTypes.default.oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center', 'centerTop', 'centerBottom']),
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  className: _propTypes.default.string,
	  content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func])
	});
	
	var defaultProps = {
	  offset: 5
	};
	
	var getLabel = function getLabel(props) {
	  var value = props.value,
	      formatter = props.formatter;
	  var label = (0, _isNil2.default)(props.children) ? value : props.children;
	
	  if ((0, _isFunction2.default)(formatter)) {
	    return formatter(label);
	  }
	
	  return label;
	};
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	};
	
	var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
	  var position = labelProps.position,
	      viewBox = labelProps.viewBox,
	      offset = labelProps.offset,
	      className = labelProps.className;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle,
	      clockWise = viewBox.clockWise;
	  var radius = (innerRadius + outerRadius) / 2;
	  var deltaAngle = getDeltaAngle(startAngle, endAngle);
	  var sign = deltaAngle >= 0 ? 1 : -1;
	  var labelAngle, direction;
	
	  if (position === 'insideStart') {
	    labelAngle = startAngle + sign * offset;
	    direction = clockWise;
	  } else if (position === 'insideEnd') {
	    labelAngle = endAngle - sign * offset;
	    direction = !clockWise;
	  } else if (position === 'end') {
	    labelAngle = endAngle + sign * offset;
	    direction = clockWise;
	  }
	
	  direction = deltaAngle <= 0 ? direction : !direction;
	  var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
	  var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
	  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
	  var id = (0, _isNil2.default)(labelProps.id) ? (0, _DataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
	  return _react.default.createElement("text", _extends({}, attrs, {
	    dominantBaseline: "central",
	    className: (0, _classnames.default)('recharts-radial-bar-label', className)
	  }), _react.default.createElement("defs", null, _react.default.createElement("path", {
	    id: id,
	    d: path
	  })), _react.default.createElement("textPath", {
	    xlinkHref: "#".concat(id)
	  }, label));
	};
	
	var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle;
	  var midAngle = (startAngle + endAngle) / 2;
	
	  if (position === 'outside') {
	    var _polarToCartesian = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle),
	        _x = _polarToCartesian.x,
	        _y = _polarToCartesian.y;
	
	    return {
	      x: _x,
	      y: _y,
	      textAnchor: _x >= cx ? 'start' : 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'center') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'centerTop') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'centerBottom') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  var r = (innerRadius + outerRadius) / 2;
	
	  var _polarToCartesian2 = (0, _PolarUtils.polarToCartesian)(cx, cy, r, midAngle),
	      x = _polarToCartesian2.x,
	      y = _polarToCartesian2.y;
	
	  return {
	    x: x,
	    y: y,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var x = viewBox.x,
	      y = viewBox.y,
	      width = viewBox.width,
	      height = viewBox.height;
	  var sign = height >= 0 ? 1 : -1;
	
	  if (position === 'top') {
	    return {
	      x: x + width / 2,
	      y: y - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: sign > 0 ? 'end' : 'start'
	    };
	  }
	
	  if (position === 'bottom') {
	    return {
	      x: x + width / 2,
	      y: y + height + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'left') {
	    return {
	      x: x - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'right') {
	    return {
	      x: x + width + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideLeft') {
	    return {
	      x: x + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideRight') {
	    return {
	      x: x + width - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideTop') {
	    return {
	      x: x + width / 2,
	      y: y + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottom') {
	    return {
	      x: x + width / 2,
	      y: y + height - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideTopLeft') {
	    return {
	      x: x + offset,
	      y: y + sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideTopRight') {
	    return {
	      x: x + width - offset,
	      y: y + sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottomLeft') {
	    return {
	      x: x + offset,
	      y: y + height - sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideBottomRight') {
	    return {
	      x: x + width - offset,
	      y: y + height - sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if ((0, _isObject2.default)(position) && ((0, _DataUtils.isNumber)(position.x) || (0, _DataUtils.isPercent)(position.x)) && ((0, _DataUtils.isNumber)(position.y) || (0, _DataUtils.isPercent)(position.y))) {
	    return {
	      x: x + (0, _DataUtils.getPercentValue)(position.x, width),
	      y: y + (0, _DataUtils.getPercentValue)(position.y, height),
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  return {
	    x: x + width / 2,
	    y: y + height / 2,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var isPolar = function isPolar(viewBox) {
	  return (0, _DataUtils.isNumber)(viewBox.cx);
	};
	
	function Label(props) {
	  var viewBox = props.viewBox,
	      position = props.position,
	      value = props.value,
	      children = props.children,
	      content = props.content,
	      _props$className = props.className,
	      className = _props$className === void 0 ? '' : _props$className;
	
	  if (!viewBox || (0, _isNil2.default)(value) && (0, _isNil2.default)(children) && !(0, _react.isValidElement)(content) && !(0, _isFunction2.default)(content)) {
	    return null;
	  }
	
	  if ((0, _react.isValidElement)(content)) {
	    return (0, _react.cloneElement)(content, props);
	  }
	
	  var label;
	
	  if ((0, _isFunction2.default)(content)) {
	    label = content(props);
	
	    if ((0, _react.isValidElement)(label)) {
	      return label;
	    }
	  } else {
	    label = getLabel(props);
	  }
	
	  var isPolarLabel = isPolar(viewBox);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(props);
	
	  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
	    return renderRadialLabel(props, label, attrs);
	  }
	
	  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
	  return _react.default.createElement(_Text.default, _extends({
	    className: (0, _classnames.default)('recharts-label', className)
	  }, attrs, positionAttrs), label);
	}
	
	Label.displayName = 'Label';
	Label.defaultProps = defaultProps;
	Label.propTypes = propTypes;
	
	var parseViewBox = function parseViewBox(props) {
	  var cx = props.cx,
	      cy = props.cy,
	      angle = props.angle,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      r = props.r,
	      radius = props.radius,
	      innerRadius = props.innerRadius,
	      outerRadius = props.outerRadius,
	      x = props.x,
	      y = props.y,
	      top = props.top,
	      left = props.left,
	      width = props.width,
	      height = props.height,
	      clockWise = props.clockWise;
	
	  if ((0, _DataUtils.isNumber)(width) && (0, _DataUtils.isNumber)(height)) {
	    if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      };
	    }
	
	    if ((0, _DataUtils.isNumber)(top) && (0, _DataUtils.isNumber)(left)) {
	      return {
	        x: top,
	        y: left,
	        width: width,
	        height: height
	      };
	    }
	  }
	
	  if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	    return {
	      x: x,
	      y: y,
	      width: 0,
	      height: 0
	    };
	  }
	
	  if ((0, _DataUtils.isNumber)(cx) && (0, _DataUtils.isNumber)(cy)) {
	    return {
	      cx: cx,
	      cy: cy,
	      startAngle: startAngle || angle || 0,
	      endAngle: endAngle || angle || 0,
	      innerRadius: innerRadius || 0,
	      outerRadius: outerRadius || radius || r || 0,
	      clockWise: clockWise
	    };
	  }
	
	  if (props.viewBox) {
	    return props.viewBox;
	  }
	
	  return {};
	};
	
	var parseLabel = function parseLabel(label, viewBox) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react.default.createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(label)) {
	    return _react.default.createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox,
	      value: label
	    });
	  }
	
	  if ((0, _react.isValidElement)(label)) {
	    if (label.type === Label) {
	      return (0, _react.cloneElement)(label, {
	        key: 'label-implicit',
	        viewBox: viewBox
	      });
	    }
	
	    return _react.default.createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isFunction2.default)(label)) {
	    return _react.default.createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isObject2.default)(label)) {
	    return _react.default.createElement(Label, _extends({
	      viewBox: viewBox
	    }, label, {
	      key: "label-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var parentViewBox = parseViewBox(parentProps);
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, Label).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      viewBox: viewBox || parentViewBox,
	      key: "label-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
	  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
	};
	
	Label.parseViewBox = parseViewBox;
	Label.renderCallByParent = renderCallByParent;
	var _default = Label;
	exports.default = _default;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabeledScaleHelper = exports.ScaleHelper = exports.rectWithCoords = exports.rectWithPoints = exports.formatAxisMap = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(664));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(1643));
	
	var _ChartUtils = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {String} axisType  The type of axes, x-axis or y-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height,
	      layout = props.layout;
	  var ids = Object.keys(axisMap);
	  var steps = {
	    left: offset.left,
	    leftMirror: offset.left,
	    right: width - offset.right,
	    rightMirror: width - offset.right,
	    top: offset.top,
	    topMirror: offset.top,
	    bottom: height - offset.bottom,
	    bottomMirror: height - offset.bottom
	  };
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var orientation = axis.orientation,
	        domain = axis.domain,
	        _axis$padding = axis.padding,
	        padding = _axis$padding === void 0 ? {} : _axis$padding,
	        mirror = axis.mirror,
	        reversed = axis.reversed;
	    var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
	    var range, x, y, needSpace;
	
	    if (axisType === 'xAxis') {
	      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	    } else if (axisType === 'yAxis') {
	      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	    } else {
	      range = axis.range;
	    }
	
	    if (reversed) {
	      range = [range[1], range[0]];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        scale = _parseScale.scale,
	        realScaleType = _parseScale.realScaleType;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    if (axisType === 'xAxis') {
	      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	      x = offset.left;
	      y = steps[offsetKey] - needSpace * axis.height;
	    } else if (axisType === 'yAxis') {
	      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	      x = steps[offsetKey] - needSpace * axis.width;
	      y = offset.top;
	    }
	
	    var finalAxis = _objectSpread({}, axis, ticks, {
	      realScaleType: realScaleType,
	      x: x,
	      y: y,
	      scale: scale,
	      width: axisType === 'xAxis' ? offset.width : axis.width,
	      height: axisType === 'yAxis' ? offset.height : axis.height
	    });
	
	    finalAxis.bandSize = (0, _ChartUtils.getBandSizeOfAxis)(finalAxis, ticks);
	
	    if (!axis.hide && axisType === 'xAxis') {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	    } else if (!axis.hide) {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var rectWithPoints = function rectWithPoints(_ref, _ref2) {
	  var x1 = _ref.x,
	      y1 = _ref.y;
	  var x2 = _ref2.x,
	      y2 = _ref2.y;
	  return {
	    x: Math.min(x1, x2),
	    y: Math.min(y1, y2),
	    width: Math.abs(x2 - x1),
	    height: Math.abs(y2 - y1)
	  };
	};
	/**
	 * Compute the x, y, width, and height of a box from two reference points.
	 * @param  {Object} coords     x1, x2, y1, and y2
	 * @return {Object} object
	 */
	
	
	exports.rectWithPoints = rectWithPoints;
	
	var rectWithCoords = function rectWithCoords(_ref3) {
	  var x1 = _ref3.x1,
	      y1 = _ref3.y1,
	      x2 = _ref3.x2,
	      y2 = _ref3.y2;
	  return rectWithPoints({
	    x: x1,
	    y: y1
	  }, {
	    x: x2,
	    y: y2
	  });
	};
	
	exports.rectWithCoords = rectWithCoords;
	
	var ScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(ScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new ScaleHelper(obj);
	    }
	  }]);
	
	  function ScaleHelper(scale) {
	    _classCallCheck(this, ScaleHelper);
	
	    this.scale = scale;
	  }
	
	  _createClass(ScaleHelper, [{
	    key: "apply",
	    value: function apply(value) {
	      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref4.bandAware;
	
	      if (value === undefined) {
	        return undefined;
	      }
	
	      if (bandAware) {
	        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
	        return this.scale(value) + offset;
	      }
	
	      return this.scale(value);
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(value) {
	      var range = this.range();
	      var first = range[0];
	      var last = range[range.length - 1];
	      return first <= last ? value >= first && value <= last : value >= last && value <= first;
	    }
	  }, {
	    key: "domain",
	    get: function get() {
	      return this.scale.domain;
	    }
	  }, {
	    key: "range",
	    get: function get() {
	      return this.scale.range;
	    }
	  }, {
	    key: "rangeMin",
	    get: function get() {
	      return this.range()[0];
	    }
	  }, {
	    key: "rangeMax",
	    get: function get() {
	      return this.range()[1];
	    }
	  }, {
	    key: "bandwidth",
	    get: function get() {
	      return this.scale.bandwidth;
	    }
	  }]);
	
	  return ScaleHelper;
	}();
	
	exports.ScaleHelper = ScaleHelper;
	ScaleHelper.EPS = 1e-4;
	
	var LabeledScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(LabeledScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new this(obj);
	    }
	  }]);
	
	  function LabeledScaleHelper(scales) {
	    _classCallCheck(this, LabeledScaleHelper);
	
	    this.scales = (0, _mapValues2.default)(scales, ScaleHelper.create);
	    Object.assign(this, this.scales);
	  }
	
	  _createClass(LabeledScaleHelper, [{
	    key: "apply",
	    value: function apply(coords) {
	      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref5.bandAware;
	
	      var scales = this.scales;
	      return (0, _mapValues2.default)(coords, function (value, label) {
	        return scales[label].apply(value, {
	          bandAware: bandAware
	        });
	      });
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(coords) {
	      var scales = this.scales;
	      return (0, _every2.default)(coords, function (value, label) {
	        return scales[label].isInRange(value);
	      });
	    }
	  }]);
	
	  return LabeledScaleHelper;
	}();
	
	exports.LabeledScaleHelper = LabeledScaleHelper;

/***/ },
/* 131 */
/***/ function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 132 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 133 */
[3151, 537],
/* 134 */
[3152, 170],
/* 135 */
[3155, 168],
/* 136 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 137 */
[3172, 554, 361],
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var isDate = __webpack_require__(580)
	
	var MILLISECONDS_IN_HOUR = 3600000
	var MILLISECONDS_IN_MINUTE = 60000
	var DEFAULT_ADDITIONAL_DIGITS = 2
	
	var parseTokenDateTimeDelimeter = /[T ]/
	var parseTokenPlainTime = /:/
	
	// year tokens
	var parseTokenYY = /^(\d{2})$/
	var parseTokensYYY = [
	  /^([+-]\d{2})$/, // 0 additional digits
	  /^([+-]\d{3})$/, // 1 additional digit
	  /^([+-]\d{4})$/ // 2 additional digits
	]
	
	var parseTokenYYYY = /^(\d{4})/
	var parseTokensYYYYY = [
	  /^([+-]\d{4})/, // 0 additional digits
	  /^([+-]\d{5})/, // 1 additional digit
	  /^([+-]\d{6})/ // 2 additional digits
	]
	
	// date tokens
	var parseTokenMM = /^-(\d{2})$/
	var parseTokenDDD = /^-?(\d{3})$/
	var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
	var parseTokenWww = /^-?W(\d{2})$/
	var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/
	
	// time tokens
	var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
	var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
	var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/
	
	// timezone tokens
	var parseTokenTimezone = /([Z+-].*)$/
	var parseTokenTimezoneZ = /^(Z)$/
	var parseTokenTimezoneHH = /^([+-])(\d{2})$/
	var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/
	
	/**
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If an argument is a string, the function tries to parse it.
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If all above fails, the function passes the given argument to Date constructor.
	 *
	 * @param {Date|String|Number} argument - the value to convert
	 * @param {Object} [options] - the object with options
	 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = parse('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Parse string '+02014101',
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = parse('+02014101', {additionalDigits: 1})
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parse (argument, dirtyOptions) {
	  if (isDate(argument)) {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime())
	  } else if (typeof argument !== 'string') {
	    return new Date(argument)
	  }
	
	  var options = dirtyOptions || {}
	  var additionalDigits = options.additionalDigits
	  if (additionalDigits == null) {
	    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
	  } else {
	    additionalDigits = Number(additionalDigits)
	  }
	
	  var dateStrings = splitDateString(argument)
	
	  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
	  var year = parseYearResult.year
	  var restDateString = parseYearResult.restDateString
	
	  var date = parseDate(restDateString, year)
	
	  if (date) {
	    var timestamp = date.getTime()
	    var time = 0
	    var offset
	
	    if (dateStrings.time) {
	      time = parseTime(dateStrings.time)
	    }
	
	    if (dateStrings.timezone) {
	      offset = parseTimezone(dateStrings.timezone)
	    } else {
	      // get offset accurate to hour in timezones that change offset
	      offset = new Date(timestamp + time).getTimezoneOffset()
	      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()
	    }
	
	    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
	  } else {
	    return new Date(argument)
	  }
	}
	
	function splitDateString (dateString) {
	  var dateStrings = {}
	  var array = dateString.split(parseTokenDateTimeDelimeter)
	  var timeString
	
	  if (parseTokenPlainTime.test(array[0])) {
	    dateStrings.date = null
	    timeString = array[0]
	  } else {
	    dateStrings.date = array[0]
	    timeString = array[1]
	  }
	
	  if (timeString) {
	    var token = parseTokenTimezone.exec(timeString)
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '')
	      dateStrings.timezone = token[1]
	    } else {
	      dateStrings.time = timeString
	    }
	  }
	
	  return dateStrings
	}
	
	function parseYear (dateString, additionalDigits) {
	  var parseTokenYYY = parseTokensYYY[additionalDigits]
	  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]
	
	  var token
	
	  // YYYY or ±YYYYY
	  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
	  if (token) {
	    var yearString = token[1]
	    return {
	      year: parseInt(yearString, 10),
	      restDateString: dateString.slice(yearString.length)
	    }
	  }
	
	  // YY or ±YYY
	  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
	  if (token) {
	    var centuryString = token[1]
	    return {
	      year: parseInt(centuryString, 10) * 100,
	      restDateString: dateString.slice(centuryString.length)
	    }
	  }
	
	  // Invalid ISO-formatted year
	  return {
	    year: null
	  }
	}
	
	function parseDate (dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) {
	    return null
	  }
	
	  var token
	  var date
	  var month
	  var week
	
	  // YYYY
	  if (dateString.length === 0) {
	    date = new Date(0)
	    date.setUTCFullYear(year)
	    return date
	  }
	
	  // YYYY-MM
	  token = parseTokenMM.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    month = parseInt(token[1], 10) - 1
	    date.setUTCFullYear(year, month)
	    return date
	  }
	
	  // YYYY-DDD or YYYYDDD
	  token = parseTokenDDD.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    var dayOfYear = parseInt(token[1], 10)
	    date.setUTCFullYear(year, 0, dayOfYear)
	    return date
	  }
	
	  // YYYY-MM-DD or YYYYMMDD
	  token = parseTokenMMDD.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    month = parseInt(token[1], 10) - 1
	    var day = parseInt(token[2], 10)
	    date.setUTCFullYear(year, month, day)
	    return date
	  }
	
	  // YYYY-Www or YYYYWww
	  token = parseTokenWww.exec(dateString)
	  if (token) {
	    week = parseInt(token[1], 10) - 1
	    return dayOfISOYear(year, week)
	  }
	
	  // YYYY-Www-D or YYYYWwwD
	  token = parseTokenWwwD.exec(dateString)
	  if (token) {
	    week = parseInt(token[1], 10) - 1
	    var dayOfWeek = parseInt(token[2], 10) - 1
	    return dayOfISOYear(year, week, dayOfWeek)
	  }
	
	  // Invalid ISO-formatted date
	  return null
	}
	
	function parseTime (timeString) {
	  var token
	  var hours
	  var minutes
	
	  // hh
	  token = parseTokenHH.exec(timeString)
	  if (token) {
	    hours = parseFloat(token[1].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR
	  }
	
	  // hh:mm or hhmm
	  token = parseTokenHHMM.exec(timeString)
	  if (token) {
	    hours = parseInt(token[1], 10)
	    minutes = parseFloat(token[2].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE
	  }
	
	  // hh:mm:ss or hhmmss
	  token = parseTokenHHMMSS.exec(timeString)
	  if (token) {
	    hours = parseInt(token[1], 10)
	    minutes = parseInt(token[2], 10)
	    var seconds = parseFloat(token[3].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE +
	      seconds * 1000
	  }
	
	  // Invalid ISO-formatted time
	  return null
	}
	
	function parseTimezone (timezoneString) {
	  var token
	  var absoluteOffset
	
	  // Z
	  token = parseTokenTimezoneZ.exec(timezoneString)
	  if (token) {
	    return 0
	  }
	
	  // ±hh
	  token = parseTokenTimezoneHH.exec(timezoneString)
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  // ±hh:mm or ±hhmm
	  token = parseTokenTimezoneHHMM.exec(timezoneString)
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  return 0
	}
	
	function dayOfISOYear (isoYear, week, day) {
	  week = week || 0
	  day = day || 0
	  var date = new Date(0)
	  date.setUTCFullYear(isoYear, 0, 4)
	  var fourthOfJanuaryDay = date.getUTCDay() || 7
	  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
	  date.setUTCDate(date.getUTCDate() + diff)
	  return date
	}
	
	module.exports = parse


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _propertyUtils = __webpack_require__(1373);
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	var getComputedStyleX = void 0;
	
	// https://stackoverflow.com/a/3485654/3040605
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	  elem.style.display = originalStyle;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box = void 0;
	  var x = void 0;
	  var y = void 0;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	  if (node.nodeType === 9) {
	    return node;
	  }
	  return node.ownerDocument;
	}
	
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = (0, _propertyUtils.getTransitionProperty)(elem) || '';
	    (0, _propertyUtils.setTransitionProperty)(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = presetH + 'px';
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = presetV + 'px';
	  }
	  // force relayout
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  forceRelayout(elem);
	  if ('left' in offset || 'top' in offset) {
	    (0, _propertyUtils.setTransitionProperty)(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	
	function setTransform(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = (0, _propertyUtils.getTransformXY)(elem);
	  var resultXY = { x: originalXY.x, y: originalXY.y };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  (0, _propertyUtils.setTransformXY)(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);
	
	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }
	
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && (0, _propertyUtils.getTransformName)() in document.body.style) {
	    setTransform(elem, offset, option);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = void 0;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = void 0;
	  var j = void 0;
	  var i = void 0;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = '' + prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val = void 0;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i = void 0;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      utils.mix(ret, args[i]);
	    }
	    return ret;
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);
	
	exports['default'] = utils;
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 141 */
124,
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBoundCurves = exports.calculatePaddingBoxPath = exports.calculateBorderBoxPath = exports.parsePathForBorder = exports.parseDocumentSize = exports.calculateContentBox = exports.calculatePaddingBox = exports.parseBounds = exports.Bounds = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Vector = __webpack_require__(276);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _BezierCurve = __webpack_require__(1480);
	
	var _BezierCurve2 = _interopRequireDefault(_BezierCurve);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TOP = 0;
	var RIGHT = 1;
	var BOTTOM = 2;
	var LEFT = 3;
	
	var H = 0;
	var V = 1;
	
	var Bounds = exports.Bounds = function () {
	    function Bounds(x, y, w, h) {
	        _classCallCheck(this, Bounds);
	
	        this.left = x;
	        this.top = y;
	        this.width = w;
	        this.height = h;
	    }
	
	    _createClass(Bounds, null, [{
	        key: 'fromClientRect',
	        value: function fromClientRect(clientRect, scrollX, scrollY) {
	            return new Bounds(clientRect.left + scrollX, clientRect.top + scrollY, clientRect.width, clientRect.height);
	        }
	    }]);
	
	    return Bounds;
	}();
	
	var parseBounds = exports.parseBounds = function parseBounds(node, scrollX, scrollY) {
	    return Bounds.fromClientRect(node.getBoundingClientRect(), scrollX, scrollY);
	};
	
	var calculatePaddingBox = exports.calculatePaddingBox = function calculatePaddingBox(bounds, borders) {
	    return new Bounds(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth));
	};
	
	var calculateContentBox = exports.calculateContentBox = function calculateContentBox(bounds, padding, borders) {
	    // TODO support percentage paddings
	    var paddingTop = padding[TOP].value;
	    var paddingRight = padding[RIGHT].value;
	    var paddingBottom = padding[BOTTOM].value;
	    var paddingLeft = padding[LEFT].value;
	
	    return new Bounds(bounds.left + paddingLeft + borders[LEFT].borderWidth, bounds.top + paddingTop + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth + paddingLeft + paddingRight), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth + paddingTop + paddingBottom));
	};
	
	var parseDocumentSize = exports.parseDocumentSize = function parseDocumentSize(document) {
	    var body = document.body;
	    var documentElement = document.documentElement;
	
	    if (!body || !documentElement) {
	        throw new Error( false ? 'Unable to get document size' : '');
	    }
	    var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
	
	    var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
	
	    return new Bounds(0, 0, width, height);
	};
	
	var parsePathForBorder = exports.parsePathForBorder = function parsePathForBorder(curves, borderSide) {
	    switch (borderSide) {
	        case TOP:
	            return createPathFromCurves(curves.topLeftOuter, curves.topLeftInner, curves.topRightOuter, curves.topRightInner);
	        case RIGHT:
	            return createPathFromCurves(curves.topRightOuter, curves.topRightInner, curves.bottomRightOuter, curves.bottomRightInner);
	        case BOTTOM:
	            return createPathFromCurves(curves.bottomRightOuter, curves.bottomRightInner, curves.bottomLeftOuter, curves.bottomLeftInner);
	        case LEFT:
	        default:
	            return createPathFromCurves(curves.bottomLeftOuter, curves.bottomLeftInner, curves.topLeftOuter, curves.topLeftInner);
	    }
	};
	
	var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
	    var path = [];
	    if (outer1 instanceof _BezierCurve2.default) {
	        path.push(outer1.subdivide(0.5, false));
	    } else {
	        path.push(outer1);
	    }
	
	    if (outer2 instanceof _BezierCurve2.default) {
	        path.push(outer2.subdivide(0.5, true));
	    } else {
	        path.push(outer2);
	    }
	
	    if (inner2 instanceof _BezierCurve2.default) {
	        path.push(inner2.subdivide(0.5, true).reverse());
	    } else {
	        path.push(inner2);
	    }
	
	    if (inner1 instanceof _BezierCurve2.default) {
	        path.push(inner1.subdivide(0.5, false).reverse());
	    } else {
	        path.push(inner1);
	    }
	
	    return path;
	};
	
	var calculateBorderBoxPath = exports.calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
	    return [curves.topLeftOuter, curves.topRightOuter, curves.bottomRightOuter, curves.bottomLeftOuter];
	};
	
	var calculatePaddingBoxPath = exports.calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
	    return [curves.topLeftInner, curves.topRightInner, curves.bottomRightInner, curves.bottomLeftInner];
	};
	
	var parseBoundCurves = exports.parseBoundCurves = function parseBoundCurves(bounds, borders, borderRadius) {
	    var tlh = borderRadius[CORNER.TOP_LEFT][H].getAbsoluteValue(bounds.width);
	    var tlv = borderRadius[CORNER.TOP_LEFT][V].getAbsoluteValue(bounds.height);
	    var trh = borderRadius[CORNER.TOP_RIGHT][H].getAbsoluteValue(bounds.width);
	    var trv = borderRadius[CORNER.TOP_RIGHT][V].getAbsoluteValue(bounds.height);
	    var brh = borderRadius[CORNER.BOTTOM_RIGHT][H].getAbsoluteValue(bounds.width);
	    var brv = borderRadius[CORNER.BOTTOM_RIGHT][V].getAbsoluteValue(bounds.height);
	    var blh = borderRadius[CORNER.BOTTOM_LEFT][H].getAbsoluteValue(bounds.width);
	    var blv = borderRadius[CORNER.BOTTOM_LEFT][V].getAbsoluteValue(bounds.height);
	
	    var factors = [];
	    factors.push((tlh + trh) / bounds.width);
	    factors.push((blh + brh) / bounds.width);
	    factors.push((tlv + blv) / bounds.height);
	    factors.push((trv + brv) / bounds.height);
	    var maxFactor = Math.max.apply(Math, factors);
	
	    if (maxFactor > 1) {
	        tlh /= maxFactor;
	        tlv /= maxFactor;
	        trh /= maxFactor;
	        trv /= maxFactor;
	        brh /= maxFactor;
	        brv /= maxFactor;
	        blh /= maxFactor;
	        blv /= maxFactor;
	    }
	
	    var topWidth = bounds.width - trh;
	    var rightHeight = bounds.height - brv;
	    var bottomWidth = bounds.width - brh;
	    var leftHeight = bounds.height - blv;
	
	    return {
	        topLeftOuter: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new _Vector2.default(bounds.left, bounds.top),
	        topLeftInner: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, Math.max(0, tlh - borders[LEFT].borderWidth), Math.max(0, tlv - borders[TOP].borderWidth), CORNER.TOP_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth),
	        topRightOuter: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top),
	        topRightInner: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borders[LEFT].borderWidth), bounds.top + borders[TOP].borderWidth, topWidth > bounds.width + borders[LEFT].borderWidth ? 0 : trh - borders[LEFT].borderWidth, trv - borders[TOP].borderWidth, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + borders[TOP].borderWidth),
	        bottomRightOuter: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top + bounds.height),
	        bottomRightInner: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borders[LEFT].borderWidth), bounds.top + Math.min(rightHeight, bounds.height + borders[TOP].borderWidth), Math.max(0, brh - borders[RIGHT].borderWidth), brv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth),
	        bottomLeftOuter: blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left, bounds.top + bounds.height),
	        bottomLeftInner: blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + leftHeight, Math.max(0, blh - borders[LEFT].borderWidth), blv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth)
	    };
	};
	
	var CORNER = {
	    TOP_LEFT: 0,
	    TOP_RIGHT: 1,
	    BOTTOM_RIGHT: 2,
	    BOTTOM_LEFT: 3
	};
	
	var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
	    var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
	    var ox = r1 * kappa; // control point offset horizontal
	    var oy = r2 * kappa; // control point offset vertical
	    var xm = x + r1; // x-middle
	    var ym = y + r2; // y-middle
	
	    switch (position) {
	        case CORNER.TOP_LEFT:
	            return new _BezierCurve2.default(new _Vector2.default(x, ym), new _Vector2.default(x, ym - oy), new _Vector2.default(xm - ox, y), new _Vector2.default(xm, y));
	        case CORNER.TOP_RIGHT:
	            return new _BezierCurve2.default(new _Vector2.default(x, y), new _Vector2.default(x + ox, y), new _Vector2.default(xm, ym - oy), new _Vector2.default(xm, ym));
	        case CORNER.BOTTOM_RIGHT:
	            return new _BezierCurve2.default(new _Vector2.default(xm, y), new _Vector2.default(xm, y + oy), new _Vector2.default(x + ox, ym), new _Vector2.default(x, ym));
	        case CORNER.BOTTOM_LEFT:
	        default:
	            return new _BezierCurve2.default(new _Vector2.default(xm, ym), new _Vector2.default(xm - ox, ym), new _Vector2.default(x, y + oy), new _Vector2.default(x, y));
	    }
	};

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.calculateLengthFromValueWithUnit = exports.LENGTH_TYPE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NodeContainer = __webpack_require__(177);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LENGTH_WITH_UNIT = /([\d.]+)(px|r?em|%)/i;
	
	var LENGTH_TYPE = exports.LENGTH_TYPE = {
	    PX: 0,
	    PERCENTAGE: 1
	};
	
	var Length = function () {
	    function Length(value) {
	        _classCallCheck(this, Length);
	
	        this.type = value.substr(value.length - 1) === '%' ? LENGTH_TYPE.PERCENTAGE : LENGTH_TYPE.PX;
	        var parsedValue = parseFloat(value);
	        if (false) {
	            console.error('Invalid value given for Length: "' + value + '"');
	        }
	        this.value = isNaN(parsedValue) ? 0 : parsedValue;
	    }
	
	    _createClass(Length, [{
	        key: 'isPercentage',
	        value: function isPercentage() {
	            return this.type === LENGTH_TYPE.PERCENTAGE;
	        }
	    }, {
	        key: 'getAbsoluteValue',
	        value: function getAbsoluteValue(parentLength) {
	            return this.isPercentage() ? parentLength * (this.value / 100) : this.value;
	        }
	    }], [{
	        key: 'create',
	        value: function create(v) {
	            return new Length(v);
	        }
	    }]);
	
	    return Length;
	}();
	
	exports.default = Length;
	
	
	var getRootFontSize = function getRootFontSize(container) {
	    var parent = container.parent;
	    return parent ? getRootFontSize(parent) : parseFloat(container.style.font.fontSize);
	};
	
	var calculateLengthFromValueWithUnit = exports.calculateLengthFromValueWithUnit = function calculateLengthFromValueWithUnit(container, value, unit) {
	    switch (unit) {
	        case 'px':
	        case '%':
	            return new Length(value + unit);
	        case 'em':
	        case 'rem':
	            var length = new Length(value);
	            length.value *= unit === 'em' ? parseFloat(container.style.font.fontSize) : getRootFontSize(container);
	            return length;
	        default:
	            // TODO: handle correctly if unknown unit is used
	            return new Length('0');
	    }
	};

/***/ },
/* 144 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 145 */
[3185, 636, 1581],
/* 146 */
[3186, 281, 1600],
/* 147 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 148 */
[3196, 282, 226],
/* 149 */
[3203, 1546, 1591],
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(226),
	    createAggregator = __webpack_require__(1580);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 152 */
[3236, 629, 639, 106],
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(630),
	    baseIteratee = __webpack_require__(60),
	    baseSome = __webpack_require__(1564),
	    isArray = __webpack_require__(29),
	    isIterateeCall = __webpack_require__(182);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(1726);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSearch = function ActionSearch(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })
	  );
	};
	ActionSearch = (0, _pure2.default)(ActionSearch);
	ActionSearch.displayName = 'ActionSearch';
	ActionSearch.muiName = 'SvgIcon';
	
	exports.default = ActionSearch;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayArrow = function AvPlayArrow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 5v14l11-7z' })
	  );
	};
	AvPlayArrow = (0, _pure2.default)(AvPlayArrow);
	AvPlayArrow.displayName = 'AvPlayArrow';
	AvPlayArrow.muiName = 'SvgIcon';
	
	exports.default = AvPlayArrow;

/***/ },
/* 157 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ },
/* 158 */
[3242, 35],
/* 159 */
[3203, 2883, 2911],
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reduceCssCalc = _interopRequireDefault(__webpack_require__(3085));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _DataUtils = __webpack_require__(40);
	
	var _ReactUtils = __webpack_require__(25);
	
	var _DOMUtils = __webpack_require__(346);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil2.default)(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return {
	        word: word,
	        width: (0, _DOMUtils.getStringSize)(word, props.style).width
	      };
	    });
	    var spaceWidth = (0, _DOMUtils.getStringSize)("\xA0", props.style).width;
	    return {
	      wordsWithComputedWidth: wordsWithComputedWidth,
	      spaceWidth: spaceWidth
	    };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Text);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Text)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      wordsByLines: []
	    };
	    return _this;
	  }
	
	  _createClass(Text, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
	      this.updateWordsByLines(nextProps, needCalculate);
	    }
	  }, {
	    key: "updateWordsByLines",
	    value: function updateWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            this.updateWordsWithoutCalculate(props);
	            return;
	          }
	        }
	
	        var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	        this.setState({
	          wordsByLines: wordsByLines
	        });
	      } else {
	        this.updateWordsWithoutCalculate(props);
	      }
	    }
	  }, {
	    key: "updateWordsWithoutCalculate",
	    value: function updateWordsWithoutCalculate(props) {
	      var words = !(0, _isNil2.default)(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	      this.setState({
	        wordsByLines: [{
	          words: words
	        }]
	      });
	    }
	  }, {
	    key: "calculateWordsByLines",
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	      return (wordsWithComputedWidth || []).reduce(function (result, _ref) {
	        var word = _ref.word,
	            width = _ref.width;
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = {
	            words: [word],
	            width: width
	          };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          dx = _this$props.dx,
	          dy = _this$props.dy,
	          textAnchor = _this$props.textAnchor,
	          verticalAnchor = _this$props.verticalAnchor,
	          scaleToFit = _this$props.scaleToFit,
	          angle = _this$props.angle,
	          lineHeight = _this$props.lineHeight,
	          capHeight = _this$props.capHeight,
	          className = _this$props.className,
	          textProps = _objectWithoutProperties(_this$props, ["dx", "dy", "textAnchor", "verticalAnchor", "scaleToFit", "angle", "lineHeight", "capHeight", "className"]);
	
	      var wordsByLines = this.state.wordsByLines;
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	      var startDy;
	
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc.default)("calc(".concat(capHeight, ")"));
	          break;
	
	        case 'middle':
	          startDy = (0, _reduceCssCalc.default)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
	          break;
	
	        default:
	          startDy = (0, _reduceCssCalc.default)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
	          break;
	      }
	
	      var transforms = [];
	
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push("scale(".concat(this.props.width / lineWidth, ")"));
	      }
	
	      if (angle) {
	        transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
	      }
	
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react.default.createElement("text", _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), {
	        x: x,
	        y: y,
	        className: (0, _classnames.default)('recharts-text', className),
	        textAnchor: textAnchor
	      }), wordsByLines.map(function (line, index) {
	        return _react.default.createElement("tspan", {
	          x: x,
	          dy: index === 0 ? startDy : lineHeight,
	          key: index
	        }, line.words.join(' '));
	      }));
	    }
	  }]);
	
	  return Text;
	}(_react.Component);
	
	Text.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes.default.bool,
	  angle: _propTypes.default.number,
	  textAnchor: _propTypes.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes.default.oneOf(['start', 'middle', 'end']),
	  style: _propTypes.default.object
	});
	Text.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em',
	  // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior
	
	};
	var _default = Text;
	exports.default = _default;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Dot = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Dot, _Component);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dot).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          r = _this$props.r,
	          className = _this$props.className;
	      var layerClass = (0, _classnames.default)('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react.default.createElement("circle", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.Component), _class2.displayName = 'Dot', _class2.propTypes = {
	  className: _propTypes.default.string,
	  cx: _propTypes.default.number,
	  cy: _propTypes.default.number,
	  r: _propTypes.default.number
	}, _temp)) || _class;
	
	var _default = Dot;
	exports.default = _default;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(175);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changePassword = exports.updatePhoto = exports.updateLogo = exports.updateProfile = exports.getPhoto = exports.getCompanyLogo = exports.getTimezone = exports.getStates = exports.setStatus = exports.CHANGE_PASSWORD = exports.UPDATE_PHOTOT = exports.UPDATE_LOGO = exports.SET_STATUS = exports.UPDATE_PROFILE = exports.GET_PHOTO = exports.GET_COMPANY_LOGO = exports.GET_TIMEZONE = exports.GET_STATES = undefined;
	
	var _Api = __webpack_require__(45);
	
	var GET_STATES = exports.GET_STATES = 'GET_STATES';
	var GET_TIMEZONE = exports.GET_TIMEZONE = 'GET_TIMEZONE';
	var GET_COMPANY_LOGO = exports.GET_COMPANY_LOGO = 'GET_COMPANY_LOGO';
	var GET_PHOTO = exports.GET_PHOTO = 'GET_PHOTO';
	var UPDATE_PROFILE = exports.UPDATE_PROFILE = 'UPDATE_PROFILE';
	var SET_STATUS = exports.SET_STATUS = 'SET_STATUS';
	var UPDATE_LOGO = exports.UPDATE_LOGO = 'UPDATA_LOGO';
	var UPDATE_PHOTOT = exports.UPDATE_PHOTOT = 'UPDATE_PHOTO';
	var CHANGE_PASSWORD = exports.CHANGE_PASSWORD = 'CHANGE_PASSWORD';
	
	var setStatus = exports.setStatus = function setStatus(value) {
	  return { type: SET_STATUS, value: value };
	};
	
	var getStates = exports.getStates = function getStates() {
	  return function (dispatch, getStates) {
	    var url = 'commons/state-options';
	    (0, _Api.callApi)(dispatch, getStates, GET_STATES, url);
	  };
	};
	
	var getTimezone = exports.getTimezone = function getTimezone() {
	  return function (dispatch, getStates) {
	    var url = 'commons/timezone-options';
	
	    (0, _Api.callApi)(dispatch, getStates, GET_TIMEZONE, url);
	  };
	};
	
	var getCompanyLogo = exports.getCompanyLogo = function getCompanyLogo(id) {
	  return function (dispatch, getStates) {
	    var url = 'pub/clients/' + id + '/logo';
	
	    (0, _Api.callApi)(dispatch, getStates, GET_COMPANY_LOGO, url);
	  };
	};
	
	var getPhoto = exports.getPhoto = function getPhoto(imgFilename) {
	  return function (dispatch, getStates) {
	    var url = 'avatars/' + imgFilename;
	
	    (0, _Api.callApi)(dispatch, getStates, GET_PHOTO, url);
	  };
	};
	
	var updateProfile = exports.updateProfile = function updateProfile(obj) {
	  return function (dispatch, getStates) {
	    var url = 'users/my-profile/basic-info';
	
	    (0, _Api.callApi)(dispatch, getStates, UPDATE_PROFILE, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var updateLogo = exports.updateLogo = function updateLogo(id, uuid) {
	  return function (dispatch, getStates) {
	    var url = 'clients/' + id + '/logo/' + uuid;
	
	    (0, _Api.callApi)(dispatch, getStates, UPDATE_LOGO, url, {
	      method: 'POST'
	    });
	  };
	};
	
	var updatePhoto = exports.updatePhoto = function updatePhoto(uuid) {
	  return function (dispatch, getStates) {
	    var url = 'users/my-profile/avatar/' + uuid;
	
	    (0, _Api.callApi)(dispatch, getStates, UPDATE_PHOTOT, url, {
	      method: 'POST'
	    });
	  };
	};
	
	var changePassword = exports.changePassword = function changePassword(obj) {
	  return function (dispatch, getState) {
	    var url = 'users/my-profile/change-password';
	    (0, _Api.callApi)(dispatch, getState, CHANGE_PASSWORD, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestActivation = exports.getSegmentRulesCounts = exports.getSegmentCounts = exports.fetchSegmentSummary = exports.clearSegmentSegmentAttrCounts = exports.clearSegmentSummary = exports.REQUEST_ACTIVATION = exports.CLEAR_SEGMENT_ATTR_COUNTS = exports.CLEAR_SEGMENT_SUMMARY = exports.SEGMENT_ATTR_COUNTS = exports.SEGMENT_COUNTS = exports.SEGMENT_SUMMARY = undefined;
	
	var _helpers = __webpack_require__(95);
	
	var _Api = __webpack_require__(45);
	
	var SEGMENT_SUMMARY = exports.SEGMENT_SUMMARY = "SEGMENT_SUMMARY";
	var SEGMENT_COUNTS = exports.SEGMENT_COUNTS = "SEGMENT_COUNTS";
	var SEGMENT_ATTR_COUNTS = exports.SEGMENT_ATTR_COUNTS = "SEGMENT_ATTR_COUNT";
	var CLEAR_SEGMENT_SUMMARY = exports.CLEAR_SEGMENT_SUMMARY = "CLEAR_SEGMENT_SUMMARY";
	var CLEAR_SEGMENT_ATTR_COUNTS = exports.CLEAR_SEGMENT_ATTR_COUNTS = "CLEAR_SEGMENT_ATTR_COUNTS";
	var REQUEST_ACTIVATION = exports.REQUEST_ACTIVATION = "REQUEST_ACTIVATION";
	
	var clearSegmentSummary = exports.clearSegmentSummary = (0, _helpers.actionCreator)(CLEAR_SEGMENT_SUMMARY);
	var clearSegmentSegmentAttrCounts = exports.clearSegmentSegmentAttrCounts = (0, _helpers.actionCreator)(CLEAR_SEGMENT_ATTR_COUNTS);
	
	var fetchSegmentSummary = exports.fetchSegmentSummary = function fetchSegmentSummary(id) {
	  var url = "segments/" + id + "/with-rules";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SEGMENT_SUMMARY, url);
	  };
	};
	
	var getSegmentCounts = exports.getSegmentCounts = function getSegmentCounts(id) {
	  var url = "segments/" + id + "/counts";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SEGMENT_COUNTS, url);
	  };
	};
	
	var getSegmentRulesCounts = exports.getSegmentRulesCounts = function getSegmentRulesCounts(rules, sid) {
	  var url = sid ? "segments/attribute-counts?sid=" + sid : "segments/attribute-counts";
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SEGMENT_ATTR_COUNTS, url, {
	      method: "POST",
	      body: JSON.stringify(rules)
	    });
	  };
	};
	
	var requestActivation = exports.requestActivation = function requestActivation(id, clientId, subject, comment) {
	  var url = "segments/" + id + "/request-activation";
	  var postData = {
	    clientId: clientId,
	    subject: subject,
	    comment: comment
	  };
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, REQUEST_ACTIVATION, url, {
	      method: "POST",
	      body: JSON.stringify(postData)
	    });
	  };
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	__webpack_require__(1400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author chargoyao
	 * @property {string} linkName link name
	 * @property {string} crumb
	 * @property {string} btnText button text
	 * @property {string} btnClassName button class name
	 * @property {function} handleDownload download callback
	 */
	var SubscriptionInfoTitle = function (_Component) {
	  _inherits(SubscriptionInfoTitle, _Component);
	
	  function SubscriptionInfoTitle() {
	    _classCallCheck(this, SubscriptionInfoTitle);
	
	    return _possibleConstructorReturn(this, (SubscriptionInfoTitle.__proto__ || Object.getPrototypeOf(SubscriptionInfoTitle)).apply(this, arguments));
	  }
	
	  _createClass(SubscriptionInfoTitle, [{
	    key: "handleDownload",
	    value: function handleDownload() {
	      this.props.handleDownload();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          crumbsLink = _props.crumbsLink,
	          crumbs = _props.crumbs;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "subscription-info-title clearfix" },
	        _react2.default.createElement(
	          "ul",
	          { className: "clearfix", style: { width: "100%" } },
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/campaigns?cid=" + this.props.selected_client },
	              this.props.linkName
	            )
	          ),
	          !crumbs && _react2.default.createElement(
	            "li",
	            null,
	            ">"
	          ),
	          (0, _map2.default)(crumbs, function (crumb, index) {
	            return [_react2.default.createElement(
	              "li",
	              { style: { margin: "0 10px" } },
	              " > "
	            ), _react2.default.createElement(
	              "li",
	              null,
	              crumbsLink && crumbsLink[index] ? _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: crumbsLink[index] },
	                crumb
	              ) : crumb
	            )];
	          }),
	          !crumbs && _react2.default.createElement(
	            "li",
	            null,
	            this.props.crumb
	          ),
	          this.props.showDownloadBtn && _react2.default.createElement(
	            "li",
	            { style: { float: "right" } },
	            _react2.default.createElement(
	              "button",
	              {
	                className: "pull-right btn btn-aa-default nav-btn-download-report",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this2.props.handleDownload();
	                }
	              },
	              "Download Report"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SubscriptionInfoTitle;
	}(_react.Component);
	
	SubscriptionInfoTitle.defaultProps = {
	  linkName: "Dashboard",
	  crumbsLink: [],
	  btnText: "DOWNLOAD CSV FILE",
	  showDownloadBtn: false
	};
	
	exports.default = SubscriptionInfoTitle;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1245);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1244);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 168 */
123,
/* 169 */
[3157, 122, 215, 135],
/* 170 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 171 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 172 */
[3155, 123],
/* 173 */
170,
/* 174 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 175 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(272);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(224);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(604);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(1468);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(1469);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Color = __webpack_require__(125);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Util = __webpack_require__(178);
	
	var _background = __webpack_require__(225);
	
	var _border = __webpack_require__(398);
	
	var _borderRadius = __webpack_require__(1483);
	
	var _display = __webpack_require__(1484);
	
	var _float = __webpack_require__(1485);
	
	var _font = __webpack_require__(1486);
	
	var _letterSpacing = __webpack_require__(1487);
	
	var _lineBreak = __webpack_require__(1488);
	
	var _listStyle = __webpack_require__(277);
	
	var _margin = __webpack_require__(1489);
	
	var _overflow = __webpack_require__(1490);
	
	var _overflowWrap = __webpack_require__(611);
	
	var _padding = __webpack_require__(612);
	
	var _position = __webpack_require__(613);
	
	var _textDecoration = __webpack_require__(399);
	
	var _textShadow = __webpack_require__(1491);
	
	var _textTransform = __webpack_require__(614);
	
	var _transform = __webpack_require__(1492);
	
	var _visibility = __webpack_require__(1493);
	
	var _wordBreak = __webpack_require__(1494);
	
	var _zIndex = __webpack_require__(1495);
	
	var _Bounds = __webpack_require__(142);
	
	var _Input = __webpack_require__(606);
	
	var _ListItem = __webpack_require__(397);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
	
	var NodeContainer = function () {
	    function NodeContainer(node, parent, resourceLoader, index) {
	        var _this = this;
	
	        _classCallCheck(this, NodeContainer);
	
	        this.parent = parent;
	        this.tagName = node.tagName;
	        this.index = index;
	        this.childNodes = [];
	        this.listItems = [];
	        if (typeof node.start === 'number') {
	            this.listStart = node.start;
	        }
	        var defaultView = node.ownerDocument.defaultView;
	        var scrollX = defaultView.pageXOffset;
	        var scrollY = defaultView.pageYOffset;
	        var style = defaultView.getComputedStyle(node, null);
	        var display = (0, _display.parseDisplay)(style.display);
	
	        var IS_INPUT = node.type === 'radio' || node.type === 'checkbox';
	
	        var position = (0, _position.parsePosition)(style.position);
	
	        this.style = {
	            background: IS_INPUT ? _Input.INPUT_BACKGROUND : (0, _background.parseBackground)(style, resourceLoader),
	            border: IS_INPUT ? _Input.INPUT_BORDERS : (0, _border.parseBorder)(style),
	            borderRadius: (node instanceof defaultView.HTMLInputElement || node instanceof HTMLInputElement) && IS_INPUT ? (0, _Input.getInputBorderRadius)(node) : (0, _borderRadius.parseBorderRadius)(style),
	            color: IS_INPUT ? _Input.INPUT_COLOR : new _Color2.default(style.color),
	            display: display,
	            float: (0, _float.parseCSSFloat)(style.float),
	            font: (0, _font.parseFont)(style),
	            letterSpacing: (0, _letterSpacing.parseLetterSpacing)(style.letterSpacing),
	            listStyle: display === _display.DISPLAY.LIST_ITEM ? (0, _listStyle.parseListStyle)(style) : null,
	            lineBreak: (0, _lineBreak.parseLineBreak)(style.lineBreak),
	            margin: (0, _margin.parseMargin)(style),
	            opacity: parseFloat(style.opacity),
	            overflow: INPUT_TAGS.indexOf(node.tagName) === -1 ? (0, _overflow.parseOverflow)(style.overflow) : _overflow.OVERFLOW.HIDDEN,
	            overflowWrap: (0, _overflowWrap.parseOverflowWrap)(style.overflowWrap ? style.overflowWrap : style.wordWrap),
	            padding: (0, _padding.parsePadding)(style),
	            position: position,
	            textDecoration: (0, _textDecoration.parseTextDecoration)(style),
	            textShadow: (0, _textShadow.parseTextShadow)(style.textShadow),
	            textTransform: (0, _textTransform.parseTextTransform)(style.textTransform),
	            transform: (0, _transform.parseTransform)(style),
	            visibility: (0, _visibility.parseVisibility)(style.visibility),
	            wordBreak: (0, _wordBreak.parseWordBreak)(style.wordBreak),
	            zIndex: (0, _zIndex.parseZIndex)(position !== _position.POSITION.STATIC ? style.zIndex : 'auto')
	        };
	
	        if (this.isTransformed()) {
	            // getBoundingClientRect provides values post-transform, we want them without the transformation
	            node.style.transform = 'matrix(1,0,0,1,0,0)';
	        }
	
	        if (display === _display.DISPLAY.LIST_ITEM) {
	            var listOwner = (0, _ListItem.getListOwner)(this);
	            if (listOwner) {
	                var listIndex = listOwner.listItems.length;
	                listOwner.listItems.push(this);
	                this.listIndex = node.hasAttribute('value') && typeof node.value === 'number' ? node.value : listIndex === 0 ? typeof listOwner.listStart === 'number' ? listOwner.listStart : 1 : listOwner.listItems[listIndex - 1].listIndex + 1;
	            }
	        }
	
	        // TODO move bound retrieval for all nodes to a later stage?
	        if (node.tagName === 'IMG') {
	            node.addEventListener('load', function () {
	                _this.bounds = (0, _Bounds.parseBounds)(node, scrollX, scrollY);
	                _this.curvedBounds = (0, _Bounds.parseBoundCurves)(_this.bounds, _this.style.border, _this.style.borderRadius);
	            });
	        }
	        this.image = getImage(node, resourceLoader);
	        this.bounds = IS_INPUT ? (0, _Input.reformatInputBounds)((0, _Bounds.parseBounds)(node, scrollX, scrollY)) : (0, _Bounds.parseBounds)(node, scrollX, scrollY);
	        this.curvedBounds = (0, _Bounds.parseBoundCurves)(this.bounds, this.style.border, this.style.borderRadius);
	
	        if (false) {
	            this.name = '' + node.tagName.toLowerCase() + (node.id ? '#' + node.id : '') + node.className.toString().split(' ').map(function (s) {
	                return s.length ? '.' + s : '';
	            }).join('');
	        }
	    }
	
	    _createClass(NodeContainer, [{
	        key: 'getClipPaths',
	        value: function getClipPaths() {
	            var parentClips = this.parent ? this.parent.getClipPaths() : [];
	            var isClipped = this.style.overflow !== _overflow.OVERFLOW.VISIBLE;
	
	            return isClipped ? parentClips.concat([(0, _Bounds.calculatePaddingBoxPath)(this.curvedBounds)]) : parentClips;
	        }
	    }, {
	        key: 'isInFlow',
	        value: function isInFlow() {
	            return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();
	        }
	    }, {
	        key: 'isVisible',
	        value: function isVisible() {
	            return !(0, _Util.contains)(this.style.display, _display.DISPLAY.NONE) && this.style.opacity > 0 && this.style.visibility === _visibility.VISIBILITY.VISIBLE;
	        }
	    }, {
	        key: 'isAbsolutelyPositioned',
	        value: function isAbsolutelyPositioned() {
	            return this.style.position !== _position.POSITION.STATIC && this.style.position !== _position.POSITION.RELATIVE;
	        }
	    }, {
	        key: 'isPositioned',
	        value: function isPositioned() {
	            return this.style.position !== _position.POSITION.STATIC;
	        }
	    }, {
	        key: 'isFloating',
	        value: function isFloating() {
	            return this.style.float !== _float.FLOAT.NONE;
	        }
	    }, {
	        key: 'isRootElement',
	        value: function isRootElement() {
	            return this.parent === null;
	        }
	    }, {
	        key: 'isTransformed',
	        value: function isTransformed() {
	            return this.style.transform !== null;
	        }
	    }, {
	        key: 'isPositionedWithZIndex',
	        value: function isPositionedWithZIndex() {
	            return this.isPositioned() && !this.style.zIndex.auto;
	        }
	    }, {
	        key: 'isInlineLevel',
	        value: function isInlineLevel() {
	            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_FLEX) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_GRID) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_LIST_ITEM) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
	        }
	    }, {
	        key: 'isInlineBlockOrInlineTable',
	        value: function isInlineBlockOrInlineTable() {
	            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
	        }
	    }]);
	
	    return NodeContainer;
	}();
	
	exports.default = NodeContainer;
	
	
	var getImage = function getImage(node, resourceLoader) {
	    if (node instanceof node.ownerDocument.defaultView.SVGSVGElement || node instanceof SVGSVGElement) {
	        var s = new XMLSerializer();
	        return resourceLoader.loadImage('data:image/svg+xml,' + encodeURIComponent(s.serializeToString(node)));
	    }
	    switch (node.tagName) {
	        case 'IMG':
	            // $FlowFixMe
	            var img = node;
	            return resourceLoader.loadImage(img.currentSrc || img.src);
	        case 'CANVAS':
	            // $FlowFixMe
	            var canvas = node;
	            return resourceLoader.loadCanvas(canvas);
	        case 'IFRAME':
	            var iframeKey = node.getAttribute('data-html2canvas-internal-iframe-key');
	            if (iframeKey) {
	                return iframeKey;
	            }
	            break;
	    }
	
	    return null;
	};

/***/ },
/* 178 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var contains = exports.contains = function contains(bit, value) {
	    return (bit & value) !== 0;
	};
	
	var distance = exports.distance = function distance(a, b) {
	    return Math.sqrt(a * a + b * b);
	};
	
	var copyCSSStyles = exports.copyCSSStyles = function copyCSSStyles(style, target) {
	    // Edge does not provide value for cssText
	    for (var i = style.length - 1; i >= 0; i--) {
	        var property = style.item(i);
	        // Safari shows pseudoelements if content is set
	        if (property !== 'content') {
	            target.style.setProperty(property, style.getPropertyValue(property));
	        }
	    }
	    return target;
	};
	
	var SMALL_IMAGE = exports.SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/***/ },
/* 179 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedValue;
	function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
	  if (keepUnprefixed) {
	    return [prefixedValue, value];
	  }
	  return prefixedValue;
	}
	module.exports = exports["default"];

/***/ },
/* 180 */
[3180, 88],
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(29),
	    isKey = __webpack_require__(411),
	    stringToPath = __webpack_require__(1629),
	    toString = __webpack_require__(233);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 182 */
[3208, 184, 106, 229, 53],
/* 183 */
[3229, 187],
/* 184 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(627),
	    baseEach = __webpack_require__(145),
	    castFunction = __webpack_require__(1570),
	    isArray = __webpack_require__(29);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 186 */
[3231, 285],
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(105),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(60),
	    basePullAt = __webpack_require__(1559);
	
	/**
	 * Removes all elements from `array` that `predicate` returns truthy for
	 * and returns an array of the removed elements. The predicate is invoked
	 * with three arguments: (value, index, array).
	 *
	 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	 * to pull elements from an array by value.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new array of removed elements.
	 * @example
	 *
	 * var array = [1, 2, 3, 4];
	 * var evens = _.remove(array, function(n) {
	 *   return n % 2 == 0;
	 * });
	 *
	 * console.log(array);
	 * // => [1, 3]
	 *
	 * console.log(evens);
	 * // => [2, 4]
	 */
	function remove(array, predicate) {
	  var result = [];
	  if (!(array && array.length)) {
	    return result;
	  }
	  var index = -1,
	      indexes = [],
	      length = array.length;
	
	  predicate = baseIteratee(predicate, 3);
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result.push(value);
	      indexes.push(index);
	    }
	  }
	  basePullAt(array, indexes);
	  return result;
	}
	
	module.exports = remove;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(1693);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(112);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(710);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _lodash = __webpack_require__(624);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverAnimationDefault = __webpack_require__(1702);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'none'
	  }
	};
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover(props, context) {
	    (0, _classCallCheck3.default)(this, Popover);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));
	
	    _this.timeout = null;
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props,
	          animated = _this$props.animated,
	          animation = _this$props.animation,
	          anchorEl = _this$props.anchorEl,
	          anchorOrigin = _this$props.anchorOrigin,
	          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
	          canAutoPosition = _this$props.canAutoPosition,
	          children = _this$props.children,
	          onRequestClose = _this$props.onRequestClose,
	          style = _this$props.style,
	          targetOrigin = _this$props.targetOrigin,
	          useLayerForClickAway = _this$props.useLayerForClickAway,
	          scrollableContainer = _this$props.scrollableContainer,
	          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway', 'scrollableContainer']);
	
	
	      var styleRoot = style;
	
	      if (!animated) {
	        styleRoot = {
	          position: 'fixed',
	          zIndex: _this.context.muiTheme.zIndex.popover
	        };
	
	        if (!_this.state.open) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
	          children
	        );
	      }
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	
	      return _react2.default.createElement(
	        Animation,
	        (0, _extends3.default)({
	          targetOrigin: targetOrigin,
	          style: styleRoot
	        }, other, {
	          open: _this.state.open && !_this.state.closing
	        }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function () {
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (!_this.popoverRefs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.popoverRefs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          targetOrigin = _this$props2.targetOrigin,
	          anchorOrigin = _this$props2.anchorOrigin;
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = targetPosition.top + 'px';
	      targetEl.style.left = targetPosition.left + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.popoverRefs = {};
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.placementTimeout = setTimeout(this.setPlacement);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open === this.props.open) {
	        return;
	      }
	
	      if (nextProps.open) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	        this.setState({
	          open: true,
	          closing: false
	        });
	      } else {
	        if (nextProps.animated) {
	          if (this.timeout !== null) return;
	          this.setState({ closing: true });
	          this.timeout = setTimeout(function () {
	            _this2.setState({
	              open: false
	            }, function () {
	              _this2.timeout = null;
	            });
	          }, 500);
	        } else {
	          this.setState({
	            open: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.placementTimeout);
	      this.placementTimeout = setTimeout(this.setPlacement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleScroll.cancel();
	
	      if (this.placementTimeout) {
	        clearTimeout(this.placementTimeout);
	        this.placementTimeout = null;
	      }
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	      a.bottom = rect.bottom || a.top + a.height;
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = (0, _extends3.default)({}, anchor);
	      var t = (0, _extends3.default)({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
	          positions = _getPositions.positions,
	          anchorPos = _getPositions.anchorPos;
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) {
	          targetPosition.top = Math.max(0, newTop);
	        } else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) {
	            targetPosition.top = Math.max(0, newTop);
	          }
	        }
	      }
	
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) {
	          targetPosition.left = Math.max(0, newLeft);
	        } else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) {
	            targetPosition.left = Math.max(0, newLeft);
	          }
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: this.props.scrollableContainer,
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: function ref(_ref) {
	            return _this3.popoverRefs.layer = _ref;
	          },
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  scrollableContainer: 'window',
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Popover.propTypes =  false ? {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _propTypes2.default.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _propTypes2.default.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _propTypes2.default.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Represents the parent scrollable container.
	   * It can be an element or a string like `window`.
	   */
	  scrollableContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _propTypes2.default.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = Popover;

/***/ },
/* 191 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(2704);
	var parse = __webpack_require__(2703);
	var formats = __webpack_require__(865);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(28);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isPlainObject2 = __webpack_require__(126);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Retrieves the display string from an option. Options can be the string
	 * themselves, or an object with a defined display string. Anything else throws
	 * an error.
	 */
	function getOptionLabel(option, labelKey) {
	  var optionLabel = void 0;
	
	  if (typeof option === 'string') {
	    optionLabel = option;
	  }
	
	  if ((0, _isPlainObject3.default)(option)) {
	    if (typeof labelKey === 'string') {
	      optionLabel = option[labelKey];
	    } else if ((0, _isFunction3.default)(labelKey)) {
	      optionLabel = labelKey(option);
	    }
	  }
	
	  !(typeof optionLabel === 'string') ?  false ? (0, _invariant2.default)(false, 'One or more options does not have a valid label string. Check the ' + '`labelKey` prop to ensure that it matches the correct option key and ' + 'provides a string for filtering and display.') : (0, _invariant2.default)(false) : void 0;
	
	  return optionLabel;
	}
	
	exports.default = getOptionLabel;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(442);
	var setInnerHTML = __webpack_require__(319);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(450);
	var setTextContent = __webpack_require__(911);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(21);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var EventPluginRegistry = __webpack_require__(443);
	var EventPluginUtils = __webpack_require__(314);
	var ReactErrorUtils = __webpack_require__(447);
	
	var accumulateInto = __webpack_require__(904);
	var forEachAccumulated = __webpack_require__(905);
	var invariant = __webpack_require__(21);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(196);
	var EventPluginUtils = __webpack_require__(314);
	
	var accumulateInto = __webpack_require__(904);
	var forEachAccumulated = __webpack_require__(905);
	var warning = __webpack_require__(34);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(2800);
	var ReactInstrumentation = __webpack_require__(90);
	
	var warning = __webpack_require__(34);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	var getEventTarget = __webpack_require__(453);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var ReactBaseClasses = __webpack_require__(990);
	var ReactChildren = __webpack_require__(3047);
	var ReactDOMFactories = __webpack_require__(3048);
	var ReactElement = __webpack_require__(202);
	var ReactPropTypes = __webpack_require__(3049);
	var ReactVersion = __webpack_require__(3050);
	
	var createReactClass = __webpack_require__(3051);
	var onlyChild = __webpack_require__(3055);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var ReactCurrentOwner = __webpack_require__(113);
	
	var warning = __webpack_require__(34);
	var canDefineProperty = __webpack_require__(994);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(992);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var XAxis = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(XAxis, _Component);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(XAxis).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.Component), _class2.displayName = 'XAxis', _class2.propTypes = {
	  allowDecimals: _propTypes.default.bool,
	  allowDuplicatedCategory: _propTypes.default.bool,
	  hide: _propTypes.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  domain: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func, _propTypes.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes.default.number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes.default.number,
	  mirror: _propTypes.default.bool,
	  // The orientation of axis
	  orientation: _propTypes.default.oneOf(['top', 'bottom']),
	  type: _propTypes.default.oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes.default.array,
	  // The count of ticks
	  tickCount: _propTypes.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes.default.func,
	  padding: _propTypes.default.shape({
	    left: _propTypes.default.number,
	    right: _propTypes.default.number
	  }),
	  allowDataOverflow: _propTypes.default.bool,
	  scale: _propTypes.default.oneOfType([_propTypes.default.oneOf(_ReactUtils.SCALE_TYPES), _propTypes.default.func]),
	  tick: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.object, _propTypes.default.element]),
	  axisLine: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  tickLine: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  minTickGap: _propTypes.default.number,
	  tickSize: _propTypes.default.number,
	  interval: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes.default.bool
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: {
	    left: 0,
	    right: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false,
	  allowDuplicatedCategory: true
	}, _temp)) || _class;
	
	var _default = XAxis;
	exports.default = _default;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var YAxis = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(YAxis, _Component);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(YAxis).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.Component), _class2.displayName = 'YAxis', _class2.propTypes = {
	  allowDecimals: _propTypes.default.bool,
	  allowDuplicatedCategory: _propTypes.default.bool,
	  hide: _propTypes.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  domain: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func, _propTypes.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes.default.array,
	  // The count of ticks
	  tickCount: _propTypes.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes.default.func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes.default.number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes.default.number,
	  mirror: _propTypes.default.bool,
	  // The orientation of axis
	  orientation: _propTypes.default.oneOf(['left', 'right']),
	  type: _propTypes.default.oneOf(['number', 'category']),
	  padding: _propTypes.default.shape({
	    top: _propTypes.default.number,
	    bottom: _propTypes.default.number
	  }),
	  allowDataOverflow: _propTypes.default.bool,
	  scale: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes.default.func]),
	  tick: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.object, _propTypes.default.element]),
	  axisLine: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  tickLine: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  minTickGap: _propTypes.default.number,
	  tickSize: _propTypes.default.number,
	  interval: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes.default.bool
	}, _class2.defaultProps = {
	  allowDuplicatedCategory: true,
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: {
	    top: 0,
	    bottom: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	}, _temp)) || _class;
	
	var _default = YAxis;
	exports.default = _default;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _ReactUtils = __webpack_require__(25);
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Cell() {
	  return null;
	}
	
	Cell.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES);
	Cell.displayName = 'Cell';
	var _default = Cell;
	exports.default = _default;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _d3Shape = __webpack_require__(388);
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _DataUtils = __webpack_require__(40);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed,
	  curveBasisOpen: _d3Shape.curveBasisOpen,
	  curveBasis: _d3Shape.curveBasis,
	  curveLinearClosed: _d3Shape.curveLinearClosed,
	  curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX,
	  curveMonotoneY: _d3Shape.curveMonotoneY,
	  curveNatural: _d3Shape.curveNatural,
	  curveStep: _d3Shape.curveStep,
	  curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	
	var getX = function getX(p) {
	  return p.x;
	};
	
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction2.default)(type)) {
	    return type;
	  }
	
	  var name = "curve".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
	  }
	
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Curve, _Component);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Curve).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine,
	          layout = _this$props.layout,
	          connectNulls = _this$props.connectNulls;
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction;
	
	      if ((0, _isArray2.default)(baseLine)) {
	        var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
	          return defined(base);
	        }) : baseLine;
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _objectSpread({}, entry, {
	            base: formatBaseLine[index]
	          });
	        });
	
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	
	        lineFunction.defined(defined).curve(curveFactory);
	        return lineFunction(areaPoints);
	      }
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          points = _this$props2.points,
	          path = _this$props2.path,
	          pathRef = _this$props2.pathRef;
	
	      if ((!points || !points.length) && !path) {
	        return null;
	      }
	
	      var realPath = points && points.length ? this.getPath() : path;
	      return _react.default.createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	        className: (0, _classnames.default)('recharts-curve', className),
	        d: realPath,
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.Component), _class2.displayName = 'Curve', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes.default.func]),
	  layout: _propTypes.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
	  points: _propTypes.default.arrayOf(_propTypes.default.object),
	  connectNulls: _propTypes.default.bool,
	  path: _propTypes.default.string,
	  pathRef: _propTypes.default.func
	}), _class2.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	}, _temp)) || _class;
	
	var _default = Curve;
	exports.default = _default;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var ySign = height >= 0 ? 1 : -1;
	  var xSign = width >= 0 ? 1 : -1;
	  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
	  var path;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
	    }
	
	    path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
	
	    if (newRadius[1] > 0) {
	      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
	    }
	
	    path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
	    }
	
	    path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
	
	    if (newRadius[3] > 0) {
	      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
	    }
	
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
	  } else {
	    path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
	  }
	
	  return path;
	};
	
	var Rectangle = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Rectangle, _Component);
	
	  function Rectangle() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rectangle)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Rectangle, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          radius = _this$props.radius,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isAnimationActive = _this$props2.isAnimationActive,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames.default)('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react.default.createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react.default.createElement(_reactSmooth.default, {
	        canBegin: totalLength > 0,
	        from: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currWidth = _ref.width,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react.default.createElement(_reactSmooth.default, {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing
	        }, _react.default.createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Rectangle;
	}(_react.Component), _class2.displayName = 'Rectangle', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  radius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
	  isAnimationActive: _propTypes.default.bool,
	  isUpdateAnimationActive: _propTypes.default.bool,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp)) || _class;
	
	var _default = Rectangle;
	exports.default = _default;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = void 0;
	
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(348);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.upload = exports.register = exports.getInvitationByCode = exports.getDepartment = exports.createAccount = exports.UPLOAD = exports.REGISTER = exports.GETINVITATIONBYCODE = exports.GET_DEPARTMENT = exports.CREATE_ACCOUNT = undefined;
	
	var _Api = __webpack_require__(45);
	
	var CREATE_ACCOUNT = exports.CREATE_ACCOUNT = 'CREATE_ACCOUNT';
	var GET_DEPARTMENT = exports.GET_DEPARTMENT = 'GET_DEPARTMENT';
	var GETINVITATIONBYCODE = exports.GETINVITATIONBYCODE = 'GETINVITATIONBYCODE';
	var REGISTER = exports.REGISTER = 'REGISTER';
	var UPLOAD = exports.UPLOAD = 'UPLOAD';
	
	var createAccount = exports.createAccount = function createAccount(obj) {
	  return function (dispatch, getState) {
	    var url = 'invitations/with/{invitationCode}';
	
	    (0, _Api.callApi)(dispatch, getState, CREATE_ACCOUNT, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var getDepartment = exports.getDepartment = function getDepartment() {
	  return function (dispatch, getState) {
	    var url = 'commons/department-options/internal';
	
	    (0, _Api.callApi)(dispatch, getState, GET_DEPARTMENT, url);
	  };
	};
	
	var getInvitationByCode = exports.getInvitationByCode = function getInvitationByCode(code) {
	  return function (dispatch, getState) {
	    var url = 'invitations/with/' + code;
	
	    (0, _Api.callApi)(dispatch, getState, GETINVITATIONBYCODE, url);
	  };
	};
	
	var register = exports.register = function register(code, obj) {
	  return function (dispatch, getState) {
	    var url = 'invitations/with/' + code + '/internal-register';
	
	    (0, _Api.callApi)(dispatch, getState, REGISTER, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var upload = exports.upload = function upload(formData, code) {
	  return function (dispatch, getState) {
	    var url = 'invitations/with/' + code + '/logo/upload';
	
	    (0, _Api.callApi)(dispatch, getState, UPLOAD, url, {
	      method: 'POST',
	      headers: {
	        'Content-Type': undefined
	      },
	      body: formData
	    });
	  };
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getTagDetail = exports.fetchTagDetail = exports.saveTag = exports.generateTag = exports.clearTagError = exports.clearInsightTagInfo = exports.setTagCampaignName = exports.setTagWebsiteURL = exports.setTagWebsiteName = exports.ADD_TAG_VARIABLE = exports.TAG_CAMPAIGN_NAME = exports.TAG_WEBSITE_URL = exports.TAG_WEBSITE_NAME = exports.GET_TAG_DETAIL = exports.CLEAR_TAG_ERROR = exports.SAVE_TAG = exports.UPDATE_TAG = exports.GENERATE_TAG = exports.CLEAR_INSIGHT_TAG_INFO = undefined;
	
	var _Api = __webpack_require__(45);
	
	var _helpers = __webpack_require__(95);
	
	var _Clients = __webpack_require__(49);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	var CLEAR_INSIGHT_TAG_INFO = exports.CLEAR_INSIGHT_TAG_INFO = "CLEAR_INSIGHT_TAG_INFO";
	var GENERATE_TAG = exports.GENERATE_TAG = "GENERATE_TAG";
	var UPDATE_TAG = exports.UPDATE_TAG = "UPDATE_TAG";
	var SAVE_TAG = exports.SAVE_TAG = "SAVE_TAG";
	var CLEAR_TAG_ERROR = exports.CLEAR_TAG_ERROR = "CLEAR_TAG_ERROR";
	var GET_TAG_DETAIL = exports.GET_TAG_DETAIL = "GET_TAG_DETAIL";
	var TAG_WEBSITE_NAME = exports.TAG_WEBSITE_NAME = 'TAG_WEBSITE_NAME';
	var TAG_WEBSITE_URL = exports.TAG_WEBSITE_URL = "TAG_WEBSITE_URL";
	var TAG_CAMPAIGN_NAME = exports.TAG_CAMPAIGN_NAME = "TAG_CAMPAIGN_NAME";
	var ADD_TAG_VARIABLE = exports.ADD_TAG_VARIABLE = "ADD_TAG_VARIABLE";
	
	var setTagWebsiteName = exports.setTagWebsiteName = (0, _helpers.actionCreator)(TAG_WEBSITE_NAME);
	var setTagWebsiteURL = exports.setTagWebsiteURL = (0, _helpers.actionCreator)(TAG_WEBSITE_URL);
	var setTagCampaignName = exports.setTagCampaignName = (0, _helpers.actionCreator)(TAG_CAMPAIGN_NAME);
	var clearInsightTagInfo = exports.clearInsightTagInfo = (0, _helpers.actionCreator)(CLEAR_INSIGHT_TAG_INFO);
	var clearTagError = exports.clearTagError = (0, _helpers.actionCreator)(CLEAR_TAG_ERROR);
	
	var generateTag = exports.generateTag = function generateTag(clientId, data) {
		return function (dispatch, getState) {
			var url = 'clients/' + clientId + '/tags';
			(0, _Api.callApi)(dispatch, getState, data.id ? UPDATE_TAG : GENERATE_TAG, url, {
				method: 'POST',
				body: JSON.stringify(data)
			});
		};
	};
	
	var saveTag = exports.saveTag = function saveTag(clientId, uuid, data) {
		return function (dispatch, getState) {
			var url = 'clients/' + clientId + '/tags/' + uuid;
			(0, _Api.callApi)(dispatch, getState, SAVE_TAG, url, {
				method: 'POST',
				body: JSON.stringify(data)
			}, {
				success: function success() {
					dispatch((0, _Clients.getClientTags)(clientId));
					dispatch((0, _reactRouterRedux.push)('/insights/tags/list'));
				}
			});
		};
	};
	
	var fetchTagDetail = exports.fetchTagDetail = function fetchTagDetail(clientId, tagid) {
		return function (dispatch, getState) {
			var url = 'clients/' + clientId + '/tags/' + tagid;
			(0, _Api.callApi)(dispatch, getState, GET_TAG_DETAIL, url);
		};
	};
	
	var getTagDetail = exports.getTagDetail = function getTagDetail(clientId, tagid, redirectUrl) {
		return function (dispatch, getState) {
			var url = 'clients/' + clientId + '/tags/' + tagid;
			(0, _Api.callApi)(dispatch, getState, GET_TAG_DETAIL, url, {}, {
				success: function success() {
					dispatch((0, _reactRouterRedux.push)(redirectUrl ? redirectUrl : '/insights/tags/detail'));
				}
			});
		};
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	__webpack_require__(1445);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author chargoyao
	 * @property {string} linkName link name
	 * @property {string} crumb
	 * @property {string} btnText button text
	 * @property {string} btnClassName button class name
	 * @property {function} handleDownload download callback
	 */
	var SubscriptionInfoTitle = function (_Component) {
	  _inherits(SubscriptionInfoTitle, _Component);
	
	  function SubscriptionInfoTitle() {
	    _classCallCheck(this, SubscriptionInfoTitle);
	
	    return _possibleConstructorReturn(this, (SubscriptionInfoTitle.__proto__ || Object.getPrototypeOf(SubscriptionInfoTitle)).apply(this, arguments));
	  }
	
	  _createClass(SubscriptionInfoTitle, [{
	    key: 'handleDownload',
	    value: function handleDownload() {
	      this.props.handleDownload();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'subscription-info-title clearfix' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/dashboard' },
	              this.props.linkName
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '>'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            this.props.crumb
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: this.props.btnClassName, onClick: function onClick() {
	              return _this2.handleDownload();
	            } },
	          this.props.btnText
	        )
	      );
	    }
	  }]);
	
	  return SubscriptionInfoTitle;
	}(_react.Component);
	
	SubscriptionInfoTitle.defaultProps = {
	  linkName: 'Dashboard',
	  crumb: 'Subscriptions',
	  btnText: 'DOWNLOAD CSV FILE'
	};
	
	exports.default = SubscriptionInfoTitle;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author chargoyao
	 * @description button component
	 * @property title
	 * @property className
	 * @property disabled {boolean}
	 * @property ifHasBg {boolean} if false color will be white and border color is black
	 * @method handleClick
	 */
	var Button = function (_PureComponent) {
	  _inherits(Button, _PureComponent);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	  }
	
	  _createClass(Button, [{
	    key: "handleClick",
	    value: function handleClick(e) {
	      this.props.handleClick(e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        "button",
	        {
	          disabled: this.props.disabled,
	          className: (0, _classnames2.default)("aw-btn", className),
	          style: {
	            color: !this.props.ifHasBg ? "black" : "",
	            border: !this.props.ifHasBg ? "1px solid black" : "",
	            background: !this.props.ifHasBg ? "white" : ""
	          },
	          onClick: function onClick(e) {
	            return _this2.handleClick(e);
	          }
	        },
	        this.props.title
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.PureComponent);
	
	Button.defaultProps = {
	  ifHasBg: true,
	  disabled: false
	};
	exports.default = Button;

/***/ },
/* 214 */
[3167, 558, 362],
/* 215 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(361);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 217 */
55,
/* 218 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(390));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(218));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(174));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 220 */
124,
/* 221 */
124,
/* 222 */
124,
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 224 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBackgroundImage = exports.parseBackground = exports.calculateBackgroundRepeatPath = exports.calculateBackgroundPosition = exports.calculateBackgroungPositioningArea = exports.calculateBackgroungPaintingArea = exports.calculateGradientBackgroundSize = exports.calculateBackgroundSize = exports.BACKGROUND_ORIGIN = exports.BACKGROUND_CLIP = exports.BACKGROUND_SIZE = exports.BACKGROUND_REPEAT = undefined;
	
	var _Color = __webpack_require__(125);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Length = __webpack_require__(143);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	var _Size = __webpack_require__(1482);
	
	var _Size2 = _interopRequireDefault(_Size);
	
	var _Vector = __webpack_require__(276);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _Bounds = __webpack_require__(142);
	
	var _padding = __webpack_require__(612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BACKGROUND_REPEAT = exports.BACKGROUND_REPEAT = {
	    REPEAT: 0,
	    NO_REPEAT: 1,
	    REPEAT_X: 2,
	    REPEAT_Y: 3
	};
	
	var BACKGROUND_SIZE = exports.BACKGROUND_SIZE = {
	    AUTO: 0,
	    CONTAIN: 1,
	    COVER: 2,
	    LENGTH: 3
	};
	
	var BACKGROUND_CLIP = exports.BACKGROUND_CLIP = {
	    BORDER_BOX: 0,
	    PADDING_BOX: 1,
	    CONTENT_BOX: 2
	};
	
	var BACKGROUND_ORIGIN = exports.BACKGROUND_ORIGIN = BACKGROUND_CLIP;
	
	var AUTO = 'auto';
	
	var BackgroundSize = function BackgroundSize(size) {
	    _classCallCheck(this, BackgroundSize);
	
	    switch (size) {
	        case 'contain':
	            this.size = BACKGROUND_SIZE.CONTAIN;
	            break;
	        case 'cover':
	            this.size = BACKGROUND_SIZE.COVER;
	            break;
	        case 'auto':
	            this.size = BACKGROUND_SIZE.AUTO;
	            break;
	        default:
	            this.value = new _Length2.default(size);
	    }
	};
	
	var calculateBackgroundSize = exports.calculateBackgroundSize = function calculateBackgroundSize(backgroundImage, image, bounds) {
	    var width = 0;
	    var height = 0;
	    var size = backgroundImage.size;
	    if (size[0].size === BACKGROUND_SIZE.CONTAIN || size[0].size === BACKGROUND_SIZE.COVER) {
	        var targetRatio = bounds.width / bounds.height;
	        var currentRatio = image.width / image.height;
	        return targetRatio < currentRatio !== (size[0].size === BACKGROUND_SIZE.COVER) ? new _Size2.default(bounds.width, bounds.width / currentRatio) : new _Size2.default(bounds.height * currentRatio, bounds.height);
	    }
	
	    if (size[0].value) {
	        width = size[0].value.getAbsoluteValue(bounds.width);
	    }
	
	    if (size[0].size === BACKGROUND_SIZE.AUTO && size[1].size === BACKGROUND_SIZE.AUTO) {
	        height = image.height;
	    } else if (size[1].size === BACKGROUND_SIZE.AUTO) {
	        height = width / image.width * image.height;
	    } else if (size[1].value) {
	        height = size[1].value.getAbsoluteValue(bounds.height);
	    }
	
	    if (size[0].size === BACKGROUND_SIZE.AUTO) {
	        width = height / image.height * image.width;
	    }
	
	    return new _Size2.default(width, height);
	};
	
	var calculateGradientBackgroundSize = exports.calculateGradientBackgroundSize = function calculateGradientBackgroundSize(backgroundImage, bounds) {
	    var size = backgroundImage.size;
	    var width = size[0].value ? size[0].value.getAbsoluteValue(bounds.width) : bounds.width;
	    var height = size[1].value ? size[1].value.getAbsoluteValue(bounds.height) : size[0].value ? width : bounds.height;
	
	    return new _Size2.default(width, height);
	};
	
	var AUTO_SIZE = new BackgroundSize(AUTO);
	
	var calculateBackgroungPaintingArea = exports.calculateBackgroungPaintingArea = function calculateBackgroungPaintingArea(curves, clip) {
	    switch (clip) {
	        case BACKGROUND_CLIP.BORDER_BOX:
	            return (0, _Bounds.calculateBorderBoxPath)(curves);
	        case BACKGROUND_CLIP.PADDING_BOX:
	        default:
	            return (0, _Bounds.calculatePaddingBoxPath)(curves);
	    }
	};
	
	var calculateBackgroungPositioningArea = exports.calculateBackgroungPositioningArea = function calculateBackgroungPositioningArea(backgroundOrigin, bounds, padding, border) {
	    var paddingBox = (0, _Bounds.calculatePaddingBox)(bounds, border);
	
	    switch (backgroundOrigin) {
	        case BACKGROUND_ORIGIN.BORDER_BOX:
	            return bounds;
	        case BACKGROUND_ORIGIN.CONTENT_BOX:
	            var paddingLeft = padding[_padding.PADDING_SIDES.LEFT].getAbsoluteValue(bounds.width);
	            var paddingRight = padding[_padding.PADDING_SIDES.RIGHT].getAbsoluteValue(bounds.width);
	            var paddingTop = padding[_padding.PADDING_SIDES.TOP].getAbsoluteValue(bounds.width);
	            var paddingBottom = padding[_padding.PADDING_SIDES.BOTTOM].getAbsoluteValue(bounds.width);
	            return new _Bounds.Bounds(paddingBox.left + paddingLeft, paddingBox.top + paddingTop, paddingBox.width - paddingLeft - paddingRight, paddingBox.height - paddingTop - paddingBottom);
	        case BACKGROUND_ORIGIN.PADDING_BOX:
	        default:
	            return paddingBox;
	    }
	};
	
	var calculateBackgroundPosition = exports.calculateBackgroundPosition = function calculateBackgroundPosition(position, size, bounds) {
	    return new _Vector2.default(position[0].getAbsoluteValue(bounds.width - size.width), position[1].getAbsoluteValue(bounds.height - size.height));
	};
	
	var calculateBackgroundRepeatPath = exports.calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(background, position, size, backgroundPositioningArea, bounds) {
	    var repeat = background.repeat;
	    switch (repeat) {
	        case BACKGROUND_REPEAT.REPEAT_X:
	            return [new _Vector2.default(Math.round(bounds.left), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(size.height + backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left), Math.round(size.height + backgroundPositioningArea.top + position.y))];
	        case BACKGROUND_REPEAT.REPEAT_Y:
	            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.height + bounds.top))];
	        case BACKGROUND_REPEAT.NO_REPEAT:
	            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y + size.height)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y + size.height))];
	        default:
	            return [new _Vector2.default(Math.round(bounds.left), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(bounds.left), Math.round(bounds.height + bounds.top))];
	    }
	};
	
	var parseBackground = exports.parseBackground = function parseBackground(style, resourceLoader) {
	    return {
	        backgroundColor: new _Color2.default(style.backgroundColor),
	        backgroundImage: parseBackgroundImages(style, resourceLoader),
	        backgroundClip: parseBackgroundClip(style.backgroundClip),
	        backgroundOrigin: parseBackgroundOrigin(style.backgroundOrigin)
	    };
	};
	
	var parseBackgroundClip = function parseBackgroundClip(backgroundClip) {
	    switch (backgroundClip) {
	        case 'padding-box':
	            return BACKGROUND_CLIP.PADDING_BOX;
	        case 'content-box':
	            return BACKGROUND_CLIP.CONTENT_BOX;
	    }
	    return BACKGROUND_CLIP.BORDER_BOX;
	};
	
	var parseBackgroundOrigin = function parseBackgroundOrigin(backgroundOrigin) {
	    switch (backgroundOrigin) {
	        case 'padding-box':
	            return BACKGROUND_ORIGIN.PADDING_BOX;
	        case 'content-box':
	            return BACKGROUND_ORIGIN.CONTENT_BOX;
	    }
	    return BACKGROUND_ORIGIN.BORDER_BOX;
	};
	
	var parseBackgroundRepeat = function parseBackgroundRepeat(backgroundRepeat) {
	    switch (backgroundRepeat.trim()) {
	        case 'no-repeat':
	            return BACKGROUND_REPEAT.NO_REPEAT;
	        case 'repeat-x':
	        case 'repeat no-repeat':
	            return BACKGROUND_REPEAT.REPEAT_X;
	        case 'repeat-y':
	        case 'no-repeat repeat':
	            return BACKGROUND_REPEAT.REPEAT_Y;
	        case 'repeat':
	            return BACKGROUND_REPEAT.REPEAT;
	    }
	
	    if (false) {
	        console.error('Invalid background-repeat value "' + backgroundRepeat + '"');
	    }
	
	    return BACKGROUND_REPEAT.REPEAT;
	};
	
	var parseBackgroundImages = function parseBackgroundImages(style, resourceLoader) {
	    var sources = parseBackgroundImage(style.backgroundImage).map(function (backgroundImage) {
	        if (backgroundImage.method === 'url') {
	            var key = resourceLoader.loadImage(backgroundImage.args[0]);
	            backgroundImage.args = key ? [key] : [];
	        }
	        return backgroundImage;
	    });
	    var positions = style.backgroundPosition.split(',');
	    var repeats = style.backgroundRepeat.split(',');
	    var sizes = style.backgroundSize.split(',');
	
	    return sources.map(function (source, index) {
	        var size = (sizes[index] || AUTO).trim().split(' ').map(parseBackgroundSize);
	        var position = (positions[index] || AUTO).trim().split(' ').map(parseBackgoundPosition);
	
	        return {
	            source: source,
	            repeat: parseBackgroundRepeat(typeof repeats[index] === 'string' ? repeats[index] : repeats[0]),
	            size: size.length < 2 ? [size[0], AUTO_SIZE] : [size[0], size[1]],
	            position: position.length < 2 ? [position[0], position[0]] : [position[0], position[1]]
	        };
	    });
	};
	
	var parseBackgroundSize = function parseBackgroundSize(size) {
	    return size === 'auto' ? AUTO_SIZE : new BackgroundSize(size);
	};
	
	var parseBackgoundPosition = function parseBackgoundPosition(position) {
	    switch (position) {
	        case 'bottom':
	        case 'right':
	            return new _Length2.default('100%');
	        case 'left':
	        case 'top':
	            return new _Length2.default('0%');
	        case 'auto':
	            return new _Length2.default('0');
	    }
	    return new _Length2.default(position);
	};
	
	var parseBackgroundImage = exports.parseBackgroundImage = function parseBackgroundImage(image) {
	    var whitespace = /^\s$/;
	    var results = [];
	
	    var args = [];
	    var method = '';
	    var quote = null;
	    var definition = '';
	    var mode = 0;
	    var numParen = 0;
	
	    var appendResult = function appendResult() {
	        var prefix = '';
	        if (method) {
	            if (definition.substr(0, 1) === '"') {
	                definition = definition.substr(1, definition.length - 2);
	            }
	
	            if (definition) {
	                args.push(definition.trim());
	            }
	
	            var prefix_i = method.indexOf('-', 1) + 1;
	            if (method.substr(0, 1) === '-' && prefix_i > 0) {
	                prefix = method.substr(0, prefix_i).toLowerCase();
	                method = method.substr(prefix_i);
	            }
	            method = method.toLowerCase();
	            if (method !== 'none') {
	                results.push({
	                    prefix: prefix,
	                    method: method,
	                    args: args
	                });
	            }
	        }
	        args = [];
	        method = definition = '';
	    };
	
	    image.split('').forEach(function (c) {
	        if (mode === 0 && whitespace.test(c)) {
	            return;
	        }
	        switch (c) {
	            case '"':
	                if (!quote) {
	                    quote = c;
	                } else if (quote === c) {
	                    quote = null;
	                }
	                break;
	            case '(':
	                if (quote) {
	                    break;
	                } else if (mode === 0) {
	                    mode = 1;
	                    return;
	                } else {
	                    numParen++;
	                }
	                break;
	            case ')':
	                if (quote) {
	                    break;
	                } else if (mode === 1) {
	                    if (numParen === 0) {
	                        mode = 0;
	                        appendResult();
	                        return;
	                    } else {
	                        numParen--;
	                    }
	                }
	                break;
	
	            case ',':
	                if (quote) {
	                    break;
	                } else if (mode === 0) {
	                    appendResult();
	                    return;
	                } else if (mode === 1) {
	                    if (numParen === 0 && !method.match(/^url$/i)) {
	                        args.push(definition.trim());
	                        definition = '';
	                        return;
	                    }
	                }
	                break;
	        }
	
	        if (mode === 0) {
	            method += c;
	        } else {
	            definition += c;
	        }
	    });
	
	    appendResult();
	    return results;
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(647);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 227 */
[3195, 151, 659, 661],
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1522),
	    Map = __webpack_require__(401),
	    Promise = __webpack_require__(1524),
	    Set = __webpack_require__(625),
	    WeakMap = __webpack_require__(1525),
	    baseGetTag = __webpack_require__(105),
	    toSource = __webpack_require__(662);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 229 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 230 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1541),
	    isObjectLike = __webpack_require__(81);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(88),
	    stubFalse = __webpack_require__(1652);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)(module)))

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(287);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultUtils = undefined;
	exports.dateTimeFormat = dateTimeFormat;
	exports.getYear = getYear;
	exports.setYear = setYear;
	exports.addDays = addDays;
	exports.addMonths = addMonths;
	exports.addYears = addYears;
	exports.cloneDate = cloneDate;
	exports.cloneAsDate = cloneAsDate;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getWeekArray = getWeekArray;
	exports.localizedWeekday = localizedWeekday;
	exports.formatIso = formatIso;
	exports.isEqualDate = isEqualDate;
	exports.isBeforeDate = isBeforeDate;
	exports.isAfterDate = isAfterDate;
	exports.isBetweenDates = isBetweenDates;
	exports.monthDiff = monthDiff;
	exports.yearDiff = yearDiff;
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
	var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function dateTimeFormat(locale, options) {
	   false ? (0, _warning2.default)(locale === 'en-US', 'Material-UI: The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;
	
	  this.format = function (date) {
	    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
	      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
	    } else if (options.year === 'numeric' && options.month === 'numeric' && options.day === 'numeric') {
	      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
	    } else if (options.year === 'numeric' && options.month === 'long') {
	      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
	    } else if (options.weekday === 'narrow') {
	      return dayAbbreviation[date.getDay()];
	    } else if (options.year === 'numeric') {
	      return date.getFullYear().toString();
	    } else if (options.day === 'numeric') {
	      return date.getDate();
	    } else {
	       false ? (0, _warning2.default)(false, 'Material-UI: Wrong usage of DateTimeFormat') : void 0;
	    }
	  };
	}
	
	function getYear(d) {
	  return d.getFullYear();
	}
	
	function setYear(d, year) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(year);
	  return newDate;
	}
	
	function addDays(d, days) {
	  var newDate = cloneDate(d);
	  newDate.setDate(d.getDate() + days);
	  return newDate;
	}
	
	function addMonths(d, months) {
	  var newDate = cloneDate(d);
	  newDate.setMonth(d.getMonth() + months);
	  return newDate;
	}
	
	function addYears(d, years) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(d.getFullYear() + years);
	  return newDate;
	}
	
	function cloneDate(d) {
	  return new Date(d.getTime());
	}
	
	function cloneAsDate(d) {
	  var clonedDate = cloneDate(d);
	  clonedDate.setHours(0, 0, 0, 0);
	  return clonedDate;
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1);
	}
	
	function getFirstDayOfWeek() {
	  var now = new Date();
	  return new Date(now.setDate(now.getDate() - now.getDay()));
	}
	
	function getWeekArray(d, firstDayOfWeek) {
	  var dayArray = [];
	  var daysInMonth = getDaysInMonth(d);
	  var weekArray = [];
	  var week = [];
	
	  for (var i = 1; i <= daysInMonth; i++) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	  }
	
	  var addWeek = function addWeek(week) {
	    var emptyDays = 7 - week.length;
	    for (var _i = 0; _i < emptyDays; ++_i) {
	      week[weekArray.length ? 'push' : 'unshift'](null);
	    }
	    weekArray.push(week);
	  };
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      addWeek(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      addWeek(week);
	    }
	  });
	
	  return weekArray;
	}
	
	function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
	  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
	  var firstDayDate = getFirstDayOfWeek();
	
	  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
	}
	
	// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
	function formatIso(date) {
	  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
	}
	
	function isEqualDate(d1, d2) {
	  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	
	function isBeforeDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() < date2.getTime();
	}
	
	function isAfterDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() > date2.getTime();
	}
	
	function isBetweenDates(dateToCheck, startDate, endDate) {
	  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
	}
	
	function monthDiff(d1, d2) {
	  var m = void 0;
	  m = (d1.getFullYear() - d2.getFullYear()) * 12;
	  m += d1.getMonth();
	  m -= d2.getMonth();
	  return m;
	}
	
	function yearDiff(d1, d2) {
	  return ~~(monthDiff(d1, d2) / 12);
	}
	
	var defaultUtils = exports.defaultUtils = {
	  getYear: getYear,
	  setYear: setYear,
	  addDays: addDays,
	  addMonths: addMonths,
	  addYears: addYears,
	  getFirstDayOfMonth: getFirstDayOfMonth,
	  getWeekArray: getWeekArray,
	  monthDiff: monthDiff
	};

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(423);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;
	
	var _Table2 = __webpack_require__(1720);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(699);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(700);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(701);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(427);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(702);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(305);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.default = _Table3.default;

/***/ },
/* 237 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addHours = addHours;
	exports.addMinutes = addMinutes;
	exports.addSeconds = addSeconds;
	exports.formatTime = formatTime;
	exports.rad2deg = rad2deg;
	exports.getTouchEventOffsetValues = getTouchEventOffsetValues;
	exports.isInner = isInner;
	function addHours(d, hours) {
	  var newDate = clone(d);
	  newDate.setHours(d.getHours() + hours);
	  return newDate;
	}
	
	function addMinutes(d, minutes) {
	  var newDate = clone(d);
	  newDate.setMinutes(d.getMinutes() + minutes);
	  return newDate;
	}
	
	function addSeconds(d, seconds) {
	  var newDate = clone(d);
	  newDate.setSeconds(d.getMinutes() + seconds);
	  return newDate;
	}
	
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * @param date [Date] A Date object.
	 * @param format [String] One of 'ampm', '24hr', defaults to 'ampm'.
	 * @param pedantic [Boolean] Check time-picker/time-picker.jsx file.
	 *
	 * @return String A string representing the formatted time.
	 */
	function formatTime(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ampm';
	  var pedantic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!date) return '';
	  var hours = date.getHours();
	  var mins = date.getMinutes().toString();
	
	  if (format === 'ampm') {
	    var isAM = hours < 12;
	    hours = hours % 12;
	    var additional = isAM ? ' am' : ' pm';
	    hours = (hours || 12).toString();
	
	    if (mins.length < 2) mins = '0' + mins;
	
	    if (pedantic) {
	      // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	      if (hours === '12' && mins === '00') {
	        return additional === ' pm' ? '12 noon' : '12 midnight';
	      }
	    }
	
	    return hours + (mins === '00' ? '' : ':' + mins) + additional;
	  }
	
	  hours = hours.toString();
	
	  if (hours.length < 2) hours = '0' + hours;
	  if (mins.length < 2) mins = '0' + mins;
	
	  return hours + ':' + mins;
	}
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(event) {
	  var el = event.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  return {
	    offsetX: event.clientX - boundingRect.left,
	    offsetY: event.clientY - boundingRect.top
	  };
	}
	
	function isInner(props) {
	  if (props.type !== 'hour') {
	    return false;
	  }
	  return props.value < 1 || props.value > 12;
	}

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(862);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toArray;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArray(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (c) {
	    ret.push(c);
	  });
	  return ret;
	}
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(4)):"function"==typeof define&&define.amd?define(["react","prop-types"],t):"object"==typeof exports?exports.Dropzone=t(require("react"),require("prop-types")):e.Dropzone=t(e.React,e.PropTypes)}(this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function c(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),d=n(2),v=r(d),h=n(3),g=n(5),y=r(g),m=function(e){function t(e,n){a(this,t);var r=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,n));return r.renderChildren=function(e,t,n,o){return"function"==typeof e?e(s({},r.state,{isDragActive:t,isDragAccept:n,isDragReject:o})):e},r.composeHandlers=r.composeHandlers.bind(r),r.onClick=r.onClick.bind(r),r.onDocumentDrop=r.onDocumentDrop.bind(r),r.onDragEnter=r.onDragEnter.bind(r),r.onDragLeave=r.onDragLeave.bind(r),r.onDragOver=r.onDragOver.bind(r),r.onDragStart=r.onDragStart.bind(r),r.onDrop=r.onDrop.bind(r),r.onFileDialogCancel=r.onFileDialogCancel.bind(r),r.onInputElementClick=r.onInputElementClick.bind(r),r.setRef=r.setRef.bind(r),r.setRefs=r.setRefs.bind(r),r.isFileDialogActive=!1,r.state={draggedFiles:[],acceptedFiles:[],rejectedFiles:[]},r}return c(t,e),l(t,[{key:"componentDidMount",value:function(){var e=this.props.preventDropOnDocument;this.dragTargets=[],e&&(document.addEventListener("dragover",h.onDocumentDragOver,!1),document.addEventListener("drop",this.onDocumentDrop,!1)),this.fileInputEl.addEventListener("click",this.onInputElementClick,!1),window.addEventListener("focus",this.onFileDialogCancel,!1)}},{key:"componentWillUnmount",value:function(){this.props.preventDropOnDocument&&(document.removeEventListener("dragover",h.onDocumentDragOver),document.removeEventListener("drop",this.onDocumentDrop)),null!=this.fileInputEl&&this.fileInputEl.removeEventListener("click",this.onInputElementClick,!1),window.removeEventListener("focus",this.onFileDialogCancel,!1)}},{key:"composeHandlers",value:function(e){return this.props.disabled?null:e}},{key:"onDocumentDrop",value:function(e){this.node&&this.node.contains(e.target)||(e.preventDefault(),this.dragTargets=[])}},{key:"onDragStart",value:function(e){this.props.onDragStart&&this.props.onDragStart.call(this,e)}},{key:"onDragEnter",value:function(e){var t=this;e.preventDefault(),-1===this.dragTargets.indexOf(e.target)&&this.dragTargets.push(e.target),Promise.resolve(this.props.getDataTransferItems(e)).then(function(e){t.setState({isDragActive:!0,draggedFiles:e})}),this.props.onDragEnter&&this.props.onDragEnter.call(this,e)}},{key:"onDragOver",value:function(e){e.preventDefault(),e.stopPropagation();try{e.dataTransfer.dropEffect=this.isFileDialogActive?"none":"copy"}catch(e){}return this.props.onDragOver&&this.props.onDragOver.call(this,e),!1}},{key:"onDragLeave",value:function(e){var t=this;e.preventDefault(),this.dragTargets=this.dragTargets.filter(function(n){return n!==e.target&&t.node.contains(n)}),this.dragTargets.length>0||(this.setState({isDragActive:!1,draggedFiles:[]}),this.props.onDragLeave&&this.props.onDragLeave.call(this,e))}},{key:"onDrop",value:function(e){var t=this,n=this.props,r=n.onDrop,o=n.onDropAccepted,a=n.onDropRejected,u=n.multiple,c=n.disablePreview,s=n.accept,l=n.getDataTransferItems;e.preventDefault(),this.dragTargets=[],this.isFileDialogActive=!1,this.draggedFiles=null,this.setState({isDragActive:!1,draggedFiles:[]}),Promise.resolve(l(e)).then(function(n){var l=[],f=[];n.forEach(function(e){if(!c)try{e.preview=window.URL.createObjectURL(e)}catch(e){}(0,h.fileAccepted)(e,s)&&(0,h.fileMatchSize)(e,t.props.maxSize,t.props.minSize)?l.push(e):f.push(e)}),u||f.push.apply(f,i(l.splice(1))),r&&r.call(t,l,f,e),f.length>0&&a&&a.call(t,f,e),l.length>0&&o&&o.call(t,l,e)})}},{key:"onClick",value:function(e){var t=this.props,n=t.onClick;t.disableClick||(e.stopPropagation(),n&&n.call(this,e),(0,h.isIeOrEdge)()?setTimeout(this.open.bind(this),0):this.open())}},{key:"onInputElementClick",value:function(e){e.stopPropagation(),this.props.inputProps&&this.props.inputProps.onClick&&this.props.inputProps.onClick()}},{key:"onFileDialogCancel",value:function(){var e=this,t=this.props.onFileDialogCancel;this.isFileDialogActive&&setTimeout(function(){if(null!=e.fileInputEl){e.fileInputEl.files.length||(e.isFileDialogActive=!1)}"function"==typeof t&&t()},300)}},{key:"setRef",value:function(e){this.node=e}},{key:"setRefs",value:function(e){this.fileInputEl=e}},{key:"open",value:function(){this.isFileDialogActive=!0,this.fileInputEl.value=null,this.fileInputEl.click()}},{key:"render",value:function(){var e=this.props,t=e.accept,n=e.acceptClassName,r=e.activeClassName,i=e.children,a=e.disabled,u=e.disabledClassName,c=e.inputProps,l=e.multiple,f=e.name,d=e.rejectClassName,v=o(e,["accept","acceptClassName","activeClassName","children","disabled","disabledClassName","inputProps","multiple","name","rejectClassName"]),g=v.acceptStyle,m=v.activeStyle,b=v.className,D=void 0===b?"":b,x=v.disabledStyle,O=v.rejectStyle,S=v.style,C=o(v,["acceptStyle","activeStyle","className","disabledStyle","rejectStyle","style"]),j=this.state,E=j.isDragActive,w=j.draggedFiles,_=w.length,k=l||_<=1,P=_>0&&(0,h.allFilesAccepted)(w,this.props.accept),A=_>0&&(!P||!k),F=!(D||S||m||g||O||x);E&&r&&(D+=" "+r),P&&n&&(D+=" "+n),A&&d&&(D+=" "+d),a&&u&&(D+=" "+u),F&&(S=y.default.default,m=y.default.active,g=y.default.active,O=y.default.rejected,x=y.default.disabled);var T=s({position:"relative"},S);m&&E&&(T=s({},T,m)),g&&P&&(T=s({},T,g)),O&&A&&(T=s({},T,O)),x&&a&&(T=s({},T,x));var I={accept:t,disabled:a,type:"file",style:s({position:"absolute",top:0,right:0,bottom:0,left:0,opacity:1e-5,pointerEvents:"none"},c.style),multiple:h.supportMultiple&&l,ref:this.setRefs,onChange:this.onDrop,autoComplete:"off"};f&&f.length&&(I.name=f);var M=(C.acceptedFiles,C.preventDropOnDocument,C.disablePreview,C.disableClick,C.onDropAccepted,C.onDropRejected,C.onFileDialogCancel,C.maxSize,C.minSize,C.getDataTransferItems,o(C,["acceptedFiles","preventDropOnDocument","disablePreview","disableClick","onDropAccepted","onDropRejected","onFileDialogCancel","maxSize","minSize","getDataTransferItems"]));return p.default.createElement("div",s({className:D,style:T},M,{onClick:this.composeHandlers(this.onClick),onDragStart:this.composeHandlers(this.onDragStart),onDragEnter:this.composeHandlers(this.onDragEnter),onDragOver:this.composeHandlers(this.onDragOver),onDragLeave:this.composeHandlers(this.onDragLeave),onDrop:this.composeHandlers(this.onDrop),ref:this.setRef,"aria-disabled":a}),this.renderChildren(i,E,P,A),p.default.createElement("input",s({},c,I)))}}]),t}(p.default.Component);t.default=m,m.propTypes={accept:v.default.oneOfType([v.default.string,v.default.arrayOf(v.default.string)]),children:v.default.oneOfType([v.default.node,v.default.func]),disableClick:v.default.bool,disabled:v.default.bool,disablePreview:v.default.bool,preventDropOnDocument:v.default.bool,inputProps:v.default.object,multiple:v.default.bool,name:v.default.string,maxSize:v.default.number,minSize:v.default.number,className:v.default.string,activeClassName:v.default.string,acceptClassName:v.default.string,rejectClassName:v.default.string,disabledClassName:v.default.string,style:v.default.object,activeStyle:v.default.object,acceptStyle:v.default.object,rejectStyle:v.default.object,disabledStyle:v.default.object,getDataTransferItems:v.default.func,onClick:v.default.func,onDrop:v.default.func,onDropAccepted:v.default.func,onDropRejected:v.default.func,onDragStart:v.default.func,onDragEnter:v.default.func,onDragOver:v.default.func,onDragLeave:v.default.func,onFileDialogCancel:v.default.func},m.defaultProps={preventDropOnDocument:!0,disabled:!1,disablePreview:!1,disableClick:!1,inputProps:{},multiple:!0,maxSize:1/0,minSize:0,getDataTransferItems:h.getDataTransferItems},e.exports=t.default},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t,n){"use strict";function r(e){var t=[];if(e.dataTransfer){var n=e.dataTransfer;n.files&&n.files.length?t=n.files:n.items&&n.items.length&&(t=n.items)}else e.target&&e.target.files&&(t=e.target.files);return Array.prototype.slice.call(t)}function o(e,t){return"application/x-moz-file"===e.type||(0,p.default)(e,t)}function i(e,t,n){return e.size<=t&&e.size>=n}function a(e,t){return e.every(function(e){return o(e,t)})}function u(e){e.preventDefault()}function c(e){return-1!==e.indexOf("MSIE")||-1!==e.indexOf("Trident/")}function s(e){return-1!==e.indexOf("Edge/")}function l(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.navigator.userAgent;return c(e)||s(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.supportMultiple=void 0,t.getDataTransferItems=r,t.fileAccepted=o,t.fileMatchSize=i,t.allFilesAccepted=a,t.onDocumentDragOver=u,t.isIeOrEdge=l;var f=n(4),p=function(e){return e&&e.__esModule?e:{default:e}}(f);t.supportMultiple="undefined"==typeof document||!document||!document.createElement||"multiple"in document.createElement("input")},function(e,t){e.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=13)}([function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){var n=e.exports={version:"2.5.0"};"number"==typeof __e&&(__e=n)},function(e,t,n){e.exports=!n(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(32)("wks"),o=n(9),i=n(0).Symbol,a="function"==typeof i;(e.exports=function(e){return r[e]||(r[e]=a&&i[e]||(a?i:o)("Symbol."+e))}).store=r},function(e,t,n){var r=n(0),o=n(2),i=n(8),a=n(22),u=n(10),c=function(e,t,n){var s,l,f,p,d=e&c.F,v=e&c.G,h=e&c.S,g=e&c.P,y=e&c.B,m=v?r:h?r[t]||(r[t]={}):(r[t]||{}).prototype,b=v?o:o[t]||(o[t]={}),D=b.prototype||(b.prototype={});v&&(n=t);for(s in n)l=!d&&m&&void 0!==m[s],f=(l?m:n)[s],p=y&&l?u(f,r):g&&"function"==typeof f?u(Function.call,f):f,m&&a(m,s,f,e&c.U),b[s]!=f&&i(b,s,p),g&&D[s]!=f&&(D[s]=f)};r.core=o,c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,e.exports=c},function(e,t,n){var r=n(16),o=n(21);e.exports=n(3)?function(e,t,n){return r.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t,n){var r=n(24);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,o){return e.call(t,n,r,o)}}return function(){return e.apply(t,arguments)}}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t,n){var r=n(28),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0}},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){if(e&&t){var n=Array.isArray(t)?t:t.split(","),r=e.name||"",o=e.type||"",i=o.replace(/\/.*$/,"");return n.some(function(e){var t=e.trim();return"."===t.charAt(0)?r.toLowerCase().endsWith(t.toLowerCase()):t.endsWith("/*")?i===t.replace(/\/.*$/,""):o===t})}return!0},n(14),n(34)},function(e,t,n){n(15),e.exports=n(2).Array.some},function(e,t,n){"use strict";var r=n(7),o=n(25)(3);r(r.P+r.F*!n(33)([].some,!0),"Array",{some:function(e){return o(this,e,arguments[1])}})},function(e,t,n){var r=n(17),o=n(18),i=n(20),a=Object.defineProperty;t.f=n(3)?Object.defineProperty:function(e,t,n){if(r(e),t=i(t,!0),r(n),o)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){var r=n(1);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t,n){e.exports=!n(3)&&!n(4)(function(){return 7!=Object.defineProperty(n(19)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(1),o=n(0).document,i=r(o)&&r(o.createElement);e.exports=function(e){return i?o.createElement(e):{}}},function(e,t,n){var r=n(1);e.exports=function(e,t){if(!r(e))return e;var n,o;if(t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;if("function"==typeof(n=e.valueOf)&&!r(o=n.call(e)))return o;if(!t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;throw TypeError("Can't convert object to primitive value")}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,n){var r=n(0),o=n(8),i=n(23),a=n(9)("src"),u=Function.toString,c=(""+u).split("toString");n(2).inspectSource=function(e){return u.call(e)},(e.exports=function(e,t,n,u){var s="function"==typeof n;s&&(i(n,"name")||o(n,"name",t)),e[t]!==n&&(s&&(i(n,a)||o(n,a,e[t]?""+e[t]:c.join(String(t)))),e===r?e[t]=n:u?e[t]?e[t]=n:o(e,t,n):(delete e[t],o(e,t,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[a]||u.call(this)})},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){var r=n(10),o=n(26),i=n(27),a=n(12),u=n(29);e.exports=function(e,t){var n=1==e,c=2==e,s=3==e,l=4==e,f=6==e,p=5==e||f,d=t||u;return function(t,u,v){for(var h,g,y=i(t),m=o(y),b=r(u,v,3),D=a(m.length),x=0,O=n?d(t,D):c?d(t,0):void 0;D>x;x++)if((p||x in m)&&(h=m[x],g=b(h,x,y),e))if(n)O[x]=g;else if(g)switch(e){case 3:return!0;case 5:return h;case 6:return x;case 2:O.push(h)}else if(l)return!1;return f?-1:s||l?l:O}}},function(e,t,n){var r=n(5);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(11);e.exports=function(e){return Object(r(e))}},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t,n){var r=n(30);e.exports=function(e,t){return new(r(e))(t)}},function(e,t,n){var r=n(1),o=n(31),i=n(6)("species");e.exports=function(e){var t;return o(e)&&(t=e.constructor,"function"!=typeof t||t!==Array&&!o(t.prototype)||(t=void 0),r(t)&&null===(t=t[i])&&(t=void 0)),void 0===t?Array:t}},function(e,t,n){var r=n(5);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});e.exports=function(e){return o[e]||(o[e]={})}},function(e,t,n){"use strict";var r=n(4);e.exports=function(e,t){return!!e&&r(function(){t?e.call(null,function(){},1):e.call(null)})}},function(e,t,n){n(35),e.exports=n(2).String.endsWith},function(e,t,n){"use strict";var r=n(7),o=n(12),i=n(36),a="".endsWith;r(r.P+r.F*n(38)("endsWith"),"String",{endsWith:function(e){var t=i(this,e,"endsWith"),n=arguments.length>1?arguments[1]:void 0,r=o(t.length),u=void 0===n?r:Math.min(o(n),r),c=String(e);return a?a.call(t,c,u):t.slice(u-c.length,u)===c}})},function(e,t,n){var r=n(37),o=n(11);e.exports=function(e,t,n){if(r(t))throw TypeError("String#"+n+" doesn't accept regex!");return String(o(e))}},function(e,t,n){var r=n(1),o=n(5),i=n(6)("match");e.exports=function(e){var t;return r(e)&&(void 0!==(t=e[i])?!!t:"RegExp"==o(e))}},function(e,t,n){var r=n(6)("match");e.exports=function(e){var t=/./;try{"/./"[e](t)}catch(n){try{return t[r]=!1,!"/./"[e](t)}catch(e){}}return!0}}])},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={rejected:{borderStyle:"solid",borderColor:"#c66",backgroundColor:"#eee"},disabled:{opacity:.5},active:{borderStyle:"solid",borderColor:"#6c6",backgroundColor:"#eee"},default:{width:200,height:200,borderWidth:2,borderColor:"#666",borderStyle:"dashed",borderRadius:5}},e.exports=t.default}])});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withGoogleMap = __webpack_require__(2846);
	
	Object.defineProperty(exports, "withGoogleMap", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withGoogleMap).default;
	  }
	});
	
	var _GoogleMap = __webpack_require__(2835);
	
	Object.defineProperty(exports, "GoogleMap", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GoogleMap).default;
	  }
	});
	
	var _Marker = __webpack_require__(2838);
	
	Object.defineProperty(exports, "Marker", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Marker).default;
	  }
	});
	
	var _Rectangle = __webpack_require__(2842);
	
	Object.defineProperty(exports, "Rectangle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rectangle).default;
	  }
	});
	
	var _Polyline = __webpack_require__(2841);
	
	Object.defineProperty(exports, "Polyline", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Polyline).default;
	  }
	});
	
	var _Polygon = __webpack_require__(2840);
	
	Object.defineProperty(exports, "Polygon", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Polygon).default;
	  }
	});
	
	var _Circle = __webpack_require__(2832);
	
	Object.defineProperty(exports, "Circle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _KmlLayer = __webpack_require__(2837);
	
	Object.defineProperty(exports, "KmlLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KmlLayer).default;
	  }
	});
	
	var _FusionTablesLayer = __webpack_require__(2834);
	
	Object.defineProperty(exports, "FusionTablesLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FusionTablesLayer).default;
	  }
	});
	
	var _TrafficLayer = __webpack_require__(2844);
	
	Object.defineProperty(exports, "TrafficLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TrafficLayer).default;
	  }
	});
	
	var _DirectionsRenderer = __webpack_require__(2833);
	
	Object.defineProperty(exports, "DirectionsRenderer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DirectionsRenderer).default;
	  }
	});
	
	var _InfoWindow = __webpack_require__(2836);
	
	Object.defineProperty(exports, "InfoWindow", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InfoWindow).default;
	  }
	});
	
	var _OverlayView = __webpack_require__(2839);
	
	Object.defineProperty(exports, "OverlayView", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OverlayView).default;
	  }
	});
	
	var _StreetViewPanorama = __webpack_require__(2843);
	
	Object.defineProperty(exports, "StreetViewPanorama", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StreetViewPanorama).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 244 */
151,
/* 245 */
[3233, 331, 472],
/* 246 */
81,
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(1249);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(3044);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 249 */
35,
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _ReactUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ErrorBar =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorBar).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: "renderErrorBars",
	    value: function renderErrorBars() {
	      var _this$props = this.props,
	          offset = _this$props.offset,
	          layout = _this$props.layout,
	          width = _this$props.width,
	          dataKey = _this$props.dataKey,
	          data = _this$props.data,
	          dataPointFormatter = _this$props.dataPointFormatter,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis,
	          others = _objectWithoutProperties(_this$props, ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"]);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid, yMid, xMin, yMin, xMax, yMax, scale, coordsTop, coordsMid, coordsBot, lowBound, highBound;
	
	        if (Array.isArray(errorVal)) {
	          var _errorVal = _slicedToArray(errorVal, 2);
	
	          lowBound = _errorVal[0];
	          highBound = _errorVal[1];
	        } else {
	          lowBound = highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = {
	            x1: xMax,
	            y1: yMin,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMin,
	            y1: yMid,
	            x2: xMax,
	            y2: yMid
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMin,
	            y2: yMax
	          };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = {
	            x1: xMin,
	            y1: yMax,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMid,
	            y1: yMin,
	            x2: xMid,
	            y2: yMax
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMax,
	            y2: yMin
	          };
	        }
	
	        return _react.default.createElement(_Layer.default, _extends({
	          className: "recharts-errorBar",
	          key: "bar-".concat(i)
	        }, props), _react.default.createElement("line", coordsTop), _react.default.createElement("line", coordsMid), _react.default.createElement("line", coordsBot));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-errorBars"
	      }, this.renderErrorBars());
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component);
	
	ErrorBar.propTypes = {
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]).isRequired,
	  data: _propTypes.default.array,
	  xAxis: _propTypes.default.object,
	  yAxis: _propTypes.default.object,
	  layout: _propTypes.default.string,
	  dataPointFormatter: _propTypes.default.func,
	  stroke: _propTypes.default.string,
	  strokeWidth: _propTypes.default.number,
	  width: _propTypes.default.number,
	  offset: _propTypes.default.number
	};
	ErrorBar.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	};
	var _default = ErrorBar;
	exports.default = _default;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _ReactUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  width: _propTypes.default.number.isRequired,
	  height: _propTypes.default.number.isRequired,
	  viewBox: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  }),
	  className: _propTypes.default.string,
	  style: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
	};
	
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ["children", "width", "height", "viewBox", "className", "style"]);
	
	  var svgView = viewBox || {
	    width: width,
	    height: height,
	    x: 0,
	    y: 0
	  };
	  var layerClass = (0, _classnames.default)('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	  return _react.default.createElement("svg", _extends({}, attrs, {
	    className: layerClass,
	    width: width,
	    height: height,
	    style: style,
	    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
	    version: "1.1"
	  }), children);
	}
	
	Surface.propTypes = propTypes;
	var _default = Surface;
	exports.default = _default;

/***/ },
/* 252 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(493);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(116)
	  , core      = __webpack_require__(131)
	  , ctx       = __webpack_require__(253)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ },
/* 255 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _lodash = __webpack_require__(18);
	
	var _recharts = __webpack_require__(101);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineGraphicSection = function (_AcquireWebComponent) {
		_inherits(LineGraphicSection, _AcquireWebComponent);
	
		function LineGraphicSection(props) {
			_classCallCheck(this, LineGraphicSection);
	
			var _this = _possibleConstructorReturn(this, (LineGraphicSection.__proto__ || Object.getPrototypeOf(LineGraphicSection)).call(this, props));
	
			_this.state = {
				active: ""
			};
			return _this;
		}
	
		_createClass(LineGraphicSection, [{
			key: 'render',
			value: function render() {
				var COLORS = ['#050505', '#1C4456', '#3888AB', '#87B7CD', '#AFCFDD'];
				var numberFormater = function numberFormater(num) {
					return (0, _utility.splitNumber)(num + '')();
				};
				// const CustomizedLabel = React.createClass({
				// 	render() {
				// 		const { x, y, stroke, value } = this.props;
				// 		return <text x={x} y={y} dy={-4} fill={stroke} fontSize={12} textAnchor="middle">
				// 			{splitNumber(value + '')()}</text>
				// 	}
				// });
	
				var CustomizedTooltip = _react2.default.createClass({
					displayName: 'CustomizedTooltip',
					render: function render() {
						var active = this.props.active;
	
						if (active) {
							var _props = this.props,
							    payload = _props.payload,
							    label = _props.label,
							    formatter = _props.formatter;
	
							return _react2.default.createElement(
								'div',
								{ className: 'recharts-default-tootip no-margin p-10', style: { background: '#FFFCDC', border: "solid 1px #ccc" } },
								_react2.default.createElement(
									'p',
									{ className: 'recharts-tooltip-label no-margin' },
									label
								),
								_react2.default.createElement(
									'ul',
									{ className: 'recharts-tooltip-item-list no-padding no-margin' },
									_react2.default.createElement(
										'li',
										{ className: 'recharts-tooltip-item',
											style: { display: "block", paddingTop: "4px", paddingBottom: "4px", color: payload ? payload[0].stroke : "#FFF" } },
										_react2.default.createElement(
											'span',
											{ className: 'recharts-tooltip-item-name' },
											payload && payload[0] ? payload[0].name : ""
										),
										_react2.default.createElement(
											'span',
											{ className: 'recharts-tooltip-item-separator' },
											' : '
										),
										_react2.default.createElement(
											'span',
											{ className: 'recharts-tooltip-item-value' },
											payload && payload[0] ? formatter(payload[0].value) : ""
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'recharts-tooltip-item',
											style: { display: "block", paddingTop: "4px", paddingBottom: "4px", color: payload[1].stroke } },
										_react2.default.createElement(
											'span',
											{ className: 'recharts-tooltip-item-name' },
											payload[1].name
										),
										_react2.default.createElement(
											'span',
											{ className: 'recharts-tooltip-item-separator' },
											' : '
										),
										_react2.default.createElement(
											'span',
											{ className: 'recharts-tooltip-item-value' },
											payload && payload.length > 1 ? formatter(payload[1].value) : ""
										)
									),
									payload.length > 2 && _react2.default.createElement(
										'li',
										{ className: 'recharts-tooltip-item',
											style: { display: "block", paddingTop: "4px", paddingBottom: "4px", color: payload[2].stroke } },
										_react2.default.createElement(
											'span',
											{ className: 'recharts-tooltip-item-name' },
											payload[2].name
										),
										_react2.default.createElement(
											'span',
											{ className: 'recharts-tooltip-item-separator' },
											' : '
										),
										_react2.default.createElement(
											'span',
											{ className: 'recharts-tooltip-item-value' },
											payload && payload.length > 2 ? formatter(payload[2].value) : ""
										)
									)
								)
							);
						}
	
						return null;
					}
				});
	
				var _props2 = this.props,
				    title = _props2.title,
				    data = _props2.data,
				    subTitle = _props2.subTitle,
				    dataNames = _props2.dataNames,
				    dataKeys = _props2.dataKeys;
	
				if ((0, _lodash.isEmpty)(data)) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '16px', lineHeight: '18px', marginBottom: '20px', fontWeight: 'bold' } },
							title
						),
						_react2.default.createElement(
							'div',
							{ style: { width: '100%', minHeight: '200px', textAlign: 'center', paddingTop: '60px', color: "#CDCDCD" } },
							_react2.default.createElement(
								'div',
								{ style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
								'No Data'
							)
						)
					);
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ style: { fontSize: '16px', lineHeight: '18px', marginBottom: '20px', fontWeight: 'bold' } },
						title
					),
					_react2.default.createElement(
						_recharts.ResponsiveContainer,
						{ width: '100%', height: '80%', minHeight: 200 },
						dataKeys.length === 2 ? _react2.default.createElement(
							_recharts.LineChart,
							{ data: data,
								margin: { top: 5, right: 0, left: 0, bottom: 5 } },
							_react2.default.createElement(_recharts.XAxis, { dataKey: 'time', padding: { left: 30, right: 30 } }),
							_react2.default.createElement(_recharts.YAxis, { yAxisId: 'left', label: { value: dataNames[0], style: { textAnchor: 'end' }, angle: -90, offset: 0, position: 'insideTopLeft' } }),
							_react2.default.createElement(_recharts.YAxis, { yAxisId: 'right', label: { value: dataNames[1], style: { textAnchor: 'start' }, angle: 90, offset: 0, position: 'insideTopRight' }, orientation: 'right' }),
							_react2.default.createElement(_recharts.CartesianGrid, { strokeDasharray: '3 3', vertical: false }),
							_react2.default.createElement(_recharts.Tooltip, { formatter: numberFormater, content: _react2.default.createElement(CustomizedTooltip, null) }),
							_react2.default.createElement(_recharts.Legend, { layout: 'horizontal', verticalAlign: 'top', align: 'center' }),
							_react2.default.createElement(_recharts.Line, { yAxisId: 'left', isAnimationActive: this.props.animation, name: dataNames[0], type: 'monotone', dataKey: dataKeys[0], strokeWidth: 2, stroke: dataKeys.length > 2 ? COLORS[0] : COLORS[1], activeDot: { r: 6 } }),
							_react2.default.createElement(_recharts.Line, { yAxisId: 'right', isAnimationActive: this.props.animation, name: dataNames[1], type: 'monotone', dataKey: dataKeys[1], strokeWidth: 2, stroke: dataKeys.length > 2 ? COLORS[1] : COLORS[2], activeDot: { r: 5 } })
						) : _react2.default.createElement(
							_recharts.LineChart,
							{ data: data,
								margin: { top: 5, right: 0, left: 0, bottom: 5 } },
							_react2.default.createElement(_recharts.XAxis, { dataKey: 'time', padding: { left: 30, right: 30 } }),
							_react2.default.createElement(_recharts.YAxis, null),
							_react2.default.createElement(_recharts.CartesianGrid, { strokeDasharray: '3 3', vertical: false }),
							_react2.default.createElement(_recharts.Tooltip, { formatter: numberFormater, content: _react2.default.createElement(CustomizedTooltip, null) }),
							_react2.default.createElement(_recharts.Legend, { layout: 'vertical', verticalAlign: 'top', align: 'right' }),
							_react2.default.createElement(_recharts.Line, { isAnimationActive: this.props.animation, name: dataNames[0], type: 'monotone', dataKey: dataKeys[0], strokeWidth: 2, stroke: dataKeys.length > 2 ? COLORS[0] : COLORS[1], activeDot: { r: 6 } }),
							_react2.default.createElement(_recharts.Line, { isAnimationActive: this.props.animation, name: dataNames[1], type: 'monotone', dataKey: dataKeys[1], strokeWidth: 2, stroke: dataKeys.length > 2 ? COLORS[1] : COLORS[2], activeDot: { r: 5 } }),
							dataKeys.length > 2 && _react2.default.createElement(_recharts.Line, { isAnimationActive: this.props.animation, name: dataNames[2], type: 'monotone', dataKey: dataKeys[2], strokeWidth: 2, stroke: COLORS[2], activeDot: { r: 4 } })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'text-center' },
						_react2.default.createElement(
							'strong',
							null,
							subTitle
						),
						' ',
						_react2.default.createElement(
							'span',
							null,
							this.props.subTitleText
						)
					)
				);
			}
		}]);
	
		return LineGraphicSection;
	}(_MaterialUI2.default);
	
	LineGraphicSection.propTypes = {
		title: _react2.default.PropTypes.string.isRequired,
		data: _react2.default.PropTypes.array,
		subTitle: _react2.default.PropTypes.string,
		subTitleText: _react2.default.PropTypes.string,
		dataNames: _react2.default.PropTypes.array,
		dataKeys: _react2.default.PropTypes.array
	};
	
	LineGraphicSection.defaultProps = {
		dataNames: ["Messages", "Engagement"],
		dataKeys: ["messages", "engagement"]
	};
	
	exports.default = LineGraphicSection;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(39);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _Grid = __webpack_require__(19);
	
	var _materialUi = __webpack_require__(38);
	
	var _reactGoogleMaps = __webpack_require__(243);
	
	var _utility = __webpack_require__(14);
	
	var _lodash = __webpack_require__(18);
	
	var _rcTree = __webpack_require__(2722);
	
	var _rcTree2 = _interopRequireDefault(_rcTree);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	__webpack_require__(1392);
	
	__webpack_require__(1442);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var google = window.google;
	
	var SelectedAttrs = function (_Component) {
	  _inherits(SelectedAttrs, _Component);
	
	  function SelectedAttrs() {
	    _classCallCheck(this, SelectedAttrs);
	
	    return _possibleConstructorReturn(this, (SelectedAttrs.__proto__ || Object.getPrototypeOf(SelectedAttrs)).apply(this, arguments));
	  }
	
	  _createClass(SelectedAttrs, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.state = {
	        removeValConfirm: false,
	        stateObj: "",
	        cityObj: "",
	        dmaObj: "",
	        countyObj: "",
	        ifRemoveState: false,
	        ifRemoveCity: false,
	        ifRemoveCounty: false,
	        ifRemoveDMA: false,
	        ifRemoveAllState: false,
	        ifRemoveAllCity: false,
	        ifRemoveAllStateAndCity: false,
	        ifRemoveAllCounty: false,
	        ifRemoveAllDMA: false,
	        stateAndCityPageY: "",
	        ifShowChannel: false,
	        ifRemoveAllZipCode: false,
	        ifRemoveZipCode: false,
	        zipcode: ""
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.getContainer();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.cmContainer) {
	        _reactDom2.default.unmountComponentAtNode(this.cmContainer);
	        document.body.removeChild(this.cmContainer);
	        this.cmContainer = null;
	      }
	    }
	  }, {
	    key: "getContainer",
	    value: function getContainer() {
	      if (!this.cmContainer) {
	        this.cmContainer = document.createElement("div");
	        document.body.appendChild(this.cmContainer);
	      }
	      return this.cmContainer;
	    }
	  }, {
	    key: "renderCm",
	    value: function renderCm(info, audiences) {
	      if (this.toolTip) {
	        if (this.cmContainer) _reactDom2.default.unmountComponentAtNode(this.cmContainer);
	        this.toolTip = null;
	      }
	      var over_lay = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _Grid.FullRow,
	          null,
	          "Reach by Channel"
	        ),
	        _react2.default.createElement(
	          _Grid.Row,
	          { className: "no-padding" },
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "4", sm: "4", md: "4", lg: "4", style: { paddingLeft: 0 } },
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement("i", {
	                className: "icon-envelope",
	                style: { fontSize: "1.5em", marginRight: "0.4em" }
	              }),
	              _react2.default.createElement(
	                "span",
	                { className: "ml-8 text-default text-bold" },
	                (0, _utility.splitNumber)(audiences.email + "")()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "4", sm: "4", md: "4", lg: "4", style: { paddingLeft: 0 } },
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement("i", {
	                className: "icon-share3",
	                style: { fontSize: "1.5em", marginRight: "0.4em" }
	              }),
	              _react2.default.createElement(
	                "span",
	                { className: "ml-8 text-default text-bold" },
	                (0, _utility.splitNumber)(audiences.social + "")()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "4", sm: "4", md: "4", lg: "4", style: { paddingRight: 0 } },
	            _react2.default.createElement(
	              "p",
	              { className: "pull-left" },
	              _react2.default.createElement("i", {
	                className: "icon-display4",
	                style: { fontSize: "1.5em", marginRight: "0.4em" }
	              }),
	              _react2.default.createElement(
	                "span",
	                { className: "ml-8 text-default text-bold" },
	                (0, _utility.splitNumber)(audiences.display + "")()
	              )
	            )
	          )
	        )
	      );
	      this.toolTip = _react2.default.createElement(
	        _rcTooltip2.default,
	        {
	          trigger: "click",
	          placement: "right",
	          prefixCls: "rc-tree-contextmenu",
	          mouseEnterDelay: 0.5,
	          defaultVisible: true,
	          overlay: over_lay
	        },
	        _react2.default.createElement("span", null)
	      );
	
	      var container = this.getContainer();
	      var width = this.props.width;
	
	      var top = info.pageY ? info.pageY : info.event.pageY;
	      var posX = width ? width / 3.2 : info.event.pageX;
	      (0, _objectAssign2.default)(this.cmContainer.style, {
	        position: "absolute",
	        left: posX + "px",
	        top: top + "px"
	      });
	
	      _reactDom2.default.render(this.toolTip, container);
	    }
	  }, {
	    key: "displayPlottedRadiusAudience",
	    value: function displayPlottedRadiusAudience(info) {
	      var width = this.props.width;
	
	      if (info.event.pageX > width / 3) return;
	      if (this.cmContainer != null) {
	        _reactDom2.default.unmountComponentAtNode(this.cmContainer);
	        document.body.removeChild(this.cmContainer);
	        this.cmContainer = null;
	      }
	      this.renderCm(info, this.props.plottedRadius.audienceCount);
	    }
	  }, {
	    key: "displayAttrAudience",
	    value: function displayAttrAudience(info, categories, slt_vals) {
	      var width = this.props.width;
	
	      if (info.event.pageX > width / 3) return;
	
	      if (this.cmContainer != null) {
	        _reactDom2.default.unmountComponentAtNode(this.cmContainer);
	        document.body.removeChild(this.cmContainer);
	        this.cmContainer = null;
	      }
	      var id = (0, _lodash.last)(info.node.props.eventKey.split("-"));
	      var audiences = { email: 0, social: 0, display: 0 };
	      if (info.node.props.isLeaf === true) {
	        (0, _lodash.map)(categories, function (cat) {
	          (0, _lodash.map)(cat.attributes, function (attr) {
	            (0, _lodash.map)(attr.values, function (val) {
	              if (parseInt(val.id, 10) === parseInt(id, 10)) {
	                audiences.email = val.email;
	                audiences.display = val.display;
	                audiences.social = val.social;
	              }
	            });
	            (0, _lodash.map)(attr.subAttributes, function (subAttr) {
	              (0, _lodash.map)(subAttr.values, function (val) {
	                if (parseInt(val.id, 10) === parseInt(id, 10)) {
	                  audiences.email = val.email;
	                  audiences.display = val.display;
	                  audiences.social = val.social;
	                }
	              });
	            });
	          });
	        });
	      }
	      if ((0, _lodash.isUndefined)(info.node.props.isLeaf)) {
	        (0, _lodash.map)(categories, function (cat) {
	          (0, _lodash.map)(cat.attributes, function (attr) {
	            if (parseInt(attr.id, 10) === parseInt(id, 10)) {
	              (0, _lodash.map)(attr.values, function (val) {
	                if (slt_vals.indexOf(val.id) >= 0) {
	                  audiences.email += val.email;
	                  audiences.display += val.display;
	                  audiences.social += val.social;
	                }
	              });
	              (0, _lodash.map)(attr.subAttributes, function (subAttr) {
	                (0, _lodash.map)(subAttr.values, function (val) {
	                  if (slt_vals.indexOf(val.id) >= 0) {
	                    audiences.email += val.email;
	                    audiences.display += val.display;
	                    audiences.social += val.social;
	                  }
	                });
	              });
	            }
	          });
	        });
	      }
	
	      this.renderCm(info, audiences);
	    }
	  }, {
	    key: "onConfirmBtnMouseOver",
	    value: function onConfirmBtnMouseOver() {
	      if (this.cmContainer != null) {
	        _reactDom2.default.unmountComponentAtNode(this.cmContainer);
	        document.body.removeChild(this.cmContainer);
	        this.cmContainer = null;
	      }
	    }
	  }, {
	    key: "onMouseLeave",
	    value: function onMouseLeave(info) {
	      if (this.cmContainer != null) {
	        _reactDom2.default.unmountComponentAtNode(this.cmContainer);
	        document.body.removeChild(this.cmContainer);
	        this.cmContainer = null;
	      }
	    }
	  }, {
	    key: "removeSelectVal",
	    value: function removeSelectVal() {
	      var _this2 = this;
	
	      if (this.state.sltId >= 0) {
	        if (this.state.removeType === "val") {
	          this.props.removeAttribute(this.state.sltId);
	        }
	        if (this.state.removeType === "attr") {
	          var _props = this.props,
	              categories = _props.categories,
	              selectedAttrs = _props.selectedAttrs;
	
	          (0, _lodash.map)(categories, function (cat, key) {
	            (0, _lodash.map)(cat.attributes, function (attr) {
	              if (attr.id === _this2.state.sltId) {
	                (0, _lodash.map)(attr.values, function (val) {
	                  if (selectedAttrs.indexOf(val.id) >= 0) {
	                    _this2.props.removeAttribute(val.id);
	                  }
	                });
	
	                (0, _lodash.map)(attr.subAttributes, function (subAttr) {
	                  (0, _lodash.map)(subAttr.values, function (val) {
	                    if (selectedAttrs.indexOf(val.id) >= 0) {
	                      _this2.props.removeAttribute(val.id);
	                    }
	                  });
	                });
	              }
	            });
	          });
	        }
	        if (this.state.removeType === "plotted_radius") {
	          this.props.removePlottedVal();
	        }
	        this.setState({ sltId: null });
	      }
	
	      if (this.props.selected_city.length > 0 || this.props.selected_state.length > 0 || this.props.selected_county.length > 0 || this.props.selected_dma.length > 0 || this.props.zipcode.length > 0) {
	        if (this.state.ifRemoveState) {
	          this.props.selectState(this.state.stateObj, false);
	          this.setState({
	            ifRemoveState: false
	          });
	        } else if (this.state.ifRemoveCity) {
	          this.props.selectCity(this.state.cityObj, false);
	          this.setState({
	            ifRemoveCity: false
	          });
	        } else if (this.state.ifRemoveCounty) {
	          this.props.selectCounty(this.state.countyObj, false);
	          this.setState({
	            ifRemoveCounty: false
	          });
	        } else if (this.state.ifRemoveDMA) {
	          this.props.selectDMA(this.state.dmaObj, false);
	          this.setState({
	            ifRemoveDMA: false
	          });
	        } else if (this.state.ifRemoveAllState) {
	          this.props.clearAllSelectedState();
	          this.setState({
	            ifRemoveAllState: false
	          });
	        } else if (this.state.ifRemoveAllCity) {
	          this.props.clearAllSelectedCity();
	          this.setState({
	            ifRemoveAllCity: false
	          });
	        } else if (this.state.ifRemoveAllStateAndCity) {
	          this.props.clearAllSelectedCity();
	          this.props.clearAllSelectedState();
	          this.props.clearAllZipCode();
	          this.setState({
	            ifRemoveAllStateAndCity: false
	          });
	        } else if (this.state.ifRemoveAllZipCode) {
	          this.props.clearAllZipCode();
	          this.setState({
	            ifRemoveAllZipCode: false
	          });
	        } else if (this.state.ifRemoveZipCode) {
	          this.props.clearZipCode(this.state.zipcode.zipcode);
	          this.setState({
	            ifRemoveZipCode: false
	          });
	        } else if (this.state.ifRemoveAllCounty) {
	          this.props.clearAllCounty();
	          this.setState({
	            ifRemoveAllCounty: false
	          });
	        } else if (this.state.ifRemoveAllDMA) {
	          this.props.clearAllDMA();
	          this.setState({
	            ifRemoveAllDMA: false
	          });
	        }
	      }
	    }
	  }, {
	    key: "removeValBtn",
	    value: function removeValBtn(id) {
	      var _this3 = this;
	
	      return this.props.listMode === true ? "" : _react2.default.createElement(
	        "a",
	        {
	          onClick: function onClick(e) {
	            e.preventDefault();
	            _this3.setState({
	              sltId: id,
	              removeType: "val",
	              removeValConfirm: true,
	              anchorEl: e.currentTarget
	            });
	          }
	        },
	        _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	      );
	    }
	  }, {
	    key: "removeAttrValBtn",
	    value: function removeAttrValBtn(id) {
	      var _this4 = this;
	
	      return this.props.listMode === true ? "" : _react2.default.createElement(
	        "a",
	        {
	          onClick: function onClick(e) {
	            e.preventDefault();
	            _this4.setState({
	              sltId: id,
	              removeType: "attr",
	              removeValConfirm: true,
	              anchorEl: e.currentTarget
	            });
	          }
	        },
	        _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	      );
	    }
	  }, {
	    key: "removePlottedValBtn",
	    value: function removePlottedValBtn() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        "a",
	        {
	          onClick: function onClick(e) {
	            e.preventDefault();
	            _this5.setState({
	              sltId: 0,
	              removeType: "plotted_radius",
	              removeValConfirm: true,
	              anchorEl: e.currentTarget
	            });
	          }
	        },
	        _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	      );
	    }
	  }, {
	    key: "handleRemoveValConfirm",
	    value: function handleRemoveValConfirm() {
	      this.setState({
	        removeValConfirm: false,
	        anchorEl: null
	      });
	    }
	  }, {
	    key: "removeStateAttribute",
	    value: function removeStateAttribute(e, stateObj) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        stateObj: stateObj,
	        ifRemoveState: true
	      });
	    }
	  }, {
	    key: "removeCityAttribute",
	    value: function removeCityAttribute(e, cityObj) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        cityObj: cityObj,
	        ifRemoveCity: true
	      });
	    }
	  }, {
	    key: "removeDMA",
	    value: function removeDMA(e, obj) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        dmaObj: obj,
	        ifRemoveDMA: true
	      });
	    }
	  }, {
	    key: "removeCounty",
	    value: function removeCounty(e, obj) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        countyObj: obj,
	        ifRemoveCounty: true
	      });
	    }
	  }, {
	    key: "removeAllState",
	    value: function removeAllState(e) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        ifRemoveAllState: true
	      });
	    }
	  }, {
	    key: "removeAllCity",
	    value: function removeAllCity(e) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        ifRemoveAllCity: true
	      });
	    }
	  }, {
	    key: "removeAllCounty",
	    value: function removeAllCounty(e) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        ifRemoveAllCounty: true
	      });
	    }
	  }, {
	    key: "removeAllDMA",
	    value: function removeAllDMA(e) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        ifRemoveAllDMA: true
	      });
	    }
	  }, {
	    key: "removeAllStateAndCity",
	    value: function removeAllStateAndCity(e) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        ifRemoveAllStateAndCity: true
	      });
	    }
	  }, {
	    key: "removeAllZipCode",
	    value: function removeAllZipCode(e) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        ifRemoveAllZipCode: true
	      });
	    }
	  }, {
	    key: "removeZipCode",
	    value: function removeZipCode(e, zipcode) {
	      e.preventDefault();
	      this.setState({
	        removeValConfirm: true,
	        anchorEl: e.currentTarget,
	        zipcode: zipcode,
	        ifRemoveZipCode: true
	      });
	    }
	  }, {
	    key: "showChannel",
	    value: function showChannel(e) {
	      var attr = e.event.target.getAttribute("data-type");
	      var obj = {};
	      var idx = e.event.target.getAttribute("data-index");
	      var email, social, display;
	      if (attr !== null) {
	        if (attr === "state/city") {
	          email = this.props.selected_state.reduce(function (acc, curr) {
	            return acc + curr.email;
	          }, 0) + this.props.selected_city.reduce(function (acc, curr) {
	            return acc + curr.email;
	          }, 0) + this.props.zipcode.reduce(function (acc, curr) {
	            return acc + curr.email;
	          }, 0);
	          social = this.props.selected_state.reduce(function (acc, curr) {
	            return acc + curr.social;
	          }, 0) + this.props.selected_city.reduce(function (acc, curr) {
	            return acc + curr.social;
	          }, 0) + this.props.zipcode.reduce(function (acc, curr) {
	            return acc + curr.social;
	          }, 0);
	          display = this.props.selected_state.reduce(function (acc, curr) {
	            return acc + curr.display;
	          }, 0) + this.props.selected_city.reduce(function (acc, curr) {
	            return acc + curr.display;
	          }, 0) + this.props.zipcode.reduce(function (acc, curr) {
	            return acc + curr.display;
	          }, 0);
	        } else if (attr === "state") {
	          email = this.props.selected_state.reduce(function (acc, curr) {
	            return acc + curr.email;
	          }, 0);
	          social = this.props.selected_state.reduce(function (acc, curr) {
	            return acc + curr.social;
	          }, 0);
	          display = this.props.selected_state.reduce(function (acc, curr) {
	            return acc + curr.display;
	          }, 0);
	        } else if (attr === "city") {
	          email = this.props.selected_city.reduce(function (acc, curr) {
	            return acc + curr.email;
	          }, 0);
	          social = this.props.selected_city.reduce(function (acc, curr) {
	            return acc + curr.social;
	          }, 0);
	          display = this.props.selected_city.reduce(function (acc, curr) {
	            return acc + curr.display;
	          }, 0);
	        } else if (attr === "stateChild") {
	          email = this.props.selected_state[idx].email;
	          social = this.props.selected_state[idx].social;
	          display = this.props.selected_state[idx].display;
	        } else if (attr === "cityChild") {
	          email = this.props.selected_city[idx].email;
	          social = this.props.selected_city[idx].social;
	          display = this.props.selected_city[idx].display;
	        } else if (attr === "zipcode") {
	          email = this.props.zipcode.reduce(function (acc, curr) {
	            return acc + curr.email;
	          }, 0);
	          social = this.props.zipcode.reduce(function (acc, curr) {
	            return acc + curr.social;
	          }, 0);
	          display = this.props.zipcode.reduce(function (acc, curr) {
	            return acc + curr.display;
	          }, 0);
	        } else if (attr === "zipcodeitem") {
	          email = this.props.zipcode[idx].email;
	          social = this.props.zipcode[idx].social;
	          display = this.props.zipcode[idx].display;
	        } else if (attr === "county") {
	          email = this.props.selected_county.reduce(function (acc, curr) {
	            return acc + curr.email;
	          }, 0);
	          social = this.props.selected_county.reduce(function (acc, curr) {
	            return acc + curr.social;
	          }, 0);
	          display = this.props.selected_county.reduce(function (acc, curr) {
	            return acc + curr.display;
	          }, 0);
	        } else if (attr === "dma") {
	          email = this.props.selected_dma.reduce(function (acc, curr) {
	            return acc + curr.email;
	          }, 0);
	          social = this.props.selected_dma.reduce(function (acc, curr) {
	            return acc + curr.social;
	          }, 0);
	          display = this.props.selected_dma.reduce(function (acc, curr) {
	            return acc + curr.display;
	          }, 0);
	        } else if (attr === "countyItem") {
	          email = this.props.selected_county[idx].email;
	          social = this.props.selected_county[idx].social;
	          display = this.props.selected_county[idx].display;
	        } else if (attr === "dmaItem") {
	          email = this.props.selected_dma[idx].email;
	          social = this.props.selected_dma[idx].social;
	          display = this.props.selected_dma[idx].display;
	        }
	        obj.email = email;
	        obj.social = social;
	        obj.display = display;
	        this.renderCm(e, obj);
	      }
	    }
	  }, {
	    key: "handleMapMounted",
	    value: function handleMapMounted(map) {
	      this._map = map;
	      if (this._map && this._vector) try {
	        this._map.fitBounds(this._vector.getBounds());
	      } catch (ex) {}
	    }
	  }, {
	    key: "plotted_radius_row",
	    value: function plotted_radius_row() {
	      var _this6 = this;
	
	      var plottedRadius = this.props.plottedRadius;
	
	      if ((0, _lodash.isEmpty)(plottedRadius)) {
	        return _react2.default.createElement("div", null);
	      } else {
	        var vector = null;
	        switch (plottedRadius.type) {
	          case "polygon":
	            vector = _react2.default.createElement(_reactGoogleMaps.Polygon, {
	              ref: function ref(elm) {
	                return _this6._vector = elm;
	              },
	              path: typeof plottedRadius.path === "string" ? google.maps.geometry.encoding.decodePath(plottedRadius.path) : plottedRadius.path,
	              options: (0, _utility.getMapVectorOptions)()
	            });
	            break;
	          case "rectangle":
	            vector = _react2.default.createElement(_reactGoogleMaps.Rectangle, {
	              ref: function ref(elm) {
	                return _this6._vector = elm;
	              },
	              bounds: plottedRadius.bounds,
	              radius: plottedRadius.radius,
	              options: (0, _utility.getMapVectorOptions)()
	            });
	            break;
	          case "circle":
	            //default:
	            vector = _react2.default.createElement(_reactGoogleMaps.Circle, {
	              ref: function ref(elm) {
	                return _this6._vector = elm;
	              },
	              center: plottedRadius.center,
	              radius: plottedRadius.radius,
	              options: (0, _utility.getMapVectorOptions)()
	            });
	            break;
	          default:
	            vector = "";
	            break;
	        }
	        var PlottedRadiusMap = null;
	        if (vector) {
	          PlottedRadiusMap = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
	            return _react2.default.createElement(
	              _reactGoogleMaps.GoogleMap,
	              {
	                zoom: plottedRadius.zoom,
	                center: plottedRadius.center,
	                defaultOptions: {
	                  streetViewControl: false,
	                  mapTypeControl: false,
	                  zoomControl: false,
	                  scrollwheel: false,
	                  draggable: false
	                },
	                ref: _this6.handleMapMounted.bind(_this6)
	              },
	              vector
	            );
	          });
	        }
	
	        var _props2 = this.props,
	            selected_state = _props2.selected_state,
	            selected_city = _props2.selected_city;
	
	        var showTitle = !(selected_state.length > 0 || selected_city.length > 0);
	        return [showTitle && _react2.default.createElement(
	          _Grid.FullRow,
	          {
	            key: "geo_header_row",
	            style: { marginTop: "-20px", marginBottom: "-10px" },
	            className: "no-padding-bottom no-padding-top no-margin-bottom no-margin-top"
	          },
	          _react2.default.createElement(
	            "h4",
	            { style: { marginBottom: "0px" } },
	            "GEOGRAPHIC"
	          )
	        ), _react2.default.createElement(
	          _Grid.Row,
	          {
	            key: "plotted-radius-row",
	            className: "no-padding-left no-margin-bottom no-padding-bottom no-padding-right pt-5 city-state-container",
	            style: {
	              width: this.props.listMode === true ? "103%" : "80%",
	              marginLeft: "20px"
	            }
	          },
	          _react2.default.createElement(
	            _Grid.Col,
	            {
	              xs: "9",
	              md: "9",
	              sm: "9",
	              lg: "9",
	              className: "no-padding-left no-padding-right",
	              style: { overflow: "hidden" }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: { float: "left" },
	                className: "text-teal-400 text-capitalize"
	              },
	              _react2.default.createElement(
	                "span",
	                null,
	                "plotted radius\xA0\xA0\xA0"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                onMouseOver: this.onConfirmBtnMouseOver.bind(this),
	                style: {
	                  marginTop: "-10px",
	                  overflow: "hidden",
	                  borderBottom: "1px gray dashed"
	                }
	              },
	              "\xA0"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            {
	              xs: "2",
	              md: "2",
	              sm: "2",
	              lg: "2",
	              className: "text-right no-padding-left no-padding-right",
	              style: { overflow: "hidden" },
	              onMouseOver: this.onConfirmBtnMouseOver.bind(this)
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginTop: "-10px",
	                  overflow: "hidden",
	                  borderBottom: "1px gray dashed"
	                }
	              },
	              "\xA0\xA0\xA0"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "1", sm: "1", md: "1", lg: "1", className: "no-padding-right pl-20" },
	            this.props.listMode === true ? null : this.removePlottedValBtn()
	          )
	        ), PlottedRadiusMap ? _react2.default.createElement(
	          _Grid.Row,
	          {
	            className: "geo-map-row-container",
	            key: "geo_map_row",
	            style: { paddingTop: "5px" }
	          },
	          _react2.default.createElement(
	            _Grid.Col,
	            {
	              xs: "8",
	              sm: "8",
	              md: "8",
	              lg: "8",
	              style: {
	                height: "250px",
	                paddingRight: "40px",
	                maxWidth: "700px"
	              }
	            },
	            _react2.default.createElement(PlottedRadiusMap, {
	              containerElement: _react2.default.createElement("div", { style: { height: "100%" } }),
	              mapElement: _react2.default.createElement("div", { style: { height: "100%" } })
	            })
	          )
	        ) : _react2.default.createElement(
	          "div",
	          {
	            key: "address_map_container",
	            style: { width: this.props.listMode === true ? "103%" : "80%" }
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              key: "geo_map_address_row",
	              id: "geo_map_address_row",
	              className: "no-margin-bottom no-padding-bottom no-padding-right",
	              style: { paddingTop: "5px", paddingLeft: "60px" }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "1",
	                sm: "1",
	                md: "1",
	                lg: "1",
	                offsetXs: "1",
	                offsetSm: "1",
	                offsetMd: "1",
	                offsetLg: "1",
	                className: "no-padding-right"
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { float: "left" } },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Address"
	                ),
	                "\xA0\xA0\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "-10px",
	                    overflow: "hidden",
	                    borderBottom: "0px gray dashed"
	                  }
	                },
	                "\xA0"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "8",
	                sm: "8",
	                md: "8",
	                lg: "8",
	                className: "text-right no-padding-right"
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { float: "right" } },
	                _react2.default.createElement(
	                  "div",
	                  { style: { maxWidth: "460px", whiteSpace: "pre-wrap" } },
	                  "\xA0\xA0",
	                  plottedRadius.addressLabel.replace(", United States", "")
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "-10px",
	                    overflow: "hidden",
	                    borderBottom: "1px gray dashed"
	                  }
	                },
	                "\xA0"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              key: "geo_map_address_role_row",
	              className: "no-margin-bottom no-padding-bottom no-padding-right",
	              style: { paddingTop: "5px", paddingLeft: "60px" }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "7",
	                sm: "7",
	                md: "7",
	                lg: "7",
	                offsetXs: "1",
	                offsetSm: "1",
	                offsetMd: "1",
	                offsetLg: "1",
	                className: "no-padding-right"
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { float: "left" } },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  plottedRadius.type === "address_radius" ? "Radius from Address" : "Drive Time from Address"
	                ),
	                "\xA0\xA0\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "-10px",
	                    overflow: "hidden",
	                    borderBottom: "1px gray dashed"
	                  }
	                },
	                "\xA0"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "2",
	                sm: "2",
	                md: "2",
	                lg: "2",
	                className: "text-right no-padding-right no-padding-left"
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { float: "right" } },
	                "\xA0\xA0",
	                plottedRadius.type === "address_radius" ? plottedRadius.radius + " Mile(s)" : plottedRadius.driveTime + " Hour(s)"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "-10px",
	                    overflow: "hidden",
	                    borderBottom: "1px gray dashed"
	                  }
	                },
	                "\xA0"
	              )
	            )
	          )
	        )];
	      }
	    }
	  }, {
	    key: "display_geography",
	    value: function display_geography() {
	      var _this7 = this;
	
	      var _props3 = this.props,
	          selected_state = _props3.selected_state,
	          selected_city = _props3.selected_city,
	          selected_county = _props3.selected_county,
	          selected_dma = _props3.selected_dma,
	          zipcode = _props3.zipcode,
	          listMode = _props3.listMode;
	
	      if (selected_state.length > 0 || selected_city.length > 0 || zipcode.length > 0 || selected_county.length > 0 || selected_dma.length > 0) {
	        return _react2.default.createElement(
	          "div",
	          { className: "state-city-tree ", style: { position: "relative" } },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-bottom no-margin-bottom  no-padding-top no-margin-top" },
	            _react2.default.createElement(
	              "h4",
	              { style: { marginBottom: "0px" } },
	              "GEOGRAPHY"
	            )
	          ),
	          _react2.default.createElement(
	            _rcTree2.default,
	            {
	              showIcon: false,
	              selectable: false,
	              showLine: false,
	              checkable: false,
	              defaultExpandAll: false,
	              onMouseEnter: function onMouseEnter(e) {
	                return _this7.showChannel(e);
	              },
	              onMouseLeave: this.onMouseLeave.bind(this)
	            },
	            _react2.default.createElement(
	              _rcTree.TreeNode,
	              {
	                title: _react2.default.createElement(
	                  _Grid.Row,
	                  { className: "no-margin-left no-margin-bottom no-padding-bottom no-padding-left no-padding-right pt-5" },
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "9",
	                      md: "9",
	                      sm: "9",
	                      lg: "9",
	                      className: "no-padding-right",
	                      style: { overflow: "hidden" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { style: { float: "left" }, "data-type": "state/city" },
	                      _react2.default.createElement(
	                        "span",
	                        { className: "text-teal-400" },
	                        zipcode.length > 0 ? "US Zip Code" : "US State/City"
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "(",
	                        zipcode.length > 0 ? zipcode.length : selected_state.length + selected_city.length,
	                        ")"
	                      ),
	                      "\xA0"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        onMouseOver: this.onConfirmBtnMouseOver.bind(this),
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "2",
	                      md: "2",
	                      sm: "2",
	                      lg: "2",
	                      style: { overflow: "hidden" },
	                      className: "text-right no-padding-right no-padding-left",
	                      onMouseOver: this.onConfirmBtnMouseOver.bind(this)
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "1",
	                      md: "1",
	                      sm: "1",
	                      lg: "1",
	                      style: {
	                        paddingLeft: "15px",
	                        display: listMode === true ? "none" : "block"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        onClick: function onClick(e) {
	                          return zipcode.length > 0 ? _this7.removeAllZipCode(e) : _this7.removeAllStateAndCity(e);
	                        }
	                      },
	                      _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                    )
	                  )
	                ),
	                className: selected_county.length > 0 || selected_dma.length > 0 ? "hidden-us-state" : this.props.listMode === true ? "width-128" : ""
	              },
	              _react2.default.createElement(
	                _rcTree.TreeNode,
	                {
	                  className: selected_state.length > 0 ? "" : "hidden-state",
	                  title: _react2.default.createElement(
	                    _Grid.Row,
	                    {
	                      style: { paddingTop: "2px" },
	                      className: "no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
	                    },
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "9",
	                        md: "9",
	                        sm: "9",
	                        lg: "9",
	                        className: "no-padding-right",
	                        style: { overflow: "hidden" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { style: { float: "left" }, "data-type": "state" },
	                        _react2.default.createElement(
	                          "span",
	                          { className: "text-teal-400" },
	                          "State"
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "(",
	                          selected_state.length,
	                          ")"
	                        ),
	                        "\xA0\xA0\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "2",
	                        md: "2",
	                        sm: "2",
	                        lg: "2",
	                        className: "text-right no-padding-right no-padding-left",
	                        style: { overflow: "hidden" },
	                        onMouseOver: this.onConfirmBtnMouseOver.bind(this)
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "1",
	                        sm: "1",
	                        md: "1",
	                        lg: "1",
	                        style: {
	                          paddingLeft: "15px",
	                          display: listMode === true ? "none" : "block"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "a",
	                        { onClick: function onClick(e) {
	                            return _this7.removeAllState(e);
	                          } },
	                        _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                      )
	                    )
	                  )
	                },
	                selected_state.map(function (item, index) {
	                  return _react2.default.createElement(_rcTree.TreeNode, {
	                    title: _react2.default.createElement(
	                      _Grid.Row,
	                      {
	                        style: { paddingTop: "2px" },
	                        className: "no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
	                      },
	                      _react2.default.createElement(
	                        _Grid.Col,
	                        {
	                          xs: "9",
	                          md: "9",
	                          sm: "9",
	                          lg: "9",
	                          className: "no-padding-right",
	                          style: { overflow: "hidden" }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "text-teal-400",
	                            "data-type": "stateChild",
	                            "data-index": index,
	                            style: { display: "flex", float: "left" }
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { style: { flexGrow: "1" } },
	                            item.label,
	                            "\xA0\xA0\xA0"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: {
	                              marginTop: "-10px",
	                              overflow: "hidden",
	                              borderBottom: "1px gray dashed"
	                            }
	                          },
	                          "\xA0"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _Grid.Col,
	                        {
	                          xs: "2",
	                          md: "2",
	                          sm: "2",
	                          lg: "2",
	                          className: "text-right no-padding-right no-padding-left",
	                          style: { overflow: "hidden" },
	                          onMouseOver: _this7.onConfirmBtnMouseOver.bind(_this7)
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: {
	                              marginTop: "-10px",
	                              overflow: "hidden",
	                              borderBottom: "1px gray dashed"
	                            }
	                          },
	                          "\xA0"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _Grid.Col,
	                        {
	                          xs: "1",
	                          sm: "1",
	                          md: "1",
	                          lg: "1",
	                          style: {
	                            paddingLeft: "15px",
	                            display: listMode === true ? "none" : "block"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            onClick: function onClick(e) {
	                              _this7.removeStateAttribute(e, item);
	                            }
	                          },
	                          _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                        )
	                      )
	                    ),
	                    key: item.id,
	                    isLeaf: true
	                  });
	                })
	              ),
	              _react2.default.createElement(
	                _rcTree.TreeNode,
	                {
	                  className: selected_city.length > 0 ? "" : "hidden-city",
	                  title: _react2.default.createElement(
	                    _Grid.Row,
	                    {
	                      style: { paddingTop: "2px" },
	                      className: "no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
	                    },
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "9",
	                        md: "9",
	                        sm: "9",
	                        lg: "9",
	                        className: "no-padding-right",
	                        style: { overflow: "hidden" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { style: { float: "left" }, "data-type": "city" },
	                        _react2.default.createElement(
	                          "span",
	                          { className: "text-teal-400" },
	                          "City"
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "(",
	                          selected_city.length,
	                          ")"
	                        ),
	                        "\xA0\xA0\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "2",
	                        md: "2",
	                        sm: "2",
	                        lg: "2",
	                        className: "text-right no-padding-right no-padding-left",
	                        style: { overflow: "hidden" },
	                        onMouseOver: this.onConfirmBtnMouseOver.bind(this)
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "1",
	                        sm: "1",
	                        md: "1",
	                        lg: "1",
	                        style: {
	                          paddingLeft: "15px",
	                          display: listMode === true ? "none" : "block"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "a",
	                        { onClick: function onClick(e) {
	                            return _this7.removeAllCity(e);
	                          } },
	                        _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                      )
	                    )
	                  )
	                },
	                selected_city.map(function (item, index) {
	                  return _react2.default.createElement(_rcTree.TreeNode, {
	                    title: _react2.default.createElement(
	                      _Grid.Row,
	                      {
	                        style: { paddingTop: "2px" },
	                        className: "no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
	                      },
	                      _react2.default.createElement(
	                        _Grid.Col,
	                        {
	                          xs: "9",
	                          md: "9",
	                          sm: "9",
	                          lg: "9",
	                          className: "no-padding-right",
	                          style: { overflow: "hidden" }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: { float: "left" },
	                            className: "text-teal-400",
	                            "data-type": "cityChild",
	                            "data-index": index
	                          },
	                          item.label,
	                          ", ",
	                          item.state,
	                          "\xA0\xA0\xA0"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: {
	                              marginTop: "-10px",
	                              overflow: "hidden",
	                              borderBottom: "1px gray dashed"
	                            }
	                          },
	                          "\xA0"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _Grid.Col,
	                        {
	                          xs: "2",
	                          md: "2",
	                          sm: "2",
	                          lg: "2",
	                          className: "text-right no-padding-right no-padding-left",
	                          style: { overflow: "hidden" },
	                          onMouseOver: _this7.onConfirmBtnMouseOver.bind(_this7)
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: {
	                              marginTop: "-10px",
	                              overflow: "hidden",
	                              borderBottom: "1px gray dashed"
	                            }
	                          },
	                          "\xA0"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _Grid.Col,
	                        {
	                          xs: "1",
	                          sm: "1",
	                          md: "1",
	                          lg: "1",
	                          style: {
	                            paddingLeft: "15px",
	                            display: listMode === true ? "none" : "block"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            onClick: function onClick(e) {
	                              _this7.removeCityAttribute(e, item);
	                            }
	                          },
	                          _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                        )
	                      )
	                    ),
	                    key: item.id,
	                    isLeaf: true
	                  });
	                })
	              ),
	              _react2.default.createElement(
	                _rcTree.TreeNode,
	                {
	                  className: zipcode.length > 0 ? "" : "hidden-zipcode",
	                  title: _react2.default.createElement(
	                    _Grid.Row,
	                    {
	                      style: { paddingTop: "2px" },
	                      className: "no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
	                    },
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "9",
	                        md: "9",
	                        sm: "9",
	                        lg: "9",
	                        className: "no-padding-right",
	                        style: { overflow: "hidden" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { style: { float: "left" }, "data-type": "zipcode" },
	                        _react2.default.createElement(
	                          "span",
	                          { className: "text-teal-400" },
	                          "Zip Code"
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "(",
	                          zipcode.length,
	                          ")"
	                        ),
	                        "\xA0\xA0\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          onMouseOver: this.onConfirmBtnMouseOver.bind(this),
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "2",
	                        md: "2",
	                        sm: "2",
	                        lg: "2",
	                        className: "text-right no-padding-right no-padding-left",
	                        style: { overflow: "hidden" },
	                        onMouseOver: this.onConfirmBtnMouseOver.bind(this)
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "1",
	                        md: "1",
	                        sm: "1",
	                        lg: "1",
	                        style: {
	                          paddingLeft: "15px",
	                          display: listMode === true ? "none" : "block"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "a",
	                        { onClick: function onClick(e) {
	                            return _this7.removeAllZipCode(e);
	                          } },
	                        _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                      )
	                    )
	                  )
	                },
	                zipcode.map(function (item, index) {
	                  return _react2.default.createElement(_rcTree.TreeNode, {
	                    title: _react2.default.createElement(
	                      _Grid.Row,
	                      {
	                        style: { paddingTop: "2px" },
	                        className: "no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
	                      },
	                      _react2.default.createElement(
	                        _Grid.Col,
	                        {
	                          xs: "9",
	                          md: "9",
	                          sm: "9",
	                          lg: "9",
	                          className: "no-padding-right",
	                          style: { overflow: "hidden" }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: { float: "left" },
	                            className: "text-teal-400",
	                            "data-type": "zipcodeitem",
	                            "data-index": index
	                          },
	                          item.zipcode,
	                          "\xA0\xA0\xA0"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: {
	                              marginTop: "-10px",
	                              overflow: "hidden",
	                              borderBottom: "1px gray dashed"
	                            }
	                          },
	                          "\xA0"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _Grid.Col,
	                        {
	                          xs: "2",
	                          md: "2",
	                          sm: "2",
	                          lg: "2",
	                          className: "text-right no-padding-right no-padding-left",
	                          style: { overflow: "hidden" },
	                          onMouseOver: _this7.onConfirmBtnMouseOver.bind(_this7)
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            style: {
	                              marginTop: "-10px",
	                              overflow: "hidden",
	                              borderBottom: "1px gray dashed"
	                            }
	                          },
	                          "\xA0"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _Grid.Col,
	                        {
	                          xs: "1",
	                          sm: "1",
	                          md: "1",
	                          lg: "1",
	                          style: {
	                            paddingLeft: "15px",
	                            display: listMode === true ? "none" : "block"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            onClick: function onClick(e) {
	                              _this7.removeZipCode(e, item);
	                            }
	                          },
	                          _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                        )
	                      )
	                    ),
	                    key: index,
	                    isLeaf: true
	                  });
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _rcTree.TreeNode,
	              {
	                className: selected_county.length > 0 ? "" : "hidden-county",
	                title: _react2.default.createElement(
	                  _Grid.Row,
	                  {
	                    style: { paddingTop: "2px" },
	                    className: "no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
	                  },
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "9",
	                      md: "9",
	                      sm: "9",
	                      lg: "9",
	                      className: "no-padding-right",
	                      style: { overflow: "hidden" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { style: { float: "left" }, "data-type": "county" },
	                      _react2.default.createElement(
	                        "span",
	                        { className: "text-teal-400" },
	                        "County"
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "(",
	                        selected_county.length,
	                        ")"
	                      ),
	                      "\xA0\xA0\xA0"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        onMouseOver: this.onConfirmBtnMouseOver.bind(this),
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "2",
	                      md: "2",
	                      sm: "2",
	                      lg: "2",
	                      className: "text-right no-padding-right no-padding-left",
	                      style: { overflow: "hidden" },
	                      onMouseOver: this.onConfirmBtnMouseOver.bind(this)
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "1",
	                      md: "1",
	                      sm: "1",
	                      lg: "1",
	                      style: {
	                        paddingLeft: "15px",
	                        display: listMode === true ? "none" : "block"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "a",
	                      { onClick: function onClick(e) {
	                          return _this7.removeAllCounty(e);
	                        } },
	                      _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                    )
	                  )
	                )
	              },
	              selected_county.map(function (item, index) {
	                return _react2.default.createElement(_rcTree.TreeNode, {
	                  title: _react2.default.createElement(
	                    _Grid.Row,
	                    {
	                      style: { paddingTop: "2px" },
	                      className: "no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
	                    },
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "9",
	                        md: "9",
	                        sm: "9",
	                        lg: "9",
	                        className: "no-padding-right",
	                        style: { overflow: "hidden" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: { float: "left" },
	                          className: "text-teal-400",
	                          "data-type": "countyItem",
	                          "data-index": index
	                        },
	                        item.label,
	                        "\xA0\xA0\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "2",
	                        md: "2",
	                        sm: "2",
	                        lg: "2",
	                        className: "text-right no-padding-right no-padding-left",
	                        style: { overflow: "hidden" },
	                        onMouseOver: _this7.onConfirmBtnMouseOver.bind(_this7)
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "1",
	                        sm: "1",
	                        md: "1",
	                        lg: "1",
	                        style: {
	                          paddingLeft: "15px",
	                          display: listMode === true ? "none" : "block"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          onClick: function onClick(e) {
	                            _this7.removeCounty(e, item);
	                          }
	                        },
	                        _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                      )
	                    )
	                  ),
	                  key: index,
	                  isLeaf: true
	                });
	              })
	            ),
	            _react2.default.createElement(
	              _rcTree.TreeNode,
	              {
	                className: selected_dma.length > 0 ? "" : "hidden-dma",
	                title: _react2.default.createElement(
	                  _Grid.Row,
	                  {
	                    style: { paddingTop: "2px" },
	                    className: "no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
	                  },
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "9",
	                      md: "9",
	                      sm: "9",
	                      lg: "9",
	                      className: "no-padding-right",
	                      style: { overflow: "hidden" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { style: { float: "left" }, "data-type": "dma" },
	                      _react2.default.createElement(
	                        "span",
	                        { className: "text-teal-400" },
	                        "DMA"
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "(",
	                        selected_dma.length,
	                        ")"
	                      ),
	                      "\xA0\xA0\xA0"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        onMouseOver: this.onConfirmBtnMouseOver.bind(this),
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "2",
	                      md: "2",
	                      sm: "2",
	                      lg: "2",
	                      className: "text-right no-padding-right no-padding-left",
	                      style: { overflow: "hidden" },
	                      onMouseOver: this.onConfirmBtnMouseOver.bind(this)
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "1",
	                      md: "1",
	                      sm: "1",
	                      lg: "1",
	                      style: {
	                        paddingLeft: "15px",
	                        display: listMode === true ? "none" : "block"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "a",
	                      { onClick: function onClick(e) {
	                          return _this7.removeAllDMA(e);
	                        } },
	                      _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                    )
	                  )
	                )
	              },
	              selected_dma.map(function (item, index) {
	                return _react2.default.createElement(_rcTree.TreeNode, {
	                  title: _react2.default.createElement(
	                    _Grid.Row,
	                    {
	                      style: { paddingTop: "2px" },
	                      className: "no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
	                    },
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "9",
	                        md: "9",
	                        sm: "9",
	                        lg: "9",
	                        className: "no-padding-right",
	                        style: { overflow: "hidden" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: { float: "left" },
	                          className: "text-teal-400",
	                          "data-type": "dmaItem",
	                          "data-index": index
	                        },
	                        item.code,
	                        " - ",
	                        item.label,
	                        "\xA0\xA0\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "2",
	                        md: "2",
	                        sm: "2",
	                        lg: "2",
	                        className: "text-right no-padding-right no-padding-left",
	                        style: { overflow: "hidden" },
	                        onMouseOver: _this7.onConfirmBtnMouseOver.bind(_this7)
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "1",
	                        sm: "1",
	                        md: "1",
	                        lg: "1",
	                        style: {
	                          paddingLeft: "15px",
	                          display: listMode === true ? "none" : "block"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          onClick: function onClick(e) {
	                            _this7.removeDMA(e, item);
	                          }
	                        },
	                        _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	                      )
	                    )
	                  ),
	                  key: index,
	                  isLeaf: true
	                });
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var display_categories = [];
	      var _props4 = this.props,
	          selectedAttrs = _props4.selectedAttrs,
	          categories = _props4.categories,
	          hideTitle = _props4.hideTitle,
	          plottedRadius = _props4.plottedRadius,
	          selected_state = _props4.selected_state,
	          selected_city = _props4.selected_city,
	          selected_county = _props4.selected_county,
	          selected_dma = _props4.selected_dma,
	          zipcode = _props4.zipcode;
	
	      (0, _lodash.map)(categories, function (cat, key) {
	        var attrs = [];
	        var auto_mm_attr_cols = [];
	        var auto_mm_total_audience = 0;
	        var auto_mm_total_count = 0;
	        (0, _lodash.map)(cat.attributes, function (attr) {
	          var total_audience = 0;
	          var total_count = 0;
	          var cat_attr_cols = [];
	          (0, _lodash.map)(attr.values, function (val) {
	            if (selectedAttrs.indexOf(val.id) >= 0) {
	              var leafNode = _react2.default.createElement(_rcTree.TreeNode, {
	                title: _react2.default.createElement(
	                  _Grid.Row,
	                  {
	                    style: { marginLeft: "0px", paddingRight: "2px" },
	                    className: "no-margin-bottom no-padding-bottom pt-5"
	                  },
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "9",
	                      md: "9",
	                      sm: "9",
	                      lg: "9",
	                      className: "no-padding-right",
	                      style: { overflow: "hidden" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { style: { float: "left" }, className: "text-teal-400" },
	                      val.label,
	                      "\xA0\xA0\xA0"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        onMouseOver: _this8.onConfirmBtnMouseOver.bind(_this8),
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "2",
	                      md: "2",
	                      sm: "2",
	                      lg: "2",
	                      className: "text-right no-padding-right no-padding-left",
	                      style: { overflow: "hidden" },
	                      onMouseOver: _this8.onConfirmBtnMouseOver.bind(_this8)
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0\xA0\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "1",
	                      md: "1",
	                      sm: "1",
	                      lg: "1",
	                      style: { paddingLeft: "15px" }
	                    },
	                    _this8.removeValBtn(val.id)
	                  )
	                ),
	                key: cat.id + "-" + attr.id + "-" + val.id,
	                isLeaf: true
	              });
	              if (attr.id === 605 || attr.id === 606) {
	                auto_mm_attr_cols.push(leafNode);
	                auto_mm_total_audience += val.total;
	                auto_mm_total_count += 1;
	              } else {
	                cat_attr_cols.push(leafNode);
	                total_audience += val.total;
	                total_count += 1;
	              }
	            }
	          });
	          (0, _lodash.map)(attr.subAttributes, function (subAttr) {
	            (0, _lodash.map)(subAttr.values, function (val) {
	              if (selectedAttrs.indexOf(val.id) >= 0) {
	                cat_attr_cols.push(_react2.default.createElement(_rcTree.TreeNode, {
	                  title: _react2.default.createElement(
	                    _Grid.Row,
	                    {
	                      style: { marginLeft: "0px", paddingRight: "2px" },
	                      className: "no-margin-bottom no-padding-bottom pt-5"
	                    },
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "9",
	                        md: "9",
	                        sm: "9",
	                        lg: "9",
	                        className: "no-padding-right",
	                        style: { overflow: "hidden" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: { float: "left" },
	                          className: "text-teal-400"
	                        },
	                        subAttr.name + ": " + val.label,
	                        "\xA0\xA0\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          onMouseOver: _this8.onConfirmBtnMouseOver.bind(_this8),
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "2",
	                        md: "2",
	                        sm: "2",
	                        lg: "2",
	                        className: "text-right no-padding-right no-padding-left",
	                        style: { overflow: "hidden" },
	                        onMouseOver: _this8.onConfirmBtnMouseOver.bind(_this8)
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            marginTop: "-10px",
	                            overflow: "hidden",
	                            borderBottom: "1px gray dashed"
	                          }
	                        },
	                        "\xA0\xA0\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Grid.Col,
	                      {
	                        xs: "1",
	                        md: "1",
	                        sm: "1",
	                        lg: "1",
	                        style: { paddingLeft: "15px" }
	                      },
	                      _this8.removeValBtn(val.id)
	                    )
	                  ),
	                  key: cat.id + "-" + attr.id + "-" + subAttr.id + "-" + val.id,
	                  isLeaf: true
	                }));
	                total_audience += val.total;
	                total_count += 1;
	              }
	            });
	          });
	          if (total_count > 0) {
	            var name = total_count > 0 ? [_react2.default.createElement(
	              "span",
	              {
	                key: "attribute_name_" + attr.id,
	                className: "text-teal-400"
	              },
	              attr.name
	            ), _react2.default.createElement(
	              "span",
	              { key: "attribute_acount_" + attr.id },
	              " (" + total_count + ")"
	            )] : _react2.default.createElement(
	              "span",
	              { key: "attribute_name_" + attr.id, className: "text-teal-400" },
	              " ",
	              "attr.name"
	            );
	            attrs.push(_react2.default.createElement(
	              _rcTree.TreeNode,
	              {
	                title: _react2.default.createElement(
	                  _Grid.Row,
	                  {
	                    style: {
	                      marginLeft: "0px",
	                      paddingTop: "2px",
	                      paddingLeft: "0px"
	                    },
	                    className: "no-margin-bottom no-padding-bottom no-padding-right"
	                  },
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "9",
	                      md: "9",
	                      sm: "9",
	                      lg: "9",
	                      className: "no-padding-right",
	                      style: { overflow: "hidden" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { style: { float: "left" } },
	                      name,
	                      "\xA0\xA0\xA0"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        onMouseOver: _this8.onConfirmBtnMouseOver.bind(_this8),
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "2",
	                      md: "2",
	                      sm: "2",
	                      lg: "2",
	                      className: "text-right no-padding-right no-padding-left",
	                      style: { overflow: "hidden" },
	                      onMouseOver: _this8.onConfirmBtnMouseOver.bind(_this8)
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          marginTop: "-10px",
	                          overflow: "hidden",
	                          borderBottom: "1px gray dashed"
	                        }
	                      },
	                      "\xA0\xA0\xA0"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    {
	                      xs: "1",
	                      md: "1",
	                      sm: "1",
	                      lg: "1",
	                      style: { paddingLeft: "15px" }
	                    },
	                    _this8.removeAttrValBtn(attr.id)
	                  )
	                ),
	                key: cat.id + "-" + attr.id,
	                className: _this8.props.listMode === true ? "width-128" : ""
	              },
	              cat_attr_cols
	            ));
	          }
	        });
	        if (auto_mm_total_count > 0) {
	          var name = auto_mm_total_count > 0 ? [_react2.default.createElement(
	            "span",
	            { key: "attribute_name_605", className: "text-teal-400" },
	            "Auto Make/Model"
	          ), _react2.default.createElement(
	            "span",
	            { key: "attribute_acount_605" },
	            " (" + auto_mm_total_count + ")"
	          )] : _react2.default.createElement(
	            "span",
	            { key: "attribute_name_605", className: "text-teal-400" },
	            "Auto Make/Model"
	          );
	          attrs.push(_react2.default.createElement(
	            _rcTree.TreeNode,
	            {
	              title: _react2.default.createElement(
	                _Grid.Row,
	                {
	                  style: {
	                    marginLeft: "0px",
	                    paddingTop: "2px",
	                    paddingLeft: "0px"
	                  },
	                  className: "no-margin-bottom no-padding-bottom no-padding-right"
	                },
	                _react2.default.createElement(
	                  _Grid.Col,
	                  {
	                    xs: "9",
	                    md: "9",
	                    sm: "9",
	                    lg: "9",
	                    className: "no-padding-right",
	                    style: { overflow: "hidden" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { style: { float: "left" } },
	                    name,
	                    "\xA0\xA0\xA0"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      onMouseOver: _this8.onConfirmBtnMouseOver.bind(_this8),
	                      style: {
	                        marginTop: "-10px",
	                        overflow: "hidden",
	                        borderBottom: "1px gray dashed"
	                      }
	                    },
	                    "\xA0"
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Col,
	                  {
	                    xs: "2",
	                    md: "2",
	                    sm: "2",
	                    lg: "2",
	                    className: "text-right no-padding-right no-padding-left",
	                    style: { overflow: "hidden" },
	                    onMouseOver: _this8.onConfirmBtnMouseOver.bind(_this8)
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        marginTop: "-10px",
	                        overflow: "hidden",
	                        borderBottom: "1px gray dashed"
	                      }
	                    },
	                    "\xA0\xA0\xA0"
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Col,
	                  {
	                    xs: "1",
	                    md: "1",
	                    sm: "1",
	                    lg: "1",
	                    style: { paddingLeft: "15px" }
	                  },
	                  _this8.removeAttrValBtn(605)
	                )
	              ),
	              key: cat.id + "-605"
	            },
	            auto_mm_attr_cols
	          ));
	        }
	
	        var cat_col = [_react2.default.createElement(
	          _Grid.FullRow,
	          { className: "no-padding-bottom no-margin-bottom  no-padding-top no-margin-top" },
	          _react2.default.createElement(
	            "h4",
	            { style: { marginBottom: "0px" } },
	            cat.name
	          )
	        ), _react2.default.createElement(
	          _rcTree2.default,
	          {
	            showIcon: false,
	            selectable: false,
	            showLine: false,
	            checkable: false,
	            defaultExpandAll: false,
	            onMouseEnter: function onMouseEnter(info) {
	              _this8.displayAttrAudience(info, categories, selectedAttrs);
	            },
	            onMouseLeave: _this8.onMouseLeave.bind(_this8)
	          },
	          attrs
	        )];
	
	        if (attrs.length > 0) {
	          display_categories.push(cat_col);
	        }
	      });
	
	      var sltAttrCount = 0;
	      if (selectedAttrs) sltAttrCount += selectedAttrs.length;
	      if (!(0, _lodash.isEmpty)(plottedRadius)) sltAttrCount += 1;
	      sltAttrCount += selected_state.length;
	      sltAttrCount += selected_city.length;
	      if (selected_county) sltAttrCount += selected_county.length;
	      if (selected_dma) sltAttrCount += selected_dma.length;
	      sltAttrCount += zipcode.length;
	      return _react2.default.createElement(
	        "div",
	        {
	          className: this.props.listMode === true ? "pl-10 pr-20 selected-values-container" : "pl-20 pr-20 selected-values-container"
	        },
	        !this.props.listMode && _react2.default.createElement(
	          _Grid.FullRow,
	          {
	            style: {
	              marginBottom: "-20px",
	              display: hideTitle === true ? "none" : "inherited"
	            }
	          },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Client: ",
	            this.props.selected_client_name
	          ),
	          _react2.default.createElement(
	            "h3",
	            null,
	            "You have added ",
	            sltAttrCount,
	            " Attributes to this segment"
	          ),
	          _react2.default.createElement("hr", null)
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "panel panel-flat no-border no-shadow no-border-radius no-margin-bottom font-1em",
	            style: {
	              maxHeight: "300px",
	              height: "300px",
	              overflowX: "hidden",
	              overflowY: "auto",
	              backgroundColor: "transparent"
	            }
	          },
	          _react2.default.createElement(
	            _materialUi.Popover,
	            {
	              open: this.state.removeValConfirm,
	              anchorEl: this.state.anchorEl,
	              anchorOrigin: { horizontal: "right", vertical: "top" },
	              targetOrigin: { horizontal: "left", vertical: "center" },
	              onRequestClose: this.handleRemoveValConfirm.bind(this),
	              style: { marginLeft: "10px" }
	            },
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "text-default" },
	              "Are you sure you want to remove",
	              _react2.default.createElement("br", null),
	              "this attribute?",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "a",
	                {
	                  style: { marginRight: "15px", marginLeft: "-15px" },
	                  className: "btn btn-link btn-sm text-teal-400 ",
	                  onClick: function onClick(e) {
	                    _this8.handleRemoveValConfirm();
	                  }
	                },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-aa-default btn-default btn-round btn-sm bg-grey text-white ",
	                  onClick: function onClick(e) {
	                    _this8.removeSelectVal();
	                    _this8.handleRemoveValConfirm();
	                  }
	                },
	                "Yes, remove"
	              )
	            )
	          ),
	          this.display_geography(),
	          this.plotted_radius_row(),
	          display_categories
	        )
	      );
	    }
	  }]);
	
	  return SelectedAttrs;
	}(_react.Component);
	
	SelectedAttrs.propTypes = {
	  removeAttribute: _react.PropTypes.func
	};
	SelectedAttrs.defaultProps = {
	  selected_dma: [],
	  selected_county: []
	};
	exports.default = SelectedAttrs;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1443);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @property data {array} data sources.
	 * [{label: 'Info', value: 12322}]
	 * @property hiddenMiddleBorder {boolean} if hidden middle border
	 */
	var SubscriptionList = function (_Component) {
	  _inherits(SubscriptionList, _Component);
	
	  function SubscriptionList() {
	    _classCallCheck(this, SubscriptionList);
	
	    return _possibleConstructorReturn(this, (SubscriptionList.__proto__ || Object.getPrototypeOf(SubscriptionList)).apply(this, arguments));
	  }
	
	  _createClass(SubscriptionList, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'ul',
	        { className: 'subscription-list clearfix ' + (this.props.hiddenMiddleBorder && 'hidden-border') },
	        Array.isArray(this.props.data) && this.props.data.map(function (item, index) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clearfix', key: index },
	            _react2.default.createElement(
	              'strong',
	              { className: 'pull-left' },
	              item.label
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'pull-right' },
	              item.value
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return SubscriptionList;
	}(_react.Component);
	
	exports.default = SubscriptionList;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _search = __webpack_require__(155);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	__webpack_require__(1444);
	
	__webpack_require__(599);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//css
	
	
	/**
	 * @property handleSearch {funciton} the seach button be clicked callback
	 * @property placeholder {string}
	 */
	var SearchBar = function (_Component) {
	  _inherits(SearchBar, _Component);
	
	  function SearchBar(props) {
	    _classCallCheck(this, SearchBar);
	
	    var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));
	
	    _this.state = {
	      optionsArr: [],
	      selectedItemLabel: '', // selected label string.
	      disabledAllClientsOption: true
	    };
	    return _this;
	  }
	
	  _createClass(SearchBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.clients !== nextProps.clients) {
	        this.initializeClientList(this.state.disabledAllClientsOption, nextProps.clients);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.clients) this.initializeClientList(this.state.disabledAllClientsOption, this.props.clients);
	    }
	  }, {
	    key: 'initializeClientList',
	    value: function initializeClientList(disabledAllClientsOption, clients) {
	      disabledAllClientsOption = true;
	      var clientsList = [];
	      if (clients) {
	        var sortedClients = (0, _lodash.sortBy)(clients, function (c) {
	          return c.name.toLowerCase();
	        });
	
	        if (clients.length === 1 && clients[0].id <= 1) {
	          clientsList = (0, _lodash.remove)(clientsList, function (c) {
	            return c.id !== 0;
	          });
	        }
	        sortedClients.forEach(function (item) {
	          if (item.id > 1) {
	            clientsList.push({ id: item.id, name: item.name });
	            if (!(0, _lodash.isEmpty)(item.businessUnits)) {
	              var sortedSubClients = (0, _lodash.sortBy)(item.businessUnits, function (c) {
	                return c.name.toLowerCase();
	              });
	              sortedSubClients.forEach(function (sc) {
	                clientsList.push({ id: sc.id, name: '      ' + sc.name });
	              });
	            }
	            //}
	          }
	        });
	      }
	      this.setState({
	        optionsArr: clientsList,
	        clientAdminMode: this.props.roleId > 1 && this.props.roleId < 10,
	        businessUserMode: this.props.roleId > 50,
	        businessAdminMode: this.props.roleId === 51
	      });
	      if (disabledAllClientsOption === true && parseInt(this.props.selected_client, 10) === 0 && clientsList.length > 1 || this.props.roleId > 50 && parseInt(this.props.selected_client, 10) === 0) {
	        if (clientsList.length > 1) {
	          this.setState({ optionVal: clientsList[1].id });
	          this.props.selectClient(clientsList[1].id);
	        }
	      }
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch() {
	      this.props.handleSearch(this.state.selectedItemLabel);
	    }
	  }, {
	    key: 'handleOnChange',
	    value: function handleOnChange(selectedItem) {
	      if (selectedItem === null) {
	        this.setState({
	          selectedItemLabel: ''
	        });
	      } else {
	        this.setState({
	          selectedItemLabel: selectedItem.value
	        });
	      }
	    }
	  }, {
	    key: 'optionRenderer',
	    value: function optionRenderer(option) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        option.label
	      );
	    }
	  }, {
	    key: 'filterOption',
	    value: function filterOption(option, filterString) {
	      if ((0, _lodash.isEmpty)(filterString)) return option;
	      //if ((option.value === '0') || (option.value.indexOf('r-') >= 0))
	      //  return option
	      if (option.label.toLowerCase().indexOf(filterString.toLowerCase()) >= 0) return option;
	
	      var clients = this.props.clients;
	
	      var sltClients = (0, _lodash.filter)(clients, function (c) {
	        return c.name.toLowerCase().indexOf(filterString) >= 0 && !(0, _lodash.isEmpty)(c.businessUnits);
	      });
	      var hit = false;
	      sltClients.forEach(function (c) {
	        if ((0, _lodash.findIndex)(c.businessUnits, function (item) {
	          return item.id.toString() === option.value;
	        }) >= 0) {
	          hit = true;
	          return;
	        }
	      });
	      if (hit) return option;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var clientOptions = [];
	      this.state.optionsArr.forEach(function (item, index) {
	        clientOptions.push({ value: item.id.toString(), label: item.name });
	      });
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'subscription-typeahead clearfix' },
	          _react2.default.createElement(
	            'span',
	            { className: 's' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'type-ahead-container' },
	            _react2.default.createElement(_reactSelect2.default, {
	              name: '',
	              placeholder: this.props.placeholder,
	              value: this.state.selectedItemLabel,
	              clearable: false,
	              options: clientOptions,
	              optionRenderer: function optionRenderer(val) {
	                return _this2.optionRenderer(val);
	              },
	              onChange: function onChange(val) {
	                return _this2.handleOnChange(val);
	              },
	              filterOption: this.filterOption.bind(this)
	            })
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this2.handleSearch();
	              }, style: { cursor: 'pointer' } },
	            _react2.default.createElement(_search2.default, {
	              style: { color: 'white' }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SearchBar;
	}(_react.Component);
	
	exports.default = SearchBar;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author chargoyao
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property placeholder {string} placeholder string
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property inputContainerStyle {object} input container element styles
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property placeholderStyle {object} placeholder container style
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property iconStyle {object} arrow icon style
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property options {array} options data array. in this array, label property is required.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property initValue {number}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property rootStyles {obj} root element styles
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * {lable: 'xxxxx', ......}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	// css
	
	
	var CustomSelect = function (_Component) {
	  _inherits(CustomSelect, _Component);
	
	  function CustomSelect(props) {
	    _classCallCheck(this, CustomSelect);
	
	    var _this = _possibleConstructorReturn(this, (CustomSelect.__proto__ || Object.getPrototypeOf(CustomSelect)).call(this, props));
	
	    _this.state = {
	      ifMenuShow: false,
	      ifShowPlaceholder: true,
	      optionText: '',
	      searchText: ''
	    };
	    _this.throttle = true;
	    return _this;
	  }
	
	  _createClass(CustomSelect, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      document.addEventListener('click', function () {
	        _this2.clearMenu();
	      }, false);
	      this.props.options.forEach(function (item) {
	        item.options.forEach(function (opt) {
	          if (opt.value === _this2.props.initValue) {
	            _this2.setState({
	              optionText: opt.label,
	              ifShowPlaceholder: false
	            });
	          }
	        });
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      nextProps.options.forEach(function (item) {
	        item.options.forEach(function (opt) {
	          if (opt.value === nextProps.initValue) {
	            _this3.setState({
	              optionText: opt.label,
	              ifShowPlaceholder: false
	            });
	          }
	        });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this4 = this;
	
	      document.removeEventListener('click', function () {
	        _this4.clearMenu();
	      }, false);
	    }
	  }, {
	    key: 'clearMenu',
	    value: function clearMenu() {
	      this.setState({
	        ifMenuShow: false
	      });
	    }
	  }, {
	    key: 'handleSelectControl',
	    value: function handleSelectControl(e) {
	      e.nativeEvent.stopImmediatePropagation();
	      this.setState({
	        ifMenuShow: true
	      });
	      this.refs.customInput.focus();
	    }
	  }, {
	    key: 'handleSelectItem',
	    value: function handleSelectItem(e, opt) {
	      var _this5 = this;
	
	      e.nativeEvent.stopImmediatePropagation();
	      this.setState({
	        ifShowPlaceholder: false,
	        optionText: opt.label,
	        ifMenuShow: false,
	        searchText: '' // clear active
	      }, function () {
	        _this5.refs.customInput.value = '';
	      });
	      this.props.onChange(opt);
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp() {
	      var _this6 = this;
	
	      this.setState({
	        ifShowPlaceholder: false,
	        optionText: '',
	        searchText: this.refs.customInput.value
	      }, function () {
	        _this6.getPosition();
	      });
	    }
	  }, {
	    key: 'getPosition',
	    value: function getPosition() {
	      var obj = [];
	      for (var i = 0; i < this.props.options.length; i++) {
	        if (this.refs['searchList' + i].className === 'active') {
	          obj.push(i);
	        }
	      }
	      if (obj.length > 0) {
	        for (var _i = 0; _i <= obj[0]; _i++) {
	          if (_i === 0) {
	            this.refs.selectMenu.scrollTop = 0;
	          } else {
	            this.refs.selectMenu.scrollTop += this.refs['searchList' + (_i - 1)].clientHeight;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'custom-select', style: this.props.rootStyles },
	        _react2.default.createElement(
	          'div',
	          { className: 'custom-select-control', style: Object.assign({}, this.props.inputContainerStyle), onClick: function onClick(e) {
	              return _this7.handleSelectControl(e);
	            } },
	          this.state.ifShowPlaceholder && _react2.default.createElement(
	            'div',
	            { className: 'custom-select-placeholder', style: this.props.placeholderStyle },
	            this.props.placeholder
	          ),
	          !this.state.ifShowPlaceholder && _react2.default.createElement(
	            'div',
	            { className: 'custom-select-text' },
	            this.state.optionText
	          ),
	          _react2.default.createElement('input', { type: 'text', className: 'custom-input', ref: 'customInput', onKeyUp: function onKeyUp() {
	              return _this7.handleKeyUp();
	            } }),
	          _react2.default.createElement(
	            'span',
	            { className: 'Select-arrow-zone pull-right' },
	            _react2.default.createElement('span', { className: 'Select-arrow' })
	          )
	        ),
	        this.state.ifMenuShow && _react2.default.createElement(
	          'ul',
	          { className: 'custom-select-menu', ref: 'selectMenu' },
	          this.props.options.map(function (item, index) {
	            return _react2.default.createElement(
	              'li',
	              { key: index, className: _this7.state.searchText !== '' && new RegExp(_this7.state.searchText, "gi").test(item.label) ? 'active' : '', ref: 'searchList' + index },
	              _react2.default.createElement(
	                'h3',
	                null,
	                item.label
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'custom-sub-options' },
	                item.options.map(function (opt) {
	                  return _react2.default.createElement(
	                    'section',
	                    { key: opt.value, onClick: function onClick(e) {
	                        return _this7.handleSelectItem(e, opt);
	                      } },
	                    opt.label
	                  );
	                })
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return CustomSelect;
	}(_react.Component);
	
	exports.default = CustomSelect;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLanguageGroup = exports.parseSegment = exports.attr2Rules = exports.getAttributeInfo = exports.parseZipcode = exports.parsePlottedValues = undefined;
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isFunction = __webpack_require__(28);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var google = window.google;
	
	var parsePlottedValues = exports.parsePlottedValues = function parsePlottedValues(plottedValues) {
	  var obj = {
	    attributeId: 91,
	    values: {
	      operator: "plotted_polygon",
	      values: ""
	    }
	  };
	  var value = null;
	  switch (plottedValues.type) {
	    case "rectangle":
	      var aNorth = null;
	      var aEast = null;
	      var aSouth = null;
	      var aWest = null;
	      if (plottedValues.bounds && typeof plottedValues.bounds.getNorthEast !== "undefined") {
	        var nePoint = plottedValues.bounds.getNorthEast();
	        var swPoint = plottedValues.bounds.getSouthWest();
	        aNorth = nePoint.lat();
	        aEast = nePoint.lng();
	        aSouth = swPoint.lat();
	        aWest = swPoint.lng();
	      } else {
	        aNorth = plottedValues.bounds.north;
	        aEast = plottedValues.bounds.east;
	        aSouth = plottedValues.bounds.south;
	        aWest = plottedValues.bounds.west;
	      }
	
	      value = {
	        coordinates: [[aWest, aNorth], [aEast, aNorth], [aEast, aSouth], [aWest, aSouth], [aWest, aNorth]]
	      };
	
	      obj.values.operator = "plotted_square";
	      obj.values.values = JSON.stringify(value);
	      break;
	    case "circle":
	      obj.values.operator = "plotted_radius";
	      value = {
	        lat: (0, _isFunction2.default)(plottedValues.center.lat) ? plottedValues.center.lat() : plottedValues.center.lat,
	        lng: (0, _isFunction2.default)(plottedValues.center.lng) ? plottedValues.center.lng() : plottedValues.center.lng,
	        radius: plottedValues.radius
	      };
	      obj.values.values = JSON.stringify(value);
	      break;
	    case "polygon":
	      var path = typeof plottedValues.path === "string" ? google.maps.geometry.encoding.decodePath(plottedValues.path) : plottedValues.path;
	      var arrPoints = [];
	      for (var i = 0; i < path.length; i++) {
	        var _path = (0, _isFunction2.default)(path.getAt) ? [path.getAt(i).lng(), path.getAt(i).lat()] : [path[i].lng(), path[i].lat()];
	        arrPoints.push(_path);
	      }
	      if ((0, _isFunction2.default)(path.getAt)) arrPoints.push([path.getAt(0).lng(), path.getAt(0).lat()]);else arrPoints.push([path[0].lng(), path[0].lat()]);
	      value = {
	        coordinates: arrPoints
	      };
	      obj.values.operator = "plotted_polygon";
	      obj.values.values = JSON.stringify(value);
	      break;
	    case "address_radius":
	      obj.attributeId = 90;
	      obj.values.operator = "plotted_radius";
	      value = {
	        lat: plottedValues.center.lat,
	        lng: plottedValues.center.lng,
	        radius: plottedValues.radius
	      };
	      obj.values.values = JSON.stringify(value);
	      break;
	    case "address_drive":
	      obj.attributeId = 90;
	      obj.values.operator = "drive_time";
	      obj.values.operator = "plotted_radius";
	      value = {
	        lat: plottedValues.center.lat,
	        lng: plottedValues.center.lng,
	        radius: plottedValues.driveRadius
	      };
	      obj.values.values = JSON.stringify(value);
	      break;
	    default:
	      obj = null;
	      break;
	  }
	
	  return obj;
	};
	
	var parseZipcode = exports.parseZipcode = function parseZipcode(data, segmentName) {
	  var newSegment = {
	    segment: {
	      name: segmentName,
	      status: "Active",
	      clientId: data.selected_client,
	      createdUserId: 1,
	      rawData: ""
	    },
	    rules: []
	  };
	  var rawData = {
	    name: segmentName,
	    selected_segments: null,
	    plotted_values: null,
	    selected_city: null,
	    selected_state: null,
	    selected_county: null,
	    selected_dma: null,
	    zipcode: null
	  };
	  var zipcode = data.zipcode,
	      rules_id = data.rules_id;
	
	  rawData.zipcode = zipcode;
	
	  if (zipcode && zipcode.length > 0) {
	    var zipcodeObj = {
	      attributeId: 7,
	      values: {
	        operator: "matches",
	        values: ""
	      }
	    };
	    if (rules_id.length > 0) {
	      rules_id.forEach(function (item) {
	        if (item.attributeId === 7) {
	          zipcodeObj.id = item.id;
	        }
	      });
	    }
	    var zipcodeValues = [];
	    (0, _map2.default)(zipcode, function (item) {
	      zipcodeValues.push(item.zipcode);
	    });
	    zipcodeObj.values.values = zipcodeValues.join();
	    newSegment.rules.push(zipcodeObj);
	  }
	
	  newSegment.segment.rawData = JSON.stringify(rawData);
	
	  return newSegment;
	};
	
	var getAttributeInfo = exports.getAttributeInfo = function getAttributeInfo(id, demoAttributes) {
	  var result = null;
	  (0, _map2.default)(demoAttributes, function (cat, key) {
	    (0, _map2.default)(cat.attributes, function (attr) {
	      if (attr.id === id) {
	        result = attr;
	        return;
	      }
	
	      (0, _map2.default)(attr.subAttributes, function (subAttr) {
	        if (subAttr.id === id) {
	          result = subAttr;
	          return;
	        }
	      });
	    });
	  });
	
	  return result;
	};
	
	var attr2Rules = exports.attr2Rules = function attr2Rules(selected_segments, demoAttributes, rules_id) {
	  var result = [];
	  (0, _map2.default)(demoAttributes, function (cat) {
	    (0, _map2.default)(cat.attributes, function (attr) {
	      var attrObj = {
	        attributeId: attr.id,
	        values: {
	          operator: "matches",
	          values: ""
	        }
	      };
	      if (rules_id.length > 0) {
	        rules_id.forEach(function (item) {
	          if (item.attributeId === attr.id) {
	            attrObj.id = item.id;
	          }
	        });
	      }
	      var attrVals = [];
	      var attrParents = [];
	      (0, _map2.default)(attr.values, function (val) {
	        if (selected_segments.indexOf(val.id) >= 0) {
	          if (attr.id === 606) {
	            //auto model
	            var labels = val.label.split(" - ");
	            if (labels.length === 2) {
	              attrParents.push(labels[0].toUpperCase());
	            }
	          }
	          attrVals.push(val.value);
	        }
	      });
	      (0, _map2.default)(attr.subAttributes, function (sub_attr) {
	        var subAttrObj = {
	          attributeId: sub_attr.id,
	          //parentId: sub_attr.parentId,
	          values: {
	            operator: "matches",
	            values: ""
	          }
	        };
	        if (rules_id.length > 0) {
	          rules_id.forEach(function (item) {
	            if (item.attributeId === sub_attr.id) {
	              subAttrObj.id = item.id;
	            }
	          });
	        }
	        var subAttrVals = [];
	        (0, _map2.default)(sub_attr.values, function (val) {
	          if (selected_segments.indexOf(val.id) >= 0) subAttrVals.push(val.value);
	        });
	        if (subAttrVals.length > 0) {
	          subAttrObj.values.values = subAttrVals.join();
	          //newSegment.rules.push(subAttrObj)
	          result.push(subAttrObj);
	        }
	      });
	      if (attrVals.length > 0) {
	        if (attr.id === 606) {
	          attrObj.values["parents"] = attrParents;
	        }
	        attrObj.values.values = attrVals.join();
	        //newSegment.rules.push(attrObj)
	        result.push(attrObj);
	      }
	    });
	  });
	  return result;
	};
	var parseSegment = exports.parseSegment = function parseSegment(data, segmentName, state_plotted_values) {
	  var newSegment = {
	    segment: {
	      name: segmentName,
	      status: "Active",
	      clientId: data.selected_client,
	      createdUserId: 1,
	      rawData: "",
	      targetHouseholdsOnly: Boolean(data.targetHouseholdsOnly)
	    },
	    rules: []
	  };
	  var rawData = {
	    name: segmentName,
	    selected_segments: null,
	    plotted_values: null,
	    selected_city: null,
	    selected_state: null,
	    selected_dma: null,
	    selected_county: null,
	    zipcode: null
	  };
	  var selected_segments = data.selected_segments,
	      demoAttributes = data.demoAttributes,
	      plotted_values = data.plotted_values,
	      selected_state = data.selected_state,
	      selected_city = data.selected_city,
	      selected_dma = data.selected_dma,
	      selected_county = data.selected_county,
	      zipcode = data.zipcode,
	      rules_id = data.rules_id;
	
	  var plottedValues = state_plotted_values ? state_plotted_values : plotted_values;
	  rawData.selected_segments = selected_segments;
	  rawData.plotted_values = plotted_values;
	  rawData.selected_city = selected_city;
	  rawData.selected_state = !(0, _isEmpty2.default)(selected_county) || !(0, _isEmpty2.default)(selected_dma) ? [] : selected_state;
	  rawData.selected_county = selected_county;
	  rawData.selected_dma = selected_dma;
	  rawData.zipcode = zipcode;
	  /*
	  map(demoAttributes, (cat) => {
	  map(cat.attributes, (attr) => {
	  	const attrObj = {
	  		attributeId: attr.id,
	  		values: {
	  			operator: "matches",
	  			values: ""
	  		}
	  	}
	  	if (rules_id.length > 0) {
	  		rules_id.forEach((item) => {
	  			if (item.attributeId === attr.id) {
	  				attrObj.id = item.id
	  			}
	  		})
	  	}
	  	let attrVals = []
	  	map(attr.values, (val) => {
	  		if (selected_segments.indexOf(val.id) >= 0)
	  			attrVals.push(val.value)
	  	})
	  	map(attr.subAttributes, (sub_attr) => {
	  		const subAttrObj = {
	  			attributeId: sub_attr.id,
	  			values: {
	  				operator: "matches",
	  				values: ""
	  			}
	  		}
	  		if (rules_id.length > 0) {
	  			rules_id.forEach((item) => {
	  				if (item.attributeId === sub_attr.id) {
	  					subAttrObj.id = item.id
	  				}
	  			})
	  		}
	  		let subAttrVals = []
	  		map(sub_attr.values, (val) => {
	  			if (selected_segments.indexOf(val.id) >= 0)
	  				subAttrVals.push(val.value)
	  		})
	  		if (subAttrVals.length > 0) {
	  			subAttrObj.values.values = subAttrVals.join()
	  			newSegment.rules.push(subAttrObj)
	  		}
	  	})
	  	if (attrVals.length > 0) {
	  		attrObj.values.values = attrVals.join()
	  		newSegment.rules.push(attrObj)
	  	}
	  })
	  })*/
	  newSegment.rules = attr2Rules(selected_segments, demoAttributes, rules_id);
	
	  if (selected_state && selected_state.length > 0 && (0, _isEmpty2.default)(selected_county) && (0, _isEmpty2.default)(selected_dma)) {
	    var stateObj = {
	      attributeId: 1,
	      values: {
	        operator: "matches",
	        values: ""
	      }
	    };
	    if (rules_id.length > 0) {
	      rules_id.forEach(function (item) {
	        if (item.attributeId === 1) {
	          stateObj.id = item.id;
	        }
	      });
	    }
	    var stateValues = [];
	    (0, _map2.default)(selected_state, function (state) {
	      stateValues.push(state.value);
	    });
	    stateObj.values.values = stateValues.join();
	    newSegment.rules.push(stateObj);
	  }
	
	  if (selected_county && selected_county.length > 0) {
	    var countyObj = {
	      attributeId: 2,
	      values: {
	        operator: "matches",
	        values: ""
	      }
	    };
	    if (rules_id.length > 0) {
	      rules_id.forEach(function (item) {
	        if (item.attributeId === 2) {
	          countyObj.id = item.id;
	        }
	      });
	    }
	    var countyValues = [];
	    (0, _map2.default)(selected_county, function (county) {
	      countyValues.push(county.value);
	    });
	    countyObj.values.values = countyValues.join();
	    newSegment.rules.push(countyObj);
	  }
	
	  if (selected_city && selected_city.length > 0) {
	    var cityObj = {
	      attributeId: 3,
	      values: {
	        operator: "matches",
	        values: "",
	        parents: []
	      }
	    };
	    if (rules_id.length > 0) {
	      rules_id.forEach(function (item) {
	        if (item.attributeId === 3) {
	          cityObj.id = item.id;
	        }
	      });
	    }
	    var cityValues = [];
	    var states = [];
	    (0, _map2.default)(selected_city, function (city) {
	      cityValues.push(city.value);
	      states.push(city.state);
	    });
	    cityObj.values.values = cityValues.join();
	    cityObj.values.parents = states;
	    newSegment.rules.push(cityObj);
	  }
	
	  if (selected_dma && selected_dma.length > 0) {
	    var dmaObj = {
	      attributeId: 4,
	      values: {
	        operator: "matches",
	        values: ""
	      }
	    };
	    if (rules_id.length > 0) {
	      rules_id.forEach(function (item) {
	        if (item.attributeId === 4) {
	          dmaObj.id = item.id;
	        }
	      });
	    }
	    var dmaValues = [];
	    (0, _map2.default)(selected_dma, function (dma) {
	      dmaValues.push(dma.value);
	    });
	    dmaObj.values.values = dmaValues.join();
	    newSegment.rules.push(dmaObj);
	  }
	  if (zipcode && zipcode.length > 0) {
	    var zipcodeObj = {
	      attributeId: 7,
	      values: {
	        operator: "matches",
	        values: ""
	      }
	    };
	    if (rules_id.length > 0) {
	      rules_id.forEach(function (item) {
	        if (item.attributeId === 7) {
	          zipcodeObj.id = item.id;
	        }
	      });
	    }
	    var zipcodeValues = [];
	    (0, _map2.default)(zipcode, function (item) {
	      zipcodeValues.push(item.zipcode);
	    });
	    zipcodeObj.values.values = zipcodeValues.join();
	    newSegment.rules.push(zipcodeObj);
	  }
	  if (plottedValues) {
	    var obj = parsePlottedValues(plottedValues);
	    if (obj) newSegment.rules.push(obj);
	  }
	  if (rawData.plotted_values && rawData.plotted_values.type === "polygon") {
	    rawData.plotted_values.path = rawData.plotted_values.encode_path;
	  }
	  newSegment.segment.rawData = JSON.stringify(rawData); //JSON.stringify(rawData)
	
	  if (data.segment_id !== "") {
	    newSegment.segment.id = data.segment_id;
	  }
	
	  if (newSegment.rules.length === 1 && newSegment.rules[0] == null) newSegment.rules = [];
	
	  return newSegment;
	};
	
	var getLanguageGroup = exports.getLanguageGroup = function getLanguageGroup(val) {
	  if (val.indexOf("HL") >= 0) {
	    return "Hispanic Language Usage";
	  }
	  if (val.indexOf("AL_CN") >= 0) {
	    return "Chinese Language Usage";
	  }
	  if (val.indexOf("AL_IN") >= 0) {
	    return "Indic Language Usage";
	  }
	  if (val.indexOf("AL_JP") >= 0) {
	    return "Japanese Language Usage";
	  }
	  if (val.indexOf("AL_VN") >= 0) {
	    return "Vietnamese Language Usage";
	  }
	  if (val.indexOf("AL_KR") >= 0) {
	    return "Korean Language Usage";
	  }
	  if (val.indexOf("HA") >= 0) {
	    return "Hispanicity";
	  }
	  if (val.indexOf("AA") >= 0) {
	    return "Asianicity";
	  }
	
	  return val;
	};

/***/ },
/* 262 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 263 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 264 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(1274)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(555)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 266 */
[3152, 173],
/* 267 */
136,
/* 268 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 269 */
124,
/* 270 */
124,
/* 271 */
124,
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(3135);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(3141);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ForeignObjectRenderer = __webpack_require__(616);
	
	var testRangeBounds = function testRangeBounds(document) {
	    var TEST_HEIGHT = 123;
	
	    if (document.createRange) {
	        var range = document.createRange();
	        if (range.getBoundingClientRect) {
	            var testElement = document.createElement('boundtest');
	            testElement.style.height = TEST_HEIGHT + 'px';
	            testElement.style.display = 'block';
	            document.body.appendChild(testElement);
	
	            range.selectNode(testElement);
	            var rangeBounds = range.getBoundingClientRect();
	            var rangeHeight = Math.round(rangeBounds.height);
	            document.body.removeChild(testElement);
	            if (rangeHeight === TEST_HEIGHT) {
	                return true;
	            }
	        }
	    }
	
	    return false;
	};
	
	// iOS 10.3 taints canvas with base64 images unless crossOrigin = 'anonymous'
	var testBase64 = function testBase64(document, src) {
	    var img = new Image();
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	
	    return new Promise(function (resolve) {
	        // Single pixel base64 image renders fine on iOS 10.3???
	        img.src = src;
	
	        var onload = function onload() {
	            try {
	                ctx.drawImage(img, 0, 0);
	                canvas.toDataURL();
	            } catch (e) {
	                return resolve(false);
	            }
	
	            return resolve(true);
	        };
	
	        img.onload = onload;
	        img.onerror = function () {
	            return resolve(false);
	        };
	
	        if (img.complete === true) {
	            setTimeout(function () {
	                onload();
	            }, 500);
	        }
	    });
	};
	
	var testCORS = function testCORS() {
	    return typeof new Image().crossOrigin !== 'undefined';
	};
	
	var testResponseType = function testResponseType() {
	    return typeof new XMLHttpRequest().responseType === 'string';
	};
	
	var testSVG = function testSVG(document) {
	    var img = new Image();
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    img.src = 'data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\'></svg>';
	
	    try {
	        ctx.drawImage(img, 0, 0);
	        canvas.toDataURL();
	    } catch (e) {
	        return false;
	    }
	    return true;
	};
	
	var isGreenPixel = function isGreenPixel(data) {
	    return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
	};
	
	var testForeignObject = function testForeignObject(document) {
	    var canvas = document.createElement('canvas');
	    var size = 100;
	    canvas.width = size;
	    canvas.height = size;
	    var ctx = canvas.getContext('2d');
	    ctx.fillStyle = 'rgb(0, 255, 0)';
	    ctx.fillRect(0, 0, size, size);
	
	    var img = new Image();
	    var greenImageSrc = canvas.toDataURL();
	    img.src = greenImageSrc;
	    var svg = (0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, img);
	    ctx.fillStyle = 'red';
	    ctx.fillRect(0, 0, size, size);
	
	    return (0, _ForeignObjectRenderer.loadSerializedSVG)(svg).then(function (img) {
	        ctx.drawImage(img, 0, 0);
	        var data = ctx.getImageData(0, 0, size, size).data;
	        ctx.fillStyle = 'red';
	        ctx.fillRect(0, 0, size, size);
	
	        var node = document.createElement('div');
	        node.style.backgroundImage = 'url(' + greenImageSrc + ')';
	        node.style.height = size + 'px';
	        // Firefox 55 does not render inline <img /> tags
	        return isGreenPixel(data) ? (0, _ForeignObjectRenderer.loadSerializedSVG)((0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, node)) : Promise.reject(false);
	    }).then(function (img) {
	        ctx.drawImage(img, 0, 0);
	        // Edge does not render background-images
	        return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
	    }).catch(function (e) {
	        return false;
	    });
	};
	
	var FEATURES = {
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_RANGE_BOUNDS() {
	        'use strict';
	
	        var value = testRangeBounds(document);
	        Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_SVG_DRAWING() {
	        'use strict';
	
	        var value = testSVG(document);
	        Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_BASE64_DRAWING() {
	        'use strict';
	
	        return function (src) {
	            var _value = testBase64(document, src);
	            Object.defineProperty(FEATURES, 'SUPPORT_BASE64_DRAWING', { value: function value() {
	                    return _value;
	                } });
	            return _value;
	        };
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_FOREIGNOBJECT_DRAWING() {
	        'use strict';
	
	        var value = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
	        Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_CORS_IMAGES() {
	        'use strict';
	
	        var value = testCORS();
	        Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_RESPONSE_TYPE() {
	        'use strict';
	
	        var value = testResponseType();
	        Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_CORS_XHR() {
	        'use strict';
	
	        var value = 'withCredentials' in new XMLHttpRequest();
	        Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
	        return value;
	    }
	};
	
	exports.default = FEATURES;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _textTransform = __webpack_require__(614);
	
	var _TextBounds = __webpack_require__(609);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextContainer = function () {
	    function TextContainer(text, parent, bounds) {
	        _classCallCheck(this, TextContainer);
	
	        this.text = text;
	        this.parent = parent;
	        this.bounds = bounds;
	    }
	
	    _createClass(TextContainer, null, [{
	        key: 'fromTextNode',
	        value: function fromTextNode(node, parent) {
	            var text = transform(node.data, parent.style.textTransform);
	            return new TextContainer(text, parent, (0, _TextBounds.parseTextBounds)(text, parent, node));
	        }
	    }]);
	
	    return TextContainer;
	}();
	
	exports.default = TextContainer;
	
	
	var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
	
	var transform = function transform(text, _transform) {
	    switch (_transform) {
	        case _textTransform.TEXT_TRANSFORM.LOWERCASE:
	            return text.toLowerCase();
	        case _textTransform.TEXT_TRANSFORM.CAPITALIZE:
	            return text.replace(CAPITALIZE, capitalize);
	        case _textTransform.TEXT_TRANSFORM.UPPERCASE:
	            return text.toUpperCase();
	        default:
	            return text;
	    }
	};
	
	function capitalize(m, p1, p2) {
	    if (m.length > 0) {
	        return p1 + p2.toUpperCase();
	    }
	
	    return m;
	}

/***/ },
/* 275 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var PATH = exports.PATH = {
	    VECTOR: 0,
	    BEZIER_CURVE: 1,
	    CIRCLE: 2
	};

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Path = __webpack_require__(275);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Vector = function Vector(x, y) {
	    _classCallCheck(this, Vector);
	
	    this.type = _Path.PATH.VECTOR;
	    this.x = x;
	    this.y = y;
	    if (false) {
	        if (isNaN(x)) {
	            console.error('Invalid x value given for Vector');
	        }
	        if (isNaN(y)) {
	            console.error('Invalid y value given for Vector');
	        }
	    }
	};
	
	exports.default = Vector;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseListStyle = exports.parseListStyleType = exports.LIST_STYLE_TYPE = exports.LIST_STYLE_POSITION = undefined;
	
	var _background = __webpack_require__(225);
	
	var LIST_STYLE_POSITION = exports.LIST_STYLE_POSITION = {
	    INSIDE: 0,
	    OUTSIDE: 1
	};
	
	var LIST_STYLE_TYPE = exports.LIST_STYLE_TYPE = {
	    NONE: -1,
	    DISC: 0,
	    CIRCLE: 1,
	    SQUARE: 2,
	    DECIMAL: 3,
	    CJK_DECIMAL: 4,
	    DECIMAL_LEADING_ZERO: 5,
	    LOWER_ROMAN: 6,
	    UPPER_ROMAN: 7,
	    LOWER_GREEK: 8,
	    LOWER_ALPHA: 9,
	    UPPER_ALPHA: 10,
	    ARABIC_INDIC: 11,
	    ARMENIAN: 12,
	    BENGALI: 13,
	    CAMBODIAN: 14,
	    CJK_EARTHLY_BRANCH: 15,
	    CJK_HEAVENLY_STEM: 16,
	    CJK_IDEOGRAPHIC: 17,
	    DEVANAGARI: 18,
	    ETHIOPIC_NUMERIC: 19,
	    GEORGIAN: 20,
	    GUJARATI: 21,
	    GURMUKHI: 22,
	    HEBREW: 22,
	    HIRAGANA: 23,
	    HIRAGANA_IROHA: 24,
	    JAPANESE_FORMAL: 25,
	    JAPANESE_INFORMAL: 26,
	    KANNADA: 27,
	    KATAKANA: 28,
	    KATAKANA_IROHA: 29,
	    KHMER: 30,
	    KOREAN_HANGUL_FORMAL: 31,
	    KOREAN_HANJA_FORMAL: 32,
	    KOREAN_HANJA_INFORMAL: 33,
	    LAO: 34,
	    LOWER_ARMENIAN: 35,
	    MALAYALAM: 36,
	    MONGOLIAN: 37,
	    MYANMAR: 38,
	    ORIYA: 39,
	    PERSIAN: 40,
	    SIMP_CHINESE_FORMAL: 41,
	    SIMP_CHINESE_INFORMAL: 42,
	    TAMIL: 43,
	    TELUGU: 44,
	    THAI: 45,
	    TIBETAN: 46,
	    TRAD_CHINESE_FORMAL: 47,
	    TRAD_CHINESE_INFORMAL: 48,
	    UPPER_ARMENIAN: 49,
	    DISCLOSURE_OPEN: 50,
	    DISCLOSURE_CLOSED: 51
	};
	
	var parseListStyleType = exports.parseListStyleType = function parseListStyleType(type) {
	    switch (type) {
	        case 'disc':
	            return LIST_STYLE_TYPE.DISC;
	        case 'circle':
	            return LIST_STYLE_TYPE.CIRCLE;
	        case 'square':
	            return LIST_STYLE_TYPE.SQUARE;
	        case 'decimal':
	            return LIST_STYLE_TYPE.DECIMAL;
	        case 'cjk-decimal':
	            return LIST_STYLE_TYPE.CJK_DECIMAL;
	        case 'decimal-leading-zero':
	            return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
	        case 'lower-roman':
	            return LIST_STYLE_TYPE.LOWER_ROMAN;
	        case 'upper-roman':
	            return LIST_STYLE_TYPE.UPPER_ROMAN;
	        case 'lower-greek':
	            return LIST_STYLE_TYPE.LOWER_GREEK;
	        case 'lower-alpha':
	            return LIST_STYLE_TYPE.LOWER_ALPHA;
	        case 'upper-alpha':
	            return LIST_STYLE_TYPE.UPPER_ALPHA;
	        case 'arabic-indic':
	            return LIST_STYLE_TYPE.ARABIC_INDIC;
	        case 'armenian':
	            return LIST_STYLE_TYPE.ARMENIAN;
	        case 'bengali':
	            return LIST_STYLE_TYPE.BENGALI;
	        case 'cambodian':
	            return LIST_STYLE_TYPE.CAMBODIAN;
	        case 'cjk-earthly-branch':
	            return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
	        case 'cjk-heavenly-stem':
	            return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
	        case 'cjk-ideographic':
	            return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
	        case 'devanagari':
	            return LIST_STYLE_TYPE.DEVANAGARI;
	        case 'ethiopic-numeric':
	            return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
	        case 'georgian':
	            return LIST_STYLE_TYPE.GEORGIAN;
	        case 'gujarati':
	            return LIST_STYLE_TYPE.GUJARATI;
	        case 'gurmukhi':
	            return LIST_STYLE_TYPE.GURMUKHI;
	        case 'hebrew':
	            return LIST_STYLE_TYPE.HEBREW;
	        case 'hiragana':
	            return LIST_STYLE_TYPE.HIRAGANA;
	        case 'hiragana-iroha':
	            return LIST_STYLE_TYPE.HIRAGANA_IROHA;
	        case 'japanese-formal':
	            return LIST_STYLE_TYPE.JAPANESE_FORMAL;
	        case 'japanese-informal':
	            return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
	        case 'kannada':
	            return LIST_STYLE_TYPE.KANNADA;
	        case 'katakana':
	            return LIST_STYLE_TYPE.KATAKANA;
	        case 'katakana-iroha':
	            return LIST_STYLE_TYPE.KATAKANA_IROHA;
	        case 'khmer':
	            return LIST_STYLE_TYPE.KHMER;
	        case 'korean-hangul-formal':
	            return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
	        case 'korean-hanja-formal':
	            return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
	        case 'korean-hanja-informal':
	            return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
	        case 'lao':
	            return LIST_STYLE_TYPE.LAO;
	        case 'lower-armenian':
	            return LIST_STYLE_TYPE.LOWER_ARMENIAN;
	        case 'malayalam':
	            return LIST_STYLE_TYPE.MALAYALAM;
	        case 'mongolian':
	            return LIST_STYLE_TYPE.MONGOLIAN;
	        case 'myanmar':
	            return LIST_STYLE_TYPE.MYANMAR;
	        case 'oriya':
	            return LIST_STYLE_TYPE.ORIYA;
	        case 'persian':
	            return LIST_STYLE_TYPE.PERSIAN;
	        case 'simp-chinese-formal':
	            return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
	        case 'simp-chinese-informal':
	            return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
	        case 'tamil':
	            return LIST_STYLE_TYPE.TAMIL;
	        case 'telugu':
	            return LIST_STYLE_TYPE.TELUGU;
	        case 'thai':
	            return LIST_STYLE_TYPE.THAI;
	        case 'tibetan':
	            return LIST_STYLE_TYPE.TIBETAN;
	        case 'trad-chinese-formal':
	            return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
	        case 'trad-chinese-informal':
	            return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
	        case 'upper-armenian':
	            return LIST_STYLE_TYPE.UPPER_ARMENIAN;
	        case 'disclosure-open':
	            return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
	        case 'disclosure-closed':
	            return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
	        case 'none':
	        default:
	            return LIST_STYLE_TYPE.NONE;
	    }
	};
	
	var parseListStyle = exports.parseListStyle = function parseListStyle(style) {
	    var listStyleImage = (0, _background.parseBackgroundImage)(style.getPropertyValue('list-style-image'));
	    return {
	        listStyleType: parseListStyleType(style.getPropertyValue('list-style-type')),
	        listStyleImage: listStyleImage.length ? listStyleImage[0] : null,
	        listStylePosition: parseListStylePosition(style.getPropertyValue('list-style-position'))
	    };
	};
	
	var parseListStylePosition = function parseListStylePosition(position) {
	    switch (position) {
	        case 'inside':
	            return LIST_STYLE_POSITION.INSIDE;
	        case 'outside':
	        default:
	            return LIST_STYLE_POSITION.OUTSIDE;
	    }
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1603),
	    listCacheDelete = __webpack_require__(1604),
	    listCacheGet = __webpack_require__(1605),
	    listCacheHas = __webpack_require__(1606),
	    listCacheSet = __webpack_require__(1607);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(402),
	    setCacheAdd = __webpack_require__(1619),
	    setCacheHas = __webpack_require__(1620);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 280 */
[3179, 278, 1622, 1623, 1624, 1625, 1626],
/* 281 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 282 */
[3183, 226, 184],
/* 283 */
[3184, 184],
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(187);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(181),
	    toKey = __webpack_require__(183);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 286 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(180),
	    arrayMap = __webpack_require__(144),
	    isArray = __webpack_require__(29),
	    isSymbol = __webpack_require__(187);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 288 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 289 */
[3201, 1601],
/* 290 */
[3222, 149],
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(650);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)(module)))

/***/ },
/* 292 */
[3234, 106, 81],
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(294);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(105),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(105),
	    isArray = __webpack_require__(29),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 296 */
[3235, 1549, 147, 291],
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(629),
	    baseKeysIn = __webpack_require__(1550),
	    isArrayLike = __webpack_require__(106);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 298 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 299 */
[3238, 1529, 145, 60, 1561, 29],
/* 300 */
[3240, 679],
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(406);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(60),
	    baseUniq = __webpack_require__(406);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toArray2 = __webpack_require__(358);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(163);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(428);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(421);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _menuUtils = __webpack_require__(1700);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var desktop = props.desktop,
	      maxHeight = props.maxHeight,
	      width = props.width;
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div because the List scales x faster than it scales y
	      zIndex: muiTheme.zIndex.menu,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    selectedMenuItem: {
	      color: muiTheme.menuItem.selectedTextColor
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu(props, context) {
	    (0, _classCallCheck3.default)(this, Menu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);
	
	    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
	      props.onMenuItemFocusChange(null, newFocusIndex);
	    }
	    _this.state = {
	      focusIndex: newFocusIndex,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var selectedIndex = void 0;
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	
	      if (this.props.multiple !== true) {
	        selectedIndex = this.getLastSelectedIndex(nextProps, filteredChildren);
	      } else {
	        selectedIndex = this.state.focusIndex;
	      }
	
	      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
	        this.props.onMenuItemFocusChange(null, newFocusIndex);
	      }
	      this.setState({
	        focusIndex: newFocusIndex,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var childIsDisabled = child.props.disabled;
	
	      var selectedChildStyles = {};
	      if (!childIsDisabled) {
	        var selected = this.isChildSelected(child, this.props);
	
	        if (selected) {
	          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
	        }
	      }
	      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);
	
	      var extraProps = {
	        desktop: this.props.desktop,
	        style: mergedChildStyles
	      };
	      if (!childIsDisabled) {
	        var isFocused = childIndex === this.state.focusIndex;
	        var focusState = 'none';
	        if (isFocused) {
	          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	        }
	
	        (0, _simpleAssign2.default)(extraProps, {
	          focusState: focusState,
	          onClick: function onClick(event) {
	            _this2.handleMenuItemTouchTap(event, child, index);
	            if (child.props.onClick) child.props.onClick(event);
	          },
	          ref: isFocused ? 'focusedMenuItem' : null
	        });
	      }
	      return _react2.default.cloneElement(child, extraProps);
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex(event) {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getLastSelectedIndex',
	    value: function getLastSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(event, keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(event, foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(event, focusIndex, false);
	
	      if (multiple) {
	        menuValue = menuValue || [];
	
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = menuValue,
	            _menuValue2 = (0, _toArray3.default)(_menuValue),
	            newMenuValue = _menuValue2.slice(0);
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
	      if (this.props.onMenuItemFocusChange) {
	        // Do this even if `newIndex === this.state.focusIndex` to allow users
	        // to detect up-arrow on the first MenuItem or down-arrow on the last.
	        this.props.onMenuItemFocusChange(event, newIndex);
	      }
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'cancelScrollEvent',
	    value: function cancelScrollEvent(event) {
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          desktop = _props.desktop,
	          disableAutoFocus = _props.disableAutoFocus,
	          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          multiple = _props.multiple,
	          onItemTouchTap = _props.onItemTouchTap,
	          onEscKeyDown = _props.onEscKeyDown,
	          onMenuItemFocusChange = _props.onMenuItemFocusChange,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          menuItemStyle = _props.menuItemStyle,
	          style = _props.style,
	          value = _props.value,
	          valueLink = _props.valueLink,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemTouchTap', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var filteredChildren = this.getFilteredChildren(children);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsDisabled = child.props.disabled;
	        var childName = child.type ? child.type.muiName : '';
	        var newChild = child;
	
	        switch (childName) {
	          case 'MenuItem':
	            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	            break;
	
	          case 'Divider':
	            newChild = _react2.default.cloneElement(child, {
	              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
	            });
	            break;
	        }
	
	        if (childName === 'MenuItem' && !childIsDisabled) {
	          menuItemIndex++;
	        }
	
	        return newChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            onWheel: this.handleOnWheel,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer',
	            role: 'presentation'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            (0, _extends3.default)({}, other, {
	              ref: 'list',
	              style: mergedListStyles,
	              role: 'menu'
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    var focusIndex = _this5.state.focusIndex;
	
	    if (focusIndex < 0) {
	      return;
	    }
	
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var focusedItem = filteredChildren[focusIndex];
	    if (focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
	      return;
	    }
	
	    _this5.setFocusIndex(event, -1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex(event);
	        } else {
	          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex(event);
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(event, hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	
	  this.handleOnWheel = function (event) {
	    var scrollContainer = _this5.refs.scrollContainer;
	    // Only scroll lock if the the Menu is scrollable.
	    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;
	
	    var scrollTop = scrollContainer.scrollTop,
	        scrollHeight = scrollContainer.scrollHeight,
	        clientHeight = scrollContainer.clientHeight;
	
	    var wheelDelta = event.deltaY;
	    var isDeltaPositive = wheelDelta > 0;
	
	    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	      scrollContainer.scrollTop = scrollHeight;
	      return _this5.cancelScrollEvent(event);
	    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	      scrollContainer.scrollTop = 0;
	      return _this5.cancelScrollEvent(event);
	    }
	  };
	};
	
	Menu.propTypes =  false ? {
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _propTypes2.default.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when the focus on a `MenuItem` is changed.
	   * There will be some "duplicate" changes reported if two different
	   * focusing event happen, for example if a `MenuItem` is focused via
	   * the keyboard and then it is clicked on.
	   *
	   * @param {object} event The event that triggered the focus change.
	   * The event can be null since the focus can be changed for non-event
	   * reasons such as prop changes.
	   * @param {number} newFocusIndex The index of the newly focused
	   * `MenuItem` or `-1` if focus was lost.
	   */
	  onMenuItemFocusChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _propTypes2.default.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _propTypes2.default.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes4.default.stringOrNumber
	} : {};
	exports.default = Menu;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(1704);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableRowColumn = context.muiTheme.tableRowColumn;
	
	
	  var styles = {
	    root: {
	      paddingLeft: tableRowColumn.spacing,
	      paddingRight: tableRowColumn.spacing,
	      height: tableRowColumn.height,
	      textAlign: 'left',
	      fontSize: 13,
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis'
	    }
	  };
	
	  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
	    styles.textAlign = 'right';
	  }
	
	  return styles;
	}
	
	var TableRowColumn = function (_Component) {
	  (0, _inherits3.default)(TableRowColumn, _Component);
	
	  function TableRowColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRowColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRowColumn.__proto__ || (0, _getPrototypeOf2.default)(TableRowColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _this.onMouseEnter = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onHover) {
	          _this.props.onHover(event, _this.props.columnNumber);
	        }
	      }
	    }, _this.onMouseLeave = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onHoverExit) {
	          _this.props.onHoverExit(event, _this.props.columnNumber);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRowColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onClick: this.onClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave
	      };
	
	      return _react2.default.createElement(
	        'td',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        children
	      );
	    }
	  }]);
	  return TableRowColumn;
	}(_react.Component);
	
	TableRowColumn.defaultProps = {
	  hoverable: false
	};
	TableRowColumn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableRowColumn.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _propTypes2.default.number,
	  /**
	   * @ignore
	   * If true, this column responds to hover events.
	   */
	  hoverable: _propTypes2.default.bool,
	  /** @ignore */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Callback function for hover exit event.
	   */
	  onHoverExit: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableRowColumn;

/***/ },
/* 306 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDone = function ActionDone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' })
	  );
	};
	ActionDone = (0, _pure2.default)(ActionDone);
	ActionDone.displayName = 'ActionDone';
	ActionDone.muiName = 'SvgIcon';
	
	exports.default = ActionDone;

/***/ },
/* 308 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(2705);
	exports.encode = exports.stringify = __webpack_require__(2706);


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2697)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = addEventListenerWrap;
	
	var _addDomEventListener = __webpack_require__(1043);
	
	var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function addEventListenerWrap(target, eventType, cb, option) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom2['default'].unstable_batchedUpdates ? function run(e) {
	    _reactDom2['default'].unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener2['default'])(target, eventType, callback, option);
	}
	module.exports = exports['default'];

/***/ },
/* 312 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * KeyCode
	 *
	 * Map of common (non-printable) keycodes for the `keydown` and `keyup` events.
	 * Note that `keypress` handles things differently and may not return the same
	 * values.
	 */
	module.exports = {
	  BACKSPACE: 8,
	  TAB: 9,
	  RETURN: 13,
	  ESC: 27,
	  SPACE: 32,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40
	};

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(589);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(1376);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactErrorUtils = __webpack_require__(447);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(34);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var EventPluginRegistry = __webpack_require__(443);
	var ReactEventEmitterMixin = __webpack_require__(2792);
	var ViewportMetrics = __webpack_require__(449);
	
	var getVendorPrefixedEventName = __webpack_require__(2824);
	var isEventSupported = __webpack_require__(454);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(199);
	var ViewportMetrics = __webpack_require__(449);
	
	var getEventModifierState = __webpack_require__(452);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(21);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 318 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(59);
	var DOMNamespaces = __webpack_require__(442);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(450);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(2923),
	    listCacheDelete = __webpack_require__(2924),
	    listCacheGet = __webpack_require__(2925),
	    listCacheHas = __webpack_require__(2926),
	    listCacheSet = __webpack_require__(2927);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 322 */
[3184, 330],
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(464),
	    isObject = __webpack_require__(128);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ },
/* 324 */
[3201, 2921],
/* 325 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 326 */
[3209, 91, 332],
/* 327 */
[3222, 159],
/* 328 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 329 */
[3229, 332],
/* 330 */
184,
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(128);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(246);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 333 */
[3236, 2868, 2885, 245],
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(200);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(860);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactInputAutosize = __webpack_require__(3023);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _defaultArrowRenderer = __webpack_require__(974);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(975);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(480);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(481);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Dropdown = __webpack_require__(3018);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Option = __webpack_require__(972);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _OptionGroup = __webpack_require__(3019);
	
	var _OptionGroup2 = _interopRequireDefault(_OptionGroup);
	
	var _Value = __webpack_require__(973);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               	Copyright (c) 2017 Jed Watson.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               	Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               	http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	
	function clone(obj) {
		var copy = {};
		for (var attr in obj) {
			if (obj.hasOwnProperty(attr)) {
				copy[attr] = obj[attr];
			};
		}
		return copy;
	}
	
	function isGroup(option) {
		return option && Array.isArray(option.options);
	}
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._flatOptions = this.flattenOptions(this.props.options);
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this._flatOptions = this.flattenOptions(nextProps.options);
				}
	
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (!nextProps.isOpen && this.props.isOpen) {
					this.closeMenu();
				} else if (nextProps.isOpen && !this.props.isOpen) {
					this.setState({ isOpen: true });
				}
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						event.preventDefault();
						if (!this.state.inputValue && this.props.deleteRemoves) {
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var _this2 = this;
	
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return _this2.expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = this.expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
	
			/**
	   * Retrieve a value from the given options and valueKey
	   * @param	{String|Number|Array}	value	- the selected value(s)
	   * @param	{Object}		props	- the Select component's props (or nextProps)
	   */
	
		}, {
			key: 'expandValue',
			value: function expandValue(value, props) {
				var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
				if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
				var labelKey = props.labelKey,
				    renderInvalidValues = props.renderInvalidValues,
				    valueKey = props.valueKey;
	
				var options = this._flatOptions;
				if (!options) return;
				for (var i = 0; i < options.length; i++) {
					if (String(options[i][valueKey]) === String(value)) return options[i];
				}
	
				// no matching option, return an invalid option if renderInvalidValues is enabled
				if (renderInvalidValues) {
					var _ref;
	
					this._invalidOptions = this._invalidOptions || {};
					this._invalidOptions[value] = this._invalidOptions[value] || (_ref = {
						invalid: true
					}, _defineProperty(_ref, labelKey, value), _defineProperty(_ref, valueKey, value), _ref);
					return this._invalidOptions[value];
				}
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this3 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this3.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this4 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this4.getValueArray(_this4.props.value);
						if (valueArray.some(function (i) {
							return i[_this4.props.valueKey] === value[_this4.props.valueKey];
						})) {
							_this4.removeValue(value);
						} else {
							_this4.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this4.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this5 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this5.props.valueKey] !== value[_this5.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this6 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this6.props.disabled || value.clearableValue === false,
								id: _this6._instancePrefix + '-value-' + i,
								instancePrefix: _this6._instancePrefix,
								key: 'value-' + i + '-' + value[_this6.props.valueKey],
								onClick: onClick,
								onRemove: _this6.removeValue,
								placeholder: _this6.props.placeholder,
								value: value
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this7 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					className: className,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this7.input = _ref2;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref3) {
							return _this7.input = _ref3;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap' },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterFlatOptions',
			value: function filterFlatOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var flatOptions = this._flatOptions;
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(flatOptions, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return flatOptions;
				}
			}
		}, {
			key: 'flattenOptions',
			value: function flattenOptions(options, group) {
				if (!options) return [];
				var flatOptions = [];
				for (var i = 0; i < options.length; i++) {
					// We clone each option with a pointer to its parent group for efficient unflattening
					var optionCopy = clone(options[i]);
					if (group) {
						optionCopy.group = group;
					}
					if (isGroup(optionCopy)) {
						flatOptions = flatOptions.concat(this.flattenOptions(optionCopy.options, optionCopy));
						optionCopy.options = [];
					} else {
						flatOptions.push(optionCopy);
					}
				}
				return flatOptions;
			}
		}, {
			key: 'unflattenOptions',
			value: function unflattenOptions(flatOptions) {
				var groupedOptions = [];
				var parent = void 0,
				    child = void 0;
	
				// Remove all ancestor groups from the tree
				flatOptions.forEach(function (option) {
					option.isInTree = false;
					parent = option.group;
					while (parent) {
						if (parent.isInTree) {
							parent.options = [];
							parent.isInTree = false;
						}
						parent = parent.group;
					}
				});
	
				// Now reconstruct the options tree
				flatOptions.forEach(function (option) {
					child = option;
					parent = child.group;
					while (parent) {
						if (!child.isInTree) {
							parent.options.push(child);
							child.isInTree = true;
						}
	
						child = parent;
						parent = child.group;
					}
					if (!child.isInTree) {
						groupedOptions.push(child);
						child.isInTree = true;
					}
				});
	
				// Remove the isInTree flag we added
				flatOptions.forEach(function (option) {
					delete option.isInTree;
				});
	
				return groupedOptions;
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionGroupComponent: this.props.optionGroupComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this8 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this8.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref4) {
							return _this8.value = _ref4;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this8.props.disabled,
						key: 'hidden.' + index,
						name: _this8.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this8.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this9 = this;
	
				var Dropdown = this.props.dropdownComponent;
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					Dropdown,
					null,
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.menuContainer = _ref6;
							}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
						_react2.default.createElement(
							'div',
							{
								className: 'Select-menu',
								id: this._instancePrefix + '-list',
								onMouseDown: this.handleMouseDownOnMenu,
								onScroll: this.handleMenuScroll,
								ref: function ref(_ref5) {
									return _this9.menu = _ref5;
								},
								role: 'listbox',
								style: this.props.menuStyle,
								tabIndex: -1
							},
							menu
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this10 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this._visibleOptions = this.filterFlatOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var options = this.unflattenOptions(this._visibleOptions);
				var isOpen = typeof this.props.isOpen === 'boolean' ? this.props.isOpen : this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = this._visibleOptions[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref8) {
							return _this10.wrapper = _ref8;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref7) {
								return _this10.control = _ref7;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // Aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // HTML ID of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // Create drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		dropdownComponent: _propTypes2.default.func, // dropdown component to render the menu in
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		isOpen: _propTypes2.default.bool, // whether the Select dropdown menu is open or not
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionGroupComponent: _propTypes2.default.func, // option group component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		renderInvalidValues: _propTypes2.default.bool, // boolean to enable rendering values that do not match any options
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: _propTypes2.default.string, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		dropdownComponent: _Dropdown2.default,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		optionGroupComponent: _OptionGroup2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(3027);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _defaultArrowRenderer = __webpack_require__(981);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(982);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(482);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(483);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(979);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(980);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = void 0;
	
	var _intersection2 = _interopRequireDefault(__webpack_require__(668));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection2.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	exports.getIntersectionKeys = getIntersectionKeys;
	
	var identity = function identity(param) {
	  return param;
	};
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	
	
	exports.identity = identity;
	
	var getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return "-".concat(v.toLowerCase());
	  });
	};
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	
	
	exports.getDashCase = getDashCase;
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, "".concat(IN_LINE_PREFIX_LIST[i], "$1"));
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;
	
	var log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	
	
	exports.log = log;
	
	var debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	    return item;
	  };
	};
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	
	
	exports.debug = debug;
	
	var debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(void 0, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
	    log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
	    return res;
	  };
	};
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	
	
	exports.debugf = debugf;
	
	var mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	
	
	exports.mapObject = mapObject;
	
	var translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _objectSpread({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	exports.translateStyle = translateStyle;
	
	var compose = function compose() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
	  }).join(',');
	};
	
	exports.getTransitionVal = getTransitionVal;
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(3041);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _position = __webpack_require__(3043);
	
	var _position2 = _interopRequireDefault(_position);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hoverDelay = 200;
	var touchToMouseOverDelay = 1000;
	
	var Tooltip = function (_React$Component) {
	  _inherits(Tooltip, _React$Component);
	
	  function Tooltip() {
	    _classCallCheck(this, Tooltip);
	
	    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this));
	
	    _this.state = { showTip: false, hasHover: false, ignoreShow: false };
	
	    _this.showTip = _this.showTip.bind(_this);
	    _this.hideTip = _this.hideTip.bind(_this);
	    _this.checkHover = _this.checkHover.bind(_this);
	    _this.cancelTip = _this.cancelTip.bind(_this);
	    _this.toggleTip = _this.toggleTip.bind(_this);
	    _this.startHover = _this.startHover.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: 'toggleTip',
	    value: function toggleTip() {
	      this.setState({ showTip: !this.state.showTip });
	    }
	  }, {
	    key: 'showTip',
	    value: function showTip() {
	      this.setState({ showTip: true });
	    }
	  }, {
	    key: 'hideTip',
	    value: function hideTip() {
	      this.setState({ hasHover: false });
	      this.setState({ showTip: false });
	    }
	  }, {
	    key: 'startHover',
	    value: function startHover() {
	      if (!this.state.ignoreShow) {
	        this.setState({ hasHover: true });
	
	        setTimeout(this.checkHover, hoverDelay);
	      }
	    }
	  }, {
	    key: 'checkHover',
	    value: function checkHover() {
	      if (this.state.hasHover) {
	        this.setState({ showTip: true });
	      }
	    }
	  }, {
	    key: 'cancelTip',
	    value: function cancelTip() {
	      var _this2 = this;
	
	      this.setState({ ignoreShow: true });
	
	      setTimeout(function () {
	        _this2.setState({ ignoreShow: false });
	      }, touchToMouseOverDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          direction = _props.direction,
	          className = _props.className,
	          color = _props.color,
	          background = _props.background,
	          padding = _props.padding,
	          children = _props.children,
	          content = _props.content,
	          styles = _props.styles,
	          eventOn = _props.eventOn,
	          eventOff = _props.eventOff,
	          eventToggle = _props.eventToggle,
	          useHover = _props.useHover;
	
	      var currentPositions = (0, _position2.default)(direction, this.tip, this.target, this.state, this.props);
	
	      var wrapperStyles = _extends({
	        position: 'relative'
	      }, styles);
	
	      var tipStyles = _extends({}, currentPositions.tip, {
	        background: background,
	        color: color,
	        padding: padding,
	        boxSizing: 'border-box',
	        zIndex: 1000,
	        position: 'absolute',
	        display: 'inline-block'
	      });
	
	      var arrowStyles = _extends({}, currentPositions.arrow, {
	        position: 'absolute',
	        width: '0px',
	        height: '0px',
	        zIndex: 1001
	      });
	
	      var props = {
	        style: wrapperStyles,
	        ref: function ref(target) {
	          _this3.target = target;
	        },
	        className: className
	      };
	
	      // event handling
	      if (eventOff) {
	        props[eventOff] = this.hideTip;
	      }
	
	      if (eventOn) {
	        props[eventOn] = this.showTip;
	      }
	
	      if (eventToggle) {
	        props[eventToggle] = this.toggleTip;
	
	        // only use hover if they don't have a toggle event
	      } else if (useHover) {
	        props.onMouseOver = this.startHover;
	        props.onMouseOut = this.hideTip;
	        props.onTouchStart = this.cancelTip;
	      }
	
	      return _react2.default.createElement(
	        this.props.tagName,
	        props,
	        children,
	        _react2.default.createElement(
	          _Portal2.default,
	          { className: className },
	          _react2.default.createElement(
	            'span',
	            { className: 'react-tooltip-lite', style: tipStyles, ref: function ref(tip) {
	                _this3.tip = tip;
	              } },
	            content
	          ),
	          _react2.default.createElement('span', { className: 'react-tooltip-lite-arrow react-tooltip-lite-' + currentPositions.realDirection + '-arrow', style: arrowStyles })
	        )
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react2.default.Component);
	
	Tooltip.propTypes = {
	  // eslint-disable-next-line react/no-unused-prop-types
	  tagName: _react.PropTypes.string,
	  direction: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  content: _react.PropTypes.node.isRequired,
	  background: _react.PropTypes.string,
	  color: _react.PropTypes.string,
	  padding: _react.PropTypes.string,
	  styles: _react.PropTypes.object,
	  eventOff: _react.PropTypes.string,
	  eventOn: _react.PropTypes.string,
	  eventToggle: _react.PropTypes.string,
	  useHover: _react.PropTypes.bool
	};
	Tooltip.defaultProps = {
	  tagName: 'div',
	  direction: 'up',
	  className: '',
	  background: '',
	  color: '',
	  padding: '10px',
	  styles: {},
	  useHover: true
	};
	exports.default = Tooltip;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ZAxis = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ZAxis, _Component);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ZAxis).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.Component), _class2.displayName = 'ZAxis', _class2.propTypes = {
	  type: _propTypes.default.oneOf(['number', 'category']),
	  // The name of data displayed in the axis
	  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  // The range of axis
	  range: _propTypes.default.arrayOf(_propTypes.default.number),
	  scale: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes.default.func])
	}, _class2.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto',
	  type: 'number'
	}, _temp)) || _class;
	
	var _default = ZAxis;
	exports.default = _default;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(302));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactSmooth = __webpack_require__(83);
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _DefaultTooltipContent = _interopRequireDefault(__webpack_require__(3074));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _DataUtils = __webpack_require__(40);
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CLS_PREFIX = 'recharts-tooltip-wrapper';
	var EPS = 1;
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.dataKey;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2.default)(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2.default)(option)) {
	    return (0, _uniqBy2.default)(payload, option);
	  }
	
	  return payload;
	};
	
	var propTypes = {
	  content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	  viewBox: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  }),
	  active: _propTypes.default.bool,
	  separator: _propTypes.default.string,
	  formatter: _propTypes.default.func,
	  offset: _propTypes.default.number,
	  itemStyle: _propTypes.default.object,
	  labelStyle: _propTypes.default.object,
	  wrapperStyle: _propTypes.default.object,
	  contentStyle: _propTypes.default.object,
	  cursor: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.element, _propTypes.default.object]),
	  coordinate: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  position: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  label: _propTypes.default.any,
	  payload: _propTypes.default.arrayOf(_propTypes.default.shape({
	    name: _propTypes.default.any,
	    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.array]),
	    unit: _propTypes.default.any,
	    type: _propTypes.default.oneOf(_ReactUtils.TOOLTIP_TYPES)
	  })),
	  paylodUniqBy: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
	  isAnimationActive: _propTypes.default.bool,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes.default.func,
	  filterNull: _propTypes.default.bool,
	  useTranslate3d: _propTypes.default.bool
	};
	var defaultProps = {
	  active: false,
	  offset: 10,
	  viewBox: {
	    x1: 0,
	    x2: 0,
	    y1: 0,
	    y2: 0
	  },
	  coordinate: {
	    x: 0,
	    y: 0
	  },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  filterNull: true,
	  useTranslate3d: false
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react.default.isValidElement(content)) {
	    return _react.default.cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2.default)(content)) {
	    return content(props);
	  }
	
	  return _react.default.createElement(_DefaultTooltipContent.default, props);
	};
	
	var Tooltip = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          isAnimationActive = _this$props.isAnimationActive,
	          animationDuration = _this$props.animationDuration,
	          animationEasing = _this$props.animationEasing,
	          filterNull = _this$props.filterNull,
	          paylodUniqBy = _this$props.paylodUniqBy;
	      var finalPayload = getUniqPaylod(paylodUniqBy, filterNull && payload && payload.length ? payload.filter(function (entry) {
	        return !(0, _isNil2.default)(entry.value);
	      }) : payload);
	      var hasPayload = finalPayload && finalPayload.length;
	      var _this$props2 = this.props,
	          content = _this$props2.content,
	          viewBox = _this$props2.viewBox,
	          coordinate = _this$props2.coordinate,
	          position = _this$props2.position,
	          active = _this$props2.active,
	          offset = _this$props2.offset,
	          wrapperStyle = _this$props2.wrapperStyle;
	
	      var outerStyle = _objectSpread({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	
	      var translateX, translateY;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _this$state2 = this.state,
	            boxWidth = _this$state2.boxWidth,
	            boxHeight = _this$state2.boxHeight;
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = position && (0, _DataUtils.isNumber)(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);
	          translateY = position && (0, _DataUtils.isNumber)(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _objectSpread({}, outerStyle, (0, _reactSmooth.translateStyle)({
	        transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
	      }));
	
	      if (isAnimationActive && active) {
	        outerStyle = _objectSpread({}, outerStyle, (0, _reactSmooth.translateStyle)({
	          transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
	        }));
	      }
	
	      var cls = (0, _classnames.default)(CLS_PREFIX, (_classNames = {}, _defineProperty(_classNames, "".concat(CLS_PREFIX, "-right"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-left"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-bottom"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-top"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY < coordinate.y), _classNames));
	      return _react.default.createElement("div", {
	        className: cls,
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: finalPayload
	      })));
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component), _class2.displayName = 'Tooltip', _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _temp)) || _class;
	
	var _default = Tooltip;
	exports.default = _default;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _Dot = _interopRequireDefault(__webpack_require__(162));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(344));
	
	var _Text = _interopRequireDefault(__webpack_require__(161));
	
	var _PolarUtils = __webpack_require__(93);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(PolarAngleAxis, _Component);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarAngleAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: "getTickLineCoord",
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          radius = _this$props.radius,
	          orientation = _this$props.orientation,
	          tickLine = _this$props.tickLine;
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
	      return {
	        x1: p1.x,
	        y1: p1.y,
	        x2: p2.x,
	        y2: p2.y
	      };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	      var cos = Math.cos(-data.coordinate * RADIAN);
	      var textAnchor;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          radius = _this$props2.radius,
	          axisLine = _this$props2.axisLine,
	          axisLineType = _this$props2.axisLineType;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react.default.createElement(_Dot.default, _extends({
	          className: "recharts-polar-angle-axis-line"
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	
	      var ticks = this.props.ticks;
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
	      });
	      return _react.default.createElement(_Polygon.default, _extends({
	        className: "recharts-polar-angle-axis-line"
	      }, props, {
	        points: points
	      }));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props3 = this.props,
	          ticks = _this$props3.ticks,
	          tick = _this$props3.tick,
	          tickLine = _this$props3.tickLine,
	          tickFormatter = _this$props3.tickFormatter,
	          stroke = _this$props3.stroke;
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this.getTickLineCoord(entry);
	
	        var textAnchor = _this.getTickTextAnchor(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i,
	          payload: entry,
	          x: lineCoord.x2,
	          y: lineCoord.y2
	        });
	
	        return _react.default.createElement(_Layer.default, _extends({
	          className: "recharts-polar-angle-axis-tick",
	          key: "tick-".concat(i)
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react.default.createElement("line", _extends({
	          className: "recharts-polar-angle-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-polar-angle-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          radius = _this$props4.radius,
	          axisLine = _this$props4.axisLine;
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-polar-angle-axis"
	      }, axisLine && this.renderAxisLine(), this.renderTicks());
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react.default.isValidElement(option)) {
	        tickItem = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react.default.createElement(_Text.default, _extends({}, props, {
	          className: "recharts-polar-angle-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.Component), _class2.displayName = 'PolarAngleAxis', _class2.axisType = 'angleAxis', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes.default.oneOf(['number', 'category']),
	  angleAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.func]),
	  cx: _propTypes.default.number,
	  cy: _propTypes.default.number,
	  radius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  hide: _propTypes.default.bool,
	  scale: _propTypes.default.oneOfType([_propTypes.default.oneOf(_ReactUtils.SCALE_TYPES), _propTypes.default.func]),
	  axisLine: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  axisLineType: _propTypes.default.oneOf(['polygon', 'circle']),
	  tickLine: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  tick: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.object, _propTypes.default.element]),
	  ticks: _propTypes.default.arrayOf(_propTypes.default.shape({
	    value: _propTypes.default.any,
	    coordinate: _propTypes.default.number
	  })),
	  stroke: _propTypes.default.string,
	  orientation: _propTypes.default.oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes.default.func,
	  allowDuplicatedCategory: _propTypes.default.bool
	}), _class2.defaultProps = {
	  type: 'category',
	  angleAxisId: 0,
	  scale: 'auto',
	  cx: 0,
	  cy: 0,
	  domain: [0, 'auto'],
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false,
	  allowDuplicatedCategory: true
	}, _temp)) || _class;
	
	var _default = PolarAngleAxis;
	exports.default = _default;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _minBy2 = _interopRequireDefault(__webpack_require__(1645));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(416));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Text = _interopRequireDefault(__webpack_require__(161));
	
	var _Label = _interopRequireDefault(__webpack_require__(129));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _PolarUtils = __webpack_require__(93);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarRadiusAxis = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(PolarRadiusAxis, _Component);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarRadiusAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: "getTickValueCoord",
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Number} coordinate The radius of tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var coordinate = _ref.coordinate;
	      var _this$props = this.props,
	          angle = _this$props.angle,
	          cx = _this$props.cx,
	          cy = _this$props.cy;
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, coordinate, angle);
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	
	        case 'right':
	          textAnchor = 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getViewBox",
	    value: function getViewBox() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          angle = _this$props2.angle,
	          ticks = _this$props2.ticks;
	      var maxRadiusTick = (0, _maxBy2.default)(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      var minRadiusTick = (0, _minBy2.default)(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      return {
	        cx: cx,
	        cy: cy,
	        startAngle: angle,
	        endAngle: angle,
	        innerRadius: minRadiusTick.coordinate || 0,
	        outerRadius: maxRadiusTick.coordinate || 0
	      };
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy,
	          angle = _this$props3.angle,
	          ticks = _this$props3.ticks,
	          axisLine = _this$props3.axisLine,
	          others = _objectWithoutProperties(_this$props3, ["cx", "cy", "angle", "ticks", "axisLine"]);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react.default.createElement("line", _extends({
	        className: "recharts-polar-radius-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          tick = _this$props4.tick,
	          angle = _this$props4.angle,
	          tickFormatter = _this$props4.tickFormatter,
	          stroke = _this$props4.stroke,
	          others = _objectWithoutProperties(_this$props4, ["ticks", "tick", "angle", "tickFormatter", "stroke"]);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var items = ticks.map(function (entry, i) {
	        var coord = _this.getTickValueCoord(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react.default.createElement(_Layer.default, _extends({
	          className: "recharts-polar-radius-axis-tick",
	          key: "tick-".concat(i)
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-polar-radius-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          ticks = _this$props5.ticks,
	          axisLine = _this$props5.axisLine,
	          tick = _this$props5.tick;
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-polar-radius-axis"
	      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), _Label.default.renderCallByParent(this.props, this.getViewBox()));
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react.default.isValidElement(option)) {
	        tickItem = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react.default.createElement(_Text.default, _extends({}, props, {
	          className: "recharts-polar-radius-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.Component), _class2.displayName = 'PolarRadiusAxis', _class2.axisType = 'radiusAxis', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes.default.oneOf(['number', 'category']),
	  cx: _propTypes.default.number,
	  cy: _propTypes.default.number,
	  hide: _propTypes.default.bool,
	  radiusAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  angle: _propTypes.default.number,
	  tickCount: _propTypes.default.number,
	  ticks: _propTypes.default.arrayOf(_propTypes.default.shape({
	    value: _propTypes.default.any,
	    coordinate: _propTypes.default.number
	  })),
	  orientation: _propTypes.default.oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  tick: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object, _propTypes.default.element, _propTypes.default.func]),
	  stroke: _propTypes.default.string,
	  tickFormatter: _propTypes.default.func,
	  domain: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes.default.func]),
	  allowDataOverflow: _propTypes.default.bool,
	  allowDuplicatedCategory: _propTypes.default.bool
	}), _class2.defaultProps = {
	  type: 'number',
	  radiusAxisId: 0,
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto',
	  allowDuplicatedCategory: true
	}, _temp)) || _class;
	
	var _default = PolarRadiusAxis;
	exports.default = _default;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Polygon, _Component);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Polygon).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          points = _this$props.points,
	          className = _this$props.className;
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames.default)('recharts-polygon', className);
	      return _react.default.createElement("polygon", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.Component), _class2.displayName = 'Polygon', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  points: _propTypes.default.arrayOf(_propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }))
	}), _temp)) || _class;
	
	var _default = Polygon;
	exports.default = _default;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _PolarUtils = __webpack_require__(93);
	
	var _DataUtils = __webpack_require__(40);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius,
	      cornerIsExternal = _ref.cornerIsExternal;
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	
	  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle
	
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line
	
	  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), lineTangencyAngle);
	  return {
	    center: center,
	    circleTangency: circleTangency,
	    lineTangency: lineTangency,
	    theta: theta
	  };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var angle = getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide
	
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
	  } else {
	    path += "L ".concat(cx, ",").concat(cy, " Z");
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      forceCornerRadius = _ref3.forceCornerRadius,
	      cornerIsExternal = _ref3.cornerIsExternal,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: startAngle,
	    sign: sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: endAngle,
	    sign: -sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    if (forceCornerRadius) {
	      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
	    }
	
	    return getSectorPath({
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	  }
	
	  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: startAngle,
	      sign: sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: endAngle,
	      sign: -sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
	    }
	
	    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
	  } else {
	    path += "L".concat(cx, ",").concat(cy, "Z");
	  }
	
	  return path;
	};
	
	var Sector = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Sector, _Component);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Sector).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          innerRadius = _this$props.innerRadius,
	          outerRadius = _this$props.outerRadius,
	          cornerRadius = _this$props.cornerRadius,
	          forceCornerRadius = _this$props.forceCornerRadius,
	          cornerIsExternal = _this$props.cornerIsExternal,
	          startAngle = _this$props.startAngle,
	          endAngle = _this$props.endAngle,
	          className = _this$props.className;
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames.default)('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          forceCornerRadius: forceCornerRadius,
	          cornerIsExternal: cornerIsExternal,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      }
	
	      return _react.default.createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.Component), _class2.displayName = 'Sector', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  cx: _propTypes.default.number,
	  cy: _propTypes.default.number,
	  innerRadius: _propTypes.default.number,
	  outerRadius: _propTypes.default.number,
	  startAngle: _propTypes.default.number,
	  endAngle: _propTypes.default.number,
	  cornerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  forceCornerRadius: _propTypes.default.bool,
	  cornerIsExternal: _propTypes.default.bool
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0,
	  forceCornerRadius: false,
	  cornerIsExternal: false
	}, _temp)) || _class;
	
	var _default = Sector;
	exports.default = _default;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = void 0;
	
	var _ReactUtils = __webpack_require__(25);
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return "".concat(value, "px");
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return _toConsumableArray(result).concat(['-', entry.toLowerCase()]);
	    }
	
	    return _toConsumableArray(result).concat([entry]);
	  }, []);
	  return formatStrs.join('');
	}
	
	var getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
	  }, '');
	};
	
	exports.getStyleString = getStyleString;
	
	var getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	
	  var str = "".concat(text);
	  var styleString = getStyleString(style);
	  var cacheKey = "".concat(str, "-").concat(styleString);
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
	    // https://en.wikipedia.org/wiki/Content_Security_Policy
	
	
	    var measurementSpanStyle = _objectSpread({}, SPAN_STYLE, style);
	
	    Object.keys(measurementSpanStyle).map(function (styleKey) {
	      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
	      return styleKey;
	    });
	    measurementSpan.textContent = str;
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = {
	      width: rect.width,
	      height: rect.height
	    };
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	};
	
	exports.getStringSize = getStringSize;
	
	var getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = {
	    top: 0,
	    left: 0
	  }; // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	
	
	exports.getOffset = getOffset;
	
	var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};
	
	exports.calculateChartCoordinate = calculateChartCoordinate;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(495)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 348 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(76).setDesc
	  , has = __webpack_require__(496)
	  , TAG = __webpack_require__(94)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(1019)
	  , defined = __webpack_require__(494);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveInsightsFileSetup = exports.clearInsightsFileSettingsSaveError = exports.setSettingsWebsiteId = exports.CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR = exports.SET_SETTINGS_WEBSITE_ID = exports.SAVE_INSIGHTS_FILE_SETUP = undefined;
	
	var _Api = __webpack_require__(45);
	
	var _helpers = __webpack_require__(95);
	
	var _Clients = __webpack_require__(49);
	
	var SAVE_INSIGHTS_FILE_SETUP = exports.SAVE_INSIGHTS_FILE_SETUP = "SAVE_INSIGHTS_FILE_SETUP";
	var SET_SETTINGS_WEBSITE_ID = exports.SET_SETTINGS_WEBSITE_ID = "SET_SETTINGS_WEBSITE_ID";
	var CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR = exports.CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR = "CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR";
	var setSettingsWebsiteId = exports.setSettingsWebsiteId = (0, _helpers.actionCreator)(SET_SETTINGS_WEBSITE_ID);
	var clearInsightsFileSettingsSaveError = exports.clearInsightsFileSettingsSaveError = (0, _helpers.actionCreator)(CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR);
	
	var saveInsightsFileSetup = exports.saveInsightsFileSetup = function saveInsightsFileSetup(client_id, tag_id, obj) {
	  return function (dispatch, getState) {
	    var url = "insights/" + tag_id + "/insights-file-setup";
	    (0, _Api.callApi)(dispatch, getState, SAVE_INSIGHTS_FILE_SETUP, url, {
	      method: "POST",
	      body: JSON.stringify(obj)
	    }, {
	      success: function success() {
	        dispatch((0, _Clients.getClientTags)(client_id));
	      }
	    });
	  };
	};

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(38);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	var _reactTooltipLite = __webpack_require__(339);
	
	var _reactTooltipLite2 = _interopRequireDefault(_reactTooltipLite);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _segment_util = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var showCodeTitle = ["PRIZM Premier", "P$YCLE", "P$YCLE Premier", "ConneXions", "IPA", "Net Worth"];
	
	var showGroupCodeTitle = ["Acculturation", "Language Segments"];
	
	var ValuePanel = function (_Component) {
	  _inherits(ValuePanel, _Component);
	
	  function ValuePanel(props) {
	    _classCallCheck(this, ValuePanel);
	
	    var _this = _possibleConstructorReturn(this, (ValuePanel.__proto__ || Object.getPrototypeOf(ValuePanel)).call(this, props));
	
	    _this.state = {
	      beSearchedId: undefined,
	      focusItemId: undefined
	    };
	    return _this;
	  }
	
	  _createClass(ValuePanel, [{
	    key: "handleSearchValueChange",
	    value: function handleSearchValueChange(selectedItem, datas) {
	      var _this2 = this;
	
	      if (selectedItem.length > 0) {
	        datas.forEach(function (item, index) {
	          if (item.id === selectedItem[0].id) {
	            _this2.setState({
	              beSearchedId: selectedItem[0].id
	            });
	            _this2.refs.valueList.scrollTop = index * 40;
	          }
	        });
	      }
	    }
	  }, {
	    key: "showGroupItems",
	    value: function showGroupItems(clsName, disabledAll) {
	      var _this3 = this;
	
	      var _props = this.props,
	          displayData = _props.displayData,
	          granularity = _props.granularity;
	
	      var renderItems = [];
	
	      (0, _map2.default)(displayData, function (data) {
	        if (data.value.endsWith("1")) {
	          renderItems.push(_react2.default.createElement(
	            "div",
	            {
	              key: "group_" + (0, _segment_util.getLanguageGroup)(data.value),
	              style: {
	                height: "40px",
	                paddingTop: "10px",
	                background: "rgb(232, 232, 232)",
	                marginLeft: "40px",
	                marginBottom: "20px",
	                marginRight: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              { style: { marginLeft: "40px" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Code"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { style: { marginLeft: "90px" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                (0, _segment_util.getLanguageGroup)(data.value)
	              )
	            )
	          ));
	        }
	        renderItems.push(_react2.default.createElement(
	          "div",
	          {
	            key: data.label + data.id + "_node",
	            style: { color: "#017FB5", cursor: "pointer" },
	            className: clsName,
	            onClick: function onClick() {
	              _this3.setState({
	                indexKey: data.id
	              });
	            },
	            onMouseOver: function onMouseOver() {
	              _this3.setState({ focusItemId: data.id });
	            }
	          },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            label: _react2.default.createElement(
	              "div",
	              { style: { display: "flex", paddingLeft: "30px" } },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "150px" } },
	                data.value
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { flexGrow: "1" } },
	                data.label,
	                _this3.state.focusItemId === data.id && _react2.default.createElement(
	                  "span",
	                  { className: "ml-10 black-border p-5" },
	                  granularity
	                )
	              )
	            ),
	            labelStyle: {
	              fontSize: "16px",
	              background: _this3.state.beSearchedId === data.id ? "#C3C3C3" : "#FFF"
	            },
	            iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	            checked: _this3.props.selected_segments.indexOf(data.id) >= 0 || disabledAll,
	            disabled: disabledAll,
	            onCheck: function onCheck(e, isInputChecked) {
	              _this3.props.onCheck(data.id, isInputChecked);
	            }
	          })
	        ));
	      });
	      return renderItems;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var clsName = "mt-10 ml-10 mr-10 p-10";
	      var disabledAll = this.props.disabledAll;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          key: this.props.key + "-value-node-contianer",
	          className: "light-grey-border"
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "pt-20 ml-20 mr-20 mb-20 pb-10 light-grey-bottom-border" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            this.props.title
	          )
	        ),
	        this.props.showFilter && _react2.default.createElement(
	          "div",
	          {
	            className: "ml-20 mr-20 mb-10 pb-15 light-grey-bottom-border",
	            style: { marginTop: "-5px" }
	          },
	          _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	            key: "value_panel_search_box",
	            labelKey: "label",
	            multiple: false,
	            options: this.props.displayData,
	            placeholder: "Search " + this.props.title,
	            onChange: function onChange(selectedItem) {
	              return _this4.handleSearchValueChange(selectedItem, _this4.props.displayData);
	            }
	          })
	        ),
	        showCodeTitle.indexOf(this.props.title) >= 0 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              height: "40px",
	              paddingTop: "10px",
	              background: "rgb(232, 232, 232)",
	              marginLeft: "40px",
	              marginBottom: "20px",
	              marginRight: "20px"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            { style: { marginLeft: "20px" } },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Segment"
	            )
	          ),
	          _react2.default.createElement(
	            "span",
	            { style: { marginLeft: "100px" } },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Segment Name"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              height: this.props.showFilter ? "390px" : "443px",
	              overflowY: "scroll"
	            },
	            ref: "valueList"
	          },
	          showGroupCodeTitle.indexOf(this.props.title) >= 0 ? this.showGroupItems(clsName, disabledAll) : (0, _map2.default)(this.props.displayData, function (data) {
	            return _react2.default.createElement(
	              "div",
	              {
	                key: data.label + data.id + "_node",
	                style: { color: "#017FB5", cursor: "pointer" },
	                className: clsName,
	                onClick: function onClick() {
	                  _this4.setState({
	                    indexKey: data.id
	                  });
	                },
	                onMouseOver: function onMouseOver() {
	                  _this4.setState({ focusItemId: data.id });
	                }
	              },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                label: showCodeTitle.indexOf(_this4.props.title) >= 0 ? _react2.default.createElement(
	                  "div",
	                  { style: { display: "flex", paddingLeft: "30px" } },
	                  _react2.default.createElement(
	                    "div",
	                    { style: { width: "150px" } },
	                    data.value
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    data.label,
	                    _this4.state.focusItemId === data.id && _this4.props.granularity && _react2.default.createElement(
	                      "span",
	                      { className: "ml-10 black-border p-5" },
	                      _this4.props.granularity
	                    )
	                  )
	                ) : _this4.state.focusItemId === data.id && _this4.props.granularity ? [_react2.default.createElement(
	                  "span",
	                  { key: data.label + "-" + data.id + "-span" },
	                  data.label
	                ), _react2.default.createElement(
	                  "span",
	                  {
	                    key: data.label + "-" + data.id + "-granularity",
	                    className: "ml-10 black-border p-5"
	                  },
	                  _this4.props.granularity
	                )] : data.label,
	                labelStyle: {
	                  fontSize: "16px",
	                  background: _this4.state.beSearchedId === data.id ? "#C3C3C3" : "#FFF"
	                },
	                iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	                checked: _this4.props.selected_segments.indexOf(data.id) >= 0 || disabledAll,
	                disabled: disabledAll,
	                onCheck: function onCheck(e, isInputChecked) {
	                  _this4.props.onCheck(data.id, isInputChecked);
	                }
	              })
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ValuePanel;
	}(_react.Component);
	
	exports.default = ValuePanel;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _lodash = __webpack_require__(18);
	
	var _recharts = __webpack_require__(101);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderActiveShape = function renderActiveShape(props) {
		var cx = props.cx,
		    cy = props.cy,
		    innerRadius = props.innerRadius,
		    outerRadius = props.outerRadius,
		    startAngle = props.startAngle,
		    endAngle = props.endAngle,
		    fill = props.fill;
	
		return _react2.default.createElement(
			'g',
			null,
			_react2.default.createElement(_recharts.Sector, {
				cx: cx,
				cy: cy,
				innerRadius: innerRadius,
				outerRadius: outerRadius,
				startAngle: startAngle,
				endAngle: endAngle,
				fill: fill
			}),
			_react2.default.createElement(_recharts.Sector, {
				cx: cx,
				cy: cy,
				startAngle: startAngle,
				endAngle: endAngle,
				innerRadius: outerRadius + 2,
				outerRadius: outerRadius + 10,
				fill: '#CCC'
			})
		);
	};
	
	var CustomizedTooltip = _react2.default.createClass({
		displayName: 'CustomizedTooltip',
		render: function render() {
			var _props = this.props,
			    stroke = _props.stroke,
			    value = _props.value,
			    fieldName = _props.fieldName;
	
			return _react2.default.createElement(
				'div',
				{ className: 'recharts-default-tootip no-margin pt-5 pl-10 pr-10 pb-5', style: { background: '#FFFCDC', border: "solid 1px #ccc" } },
				_react2.default.createElement('p', { className: 'recharts-tooltip-label no-margin' }),
				_react2.default.createElement(
					'ul',
					{ className: 'recharts-tooltip-item-list no-padding no-margin' },
					_react2.default.createElement(
						'li',
						{ className: 'recharts-tooltip-item',
							style: { display: "inline", paddingTop: "4px", paddingBottom: "4px", width: "100%", stroke: stroke } },
						_react2.default.createElement(
							'div',
							{ style: { width: "auto", height: "20px", display: "block", overflow: "overlap", whiteSpace: "nowrap", textOverflow: "unset" } },
							_react2.default.createElement('p', { className: 'recharts-tooltip-label no-margin', style: { stroke: stroke } }),
							fieldName,
							' ',
							_react2.default.createElement(
								'strong',
								null,
								'- ',
								(0, _utility.splitNumber)(value)()
							)
						)
					)
				)
			);
		}
	});
	
	var styles = {
		textOverflow: {
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}
	};
	
	var PieGraphicSection = function (_AcquireWebComponent) {
		_inherits(PieGraphicSection, _AcquireWebComponent);
	
		function PieGraphicSection(props) {
			_classCallCheck(this, PieGraphicSection);
	
			var _this = _possibleConstructorReturn(this, (PieGraphicSection.__proto__ || Object.getPrototypeOf(PieGraphicSection)).call(this, props));
	
			_this.state = { activeIndex: undefined };
			return _this;
		}
	
		_createClass(PieGraphicSection, [{
			key: 'onPieEnter',
			value: function onPieEnter(data, index) {
				this.setState({
					activeIndex: index,
					tooltip_name: data.payload.linkurl,
					tooltip_field_name: data.payload.linkurl,
					tooltip_value: data.payload.clicks,
					tooltip_stroke: data.payload.fill
				});
				var tooltips = _reactDom2.default.findDOMNode(this).getElementsByClassName('recharts-tooltip-wrapper');
				if (tooltips && tooltips.length > 0) {
					var el = tooltips[0];
					el.style['visibility'] = "visible";
					el.style['padding-bottom'] = '0px';
				}
			}
		}, {
			key: 'onPieLeave',
			value: function onPieLeave() {
				this.setState({
					activeIndex: -1
				});
				var tooltips = _reactDom2.default.findDOMNode(this).getElementsByClassName('recharts-tooltip-wrapper');
				if (tooltips && tooltips.length > 0) {
					var el = tooltips[0];
					el.style['visibility'] = "hidden";
				}
			}
		}, {
			key: 'render',
			value: function render() {
				//const COLORS = ['#050505', '#1C4456',  '#3888AB',  '#87B7CD',  '#AFCFDD'];
				var COLORS = ['#216E69', '#32A59D', '#56CBC4', '#99DFDD', '#BBEAE7'];
	
				var _props2 = this.props,
				    title = _props2.title,
				    data = _props2.data,
				    footer = _props2.footer,
				    subTitle = _props2.subTitle,
				    fieldDisplayFunc = _props2.fieldDisplayFunc;
	
				var sortedData = (0, _lodash.orderBy)(data, ['value'], ['desc']);
				var hideOverflowText = this.props.hideOverflow === true;
	
				var coloredData = {};
				(0, _lodash.map)(sortedData, function (data, index) {
					coloredData[data.linkurl] = COLORS[index % COLORS.length];
				});
				if ((0, _lodash.isEmpty)(data)) {
					return _react2.default.createElement(
						'div',
						{ style: { float: "left", width: "100%", position: "relative", fontSize: "16px" } },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '24px', lineHeight: '18px', fontWeight: 'bold' } },
							title
						),
						_react2.default.createElement(
							'div',
							{ style: { width: '100%', minHeight: '338px', textAlign: 'center', paddingTop: '160px', color: "#CDCDCD" } },
							_react2.default.createElement(
								'div',
								{ style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
								'No Data'
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ style: { float: "left", width: "100%", position: "relative", fontSize: "16px" } },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '24px', lineHeight: '18px', fontWeight: 'bold' } },
							title
						),
						_react2.default.createElement(
							'div',
							{ style: { width: '40%', marginTop: '-10px', minHeight: '200px', display: "block", position: "relative", float: "right" } },
							_react2.default.createElement(
								_recharts.ResponsiveContainer,
								{ width: '100%', height: '80%', minHeight: 250 },
								_react2.default.createElement(
									_recharts.PieChart,
									null,
									_react2.default.createElement(
										_recharts.Pie,
										{ onMouseLeave: this.onPieLeave.bind(this), onMouseEnter: this.onPieEnter.bind(this),
											activeShape: renderActiveShape, data: sortedData, fill: '#8884d8', activeIndex: this.state.activeIndex,
											dataKey: 'clicks', isAnimationActive: false },
										sortedData.map(function (entry, index) {
											return _react2.default.createElement(_recharts.Cell, { key: "graphic-cell-" + index, fill: COLORS[index % COLORS.length] });
										})
									),
									_react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(CustomizedTooltip, null), name: this.state.tooltip_name,
										value: this.state.tooltip_value, stroke: this.state.stroke,
										fieldName: this.state.tooltip_field_name })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'light-grey-border-bottom pb-10', style: { width: '60%', top: "10px", position: "relative", float: "left", marginBottom: '30px' } },
							subTitle && _react2.default.createElement(
								'div',
								{ className: 'text-right mt-10 mb-10', style: { color: subTitle === "&nbsp;" ? "#FFF" : "inherit", fontSize: "9pt" } },
								_react2.default.createElement(
									'strong',
									null,
									subTitle
								)
							),
							(0, _lodash.map)(data, function (obj, idx) {
								return _react2.default.createElement(
									'div',
									{ key: "list-" + idx, className: 'light-grey-border-top mt-15 pt-15', style: { height: "42px", display: "flex" } },
									_react2.default.createElement(
										'div',
										{ style: { flex: "0 0 20px", paddingTop: "3px" } },
										!(0, _lodash.isEmpty)(coloredData) && _react2.default.createElement(
											'span',
											{ className: 'span-legend', style: { background: coloredData[obj.linkurl] } },
											'\xA0'
										)
									),
									_react2.default.createElement(
										'div',
										{ style: hideOverflowText ? Object.assign({}, styles.textOverflow, { height: "24px", paddingRight: "10px", flex: "1 1" }) : { height: "18px", paddingRight: "10px", flex: "1 1 " } },
										_react2.default.createElement(
											'span',
											null,
											obj.linkurl
										)
									),
									_react2.default.createElement(
										'div',
										{ style: { flex: "0 0 40px", textAlign: "right" } },
										fieldDisplayFunc ? fieldDisplayFunc(obj) : obj.value
									)
								);
							})
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						sortedData.length === 5 && title === "DEMOGRAPHIC" && _react2.default.createElement(
							'div',
							{ className: 'mb-15' },
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null)
						),
						_react2.default.createElement(
							'div',
							{ className: 'list-chart-footer', style: { marginTop: "290px" } },
							footer ? footer : _react2.default.createElement('br', null)
						)
					);
				}
			}
		}]);
	
		return PieGraphicSection;
	}(_MaterialUI2.default);
	
	exports.default = PieGraphicSection;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  textOverflow: {
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    width: '88%'
	  }
	};
	
	var TopLocationSection = function (_AcquireWebComponent) {
	  _inherits(TopLocationSection, _AcquireWebComponent);
	
	  function TopLocationSection() {
	    _classCallCheck(this, TopLocationSection);
	
	    return _possibleConstructorReturn(this, (TopLocationSection.__proto__ || Object.getPrototypeOf(TopLocationSection)).apply(this, arguments));
	  }
	
	  _createClass(TopLocationSection, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          title = _props.title;
	
	      if ((0, _isEmpty2.default)(data)) {
	        return _react2.default.createElement(
	          'div',
	          { style: { float: "left", width: "100%", position: "relative" } },
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: '24px', lineHeight: '18px', fontWeight: 'bold' } },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { width: '100%', minHeight: '338px', textAlign: 'center', paddingTop: '160px', color: "#CDCDCD" } },
	            _react2.default.createElement(
	              'div',
	              { style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
	              'No Data'
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { style: { float: "left", width: "100%", position: "relative" } },
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: '24px', lineHeight: '18px', fontWeight: 'bold' } },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { width: '100%', minHeight: '318px', marginTop: "20px" } },
	            (0, _map2.default)(data, function (obj, idx) {
	              return _react2.default.createElement(
	                'div',
	                { key: "list-" + idx,
	                  className: idx + 1 === data.length ? "light-grey-border-top light-grey-border-bottom mt-10 pt-15" : "light-grey-border-top mt-10 pt-15",
	                  style: { height: idx + 1 === data.length ? "54px" : "40px" } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pull-left', style: styles.textOverflow },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    obj.link ? _react2.default.createElement(
	                      'a',
	                      { href: obj.link },
	                      obj.state
	                    ) : obj.state
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pull-right' },
	                  obj.opens ? (0, _utility.splitNumber)(obj.opens)() : (0, _utility.splitNumber)(obj.clicks)()
	                )
	              );
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return TopLocationSection;
	}(_MaterialUI2.default);
	
	TopLocationSection.propTypes = {
	  data: _propTypes2.default.array,
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = TopLocationSection;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsightNavigation = function (_AcquireWebComponent) {
		_inherits(InsightNavigation, _AcquireWebComponent);
	
		function InsightNavigation() {
			_classCallCheck(this, InsightNavigation);
	
			return _possibleConstructorReturn(this, (InsightNavigation.__proto__ || Object.getPrototypeOf(InsightNavigation)).apply(this, arguments));
		}
	
		_createClass(InsightNavigation, [{
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement('div', { className: 'page-navigation', style: { height: '0px' } });
			}
		}]);
	
		return InsightNavigation;
	}(_MaterialUI2.default);
	
	exports.default = InsightNavigation;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _utility = __webpack_require__(14);
	
	var _recharts = __webpack_require__(101);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomTooltip = function CustomTooltip(_ref) {
	  var active = _ref.active,
	      payload = _ref.payload,
	      label = _ref.label;
	
	  if (active) {
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "recharts-default-tootip no-margin pt-10 pl-20 pr-20 pb-15",
	        style: { background: "#000", border: "solid 1px #000", color: "#FFF" }
	      },
	      _react2.default.createElement("p", { className: "recharts-tooltip-label no-margin" }),
	      _react2.default.createElement(
	        "ul",
	        { className: "recharts-tooltip-item-list no-padding no-margin" },
	        _react2.default.createElement(
	          "li",
	          {
	            className: "recharts-tooltip-item",
	            style: {
	              display: "inline",
	              paddingTop: "4px",
	              paddingBottom: "4px",
	              width: "100%"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "auto",
	                height: "25px",
	                display: "block",
	                overflow: "overlap",
	                whiteSpace: "nowrap",
	                textOverflow: "unset"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "recharts-tooltip-label no-margin-left no-margin-top no-margin-right mb-5" },
	              payload[0].payload.key + " : " + (parseFloat(payload[0].payload.value) / parseFloat(payload[0].payload.total)).toLocaleString(undefined, {
	                style: "percent",
	                minimumFractionDigits: 2
	              })
	            )
	          )
	        )
	      )
	    );
	  }
	
	  return null;
	};
	
	var PieChartTable = function (_AcquireWebComponent) {
	  _inherits(PieChartTable, _AcquireWebComponent);
	
	  function PieChartTable(props) {
	    _classCallCheck(this, PieChartTable);
	
	    var _this = _possibleConstructorReturn(this, (PieChartTable.__proto__ || Object.getPrototypeOf(PieChartTable)).call(this, props));
	
	    _this.state = {
	      activeIndex: -1
	    };
	    return _this;
	  }
	
	  _createClass(PieChartTable, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          dataKey = _props.dataKey,
	          data = _props.data,
	          title = _props.title,
	          tableTitle = _props.tableTitle,
	          showUniqVisitsTitle = _props.showUniqVisitsTitle,
	          inLine = _props.inLine,
	          footer = _props.footer;
	
	      var sum = 0;
	      (0, _map2.default)(data, function (d) {
	        sum += d.value;
	      });
	      var processData = [];
	      (0, _map2.default)(data, function (d) {
	        processData.push({
	          key: d.key ? d.key : d.name,
	          value: d.value,
	          total: sum
	        });
	      });
	      var COLORS = ["#216E69", "#32A59D", "#56CBC4", "#99DFDD", "#BBEAE7", "#BAE6FE", "#FFE0CA", "#F3D6D4"];
	
	      var style = inLine ? {
	        box: {
	          display: 'flex'
	        },
	        pieWidth: '50%',
	        table: {
	          width: '50%'
	        }
	      } : {
	        box: {},
	        pieWidth: '100%',
	        table: {}
	      };
	      if (!processData || processData.length === 0) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            title && _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontWeight: "bold",
	                  fontSize: "24px",
	                  padding: "20px 20px 0"
	                }
	              },
	              title
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { width: '100%', minHeight: '280px', textAlign: 'center', paddingTop: '100px', color: "#CDCDCD" } },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
	              "No Data"
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          title && _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontWeight: "bold",
	                fontSize: "24px",
	                padding: "20px 20px 0"
	              }
	            },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: Object.assign({ width: "100%", fontSize: "16px" }, style.box) },
	          _react2.default.createElement(
	            _recharts.ResponsiveContainer,
	            {
	              width: style.pieWidth,
	              height: "100%",
	              minWidth: "400px",
	              minHeight: "300px"
	            },
	            _react2.default.createElement(
	              _recharts.PieChart,
	              null,
	              _react2.default.createElement(
	                _recharts.Pie,
	                {
	                  dataKey: dataKey,
	                  data: processData,
	                  onMouseEnter: function onMouseEnter(data, index) {
	                    _this2.setState({ activeIndex: index });
	                  },
	                  onMouseLeave: function onMouseLeave() {
	                    _this2.setState({ activeIndex: -1 });
	                  }
	                },
	                processData.map(function (entry, idx) {
	                  return _react2.default.createElement(_recharts.Cell, {
	                    key: "segment-graphic" + idx + "-cell-" + dataKey,
	                    fill: COLORS[idx % COLORS.length]
	                  });
	                })
	              ),
	              _react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(CustomTooltip, null) })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: inLine ? 'mt-20' : 'mt-20 mb-20', style: style.table },
	            showUniqVisitsTitle ? _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  padding: "10px",
	                  margin: "-20px 20px 10px",
	                  background: "#F5F5F5",
	                  fontWeight: "bold",
	                  display: "flex",
	                  justifyContent: "space-between"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                null,
	                tableTitle
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                "Unique Visits"
	              )
	            ) : _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  padding: "10px",
	                  margin: "-20px 20px 10px",
	                  background: "#F5F5F5",
	                  fontWeight: "bold",
	                  textAlign: "center"
	                }
	              },
	              tableTitle
	            ),
	            processData.map(function (entry, idx) {
	              var pct = (parseFloat(entry.value) / parseFloat(entry.total)).toLocaleString(undefined, {
	                style: "percent",
	                minimumFractionDigits: 2
	              });
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: "container-pie-" + idx,
	                  style: {
	                    display: "flex",
	                    padding: showUniqVisitsTitle ? "10px" : "10px 0",
	                    margin: "0px 20px",
	                    borderBottom: "solid 1px #EEEFF2 "
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "50%" } },
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        width: "18px",
	                        height: "18px",
	                        display: "inline-block",
	                        marginRight: "10px",
	                        background: COLORS[idx % COLORS.length]
	                      }
	                    },
	                    "\xA0"
	                  ),
	                  entry.key ? entry.key : entry.name
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "50%", textAlign: "right" } },
	                  pct
	                )
	              );
	            }),
	            footer
	          )
	        )
	      );
	    }
	  }]);
	
	  return PieChartTable;
	}(_MaterialUI2.default);
	
	exports.default = PieChartTable;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1239);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(1238);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(537);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ },
/* 359 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 360 */
[3154, 1257],
/* 361 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 362 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 363 */
[3161, 134, 1271, 362, 368, 552, 1262],
/* 364 */
[3164, 263, 215, 137, 371, 136, 553, 135],
/* 365 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(120);
	var core = __webpack_require__(55);
	var fails = __webpack_require__(168);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(122).f;
	var has = __webpack_require__(136);
	var TAG = __webpack_require__(86)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 368 */
[3169, 369, 264],
/* 369 */
[3170, 55, 121, 262],
/* 370 */
268,
/* 371 */
[3174, 170],
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(121);
	var core = __webpack_require__(55);
	var LIBRARY = __webpack_require__(262);
	var wksExt = __webpack_require__(373);
	var defineProperty = __webpack_require__(122).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(86);


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1279);
	var global = __webpack_require__(121);
	var hide = __webpack_require__(169);
	var Iterators = __webpack_require__(171);
	var TO_STRING_TAG = __webpack_require__(86)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 375 */
359,
/* 376 */
361,
/* 377 */
362,
/* 378 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 379 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 380 */
[3162, 266, 566, 384, 172],
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(33);
	var defined = __webpack_require__(376);
	var fails = __webpack_require__(123);
	var spaces = __webpack_require__(382);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 382 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 383 */
[3172, 1295, 376],
/* 384 */
[3174, 173],
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(575);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 386 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ },
/* 387 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var toCodePoints = exports.toCodePoints = function toCodePoints(str) {
	    var codePoints = [];
	    var i = 0;
	    var length = str.length;
	    while (i < length) {
	        var value = str.charCodeAt(i++);
	        if (value >= 0xd800 && value <= 0xdbff && i < length) {
	            var extra = str.charCodeAt(i++);
	            if ((extra & 0xfc00) === 0xdc00) {
	                codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
	            } else {
	                codePoints.push(value);
	                i--;
	            }
	        } else {
	            codePoints.push(value);
	        }
	    }
	    return codePoints;
	};
	
	var fromCodePoint = exports.fromCodePoint = function fromCodePoint() {
	    if (String.fromCodePoint) {
	        return String.fromCodePoint.apply(String, arguments);
	    }
	
	    var length = arguments.length;
	    if (!length) {
	        return '';
	    }
	
	    var codeUnits = [];
	
	    var index = -1;
	    var result = '';
	    while (++index < length) {
	        var codePoint = arguments.length <= index ? undefined : arguments[index];
	        if (codePoint <= 0xffff) {
	            codeUnits.push(codePoint);
	        } else {
	            codePoint -= 0x10000;
	            codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
	        }
	        if (index + 1 === length || codeUnits.length > 0x4000) {
	            result += String.fromCharCode.apply(String, codeUnits);
	            codeUnits.length = 0;
	        }
	    }
	    return result;
	};
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	// Use a lookup table to find the index.
	var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	}
	
	var decode = exports.decode = function decode(base64) {
	    var bufferLength = base64.length * 0.75,
	        len = base64.length,
	        i = void 0,
	        p = 0,
	        encoded1 = void 0,
	        encoded2 = void 0,
	        encoded3 = void 0,
	        encoded4 = void 0;
	
	    if (base64[base64.length - 1] === '=') {
	        bufferLength--;
	        if (base64[base64.length - 2] === '=') {
	            bufferLength--;
	        }
	    }
	
	    var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
	    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
	
	    for (i = 0; i < len; i += 4) {
	        encoded1 = lookup[base64.charCodeAt(i)];
	        encoded2 = lookup[base64.charCodeAt(i + 1)];
	        encoded3 = lookup[base64.charCodeAt(i + 2)];
	        encoded4 = lookup[base64.charCodeAt(i + 3)];
	
	        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	    }
	
	    return buffer;
	};
	
	var polyUint16Array = exports.polyUint16Array = function polyUint16Array(buffer) {
	    var length = buffer.length;
	    var bytes = [];
	    for (var _i = 0; _i < length; _i += 2) {
	        bytes.push(buffer[_i + 1] << 8 | buffer[_i]);
	    }
	    return bytes;
	};
	
	var polyUint32Array = exports.polyUint32Array = function polyUint32Array(buffer) {
	    var length = buffer.length;
	    var bytes = [];
	    for (var _i2 = 0; _i2 < length; _i2 += 4) {
	        bytes.push(buffer[_i2 + 3] << 24 | buffer[_i2 + 2] << 16 | buffer[_i2 + 1] << 8 | buffer[_i2]);
	    }
	    return bytes;
	};

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ v1.3.5 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1350)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = y32 * x10 - x32 * y10;
	  if (t * t < epsilon) return;
	  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	function arc() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00),
	            oc;
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
	          var ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function area() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function identity(d) {
	  return d;
	}
	
	function pie() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	function lineRadial$1() {
	  return lineRadial(line().curve(curveRadialLinear));
	}
	
	function areaRadial() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	function pointRadial(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	}
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
	    kx = Math.sin(tau / 10) * kr,
	    ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	function symbol() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	function noop() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basis(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisClosed(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisOpen(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	function linearClosed(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	function natural(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function step(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	function none(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	function none$1(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	function stack() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	function expand(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	function diverging(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	}
	
	function silhouette(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	function wiggle(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	function appearance(series) {
	  var peaks = series.map(peak);
	  return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
	}
	
	function peak(series) {
	  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
	  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
	  return j;
	}
	
	function ascending(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	function descending$1(series) {
	  return ascending(series).reverse();
	}
	
	function insideOut(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = appearance(series),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	function reverse(series) {
	  return none$1(series).reverse();
	}
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAppearance = appearance;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var startOfWeek = __webpack_require__(1363)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek (dirtyDate) {
	  return startOfWeek(dirtyDate, {weekStartsOn: 1})
	}
	
	module.exports = startOfISOWeek


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(140));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(218));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(592));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1387));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1382));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(1383));
	
	var _properties = __webpack_require__(591);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(1384));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 393 */
/***/ function(module, exports) {

	"use strict";
	
	var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
	// Thanks to:
	// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
	// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
	// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
	exports.validate = function(email)
	{
		if (!email)
			return false;
			
		if(email.length>254)
			return false;
	
		var valid = tester.test(email);
		if(!valid)
			return false;
	
		// Further checking of some things regex can't handle
		var parts = email.split("@");
		if(parts[0].length>64)
			return false;
	
		var domainParts = parts[1].split(".");
		if(domainParts.some(function(part) { return part.length>63; }))
			return false;
	
		return true;
	}

/***/ },
/* 394 */
124,
/* 395 */
124,
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createCounterText = exports.inlineListItemElement = exports.getListOwner = undefined;
	
	var _Util = __webpack_require__(178);
	
	var _NodeContainer = __webpack_require__(177);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _TextContainer = __webpack_require__(274);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _listStyle = __webpack_require__(277);
	
	var _Unicode = __webpack_require__(610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Margin between the enumeration and the list item content
	var MARGIN_RIGHT = 7;
	
	var ancestorTypes = ['OL', 'UL', 'MENU'];
	
	var getListOwner = exports.getListOwner = function getListOwner(container) {
	    var parent = container.parent;
	    if (!parent) {
	        return null;
	    }
	
	    do {
	        var isAncestor = ancestorTypes.indexOf(parent.tagName) !== -1;
	        if (isAncestor) {
	            return parent;
	        }
	        parent = parent.parent;
	    } while (parent);
	
	    return container.parent;
	};
	
	var inlineListItemElement = exports.inlineListItemElement = function inlineListItemElement(node, container, resourceLoader) {
	    var listStyle = container.style.listStyle;
	
	    if (!listStyle) {
	        return;
	    }
	
	    var style = node.ownerDocument.defaultView.getComputedStyle(node, null);
	    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
	    (0, _Util.copyCSSStyles)(style, wrapper);
	
	    wrapper.style.position = 'absolute';
	    wrapper.style.bottom = 'auto';
	    wrapper.style.display = 'block';
	    wrapper.style.letterSpacing = 'normal';
	
	    switch (listStyle.listStylePosition) {
	        case _listStyle.LIST_STYLE_POSITION.OUTSIDE:
	            wrapper.style.left = 'auto';
	            wrapper.style.right = node.ownerDocument.defaultView.innerWidth - container.bounds.left - container.style.margin[1].getAbsoluteValue(container.bounds.width) + MARGIN_RIGHT + 'px';
	            wrapper.style.textAlign = 'right';
	            break;
	        case _listStyle.LIST_STYLE_POSITION.INSIDE:
	            wrapper.style.left = container.bounds.left - container.style.margin[3].getAbsoluteValue(container.bounds.width) + 'px';
	            wrapper.style.right = 'auto';
	            wrapper.style.textAlign = 'left';
	            break;
	    }
	
	    var text = void 0;
	    var MARGIN_TOP = container.style.margin[0].getAbsoluteValue(container.bounds.width);
	    var styleImage = listStyle.listStyleImage;
	    if (styleImage) {
	        if (styleImage.method === 'url') {
	            var image = node.ownerDocument.createElement('img');
	            image.src = styleImage.args[0];
	            wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
	            wrapper.style.width = 'auto';
	            wrapper.style.height = 'auto';
	            wrapper.appendChild(image);
	        } else {
	            var size = parseFloat(container.style.font.fontSize) * 0.5;
	            wrapper.style.top = container.bounds.top - MARGIN_TOP + container.bounds.height - 1.5 * size + 'px';
	            wrapper.style.width = size + 'px';
	            wrapper.style.height = size + 'px';
	            wrapper.style.backgroundImage = style.listStyleImage;
	        }
	    } else if (typeof container.listIndex === 'number') {
	        text = node.ownerDocument.createTextNode(createCounterText(container.listIndex, listStyle.listStyleType, true));
	        wrapper.appendChild(text);
	        wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
	    }
	
	    // $FlowFixMe
	    var body = node.ownerDocument.body;
	    body.appendChild(wrapper);
	
	    if (text) {
	        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
	        body.removeChild(wrapper);
	    } else {
	        // $FlowFixMe
	        container.childNodes.push(new _NodeContainer2.default(wrapper, container, resourceLoader, 0));
	    }
	};
	
	var ROMAN_UPPER = {
	    integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
	    values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
	};
	
	var ARMENIAN = {
	    integers: [9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
	    values: ['Ք', 'Փ', 'Ւ', 'Ց', 'Ր', 'Տ', 'Վ', 'Ս', 'Ռ', 'Ջ', 'Պ', 'Չ', 'Ո', 'Շ', 'Ն', 'Յ', 'Մ', 'Ճ', 'Ղ', 'Ձ', 'Հ', 'Կ', 'Ծ', 'Խ', 'Լ', 'Ի', 'Ժ', 'Թ', 'Ը', 'Է', 'Զ', 'Ե', 'Դ', 'Գ', 'Բ', 'Ա']
	};
	
	var HEBREW = {
	    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
	    values: ['י׳', 'ט׳', 'ח׳', 'ז׳', 'ו׳', 'ה׳', 'ד׳', 'ג׳', 'ב׳', 'א׳', 'ת', 'ש', 'ר', 'ק', 'צ', 'פ', 'ע', 'ס', 'נ', 'מ', 'ל', 'כ', 'יט', 'יח', 'יז', 'טז', 'טו', 'י', 'ט', 'ח', 'ז', 'ו', 'ה', 'ד', 'ג', 'ב', 'א']
	};
	
	var GEORGIAN = {
	    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
	    values: ['ჵ', 'ჰ', 'ჯ', 'ჴ', 'ხ', 'ჭ', 'წ', 'ძ', 'ც', 'ჩ', 'შ', 'ყ', 'ღ', 'ქ', 'ფ', 'ჳ', 'ტ', 'ს', 'რ', 'ჟ', 'პ', 'ო', 'ჲ', 'ნ', 'მ', 'ლ', 'კ', 'ი', 'თ', 'ჱ', 'ზ', 'ვ', 'ე', 'დ', 'გ', 'ბ', 'ა']
	};
	
	var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
	    if (value < min || value > max) {
	        return createCounterText(value, fallback, suffix.length > 0);
	    }
	
	    return symbols.integers.reduce(function (string, integer, index) {
	        while (value >= integer) {
	            value -= integer;
	            string += symbols.values[index];
	        }
	        return string;
	    }, '') + suffix;
	};
	
	var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
	    var string = '';
	
	    do {
	        if (!isNumeric) {
	            value--;
	        }
	        string = resolver(value) + string;
	        value /= codePointRangeLength;
	    } while (value * codePointRangeLength >= codePointRangeLength);
	
	    return string;
	};
	
	var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
	    var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
	
	    return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
	        return (0, _Unicode.fromCodePoint)(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
	    }) + suffix);
	};
	
	var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols) {
	    var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '. ';
	
	    var codePointRangeLength = symbols.length;
	    return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) {
	        return symbols[Math.floor(codePoint % codePointRangeLength)];
	    }) + suffix;
	};
	
	var CJK_ZEROS = 1 << 0;
	var CJK_TEN_COEFFICIENTS = 1 << 1;
	var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
	var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
	
	var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
	    if (value < -9999 || value > 9999) {
	        return createCounterText(value, _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
	    }
	    var tmp = Math.abs(value);
	    var string = suffix;
	
	    if (tmp === 0) {
	        return numbers[0] + string;
	    }
	
	    for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
	        var coefficient = tmp % 10;
	
	        if (coefficient === 0 && (0, _Util.contains)(flags, CJK_ZEROS) && string !== '') {
	            string = numbers[coefficient] + string;
	        } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && (0, _Util.contains)(flags, CJK_HUNDRED_COEFFICIENTS)) {
	            string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
	        } else if (coefficient === 1 && digit > 0) {
	            string = multipliers[digit - 1] + string;
	        }
	        tmp = Math.floor(tmp / 10);
	    }
	
	    return (value < 0 ? negativeSign : '') + string;
	};
	
	var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
	var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
	var JAPANESE_NEGATIVE = 'マイナス';
	var KOREAN_NEGATIVE = '마이너스 ';
	
	var createCounterText = exports.createCounterText = function createCounterText(value, type, appendSuffix) {
	    var defaultSuffix = appendSuffix ? '. ' : '';
	    var cjkSuffix = appendSuffix ? '、' : '';
	    var koreanSuffix = appendSuffix ? ', ' : '';
	    switch (type) {
	        case _listStyle.LIST_STYLE_TYPE.DISC:
	            return '•';
	        case _listStyle.LIST_STYLE_TYPE.CIRCLE:
	            return '◦';
	        case _listStyle.LIST_STYLE_TYPE.SQUARE:
	            return '◾';
	        case _listStyle.LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
	            var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	            return string.length < 4 ? '0' + string : string;
	        case _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL:
	            return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_ROMAN:
	            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
	        case _listStyle.LIST_STYLE_TYPE.UPPER_ROMAN:
	            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_GREEK:
	            return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_ALPHA:
	            return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.UPPER_ALPHA:
	            return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.ARABIC_INDIC:
	            return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.ARMENIAN:
	        case _listStyle.LIST_STYLE_TYPE.UPPER_ARMENIAN:
	            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_ARMENIAN:
	            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
	        case _listStyle.LIST_STYLE_TYPE.BENGALI:
	            return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CAMBODIAN:
	        case _listStyle.LIST_STYLE_TYPE.KHMER:
	            return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
	            return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
	            return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
	        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
	            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
	            return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
	            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
	            return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.JAPANESE_INFORMAL:
	            return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
	        case _listStyle.LIST_STYLE_TYPE.JAPANESE_FORMAL:
	            return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
	            return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
	            return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
	        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
	            return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.DEVANAGARI:
	            return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.GEORGIAN:
	            return createAdditiveCounter(value, 1, 19999, GEORGIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.GUJARATI:
	            return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.GURMUKHI:
	            return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.HEBREW:
	            return createAdditiveCounter(value, 1, 10999, HEBREW, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.HIRAGANA:
	            return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
	        case _listStyle.LIST_STYLE_TYPE.HIRAGANA_IROHA:
	            return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
	        case _listStyle.LIST_STYLE_TYPE.KANNADA:
	            return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.KATAKANA:
	            return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.KATAKANA_IROHA:
	            return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LAO:
	            return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.MONGOLIAN:
	            return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.MYANMAR:
	            return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.ORIYA:
	            return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.PERSIAN:
	            return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.TAMIL:
	            return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.TELUGU:
	            return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.THAI:
	            return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.TIBETAN:
	            return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.DECIMAL:
	        default:
	            return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	    }
	};

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBorder = exports.BORDER_SIDES = exports.BORDER_STYLE = undefined;
	
	var _Color = __webpack_require__(125);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BORDER_STYLE = exports.BORDER_STYLE = {
	    NONE: 0,
	    SOLID: 1
	};
	
	var BORDER_SIDES = exports.BORDER_SIDES = {
	    TOP: 0,
	    RIGHT: 1,
	    BOTTOM: 2,
	    LEFT: 3
	};
	
	var SIDES = Object.keys(BORDER_SIDES).map(function (s) {
	    return s.toLowerCase();
	});
	
	var parseBorderStyle = function parseBorderStyle(style) {
	    switch (style) {
	        case 'none':
	            return BORDER_STYLE.NONE;
	    }
	    return BORDER_STYLE.SOLID;
	};
	
	var parseBorder = exports.parseBorder = function parseBorder(style) {
	    return SIDES.map(function (side) {
	        var borderColor = new _Color2.default(style.getPropertyValue('border-' + side + '-color'));
	        var borderStyle = parseBorderStyle(style.getPropertyValue('border-' + side + '-style'));
	        var borderWidth = parseFloat(style.getPropertyValue('border-' + side + '-width'));
	        return {
	            borderColor: borderColor,
	            borderStyle: borderStyle,
	            borderWidth: isNaN(borderWidth) ? 0 : borderWidth
	        };
	    });
	};

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTextDecoration = exports.TEXT_DECORATION_LINE = exports.TEXT_DECORATION = exports.TEXT_DECORATION_STYLE = undefined;
	
	var _Color = __webpack_require__(125);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEXT_DECORATION_STYLE = exports.TEXT_DECORATION_STYLE = {
	    SOLID: 0,
	    DOUBLE: 1,
	    DOTTED: 2,
	    DASHED: 3,
	    WAVY: 4
	};
	
	var TEXT_DECORATION = exports.TEXT_DECORATION = {
	    NONE: null
	};
	
	var TEXT_DECORATION_LINE = exports.TEXT_DECORATION_LINE = {
	    UNDERLINE: 1,
	    OVERLINE: 2,
	    LINE_THROUGH: 3,
	    BLINK: 4
	};
	
	var parseLine = function parseLine(line) {
	    switch (line) {
	        case 'underline':
	            return TEXT_DECORATION_LINE.UNDERLINE;
	        case 'overline':
	            return TEXT_DECORATION_LINE.OVERLINE;
	        case 'line-through':
	            return TEXT_DECORATION_LINE.LINE_THROUGH;
	    }
	    return TEXT_DECORATION_LINE.BLINK;
	};
	
	var parseTextDecorationLine = function parseTextDecorationLine(line) {
	    if (line === 'none') {
	        return null;
	    }
	
	    return line.split(' ').map(parseLine);
	};
	
	var parseTextDecorationStyle = function parseTextDecorationStyle(style) {
	    switch (style) {
	        case 'double':
	            return TEXT_DECORATION_STYLE.DOUBLE;
	        case 'dotted':
	            return TEXT_DECORATION_STYLE.DOTTED;
	        case 'dashed':
	            return TEXT_DECORATION_STYLE.DASHED;
	        case 'wavy':
	            return TEXT_DECORATION_STYLE.WAVY;
	    }
	    return TEXT_DECORATION_STYLE.SOLID;
	};
	
	var parseTextDecoration = exports.parseTextDecoration = function parseTextDecoration(style) {
	    var textDecorationLine = parseTextDecorationLine(style.textDecorationLine ? style.textDecorationLine : style.textDecoration);
	    if (textDecorationLine === null) {
	        return TEXT_DECORATION.NONE;
	    }
	
	    var textDecorationColor = style.textDecorationColor ? new _Color2.default(style.textDecorationColor) : null;
	    var textDecorationStyle = parseTextDecorationStyle(style.textDecorationStyle);
	
	    return {
	        textDecorationLine: textDecorationLine,
	        textDecorationColor: textDecorationColor,
	        textDecorationStyle: textDecorationStyle
	    };
	};

/***/ },
/* 400 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 401 */
[3176, 149, 88],
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1608),
	    mapCacheDelete = __webpack_require__(1609),
	    mapCacheGet = __webpack_require__(1610),
	    mapCacheHas = __webpack_require__(1611),
	    mapCacheSet = __webpack_require__(1612);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1539);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 404 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1542),
	    isObjectLike = __webpack_require__(81);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(279),
	    arrayIncludes = __webpack_require__(403),
	    arrayIncludesWith = __webpack_require__(404),
	    cacheHas = __webpack_require__(288),
	    createSet = __webpack_require__(1585),
	    setToArray = __webpack_require__(412);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(626);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 408 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(658);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(628),
	    stubArray = __webpack_require__(676);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 411 */
[3209, 29, 187],
/* 412 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53),
	    now = __webpack_require__(1646),
	    toNumber = __webpack_require__(680);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(634),
	    baseIteratee = __webpack_require__(60),
	    toInteger = __webpack_require__(300);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 415 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(284),
	    baseGt = __webpack_require__(638),
	    baseIteratee = __webpack_require__(60);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(144),
	    baseClone = __webpack_require__(633),
	    baseUnset = __webpack_require__(643),
	    castPath = __webpack_require__(181),
	    copyObject = __webpack_require__(148),
	    customOmitClone = __webpack_require__(1586),
	    flatRest = __webpack_require__(649),
	    getAllKeysIn = __webpack_require__(652);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(286);
	
	/**
	 * Gets all but the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.tail([1, 2, 3]);
	 * // => [2, 3]
	 */
	function tail(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseSlice(array, 1, length) : [];
	}
	
	module.exports = tail;


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(146),
	    baseRest = __webpack_require__(227),
	    baseUniq = __webpack_require__(406),
	    isArrayLikeObject = __webpack_require__(292);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(1690);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Subheader = __webpack_require__(698);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var hasSubheader = false;
	
	      var firstChild = _react.Children.toArray(children)[0];
	      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	        hasSubheader = true;
	      }
	
	      var styles = {
	        root: {
	          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	List.propTypes =  false ? {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = List;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(163);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(97);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(189);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(728);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(729);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(1698);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var autoGenerateNestedIndicator = props.autoGenerateNestedIndicator,
	      insetChildren = props.insetChildren,
	      leftAvatar = props.leftAvatar,
	      leftCheckbox = props.leftCheckbox,
	      leftIcon = props.leftIcon,
	      nestedItems = props.nestedItems,
	      nestedLevel = props.nestedLevel,
	      rightAvatar = props.rightAvatar,
	      rightIcon = props.rightIcon,
	      rightIconButton = props.rightIconButton,
	      rightToggle = props.rightToggle,
	      secondaryText = props.secondaryText,
	      secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var isKeyboardFocused = (props.isKeyboardFocused !== undefined ? props : state).isKeyboardFocused;
	
	  var styles = {
	    root: {
	      backgroundColor: (isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton || nestedItems.length && autoGenerateNestedIndicator ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	
	      if (_this.props.primaryTogglesNestedList) {
	        _this.handleNestedListToggle(event);
	      }
	    }, _this.handleNestedListToggle = function (event) {
	      if (_this.props.leftCheckbox) {
	        event.preventDefault();
	      }
	      event.stopPropagation();
	
	      if (_this.props.open === null) {
	        _this.setState({ open: !_this.state.open }, function () {
	          _this.props.onNestedListToggle(_this);
	        });
	      } else {
	        // Exposing `this` in the callback is quite a bad API.
	        // I'm doing a one level deep clone to expose a fake state.open.
	        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
	          state: {
	            open: !_this.state.open
	          }
	        }));
	      }
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onClick) iconButton.props.onClick(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchEnd(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      if (this.button) {
	        var buttonEl = _reactDom2.default.findDOMNode(this.button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            this.button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props,
	          innerDivStyle = _props.innerDivStyle,
	          style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props,
	          innerDivStyle = _props2.innerDivStyle,
	          style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          hoverColor = _props3.hoverColor,
	          initiallyOpen = _props3.initiallyOpen,
	          innerDivStyle = _props3.innerDivStyle,
	          insetChildren = _props3.insetChildren,
	          leftAvatar = _props3.leftAvatar,
	          leftCheckbox = _props3.leftCheckbox,
	          leftIcon = _props3.leftIcon,
	          nestedItems = _props3.nestedItems,
	          nestedLevel = _props3.nestedLevel,
	          nestedListStyle = _props3.nestedListStyle,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          isKeyboardFocused = _props3.isKeyboardFocused,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onNestedListToggle = _props3.onNestedListToggle,
	          onTouchStart = _props3.onTouchStart,
	          onClick = _props3.onClick,
	          rightAvatar = _props3.rightAvatar,
	          rightIcon = _props3.rightIcon,
	          rightIconButton = _props3.rightIconButton,
	          rightToggle = _props3.rightToggle,
	          primaryText = _props3.primaryText,
	          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
	          secondaryText = _props3.secondaryText,
	          secondaryTextLines = _props3.secondaryTextLines,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'isKeyboardFocused', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onClick', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onClick: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onClick = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({
	            containerElement: containerElement
	          }, other, {
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchEnd: this.handleTouchEnd,
	            onClick: this.handleTouchTap,
	            disabled: disabled,
	            ref: function ref(node) {
	              return _this2.button = node;
	            },
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  containerElement: 'span',
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ListItem.propTypes =  false ? {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _propTypes2.default.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The element to use as the container for the ListItem. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * ListItem in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _propTypes2.default.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	  * Override the hover background color.
	  */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * Use to control if the list item should render as keyboard focused.  If
	   * undefined (default), this will be automatically managed.  If provided,
	   * it will change the components style.  Note that this will not change the
	   * actual focus - and should only be used when you want to simulate
	   * keyboard focus (eg. in a rich text input autocomplete).
	   */
	  isKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _propTypes2.default.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the list item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the list item.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _propTypes2.default.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _propTypes2.default.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _propTypes2.default.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ListItem;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(163);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(190);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(724);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(422);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(303);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'default' : 'pointer',
	      minHeight: props.desktop ? '32px' : '48px',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
	      paddingRight: props.rightIcon ? indent : sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onClick: function onClick(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onClick) {
	            item.props.onClick(event);
	          }
	        }
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          animation = _props.animation,
	          anchorOrigin = _props.anchorOrigin,
	          targetOrigin = _props.targetOrigin,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'targetOrigin', 'value']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: anchorOrigin,
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            targetOrigin: targetOrigin,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onClick = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          hoverColor: this.context.muiTheme.menuItem.hoverColor,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          role: 'menuitem',
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.defaultProps = {
	  anchorOrigin: { horizontal: 'right', vertical: 'top' },
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false,
	  targetOrigin: { horizontal: 'left', vertical: 'top' }
	};
	MenuItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	MenuItem.propTypes =  false ? {
	  /**
	   * Location of the anchor for the popover of nested `MenuItem`
	   * elements.
	   * Options:
	   * horizontal: [left, middle, right]
	   * vertical: [top, center, bottom].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _propTypes2.default.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _propTypes2.default.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Location on the popover of nested `MenuItem` elements that will attach
	   * to the anchor's origin.
	   * Options:
	   * horizontal: [left, middle, right]
	   * vertical: [top, center, bottom].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * The value of the menu item.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = MenuItem;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'center');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	PopoverAnimationVertical.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = PopoverAnimationVertical;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedSwitch = __webpack_require__(429);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _radioButtonUnchecked = __webpack_require__(734);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _radioButtonChecked = __webpack_require__(733);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var radioButton = context.muiTheme.radioButton;
	
	
	  return {
	    icon: {
	      height: radioButton.size,
	      width: radioButton.size
	    },
	    target: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(1)',
	      fill: radioButton.borderColor
	    },
	    fill: {
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(0)',
	      transformOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut(),
	      fill: radioButton.checkedColor
	    },
	    targetWhenChecked: {
	      opacity: 0,
	      transform: 'scale(0)'
	    },
	    fillWhenChecked: {
	      opacity: 1,
	      transform: 'scale(1)'
	    },
	    targetWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    fillWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    label: {
	      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
	    },
	    ripple: {
	      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
	    }
	  };
	}
	
	var RadioButton = function (_Component) {
	  (0, _inherits3.default)(RadioButton, _Component);
	
	  function RadioButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitch = function (event) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, _this.props.value);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // Only called when selected, not when unselected.
	
	
	  (0, _createClass3.default)(RadioButton, [{
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	
	    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	    // RadioButton's checked value.
	
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.enhancedSwitch.getValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onCheck = _props.onCheck,
	          uncheckedIcon = _props.uncheckedIcon,
	          disabled = _props.disabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);
	
	      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);
	
	      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });
	
	      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });
	
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, {
	        ref: 'enhancedSwitch',
	        inputType: 'radio',
	        checked: checked,
	        switched: checked,
	        disabled: disabled,
	        rippleColor: styles.ripple.color,
	        iconStyle: mergedIconStyle,
	        labelStyle: mergedLabelStyle,
	        labelPosition: labelPosition,
	        onSwitch: this.handleSwitch,
	        switchElement: _react2.default.createElement(
	          'div',
	          null,
	          uncheckedElement,
	          checkedElement
	        )
	      }));
	    }
	  }]);
	  return RadioButton;
	}(_react.Component);
	
	RadioButton.defaultProps = {
	  checked: false,
	  disabled: false,
	  labelPosition: 'right'
	};
	RadioButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RadioButton.propTypes =  false ? {
	  /**
	   * @ignore
	   * checked if true
	   * Used internally by `RadioButtonGroup`.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * The icon element to show when the radio button is checked.
	   */
	  checkedIcon: _propTypes2.default.element,
	  /**
	   * If true, the radio button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
	   * Where the label will be placed next to the radio button.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Override the inline-styles of the label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Callback function fired when the radio button is checked. Note that this
	   * function will not be called if the radio button is part of a
	   * radio button group: in this case, use the `onChange` property of
	   * `RadioButtonGroup`.
	   *
	   * @param {object} event `change` event targeting the element.
	   * @param {string} value The element's `value`.
	   */
	  onCheck: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The icon element to show when the radio button is unchecked.
	   */
	  uncheckedIcon: _propTypes2.default.element,
	  /**
	   * The value of the radio button.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = RadioButton;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RadioButton = __webpack_require__(425);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioButtonGroup = function (_Component) {
	  (0, _inherits3.default)(RadioButtonGroup, _Component);
	
	  function RadioButtonGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButtonGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      numberCheckedRadioButtons: 0,
	      selected: ''
	    }, _this.handleChange = function (event, newSelection) {
	      _this.updateRadioButtons(newSelection);
	
	      // Successful update
	      if (_this.state.numberCheckedRadioButtons === 0) {
	        if (_this.props.onChange) _this.props.onChange(event, newSelection);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RadioButtonGroup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var cnt = 0;
	      var selected = '';
	      var _props = this.props,
	          valueSelected = _props.valueSelected,
	          defaultSelected = _props.defaultSelected;
	
	      if (valueSelected !== undefined) {
	        selected = valueSelected;
	      } else if (defaultSelected !== undefined) {
	        selected = defaultSelected;
	      }
	
	      _react2.default.Children.forEach(this.props.children, function (option) {
	        if (_this2.hasCheckAttribute(option)) cnt++;
	      }, this);
	
	      this.setState({
	        numberCheckedRadioButtons: cnt,
	        selected: selected
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasOwnProperty('valueSelected')) {
	        this.setState({
	          selected: nextProps.valueSelected
	        });
	      }
	    }
	  }, {
	    key: 'hasCheckAttribute',
	    value: function hasCheckAttribute(radioButton) {
	      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	    }
	  }, {
	    key: 'updateRadioButtons',
	    value: function updateRadioButtons(newSelection) {
	      if (this.state.numberCheckedRadioButtons === 0) {
	        this.setState({ selected: newSelection });
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
	      }
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue() {
	      return this.state.selected;
	    }
	  }, {
	    key: 'setSelectedValue',
	    value: function setSelectedValue(newSelectionValue) {
	      this.updateRadioButtons(newSelectionValue);
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setSelectedValue('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var options = _react2.default.Children.map(this.props.children, function (option) {
	        var _option$props = option.props,
	            name = _option$props.name,
	            value = _option$props.value,
	            label = _option$props.label,
	            onCheck = _option$props.onCheck,
	            other = (0, _objectWithoutProperties3.default)(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	
	        return _react2.default.createElement(_RadioButton2.default, (0, _extends3.default)({}, other, {
	          ref: option.props.value,
	          name: _this3.props.name,
	          key: option.props.value,
	          value: option.props.value,
	          label: option.props.label,
	          labelPosition: _this3.props.labelPosition,
	          onCheck: _this3.handleChange,
	          checked: option.props.value === _this3.state.selected
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
	          className: this.props.className
	        },
	        options
	      );
	    }
	  }]);
	  return RadioButtonGroup;
	}(_react.Component);
	
	RadioButtonGroup.defaultProps = {
	  style: {}
	};
	RadioButtonGroup.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RadioButtonGroup.propTypes =  false ? {
	  /**
	   * Should be used to pass `RadioButton` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The `value` property of the radio button that will be
	   * selected by default. This takes precedence over the `checked` property
	   * of the `RadioButton` elements.
	   */
	  defaultSelected: _propTypes2.default.any,
	  /**
	   * Where the label will be placed for all child radio buttons.
	   * This takes precedence over the `labelPosition` property of the
	   * `RadioButton` elements.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * The name that will be applied to all child radio buttons.
	   */
	  name: _propTypes2.default.string.isRequired,
	  /**
	   * Callback function that is fired when a radio button has
	   * been checked.
	   *
	   * @param {object} event `change` event targeting the selected
	   * radio button.
	   * @param {*} value The `value` of the selected radio button.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The `value` of the currently selected radio button.
	   */
	  valueSelected: _propTypes2.default.any
	} : {};
	exports.default = RadioButtonGroup;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tooltip = __webpack_require__(711);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;
	
	
	  return {
	    root: {
	      fontWeight: 'normal',
	      fontSize: 12,
	      paddingLeft: tableHeaderColumn.spacing,
	      paddingRight: tableHeaderColumn.spacing,
	      height: tableHeaderColumn.height,
	      textAlign: 'left',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      color: tableHeaderColumn.textColor,
	      position: 'relative'
	    },
	    tooltip: {
	      boxSizing: 'border-box',
	      marginTop: tableHeaderColumn.height / 2
	    }
	  };
	}
	
	var TableHeaderColumn = function (_Component) {
	  (0, _inherits3.default)(TableHeaderColumn, _Component);
	
	  function TableHeaderColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeaderColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderColumn.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onMouseEnter = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: true });
	      }
	    }, _this.onMouseLeave = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: false });
	      }
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeaderColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipStyle = _props.tooltipStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onClick: this.onClick
	      };
	
	      var tooltipNode = void 0;
	
	      if (tooltip !== undefined) {
	        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
	          label: tooltip,
	          show: this.state.hovered,
	          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
	        });
	      }
	
	      return _react2.default.createElement(
	        'th',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        tooltipNode,
	        children
	      );
	    }
	  }]);
	  return TableHeaderColumn;
	}(_react.Component);
	
	TableHeaderColumn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableHeaderColumn.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _propTypes2.default.number,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  hoverable: _propTypes2.default.bool,
	  /** @ignore */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHoverExit: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The string to supply to the tooltip. If not
	   * string is supplied no tooltip will be shown.
	   */
	  tooltip: _propTypes2.default.string,
	  /**
	   * Additional styling that can be applied to the tooltip.
	   */
	  tooltipStyle: _propTypes2.default.object
	} : {};
	exports.default = TableHeaderColumn;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(308);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  (0, _inherits3.default)(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.Component);
	
	ClickAwayListener.propTypes =  false ? {
	  children: _propTypes2.default.element,
	  onClickAway: _propTypes2.default.func
	} : {};
	exports.default = ClickAwayListener;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(112);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(430);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(712);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      position: 'relative',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: 'inherit',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  (0, _inherits3.default)(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedSwitch, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          inputStyle = _props.inputStyle,
	          inputType = _props.inputType,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onSwitch = _props.onSwitch,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onParentShouldUpdate = _props.onParentShouldUpdate,
	          disabled = _props.disabled,
	          disableTouchRipple = _props.disableTouchRipple,
	          disableFocusRipple = _props.disableFocusRipple,
	          className = _props.className,
	          rippleColor = _props.rippleColor,
	          rippleStyle = _props.rippleStyle,
	          style = _props.style,
	          switched = _props.switched,
	          switchElement = _props.switchElement,
	          thumbStyle = _props.thumbStyle,
	          trackStyle = _props.trackStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'checked', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var touchHandlers = showTouchRipple ? {
	        onMouseUp: this.handleMouseUp,
	        onMouseDown: this.handleMouseDown,
	        onMouseLeave: this.handleMouseLeave,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd
	      } : {};
	
	      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        checked: this.state.switched,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange
	      }, touchHandlers));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedSwitch.propTypes =  false ? {
	  checked: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  defaultChecked: _propTypes2.default.bool,
	  disableFocusRipple: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  iconStyle: _propTypes2.default.object,
	  inputStyle: _propTypes2.default.object,
	  inputType: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.node,
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  labelStyle: _propTypes2.default.object,
	  name: _propTypes2.default.string,
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onParentShouldUpdate: _propTypes2.default.func,
	  onSwitch: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  rippleColor: _propTypes2.default.string,
	  rippleStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  switchElement: _propTypes2.default.element.isRequired,
	  switched: _propTypes2.default.bool.isRequired,
	  thumbStyle: _propTypes2.default.object,
	  trackStyle: _propTypes2.default.object,
	  value: _propTypes2.default.any
	} : {};
	exports.default = EnhancedSwitch;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(163);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(157);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(1747);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FocusRipple.propTypes =  false ? {
	  color: _propTypes2.default.string,
	  innerStyle: _propTypes2.default.object,
	  opacity: _propTypes2.default.number,
	  show: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : {};
	exports.default = FocusRipple;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(248);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _SlideInChild = __webpack_require__(1749);
	
	var _SlideInChild2 = _interopRequireDefault(_SlideInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideIn = function (_Component) {
	  (0, _inherits3.default)(SlideIn, _Component);
	
	  function SlideIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SlideIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call.apply(_ref, [this].concat(args))), _this), _this.getLeaveDirection = function () {
	      return _this.props.direction;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SlideIn, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          direction = _props.direction,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _SlideInChild2.default,
	          {
	            key: child.key,
	            direction: direction,
	            enterDelay: enterDelay,
	            getLeaveDirection: _this2.getLeaveDirection,
	            style: childStyle
	          },
	          child
	        );
	      }, this);
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return SlideIn;
	}(_react.Component);
	
	SlideIn.defaultProps = {
	  enterDelay: 0,
	  direction: 'left'
	};
	SlideIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SlideIn.propTypes =  false ? {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
	  enterDelay: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = SlideIn;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettings = function ActionSettings(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z' })
	  );
	};
	ActionSettings = (0, _pure2.default)(ActionSettings);
	ActionSettings.displayName = 'ActionSettings';
	ActionSettings.muiName = 'SvgIcon';
	
	exports.default = ActionSettings;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMoreHoriz = function NavigationMoreHoriz(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	NavigationMoreHoriz = (0, _pure2.default)(NavigationMoreHoriz);
	NavigationMoreHoriz.displayName = 'NavigationMoreHoriz';
	NavigationMoreHoriz.muiName = 'SvgIcon';
	
	exports.default = NavigationMoreHoriz;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addEventListener = __webpack_require__(311);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Handle = function (_React$Component) {
	  (0, _inherits3['default'])(Handle, _React$Component);
	
	  function Handle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Handle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clickFocused: false
	    }, _this.setHandleRef = function (node) {
	      _this.handle = node;
	    }, _this.handleMouseUp = function () {
	      if (document.activeElement === _this.handle) {
	        _this.setClickFocus(true);
	      }
	    }, _this.handleBlur = function () {
	      _this.setClickFocus(false);
	    }, _this.handleKeyDown = function () {
	      _this.setClickFocus(false);
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Handle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // mouseup won't trigger if mouse moved out of handle,
	      // so we listen on document here.
	      this.onMouseUpListener = (0, _addEventListener2['default'])(document, 'mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.onMouseUpListener) {
	        this.onMouseUpListener.remove();
	      }
	    }
	  }, {
	    key: 'setClickFocus',
	    value: function setClickFocus(focused) {
	      this.setState({ clickFocused: focused });
	    }
	  }, {
	    key: 'clickFocus',
	    value: function clickFocus() {
	      this.setClickFocus(true);
	      this.focus();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.handle.focus();
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.handle.blur();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          vertical = _props.vertical,
	          offset = _props.offset,
	          style = _props.style,
	          disabled = _props.disabled,
	          min = _props.min,
	          max = _props.max,
	          value = _props.value,
	          tabIndex = _props.tabIndex,
	          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);
	
	
	      var className = (0, _classnames2['default'])(this.props.className, (0, _defineProperty3['default'])({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
	
	      var postionStyle = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
	      var elStyle = (0, _extends3['default'])({}, style, postionStyle);
	
	      return _react2['default'].createElement('div', (0, _extends3['default'])({
	        ref: this.setHandleRef,
	        tabIndex: disabled ? null : tabIndex || 0
	      }, restProps, {
	        className: className,
	        style: elStyle,
	        onBlur: this.handleBlur,
	        onKeyDown: this.handleKeyDown
	
	        // aria attribute
	        , role: 'slider',
	        'aria-valuemin': min,
	        'aria-valuemax': max,
	        'aria-valuenow': value,
	        'aria-disabled': !!disabled
	      }));
	    }
	  }]);
	  return Handle;
	}(_react2['default'].Component);
	
	exports['default'] = Handle;
	
	
	Handle.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  vertical: _propTypes2['default'].bool,
	  offset: _propTypes2['default'].number,
	  style: _propTypes2['default'].object,
	  disabled: _propTypes2['default'].bool,
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  value: _propTypes2['default'].number,
	  tabIndex: _propTypes2['default'].number
	};
	module.exports = exports['default'];

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.isDev = isDev;
	exports.isEventFromHandle = isEventFromHandle;
	exports.isValueOutOfRange = isValueOutOfRange;
	exports.isNotTouchEvent = isNotTouchEvent;
	exports.getClosestPoint = getClosestPoint;
	exports.getPrecision = getPrecision;
	exports.getMousePosition = getMousePosition;
	exports.getTouchPosition = getTouchPosition;
	exports.getHandleCenterPosition = getHandleCenterPosition;
	exports.ensureValueInRange = ensureValueInRange;
	exports.ensureValuePrecision = ensureValuePrecision;
	exports.pauseEvent = pauseEvent;
	exports.calculateNextValue = calculateNextValue;
	exports.getKeyboardValueMutator = getKeyboardValueMutator;
	
	var _reactDom = __webpack_require__(17);
	
	var _KeyCode = __webpack_require__(2731);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isDev() {
	  return ("production") !== 'production';
	}
	
	function isEventFromHandle(e, handles) {
	  try {
	    return Object.keys(handles).some(function (key) {
	      return e.target === (0, _reactDom.findDOMNode)(handles[key]);
	    });
	  } catch (error) {
	    return false;
	  }
	}
	
	function isValueOutOfRange(value, _ref) {
	  var min = _ref.min,
	      max = _ref.max;
	
	  return value < min || value > max;
	}
	
	function isNotTouchEvent(e) {
	  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
	}
	
	function getClosestPoint(val, _ref2) {
	  var marks = _ref2.marks,
	      step = _ref2.step,
	      min = _ref2.min;
	
	  var points = Object.keys(marks).map(parseFloat);
	  if (step !== null) {
	    var closestStep = Math.round((val - min) / step) * step + min;
	    points.push(closestStep);
	  }
	  var diffs = points.map(function (point) {
	    return Math.abs(val - point);
	  });
	  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3['default'])(diffs)))];
	}
	
	function getPrecision(step) {
	  var stepString = step.toString();
	  var precision = 0;
	  if (stepString.indexOf('.') >= 0) {
	    precision = stepString.length - stepString.indexOf('.') - 1;
	  }
	  return precision;
	}
	
	function getMousePosition(vertical, e) {
	  return vertical ? e.clientY : e.pageX;
	}
	
	function getTouchPosition(vertical, e) {
	  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
	}
	
	function getHandleCenterPosition(vertical, handle) {
	  var coords = handle.getBoundingClientRect();
	  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
	}
	
	function ensureValueInRange(val, _ref3) {
	  var max = _ref3.max,
	      min = _ref3.min;
	
	  if (val <= min) {
	    return min;
	  }
	  if (val >= max) {
	    return max;
	  }
	  return val;
	}
	
	function ensureValuePrecision(val, props) {
	  var step = props.step;
	
	  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
	  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
	}
	
	function pauseEvent(e) {
	  e.stopPropagation();
	  e.preventDefault();
	}
	
	function calculateNextValue(func, value, props) {
	  var operations = {
	    increase: function increase(a, b) {
	      return a + b;
	    },
	    decrease: function decrease(a, b) {
	      return a - b;
	    }
	  };
	
	  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
	  var keyToGet = Object.keys(props.marks)[indexToGet];
	
	  if (props.step) {
	    return operations[func](value, props.step);
	  } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
	    return props.marks[keyToGet];
	  }
	  return value;
	}
	
	function getKeyboardValueMutator(e) {
	  switch (e.keyCode) {
	    case _KeyCode2['default'].UP:
	    case _KeyCode2['default'].RIGHT:
	      return function (value, props) {
	        return calculateNextValue('increase', value, props);
	      };
	
	    case _KeyCode2['default'].DOWN:
	    case _KeyCode2['default'].LEFT:
	      return function (value, props) {
	        return calculateNextValue('decrease', value, props);
	      };
	
	    case _KeyCode2['default'].END:
	      return function (value, props) {
	        return props.max;
	      };
	    case _KeyCode2['default'].HOME:
	      return function (value, props) {
	        return props.min;
	      };
	    case _KeyCode2['default'].PAGE_UP:
	      return function (value, props) {
	        return value + props.step * 2;
	      };
	    case _KeyCode2['default'].PAGE_DOWN:
	      return function (value, props) {
	        return value - props.step * 2;
	      };
	
	    default:
	      return undefined;
	  }
	}

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.supportTransition = exports.transitionEndName = exports.animationEndName = undefined;
	exports.getStyleProperty = getStyleProperty;
	exports.getStyleValue = getStyleValue;
	exports.getVendorPrefixes = getVendorPrefixes;
	exports.getVendorPrefixedEventName = getVendorPrefixedEventName;
	exports.mergeChildren = mergeChildren;
	exports.cloneProps = cloneProps;
	exports.getTransitionName = getTransitionName;
	
	var _toArray = __webpack_require__(239);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _ExecutionEnvironment = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// =================== Style ====================
	var stylePrefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < stylePrefixes.length; i++) {
	    ret = style.getPropertyValue(stylePrefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function getStyleValue(node, name) {
	  return parseFloat(getStyleProperty(node, name));
	}
	
	// ================= Transition =================
	// Event wrapper. Copy from react source code
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	function getVendorPrefixes(domSupport, win) {
	  var prefixes = {
	    animationend: makePrefixMap('Animation', 'AnimationEnd'),
	    transitionend: makePrefixMap('Transition', 'TransitionEnd')
	  };
	
	  if (domSupport) {
	    if (!('AnimationEvent' in win)) {
	      delete prefixes.animationend.animation;
	    }
	
	    if (!('TransitionEvent' in win)) {
	      delete prefixes.transitionend.transition;
	    }
	  }
	
	  return prefixes;
	}
	
	var vendorPrefixes = getVendorPrefixes(_ExecutionEnvironment.canUseDOM, typeof window !== 'undefined' ? window : {});
	
	var style = {};
	
	if (_ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	}
	
	var prefixedEventNames = {};
	
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  if (prefixMap) {
	    var stylePropList = Object.keys(prefixMap);
	    var len = stylePropList.length;
	    for (var i = 0; i < len; i += 1) {
	      var styleProp = stylePropList[i];
	      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
	        prefixedEventNames[eventName] = prefixMap[styleProp];
	        return prefixedEventNames[eventName];
	      }
	    }
	  }
	
	  return '';
	}
	
	var animationEndName = exports.animationEndName = getVendorPrefixedEventName('animationend');
	var transitionEndName = exports.transitionEndName = getVendorPrefixedEventName('transitionend');
	var supportTransition = exports.supportTransition = !!(animationEndName && transitionEndName);
	
	// ==================== Node ====================
	/**
	 * [Legacy] Find the same children in both prev & next list.
	 * Insert not find one before the find one, otherwise in the end. For example:
	 * - prev: [1,2,3]
	 * - next: [2,4]
	 * -> [1,2,4,3]
	 */
	function mergeChildren(prev, next) {
	  var prevList = (0, _toArray2['default'])(prev);
	  var nextList = (0, _toArray2['default'])(next);
	
	  // Skip if is single children
	  if (prevList.length === 1 && nextList.length === 1 && prevList[0].key === nextList[0].key) {
	    return nextList;
	  }
	
	  var mergeList = [];
	  var nextChildrenMap = {};
	  var missMatchChildrenList = [];
	
	  // Fill matched prev node into next node map
	  prevList.forEach(function (prevNode) {
	    if (prevNode && nextList.some(function (_ref) {
	      var key = _ref.key;
	      return key === prevNode.key;
	    })) {
	      if (missMatchChildrenList.length) {
	        nextChildrenMap[prevNode.key] = missMatchChildrenList;
	        missMatchChildrenList = [];
	      }
	    } else {
	      missMatchChildrenList.push(prevNode);
	    }
	  });
	
	  // Insert prev node before the matched next node
	  nextList.forEach(function (nextNode) {
	    if (nextNode && nextChildrenMap[nextNode.key]) {
	      mergeList = mergeList.concat(nextChildrenMap[nextNode.key]);
	    }
	    mergeList.push(nextNode);
	  });
	
	  mergeList = mergeList.concat(missMatchChildrenList);
	
	  return mergeList;
	}
	
	function cloneProps(props, propList) {
	  var newProps = {};
	  propList.forEach(function (prop) {
	    if (prop in props) {
	      newProps[prop] = props[prop];
	    }
	  });
	
	  return newProps;
	}
	
	function getTransitionName(transitionName, transitionType) {
	  if (!transitionName) return null;
	
	  if (typeof transitionName === 'object') {
	    var type = transitionType.replace(/-\w/g, function (match) {
	      return match[1].toUpperCase();
	    });
	    return transitionName[type];
	  }
	
	  return transitionName + '-' + transitionType;
	}

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BaseMenuItem = undefined;
	
	var _noop2 = __webpack_require__(298);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _menuItemContainer = __webpack_require__(882);
	
	var _menuItemContainer2 = _interopRequireDefault(_menuItemContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseMenuItem = function (_React$Component) {
	  _inherits(BaseMenuItem, _React$Component);
	
	  function BaseMenuItem(props) {
	    _classCallCheck(this, BaseMenuItem);
	
	    var _this = _possibleConstructorReturn(this, (BaseMenuItem.__proto__ || Object.getPrototypeOf(BaseMenuItem)).call(this, props));
	
	    _this.displayName = 'BaseMenuItem';
	
	
	    _this._handleClick = _this._handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(BaseMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled;
	
	
	      return _react2.default.createElement(
	        'li',
	        {
	          className: (0, _classnames2.default)({
	            'active': active,
	            'disabled': disabled
	          }, className) },
	        _react2.default.createElement(
	          'a',
	          { onClick: this._handleClick, role: 'button' },
	          children
	        )
	      );
	    }
	  }, {
	    key: '_handleClick',
	    value: function _handleClick(e) {
	      var _props2 = this.props,
	          disabled = _props2.disabled,
	          onClick = _props2.onClick;
	
	
	      e.preventDefault();
	      !disabled && onClick(e);
	    }
	  }]);
	
	  return BaseMenuItem;
	}(_react2.default.Component);
	
	BaseMenuItem.defaultProps = {
	  onClick: _noop3.default
	};
	
	var MenuItem = (0, _menuItemContainer2.default)(BaseMenuItem);
	
	exports.BaseMenuItem = BaseMenuItem;
	exports.default = MenuItem;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(238);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(240);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(2748);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	
	      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
	    }, _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this.setContainer();
	    this.forceUpdate(this.props.onRendered);
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(4));
	var classnames = _interopDefault(__webpack_require__(16));
	var onClickOutside = _interopDefault(__webpack_require__(2760));
	var moment = _interopDefault(__webpack_require__(5));
	var reactPopper = __webpack_require__(2761);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateYears(year, noOfYear, minDate, maxDate) {
	  var list = [];
	  for (var i = 0; i < 2 * noOfYear + 1; i++) {
	    var newYear = year + noOfYear - i;
	    var isInRange = true;
	
	    if (minDate) {
	      isInRange = minDate.year() <= newYear;
	    }
	
	    if (maxDate && isInRange) {
	      isInRange = maxDate.year() >= newYear;
	    }
	
	    if (isInRange) {
	      list.push(newYear);
	    }
	  }
	
	  return list;
	}
	
	var YearDropdownOptions = function (_React$Component) {
	  inherits(YearDropdownOptions, _React$Component);
	
	  function YearDropdownOptions(props) {
	    classCallCheck(this, YearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      var selectedYear = _this.props.year;
	      var options = _this.state.yearsList.map(function (year) {
	        return React.createElement(
	          "div",
	          {
	            className: selectedYear === year ? "react-datepicker__year-option --selected_year" : "react-datepicker__year-option",
	            key: year,
	            ref: year,
	            onClick: _this.onChange.bind(_this, year)
	          },
	          selectedYear === year ? React.createElement(
	            "span",
	            { className: "react-datepicker__year-option--selected" },
	            "\u2713"
	          ) : "",
	          year
	        );
	      });
	
	      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
	      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;
	
	      if (!maxYear || !_this.state.yearsList.find(function (year) {
	        return year === maxYear;
	      })) {
	        options.unshift(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "upcoming",
	            key: "upcoming",
	            onClick: _this.incrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
	        ));
	      }
	
	      if (!minYear || !_this.state.yearsList.find(function (year) {
	        return year === minYear;
	      })) {
	        options.push(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "previous",
	            key: "previous",
	            onClick: _this.decrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
	        ));
	      }
	
	      return options;
	    };
	
	    _this.onChange = function (year) {
	      _this.props.onChange(year);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.shiftYears = function (amount) {
	      var years = _this.state.yearsList.map(function (year) {
	        return year + amount;
	      });
	
	      _this.setState({
	        yearsList: years
	      });
	    };
	
	    _this.incrementYears = function () {
	      return _this.shiftYears(1);
	    };
	
	    _this.decrementYears = function () {
	      return _this.shiftYears(-1);
	    };
	
	    var yearDropdownItemNumber = props.yearDropdownItemNumber,
	        scrollableYearDropdown = props.scrollableYearDropdown;
	
	    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
	
	    _this.state = {
	      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  YearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__year-dropdown": true,
	      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return YearDropdownOptions;
	}(React.Component);
	
	YearDropdownOptions.propTypes = {
	  minDate: PropTypes.object,
	  maxDate: PropTypes.object,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number
	};
	
	var dayOfWeekCodes = {
	  1: "mon",
	  2: "tue",
	  3: "wed",
	  4: "thu",
	  5: "fri",
	  6: "sat",
	  7: "sun"
	};
	
	// These functions are not exported so
	// that we avoid magic strings like 'days'
	function set$1(date, unit, to) {
	  return date.set(unit, to);
	}
	
	function add(date, amount, unit) {
	  return date.add(amount, unit);
	}
	
	function subtract(date, amount, unit) {
	  return date.subtract(amount, unit);
	}
	
	function get$1(date, unit) {
	  return date.get(unit);
	}
	
	function getStartOf(date, unit) {
	  return date.startOf(unit);
	}
	
	// ** Date Constructors **
	
	function newDate(point) {
	  return moment(point);
	}
	
	function newDateWithOffset(utcOffset) {
	  return moment().utc().utcOffset(utcOffset);
	}
	
	function now(maybeFixedUtcOffset) {
	  if (maybeFixedUtcOffset == null) {
	    return newDate();
	  }
	  return newDateWithOffset(maybeFixedUtcOffset);
	}
	
	function cloneDate(date) {
	  return date.clone();
	}
	
	function parseDate(value, _ref) {
	  var dateFormat = _ref.dateFormat,
	      locale = _ref.locale;
	
	  var m = moment(value, dateFormat, locale || moment.locale(), true);
	  return m.isValid() ? m : null;
	}
	
	// ** Date "Reflection" **
	
	function isMoment(date) {
	  return moment.isMoment(date);
	}
	
	function isDate(date) {
	  return moment.isDate(date);
	}
	
	// ** Date Formatting **
	
	function formatDate(date, format) {
	  return date.format(format);
	}
	
	function safeDateFormat(date, _ref2) {
	  var dateFormat = _ref2.dateFormat,
	      locale = _ref2.locale;
	
	  return date && date.clone().locale(locale || moment.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
	}
	
	// ** Date Setters **
	
	function setTime(date, _ref3) {
	  var hour = _ref3.hour,
	      minute = _ref3.minute,
	      second = _ref3.second;
	
	  date.set({ hour: hour, minute: minute, second: second });
	  return date;
	}
	
	function setMonth(date, month) {
	  return set$1(date, "month", month);
	}
	
	function setYear(date, year) {
	  return set$1(date, "year", year);
	}
	
	
	
	// ** Date Getters **
	
	function getSecond(date) {
	  return get$1(date, "second");
	}
	
	function getMinute(date) {
	  return get$1(date, "minute");
	}
	
	function getHour(date) {
	  return get$1(date, "hour");
	}
	
	// Returns day of week
	function getDay(date) {
	  return get$1(date, "day");
	}
	
	function getWeek(date) {
	  return get$1(date, "week");
	}
	
	function getMonth(date) {
	  return get$1(date, "month");
	}
	
	function getYear(date) {
	  return get$1(date, "year");
	}
	
	// Returns day of month
	function getDate(date) {
	  return get$1(date, "date");
	}
	
	
	
	function getDayOfWeekCode(day) {
	  return dayOfWeekCodes[day.isoWeekday()];
	}
	
	// *** Start of ***
	
	function getStartOfDay(date) {
	  return getStartOf(date, "day");
	}
	
	function getStartOfWeek(date) {
	  return getStartOf(date, "week");
	}
	function getStartOfMonth(date) {
	  return getStartOf(date, "month");
	}
	
	function getStartOfDate(date) {
	  return getStartOf(date, "date");
	}
	
	// *** End of ***
	
	
	
	
	
	// ** Date Math **
	
	// *** Addition ***
	
	function addMinutes(date, amount) {
	  return add(date, amount, "minutes");
	}
	
	function addHours(date, amount) {
	  return add(date, amount, "hours");
	}
	
	function addDays(date, amount) {
	  return add(date, amount, "days");
	}
	
	function addWeeks(date, amount) {
	  return add(date, amount, "weeks");
	}
	
	function addMonths(date, amount) {
	  return add(date, amount, "months");
	}
	
	function addYears(date, amount) {
	  return add(date, amount, "years");
	}
	
	// *** Subtraction ***
	function subtractDays(date, amount) {
	  return subtract(date, amount, "days");
	}
	
	function subtractWeeks(date, amount) {
	  return subtract(date, amount, "weeks");
	}
	
	function subtractMonths(date, amount) {
	  return subtract(date, amount, "months");
	}
	
	function subtractYears(date, amount) {
	  return subtract(date, amount, "years");
	}
	
	// ** Date Comparison **
	
	function isBefore(date1, date2) {
	  return date1.isBefore(date2);
	}
	
	function isAfter(date1, date2) {
	  return date1.isAfter(date2);
	}
	
	
	
	function isSameYear(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "year");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameMonth(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "month");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameDay(moment1, moment2) {
	  if (moment1 && moment2) {
	    return moment1.isSame(moment2, "day");
	  } else {
	    return !moment1 && !moment2;
	  }
	}
	
	
	
	function isDayInRange(day, startDate, endDate) {
	  var before = startDate.clone().startOf("day").subtract(1, "seconds");
	  var after = endDate.clone().startOf("day").add(1, "seconds");
	  return day.clone().startOf("day").isBetween(before, after);
	}
	
	// *** Diffing ***
	
	
	
	// ** Date Localization **
	
	function localizeDate(date, locale) {
	  return date.clone().locale(locale || moment.locale());
	}
	
	
	
	
	
	
	
	function getLocaleData(date) {
	  return date.localeData();
	}
	
	function getLocaleDataForLocale(locale) {
	  return moment.localeData(locale);
	}
	
	function getWeekdayMinInLocale(locale, date) {
	  return locale.weekdaysMin(date);
	}
	
	function getWeekdayShortInLocale(locale, date) {
	  return locale.weekdaysShort(date);
	}
	
	// TODO what is this format exactly?
	function getMonthInLocale(locale, date, format) {
	  return locale.months(date, format);
	}
	
	function getMonthShortInLocale(locale, date) {
	  return locale.monthsShort(date);
	}
	
	// ** Utils for some components **
	
	function isDayDisabled(day) {
	  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      minDate = _ref4.minDate,
	      maxDate = _ref4.maxDate,
	      excludeDates = _ref4.excludeDates,
	      includeDates = _ref4.includeDates,
	      filterDate = _ref4.filterDate;
	
	  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
	    return isSameDay(day, excludeDate);
	  }) || includeDates && !includeDates.some(function (includeDate) {
	    return isSameDay(day, includeDate);
	  }) || filterDate && !filterDate(day.clone()) || false;
	}
	
	function isTimeDisabled(time, disabledTimes) {
	  var l = disabledTimes.length;
	  for (var i = 0; i < l; i++) {
	    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isTimeInDisabledRange(time, _ref5) {
	  var minTime = _ref5.minTime,
	      maxTime = _ref5.maxTime;
	
	  if (!minTime || !maxTime) {
	    throw new Error("Both minTime and maxTime props required");
	  }
	
	  var base = moment().hours(0).minutes(0).seconds(0);
	  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
	  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
	  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));
	
	  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
	}
	
	function allDaysDisabledBefore(day, unit) {
	  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      minDate = _ref6.minDate,
	      includeDates = _ref6.includeDates;
	
	  var dateBefore = day.clone().subtract(1, unit);
	  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateBefore.isBefore(includeDate, unit);
	  }) || false;
	}
	
	function allDaysDisabledAfter(day, unit) {
	  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      maxDate = _ref7.maxDate,
	      includeDates = _ref7.includeDates;
	
	  var dateAfter = day.clone().add(1, unit);
	  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateAfter.isAfter(includeDate, unit);
	  }) || false;
	}
	
	function getEffectiveMinDate(_ref8) {
	  var minDate = _ref8.minDate,
	      includeDates = _ref8.includeDates;
	
	  if (includeDates && minDate) {
	    return moment.min(includeDates.filter(function (includeDate) {
	      return minDate.isSameOrBefore(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.min(includeDates);
	  } else {
	    return minDate;
	  }
	}
	
	function getEffectiveMaxDate(_ref9) {
	  var maxDate = _ref9.maxDate,
	      includeDates = _ref9.includeDates;
	
	  if (includeDates && maxDate) {
	    return moment.max(includeDates.filter(function (includeDate) {
	      return maxDate.isSameOrAfter(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.max(includeDates);
	  } else {
	    return maxDate;
	  }
	}
	
	function getHightLightDaysMap() {
	  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";
	
	  var dateClasses = new Map();
	  for (var i = 0, len = highlightDates.length; i < len; i++) {
	    var obj = highlightDates[i];
	    if (isMoment(obj)) {
	      var key = obj.format("MM.DD.YYYY");
	      var classNamesArr = dateClasses.get(key) || [];
	      if (!classNamesArr.includes(defaultClassName)) {
	        classNamesArr.push(defaultClassName);
	        dateClasses.set(key, classNamesArr);
	      }
	    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
	      var keys = Object.keys(obj);
	      var className = keys[0];
	      var arrOfMoments = obj[keys[0]];
	      if (typeof className === "string" && arrOfMoments.constructor === Array) {
	        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
	          var _key = arrOfMoments[k].format("MM.DD.YYYY");
	          var _classNamesArr = dateClasses.get(_key) || [];
	          if (!_classNamesArr.includes(className)) {
	            _classNamesArr.push(className);
	            dateClasses.set(_key, _classNamesArr);
	          }
	        }
	      }
	    }
	  }
	
	  return dateClasses;
	}
	
	function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
	  var l = injectedTimes.length;
	  var times = [];
	  for (var i = 0; i < l; i++) {
	    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
	    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);
	
	    if (injectedTime.isBetween(currentTime, nextTime)) {
	      times.push(injectedTimes[i]);
	    }
	  }
	
	  return times;
	}
	
	var WrappedYearDropdownOptions = onClickOutside(YearDropdownOptions);
	
	var YearDropdown = function (_React$Component) {
	  inherits(YearDropdown, _React$Component);
	
	  function YearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, YearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
	      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
	
	      var options = [];
	      for (var i = minYear; i <= maxYear; i++) {
	        options.push(React.createElement(
	          "option",
	          { key: i, value: i },
	          i
	        ));
	      }
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.year,
	          className: "react-datepicker__year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__year-read-view--selected-year" },
	          _this.props.year
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        year: _this.props.year,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (year) {
	      _this.toggleDropdown();
	      if (year === _this.props.year) return;
	      _this.props.onChange(year);
	    }, _this.toggleDropdown = function (event) {
	      _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      }, function () {
	        if (_this.props.adjustDateOnChange) {
	          _this.handleYearChange(_this.props.date, event);
	        }
	      });
	    }, _this.handleYearChange = function (date, event) {
	      _this.onSelect(date, event);
	      _this.setOpen();
	    }, _this.onSelect = function (date, event) {
	      if (_this.props.onSelect) {
	        _this.props.onSelect(date, event);
	      }
	    }, _this.setOpen = function () {
	      if (_this.props.setOpen) {
	        _this.props.setOpen(true);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  YearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return YearDropdown;
	}(React.Component);
	
	YearDropdown.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number,
	  date: PropTypes.object,
	  onSelect: PropTypes.func,
	  setOpen: PropTypes.func
	};
	
	var MonthDropdownOptions = function (_React$Component) {
	  inherits(MonthDropdownOptions, _React$Component);
	
	  function MonthDropdownOptions() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdownOptions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
	      return _this.props.monthNames.map(function (month, i) {
	        return React.createElement(
	          "div",
	          {
	            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
	            key: month,
	            ref: month,
	            onClick: _this.onChange.bind(_this, i)
	          },
	          _this.props.month === i ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-option--selected" },
	            "\u2713"
	          ) : "",
	          month
	        );
	      });
	    }, _this.onChange = function (month) {
	      return _this.props.onChange(month);
	    }, _this.handleClickOutside = function () {
	      return _this.props.onCancel();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdownOptions.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__month-dropdown" },
	      this.renderOptions()
	    );
	  };
	
	  return MonthDropdownOptions;
	}(React.Component);
	
	MonthDropdownOptions.propTypes = {
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  month: PropTypes.number.isRequired,
	  monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
	};
	
	var WrappedMonthDropdownOptions = onClickOutside(MonthDropdownOptions);
	
	var MonthDropdown = function (_React$Component) {
	  inherits(MonthDropdown, _React$Component);
	
	  function MonthDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function (monthNames) {
	      return monthNames.map(function (M, i) {
	        return React.createElement(
	          "option",
	          { key: i, value: i },
	          M
	        );
	      });
	    }, _this.renderSelectMode = function (monthNames) {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.month,
	          className: "react-datepicker__month-select",
	          onChange: function onChange(e) {
	            return _this.onChange(e.target.value);
	          }
	        },
	        _this.renderSelectOptions(monthNames)
	      );
	    }, _this.renderReadView = function (visible, monthNames) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-read-view",
	          onClick: _this.toggleDropdown
	        },
	        React.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-read-view--selected-month" },
	          monthNames[_this.props.month]
	        )
	      );
	    }, _this.renderDropdown = function (monthNames) {
	      return React.createElement(WrappedMonthDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        month: _this.props.month,
	        monthNames: monthNames,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown
	      });
	    }, _this.renderScrollMode = function (monthNames) {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown(monthNames));
	      }
	      return result;
	    }, _this.onChange = function (month) {
	      _this.toggleDropdown();
	      if (month !== _this.props.month) {
	        _this.props.onChange(month);
	      }
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var localeData = getLocaleDataForLocale(this.props.locale);
	    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
	      return getMonthShortInLocale(localeData, newDate({ M: M }));
	    } : function (M) {
	      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
	    });
	
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode(monthNames);
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode(monthNames);
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthDropdown;
	}(React.Component);
	
	MonthDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  locale: PropTypes.string,
	  dateFormat: PropTypes.string.isRequired,
	  month: PropTypes.number.isRequired,
	  onChange: PropTypes.func.isRequired,
	  useShortMonthInDropdown: PropTypes.bool
	};
	
	function generateMonthYears(minDate, maxDate) {
	  var list = [];
	
	  var currDate = getStartOfMonth(cloneDate(minDate));
	  var lastDate = getStartOfMonth(cloneDate(maxDate));
	
	  while (!isAfter(currDate, lastDate)) {
	    list.push(cloneDate(currDate));
	
	    addMonths(currDate, 1);
	  }
	
	  return list;
	}
	
	var MonthYearDropdownOptions = function (_React$Component) {
	  inherits(MonthYearDropdownOptions, _React$Component);
	
	  function MonthYearDropdownOptions(props) {
	    classCallCheck(this, MonthYearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      return _this.state.monthYearsList.map(function (monthYear) {
	        var monthYearPoint = monthYear.valueOf();
	
	        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
	
	        return React.createElement(
	          "div",
	          {
	            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
	            key: monthYearPoint,
	            ref: monthYearPoint,
	            onClick: _this.onChange.bind(_this, monthYearPoint)
	          },
	          isSameMonthYear ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-year-option--selected" },
	            "\u2713"
	          ) : "",
	          formatDate(monthYear, _this.props.dateFormat)
	        );
	      });
	    };
	
	    _this.onChange = function (monthYear) {
	      return _this.props.onChange(monthYear);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.state = {
	      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  MonthYearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__month-year-dropdown": true,
	      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return MonthYearDropdownOptions;
	}(React.Component);
	
	MonthYearDropdownOptions.propTypes = {
	  minDate: PropTypes.object.isRequired,
	  maxDate: PropTypes.object.isRequired,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  date: PropTypes.object.isRequired,
	  dateFormat: PropTypes.string.isRequired
	};
	
	var WrappedMonthYearDropdownOptions = onClickOutside(MonthYearDropdownOptions);
	
	var MonthYearDropdown = function (_React$Component) {
	  inherits(MonthYearDropdown, _React$Component);
	
	  function MonthYearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthYearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
	      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));
	
	      var options = [];
	
	      while (!isAfter(currDate, lastDate)) {
	        var timepoint = currDate.valueOf();
	        options.push(React.createElement(
	          "option",
	          { key: timepoint, value: timepoint },
	          formatDate(currDate, _this.props.dateFormat)
	        ));
	
	        addMonths(currDate, 1);
	      }
	
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: getStartOfMonth(_this.props.date).valueOf(),
	          className: "react-datepicker__month-year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);
	
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-year-read-view--selected-month-year" },
	          yearMonth
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedMonthYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        date: _this.props.date,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: localizeDate(_this.props.minDate, _this.props.locale),
	        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (monthYearPoint) {
	      _this.toggleDropdown();
	
	      var changedDate = newDate(parseInt(monthYearPoint));
	
	      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
	        return;
	      }
	
	      _this.props.onChange(changedDate);
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthYearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthYearDropdown;
	}(React.Component);
	
	MonthYearDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  dateFormat: PropTypes.string.isRequired,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object.isRequired,
	  minDate: PropTypes.object.isRequired,
	  date: PropTypes.object.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool
	};
	
	var Day = function (_React$Component) {
	  inherits(Day, _React$Component);
	
	  function Day() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (!_this.isDisabled() && _this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.isDisabled() && _this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.isSameDay = function (other) {
	      return isSameDay(_this.props.day, other);
	    }, _this.isKeyboardSelected = function () {
	      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
	    }, _this.isDisabled = function () {
	      return isDayDisabled(_this.props.day, _this.props);
	    }, _this.getHighLightedClass = function (defaultClassName) {
	      var _this$props = _this.props,
	          day = _this$props.day,
	          highlightDates = _this$props.highlightDates;
	
	
	      if (!highlightDates) {
	        return false;
	      }
	
	      // Looking for className in the Map of {'day string, 'className'}
	      var dayStr = day.format("MM.DD.YYYY");
	      return highlightDates.get(dayStr);
	    }, _this.isInRange = function () {
	      var _this$props2 = _this.props,
	          day = _this$props2.day,
	          startDate = _this$props2.startDate,
	          endDate = _this$props2.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isDayInRange(day, startDate, endDate);
	    }, _this.isInSelectingRange = function () {
	      var _this$props3 = _this.props,
	          day = _this$props3.day,
	          selectsStart = _this$props3.selectsStart,
	          selectsEnd = _this$props3.selectsEnd,
	          selectingDate = _this$props3.selectingDate,
	          startDate = _this$props3.startDate,
	          endDate = _this$props3.endDate;
	
	
	      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
	        return false;
	      }
	
	      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
	        return isDayInRange(day, selectingDate, endDate);
	      }
	
	      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
	        return isDayInRange(day, startDate, selectingDate);
	      }
	
	      return false;
	    }, _this.isSelectingRangeStart = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props4 = _this.props,
	          day = _this$props4.day,
	          selectingDate = _this$props4.selectingDate,
	          startDate = _this$props4.startDate,
	          selectsStart = _this$props4.selectsStart;
	
	
	      if (selectsStart) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, startDate);
	      }
	    }, _this.isSelectingRangeEnd = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props5 = _this.props,
	          day = _this$props5.day,
	          selectingDate = _this$props5.selectingDate,
	          endDate = _this$props5.endDate,
	          selectsEnd = _this$props5.selectsEnd;
	
	
	      if (selectsEnd) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, endDate);
	      }
	    }, _this.isRangeStart = function () {
	      var _this$props6 = _this.props,
	          day = _this$props6.day,
	          startDate = _this$props6.startDate,
	          endDate = _this$props6.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(startDate, day);
	    }, _this.isRangeEnd = function () {
	      var _this$props7 = _this.props,
	          day = _this$props7.day,
	          startDate = _this$props7.startDate,
	          endDate = _this$props7.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(endDate, day);
	    }, _this.isWeekend = function () {
	      var weekday = getDay(_this.props.day);
	      return weekday === 0 || weekday === 6;
	    }, _this.isOutsideMonth = function () {
	      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
	    }, _this.getClassNames = function (date) {
	      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
	      return classnames("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
	        "react-datepicker__day--disabled": _this.isDisabled(),
	        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
	        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
	        "react-datepicker__day--range-start": _this.isRangeStart(),
	        "react-datepicker__day--range-end": _this.isRangeEnd(),
	        "react-datepicker__day--in-range": _this.isInRange(),
	        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
	        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
	        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
	        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
	        "react-datepicker__day--weekend": _this.isWeekend(),
	        "react-datepicker__day--outside-month": _this.isOutsideMonth()
	      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Day.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(this.props.day),
	        onClick: this.handleClick,
	        onMouseEnter: this.handleMouseEnter,
	        "aria-label": "day-" + getDate(this.props.day),
	        role: "option"
	      },
	      getDate(this.props.day)
	    );
	  };
	
	  return Day;
	}(React.Component);
	
	Day.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  highlightDates: PropTypes.instanceOf(Map),
	  inline: PropTypes.bool,
	  month: PropTypes.number,
	  onClick: PropTypes.func,
	  onMouseEnter: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var WeekNumber = function (_React$Component) {
	  inherits(WeekNumber, _React$Component);
	
	  function WeekNumber() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, WeekNumber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  WeekNumber.prototype.render = function render() {
	    var weekNumberClasses = {
	      "react-datepicker__week-number": true,
	      "react-datepicker__week-number--clickable": !!this.props.onClick
	    };
	    return React.createElement(
	      "div",
	      {
	        className: classnames(weekNumberClasses),
	        "aria-label": "week-" + this.props.weekNumber,
	        onClick: this.handleClick
	      },
	      this.props.weekNumber
	    );
	  };
	
	  return WeekNumber;
	}(React.Component);
	
	WeekNumber.propTypes = {
	  weekNumber: PropTypes.number.isRequired,
	  onClick: PropTypes.func
	};
	
	var Week = function (_React$Component) {
	  inherits(Week, _React$Component);
	
	  function Week() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Week);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleWeekClick = function (day, weekNumber, event) {
	      if (typeof _this.props.onWeekSelect === "function") {
	        _this.props.onWeekSelect(day, weekNumber, event);
	      }
	    }, _this.formatWeekNumber = function (startOfWeek) {
	      if (_this.props.formatWeekNumber) {
	        return _this.props.formatWeekNumber(startOfWeek);
	      }
	      return getWeek(startOfWeek);
	    }, _this.renderDays = function () {
	      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
	      var days = [];
	      var weekNumber = _this.formatWeekNumber(startOfWeek);
	      if (_this.props.showWeekNumber) {
	        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
	        days.push(React.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
	      }
	      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        return React.createElement(Day, {
	          key: offset,
	          day: day,
	          month: _this.props.month,
	          onClick: _this.handleDayClick.bind(_this, day),
	          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset
	        });
	      }));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Week.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__week" },
	      this.renderDays()
	    );
	  };
	
	  return Week;
	}(React.Component);
	
	Week.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  month: PropTypes.number,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumber: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
	
	var Month = function (_React$Component) {
	  inherits(Month, _React$Component);
	
	  function Month() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleMouseLeave = function () {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave();
	      }
	    }, _this.isWeekInMonth = function (startOfWeek) {
	      var day = _this.props.day;
	      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
	      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
	    }, _this.renderWeeks = function () {
	      var weeks = [];
	      var isFixedHeight = _this.props.fixedHeight;
	      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
	      var i = 0;
	      var breakAfterNextPush = false;
	
	      while (true) {
	        weeks.push(React.createElement(Week, {
	          key: i,
	          day: currentWeekStart,
	          month: getMonth(_this.props.day),
	          onDayClick: _this.handleDayClick,
	          onDayMouseEnter: _this.handleDayMouseEnter,
	          onWeekSelect: _this.props.onWeekSelect,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          showWeekNumber: _this.props.showWeekNumbers,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset
	        }));
	
	        if (breakAfterNextPush) break;
	
	        i++;
	        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);
	
	        // If one of these conditions is true, we will either break on this week
	        // or break on the next week
	        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
	        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
	
	        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
	          if (_this.props.peekNextMonth) {
	            breakAfterNextPush = true;
	          } else {
	            break;
	          }
	        }
	      }
	
	      return weeks;
	    }, _this.getClassNames = function () {
	      var _this$props = _this.props,
	          selectingDate = _this$props.selectingDate,
	          selectsStart = _this$props.selectsStart,
	          selectsEnd = _this$props.selectsEnd;
	
	      return classnames("react-datepicker__month", {
	        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Month.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(),
	        onMouseLeave: this.handleMouseLeave,
	        role: "listbox"
	      },
	      this.renderWeeks()
	    );
	  };
	
	  return Month;
	}(React.Component);
	
	Month.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onMouseLeave: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  peekNextMonth: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var Time = function (_React$Component) {
	  inherits(Time, _React$Component);
	
	  function Time() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Time);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        return;
	      }
	
	      _this.props.onChange(time);
	    }, _this.liClasses = function (time, currH, currM) {
	      var classes = ["react-datepicker__time-list-item"];
	
	      if (currH === getHour(time) && currM === getMinute(time)) {
	        classes.push("react-datepicker__time-list-item--selected");
	      }
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        classes.push("react-datepicker__time-list-item--disabled");
	      }
	      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
	        classes.push("react-datepicker__time-list-item--injected");
	      }
	
	      return classes.join(" ");
	    }, _this.renderTimes = function () {
	      var times = [];
	      var format = _this.props.format ? _this.props.format : "hh:mm A";
	      var intervals = _this.props.intervals;
	      var activeTime = _this.props.selected ? _this.props.selected : newDate();
	      var currH = getHour(activeTime);
	      var currM = getMinute(activeTime);
	      var base = getStartOfDay(newDate());
	      var multiplier = 1440 / intervals;
	      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
	        return a - b;
	      });
	      for (var i = 0; i < multiplier; i++) {
	        var currentTime = addMinutes(cloneDate(base), i * intervals);
	        times.push(currentTime);
	
	        if (sortedInjectTimes) {
	          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
	          times = times.concat(timesToInject);
	        }
	      }
	
	      return times.map(function (time, i) {
	        return React.createElement(
	          "li",
	          {
	            key: i,
	            onClick: _this.handleClick.bind(_this, time),
	            className: _this.liClasses(time, currH, currM)
	          },
	          formatDate(time, format)
	        );
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Time.prototype.componentDidMount = function componentDidMount() {
	    // code to ensure selected time will always be in focus within time window when it first appears
	    var multiplier = 60 / this.props.intervals;
	    var currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
	    this.list.scrollTop = 30 * (multiplier * currH);
	  };
	
	  Time.prototype.render = function render() {
	    var _this2 = this;
	
	    var height = null;
	    if (this.props.monthRef) {
	      height = this.props.monthRef.clientHeight - 39;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
	      },
	      React.createElement(
	        "div",
	        { className: "react-datepicker__header react-datepicker__header--time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker-time__header" },
	          this.props.timeCaption
	        )
	      ),
	      React.createElement(
	        "div",
	        { className: "react-datepicker__time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker__time-box" },
	          React.createElement(
	            "ul",
	            {
	              className: "react-datepicker__time-list",
	              ref: function ref(list) {
	                _this2.list = list;
	              },
	              style: height ? { height: height } : {}
	            },
	            this.renderTimes.bind(this)()
	          )
	        )
	      )
	    );
	  };
	
	  createClass(Time, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        intervals: 30,
	        onTimeChange: function onTimeChange() {},
	        todayButton: null,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	  return Time;
	}(React.Component);
	
	Time.propTypes = {
	  format: PropTypes.string,
	  includeTimes: PropTypes.array,
	  intervals: PropTypes.number,
	  selected: PropTypes.object,
	  onChange: PropTypes.func,
	  todayButton: PropTypes.string,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  monthRef: PropTypes.object,
	  timeCaption: PropTypes.string,
	  injectTimes: PropTypes.array
	};
	
	var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];
	
	var isDropdownSelect = function isDropdownSelect() {
	  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var classNames = (element.className || "").split(/\s+/);
	  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
	    return classNames.indexOf(testClassname) >= 0;
	  });
	};
	
	var Calendar = function (_React$Component) {
	  inherits(Calendar, _React$Component);
	  createClass(Calendar, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        onDropdownFocus: function onDropdownFocus() {},
	        monthsShown: 1,
	        forceShowMonthNavigation: false,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	
	  function Calendar(props) {
	    classCallCheck(this, Calendar);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClickOutside = function (event) {
	      _this.props.onClickOutside(event);
	    };
	
	    _this.handleDropdownFocus = function (event) {
	      if (isDropdownSelect(event.target)) {
	        _this.props.onDropdownFocus();
	      }
	    };
	
	    _this.getDateInView = function () {
	      var _this$props = _this.props,
	          preSelection = _this$props.preSelection,
	          selected = _this$props.selected,
	          openToDate = _this$props.openToDate,
	          utcOffset = _this$props.utcOffset;
	
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var current = now(utcOffset);
	      var initialDate = openToDate || selected || preSelection;
	      if (initialDate) {
	        return initialDate;
	      } else {
	        if (minDate && isBefore(current, minDate)) {
	          return minDate;
	        } else if (maxDate && isAfter(current, maxDate)) {
	          return maxDate;
	        }
	      }
	      return current;
	    };
	
	    _this.localizeDate = function (date) {
	      return localizeDate(date, _this.props.locale);
	    };
	
	    _this.increaseMonth = function () {
	      _this.setState({
	        date: addMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.decreaseMonth = function () {
	      _this.setState({
	        date: subtractMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.handleDayClick = function (day, event) {
	      return _this.props.onSelect(day, event);
	    };
	
	    _this.handleDayMouseEnter = function (day) {
	      return _this.setState({ selectingDate: day });
	    };
	
	    _this.handleMonthMouseLeave = function () {
	      return _this.setState({ selectingDate: null });
	    };
	
	    _this.handleYearChange = function (date) {
	      if (_this.props.onYearChange) {
	        _this.props.onYearChange(date);
	      }
	    };
	
	    _this.handleMonthChange = function (date) {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(date);
	      }
	      if (_this.props.adjustDateOnChange) {
	        if (_this.props.onSelect) {
	          _this.props.onSelect(date);
	        }
	        if (_this.props.setOpen) {
	          _this.props.setOpen(true);
	        }
	      }
	    };
	
	    _this.handleMonthYearChange = function (date) {
	      _this.handleYearChange(date);
	      _this.handleMonthChange(date);
	    };
	
	    _this.changeYear = function (year) {
	      _this.setState({
	        date: setYear(cloneDate(_this.state.date), year)
	      }, function () {
	        return _this.handleYearChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonth = function (month) {
	      _this.setState({
	        date: setMonth(cloneDate(_this.state.date), month)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonthYear = function (monthYear) {
	      _this.setState({
	        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
	      }, function () {
	        return _this.handleMonthYearChange(_this.state.date);
	      });
	    };
	
	    _this.header = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var startOfWeek = getStartOfWeek(cloneDate(date));
	      var dayNames = [];
	      if (_this.props.showWeekNumbers) {
	        dayNames.push(React.createElement(
	          "div",
	          { key: "W", className: "react-datepicker__day-name" },
	          _this.props.weekLabel || "#"
	        ));
	      }
	      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        var localeData = getLocaleData(day);
	        var weekDayName = _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
	        return React.createElement(
	          "div",
	          { key: offset, className: "react-datepicker__day-name" },
	          weekDayName
	        );
	      }));
	    };
	
	    _this.renderPreviousMonthButton = function () {
	      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
	
	      var clickHandler = _this.decreaseMonth;
	
	      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--previous--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement("button", {
	        type: "button",
	        className: classes.join(" "),
	        onClick: clickHandler
	      });
	    };
	
	    _this.renderNextMonthButton = function () {
	      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
	      if (_this.props.showTimeSelect) {
	        classes.push("react-datepicker__navigation--next--with-time");
	      }
	      if (_this.props.todayButton) {
	        classes.push("react-datepicker__navigation--next--with-today-button");
	      }
	
	      var clickHandler = _this.increaseMonth;
	
	      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--next--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement("button", {
	        type: "button",
	        className: classes.join(" "),
	        onClick: clickHandler
	      });
	    };
	
	    _this.renderCurrentMonth = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var classes = ["react-datepicker__current-month"];
	
	      if (_this.props.showYearDropdown) {
	        classes.push("react-datepicker__current-month--hasYearDropdown");
	      }
	      if (_this.props.showMonthDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthDropdown");
	      }
	      if (_this.props.showMonthYearDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
	      }
	      return React.createElement(
	        "div",
	        { className: classes.join(" ") },
	        formatDate(date, _this.props.dateFormat)
	      );
	    };
	
	    _this.renderYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(YearDropdown, {
	        adjustDateOnChange: _this.props.adjustDateOnChange,
	        date: _this.state.date,
	        onSelect: _this.props.onSelect,
	        setOpen: _this.props.setOpen,
	        dropdownMode: _this.props.dropdownMode,
	        onChange: _this.changeYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        year: getYear(_this.state.date),
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    };
	
	    _this.renderMonthDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonth,
	        month: getMonth(_this.state.date),
	        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
	      });
	    };
	
	    _this.renderMonthYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthYearDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonthYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        date: _this.state.date,
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    };
	
	    _this.renderTodayButton = function () {
	      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
	        return;
	      }
	      return React.createElement(
	        "div",
	        {
	          className: "react-datepicker__today-button",
	          onClick: function onClick(e) {
	            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
	          }
	        },
	        _this.props.todayButton
	      );
	    };
	
	    _this.renderMonths = function () {
	      if (_this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var monthList = [];
	      for (var i = 0; i < _this.props.monthsShown; ++i) {
	        var monthDate = addMonths(cloneDate(_this.state.date), i);
	        var monthKey = "month-" + i;
	        monthList.push(React.createElement(
	          "div",
	          {
	            key: monthKey,
	            ref: function ref(div) {
	              _this.monthContainer = div;
	            },
	            className: "react-datepicker__month-container"
	          },
	          React.createElement(
	            "div",
	            { className: "react-datepicker__header" },
	            _this.renderCurrentMonth(monthDate),
	            React.createElement(
	              "div",
	              {
	                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
	                onFocus: _this.handleDropdownFocus
	              },
	              _this.renderMonthDropdown(i !== 0),
	              _this.renderMonthYearDropdown(i !== 0),
	              _this.renderYearDropdown(i !== 0)
	            ),
	            React.createElement(
	              "div",
	              { className: "react-datepicker__day-names" },
	              _this.header(monthDate)
	            )
	          ),
	          React.createElement(Month, {
	            day: monthDate,
	            dayClassName: _this.props.dayClassName,
	            onDayClick: _this.handleDayClick,
	            onDayMouseEnter: _this.handleDayMouseEnter,
	            onMouseLeave: _this.handleMonthMouseLeave,
	            onWeekSelect: _this.props.onWeekSelect,
	            formatWeekNumber: _this.props.formatWeekNumber,
	            minDate: _this.props.minDate,
	            maxDate: _this.props.maxDate,
	            excludeDates: _this.props.excludeDates,
	            highlightDates: _this.props.highlightDates,
	            selectingDate: _this.state.selectingDate,
	            includeDates: _this.props.includeDates,
	            inline: _this.props.inline,
	            fixedHeight: _this.props.fixedHeight,
	            filterDate: _this.props.filterDate,
	            preSelection: _this.props.preSelection,
	            selected: _this.props.selected,
	            selectsStart: _this.props.selectsStart,
	            selectsEnd: _this.props.selectsEnd,
	            showWeekNumbers: _this.props.showWeekNumbers,
	            startDate: _this.props.startDate,
	            endDate: _this.props.endDate,
	            peekNextMonth: _this.props.peekNextMonth,
	            utcOffset: _this.props.utcOffset
	          })
	        ));
	      }
	      return monthList;
	    };
	
	    _this.renderTimeSection = function () {
	      if (_this.props.showTimeSelect) {
	        return React.createElement(Time, {
	          selected: _this.props.selected,
	          onChange: _this.props.onTimeChange,
	          format: _this.props.timeFormat,
	          includeTimes: _this.props.includeTimes,
	          intervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          todayButton: _this.props.todayButton,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          monthRef: _this.state.monthContainer,
	          injectTimes: _this.props.injectTimes
	        });
	      }
	    };
	
	    _this.state = {
	      date: _this.localizeDate(_this.getDateInView()),
	      selectingDate: null,
	      monthContainer: _this.monthContainer
	    };
	    return _this;
	  }
	
	  Calendar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // monthContainer height is needed in time component
	    // to determine the height for the ul in the time component
	    // setState here so height is given after final component
	    // layout is rendered
	    if (this.props.showTimeSelect) {
	      this.assignMonthContainer = function () {
	        _this2.setState({ monthContainer: _this2.monthContainer });
	      }();
	    }
	  };
	
	  Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.preSelection && !isSameDay(nextProps.preSelection, this.props.preSelection)) {
	      this.setState({
	        date: this.localizeDate(nextProps.preSelection)
	      });
	    } else if (nextProps.openToDate && !isSameDay(nextProps.openToDate, this.props.openToDate)) {
	      this.setState({
	        date: this.localizeDate(nextProps.openToDate)
	      });
	    }
	  };
	
	  Calendar.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: classnames("react-datepicker", this.props.className, {
	          "react-datepicker--time-only": this.props.showTimeSelectOnly
	        })
	      },
	      React.createElement("div", { className: "react-datepicker__triangle" }),
	      this.renderPreviousMonthButton(),
	      this.renderNextMonthButton(),
	      this.renderMonths(),
	      this.renderTodayButton(),
	      this.renderTimeSection(),
	      this.props.children
	    );
	  };
	
	  return Calendar;
	}(React.Component);
	
	Calendar.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
	  dayClassName: PropTypes.func,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]),
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  onClickOutside: PropTypes.func.isRequired,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  forceShowMonthNavigation: PropTypes.bool,
	  onDropdownFocus: PropTypes.func,
	  onSelect: PropTypes.func.isRequired,
	  onWeekSelect: PropTypes.func,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  onTimeChange: PropTypes.func,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  timeCaption: PropTypes.string,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  startDate: PropTypes.object,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  withPortal: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  weekLabel: PropTypes.string,
	  yearDropdownItemNumber: PropTypes.number,
	  setOpen: PropTypes.func,
	  useShortMonthInDropdown: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool
	};
	
	var popperPlacementPositions = ["auto", "auto-left", "auto-right", "bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];
	
	var PopperComponent = function (_React$Component) {
	  inherits(PopperComponent, _React$Component);
	
	  function PopperComponent() {
	    classCallCheck(this, PopperComponent);
	    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PopperComponent.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        hidePopper = _props.hidePopper,
	        popperComponent = _props.popperComponent,
	        popperModifiers = _props.popperModifiers,
	        popperPlacement = _props.popperPlacement,
	        targetComponent = _props.targetComponent;
	
	
	    var popper = void 0;
	
	    if (!hidePopper) {
	      var classes = classnames("react-datepicker-popper", className);
	      popper = React.createElement(
	        reactPopper.Popper,
	        {
	          className: classes,
	          modifiers: popperModifiers,
	          placement: popperPlacement
	        },
	        popperComponent
	      );
	    }
	
	    if (this.props.popperContainer) {
	      popper = React.createElement(this.props.popperContainer, {}, popper);
	    }
	
	    return React.createElement(
	      reactPopper.Manager,
	      null,
	      React.createElement(
	        reactPopper.Target,
	        { className: "react-datepicker-wrapper" },
	        targetComponent
	      ),
	      popper
	    );
	  };
	
	  createClass(PopperComponent, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        hidePopper: true,
	        popperModifiers: {
	          preventOverflow: {
	            enabled: true,
	            escapeWithReference: true,
	            boundariesElement: "viewport"
	          }
	        },
	        popperPlacement: "bottom-start"
	      };
	    }
	  }]);
	  return PopperComponent;
	}(React.Component);
	
	PopperComponent.propTypes = {
	  className: PropTypes.string,
	  hidePopper: PropTypes.bool,
	  popperComponent: PropTypes.element,
	  popperModifiers: PropTypes.object, // <datepicker/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <datepicker/> props
	  popperContainer: PropTypes.func,
	  targetComponent: PropTypes.element
	};
	
	var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
	var WrappedCalendar = onClickOutside(Calendar);
	
	// Compares dates year+month combinations
	function hasPreSelectionChanged(date1, date2) {
	  if (date1 && date2) {
	    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
	  }
	
	  return date1 !== date2;
	}
	
	/**
	 * General datepicker component.
	 */
	
	var DatePicker = function (_React$Component) {
	  inherits(DatePicker, _React$Component);
	  createClass(DatePicker, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        allowSameDay: false,
	        dateFormat: "L",
	        dateFormatCalendar: "MMMM YYYY",
	        onChange: function onChange() {},
	
	        disabled: false,
	        disabledKeyboardNavigation: false,
	        dropdownMode: "scroll",
	        onFocus: function onFocus() {},
	        onBlur: function onBlur() {},
	        onKeyDown: function onKeyDown() {},
	        onSelect: function onSelect() {},
	        onClickOutside: function onClickOutside$$1() {},
	        onMonthChange: function onMonthChange() {},
	
	        preventOpenOnFocus: false,
	        onYearChange: function onYearChange() {},
	
	        monthsShown: 1,
	        withPortal: false,
	        shouldCloseOnSelect: true,
	        showTimeSelect: false,
	        timeIntervals: 30,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	
	  function DatePicker(props) {
	    classCallCheck(this, DatePicker);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.getPreSelection = function () {
	      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
	    };
	
	    _this.calcInitialState = function () {
	      var defaultPreSelection = _this.getPreSelection();
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
	      return {
	        open: _this.props.startOpen || false,
	        preventFocus: false,
	        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
	        // transforming highlighted days (perhaps nested array)
	        // to flat Map for faster access in day.jsx
	        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
	        focused: false
	      };
	    };
	
	    _this.clearPreventFocusTimeout = function () {
	      if (_this.preventFocusTimeout) {
	        clearTimeout(_this.preventFocusTimeout);
	      }
	    };
	
	    _this.setFocus = function () {
	      if (_this.input && _this.input.focus) {
	        _this.input.focus();
	      }
	    };
	
	    _this.setOpen = function (open) {
	      _this.setState({
	        open: open,
	        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection
	      });
	    };
	
	    _this.handleFocus = function (event) {
	      if (!_this.state.preventFocus) {
	        _this.props.onFocus(event);
	        if (!_this.props.preventOpenOnFocus) {
	          _this.setOpen(true);
	        }
	      }
	      _this.setState({ focused: true });
	    };
	
	    _this.cancelFocusInput = function () {
	      clearTimeout(_this.inputFocusTimeout);
	      _this.inputFocusTimeout = null;
	    };
	
	    _this.deferFocusInput = function () {
	      _this.cancelFocusInput();
	      _this.inputFocusTimeout = setTimeout(function () {
	        return _this.setFocus();
	      }, 1);
	    };
	
	    _this.handleDropdownFocus = function () {
	      _this.cancelFocusInput();
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.state.open) {
	        _this.deferFocusInput();
	      } else {
	        _this.props.onBlur(event);
	      }
	      _this.setState({ focused: false });
	    };
	
	    _this.handleCalendarClickOutside = function (event) {
	      if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	      _this.props.onClickOutside(event);
	      if (_this.props.withPortal) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleChange = function () {
	      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
	        allArgs[_key] = arguments[_key];
	      }
	
	      var event = allArgs[0];
	      if (_this.props.onChangeRaw) {
	        _this.props.onChangeRaw.apply(_this, allArgs);
	        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
	          return;
	        }
	      }
	      _this.setState({ inputValue: event.target.value });
	      var date = parseDate(event.target.value, _this.props);
	      if (date || !event.target.value) {
	        _this.setSelected(date, event, true);
	      }
	    };
	
	    _this.handleSelect = function (date, event) {
	      // Preventing onFocus event to fix issue
	      // https://github.com/Hacker0x01/react-datepicker/issues/628
	      _this.setState({ preventFocus: true }, function () {
	        _this.preventFocusTimeout = setTimeout(function () {
	          return _this.setState({ preventFocus: false });
	        }, 50);
	        return _this.preventFocusTimeout;
	      });
	      _this.setSelected(date, event);
	      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
	        _this.setPreSelection(date);
	      } else if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	    };
	
	    _this.setSelected = function (date, event, keepInput) {
	      var changedDate = date;
	
	      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
	        return;
	      }
	
	      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
	        if (changedDate !== null) {
	          if (_this.props.selected) {
	            var selected = _this.props.selected;
	            if (keepInput) selected = newDate(changedDate);
	            changedDate = setTime(newDate(changedDate), {
	              hour: getHour(selected),
	              minute: getMinute(selected),
	              second: getSecond(selected)
	            });
	          }
	          _this.setState({
	            preSelection: changedDate
	          });
	        }
	        _this.props.onChange(changedDate, event);
	      }
	
	      _this.props.onSelect(changedDate, event);
	
	      if (!keepInput) {
	        _this.setState({ inputValue: null });
	      }
	    };
	
	    _this.setPreSelection = function (date) {
	      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
	      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
	      if (isValidDateSelection) {
	        _this.setState({
	          preSelection: date
	        });
	      }
	    };
	
	    _this.handleTimeChange = function (time) {
	      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
	      var changedDate = setTime(cloneDate(selected), {
	        hour: getHour(time),
	        minute: getMinute(time)
	      });
	
	      _this.setState({
	        preSelection: changedDate
	      });
	
	      _this.props.onChange(changedDate);
	      _this.setOpen(false);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.onInputClick = function () {
	      if (!_this.props.disabled) {
	        _this.setOpen(true);
	      }
	    };
	
	    _this.onInputKeyDown = function (event) {
	      _this.props.onKeyDown(event);
	      var eventKey = event.key;
	      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
	        if (eventKey !== "Enter" && eventKey !== "Escape" && eventKey !== "Tab") {
	          _this.onInputClick();
	        }
	        return;
	      }
	      var copy = newDate(_this.state.preSelection);
	      if (eventKey === "Enter") {
	        event.preventDefault();
	        if (isMoment(_this.state.preSelection) || isDate(_this.state.preSelection)) {
	          _this.handleSelect(copy, event);
	          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
	        } else {
	          _this.setOpen(false);
	        }
	      } else if (eventKey === "Escape") {
	        event.preventDefault();
	        _this.setOpen(false);
	      } else if (eventKey === "Tab") {
	        _this.setOpen(false);
	      } else if (!_this.props.disabledKeyboardNavigation) {
	        var newSelection = void 0;
	        switch (eventKey) {
	          case "ArrowLeft":
	            event.preventDefault();
	            newSelection = subtractDays(copy, 1);
	            break;
	          case "ArrowRight":
	            event.preventDefault();
	            newSelection = addDays(copy, 1);
	            break;
	          case "ArrowUp":
	            event.preventDefault();
	            newSelection = subtractWeeks(copy, 1);
	            break;
	          case "ArrowDown":
	            event.preventDefault();
	            newSelection = addWeeks(copy, 1);
	            break;
	          case "PageUp":
	            event.preventDefault();
	            newSelection = subtractMonths(copy, 1);
	            break;
	          case "PageDown":
	            event.preventDefault();
	            newSelection = addMonths(copy, 1);
	            break;
	          case "Home":
	            event.preventDefault();
	            newSelection = subtractYears(copy, 1);
	            break;
	          case "End":
	            event.preventDefault();
	            newSelection = addYears(copy, 1);
	            break;
	        }
	        if (_this.props.adjustDateOnChange) {
	          _this.setSelected(newSelection);
	        }
	        _this.setPreSelection(newSelection);
	      }
	    };
	
	    _this.onClearClick = function (event) {
	      if (event) {
	        if (event.preventDefault) {
	          event.preventDefault();
	        }
	      }
	      _this.props.onChange(null, event);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.clear = function () {
	      _this.onClearClick();
	    };
	
	    _this.renderCalendar = function () {
	      if (!_this.props.inline && (!_this.state.open || _this.props.disabled)) {
	        return null;
	      }
	      return React.createElement(
	        WrappedCalendar,
	        {
	          ref: function ref(elem) {
	            _this.calendar = elem;
	          },
	          locale: _this.props.locale,
	          adjustDateOnChange: _this.props.adjustDateOnChange,
	          setOpen: _this.setOpen,
	          dateFormat: _this.props.dateFormatCalendar,
	          useWeekdaysShort: _this.props.useWeekdaysShort,
	          dropdownMode: _this.props.dropdownMode,
	          selected: _this.props.selected,
	          preSelection: _this.state.preSelection,
	          onSelect: _this.handleSelect,
	          onWeekSelect: _this.props.onWeekSelect,
	          openToDate: _this.props.openToDate,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          excludeDates: _this.props.excludeDates,
	          filterDate: _this.props.filterDate,
	          onClickOutside: _this.handleCalendarClickOutside,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          highlightDates: _this.state.highlightDates,
	          includeDates: _this.props.includeDates,
	          includeTimes: _this.props.includeTimes,
	          injectTimes: _this.props.injectTimes,
	          inline: _this.props.inline,
	          peekNextMonth: _this.props.peekNextMonth,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showWeekNumbers: _this.props.showWeekNumbers,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
	          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
	          scrollableYearDropdown: _this.props.scrollableYearDropdown,
	          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
	          todayButton: _this.props.todayButton,
	          weekLabel: _this.props.weekLabel,
	          utcOffset: _this.props.utcOffset,
	          outsideClickIgnoreClass: outsideClickIgnoreClass,
	          fixedHeight: _this.props.fixedHeight,
	          monthsShown: _this.props.monthsShown,
	          onDropdownFocus: _this.handleDropdownFocus,
	          onMonthChange: _this.props.onMonthChange,
	          onYearChange: _this.props.onYearChange,
	          dayClassName: _this.props.dayClassName,
	          showTimeSelect: _this.props.showTimeSelect,
	          showTimeSelectOnly: _this.props.showTimeSelectOnly,
	          onTimeChange: _this.handleTimeChange,
	          timeFormat: _this.props.timeFormat,
	          timeIntervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          className: _this.props.calendarClassName,
	          yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	        },
	        _this.props.children
	      );
	    };
	
	    _this.renderDateInput = function () {
	      var _classnames, _React$cloneElement;
	
	      var className = classnames(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));
	
	      var customInput = _this.props.customInput || React.createElement("input", { type: "text" });
	      var customInputRef = _this.props.customInputRef || "ref";
	      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);
	
	      return React.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
	        _this.input = input;
	      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
	    };
	
	    _this.renderClearButton = function () {
	      if (_this.props.isClearable && _this.props.selected != null) {
	        return React.createElement("button", {
	          className: "react-datepicker__close-icon",
	          onClick: _this.onClearClick,
	          title: _this.props.clearButtonTitle,
	          tabIndex: -1
	        });
	      } else {
	        return null;
	      }
	    };
	
	    _this.state = _this.calcInitialState();
	    return _this;
	  }
	
	  DatePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.inline && hasPreSelectionChanged(this.props.selected, nextProps.selected)) {
	      this.setPreSelection(nextProps.selected);
	    }
	    if (this.props.highlightDates !== nextProps.highlightDates) {
	      this.setState({
	        highlightDates: getHightLightDaysMap(nextProps.highlightDates)
	      });
	    }
	    if (!this.state.focused) this.setState({ inputValue: null });
	  };
	
	  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearPreventFocusTimeout();
	  };
	
	  DatePicker.prototype.render = function render() {
	    var calendar = this.renderCalendar();
	
	    if (this.props.inline && !this.props.withPortal) {
	      return calendar;
	    }
	
	    if (this.props.withPortal) {
	      return React.createElement(
	        "div",
	        null,
	        !this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__input-container" },
	          this.renderDateInput(),
	          this.renderClearButton()
	        ) : null,
	        this.state.open || this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__portal" },
	          calendar
	        ) : null
	      );
	    }
	
	    return React.createElement(PopperComponent, {
	      className: this.props.popperClassName,
	      hidePopper: !this.state.open || this.props.disabled,
	      popperModifiers: this.props.popperModifiers,
	      targetComponent: React.createElement(
	        "div",
	        { className: "react-datepicker__input-container" },
	        this.renderDateInput(),
	        this.renderClearButton()
	      ),
	      popperContainer: this.props.popperContainer,
	      popperComponent: calendar,
	      popperPlacement: this.props.popperPlacement
	    });
	  };
	
	  return DatePicker;
	}(React.Component);
	
	DatePicker.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  allowSameDay: PropTypes.bool,
	  autoComplete: PropTypes.string,
	  autoFocus: PropTypes.bool,
	  calendarClassName: PropTypes.string,
	  children: PropTypes.node,
	  className: PropTypes.string,
	  customInput: PropTypes.element,
	  customInputRef: PropTypes.string,
	  // eslint-disable-next-line react/no-unused-prop-types
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	  dateFormatCalendar: PropTypes.string,
	  dayClassName: PropTypes.func,
	  disabled: PropTypes.bool,
	  disabledKeyboardNavigation: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  id: PropTypes.string,
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  isClearable: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  name: PropTypes.string,
	  onBlur: PropTypes.func,
	  onChange: PropTypes.func.isRequired,
	  onSelect: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  onClickOutside: PropTypes.func,
	  onChangeRaw: PropTypes.func,
	  onFocus: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  placeholderText: PropTypes.string,
	  popperContainer: PropTypes.func,
	  popperClassName: PropTypes.string, // <PopperComponent/> props
	  popperModifiers: PropTypes.object, // <PopperComponent/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <PopperComponent/> props
	  preventOpenOnFocus: PropTypes.bool,
	  readOnly: PropTypes.bool,
	  required: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  forceShowMonthNavigation: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool,
	  startDate: PropTypes.object,
	  startOpen: PropTypes.bool,
	  tabIndex: PropTypes.number,
	  timeCaption: PropTypes.string,
	  title: PropTypes.string,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  value: PropTypes.string,
	  weekLabel: PropTypes.string,
	  withPortal: PropTypes.bool,
	  yearDropdownItemNumber: PropTypes.number,
	  shouldCloseOnSelect: PropTypes.bool,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  useShortMonthInDropdown: PropTypes.bool,
	  clearButtonTitle: PropTypes.string
	};
	
	module.exports = DatePicker;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(194);
	var Danger = __webpack_require__(2768);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstrumentation = __webpack_require__(90);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(450);
	var setInnerHTML = __webpack_require__(319);
	var setTextContent = __webpack_require__(911);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 442 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 444 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactPropTypesSecret = __webpack_require__(2798);
	var propTypesFactory = __webpack_require__(863);
	
	var React = __webpack_require__(201);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(34);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(21);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactInstanceMap = __webpack_require__(241);
	var ReactInstrumentation = __webpack_require__(90);
	var ReactUpdates = __webpack_require__(99);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(34);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 449 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 450 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 451 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 452 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 453 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(59);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 455 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var emptyFunction = __webpack_require__(87);
	var warning = __webpack_require__(34);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(464),
	    baseLodash = __webpack_require__(466);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(464),
	    baseLodash = __webpack_require__(466);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 459 */
[3176, 159, 82],
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(2928),
	    mapCacheDelete = __webpack_require__(2929),
	    mapCacheGet = __webpack_require__(2930),
	    mapCacheHas = __webpack_require__(2931),
	    mapCacheSet = __webpack_require__(2932);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 461 */
[3180, 82],
/* 462 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 463 */
/***/ function(module, exports) {

	/** Built-in value references. */
	var defineProperty = Object.defineProperty;
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(128);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = prototype;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 465 */
[3191, 2886, 2887, 244, 91, 2968],
/* 466 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 467 */
[3195, 244, 943, 470],
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(942),
	    noop = __webpack_require__(948);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 469 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 470 */
[3226, 2891, 946],
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(2964);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 472 */
415,
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2981);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 474 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 475 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 476 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(334);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(200);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(335);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(860);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ },
/* 480 */
[3247, 976, 3022],
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isGroup = function isGroup(option) {
		return option && Array.isArray(option.options);
	};
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionGroupComponent = _ref.optionGroupComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var OptionGroup = optionGroupComponent;
		var Option = optionComponent;
		var renderLabel = optionRenderer;
	
		var renderOptions = function renderOptions(optionsSubset) {
			return optionsSubset.map(function (option, i) {
				if (isGroup(option)) {
					var optionGroupClass = (0, _classnames2.default)({
						'Select-option-group': true
					});
	
					return _react2.default.createElement(
						OptionGroup,
						{
							className: optionGroupClass,
							key: 'option-group-' + i,
							label: renderLabel(option),
							option: option,
							optionIndex: i
						},
						renderOptions(option.options)
					);
				} else {
					var isSelected = valueArray && valueArray.indexOf(option) > -1;
					var isFocused = option === focusedOption;
					var optionRef = isFocused ? 'focused' : null;
					var optionClass = (0, _classnames2.default)(optionClassName, {
						'Select-option': true,
						'is-selected': isSelected,
						'is-focused': isFocused,
						'is-disabled': option.disabled
					});
	
					return _react2.default.createElement(
						Option,
						{
							className: optionClass,
							focusOption: focusOption,
							inputValue: inputValue,
							instancePrefix: instancePrefix,
							isDisabled: option.disabled,
							isFocused: isFocused,
							isSelected: isSelected,
							key: 'option-' + i + '-' + option[valueKey],
							onFocus: onFocus,
							onSelect: onSelect,
							option: option,
							optionIndex: i,
							ref: function ref(_ref2) {
								onOptionRef(_ref2, isFocused);
							},
							removeValue: removeValue,
							selectValue: selectValue
						},
						renderLabel(option, i)
					);
				}
			});
		};
	
		return renderOptions(options);
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 482 */
[3247, 983, 3026],
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(293));
	
	var _max2 = _interopRequireDefault(__webpack_require__(670));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _get2 = _interopRequireDefault(__webpack_require__(186));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _Curve = _interopRequireDefault(__webpack_require__(206));
	
	var _Dot = _interopRequireDefault(__webpack_require__(162));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _DataUtils = __webpack_require__(40);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Area = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Area, _Component);
	
	  function Area() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Area)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-area-');
	
	    _this.cachePrevData = function (points, baseLine) {
	      _this.setState({
	        prevPoints: points,
	        prevBaseLine: baseLine
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2.default)(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2.default)(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Area, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points, baseLine);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (isAnimationActive && !isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          points = _this$props2.points,
	          dataKey = _this$props2.dataKey;
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, areaProps, customDotProps, dotEvents, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react.default.createElement(_Layer.default, _extends({
	        className: "recharts-area-dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderHorizontalRect",
	    value: function renderHorizontalRect(alpha) {
	      var _this$props3 = this.props,
	          baseLine = _this$props3.baseLine,
	          points = _this$props3.points,
	          strokeWidth = _this$props3.strokeWidth;
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = (0, _max2.default)(points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else if (baseLine && (0, _isArray2.default)(baseLine) && baseLine.length) {
	        maxY = Math.max((0, _max2.default)(baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxY)) {
	        return _react.default.createElement("rect", {
	          x: startX < endX ? startX : startX - width,
	          y: 0,
	          width: width,
	          height: parseInt(maxY + (strokeWidth || 1), 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderVerticalRect",
	    value: function renderVerticalRect(alpha) {
	      var _this$props4 = this.props,
	          baseLine = _this$props4.baseLine,
	          points = _this$props4.points,
	          strokeWidth = _this$props4.strokeWidth;
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = (0, _max2.default)(points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else if (baseLine && (0, _isArray2.default)(baseLine) && baseLine.length) {
	        maxX = Math.max((0, _max2.default)(baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxX)) {
	        return _react.default.createElement("rect", {
	          x: 0,
	          y: startY < endY ? startY : startY - height,
	          width: maxX + (strokeWidth || 1),
	          height: parseInt(height, 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderClipRect",
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: "renderAreaStatically",
	    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
	      var _this$props5 = this.props,
	          layout = _this$props5.layout,
	          type = _this$props5.type,
	          stroke = _this$props5.stroke,
	          connectNulls = _this$props5.connectNulls,
	          isRange = _this$props5.isRange;
	      return _react.default.createElement(_Layer.default, {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, _react.default.createElement(_Curve.default, _extends({}, this.props, {
	        points: points,
	        baseLine: baseLine,
	        stroke: "none",
	        className: "recharts-area-area"
	      })), stroke !== 'none' && _react.default.createElement(_Curve.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: points
	      })), stroke !== 'none' && isRange && _react.default.createElement(_Curve.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: baseLine
	      })));
	    }
	  }, {
	    key: "renderAreaWithAnimation",
	    value: function renderAreaWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          baseLine = _this$props6.baseLine,
	          isAnimationActive = _this$props6.isAnimationActive,
	          animationBegin = _this$props6.animationBegin,
	          animationDuration = _this$props6.animationDuration,
	          animationEasing = _this$props6.animationEasing,
	          animationId = _this$props6.animationId;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;
	
	      return _react.default.createElement(_reactSmooth.default, {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "area-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion
	
	          var stepPoints = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            }
	
	            return entry;
	          });
	          var stepBaseLine;
	
	          if ((0, _DataUtils.isNumber)(baseLine)) {
	            var interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, baseLine);
	            stepBaseLine = interpolator(t);
	          } else if ((0, _isNil2.default)(baseLine) || (0, _isNaN2.default)(baseLine)) {
	            var _interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, 0);
	
	            stepBaseLine = _interpolator(t);
	          } else {
	            stepBaseLine = baseLine.map(function (entry, index) {
	              var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	              if (prevBaseLine[prevPointIndex]) {
	                var prev = prevBaseLine[prevPointIndex];
	                var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	                return _objectSpread({}, entry, {
	                  x: interpolatorX(t),
	                  y: interpolatorY(t)
	                });
	              }
	
	              return entry;
	            });
	          }
	
	          return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
	        }
	
	        return _react.default.createElement(_Layer.default, null, _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
	          id: "animationClipPath-".concat(clipPathId)
	        }, _this3.renderClipRect(t))), _react.default.createElement(_Layer.default, {
	          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
	        }, _this3.renderAreaStatically(points, baseLine, needClip, clipPathId)));
	      });
	    }
	  }, {
	    key: "renderArea",
	    value: function renderArea(needClip, clipPathId) {
	      var _this$props7 = this.props,
	          points = _this$props7.points,
	          baseLine = _this$props7.baseLine,
	          isAnimationActive = _this$props7.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          prevBaseLine = _this$state2.prevBaseLine,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2.default)(prevPoints, points) || !(0, _isEqual2.default)(prevBaseLine, baseLine))) {
	        return this.renderAreaWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props8 = this.props,
	          hide = _this$props8.hide,
	          dot = _this$props8.dot,
	          points = _this$props8.points,
	          className = _this$props8.className,
	          top = _this$props8.top,
	          left = _this$props8.left,
	          xAxis = _this$props8.xAxis,
	          yAxis = _this$props8.yAxis,
	          width = _this$props8.width,
	          height = _this$props8.height,
	          isAnimationActive = _this$props8.isAnimationActive,
	          id = _this$props8.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames.default)('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2.default)(id) ? this.id : id;
	      return _react.default.createElement(_Layer.default, {
	        className: layerClass
	      }, needClip ? _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react.default.createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: parseInt(height, 10)
	      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList.default.renderCallByParent(this.props, points));
	    }
	  }]);
	
	  return Area;
	}(_react.Component), _class2.displayName = 'Area', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]).isRequired,
	  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes.default.func]),
	  unit: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  yAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  xAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  yAxis: _propTypes.default.object,
	  xAxis: _propTypes.default.object,
	  stackId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  legendType: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes.default.oneOf(_ReactUtils.TOOLTIP_TYPES),
	  connectNulls: _propTypes.default.bool,
	  activeDot: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element, _propTypes.default.func, _propTypes.default.bool]),
	  // dot configuration
	  dot: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element, _propTypes.default.object, _propTypes.default.bool]),
	  label: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element, _propTypes.default.object, _propTypes.default.bool]),
	  hide: _propTypes.default.bool,
	  // have curve configuration
	  layout: _propTypes.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
	  isRange: _propTypes.default.bool,
	  points: _propTypes.default.arrayOf(_propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array])
	  })),
	  onAnimationStart: _propTypes.default.func,
	  onAnimationEnd: _propTypes.default.func,
	  animationId: _propTypes.default.number,
	  isAnimationActive: _propTypes.default.bool,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes.default.string
	}), _class2.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  activeDot: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getBaseValue = function (props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	}, _class2.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      bandSize = _ref2.bandSize,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	  var points = displayedData.map(function (entry, index) {
	    var value;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2.default)(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2.default)(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2.default)(value[1]) ? null : xAxis.scale(value[1]),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  var baseLine;
	
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      if (layout === 'horizontal') {
	        return {
	          x: entry.x,
	          y: !(0, _isNil2.default)((0, _get2.default)(entry, 'value[0]')) ? yAxis.scale((0, _get2.default)(entry, 'value[0]')) : null
	        };
	      }
	
	      return {
	        x: !(0, _isNil2.default)((0, _get2.default)(entry, 'value[0]')) ? xAxis.scale((0, _get2.default)(entry, 'value[0]')) : null,
	        y: entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return _objectSpread({
	    points: points,
	    baseLine: baseLine,
	    layout: layout,
	    isRange: isRange
	  }, offset);
	}, _class2.renderDotItem = function (option, props) {
	  var dotItem;
	
	  if (_react.default.isValidElement(option)) {
	    dotItem = _react.default.cloneElement(option, props);
	  } else if ((0, _isFunction2.default)(option)) {
	    dotItem = option(props);
	  } else {
	    dotItem = _react.default.createElement(_Dot.default, _extends({}, props, {
	      className: "recharts-area-dot"
	    }));
	  }
	
	  return dotItem;
	}, _temp)) || _class;
	
	var _default = Area;
	exports.default = _default;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(207));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(250));
	
	var _Cell = _interopRequireDefault(__webpack_require__(205));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _DataUtils = __webpack_require__(40);
	
	var _ReactUtils = __webpack_require__(25);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Bar = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Bar, _Component);
	
	  function Bar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Bar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-bar-');
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Bar, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "renderRectanglesStatically",
	    value: function renderRectanglesStatically(data) {
	      var _this2 = this;
	
	      var shape = this.props.shape;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return data && data.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, entry, {
	          index: i
	        });
	
	        return _react.default.createElement(_Layer.default, _extends({
	          className: "recharts-bar-rectangle"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "rectangle-".concat(i)
	        }), _this2.constructor.renderRectangle(shape, props));
	      });
	    }
	  }, {
	    key: "renderRectanglesWithAnimation",
	    value: function renderRectanglesWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          data = _this$props2.data,
	          layout = _this$props2.layout,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevData = this.state.prevData;
	      return _react.default.createElement(_reactSmooth.default, {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "bar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	            var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	            var interpolatorWidth = (0, _DataUtils.interpolateNumber)(prev.width, entry.width);
	            var interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	            return _objectSpread({}, entry, {
	              x: interpolatorX(t),
	              y: interpolatorY(t),
	              width: interpolatorWidth(t),
	              height: interpolatorHeight(t)
	            });
	          }
	
	          if (layout === 'horizontal') {
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	
	            var h = _interpolatorHeight(t);
	
	            return _objectSpread({}, entry, {
	              y: entry.y + entry.height - h,
	              height: h
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.width);
	          var w = interpolator(t);
	          return _objectSpread({}, entry, {
	            width: w
	          });
	        });
	        return _react.default.createElement(_Layer.default, null, _this3.renderRectanglesStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderRectangles",
	    value: function renderRectangles() {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2.default)(prevData, data))) {
	        return this.renderRectanglesWithAnimation();
	      }
	
	      return this.renderRectanglesStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this4 = this;
	
	      var data = this.props.data;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return data.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({}, rest, {
	          fill: '#eee'
	        }, background, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "background-bar-".concat(i),
	          className: 'recharts-bar-background-rectangle'
	        });
	
	        return _this4.constructor.renderRectangle(_this4.props.background, props);
	      });
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          xAxis = _this$props4.xAxis,
	          yAxis = _this$props4.yAxis,
	          layout = _this$props4.layout,
	          children = _this$props4.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react.default.cloneElement(item, {
	          key: "error-bar-".concat(i),
	          data: data,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          offset: offset,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          hide = _this$props5.hide,
	          data = _this$props5.data,
	          className = _this$props5.className,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          left = _this$props5.left,
	          top = _this$props5.top,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          isAnimationActive = _this$props5.isAnimationActive,
	          background = _this$props5.background,
	          id = _this$props5.id;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames.default)('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2.default)(id) ? this.id : id;
	      return _react.default.createElement(_Layer.default, {
	        className: layerClass
	      }, needClip ? _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react.default.createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, _react.default.createElement(_Layer.default, {
	        className: "recharts-bar-rectangles",
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(), (!isAnimationActive || isAnimationFinished) && _LabelList.default.renderCallByParent(this.props, data));
	    }
	  }], [{
	    key: "renderRectangle",
	    value: function renderRectangle(option, props) {
	      var rectangle;
	
	      if (_react.default.isValidElement(option)) {
	        rectangle = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react.default.createElement(_Rectangle.default, props);
	      }
	
	      return rectangle;
	    }
	  }]);
	
	  return Bar;
	}(_react.Component), _class2.displayName = 'Bar', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  layout: _propTypes.default.oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  yAxisId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  yAxis: _propTypes.default.object,
	  xAxis: _propTypes.default.object,
	  stackId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  barSize: _propTypes.default.number,
	  unit: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]).isRequired,
	  legendType: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes.default.oneOf(_ReactUtils.TOOLTIP_TYPES),
	  minPointSize: _propTypes.default.number,
	  maxBarSize: _propTypes.default.number,
	  hide: _propTypes.default.bool,
	  shape: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
	  data: _propTypes.default.arrayOf(_propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number,
	    radius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
	    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.array])
	  })),
	  onAnimationStart: _propTypes.default.func,
	  onAnimationEnd: _propTypes.default.func,
	  animationId: _propTypes.default.number,
	  isAnimationActive: _propTypes.default.bool,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes.default.string
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  hide: false,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'ease',
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _class2.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      item = _ref2.item,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var layout = props.layout;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell.default);
	  var rects = displayedData.map(function (entry, index) {
	    var value, x, y, width, height, background;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: xAxis,
	        ticks: xAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	      background = {
	        x: x,
	        y: yAxis.y,
	        width: width,
	        height: yAxis.height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	      background = {
	        x: xAxis.x,
	        y: y,
	        width: xAxis.width,
	        height: height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	
	        width += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, {
	      x: x,
	      y: y,
	      width: width,
	      height: height,
	      value: stackedData ? value : value[1],
	      payload: entry,
	      background: background
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    data: rects,
	    layout: layout
	  }, offset);
	}, _temp)) || _class;
	
	var _default = Bar;
	exports.default = _default;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Curve = _interopRequireDefault(__webpack_require__(206));
	
	var _Dot = _interopRequireDefault(__webpack_require__(162));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(250));
	
	var _DataUtils = __webpack_require__(40);
	
	var _ReactUtils = __webpack_require__(25);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Line = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Line)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-line-');
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.pathRef = function (node) {
	      _this.mainCurve = node;
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Line, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (!this.props.isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	      this.setState({
	        totalLength: totalLength
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "getTotalLength",
	    value: function getTotalLength() {
	      var curveDom = this.mainCurve;
	
	      try {
	        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	      } catch (err) {
	        return 0;
	      }
	    }
	  }, {
	    key: "getStrokeDasharray",
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	      var remainLines = [];
	
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = _toConsumableArray(lines.slice(0, i)).concat([remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	      return _toConsumableArray(this.constructor.repeat(lines, count)).concat(_toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return "".concat(line, "px");
	      }).join(', ');
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          points = _this$props2.points,
	          xAxis = _this$props2.xAxis,
	          yAxis = _this$props2.yAxis,
	          layout = _this$props2.layout,
	          children = _this$props2.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          dot = _this$props3.dot,
	          points = _this$props3.points,
	          dataKey = _this$props3.dataKey;
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, lineProps, customDotProps, dotEvents, {
	          value: entry.value,
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react.default.createElement(_Layer.default, _extends({
	        className: "recharts-line-dots",
	        key: "dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderCurveStatically",
	    value: function renderCurveStatically(points, needClip, clipPathId, props) {
	      var _this$props4 = this.props,
	          type = _this$props4.type,
	          layout = _this$props4.layout,
	          connectNulls = _this$props4.connectNulls;
	
	      var curveProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
	        points: points
	      }, props, {
	        type: type,
	        layout: layout,
	        connectNulls: connectNulls
	      });
	
	      return _react.default.createElement(_Curve.default, _extends({}, curveProps, {
	        pathRef: this.pathRef
	      }));
	    }
	  }, {
	    key: "renderCurveWithAnimation",
	    value: function renderCurveWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          strokeDasharray = _this$props5.strokeDasharray,
	          isAnimationActive = _this$props5.isAnimationActive,
	          animationBegin = _this$props5.animationBegin,
	          animationDuration = _this$props5.animationDuration,
	          animationEasing = _this$props5.animationEasing,
	          animationId = _this$props5.animationId,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          totalLength = _this$state.totalLength;
	      return _react.default.createElement(_reactSmooth.default, {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "line-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length;
	          var stepData = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            } // magic number of faking previous x and y location
	
	
	            if (_this3.animateNewValues) {
	              var _interpolatorX = (0, _DataUtils.interpolateNumber)(width * 2, entry.x);
	
	              var _interpolatorY = (0, _DataUtils.interpolateNumber)(height / 2, entry.y);
	
	              return _objectSpread({}, entry, {
	                x: _interpolatorX(t),
	                y: _interpolatorY(t)
	              });
	            }
	
	            return _objectSpread({}, entry, {
	              x: entry.x,
	              y: entry.y
	            });
	          });
	          return _this3.renderCurveStatically(stepData, needClip, clipPathId);
	        }
	
	        var interpolator = (0, _DataUtils.interpolateNumber)(0, totalLength);
	        var curLength = interpolator(t);
	        var currentStrokeDasharray;
	
	        if (strokeDasharray) {
	          var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	            return parseFloat(num);
	          });
	          currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
	        } else {
	          currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
	        }
	
	        return _this3.renderCurveStatically(points, needClip, clipPathId, {
	          strokeDasharray: currentStrokeDasharray
	        });
	      });
	    }
	  }, {
	    key: "renderCurve",
	    value: function renderCurve(needClip, clipPathId) {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2.default)(prevPoints, points))) {
	        return this.renderCurveWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderCurveStatically(points, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          dot = _this$props7.dot,
	          points = _this$props7.points,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          top = _this$props7.top,
	          left = _this$props7.left,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          isAnimationActive = _this$props7.isAnimationActive,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames.default)('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2.default)(id) ? this.id : id;
	      return _react.default.createElement(_Layer.default, {
	        className: layerClass
	      }, needClip ? _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react.default.createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(), (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList.default.renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "repeat",
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? _toConsumableArray(lines).concat([0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = _toConsumableArray(result).concat(_toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react.default.isValidElement(option)) {
	        dotItem = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames.default)('recharts-line-dot', option ? option.className : '');
	        dotItem = _react.default.createElement(_Dot.default, _extends({}, props, {
	          className: className
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Line;
	}(_react.Component), _class2.displayName = 'Line', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes.default.func]),
	  unit: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  yAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  xAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  yAxis: _propTypes.default.object,
	  xAxis: _propTypes.default.object,
	  legendType: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes.default.oneOf(_ReactUtils.TOOLTIP_TYPES),
	  layout: _propTypes.default.oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes.default.bool,
	  hide: _propTypes.default.bool,
	  // whether have dot in line
	  activeDot: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element, _propTypes.default.func, _propTypes.default.bool]),
	  dot: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element, _propTypes.default.func, _propTypes.default.bool]),
	  top: _propTypes.default.number,
	  left: _propTypes.default.number,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  points: _propTypes.default.arrayOf(_propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    value: _propTypes.default.value
	  })),
	  onAnimationStart: _propTypes.default.func,
	  onAnimationEnd: _propTypes.default.func,
	  isAnimationActive: _propTypes.default.bool,
	  animateNewValues: _propTypes.default.bool,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes.default.number,
	  id: _propTypes.default.string
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animateNewValues: true,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  hide: false,
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _class2.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var points = displayedData.map(function (entry, index) {
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2.default)(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2.default)(value) ? null : xAxis.scale(value),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  return _objectSpread({
	    points: points,
	    layout: layout
	  }, offset);
	}, _temp)) || _class;
	
	var _default = Line;
	exports.default = _default;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(340));
	
	var _Curve = _interopRequireDefault(__webpack_require__(206));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(489));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(250));
	
	var _Cell = _interopRequireDefault(__webpack_require__(205));
	
	var _DataUtils = __webpack_require__(40);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Scatter = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Scatter, _Component);
	
	  function Scatter() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Scatter)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevPoints = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	    };
	
	    _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-');
	    return _this;
	  }
	
	  _createClass(Scatter, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevPoints(points);
	      }
	    }
	  }, {
	    key: "renderSymbolsStatically",
	    value: function renderSymbolsStatically(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          shape = _this$props2.shape,
	          activeShape = _this$props2.activeShape,
	          activeIndex = _this$props2.activeIndex;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return points.map(function (entry, i) {
	        var props = _objectSpread({
	          key: "symbol-".concat(i)
	        }, baseProps, entry);
	
	        return _react.default.createElement(_Layer.default, _extends({
	          className: "recharts-scatter-symbol"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "symbol-".concat(i)
	        }), _this2.constructor.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
	      });
	    }
	  }, {
	    key: "renderSymbolsWithAnimation",
	    value: function renderSymbolsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          points = _this$props3.points,
	          isAnimationActive = _this$props3.isAnimationActive,
	          animationBegin = _this$props3.animationBegin,
	          animationDuration = _this$props3.animationDuration,
	          animationEasing = _this$props3.animationEasing,
	          animationId = _this$props3.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react.default.createElement(_reactSmooth.default, {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[index];
	
	          if (prev) {
	            var interpolatorCx = (0, _DataUtils.interpolateNumber)(prev.cx, entry.cx);
	            var interpolatorCy = (0, _DataUtils.interpolateNumber)(prev.cy, entry.cy);
	            var interpolatorSize = (0, _DataUtils.interpolateNumber)(prev.size, entry.size);
	            return _objectSpread({}, entry, {
	              cx: interpolatorCx(t),
	              cy: interpolatorCy(t),
	              size: interpolatorSize(t)
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.size);
	          return _objectSpread({}, entry, {
	            size: interpolator(t)
	          });
	        });
	        return _react.default.createElement(_Layer.default, null, _this3.renderSymbolsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSymbols",
	    value: function renderSymbols() {
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2.default)(prevPoints, points))) {
	        return this.renderSymbolsWithAnimation();
	      }
	
	      return this.renderSymbolsStatically(points);
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          children = _this$props5.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.y,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.x,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	        return _react.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: "renderLine",
	    value: function renderLine() {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          line = _this$props6.line,
	          lineType = _this$props6.lineType,
	          lineJointType = _this$props6.lineJointType;
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints, lineItem;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return {
	            x: entry.cx,
	            y: entry.cy
	          };
	        });
	      } else if (lineType === 'fitting') {
	        var _getLinearRegression = (0, _DataUtils.getLinearRegression)(points),
	            xmin = _getLinearRegression.xmin,
	            xmax = _getLinearRegression.xmax,
	            a = _getLinearRegression.a,
	            b = _getLinearRegression.b;
	
	        var linearExp = function linearExp(x) {
	          return a * x + b;
	        };
	
	        linePoints = [{
	          x: xmin,
	          y: linearExp(xmin)
	        }, {
	          x: xmax,
	          y: linearExp(xmax)
	        }];
	      }
	
	      var lineProps = _objectSpread({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react.default.isValidElement(line)) {
	        lineItem = _react.default.cloneElement(line, lineProps);
	      } else if ((0, _isFunction2.default)(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react.default.createElement(_Curve.default, _extends({}, lineProps, {
	          type: lineJointType
	        }));
	      }
	
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-scatter-line",
	        key: "recharts-scatter-line"
	      }, lineItem);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          points = _this$props7.points,
	          line = _this$props7.line,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          left = _this$props7.left,
	          top = _this$props7.top,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isAnimationActive = _this$state.isAnimationActive,
	          isAnimationFinished = _this$state.isAnimationFinished;
	      var layerClass = (0, _classnames.default)('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2.default)(id) ? this.id : id;
	      return _react.default.createElement(_Layer.default, {
	        className: layerClass,
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, needClip ? _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react.default.createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, line && this.renderLine(), this.renderErrorBar(), _react.default.createElement(_Layer.default, {
	        key: "recharts-scatter-symbols"
	      }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && _LabelList.default.renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderSymbolItem",
	    value: function renderSymbolItem(option, props) {
	      var symbol;
	
	      if (_react.default.isValidElement(option)) {
	        symbol = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react.default.createElement(_Symbols.default, _extends({}, props, {
	          type: option
	        }));
	      }
	
	      return symbol;
	    }
	  }]);
	
	  return Scatter;
	}(_react.Component), _class2.displayName = 'Scatter', _class2.propTypes = _objectSpread({}, _ReactUtils.EVENT_ATTRIBUTES, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  xAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  yAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  zAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  line: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object, _propTypes.default.func, _propTypes.default.element]),
	  lineType: _propTypes.default.oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes.default.oneOfType([_propTypes.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes.default.func]),
	  legendType: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes.default.oneOf(_ReactUtils.TOOLTIP_TYPES),
	  className: _propTypes.default.string,
	  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  activeIndex: _propTypes.default.number,
	  activeShape: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.element]),
	  shape: _propTypes.default.oneOfType([_propTypes.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes.default.element, _propTypes.default.func]),
	  points: _propTypes.default.arrayOf(_propTypes.default.shape({
	    cx: _propTypes.default.number,
	    cy: _propTypes.default.number,
	    size: _propTypes.default.number,
	    node: _propTypes.default.shape({
	      x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	      y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	      z: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	    }),
	    payload: _propTypes.default.any
	  })),
	  hide: _propTypes.default.bool,
	  isAnimationActive: _propTypes.default.bool,
	  animationId: _propTypes.default.number,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	}, _class2.getComposedData = function (_ref2) {
	  var xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      zAxis = _ref2.zAxis,
	      item = _ref2.item,
	      displayedData = _ref2.displayedData,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter,
	      offset = _ref2.offset,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks;
	  var tooltipType = item.props.tooltipType;
	  var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell.default);
	  var xAxisDataKey = (0, _isNil2.default)(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
	  var yAxisDataKey = (0, _isNil2.default)(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
	  var zAxisDataKey = zAxis && zAxis.dataKey;
	  var defaultRangeZ = zAxis ? zAxis.range : _ZAxis.default.defaultProps.range;
	  var defaultZ = defaultRangeZ && defaultRangeZ[0];
	  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
	  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
	  var points = displayedData.map(function (entry, index) {
	    var x = entry[xAxisDataKey];
	    var y = entry[yAxisDataKey];
	    var z = !(0, _isNil2.default)(zAxisDataKey) && entry[zAxisDataKey] || '-';
	    var tooltipPayload = [{
	      name: xAxis.name || xAxis.dataKey,
	      unit: xAxis.unit || '',
	      value: x,
	      payload: entry,
	      dataKey: xAxisDataKey,
	      type: tooltipType
	    }, {
	      name: yAxis.name || yAxis.dataKey,
	      unit: yAxis.unit || '',
	      value: y,
	      payload: entry,
	      dataKey: yAxisDataKey,
	      type: tooltipType
	    }];
	
	    if (z !== '-') {
	      tooltipPayload.push({
	        name: zAxis.name || zAxis.dataKey,
	        unit: zAxis.unit || '',
	        value: z,
	        payload: entry,
	        dataKey: zAxisDataKey,
	        type: tooltipType
	      });
	    }
	
	    var cx = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: xAxis,
	      ticks: xAxisTicks,
	      bandSize: xBandSize,
	      entry: entry,
	      index: index,
	      dataKey: xAxisDataKey
	    });
	    var cy = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: yAxis,
	      ticks: yAxisTicks,
	      bandSize: yBandSize,
	      entry: entry,
	      index: index,
	      dataKey: yAxisDataKey
	    });
	    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
	    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
	    return _objectSpread({}, entry, {
	      cx: cx,
	      cy: cy,
	      x: cx - radius,
	      y: cy - radius,
	      xAxis: xAxis,
	      yAxis: yAxis,
	      zAxis: zAxis,
	      width: 2 * radius,
	      height: 2 * radius,
	      size: size,
	      node: {
	        x: x,
	        y: y,
	        z: z
	      },
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: {
	        x: cx,
	        y: cy
	      },
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter,
	    points: points
	  }, offset);
	}, _temp)) || _class;
	
	var _default = Scatter;
	exports.default = _default;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(302));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _DefaultLegendContent = _interopRequireDefault(__webpack_require__(3073));
	
	var _DataUtils = __webpack_require__(40);
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.value;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2.default)(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2.default)(option)) {
	    return (0, _uniqBy2.default)(payload, option);
	  }
	
	  return payload;
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react.default.isValidElement(content)) {
	    return _react.default.cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2.default)(content)) {
	    return content(props);
	  }
	
	  return _react.default.createElement(_DefaultLegendContent.default, props);
	};
	
	var EPS = 1;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Legend, _Component);
	
	  function Legend() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Legend)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	    return _this;
	  }
	
	  _createClass(Legend, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "getBBox",
	    value: function getBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return {
	          width: boxWidth,
	          height: boxHeight
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: "getDefaultPosition",
	    value: function getDefaultPosition(style) {
	      var _this$props = this.props,
	          layout = _this$props.layout,
	          align = _this$props.align,
	          verticalAlign = _this$props.verticalAlign,
	          margin = _this$props.margin,
	          chartWidth = _this$props.chartWidth,
	          chartHeight = _this$props.chartHeight;
	      var hPos, vPos;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || {
	            width: 0
	          };
	          hPos = {
	            left: ((chartWidth || 0) - box.width) / 2
	          };
	        } else {
	          hPos = align === 'right' ? {
	            right: margin && margin.right || 0
	          } : {
	            left: margin && margin.left || 0
	          };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || {
	            height: 0
	          };
	
	          vPos = {
	            top: ((chartHeight || 0) - _box.height) / 2
	          };
	        } else {
	          vPos = verticalAlign === 'bottom' ? {
	            bottom: margin && margin.bottom || 0
	          } : {
	            top: margin && margin.top || 0
	          };
	        }
	      }
	
	      return _objectSpread({}, hPos, vPos);
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state2 = this.state,
	          boxWidth = _this$state2.boxWidth,
	          boxHeight = _this$state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          content = _this$props2.content,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          wrapperStyle = _this$props2.wrapperStyle,
	          paylodUniqBy = _this$props2.paylodUniqBy,
	          payload = _this$props2.payload;
	
	      var outerStyle = _objectSpread({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), wrapperStyle);
	
	      return _react.default.createElement("div", {
	        className: "recharts-legend-wrapper",
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: getUniqPaylod(paylodUniqBy, payload)
	      })));
	    }
	  }], [{
	    key: "getWithHeight",
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      }
	
	      if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	  wrapperStyle: _propTypes.default.object,
	  chartWidth: _propTypes.default.number,
	  chartHeight: _propTypes.default.number,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  iconSize: _propTypes.default.number,
	  iconType: _propTypes.default.oneOf(ICON_TYPES),
	  layout: _propTypes.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes.default.oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes.default.shape({
	    top: _propTypes.default.number,
	    left: _propTypes.default.number,
	    bottom: _propTypes.default.number,
	    right: _propTypes.default.number
	  }),
	  payload: _propTypes.default.arrayOf(_propTypes.default.shape({
	    value: _propTypes.default.any,
	    id: _propTypes.default.any,
	    type: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  paylodUniqBy: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
	  formatter: _propTypes.default.func,
	  onMouseEnter: _propTypes.default.func,
	  onMouseLeave: _propTypes.default.func,
	  onClick: _propTypes.default.func,
	  onBBoxUpdate: _propTypes.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	}, _temp)) || _class;
	
	var _default = Legend;
	exports.default = _default;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _d3Shape = __webpack_require__(388);
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle,
	  symbolCross: _d3Shape.symbolCross,
	  symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare,
	  symbolStar: _d3Shape.symbolStar,
	  symbolTriangle: _d3Shape.symbolTriangle,
	  symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = "symbol".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	
	    case 'square':
	      return size * size;
	
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Symbols, _Component);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Symbols).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          size = _this$props.size,
	          sizeType = _this$props.sizeType,
	          type = _this$props.type;
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	      return symbol();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          size = _this$props2.size;
	
	      if (cx === +cx && cy === +cy && size === +size) {
	        return _react.default.createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames.default)('recharts-symbols', className),
	          transform: "translate(".concat(cx, ", ").concat(cy, ")"),
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.Component), _class2.displayName = 'Symbols', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  type: _propTypes.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes.default.number,
	  cy: _propTypes.default.number,
	  size: _propTypes.default.number,
	  sizeType: _propTypes.default.oneOf(['area', 'diameter'])
	}), _class2.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	}, _temp)) || _class;
	
	var _default = Symbols;
	exports.default = _default;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Symbol key that carries API call info interpreted by this Redux middleware.
	 *
	 * @constant {symbol}
	 * @access public
	 * @default
	 */
	'use strict';
	
	var _Symbol = __webpack_require__(1015)['default'];
	
	exports.__esModule = true;
	var CALL_API = _Symbol('Call API');
	
	exports['default'] = CALL_API;
	module.exports = exports['default'];

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Error class for an RSAA that does not conform to the RSAA definition
	 *
	 * @class InvalidRSAA
	 * @access public
	 * @param {array} validationErrors - an array of validation errors
	 */
	'use strict';
	
	var _inherits = __webpack_require__(3090)['default'];
	
	var _classCallCheck = __webpack_require__(3089)['default'];
	
	exports.__esModule = true;
	
	var InvalidRSAA = (function (_Error) {
	  _inherits(InvalidRSAA, _Error);
	
	  function InvalidRSAA(validationErrors) {
	    _classCallCheck(this, InvalidRSAA);
	
	    _Error.call(this);
	    this.name = 'InvalidRSAA';
	    this.message = 'Invalid RSAA';
	    this.validationErrors = validationErrors;
	  }
	
	  /**
	   * Error class for a custom `payload` or `meta` function throwing
	   *
	   * @class InternalError
	   * @access public
	   * @param {string} message - the error message
	   */
	  return InvalidRSAA;
	})(Error);
	
	var InternalError = (function (_Error2) {
	  _inherits(InternalError, _Error2);
	
	  function InternalError(message) {
	    _classCallCheck(this, InternalError);
	
	    _Error2.call(this);
	    this.name = 'InternalError';
	    this.message = message;
	  }
	
	  /**
	   * Error class for an error raised trying to make an API call
	   *
	   * @class RequestError
	   * @access public
	   * @param {string} message - the error message
	   */
	  return InternalError;
	})(Error);
	
	var RequestError = (function (_Error3) {
	  _inherits(RequestError, _Error3);
	
	  function RequestError(message) {
	    _classCallCheck(this, RequestError);
	
	    _Error3.call(this);
	    this.name = 'RequestError';
	    this.message = message;
	  }
	
	  /**
	   * Error class for an API response outside the 200 range
	   *
	   * @class ApiError
	   * @access public
	   * @param {number} status - the status code of the API response
	   * @param {string} statusText - the status text of the API response
	   * @param {object} response - the parsed JSON response of the API server if the
	   *  'Content-Type' header signals a JSON response
	   */
	  return RequestError;
	})(Error);
	
	var ApiError = (function (_Error4) {
	  _inherits(ApiError, _Error4);
	
	  function ApiError(status, statusText, response) {
	    _classCallCheck(this, ApiError);
	
	    _Error4.call(this);
	    this.name = 'ApiError';
	    this.status = status;
	    this.statusText = statusText;
	    this.response = response;
	    this.message = status + ' - ' + statusText;
	  }
	
	  return ApiError;
	})(Error);
	
	exports.InvalidRSAA = InvalidRSAA;
	exports.InternalError = InternalError;
	exports.RequestError = RequestError;
	exports.ApiError = ApiError;

/***/ },
/* 492 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ },
/* 493 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 494 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 495 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 496 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(76)
	  , createDesc = __webpack_require__(499);
	module.exports = __webpack_require__(347) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 498 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 499 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(497);

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(1027);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(3133);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(3132);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(3131);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(1026);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(1028);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 502 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 503 */
/***/ function(module, exports) {

	function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.searchClientsWithKeyword = exports.getAllUsersSearch = exports.usersSearchAll = exports.usersSearch = exports.getAllSearch = exports.clientBusinessSearch = exports.getClientBusinessTotal = exports.clearUsersSearch = exports.CLEAR_USERS_SEARCH = exports.SEARCH_CLIENTS_BY_KEYWORD = exports.ALL_USERS_SEARCH = exports.USERS_SEARCH_ALL_RESULT = exports.USERS_SEARCH = exports.ALL_SEARCH = exports.CLIENT_BUSINESS_SEARCH = exports.GET_CLIENT_BUSINESS_TOTAL = undefined;
	
	var _Api = __webpack_require__(45);
	
	var _helpers = __webpack_require__(95);
	
	var GET_CLIENT_BUSINESS_TOTAL = exports.GET_CLIENT_BUSINESS_TOTAL = 'GET_CLIENT_BUSINESS_TOTAL';
	var CLIENT_BUSINESS_SEARCH = exports.CLIENT_BUSINESS_SEARCH = 'CLIENT_BUSINESS_SEARCH';
	var ALL_SEARCH = exports.ALL_SEARCH = 'ALL_SEARCH';
	var USERS_SEARCH = exports.USERS_SEARCH = 'USERS_SEARCH';
	var USERS_SEARCH_ALL_RESULT = exports.USERS_SEARCH_ALL_RESULT = "USERS_SEARCH_ALL_RESULT";
	var ALL_USERS_SEARCH = exports.ALL_USERS_SEARCH = 'ALL_USERS_SEARCH';
	var SEARCH_CLIENTS_BY_KEYWORD = exports.SEARCH_CLIENTS_BY_KEYWORD = 'SEARCH_CLIENTS_BY_KEYWORD';
	var CLEAR_USERS_SEARCH = exports.CLEAR_USERS_SEARCH = 'CLEAR_USERS_SEARCH';
	var clearUsersSearch = exports.clearUsersSearch = (0, _helpers.actionCreator)(CLEAR_USERS_SEARCH);
	
	var getClientBusinessTotal = exports.getClientBusinessTotal = function getClientBusinessTotal() {
	  return function (dispatch, getState) {
	    var url = 'clients/stats';
	    (0, _Api.callApi)(dispatch, getState, GET_CLIENT_BUSINESS_TOTAL, url);
	  };
	};
	
	var clientBusinessSearch = exports.clientBusinessSearch = function clientBusinessSearch(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/stats/details/search';
	    (0, _Api.callApi)(dispatch, getState, CLIENT_BUSINESS_SEARCH, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var getAllSearch = exports.getAllSearch = function getAllSearch(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/stats/details/search';
	    (0, _Api.callApi)(dispatch, getState, ALL_SEARCH, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	var usersSearch = exports.usersSearch = function usersSearch(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/stats/client/users';
	    (0, _Api.callApi)(dispatch, getState, USERS_SEARCH, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	var usersSearchAll = exports.usersSearchAll = function usersSearchAll(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/stats/client/users';
	    (0, _Api.callApi)(dispatch, getState, USERS_SEARCH_ALL_RESULT, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	var getAllUsersSearch = exports.getAllUsersSearch = function getAllUsersSearch(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/stats/client/users';
	    (0, _Api.callApi)(dispatch, getState, ALL_USERS_SEARCH, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var searchClientsWithKeyword = exports.searchClientsWithKeyword = function searchClientsWithKeyword(keyword) {
	  var url = 'clients/client-ids';
	  return function (dispatch, getState) {
	    (0, _Api.callApi)(dispatch, getState, SEARCH_CLIENTS_BY_KEYWORD, url, {
	      method: 'POST',
	      body: JSON.stringify({ keyword: keyword })
	    });
	  };
	};

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.register = exports.REGISTER = undefined;
	
	var _Api = __webpack_require__(45);
	
	var REGISTER = exports.REGISTER = 'REGISTER';
	
	var register = exports.register = function register(code, obj, status) {
	  return function (dispatch, getState) {
	    var url = void 0;
	    if (status === 'clientRegister') {
	      url = 'invitations/with/' + code + '/client-register';
	    }
	
	    if (status === 'businessUnitMemberRegister') {
	      url = 'invitations/with/' + code + '/business-unit-team-member-register';
	    }
	
	    (0, _Api.callApi)(dispatch, getState, REGISTER, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getInsightsStats = exports.getClientTagStats = exports.getClientStats = exports.getClientSubscriptionStats = exports.clearDashboardStats = exports.CLEAR_DASHBOARD_STATS = exports.GET_INSIGHTS_PERIOD_STATS = exports.GET_CLIENT_TAG_STATS = exports.GET_CLIENT_STATS = exports.GET_CLIENT_SUBSCRIPTION_STATS = undefined;
	
	var _Api = __webpack_require__(45);
	
	var _helpers = __webpack_require__(95);
	
	var GET_CLIENT_SUBSCRIPTION_STATS = exports.GET_CLIENT_SUBSCRIPTION_STATS = 'GET_CLIENT_SUBSCRIPTION_STATS';
	var GET_CLIENT_STATS = exports.GET_CLIENT_STATS = 'GET_CLIENT_STATS';
	var GET_CLIENT_TAG_STATS = exports.GET_CLIENT_TAG_STATS = 'GET_CLIENT_TAG_STATS';
	var GET_INSIGHTS_PERIOD_STATS = exports.GET_INSIGHTS_PERIOD_STATS = 'GET_INSIGHTS_PERIOD_STATS';
	var CLEAR_DASHBOARD_STATS = exports.CLEAR_DASHBOARD_STATS = 'CLEAR_DASHBOARD_STATS';
	
	var clearDashboardStats = exports.clearDashboardStats = (0, _helpers.actionCreator)(CLEAR_DASHBOARD_STATS);
	
	var getClientSubscriptionStats = exports.getClientSubscriptionStats = function getClientSubscriptionStats() {
		return function (dispatch, getState) {
			(0, _Api.callApi)(dispatch, getState, GET_CLIENT_SUBSCRIPTION_STATS, 'clients/subscription/stats');
		};
	};
	
	var getClientStats = exports.getClientStats = function getClientStats() {
		return function (dispatch, getState) {
			(0, _Api.callApi)(dispatch, getState, GET_CLIENT_STATS, 'clients/stats');
		};
	};
	
	var getClientTagStats = exports.getClientTagStats = function getClientTagStats() {
		return function (dispatch, getState) {
			(0, _Api.callApi)(dispatch, getState, GET_CLIENT_TAG_STATS, 'clients/tag/stats');
		};
	};
	
	var getInsightsStats = exports.getInsightsStats = function getInsightsStats(period) {
		var url = 'insights/' + period + '/stats';
		return function (dispatch, getState) {
			(0, _Api.callApi)(dispatch, getState, GET_INSIGHTS_PERIOD_STATS, url);
		};
	};

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAllSearch = exports.getSearch = exports.resetData = exports.RESET_DATA = exports.GET_ALL_INSIGHTS_SEARCH_RESULTS = exports.GET_INSIGHTS_SEARCH_RESULTS = undefined;
	
	var _Api = __webpack_require__(45);
	
	var GET_INSIGHTS_SEARCH_RESULTS = exports.GET_INSIGHTS_SEARCH_RESULTS = 'GET_INSIGHTS_SEARCH_RESULTS';
	var GET_ALL_INSIGHTS_SEARCH_RESULTS = exports.GET_ALL_INSIGHTS_SEARCH_RESULTS = 'GET_ALL_INSIGHTS_SEARCH_RESULTS';
	var RESET_DATA = exports.RESET_DATA = 'RESET_DATA';
	
	var resetData = exports.resetData = function resetData() {
	  return { type: RESET_DATA };
	};
	
	var getSearch = exports.getSearch = function getSearch(obj) {
	  return function (dispatch, getState) {
	    var url = 'insights/stats/insights-files';
	    (0, _Api.callApi)(dispatch, getState, GET_INSIGHTS_SEARCH_RESULTS, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var getAllSearch = exports.getAllSearch = function getAllSearch(obj) {
	  return function (dispatch, getState) {
	    var url = 'insights/stats/insights-files';
	    (0, _Api.callApi)(dispatch, getState, GET_ALL_INSIGHTS_SEARCH_RESULTS, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAllSearchData = exports.getSearchData = exports.getSubStats = exports.GET_ALL_SEARCH_RESULTS = exports.GET_SEARCH_RESULTS = exports.GET_SUB_STATS = undefined;
	
	var _Api = __webpack_require__(45);
	
	var GET_SUB_STATS = exports.GET_SUB_STATS = 'GET_SUB_STATS';
	var GET_SEARCH_RESULTS = exports.GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';
	var GET_ALL_SEARCH_RESULTS = exports.GET_ALL_SEARCH_RESULTS = 'GET_ALL_SEARCH_RESULTS';
	
	var getSubStats = exports.getSubStats = function getSubStats() {
	  return function (dispatch, getState) {
	    var url = 'clients/subscription/stats';
	    (0, _Api.callApi)(dispatch, getState, GET_SUB_STATS, url);
	  };
	};
	
	var getSearchData = exports.getSearchData = function getSearchData(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/stats/details/search';
	    (0, _Api.callApi)(dispatch, getState, GET_SEARCH_RESULTS, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	var getAllSearchData = exports.getAllSearchData = function getAllSearchData(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/stats/details/search';
	    (0, _Api.callApi)(dispatch, getState, GET_ALL_SEARCH_RESULTS, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tagsAllSearch = exports.tagsSearch = exports.getClientTree = exports.getTagsTotal = exports.ALL_TAGS_SEARCH = exports.TAGS_SEARCH = exports.GET_CLIENTS_TREE = exports.GET_TAGS_TOTAL = undefined;
	
	var _Api = __webpack_require__(45);
	
	var GET_TAGS_TOTAL = exports.GET_TAGS_TOTAL = 'GET_TAGS_TOTAL';
	var GET_CLIENTS_TREE = exports.GET_CLIENTS_TREE = 'GET_CLIENTS_TREE';
	var TAGS_SEARCH = exports.TAGS_SEARCH = 'TAGS_SEARCH';
	var ALL_TAGS_SEARCH = exports.ALL_TAGS_SEARCH = 'ALL_TAGS_SEARCH';
	
	var getTagsTotal = exports.getTagsTotal = function getTagsTotal() {
	  return function (dispatch, getState) {
	    var url = 'clients/tag/stats';
	    (0, _Api.callApi)(dispatch, getState, GET_TAGS_TOTAL, url);
	  };
	};
	
	var getClientTree = exports.getClientTree = function getClientTree(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/tree';
	    (0, _Api.callApi)(dispatch, getState, GET_CLIENTS_TREE, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var tagsSearch = exports.tagsSearch = function tagsSearch(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/tags/search';
	    (0, _Api.callApi)(dispatch, getState, TAGS_SEARCH, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};
	
	var tagsAllSearch = exports.tagsAllSearch = function tagsAllSearch(obj) {
	  return function (dispatch, getState) {
	    var url = 'clients/tags/search';
	    (0, _Api.callApi)(dispatch, getState, ALL_TAGS_SEARCH, url, {
	      method: 'POST',
	      body: JSON.stringify(obj)
	    });
	  };
	};

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(222);
	
	var _index = __webpack_require__(15);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reverse = __webpack_require__(675);
	
	var _reverse2 = _interopRequireDefault(_reverse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var arrowStyles = {
	  position: 'absolute',
	  right: 0,
	  top: '7px'
	};
	
	var altArrowStyles = {
	  position: 'absolute',
	  right: 0,
	  top: '0px'
	};
	
	var ChannelCampaignsTable = function (_AcquireWebComponent) {
	  _inherits(ChannelCampaignsTable, _AcquireWebComponent);
	
	  function ChannelCampaignsTable(props) {
	    _classCallCheck(this, ChannelCampaignsTable);
	
	    var _this = _possibleConstructorReturn(this, (ChannelCampaignsTable.__proto__ || Object.getPrototypeOf(ChannelCampaignsTable)).call(this, props));
	
	    _this.state = {
	      activeIndex: props.activeIndex,
	      arrowActive: 'down',
	      sltIds: [],
	      bodyData: props.bodyDataArr
	    };
	    return _this;
	  }
	
	  _createClass(ChannelCampaignsTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _isEqual2.default)(nextProps.bodyDataArr.slice().sort(), this.props.bodyDataArr.slice().sort())) {
	        this.setState({
	          bodyData: nextProps.bodyDataArr
	        });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(label, index) {
	      if (label === "Select" || label === "") {
	        return;
	      }
	      var sortDesc = false;
	      this.setState({
	        activeIndex: index
	      });
	      if (+index === this.state.activeIndex) {
	        if (this.state.arrowActive === 'down') {
	          this.setState({
	            arrowActive: 'up'
	          });
	        } else {
	          this.setState({
	            arrowActive: 'down'
	          });
	        }
	      } else {
	        this.setState({
	          arrowActive: 'down'
	        });
	      }
	
	      var sortField = "";
	      switch (label) {
	        case "Campaign Name":
	          sortField = "name";
	          break;
	        case "Campaign ID":
	          sortField = "campaignId";
	          break;
	        case "Campaign Start Date":
	          sortField = "startDate";
	          break;
	        case "Campaign End Date":
	          sortField = "endDate";
	          break;
	        case "Status":
	          sortField = "status";
	          break;
	        default:
	          sortField = "name";
	          break;
	      }
	
	      var list = sortDesc ? (0, _reverse2.default)((0, _sortBy2.default)(this.state.bodyData, function (data) {
	        return data[sortField];
	      })) : (0, _sortBy2.default)(this.state.bodyData, function (data) {
	        return data[sortField];
	      });
	
	      this.setState({
	        bodyData: list
	      });
	    }
	  }, {
	    key: 'updateCheck',
	    value: function updateCheck(id) {
	      (0, _map2.default)(this.state.bodyData, function (data) {
	        if (parseInt(data.id, 10) === parseInt(id, 10)) {
	          data.select = !data.select;
	        }
	      });
	
	      this.props.selectCampaignIds(id);
	      this.forceUpdate();
	    }
	  }, {
	    key: 'removeCampaign',
	    value: function removeCampaign(cid) {
	      this.props.removeCampaignId(cid);
	      this.forceUpdate();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'spread-table' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              this.props.tableHeaderArr.map(function (item, index) {
	                var widthStyle = '';
	                switch (index) {
	                  case 0:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[0];
	                    break;
	                  case 1:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[1];
	                    break;
	                  case 2:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[2];
	                    break;
	                  case 3:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[3];
	                    break;
	                  case 4:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[4];
	                    break;
	                  case 5:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[5];
	                    break;
	                  case 6:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[6];
	                    break;
	                  default:
	                    widthStyle = '';
	                    break;
	                }
	                return _react2.default.createElement(
	                  'th',
	                  { key: item.value,
	                    className: _this2.state.activeIndex === index ? 'active' : '',
	                    onClick: function onClick(e) {
	                      _this2.props.sortable ? _this2.handleClick(item.label, index) : e.preventDefault();
	                    },
	                    style: { width: widthStyle, whiteSpace: 'pre-wrap', paddingLeft: index === 0 ? "20px" : '10px' }
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text' },
	                    item.label
	                  ),
	                  _this2.state.activeIndex === index && _this2.props.sortable && _this2.state.arrowActive === 'down' && _react2.default.createElement(_arrowDropDown2.default, {
	                    style: _this2.props.narrowHeader ? Object.assign({}, altArrowStyles) : Object.assign({}, arrowStyles)
	                  }),
	                  _this2.state.activeIndex === index && _this2.props.sortable && _this2.state.arrowActive === 'up' && _react2.default.createElement(_arrowDropUp2.default, {
	                    style: _this2.props.narrowHeader ? Object.assign({}, altArrowStyles) : Object.assign({}, arrowStyles)
	                  })
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            this.state.bodyData.map(function (item, index) {
	              return _react2.default.createElement(
	                'tr',
	                { key: index },
	                _this2.props.showSelectBox && _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(_Checkbox2.default, { iconStyle: { fill: "#47A1AB" },
	                    checked: item.select, onCheck: _this2.updateCheck.bind(_this2, item.id) })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { paddingLeft: '20px' } },
	                  item.name
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  item.campaignId
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  (0, _moment2.default)(item.startDate).format("MM/DD/YY")
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  item.endDate ? (0, _moment2.default)(item.endDate).format("MM/DD/YY") : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  item.status
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _this2.props.showDelBtn && _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick(e) {
	                        e.preventDefault();_this2.removeCampaign(item.id);
	                      } },
	                    _react2.default.createElement('i', { className: 'icon-cancel-circle2', style: { color: "red" } })
	                  )
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChannelCampaignsTable;
	}(_index2.default);
	
	ChannelCampaignsTable.defaultProps = {
	  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
	  bodyDataArr: [],
	  bodyDataKey: [],
	  activeIndex: 0,
	  renderCols: {
	    addCol: '',
	    cols: []
	  },
	  showSelectBox: true,
	  showDelBtn: false,
	  narrowHeader: false,
	  sortable: false
	};
	
	exports.default = ChannelCampaignsTable;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _index = __webpack_require__(15);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _Grid = __webpack_require__(19);
	
	var _ChannelCampaignsTable = __webpack_require__(510);
	
	var _ChannelCampaignsTable2 = _interopRequireDefault(_ChannelCampaignsTable);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _union = __webpack_require__(419);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _search = __webpack_require__(155);
	
	var _search2 = _interopRequireDefault(_search);
	
	__webpack_require__(595);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddCampaignDialog = function (_AcquireWebComponent) {
		_inherits(AddCampaignDialog, _AcquireWebComponent);
	
		function AddCampaignDialog(props) {
			_classCallCheck(this, AddCampaignDialog);
	
			var _this = _possibleConstructorReturn(this, (AddCampaignDialog.__proto__ || Object.getPrototypeOf(AddCampaignDialog)).call(this, props));
	
			_this.state = {
				openDialog: props.open,
				channelCampaigns: (0, _union2.default)( /*props.channelCampaigns,*/props.emailCampaigns),
				originChannelCampaigns: props.channelCampaigns,
				sltCampaigns: [],
				searchText: ''
			};
			return _this;
		}
	
		_createClass(AddCampaignDialog, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var _this2 = this;
	
				this.setState({
					openDialog: nextProps.open
				});
	
				//if ((!isEqual(nextProps.channelCampaigns.slice().sort(), this.props.channelCampaigns.slice().sort())) || 
				//	(!isEqual(nextProps.emailCampaigns.slice().sort(), this.props.emailCampaigns.slice().sort()))) {
				if (this.props.selectCampaignIds) {
					var vals = [];
					var sltIds = [];
					nextProps.channelCampaigns.forEach(function (item) {
						var val = Object.assign({ select: false }, item);
						if (_this2.props.selectCampaignIds.indexOf(item.id) >= 0) {
							val.select = true;
							sltIds.push(item.id);
						}
						vals.push(val);
					});
	
					nextProps.emailCampaigns.forEach(function (item) {
						var val = Object.assign({ select: false }, item);
						if (_this2.props.selectCampaignIds.indexOf(item.id) >= 0) {
							val.select = true;
							sltIds.push(item.id);
						}
						vals.push(val);
					});
					this.setState({
						channelCampaigns: vals,
						originChannelCampaigns: vals,
						sltCampaigns: sltIds
					});
				}
			}
		}, {
			key: 'selectCampaignIds',
			value: function selectCampaignIds(id) {
				var idx = this.state.sltCampaigns.indexOf(id);
				if (idx < 0) {
					this.state.sltCampaigns.push(id);
				} else {
					this.state.sltCampaigns.splice(idx, 1);
				}
				this.forceUpdate();
			}
		}, {
			key: 'clickBtnAddCampaign',
			value: function clickBtnAddCampaign(e) {
				e.preventDefault();
				this.props.applyChange(this.state.sltCampaigns, this.props.deployName);
				this.props.onRequestClose();
				this.setState({
					openDialog: false,
					sltCampaigns: []
				});
			}
		}, {
			key: 'onSearchChange',
			value: function onSearchChange(e) {
				var result = (0, _filter2.default)(this.state.originChannelCampaigns, function (obj) {
					return (0, _isEmpty2.default)(e.target.value.trim()) ? true : obj.name.indexOf(e.target.value.trim()) >= 0 || obj.campaignId.indexOf(e.target.value.trim()) >= 0;
				});
	
				this.setState({
					channelCampaigns: result,
					searchText: e.target.value.trim()
				});
				this.forceUpdate();
			}
		}, {
			key: 'handleSearch',
			value: function handleSearch(e) {
				e.preventDefault();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var actions = [_react2.default.createElement(_FlatButton2.default, {
					label: 'Cancel',
					primary: true,
					className: 'black-border mr-20 btn-aa-claritas-info',
					backgroundColor: '#FFFFFF',
					labelStyle: { color: '#000', textTransform: "capitalize", fontSize: "16px" },
					hoverColor: '#FFFFFF',
					onClick: function onClick(e) {
						e.preventDefault();_this3.setState({ openDialog: false, sltCampaigns: [] });_this3.props.onRequestClose();
					}
				}), _react2.default.createElement(_FlatButton2.default, {
					label: 'Add Segment',
					primary: true,
					className: 'btn-aa-claritas btn-claritas-default btn-aa-claritas-default',
					labelStyle: { color: '#FFFFFF', textTransform: "capitalize", fontSize: "16px" },
					hoverColor: '#FFFFFF',
					onClick: this.clickBtnAddCampaign.bind(this)
				})];
				return _react2.default.createElement(
					_Dialog2.default,
					{ modal: true, title: '', open: this.state.openDialog, onRequestClose: this.props.onRequestClose,
						bodyStyle: { color: "#000", fontSize: '16px', padding: '20px' }, contentStyle: { width: '1024px', maxWidth: '1024px' },
						titleStyle: { display: 'none' }, actionsContainerStyle: { padding: "20px" },
						actions: actions
					},
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'light-grey-border no-margin-left no-margin-right no-padding mb-20' },
						_react2.default.createElement(
							'h3',
							{ className: 'pl-10', style: { fontSize: '24px', fontWeight: 'bold' } },
							'CAMPAIGN GROUP'
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'no-padding no-margin pl-10' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding no-margin' },
								_react2.default.createElement(
									'strong',
									{ style: { fontSize: '16px' } },
									'Campaign Group Name'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '4', sm: '4', md: '4', lg: '4', className: 'no-padding no-margin' },
								this.props.campaignName
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding no-margin' },
								_react2.default.createElement(
									'strong',
									null,
									'Campaign Group Start Date'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '2', sm: '2', md: '2', lg: '2', className: 'no-padding no-margin' },
								(0, _moment2.default)(this.props.startDate).format("MM/DD/YY")
							)
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'pl-10 no-margin-bottom pt-10 ' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3' },
								_react2.default.createElement(
									'strong',
									null,
									'Campaign Group Status'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '4', sm: '4', md: '4', lg: '4' },
								this.props.campaignStatus
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3' },
								_react2.default.createElement(
									'strong',
									null,
									'Campaign Group End Date'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '2', sm: '2', md: '2', lg: '2' },
								(0, _moment2.default)(this.props.endDate).format("MM/DD/YY")
							)
						)
					),
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'light-grey-border no-padding no-margin-left no-margin-right no-margin-bottom deployment-section' },
						_react2.default.createElement(
							'h3',
							{ className: 'pl-10', style: { fontSize: '16px', fontWeight: 'bold' } },
							this.props.title
						),
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'pl-10 pr-10 pt-10 no-margin-bottom' },
							_react2.default.createElement(
								'div',
								{ className: 'search-wrapper clearfix mb-20' },
								_react2.default.createElement(
									'span',
									{ className: 'search-tit', style: { fontSize: '16px' } },
									'Search'
								),
								_react2.default.createElement(
									'div',
									{ className: 'search-bar', style: { width: "320px", border: "solid 1px #EEEFF2" } },
									_react2.default.createElement('input', { placeholder: 'Search by Name or ID',
										style: { width: '100%', lineHeight: '25px', border: 'none' },
										onChange: this.onSearchChange.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'icon' },
									_react2.default.createElement(
										'button',
										{ onClick: this.handleSearch.bind(this) },
										_react2.default.createElement(_search2.default, {
											style: { color: 'white', marginLeft: '-4px', marginTop: '2px' }
										})
									)
								)
							),
							(0, _isEmpty2.default)(this.state.channelCampaigns) ? _react2.default.createElement(
								'span',
								{ style: { color: "#FF0000" } },
								'No ',
								this.props.channelType.toLowerCase(),
								' segments within date range selected'
							) : _react2.default.createElement(_ChannelCampaignsTable2.default, { tableHeaderArr: [{ label: '', value: 0 }, { label: 'Segment Name', value: 1 }, { label: 'Segment ID', value: 2 }, { label: 'Segment Start Date', value: 3 }, { label: 'Segment End Date', value: 4 }, { label: 'Status', value: 5 }], activeIndex: 1, bodyDataArr: this.state.channelCampaigns,
								bodyDataKey: ['select', 'name', 'campaignId', 'startDate', 'endDate', 'status'],
								selectCampaignIds: this.selectCampaignIds.bind(this),
								sltCampaignIds: this.state.sltCampaigns,
								tableHeaderWidthStyle: ['7%', '28%', '19%', '18%', '18%', '10%']
							})
						)
					)
				);
			}
		}]);
	
		return AddCampaignDialog;
	}(_index2.default);
	
	exports.default = AddCampaignDialog;
	
	
	AddCampaignDialog.defaultProps = {
		channelCampaigns: [],
		campaignStatus: "Draft"
	};

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(108);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _reactDropzone = __webpack_require__(242);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _CustomSelect = __webpack_require__(260);
	
	var _CustomSelect2 = _interopRequireDefault(_CustomSelect);
	
	var _reactTextMask = __webpack_require__(247);
	
	var _reactTextMask2 = _interopRequireDefault(_reactTextMask);
	
	var _groupBy = __webpack_require__(150);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _RadioButton = __webpack_require__(107);
	
	var _utility = __webpack_require__(14);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _worker = __webpack_require__(1084);
	
	var _worker2 = _interopRequireDefault(_worker);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(269);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(1412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// button color
	
	// import web workers;
	
	// css
	
	
	var validator = __webpack_require__(393);
	
	var styles = {
	  iconStyle: {
	    fill: "#000000",
	    transform: "scale(0.9)",
	    WebkitTransform: "scale(0.9)",
	    MsTransform: "scale(0.9)",
	    MozTransform: "scale(0.9)",
	    marginRight: "13px",
	    marginLeft: "-1px"
	  },
	  labelStyle: {
	    lineHeight: "15px",
	    marginBottom: 0,
	    paddingTop: "3px",
	    fontWeight: "normal"
	  }
	};
	
	var Profile = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile(props) {
	    _classCallCheck(this, Profile);
	
	    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));
	
	    _this.flag = true;
	    _this.flagBase = true;
	    _this.flagPhoto = true;
	    _this.myProfile_worker = new Worker(_worker2.default);
	    var months = [{ value: "01", label: "Jan" }, { value: "02", label: "Feb" }, { value: "03", label: "Mar" }, { value: "04", label: "Apr" }, { value: "05", label: "May" }, { value: "06", label: "Jun" }, { value: "07", label: "Jul" }, { value: "08", label: "Aug" }, { value: "09", label: "Sep" }, { value: "10", label: "Oct" }, { value: "11", label: "Nov" }, { value: "12", label: "Dec" }];
	    var years = [];
	    for (var i = 0; i < 10; i++) {
	      years.push({
	        value: (0, _moment2.default)().add(i, "years").format("YYYY"),
	        label: (0, _moment2.default)().add(i, "years").format("YYYY")
	      });
	    }
	
	    _this.state = {
	      expMonth: null,
	      expYear: null,
	      years: years,
	      months: months,
	      disableCloseBtn: true,
	      consumerDataSource: window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon",
	      businessDataSource: "InfoGroup",
	      requiredNameText: "", // requied field firset name tip text
	      requiredEmailText: "",
	      requiredTimezoneText: "", // required field last name tip text
	      requiredTierText: "", // required field email tip text
	      requiredIndustryIdText: "", // requierd industry text
	      requiredAssignClientText: "", // assign client text
	      ifLogoUploadButtonEnable: false, // if upload button enable for logo
	      ifPhotoUploadButtonEnable: false, // if uploda button enable for photo
	      ifLogoSaveBtnEnable: false, // if logo save button can be request api
	      ifPhotoSaveBtnEnable: false, // if photo save button can be request api
	      logoFileName: "No file chosen",
	      logoUploadSuccess: false,
	      photoUploadSucess: false,
	      campaignReportPreference: "Aggregated",
	      consumerRecords: 500, // consumer default value
	      businessRecords: 200, // business default value
	      roleValue: "",
	      stateValue: "",
	      timezoneValue: "",
	      industryValue: "",
	      subscriptionTierValue: /^\/clients$/g.test(_this.props.path) ? /^(administrator|team member)/gi.test(_this.props.roleName) ? 2 : 2 : 2,
	      assignClientValue: [""],
	      clientId: "", // client id for upload
	      companyLogoErrorText: "",
	      profilePhotoErrorText: "",
	      userAvatarUuid: "",
	      roleInfo: "", // store role object information,
	      industryGroupObj: [], // for the new industry group obj
	      requestParams: {
	        name: "",
	        address1: "",
	        address2: "",
	        city: "",
	        state: "",
	        zipCode: "",
	        phone: "",
	        timezone: "",
	        industryId: "",
	        accountNumber: "",
	        subscriptionTierId: /^\/clients$/g.test(_this.props.path) ? /^(administrator|team member)/gi.test(_this.props.roleName) ? 2 : 2 : 2,
	        logoUuid: "",
	        accountManagerUserIds: [""],
	        campaignReportPreference: "Aggregated"
	      },
	      // password_error_tip_show: false,
	      newLogoBase64: "",
	      showNewPwError: false,
	      showConfirmPwError: false,
	      segmentationSystem: "prizm_premier",
	      appendSegmentation: false,
	      audienceResolutionGranularity: "Scale"
	      // showBaseInfoError: false
	    };
	    return _this;
	  }
	
	  _createClass(Profile, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // this.props.getRoles();
	      this.props.getStates();
	      this.props.getTimezone();
	      localStorage.setItem("newLogoBase64", "");
	      localStorage.setItem("newPhotoBase64", "");
	      // init value when subscription tier value is 1
	      if (this.state.requestParams.subscriptionTierId === 1 && this.refs.consumer && this.refs.business) {
	        this.refs.consumer.value = this.state.consumerRecords;
	        this.refs.business.value = this.state.businessRecords;
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (/^Please add a contract number/g.test(nextProps.createClientProfileMessage)) {
	        this.setState({
	          ifShowContractNumber: true,
	          contractNumberText: "Please add a contract number"
	        });
	      }
	      // change blob to base64 for photo
	      if (typeof nextProps.avatar !== "undefined") {
	        if (this.flagPhoto) {
	          var reader = new FileReader();
	          reader.readAsDataURL(nextProps.avatar);
	          reader.onload = function () {
	            _this2.setState({
	              imgPhotoDataBase64: reader.result
	            });
	          };
	        }
	      }
	      if (nextProps.loginUserDetail) {
	        var _nextProps$loginUserD = nextProps.loginUserDetail,
	            role = _nextProps$loginUserD.role,
	            id = _nextProps$loginUserD.id;
	
	        this.setState({
	          clientId: id
	        }, function () {
	          // account manager get config insights standard datas
	          // if (/^account manager/gi.test(nextProps.roleInfo)) {
	          //   nextProps.getConfigInsightsStandard(this.state.clientId)
	          // }
	        });
	
	        this.setState({
	          roleInfo: role
	        });
	      }
	
	      if (nextProps.industryOptions.length > 0) {
	        this.setState({
	          industryValue: ""
	        });
	
	        var industryGroup = (0, _groupBy2.default)(nextProps.industryOptions, "group");
	        var obj = [];
	        // obj.push({label: 'All Industries', options: [
	        //   {
	        //     label: 'All Industries',
	        //     value: ''
	        //   }
	        // ]})
	        for (var x in industryGroup) {
	          obj.push({
	            label: x,
	            options: industryGroup[x]
	          });
	        }
	        this.setState({
	          industryGroupObj: obj
	        });
	      }
	      /*
	      if (nextProps.clientId !== '') {
	        if (this.state.requestParams.subscriptionTierId >= 3 || this.state.requestParams.subscriptionTierId === 1) {
	          nextProps.configInsightsStandard(nextProps.clientId, {
	            // id: this.props.match.params.businessUnitId,
	            maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
	            maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
	            consumerDataSource: this.state.consumerDataSource,
	            businessDataSource: 'InfoGroup'
	          })
	        }
	      }*/
	    }
	  }, {
	    key: "handleItemsChange",
	    value: function handleItemsChange(e, index, value) {
	      this.setState({
	        roleValue: value
	      });
	    }
	  }, {
	    key: "handleStateChange",
	    value: function handleStateChange(value) {
	      this.setState({
	        stateValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          state: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleExpMonthChange",
	    value: function handleExpMonthChange(value) {
	      this.setState({
	        expMonth: value.value
	      });
	    }
	  }, {
	    key: "handleExpYearChange",
	    value: function handleExpYearChange(value) {
	      this.setState({
	        expYear: value.value
	      });
	    }
	  }, {
	    key: "handleTimeZoneChange",
	    value: function handleTimeZoneChange(value) {
	      this.setState({
	        timezoneValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          timezone: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleClientName",
	    value: function handleClientName(e, value) {
	      var notAllowedRegex = /[\"*\/:<>?\\|\+,.;=\[\]\']/;
	      if (notAllowedRegex.test(value)) {
	        this.setState({
	          requiredNameText: 'Client Name cannot contain any of the following special characters: \" / * : < > ? \ | + \' , . ; = [ ] .',
	          requestParams: Object.assign({}, this.state.requestParams, {
	            name: value
	          })
	        });
	        return;
	      } else {
	        this.setState({
	          requiredNameText: '',
	          requestParams: Object.assign({}, this.state.requestParams, {
	            name: value
	          })
	        });
	      }
	    }
	  }, {
	    key: "handleLicenseNumber",
	    value: function handleLicenseNumber(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams),
	        licenseNum: value
	      });
	    }
	  }, {
	    key: "handleClientAddress1",
	    value: function handleClientAddress1(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address1: value
	        })
	      });
	    }
	  }, {
	    key: "handleClientAddress2",
	    value: function handleClientAddress2(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address2: value
	        })
	      });
	    }
	  }, {
	    key: "handleIndustryChange",
	    value: function handleIndustryChange(value) {
	      this.setState({
	        industryValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          industryId: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleCity",
	    value: function handleCity(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          city: value
	        })
	      });
	    }
	  }, {
	    key: "handleZipCode",
	    value: function handleZipCode(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          zipCode: value
	        })
	      });
	    }
	  }, {
	    key: "handleOfficePhoneNumber",
	    value: function handleOfficePhoneNumber(e) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          phone: e.target.value
	        })
	      });
	    }
	  }, {
	    key: "handleSubscriptionTierChange",
	    value: function handleSubscriptionTierChange(value) {
	      var _this3 = this;
	
	      this.setState({
	        consumerDataSource: window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon",
	        subscriptionTierValue: value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          subscriptionTierId: value
	        })
	      }, function () {
	        if ((value >= 3 && value !== 5 || value === 1) && _this3.refs.consumer && _this3.refs.business) {
	          _this3.refs.consumer.value = _this3.state.consumerRecords;
	          _this3.refs.business.value = _this3.state.businessRecords;
	        }
	      });
	    }
	  }, {
	    key: "handleAssignClientChange",
	    value: function handleAssignClientChange(value) {
	      this.setState({
	        assignClientValue: value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          accountManagerUserIds: value
	        })
	      });
	    }
	  }, {
	    key: "handleAccountNumber",
	    value: function handleAccountNumber(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          accountNumber: value
	        })
	      });
	    }
	  }, {
	    key: "handleDrop",
	    value: function handleDrop(files, accept, reject) {
	      this.setState({
	        logoFileName: files[0],
	        ifLogoUploadButtonEnable: true,
	        companyLogoErrorText: ""
	      });
	    }
	  }, {
	    key: "handleCampaignReportChanged",
	    value: function handleCampaignReportChanged(value) {
	      if (value === "Detailed") {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            campaignReportPreference: value,
	            clientReportDetailSetting: {
	              topLocationChannelReport: 0
	            }
	          })
	        });
	      } else {
	        var others = _objectWithoutProperties(this.state.requestParams, []);
	
	        this.setState({
	          requestParams: Object.assign({}, others, {
	            campaignReportPreference: value
	          })
	        });
	      }
	    }
	  }, {
	    key: "handleTopLocationReportCheck",
	    value: function handleTopLocationReportCheck(e, isChecked) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          clientReportDetailSetting: {
	            topLocationChannelReport: isChecked ? 1 : 0
	          }
	        })
	      });
	    }
	  }, {
	    key: "onDropRejected",
	    value: function onDropRejected() {
	      this.setState({
	        companyLogoErrorText: "Only jpg, png, and gif file with maximum size of 1MB is allowed"
	      });
	    }
	  }, {
	    key: "handleUpdateProfile",
	    value: function handleUpdateProfile() {
	      if (/^account manager/gi.test(this.props.roleName) && typeof this.state.requestParams.contractNumber === "undefined") {
	        this.setState({
	          ifShowContractNumber: true,
	          contractNumberText: "Please add a contract number"
	        });
	      }
	      var notAllowedRegex = /[\"*\/:<>?\\|\+,.;=\[\]\']/;
	      if (notAllowedRegex.test(this.state.requestParams.name)) {
	        this.setState({
	          requiredNameText: 'Client Name cannot contain any of the following special characters: \" / * : < > ? \ | + \' , . ; = [ ] .'
	        });
	        return;
	      }
	      if (this.state.requestParams.name.trim().length === 0) {
	        /^(administrator|team member)/gi.test(this.props.roleName) ? this.setState({
	          requiredNameText: "Please enter your business unit name"
	        }) : this.setState({
	          requiredNameText: "Please enter your client name"
	        });
	      } else {
	        this.setState({
	          requiredNameText: ""
	        });
	      }
	      if (this.state.requestParams.subscriptionTierId === 5) {
	        this.setState({
	          requiredEmailText: ""
	        });
	        if (this.state.requestParams.email.trim().length === 0) {
	          this.setState({
	            requiredEmailText: "Please enter email address"
	          });
	        } else {
	          if (!validator.validate(this.state.requestParams.email.trim())) {
	            this.setState({
	              requiredEmailText: "Invalid email address"
	            });
	          }
	        }
	      }
	      if (this.state.requestParams.timezone.trim().length === 0) {
	        this.setState({
	          requiredTimezoneText: "Please select your time zone"
	        });
	      } else {
	        this.setState({
	          requiredTimezoneText: ""
	        });
	      }
	      if (typeof this.state.requestParams.subscriptionTierId === "string" && /^(system administrator|account manager|operations manager)/gi.test(this.props.roleName)) {
	        this.setState({
	          requiredTierText: "Please select your subscription tier"
	        });
	      } else {
	        this.setState({
	          requiredTierText: ""
	        });
	      }
	      if (typeof this.state.requestParams.industryId === "string") {
	        this.setState({
	          requiredIndustryIdText: "Please select your industry type"
	        });
	      } else {
	        this.setState({
	          requiredIndustryIdText: ""
	        });
	      }
	      if (this.state.requestParams.subscriptionTierId == 4) {
	        if (this.state.appendSegmentation === true) {
	          if (!this.state.licenseNum || !this.state.expMonth || !this.state.expYear) {
	            this.setState({
	              licenseErrorText: "Please input license number and select expiration time"
	            });
	          } else {
	            this.setState({
	              licenseErrorText: null
	            });
	          }
	        } else {
	          this.setState({
	            licenseErrorText: null
	          });
	        }
	      } else {
	        this.setState({
	          licenseErrorText: null
	        });
	      }
	      if (Array.isArray(this.state.requestParams.accountManagerUserIds) && (0, _lodash.isEmpty)(this.state.requestParams.accountManagerUserIds[0]) && !/^(team member|account manager)/gi.test(this.props.roleName) && !/^(administrator|team member)/gi.test(this.props.roleName)) {
	        this.setState({
	          requiredAssignClientText: "Please select assignee"
	        });
	        // for system administrator create client profile
	        if (/^(system administrator)/gi.test(this.props.roleName)) {
	          return;
	        }
	      } else {
	        this.setState({
	          requiredAssignClientText: ""
	        });
	      }
	      var requestParams = this.state.requestParams;
	
	
	      if (requestParams.accountManagerUserIds && (requestParams.accountManagerUserIds[0] === "" || requestParams.accountManagerUserIds === "")) {
	        requestParams.accountManagerUserIds = undefined;
	      } else {
	        requestParams.accountManagerUserIds = typeof requestParams.accountManagerUserIds === "number" ? [requestParams.accountManagerUserIds] : requestParams.accountManagerUserIds ? (0, _lodash.isArray)(requestParams.accountManagerUserIds) ? requestParams.accountManagerUserIds : requestParams.accountManagerUserIds.split(",") : undefined;
	      }
	      // if (/^(\/clients\/edit\/Business-Units\/:id)/g.test(this.props.path)) {
	      //   if (this.state.requestParams.name.trim().length > 0 &&
	      //     this.state.requestParams.timezone.trim().length > 0 &&)
	      //
	      //   return;
	      // }
	      // for internal account
	      if (/^(system administrator)/gi.test(this.props.roleName) && this.state.requestParams.name.trim().length > 0 && this.state.requestParams.timezone.trim().length > 0 && typeof this.state.requestParams.industryId === "number" && typeof this.state.requestParams.subscriptionTierId === "number") {
	        // for create client profile (system admini)
	        if (this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5) {
	          var requestData = Object.assign({}, requestParams, {
	            insightsStandardConfig: {
	              maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
	              maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
	              consumerDataSource: this.state.consumerDataSource,
	              businessDataSource: this.state.businessDataSource
	            },
	            audienceResolutionGranularity: this.state.audienceResolutionGranularity
	          });
	          if (this.state.requestParams.subscriptionTierId === 4) {
	            requestData.insightsStandardConfig["segmentationSystem"] = this.state.segmentationSystem ? this.state.segmentationSystem : "prizm_premier";
	            requestData.insightsStandardConfig["appendSegmentation"] = this.state.appendSegmentation ? this.state.appendSegmentation : false;
	            if (this.state.appendSegmentation === true) {
	              requestData.insightsStandardConfig["segmentationLicenseNumber"] = this.state.licenseNum;
	              requestData.insightsStandardConfig["licenseExpirationDate"] = this.state.expYear + "-" + this.state.expMonth + "-01";
	            } else {
	              requestData.insightsStandardConfig["segmentationLicenseNumber"] = null;
	              requestData.insightsStandardConfig["licenseExpirationDate"] = null;
	            }
	          }
	          this.props.createClientProfile(requestData, this.props.paramId);
	        } else {
	          this.props.createClientProfile(this.state.requestParams, this.props.paramId);
	        }
	        // if (this.state.requestParams.subscriptionTierId === 3 || this.state.requestParams.subscriptionTierId === 1) {
	        //   setTimeout(() => {
	        //     this.props.configInsightsStandard(localStorage.getItem('createClientProfileId'), {
	        //       // id: this.props.match.params.businessUnitId,
	        //       maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords),
	        //       maxMonthlyBusinessRecords: parseInt(this.state.businessRecords),
	        //       consumerDataSource: this.state.consumerDataSource,
	        //       businessDataSource: 'InfoGroup'
	        //     })
	        //     this.setState({
	        //       disableCloseBtn: false
	        //     })
	        //   }, 3000)
	        // }
	      } else if (this.state.requestParams.name.trim().length > 0 && this.state.requestParams.timezone.trim().length > 0 && typeof this.state.requestParams.industryId === "number" && typeof this.state.requestParams.subscriptionTierId === "number") {
	        // for create client profile and create business unit profile (account manager)
	        if (this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5) {
	          var _requestParams = this.state.requestParams;
	
	          var _requestData = Object.assign({}, _requestParams, {
	            insightsStandardConfig: {
	              maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
	              maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
	              consumerDataSource: this.state.consumerDataSource,
	              businessDataSource: "InfoGroup"
	            },
	            audienceResolutionGranularity: this.state.audienceResolutionGranularity
	          });
	          if (this.state.requestParams.subscriptionTierId === 4) {
	            _requestData.insightsStandardConfig["segmentationSystem"] = this.state.segmentationSystem ? this.state.segmentationSystem : "prizm_premier";
	            _requestData.insightsStandardConfig["appendSegmentation"] = this.state.appendSegmentation ? this.state.appendSegmentation : false;
	            if (this.state.appendSegmentation === true) {
	              _requestData.insightsStandardConfig["segmentationLicenseNumber"] = this.state.licenseNum;
	              _requestData.insightsStandardConfig["licenseExpirationDate"] = this.state.expYear + "-" + this.state.expMonth + "-1";
	            } else {
	              _requestData.insightsStandardConfig["segmentationLicenseNumber"] = null;
	              _requestData.insightsStandardConfig["licenseExpirationDate"] = null;
	            }
	          }
	          this.props.createClientProfile(_requestData, this.props.paramId);
	        } else {
	          this.props.createClientProfile(this.state.requestParams, this.props.paramId);
	        }
	        // if (this.state.requestParams.subscriptionTierId === 3 || this.state.requestParams.subscriptionTierId === 1) {
	        //   setTimeout(() => {
	        //     this.props.configInsightsStandard(localStorage.getItem('createClientProfileId'), {
	        //       // id: this.props.match.params.businessUnitId,
	        //       maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords),
	        //       maxMonthlyBusinessRecords: parseInt(this.state.businessRecords),
	        //       consumerDataSource: this.state.consumerDataSource,
	        //       businessDataSource: 'InfoGroup'
	        //     })
	        //     this.setState({
	        //       disableCloseBtn: false
	        //     })
	        //   }, 3000)
	        // }
	      } else if (
	      // for business unit
	      this.state.requestParams.name.trim().length > 0 && this.state.requestParams.timezone.trim().length > 0 && typeof this.state.requestParams.industryId === "number") {
	        if (/^administrator/gi.test(this.props.roleName)) {
	          if ((0, _lodash.isEmpty)(this.state.requestParams.accountManagerUserId)) {
	            this.props.createClientProfile((0, _lodash.omit)(this.state.requestParams, "accountManagerUserIds"), this.props.paramId);
	          } else {
	            this.props.createClientProfile(this.state.requestParams, this.props.paramId);
	          }
	        } else {
	          this.props.createClientProfile(this.state.requestParams);
	        }
	      } else if (
	      // create business unit profile(system|account manager)
	      this.state.requestParams.name.trim().length > 0 && this.state.requestParams.timezone.trim().length > 0 && typeof this.state.requestParams.industryId === "number") {
	        if (/^(administrator|team member)/gi.test(this.props.roleInfo)) {
	          this.setState({
	            disableCloseBtn: false
	          });
	        }
	        if (this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5) {
	          var _requestParams2 = this.state.requestParams;
	
	          var _requestData2 = Object.assign({}, _requestParams2, {
	            insightsStandardConfig: {
	              maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
	              maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
	              consumerDataSource: this.state.consumerDataSource,
	              businessDataSource: this.state.businessDataSource
	            },
	            audienceResolutionGranularity: this.state.audienceResolutionGranularity
	          });
	          if (this.state.requestParams.subscriptionTierId === 4) {
	            _requestData2.insightsStandardConfig["segmentationSystem"] = this.state.segmentationSystem ? this.state.segmentationSystem : "prizm_premier";
	            _requestData2.insightsStandardConfig["appendSegmentation"] = this.state.appendSegmentation ? this.state.appendSegmentation : false;
	            if (this.state.appendSegmentation === true) {
	              _requestData2.insightsStandardConfig["segmentationLicenseNumber"] = this.state.licenseNum;
	              _requestData2.insightsStandardConfig["licenseExpirationDate"] = this.state.expYear + "-" + this.state.expMonth + "-1";
	            } else {
	              _requestData2.insightsStandardConfig["segmentationLicenseNumber"] = null;
	              _requestData2.insightsStandardConfig["licenseExpirationDate"] = null;
	            }
	          }
	          this.props.createClientProfile(_requestData2, this.props.paramId);
	        } else {
	          this.props.createClientProfile(this.state.requestParams, this.props.paramId);
	        }
	      }
	    }
	  }, {
	    key: "handleUploadLogo",
	    value: function handleUploadLogo() {
	      var _this4 = this;
	
	      if (this.state.ifLogoUploadButtonEnable) {
	        var formData = new FormData();
	        formData.append("logo", this.state.logoFileName);
	        // call api
	        var url = /^(system administrator|account manager|team member|administrator)/gi.test(this.props.roleName) ? "/api/clients/logo/upload" : "/api/clients/" + this.state.roleInfo.id + "/logo/upload";
	        fetch(url, {
	          method: "POST",
	          body: formData,
	          headers: new Headers({
	            Authorization: this.props.token
	          })
	        }).then(function (res) {
	          if (res.status === 200) {
	            return res.json();
	          } else {
	            res.json().then(function (json) {
	              _this4.setState({
	                companyLogoErrorText: json.message
	              });
	            });
	          }
	        }, function () {}).then(function (json) {
	          if (typeof json !== "undefined") {
	            localStorage.setItem("newLogoBase64", _this4.state.logoFileName.preview);
	            _this4.setState({
	              companyLogoErrorText: "",
	              newLogoBase64: _this4.state.logoFileName.preview,
	              requestParams: Object.assign({}, _this4.state.requestParams, {
	                logoUuid: json.uuid
	              })
	            });
	          }
	        }).catch(function (err) {
	          alert(err);
	        });
	      }
	    }
	  }, {
	    key: "handleClientProfileCancel",
	    value: function handleClientProfileCancel() {
	      this.props.clientProfileCancel();
	      this.props.rollbackProfileStatus();
	    }
	  }, {
	    key: "handleCloseCreateClientProfile",
	    value: function handleCloseCreateClientProfile() {
	      var _this5 = this;
	
	      this.props.rollbackProfileStatus(false);
	      this.setState({
	        logoUploadSuccess: false,
	        photoUploadSucess: false,
	        requiredNameText: "",
	        requiredTimezoneText: "",
	        requiredTierText: "",
	        requiredIndustryIdText: "",
	        ifLogoUploadButtonEnable: false,
	        ifPhotoUploadButtonEnable: false,
	        logoFileName: "No file chosen",
	        roleValue: "",
	        stateValue: "",
	        timezoneValue: "",
	        industryValue: "",
	        subscriptionTierValue: "",
	        assignClientValue: "",
	        clientId: "", // client id for upload
	        companyLogoErrorText: "",
	        profilePhotoErrorText: "",
	        companyLogoUuid: "", // logo uuid
	        userAvatarUuid: "", // avatar uuid
	        requestParams: {
	          name: "",
	          address1: "",
	          address2: "",
	          city: "",
	          state: "",
	          zipCode: "",
	          phone: "",
	          timezone: "",
	          industryId: "",
	          subscriptionTierId: "",
	          accountManagerUserIds: [""],
	          logoUuid: ""
	        },
	        ifShowContractNumber: false,
	        passwordRequestParams: {
	          password: Math.random().toString(36).substr(2),
	          confirmPassword: ""
	        },
	        newLogoBase64: ""
	        // showBaseInfoError: false
	      }, function () {
	        _this5.props.clientProfileCancel();
	      });
	    }
	  }, {
	    key: "handleConsumerRecords",
	    value: function handleConsumerRecords(e) {
	      if (e.target.value > 1000000) {
	        this.refs.consumer.value = 1000000;
	      } else if (!/^[0-9]*$/g.test(e.target.value)) {
	        this.refs.consumer.value = 0;
	      } else {
	        this.setState({
	          consumerRecords: e.target.value
	        });
	      }
	    }
	  }, {
	    key: "handleBusinessRecords",
	    value: function handleBusinessRecords(e) {
	      if (e.target.value > 1000000) {
	        this.refs.business.value = 1000000;
	      } else if (!/^[0-9]*$/g.test(e.target.value)) {
	        this.refs.business.value = 0;
	      } else {
	        this.setState({
	          businessRecords: e.target.value
	        });
	      }
	    }
	  }, {
	    key: "handleAccoundDownloadOptions",
	    value: function handleAccoundDownloadOptions(e, value) {
	      this.setState({
	        audienceResolutionGranularity: value
	      });
	    }
	  }, {
	    key: "handle3rdPartyData",
	    value: function handle3rdPartyData(e, value) {
	      this.setState({
	        consumerDataSource: value
	      });
	    }
	  }, {
	    key: "handle3rdBusinessPartyData",
	    value: function handle3rdBusinessPartyData(e, value) {
	      this.setState({
	        businessDataSource: value
	      });
	    }
	  }, {
	    key: "handleSegmentationSystem",
	    value: function handleSegmentationSystem(e, value) {
	      this.setState({
	        segmentationSystem: value
	      });
	    }
	  }, {
	    key: "handleAppendSegment",
	    value: function handleAppendSegment(e, value) {
	      this.setState({
	        appendSegmentation: value === "append_seg" ? true : false
	      });
	    }
	  }, {
	    key: "handleSalesforceId",
	    value: function handleSalesforceId(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          salesForceId: value
	        })
	      });
	    }
	  }, {
	    key: "handleEmail",
	    value: function handleEmail(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          email: value
	        })
	      });
	    }
	  }, {
	    key: "handleContractNumber",
	    value: function handleContractNumber(e, value) {
	      if (value === "" && /^(account manager)/gi.test(this.props.roleName)) {
	        this.setState({
	          ifShowContractNumber: true,
	          contractNumberText: "Please add a contract number"
	        });
	      } else if (value === "" && /^(system administrator)/gi.test(this.props.roleName)) {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            contractNumber: null
	          }),
	          contractNumberText: "",
	          ifShowContractNumber: false
	        });
	      } else if (!/^[0-9]{8}$/g.test(value) && value !== "") {
	        this.setState({
	          ifShowContractNumber: true,
	          requestParams: Object.assign({}, this.state.requestParams),
	          contractNumberText: "The contract number must be an 8 byte integer"
	        });
	      } else {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            contractNumber: value
	          }),
	          ifShowContractNumber: false,
	          contractNumberText: ""
	        });
	      }
	    }
	  }, {
	    key: "handelChangeContractNumb",
	    value: function handelChangeContractNumb(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          contractNumber: value
	        })
	      });
	    }
	  }, {
	    key: "handleChangeSalesforceId",
	    value: function handleChangeSalesforceId(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          salesForceId: value
	        })
	      });
	    }
	  }, {
	    key: "handleChangeEmail",
	    value: function handleChangeEmail(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          email: value
	        })
	      });
	    }
	  }, {
	    key: "handleClickDateWrapper",
	    value: function handleClickDateWrapper() {
	      var eles = document.querySelectorAll(".react-datepicker__day-name");
	      // change month name
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = eles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          v.innerText = v.innerText.substring(0, 1);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: "handleOnMonthChange",
	    value: function handleOnMonthChange(date) {
	      this.setState({
	        compareStartDate: date
	      });
	    }
	  }, {
	    key: "handleStartDateChange",
	    value: function handleStartDateChange(startDate) {
	      this.props.startDateChange(startDate ? startDate.format("YYYY-MM-DD") : null);
	
	      if (startDate) {
	        this.handleChange({ startDate: startDate });
	      } else {
	        this.setState({ startDate: null });
	      }
	    }
	  }, {
	    key: "clickOutsiteDatePicker",
	    value: function clickOutsiteDatePicker(type) {
	      switch (type) {
	        case "end":
	          this.refs.endDatePicker.cancelFocusInput();
	          this.refs.endDatePicker.setOpen(false);
	          break;
	        case "start":
	        default:
	          this.refs.startDatePicker.cancelFocusInput();
	          this.refs.startDatePicker.setOpen(false);
	          break;
	      }
	    }
	  }, {
	    key: "renderAccountDownloadConfig",
	    value: function renderAccountDownloadConfig() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "clearfix",
	          style: {
	            paddingTop: "16px",
	            paddingBottom: "16px",
	            marginBottom: "30px",
	            borderTop: "1px solid #B1B0B0",
	            borderBottom: "1px solid #B1B0B0"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: "24px",
	              fontWeight: "bold",
	              paddingBottom: "20px"
	            }
	          },
	          "Account Download Options"
	        ),
	        _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              fontWeight: "bolder",
	              width: "30%",
	              lineHeight: "1.2"
	            }
	          },
	          "Desired Granularity",
	          _react2.default.createElement(
	            "em",
	            { style: { color: "red" } },
	            "*"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              marginBottom: "20px",
	              minWidth: "400px",
	              width: "60%"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "download",
	              valueSelected: this.state.audienceResolutionGranularity,
	              onChange: function onChange(e, value) {
	                return _this6.handleAccoundDownloadOptions(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "Precision",
	              label: "Precision: Z+6 matches only",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "Scale",
	              label: "Scale: Z+6 matches where available/ Z+4 fallback",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderProfessionalConfig",
	    value: function renderProfessionalConfig() {
	      var _this7 = this,
	          _ref;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "clearfix",
	          style: {
	            paddingTop: "16px",
	            paddingBottom: "16px",
	            marginBottom: "30px",
	            borderTop: "1px solid #B1B0B0",
	            borderBottom: "1px solid #B1B0B0"
	          }
	        },
	        this.state.requestParams.subscriptionTierId === 4 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: "24px",
	              fontWeight: "bold",
	              paddingBottom: "20px"
	            }
	          },
	          "Professional Subscription Tier"
	        ),
	        _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              fontWeight: "bolder",
	              width: "30%",
	              lineHeight: "1.2"
	            }
	          },
	          "Maximum Monthly Records",
	          _react2.default.createElement(
	            "em",
	            { style: { color: "red" } },
	            "*"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { float: "left", width: "60%" } },
	          _react2.default.createElement(
	            "label",
	            { style: { fontWeight: "bold" } },
	            "Consumer"
	          ),
	          this.state.requestParams.subscriptionTierId === 1 && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "section",
	              { style: { marginBottom: "29px" } },
	              _react2.default.createElement(
	                "span",
	                null,
	                "Maximum Monthly Consumer Records",
	                " ",
	                _react2.default.createElement("input", {
	                  disabled: /^(administrator|team member)/gi.test(this.props.roleInfo),
	                  onBlur: function onBlur(e) {
	                    return _this7.handleConsumerRecords(e);
	                  },
	                  ref: "consumer",
	                  type: "text",
	                  style: {
	                    textAlign: "center",
	                    border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "none" : "1px solid #B1B0B0",
	                    width: "49px",
	                    height: "30px",
	                    marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "0" : "15px"
	                  }
	                })
	              )
	            )
	          ),
	          this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "section",
	              { style: { marginBottom: "29px" } },
	              _react2.default.createElement(
	                "span",
	                null,
	                "Maximum Monthly Consumer Records",
	                " ",
	                _react2.default.createElement("input", {
	                  disabled: /^(administrator|team member)/gi.test(this.props.roleInfo),
	                  onBlur: function onBlur(e) {
	                    return _this7.handleConsumerRecords(e);
	                  },
	                  ref: "consumer",
	                  type: "text",
	                  style: {
	                    textAlign: "center",
	                    border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "none" : "1px solid #B1B0B0",
	                    width: "49px",
	                    height: "30px",
	                    marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "0" : "15px"
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "label",
	            { style: { fontWeight: "bold" } },
	            "Business"
	          ),
	          _react2.default.createElement(
	            "section",
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              "Maximum Monthly Business Records",
	              " ",
	              _react2.default.createElement("input", {
	                disabled: /^(administrator|team member)/gi.test(this.props.roleInfo),
	                onBlur: function onBlur(e) {
	                  return _this7.handleBusinessRecords(e);
	                },
	                ref: "business",
	                type: "text",
	                style: {
	                  textAlign: "center",
	                  border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "none" : "1px solid #B1B0B0",
	                  width: "49px",
	                  height: "30px",
	                  marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "8px" : "22px"
	                }
	              })
	            )
	          )
	        ),
	        this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              fontWeight: "bolder",
	              width: "30%"
	            }
	          },
	          "Data Source - Consumer"
	        ),
	        this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              marginBottom: "20px",
	              minWidth: "400px",
	              width: "60%"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "consumer",
	              defaultSelected: window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon",
	              onChange: function onChange(e, value) {
	                return _this7.handle3rdPartyData(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "InfoGroup",
	              label: "InfoGroup",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "Epsilon",
	              label: "Epsilon",
	              disabled: window.location.href.indexOf("app.") >= 0
	              /*disabled={!(this.state.requestParams.subscriptionTierId === 1)}*/
	              , iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              fontWeight: "bolder",
	              width: "30%"
	            }
	          },
	          "Data Source - Business"
	        ),
	        this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              marginBottom: "20px",
	              minWidth: "400px",
	              width: "60%"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "consumer",
	              defaultSelected: "InfoGroup",
	              onChange: function onChange(e, value) {
	                return _this7.handle3rdBusinessPartyData(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "InfoGroup",
	              label: "InfoGroup",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId == 4 && _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              fontWeight: "bolder",
	              width: "30%"
	            }
	          },
	          "Segmentation System"
	        ),
	        this.state.requestParams.subscriptionTierId == 4 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              marginBottom: "20px",
	              minWidth: "400px"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "segmentation",
	              defaultSelected: "prizm_premier",
	              onChange: function onChange(e, value) {
	                return _this7.handleSegmentationSystem(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "prizm_premier",
	              label: "PRIZM Premier",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "psycle_premier",
	              label: "P$YCLE Premier",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "connexions",
	              label: "ConneXions",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId > 4 && _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              fontWeight: "bolder",
	              width: "30%"
	            }
	          },
	          "Append Segmentation to File"
	        ),
	        this.state.requestParams.subscriptionTierId > 4 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              marginBottom: "20px",
	              minWidth: "400px"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "segmentation",
	              defaultSelected: "no_append_seg",
	              onChange: function onChange(e, value) {
	                return _this7.handleAppendSegment(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "append_seg",
	              label: "Yes",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "no_append_seg",
	              label: "No",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId > 4 && this.state.appendSegmentation && _react2.default.createElement(_InputField2.default, {
	          labelTitle: "Segmentation License Number",
	          ifRequireField: true,
	          borderColor: "#B1B0B0",
	          onChange: function onChange(e, value) {
	            return _this7.handleLicenseNumber(e, value);
	          },
	          borderCorlor: "#B1B0B0",
	          labelStyle: (_ref = {
	            float: "left",
	            fontWeight: "bolder",
	            width: "30%",
	            lineHeight: "1.2",
	            margin: 0
	          }, _defineProperty(_ref, "lineHeight", "18px"), _defineProperty(_ref, "marginTop", "8px"), _ref),
	          inputContainerId: "firstName",
	          style: {
	            height: "32px",
	            lineHeight: "32px",
	            marginBottom: "30px",
	            zIndex: 2000
	          }
	        }),
	        this.state.requestParams.subscriptionTierId > 4 && this.state.appendSegmentation && _react2.default.createElement(
	          "div",
	          {
	            className: "role clearfix",
	            style: {
	              lineHeight: "32px",
	              position: "relative",
	              marginBottom: "20px",
	              marginTop: "150px"
	            }
	          },
	          _react2.default.createElement(
	            "p",
	            {
	              style: {
	                color: "black",
	                float: "left",
	                width: "30%",
	                margin: 0,
	                fontWeight: "bolder",
	                position: "absolute",
	                bottom: "5px"
	              }
	            },
	            "Expiration Date",
	            _react2.default.createElement(
	              "em",
	              { style: { color: "red" } },
	              "*"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "content clearfix ",
	              style: { paddingLeft: "30px", width: "80%" }
	            },
	            _react2.default.createElement(_reactSelect2.default, {
	              className: "date-selector month-selector z-index-199",
	              value: this.state.expMonth,
	              clearable: false,
	              options: this.state.months,
	              onChange: function onChange(date) {
	                return _this7.handleExpMonthChange(date);
	              },
	              placeholder: "MM"
	            }),
	            _react2.default.createElement(
	              "span",
	              {
	                className: "pl-20 pr-20",
	                style: { position: "absolute", bottom: "10px" }
	              },
	              "-"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              className: "date-selector year-selector z-index-199",
	              value: this.state.expYear,
	              clearable: false,
	              options: this.state.years,
	              onChange: function onChange(date) {
	                return _this7.handleExpYearChange(date);
	              },
	              placeholder: "YYYY"
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId == 4 && this.state.appendSegmentation && _react2.default.createElement(
	          "div",
	          { className: "profile-fn-wrapper", style: { marginTop: "1em" } },
	          this.state.licenseErrorText && this.state.licenseErrorText !== "" && _react2.default.createElement(
	            "section",
	            { className: "create-profile-error clearfix" },
	            _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	            _react2.default.createElement(
	              "span",
	              null,
	              this.state.licenseErrorText
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderTeamMembers",
	    value: function renderTeamMembers(isClientAdmin) {
	      if (/^(administrator|team member)/gi.test(this.props.roleName) && (0, _lodash.isEmpty)(this.props.teamMember_options)) {
	        return "";
	      }
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "role clearfix",
	          style: { lineHeight: "32px", marginBottom: "30px" }
	        },
	        _react2.default.createElement(
	          "p",
	          {
	            style: {
	              marginTop: "10px",
	              color: "black",
	              float: "left",
	              width: "30%",
	              lineHeight: /^(administrator|team member)/gi.test(this.props.roleName) ? "1.3em" : "",
	              fontWeight: "bolder"
	            }
	          },
	          /^(administrator|team member)/gi.test(this.props.roleName) ? "Assign Business Unit to" : "Assign Client to",
	          _react2.default.createElement(
	            "em",
	            {
	              style: { color: "red", display: isClientAdmin ? "none" : "inline" }
	            },
	            "*"
	          )
	        ),
	        _react2.default.createElement(_reactSelect2.default, {
	          style: { width: "68%", height: "32px" },
	          multi: true,
	          className: "cp-state-selector",
	          value: this.state.assignClientValue,
	          clearable: true,
	          simpleValue: true,
	          options: /^(administrator|team member)/gi.test(this.props.roleName) ? this.props.teamMember_options : this.props.account_manager,
	          onChange: this.handleAssignClientChange.bind(this)
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var muiTheme = (0, _getMuiTheme2.default)({
	        menuItem: {
	          hoverColor: (0, _utility.buttonBlueColor)()
	        }
	      });
	      var isClientAdmin = /^(administrator|team member)/gi.test(this.props.roleName);
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: muiTheme },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "profile fix-ui",
	            style: { marginTop: "20px", background: "#FFF" }
	          },
	          _react2.default.createElement(
	            _Dialog2.default,
	            {
	              modal: true,
	              contentStyle: {
	                width: "40%",
	                border: "1px solid black",
	                top: "-6em"
	              },
	              open: this.props.ifCreateClientProfileSuccess,
	              bodyStyle: { overflowY: "inherit", padding: "20px" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "create-profile-tip" },
	              _react2.default.createElement(
	                "p",
	                { className: "tip" },
	                "The profile was created successfully."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "btn-wrapper" },
	                _react2.default.createElement(
	                  "button",
	                  { onClick: function onClick() {
	                      return _this8.handleCloseCreateClientProfile();
	                    } },
	                  "CLOSE"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Dialog2.default,
	            {
	              modal: true,
	              contentStyle: {
	                width: "40%",
	                border: "1px solid black",
	                top: "-6em"
	              },
	              open: this.props.ifCreateClientProfileSuccessBasic,
	              bodyStyle: { overflowY: "inherit", padding: "20px" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "create-profile-tip" },
	              _react2.default.createElement(
	                "p",
	                { className: "tip" },
	                "The profile was created successfully."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "btn-wrapper" },
	                _react2.default.createElement(
	                  "button",
	                  { onClick: function onClick() {
	                      return _this8.handleCloseCreateClientProfile();
	                    } },
	                  "CLOSE"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "profile-form-top" },
	              _react2.default.createElement(
	                "h1",
	                { style: { border: "none", marginTop: "0.6em" } },
	                isClientAdmin ? "CREATE BUSINESS UNIT PROFILE" : "CREATE CLIENT PROFILE"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "profile-form" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "top" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "profile-fn-wrapper",
	                      style: { marginTop: "1em" }
	                    },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: /^(administrator|team member)/gi.test(this.props.roleName) ? "Business Unit Name" : "Client Name",
	                      ifRequireField: true,
	                      borderColor: "#B1B0B0",
	                      onChange: function onChange(e, value) {
	                        return _this8.handleClientName(e, value);
	                      },
	                      labelStyle: {
	                        float: "left",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0,
	                        lineHeight: "18px",
	                        marginTop: "8px"
	                      },
	                      inputContainerId: "firstName",
	                      style: { lineHeight: "32px", marginBottom: "30px" }
	                    }),
	                    this.state.requiredNameText !== "" && _react2.default.createElement(
	                      "section",
	                      { className: "create-profile-error clearfix" },
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        this.state.requiredNameText
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-ln-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: isClientAdmin ? "Business Unit Address 1" : "Client Address 1",
	                      onChange: function onChange(e, value) {
	                        return _this8.handleClientAddress1(e, value);
	                      },
	                      labelStyle: {
	                        float: "left",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        lineHeight: "1.2",
	                        margin: 0
	                      },
	                      inputContainerId: "lastName",
	                      borderColor: "#B1B0B0",
	                      style: { lineHeight: "32px", marginBottom: "30px" }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-ln-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: isClientAdmin ? "Business Unit Address 2" : "Client Address 2",
	                      onChange: function onChange(e, value) {
	                        return _this8.handleClientAddress2(e, value);
	                      },
	                      labelStyle: {
	                        float: "left",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        lineHeight: "1.2",
	                        margin: 0
	                      },
	                      inputContainerId: "lastName",
	                      borderColor: "#B1B0B0",
	                      style: { lineHeight: "32px", marginBottom: "30px" }
	                    })
	                  ),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: "City",
	                    labelStyle: {
	                      float: "left",
	                      fontWeight: "bolder",
	                      width: "30%",
	                      lineHeight: "1.2",
	                      margin: 0
	                    },
	                    onChange: function onChange(e, value) {
	                      return _this8.handleCity(e, value);
	                    },
	                    inputContainerId: "city",
	                    borderColor: "#B1B0B0",
	                    style: { lineHeight: "32px", marginBottom: "30px" }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "role clearfix",
	                      style: { lineHeight: "32px", marginBottom: "30px" }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          color: "black",
	                          float: "left",
	                          width: "30%",
	                          margin: 0,
	                          fontWeight: "bolder"
	                        }
	                      },
	                      "State"
	                    ),
	                    _react2.default.createElement(_reactSelect2.default, {
	                      style: { width: "68%", height: "32px" },
	                      className: "cp-state-selector z-index-199",
	                      value: this.state.stateValue,
	                      clearable: false,
	                      options: this.props.allstates,
	                      onChange: this.handleStateChange.bind(this)
	                    })
	                  ),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: "Zip Code",
	                    labelStyle: {
	                      float: "left",
	                      fontWeight: "bolder",
	                      width: "30%",
	                      lineHeight: "1.2",
	                      margin: 0
	                    },
	                    onChange: function onChange(e, value) {
	                      return _this8.handleZipCode(e, value);
	                    },
	                    inputContainerId: "zipCode",
	                    borderColor: "#B1B0B0",
	                    style: { lineHeight: "32px", marginBottom: "30px" }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "role clearfix",
	                      style: { lineHeight: "32px", marginBottom: "30px" }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          color: "black",
	                          float: "left",
	                          width: "30%",
	                          margin: 0,
	                          fontWeight: "bolder"
	                        }
	                      },
	                      "Time Zone",
	                      _react2.default.createElement(
	                        "em",
	                        { style: { color: "red" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement(_reactSelect2.default, {
	                      style: { width: "68%", height: "32px" },
	                      className: "cp-state-selector z-index-198",
	                      value: this.state.timezoneValue,
	                      clearable: false,
	                      options: this.props.timezone,
	                      onChange: this.handleTimeZoneChange.bind(this)
	                    })
	                  ),
	                  this.state.requiredTimezoneText !== "" && _react2.default.createElement(
	                    "section",
	                    { className: "create-profile-error clearfix" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.requiredTimezoneText
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "profile-mobile-phone-number clearfix",
	                      style: { marginBottom: "30px" }
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { style: { marginTop: "10px" } },
	                      "Phone Number"
	                    ),
	                    _react2.default.createElement(_reactTextMask2.default, {
	                      className: "mp-mask",
	                      guide: false,
	                      style: { border: "1px solid #B1B0B0", height: "32px" },
	                      mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
	                      onChange: function onChange(e) {
	                        return _this8.handleOfficePhoneNumber(e);
	                      }
	                    })
	                  ),
	                  /^(system administrator|administrator|team member|account manager)/gi.test(this.props.roleName) && _react2.default.createElement(_InputField2.default, {
	                    labelTitle: "Account Number",
	                    labelStyle: {
	                      float: "left",
	                      fontWeight: "bolder",
	                      width: "30%",
	                      lineHeight: "1.2",
	                      margin: 0
	                    },
	                    onChange: function onChange(e, value) {
	                      return _this8.handleAccountNumber(e, value);
	                    },
	                    inputContainerId: "officeNumber",
	                    borderCorlor: "#B1B0B0",
	                    style: { lineHeight: "32px", marginBottom: "30px" }
	                  }),
	                  /^\/clients$/g.test(this.props.path) && /^(account manager|system administrator)/gi.test(this.props.roleName) && _react2.default.createElement(
	                    "div",
	                    { className: "profile-fn-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: "Contract Number",
	                      handleOnBlur: function handleOnBlur(e, value) {
	                        return _this8.handleContractNumber(e, value);
	                      },
	                      onChange: function onChange(e, value) {
	                        return _this8.handelChangeContractNumb(e, value);
	                      },
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      initValue: this.state.requestParams.contractNumber === null ? "" : this.state.requestParams.contractNumber,
	                      ifRequireField: /^(account manager)/gi.test(this.props.roleName),
	                      borderCorlor: "#B1B0B0",
	                      labelStyle: {
	                        float: "left",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0
	                      },
	                      inputContainerId: "firstName",
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                      }
	                    }),
	                    this.state.ifShowContractNumber && _react2.default.createElement(
	                      "p",
	                      {
	                        className: "create-account-field-error clearfix",
	                        style: {
	                          marginBottom: "18px",
	                          marginTop: "-10px"
	                        }
	                      },
	                      _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        this.state.contractNumberText
	                      )
	                    )
	                  ),
	                  /^(system administrator|administrator|team member|account manager)/gi.test(this.props.roleName) && _react2.default.createElement(_InputField2.default, {
	                    labelTitle: "Salesforce ID",
	                    maxLength: 20,
	                    handleOnBlur: function handleOnBlur(e, value) {
	                      return _this8.handleSalesforceId(e, value);
	                    },
	                    onChange: function onChange(e, value) {
	                      return _this8.handleChangeSalesforceId(e, value);
	                    },
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    initValue: this.state.requestParams.salesForceId === null ? "" : this.state.requestParams.salesForceId,
	                    ifRequireField: false,
	                    borderCorlor: "#B1B0B0",
	                    labelStyle: {
	                      float: "left",
	                      fontWeight: "bolder",
	                      width: "30%",
	                      margin: 0
	                    },
	                    inputContainerId: "firstName",
	                    style: {
	                      lineHeight: "32px",
	                      borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                    }
	                  }),
	                  /^(system administrator|account manager|administrator|team member)/gi.test(this.props.roleInfo) && /^(\/clients\/edit\/Business-Units\/:id|\/clients)/g.test(this.props.path) && _react2.default.createElement(
	                    "div",
	                    {
	                      className: "role clearfix",
	                      style: { lineHeight: "32px", marginBottom: "10px" }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          color: "black",
	                          float: "left",
	                          width: "30%",
	                          margin: 0,
	                          fontWeight: "bolder"
	                        }
	                      },
	                      "Subscription Tier",
	                      " ",
	                      _react2.default.createElement(
	                        "em",
	                        { style: { color: "red" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { style: { float: "left" } },
	                      _react2.default.createElement(
	                        _RadioButton.RadioButtonGroup,
	                        {
	                          name: "clientTier",
	                          defaultSelected: this.state.subscriptionTierValue,
	                          onChange: function onChange(e, value) {
	                            return _this8.handleSubscriptionTierChange(value);
	                          }
	                        },
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          value: 2,
	                          label: "Basic",
	                          iconStyle: {
	                            fill: "black",
	                            width: "20px",
	                            height: "20px"
	                          }
	                        }),
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          value: 3,
	                          label: "Standard",
	                          iconStyle: {
	                            fill: "black",
	                            width: "20px",
	                            height: "20px"
	                          }
	                        }),
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          value: 4,
	                          label: "Professional",
	                          iconStyle: {
	                            fill: "black",
	                            width: "20px",
	                            height: "20px"
	                          }
	                        }),
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          value: 5,
	                          disabled: isClientAdmin,
	                          label: "Optimize",
	                          iconStyle: {
	                            fill: "black",
	                            width: "20px",
	                            height: "20px"
	                          }
	                        })
	                      )
	                    )
	                  ),
	                  this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && /^(system administrator|account manager|administrator|team member)/gi.test(this.props.roleInfo) && /^(\/clients\/edit\/Business-Units\/:id$)/g.test(this.props.path) && this.renderAccountDownloadConfig(),
	                  this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && /^(system administrator|account manager)/gi.test(this.props.roleInfo) && /^(\/clients)$/g.test(this.props.path) && this.renderAccountDownloadConfig(),
	                  this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && /^(system administrator|account manager|administrator|team member)/gi.test(this.props.roleInfo) && /^(\/clients\/edit\/Business-Units\/:id$)/g.test(this.props.path) &&
	                  /*
	                      <div style={{display: this.state.ifHiddenTopEdit ? 'none' : 'block', paddingLeft: '30%', paddingBottom: '29px'}}>
	                        <section style={{marginBottom: '29px'}}>
	                          <span>Maximum Monthly Consumer Records<input disabled={/^(administrator|team member)/gi.test(this.props.roleInfo)} onBlur={(e) => this.handleConsumerRecords(e)} ref="consumer" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? 'none' : '1px solid #B1B0B0', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? '0' : '15px'}}/></span>
	                        </section>
	                        <section>
	                          <span>Maximum Monthly Business Records <input disabled={/^(administrator|team member)/gi.test(this.props.roleInfo)} onBlur={(e) => this.handleBusinessRecords(e)} ref="business" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? 'none' : '1px solid #B1B0B0', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? '8px' : '22px'}}/></span>
	                        </section>
	                      </div>*/
	                  this.renderProfessionalConfig(),
	                  (this.state.requestParams.subscriptionTierId === 1 || this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5) && /^(system administrator|account manager)/gi.test(this.props.roleInfo) && /^(\/clients)$/g.test(this.props.path) && this.renderProfessionalConfig(),
	                  this.state.requiredTierText !== "" && _react2.default.createElement(
	                    "section",
	                    { className: "create-profile-error clearfix" },
	                    _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.requiredTierText
	                    )
	                  ),
	                  /^(system administrator|account manager)/gi.test(this.props.roleInfo) && this.state.requestParams.subscriptionTierId === 5 && _react2.default.createElement(_InputField2.default, {
	                    labelTitle: "Email",
	                    maxLength: 120,
	                    handleOnBlur: function handleOnBlur(e, value) {
	                      return _this8.handleEmail(e, value);
	                    },
	                    onChange: function onChange(e, value) {
	                      return _this8.handleChangeEmail(e, value);
	                    },
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    initValue: this.state.requestParams.email === null ? "" : this.state.requestParams.email,
	                    ifRequireField: true,
	                    borderCorlor: "#B1B0B0",
	                    labelStyle: {
	                      float: "left",
	                      fontWeight: "bolder",
	                      width: "30%",
	                      margin: 0
	                    },
	                    inputContainerId: "firstName",
	                    style: {
	                      lineHeight: "32px",
	                      borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                    }
	                  }),
	                  /^(system administrator|account manager)/gi.test(this.props.roleInfo) && this.state.requestParams.subscriptionTierId === 5 && this.state.requiredEmailText !== "" && _react2.default.createElement(
	                    "section",
	                    { className: "create-profile-error clearfix" },
	                    _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.requiredEmailText
	                    )
	                  ),
	                  /^(system administrator|account manager)/gi.test(this.props.roleInfo) && _react2.default.createElement(
	                    "div",
	                    {
	                      className: "role clearfix",
	                      style: { lineHeight: "32px", marginBottom: "30px" }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          color: "black",
	                          float: "left",
	                          width: "30%",
	                          margin: 0,
	                          fontWeight: "bolder"
	                        }
	                      },
	                      "Campaign Reporting ",
	                      _react2.default.createElement(
	                        "em",
	                        { style: { color: "red" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          float: "left",
	                          minWidth: "400px",
	                          with: "68%"
	                        }
	                      },
	                      _react2.default.createElement(
	                        _RadioButton.RadioButtonGroup,
	                        {
	                          name: "clientTier",
	                          valueSelected: this.state.requestParams.campaignReportPreference,
	                          onChange: function onChange(e, value) {
	                            e.preventDefault();
	                            _this8.handleCampaignReportChanged(value);
	                          }
	                        },
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          value: "Aggregated",
	                          label: "Aggregate",
	                          iconStyle: {
	                            fill: "black",
	                            width: "20px",
	                            height: "20px"
	                          }
	                        }),
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          value: "Detailed",
	                          label: "Detailed Campaign Reporting",
	                          iconStyle: {
	                            fill: "black",
	                            width: "20px",
	                            height: "20px"
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "pt-10",
	                          style: {
	                            borderTop: "solid 1px #000000",
	                            display: this.state.requestParams.campaignReportPreference === "Detailed" ? "block" : "none"
	                          }
	                        },
	                        _react2.default.createElement(_Checkbox2.default, {
	                          label: "Display Top Locations on Channel Reports",
	                          onCheck: function onCheck(e, isInputChecked) {
	                            return _this8.handleTopLocationReportCheck(e, isInputChecked);
	                          },
	                          iconStyle: styles.iconStyle,
	                          labelStyle: styles.labelStyle
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "role clearfix",
	                      style: { lineHeight: "32px", marginBottom: "30px" }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          color: "black",
	                          float: "left",
	                          width: "30%",
	                          margin: 0,
	                          fontWeight: "bolder"
	                        }
	                      },
	                      "Industry Type",
	                      _react2.default.createElement(
	                        "em",
	                        { style: { color: "red" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "ac-clients-select-filed",
	                        id: "industryType",
	                        style: { width: "68%", height: "34px" }
	                      },
	                      _react2.default.createElement(_CustomSelect2.default, {
	                        placeholder: "Select Industry Type",
	                        options: this.state.industryGroupObj,
	                        onChange: function onChange(value) {
	                          return _this8.handleIndustryChange(value);
	                        }
	                      })
	                    )
	                  ),
	                  this.state.requiredIndustryIdText !== "" && _react2.default.createElement(
	                    "section",
	                    { className: "create-profile-error clearfix" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.requiredIndustryIdText
	                    )
	                  ),
	                  !/^(account manager|team member)/gi.test(this.props.roleName) && this.renderTeamMembers(isClientAdmin),
	                  this.state.requiredAssignClientText !== "" && _react2.default.createElement(
	                    "section",
	                    { className: "create-profile-error clearfix" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.requiredAssignClientText
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "profile-logo-wrapper" },
	              typeof this.props.loginUserDetail !== "undefined" && /^(account manager|team member|system administrator|administrator)/gi.test(this.props.roleName) ? _react2.default.createElement(
	                "div",
	                { className: "profile-logo profile-company-logo clearfix" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "clearfix" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "title clearfix" },
	                    _react2.default.createElement(
	                      "span",
	                      { id: "profile-subtit" },
	                      "LOGO"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "review" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "profile-edit-img" },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "section" },
	                        "Select a logo to upload"
	                      ),
	                      _react2.default.createElement(
	                        _reactDropzone2.default,
	                        {
	                          onDrop: function onDrop(files, accept, reject) {
	                            return _this8.handleDrop(files, accept, reject);
	                          },
	                          style: { width: "100%", marginTop: "5px" },
	                          accept: "image/jpeg, image/png, image/jpg, image/gif",
	                          maxSize: 1048576,
	                          onDropRejected: function onDropRejected() {
	                            return _this8.onDropRejected();
	                          },
	                          name: "logo"
	                        },
	                        _react2.default.createElement(
	                          "p",
	                          {
	                            style: {
	                              textAlign: "center",
	                              display: "inline-block",
	                              width: "20%",
	                              height: "20px",
	                              fontSize: "12px",
	                              border: "1px solid grey",
	                              color: "black",
	                              borderRadius: "6px",
	                              lineHeight: "20px",
	                              marginTop: "10px"
	                            }
	                          },
	                          "Choose File"
	                        ),
	                        _react2.default.createElement(
	                          "i",
	                          {
	                            style: { fontStyle: "normal", marginLeft: "6px" }
	                          },
	                          this.state.logoFileName !== undefined && this.state.logoFileName.name || "No file chosen"
	                        ),
	                        _react2.default.createElement(
	                          "section",
	                          { className: "spec" },
	                          "(Only jpg, png, and gif file with maximum size of 1MB is allowed)"
	                        )
	                      ),
	                      _react2.default.createElement("img", { src: this.state.newLogoBase64, alt: "" }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          style: {
	                            background: (0, _utility.buttonBlueColor)(),
	                            padding: "5px 10px"
	                          },
	                          onClick: function onClick() {
	                            return _this8.handleUploadLogo();
	                          }
	                        },
	                        "UPLOAD LOGO"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "error", style: { marginLeft: "150px" } },
	                  this.props.update_logo_msg || this.state.companyLogoErrorText
	                )
	              ) : "",
	              _react2.default.createElement(
	                "div",
	                { className: "profile-edit clearfix" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "save-group clearfix",
	                    style: { position: "relative" }
	                  },
	                  _react2.default.createElement(
	                    "section",
	                    { className: "create-profile-s-error" },
	                    this.props.createClientProfileMessage
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "save",
	                      style: { background: (0, _utility.buttonBlueColor)() },
	                      onClick: function onClick() {
	                        return _this8.handleUpdateProfile();
	                      }
	                    },
	                    "SAVE"
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "cancel",
	                      onClick: function onClick() {
	                        return _this8.handleClientProfileCancel();
	                      },
	                      style: { fontWeight: "bolder", background: "white" }
	                    },
	                    "CANCEL"
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Profile;
	}(_react.Component);
	
	exports.default = Profile;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _RadioButton = __webpack_require__(107);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	__webpack_require__(395);
	
	var _clear = __webpack_require__(109);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _groupBy = __webpack_require__(150);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _CustomSelect = __webpack_require__(260);
	
	var _CustomSelect2 = _interopRequireDefault(_CustomSelect);
	
	var _reactTextMask = __webpack_require__(247);
	
	var _reactTextMask2 = _interopRequireDefault(_reactTextMask);
	
	var _reactDropzone = __webpack_require__(242);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _utility = __webpack_require__(14);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _image_not_available = __webpack_require__(1029);
	
	var _image_not_available2 = _interopRequireDefault(_image_not_available);
	
	var _worker = __webpack_require__(528);
	
	var _worker2 = _interopRequireDefault(_worker);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _concat = __webpack_require__(1633);
	
	var _concat2 = _interopRequireDefault(_concat);
	
	var _Grid = __webpack_require__(19);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property editMode {boolean} if true will be show edit mode.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var validator = __webpack_require__(393);
	
	var suspendDialogStyle = {
	  cancel: {
	    height: "30px",
	    background: "white",
	    color: "black",
	    border: "1px solid #B1B0B0",
	    fontWeight: "bold",
	    marginRight: "10px",
	    padding: "0 10px",
	    fontSize: "12px"
	  },
	  suspend: {
	    height: "30px",
	    background: "#DD0000",
	    color: "white",
	    border: "none",
	    fontWeight: "bold",
	    padding: "0 10px",
	    fontSize: "12px"
	  }
	};
	var styles = {
	  iconStyle: {
	    fill: "#000000",
	    transform: "scale(0.9)",
	    WebkitTransform: "scale(0.9)",
	    MsTransform: "scale(0.9)",
	    MozTransform: "scale(0.9)",
	    marginRight: "16px",
	    marginLeft: "-1px"
	  },
	  labelStyle: {
	    fontSize: "16px",
	    lineHeight: "15px",
	    marginBottom: 0,
	    paddingTop: "3px",
	    fontWeight: "normal"
	  }
	};
	
	var BusinessUnitsDetail = function (_Component) {
	  _inherits(BusinessUnitsDetail, _Component);
	
	  function BusinessUnitsDetail(props) {
	    _classCallCheck(this, BusinessUnitsDetail);
	
	    var _this = _possibleConstructorReturn(this, (BusinessUnitsDetail.__proto__ || Object.getPrototypeOf(BusinessUnitsDetail)).call(this, props));
	
	    _this.myProfile_worker = new Worker(_worker2.default);
	    _this.flagBase = true;
	    _this.throttleEditBusinessUnit = true; // for edit business unit profile
	    var months = [{ value: "01", label: "Jan" }, { value: "02", label: "Feb" }, { value: "03", label: "Mar" }, { value: "04", label: "Apr" }, { value: "05", label: "May" }, { value: "06", label: "Jun" }, { value: "07", label: "Jul" }, { value: "08", label: "Aug" }, { value: "09", label: "Sep" }, { value: "10", label: "Oct" }, { value: "11", label: "Nov" }, { value: "12", label: "Dec" }];
	    var years = [];
	    for (var i = 0; i < 10; i++) {
	      years.push({
	        value: (0, _moment2.default)().add(i, "years").format("YYYY"),
	        label: (0, _moment2.default)().add(i, "years").format("YYYY")
	      });
	    }
	    _this.state = {
	      expMonth: null,
	      expYear: null,
	      years: years,
	      months: months,
	      ori_edit_client_profile: {},
	      consumerDataSource: "",
	      ifShowSuspend: false,
	      ifHiddenTopEdit: true,
	      stateValue: "",
	      ifHiddenLogoEdit: true, // for logo
	      logoFileName: "No file chosen", // for logo
	      ifLogoUploadButtonEnable: false, // for logo
	      ifLogoSaveBtnEnable: false, // for logo
	      logoUploadSuccess: false, // for logo
	      industryGroupObj: [],
	      companyLogoErrorText: "",
	      campaignReportPreference: "Aggregated",
	      consumerRecords: 500, // consumer default value
	      businessRecords: 200, // business default value
	      audienceResolutionGranularity: "Scale",
	      status: "",
	      industry: {
	        id: "",
	        name: ""
	      },
	      subscription: {
	        id: "",
	        name: ""
	      },
	      accountManagers: [{
	        id: "",
	        firstName: "",
	        lastName: ""
	      }],
	      imgDataBase64: "", // for logo
	      newLogoBase64: "", // for logo
	      requestParams: {
	        name: "",
	        address1: "",
	        address2: "",
	        city: "",
	        state: "",
	        zipCode: "",
	        phone: "",
	        timezone: "",
	        email: "",
	        industryId: "",
	        // subscriptionTierId: '',
	        accountManagerUserIds: [""],
	        campaignReportPreference: "",
	        logoUuid: "",
	        contractNumber: "",
	        salesForceId: ""
	      },
	      contractNumberText: "",
	      ifShowContractNumber: false,
	      showDowngradeConfirm: false,
	      segmentationSystem: "prizm_premier",
	      appendSegmentation: false
	    };
	    return _this;
	  }
	
	  _createClass(BusinessUnitsDetail, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // when administarator
	      if (this.props.editMode) {
	        this.setState({
	          ifHiddenTopEdit: false
	        });
	      }
	      if (/^(administrator| team member)/gi.test(this.props.roleName)) {
	        this.setState({
	          ifHiddenTopEdit: false
	        });
	      }
	      this.props.getClientProfile(this.props.match.params.businessUnitId);
	      this.props.getTimezone();
	      this.props.getIndustryOptions();
	      this.props.getTierOptions();
	      if (this.props.match.params.id) {
	        this.props.getTeamMember(this.props.match.params.id);
	      } else {
	        if (/^(administrator| team member)/gi.test(this.props.roleName)) {
	          this.props.getTeamMember(this.props.loginUserDetail.client.id);
	        }
	      }
	      this.props.getCompanyLogo(this.props.match.params.businessUnitId);
	      this.props.getStates();
	      localStorage.setItem("newLogoBase64", "");
	      if (this.props.edit_client_profile && this.props.edit_client_profile.subscriptionTierId >= 3 && this.props.edit_client_profile.subscriptionTierId != 5) {
	        this.props.getConfigInsightsStandard(this.props.match.params.businessUnitId);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (/^Please add a contract number/g.test(nextProps.createClientProfileMessage)) {
	        this.setState({
	          ifShowContractNumber: true,
	          contractNumberText: "Please add a contract number"
	        });
	      }
	      // set 3rd part dataSource
	      // for edit business unit profile
	      if (this.throttleEditBusinessUnit && nextProps.match.params.id) {
	        if (nextProps.edit_client_profile && nextProps.edit_client_profile.subscriptionTierId >= 3 && nextProps.edit_client_profile.subscriptionTierId != 5) {
	          this.props.getConfigInsightsStandard(nextProps.match.params.businessUnitId);
	          this.throttleEditBusinessUnit = false;
	        }
	      }
	      if ((0, _isEmpty2.default)(this.state.industryGroupObj) && !(0, _isEmpty2.default)(nextProps.industryOptions)) {
	        var industryGroup = (0, _groupBy2.default)(nextProps.industryOptions, "group");
	        var obj = [];
	        for (var x in industryGroup) {
	          obj.push({
	            label: x,
	            options: industryGroup[x]
	          });
	        }
	        this.setState({
	          industryGroupObj: obj
	        });
	      }
	      if (nextProps.edit_client_profile.name && !(0, _isEqual2.default)(nextProps.edit_client_profile, this.state.ori_edit_client_profile)) {
	        var _nextProps$edit_clien = nextProps.edit_client_profile,
	            name = _nextProps$edit_clien.name,
	            address1 = _nextProps$edit_clien.address1,
	            address2 = _nextProps$edit_clien.address2,
	            city = _nextProps$edit_clien.city,
	            state = _nextProps$edit_clien.state,
	            status = _nextProps$edit_clien.status,
	            zipCode = _nextProps$edit_clien.zipCode,
	            phone = _nextProps$edit_clien.phone,
	            timezone = _nextProps$edit_clien.timezone,
	            industryId = _nextProps$edit_clien.industryId,
	            accountManagerUserIds = _nextProps$edit_clien.accountManagerUserIds,
	            subscriptionTierId = _nextProps$edit_clien.subscriptionTierId,
	            industry = _nextProps$edit_clien.industry,
	            subscription = _nextProps$edit_clien.subscription,
	            accountManagers = _nextProps$edit_clien.accountManagers,
	            accountNumber = _nextProps$edit_clien.accountNumber,
	            logo = _nextProps$edit_clien.logo,
	            campaignReportPreference = _nextProps$edit_clien.campaignReportPreference,
	            contractNumber = _nextProps$edit_clien.contractNumber,
	            clientReportDetailSetting = _nextProps$edit_clien.clientReportDetailSetting,
	            audienceResolutionGranularity = _nextProps$edit_clien.audienceResolutionGranularity,
	            salesForceId = _nextProps$edit_clien.salesForceId,
	            email = _nextProps$edit_clien.email;
	        // for logo
	
	        if (logo !== "logo.png" && typeof logo !== "undefined" && _typeof(nextProps.company_logo) === "object") {
	          // change blob to base64 for img element. and implement one time.
	          this.myProfile_worker.postMessage(nextProps.company_logo);
	          this.myProfile_worker.onmessage = function (e) {
	            _this2.setState({
	              imgDataBase64: e.data
	            });
	          };
	        } else {
	          this.setState({
	            imgDataBase64: _image_not_available2.default
	          });
	        }
	        if (nextProps.allstates.length > 0) {
	          var stateValue = nextProps.allstates.filter(function (item) {
	            return item.value === state;
	          }).length !== 0 && nextProps.allstates.filter(function (item) {
	            return item.value === state;
	          })[0].label;
	          this.setState({
	            stateValue: stateValue
	          });
	        }
	        if (nextProps.timezone.length > 0) {
	          var timezoneValue = nextProps.timezone.filter(function (item) {
	            return item.value === timezone;
	          })[0].label;
	          this.setState({
	            timezoneValue: timezoneValue
	          });
	        }
	        this.setState({
	          ori_edit_client_profile: Object.assign({}, nextProps.edit_client_profile),
	          status: status, // status can ben suspend or active,
	          industry: typeof industry !== "undefined" && industry,
	          subscription: typeof subscription !== "undefined" && subscription,
	          accountManagers: !(0, _isEmpty2.default)(accountManagers) && accountManagers[0] && accountManagers[0].status !== "Suspended" ? accountManagers : [{}],
	          audienceResolutionGranularity: audienceResolutionGranularity,
	          requestParams: Object.assign({}, this.state.requestParams, {
	            name: name,
	            address1: address1,
	            address2: address2,
	            city: city,
	            state: state,
	            status: status,
	            zipCode: zipCode,
	            phone: phone,
	            timezone: timezone,
	            industryId: industryId,
	            campaignReportPreference: campaignReportPreference,
	            subscriptionTierId: subscriptionTierId,
	            contractNumber: contractNumber,
	            email: email,
	            salesForceId: salesForceId,
	            accountManagerUserIds: !(0, _isEmpty2.default)(accountManagers) ? (0, _map2.default)(accountManagers, "id") : [""],
	            accountNumber: accountNumber,
	            clientReportDetailSetting: clientReportDetailSetting
	          })
	        });
	        // for edit client profile
	      }
	      if (!(0, _isEmpty2.default)(this.refs)) {
	        var _subscriptionTierId = this.props.edit_client_profile.subscriptionTierId;
	
	        if ((parseInt(_subscriptionTierId, 10) >= 3 && parseInt(_subscriptionTierId, 10) !== 5 || parseInt(_subscriptionTierId, 10) === 1) && nextProps.insights_standard_config !== "" && (/^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname) || /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname))) {
	          var insights_standard_config = nextProps.insights_standard_config;
	          // set consumer and business for edit client profile
	
	          this.refs.consumer.value = insights_standard_config.maxMonthlyConsumerRecords;
	          this.refs.business.value = insights_standard_config.maxMonthlyBusinessRecords;
	          this.setState({
	            consumerDataSource: insights_standard_config.consumerDataSource, //subscriptionTierId === 1 ? this.props.insights_standard_config.consumerDataSource : 'InfoGroup',
	            businessDataSource: insights_standard_config.businessDataSource,
	            consumerRecords: insights_standard_config.maxMonthlyConsumerRecords,
	            businessRecords: insights_standard_config.maxMonthlyBusinessRecords,
	            appendSegmentation: insights_standard_config.appendSegmentation,
	            licenseNum: insights_standard_config.segmentationLicenseNumber,
	            segmentationSystem: insights_standard_config.segmentationSystem,
	            expMonth: (0, _moment2.default)(insights_standard_config.licenseExpirationDate).format("MM"),
	            expYear: (0, _moment2.default)(insights_standard_config.licenseExpirationDate).format("YYYY")
	          });
	        } else if ((_subscriptionTierId >= 3 && _subscriptionTierId !== 5 || _subscriptionTierId === 1) && nextProps.insights_standard_config === "" /*&& this.refs.consumer && this.refs.business*/
	        ) {
	            this.refs.consumer.value = 0;
	            this.refs.business.value = 0;
	            this.setState({
	              consumerRecords: 0,
	              businessRecords: 0,
	              consumerDataSource: window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon",
	              businessDataSource: "InfoGroup"
	            });
	          }
	      }
	    }
	  }, {
	    key: "filterSubscriptionTierId",
	    value: function filterSubscriptionTierId(nextProps, subscriptionTierId) {
	      if (/^\/clients\/edit\/Business-Units\/detail/g.test(nextProps.location.pathname)) {
	        if (/^(system administrator|account manager)/gi.test(nextProps.roleName)) {
	          return "";
	        }
	      }
	      if (/^\/clients\/edit\/Client-Profile/g.test(nextProps.location.pathname)) {
	        if (/^(system administrator|account manager)/gi.test(nextProps.roleName)) {
	          return "";
	        }
	      }
	    }
	  }, {
	    key: "handleLogoEdit",
	    value: function handleLogoEdit() {
	      this.setState({
	        ifHiddenLogoEdit: false
	      });
	    }
	  }, {
	    key: "handleCancelLogoEdit",
	    value: function handleCancelLogoEdit() {
	      this.setState({
	        ifHiddenLogoEdit: true,
	        newLogoBase64: "",
	        logoFileName: "No file chosen"
	      });
	      localStorage.setItem("newLogoBase64", "");
	    }
	  }, {
	    key: "handleEdit",
	    value: function handleEdit() {
	      var _this3 = this;
	
	      if (!this.state.ifHiddenTopEdit) {
	        this.props.getClientProfile(this.props.match.params.businessUnitId);
	      }
	      if (this.props.editMode) {
	        this.props.handleCancel();
	      }
	      this.setState({
	        ifHiddenTopEdit: !this.state.ifHiddenTopEdit
	      }, function () {
	        if (_this3.refs.consumer && _this3.refs.business) {
	          _this3.refs.consumer.value = _this3.state.consumerRecords;
	          _this3.refs.business.value = _this3.state.businessRecords;
	        }
	      });
	    }
	  }, {
	    key: "handleDrop",
	    value: function handleDrop(files, accept, reject) {
	      this.setState({
	        logoFileName: files[0],
	        ifLogoUploadButtonEnable: true,
	        companyLogoErrorText: ""
	      });
	    }
	  }, {
	    key: "onDropRejected",
	    value: function onDropRejected() {
	      this.setState({
	        companyLogoErrorText: "Only jpg, png, and gif file with maximum size of 1MB is allowed"
	      });
	    }
	  }, {
	    key: "handleUploadLogo",
	    value: function handleUploadLogo() {
	      var _this4 = this;
	
	      if (this.state.ifLogoUploadButtonEnable) {
	        var formData = new FormData();
	        formData.append("logo", this.state.logoFileName);
	        // call api
	        fetch("/api/clients/" + this.props.match.params.businessUnitId + "/logo/upload", {
	          method: "POST",
	          body: formData,
	          headers: new Headers({
	            Authorization: this.props.token
	          })
	        }).then(function (res) {
	          if (res.status === 200) {
	            return res.json();
	          } else {
	            res.json().then(function (json) {
	              _this4.setState({
	                companyLogoErrorText: json.message
	              });
	            });
	          }
	        }, function () {}).then(function (json) {
	          if (typeof json !== "undefined") {
	            localStorage.setItem("newLogoBase64", _this4.state.logoFileName.preview);
	            _this4.setState({
	              companyLogoErrorText: "",
	              ifLogoSaveBtnEnable: true,
	              logoUploadSuccess: true,
	              requestParams: Object.assign({}, _this4.state.requestParams, {
	                logoUuid: json.uuid
	              }),
	              newLogoBase64: _this4.state.logoFileName.preview
	            });
	          }
	        }).catch(function (err) {
	          alert(err);
	        });
	      }
	    }
	  }, {
	    key: "handleUpdatelogo",
	    value: function handleUpdatelogo() {
	      if (this.state.ifLogoSaveBtnEnable) {
	        this.props.updateLogo(this.props.match.params.businessUnitId, this.state.requestParams.logoUuid);
	      }
	    }
	  }, {
	    key: "handleCloseDialog",
	    value: function handleCloseDialog() {
	      // reload redux
	      this.props.setStatus(false);
	    }
	  }, {
	    key: "handleTimeZoneChange",
	    value: function handleTimeZoneChange(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          timezone: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleIndustryChange",
	    value: function handleIndustryChange(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          industryId: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleReassignTo",
	    value: function handleReassignTo(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          accountManagerUserIds: value
	        })
	      });
	    }
	  }, {
	    key: "handleUpdate",
	    value: function handleUpdate() {
	      var requestData = this.state.requestParams;
	      if (this.state.requestParams.subscriptionTierId === 5) {
	        this.setState({
	          requiredEmailText: ""
	        });
	        if (this.state.requestParams.email.trim().length === 0) {
	          this.setState({
	            requiredEmailText: "Please enter email address"
	          });
	          return;
	        } else {
	          if (!validator.validate(this.state.requestParams.email.trim())) {
	            this.setState({
	              requiredEmailText: "Invalid email address"
	            });
	            return;
	          }
	        }
	      }
	      if (/^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname)) {
	        if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
	          // update consumer and business records
	          //if (this.state.requestParams.subscriptionTierId >= 3 ) {
	          // for edit business unit profile and create business unit profile
	          /*
	            this.props.configInsightsStandard(this.props.match.params.businessUnitId, {
	              // id: parseInt(this.props.match.params.businessUnitId),
	              maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
	              maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
	              consumerDataSource: this.state.consumerDataSource,
	              businessDataSource: 'InfoGroup'
	            })*/
	          var requestParams = this.state.requestParams;
	
	
	          if (requestParams.accountManagerUserIds && requestParams.accountManagerUserIds.length > 0 && requestParams.accountManagerUserIds[0] === "") {
	            requestParams.accountManagerUserIds = undefined;
	          } else {
	            if (requestParams.accountManagerUserIds && requestParams.accountManagerUserIds[0].value) {
	              var vals = (0, _map2.default)(requestParams.accountManagerUserIds, "value");
	              requestParams.accountManagerUserIds = vals;
	            } else {
	              if (!requestParams.accountManagerUserIds) requestParams.accountManagerUserIds = (0, _isEmpty2.default)(this.props.accountManagers) ? undefined : (0, _map2.default)(this.props.accountManagers, "id");
	            }
	          }
	          if (this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5) {
	            requestData = Object.assign({}, requestParams, {
	              insightsStandardConfig: {
	                maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
	                maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
	                consumerDataSource: this.state.consumerDataSource,
	                businessDataSource: this.state.businessDataSource
	              },
	              audienceResolutionGranularity: this.state.audienceResolutionGranularity
	            });
	            if (this.state.requestParams.subscriptionTierId === 4) {
	              requestData.insightsStandardConfig["segmentationSystem"] = this.state.segmentationSystem ? this.state.segmentationSystem : "prizm_premier";
	              requestData.insightsStandardConfig["appendSegmentation"] = this.state.appendSegmentation ? this.state.appendSegmentation : false;
	              if (this.state.appendSegmentation === true) {
	                requestData.insightsStandardConfig["segmentationLicenseNumber"] = this.state.licenseNum;
	                requestData.insightsStandardConfig["licenseExpirationDate"] = this.state.expYear + "-" + this.state.expMonth + "-01";
	              } else {
	                requestData.insightsStandardConfig["segmentationLicenseNumber"] = null;
	                requestData.insightsStandardConfig["licenseExpirationDate"] = null;
	              }
	            }
	          } else {
	            requestData = Object.assign({}, requestParams, {
	              insightsStandardConfig: undefined
	            });
	          }
	        }
	
	        if (this.props.edit_client_profile.subscriptionTierId >= 3 && this.props.edit_client_profile.subscriptionTierId !== 5 && requestData.subscriptionTierId === 2) {
	          this.setState({
	            showDowngradeConfirm: true
	          });
	        } else {
	          this.props.updateClientProfile(this.props.match.params.businessUnitId, requestData);
	        }
	        //}
	      }
	      if (/^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname)) {
	        // for edit client profile page
	
	        if (this.state.contractNumberText !== "") {
	          return;
	        }
	
	        //if (this.state.requestParams.subscriptionTierId >= 3) {
	        /*
	          // for edit business unit profile and create business unit profile
	          this.props.configInsightsStandard(this.props.match.params.businessUnitId, {
	            // id: parseInt(this.props.match.params.businessUnitId),
	            maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
	            maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
	            consumerDataSource: this.state.consumerDataSource,
	            businessDataSource: 'InfoGroup'
	          })*/
	        var _requestParams = this.state.requestParams;
	
	
	        if (_requestParams.accountManagerUserIds && _requestParams.accountManagerUserIds.length > 0 && _requestParams.accountManagerUserIds[0] === "") {
	          _requestParams.accountManagerUserIds = undefined;
	        } else {
	          if (_requestParams.accountManagerUserIds && _requestParams.accountManagerUserIds.length > 0) {
	            if (isNaN(_requestParams.accountManagerUserIds[0])) {
	              var _vals = (0, _map2.default)(_requestParams.accountManagerUserIds, "value");
	              _requestParams.accountManagerUserIds = _vals;
	            }
	          } else {
	            _requestParams.accountManagerUserIds = (0, _isEmpty2.default)(this.props.accountManagers) ? undefined : (0, _map2.default)(this.props.accountManagers, "id");
	          }
	        }
	        if (this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5) {
	          requestData = Object.assign({}, _requestParams, {
	            insightsStandardConfig: {
	              maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
	              maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
	              consumerDataSource: (0, _isEmpty2.default)(this.state.consumerDataSource) ? window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon" : this.state.consumerDataSource,
	              businessDataSource: (0, _isEmpty2.default)(this.state.businessDataSource) ? "Epsilon" : this.state.businessDataSource
	            },
	            audienceResolutionGranularity: this.state.audienceResolutionGranularity
	          });
	          if (this.state.requestParams.subscriptionTierId === 4) {
	            requestData.insightsStandardConfig["segmentationSystem"] = this.state.segmentationSystem ? this.state.segmentationSystem : "prizm_premier";
	            requestData.insightsStandardConfig["appendSegmentation"] = this.state.appendSegmentation ? this.state.appendSegmentation : false;
	            if (this.state.appendSegmentation === true) {
	              requestData.insightsStandardConfig["segmentationLicenseNumber"] = this.state.licenseNum;
	              requestData.insightsStandardConfig["licenseExpirationDate"] = this.state.expYear + "-" + this.state.expMonth + "-01";
	            } else {
	              requestData.insightsStandardConfig["segmentationLicenseNumber"] = null;
	              requestData.insightsStandardConfig["licenseExpirationDate"] = null;
	            }
	          }
	        } else {
	          requestData = Object.assign({}, _requestParams, {
	            insightsStandardConfig: undefined
	          });
	        }
	        //}
	        if (this.props.edit_client_profile.subscriptionTierId >= 3 && this.props.edit_client_profile.subscriptionTierId != 5 && requestData.subscriptionTierId === 2) {
	          this.setState({
	            showDowngradeConfirm: true
	          });
	        } else {
	          this.props.updateClientProfile(this.props.match.params.businessUnitId, requestData);
	        }
	      }
	      /*
	      if (/^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname)) {
	        if (/^(administrator|team member)/gi.test(this.props.roleName)) {
	          this.setState({
	            requestParams: {
	              ...this.state.requestParams
	            }
	          }, () => {
	            this.props.updateClientProfile(this.props.match.params.businessUnitId, this.state.requestParams);
	          })
	        }
	      }*/
	      this.throttleEditBusinessUnit = true;
	    }
	  }, {
	    key: "handleClose",
	    value: function handleClose() {
	      this.props.getClientProfile(this.props.match.params.businessUnitId);
	      this.setState({
	        ifHiddenTopEdit: true,
	        ifHiddenLogoEdit: true
	      });
	      if (this.props.editMode) {
	        this.props.handleCancel();
	      }
	      this.props.rollbackProfileStatus();
	      this.props.resetStandardConfig();
	      this.throttleEditBusinessUnit = true;
	    }
	  }, {
	    key: "handleAddress1",
	    value: function handleAddress1(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address1: value
	        })
	      });
	    }
	  }, {
	    key: "handleAddress2",
	    value: function handleAddress2(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address2: value
	        })
	      });
	    }
	  }, {
	    key: "handleCity",
	    value: function handleCity(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          city: value
	        })
	      });
	    }
	  }, {
	    key: "handleState",
	    value: function handleState(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          state: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleZipCode",
	    value: function handleZipCode(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          zipCode: value
	        })
	      });
	    }
	  }, {
	    key: "handlePhone",
	    value: function handlePhone(e) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          phone: e.target.value
	        })
	      });
	    }
	  }, {
	    key: "handleSuspendUser",
	    value: function handleSuspendUser() {
	      this.setState({
	        ifShowSuspend: true
	      });
	    }
	  }, {
	    key: "handleCancelSuspend",
	    value: function handleCancelSuspend() {
	      this.setState({
	        ifShowSuspend: false
	      });
	    }
	  }, {
	    key: "handleAccountNumber",
	    value: function handleAccountNumber(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          accountNumber: value
	        })
	      });
	    }
	  }, {
	    key: "handleName",
	    value: function handleName(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          name: value
	        })
	      });
	    }
	  }, {
	    key: "suspendUser",
	    value: function suspendUser() {
	      var clientId = this.props.match.params.businessUnitId;
	      var status = void 0;
	      if (this.state.status === "Suspended") {
	        status = "reactivate";
	      } else if (this.state.status === "Active") {
	        status = "suspend";
	      }
	      this.props.suspendAndReactivate(clientId, status);
	    }
	  }, {
	    key: "handleSubscriptionTierChange",
	    value: function handleSubscriptionTierChange(value) {
	      var _this5 = this;
	
	      var obj = value >= 3 && value !== 5 ? {
	        consumerDataSource: window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon",
	        businessDataSource: "InfoGroup",
	        requestParams: Object.assign({}, this.state.requestParams, {
	          subscriptionTierId: value
	        })
	      } : {
	        businessDataSource: this.props.insights_standard_config.businessDataSource,
	        consumerDataSource: this.props.insights_standard_config.consumerDataSource,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          subscriptionTierId: value
	        })
	      };
	      this.setState(obj, function () {
	        if ((value >= 3 && value !== 5 || value === 1) && _this5.refs.consumer && _this5.refs.business) {
	          _this5.refs.consumer.value = _this5.state.consumerRecords;
	          _this5.refs.business.value = _this5.state.businessRecords;
	        }
	      });
	    }
	  }, {
	    key: "filterTitle",
	    value: function filterTitle() {
	      if (/^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname)) {
	        if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
	          return "BUSINESS UNIT";
	        }
	      }
	      if (/^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname)) {
	        if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
	          return "CLIENT";
	        }
	        if (/^(administrator|team member)/gi.test(this.props.roleName)) {
	          return "BUSINESS UNIT";
	        }
	      }
	    }
	  }, {
	    key: "ifShowAssignTo",
	    value: function ifShowAssignTo() {
	      var ds = this.props.editMode ? /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname) && /^administrator/gi.test(this.props.roleName) ? this.props.teamMember_options : this.props.account_manager : this.props.teamMember_options;
	
	      if (/^(system administrator)/gi.test(this.props.roleName)) {
	        return true && !(0, _isEmpty2.default)(ds);
	      } else if (/^account manager/gi.test(this.props.roleName) && /^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname)) {
	        return true && !(0, _isEmpty2.default)(ds);
	      } else if (/^administrator/gi.test(this.props.roleName) && (/^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname) || /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname))) {
	        return true && !(0, _isEmpty2.default)(ds);
	      } else if (/^team member/gi.test(this.props.roleName) && /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname)) {
	        return false;
	      }
	    }
	  }, {
	    key: "handleConsumerRecords",
	    value: function handleConsumerRecords(e) {
	      if (e.target.value > 1000000) {
	        this.refs.consumer.value = 1000000;
	      } else if (!/^[0-9]*$/g.test(e.target.value)) {
	        this.refs.consumer.value = 0;
	      } else {
	        this.setState({
	          consumerRecords: e.target.value
	        });
	      }
	    }
	  }, {
	    key: "handleBusinessRecords",
	    value: function handleBusinessRecords(e) {
	      if (e.target.value > 1000000) {
	        this.refs.business.value = 1000000;
	      } else if (!/^[0-9]*$/g.test(e.target.value)) {
	        this.refs.business.value = 0;
	      } else {
	        this.setState({
	          businessRecords: e.target.value
	        });
	      }
	    }
	  }, {
	    key: "handle3rdPartyData",
	    value: function handle3rdPartyData(e, value) {
	      this.setState({
	        consumerDataSource: value //id === 1 ? value : 'InfoGroup'
	      });
	    }
	  }, {
	    key: "handleBusinessData",
	    value: function handleBusinessData(e, value) {
	      this.setState({
	        businessDataSource: value //id === 1 ? value : 'InfoGroup'
	      });
	    }
	  }, {
	    key: "handleSalesforceId",
	    value: function handleSalesforceId(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          salesForceId: value
	        })
	      });
	    }
	  }, {
	    key: "handleChangeSalesforceId",
	    value: function handleChangeSalesforceId(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          salesForceId: value
	        })
	      });
	    }
	  }, {
	    key: "handleEmail",
	    value: function handleEmail(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          email: value
	        })
	      });
	    }
	  }, {
	    key: "handleChangeEmail",
	    value: function handleChangeEmail(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          email: value
	        })
	      });
	    }
	  }, {
	    key: "handleContractNumber",
	    value: function handleContractNumber(e, value) {
	      if (value === "" && /^(account manager)/gi.test(this.props.roleName)) {
	        this.setState({
	          ifShowContractNumber: true,
	          contractNumberText: "Please add a contract number"
	        });
	      } else if (value === "" && /^(system administrator)/gi.test(this.props.roleName)) {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            contractNumber: null
	          }),
	          contractNumberText: "",
	          ifShowContractNumber: false
	        });
	      } else if (!/^[0-9]{8}$/g.test(value) && value !== "") {
	        this.setState({
	          ifShowContractNumber: true,
	          requestParams: Object.assign({}, this.state.requestParams),
	          contractNumberText: "The contract number must be an 8 byte integer"
	        });
	      } else {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            contractNumber: value
	          }),
	          ifShowContractNumber: false,
	          contractNumberText: ""
	        });
	      }
	      // else if (value === '') {
	      //   this.setState({
	      //     ifShowContractNumber: true,
	      //     contractNumberText: 'Please add a contract number'
	      //   })
	      // } else {
	      //   this.setState({
	      //     ifShowContractNumber: false,
	      //     contractNumberText: 'Please add a contract number'
	      //   })
	      // }
	    }
	  }, {
	    key: "handelChangeContractNumb",
	    value: function handelChangeContractNumb(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          contractNumber: value
	        })
	      });
	    }
	  }, {
	    key: "handledReportTypeChanged",
	    value: function handledReportTypeChanged(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          campaignReportPreference: value
	        })
	      });
	    }
	  }, {
	    key: "handleTopLocationReportCheck",
	    value: function handleTopLocationReportCheck(e, isChecked) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          clientReportDetailSetting: {
	            topLocationChannelReport: isChecked ? 1 : 0
	          }
	        })
	      });
	    }
	  }, {
	    key: "handleSegmentationSystem",
	    value: function handleSegmentationSystem(e, value) {
	      this.setState({
	        segmentationSystem: value
	      });
	    }
	  }, {
	    key: "handleAppendSegment",
	    value: function handleAppendSegment(e, value) {
	      this.setState({
	        appendSegmentation: value === "append_seg" ? true : false
	      });
	    }
	  }, {
	    key: "handleLicenseNumber",
	    value: function handleLicenseNumber(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams),
	        licenseNum: value
	      });
	    }
	  }, {
	    key: "handleExpMonthChange",
	    value: function handleExpMonthChange(value) {
	      this.setState({
	        expMonth: value.value
	      });
	    }
	  }, {
	    key: "handleExpYearChange",
	    value: function handleExpYearChange(value) {
	      this.setState({
	        expYear: value.value
	      });
	    }
	  }, {
	    key: "saveDowngradeClient",
	    value: function saveDowngradeClient(e) {
	      e.preventDefault();
	      this.props.updateClientProfile(this.props.match.params.businessUnitId, this.state.requestParams);
	      this.setState({ showDowngradeConfirm: false });
	    }
	  }, {
	    key: "handleAccoundDownloadOptions",
	    value: function handleAccoundDownloadOptions(e, value) {
	      this.setState({
	        audienceResolutionGranularity: value
	      });
	    }
	  }, {
	    key: "renderAccountDownloadConfig",
	    value: function renderAccountDownloadConfig() {
	      var _this6 = this;
	
	      return this.state.ifHiddenTopEdit ? _react2.default.createElement(
	        "div",
	        {
	          className: "role clearfix",
	          style: {
	            lineHeight: "33px",
	            borderBottom: "solid 1px #E8EBEF",
	            marginBottom: "0px"
	          }
	        },
	        _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              color: "#000",
	              fontWeight: "bolder",
	              width: "30%",
	              fontSize: "16px",
	              marginBottom: "0px"
	            }
	          },
	          "Desired Granularity",
	          _react2.default.createElement(
	            "em",
	            { style: { color: "red" } },
	            "*"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "pl-10", style: { float: "left" } },
	          this.state.audienceResolutionGranularity
	        )
	      ) : _react2.default.createElement(
	        "div",
	        {
	          className: "clearfix",
	          style: {
	            paddingTop: "16px",
	            paddingBottom: "16px",
	            borderTop: "1px solid #B1B0B0"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: "24px",
	              fontWeight: "bold",
	              paddingBottom: "20px"
	            }
	          },
	          "Account Download Options"
	        ),
	        _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              fontWeight: "bolder",
	              width: "30%",
	              lineHeight: "1.2"
	            }
	          },
	          "Desired Granularity",
	          _react2.default.createElement(
	            "em",
	            { style: { color: "red" } },
	            "*"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginBottom: "20px",
	              minWidth: "400px",
	              width: "60%"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "download",
	              valueSelected: this.state.audienceResolutionGranularity,
	              onChange: function onChange(e, value) {
	                return _this6.handleAccoundDownloadOptions(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "Precision",
	              label: "Precision: Z+6 matches only",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "Scale",
	              label: "Scale: Z+6 matches where available/ Z+4 fallback",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderProfessionalConfig",
	    value: function renderProfessionalConfig() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "clearfix",
	          style: {
	            display: this.state.ifHiddenTopEdit ? "none" : "block",
	            paddingTop: "16px",
	            paddingBottom: "16px",
	            marginBottom: "30px",
	            borderTop: "1px solid #B1B0B0",
	            borderBottom: "1px solid #B1B0B0"
	          }
	        },
	        this.state.requestParams.subscriptionTierId === 4 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: "24px",
	              fontWeight: "bold",
	              paddingBottom: "20px"
	            }
	          },
	          "Professional Subscription Tier"
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { float: "left", fontWeight: "bolder", width: "30%" } },
	          "Maximum Monthly Records",
	          _react2.default.createElement(
	            "em",
	            { style: { color: "red" } },
	            "*"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { float: "left", width: "60%" } },
	          _react2.default.createElement(
	            "label",
	            { style: { fontWeight: "bold" } },
	            "Consumer"
	          ),
	          this.state.requestParams.subscriptionTierId === 1 && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "section",
	              { style: { marginBottom: "29px" } },
	              _react2.default.createElement(
	                "span",
	                null,
	                "Maximum Monthly Consumer Records",
	                " ",
	                _react2.default.createElement("input", {
	                  disabled: /^(administrator|team member)/gi.test(this.props.roleInfo),
	                  onBlur: function onBlur(e) {
	                    return _this7.handleConsumerRecords(e);
	                  },
	                  ref: "consumer",
	                  type: "text",
	                  style: {
	                    textAlign: "center",
	                    border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "none" : "1px solid #B1B0B0",
	                    width: "49px",
	                    height: "30px",
	                    marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "0" : "15px"
	                  }
	                })
	              )
	            )
	          ),
	          this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "section",
	              { style: { marginBottom: "29px" } },
	              _react2.default.createElement(
	                "span",
	                null,
	                "Maximum Monthly Consumer Records4",
	                " ",
	                _react2.default.createElement("input", {
	                  disabled: /^(administrator|team member)/gi.test(this.props.roleInfo),
	                  onBlur: function onBlur(e) {
	                    return _this7.handleConsumerRecords(e);
	                  },
	                  ref: "consumer",
	                  type: "text",
	                  style: {
	                    textAlign: "center",
	                    border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "none" : "1px solid #B1B0B0",
	                    width: "49px",
	                    height: "30px",
	                    marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "0" : "15px"
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "label",
	            { style: { fontWeight: "bold" } },
	            "Business"
	          ),
	          _react2.default.createElement(
	            "section",
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              "Maximum Monthly Business Records",
	              " ",
	              _react2.default.createElement("input", {
	                disabled: /^(administrator|team member)/gi.test(this.props.roleInfo),
	                onBlur: function onBlur(e) {
	                  return _this7.handleBusinessRecords(e);
	                },
	                ref: "business",
	                type: "text",
	                style: {
	                  textAlign: "center",
	                  border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "none" : "1px solid #B1B0B0",
	                  width: "49px",
	                  height: "30px",
	                  marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? "8px" : "22px"
	                }
	              })
	            )
	          )
	        ),
	        this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              fontWeight: "bolder",
	              width: "30%"
	            }
	          },
	          "Data Source - Consumer"
	        ),
	        this.state.requestParams.subscriptionTierId >= 3 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              marginBottom: "20px",
	              minWidth: "400px",
	              width: "60%"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "consumer",
	              valueSelected: this.state.consumerDataSource ? this.state.consumerDataSource : window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon",
	              onChange: function onChange(e, value) {
	                return _this7.handle3rdPartyData(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "InfoGroup",
	              label: "InfoGroup",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "Epsilon",
	              label: "Epsilon",
	              disabled: window.location.href.indexOf("app.") >= 0
	              /*disabled={!(this.state.requestParams.subscriptionTierId === 1)}*/
	              , iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              fontWeight: "bolder",
	              width: "30%"
	            }
	          },
	          "Data Source - Business"
	        ),
	        this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              marginBottom: "20px",
	              minWidth: "400px",
	              width: "60%"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "business",
	              valueSelected: this.state.businessDataSource ? this.state.businessDataSource : "InfoGroup",
	              onChange: function onChange(e, value) {
	                return _this7.handleBusinessData(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "InfoGroup",
	              label: "InfoGroup",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId == 4 && _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              fontWeight: "bolder",
	              width: "30%"
	            }
	          },
	          "Segmentation System"
	        ),
	        this.state.requestParams.subscriptionTierId == 4 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              marginBottom: "20px",
	              minWidth: "400px",
	              width: "60%"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "segmentation",
	              valueSelected: this.state.segmentationSystem ? this.state.segmentationSystem : "prizm_premier",
	              onChange: function onChange(e, value) {
	                return _this7.handleSegmentationSystem(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "prizm_premier",
	              label: "PRIZM Premier",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "psycle_premier",
	              label: "P$YCLE Premier",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "connexions",
	              label: "ConneXions",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId > 4 && _react2.default.createElement(
	          "p",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              fontWeight: "bolder",
	              width: "30%"
	            }
	          },
	          "Append Segmentation to File"
	        ),
	        this.state.requestParams.subscriptionTierId > 4 && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              marginTop: "20px",
	              marginBottom: "20px",
	              minWidth: "400px"
	            }
	          },
	          _react2.default.createElement(
	            _RadioButton.RadioButtonGroup,
	            {
	              name: "segmentation",
	              defaultSelected: "no_append_seg",
	              valueSelected: this.state.appendSegmentation && this.state.appendSegmentation === true ? "append_seg" : "no_append_seg",
	              onChange: function onChange(e, value) {
	                return _this7.handleAppendSegment(e, value);
	              }
	            },
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "append_seg",
	              label: "Yes",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            }),
	            _react2.default.createElement(_RadioButton.RadioButton, {
	              value: "no_append_seg",
	              label: "No",
	              iconStyle: { fill: "black", width: "20px", height: "20px" }
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId > 4 && this.state.appendSegmentation && _react2.default.createElement(
	          "div",
	          { className: "profile-fn-wrapper" },
	          _react2.default.createElement(_InputField2.default, {
	            labelTitle: "Segmentation License Number",
	            ifRequireField: true,
	            borderColor: "#B1B0B0",
	            onChange: function onChange(e, value) {
	              return _this7.handleLicenseNumber(e, value);
	            },
	            initValue: this.state.licenseNum === null ? "" : this.state.licenseNum,
	            borderCorlor: "#B1B0B0",
	            labelStyle: {
	              float: "left",
	              fontWeight: "bolder",
	              width: "50%",
	              margin: 0,
	              lineHeight: "18px",
	              marginTop: "8px"
	            },
	            inputContainerId: "licenseNumber",
	            style: {
	              height: "32px",
	              lineHeight: "32px",
	              marginBottom: "30px",
	              zIndex: 2000,
	              width: "60%"
	            }
	          })
	        ),
	        this.state.requestParams.subscriptionTierId > 4 && this.state.appendSegmentation && _react2.default.createElement(
	          "div",
	          {
	            className: "role clearfix",
	            style: {
	              lineHeight: "32px",
	              position: "relative",
	              marginTop: "150px"
	            }
	          },
	          _react2.default.createElement(
	            "p",
	            {
	              style: {
	                color: "black",
	                float: "left",
	                width: "30%",
	                margin: 0,
	                fontWeight: "bolder",
	                position: "absolute",
	                bottom: "5px"
	              }
	            },
	            "Expiration Date",
	            _react2.default.createElement(
	              "em",
	              { style: { color: "red" } },
	              "*"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "content clearfix ",
	              style: { width: "65%", paddingLeft: "30%" }
	            },
	            _react2.default.createElement(_reactSelect2.default, {
	              className: "date-selector month-selector z-index-199",
	              value: this.state.expMonth,
	              clearable: false,
	              options: this.state.months,
	              onChange: function onChange(date) {
	                return _this7.handleExpMonthChange(date);
	              },
	              placeholder: "MM"
	            }),
	            _react2.default.createElement(
	              "span",
	              {
	                className: "pl-10 pr-10",
	                style: { position: "absolute", bottom: "10px" }
	              },
	              "-"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              className: "date-selector year-selector z-index-199",
	              value: this.state.expYear,
	              clearable: false,
	              options: this.state.years,
	              onChange: function onChange(date) {
	                return _this7.handleExpYearChange(date);
	              },
	              placeholder: "YYYY"
	            })
	          )
	        ),
	        this.state.requestParams.subscriptionTierId == 4 && this.state.appendSegmentation && _react2.default.createElement(
	          "div",
	          { className: "profile-fn-wrapper", style: { marginTop: "1em" } },
	          this.state.licenseErrorText && this.state.licenseErrorText !== "" && _react2.default.createElement(
	            "section",
	            { className: "create-profile-error clearfix" },
	            _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	            _react2.default.createElement(
	              "span",
	              null,
	              this.state.licenseErrorText
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        label: "Close",
	        primary: true,
	        backgroundColor: (0, _utility.buttonBlueColor)(),
	        labelStyle: { color: "white" },
	        hoverColor: (0, _utility.buttonBlueColor)(),
	        onClick: function onClick() {
	          return _this8.handleCloseDialog();
	        }
	      })];
	      var isEmptyAccIds = !this.state.requestParams.accountManagerUserIds || (0, _isEmpty2.default)(this.state.requestParams.accountManagerUserIds) || this.state.requestParams.accountManagerUserIds[0] === "";
	      var roleName = this.props.roleName;
	
	      console.log(roleName);
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "edit-client-profile",
	          style: {
	            padding: /^(administrator|team member|system administrator|account manager)/gi.test(this.props.roleName) && this.props.editMode ? "0" : ""
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "edit-client-box" },
	          this.state.ifHiddenTopEdit && _react2.default.createElement("div", { className: "edit-client-shadow" }),
	          _react2.default.createElement(
	            "h4",
	            {
	              style: {
	                display: !this.state.ifHiddenTopEdit ? "block" : "none",
	                fontWeight: "bolder",
	                fontSize: "24px",
	                marginTop: "0",
	                marginBottom: "20px"
	              }
	            },
	            "CHANGE",
	            " ",
	            /^(system administrator|account manager)/gi.test(this.props.roleName) ? /^\/clients\/edit\/Business-Units/g.test(this.props.location.pathname) ? "BUSSINESS UNIT" : "CLIENT" : "BUSINESS UNIT",
	            " ",
	            "PROFILE"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              href: "/clients/edit/Business-Units/detail/Team Members/" + this.props.match.params.id + "?name=" + this.props.edit_client_profile.name + "&id=" + this.props.edit_client_profile.id,
	              style: {
	                display: this.state.ifHiddenTopEdit && /^\/clients\/edit\/Business-Units\/detail/gi.test(this.props.location.pathname) ? "block" : "none",
	                textAlign: "right",
	                margin: this.state.ifHiddenTopEdit ? "" : "0 13px 20px 0"
	              }
	            },
	            "View Team Members"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: /^(system administrator|account manager)/gi.test(this.props.roleName) ? /^\/clients\/edit\/Business-Units/g.test(this.props.location.pathname) ? "Business Unit Name" : "Client Name" : "Business Unit Name",
	              onChange: function onChange(e, value) {
	                return _this8.handleName(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.name,
	              hintText: this.state.requestParams.name,
	              ifRequireField: true,
	              borderColor: "#B1B0B0",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "profile-fn-wrapper clearfix",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "none",
	                marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  float: "left",
	                  fontSize: "16px",
	                  fontWeight: "bolder",
	                  width: "30%"
	                }
	              },
	              "Profile Creation Date"
	            ),
	            _react2.default.createElement(
	              "strong",
	              {
	                style: {
	                  float: "left",
	                  paddingLeft: "10px",
	                  fontWeight: "normal"
	                }
	              },
	              this.props.edit_client_profile.createdTime && (0, _moment2.default)(this.props.edit_client_profile.createdTime).format("M/D/YYYY")
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "profile-fn-wrapper clearfix",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "none",
	                marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  float: "left",
	                  fontSize: "16px",
	                  fontWeight: "bolder",
	                  width: "30%"
	                }
	              },
	              "Status"
	            ),
	            _react2.default.createElement(
	              "strong",
	              {
	                style: {
	                  float: "left",
	                  paddingLeft: "10px",
	                  fontWeight: "normal"
	                }
	              },
	              this.state.requestParams.status
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: /^(system administrator|account manager)/gi.test(this.props.roleName) ? /^\/clients\/edit\/Business-Units/g.test(this.props.location.pathname) ? "Business Unit Address 1" : "Client Address 1" : "Business Unit Address 1",
	              onChange: function onChange(e, value) {
	                return _this8.handleAddress1(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.address1,
	              hintText: this.state.requestParams.address1,
	              borderColor: "#B1B0B0",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: /^(system administrator|account manager)/gi.test(this.props.roleName) ? /^\/clients\/edit\/Business-Units/g.test(this.props.location.pathname) ? "Business Unit Address 2" : "Client Address 2" : "Business Unit Address 2",
	              onChange: function onChange(e, value) {
	                return _this8.handleAddress2(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.address2,
	              hintText: this.state.requestParams.address2,
	              borderColor: "#B1B0B0",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: "City",
	              onChange: function onChange(e, value) {
	                return _this8.handleCity(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.city,
	              hintText: this.state.requestParams.city,
	              borderColor: "#B1B0B0",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "State"
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "70%" } },
	              this.state.stateValue
	            ) : _react2.default.createElement(_reactSelect2.default, {
	              className: "client-profile-timezone edit-state",
	              value: this.state.requestParams.state,
	              clearable: false,
	              options: this.props.allstates,
	              onChange: function onChange(value) {
	                return _this8.handleState(value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: "Zip Code",
	              onChange: function onChange(e, value) {
	                return _this8.handleZipCode(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.zipCode,
	              hintText: this.state.requestParams.zipCode,
	              borderColor: "#B1B0B0",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Time Zone",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "70%" } },
	              this.state.timezoneValue
	            ) : _react2.default.createElement(_reactSelect2.default, {
	              className: "client-profile-timezone edit-timezone",
	              value: this.state.requestParams.timezone,
	              clearable: false,
	              searchable: false,
	              options: this.props.timezone,
	              onChange: function onChange(value) {
	                return _this8.handleTimeZoneChange(value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "profile-mobile-phone-number clearfix",
	              style: {
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                style: { marginTop: this.state.ifHiddenTopEdit ? "" : "10px" }
	              },
	              "Phone Number"
	            ),
	            _react2.default.createElement(_reactTextMask2.default, {
	              className: "mp-mask",
	              guide: false,
	              value: this.state.requestParams.phone,
	              style: {
	                border: this.state.ifHiddenTopEdit ? "" : "1px solid #B1B0B0",
	                height: this.state.ifHiddenTopEdit ? "" : "32px"
	              },
	              mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
	              onChange: function onChange(e) {
	                return _this8.handlePhone(e);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: "Account Number",
	              onChange: function onChange(e, value) {
	                return _this8.handleAccountNumber(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.accountNumber,
	              hintText: this.state.requestParams.accountNumber,
	              borderColor: "#B1B0B0",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0
	              }
	            })
	          ),
	          /^(\/clients\/edit\/Client-Profile)/g.test(this.props.location.pathname) && /^(account manager|system administrator)/gi.test(this.props.roleName) && _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: "Contract Number",
	              handleOnBlur: function handleOnBlur(e, value) {
	                return _this8.handleContractNumber(e, value);
	              },
	              onChange: function onChange(e, value) {
	                return _this8.handelChangeContractNumb(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.contractNumber === null ? "" : this.state.requestParams.contractNumber,
	              hintText: this.state.requestParams.contractNumber,
	              borderColor: "#B1B0B0",
	              ifRequireField: /^(account manager)/gi.test(this.props.roleName),
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0
	              }
	            }),
	            this.state.ifShowContractNumber && _react2.default.createElement(
	              "p",
	              { className: "create-account-field-error clearfix" },
	              _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	              _react2.default.createElement(
	                "span",
	                null,
	                this.state.contractNumberText
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              maxLength: 20,
	              labelTitle: "Salesforce ID",
	              handleOnBlur: function handleOnBlur(e, value) {
	                return _this8.handleSalesforceId(e, value);
	              },
	              onChange: function onChange(e, value) {
	                return _this8.handleChangeSalesforceId(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.salesForceId === null ? "" : this.state.requestParams.salesForceId,
	              hintText: this.state.requestParams.salesForceId,
	              borderColor: "#B1B0B0",
	              ifRequireField: false,
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0
	              }
	            })
	          ),
	          /^(system administrator|account manager|administrator|team member)/gi.test(this.props.roleName) && /^(\/clients\/edit\/Client-Profile|\/clients\/edit\/Business-Units\/detail)/g.test(this.props.location.pathname) &&
	          /*
	          <div className="role clearfix" style={{lineHeight: '33px', borderBottom: this.state.ifHiddenTopEdit ? '1px solid #E8EBEF' : '', marginBottom: !this.state.ifHiddenTopEdit ? '13px' : '0'}}>
	            <p style={{ marginTop: '7px', color: 'black', fontSize: '16px', float: 'left', width: '30%', margin: 0, fontWeight: 'bolder' }}>Subscription Tier<em style={{ color: 'red'}}>*</em></p>
	            {this.state.ifHiddenTopEdit  ? (<div className="pull-left pl-10" style={{width: '68%'}}>{this.state.subscription.name}</div>):
	              (<Select
	                className="client-profile-stimezone edit-subscription"
	                value={this.state.requestParams.subscriptionTierId}
	                clearable={false}
	                searchable={false}
	                options={/^(\/clients\/edit\/Business-Units\/detail)/g.test(this.props.location.pathname) ||
	                (/^(administrator|team member)/gi.test(this.props.roleName) && /^(\/clients\/edit\/Client-Profile)/g.test(this.props.location.pathname)) ?
	                  this.props.tier_options.filter(item => item.value !== 1) :
	                  this.props.tier_options}
	                onChange={(value) => this.handleSubscriptionTierChange(value)}
	              />)}
	          </div>*/
	          _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "16px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Subscription Tier ",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { float: "left" } },
	              this.state.ifHiddenTopEdit ? _react2.default.createElement(
	                "div",
	                { className: "ml-10" },
	                this.state.requestParams.subscriptionTierId && (this.state.requestParams.subscriptionTierId === 2 ? "Basic" : this.state.requestParams.subscriptionTierId === 3 ? "Standard" : "Professional")
	              ) : _react2.default.createElement(
	                _RadioButton.RadioButtonGroup,
	                {
	                  name: "clientTier",
	                  valueSelected: this.state.requestParams.subscriptionTierId,
	                  onChange: function onChange(e, value) {
	                    return _this8.handleSubscriptionTierChange(value);
	                  }
	                },
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: 2,
	                  label: "Basic",
	                  iconStyle: {
	                    fill: "black",
	                    width: "20px",
	                    height: "20px"
	                  }
	                }),
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: 3,
	                  label: "Standard",
	                  iconStyle: {
	                    fill: "black",
	                    width: "20px",
	                    height: "20px"
	                  }
	                }),
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: 4,
	                  label: "Professional",
	                  iconStyle: {
	                    fill: "black",
	                    width: "20px",
	                    height: "20px"
	                  }
	                }),
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: 5,
	                  disabled: /^\/clients\/edit\/Business-Units/g.test(this.props.location.pathname),
	                  label: "Optimize",
	                  iconStyle: {
	                    fill: "black",
	                    width: "20px",
	                    height: "20px"
	                  }
	                })
	              )
	            )
	          ),
	          /^(\/clients\/edit\/Client-Profile|\/clients\/edit\/Business-Units\/detail)/g.test(this.props.location.pathname) && /^(account manager|system administrator)/gi.test(this.props.roleName) && this.state.requestParams.subscriptionTierId === 5 && _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: "Email",
	              handleOnBlur: function handleOnBlur(e, value) {
	                return _this8.handleEmail(e, value);
	              },
	              onChange: function onChange(e, value) {
	                return _this8.handleChangeEmail(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.email === null ? "" : this.state.requestParams.email,
	              hintText: this.state.requestParams.email,
	              borderColor: "#B1B0B0",
	              ifRequireField: true,
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0
	              }
	            }),
	            this.state.requiredEmailText && _react2.default.createElement(
	              "p",
	              { className: "create-account-field-error clearfix" },
	              _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	              _react2.default.createElement(
	                "span",
	                null,
	                this.state.requiredEmailText
	              )
	            )
	          ),
	          this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && /^(system administrator|account manager)/gi.test(this.props.roleName) && /^(\/clients\/edit\/Business-Units\/detail)/g.test(this.props.location.pathname) && this.state.ifHiddenTopEdit && _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "33px",
	                borderBottom: "solid 1px #E8EBEF",
	                marginBottom: "0px"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  float: "left",
	                  color: "#000",
	                  fontWeight: "bolder",
	                  width: "30%",
	                  fontSize: "16px",
	                  marginBottom: "0px"
	                }
	              },
	              "Data Source",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "pl-10", style: { float: "left" } },
	              _react2.default.createElement(
	                "section",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Consumer"
	                ),
	                " - ",
	                this.state.consumerDataSource
	              ),
	              _react2.default.createElement(
	                "section",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Business"
	                ),
	                " - ",
	                this.state.businessDataSource
	              )
	            )
	          ),
	          this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && /^(system administrator|account manager)/gi.test(this.props.roleName) && /^(\/clients\/edit\/Business-Units\/detail)/g.test(this.props.location.pathname) && this.renderAccountDownloadConfig(),
	          this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && /^(system administrator|account manager)/gi.test(this.props.roleName) && /^(\/clients\/edit\/Client-Profile)/g.test(this.props.location.pathname) && this.renderAccountDownloadConfig(),
	          this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 && /^(system administrator|account manager|administrator|team member)/gi.test(this.props.roleName) && /^(\/clients\/edit\/Business-Units\/detail)/g.test(this.props.location.pathname) /* || 
	                                                                                                                                                                                                                                                                                                      /^(\/clients\/edit\/Client-Profile)/g.test(this.props.location.pathname)*/ &&
	          /*
	            <div style={{display: this.state.ifHiddenTopEdit ? 'none' : 'block', paddingLeft: '30%', paddingBottom: '29px'}}>
	              <section style={{marginBottom: '29px'}}>
	                <span>Maximum Monthly Consumer Records <input disabled={/^(administrator|team member)/gi.test(this.props.roleName)} onBlur={(e) => this.handleConsumerRecords(e)} 
	                  defaultValue={this.state.consumerRecords}
	                  ref="consumer" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleName) ? 'none' : '1px solid #B1B0B0', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleName) ? '0' : '15px'}}/></span>
	              </section>
	              <section>
	                <span>Maximum Monthly Business Records <input disabled={/^(administrator|team member)/gi.test(this.props.roleName)} onBlur={(e) => this.handleBusinessRecords(e)} ref="business" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleName) ? 'none' : '1px solid #B1B0B0', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleName) ? '8px' : '22px'}}/></span>
	              </section>
	            </div>*/
	          this.renderProfessionalConfig(),
	          (this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 || this.state.requestParams.subscriptionTierId === 1) && /^(system administrator|account manager)/gi.test(this.props.roleName) && /^(\/clients\/edit\/Client-Profile)/g.test(this.props.location.pathname) && this.renderProfessionalConfig(),
	          /^(system administrator|account manager)/gi.test(this.props.roleName) && /^(\/clients\/edit\/Client-Profile|\/clients\/edit\/Business-Units\/detail)/g.test(this.props.location.pathname) && _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: this.state.ifHiddenTopEdit ? {
	                lineHeight: "33px",
	                borderBottom: "1px solid #E8EBEF",
	                marginBottom: "0px"
	              } : { lineHeight: "32px", marginBottom: "30px" }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Campaign Reporting ",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "ml-10 pull-left" },
	              this.state.requestParams.campaignReportPreference && (this.state.requestParams.campaignReportPreference === "Detailed" ? "Detailed Campaign Reporting" : "Aggregate")
	            ) : _react2.default.createElement(
	              "div",
	              {
	                style: { float: "left", minWidth: "400px", width: "68%" }
	              },
	              _react2.default.createElement(
	                _RadioButton.RadioButtonGroup,
	                {
	                  name: "clientTier",
	                  valueSelected: this.state.requestParams.campaignReportPreference,
	                  onChange: function onChange(e, value) {
	                    e.preventDefault();
	                    _this8.handledReportTypeChanged(value);
	                  }
	                },
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: "Aggregated",
	                  label: "Aggregate",
	                  iconStyle: {
	                    fill: "black",
	                    width: "20px",
	                    height: "20px"
	                  }
	                }),
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: "Detailed",
	                  label: "Detailed Campaign Reporting",
	                  iconStyle: {
	                    fill: "black",
	                    width: "20px",
	                    height: "20px"
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "pt-10",
	                  style: {
	                    borderTop: "solid 1px #000000",
	                    display: this.state.requestParams.campaignReportPreference === "Detailed" ? "block" : "none"
	                  }
	                },
	                _react2.default.createElement(_Checkbox2.default, {
	                  label: "Display Top Locations on Channel Reports",
	                  checked: this.state.requestParams.clientReportDetailSetting && this.state.requestParams.clientReportDetailSetting.topLocationChannelReport,
	                  onCheck: function onCheck(e, isInputChecked) {
	                    return _this8.handleTopLocationReportCheck(e, isInputChecked);
	                  },
	                  iconStyle: styles.iconStyle,
	                  labelStyle: styles.labelStyle
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  marginTop: "7px",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Industry Type",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "70%" } },
	              this.state.industry.name
	            ) : _react2.default.createElement(_CustomSelect2.default, {
	              placeholder: "Select Industry Type",
	              options: this.state.industryGroupObj,
	              rootStyles: {
	                float: "left",
	                width: "68%",
	                border: "1px solid #B1B0B0"
	              },
	              onChange: function onChange(value) {
	                return _this8.handleIndustryChange(value);
	              },
	              initValue: this.state.requestParams.industryId
	            })
	          ),
	          this.ifShowAssignTo() && _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "33px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              /^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname) || /^administrator/gi.test(this.props.roleName) ? "Assign Business Unit to" : "Assign Client to",
	              /^system administrator/gi.test(this.props.roleName) && !/^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname) && _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "70%" } },
	              !(0, _isEmpty2.default)(this.state.accountManagers) && !(0, _isEmpty2.default)(this.state.accountManagers[0]) ? (0, _map2.default)(this.state.accountManagers, function (data) {
	                return data.firstName + " " + data.lastName;
	              }).join(", ") : "",
	              " "
	            ) : _react2.default.createElement(_reactSelect2.default, {
	              className: "client-profile-timezone",
	              value: this.state.requestParams && this.state.requestParams.accountManagerUserIds ? this.state.requestParams.accountManagerUserIds : this.state.accountManagers ? (0, _map2.default)(this.state.accountManagers, "id") : "",
	              clearable: false,
	              options: this.props.editMode ? /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname) && /^system administrator/gi.test(this.props.roleName) ? this.props.account_manager : this.props.teamMember_options : this.props.teamMember_options,
	              multi: true,
	              ifRequireField: true,
	              onChange: function onChange(value) {
	                return _this8.handleReassignTo(value);
	              }
	            })
	          ),
	          this.state.ifHiddenTopEdit && _react2.default.createElement(
	            "div",
	            { className: "btns" },
	            _react2.default.createElement(
	              "button",
	              { className: "edit", onClick: function onClick() {
	                  return _this8.handleEdit();
	                } },
	              "EDIT"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "suspend",
	                onClick: function onClick() {
	                  return _this8.handleSuspendUser();
	                }
	              },
	              this.state.status === "Active" ? "SUSPEND BUSINESS UNIT" : "REACTIVATE BUSINESS UNIT"
	            )
	          )
	        ),
	        !this.state.ifHiddenTopEdit && _react2.default.createElement(
	          "div",
	          { className: "profile-logo-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "profile-logo profile-company-logo clearfix" },
	            _react2.default.createElement(
	              "div",
	              { className: "clearfix" },
	              _react2.default.createElement(
	                "div",
	                { className: "title clearfix" },
	                _react2.default.createElement(
	                  "span",
	                  { id: "profile-subtit" },
	                  "LOGO"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "review" },
	                _react2.default.createElement("img", {
	                  src: localStorage.getItem("newLogoBase64") !== "" ? localStorage.getItem("newLogoBase64") : this.state.imgDataBase64,
	                  alt: "",
	                  style: {
	                    display: this.state.ifHiddenLogoEdit ? "inline-block" : "none"
	                  }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "profile-edit-img",
	                    style: {
	                      display: this.state.ifHiddenLogoEdit ? "none" : "block"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "section",
	                    { className: "section" },
	                    "Select a logo to upload"
	                  ),
	                  _react2.default.createElement(
	                    _reactDropzone2.default,
	                    {
	                      onDrop: function onDrop(files, accept, reject) {
	                        return _this8.handleDrop(files, accept, reject);
	                      },
	                      style: { width: "100%" },
	                      accept: "image/jpeg, image/png, image/jpg, image/gif",
	                      maxSize: 1048576,
	                      onDropRejected: function onDropRejected() {
	                        return _this8.onDropRejected();
	                      },
	                      name: "logo"
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          textAlign: "center",
	                          display: "inline-block",
	                          width: "20%",
	                          height: "20px",
	                          fontSize: "12px",
	                          border: "1px solid grey",
	                          color: "black",
	                          borderRadius: "6px",
	                          lineHeight: "20px",
	                          marginTop: "10px"
	                        }
	                      },
	                      "Choose File"
	                    ),
	                    _react2.default.createElement(
	                      "i",
	                      { style: { fontStyle: "normal", marginLeft: "6px" } },
	                      this.state.logoFileName !== undefined && this.state.logoFileName.name || "No file chosen"
	                    ),
	                    _react2.default.createElement(
	                      "section",
	                      { className: "spec" },
	                      "(Only jpg, png, and gif file with maximum size of 1MB is allowed)"
	                    )
	                  ),
	                  _react2.default.createElement("img", { src: this.state.newLogoBase64, alt: "" }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      style: { background: (0, _utility.buttonBlueColor)() },
	                      onClick: function onClick() {
	                        return _this8.handleUploadLogo();
	                      }
	                    },
	                    "UPLOAD LOGO"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "error" },
	              this.props.update_logo_msg || this.state.companyLogoErrorText
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "profile-edit clearfix" },
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "edit-button",
	                  style: {
	                    background: (0, _utility.buttonBlueColor)(),
	                    display: this.state.ifHiddenLogoEdit ? "block" : "none"
	                  },
	                  onClick: function onClick() {
	                    return _this8.handleLogoEdit();
	                  }
	                },
	                "EDIT"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "save-group clearfix",
	                  style: {
	                    display: this.state.ifHiddenLogoEdit ? "none" : "block"
	                  }
	                },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: this.state.ifHiddenTopEdit ? "save" : "add-margin save",
	                    disabled: this.state.logoUploadSuccess ? "" : "disabled",
	                    style: { background: (0, _utility.buttonBlueColor)() },
	                    onClick: function onClick() {
	                      return _this8.handleUpdatelogo();
	                    }
	                  },
	                  "SAVE"
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "cancel",
	                    onClick: function onClick() {
	                      return _this8.handleCancelLogoEdit();
	                    }
	                  },
	                  "CANCEL"
	                )
	              )
	            )
	          )
	        ),
	        !this.state.ifHiddenTopEdit && _react2.default.createElement(
	          "div",
	          {
	            className: "btns",
	            style: { textAlign: "right", position: "relative" }
	          },
	          _react2.default.createElement(
	            "p",
	            { style: { position: "absolute", left: 0, color: "red" } },
	            this.props.clientProfileUpdateError,
	            isEmptyAccIds && /^system administrator/gi.test(this.props.roleName) && !/^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname) && "Please assign account manager"
	          ),
	          _react2.default.createElement(
	            "button",
	            { className: "cancel", onClick: function onClick() {
	                return _this8.handleEdit();
	              } },
	            "CANCEL"
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              className: "save",
	              disabled: isEmptyAccIds && /^system administrator/gi.test(this.props.roleName) && !/^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname),
	              onClick: function onClick() {
	                _this8.handleUpdate();
	              }
	            },
	            "SAVE"
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            modal: true,
	            contentStyle: { width: "40%" },
	            open: this.props.ifEditClientProfileSuccess,
	            bodyStyle: { padding: "20px" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "clearfix", style: { position: "relative" } },
	            _react2.default.createElement(_clear2.default, {
	              style: {
	                position: "absolute",
	                right: "0em",
	                cursor: "pointer",
	                top: "0em"
	              },
	              onClick: function onClick() {
	                return _this8.handleClose();
	              }
	            }),
	            _react2.default.createElement(
	              "h2",
	              {
	                style: {
	                  fontSize: "16px",
	                  fontWeight: "bolder",
	                  color: "black",
	                  marginTop: "0"
	                }
	              },
	              "UPDATE ",
	              this.filterTitle(),
	              " PROFILE"
	            ),
	            this.props.ifEditClientProfileSuccess && _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  textAlign: "center",
	                  color: "black",
	                  marginTop: "1.2em"
	                }
	              },
	              "The profile was updated successfully."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form-btns clearfix", style: { marginTop: "19px" } },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-link pull-right ",
	                  id: "userStatusA",
	                  style: {
	                    marginLeft: "-1.3em",
	                    border: "1px solid #B1B0B0",
	                    fontWeight: "bolder",
	                    padding: "7px 17px",
	                    borderRadius: "0",
	                    marginRight: "0.8em"
	                  },
	                  onClick: function onClick(e) {
	                    return _this8.handleClose();
	                  }
	                },
	                "Close"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { modal: false, open: this.state.ifShowSuspend },
	          _react2.default.createElement(
	            "p",
	            { style: { textAlign: "center", color: "black" } },
	            "Are you sure you would like to",
	            " ",
	            this.state.status === "Active" ? "suspend" : "reactivate",
	            " this business unit?"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "btns", style: { textAlign: "center" } },
	            _react2.default.createElement(
	              "button",
	              {
	                style: suspendDialogStyle.cancel,
	                onClick: function onClick() {
	                  return _this8.handleCancelSuspend();
	                }
	              },
	              "CANCEL"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                style: suspendDialogStyle.suspend,
	                onClick: function onClick() {
	                  return _this8.suspendUser();
	                }
	              },
	              this.state.status === "Active" ? "SUSPEND" : "REACTIVATE",
	              " ",
	              "BUSINESS UNIT"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            actions: actions,
	            modal: false,
	            open: this.props.ifUpdateSuccess
	          },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Update logo successfully"
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.showDowngradeConfirm,
	            contentStyle: { width: "435px", padding: "20px" }
	          },
	          _react2.default.createElement(
	            "p",
	            { style: { fontWeight: "bold", color: "#000" } },
	            "Changing the subscription tier to Basic will stop file exports, limit some reporting views, and limit the number of segments that can be saved."
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "text-center no-padding-bottom no-margin-bottom" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-default btn-aa-info",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this8.setState({ showDowngradeConfirm: false });
	                }
	              },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-default btn-aa-warning ml-20",
	                onClick: this.saveDowngradeClient.bind(this)
	              },
	              "Continue"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BusinessUnitsDetail;
	}(_react.Component);
	
	exports.default = BusinessUnitsDetail;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _clear = __webpack_require__(109);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _MenuItem = __webpack_require__(235);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _utility = __webpack_require__(14);
	
	var _UpdateAdminUserTip = __webpack_require__(516);
	
	var _UpdateAdminUserTip2 = _interopRequireDefault(_UpdateAdminUserTip);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(596);
	
	var _materialUi = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property open {boolean} if open dialog
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property ifInviteButtonDisable {boolean} if disable the invite button
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property handleCloseDialog {function} callback of close dialog
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property handleSendInvite {function} callback of send invite
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	// css
	
	// import 'react-select-plus/dist/react-select-plus.css';
	
	// icon
	
	
	var IndustryDialog = function (_Component) {
	  _inherits(IndustryDialog, _Component);
	
	  function IndustryDialog(props) {
	    _classCallCheck(this, IndustryDialog);
	
	    var _this = _possibleConstructorReturn(this, (IndustryDialog.__proto__ || Object.getPrototypeOf(IndustryDialog)).call(this, props));
	
	    _this.state = {
	      clientNameValue: '',
	      roleValue: '',
	      fieldErrorTip: '', // for field input error tips
	      ifButtonDisable: true,
	      isPrimaryContract: false,
	      UpdateAdminUserTipDialogOpen: false,
	      disableSelect: false,
	      requestParams: {
	        firstName: '',
	        lastName: '',
	        email: '',
	        clientId: '',
	        roleId: '',
	        primaryContact: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(IndustryDialog, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.client_options.length > 0) {
	        if (/^(administrator|team member)/gi.test(nextProps.roleName)) {
	          this.setState({
	            roleValue: nextProps.client_options[2].value,
	            disableSelect: true, // disable Select Component.
	            requestParams: Object.assign({}, this.state.requestParams, {
	              roleId: nextProps.client_options[2].value
	            })
	          });
	        } else if (/^(system administrator|account manager)/gi.test(nextProps.roleName)) {
	          this.setState({
	            roleValue: nextProps.client_options[0].value,
	            disableSelect: true, // disable Select Component.
	            requestParams: Object.assign({}, this.state.requestParams, {
	              roleId: nextProps.client_options[0].value
	            })
	          });
	        } else {
	          this.setState({
	            roleValue: nextProps.client_options[0].value,
	            requestParams: Object.assign({}, this.state.requestParams, {
	              roleId: nextProps.client_options[0].value
	            })
	          });
	        }
	      }
	
	      if (nextProps.ifSendInvitationSuccess) {
	        this.setState({
	          UpdateAdminUserTipDialogOpen: true,
	          ifButtonDisable: true,
	          fieldErrorTip: '',
	          requestParams: {
	            firstName: '',
	            lastName: '',
	            email: '',
	            clientId: '',
	            roleId: '',
	            primaryContact: false
	          }
	        });
	      }
	    }
	  }, {
	    key: 'menuItems',
	    value: function menuItems(items) {
	      return items.map(function (item) {
	        return _react2.default.createElement(_MenuItem2.default, {
	          key: item.value,
	          value: item.value,
	          primaryText: item.label
	        });
	      });
	    }
	  }, {
	    key: 'handleRoleChange',
	    value: function handleRoleChange(value) {
	      this.setState({
	        roleValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          roleId: value.value
	        })
	      });
	    }
	  }, {
	    key: 'handleCloseDialog',
	    value: function handleCloseDialog() {
	      var _this2 = this;
	
	      this.props.rollbackStatus();
	      this.setState({
	        clientNameValue: '',
	        roleValue: '',
	        fieldErrorTip: '', // for field input error tips
	        ifButtonDisable: true,
	        UpdateAdminUserTipDialogOpen: false,
	        disableSelect: false,
	        isPrimaryContract: false,
	        requestParams: {
	          firstName: '',
	          lastName: '',
	          email: '',
	          clientId: '',
	          roleId: '',
	          primaryContact: false
	        }
	      }, function () {
	        _this2.props.handleCloseDialog();
	      });
	    }
	  }, {
	    key: 'handleFirstName',
	    value: function handleFirstName(e, value) {
	      var _this3 = this;
	
	      if (value.trim().length > 0) {
	        if (!/^[a-zA-Z]+$/g.test(value)) {
	          this.setState({
	            fieldErrorTip: 'Invalid firstName',
	            ifButtonDisable: true
	          });
	        } else {
	          this.setState({
	            requestParams: Object.assign({}, this.state.requestParams, {
	              firstName: value
	            }),
	            fieldErrorTip: ''
	          }, function () {
	            _this3.handleDisableButton();
	          });
	        }
	      } else {
	        this.setState({
	          fieldErrorTip: ''
	        });
	      }
	    }
	  }, {
	    key: 'handleLastName',
	    value: function handleLastName(e, value) {
	      var _this4 = this;
	
	      if (value.trim().length > 0) {
	        if (!/^[A-z]+(-{0,1}[A-z])+$/g.test(value)) {
	          this.setState({
	            fieldErrorTip: 'Invalid lastName',
	            ifButtonDisable: true
	          });
	        } else {
	          this.setState({
	            requestParams: Object.assign({}, this.state.requestParams, {
	              lastName: value
	            }),
	            fieldErrorTip: ''
	          }, function () {
	            _this4.handleDisableButton();
	          });
	        }
	      } else {
	        this.setState({
	          fieldErrorTip: ''
	        });
	      }
	    }
	  }, {
	    key: 'handleTitle',
	    value: function handleTitle(e, value) {
	      var _this5 = this;
	
	      if (value.trim().length > 0) {
	        if (/^[a-zA-Z][a-zA-Z0-9\s]*$/g.test(value.trim())) {
	          this.setState({
	            fieldErrorTip: '',
	            requestParams: Object.assign({}, this.state.requestParams, {
	              title: value
	            })
	          }, function () {
	            _this5.handleDisableButton();
	          });
	        } else {
	          this.setState({
	            fieldErrorTip: 'Title must be 5 to 20 characters.',
	            ifButtonDisable: true
	          });
	        }
	      } else {
	        this.setState({
	          fieldErrorTip: ''
	        });
	      }
	    }
	  }, {
	    key: 'handleEmail',
	    value: function handleEmail(e, value) {
	      var _this6 = this;
	
	      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	      if (value.trim().length > 0) {
	        if (!re.test(value)) {
	          this.setState({
	            fieldErrorTip: 'Invalid email',
	            ifButtonDisable: true
	          });
	        } else {
	          this.setState({
	            fieldErrorTip: '',
	            requestParams: Object.assign({}, this.state.requestParams, {
	              email: value
	            })
	          }, function () {
	            _this6.handleDisableButton();
	          });
	        }
	      } else {
	        this.setState({
	          fieldErrorTip: ''
	        });
	      }
	    }
	  }, {
	    key: 'handleDisableButton',
	    value: function handleDisableButton() {
	      var _state$requestParams = this.state.requestParams,
	          firstName = _state$requestParams.firstName,
	          lastName = _state$requestParams.lastName,
	          clientId = _state$requestParams.clientId,
	          email = _state$requestParams.email;
	
	
	      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      if (/^[a-zA-Z]+$/g.test(firstName) && /^[A-z]+(-{0,1}[A-z])+$/g.test(lastName) && re.test(email) && clientId !== '') {
	        this.setState({
	          ifButtonDisable: false,
	          fieldErrorTip: ''
	        });
	      }
	    }
	  }, {
	    key: 'handleSendInvite',
	    value: function handleSendInvite() {
	      if (/^(administrator|team member)/gi.test(this.props.roleName)) {
	        this.props.inviteBusinessMember(this.state.requestParams);
	      } else if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        this.props.send_invitation(this.state.requestParams);
	      }
	    }
	  }, {
	    key: 'handleCloseSuccessTip',
	    value: function handleCloseSuccessTip() {
	      this.setState({
	        clientNameValue: '',
	        roleValue: '',
	        fieldErrorTip: '', // for field input error tips
	        ifButtonDisable: true,
	        UpdateAdminUserTipDialogOpen: false,
	        disableSelect: false,
	        isPrimaryContract: false,
	        requestParams: {
	          firstName: '',
	          lastName: '',
	          email: '',
	          clientId: '',
	          roleId: ''
	        }
	      });
	      this.props.rollbackStatus();
	    }
	  }, {
	    key: 'handleInviteAnotherClient',
	    value: function handleInviteAnotherClient() {
	      this.props.handleInviteAnotherClient();
	      this.props.rollbackStatus(false);
	    }
	  }, {
	    key: 'handleClientNameChange',
	    value: function handleClientNameChange(value) {
	      var _this7 = this;
	
	      this.setState({
	        clientNameValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          clientId: value.value
	        })
	      }, function () {
	        _this7.handleDisableButton();
	      });
	    }
	  }, {
	    key: 'handlePrimaryContractChange',
	    value: function handlePrimaryContractChange(e, isChecked) {
	      this.setState({
	        isPrimaryContract: isChecked,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          primaryContact: isChecked
	        })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var isBusinessInvite = /^(administrator|team member)/gi.test(this.props.roleName);
	      return _react2.default.createElement(
	        'div',
	        { className: 'industry-dialog' },
	        _react2.default.createElement(
	          _UpdateAdminUserTip2.default,
	          {
	            UpdateAdminUserTipDialogOpen: this.state.UpdateAdminUserTipDialogOpen,
	            closeUpdateAdminUserTipDialog: function closeUpdateAdminUserTipDialog() {
	              return _this8.handleCloseSuccessTip();
	            },
	            'continue': function _continue() {
	              return _this8.handleInviteAnotherClient();
	            },
	            closeLabel: 'close',
	            ifHiddenContinueButton: true,
	            continueLabel: 'INVITE ANOTHER CLIENT'
	          },
	          _react2.default.createElement(
	            'p',
	            { style: { color: 'black', textAlign: 'center', fontWeight: 'bolder' } },
	            'Your invitation email has been sent.'
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.props.open,
	            contentStyle: { width: '520px' },
	            autoScrollBodyContent: true
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'ac-clients-wrapper' },
	            _react2.default.createElement(_clear2.default, {
	              onClick: function onClick() {
	                return _this8.handleCloseDialog();
	              },
	              style: { position: 'absolute', top: '-1em', right: '-0.8em', cursor: 'pointer' }
	            }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              isBusinessInvite ? 'INVITE BUSINESS UNIT TEAM MEMBER' : 'INVITE CLIENT'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'select-field clearfix', style: { marginBottom: '0.8em' } },
	              _react2.default.createElement(
	                'p',
	                { style: { float: 'left', marginTop: '9px', fontWeight: 'bolder' } },
	                'Role'
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                className: 'client-role-selector ',
	                value: this.state.roleValue,
	                clearable: false,
	                options: this.props.client_options,
	                onChange: this.handleRoleChange.bind(this),
	                disabled: this.state.disableSelect
	              })
	            ),
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: 'Title',
	              labelStyle: { float: 'left', fontSize: '13px', color: 'black', marginTop: '0.5em', fontWeight: 'bolder' },
	              inputContainerId: 'clientTitle',
	              borderColor: 'black',
	              onChange: function onChange(e, value) {
	                return _this8.handleTitle(e, value);
	              }
	            }),
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: 'First Name',
	              ifRequireField: true,
	              labelStyle: { float: 'left', fontSize: '13px', color: 'black', marginTop: '0.5em', fontWeight: 'bolder' },
	              inputContainerId: 'clientFirstName',
	              borderColor: 'black',
	              onChange: function onChange(e, value) {
	                return _this8.handleFirstName(e, value);
	              }
	            }),
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: 'Last Name',
	              ifRequireField: true,
	              labelStyle: { float: 'left', fontSize: '13px', color: 'black', marginTop: '0.5em', fontWeight: 'bolder' },
	              inputContainerId: 'clientLastName',
	              borderColor: 'black',
	              onChange: function onChange(e, value) {
	                return _this8.handleLastName(e, value);
	              }
	            }),
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: 'E-mail',
	              ifRequireField: true,
	              labelStyle: { float: 'left', fontSize: '13px', color: 'black', marginTop: '0.5em', fontWeight: 'bolder' },
	              inputContainerId: 'clientEmail',
	              borderColor: 'black',
	              onChange: function onChange(e, value) {
	                return _this8.handleEmail(e, value);
	              }
	            }),
	            isBusinessInvite && _react2.default.createElement(
	              'div',
	              { className: 'select-field clearfix', style: { marginBottom: '10px', height: '40px' } },
	              _react2.default.createElement(
	                'p',
	                { style: { marginTop: '5px', fontWeight: 'bolder', position: 'absolute' } },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Primay Business ',
	                  _react2.default.createElement('br', null),
	                  'Unit Contact'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: { marginLeft: '68px', position: 'absolute', top: '5px' } },
	                  _react2.default.createElement(_materialUi.Checkbox, { iconStyle: { fill: '#000', fillOpacity: '0.7' },
	                    checked: this.state.isPrimaryContract,
	                    onCheck: this.handlePrimaryContractChange.bind(this) })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'select-field clearfix', style: { height: '41px' } },
	              _react2.default.createElement(
	                'p',
	                { style: { float: 'left', marginTop: '9px', fontWeight: 'bolder' } },
	                isBusinessInvite ? _react2.default.createElement(
	                  'span',
	                  null,
	                  'Business Unit',
	                  _react2.default.createElement('br', null),
	                  ' Name'
	                ) : 'Client Name',
	                _react2.default.createElement(
	                  'em',
	                  { style: { color: 'red' } },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                className: 'client-name-selector ',
	                value: this.state.clientNameValue,
	                clearable: false,
	                options: this.props.roleName !== undefined && isBusinessInvite ? this.props.businessUnitOptions : this.props.client_names,
	                onChange: this.handleClientNameChange.bind(this)
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ac-clients-form-btns clearfix', style: { marginTop: '2em' } },
	            _react2.default.createElement(_FlatButton2.default, {
	              label: 'SEND INVITE',
	              labelStyle: { padding: 0, fontSize: '13px' },
	              style: { width: '100px', height: '30px', lineHeight: 'auto', fontSize: '13px', color: 'white ', float: 'right' },
	              backgroundColor: (0, _utility.buttonBlueColor)(),
	              hoverColor: (0, _utility.buttonBlueColor)(),
	              onClick: function onClick() {
	                return _this8.handleSendInvite();
	              },
	              disabled: this.state.ifButtonDisable
	            }),
	            _react2.default.createElement(_FlatButton2.default, {
	              label: 'Cancel',
	              labelStyle: { padding: 0, fontSize: '13px' },
	              style: { float: 'right', width: '73px', height: '30px', lineHeight: 'auto', color: 'black', fontSize: '13px', marginLeft: '-1.6em', border: '1px solid black', marginRight: '1em' },
	              onClick: function onClick() {
	                return _this8.handleCloseDialog();
	              },
	              hoverColor: 'none'
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'ac-clients-error' },
	              this.props.send_invitation_error_msg || this.state.fieldErrorTip
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndustryDialog;
	}(_react.Component);
	
	exports.default = IndustryDialog;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _qs = __webpack_require__(192);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _Table = __webpack_require__(236);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _RaisedButton = __webpack_require__(304);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _InviteUser = __webpack_require__(1092);
	
	var _InviteUser2 = _interopRequireDefault(_InviteUser);
	
	var _UpdateAdminUserTip = __webpack_require__(516);
	
	var _UpdateAdminUserTip2 = _interopRequireDefault(_UpdateAdminUserTip);
	
	var _Page = __webpack_require__(103);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _lodash = __webpack_require__(18);
	
	var _utility = __webpack_require__(14);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// confirmation
	
	
	var styles = {
	  tableHeaderStyle: {
	    borderTop: '1px solid #000',
	    borderBottom: '1px solid #000',
	    background: '#E4E4E4'
	  },
	  arrowStyle: {
	    position: 'absolute',
	    top: '1px'
	  },
	  tableHeaderColumn: {
	    height: '30px',
	    color: '#000',
	    cursor: 'pointer',
	    fontWeight: 'bolder',
	    paddingLeft: '10px'
	  },
	  tableHeaderSortedColumn: {
	    height: '30px',
	    color: '#000',
	    cursor: 'pointer',
	    fontWeight: 'bolder',
	    background: "#CECECE",
	    paddingLeft: '10px',
	    backgroundClip: 'padding-box'
	  },
	  tableRowColumn: {
	    position: 'relative',
	    paddingLeft: '10px',
	    height: '30px'
	  },
	  settingStyle: {
	    position: 'absolute',
	    right: '6em',
	    top: '0.9em',
	    cursor: 'pointer'
	  }
	};
	
	var ClientUsers = function (_AcquireWebComponent) {
	  _inherits(ClientUsers, _AcquireWebComponent);
	
	  function ClientUsers(props) {
	    _classCallCheck(this, ClientUsers);
	
	    var _this = _possibleConstructorReturn(this, (ClientUsers.__proto__ || Object.getPrototypeOf(ClientUsers)).call(this, props));
	
	    _this.throttle = true;
	    _this.state = {
	      open: false,
	      value: '', // for table list dialog role value
	      rolesValue: '', // role value for invite component
	      openInviteUser: false,
	      requestParams: {
	        pageNumber: 1,
	        pageSize: 10,
	        sortColumn: 'name', //support name , role, email, status field
	        order: 'desc' // asc or desc
	      },
	      employeeName: '', // name of employee
	      suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
	      ifReassignClientUIDispaly: false, // weather display re-assign client.
	      ifDisplayConfirmation: false,
	      ifDisplayUpdateAdminUser: true, // default display update admin user view
	      archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
	      ifArchiveOverlayDisplay: false, // archive overlay
	      ifDisplayArchiveUserLink: false, // if archive link click
	      updateParams: {
	        firstName: '',
	        lastName: '',
	        email: '',
	        roleId: 1
	      },
	      employeeId: '',
	      ifUpdateButtonDisable: true
	    };
	    return _this;
	  }
	
	  _createClass(ClientUsers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.roleId === 5) //operation manager
	        this.props.history.push("/");
	      // get role data
	      var params = {
	        pageNumber: 1,
	        pageSize: 10,
	        sortColumn: 'name', //support name , role, email, status field
	        order: 'desc' // asc or desc
	
	        // administartor or team member
	      };if (this.props.roleId > 50) {
	        if (this.props.getClientRoles) {
	          this.props.getClientRoles();
	        }
	        if (/^\/clients\/edit\/Client-Team-Members/.test(this.props.location.pathname) && /administrator|team member/gi.test(this.props.roleName)) {
	          this.props.getTableList(this.props.clientId, this.props.match.params.id);
	        } else {
	          this.props.getTableList(params, this.props.clientId);
	        }
	      } else if (this.props.roleId > 0) {
	        this.props.getRoles();
	        if (/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname)) {
	          this.props.getTableList(this.props.match.id);
	        } else if (/^\/clents\/edit\/Client-Team-Members/.test(this.props.location.pathname) && /administrator|team member/gi.test(this.props.roleName)) {
	          this.props.getTableList(this.props.clientId, this.props.match.params.id);
	        } else {
	          if (this.props.clientId) this.props.getTableList(params, this.props.clientId);else this.props.getTableList(params);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.roleId === 5) this.props.history.push("/");
	      if (nextProps.updateErrorText === '') {
	        this.setState({
	          open: false
	        });
	      }
	      var params = {
	        pageNumber: 1,
	        pageSize: 10,
	        sortColumn: 'name', //support name , role, email, status fieldf
	        order: 'desc' // asc or desc
	      };
	      if (nextProps.roleId !== this.props.roleId) {
	        if (nextProps.roleId > 50) {
	          if (nextProps.getClientRoles) nextProps.getClientRoles();
	          if (nextProps.selected_client > 0) if (/^\/clients\/edit\/Client-Team-Members/.test(nextProps.location.pathname) && /administrator|team member/gi.test(nextProps.roleName)) {
	            nextProps.getTableList(nextProps.clientId, nextProps.match.params.id);
	          } else {
	            nextProps.getTableList(params, nextProps.selected_client);
	          }
	        } else if (nextProps.roleId > 0) {
	          nextProps.getRoles();
	          if (/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(nextProps.location.pathname)) {
	            nextProps.getTableList(nextProps.match.params.id, _qs2.default.parse(nextProps.location.search).id);
	          } else {
	            if (nextProps.clientId) nextProps.getTableList(params, nextProps.clientId);else nextProps.getTableList(params);
	          }
	        }
	      }
	
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (nextProps.roleId > 50) {
	          if (nextProps.selected_client > 0) this.props.getTableList(params, nextProps.selected_client);
	        } else if (nextProps.roleId > 0) {
	          this.props.getTableList(params);
	        }
	      }
	    }
	  }, {
	    key: 'dispatchPageAction',
	    value: function dispatchPageAction(page) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageNumber: page
	        })
	      });
	      var params = {
	        pageNumber: page,
	        pageSize: this.state.requestParams.pageSize,
	        sortColumn: this.state.requestParams.sortColumn, //support name , role, email, status field
	        order: this.state.requestParams.order // asc or desc
	      };
	      if (this.props.selected_client && this.props.roleId > 50) this.props.getTableList(params, this.props.selected_client);else {
	        if (!this.props.clientId) {
	          this.props.getTableList(params);
	        } else {
	          this.props.getTableList(params, this.props.clientId);
	        }
	      }
	    }
	    //call back for page component
	
	  }, {
	    key: 'nextBeClick',
	    value: function nextBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: 'nextGroupBeClick',
	    value: function nextGroupBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: 'previousGroupBeClick',
	    value: function previousGroupBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: 'previousBeClick',
	    value: function previousBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: 'pageBeClick',
	    value: function pageBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: 'goToPage',
	    value: function goToPage(page) {
	      if (page > this.props.tableList.pageCount) {
	        return;
	      } else {
	        this.dispatchPageAction(page);
	      }
	    }
	  }, {
	    key: 'selectRows',
	    value: function selectRows(page, row) {
	      var _this2 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageSize: row
	        })
	      }, function () {
	        _this2.dispatchPageAction(page);
	      });
	    }
	    //end
	
	  }, {
	    key: 'handleDialogShow',
	    value: function handleDialogShow(e, employeeName) {
	      var url = '/employees/user-status/' + employeeName.id + '/' + this.state.requestParams.pageNumber + '/' + this.state.requestParams.sortColumn + '/' + this.state.requestParams.order;
	      if (this.props.clientId) {
	        // set localStorage
	        localStorage.setItem('clientTeamMemberName', employeeName.firstName + ' ' + employeeName.lastName);
	        if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
	          url = '/clients/edit/Client-Team-Members/user-status/' + employeeName.id + '/' + this.state.requestParams.pageNumber + '/' + this.state.requestParams.sortColumn + '/' + this.state.requestParams.order + '?cid=' + this.props.clientId;
	        } else if (/^(administrator|team member)/gi.test(this.props.roleName)) {
	          url = '/clients/edit/Client-Team-Members/user-status/' + employeeName.id + '/' + this.state.requestParams.pageNumber + '/' + this.state.requestParams.sortColumn + '/' + this.state.requestParams.order + '?cid=' + this.props.clientId + '&name=' + _qs2.default.parse(this.props.location.search.split('?')[1]).name;
	        }
	      }
	      if (this.props.suspendOrReactivate) {
	        var query = _qs2.default.stringify({
	          name: employeeName.firstName + ' ' + employeeName.lastName,
	          id: _qs2.default.parse(this.props.location.search.split('?')[1]).id
	        });
	        var businessUnitName = _qs2.default.parse(this.props.location.search.split('?')[1]).name;
	        url = '/clients/edit/Business-Units/detail/Business Unit Team Members/' + this.props.match.params.id + '?cid=' + employeeName.id + '&' + query + '&businessUnitName=' + businessUnitName;
	      }
	      this.props.history.push(url);
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog() {
	      this.setState({
	        open: false,
	        suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
	        ifReassignClientUIDispaly: false, // weather display re-assign client.
	        ifDisplayConfirmation: false,
	        ifDisplayUpdateAdminUser: true, // default display update admin user view
	        archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
	        ifArchiveOverlayDisplay: false, // archive overlay
	        ifDisplayArchiveUserLink: false // if archive link click
	      });
	    }
	  }, {
	    key: 'handleItemsChange',
	    value: function handleItemsChange(e, index, value) {
	      this.setState({
	        value: value,
	        updateParams: Object.assign({}, this.state.updateParams, {
	          roleId: value
	        })
	      });
	    }
	  }, {
	    key: 'handleInviteUser',
	    value: function handleInviteUser() {
	      this.setState({
	        openInviteUser: true
	      });
	    }
	  }, {
	    key: 'closeInviteDialog',
	    value: function closeInviteDialog() {
	      this.setState({
	        openInviteUser: false,
	        suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
	        ifReassignClientUIDispaly: false, // weather display re-assign client.
	        ifDisplayConfirmation: false,
	        ifDisplayUpdateAdminUser: true, // default display update admin user view
	        archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
	        ifArchiveOverlayDisplay: false, // archive overlay
	        ifDisplayArchiveUserLink: false // if archive link click
	      });
	    }
	  }, {
	    key: 'saveUpdate',
	    value: function saveUpdate() {
	      this.props.updateProfile(this.state.employeeId, this.state.updateParams);
	    }
	  }, {
	    key: 'clickSuspendUser',
	    value: function clickSuspendUser() {
	      this.setState({
	        suspendUserDialogOpen: true,
	        employeeName: this.state.employeeName
	      });
	    }
	  }, {
	    key: 'closeSuspendUserDialog',
	    value: function closeSuspendUserDialog() {
	      this.setState({
	        suspendUserDialogOpen: false
	      });
	    }
	  }, {
	    key: 'continueSuspendUser',
	    value: function continueSuspendUser() {
	      this.setState({
	        ifReassignClientUIDispaly: true,
	        ifDisplayUpdateAdminUser: false
	      });
	    }
	  }, {
	    key: 'goBackFromRessignClientUI',
	    value: function goBackFromRessignClientUI() {
	      this.setState({
	        ifReassignClientUIDispaly: false,
	        ifDisplayUpdateAdminUser: true
	      });
	    }
	  }, {
	    key: 'displayConfirmation',
	    value: function displayConfirmation() {
	      // when confirmation display, reassign view should been hide
	      this.setState({
	        ifDisplayConfirmation: true,
	        ifReassignClientUIDispaly: false,
	        ifDisplayUpdateAdminUser: false // hide update admin user view
	      });
	    }
	  }, {
	    key: 'closeConfirmation',
	    value: function closeConfirmation() {
	      // when click the `close` button of confirmation, init state
	      this.setState({
	        suspendUserDialogOpen: false,
	        ifReassignClientUIDispaly: false,
	        ifDisplayConfirmation: false,
	        ifDisplayUpdateAdminUser: true,
	        open: false
	      });
	    }
	  }, {
	    key: 'clickArchiveUser',
	    value: function clickArchiveUser() {
	      this.setState({
	        archiveUserDialogOpen: true
	      });
	    }
	  }, {
	    key: 'closeArchiveUserTipDialog',
	    value: function closeArchiveUserTipDialog() {
	      this.setState({
	        archiveUserDialogOpen: false
	      });
	    }
	    // archive user overlay display function
	
	  }, {
	    key: 'continueArchiveUser',
	    value: function continueArchiveUser() {
	      // display archive overlay
	      this.setState({
	        ifArchiveOverlayDisplay: true,
	        ifDisplayUpdateAdminUser: false // hide update admin user overlay
	      });
	    }
	  }, {
	    key: 'closeArchiveUserDialog',
	    value: function closeArchiveUserDialog() {
	      this.setState({
	        suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
	        ifReassignClientUIDispaly: false, // weather display re-assign client.
	        ifDisplayConfirmation: false,
	        ifDisplayUpdateAdminUser: true, // default display update admin user view
	        archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
	        ifArchiveOverlayDisplay: false // archive overlay
	      });
	    }
	  }, {
	    key: 'archiveUserLink',
	    value: function archiveUserLink() {
	      this.setState({
	        ifDisplayArchiveUserLink: true
	      });
	    }
	  }, {
	    key: 'clearArchiveLink',
	    value: function clearArchiveLink() {
	      this.setState({
	        ifDisplayArchiveUserLink: false // roll back to archive link
	      });
	    }
	    // role item change function
	
	  }, {
	    key: 'handleRoleItemsChange',
	    value: function handleRoleItemsChange(value) {
	      this.setState({
	        rolesValue: value.value
	      });
	    }
	  }, {
	    key: 'handleHeaderClick',
	    value: function handleHeaderClick(e) {
	      var _this3 = this;
	
	      this.setState({
	        cache_sortColumn: e.target.innerText
	      });
	      var params = {
	        order: this.state.requestParams.order === 'desc' && this.state.cache_sortColumn === e.target.innerText ? 'asc' : 'desc',
	        sortColumn: 'name'
	      };
	      switch (e.target.innerText) {
	        case 'Role':
	          params.sortColumn = 'role';
	          break;
	        case 'Email':
	          params.sortColumn = 'email';
	          break;
	        case 'Status':
	          params.sortColumn = 'status';
	          break;
	        case 'Name':
	          params.sortColumn = 'name';
	          break;
	        case 'Last Logged on':
	          params.sortColumn = 'lastLoggedonDatetime';
	          break;
	        default:
	          return;
	      }
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          order: params.order,
	          sortColumn: params.sortColumn
	        })
	      }, function () {
	        if (/^system administrator/gi.test(_this3.props.roleName)) {
	          _this3.props.getTableList(_this3.state.requestParams, _this3.props.clientId);
	        } else {
	          _this3.props.roleId > 50 ? _this3.props.getTableList(_this3.state.requestParams, _this3.props.selected_client) : _this3.props.getTableList(_this3.state.requestParams);
	        }
	      });
	    }
	  }, {
	    key: 'handleFirstName',
	    value: function handleFirstName(e) {
	      this.checkButtonEnable();
	      this.setState({
	        updateParams: Object.assign({}, this.state.updateParams, {
	          firstName: e.target.value
	        })
	      });
	    }
	  }, {
	    key: 'handleLastName',
	    value: function handleLastName(e) {
	      this.checkButtonEnable();
	      this.setState({
	        updateParams: Object.assign({}, this.state.updateParams, {
	          lastName: e.target.value
	        })
	      });
	    }
	  }, {
	    key: 'handleEmail',
	    value: function handleEmail(e) {
	      this.checkButtonEnable();
	      this.setState({
	        updateParams: Object.assign({}, this.state.updateParams, {
	          email: e.target.value
	        })
	      });
	    }
	  }, {
	    key: 'checkButtonEnable',
	    value: function checkButtonEnable() {
	      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      if (/^([A-z]{1,}\s?)*[A-z]$/g.test(this.refs.firstName.value) && /^[A-z]+(-{0,1}[A-z])+$/g.test(this.refs.lastName.value) && re.test(this.refs.email.value)) {
	        this.setState({
	          ifUpdateButtonDisable: false
	        });
	      } else {
	        this.setState({
	          ifUpdateButtonDisable: true
	        });
	      }
	    }
	  }, {
	    key: 'closeUpdateSuccessTip',
	    value: function closeUpdateSuccessTip() {
	      // init button to disable and request param and employeeId
	      this.setState({
	        ifUpdateButtonDisable: false,
	        updateParams: {
	          firstName: '',
	          lastName: '',
	          email: '',
	          roleId: 1
	        },
	        employeeId: ''
	      });
	      this.props.rollBackUpdateStatus();
	      // refresh table list
	      // this.props.getTableList({
	      //   pageNumber: this.state.pageNumber,
	      //   pageSize: 10,
	      //   sortColumn: 'name', //support name , role, email, status field
	      //   order: 'desc' // asc or desc
	      // });
	      this.dispatchPageAction(this.state.requestParams.pageNumber);
	    }
	  }, {
	    key: 'handleIconClick',
	    value: function handleIconClick(targetName) {
	      var _this4 = this;
	
	      var params = {
	        order: this.state.requestParams.order === 'desc' ? 'asc' : 'desc',
	        sortColumn: 'name'
	      };
	
	      switch (targetName) {
	        case 'Role':
	          params.sortColumn = 'role';
	          break;
	        case 'Email':
	          params.sortColumn = 'email';
	          break;
	        case 'Status':
	          params.sortColumn = 'status';
	          break;
	        case 'Name':
	          params.sortColumn = 'name';
	          break;
	        case 'Last Logged on':
	          params.sortColumn = 'lastLoggedonDatetime';
	          break;
	        default:
	          return;
	      }
	      this.setState({
	        requestParams: {
	          order: params.order,
	          sortColumn: params.sortColumn
	        }
	      }, function () {
	        if (/^system administrator/gi.test(_this4.props.roleName)) {
	          _this4.props.getTableList(_this4.state.requestParams, _this4.props.clientId);
	        } else {
	          _this4.props.roleId > 50 ? _this4.props.getTableList(_this4.state.requestParams, _this4.props.selected_client) : _this4.props.getTableList(_this4.state.requestParams);
	        }
	      });
	    }
	  }, {
	    key: 'getTableColWidth',
	    value: function getTableColWidth(index) {
	      switch (index) {
	        case 1:
	          return '23%';
	        case 2:
	          return '30%';
	        case 3:
	          return '15%';
	        default:
	          return 'auto';
	      }
	    }
	  }, {
	    key: 'filterSuccessReduceProp',
	    value: function filterSuccessReduceProp() {
	      if (/^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        return this.props.ifSendInviteSuccess;
	      } else if (/^(\/clients\/edit\/Business-Units\/detail\/Team Members)/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        return this.props.ifInviteBusinessUnitMemberSuccess;
	      } else if (/^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(this.props.roleName)) {
	        return this.props.ifInviteBusinessUnitMemberSuccess;
	      } else {
	        return this.props.ifSendInviteSuccess;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var inviteUserRoles = (0, _lodash.isEmpty)(this.props.match.params.id) ? this.props.roles : [{ value: 51, label: 'Administrator' }];
	      var clientAdminMode = !(0, _lodash.isEmpty)(this.props.match.params.id) && this.props.roleId < 50;
	      return _react2.default.createElement(
	        'div',
	        { className: 'wrapper', style: { paddingLeft: '2%', paddingRight: '2%' }, onClick: function onClick(e) {
	            return _this5.handleHeaderClick(e);
	          } },
	        /^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname) && _react2.default.createElement('div', { className: 'disabled-sort-container', style: { background: 'none', zIndex: '1000', height: '36px', position: 'absolute', width: '80%', left: '10%', padding: '0 10%' } }),
	        _react2.default.createElement(
	          _Table.Table,
	          { style: { fontFamily: 'Arial' }
	          },
	          _react2.default.createElement(
	            _Table.TableHeader,
	            {
	              displaySelectAll: false,
	              style: styles.tableHeaderStyle,
	              adjustForCheckbox: false
	            },
	            _react2.default.createElement(
	              _Table.TableRow,
	              {
	                displayBorder: false,
	                style: { height: '30px' }
	              },
	              [{ name: 'Name', value: 'name' }, { name: 'Role', value: 'role' }, { name: 'Email', value: 'email' }, { name: 'Status', value: 'status' }, { name: 'Last Logged on', value: 'lastLoggedonDatetime' }].map(function (item, index) {
	                return (
	                  // if url is /clients/edit/Business-Units/detail/Team Member will not show background
	                  _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    {
	                      style: Object.assign({}, _this5.state.requestParams.sortColumn === item.value ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { textAlign: index === 3 ? 'left' : '', width: _this5.getTableColWidth(index) }),
	                      key: index
	                    },
	                    item.name,
	                    !/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(_this5.props.location.pathname) && _react2.default.createElement(_arrowDropDown2.default, { onClick: function onClick() {
	                        return _this5.handleIconClick(item.name);
	                      }, style: { display: _this5.state.requestParams.order === 'desc' && _this5.state.requestParams.sortColumn === item.value ? 'inline-block' : 'none', position: 'absolute', top: '0', right: '0' } }),
	                    !/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(_this5.props.location.pathname) && _react2.default.createElement(_arrowDropUp2.default, { onClick: function onClick() {
	                        return _this5.handleIconClick(item.name);
	                      }, style: { display: _this5.state.requestParams.order === 'asc' && _this5.state.requestParams.sortColumn === item.value ? 'inline-block' : 'none', position: 'absolute', top: '0', right: '0' } })
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableBody,
	            {
	              displayRowCheckbox: false
	            },
	            /^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname) && (0, _lodash.isEmpty)(this.props.tableList) && _react2.default.createElement(
	              _Table.TableRow,
	              {
	                style: { border: 'none' }
	              },
	              _react2.default.createElement(
	                _Table.TableRowColumn,
	                null,
	                _react2.default.createElement(
	                  'p',
	                  { style: { marginTop: '3em', textAlign: 'center', fontSize: '16px', fontWeight: 'bolder' } },
	                  'No Business Unit Team Member exist for this Business Unit'
	                )
	              )
	            ),
	            !(0, _lodash.isEmpty)(this.props.tableList) && this.props.tableList.map(function (item, index) {
	              return _react2.default.createElement(
	                _Table.TableRow,
	                {
	                  selectable: false,
	                  key: item.id,
	                  style: { borderBottom: '1px solid black', height: '30px' }
	                },
	                _react2.default.createElement(
	                  _Table.TableRowColumn,
	                  { style: Object.assign({}, styles.tableRowColumn, { color: '#0997F7', cursor: 'pointer' }) },
	                  _react2.default.createElement(
	                    'span',
	                    { onClick: function onClick(e) {
	                        return _this5.handleDialogShow(e, item);
	                      } },
	                    item.firstName + ' ' + item.lastName
	                  )
	                ),
	                _react2.default.createElement(
	                  _Table.TableRowColumn,
	                  { style: Object.assign({}, styles.tableRowColumn, { width: '23%' }) },
	                  item.role.name
	                ),
	                _react2.default.createElement(
	                  _Table.TableRowColumn,
	                  { style: Object.assign({}, styles.tableRowColumn, { width: _this5.getTableColWidth(2) }) },
	                  item.email
	                ),
	                _react2.default.createElement(
	                  _Table.TableRowColumn,
	                  { style: Object.assign({}, styles.tableRowColumn, { textAlign: 'left', width: _this5.getTableColWidth(3) }) },
	                  item.status
	                ),
	                _react2.default.createElement(
	                  _Table.TableRowColumn,
	                  { style: styles.tableRowColumn },
	                  item.lastLoggedonDatetime ? _moment2.default.unix(item.lastLoggedonDatetime / 1000).format('M/D/YY') : ''
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-btn' },
	          _react2.default.createElement(_Page2.default, {
	            nextBeClick: function nextBeClick(page) {
	              return _this5.nextBeClick(page);
	            },
	            pageCount: this.props.origin_tableList ? this.props.origin_tableList.pageCount : 0,
	            pageSize: this.props.origin_tableList ? this.props.origin_tableList.pageSize : 10,
	            nextGroupBeClick: function nextGroupBeClick(page) {
	              return _this5.nextGroupBeClick(page);
	            },
	            previousGroupBeClick: function previousGroupBeClick(page) {
	              return _this5.previousGroupBeClick(page);
	            },
	            previousBeClick: function previousBeClick(page) {
	              return _this5.previousBeClick(page);
	            },
	            pageBeClick: function pageBeClick(page) {
	              return _this5.pageBeClick(page);
	            },
	            total: this.props.origin_tableList ? this.props.origin_tableList.total : 0,
	            hasNext: this.props.origin_tableList ? this.props.origin_tableList.hasNext : false,
	            hasPrevious: this.props.origin_tableList ? this.props.origin_tableList.hasPrevious : false,
	            selectRows: function selectRows(page, row) {
	              return _this5.selectRows(page, row);
	            },
	            goToPage: function goToPage(page) {
	              return _this5.goToPage(page);
	            },
	            pagePlus: true,
	            style: { marginTop: '20px' }
	          }),
	          (clientAdminMode || this.props.roleId <= 51 || /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(this.props.roleName)) && _react2.default.createElement(_RaisedButton2.default, {
	            label: /^(administrator|team member)/gi.test(this.props.roleName) || /^\/clients\/edit\/Business-Units\/detail\/Team Members/g.test(this.props.location.pathname) ? "Invite Business Unit Team Member" : "Invite Team Member",
	            backgroundColor: (0, _utility.buttonBlueColor)(),
	            labelStyle: { color: 'white', padding: '0 6px', fontSize: '16px' },
	            style: { position: 'absolute', top: 0, width: 'auto', height: '46px', lineHeight: '30px' },
	            onClick: function onClick() {
	              return _this5.handleInviteUser();
	            }
	          })
	        ),
	        _react2.default.createElement(_InviteUser2.default, {
	          openInviteUser: this.state.openInviteUser,
	          closeInviteDialog: function closeInviteDialog() {
	            return _this5.closeInviteDialog();
	          },
	          roles: inviteUserRoles,
	          rolesValue: clientAdminMode ? 51 : this.state.rolesValue,
	          roleName: this.props.roleName,
	          clientId: clientAdminMode ? this.props.match.params.id : null,
	          handleItemsChange: function handleItemsChange(value) {
	            return _this5.handleRoleItemsChange(value);
	          }
	          // if router is /employees use this.props.sendInvite /edit/Business-Unit/Team Member user this.props.sendInviteBusinessUnitMember
	          , sendInvite: this.props.roleId > 50 ? /^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) ? this.props.sendInviteBusinessUnitMember : this.props.sendClientInvite : /^(\/clients\/edit\/Business-Units\/detail\/Team Member)/g.test(this.props.location.pathname) ? this.props.sendInviteBusinessUnitMember : this.props.sendInvite,
	          ifSendInviteSuccess: this.filterSuccessReduceProp(),
	          match: this.props.match,
	          rollbackStatus: /^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname) || /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) ? this.props.rollbackStatus : this.props.rollBackStatus,
	          sendInvite_error_message: this.props.sendInvite_error_message,
	          send_invitation_error_msg: this.props.send_invitation_error_msg,
	          location: this.props.location
	        }),
	        _react2.default.createElement(
	          _UpdateAdminUserTip2.default,
	          {
	            UpdateAdminUserTipDialogOpen: this.state.suspendUserDialogOpen,
	            closeUpdateAdminUserTipDialog: function closeUpdateAdminUserTipDialog() {
	              return _this5.closeSuspendUserDialog();
	            },
	            'continue': function _continue() {
	              return _this5.continueSuspendUser();
	            },
	            continueLabel: 'Yes, continue'
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'suspend-user-tips' },
	            'Are you sure you want to suspend ',
	            _react2.default.createElement('br', null),
	            '[',
	            this.state.employeeName.firstName + ' ' + this.state.employeeName.lastName,
	            ']?'
	          )
	        ),
	        _react2.default.createElement(
	          _UpdateAdminUserTip2.default,
	          {
	            UpdateAdminUserTipDialogOpen: this.state.archiveUserDialogOpen,
	            closeUpdateAdminUserTipDialog: function closeUpdateAdminUserTipDialog() {
	              return _this5.closeArchiveUserTipDialog();
	            },
	            'continue': function _continue() {
	              return _this5.continueArchiveUser();
	            },
	            continueLabel: 'Yes, continue'
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'suspend-user-tips' },
	            'Are you sure you want to archive ',
	            _react2.default.createElement('br', null),
	            '[',
	            this.state.employeeName.firstName + ' ' + this.state.employeeName.lastName,
	            ']?'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClientUsers;
	}(_MaterialUI2.default);
	
	ClientUsers.propTypes = {
	  selected_client: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  roleId: _propTypes2.default.number,
	  getTableList: _propTypes2.default.func.isRequired,
	  getClientRoles: _propTypes2.default.func,
	  roles: _propTypes2.default.array,
	  sendInvite: _propTypes2.default.func,
	  sendClientInvite: _propTypes2.default.func,
	  sendInvite_error_message: _propTypes2.default.string,
	  rollBackStatus: _propTypes2.default.func,
	  inviteBusinessMember: _propTypes2.default.func
	};
	exports.default = ClientUsers;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _clear = __webpack_require__(109);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author chargoyao
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * UpdateAdminUserTip Component
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props UpdateAdminUserTipDialogOpen {boolean} if open tip.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props closeUpdateAdminUserTipDialog {function} when user click `close` button function.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props continue {function} when user click the `confirmation` button go ahead to do something.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props continueLabel {string} confirmation button label string.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props children {node} the node which you want to append.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property closeLabel {string} close button label string
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property ifHiddenContinueButton {boolean} if true hidden continue button
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	// css
	
	
	var UpdateAdminUserTip = function (_Component) {
	  _inherits(UpdateAdminUserTip, _Component);
	
	  function UpdateAdminUserTip() {
	    _classCallCheck(this, UpdateAdminUserTip);
	
	    return _possibleConstructorReturn(this, (UpdateAdminUserTip.__proto__ || Object.getPrototypeOf(UpdateAdminUserTip)).apply(this, arguments));
	  }
	
	  _createClass(UpdateAdminUserTip, [{
	    key: 'closeDialog',
	    value: function closeDialog() {
	      this.props.closeUpdateAdminUserTipDialog();
	    }
	  }, {
	    key: 'confirmSuspendUser',
	    value: function confirmSuspendUser() {
	      // TODO: continue button been clicked
	      this.closeDialog();
	      this.props.continue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var actions = [_react2.default.createElement(
	        'a',
	        { className: this.props.ifHiddenContinueButton ? "btn btn-link" : "btn btn-link pull-left", style: { marginLeft: '0em', background: this.props.ifHiddenContinueButton ? (0, _utility.buttonBlueColor)() : '', color: this.props.ifHiddenContinueButton ? 'white' : '', marginBottom: this.props.ifHiddenContinueButton ? '1em' : '' },
	          onClick: function onClick(e) {
	            _this2.closeDialog();
	          } },
	        this.props.closeLabel || 'Cancel'
	      ), _react2.default.createElement(_FlatButton2.default, {
	        label: this.props.continueLabel,
	        style: { fontSize: '14px', color: 'white ', display: this.props.ifHiddenContinueButton ? 'none' : '' },
	        backgroundColor: (0, _utility.primaryColor)(),
	        disabled: false,
	        hoverColor: (0, _utility.primaryColor)(),
	        onClick: function onClick() {
	          return _this2.confirmSuspendUser();
	        }
	      })];
	      return _react2.default.createElement(
	        'div',
	        { className: 'suspend-user' },
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.props.UpdateAdminUserTipDialogOpen,
	            autoScrollBodyContent: true,
	            contentStyle: { width: '45%' },
	            bodyStyle: { border: 'none' },
	            style: { zIndex: '1600', paddingRight: '5%', top: this.props.ifHiddenContinueButton ? '-30%' : '' },
	            actions: actions,
	            actionsContainerStyle: { border: 'none', textAlign: this.props.ifHiddenContinueButton ? 'center' : 'right', marginTop: '-20px' },
	            actionsContainerClassName: 'update-admin-tip-actions'
	          },
	          _react2.default.createElement(_clear2.default, {
	            style: { position: 'absolute', right: '0.7em', cursor: 'pointer', top: '0.4em' },
	            onClick: function onClick() {
	              return _this2.closeDialog();
	            }
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return UpdateAdminUserTip;
	}(_react.Component);
	
	exports.default = UpdateAdminUserTip;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(108);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _Table = __webpack_require__(236);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _ReassignClientDialog = __webpack_require__(1093);
	
	var _ReassignClientDialog2 = _interopRequireDefault(_ReassignClientDialog);
	
	var _SuspendUser = __webpack_require__(1094);
	
	var _SuspendUser2 = _interopRequireDefault(_SuspendUser);
	
	__webpack_require__(1422);
	
	var _utility = __webpack_require__(14);
	
	var _qs = __webpack_require__(192);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// css
	
	
	var styles = {
	  tableHeaderStyle: {
	    border: 'none',
	    background: '#E4E4E4'
	  },
	  arrowStyle: {
	    position: 'absolute',
	    top: '0'
	  },
	  tableHeaderColumn: {
	    height: '30px',
	    color: 'black',
	    cursor: 'pointer',
	    fontWeight: 'bolder',
	    borderTop: '1px solid black',
	    borderBottom: '1px solid black',
	    paddingLeft: '10px'
	  },
	  tableHeaderSortedColumn: {
	    height: '30px',
	    color: 'black',
	    cursor: 'pointer',
	    fontWeight: 'bolder',
	    borderTop: '1px solid black',
	    borderBottom: '1px solid black',
	    backgroundColor: "#CECECE",
	    paddingLeft: '10px',
	    backgroundClip: 'padding-box'
	  },
	  tableRowColumn: {
	    position: 'relative',
	    paddingLeft: '10px',
	    height: '30px'
	  },
	  settingStyle: {
	    position: 'absolute',
	    right: '6em',
	    top: '0.9em',
	    cursor: 'pointer'
	  }
	};
	
	var UserStatus = function (_Component) {
	  _inherits(UserStatus, _Component);
	
	  function UserStatus(props) {
	    _classCallCheck(this, UserStatus);
	
	    var _this = _possibleConstructorReturn(this, (UserStatus.__proto__ || Object.getPrototypeOf(UserStatus)).call(this, props));
	
	    _this.state = {
	      tableList: [],
	      open: false,
	      rolesValue: '',
	      reassignClientDialogOpen: false,
	      suspendUserOpen: false,
	      reassignLabel: '',
	      showTips: false
	    };
	    _this.throttle = true;
	    _this.throttle_assign = true;
	    return _this;
	  }
	
	  _createClass(UserStatus, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var cid = undefined;
	      if (!(0, _lodash.isEmpty)(this.props.location.search)) {
	        cid = this.props.location.search.replace("?cid=", '');
	      }
	      this.setState({ cid: cid });
	      var params = {
	        pageNumber: +this.props.match.params.pageNumber,
	        pageSize: 10,
	        sortColumn: this.props.match.params.sortColumn, //support name , role, email, status field
	        order: this.props.match.params.order // asc or desc
	
	
	        // administrator or team member
	      };if (this.props.roleId > 50) {
	        this.props.getClientRoles();
	        if (/^\/clients\/edit\/Client-Team-Members/.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(this.props.roleName)) {
	          var clientId = _qs2.default.parse(this.props.location.search.split('?')[1]).cid;
	          this.props.getBusinessUnitTeamMembers(clientId, this.props.match.params.id);
	        } else {
	          this.props.getTableList(params, cid);
	        }
	      } else if (this.props.roleId > 0) {
	        if ((0, _lodash.isEmpty)(cid)) {
	          this.props.getRoles();
	          this.props.getTableList(params);
	        } else {
	          this.props.getClientRoles();
	          if (/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname)) {
	            var businessId = _qs2.default.parse(this.props.location.search.split('?')[1]).id;
	            this.props.getBusinessUnitTeamMembers(this.props.match.params.id, businessId);
	          } else {
	            this.props.getTableList(params, cid);
	          }
	        }
	      }
	      var roleName = JSON.parse(localStorage.getItem('session')).roleName;
	      if (/system administrator/gi.test(roleName)) {
	        this.props.getAccountManage();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      // when data role is changed rerender UI
	      if (typeof roleName === 'string' || /^system administrator/gi.test(nextProps.roleName)) {
	        this.setState({
	          reassignLabel: 'REASSIGN CLIENTS'
	        });
	      } else if (typeof roleName === 'string' || /^administrator/gi.test(nextProps.roleName)) {
	        this.setState({
	          reassignLabel: 'REASSIGN BUSINESS UNITS'
	        });
	      }
	      if (Array.isArray(nextProps.tableList.data)) {
	        var tableList = void 0;
	        tableList = nextProps.tableList.data.filter(function (item) {
	          return item.id === +nextProps.match.params.id;
	        });
	        this.setState({
	          tableList: tableList,
	          rolesValue: tableList.length > 0 && tableList[0].role.id
	        });
	        // get client list for systemn administrator
	        if (this.throttle_assign && tableList.length > 0) {
	          nextProps.getClientAssignments(tableList[0].id);
	          this.throttle_assign = false;
	        }
	      }
	
	      // filter data for router: /clients/edit/Business-Units/detail/Business Unit Team Members/
	      if (Array.isArray(nextProps.client_team_members)) {
	        var _tableList = void 0;
	        if (/^\/clients\/edit\/Client-Team-Members/.test(nextProps.location.pathname) && /^(administrator|team member)/gi.test(nextProps.roleName)) {
	          _tableList = nextProps.client_team_members.filter(function (item) {
	            return item.id === +_this2.props.match.params.id;
	          });
	        } else {
	          _tableList = nextProps.client_team_members.filter(function (item) {
	            return item.id === +_qs2.default.parse(nextProps.location.search.split('?')[1]).cid;
	          });
	        }
	        this.setState({
	          tableList: _tableList,
	          rolesValue: _tableList.length > 0 && _tableList[0].role.id
	        });
	      }
	      if (this.throttle && typeof nextProps.selected_client === 'number') {
	        nextProps.getAccountManage(nextProps.selected_client); // for client
	        var params = {
	          pageNumber: +nextProps.match.params.pageNumber,
	          pageSize: 10,
	          sortColumn: nextProps.match.params.sortColumn, //support name , role, email, status field
	          order: nextProps.match.params.order // asc or desc
	        };
	        if (nextProps.roleId > 50) {
	          nextProps.getClientRoles();
	          // for administrator | team member in business unit team member
	          if (/^\/clients\/edit\/Client-Team-Members/.test(nextProps.location.pathname) && /^(administrator|team member)/gi.test(nextProps.roleName)) {
	            var clientId = _qs2.default.parse(nextProps.location.search.split('?')[1]).cid;
	            nextProps.getBusinessUnitTeamMembers(clientId, clientId);
	          } else {
	            nextProps.getTableList(params, nextProps.selected_client);
	          }
	        } else if (nextProps.roleId > 0) {
	          if (this.props.location.search === '') {
	            nextProps.getTableList(params);
	            nextProps.getRoles();
	          } else {
	            nextProps.getClientRoles();
	            // cid some time can be undefined ,use this.props.location.search
	
	            if (/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname)) {
	              var businessId = _qs2.default.parse(this.props.location.search.split('?')[1]).id;
	              this.props.getBusinessUnitTeamMembers(this.props.match.params.id, businessId);
	            } else {
	              nextProps.getTableList(params, this.props.location.search.split('=')[1]);
	            }
	          }
	        }
	        this.throttle = false;
	      }
	
	      // nextProps.getClientAssignments(tableList[0].id);
	    }
	  }, {
	    key: 'getClientAssignmentsAgain',
	    value: function getClientAssignmentsAgain() {
	      this.props.getClientAssignments(this.state.tableList[0].id);
	    }
	  }, {
	    key: 'handleUpdateRole',
	    value: function handleUpdateRole() {
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'handleItemsChange',
	    value: function handleItemsChange(valObj) {
	      this.setState({
	        rolesValue: valObj.value
	      });
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog() {
	      if (this.props.ifUpdateRoleSuccess) {
	        this.props.rollBackUpdateStatus();
	        var params = {
	          pageNumber: 1,
	          pageSize: 10,
	          sortColumn: 'name', //support name , role, email, status field
	          order: 'desc' // asc or desc
	        };
	        if (this.props.roleId > 50) {
	          this.props.getTableList(params, this.props.selected_client);
	        } else if (this.props.roleId > 0) {
	          if ((0, _lodash.isEmpty)(this.state.cid)) this.props.getTableList(params);else this.props.getTableList(params, this.state.cid);
	        }
	      }
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave() {
	      if ((0, _lodash.isEmpty)(this.state.cid)) this.props.updateRole(this.props.match.params.id, this.state.rolesValue);else this.props.updateRole(this.props.match.params.id, this.state.rolesValue, true);
	    }
	  }, {
	    key: 'handleRessignClients',
	    value: function handleRessignClients() {
	      if (this.state.tableList[0].role.name !== 'Account Manager' && this.props.roleId === 1) {
	        this.setState({
	          showTips: true
	        });
	
	        return;
	      }
	      this.setState({
	        reassignClientDialogOpen: true
	      }, function () {
	        var ThEleCollection = document.querySelectorAll('.reassign-table th');
	        var ThEleCollection_td = document.querySelectorAll('.reassign-table td');
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = ThEleCollection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var i = _step.value;
	
	            i.style.height = '32px';
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = ThEleCollection_td[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _i = _step2.value;
	
	            _i.style.height = '32px';
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'closeReassignClientDialog',
	    value: function closeReassignClientDialog() {
	      this.setState({
	        reassignClientDialogOpen: false
	      });
	    }
	  }, {
	    key: 'handleSuspendUser',
	    value: function handleSuspendUser() {
	      this.setState({
	        suspendUserOpen: true
	      });
	    }
	  }, {
	    key: 'closeSuspendUser',
	    value: function closeSuspendUser() {
	      this.setState({
	        suspendUserOpen: false
	      });
	    }
	  }, {
	    key: 'getNavBar',
	    value: function getNavBar() {
	      if (!this.props.ifForInternalPage && (0, _lodash.isEmpty)(this.state.cid)) {
	        return _react2.default.createElement(
	          'ul',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/employees' },
	              'Team'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '>'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'User Status'
	          )
	        );
	      }
	      /*
	          if (!isEmpty(this.state.cid)) {
	            return (
	              {
	              <ul className="clearfix">
	              <li>
	                <a href="/Clients">Client</a>
	              </li>
	              <li>></li>
	              <li>
	                <a href={`/clients/edit/Client-Team-Members/${this.state.cid}`}>Client Team Members</a>
	              </li>
	              <li>></li>
	              <li>
	                User Status
	              </li>
	            </ul>
	            
	            )
	          }*/
	    }
	  }, {
	    key: 'handleCloseTips',
	    value: function handleCloseTips() {
	      this.setState({
	        showTips: false
	      });
	    }
	  }, {
	    key: 'showRoleUpdate',
	    value: function showRoleUpdate() {
	      var _this3 = this;
	
	      if (/^\/employees\/user-status/.test(this.props.location.pathname)) {
	        return _react2.default.createElement(
	          'button',
	          { className: 'blue', onClick: function onClick() {
	              return _this3.handleUpdateRole();
	            } },
	          'UPDATE ROLE'
	        );
	      }
	      if (/^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        return _react2.default.createElement(
	          'button',
	          { className: 'blue', onClick: function onClick() {
	              return _this3.handleUpdateRole();
	            } },
	          'UPDATE ROLE'
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var muiTheme = (0, _getMuiTheme2.default)({
	        menuItem: {
	          hoverColor: (0, _utility.buttonBlueColor)()
	        },
	        checkbox: {
	          checkedColor: (0, _utility.buttonBlueColor)()
	        },
	        tableRow: {
	          selectedColor: 'white'
	        }
	      });
	      var tableList = this.state.tableList.length > 0 && this.state.tableList[0];
	      var roles = (0, _lodash.isEmpty)(this.state.cid) ? this.props.roles : this.props.clientRoles;
	      var tableHeaderArr = /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) ? [{ name: 'Name', value: 'name' }, { name: 'Role', value: 'role' }, { name: 'Email', value: 'email' }, { name: 'Status', value: 'status' }, { name: 'Last Logged on', value: 'lastLoggedonDatetime' }] : [{ name: 'Name', value: 'name' }, { name: 'Role', value: 'role' }, { name: 'Email', value: 'email' }, { name: 'Status', value: 'status' }];
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: muiTheme },
	        _react2.default.createElement(
	          'div',
	          { className: 'employees-user-status employees' },
	          _react2.default.createElement(
	            _Dialog2.default,
	            {
	              modal: true,
	              contentStyle: { width: '40%' },
	              open: this.state.open,
	              bodyStyle: { overflowY: 'inherit', padding: '20px' }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix', style: { position: 'relative' } },
	              _react2.default.createElement(
	                'h2',
	                { style: { fontSize: '16px', fontWeight: 'bolder', color: 'black', marginTop: '0', marginBottom: '12px' } },
	                'UPDATE ROLE'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix', style: { height: '32px' } },
	                !this.props.ifUpdateRoleSuccess && _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '14px', color: 'black', fontWeight: 'bolder' } },
	                  'Role'
	                ),
	                !this.props.ifUpdateRoleSuccess && _react2.default.createElement(_reactSelect2.default, {
	                  className: 'iv-role-selector',
	                  value: this.state.rolesValue,
	                  clearable: false,
	                  options: roles.filter(function (item) {
	                    return item.value !== 53;
	                  }),
	                  onChange: this.handleItemsChange.bind(this)
	                })
	              ),
	              this.props.ifUpdateRoleSuccess && _react2.default.createElement(
	                'p',
	                { style: { textAlign: 'center', color: 'black' } },
	                'Update successfully'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-btns clearfix', style: { marginTop: '19px' } },
	                !this.props.ifUpdateRoleSuccess && _react2.default.createElement(_FlatButton2.default, {
	                  label: 'SAVE',
	                  labelStyle: { fontSize: '13px', padding: 0 },
	                  style: { minWidth: 'auto', width: '54px', fontSize: '14px', color: 'white ', float: 'right', height: '30px', lineHeight: '30px' },
	                  backgroundColor: (0, _utility.buttonBlueColor)(),
	                  hoverColor: (0, _utility.buttonBlueColor)(),
	                  onClick: function onClick() {
	                    return _this4.handleSave();
	                  },
	                  disabled: this.state.ifInviteButtonDisable
	                }),
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn btn-link pull-right ', id: 'userStatusA', style: { marginLeft: '-1.3em', border: '1px solid black', fontWeight: 'bolder', padding: '8px 9px', borderRadius: '0', marginRight: '0.8em', height: '30px', lineHeight: '1.23' },
	                    onClick: function onClick(e) {
	                      return _this4.closeDialog();
	                    } },
	                  !this.props.ifUpdateRoleSuccess ? 'Cancel' : 'Close'
	                )
	              )
	            )
	          ),
	          this.getNavBar(),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper', style: { paddingLeft: '2%', paddingRight: '2%', marginTop: 0 } },
	            _react2.default.createElement(
	              'h5',
	              null,
	              /^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) ? /^(administrator|team member)/gi.test(this.props.roleName) ? 'BUSINESS UNIT TEAM MEMBER STATUS' : 'TEAM MEMBER STATUS' : 'USER STATUS'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _Table.Table,
	                null,
	                _react2.default.createElement(
	                  _Table.TableHeader,
	                  {
	                    displaySelectAll: false,
	                    style: styles.tableHeaderStyle,
	                    adjustForCheckbox: false
	                  },
	                  _react2.default.createElement(
	                    _Table.TableRow,
	                    {
	                      displayBorder: false,
	                      style: { height: '30px' }
	                    },
	                    tableHeaderArr.map(function (item, index) {
	                      return _react2.default.createElement(
	                        _Table.TableHeaderColumn,
	                        {
	                          style: Object.assign({}, styles.tableHeaderColumn, { textAlign: 'left' }),
	                          key: index
	                        },
	                        item.name
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _Table.TableBody,
	                  {
	                    displayRowCheckbox: false
	                  },
	                  this.state.tableList.length > 0 && _react2.default.createElement(
	                    _Table.TableRow,
	                    {
	                      selectable: false,
	                      key: tableList.id,
	                      style: { borderBottom: '1px solid black', height: '30px' }
	                    },
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { style: Object.assign({}, styles.tableRowColumn, { cursor: 'pointer' }) },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        tableList.firstName + ' ' + tableList.lastName
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { style: Object.assign({}, styles.tableRowColumn) },
	                      tableList.role !== undefined && tableList.role.name
	                    ),
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { style: styles.tableRowColumn },
	                      tableList.email
	                    ),
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { style: Object.assign({}, styles.tableRowColumn, { textAlign: 'left' }) },
	                      tableList.status
	                    ),
	                    /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) && _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { style: Object.assign({}, styles.tableRowColumn, { textAlign: 'left' }) },
	                      tableList.lastLoggedonDatetime ? _moment2.default.unix(tableList.lastLoggedonDatetime / 1000).format('M/D/YY') : ''
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'btns' },
	              this.showRoleUpdate(),
	              (0, _lodash.isEmpty)(this.state.cid) && _react2.default.createElement(
	                'button',
	                { className: 'blue', onClick: function onClick() {
	                    return _this4.handleRessignClients();
	                  } },
	                this.state.reassignLabel
	              ),
	              tableList.status === 'Suspended' && _react2.default.createElement(
	                'button',
	                { className: 'red', onClick: function onClick() {
	                    return _this4.handleSuspendUser();
	                  } },
	                /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) ? 'REACTIVATE BUSINESS UNIT TEAM MEMBER' : /^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) ? /^(administrator|team member)/gi.test(this.props.roleName) ? 'REACTIVATE BUSINESS UNIT TEAM MEMBER' : 'REACTIVATE TEAM MEMBER' : 'REACTIVATE USER'
	              ),
	              tableList.status === 'Active' && _react2.default.createElement(
	                'button',
	                { className: 'red', onClick: function onClick() {
	                    return _this4.handleSuspendUser();
	                  } },
	                /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) ? 'SUSPEND BUSINESS UNIT TEAM MEMBER' : /^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) ? /^(administrator|team member)/gi.test(this.props.roleName) ? 'SUSPEND BUSINESS UNIT TEAM MEMBER' : 'SUSPEND TEAM MEMBER' : 'SUSPEND USER'
	              )
	            ),
	            _react2.default.createElement(
	              _Dialog2.default,
	              {
	                modal: false,
	                open: this.state.showTips,
	                onRequestClose: this.handleClose
	              },
	              _react2.default.createElement(
	                'p',
	                { style: { color: 'black', textAlign: 'center' } },
	                'This user is not an account manager'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'btns', style: { textAlign: 'center', marginTop: '1em' } },
	                _react2.default.createElement(_FlatButton2.default, {
	                  label: 'CLOSE',
	                  className: 'btn-aa-info',
	                  backgroundColor: (0, _utility.buttonBlueColor)(),
	                  labelStyle: { color: 'white' },
	                  onClick: function onClick() {
	                    return _this4.handleCloseTips();
	                  },
	                  hoverColor: (0, _utility.buttonBlueColor)()
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(_ReassignClientDialog2.default, {
	            open: this.state.reassignClientDialogOpen,
	            closeDialog: function closeDialog() {
	              return _this4.closeReassignClientDialog();
	            },
	            account_manager: this.props.account_manager,
	            suspendUserId: tableList.id,
	            suspended: tableList.status === 'Suspended',
	            client_assignments: this.props.client_assignments,
	            ifReassignSuccess: this.props.ifReassignSuccess,
	            reassingAccountManager: this.props.reassingAccountManager,
	            originAccountManagerUserId: this.props.match.params.id,
	            rollBackReassign: this.props.rollBackReassign,
	            getClientAssignmentsAgain: function getClientAssignmentsAgain() {
	              return _this4.getClientAssignmentsAgain();
	            },
	            roleName: this.props.roleName,
	            client_assignments_error: this.props.client_assignments_error
	          }),
	          _react2.default.createElement(_SuspendUser2.default, {
	            isClientUser: /^\/employees\/user-status/g.test(this.props.location.pathname),
	            open: this.state.suspendUserOpen,
	            roleName: this.props.roleName,
	            location: this.props.location,
	            businessUnitTeamMemberPage: /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname),
	            userId: this.props.userId,
	            closeSuspendUser: function closeSuspendUser() {
	              return _this4.closeSuspendUser();
	            },
	            suspendUser: this.props.suspendUser,
	            suspendUserId: tableList.id,
	            suspended: tableList.status === 'Suspended',
	            suspend_error: this.props.suspend_error,
	            clearSuspendError: this.props.clearSuspendError
	          })
	        )
	      );
	    }
	  }]);
	
	  return UserStatus;
	}(_react.Component);
	
	exports.default = UserStatus;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var google = window.google;
	var deck = window.deck;
	
	var COLOR_RANGE = [[32, 43, 223, 0], [31, 31, 223], [223, 31, 223], [223, 31, 31], [223, 223, 31]];
	
	var HeatMap = function (_AcquireWebComponent) {
	  _inherits(HeatMap, _AcquireWebComponent);
	
	  function HeatMap(props) {
	    _classCallCheck(this, HeatMap);
	
	    var _this = _possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).call(this, props));
	
	    _this.state = { showLoadingDialog: false };
	    _this.map = null;
	    _this.overlay = null;
	    return _this;
	  }
	
	  _createClass(HeatMap, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var pointsData = this.props.pointsData;
	
	
	      if ((0, _lodash.isEmpty)(pointsData)) return;
	      var INITIAL_CENTER = { lat: 42.87, lng: -97.38 };
	
	      this.map = new google.maps.Map(document.getElementById("map-canvas"), {
	        zoom: 4,
	        maxZoom: 9,
	        minZoom: 4,
	        center: INITIAL_CENTER,
	        mapTypeId: "roadmap",
	        zoomControl: true,
	        mapTypeControl: false,
	        scaleControl: true,
	        streetViewControl: false,
	        rotateControl: false,
	        fullscreenControl: false
	      });
	
	      this.overlay = new deck.GoogleMapsOverlay({
	        layers: [this.buildHeatmapLayer()]
	      });
	      this.overlay.setMap(this.map);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.overlay) {
	        this.overlay.setMap(null);
	        this.overlay = null;
	      }
	    }
	  }, {
	    key: "buildHeatmapLayer",
	    value: function buildHeatmapLayer() {
	      return new deck.HeatmapLayer({
	        id: "insights-heatmap",
	        data: this.props.pointsData,
	        getPosition: function getPosition(d) {
	          return d.position;
	        },
	        getWeight: function getWeight(d) {
	          return d.weight;
	        },
	        radiusPixels: 80,
	        intensity: 2,
	        threshold: 0.03,
	        colorRange: COLOR_RANGE,
	        aggregation: "SUM"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          height = _props.height,
	          pointsData = _props.pointsData,
	          onLoading = _props.onLoading;
	
	      if (onLoading) {
	        return _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              height: "200px",
	              width: "100%",
	              position: "relative",
	              padding: "20px"
	            }
	          },
	          _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } }),
	          "\xA0loading..."
	        );
	      }
	      if ((0, _lodash.isEmpty)(pointsData)) {
	        return _react2.default.createElement(
	          "div",
	          {
	            style: {
	              float: "left",
	              height: "200px",
	              width: "100%",
	              position: "relative",
	              padding: "20px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                minHeight: "200px",
	                textAlign: "center",
	                paddingTop: "60px",
	                color: "#CDCDCD"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" } },
	              "No Data"
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "mb-20",
	          style: { /*height: "100%", */position: "relative" }
	        },
	        this.state.showLoadingDialog && _react2.default.createElement(
	          "div",
	          { className: "map-loading-modal" },
	          _react2.default.createElement(
	            "div",
	            null,
	            "Map data loading, please wait..."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: { fontSize: "24px", marginBottom: "20px", fontWeight: "bold" }
	          },
	          title
	        ),
	        _react2.default.createElement("div", { id: "map-canvas", style: { height: height + "px" } }),
	        _react2.default.createElement(
	          "div",
	          { style: { width: "100%", margin: "10px 20px", height: "40px" } },
	          _react2.default.createElement(
	            "div",
	            { className: "text-center mt-10 mb-5" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Heat Map Density Scale"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              id: "map_legend",
	              className: "heatmap-legend",
	              style: { width: "60%", margin: "0", border: "solid 1px black" }
	            },
	            "\xA0"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "mt-5 mb-10",
	              style: { width: "60%", marginLeft: "20%", fontWeight: "350" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "pull-left" },
	              "Low"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "pull-right" },
	              "High"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "text-center" },
	              "Medium"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HeatMap;
	}(_MaterialUI2.default);
	
	exports.default = HeatMap;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _recharts = __webpack_require__(101);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEmpty } from "lodash";
	
	
	var LineGraphicSection = function (_AcquireWebComponent) {
	  _inherits(LineGraphicSection, _AcquireWebComponent);
	
	  function LineGraphicSection() {
	    _classCallCheck(this, LineGraphicSection);
	
	    return _possibleConstructorReturn(this, (LineGraphicSection.__proto__ || Object.getPrototypeOf(LineGraphicSection)).apply(this, arguments));
	  }
	
	  _createClass(LineGraphicSection, [{
	    key: "isEmpty",
	    value: function isEmpty(data) {
	      if (!data || data.length === 0) return true;
	      if (data.length === 2) {
	        for (var i = 0; i < data.length; i++) {
	          if (data[i].totalVisits > 0 || data[i].uniqueVisits > 0) return false;
	        }
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var COLORS = ["#216E69", "#00A3AD", "#3888AB", "#87B7CD", "#AFCFDD"];
	      var numberFormater = function numberFormater(num) {
	        return (0, _utility.splitNumber)(num + "")();
	      };
	
	      var CustomizedTooltip = _react2.default.createClass({
	        displayName: "CustomizedTooltip",
	        render: function render() {
	          var active = this.props.active;
	
	          if (active) {
	            var _props = this.props,
	                payload = _props.payload,
	                label = _props.label,
	                formatter = _props.formatter;
	
	            return _react2.default.createElement(
	              "div",
	              {
	                className: "recharts-default-tootip no-margin p-10",
	                style: { background: "#FFFCDC", border: "solid 1px #ccc" }
	              },
	              _react2.default.createElement(
	                "p",
	                { className: "recharts-tooltip-label no-margin" },
	                label
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "recharts-tooltip-item-list no-padding no-margin" },
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "recharts-tooltip-item",
	                    style: {
	                      display: "block",
	                      paddingTop: "4px",
	                      paddingBottom: "4px",
	                      color: payload ? payload[0].stroke : "#FFF"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "recharts-tooltip-item-name" },
	                    payload && payload[0] ? payload[0].name : ""
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "recharts-tooltip-item-separator" },
	                    " : "
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "recharts-tooltip-item-value" },
	                    payload && payload[0] ? formatter(payload[0].value) : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "recharts-tooltip-item",
	                    style: {
	                      display: "block",
	                      paddingTop: "4px",
	                      paddingBottom: "4px",
	                      color: payload[1].stroke
	                    }
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "recharts-tooltip-item-name" },
	                    payload[1].name
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "recharts-tooltip-item-separator" },
	                    " : "
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "recharts-tooltip-item-value" },
	                    payload && payload.length > 1 ? formatter(payload[1].value) : ""
	                  )
	                )
	              )
	            );
	          }
	
	          return null;
	        }
	      });
	
	      var _props2 = this.props,
	          title = _props2.title,
	          data = _props2.data,
	          subTitle = _props2.subTitle;
	
	      if (this.isEmpty(data)) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontSize: "24px",
	                lineHeight: "18px",
	                marginBottom: "20px",
	                fontWeight: "bold"
	              }
	            },
	            title
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                minHeight: "200px",
	                textAlign: "center",
	                paddingTop: "60px",
	                color: "#CDCDCD"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" } },
	              "No Data"
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "line-graphic-section" },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: "24px",
	              marginBottom: "40px",
	              fontWeight: "bold"
	            }
	          },
	          title
	        ),
	        _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: "100%", height: "80%", minHeight: 200 },
	          _react2.default.createElement(
	            _recharts.LineChart,
	            {
	              data: data,
	              margin: { top: 5, right: 0, left: 0, bottom: 5 }
	            },
	            _react2.default.createElement(_recharts.XAxis, {
	              dataKey: "time",
	              padding: { left: 30, right: 30 },
	              interval: "preserveStartEnd",
	              minTickGap: 12
	            }),
	            _react2.default.createElement(_recharts.YAxis, null),
	            _react2.default.createElement(_recharts.CartesianGrid, { strokeDasharray: "3 3", vertical: false }),
	            _react2.default.createElement(_recharts.Tooltip, {
	              formatter: numberFormater,
	              content: _react2.default.createElement(CustomizedTooltip, null)
	            }),
	            _react2.default.createElement(_recharts.Legend, { layout: "horizontal", verticalAlign: "top", align: "left" }),
	            _react2.default.createElement(_recharts.Line, {
	              isAnimationActive: this.props.animation,
	              name: this.props.type === "business" ? "Total Domestic Visits" : "Total Visits",
	              type: "monotone",
	              dataKey: "totalVisits",
	              strokeWidth: 5,
	              stroke: COLORS[0],
	              activeDot: { r: 1 }
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              isAnimationActive: this.props.animation,
	              name: this.props.type === "business" ? "Unique Domestic Visits" : "Unique Visits",
	              type: "monotone",
	              dataKey: "uniqueVisits",
	              strokeWidth: 5,
	              stroke: COLORS[1],
	              activeDot: { r: 1 }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "text-center" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Date: "
	          ),
	          subTitle
	        )
	      );
	    }
	  }]);
	
	  return LineGraphicSection;
	}(_MaterialUI2.default);
	
	LineGraphicSection.propTypes = {
	  title: _react2.default.PropTypes.string.isRequired,
	  data: _react2.default.PropTypes.array,
	  subTitle: _react2.default.PropTypes.string,
	  type: _react2.default.PropTypes.string
	};
	
	exports.default = LineGraphicSection;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _lodash = __webpack_require__(18);
	
	var _recharts = __webpack_require__(101);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderActiveShape = function renderActiveShape(props) {
	  var cx = props.cx,
	      cy = props.cy,
	      innerRadius = props.innerRadius,
	      outerRadius = props.outerRadius,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      fill = props.fill;
	
	  return _react2.default.createElement(
	    "g",
	    null,
	    _react2.default.createElement(_recharts.Sector, {
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle,
	      fill: fill
	    }),
	    _react2.default.createElement(_recharts.Sector, {
	      cx: cx,
	      cy: cy,
	      startAngle: startAngle,
	      endAngle: endAngle,
	      innerRadius: outerRadius + 2,
	      outerRadius: outerRadius + 10,
	      fill: "#CCC"
	    })
	  );
	};
	
	var CustomizedTooltip = _react2.default.createClass({
	  displayName: "CustomizedTooltip",
	  render: function render() {
	    var _props = this.props,
	        stroke = _props.stroke,
	        name = _props.name,
	        value = _props.value,
	        fieldName = _props.fieldName;
	
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "recharts-default-tootip no-margin pt-5 pl-10 pr-10 pb-5",
	        style: { background: "#FFFCDC", border: "solid 1px #ccc" }
	      },
	      _react2.default.createElement("p", { className: "recharts-tooltip-label no-margin" }),
	      _react2.default.createElement(
	        "ul",
	        { className: "recharts-tooltip-item-list no-padding no-margin" },
	        _react2.default.createElement(
	          "li",
	          {
	            className: "recharts-tooltip-item",
	            style: {
	              display: "block",
	              paddingTop: "4px",
	              paddingBottom: "4px",
	              stroke: stroke
	            }
	          },
	          name && _react2.default.createElement(
	            "span",
	            { className: "recharts-tooltip-item-name text-capital" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              name
	            )
	          ),
	          name && _react2.default.createElement("hr", {
	            style: {
	              borderTop: "1px solid #000",
	              height: "1px",
	              display: "block",
	              margin: "5px 0"
	            }
	          }),
	          _react2.default.createElement(
	            "span",
	            {
	              className: "recharts-tooltip-item-value ",
	              style: { fontWeight: 300 }
	            },
	            fieldName,
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "- ",
	              (0, _utility.splitNumber)(value)()
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	var styles = {
	  textOverflow: {
	    whiteSpace: "nowrap",
	    overflow: "hidden",
	    textOverflow: "ellipsis"
	  }
	};
	
	var ListGraphicSection = function (_AcquireWebComponent) {
	  _inherits(ListGraphicSection, _AcquireWebComponent);
	
	  function ListGraphicSection(props) {
	    _classCallCheck(this, ListGraphicSection);
	
	    var _this = _possibleConstructorReturn(this, (ListGraphicSection.__proto__ || Object.getPrototypeOf(ListGraphicSection)).call(this, props));
	
	    _this.renderItem = function () {
	      var COLORS = ["#050505", "#1C4456", "#3888AB", "#87B7CD", "#AFCFDD"];
	      var _this$props = _this.props,
	          fieldDisplayFunc = _this$props.fieldDisplayFunc,
	          title = _this$props.title,
	          showGraphic = _this$props.showGraphic,
	          data = _this$props.data;
	
	      var hideOverflowText = _this.props.hideOverflow === true;
	      var sortedData = (0, _lodash.orderBy)(data, ["value"], ["desc"]);
	
	      var wrapValue = function wrapValue(val) {
	        if (val === "N/A") {
	          return "Unknown";
	        }
	        if (val === "0.00%") {
	          return "Unknown";
	        }
	        return val;
	      };
	      var coloredData = {};
	      if (showGraphic === true) {
	        (0, _lodash.map)(sortedData, function (data, index) {
	          coloredData[data.name] = COLORS[index % COLORS.length];
	        });
	      }
	      return function (obj, idx) {
	        return _react2.default.createElement(
	          "div",
	          {
	            key: "list-" + idx,
	            className: "light-grey-top-border mt-15 pt-15",
	            style: { display: "flex", justifyContent: "space-between" }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: hideOverflowText ? Object.assign({
	                width: "88%"
	              }, styles.textOverflow, {
	                flexShrink: "0",
	                paddingRight: "20px"
	              }) : { flexShrink: "0", paddingRight: "20px" }
	            },
	            !(0, _lodash.isEmpty)(coloredData) && _react2.default.createElement(
	              "span",
	              {
	                className: "insights-span-legend",
	                style: { background: coloredData[obj.name] }
	              },
	              "\xA0"
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              obj.link ? _react2.default.createElement(
	                "a",
	                { href: obj.link },
	                obj.name
	              ) : obj.name
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { flexGrow: "1", position: "relative" } },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  position: "absolute",
	                  top: "50%",
	                  left: 0,
	                  right: 0,
	                  transform: "translateY(-50%)",
	                  overflow: "hidden",
	                  whiteSpace: "nowrap",
	                  textAlign: "right",
	                  textOverflow: "ellipsis",
	                  paddingRight: title === "Most Popular Pages" ? "20px" : 0
	                }
	              },
	              fieldDisplayFunc ? fieldDisplayFunc(obj.value) : wrapValue(obj.value)
	            )
	          )
	        );
	      };
	    };
	
	    _this.state = { activeIndex: undefined };
	    return _this;
	  }
	
	  _createClass(ListGraphicSection, [{
	    key: "onPieEnter",
	    value: function onPieEnter(data, index) {
	      this.setState({
	        activeIndex: index,
	        tooltip_name: data.payload.uniqueVisits ? data.payload.name : undefined,
	        tooltip_field_name: data.payload.uniqueVisits ? "Unique Visit" : data.payload.name,
	        tooltip_value: data.payload.uniqueVisits ? data.payload.uniqueVisits : data.payload.value,
	        tooltip_stroke: data.payload.fill
	      });
	      var tooltips = _reactDom2.default.findDOMNode(this).getElementsByClassName("recharts-tooltip-wrapper");
	      if (tooltips && tooltips.length > 0) {
	        var el = tooltips[0];
	        el.style["visibility"] = "visible";
	        el.style["padding-bottom"] = "0px";
	      }
	    }
	  }, {
	    key: "onPieLeave",
	    value: function onPieLeave() {
	      this.setState({
	        activeIndex: -1
	      });
	      var tooltips = _reactDom2.default.findDOMNode(this).getElementsByClassName("recharts-tooltip-wrapper");
	      if (tooltips && tooltips.length > 0) {
	        var el = tooltips[0];
	        el.style["visibility"] = "hidden";
	      }
	    }
	  }, {
	    key: "renderBusinessFirmographic",
	    value: function renderBusinessFirmographic() {
	      var data = this.props.data;
	
	      var data1 = data.slice(0, 3);
	      var data2 = data.slice(3);
	      var style = {
	        width: '50%',
	        paddingRight: '20px',
	        marginBottom: '-30px',
	        paddingBottom: '20px'
	      };
	      return _react2.default.createElement(
	        "div",
	        { style: {
	            display: 'flex'
	          } },
	        _react2.default.createElement(
	          "div",
	          { style: style, className: "light-grey-bottom-border" },
	          data1.map(this.renderItem())
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { width: '50%', paddingLeft: '20px' } },
	          data2.map(this.renderItem())
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      //		const COLORS = ['#050505', '#0E222C', '#1C4456', '#2A6581', '#3888AB', '#609FBD', '#609FBD', '#87B7CD', '#AFCFDD', '#D6E7EF'];
	      var COLORS = ["#050505", "#1C4456", "#3888AB", "#87B7CD", "#AFCFDD"];
	      var _props2 = this.props,
	          title = _props2.title,
	          data = _props2.data,
	          footer = _props2.footer,
	          subTitle = _props2.subTitle,
	          showGraphic = _props2.showGraphic,
	          subTitleStyle = _props2.subTitleStyle,
	          mode = _props2.mode;
	
	      var sortedData = (0, _lodash.orderBy)(data, ["value"], ["desc"]);
	      // const hideOverflowText = this.props.hideOverflow === true;
	
	      if ((0, _lodash.isEmpty)(data)) {
	        return _react2.default.createElement(
	          "div",
	          { style: { float: "left", width: "100%", position: "relative" } },
	          _react2.default.createElement(
	            "div",
	            { style: { fontSize: "24px", fontWeight: "bold" } },
	            title
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                minHeight: "200px",
	                textAlign: "center",
	                paddingTop: "60px",
	                color: "#CDCDCD"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#CDCDCD", fontSize: "24px", opacity: "0.8" } },
	              "No Data"
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          "div",
	          { style: Object.assign({}, mode === 'business' ? {} : { float: 'left' }, { width: "100%", position: "relative" }) },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontSize: "24px",
	                fontWeight: "bold",
	                textTransform: "capitalize"
	              }
	            },
	            title
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: (mode === 'business' ? '' : "light-grey-bottom-border") + (footer ? '' : 'no-footer'),
	              style: Object.assign({
	                width: showGraphic === true ? "50%" : "100%",
	                position: "relative",
	                paddingBottom: footer ? "15px" : '0',
	                fontSize: "16px"
	              }, mode === 'business' ? {} : {
	                marginBottom: footer ? "35px" : '0',
	                float: 'left'
	              })
	            },
	            subTitle && _react2.default.createElement(
	              "div",
	              {
	                className: "text-right mt-10 mb-10",
	                style: Object.assign({
	                  color: subTitle === "&nbsp;" ? "#FFF" : "inherit",
	                  fontSize: "16px"
	                }, subTitleStyle ? subTitleStyle : {})
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                subTitle
	              )
	            ),
	            mode === 'business' ? this.renderBusinessFirmographic() : (0, _lodash.map)(data, this.renderItem())
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: Object.assign({
	                width: "50%",
	                marginTop: "-10px",
	                minHeight: "200px",
	                display: showGraphic === true ? "block" : "none",
	                position: "relative"
	              }, mode === 'business' ? {} : { float: 'left' })
	            },
	            _react2.default.createElement(
	              _recharts.ResponsiveContainer,
	              { width: "100%", height: "80%", minHeight: 200 },
	              _react2.default.createElement(
	                _recharts.PieChart,
	                null,
	                _react2.default.createElement(
	                  _recharts.Pie,
	                  {
	                    onMouseLeave: this.onPieLeave.bind(this),
	                    onMouseEnter: this.onPieEnter.bind(this),
	                    activeShape: renderActiveShape,
	                    data: sortedData,
	                    fill: "#8884d8",
	                    activeIndex: this.state.activeIndex,
	                    dataKey: "value",
	                    innerRadius: 40,
	                    outerRadius: 80,
	                    isAnimationActive: false
	                  },
	                  sortedData.map(function (entry, index) {
	                    return _react2.default.createElement(_recharts.Cell, {
	                      key: "insight-graphic-cell-" + index,
	                      fill: COLORS[index % COLORS.length]
	                    });
	                  })
	                ),
	                _react2.default.createElement(_recharts.Tooltip, {
	                  content: _react2.default.createElement(CustomizedTooltip, null),
	                  name: this.state.tooltip_name,
	                  value: this.state.tooltip_value,
	                  stroke: this.state.stroke,
	                  fieldName: this.state.tooltip_field_name
	                })
	              )
	            )
	          ),
	          mode === 'business' ? null : [_react2.default.createElement("br", { key: "1" }), _react2.default.createElement("br", { key: "2" })],
	          sortedData.length === 5 && title === "DEMOGRAPHIC" && _react2.default.createElement(
	            "div",
	            { className: "mb-15" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          footer ? _react2.default.createElement(
	            "div",
	            { className: "mt-10 list-chart-footer", style: mode === 'business' ? {
	                borderBottom: '1px solid #eeeff2',
	                padding: footer ? '20px 0 15px' : '4px',
	                marginBottom: '-20px'
	              } : {} },
	            footer
	          ) : null
	        );
	      }
	    }
	  }]);
	
	  return ListGraphicSection;
	}(_MaterialUI2.default);
	
	ListGraphicSection.propTypes = {
	  title: _react2.default.PropTypes.string.isRequired,
	  subTitle: _react2.default.PropTypes.string,
	  data: _react2.default.PropTypes.array,
	  showGraphic: _react2.default.PropTypes.bool,
	  fieldDisplayFunc: _react2.default.PropTypes.func,
	  footer: _react2.default.PropTypes.element,
	  mode: _react2.default.PropTypes.string
	};
	exports.default = ListGraphicSection;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _utility = __webpack_require__(14);
	
	var _recharts = __webpack_require__(101);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reduce = __webpack_require__(299);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomTooltip = function CustomTooltip(_ref) {
	  var active = _ref.active,
	      payload = _ref.payload,
	      label = _ref.label;
	
	  if (active) {
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "recharts-default-tootip no-margin pt-10 pl-20 pr-20 pb-15",
	        style: { background: "#000", border: "solid 1px #000", color: "#FFF" }
	      },
	      _react2.default.createElement("p", { className: "recharts-tooltip-label no-margin" }),
	      _react2.default.createElement(
	        "ul",
	        { className: "recharts-tooltip-item-list no-padding no-margin" },
	        _react2.default.createElement(
	          "li",
	          {
	            className: "recharts-tooltip-item",
	            style: {
	              display: "inline",
	              paddingTop: "4px",
	              paddingBottom: "4px",
	              width: "100%"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "auto",
	                height: "25px",
	                display: "block",
	                overflow: "overlap",
	                whiteSpace: "nowrap",
	                textOverflow: "unset"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "recharts-tooltip-label no-margin-left no-margin-top no-margin-right mb-5" },
	              payload[0].payload.key + " : " + payload[0].payload.percentage + "%"
	            )
	          )
	        )
	      )
	    );
	  }
	
	  return null;
	};
	
	var PieChartHighlight = function (_AcquireWebComponent) {
	  _inherits(PieChartHighlight, _AcquireWebComponent);
	
	  function PieChartHighlight(props) {
	    _classCallCheck(this, PieChartHighlight);
	
	    var _this = _possibleConstructorReturn(this, (PieChartHighlight.__proto__ || Object.getPrototypeOf(PieChartHighlight)).call(this, props));
	
	    _this.state = {
	      activeIndex: -1
	    };
	    return _this;
	  }
	
	  _createClass(PieChartHighlight, [{
	    key: "isEmpty",
	    value: function isEmpty(data) {
	      if (!data || data.length === 0) return true;
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].value > 0) return false;
	      }
	      return true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          showHighlight = _props.showHighlight,
	          showHeader = _props.showHeader,
	          data = _props.data,
	          title = _props.title,
	          showDetail = _props.showDetail,
	          showList = _props.showList,
	          showPercentage = _props.showPercentage;
	
	      var sum = (0, _reduce2.default)(data, function (sum, d) {
	        return sum + d.value;
	      }, 0);
	      var processData = [];
	      (0, _map2.default)(data, function (d) {
	        processData.push({
	          key: d.key,
	          _key: d._key,
	          middleVal: d.middleVal,
	          value: d.value,
	          percentage: sum <= 0 ? 0 : parseFloat((d.value / sum * 100).toFixed(2))
	        });
	      });
	      var sortData = (0, _sortBy2.default)(processData, "percentage").reverse();
	      var COLORS = ["#216E69", "#32A59D", "#56CBC4", "#99DFDD", "#BBEAE7", "#BAE6FE", "#FFE0CA", "#F3D6D4"];
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          title && _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontWeight: "bold",
	                fontSize: "24px",
	                padding: "20px"
	              }
	            },
	            title
	          )
	        ),
	        !this.isEmpty(sortData) ? _react2.default.createElement(
	          "div",
	          { style: { width: "100%", fontSize: "16px" } },
	          _react2.default.createElement(
	            "div",
	            { style: { display: "flex" } },
	            showHighlight === true && _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  flex: "0 0 160px",
	                  paddingLeft: "20px",
	                  paddingTop: "50px"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    fontSize: "70px",
	                    color: COLORS[0],
	                    fontWeight: "bold",
	                    height: "71px"
	                  }
	                },
	                sortData.length > 0 && sortData[0].percentage ? parseInt(sortData[0].percentage, 10) + "%" : ""
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    fontSize: "40px",
	                    width: "150px"
	                  }
	                },
	                sortData && sortData[0] ? showList === true ? sortData[0].key : sortData[0].key.split(" ")[0] : ""
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { flex: "1 1 230px" }, className: "_pie-chart" },
	              _react2.default.createElement(
	                _recharts.ResponsiveContainer,
	                {
	                  width: "100%",
	                  height: "100%",
	                  minWidth: "230px",
	                  minHeight: showHighlight ? "320px" : "230px"
	                },
	                _react2.default.createElement(
	                  _recharts.PieChart,
	                  null,
	                  _react2.default.createElement(
	                    _recharts.Pie,
	                    {
	                      dataKey: "value",
	                      data: sortData,
	                      onMouseEnter: function onMouseEnter(data, index) {
	                        _this2.setState({ activeIndex: index });
	                      },
	                      onMouseLeave: function onMouseLeave() {
	                        _this2.setState({ activeIndex: -1 });
	                      }
	                    },
	                    sortData.map(function (entry, idx) {
	                      return _react2.default.createElement(_recharts.Cell, {
	                        key: "segment-highlight-chart" + idx + "-cell-" + entry.key,
	                        fill: COLORS[idx % COLORS.length]
	                      });
	                    })
	                  ),
	                  _react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(CustomTooltip, null) }),
	                  showList === false && _react2.default.createElement(_recharts.Legend, {
	                    verticalAlign: "top",
	                    align: "left",
	                    formatter: function formatter(value, entry, index) {
	                      if (entry && entry.payload && entry.payload.payload && entry.payload.payload.payload) return entry.payload.payload.payload.key;else return "";
	                    }
	                  })
	                )
	              )
	            )
	          ),
	          showList === true && _react2.default.createElement(
	            "div",
	            { className: "mt-20 mb-20" },
	            showDetail && showHeader && _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  padding: "10px 20px",
	                  margin: "-20px 20px -5px",
	                  background: "#F5F5F5",
	                  fontWeight: "bold"
	                }
	              },
	              showDetail && showHeader && _react2.default.createElement(
	                "div",
	                null,
	                !this.props.middleKey ? _react2.default.createElement(
	                  "div",
	                  { style: { display: "flex" } },
	                  _react2.default.createElement(
	                    "div",
	                    { style: { flex: "1 1 50%" } },
	                    this.props.stateName || "State"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: { flex: "1 1 50%", textAlign: "right" }
	                    },
	                    this.props.fieldTitle
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { style: { display: "flex" } },
	                  _react2.default.createElement(
	                    "div",
	                    { style: { flex: "1 1 20%" } },
	                    this.props.stateName || "State"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { flex: "1 1 50%" } },
	                    this.props.middleKey
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: { flex: "1 1 30%", textAlign: "right" }
	                    },
	                    this.props.fieldTitle
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  padding: "0",
	                  margin: "0px 20px",
	                  height: "5px",
	                  borderBottom: "solid 1px #EEEFF2 "
	                }
	              },
	              "\xA0"
	            ),
	            sortData.map(function (entry, idx) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: "sortdata-" + idx,
	                  style: {
	                    display: "flex",
	                    padding: showDetail === true ? "10px 20px" : "10px 0",
	                    margin: "0px 20px",
	                    borderBottom: "solid 1px #EEEFF2 "
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      width: entry.middleVal ? "20%" : "50%",
	                      paddingLeft: "0px"
	                    }
	                  },
	                  showDetail === false && _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        width: "18px",
	                        height: "18px",
	                        display: "inline-block",
	                        marginRight: "10px",
	                        background: COLORS[idx % COLORS.length]
	                      }
	                    },
	                    "\xA0"
	                  ),
	                  entry._key || entry.key
	                ),
	                entry.middleVal ? _react2.default.createElement(
	                  "div",
	                  { style: { width: "50%" } },
	                  entry.middleVal
	                ) : null,
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      width: entry.middleVal ? "30%" : "50%",
	                      textAlign: "right"
	                    }
	                  },
	                  showDetail === true ? showPercentage ? entry.percentage <= 0 ? "0" : entry.percentage + "%" : entry.value : ""
	                )
	              );
	            })
	          )
	        ) : _react2.default.createElement(
	          "div",
	          {
	            style: {
	              width: "100%",
	              minHeight: "200px",
	              textAlign: "center",
	              paddingTop: "60px",
	              color: "#CDCDCD"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" } },
	            "No Data"
	          )
	        )
	      );
	    }
	  }]);
	
	  return PieChartHighlight;
	}(_MaterialUI2.default);
	
	PieChartHighlight.defaultProps = {
	  showList: true,
	  showDetail: false,
	  showHeader: true,
	  showHighlight: false,
	  fieldTitle: "Estimated Reach",
	  showPercentage: true
	};
	exports.default = PieChartHighlight;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _recharts = __webpack_require__(101);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reduce = __webpack_require__(299);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _maxBy = __webpack_require__(416);
	
	var _maxBy2 = _interopRequireDefault(_maxBy);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomTooltip = function CustomTooltip(_ref) {
	  var active = _ref.active,
	      payload = _ref.payload,
	      label = _ref.label;
	
	  if (active) {
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "recharts-default-tootip no-margin pt-10 pl-20 pr-20 pb-15",
	        style: { background: "#000", border: "solid 1px #000", color: "#FFF" }
	      },
	      _react2.default.createElement("p", { className: "recharts-tooltip-label no-margin" }),
	      _react2.default.createElement(
	        "ul",
	        { className: "recharts-tooltip-item-list no-padding no-margin" },
	        _react2.default.createElement(
	          "li",
	          {
	            className: "recharts-tooltip-item",
	            style: {
	              display: "inline",
	              paddingTop: "4px",
	              paddingBottom: "4px",
	              width: "100%"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "auto",
	                height: "25px",
	                display: "block",
	                overflow: "overlap",
	                whiteSpace: "nowrap",
	                textOverflow: "unset"
	              }
	            },
	            (0, _isEmpty2.default)(payload) ? "" : _react2.default.createElement(
	              "div",
	              { className: "recharts-tooltip-label no-margin-left no-margin-top no-margin-right mb-5" },
	              payload[0].payload.key + " : " + payload[0].payload.percentage.toLocaleString(undefined, {
	                style: "percent",
	                minimumFractionDigits: 2
	              }) + "%"
	            )
	          )
	        )
	      )
	    );
	  }
	
	  return null;
	};
	
	var VerticalBarChart = function (_AcquireWebComponent) {
	  _inherits(VerticalBarChart, _AcquireWebComponent);
	
	  function VerticalBarChart() {
	    _classCallCheck(this, VerticalBarChart);
	
	    return _possibleConstructorReturn(this, (VerticalBarChart.__proto__ || Object.getPrototypeOf(VerticalBarChart)).apply(this, arguments));
	  }
	
	  _createClass(VerticalBarChart, [{
	    key: "formatXAxis",
	    value: function formatXAxis(item) {
	      return item === 0 ? item : parseInt(item, 10) + "%";
	    }
	  }, {
	    key: "isEmpty",
	    value: function isEmpty(data) {
	      if (!data || data.length === 0) return true;
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].value > 0) return false;
	      }
	      return true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          data = _props.data;
	
	      var processData = [];
	      var sum = (0, _reduce2.default)(data, function (sum, d) {
	        return sum + d.value;
	      }, 0);
	
	      (0, _map2.default)(data, function (d) {
	        if (d.key !== "Unknown") processData.push({
	          key: d.key,
	          value: d.value,
	          percentage: (d.value / sum * 100).toFixed(2)
	        });
	      });
	      var maxData = (0, _maxBy2.default)(processData, function (d) {
	        return parseInt(d.percentage, 10);
	      });
	      var maxVal = maxData ? parseInt(maxData.percentage) : 0;
	      if (this.isEmpty(processData)) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontSize: "24px",
	                fontWeight: "bold",
	                padding: "20px"
	              }
	            },
	            title
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                minHeight: "200px",
	                textAlign: "center",
	                paddingTop: "60px",
	                color: "#CDCDCD"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" } },
	              "No Data"
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: "24px",
	              fontWeight: "bold",
	              padding: "20px"
	            }
	          },
	          title
	        ),
	        _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          {
	            width: "100%",
	            height: "100%",
	            minWidth: "400px",
	            minHeight: this.props.height
	          },
	          _react2.default.createElement(
	            _recharts.BarChart,
	            {
	              data: processData,
	              layout: "vertical",
	              margin: this.props.chartMargin,
	              maxBarSize: 20
	            },
	            _react2.default.createElement(_recharts.CartesianGrid, { strokeDasharray: "3 3", horizontal: false }),
	            _react2.default.createElement(_recharts.XAxis, {
	              type: "number",
	              domain: [0, maxVal > 95 ? 100 : maxVal + 3],
	              tickCount: 5,
	              tickFormatter: this.formatXAxis
	            }),
	            _react2.default.createElement(_recharts.YAxis, {
	              dataKey: "key",
	              type: "category",
	              width: this.props.yAxisWidth,
	              padding: { top: 20 },
	              mirror: !!this.props.yMirror,
	              tickLine: !this.props.yTickHide
	            }),
	            _react2.default.createElement(_recharts.Bar, { dataKey: "percentage", fill: "#216E69" }),
	            _react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(CustomTooltip, null), cursor: false })
	          )
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return VerticalBarChart;
	}(_MaterialUI2.default);
	
	VerticalBarChart.defaultProps = {
	  chartMargin: {
	    top: 0,
	    right: 20,
	    left: 10,
	    bottom: 20
	  },
	  yAxisWidth: 60,
	  height: "300px"
	};
	exports.default = VerticalBarChart;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _reactCopyToClipboard = __webpack_require__(892);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailTagDetail = function (_AcquireWebComponent) {
	  _inherits(EmailTagDetail, _AcquireWebComponent);
	
	  function EmailTagDetail() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailTagDetail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailTagDetail.__proto__ || Object.getPrototypeOf(EmailTagDetail)).call.apply(_ref, [this].concat(args))), _this), _this._downloadTxtFile = function (fileName, txt) {
	      var element = document.createElement("a");
	      var file = new Blob([txt], { type: "text/plain" });
	      element.href = URL.createObjectURL(file);
	      //element.download = this.props.website_name ? this.props.website_name : this.props.tag_info.siteName
	      // 										+ "_Tag_JS.txt"
	      element.download = fileName;
	      element.click();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EmailTagDetail, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var type = this.props.type;
	      var _props$tag_info = this.props.tag_info,
	          imageTag = _props$tag_info.imageTag,
	          deploymentType = _props$tag_info.deploymentType,
	          id = _props$tag_info.id;
	
	
	      var filePreName = this.props.campaign_name ? this.props.campaign_name : this.props.tag_info.campaignName;
	      var tagType = deploymentType === "Web" ? "Web Deployment" : "HTML Email";
	      var imgTagFileName = (filePreName + "_Tag_IMG.txt").replace(" ", "_");
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: this.props.style ? this.props.style : { padding: "20px 10%" },
	          key: "tag-create-confirm"
	        },
	        _react2.default.createElement(
	          _Grid.Row,
	          { className: "no-padding no-margin-bottom" },
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "6", sm: "6", lg: "6", md: "6" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "aa-color",
	                onClick: function onClick(e) {
	                  _this2.props.backToListClick(e);
	                }
	              },
	              "Tags"
	            ),
	            "\xA0\xA0\xA0>\xA0\xA0\xA0Insights Tag",
	            " ",
	            type === "detail" ? "Detail" : "Creation"
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "6", sm: "6", md: "6", lg: "6", className: "text-right" },
	            parseInt(this.props.roleId, 10) === 1 && _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                to: "/settings/tags/edit?id=" + id,
	                className: "btn-aa-default"
	              },
	              "EDIT TAG"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "black-border no-padding mt-20",
	            style: { fontWeight: 300, background: "#FFF" }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { style: { fontSize: "12pt" }, className: "no-padding-bottom" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "INSIGHTS TAG ",
	              type === "detail" ? "DETAIL" : "CREATION"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Client Name"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              this.props.clientName
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Business Unit Name"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              this.props.buName
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Tag Deployment Type"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              tagType
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom " },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Email Campaign Name"
	              ),
	              _react2.default.createElement(
	                "span",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              this.props.campaign_name ? this.props.campaign_name : this.props.tag_info.campaignName
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom " },
	            _react2.default.createElement("hr", { className: "black-hr" })
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Insights Tag ID"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              this.props.tag_info ? this.props.tag_info.uuid : ""
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            "Below is your Insights tracking code for the HTML email campaign you specified.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "If you asked for an Insights tag where you could return a unique identifier or to pass hashed emails for matching purposes, the primary tag has been ",
	            _react2.default.createElement("br", null),
	            "updated to support your request. ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "Copy and Paste the Insights tracking code right before the closing tag in your HTML, ",
	            "</html>",
	            ". ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "Please note that if you're using a tool to convert your CSS code to be inline, it's important to run this tool before you insert our tracking code. If you run",
	            _react2.default.createElement("br", null),
	            "it after you've inserted it, the tracking code could be altered and prevent you from collecting accurate stats."
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom mb-20 text-right" },
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                className: "btn btn-default legitRipple btn-aa-default ml-20"
	              },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://s3-us-west-2.amazonaws.com/images.audience-anywhere.com/Claritas_Insights_Tag_Implementation_Guide.pdf",
	                  target: "_blank"
	                },
	                "DOWNLOAD IMPLEMENTATION GUIDE"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-bottom pl-10 pr-10 pt-10 mb-20 ml-20 mr-20 black-border" },
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding mt-10 mb-10" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                this.props.campaign_name ? this.props.campaign_name : this.props.tag_info.campaignName,
	                " ",
	                "Image Tag"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding" },
	              _react2.default.createElement("hr", { className: "no-margin", style: { borderColor: "#000" } })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding" },
	              _react2.default.createElement(
	                "span",
	                { style: { color: "#F56600" } },
	                "PLEASE NOTE: "
	              ),
	              "Image Tags require additional parameter configuration. If you are using a Tag Manager, please refer to the documentation. For a list of available parameters please refer to the Implementation Guide."
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding mb-20" },
	              _react2.default.createElement("hr", { className: "no-margin", style: { borderColor: "#000" } })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding no-margin-bottom mt-10" },
	              _react2.default.createElement("textarea", {
	                id: "js-code-box",
	                value: imageTag,
	                readOnly: true,
	                style: {
	                  width: "100%",
	                  height: "60px",
	                  border: "none",
	                  overflow: "hidden"
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding no-margin-bottom" },
	              _react2.default.createElement("hr", { style: { borderColor: "#000" } })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "text-right no-padding mb-20" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-default legitRipple btn-aa-default mr-10",
	                  onClick: function onClick(e) {
	                    e.preventDefault();
	                    _this2._downloadTxtFile(imgTagFileName, imageTag);
	                  }
	                },
	                "DOWNLOAD AS TEXT FILE"
	              ),
	              _react2.default.createElement(
	                _reactCopyToClipboard.CopyToClipboard,
	                {
	                  text: imageTag,
	                  onCopy: function onCopy() {
	                    return _this2.setState({ copied: true });
	                  }
	                },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-default legitRipple btn-aa-default"
	                  },
	                  "Copy tag to clipboard"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding ml-20 mr-20 mb-20 text-right" },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "12",
	                sm: "12",
	                md: "12",
	                lg: "12",
	                className: "text-right no-padding"
	              },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "aa-color",
	                  onClick: function onClick(e) {
	                    _this2.props.backToListClick(e);
	                  }
	                },
	                "Back to Tags"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EmailTagDetail;
	}(_MaterialUI2.default);
	
	exports.default = EmailTagDetail;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _lodash = __webpack_require__(18);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
		tableHeaderStyle: {
			border: 'none',
			background: '#E4E4E4'
		},
		arrowStyle: {
			position: 'absolute',
			top: '0.4em'
		},
		tableHeaderColumn: {
			height: '30px',
			color: 'black',
			cursor: 'pointer',
			fontWeight: 'bolder',
			paddingLeft: '10px',
			position: 'relative',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		},
		tableTd: {
			paddingLeft: '10px',
			height: '30px',
			borderBottom: '1px solid black',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		},
		tableHeaderSortedColumn: {
			height: '30px',
			color: 'black',
			cursor: 'pointer',
			fontWeight: 'bolder',
			position: 'relative',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
			paddingLeft: '10px',
			backgroundColor: '#CECECE',
			backgroundClip: 'padding-box'
		},
		tableRowColumn: {
			position: 'relative'
		},
		settingStyle: {
			position: 'absolute',
			right: '6em',
			top: '0.9em',
			cursor: 'pointer'
		}
	};
	
	var EmailTagsTable = function (_AcquireWebComponent) {
		_inherits(EmailTagsTable, _AcquireWebComponent);
	
		function EmailTagsTable() {
			_classCallCheck(this, EmailTagsTable);
	
			return _possibleConstructorReturn(this, (EmailTagsTable.__proto__ || Object.getPrototypeOf(EmailTagsTable)).apply(this, arguments));
		}
	
		_createClass(EmailTagsTable, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.state = {
					sortOrder: 'asc',
					sortColumn: 'name'
				};
			}
		}, {
			key: 'handleHeaderClick',
			value: function handleHeaderClick(column) {
				var sortOrder = this.state.sortColumn !== column ? 'asc' : this.state.sortOrder === 'asc' ? "desc" : 'asc';
				this.setState({
					sortOrder: sortOrder,
					sortColumn: column
				});
			}
		}, {
			key: 'sortIcon',
			value: function sortIcon(column) {
				var _this2 = this;
	
				var style = {
					display: 'inline-block',
					position: 'absolute',
					top: '3px',
					right: '0'
				};
				if (column === this.state.sortColumn) {
					var icon = this.state.sortOrder === 'asc' ? _react2.default.createElement(_arrowDropUp2.default, { onClick: function onClick() {
							return _this2.handleHeaderClick(column);
						}, style: Object.assign({}, style) }) : _react2.default.createElement(_arrowDropDown2.default, { style: Object.assign({}, style), onClick: function onClick() {
							return _this2.handleHeaderClick(column);
						} });
					return icon;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var sortCol = this.state.sortColumn;
				var tags = (0, _lodash.sortBy)(this.props.client_tags, function (tag) {
					switch (sortCol) {
						case 'domain':
							return tag.domain;
						case 'id':
							return tag.uuid;
						case 'created_date':
							return tag.createdDatetime;
						default:
							return tag.siteName;
					}
				});
	
				return _react2.default.createElement(
					'table',
					{ style: { width: '100%' } },
					_react2.default.createElement(
						'thead',
						{ style: styles.tableHeaderStyle },
						_react2.default.createElement(
							'tr',
							{ style: { height: '30px', borderTop: '1px solid black', borderBottom: '1px solid black' } },
							_react2.default.createElement(
								'th',
								{ onClick: function onClick() {
										return _this3.handleHeaderClick('name');
									}, style: Object.assign({}, this.state.sortColumn === 'name' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { width: '32%' }) },
								'Campaign Name',
								this.sortIcon('name')
							),
							_react2.default.createElement(
								'th',
								{ onClick: function onClick() {
										return _this3.handleHeaderClick('id');
									}, style: Object.assign({}, this.state.sortColumn === 'id' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { width: '20%' }) },
								'Insights Tag ID',
								this.sortIcon('id')
							),
							_react2.default.createElement(
								'th',
								{ style: Object.assign({}, this.state.sortColumn === 'type' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { cursor: 'default', width: '23%' }) },
								'Tag Deployment Type'
							),
							_react2.default.createElement(
								'th',
								{ onClick: function onClick() {
										return _this3.handleHeaderClick('created_date');
									}, style: Object.assign({}, this.state.sortColumn === 'created_date' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { width: '25%' }) },
								'Tag Creation Date',
								this.sortIcon('created_date')
							)
						)
					),
					_react2.default.createElement(
						'tbody',
						null,
						(0, _lodash.map)(this.state.sortOrder === 'desc' ? (0, _lodash.reverse)(tags) : tags, function (tag) {
							if (tag.deploymentType === "Email") return _react2.default.createElement(
								'tr',
								{ key: tag.uuid },
								_react2.default.createElement(
									'td',
									{ style: styles.tableTd },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick(e) {
												e.preventDefault();_this3.props.getTagDetail(_this3.props.client_info.id, tag.id, _this3.props.redirectUrl);
											} },
										tag.campaignName
									)
								),
								_react2.default.createElement(
									'td',
									{ style: styles.tableTd },
									_react2.default.createElement(
										'div',
										{ className: 'ellipse-cell', 'data-text': tag.uuid },
										tag.uuid
									)
								),
								_react2.default.createElement(
									'td',
									{ style: styles.tableTd },
									'HTML Email'
								),
								_react2.default.createElement(
									'td',
									{ style: styles.tableTd },
									(0, _moment2.default)(tag.createdDatetime, 'x').format('MM/D/YY')
								)
							);
						})
					)
				);
			}
		}]);
	
		return EmailTagsTable;
	}(_MaterialUI2.default);
	
	exports.default = EmailTagsTable;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _Grid = __webpack_require__(19);
	
	var _lodash = __webpack_require__(18);
	
	var _materialUi = __webpack_require__(38);
	
	var _reactCopyToClipboard = __webpack_require__(892);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HtmlTagDetail = function (_AcquireWebComponent) {
	  _inherits(HtmlTagDetail, _AcquireWebComponent);
	
	  function HtmlTagDetail() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HtmlTagDetail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HtmlTagDetail.__proto__ || Object.getPrototypeOf(HtmlTagDetail)).call.apply(_ref, [this].concat(args))), _this), _this._downloadTxtFile = function (fileName, txt) {
	      var element = document.createElement("a");
	      var file = new Blob([txt], { type: "text/plain" });
	      element.href = URL.createObjectURL(file);
	      //element.download = this.props.website_name ? this.props.website_name : this.props.tag_info.siteName
	      // 										+ "_Tag_JS.txt"
	      element.download = fileName;
	      element.click();
	    }, _this._downloadImageTagTextFile = function () {
	      var _this$state = _this.state,
	          imgTag = _this$state.imgTag,
	          imgTagFilename = _this$state.imgTagFilename;
	
	      if (imgTag) {
	        var element = document.createElement("a");
	        var file = new Blob([imgTag], { type: "text/plain" });
	        element.href = URL.createObjectURL(file);
	        //element.download = this.props.website_name ? this.props.website_name : this.props.tag_info.siteName
	        //										 + "_Tag_IMG.txt"
	        element.download = imgTagFilename;
	        element.click();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HtmlTagDetail, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.state = {
	        showImgTagDialog: false,
	        imgTag: this.props.imgTag,
	        imgTagFilename: this.props.imgTagFileName,
	        imgTagName: this.props.imgTagName
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var imgTagActions = [_react2.default.createElement(_materialUi.FlatButton, {
	        key: "1",
	        label: "Cancel",
	        primary: true,
	        className: "black-border btn-aa-info",
	        backgroundColor: "#FFFFFF",
	        labelStyle: { color: "#000" },
	        hoverColor: "#FFFFFF",
	        onClick: function onClick() {
	          _this2.setState({ showImgTagDialog: false });
	        }
	      }), _react2.default.createElement("div", { key: "2", style: { flexGrow: "1" } }), _react2.default.createElement(
	        "button",
	        {
	          key: "3",
	          type: "button",
	          style: { height: "36px", marginRight: "10px" },
	          className: "btn btn-default legitRipple btn-aa-default ml-10 pull-right"
	        },
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://s3-us-west-2.amazonaws.com/images.audience-anywhere.com/Claritas_Insights_Tag_Implementation_Guide.pdf",
	            target: "_blank"
	          },
	          "DOWNLOAD IMPLEMENTATION GUIDE"
	        )
	      ), _react2.default.createElement(_materialUi.FlatButton, {
	        key: "4",
	        label: "Download AS TEXT FILE",
	        primary: true,
	        className: "pull-right btn btn-default legitRipple btn-aa-default",
	        backgroundColor: (0, _utility.buttonBlueColor)(),
	        labelStyle: { color: "#FFF" },
	        hoverColor: (0, _utility.buttonBlueColor)(),
	        onClick: function onClick() {
	          return _this2._downloadImageTagTextFile();
	        }
	      })];
	      var _props = this.props,
	          type = _props.type,
	          clientName = _props.clientName,
	          buName = _props.buName;
	      var _props$tag_info = this.props.tag_info,
	          tagParams = _props$tag_info.tagParams,
	          jsTagTemplate = _props$tag_info.jsTagTemplate,
	          imageTagTemplate = _props$tag_info.imageTagTemplate,
	          dynamic = _props$tag_info.dynamic,
	          id = _props$tag_info.id,
	          jsTag = _props$tag_info.jsTag,
	          imageTag = _props$tag_info.imageTag,
	          deploymentType = _props$tag_info.deploymentType;
	
	      var tagType = deploymentType === "Web" ? "Web Deployment" : "HTML Email";
	      // const showPrimary = tagParams && !isNil(tagParams.pageReferences) ?
	      // 	dynamic === true && (!isEmpty(tagParams.pageReferences)) :
	      // 	(tagParams && !isNil(tagParams.passThroughs) && !isEmpty(tagParams.passThroughs)) ||
	      // 	(tagParams && !isNil(tagParams.hashedEmails) && !isEmpty(tagParams.hashedEmails))
	
	      var primaryJsTag = jsTag;
	      var filePreName = this.props.website_name ? this.props.website_name : this.props.tag_info.siteName;
	      var primaryJsTagFileName = (filePreName + "_Tag_JS.txt").replace(" ", "_");
	      var primaryImgTag = imageTag;
	      var primaryImgTagFileName = (filePreName + "_Tag_IMG.txt").replace(" ", "_");
	      return _react2.default.createElement(
	        "div",
	        {
	          style: this.props.style ? this.props.style : { padding: "20px 10%" },
	          key: "tag-create-confirm"
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding no-margin-bottom" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "6", sm: "6", md: "6", lg: "6" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "aa-color",
	                  onClick: function onClick(e) {
	                    _this2.props.backToListClick(e);
	                  }
	                },
	                "Tags"
	              ),
	              "\xA0\xA0\xA0>\xA0\xA0\xA0Insights Tag",
	              " ",
	              type === "detail" ? "Detail" : "Creation"
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "6", sm: "6", md: "6", lg: "6", className: "text-right" },
	              parseInt(this.props.roleId, 10) === 1 && _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/settings/tags/edit?id=" + id,
	                  className: "btn-aa-default"
	                },
	                "EDIT TAG"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "black-border no-padding mt-20",
	            style: { fontWeight: 300, background: "#FFF" }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { style: { fontSize: "12pt" }, className: "no-padding-bottom" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "INSIGHTS TAG ",
	              type === "detail" ? "DETAIL" : "CREATION"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Client Name"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              clientName
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Business Unit Name"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              buName
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Tag Deployment Type"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              tagType
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              className: "no-padding-top no-padding-bottom mb-20",
	              style: { display: deploymentType === "Web" ? "block" : "none" }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Website Name"
	              ),
	              _react2.default.createElement(
	                "span",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              this.props.website_name ? this.props.website_name : this.props.tag_info.siteName
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              className: "no-padding-top no-padding-bottom ",
	              style: { display: deploymentType === "Web" ? "block" : "none" }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Website Domain"
	              ),
	              _react2.default.createElement(
	                "span",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              this.props.website_url ? this.props.website_url : this.props.tag_info.domain
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom " },
	            _react2.default.createElement("hr", { className: "black-hr" })
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Insights Tag ID"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              this.props.tag_info ? this.props.tag_info.uuid : ""
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            "Below are your insights tacking code(s) based on the criteria you entered. Please note, we will always provide you a primary tag that can be deployed site wide and will collect site and page level information. ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "If you selected page reference custom variables and depending on the delivery method you selected, you will also find below either an updated primary tag or unique insights tag(s) for each page reference you created.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "Copy and Paste the primary tag code below between the ",
	            "<head>",
	            " and ",
	            "</head>",
	            " tags of every webpage you want to track. Similarly, Copy and Paste the page reference tag(s) between the",
	            " ",
	            "<head>",
	            " and ",
	            "</head>",
	            " tags of every webpage you want to the page reference tag to track.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "Please note, if your site uses a \"Master Page\" or master template, the primary tag script can be placed there to appear on all pages. You may already have other existing code between the head tags, so just place the pixel code underneath that, but above ",
	            "</head>",
	            "."
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Implementing the Insight Tag with an Exiting Tag Manager"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            "The Insights tag can be easilly implemented with a Tag Manager such as Google Tag Manager or others. When creating a new tag within your tag manager, select Custom HTML Tag and COPY and PASTE your unique Insight tag and assign it to all pages, or select a specific page."
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom mb-20 text-right" },
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                className: "btn btn-default legitRipple btn-aa-default ml-20"
	              },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://s3-us-west-2.amazonaws.com/images.audience-anywhere.com/Claritas_Insights_Tag_Implementation_Guide.pdf",
	                  target: "_blank"
	                },
	                "DOWNLOAD IMPLEMENTATION GUIDE"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom pl-10 pr-10 mb-20 ml-20 mr-20 black-border" },
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding mt-20 mb-10" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "PRIMARY JAVASCRIPT TAG"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Row,
	              { className: "no-padding no-margin-bottom" },
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "8", sm: "8", md: "8", lg: "8" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "aa-color",
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this2.setState({
	                        showImgTagDialog: true,
	                        imgTag: primaryImgTag,
	                        imgTagFilename: primaryImgTagFileName,
	                        imgTagName: "PRIMARY"
	                      });
	                    }
	                  },
	                  "Click here"
	                ),
	                " ",
	                "if a non javascript tag is required"
	              ),
	              _react2.default.createElement(_Grid.Col, {
	                xs: "4",
	                sm: "4",
	                md: "4",
	                lg: "4",
	                style: { textAlign: "right" }
	              })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding no-margin-bottom" },
	              _react2.default.createElement("hr", { style: { borderColor: "#000" } })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding no-margin-bottom" },
	              _react2.default.createElement("textarea", {
	                id: "js-code-box",
	                value: primaryJsTag,
	                readOnly: true,
	                style: {
	                  width: "100%",
	                  height: "200px",
	                  border: "none",
	                  overflow: "hidden"
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding no-margin-bottom" },
	              _react2.default.createElement("hr", { style: { borderColor: "#000" } })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "text-right no-padding mb-20" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-default legitRipple btn-aa-default mr-10",
	                  onClick: function onClick(e) {
	                    e.preventDefault();
	                    _this2._downloadTxtFile(primaryJsTagFileName, primaryJsTag);
	                  }
	                },
	                "DOWNLOAD AS TEXT FILE"
	              ),
	              _react2.default.createElement(
	                _reactCopyToClipboard.CopyToClipboard,
	                {
	                  text: primaryJsTag,
	                  onCopy: function onCopy() {
	                    return _this2.setState({ copied: true });
	                  }
	                },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-default legitRipple btn-aa-default"
	                  },
	                  "Copy tag to clipboard"
	                )
	              )
	            )
	          ),
	          tagParams && dynamic === false && (0, _lodash.map)(tagParams.pageReferences, function (r) {
	            var imgTag = imageTagTemplate.replace("##Page_Ref##", r);
	            var jsTag = jsTagTemplate.replace("##Page_Ref##", r);
	            var filePreName = _this2.props.website_name ? _this2.props.website_name : _this2.props.tag_info.siteName;
	            var jsFileName = (filePreName + "_" + r + "_Tag_JS.txt").replace(" ", "_");
	            var imgTagFileName = (filePreName + "_" + r + "_Tag_IMG.txt").replace(" ", "_");
	            return _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                key: "page-reference-" + r + "-container",
	                className: "no-padding-top no-padding-bottom pl-10 pr-10 mb-20 ml-20 mr-20 black-border"
	              },
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "no-padding mt-20 mb-10" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "PAGE REFERENCE JAVASCRIPT TAG: ",
	                  r
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.Row,
	                { className: "no-padding no-margin-bottom" },
	                _react2.default.createElement(
	                  _Grid.Col,
	                  { xs: "8", sm: "8", md: "8", lg: "8" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "aa-color",
	                      onClick: function onClick(e) {
	                        e.preventDefault();
	                        _this2.setState({
	                          showImgTagDialog: true,
	                          imgTag: imgTag,
	                          imgTagFilename: imgTagFileName,
	                          imgTagName: r.toUpperCase()
	                        });
	                      }
	                    },
	                    "Click here"
	                  ),
	                  " ",
	                  "if a non javascript tag is required"
	                ),
	                _react2.default.createElement(
	                  _Grid.Col,
	                  {
	                    xs: "4",
	                    sm: "4",
	                    md: "4",
	                    lg: "4",
	                    style: { textAlign: "right" }
	                  },
	                  "\xA0"
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "no-padding no-margin-bottom" },
	                _react2.default.createElement("hr", { style: { borderColor: "#000" } })
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "no-padding no-margin-bottom" },
	                _react2.default.createElement("textarea", {
	                  id: "js-code-box",
	                  value: jsTag,
	                  readOnly: true,
	                  style: {
	                    width: "100%",
	                    height: "200px",
	                    border: "none",
	                    overflow: "hidden"
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "no-padding no-margin-bottom" },
	                _react2.default.createElement("hr", { style: { borderColor: "#000" } })
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "text-right no-padding mb-20" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-default legitRipple btn-aa-default mr-10",
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this2._downloadTxtFile(jsFileName, jsTag);
	                    }
	                  },
	                  "DOWNLOAD AS TEXT FILE"
	                ),
	                _react2.default.createElement(
	                  _reactCopyToClipboard.CopyToClipboard,
	                  {
	                    text: jsTag,
	                    onCopy: function onCopy() {
	                      return _this2.setState({ copied: true });
	                    }
	                  },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      className: "btn btn-default legitRipple btn-aa-default"
	                    },
	                    "Copy tag to clipboard"
	                  )
	                )
	              )
	            );
	          }),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding ml-20 mr-20 mb-20 text-right" },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "12",
	                sm: "12",
	                md: "12",
	                lg: "12",
	                className: "text-right no-padding"
	              },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "aa-color",
	                  onClick: function onClick(e) {
	                    _this2.props.backToListClick(e);
	                  }
	                },
	                "Back to Tags"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _materialUi.Dialog,
	            {
	              actions: imgTagActions,
	              title: this.state.imgTagName + " IMAGE TAG",
	              contentStyle: {
	                color: "rgba(0,0,0,1)",
	                minHeight: "100px",
	                paddingBottom: "0px",
	                minWidth: "680px",
	                paddingBotom: "0px",
	                maxWidth: "800px",
	                maxHeight: "none",
	                fontWeight: "bold"
	              },
	              modal: false,
	              open: this.state.showImgTagDialog,
	              titleStyle: {
	                fontSize: "12pt",
	                paddingBottom: "0px",
	                paddingTop: "10px"
	              },
	              actionsContainerStyle: {
	                textTransform: "uppercase",
	                textAlign: "center",
	                paddingBottom: "24px",
	                paddingLeft: "24px",
	                paddingRight: "24px",
	                display: "flex"
	              }
	            },
	            _react2.default.createElement(
	              _reactCopyToClipboard.CopyToClipboard,
	              {
	                text: this.state.imgTag,
	                style: { height: "40px" },
	                onCopy: function onCopy() {
	                  return _this2.setState({ copied: true });
	                }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  style: { margintTop: "-10px" },
	                  className: "btn btn-default legitRipple btn-aa-default pull-right"
	                },
	                "Copy tag to clipboard"
	              )
	            ),
	            _react2.default.createElement("hr", { style: { borderColor: "#000", marginTop: "50px" } }),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding" },
	              _react2.default.createElement(
	                "span",
	                { style: { color: "#F56600" } },
	                "PLEASE NOTE: "
	              ),
	              "Image Tags require additional parameter configuration. If you are using a Tag Manager, please refer to the documentation. For a list of available parameters please refer to the Implementation Guide."
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding mb-20" },
	              _react2.default.createElement("hr", { className: "no-margin", style: { borderColor: "#000" } })
	            ),
	            _react2.default.createElement("textarea", {
	              id: "img-code-box",
	              value: this.state.imgTag,
	              readOnly: true,
	              style: {
	                fontSize: "10pt",
	                color: "#000",
	                fontWeight: "300",
	                width: "100%",
	                height: "60px",
	                border: "none",
	                overflow: "hidden"
	              }
	            }),
	            _react2.default.createElement("hr", {
	              style: {
	                borderColor: "#000",
	                marginTop: "0px",
	                marginBottom: "0px"
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return HtmlTagDetail;
	}(_MaterialUI2.default);
	
	exports.default = HtmlTagDetail;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _materialUi = __webpack_require__(38);
	
	var _lodash = __webpack_require__(18);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _CustomTagVariables = __webpack_require__(1119);
	
	var _CustomTagVariables2 = _interopRequireDefault(_CustomTagVariables);
	
	var _HashedEmail = __webpack_require__(1120);
	
	var _HashedEmail2 = _interopRequireDefault(_HashedEmail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var inputStyle = {
	  border: "solid 1px #000",
	  height: "28px",
	  width: "100%",
	  paddingLeft: "10px",
	  fontSize: "13px",
	  color: "black"
	};
	
	var styles = {
	  tableHeaderStyle: {
	    border: "none",
	    background: "#E4E4E4"
	  },
	  arrowStyle: {
	    position: "absolute",
	    top: "0.4em"
	  },
	  tableHeaderColumn: {
	    height: "30px",
	    color: "black",
	    cursor: "pointer",
	    fontWeight: "bolder",
	    paddingLeft: "10px",
	    position: "relative",
	    whiteSpace: "nowrap",
	    textOverflow: "ellipsis"
	  },
	  tableTd: {
	    paddingLeft: "10px",
	    height: "30px",
	    borderBottom: "1px solid black",
	    whiteSpace: "nowrap",
	    overflow: "hidden",
	    textOverflow: "ellipsis"
	  },
	  tableHeaderSortedColumn: {
	    height: "30px",
	    color: "black",
	    cursor: "pointer",
	    fontWeight: "bolder",
	    position: "relative",
	    whiteSpace: "nowrap",
	    textOverflow: "ellipsis",
	    paddingLeft: "10px",
	    backgroundColor: "#CECECE",
	    backgroundClip: "padding-box"
	  },
	  tableRowColumn: {
	    position: "relative"
	  },
	  settingStyle: {
	    position: "absolute",
	    right: "6em",
	    top: "0.9em",
	    cursor: "pointer"
	  }
	};
	
	var TagCreation = function (_AcquireWebComponent) {
	  _inherits(TagCreation, _AcquireWebComponent);
	
	  function TagCreation() {
	    _classCallCheck(this, TagCreation);
	
	    return _possibleConstructorReturn(this, (TagCreation.__proto__ || Object.getPrototypeOf(TagCreation)).apply(this, arguments));
	  }
	
	  _createClass(TagCreation, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.state = {
	        id: this.props.id ? this.props.id : undefined,
	        isValidDomain: this.props.website_url ? true : false,
	        showTagConfirmDialog: false,
	        showImgTagDialog: false,
	        clientName: "",
	        buName: "",
	        clientId: undefined,
	        showCustomVarDialog: false,
	        tag_variables: this.props.tag_variables ? this.props.tag_variables : [],
	        origin_tag_variables: this.props.tag_variables ? this.props.tag_variables : [],
	        pass_variables: this.props.pass_variables ? this.props.pass_variables : [],
	        origin_pass_variables: this.props.pass_variables ? this.props.pass_variables : [],
	        hash_format: this.props.hash_format ? this.props.hash_format : [],
	        origin_hash_format: this.props.hash_format ? this.props.hashed_format : [],
	        hash_case: this.props.hash_case ? this.props.hash_case : "upper",
	        origin_hash_case: this.props.hash_case ? this.props.hash_case : "upper",
	        tag_vars_error_message: undefined,
	        tag_vars_deploy: this.props.tag_vars_deploy ? this.props.tag_vars_deploy : "unique",
	        tag_type: this.props.tag_type ? this.props.tag_type : "Web",
	        filter_tag_type: this.props.tag_type ? this.props.tag_type : "Web"
	      };
	    }
	  }, {
	    key: "handleCampaignNameChange",
	    value: function handleCampaignNameChange(e, val) {
	      e.preventDefault();
	      this.props.setTagCampaignName(val);
	    }
	  }, {
	    key: "handleWebsiteNameChange",
	    value: function handleWebsiteNameChange(e, val) {
	      e.preventDefault();
	      this.props.setTagWebsiteName(val);
	    }
	  }, {
	    key: "handleWebsiteURLChange",
	    value: function handleWebsiteURLChange(e, val) {
	      e.preventDefault();
	      this.props.setTagWebsiteURL(val);
	      //const isUrl = /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/i.test(val)
	      var isUrl = /[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/i.test(val);
	      if (isUrl === true) this.setState({ isValidDomain: true });else this.setState({ isValidDomain: false });
	    }
	  }, {
	    key: "handleTagDevTypeChanged",
	    value: function handleTagDevTypeChanged(e) {
	      this.setState({
	        tag_type: e.value
	      });
	    }
	  }, {
	    key: "showCustomVarsDialog",
	    value: function showCustomVarsDialog() {
	      var _state = this.state,
	          tag_variables = _state.tag_variables,
	          pass_variables = _state.pass_variables,
	          hash_format = _state.hash_format,
	          hash_case = _state.hash_case;
	
	      this.setState({
	        showCustomVarDialog: true,
	        origin_tag_variables: tag_variables.slice(),
	        origin_pass_variables: pass_variables.slice(),
	        origin_hash_format: hash_format.slice(),
	        origin_hash_case: hash_case.slice()
	      });
	    }
	  }, {
	    key: "tagVarChanged",
	    value: function tagVarChanged(e, index) {
	      var tag_variables = this.state.tag_variables;
	
	      tag_variables[index] = e.target.value;
	      this.setState({
	        tag_variables: tag_variables,
	        tag_vars_error_message: undefined
	      });
	    }
	  }, {
	    key: "addTagVariable",
	    value: function addTagVariable() {
	      var v = this.state.tag_variables;
	      if (v.length < 5) v.push("");
	      this.setState({
	        tag_variables: v,
	        tag_vars_error_message: undefined
	      });
	    }
	  }, {
	    key: "removeTagVariable",
	    value: function removeTagVariable() {
	      var v = this.state.tag_variables;
	      if (v.length > 0) v.pop();
	      this.setState({
	        tag_variables: v,
	        tag_vars_error_message: undefined
	      });
	    }
	  }, {
	    key: "addPassThrough",
	    value: function addPassThrough() {
	      var v = this.state.pass_variables;
	      if (v.length < 5) v.push("");
	      this.setState({
	        pass_variables: v,
	        tag_vars_error_message: undefined
	      });
	    }
	  }, {
	    key: "removePassThrough",
	    value: function removePassThrough() {
	      var v = this.state.pass_variables;
	      if (v.length > 0) v.pop();
	      this.setState({
	        pass_variables: v,
	        tag_vars_error_message: undefined
	      });
	    }
	  }, {
	    key: "passThroughChanged",
	    value: function passThroughChanged(e, index) {
	      var pass_variables = this.state.pass_variables;
	
	      pass_variables[index] = e.target.value;
	      this.setState({
	        pass_variables: pass_variables,
	        tag_vars_error_message: undefined
	      });
	    }
	  }, {
	    key: "cancelSaveCustomVars",
	    value: function cancelSaveCustomVars() {
	      var _state2 = this.state,
	          origin_tag_variables = _state2.origin_tag_variables,
	          origin_pass_variables = _state2.origin_pass_variables,
	          origin_hash_case = _state2.origin_hash_case,
	          origin_hash_format = _state2.origin_hash_format;
	
	      this.setState({
	        tag_vars_error_message: undefined,
	        tag_variables: origin_tag_variables.slice(),
	        pass_variables: origin_pass_variables.slice(),
	        hash_case: origin_hash_case.slice(),
	        hash_format: origin_hash_format.slice(),
	        showCustomVarDialog: false
	      });
	    }
	  }, {
	    key: "handleHashFormatChanged",
	    value: function handleHashFormatChanged(e) {
	      var hash_format = this.state.hash_format;
	
	      if (e.target.checked === true) {
	        hash_format.push(e.target.value);
	      } else {
	        (0, _lodash.pull)(hash_format, e.target.value);
	      }
	      this.setState({ hash_format: (0, _lodash.sortBy)(hash_format) });
	    }
	  }, {
	    key: "handleHashCaseChanged",
	    value: function handleHashCaseChanged(e) {
	      this.setState({ hash_case: e.target.value });
	    }
	  }, {
	    key: "saveCustomVars",
	    value: function saveCustomVars() {
	      var _state3 = this.state,
	          tag_variables = _state3.tag_variables,
	          pass_variables = _state3.pass_variables;
	
	      var emptyTag = tag_variables.find(function (val) {
	        return (0, _lodash.isEmpty)(val);
	      });
	      if (!(0, _lodash.isNil)(emptyTag)) {
	        this.setState({
	          tag_vars_error_message: "Page reference name can not be empty!"
	        });
	        return;
	      }
	      var duplicateTag = tag_variables.filter(function (value, index, iteratee) {
	        return iteratee.includes(value, index + 1);
	      });
	      if (!(0, _lodash.isEmpty)(duplicateTag)) {
	        this.setState({
	          tag_vars_error_message: "Duplicated page reference names, Please check again"
	        });
	        return;
	      }
	
	      var emptyPass = pass_variables.find(function (val) {
	        return (0, _lodash.isEmpty)(val);
	      });
	      if (!(0, _lodash.isNil)(emptyPass)) {
	        this.setState({
	          tag_vars_error_message: "Pass through name can not be empty!"
	        });
	        return;
	      }
	      var duplicatePass = pass_variables.filter(function (value, index, iteratee) {
	        return iteratee.includes(value, index + 1);
	      });
	      if (!(0, _lodash.isEmpty)(duplicatePass)) {
	        this.setState({
	          tag_vars_error_message: "Duplicated pass through names, Please check again"
	        });
	        return;
	      }
	      this.setState({
	        tag_vars_error_message: undefined,
	        showCustomVarDialog: false
	      });
	    }
	  }, {
	    key: "clickGenerateTag",
	    value: function clickGenerateTag(evt) {
	      evt.preventDefault();
	      this.props.clearTagError();
	      this.setState({ showTagConfirmDialog: true });
	    }
	  }, {
	    key: "clickBack2TagList",
	    value: function clickBack2TagList(e) {
	      e.preventDefault();
	      this.props.clearTagError();
	    }
	  }, {
	    key: "handleCloseConfirmDialog",
	    value: function handleCloseConfirmDialog(confirm) {
	      if (confirm === true) {
	        var _props = this.props,
	            client_info = _props.client_info,
	            website_name = _props.website_name,
	            website_url = _props.website_url,
	            campaign_name = _props.campaign_name;
	        var _state4 = this.state,
	            tag_variables = _state4.tag_variables,
	            tag_vars_deploy = _state4.tag_vars_deploy,
	            pass_variables = _state4.pass_variables,
	            hash_format = _state4.hash_format,
	            hash_case = _state4.hash_case;
	
	        var data = {
	          deploymentType: this.state.tag_type
	        };
	        switch (this.state.tag_type) {
	          case "Web":
	            data["siteName"] = website_name;
	            data["domain"] = website_url;
	            if (!(0, _lodash.isEmpty)(tag_variables)) {
	              data["dynamic"] = tag_vars_deploy === "dynamic";
	              data["tagParams"] = {
	                pageReferences: tag_variables
	              };
	            }
	            break;
	          case "Email":
	            data["campaignName"] = campaign_name;
	            break;
	          default:
	            return;
	        }
	
	        if (!(0, _lodash.isEmpty)(pass_variables)) {
	          if ((0, _lodash.isNil)(data["tagParams"])) {
	            data["tagParams"] = {
	              passThroughs: pass_variables
	            };
	          } else {
	            data["tagParams"]["passThroughs"] = pass_variables;
	          }
	        }
	        if (!(0, _lodash.isEmpty)(hash_format)) {
	          if ((0, _lodash.isNil)(data["tagParams"])) {
	            data["tagParams"] = {
	              hashedEmails: hash_format,
	              upperCase: hash_case === "upper"
	            };
	          } else {
	            data["tagParams"]["hashedEmails"] = hash_format;
	            data["tagParams"]["upperCase"] = hash_case === "upper";
	          }
	        }
	
	        if (!(0, _lodash.isUndefined)(this.props.id)) {
	          data["id"] = this.props.id;
	        }
	        this.setState({ clientId: client_info.id });
	        this.props.generateTag(client_info.id, data);
	        this.props.getClientTags(client_info.id);
	      } else {
	        this.setState({ showTagConfirmDialog: false });
	      }
	    }
	  }, {
	    key: "handleOptionChange",
	    value: function handleOptionChange(e) {
	      this.setState({
	        tag_vars_deploy: e.target.value
	      });
	    }
	  }, {
	    key: "back2ListClick",
	    value: function back2ListClick(e) {
	      e.preventDefault();
	      this.props.clearTagError();
	      this.props.history.push("/settings/tags/detail");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var tagListPageUrl = this.props.location && this.props.location.pathname.indexOf("settings") > 0 ? "/settings/tags/list" : "/insights/tags/list";
	      var roleId = this.props.roleId;
	
	      var isSysAdmin = roleId === 1;
	      var tagConfirmActions = [_react2.default.createElement(_materialUi.FlatButton, {
	        label: "Cancel",
	        primary: true,
	        className: "black-border btn-aa-info",
	        backgroundColor: "#FFFFFF",
	        labelStyle: { color: "#000" },
	        hoverColor: "#FFFFFF",
	        onClick: function onClick() {
	          return _this2.handleCloseConfirmDialog(false);
	        }
	      }), _react2.default.createElement(_materialUi.FlatButton, {
	        label: "Confirm",
	        primary: true,
	        className: "ml-20 mr-20 btn-aa-warning",
	        backgroundColor: "red",
	        labelStyle: { color: "white" },
	        hoverColor: "red",
	        onClick: function onClick() {
	          return _this2.handleCloseConfirmDialog(true);
	        }
	      })];
	
	      var custVarsActions = [_react2.default.createElement(
	        "span",
	        { className: "pull-left mt-10", style: { color: "red" } },
	        this.state.tag_vars_error_message
	      ), _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          className: "btn btn-default legitRipple btn-aa-default pull-right ml-10",
	          onClick: function onClick(e) {
	            e.preventDefault();
	            _this2.saveCustomVars();
	          }
	        },
	        "Save"
	      ), _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          className: "btn btn-aa-info btn-default legitRipple btn-aa-secondary pull-right",
	          style: {
	            backgroundColor: "#FFF",
	            color: "#000",
	            border: "solid 1px #000"
	          },
	          onClick: function onClick(e) {
	            e.preventDefault();
	            _this2.cancelSaveCustomVars();
	          }
	        },
	        "Cancel"
	      )];
	      var showAddVarBtn = ((0, _lodash.isEmpty)(this.state.tag_variables) || (0, _lodash.isEmpty)(this.state.tag_variables[0])) && ((0, _lodash.isEmpty)(this.state.pass_variables) || (0, _lodash.isEmpty)(this.state.pass_variables[0])) && (0, _lodash.isEmpty)(this.state.hash_format);
	
	      var _props2 = this.props,
	          tagDevOptions = _props2.tagDevOptions,
	          clientName = _props2.clientName,
	          buName = _props2.buName;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: this.props.style ? this.props.style : { padding: "20px 30%" },
	          key: "tag-creation-container"
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: tagListPageUrl },
	            "Tags"
	          ),
	          "\xA0\xA0\xA0>\xA0\xA0\xA0Insights Tag Creation"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "black-border no-padding mt-20 ",
	            style: { background: "#FFF", fontWeight: 300 }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { style: { fontSize: "12pt" }, className: "no-padding-bottom" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "INSIGHTS TAG CREATION"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Client Name"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              clientName
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Business Unit Name"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              buName
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-top no-padding-bottom mb-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Tag Deployment Type"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8", className: "no-padding-left" },
	              (0, _lodash.isUndefined)(this.props.id) ? _react2.default.createElement(_reactSelect2.default, {
	                style: { marginTop: "-10px" },
	                value: this.state.tag_type,
	                name: "",
	                clearable: false,
	                options: tagDevOptions,
	                searchable: false,
	                onChange: this.handleTagDevTypeChanged.bind(this)
	              }) : _react2.default.createElement(
	                "span",
	                { className: "ml-10" },
	                this.state.tag_type === "Web" ? "Web Property" : "HTML Email"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              className: "no-padding-top no-padding-bottom",
	              style: {
	                display: this.state.tag_type === "Email" ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4", className: "pt-5 no-padding-right" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Email Campaign Name"
	              ),
	              _react2.default.createElement(
	                "span",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              (0, _lodash.isUndefined)(this.props.id) ? _react2.default.createElement("input", {
	                type: "text",
	                value: this.props.campaign_name,
	                ref: "inputCampaignNameRef",
	                style: inputStyle,
	                key: "campaign-name-input",
	                onChange: function onChange(e) {
	                  return _this2.handleCampaignNameChange(e, _this2.refs.inputCampaignNameRef.value);
	                },
	                placeholder: "Please enter email campaign name",
	                maxLength: "50"
	              }) : _react2.default.createElement(
	                "span",
	                null,
	                this.props.campaign_name
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              className: "no-padding-top no-padding-bottom mb-20",
	              style: {
	                display: this.state.tag_type === "Web" ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4", className: "pt-5" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Website Name"
	              ),
	              _react2.default.createElement(
	                "span",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              (0, _lodash.isUndefined)(this.props.id) ? _react2.default.createElement("input", {
	                type: "text",
	                value: this.props.website_name,
	                ref: "inputWebsiteNameRef",
	                style: inputStyle,
	                key: "website-name-input",
	                onChange: function onChange(e) {
	                  return _this2.handleWebsiteNameChange(e, _this2.refs.inputWebsiteNameRef.value);
	                },
	                placeholder: "Please enter website name",
	                maxLength: "50"
	              }) : _react2.default.createElement(
	                "span",
	                null,
	                this.props.website_name
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              className: "no-padding-top no-padding-bottom ",
	              style: {
	                display: this.state.tag_type === "Web" ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4", className: "pt-5" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Website Domain"
	              ),
	              _react2.default.createElement(
	                "span",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              (0, _lodash.isUndefined)(this.props.id) ? [_react2.default.createElement("input", {
	                type: "text",
	                value: this.props.website_url,
	                ref: "inputWebsiteURLRef",
	                style: inputStyle,
	                key: "url-input",
	                onChange: function onChange(e) {
	                  return _this2.handleWebsiteURLChange(e, _this2.refs.inputWebsiteURLRef.value);
	                },
	                placeholder: "Please enter website Domain",
	                maxLength: 200
	              }), _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "5px",
	                    color: this.state.isValidDomain === true ? "#000" : "red"
	                  }
	                },
	                "(Must be a fully qualified domain name)"
	              )] : _react2.default.createElement(
	                "span",
	                null,
	                this.props.website_url
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-padding-top no-padding-bottom no-margin-bottom",
	              style: {
	                display: this.state.tag_type === "Email" && this.props.roleId !== 1 ? "none" : "block"
	              }
	            },
	            _react2.default.createElement("hr", { style: { borderColor: "#000" } }),
	            _react2.default.createElement(
	              "strong",
	              { style: { fontSize: "12pt" } },
	              "CUSTOM VARIABLES"
	            ),
	            _react2.default.createElement("br", null),
	            showAddVarBtn ? _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                className: "mt-10 btn btn-default legitRipple btn-aa-default",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this2.showCustomVarsDialog();
	                }
	              },
	              "ADD CUSTOM VARIABLES"
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "table",
	                { style: { width: "100%", marginTop: "10px" } },
	                _react2.default.createElement(
	                  "thead",
	                  { style: styles.tableHeaderStyle },
	                  _react2.default.createElement(
	                    "tr",
	                    {
	                      style: {
	                        height: "30px",
	                        borderTop: "1px solid black",
	                        borderBottom: "1px solid black"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "th",
	                      { style: Object.assign({}, styles.tableHeaderColumn, { width: "40%" }) },
	                      "Reference Name"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      { style: Object.assign({}, styles.tableHeaderColumn, { width: "30%" }) },
	                      "Hash Case"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      { style: Object.assign({}, styles.tableHeaderColumn, { width: "30%" }) },
	                      "Variable Type"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  this.state.tag_variables.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "tr",
	                      { key: "tag_vars_" + index },
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.tableTd },
	                        item
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.tableTd },
	                        " \xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.tableTd },
	                        "Page Reference"
	                      )
	                    );
	                  }),
	                  this.state.pass_variables.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "tr",
	                      { key: "pass_vars_" + index },
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.tableTd },
	                        item
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.tableTd },
	                        " \xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.tableTd },
	                        "Pass Through"
	                      )
	                    );
	                  }),
	                  this.state.hash_format.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "tr",
	                      { key: "pass_vars_" + index },
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.tableTd },
	                        item
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.tableTd },
	                        _this2.state.hash_case === "upper" ? "Uppercase" : "Lowercase"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { style: styles.tableTd },
	                        "Hashed Email"
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "no-padding" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "mt-20 btn btn-default legitRipple btn-aa-default pull-right",
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this2.showCustomVarsDialog();
	                    }
	                  },
	                  "Edit CUSTOM VARIABLES"
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                {
	                  className: "no-padding mt-10",
	                  style: {
	                    display: this.state.tag_type === "Web" ? "block" : "none"
	                  }
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "We can deliver your custom variable tags in one of two ways. Please select your",
	                  _react2.default.createElement("br", null),
	                  "preferred method:"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("input", {
	                  type: "radio",
	                  name: "varDeploy",
	                  value: "unique",
	                  className: "mt-20 mb-20",
	                  onChange: function onChange(e) {
	                    _this2.handleOptionChange(e);
	                  },
	                  checked: this.state.tag_vars_deploy === "unique"
	                }),
	                "\xA0\xA0A unique tag for each page reference name you entered.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("input", {
	                  type: "radio",
	                  name: "varDeploy",
	                  value: "dynamic",
	                  onChange: function onChange(e) {
	                    _this2.handleOptionChange(e);
	                  },
	                  checked: this.state.tag_vars_deploy === "dynamic"
	                }),
	                "\xA0\xA0One tag where you can dynamically inject any of the page reference names you entered when the tag is fired. Note: This approach requires some additional programming on your end.",
	                _react2.default.createElement("br", null)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-top no-padding-bottom mb-20 text-right" },
	            _react2.default.createElement("hr", { style: { borderColor: "#000" } }),
	            (0, _lodash.isUndefined)(this.props.id) ? _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                disabled: this.state.tag_type === "Email" ? (0, _lodash.isEmpty)(this.props.campaign_name) : (0, _lodash.isEmpty)(this.props.website_name) || !this.state.isValidDomain,
	                className: "btn btn-default legitRipple btn-aa-default",
	                onClick: function onClick(e) {
	                  _this2.clickGenerateTag(e);
	                }
	              },
	              "GENERATE INSIGHTS TAG"
	            ) : [_react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                className: "btn btn-default btn-aa-default legitRipple mr-20",
	                key: "btn-cancel",
	                onClick: this.back2ListClick.bind(this),
	                to: "/settings/tags/list"
	              },
	              "CANCEL"
	            ), _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                key: "btn-save-tag",
	                disabled: this.state.tag_type === "Email" ? (0, _lodash.isEmpty)(this.props.campaign_name) : (0, _lodash.isEmpty)(this.props.website_name) || !this.state.isValidDomain,
	                className: "btn btn-default legitRipple btn-aa-default",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this2.handleCloseConfirmDialog(true);
	                }
	              },
	              "SAVE TAG"
	            )]
	          ),
	          _react2.default.createElement(
	            _materialUi.Dialog,
	            {
	              actions: [_react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  className: "btn btn-default btn-aa-default legitRipple mr-20",
	                  onClick: this.back2ListClick.bind(this),
	                  to: "/settings/tags/detail"
	                },
	                "CLOSE"
	              )],
	              contentStyle: {
	                color: "rgba(0,0,0,1)",
	                width: "400px",
	                maxWidth: "none",
	                textAlign: "center",
	                fontWeight: "bold"
	              },
	              modal: false,
	              open: this.props.tag_updated_success === true,
	              actionsContainerStyle: {
	                textAlign: "center",
	                paddingBottom: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  textAlign: "center",
	                  fontWeight: "600",
	                  color: "#000",
	                  fontSize: "11pt"
	                }
	              },
	              "Your edits have been saved."
	            )
	          ),
	          _react2.default.createElement(
	            _materialUi.Dialog,
	            {
	              actions: tagConfirmActions,
	              contentStyle: {
	                color: "rgba(0,0,0,1)",
	                width: "600px",
	                maxWidth: "none",
	                textAlign: "center",
	                fontWeight: "bold"
	              },
	              modal: false,
	              open: this.state.showTagConfirmDialog,
	              actionsContainerStyle: {
	                textAlign: "center",
	                paddingBottom: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  textAlign: "center",
	                  fontWeight: "600",
	                  color: "#000",
	                  fontSize: "11pt"
	                }
	              },
	              "Please confirm that your",
	              " ",
	              this.state.tag_type === "Email" ? "Email Campaign Name is correct" : "Website Name and Website Domain are correct",
	              "."
	            ),
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  display: this.props.tag_error_message ? "block" : "none",
	                  color: "red",
	                  fontSize: "9pt",
	                  marginTop: "10px"
	                }
	              },
	              this.props.tag_error_message
	            )
	          ),
	          _react2.default.createElement(
	            _materialUi.Dialog,
	            {
	              actions: custVarsActions,
	              title: "CUSTOM VARIABLE SETUP",
	              contentStyle: {
	                paddingBottom: "0px",
	                fontSize: "13px",
	                color: "#000000",
	                width: "510px",
	                paddingBotom: "0px",
	                maxWidth: "none",
	                maxHeight: "none"
	              },
	              bodyStyle: {
	                paddingTop: "20px",
	                fontSize: "13px",
	                color: "#000",
	                paddingBottom: "0px"
	              },
	              modal: false,
	              autoScrollBodyContent: true,
	              open: this.state.showCustomVarDialog,
	              titleStyle: {
	                fontSize: "16px",
	                fontWeight: "bold",
	                paddingBottom: "10px",
	                paddingTop: "10px"
	              },
	              actionsContainerStyle: {
	                textAlign: "center",
	                paddingBottom: "40px",
	                paddingLeft: "20px",
	                paddingRight: "20px"
	              }
	            },
	            this.state.tag_type !== "Email" && _react2.default.createElement(_CustomTagVariables2.default, {
	              variables: this.state.tag_variables,
	              varChanged: this.tagVarChanged.bind(this),
	              addVariable: this.addTagVariable.bind(this),
	              removeVariable: this.removeTagVariable.bind(this),
	              varType: "page"
	            }),
	            isSysAdmin && _react2.default.createElement(_CustomTagVariables2.default, {
	              variables: this.state.pass_variables,
	              varChanged: this.passThroughChanged.bind(this),
	              addVariable: this.addPassThrough.bind(this),
	              removeVariable: this.removePassThrough.bind(this),
	              varType: "passthrough"
	            }),
	            isSysAdmin && _react2.default.createElement(_HashedEmail2.default, {
	              hashCase: this.state.hash_case,
	              hashFormat: this.state.hash_format,
	              handleHashFormatChanged: this.handleHashFormatChanged.bind(this),
	              handleHashCaseChanged: this.handleHashCaseChanged.bind(this)
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TagCreation;
	}(_MaterialUI2.default);
	
	exports.default = TagCreation;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _lodash = __webpack_require__(18);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
		tableHeaderStyle: {
			border: 'none',
			background: '#E4E4E4'
		},
		arrowStyle: {
			position: 'absolute',
			top: '0.4em'
		},
		tableHeaderColumn: {
			height: '30px',
			color: 'black',
			cursor: 'pointer',
			fontWeight: 'bolder',
			paddingLeft: '10px',
			position: 'relative',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		},
		tableTd: {
			paddingLeft: '10px',
			height: '30px',
			borderBottom: '1px solid black',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		},
		tableHeaderSortedColumn: {
			height: '30px',
			color: 'black',
			cursor: 'pointer',
			fontWeight: 'bolder',
			position: 'relative',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
			paddingLeft: '10px',
			backgroundColor: '#CECECE',
			backgroundClip: 'padding-box'
		},
		tableRowColumn: {
			position: 'relative'
		},
		settingStyle: {
			position: 'absolute',
			right: '6em',
			top: '0.9em',
			cursor: 'pointer'
		}
	};
	
	var WebTagsTable = function (_AcquireWebComponent) {
		_inherits(WebTagsTable, _AcquireWebComponent);
	
		function WebTagsTable() {
			_classCallCheck(this, WebTagsTable);
	
			return _possibleConstructorReturn(this, (WebTagsTable.__proto__ || Object.getPrototypeOf(WebTagsTable)).apply(this, arguments));
		}
	
		_createClass(WebTagsTable, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.state = {
					sortOrder: 'asc',
					sortColumn: 'name'
				};
			}
		}, {
			key: 'handleHeaderClick',
			value: function handleHeaderClick(column) {
				var sortOrder = this.state.sortColumn !== column ? 'asc' : this.state.sortOrder === 'asc' ? "desc" : 'asc';
				this.setState({
					sortOrder: sortOrder,
					sortColumn: column
				});
			}
		}, {
			key: 'sortIcon',
			value: function sortIcon(column) {
				var _this2 = this;
	
				var style = {
					display: 'inline-block',
					position: 'absolute',
					top: '3px',
					right: '0'
				};
				if (column === this.state.sortColumn) {
					var icon = this.state.sortOrder === 'asc' ? _react2.default.createElement(_arrowDropUp2.default, { onClick: function onClick() {
							return _this2.handleHeaderClick(column);
						}, style: Object.assign({}, style) }) : _react2.default.createElement(_arrowDropDown2.default, { style: Object.assign({}, style), onClick: function onClick() {
							return _this2.handleHeaderClick(column);
						} });
					return icon;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var sortCol = this.state.sortColumn;
				var tags = (0, _lodash.sortBy)(this.props.client_tags, function (tag) {
					switch (sortCol) {
						case 'domain':
							return tag.domain;
						case 'id':
							return tag.uuid;
						case 'created_date':
							return tag.createdDatetime;
						default:
							return tag.siteName;
					}
				});
				var _props = this.props,
				    redirectUrl = _props.redirectUrl,
				    client_info = _props.client_info;
	
				return _react2.default.createElement(
					'table',
					{ style: { width: '100%' } },
					_react2.default.createElement(
						'thead',
						{ style: styles.tableHeaderStyle },
						_react2.default.createElement(
							'tr',
							{ style: { height: '30px', borderTop: '1px solid black', borderBottom: '1px solid black' } },
							_react2.default.createElement(
								'th',
								{ onClick: function onClick() {
										return _this3.handleHeaderClick('name');
									}, style: Object.assign({}, this.state.sortColumn === 'name' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { width: '23%' }) },
								'Website Name',
								this.sortIcon('name')
							),
							_react2.default.createElement(
								'th',
								{ onClick: function onClick() {
										return _this3.handleHeaderClick('domain');
									}, style: Object.assign({}, this.state.sortColumn === 'domain' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { width: '25%' }) },
								'Website Domain',
								this.sortIcon('domain')
							),
							_react2.default.createElement(
								'th',
								{ onClick: function onClick() {
										return _this3.handleHeaderClick('id');
									}, style: Object.assign({}, this.state.sortColumn === 'id' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { width: '19%' }) },
								'Insights Tag ID',
								this.sortIcon('id')
							),
							_react2.default.createElement(
								'th',
								{ style: Object.assign({}, this.state.sortColumn === 'type' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { cursor: 'default', width: '18%' }) },
								'Tag Deployment Type',
								this.sortIcon('type')
							),
							_react2.default.createElement(
								'th',
								{ onClick: function onClick() {
										return _this3.handleHeaderClick('created_date');
									}, style: Object.assign({}, this.state.sortColumn === 'created_date' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, { width: '15%' }) },
								'Tag Creation Date',
								this.sortIcon('created_date')
							)
						)
					),
					_react2.default.createElement(
						'tbody',
						null,
						(0, _lodash.map)(this.state.sortOrder === 'desc' ? (0, _lodash.reverse)(tags) : tags, function (tag) {
							if (tag.deploymentType === "Web") return _react2.default.createElement(
								'tr',
								{ key: tag.uuid },
								_react2.default.createElement(
									'td',
									{ style: styles.tableTd },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick(e) {
												e.preventDefault();_this3.props.getTagDetail(client_info.id, tag.id, redirectUrl);
											} },
										tag.siteName
									)
								),
								_react2.default.createElement(
									'td',
									{ style: styles.tableTd },
									tag.domain
								),
								_react2.default.createElement(
									'td',
									{ style: styles.tableTd },
									_react2.default.createElement(
										'div',
										{ className: 'ellipse-cell', 'data-text': tag.uuid },
										tag.uuid
									)
								),
								_react2.default.createElement(
									'td',
									{ style: styles.tableTd },
									'Web Property'
								),
								_react2.default.createElement(
									'td',
									{ style: styles.tableTd },
									(0, _moment2.default)(tag.createdDatetime, 'x').format('MM/D/YY')
								)
							);
						})
					)
				);
			}
		}]);
	
		return WebTagsTable;
	}(_MaterialUI2.default);
	
	exports.default = WebTagsTable;

/***/ },
/* 528 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var workercode = function workercode() {
	
	  self.onmessage = function (e) {
	    var reader = new FileReader();
	    reader.readAsDataURL(e.data);
	    reader.onload = function () {
	      self.postMessage(reader.result);
	    };
	  };
	};
	
	var code = workercode.toString();
	code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
	
	var blob = new Blob([code], { type: "application/javascript" });
	var worker_script = URL.createObjectURL(blob);
	
	exports.default = worker_script;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MySettingsNavigator = function (_AcquireWebComponent) {
	  _inherits(MySettingsNavigator, _AcquireWebComponent);
	
	  function MySettingsNavigator() {
	    _classCallCheck(this, MySettingsNavigator);
	
	    return _possibleConstructorReturn(this, (MySettingsNavigator.__proto__ || Object.getPrototypeOf(MySettingsNavigator)).apply(this, arguments));
	  }
	
	  _createClass(MySettingsNavigator, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeIndex = _props.activeIndex,
	          client = _props.client;
	
	      var showInsightsFileSetup = client && client.subscription && client.subscription.name.toLowerCase().indexOf("basic") < 0;
	      /*
	      switch(activeIndex){
	      case 1:
	      return (
	      	<div className="page-navigation">
	      		<div className='pull-left page-nav-tab pl-20 text-left pr-20'>
	      			<strong><Link to="/settings/tags/list">TAGS</Link></strong>
	      		</div>
	      		{
	      			showInsightsFileSetup && 
	      			<div className="pull-left page-nav-tab-active ">
	      				<strong>INSIGHTS FILE SETUP</strong>
	      			</div>
	      		}
	      	</div>
	      )
	      default:
	      return (
	      	<div className="page-navigation">
	      		<div className='pull-left page-nav-tab-active'>
	      			<strong>Tags</strong>
	      		</div>
	      		{
	      			showInsightsFileSetup && 
	      				<div className="pull-left page-nav-tab pl-20 text-left pr-20">
	      				<strong><Link to="/settings/insights" >Insights File Setup</Link></strong>
	      			</div>
	      		}
	      	</div>
	      )
	      }*/
	      return _react2.default.createElement(
	        "div",
	        { id: "left-nav", style: { flex: "0 0 290px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border" },
	          _react2.default.createElement(
	            "div",
	            {
	              onClick: function onClick() {
	                _this2.props.history.push("/settings/tags/list?cid=" + _this2.props.selected_client);
	              },
	              style: { height: "58px", padding: "15px 20px 15px 35px" },
	              className: activeIndex !== 1 ? "tag-settings-type-active" : "tag-settings-type"
	            },
	            "Tags"
	          ),
	          showInsightsFileSetup && _react2.default.createElement(
	            "div",
	            {
	              onClick: function onClick() {
	                _this2.props.history.push("/settings/insights?cid=" + _this2.props.selected_client);
	              },
	              style: { height: "58px", padding: "15px 20px 15px 35px" },
	              className: activeIndex === 1 ? "tag-settings-type-active" : "tag-settings-type"
	            },
	            "Consumer Address File Setup"
	          )
	        )
	      );
	    }
	  }]);
	
	  return MySettingsNavigator;
	}(_MaterialUI2.default);
	
	exports.default = MySettingsNavigator;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LimitExceededForm = function (_AcquireWebComponent) {
		_inherits(LimitExceededForm, _AcquireWebComponent);
	
		function LimitExceededForm(props) {
			_classCallCheck(this, LimitExceededForm);
	
			var _this = _possibleConstructorReturn(this, (LimitExceededForm.__proto__ || Object.getPrototypeOf(LimitExceededForm)).call(this, props));
	
			_this.state = {
				comments: "",
				subject: ""
			};
			return _this;
		}
	
		_createClass(LimitExceededForm, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props = this.props,
				    showSaveErrorDialog = _props.showSaveErrorDialog,
				    showSuccessForm = _props.showSuccessForm,
				    openContactForm = _props.openContactForm,
				    history = _props.history,
				    roleId = _props.roleId,
				    openContactFormClick = _props.openContactFormClick,
				    onContactFormSubmit = _props.onContactFormSubmit,
				    send_assist_request_error = _props.send_assist_request_error;
	
				var actionButtons = [send_assist_request_error && _react2.default.createElement(
					'div',
					{ className: 'pull-left ml-20 mt-5', style: { fontWeight: "bold", color: "#FF0000" } },
					send_assist_request_error
				), _react2.default.createElement(
					'button',
					{ onClick: function onClick(e) {
							e.preventDefault();history.push("/segments/list/active");
						}, className: 'btn btn-default btn-aa-info mr-10' },
					'Cancel'
				), (0, _isEmpty2.default)(this.state.comments) || (0, _isEmpty2.default)(this.state.subject) ? _react2.default.createElement(
					'button',
					{ disabled: true, className: 'btn btn-default btn-aa-info mr-10' },
					'Submit'
				) : _react2.default.createElement(
					'button',
					{ onClick: function onClick(e) {
							onContactFormSubmit(e, _this2.state.subject, _this2.state.comments);
						}, className: 'btn btn-aa-default mr-10' },
					'Submit'
				)];
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_Dialog2.default,
						{ open: showSaveErrorDialog, style: { top: '-1.8em' }, modal: true, contentStyle: { width: "500px" }, bodyStyle: { width: "500px", padding: "20px" },
							overlayStyle: { opacity: 0.9, backgroundColor: '#666666' } },
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'no-margin no-padding-top no-padding-right', key: 'content-row',
								style: { fontSize: '16px', color: "#000", fontFamily: "Arial" } },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '12', sm: '12', md: '12', lg: '12', className: 'no-padding-right' },
								_react2.default.createElement(_error2.default, { style: { position: "absolute", left: "-20px" }, color: '#FF0000' }),
								_react2.default.createElement(
									'strong',
									{ key: 'error-text' },
									'You have reached your saved audience segment limit for the Basic subscription tier. In order to save more segments, you must upgrade your account. ',
									roleId >= 51 && [_react2.default.createElement(
										'a',
										{ key: 'btn-open-contact-form', className: 'contact-request-link', onClick: openContactFormClick.bind(this), href: '#' },
										'Click here'
									), " to contact your client services representative to discuss upgrading your account."]
								)
							)
						),
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-margin no-padding text-center', key: 'button-row' },
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: function onClick() {
										history.push("/segments/list/active");
									}, className: 'btn btn-default btn-aa-info' },
								'Cancel'
							)
						)
					),
					_react2.default.createElement(
						_Dialog2.default,
						{ open: showSuccessForm,
							contentStyle: { width: "350px", padding: '20px' },
							modal: true },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '16px', fontFamily: "Arial", color: "#000" }, className: 'text-center' },
							'Your message has been sent.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'text-center mt-20' },
							_react2.default.createElement(
								'button',
								{ className: 'btn btn-aa-default', onClick: function onClick() {
										history.push("/segments/list/active");
									} },
								'CLOSE'
							)
						)
					),
					_react2.default.createElement(
						_Dialog2.default,
						{ open: openContactForm,
							contentStyle: { width: "540px" },
							titleClassName: "support-form-title",
							bodyClassName: "support-form-body",
							actionsContainerClassName: "support-form-action-container",
							title: "CONTACT US",
							modal: true, actions: actionButtons },
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'no-padding-left no-padding-right no-padding-bottom pt-10 no-margin-bottom' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'pt-10' },
								_react2.default.createElement(
									'strong',
									null,
									'Subject'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '9', sm: '9', md: '9', lg: '9' },
								_react2.default.createElement('input', { type: 'text', style: { width: "100%" }, value: this.state.subject, maxLength: '65',
									onChange: function onChange(e) {
										_this2.setState({ subject: e.target.value });
									} })
							)
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'no-padding-left no-padding-right no-padding-bottom no-margin-bottom' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'pt-10' },
								_react2.default.createElement(
									'strong',
									null,
									'Comments'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '9', sm: '9', md: '9', lg: '9' },
								_react2.default.createElement('textarea', { className: 'comment-box', value: this.state.comments, maxLength: '500',
									onChange: function onChange(e) {
										_this2.setState({ comments: e.target.value });
									} })
							)
						)
					)
				);
			}
		}]);
	
		return LimitExceededForm;
	}(_MaterialUI2.default);
	
	LimitExceededForm.defaultProps = {
		showSaveErrorDialog: false,
		showSuccessForm: false,
		openContactForm: false
	};
	exports.default = LimitExceededForm;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(38);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _RadioButton = __webpack_require__(107);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _clear = __webpack_require__(109);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// css
	
	
	var styles = {
	  iconStyle: {
	    fill: "#000000",
	    transform: "scale(0.8)",
	    WebkitTransform: "scale(0.8)",
	    MsTransform: "scale(0.8)",
	    MozTransform: "scale(0.8)",
	    marginRight: "0"
	  },
	  radioButton: {
	    width: "15px",
	    fill: "#000000"
	  },
	  labelStyle: {
	    fontSize: "13px",
	    marginBottom: 0,
	    fontWeight: "bold"
	  }
	};
	
	var CreateCampaign = function (_Component) {
	  _inherits(CreateCampaign, _Component);
	
	  function CreateCampaign(props) {
	    _classCallCheck(this, CreateCampaign);
	
	    var _this = _possibleConstructorReturn(this, (CreateCampaign.__proto__ || Object.getPrototypeOf(CreateCampaign)).call(this, props));
	
	    _this.throttle = true;
	    _this.arr = new Set([]); // for hashType record
	    _this.state = {
	      ifCreateButtonEnable: false,
	      ifCaseNumberEnable: false,
	      ifShowButtonTip: false,
	      createCampaignData: {
	        clientId: "",
	        caseNumber: "",
	        emailChannelEnabled: false,
	        socialChannelEnabled: false,
	        displayChannelEnabled: false,
	        directMailChannelEnabled: false,
	        segmentId: ""
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CreateCampaign, [{
	    key: "closeDialog",
	    value: function closeDialog() {
	      this.props.closeCreateCampaignDialog();
	      // rollback
	      this.props.rollbackRequestSuccessToFalse(false);
	      this.throttle = true; // set throttle to true, which button can be clicked.
	      this.arr = new Set([]);
	      this.setState({
	        ifCreateButtonEnable: false,
	        ifShowButtonTip: false,
	        createCampaignData: {
	          clientId: "",
	          caseNumber: "",
	          emailChannelEnabled: false,
	          socialChannelEnabled: false,
	          displayChannelEnabled: false,
	          directMailChannelEnabled: false,
	          segmentId: ""
	        }
	      });
	    }
	  }, {
	    key: "handleDirectMail",
	    value: function handleDirectMail(e, isInputChecked) {
	      var _this2 = this;
	
	      this.setState({
	        createCampaignData: Object.assign({}, this.state.createCampaignData, {
	          directMailChannelEnabled: isInputChecked
	        })
	      }, function () {
	        _this2.setState({
	          ifCreateButtonEnable: _this2.ifButtonEnable()
	        });
	      });
	    }
	  }, {
	    key: "handleEmailChecked",
	    value: function handleEmailChecked(e, isInputChecked) {
	      var _this3 = this;
	
	      if (!isInputChecked) {
	        this.setState({
	          createCampaignData: Object.assign({}, this.state.createCampaignData, {
	            emailChannelEnabled: isInputChecked
	          })
	        }, function () {
	          _this3.setState({
	            ifCreateButtonEnable: _this3.ifButtonEnable()
	          });
	        });
	      } else {
	        this.setState({
	          createCampaignData: Object.assign({}, this.state.createCampaignData, {
	            emailChannelEnabled: isInputChecked
	          })
	        }, function () {
	          _this3.setState({
	            ifCreateButtonEnable: _this3.ifButtonEnable()
	          });
	        });
	      }
	
	      this.props.handleEmailChecked(e, isInputChecked);
	    }
	  }, {
	    key: "handleSocialMedia",
	    value: function handleSocialMedia(e, isInputChecked) {
	      var _this4 = this;
	
	      e.stopPropagation();
	      if (!isInputChecked) {
	        this.setState({
	          createCampaignData: Object.assign({}, this.state.createCampaignData, {
	            socialChannelEnabled: isInputChecked
	          })
	        }, function () {
	          _this4.setState({
	            ifCreateButtonEnable: _this4.ifButtonEnable()
	          });
	        });
	      } else {
	        this.setState({
	          createCampaignData: Object.assign({}, this.state.createCampaignData, {
	            socialChannelEnabled: isInputChecked
	          })
	        }, function () {
	          _this4.setState({
	            ifCreateButtonEnable: _this4.ifButtonEnable()
	          });
	        });
	      }
	
	      this.props.handleSocialMedia(e, isInputChecked);
	    }
	  }, {
	    key: "handleDisplayCheck",
	    value: function handleDisplayCheck(e, isInputChecked) {
	      var _this5 = this;
	
	      this.setState({
	        createCampaignData: Object.assign({}, this.state.createCampaignData, {
	          displayChannelEnabled: isInputChecked
	        })
	      }, function () {
	        _this5.setState({
	          ifCreateButtonEnable: _this5.ifButtonEnable()
	        });
	      });
	
	      this.props.handleDisplayCheck(e, isInputChecked);
	    }
	  }, {
	    key: "handleOrderNumberKeyUp",
	    value: function handleOrderNumberKeyUp() {
	      var _this6 = this;
	
	      if (!(0, _lodash.isEmpty)(this.refs.orderNumber.value) && /^\d{8}$/g.test(this.refs.orderNumber.value)) {
	        this.setState(Object.assign({}, this.state, {
	          ifCaseNumberEnable: true
	        }), function () {
	          _this6.setState({
	            ifCreateButtonEnable: _this6.ifButtonEnable()
	          });
	        });
	      } else {
	        this.setState({
	          ifCreateButtonEnable: false
	        });
	      }
	    }
	
	    // call api
	
	  }, {
	    key: "createCampaign",
	    value: function createCampaign() {
	      var _this7 = this;
	
	      if (this.throttle) {
	        this.throttle = false;
	        this.setState({
	          createCampaignData: Object.assign({}, this.state.createCampaignData, {
	            clientId: this.props.createCampaign_clientId,
	            segmentId: this.props.createCampaign_segment_id,
	            caseNumber: this.refs.orderNumber.value
	          })
	        }, function () {
	          _this7.props.getCreateCampaign(_this7.props.createCampaign_segment_id, _this7.state.createCampaignData);
	        });
	        window.setTimeout(function () {
	          _this7.throttle = true;
	        }, 500);
	      }
	    }
	  }, {
	    key: "ifButtonEnable",
	    value: function ifButtonEnable() {
	      var _state$createCampaign = this.state.createCampaignData,
	          emailChannelEnabled = _state$createCampaign.emailChannelEnabled,
	          displayChannelEnabled = _state$createCampaign.displayChannelEnabled,
	          socialChannelEnabled = _state$createCampaign.socialChannelEnabled,
	          directMailChannelEnabled = _state$createCampaign.directMailChannelEnabled;
	
	      if (!(0, _lodash.isEmpty)(this.refs.orderNumber.value) && /^\d{8}$/g.test(this.refs.orderNumber.value)) {
	        if ((emailChannelEnabled || displayChannelEnabled || socialChannelEnabled || directMailChannelEnabled) && this.state.ifCaseNumberEnable) {
	          return true;
	        } else {
	          return false;
	        }
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "create-campaign-wrapper" },
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            open: this.props.openCreateCampaignDialog,
	            modal: false,
	            autoScrollBodyContent: true,
	            autoDetectWindowHeight: true,
	            repositionOnUpdate: false,
	            contentStyle: { width: "60%", minWidth: "600px" },
	            bodyStyle: { padding: "20px" }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "create-campaign-outer",
	              style: {
	                display: this.props.create_campaign && this.props.create_campaign.ifRequestSuccess ? "none" : "block"
	              }
	            },
	            _react2.default.createElement(
	              "h2",
	              { className: "create-campaign-h2" },
	              "CREATE AN AUDIENCE FILE"
	            ),
	            _react2.default.createElement(
	              "h3",
	              { className: "create-campaign-h3" },
	              "Select a Campaign Type:"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "create-campaign-wrapper" },
	              _react2.default.createElement(
	                "div",
	                { className: "selection" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "email" },
	                  _react2.default.createElement(_Checkbox2.default, {
	                    label: "Direct Mail",
	                    onCheck: function onCheck(e, isInputChecked) {
	                      return _this8.handleDirectMail(e, isInputChecked);
	                    },
	                    iconStyle: styles.iconStyle,
	                    labelStyle: styles.labelStyle
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "social" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "main" },
	                    _react2.default.createElement(_Checkbox2.default, {
	                      label: "Social",
	                      onCheck: function onCheck(e, isInputChecked) {
	                        return _this8.handleSocialMedia(e, isInputChecked);
	                      },
	                      checked: this.props.ifSocialMediaChecked,
	                      iconStyle: styles.iconStyle,
	                      labelStyle: styles.labelStyle
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "display" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "main" },
	                    _react2.default.createElement(_Checkbox2.default, {
	                      label: "Display",
	                      onCheck: function onCheck(e, isInputChecked) {
	                        return _this8.handleDisplayCheck(e, isInputChecked);
	                      },
	                      checked: this.props.ifDisplayChecked,
	                      iconStyle: styles.iconStyle,
	                      labelStyle: styles.labelStyle
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "email" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "main" },
	                    _react2.default.createElement(_Checkbox2.default, {
	                      label: "Email",
	                      onCheck: function onCheck(e, isInputChecked) {
	                        return _this8.handleEmailChecked(e, isInputChecked);
	                      },
	                      iconStyle: styles.iconStyle,
	                      labelStyle: styles.labelStyle
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "common-input" },
	                _react2.default.createElement(
	                  "label",
	                  { htmlFor: "" },
	                  _react2.default.createElement(
	                    "span",
	                    { style: { color: 'red' } },
	                    "*"
	                  ),
	                  "Enter Case Number"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  ref: "orderNumber",
	                  onKeyUp: function onKeyUp() {
	                    return _this8.handleOrderNumberKeyUp();
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "clearfix",
	                  style: {
	                    display: this.props.create_campaign && (0, _lodash.isEmpty)(this.props.create_campaign.error_payload) ? "none" : "block"
	                  }
	                },
	                _react2.default.createElement(
	                  "p",
	                  { style: { color: "red", fontSize: "12px", marginTop: "1em" } },
	                  this.props.create_campaign && this.props.create_campaign.error_payload
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "btns clearfix" },
	                _react2.default.createElement(
	                  "section",
	                  {
	                    style: {
	                      display: this.state.ifShowButtonTip ? "block" : "none"
	                    }
	                  },
	                  "You must choose at least one checkbox to continue."
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-default btn-aa-default pull-right",
	                    onClick: function onClick(e) {
	                      _this8.createCampaign();
	                    },
	                    disabled: !this.state.ifCreateButtonEnable
	                  },
	                  "CREATE AUDIENCE FILE"
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "pull-right btn btn-aa-info mr-20",
	                    onClick: function onClick(e) {
	                      _this8.closeDialog();
	                    }
	                  },
	                  "CANCEL"
	                )
	              )
	            ),
	            _react2.default.createElement(_clear2.default, {
	              style: {
	                position: "absolute",
	                right: "0em",
	                cursor: "pointer",
	                top: "-0.5em"
	              },
	              onClick: function onClick() {
	                return _this8.closeDialog();
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "section",
	            {
	              style: {
	                padding: "2em 6em",
	                position: "relative",
	                display: this.props.create_campaign && this.props.create_campaign.ifRequestSuccess ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  fontWeight: "bolder",
	                  color: "black",
	                  fontSize: "18px",
	                  display: this.props.create_campaign && this.props.create_campaign.error ? "none" : "block"
	                }
	              },
	              "We are now preparing your audience file. ",
	              _react2.default.createElement("br", null),
	              "You will soon receive an email when it's ready."
	            ),
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  fontWeight: "bolder",
	                  color: "black",
	                  fontSize: "18px",
	                  display: this.props.create_campaign && this.props.create_campaign.error ? "block" : "none"
	                }
	              },
	              this.props.create_campaign && this.props.create_campaign.error_payload
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", marginTop: "2em" } },
	              _react2.default.createElement(_FlatButton2.default, {
	                label: "CANCEL",
	                style: { color: "black", border: "1px solid black" },
	                backgroundColor: "#FFFFFF",
	                hoverColor: "#FFFFFF",
	                onClick: function onClick() {
	                  return _this8.closeDialog();
	                }
	              })
	            ),
	            _react2.default.createElement(_clear2.default, {
	              style: {
	                position: "absolute",
	                right: "2em",
	                cursor: "pointer",
	                top: "-0.5em"
	              },
	              onClick: function onClick() {
	                return _this8.closeDialog();
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateCampaign;
	}(_react.Component);
	
	exports.default = CreateCampaign;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _modeEdit = __webpack_require__(719);
	
	var _modeEdit2 = _interopRequireDefault(_modeEdit);
	
	var _input = __webpack_require__(716);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _archive = __webpack_require__(717);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	var _create = __webpack_require__(718);
	
	var _create2 = _interopRequireDefault(_create);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NavList component
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author chargoyao
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop handleActiveRedirectCreate {function} required click redirect to `edit segment`.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @notice need param the id of segment
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * handleActiveRedirectCreate={() => this.handleActiveRedirectCreate(segmentId)}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop popoutTip {function} required archive segment popout function
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop popout {boolean} required if display the confirmation for segment popout.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop handleConfirmArchive {function} required when user click the button for `confirm archive`.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @notice need param, the id of segment
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * handleConfirmArchive={() => this.handleConfirmArchive(segmentId)}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop handleCancelArchive {function} required when user click `cancel` button. not to archive segment.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop createCampaignPopover {function} create campaign popover function.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @notice need params, segment'id and segment's clientId
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * createCampaignPopover={() => this.createCampaignPopover(segmentId, clientId)}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop _handleDownloadPDF {function} download pdf
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @notice need four params, segment_summary, segment_attributes, demoAttributes, geoAttributes
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @exapmle
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * _handleDownloadPDF={() => this._handleDownloadPDF(segment_summary, segment_attributes, demoAttributes, geoAttributes)}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop ifShowPdfDownload {boolean}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var NavList = function (_Component) {
	  _inherits(NavList, _Component);
	
	  function NavList() {
	    _classCallCheck(this, NavList);
	
	    return _possibleConstructorReturn(this, (NavList.__proto__ || Object.getPrototypeOf(NavList)).apply(this, arguments));
	  }
	
	  _createClass(NavList, [{
	    key: 'popoutTip',
	    value: function popoutTip() {
	      this.props.popoutTip();
	    }
	  }, {
	    key: 'handleActiveRedirectCreate',
	    value: function handleActiveRedirectCreate() {
	      this.props.handleActiveRedirectCreate();
	    }
	  }, {
	    key: 'handleConfirmArchive',
	    value: function handleConfirmArchive() {
	      this.props.handleConfirmArchive();
	    }
	  }, {
	    key: 'handleCancelArchive',
	    value: function handleCancelArchive() {
	      this.props.handleCancelArchive();
	    }
	  }, {
	    key: 'createCampaignPopover',
	    value: function createCampaignPopover() {
	      this.props.createCampaignPopover();
	    }
	  }, {
	    key: '_handleDownloadPDF',
	    value: function _handleDownloadPDF() {
	      this.props._handleDownloadPDF();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'ul',
	        { style: { margin: 0, padding: 0, display: this.props.visible === true ? "block" : "none" } },
	        _react2.default.createElement(
	          'li',
	          { style: { listStyleType: 'none', padding: '1em' }, className: 'clearfix' },
	          _react2.default.createElement(_modeEdit2.default, { style: { float: 'left', width: '16px', height: '16px', marginRight: '0.6em' } }),
	          _react2.default.createElement(
	            'a',
	            { style: { color: '#0997F7', float: 'left' }, onClick: function onClick() {
	                return _this2.handleActiveRedirectCreate();
	              } },
	            'Edit this segment'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { style: { listStyleType: 'none', padding: '1em', paddingTop: 0, display: this.props.ifShowPdfDownload ? 'block' : 'none' }, className: 'clearfix' },
	          _react2.default.createElement(_input2.default, {
	            style: { float: 'left', width: '16px', height: '16px', marginRight: '0.6em' }
	          }),
	          _react2.default.createElement(
	            'a',
	            { style: { color: '#0997F7', float: 'left', lineHeight: '1.3em' },
	              onClick: function onClick(e) {
	                e.preventDefault();return _this2._handleDownloadPDF();
	              } },
	            'Download as a PDF'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { style: { listStyleType: 'none', position: 'relative', padding: '1em', paddingTop: 0 },
	            className: 'clearfix', onClick: function onClick() {
	              return _this2.popoutTip();
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'clearfix' },
	            _react2.default.createElement(_archive2.default, {
	              style: { float: 'left', width: '16px', height: '16px', marginRight: '0.6em' }
	            }),
	            _react2.default.createElement(
	              'a',
	              { style: { color: '#0997F7', float: 'left' } },
	              'Archive this segment'
	            )
	          )
	        ),
	        /^(system administrator|operations manager)/gi.test(this.props.roleName) && _react2.default.createElement(
	          'li',
	          { style: { listStyleType: 'none', position: 'relative', padding: '1em', paddingTop: 0 },
	            className: 'clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'clearfix' },
	            _react2.default.createElement(_create2.default, {
	              style: { float: 'left', width: '16px', height: '16px', marginRight: '0.6em' }
	            }),
	            _react2.default.createElement(
	              'a',
	              { style: { color: '#0997F7', float: 'left' }, onClick: function onClick() {
	                  return _this2.createCampaignPopover();
	                } },
	              'Create an Audience',
	              _react2.default.createElement('br', null),
	              'File'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.popout ? "archive-tips active" : "archive-tips" },
	          _react2.default.createElement(
	            'p',
	            { style: { padding: 0, margin: 0 } },
	            'Are you sure you want to archive this segment ?'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'confirm', onClick: function onClick() {
	                return _this2.handleConfirmArchive();
	              } },
	            'Yes, archive this'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'concel', onClick: function onClick() {
	                return _this2.handleCancelArchive();
	              } },
	            'Cancel'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavList;
	}(_react.Component);
	
	NavList.propTypes = {
	  visible: _propTypes2.default.bool.isRequired,
	  popoutTip: _propTypes2.default.func.isRequired,
	  handleActiveRedirectCreate: _propTypes2.default.func.isRequired,
	  popout: _propTypes2.default.bool.isRequired,
	  handleConfirmArchive: _propTypes2.default.func.isRequired,
	  handleCancelArchive: _propTypes2.default.func.isRequired,
	  createCampaignPopover: _propTypes2.default.func.isRequired,
	  _handleDownloadPDF: _propTypes2.default.func.isRequired
	};
	
	exports.default = NavList;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Table = __webpack_require__(236);
	
	var _materialUi = __webpack_require__(38);
	
	var _getMuiTheme = __webpack_require__(108);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _settings = __webpack_require__(433);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(18);
	
	var _clear = __webpack_require__(109);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _utility = __webpack_require__(14);
	
	var _Grid = __webpack_require__(19);
	
	var _SegmentSummary = __webpack_require__(1150);
	
	var _SegmentSummary2 = _interopRequireDefault(_SegmentSummary);
	
	var _NavList = __webpack_require__(532);
	
	var _NavList2 = _interopRequireDefault(_NavList);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _RadioButton = __webpack_require__(107);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _env = __webpack_require__(85);
	
	__webpack_require__(124);
	
	__webpack_require__(221);
	
	var _CreateCampaign = __webpack_require__(531);
	
	var _CreateCampaign2 = _interopRequireDefault(_CreateCampaign);
	
	var _Page = __webpack_require__(103);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/*import ContentCopy from 'material-ui/svg-icons/content/content-copy';*/
	
	// create campaign component
	
	
	// page component
	
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	var styles = {
	  tableHeaderStyle: {
	    background: "#F5F5F5",
	    borderTop: "0px solid #E8EBEF",
	    borderBottom: "0px solid #E8EBEF"
	  },
	  arrowStyle: {
	    position: "absolute",
	    top: "10px"
	  },
	  tableHeaderColumn: {
	    height: "50px",
	    color: "#000",
	    cursor: "pointer",
	    fontWeight: "bolder",
	    paddingLeft: "10px",
	    paddingRight: "10px",
	    fontSize: "16px"
	  },
	  tableHeaderSortedColumn: {
	    height: "50px",
	    color: "#000",
	    cursor: "pointer",
	    fontWeight: "bolder",
	    background: "#E3E3E3",
	    paddingLeft: "10px",
	    paddingRight: "10px",
	    backgroundClip: "padding-box",
	    fontSize: "16px"
	  },
	  tableRowColumn: {
	    position: "relative",
	    paddingRight: "10px",
	    paddingLeft: "10px",
	    height: "50px",
	    fontSize: "16px",
	    paddingTop: "5px",
	    paddingBottom: "5px"
	  },
	  tableCountRowColumn: {
	    position: "relative",
	    paddingRight: "10px",
	    paddingLeft: "10px",
	    fontSize: "16px"
	  },
	  settingStyle: {
	    position: "absolute",
	    right: "1.1em",
	    top: "0.9em",
	    cursor: "pointer"
	  }
	};
	
	var SegmentTable = function (_Component) {
	  _inherits(SegmentTable, _Component);
	
	  function SegmentTable(props) {
	    _classCallCheck(this, SegmentTable);
	
	    var _this = _possibleConstructorReturn(this, (SegmentTable.__proto__ || Object.getPrototypeOf(SegmentTable)).call(this, props));
	
	    _this.handleClose = function () {
	      _this.setState({ open: false });
	    };
	
	    _this.state = {
	      pageCount: [1, 2, 3, 4, 5, 6],
	      activeIndex: 1, //record pageNumber
	      ifHasNextGroup: true, // next button display control, default has next group icon
	      ifHasPreGroup: false, // previous button display control, default no previous group icon
	      popout: false, // popout archive tips
	      archivedId: "",
	      openDetailDialog: false,
	      detailSegmentId: 0,
	      open: false, // if open dialog
	      archive_data_obj: {}, // for copy segment
	      openCreateCampaignDialog: false,
	      ifShowEmailSubCheckbox: false, // when email checkbox is selected change the value to `true`
	      ifSocialMediaChecked: false, // when `Social Media` checkbox is selected set value to `true`
	      socialMediaFacebook: false, // when `the social media's selection facebook` checkbox is selected set value to `true`
	      socialMediaGoogle: false, // when `the social media's selection google` checkbox is selected set value to `true`
	      ifDisplayChecked: false, // when `Display Advertising` checkbox is selected set value to `true`
	      createCampaign_segment_id: "",
	      createCampaign_clientId: "", // the client id for create campaign component
	      showLoadingDialog: false,
	      showDataLoadingDialog: false,
	      segmentsId: new Set([]) // set data for checkbox selected
	    };
	    return _this;
	  }
	
	  _createClass(SegmentTable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var width = document.getElementById("tbl-segments-list").clientWidth;
	      this.setState({ width: width });
	
	      // if pageCount less than six show pageCount length
	
	      // console.log(this.props.data.pageCount)
	      // if (this.props.data.pageCount <= this.state.pageCount.length) {
	      //   let len = this.props.data.pageCount;
	      //   let obj = [];
	      //   for (let i = 0; i < len; i++) {
	      //     obj.push(i + 1)
	      //   }
	      //   this.setState({
	      //     pageCount: obj,
	      //     ifHasNextGroup: false
	      //   })
	      // }
	      if (this.props.save_segment_report_id) {
	        this.showSegmentDetail(+this.props.save_segment_report_id);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var client_id = "";
	      if (!nextProps.selectedSegmentSetArray || nextProps.selectedSegmentSetArray.length === 0) {
	        // if selectedSegmentSetArray lenght is 0 clear state data
	        if (this.props.flag !== "archive") {
	          this.setState({
	            segmentsId: new Set([])
	          });
	        }
	      }
	      if (nextProps.ifCreateAudienceFile) {
	        nextProps.data.data.map(function (item) {
	          if (item.id === nextProps.selectedSegmentSetArray[0]) {
	            client_id = item.clientId;
	          }
	
	          return false;
	        });
	        this.setState({
	          openCreateCampaignDialog: true,
	          createCampaign_segment_id: nextProps.selectedSegmentSetArray[0],
	          createCampaign_clientId: client_id
	        });
	      }
	      var initPageCount = [1, 2, 3, 4, 5, 6];
	      if (nextProps.data.pageCount <= initPageCount.length) {
	        var len = nextProps.data.pageCount;
	        var obj = [];
	        for (var i = 0; i < len; i++) {
	          obj.push(i + 1);
	        }
	        this.setState({
	          pageCount: obj,
	          ifHasNextGroup: false
	        });
	      }
	      // if (nextProps.data.pageCount > initPageCount.length) {
	      //   this.setState({
	      //     pageCount: [1,2,3,4,5,6],
	      //     ifHasNextGroup: true
	      //   })
	      // }
	      if (nextProps.ifArchiveSuccess) {
	        this.setState({
	          ifMaterialUIpopout: true
	        });
	      }
	      if (!(0, _lodash.isEmpty)(nextProps.copy_segment)) {
	        var rawData = JSON.parse(nextProps.copy_segment.rawData);
	        nextProps.segment_edit_creation.selected_segments = rawData.selected_segments;
	        nextProps.segment_edit_creation.plotted_values = rawData.plotted_values;
	        nextProps.segment_edit_creation.selected_city = rawData.selected_city;
	        nextProps.segment_edit_creation.selected_state = rawData.selected_state;
	        nextProps.segment_edit_creation.selected_county = rawData.selected_county;
	        nextProps.segment_edit_creation.selected_dma = rawData.selected_dma;
	
	        nextProps.segment_edit_creation.zipcode = rawData.zipcode;
	        nextProps.segment_edit_creation.segment_name = rawData.name;
	        nextProps.copy_segment.rules.forEach(function (item) {
	          nextProps.segment_edit_creation.rules_id.push({
	            id: item.id,
	            attributeId: item.attributeId
	          });
	        });
	        nextProps.segment_edit_creation.segment_id = nextProps.copy_segment.id;
	      }
	      // for active edit segment link
	      if (!(0, _lodash.isEmpty)(nextProps.active_segment_attributes)) {
	        var _rawData = JSON.parse(nextProps.active_segment_attributes.rawData);
	        nextProps.segment_active_creation.selected_segments = _rawData.selected_segments;
	        nextProps.segment_active_creation.plotted_values = _rawData.plotted_values;
	        nextProps.segment_active_creation.selected_city = _rawData.selected_city;
	        nextProps.segment_active_creation.selected_state = _rawData.selected_state;
	        nextProps.segment_active_creation.selected_county = _rawData.selected_county;
	        nextProps.segment_active_creation.selected_dma = _rawData.selected_dma;
	        nextProps.segment_active_creation.zipcode = _rawData.zipcode;
	        nextProps.segment_active_creation.segment_name = _rawData.name;
	        nextProps.active_segment_attributes.rules.forEach(function (item) {
	          nextProps.segment_active_creation.rules_id.push({
	            id: item.id,
	            attributeId: item.attributeId
	          });
	        });
	        nextProps.segment_active_creation.segment_id = nextProps.active_segment_attributes.id;
	      }
	    }
	  }, {
	    key: "initPageArray",
	    value: function initPageArray(obj) {
	      if (obj.data.pageCount <= this.state.pageCount.length) {
	        var len = obj.data.pageCount;
	        var _obj = [];
	        for (var i = 0; i < len; i++) {
	          _obj.push(i + 1);
	        }
	        this.setState({
	          pageCount: _obj,
	          ifHasNextGroup: false
	        });
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(e) {
	      this.props.headerBeClick(e.target.innerText, this.state.activeIndex);
	    }
	  }, {
	    key: "handleClickPage",
	    value: function handleClickPage(page) {
	      this.props.pageBeClick(page);
	      this.setState({
	        activeIndex: page
	      });
	    }
	  }, {
	    key: "goToNext",
	    value: function goToNext(page) {
	      // if activeIndex greater than total return
	      this.props.nextBeClick(page);
	      this.setState({
	        activeIndex: page
	      });
	    }
	  }, {
	    key: "nextToGroup",
	    value: function nextToGroup(page) {
	      this.props.nextGroupBeClick(page);
	    }
	  }, {
	    key: "previousToGroup",
	    value: function previousToGroup(page) {
	      this.props.previousGroupBeClick(page);
	    }
	  }, {
	    key: "goToPrevious",
	    value: function goToPrevious(page) {
	      this.props.previousBeClick(page);
	    }
	  }, {
	    key: "selectRows",
	    value: function selectRows(page, row) {
	      this.props.selectRows(page, row);
	    }
	  }, {
	    key: "goToPage",
	    value: function goToPage(page) {
	      this.props.goToPage(page);
	    }
	  }, {
	    key: "popoutTip",
	    value: function popoutTip(e) {
	      this.setState({
	        popout: true
	      });
	    }
	    // archive segment function
	
	  }, {
	    key: "handleConfirmArchive",
	    value: function handleConfirmArchive(id) {
	      var _this2 = this;
	
	      this.setState({
	        archivedId: id
	      });
	      this.props.archiveSegment(id);
	      this.setState({
	        popout: false
	      });
	      window.setTimeout(function () {
	        _this2.setState({
	          archivedId: ""
	        }, function () {
	          _this2.props.updateSegmentList(_this2.state.activeIndex); // update segment list when archive success
	        });
	      }, 3000);
	    }
	  }, {
	    key: "handleCancelArchive",
	    value: function handleCancelArchive(e) {
	      this.setState({
	        popout: false
	      });
	    }
	  }, {
	    key: "onVisibleChange",
	    value: function onVisibleChange(visible) {
	      this.setState({
	        popout: false
	      });
	    }
	  }, {
	    key: "copySegment",
	    value: function copySegment(id) {
	      var segmentObj = this.props.data.data.find(function (x) {
	        return x.id === id;
	      });
	      this.setState({
	        open: true,
	        archive_data_obj: segmentObj
	      });
	      this.props.getAttributes(id);
	    }
	  }, {
	    key: "handleCopyToCreate",
	    value: function handleCopyToCreate(e, id, clientId, name) {
	      // get user selected attributes
	      e.stopPropagation();
	      this.setState({ showDataLoadingDialog: true });
	      this.props.selectedClientChanged(clientId);
	      this.props.copySegmentRedirect(id);
	    }
	  }, {
	    key: "handleActiveRedirectCreate",
	    value: function handleActiveRedirectCreate(id, clientId) {
	      this.setState({ showDataLoadingDialog: true, openDetailDialog: false });
	      this.props.handleActiveRedirectCreate(id, clientId);
	    }
	  }, {
	    key: "closeSegmentDetailDialog",
	    value: function closeSegmentDetailDialog() {
	      this.props.clearSegmentSummary();
	      this.setState({
	        openDetailDialog: false,
	        detailSegmentId: 0,
	        segment_summary: null
	      });
	    }
	  }, {
	    key: "closeCreateCampaignDialog",
	    value: function closeCreateCampaignDialog() {
	      this.setState({
	        openCreateCampaignDialog: false,
	        ifSocialMediaChecked: false,
	        ifDisplayChecked: false,
	        socialMediaFacebook: false, // when `the social media's selection facebook` checkbox is selected set value to `true`
	        socialMediaGoogle: false
	      });
	      // rollback ifRequestSuccess value
	      this.props.rollbackRequestSuccessToFalse(false);
	      this.props.closeCreateCampaignDialog();
	    }
	  }, {
	    key: "handleEmailChecked",
	    value: function handleEmailChecked(e, isInputChecked) {
	      // if (!isInputChecked) {
	      //   this.setState({
	      //     ifReturnEmailChecked: isInputChecked
	      //   })
	      // }
	    }
	  }, {
	    key: "handleReturnEmail",
	    value: function handleReturnEmail(e, isInputChecked) {
	      // this.setState({
	      //   ifReturnEmailChecked: isInputChecked
	      // })
	    }
	  }, {
	    key: "handleSocialMedia",
	    value: function handleSocialMedia(e, isInputChecked) {
	      this.setState({
	        ifSocialMediaChecked: isInputChecked
	      });
	      if (!isInputChecked) {
	        this.setState({
	          socialMediaFacebook: false,
	          socialMediaGoogle: false
	        });
	      } else {
	        this.setState({
	          socialMediaFacebook: true,
	          socialMediaGoogle: true
	        });
	      }
	    }
	    // handleSocialMediaAllChecked() {
	    //   this.setState({
	    //     socialMediaFacebook: true,
	    //     socialMediaGoogle: true
	    //   })
	    // }
	
	  }, {
	    key: "handleFacebookCheck",
	    value: function handleFacebookCheck(e, isInputChecked) {
	      this.setState({
	        socialMediaFacebook: isInputChecked
	      });
	    }
	  }, {
	    key: "handleGoogleCheck",
	    value: function handleGoogleCheck(e, isInputChecked) {
	      this.setState({
	        socialMediaGoogle: isInputChecked
	      });
	    }
	  }, {
	    key: "handleDisplayCheck",
	    value: function handleDisplayCheck(e, isInputChecked) {
	      this.setState({
	        ifDisplayChecked: isInputChecked
	      });
	    }
	    // handleSelectAllCheckbox() {
	    //   this.setState({
	    //     ifShowEmailSubCheckbox: true,
	    //     ifSocialMediaChecked: true,
	    //     ifDisplayChecked: true
	    //   })
	    // }
	
	  }, {
	    key: "_addSummarytoPDF",
	    value: function _addSummarytoPDF(segment, attributes, pdf) {
	      var top = 10;
	
	      pdf.setFont("helvetica");
	      pdf.setFontSize(22);
	      pdf.addImage((0, _utility.audienceAnywhereLogoDataUri)(), "png", 12, top);
	      top += 30;
	      pdf.setFontSize(12);
	      pdf.setFontType("bold");
	      pdf.text(12, top, "Audience Segment Name: ");
	      pdf.setFontType("normal");
	      pdf.text(67, top, segment.name);
	      top += 10;
	
	      var line_len = 26;
	      pdf.setFont("helvetica");
	      pdf.setFontType("normal");
	      pdf.setFontSize(10);
	
	      var strDate = "Date%%% " + (0, _moment2.default)(segment.createdTime, "x").format("MMMM D, YYYY");
	      var fillStrWidth = pdf.getStringUnitWidth(" _");
	
	      var arrReplace = [];
	      //for (let i = 0; i < (line_len - strDate.length) / 2; i++) {
	      for (var i = 0; i < (line_len - pdf.getStringUnitWidth(strDate) - 3) / fillStrWidth; i++) {
	        arrReplace.push(" _");
	      }
	      strDate = strDate.replace("%%%", arrReplace.join(""));
	      arrReplace.length = 0;
	
	      var strAttributes = "Attributes%%% " + attributes;
	      //for (let i = 0; i < (line_len - strAttributes.length) / 2; i++) {
	      for (var _i = 0; _i < (line_len - pdf.getStringUnitWidth(strAttributes) - 3) / fillStrWidth; _i++) {
	        arrReplace.push(" _");
	      }
	      strAttributes = strAttributes.replace("%%%", arrReplace.join(""));
	
	      var strClient = "Client%%% " + segment.clientName;
	      arrReplace.length = 0;
	      //for (let i = 0; i < (line_len - strClient.length) / 2; i++) {
	      for (var _i2 = 0; _i2 < (line_len - pdf.getStringUnitWidth(strClient) - 3) / fillStrWidth; _i2++) {
	        arrReplace.push(" _");
	      }
	      strClient = strClient.replace("%%%", arrReplace.join(""));
	
	      var strAudience = "Audience%%% " + (0, _utility.splitNumber)(segment.count + "")();
	      arrReplace.length = 0;
	      //		for (let i = 0; i < (line_len - strAudience.length) / 2; i++) {
	      for (var _i3 = 0; _i3 < (line_len - pdf.getStringUnitWidth(strAudience) - 3) / fillStrWidth; _i3++) {
	        arrReplace.push(" _");
	      }
	      strAudience = strAudience.replace("%%%", arrReplace.join(""));
	
	      pdf.setFontSize(10);
	      pdf.text(16, top, strDate);
	      pdf.text(190, top, strAttributes, null, null, "right");
	      top += 12;
	      pdf.text(16, top, strClient);
	      //pdf.text(190, top, strAudience, null, null, "right")
	      top += 10;
	      pdf.setDrawColor(169, 169, 169);
	      pdf.line(12, top, 200, top);
	      top += 6;
	      pdf.setDrawColor(255, 255, 255);
	      pdf.text(16, top, "Audience: " + (0, _utility.splitNumber)(segment.count + "")());
	      pdf.text(88, top, "Reach By Channel");
	      pdf.addImage((0, _utility.imageEmailUri)(), "PNG", 120, top - 3, 4, 4);
	      pdf.text(125, top, (0, _utility.splitNumber)(segment.email + "")());
	      pdf.addImage((0, _utility.imageSocialUri)(), "PNG", 146, top - 3, 4, 4);
	      pdf.text(151, top, (0, _utility.splitNumber)(segment.social + "")());
	      pdf.addImage((0, _utility.imageDispalyUri)(), "PNG", 174, top - 3, 4, 4);
	      pdf.text(179, top, (0, _utility.splitNumber)(segment.display + "")());
	
	      top += 4;
	      pdf.setDrawColor(169, 169, 169);
	      pdf.line(12, top, 200, top);
	      top += 12;
	      pdf.setDrawColor(255, 255, 255);
	
	      pdf.setFontType("bold");
	      var strTableHead = "ATTRIBUTE%%%COUNT";
	      arrReplace.length = 0;
	      for (var _i4 = 0; _i4 < 96 + 56 - strTableHead.length - 3; _i4++) {
	        arrReplace.push(" ");
	      }
	      pdf.text(16, top, strTableHead.replace("%%%", arrReplace.join("")));
	      top += 5;
	      pdf.setDrawColor(169, 169, 169);
	      pdf.line(12, top, 200, top);
	      return top;
	    }
	  }, {
	    key: "_handleDownloadListPDF",
	    value: function _handleDownloadListPDF(segment, attributes, demoAttributes, geoAttributes) {
	      var datas = this._generateSelectData(segment);
	      var geoDatas = this._generateGeographyData(segment);
	      var rawData = JSON.parse(segment.rawData);
	      var pdf = new pdfConverter("p", "mm", "a4");
	      this.setState({ loaded: false });
	
	      pdf.setFont("helvetica");
	      pdf.setFontType("normal");
	      pdf.setFontSize(9);
	      var top = 10;
	
	      top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
	      var imageRendering = false;
	      var fileName = segment.name + "_list_report.pdf";
	
	      setTimeout(function () {
	        var _this3 = this;
	
	        if (!(0, _lodash.isEmpty)(datas)) {
	          pdf.setFontSize(10);
	          pdf.setFontType("normal");
	          pdf.text(18, top, "");
	          top += 8;
	        }
	        (0, _lodash.map)(datas, function (data, key) {
	          pdf.setFontType("normal");
	          pdf.setFontSize(9);
	          var arrReplace = [];
	          var fillStrWidth = pdf.getStringUnitWidth(" _");
	
	          for (var i = 0; i < (48 - pdf.getStringUnitWidth(data.label)) / fillStrWidth; i++) {
	            arrReplace.push(" _");
	          }
	
	          pdf.text(190, top, data.label + arrReplace.join(""), null, null, "right");
	          top += 8;
	          if (top > 260) {
	            pdf.addPage("a4", "p");
	            top = _this3._addSummarytoPDF(segment, attributes, pdf) + 5;
	          }
	          (0, _lodash.map)(data, function (dataVal, dataKey) {
	            if (dataKey !== "label" && dataKey !== "total") {
	              arrReplace.length = 0;
	              var valStr = dataVal.label + (0, _utility.splitNumber)(dataVal.total)();
	              for (var i = 0; i < (24 - pdf.getStringUnitWidth(valStr)) / fillStrWidth; i++) {
	                arrReplace.push(" _");
	              }
	              pdf.text(185, top, dataVal.label + arrReplace.join("") + (0, _utility.splitNumber)(dataVal.total)(), null, null, "right");
	              top += 5;
	            }
	          });
	          pdf.setDrawColor(128, 128, 128);
	          pdf.line(98, top, 188, top);
	          top += 5;
	          if (top > 260) {
	            pdf.addPage("a4", "p");
	            top = _this3._addSummarytoPDF(segment, attributes, pdf) + 5;
	          }
	          pdf.setFontType("bold");
	          pdf.setFontSize(12);
	          pdf.text(185, top, (0, _utility.splitNumber)(data.total)(), null, null, "right");
	          top += 8;
	          if (top > 260) {
	            pdf.addPage("a4", "p");
	            top = _this3._addSummarytoPDF(segment, attributes, pdf) + 5;
	          }
	        });
	        var els = document.getElementsByClassName("geo-map-row-container");
	
	        if (els.length > 0) {
	          var el = els[0].firstElementChild;
	          imageRendering = true;
	          if (!(0, _lodash.isEmpty)(datas)) {
	            pdf.addPage("a4", "p");
	            top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
	          }
	          pdf.setFontSize(10);
	          pdf.setFontType("normal");
	          pdf.text(18, top, "GEOGRAPHY");
	          top += 5;
	          html2canvas(el, {
	            proxy: _env.apiBaseUrl + "/proxy/images",
	            useCORS: true,
	            allowTraint: true
	          }).then(function (canvas) {
	            pdf.addImage(canvas.toDataURL(), "PNG", 18, 90, 174, 0);
	
	            setTimeout(function () {
	              this.setState({ loaded: true });
	              var pageCount = pdf.internal.getNumberOfPages();
	              pdf.setFontSize(8);
	              pdf.setFontType("normal");
	
	              for (var i = 0; i < pageCount; i++) {
	                pdf.setPage(i);
	                pdf.text(188, 288, "Page " + pdf.internal.getCurrentPageInfo().pageNumber + " of " + pageCount, null, null, "right");
	                pdf.addImage((0, _utility.pdfReportFooterDataUri)(), "PNG", 15, 290, 20, 0);
	                pdf.text(65, 288, "© " + (0, _moment2.default)().format("YYYY") + " Claritas, LLC. All rights reserved");
	              }
	              pdf.save(fileName);
	              this.setState({ showLoadingDialog: false });
	            }.bind(this), 5000);
	          }.bind(this));
	
	          top += 70;
	          pdf.setDrawColor(128, 128, 128);
	          pdf.line(18, top, 190, top);
	          top += 5;
	          pdf.text(18, top, "GEOGRAPHIC AREA SELECTED");
	          var _rawData2 = JSON.parse(segment.rawData);
	          pdf.text(186, top, (0, _utility.splitNumber)(_rawData2.plotted_values.audienceCount.total)(), null, null, "right");
	        }
	        if (rawData.selected_state.length + rawData.selected_city.length + rawData.zipcode.length + rawData.selected_county.length + rawData.selected_dma.length + geoDatas.length > 0) {
	          if (!(0, _lodash.isEmpty)(datas)) {
	            pdf.addPage("a4", "p");
	            top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
	          }
	          pdf.setFontSize(10);
	          pdf.setFontType("normal");
	          pdf.text(18, top, "GEOGRAPHY");
	          top += 8;
	          if (rawData.selected_state.length > 0) {
	            var arrReplace = [];
	            var fillStrWidth = pdf.getStringUnitWidth(" _");
	
	            for (var i = 0; i < (48 - pdf.getStringUnitWidth("State")) / fillStrWidth; i++) {
	              arrReplace.push(" _");
	            }
	
	            pdf.text(190, top, "State" + arrReplace.join(""), null, null, "right");
	            top += 8;
	            (0, _lodash.map)(rawData.selected_state, function (state) {
	              arrReplace.length = 0;
	
	              var valStr = state.label + (0, _utility.splitNumber)(state.total)();
	              for (var i = 0; i < (24 - pdf.getStringUnitWidth(valStr)) / fillStrWidth; i++) {
	                arrReplace.push(" _");
	              }
	              pdf.text(185, top, state.label + arrReplace.join("") + (0, _utility.splitNumber)(state.total)(), null, null, "right");
	              top += 5;
	            });
	          }
	          if (rawData.selected_city.length > 0) {
	            var _arrReplace = [];
	            var _fillStrWidth = pdf.getStringUnitWidth(" _");
	
	            for (i = 0; i < (48 - pdf.getStringUnitWidth("City")) / _fillStrWidth; i++) {
	              _arrReplace.push(" _");
	            }
	
	            pdf.text(190, top, "City" + _arrReplace.join(""), null, null, "right");
	            top += 8;
	            (0, _lodash.map)(rawData.selected_city, function (city) {
	              _arrReplace.length = 0;
	
	              var valStr = city.value + ", " + city.state + (0, _utility.splitNumber)(city.total)();
	              for (var i = 0; i < (24 - pdf.getStringUnitWidth(valStr)) / _fillStrWidth; i++) {
	                _arrReplace.push(" _");
	              }
	              pdf.text(185, top, city.value + ", " + city.state + _arrReplace.join("") + (0, _utility.splitNumber)(city.total)(), null, null, "right");
	              top += 5;
	            });
	          }
	          if (geoDatas.length > 0) {
	            var _arrReplace2 = [];
	            _arrReplace2.length = 0;
	            var _fillStrWidth2 = pdf.getStringUnitWidth(" _");
	
	            var valStr = geoDatas[0] + (0, _utility.splitNumber)(segment.count)();
	            for (i = 0; i < (47 - pdf.getStringUnitWidth(valStr)) / _fillStrWidth2; i++) {
	              _arrReplace2.push(" _");
	            }
	
	            pdf.text(185, top, geoDatas[0] + _arrReplace2.join("") + (0, _utility.splitNumber)(segment.count)(), null, null, "right");
	            top += 7;
	
	            valStr = geoDatas[1] + geoDatas[2];
	            _arrReplace2.length = 0;
	            for (i = 0; i < (47 - pdf.getStringUnitWidth(valStr)) / _fillStrWidth2; i++) {
	              _arrReplace2.push(" _");
	            }
	            pdf.text(185, top, geoDatas[1] + _arrReplace2.join("") + geoDatas[2], null, null, "right");
	            top += 5;
	          }
	        }
	
	        if (!imageRendering) {
	          setTimeout(function () {
	            var pageCount = pdf.internal.getNumberOfPages();
	            pdf.setFontSize(8);
	            pdf.setFontType("normal");
	
	            for (var i = 0; i < pageCount; i++) {
	              pdf.setPage(i);
	              pdf.text(188, 288, "Page " + pdf.internal.getCurrentPageInfo().pageNumber + " of " + pageCount, null, null, "right");
	              pdf.addImage((0, _utility.pdfReportFooterDataUri)(), "PNG", 15, 290, 20, 0);
	
	              pdf.text(65, 288, "© " + (0, _moment2.default)().format("YYYY") + " Claritas, LLC. All rights reserved");
	            }
	            this.setState({ loaded: true });
	            pdf.save(fileName);
	            this.setState({ showLoadingDialog: false });
	          }.bind(this), 6000);
	        }
	      }.bind(this), 1000);
	    }
	  }, {
	    key: "handleEdit",
	    value: function handleEdit(id) {
	      var _props = this.props,
	          getSegmentWithRules = _props.getSegmentWithRules,
	          selectedClientChanged = _props.selectedClientChanged,
	          data = _props.data;
	
	      this.setState({
	        segmentIds: new Set([])
	      });
	      var cid = undefined;
	      data.data.forEach(function (item) {
	        if (item.id === id) {
	          selectedClientChanged(item.clientId);
	          cid = item.clientId;
	        }
	      });
	
	      getSegmentWithRules(id, cid);
	      this.props.clearSegmentSummary();
	    }
	  }, {
	    key: "_handleDownloadPDF",
	    value: function _handleDownloadPDF(segment, attributes, demoAttributes, geoAttributes) {
	      var els = document.getElementsByClassName("icon-pie-chart4");
	      if (this.state.showLoadingDialog === true) return;
	      this.setState({ showLoadingDialog: true });
	      if ((" " + els[0].className + " ").indexOf("active") > -1) {
	        this._handleDownloadChartPDF(segment, attributes, demoAttributes, geoAttributes);
	      } else {
	        this._handleDownloadListPDF(segment, attributes, demoAttributes, geoAttributes);
	      }
	    }
	  }, {
	    key: "_handleDownloadChartPDF",
	    value: function _handleDownloadChartPDF(segment, attributes, demoAttributes, geoAttributes) {
	      var geoDatas = this._generateGeographyData(segment);
	      var pdf = new pdfConverter("p", "mm", "a4");
	      this.setState({ loaded: false });
	      //const el = document.getElementById("segment-summary-container")
	      /*
	      html2canvas(el, {
	      onrendered: function (canvas) {
	      //pdf.addImage(canvas.toDataURL(), 'PNG', -50, -15, 0, 0, 'IMG1', 'fast')
	      //pdf.fromHTML(canvas, 10, 10, { 'width': 180 })
	      //pdf.save('test.pdf')
	      document.body.appendChild(canvas)
	      }, allowTraint: true, useCROS: true, type: "view"
	      });*/
	      pdf.setFont("helvetica");
	      pdf.setFontType("normal");
	      pdf.setFontSize(9);
	      //pdf.text(195, 278, "Page 1 of 1", null, null, "right")
	      //pdf.text(12, 288, "©" + moment().format("YYYY") + " Claritas, LLC. All rights reserved")
	      var els = document.getElementsByClassName("segment-attr-panel");
	
	      var top = 10;
	      var pdfCanvas = [];
	      //document.querySelectorAll('.segment-attr-panel').forEach((el) => {
	      var isIndChartReady = [];
	      (0, _lodash.map)(els, function (el) {
	        var width = el.offsetWidth;
	        el.style.width = "700px";
	        isIndChartReady.push(false);
	        setTimeout(function () {
	          html2canvas(el).then(function (canva) {
	            pdfCanvas.push(canva);
	            isIndChartReady.pop();
	          });
	        }, 50);
	        setTimeout(function () {
	          el.style.width = width + "px";
	        }, 100);
	      });
	
	      var cityStateZipcodeCanvas = [];
	      var isCityStateChartReady = [];
	      document.querySelectorAll(".city-state-panel").forEach(function (el) {
	        isCityStateChartReady.push(false);
	        var width = el.offsetWidth;
	        el.style.width = "700px";
	        setTimeout(function () {
	          html2canvas(el).then(function (canva) {
	            cityStateZipcodeCanvas.push(canva);
	            isCityStateChartReady.pop();
	          });
	        }, 50);
	        setTimeout(function () {
	          el.style.width = width + "px";
	        }, 50);
	      });
	      var isZipChartReady = [];
	      document.querySelectorAll(".zipcode-panel").forEach(function (el) {
	        isZipChartReady.push(false);
	        var width = el.offsetWidth;
	        el.style.width = "700px";
	        setTimeout(function () {
	          html2canvas(el).then(function (canva) {
	            cityStateZipcodeCanvas.push(canva);
	            isZipChartReady.pop();
	          });
	        }, 50);
	        setTimeout(function () {
	          el.style.width = width + "px";
	        }, 50);
	      });
	
	      top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
	      var newPage = false;
	      var intervalId = setInterval(function () {
	        if (isIndChartReady.length > 0 || isCityStateChartReady.length > 0 || isZipChartReady.length > 0) {
	          console.log("waiting...");
	        } else {
	          clearInterval(intervalId);
	          setTimeout(function () {
	            var _this4 = this;
	
	            var fileName = segment.name + "_chart_report.pdf";
	            if (pdfCanvas.length > 0) {
	              newPage = true;
	              pdf.setFontSize(10);
	              pdf.setFontType("normal");
	              pdf.text(16, top, "");
	              top += 5;
	              (0, _lodash.map)(pdfCanvas, function (canvas) {
	                pdf.addImage(canvas.toDataURL(), "PNG", 12, top, 186, 0);
	                pdf.setFillColor(255);
	                pdf.rect(196, top - 1, 10, canvas.height / 240 * 67, "F");
	                top += canvas.height / 240 * 70;
	                if (top > 208 && canvas !== (0, _lodash.last)(pdfCanvas)) {
	                  pdf.addPage("a4", "p");
	                  top = _this4._addSummarytoPDF(segment, attributes, pdf) + 5;
	                }
	              });
	            }
	            if (cityStateZipcodeCanvas.length > 0) {
	              if (newPage) {
	                pdf.addPage("a4", "p");
	                top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
	              }
	              newPage = true;
	              pdf.setFontSize(10);
	              pdf.setFontType("normal");
	              pdf.text(16, top, "GEOGRAPHIC");
	              top += 5;
	
	              (0, _lodash.map)(cityStateZipcodeCanvas, function (canvas) {
	                pdf.addImage(canvas.toDataURL(), "PNG", 12, top, 186, 0);
	                pdf.setFillColor(255);
	                pdf.rect(196, top - 1, 10, canvas.height / 240 * 67, "F");
	                top += canvas.height / 240 * 70;
	                if (top > 208 && canvas !== (0, _lodash.last)(pdfCanvas)) {
	                  pdf.addPage("a4", "p");
	                  top = _this4._addSummarytoPDF(segment, attributes, pdf) + 5;
	                }
	              });
	            }
	            var map_els = document.getElementsByClassName("google_map_container");
	            if (map_els.length > 0) {
	              if (newPage) {
	                pdf.addPage("a4", "p");
	              }
	              top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
	
	              pdf.setFontSize(10);
	              pdf.setFontType("normal");
	              pdf.text(16, top, "GEOGRAPHY");
	              top += 5;
	              pdf.setDrawColor(128, 128, 128);
	              pdf.line(16, top, 190, top);
	              top += 5;
	
	              html2canvas(map_els[0], {
	                useCORS: true,
	                allowTraint: true,
	                proxy: _env.apiBaseUrl + "/proxy/images"
	              }).then(function (canva) {
	                pdf.addImage(canva.toDataURL(), "PNG", 30, 95);
	                setTimeout(function () {
	                  this.setState({ loaded: true });
	                  var pageCount = pdf.internal.getNumberOfPages();
	                  pdf.setFontSize(8);
	                  pdf.setFontType("normal");
	                  for (var i = 0; i < pageCount; i++) {
	                    pdf.setPage(i);
	                    pdf.text(188, 288, "Page " + pdf.internal.getCurrentPageInfo().pageNumber + " of " + pageCount, null, null, "right");
	                    pdf.addImage((0, _utility.pdfReportFooterDataUri)(), "PNG", 15, 290, 20, 0);
	
	                    pdf.text(65, 288, "© " + (0, _moment2.default)().format("YYYY") + " Claritas, LLC. All rights reserved");
	                  }
	                  pdf.save(fileName);
	                  this.setState({ showLoadingDialog: false });
	                }.bind(this), 4000);
	              }.bind(this));
	
	              top += 60;
	              pdf.setDrawColor(128, 128, 128);
	              pdf.line(16, top, 190, top);
	              top += 5;
	              pdf.text(16, top, "GEOGRAPHIC AREA SELECTED");
	              var rawData = JSON.parse(segment.rawData);
	              pdf.text(186, top, (0, _utility.splitNumber)(rawData.plotted_values.audienceCount.total)(), null, null, "right");
	            }
	
	            if (geoDatas.length > 0) {
	              if (newPage) {
	                pdf.addPage("a4", "p");
	              }
	              top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
	
	              pdf.setFontSize(10);
	              pdf.setFontType("normal");
	              pdf.text(16, top, "GEOGRAPHY");
	              top += 8;
	
	              var arrReplace = [];
	              arrReplace.length = 0;
	              var fillStrWidth = pdf.getStringUnitWidth(" _");
	
	              var valStr = geoDatas[0] + (0, _utility.splitNumber)(segment.count)();
	              for (var i = 0; i < (47 - pdf.getStringUnitWidth(valStr)) / fillStrWidth; i++) {
	                arrReplace.push(" _");
	              }
	
	              pdf.text(185, top, geoDatas[0] + arrReplace.join("") + (0, _utility.splitNumber)(segment.count)(), null, null, "right");
	              top += 7;
	
	              valStr = geoDatas[1] + geoDatas[2];
	              arrReplace.length = 0;
	              for (i = 0; i < (47 - pdf.getStringUnitWidth(valStr)) / fillStrWidth; i++) {
	                arrReplace.push(" _");
	              }
	              pdf.text(185, top, geoDatas[1] + arrReplace.join("") + geoDatas[2], null, null, "right");
	              top += 5;
	            }
	            //setTimeout(function () {
	
	            if (map_els.length <= 0) {
	              setTimeout(function () {
	                this.setState({ loaded: true });
	
	                var pageCount = pdf.internal.getNumberOfPages();
	                pdf.setFontSize(8);
	                pdf.setFontType("normal");
	                for (var i = 0; i < pageCount; i++) {
	                  pdf.setPage(i);
	                  pdf.text(188, 288, "Page " + pdf.internal.getCurrentPageInfo().pageNumber + " of " + pageCount, null, null, "right");
	                  pdf.addImage((0, _utility.pdfReportFooterDataUri)(), "PNG", 15, 290, 20, 0);
	                  pdf.text(65, 288, "© " + (0, _moment2.default)().format("YYYY") + " Claritas, LLC. All rights reserved");
	                }
	                pdf.save(fileName);
	                this.setState({ showLoadingDialog: false });
	              }.bind(this), 4000);
	            }
	          }.bind(this), 1000);
	        }
	      }.bind(this), 50);
	    }
	  }, {
	    key: "_generateSelectData",
	    value: function _generateSelectData(segment_summary) {
	      var datas = {};
	
	      if (segment_summary && segment_summary.audiences) {
	        (0, _lodash.map)(segment_summary.audiences, function (audience) {
	          var key = Object.keys(audience)[0];
	          var val = Object.values(audience)[0];
	          if (key.startsWith("a")) {
	            key = parseInt(key.replace("a", ""), 10);
	            if (key > 1 && key !== 3) {
	              if (!datas[key]) datas[key] = { total: val.total, label: val.label };
	            }
	          } else {
	            if (key.startsWith("v")) {
	              key = parseInt(key.replace("v", ""), 10);
	              var attrObj = datas[val.attributeid];
	              attrObj[key] = {
	                total: val.total,
	                label: val.label,
	                email: val.email,
	                social: val.social,
	                display: val.display
	              };
	            }
	          }
	        });
	      }
	      return datas;
	    }
	  }, {
	    key: "_generateGeographyData",
	    value: function _generateGeographyData(segment_summary) {
	      var raw = JSON.parse(segment_summary.rawData);
	      var result = [];
	      if (!(0, _lodash.isEmpty)(raw.plotted_values)) {
	        var _raw$plotted_values = raw.plotted_values,
	            radius = _raw$plotted_values.radius,
	            addressLabel = _raw$plotted_values.addressLabel,
	            driveTime = _raw$plotted_values.driveTime;
	
	
	        if (addressLabel) {
	          result[0] = addressLabel.replace(", United States", "");
	          result[1] = driveTime ? "Drive from Location" : "Radius from Location";
	          result[2] = driveTime ? driveTime + " hours" : radius + " miles";
	        }
	      }
	      return result;
	    }
	  }, {
	    key: "changeShowLoadingDialogState",
	    value: function changeShowLoadingDialogState(obj) {
	      this.setState(obj);
	    }
	  }, {
	    key: "handleIconClick",
	    value: function handleIconClick(targetValue) {
	      this.props.handleIconClick(targetValue, this.state.activeIndex);
	    }
	    // handle the checkbox be selected
	
	  }, {
	    key: "handleCheckboxSelected",
	    value: function handleCheckboxSelected(e, isInputChecked, itemId) {
	      var itemIds = new Set([]);
	      itemIds.add(itemId);
	      this.setState({
	        segmentsId: itemIds
	      });
	      if (this.props.selectedSegment) this.props.selectedSegment([].concat(_toConsumableArray(itemIds)));
	      if (this.props.checkBoxBeClick) this.props.checkBoxBeClick();
	    }
	  }, {
	    key: "_gotoDetail",
	    value: function _gotoDetail(id) {
	      this.props.clearSegmentSummary();
	      this.props.history.push("detail/" + id);
	    }
	  }, {
	    key: "formatNameTime",
	    value: function formatNameTime(name) {
	      if (typeof name !== "string") return name;
	      var originNames = name.match(/.*_(\d+)$/);
	      if (!originNames || !originNames[1] || originNames[1].length !== 8) return name;
	      var originName = originNames[1];
	      var year = originName.substr(0, 4);
	      var month = originName.substr(4, 2);
	      var day = originName.substr(6);
	      return name.replace(originName, "" + month + day + year);
	    }
	
	    // the end
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, { label: "Close", primary: true, onTouchTap: this.handleClose })];
	      var muiTheme = (0, _getMuiTheme2.default)({
	        checkbox: {
	          checkedColor: (0, _utility.buttonBlueColor)()
	        }
	      });
	      var _props2 = this.props,
	          tableHeaderArray = _props2.tableHeaderArray,
	          data = _props2.data,
	          segment_summary = _props2.segment_summary,
	          fetchSegmentDetail = _props2.fetchSegmentDetail,
	          segment_attributes = _props2.segment_attributes,
	          demoAttributes = _props2.demoAttributes,
	          geoAttributes = _props2.geoAttributes;
	
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: muiTheme },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "segment-table",
	            id: "tbl-segments-list",
	            onClick: function onClick(e) {
	              return _this5.handleClick(e);
	            }
	          },
	          _react2.default.createElement(
	            _materialUi.Dialog,
	            {
	              open: this.state.showDataLoadingDialog,
	              style: { top: "-1.8em" },
	              overlayStyle: { opacity: 0.9, backgroundColor: "#666666" },
	              modal: true
	            },
	            _react2.default.createElement(
	              _Grid.Row,
	              { className: "mt-20" },
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "7", sm: "7", md: "7", lg: "7", className: "text-right" },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Data loading, please wait..."
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "1", sm: "1", md: "1", lg: "1" },
	                _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _materialUi.Dialog,
	            {
	              open: this.state.openDetailDialog,
	              onRequestClose: this.closeSegmentDetailDialog.bind(this),
	              modal: false,
	              autoScrollBodyContent: true,
	              style: { top: "-1.8em" },
	              contentStyle: { width: this.state.width + "px", maxWidth: "none" },
	              actions: [_react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-default btn-xlg legitRipple bg-teal-400",
	                  style: {
	                    marginRight: "56px",
	                    marginTop: "1.5em",
	                    marginBottom: "1.5em"
	                  },
	                  onClick: this.closeSegmentDetailDialog.bind(this)
	                },
	                "Close"
	              )]
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                key: "segment-deatail-container",
	                className: "text-default no-padding pt-20 pl-20"
	              },
	              _react2.default.createElement(_clear2.default, {
	                style: {
	                  position: "absolute",
	                  right: "2em",
	                  cursor: "pointer",
	                  top: "2.4em"
	                },
	                onClick: function onClick() {
	                  return _this5.closeSegmentDetailDialog();
	                }
	              }),
	              _react2.default.createElement(_SegmentSummary2.default, {
	                segment_id: this.state.detailSegmentId,
	                segment_summary: segment_summary,
	                segment_attributes: segment_attributes,
	                demoAttributes: demoAttributes,
	                geoAttributes: geoAttributes,
	                popout: this.state.popout,
	                popoutTip: function popoutTip() {
	                  return _this5.popoutTip();
	                },
	                handleCancelArchive: function handleCancelArchive() {
	                  return _this5.handleCancelArchive();
	                },
	                showLoadingDialog: this.state.showLoadingDialog,
	                archiveSegment: this.props.archiveSegment,
	                updateSegmentList: this.props.updateSegmentList,
	                handleActiveRedirectCreate: function handleActiveRedirectCreate(id, clientId) {
	                  return _this5.handleActiveRedirectCreate(id, clientId);
	                },
	                createCampaignPopover: function createCampaignPopover(id, clientId) {
	                  return _this5.createCampaignPopover(id, clientId);
	                },
	                fetchSegmentDetail: fetchSegmentDetail ? fetchSegmentDetail : function () {},
	                changeShowLoadingDialogState: function changeShowLoadingDialogState(object) {
	                  return _this5.changeShowLoadingDialogState(object);
	                },
	                _generateSelectData: function _generateSelectData(datas) {
	                  return _this5._generateSelectData(datas);
	                },
	                _handleDownloadPDF: function _handleDownloadPDF() {
	                  return _this5._handleDownloadPDF(segment_summary, segment_attributes, demoAttributes, geoAttributes);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(_CreateCampaign2.default, {
	            openCreateCampaignDialog: this.state.openCreateCampaignDialog,
	            closeCreateCampaignDialog: function closeCreateCampaignDialog() {
	              return _this5.closeCreateCampaignDialog();
	            }
	            // ifShowEmailSubCheckbox={this.state.ifShowEmailSubCheckbox}
	            // ifReturnEmailChecked={this.state.ifReturnEmailChecked}
	            , handleEmailChecked: function handleEmailChecked(e, isInputChecked) {
	              return _this5.handleEmailChecked(e, isInputChecked);
	            },
	            handleReturnEmail: function handleReturnEmail(e, isInputChecked) {
	              return _this5.handleReturnEmail(e, isInputChecked);
	            },
	            handleSocialMedia: function handleSocialMedia(e, isInputChecked) {
	              return _this5.handleSocialMedia(e, isInputChecked);
	            },
	            ifSocialMediaChecked: this.state.ifSocialMediaChecked,
	            socialMediaFacebook: this.state.socialMediaFacebook,
	            socialMediaGoogle: this.state.socialMediaGoogle
	            // handleSocialMediaAllChecked={() => this.handleSocialMediaAllChecked()}
	            , handleFacebookCheck: function handleFacebookCheck(e, isInputChecked) {
	              return _this5.handleFacebookCheck(e, isInputChecked);
	            },
	            handleGoogleCheck: function handleGoogleCheck(e, isInputChecked) {
	              return _this5.handleGoogleCheck(e, isInputChecked);
	            },
	            handleDisplayCheck: function handleDisplayCheck(e, isInputChecked) {
	              return _this5.handleDisplayCheck(e, isInputChecked);
	            },
	            ifDisplayChecked: this.state.ifDisplayChecked,
	            handleSelectAllCheckbox: function handleSelectAllCheckbox() {
	              return _this5.handleSelectAllCheckbox();
	            },
	            createCampaign_segment_id: this.state.createCampaign_segment_id,
	            getCreateCampaign: this.props.getCreateCampaign // create campaign api function
	            , createCampaign_clientId: this.state.createCampaign_clientId,
	            create_campaign: this.props.create_campaign,
	            rollbackRequestSuccessToFalse: this.props.rollbackRequestSuccessToFalse
	          }),
	          _react2.default.createElement(
	            _Table.Table,
	            { style: { fontFamily: "Arial", fontsize: "16px" } },
	            _react2.default.createElement(
	              _Table.TableHeader,
	              {
	                displaySelectAll: false,
	                style: styles.tableHeaderStyle,
	                adjustForCheckbox: false
	              },
	              _react2.default.createElement(
	                _Table.TableRow,
	                { displayBorder: false, style: { height: "30px" } },
	                tableHeaderArray.length === 6 ? tableHeaderArray.map(function (header, index) {
	                  var isSortedCol = _this5.props.sortName === header && header !== "";
	                  if (index === 1) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        key: index,
	                        style: Object.assign({}, isSortedCol ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          width: "35%"
	                        }),
	                        className: "count-" + _this5.props.flag + index
	                      },
	                      header,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "desc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "asc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  } else if (index === 0) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        key: index,
	                        style: Object.assign({}, isSortedCol ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          width: "7%",
	                          paddingRight: "10px",
	                          textAlign: "center"
	                        }),
	                        className: "count-" + _this5.props.flag + index
	                      },
	                      header,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "desc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "asc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  } else if (index === 2) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        key: index,
	                        style: Object.assign({}, isSortedCol ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          textAlign: "left",
	                          paddingRight: "64px",
	                          width: "12%"
	                        }),
	                        className: "count-" + _this5.props.flag + index
	                      },
	                      header,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "desc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "asc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  } else if (index === 3) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        key: index,
	                        style: Object.assign({}, isSortedCol ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          textAlign: "left",
	                          paddingRight: "64px",
	                          width: "18%"
	                        }),
	                        className: "count-" + _this5.props.flag + index
	                      },
	                      header,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "desc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "asc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  } else if (index === 4) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        key: index,
	                        style: Object.assign({}, isSortedCol ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          textAlign: "left",
	                          paddingRight: "64px",
	                          width: "13.5%"
	                        }),
	                        className: "count-" + _this5.props.flag + index
	                      },
	                      header,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "desc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "asc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        key: index,
	                        style: Object.assign({}, isSortedCol ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn),
	                        className: "count-" + _this5.props.flag + index
	                      },
	                      header,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "desc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "asc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  }
	                }) : // for archive
	                tableHeaderArray.map(function (header, index) {
	                  var isSortedCol = _this5.props.sortName === header && header !== "";
	
	                  if (index === 0) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        key: index,
	                        style: Object.assign({}, isSortedCol ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          width: "8%"
	                        }),
	                        className: "count-" + _this5.props.flag + index
	                      },
	                      header,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "desc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "asc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  } else if (index === 2) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        key: index,
	                        style: Object.assign({}, isSortedCol ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          textAlign: "left",
	                          width: "14%",
	                          paddingRight: tableHeaderArray.length === 3 ? "96px" : "64px"
	                        }),
	                        className: "count-" + _this5.props.flag + index
	                      },
	                      header,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "desc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "asc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        key: index,
	                        style: Object.assign({}, isSortedCol ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          width: index === 1 || index === 3 ? "33%" : ""
	                        }),
	                        className: "count-" + _this5.props.flag + index
	                      },
	                      header,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "desc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this5.handleIconClick(header);
	                        },
	                        style: {
	                          display: _this5.props.sort === "asc" && _this5.props.sortName === header && header !== "" ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _Table.TableBody,
	              { displayRowCheckbox: false, className: "archive-body" },
	              "// for active",
	              typeof data.data !== "undefined" && this.props.flag === "active" && data.data.map(function (item, index) {
	                var _tableRow = _react2.default.createElement(
	                  _Table.TableRow,
	                  {
	                    key: index,
	                    style: {
	                      position: "relative",
	                      borderBottom: "1px solid #E8EBEF",
	                      height: "30px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { style: { width: "7%", height: "32px" } },
	                    item.status === "Active" && _react2.default.createElement(_RadioButton2.default, {
	                      style: {
	                        height: "28px",
	                        transform: "scale(0.7)"
	                      }
	                      // iconStyle={{width: '15px', height: '15px', marginTop: '3px'}}
	                      , checked: _this5.props.selectedSegmentSetArray.some(function (id) {
	                        return id === item.id;
	                      }),
	                      onCheck: function onCheck(e, selected) {
	                        _this5.handleCheckboxSelected(e, selected, item.id);
	                      },
	                      value: item.id
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      className: "segment-row",
	                      style: Object.assign({}, styles.tableRowColumn, { width: "40%" })
	                    },
	                    item.status === "Pending" ? _react2.default.createElement(
	                      "span",
	                      null,
	                      _this5.formatNameTime(item.name)
	                    ) : _react2.default.createElement(
	                      "a",
	                      {
	                        onClick: function onClick(e) {
	                          e.preventDefault();
	                          _this5._gotoDetail(item.id);
	                        }
	                      },
	                      _this5.formatNameTime(item.name)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: Object.assign({}, styles.tableRowColumn, { width: "16%" })
	                    },
	                    item.createdTime
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: Object.assign({}, styles.tableRowColumn, { width: "40%" })
	                    },
	                    item.sourceLabel
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: Object.assign({}, styles.tableRowColumn, { width: "13.5%" })
	                    },
	                    item.status === "Active" ? item.restoredTime ? "Active from Archive" : "Active" : item.status
	                  ),
	                  _this5.props.tableHeaderArray.some(function (item) {
	                    return item === "CLIENT";
	                  }) ? _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: { position: "relative" },
	                      className: ""
	                    },
	                    item.clientName,
	                    _react2.default.createElement(
	                      _rcTooltip2.default,
	                      {
	                        placement: "right",
	                        overlayClassName: "segment-list-tooltip",
	                        overlay: _react2.default.createElement(_NavList2.default, {
	                          roleName: _this5.props.roleName,
	                          visible: !_this5.state.showLoadingDialog,
	                          handleActiveRedirectCreate: function handleActiveRedirectCreate() {
	                            return _this5.handleActiveRedirectCreate(item.id, item.clientId);
	                          },
	                          popout: _this5.state.popout,
	                          popoutTip: function popoutTip() {
	                            return _this5.popoutTip();
	                          },
	                          handleConfirmArchive: function handleConfirmArchive() {
	                            return _this5.handleConfirmArchive(item.id);
	                          },
	                          handleCancelArchive: function handleCancelArchive() {
	                            return _this5.handleCancelArchive();
	                          },
	                          createCampaignPopover: function createCampaignPopover() {
	                            return _this5.createCampaignPopover(item.id, item.clientId);
	                          },
	                          _handleDownloadPDF: function _handleDownloadPDF() {
	                            return _this5._handleDownloadPDF(segment_summary, segment_attributes, demoAttributes, geoAttributes);
	                          }
	                        }),
	                        defaultVisible: false,
	                        arrowContent: _react2.default.createElement("div", { className: "rc-tooltip-arrow-inner" })
	                      },
	                      _react2.default.createElement(_settings2.default, { style: styles.settingStyle })
	                    )
	                  ) : ""
	                );
	                var row = [_tableRow, _react2.default.createElement(
	                  _Table.TableRow,
	                  {
	                    className: "archive-popout-tip",
	                    style: {
	                      height: _this5.props.ifArchiveSuccess.some(function (item) {
	                        return item === _this5.state.archivedId;
	                      }) && item.id === _this5.state.archivedId ? "30px" : 0,
	                      overflow: "hidden",
	                      border: "none"
	                    }
	                  },
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      colSpan: _this5.props.tableHeaderArray.some(function (item) {
	                        return item === "CLIENT";
	                      }) ? 4 : 6,
	                      className: "clearfix",
	                      style: {
	                        height: 0,
	                        overflow: "hidden"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        style: {
	                          display: _this5.props.ifArchiveSuccess.some(function (item) {
	                            return item === _this5.state.archivedId;
	                          }) && item.id === _this5.state.archivedId ? "inline" : "none"
	                        }
	                      },
	                      "This segment has been archived,"
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "/segments/list/archive",
	                        style: {
	                          display: _this5.props.ifArchiveSuccess.some(function (item) {
	                            return item === _this5.state.archivedId;
	                          }) && item.id === _this5.state.archivedId ? "inline" : "none"
	                        }
	                      },
	                      "View Archive"
	                    )
	                  )
	                )];
	                return row;
	              }),
	              "// for Archive",
	              typeof data.data !== "undefined" && this.props.flag === "archive" && data.data.map(function (item, index) {
	                return _react2.default.createElement(
	                  _Table.TableRow,
	                  {
	                    key: index,
	                    style: {
	                      borderBottom: "1px solid #E8EBEF",
	                      height: "30px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { style: { width: "6%", height: "32px", padding: 0, textAlign: 'center' } },
	                    _react2.default.createElement(_RadioButton2.default, {
	                      style: { height: "28px", transform: "scale(0.7)" },
	                      checked: _this5.state.segmentsId.values().next().value && _this5.state.segmentsId.values().next().value === item.id,
	                      onCheck: function onCheck(e, selected) {
	                        _this5.handleCheckboxSelected(e, selected, item.id);
	                      },
	                      value: item.id
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: Object.assign({}, styles.tableRowColumn, { width: "25%", padding: 0 })
	                    },
	                    _react2.default.createElement(
	                      "a",
	                      { onClick: function onClick() {
	                          return _this5.copySegment(item.id);
	                        } },
	                      item.name
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: Object.assign({}, styles.tableRowColumn, { width: "9%", padding: 0, textAlign: 'center' })
	                    },
	                    item.archivedTime
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: Object.assign({}, styles.tableRowColumn, { width: "25%" })
	                    },
	                    item.sourceLabel
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: Object.assign({}, styles.tableRowColumn, { width: "8.6%" })
	                    },
	                    item.status
	                  ),
	                  _this5.props.tableHeaderArray.some(function (item) {
	                    return item === "CLIENT";
	                  }) ? _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { style: styles.tableRowColumn },
	                    item.clientName
	                  ) : ""
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(_Page2.default, {
	            nextBeClick: function nextBeClick(page) {
	              return _this5.goToNext(page);
	            },
	            pageCount: data.pageCount,
	            pageSize: data.pageSize,
	            nextGroupBeClick: function nextGroupBeClick(page) {
	              return _this5.nextToGroup(page);
	            },
	            previousGroupBeClick: function previousGroupBeClick(page) {
	              return _this5.previousToGroup(page);
	            },
	            previousBeClick: function previousBeClick(page) {
	              return _this5.goToPrevious(page);
	            },
	            pageBeClick: function pageBeClick(page) {
	              return _this5.pageBeClick(page);
	            },
	            total: data.total,
	            hasNext: data.hasNext,
	            hasPrevious: data.hasPrevious,
	            pagePlus: true,
	            selectRows: function selectRows(page, row) {
	              return _this5.selectRows(page, row);
	            },
	            goToPage: function goToPage(page) {
	              return _this5.goToPage(page);
	            },
	            segmentIds: this.state.segmentsId,
	            archiveFun: this.props.flag === "archive" ? null : function () {
	              _this5.props.handleConfirmArchive();
	            },
	            unArchiveFun: this.props.flag === "archive" ? function (id) {
	              _this5.props.reactiveSegment(id);
	            } : null,
	            editFun: this.props.flag === "archive" ? null : function (id) {
	              return _this5.handleEdit(id);
	            },
	            reactive_success: this.props.reactive_success,
	            reactive_on_progress: this.props.reactive_on_progress,
	            history: this.props.history
	          }),
	          _react2.default.createElement(
	            _materialUi.Dialog,
	            {
	              title: "",
	              contentStyle: { width: "80%", maxWidth: "inherit" },
	              actions: actions,
	              modal: false,
	              open: this.state.open,
	              onRequestClose: this.handleClose
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "top-copy-archive clearfix" },
	              _react2.default.createElement(
	                "span",
	                null,
	                this.state.archive_data_obj.name
	              )
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "copy-archive-ul clearfix" },
	              _react2.default.createElement(
	                "li",
	                { className: "clearfix" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Date"
	                ),
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    this.state.archive_data_obj.archivedTime
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Attributes"
	                ),
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    this.props.segment_attributes
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "clearfix" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Client"
	                ),
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    this.state.archive_data_obj.clientName
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Count"
	                ),
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    this.state.archive_data_obj.count
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SegmentTable;
	}(_react.Component);
	
	SegmentTable.propTypes = {
	  tableHeaderArray: _propTypes2.default.array,
	  data: _propTypes2.default.object,
	  headerBeClick: _propTypes2.default.func,
	  pageBeClick: _propTypes2.default.func,
	  nextBeClick: _propTypes2.default.func,
	  previousBeClick: _propTypes2.default.func,
	  nextGroupBeClick: _propTypes2.default.func,
	  previousGroupBeClick: _propTypes2.default.func,
	  sort: _propTypes2.default.string,
	  sortName: _propTypes2.default.string,
	  ifArchiveSuccess: _propTypes2.default.array,
	  getAttributes: _propTypes2.default.func,
	  copySegmentRedirect: _propTypes2.default.func,
	  selectedClientChanged: _propTypes2.default.func,
	  flag: _propTypes2.default.string
	};
	
	exports.default = SegmentTable;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Dashboard = __webpack_require__(506);
	
	var _index = __webpack_require__(1088);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$dashboard = state.dashboard,
	      client_subscription_stats = _state$dashboard.client_subscription_stats,
	      client_stats = _state$dashboard.client_stats,
	      client_tag_stats = _state$dashboard.client_tag_stats,
	      insights_stats = _state$dashboard.insights_stats;
	  var _state$app = state.app,
	      roleId = _state$app.roleId,
	      selected_client = _state$app.selected_client,
	      optimizeUserDetail = _state$app.optimizeUserDetail,
	      loginUserDetail = _state$app.loginUserDetail,
	      client_info = _state$app.client_info,
	      clients = _state$app.clients,
	      loadingOptimizeUserDetail = _state$app.loadingOptimizeUserDetail,
	      disabledFeatures = _state$app.disabledFeatures,
	      loadingDisabledFeatures = _state$app.loadingDisabledFeatures;
	
	  return {
	    client_subscription_stats: client_subscription_stats,
	    client_stats: client_stats,
	    client_tag_stats: client_tag_stats,
	    insights_stats: insights_stats,
	    roleId: roleId,
	    selected_client: selected_client,
	    loginUserDetail: loginUserDetail,
	    optimizeUserDetail: optimizeUserDetail,
	    client_info: client_info,
	    clients: clients,
	    loadingOptimizeUserDetail: loadingOptimizeUserDetail,
	    disabledFeatures: disabledFeatures,
	    loadingDisabledFeatures: loadingDisabledFeatures
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientStats: function getClientStats() {
	      dispatch((0, _Dashboard.getClientStats)());
	    },
	    setLoginErrorMessage: function setLoginErrorMessage(message) {
	      dispatch((0, _App.setLoginErrorMessage)(message));
	    },
	
	    getClientSubscriptionStats: function getClientSubscriptionStats() {
	      dispatch((0, _Dashboard.getClientSubscriptionStats)());
	    },
	
	    getClientTagStats: function getClientTagStats() {
	      dispatch((0, _Dashboard.getClientTagStats)());
	    },
	
	    getInsightsStats: function getInsightsStats(period) {
	      dispatch((0, _Dashboard.getInsightsStats)(period));
	    },
	
	    selectClient: function selectClient(clientId) {
	      dispatch((0, _App.selectClient)(clientId));
	    },
	
	    getClientInfo: function getClientInfo(clientId) {
	      dispatch((0, _App.getClientInfo)(clientId));
	    },
	
	    clearDashboardStats: function clearDashboardStats() {
	      dispatch((0, _Dashboard.clearDashboardStats)());
	    },
	    getDisabledFeatures: function getDisabledFeatures() {
	      dispatch((0, _App.getDisabledFeatures)());
	    }
	  };
	};
	
	var DashboardContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_index2.default);
	
	exports.default = DashboardContainer;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserStatus = __webpack_require__(517);
	
	var _UserStatus2 = _interopRequireDefault(_UserStatus);
	
	var _employees = __webpack_require__(119);
	
	var _Clients = __webpack_require__(49);
	
	var _reactRedux = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$employees = state.employees,
	      tableList = _state$employees.tableList,
	      account_manager = _state$employees.account_manager,
	      roles = _state$employees.roles,
	      clientRoles = _state$employees.clientRoles,
	      ifUpdateRoleSuccess = _state$employees.ifUpdateRoleSuccess,
	      client_assignments = _state$employees.client_assignments,
	      ifReassignSuccess = _state$employees.ifReassignSuccess,
	      suspend_error = _state$employees.suspend_error,
	      client_assignments_error = _state$employees.client_assignments_error,
	      team_member_options = _state$employees.team_member_options;
	  var _state$app = state.app,
	      clients = _state$app.clients,
	      roleId = _state$app.roleId,
	      selected_client = _state$app.selected_client,
	      userId = _state$app.userId,
	      roleName = _state$app.roleName;
	  var client_team_members = state.clients.client_team_members;
	
	  var isAdminSelect = typeof selected_client === "string" && selected_client.indexOf("r-") >= 0;
	  return {
	    roles: roleId > 50 ? clientRoles : roles,
	    clientRoles: clientRoles,
	    tableList: tableList,
	    ifUpdateRoleSuccess: ifUpdateRoleSuccess,
	    roleId: roleId,
	    userId: userId,
	    roleName: roleName,
	    suspend_error: suspend_error,
	    account_manager: account_manager.filter(function (item) {
	      return item.id !== 53;
	    }),
	    client_assignments: client_assignments,
	    ifReassignSuccess: ifReassignSuccess,
	    client_assignments_error: client_assignments_error,
	    team_member_options: team_member_options,
	    clients: clients,
	    client_team_members: client_team_members,
	    selected_client: clients !== undefined && isAdminSelect && clients[0].id
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getRoles: function getRoles() {
	      dispatch((0, _employees.getRoles)());
	    },
	    getClientRoles: function getClientRoles() {
	      dispatch((0, _employees.getClientRoles)());
	    },
	    // updateRole: (userId, roleId) => {
	    //   dispatch(updateRole(userId, roleId))
	    // },
	    updateRole: function updateRole(userId, roleId, isUpdateClient) {
	      dispatch((0, _employees.updateRole)(userId, roleId, isUpdateClient));
	    },
	    rollBackUpdateStatus: function rollBackUpdateStatus() {
	      dispatch((0, _employees.rollBackUpdateStatus)());
	    },
	    getTableList: function getTableList(obj, clientId) {
	      dispatch((0, _employees.getTableList)(obj, clientId));
	    },
	    getAccountManage: function getAccountManage(id) {
	      dispatch((0, _employees.getAccountManage)(id));
	    },
	    // suspendUser: (userId, status) => {
	    //   dispatch(suspendUser(userId, status))
	    // },
	    suspendUser: function suspendUser(userId, status, isClientUser) {
	      dispatch((0, _employees.suspendUser)(userId, status, isClientUser));
	    },
	    getClientAssignments: function getClientAssignments(id) {
	      dispatch((0, _employees.getClientAssignments)(id));
	    },
	    reassingAccountManager: function reassingAccountManager(id, obj) {
	      dispatch((0, _employees.reassingAccountManager)(id, obj));
	    },
	    rollBackReassign: function rollBackReassign() {
	      dispatch((0, _employees.rollBackReassign)());
	    },
	    clearSuspendError: function clearSuspendError() {
	      dispatch((0, _employees.clearSuspendError)());
	    },
	    getBusinessUnitTeamMembers: function getBusinessUnitTeamMembers(clientId, businessId) {
	      dispatch((0, _Clients.getBusinessUnitTeamMembers)(clientId, businessId));
	    }
	  };
	};
	
	var UserStatus = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_UserStatus2.default);
	
	exports.default = UserStatus;

/***/ },
/* 536 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var localSegmentSelection = {
	  clearLocalData: function clearLocalData() {
	    window.localStorage.removeItem('dayRange');
	    window.localStorage.removeItem('__segmentTop__');
	    window.localStorage.removeItem('__segmentMeasure__');
	    window.localStorage.removeItem('__websiteId__');
	    window.localStorage.removeItem('__segmentSysId__');
	    window.localStorage.removeItem('__granularity__');
	  }
	};
	
	exports.default = localSegmentSelection;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(543), __esModule: true };

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(546), __esModule: true };

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1256), __esModule: true };

/***/ },
/* 540 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(542);
	} catch (err) {
	  var index = __webpack_require__(542);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 542 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(265);
	__webpack_require__(1278);
	module.exports = __webpack_require__(55).Array.from;


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1280);
	module.exports = __webpack_require__(55).Object.assign;


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1281);
	var $Object = __webpack_require__(55).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1282);
	var $Object = __webpack_require__(55).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1284);
	module.exports = __webpack_require__(55).Object.getPrototypeOf;


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1286);
	module.exports = __webpack_require__(55).Object.setPrototypeOf;


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1288);
	__webpack_require__(1287);
	__webpack_require__(1289);
	__webpack_require__(1290);
	module.exports = __webpack_require__(55).Symbol;


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(265);
	__webpack_require__(374);
	module.exports = __webpack_require__(373).f('iterator');


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(359);
	var TAG = __webpack_require__(86)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 552 */
[3156, 170, 121],
/* 553 */
[3159, 135, 168, 552],
/* 554 */
[3160, 359],
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(262);
	var $export = __webpack_require__(120);
	var redefine = __webpack_require__(559);
	var hide = __webpack_require__(169);
	var Iterators = __webpack_require__(171);
	var $iterCreate = __webpack_require__(1266);
	var setToStringTag = __webpack_require__(367);
	var getPrototypeOf = __webpack_require__(557);
	var ITERATOR = __webpack_require__(86)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 556 */
[3165, 558, 362],
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(136);
	var toObject = __webpack_require__(216);
	var IE_PROTO = __webpack_require__(368)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 558 */
[3166, 136, 137, 1259, 368],
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(169);


/***/ },
/* 560 */
[3173, 370],
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(551);
	var ITERATOR = __webpack_require__(86)('iterator');
	var Iterators = __webpack_require__(171);
	module.exports = __webpack_require__(55).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(375);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 563 */
[3154, 1291],
/* 564 */
[3156, 173, 104],
/* 565 */
[3157, 380, 571, 172],
/* 566 */
[3159, 172, 123, 564],
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(173);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 568 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 569 */
[3164, 1302, 571, 383, 384, 267, 566, 172],
/* 570 */
[3166, 267, 383, 1292, 573],
/* 571 */
215,
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(104);
	var hide = __webpack_require__(565);
	var has = __webpack_require__(267);
	var SRC = __webpack_require__(574)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(217).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 573 */
[3169, 1306, 574],
/* 574 */
264,
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var emptyObject = __webpack_require__(223);
	var _invariant = __webpack_require__(21);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(1496);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ v2.2.2 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1346), __webpack_require__(1345), __webpack_require__(1349), __webpack_require__(1348), __webpack_require__(578), __webpack_require__(1351)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-collection', 'd3-array', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Collection,d3Array,d3Interpolate,d3Format,d3Time,d3TimeFormat) { 'use strict';
	
	function initRange(domain, range) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.range(domain); break;
	    default: this.range(range).domain(domain); break;
	  }
	  return this;
	}
	
	function initInterpolator(domain, interpolator) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.interpolator(domain); break;
	    default: this.interpolator(interpolator).domain(domain); break;
	  }
	  return this;
	}
	
	var array = Array.prototype;
	
	var map = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal() {
	  var index = d3Collection.map(),
	      domain = [],
	      range = [],
	      unknown = implicit;
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal(domain, range).unknown(unknown);
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range[1] < range[0],
	        start = range[reverse - 0],
	        stop = range[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band(domain(), range)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return initRange.apply(rescale(), arguments);
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band.apply(null, arguments).paddingInner(1));
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function number(x) {
	  return +x;
	}
	
	var unit = [0, 1];
	
	function identity(x) {
	  return x;
	}
	
	function normalize(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(isNaN(b) ? NaN : 0.5);
	}
	
	function clamper(domain) {
	  var a = domain[0], b = domain[domain.length - 1], t;
	  if (a > b) t = a, a = b, b = t;
	  return function(x) { return Math.max(a, Math.min(b, x)); };
	}
	
	// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
	function bimap(domain, range, interpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
	  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range, interpolate) {
	  var j = Math.min(domain.length, range.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range = range.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = normalize(domain[i], domain[i + 1]);
	    r[i] = interpolate(range[i], range[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function transformer() {
	  var domain = unit,
	      range = unit,
	      interpolate = d3Interpolate.interpolate,
	      transform,
	      untransform,
	      unknown,
	      clamp = identity,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
	  }
	
	  scale.invert = function(y) {
	    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), d3Interpolate.interpolateNumber)))(y)));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map.call(_, number), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = slice.call(_), interpolate = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate = _, rescale()) : interpolate;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t, u) {
	    transform = t, untransform = u;
	    return rescale();
	  };
	}
	
	function continuous(transform, untransform) {
	  return transformer()(transform, untransform);
	}
	
	function tickFormat(start, stop, count, specifier) {
	  var step = d3Array.tickStep(start, stop, count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	}
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    var d = domain();
	    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(identity, identity);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return linearish(scale);
	}
	
	function identity$1(domain) {
	  var unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map.call(_, number), scale) : domain.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return identity$1(domain).unknown(unknown);
	  };
	
	  domain = arguments.length ? map.call(domain, number) : [0, 1];
	
	  return linearish(scale);
	}
	
	function nice(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	}
	
	function transformLog(x) {
	  return Math.log(x);
	}
	
	function transformExp(x) {
	  return Math.exp(x);
	}
	
	function transformLogn(x) {
	  return -Math.log(-x);
	}
	
	function transformExpn(x) {
	  return -Math.exp(-x);
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function loggish(transform) {
	  var scale = transform(transformLog, transformExp),
	      domain = scale.domain,
	      base = 10,
	      logs,
	      pows;
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) {
	      logs = reflect(logs), pows = reflect(pows);
	      transform(transformLogn, transformExpn);
	    } else {
	      transform(transformLog, transformExp);
	    }
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  return scale;
	}
	
	function log() {
	  var scale = loggish(transformer()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy(scale, log()).base(scale.base());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function transformSymlog(c) {
	  return function(x) {
	    return Math.sign(x) * Math.log1p(Math.abs(x / c));
	  };
	}
	
	function transformSymexp(c) {
	  return function(x) {
	    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
	  };
	}
	
	function symlogish(transform) {
	  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
	
	  scale.constant = function(_) {
	    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
	  };
	
	  return linearish(scale);
	}
	
	function symlog() {
	  var scale = symlogish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, symlog()).constant(scale.constant());
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function transformPow(exponent) {
	  return function(x) {
	    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	  };
	}
	
	function transformSqrt(x) {
	  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
	}
	
	function transformSquare(x) {
	  return x < 0 ? -x * x : x * x;
	}
	
	function powish(transform) {
	  var scale = transform(identity, identity),
	      exponent = 1;
	
	  function rescale() {
	    return exponent === 1 ? transform(identity, identity)
	        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
	        : transform(transformPow(exponent), transformPow(1 / exponent));
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, rescale()) : exponent;
	  };
	
	  return linearish(scale);
	}
	
	function pow() {
	  var scale = powish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, pow()).exponent(scale.exponent());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function sqrt() {
	  return pow.apply(null, arguments).exponent(0.5);
	}
	
	function quantile() {
	  var domain = [],
	      range = [],
	      thresholds = [],
	      unknown;
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : range[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range = [0, 1],
	      unknown;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : scale;
	  };
	
	  scale.thresholds = function() {
	    return domain.slice();
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(linearish(scale), arguments);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range = [0, 1],
	      unknown,
	      n = 1;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	var durationSecond = 1000,
	    durationMinute = durationSecond * 60,
	    durationHour = durationMinute * 60,
	    durationDay = durationHour * 24,
	    durationWeek = durationDay * 7,
	    durationMonth = durationDay * 30,
	    durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	  var scale = continuous(identity, identity),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	  };
	
	  return scale;
	}
	
	function time() {
	  return initRange.apply(calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
	}
	
	function utcTime() {
	  return initRange.apply(calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
	}
	
	function transformer$1() {
	  var x0 = 0,
	      x1 = 1,
	      t0,
	      t1,
	      k10,
	      transform,
	      interpolator = identity,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
	    return scale;
	  };
	}
	
	function copy$1(source, target) {
	  return target
	      .domain(source.domain())
	      .interpolator(source.interpolator())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function sequential() {
	  var scale = linearish(transformer$1()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, sequential());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialLog() {
	  var scale = loggish(transformer$1()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSymlog() {
	  var scale = symlogish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialPow() {
	  var scale = powish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSqrt() {
	  return sequentialPow.apply(null, arguments).exponent(0.5);
	}
	
	function sequentialQuantile() {
	  var domain = [],
	      interpolator = identity;
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return interpolator((d3Array.bisect(domain, x) - 1) / (domain.length - 1));
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return scale;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequentialQuantile(interpolator).domain(domain);
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function transformer$2() {
	  var x0 = 0,
	      x1 = 0.5,
	      x2 = 1,
	      t0,
	      t1,
	      t2,
	      k10,
	      k21,
	      interpolator = identity,
	      transform,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
	    return scale;
	  };
	}
	
	function diverging() {
	  var scale = linearish(transformer$2()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, diverging());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingLog() {
	  var scale = loggish(transformer$2()).domain([0.1, 1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, divergingLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSymlog() {
	  var scale = symlogish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingPow() {
	  var scale = powish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSqrt() {
	  return divergingPow.apply(null, arguments).exponent(0.5);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity$1;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleSymlog = symlog;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.scaleSequential = sequential;
	exports.scaleSequentialLog = sequentialLog;
	exports.scaleSequentialPow = sequentialPow;
	exports.scaleSequentialSqrt = sequentialSqrt;
	exports.scaleSequentialSymlog = sequentialSymlog;
	exports.scaleSequentialQuantile = sequentialQuantile;
	exports.scaleDiverging = diverging;
	exports.scaleDivergingLog = divergingLog;
	exports.scaleDivergingPow = divergingPow;
	exports.scaleDivergingSqrt = divergingSqrt;
	exports.scaleDivergingSymlog = divergingSymlog;
	exports.tickFormat = tickFormat;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.0.11 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds());
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(138)
	var startOfISOWeek = __webpack_require__(389)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * var result = getISOYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	
	  var fourthOfJanuaryOfNextYear = new Date(0)
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
	  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)
	
	  var fourthOfJanuaryOfThisYear = new Date(0)
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
	  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year
	  } else {
	    return year - 1
	  }
	}
	
	module.exports = getISOYear


/***/ },
/* 580 */
/***/ function(module, exports) {

	/**
	 * @category Common Helpers
	 * @summary Is the given argument an instance of Date?
	 *
	 * @description
	 * Is the given argument an instance of Date?
	 *
	 * @param {*} argument - the argument to check
	 * @returns {Boolean} the given argument is an instance of Date
	 *
	 * @example
	 * // Is 'mayonnaise' a Date?
	 * var result = isDate('mayonnaise')
	 * //=> false
	 */
	function isDate (argument) {
	  return argument instanceof Date
	}
	
	module.exports = isDate


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! decimal.js-light v2.5.0 https://github.com/MikeMcl/decimal.js-light/LICENCE */
	;(function (globalScope) {
	  'use strict';
	
	
	  /*
	   *  decimal.js-light v2.5.0
	   *  An arbitrary-precision Decimal type for JavaScript.
	   *  https://github.com/MikeMcl/decimal.js-light
	   *  Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
	   *  MIT Expat Licence
	   */
	
	
	  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
	
	
	    // The limit on the value of `precision`, and on the value of the first argument to
	    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
	  var MAX_DIGITS = 1e9,                        // 0 to 1e9
	
	
	    // The initial configuration properties of the Decimal constructor.
	    Decimal = {
	
	      // These values must be integers within the stated ranges (inclusive).
	      // Most of these values can be changed during run-time using `Decimal.config`.
	
	      // The maximum number of significant digits of the result of a calculation or base conversion.
	      // E.g. `Decimal.config({ precision: 20 });`
	      precision: 20,                         // 1 to MAX_DIGITS
	
	      // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
	      // `toFixed`, `toPrecision` and `toSignificantDigits`.
	      //
	      // ROUND_UP         0 Away from zero.
	      // ROUND_DOWN       1 Towards zero.
	      // ROUND_CEIL       2 Towards +Infinity.
	      // ROUND_FLOOR      3 Towards -Infinity.
	      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
	      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
	      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
	      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
	      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
	      //
	      // E.g.
	      // `Decimal.rounding = 4;`
	      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
	      rounding: 4,                           // 0 to 8
	
	      // The exponent value at and beneath which `toString` returns exponential notation.
	      // JavaScript numbers: -7
	      toExpNeg: -7,                          // 0 to -MAX_E
	
	      // The exponent value at and above which `toString` returns exponential notation.
	      // JavaScript numbers: 21
	      toExpPos:  21,                         // 0 to MAX_E
	
	      // The natural logarithm of 10.
	      // 115 digits
	      LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
	    },
	
	
	  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
	
	
	    external = true,
	
	    decimalError = '[DecimalError] ',
	    invalidArgument = decimalError + 'Invalid argument: ',
	    exponentOutOfRange = decimalError + 'Exponent out of range: ',
	
	    mathfloor = Math.floor,
	    mathpow = Math.pow,
	
	    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
	
	    ONE,
	    BASE = 1e7,
	    LOG_BASE = 7,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284
	
	    // Decimal.prototype object
	    P = {};
	
	
	  // Decimal prototype methods
	
	
	  /*
	   *  absoluteValue                       abs
	   *  comparedTo                          cmp
	   *  decimalPlaces                       dp
	   *  dividedBy                           div
	   *  dividedToIntegerBy                  idiv
	   *  equals                              eq
	   *  exponent
	   *  greaterThan                         gt
	   *  greaterThanOrEqualTo                gte
	   *  isInteger                           isint
	   *  isNegative                          isneg
	   *  isPositive                          ispos
	   *  isZero
	   *  lessThan                            lt
	   *  lessThanOrEqualTo                   lte
	   *  logarithm                           log
	   *  minus                               sub
	   *  modulo                              mod
	   *  naturalExponential                  exp
	   *  naturalLogarithm                    ln
	   *  negated                             neg
	   *  plus                                add
	   *  precision                           sd
	   *  squareRoot                          sqrt
	   *  times                               mul
	   *  toDecimalPlaces                     todp
	   *  toExponential
	   *  toFixed
	   *  toInteger                           toint
	   *  toNumber
	   *  toPower                             pow
	   *  toPrecision
	   *  toSignificantDigits                 tosd
	   *  toString
	   *  valueOf                             val
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the absolute value of this Decimal.
	   *
	   */
	  P.absoluteValue = P.abs = function () {
	    var x = new this.constructor(this);
	    if (x.s) x.s = 1;
	    return x;
	  };
	
	
	  /*
	   * Return
	   *   1    if the value of this Decimal is greater than the value of `y`,
	   *  -1    if the value of this Decimal is less than the value of `y`,
	   *   0    if they have the same value
	   *
	   */
	  P.comparedTo = P.cmp = function (y) {
	    var i, j, xdL, ydL,
	      x = this;
	
	    y = new x.constructor(y);
	
	    // Signs differ?
	    if (x.s !== y.s) return x.s || -y.s;
	
	    // Compare exponents.
	    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
	
	    xdL = x.d.length;
	    ydL = y.d.length;
	
	    // Compare digit by digit.
	    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
	      if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
	  };
	
	
	  /*
	   * Return the number of decimal places of the value of this Decimal.
	   *
	   */
	  P.decimalPlaces = P.dp = function () {
	    var x = this,
	      w = x.d.length - 1,
	      dp = (w - x.e) * LOG_BASE;
	
	    // Subtract the number of trailing zeros of the last word.
	    w = x.d[w];
	    if (w) for (; w % 10 == 0; w /= 10) dp--;
	
	    return dp < 0 ? 0 : dp;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.dividedBy = P.div = function (y) {
	    return divide(this, new this.constructor(y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
	   * by the value of `y`, truncated to `precision` significant digits.
	   *
	   */
	  P.dividedToIntegerBy = P.idiv = function (y) {
	    var x = this,
	      Ctor = x.constructor;
	    return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
	   *
	   */
	  P.equals = P.eq = function (y) {
	    return !this.cmp(y);
	  };
	
	
	  /*
	   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
	   *
	   */
	  P.exponent = function () {
	    return getBase10Exponent(this);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
	   * false.
	   *
	   */
	  P.greaterThan = P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
	   * otherwise return false.
	   *
	   */
	  P.greaterThanOrEqualTo = P.gte = function (y) {
	    return this.cmp(y) >= 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is an integer, otherwise return false.
	   *
	   */
	  P.isInteger = P.isint = function () {
	    return this.e > this.d.length - 2;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is negative, otherwise return false.
	   *
	   */
	  P.isNegative = P.isneg = function () {
	    return this.s < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is positive, otherwise return false.
	   *
	   */
	  P.isPositive = P.ispos = function () {
	    return this.s > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is 0, otherwise return false.
	   *
	   */
	  P.isZero = function () {
	    return this.s === 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than `y`, otherwise return false.
	   *
	   */
	  P.lessThan = P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
	   *
	   */
	  P.lessThanOrEqualTo = P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return the logarithm of the value of this Decimal to the specified base, truncated to
	   * `precision` significant digits.
	   *
	   * If no base is specified, return log[10](x).
	   *
	   * log[base](x) = ln(x) / ln(base)
	   *
	   * The maximum error of the result is 1 ulp (unit in the last place).
	   *
	   * [base] {number|string|Decimal} The base of the logarithm.
	   *
	   */
	  P.logarithm = P.log = function (base) {
	    var r,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision,
	      wpr = pr + 5;
	
	    // Default base is 10.
	    if (base === void 0) {
	      base = new Ctor(10);
	    } else {
	      base = new Ctor(base);
	
	      // log[-b](x) = NaN
	      // log[0](x)  = NaN
	      // log[1](x)  = NaN
	      if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
	    }
	
	    // log[b](-x) = NaN
	    // log[b](0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // log[b](1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    external = false;
	    r = divide(ln(x, wpr), ln(base, wpr), wpr);
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.minus = P.sub = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.modulo = P.mod = function (y) {
	    var q,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    y = new Ctor(y);
	
	    // x % 0 = NaN
	    if (!y.s) throw Error(decimalError + 'NaN');
	
	    // Return x if x is 0.
	    if (!x.s) return round(new Ctor(x), pr);
	
	    // Prevent rounding of intermediate calculations.
	    external = false;
	    q = divide(x, y, 0, 1).times(y);
	    external = true;
	
	    return x.minus(q);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
	   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.naturalExponential = P.exp = function () {
	    return exp(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
	   * truncated to `precision` significant digits.
	   *
	   */
	  P.naturalLogarithm = P.ln = function () {
	    return ln(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
	   * -1.
	   *
	   */
	  P.negated = P.neg = function () {
	    var x = new this.constructor(this);
	    x.s = -x.s || 0;
	    return x;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.plus = P.add = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return the number of significant digits of the value of this Decimal.
	   *
	   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
	   *
	   */
	  P.precision = P.sd = function (z) {
	    var e, sd, w,
	      x = this;
	
	    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
	
	    e = getBase10Exponent(x) + 1;
	    w = x.d.length - 1;
	    sd = w * LOG_BASE + 1;
	    w = x.d[w];
	
	    // If non-zero...
	    if (w) {
	
	      // Subtract the number of trailing zeros of the last word.
	      for (; w % 10 == 0; w /= 10) sd--;
	
	      // Add the number of digits of the first word.
	      for (w = x.d[0]; w >= 10; w /= 10) sd++;
	    }
	
	    return z && e > sd ? e : sd;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.squareRoot = P.sqrt = function () {
	    var e, n, pr, r, s, t, wpr,
	      x = this,
	      Ctor = x.constructor;
	
	    // Negative or zero?
	    if (x.s < 1) {
	      if (!x.s) return new Ctor(0);
	
	      // sqrt(-x) = NaN
	      throw Error(decimalError + 'NaN');
	    }
	
	    e = getBase10Exponent(x);
	    external = false;
	
	    // Initial estimate.
	    s = Math.sqrt(+x);
	
	    // Math.sqrt underflow/overflow?
	    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
	    if (s == 0 || s == 1 / 0) {
	      n = digitsToString(x.d);
	      if ((n.length + e) % 2 == 0) n += '0';
	      s = Math.sqrt(n);
	      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
	
	      if (s == 1 / 0) {
	        n = '1e' + e;
	      } else {
	        n = s.toExponential();
	        n = n.slice(0, n.indexOf('e') + 1) + e;
	      }
	
	      r = new Ctor(n);
	    } else {
	      r = new Ctor(s.toString());
	    }
	
	    pr = Ctor.precision;
	    s = wpr = pr + 3;
	
	    // Newton-Raphson iteration.
	    for (;;) {
	      t = r;
	      r = t.plus(divide(x, t, wpr + 2)).times(0.5);
	
	      if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
	        n = n.slice(wpr - 3, wpr + 1);
	
	        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
	        // 4999, i.e. approaching a rounding boundary, continue the iteration.
	        if (s == wpr && n == '4999') {
	
	          // On the first iteration only, check to see if rounding up gives the exact result as the
	          // nines may infinitely repeat.
	          round(t, pr + 1, 0);
	
	          if (t.times(t).eq(x)) {
	            r = t;
	            break;
	          }
	        } else if (n != '9999') {
	          break;
	        }
	
	        wpr += 4;
	      }
	    }
	
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.times = P.mul = function (y) {
	    var carry, e, i, k, r, rL, t, xdL, ydL,
	      x = this,
	      Ctor = x.constructor,
	      xd = x.d,
	      yd = (y = new Ctor(y)).d;
	
	    // Return 0 if either is 0.
	    if (!x.s || !y.s) return new Ctor(0);
	
	    y.s *= x.s;
	    e = x.e + y.e;
	    xdL = xd.length;
	    ydL = yd.length;
	
	    // Ensure xd points to the longer array.
	    if (xdL < ydL) {
	      r = xd;
	      xd = yd;
	      yd = r;
	      rL = xdL;
	      xdL = ydL;
	      ydL = rL;
	    }
	
	    // Initialise the result array with zeros.
	    r = [];
	    rL = xdL + ydL;
	    for (i = rL; i--;) r.push(0);
	
	    // Multiply!
	    for (i = ydL; --i >= 0;) {
	      carry = 0;
	      for (k = xdL + i; k > i;) {
	        t = r[k] + yd[i] * xd[k - i - 1] + carry;
	        r[k--] = t % BASE | 0;
	        carry = t / BASE | 0;
	      }
	
	      r[k] = (r[k] + carry) % BASE | 0;
	    }
	
	    // Remove trailing zeros.
	    for (; !r[--rL];) r.pop();
	
	    if (carry) ++e;
	    else r.shift();
	
	    y.d = r;
	    y.e = e;
	
	    return external ? round(y, Ctor.precision) : y;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
	   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
	   *
	   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toDecimalPlaces = P.todp = function (dp, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    x = new Ctor(x);
	    if (dp === void 0) return x;
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    return round(x, dp + getBase10Exponent(x) + 1, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in exponential notation rounded to
	   * `dp` fixed decimal places using rounding mode `rounding`.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toExponential = function (dp, rm) {
	    var str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) {
	      str = toString(x, true);
	    } else {
	      checkInt32(dp, 0, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), dp + 1, rm);
	      str = toString(x, true, dp + 1);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
	   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
	   * omitted.
	   *
	   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   * (-0).toFixed(3) is '0.000'.
	   * (-0.5).toFixed(0) is '-0'.
	   *
	   */
	  P.toFixed = function (dp, rm) {
	    var str, y,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) return toString(x);
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
	    str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
	
	    // To determine whether to add the minus sign look at the value before it was rounded,
	    // i.e. look at `x` rather than `y`.
	    return x.isneg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
	   * rounding mode `rounding`.
	   *
	   */
	  P.toInteger = P.toint = function () {
	    var x = this,
	      Ctor = x.constructor;
	    return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
	  };
	
	
	  /*
	   * Return the value of this Decimal converted to a number primitive.
	   *
	   */
	  P.toNumber = function () {
	    return +this;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
	   * truncated to `precision` significant digits.
	   *
	   * For non-integer or very large exponents pow(x, y) is calculated using
	   *
	   *   x^y = exp(y*ln(x))
	   *
	   * The maximum error is 1 ulp (unit in last place).
	   *
	   * y {number|string|Decimal} The power to which to raise this Decimal.
	   *
	   */
	  P.toPower = P.pow = function (y) {
	    var e, k, pr, r, sign, yIsInt,
	      x = this,
	      Ctor = x.constructor,
	      guard = 12,
	      yn = +(y = new Ctor(y));
	
	    // pow(x, 0) = 1
	    if (!y.s) return new Ctor(ONE);
	
	    x = new Ctor(x);
	
	    // pow(0, y > 0) = 0
	    // pow(0, y < 0) = Infinity
	    if (!x.s) {
	      if (y.s < 1) throw Error(decimalError + 'Infinity');
	      return x;
	    }
	
	    // pow(1, y) = 1
	    if (x.eq(ONE)) return x;
	
	    pr = Ctor.precision;
	
	    // pow(x, 1) = x
	    if (y.eq(ONE)) return round(x, pr);
	
	    e = y.e;
	    k = y.d.length - 1;
	    yIsInt = e >= k;
	    sign = x.s;
	
	    if (!yIsInt) {
	
	      // pow(x < 0, y non-integer) = NaN
	      if (sign < 0) throw Error(decimalError + 'NaN');
	
	    // If y is a small integer use the 'exponentiation by squaring' algorithm.
	    } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
	      r = new Ctor(ONE);
	
	      // Max k of 9007199254740991 takes 53 loop iterations.
	      // Maximum digits array length; leaves [28, 34] guard digits.
	      e = Math.ceil(pr / LOG_BASE + 4);
	
	      external = false;
	
	      for (;;) {
	        if (k % 2) {
	          r = r.times(x);
	          truncate(r.d, e);
	        }
	
	        k = mathfloor(k / 2);
	        if (k === 0) break;
	
	        x = x.times(x);
	        truncate(x.d, e);
	      }
	
	      external = true;
	
	      return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
	    }
	
	    // Result is negative if x is negative and the last digit of integer y is odd.
	    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
	
	    x.s = 1;
	    external = false;
	    r = y.times(ln(x, pr + guard));
	    external = true;
	    r = exp(r);
	    r.s = sign;
	
	    return r;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal rounded to `sd` significant digits
	   * using rounding mode `rounding`.
	   *
	   * Return exponential notation if `sd` is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toPrecision = function (sd, rm) {
	    var e, str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      e = getBase10Exponent(x);
	      str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), sd, rm);
	      e = getBase10Exponent(x);
	      str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
	   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
	   * omitted.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toSignificantDigits = P.tosd = function (sd, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      sd = Ctor.precision;
	      rm = Ctor.rounding;
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	    }
	
	    return round(new Ctor(x), sd, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal.
	   *
	   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
	   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
	   *
	   */
	  P.toString = P.valueOf = P.val = P.toJSON = function () {
	    var x = this,
	      e = getBase10Exponent(x),
	      Ctor = x.constructor;
	
	    return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	  };
	
	
	  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
	
	
	  /*
	   *  add                 P.minus, P.plus
	   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
	   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
	   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
	   *  exp                 P.exp, P.pow
	   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
	   *                      P.toString, divide, round, toString, exp, ln
	   *  getLn10             P.log, ln
	   *  getZeroString       digitsToString, toString
	   *  ln                  P.log, P.ln, P.pow, exp
	   *  parseDecimal        Decimal
	   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
	   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
	   *                      divide, getLn10, exp, ln
	   *  subtract            P.minus, P.plus
	   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
	   *  truncate            P.pow
	   *
	   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
	   *                      getLn10, exp, ln, parseDecimal, Decimal, config
	   */
	
	
	  function add(x, y) {
	    var carry, d, e, i, k, len, xd, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // If either is zero...
	    if (!x.s || !y.s) {
	
	      // Return x if y is zero.
	      // Return y if y is non-zero.
	      if (!y.s) y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are finite, non-zero numbers with the same sign.
	
	    k = x.e;
	    e = y.e;
	    xd = xd.slice();
	    i = k - e;
	
	    // If base 1e7 exponents differ...
	    if (i) {
	      if (i < 0) {
	        d = xd;
	        i = -i;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = k;
	        len = xd.length;
	      }
	
	      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
	      k = Math.ceil(pr / LOG_BASE);
	      len = k > len ? k + 1 : len + 1;
	
	      if (i > len) {
	        i = len;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
	      d.reverse();
	      for (; i--;) d.push(0);
	      d.reverse();
	    }
	
	    len = xd.length;
	    i = yd.length;
	
	    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
	    if (len - i < 0) {
	      i = len;
	      d = yd;
	      yd = xd;
	      xd = d;
	    }
	
	    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
	    for (carry = 0; i;) {
	      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
	      xd[i] %= BASE;
	    }
	
	    if (carry) {
	      xd.unshift(carry);
	      ++e;
	    }
	
	    // Remove trailing zeros.
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	    for (len = xd.length; xd[--len] == 0;) xd.pop();
	
	    y.d = xd;
	    y.e = e;
	
	    return external ? round(y, pr) : y;
	  }
	
	
	  function checkInt32(i, min, max) {
	    if (i !== ~~i || i < min || i > max) {
	      throw Error(invalidArgument + i);
	    }
	  }
	
	
	  function digitsToString(d) {
	    var i, k, ws,
	      indexOfLastWord = d.length - 1,
	      str = '',
	      w = d[0];
	
	    if (indexOfLastWord > 0) {
	      str += w;
	      for (i = 1; i < indexOfLastWord; i++) {
	        ws = d[i] + '';
	        k = LOG_BASE - ws.length;
	        if (k) str += getZeroString(k);
	        str += ws;
	      }
	
	      w = d[i];
	      ws = w + '';
	      k = LOG_BASE - ws.length;
	      if (k) str += getZeroString(k);
	    } else if (w === 0) {
	      return '0';
	    }
	
	    // Remove trailing zeros of last w.
	    for (; w % 10 === 0;) w /= 10;
	
	    return str + w;
	  }
	
	
	  var divide = (function () {
	
	    // Assumes non-zero x and k, and hence non-zero result.
	    function multiplyInteger(x, k) {
	      var temp,
	        carry = 0,
	        i = x.length;
	
	      for (x = x.slice(); i--;) {
	        temp = x[i] * k + carry;
	        x[i] = temp % BASE | 0;
	        carry = temp / BASE | 0;
	      }
	
	      if (carry) x.unshift(carry);
	
	      return x;
	    }
	
	    function compare(a, b, aL, bL) {
	      var i, r;
	
	      if (aL != bL) {
	        r = aL > bL ? 1 : -1;
	      } else {
	        for (i = r = 0; i < aL; i++) {
	          if (a[i] != b[i]) {
	            r = a[i] > b[i] ? 1 : -1;
	            break;
	          }
	        }
	      }
	
	      return r;
	    }
	
	    function subtract(a, b, aL) {
	      var i = 0;
	
	      // Subtract b from a.
	      for (; aL--;) {
	        a[aL] -= i;
	        i = a[aL] < b[aL] ? 1 : 0;
	        a[aL] = i * BASE + a[aL] - b[aL];
	      }
	
	      // Remove leading zeros.
	      for (; !a[0] && a.length > 1;) a.shift();
	    }
	
	    return function (x, y, pr, dp) {
	      var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
	        Ctor = x.constructor,
	        sign = x.s == y.s ? 1 : -1,
	        xd = x.d,
	        yd = y.d;
	
	      // Either 0?
	      if (!x.s) return new Ctor(x);
	      if (!y.s) throw Error(decimalError + 'Division by zero');
	
	      e = x.e - y.e;
	      yL = yd.length;
	      xL = xd.length;
	      q = new Ctor(sign);
	      qd = q.d = [];
	
	      // Result exponent may be one less than e.
	      for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
	      if (yd[i] > (xd[i] || 0)) --e;
	
	      if (pr == null) {
	        sd = pr = Ctor.precision;
	      } else if (dp) {
	        sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
	      } else {
	        sd = pr;
	      }
	
	      if (sd < 0) return new Ctor(0);
	
	      // Convert precision in number of base 10 digits to base 1e7 digits.
	      sd = sd / LOG_BASE + 2 | 0;
	      i = 0;
	
	      // divisor < 1e7
	      if (yL == 1) {
	        k = 0;
	        yd = yd[0];
	        sd++;
	
	        // k is the carry.
	        for (; (i < xL || k) && sd--; i++) {
	          t = k * BASE + (xd[i] || 0);
	          qd[i] = t / yd | 0;
	          k = t % yd | 0;
	        }
	
	      // divisor >= 1e7
	      } else {
	
	        // Normalise xd and yd so highest order digit of yd is >= BASE/2
	        k = BASE / (yd[0] + 1) | 0;
	
	        if (k > 1) {
	          yd = multiplyInteger(yd, k);
	          xd = multiplyInteger(xd, k);
	          yL = yd.length;
	          xL = xd.length;
	        }
	
	        xi = yL;
	        rem = xd.slice(0, yL);
	        remL = rem.length;
	
	        // Add zeros to make remainder as long as divisor.
	        for (; remL < yL;) rem[remL++] = 0;
	
	        yz = yd.slice();
	        yz.unshift(0);
	        yd0 = yd[0];
	
	        if (yd[1] >= BASE / 2) ++yd0;
	
	        do {
	          k = 0;
	
	          // Compare divisor and remainder.
	          cmp = compare(yd, rem, yL, remL);
	
	          // If divisor < remainder.
	          if (cmp < 0) {
	
	            // Calculate trial digit, k.
	            rem0 = rem[0];
	            if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
	
	            // k will be how many times the divisor goes into the current remainder.
	            k = rem0 / yd0 | 0;
	
	            //  Algorithm:
	            //  1. product = divisor * trial digit (k)
	            //  2. if product > remainder: product -= divisor, k--
	            //  3. remainder -= product
	            //  4. if product was < remainder at 2:
	            //    5. compare new remainder and divisor
	            //    6. If remainder > divisor: remainder -= divisor, k++
	
	            if (k > 1) {
	              if (k >= BASE) k = BASE - 1;
	
	              // product = divisor * trial digit.
	              prod = multiplyInteger(yd, k);
	              prodL = prod.length;
	              remL = rem.length;
	
	              // Compare product and remainder.
	              cmp = compare(prod, rem, prodL, remL);
	
	              // product > remainder.
	              if (cmp == 1) {
	                k--;
	
	                // Subtract divisor from product.
	                subtract(prod, yL < prodL ? yz : yd, prodL);
	              }
	            } else {
	
	              // cmp is -1.
	              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
	              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
	              if (k == 0) cmp = k = 1;
	              prod = yd.slice();
	            }
	
	            prodL = prod.length;
	            if (prodL < remL) prod.unshift(0);
	
	            // Subtract product from remainder.
	            subtract(rem, prod, remL);
	
	            // If product was < previous remainder.
	            if (cmp == -1) {
	              remL = rem.length;
	
	              // Compare divisor and new remainder.
	              cmp = compare(yd, rem, yL, remL);
	
	              // If divisor < new remainder, subtract divisor from remainder.
	              if (cmp < 1) {
	                k++;
	
	                // Subtract divisor from remainder.
	                subtract(rem, yL < remL ? yz : yd, remL);
	              }
	            }
	
	            remL = rem.length;
	          } else if (cmp === 0) {
	            k++;
	            rem = [0];
	          }    // if cmp === 1, k will be 0
	
	          // Add the next digit, k, to the result array.
	          qd[i++] = k;
	
	          // Update the remainder.
	          if (cmp && rem[0]) {
	            rem[remL++] = xd[xi] || 0;
	          } else {
	            rem = [xd[xi]];
	            remL = 1;
	          }
	
	        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
	      }
	
	      // Leading zero?
	      if (!qd[0]) qd.shift();
	
	      q.e = e;
	
	      return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
	    };
	  })();
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
	   * significant digits.
	   *
	   * Taylor/Maclaurin series.
	   *
	   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
	   *
	   * Argument reduction:
	   *   Repeat x = x / 32, k += 5, until |x| < 0.1
	   *   exp(x) = exp(x / 2^k)^(2^k)
	   *
	   * Previously, the argument was initially reduced by
	   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
	   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
	   * found to be slower than just dividing repeatedly by 32 as above.
	   *
	   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
	   *
	   *  exp(x) is non-terminating for any finite, non-zero x.
	   *
	   */
	  function exp(x, sd) {
	    var denominator, guard, pow, sum, t, wpr,
	      i = 0,
	      k = 0,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
	
	    // exp(0) = 1
	    if (!x.s) return new Ctor(ONE);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    t = new Ctor(0.03125);
	
	    while (x.abs().gte(0.1)) {
	      x = x.times(t);    // x = x / 2^5
	      k += 5;
	    }
	
	    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
	    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
	    wpr += guard;
	    denominator = pow = sum = new Ctor(ONE);
	    Ctor.precision = wpr;
	
	    for (;;) {
	      pow = round(pow.times(x), wpr);
	      denominator = denominator.times(++i);
	      t = sum.plus(divide(pow, denominator, wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        while (k--) sum = round(sum.times(sum), wpr);
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	    }
	  }
	
	
	  // Calculate the base 10 exponent from the base 1e7 exponent.
	  function getBase10Exponent(x) {
	    var e = x.e * LOG_BASE,
	      w = x.d[0];
	
	    // Add the number of digits of the first word of the digits array.
	    for (; w >= 10; w /= 10) e++;
	    return e;
	  }
	
	
	  function getLn10(Ctor, sd, pr) {
	
	    if (sd > Ctor.LN10.sd()) {
	
	
	      // Reset global state in case the exception is caught.
	      external = true;
	      if (pr) Ctor.precision = pr;
	      throw Error(decimalError + 'LN10 precision limit exceeded');
	    }
	
	    return round(new Ctor(Ctor.LN10), sd);
	  }
	
	
	  function getZeroString(k) {
	    var zs = '';
	    for (; k--;) zs += '0';
	    return zs;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
	   * digits.
	   *
	   *  ln(n) is non-terminating (n != 1)
	   *
	   */
	  function ln(y, sd) {
	    var c, c0, denominator, e, numerator, sum, t, wpr, x2,
	      n = 1,
	      guard = 10,
	      x = y,
	      xd = x.d,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // ln(-x) = NaN
	    // ln(0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // ln(1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    if (x.eq(10)) {
	      if (sd == null) external = true;
	      return getLn10(Ctor, wpr);
	    }
	
	    wpr += guard;
	    Ctor.precision = wpr;
	    c = digitsToString(xd);
	    c0 = c.charAt(0);
	    e = getBase10Exponent(x);
	
	    if (Math.abs(e) < 1.5e15) {
	
	      // Argument reduction.
	      // The series converges faster the closer the argument is to 1, so using
	      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
	      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
	      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
	      // later be divided by this number, then separate out the power of 10 using
	      // ln(a*10^b) = ln(a) + b*ln(10).
	
	      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
	      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
	      // max n is 6 (gives 0.7 - 1.3)
	      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
	        x = x.times(y);
	        c = digitsToString(x.d);
	        c0 = c.charAt(0);
	        n++;
	      }
	
	      e = getBase10Exponent(x);
	
	      if (c0 > 1) {
	        x = new Ctor('0.' + c);
	        e++;
	      } else {
	        x = new Ctor(c0 + '.' + c.slice(1));
	      }
	    } else {
	
	      // The argument reduction method above may result in overflow if the argument y is a massive
	      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
	      // function using ln(x*10^e) = ln(x) + e*ln(10).
	      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
	      x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
	
	      Ctor.precision = pr;
	      return sd == null ? (external = true, round(x, pr)) : x;
	    }
	
	    // x is reduced to a value near 1.
	
	    // Taylor series.
	    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
	    // where x = (y - 1)/(y + 1)    (|x| < 1)
	    sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
	    x2 = round(x.times(x), wpr);
	    denominator = 3;
	
	    for (;;) {
	      numerator = round(numerator.times(x2), wpr);
	      t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        sum = sum.times(2);
	
	        // Reverse the argument reduction.
	        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
	        sum = divide(sum, new Ctor(n), wpr);
	
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	      denominator += 2;
	    }
	  }
	
	
	  /*
	   * Parse the value of a new Decimal `x` from string `str`.
	   */
	  function parseDecimal(x, str) {
	    var e, i, len;
	
	    // Decimal point?
	    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
	
	    // Exponential form?
	    if ((i = str.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +str.slice(i + 1);
	      str = str.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = str.length;
	    }
	
	    // Determine leading zeros.
	    for (i = 0; str.charCodeAt(i) === 48;) ++i;
	
	    // Determine trailing zeros.
	    for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
	    str = str.slice(i, len);
	
	    if (str) {
	      len -= i;
	      e = e - i - 1;
	      x.e = mathfloor(e / LOG_BASE);
	      x.d = [];
	
	      // Transform base
	
	      // e is the base 10 exponent.
	      // i is where to slice str to get the first word of the digits array.
	      i = (e + 1) % LOG_BASE;
	      if (e < 0) i += LOG_BASE;
	
	      if (i < len) {
	        if (i) x.d.push(+str.slice(0, i));
	        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
	        str = str.slice(i);
	        i = LOG_BASE - str.length;
	      } else {
	        i -= len;
	      }
	
	      for (; i--;) str += '0';
	      x.d.push(+str);
	
	      if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
	    } else {
	
	      // Zero.
	      x.s = 0;
	      x.e = 0;
	      x.d = [0];
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
	   */
	   function round(x, sd, rm) {
	    var i, j, k, n, rd, doRound, w, xdi,
	      xd = x.d;
	
	    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
	    // w: the word of xd which contains the rounding digit, a base 1e7 number.
	    // xdi: the index of w within xd.
	    // n: the number of digits of w.
	    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
	    // they had leading zeros)
	    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
	
	    // Get the length of the first word of the digits array xd.
	    for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
	    i = sd - n;
	
	    // Is the rounding digit in the first word of xd?
	    if (i < 0) {
	      i += LOG_BASE;
	      j = sd;
	      w = xd[xdi = 0];
	    } else {
	      xdi = Math.ceil((i + 1) / LOG_BASE);
	      k = xd.length;
	      if (xdi >= k) return x;
	      w = k = xd[xdi];
	
	      // Get the number of digits of w.
	      for (n = 1; k >= 10; k /= 10) n++;
	
	      // Get the index of rd within w.
	      i %= LOG_BASE;
	
	      // Get the index of rd within w, adjusted for leading zeros.
	      // The number of leading zeros of w is given by LOG_BASE - n.
	      j = i - LOG_BASE + n;
	    }
	
	    if (rm !== void 0) {
	      k = mathpow(10, n - j - 1);
	
	      // Get the rounding digit at index j of w.
	      rd = w / k % 10 | 0;
	
	      // Are there any non-zero digits after the rounding digit?
	      doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
	
	      // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
	      // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
	      // 714.
	
	      doRound = rm < 4
	        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
	        : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&
	
	          // Check whether the digit to the left of the rounding digit is odd.
	          ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
	            rm == (x.s < 0 ? 8 : 7));
	    }
	
	    if (sd < 1 || !xd[0]) {
	      if (doRound) {
	        k = getBase10Exponent(x);
	        xd.length = 1;
	
	        // Convert sd to decimal places.
	        sd = sd - k - 1;
	
	        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
	        x.e = mathfloor(-sd / LOG_BASE) || 0;
	      } else {
	        xd.length = 1;
	
	        // Zero.
	        xd[0] = x.e = x.s = 0;
	      }
	
	      return x;
	    }
	
	    // Remove excess digits.
	    if (i == 0) {
	      xd.length = xdi;
	      k = 1;
	      xdi--;
	    } else {
	      xd.length = xdi + 1;
	      k = mathpow(10, LOG_BASE - i);
	
	      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
	      // j > 0 means i > number of leading zeros of w.
	      xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
	    }
	
	    if (doRound) {
	      for (;;) {
	
	        // Is the digit to be rounded up in the first word of xd?
	        if (xdi == 0) {
	          if ((xd[0] += k) == BASE) {
	            xd[0] = 1;
	            ++x.e;
	          }
	
	          break;
	        } else {
	          xd[xdi] += k;
	          if (xd[xdi] != BASE) break;
	          xd[xdi--] = 0;
	          k = 1;
	        }
	      }
	    }
	
	    // Remove trailing zeros.
	    for (i = xd.length; xd[--i] === 0;) xd.pop();
	
	    if (external && (x.e > MAX_E || x.e < -MAX_E)) {
	      throw Error(exponentOutOfRange + getBase10Exponent(x));
	    }
	
	    return x;
	  }
	
	
	  function subtract(x, y) {
	    var d, e, i, j, k, len, xd, xe, xLTy, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // Return y negated if x is zero.
	    // Return x if y is zero and x is non-zero.
	    if (!x.s || !y.s) {
	      if (y.s) y.s = -y.s;
	      else y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are non-zero numbers with the same sign.
	
	    e = y.e;
	    xe = x.e;
	    xd = xd.slice();
	    k = xe - e;
	
	    // If exponents differ...
	    if (k) {
	      xLTy = k < 0;
	
	      if (xLTy) {
	        d = xd;
	        k = -k;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = xe;
	        len = xd.length;
	      }
	
	      // Numbers with massively different exponents would result in a very high number of zeros
	      // needing to be prepended, but this can be avoided while still ensuring correct rounding by
	      // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
	      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
	
	      if (k > i) {
	        k = i;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents.
	      d.reverse();
	      for (i = k; i--;) d.push(0);
	      d.reverse();
	
	    // Base 1e7 exponents equal.
	    } else {
	
	      // Check digits to determine which is the bigger number.
	
	      i = xd.length;
	      len = yd.length;
	      xLTy = i < len;
	      if (xLTy) len = i;
	
	      for (i = 0; i < len; i++) {
	        if (xd[i] != yd[i]) {
	          xLTy = xd[i] < yd[i];
	          break;
	        }
	      }
	
	      k = 0;
	    }
	
	    if (xLTy) {
	      d = xd;
	      xd = yd;
	      yd = d;
	      y.s = -y.s;
	    }
	
	    len = xd.length;
	
	    // Append zeros to xd if shorter.
	    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
	    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
	
	    // Subtract yd from xd.
	    for (i = yd.length; i > k;) {
	      if (xd[--i] < yd[i]) {
	        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
	        --xd[j];
	        xd[i] += BASE;
	      }
	
	      xd[i] -= yd[i];
	    }
	
	    // Remove trailing zeros.
	    for (; xd[--len] === 0;) xd.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xd[0] === 0; xd.shift()) --e;
	
	    // Zero?
	    if (!xd[0]) return new Ctor(0);
	
	    y.d = xd;
	    y.e = e;
	
	    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
	    return external ? round(y, pr) : y;
	  }
	
	
	  function toString(x, isExp, sd) {
	    var k,
	      e = getBase10Exponent(x),
	      str = digitsToString(x.d),
	      len = str.length;
	
	    if (isExp) {
	      if (sd && (k = sd - len) > 0) {
	        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
	      } else if (len > 1) {
	        str = str.charAt(0) + '.' + str.slice(1);
	      }
	
	      str = str + (e < 0 ? 'e' : 'e+') + e;
	    } else if (e < 0) {
	      str = '0.' + getZeroString(-e - 1) + str;
	      if (sd && (k = sd - len) > 0) str += getZeroString(k);
	    } else if (e >= len) {
	      str += getZeroString(e + 1 - len);
	      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
	    } else {
	      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
	      if (sd && (k = sd - len) > 0) {
	        if (e + 1 === len) str += '.';
	        str += getZeroString(k);
	      }
	    }
	
	    return x.s < 0 ? '-' + str : str;
	  }
	
	
	  // Does not strip trailing zeros.
	  function truncate(arr, len) {
	    if (arr.length > len) {
	      arr.length = len;
	      return true;
	    }
	  }
	
	
	  // Decimal methods
	
	
	  /*
	   *  clone
	   *  config/set
	   */
	
	
	  /*
	   * Create and return a Decimal constructor with the same configuration properties as this Decimal
	   * constructor.
	   *
	   */
	  function clone(obj) {
	    var i, p, ps;
	
	    /*
	     * The Decimal constructor and exported function.
	     * Return a new Decimal instance.
	     *
	     * value {number|string|Decimal} A numeric value.
	     *
	     */
	    function Decimal(value) {
	      var x = this;
	
	      // Decimal called without new.
	      if (!(x instanceof Decimal)) return new Decimal(value);
	
	      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
	      // which points to Object.
	      x.constructor = Decimal;
	
	      // Duplicate.
	      if (value instanceof Decimal) {
	        x.s = value.s;
	        x.e = value.e;
	        x.d = (value = value.d) ? value.slice() : value;
	        return;
	      }
	
	      if (typeof value === 'number') {
	
	        // Reject Infinity/NaN.
	        if (value * 0 !== 0) {
	          throw Error(invalidArgument + value);
	        }
	
	        if (value > 0) {
	          x.s = 1;
	        } else if (value < 0) {
	          value = -value;
	          x.s = -1;
	        } else {
	          x.s = 0;
	          x.e = 0;
	          x.d = [0];
	          return;
	        }
	
	        // Fast path for small integers.
	        if (value === ~~value && value < 1e7) {
	          x.e = 0;
	          x.d = [value];
	          return;
	        }
	
	        return parseDecimal(x, value.toString());
	      } else if (typeof value !== 'string') {
	        throw Error(invalidArgument + value);
	      }
	
	      // Minus sign?
	      if (value.charCodeAt(0) === 45) {
	        value = value.slice(1);
	        x.s = -1;
	      } else {
	        x.s = 1;
	      }
	
	      if (isDecimal.test(value)) parseDecimal(x, value);
	      else throw Error(invalidArgument + value);
	    }
	
	    Decimal.prototype = P;
	
	    Decimal.ROUND_UP = 0;
	    Decimal.ROUND_DOWN = 1;
	    Decimal.ROUND_CEIL = 2;
	    Decimal.ROUND_FLOOR = 3;
	    Decimal.ROUND_HALF_UP = 4;
	    Decimal.ROUND_HALF_DOWN = 5;
	    Decimal.ROUND_HALF_EVEN = 6;
	    Decimal.ROUND_HALF_CEIL = 7;
	    Decimal.ROUND_HALF_FLOOR = 8;
	
	    Decimal.clone = clone;
	    Decimal.config = Decimal.set = config;
	
	    if (obj === void 0) obj = {};
	    if (obj) {
	      ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
	      for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
	    }
	
	    Decimal.config(obj);
	
	    return Decimal;
	  }
	
	
	  /*
	   * Configure global settings for a Decimal constructor.
	   *
	   * `obj` is an object with one or more of the following properties,
	   *
	   *   precision  {number}
	   *   rounding   {number}
	   *   toExpNeg   {number}
	   *   toExpPos   {number}
	   *
	   * E.g. Decimal.config({ precision: 20, rounding: 4 })
	   *
	   */
	  function config(obj) {
	    if (!obj || typeof obj !== 'object') {
	      throw Error(decimalError + 'Object expected');
	    }
	    var i, p, v,
	      ps = [
	        'precision', 1, MAX_DIGITS,
	        'rounding', 0, 8,
	        'toExpNeg', -1 / 0, 0,
	        'toExpPos', 0, 1 / 0
	      ];
	
	    for (i = 0; i < ps.length; i += 3) {
	      if ((v = obj[p = ps[i]]) !== void 0) {
	        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
	        else throw Error(invalidArgument + p + ': ' + v);
	      }
	    }
	
	    if ((v = obj[p = 'LN10']) !== void 0) {
	        if (v == Math.LN10) this[p] = new this(v);
	        else throw Error(invalidArgument + p + ': ' + v);
	    }
	
	    return this;
	  }
	
	
	  // Create and configure initial Decimal constructor.
	  Decimal = clone(Decimal);
	
	  Decimal['default'] = Decimal.Decimal = Decimal;
	
	  // Internal constant.
	  ONE = new Decimal(1);
	
	
	  // Export.
	
	
	  // AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return Decimal;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other environments that support module.exports.
	  } else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Decimal;
	
	    // Browser.
	  } else {
	    if (!globalScope) {
	      globalScope = typeof self != 'undefined' && self && self.self == self
	        ? self : Function('return this')();
	    }
	
	    globalScope.Decimal = Decimal;
	  }
	})(this);


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(139);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getVisibleRectForElement = __webpack_require__(585);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _adjustForViewport = __webpack_require__(1366);
	
	var _adjustForViewport2 = _interopRequireDefault(_adjustForViewport);
	
	var _getRegion = __webpack_require__(584);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	var _getElFuturePos = __webpack_require__(1370);
	
	var _getElFuturePos2 = _interopRequireDefault(_getElFuturePos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// http://yiminghe.iteye.com/blog/1124720
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	} /**
	   * align dom node flexibly
	   * @author yiminghe@gmail.com
	   */
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  _utils2['default'].each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n = void 0;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */
	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  // 当前节点可以被放置的显示区域
	  var visibleRect = (0, _getVisibleRectForElement2['default'])(source);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = (0, _getRegion2['default'])(source);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = _utils2['default'].merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/ig, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
	
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/ig, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
	
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, points, offset, targetOffset);
	      _utils2['default'].mix(newElRegion, elFuturePos);
	    }
	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
	    // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数
	    if (isStillFailX || isStillFailY) {
	      points = align.points;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    }
	    // 2. 只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = (0, _adjustForViewport2['default'])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    _utils2['default'].css(source, 'width', _utils2['default'].width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    _utils2['default'].css(source, 'height', _utils2['default'].height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  _utils2['default'].offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	
	exports['default'] = doAlign;
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	module.exports = exports['default'];

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(139);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	function getOffsetParent(element) {
	  if (_utils2['default'].isWindow(element) || element.nodeType === 9) {
	    return null;
	  }
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = _utils2['default'].getDocument(element);
	  var body = doc.body;
	  var parent = void 0;
	  var positionStyle = _utils2['default'].css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
	  }
	
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    positionStyle = _utils2['default'].css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	exports['default'] = getOffsetParent;
	module.exports = exports['default'];

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(139);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getRegion(node) {
	  var offset = void 0;
	  var w = void 0;
	  var h = void 0;
	  if (!_utils2['default'].isWindow(node) && node.nodeType !== 9) {
	    offset = _utils2['default'].offset(node);
	    w = _utils2['default'].outerWidth(node);
	    h = _utils2['default'].outerHeight(node);
	  } else {
	    var win = _utils2['default'].getWindow(node);
	    offset = {
	      left: _utils2['default'].getWindowScrollLeft(win),
	      top: _utils2['default'].getWindowScrollTop(win)
	    };
	    w = _utils2['default'].viewportWidth(win);
	    h = _utils2['default'].viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	exports['default'] = getRegion;
	module.exports = exports['default'];

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(139);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(583);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _isAncestorFixed = __webpack_require__(1372);
	
	var _isAncestorFixed2 = _interopRequireDefault(_isAncestorFixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = (0, _getOffsetParent2['default'])(element);
	  var doc = _utils2['default'].getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && _utils2['default'].css(el, 'overflow') !== 'visible') {
	      var pos = _utils2['default'].offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = (0, _getOffsetParent2['default'])(el);
	  }
	
	  // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	  var originalPosition = null;
	  if (!_utils2['default'].isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = _utils2['default'].css(element, 'position');
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	
	  var scrollX = _utils2['default'].getWindowScrollLeft(win);
	  var scrollY = _utils2['default'].getWindowScrollTop(win);
	  var viewportWidth = _utils2['default'].viewportWidth(win);
	  var viewportHeight = _utils2['default'].viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight;
	
	  // Reset element position after calculate the visible area
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	
	  if ((0, _isAncestorFixed2['default'])(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	exports['default'] = getVisibleRectForElement;
	module.exports = exports['default'];

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(587));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 587 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 588 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(140));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(174));
	
	var _style = _interopRequireDefault(__webpack_require__(392));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(140));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(1385));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(140));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 594 */
124,
/* 595 */
124,
/* 596 */
124,
/* 597 */
124,
/* 598 */
124,
/* 599 */
124,
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(87);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 601 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 602 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 603 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(272);
	
	var _PathUtils = __webpack_require__(224);
	
	var _createTransitionManager = __webpack_require__(396);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(603);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FontMetrics = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Util = __webpack_require__(178);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SAMPLE_TEXT = 'Hidden Text';
	
	var FontMetrics = exports.FontMetrics = function () {
	    function FontMetrics(document) {
	        _classCallCheck(this, FontMetrics);
	
	        this._data = {};
	        this._document = document;
	    }
	
	    _createClass(FontMetrics, [{
	        key: '_parseMetrics',
	        value: function _parseMetrics(font) {
	            var container = this._document.createElement('div');
	            var img = this._document.createElement('img');
	            var span = this._document.createElement('span');
	
	            var body = this._document.body;
	            if (!body) {
	                throw new Error( false ? 'No document found for font metrics' : '');
	            }
	
	            container.style.visibility = 'hidden';
	            container.style.fontFamily = font.fontFamily;
	            container.style.fontSize = font.fontSize;
	            container.style.margin = '0';
	            container.style.padding = '0';
	
	            body.appendChild(container);
	
	            img.src = _Util.SMALL_IMAGE;
	            img.width = 1;
	            img.height = 1;
	
	            img.style.margin = '0';
	            img.style.padding = '0';
	            img.style.verticalAlign = 'baseline';
	
	            span.style.fontFamily = font.fontFamily;
	            span.style.fontSize = font.fontSize;
	            span.style.margin = '0';
	            span.style.padding = '0';
	
	            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	            container.appendChild(span);
	            container.appendChild(img);
	            var baseline = img.offsetTop - span.offsetTop + 2;
	
	            container.removeChild(span);
	            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	
	            container.style.lineHeight = 'normal';
	            img.style.verticalAlign = 'super';
	
	            var middle = img.offsetTop - container.offsetTop + 2;
	
	            body.removeChild(container);
	
	            return { baseline: baseline, middle: middle };
	        }
	    }, {
	        key: 'getMetrics',
	        value: function getMetrics(font) {
	            var key = font.fontFamily + ' ' + font.fontSize;
	            if (this._data[key] === undefined) {
	                this._data[key] = this._parseMetrics(font);
	            }
	
	            return this._data[key];
	        }
	    }]);
	
	    return FontMetrics;
	}();

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reformatInputBounds = exports.inlineSelectElement = exports.inlineTextAreaElement = exports.inlineInputElement = exports.getInputBorderRadius = exports.INPUT_BACKGROUND = exports.INPUT_BORDERS = exports.INPUT_COLOR = undefined;
	
	var _TextContainer = __webpack_require__(274);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _background = __webpack_require__(225);
	
	var _border = __webpack_require__(398);
	
	var _Circle = __webpack_require__(1481);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _Vector = __webpack_require__(276);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _Color = __webpack_require__(125);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Length = __webpack_require__(143);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	var _Bounds = __webpack_require__(142);
	
	var _TextBounds = __webpack_require__(609);
	
	var _Util = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INPUT_COLOR = exports.INPUT_COLOR = new _Color2.default([42, 42, 42]);
	var INPUT_BORDER_COLOR = new _Color2.default([165, 165, 165]);
	var INPUT_BACKGROUND_COLOR = new _Color2.default([222, 222, 222]);
	var INPUT_BORDER = {
	    borderWidth: 1,
	    borderColor: INPUT_BORDER_COLOR,
	    borderStyle: _border.BORDER_STYLE.SOLID
	};
	var INPUT_BORDERS = exports.INPUT_BORDERS = [INPUT_BORDER, INPUT_BORDER, INPUT_BORDER, INPUT_BORDER];
	var INPUT_BACKGROUND = exports.INPUT_BACKGROUND = {
	    backgroundColor: INPUT_BACKGROUND_COLOR,
	    backgroundImage: [],
	    backgroundClip: _background.BACKGROUND_CLIP.PADDING_BOX,
	    backgroundOrigin: _background.BACKGROUND_ORIGIN.PADDING_BOX
	};
	
	var RADIO_BORDER_RADIUS = new _Length2.default('50%');
	var RADIO_BORDER_RADIUS_TUPLE = [RADIO_BORDER_RADIUS, RADIO_BORDER_RADIUS];
	var INPUT_RADIO_BORDER_RADIUS = [RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE];
	
	var CHECKBOX_BORDER_RADIUS = new _Length2.default('3px');
	var CHECKBOX_BORDER_RADIUS_TUPLE = [CHECKBOX_BORDER_RADIUS, CHECKBOX_BORDER_RADIUS];
	var INPUT_CHECKBOX_BORDER_RADIUS = [CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE];
	
	var getInputBorderRadius = exports.getInputBorderRadius = function getInputBorderRadius(node) {
	    return node.type === 'radio' ? INPUT_RADIO_BORDER_RADIUS : INPUT_CHECKBOX_BORDER_RADIUS;
	};
	
	var inlineInputElement = exports.inlineInputElement = function inlineInputElement(node, container) {
	    if (node.type === 'radio' || node.type === 'checkbox') {
	        if (node.checked) {
	            var size = Math.min(container.bounds.width, container.bounds.height);
	            container.childNodes.push(node.type === 'checkbox' ? [new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79), new _Vector2.default(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549), new _Vector2.default(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071), new _Vector2.default(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649), new _Vector2.default(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23), new _Vector2.default(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085), new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)] : new _Circle2.default(container.bounds.left + size / 4, container.bounds.top + size / 4, size / 4));
	        }
	    } else {
	        inlineFormElement(getInputValue(node), node, container, false);
	    }
	};
	
	var inlineTextAreaElement = exports.inlineTextAreaElement = function inlineTextAreaElement(node, container) {
	    inlineFormElement(node.value, node, container, true);
	};
	
	var inlineSelectElement = exports.inlineSelectElement = function inlineSelectElement(node, container) {
	    var option = node.options[node.selectedIndex || 0];
	    inlineFormElement(option ? option.text || '' : '', node, container, false);
	};
	
	var reformatInputBounds = exports.reformatInputBounds = function reformatInputBounds(bounds) {
	    if (bounds.width > bounds.height) {
	        bounds.left += (bounds.width - bounds.height) / 2;
	        bounds.width = bounds.height;
	    } else if (bounds.width < bounds.height) {
	        bounds.top += (bounds.height - bounds.width) / 2;
	        bounds.height = bounds.width;
	    }
	    return bounds;
	};
	
	var inlineFormElement = function inlineFormElement(value, node, container, allowLinebreak) {
	    var body = node.ownerDocument.body;
	    if (value.length > 0 && body) {
	        var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
	        (0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node, null), wrapper);
	        wrapper.style.position = 'absolute';
	        wrapper.style.left = container.bounds.left + 'px';
	        wrapper.style.top = container.bounds.top + 'px';
	        if (!allowLinebreak) {
	            wrapper.style.whiteSpace = 'nowrap';
	        }
	        var text = node.ownerDocument.createTextNode(value);
	        wrapper.appendChild(text);
	        body.appendChild(wrapper);
	        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
	        body.removeChild(wrapper);
	    }
	};
	
	var getInputValue = function getInputValue(node) {
	    var value = node.type === 'password' ? new Array(node.value.length + 1).join('\u2022') : node.value;
	
	    return value.length === 0 ? node.placeholder || '' : value;
	};

/***/ },
/* 607 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Logger = function () {
	    function Logger(enabled, id, start) {
	        _classCallCheck(this, Logger);
	
	        this.enabled = typeof window !== 'undefined' && enabled;
	        this.start = start ? start : Date.now();
	        this.id = id;
	    }
	
	    _createClass(Logger, [{
	        key: 'child',
	        value: function child(id) {
	            return new Logger(this.enabled, id, this.start);
	        }
	
	        // eslint-disable-next-line flowtype/no-weak-types
	
	    }, {
	        key: 'log',
	        value: function log() {
	            if (this.enabled && window.console && window.console.log) {
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                    args[_key] = arguments[_key];
	                }
	
	                Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
	            }
	        }
	
	        // eslint-disable-next-line flowtype/no-weak-types
	
	    }, {
	        key: 'error',
	        value: function error() {
	            if (this.enabled && window.console && window.console.error) {
	                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                    args[_key2] = arguments[_key2];
	                }
	
	                Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
	            }
	        }
	    }]);
	
	    return Logger;
	}();
	
	exports.default = Logger;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Proxy = undefined;
	
	var _Feature = __webpack_require__(273);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Proxy = exports.Proxy = function Proxy(src, options) {
	    if (!options.proxy) {
	        return Promise.reject( false ? 'No proxy defined' : null);
	    }
	    var proxy = options.proxy;
	
	    return new Promise(function (resolve, reject) {
	        var responseType = _Feature2.default.SUPPORT_CORS_XHR && _Feature2.default.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
	        var xhr = _Feature2.default.SUPPORT_CORS_XHR ? new XMLHttpRequest() : new XDomainRequest();
	        xhr.onload = function () {
	            if (xhr instanceof XMLHttpRequest) {
	                if (xhr.status === 200) {
	                    if (responseType === 'text') {
	                        resolve(xhr.response);
	                    } else {
	                        var reader = new FileReader();
	                        // $FlowFixMe
	                        reader.addEventListener('load', function () {
	                            return resolve(reader.result);
	                        }, false);
	                        // $FlowFixMe
	                        reader.addEventListener('error', function (e) {
	                            return reject(e);
	                        }, false);
	                        reader.readAsDataURL(xhr.response);
	                    }
	                } else {
	                    reject( false ? 'Failed to proxy resource ' + src.substring(0, 256) + ' with status code ' + xhr.status : '');
	                }
	            } else {
	                resolve(xhr.responseText);
	            }
	        };
	
	        xhr.onerror = reject;
	        xhr.open('GET', proxy + '?url=' + encodeURIComponent(src) + '&responseType=' + responseType);
	
	        if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
	            xhr.responseType = responseType;
	        }
	
	        if (options.imageTimeout) {
	            var timeout = options.imageTimeout;
	            xhr.timeout = timeout;
	            xhr.ontimeout = function () {
	                return reject( false ? 'Timed out (' + timeout + 'ms) proxying ' + src.substring(0, 256) : '');
	            };
	        }
	
	        xhr.send();
	    });
	};

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTextBounds = exports.TextBounds = undefined;
	
	var _Bounds = __webpack_require__(142);
	
	var _textDecoration = __webpack_require__(399);
	
	var _Feature = __webpack_require__(273);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Unicode = __webpack_require__(610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextBounds = exports.TextBounds = function TextBounds(text, bounds) {
	    _classCallCheck(this, TextBounds);
	
	    this.text = text;
	    this.bounds = bounds;
	};
	
	var parseTextBounds = exports.parseTextBounds = function parseTextBounds(value, parent, node) {
	    var letterRendering = parent.style.letterSpacing !== 0;
	    var textList = letterRendering ? (0, _Unicode.toCodePoints)(value).map(function (i) {
	        return (0, _Unicode.fromCodePoint)(i);
	    }) : (0, _Unicode.breakWords)(value, parent);
	    var length = textList.length;
	    var defaultView = node.parentNode ? node.parentNode.ownerDocument.defaultView : null;
	    var scrollX = defaultView ? defaultView.pageXOffset : 0;
	    var scrollY = defaultView ? defaultView.pageYOffset : 0;
	    var textBounds = [];
	    var offset = 0;
	    for (var i = 0; i < length; i++) {
	        var text = textList[i];
	        if (parent.style.textDecoration !== _textDecoration.TEXT_DECORATION.NONE || text.trim().length > 0) {
	            if (_Feature2.default.SUPPORT_RANGE_BOUNDS) {
	                textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length, scrollX, scrollY)));
	            } else {
	                var replacementNode = node.splitText(text.length);
	                textBounds.push(new TextBounds(text, getWrapperBounds(node, scrollX, scrollY)));
	                node = replacementNode;
	            }
	        } else if (!_Feature2.default.SUPPORT_RANGE_BOUNDS) {
	            node = node.splitText(text.length);
	        }
	        offset += text.length;
	    }
	    return textBounds;
	};
	
	var getWrapperBounds = function getWrapperBounds(node, scrollX, scrollY) {
	    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
	    wrapper.appendChild(node.cloneNode(true));
	    var parentNode = node.parentNode;
	    if (parentNode) {
	        parentNode.replaceChild(wrapper, node);
	        var bounds = (0, _Bounds.parseBounds)(wrapper, scrollX, scrollY);
	        if (wrapper.firstChild) {
	            parentNode.replaceChild(wrapper.firstChild, wrapper);
	        }
	        return bounds;
	    }
	    return new _Bounds.Bounds(0, 0, 0, 0);
	};
	
	var getRangeBounds = function getRangeBounds(node, offset, length, scrollX, scrollY) {
	    var range = node.ownerDocument.createRange();
	    range.setStart(node, offset);
	    range.setEnd(node, offset + length);
	    return _Bounds.Bounds.fromClientRect(range.getBoundingClientRect(), scrollX, scrollY);
	};

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.breakWords = exports.fromCodePoint = exports.toCodePoints = undefined;
	
	var _cssLineBreak = __webpack_require__(1343);
	
	Object.defineProperty(exports, 'toCodePoints', {
	    enumerable: true,
	    get: function get() {
	        return _cssLineBreak.toCodePoints;
	    }
	});
	Object.defineProperty(exports, 'fromCodePoint', {
	    enumerable: true,
	    get: function get() {
	        return _cssLineBreak.fromCodePoint;
	    }
	});
	
	var _NodeContainer = __webpack_require__(177);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _overflowWrap = __webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var breakWords = exports.breakWords = function breakWords(str, parent) {
	    var breaker = (0, _cssLineBreak.LineBreaker)(str, {
	        lineBreak: parent.style.lineBreak,
	        wordBreak: parent.style.overflowWrap === _overflowWrap.OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : parent.style.wordBreak
	    });
	
	    var words = [];
	    var bk = void 0;
	
	    while (!(bk = breaker.next()).done) {
	        words.push(bk.value.slice());
	    }
	
	    return words;
	};

/***/ },
/* 611 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OVERFLOW_WRAP = exports.OVERFLOW_WRAP = {
	    NORMAL: 0,
	    BREAK_WORD: 1
	};
	
	var parseOverflowWrap = exports.parseOverflowWrap = function parseOverflowWrap(overflow) {
	    switch (overflow) {
	        case 'break-word':
	            return OVERFLOW_WRAP.BREAK_WORD;
	        case 'normal':
	        default:
	            return OVERFLOW_WRAP.NORMAL;
	    }
	};

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parsePadding = exports.PADDING_SIDES = undefined;
	
	var _Length = __webpack_require__(143);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PADDING_SIDES = exports.PADDING_SIDES = {
	    TOP: 0,
	    RIGHT: 1,
	    BOTTOM: 2,
	    LEFT: 3
	};
	
	var SIDES = ['top', 'right', 'bottom', 'left'];
	
	var parsePadding = exports.parsePadding = function parsePadding(style) {
	    return SIDES.map(function (side) {
	        return new _Length2.default(style.getPropertyValue('padding-' + side));
	    });
	};

/***/ },
/* 613 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var POSITION = exports.POSITION = {
	    STATIC: 0,
	    RELATIVE: 1,
	    ABSOLUTE: 2,
	    FIXED: 3,
	    STICKY: 4
	};
	
	var parsePosition = exports.parsePosition = function parsePosition(position) {
	    switch (position) {
	        case 'relative':
	            return POSITION.RELATIVE;
	        case 'absolute':
	            return POSITION.ABSOLUTE;
	        case 'fixed':
	            return POSITION.FIXED;
	        case 'sticky':
	            return POSITION.STICKY;
	    }
	
	    return POSITION.STATIC;
	};

/***/ },
/* 614 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TEXT_TRANSFORM = exports.TEXT_TRANSFORM = {
	    NONE: 0,
	    LOWERCASE: 1,
	    UPPERCASE: 2,
	    CAPITALIZE: 3
	};
	
	var parseTextTransform = exports.parseTextTransform = function parseTextTransform(textTransform) {
	    switch (textTransform) {
	        case 'uppercase':
	            return TEXT_TRANSFORM.UPPERCASE;
	        case 'lowercase':
	            return TEXT_TRANSFORM.LOWERCASE;
	        case 'capitalize':
	            return TEXT_TRANSFORM.CAPITALIZE;
	    }
	
	    return TEXT_TRANSFORM.NONE;
	};

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Path = __webpack_require__(275);
	
	var _textDecoration = __webpack_require__(399);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var addColorStops = function addColorStops(gradient, canvasGradient) {
	    var maxStop = Math.max.apply(null, gradient.colorStops.map(function (colorStop) {
	        return colorStop.stop;
	    }));
	    var f = 1 / Math.max(1, maxStop);
	    gradient.colorStops.forEach(function (colorStop) {
	        canvasGradient.addColorStop(f * colorStop.stop, colorStop.color.toString());
	    });
	};
	
	var CanvasRenderer = function () {
	    function CanvasRenderer(canvas) {
	        _classCallCheck(this, CanvasRenderer);
	
	        this.canvas = canvas ? canvas : document.createElement('canvas');
	    }
	
	    _createClass(CanvasRenderer, [{
	        key: 'render',
	        value: function render(options) {
	            this.ctx = this.canvas.getContext('2d');
	            this.options = options;
	            this.canvas.width = Math.floor(options.width * options.scale);
	            this.canvas.height = Math.floor(options.height * options.scale);
	            this.canvas.style.width = options.width + 'px';
	            this.canvas.style.height = options.height + 'px';
	
	            this.ctx.scale(this.options.scale, this.options.scale);
	            this.ctx.translate(-options.x, -options.y);
	            this.ctx.textBaseline = 'bottom';
	            options.logger.log('Canvas renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + this.options.scale);
	        }
	    }, {
	        key: 'clip',
	        value: function clip(clipPaths, callback) {
	            var _this = this;
	
	            if (clipPaths.length) {
	                this.ctx.save();
	                clipPaths.forEach(function (path) {
	                    _this.path(path);
	                    _this.ctx.clip();
	                });
	            }
	
	            callback();
	
	            if (clipPaths.length) {
	                this.ctx.restore();
	            }
	        }
	    }, {
	        key: 'drawImage',
	        value: function drawImage(image, source, destination) {
	            this.ctx.drawImage(image, source.left, source.top, source.width, source.height, destination.left, destination.top, destination.width, destination.height);
	        }
	    }, {
	        key: 'drawShape',
	        value: function drawShape(path, color) {
	            this.path(path);
	            this.ctx.fillStyle = color.toString();
	            this.ctx.fill();
	        }
	    }, {
	        key: 'fill',
	        value: function fill(color) {
	            this.ctx.fillStyle = color.toString();
	            this.ctx.fill();
	        }
	    }, {
	        key: 'getTarget',
	        value: function getTarget() {
	            this.canvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
	            return Promise.resolve(this.canvas);
	        }
	    }, {
	        key: 'path',
	        value: function path(_path) {
	            var _this2 = this;
	
	            this.ctx.beginPath();
	            if (Array.isArray(_path)) {
	                _path.forEach(function (point, index) {
	                    var start = point.type === _Path.PATH.VECTOR ? point : point.start;
	                    if (index === 0) {
	                        _this2.ctx.moveTo(start.x, start.y);
	                    } else {
	                        _this2.ctx.lineTo(start.x, start.y);
	                    }
	
	                    if (point.type === _Path.PATH.BEZIER_CURVE) {
	                        _this2.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
	                    }
	                });
	            } else {
	                this.ctx.arc(_path.x + _path.radius, _path.y + _path.radius, _path.radius, 0, Math.PI * 2, true);
	            }
	
	            this.ctx.closePath();
	        }
	    }, {
	        key: 'rectangle',
	        value: function rectangle(x, y, width, height, color) {
	            this.ctx.fillStyle = color.toString();
	            this.ctx.fillRect(x, y, width, height);
	        }
	    }, {
	        key: 'renderLinearGradient',
	        value: function renderLinearGradient(bounds, gradient) {
	            var linearGradient = this.ctx.createLinearGradient(bounds.left + gradient.direction.x1, bounds.top + gradient.direction.y1, bounds.left + gradient.direction.x0, bounds.top + gradient.direction.y0);
	
	            addColorStops(gradient, linearGradient);
	            this.ctx.fillStyle = linearGradient;
	            this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
	        }
	    }, {
	        key: 'renderRadialGradient',
	        value: function renderRadialGradient(bounds, gradient) {
	            var _this3 = this;
	
	            var x = bounds.left + gradient.center.x;
	            var y = bounds.top + gradient.center.y;
	
	            var radialGradient = this.ctx.createRadialGradient(x, y, 0, x, y, gradient.radius.x);
	            if (!radialGradient) {
	                return;
	            }
	
	            addColorStops(gradient, radialGradient);
	            this.ctx.fillStyle = radialGradient;
	
	            if (gradient.radius.x !== gradient.radius.y) {
	                // transforms for elliptical radial gradient
	                var midX = bounds.left + 0.5 * bounds.width;
	                var midY = bounds.top + 0.5 * bounds.height;
	                var f = gradient.radius.y / gradient.radius.x;
	                var invF = 1 / f;
	
	                this.transform(midX, midY, [1, 0, 0, f, 0, 0], function () {
	                    return _this3.ctx.fillRect(bounds.left, invF * (bounds.top - midY) + midY, bounds.width, bounds.height * invF);
	                });
	            } else {
	                this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
	            }
	        }
	    }, {
	        key: 'renderRepeat',
	        value: function renderRepeat(path, image, imageSize, offsetX, offsetY) {
	            this.path(path);
	            this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(image, imageSize), 'repeat');
	            this.ctx.translate(offsetX, offsetY);
	            this.ctx.fill();
	            this.ctx.translate(-offsetX, -offsetY);
	        }
	    }, {
	        key: 'renderTextNode',
	        value: function renderTextNode(textBounds, color, font, textDecoration, textShadows) {
	            var _this4 = this;
	
	            this.ctx.font = [font.fontStyle, font.fontVariant, font.fontWeight, font.fontSize, font.fontFamily].join(' ');
	
	            textBounds.forEach(function (text) {
	                _this4.ctx.fillStyle = color.toString();
	                if (textShadows && text.text.trim().length) {
	                    textShadows.slice(0).reverse().forEach(function (textShadow) {
	                        _this4.ctx.shadowColor = textShadow.color.toString();
	                        _this4.ctx.shadowOffsetX = textShadow.offsetX * _this4.options.scale;
	                        _this4.ctx.shadowOffsetY = textShadow.offsetY * _this4.options.scale;
	                        _this4.ctx.shadowBlur = textShadow.blur;
	
	                        _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
	                    });
	                } else {
	                    _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
	                }
	
	                if (textDecoration !== null) {
	                    var textDecorationColor = textDecoration.textDecorationColor || color;
	                    textDecoration.textDecorationLine.forEach(function (textDecorationLine) {
	                        switch (textDecorationLine) {
	                            case _textDecoration.TEXT_DECORATION_LINE.UNDERLINE:
	                                // Draws a line at the baseline of the font
	                                // TODO As some browsers display the line as more than 1px if the font-size is big,
	                                // need to take that into account both in position and size
	                                var _options$fontMetrics$ = _this4.options.fontMetrics.getMetrics(font),
	                                    baseline = _options$fontMetrics$.baseline;
	
	                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1, textDecorationColor);
	                                break;
	                            case _textDecoration.TEXT_DECORATION_LINE.OVERLINE:
	                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1, textDecorationColor);
	                                break;
	                            case _textDecoration.TEXT_DECORATION_LINE.LINE_THROUGH:
	                                // TODO try and find exact position for line-through
	                                var _options$fontMetrics$2 = _this4.options.fontMetrics.getMetrics(font),
	                                    middle = _options$fontMetrics$2.middle;
	
	                                _this4.rectangle(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1, textDecorationColor);
	                                break;
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'resizeImage',
	        value: function resizeImage(image, size) {
	            if (image.width === size.width && image.height === size.height) {
	                return image;
	            }
	
	            var canvas = this.canvas.ownerDocument.createElement('canvas');
	            canvas.width = size.width;
	            canvas.height = size.height;
	            var ctx = canvas.getContext('2d');
	            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height);
	            return canvas;
	        }
	    }, {
	        key: 'setOpacity',
	        value: function setOpacity(opacity) {
	            this.ctx.globalAlpha = opacity;
	        }
	    }, {
	        key: 'transform',
	        value: function transform(offsetX, offsetY, matrix, callback) {
	            this.ctx.save();
	            this.ctx.translate(offsetX, offsetY);
	            this.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	            this.ctx.translate(-offsetX, -offsetY);
	
	            callback();
	
	            this.ctx.restore();
	        }
	    }]);
	
	    return CanvasRenderer;
	}();
	
	exports.default = CanvasRenderer;

/***/ },
/* 616 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ForeignObjectRenderer = function () {
	    function ForeignObjectRenderer(element) {
	        _classCallCheck(this, ForeignObjectRenderer);
	
	        this.element = element;
	    }
	
	    _createClass(ForeignObjectRenderer, [{
	        key: 'render',
	        value: function render(options) {
	            var _this = this;
	
	            this.options = options;
	            this.canvas = document.createElement('canvas');
	            this.ctx = this.canvas.getContext('2d');
	            this.canvas.width = Math.floor(options.width) * options.scale;
	            this.canvas.height = Math.floor(options.height) * options.scale;
	            this.canvas.style.width = options.width + 'px';
	            this.canvas.style.height = options.height + 'px';
	
	            options.logger.log('ForeignObject renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + options.scale);
	            var svg = createForeignObjectSVG(Math.max(options.windowWidth, options.width) * options.scale, Math.max(options.windowHeight, options.height) * options.scale, options.scrollX * options.scale, options.scrollY * options.scale, this.element);
	
	            return loadSerializedSVG(svg).then(function (img) {
	                if (options.backgroundColor) {
	                    _this.ctx.fillStyle = options.backgroundColor.toString();
	                    _this.ctx.fillRect(0, 0, options.width * options.scale, options.height * options.scale);
	                }
	
	                _this.ctx.drawImage(img, -options.x * options.scale, -options.y * options.scale);
	                return _this.canvas;
	            });
	        }
	    }]);
	
	    return ForeignObjectRenderer;
	}();
	
	exports.default = ForeignObjectRenderer;
	var createForeignObjectSVG = exports.createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
	    var xmlns = 'http://www.w3.org/2000/svg';
	    var svg = document.createElementNS(xmlns, 'svg');
	    var foreignObject = document.createElementNS(xmlns, 'foreignObject');
	    svg.setAttributeNS(null, 'width', width);
	    svg.setAttributeNS(null, 'height', height);
	
	    foreignObject.setAttributeNS(null, 'width', '100%');
	    foreignObject.setAttributeNS(null, 'height', '100%');
	    foreignObject.setAttributeNS(null, 'x', x);
	    foreignObject.setAttributeNS(null, 'y', y);
	    foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
	    svg.appendChild(foreignObject);
	
	    foreignObject.appendChild(node);
	
	    return svg;
	};
	
	var loadSerializedSVG = exports.loadSerializedSVG = function loadSerializedSVG(svg) {
	    return new Promise(function (resolve, reject) {
	        var img = new Image();
	        img.onload = function () {
	            return resolve(img);
	        };
	        img.onerror = reject;
	
	        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg));
	    });
	};

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 618 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 619 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ },
/* 620 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(1032);
	module.exports = self.fetch.bind(self);


/***/ },
/* 622 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 623 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 624 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 625 */
[3178, 149, 88],
/* 626 */
[3181, 88],
/* 627 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 628 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1568),
	    isArguments = __webpack_require__(231),
	    isArray = __webpack_require__(29),
	    isBuffer = __webpack_require__(232),
	    isIndex = __webpack_require__(229),
	    isTypedArray = __webpack_require__(296);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 630 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(226),
	    eq = __webpack_require__(184);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 632 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(280),
	    arrayEach = __webpack_require__(627),
	    assignValue = __webpack_require__(282),
	    baseAssign = __webpack_require__(1532),
	    baseAssignIn = __webpack_require__(1533),
	    cloneBuffer = __webpack_require__(644),
	    copyArray = __webpack_require__(408),
	    copySymbols = __webpack_require__(1577),
	    copySymbolsIn = __webpack_require__(1578),
	    getAllKeys = __webpack_require__(651),
	    getAllKeysIn = __webpack_require__(652),
	    getTag = __webpack_require__(228),
	    initCloneArray = __webpack_require__(1598),
	    initCloneByTag = __webpack_require__(1599),
	    initCloneObject = __webpack_require__(655),
	    isArray = __webpack_require__(29),
	    isBuffer = __webpack_require__(232),
	    isMap = __webpack_require__(1638),
	    isObject = __webpack_require__(53),
	    isSet = __webpack_require__(1641),
	    keys = __webpack_require__(152);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 634 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 635 */
[3187, 1582],
/* 636 */
[3188, 635, 152],
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(281),
	    isArray = __webpack_require__(29);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 638 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ },
/* 639 */
[3192, 230, 1615],
/* 640 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(145),
	    isArrayLike = __webpack_require__(106);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(144),
	    baseIteratee = __webpack_require__(60),
	    baseMap = __webpack_require__(641),
	    baseSortBy = __webpack_require__(1565),
	    baseUnary = __webpack_require__(147),
	    compareMultiple = __webpack_require__(1576),
	    identity = __webpack_require__(151);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(181),
	    last = __webpack_require__(669),
	    parent = __webpack_require__(1618),
	    toKey = __webpack_require__(183);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(88);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)(module)))

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(407);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 646 */
[3198, 227, 182],
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(149);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(279),
	    arraySome = __webpack_require__(630),
	    cacheHas = __webpack_require__(288);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 649 */
[3200, 1636, 659, 661],
/* 650 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(637),
	    getSymbols = __webpack_require__(410),
	    keys = __webpack_require__(152);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(637),
	    getSymbolsIn = __webpack_require__(653),
	    keysIn = __webpack_require__(297);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(281),
	    getPrototype = __webpack_require__(409),
	    getSymbols = __webpack_require__(410),
	    stubArray = __webpack_require__(676);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 654 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1534),
	    getPrototype = __webpack_require__(409),
	    isPrototype = __webpack_require__(230);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 656 */
[3211, 53],
/* 657 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 658 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 659 */
[3224, 1526],
/* 660 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ },
/* 661 */
[3226, 1563, 1621],
/* 662 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(1535),
	    baseFlatten = __webpack_require__(146),
	    baseRest = __webpack_require__(227),
	    isArrayLikeObject = __webpack_require__(292);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(1528),
	    baseEvery = __webpack_require__(1536),
	    baseIteratee = __webpack_require__(60),
	    isArray = __webpack_require__(29),
	    isIterateeCall = __webpack_require__(182);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(146),
	    map = __webpack_require__(23);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 666 */
[3232, 1538, 1592],
/* 667 */
/***/ function(module, exports) {

	/**
	 * Gets the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias first
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the first element of `array`.
	 * @example
	 *
	 * _.head([1, 2, 3]);
	 * // => 1
	 *
	 * _.head([]);
	 * // => undefined
	 */
	function head(array) {
	  return (array && array.length) ? array[0] : undefined;
	}
	
	module.exports = head;


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(144),
	    baseIntersection = __webpack_require__(1540),
	    baseRest = __webpack_require__(227),
	    castArrayLikeObject = __webpack_require__(1569);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 669 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(284),
	    baseGt = __webpack_require__(638),
	    identity = __webpack_require__(151);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(1553),
	    createAssigner = __webpack_require__(646);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(284),
	    baseLt = __webpack_require__(640),
	    identity = __webpack_require__(151);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(642),
	    isArray = __webpack_require__(29);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(1584);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 675 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeReverse = arrayProto.reverse;
	
	/**
	 * Reverses `array` so that the first element becomes the last, the second
	 * element becomes the second to last, and so on.
	 *
	 * **Note:** This method mutates `array` and is based on
	 * [`Array#reverse`](https://mdn.io/Array/reverse).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [1, 2, 3];
	 *
	 * _.reverse(array);
	 * // => [3, 2, 1]
	 *
	 * console.log(array);
	 * // => [3, 2, 1]
	 */
	function reverse(array) {
	  return array == null ? array : nativeReverse.call(array);
	}
	
	module.exports = reverse;


/***/ },
/* 676 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(60),
	    baseSum = __webpack_require__(1567);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(286),
	    toInteger = __webpack_require__(300);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ },
/* 679 */
[3239, 680],
/* 680 */
[3241, 53, 187],
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Avatar = __webpack_require__(1660);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var selected = props.selected;
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var color = selected ? bottomNavigation.selectedColor : bottomNavigation.unselectedColor;
	
	  var styles = {
	    root: {
	      transition: 'padding-top 0.3s',
	      paddingTop: selected ? 6 : 8,
	      paddingBottom: 10,
	      paddingLeft: 12,
	      paddingRight: 12,
	      minWidth: 80,
	      maxWidth: 168
	    },
	    label: {
	      fontSize: selected ? bottomNavigation.selectedFontSize : bottomNavigation.unselectedFontSize,
	      transition: 'color 0.3s, font-size 0.3s',
	      color: color
	    },
	    icon: {
	      display: 'block',
	      /**
	       * Used to ensure SVG icons are centered
	       */
	      width: '100%'
	    },
	    iconColor: color
	  };
	
	  return styles;
	}
	
	var BottomNavigationItem = function BottomNavigationItem(props, context) {
	  var label = props.label,
	      icon = props.icon,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['label', 'icon', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var styledIcon = (0, _react.cloneElement)(icon, {
	    style: (0, _simpleAssign2.default)({}, styles.icon, icon.props.style),
	    color: icon.props.color || styles.iconColor
	  });
	
	  return _react2.default.createElement(
	    _EnhancedButton2.default,
	    (0, _extends3.default)({}, other, { style: (0, _simpleAssign2.default)({}, styles.root, style) }),
	    styledIcon,
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles(styles.label) },
	      label
	    )
	  );
	};
	
	BottomNavigationItem.propTypes =  false ? {
	  /**
	   * Set the icon representing the view for this item.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Set the label describing the view for this item.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	BottomNavigationItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = BottomNavigationItem;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      padding: 8,
	      position: 'relative'
	    },
	    action: {
	      marginRight: 8
	    }
	  };
	}
	
	var CardActions = function (_Component) {
	  (0, _inherits3.default)(CardActions, _Component);
	
	  function CardActions() {
	    (0, _classCallCheck3.default)(this, CardActions);
	    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        styledChildren
	      );
	    }
	  }]);
	  return CardActions;
	}(_react.Component);
	
	CardActions.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardActions.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Action.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardActions;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keyboardArrowUp = __webpack_require__(722);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(721);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _IconButton = __webpack_require__(189);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      top: 0,
	      bottom: 0,
	      right: 4,
	      margin: 'auto',
	      position: 'absolute'
	    }
	  };
	}
	
	var CardExpandable = function (_Component) {
	  (0, _inherits3.default)(CardExpandable, _Component);
	
	  function CardExpandable() {
	    (0, _classCallCheck3.default)(this, CardExpandable);
	    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardExpandable, [{
	    key: 'render',
	    value: function render() {
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          onClick: this.props.onExpanding,
	          iconStyle: this.props.iconStyle
	        },
	        this.props.expanded ? this.props.openIcon : this.props.closeIcon
	      );
	    }
	  }]);
	  return CardExpandable;
	}(_react.Component);
	
	CardExpandable.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardExpandable.defaultProps = {
	  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
	  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
	};
	CardExpandable.propTypes =  false ? {
	  closeIcon: _propTypes2.default.node,
	  expanded: _propTypes2.default.bool,
	  iconStyle: _propTypes2.default.object,
	  onExpanding: _propTypes2.default.func.isRequired,
	  openIcon: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardExpandable;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Avatar = __webpack_require__(681);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontWeight: card.fontWeight,
	      boxSizing: 'border-box',
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    text: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      whiteSpace: 'normal',
	      paddingRight: '90px'
	    },
	    avatar: {
	      marginRight: 16
	    },
	    title: {
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      fontSize: 15
	    },
	    subtitle: {
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block',
	      fontSize: 14
	    }
	  };
	}
	
	var CardHeader = function (_Component) {
	  (0, _inherits3.default)(CardHeader, _Component);
	
	  function CardHeader() {
	    (0, _classCallCheck3.default)(this, CardHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          avatarProp = _props.avatar,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          openIcon = _props.openIcon,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          textStyle = _props.textStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle', 'iconStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var avatar = avatarProp;
	
	      if ((0, _react.isValidElement)(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatar, {
	          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
	        });
	      } else if (avatar !== null) {
	        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        avatar,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	            subtitle
	          )
	        ),
	        children
	      );
	    }
	  }]);
	  return CardHeader;
	}(_react.Component);
	
	CardHeader.muiName = 'CardHeader';
	CardHeader.defaultProps = {
	  avatar: null
	};
	CardHeader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardHeader.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
	   * If `avatar` is an `Avatar` or other element, it will be rendered.
	   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
	   */
	  avatar: _propTypes2.default.node,
	  /**
	   * Can be used to render elements inside the Card Header.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the iconStyle of the Icon Button.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
	   */
	  openIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Can be used to render a subtitle in Card Header.
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the text.
	   */
	  textStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render a title in Card Header.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = CardHeader;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardMedia = context.muiTheme.cardMedia;
	
	
	  return {
	    root: {
	      position: 'relative'
	    },
	    overlayContainer: {
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0
	    },
	    overlay: {
	      height: '100%',
	      position: 'relative'
	    },
	    overlayContent: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      left: 0,
	      paddingTop: 8,
	      background: cardMedia.overlayContentBackground
	    },
	    media: {},
	    mediaChild: {
	      verticalAlign: 'top',
	      maxWidth: '100%',
	      minWidth: '100%',
	      width: '100%'
	    }
	  };
	}
	
	var CardMedia = function (_Component) {
	  (0, _inherits3.default)(CardMedia, _Component);
	
	  function CardMedia() {
	    (0, _classCallCheck3.default)(this, CardMedia);
	    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          mediaStyle = _props.mediaStyle,
	          overlay = _props.overlay,
	          overlayContainerStyle = _props.overlayContainerStyle,
	          overlayContentStyle = _props.overlayContentStyle,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
	      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
	      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
	      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      var titleColor = this.context.muiTheme.cardMedia.titleColor;
	      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
	      var color = this.context.muiTheme.cardMedia.color;
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (!child) {
	          return child;
	        }
	
	        return _react2.default.cloneElement(child, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
	        });
	      });
	
	      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
	        var childMuiName = child && child.type ? child.type.muiName : null;
	
	        if (childMuiName === 'CardHeader' || childMuiName === 'CardTitle') {
	          return _react2.default.cloneElement(child, {
	            titleColor: titleColor,
	            subtitleColor: subtitleColor
	          });
	        } else if (childMuiName === 'CardText') {
	          return _react2.default.cloneElement(child, {
	            color: color
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedMediaStyle) },
	          styledChildren
	        ),
	        overlay ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedOverlayContainerStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(extendedOverlayStyle) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(extendedOverlayContentStyle) },
	              overlayChildren
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	  return CardMedia;
	}(_react.Component);
	
	CardMedia.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardMedia.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Media.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the Card Media.
	   */
	  mediaStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render overlay element in Card Media.
	   */
	  overlay: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the overlay container.
	   */
	  overlayContainerStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the overlay content.
	   */
	  overlayContentStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the overlay element.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardMedia;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardText = context.muiTheme.cardText;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontSize: 14,
	      color: props.color || cardText.textColor
	    }
	  };
	}
	
	var CardText = function (_Component) {
	  (0, _inherits3.default)(CardText, _Component);
	
	  function CardText() {
	    (0, _classCallCheck3.default)(this, CardText);
	    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          color = _props.color,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        children
	      );
	    }
	  }]);
	  return CardText;
	}(_react.Component);
	
	CardText.muiName = 'CardText';
	CardText.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardText.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Text.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the CardText color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardText;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      position: 'relative'
	    },
	    title: {
	      fontSize: 24,
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      lineHeight: '36px'
	    },
	    subtitle: {
	      fontSize: 14,
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block'
	    }
	  };
	}
	
	var CardTitle = function (_Component) {
	  (0, _inherits3.default)(CardTitle, _Component);
	
	  function CardTitle() {
	    (0, _classCallCheck3.default)(this, CardTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'closeIcon', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
	      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
	      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedTitleStyle) },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedSubtitleStyle) },
	          subtitle
	        ),
	        children
	      );
	    }
	  }]);
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.muiName = 'CardTitle';
	CardTitle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardTitle.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Title.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Can be used to render a subtitle in the Card Title.
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render a title in the Card Title.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = CardTitle;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Chip = __webpack_require__(1668);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip2.default;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(1669);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(1682);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(1685);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(423);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _titleBar;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      gridTile = _context$muiTheme.gridTile;
	
	
	  var actionPos = props.actionIcon && props.actionPosition;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'block',
	      height: '100%',
	      overflow: 'hidden'
	    },
	    titleBar: (_titleBar = {
	      position: 'absolute',
	      left: 0,
	      right: 0
	    }, (0, _defineProperty3.default)(_titleBar, props.titlePosition, 0), (0, _defineProperty3.default)(_titleBar, 'height', props.subtitle ? 68 : 48), (0, _defineProperty3.default)(_titleBar, 'background', props.titleBackground), (0, _defineProperty3.default)(_titleBar, 'display', 'flex'), (0, _defineProperty3.default)(_titleBar, 'alignItems', 'center'), _titleBar),
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: actionPos !== 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginRight: actionPos === 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      color: gridTile.textColor,
	      overflow: 'hidden'
	    },
	    title: {
	      fontSize: '16px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: '12px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {
	      order: actionPos === 'left' ? -1 : 1
	    },
	    childImg: {
	      height: '100%',
	      transform: 'translateX(-50%)',
	      position: 'relative',
	      left: '50%'
	    }
	  };
	  return styles;
	}
	
	var GridTile = function (_Component) {
	  (0, _inherits3.default)(GridTile, _Component);
	
	  function GridTile() {
	    (0, _classCallCheck3.default)(this, GridTile);
	    return (0, _possibleConstructorReturn3.default)(this, (GridTile.__proto__ || (0, _getPrototypeOf2.default)(GridTile)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridTile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'ensureImageCover',
	    value: function ensureImageCover() {
	      var _this2 = this;
	
	      var imgEl = this.refs.img;
	
	      if (imgEl) {
	        var fit = function fit() {
	          if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
	            var isRtl = _this2.context.muiTheme.isRtl;
	
	            imgEl.style.height = 'auto';
	            if (isRtl) {
	              imgEl.style.right = '0';
	            } else {
	              imgEl.style.left = '0';
	            }
	            imgEl.style.width = '100%';
	            imgEl.style.top = '50%';
	            imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
	          }
	          imgEl.removeEventListener('load', fit);
	          imgEl = null; // prevent closure memory leak
	        };
	        if (imgEl.complete) {
	          fit();
	        } else {
	          imgEl.addEventListener('load', fit);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          subtitle = _props.subtitle,
	          titlePosition = _props.titlePosition,
	          titleBackground = _props.titleBackground,
	          titleStyle = _props.titleStyle,
	          subtitleStyle = _props.subtitleStyle,
	          actionIcon = _props.actionIcon,
	          actionPosition = _props.actionPosition,
	          style = _props.style,
	          children = _props.children,
	          containerElement = _props.containerElement,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'titleStyle', 'subtitleStyle', 'actionIcon', 'actionPosition', 'style', 'children', 'containerElement']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var titleBar = null;
	
	      if (title) {
	        titleBar = _react2.default.createElement(
	          'div',
	          { key: 'titlebar', style: prepareStyles(styles.titleBar) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.titleWrap) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	              title
	            ),
	            subtitle ? _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	              subtitle
	            ) : null
	          ),
	          actionIcon ? _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.actionIcon) },
	            actionIcon
	          ) : null
	        );
	      }
	
	      var newChildren = children;
	
	      // if there is a single image passed as children
	      // clone it and add our styles
	      if (_react2.default.Children.count(children) === 1) {
	        newChildren = _react2.default.Children.map(children, function (child) {
	          if (child.type === 'img') {
	            return _react2.default.cloneElement(child, {
	              key: 'img',
	              ref: 'img',
	              style: prepareStyles((0, _simpleAssign2.default)({}, styles.childImg, child.props.style))
	            });
	          } else {
	            return child;
	          }
	        });
	      }
	
	      var containerProps = (0, _extends3.default)({
	        style: prepareStyles(mergedRootStyles)
	      }, other);
	
	      return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, containerProps, [newChildren, titleBar]) : _react2.default.createElement(containerElement, containerProps, [newChildren, titleBar]);
	    }
	  }]);
	  return GridTile;
	}(_react.Component);
	
	GridTile.defaultProps = {
	  titlePosition: 'bottom',
	  titleBackground: 'rgba(0, 0, 0, 0.4)',
	  actionPosition: 'right',
	  cols: 1,
	  rows: 1,
	  containerElement: 'div'
	};
	GridTile.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	GridTile.propTypes =  false ? {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes2.default.element,
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in whichcase GridTile takes care of making the image "cover" available space
	   * (similar to background-size: cover or to object-fit:cover).
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * Either a string used as tag name for the tile root element, or a ReactElement.
	   * This is useful when you have, for example, a custom implementation of
	   * a navigation link (that knows about your routes) and you want to use it as the primary tile action.
	   * In case you pass a ReactElement, please ensure that it passes all props,
	   * accepts styles overrides and render it's children.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the subtitle element.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Style used for title bar background.
	   * Useful for setting custom gradients for example
	   */
	  titleBackground: _propTypes2.default.string,
	  /**
	   * Position of the title bar (container of title, subtitle and action icon).
	   */
	  titlePosition: _propTypes2.default.oneOf(['top', 'bottom']),
	  /**
	   * Override the inline-styles of the title element.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = GridTile;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelectable = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colorManipulator = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeSelectable = function makeSelectable(MyComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(_class, _Component);
	
	    function _class() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3.default)(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
	        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
	        }
	        return previousValue || _this.isChildSelected(child, _this.props);
	      }, _this.handleItemTouchTap = function (event, item) {
	        var itemValue = item.props.value;
	
	        if (itemValue !== _this.props.value) {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, itemValue);
	          }
	        }
	      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(_class, [{
	      key: 'extendChild',
	      value: function extendChild(child, styles, selectedItemStyle) {
	        var _this2 = this;
	
	        if (child && child.type && child.type.muiName === 'ListItem') {
	          var selected = this.isChildSelected(child, this.props);
	          var selectedChildrenStyles = void 0;
	          if (selected) {
	            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
	          }
	
	          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	          this.keyIndex += 1;
	
	          return _react2.default.cloneElement(child, {
	            onClick: function onClick(event) {
	              _this2.handleItemTouchTap(event, child);
	              if (child.props.onClick) {
	                child.props.onClick(event);
	              }
	            },
	            key: this.keyIndex,
	            style: mergedChildrenStyles,
	            nestedItems: child.props.nestedItems.map(function (child) {
	              return _this2.extendChild(child, styles, selectedItemStyle);
	            }),
	            initiallyOpen: this.isInitiallyOpen(child)
	          });
	        } else {
	          return child;
	        }
	      }
	    }, {
	      key: 'isInitiallyOpen',
	      value: function isInitiallyOpen(child) {
	        if (child.props.initiallyOpen) {
	          return child.props.initiallyOpen;
	        }
	        return this.hasSelectedDescendant(false, child);
	      }
	    }, {
	      key: 'isChildSelected',
	      value: function isChildSelected(child, props) {
	        return props.value === child.props.value;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            selectedItemStyle = _props.selectedItemStyle,
	            other = (0, _objectWithoutProperties3.default)(_props, ['children', 'selectedItemStyle']);
	
	
	        this.keyIndex = 0;
	        var styles = {};
	
	        if (!selectedItemStyle) {
	          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
	          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
	        }
	
	        return _react2.default.createElement(
	          MyComponent,
	          (0, _extends3.default)({}, other, this.state),
	          _react.Children.map(children, function (child) {
	            return _this3.extendChild(child, styles, selectedItemStyle);
	          })
	        );
	      }
	    }]);
	    return _class;
	  }(_react.Component), _class.propTypes = {
	    children: _propTypes2.default.node,
	    onChange: _propTypes2.default.func,
	    selectedItemStyle: _propTypes2.default.object,
	    value: _propTypes2.default.any
	  }, _class.contextTypes = {
	    muiTheme: _propTypes2.default.object.isRequired
	  }, _temp2;
	};
	
	exports.makeSelectable = makeSelectable;
	exports.default = makeSelectable;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(303);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(235);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _Menu3.default;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(1707);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _typeof2 = __webpack_require__(167);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _checkCircle = __webpack_require__(432);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active,
	      completed = _ref.completed,
	      disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme,
	      stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper,
	      textColor = _muiTheme$stepper.textColor,
	      disabledTextColor = _muiTheme$stepper.disabledTextColor,
	      iconColor = _muiTheme$stepper.iconColor,
	      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var baseTheme = muiTheme.baseTheme;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      paddingRight: 8
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'default';
	  }
	
	  return styles;
	};
	
	var renderIcon = function renderIcon(completed, icon, styles) {
	  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);
	
	  if (iconType === 'number' || iconType === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_checkCircle2.default, {
	        color: styles.icon.color,
	        style: styles.icon
	      });
	    }
	
	    return _react2.default.createElement(
	      _SvgIcon2.default,
	      { color: styles.icon.color, style: styles.icon },
	      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: '12',
	          y: '16',
	          textAnchor: 'middle',
	          fontSize: '12',
	          fill: '#fff'
	        },
	        icon
	      )
	    );
	  }
	
	  return icon;
	};
	
	var StepLabel = function StepLabel(props, context) {
	  var active = props.active,
	      children = props.children,
	      completed = props.completed,
	      userIcon = props.icon,
	      iconContainerStyle = props.iconContainerStyle,
	      last = props.last,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	  var icon = renderIcon(completed, userIcon, styles);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	    icon && _react2.default.createElement(
	      'span',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
	      icon
	    ),
	    children
	  );
	};
	
	StepLabel.muiName = 'StepLabel';
	
	StepLabel.propTypes =  false ? {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * The label text node
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	StepLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	exports.default = StepLabel;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(1718);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(167);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableRowColumn = __webpack_require__(305);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _ClickAwayListener = __webpack_require__(428);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableBody = function (_Component) {
	  (0, _inherits3.default)(TableBody, _Component);
	
	  function TableBody() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedRows: []
	    }, _this.isControlled = false, _this.handleClickAway = function () {
	      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length > 0) {
	        var selectedRows = [];
	        _this.setState({ selectedRows: selectedRows });
	        if (_this.props.onRowSelection) {
	          _this.props.onRowSelection(selectedRows);
	        }
	      }
	    }, _this.onRowClick = function (event, rowNumber) {
	      event.stopPropagation();
	
	      if (_this.props.selectable) {
	        // Prevent text selection while selecting rows.
	        if (window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects.length > 0) {
	          window.getSelection().removeAllRanges();
	        }
	        _this.processRowSelection(event, rowNumber);
	      }
	    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
	      event.stopPropagation();
	      if (_this.props.onCellClick) {
	        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHover) {
	        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHover(event, rowNumber);
	    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHoverExit) {
	        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHoverExit(event, rowNumber);
	    }, _this.onRowHover = function (event, rowNumber) {
	      if (_this.props.onRowHover) {
	        _this.props.onRowHover(rowNumber);
	      }
	    }, _this.onRowHoverExit = function (event, rowNumber) {
	      if (_this.props.onRowHoverExit) {
	        _this.props.onRowHoverExit(rowNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableBody, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.preScanRows) {
	        this.setState({
	          selectedRows: this.getSelectedRows(this.props)
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.preScanRows) {
	        this.setState({ // eslint-disable-line react/no-did-mount-set-state
	          selectedRows: this.getSelectedRows(this.props)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        if (!nextProps.allRowsSelected) {
	          this.setState({
	            selectedRows: []
	          });
	          return;
	        }
	      }
	
	      this.setState({
	        selectedRows: this.getSelectedRows(nextProps)
	      });
	    }
	  }, {
	    key: 'createRows',
	    value: function createRows() {
	      var _this2 = this;
	
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var rowNumber = 0;
	      var handlers = {
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowClick: this.onRowClick
	      };
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          var props = {
	            hoverable: _this2.props.showRowHover,
	            selected: _this2.isRowSelected(rowNumber),
	            striped: _this2.props.stripedRows && rowNumber % 2 === 0,
	            rowNumber: rowNumber++
	          };
	
	          if (rowNumber === numChildren) {
	            props.displayBorder = false;
	          }
	
	          var children = [_this2.createRowCheckboxColumn(props)];
	
	          _react2.default.Children.forEach(child.props.children, function (child) {
	            children.push(child);
	          });
	
	          return _react2.default.cloneElement(child, (0, _extends3.default)({}, props, handlers), children);
	        }
	      });
	    }
	  }, {
	    key: 'createRowCheckboxColumn',
	    value: function createRowCheckboxColumn(rowProps) {
	      if (!this.props.displayRowCheckbox) {
	        return null;
	      }
	
	      var name = rowProps.rowNumber + '-cb';
	      var disabled = !this.props.selectable;
	
	      return _react2.default.createElement(
	        _TableRowColumn2.default,
	        {
	          key: name,
	          columnNumber: 0,
	          style: {
	            width: 24,
	            cursor: disabled ? 'default' : 'inherit'
	          }
	        },
	        _react2.default.createElement(_Checkbox2.default, {
	          name: name,
	          value: 'selected',
	          disabled: disabled,
	          checked: rowProps.selected
	        })
	      );
	    }
	  }, {
	    key: 'getSelectedRows',
	    value: function getSelectedRows(props) {
	      var _this3 = this;
	
	      var selectedRows = [];
	
	      if (props.selectable) {
	        var index = 0;
	        _react2.default.Children.forEach(props.children, function (child) {
	          if (_react2.default.isValidElement(child)) {
	            if (child.props.selected !== undefined) {
	              _this3.isControlled = true;
	            }
	
	            if (child.props.selected && (selectedRows.length === 0 || props.multiSelectable)) {
	              selectedRows.push(index);
	            }
	
	            index++;
	          }
	        });
	      }
	
	      return selectedRows;
	    }
	  }, {
	    key: 'isRowSelected',
	    value: function isRowSelected(rowNumber) {
	      var _this4 = this;
	
	      if (this.props.allRowsSelected) {
	        return true;
	      }
	
	      return this.state.selectedRows.some(function (row) {
	        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
	          if (_this4.isValueInRange(rowNumber, row)) {
	            return true;
	          }
	        } else {
	          if (row === rowNumber) {
	            return true;
	          }
	        }
	
	        return false;
	      });
	    }
	  }, {
	    key: 'isValueInRange',
	    value: function isValueInRange(value, range) {
	      if (!range) return false;
	
	      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'processRowSelection',
	    value: function processRowSelection(event, rowNumber) {
	      var selectedRows = [].concat((0, _toConsumableArray3.default)(this.state.selectedRows));
	
	      if (event.shiftKey && this.props.multiSelectable && selectedRows.length > 0) {
	        var lastIndex = selectedRows.length - 1;
	        var lastSelection = selectedRows[lastIndex];
	
	        if ((typeof lastSelection === 'undefined' ? 'undefined' : (0, _typeof3.default)(lastSelection)) === 'object') {
	          lastSelection.end = rowNumber;
	        } else {
	          selectedRows.splice(lastIndex, 1, {
	            start: lastSelection,
	            end: rowNumber
	          });
	        }
	      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
	        var idx = selectedRows.indexOf(rowNumber);
	        if (idx < 0) {
	          var foundRange = false;
	          for (var i = 0; i < selectedRows.length; i++) {
	            var range = selectedRows[i];
	            if ((typeof range === 'undefined' ? 'undefined' : (0, _typeof3.default)(range)) !== 'object') continue;
	
	            if (this.isValueInRange(rowNumber, range)) {
	              var _selectedRows;
	
	              foundRange = true;
	              var values = this.splitRange(range, rowNumber);
	              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat((0, _toConsumableArray3.default)(values)));
	            }
	          }
	
	          if (!foundRange) selectedRows.push(rowNumber);
	        } else {
	          selectedRows.splice(idx, 1);
	        }
	      } else {
	        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	          selectedRows = [];
	        } else {
	          selectedRows = [rowNumber];
	        }
	      }
	
	      if (!this.isControlled) {
	        this.setState({ selectedRows: selectedRows });
	      }
	
	      if (this.props.onRowSelection) {
	        this.props.onRowSelection(this.flattenRanges(selectedRows));
	      }
	    }
	  }, {
	    key: 'splitRange',
	    value: function splitRange(range, splitPoint) {
	      var splitValues = [];
	      var startOffset = range.start - splitPoint;
	      var endOffset = range.end - splitPoint;
	
	      // Process start half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, startOffset)));
	
	      // Process end half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, endOffset)));
	
	      return splitValues;
	    }
	  }, {
	    key: 'genRangeOfValues',
	    value: function genRangeOfValues(start, offset) {
	      var values = [];
	      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	      while (offset !== 0) {
	        values.push(start + offset);
	        offset += dir;
	      }
	
	      return values;
	    }
	  }, {
	    key: 'flattenRanges',
	    value: function flattenRanges(selectedRows) {
	      var _this5 = this;
	
	      return selectedRows.reduce(function (rows, row) {
	        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
	          var values = _this5.genRangeOfValues(row.end, row.start - row.end);
	          rows.push.apply(rows, [row.end].concat((0, _toConsumableArray3.default)(values)));
	        } else {
	          rows.push(row);
	        }
	
	        return rows;
	      }, []).sort();
	    }
	  }, {
	    key: 'getColumnId',
	    value: function getColumnId(columnNumber) {
	      return columnNumber - 1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          allRowsSelected = _props.allRowsSelected,
	          multiSelectable = _props.multiSelectable,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          onRowSelection = _props.onRowSelection,
	          selectable = _props.selectable,
	          deselectOnClickaway = _props.deselectOnClickaway,
	          showRowHover = _props.showRowHover,
	          stripedRows = _props.stripedRows,
	          displayRowCheckbox = _props.displayRowCheckbox,
	          preScanRows = _props.preScanRows,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'allRowsSelected', 'multiSelectable', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowHover', 'onRowHoverExit', 'onRowSelection', 'selectable', 'deselectOnClickaway', 'showRowHover', 'stripedRows', 'displayRowCheckbox', 'preScanRows']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'tbody',
	          (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	          this.createRows()
	        )
	      );
	    }
	  }]);
	  return TableBody;
	}(_react.Component);
	
	TableBody.muiName = 'TableBody';
	TableBody.defaultProps = {
	  allRowsSelected: false,
	  deselectOnClickaway: true,
	  displayRowCheckbox: true,
	  multiSelectable: false,
	  preScanRows: true,
	  selectable: true,
	  style: {}
	};
	TableBody.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableBody.propTypes =  false ? {
	  /**
	   * @ignore
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _propTypes2.default.bool,
	  /**
	   * Children passed to table body.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Controls whether or not to deselect all selected
	   * rows after clicking outside the table.
	   */
	  deselectOnClickaway: _propTypes2.default.bool,
	  /**
	   * Controls the display of the row checkbox. The default value is true.
	   */
	  displayRowCheckbox: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Callback function for when a cell is clicked.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered. rowNumber
	   * is the row number of the hovered row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer
	   * hovered. rowNumber is the row number of the row
	   * that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a row is selected. selectedRows is an
	   * array of all row selections. If all rows have been selected,
	   * the string "all" will be returned instead to indicate that
	   * all rows have been selected.
	   */
	  onRowSelection: _propTypes2.default.func,
	  /**
	   * Controls whether or not the rows are pre-scanned to determine
	   * initial state. If your table has a large number of rows and
	   * you are experiencing a delay in rendering, turn off this property.
	   */
	  preScanRows: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * If true, table rows can be selected. If multiple
	   * row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * If true, table rows will be highlighted when
	   * the cursor is hovering over the row. The default
	   * value is false.
	   */
	  showRowHover: _propTypes2.default.bool,
	  /**
	   * If true, every other table row starting
	   * with the first row will be striped. The default value is false.
	   */
	  stripedRows: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableBody;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TableRowColumn = __webpack_require__(305);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableFooter = context.muiTheme.tableFooter;
	
	
	  return {
	    cell: {
	      borderTop: '1px solid ' + tableFooter.borderColor,
	      verticalAlign: 'bottom',
	      padding: 20,
	      textAlign: 'left',
	      whiteSpace: 'nowrap'
	    }
	  };
	}
	
	var TableFooter = function (_Component) {
	  (0, _inherits3.default)(TableFooter, _Component);
	
	  function TableFooter() {
	    (0, _classCallCheck3.default)(this, TableFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          adjustForCheckbox = _props.adjustForCheckbox,
	          children = _props.children,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
	        var newChildProps = {
	          displayBorder: false,
	          key: 'f-' + rowNumber,
	          rowNumber: rowNumber,
	          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	        };
	
	        var newDescendants = void 0;
	
	        if (adjustForCheckbox) {
	          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat((0, _toConsumableArray3.default)(_react2.default.Children.toArray(child.props.children)));
	        } else {
	          newDescendants = child.props.children;
	        }
	
	        return _react2.default.cloneElement(child, newChildProps, newDescendants);
	      });
	
	      return _react2.default.createElement(
	        'tfoot',
	        (0, _extends3.default)({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        footerRows
	      );
	    }
	  }]);
	  return TableFooter;
	}(_react.Component);
	
	TableFooter.muiName = 'TableFooter';
	TableFooter.defaultProps = {
	  adjustForCheckbox: true,
	  style: {}
	};
	TableFooter.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableFooter.propTypes =  false ? {
	  /**
	   * @ignore
	   * Controls whether or not header rows should be adjusted
	   * for a checkbox column. If the select all checkbox is true,
	   * this property will not influence the number of columns.
	   * This is mainly useful for "super header" rows so that
	   * the checkbox column does not create an offset that needs
	   * to be accounted for manually.
	   */
	  adjustForCheckbox: _propTypes2.default.bool,
	  /**
	   * Children passed to table footer.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableFooter;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableHeaderColumn = __webpack_require__(427);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeader = context.muiTheme.tableHeader;
	
	
	  return {
	    root: {
	      borderBottom: '1px solid ' + tableHeader.borderColor
	    }
	  };
	}
	
	var TableHeader = function (_Component) {
	  (0, _inherits3.default)(TableHeader, _Component);
	
	  function TableHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
	      if (_this.props.onSelectAll) {
	        _this.props.onSelectAll(checked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeader, [{
	    key: 'createSuperHeaderRows',
	    value: function createSuperHeaderRows() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      if (numChildren === 1) return undefined;
	
	      var superHeaders = [];
	      for (var index = 0; index < numChildren - 1; index++) {
	        var child = this.props.children[index];
	
	        if (!_react2.default.isValidElement(child)) continue;
	
	        var props = {
	          key: 'sh' + index,
	          rowNumber: index
	        };
	        superHeaders.push(this.createSuperHeaderRow(child, props));
	      }
	
	      if (superHeaders.length) return superHeaders;
	    }
	  }, {
	    key: 'createSuperHeaderRow',
	    value: function createSuperHeaderRow(child, props) {
	      var children = [];
	      if (this.props.adjustForCheckbox) {
	        children.push(this.getCheckboxPlaceholder(props));
	      }
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'createBaseHeaderRow',
	    value: function createBaseHeaderRow() {
	      var childrenArray = _react2.default.Children.toArray(this.props.children);
	      var numChildren = childrenArray.length;
	      if (numChildren < 1) {
	        return null;
	      }
	
	      var child = childrenArray[numChildren - 1];
	
	      var props = {
	        key: 'h' + numChildren,
	        rowNumber: numChildren
	      };
	
	      var children = [this.getSelectAllCheckboxColumn(props)];
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'getCheckboxPlaceholder',
	    value: function getCheckboxPlaceholder(props) {
	      if (!this.props.adjustForCheckbox) return null;
	
	      var disabled = !this.props.enableSelectAll;
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(_TableHeaderColumn2.default, {
	        key: key,
	        style: {
	          width: 24,
	          cursor: disabled ? 'default' : 'inherit'
	        }
	      });
	    }
	  }, {
	    key: 'getSelectAllCheckboxColumn',
	    value: function getSelectAllCheckboxColumn(props) {
	      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);
	
	      var disabled = !this.props.enableSelectAll;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        key: 'selectallcb',
	        name: 'selectallcb',
	        value: 'selected',
	        disabled: disabled,
	        checked: this.props.selectAllSelected,
	        onCheck: this.handleCheckAll
	      });
	
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(
	        _TableHeaderColumn2.default,
	        {
	          key: key,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var superHeaderRows = this.createSuperHeaderRows();
	      var baseHeaderRow = this.createBaseHeaderRow();
	
	      return _react2.default.createElement(
	        'thead',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        superHeaderRows,
	        baseHeaderRow
	      );
	    }
	  }]);
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.muiName = 'TableHeader';
	TableHeader.defaultProps = {
	  adjustForCheckbox: true,
	  displaySelectAll: true,
	  enableSelectAll: true,
	  selectAllSelected: false
	};
	TableHeader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableHeader.propTypes =  false ? {
	  /**
	   * Controls whether or not header rows should be
	   * adjusted for a checkbox column. If the select all
	   * checkbox is true, this property will not influence
	   * the number of columns. This is mainly useful for
	   * "super header" rows so that the checkbox column
	   * does not create an offset that needs to be accounted
	   * for manually.
	   */
	  adjustForCheckbox: _propTypes2.default.bool,
	  /**
	   * Children passed to table header.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Controls whether or not the select all checkbox is displayed.
	   */
	  displaySelectAll: _propTypes2.default.bool,
	  /**
	   * If set to true, the select all button will be interactable.
	   * If set to false, the button will not be interactable.
	   * To hide the checkbox, set displaySelectAll to false.
	   */
	  enableSelectAll: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Callback when select all has been checked.
	   */
	  onSelectAll: _propTypes2.default.func,
	  /**
	   * @ignore
	   * True when select all has been checked.
	   */
	  selectAllSelected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableHeader;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var tableRow = context.muiTheme.tableRow;
	
	
	  var cellBgColor = 'inherit';
	  if (props.hovered || state.hovered) {
	    cellBgColor = tableRow.hoverColor;
	  } else if (props.selected) {
	    cellBgColor = tableRow.selectedColor;
	  } else if (props.striped) {
	    cellBgColor = tableRow.stripeColor;
	  }
	
	  return {
	    root: {
	      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
	      color: tableRow.textColor,
	      height: tableRow.height
	    },
	    cell: {
	      backgroundColor: cellBgColor
	    }
	  };
	}
	
	var TableRow = function (_Component) {
	  (0, _inherits3.default)(TableRow, _Component);
	
	  function TableRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onCellClick = function (event, columnIndex) {
	      if (_this.props.selectable && _this.props.onCellClick) {
	        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
	      }
	      event.ctrlKey = true;
	      _this.onRowClick(event);
	    }, _this.onCellHover = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHover(event);
	      }
	    }, _this.onCellHoverExit = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHoverExit(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRow, [{
	    key: 'onRowClick',
	    value: function onRowClick(event) {
	      if (this.props.selectable && this.props.onRowClick) {
	        this.props.onRowClick(event, this.props.rowNumber);
	      }
	    }
	  }, {
	    key: 'onRowHover',
	    value: function onRowHover(event) {
	      if (this.props.onRowHover) {
	        this.props.onRowHover(event, this.props.rowNumber);
	      }
	    }
	  }, {
	    key: 'onRowHoverExit',
	    value: function onRowHoverExit(event) {
	      if (this.props.onRowHoverExit) {
	        this.props.onRowHoverExit(event, this.props.rowNumber);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          displayBorder = _props.displayBorder,
	          hoverable = _props.hoverable,
	          hovered = _props.hovered,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowClick = _props.onRowClick,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          rowNumber = _props.rowNumber,
	          selectable = _props.selectable,
	          selected = _props.selected,
	          striped = _props.striped,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            columnNumber: columnNumber,
	            hoverable: _this2.props.hoverable,
	            key: _this2.props.rowNumber + '-' + columnNumber,
	            onClick: _this2.onCellClick,
	            onHover: _this2.onCellHover,
	            onHoverExit: _this2.onCellHoverExit,
	            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other),
	        rowColumns
	      );
	    }
	  }]);
	  return TableRow;
	}(_react.Component);
	
	TableRow.defaultProps = {
	  displayBorder: true,
	  hoverable: false,
	  hovered: false,
	  selectable: true,
	  striped: false
	};
	TableRow.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableRow.propTypes =  false ? {
	  /**
	   * Children passed to table row.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, row border will be displayed for the row.
	   * If false, no border will be drawn.
	   */
	  displayBorder: _propTypes2.default.bool,
	  /**
	   * Controls whether or not the row responds to hover events.
	   */
	  hoverable: _propTypes2.default.bool,
	  /**
	   * Controls whether or not the row should be rendered as being
	   * hovered. This property is evaluated in addition to this.state.hovered
	   * and can be used to synchronize the hovered state with some other
	   * external events.
	   */
	  hovered: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when row is clicked.
	   */
	  onRowClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * Number to identify the row. This property is
	   * automatically populated when used with the TableBody component.
	   */
	  rowNumber: _propTypes2.default.number,
	  /**
	   * If true, table rows can be selected. If multiple row
	   * selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * Indicates that a particular row is selected.
	   * This property can be used to programmatically select rows.
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * Indicates whether or not the row is striped.
	   */
	  striped: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableRow;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    root: {
	      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: props.width,
	      textTransform: 'uppercase',
	      padding: 0
	    },
	    button: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: props.label && props.icon ? 72 : 48
	    }
	  };
	}
	
	var Tab = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(_this.props.value, event, _this);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          index = _props.index,
	          onActive = _props.onActive,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          label = _props.label,
	          buttonStyle = _props.buttonStyle,
	          style = _props.style,
	          value = _props.value,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onClick', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (icon && _react2.default.isValidElement(icon)) {
	        iconElement = _react2.default.cloneElement(icon, {
	          style: {
	            fontSize: 24,
	            color: icon.props && icon.props.style && icon.props.style.color ? icon.props.style.color : styles.root.color,
	            marginBottom: label ? 5 : 0
	          }
	        });
	      }
	
	      var rippleOpacity = 0.3;
	      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity,
	          onClick: this.handleTouchTap
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
	          iconElement,
	          label
	        )
	      );
	    }
	  }]);
	  return Tab;
	}(_react.Component);
	
	Tab.muiName = 'Tab';
	Tab.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tab.propTypes =  false ? {
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _propTypes2.default.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  index: _propTypes2.default.any,
	  /**
	   * Sets the text value of the tab item to the string specified.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Fired when the active tab changes by touch or tap.
	   * Use this event to specify any functionality when an active tab changes.
	   * For example - we are using this to route to home when the third tab becomes active.
	   * This function will always recieve the active tab as it\'s first argument.
	   */
	  onActive: _propTypes2.default.func,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Defines if the current tab is selected or not.
	   * The Tabs component is responsible for setting this property.
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * If value prop passed to Tabs component, this value prop is also required.
	   * It assigns a value to the tab so that it can be selected by the Tabs.
	   */
	  value: _propTypes2.default.any,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  width: _propTypes2.default.string
	} : {};
	exports.default = Tab;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _slicedToArray2 = __webpack_require__(357);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _timeUtils = __webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var styles = {
	    root: {
	      directionInvariant: true,
	      display: 'inline-block',
	      position: 'absolute',
	      width: 32,
	      height: 32,
	      borderRadius: '100%',
	      left: 'calc(50% - 16px)',
	      top: 10,
	      textAlign: 'center',
	      paddingTop: 5,
	      userSelect: 'none', /* Chrome all / Safari all */
	      fontSize: '1.1em',
	      pointerEvents: 'none',
	      boxSizing: 'border-box'
	    }
	  };
	
	  var muiTheme = context.muiTheme;
	
	
	  var pos = props.value;
	
	  if (props.type === 'hour') {
	    pos %= 12;
	  } else {
	    pos = pos / 5;
	  }
	
	  var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	  var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	  if (props.isSelected) {
	    styles.root.backgroundColor = muiTheme.timePicker.accentColor;
	    styles.root.color = muiTheme.timePicker.selectTextColor;
	  }
	
	  var transformPos = positions[pos];
	
	  if ((0, _timeUtils.isInner)(props)) {
	    styles.root.width = 28;
	    styles.root.height = 28;
	    styles.root.left = 'calc(50% - 14px)';
	    transformPos = innerPositions[pos];
	  }
	
	  var _transformPos = transformPos,
	      _transformPos2 = (0, _slicedToArray3.default)(_transformPos, 2),
	      x = _transformPos2[0],
	      y = _transformPos2[1];
	
	  styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	  return styles;
	}
	
	var ClockNumber = function (_Component) {
	  (0, _inherits3.default)(ClockNumber, _Component);
	
	  function ClockNumber() {
	    (0, _classCallCheck3.default)(this, ClockNumber);
	    return (0, _possibleConstructorReturn3.default)(this, (ClockNumber.__proto__ || (0, _getPrototypeOf2.default)(ClockNumber)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ClockNumber, [{
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var clockNumber = this.props.value === 0 ? '00' : this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles(styles.root) },
	        clockNumber
	      );
	    }
	  }]);
	  return ClockNumber;
	}(_react.Component);
	
	ClockNumber.defaultProps = {
	  value: 0,
	  type: 'minute',
	  isSelected: false
	};
	ClockNumber.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockNumber.propTypes =  false ? {
	  isSelected: _propTypes2.default.bool,
	  onSelected: _propTypes2.default.func,
	  type: _propTypes2.default.oneOf(['hour', 'minute']),
	  value: _propTypes2.default.number
	} : {};
	exports.default = ClockNumber;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _timeUtils = __webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcAngle(value, base) {
	  value %= base;
	  var angle = 360 / base * value;
	  return angle;
	}
	
	function getStyles(props, context, state) {
	  var hasSelected = props.hasSelected,
	      type = props.type,
	      value = props.value;
	  var inner = state.inner;
	  var timePicker = context.muiTheme.timePicker;
	
	  var angle = type === 'hour' ? calcAngle(value, 12) : calcAngle(value, 60);
	
	  var styles = {
	    root: {
	      height: inner ? '30%' : '40%',
	      background: timePicker.accentColor,
	      width: 2,
	      left: 'calc(50% - 1px)',
	      position: 'absolute',
	      bottom: '50%',
	      transformOrigin: 'bottom',
	      pointerEvents: 'none',
	      transform: 'rotateZ(' + angle + 'deg)'
	    },
	    mark: {
	      boxSizing: 'content-box',
	      background: timePicker.selectTextColor,
	      border: '4px solid ' + timePicker.accentColor,
	      display: hasSelected && 'none',
	      width: 7,
	      height: 7,
	      position: 'absolute',
	      top: -5,
	      left: -6,
	      borderRadius: '100%'
	    }
	  };
	
	  return styles;
	}
	
	var ClockPointer = function (_Component) {
	  (0, _inherits3.default)(ClockPointer, _Component);
	
	  function ClockPointer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockPointer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockPointer.__proto__ || (0, _getPrototypeOf2.default)(ClockPointer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inner: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockPointer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(this.props)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(nextProps)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.value === null) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement('div', { style: prepareStyles(styles.mark) })
	      );
	    }
	  }]);
	  return ClockPointer;
	}(_react.Component);
	
	ClockPointer.defaultProps = {
	  hasSelected: false,
	  value: null,
	  type: 'minute'
	};
	ClockPointer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockPointer.propTypes =  false ? {
	  hasSelected: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf(['hour', 'minute']),
	  value: _propTypes2.default.number
	} : {};
	exports.default = ClockPointer;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var firstChild = props.firstChild,
	      lastChild = props.lastChild;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  var marginHorizontal = baseTheme.spacing.desktopGutter;
	  var marginVertical = (toolbar.height - button.height) / 2;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      marginLeft: firstChild ? -marginHorizontal : undefined,
	      marginRight: lastChild ? -marginHorizontal : undefined,
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center'
	    },
	    dropDownMenu: {
	      root: {
	        color: toolbar.color, // removes hover color change, we want to keep it
	        marginRight: baseTheme.spacing.desktopGutter,
	        flex: 1,
	        whiteSpace: 'nowrap'
	      },
	      controlBg: {
	        backgroundColor: toolbar.menuHoverColor,
	        borderRadius: 0
	      },
	      underline: {
	        display: 'none'
	      }
	    },
	    button: {
	      margin: marginVertical + 'px ' + marginHorizontal + 'px',
	      position: 'relative'
	    },
	    icon: {
	      root: {
	        cursor: 'pointer',
	        lineHeight: toolbar.height + 'px',
	        paddingLeft: baseTheme.spacing.desktopGutter
	      }
	    },
	    span: {
	      color: toolbar.iconColor,
	      lineHeight: toolbar.height + 'px'
	    }
	  };
	
	  return styles;
	}
	
	var ToolbarGroup = function (_Component) {
	  (0, _inherits3.default)(ToolbarGroup, _Component);
	
	  function ToolbarGroup() {
	    (0, _classCallCheck3.default)(this, ToolbarGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarGroup, [{
	    key: 'handleMouseLeaveFontIcon',
	    value: function handleMouseLeaveFontIcon(style) {
	      return function (event) {
	        event.target.style.zIndex = 'auto';
	        event.target.style.color = style.root.color;
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          firstChild = _props.firstChild,
	          lastChild = _props.lastChild,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (!currentChild) {
	          return null;
	        }
	        if (!currentChild.type) {
	          return currentChild;
	        }
	        switch (currentChild.type.muiName) {
	          case 'DropDownMenu':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
	              underlineStyle: styles.dropDownMenu.underline
	            });
	          case 'RaisedButton':
	          case 'FlatButton':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
	            });
	          case 'FontIcon':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
	              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
	              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
	            });
	          case 'ToolbarSeparator':
	          case 'ToolbarTitle':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
	            });
	          default:
	            return currentChild;
	        }
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        newChildren
	      );
	    }
	  }]);
	  return ToolbarGroup;
	}(_react.Component);
	
	ToolbarGroup.defaultProps = {
	  firstChild: false,
	  lastChild: false
	};
	ToolbarGroup.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ToolbarGroup.propTypes =  false ? {
	  /**
	   * Can be any node or number of nodes.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
	   * to prevent setting the left gap.
	   */
	  firstChild: _propTypes2.default.bool,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
	   * to prevent setting the right gap.
	   */
	  lastChild: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ToolbarGroup;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      backgroundColor: toolbar.separatorColor,
	      display: 'block',
	      height: baseTheme.spacing.desktopGutterMore,
	      marginLeft: baseTheme.spacing.desktopGutter,
	      width: 1
	    }
	  };
	}
	
	var ToolbarSeparator = function (_Component) {
	  (0, _inherits3.default)(ToolbarSeparator, _Component);
	
	  function ToolbarSeparator() {
	    (0, _classCallCheck3.default)(this, ToolbarSeparator);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	    }
	  }]);
	  return ToolbarSeparator;
	}(_react.Component);
	
	ToolbarSeparator.muiName = 'ToolbarSeparator';
	ToolbarSeparator.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ToolbarSeparator.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ToolbarSeparator;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      lineHeight: toolbar.height + 'px',
	      fontSize: toolbar.titleFontSize,
	      fontFamily: baseTheme.fontFamily,
	      position: 'relative',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    }
	  };
	}
	
	var ToolbarTitle = function (_Component) {
	  (0, _inherits3.default)(ToolbarTitle, _Component);
	
	  function ToolbarTitle() {
	    (0, _classCallCheck3.default)(this, ToolbarTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          text = _props.text,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'text']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style))
	        }, other),
	        text
	      );
	    }
	  }]);
	  return ToolbarTitle;
	}(_react.Component);
	
	ToolbarTitle.muiName = 'ToolbarTitle';
	ToolbarTitle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ToolbarTitle.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The text to be displayed.
	   */
	  text: _propTypes2.default.node
	} : {};
	exports.default = ToolbarTitle;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(1741);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  (0, _inherits3.default)(Overlay, _Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoLockScrolling = _props.autoLockScrolling,
	          show = _props.show,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	  return Overlay;
	}(_react.Component);
	
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Overlay.propTypes =  false ? {
	  autoLockScrolling: _propTypes2.default.bool,
	  show: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  transitionEnabled: _propTypes2.default.bool
	} : {};
	exports.default = Overlay;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _dom = __webpack_require__(736);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  (0, _inherits3.default)(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props,
	          open = _props.open,
	          render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RenderToLayer.propTypes =  false ? {
	  componentClickAway: _propTypes2.default.func,
	  open: _propTypes2.default.bool.isRequired,
	  render: _propTypes2.default.func.isRequired,
	  useLayerForClickAway: _propTypes2.default.bool
	} : {};
	exports.default = RenderToLayer;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      zIndex = _context$muiTheme.zIndex,
	      tooltip = _context$muiTheme.tooltip,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: borderRadius,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: tooltip.opacity,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          horizontalPosition = _props.horizontalPosition,
	          label = _props.label,
	          show = _props.show,
	          touch = _props.touch,
	          verticalPosition = _props.verticalPosition,
	          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tooltip.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  horizontalPosition: _propTypes2.default.oneOf(['left', 'right', 'center']),
	  label: _propTypes2.default.node.isRequired,
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  touch: _propTypes2.default.bool,
	  verticalPosition: _propTypes2.default.oneOf(['top', 'bottom'])
	} : {};
	exports.default = Tooltip;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(358);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionGroup = __webpack_require__(248);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _dom = __webpack_require__(736);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(1743);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none',
	          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _TransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TouchRipple.propTypes =  false ? {
	  abortOnScroll: _propTypes2.default.bool,
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = TouchRipple;

/***/ },
/* 713 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ },
/* 714 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHighlightOff = function ActionHighlightOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ActionHighlightOff = (0, _pure2.default)(ActionHighlightOff);
	ActionHighlightOff.displayName = 'ActionHighlightOff';
	ActionHighlightOff.muiName = 'SvgIcon';
	
	exports.default = ActionHighlightOff;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInput = function ActionInput(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z' })
	  );
	};
	ActionInput = (0, _pure2.default)(ActionInput);
	ActionInput.displayName = 'ActionInput';
	ActionInput.muiName = 'SvgIcon';
	
	exports.default = ActionInput;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentArchive = function ContentArchive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z' })
	  );
	};
	ContentArchive = (0, _pure2.default)(ContentArchive);
	ContentArchive.displayName = 'ContentArchive';
	ContentArchive.muiName = 'SvgIcon';
	
	exports.default = ContentArchive;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentCreate = function ContentCreate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	ContentCreate = (0, _pure2.default)(ContentCreate);
	ContentCreate.displayName = 'ContentCreate';
	ContentCreate.muiName = 'SvgIcon';
	
	exports.default = ContentCreate;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorModeEdit = function EditorModeEdit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	EditorModeEdit = (0, _pure2.default)(EditorModeEdit);
	EditorModeEdit.displayName = 'EditorModeEdit';
	EditorModeEdit.muiName = 'SvgIcon';
	
	exports.default = EditorModeEdit;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFileDownload = function FileFileDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
	  );
	};
	FileFileDownload = (0, _pure2.default)(FileFileDownload);
	FileFileDownload.displayName = 'FileFileDownload';
	FileFileDownload.muiName = 'SvgIcon';
	
	exports.default = FileFileDownload;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	  );
	};
	HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
	HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
	HardwareKeyboardArrowDown.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowDown;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	  );
	};
	HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
	HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
	HardwareKeyboardArrowUp.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowUp;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCancel = function NavigationCancel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
	  );
	};
	NavigationCancel = (0, _pure2.default)(NavigationCancel);
	NavigationCancel.displayName = 'NavigationCancel';
	NavigationCancel.muiName = 'SvgIcon';
	
	exports.default = NavigationCancel;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = function NavigationChevronLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
	NavigationChevronLeft.displayName = 'NavigationChevronLeft';
	NavigationChevronLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronLeft;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = function NavigationChevronRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
	NavigationChevronRight.displayName = 'NavigationChevronRight';
	NavigationChevronRight.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronRight;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationClose = function NavigationClose(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
	  );
	};
	NavigationClose = (0, _pure2.default)(NavigationClose);
	NavigationClose.displayName = 'NavigationClose';
	NavigationClose.muiName = 'SvgIcon';
	
	exports.default = NavigationClose;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = function NavigationMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	  );
	};
	NavigationMenu = (0, _pure2.default)(NavigationMenu);
	NavigationMenu.displayName = 'NavigationMenu';
	NavigationMenu.muiName = 'SvgIcon';
	
	exports.default = NavigationMenu;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
	ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
	ToggleRadioButtonChecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonChecked;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
	ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
	ToggleRadioButtonUnchecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonUnchecked;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ },
/* 736 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'MMMM [de] D [de] YYYY',
	            LLL : 'MMMM [de] D [de] YYYY h:mm A',
	            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka horan', 'ek hor'],
	            'hh': [number + ' horanim', number + ' horam'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(2696)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(473);
	
	var _createChainableTypeChecker = __webpack_require__(862);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  if (!(0, _reactIs.isValidElementType)(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ },
/* 862 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(2702);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 864 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 865 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ },
/* 866 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (Array.isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str, decoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var encode = function encode(str, defaultEncoder, charset) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    merge: merge
	};


/***/ },
/* 867 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Track = function Track(props) {
	  var className = props.className,
	      included = props.included,
	      vertical = props.vertical,
	      offset = props.offset,
	      length = props.length,
	      style = props.style;
	
	
	  var positonStyle = vertical ? {
	    bottom: offset + '%',
	    height: length + '%'
	  } : {
	    left: offset + '%',
	    width: length + '%'
	  };
	
	  var elStyle = (0, _extends3['default'])({}, style, positonStyle);
	  return included ? _react2['default'].createElement('div', { className: className, style: elStyle }) : null;
	}; /* eslint-disable react/prop-types */
	exports['default'] = Track;
	module.exports = exports['default'];

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1246);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = createSlider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _addEventListener = __webpack_require__(311);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Steps = __webpack_require__(2716);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Marks = __webpack_require__(2715);
	
	var _Marks2 = _interopRequireDefault(_Marks);
	
	var _Handle = __webpack_require__(435);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _utils = __webpack_require__(436);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function createSlider(Component) {
	  var _class, _temp;
	
	  return _temp = _class = function (_Component) {
	    (0, _inherits3['default'])(ComponentEnhancer, _Component);
	
	    function ComponentEnhancer(props) {
	      (0, _classCallCheck3['default'])(this, ComponentEnhancer);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));
	
	      _this.onMouseDown = function (e) {
	        if (e.button !== 0) {
	          return;
	        }
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getMousePosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.removeDocumentEvents();
	        _this.onStart(position);
	        _this.addDocumentMouseEvents();
	      };
	
	      _this.onTouchStart = function (e) {
	        if (utils.isNotTouchEvent(e)) return;
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getTouchPosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.onStart(position);
	        _this.addDocumentTouchEvents();
	        utils.pauseEvent(e);
	      };
	
	      _this.onFocus = function (e) {
	        var _this$props = _this.props,
	            onFocus = _this$props.onFocus,
	            vertical = _this$props.vertical;
	
	        if (utils.isEventFromHandle(e, _this.handlesRefs)) {
	          var handlePosition = utils.getHandleCenterPosition(vertical, e.target);
	          _this.dragOffset = 0;
	          _this.onStart(handlePosition);
	          utils.pauseEvent(e);
	          if (onFocus) {
	            onFocus(e);
	          }
	        }
	      };
	
	      _this.onBlur = function (e) {
	        var onBlur = _this.props.onBlur;
	
	        _this.onEnd(e);
	        if (onBlur) {
	          onBlur(e);
	        }
	      };
	
	      _this.onMouseUp = function () {
	        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
	          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
	        }
	      };
	
	      _this.onMouseMove = function (e) {
	        if (!_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	        var position = utils.getMousePosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.onTouchMove = function (e) {
	        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	
	        var position = utils.getTouchPosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.onKeyDown = function (e) {
	        if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.onKeyboard(e);
	        }
	      };
	
	      _this.onClickMarkLabel = function (e, value) {
	        e.stopPropagation();
	        _this.onChange({ value: value });
	        _this.onEnd();
	      };
	
	      _this.saveSlider = function (slider) {
	        _this.sliderRef = slider;
	      };
	
	      if (utils.isDev()) {
	        var step = props.step,
	            max = props.max,
	            min = props.min;
	
	        var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
	        (0, _warning2['default'])(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
	      }
	      _this.handlesRefs = {};
	      return _this;
	    }
	
	    (0, _createClass3['default'])(ComponentEnhancer, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // Snapshot testing cannot handle refs, so be sure to null-check this.
	        this.document = this.sliderRef && this.sliderRef.ownerDocument;
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if ((0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
	        this.removeDocumentEvents();
	      }
	    }, {
	      key: 'getSliderStart',
	      value: function getSliderStart() {
	        var slider = this.sliderRef;
	        var rect = slider.getBoundingClientRect();
	
	        return this.props.vertical ? rect.top : rect.left + window.pageXOffset;
	      }
	    }, {
	      key: 'getSliderLength',
	      value: function getSliderLength() {
	        var slider = this.sliderRef;
	        if (!slider) {
	          return 0;
	        }
	
	        var coords = slider.getBoundingClientRect();
	        return this.props.vertical ? coords.height : coords.width;
	      }
	    }, {
	      key: 'addDocumentTouchEvents',
	      value: function addDocumentTouchEvents() {
	        // just work for Chrome iOS Safari and Android Browser
	        this.onTouchMoveListener = (0, _addEventListener2['default'])(this.document, 'touchmove', this.onTouchMove);
	        this.onTouchUpListener = (0, _addEventListener2['default'])(this.document, 'touchend', this.onEnd);
	      }
	    }, {
	      key: 'addDocumentMouseEvents',
	      value: function addDocumentMouseEvents() {
	        this.onMouseMoveListener = (0, _addEventListener2['default'])(this.document, 'mousemove', this.onMouseMove);
	        this.onMouseUpListener = (0, _addEventListener2['default'])(this.document, 'mouseup', this.onEnd);
	      }
	    }, {
	      key: 'removeDocumentEvents',
	      value: function removeDocumentEvents() {
	        /* eslint-disable no-unused-expressions */
	        this.onTouchMoveListener && this.onTouchMoveListener.remove();
	        this.onTouchUpListener && this.onTouchUpListener.remove();
	
	        this.onMouseMoveListener && this.onMouseMoveListener.remove();
	        this.onMouseUpListener && this.onMouseUpListener.remove();
	        /* eslint-enable no-unused-expressions */
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        if (!this.props.disabled) {
	          this.handlesRefs[0].focus();
	        }
	      }
	    }, {
	      key: 'blur',
	      value: function blur() {
	        var _this2 = this;
	
	        if (!this.props.disabled) {
	          Object.keys(this.handlesRefs).forEach(function (key) {
	            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
	              _this2.handlesRefs[key].blur();
	            }
	          });
	        }
	      }
	    }, {
	      key: 'calcValue',
	      value: function calcValue(offset) {
	        var _props = this.props,
	            vertical = _props.vertical,
	            min = _props.min,
	            max = _props.max;
	
	        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
	        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
	        return value;
	      }
	    }, {
	      key: 'calcValueByPos',
	      value: function calcValueByPos(position) {
	        var pixelOffset = position - this.getSliderStart();
	        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
	        return nextValue;
	      }
	    }, {
	      key: 'calcOffset',
	      value: function calcOffset(value) {
	        var _props2 = this.props,
	            min = _props2.min,
	            max = _props2.max;
	
	        var ratio = (value - min) / (max - min);
	        return ratio * 100;
	      }
	    }, {
	      key: 'saveHandle',
	      value: function saveHandle(index, handle) {
	        this.handlesRefs[index] = handle;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classNames;
	
	        var _props3 = this.props,
	            prefixCls = _props3.prefixCls,
	            className = _props3.className,
	            marks = _props3.marks,
	            dots = _props3.dots,
	            step = _props3.step,
	            included = _props3.included,
	            disabled = _props3.disabled,
	            vertical = _props3.vertical,
	            min = _props3.min,
	            max = _props3.max,
	            children = _props3.children,
	            maximumTrackStyle = _props3.maximumTrackStyle,
	            style = _props3.style,
	            railStyle = _props3.railStyle,
	            dotStyle = _props3.dotStyle,
	            activeDotStyle = _props3.activeDotStyle;
	
	        var _get$call = (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
	            tracks = _get$call.tracks,
	            handles = _get$call.handles;
	
	        var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
	        return _react2['default'].createElement(
	          'div',
	          {
	            ref: this.saveSlider,
	            className: sliderClassName,
	            onTouchStart: disabled ? noop : this.onTouchStart,
	            onMouseDown: disabled ? noop : this.onMouseDown,
	            onMouseUp: disabled ? noop : this.onMouseUp,
	            onKeyDown: disabled ? noop : this.onKeyDown,
	            onFocus: disabled ? noop : this.onFocus,
	            onBlur: disabled ? noop : this.onBlur,
	            style: style
	          },
	          _react2['default'].createElement('div', {
	            className: prefixCls + '-rail',
	            style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
	          }),
	          tracks,
	          _react2['default'].createElement(_Steps2['default'], {
	            prefixCls: prefixCls,
	            vertical: vertical,
	            marks: marks,
	            dots: dots,
	            step: step,
	            included: included,
	            lowerBound: this.getLowerBound(),
	            upperBound: this.getUpperBound(),
	            max: max,
	            min: min,
	            dotStyle: dotStyle,
	            activeDotStyle: activeDotStyle
	          }),
	          handles,
	          _react2['default'].createElement(_Marks2['default'], {
	            className: prefixCls + '-mark',
	            onClickLabel: disabled ? noop : this.onClickMarkLabel,
	            vertical: vertical,
	            marks: marks,
	            included: included,
	            lowerBound: this.getLowerBound(),
	            upperBound: this.getUpperBound(),
	            max: max,
	            min: min
	          }),
	          children
	        );
	      }
	    }]);
	    return ComponentEnhancer;
	  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
	    min: _propTypes2['default'].number,
	    max: _propTypes2['default'].number,
	    step: _propTypes2['default'].number,
	    marks: _propTypes2['default'].object,
	    included: _propTypes2['default'].bool,
	    className: _propTypes2['default'].string,
	    prefixCls: _propTypes2['default'].string,
	    disabled: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any,
	    onBeforeChange: _propTypes2['default'].func,
	    onChange: _propTypes2['default'].func,
	    onAfterChange: _propTypes2['default'].func,
	    handle: _propTypes2['default'].func,
	    dots: _propTypes2['default'].bool,
	    vertical: _propTypes2['default'].bool,
	    style: _propTypes2['default'].object,
	    minimumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
	    maximumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
	    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    railStyle: _propTypes2['default'].object,
	    dotStyle: _propTypes2['default'].object,
	    activeDotStyle: _propTypes2['default'].object,
	    autoFocus: _propTypes2['default'].bool,
	    onFocus: _propTypes2['default'].func,
	    onBlur: _propTypes2['default'].func
	  }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
	    prefixCls: 'rc-slider',
	    className: '',
	    min: 0,
	    max: 100,
	    step: 1,
	    marks: {},
	    handle: function handle(_ref) {
	      var index = _ref.index,
	          restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);
	
	      delete restProps.dragging;
	      if (restProps.value === null) {
	        return null;
	      }
	
	      return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, { key: index }));
	    },
	
	    onBeforeChange: noop,
	    onChange: noop,
	    onAfterChange: noop,
	    included: true,
	    disabled: false,
	    dots: false,
	    vertical: false,
	    trackStyle: [{}],
	    handleStyle: [{}],
	    railStyle: {},
	    dotStyle: {},
	    activeDotStyle: {}
	  }), _temp;
	}
	module.exports = exports['default'];

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createSliderWithTooltip = exports.Handle = exports.Range = undefined;
	
	var _Slider = __webpack_require__(2714);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Range = __webpack_require__(2713);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	var _Handle = __webpack_require__(435);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _createSliderWithTooltip = __webpack_require__(2717);
	
	var _createSliderWithTooltip2 = _interopRequireDefault(_createSliderWithTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Slider2['default'].Range = _Range2['default'];
	_Slider2['default'].Handle = _Handle2['default'];
	_Slider2['default'].createSliderWithTooltip = _createSliderWithTooltip2['default'];
	exports['default'] = _Slider2['default'];
	exports.Range = _Range2['default'];
	exports.Handle = _Handle2['default'];
	exports.createSliderWithTooltip = _createSliderWithTooltip2['default'];

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rcAnimate = __webpack_require__(2725);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _toArray = __webpack_require__(239);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _reactLifecyclesCompat = __webpack_require__(160);
	
	var _contextTypes = __webpack_require__(872);
	
	var _util = __webpack_require__(873);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ICON_OPEN = 'open';
	var ICON_CLOSE = 'close';
	
	var defaultTitle = '---';
	
	var TreeNode = function (_React$Component) {
	  (0, _inherits3['default'])(TreeNode, _React$Component);
	
	  function TreeNode(props) {
	    (0, _classCallCheck3['default'])(this, TreeNode);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (TreeNode.__proto__ || Object.getPrototypeOf(TreeNode)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      dragNodeHighlight: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(TreeNode, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return (0, _extends3['default'])({}, this.context, {
	        rcTreeNode: {
	          // onUpCheckConduct: this.onUpCheckConduct,
	        }
	      });
	    }
	
	    // Isomorphic needn't load data in server side
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncLoadData(this.props);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.syncLoadData(this.props);
	    }
	
	    // Disabled item still can be switch
	
	
	    // Drag usage
	
	  }, {
	    key: 'isSelectable',
	    value: function isSelectable() {
	      var selectable = this.props.selectable;
	      var treeSelectable = this.context.rcTree.selectable;
	
	      // Ignore when selectable is undefined or null
	
	      if (typeof selectable === 'boolean') {
	        return selectable;
	      }
	
	      return treeSelectable;
	    }
	
	    // Load data to avoid default expanded tree without data
	
	
	    // Switcher
	
	
	    // Checkbox
	
	
	    // Icon + Title
	
	
	    // Children list wrapped with `Animation`
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var loading = this.props.loading;
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          dragOver = _props.dragOver,
	          dragOverGapTop = _props.dragOverGapTop,
	          dragOverGapBottom = _props.dragOverGapBottom,
	          isLeaf = _props.isLeaf,
	          expanded = _props.expanded,
	          selected = _props.selected,
	          checked = _props.checked,
	          halfChecked = _props.halfChecked,
	          otherProps = (0, _objectWithoutProperties3['default'])(_props, ['className', 'style', 'dragOver', 'dragOverGapTop', 'dragOverGapBottom', 'isLeaf', 'expanded', 'selected', 'checked', 'halfChecked']);
	      var _context$rcTree = this.context.rcTree,
	          prefixCls = _context$rcTree.prefixCls,
	          filterTreeNode = _context$rcTree.filterTreeNode,
	          draggable = _context$rcTree.draggable;
	
	      var disabled = this.isDisabled();
	      var dataOrAriaAttributeProps = (0, _util.getDataAndAria)(otherProps);
	
	      return _react2['default'].createElement(
	        'li',
	        (0, _extends3['default'])({
	          className: (0, _classnames2['default'])(className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-switcher-' + (expanded ? 'open' : 'close'), !isLeaf), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-checkbox-checked', checked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-checkbox-indeterminate', halfChecked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-selected', selected), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-loading', loading), (0, _defineProperty3['default'])(_classNames, 'drag-over', !disabled && dragOver), (0, _defineProperty3['default'])(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), (0, _defineProperty3['default'])(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), (0, _defineProperty3['default'])(_classNames, 'filter-node', filterTreeNode && filterTreeNode(this)), _classNames)),
	
	          style: style,
	
	          role: 'treeitem',
	
	          onDragEnter: draggable ? this.onDragEnter : undefined,
	          onDragOver: draggable ? this.onDragOver : undefined,
	          onDragLeave: draggable ? this.onDragLeave : undefined,
	          onDrop: draggable ? this.onDrop : undefined,
	          onDragEnd: draggable ? this.onDragEnd : undefined
	        }, dataOrAriaAttributeProps),
	        this.renderSwitcher(),
	        this.renderCheckbox(),
	        this.renderSelector(),
	        this.renderChildren()
	      );
	    }
	  }]);
	  return TreeNode;
	}(_react2['default'].Component);
	
	TreeNode.propTypes = {
	  eventKey: _propTypes2['default'].string, // Pass by parent `cloneElement`
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  root: _propTypes2['default'].object,
	  onSelect: _propTypes2['default'].func,
	
	  // By parent
	  expanded: _propTypes2['default'].bool,
	  selected: _propTypes2['default'].bool,
	  checked: _propTypes2['default'].bool,
	  loaded: _propTypes2['default'].bool,
	  loading: _propTypes2['default'].bool,
	  halfChecked: _propTypes2['default'].bool,
	  children: _propTypes2['default'].node,
	  title: _propTypes2['default'].node,
	  pos: _propTypes2['default'].string,
	  dragOver: _propTypes2['default'].bool,
	  dragOverGapTop: _propTypes2['default'].bool,
	  dragOverGapBottom: _propTypes2['default'].bool,
	
	  // By user
	  isLeaf: _propTypes2['default'].bool,
	  selectable: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  disableCheckbox: _propTypes2['default'].bool,
	  icon: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]),
	  switcherIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func])
	};
	TreeNode.contextTypes = _contextTypes.nodeContextTypes;
	TreeNode.childContextTypes = _contextTypes.nodeContextTypes;
	TreeNode.defaultProps = {
	  title: defaultTitle
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onSelectorClick = function (e) {
	    // Click trigger before select/check operation
	    var onNodeClick = _this2.context.rcTree.onNodeClick;
	
	    onNodeClick(e, _this2);
	
	    if (_this2.isSelectable()) {
	      _this2.onSelect(e);
	    } else {
	      _this2.onCheck(e);
	    }
	  };
	
	  this.onSelectorDoubleClick = function (e) {
	    var onNodeDoubleClick = _this2.context.rcTree.onNodeDoubleClick;
	
	    onNodeDoubleClick(e, _this2);
	  };
	
	  this.onSelect = function (e) {
	    if (_this2.isDisabled()) return;
	
	    var onNodeSelect = _this2.context.rcTree.onNodeSelect;
	
	    e.preventDefault();
	    onNodeSelect(e, _this2);
	  };
	
	  this.onCheck = function (e) {
	    if (_this2.isDisabled()) return;
	
	    var _props2 = _this2.props,
	        disableCheckbox = _props2.disableCheckbox,
	        checked = _props2.checked;
	    var _context$rcTree2 = _this2.context.rcTree,
	        checkable = _context$rcTree2.checkable,
	        onNodeCheck = _context$rcTree2.onNodeCheck;
	
	
	    if (!checkable || disableCheckbox) return;
	
	    e.preventDefault();
	    var targetChecked = !checked;
	    onNodeCheck(e, _this2, targetChecked);
	  };
	
	  this.onMouseEnter = function (e) {
	    var onNodeMouseEnter = _this2.context.rcTree.onNodeMouseEnter;
	
	    onNodeMouseEnter(e, _this2);
	  };
	
	  this.onMouseLeave = function (e) {
	    var onNodeMouseLeave = _this2.context.rcTree.onNodeMouseLeave;
	
	    onNodeMouseLeave(e, _this2);
	  };
	
	  this.onContextMenu = function (e) {
	    var onNodeContextMenu = _this2.context.rcTree.onNodeContextMenu;
	
	    onNodeContextMenu(e, _this2);
	  };
	
	  this.onDragStart = function (e) {
	    var onNodeDragStart = _this2.context.rcTree.onNodeDragStart;
	
	
	    e.stopPropagation();
	    _this2.setState({
	      dragNodeHighlight: true
	    });
	    onNodeDragStart(e, _this2);
	
	    try {
	      // ie throw error
	      // firefox-need-it
	      e.dataTransfer.setData('text/plain', '');
	    } catch (error) {
	      // empty
	    }
	  };
	
	  this.onDragEnter = function (e) {
	    var onNodeDragEnter = _this2.context.rcTree.onNodeDragEnter;
	
	
	    e.preventDefault();
	    e.stopPropagation();
	    onNodeDragEnter(e, _this2);
	  };
	
	  this.onDragOver = function (e) {
	    var onNodeDragOver = _this2.context.rcTree.onNodeDragOver;
	
	
	    e.preventDefault();
	    e.stopPropagation();
	    onNodeDragOver(e, _this2);
	  };
	
	  this.onDragLeave = function (e) {
	    var onNodeDragLeave = _this2.context.rcTree.onNodeDragLeave;
	
	
	    e.stopPropagation();
	    onNodeDragLeave(e, _this2);
	  };
	
	  this.onDragEnd = function (e) {
	    var onNodeDragEnd = _this2.context.rcTree.onNodeDragEnd;
	
	
	    e.stopPropagation();
	    _this2.setState({
	      dragNodeHighlight: false
	    });
	    onNodeDragEnd(e, _this2);
	  };
	
	  this.onDrop = function (e) {
	    var onNodeDrop = _this2.context.rcTree.onNodeDrop;
	
	
	    e.preventDefault();
	    e.stopPropagation();
	    _this2.setState({
	      dragNodeHighlight: false
	    });
	    onNodeDrop(e, _this2);
	  };
	
	  this.onExpand = function (e) {
	    var onNodeExpand = _this2.context.rcTree.onNodeExpand;
	
	    onNodeExpand(e, _this2);
	  };
	
	  this.setSelectHandle = function (node) {
	    _this2.selectHandle = node;
	  };
	
	  this.getNodeChildren = function () {
	    var children = _this2.props.children;
	
	    var originList = (0, _toArray2['default'])(children).filter(function (node) {
	      return node;
	    });
	    var targetList = (0, _util.getNodeChildren)(originList);
	
	    if (originList.length !== targetList.length) {
	      (0, _util.warnOnlyTreeNode)();
	    }
	
	    return targetList;
	  };
	
	  this.getNodeState = function () {
	    var expanded = _this2.props.expanded;
	
	
	    if (_this2.isLeaf()) {
	      return null;
	    }
	
	    return expanded ? ICON_OPEN : ICON_CLOSE;
	  };
	
	  this.isLeaf = function () {
	    var _props3 = _this2.props,
	        isLeaf = _props3.isLeaf,
	        loaded = _props3.loaded;
	    var loadData = _this2.context.rcTree.loadData;
	
	
	    var hasChildren = _this2.getNodeChildren().length !== 0;
	
	    if (isLeaf === false) {
	      return false;
	    }
	
	    return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
	  };
	
	  this.isDisabled = function () {
	    var disabled = _this2.props.disabled;
	    var treeDisabled = _this2.context.rcTree.disabled;
	
	    // Follow the logic of Selectable
	
	    if (disabled === false) {
	      return false;
	    }
	
	    return !!(treeDisabled || disabled);
	  };
	
	  this.syncLoadData = function (props) {
	    var expanded = props.expanded,
	        loading = props.loading,
	        loaded = props.loaded;
	    var _context$rcTree3 = _this2.context.rcTree,
	        loadData = _context$rcTree3.loadData,
	        onNodeLoad = _context$rcTree3.onNodeLoad;
	
	
	    if (loading) return;
	
	    // read from state to avoid loadData at same time
	    if (loadData && expanded && !_this2.isLeaf()) {
	      // We needn't reload data when has children in sync logic
	      // It's only needed in node expanded
	      var hasChildren = _this2.getNodeChildren().length !== 0;
	      if (!hasChildren && !loaded) {
	        onNodeLoad(_this2);
	      }
	    }
	  };
	
	  this.renderSwitcher = function () {
	    var _props4 = _this2.props,
	        expanded = _props4.expanded,
	        switcherIconFromProps = _props4.switcherIcon;
	    var _context$rcTree4 = _this2.context.rcTree,
	        prefixCls = _context$rcTree4.prefixCls,
	        switcherIconFromCtx = _context$rcTree4.switcherIcon;
	
	
	    var switcherIcon = switcherIconFromProps || switcherIconFromCtx;
	
	    if (_this2.isLeaf()) {
	      return _react2['default'].createElement(
	        'span',
	        { className: (0, _classnames2['default'])(prefixCls + '-switcher', prefixCls + '-switcher-noop') },
	        typeof switcherIcon === 'function' ? _react2['default'].createElement(switcherIcon, (0, _extends3['default'])({}, _this2.props, { isLeaf: true })) : switcherIcon
	      );
	    }
	
	    var switcherCls = (0, _classnames2['default'])(prefixCls + '-switcher', prefixCls + '-switcher_' + (expanded ? ICON_OPEN : ICON_CLOSE));
	    return _react2['default'].createElement(
	      'span',
	      { onClick: _this2.onExpand, className: switcherCls },
	      typeof switcherIcon === 'function' ? _react2['default'].createElement(switcherIcon, (0, _extends3['default'])({}, _this2.props, { isLeaf: false })) : switcherIcon
	    );
	  };
	
	  this.renderCheckbox = function () {
	    var _props5 = _this2.props,
	        checked = _props5.checked,
	        halfChecked = _props5.halfChecked,
	        disableCheckbox = _props5.disableCheckbox;
	    var _context$rcTree5 = _this2.context.rcTree,
	        prefixCls = _context$rcTree5.prefixCls,
	        checkable = _context$rcTree5.checkable;
	
	    var disabled = _this2.isDisabled();
	
	    if (!checkable) return null;
	
	    // [Legacy] Custom element should be separate with `checkable` in future
	    var $custom = typeof checkable !== 'boolean' ? checkable : null;
	
	    return _react2['default'].createElement(
	      'span',
	      {
	        className: (0, _classnames2['default'])(prefixCls + '-checkbox', checked && prefixCls + '-checkbox-checked', !checked && halfChecked && prefixCls + '-checkbox-indeterminate', (disabled || disableCheckbox) && prefixCls + '-checkbox-disabled'),
	        onClick: _this2.onCheck
	      },
	      $custom
	    );
	  };
	
	  this.renderIcon = function () {
	    var loading = _this2.props.loading;
	    var prefixCls = _this2.context.rcTree.prefixCls;
	
	
	    return _react2['default'].createElement('span', {
	      className: (0, _classnames2['default'])(prefixCls + '-iconEle', prefixCls + '-icon__' + (_this2.getNodeState() || 'docu'), loading && prefixCls + '-icon_loading')
	    });
	  };
	
	  this.renderSelector = function () {
	    var dragNodeHighlight = _this2.state.dragNodeHighlight;
	    var _props6 = _this2.props,
	        title = _props6.title,
	        selected = _props6.selected,
	        icon = _props6.icon,
	        loading = _props6.loading;
	    var _context$rcTree6 = _this2.context.rcTree,
	        prefixCls = _context$rcTree6.prefixCls,
	        showIcon = _context$rcTree6.showIcon,
	        treeIcon = _context$rcTree6.icon,
	        draggable = _context$rcTree6.draggable,
	        loadData = _context$rcTree6.loadData;
	
	    var disabled = _this2.isDisabled();
	
	    var wrapClass = prefixCls + '-node-content-wrapper';
	
	    // Icon - Still show loading icon when loading without showIcon
	    var $icon = void 0;
	
	    if (showIcon) {
	      var currentIcon = icon || treeIcon;
	
	      $icon = currentIcon ? _react2['default'].createElement(
	        'span',
	        {
	          className: (0, _classnames2['default'])(prefixCls + '-iconEle', prefixCls + '-icon__customize')
	        },
	        typeof currentIcon === 'function' ? _react2['default'].createElement(currentIcon, (0, _extends3['default'])({}, _this2.props)) : currentIcon
	      ) : _this2.renderIcon();
	    } else if (loadData && loading) {
	      $icon = _this2.renderIcon();
	    }
	
	    // Title
	    var $title = _react2['default'].createElement(
	      'span',
	      { className: prefixCls + '-title' },
	      title
	    );
	
	    return _react2['default'].createElement(
	      'span',
	      {
	        ref: _this2.setSelectHandle,
	        title: typeof title === 'string' ? title : '',
	        className: (0, _classnames2['default'])('' + wrapClass, wrapClass + '-' + (_this2.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && prefixCls + '-node-selected', !disabled && draggable && 'draggable'),
	        draggable: !disabled && draggable || undefined,
	        'aria-grabbed': !disabled && draggable || undefined,
	
	        onMouseEnter: _this2.onMouseEnter,
	        onMouseLeave: _this2.onMouseLeave,
	        onContextMenu: _this2.onContextMenu,
	        onClick: _this2.onSelectorClick,
	        onDoubleClick: _this2.onSelectorDoubleClick,
	        onDragStart: draggable ? _this2.onDragStart : undefined
	      },
	      $icon,
	      $title
	    );
	  };
	
	  this.renderChildren = function () {
	    var _props7 = _this2.props,
	        expanded = _props7.expanded,
	        pos = _props7.pos;
	    var _context$rcTree7 = _this2.context.rcTree,
	        prefixCls = _context$rcTree7.prefixCls,
	        openTransitionName = _context$rcTree7.openTransitionName,
	        openAnimation = _context$rcTree7.openAnimation,
	        renderTreeNode = _context$rcTree7.renderTreeNode;
	
	
	    var animProps = {};
	    if (openTransitionName) {
	      animProps.transitionName = openTransitionName;
	    } else if (typeof openAnimation === 'object') {
	      animProps.animation = (0, _extends3['default'])({}, openAnimation);
	    }
	
	    // Children TreeNode
	    var nodeList = _this2.getNodeChildren();
	
	    if (nodeList.length === 0) {
	      return null;
	    }
	
	    var $children = void 0;
	    if (expanded) {
	      $children = _react2['default'].createElement(
	        'ul',
	        {
	          className: (0, _classnames2['default'])(prefixCls + '-child-tree', expanded && prefixCls + '-child-tree-open'),
	          'data-expanded': expanded,
	          role: 'group'
	        },
	        (0, _util.mapChildren)(nodeList, function (node, index) {
	          return renderTreeNode(node, index, pos);
	        })
	      );
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      (0, _extends3['default'])({}, animProps, {
	        showProp: 'data-expanded',
	        component: ''
	      }),
	      $children
	    );
	  };
	};
	
	TreeNode.isTreeNode = 1;
	
	(0, _reactLifecyclesCompat.polyfill)(TreeNode);
	
	exports['default'] = TreeNode;
	module.exports = exports['default'];

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nodeContextTypes = exports.treeContextTypes = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Thought we still use `cloneElement` to pass `key`,
	 * other props can pass with context for future refactor.
	 */
	var treeContextTypes = exports.treeContextTypes = {
	  rcTree: _propTypes2['default'].shape({
	    root: _propTypes2['default'].object,
	
	    prefixCls: _propTypes2['default'].string,
	    selectable: _propTypes2['default'].bool,
	    showIcon: _propTypes2['default'].bool,
	    icon: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]),
	    draggable: _propTypes2['default'].bool,
	    checkable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	    checkStrictly: _propTypes2['default'].bool,
	    disabled: _propTypes2['default'].bool,
	    openTransitionName: _propTypes2['default'].string,
	    openAnimation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	
	    loadData: _propTypes2['default'].func,
	    filterTreeNode: _propTypes2['default'].func,
	    renderTreeNode: _propTypes2['default'].func,
	
	    isKeyChecked: _propTypes2['default'].func,
	
	    onNodeClick: _propTypes2['default'].func,
	    onNodeDoubleClick: _propTypes2['default'].func,
	    onNodeExpand: _propTypes2['default'].func,
	    onNodeSelect: _propTypes2['default'].func,
	    onNodeCheck: _propTypes2['default'].func,
	    onNodeMouseEnter: _propTypes2['default'].func,
	    onNodeMouseLeave: _propTypes2['default'].func,
	    onNodeContextMenu: _propTypes2['default'].func,
	    onNodeDragStart: _propTypes2['default'].func,
	    onNodeDragEnter: _propTypes2['default'].func,
	    onNodeDragOver: _propTypes2['default'].func,
	    onNodeDragLeave: _propTypes2['default'].func,
	    onNodeDragEnd: _propTypes2['default'].func,
	    onNodeDrop: _propTypes2['default'].func
	
	    // TODO: Remove this
	    // onBatchNodeCheck: PropTypes.func,
	    // onCheckConductFinished: PropTypes.func,
	
	    // Tree will store the entities when the treeNode refresh.
	    // User can pass the func to add more info to customize the additional info.
	    // processTreeEntity: PropTypes.func,
	  })
	}; /**
	    * Webpack has bug for import loop, which is not the same behavior as ES module.
	    * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
	    */
	
	var nodeContextTypes = exports.nodeContextTypes = (0, _extends3['default'])({}, treeContextTypes, {
	  rcTreeNode: _propTypes2['default'].shape({
	    onUpCheckConduct: _propTypes2['default'].func
	  })
	});

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.warnOnlyTreeNode = warnOnlyTreeNode;
	exports.arrDel = arrDel;
	exports.arrAdd = arrAdd;
	exports.posToArr = posToArr;
	exports.getPosition = getPosition;
	exports.isTreeNode = isTreeNode;
	exports.getNodeChildren = getNodeChildren;
	exports.isCheckDisabled = isCheckDisabled;
	exports.traverseTreeNodes = traverseTreeNodes;
	exports.mapChildren = mapChildren;
	exports.getDragNodesKeys = getDragNodesKeys;
	exports.calcDropPosition = calcDropPosition;
	exports.calcSelectedKeys = calcSelectedKeys;
	exports.convertDataToTree = convertDataToTree;
	exports.convertTreeToEntities = convertTreeToEntities;
	exports.parseCheckedKeys = parseCheckedKeys;
	exports.conductCheck = conductCheck;
	exports.conductExpandParent = conductExpandParent;
	exports.getDataAndAria = getDataAndAria;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _toArray = __webpack_require__(239);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TreeNode = __webpack_require__(871);
	
	var _TreeNode2 = _interopRequireDefault(_TreeNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DRAG_SIDE_RANGE = 0.25;
	var DRAG_MIN_GAP = 2;
	
	var onlyTreeNodeWarned = false;
	
	function warnOnlyTreeNode() {
	  if (onlyTreeNodeWarned) return;
	
	  onlyTreeNodeWarned = true;
	  (0, _warning2['default'])(false, 'Tree only accept TreeNode as children.');
	}
	
	function arrDel(list, value) {
	  var clone = list.slice();
	  var index = clone.indexOf(value);
	  if (index >= 0) {
	    clone.splice(index, 1);
	  }
	  return clone;
	}
	
	function arrAdd(list, value) {
	  var clone = list.slice();
	  if (clone.indexOf(value) === -1) {
	    clone.push(value);
	  }
	  return clone;
	}
	
	function posToArr(pos) {
	  return pos.split('-');
	}
	
	function getPosition(level, index) {
	  return level + '-' + index;
	}
	
	function isTreeNode(node) {
	  return node && node.type && node.type.isTreeNode;
	}
	
	function getNodeChildren(children) {
	  return (0, _toArray2['default'])(children).filter(isTreeNode);
	}
	
	function isCheckDisabled(node) {
	  var _ref = node.props || {},
	      disabled = _ref.disabled,
	      disableCheckbox = _ref.disableCheckbox;
	
	  return !!(disabled || disableCheckbox);
	}
	
	function traverseTreeNodes(treeNodes, callback) {
	  function processNode(node, index, parent) {
	    var children = node ? node.props.children : treeNodes;
	    var pos = node ? getPosition(parent.pos, index) : 0;
	
	    // Filter children
	    var childList = getNodeChildren(children);
	
	    // Process node if is not root
	    if (node) {
	      var data = {
	        node: node,
	        index: index,
	        pos: pos,
	        key: node.key || pos,
	        parentPos: parent.node ? parent.pos : null
	      };
	
	      callback(data);
	    }
	
	    // Process children node
	    _react.Children.forEach(childList, function (subNode, subIndex) {
	      processNode(subNode, subIndex, { node: node, pos: pos });
	    });
	  }
	
	  processNode(null);
	}
	
	/**
	 * Use `rc-util` `toArray` to get the children list which keeps the key.
	 * And return single node if children is only one(This can avoid `key` missing check).
	 */
	function mapChildren(children, func) {
	  var list = (0, _toArray2['default'])(children).map(func);
	  if (list.length === 1) {
	    return list[0];
	  }
	  return list;
	}
	
	function getDragNodesKeys(treeNodes, node) {
	  var _node$props = node.props,
	      eventKey = _node$props.eventKey,
	      pos = _node$props.pos;
	
	  var dragNodesKeys = [];
	
	  traverseTreeNodes(treeNodes, function (_ref2) {
	    var key = _ref2.key;
	
	    dragNodesKeys.push(key);
	  });
	  dragNodesKeys.push(eventKey || pos);
	  return dragNodesKeys;
	}
	
	// Only used when drag, not affect SSR.
	function calcDropPosition(event, treeNode) {
	  var clientY = event.clientY;
	
	  var _treeNode$selectHandl = treeNode.selectHandle.getBoundingClientRect(),
	      top = _treeNode$selectHandl.top,
	      bottom = _treeNode$selectHandl.bottom,
	      height = _treeNode$selectHandl.height;
	
	  var des = Math.max(height * DRAG_SIDE_RANGE, DRAG_MIN_GAP);
	
	  if (clientY <= top + des) {
	    return -1;
	  } else if (clientY >= bottom - des) {
	    return 1;
	  }
	
	  return 0;
	}
	
	/**
	 * Return selectedKeys according with multiple prop
	 * @param selectedKeys
	 * @param props
	 * @returns [string]
	 */
	function calcSelectedKeys(selectedKeys, props) {
	  if (!selectedKeys) return undefined;
	
	  var multiple = props.multiple;
	
	  if (multiple) {
	    return selectedKeys.slice();
	  }
	
	  if (selectedKeys.length) {
	    return [selectedKeys[0]];
	  }
	  return selectedKeys;
	}
	
	/**
	 * Since React internal will convert key to string,
	 * we need do this to avoid `checkStrictly` use number match
	 */
	function keyListToString(keyList) {
	  if (!keyList) return keyList;
	  return keyList.map(function (key) {
	    return String(key);
	  });
	}
	
	var internalProcessProps = function internalProcessProps(props) {
	  return props;
	};
	function convertDataToTree(treeData, processer) {
	  if (!treeData) return [];
	
	  var _ref3 = processer || {},
	      _ref3$processProps = _ref3.processProps,
	      processProps = _ref3$processProps === undefined ? internalProcessProps : _ref3$processProps;
	
	  var list = Array.isArray(treeData) ? treeData : [treeData];
	  return list.map(function (_ref4) {
	    var children = _ref4.children,
	        props = (0, _objectWithoutProperties3['default'])(_ref4, ['children']);
	
	    var childrenNodes = convertDataToTree(children, processer);
	
	    return _react2['default'].createElement(
	      _TreeNode2['default'],
	      processProps(props),
	      childrenNodes
	    );
	  });
	}
	
	// TODO: ========================= NEW LOGIC =========================
	/**
	 * Calculate treeNodes entities. `processTreeEntity` is used for `rc-tree-select`
	 * @param treeNodes
	 * @param processTreeEntity  User can customize the entity
	 */
	function convertTreeToEntities(treeNodes) {
	  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      initWrapper = _ref5.initWrapper,
	      processEntity = _ref5.processEntity,
	      onProcessFinished = _ref5.onProcessFinished;
	
	  var posEntities = {};
	  var keyEntities = {};
	  var wrapper = {
	    posEntities: posEntities,
	    keyEntities: keyEntities
	  };
	
	  if (initWrapper) {
	    wrapper = initWrapper(wrapper) || wrapper;
	  }
	
	  traverseTreeNodes(treeNodes, function (item) {
	    var node = item.node,
	        index = item.index,
	        pos = item.pos,
	        key = item.key,
	        parentPos = item.parentPos;
	
	    var entity = { node: node, index: index, key: key, pos: pos };
	
	    posEntities[pos] = entity;
	    keyEntities[key] = entity;
	
	    // Fill children
	    entity.parent = posEntities[parentPos];
	    if (entity.parent) {
	      entity.parent.children = entity.parent.children || [];
	      entity.parent.children.push(entity);
	    }
	
	    if (processEntity) {
	      processEntity(entity, wrapper);
	    }
	  });
	
	  if (onProcessFinished) {
	    onProcessFinished(wrapper);
	  }
	
	  return wrapper;
	}
	
	/**
	 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
	 */
	function parseCheckedKeys(keys) {
	  if (!keys) {
	    return null;
	  }
	
	  // Convert keys to object format
	  var keyProps = void 0;
	  if (Array.isArray(keys)) {
	    // [Legacy] Follow the api doc
	    keyProps = {
	      checkedKeys: keys,
	      halfCheckedKeys: undefined
	    };
	  } else if (typeof keys === 'object') {
	    keyProps = {
	      checkedKeys: keys.checked || undefined,
	      halfCheckedKeys: keys.halfChecked || undefined
	    };
	  } else {
	    (0, _warning2['default'])(false, '`checkedKeys` is not an array or an object');
	    return null;
	  }
	
	  keyProps.checkedKeys = keyListToString(keyProps.checkedKeys);
	  keyProps.halfCheckedKeys = keyListToString(keyProps.halfCheckedKeys);
	
	  return keyProps;
	}
	
	/**
	 * Conduct check state by the keyList. It will conduct up & from the provided key.
	 * If the conduct path reach the disabled or already checked / unchecked node will stop conduct.
	 * @param keyList       list of keys
	 * @param isCheck       is check the node or not
	 * @param keyEntities   parsed by `convertTreeToEntities` function in Tree
	 * @param checkStatus   Can pass current checked status for process (usually for uncheck operation)
	 * @returns {{checkedKeys: [], halfCheckedKeys: []}}
	 */
	function conductCheck(keyList, isCheck, keyEntities) {
	  var checkStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var checkedKeys = {};
	  var halfCheckedKeys = {}; // Record the key has some child checked (include child half checked)
	
	  (checkStatus.checkedKeys || []).forEach(function (key) {
	    checkedKeys[key] = true;
	  });
	
	  (checkStatus.halfCheckedKeys || []).forEach(function (key) {
	    halfCheckedKeys[key] = true;
	  });
	
	  // Conduct up
	  function conductUp(key) {
	    if (checkedKeys[key] === isCheck) return;
	
	    var entity = keyEntities[key];
	    if (!entity) return;
	
	    var children = entity.children,
	        parent = entity.parent,
	        node = entity.node;
	
	
	    if (isCheckDisabled(node)) return;
	
	    // Check child node checked status
	    var everyChildChecked = true;
	    var someChildChecked = false; // Child checked or half checked
	
	    (children || []).filter(function (child) {
	      return !isCheckDisabled(child.node);
	    }).forEach(function (_ref6) {
	      var childKey = _ref6.key;
	
	      var childChecked = checkedKeys[childKey];
	      var childHalfChecked = halfCheckedKeys[childKey];
	
	      if (childChecked || childHalfChecked) someChildChecked = true;
	      if (!childChecked) everyChildChecked = false;
	    });
	
	    // Update checked status
	    if (isCheck) {
	      checkedKeys[key] = everyChildChecked;
	    } else {
	      checkedKeys[key] = false;
	    }
	    halfCheckedKeys[key] = someChildChecked;
	
	    if (parent) {
	      conductUp(parent.key);
	    }
	  }
	
	  // Conduct down
	  function conductDown(key) {
	    if (checkedKeys[key] === isCheck) return;
	
	    var entity = keyEntities[key];
	    if (!entity) return;
	
	    var children = entity.children,
	        node = entity.node;
	
	
	    if (isCheckDisabled(node)) return;
	
	    checkedKeys[key] = isCheck;
	
	    (children || []).forEach(function (child) {
	      conductDown(child.key);
	    });
	  }
	
	  function conduct(key) {
	    var entity = keyEntities[key];
	
	    if (!entity) {
	      (0, _warning2['default'])(false, '\'' + key + '\' does not exist in the tree.');
	      return;
	    }
	
	    var children = entity.children,
	        parent = entity.parent,
	        node = entity.node;
	
	    checkedKeys[key] = isCheck;
	
	    if (isCheckDisabled(node)) return;
	
	    // Conduct down
	    (children || []).filter(function (child) {
	      return !isCheckDisabled(child.node);
	    }).forEach(function (child) {
	      conductDown(child.key);
	    });
	
	    // Conduct up
	    if (parent) {
	      conductUp(parent.key);
	    }
	  }
	
	  (keyList || []).forEach(function (key) {
	    conduct(key);
	  });
	
	  var checkedKeyList = [];
	  var halfCheckedKeyList = [];
	
	  // Fill checked list
	  Object.keys(checkedKeys).forEach(function (key) {
	    if (checkedKeys[key]) {
	      checkedKeyList.push(key);
	    }
	  });
	
	  // Fill half checked list
	  Object.keys(halfCheckedKeys).forEach(function (key) {
	    if (!checkedKeys[key] && halfCheckedKeys[key]) {
	      halfCheckedKeyList.push(key);
	    }
	  });
	
	  return {
	    checkedKeys: checkedKeyList,
	    halfCheckedKeys: halfCheckedKeyList
	  };
	}
	
	/**
	 * If user use `autoExpandParent` we should get the list of parent node
	 * @param keyList
	 * @param keyEntities
	 */
	function conductExpandParent(keyList, keyEntities) {
	  var expandedKeys = {};
	
	  function conductUp(key) {
	    if (expandedKeys[key]) return;
	
	    var entity = keyEntities[key];
	    if (!entity) return;
	
	    expandedKeys[key] = true;
	
	    var parent = entity.parent,
	        node = entity.node;
	
	
	    if (isCheckDisabled(node)) return;
	
	    if (parent) {
	      conductUp(parent.key);
	    }
	  }
	
	  (keyList || []).forEach(function (key) {
	    conductUp(key);
	  });
	
	  return Object.keys(expandedKeys);
	}
	
	/**
	 * Returns only the data- and aria- key/value pairs
	 * @param {object} props 
	 */
	function getDataAndAria(props) {
	  return Object.keys(props).reduce(function (prev, key) {
	    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
	      prev[key] = props[key];
	    }
	    return prev;
	  }, {});
	}

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toArray2 = __webpack_require__(358);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.genAnimateChild = genAnimateChild;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(160);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentClasses = __webpack_require__(541);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	var _raf = __webpack_require__(310);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _util = __webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var clonePropList = ['appeared', 'show', 'exclusive', 'children', 'animation'];
	
	/**
	 * AnimateChild only accept one child node.
	 * `transitionSupport` is used for none transition test case.
	 * Default we use browser transition event support check.
	 */
	function genAnimateChild(transitionSupport) {
	  var AnimateChild = function (_React$Component) {
	    (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	    function AnimateChild() {
	      (0, _classCallCheck3['default'])(this, AnimateChild);
	
	      // [Legacy] Since old code addListener on the element.
	      // To avoid break the behaviour that component not handle animation/transition
	      // also can handle the animate, let keep the logic.
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).call(this));
	
	      _this.state = {
	        child: null,
	
	        eventQueue: [],
	        eventActive: false
	      };
	
	      _this.onDomUpdated = function () {
	        var eventActive = _this.state.eventActive;
	        var _this$props = _this.props,
	            transitionName = _this$props.transitionName,
	            animation = _this$props.animation,
	            onChildLeaved = _this$props.onChildLeaved,
	            animateKey = _this$props.animateKey;
	
	
	        var $ele = _this.getDomElement();
	
	        // Skip if dom element not ready
	        if (!$ele) return;
	
	        // [Legacy] Add animation/transition event by dom level
	        if (transitionSupport && _this.$prevEle !== $ele) {
	          _this.cleanDomEvent();
	
	          _this.$prevEle = $ele;
	          _this.$prevEle.addEventListener(_util.animationEndName, _this.onMotionEnd);
	          _this.$prevEle.addEventListener(_util.transitionEndName, _this.onMotionEnd);
	        }
	
	        var currentEvent = _this.getCurrentEvent();
	        if (currentEvent.empty) {
	          // Additional process the leave event
	          if (currentEvent.lastEventType === 'leave') {
	            onChildLeaved(animateKey);
	          }
	          return;
	        }
	
	        var eventType = currentEvent.eventType,
	            restQueue = currentEvent.restQueue;
	
	        var nodeClasses = (0, _componentClasses2['default'])($ele);
	
	        // [Legacy] Since origin code use js to set `className`.
	        // This caused that any component without support `className` can be forced set.
	        // Let's keep the logic.
	        function legacyAppendClass() {
	          if (!transitionSupport) return;
	
	          var basicClassName = (0, _util.getTransitionName)(transitionName, '' + eventType);
	          if (basicClassName) nodeClasses.add(basicClassName);
	
	          if (eventActive) {
	            var activeClassName = (0, _util.getTransitionName)(transitionName, eventType + '-active');
	            if (activeClassName) nodeClasses.add(activeClassName);
	          }
	        }
	
	        if (_this.currentEvent && _this.currentEvent.type === eventType) {
	          legacyAppendClass();
	          return;
	        }
	
	        // Clear timeout for legacy check
	        clearTimeout(_this.timeout);
	
	        // Clean up last event environment
	        if (_this.currentEvent && _this.currentEvent.animateObj && _this.currentEvent.animateObj.stop) {
	          _this.currentEvent.animateObj.stop();
	        }
	
	        // Clean up last transition class
	        if (_this.currentEvent) {
	          var basicClassName = (0, _util.getTransitionName)(transitionName, '' + _this.currentEvent.type);
	          var activeClassName = (0, _util.getTransitionName)(transitionName, _this.currentEvent.type + '-active');
	          if (basicClassName) nodeClasses.remove(basicClassName);
	          if (activeClassName) nodeClasses.remove(activeClassName);
	        }
	
	        // New event come
	        _this.currentEvent = {
	          type: eventType
	        };
	
	        var animationHandler = (animation || {})[eventType];
	        // =============== Check if has customize animation ===============
	        if (animationHandler) {
	          _this.currentEvent.animateObj = animationHandler($ele, function () {
	            _this.onMotionEnd({ target: $ele });
	          });
	
	          // Do next step if not animate object provided
	          if (!_this.currentEvent || !_this.currentEvent.animateObj) {
	            _this.nextEvent(restQueue);
	          }
	
	          // ==================== Use transition instead ====================
	        } else if (transitionSupport) {
	          legacyAppendClass();
	          if (!eventActive) {
	            // Trigger `eventActive` in next frame
	            (0, _raf2['default'])(function () {
	              if (_this.currentEvent && _this.currentEvent.type === eventType && !_this._destroy) {
	                _this.setState({ eventActive: true }, function () {
	                  // [Legacy] Handle timeout if browser transition event not handle
	                  var transitionDelay = (0, _util.getStyleValue)($ele, 'transition-delay') || 0;
	                  var transitionDuration = (0, _util.getStyleValue)($ele, 'transition-duration') || 0;
	                  var animationDelay = (0, _util.getStyleValue)($ele, 'animation-delay') || 0;
	                  var animationDuration = (0, _util.getStyleValue)($ele, 'animation-duration') || 0;
	                  var totalTime = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	
	                  if (totalTime >= 0) {
	                    _this.timeout = setTimeout(function () {
	                      _this.onMotionEnd({ target: $ele });
	                    }, totalTime * 1000);
	                  }
	                });
	              }
	            });
	          }
	
	          // ======================= Just next action =======================
	        } else {
	          _this.onMotionEnd({ target: $ele });
	        }
	      };
	
	      _this.onMotionEnd = function (_ref) {
	        var target = _ref.target;
	        var _this$props2 = _this.props,
	            transitionName = _this$props2.transitionName,
	            onChildLeaved = _this$props2.onChildLeaved,
	            animateKey = _this$props2.animateKey,
	            onAppear = _this$props2.onAppear,
	            onEnter = _this$props2.onEnter,
	            onLeave = _this$props2.onLeave,
	            onEnd = _this$props2.onEnd;
	
	        var currentEvent = _this.getCurrentEvent();
	        if (currentEvent.empty) return;
	
	        // Clear timeout for legacy check
	        clearTimeout(_this.timeout);
	
	        var restQueue = currentEvent.restQueue;
	
	
	        var $ele = _this.getDomElement();
	        if (!_this.currentEvent || $ele !== target) return;
	
	        if (_this.currentEvent.animateObj && _this.currentEvent.animateObj.stop) {
	          _this.currentEvent.animateObj.stop();
	        }
	
	        // [Legacy] Same as above, we need call js to remove the class
	        if (transitionSupport && _this.currentEvent) {
	          var basicClassName = (0, _util.getTransitionName)(transitionName, _this.currentEvent.type);
	          var activeClassName = (0, _util.getTransitionName)(transitionName, _this.currentEvent.type + '-active');
	
	          var nodeClasses = (0, _componentClasses2['default'])($ele);
	          if (basicClassName) nodeClasses.remove(basicClassName);
	          if (activeClassName) nodeClasses.remove(activeClassName);
	        }
	
	        // Additional process the leave event
	        if (_this.currentEvent && _this.currentEvent.type === 'leave') {
	          onChildLeaved(animateKey);
	        }
	
	        // [Legacy] Trigger on event when it's last event
	        if (_this.currentEvent && !restQueue.length) {
	          if (_this.currentEvent.type === 'appear' && onAppear) {
	            onAppear(animateKey);
	          } else if (_this.currentEvent.type === 'enter' && onEnter) {
	            onEnter(animateKey);
	          } else if (_this.currentEvent.type === 'leave' && onLeave) {
	            onLeave(animateKey);
	          }
	
	          if (onEnd) {
	            // OnEnd(key, isShow)
	            onEnd(animateKey, _this.currentEvent.type !== 'leave');
	          }
	        }
	
	        _this.currentEvent = null;
	
	        // Next queue
	        _this.nextEvent(restQueue);
	      };
	
	      _this.getDomElement = function () {
	        if (_this._destroy) return null;
	        return _reactDom2['default'].findDOMNode(_this);
	      };
	
	      _this.getCurrentEvent = function () {
	        var _this$state$eventQueu = _this.state.eventQueue,
	            eventQueue = _this$state$eventQueu === undefined ? [] : _this$state$eventQueu;
	        var _this$props3 = _this.props,
	            animation = _this$props3.animation,
	            exclusive = _this$props3.exclusive,
	            transitionAppear = _this$props3.transitionAppear,
	            transitionEnter = _this$props3.transitionEnter,
	            transitionLeave = _this$props3.transitionLeave;
	
	
	        function hasEventHandler(eventType) {
	          return eventType === 'appear' && (transitionAppear || animation.appear) || eventType === 'enter' && (transitionEnter || animation.enter) || eventType === 'leave' && (transitionLeave || animation.leave);
	        }
	
	        var event = null;
	        // If is exclusive, only check the last event
	        if (exclusive) {
	          var eventType = eventQueue[eventQueue.length - 1];
	          if (hasEventHandler(eventType)) {
	            event = {
	              eventType: eventType,
	              restQueue: []
	            };
	          }
	        } else {
	          // Loop check the queue until find match
	          var cloneQueue = eventQueue.slice();
	          while (cloneQueue.length) {
	            var _cloneQueue = cloneQueue,
	                _cloneQueue2 = (0, _toArray3['default'])(_cloneQueue),
	                _eventType = _cloneQueue2[0],
	                restQueue = _cloneQueue2.slice(1);
	
	            if (hasEventHandler(_eventType)) {
	              event = {
	                eventType: _eventType,
	                restQueue: restQueue
	              };
	              break;
	            }
	            cloneQueue = restQueue;
	          }
	        }
	
	        if (!event) {
	          event = {
	            empty: true,
	            lastEventType: eventQueue[eventQueue.length - 1]
	          };
	        }
	
	        return event;
	      };
	
	      _this.nextEvent = function (restQueue) {
	        // Next queue
	        if (!_this._destroy) {
	          _this.setState({
	            eventQueue: restQueue,
	            eventActive: false
	          });
	        }
	      };
	
	      _this.cleanDomEvent = function () {
	        if (_this.$prevEle && transitionSupport) {
	          _this.$prevEle.removeEventListener(_util.animationEndName, _this.onMotionEnd);
	          _this.$prevEle.removeEventListener(_util.transitionEndName, _this.onMotionEnd);
	        }
	      };
	
	      _this.$prevEle = null;
	
	      _this.currentEvent = null;
	      _this.timeout = null;
	      return _this;
	    }
	
	    (0, _createClass3['default'])(AnimateChild, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.onDomUpdated();
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        this.onDomUpdated();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        clearTimeout(this.timeout);
	        this._destroy = true;
	        this.cleanDomEvent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            child = _state.child,
	            eventActive = _state.eventActive;
	        var _props = this.props,
	            showProp = _props.showProp,
	            transitionName = _props.transitionName;
	
	        var _ref2 = child.props || {},
	            className = _ref2.className;
	
	        var currentEvent = this.getCurrentEvent();
	
	        // Class name
	        var connectClassName = transitionSupport && this.currentEvent ? (0, _classnames2['default'])(className, (0, _util.getTransitionName)(transitionName, this.currentEvent.type), eventActive && (0, _util.getTransitionName)(transitionName, this.currentEvent.type + '-active')) : className;
	
	        var show = true;
	
	        // Keep show when is in transition or has customize animate
	        if (transitionSupport && (!currentEvent.empty || this.currentEvent && this.currentEvent.animateObj)) {
	          show = true;
	        } else {
	          show = child.props[showProp];
	        }
	
	        // Clone child
	        var newChildProps = {
	          className: connectClassName
	        };
	
	        if (showProp) {
	          newChildProps[showProp] = show;
	        }
	
	        return _react2['default'].cloneElement(child, newChildProps);
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(nextProps, prevState) {
	        var _prevState$prevProps = prevState.prevProps,
	            prevProps = _prevState$prevProps === undefined ? {} : _prevState$prevProps;
	        var appeared = nextProps.appeared;
	
	
	        var newState = {
	          prevProps: (0, _util.cloneProps)(nextProps, clonePropList)
	        };
	
	        function processState(propName, updater) {
	          if (prevProps[propName] !== nextProps[propName]) {
	            if (updater) {
	              updater(nextProps[propName]);
	            }
	            return true;
	          }
	          return false;
	        }
	
	        function pushEvent(eventType) {
	          var eventQueue = newState.eventQueue || prevState.eventQueue.slice();
	          var matchIndex = eventQueue.indexOf(eventType);
	
	          // Clean the rest event if eventType match
	          if (matchIndex !== -1) {
	            eventQueue = eventQueue.slice(0, matchIndex);
	          }
	
	          eventQueue.push(eventType);
	          newState.eventQueue = eventQueue;
	        }
	
	        // Child update. Only set child.
	        processState('children', function (child) {
	          newState.child = child;
	        });
	
	        processState('appeared', function (isAppeared) {
	          if (isAppeared) {
	            pushEvent('appear');
	          }
	        });
	
	        // Show update
	        processState('show', function (show) {
	          if (!appeared) {
	            if (show) {
	              pushEvent('enter');
	            } else {
	              pushEvent('leave');
	            }
	          }
	        });
	
	        return newState;
	      }
	    }]);
	    return AnimateChild;
	  }(_react2['default'].Component);
	
	  AnimateChild.propTypes = {
	    transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    transitionAppear: _propTypes2['default'].bool,
	    transitionEnter: _propTypes2['default'].bool,
	    transitionLeave: _propTypes2['default'].bool,
	    exclusive: _propTypes2['default'].bool,
	    appeared: _propTypes2['default'].bool,
	    showProp: _propTypes2['default'].string,
	
	    animateKey: _propTypes2['default'].any,
	    animation: _propTypes2['default'].object,
	    onChildLeaved: _propTypes2['default'].func,
	
	    onEnd: _propTypes2['default'].func,
	    onAppear: _propTypes2['default'].func,
	    onEnter: _propTypes2['default'].func,
	    onLeave: _propTypes2['default'].func
	  };
	
	
	  (0, _reactLifecyclesCompat.polyfill)(AnimateChild);
	
	  return AnimateChild;
	}
	
	exports['default'] = genAnimateChild(_util.supportTransition);

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_Component) {
	  (0, _inherits3['default'])(LazyRenderBox, _Component);
	
	  function LazyRenderBox() {
	    (0, _classCallCheck3['default'])(this, LazyRenderBox);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  };
	
	  LazyRenderBox.prototype.render = function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2['default'].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2['default'].createElement('div', props);
	    }
	
	    return _react2['default'].Children.only(props.children);
	  };
	
	  return LazyRenderBox;
	}(_react.Component);
	
	LazyRenderBox.propTypes = {
	  children: _propTypes2['default'].any,
	  className: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool,
	  hiddenClassName: _propTypes2['default'].string
	};
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getAlignPopupClassName = getAlignPopupClassName;
	exports.saveRef = saveRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isPointsEq(a1, a2, isAlignPoint) {
	  if (isAlignPoint) {
	    return a1[0] === a2[0];
	  }
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3['default'])({}, baseAlign, align);
	}
	
	function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}
	
	function saveRef(name, component) {
	  this[name] = component;
	}

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(175);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MenuItem = __webpack_require__(438);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseMenu = function BaseMenu(props) {
	  return _react2.default.createElement(
	    'ul',
	    _extends({}, props, {
	      className: (0, _classnames2.default)('dropdown-menu', props.className) }),
	    props.children
	  );
	};
	
	/**
	 * Menu component that automatically handles pagination and empty state when
	 * passed a set of filtered and truncated results.
	 */
	
	var Menu = function (_React$Component) {
	  _inherits(Menu, _React$Component);
	
	  function Menu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'Menu', _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Menu, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          emptyLabel = _props.emptyLabel;
	
	      var noResults = _react.Children.count(children) === 0;
	
	      // If an empty string is passed, suppress menu when there are no results.
	      if (noResults && emptyLabel === '') {
	        return null;
	      }
	
	      var contents = noResults ? _react2.default.createElement(
	        _MenuItem.BaseMenuItem,
	        { disabled: true },
	        emptyLabel
	      ) : children;
	
	      return _react2.default.createElement(
	        BaseMenu,
	        {
	          className: (0, _classnames2.default)('bootstrap-typeahead-menu', {
	            'dropdown-menu-justify': align === 'justify',
	            'dropdown-menu-right': align === 'right'
	          }, className),
	          style: this._getMenuStyle() },
	        contents,
	        this._renderPaginationMenuItem()
	      );
	    }
	
	    /**
	     * Allow user to see more results, if available.
	     */
	
	  }, {
	    key: '_renderPaginationMenuItem',
	    value: function _renderPaginationMenuItem() {
	      var _props2 = this.props,
	          children = _props2.children,
	          onPaginate = _props2.onPaginate,
	          paginate = _props2.paginate,
	          paginationText = _props2.paginationText;
	
	
	      if (paginate && _react.Children.count(children)) {
	        return [_react2.default.createElement('li', {
	          className: 'divider',
	          key: 'pagination-item-divider',
	          role: 'separator'
	        }), _react2.default.createElement(
	          _MenuItem.BaseMenuItem,
	          {
	            className: 'bootstrap-typeahead-menu-paginator',
	            key: 'pagination-item',
	            onClick: onPaginate },
	          paginationText
	        )];
	      }
	    }
	  }, {
	    key: '_getMenuStyle',
	    value: function _getMenuStyle() {
	      var _props3 = this.props,
	          align = _props3.align,
	          dropup = _props3.dropup,
	          maxHeight = _props3.maxHeight,
	          style = _props3.style;
	
	      var menuStyle = _extends({}, style, {
	        display: 'block',
	        maxHeight: maxHeight + 'px',
	        overflow: 'auto'
	      });
	
	      if (style) {
	        if (dropup) {
	          menuStyle.top = 'auto';
	        } else {
	          delete menuStyle.bottom;
	        }
	        menuStyle.left = align === 'right' ? 'auto' : style.left;
	        menuStyle.right = align === 'left' ? 'auto' : style.right;
	      }
	
	      return menuStyle;
	    }
	  }]);
	
	  return Menu;
	}(_react2.default.Component);
	
	Menu.PropTypes = {
	  /**
	   * Specify menu alignment. The default value is `justify`, which makes the
	   * menu as wide as the input and truncates long values. Specifying `left`
	   * or `right` will align the menu to that side and the width will be
	   * determined by the length of menu item values.
	   */
	  align: _propTypes2.default.oneOf(['justify', 'left', 'right']),
	  /**
	   * Message to display in the menu if there are no valid results.
	   */
	  emptyLabel: _propTypes2.default.string,
	  /**
	   * Maximum height of the dropdown menu, in px.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Prompt displayed when large data sets are paginated.
	   */
	  paginationText: _propTypes2.default.string
	};
	
	Menu.defaultProps = {
	  align: 'justify',
	  emptyLabel: 'No matches found.',
	  maxHeight: 300,
	  paginate: true,
	  paginationText: 'Display additional results...'
	};
	
	exports.default = Menu;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _noop2 = __webpack_require__(298);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tokenContainer = __webpack_require__(883);
	
	var _tokenContainer2 = _interopRequireDefault(_tokenContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Token
	 *
	 * Individual token component, generally displayed within the TokenizerInput
	 * component, but can also be rendered on its own.
	 */
	var Token = function (_React$Component) {
	  _inherits(Token, _React$Component);
	
	  function Token() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Token);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Token.__proto__ || Object.getPrototypeOf(Token)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'Token', _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Token, [{
	    key: 'render',
	    value: function render() {
	      return this.props.onRemove && !this.props.disabled ? this._renderRemoveableToken() : this._renderToken();
	    }
	  }, {
	    key: '_renderRemoveableToken',
	    value: function _renderRemoveableToken() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onRemove = _props.onRemove,
	          selected = _props.selected,
	          otherProps = _objectWithoutProperties(_props, ['children', 'className', 'onRemove', 'selected']);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, otherProps, {
	          className: (0, _classnames2.default)('token', 'token-removeable', {
	            'token-selected': selected
	          }, className),
	          tabIndex: 0 }),
	        children,
	        _react2.default.createElement(
	          'span',
	          {
	            className: 'close-button',
	            onClick: onRemove,
	            role: 'button' },
	          '\xD7'
	        )
	      );
	    }
	  }, {
	    key: '_renderToken',
	    value: function _renderToken() {
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          href = _props2.href;
	
	      var classnames = (0, _classnames2.default)('token', { 'token-disabled': disabled }, className);
	
	      if (href) {
	        return _react2.default.createElement(
	          'a',
	          { className: classnames, href: href },
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classnames },
	        children
	      );
	    }
	  }]);
	
	  return Token;
	}(_react2.default.Component);
	
	Token.propTypes = {
	  /**
	   * Handler for removing/deleting the token. If not defined, the token will
	   * be rendered in a read-only state.
	   */
	  onRemove: _propTypes2.default.func,
	  selected: _propTypes2.default.bool
	};
	
	Token.defaultProps = {
	  onRemove: _noop3.default,
	  selected: false
	};
	
	exports.default = (0, _tokenContainer2.default)(Token);

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _noop2 = __webpack_require__(298);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _isEqual2 = __webpack_require__(31);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _find2 = __webpack_require__(47);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactOnclickoutside = __webpack_require__(951);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClearButton = __webpack_require__(2734);
	
	var _ClearButton2 = _interopRequireDefault(_ClearButton);
	
	var _Loader = __webpack_require__(2735);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Overlay = __webpack_require__(2736);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _TokenizerInput = __webpack_require__(2738);
	
	var _TokenizerInput2 = _interopRequireDefault(_TokenizerInput);
	
	var _TypeaheadInput = __webpack_require__(2739);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _TypeaheadMenu = __webpack_require__(2740);
	
	var _TypeaheadMenu2 = _interopRequireDefault(_TypeaheadMenu);
	
	var _addCustomOption = __webpack_require__(2741);
	
	var _addCustomOption2 = _interopRequireDefault(_addCustomOption);
	
	var _defaultFilterBy = __webpack_require__(2742);
	
	var _defaultFilterBy2 = _interopRequireDefault(_defaultFilterBy);
	
	var _getHintText = __webpack_require__(2743);
	
	var _getHintText2 = _interopRequireDefault(_getHintText);
	
	var _getInputText = __webpack_require__(2744);
	
	var _getInputText2 = _interopRequireDefault(_getInputText);
	
	var _getOptionLabel = __webpack_require__(193);
	
	var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);
	
	var _getTruncatedOptions = __webpack_require__(2745);
	
	var _getTruncatedOptions2 = _interopRequireDefault(_getTruncatedOptions);
	
	var _warn = __webpack_require__(886);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	var _keyCode = __webpack_require__(312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getInitialState(props) {
	  var defaultSelected = props.defaultSelected,
	      maxResults = props.maxResults;
	
	
	  var selected = props.selected.slice();
	  if (defaultSelected && defaultSelected.length) {
	    selected = defaultSelected;
	  }
	
	  return {
	    activeIndex: -1,
	    activeItem: null,
	    initialItem: null,
	    selected: selected,
	    showMenu: false,
	    shownResults: maxResults,
	    text: ''
	  };
	}
	
	/**
	 * Typeahead
	 */
	
	var Typeahead = function (_React$Component) {
	  _inherits(Typeahead, _React$Component);
	
	  function Typeahead(props) {
	    _classCallCheck(this, Typeahead);
	
	    var _this = _possibleConstructorReturn(this, (Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call(this, props));
	
	    _this._getFilteredResults = function () {
	      var _this$props = _this.props,
	          caseSensitive = _this$props.caseSensitive,
	          filterBy = _this$props.filterBy,
	          ignoreDiacritics = _this$props.ignoreDiacritics,
	          labelKey = _this$props.labelKey,
	          minLength = _this$props.minLength,
	          multiple = _this$props.multiple,
	          options = _this$props.options;
	      var _this$state = _this.state,
	          selected = _this$state.selected,
	          text = _this$state.text;
	
	
	      if (text.length < minLength) {
	        return [];
	      }
	
	      var callback = Array.isArray(filterBy) ? function (option) {
	        return (0, _defaultFilterBy2.default)(option, text, labelKey, multiple && !!(0, _find3.default)(selected, function (o) {
	          return (0, _isEqual3.default)(o, option);
	        }), { caseSensitive: caseSensitive, ignoreDiacritics: ignoreDiacritics, fields: filterBy });
	      } : function (option) {
	        return filterBy(option, text);
	      };
	
	      return options.filter(callback);
	    };
	
	    _this.blur = function () {
	      _this.refs.input.blur();
	      _this._hideDropdown();
	    };
	
	    _this.clear = function () {
	      _this.setState(getInitialState(_this.props));
	
	      _this._updateSelected([]);
	      _this._updateText('');
	    };
	
	    _this.focus = function () {
	      _this.refs.input.focus();
	    };
	
	    _this._renderInput = function (results) {
	      var _this$props2 = _this.props,
	          bsSize = _this$props2.bsSize,
	          disabled = _this$props2.disabled,
	          labelKey = _this$props2.labelKey,
	          minLength = _this$props2.minLength,
	          multiple = _this$props2.multiple,
	          name = _this$props2.name,
	          placeholder = _this$props2.placeholder,
	          renderToken = _this$props2.renderToken;
	      var _this$state2 = _this.state,
	          activeIndex = _this$state2.activeIndex,
	          activeItem = _this$state2.activeItem,
	          initialItem = _this$state2.initialItem,
	          selected = _this$state2.selected,
	          text = _this$state2.text;
	
	      var Input = multiple ? _TokenizerInput2.default : _TypeaheadInput2.default;
	      var inputProps = { bsSize: bsSize, disabled: disabled, name: name, placeholder: placeholder, renderToken: renderToken };
	
	      return _react2.default.createElement(Input, _extends({}, inputProps, {
	        activeIndex: activeIndex,
	        activeItem: activeItem,
	        hasAux: !!_this._renderAux(),
	        hintText: (0, _getHintText2.default)({
	          activeItem: activeItem,
	          initialItem: initialItem,
	          labelKey: labelKey,
	          minLength: minLength,
	          selected: selected,
	          text: text
	        }),
	        initialItem: initialItem,
	        labelKey: labelKey,
	        onAdd: _this._handleAddOption,
	        onBlur: _this._handleBlur,
	        onChange: _this._handleTextChange,
	        onFocus: _this._handleFocus,
	        onKeyDown: function onKeyDown(e) {
	          return _this._handleKeydown(results, e);
	        },
	        onRemove: _this._handleRemoveOption,
	        options: results,
	        ref: 'input',
	        selected: selected.slice(),
	        value: (0, _getInputText2.default)({ activeItem: activeItem, labelKey: labelKey, multiple: multiple, selected: selected, text: text })
	      }));
	    };
	
	    _this._renderMenu = function (results, shouldPaginate) {
	      var _this$props3 = _this.props,
	          align = _this$props3.align,
	          bodyContainer = _this$props3.bodyContainer,
	          dropup = _this$props3.dropup,
	          emptyLabel = _this$props3.emptyLabel,
	          labelKey = _this$props3.labelKey,
	          maxHeight = _this$props3.maxHeight,
	          minLength = _this$props3.minLength,
	          newSelectionPrefix = _this$props3.newSelectionPrefix,
	          paginationText = _this$props3.paginationText,
	          renderMenu = _this$props3.renderMenu,
	          renderMenuItemChildren = _this$props3.renderMenuItemChildren;
	      var _this$state3 = _this.state,
	          showMenu = _this$state3.showMenu,
	          text = _this$state3.text;
	
	
	      var menuProps = {
	        align: align,
	        dropup: dropup,
	        emptyLabel: emptyLabel,
	        labelKey: labelKey,
	        maxHeight: maxHeight,
	        newSelectionPrefix: newSelectionPrefix,
	        paginationText: paginationText,
	        onPaginate: _this._handlePagination,
	        paginate: shouldPaginate,
	        text: text
	      };
	
	      var menu = renderMenu ? renderMenu(results, menuProps) : _react2.default.createElement(_TypeaheadMenu2.default, _extends({}, menuProps, {
	        options: results,
	        renderMenuItemChildren: renderMenuItemChildren
	      }));
	
	      return _react2.default.createElement(
	        _Overlay2.default,
	        {
	          container: bodyContainer ? document.body : _this,
	          show: showMenu && text.length >= minLength,
	          target: function target() {
	            return _this.refs.input;
	          } },
	        menu
	      );
	    };
	
	    _this._renderAux = function () {
	      var _this$props4 = _this.props,
	          bsSize = _this$props4.bsSize,
	          clearButton = _this$props4.clearButton,
	          disabled = _this$props4.disabled,
	          isLoading = _this$props4.isLoading;
	
	
	      if (isLoading) {
	        return _react2.default.createElement(_Loader2.default, { bsSize: bsSize });
	      }
	
	      if (clearButton && !disabled && _this.state.selected.length) {
	        return _react2.default.createElement(_ClearButton2.default, {
	          bsSize: bsSize,
	          className: 'bootstrap-typeahead-clear-button',
	          onClick: _this.clear
	        });
	      }
	    };
	
	    _this._handleActiveItemChange = function (activeItem) {
	      _this.setState({ activeItem: activeItem });
	    };
	
	    _this._handleBlur = function (e) {
	      // Note: Don't hide the menu here, since that interferes with other actions
	      // like making a selection by clicking on a menu item.
	      _this.props.onBlur(e);
	    };
	
	    _this._handleFocus = function (e) {
	      _this.props.onFocus(e);
	      _this.setState({ showMenu: true });
	    };
	
	    _this._handleInitialItemChange = function (initialItem) {
	      var currentItem = _this.state.initialItem;
	
	      if (!currentItem) {
	        _this.setState({ initialItem: initialItem });
	        return;
	      }
	
	      var labelKey = _this.props.labelKey;
	
	      // Don't update the initial item if it hasn't changed. For custom items,
	      // compare the `labelKey` values since a unique id is generated each time,
	      // causing the comparison to always return false otherwise.
	
	      if ((0, _isEqual3.default)(initialItem, currentItem) || initialItem.customOption && initialItem[labelKey] === currentItem[labelKey]) {
	        return;
	      }
	
	      _this.setState({ initialItem: initialItem });
	    };
	
	    _this._handleTextChange = function (text) {
	      var _getInitialState = getInitialState(_this.props),
	          activeIndex = _getInitialState.activeIndex,
	          activeItem = _getInitialState.activeItem;
	
	      _this.setState({
	        activeIndex: activeIndex,
	        activeItem: activeItem,
	        showMenu: true
	      });
	      _this._updateText(text);
	    };
	
	    _this._handleKeydown = function (options, e) {
	      var _this$state4 = _this.state,
	          activeItem = _this$state4.activeItem,
	          showMenu = _this$state4.showMenu;
	
	
	      switch (e.keyCode) {
	        case _keyCode.UP:
	        case _keyCode.DOWN:
	          // Don't cycle through the options if the menu is hidden.
	          if (!showMenu) {
	            return;
	          }
	
	          var activeIndex = _this.state.activeIndex;
	
	          // Prevents input cursor from going to the beginning when pressing up.
	
	          e.preventDefault();
	
	          // Increment or decrement index based on user keystroke.
	          activeIndex += e.keyCode === _keyCode.UP ? -1 : 1;
	
	          // If we've reached the end, go back to the beginning or vice-versa.
	          if (activeIndex === options.length) {
	            activeIndex = -1;
	          } else if (activeIndex === -2) {
	            activeIndex = options.length - 1;
	          }
	
	          var newState = { activeIndex: activeIndex };
	          if (activeIndex === -1) {
	            // Reset the active item if there is no active index.
	            newState.activeItem = null;
	          }
	
	          _this.setState(newState);
	          break;
	        case _keyCode.ESC:
	        case _keyCode.TAB:
	          // Prevent closing dialogs.
	          e.keyCode === _keyCode.ESC && e.preventDefault();
	
	          _this._hideDropdown();
	          break;
	        case _keyCode.RETURN:
	          // if menu is shown and we have active item
	          // there is no any sense to submit form on <RETURN>
	          if (!_this.props.submitFormOnEnter || showMenu && activeItem) {
	            // Prevent submitting forms.
	            e.preventDefault();
	          }
	
	          if (showMenu && activeItem) {
	            _this._handleAddOption(activeItem);
	          }
	          break;
	      }
	    };
	
	    _this._handleAddOption = function (selectedOption) {
	      var _this$props5 = _this.props,
	          multiple = _this$props5.multiple,
	          labelKey = _this$props5.labelKey;
	
	
	      var selected = void 0;
	      var text = void 0;
	
	      if (multiple) {
	        // If multiple selections are allowed, add the new selection to the
	        // existing selections.
	        selected = _this.state.selected.concat(selectedOption);
	        text = '';
	      } else {
	        // If only a single selection is allowed, replace the existing selection
	        // with the new one.
	        selected = [selectedOption];
	        text = (0, _getOptionLabel2.default)(selectedOption, labelKey);
	      }
	
	      _this._hideDropdown();
	      _this._updateSelected(selected);
	      _this._updateText(text);
	
	      _this.setState({ initialItem: selectedOption });
	    };
	
	    _this._handlePagination = function (e) {
	      var _this$props6 = _this.props,
	          maxResults = _this$props6.maxResults,
	          onPaginate = _this$props6.onPaginate;
	
	
	      onPaginate(e);
	      _this.setState({ shownResults: _this.state.shownResults + maxResults });
	    };
	
	    _this._handleRemoveOption = function (removedOption) {
	      var selected = _this.state.selected.filter(function (option) {
	        return !(0, _isEqual3.default)(option, removedOption);
	      });
	
	      // Make sure the input stays focused after the item is removed.
	      _this.focus();
	      _this._hideDropdown();
	      _this._updateSelected(selected);
	    };
	
	    _this.handleClickOutside = function (e) {
	      _this.state.showMenu && _this._hideDropdown();
	    };
	
	    _this._hideDropdown = function () {
	      var _getInitialState2 = getInitialState(_this.props),
	          activeIndex = _getInitialState2.activeIndex,
	          activeItem = _getInitialState2.activeItem,
	          showMenu = _getInitialState2.showMenu,
	          shownResults = _getInitialState2.shownResults;
	
	      _this.setState({
	        activeIndex: activeIndex,
	        activeItem: activeItem,
	        showMenu: showMenu,
	        shownResults: shownResults
	      });
	    };
	
	    _this._updateSelected = function (selected) {
	      _this.setState({ selected: selected });
	      _this.props.onChange(selected);
	    };
	
	    _this._updateText = function (text) {
	      _this.setState({ text: text });
	      _this.props.onInputChange(text);
	    };
	
	    _this.state = getInitialState(props);
	    return _this;
	  }
	
	  _createClass(Typeahead, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        activeIndex: this.state.activeIndex,
	        onActiveItemChange: this._handleActiveItemChange,
	        onInitialItemChange: this._handleInitialItemChange,
	        onMenuItemClick: this._handleAddOption
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          allowNew = _props.allowNew,
	          caseSensitive = _props.caseSensitive,
	          filterBy = _props.filterBy,
	          ignoreDiacritics = _props.ignoreDiacritics,
	          labelKey = _props.labelKey;
	
	
	      (0, _warn2.default)(!(typeof filterBy === 'function' && (caseSensitive || !ignoreDiacritics)), 'Your `filterBy` function will override the `caseSensitive` and ' + '`ignoreDiacritics` props.');
	
	      (0, _warn2.default)(!(typeof labelKey === 'function' && allowNew), '`labelKey` must be a string if creating new options is allowed.');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.autoFocus && this.focus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var multiple = nextProps.multiple,
	          selected = nextProps.selected;
	
	      // If new selections are passed via props, treat as a controlled input.
	
	      if (!(0, _isEqual3.default)(selected, this.props.selected)) {
	        this.setState({ selected: selected });
	      }
	
	      // If component changes from multi-select to single-select, keep only the
	      // first selection, if any.
	      if (this.props.multiple && !multiple) {
	        this._updateSelected(this.state.selected.slice(0, 1));
	      }
	
	      if (multiple !== this.props.multiple) {
	        this.setState({ text: '' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          allowNew = _props2.allowNew,
	          className = _props2.className,
	          dropup = _props2.dropup,
	          labelKey = _props2.labelKey,
	          paginate = _props2.paginate;
	      var _state = this.state,
	          shownResults = _state.shownResults,
	          text = _state.text;
	
	      // First filter the results by the input string.
	
	      var results = this._getFilteredResults();
	
	      // This must come before we truncate.
	      var shouldPaginate = paginate && results.length > shownResults;
	
	      // Truncate if necessary.
	      results = (0, _getTruncatedOptions2.default)(results, shownResults);
	
	      // Add the custom option.
	      if (allowNew) {
	        results = (0, _addCustomOption2.default)(results, text, labelKey);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('bootstrap-typeahead', 'clearfix', 'open', {
	            'dropup': dropup
	          }, className),
	          style: { position: 'relative' } },
	        this._renderInput(results),
	        this._renderAux(),
	        this._renderMenu(results, shouldPaginate)
	      );
	    }
	
	    /**
	     * Public method to allow external clearing of the input. Clears both text
	     * and selection(s).
	     */
	
	
	    /**
	     * From `onClickOutside` HOC.
	     */
	
	  }]);
	
	  return Typeahead;
	}(_react2.default.Component);
	
	Typeahead.propTypes = {
	  /**
	   * Allows the creation of new selections on the fly. Note that any new items
	   * will be added to the list of selections, but not the list of original
	   * options unless handled as such by `Typeahead`'s parent.
	   */
	  allowNew: _propTypes2.default.bool,
	  /**
	   * Autofocus the input when the component initially mounts.
	   */
	  autoFocus: _propTypes2.default.bool,
	  /**
	   * Whether to render the menu inline or attach to `document.body`.
	   */
	  bodyContainer: _propTypes2.default.bool,
	  /**
	   * Whether or not filtering should be case-sensitive.
	   */
	  caseSensitive: _propTypes2.default.bool,
	  /**
	   * Displays a button to clear the input when there are selections.
	   */
	  clearButton: _propTypes2.default.bool,
	  /**
	   * Specify any pre-selected options. Use only if you want the component to
	   * be uncontrolled.
	   */
	  defaultSelected: _propTypes2.default.array,
	  /**
	   * Specify whether the menu should appear above the input.
	   */
	  dropup: _propTypes2.default.bool,
	  /**
	   * Either an array of fields in `option` to search, or a custom filtering
	   * callback.
	   */
	  filterBy: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string.isRequired), _propTypes2.default.func]),
	  /**
	   * Whether the filter should ignore accents and other diacritical marks.
	   */
	  ignoreDiacritics: _propTypes2.default.bool,
	  /**
	   * Indicate whether an asynchromous data fetch is happening.
	   */
	  isLoading: _propTypes2.default.bool,
	  /**
	   * Specify the option key to use for display or a function returning the
	   * display string. By default, the selector will use the `label` key.
	   */
	  labelKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Maximum number of results to display by default. Mostly done for
	   * performance reasons so as not to render too many DOM nodes in the case of
	   * large data sets.
	   */
	  maxResults: _propTypes2.default.number,
	  /**
	   * Number of input characters that must be entered before showing results.
	   */
	  minLength: _propTypes2.default.number,
	  /**
	   * Whether or not multiple selections are allowed.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Invoked when the input is blurred. Receives an event.
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Invoked whenever items are added or removed. Receives an array of the
	   * selected options.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Invoked when the input is focused. Receives an event.
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Invoked when the input value changes. Receives the string value of the
	   * input.
	   */
	  onInputChange: _propTypes2.default.func,
	  /**
	   * Invoked when the pagination menu item is clicked. Receives an event.
	   */
	  onPaginate: _propTypes2.default.func,
	  /**
	   * Full set of options, including pre-selected options. Must either be an
	   * array of objects (recommended) or strings.
	   */
	  options: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.object.isRequired), _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired)]).isRequired,
	  /**
	   * Give user the ability to display additional results if the number of
	   * results exceeds `maxResults`.
	   */
	  paginate: _propTypes2.default.bool,
	  /**
	   * Callback for custom menu rendering.
	   */
	  renderMenu: _propTypes2.default.func,
	  /**
	   * The selected option(s) displayed in the input. Use this prop if you want
	   * to control the component via its parent.
	   */
	  selected: _propTypes2.default.array,
	  /**
	   * Propagate <RETURN> event to parent form.
	   */
	  submitFormOnEnter: _propTypes2.default.bool
	};
	
	Typeahead.defaultProps = {
	  allowNew: false,
	  autoFocus: false,
	  bodyContainer: false,
	  caseSensitive: false,
	  clearButton: false,
	  defaultSelected: [],
	  dropup: false,
	  filterBy: [],
	  ignoreDiacritics: true,
	  isLoading: false,
	  labelKey: 'label',
	  maxResults: 100,
	  minLength: 0,
	  multiple: false,
	  onBlur: _noop3.default,
	  onChange: _noop3.default,
	  onFocus: _noop3.default,
	  onInputChange: _noop3.default,
	  onPaginate: _noop3.default,
	  paginate: true,
	  selected: [],
	  submitFormOnEnter: false
	};
	
	Typeahead.childContextTypes = {
	  activeIndex: _propTypes2.default.number.isRequired,
	  onActiveItemChange: _propTypes2.default.func.isRequired,
	  onInitialItemChange: _propTypes2.default.func.isRequired,
	  onMenuItemClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactOnclickoutside2.default)(Typeahead);

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(413);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_DELAY_MS = 200;
	
	/**
	 * HoC that encapsulates common behavior and functionality for doing
	 * asynchronous searches, including:
	 *
	 *  - Debouncing user input
	 *  - Query caching (optional)
	 *  - Search prompt and empty results behaviors
	 */
	var asyncContainer = function asyncContainer(Typeahead) {
	  var Container = function (_React$Component) {
	    _inherits(Container, _React$Component);
	
	    function Container(props) {
	      _classCallCheck(this, Container);
	
	      var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, props));
	
	      _this._handleChange = _this._handleChange.bind(_this);
	      _this._handleInputChange = _this._handleInputChange.bind(_this);
	      _this._handleSearch = _this._handleSearch.bind(_this);
	
	      _this.state = {
	        hasSelection: false,
	        query: '',
	        requestPending: false
	      };
	      return _this;
	    }
	
	    _createClass(Container, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this._cache = {};
	        this._handleSearchDebounced = (0, _debounce3.default)(this._handleSearch, this.props.delay);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var options = nextProps.options,
	            useCache = nextProps.useCache;
	        var _state = this.state,
	            query = _state.query,
	            requestPending = _state.requestPending;
	
	
	        if (!requestPending) {
	          return;
	        }
	
	        if (useCache) {
	          this._cache[query] = options;
	        }
	
	        this.setState({ requestPending: false });
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._cache = {};
	        this._handleSearchDebounced.cancel();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            allowNew = _props.allowNew,
	            options = _props.options,
	            useCache = _props.useCache,
	            props = _objectWithoutProperties(_props, ['allowNew', 'options', 'useCache']);
	
	        var cachedQuery = this._cache[this.state.query];
	        var emptyLabel = this._getEmptyLabel();
	
	        // Short-circuit the creation of custom selections while the user is in
	        // the process of searching. The logic for whether or not to display the
	        // custom menu option is basically the same as whether we display the
	        // empty label, so use that as a proxy.
	        var shouldAllowNew = allowNew && emptyLabel === props.emptyLabel;
	
	        return _react2.default.createElement(Typeahead, _extends({}, props, {
	          allowNew: shouldAllowNew,
	          emptyLabel: emptyLabel,
	          isLoading: this.state.requestPending,
	          onChange: this._handleChange,
	          onInputChange: this._handleInputChange,
	          options: useCache && cachedQuery ? cachedQuery : options,
	          ref: function ref(instance) {
	            return _this2._instance = instance;
	          }
	        }));
	      }
	
	      /**
	       * Make the component instance available.
	       */
	
	    }, {
	      key: 'getInstance',
	      value: function getInstance() {
	        return this._instance.getInstance();
	      }
	    }, {
	      key: '_getEmptyLabel',
	      value: function _getEmptyLabel() {
	        var _props2 = this.props,
	            emptyLabel = _props2.emptyLabel,
	            multiple = _props2.multiple,
	            promptText = _props2.promptText,
	            searchText = _props2.searchText,
	            useCache = _props2.useCache;
	        var _state2 = this.state,
	            hasSelection = _state2.hasSelection,
	            query = _state2.query,
	            requestPending = _state2.requestPending;
	
	
	        if (!query.length || !multiple && hasSelection) {
	          return promptText;
	        }
	
	        if (requestPending || useCache && !this._cache[query]) {
	          return searchText;
	        }
	
	        return emptyLabel;
	      }
	    }, {
	      key: '_handleChange',
	      value: function _handleChange(selected) {
	        this.props.onChange && this.props.onChange(selected);
	        this.setState({ hasSelection: !!selected.length });
	      }
	    }, {
	      key: '_handleInputChange',
	      value: function _handleInputChange(query) {
	        this.props.onInputChange && this.props.onInputChange(query);
	        this._handleSearchDebounced(query);
	      }
	    }, {
	      key: '_handleSearch',
	      value: function _handleSearch(initialQuery) {
	        var _props3 = this.props,
	            caseSensitive = _props3.caseSensitive,
	            minLength = _props3.minLength,
	            multiple = _props3.multiple,
	            onSearch = _props3.onSearch,
	            useCache = _props3.useCache;
	
	
	        var query = initialQuery.trim();
	        if (!caseSensitive) {
	          query = query.toLowerCase();
	        }
	
	        this.setState({ query: query });
	
	        if (!query || minLength && query.length < minLength) {
	          return;
	        }
	
	        // Use cached results, if available.
	        if (useCache && this._cache[query]) {
	          return;
	        }
	
	        // In the single-selection case, perform a search only on user input
	        // not selection.
	        if (!multiple && this.state.hasSelection) {
	          return;
	        }
	
	        // Perform the async search.
	        this.setState({ requestPending: true }, function () {
	          return onSearch(query);
	        });
	      }
	    }]);
	
	    return Container;
	  }(_react2.default.Component);
	
	  Container.propTypes = {
	    /**
	     * Delay, in milliseconds, before performing search.
	     */
	    delay: _propTypes2.default.number,
	    /**
	     * Callback to perform when the search is executed.
	     */
	    onSearch: _propTypes2.default.func.isRequired,
	    /**
	     * Options to be passed to the typeahead. Will typically be the query
	     * results, but can also be initial default options.
	     */
	    options: _propTypes2.default.array,
	    /**
	     * Text displayed in the menu when there is no user input.
	     */
	    promptText: _propTypes2.default.string,
	    /**
	     * Text displayed in the menu while the request is pending.
	     */
	    searchText: _propTypes2.default.string,
	    /**
	     * Whether or not the component should cache query results.
	     */
	    useCache: _propTypes2.default.bool
	  };
	
	  Container.defaultProps = {
	    delay: DEFAULT_DELAY_MS,
	    minLength: 2,
	    options: [],
	    promptText: 'Type to search...',
	    searchText: 'Searching...',
	    useCache: true
	  };
	
	  return Container;
	};
	
	exports.default = asyncContainer;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _getDisplayName = __webpack_require__(884);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _scrollIntoViewIfNeeded = __webpack_require__(2746);
	
	var _scrollIntoViewIfNeeded2 = _interopRequireDefault(_scrollIntoViewIfNeeded);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var menuItemContainer = function menuItemContainer(Component) {
	  var WrappedMenuItem = function (_React$Component) {
	    _inherits(WrappedMenuItem, _React$Component);
	
	    function WrappedMenuItem() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, WrappedMenuItem);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedMenuItem.__proto__ || Object.getPrototypeOf(WrappedMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	        var _this$props = _this.props,
	            option = _this$props.option,
	            onClick = _this$props.onClick;
	
	
	        _this.context.onMenuItemClick(option);
	        onClick && onClick(e);
	      }, _this._updateInitialItem = function (props) {
	        var option = props.option,
	            position = props.position;
	
	        if (position === 0) {
	          _this.context.onInitialItemChange(option);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(WrappedMenuItem, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this._updateInitialItem(this.props);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps, nextContext) {
	        var currentlyActive = this.context.activeIndex === this.props.position;
	        var option = nextProps.option,
	            position = nextProps.position;
	        var activeIndex = nextContext.activeIndex,
	            onActiveItemChange = nextContext.onActiveItemChange;
	
	
	        if (position == null) {
	          return;
	        }
	
	        // The item will become active.
	        if (activeIndex === position) {
	          // Ensures that if the menu items exceed the bounds of the menu, the
	          // menu will scroll up or down as the user hits the arrow keys.
	          (0, _scrollIntoViewIfNeeded2.default)((0, _reactDom.findDOMNode)(this));
	
	          // Fire the change handler when the menu item becomes active.
	          !currentlyActive && onActiveItemChange(option);
	        }
	
	        this._updateInitialItem(nextProps);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var activeIndex = this.context.activeIndex;
	
	        var _props = this.props,
	            position = _props.position,
	            props = _objectWithoutProperties(_props, ['position']);
	
	        return _react2.default.createElement(Component, _extends({}, props, {
	          active: activeIndex === position,
	          onClick: this._handleClick
	        }));
	      }
	    }]);
	
	    return WrappedMenuItem;
	  }(_react2.default.Component);
	
	  WrappedMenuItem.displayName = 'menuItemContainer(' + (0, _getDisplayName2.default)(Component) + ')';
	
	  WrappedMenuItem.propTypes = {
	    option: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
	    position: _propTypes2.default.number
	  };
	
	  WrappedMenuItem.contextTypes = {
	    activeIndex: _propTypes2.default.number.isRequired,
	    onActiveItemChange: _propTypes2.default.func.isRequired,
	    onInitialItemChange: _propTypes2.default.func.isRequired,
	    onMenuItemClick: _propTypes2.default.func.isRequired
	  };
	
	  return WrappedMenuItem;
	};
	
	exports.default = menuItemContainer;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _omit2 = __webpack_require__(417);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactOnclickoutside = __webpack_require__(951);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _getDisplayName = __webpack_require__(884);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _keyCode = __webpack_require__(312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Higher-order component that encapsulates Token behaviors, allowing them to
	 * be easily re-used.
	 */
	var tokenContainer = function tokenContainer(Component) {
	  var WrappedComponent = function (_React$Component) {
	    _inherits(WrappedComponent, _React$Component);
	
	    function WrappedComponent(props) {
	      _classCallCheck(this, WrappedComponent);
	
	      var _this = _possibleConstructorReturn(this, (WrappedComponent.__proto__ || Object.getPrototypeOf(WrappedComponent)).call(this, props));
	
	      _this.displayName = 'tokenContainer(' + (0, _getDisplayName2.default)(Component) + ')';
	
	
	      _this._handleBlur = _this._handleBlur.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._handleRemove = _this._handleRemove.bind(_this);
	      _this._handleSelect = _this._handleSelect.bind(_this);
	      _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	
	      _this.state = {
	        selected: false
	      };
	      return _this;
	    }
	
	    _createClass(WrappedComponent, [{
	      key: 'render',
	      value: function render() {
	        var tokenProps = (0, _omit3.default)(this.props, ['disableOnClickOutside', 'enableOnClickOutside']);
	
	        return _react2.default.createElement(Component, _extends({}, tokenProps, this.state, {
	          onBlur: this._handleBlur,
	          onClick: this._handleSelect,
	          onFocus: this._handleSelect,
	          onKeyDown: this._handleKeyDown
	        }));
	      }
	    }, {
	      key: '_handleBlur',
	      value: function _handleBlur(e) {
	        (0, _reactDom.findDOMNode)(this).blur();
	        this.setState({ selected: false });
	        this.props.disableOnClickOutside && this.props.disableOnClickOutside();
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        switch (e.keyCode) {
	          case _keyCode.BACKSPACE:
	            if (this.state.selected) {
	              // Prevent backspace keypress from triggering the browser "back"
	              // action.
	              e.preventDefault();
	              this._handleRemove();
	            }
	            break;
	        }
	      }
	
	      /**
	       * From `onClickOutside` HOC.
	       */
	
	    }, {
	      key: 'handleClickOutside',
	      value: function handleClickOutside(e) {
	        this._handleBlur();
	      }
	    }, {
	      key: '_handleRemove',
	      value: function _handleRemove(e) {
	        this.props.onRemove && this.props.onRemove();
	      }
	    }, {
	      key: '_handleSelect',
	      value: function _handleSelect(e) {
	        e.stopPropagation();
	        this.setState({ selected: true });
	        this.props.enableOnClickOutside && this.props.enableOnClickOutside();
	      }
	    }]);
	
	    return WrappedComponent;
	  }(_react2.default.Component);
	
	  return (0, _reactOnclickoutside2.default)(WrappedComponent);
	};
	
	exports.default = tokenContainer;

/***/ },
/* 884 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDisplayName;
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}

/***/ },
/* 885 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripDiacritics;
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Taken from: http://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript/18391901#18391901
	 */
	
	/* eslint-disable max-len */
	var map = [{ 'base': 'A', 'letters': 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' }, { 'base': 'AA', 'letters': '\uA732' }, { 'base': 'AE', 'letters': '\xC6\u01FC\u01E2' }, { 'base': 'AO', 'letters': '\uA734' }, { 'base': 'AU', 'letters': '\uA736' }, { 'base': 'AV', 'letters': '\uA738\uA73A' }, { 'base': 'AY', 'letters': '\uA73C' }, { 'base': 'B', 'letters': 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' }, { 'base': 'C', 'letters': 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E' }, { 'base': 'D', 'letters': 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0' }, { 'base': 'DZ', 'letters': '\u01F1\u01C4' }, { 'base': 'Dz', 'letters': '\u01F2\u01C5' }, { 'base': 'E', 'letters': 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' }, { 'base': 'F', 'letters': 'F\u24BB\uFF26\u1E1E\u0191\uA77B' }, { 'base': 'G', 'letters': 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' }, { 'base': 'H', 'letters': 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' }, { 'base': 'I', 'letters': 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' }, { 'base': 'J', 'letters': 'J\u24BF\uFF2A\u0134\u0248' }, { 'base': 'K', 'letters': 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' }, { 'base': 'L', 'letters': 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' }, { 'base': 'LJ', 'letters': '\u01C7' }, { 'base': 'Lj', 'letters': '\u01C8' }, { 'base': 'M', 'letters': 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' }, { 'base': 'N', 'letters': 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' }, { 'base': 'NJ', 'letters': '\u01CA' }, { 'base': 'Nj', 'letters': '\u01CB' }, { 'base': 'O', 'letters': 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C' }, { 'base': 'OI', 'letters': '\u01A2' }, { 'base': 'OO', 'letters': '\uA74E' }, { 'base': 'OU', 'letters': '\u0222' }, { 'base': 'OE', 'letters': '\x8C\u0152' }, { 'base': 'oe', 'letters': '\x9C\u0153' }, { 'base': 'P', 'letters': 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' }, { 'base': 'Q', 'letters': 'Q\u24C6\uFF31\uA756\uA758\u024A' }, { 'base': 'R', 'letters': 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' }, { 'base': 'S', 'letters': 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' }, { 'base': 'T', 'letters': 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' }, { 'base': 'TZ', 'letters': '\uA728' }, { 'base': 'U', 'letters': 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' }, { 'base': 'V', 'letters': 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' }, { 'base': 'VY', 'letters': '\uA760' }, { 'base': 'W', 'letters': 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' }, { 'base': 'X', 'letters': 'X\u24CD\uFF38\u1E8A\u1E8C' }, { 'base': 'Y', 'letters': 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' }, { 'base': 'Z', 'letters': 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' }, { 'base': 'a', 'letters': 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' }, { 'base': 'aa', 'letters': '\uA733' }, { 'base': 'ae', 'letters': '\xE6\u01FD\u01E3' }, { 'base': 'ao', 'letters': '\uA735' }, { 'base': 'au', 'letters': '\uA737' }, { 'base': 'av', 'letters': '\uA739\uA73B' }, { 'base': 'ay', 'letters': '\uA73D' }, { 'base': 'b', 'letters': 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' }, { 'base': 'c', 'letters': 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184' }, { 'base': 'd', 'letters': 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' }, { 'base': 'dz', 'letters': '\u01F3\u01C6' }, { 'base': 'e', 'letters': 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' }, { 'base': 'f', 'letters': 'f\u24D5\uFF46\u1E1F\u0192\uA77C' }, { 'base': 'g', 'letters': 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' }, { 'base': 'h', 'letters': 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' }, { 'base': 'hv', 'letters': '\u0195' }, { 'base': 'i', 'letters': 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' }, { 'base': 'j', 'letters': 'j\u24D9\uFF4A\u0135\u01F0\u0249' }, { 'base': 'k', 'letters': 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' }, { 'base': 'l', 'letters': 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' }, { 'base': 'lj', 'letters': '\u01C9' }, { 'base': 'm', 'letters': 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' }, { 'base': 'n', 'letters': 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' }, { 'base': 'nj', 'letters': '\u01CC' }, { 'base': 'o', 'letters': 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275' }, { 'base': 'oi', 'letters': '\u01A3' }, { 'base': 'ou', 'letters': '\u0223' }, { 'base': 'oo', 'letters': '\uA74F' }, { 'base': 'p', 'letters': 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' }, { 'base': 'q', 'letters': 'q\u24E0\uFF51\u024B\uA757\uA759' }, { 'base': 'r', 'letters': 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' }, { 'base': 's', 'letters': 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' }, { 'base': 't', 'letters': 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' }, { 'base': 'tz', 'letters': '\uA729' }, { 'base': 'u', 'letters': 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' }, { 'base': 'v', 'letters': 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' }, { 'base': 'vy', 'letters': '\uA761' }, { 'base': 'w', 'letters': 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' }, { 'base': 'x', 'letters': 'x\u24E7\uFF58\u1E8B\u1E8D' }, { 'base': 'y', 'letters': 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' }, { 'base': 'z', 'letters': 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }];
	/* eslint-enable max-len */
	
	var diacriticsMap = {};
	for (var ii = 0; ii < map.length; ii++) {
	  var letters = map[ii].letters;
	  for (var jj = 0; jj < letters.length; jj++) {
	    diacriticsMap[letters[jj]] = map[ii].base;
	  }
	}
	
	// "what?" version ... http://jsperf.com/diacritics/12
	function stripDiacritics(str) {
	  return str.replace(/[^\u0000-\u007E]/g, function (a) {
	    return diacriticsMap[a] || a;
	  });
	}

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = warn;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {}; /**
	                  * This code is copied from: https://github.com/ReactTraining/react-router/blob/master/modules/routerWarning.js
	                  */
	
	function warn(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	    warned[message] = true;
	  }
	
	  message = '[react-bootstrap-typeahead] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _height = __webpack_require__(1379);
	
	var _height2 = _interopRequireDefault(_height);
	
	var _offset = __webpack_require__(219);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _offsetParent = __webpack_require__(590);
	
	var _offsetParent2 = _interopRequireDefault(_offsetParent);
	
	var _scrollTop = __webpack_require__(391);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(593);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(313);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _getDocumentHeight = __webpack_require__(890);
	
	var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _ownerWindow = __webpack_require__(891);
	
	var _ownerWindow2 = _interopRequireDefault(_ownerWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Affix/>` component toggles `position: fixed;` on and off, emulating
	 * the effect found with `position: sticky;`.
	 */
	var Affix = function (_React$Component) {
	  _inherits(Affix, _React$Component);
	
	  function Affix(props, context) {
	    _classCallCheck(this, Affix);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.onWindowScroll = function () {
	      _this.onUpdate();
	    };
	
	    _this.onDocumentClick = function () {
	      (0, _requestAnimationFrame2.default)(function () {
	        return _this.onUpdate();
	      });
	    };
	
	    _this.onUpdate = function () {
	      if (!_this._isMounted) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          offsetTop = _this$props.offsetTop,
	          viewportOffsetTop = _this$props.viewportOffsetTop;
	
	      var scrollTop = (0, _scrollTop2.default)((0, _ownerWindow2.default)(_this));
	      var positionTopMin = scrollTop + (viewportOffsetTop || 0);
	
	      if (positionTopMin <= offsetTop) {
	        _this.updateState('top', null, null);
	        return;
	      }
	
	      if (positionTopMin > _this.getPositionTopMax()) {
	        if (_this.state.affixed === 'bottom') {
	          _this.updateStateAtBottom();
	        } else {
	          // Setting position away from `fixed` can change the offset parent of
	          // the affix, so we can't calculate the correct position until after
	          // we've updated its position.
	          _this.setState({
	            affixed: 'bottom',
	            position: 'absolute',
	            top: null
	          }, function () {
	            if (!_this._isMounted) {
	              return;
	            }
	
	            _this.updateStateAtBottom();
	          });
	        }
	        return;
	      }
	
	      _this.updateState('affix', 'fixed', viewportOffsetTop);
	    };
	
	    _this.getPositionTopMax = function () {
	      var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));
	      var height = (0, _height2.default)(_reactDom2.default.findDOMNode(_this));
	
	      return documentHeight - height - _this.props.offsetBottom;
	    };
	
	    _this.updateState = function (affixed, position, top) {
	      if (affixed === _this.state.affixed && position === _this.state.position && top === _this.state.top) {
	        return;
	      }
	
	      var upperName = affixed === 'affix' ? '' : affixed.charAt(0).toUpperCase() + affixed.substr(1);
	
	      if (_this.props['onAffix' + upperName]) {
	        _this.props['onAffix' + upperName]();
	      }
	
	      _this.setState({ affixed: affixed, position: position, top: top }, function () {
	        if (_this.props['onAffixed' + upperName]) {
	          _this.props['onAffixed' + upperName]();
	        }
	      });
	    };
	
	    _this.updateStateAtBottom = function () {
	      var positionTopMax = _this.getPositionTopMax();
	      var offsetParent = (0, _offsetParent2.default)(_reactDom2.default.findDOMNode(_this));
	      var parentTop = (0, _offset2.default)(offsetParent).top;
	
	      _this.updateState('bottom', 'absolute', positionTopMax - parentTop);
	    };
	
	    _this.state = {
	      affixed: 'top',
	      position: null,
	      top: null
	    };
	
	    _this._needPositionUpdate = false;
	    return _this;
	  }
	
	  Affix.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this._isMounted = true;
	
	    this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
	      return _this2.onWindowScroll();
	    });
	    this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
	      return _this2.onDocumentClick();
	    });
	
	    this.onUpdate();
	  };
	
	  Affix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needPositionUpdate = true;
	  };
	
	  Affix.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this._needPositionUpdate) {
	      this._needPositionUpdate = false;
	      this.onUpdate();
	    }
	  };
	
	  Affix.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	
	    if (this._windowScrollListener) {
	      this._windowScrollListener.remove();
	    }
	    if (this._documentClickListener) {
	      this._documentClickListener.remove();
	    }
	  };
	
	  Affix.prototype.render = function render() {
	    var child = _react2.default.Children.only(this.props.children);
	    var _child$props = child.props,
	        className = _child$props.className,
	        style = _child$props.style;
	    var _state = this.state,
	        affixed = _state.affixed,
	        position = _state.position,
	        top = _state.top;
	
	    var positionStyle = { position: position, top: top };
	
	    var affixClassName = void 0;
	    var affixStyle = void 0;
	    if (affixed === 'top') {
	      affixClassName = this.props.topClassName;
	      affixStyle = this.props.topStyle;
	    } else if (affixed === 'bottom') {
	      affixClassName = this.props.bottomClassName;
	      affixStyle = this.props.bottomStyle;
	    } else {
	      affixClassName = this.props.affixClassName;
	      affixStyle = this.props.affixStyle;
	    }
	
	    return _react2.default.cloneElement(child, {
	      className: (0, _classnames2.default)(affixClassName, className),
	      style: _extends({}, positionStyle, affixStyle, style)
	    });
	  };
	
	  return Affix;
	}(_react2.default.Component);
	
	Affix.propTypes = {
	  /**
	   * Pixels to offset from top of screen when calculating position
	   */
	  offsetTop: _propTypes2.default.number,
	
	  /**
	   * When affixed, pixels to offset from top of viewport
	   */
	  viewportOffsetTop: _propTypes2.default.number,
	
	  /**
	   * Pixels to offset from bottom of screen when calculating position
	   */
	  offsetBottom: _propTypes2.default.number,
	
	  /**
	   * CSS class or classes to apply when at top
	   */
	  topClassName: _propTypes2.default.string,
	
	  /**
	   * Style to apply when at top
	   */
	  topStyle: _propTypes2.default.object,
	
	  /**
	   * CSS class or classes to apply when affixed
	   */
	  affixClassName: _propTypes2.default.string,
	  /**
	   * Style to apply when affixed
	   */
	  affixStyle: _propTypes2.default.object,
	
	  /**
	   * CSS class or classes to apply when at bottom
	   */
	  bottomClassName: _propTypes2.default.string,
	
	  /**
	   * Style to apply when at bottom
	   */
	  bottomStyle: _propTypes2.default.object,
	
	  /**
	   * Callback fired when the right before the `affixStyle` and `affixStyle` props are rendered
	   */
	  onAffix: _propTypes2.default.func,
	  /**
	   * Callback fired after the component `affixStyle` and `affixClassName` props have been rendered.
	   */
	  onAffixed: _propTypes2.default.func,
	
	  /**
	   * Callback fired when the right before the `topStyle` and `topClassName` props are rendered
	   */
	  onAffixTop: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the component `topStyle` and `topClassName` props have been rendered.
	   */
	  onAffixedTop: _propTypes2.default.func,
	
	  /**
	   * Callback fired when the right before the `bottomStyle` and `bottomClassName` props are rendered
	   */
	  onAffixBottom: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the component `bottomStyle` and `bottomClassName` props have been rendered.
	   */
	  onAffixedBottom: _propTypes2.default.func
	};
	
	Affix.defaultProps = {
	  offsetTop: 0,
	  viewportOffsetTop: null,
	  offsetBottom: 0
	};
	
	exports.default = Affix;
	module.exports = exports['default'];

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(238);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _calculatePosition = __webpack_require__(2756);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(240);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.getTarget = function () {
	      var target = _this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    };
	
	    _this.maybeUpdatePosition = function (placementChanged) {
	      var target = _this.getTarget();
	
	      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      _this.updatePosition(target);
	    };
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition(this.getTarget());
	  };
	
	  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	    }
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state,
	        positionLeft = _state.positionLeft,
	        positionTop = _state.positionTop,
	        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	
	
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	    delete props.shouldUpdatePosition;
	
	    var child = _react2.default.Children.only(children);
	    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	      // and `props.style`.
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: (0, _classnames2.default)(className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.updatePosition = function updatePosition(target) {
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2.default.findDOMNode(this);
	    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _propTypes2.default.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _propTypes2.default.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contains = __webpack_require__(390);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(313);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.addEventListeners = function () {
	      var event = _this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(_this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
	
	      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
	
	      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
	    };
	
	    _this.removeEventListeners = function () {
	      if (_this.documentMouseCaptureListener) {
	        _this.documentMouseCaptureListener.remove();
	      }
	
	      if (_this.documentMouseListener) {
	        _this.documentMouseListener.remove();
	      }
	
	      if (_this.documentKeyupListener) {
	        _this.documentKeyupListener.remove();
	      }
	    };
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.disabled) {
	      this.addEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.props.disabled && prevProps.disabled) {
	      this.addEventListeners();
	    } else if (this.props.disabled && !prevProps.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.props.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _propTypes2.default.func,
	  /**
	   * Children to render.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 890 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (doc) {
	  return Math.max(doc.documentElement.offsetHeight || 0, doc.height || 0, doc.body.scrollHeight || 0, doc.body.offsetHeight || 0);
	};
	
	module.exports = exports["default"]; /**
	                                      * Get the height of the document
	                                      *
	                                      * @returns {documentHeight: number}
	                                      */

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerWindow2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerWindow = __webpack_require__(1378);
	
	var _ownerWindow2 = _interopRequireDefault(_ownerWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(2759),
	    CopyToClipboard = _require.CopyToClipboard;
	
	CopyToClipboard.CopyToClipboard = CopyToClipboard;
	module.exports = CopyToClipboard;

/***/ },
/* 893 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(158);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(195);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstrumentation = __webpack_require__(90);
	
	var quoteAttributeValueForBrowser = __webpack_require__(2825);
	var warning = __webpack_require__(34);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 896 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var LinkedValueUtils = __webpack_require__(445);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(99);
	
	var warning = __webpack_require__(34);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 898 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 899 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(21);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(2785);
	
	var containsNode = __webpack_require__(1456);
	var focusNode = __webpack_require__(601);
	var getActiveElement = __webpack_require__(602);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var DOMLazyTree = __webpack_require__(194);
	var DOMProperty = __webpack_require__(195);
	var React = __webpack_require__(201);
	var ReactBrowserEventEmitter = __webpack_require__(315);
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMContainerInfo = __webpack_require__(2779);
	var ReactDOMFeatureFlags = __webpack_require__(2781);
	var ReactFeatureFlags = __webpack_require__(899);
	var ReactInstanceMap = __webpack_require__(241);
	var ReactInstrumentation = __webpack_require__(90);
	var ReactMarkupChecksum = __webpack_require__(2795);
	var ReactReconciler = __webpack_require__(198);
	var ReactUpdateQueue = __webpack_require__(448);
	var ReactUpdates = __webpack_require__(99);
	
	var emptyObject = __webpack_require__(223);
	var instantiateReactComponent = __webpack_require__(909);
	var invariant = __webpack_require__(21);
	var setInnerHTML = __webpack_require__(319);
	var shouldUpdateReactComponent = __webpack_require__(455);
	var warning = __webpack_require__(34);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var React = __webpack_require__(201);
	
	var invariant = __webpack_require__(21);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 905 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(903);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(59);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(39);
	
	var ReactCompositeComponent = __webpack_require__(2776);
	var ReactEmptyComponent = __webpack_require__(898);
	var ReactHostComponent = __webpack_require__(900);
	
	var getNextDebugID = __webpack_require__(3053);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(34);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 910 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(59);
	var escapeTextContentForBrowser = __webpack_require__(318);
	var setInnerHTML = __webpack_require__(319);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactCurrentOwner = __webpack_require__(113);
	var REACT_ELEMENT_TYPE = __webpack_require__(2791);
	
	var getIteratorFn = __webpack_require__(2822);
	var invariant = __webpack_require__(21);
	var KeyEscapeUtils = __webpack_require__(444);
	var warning = __webpack_require__(34);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(622);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _defaults = __webpack_require__(2827);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _propTypes = __webpack_require__(2829);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _filterInputAttributes = __webpack_require__(914);
	
	var _filterInputAttributes2 = _interopRequireDefault(_filterInputAttributes);
	
	var _input = __webpack_require__(2828);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _suggestList = __webpack_require__(2831);
	
	var _suggestList2 = _interopRequireDefault(_suggestList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */
	
	// Escapes special characters in user input for regex
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	/**
	 * Entry point for the Geosuggest component
	 */
	
	var Geosuggest = function (_React$Component) {
	  _inherits(Geosuggest, _React$Component);
	
	  /**
	   * The constructor. Sets the initial state.
	   * @param  {Object} props The properties object.
	   */
	  function Geosuggest(props) {
	    _classCallCheck(this, Geosuggest);
	
	    var _this = _possibleConstructorReturn(this, (Geosuggest.__proto__ || Object.getPrototypeOf(Geosuggest)).call(this, props));
	
	    _this.onInputChange = function (userInput) {
	      if (!userInput) {
	        _this.props.onSuggestSelect();
	      }
	      _this.setState({ userInput: userInput }, _this.onAfterInputChange);
	    };
	
	    _this.onAfterInputChange = function () {
	      _this.showSuggests();
	      _this.props.onChange(_this.state.userInput);
	    };
	
	    _this.onInputFocus = function () {
	      _this.props.onFocus();
	      _this.showSuggests();
	    };
	
	    _this.onInputBlur = function () {
	      if (!_this.state.ignoreBlur) {
	        _this.hideSuggests();
	      }
	    };
	
	    _this.onNext = function () {
	      return _this.activateSuggest('next');
	    };
	
	    _this.onPrev = function () {
	      return _this.activateSuggest('prev');
	    };
	
	    _this.onSelect = function () {
	      return _this.selectSuggest(_this.state.activeSuggest);
	    };
	
	    _this.onSuggestMouseDown = function () {
	      return _this.setState({ ignoreBlur: true });
	    };
	
	    _this.onSuggestMouseOut = function () {
	      return _this.setState({ ignoreBlur: false });
	    };
	
	    _this.onSuggestNoResults = function () {
	      _this.props.onSuggestNoResults(_this.state.userInput);
	    };
	
	    _this.hideSuggests = function () {
	      _this.props.onBlur(_this.state.userInput);
	      _this.timer = setTimeout(function () {
	        _this.setState({
	          isSuggestsHidden: true,
	          activeSuggest: null
	        });
	      }, 100);
	    };
	
	    _this.selectSuggest = function (suggest) {
	      if (!suggest) {
	        suggest = {
	          label: _this.state.userInput
	        };
	      }
	
	      _this.setState({
	        isSuggestsHidden: true,
	        userInput: _typeof(suggest.label) !== 'object' ? suggest.label : suggest.description
	      });
	
	      if (suggest.location) {
	        _this.setState({ ignoreBlur: false });
	        _this.props.onSuggestSelect(suggest);
	        return;
	      }
	
	      _this.geocodeSuggest(suggest);
	    };
	
	    _this.state = {
	      isSuggestsHidden: true,
	      isLoading: false,
	      userInput: props.initialValue,
	      activeSuggest: null,
	      suggests: []
	    };
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onAfterInputChange = _this.onAfterInputChange.bind(_this);
	
	    if (props.queryDelay) {
	      _this.onAfterInputChange = (0, _lodash2.default)(_this.onAfterInputChange, props.queryDelay);
	    }
	    return _this;
	  }
	
	  /**
	   * Change inputValue if prop changes
	   * @param {Object} props The new props
	   */
	
	
	  _createClass(Geosuggest, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (this.props.initialValue !== props.initialValue) {
	        this.setState({ userInput: props.initialValue });
	      }
	    }
	
	    /**
	     * Called on the client side after component is mounted.
	     * Google api sdk object will be obtained and cached as a instance property.
	     * Necessary objects of google api will also be determined and saved.
	     */
	
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var googleMaps = this.props.googleMaps || window.google && // eslint-disable-line no-extra-parens
	      window.google.maps || this.googleMaps;
	
	      /* istanbul ignore next */
	      if (!googleMaps) {
	        if (console) {
	          console.error( // eslint-disable-line no-console
	          'Google map api was not found in the page.');
	        }
	        return;
	      }
	      this.googleMaps = googleMaps;
	
	      this.autocompleteService = new googleMaps.places.AutocompleteService();
	      this.geocoder = new googleMaps.Geocoder();
	    }
	
	    /**
	     * When the component will unmount
	     */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timer);
	    }
	
	    /**
	     * When the input changed
	     * @param {String} userInput The input value of the user
	     */
	
	
	    /**
	     * On After the input got changed
	     */
	
	
	    /**
	     * When the input gets focused
	     */
	
	
	    /**
	     * When the input gets blurred
	     */
	
	  }, {
	    key: 'focus',
	
	
	    /**
	     * Focus the input
	     */
	    value: function focus() {
	      this.input.focus();
	    }
	
	    /**
	     * Blur the input
	     */
	
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.input.blur();
	    }
	
	    /**
	     * Update the value of the user input
	     * @param {String} userInput the new value of the user input
	     */
	
	  }, {
	    key: 'update',
	    value: function update(userInput) {
	      this.setState({ userInput: userInput });
	      this.props.onChange(userInput);
	    }
	
	    /*
	     * Clear the input and close the suggestion pane
	     */
	
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.setState({ userInput: '' }, this.hideSuggests);
	    }
	
	    /**
	     * Search for new suggests
	     */
	
	  }, {
	    key: 'searchSuggests',
	    value: function searchSuggests() {
	      var _this2 = this;
	
	      if (!this.state.userInput) {
	        this.updateSuggests();
	        return;
	      }
	
	      var options = {
	        input: this.state.userInput
	      },
	          inputLength = this.state.userInput.length,
	          isShorterThanMinLength = inputLength < this.props.minLength;
	
	      if (isShorterThanMinLength) {
	        return;
	      }
	
	      ['location', 'radius', 'bounds', 'types'].forEach(function (option) {
	        if (_this2.props[option]) {
	          options[option] = _this2.props[option];
	        }
	      });
	
	      if (this.props.country) {
	        options.componentRestrictions = {
	          country: this.props.country
	        };
	      }
	
	      this.setState({ isLoading: true }, function () {
	        _this2.autocompleteService.getPlacePredictions(options, function (suggestsGoogle) {
	          _this2.setState({ isLoading: false });
	          _this2.updateSuggests(suggestsGoogle || [], // can be null
	          function () {
	            if (_this2.props.autoActivateFirstSuggest && !_this2.state.activeSuggest) {
	              _this2.activateSuggest('next');
	            }
	          });
	        });
	      });
	    }
	
	    /**
	     * Update the suggests
	     * @param {Array} suggestsGoogle The new google suggests
	     * @param {Function} callback Called once the state has been updated
	     */
	
	  }, {
	    key: 'updateSuggests',
	    value: function updateSuggests() {
	      var _this3 = this;
	
	      var suggestsGoogle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var callback = arguments[1];
	
	      var suggests = [],
	          userInput = this.state.userInput,
	          regex = new RegExp(escapeRegExp(userInput), 'gim'),
	          skipSuggest = this.props.skipSuggest,
	          maxFixtures = this.props.maxFixtures,
	          fixturesSearched = 0,
	          activeSuggest = null;
	
	      this.props.fixtures.forEach(function (suggest) {
	        if (fixturesSearched >= maxFixtures) {
	          return;
	        }
	
	        if (!skipSuggest(suggest) && suggest.label.match(regex)) {
	          fixturesSearched++;
	
	          suggest.placeId = suggest.label;
	          suggest.isFixture = true;
	          suggest.matchedSubstrings = {
	            offset: suggest.label.indexOf(userInput),
	            length: userInput.length
	          };
	          suggests.push(suggest);
	        }
	      });
	
	      suggestsGoogle.forEach(function (suggest) {
	        if (!skipSuggest(suggest)) {
	          suggests.push({
	            description: suggest.description,
	            label: _this3.props.getSuggestLabel(suggest),
	            placeId: suggest.place_id,
	            isFixture: false,
	            matchedSubstrings: suggest.matched_substrings[0]
	          });
	        }
	      });
	
	      activeSuggest = this.updateActiveSuggest(suggests);
	
	      this.props.onUpdateSuggests(suggests, activeSuggest);
	      this.setState({ suggests: suggests, activeSuggest: activeSuggest }, callback);
	    }
	
	    /**
	     * Return the new activeSuggest object after suggests have been updated
	     * @param {Array} suggests The new list of suggests
	     * @return {Object} The new activeSuggest
	     **/
	
	  }, {
	    key: 'updateActiveSuggest',
	    value: function updateActiveSuggest() {
	      var suggests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var activeSuggest = this.state.activeSuggest;
	
	      if (activeSuggest) {
	        var newSuggest = suggests.filter(function (listedSuggest) {
	          return activeSuggest.placeId === listedSuggest.placeId && activeSuggest.isFixture === listedSuggest.isFixture;
	        })[0];
	
	        activeSuggest = newSuggest || null;
	      }
	
	      return activeSuggest;
	    }
	
	    /**
	     * Show the suggestions
	     */
	
	  }, {
	    key: 'showSuggests',
	    value: function showSuggests() {
	      this.searchSuggests();
	      this.setState({ isSuggestsHidden: false });
	    }
	
	    /**
	     * Hide the suggestions
	     */
	
	  }, {
	    key: 'activateSuggest',
	
	
	    /**
	     * Activate a new suggest
	     * @param {String} direction The direction in which to activate new suggest
	     */
	    value: function activateSuggest(direction) {
	      // eslint-disable-line complexity
	      if (this.state.isSuggestsHidden) {
	        this.showSuggests();
	        return;
	      }
	
	      var suggestsCount = this.state.suggests.length - 1,
	          next = direction === 'next';
	      var newActiveSuggest = null,
	          newIndex = 0,
	          i = 0;
	
	      for (i; i <= suggestsCount; i++) {
	        if (this.state.suggests[i] === this.state.activeSuggest) {
	          newIndex = next ? i + 1 : i - 1;
	        }
	      }
	
	      if (!this.state.activeSuggest) {
	        newIndex = next ? 0 : suggestsCount;
	      }
	
	      if (newIndex >= 0 && newIndex <= suggestsCount) {
	        newActiveSuggest = this.state.suggests[newIndex];
	      }
	
	      this.props.onActivateSuggest(newActiveSuggest);
	
	      this.setState({ activeSuggest: newActiveSuggest });
	    }
	
	    /**
	     * When an item got selected
	     * @param {GeosuggestItem} suggest The selected suggest item
	     */
	
	  }, {
	    key: 'geocodeSuggest',
	
	
	    /**
	     * Geocode a suggest
	     * @param  {Object} suggest The suggest
	     */
	    value: function geocodeSuggest(suggest) {
	      var _this4 = this;
	
	      var options = null;
	      if (suggest.placeId && !suggest.isFixture) {
	        options = {
	          placeId: suggest.placeId
	        };
	      } else {
	        options = {
	          address: suggest.label,
	          location: this.props.location,
	          bounds: this.props.bounds,
	          componentRestrictions: this.props.country ? { country: this.props.country } : null
	        };
	      }
	      this.geocoder.geocode(options, function (results, status) {
	        if (status === _this4.googleMaps.GeocoderStatus.OK) {
	          var gmaps = results[0],
	              location = gmaps.geometry.location;
	
	          suggest.gmaps = gmaps;
	          suggest.location = {
	            lat: location.lat(),
	            lng: location.lng()
	          };
	        }
	        _this4.props.onSuggestSelect(suggest);
	      });
	    }
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var attributes = (0, _filterInputAttributes2.default)(this.props),
	          classes = (0, _classnames2.default)('geosuggest', this.props.className, { 'geosuggest--loading': this.state.isLoading }),
	          shouldRenderLabel = this.props.label && attributes.id,
	          input = _react2.default.createElement(_input2.default, _extends({ className: this.props.inputClassName,
	        ref: function ref(i) {
	          return _this5.input = i;
	        },
	        value: this.state.userInput,
	        doNotSubmitOnEnter: !this.state.isSuggestsHidden,
	        ignoreTab: this.props.ignoreTab,
	        ignoreEnter: this.props.ignoreEnter,
	        style: this.props.style.input,
	        onChange: this.onInputChange,
	        onFocus: this.onInputFocus,
	        onBlur: this.onInputBlur,
	        onKeyDown: this.props.onKeyDown,
	        onKeyPress: this.props.onKeyPress,
	        onNext: this.onNext,
	        onPrev: this.onPrev,
	        onSelect: this.onSelect,
	        onEscape: this.hideSuggests }, attributes)),
	          suggestionsList = _react2.default.createElement(_suggestList2.default, { isHidden: this.state.isSuggestsHidden,
	        style: this.props.style.suggests,
	        suggestItemStyle: this.props.style.suggestItem,
	        userInput: this.state.userInput,
	        isHighlightMatch: this.props.highlightMatch,
	        suggestsClassName: this.props.suggestsClassName,
	        suggestItemClassName: this.props.suggestItemClassName,
	        suggests: this.state.suggests,
	        hiddenClassName: this.props.suggestsHiddenClassName,
	        suggestItemActiveClassName: this.props.suggestItemActiveClassName,
	        activeSuggest: this.state.activeSuggest,
	        onSuggestNoResults: this.onSuggestNoResults,
	        onSuggestMouseDown: this.onSuggestMouseDown,
	        onSuggestMouseOut: this.onSuggestMouseOut,
	        onSuggestSelect: this.selectSuggest,
	        renderSuggestItem: this.props.renderSuggestItem,
	        minLength: this.props.minLength });
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'geosuggest__input-wrapper' },
	          shouldRenderLabel && _react2.default.createElement(
	            'label',
	            { className: 'geosuggest__label',
	              htmlFor: attributes.id },
	            this.props.label
	          ),
	          input
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'geosuggest__suggests-wrapper' },
	          suggestionsList
	        )
	      );
	    }
	  }]);
	
	  return Geosuggest;
	}(_react2.default.Component);
	
	/**
	 * Types for the properties
	 * @type {Object}
	 */
	
	
	Geosuggest.propTypes = _propTypes2.default;
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	Geosuggest.defaultProps = _defaults2.default;
	
	exports.default = Geosuggest;

/***/ },
/* 914 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (props) {
	  var attributes = {};
	
	  allowedAttributes.forEach(function (allowedAttribute) {
	    if (props[allowedAttribute]) {
	      attributes[allowedAttribute] = props[allowedAttribute];
	    }
	  });
	
	  return attributes;
	};
	
	/**
	 * Attributes allowed on input elements
	 */
	var allowedAttributes = ['autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'disabled', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'height', 'id', 'inputMode', 'maxLength', 'name', 'onClick', 'onContextMenu', 'onCopy', 'onCut', 'onDoubleClick', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onPaste', 'pattern', 'placeholder', 'readOnly', 'required', 'size', 'spellCheck', 'tabIndex', 'title', 'aria-atomic', 'aria-busy', 'aria-controls', 'aria-current', 'aria-describedby', 'aria-details', 'aria-disabled', 'aria-dropeffect', 'aria-errormessage', 'aria-flowto', 'aria-grabbed', 'aria-haspopup', 'aria-hidden', 'aria-invalid', 'aria-keyshortcuts', 'aria-label', 'aria-labelledby', 'aria-live', 'aria-owns', 'aria-relevant', 'aria-roledescription', 'aria-activedescendant', 'aria-autocomplete', 'aria-multiline', 'aria-placeholder', 'aria-readonly', 'aria-required'];
	
	/**
	 * Filter the properties for only allowed input properties
	 * @param  {Object} props The properties to filter
	 * @return {Object} The filtered, allowed properties
	 */

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DrawingManager
	  drawingMode: _propTypes2.default.any,
	  options: _propTypes2.default.object
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DrawingManager
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onCircleComplete: "circlecomplete",
	
	  onMarkerComplete: "markercomplete",
	
	  onOverlayComplete: "overlaycomplete",
	
	  onPolygonComplete: "polygoncomplete",
	
	  onPolylineComplete: "polylinecomplete",
	
	  onRectangleComplete: "rectanglecomplete"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DrawingManager
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getDrawingMode: function getDrawingMode(drawingManager) {
	    return drawingManager.getDrawingMode();
	  }
	};
	
	var controlledPropUpdaterMap = {
	  drawingMode: function drawingMode(drawingManager, _drawingMode) {
	    drawingManager.setDrawingMode(_drawingMode);
	  },
	  options: function options(drawingManager, _options) {
	    drawingManager.setOptions(_options);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.DRAWING_MANAGER];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "DrawingManager",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DrawingManager
	    var drawingManager = new google.maps.drawing.DrawingManager((0, _extends3.default)({
	      map: this.context[_constants.MAP]
	    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	    return (0, _defineProperty3.default)({}, _constants.DRAWING_MANAGER, drawingManager);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var drawingManager = getInstanceFromComponent(this);
	    if (drawingManager) {
	      drawingManager.setMap(null);
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 916 */
538,
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(2853);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(2852);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 918 */
[3179, 321, 2945, 2946, 2947, 2948, 2949],
/* 919 */
[3182, 159, 82],
/* 920 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 921 */
[3183, 463, 330],
/* 922 */
[3185, 923, 2900],
/* 923 */
[3188, 2875, 333],
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(927),
	    isKey = __webpack_require__(326),
	    toKey = __webpack_require__(329);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(2880),
	    isObject = __webpack_require__(128),
	    isObjectLike = __webpack_require__(246);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(244),
	    metaMap = __webpack_require__(942);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(91),
	    stringToPath = __webpack_require__(2951);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = castPath;


/***/ },
/* 928 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 929 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 930 */
408,
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(928),
	    composeArgsRight = __webpack_require__(929),
	    countHolders = __webpack_require__(2898),
	    createCtor = __webpack_require__(323),
	    createRecurry = __webpack_require__(932),
	    getHolder = __webpack_require__(469),
	    reorder = __webpack_require__(2941),
	    replaceHolders = __webpack_require__(328),
	    root = __webpack_require__(82);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    ARY_FLAG = 128,
	    FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(938),
	    setData = __webpack_require__(944),
	    setWrapToString = __webpack_require__(945);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(926),
	    createBind = __webpack_require__(2902),
	    createCurry = __webpack_require__(2903),
	    createHybrid = __webpack_require__(931),
	    createPartial = __webpack_require__(2905),
	    getData = __webpack_require__(468),
	    mergeData = __webpack_require__(2935),
	    setData = __webpack_require__(944),
	    setWrapToString = __webpack_require__(945),
	    toInteger = __webpack_require__(2971);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(2865),
	    arraySome = __webpack_require__(2871),
	    cacheHas = __webpack_require__(2895);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 935 */
650,
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(2940);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(927),
	    isArguments = __webpack_require__(471),
	    isArray = __webpack_require__(91),
	    isIndex = __webpack_require__(325),
	    isKey = __webpack_require__(326),
	    isLength = __webpack_require__(472),
	    toKey = __webpack_require__(329);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(457),
	    getData = __webpack_require__(468),
	    getFuncName = __webpack_require__(936),
	    lodash = __webpack_require__(2973);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 939 */
230,
/* 940 */
[3211, 128],
/* 941 */
657,
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(919);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 943 */
[3224, 462],
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(926),
	    shortOut = __webpack_require__(946);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(2912),
	    insertWrapDetails = __webpack_require__(2918),
	    setToString = __webpack_require__(470),
	    updateWrapDetails = __webpack_require__(2952);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ },
/* 946 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 500,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 947 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 948 */
298,
/* 949 */
[3241, 128, 332],
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _Highlighter = __webpack_require__(2);
		
		var _Highlighter2 = _interopRequireDefault(_Highlighter);
	
		exports['default'] = _Highlighter2['default'];
		module.exports = exports['default'];
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		exports['default'] = Highlighter;
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		var _highlightWordsCore = __webpack_require__(3);
		
		var _propTypes = __webpack_require__(4);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _react = __webpack_require__(14);
		
		var _memoizeOne = __webpack_require__(15);
		
		var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
		
		Highlighter.propTypes = {
		  activeClassName: _propTypes2['default'].string,
		  activeIndex: _propTypes2['default'].number,
		  activeStyle: _propTypes2['default'].object,
		  autoEscape: _propTypes2['default'].bool,
		  className: _propTypes2['default'].string,
		  findChunks: _propTypes2['default'].func,
		  highlightClassName: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
		  highlightStyle: _propTypes2['default'].object,
		  highlightTag: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func, _propTypes2['default'].string]),
		  sanitize: _propTypes2['default'].func,
		  searchWords: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].instanceOf(RegExp)])).isRequired,
		  textToHighlight: _propTypes2['default'].string.isRequired,
		  unhighlightClassName: _propTypes2['default'].string,
		  unhighlightStyle: _propTypes2['default'].object
		};
		
		/**
		 * Highlights all occurrences of search terms (searchText) within a string (textToHighlight).
		 * This function returns an array of strings and <span>s (wrapping highlighted words).
		 */
		
		function Highlighter(_ref) {
		  var _ref$activeClassName = _ref.activeClassName;
		  var activeClassName = _ref$activeClassName === undefined ? '' : _ref$activeClassName;
		  var _ref$activeIndex = _ref.activeIndex;
		  var activeIndex = _ref$activeIndex === undefined ? -1 : _ref$activeIndex;
		  var activeStyle = _ref.activeStyle;
		  var autoEscape = _ref.autoEscape;
		  var _ref$caseSensitive = _ref.caseSensitive;
		  var caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive;
		  var className = _ref.className;
		  var findChunks = _ref.findChunks;
		  var _ref$highlightClassName = _ref.highlightClassName;
		  var highlightClassName = _ref$highlightClassName === undefined ? '' : _ref$highlightClassName;
		  var _ref$highlightStyle = _ref.highlightStyle;
		  var highlightStyle = _ref$highlightStyle === undefined ? {} : _ref$highlightStyle;
		  var _ref$highlightTag = _ref.highlightTag;
		  var highlightTag = _ref$highlightTag === undefined ? 'mark' : _ref$highlightTag;
		  var sanitize = _ref.sanitize;
		  var searchWords = _ref.searchWords;
		  var textToHighlight = _ref.textToHighlight;
		  var _ref$unhighlightClassName = _ref.unhighlightClassName;
		  var unhighlightClassName = _ref$unhighlightClassName === undefined ? '' : _ref$unhighlightClassName;
		  var unhighlightStyle = _ref.unhighlightStyle;
		
		  var rest = _objectWithoutProperties(_ref, ['activeClassName', 'activeIndex', 'activeStyle', 'autoEscape', 'caseSensitive', 'className', 'findChunks', 'highlightClassName', 'highlightStyle', 'highlightTag', 'sanitize', 'searchWords', 'textToHighlight', 'unhighlightClassName', 'unhighlightStyle']);
		
		  var chunks = (0, _highlightWordsCore.findAll)({
		    autoEscape: autoEscape,
		    caseSensitive: caseSensitive,
		    findChunks: findChunks,
		    sanitize: sanitize,
		    searchWords: searchWords,
		    textToHighlight: textToHighlight
		  });
		  var HighlightTag = highlightTag;
		  var highlightIndex = -1;
		  var highlightClassNames = '';
		  var highlightStyles = undefined;
		
		  var lowercaseProps = function lowercaseProps(object) {
		    var mapped = {};
		    for (var key in object) {
		      mapped[key.toLowerCase()] = object[key];
		    }
		    return mapped;
		  };
		  var memoizedLowercaseProps = (0, _memoizeOne2['default'])(lowercaseProps);
		
		  return (0, _react.createElement)('span', _extends({
		    className: className
		  }, rest, {
		    children: chunks.map(function (chunk, index) {
		      var text = textToHighlight.substr(chunk.start, chunk.end - chunk.start);
		
		      if (chunk.highlight) {
		        highlightIndex++;
		
		        var highlightClass = undefined;
		        if (typeof highlightClassName === 'object') {
		          if (!caseSensitive) {
		            highlightClassName = memoizedLowercaseProps(highlightClassName);
		            highlightClass = highlightClassName[text.toLowerCase()];
		          } else {
		            highlightClass = highlightClassName[text];
		          }
		        } else {
		          highlightClass = highlightClassName;
		        }
		
		        var isActive = highlightIndex === +activeIndex;
		
		        highlightClassNames = highlightClass + ' ' + (isActive ? activeClassName : '');
		        highlightStyles = isActive === true && activeStyle != null ? Object.assign({}, highlightStyle, activeStyle) : highlightStyle;
		
		        var props = {
		          children: text,
		          className: highlightClassNames,
		          key: index,
		          style: highlightStyles
		        };
		
		        // Don't attach arbitrary props to DOM elements; this triggers React DEV warnings (https://fb.me/react-unknown-prop)
		        // Only pass through the highlightIndex attribute for custom components.
		        if (typeof HighlightTag !== 'string') {
		          props.highlightIndex = highlightIndex;
		        }
		
		        return (0, _react.createElement)(HighlightTag, props);
		      } else {
		        return (0, _react.createElement)('span', {
		          children: text,
		          className: unhighlightClassName,
		          key: index,
		          style: unhighlightStyle
		        });
		      }
		    })
		  }));
		}
		
		module.exports = exports['default'];
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports =
		/******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		/******/
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
		/******/
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
		/******/
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
		/******/
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
		/******/
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
		/******/
		/******/
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		/******/
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		/******/
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		/******/
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ (function(module, exports, __webpack_require__) {
		
			module.exports = __webpack_require__(1);
		
		
		/***/ }),
		/* 1 */
		/***/ (function(module, exports, __webpack_require__) {
		
			'use strict';
			
			Object.defineProperty(exports, "__esModule", {
			  value: true
			});
			
			var _utils = __webpack_require__(2);
			
			Object.defineProperty(exports, 'combineChunks', {
			  enumerable: true,
			  get: function get() {
			    return _utils.combineChunks;
			  }
			});
			Object.defineProperty(exports, 'fillInChunks', {
			  enumerable: true,
			  get: function get() {
			    return _utils.fillInChunks;
			  }
			});
			Object.defineProperty(exports, 'findAll', {
			  enumerable: true,
			  get: function get() {
			    return _utils.findAll;
			  }
			});
			Object.defineProperty(exports, 'findChunks', {
			  enumerable: true,
			  get: function get() {
			    return _utils.findChunks;
			  }
			});
		
		/***/ }),
		/* 2 */
		/***/ (function(module, exports) {
		
			'use strict';
			
			Object.defineProperty(exports, "__esModule", {
			  value: true
			});
			/**
			 * Creates an array of chunk objects representing both higlightable and non highlightable pieces of text that match each search word.
			 * @return Array of "chunks" (where a Chunk is { start:number, end:number, highlight:boolean })
			 */
			var findAll = exports.findAll = function findAll(_ref) {
			  var autoEscape = _ref.autoEscape,
			      _ref$caseSensitive = _ref.caseSensitive,
			      caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive,
			      _ref$findChunks = _ref.findChunks,
			      findChunks = _ref$findChunks === undefined ? defaultFindChunks : _ref$findChunks,
			      sanitize = _ref.sanitize,
			      searchWords = _ref.searchWords,
			      textToHighlight = _ref.textToHighlight;
			  return fillInChunks({
			    chunksToHighlight: combineChunks({
			      chunks: findChunks({
			        autoEscape: autoEscape,
			        caseSensitive: caseSensitive,
			        sanitize: sanitize,
			        searchWords: searchWords,
			        textToHighlight: textToHighlight
			      })
			    }),
			    totalLength: textToHighlight ? textToHighlight.length : 0
			  });
			};
			
			/**
			 * Takes an array of {start:number, end:number} objects and combines chunks that overlap into single chunks.
			 * @return {start:number, end:number}[]
			 */
			var combineChunks = exports.combineChunks = function combineChunks(_ref2) {
			  var chunks = _ref2.chunks;
			
			  chunks = chunks.sort(function (first, second) {
			    return first.start - second.start;
			  }).reduce(function (processedChunks, nextChunk) {
			    // First chunk just goes straight in the array...
			    if (processedChunks.length === 0) {
			      return [nextChunk];
			    } else {
			      // ... subsequent chunks get checked to see if they overlap...
			      var prevChunk = processedChunks.pop();
			      if (nextChunk.start <= prevChunk.end) {
			        // It may be the case that prevChunk completely surrounds nextChunk, so take the
			        // largest of the end indeces.
			        var endIndex = Math.max(prevChunk.end, nextChunk.end);
			        processedChunks.push({ start: prevChunk.start, end: endIndex });
			      } else {
			        processedChunks.push(prevChunk, nextChunk);
			      }
			      return processedChunks;
			    }
			  }, []);
			
			  return chunks;
			};
			
			/**
			 * Examine text for any matches.
			 * If we find matches, add them to the returned array as a "chunk" object ({start:number, end:number}).
			 * @return {start:number, end:number}[]
			 */
			var defaultFindChunks = function defaultFindChunks(_ref3) {
			  var autoEscape = _ref3.autoEscape,
			      caseSensitive = _ref3.caseSensitive,
			      _ref3$sanitize = _ref3.sanitize,
			      sanitize = _ref3$sanitize === undefined ? identity : _ref3$sanitize,
			      searchWords = _ref3.searchWords,
			      textToHighlight = _ref3.textToHighlight;
			
			  textToHighlight = sanitize(textToHighlight);
			
			  return searchWords.filter(function (searchWord) {
			    return searchWord;
			  }) // Remove empty words
			  .reduce(function (chunks, searchWord) {
			    searchWord = sanitize(searchWord);
			
			    if (autoEscape) {
			      searchWord = escapeRegExpFn(searchWord);
			    }
			
			    var regex = new RegExp(searchWord, caseSensitive ? 'g' : 'gi');
			
			    var match = void 0;
			    while (match = regex.exec(textToHighlight)) {
			      var start = match.index;
			      var end = regex.lastIndex;
			      // We do not return zero-length matches
			      if (end > start) {
			        chunks.push({ start: start, end: end });
			      }
			
			      // Prevent browsers like Firefox from getting stuck in an infinite loop
			      // See http://www.regexguru.com/2008/04/watch-out-for-zero-length-matches/
			      if (match.index == regex.lastIndex) {
			        regex.lastIndex++;
			      }
			    }
			
			    return chunks;
			  }, []);
			};
			// Allow the findChunks to be overridden in findAll,
			// but for backwards compatibility we export as the old name
			exports.findChunks = defaultFindChunks;
			
			/**
			 * Given a set of chunks to highlight, create an additional set of chunks
			 * to represent the bits of text between the highlighted text.
			 * @param chunksToHighlight {start:number, end:number}[]
			 * @param totalLength number
			 * @return {start:number, end:number, highlight:boolean}[]
			 */
			
			var fillInChunks = exports.fillInChunks = function fillInChunks(_ref4) {
			  var chunksToHighlight = _ref4.chunksToHighlight,
			      totalLength = _ref4.totalLength;
			
			  var allChunks = [];
			  var append = function append(start, end, highlight) {
			    if (end - start > 0) {
			      allChunks.push({
			        start: start,
			        end: end,
			        highlight: highlight
			      });
			    }
			  };
			
			  if (chunksToHighlight.length === 0) {
			    append(0, totalLength, false);
			  } else {
			    var lastIndex = 0;
			    chunksToHighlight.forEach(function (chunk) {
			      append(lastIndex, chunk.start, false);
			      append(chunk.start, chunk.end, true);
			      lastIndex = chunk.end;
			    });
			    append(lastIndex, totalLength, false);
			  }
			  return allChunks;
			};
			
			function identity(value) {
			  return value;
			}
			
			function escapeRegExpFn(str) {
			  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
			}
		
		/***/ })
		/******/ ]);
		//# sourceMappingURL=index.js.map
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		if (process.env.NODE_ENV !== 'production') {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
		
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
		
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(6)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(13)();
		}
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
		
		process.listeners = function (name) { return [] }
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(7);
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(9);
		var assign = __webpack_require__(10);
		
		var ReactPropTypesSecret = __webpack_require__(11);
		var checkPropTypes = __webpack_require__(12);
		
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
		
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
		
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
		
		  var ANONYMOUS = '<<anonymous>>';
		
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
		
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker,
		    exact: createStrictShapeTypeChecker,
		  };
		
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
		
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
		
		  function createChainableTypeChecker(validate) {
		    if (process.env.NODE_ENV !== 'production') {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
		
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
		
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
		
		    return chainedCheckType;
		  }
		
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
		
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
		
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
		
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning(
		          false,
		          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction.thatReturnsNull;
		      }
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
		
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createStrictShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      // We need to check all keys in case some are required but missing from
		      // props.
		      var allKeys = assign({}, props[propName], shapeTypes);
		      for (var key in allKeys) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          return new PropTypeError(
		            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
		            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
		            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
		          );
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		
		    return createChainableTypeChecker(validate);
		  }
		
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
		
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
		
		        return true;
		      default:
		        return false;
		    }
		  }
		
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
		
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
		
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
		
		    return false;
		  }
		
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
		
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
		
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
		
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
		
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		"use strict";
		
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 * 
		 */
		
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
		
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
		
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
		
		module.exports = emptyFunction;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
		
		'use strict';
		
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
		
		var validateFormat = function validateFormat(format) {};
		
		if (process.env.NODE_ENV !== 'production') {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
		
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
		
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
		
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
		
		module.exports = invariant;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2014-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(7);
		
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
		
		var warning = emptyFunction;
		
		if (process.env.NODE_ENV !== 'production') {
		  var printWarning = function printWarning(format) {
		    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		      args[_key - 1] = arguments[_key];
		    }
		
		    var argIndex = 0;
		    var message = 'Warning: ' + format.replace(/%s/g, function () {
		      return args[argIndex++];
		    });
		    if (typeof console !== 'undefined') {
		      console.error(message);
		    }
		    try {
		      // --- Welcome to debugging React ---
		      // This error was thrown as a convenience so that you can use this stack
		      // to find the callsite that caused this warning to fire.
		      throw new Error(message);
		    } catch (x) {}
		  };
		
		  warning = function warning(condition, format) {
		    if (format === undefined) {
		      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		    }
		
		    if (format.indexOf('Failed Composite propType: ') === 0) {
		      return; // Ignore CompositeComponent proptype check.
		    }
		
		    if (!condition) {
		      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		        args[_key2 - 2] = arguments[_key2];
		      }
		
		      printWarning.apply(undefined, [format].concat(args));
		    }
		  };
		}
		
		module.exports = warning;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
		
		'use strict';
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
		
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
		
			return Object(val);
		}
		
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
		
				// Detect buggy property enumeration order in older V8 versions.
		
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
		
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
		
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
		
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
		
		module.exports = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
		
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
		
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
		
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
		
			return to;
		};
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		'use strict';
		
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
		
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		'use strict';
		
		if (process.env.NODE_ENV !== 'production') {
		  var invariant = __webpack_require__(8);
		  var warning = __webpack_require__(9);
		  var ReactPropTypesSecret = __webpack_require__(11);
		  var loggedTypeFailures = {};
		}
		
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (process.env.NODE_ENV !== 'production') {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
		
		          var stack = getStack ? getStack() : '';
		
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
		
		module.exports = checkPropTypes;
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(7);
		var invariant = __webpack_require__(8);
		var ReactPropTypesSecret = __webpack_require__(11);
		
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
		
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim,
		    exact: getShim
		  };
		
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		var simpleIsEqual = function simpleIsEqual(a, b) {
		  return a === b;
		};
		
		function index (resultFn) {
		  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;
		
		  var lastThis = void 0;
		  var lastArgs = [];
		  var lastResult = void 0;
		  var calledOnce = false;
		
		  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
		    return isEqual(newArg, lastArgs[index]);
		  };
		
		  var result = function result() {
		    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
		      newArgs[_key] = arguments[_key];
		    }
		
		    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
		      return lastResult;
		    }
		
		    calledOnce = true;
		    lastThis = this;
		    lastArgs = newArgs;
		    lastResult = resultFn.apply(this, newArgs);
		    return lastResult;
		  };
		
		  return result;
		}
		
		module.exports = index;
	
	
	/***/ })
	/******/ ]);
	//# sourceMappingURL=main.js.map

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A higher-order-component for handling onClickOutside for React components.
	 */
	(function(root) {
	
	  // administrative
	  var registeredComponents = [];
	  var handlers = [];
	  var IGNORE_CLASS = 'ignore-react-onclickoutside';
	  var DEFAULT_EVENTS = ['mousedown', 'touchstart'];
	
	  /**
	   * Check whether some DOM node is our Component's node.
	   */
	  var isNodeFound = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	    // SVG <use/> elements do not technically reside in the rendered DOM, so
	    // they do not have classList directly, but they offer a link to their
	    // corresponding element, which can have classList. This extra check is for
	    // that case.
	    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	    if (current.correspondingElement) {
	      return current.correspondingElement.classList.contains(ignoreClass);
	    }
	    return current.classList.contains(ignoreClass);
	  };
	
	  /**
	   * Try to find our node in a hierarchy of nodes, returning the document
	   * node as highest noode if our node is not found in the path up.
	   */
	  var findHighest = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	
	    // If source=local then this event came from 'somewhere'
	    // inside and should be ignored. We could handle this with
	    // a layered approach, too, but that requires going back to
	    // thinking in terms of Dom node nesting, running counter
	    // to React's 'you shouldn't care about the DOM' philosophy.
	    while(current.parentNode) {
	      if (isNodeFound(current, componentNode, ignoreClass)) {
	        return true;
	      }
	      current = current.parentNode;
	    }
	    return current;
	  };
	
	  /**
	   * Check if the browser scrollbar was clicked
	   */
	  var clickedScrollbar = function(evt) {
	    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	  };
	
	  /**
	   * Generate the event handler that checks whether a clicked DOM node
	   * is inside of, or lives outside of, our Component's node tree.
	   */
	  var generateOutsideCheck = function(componentNode, componentInstance, eventHandler, ignoreClass, excludeScrollbar, preventDefault, stopPropagation) {
	    return function(evt) {
	      if (preventDefault) {
	        evt.preventDefault();
	      }
	      if (stopPropagation) {
	        evt.stopPropagation();
	      }
	      var current = evt.target;
	      if((excludeScrollbar && clickedScrollbar(evt)) || (findHighest(current, componentNode, ignoreClass) !== document)) {
	        return;
	      }
	      eventHandler(evt);
	    };
	  };
	
	  /**
	   * This function generates the HOC function that you'll use
	   * in order to impart onOutsideClick listening to an
	   * arbitrary component. It gets called at the end of the
	   * bootstrapping code to yield an instance of the
	   * onClickOutsideHOC function defined inside setupHOC().
	   */
	  function setupHOC(root, React, ReactDOM, createReactClass) {
	
	    // The actual Component-wrapping HOC:
	    return function onClickOutsideHOC(Component, config) {
	      var wrapComponentWithOnClickOutsideHandling = createReactClass({
	        statics: {
	          /**
	           * Access the wrapped Component's class.
	           */
	          getClass: function() {
	            if (Component.getClass) {
	              return Component.getClass();
	            }
	            return Component;
	          }
	        },
	
	        /**
	         * Access the wrapped Component's instance.
	         */
	        getInstance: function() {
	          return Component.prototype.isReactComponent ? this.refs.instance : this;
	        },
	
	        // this is given meaning in componentDidMount
	        __outsideClickHandler: function() {},
	
	        getDefaultProps: function() {
	          return {
	            excludeScrollbar: config && config.excludeScrollbar
	          };
	        },
	
	        /**
	         * Add click listeners to the current document,
	         * linked to this component's state.
	         */
	        componentDidMount: function() {
	          // If we are in an environment without a DOM such
	          // as shallow rendering or snapshots then we exit
	          // early to prevent any unhandled errors being thrown.
	          if (typeof document === 'undefined' || !document.createElement){
	            return;
	          }
	
	          var instance = this.getInstance();
	          var clickOutsideHandler;
	
	          if(config && typeof config.handleClickOutside === 'function') {
	            clickOutsideHandler = config.handleClickOutside(instance);
	            if(typeof clickOutsideHandler !== 'function') {
	              throw new Error('Component lacks a function for processing outside click events specified by the handleClickOutside config option.');
	            }
	          } else if(typeof instance.handleClickOutside === 'function') {
	            if (React.Component.prototype.isPrototypeOf(instance)) {
	              clickOutsideHandler = instance.handleClickOutside.bind(instance);
	            } else {
	              clickOutsideHandler = instance.handleClickOutside;
	            }
	          } else if(typeof instance.props.handleClickOutside === 'function') {
	            clickOutsideHandler = instance.props.handleClickOutside;
	          } else {
	            throw new Error('Component lacks a handleClickOutside(event) function for processing outside click events.');
	          }
	
	          var componentNode = ReactDOM.findDOMNode(instance);
	          if (componentNode === null) {
	            console.warn('Antipattern warning: there was no DOM node associated with the component that is being wrapped by outsideClick.');
	            console.warn([
	              'This is typically caused by having a component that starts life with a render function that',
	              'returns `null` (due to a state or props value), so that the component \'exist\' in the React',
	              'chain of components, but not in the DOM.\n\nInstead, you need to refactor your code so that the',
	              'decision of whether or not to show your component is handled by the parent, in their render()',
	              'function.\n\nIn code, rather than:\n\n  A{render(){return check? <.../> : null;}\n  B{render(){<A check=... />}\n\nmake sure that you',
	              'use:\n\n  A{render(){return <.../>}\n  B{render(){return <...>{ check ? <A/> : null }<...>}}\n\nThat is:',
	              'the parent is always responsible for deciding whether or not to render any of its children.',
	              'It is not the child\'s responsibility to decide whether a render instruction from above should',
	              'get ignored or not by returning `null`.\n\nWhen any component gets its render() function called,',
	              'that is the signal that it should be rendering its part of the UI. It may in turn decide not to',
	              'render all of *its* children, but it should never return `null` for itself. It is not responsible',
	              'for that decision.'
	            ].join(' '));
	          }
	
	          var fn = this.__outsideClickHandler = generateOutsideCheck(
	            componentNode,
	            instance,
	            clickOutsideHandler,
	            this.props.outsideClickIgnoreClass || IGNORE_CLASS,
	            this.props.excludeScrollbar, // fallback not needed, prop always exists because of getDefaultProps
	            this.props.preventDefault || false,
	            this.props.stopPropagation || false
	          );
	
	          var pos = registeredComponents.length;
	          registeredComponents.push(this);
	          handlers[pos] = fn;
	
	          // If there is a truthy disableOnClickOutside property for this
	          // component, don't immediately start listening for outside events.
	          if (!this.props.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          }
	        },
	
	        /**
	        * Track for disableOnClickOutside props changes and enable/disable click outside
	        */
	        componentWillReceiveProps: function(nextProps) {
	          if (this.props.disableOnClickOutside && !nextProps.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          } else if (!this.props.disableOnClickOutside && nextProps.disableOnClickOutside) {
	            this.disableOnClickOutside();
	          }
	        },
	
	        /**
	         * Remove the document's event listeners
	         */
	        componentWillUnmount: function() {
	          this.disableOnClickOutside();
	          this.__outsideClickHandler = false;
	          var pos = registeredComponents.indexOf(this);
	          if( pos>-1) {
	            // clean up so we don't leak memory
	            if (handlers[pos]) { handlers.splice(pos, 1); }
	            registeredComponents.splice(pos, 1);
	          }
	        },
	
	        /**
	         * Can be called to explicitly enable event listening
	         * for clicks and touches outside of this element.
	         */
	        enableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.addEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Can be called to explicitly disable event listening
	         * for clicks and touches outside of this element.
	         */
	        disableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.removeEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Pass-through render
	         */
	        render: function() {
	          var passedProps = this.props;
	          var props = {};
	          Object.keys(this.props).forEach(function(key) {
	            if (key !== 'excludeScrollbar') {
	              props[key] = passedProps[key];
	            }
	          });
	          if (Component.prototype.isReactComponent) {
	            props.ref = 'instance';
	          }
	          props.disableOnClickOutside = this.disableOnClickOutside;
	          props.enableOnClickOutside = this.enableOnClickOutside;
	          return React.createElement(Component, props);
	        }
	      });
	
	      // Add display name for React devtools
	      (function bindWrappedComponentName(c, wrapper) {
	        var componentName = c.displayName || c.name || 'Component';
	        wrapper.displayName = 'OnClickOutside(' + componentName + ')';
	      }(Component, wrapComponentWithOnClickOutsideHandling));
	
	      return wrapComponentWithOnClickOutsideHandling;
	    };
	  }
	
	  /**
	   * This function sets up the library in ways that
	   * work with the various modulde loading solutions
	   * used in JavaScript land today.
	   */
	  function setupBinding(root, factory) {
	    if (true) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1),__webpack_require__(17),__webpack_require__(385)], __WEBPACK_AMD_DEFINE_RESULT__ = function(React, ReactDom, createReactClass) {
	        if (!createReactClass) createReactClass = React.createClass;
	        return factory(root, React, ReactDom, createReactClass);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	      // Node. Note that this does not work with strict
	      // CommonJS, but only CommonJS-like environments
	      // that support module.exports
	      module.exports = factory(root, require('react'), require('react-dom'), require('create-react-class'));
	    } else {
	      // Browser globals (root is window)
	      var createReactClass = React.createClass ? React.createClass : window.createReactClass;
	      root.onClickOutside = factory(root, React, ReactDOM, createReactClass);
	    }
	  }
	
	  // Make it all happen
	  setupBinding(root, setupHOC);
	
	}(this));


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(956));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(2995));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(475));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(476));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(2997));
	
	var _invariant = _interopRequireDefault(__webpack_require__(79));
	
	var _react = __webpack_require__(1);
	
	var _reactIs = __webpack_require__(473);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(2992));
	
	var _PropTypes = __webpack_require__(954);
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(955));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(2993));
	
	var _warning = _interopRequireDefault(__webpack_require__(474));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 956 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore everything but left clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");
	
	    (0, _invariant2.default)(to !== undefined, 'You must specify the "to" property');
	
	    var history = this.context.router.history;
	
	    var location = typeof to === "string" ? (0, _history.createLocation)(to, null, null, history.location) : to;
	
	    var href = history.createHref(location);
	    return _react2.default.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(478);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 959 */
200,
/* 960 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 961 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  location: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { location: payload });
	  }
	
	  return state;
	}

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(200);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(176);
	
	var _Router = __webpack_require__(334);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(200);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(176);
	
	var _generatePath = __webpack_require__(479);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(200);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(176);
	
	var _Router = __webpack_require__(334);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(200);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(335);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(962);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(963);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(964);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(478);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(334);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(965);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(966);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(479);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(335);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(968);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(1470);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(478);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(1044);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 970 */
[3243, 336, 976],
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(480);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(481);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(336);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.select.filterFlatOptions();
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 972 */
[3245, 3021],
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 976 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 977 */
[3243, 337, 983],
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(482);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(483);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(337);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 979 */
[3245, 3025],
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 981 */
974,
/* 982 */
975,
/* 983 */
976,
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _AnimateManager = _interopRequireDefault(__webpack_require__(3030));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(3031));
	
	var _easing = __webpack_require__(985);
	
	var _configUpdate = _interopRequireDefault(__webpack_require__(3032));
	
	var _util = __webpack_require__(338);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Animate = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate(props, context) {
	    var _this;
	
	    _classCallCheck(this, Animate);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Animate).call(this, props, context));
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    if (!isActive) {
	      _this.state = {
	        style: {}
	      }; // if children is a function and animation is not active, set style to 'to'
	
	      if (typeof children === 'function') {
	        _this.state = {
	          style: to
	        };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = {
	        style: steps[0].style
	      };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	        return _possibleConstructorReturn(_this);
	      }
	
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = {
	        style: {}
	      };
	    }
	
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props2 = this.props,
	          isActive = _this$props2.isActive,
	          canBegin = _this$props2.canBegin;
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var isActive = nextProps.isActive,
	          canBegin = nextProps.canBegin,
	          attributeName = nextProps.attributeName,
	          shouldReAnimate = nextProps.shouldReAnimate;
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        this.setState({
	          style: attributeName ? _defineProperty({}, attributeName, nextProps.to) : nextProps.to
	        });
	        return;
	      }
	
	      if ((0, _isEqual2.default)(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
	        return;
	      }
	
	      var isTriggered = !this.props.canBegin || !this.props.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;
	      this.setState({
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      });
	      this.runAnimation(_objectSpread({}, nextProps, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: "runJSAnimation",
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	      var startAnimation = (0, _configUpdate.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: "runStepAnimation",
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return _toConsumableArray(sequence).concat([_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	
	        var newStyle = _objectSpread({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return _toConsumableArray(sequence).concat([newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: "runAnimation",
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager.default)();
	      }
	
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	      var manager = this.manager;
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	      manager.start([onAnimationStart, begin, _objectSpread({}, to, {
	        transition: transition
	      }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: "handleStyleChange",
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: "changeStyle",
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          begin = _this$props3.begin,
	          duration = _this$props3.duration,
	          attributeName = _this$props3.attributeName,
	          easing = _this$props3.easing,
	          isActive = _this$props3.isActive,
	          steps = _this$props3.steps,
	          from = _this$props3.from,
	          to = _this$props3.to,
	          canBegin = _this$props3.canBegin,
	          onAnimationEnd = _this$props3.onAnimationEnd,
	          shouldReAnimate = _this$props3.shouldReAnimate,
	          onAnimationReStart = _this$props3.onAnimationReStart,
	          others = _objectWithoutProperties(_this$props3, ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"]);
	
	      var count = _react.Children.count(children);
	
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === void 0 ? {} : _container$props$styl,
	            className = _container$props.className;
	        var res = (0, _react.cloneElement)(container, _objectSpread({}, others, {
	          style: _objectSpread({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react.default.createElement("div", null, _react.Children.map(children, function (child) {
	        return cloneContainer(child);
	      }));
	    }
	  }]);
	
	  return Animate;
	}(_react.Component), _class2.displayName = 'Animate', _class2.propTypes = {
	  from: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  to: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  attributeName: _propTypes.default.string,
	  // animation duration
	  duration: _propTypes.default.number,
	  begin: _propTypes.default.number,
	  easing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
	    duration: _propTypes.default.number.isRequired,
	    style: _propTypes.default.object.isRequired,
	    easing: _propTypes.default.oneOfType([_propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes.default.arrayOf('string'),
	    onAnimationEnd: _propTypes.default.func
	  })),
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  isActive: _propTypes.default.bool,
	  canBegin: _propTypes.default.bool,
	  onAnimationEnd: _propTypes.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes.default.bool,
	  onAnimationStart: _propTypes.default.func,
	  onAnimationReStart: _propTypes.default.func
	}, _class2.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	}, _temp)) || _class;
	
	var _default = Animate;
	exports.default = _default;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = void 0;
	
	var _util = __webpack_require__(338);
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    var newParams = _toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)).concat([0]);
	
	    return multyTime(newParams, t);
	  };
	}; // calculate cubic-bezier using Newton's method
	
	
	var configBezier = function configBezier() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      default:
	        (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	  return bezier;
	};
	
	exports.configBezier = configBezier;
	
	var configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === void 0 ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === void 0 ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === void 0 ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	  return stepper;
	};
	
	exports.configSpring = configSpring;
	
	var configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	
	      case 'spring':
	        return configSpring();
	
	      default:
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	  return null;
	};
	
	exports.configEasing = configEasing;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(17));
	
	var _reactLifecyclesCompat = __webpack_require__(160);
	
	var _PropTypes = __webpack_require__(989);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(160);
	
	var _ChildMapping = __webpack_require__(3036);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(3034));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(3035));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(987));
	
	var _Transition = _interopRequireDefault(__webpack_require__(986));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(249),
	    _assign = __webpack_require__(39);
	
	var ReactNoopUpdateQueue = __webpack_require__(993);
	
	var canDefineProperty = __webpack_require__(994);
	var emptyObject = __webpack_require__(223);
	var invariant = __webpack_require__(21);
	var lowPriorityWarning = __webpack_require__(3054);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(249);
	
	var ReactCurrentOwner = __webpack_require__(113);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(34);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 992 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(34);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 995 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.memoize = exports.reverse = exports.compose = exports.map = exports.range = exports.curry = exports.PLACE_HOLDER = void 0;
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	exports.PLACE_HOLDER = PLACE_HOLDER;
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(void 0, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(void 0, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	      return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	exports.curry = curry;
	
	var range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	exports.range = range;
	var map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	exports.map = map;
	
	var compose = function compose() {
	  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  } // can be string
	
	
	  return arr.split('').reverse.join('');
	};
	
	exports.reverse = reverse;
	
	var memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(void 0, args);
	    return lastResult;
	  };
	};
	
	exports.memoize = memoize;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _range2 = _interopRequireDefault(__webpack_require__(674));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _d3Scale = __webpack_require__(577);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _Text = _interopRequireDefault(__webpack_require__(161));
	
	var _DataUtils = __webpack_require__(40);
	
	var _CssPrefixUtils = __webpack_require__(3079);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Brush = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Brush, _Component);
	
	  function Brush(props) {
	    var _this;
	
	    _classCallCheck(this, Brush);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Brush).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'endX')
	    };
	    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
	    return _this;
	  }
	
	  _createClass(Brush, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          x = _this$props.x,
	          travellerWidth = _this$props.travellerWidth,
	          updateId = _this$props.updateId;
	
	      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
	        this.setState(this.updateScale(nextProps));
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	      var _this$props2 = this.props,
	          gap = _this$props2.gap,
	          data = _this$props2.data;
	      var lastIndex = data.length - 1;
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.constructor.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.constructor.getIndexInRange(this.scaleValues, max);
	      return {
	        startIndex: minIndex - minIndex % gap,
	        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
	      };
	    }
	  }, {
	    key: "getTextOfTick",
	    value: function getTextOfTick(index) {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          tickFormatter = _this$props3.tickFormatter,
	          dataKey = _this$props3.dataKey;
	      var text = (0, _ChartUtils.getValueByDataKey)(data[index], dataKey, index);
	      return (0, _isFunction2.default)(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: "handleSlideDrag",
	    value: function handleSlideDrag(e) {
	      var _this$state = this.state,
	          slideMoveStartX = _this$state.slideMoveStartX,
	          startX = _this$state.startX,
	          endX = _this$state.endX;
	      var _this$props4 = this.props,
	          x = _this$props4.x,
	          width = _this$props4.width,
	          travellerWidth = _this$props4.travellerWidth,
	          startIndex = _this$props4.startIndex,
	          endIndex = _this$props4.endIndex,
	          onChange = _this$props4.onChange;
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerDragStart",
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerMove",
	    value: function handleTravellerMove(e) {
	      var _this$setState;
	
	      var _this$state2 = this.state,
	          brushMoveStartX = _this$state2.brushMoveStartX,
	          movingTravellerId = _this$state2.movingTravellerId,
	          endX = _this$state2.endX,
	          startX = _this$state2.startX;
	      var prevValue = this.state[movingTravellerId];
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          width = _this$props5.width,
	          travellerWidth = _this$props5.travellerWidth,
	          onChange = _this$props5.onChange,
	          gap = _this$props5.gap,
	          data = _this$props5.data;
	      var params = {
	        startX: this.state.startX,
	        endX: this.state.endX
	      };
	      var delta = e.pageX - brushMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	      var newIndex = this.getIndex(params);
	      var startIndex = newIndex.startIndex,
	          endIndex = newIndex.endIndex;
	
	      var isFullGap = function isFullGap() {
	        var lastIndex = data.length - 1;
	
	        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
	          return true;
	        }
	
	        return false;
	      };
	
	      this.setState((_this$setState = {}, _defineProperty(_this$setState, movingTravellerId, prevValue + delta), _defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function () {
	        if (onChange) {
	          if (isFullGap()) {
	            onChange(newIndex);
	          }
	        }
	      });
	    }
	  }, {
	    key: "updateScale",
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	      var len = data.length;
	      this.scale = (0, _d3Scale.scalePoint)().domain((0, _range2.default)(0, len)).range([x, x + width - travellerWidth]);
	      this.scaleValues = this.scale.domain().map(function (entry) {
	        return _this3.scale(entry);
	      });
	      return {
	        isTextActive: false,
	        isSlideMoving: false,
	        isTravellerMoving: false,
	        startX: this.scale(startIndex),
	        endX: this.scale(endIndex)
	      };
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          fill = _this$props6.fill,
	          stroke = _this$props6.stroke;
	      return _react.default.createElement("rect", {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: "renderPanorama",
	    value: function renderPanorama() {
	      var _this$props7 = this.props,
	          x = _this$props7.x,
	          y = _this$props7.y,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          data = _this$props7.data,
	          children = _this$props7.children,
	          padding = _this$props7.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react.default.cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: "renderTraveller",
	    value: function renderTraveller(travellerX, id) {
	      var _this$props8 = this.props,
	          y = _this$props8.y,
	          travellerWidth = _this$props8.travellerWidth,
	          height = _this$props8.height,
	          stroke = _this$props8.stroke;
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(travellerX, this.props.x);
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-brush-traveller",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.travellerDragStartHandlers[id],
	        onTouchStart: this.travellerDragStartHandlers[id],
	        style: {
	          cursor: 'col-resize'
	        }
	      }, _react.default.createElement("rect", {
	        x: x,
	        y: y,
	        width: travellerWidth,
	        height: height,
	        fill: stroke,
	        stroke: "none"
	      }), _react.default.createElement("line", {
	        x1: x + 1,
	        y1: lineY,
	        x2: x + travellerWidth - 1,
	        y2: lineY,
	        fill: "none",
	        stroke: "#fff"
	      }), _react.default.createElement("line", {
	        x1: x + 1,
	        y1: lineY + 2,
	        x2: x + travellerWidth - 1,
	        y2: lineY + 2,
	        fill: "none",
	        stroke: "#fff"
	      }));
	    }
	  }, {
	    key: "renderSlide",
	    value: function renderSlide(startX, endX) {
	      var _this$props9 = this.props,
	          y = _this$props9.y,
	          height = _this$props9.height,
	          stroke = _this$props9.stroke;
	      return _react.default.createElement("rect", {
	        className: "recharts-brush-slide",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: {
	          cursor: 'move'
	        },
	        stroke: "none",
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: "renderText",
	    value: function renderText() {
	      var _this$props10 = this.props,
	          startIndex = _this$props10.startIndex,
	          endIndex = _this$props10.endIndex,
	          y = _this$props10.y,
	          height = _this$props10.height,
	          travellerWidth = _this$props10.travellerWidth,
	          stroke = _this$props10.stroke;
	      var _this$state3 = this.state,
	          startX = _this$state3.startX,
	          endX = _this$state3.endX;
	      var offset = 5;
	      var attrs = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-brush-texts"
	      }, _react.default.createElement(_Text.default, _extends({
	        textAnchor: "end",
	        verticalAnchor: "middle",
	        x: Math.min(startX, endX) - offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(startIndex)), _react.default.createElement(_Text.default, _extends({
	        textAnchor: "start",
	        verticalAnchor: "middle",
	        x: Math.max(startX, endX) + travellerWidth + offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(endIndex)));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props11 = this.props,
	          data = _this$props11.data,
	          className = _this$props11.className,
	          children = _this$props11.children,
	          x = _this$props11.x,
	          y = _this$props11.y,
	          width = _this$props11.width,
	          height = _this$props11.height;
	      var _this$state4 = this.state,
	          startX = _this$state4.startX,
	          endX = _this$state4.endX,
	          isTextActive = _this$state4.isTextActive,
	          isSlideMoving = _this$state4.isSlideMoving,
	          isTravellerMoving = _this$state4.isTravellerMoving;
	
	      if (!data || !data.length || !(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || width <= 0 || height <= 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames.default)('recharts-brush', className);
	      var isPanoramic = _react.default.Children.count(children) === 1;
	      var style = (0, _CssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
	      return _react.default.createElement(_Layer.default, {
	        className: layerClass,
	        onMouseMove: this.handleDrag,
	        onMouseLeave: this.handleLeaveWrapper,
	        onMouseUp: this.handleDragEnd,
	        onTouchEnd: this.handleDragEnd,
	        onTouchMove: this.handleTouchMove,
	        style: style
	      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTraveller(startX, 'startX'), this.renderTraveller(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText());
	    }
	  }], [{
	    key: "getIndexInRange",
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }]);
	
	  return Brush;
	}(_react.Component), _class2.displayName = 'Brush', _class2.propTypes = {
	  className: _propTypes.default.string,
	  fill: _propTypes.default.string,
	  stroke: _propTypes.default.string,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number.isRequired,
	  travellerWidth: _propTypes.default.number,
	  gap: _propTypes.default.number,
	  padding: _propTypes.default.shape({
	    top: _propTypes.default.number,
	    right: _propTypes.default.number,
	    bottom: _propTypes.default.number,
	    left: _propTypes.default.number
	  }),
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  data: _propTypes.default.array,
	  startIndex: _propTypes.default.number,
	  endIndex: _propTypes.default.number,
	  tickFormatter: _propTypes.default.func,
	  children: _propTypes.default.node,
	  onChange: _propTypes.default.func,
	  updateId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  leaveTimeOut: _propTypes.default.number
	}, _class2.defaultProps = {
	  height: 40,
	  travellerWidth: 5,
	  gap: 1,
	  fill: '#fff',
	  stroke: '#666',
	  padding: {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  },
	  leaveTimeOut: 1000
	}, _temp)) || _class;
	
	var _default = Brush;
	exports.default = _default;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = __webpack_require__(26);
	
	var _DOMUtils = __webpack_require__(346);
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _Text = _interopRequireDefault(__webpack_require__(161));
	
	var _Label = _interopRequireDefault(__webpack_require__(129));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _DataUtils = __webpack_require__(40);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianAxis =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianAxis).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ["viewBox"]);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _this$props = this.props,
	          viewBoxOld = _this$props.viewBox,
	          restPropsOld = _objectWithoutProperties(_this$props, ["viewBox"]);
	
	      return !(0, _PureRender.shallowEqual)(viewBox, viewBoxOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(state, this.state);
	    }
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: "getTickLineCoord",
	    value: function getTickLineCoord(data) {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          orientation = _this$props2.orientation,
	          tickSize = _this$props2.tickSize,
	          mirror = _this$props2.mirror,
	          tickMargin = _this$props2.tickMargin;
	      var x1, x2, y1, y2, tx, ty;
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = y2 - sign * finalTickSize;
	          ty = y1 - sign * tickMargin;
	          tx = tickCoord;
	          break;
	
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = x2 - sign * finalTickSize;
	          tx = x1 - sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = x2 + sign * finalTickSize;
	          tx = x1 + sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = y2 + sign * finalTickSize;
	          ty = y1 + sign * tickMargin;
	          tx = tickCoord;
	          break;
	      }
	
	      return {
	        line: {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2
	        },
	        tick: {
	          x: tx,
	          y: ty
	        }
	      };
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var _this$props3 = this.props,
	          orientation = _this$props3.orientation,
	          mirror = _this$props3.mirror;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getTickVerticalAnchor",
	    value: function getTickVerticalAnchor() {
	      var _this$props4 = this.props,
	          orientation = _this$props4.orientation,
	          mirror = _this$props4.mirror;
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          orientation = _this$props5.orientation,
	          axisLine = _this$props5.axisLine,
	          mirror = _this$props5.mirror;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react.default.createElement("line", _extends({
	        className: "recharts-cartesian-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	    value: function renderTicks(ticks) {
	      var _this = this;
	
	      var _this$props6 = this.props,
	          tickLine = _this$props6.tickLine,
	          stroke = _this$props6.stroke,
	          tick = _this$props6.tick,
	          tickFormatter = _this$props6.tickFormatter,
	          unit = _this$props6.unit;
	      var finalTicks = CartesianAxis.getTicks(_objectSpread({}, this.props, {
	        ticks: ticks
	      }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = finalTicks.map(function (entry, i) {
	        var _this$getTickLineCoor = _this.getTickLineCoord(entry),
	            lineCoord = _this$getTickLineCoor.line,
	            tickCoord = _this$getTickLineCoor.tick;
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, tickCoord, {
	          index: i,
	          payload: entry,
	          visibleTicksCount: finalTicks.length
	        });
	
	        return _react.default.createElement(_Layer.default, _extends({
	          className: "recharts-cartesian-axis-tick",
	          key: "tick-".concat(i)
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react.default.createElement("line", _extends({
	          className: "recharts-cartesian-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, "".concat((0, _isFunction2.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value).concat(unit || '')));
	      });
	      return _react.default.createElement("g", {
	        className: "recharts-cartesian-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          axisLine = _this$props7.axisLine,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          ticksGenerator = _this$props7.ticksGenerator,
	          className = _this$props7.className,
	          hide = _this$props7.hide;
	
	      if (hide) {
	        return null;
	      }
	
	      var _this$props8 = this.props,
	          ticks = _this$props8.ticks,
	          noTicksProps = _objectWithoutProperties(_this$props8, ["ticks"]);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction2.default)(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react.default.createElement(_Layer.default, {
	        className: (0, _classnames.default)('recharts-cartesian-axis', className)
	      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), _Label.default.renderCallByParent(this.props));
	    }
	  }], [{
	    key: "getTicks",
	    value: function getTicks(props) {
	      var tick = props.tick,
	          ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter,
	          unit = props.unit;
	
	      if (!ticks || !ticks.length || !tick) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        }, true);
	      }
	
	      if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({
	        ticks: ticks,
	        tickFormatter: tickFormatter,
	        viewBox: viewBox,
	        orientation: orientation,
	        minTickGap: minTickGap,
	        unit: unit
	      });
	    }
	  }, {
	    key: "getNumberIntervalTicks",
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: "getTicksStart",
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap,
	          unit = _ref2.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction2.default)(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey] + unitSize;
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _objectSpread({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _objectSpread({}, tail, {
	            isShow: true
	          });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	
	      for (var i = 0; i < count; i++) {
	        var entry = result[i];
	        var content = (0, _isFunction2.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[i] = entry = _objectSpread({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[i] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "getTicksEnd",
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap,
	          unit = _ref3.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height'; // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var i = len - 1; i >= 0; i--) {
	        var entry = result[i];
	        var content = (0, _isFunction2.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (i === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[i] = entry = _objectSpread({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[i] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react.default.isValidElement(option)) {
	        tickItem = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react.default.createElement(_Text.default, _extends({}, props, {
	          className: "recharts-cartesian-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component);
	
	CartesianAxis.displayName = 'CartesianAxis';
	CartesianAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  orientation: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  }),
	  tick: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.object, _propTypes.default.element]),
	  axisLine: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  tickLine: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  mirror: _propTypes.default.bool,
	  tickMargin: _propTypes.default.number.isRequired,
	  minTickGap: _propTypes.default.number,
	  ticks: _propTypes.default.array,
	  tickSize: _propTypes.default.number,
	  stroke: _propTypes.default.string,
	  tickFormatter: _propTypes.default.func,
	  ticksGenerator: _propTypes.default.func,
	  interval: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	});
	CartesianAxis.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  tickMargin: 2,
	  interval: 'preserveEnd'
	};
	var _default = CartesianAxis;
	exports.default = _default;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _Label = _interopRequireDefault(__webpack_require__(129));
	
	var _CartesianUtils = __webpack_require__(130);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _DataUtils = __webpack_require__(40);
	
	var _LogUtils = __webpack_require__(208);
	
	var _ReactUtils = __webpack_require__(25);
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(207));
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceArea = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ReferenceArea, _Component);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceArea).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: "getRect",
	    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
	      var _this$props = this.props,
	          xValue1 = _this$props.x1,
	          xValue2 = _this$props.x2,
	          yValue1 = _this$props.y1,
	          yValue2 = _this$props.y2,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scale = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var p1 = {
	        x: hasX1 ? scale.x.apply(xValue1) : scale.x.rangeMin,
	        y: hasY1 ? scale.y.apply(yValue1) : scale.y.rangeMin
	      };
	      var p2 = {
	        x: hasX2 ? scale.x.apply(xValue2) : scale.x.rangeMax,
	        y: hasY2 ? scale.y.apply(yValue2) : scale.y.rangeMax
	      };
	
	      if ((0, _ChartUtils.ifOverflowMatches)(this.props, 'discard') && (!scale.isInRange(p1) || !scale.isInRange(p2))) {
	        return null;
	      }
	
	      return (0, _CartesianUtils.rectWithPoints)(p1, p2);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x1 = _this$props2.x1,
	          x2 = _this$props2.x2,
	          y1 = _this$props2.y1,
	          y2 = _this$props2.y2,
	          className = _this$props2.className,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	      var hasX1 = (0, _DataUtils.isNumOrStr)(x1);
	      var hasX2 = (0, _DataUtils.isNumOrStr)(x2);
	      var hasY1 = (0, _DataUtils.isNumOrStr)(y1);
	      var hasY2 = (0, _DataUtils.isNumOrStr)(y2);
	
	      if (!hasX1 && !hasX2 && !hasY1 && !hasY2) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);
	
	      if (!rect) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	      var clipPath = (0, _ChartUtils.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	      return _react.default.createElement(_Layer.default, {
	        className: (0, _classnames.default)('recharts-reference-area', className)
	      }, this.constructor.renderRect(shape, _objectSpread({
	        clipPath: clipPath
	      }, this.props, rect)), _Label.default.renderCallByParent(this.props, rect));
	    }
	  }], [{
	    key: "renderRect",
	    value: function renderRect(option, props) {
	      var rect;
	
	      if (_react.default.isValidElement(option)) {
	        rect = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        rect = option(props);
	      } else {
	        rect = _react.default.createElement(_Rectangle.default, _extends({}, props, {
	          className: "recharts-reference-area-rect"
	        }));
	      }
	
	      return rect;
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.Component), _class2.displayName = 'ReferenceArea', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  }),
	  xAxis: _propTypes.default.object,
	  yAxis: _propTypes.default.object,
	  isFront: _propTypes.default.bool,
	  alwaysShow: _propTypes.default.bool,
	  ifOverflow: _propTypes.default.oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x1: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  x2: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  y1: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  y2: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  className: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  yAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  xAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  shape: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	}, _temp)) || _class;
	
	var _default = ReferenceArea;
	exports.default = _default;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _Dot = _interopRequireDefault(__webpack_require__(162));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _Label = _interopRequireDefault(__webpack_require__(129));
	
	var _DataUtils = __webpack_require__(40);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _CartesianUtils = __webpack_require__(130);
	
	var _LogUtils = __webpack_require__(208);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceDot = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ReferenceDot, _Component);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceDot).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: "getCoordinate",
	    value: function getCoordinate() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var result = scales.apply({
	        x: x,
	        y: y
	      }, {
	        bandAware: true
	      });
	
	      if ((0, _ChartUtils.ifOverflowMatches)(this.props, 'discard') && !scales.isInRange(result)) {
	        return null;
	      }
	
	      return result;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          r = _this$props2.r,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var cx = coordinate.x,
	          cy = coordinate.y;
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          className = _this$props3.className;
	      var clipPath = (0, _ChartUtils.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var dotProps = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        cx: cx,
	        cy: cy
	      });
	
	      return _react.default.createElement(_Layer.default, {
	        className: (0, _classnames.default)('recharts-reference-dot', className)
	      }, this.constructor.renderDot(shape, dotProps), _Label.default.renderCallByParent(this.props, {
	        x: cx - r,
	        y: cy - r,
	        width: 2 * r,
	        height: 2 * r
	      }));
	    }
	  }], [{
	    key: "renderDot",
	    value: function renderDot(option, props) {
	      var dot;
	
	      if (_react.default.isValidElement(option)) {
	        dot = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react.default.createElement(_Dot.default, _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: "recharts-reference-dot-dot"
	        }));
	      }
	
	      return dot;
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.Component), _class2.displayName = 'ReferenceDot', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes.default.number,
	  xAxis: _propTypes.default.shape({
	    scale: _propTypes.default.func
	  }),
	  yAxis: _propTypes.default.shape({
	    scale: _propTypes.default.func
	  }),
	  isFront: _propTypes.default.bool,
	  alwaysShow: _propTypes.default.bool,
	  ifOverflow: _propTypes.default.oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  className: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  yAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  xAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  shape: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
	  clipPathId: _propTypes.default.string
	}), _class2.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	var _default = ReferenceDot;
	exports.default = _default;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _some2 = _interopRequireDefault(__webpack_require__(153));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _Label = _interopRequireDefault(__webpack_require__(129));
	
	var _ChartUtils = __webpack_require__(52);
	
	var _DataUtils = __webpack_require__(40);
	
	var _CartesianUtils = __webpack_require__(130);
	
	var _LogUtils = __webpack_require__(208);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var renderLine = function renderLine(option, props) {
	  var line;
	
	  if (_react.default.isValidElement(option)) {
	    line = _react.default.cloneElement(option, props);
	  } else if ((0, _isFunction2.default)(option)) {
	    line = option(props);
	  } else {
	    line = _react.default.createElement("line", _extends({}, props, {
	      className: "recharts-reference-line-line"
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ReferenceLine, _Component);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceLine).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: "getEndPoints",
	    value: function getEndPoints(scales, isFixedX, isFixedY, isSegment) {
	      var _this$props$viewBox = this.props.viewBox,
	          x = _this$props$viewBox.x,
	          y = _this$props$viewBox.y,
	          width = _this$props$viewBox.width,
	          height = _this$props$viewBox.height;
	
	      if (isFixedY) {
	        var _this$props = this.props,
	            yCoord = _this$props.y,
	            orientation = _this$props.yAxis.orientation;
	        var coord = scales.y.apply(yCoord, {
	          bandAware: true
	        });
	
	        if ((0, _ChartUtils.ifOverflowMatches)(this.props, 'discard') && !scales.y.isInRange(coord)) {
	          return null;
	        }
	
	        var points = [{
	          x: x + width,
	          y: coord
	        }, {
	          x: x,
	          y: coord
	        }];
	        return orientation === 'left' ? points.reverse() : points;
	      }
	
	      if (isFixedX) {
	        var _this$props2 = this.props,
	            xCoord = _this$props2.x,
	            _orientation = _this$props2.xAxis.orientation;
	
	        var _coord = scales.x.apply(xCoord, {
	          bandAware: true
	        });
	
	        if ((0, _ChartUtils.ifOverflowMatches)(this.props, 'discard') && !scales.x.isInRange(_coord)) {
	          return null;
	        }
	
	        var _points = [{
	          x: _coord,
	          y: y + height
	        }, {
	          x: _coord,
	          y: y
	        }];
	        return _orientation === 'top' ? _points.reverse() : _points;
	      }
	
	      if (isSegment) {
	        var segment = this.props.segment;
	
	        var _points2 = segment.map(function (p) {
	          return scales.apply(p, {
	            bandAware: true
	          });
	        });
	
	        if ((0, _ChartUtils.ifOverflowMatches)(this.props, 'discard') && (0, _some2.default)(_points2, function (p) {
	          return !scales.isInRange(p);
	        })) {
	          return null;
	        }
	
	        return _points2;
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          fixedX = _this$props3.x,
	          fixedY = _this$props3.y,
	          segment = _this$props3.segment,
	          xAxis = _this$props3.xAxis,
	          yAxis = _this$props3.yAxis,
	          shape = _this$props3.shape,
	          className = _this$props3.className,
	          alwaysShow = _this$props3.alwaysShow,
	          clipPathId = _this$props3.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var isX = (0, _DataUtils.isNumOrStr)(fixedX);
	      var isY = (0, _DataUtils.isNumOrStr)(fixedY);
	      var isSegment = segment && segment.length === 2;
	      var endPoints = this.getEndPoints(scales, isX, isY, isSegment);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          _endPoints$ = _endPoints[0],
	          x1 = _endPoints$.x,
	          y1 = _endPoints$.y,
	          _endPoints$2 = _endPoints[1],
	          x2 = _endPoints$2.x,
	          y2 = _endPoints$2.y;
	
	      var clipPath = (0, _ChartUtils.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var props = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      });
	
	      return _react.default.createElement(_Layer.default, {
	        className: (0, _classnames.default)('recharts-reference-line', className)
	      }, renderLine(shape, props), _Label.default.renderCallByParent(this.props, (0, _CartesianUtils.rectWithCoords)({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      })));
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.Component), _class2.displayName = 'ReferenceLine', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  }),
	  xAxis: _propTypes.default.object,
	  yAxis: _propTypes.default.object,
	  isFront: _propTypes.default.bool,
	  alwaysShow: _propTypes.default.bool,
	  ifOverflow: _propTypes.default.oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  segment: _propTypes.default.arrayOf(_propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })),
	  className: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  yAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  xAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  shape: _propTypes.default.func
	}), _class2.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	var _default = ReferenceLine;
	exports.default = _default;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(126));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(417));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(295));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(294));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _Trapezoid = _interopRequireDefault(__webpack_require__(1006));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _Cell = _interopRequireDefault(__webpack_require__(205));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _DataUtils = __webpack_require__(40);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Funnel = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Funnel, _Component);
	
	  function Funnel() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Funnel);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Funnel)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (trapezoids) {
	      _this.setState({
	        prevTrapezoids: trapezoids
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2.default)(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2.default)(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Funnel, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          trapezoids = _this$props.trapezoids;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(trapezoids);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderTrapezoidsStatically",
	    value: function renderTrapezoidsStatically(trapezoids) {
	      var _this2 = this;
	
	      var activeShape = this.props.activeShape;
	      return trapezoids.map(function (entry, i) {
	        var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : null;
	
	        var trapezoidProps = _objectSpread({}, entry, {
	          stroke: entry.stroke
	        });
	
	        return _react.default.createElement(_Layer.default, _extends({
	          className: "recharts-funnel-trapezoid"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "trapezoid-".concat(i)
	        }), _this2.constructor.renderTrapezoidItem(trapezoidOptions, trapezoidProps));
	      });
	    }
	  }, {
	    key: "renderTrapezoidsWithAnimation",
	    value: function renderTrapezoidsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          trapezoids = _this$props2.trapezoids,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevTrapezoids = this.state.prevTrapezoids;
	      return _react.default.createElement(_reactSmooth.default, {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "funnel-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = trapezoids.map(function (entry, index) {
	          var prev = prevTrapezoids && prevTrapezoids[index];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            var _interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(prev.upperWidth, entry.upperWidth);
	
	            var _interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(prev.lowerWidth, entry.lowerWidth);
	
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t),
	              upperWidth: _interpolatorUpperWidth(t),
	              lowerWidth: _interpolatorLowerWidth(t),
	              height: _interpolatorHeight(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.x + entry.upperWidth / 2, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.y + entry.height / 2, entry.y);
	          var interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(0, entry.upperWidth);
	          var interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(0, entry.lowerWidth);
	          var interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t),
	            upperWidth: interpolatorUpperWidth(t),
	            lowerWidth: interpolatorLowerWidth(t),
	            height: interpolatorHeight(t)
	          });
	        });
	        return _react.default.createElement(_Layer.default, null, _this3.renderTrapezoidsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderTrapezoids",
	    value: function renderTrapezoids() {
	      var _this$props3 = this.props,
	          trapezoids = _this$props3.trapezoids,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevTrapezoids = this.state.prevTrapezoids;
	
	      if (isAnimationActive && trapezoids && trapezoids.length && (!prevTrapezoids || !(0, _isEqual2.default)(prevTrapezoids, trapezoids))) {
	        return this.renderTrapezoidsWithAnimation();
	      }
	
	      return this.renderTrapezoidsStatically(trapezoids);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          hide = _this$props4.hide,
	          trapezoids = _this$props4.trapezoids,
	          className = _this$props4.className,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (hide || !trapezoids || !trapezoids.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames.default)('recharts-trapezoids', className);
	      return _react.default.createElement(_Layer.default, {
	        className: layerClass
	      }, this.renderTrapezoids(), (!isAnimationActive || isAnimationFinished) && _LabelList.default.renderCallByParent(this.props, trapezoids));
	    }
	  }], [{
	    key: "renderTrapezoidItem",
	    value: function renderTrapezoidItem(option, props) {
	      if (_react.default.isValidElement(option)) {
	        return _react.default.cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2.default)(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2.default)(option)) {
	        return _react.default.createElement(_Trapezoid.default, _extends({}, props, option));
	      }
	
	      return _react.default.createElement(_Trapezoid.default, props);
	    }
	  }]);
	
	  return Funnel;
	}(_react.Component), _class2.displayName = 'Funnel', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  animationId: _propTypes.default.number,
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]).isRequired,
	  nameKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  data: _propTypes.default.arrayOf(_propTypes.default.object),
	  trapezoids: _propTypes.default.arrayOf(_propTypes.default.object),
	  hide: _propTypes.default.bool,
	  activeShape: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.element]),
	  legendType: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes.default.oneOf(_ReactUtils.TOOLTIP_TYPES),
	  activeIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	  isAnimationActive: _propTypes.default.bool,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
	}), _class2.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  labelLine: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name'
	}, _class2.getRealFunnelData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell.default);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, entry, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, cell.props);
	    });
	  }
	
	  return [];
	}, _class2.getRealWidthHeight = function (item, offset) {
	  var customWidth = item.props.width;
	  var width = offset.width,
	      height = offset.height,
	      left = offset.left,
	      right = offset.right,
	      top = offset.top,
	      bottom = offset.bottom;
	  var realHeight = height;
	  var realWidth = width;
	
	  if ((0, _isNumber2.default)(customWidth)) {
	    realWidth = customWidth;
	  } else if ((0, _isString2.default)(customWidth)) {
	    realWidth = realWidth * parseFloat(customWidth) / 100;
	  }
	
	  return {
	    realWidth: realWidth - left - right - 50,
	    realHeight: realHeight - bottom - top,
	    offsetX: (width - realWidth) / 2,
	    offsetY: (height - realHeight) / 2
	  };
	}, _class2.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      offset = _ref2.offset,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter;
	  var funnelData = Funnel.getRealFunnelData(item);
	  var _item$props2 = item.props,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      tooltipType = _item$props2.tooltipType;
	  var left = offset.left,
	      top = offset.top;
	
	  var _Funnel$getRealWidthH = Funnel.getRealWidthHeight(item, offset),
	      realHeight = _Funnel$getRealWidthH.realHeight,
	      realWidth = _Funnel$getRealWidthH.realWidth,
	      offsetX = _Funnel$getRealWidthH.offsetX,
	      offsetY = _Funnel$getRealWidthH.offsetY;
	
	  var maxValue = (0, _ChartUtils.getValueByDataKey)(funnelData[0], dataKey, 0);
	  var len = funnelData.length;
	  var rowHeight = realHeight / len;
	  var trapezoids = funnelData.map(function (entry, i) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	    var nextVal = 0;
	
	    if (i !== len - 1) {
	      nextVal = (0, _ChartUtils.getValueByDataKey)(funnelData[i + 1], dataKey, 0);
	    }
	
	    var x = (maxValue - val) * realWidth / (2 * maxValue) + top + 25 + offsetX;
	    var y = realHeight / len * i + left + offsetY;
	    var upperWidth = val / maxValue * realWidth;
	    var lowerWidth = nextVal / maxValue * realWidth;
	    var tooltipPayload = [{
	      name: name,
	      value: val,
	      payload: entry,
	      dataKey: dataKey,
	      type: tooltipType
	    }];
	    var tooltipPosition = {
	      x: x + upperWidth / 2,
	      y: y + rowHeight / 2
	    };
	    return _objectSpread({
	      x: x,
	      y: y,
	      width: Math.max(upperWidth, lowerWidth),
	      upperWidth: upperWidth,
	      lowerWidth: lowerWidth,
	      height: rowHeight,
	      name: name,
	      val: val,
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: tooltipPosition
	    }, (0, _omit2.default)(entry, 'width'), {
	      payload: entry
	    });
	  });
	  return {
	    trapezoids: trapezoids,
	    data: funnelData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  };
	}, _temp)) || _class;
	
	var _default = Funnel;
	exports.default = _default;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _get2 = _interopRequireDefault(__webpack_require__(186));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(126));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(56));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _Sector = _interopRequireDefault(__webpack_require__(345));
	
	var _Curve = _interopRequireDefault(__webpack_require__(206));
	
	var _Text = _interopRequireDefault(__webpack_require__(161));
	
	var _Label = _interopRequireDefault(__webpack_require__(129));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _Cell = _interopRequireDefault(__webpack_require__(205));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _PolarUtils = __webpack_require__(93);
	
	var _DataUtils = __webpack_require__(40);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _LogUtils = __webpack_require__(208);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Pie = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Pie, _Component);
	
	  function Pie() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pie)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-pie-');
	
	    _this.cachePrevData = function (sectors) {
	      _this.setState({
	        prevSectors: sectors
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2.default)(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2.default)(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Pie, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          sectors = _this$props.sectors;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(sectors);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderLabels",
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          label = _this$props2.label,
	          labelLine = _this$props2.labelLine,
	          dataKey = _this$props2.dataKey,
	          valueKey = _this$props2.valueKey;
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	
	        var labelProps = _objectSpread({}, pieProps, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.constructor.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	
	        var lineProps = _objectSpread({}, pieProps, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          index: i,
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint],
	          key: 'line'
	        });
	
	        var realDataKey = dataKey; // TODO: compatible to lower versions
	
	        if ((0, _isNil2.default)(dataKey) && (0, _isNil2.default)(valueKey)) {
	          realDataKey = 'value';
	        } else if ((0, _isNil2.default)(dataKey)) {
	          realDataKey = valueKey;
	        }
	
	        return _react.default.createElement(_Layer.default, {
	          key: "label-".concat(i)
	        }, labelLine && _this2.constructor.renderLabelLineItem(labelLine, lineProps), _this2.constructor.renderLabelItem(label, labelProps, (0, _ChartUtils.getValueByDataKey)(entry, realDataKey)));
	      });
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-pie-labels"
	      }, labels);
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          activeShape = _this$props3.activeShape,
	          blendStroke = _this$props3.blendStroke;
	      return sectors.map(function (entry, i) {
	        var sectorOptions = _this3.isActiveIndex(i) ? activeShape : null;
	
	        var sectorProps = _objectSpread({}, entry, {
	          stroke: blendStroke ? entry.fill : entry.stroke
	        });
	
	        return _react.default.createElement(_Layer.default, _extends({
	          className: "recharts-pie-sector"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	          key: "sector-".concat(i)
	        }), _this3.constructor.renderSectorItem(sectorOptions, sectorProps));
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          sectors = _this$props4.sectors,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevSectors = this.state.prevSectors;
	      return _react.default.createElement(_reactSmooth.default, {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = [];
	        var first = sectors && sectors[0];
	        var curAngle = first.startAngle;
	        sectors.forEach(function (entry, index) {
	          var prev = prevSectors && prevSectors[index];
	          var paddingAngle = index > 0 ? (0, _get2.default)(entry, 'paddingAngle', 0) : 0;
	
	          if (prev) {
	            var angleIp = (0, _DataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
	
	            var latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + angleIp(t) + paddingAngle
	            });
	
	            stepData.push(latest);
	            curAngle = latest.endAngle;
	          } else {
	            var endAngle = entry.endAngle,
	                startAngle = entry.startAngle;
	            var interpolatorAngle = (0, _DataUtils.interpolateNumber)(0, endAngle - startAngle);
	            var deltaAngle = interpolatorAngle(t);
	
	            var _latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + deltaAngle + paddingAngle
	            });
	
	            stepData.push(_latest);
	            curAngle = _latest.endAngle;
	          }
	        });
	        return _react.default.createElement(_Layer.default, null, _this4.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          sectors = _this$props5.sectors,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevSectors = this.state.prevSectors;
	
	      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqual2.default)(prevSectors, sectors))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(sectors);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          sectors = _this$props6.sectors,
	          className = _this$props6.className,
	          label = _this$props6.label,
	          cx = _this$props6.cx,
	          cy = _this$props6.cy,
	          innerRadius = _this$props6.innerRadius,
	          outerRadius = _this$props6.outerRadius,
	          isAnimationActive = _this$props6.isAnimationActive,
	          prevSectors = _this$props6.prevSectors;
	
	      if (hide || !sectors || !sectors.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames.default)('recharts-pie', className);
	      return _react.default.createElement(_Layer.default, {
	        className: layerClass
	      }, this.renderSectors(), label && this.renderLabels(sectors), _Label.default.renderCallByParent(this.props, null, false), (!isAnimationActive || prevSectors && (0, _isEqual2.default)(prevSectors, sectors)) && _LabelList.default.renderCallByParent(this.props, sectors, false));
	    }
	  }], [{
	    key: "getTextAnchor",
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      }
	
	      if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: "renderLabelLineItem",
	    value: function renderLabelLineItem(option, props) {
	      if (_react.default.isValidElement(option)) {
	        return _react.default.cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2.default)(option)) {
	        return option(props);
	      }
	
	      return _react.default.createElement(_Curve.default, _extends({}, props, {
	        type: "linear",
	        className: "recharts-pie-label-line"
	      }));
	    }
	  }, {
	    key: "renderLabelItem",
	    value: function renderLabelItem(option, props, value) {
	      if (_react.default.isValidElement(option)) {
	        return _react.default.cloneElement(option, props);
	      }
	
	      var label = value;
	
	      if ((0, _isFunction2.default)(option)) {
	        label = option(props);
	
	        if (_react.default.isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react.default.createElement(_Text.default, _extends({}, props, {
	        alignmentBaseline: "middle",
	        className: "recharts-pie-label-text"
	      }), label);
	    }
	  }, {
	    key: "renderSectorItem",
	    value: function renderSectorItem(option, props) {
	      if (_react.default.isValidElement(option)) {
	        return _react.default.cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2.default)(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2.default)(option)) {
	        return _react.default.createElement(_Sector.default, _extends({}, props, option));
	      }
	
	      return _react.default.createElement(_Sector.default, props);
	    }
	  }]);
	
	  return Pie;
	}(_react.Component), _class2.displayName = 'Pie', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  animationId: _propTypes.default.number,
	  cx: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  cy: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  startAngle: _propTypes.default.number,
	  endAngle: _propTypes.default.number,
	  paddingAngle: _propTypes.default.number,
	  innerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  outerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  cornerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]).isRequired,
	  nameKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  valueKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  data: _propTypes.default.arrayOf(_propTypes.default.object),
	  blendStroke: _propTypes.default.bool,
	  minAngle: _propTypes.default.number,
	  legendType: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes.default.oneOf(_ReactUtils.TOOLTIP_TYPES),
	  maxRadius: _propTypes.default.number,
	  sectors: _propTypes.default.arrayOf(_propTypes.default.object),
	  hide: _propTypes.default.bool,
	  labelLine: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.element, _propTypes.default.bool]),
	  label: _propTypes.default.oneOfType([_propTypes.default.shape({
	    offsetRadius: _propTypes.default.number
	  }), _propTypes.default.func, _propTypes.default.element, _propTypes.default.bool]),
	  activeShape: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.element]),
	  activeIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	  isAnimationActive: _propTypes.default.bool,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
	  id: _propTypes.default.string
	}), _class2.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  labelLine: true,
	  hide: false,
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name',
	  // Match each sector's stroke color to it's fill color
	  blendStroke: false
	}, _class2.parseDeltaAngle = function (_ref2) {
	  var startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	}, _class2.getRealPieData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell.default);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, entry, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, cell.props);
	    });
	  }
	
	  return [];
	}, _class2.parseCoordinateOfPie = function (item, offset) {
	  var top = offset.top,
	      left = offset.left,
	      width = offset.width,
	      height = offset.height;
	  var maxPieRadius = (0, _PolarUtils.getMaxRadius)(width, height);
	  var cx = left + (0, _DataUtils.getPercentValue)(item.props.cx, width, width / 2);
	  var cy = top + (0, _DataUtils.getPercentValue)(item.props.cy, height, height / 2);
	  var innerRadius = (0, _DataUtils.getPercentValue)(item.props.innerRadius, maxPieRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
	  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
	  return {
	    cx: cx,
	    cy: cy,
	    innerRadius: innerRadius,
	    outerRadius: outerRadius,
	    maxRadius: maxRadius
	  };
	}, _class2.getComposedData = function (_ref3) {
	  var item = _ref3.item,
	      offset = _ref3.offset,
	      onItemMouseLeave = _ref3.onItemMouseLeave,
	      onItemMouseEnter = _ref3.onItemMouseEnter;
	  var pieData = Pie.getRealPieData(item);
	
	  if (!pieData || !pieData.length) {
	    return [];
	  }
	
	  var _item$props2 = item.props,
	      cornerRadius = _item$props2.cornerRadius,
	      startAngle = _item$props2.startAngle,
	      endAngle = _item$props2.endAngle,
	      paddingAngle = _item$props2.paddingAngle,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      valueKey = _item$props2.valueKey,
	      tooltipType = _item$props2.tooltipType;
	  var minAngle = Math.abs(item.props.minAngle);
	  var coordinate = Pie.parseCoordinateOfPie(item, offset);
	  var len = pieData.length;
	  var deltaAngle = Pie.parseDeltaAngle({
	    startAngle: startAngle,
	    endAngle: endAngle
	  });
	  var absDeltaAngle = Math.abs(deltaAngle);
	  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
	  var realDataKey = dataKey;
	
	  if ((0, _isNil2.default)(dataKey) && (0, _isNil2.default)(valueKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = 'value';
	  } else if ((0, _isNil2.default)(dataKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = valueKey;
	  }
	
	  var sum = pieData.reduce(function (result, entry) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	    return result + ((0, _DataUtils.isNumber)(val) ? val : 0);
	  }, 0);
	  var sectors;
	
	  if (sum > 0) {
	    var prev;
	    sectors = pieData.map(function (entry, i) {
	      var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	      var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	      var percent = ((0, _DataUtils.isNumber)(val) ? val : 0) / sum;
	      var tempStartAngle;
	
	      if (i) {
	        tempStartAngle = prev.endAngle + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	      } else {
	        tempStartAngle = startAngle;
	      }
	
	      var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * realTotalAngle);
	      var midAngle = (tempStartAngle + tempEndAngle) / 2;
	      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
	      var tooltipPayload = [{
	        name: name,
	        value: val,
	        payload: entry,
	        dataKey: realDataKey,
	        type: tooltipType
	      }];
	      var tooltipPosition = (0, _PolarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
	      prev = _objectSpread({
	        percent: percent,
	        cornerRadius: cornerRadius,
	        name: name,
	        tooltipPayload: tooltipPayload,
	        midAngle: midAngle,
	        middleRadius: middleRadius,
	        tooltipPosition: tooltipPosition
	      }, entry, coordinate, {
	        value: (0, _ChartUtils.getValueByDataKey)(entry, realDataKey),
	        startAngle: tempStartAngle,
	        endAngle: tempEndAngle,
	        payload: entry,
	        paddingAngle: (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle
	      });
	      return prev;
	    });
	  }
	
	  return _objectSpread({}, coordinate, {
	    sectors: sectors,
	    data: pieData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  });
	}, _temp)) || _class;
	
	var _default = Pie;
	exports.default = _default;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _DataUtils = __webpack_require__(40);
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _PolarUtils = __webpack_require__(93);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _Polygon = _interopRequireDefault(__webpack_require__(344));
	
	var _Dot = _interopRequireDefault(__webpack_require__(162));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Radar = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Radar, _Component);
	
	  function Radar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	    };
	
	    _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    };
	
	    _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Radar, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          dataKey = _this$props2.dataKey;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, baseProps, customDotProps, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-radar-dots"
	      }, dots);
	    }
	  }, {
	    key: "renderPolygonStatically",
	    value: function renderPolygonStatically(points) {
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          dot = _this$props3.dot;
	      var radar;
	
	      if (_react.default.isValidElement(shape)) {
	        radar = _react.default.cloneElement(shape, _objectSpread({}, this.props, {
	          points: points
	        }));
	      } else if ((0, _isFunction2.default)(shape)) {
	        radar = shape(_objectSpread({}, this.props, {
	          points: points
	        }));
	      } else {
	        radar = _react.default.createElement(_Polygon.default, _extends({}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave
	        }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          points: points
	        }));
	      }
	
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-radar-polygon"
	      }, radar, dot ? this.renderDots(points) : null);
	    }
	  }, {
	    key: "renderPolygonWithAnimation",
	    value: function renderPolygonWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react.default.createElement(_reactSmooth.default, {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.cx, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.cy, entry.y);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t)
	          });
	        });
	        return _this3.renderPolygonStatically(stepData);
	      });
	    }
	  }, {
	    key: "renderPolygon",
	    value: function renderPolygon() {
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2.default)(prevPoints, points))) {
	        return this.renderPolygonWithAnimation();
	      }
	
	      return this.renderPolygonStatically(points);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          className = _this$props6.className,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames.default)('recharts-radar', className);
	      return _react.default.createElement(_Layer.default, {
	        className: layerClass
	      }, this.renderPolygon(), (!isAnimationActive || isAnimationFinished) && _LabelList.default.renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react.default.isValidElement(option)) {
	        dotItem = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react.default.createElement(_Dot.default, _extends({}, props, {
	          className: "recharts-radar-dot"
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Radar;
	}(_react.Component), _class2.displayName = 'Radar', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.func]).isRequired,
	  angleAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  radiusAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  points: _propTypes.default.arrayOf(_propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    cx: _propTypes.default.number,
	    cy: _propTypes.default.number,
	    angle: _propTypes.default.number,
	    radius: _propTypes.default.number,
	    value: _propTypes.default.number,
	    payload: _propTypes.default.object
	  })),
	  shape: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	  activeDot: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element, _propTypes.default.func, _propTypes.default.bool]),
	  // whether have dot in poly line
	  dot: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element, _propTypes.default.func, _propTypes.default.bool]),
	  label: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func, _propTypes.default.object, _propTypes.default.bool]),
	  legendType: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes.default.oneOf(_ReactUtils.TOOLTIP_TYPES),
	  hide: _propTypes.default.bool,
	  onMouseEnter: _propTypes.default.func,
	  onMouseLeave: _propTypes.default.func,
	  onClick: _propTypes.default.func,
	  isAnimationActive: _propTypes.default.bool,
	  animationId: _propTypes.default.number,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  hide: false,
	  activeDot: true,
	  dot: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getComposedData = function (_ref2) {
	  var radiusAxis = _ref2.radiusAxis,
	      angleAxis = _ref2.angleAxis,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize;
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var points = displayedData.map(function (entry, i) {
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, angleAxis.dataKey, i);
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var angle = angleAxis.scale(name) + (bandSize || 0);
	    var radius = radiusAxis.scale(value);
	    return _objectSpread({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	      name: name,
	      value: value,
	      cx: cx,
	      cy: cy,
	      radius: radius,
	      angle: angle,
	      payload: entry
	    });
	  });
	  return {
	    points: points
	  };
	}, _temp)) || _class;
	
	var _default = Radar;
	exports.default = _default;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _Sector = _interopRequireDefault(__webpack_require__(345));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _Cell = _interopRequireDefault(__webpack_require__(205));
	
	var _DataUtils = __webpack_require__(40);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RadialBar = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(RadialBar, _Component);
	
	  function RadialBar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadialBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(RadialBar, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "getDeltaAngle",
	    value: function getDeltaAngle() {
	      var _this$props2 = this.props,
	          startAngle = _this$props2.startAngle,
	          endAngle = _this$props2.endAngle;
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	      return sign * deltaAngle;
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          activeShape = _this$props3.activeShape,
	          activeIndex = _this$props3.activeIndex,
	          cornerRadius = _this$props3.cornerRadius,
	          others = _objectWithoutProperties(_this$props3, ["shape", "activeShape", "activeIndex", "cornerRadius"]);
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      return sectors.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, {
	          cornerRadius: cornerRadius
	        }, entry, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-sector',
	          forceCornerRadius: others.forceCornerRadius,
	          cornerIsExternal: others.cornerIsExternal
	        });
	
	        return _this2.constructor.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevData = this.state.prevData;
	      return _react.default.createElement(_reactSmooth.default, {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radialBar-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorStartAngle = (0, _DataUtils.interpolateNumber)(prev.startAngle, entry.startAngle);
	            var interpolatorEndAngle = (0, _DataUtils.interpolateNumber)(prev.endAngle, entry.endAngle);
	            return _objectSpread({}, entry, {
	              startAngle: interpolatorStartAngle(t),
	              endAngle: interpolatorEndAngle(t)
	            });
	          }
	
	          var endAngle = entry.endAngle,
	              startAngle = entry.startAngle;
	          var interpolator = (0, _DataUtils.interpolateNumber)(startAngle, endAngle);
	          return _objectSpread({}, entry, {
	            endAngle: interpolator(t)
	          });
	        });
	        return _react.default.createElement(_Layer.default, null, _this3.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          data = _this$props5.data,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2.default)(prevData, data))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground(sectors) {
	      var _this4 = this;
	
	      var cornerRadius = this.props.cornerRadius;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, background, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this4.constructor.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          data = _this$props6.data,
	          className = _this$props6.className,
	          background = _this$props6.background,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames.default)('recharts-area', className);
	      return _react.default.createElement(_Layer.default, {
	        className: layerClass
	      }, background && _react.default.createElement(_Layer.default, {
	        className: "recharts-radial-bar-background"
	      }, this.renderBackground(data)), _react.default.createElement(_Layer.default, {
	        className: "recharts-radial-bar-sectors"
	      }, this.renderSectors(data)), (!isAnimationActive || isAnimationFinished) && _LabelList.default.renderCallByParent(_objectSpread({}, this.props, {
	        clockWise: this.getDeltaAngle() < 0
	      }), data));
	    }
	  }], [{
	    key: "renderSectorShape",
	    value: function renderSectorShape(shape, props) {
	      var sectorShape;
	
	      if (_react.default.isValidElement(shape)) {
	        sectorShape = _react.default.cloneElement(shape, props);
	      } else if ((0, _isFunction2.default)(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react.default.createElement(_Sector.default, props);
	      }
	
	      return sectorShape;
	    }
	  }]);
	
	  return RadialBar;
	}(_react.Component), _class2.displayName = 'RadialBar', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  angleAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  radiusAxisId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  shape: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
	  activeShape: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.element]),
	  activeIndex: _propTypes.default.number,
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]).isRequired,
	  cornerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  forceCornerRadius: _propTypes.default.bool,
	  cornerIsExternal: _propTypes.default.bool,
	  minPointSize: _propTypes.default.number,
	  maxBarSize: _propTypes.default.number,
	  data: _propTypes.default.arrayOf(_propTypes.default.shape({
	    cx: _propTypes.default.number,
	    cy: _propTypes.default.number,
	    innerRadius: _propTypes.default.number,
	    outerRadius: _propTypes.default.number,
	    value: _propTypes.default.value
	  })),
	  legendType: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes.default.oneOf(_ReactUtils.TOOLTIP_TYPES),
	  label: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.element, _propTypes.default.object]),
	  background: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.object, _propTypes.default.element]),
	  hide: _propTypes.default.bool,
	  onMouseEnter: _propTypes.default.func,
	  onMouseLeave: _propTypes.default.func,
	  onClick: _propTypes.default.func,
	  isAnimationActive: _propTypes.default.bool,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	}), _class2.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  minPointSize: 0,
	  hide: false,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  forceCornerRadius: false,
	  cornerIsExternal: false
	}, _class2.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      props = _ref2.props,
	      radiusAxis = _ref2.radiusAxis,
	      radiusAxisTicks = _ref2.radiusAxisTicks,
	      angleAxis = _ref2.angleAxis,
	      angleAxisTicks = _ref2.angleAxisTicks,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      dataStartIndex = _ref2.dataStartIndex;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var layout = props.layout;
	  var _item$props = item.props,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell.default);
	  var sectors = displayedData.map(function (entry, index) {
	    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'radial') {
	      innerRadius = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: radiusAxis,
	        ticks: radiusAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = angleAxis.scale(value[1]);
	      startAngle = angleAxis.scale(value[0]);
	      outerRadius = innerRadius + pos.size;
	      var deltaAngle = endAngle - startAngle;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
	        endAngle += delta;
	      }
	
	      backgroundSector = {
	        background: {
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: props.startAngle,
	          endAngle: props.endAngle
	        }
	      };
	    } else {
	      innerRadius = radiusAxis.scale(value[0]);
	      outerRadius = radiusAxis.scale(value[1]);
	      startAngle = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: angleAxis,
	        ticks: angleAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = startAngle + pos.size;
	      var deltaRadius = outerRadius - innerRadius;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
	
	        outerRadius += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, backgroundSector, {
	      payload: entry,
	      value: stackedData ? value : value[1],
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    }, cells && cells[index] && cells[index].props);
	  });
	  return {
	    data: sectors,
	    layout: layout
	  };
	}, _temp)) || _class;
	
	var _default = RadialBar;
	exports.default = _default;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _DataUtils = __webpack_require__(40);
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Cross = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Cross, _Component);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Cross).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          top = _this$props.top,
	          left = _this$props.left,
	          className = _this$props.className;
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react.default.createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames.default)('recharts-cross', className),
	        d: this.constructor.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }], [{
	    key: "getPath",
	    value: function getPath(x, y, width, height, top, left) {
	      return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
	    }
	  }]);
	
	  return Cross;
	}(_react.Component), _class2.displayName = 'Cross', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes.default.number,
	  y: _propTypes.default.number,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  top: _propTypes.default.number,
	  left: _propTypes.default.number,
	  className: _propTypes.default.string
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	}, _temp)) || _class;
	
	var _default = Cross;
	exports.default = _default;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
	  var widthGap = upperWidth - lowerWidth;
	  var path;
	  path = "M ".concat(x, ",").concat(y);
	  path += "L ".concat(x + upperWidth, ",").concat(y);
	  path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
	  path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
	  path += "L ".concat(x, ",").concat(y, " Z");
	  return path;
	};
	
	var Trapezoid = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Trapezoid, _Component);
	
	  function Trapezoid() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Trapezoid);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Trapezoid)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Trapezoid, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          upperWidth = _this$props.upperWidth,
	          lowerWidth = _this$props.lowerWidth,
	          height = _this$props.height,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames.default)('recharts-trapezoid', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react.default.createElement("g", null, _react.default.createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
	        })));
	      }
	
	      return _react.default.createElement(_reactSmooth.default, {
	        canBegin: totalLength > 0,
	        from: {
	          upperWidth: 0,
	          lowerWidth: 0,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          upperWidth: upperWidth,
	          lowerWidth: lowerWidth,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currUpperWidth = _ref.upperWidth,
	            currLowerWidth = _ref.lowerWidth,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react.default.createElement(_reactSmooth.default, {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          easing: animationEasing
	        }, _react.default.createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Trapezoid;
	}(_react.Component), _class2.displayName = 'Trapezoid', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes.default.string,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number,
	  upperWidth: _propTypes.default.number,
	  lowerWidth: _propTypes.default.number,
	  height: _propTypes.default.number,
	  isUpdateAnimationActive: _propTypes.default.bool,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  upperWidth: 0,
	  lowerWidth: 0,
	  height: 0,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp)) || _class;
	
	var _default = Trapezoid;
	exports.default = _default;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(3083);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(3082);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Redux middleware for calling an API
	 * @module redux-api-middleware
	 * @requires isomorphic-fetch
	 * @requires lodash.isplainobject
	 * @exports {symbol} CALL_API
	 * @exports {function} isRSAA
	 * @exports {function} validateRSAA
	 * @exports {function} isValidRSAA
	 * @exports {error} InvalidRSAA
	 * @exports {error} InternalError
	 * @exports {error} RequestError
	 * @exports {error} ApiError
	 * @exports {function} getJSON
	 * @exports {ReduxMiddleWare} apiMiddleware
	 */
	
	/**
	 * @typedef {function} ReduxMiddleware
	 * @param {object} store
	 * @returns {ReduxNextHandler}
	 *
	 * @typedef {function} ReduxNextHandler
	 * @param {function} next
	 * @returns {ReduxActionHandler}
	 *
	 * @typedef {function} ReduxActionHandler
	 * @param {object} action
	 * @returns undefined
	 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(492)['default'];
	
	exports.__esModule = true;
	
	var _CALL_API = __webpack_require__(490);
	
	var _CALL_API2 = _interopRequireDefault(_CALL_API);
	
	var _validation = __webpack_require__(1011);
	
	var _errors = __webpack_require__(491);
	
	var _util = __webpack_require__(1010);
	
	var _middleware = __webpack_require__(3087);
	
	exports.CALL_API = _CALL_API2['default'];
	exports.isRSAA = _validation.isRSAA;
	exports.validateRSAA = _validation.validateRSAA;
	exports.isValidRSAA = _validation.isValidRSAA;
	exports.InvalidRSAA = _errors.InvalidRSAA;
	exports.InternalError = _errors.InternalError;
	exports.RequestError = _errors.RequestError;
	exports.ApiError = _errors.ApiError;
	exports.getJSON = _util.getJSON;
	exports.apiMiddleware = _middleware.apiMiddleware;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(1016)['default'];
	
	var _regeneratorRuntime = __webpack_require__(1017)['default'];
	
	var _Promise = __webpack_require__(1014)['default'];
	
	exports.__esModule = true;
	
	var _errors = __webpack_require__(491);
	
	/**
	 * Extract JSON body from a server response
	 *
	 * @function getJSON
	 * @access public
	 * @param {object} res - A raw response object
	 * @returns {promise|undefined}
	 */
	function getJSON(res) {
	  var contentType, emptyCodes;
	  return _regeneratorRuntime.async(function getJSON$(context$1$0) {
	    while (1) switch (context$1$0.prev = context$1$0.next) {
	      case 0:
	        contentType = res.headers.get('Content-Type');
	        emptyCodes = [204, 205];
	
	        if (!(! ~emptyCodes.indexOf(res.status) && contentType && ~contentType.indexOf('json'))) {
	          context$1$0.next = 8;
	          break;
	        }
	
	        context$1$0.next = 5;
	        return _regeneratorRuntime.awrap(res.json());
	
	      case 5:
	        return context$1$0.abrupt('return', context$1$0.sent);
	
	      case 8:
	        context$1$0.next = 10;
	        return _regeneratorRuntime.awrap(_Promise.resolve());
	
	      case 10:
	        return context$1$0.abrupt('return', context$1$0.sent);
	
	      case 11:
	      case 'end':
	        return context$1$0.stop();
	    }
	  }, null, this);
	}
	
	/**
	 * Blow up string or symbol types into full-fledged type descriptors,
	 *   and add defaults
	 *
	 * @function normalizeTypeDescriptors
	 * @access private
	 * @param {array} types - The [CALL_API].types from a validated RSAA
	 * @returns {array}
	 */
	function normalizeTypeDescriptors(types) {
	  var requestType = types[0];
	  var successType = types[1];
	  var failureType = types[2];
	
	  if (typeof requestType === 'string' || typeof requestType === 'symbol') {
	    requestType = { type: requestType };
	  }
	
	  if (typeof successType === 'string' || typeof successType === 'symbol') {
	    successType = { type: successType };
	  }
	  successType = _extends({
	    payload: function payload(action, state, res) {
	      return getJSON(res);
	    }
	  }, successType);
	
	  if (typeof failureType === 'string' || typeof failureType === 'symbol') {
	    failureType = { type: failureType };
	  }
	  failureType = _extends({
	    payload: function payload(action, state, res) {
	      return getJSON(res).then(function (json) {
	        return new _errors.ApiError(res.status, res.statusText, json);
	      });
	    }
	  }, failureType);
	
	  return [requestType, successType, failureType];
	}
	
	/**
	 * Evaluate a type descriptor to an FSA
	 *
	 * @function actionWith
	 * @access private
	 * @param {object} descriptor - A type descriptor
	 * @param {array} args - The array of arguments for `payload` and `meta` function properties
	 * @returns {object}
	 */
	function actionWith(descriptor, args) {
	  return _regeneratorRuntime.async(function actionWith$(context$1$0) {
	    while (1) switch (context$1$0.prev = context$1$0.next) {
	      case 0:
	        context$1$0.prev = 0;
	        context$1$0.next = 3;
	        return _regeneratorRuntime.awrap(typeof descriptor.payload === 'function' ? descriptor.payload.apply(descriptor, args) : descriptor.payload);
	
	      case 3:
	        descriptor.payload = context$1$0.sent;
	        context$1$0.next = 10;
	        break;
	
	      case 6:
	        context$1$0.prev = 6;
	        context$1$0.t0 = context$1$0['catch'](0);
	
	        descriptor.payload = new _errors.InternalError(context$1$0.t0.message);
	        descriptor.error = true;
	
	      case 10:
	        context$1$0.prev = 10;
	        context$1$0.next = 13;
	        return _regeneratorRuntime.awrap(typeof descriptor.meta === 'function' ? descriptor.meta.apply(descriptor, args) : descriptor.meta);
	
	      case 13:
	        descriptor.meta = context$1$0.sent;
	        context$1$0.next = 21;
	        break;
	
	      case 16:
	        context$1$0.prev = 16;
	        context$1$0.t1 = context$1$0['catch'](10);
	
	        delete descriptor.meta;
	        descriptor.payload = new _errors.InternalError(context$1$0.t1.message);
	        descriptor.error = true;
	
	      case 21:
	        return context$1$0.abrupt('return', descriptor);
	
	      case 22:
	      case 'end':
	        return context$1$0.stop();
	    }
	  }, null, this, [[0, 6], [10, 16]]);
	}
	
	exports.getJSON = getJSON;
	exports.normalizeTypeDescriptors = normalizeTypeDescriptors;
	exports.actionWith = actionWith;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(492)['default'];
	
	exports.__esModule = true;
	
	var _CALL_API = __webpack_require__(490);
	
	var _CALL_API2 = _interopRequireDefault(_CALL_API);
	
	var _lodashIsplainobject = __webpack_require__(1519);
	
	var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);
	
	/**
	 * Is the given action a plain JavaScript object with a [CALL_API] property?
	 *
	 * @function isRSAA
	 * @access public
	 * @param {object} action - The action to check
	 * @returns {boolean}
	 */
	function isRSAA(action) {
	  return _lodashIsplainobject2['default'](action) && action.hasOwnProperty(_CALL_API2['default']);
	}
	
	/**
	 * Is the given object a valid type descriptor?
	 *
	 * @function isValidTypeDescriptor
	 * @access private
	 * @param {object} obj - The object to check agains the type descriptor definition
	 * @returns {boolean}
	 */
	function isValidTypeDescriptor(obj) {
	  var validKeys = ['type', 'payload', 'meta'];
	
	  if (!_lodashIsplainobject2['default'](obj)) {
	    return false;
	  }
	  for (var key in obj) {
	    if (! ~validKeys.indexOf(key)) {
	      return false;
	    }
	  }
	  if (!('type' in obj)) {
	    return false;
	  } else if (typeof obj.type !== 'string' && typeof obj.type !== 'symbol') {
	    return false;
	  }
	
	  return true;
	}
	
	/**
	 * Checks an action against the RSAA definition, returning a (possibly empty)
	 * array of validation errors.
	 *
	 * @function validateRSAA
	 * @access public
	 * @param {object} action - The action to check against the RSAA definition
	 * @returns {array}
	 */
	function validateRSAA(action) {
	  var validationErrors = [];
	  var validCallAPIKeys = ['endpoint', 'method', 'body', 'headers', 'credentials', 'bailout', 'types'];
	  var validMethods = ['GET', 'HEAD', 'POST', 'PUT', 'PATCH', 'DELETE', 'OPTIONS'];
	  var validCredentials = ['omit', 'same-origin', 'include'];
	
	  if (!isRSAA(action)) {
	    validationErrors.push('RSAAs must be plain JavaScript objects with a [CALL_API] property');
	    return validationErrors;
	  }
	
	  for (var key in action) {
	    if (key !== [_CALL_API2['default']]) {
	      validationErrors.push('Invalid root key: ' + key);
	    }
	  }
	
	  var callAPI = action[_CALL_API2['default']];
	  if (!_lodashIsplainobject2['default'](callAPI)) {
	    validationErrors.push('[CALL_API] property must be a plain JavaScript object');
	  }
	  for (var key in callAPI) {
	    if (! ~validCallAPIKeys.indexOf(key)) {
	      validationErrors.push('Invalid [CALL_API] key: ' + key);
	    }
	  }
	
	  var endpoint = callAPI.endpoint;
	  var method = callAPI.method;
	  var headers = callAPI.headers;
	  var credentials = callAPI.credentials;
	  var types = callAPI.types;
	  var bailout = callAPI.bailout;
	
	  if (typeof endpoint === 'undefined') {
	    validationErrors.push('[CALL_API] must have an endpoint property');
	  } else if (typeof endpoint !== 'string' && typeof endpoint !== 'function') {
	    validationErrors.push('[CALL_API].endpoint property must be a string or a function');
	  }
	  if (typeof method === 'undefined') {
	    validationErrors.push('[CALL_API] must have a method property');
	  } else if (typeof method !== 'string') {
	    validationErrors.push('[CALL_API].method property must be a string');
	  } else if (! ~validMethods.indexOf(method.toUpperCase())) {
	    validationErrors.push('Invalid [CALL_API].method: ' + method.toUpperCase());
	  }
	
	  if (typeof headers !== 'undefined' && !_lodashIsplainobject2['default'](headers) && typeof headers !== 'function') {
	    validationErrors.push('[CALL_API].headers property must be undefined, a plain JavaScript object, or a function');
	  }
	  if (typeof credentials !== 'undefined') {
	    if (typeof credentials !== 'string') {
	      validationErrors.push('[CALL_API].credentials property must be undefined, or a string');
	    } else if (! ~validCredentials.indexOf(credentials)) {
	      validationErrors.push('Invalid [CALL_API].credentials: ' + credentials);
	    }
	  }
	  if (typeof bailout !== 'undefined' && typeof bailout !== 'boolean' && typeof bailout !== 'function') {
	    validationErrors.push('[CALL_API].bailout property must be undefined, a boolean, or a function');
	  }
	
	  if (typeof types === 'undefined') {
	    validationErrors.push('[CALL_API] must have a types property');
	  } else if (!Array.isArray(types) || types.length !== 3) {
	    validationErrors.push('[CALL_API].types property must be an array of length 3');
	  } else {
	    var requestType = types[0];
	    var successType = types[1];
	    var failureType = types[2];
	
	    if (typeof requestType !== 'string' && typeof requestType !== 'symbol' && !isValidTypeDescriptor(requestType)) {
	      validationErrors.push('Invalid request type');
	    }
	    if (typeof successType !== 'string' && typeof successType !== 'symbol' && !isValidTypeDescriptor(successType)) {
	      validationErrors.push('Invalid success type');
	    }
	    if (typeof failureType !== 'string' && typeof failureType !== 'symbol' && !isValidTypeDescriptor(failureType)) {
	      validationErrors.push('Invalid failure type');
	    }
	  }
	
	  return validationErrors;
	}
	
	/**
	 * Is the given action a valid RSAA?
	 *
	 * @function isValidRSAA
	 * @access public
	 * @param {object} action - The action to check against the RSAA definition
	 * @returns {boolean}
	 */
	function isValidRSAA(action) {
	  return !validateRSAA(action).length;
	}
	
	exports.isRSAA = isRSAA;
	exports.isValidTypeDescriptor = isValidTypeDescriptor;
	exports.validateRSAA = validateRSAA;
	exports.isValidRSAA = isValidRSAA;

/***/ },
/* 1012 */
[3143, 3093],
/* 1013 */
[3144, 3094],
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(3095), __esModule: true };

/***/ },
/* 1015 */
[3145, 3096],
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(3088)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(3091);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	module.exports = { "default": module.exports, __esModule: true };
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(252)
	  , TAG = __webpack_require__(94)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(252);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(498)
	  , $export        = __webpack_require__(254)
	  , redefine       = __webpack_require__(500)
	  , hide           = __webpack_require__(497)
	  , has            = __webpack_require__(496)
	  , Iterators      = __webpack_require__(255)
	  , $iterCreate    = __webpack_require__(3107)
	  , setToStringTag = __webpack_require__(349)
	  , getProto       = __webpack_require__(76).getProto
	  , ITERATOR       = __webpack_require__(94)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(76).getDesc
	  , isObject = __webpack_require__(348)
	  , anObject = __webpack_require__(209);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(253)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(116)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 1023 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 1024 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 1025 */
/***/ function(module, exports) {



/***/ },
/* 1026 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(3137);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 1028 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 1029 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1030 */
/***/ function(module, exports) {

	"use strict";
	/*
	 inspired from
	 https://raw.githubusercontent.com/github/url-polyfill/master/url.js
	 and https://stackoverflow.com/questions/6168260/how-to-parse-a-url
	*/
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIterator;
	if (Symbol && Symbol.iterator && (typeof ([][Symbol.iterator]) === 'function')) {
	    createIterator = function (items) {
	        return items[Symbol.iterator]();
	    };
	}
	else {
	    createIterator = function (items) {
	        return {
	            next: function () {
	                var value = items.shift();
	                return { done: value === void 0, value: value };
	            }
	        };
	    };
	}
	var URLSearchParams = /** @class */ (function () {
	    function URLSearchParams(init) {
	        var _this = this;
	        this._entries = {};
	        if (typeof init === 'string') {
	            if (init !== '') {
	                init = init.replace(/^\?/, '');
	                var attributes = init.split('&');
	                var attribute = void 0;
	                for (var i = 0; i < attributes.length; i++) {
	                    attribute = attributes[i].split('=');
	                    this.append(decodeURIComponent(attribute[0]), (attribute.length > 1) ? decodeURIComponent(attribute[1]) : '');
	                }
	            }
	        }
	        else if (init instanceof URLSearchParams) {
	            init.forEach(function (value, name) {
	                _this.append(value, name);
	            });
	        }
	    }
	    URLSearchParams.prototype.append = function (name, value) {
	        value = value.toString();
	        if (name in this._entries) {
	            this._entries[name].push(value);
	        }
	        else {
	            this._entries[name] = [value];
	        }
	    };
	    URLSearchParams.prototype.delete = function (name) {
	        delete this._entries[name];
	    };
	    URLSearchParams.prototype.get = function (name) {
	        return (name in this._entries) ? this._entries[name][0] : null;
	    };
	    URLSearchParams.prototype.getAll = function (name) {
	        return (name in this._entries) ? this._entries[name].slice(0) : [];
	    };
	    URLSearchParams.prototype.has = function (name) {
	        return (name in this._entries);
	    };
	    URLSearchParams.prototype.set = function (name, value) {
	        this._entries[name] = [value.toString()];
	    };
	    URLSearchParams.prototype.forEach = function (callback) {
	        var entries;
	        for (var name_1 in this._entries) {
	            if (this._entries.hasOwnProperty(name_1)) {
	                entries = this._entries[name_1];
	                for (var i = 0; i < entries.length; i++) {
	                    callback.call(this, entries[i], name_1, this);
	                }
	            }
	        }
	    };
	    URLSearchParams.prototype.keys = function () {
	        var items = [];
	        this.forEach(function (value, name) { items.push(name); });
	        return createIterator(items);
	    };
	    URLSearchParams.prototype.values = function () {
	        var items = [];
	        this.forEach(function (value) { items.push(value); });
	        return createIterator(items);
	    };
	    URLSearchParams.prototype.entries = function () {
	        var items = [];
	        this.forEach(function (value, name) { items.push([value, name]); });
	        return createIterator(items);
	    };
	    URLSearchParams.prototype.toString = function () {
	        var searchString = '';
	        this.forEach(function (value, name) {
	            if (searchString.length > 0)
	                searchString += '&';
	            searchString += encodeURIComponent(name) + '=' + encodeURIComponent(value);
	        });
	        return searchString;
	    };
	    return URLSearchParams;
	}());
	exports.URLSearchParams = URLSearchParams;
	var URL = /** @class */ (function () {
	    function URL(url, base) {
	        var baseParts;
	        try {
	            baseParts = URL.parse(base);
	        }
	        catch (e) {
	            throw new Error('Invalid base URL');
	        }
	        var urlParts = URL.parse(url);
	        if (urlParts.protocol) {
	            this._parts = __assign({}, urlParts);
	        }
	        else {
	            this._parts = {
	                protocol: baseParts.protocol,
	                username: baseParts.username,
	                password: baseParts.password,
	                hostname: baseParts.hostname,
	                port: baseParts.port,
	                path: urlParts.path || baseParts.path,
	                query: urlParts.query || baseParts.query,
	                hash: urlParts.hash,
	            };
	        }
	        // console.log(URL.parse(base), URL.parse(url), this._parts);
	    }
	    URL.init = function () {
	        this.URLRegExp = new RegExp('^' + this.patterns.protocol + '?' + this.patterns.authority + '?' + this.patterns.path + this.patterns.query + '?' + this.patterns.hash + '?');
	        this.AuthorityRegExp = new RegExp('^' + this.patterns.authentication + '?' + this.patterns.hostname + this.patterns.port + '?$');
	    };
	    URL.parse = function (url) {
	        var urlMatch = this.URLRegExp.exec(url);
	        if (urlMatch !== null) {
	            var authorityMatch = urlMatch[2] ? this.AuthorityRegExp.exec(urlMatch[2]) : [null, null, null, null, null];
	            if (authorityMatch !== null) {
	                return {
	                    protocol: urlMatch[1] || '',
	                    username: authorityMatch[1] || '',
	                    password: authorityMatch[2] || '',
	                    hostname: authorityMatch[3] || '',
	                    port: authorityMatch[4] || '',
	                    path: urlMatch[3] || '',
	                    query: urlMatch[4] || '',
	                    hash: urlMatch[5] || '',
	                };
	            }
	        }
	        throw new Error('Invalid URL');
	    };
	    Object.defineProperty(URL.prototype, "hash", {
	        get: function () {
	            return this._parts.hash;
	        },
	        set: function (value) {
	            value = value.toString();
	            if (value.length === 0) {
	                this._parts.hash = '';
	            }
	            else {
	                if (value.charAt(0) !== '#')
	                    value = '#' + value;
	                this._parts.hash = encodeURIComponent(value);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "host", {
	        get: function () {
	            return this.hostname + (this.port ? (':' + this.port) : '');
	        },
	        set: function (value) {
	            value = value.toString();
	            var url = new URL('http://' + value);
	            this._parts.hostname = url.hostname;
	            this._parts.port = url.port;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "hostname", {
	        get: function () {
	            return this._parts.hostname;
	        },
	        set: function (value) {
	            value = value.toString();
	            this._parts.hostname = encodeURIComponent(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "href", {
	        get: function () {
	            var authentication = (this.username || this.password) ? (this.username + (this.password ? (':' + this.password) : '') + '@') : '';
	            return this.protocol + '//' + authentication + this.host + this.pathname + this.search + this.hash;
	        },
	        set: function (value) {
	            value = value.toString();
	            var url = new URL(value);
	            this._parts = __assign({}, url._parts);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "origin", {
	        get: function () {
	            return this.protocol + '//' + this.host;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "password", {
	        get: function () {
	            return this._parts.password;
	        },
	        set: function (value) {
	            value = value.toString();
	            this._parts.password = encodeURIComponent(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "pathname", {
	        get: function () {
	            return this._parts.path ? this._parts.path : '/';
	        },
	        set: function (value) {
	            value = value.toString();
	            if ((value.length === 0) || (value.charAt(0) !== '/'))
	                value = '/' + value;
	            this._parts.path = encodeURIComponent(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "port", {
	        get: function () {
	            return this._parts.port;
	        },
	        set: function (value) {
	            var port = parseInt(value);
	            if (isNaN(port)) {
	                this._parts.port = '0';
	            }
	            else {
	                this._parts.port = Math.max(0, port % (Math.pow(2, 16))).toString();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "protocol", {
	        get: function () {
	            return this._parts.protocol + ':';
	        },
	        set: function (value) {
	            value = value.toString();
	            if (value.length !== 0) {
	                if (value.charAt(value.length - 1) === ':') {
	                    value = value.slice(0, -1);
	                }
	                this._parts.protocol = encodeURIComponent(value);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "search", {
	        get: function () {
	            return this._parts.query;
	        },
	        set: function (value) {
	            value = value.toString();
	            if (value.charAt(0) !== '?')
	                value = '?' + value;
	            this._parts.query = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "username", {
	        get: function () {
	            return this._parts.username;
	        },
	        set: function (value) {
	            value = value.toString();
	            this._parts.username = encodeURIComponent(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(URL.prototype, "searchParams", {
	        get: function () {
	            var _this = this;
	            var searchParams = new URLSearchParams(this.search);
	            ['append', 'delete', 'set'].forEach(function (methodName) {
	                var method = searchParams[methodName];
	                searchParams[methodName] = function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    method.apply(searchParams, args);
	                    _this.search = searchParams.toString();
	                };
	            });
	            return searchParams;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    URL.prototype.toString = function () {
	        return this.href;
	    };
	    // createObjectURL(object: any, options?: ObjectURLOptions): string;
	    // revokeObjectURL(url: string): void;
	    URL.patterns = {
	        protocol: '(?:([^:/?#]+):)',
	        authority: '(?://([^/?#]*))',
	        path: '([^?#]*)',
	        query: '(\\?[^#]*)',
	        hash: '(#.*)',
	        authentication: '(?:([^:]*)(?::([^@]*))?@)',
	        hostname: '([^:]+)',
	        port: '(?::(\\d+))',
	    };
	    return URL;
	}());
	exports.URL = URL;
	URL.init();


/***/ },
/* 1031 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob:
	      'FileReader' in self &&
	      'Blob' in self &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = self.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.onabort = function() {
	        reject(new exports.DOMException('Aborted', 'AbortError'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!self.fetch) {
	    self.fetch = fetch;
	    self.Headers = Headers;
	    self.Request = Request;
	    self.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1033 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 1034 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ },
/* 1035 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 1036 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 1037 */
/***/ function(module, exports) {

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	module.exports = _inherits;

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(1036);
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread;

/***/ },
/* 1039 */
/***/ function(module, exports) {

	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(503);
	
	var assertThisInitialized = __webpack_require__(1033);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ },
/* 1041 */
/***/ function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(1041);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(39);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(1042);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback, option) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    var _ret = (function () {
	      var useCapture = false;
	      if (typeof option === 'object') {
	        useCapture = option.capture || false;
	      } else if (typeof option === 'boolean') {
	        useCapture = option;
	      }
	
	      target.addEventListener(eventType, wrapCallback, option || false);
	
	      return {
	        v: {
	          remove: function remove() {
	            target.removeEventListener(eventType, wrapCallback, useCapture);
	          }
	        }
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 1044 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(18);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _endsWith = __webpack_require__(1635);
	
	var _endsWith2 = _interopRequireDefault(_endsWith);
	
	var _MainNav = __webpack_require__(1169);
	
	var _MainNav2 = _interopRequireDefault(_MainNav);
	
	var _LocalStorage = __webpack_require__(1168);
	
	var _LocalStorage2 = _interopRequireDefault(_LocalStorage);
	
	var _HomeNav = __webpack_require__(1171);
	
	var _HomeNav2 = _interopRequireDefault(_HomeNav);
	
	var _Dashboard = __webpack_require__(534);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _utility = __webpack_require__(14);
	
	var _reactIdleTimer = __webpack_require__(2977);
	
	var _reactIdleTimer2 = _interopRequireDefault(_reactIdleTimer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: "gotoOptimize",
	    value: function gotoOptimize() {
	      if (this.props.optimizeUserDetail && this.props.optimizeUserDetail.baroUser) {
	        var optimizeHost = window.location.hostname.indexOf("audienceanywhere.com") >= 0 ? "https://optimize-" + window.location.hostname : "https://optimize-qa.audienceanywhere.com";
	        optimizeHost = optimizeHost.replace("optimize-app", "optimize");
	
	        var token = localStorage.getItem("aa_access_token");
	        window.location.replace(optimizeHost + "?token=" + token.replace("Bearer ", ""));
	      } else {
	        window.location.replace("/login");
	      }
	    }
	  }, {
	    key: "redirectIdo",
	    value: function redirectIdo() {
	      if (this.props.optimizeUserDetail && !(0, _endsWith2.default)(window.location.href, "/myProfile")) {
	        if (this.props.optimizeUserDetail && this.props.optimizeUserDetail.aaUser && parseInt(this.props.optimizeUserDetail.aaUser.subscriptionTierId, 10) === 5) {
	          this.gotoOptimize();
	        }
	        if (this.props.loginUserDetail && this.props.loginUserDetail.baroUid && !this.props.optimizeUserDetail && this.props.loadingOptimizeUserDetail === false) {
	          this.gotoOptimize();
	        }
	      } else if (!this.props.optimizeUserDetail) {
	        if (this.props.loadingOptimizeUserDetail === false) {
	          if (true) {
	            var optimizeHost = window.location.hostname.indexOf("audienceanywhere.com") >= 0 ? "https://optimize-" + window.location.hostname : "https://optimize-qa.audienceanywhere.com";
	            optimizeHost = optimizeHost.replace("optimize-app", "optimize");
	
	            var token = localStorage.getItem("aa_access_token");
	            window.location.replace(optimizeHost + "?token=" + token.replace("Bearer ", ""));
	            console.log(this.props);
	          }
	        }
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if ((0, _lodash.isObject)(this.session) /*&& window.localStorage.getItem("session")*/) {
	          this.props.mountSession(this.session);
	          //this.props.getUserClients(this.session.userId)
	          if (!/(\/create-internal-account|\/create-client-account|\/create-business-unit-member-account)/g.test(this.props.location.path)) {
	            this.props.getCurrentUserClients();
	          }
	          if (!this.props.demoAttributes) {
	            // console.log(getUrlParameterByName("cid"));
	            this.props.loadAttributes((0, _utility.getUrlParameterByName)("cid"));
	          }
	          //this.props.validateSession();
	        } else {
	        this.session = {};
	
	        if (this.isLoginRequired(this.props.location.path)) {
	          var redirectUrl = window.location.pathname + window.location.search + window.location.hash;
	          window.location.replace("login?redirect=" + encodeURIComponent(redirectUrl));
	        }
	      }
	      this.redirectIdo();
	
	      setInterval(function () {
	        this.props.getAPIBuildNumber();
	        this.activeAction();
	      }.bind(this), 600000);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.token && this.props.location.path && this.isLoginRequired(this.props.location.path)) {
	        window.location.replace("/login");
	      }
	      this.redirectIdo();
	    }
	  }, {
	    key: "isLoginRequired",
	    value: function isLoginRequired(url) {
	      return !(/(\/create-internal-account|\/create-client-account|\/create-business-unit-member-account)/g.test(url) || /\/login/g.test(url) || /\/resetpassword/g.test(url) || /\/changepassword/g.test(url));
	    }
	  }, {
	    key: "retrieveSession",
	    value: function retrieveSession(session) {
	      this.session = JSON.parse(session);
	    }
	  }, {
	    key: "requireLogin",
	    value: function requireLogin() {
	      //return !(this.props.token && this.props.tokenExpirationTime > moment().valueOf());
	      //TODO:
	      return !(this.props.token && this.props.tokenExpirationTime > (0, _moment2.default)().valueOf());
	    }
	  }, {
	    key: "handleLoginSubmit",
	    value: function handleLoginSubmit(email, password) {
	      this.props.handleLoginSubmit(email, password);
	    }
	  }, {
	    key: "handleLoginClose",
	    value: function handleLoginClose() {
	      this.props.handleLoginClose();
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      // only return content if token is defined
	      if (!this.requireLogin()) {
	        return _react2.default.createElement(_Dashboard2.default, null);
	      }
	
	      return undefined;
	    }
	  }, {
	    key: "getTokenAfterLogin",
	    value: function getTokenAfterLogin() {
	      if (this.props.token) {
	        return {
	          key: "session",
	          val: {
	            loginTime: new Date(),
	            token: this.props.token,
	            userId: this.props.userId,
	            roleId: this.props.roleId,
	            roleName: this.props.roleName,
	            tokenExpirationTime: this.props.tokenExpirationTime,
	            apiBuildNumber: this.props.apiBuildNumber
	          }
	        };
	      }
	      return null;
	    }
	  }, {
	    key: "activeAction",
	    value: function activeAction() {
	      if (this.isLoginRequired(this.props.location.path)) {
	        if (this.requireLogin() || this.session.apiBuildNumber !== this.props.apiBuildNumber) this.idleAction();
	      }
	    }
	  }, {
	    key: "idleAction",
	    value: function idleAction() {
	      this.props.handleLogout();
	      setTimeout(function () {
	        window.location.replace("/login");
	      }, 1000);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var needsLogin = false;
	      if (this.isLoginRequired(this.props.location.path)) {
	        if (this.session && this.props && !(0, _lodash.isNil)(this.session.apiBuildNumber) && this.session.apiBuildNumber !== this.props.apiBuildNumber) needsLogin = true;else needsLogin = (0, _lodash.isNil)(this.props.token) && (0, _lodash.isObject)(this.session);
	
	        if (needsLogin === true) {
	          this.idleAction();
	        }
	      }
	
	      var timeout = 60000 * 60; // 60 minutes
	      var displayToolbar = !(/^\/login/g.test(this.props.location.path) || /^\/resetpassword/g.test(this.props.location.path) || /^\/changepassword/g.test(this.props.location.path));
	      return _react2.default.createElement(
	        _reactIdleTimer2.default,
	        {
	          ref: "idleTimer",
	          element: document,
	          activeAction: this.activeAction.bind(this),
	          idleAction: this.idleAction.bind(this),
	          timeout: timeout,
	          format: "MM-DD-YYYY HH:MM:ss.SSS"
	        },
	        _react2.default.createElement(
	          "div",
	          { id: "AcquireAnywhere" },
	          displayToolbar && _react2.default.createElement(_MainNav2.default, this.props),
	          displayToolbar && _react2.default.createElement(_HomeNav2.default, this.props),
	          _react2.default.createElement(
	            "div",
	            { id: "AcquireAnywhereMain" },
	            this.props.children
	          ),
	          _react2.default.createElement(_LocalStorage2.default, {
	            retrieve: "session",
	            onRetrieve: this.retrieveSession.bind(this),
	            store: this.getTokenAfterLogin()
	          })
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(38);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _ValuePanel = __webpack_require__(352);
	
	var _ValuePanel2 = _interopRequireDefault(_ValuePanel);
	
	var _utility = __webpack_require__(14);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _some = __webpack_require__(153);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoMakePanel = function (_Component) {
	  _inherits(AutoMakePanel, _Component);
	
	  function AutoMakePanel(props) {
	    _classCallCheck(this, AutoMakePanel);
	
	    var _this = _possibleConstructorReturn(this, (AutoMakePanel.__proto__ || Object.getPrototypeOf(AutoMakePanel)).call(this, props));
	
	    _this.state = {
	      indexKey: null,
	      selectedVal: null,
	      selectedStates: [],
	      focusItemId: undefined
	    };
	    return _this;
	  }
	
	  _createClass(AutoMakePanel, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.setState({
	        indexKey: null,
	        selectedVal: null,
	        selectedStates: []
	      });
	    }
	  }, {
	    key: "handleModelSelect",
	    value: function handleModelSelect(id, isChecked) {
	      var model = (0, _find2.default)(this.props.models, function (m) {
	        return m.id === id;
	      });
	      this.props.selectModel(model, isChecked);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var displayModels = void 0;
	      if (this.state.indexKey) {
	        var makeName = this.state.selectedVal;
	        displayModels = (0, _filter2.default)(this.props.models, function (m) {
	          return m.label.split(" - ")[0] === makeName;
	        });
	      }
	      var selectedMakeIds = (0, _map2.default)(this.props.selected_make, "id");
	      return _react2.default.createElement(
	        "div",
	        { style: { display: "flex", flexGrow: "1" } },
	        _react2.default.createElement(
	          "div",
	          {
	            key: "geo-state-node-contianer",
	            style: { width: "300px" },
	            className: "light-grey-border"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border",
	              style: { display: "flex", justifyContent: "space-between" }
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Auto Make"
	              )
	            ),
	            _react2.default.createElement("div", { style: { height: "24px" } })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "light-grey-bottom-border mb-10 pb-10 ml-20 mr-20 mt-20" },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Select All",
	              labelStyle: { fontSize: "16px" },
	              iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	              checked: this.props.selected_make.length > 0 && this.props.selected_make.length === this.props.makes.length,
	              onCheck: function onCheck(e, isInputChecked) {
	                _this2.props.selectAllAutoMakes(isInputChecked);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                height: "390px",
	                overflowY: "scroll"
	              }
	            },
	            (0, _map2.default)(this.props.makes, function (data) {
	              var clsName = " ml-10 mr-10";
	              var showMark = (0, _some2.default)(_this2.props.selected_model, function (m) {
	                return m.label.split(" - ")[0] === data.label;
	              });
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: data.label + "_" + data.id,
	                  style: {
	                    color: "#017FB5",
	                    cursor: "pointer",
	                    display: "flex"
	                  },
	                  className: clsName,
	                  onClick: function onClick() {
	                    _this2.setState({
	                      indexKey: data.id,
	                      selectedVal: data.value
	                    });
	                    //if (this.props.getCities) this.props.getCities(data.id);
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "p-10 mr-10",
	                    style: {
	                      background: _this2.state.indexKey === data.id ? "#F5F5F5" : "#FFF",
	                      flexGrow: "1",
	                      display: "flex"
	                    }
	                  },
	                  _react2.default.createElement(_materialUi.Checkbox, {
	                    label: "",
	                    labelStyle: { fontSize: "16px" },
	                    style: { width: "10px" },
	                    iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	                    checked: selectedMakeIds.indexOf(data.id) >= 0,
	                    onCheck: function onCheck(e, isInputChecked) {
	                      _this2.props.selectMake(data, isInputChecked);
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    data.label,
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        display: showMark && selectedMakeIds.indexOf(data.id) < 0 ? "flex" : "none",
	                        paddingTop: "4px"
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "icon-checkmark4 text-orange-400" })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "tree-node-arrow-right" })
	              );
	            })
	          )
	        ),
	        displayModels && _react2.default.createElement(
	          "div",
	          { style: { flexGrow: "1" } },
	          _react2.default.createElement(_ValuePanel2.default, {
	            key: this.state.selectedVal + "_values_panel",
	            displayData: displayModels,
	            selected_segments: (0, _map2.default)(this.props.selected_model, "id"),
	            title: "Model",
	            showFilter: true,
	            onCheck: function onCheck(id, isChecked) {
	              _this2.handleModelSelect(id, isChecked);
	            },
	            granularity: this.props.granularity,
	            disabledAll: selectedMakeIds.indexOf(this.state.indexKey) >= 0
	          })
	        )
	      );
	    }
	  }]);
	
	  return AutoMakePanel;
	}(_react.Component);
	
	exports.default = AutoMakePanel;

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(38);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _utility = __webpack_require__(14);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _intersection = __webpack_require__(668);
	
	var _intersection2 = _interopRequireDefault(_intersection);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _some = __webpack_require__(153);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var geographicText = _react2.default.createElement(
	  "section",
	  null,
	  _react2.default.createElement(
	    "div",
	    { className: "mb-10" },
	    "To select an entire state, select that state's checkbox."
	  ),
	  _react2.default.createElement(
	    "div",
	    null,
	    "To display a state's cities, select that state's row."
	  )
	);
	
	var GeoStatesPanel = function (_Component) {
	  _inherits(GeoStatesPanel, _Component);
	
	  function GeoStatesPanel(props) {
	    _classCallCheck(this, GeoStatesPanel);
	
	    var _this = _possibleConstructorReturn(this, (GeoStatesPanel.__proto__ || Object.getPrototypeOf(GeoStatesPanel)).call(this, props));
	
	    _this.state = {
	      indexKey: null,
	      selectedVal: null,
	      selectedStates: []
	    };
	    return _this;
	  }
	
	  _createClass(GeoStatesPanel, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.setState({
	        indexKey: null,
	        selectedVal: null,
	        selectedStates: []
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        indexKey: null,
	        selectedVal: null,
	        selectedStates: []
	      });
	    }
	  }, {
	    key: "handleCityChange",
	    value: function handleCityChange(selectedItem, cities) {
	      var _this2 = this;
	
	      if (selectedItem.length > 0) {
	        cities.forEach(function (city, index) {
	          if (city.id === selectedItem[0].id) {
	            // compute scrollTop
	            //this.refs.cityUl.scrollTop = index * liHeight;
	            _this2.setState({
	              beSearchedCityId: selectedItem[0].id
	            });
	            _this2.refs.citiesList.scrollTop = index * 40;
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var selectedStateIds = this.props.selected_states ? (0, _map2.default)(this.props.selected_states, function (s) {
	        return s.id;
	      }) : [];
	      var checkStates = this.props.displayData ? (0, _filter2.default)(this.props.displayData, function (state) {
	        return selectedStateIds.indexOf(state.id) >= 0;
	      }) : [];
	
	      var isAllStateCitiesCheck = !(0, _isEmpty2.default)(checkStates) && (0, _some2.default)(checkStates, function (state) {
	        return state.value === _this3.state.selectedVal;
	      });
	
	      var clsName = "mt-10 ml-10 mr-10";
	      var cityStateMode = Boolean(this.props.getCities);
	      var valueList = null;
	      if (cityStateMode) {
	        valueList = this.props.cities;
	      } else {
	        if (this.props.cities) {
	          if (this.props.subTitle === 'COUNTY') {
	            valueList = (0, _filter2.default)(this.props.cities, function (item) {
	              return item.label.endsWith(_this3.state.selectedVal);
	            });
	          }
	          if (this.props.subTitle === 'DMA') {
	            valueList = this.props.cities.filter(function (l) {
	              return l.label.substring(l.label.indexOf(',') + 1, l.label.length).indexOf(_this3.state.selectedVal) >= 0;
	            }).filter(function (item) {
	              return +item.value !== 999;
	            });
	          }
	        }
	      }
	
	      var selectedVal = this.state.selectedVal;
	
	      return _react2.default.createElement(
	        "div",
	        { style: { display: "flex", flexGrow: "1" } },
	        _react2.default.createElement(
	          "div",
	          {
	            key: "geo-state-node-contianer",
	            style: { width: "300px" },
	            className: "light-grey-border"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border",
	              style: { display: "flex", justifyContent: "space-between" }
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                this.props.title
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { height: "24px" } },
	              _react2.default.createElement(
	                _rcTooltip2.default,
	                {
	                  placement: "right",
	                  overlay: geographicText,
	                  arrowContent: _react2.default.createElement("div", { className: "rc-tooltip-arrow-inner" })
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "inline-block",
	                      color: "#1E88E5",
	                      cursor: "pointer"
	                    }
	                  },
	                  _react2.default.createElement(_infoOutline2.default, null)
	                )
	              )
	            )
	          ),
	          this.props.showSelectAll && _react2.default.createElement(
	            "div",
	            { className: "light-grey-bottom-border mb-10 pb-10 ml-20 mr-20 mt-20" },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              label: "Select All",
	              labelStyle: { fontSize: "16px" },
	              iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	              checked: this.props.selected_states.length > 0 && this.props.selected_states.length === this.props.displayData.length,
	              onCheck: function onCheck(e, isInputChecked) {
	                _this3.props.selectAllStates((0, _map2.default)(_this3.props.displayData, function (d) {
	                  return d;
	                }), isInputChecked);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { height: "390px", overflowY: "scroll" } },
	            (0, _map2.default)(this.props.displayData, function (data) {
	              var clsName = " ml-10 mr-10";
	              var countiesInState = _this3.props.subTitle === "COUNTY" && _this3.props.cities ? (0, _filter2.default)(_this3.props.cities, function (item) {
	                return item.label.endsWith(", " + data.value);
	              }) : [];
	              var selectedCountyIdsInState = (0, _intersection2.default)((0, _map2.default)(_this3.props.selected_cities, "id"), (0, _map2.default)(countiesInState, "id"));
	              var hasSelectedCountyInState = selectedCountyIdsInState.length > 0;
	              var allCountiesInStateSelected = countiesInState.length > 0 && selectedCountyIdsInState.length === countiesInState.length;
	              var showMark = (0, _some2.default)(_this3.props.selected_cities, function (city) {
	                if (cityStateMode) return city.state === data.value;
	                if (_this3.props.subTitle === "COUNTY") return city.label.endsWith(", " + data.value);
	                return city.label.indexOf(data.value) >= 0;
	              });
	              var shouldShowMark = _this3.props.subTitle === "COUNTY" ? hasSelectedCountyInState : cityStateMode ? showMark || selectedStateIds.indexOf(data.id) >= 0 : showMark && selectedStateIds.indexOf(data.id) < 0;
	              var dataChecked = selectedStateIds.indexOf(data.id) >= 0;
	              if ((_this3.props.subTitle === "DMA" || _this3.props.subTitle === "COUNTY") && _this3.props.cities) {
	                var vals = (0, _filter2.default)(_this3.props.cities, function (item) {
	                  if (_this3.props.subTitle === "COUNTY") return item.label.endsWith(", " + data.value);
	                  return item.label.indexOf(data.value) >= 0;
	                });
	                if (vals.length > 0) if (_this3.props.subTitle === "State") {
	                  dataChecked = (0, _intersection2.default)((0, _map2.default)(_this3.props.selected_cities, "id"), (0, _map2.default)(vals, "id")).length === vals.length;
	                }
	                if (_this3.props.subTitle === "COUNTY") {
	                  dataChecked = allCountiesInStateSelected;
	                }
	              }
	
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: data.label + "_" + data.id,
	                  style: {
	                    color: "#017FB5",
	                    cursor: "pointer",
	                    display: "flex"
	                  },
	                  className: clsName,
	                  onClick: function onClick() {
	                    _this3.setState({
	                      indexKey: data.id,
	                      selectedVal: data.value
	                    });
	                    if (_this3.props.getCities) _this3.props.getCities(data.id);
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "p-10 mr-10",
	                    style: {
	                      background: _this3.state.indexKey === data.id ? "#F5F5F5" : "#FFF",
	                      flexGrow: "1",
	                      display: "flex"
	                    }
	                  },
	                  _react2.default.createElement(_materialUi.Checkbox, {
	                    label: "",
	                    labelStyle: { fontSize: "16px" },
	                    style: { width: "10px" },
	                    iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	                    checked: dataChecked,
	                    onCheck: function onCheck(e, isInputChecked) {
	                      _this3.props.selectState(data, isInputChecked);
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    data.label
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        display: shouldShowMark ? "flex" : "none",
	                        paddingTop: "4px"
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "icon-checkmark4 text-orange-400" })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "tree-node-arrow-right" })
	              );
	            })
	          )
	        ),
	        this.state.selectedVal && _react2.default.createElement(
	          "div",
	          {
	            key: "geo-state-values-node-contianer",
	            style: { flexGrow: "1" },
	            className: "light-grey-border"
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              this.props.subTitle
	            )
	          ),
	          !this.props.ifLoading && valueList && (this.props.subTitle === "DMA" ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                height: "40px",
	                paddingTop: "10px",
	                background: "rgb(232, 232, 232)",
	                marginLeft: "40px",
	                marginBottom: "20px",
	                marginRight: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              { style: { marginLeft: "10px" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Code"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { style: { marginLeft: "60px" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "DMA"
	              )
	            )
	          ) : _react2.default.createElement(
	            "div",
	            { className: "ml-20 mr-20 mb-10 pb-20 light-grey-bottom-border" },
	            _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	              key: "city_search_box",
	              labelKey: "label",
	              multiple: false,
	              options: this.props.subTitle === "City" ? this.props.cities : valueList,
	              placeholder: this.props.subTitle === "COUNTY" ? "Search Counties" : "Search Cities",
	              onChange: function onChange(selectedItem) {
	                return _this3.handleCityChange(selectedItem, _this3.props.cities);
	              }
	            })
	          )),
	          _react2.default.createElement(
	            "div",
	            {
	              style: { height: "390px", overflowY: "scroll" },
	              ref: "citiesList"
	            },
	            this.props.ifLoading ? _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", paddingTop: "100px" } },
	              "loading..."
	            ) : (0, _map2.default)(valueList, function (city, idx) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: city.label + city.id + "_node",
	                  style: { color: "#017FB5", cursor: "pointer" },
	                  className: clsName
	                },
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: _this3.props.subTitle === "DMA" ? _react2.default.createElement(
	                    "div",
	                    {
	                      style: { display: "flex", paddingLeft: "20px" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { style: { width: "50px" } },
	                      city.value
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { style: { flexGrow: "1" } },
	                      city.label
	                    )
	                  ) : city.label,
	                  labelStyle: {
	                    fontSize: "16px",
	                    background: _this3.state.beSearchedCityId === city.id ? "#C3C3C3" : "#FFF"
	                  },
	                  iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	                  checked: isAllStateCitiesCheck || _this3.props.selected_cities.some(function (item) {
	                    return item.id === city.id;
	                  }),
	                  disabled: isAllStateCitiesCheck,
	                  onCheck: function onCheck(e, isInputChecked) {
	                    _this3.props.selectCity(city, _this3.state.selectedVal, isInputChecked);
	                  }
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return GeoStatesPanel;
	}(_react.Component);
	
	GeoStatesPanel.defaultProps = {
	  showSelectAll: true
	};
	
	exports.default = GeoStatesPanel;

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleMaps = __webpack_require__(243);
	
	var _DrawingManager = __webpack_require__(915);
	
	var _DrawingManager2 = _interopRequireDefault(_DrawingManager);
	
	var _materialUi = __webpack_require__(38);
	
	var _utility = __webpack_require__(14);
	
	var _Grid = __webpack_require__(19);
	
	var _reactGeosuggest = __webpack_require__(913);
	
	var _reactGeosuggest2 = _interopRequireDefault(_reactGeosuggest);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _rcSlider = __webpack_require__(870);
	
	var _rcSlider2 = _interopRequireDefault(_rcSlider);
	
	__webpack_require__(124);
	
	__webpack_require__(594);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(1399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-undef */
	
	var INITIAL_CENTER = { lat: 42.87, lng: -97.38 };
	var radioButtonStyle = {
	  labeStyle: {
	    color: "#EDEDED",
	    fontSize: "0.9em"
	  },
	  inputStyle: {
	    fill: "#EDEDED",
	    height: "16px",
	    width: "16px",
	    marginLeft: "4px",
	    marginRight: "8px",
	    marginTop: "2px"
	  },
	  firstRadioStyle: {
	    width: "35%",
	    float: "left"
	  },
	  secondRadioStyle: {
	    width: "60%",
	    float: "left"
	  }
	};
	
	//reference https://developers.google.com/maps/documentation/geocoding/intro#Types
	var addressTypes = ["street_address", "premise", "subpremise", "airport", "park", "neighborhood", "floor", "point_of_interest", "establishment", "parking", "post_box", "room", "street_number", "bus_station", "train_station", "transit_station"];
	
	var PlotMapPanel = function (_Component) {
	  _inherits(PlotMapPanel, _Component);
	
	  function PlotMapPanel(props) {
	    _classCallCheck(this, PlotMapPanel);
	
	    var _this = _possibleConstructorReturn(this, (PlotMapPanel.__proto__ || Object.getPrototypeOf(PlotMapPanel)).call(this, props));
	
	    _this.overlayComplete = function (e) {
	      var overlay = e.overlay;
	      switch (e.type) {
	        case "circle":
	          var radius = e.overlay.getRadius();
	          var center = e.overlay.getCenter();
	          var c = {
	            center: center,
	            radius: radius,
	            visible: true
	          };
	          _this.setState({
	            circle: c,
	            readyApply: true
	          });
	          break;
	        case "rectangle":
	          var bounds = e.overlay.getBounds();
	          _this.setState({
	            rect: {
	              bounds: bounds,
	              visible: true
	            },
	            readyApply: true
	          });
	          break;
	        //case "polygon":
	        default:
	          _this.setState({
	            polygon: {
	              path: e.overlay.getPath(),
	              visible: true
	            },
	            readyApply: true
	          });
	          break;
	      }
	
	      _this.setState({
	        defaultDrawingMode: null,
	        onDrawing: false
	      });
	      _this.calTotalAudience();
	      _this.applySelect(true);
	      google.maps.event.clearInstanceListeners(overlay);
	      overlay.setMap(null);
	    };
	
	    _this._getPolygonNewPaths = function (polygon) {
	      if (!_this.state.readyApply) _this.setState({
	        readyApply: true
	      });
	
	      var polygonPaths = [];
	      polygon.getArray().forEach(function (path, index) {
	        var line = {
	          lat: path.lat(),
	          lng: path.lng()
	        };
	        polygonPaths.push(line);
	      });
	
	      _this.calTotalAudience();
	      _this.applySelect(true);
	    };
	
	    _this.state = {
	      showDrawingTool: false,
	      defaultDrawingMode: null,
	      circles: [],
	      openReset: false,
	      circle: {
	        center: null,
	        radius: 0,
	        visible: false
	      },
	      rect: {
	        bounds: null,
	        visiable: false
	      },
	      polygon: {
	        path: [],
	        visiable: false
	      },
	      zoom: 4,
	      bounds: null,
	      center: INITIAL_CENTER,
	      audienceCount: {
	        total: 0,
	        email: 0,
	        display: 0,
	        social: 0
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PlotMapPanel, [{
	    key: "onStartDrawing",
	    value: function onStartDrawing(type) {
	      this.setState({
	        circle: {
	          center: null,
	          radius: 0,
	          visible: false
	        },
	        rect: {
	          bounds: null,
	          visiable: false
	        },
	        polygon: {
	          path: [],
	          visiable: false
	        },
	        zoom: this._map.getZoom(),
	        center: this._map.getCenter(),
	        onDrawing: false,
	        readyApply: false
	      });
	      switch (type) {
	        case "circle":
	          this.setState({
	            defaultDrawingMode: google.maps.drawing.OverlayType.CIRCLE
	          });
	          //this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE)
	          break;
	        case "rectangle":
	          this.setState({
	            defaultDrawingMode: google.maps.drawing.OverlayType.RECTANGLE
	          });
	          //this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE)
	          break;
	        //case "polygon":
	        default:
	          this.setState({
	            defaultDrawingMode: google.maps.drawing.OverlayType.POLYGON
	          });
	          //this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON)
	          break;
	      }
	    }
	  }, {
	    key: "handleMapMounted",
	    value: function handleMapMounted(map) {
	      this._map = map;
	    }
	  }, {
	    key: "handleCenterChanged",
	    value: function handleCenterChanged() {
	      var nextCenter = this._map.getCenter();
	      if (nextCenter.equals(new google.maps.LatLng(INITIAL_CENTER))) {
	        return;
	      }
	
	      this.setState({
	        center: nextCenter
	      });
	    }
	  }, {
	    key: "handleZoomChanged",
	    value: function handleZoomChanged() {
	      this.setState({
	        zoom: this._map.getZoom(),
	        center: this._map.getCenter()
	      });
	    }
	  }, {
	    key: "calTotalAudience",
	    value: function calTotalAudience() {
	      var result = { total: 0, email: 0, display: 0, social: 0 };
	      this.setState({
	        audienceCount: result
	      });
	    }
	  }, {
	    key: "handleBoundsChanged",
	    value: function handleBoundsChanged() {
	      this.setState({
	        bounds: this._map.getBounds(),
	        center: this._map.getCenter()
	      });
	    }
	  }, {
	    key: "isAddress",
	    value: function isAddress(suggest) {
	      return suggest && suggest.gmaps && suggest.gmaps.types && addressTypes.findIndex(function (o) {
	        return suggest.gmaps.types.indexOf(o) > -1;
	      }) > -1;
	    }
	  }, {
	    key: "handleSuggestSelect",
	    value: function handleSuggestSelect(suggest) {
	      if (suggest) {
	        var isAddress = this.isAddress(suggest);
	        this.setState({
	          center: suggest.location,
	          updateComponent: true,
	          search_suggest: suggest,
	          radiusVal: null,
	          driveRadiusVal: null,
	          driveTimeVal: null
	        });
	        if (isAddress) {
	          this.setState({
	            marker: {
	              position: {
	                lat: suggest.location.lat,
	                lng: suggest.location.lng
	              },
	              key: "address"
	            }
	          });
	          if (this.state.zoom < 15) this.setState({ zoom: 15 });
	        } else {
	          if (this.state.zoom < 13) this.setState({ zoom: 13 });
	        }
	      }
	    }
	  }, {
	    key: "handleOpenResetDialog",
	    value: function handleOpenResetDialog(e, status) {
	      e.preventDefault();
	      this.setState({
	        openReset: status,
	        resetAnchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "handleStartOverDialog",
	    value: function handleStartOverDialog(e, status) {
	      if (e) {
	        e.preventDefault();
	        this.setState({
	          openStartOver: status,
	          startOverAnchorEl: e.currentTarget
	        });
	      } else {
	        this.setState({
	          openStartOver: status
	        });
	      }
	    }
	  }, {
	    key: "handleAddressStartOverDialog",
	    value: function handleAddressStartOverDialog(e, status) {
	      if (e) {
	        e.preventDefault();
	        this.setState({
	          openAddressStartOver: status,
	          openStartOver: false,
	          addressOpenOverAnchorEl: e.currentTarget
	        });
	      } else {
	        this.setState({
	          openStartOver: false,
	          openAddressStartOver: status
	        });
	      }
	    }
	  }, {
	    key: "clearAllDrawing",
	    value: function clearAllDrawing() {
	      this.setState({
	        circle: {
	          center: null,
	          radius: 0,
	          visible: false
	        },
	        rect: {
	          bounds: null,
	          visiable: false
	        },
	        polygon: {
	          path: [],
	          visiable: false
	        },
	        readyApply: false,
	        onDrawing: false,
	        search_suggest: null,
	        radiusVal: null,
	        driveRadiusVal: null,
	        driveTimeVal: null,
	        audienceCount: { total: 0, email: 0, display: 0, social: 0 },
	        marker: {}
	      });
	      this.props.onApplyChanges({});
	    }
	  }, {
	    key: "updateCircleInfo",
	    value: function updateCircleInfo() {
	      this.setState({
	        circle: {
	          center: this._circle.getCenter(),
	          radius: this._circle.getRadius(),
	          visible: true
	        },
	        readyApply: true
	      });
	      this.calTotalAudience();
	      this.applySelect(true);
	    }
	  }, {
	    key: "updateRectInfo",
	    value: function updateRectInfo() {
	      var bounds = null;
	      try {
	        bounds = this._rectangle.getBounds();
	      } catch (ex) {}
	
	      if (bounds !== null) {
	        this.setState({
	          rect: {
	            bounds: this._rectangle.getBounds(),
	            visible: true
	          },
	          readyApply: true
	        });
	        this.calTotalAudience();
	        this.applySelect(true);
	      }
	    }
	  }, {
	    key: "preparePolygonInfo",
	    value: function preparePolygonInfo() {
	      var _this2 = this;
	
	      google.maps.event.addListener(this._polygon, "set_at", function () {
	        _this2._getPolygonNewPaths(_this2._polygon);
	      });
	      google.maps.event.addListener(this._polygon, "insert_at", function () {
	        _this2._getPolygonNewPaths(_this2._polygon);
	      });
	      google.maps.event.addListener(this._polygon, "remove_at", function () {
	        _this2._getPolygonNewPaths(_this2._polygon);
	      });
	    }
	  }, {
	    key: "updatePolygonInfo",
	    value: function updatePolygonInfo(e) {
	      this.setState({ onDraging: true });
	      this.calTotalAudience();
	      this.applySelect(true);
	      this.setState({ onDraging: false });
	    }
	  }, {
	    key: "handleStartOver",
	    value: function handleStartOver() {
	      this.setState({
	        showDrawingTool: false,
	        defaultDrawingMode: null,
	        onDrawing: false,
	        readyApply: false,
	        width: this.state.width,
	        circles: [],
	        openReset: false,
	        circle: {
	          center: null,
	          radius: 0,
	          visible: false
	        },
	        rect: {
	          bounds: null,
	          visiable: false
	        },
	        polygon: {
	          path: [],
	          visiable: false
	        },
	        zoom: 4,
	        bounds: null,
	        marker: {},
	        search_suggest: null,
	        center: INITIAL_CENTER,
	        audienceCount: {
	          total: 0,
	          email: 0,
	          display: 0,
	          social: 0
	        }
	      });
	      this._geoSuggest.clear();
	      this.props.onApplyChanges({});
	    }
	  }, {
	    key: "applySelect",
	    value: function applySelect(updateCountOnly) {
	      if (this.isAddress(this.state.search_suggest)) {
	        var address = null;
	        this.props.onUpdateAudienceCount(null);
	
	        switch (this.state.drawAddrType) {
	          case "radius":
	            address = {
	              type: "address_radius",
	              addressLabel: this.state.search_suggest.label,
	              center: this.state.search_suggest.location,
	              radius: this.state.radiusVal,
	              zoom: this.state.zoom,
	              audienceCount: this.state.audienceCount
	            };
	            break;
	          //case "drive":
	          default:
	            address = {
	              type: "address_drive",
	              zoom: this.state.zoom,
	              addressLabel: this.state.search_suggest.label,
	              center: this.state.search_suggest.location,
	              driveTime: this.state.driveTimeVal,
	              driveRadius: this.state.driveRadiusVal,
	              audienceCount: this.state.audienceCount
	            };
	            break;
	        }
	        if (address !== null) {
	          if (updateCountOnly) this.props.onUpdateAudienceCount(address);else this.props.onApplyChanges(address);
	        }
	      } else {
	        this.props.onUpdateAudienceCount(null);
	        if (this.state.circle.visible === true) {
	          var circle = {
	            center: this.state.circle.center,
	            radius: this.state.circle.radius,
	            type: "circle",
	            zoom: this.state.zoom,
	            audienceCount: this.state.audienceCount
	          };
	          if (updateCountOnly) this.props.onUpdateAudienceCount(circle);else this.props.onApplyChanges(circle);
	        }
	        if (this.state.rect.visible === true) {
	          var ne = this.state.rect.bounds.getNorthEast();
	          var sw = this.state.rect.bounds.getSouthWest();
	          var rectBound = new google.maps.LatLngBounds(sw, ne);
	          var rectangle = {
	            bounds: this.state.rect.bounds,
	            center: rectBound.getCenter(),
	            type: "rectangle",
	            zoom: this.state.zoom,
	            audienceCount: this.state.audienceCount
	          };
	          if (updateCountOnly) this.props.onUpdateAudienceCount(rectangle);else this.props.onApplyChanges(rectangle);
	        }
	        if (this.state.polygon.visible === true) {
	          var polygonBounds = new google.maps.LatLngBounds();
	          var polygonPath = this._polygon.getPath();
	          polygonPath.forEach(function (element, index) {
	            polygonBounds.extend(element);
	          });
	          var polygon = {
	            path: polygonPath,
	            encode_path: google.maps.geometry.encoding.encodePath(polygonPath),
	            center: polygonBounds.getCenter(), //this._map.getCenter(),
	            type: "polygon",
	            zoom: this.state.zoom,
	            audienceCount: this.state.audienceCount
	          };
	          if (updateCountOnly) this.props.onUpdateAudienceCount(polygon);else this.props.onApplyChanges(polygon);
	        }
	      }
	      if (!updateCountOnly) {
	        this.setState({ readyApply: false, onDraging: false });
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "handleRadioChange",
	    value: function handleRadioChange(e, value) {
	      e.preventDefault();
	      if (this.state.drawAddrType !== value) {
	        this.setState({
	          drawAddrType: value,
	          radiusVal: 0,
	          driveRadiusVal: 0,
	          driveTimeVal: 0,
	          audienceCount: { total: 0, email: 0, display: 0, social: 0 }
	        });
	        this.props.onApplyChanges({});
	      }
	    }
	  }, {
	    key: "_onRadiusAfterChange",
	    value: function _onRadiusAfterChange(value) {
	      if (this.state.readyApply === false) {
	        if (value > 0) {
	          setTimeout(function () {
	            this._map.fitBounds(this._addressCircle.getBounds());
	          }.bind(this), 200);
	          setTimeout(function () {
	            this.applySelect(true);
	            this.setState({
	              readyApply: true
	            });
	          }.bind(this), 200);
	        } else {
	          setTimeout(function () {
	            this.setState({ zoom: 15, readyApply: true });
	          }.bind(this), 200);
	          this.applySelect(true);
	        }
	        this.calTotalAudience();
	      }
	    }
	  }, {
	    key: "_handleRadiusChange",
	    value: function _handleRadiusChange(value) {
	      this.setState({
	        radiusVal: value,
	        readyApply: false
	      });
	    }
	  }, {
	    key: "_handleDriveTimeChange",
	    value: function _handleDriveTimeChange(value) {
	      this.setState({
	        driveTimeVal: value,
	        readyApply: false
	      });
	    }
	  }, {
	    key: "_onDriveTimeAfterChange",
	    value: function _onDriveTimeAfterChange(value) {
	      if (this.state.readyApply === false) {
	        this.calTotalAudience();
	        var radius = (0, _utility.getCityAvgSpeed)(this.state.search_suggest.label) * value / 1000 * 0.6;
	        this.setState({
	          driveTimeVal: value,
	          driveRadiusVal: radius,
	          radiusVal: radius,
	          readyApply: false
	        });
	        if (value > 0) {
	          setTimeout(function () {
	            this._map.fitBounds(this._driveCircle.getBounds());
	          }.bind(this), 200);
	          setTimeout(function () {
	            this.applySelect(true);
	            this.setState({
	              readyApply: true
	            });
	          }.bind(this), 300);
	        } else {
	          setTimeout(function () {
	            this.setState({ zoom: 15, readyApply: true });
	          }.bind(this), 200);
	          this.applySelect(true);
	        }
	      }
	    }
	  }, {
	    key: "_handleClose",
	    value: function _handleClose(e) {
	      e.preventDefault();
	      this.setState({ readyApply: false, onDraging: false });
	
	      setTimeout(function () {
	        this.props.onClose();
	      }.bind(this), 50);
	    }
	  }, {
	    key: "_initMap",
	    value: function _initMap(plottedValue) {
	      this.setState({
	        circle: {
	          center: null,
	          radius: 0,
	          visible: false
	        },
	        rect: {
	          bounds: null,
	          visiable: false
	        },
	        polygon: {
	          path: [],
	          visiable: false
	        },
	        readyApply: false,
	        onDrawing: false,
	        search_suggest: null,
	        radiusVal: null,
	        driveRadiusVal: null,
	        driveTimeVal: null,
	        audienceCount: { total: 0, email: 0, display: 0, social: 0 },
	        marker: {}
	      });
	
	      switch (plottedValue.type) {
	        case "address_radius":
	        case "address_drive":
	          this.setState({
	            center: plottedValue.center,
	            zoom: plottedValue.zoom,
	            updateComponent: true,
	            search_suggest: {
	              gmaps: { types: ["street_address"] },
	              label: plottedValue.addressLabel,
	              location: plottedValue.center
	            },
	            radiusVal: plottedValue.radius,
	            driveTimeVal: plottedValue.driveTime,
	            driveRadiusVal: plottedValue.driveRadius,
	            drawAddrType: plottedValue.type === "address_radius" ? "radius" : "drive"
	          });
	          this.setState({
	            marker: {
	              position: {
	                lat: plottedValue.center.lat,
	                lng: plottedValue.center.lng
	              },
	              key: "address"
	            }
	          });
	          break;
	        case "rectangle":
	          this.setState({
	            center: plottedValue.center,
	            zoom: plottedValue.zoom,
	            rect: {
	              bounds: plottedValue.bounds,
	              visiable: true
	            }
	          });
	          break;
	        case "circle":
	        default:
	          this.setState({
	            center: plottedValue.center,
	            zoom: plottedValue.zoom,
	            circle: {
	              center: plottedValue.center,
	              radius: plottedValue.radius,
	              visiable: true
	            }
	          });
	          break;
	        case "polygon":
	          this.setState({
	            center: plottedValue.center,
	            zoom: plottedValue.zoom,
	            polygon: {
	              path: typeof plottedValue.path === "string" ? google.maps.geometry.encoding.decodePath(plottedValue.path) : plottedValue.path,
	              visiable: true
	            }
	          });
	
	          break;
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var width = document.getElementById("CreateSegment") ? document.getElementById("CreateSegment").clientWidth : null;
	      this.setState({ width: width ? width : 1280 });
	      var plottedValue = this.props.plottedValue;
	
	      if (!(0, _lodash.isEmpty)(plottedValue)) {
	        this._initMap(plottedValue);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.onDraging === true || this.state.onDraging === true) return false;
	
	      return true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var btnStartOver = _react2.default.createElement(
	        _rcTooltip2.default,
	        {
	          visible: this.state.openStartOver,
	          overlayStyle: { zIndex: 9999 },
	          animation: "zoom",
	          onVisibleChange: function onVisibleChange(visible) {
	            return _this3.handleStartOverDialog(null, visible);
	          },
	          trigger: "click",
	          overlay: [_react2.default.createElement(
	            _Grid.FullRow,
	            {
	              key: "so-text-row",
	              className: "text-default no-padding-bottom no-margin-bottom"
	            },
	            "Are you sure you want to start over?",
	            _react2.default.createElement("br", null),
	            "Any selections you have made will not be saved",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ), _react2.default.createElement(
	            _Grid.FullRow,
	            { key: "so-btn-row", className: "no-padding-bottom" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-link btn-sm text-teal-400 mr-20",
	                onClick: function onClick(e) {
	                  _this3.handleStartOverDialog(e, false);
	                }
	              },
	              "Close"
	            ),
	            "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0",
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-aa-default btn-round btn-sm bg-grey text-white ml-20",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this3.handleStartOver();
	                  _this3.handleStartOverDialog(e, false);
	                }
	              },
	              "Yes, reset"
	            )
	          )]
	        },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "btn btn-link no-padding pt-10 ml-10 text-capitalize text-size-small text-white",
	            onClick: function onClick(e) {
	              _this3.handleStartOverDialog(e, true);
	            }
	          },
	          "Start over"
	        )
	      );
	
	      var btnAddressStartOver = _react2.default.createElement(
	        _rcTooltip2.default,
	        {
	          visible: this.state.openAddressStartOver,
	          overlayStyle: { zIndex: 9999 },
	          animation: "zoom",
	          onVisibleChange: function onVisibleChange(visible) {
	            return _this3.handleAddressStartOverDialog(null, visible);
	          },
	          trigger: "click",
	          overlay: [_react2.default.createElement(
	            _Grid.FullRow,
	            {
	              key: "so-text-row",
	              className: "text-default no-padding-bottom no-margin-bottom"
	            },
	            "Are you sure you want to start over?",
	            _react2.default.createElement("br", null),
	            "Any selections you have made will not be saved",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ), _react2.default.createElement(
	            _Grid.FullRow,
	            { key: "so-btn-row", className: "no-padding-bottom" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-link btn-sm text-teal-400 mr-20",
	                onClick: function onClick(e) {
	                  _this3.handleAddressStartOverDialog(e, false);
	                }
	              },
	              "Close"
	            ),
	            "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0",
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-aa-default btn-round btn-sm bg-grey text-white ml-20",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this3.handleStartOver();
	                  _this3.handleAddressStartOverDialog(e, false);
	                }
	              },
	              "Yes, reset"
	            )
	          )]
	        },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "btn btn-link no-padding pt-10 ml-10 text-capitalize text-size-small text-white mt-10",
	            onClick: function onClick(e) {
	              _this3.handleStartOverDialog(e, true);
	            }
	          },
	          "Start over"
	        )
	      );
	
	      var circle_options = (0, _utility.getMapVectorOptions)();
	      var onClose = this.props.onClose;
	
	      var drawingBtnClass = "btn btn-icon pt-10 no-padding mr-20 ";
	      var removeDrawingBtnClass = "btn btn-icon pt-10 no-padding mr-20 text-white ";
	      var applyBtnClass = this.state.readyApply === true ? "btn btn-rounded btn-xs text-uppercase bg-teal-400" : "btn btn-rounded disabled btn-xs text-uppercase bg-teal-400 ";
	      if (this.state.onDrawing === true || this.state.readyApply === true) drawingBtnClass += " disabled";else removeDrawingBtnClass += " disabled";
	      var SegmentGoogleMap = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
	        return _react2.default.createElement(
	          _reactGoogleMaps.GoogleMap,
	          {
	            defaultCenter: _this3.state.center,
	            defaultOptions: {
	              streetViewControl: false,
	              mapTypeControl: false
	            },
	            ref: props.onMapLoad,
	            defaultZoom: 4,
	            onZoomChanged: props.onZoomChanged,
	            zoom: props.zoom,
	            center: props.center
	          },
	          _react2.default.createElement(_DrawingManager2.default, {
	            ref: function ref(elm) {
	              return _this3.drawingManager = elm;
	            },
	            defaultDrawingMode: null,
	            defaultOptions: {
	              drawingControl: false,
	              drawingControlOptions: {
	                position: google.maps.ControlPosition.TOP_CENTER,
	                drawingModes: [google.maps.drawing.OverlayType.CIRCLE, google.maps.drawing.OverlayType.POLYGON, google.maps.drawing.OverlayType.RECTANGLE]
	              },
	              circleOptions: circle_options,
	              rectangleOptions: circle_options,
	              polymgonOptions: circle_options
	            },
	            drawingMode: _this3.state.defaultDrawingMode,
	            onOverlayComplete: _this3.overlayComplete.bind(_this3)
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Circle, {
	            center: _this3.state.circle.center,
	            ref: function ref(circle) {
	              return _this3._circle = circle;
	            },
	            radius: _this3.state.circle.radius,
	            visiable: _this3.state.circle.visible,
	            editable: true,
	            draggable: false,
	            options: circle_options,
	            onCenterChanged: _this3.updateCircleInfo.bind(_this3),
	            onRadiusChanged: _this3.updateCircleInfo.bind(_this3)
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Circle, {
	            center: _this3.state.search_suggest ? _this3.state.search_suggest.location : null,
	            ref: function ref(circle) {
	              return _this3._addressCircle = circle;
	            },
	            radius: _this3.state.radiusVal * 1609.34,
	            visible: _this3.state.drawAddrType === "radius",
	            editable: false,
	            draggable: false,
	            options: (0, _utility.getMutableCircleOptions)()
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Circle, {
	            center: _this3.state.search_suggest ? _this3.state.search_suggest.location : null,
	            ref: function ref(circle) {
	              return _this3._driveCircle = circle;
	            },
	            radius: _this3.state.driveRadiusVal * 1609.34,
	            visible: _this3.state.drawAddrType === "drive",
	            editable: false,
	            draggable: false,
	            options: (0, _utility.getMutableCircleOptions)()
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Rectangle, {
	            bounds: _this3.state.rect.bounds,
	            visiable: _this3.state.rect.visible,
	            ref: function ref(rectangle) {
	              return _this3._rectangle = rectangle;
	            },
	            editable: true,
	            draggable: true,
	            options: circle_options,
	            onDragEnd: function onDragEnd() {
	              _this3.setState({ onDraging: false });
	            },
	            onDragStart: function onDragStart() {
	              _this3.setState({ onDraging: true });
	            }
	            //onMouseDown={()=>{this.setState({onDraging: true})}}
	            //onMouseUp={()=>{this.setState({onDraging: false})}}
	            , onBoundsChanged: _this3.updateRectInfo.bind(_this3)
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Polygon, {
	            path: _this3.state.polygon.path,
	            visiable: _this3.state.polygon.visible,
	            ref: function ref(polygon) {
	              return _this3._polygon = polygon;
	            }
	            //onMouseDown={this.preparePolygonInfo.bind(this)}
	            , editable: true,
	            draggable: true,
	            options: circle_options,
	            onMouseUp: _this3.updatePolygonInfo.bind(_this3)
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Marker, _this3.state.marker)
	        );
	      });
	
	      var showAddressTool = this.isAddress(this.state.search_suggest);
	      return _react2.default.createElement(
	        "div",
	        { className: "p-20 light-grey-border" },
	        _react2.default.createElement(
	          "div",
	          { className: "pb-10 light-grey-bottom-border mb-20" },
	          "Plot a Custom Radius"
	        ),
	        _react2.default.createElement(SegmentGoogleMap, {
	          containerElement: _react2.default.createElement("div", { style: { height: "100%", minHeight: "400px" } }),
	          mapElement: _react2.default.createElement("div", { style: { height: "100%", minHeight: "423px" } }),
	          zoom: this.state.zoom,
	          center: this.state.center,
	          onMapLoad: this.handleMapMounted.bind(this),
	          onBoundsChanged: this.handleBoundsChanged.bind(this),
	          onZoomChanged: this.handleZoomChanged.bind(this),
	          bounds: this.state.bounds
	        }),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "pl-20 pr-20 pb-10 pt-15",
	            style: {
	              color: "white",
	              width: "85%",
	              height: "55px",
	              position: "absolute",
	              left: 40,
	              top: 85,
	              backgroundColor: "rgba(0,0,0, 0.6)",
	              display: this.state.zoom < 5 && !showAddressTool ? "block" : "none"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "pull-left mr-10 pt-5" },
	            "ZOOM-IN OR "
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "pull-left text-grey", style: { width: "360px" } },
	            _react2.default.createElement(_reactGeosuggest2.default, {
	              ref: function ref(el) {
	                return _this3._geoSuggest = el;
	              },
	              onSuggestSelect: this.handleSuggestSelect.bind(this),
	              suggestsClassName: "find-address-suggest",
	              suggestItemClassName: "find-address-suggest-item",
	              suggestItemActiveClassName: "find-address-suggest-active-item",
	              placeholder: "Find a Place",
	              types: ["geocode"],
	              country: "us"
	            })
	          ),
	          _react2.default.createElement(
	            "span",
	            {
	              className: "pull-left",
	              style: { marginLeft: "-20px", marginTop: "3px", color: "grey" }
	            },
	            _react2.default.createElement("i", { className: "icon-search4" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "pl-20 pr-20 pb-10",
	            style: {
	              color: "white",
	              width: "85%",
	              paddingTop: "5px",
	              height: "70px",
	              position: "absolute",
	              left: 40,
	              top: 85,
	              backgroundColor: "rgba(0,0,0, 0.6)",
	              display: this.state.zoom < 5 || showAddressTool ? "none" : "block"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            "Select a drawing tool to plot a radius"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pull-right" },
	            _react2.default.createElement(
	              "a",
	              { onClick: this._handleClose.bind(this) },
	              _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            {
	              className: drawingBtnClass,
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this3.onStartDrawing("circle");
	              }
	            },
	            _react2.default.createElement("i", { className: "icon-circle text-white" })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: drawingBtnClass,
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this3.onStartDrawing("rectangle");
	              }
	            },
	            _react2.default.createElement("i", { className: " icon-checkbox-unchecked text-white" })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: drawingBtnClass,
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this3.onStartDrawing("polygon");
	              }
	            },
	            _react2.default.createElement("i", { className: " icon-stats-growth2 text-white" })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: removeDrawingBtnClass,
	              style: { textTransform: "capitalize" },
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this3.clearAllDrawing();
	              }
	            },
	            "X Delete Radius"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              style: {
	                padding: "3px 10px",
	                marginTop: "5px",
	                marginLeft: "90px"
	              },
	              className: applyBtnClass,
	              onClick: this.applySelect.bind(this, false)
	            },
	            "Apply Map Selection",
	            " "
	          ),
	          btnStartOver
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "pl-20 pr-20 pb-10 pt-10",
	            style: {
	              color: "white",
	              width: "90%",
	              paddingTop: "5px",
	              height: "140px",
	              position: "absolute",
	              left: 40,
	              top: 85,
	              backgroundColor: "rgba(0,0,0, 0.6)",
	              display: showAddressTool ? "block" : "none",
	              fontSize: "14px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "text-grey pull-left", style: { width: "50%" } },
	            _react2.default.createElement("input", {
	              className: "no-border pl-5 pr-5 pt-5 pb-5 ",
	              type: "text",
	              readOnly: true,
	              style: { width: "100%" },
	              value: this.state.search_suggest ? this.state.search_suggest.label : ""
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "text-grey ml-20",
	              style: { width: "40%", display: "inline-block" }
	            },
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "radio_group_address",
	                onChange: this.handleRadioChange.bind(this),
	                valueSelected: this.state.drawAddrType
	              },
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "radius",
	                label: "RADIUS",
	                labelStyle: radioButtonStyle.labeStyle,
	                iconStyle: radioButtonStyle.inputStyle,
	                style: radioButtonStyle.firstRadioStyle
	              }),
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "drive",
	                label: "DRIVE TIME",
	                labelStyle: radioButtonStyle.labeStyle,
	                iconStyle: radioButtonStyle.inputStyle,
	                style: radioButtonStyle.secondRadioStyle
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: this.state.drawAddrType === "radius" ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(_rcSlider2.default, {
	              className: "slider-radius",
	              min: 0,
	              max: 100,
	              included: true,
	              step: 1,
	              onChange: this._handleRadiusChange.bind(this),
	              value: this.state.radiusVal,
	              onAfterChange: this._onRadiusAfterChange.bind(this),
	              marks: {
	                5: "5",
	                10: "10",
	                25: "25",
	                50: "50",
	                75: "75",
	                100: "100"
	              }
	            }),
	            _react2.default.createElement("input", {
	              type: "text",
	              readOnly: true,
	              style: { width: "50px" },
	              value: this.state.radiusVal ? this.state.radiusVal : "",
	              className: "no-border pl-5 pr-5 pt-5 pb-5 text-teal-400"
	            }),
	            " ",
	            "\xA0 Miles"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: this.state.drawAddrType === "drive" ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(_rcSlider2.default, {
	              className: "slider-radius",
	              min: 0,
	              max: 4,
	              included: true,
	              step: 0.5,
	              onChange: this._handleDriveTimeChange.bind(this),
	              onAfterChange: this._onDriveTimeAfterChange.bind(this),
	              value: this.state.driveTimeVal,
	              marks: {
	                0.5: "0.5",
	                1: "1",
	                1.5: "1.5",
	                2: "2",
	                2.5: "2.5",
	                3: "3",
	                3.5: "3.5",
	                4: "4"
	              }
	            }),
	            _react2.default.createElement("input", {
	              type: "text",
	              readOnly: true,
	              style: { width: "50px" },
	              value: this.state.driveTimeVal ? this.state.driveTimeVal : "",
	              className: "no-border pl-5 pr-5 pt-5 pb-5 text-teal-400"
	            }),
	            " ",
	            "\xA0 HR(S)"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "a",
	              {
	                style: { padding: "3px 10px", marginTop: "20px" },
	                className: applyBtnClass,
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this3.applySelect(false);
	                }
	              },
	              "Apply"
	            ),
	            "\xA0\xA0\xA0",
	            btnAddressStartOver
	          )
	        )
	      );
	    }
	  }]);
	
	  return PlotMapPanel;
	}(_react.Component);
	
	exports.default = PlotMapPanel;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(38);
	
	var _ValuePanel = __webpack_require__(352);
	
	var _ValuePanel2 = _interopRequireDefault(_ValuePanel);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _some = __webpack_require__(153);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegionLocalePanel = function (_Component) {
	  _inherits(RegionLocalePanel, _Component);
	
	  function RegionLocalePanel(props) {
	    _classCallCheck(this, RegionLocalePanel);
	
	    var _this = _possibleConstructorReturn(this, (RegionLocalePanel.__proto__ || Object.getPrototypeOf(RegionLocalePanel)).call(this, props));
	
	    _this.state = {
	      indexKey: null,
	      selectedVal: null,
	      selectedStates: []
	    };
	    return _this;
	  }
	
	  _createClass(RegionLocalePanel, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.setState({
	        indexKey: null,
	        selectedVal: null,
	        selectedStates: []
	      });
	    }
	  }, {
	    key: "handleLocaleSelect",
	    value: function handleLocaleSelect(id, isChecked) {
	      var locale = (0, _find2.default)(this.props.locales, function (m) {
	        return m.id === id;
	      });
	      this.props.selectLocale(locale, isChecked);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var displayLocales = void 0;
	      if (this.state.indexKey) {
	        var regionName = this.state.selectedVal;
	        displayLocales = (0, _filter2.default)(this.props.locales, function (m) {
	          return m.value.split(" - ")[0] === regionName;
	        });
	      }
	      var selectedRegionIds = (0, _map2.default)(this.props.selected_region, "id");
	      return _react2.default.createElement(
	        "div",
	        { style: { display: "flex", flexGrow: "1" } },
	        _react2.default.createElement(
	          "div",
	          {
	            key: "geo-state-node-contianer",
	            style: { width: "300px" },
	            className: "light-grey-border"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border",
	              style: { display: "flex", justifyContent: "space-between" }
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Region"
	              )
	            ),
	            _react2.default.createElement("div", { style: { height: "24px" } })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                height: "453px",
	                overflowY: "scroll"
	              }
	            },
	            (0, _map2.default)(this.props.regions, function (data) {
	              var clsName = " ml-10 mr-10";
	              var showMark = (0, _some2.default)(_this2.props.selected_locale, function (m) {
	                return m.value.split(" - ")[0] === data.value;
	              });
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: data.label + "_" + data.id,
	                  style: {
	                    color: "#017FB5",
	                    cursor: "pointer",
	                    display: "flex"
	                  },
	                  className: clsName,
	                  onClick: function onClick() {
	                    _this2.setState({
	                      indexKey: data.id,
	                      selectedVal: data.value
	                    });
	                    //if (this.props.getCities) this.props.getCities(data.id);
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "p-10 mr-10",
	                    style: {
	                      background: _this2.state.indexKey === data.id ? "#F5F5F5" : "#FFF",
	                      flexGrow: "1",
	                      display: "flex"
	                    }
	                  },
	                  _react2.default.createElement(_materialUi.Checkbox, {
	                    label: "",
	                    labelStyle: { fontSize: "16px" },
	                    style: { width: "10px" },
	                    iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	                    checked: selectedRegionIds.indexOf(data.id) >= 0,
	                    onCheck: function onCheck(e, isInputChecked) {
	                      _this2.props.selectRegion(data, isInputChecked);
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    data.label
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        display: showMark && selectedRegionIds.indexOf(data.id) < 0 ? "flex" : "none",
	                        paddingTop: "4px"
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "icon-checkmark4 text-orange-400" })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "tree-node-arrow-right" })
	              );
	            })
	          )
	        ),
	        displayLocales && _react2.default.createElement(
	          "div",
	          { style: { flexGrow: "1" } },
	          _react2.default.createElement(_ValuePanel2.default, {
	            key: this.state.selectedVal + "_values_panel",
	            displayData: displayLocales,
	            selected_segments: (0, _map2.default)(this.props.selected_locale, "id"),
	            title: "Locale",
	            showFilter: true,
	            onCheck: function onCheck(id, isChecked) {
	              _this2.handleLocaleSelect(id, isChecked);
	            },
	            disabledAll: selectedRegionIds.indexOf(this.state.indexKey) >= 0,
	            granularity: this.props.granularity
	          })
	        )
	      );
	    }
	  }]);
	
	  return RegionLocalePanel;
	}(_react.Component);
	
	exports.default = RegionLocalePanel;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(38);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubValuePanel = function (_Component) {
	  _inherits(SubValuePanel, _Component);
	
	  function SubValuePanel(props) {
	    _classCallCheck(this, SubValuePanel);
	
	    var _this = _possibleConstructorReturn(this, (SubValuePanel.__proto__ || Object.getPrototypeOf(SubValuePanel)).call(this, props));
	
	    _this.state = {
	      focusItemId: undefined
	    };
	    return _this;
	  }
	
	  _createClass(SubValuePanel, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var clsName = "ml-20 mr-10 pb-20";
	      return _react2.default.createElement(
	        "div",
	        {
	          key: this.props.key + "-value-node-contianer",
	          className: "light-grey-border",
	          style: {
	            height: "520px",
	            overflowY: "scroll"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "pt-20 ml-20 mr-20 mb-20 pb-10 light-grey-bottom-border" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            this.props.title
	          )
	        ),
	        (0, _map2.default)(this.props.displayData, function (data) {
	          return _react2.default.createElement(
	            "div",
	            {
	              key: data.id + "-sub-attributes-line",
	              style: { display: "flex", justifyContent: "space-between" },
	              className: "pt-20 ml-20 mr-20"
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                key: data.id + "-sub-attributes-name",
	                style: { width: "250px", flex: "1 1 0" }
	              },
	              data.name
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                key: data.id + "-sub-attr-values-list",
	                style: { flex: "1 1 0" }
	              },
	              (0, _map2.default)(data.values, function (v) {
	                return _react2.default.createElement(
	                  "div",
	                  {
	                    key: v.label + v.id + "_node",
	                    style: { color: "#017FB5", cursor: "pointer" },
	                    className: clsName,
	                    onClick: function onClick() {
	                      _this2.setState({
	                        indexKey: v.id
	                      });
	                    },
	                    onMouseOver: function onMouseOver() {
	                      _this2.setState({ focusItemId: v.id });
	                    }
	                  },
	                  _react2.default.createElement(_materialUi.Checkbox, {
	                    label: _this2.state.focusItemId === v.id && data.granularity ? [_react2.default.createElement(
	                      "span",
	                      { key: v.label + "-" + v.id + "-span" },
	                      v.label
	                    ), _react2.default.createElement(
	                      "span",
	                      {
	                        key: v.label + "-" + v.id + "-granularity",
	                        className: "ml-10 black-border p-5"
	                      },
	                      data.granularity
	                    )] : v.label,
	                    labelStyle: {
	                      fontSize: "16px"
	                    },
	                    iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	                    checked: _this2.props.selected_segments.indexOf(v.id) >= 0,
	                    onCheck: function onCheck(e, isInputChecked) {
	                      _this2.props.onCheck(v.id, isInputChecked);
	                    }
	                  })
	                );
	              })
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return SubValuePanel;
	}(_react.Component);
	
	exports.default = SubValuePanel;

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreePanel = function (_Component) {
	  _inherits(TreePanel, _Component);
	
	  function TreePanel(props) {
	    _classCallCheck(this, TreePanel);
	
	    var _this = _possibleConstructorReturn(this, (TreePanel.__proto__ || Object.getPrototypeOf(TreePanel)).call(this, props));
	
	    _this.state = {
	      indexKey: null
	    };
	    return _this;
	  }
	
	  _createClass(TreePanel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        indexKey: this.props.selectedId
	      });
	      if (this.props.selectedId) {
	        this.props.onClick(this.props.selectedId);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.selectedId !== this.props.selectedId && this.state.indexKey !== this.props.selectedId) {
	        this.setState({
	          indexKey: this.props.selectedId
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          key: this.props.key + "-tree-node-contianer",
	          style: { width: "300px", height: "520px", overflowY: "scroll" },
	          className: "light-grey-border"
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border",
	            style: { display: "flex", justifyContent: "space-between" }
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              this.props.title
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { height: "24px" } },
	            this.props.tooltip && _react2.default.createElement(
	              _rcTooltip2.default,
	              {
	                placement: "right",
	                overlay: this.props.tooltip,
	                arrowContent: _react2.default.createElement("div", { className: "rc-tooltip-arrow-inner" })
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "inline-block",
	                    color: "#1E88E5",
	                    cursor: "pointer"
	                  }
	                },
	                _react2.default.createElement(_infoOutline2.default, null)
	              )
	            )
	          )
	        ),
	        (0, _map2.default)(this.props.displayData.filter(function (l) {
	          return l.id !== 6;
	        }), function (data) {
	          var clsName = " ml-10 mr-10";
	          return _react2.default.createElement(
	            "div",
	            {
	              key: _this2.props.key + data.name + data.id,
	              style: { color: "#017FB5", cursor: "pointer", display: "flex" },
	              className: clsName,
	              onClick: function onClick() {
	                _this2.setState({
	                  indexKey: data.id
	                });
	                _this2.props.onClick(data.id);
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "pt-10 pl-10 pr-10 pb-10 mr-10",
	                style: {
	                  background: _this2.state.indexKey === data.id ? "#F5F5F5" : "#FFF",
	                  flexGrow: "1"
	                }
	              },
	              data.name
	            ),
	            _react2.default.createElement("div", { className: "tree-node-arrow-right" })
	          );
	        })
	      );
	    }
	  }]);
	
	  return TreePanel;
	}(_react.Component);
	
	exports.default = TreePanel;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(154);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _RaisedButton = __webpack_require__(304);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _utility = __webpack_require__(14);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _some = __webpack_require__(153);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _difference = __webpack_require__(663);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	var _uniq = __webpack_require__(301);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  raidoIcon: {
	    color: "black"
	  },
	  divider: {
	    borderBottom: "1px solid black",
	    marginBottom: "6px"
	  },
	  iconStyle: {
	    fill: (0, _utility.primaryColor)()
	  },
	  textareaUnderlineStyle: {
	    borderBottom: "1px solid red"
	  },
	  rootElementStyle: {
	    height: "400px"
	  },
	  btnStyle: {
	    background: (0, _utility.primaryColor)(),
	    color: "#FFF"
	  },
	  searchStyle: {
	    borderColor: (0, _utility.primaryColor)()
	  }
	};
	
	var ZipcodePanel = function (_Component) {
	  _inherits(ZipcodePanel, _Component);
	
	  function ZipcodePanel(props) {
	    _classCallCheck(this, ZipcodePanel);
	
	    var _this = _possibleConstructorReturn(this, (ZipcodePanel.__proto__ || Object.getPrototypeOf(ZipcodePanel)).call(this, props));
	
	    _this.state = {
	      ifZipcodeValid: true,
	      zipcode: "",
	      inValidZips: []
	    };
	    return _this;
	  }
	
	  _createClass(ZipcodePanel, [{
	    key: "handleZipCode",
	    value: function handleZipCode(e, newValue) {
	      var matchArrs = newValue.match(/\b\d{5}\b/g);
	      var arrs = newValue.split(",");
	      var diff = (0, _difference2.default)(arrs, matchArrs);
	      if ((0, _isEmpty2.default)(diff)) {
	        this.setState({
	          ifZipcodeValid: false,
	          zipcode: newValue,
	          inValidZips: []
	        });
	      } else {
	        this.setState({
	          ifZipcodeValid: true,
	          inValidZips: diff
	        });
	      }
	    }
	  }, {
	    key: "handleApplyClick",
	    value: function handleApplyClick(e) {
	      if (!this.state.ifZipcodeValid) {
	        var zipcodes = (0, _uniq2.default)(this.state.zipcode.split(","));
	        this.props.addZipCode(zipcodes.join(","));
	        this.setState({
	          zipcode: "",
	          ifZipcodeValid: true
	        });
	        document.getElementById(this.refs.textarea.uniqueId).value = "";
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "light-grey-border p-20", style: { height: "520px" } },
	        _react2.default.createElement(
	          "div",
	          {
	            style: { display: "flex", justifyContent: "space-between" },
	            className: "light-grey-bottom-border pb-10"
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Zip code"
	            )
	          ),
	          _react2.default.createElement("div", null)
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "show-zipcode clearfix pt-10 pb-10 light-grey-bottom-border",
	            style: {
	              display: this.props.zipcode.length > 0 ? "block" : "none",
	              marginBottom: "5px",
	              maxHeight: "60px",
	              overflowY: "scroll"
	            }
	          },
	          this.props.zipcode.map(function (item, index) {
	            return _react2.default.createElement(
	              "span",
	              {
	                className: "text-muted text-light mr-10",
	                style: { float: "left" },
	                key: index
	              },
	              _react2.default.createElement(
	                "small",
	                null,
	                item.zipcode
	              )
	            );
	          }),
	          _react2.default.createElement(
	            "span",
	            { className: "text-orange-400 ml-10", style: { float: "left" } },
	            _react2.default.createElement("i", { className: "icon-checkmark4 text-size-md " })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "light-grey-border pl-10 pr-10 pb-10 mb-20",
	            style: { height: this.props.zipcode.length > 0 ? "300px" : "340px" }
	          },
	          _react2.default.createElement(_TextField2.default, {
	            fullWidth: true,
	            multiLine: true,
	            rows: 1,
	            rowsMax: 11,
	            underlineShow: false,
	            hintText: "Enter Zip Code(s) or Zip Code Range(s)",
	            onChange: function onChange(e, newValue) {
	              return _this2.handleZipCode(e, newValue);
	            },
	            errorText: this.state.errorText,
	            ref: "textarea"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "mb-5" },
	          "If entering multiple zip codes or zip code ranges, separate each with a comma"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", justifyContent: "space-between" } },
	          _react2.default.createElement(
	            "div",
	            { style: { color: "#FF0000" } },
	            !(0, _isEmpty2.default)(this.state.inValidZips) && "Some invalid zipcodes: " + this.state.inValidZips.join(",")
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_RaisedButton2.default, {
	              label: "Apply",
	              buttonStyle: styles.btnStyle,
	              labelColor: "#FFF",
	              disabled: this.state.ifZipcodeValid,
	              onTouchTap: function onTouchTap(e) {
	                return _this2.handleApplyClick(e);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ZipcodePanel;
	}(_react.Component);
	
	exports.default = ZipcodePanel;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _SelectField = __webpack_require__(696);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(235);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Chip = __webpack_require__(689);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _SelectedAttrs = __webpack_require__(257);
	
	var _SelectedAttrs2 = _interopRequireDefault(_SelectedAttrs);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _groupBy = __webpack_require__(150);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _remove = __webpack_require__(188);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _some = __webpack_require__(153);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _close = __webpack_require__(727);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _materialUi = __webpack_require__(38);
	
	var _utility = __webpack_require__(14);
	
	var _segment_util = __webpack_require__(261);
	
	var _TreePanel = __webpack_require__(1051);
	
	var _TreePanel2 = _interopRequireDefault(_TreePanel);
	
	var _PlotMapPanel = __webpack_require__(1048);
	
	var _PlotMapPanel2 = _interopRequireDefault(_PlotMapPanel);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1398);
	
	var _ValuePanel = __webpack_require__(352);
	
	var _ValuePanel2 = _interopRequireDefault(_ValuePanel);
	
	var _SubValuePanel = __webpack_require__(1050);
	
	var _SubValuePanel2 = _interopRequireDefault(_SubValuePanel);
	
	var _GeoStatesPanel = __webpack_require__(1047);
	
	var _GeoStatesPanel2 = _interopRequireDefault(_GeoStatesPanel);
	
	var _ZipcodePanel = __webpack_require__(1052);
	
	var _ZipcodePanel2 = _interopRequireDefault(_ZipcodePanel);
	
	var _AutoMakePanel = __webpack_require__(1046);
	
	var _AutoMakePanel2 = _interopRequireDefault(_AutoMakePanel);
	
	var _RegionLocalePanel = __webpack_require__(1049);
	
	var _RegionLocalePanel2 = _interopRequireDefault(_RegionLocalePanel);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _flattenDeep = __webpack_require__(1637);
	
	var _flattenDeep2 = _interopRequireDefault(_flattenDeep);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var geoCategory = {
	  name: "Geography",
	  attributes: [{ id: 1, name: "Add City / State" }, { id: 7, name: "Add Zip Code" }, { id: 2, name: "Add County" }, { id: 4, name: "Add DMA" }, { id: 6, name: "Plot a Custom Radius" }]
	};
	var geoInfoText = _react2.default.createElement(
	  "section",
	  null,
	  _react2.default.createElement(
	    "div",
	    { className: "mb-10" },
	    _react2.default.createElement(
	      "strong",
	      null,
	      "Selecting Geographic Attributes:"
	    )
	  ),
	  _react2.default.createElement(
	    "div",
	    null,
	    "You can build your audience by selecting only 1 geographic option."
	  ),
	  _react2.default.createElement(
	    "div",
	    null,
	    "If you select a different geography type, any selections made will be deleted."
	  )
	);
	var MenuDivider = function MenuDivider(props) {
	  return _react2.default.createElement("li", { className: "divider", role: "separator" });
	};
	var MenuHeader = function MenuHeader(props) {
	  return _react2.default.createElement("li", Object.assign({}, props, { className: "dropdown-header" }));
	};
	
	var AudienceBuilder = function (_AcquireWebComponent) {
	  _inherits(AudienceBuilder, _AcquireWebComponent);
	
	  function AudienceBuilder(props) {
	    _classCallCheck(this, AudienceBuilder);
	
	    var _this = _possibleConstructorReturn(this, (AudienceBuilder.__proto__ || Object.getPrototypeOf(AudienceBuilder)).call(this, props));
	
	    _this.onUnload = function (e) {
	      // the method that will be used for both add and remove event
	      e.preventDefault();
	      e.returnValue = "";
	    };
	
	    _this.closeMapSelectDialog = function () {
	      _this.setState({ openMapDialog: false, plotted_values: null });
	      _this.props.clearAudienceCount();
	    };
	
	    _this.computedSelectedOtherSegment = function (nextProps) {
	      var other = [];
	      nextProps.value_typehead.forEach(function (value) {
	        nextProps.selected_segments.forEach(function (segment) {
	          if (segment === value.id) {
	            var parent = nextProps.value_typehead.find(function (l) {
	              return l.label === value.parent;
	            });
	            other.push({
	              id: parent.id,
	              name: value.parent
	            });
	          }
	        });
	      });
	      _this.setState({
	        otherSegmentDropDownList: other
	      });
	    };
	
	    _this.computedSelectedGeo = function (nextProps) {
	      var geoArrs = [];
	      if (nextProps.selected_city.length > 0 || nextProps.selected_state.length > 0) {
	        geoArrs.push({
	          id: nextProps.selected_city.length > 0 ? 3 : 1,
	          name: 'City/State'
	        });
	      }
	      if (nextProps.selected_dma.length > 0) {
	        geoArrs.push({
	          id: 4,
	          name: 'Dma'
	        });
	      }
	      if (nextProps.zipcode.length > 0) {
	        geoArrs.push({
	          id: 7,
	          name: 'Zip Code'
	        });
	      }
	      if (nextProps.selected_county.length > 0) {
	        geoArrs.push({
	          id: 2,
	          name: 'County'
	        });
	      }
	      _this.setState({
	        geoDropDownList: geoArrs
	      });
	    };
	
	    _this.handleExportCsv = function () {
	      if ((_this.state.exportCsvField.email || _this.state.exportCsvField.directMail || _this.state.exportCsvField.socialDisplay) && _this.state.exportCsvField.geo && _this.state.exportCsvField.other) {
	        if (_this.props.zipcode.length > 0) {
	          (0, _segment_util.parseZipcode)(_this.props, _this.props.segment_name);
	        }
	        var newSegment = (0, _segment_util.parseSegment)(_this.props, _this.props.segment_name, _this.state.plotted_values);
	        if (newSegment.rules.length > 0 || _this.props.selected_city.length > 0 || _this.props.selected_state.length > 0 || _this.props.zipcode.length > 0 || _this.props.selected_dma.length > 0 || _this.props.selected_county.length > 0) {
	          var targetHouseholdsOnly = _this.props.targetHouseholdsOnly;
	          /**
	           * filter non-geo
	           */
	
	          var newRules = newSegment.rules.filter(function (l) {
	            return [_this.state.exportCsvField.geo.id, _this.state.exportCsvField.other.id].includes(l.attributeId);
	          });
	          var channels = [];
	          if (_this.state.exportCsvField.email) {
	            channels.push('email');
	          }
	          if (_this.state.exportCsvField.directMail) {
	            channels.push('directMail');
	          }
	          if (_this.state.exportCsvField.socialDisplay) {
	            channels.push('social');
	          }
	          _this.requestDownloadCsvApi({
	            rules: newRules,
	            filtered: {
	              targetHouseholdsOnly: (0, _isUndefined2.default)(undefined) ? Boolean(targetHouseholdsOnly) : undefined
	            },
	            channels: channels
	          });
	        } else {
	          _this.props.clearAudienceCount();
	        }
	      }
	    };
	
	    _this.state = {
	      selectedCatId: null,
	      selectedAttrId: null,
	      errorVisible: false,
	      openCancel: false,
	      openReset: false,
	      openViewSelected: false,
	      cancelAnchorEl: null,
	      openExportCsvModal: false,
	      geoDropDownList: [],
	      otherSegmentDropDownList: [],
	      exportCsvField: {
	        email: true,
	        socialDisplay: true,
	        directMail: true,
	        geo: {
	          id: null,
	          name: null
	        },
	        other: {
	          id: null,
	          name: null
	        },
	        channel: []
	      }
	    };
	
	    var cid = (0, _utility.getUrlParameterByName)("cid");
	    if (cid) {
	      _this.props.selectClient(parseInt(cid, 10));
	      if (!props.demoAttributes) {
	        props.loadAttributes(cid);
	      }
	    }
	    return _this;
	  }
	
	  _createClass(AudienceBuilder, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("beforeunload", this.onUnload);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.addEventListener("beforeunload", this.onUnload);
	
	      if ((0, _utility.getUrlParameterByName)("cid")) {
	        this.props.selectClient(parseInt((0, _utility.getUrlParameterByName)("cid"), 10));
	        if ((0, _utility.getUrlParameterByName)("id")) {
	          this.props.getSegmentDetail((0, _utility.getUrlParameterByName)("id"), (0, _utility.getUrlParameterByName)("cid"));
	        }
	      } else {
	        var url = window.location.pathname;
	        if ((0, _utility.getUrlParameterByName)("id")) {
	          url = (0, _utility.pushParamsToUrl)(url, "id", (0, _utility.getUrlParameterByName)("id"));
	        }
	        this.props.history.push((0, _utility.pushParamsToUrl)(url, "cid", this.props.selected_client));
	      }
	      if (!this.props.allstates || (0, _isEmpty2.default)(this.props.allstates)) this.props.getAllStates();
	      //get all states
	      //if (!this.props.all_state_cities || isEmpty(this.props.all_state_cities))
	      //this.props.getAllStateCities(); // get all states and cities
	      this.props.loadCounties();
	      this.props.loadDMAs();
	      var attrId = void 0;
	      if (!(0, _isEmpty2.default)(this.props.plotted_values) || !(0, _isEmpty2.default)(this.props.selected_city) || !(0, _isEmpty2.default)(this.props.selected_state) || !(0, _isEmpty2.default)(this.props.selected_county) || !(0, _isEmpty2.default)(this.props.selected_dma) || !(0, _isEmpty2.default)(this.props.zipcode)) {
	        if (!(0, _isEmpty2.default)(this.props.selected_dma)) {
	          attrId = 4;
	        } else if (!(0, _isEmpty2.default)(this.props.selected_county)) {
	          attrId = 2;
	        } else if (!(0, _isEmpty2.default)(this.props.selected_state) || !(0, _isEmpty2.default)(this.props.selected_city)) {
	          attrId = 1;
	        }
	        this.setState({
	          selectedCatId: 0,
	          selectedAttrId: attrId,
	          selected_segments: this.props.selected_segments
	        }, function () {
	          _this2.updateSelectedFocus();
	        });
	      } else {
	        this.setState({
	          selected_segments: this.props.selected_segments
	        }, function () {
	          _this2.updateSelectedFocus();
	        });
	      }
	      this.recalculateTotal();
	    }
	  }, {
	    key: "updateSelectedFocus",
	    value: function updateSelectedFocus() {
	      var _this3 = this;
	
	      if (!this.state.selected_segments || !this.props.demoAttributes || !this.props.demoAttributes[0]) return;
	      (0, _map2.default)(this.state.selected_segments, function (seg) {
	        if (seg && seg.toString().indexOf("606") >= 0) {
	          var model = (0, _find2.default)(_this3.props.demoAttributes[0].attributes[2].values, function (m) {
	            return m.id === seg;
	          });
	          _this3.handleAutoModelSelected(model, true);
	        }
	        if (seg && seg.toString().indexOf("605") >= 0) {
	          var make = (0, _find2.default)(_this3.props.demoAttributes[0].attributes[1].values, function (m) {
	            return m.id === seg;
	          });
	          _this3.handleAutoMakeSelected(make, true);
	        }
	        if (seg && seg.toString().indexOf("1503") >= 0) {
	          var locale = (0, _find2.default)(_this3.props.demoAttributes[2].attributes[2].values, function (m) {
	            return m.id === seg;
	          });
	          _this3.handleCultureLocaleSelected(locale, true);
	        }
	        if (seg && seg.toString().indexOf("1502") >= 0) {
	          var region = (0, _find2.default)(_this3.props.demoAttributes[2].attributes[1].values, function (m) {
	            return m.id === seg;
	          });
	          _this3.handleCultureRegionSelected(region, true);
	        }
	      });
	      var catId = void 0;
	      var attrId = void 0;
	      (0, _map2.default)(this.props.demoAttributes, function (c) {
	        (0, _map2.default)(c.attributes, function (attr) {
	          if (attr.subAttributes) {} else {
	            if ((0, _some2.default)(attr.values, function (val) {
	              return _this3.state.selected_segments.indexOf(val.id) >= 0;
	            })) {
	              catId = c.id;
	              attrId = attr.id;
	            }
	          }
	        });
	      });
	      this.setState({
	        selectedCatId: catId,
	        selectedAttrId: attrId,
	        selected_segments: undefined
	      });
	      this.delayRecalculate();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this4 = this;
	
	      if (prevProps.selected_client !== this.props.selected_client) {
	        if (this.props.selected_client > 1 && (0, _utility.getUrlParameterByName)("cid") !== this.props.selected_client) {
	          /*if (getUrlParameterByName("id")) {
	            this.props.history.push(
	              pushParamsToUrl(
	                "/segments/list/active",
	                "cid",
	                this.props.selected_client,
	              ),
	            );
	          } else {*/
	          var url = window.location.pathname;
	
	          this.props.history.push((0, _utility.pushParamsToUrl)(url, "cid", this.props.selected_client));
	          //}
	        }
	      }
	      if (this.props.isNameDuplicated === true) {
	        if (!this.state.errorVisible) this.setState({ errorVisible: true });
	      } else {
	        if (this.state.errorVisible === true) this.setState({ errorVisible: false });
	      }
	      if (this.props.save_segment_success === false && prevProps.save_segment_success !== this.props.save_segment_success) {
	        this.setState({
	          errorVisible: true
	        });
	        if (String(this.props.save_segment_error_errorNo) === "422004") this.setState({
	          showSaveErrorDialog: true,
	          subject: "",
	          comments: "",
	          openContactForm: false
	        });
	      }
	      if (!(0, _isEqual2.default)(prevProps.demoAttributes, this.props.demoAttributes)) {
	        this.updateSelectedFocus();
	      }
	      if (this.props.active_segment_attributes && !(0, _isEqual2.default)(this.props.active_segment_attributes, prevProps.active_segment_attributes)) {
	        if (this.props.active_segment_attributes.rawData) {
	          var rawData = JSON.parse(this.props.active_segment_attributes.rawData);
	          this.props.segment_active_creation.selected_segments = rawData.selected_segments;
	          this.props.segment_active_creation.plotted_values = rawData.plotted_values;
	          this.props.segment_active_creation.selected_city = rawData.selected_city;
	          this.props.segment_active_creation.selected_state = rawData.selected_state;
	          this.props.segment_active_creation.selected_county = rawData.selected_county;
	          this.props.segment_active_creation.selected_dma = rawData.selected_dma;
	          this.props.segment_active_creation.zipcode = rawData.zipcode;
	          this.props.segment_active_creation.segment_name = rawData.name;
	          var segmentNameInput = _reactDom2.default.findDOMNode(this.refs.segmentNameInput);
	          if (segmentNameInput) segmentNameInput.value = rawData.name;
	          this.props.active_segment_attributes.rules.forEach(function (item) {
	            _this4.props.segment_active_creation.rules_id.push({
	              id: item.id,
	              attributeId: item.attributeId
	            });
	          });
	          this.props.segment_active_creation.segment_id = this.props.active_segment_attributes.id;
	          var attrId = void 0;
	          if (!(0, _isEmpty2.default)(rawData.plotted_values) || !(0, _isEmpty2.default)(rawData.selected_city) || !(0, _isEmpty2.default)(rawData.selected_state) || !(0, _isEmpty2.default)(rawData.selected_county) || !(0, _isEmpty2.default)(rawData.selected_dma) || !(0, _isEmpty2.default)(rawData.zipcode)) {
	            if (!(0, _isEmpty2.default)(rawData.selected_dma)) {
	              attrId = 4;
	            } else if (!(0, _isEmpty2.default)(rawData.selected_county)) {
	              attrId = 2;
	            } else if (!(0, _isEmpty2.default)(rawData.selected_state) || !(0, _isEmpty2.default)(rawData.selected_city)) {
	              attrId = 1;
	            }
	            this.setState({
	              selectedCatId: 0,
	              selectedAttrId: attrId,
	              selected_segments: rawData.selected_segments
	            }, function () {
	              _this4.updateSelectedFocus();
	            });
	          } else {
	            this.setState({
	              selected_segments: rawData.selected_segments
	            }, function () {
	              _this4.updateSelectedFocus();
	            });
	          }
	          setTimeout(function () {
	            _this4.recalculateTotal();
	          }, 1000);
	        }
	      }
	    }
	  }, {
	    key: "recalculateTotal",
	    value: function recalculateTotal(targetOnly) {
	      if (this.props.zipcode.length > 0) {
	        var _newSegment = (0, _segment_util.parseZipcode)(this.props, this.props.segment_name);
	        this.props.getZipcodeAudienceCount({
	          rules: _newSegment.rules,
	          filtered: {
	            targetHouseholdsOnly: !(0, _isUndefined2.default)(targetOnly) ? Boolean(targetOnly) : Boolean(this.props.targetHouseholdsOnly)
	          }
	        }, this.props.segment_id);
	      }
	      var newSegment = (0, _segment_util.parseSegment)(this.props, this.props.segment_name, this.state.plotted_values);
	      if (newSegment.rules.length > 0 || this.props.selected_city.length > 0 || this.props.selected_state.length > 0 || this.props.zipcode.length > 0 || this.props.selected_dma.length > 0 || this.props.selected_county.length > 0 || !(0, _isEmpty2.default)(this.props.plotted_values)) {
	        var targetHouseholdsOnly = this.props.targetHouseholdsOnly;
	
	
	        this.props.getAudienceCount({
	          rules: newSegment.rules,
	          filtered: {
	            targetHouseholdsOnly: (0, _isUndefined2.default)(targetOnly) ? Boolean(targetHouseholdsOnly) : targetOnly
	          }
	        }, this.props.segment_id);
	      } else {
	        this.props.clearAudienceCount();
	      }
	    }
	  }, {
	    key: "getAttributesPanel",
	    value: function getAttributesPanel() {
	      var _this5 = this;
	
	      if (this.state.selectedCatId >= 0) {
	        var cat = this.state.selectedCatId == 0 ? geoCategory : (0, _find2.default)(this.props.demoAttributes, function (attrs) {
	          return _this5.state.selectedCatId == attrs.id;
	        });
	        if (cat && cat.attributes) {
	          var selectId = this.state.selectedAttrId;
	          if (cat.id === 7) {
	            var attrs = Object.assign([], cat.attributes);
	            (0, _remove2.default)(attrs, function (item) {
	              return item.id === 606;
	            });
	            (0, _find2.default)(attrs, function (item) {
	              return item.id === 605;
	            }).name = "Auto Make/Model";
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_TreePanel2.default, {
	                key: cat.name + "_tree_panel",
	                displayData: attrs,
	                selectedId: selectId,
	                title: cat.name,
	                onClick: function onClick(id) {
	                  _this5.setState({ selectedAttrId: id });
	                }
	              })
	            );
	          }
	          if (cat.id === 15) {
	            var _attrs = Object.assign([], cat.attributes);
	            (0, _remove2.default)(_attrs, function (item) {
	              return item.id === 1503;
	            });
	            (0, _find2.default)(_attrs, function (item) {
	              return item.id === 1502;
	            }).name = "Region/Locale";
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_TreePanel2.default, {
	                key: cat.name + "_tree_panel",
	                displayData: _attrs,
	                selectedId: selectId,
	                title: cat.name,
	                onClick: function onClick(id) {
	                  _this5.setState({ selectedAttrId: id });
	                }
	              })
	            );
	          }
	          if (!(0, _isEmpty2.default)(this.props.selected_city) || !(0, _isEmpty2.default)(this.props.selected_state)) {
	            selectId = 1;
	          }
	          if (!(0, _isEmpty2.default)(this.props.selected_dma)) {
	            selectId = 4;
	          }
	          if (!(0, _isEmpty2.default)(this.props.selected_county)) {
	            selectId = 2;
	          }
	          if (!(0, _isEmpty2.default)(this.props.plotted_values)) {
	            selectId = 6;
	          }
	          if (!(0, _isEmpty2.default)(this.props.zipcode)) {
	            selectId = 7;
	          }
	          return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_TreePanel2.default, {
	              key: cat.name + "_" + selectId + "_tree_panel",
	              displayData: cat.attributes,
	              tooltip: cat.name === "Geography" ? geoInfoText : undefined,
	              selectedId: selectId,
	              title: cat.name,
	              onClick: function onClick(id) {
	                if (cat.name === "Geography") {
	                  if (id !== selectId && id !== _this5.state.selectedAttrId) {
	                    _this5.props.clearAllCounty();
	                    _this5.props.clearAllDMA();
	                    _this5.props.clearAllSelectedCity();
	                    _this5.props.clearAllSelectedState();
	                    _this5.props.clearAllZipCode();
	                    _this5.props.setPlotValues({});
	
	                    setTimeout(function () {
	                      _this5.recalculateTotal();
	                    }, 500);
	                  }
	                }
	                _this5.setState({ selectedAttrId: id });
	              }
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: "updateAudienceCountWithPlotted",
	    value: function updateAudienceCountWithPlotted(plottedRadius) {
	      this.setState({
	        plotted_values: plottedRadius
	      });
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 100);
	    }
	  }, {
	    key: "handleApplyPlotted",
	    value: function handleApplyPlotted(val) {
	      this.props.clearAllSelectedState();
	      this.props.clearAllSelectedCity();
	      this.props.clearAllDMA();
	      this.props.clearAllCounty();
	      this.props.clearAllZipCode();
	      this.props.setPlotValues(val);
	      this.setState({
	        plotted_values: null
	      });
	      var plottedRules = [];
	      var rule = (0, _segment_util.parsePlottedValues)(val);
	      if (rule) {
	        plottedRules.push(rule);
	        setTimeout(function () {
	          this.props.getPlottedAudienceCount({
	            rules: plottedRules,
	            filtered: {
	              targetHouseholdsOnly: Boolean(this.props.targetHouseholdsOnly)
	            }
	          }, this.props.segment_id);
	        }.bind(this), 100);
	      }
	
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 100);
	    }
	  }, {
	    key: "_handleCancelPlotted",
	    value: function _handleCancelPlotted() {
	      this.setState({
	        plotted_values: null
	      });
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 50);
	    }
	  }, {
	    key: "handleSelectAllStates",
	    value: function handleSelectAllStates(val, flag) {
	      this.props.selectAllState(val, flag);
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 100);
	    }
	  }, {
	    key: "handleSelectAllDMAStates",
	    value: function handleSelectAllDMAStates(stateIds, flag) {
	      var _this6 = this;
	
	      //this.props.selectCounty(countyObj, label, isChecked);
	      (0, _map2.default)(this.props.dmas, function (d) {
	        _this6.props.selectDMA(d, d.label.split(",")[1], flag);
	      });
	      this.props.selectAllState(stateIds, flag);
	
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 100);
	    }
	  }, {
	    key: "handleSelectAllCountyStates",
	    value: function handleSelectAllCountyStates(stateIds, flag) {
	      var _this7 = this;
	
	      (0, _map2.default)(this.props.counties, function (c) {
	        _this7.props.selectCounty(c, c.label.split(",")[1], flag);
	      });
	      this.props.selectAllState(stateIds, flag);
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 100);
	    }
	  }, {
	    key: "chooseSegmentValues",
	    value: function chooseSegmentValues(id, flag) {
	      var selected = this.props.selected_segments ? this.props.selected_segments : [];
	      var idx = selected ? selected.indexOf(id) : -1;
	      if (idx >= 0 && !flag) {
	        selected.splice(idx, 1);
	      } else {
	        if (flag && idx < 0) selected.push(id);
	      }
	      this.props.selectSegment(selected);
	
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 20);
	    }
	  }, {
	    key: "getValuesPanel",
	    value: function getValuesPanel() {
	      var _this8 = this,
	          _React$createElement;
	
	      if (this.state.selectedAttrId) {
	        var cat = this.state.selectedCatId == 0 ? geoCategory : (0, _find2.default)(this.props.demoAttributes, function (attrs) {
	          return _this8.state.selectedCatId == attrs.id;
	        });
	        var attr = (0, _find2.default)(cat.attributes, function (a) {
	          return _this8.state.selectedAttrId == a.id;
	        });
	        if (cat && attr) {
	          switch (this.state.selectedCatId) {
	            case 0:
	              switch (this.state.selectedAttrId) {
	                case 2:
	                  return _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    _react2.default.createElement(_GeoStatesPanel2.default, {
	                      key: cat.name + "+county_tree_panel",
	                      displayData: this.props.allstates,
	                      cities: this.props.counties,
	                      subTitle: "COUNTY",
	                      title: "State",
	                      onClick: function onClick(id) {
	                        _this8.setState({ selectedAttrId: id });
	                      },
	                      showSelectAll: false,
	                      selectCity: this.handleCountySelected.bind(this),
	                      selectState: this.handleCountyStateSelected.bind(this),
	                      selected_cities: this.props.selected_county,
	                      selected_states: this.props.selected_state,
	                      selectAllStates: this.handleSelectAllCountyStates.bind(this)
	                    })
	                  );
	                case 6:
	                  return _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1", position: "relative" } },
	                    _react2.default.createElement(_PlotMapPanel2.default, {
	                      key: this.state.mapKey,
	                      onClose: this.closeMapSelectDialog,
	                      getAudienceCount: this.props.getAudienceCount,
	                      clearAudienceCount: this.props.clearAudienceCount,
	                      onUpdateAudienceCount: this.updateAudienceCountWithPlotted.bind(this),
	                      onApplyChanges: this.handleApplyPlotted.bind(this),
	                      onCancelChanges: this._handleCancelPlotted.bind(this),
	                      plottedValue: this.props.plotted_values
	                    })
	                  );
	                case 7:
	                  return _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    _react2.default.createElement(_ZipcodePanel2.default, {
	                      addZipCode: this.handleZipcodeAdded.bind(this),
	                      zipcode: this.props.zipcode
	                    })
	                  );
	                case 4:
	                  return _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    _react2.default.createElement(_GeoStatesPanel2.default, {
	                      key: cat.name + "_dma_tree_panel",
	                      displayData: this.props.allstates,
	                      cities: this.props.dmas,
	                      subTitle: "DMA",
	                      title: "State",
	                      onClick: function onClick(id) {
	                        _this8.setState({ selectedAttrId: id });
	                      },
	                      showSelectAll: false,
	                      selectCity: this.handleDMASelected.bind(this),
	                      selectState: this.handleDMAStateSelected.bind(this),
	                      selected_cities: this.props.selected_dma,
	                      selected_states: this.props.selected_state,
	                      selectAllStates: this.handleSelectAllDMAStates.bind(this)
	                    })
	                  );
	                case 1:
	                default:
	                  return _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    _react2.default.createElement(_GeoStatesPanel2.default, {
	                      key: cat.name + "_state_city_tree_panel",
	                      displayData: this.props.allstates,
	                      cities: this.props.allcities,
	                      getCities: this.props.getCities,
	                      ifLoading: this.props.ifLoading,
	                      stateValues: this.props.all_state_cities,
	                      title: "State",
	                      subTitle: "City",
	                      onClick: function onClick(id) {
	                        _this8.setState({ selectedAttrId: id });
	                      },
	                      selectCity: this.handleCitySelected.bind(this),
	                      selectState: this.handleStateSelected.bind(this),
	                      selected_cities: this.props.selected_city,
	                      selected_states: this.props.selected_state,
	                      selectAllStates: this.handleSelectAllStates.bind(this)
	                    })
	                  );
	                  break;
	              }
	              break;
	            case 7:
	              switch (this.state.selectedAttrId) {
	                case 605:
	                case 606:
	                  var models = (0, _find2.default)(cat.attributes, function (a) {
	                    return a.id === 606;
	                  });
	                  return _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    _react2.default.createElement(_AutoMakePanel2.default, (_React$createElement = {
	                      makes: attr.values,
	                      models: models.values,
	                      granularity: attr.granularity
	                    }, _defineProperty(_React$createElement, "granularity", attr.granularity), _defineProperty(_React$createElement, "selected_make", this.props.selected_make), _defineProperty(_React$createElement, "selected_model", this.props.selected_model), _defineProperty(_React$createElement, "selectMake", this.handleAutoMakeSelected.bind(this)), _defineProperty(_React$createElement, "selectModel", this.handleAutoModelSelected.bind(this)), _defineProperty(_React$createElement, "selectAllAutoMakes", this.handleAllAutoMakeSelected.bind(this)), _React$createElement))
	                  );
	              }
	            case 15:
	              switch (this.state.selectedAttrId) {
	                case 1502:
	                case 1503:
	                  var locales = (0, _find2.default)(cat.attributes, function (a) {
	                    return a.id === 1503;
	                  });
	                  return _react2.default.createElement(
	                    "div",
	                    { style: { flexGrow: "1" } },
	                    _react2.default.createElement(_RegionLocalePanel2.default, {
	                      granularity: attr.granularity,
	                      regions: attr.values,
	                      locales: locales.values,
	                      selected_region: this.props.selected_culture_region,
	                      selected_locale: this.props.selected_culture_locale,
	                      selectRegion: this.handleCultureRegionSelected.bind(this),
	                      selectLocale: this.handleCultureLocaleSelected.bind(this)
	                    })
	                  );
	              }
	            default:
	              return attr.values ? _react2.default.createElement(
	                "div",
	                { style: { flexGrow: "1" } },
	                _react2.default.createElement(_ValuePanel2.default, {
	                  granularity: attr.granularity,
	                  key: attr.id + "_values_panel",
	                  displayData: attr.values,
	                  selected_segments: this.props.selected_segments,
	                  title: attr.name,
	                  onCheck: function onCheck(id, isChecked) {
	                    _this8.chooseSegmentValues(id, isChecked);
	                  }
	                })
	              ) : _react2.default.createElement(
	                "div",
	                { style: { flexGrow: "1" } },
	                _react2.default.createElement(_SubValuePanel2.default, {
	                  key: attr.id + "_subvalues_panel",
	                  displayData: attr.subAttributes,
	                  selected_segments: this.props.selected_segments,
	                  title: attr.name,
	                  onCheck: function onCheck(id, isChecked) {
	                    _this8.chooseSegmentValues(id, isChecked);
	                  }
	                })
	              );
	          }
	        }
	      }
	    }
	  }, {
	    key: "getAttrValuesPanel",
	    value: function getAttrValuesPanel() {
	      //if ()
	    }
	  }, {
	    key: "handleZipcodeAdded",
	    value: function handleZipcodeAdded(zipcode) {
	      this.props.addZipCode(zipcode);
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 200);
	    }
	  }, {
	    key: "handleCitySelected",
	    value: function handleCitySelected(cityObj, label, isInputChecked) {
	      this.props.selectCity(cityObj, label, isInputChecked);
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 200);
	    }
	  }, {
	    key: "handleStateSelected",
	    value: function handleStateSelected(id, isInputChecked) {
	      this.props.selectState(id, isInputChecked);
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 200);
	    }
	  }, {
	    key: "handleDMAStateSelected",
	    value: function handleDMAStateSelected(state, isInputChecked) {
	      var _this9 = this;
	
	      this.props.selectState(state, false);
	
	      (0, _map2.default)(this.props.dmas, function (dma) {
	        if (dma.label.indexOf(state.value) >= 0) {
	          _this9.props.selectDMA(dma, state.value, isInputChecked);
	        }
	      });
	      this.delayRecalculate();
	    }
	  }, {
	    key: "handleCountyStateSelected",
	    value: function handleCountyStateSelected(state, isInputChecked) {
	      var _this10 = this;
	
	      this.props.selectState(state, false);
	
	      (0, _map2.default)(this.props.counties, function (county) {
	        if (county.label.endsWith(", " + state.value)) {
	          _this10.props.selectCounty(county, state.value, isInputChecked);
	        }
	      });
	      this.delayRecalculate();
	    }
	  }, {
	    key: "handleCountySelected",
	    value: function handleCountySelected(countyObj, label, isChecked) {
	      this.props.selectCounty(countyObj, label, isChecked);
	      this.delayRecalculate();
	    }
	  }, {
	    key: "handleDMASelected",
	    value: function handleDMASelected(dmaObj, label, isChecked) {
	      this.props.selectDMA(dmaObj, label, isChecked);
	      this.delayRecalculate();
	    }
	  }, {
	    key: "handleAllAutoMakeSelected",
	    value: function handleAllAutoMakeSelected(isChecked) {
	      var _this11 = this;
	
	      var models = this.props.demoAttributes[0].attributes[2].values;
	      var selectedSegments = this.props.selected_segments ? this.props.selected_segments : [];
	      (0, _map2.default)(models, function (m) {
	        var idx = selectedSegments ? selectedSegments.indexOf(m.id) : -1;
	        if (idx >= 0) {
	          selectedSegments.splice(idx, 1);
	        } else {
	          selectedSegments.push(m.id);
	        }
	        _this11.props.selectModel(m, false);
	      });
	      var makes = this.props.demoAttributes[0].attributes[1].values;
	      (0, _map2.default)(makes, function (m) {
	        var idx = selectedSegments ? selectedSegments.indexOf(m.id) : -1;
	        if (idx >= 0) {
	          selectedSegments.splice(idx, 1);
	        } else {
	          selectedSegments.push(m.id);
	        }
	        _this11.props.selectMake(m, isChecked);
	      });
	      this.props.selectSegment(selectedSegments);
	
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 20);
	    }
	  }, {
	    key: "handleAutoMakeSelected",
	    value: function handleAutoMakeSelected(makeObj, isChecked) {
	      this.chooseSegmentValues(makeObj.id, isChecked);
	      this.props.selectMake(makeObj, isChecked);
	    }
	  }, {
	    key: "handleAutoModelSelected",
	    value: function handleAutoModelSelected(modelObj, isChecked) {
	      this.chooseSegmentValues(modelObj.id, isChecked);
	      this.props.selectModel(modelObj, isChecked);
	    }
	  }, {
	    key: "handleCultureRegionSelected",
	    value: function handleCultureRegionSelected(obj, isChecked) {
	      var _this12 = this;
	
	      var attrs = this.props.demoAttributes.find(function (attr) {
	        return attr.id === _this12.state.selectedCatId;
	      });
	      if (attrs) {
	        var target_attrs = attrs.attributes.find(function (l) {
	          return l.id === _this12.state.selectedAttrId;
	        });
	        var locales = (0, _filter2.default)(target_attrs.values, function (v) {
	          return v.label.split(" - ")[0] === obj.value;
	        });
	        (0, _map2.default)(locales, function (l) {
	          var selected = _this12.props.selected_segments ? _this12.props.selected_segments : [];
	
	          var idx = selected ? selected.indexOf(l.id) : -1;
	          if (idx >= 0) {
	            selected.splice(idx, 1);
	          } else {
	            selected.push(l.id);
	          }
	          _this12.props.selectSegment(selected);
	          _this12.props.selectCultureLocale(l, false);
	        });
	      }
	
	      this.props.selectCultureRegion(obj, isChecked);
	      this.chooseSegmentValues(obj.id, isChecked);
	      this.delayRecalculate();
	    }
	  }, {
	    key: "handleCultureLocaleSelected",
	    value: function handleCultureLocaleSelected(obj, isChecked) {
	      this.chooseSegmentValues(obj.id, isChecked);
	      this.props.selectCultureLocale(obj, isChecked);
	      this.delayRecalculate();
	    }
	  }, {
	    key: "handleSegmentNameChange",
	    value: function handleSegmentNameChange(e) {
	      this.props.setSegmentName(e.target.value);
	    }
	  }, {
	    key: "verifyAudience",
	    value: function verifyAudience() {
	      this.props.verifySegmentName(this.props.selected_client, this.props.segment_name);
	    }
	  }, {
	    key: "saveSegment",
	    value: function saveSegment() {
	      /*
	      if (this.state.disabledSaveBtn === true) return;
	      else this.setState({ disabledSaveBtn: true });*/
	
	      var segmentName = this.props.segment_name;
	      var client_name = this.props.selected_client_name.split(" ").join("_");
	
	      if (this.props.segment_name.indexOf(client_name) < 0) segmentName = (client_name + "_" + this.props.segment_name + "_" + (0, _moment2.default)().format("YYYYMMDD")).split(" ").join("_");
	      var newSegment = (0, _segment_util.parseSegment)(this.props, segmentName);
	      this.props.setSegmentName(segmentName);
	      this.props.saveSegment(newSegment);
	    }
	  }, {
	    key: "removeSelectedVal",
	    value: function removeSelectedVal(id) {
	      var _props = this.props,
	          selected_segments = _props.selected_segments,
	          selected_culture_region = _props.selected_culture_region,
	          selected_culture_locale = _props.selected_culture_locale,
	          selected_make = _props.selected_make,
	          selected_model = _props.selected_model;
	
	
	      var idx = selected_segments.indexOf(id);
	      if (idx >= 0) {
	        selected_segments.splice(idx, 1);
	        this.props.selectSegment(selected_segments);
	      }
	      var locale = (0, _find2.default)(selected_culture_locale, function (l) {
	        return l.id === id;
	      });
	      var region = (0, _find2.default)(selected_culture_region, function (r) {
	        return r.id === id;
	      });
	      var make = (0, _find2.default)(selected_make, function (m) {
	        return m.id === id;
	      });
	      var model = (0, _find2.default)(selected_model, function (m) {
	        return m.id === id;
	      });
	
	      if (locale) {
	        this.props.selectCultureLocale(locale, false);
	      }
	      if (region) {
	        this.props.selectCultureRegion(region, false);
	      }
	      if (make) {
	        this.props.selectMake(make, false);
	      }
	      if (model) {
	        this.props.selectModel(model, false);
	      }
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 200);
	    }
	  }, {
	    key: "removePlottedVal",
	    value: function removePlottedVal() {
	      this.props.setPlotValues({});
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 200);
	    }
	  }, {
	    key: "getSelectedAttrCount",
	    value: function getSelectedAttrCount() {
	      var _props2 = this.props,
	          selected_segments = _props2.selected_segments,
	          plotted_values = _props2.plotted_values,
	          selected_state = _props2.selected_state,
	          selected_city = _props2.selected_city,
	          zipcode = _props2.zipcode,
	          selected_county = _props2.selected_county,
	          selected_dma = _props2.selected_dma;
	
	      var sltAttrCount = 0;
	      if (selected_segments) sltAttrCount += selected_segments.length;
	      if (!(0, _isEmpty2.default)(plotted_values)) sltAttrCount += 1;
	      sltAttrCount += selected_state.length;
	      sltAttrCount += selected_city.length;
	      sltAttrCount += zipcode.length;
	      if (selected_county) sltAttrCount += selected_county.length;
	      if (selected_dma) sltAttrCount += selected_dma.length;
	
	      return sltAttrCount;
	    }
	  }, {
	    key: "handleOpenCancelDialog",
	    value: function handleOpenCancelDialog(e, status) {
	      e.preventDefault();
	      this.setState({
	        openCancel: status,
	        cancelAnchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "handleOpenResetDialog",
	    value: function handleOpenResetDialog(e, status) {
	      e.preventDefault();
	      this.setState({
	        openReset: status,
	        resetAnchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "getResetAllPopup",
	    value: function getResetAllPopup() {
	      var _this13 = this;
	
	      return _react2.default.createElement(
	        _materialUi.Popover,
	        {
	          open: this.state.openReset,
	          anchorEl: this.state.resetAnchorEl,
	          anchorOrigin: { horizontal: "right", vertical: "top" },
	          targetOrigin: { horizontal: "left", vertical: "center" },
	          onRequestClose: this.handleRequestClose
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              padding: "20px 30px",
	              fontSize: "16px"
	            }
	          },
	          "Are you sure you want to reset attributes?",
	          _react2.default.createElement("br", null),
	          "Any selections you have made will not be saved",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { style: { display: "flex", justifyContent: "space-between" } },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-link btn-sm cancel-btn mr-20 text-bold",
	                  onClick: function onClick(e) {
	                    _this13.handleOpenResetDialog(e, false);
	                  }
	                },
	                "Close"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-default btn-round btn-sm btn-aa-primary ml-20",
	                  onClick: function onClick(e) {
	                    e.preventDefault();
	                    _this13.props.clearAllCounty();
	                    _this13.props.clearAllDMA();
	                    _this13.props.clearAllSelectedCity();
	                    _this13.props.clearAllSelectedState();
	                    _this13.props.clearAllZipCode();
	                    _this13.props.clearAllAutoSelected();
	                    _this13.props.clearAllRegionSelected();
	                    _this13.props.clearAudienceCount();
	                    _this13.props.setPlotValues({});
	                    _this13.props.selectSegment([]);
	                    _this13.props.setSegmentName("");
	                    var segmentNameInput = _reactDom2.default.findDOMNode(_this13.refs.segmentNameInput);
	                    segmentNameInput.value = "";
	                    _this13.props.setTargetHouseholdOnly(false);
	                    _this13.setState({
	                      openReset: false,
	                      selectedCatId: undefined,
	                      selectedAttrId: undefined
	                    });
	                  }
	                },
	                "Yes, Reset"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getExitPopup",
	    value: function getExitPopup() {
	      var _this14 = this;
	
	      return _react2.default.createElement(
	        _materialUi.Popover,
	        {
	          open: this.state.openCancel,
	          anchorEl: this.state.cancelAnchorEl,
	          anchorOrigin: { horizontal: "right", vertical: "top" },
	          targetOrigin: { horizontal: "left", vertical: "center" },
	          onRequestClose: this.handleRequestClose
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              padding: "20px 30px",
	              fontSize: "16px"
	            }
	          },
	          "Are you sure you want to exit?",
	          _react2.default.createElement("br", null),
	          "Any selections you have made will not be saved",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { style: { display: "flex", justifyContent: "space-between" } },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-link btn-sm cancel-btn mr-20 text-bold",
	                  onClick: function onClick(e) {
	                    _this14.handleOpenCancelDialog(e, false);
	                  }
	                },
	                "Close"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-default btn-round btn-sm btn-aa-primary ml-20",
	                  onClick: function onClick(e) {
	                    e.preventDefault();
	                    window.location = "/segments/list/active" + (_this14.props.selected_client ? "?cid=" + _this14.props.selected_client : "");
	                  }
	                },
	                "Yes, exit"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "closeSelectedAttrDialog",
	    value: function closeSelectedAttrDialog() {
	      this.setState({
	        openViewSelected: false
	      });
	    }
	  }, {
	    key: "delayRecalculate",
	    value: function delayRecalculate() {
	      setTimeout(function () {
	        this.recalculateTotal();
	      }.bind(this), 200);
	    }
	  }, {
	    key: "getViewSelected",
	    value: function getViewSelected() {
	      var _this15 = this;
	
	      return _react2.default.createElement(
	        _materialUi.Dialog,
	        {
	          open: this.state.openViewSelected,
	          onRequestClose: this.closeSelectedAttrDialog.bind(this),
	          modal: false,
	          autoScrollBodyContent: true,
	          contentStyle: {
	            width: "1180px",
	            maxWidth: "none"
	          },
	          actionsContainerStyle: {
	            padding: "20px 40px"
	          },
	          actions: [_react2.default.createElement(
	            "a",
	            {
	              className: "btn btn-aa-info pt-10 pb-10 mr-20 pr-20",
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this15.closeSelectedAttrDialog();
	              }
	            },
	            "Close"
	          )]
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "text-default no-padding no-margin",
	            style: { marginTop: "-40px !important" }
	          },
	          _react2.default.createElement(_SelectedAttrs2.default, {
	            selectedAttrs: this.props.selected_segments,
	            plottedRadius: this.props.plotted_values,
	            selected_state: this.props.selected_state,
	            selected_city: this.props.selected_city,
	            selected_county: this.props.selected_county,
	            selected_dma: this.props.selected_dma,
	            categories: this.props.demoAttributes,
	            clearAllSelectedState: function clearAllSelectedState() {
	              _this15.props.clearAllSelectedState();
	              _this15.delayRecalculate();
	            },
	            clearAllSelectedCity: function clearAllSelectedCity() {
	              _this15.props.clearAllSelectedCity();
	              _this15.delayRecalculate();
	            },
	            clearAllZipCode: function clearAllZipCode() {
	              _this15.props.clearAllZipCode();
	              _this15.delayRecalculate();
	            },
	            clearZipCode: function clearZipCode(val) {
	              _this15.props.clearZipCode(val);
	              _this15.delayRecalculate();
	            },
	            clearAllCounty: function clearAllCounty() {
	              _this15.props.clearAllCounty();
	              _this15.delayRecalculate();
	            },
	            clearAllDMA: function clearAllDMA() {
	              _this15.props.clearAllDMA();
	              _this15.delayRecalculate();
	            },
	            selectState: function selectState(obj, checked) {
	              _this15.props.selectState(obj, checked);
	              _this15.delayRecalculate();
	            },
	            selectCity: function selectCity(obj, checked) {
	              _this15.props.selectCity(obj, checked);
	              _this15.delayRecalculate();
	            },
	            selectCounty: function selectCounty(obj, checked) {
	              _this15.props.selectCounty(obj, checked);
	              _this15.delayRecalculate();
	            },
	            selectDMA: function selectDMA(obj, checked) {
	              _this15.props.selectDMA(obj, checked);
	              _this15.delayRecalculate();
	            },
	            zipcode: this.props.zipcode,
	            width: this.state.width,
	            removeAttribute: this.removeSelectedVal.bind(this),
	            removePlottedVal: this.removePlottedVal.bind(this),
	            selected_make: this.props.selected_make,
	            selected_model: this.props.selected_model,
	            selected_client_name: this.props.selected_client_name
	          })
	        ),
	        _react2.default.createElement("div", { className: "text-right mt-20" })
	      );
	    }
	  }, {
	    key: "onSearchInputChange",
	    value: function onSearchInputChange(text) {
	      this.setState({
	        search_input: text
	      });
	    }
	  }, {
	    key: "handleSearchChange",
	    value: function handleSearchChange(e) {
	      var _this16 = this;
	
	      if (e) {
	        var result = e[0];
	        var demoAttributes = this.props.demoAttributes;
	
	        if (result["id"]) {
	          (0, _map2.default)(demoAttributes, function (cat) {
	            (0, _map2.default)((0, _flattenDeep2.default)(cat.attributes), function (attr) {
	              if (attr.id === result["id"]) {
	                //this.setState({ selectKeyPair: attr, hightlightCid: cat.id });
	                //ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";
	                _this16.setState({
	                  selectedCatId: cat.id,
	                  selectedAttrId: attr.id
	                });
	              }
	              (0, _map2.default)(attr.values, function (val) {
	                if (val.id === result["id"]) {
	                  /*
	                  this.setState({
	                    highlightAid: val.id,
	                    hightlightCid: cat.id,
	                    selectKeyPair: attr,
	                  });
	                  ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";*/
	                  _this16.setState({
	                    selectedCatId: cat.id,
	                    selectedAttrId: attr.id
	                  });
	                }
	              });
	              (0, _map2.default)(attr.subAttributes, function (subAttr) {
	                (0, _map2.default)(subAttr.values, function (val) {
	                  if (val.id === result["id"]) {
	                    _this16.setState({
	                      selectedCatId: cat.id,
	                      selectedAttrId: attr.id
	                    });
	                    /*
	                    this.setState({
	                      highlightAid: val.id,
	                      hightlightCid: cat.id,
	                      selectKeyPair: attr,
	                    });
	                    ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";*/
	                  }
	                });
	              });
	            });
	          });
	        }
	      }
	      /*
	      this.setState({
	        highlightId: 0,
	        highlightAid: 0,
	        hightlightCid: 0,
	        selectKeyPair: {},
	      });
	      if (e) {
	        const result = e[0];
	        if (result) {
	          this.setState({ highlightId: result["id"] });
	          const { demoAttributes } = this.props;
	           map(demoAttributes, cat => {
	            const group_id = "cat-attr-" + cat.id + "-item-group";
	             map(flattenDeep(cat.attributes), attr => {
	              if (attr.id === result["id"]) {
	                this.setState({ selectKeyPair: attr, hightlightCid: cat.id });
	                ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";
	              }
	              map(attr.values, val => {
	                if (val.id === result["id"]) {
	                  this.setState({
	                    highlightAid: val.id,
	                    hightlightCid: cat.id,
	                    selectKeyPair: attr,
	                  });
	                  ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";
	                }
	              });
	              map(attr.subAttributes, subAttr => {
	                map(subAttr.values, val => {
	                  if (val.id === result["id"]) {
	                    this.setState({
	                      highlightAid: val.id,
	                      hightlightCid: cat.id,
	                      selectKeyPair: attr,
	                    });
	                    ReactDOM.findDOMNode(this.refs[group_id]).style.height =
	                      "auto";
	                  }
	                });
	              });
	            });
	          });
	        }
	      }*/
	    }
	  }, {
	    key: "renderSearchMenu",
	    value: function renderSearchMenu(results, menuProps) {
	      var _this17 = this;
	
	      var idx = 0;
	
	      var equal_results = [];
	      var other_results = [];
	      (0, _map2.default)(results, function (result) {
	        if (result.label.toUpperCase() === _this17.state.search_input.toUpperCase()) equal_results.push(result);else other_results.push(result);
	      });
	
	      var match_grouped = (0, _groupBy2.default)(equal_results, function (r) {
	        return r.parent;
	      });
	      var match_items = Object.keys(match_grouped).sort().map(function (parent) {
	        return [!!idx && _react2.default.createElement(MenuDivider, { key: parent + "-divider" }), _react2.default.createElement(
	          MenuHeader,
	          { key: parent + "-header" },
	          parent
	        ), (0, _map2.default)(match_grouped[parent], function (obj) {
	          var item = _react2.default.createElement(
	            _reactBootstrapTypeahead.MenuItem,
	            { key: idx, option: obj, position: idx },
	            obj.label
	          );
	
	          idx++;
	          return item;
	        })];
	      });
	
	      var grouped = (0, _groupBy2.default)(other_results, function (r) {
	        return r.parent;
	      });
	      var items = Object.keys(grouped).sort().map(function (parent) {
	        return [!!idx && _react2.default.createElement(MenuDivider, { key: parent + "-divider" }), _react2.default.createElement(
	          MenuHeader,
	          { key: parent + "-header" },
	          parent
	        ), (0, _map2.default)(grouped[parent], function (obj) {
	          var item = _react2.default.createElement(
	            _reactBootstrapTypeahead.MenuItem,
	            { key: idx, option: obj, position: idx },
	            obj.label
	          );
	
	          idx++;
	          return item;
	        })];
	      });
	
	      return _react2.default.createElement(
	        _reactBootstrapTypeahead.Menu,
	        menuProps,
	        [match_items, items]
	      );
	    }
	  }, {
	    key: "ifDisabledExportButton",
	    value: function ifDisabledExportButton() {
	      if ((this.props.selected_dma.length > 0 || this.props.selected_city.length > 0 || this.props.selected_state.length > 0 || this.props.selected_county.length > 0 || this.props.zipcode.length > 0) && this.props.selected_segments.length > 0) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      this.computedSelectedGeo(nextProps);
	      this.computedSelectedOtherSegment(nextProps);
	    }
	  }, {
	    key: "requestDownloadCsvApi",
	    value: function requestDownloadCsvApi(data) {
	      fetch('/api/segments/grouping-counts', {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'Authorization': localStorage.getItem('aa_access_token')
	        },
	        body: JSON.stringify(data)
	      }).then(function (response) {
	        if (!response.ok) {
	          throw new Error('Failed to fetch the CSV file');
	        }
	        var disposition = response.headers.get('Content-Disposition');
	        var filename = 'download.csv'; // default filename
	
	        if (disposition && disposition.includes('filename=')) {
	          var match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
	          if (match && match[1]) {
	            filename = match[1].replace(/['"]/g, ''); // remove quotes
	          }
	        }
	
	        return response.blob().then(function (blob) {
	          return { blob: blob, filename: filename };
	        });
	      }).then(function (_ref) {
	        var blob = _ref.blob,
	            filename = _ref.filename;
	
	        var url = window.URL.createObjectURL(blob);
	        var a = document.createElement('a');
	        a.href = url;
	        a.download = filename;
	        document.body.appendChild(a);
	        a.click();
	        a.remove();
	        window.URL.revokeObjectURL(url);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this18 = this;
	
	      var segmentNameOnChange = (0, _utility.debounceEventHandler)(this.handleSegmentNameChange.bind(this), 500);
	      if ((0, _isEmpty2.default)(this.props.demoAttributes) || (0, _isEmpty2.default)(this.props.allstates)) {
	        return _react2.default.createElement(
	          "div",
	          {
	            style: {
	              border: "solid 1px black",
	              color: "#5C5C5C",
	              background: "#FFF"
	            }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-margin-bottom pt-20 pb-20",
	              style: { fontWeight: "300" }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  height: "600px",
	                  width: "100%",
	                  position: "relative",
	                  padding: "100px",
	                  fontSize: "24px",
	                  textAlign: "center"
	                }
	              },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } }),
	              "\xA0Data Loading..."
	            )
	          )
	        );
	      }
	      var categories = (0, _map2.default)(this.props.demoAttributes, function (attr) {
	        return {
	          name: attr.name,
	          id: attr.id
	        };
	      });
	      if (!(0, _isEmpty2.default)(categories)) categories.unshift({ name: "Geography", id: 0 });
	      return _react2.default.createElement(
	        "div",
	        { className: "audience-builder-main" },
	        this.getExitPopup(),
	        this.getResetAllPopup(),
	        this.getViewSelected(),
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border pl-20 pr-20 pb-20 mb-20" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Create Audience Segment"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pb-20 light-grey-bottom-border" },
	            (0, _utility.getUrlParameterByName)("step") === "confirm" ? "Review your inputs and selections you've made." : "Select a combination of attributes and value pairs to build your audience segment."
	          ),
	          (0, _utility.getUrlParameterByName)("step") === "confirm" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { display: "flex" } },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "70%", padding: "10px 0px 10px 40px" } },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Attributes(",
	                  this.getSelectedAttrCount(),
	                  ")"
	                )
	              ),
	              _react2.default.createElement("div", { style: { width: "25%", padding: "10px" } })
	            ),
	            _react2.default.createElement(_SelectedAttrs2.default, {
	              selected_state: this.props.selected_state,
	              selected_city: this.props.selected_city,
	              selected_county: this.props.selected_county,
	              selected_dma: this.props.selected_dma,
	              clearAllSelectedState: function clearAllSelectedState() {
	                _this18.props.clearAllSelectedState();
	                _this18.delayRecalculate();
	              },
	              clearAllSelectedCity: function clearAllSelectedCity() {
	                _this18.props.clearAllSelectedCity();
	                _this18.delayRecalculate();
	              },
	              clearAllZipCode: function clearAllZipCode() {
	                _this18.props.clearAllZipCode();
	                _this18.delayRecalculate();
	              },
	              clearZipCode: function clearZipCode(val) {
	                _this18.props.clearZipCode(val);
	                _this18.delayRecalculate();
	              },
	              clearAllCounty: function clearAllCounty() {
	                _this18.props.clearAllCounty();
	                _this18.delayRecalculate();
	              },
	              clearAllDMA: function clearAllDMA() {
	                _this18.props.clearAllDMA();
	                _this18.delayRecalculate();
	              },
	              selectState: function selectState(obj, checked) {
	                _this18.props.selectState(obj, checked);
	                _this18.delayRecalculate();
	              },
	              selectCity: function selectCity(obj, checked) {
	                _this18.props.selectCity(obj, checked);
	                _this18.delayRecalculate();
	              },
	              selectCounty: function selectCounty(obj, checked) {
	                _this18.props.selectCounty(obj, checked);
	                _this18.delayRecalculate();
	              },
	              selectDMA: function selectDMA(obj, checked) {
	                _this18.props.selectDMA(obj, checked);
	                _this18.delayRecalculate();
	              },
	              selectedAttrs: this.props.selected_segments,
	              plottedRadius: this.props.plotted_values,
	              categories: this.props.demoAttributes,
	              width: "100%",
	              hideTitle: true,
	              removeAttribute: this.removeSelectedVal.bind(this),
	              removePlottedVal: this.removePlottedVal.bind(this),
	              zipcode: this.props.zipcode
	            }),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  width: "100%",
	                  display: "flex",
	                  justifyContent: "space-between"
	                },
	                className: "pt-20 pb-20 light-grey-top-border"
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "280px", marginRight: "-20px" } },
	                " ",
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  label: "Target Primary Decision Maker",
	                  labelStyle: { fontSize: "16px" },
	                  iconStyle: { fill: "#A3A3A3", marginRight: "10px" },
	                  defaultChecked: Boolean(this.props.targetHouseholdsOnly),
	                  disabled: true
	                })
	              )
	            )
	          ) : _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              {
	                style: { display: "flex" },
	                className: "pt-20 pb-20 light-grey-bottom-border mb-20"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "pt-5" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Search Attribute"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "ml-20" },
	                _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	                  labelKey: "label",
	                  options: this.props.value_typehead,
	                  placeholder: "Select Attribute or Value Pair",
	                  minLength: 1,
	                  renderMenu: this.renderSearchMenu.bind(this),
	                  onChange: this.handleSearchChange.bind(this),
	                  onInputChange: this.onSearchInputChange.bind(this),
	                  style: { fontSize: "16px" },
	                  ref: function ref(typeahead) {
	                    return _this18.typeahead = typeahead;
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    flexGrow: "1",
	                    textAlign: "right",
	                    paddingTop: "10px"
	                  }
	                },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this18.setState({ openViewSelected: true });
	                    }
	                  },
	                  "View Attributes Selected"
	                )
	              )
	            ),
	            categories && _react2.default.createElement(
	              "div",
	              { style: { display: "flex" } },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_TreePanel2.default, {
	                  displayData: categories,
	                  title: "Category",
	                  selectedId: this.state.selectedCatId,
	                  onClick: function onClick(id) {
	                    _this18.setState({
	                      selectedCatId: id,
	                      selectedAttrId: null
	                    }); /*
	                        this.props.clearAudienceCount();
	                        this.props.clearAllSelectedState();
	                        this.props.clearAllSelectedCity();
	                        this.props.clearAllZipCode();
	                        this.props.clearAllDMA();
	                        this.props.clearAllCounty();*/
	                  }
	                })
	              ),
	              this.getAttributesPanel(),
	              this.getValuesPanel(),
	              this.getAttrValuesPanel()
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "100%" }, className: "pt-20 pb-20 text-right" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "#",
	                  className: this.getSelectedAttrCount() > 0 ? "btn btn-default btn-aa-default" : "btn btn-default btn-aa-default disabled",
	                  onClick: function onClick(e) {
	                    _this18.handleOpenResetDialog(e, true);
	                  }
	                },
	                "Reset Attributes"
	              )
	            ),
	            _react2.default.createElement("div", {
	              style: {
	                width: "100%",
	                display: "flex",
	                justifyContent: "space-between"
	              },
	              className: "pt-20 pb-20 light-grey-top-border"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                paddingTop: "18px",
	                background: "#F5F5F5",
	                height: "60px",
	                textAlign: "center"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Channel Reach"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                justifyContent: "space-between"
	              },
	              className: "pt-20 pb-20"
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement("img", { src: "/images/media_web.png" }),
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Email:"
	              ),
	              " ",
	              this.props.audience_total_count ? (0, _utility.splitNumber)(this.props.audience_total_count.email)() : ""
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement("img", { src: "/images/media_social.png" }),
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Social/Display:"
	              ),
	              " ",
	              this.props.audience_total_count ? (0, _utility.splitNumber)(this.props.audience_total_count.social)() : ""
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement("img", { src: "/images/media_email.png" }),
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Direct Mail:"
	              ),
	              " ",
	              this.props.audience_total_count ? (0, _utility.splitNumber)(this.props.audience_total_count.directMail)() : ""
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                display: "flex",
	                justifyContent: "space-between"
	              },
	              className: "pt-20 light-grey-top-border"
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { display: "flex" } },
	              _react2.default.createElement(
	                "strong",
	                { style: { paddingTop: "10px" } },
	                "Name the Audience "
	              ),
	              (0, _utility.getUrlParameterByName)("step") === "confirm" ? _react2.default.createElement(
	                "div",
	                { className: "ml-20 pt-10" },
	                this.props.segment_name
	              ) : _react2.default.createElement("input", {
	                type: "text",
	                ref: "segmentNameInput",
	                className: "ml-10 pt-5 pb-5 pl-10 pr-10",
	                style: {
	                  border: "solid 1px #B3B3B3",
	                  width: "400px",
	                  fontSize: "16px"
	                },
	                maxLength: 60,
	                onChange: segmentNameOnChange.bind(this),
	                defaultValue: this.props.segment_name
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  onClick: function onClick() {
	                    _this18.setState({
	                      openExportCsvModal: true
	                    });
	                  },
	                  className: this.ifDisabledExportButton() ? "btn btn-default btn-aa-default mr-20 disabled" : "btn btn-default btn-aa-default mr-20"
	                },
	                "Export"
	              ),
	              (0, _utility.getUrlParameterByName)("step") === "confirm" && _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-default btn-aa-default mr-20",
	                  onClick: function onClick(e) {
	                    e.preventDefault();
	                    window.history.back();
	                  }
	                },
	                "Back"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-aa-info mr-10 pt-10 pb-10 ml-10",
	                  href: "#",
	                  onClick: function onClick(e) {
	                    _this18.handleOpenCancelDialog(e, true);
	                  }
	                },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  className: (0, _isEmpty2.default)(this.props.segment_name) || this.getSelectedAttrCount() <= 0 ? "btn btn-default btn-aa-default disabled" : "btn btn-default btn-aa-default",
	                  onClick: function onClick(e) {
	                    e.preventDefault();
	                    if ((0, _utility.getUrlParameterByName)("step") === "confirm") _this18.saveSegment();else _this18.verifyAudience();
	                  },
	                  href: "#"
	                },
	                (0, _utility.getUrlParameterByName)("step") === "confirm" ? "Save" : "Next"
	              )
	            )
	          ),
	          this.state.errorVisible && _react2.default.createElement(
	            "div",
	            {
	              style: {
	                color: "#ff0000"
	              }
	            },
	            "This segment name already exists, please enter a unique segment name to continue",
	            " "
	          )
	        ),
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            open: this.state.openExportCsvModal,
	            title: _react2.default.createElement(
	              "div",
	              { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	              _react2.default.createElement(
	                "span",
	                null,
	                "Export Counts"
	              ),
	              _react2.default.createElement(
	                _materialUi.IconButton,
	                { onClick: function onClick() {
	                    _this18.setState({
	                      openExportCsvModal: false
	                    });
	                  } },
	                _react2.default.createElement(_close2.default, null)
	              )
	            ),
	            actions: [_react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-aa-info pt-10 pb-10 mr-20 pr-20",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this18.setState({
	                    openExportCsvModal: false
	                  });
	                }
	              },
	              "Close"
	            ), _react2.default.createElement(
	              "a",
	              {
	                onClick: this.handleExportCsv,
	                className: (this.state.exportCsvField.email || this.state.exportCsvField.socialDisplay || this.state.exportCsvField.directMail) && this.state.exportCsvField.geo.id && this.state.exportCsvField.other.id ? "btn btn-default btn-aa-default mr-20" : "btn btn-default btn-aa-default mr-20 disabled"
	              },
	              "Export"
	            )]
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: { display: 'flex' } },
	              _react2.default.createElement(
	                "div",
	                { style: { width: '694px' } },
	                "Channel"
	              ),
	              _react2.default.createElement(_materialUi.Checkbox, { label: "Email", checked: this.state.exportCsvField.email, onCheck: function onCheck(value, isChecked) {
	                  _this18.setState({
	                    exportCsvField: Object.assign({}, _this18.state.exportCsvField, {
	                      email: isChecked
	                    })
	                  });
	                } }),
	              _react2.default.createElement(_materialUi.Checkbox, { label: "Social/Display", checked: this.state.exportCsvField.socialDisplay, onCheck: function onCheck(value, isChecked) {
	                  _this18.setState({
	                    exportCsvField: Object.assign({}, _this18.state.exportCsvField, {
	                      socialDisplay: isChecked
	                    })
	                  });
	                } }),
	              _react2.default.createElement(_materialUi.Checkbox, { label: "Direct Mail", checked: this.state.exportCsvField.directMail, onCheck: function onCheck(value, isChecked) {
	                  _this18.setState({
	                    exportCsvField: Object.assign({}, _this18.state.exportCsvField, {
	                      directMail: isChecked
	                    })
	                  });
	                } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { display: 'flex', alignItems: 'center' } },
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: '28px', marginRight: '79px' } },
	                "Geography"
	              ),
	              _react2.default.createElement(
	                _SelectField2.default,
	                {
	                  fullWidth: true,
	                  maxHeight: 120,
	                  floatingLabelText: "Select an option",
	                  value: this.state.exportCsvField.geo.id,
	                  onChange: function onChange(e, index, value) {
	                    _this18.setState({
	                      exportCsvField: Object.assign({}, _this18.state.exportCsvField, {
	                        geo: {
	                          id: _this18.state.geoDropDownList[index].id,
	                          name: _this18.state.geoDropDownList[index].name
	                        }
	                      })
	                    });
	                  }
	                },
	                this.state.geoDropDownList.map(function (item) {
	                  return _react2.default.createElement(_MenuItem2.default, { value: item.id, primaryText: item.name, key: item.id });
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { display: 'flex', alignItems: 'center' } },
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: '28px', marginRight: '10px', width: '207px' } },
	                "Other Categories"
	              ),
	              _react2.default.createElement(
	                _SelectField2.default,
	                {
	                  fullWidth: true,
	                  maxHeight: 120,
	                  floatingLabelText: "Select an option",
	                  value: this.state.exportCsvField.other.id,
	                  onChange: function onChange(e, index, value) {
	                    _this18.setState({
	                      exportCsvField: Object.assign({}, _this18.state.exportCsvField, {
	                        other: {
	                          id: _this18.state.otherSegmentDropDownList[index].id,
	                          name: _this18.state.otherSegmentDropDownList[index].name
	                        }
	                      })
	                    });
	                  }
	                },
	                this.state.otherSegmentDropDownList.map(function (item) {
	                  return _react2.default.createElement(_MenuItem2.default, { value: item.id, primaryText: item.name, key: item.id });
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { display: 'flex', alignItems: 'center' } },
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: '28px', marginRight: '10px', width: '203px' } },
	                "Summary"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: '100%' } },
	                _react2.default.createElement(
	                  "section",
	                  null,
	                  "These selections will be applied to the export file"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { display: 'flex', flexWrap: 'wrap' } },
	                  this.state.exportCsvField.email && _react2.default.createElement(
	                    _Chip2.default,
	                    { style: { margin: '2px 4px' } },
	                    "Chanel:email"
	                  ),
	                  this.state.exportCsvField.socialDisplay && _react2.default.createElement(
	                    _Chip2.default,
	                    { style: { margin: '2px 4px' } },
	                    "Chanel:Social/Display"
	                  ),
	                  this.state.exportCsvField.directMail && _react2.default.createElement(
	                    _Chip2.default,
	                    { style: { margin: '2px 4px' } },
	                    "Chanel:Direct Mail"
	                  ),
	                  this.state.exportCsvField.geo && _react2.default.createElement(
	                    _Chip2.default,
	                    { style: { margin: '2px 4px' } },
	                    "Geography:" + this.state.exportCsvField.geo.name
	                  ),
	                  this.state.exportCsvField.other && _react2.default.createElement(
	                    _Chip2.default,
	                    { style: { margin: '2px 4px' } },
	                    "Other:" + this.state.exportCsvField.other.name
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AudienceBuilder;
	}(_MaterialUI2.default);
	
	exports.default = AudienceBuilder;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _materialUi = __webpack_require__(38);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(394);
	
	var _env = __webpack_require__(85);
	
	var _url = __webpack_require__(1030);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChangePassword = function (_AcquireWebComponent) {
	  _inherits(ChangePassword, _AcquireWebComponent);
	
	  function ChangePassword() {
	    _classCallCheck(this, ChangePassword);
	
	    return _possibleConstructorReturn(this, (ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).apply(this, arguments));
	  }
	
	  _createClass(ChangePassword, [{
	    key: "updateDimensions",
	    value: function updateDimensions() {
	      this.setState({
	        height: window.innerHeight + "px",
	        topPadding: (window.innerHeight - 480) / 2 + "px",
	        footerTop: (window.innerHeight - 480) / 2 - 20 + "px"
	      });
	    }
	  }, {
	    key: "retrieveSession",
	    value: function retrieveSession(session) {
	      this.session = JSON.parse(session);
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.updateDimensions();
	      this.setState({
	        password: "",
	        password2: ""
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var url = new _url.URL(window.location.href);
	      var reqKey = url && url.searchParams ? url.searchParams.get("requestKey") : url.search.replace("?requestKey=", "");
	      this.setState({
	        requestKey: reqKey
	      });
	      window.addEventListener("resize", this.updateDimensions.bind(this));
	      if (!this.props.apiBuildNumber) {
	        this.props.getAPIBuildNumber();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions.bind(this));
	    }
	  }, {
	    key: "handlePasswordChanged",
	    value: function handlePasswordChanged(e, value) {
	      this.setState({
	        password: value
	      });
	    }
	  }, {
	    key: "handlePasswordKeyPress",
	    value: function handlePasswordKeyPress(e) {
	      if (e.key === "Enter") {
	        if (!(0, _lodash.isEmpty)(this.state.password)) this.passwordReInput.refs.inputRef.focus();
	      }
	    }
	  }, {
	    key: "handlePasswordReEnterChanged",
	    value: function handlePasswordReEnterChanged(e, value) {
	      this.setState({
	        password2: value
	      });
	
	      if (value !== this.state.password) {
	        this.setState({
	          password2Tooltip: "Password and confirm must be equal."
	        });
	        setTimeout(function () {
	          this.passwordInput.refs.inputRef.focus();
	          this.passwordReInput.refs.inputRef.focus();
	        }.bind(this), 20);
	      } else {
	        this.setState({
	          password2Tooltip: undefined
	        });
	      }
	    }
	  }, {
	    key: "handlePasswordReEnterKeyPress",
	    value: function handlePasswordReEnterKeyPress(e) {
	      if (e.key === "Enter") {
	        this.btnSubmit.refs.container.button.focus();
	        this.props.resetPassword(this.state.password, this.state.password2, this.state.requestKey);
	      }
	    }
	  }, {
	    key: "clickContinue",
	    value: function clickContinue(e) {
	      e.preventDefault();
	      this.props.resetPassword(this.state.password, this.state.password2, this.state.requestKey);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var apiBuildNumber = this.props.apiBuildNumber;
	      var _props = this.props,
	          resetPasswordSuccess = _props.resetPasswordSuccess,
	          resetPasswordFailMessage = _props.resetPasswordFailMessage;
	
	      var hasErrorMessage = resetPasswordFailMessage !== undefined && resetPasswordSuccess !== true;
	      return _react2.default.createElement(
	        _Grid.Row,
	        {
	          className: "login-container",
	          style: { height: this.state.height, paddingTop: this.state.topPadding }
	        },
	        _react2.default.createElement(
	          _Grid.Col,
	          {
	            xs: "4",
	            sm: "4",
	            md: "4",
	            lg: "4",
	            offsetXs: "4",
	            offsetSm: "4",
	            offsetLg: "4",
	            offsetMd: "4"
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "text-center", style: { marginBottom: "-30px" } },
	            _react2.default.createElement("img", {
	              alt: "",
	              src: "/aa.png",
	              style: {
	                display: "inline-table",
	                marginTop: "-12px",
	                marginRight: "10px",
	                height: "36px"
	              }
	            }),
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  display: "inline-table",
	                  letterSpacing: "1.5pt",
	                  fontSize: "22pt",
	                  fontWeight: "600"
	                }
	              },
	              "AudienceAnywhere"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "text-center" },
	            _react2.default.createElement(
	              "div",
	              {
	                key: "send-reset-success",
	                className: "login-form",
	                style: {
	                  display: resetPasswordSuccess === true ? "block" : "none",
	                  color: "#000"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "30px", fontSize: "12pt" } },
	                " ",
	                "PASSWORD CHANGED"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "30px", marginBottom: "30px" } },
	                " ",
	                "Success! Your Password has been changed!"
	              ),
	              _react2.default.createElement("hr", { style: { color: "#000" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-right" },
	                _react2.default.createElement(
	                  "a",
	                  { className: "link-with-white", href: "/login" },
	                  "Back to log in"
	                ),
	                "\xA0|\xA0",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "link-with-white",
	                    href: "mailto:AudienceAnywhere@claritas.com"
	                  },
	                  "Contact",
	                  " "
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                key: "send-reset-form",
	                className: "login-form",
	                style: {
	                  display: resetPasswordSuccess !== true ? "block" : "none"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "text-left ", style: { color: "#000" } },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  "Choose a new password"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { display: hasErrorMessage ? "block" : "none" },
	                  className: "error-message-box"
	                },
	                _react2.default.createElement(
	                  "div",
	                  { style: { color: "red" } },
	                  resetPasswordFailMessage
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { color: "#000" }, className: "text-left mb-10" },
	                "Enter new password"
	              ),
	              _react2.default.createElement(_InputField2.default, {
	                ref: function ref(input) {
	                  _this2.passwordInput = input;
	                },
	                labelTitle: "",
	                key: "passwordInputField",
	                toolTipContent: this.state.passwordTooltip,
	                onChange: function onChange(e, value) {
	                  return _this2.handlePasswordChanged(e, value);
	                },
	                initValue: this.state.password,
	                hintText: "Enter your password",
	                inputType: "password",
	                onKeyDown: function onKeyDown(e) {
	                  return _this2.handlePasswordKeyPress(e);
	                }
	              }),
	              _react2.default.createElement(
	                "div",
	                { style: { color: "#000" }, className: "text-left mb-10" },
	                "Re-enter password"
	              ),
	              _react2.default.createElement(_InputField2.default, {
	                ref: function ref(input) {
	                  _this2.passwordReInput = input;
	                },
	                labelTitle: "",
	                key: "passwordReInputField",
	                toolTipContent: this.state.password2Tooltip,
	                onChange: function onChange(e, value) {
	                  return _this2.handlePasswordReEnterChanged(e, value);
	                },
	                initValue: this.state.password2,
	                hintText: "Re-enter your password",
	                inputType: "password",
	                onKeyDown: function onKeyDown(e) {
	                  return _this2.handlePasswordReEnterKeyPress(e);
	                }
	              }),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                backgroundColor: "#F56600",
	                ref: function ref(input) {
	                  _this2.btnSubmit = input;
	                },
	                labelColor: "#FFF",
	                key: "btn-continue",
	                disabled: (0, _lodash.isEmpty)(this.state.password) || (0, _lodash.isEmpty)(this.state.password2) || this.state.password !== this.state.password2,
	                style: { marginTop: "20px" },
	                onClick: this.clickContinue.bind(this),
	                label: "CONTINUE"
	              }),
	              _react2.default.createElement("hr", { style: { color: "#000" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-right" },
	                _react2.default.createElement(
	                  "a",
	                  { className: "link-with-white", href: "/login" },
	                  "Back to log in"
	                ),
	                "\xA0|\xA0",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "link-with-white",
	                    href: "mailto:AudienceAnywhere@claritas.com"
	                  },
	                  "Contact",
	                  " "
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "text-center", style: { color: "#FFFFFF" } },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "link-color-white",
	                target: "_blank",
	                href: "https://www.claritas.com/sites/default/files/files/Claritas%20Comprehensive%20Privacy%20Policy%20-%20Jan%202019.pdf"
	              },
	              "Privacy Policy"
	            ),
	            " ",
	            "- ",
	            _react2.default.createElement(
	              "span",
	              { className: "link-color-white" },
	              "Terms of use"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { xs: "12", sm: "12", md: "12", lg: "12" },
	          _env.uiBuildNumber && apiBuildNumber && _react2.default.createElement(
	            "span",
	            {
	              className: "pull-right text-right",
	              style: {
	                fontSize: "0.6em",
	                position: "absolute",
	                right: "0",
	                top: this.state.footerTop
	              }
	            },
	            _react2.default.createElement(
	              "small",
	              null,
	              "UI Build #",
	              _env.uiBuildNumber
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "small",
	              null,
	              "API Build #",
	              apiBuildNumber
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChangePassword;
	}(_MaterialUI2.default);
	
	exports.default = ChangePassword;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _utility = __webpack_require__(14);
	
	var _localSegmentSelecttion = __webpack_require__(536);
	
	var _localSegmentSelecttion2 = _interopRequireDefault(_localSegmentSelecttion);
	
	var _env = __webpack_require__(85);
	
	var _materialUi = __webpack_require__(38);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(394);
	
	__webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_AcquireWebComponent) {
	  _inherits(Login, _AcquireWebComponent);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    props.handleLogout();
	    window.localStorage.removeItem("session");
	    window.localStorage.removeItem("session_timestamp");
	    window.localStorage.clear();
	
	    _localSegmentSelecttion2.default.clearLocalData();
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: "updateDimensions",
	    value: function updateDimensions() {
	      this.setState({
	        height: window.innerHeight + "px",
	        topPadding: (window.innerHeight - 480) / 4 + "px",
	        footerTop: (window.innerHeight - 480) / 2 - 80 + "px"
	      });
	    }
	  }, {
	    key: "retrieveSession",
	    value: function retrieveSession(session) {
	      this.session = JSON.parse(session);
	    }
	  }, {
	    key: "getTokenAfterLogin",
	    value: function getTokenAfterLogin() {
	      if (this.props.token) {
	        return {
	          key: "session",
	          val: {
	            loginTime: new Date(),
	            token: this.props.token,
	            userId: this.props.userId,
	            roleId: this.props.roleId,
	            roleName: this.props.roleName,
	            apiBuildNumber: this.props.apiBuildNumber,
	            tokenExpirationTime: this.props.tokenExpirationTime
	          }
	        };
	      }
	      return null;
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(e) {
	      if (e.key === "Enter") {
	        this.handleContinue();
	      }
	    }
	  }, {
	    key: "handlePasswordKeyPress",
	    value: function handlePasswordKeyPress(e) {
	      if (e.key === "Enter") {
	        this.handleLogin();
	      }
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.updateDimensions();
	      this.setState({
	        usernameTooltip: undefined,
	        passwordTooltip: undefined,
	        pwdInputOpacity: 0,
	        unameInputOpacity: 1,
	        username: "",
	        inputMode: "username",
	        apiBuildNumber: undefined,
	        submit: false
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      window.addEventListener("resize", this.updateDimensions.bind(this));
	      if ((0, _lodash.isObject)(this.session)) {
	        this.props.mountSession(this.session);
	      } else {
	        this.session = {};
	        this.props.handleLogout();
	        window.localStorage.clear();
	      }
	      this.usernameInput.refs.inputRef.focus();
	      if (!this.props.apiBuildNumber) {
	        this.props.getAPIBuildNumber();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions.bind(this));
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.loggedIn === true && this.props.loggedIn !== nextProps.loggedIn) {
	        this.session = {
	          key: "session",
	          val: {
	            loginTime: new Date(),
	            token: nextProps.token,
	            userId: nextProps.userId,
	            roleId: nextProps.roleId,
	            roleName: nextProps.roleName,
	            apiBuildNumber: nextProps.apiBuildNumber,
	            tokenExpirationTime: nextProps.tokenExpirationTime
	          }
	        };
	        this.props.mountSession(this.session);
	        setTimeout(function () {
	          var redirectUrl = (0, _utility.getUrlParameterByName)("redirect");
	          if (!(0, _lodash.isEmpty)(redirectUrl) && redirectUrl.indexOf("/insights/audience") >= 0) {
	            window.location = redirectUrl;
	          } else {
	            window.location = "/";
	          }
	        }, 1000);
	      } else {
	        if (nextProps.loginErrorMessage) {
	          this.setState({ submit: false });
	        }
	      }
	    }
	  }, {
	    key: "handleUsernameChanged",
	    value: function handleUsernameChanged(e, value) {
	      var uname = value.trim();
	      if (uname === "") {
	        this.setState({
	          usernameTooltip: "Please enter an Email or Username",
	          username: ""
	        });
	      } else {
	        this.setState({
	          usernameTooltip: undefined,
	          username: uname
	        });
	      }
	    }
	  }, {
	    key: "handlePasswordChanged",
	    value: function handlePasswordChanged(e, value) {
	      var pwd = value.trim();
	      if (pwd === "" || pwd === undefined) {
	        this.setState({
	          passwordTooltip: "Please enter your password",
	          password: undefined
	        });
	      } else this.setState({
	        password: pwd,
	        passwordTooltip: undefined
	      });
	    }
	  }, {
	    key: "handleContinue",
	    value: function handleContinue() {
	      //this.btnContinue.refs.container.button.focus()
	      this.passwordInput.refs.inputRef.focus();
	      if (this.state.username.trim() === "") {
	        this.setState({
	          usernameTooltip: "Please enter an Email or Username"
	        });
	        setTimeout(function () {
	          this.usernameInput.refs.inputRef.focus();
	        }.bind(this), 20);
	        return;
	      }
	      this.setState({ inputMode: "password", usernameTooltip: undefined });
	      setTimeout(function () {
	        this.setState({
	          pwdInputOpacity: 1
	        });
	        this.passwordInput.refs.inputRef.focus();
	      }.bind(this), 20);
	    }
	  }, {
	    key: "handleUpdateUserName",
	    value: function handleUpdateUserName(e) {
	      e.preventDefault();
	      this.setState({
	        inputMode: "username",
	        password: "",
	        pwdInputOpacity: 0,
	        usernameTooltip: undefined,
	        passwordTooltip: undefined
	      });
	    }
	  }, {
	    key: "handleLogin",
	    value: function handleLogin() {
	      this.setState({
	        submit: true
	      });
	      this.btnLogin.refs.container.button.focus();
	      var password = this.state.password;
	      if (password === "" || password === undefined) {
	        this.setState({
	          passwordTooltip: "Please enter your password"
	        });
	        setTimeout(function () {
	          this.passwordInput.refs.inputRef.focus();
	        }.bind(this), 20);
	        return;
	      } else {
	        this.setState({
	          passwordTooltip: undefined
	        });
	        this.props.handleLoginSubmit(this.state.username, this.state.password);
	      }
	    }
	  }, {
	    key: "displayErrorMessage",
	    value: function displayErrorMessage() {
	      var error = (0, _utility.getUrlParameterByName)("error");
	      if ((this.props.loginErrorMessage || error) && !this.state.submit) {
	        return _react2.default.createElement(
	          "div",
	          { className: "rc-tooltip-content" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "rc-tooltip-inner mb-20",
	              style: { borderColor: "#000", backgroundColor: "#EBEBEB" }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "red" } },
	              this.props.loginErrorMessage ? this.props.loginErrorMessage : error,
	              " "
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var apiBuildNumber = this.props.apiBuildNumber;
	
	      return _react2.default.createElement(
	        _Grid.Row,
	        {
	          className: "login-container",
	          style: {
	            height: this.state.height,
	            paddingTop: this.state.topPadding,
	            fontSize: "16px"
	          }
	        },
	        _react2.default.createElement(
	          _Grid.Col,
	          {
	            xs: "4",
	            sm: "4",
	            md: "4",
	            lg: "4",
	            offsetXs: "4",
	            offsetSm: "4",
	            offsetLg: "4",
	            offsetMd: "4"
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "text-center", style: { marginBottom: "-10px" } },
	            _react2.default.createElement(
	              "div",
	              { className: "login-form", style: { width: "400px" } },
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "text-center no-padding no-margin-bottom" },
	                _react2.default.createElement("img", {
	                  alt: "",
	                  src: "/images/logo.png",
	                  style: { display: "inline-table", height: "48px" }
	                }),
	                _react2.default.createElement("hr", { style: { borderTop: "solid 1px #000" } })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "pl-20 pr-20" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      color: "#000000",
	                      textAlign: "left",
	                      marginBottom: "10px",
	                      fontWeight: "bold",
	                      fontSize: "24px"
	                    }
	                  },
	                  "Sign in"
	                ),
	                this.displayErrorMessage(),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      color: "#000000",
	                      marginBottom: "-10px",
	                      marginTop: "20px"
	                    },
	                    className: "text-left"
	                  },
	                  "Email"
	                ),
	                _react2.default.createElement(_InputField2.default, {
	                  ref: function ref(input) {
	                    _this2.usernameInput = input;
	                  },
	                  labelTitle: "",
	                  key: "usernameInputField",
	                  toolTipContent: this.state.usernameTooltip,
	                  onChange: function onChange(e, value) {
	                    return _this2.handleUsernameChanged(e, value);
	                  },
	                  initValue: this.state.username,
	                  hintText: "Enter Email or Username"
	                  /*style={{display: this.state.inputMode === "username" ? "block":"none"}}*/
	                  , onKeyDown: function onKeyDown(e) {
	                    return _this2.handleKeyPress(e);
	                  }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      color: "#000000",
	                      marginBottom: "-10px",
	                      marginTop: "20px"
	                    },
	                    className: "text-left"
	                  },
	                  "Password"
	                ),
	                _react2.default.createElement(_InputField2.default, {
	                  ref: function ref(input) {
	                    _this2.passwordInput = input;
	                  },
	                  labelTitle: "",
	                  key: "passwordInputField",
	                  toolTipContent: this.state.passwordTooltip,
	                  onChange: function onChange(e, value) {
	                    return _this2.handlePasswordChanged(e, value);
	                  },
	                  initValue: this.state.password,
	                  hintText: "Enter your password",
	                  inputType: "password",
	                  onKeyDown: function onKeyDown(e) {
	                    return _this2.handlePasswordKeyPress(e);
	                  }
	                  /*style={{display: this.state.inputMode === "password" ? "block":"none", opacity: this.state.pwdInputOpacity}}*/
	                })
	              ),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                ref: function ref(input) {
	                  _this2.btnLogin = input;
	                },
	                backgroundColor: "#F56600",
	                key: "btn-login",
	                labelColor: "#FFF",
	                onClick: this.handleLogin.bind(this),
	                disabled: (0, _lodash.isEmpty)(this.state.username) || (0, _lodash.isEmpty)(this.state.password) || this.state.submit,
	                style: {
	                  backgroundColor: "#F56600",
	                  marginTop: "10px",
	                  marginBottom: "10px",
	                  textTransform: "capitalize",
	                  fontFamily: "Arial"
	                },
	                label: "Sign In"
	              }),
	              this.state.submit && _react2.default.createElement(
	                "span",
	                {
	                  style: {
	                    position: "absolute",
	                    bottom: "100px",
	                    right: "185px"
	                  }
	                },
	                _react2.default.createElement("img", { style: { width: "25px" }, src: "/Spinner.gif", alt: "" })
	              ),
	              _react2.default.createElement("hr", { style: { borderTop: "solid 1px #000" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-right" },
	                _react2.default.createElement(
	                  "a",
	                  { className: "link-with-white", href: "/resetpassword" },
	                  "Can't sign in?"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "text-center mt-20", style: { color: "#FFFFFF" } },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "link-color-white",
	                target: "_blank",
	                href: "https://www.claritas.com/sites/default/files/files/Claritas%20Comprehensive%20Privacy%20Policy%20-%20Jan%202019.pdf"
	              },
	              "Privacy Policy"
	            ),
	            " ",
	            "- ",
	            _react2.default.createElement(
	              "span",
	              { className: "link-color-white" },
	              "Terms of use"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "mt-20 mb-20" },
	              _react2.default.createElement(
	                "a",
	                { href: "https://www.claritas.com/", target: "_blank" },
	                _react2.default.createElement("img", {
	                  alt: "",
	                  src: "/images/claritas-logo.png",
	                  style: { display: "inline-table", height: "28px" }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Copyright \xA9 2019 Claritas, LLC. All rights reserved. "
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { xs: "12", sm: "12", md: "12", lg: "12" },
	          _env.uiBuildNumber && apiBuildNumber && _react2.default.createElement(
	            "span",
	            {
	              className: "pull-right text-right",
	              style: {
	                fontSize: "0.6em",
	                position: "absolute",
	                right: "20",
	                top: this.state.footerTop
	              }
	            },
	            _react2.default.createElement(
	              "small",
	              null,
	              "UI Build #",
	              _env.uiBuildNumber
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "small",
	              null,
	              "API Build #",
	              apiBuildNumber
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_MaterialUI2.default);
	
	exports.default = Login;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _materialUi = __webpack_require__(38);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(394);
	
	var _env = __webpack_require__(85);
	
	var _reactRecaptcha = __webpack_require__(2984);
	
	var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPassword = function (_AcquireWebComponent) {
	  _inherits(ResetPassword, _AcquireWebComponent);
	
	  function ResetPassword() {
	    _classCallCheck(this, ResetPassword);
	
	    return _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).apply(this, arguments));
	  }
	
	  _createClass(ResetPassword, [{
	    key: "updateDimensions",
	    value: function updateDimensions() {
	      this.setState({
	        height: window.innerHeight + "px",
	        topPadding: (window.innerHeight - 480) / 2 + "px",
	        footerTop: (window.innerHeight - 480) / 2 - 20 + "px"
	      });
	    }
	  }, {
	    key: "retrieveSession",
	    value: function retrieveSession(session) {
	      this.session = JSON.parse(session);
	    }
	  }, {
	    key: "getTokenAfterLogin",
	    value: function getTokenAfterLogin() {
	      if (this.props.token) {
	        return {
	          key: "session",
	          val: {
	            loginTime: new Date(),
	            token: this.props.token,
	            userId: this.props.userId,
	            roleId: this.props.roleId,
	            roleName: this.props.roleName,
	            tokenExpirationTime: this.props.tokenExpirationTime,
	            apiBuildNumber: this.props.apiBuildNumber
	          }
	        };
	      }
	      return null;
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.updateDimensions();
	      this.setState({
	        emailTooltip: undefined,
	        email: "",
	        captchaReady: false
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      window.addEventListener("resize", this.updateDimensions.bind(this));
	      if (!this.props.apiBuildNumber) {
	        this.props.getAPIBuildNumber();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions.bind(this));
	    }
	  }, {
	    key: "handleEmailChanged",
	    value: function handleEmailChanged(e, value) {
	      this.setState({
	        email: value
	      });
	    }
	  }, {
	    key: "handleSendRecovery",
	    value: function handleSendRecovery(e) {
	      e.preventDefault();
	      this.props.sendPasswordRecoveryEmail(this.state.email, this.state.secretKey);
	      this.recaptchaInstance.reset();
	    }
	  }, {
	    key: "onLoadCallback",
	    value: function onLoadCallback() {
	      this.setState({ captchaReady: false, secretKey: undefined });
	    }
	  }, {
	    key: "verifyCallback",
	    value: function verifyCallback(response) {
	      this.setState({ captchaReady: true, secretKey: response });
	    }
	  }, {
	    key: "expiredCallback",
	    value: function expiredCallback() {
	      this.setState({ captchaReady: false, secretKey: undefined });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var apiBuildNumber = this.props.apiBuildNumber;
	      var _props = this.props,
	          sendRecoveryEmailFailMessage = _props.sendRecoveryEmailFailMessage,
	          sendRecoveryEmailSuccess = _props.sendRecoveryEmailSuccess;
	
	      var hasErrorMessage = sendRecoveryEmailFailMessage !== undefined && sendRecoveryEmailSuccess !== true;
	      return _react2.default.createElement(
	        _Grid.Row,
	        {
	          className: "login-container",
	          style: { height: this.state.height, paddingTop: this.state.topPadding }
	        },
	        _react2.default.createElement(
	          _Grid.Col,
	          {
	            xs: "4",
	            sm: "4",
	            md: "4",
	            lg: "4",
	            offsetXs: "4",
	            offsetSm: "4",
	            offsetLg: "4",
	            offsetMd: "4"
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "text-center no-padding no-margin-bottom" },
	            _react2.default.createElement("img", {
	              alt: "",
	              src: "/images/logo.png",
	              style: {
	                display: "inline-table",
	                marginTop: "-12px",
	                marginRight: "10px",
	                height: "48px"
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "text-center" },
	            _react2.default.createElement(
	              "div",
	              {
	                key: "send-reset-success",
	                className: "login-form",
	                style: {
	                  display: sendRecoveryEmailSuccess === true ? "block" : "none",
	                  color: "#000"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "30px", fontSize: "12pt" } },
	                " ",
	                "We've send you a verification email."
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "30px" } },
	                " ",
	                "We sent a recovery link to your email address."
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginBottom: "30px" } },
	                this.state.email
	              ),
	              _react2.default.createElement("hr", { style: { color: "#000" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-right" },
	                _react2.default.createElement(
	                  "a",
	                  { className: "link-with-white", href: "/resetpassword" },
	                  "Resend recovery link",
	                  " "
	                ),
	                "\xA0|\xA0",
	                _react2.default.createElement(
	                  "a",
	                  { className: "link-with-white", href: "/login" },
	                  "Back to log in"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                key: "send-reset-form",
	                className: "login-form",
	                style: {
	                  display: sendRecoveryEmailSuccess !== true ? "block" : "none"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "text-left ", style: { color: "#000" } },
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Reset Password"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { display: hasErrorMessage ? "block" : "none" },
	                  className: "error-message-box"
	                },
	                _react2.default.createElement(
	                  "div",
	                  { style: { color: "red" } },
	                  sendRecoveryEmailFailMessage
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { color: "#000" }, className: "text-left" },
	                "We'll send a recovery link to"
	              ),
	              _react2.default.createElement(_InputField2.default, {
	                labelTitle: "",
	                key: "usernameInputField",
	                toolTipContent: this.state.emailTooltip,
	                onChange: function onChange(e, value) {
	                  return _this2.handleEmailChanged(e, value);
	                },
	                initValue: this.state.email,
	                hintText: "Enter your email",
	                style: { marginBottom: "20px" }
	              }),
	              _react2.default.createElement(_reactRecaptcha2.default, {
	                sitekey: "6LeCRTMUAAAAAHF6VoY2v3rjshzumDH6SFLzeMfR",
	                ref: function ref(e) {
	                  return _this2.recaptchaInstance = e;
	                },
	                onloadCallback: this.onLoadCallback.bind(this),
	                verifyCallback: this.verifyCallback.bind(this),
	                expiredCallback: this.expiredCallback.bind(this),
	                render: "explicit"
	              }),
	              _react2.default.createElement(_materialUi.RaisedButton, {
	                backgroundColor: "#F56600",
	                labelColor: "#FFF",
	                key: "btn-continue",
	                disabled: (0, _lodash.isEmpty)(this.state.email) || this.state.captchaReady === false,
	                style: { marginTop: "20px" },
	                onClick: this.handleSendRecovery.bind(this),
	                label: "SUBMIT"
	              }),
	              _react2.default.createElement("hr", { style: { color: "#000" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-right" },
	                _react2.default.createElement(
	                  "a",
	                  { className: "link-with-white", href: "/login" },
	                  "Back to log in"
	                ),
	                "\xA0|\xA0",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "link-with-white",
	                    href: "mailto:AudienceAnywhere@claritas.com"
	                  },
	                  "Contact",
	                  " "
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { xs: "12", sm: "12", md: "12", lg: "12" },
	          _env.uiBuildNumber && apiBuildNumber && _react2.default.createElement(
	            "span",
	            {
	              className: "pull-right text-right",
	              style: {
	                fontSize: "0.6em",
	                position: "absolute",
	                right: "0",
	                top: this.state.footerTop
	              }
	            },
	            _react2.default.createElement(
	              "small",
	              null,
	              "UI Build #",
	              _env.uiBuildNumber
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "small",
	              null,
	              "API Build #",
	              apiBuildNumber
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_MaterialUI2.default);
	
	exports.default = ResetPassword;

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	__webpack_require__(222);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var arrowStyles = {
	  position: 'absolute',
	  right: '5px',
	  top: '5px'
	};
	
	var CampaignsTable = function (_Component) {
	  _inherits(CampaignsTable, _Component);
	
	  function CampaignsTable(props) {
	    _classCallCheck(this, CampaignsTable);
	
	    var _this = _possibleConstructorReturn(this, (CampaignsTable.__proto__ || Object.getPrototypeOf(CampaignsTable)).call(this, props));
	
	    _this.state = {
	      activeIndex: props.activeIndex,
	      arrowActive: 'down',
	      bodyData: props.bodyDataArr
	    };
	    return _this;
	  }
	
	  _createClass(CampaignsTable, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _isEqual2.default)(nextProps.bodyDataArr.slice().sort(), this.props.bodyDataArr.slice().sort())) {
	        /*
	        let sortField = ""
	        switch(this.state.activeIndex){
	          case 0:
	            sortField = "name";
	            break;
	          case 1:
	            sortField = "campaignId";
	            break;
	          case 2:
	            sortField = "clientCampaignId";
	            break;
	          case 4:
	            sortField = "startDate";
	            break;
	          case 5:
	            sortField = "endDate";
	            break;
	          case 3:
	            sortField = "status";
	            break;
	          default:
	            sortField = "name";
	            break;
	        }*/
	
	        /*const list = this.state.arrowActive === 'up' ? sortBy(nextProps.bodyDataArr, (data)=>{
	          return data[sortField];
	        }) : reverse(sortBy(nextProps.bodyDataArr, (data)=>{
	          return data[sortField];
	        }))*/
	
	        this.setState({
	          bodyData: nextProps.bodyDataArr
	        });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(index) {
	      this.setState({
	        activeIndex: index
	      });
	      var sortDesc = false;
	      if (+index === this.state.activeIndex) {
	        if (this.state.arrowActive === 'down') {
	          this.setState({
	            arrowActive: 'up'
	          });
	        } else {
	          this.setState({
	            arrowActive: 'down'
	          });
	          sortDesc = true;
	        }
	      } else {
	        this.setState({
	          arrowActive: 'down'
	        });
	        sortDesc = true;
	      }
	
	      var sortField = "";
	      switch (index) {
	        case 0:
	          sortField = "campaignName";
	          break;
	        case 1:
	          sortField = "campaignId";
	          break;
	        case 2:
	          sortField = "clientCampaignId";
	          break;
	        case 4:
	          sortField = "startDate";
	          break;
	        case 5:
	          sortField = "endDate";
	          break;
	        case 3:
	          sortField = "status";
	          break;
	        default:
	          sortField = "campaignName";
	          break;
	      }
	
	      this.props.handleSearch(sortField, sortDesc);
	      /*
	          const list = sortDesc ? reverse(sortBy(this.state.bodyData, (data)=>{
	            return data[sortField];
	          })) : sortBy(this.state.bodyData, (data)=>{
	            return data[sortField];
	          })
	      
	          this.setState({
	            bodyData: list
	          })*/
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'spread-table' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              this.props.tableHeaderArr.map(function (item, index) {
	                var widthStyle = '';
	                switch (index) {
	                  case 0:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[0];
	                    break;
	                  case 1:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[1];
	                    break;
	                  case 2:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[2];
	                    break;
	                  case 3:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[3];
	                    break;
	                  case 4:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[4];
	                    break;
	                  case 5:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[5];
	                    break;
	                  case 6:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[6];
	                    break;
	                  default:
	                    widthStyle = '';
	                    break;
	                }
	                return _react2.default.createElement(
	                  'th',
	                  { key: item.value,
	                    className: _this2.state.activeIndex === index ? 'active no-padding-right' : 'no-padding-right',
	                    onClick: function onClick(e) {
	                      _this2.props.sortable ? _this2.handleClick(index) : e.preventDefault();
	                    },
	                    style: { width: widthStyle, whiteSpace: 'pre-wrap' }
	                  },
	                  item.label,
	                  _this2.state.activeIndex === index && _this2.props.sortable && _this2.state.arrowActive === 'down' && _react2.default.createElement(_arrowDropDown2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  }),
	                  _this2.state.activeIndex === index && _this2.props.sortable && _this2.state.arrowActive === 'up' && _react2.default.createElement(_arrowDropUp2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  })
	                );
	              })
	            ),
	            this.state.bodyData.map(function (item, index) {
	              return _react2.default.createElement(
	                'tr',
	                { key: index },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: 'campaign-name-link', to: '/campaigns/report/' + item.id },
	                    item.name
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  item.campaignId
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  item.clientCampaignId ? item.clientCampaignId : ''
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  item.status
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  item.startDate
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  item.endDate
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _this2.props.canEdit && _react2.default.createElement(
	                    'a',
	                    { style: { marginLeft: '-10px' }, onClick: function onClick(e) {
	                        _this2.props.handleClickEditCampaign(e, item.id);
	                      } },
	                    _react2.default.createElement('i', { className: 'icon-pencil4', style: { color: "#BEBEBE" } })
	                  )
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignsTable;
	}(_react.Component);
	
	CampaignsTable.defaultProps = {
	  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
	  bodyDataArr: [],
	  bodyDataKey: [],
	  activeIndex: 4,
	  renderCols: {
	    addCol: '',
	    cols: []
	  },
	  canEdit: false,
	  sortable: true
	};
	
	exports.default = CampaignsTable;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(213);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _index = __webpack_require__(15);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(595);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _AddCampaignDialog = __webpack_require__(511);
	
	var _AddCampaignDialog2 = _interopRequireDefault(_AddCampaignDialog);
	
	var _Grid = __webpack_require__(19);
	
	var _deploymentCampaigns = __webpack_require__(1059);
	
	var _deploymentCampaigns2 = _interopRequireDefault(_deploymentCampaigns);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @property title {string}
	 * @property ifHasCampaigns {boolean}
	 */
	var AddCampaign = function (_AcquireWebComponent) {
	  _inherits(AddCampaign, _AcquireWebComponent);
	
	  function AddCampaign(props) {
	    _classCallCheck(this, AddCampaign);
	
	    var _this = _possibleConstructorReturn(this, (AddCampaign.__proto__ || Object.getPrototypeOf(AddCampaign)).call(this, props));
	
	    _this.state = {
	      openDialog: props.openDialog,
	      emailReportType: "delivered",
	      emailReportDelivered: props.parentCampaignDetail ? props.parentCampaignDetail.emailReportDelivered : true,
	      emailReportDistinctIndividuals: props.parentCampaignDetail ? props.parentCampaignDetail.emailReportDistinctIndividuals : undefined,
	      openDelConfirm: false,
	      removeCampaignId: undefined,
	      removeDeployName: undefined,
	      openDeploymentDialog: false,
	      openDelDeploymentDialog: false,
	      deployNameError: undefined
	    };
	    if (props.legacy && !props.viewMode) {
	      props.addDeployment("default", props.title);
	    }
	    return _this;
	  }
	
	  _createClass(AddCampaign, [{
	    key: "onAddDeploymentBtnClick",
	    value: function onAddDeploymentBtnClick(e) {
	      e.preventDefault();
	      this.setState({
	        openDeploymentDialog: true
	      });
	    }
	  }, {
	    key: "onAddSegmentBtnClick",
	    value: function onAddSegmentBtnClick(e) {
	      e.preventDefault();
	      this.props.addDeployment("default", this.props.title);
	    }
	  }, {
	    key: "onDevploymentDialogClose",
	    value: function onDevploymentDialogClose(e) {
	      e.preventDefault();
	      this.setState({
	        openDeploymentDialog: false
	      });
	    }
	  }, {
	    key: "onAddCampaignBtnClick",
	    value: function onAddCampaignBtnClick(e) {
	      e.preventDefault();
	      this.props.onClickAddCampaign(this.props.startDate, this.props.endDate);
	      this.setState({
	        openDialog: true
	      });
	    }
	  }, {
	    key: "onRequestClose",
	    value: function onRequestClose() {
	      this.setState({
	        openDialog: false
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.viewMode !== this.props.viewMode && !nextProps.viewMode && nextProps.legacy && (0, _isEmpty2.default)(nextProps.deploymentCampaigns)) {
	        nextProps.addDeployment("default", nextProps.title);
	      }
	    }
	  }, {
	    key: "applyCampaignChange",
	    value: function applyCampaignChange(campaignIds) {
	      this.props.onApplyCampaignChanges(this.props.title.toLowerCase(), campaignIds);
	    }
	  }, {
	    key: "applyDeploymentChange",
	    value: function applyDeploymentChange(campaignIds, deployName) {
	      this.props.onApplyCampaignChanges(this.props.title.toLowerCase(), deployName, campaignIds);
	    }
	  }, {
	    key: "removeCampaignId",
	    value: function removeCampaignId(id, name) {
	      this.setState({
	        openDelConfirm: true,
	        removeCampaignId: id,
	        removeDeployName: name
	      });
	    }
	  }, {
	    key: "onDelDeployment",
	    value: function onDelDeployment(name) {
	      this.setState({
	        openDelDeploymentDialog: true,
	        removeDeployName: name
	      });
	    }
	  }, {
	    key: "closeConfirm",
	    value: function closeConfirm(e) {
	      e.preventDefault();
	      this.setState({ openDelConfirm: false });
	    }
	  }, {
	    key: "closeConfirmDeployment",
	    value: function closeConfirmDeployment(e) {
	      e.preventDefault();
	      this.setState({ openDelDeploymentDialog: false });
	    }
	  }, {
	    key: "closeDeployConfirm",
	    value: function closeDeployConfirm(e) {
	      e.preventDefault();
	      this.setState({
	        openDeploymentDialog: false,
	        deployNameError: undefined
	      });
	    }
	  }, {
	    key: "confirmRemoveDeployment",
	    value: function confirmRemoveDeployment(e) {
	      e.preventDefault();
	      this.props.removeDeployment(this.state.removeDeployName, this.props.title.toLowerCase());
	      this.setState({
	        openDelDeploymentDialog: false,
	        removeDeployName: undefined
	      });
	    }
	  }, {
	    key: "confirmRemove",
	    value: function confirmRemove(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      if (this.state.removeCampaignId) {
	        var cids = [];
	        /*
	        map(this.props.selectedCampaigns, (sltCampaign)=>{
	          if (sltCampaign.id !== this.state.removeCampaignId)
	            cids.push(sltCampaign.id)
	        })*/
	        (0, _map2.default)(this.props.deploymentCampaigns, function (campaign) {
	          if (campaign.name === _this2.state.removeDeployName) {
	            (0, _map2.default)(campaign.channelCampaigns, function (channelCampaign) {
	              if (parseInt(channelCampaign.id, 10) !== parseInt(_this2.state.removeCampaignId, 10)) cids.push(channelCampaign.id);
	            });
	          }
	        });
	        /*
	        if (this.props.parentCampaignDetail) {
	          map(this.props.parentCampaignDetail.channelCampaigns, (emailCampaign)=>{
	            if (emailCampaign.id !== this.state.removeCampaignId)
	              cids.push(emailCampaign.id)
	          })
	        }*/
	        this.props.onApplyCampaignChanges(this.props.title.toLowerCase(), this.state.removeDeployName, cids);
	      }
	      this.setState({ openDelConfirm: false });
	    }
	  }, {
	    key: "confirmAddDeployment",
	    value: function confirmAddDeployment(e) {
	      e.preventDefault();
	      var deployName = this.refs.deployName.value.trim();
	      var result = (0, _filter2.default)(this.props.deploymentCampaigns, function (campaign) {
	        return campaign.name === deployName;
	      });
	      if (result.length > 0 || deployName === "") {
	        this.setState({
	          deployNameError: deployName === "" ? "Deployment name could not be empty" : "Duplicate deployment name, please update"
	        });
	      } else {
	        this.props.addDeployment(this.refs.deployName.value, this.props.title);
	        this.setState({
	          openDeploymentDialog: false,
	          deployNameError: ""
	        });
	      }
	    }
	  }, {
	    key: "onEmailReportDeliveredCheck",
	    value: function onEmailReportDeliveredCheck() {
	      var val = !this.state.emailReportDelivered;
	      this.setState({
	        emailReportDelivered: val
	      });
	      this.props.setEmailReportDelivered(val);
	    }
	  }, {
	    key: "onEmailReportDistinctCheck",
	    value: function onEmailReportDistinctCheck() {
	      var val = !this.state.emailReportDistinctIndividuals;
	      this.setState({
	        emailReportDistinctIndividuals: val
	      });
	      this.props.setEmailReportDistinct(val);
	    }
	  }, {
	    key: "getReportOption",
	    value: function getReportOption() {
	      var parentCampaignDetail = this.props.parentCampaignDetail;
	
	      if (this.props.viewMode) {
	        return _react2.default.createElement(
	          "div",
	          {
	            style: { marginLeft: "30%", marginTop: "-18px", minHeight: "25px" }
	          },
	          parentCampaignDetail && parentCampaignDetail.emailReportDelivered && _react2.default.createElement(
	            "p",
	            { className: "no-margin-top", style: { fontSize: "16px" } },
	            "Delivered"
	          ),
	          parentCampaignDetail && parentCampaignDetail.emailReportDistinctIndividuals && _react2.default.createElement(
	            "p",
	            { className: "no-margin-top", style: { fontSize: "16px" } },
	            "Distinct Individuals"
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          "div",
	          {
	            style: { display: "inline-block", marginLeft: "18%", width: "300px" }
	          },
	          _react2.default.createElement(_Checkbox2.default, {
	            label: "Delivered",
	            checked: this.state.emailReportDelivered,
	            onCheck: this.onEmailReportDeliveredCheck.bind(this)
	          }),
	          _react2.default.createElement(_Checkbox2.default, {
	            label: "Distinct Individuals",
	            checked: this.state.emailReportDistinctIndividuals,
	            onCheck: this.onEmailReportDistinctCheck.bind(this)
	          }),
	          !this.state.emailReportDelivered && !this.state.emailReportDistinctIndividuals && _react2.default.createElement(
	            "div",
	            { style: { color: "#FF0000", marginBottom: "10px" } },
	            _react2.default.createElement("i", { className: "icon-warning2 pr-10" }),
	            "One reporting option must be checked to save"
	          )
	        )
	        /*
	        <RadioButtonGroup style={{paddingLeft:"32%"}} name="reportType" 
	        valueSelected={this.state.emailReportType}
	        onChange={(e, value) => this.handleEmailReportTypeChange(e, value)}>
	        <RadioButton value={"delivered"} label="Delivered" 
	          iconStyle={{fill: 'black', width: '20px', height: '20px'}}/>
	        <RadioButton value={"distinct"} label="Distinct Individuals" 
	          iconStyle={{fill: 'black', width: '20px', height: '20px'}}/>
	        </RadioButtonGroup>*/
	        ;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var campaigns = this.props.parentCampaignDetail ? (0, _filter2.default)(this.props.parentCampaignDetail.channelCampaigns, function (campaign) {
	        return campaign.channel.toLowerCase() === _this3.props.title.toLowerCase();
	      }) : [];
	      var dialogTitle = this.props.title === "SOCIAL" ? "FACEBOOK" : this.props.title === "DISPLAY" ? "Google Ads" : this.props.title;
	      return _react2.default.createElement(
	        "div",
	        { className: "add-campaign" },
	        this.props.showReportOptions ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            {
	              className: "no-margin-bottom no-border-bottom",
	              style: { fontSize: "24px" }
	            },
	            this.props.title
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontWeight: "bold",
	                float: this.props.viewMode ? "none" : "left"
	              }
	            },
	            "Reporting Options"
	          ),
	          this.getReportOption()
	        ) : _react2.default.createElement(
	          "h2",
	          { className: "no-margin-bottom", style: { fontSize: "24px" } },
	          this.props.title
	        ),
	        this.props.children,
	
	        /*
	        (this.props.selectedCampaigns &&  this.props.selectedCampaigns.length > 0) ?
	          (
	            <ChannelCampaignsTable tableHeaderArr={
	              [
	                {label: 'Campaign Name', value: 0},
	                {label: 'Campaign ID', value:1},
	                {label: 'Campaign Start Date', value: 2},
	                {label: 'Campaign End Date', value: 3},
	                {label: 'Status', value: 4},
	                {label: '', value:5}
	              ]
	            } activeIndex={0} bodyDataArr={this.props.selectedCampaigns} showSelectBox={false}
	            bodyDataKey={['select','name', 'campaignId','startDate','endDate','status']}
	            tableHeaderWidthStyle={
	              [ '32%', '18%', '15%', '14.5%', '14%']
	            } showDelBtn={!this.props.viewMode} removeCampaignId={this.removeCampaignId.bind(this)}
	            />
	          ) : (
	            <section className="no-data">
	              No deployment have been added.
	            </section>
	          ) */
	        _react2.default.createElement(_deploymentCampaigns2.default, {
	          onClickAddSegment: function onClickAddSegment() {
	            _this3.props.onClickAddCampaign(_this3.props.startDate, _this3.props.endDate);
	          },
	          onApplyCampaignChanges: this.applyDeploymentChange.bind(this),
	          campaigns: this.props.deploymentCampaigns,
	          dialogTitle: dialogTitle,
	          parentCampaignDetail: this.props.parentCampaignDetail,
	          title: this.props.title,
	          channelCampaigns: this.props.channelCampaigns,
	          campaignStatus: this.props.parentCampaignDetail ? this.props.parentCampaignDetail.status : "Draft",
	          selectCampaignIds: this.props.prevSelectCampaignIds,
	          startDate: this.props.startDate,
	          endDate: this.props.endDate,
	          removeCampaignId: this.removeCampaignId.bind(this),
	          onDelDeployment: this.onDelDeployment.bind(this),
	          viewMode: this.props.viewMode,
	          legacy: this.props.legacy
	        }),
	        this.props.viewMode === false && _react2.default.createElement(
	          "div",
	          { className: "add-btn clearfix" },
	          !this.props.legacy && _react2.default.createElement(_Button2.default, {
	            title: "Add Deployment",
	            disabled: this.props.deploymentCampaigns && this.props.deploymentCampaigns.length >= 5,
	            handleClick: this.onAddDeploymentBtnClick.bind(this)
	          })
	        ),
	        _react2.default.createElement(_AddCampaignDialog2.default, {
	          open: this.state.openDialog,
	          title: dialogTitle,
	          applyChange: this.applyCampaignChange.bind(this),
	          onRequestClose: this.onRequestClose.bind(this),
	          channelCampaigns: this.props.channelCampaigns,
	          campaignName: this.props.campaignName,
	          emailCampaigns: campaigns,
	          channelType: this.props.title.toLowerCase(),
	          campaignStatus: this.props.parentCampaignDetail ? this.props.parentCampaignDetail.status : "Draft",
	          selectCampaignIds: this.props.prevSelectCampaignIds,
	          startDate: this.props.startDate,
	          endDate: this.props.endDate
	        }),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            title: "",
	            open: this.state.openDelConfirm,
	            onRequestClose: this.props.onRequestClose,
	            bodyStyle: {
	              color: "#000",
	              fontWeight: "bold",
	              fontSize: "16px",
	              paddingTop: "0px",
	              paddingBottom: "0px",
	              textAlign: "center"
	            },
	            contentStyle: { width: "482px", maxWidth: "482px" },
	            titleStyle: { display: "none" },
	            actionsContainerStyle: { display: "none" }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-left no-padding-right no-padding-bottom no-margin-bottom" },
	            "Are you sure you would like to remove this segment?"
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-margin-bottom pt-20" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-aa-info mr-20 ",
	                onClick: this.closeConfirm.bind(this),
	                style: {
	                  color: "#000",
	                  fontSize: "16px !important",
	                  textTransform: "capitalize"
	                }
	              },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-default btn-aa-warning",
	                onClick: this.confirmRemove.bind(this),
	                style: {
	                  fontSize: "16p !importantx",
	                  textTransform: "capitalize"
	                }
	              },
	              "Remove Segment"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            title: "",
	            open: this.state.openDelDeploymentDialog,
	            onRequestClose: this.props.onRequestClose,
	            bodyStyle: {
	              color: "#000",
	              fontWeight: "bold",
	              fontSize: "16px",
	              paddingTop: "0px",
	              paddingBottom: "0px",
	              textAlign: "center"
	            },
	            contentStyle: { width: "482px", maxWidth: "482px" },
	            titleStyle: { display: "none" },
	            actionsContainerStyle: { display: "none" }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-left no-padding-right no-padding-bottom no-margin-bottom" },
	            "Are you sure you would like to remove this deployment?"
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-margin-bottom pt-20" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-aa-info mr-20 ",
	                onClick: this.closeConfirmDeployment.bind(this),
	                style: {
	                  color: "#000",
	                  fontSize: "16px !important",
	                  textTransform: "capitalize"
	                }
	              },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-default btn-aa-warning",
	                onClick: this.confirmRemoveDeployment.bind(this),
	                style: {
	                  fontSize: "16px !important",
	                  textTransform: "capitalize"
	                }
	              },
	              "Remove Deployment"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            title: "",
	            open: this.state.openDeploymentDialog,
	            onRequestClose: this.onDevploymentDialogClose.bind(this),
	            bodyStyle: {
	              color: "#000",
	              fontSize: "16px",
	              paddingTop: "0px",
	              paddingBottom: "0px"
	            },
	            contentStyle: { width: "482px", maxWidth: "482px" },
	            titleStyle: { display: "none" },
	            actionsContainerStyle: { display: "none" }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              style: { fontSize: "14px" },
	              className: "no-padding-left no-padding-right no-padding-bottom no-margin-bottom"
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontWeight: "bold",
	                  marginBottom: "15px",
	                  fontSize: "16px",
	                  textTransform: "capitalize"
	                }
	              },
	              "Add ",
	              this.props.title.toLowerCase(),
	              " Deployment"
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              "Deployment",
	              this.props.deploymentCampaigns ? this.props.deploymentCampaigns.length + 1 : "1"
	            ),
	            _react2.default.createElement("input", {
	              ref: "deployName",
	              className: "p-5 light-grey-border",
	              style: { marginLeft: "20px", width: "330px" },
	              maxLength: "100"
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#FF0000", fontSize: "12px" } },
	              this.state.deployNameError
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              style: {
	                textAlign: "right",
	                paddingRight: "0px",
	                paddingBottom: "10px"
	              }
	            },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-aa-info mr-20 btn-aa-claritas-info ",
	                onClick: this.closeDeployConfirm.bind(this),
	                style: { color: "#000" }
	              },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-default btn-aa-default btn-aa-claritas",
	                onClick: this.confirmAddDeployment.bind(this)
	              },
	              "Add Deployment"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddCampaign;
	}(_index2.default);
	
	exports.default = AddCampaign;
	
	
	AddCampaign.defaultProps = {
	  openDialog: false,
	  title: "title",
	  ifHasCampaigns: false,
	  channelCampaigns: [],
	  viewMode: false,
	  showReportOptions: false,
	  legacy: false
	};

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(213);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _index = __webpack_require__(15);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ChannelCampaignsTable = __webpack_require__(510);
	
	var _ChannelCampaignsTable2 = _interopRequireDefault(_ChannelCampaignsTable);
	
	var _AddCampaignDialog = __webpack_require__(511);
	
	var _AddCampaignDialog2 = _interopRequireDefault(_AddCampaignDialog);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _union = __webpack_require__(419);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _colorManipulator = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeploymentCampaigns = function (_AcquireWebComponent) {
	  _inherits(DeploymentCampaigns, _AcquireWebComponent);
	
	  function DeploymentCampaigns(props) {
	    _classCallCheck(this, DeploymentCampaigns);
	
	    var _this = _possibleConstructorReturn(this, (DeploymentCampaigns.__proto__ || Object.getPrototypeOf(DeploymentCampaigns)).call(this, props));
	
	    _this.state = {
	      openDialog: false,
	      deployName: undefined
	    };
	    return _this;
	  }
	
	  _createClass(DeploymentCampaigns, [{
	    key: 'removeCampaignId',
	    value: function removeCampaignId(id) {
	      this.setState({ openDelConfirm: true, removeCampaignId: id });
	    }
	  }, {
	    key: 'onAddSegmentBtnClick',
	    value: function onAddSegmentBtnClick(e, name) {
	      e.preventDefault();
	      this.props.onClickAddSegment();
	      this.setState({
	        openDialog: true,
	        deployName: name
	      });
	    }
	  }, {
	    key: 'onRequestClose',
	    value: function onRequestClose() {
	      this.setState({
	        openDialog: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          campaigns = _props.campaigns,
	          viewMode = _props.viewMode,
	          title = _props.title,
	          parentCampaignDetail = _props.parentCampaignDetail,
	          legacy = _props.legacy;
	
	      var sourceCampaigns = this.props.parentCampaignDetail ? (0, _filter2.default)(this.props.parentCampaignDetail.channelCampaigns, function (campaign) {
	        return campaign.channel.toLowerCase() === _this2.props.title.toLowerCase();
	      }) : [];
	
	      var dialogTitle = this.props.title === 'SOCIAL' ? "FACEBOOK" : this.props.title === "DISPLAY" ? "Google Ads" : this.props.title;
	      var sltIds = [];
	      var hideIds = [];
	
	      (0, _map2.default)(campaigns, function (deployCampaign) {
	        var ids = (0, _map2.default)(deployCampaign.channelCampaigns, "id");
	        if (deployCampaign.name === _this2.state.deployName) {
	          sltIds = (0, _union2.default)(ids, sltIds);
	        } else {
	          hideIds = (0, _union2.default)(ids, hideIds);
	        }
	      });
	
	      var displayCampaigns = (0, _filter2.default)(this.props.channelCampaigns, function (channelCampaign) {
	        return hideIds.indexOf(channelCampaign.id) < 0;
	      });
	
	      if (parentCampaignDetail) {
	        (0, _map2.default)(parentCampaignDetail.campaignDeployments, function (deployment) {
	          if (deployment.channel.toLowerCase() === _this2.props.title.toLowerCase()) {
	            if (deployment.name === _this2.state.deployName) {
	              (0, _map2.default)(deployment.channelCampaigns, function (channelCampaign) {
	                if ((0, _filter2.default)(campaigns, function (campaign) {
	                  return channelCampaign.channel.toLowerCase() === campaign.channel.toLowerCase() && channelCampaign.id === campaign.id;
	                }).length <= 0) {
	                  displayCampaigns.push(channelCampaign);
	                }
	              });
	            } else {
	              (0, _map2.default)(deployment.channelCampaigns, function (channelCampaign) {
	                var isRemoved = true;
	                (0, _map2.default)(campaigns, function (campaign) {
	                  if (channelCampaign.channel.toLowerCase() === campaign.channel.toLowerCase() && (0, _map2.default)(campaign.channelCampaigns, "id").indexOf(channelCampaign.id) >= 0 && isRemoved === true) {
	                    isRemoved = false;
	                  }
	                });
	                if (isRemoved === true) displayCampaigns.push(channelCampaign);
	              });
	            }
	          }
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AddCampaignDialog2.default, { open: this.state.openDialog, title: dialogTitle,
	          applyChange: this.props.onApplyCampaignChanges,
	          onRequestClose: this.onRequestClose.bind(this),
	          channelCampaigns: displayCampaigns,
	          campaignName: this.props.parentCampaignDetail ? this.props.parentCampaignDetail.name : this.props.campaignName,
	          emailCampaigns: sourceCampaigns,
	          channelType: title.toLowerCase(),
	          campaignStatus: this.props.campaignStatus,
	          selectCampaignIds: sltIds,
	          startDate: this.props.startDate, endDate: this.props.endDate,
	          deployName: this.state.deployName
	        }),
	        (0, _map2.default)(campaigns, function (deploy, idx) {
	
	          var displayCampaigns = (0, _isEmpty2.default)(deploy.channelCampaigns) || !deploy.channelCampaigns[0].name ? (0, _filter2.default)(_this2.props.channelCampaigns, function (campaign) {
	            return (0, _filter2.default)(deploy.channelCampaigns, function (deployCampaign) {
	              return deployCampaign.id === campaign.id;
	            }).length > 0;
	          }) : deploy.channelCampaigns;
	
	          return _react2.default.createElement(
	            'div',
	            { className: legacy ? "deployment-legacy-section" : "deployment-section", style: { paddingLeft: legacy ? "0" : '0px', marginTop: legacy ? "5px" : "20px" },
	              key: deploy.name + "-container" },
	            _react2.default.createElement(
	              'div',
	              { style: { width: '100%', height: '45px', background: "#CDCDCD", fontWeight: 'bold', position: 'relative', textOverflow: "ellipsis",
	                  display: legacy ? "none" : "block", overflow: "hidden", whiteSpace: "nowrap" },
	                className: 'pt-10 pb-5 pl-20 pr-20 deployment-title' },
	              _react2.default.createElement('div', { className: _this2.state['collapsed' + idx] ? "arrow-right" : "arrow-down", onClick: function onClick() {
	                  _this2.setState(_defineProperty({}, 'collapsed' + idx, !_this2.state['collapsed' + idx]));
	                } }),
	              'Deployment ',
	              idx + 1,
	              ' - ',
	              deploy.name,
	              !viewMode && _react2.default.createElement(
	                'a',
	                { onClick: function onClick(e) {
	                    e.preventDefault();_this2.props.onDelDeployment(deploy.name);
	                  } },
	                _react2.default.createElement('i', { className: 'icon-cancel-circle2', style: { color: "red", position: "absolute", top: "13px", right: '21px' } })
	              )
	            ),
	            !(0, _isEmpty2.default)(deploy.channelCampaigns) && !_this2.state['collapsed' + idx] && _react2.default.createElement(_ChannelCampaignsTable2.default, { tableHeaderArr: [{ label: 'Segment Name', value: 0 }, { label: 'Segment ID', value: 1 }, { label: 'Segment Start Date', value: 2 }, { label: 'Segment End Date', value: 3 }, { label: 'Status', value: 4 }, { label: '', value: 5 }], activeIndex: 0, bodyDataArr: displayCampaigns, showSelectBox: false, sortable: false,
	              bodyDataKey: ['select', 'name', 'campaignId', 'startDate', 'endDate', 'status'],
	              tableHeaderWidthStyle: ['40%', '16%', '15.5%', '15%', '10%'], showDelBtn: !viewMode, removeCampaignId: function removeCampaignId(id) {
	                _this2.props.removeCampaignId(id, deploy.name);
	              }, narrowHeader: true
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-10' },
	              !viewMode && [_react2.default.createElement(
	                'div',
	                { className: 'pt-10 pb-10 light-grey-top-border light-grey-bottom-border mb-10',
	                  style: { display: displayCampaigns.length > 0 ? "none" : "block", textAlign: "center" } },
	                'No segment(s) have been added'
	              ), _react2.default.createElement(_Button2.default, { title: 'Add Segment', disabled: deploy.channelCampaigns.length >= 10,
	                handleClick: function handleClick(e) {
	                  _this2.onAddSegmentBtnClick(e, deploy.name);
	                } })]
	            )
	          );
	        }),
	        (0, _isEmpty2.default)(campaigns) ? _react2.default.createElement(
	          'section',
	          { className: 'no-data', style: { fontSize: "16px" } },
	          "No deployment(s) have been added."
	        ) : ""
	      );
	    }
	  }]);
	
	  return DeploymentCampaigns;
	}(_index2.default);
	
	exports.default = DeploymentCampaigns;
	
	
	DeploymentCampaigns.protoTypes = {
	  campaignss: _react2.default.PropTypes.array.isRequired,
	  viewMode: _react2.default.PropTypes.bool.isRequired,
	  onApplyCampaignsChange: _react2.default.PropTypes.func.isRequired,
	  campaignName: _react2.default.PropTypes.string.isRequired,
	  legacy: _react2.default.PropTypes.bool.isRequired
	};
	
	DeploymentCampaigns.defaultProps = {
	  campaigns: [],
	  viewMode: true,
	  legacy: false
	};

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
		tableHeaderStyle: {
			border: 'none',
			background: '#F5F5F5',
			fontSize: '12px',
			fontWeight: "bold"
		},
		tableHeaderColumn: {
			height: '35px',
			color: 'black',
			cursor: 'pointer',
			fontWeight: 'bolder',
			paddingLeft: '10px',
			position: 'relative',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		},
		tableTd: {
			paddingLeft: '10px',
			height: '30px',
			borderBottom: '1px solid black',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}
	};
	
	var CampaignDetail = function (_AcquireWebComponent) {
		_inherits(CampaignDetail, _AcquireWebComponent);
	
		function CampaignDetail() {
			_classCallCheck(this, CampaignDetail);
	
			return _possibleConstructorReturn(this, (CampaignDetail.__proto__ || Object.getPrototypeOf(CampaignDetail)).apply(this, arguments));
		}
	
		_createClass(CampaignDetail, [{
			key: 'render',
			value: function render() {
				var data = this.props.data;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'light-grey-border mt-20 campaign-detail-container', style: { background: "#FFFFFF" } },
						_react2.default.createElement(
							'h2',
							{ className: 'pl-20 pt-20' },
							'CAMPAIGN GROUP'
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'light-grey-border-top light-grey-border-bottom no-margin-bottom pt-5 pb-5 no-padding-left ml-20 no-padding-right mr-20' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding-left' },
								_react2.default.createElement(
									'strong',
									null,
									'Campaign Group Name'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '4', sm: '4', md: '4', lg: '4' },
								data.name
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding-left' },
								_react2.default.createElement(
									'strong',
									null,
									'Client Campaign ID'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '2', sm: '2', md: '2', lg: '2' },
								data.clientCampaignId
							)
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'light-grey-border-bottom pt-5 pb-5 no-margin-bottom no-padding-left ml-20 no-padding-right mr-20 ' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding-left' },
								_react2.default.createElement(
									'strong',
									null,
									'Audience Size'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '4', sm: '4', md: '4', lg: '4' },
								data.audienceSize ? (0, _utility.splitNumber)(data.audienceSize)() : ''
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding-left' },
								_react2.default.createElement(
									'strong',
									null,
									'Campaign Group Start Date'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '2', sm: '2', md: '2', lg: '2' },
								data.startDate
							)
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'light-grey-border-bottom pt-5 pb-5 no-margin-bottom no-padding-left ml-20 no-padding-right mr-20 ' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding-left' },
								_react2.default.createElement(
									'strong',
									null,
									'Campaign Budget'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '4', sm: '4', md: '4', lg: '4' },
								data.budget ? '$' + (0, _utility.splitNumber)(data.budget)() : ''
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding-left' },
								_react2.default.createElement(
									'strong',
									null,
									'Campaign Group End Date'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '2', sm: '2', md: '2', lg: '2' },
								data.endDate
							)
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'light-grey-border-bottom pt-5 pb-5 mb-20 no-margin-bottom no-padding-left ml-20 no-padding-right mr-20 ' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding-left' },
								_react2.default.createElement(
									'strong',
									null,
									'Campaign Group ID'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '4', sm: '4', md: '4', lg: '4' },
								data.campaignId
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding-left' },
								_react2.default.createElement(
									'strong',
									null,
									'Campaign Group Status'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '2', sm: '2', md: '2', lg: '2' },
								data.status
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'light-grey-border mt-20 campaign-detail-pdf-container', style: { background: "#FFFFFF", display: "none" } },
						_react2.default.createElement(
							'table',
							{ style: { width: "100%" } },
							_react2.default.createElement(
								'thead',
								{ style: styles.tableHeaderStyle },
								_react2.default.createElement(
									'tr',
									{ style: { height: "42px" } },
									_react2.default.createElement(
										'th',
										{ style: { width: '16%', paddingLeft: "20px", wordBreak: "break-word" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Group Name'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '10%', paddingLeft: "20px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Audience Size'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '10%', paddingLeft: "20px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Budget'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '12%', paddingLeft: "20px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Group ID'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '12%', paddingLeft: "20px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Client Campaign ID'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '14%', paddingLeft: "20px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Group Start Date'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '14%', paddingLeft: "20px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Group End Date'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '12%', paddingLeft: "20px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Group Status'
										)
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								_react2.default.createElement(
									'tr',
									{ style: { height: "42px" } },
									_react2.default.createElement(
										'td',
										{ style: { width: '16%', paddingLeft: "20px", wordBreak: "break-word" } },
										data.name
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '10%', paddingLeft: "20px" } },
										data.audienceSize ? (0, _utility.splitNumber)(data.audienceSize)() : ''
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '10%', paddingLeft: "20px" } },
										data.budget ? '$' + (0, _utility.splitNumber)(data.budget)() : ''
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '12%', paddingLeft: "20px" } },
										data.id
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '12%', paddingLeft: "20px" } },
										data.clientCampaignId
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '14%', paddingLeft: "20px" } },
										data.startDate
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '14%', paddingLeft: "20px" } },
										data.endDate
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '12%', paddingLeft: "20px" } },
										data.status
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return CampaignDetail;
	}(_MaterialUI2.default);
	
	exports.default = CampaignDetail;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Title = __webpack_require__(166);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	__webpack_require__(1401);
	
	var _reactDatepicker = __webpack_require__(440);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(269);
	
	var _AddCampaign = __webpack_require__(1058);
	
	var _AddCampaign2 = _interopRequireDefault(_AddCampaign);
	
	var _Button = __webpack_require__(213);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _RadioButton = __webpack_require__(107);
	
	var _utility = __webpack_require__(14);
	
	var _CampaignDetail = __webpack_require__(1060);
	
	var _CampaignDetail2 = _interopRequireDefault(_CampaignDetail);
	
	var _momentTimezone = __webpack_require__(110);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _flatMap = __webpack_require__(665);
	
	var _flatMap2 = _interopRequireDefault(_flatMap);
	
	var _union = __webpack_require__(419);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _remove = __webpack_require__(188);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	var CreateCampaigns = function (_AcquireWebComponent) {
	  _inherits(CreateCampaigns, _AcquireWebComponent);
	
	  function CreateCampaigns(props) {
	    _classCallCheck(this, CreateCampaigns);
	
	    var _this = _possibleConstructorReturn(this, (CreateCampaigns.__proto__ || Object.getPrototypeOf(CreateCampaigns)).call(this, props));
	
	    (0, _utility.initMomentTimezone)();
	    if (props.client_tz) {
	      _momentTimezone2.default.tz.setDefault(props.client_tz);
	    }
	    if (props.campaignDetail) {
	      var campaignDetail = props.campaignDetail;
	
	      var selectEmailCampaigns = (0, _filter2.default)(campaignDetail.channelCampaigns, function (campaign) {
	        return campaign.channel === "Email";
	      });
	      var selectSocialCampaigns = (0, _filter2.default)(campaignDetail.channelCampaigns, function (campaign) {
	        return campaign.channel === "SOCIAL";
	      });
	      var selectDisplayCampaigns = (0, _filter2.default)(campaignDetail.channelCampaigns, function (campaign) {
	        return campaign.channel === "Display";
	      });
	
	      _this.state = {
	        campaignId: campaignDetail.id,
	        awCampaignId: campaignDetail.campaignId,
	        groupCampaignType: campaignDetail.type,
	        startDate: (0, _momentTimezone2.default)(campaignDetail.startDate),
	        compareStartDate: (0, _momentTimezone2.default)(campaignDetail.startDate),
	        minStartDate: (0, _momentTimezone2.default)(campaignDetail.startDate).subtract(15, "d"),
	        endDate: (0, _momentTimezone2.default)(campaignDetail.endDate),
	        compareEndDate: (0, _momentTimezone2.default)(campaignDetail.endDate),
	        campaignName: campaignDetail.name,
	        audienceSize: campaignDetail.audienceSize,
	        campaignBudget: campaignDetail.budget,
	        clientCampaignId: campaignDetail.clientCampaignId,
	        selectEmailCampaigns: selectEmailCampaigns,
	        selectSocialCampaigns: selectSocialCampaigns,
	        selectDisplayCampaigns: selectDisplayCampaigns,
	        sltEmailChannelCampaigns: (0, _map2.default)(selectEmailCampaigns, "id"),
	        sltSocialChannelCampaigns: (0, _map2.default)(selectSocialCampaigns, "id"),
	        sltDisplayChannelCampaigns: (0, _map2.default)(selectDisplayCampaigns, "id"),
	        inEdit: false,
	        editMode: true,
	        onCsvReportDownload: false,
	        onPdfReportDownload: false,
	        showDownloadDialog: false,
	        emailDeployCampaigns: campaignDetail.emailDeployments,
	        socialDeployCampaigns: campaignDetail.socialDeployments,
	        displayDeployCampaigns: campaignDetail.displayDeployments,
	        emailReportDelivered: campaignDetail.emailReportDelivered,
	        emailReportDistinctIndividuals: campaignDetail.emailReportDistinctIndividuals
	      };
	    } else {
	      _this.state = {
	        //startDate: props.client_tz ? moment().tz(props.client_tz) : moment(),
	        //endDate: props.client_tz ? moment().add(31, 'days').tz(props.client_tz) : moment().add(31, 'days'),
	        //compareStartDate: props.client_tz ? moment().tz(props.client_tz) : moment(),
	        //compareEndDate: props.client_tz ? moment().add(31, 'days').tz(props.client_tz) : moment().add(31, 'days'),
	        groupCampaignType: "General",
	        startDate: (0, _momentTimezone2.default)(),
	        endDate: (0, _momentTimezone2.default)().add(31, "days"),
	        compareStartDate: (0, _momentTimezone2.default)(),
	        minStartDate: (0, _momentTimezone2.default)().subtract(15, "d"),
	        compareEndDate: (0, _momentTimezone2.default)().add(31, "days"),
	        sltEmailChannelCampaigns: [],
	        sltSocialChannelCampaigns: [],
	        sltDisplayChannelCampaigns: [],
	        selectEmailCampaigns: [],
	        selectSocialCampaigns: [],
	        selectDisplayCampaigns: [],
	        campaignName: "",
	        audienceSize: "",
	        campaignBudget: "",
	        clientCampaignId: "",
	        campaignId: null,
	        inEdit: true,
	        editMode: false,
	        onCsvReportDownload: false,
	        onPdfReportDownload: false,
	        showDownloadDialog: false,
	        emailDeployCampaigns: [],
	        socialDeployCampaigns: [],
	        displayDeployCampaigns: [],
	        emailReportDelivered: true,
	        emailReportDistinctIndividuals: undefined
	      };
	    }
	    return _this;
	  }
	
	  _createClass(CreateCampaigns, [{
	    key: "handleGroupCampaignTypeChange",
	    value: function handleGroupCampaignTypeChange(e, value) {
	      e.preventDefault();
	      this.setState(Object.assign({}, this.state, {
	        groupCampaignType: value
	      }));
	    }
	  }, {
	    key: "handleCampaignNameChanged",
	    value: function handleCampaignNameChanged(e, value) {
	      e.preventDefault();
	      this.setState(Object.assign({}, this.state, {
	        campaignName: value
	      }));
	    }
	  }, {
	    key: "handleAudienceSizeChanged",
	    value: function handleAudienceSizeChanged(e, value) {
	      e.preventDefault();
	      this.setState(Object.assign({}, this.state, {
	        audienceSize: value
	      }));
	    }
	  }, {
	    key: "handleCampaignBudgetChanged",
	    value: function handleCampaignBudgetChanged(e, value) {
	      e.preventDefault();
	      this.setState(Object.assign({}, this.state, {
	        campaignBudget: value
	      }));
	    }
	  }, {
	    key: "handleClientCampaignIdChanged",
	    value: function handleClientCampaignIdChanged(e, value) {
	      e.preventDefault();
	      this.setState(Object.assign({}, this.state, {
	        clientCampaignId: value
	      }));
	    }
	  }, {
	    key: "handleOnStartMonthChange",
	    value: function handleOnStartMonthChange(date) {
	      this.setState({
	        compareStartDate: date
	      });
	    }
	  }, {
	    key: "handleOnEndMonthChange",
	    value: function handleOnEndMonthChange(date) {
	      this.setState({
	        compareEndDate: date
	      });
	    }
	  }, {
	    key: "handleStartDateChange",
	    value: function handleStartDateChange(startDate) {
	      this.handleChange({ startDate: startDate });
	    }
	  }, {
	    key: "handleEndDateChange",
	    value: function handleEndDateChange(endDate) {
	      this.handleChange({ endDate: endDate });
	    }
	  }, {
	    key: "handleChange",
	    value: function handleChange(_ref) {
	      var startDate = _ref.startDate,
	          endDate = _ref.endDate;
	
	      startDate = startDate || this.state.startDate;
	      endDate = endDate || this.state.endDate;
	
	      if (startDate.isAfter(endDate)) {
	        endDate = startDate;
	        this.setState({
	          compareEndDate: startDate
	        });
	      }
	
	      this.setState({
	        startDate: startDate,
	        endDate: endDate
	      });
	
	      this.props.getChannelCampaigns("email", (0, _momentTimezone2.default)(startDate).format("YYYY-MM-DD"), (0, _momentTimezone2.default)(endDate).format("YYYY-MM-DD"));
	      this.props.getChannelCampaigns("social", (0, _momentTimezone2.default)(startDate).format("YYYY-MM-DD"), (0, _momentTimezone2.default)(endDate).format("YYYY-MM-DD"));
	      this.props.getChannelCampaigns("display", (0, _momentTimezone2.default)(startDate).format("YYYY-MM-DD"), (0, _momentTimezone2.default)(endDate).format("YYYY-MM-DD"));
	    }
	  }, {
	    key: "handleClickDateWrapper",
	    value: function handleClickDateWrapper() {
	      var eles = document.querySelectorAll(".react-datepicker__day-name");
	      // change month name
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = eles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          v.innerText = v.innerText.substring(0, 1);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: "clickAddEmailCampaign",
	    value: function clickAddEmailCampaign(startDate, endDate) {
	      this.props.getChannelCampaigns("email", startDate, endDate);
	    }
	  }, {
	    key: "clickAddSocialCampaign",
	    value: function clickAddSocialCampaign(startDate, endDate) {
	      this.props.getChannelCampaigns("social", startDate, endDate);
	    }
	  }, {
	    key: "clickAddGoogleCampaign",
	    value: function clickAddGoogleCampaign(startDate, endDate) {
	      this.props.getChannelCampaigns("display", startDate, endDate);
	    }
	  }, {
	    key: "applyChannelCampaignChanges",
	    value: function applyChannelCampaignChanges(type, deployName, campaignIds) {
	      var dataSource = void 0;
	      var segmentSource = void 0;
	      switch (type.toLowerCase()) {
	        case "display":
	          dataSource = this.state.displayDeployCampaigns;
	          segmentSource = this.props.displayChannelCampaigns;
	          break;
	        case "social":
	          dataSource = this.state.socialDeployCampaigns;
	          segmentSource = this.props.socialChannelCampaigns;
	          break;
	        case "email":
	        default:
	          dataSource = this.state.emailDeployCampaigns;
	          segmentSource = this.props.emailChannelCampaigns;
	          break;
	      }
	      //const ds = filter(dataSource, (deploy) => {return deploy.name === deployName && deploy.channel.toLowerCase() === type});
	      //const deployDs = ds[0].channelCampaigns;
	      //const newList = filter(deployDs, ds => {return campaignIds.includes(ds.id)});
	      //const toAddCid = filter(campaignIds, cid => {
	      //  return filter(deployDs, ds=> {return ds.id === cid}).length <= 0
	      //});
	      var campaignDetail = this.props.campaignDetail;
	
	      var originDeployments = campaignDetail && campaignDetail.campaignDeployments ? (0, _filter2.default)(campaignDetail.campaignDeployments, function (dep) {
	        return dep.channel.toLowerCase() === type;
	      }) : [];
	      (0, _map2.default)(dataSource, function (deploy) {
	        if (deploy.name === deployName && deploy.channel.toLowerCase() === type) {
	          var segments = (0, _isEmpty2.default)(originDeployments) ? [] : (0, _flatMap2.default)(originDeployments, "channelCampaigns");
	          deploy.channelCampaigns = [];
	
	          (0, _map2.default)(campaignIds, function (cid) {
	            var originSegment = (0, _filter2.default)(segments, function (segment) {
	              return segment.id === cid;
	            });
	            if (originSegment.length > 0) {
	              deploy.channelCampaigns.push(originSegment[0]);
	            } else {
	              var fullSegment = (0, _filter2.default)(segmentSource, function (ds) {
	                return ds.id === cid;
	              });
	              if (fullSegment.length > 0) deploy.channelCampaigns.push(fullSegment[0]);
	            }
	          });
	        }
	      });
	
	      /*
	      const newList = filter(dataSource, cid => campaignIds.includes(cid));
	      const toAddCid = filter(campaignIds, cid => !dataSource.includes(cid));
	      //const newDeployList = filter(this.state.deploymentCampaigns, (deploy))
	      const result =  union(newList, toAddCid);
	      let channelSelects;
	      let updatedSelects;
	      switch(type) {
	        case "display":
	          this.setState({
	            sltDisplayChannelCampaigns: result
	          })
	          channelSelects = filter(this.props.displayChannelCampaigns, c=> result.includes(c.id));
	          updatedSelects = this.props.campaignDetail ? 
	            filter(filter(this.props.campaignDetail.channelCampaigns, (c) => {return c.channel ==="Display"}), 
	              c=> result.includes(c.id)) : [];
	          this.setState({
	            selectDisplayCampaigns: union(channelSelects, updatedSelects) // channelSelects.concat(updatedSelects)
	          })
	          break;
	        case "social":
	          this.setState({
	            sltSocialChannelCampaigns: result
	          })
	          channelSelects = filter(this.props.socialChannelCampaigns, c=> result.includes(c.id));
	          updatedSelects = this.props.campaignDetail ? 
	            filter(filter(this.props.campaignDetail.channelCampaigns, (c) => {return c.channel ==="Social"}), 
	              c=> result.includes(c.id)) : [];
	          this.setState({
	            selectSocialCampaigns: union(channelSelects, updatedSelects) // channelSelects.concat(updatedSelects)
	          })
	          break;
	        case "email":
	        default:
	          this.setState({
	            sltEmailChannelCampaigns : result
	          })
	          channelSelects = filter(this.props.emailChannelCampaigns, c=> result.includes(c.id));
	          updatedSelects = this.props.campaignDetail ? 
	            filter(filter(this.props.campaignDetail.channelCampaigns, (c) => {return c.channel ==="Email"}), 
	              c=> result.includes(c.id)) : [];
	          this.setState({
	            selectEmailCampaigns: union(channelSelects, updatedSelects) // channelSelects.concat(updatedSelects)
	          })
	          break;
	      }*/
	    }
	  }, {
	    key: "onClickCancel",
	    value: function onClickCancel(e) {
	      e.preventDefault();
	      this.props.clearSaveCampaignErrorMessage();
	      if (this.props.campaignDetail) {
	        var campaignDetail = this.props.campaignDetail;
	
	        this.setState({
	          campaignId: campaignDetail.id,
	          startDate: (0, _momentTimezone2.default)(campaignDetail.startDate),
	          compareStartDate: (0, _momentTimezone2.default)(campaignDetail.startDate),
	          minStartDate: (0, _momentTimezone2.default)(campaignDetail.startDate).subtract(15, "d"),
	          endDate: (0, _momentTimezone2.default)(campaignDetail.endDate),
	          minEndDate: (0, _momentTimezone2.default)(campaignDetail.endDate),
	          groupCampaignType: campaignDetail.type,
	          compareEndDate: (0, _momentTimezone2.default)(campaignDetail.endDate),
	          campaignName: campaignDetail.name,
	          audienceSize: campaignDetail.audienceSize,
	          campaignBudget: campaignDetail.budget,
	          clientCampaignId: campaignDetail.clientCampaignId,
	          selectEmailCampaigns: (0, _filter2.default)(campaignDetail.channelCampaigns, function (campaign) {
	            return campaign.channel === "Email";
	          }),
	          selectSocialCampaigns: (0, _filter2.default)(campaignDetail.channelCampaigns, function (campaign) {
	            return campaign.channel === "SOCIAL";
	          }),
	          selectDisplayCampaigns: (0, _filter2.default)(campaignDetail.channelCampaigns, function (campaign) {
	            return campaign.channel === "Display";
	          }),
	          inEdit: false,
	          editMode: true,
	          onCsvReportDownload: false,
	          onPdfReportDownload: false,
	          showDownloadDialog: false,
	          emailDeployCampaigns: (0, _filter2.default)(campaignDetail.campaignDeployments, function (deployment) {
	            return deployment.channel.toLowerCase() === "email";
	          }),
	          socialDeployCampaigns: (0, _filter2.default)(campaignDetail.campaignDeployments, function (deployment) {
	            return deployment.channel.toLowerCase() === "social";
	          }),
	          displayDeployCampaigns: (0, _filter2.default)(campaignDetail.campaignDeployments, function (deployment) {
	            return deployment.channel.toLowerCase() === "display";
	          }),
	          emailReportDelivered: campaignDetail.emailReportDelivered,
	          emailReportDistinctIndividuals: campaignDetail.emailReportDistinctIndividuals
	        });
	      } else {
	        this.props.history.push("/campaigns");
	      }
	    }
	  }, {
	    key: "onSaveClick",
	    value: function onSaveClick(e) {
	      e.preventDefault();
	      var campaignData = {
	        name: this.state.campaignName,
	        clientId: this.props.client_id,
	        startDate: (0, _momentTimezone2.default)(this.state.startDate).format("YYYY-MM-DD"),
	        endDate: (0, _momentTimezone2.default)(this.state.endDate).format("YYYY-MM-DD")
	      };
	
	      if (this.state.campaignBudget) {
	        campaignData.budget = this.state.campaignBudget;
	      }
	      if (this.state.audienceSize) {
	        campaignData.audienceSize = this.state.audienceSize;
	      }
	      if (this.state.clientCampaignId) {
	        campaignData.clientCampaignId = this.state.clientCampaignId;
	      }
	      if (this.state.campaignId) {
	        campaignData.id = this.state.campaignId;
	      }
	      campaignData.emailReportDelivered = this.state.emailReportDelivered;
	      campaignData.emailReportDistinctIndividuals = this.state.emailReportDistinctIndividuals;
	      campaignData.type = this.state.groupCampaignType;
	      var deployments = (0, _union2.default)(this.state.emailDeployCampaigns, this.state.socialDeployCampaigns, this.state.displayDeployCampaigns);
	
	      campaignData.campaignDeployments = deployments;
	      /*
	      map(this.state.selectEmailCampaigns, (campaign) => {
	        const obj = {id: campaign.id};
	        campaignData.channelCampaigns.push(obj);
	      })
	      map(this.state.selectSocialCampaigns, (campaign) => {
	        const obj = {id: campaign.id};
	        campaignData.channelCampaigns.push(obj);
	      })
	      map(this.state.selectDisplayCampaigns, (campaign) => {
	        const obj = {id: campaign.id}
	        campaignData.channelCampaigns.push(obj);
	      })*/
	
	      this.props.saveCampaignGroup(campaignData);
	    }
	  }, {
	    key: "onEditClick",
	    value: function onEditClick(e) {
	      e.preventDefault();
	      this.setState({
	        inEdit: true,
	        editMode: false
	      });
	    }
	  }, {
	    key: "intKeyDown",
	    value: function intKeyDown(evt) {
	      var key = evt.charCode || evt.keyCode || 0;
	      if (!(key === 8 || key === 9 || key === 46 || key === 110 || key >= 35 && key <= 40 || key >= 48 && key <= 57 || key >= 96 && key <= 105)) {
	        evt.preventDefault();
	      }
	    }
	  }, {
	    key: "numKeyDown",
	    value: function numKeyDown(evt) {
	      var key = evt.charCode || evt.keyCode || 0;
	      if (!(key === 8 || key === 9 || key === 46 || key === 110 || key === 190 || key >= 35 && key <= 40 || key >= 48 && key <= 57 || key >= 96 && key <= 105)) {
	        evt.preventDefault();
	      }
	    }
	  }, {
	    key: "handleBudgetOnBlur",
	    value: function handleBudgetOnBlur(e, val) {
	      e.preventDefault();
	      /*
	      this.setState({
	        campaignBudget: "$" + val
	      })
	      console.log(this.state.campaignBudget)*/
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.client_id !== this.props.client_id && this.props.client_id) {
	        //this.props.history.push("/campaigns")
	        this.props.selectClient(this.props.campaignDetail.clientId);
	      }
	
	      if (nextProps.client_tz !== this.props.client_tz) {
	        _momentTimezone2.default.tz.setDefault(nextProps.client_tz);
	
	        var _state = this.state,
	            startDate = _state.startDate,
	            endDate = _state.endDate,
	            compareStartDate = _state.compareStartDate,
	            compareEndDate = _state.compareEndDate;
	
	        if (nextProps.client_tz) {
	          this.setState({
	            startDate: (0, _utility.getTimezoneMoment)((0, _momentTimezone2.default)(startDate), nextProps.client_tz),
	            compareStartDate: (0, _utility.getTimezoneMoment)((0, _momentTimezone2.default)(compareStartDate), nextProps.client_tz),
	            minStartDate: (0, _utility.getTimezoneMoment)((0, _momentTimezone2.default)(compareStartDate), nextProps.client_tz).subtract(15, "d"),
	            endDate: (0, _utility.getTimezoneMoment)((0, _momentTimezone2.default)(endDate), nextProps.client_tz),
	            compareEndDate: (0, _utility.getTimezoneMoment)((0, _momentTimezone2.default)(compareEndDate), nextProps.client_tz)
	          });
	        }
	      }
	      if (!(0, _isEqual2.default)(nextProps.campaignDetail, this.props.campaignDetail)) {
	        if (nextProps.campaignDetail) {
	          var campaignDetail = nextProps.campaignDetail;
	
	          var selectEmailCampaigns = (0, _filter2.default)(campaignDetail.channelCampaigns, function (campaign) {
	            return campaign.channel === "Email";
	          });
	          var selectSocialCampaigns = (0, _filter2.default)(campaignDetail.channelCampaigns, function (campaign) {
	            return campaign.channel === "SOCIAL";
	          });
	          var selectDisplayCampaigns = (0, _filter2.default)(campaignDetail.channelCampaigns, function (campaign) {
	            return campaign.channel === "Display";
	          });
	          this.setState({
	            campaignId: nextProps.campaignDetail.id,
	            startDate: (0, _utility.getTimezoneMoment)(campaignDetail.startDate, nextProps.client_tz),
	            compareStartDate: (0, _utility.getTimezoneMoment)(campaignDetail.startDate, nextProps.client_tz),
	            minStartDate: (0, _utility.getTimezoneMoment)(campaignDetail.startDate, nextProps.client_tz),
	            endDate: (0, _utility.getTimezoneMoment)(campaignDetail.endDate, nextProps.client_tz),
	            compareEndDate: (0, _utility.getTimezoneMoment)(campaignDetail.endDate, nextProps.client_tz),
	            campaignName: campaignDetail.name,
	            audienceSize: campaignDetail.audienceSize,
	            campaignBudget: campaignDetail.budget,
	            clientCampaignId: campaignDetail.clientCampaignId,
	            selectEmailCampaigns: selectEmailCampaigns,
	            selectSocialCampaigns: selectSocialCampaigns,
	            selectDisplayCampaigns: selectDisplayCampaigns,
	            sltEmailChannelCampaigns: (0, _map2.default)(selectEmailCampaigns, "id"),
	            sltSocialChannelCampaigns: (0, _map2.default)(selectSocialCampaigns, "id"),
	            sltDisplayChannelCampaigns: (0, _map2.default)(selectDisplayCampaigns, "id"),
	            emailDeployCampaigns: campaignDetail.emailDeployments,
	            socialDeployCampaigns: campaignDetail.socialDeployments,
	            displayDeployCampaigns: campaignDetail.displayDeployments,
	            emailReportDelivered: campaignDetail.emailReportDelivered,
	            emailReportDistinctIndividuals: campaignDetail.emailReportDistinctIndividuals
	          });
	        }
	      }
	
	      if (this.props.client_id !== nextProps.client_id) {
	        if (this.props.campaignDetail) {
	          if (nextProps.client_id !== this.props.campaignDetail.clientId) {
	            this.props.selectClient(this.props.campaignDetail.clientId);
	          }
	        }
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var datePickers = document.getElementsByClassName("react-datepicker__input-container");
	      (0, _map2.default)(datePickers, function (datePicker) {
	        datePicker.childNodes[0].setAttribute("readOnly", true);
	      });
	
	      var _props = this.props,
	          match = _props.match,
	          location = _props.location;
	
	      if (location.pathname.indexOf("campaigns/edit") >= 0) {
	        if (match && match.params && match.params.id) {
	          this.setState({
	            campaignId: match.params.id,
	            inEdit: false,
	            editMode: true
	          });
	          if (!this.props.campaignDetail) {
	            this.props.getCampaignById(match.params.id);
	          }
	        }
	      }
	    }
	  }, {
	    key: "handleClickDownload",
	    value: function handleClickDownload() {
	      this.setState({ showDownloadDialog: true });
	    }
	  }, {
	    key: "handleDownload",
	    value: function handleDownload(e) {
	      e.preventDefault();
	
	      if (this.refs.cbPDF.state.switched) {
	        this.handlePdfDownload();
	      }
	
	      if (this.refs.cbCSV.state.switched) {
	        this.handleCsvDownload();
	      }
	    }
	  }, {
	    key: "_addPdfHeader",
	    value: function _addPdfHeader(pdf, client_name, bu_name, campaignDetail) {
	      pdf.setFillColor(127, 127, 127);
	      pdf.rect(0, 15, 210, 10, "F");
	
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(9);
	      pdf.setFontType("bold");
	      pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), "PNG", 10.5, 3, 60, 0);
	      pdf.text(198, 8, (0, _momentTimezone2.default)().format("MMMM DD, YYYY"), null, null, "right");
	
	      pdf.setTextColor(255, 255, 255);
	      pdf.setFontType("bold");
	      pdf.text(12, 21, "Client:");
	      //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
	      pdf.setFontType("normal");
	      pdf.text(26, 21, client_name ? client_name.trim() : "");
	      //cm to inches
	      var start = 90; //46 + lenClientName.width * 0.3937 + 0.4
	      if (!(0, _isEmpty2.default)(bu_name)) {
	        pdf.setFontType("bold");
	        pdf.text(start, 21, "Business Unit:");
	        start += 26.5;
	        pdf.setFontType("normal");
	        pdf.text(start, 21, bu_name ? bu_name.trim() : "");
	      }
	      pdf.setFillColor(255);
	      start = 12;
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(10);
	      pdf.text(12, 30, "Campaigns  >  " + campaignDetail.name);
	    }
	  }, {
	    key: "handlePdfDownload",
	    value: function handlePdfDownload() {
	      this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
	      var _props2 = this.props,
	          campaignDetail = _props2.campaignDetail,
	          clients = _props2.clients,
	          client_info = _props2.client_info;
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var c = (0, _find2.default)(clients, function (c) {
	          return c.id === client_info.parentClientId;
	        });
	        client_name = c.name;
	        bu_name = client_info.name;
	      }
	
	      var pdfFileName = campaignDetail.name.split(" ").join("_") + "_Campaign_Group_Details_" + (0, _momentTimezone2.default)().format("YYYYMMDD") + ".pdf";
	
	      var pdf = new pdfConverter("p", "mm", "a4");
	      pdf.setFont("Helvetica");
	      pdf.setFontType("normal");
	      pdf.setFontSize(9);
	      var pageWidth = 186;
	
	      var el_campaign_detail = document.getElementsByClassName("campaign-detail-pdf-container")[0];
	      el_campaign_detail.style.display = "block";
	      var el_email_channel = document.getElementsByClassName("email-channel-section")[0];
	      var el_social_channel = document.getElementsByClassName("social-channel-section")[0];
	      var el_display_channel = document.getElementsByClassName("display-channel-section")[0];
	      var el_arrow_down_icons = document.getElementsByClassName("arrow-down");
	      (0, _map2.default)(el_arrow_down_icons, function (icon) {
	        icon.style.display = "none";
	      });
	      var tables = document.getElementsByClassName("spread-table");
	      for (var i = 0; i < tables.length; i++) {
	        tables[i].style.maxHeight = "450px";
	      }
	
	      var canvasCampaignDetail = null;
	      var canvasEmailChannel = null;
	      var canvasFacebookChannel = null;
	      var canvasGoogleChannel = null;
	      var isCanvasCampaignDetailReady = false;
	      var isCanvasEmailChannelReady = false;
	      var isCanvasFacebookChannelReady = false;
	      var isCanvasGoogleChannelReady = false;
	
	      var oriWidth = el_campaign_detail.offsetWidth;
	      el_campaign_detail.style.width = "1024px";
	      el_email_channel.style.width = "1024px";
	      el_social_channel.style.width = "1024px";
	      el_display_channel.style.width = "1024px";
	
	      setTimeout(function () {
	        html2canvas(el_campaign_detail, { logging: false }).then(function (canvas) {
	          canvasCampaignDetail = canvas;
	          isCanvasCampaignDetailReady = true;
	          el_campaign_detail.style.width = oriWidth + "px";
	          el_campaign_detail.style.display = "none";
	        });
	      }, 50);
	      setTimeout(function () {
	        html2canvas(el_email_channel, { logging: false }).then(function (canvas) {
	          canvasEmailChannel = canvas;
	          isCanvasEmailChannelReady = true;
	          el_email_channel.style.width = oriWidth + "px";
	        });
	      }, 50);
	      setTimeout(function () {
	        html2canvas(el_social_channel, { logging: false }).then(function (canvas) {
	          canvasFacebookChannel = canvas;
	          isCanvasFacebookChannelReady = true;
	          el_social_channel.style.width = oriWidth + "px";
	        });
	      }, 50);
	      setTimeout(function () {
	        html2canvas(el_display_channel, { logging: false }).then(function (canvas) {
	          canvasGoogleChannel = canvas;
	          isCanvasGoogleChannelReady = true;
	          el_display_channel.style.width = oriWidth + "px";
	        });
	      }, 50);
	
	      var top = 35;
	      var left = 12;
	      var intervalId = setInterval(function () {
	        if (isCanvasCampaignDetailReady === false || isCanvasEmailChannelReady === false || isCanvasFacebookChannelReady === false || isCanvasGoogleChannelReady === false) {
	          console.log("PDF Generating...");
	        } else {
	          clearInterval(intervalId);
	          setTimeout(function () {
	            this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
	            var h1 = canvasCampaignDetail.height * pageWidth / canvasCampaignDetail.width;
	            var h2 = canvasEmailChannel.height * pageWidth / canvasEmailChannel.width;
	            var h3 = canvasFacebookChannel.height * pageWidth / canvasFacebookChannel.width;
	            var h4 = canvasGoogleChannel.height * pageWidth / canvasGoogleChannel.width;
	
	            pdf.addImage(canvasCampaignDetail.toDataURL(), "PNG", left, top, pageWidth, 0);
	            top += h1 + 4;
	            pdf.addImage(canvasEmailChannel.toDataURL(), "PNG", left, top, pageWidth, 0);
	            top += h2 + 4;
	
	            if (top + h3 > 285) {
	              (0, _utility.addPdfFooter)(pdf);
	              pdf.addPage("a4", "p");
	              this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
	              top = 35;
	            }
	            pdf.addImage(canvasFacebookChannel.toDataURL(), "PNG", left, top, pageWidth, 0);
	            top += h3 + 4;
	
	            if (top + h4 > 285) {
	              (0, _utility.addPdfFooter)(pdf);
	              pdf.addPage("a4", "p");
	              this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
	              top = 35;
	            }
	            pdf.addImage(canvasGoogleChannel.toDataURL(), "PNG", left, top, pageWidth, 0);
	
	            (0, _map2.default)(el_arrow_down_icons, function (icon) {
	              icon.style.display = "block";
	            });
	
	            (0, _utility.addPdfFooter)(pdf);
	
	            for (var i = 0; i < tables.length; i++) {
	              tables[i].style.maxHeight = "320px";
	            }
	
	            pdf.save(pdfFileName);
	            this.setState({ onPdfReportDownload: false });
	          }.bind(this), 100);
	        }
	      }.bind(this), 50);
	    }
	  }, {
	    key: "handleCsvDownload",
	    value: function handleCsvDownload() {
	      this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	
	      var _props3 = this.props,
	          campaignDetail = _props3.campaignDetail,
	          clients = _props3.clients,
	          client_info = _props3.client_info;
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var c = (0, _find2.default)(clients, function (c) {
	          return c.id === client_info.parentClientId;
	        });
	        client_name = c.name;
	        bu_name = client_info.name;
	      }
	      var budget = "$" + (0, _utility.formatMoney)(campaignDetail.budget, 2, ".", ",");
	      var title_line = "AudienceAnywhere Campaign Group Details Report ,,,,\r\n";
	      // moment().format("YYYY-MM-DD")
	      var date_line = "Today's Date," + ("\"" + (0, _momentTimezone2.default)().format("MM/DD/YY") + "\"") + ",,,\r\n";
	      var client_line = "Client," + client_name + ",,,\r\n";
	      var business_unit_line = "Business Unit," + bu_name + ",,,\r\n";
	      var split_line = ",,,,\r\n";
	      var campaign_group_line = "CAMPAIGN GROUP,,,,\r\n";
	      var campaign_group_name_line = "Campaign Group Name," + campaignDetail.name + ",,,\r\n";
	      var campaign_group_audience_line = "Audience Size,\"" + campaignDetail.audienceSize + "\",,,\r\n";
	      var campaign_group_budget_line = "Campaign Budget,\"" + budget + " \",,,\r\n";
	      var campaign_group_id_line = "Campaign Group ID,\"" + campaignDetail.campaignId + "\",,,\r\n";
	      var campaign_group_client_group_id_line = "Client Campaign ID," + campaignDetail.clientCampaignId + ",,,\r\n";
	      var campaign_group_start_date_line = "Campaign Group Start Date," + (0, _momentTimezone2.default)(campaignDetail.startDate, "YYYY-MM-DD").format("MM-DD-YYYY") + ",,,\r\n";
	      var campaign_group_end_date_line = "Campaign Group End Date," + (campaignDetail.endDate ? (0, _momentTimezone2.default)(campaignDetail.endDate, "YYYY-MM-DD").format("MM-DD-YYYY") : "") + ",,,\r\n";
	      var campaign_group_status_line = "Campaign Group Status," + campaignDetail.status + ",,,\r\n";
	      var email_title_line = "EMAIL,,,,\r\n";
	      var campaign_reporting_options = "Reporting Options," + (campaignDetail.emailReportDelivered ? "Delivered" : campaignDetail.emailReportDistinctIndividuals ? "Distinct Individuals" : "") + ",,,\r\n";
	      var email_channel_campaign_lines = [];
	      var social_channel_campaign_lines = [];
	      var display_channel_campaign_lines = [];
	      var email_deployment_idx = 0;
	      var social_deployment_id = 0;
	      var display_deployment_id = 0;
	      function formatSpecialSymbol(str) {
	        if (!str || typeof str !== "string") return str;else return str.replace(/#/g, "♯");
	      }
	      (0, _map2.default)(campaignDetail.campaignDeployments, function (deployment, idx) {
	        var line = "";
	
	        if (deployment.channel.toLowerCase() === "email") {
	          line += ",,,,\r\n";
	          line += "Deployment " + (email_deployment_idx + 1) + " - " + deployment.name + ",,,,\r\n";
	          email_deployment_idx += 1;
	          line += "Segment Name,Segment ID,Segment Start Date,Segment End Date,Status\r\n";
	          (0, _map2.default)(deployment.channelCampaigns, function (campaign) {
	            line += formatSpecialSymbol(campaign.name) + ",\"" + campaign.campaignId + "\"," + (0, _momentTimezone2.default)(campaign.startDate, "YYYY-MM-DD").format("MM-DD-YYYY") + "," + (campaign.endDate ? (0, _momentTimezone2.default)(campaign.endDate, "YYYY-MM-DD").format("MM-DD-YYYY") : "") + "," + campaign.status + "\r\n";
	          });
	          email_channel_campaign_lines.push(line);
	        }
	        if (deployment.channel.toLowerCase() === "social") {
	          line += ",,,,\r\n";
	          line += "Deployment " + (social_deployment_id + 1) + " - " + deployment.name + ",,,,\r\n";
	          social_deployment_id += 1;
	          line += "Segment Name,Segment ID,Segment Start Date,Segment End Date,Status\r\n";
	          (0, _map2.default)(deployment.channelCampaigns, function (campaign) {
	            line += formatSpecialSymbol(campaign.name) + ",\"" + campaign.campaignId + "\"," + (0, _momentTimezone2.default)(campaign.startDate, "YYYY-MM-DD").format("MM-DD-YYYY") + "," + (campaign.endDate ? (0, _momentTimezone2.default)(campaign.endDate, "YYYY-MM-DD").format("MM-DD-YYYY") : "") + "," + campaign.status + "\r\n";
	          });
	          social_channel_campaign_lines.push(line);
	        }
	        if (deployment.channel.toLowerCase() === "display") {
	          line += ",,,,\r\n";
	          line += "Deployment " + (display_deployment_id + 1) + " - " + deployment.name + ",,,,\r\n";
	          display_deployment_id += 1;
	          line += "Segment Name,Segment ID,Segment Start Date,Segment End Date,Status\r\n";
	          (0, _map2.default)(deployment.channelCampaigns, function (campaign) {
	            line += formatSpecialSymbol(campaign.name) + ",\"" + campaign.campaignId + "\"," + (0, _momentTimezone2.default)(campaign.startDate, "YYYY-MM-DD").format("MM-DD-YYYY") + "," + (campaign.endDate ? (0, _momentTimezone2.default)(campaign.endDate, "YYYY-MM-DD").format("MM-DD-YYYY") : "") + "," + campaign.status + "\r\n";
	          });
	          display_channel_campaign_lines.push(line);
	        }
	      });
	      var social_title_line = "SOCIAL,,,,\r\n";
	      var facebook_title_line = "FACEBOOK,,,,\r\n";
	      var display_title_line = "DISPLAY,,,,\r\n";
	      var google_table_header_line = "";
	      var facebook_table_header_line = "";
	      var google_title_line = "Google Ads,,,,\r\n";
	      var resultString = title_line + date_line + client_line + business_unit_line + split_line + campaign_group_line + campaign_group_name_line + campaign_group_audience_line + campaign_group_budget_line + campaign_group_id_line + campaign_group_client_group_id_line + campaign_group_start_date_line + campaign_group_end_date_line + campaign_group_status_line + split_line + email_title_line;
	      if (campaignDetail.emailReportDelivered || campaignDetail.emailReportDistinctIndividuals) {
	        resultString += campaign_reporting_options;
	      }
	      (0, _map2.default)(email_channel_campaign_lines, function (line) {
	        resultString += line;
	      });
	      resultString += split_line + social_title_line + split_line + facebook_title_line;
	      if (social_channel_campaign_lines.length > 0) {
	        resultString += facebook_table_header_line;
	        (0, _map2.default)(social_channel_campaign_lines, function (line) {
	          resultString += line;
	        });
	      }
	
	      resultString += split_line + display_title_line + split_line + google_title_line;
	      if (display_channel_campaign_lines.length > 0) {
	        resultString += google_table_header_line;
	        (0, _map2.default)(display_channel_campaign_lines, function (line) {
	          resultString += line;
	        });
	      }
	      var csvFileName = campaignDetail.name.split(" ").join("_") + "_Campaign_Group_Details_" + (0, _momentTimezone2.default)().format("YYYYMMDD");
	
	      (0, _utility.downLoadCSVFunc)(resultString, csvFileName);
	      setTimeout(function () {
	        this.setState({ onCsvReportDownload: false });
	      }.bind(this), 2000);
	    }
	  }, {
	    key: "addDeployment",
	    value: function addDeployment(name, channel) {
	      var result = void 0;
	      switch (channel.toUpperCase()) {
	        case "SOCIAL":
	          result = this.state.socialDeployCampaigns;
	          break;
	        case "DISPLAY":
	          result = this.state.displayDeployCampaigns;
	          break;
	        case "EMAIL":
	        default:
	          result = this.state.emailDeployCampaigns;
	          break;
	      }
	      result.push({
	        name: name,
	        channel: channel,
	        channelCampaigns: []
	      });
	      switch (channel.toUpperCase()) {
	        case "SOCIAL":
	          this.setState({
	            socialDeployCampaigns: result
	          });
	          break;
	        case "DISPLAY":
	          this.setState({
	            displayDeployCampaigns: result
	          });
	          break;
	        case "EMAIL":
	        default:
	          this.setState({
	            emailDeployCampaigns: result
	          });
	          break;
	      }
	    }
	  }, {
	    key: "removeDeployment",
	    value: function removeDeployment(name, channel) {
	      var source = void 0;
	      switch (channel) {
	        case "social":
	          source = this.state.socialDeployCampaigns;
	          break;
	        case "display":
	          source = this.state.displayDeployCampaigns;
	          break;
	        case "email":
	        default:
	          source = this.state.emailDeployCampaigns;
	          break;
	      }
	      (0, _remove2.default)(source, function (deployment) {
	        return deployment.name.toLowerCase() === name.toLowerCase() && deployment.channel.toLowerCase() === channel.toLowerCase();
	      });
	      /*
	      this.setState({
	        deploymentCampaigns: result
	      })*/
	    }
	  }, {
	    key: "setEmailReportDelivered",
	    value: function setEmailReportDelivered(val) {
	      this.setState({
	        emailReportDelivered: val
	      });
	    }
	  }, {
	    key: "setEmailReportDistinct",
	    value: function setEmailReportDistinct(val) {
	      this.setState({
	        emailReportDistinctIndividuals: val
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          savingCampaignErrorMessage = _props4.savingCampaignErrorMessage,
	          onSavingCampaign = _props4.onSavingCampaign,
	          campaignDetail = _props4.campaignDetail;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "create-campaigns date-selection" },
	        _react2.default.createElement(_Title2.default, {
	          selected_client: this.props.client_id,
	          crumb: campaignDetail ? campaignDetail.name : "Create Campaign",
	          linkName: "Campaigns",
	          showDownloadBtn: campaignDetail && !this.state.inEdit ? true : false,
	          handleDownload: this.handleClickDownload.bind(this)
	        }),
	        this.state.inEdit ? _react2.default.createElement(
	          "div",
	          { className: "group" },
	          _react2.default.createElement(
	            "h2",
	            { style: { fontSize: "24px", maginBottom: "20px" } },
	            "CAMPAIGN GROUP"
	          ),
	          _react2.default.createElement(_InputField2.default, {
	            labelTitle: "Campaign Group Name",
	            key: "campaign-name-input-field",
	            onChange: function onChange(e, value) {
	              return _this2.handleCampaignNameChanged(e, value);
	            },
	            labelStyle: {
	              float: "left",
	              height: "33px",
	              lineHeight: "33px",
	              margin: 0,
	              fontSize: "16px",
	              fontWeight: "bold"
	            },
	            inputContainerClassName: "input-wrapper",
	            inputStyle: { height: "28px", fontSize: "16px" },
	            initValue: this.state.campaignName,
	            borderColor: "#EEEFF2",
	            ifRequireField: true
	          }),
	          _react2.default.createElement(
	            "section",
	            { className: "group-type-container" },
	            _react2.default.createElement(
	              "p",
	              { style: { width: "396px", float: "left", fontSize: "16px" } },
	              "Campaign Group Type"
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                _RadioButton.RadioButtonGroup,
	                {
	                  style: { float: "left", width: "40%" },
	                  name: "campaignType",
	                  valueSelected: this.state.groupCampaignType,
	                  onChange: function onChange(e, value) {
	                    return _this2.handleGroupCampaignTypeChange(e, value);
	                  }
	                },
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: "General",
	                  label: "General Marketing Campaign",
	                  iconStyle: { fill: "black", width: "20px", height: "20px" }
	                }),
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: "FirmOfferOfCredit",
	                  label: "Firm Offer Of Credit",
	                  iconStyle: { fill: "black", width: "20px", height: "20px" }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(_InputField2.default, {
	            key: "audience-size-input-field",
	            labelTitle: "Audience Size",
	            labelStyle: {
	              float: "left",
	              height: "33px",
	              lineHeight: "33px",
	              margin: 0,
	              fontSize: "16px",
	              fontWeight: "bold"
	            },
	            inputContainerClassName: "input-wrapper",
	            onChange: function onChange(e, value) {
	              return _this2.handleAudienceSizeChanged(e, value);
	            },
	            inputStyle: { height: "28px", fontSize: "16px" },
	            initValue: this.state.audienceSize,
	            onKeyDown: this.intKeyDown,
	            borderColor: "#EEEFF2",
	            maskInput: function maskInput(val) {
	              return (0, _utility.splitNumber)(val)();
	            }
	          }),
	          _react2.default.createElement(_InputField2.default, {
	            key: "campaign-budget-input-field",
	            labelTitle: "Campaign Budget",
	            labelStyle: {
	              float: "left",
	              height: "33px",
	              lineHeight: "33px",
	              margin: 0,
	              fontSize: "16px",
	              fontWeight: "bold"
	            },
	            onChange: function onChange(e, value) {
	              return _this2.handleCampaignBudgetChanged(e, value);
	            },
	            inputContainerClassName: "input-wrapper",
	            inputStyle: { height: "28px", fontSize: "16px" },
	            handleOnBlur: this.handleBudgetOnBlur.bind(this),
	            initValue: this.state.campaignBudget,
	            onKeyDown: this.numKeyDown,
	            maskInput: function maskInput(val) {
	              return "$" + (0, _utility.formatMoney)(val, 2, ".", ",");
	            },
	            borderColor: "#EEEFF2"
	          }),
	          _react2.default.createElement(
	            "section",
	            { className: "cam-id" },
	            _react2.default.createElement(
	              "span",
	              null,
	              "# Campaign Group ID",
	              _react2.default.createElement(
	                "em",
	                null,
	                "*"
	              )
	            ),
	            this.props.campaignDetail ? _react2.default.createElement(
	              "span",
	              null,
	              this.props.campaignDetail.campaignId
	            ) : _react2.default.createElement(
	              "strong",
	              null,
	              "-"
	            )
	          ),
	          _react2.default.createElement(_InputField2.default, {
	            key: "client-campaign-id-input-field",
	            labelTitle: "Client Campaign ID",
	            labelStyle: {
	              float: "left",
	              height: "33px",
	              lineHeight: "33px",
	              margin: 0,
	              fontSize: "16px",
	              fontWeight: "bold"
	            },
	            inputContainerClassName: "input-wrapper",
	            onChange: function onChange(e, value) {
	              return _this2.handleClientCampaignIdChanged(e, value);
	            },
	            inputStyle: { height: "28px", fontSize: "16px" },
	            initValue: this.state.clientCampaignId,
	            borderColor: "#EEEFF2"
	          }),
	          _react2.default.createElement(
	            "section",
	            {
	              className: "startDate content clearfix",
	              style: { marginBottom: "30px" }
	            },
	            _react2.default.createElement(
	              "span",
	              { className: "title", style: { fontSize: "16px" } },
	              "Campaign Group Start Date",
	              _react2.default.createElement(
	                "em",
	                null,
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "start-date clearfix",
	                style: {
	                  borderColor:
	                  /*this.state.selectEmailCampaigns.length > 0 ? "#D3D3D3" :*/"#EEEFF2"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "icon-wrapper",
	                  style: {
	                    background:
	                    /*this.state.selectEmailCampaigns.length > 0 ? "#D3D3D3" : */"#F6F6F6"
	                  }
	                },
	                _react2.default.createElement("i", {
	                  className: "far fa-calendar-alt",
	                  style: {
	                    color:
	                    /*this.state.selectEmailCampaigns.length > 0 ? "#999999" :*/"#A3A3A3"
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "date-wrapper",
	                  onClick: function onClick() {
	                    return _this2.handleClickDateWrapper();
	                  }
	                },
	                _react2.default.createElement(_reactDatepicker2.default, {
	                  dateFormat: "MM-DD-YYYY",
	                  calendarClassName: "calendar-left",
	                  className:
	                  /*this.state.selectEmailCampaigns.length > 0 ? "date-con date-con-disabled" :*/"date-con",
	                  selected: this.state.startDate,
	                  startDate: this.state.startDate,
	                  minDate: this.state.minStartDate /*
	                                                   disabled={(this.state.selectEmailCampaigns && this.state.selectEmailCampaigns.length > 0) || 
	                                                   (this.state.selectSocialCampaigns && this.state.selectSocialCampaigns.length > 0) || 
	                                                   (this.state.selectDisplayCampaigns && this.state.selectDisplayCampaigns.length > 0)}*/
	                  , filterDate: function filterDate(date) {
	                    return date.format("M") === _this2.state.compareStartDate.format("M");
	                  },
	                  onMonthChange: function onMonthChange(date) {
	                    return _this2.handleOnStartMonthChange(date);
	                  },
	                  onChange: function onChange(date) {
	                    return _this2.handleStartDateChange(date);
	                  },
	                  showDisabledMonthNavigation: true
	                })
	              )
	            ),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(
	            "section",
	            { className: "startDate clearfix" },
	            _react2.default.createElement(
	              "span",
	              { className: "title" },
	              "Campaign Group End Date",
	              _react2.default.createElement(
	                "em",
	                null,
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "start-date content clearfix",
	                style: { borderColor: "#EEEFF2" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "icon-wrapper", style: { background: "#F6F6F6" } },
	                _react2.default.createElement("i", {
	                  className: "far fa-calendar-alt",
	                  style: { color: "#A3A3A3" }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "date-wrapper",
	                  onClick: function onClick() {
	                    return _this2.handleClickDateWrapper();
	                  }
	                },
	                _react2.default.createElement(_reactDatepicker2.default, {
	                  dateFormat: "MM-DD-YYYY",
	                  calendarClassName: "calendar-left",
	                  className: "date-con",
	                  selected: this.state.endDate,
	                  endDate: this.state.endDate,
	                  filterDate: function filterDate(date) {
	                    return date.format("M") === _this2.state.compareEndDate.format("M");
	                  },
	                  onMonthChange: function onMonthChange(date) {
	                    return _this2.handleOnEndMonthChange(date);
	                  },
	                  onChange: function onChange(date) {
	                    return _this2.handleEndDateChange(date);
	                  },
	                  minDate: this.props.campaignDetail && this.props.campaignDetail.status.toLowerCase !== "draft" && this.props.campaignDetail.campaignDeployments.length > 0 ? (0, _momentTimezone2.default)(this.props.campaignDetail.endDate) : this.state.startDate,
	                  showDisabledMonthNavigation: true
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "section",
	            { className: "cam-id", style: { margin: 0 } },
	            _react2.default.createElement(
	              "span",
	              null,
	              "Campaign Group Status"
	            ),
	            this.props.campaignDetail ? _react2.default.createElement(
	              "span",
	              null,
	              this.props.campaignDetail.status
	            ) : _react2.default.createElement(
	              "strong",
	              null,
	              "-"
	            )
	          )
	        ) : campaignDetail && _react2.default.createElement(_CampaignDetail2.default, { data: campaignDetail }),
	        _react2.default.createElement(
	          "div",
	          { className: "add email-channel-section" },
	          _react2.default.createElement(_AddCampaign2.default, {
	            title: "EMAIL",
	            startDate: (0, _momentTimezone2.default)(this.state.startDate).format("YYYY-MM-DD"),
	            endDate: (0, _momentTimezone2.default)(this.state.endDate).format("YYYY-MM-DD"),
	            campaignName: this.state.campaignName,
	            parentCampaignDetail: this.props.campaignDetail,
	            selectedCampaigns: this.state.selectEmailCampaigns,
	            channelCampaigns: this.props.emailChannelCampaigns,
	            prevSelectCampaignIds: this.state.sltEmailChannelCampaigns,
	            onClickAddCampaign: this.clickAddEmailCampaign.bind(this),
	            onApplyCampaignChanges: this.applyChannelCampaignChanges.bind(this),
	            viewMode: !this.state.inEdit,
	            showReportOptions: true,
	            setEmailReportDelivered: this.setEmailReportDelivered.bind(this),
	            setEmailReportDistinct: this.setEmailReportDistinct.bind(this),
	            deploymentCampaigns: this.state.emailDeployCampaigns,
	            addDeployment: this.addDeployment.bind(this),
	            removeDeployment: this.removeDeployment.bind(this)
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "add social-channel-section" },
	          _react2.default.createElement(
	            _AddCampaign2.default,
	            {
	              title: "SOCIAL",
	              startDate: (0, _momentTimezone2.default)(this.state.startDate).format("YYYY-MM-DD"),
	              endDate: (0, _momentTimezone2.default)(this.state.endDate).format("YYYY-MM-DD"),
	              campaignName: this.state.campaignName,
	              parentCampaignDetail: this.props.campaignDetail,
	              selectedCampaigns: this.state.selectSocialCampaigns,
	              channelCampaigns: this.props.socialChannelCampaigns,
	              prevSelectCampaignIds: this.state.sltSocialChannelCampaigns,
	              onClickAddCampaign: this.clickAddSocialCampaign.bind(this),
	              onApplyCampaignChanges: this.applyChannelCampaignChanges.bind(this),
	              viewMode: !this.state.inEdit,
	              showReportOptions: false,
	              deploymentCampaigns: this.state.socialDeployCampaigns,
	              addDeployment: this.addDeployment.bind(this),
	              removeDeployment: this.removeDeployment.bind(this),
	              legacy: false
	            },
	            _react2.default.createElement(
	              "h3",
	              null,
	              "FACEBOOK"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "add display-channel-section" },
	          _react2.default.createElement(
	            _AddCampaign2.default,
	            {
	              title: "DISPLAY",
	              startDate: (0, _momentTimezone2.default)(this.state.startDate).format("YYYY-MM-DD"),
	              endDate: (0, _momentTimezone2.default)(this.state.endDate).format("YYYY-MM-DD"),
	              campaignName: this.state.campaignName,
	              parentCampaignDetail: this.props.campaignDetail,
	              selectedCampaigns: this.state.selectDisplayCampaigns,
	              channelCampaigns: this.props.displayChannelCampaigns,
	              prevSelectCampaignIds: this.state.sltDisplayChannelCampaigns,
	              onClickAddCampaign: this.clickAddGoogleCampaign.bind(this),
	              onApplyCampaignChanges: this.applyChannelCampaignChanges.bind(this),
	              viewMode: !this.state.inEdit,
	              deploymentCampaigns: this.state.displayDeployCampaigns,
	              addDeployment: this.addDeployment.bind(this),
	              removeDeployment: this.removeDeployment.bind(this),
	              legacy: false
	            },
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Google Ads"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "create-btn clearfix" },
	          this.state.inEdit ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "confirm" },
	              _react2.default.createElement(_Button2.default, {
	                title: "Save",
	                disabled: !this.state.campaignName,
	                handleClick: this.onSaveClick.bind(this)
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "confirm" },
	              _react2.default.createElement(_Button2.default, {
	                ifHasBg: false,
	                handleClick: this.onClickCancel.bind(this),
	                title: "Cancel"
	              })
	            )
	          ) : _react2.default.createElement(
	            "div",
	            { className: "confirm" },
	            _react2.default.createElement(_Button2.default, { title: "Edit", handleClick: this.onEditClick.bind(this) })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "cancel pt-5" },
	            onSavingCampaign && _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } }),
	            savingCampaignErrorMessage && _react2.default.createElement(
	              "span",
	              { style: { color: "#FF0000" } },
	              _react2.default.createElement("i", { className: "icon-warning2 pr-10" }),
	              savingCampaignErrorMessage
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.onCsvReportDownload,
	            style: { top: "-1.8em" },
	            modal: true,
	            contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: "#666666" }
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "mt-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                offsetXs: "1",
	                offsetSm: "1",
	                offsetMd: "1",
	                offsetLg: "1",
	                xs: "7",
	                sm: "7",
	                md: "7",
	                lg: "7",
	                className: "text-right"
	              },
	              _react2.default.createElement(
	                "div",
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "1", sm: "1", md: "1", lg: "1" },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.onPdfReportDownload,
	            style: { top: "-1.8em" },
	            modal: true,
	            contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: "#666666" }
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "mt-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                offsetXs: "1",
	                offsetSm: "1",
	                offsetMd: "1",
	                offsetLg: "1",
	                xs: "7",
	                sm: "7",
	                md: "7",
	                lg: "7",
	                className: "text-right"
	              },
	              _react2.default.createElement(
	                "div",
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "1", sm: "1", md: "1", lg: "1" },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.showDownloadDialog,
	            style: { top: "-1.8em" },
	            modal: true,
	            contentStyle: { width: "440px" }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-margin-top no-padding",
	              style: { fontSize: "16px", color: "#000" }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Choose the type of file you would like to download"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-padding-top no-padding-right no-padding-bottom no-margin-bottom",
	              style: { paddingLeft: "150px" }
	            },
	            _react2.default.createElement(_Checkbox2.default, {
	              iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	              label: "PDF File",
	              labelStyle: { fontSize: "16px" },
	              defaultChecked: false,
	              ref: "cbPDF" /*onCheck={this.updateCheck.bind(this, item.id)}*/
	            })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-padding-top no-padding-right no-padding-bottom",
	              style: { paddingLeft: "150px" }
	            },
	            _react2.default.createElement(_Checkbox2.default, {
	              iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	              label: "CSV File",
	              labelStyle: { fontSize: "16px" },
	              defaultChecked: true,
	              ref: "cbCSV" /*onCheck={this.updateCheck.bind(this, item.id)}*/
	            })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding no-margin-bottom mt-20 text-center" },
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                onClick: function onClick() {
	                  return _this2.setState({ showDownloadDialog: false });
	                },
	                className: "btn btn-default btn-aa-info mr-20"
	              },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                onClick: this.handleDownload.bind(this),
	                className: "btn btn-default btn-aa-default"
	              },
	              "Download File"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateCampaigns;
	}(_MaterialUI2.default);
	
	exports.default = CreateCampaigns;

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatepicker = __webpack_require__(440);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(269);
	
	__webpack_require__(1402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateSelection = function (_Component) {
	  _inherits(DateSelection, _Component);
	
	  function DateSelection(props) {
	    _classCallCheck(this, DateSelection);
	
	    var _this = _possibleConstructorReturn(this, (DateSelection.__proto__ || Object.getPrototypeOf(DateSelection)).call(this, props));
	
	    _this.state = {
	      startDate: props.defaultStartDate ? (0, _moment2.default)(props.defaultStartDate) :
	      /*props.timezone ? moment().startOf('month').tz(props.timezone) : moment().startOf('month')*/null,
	      endDate: props.defaultEndDate ? (0, _moment2.default)(props.defaultEndDate) : null,
	      activeMonth: true,
	      activeMonthEnd: true,
	      compareStartDate: props.defaultStartDate ? (0, _moment2.default)(props.defaultStartDate) : props.timezone ? (0, _moment2.default)().startOf('month').tz(props.timezone) : (0, _moment2.default)().startOf('month'),
	      compareEndDate: props.defaultEndDate ? (0, _moment2.default)(props.defaultEndDate) : props.timezone ? (0, _moment2.default)().endOf('month').tz(props.timezone) : (0, _moment2.default)().endOf("month")
	    };
	    return _this;
	  }
	
	  _createClass(DateSelection, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.defaultStartDate !== this.props.defaultStartDate) {
	        this.setState({
	          startDate: nextProps.defaultStartDate ? (0, _moment2.default)(nextProps.defaultStartDate) : null
	        });
	      }
	      if (nextProps.defaultEndDate !== this.props.defaultEndDate) {
	        this.setState({
	          endDate: nextProps.defaultEndDate ? (0, _moment2.default)(nextProps.defaultEndDate) : null
	        });
	      }
	    }
	  }, {
	    key: 'handleStartDateChange',
	    value: function handleStartDateChange(startDate) {
	      this.props.startDateChange(startDate ? startDate.format('YYYY-MM-DD') : null);
	
	      if (startDate) {
	        this.handleChange({ startDate: startDate });
	      } else {
	        this.setState({ startDate: null });
	      }
	    }
	  }, {
	    key: 'handleEndDateChange',
	    value: function handleEndDateChange(endDate) {
	      this.props.endDateChange(endDate ? endDate.format('YYYY-MM-DD') : null);
	      if (endDate) {
	        this.handleChange({ endDate: endDate });
	      } else {
	        this.setState({ endDate: null });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(_ref) {
	      var startDate = _ref.startDate,
	          endDate = _ref.endDate;
	
	      startDate = startDate || this.state.startDate;
	      endDate = endDate || this.state.endDate;
	
	      if (startDate && startDate.isAfter(endDate)) {
	        if (!endDate) endDate = startDate;
	        this.setState({
	          compareEndDate: startDate
	        });
	      }
	      this.setState({
	        startDate: startDate,
	        endDate: endDate
	      });
	    }
	  }, {
	    key: 'handleClickDateWrapper',
	    value: function handleClickDateWrapper() {
	      var eles = document.querySelectorAll('.react-datepicker__day-name');
	      // change month name
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = eles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          v.innerText = v.innerText.substring(0, 1);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'handleOnMonthChange',
	    value: function handleOnMonthChange(date) {
	      this.setState({
	        compareStartDate: date
	      });
	    }
	  }, {
	    key: 'handleOnEndMonthChange',
	    value: function handleOnEndMonthChange(date) {
	      this.setState({
	        compareEndDate: date
	      });
	    }
	
	    /**
	     * this callback of apply button
	     */
	
	  }, {
	    key: 'handleApplyBeClick',
	    value: function handleApplyBeClick() {
	      this.props.handleApplyBeClick();
	    }
	  }, {
	    key: 'clickOutsiteDatePicker',
	    value: function clickOutsiteDatePicker(type) {
	      switch (type) {
	        case "end":
	          this.refs.endDatePicker.cancelFocusInput();
	          this.refs.endDatePicker.setOpen(false);
	          break;
	        case "start":
	        default:
	          this.refs.startDatePicker.cancelFocusInput();
	          this.refs.startDatePicker.setOpen(false);
	          break;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'date-selection' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Campaign Reporting Filter'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Filter campaigns by date.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content clearfix' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'From:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'start-date clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-wrapper' },
	              _react2.default.createElement('i', { className: 'far fa-calendar-alt' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'date-wrapper', onClick: function onClick() {
	                  return _this2.handleClickDateWrapper();
	                } },
	              _react2.default.createElement(_reactDatepicker2.default, {
	                ref: 'startDatePicker',
	                key: 'date-picker-start-date',
	                dateFormat: 'MM-DD-YYYY',
	                calendarClassName: 'calendar-left',
	                className: 'date-con',
	                selected: this.state.startDate,
	                isClearable: true,
	                startDate: this.state.startDate,
	                filterDate: function filterDate(date) {
	                  return date.format('M') === _this2.state.compareStartDate.format('M');
	                },
	                onMonthChange: function onMonthChange(date) {
	                  return _this2.handleOnMonthChange(date);
	                },
	                onChange: function onChange(date) {
	                  return _this2.handleStartDateChange(date);
	                },
	                onClickOutside: function onClickOutside() {
	                  return _this2.clickOutsiteDatePicker("start");
	                }
	              })
	            )
	          ),
	          _react2.default.createElement('strong', { className: 'line' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'To:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'end-date' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-wrapper' },
	              _react2.default.createElement('i', { className: 'far fa-calendar-alt' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'date-wrapper', onClick: function onClick() {
	                  return _this2.handleClickDateWrapper();
	                } },
	              _react2.default.createElement(_reactDatepicker2.default, {
	                ref: 'endDatePicker',
	                key: 'date-picker-end-date',
	                dateFormat: 'MM-DD-YYYY',
	                calendarClassName: 'calendar-left',
	                className: 'date-con',
	                endDate: this.state.endDate,
	                isClearable: true,
	                selected: this.state.endDate,
	                filterDate: function filterDate(date) {
	                  return date.format('M') === _this2.state.compareEndDate.format('M');
	                },
	                onMonthChange: function onMonthChange(date) {
	                  return _this2.handleOnEndMonthChange(date);
	                },
	                onChange: function onChange(date) {
	                  return _this2.handleEndDateChange(date);
	                },
	                onClickOutside: function onClickOutside() {
	                  return _this2.clickOutsiteDatePicker("end");
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'apply', onClick: function onClick() {
	                return _this2.handleApplyBeClick();
	              } },
	            'Apply'
	          )
	        )
	      );
	    }
	  }]);
	
	  return DateSelection;
	}(_react.Component);
	
	exports.default = DateSelection;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Date = __webpack_require__(1062);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _search = __webpack_require__(155);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _Button = __webpack_require__(213);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CampaignsTable = __webpack_require__(1057);
	
	var _CampaignsTable2 = _interopRequireDefault(_CampaignsTable);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Page = __webpack_require__(103);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Grid = __webpack_require__(19);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _forEach = __webpack_require__(185);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _momentTimezone = __webpack_require__(110);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1404);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	// css
	
	var Campaigns = function (_Component) {
	  _inherits(Campaigns, _Component);
	
	  function Campaigns(props) {
	    _classCallCheck(this, Campaigns);
	
	    var _this = _possibleConstructorReturn(this, (Campaigns.__proto__ || Object.getPrototypeOf(Campaigns)).call(this, props));
	
	    (0, _utility.initMomentTimezone)();
	    if (props.client_tz) {
	      _momentTimezone2.default.tz.setDefault(props.client_tz);
	    }
	    var cid = (0, _utility.getUrlParameterByName)("cid");
	    if (cid) {
	      _this.props.selectClient(parseInt(cid, 10));
	    }
	    _this.state = {
	      onCsvReportDownload: false,
	      onPdfReportDownload: false,
	      showDownloadDialog: false,
	      disabledDlBtn: false,
	      requestParams: {
	        clientId: props.client_id,
	        pageNumber: 1,
	        pageSize: 7,
	        sortColumn: "startDate",
	        order: "desc",
	        fromDate: props.campaignFilterStartDate ? props.campaignFilterStartDate : /*moment(moment().tz(props.client_tz)).startOf("month").format('YYYY-MM-DD')*/null,
	        toDate: props.campaignFilterEndDate ? props.campaignFilterEndDate : null,
	        keyword: props.campaignFilterValue ? props.campaignFilterValue : ""
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Campaigns, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (typeof this.props.client_id === "number") this.props.getTables(this.state.requestParams);
	    }
	  }, {
	    key: "_addPdfHeader",
	    value: function _addPdfHeader(pdf, client_name, bu_name) {
	      pdf.setFillColor(127, 127, 127);
	      pdf.rect(0, 15, 210, 10, "F");
	
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(9);
	      pdf.setFontType("bold");
	      pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), "PNG", 10.5, 3, 60, 0);
	      pdf.text(198, 8, (0, _momentTimezone2.default)().format("MMMM DD, YYYY"), null, null, "right");
	
	      pdf.setTextColor(255, 255, 255);
	      pdf.setFontType("bold");
	      pdf.text(12, 21, "Client:");
	      //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
	      pdf.setFontType("normal");
	      pdf.text(26, 21, client_name ? client_name.trim() : "");
	      //cm to inches
	      var start = 90; //46 + lenClientName.width * 0.3937 + 0.4
	      if (!(0, _isEmpty2.default)(bu_name)) {
	        pdf.setFontType("bold");
	        pdf.text(start, 21, "Business Unit:");
	        start += 26.5;
	        pdf.setFontType("normal");
	        pdf.text(start, 21, bu_name ? bu_name.trim() : "");
	      }
	      pdf.setFillColor(255);
	      start = 12;
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(10);
	      //pdf.text(12, 30, 'Campaigns  >  ' + campaignDetail.name );
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (typeof nextProps.client_id === "number") {
	        if (nextProps.client_id !== this.props.client_id) {
	          var startDate = null; //moment(moment().tz(nextProps.client_tz)).startOf("month").format('YYYY-MM-DD');
	          this.props.setCampaignFilterStartDate(startDate);
	          this.props.setCampaignFilterEndDate(null);
	          this.setState({
	            requestParams: Object.assign({}, this.state.requestParams, {
	              clientId: nextProps.client_id,
	              fromDate: startDate,
	              toDate: null
	            })
	          }, function () {
	            _this2.props.getTables(_this2.state.requestParams);
	            _this2.props.history.push("/campaigns?cid=" + nextProps.client_id);
	          });
	        }
	
	        if (nextProps.csvData !== this.props.csvData && !(0, _isUndefined2.default)(nextProps.csvData)) {
	          var _props = this.props,
	              clients = _props.clients,
	              client_info = _props.client_info;
	
	          var client_name = client_info.name;
	          var bu_name = "";
	          if (client_info.parentClientId) {
	            var parent_client = (0, _find2.default)(clients, function (c) {
	              return c.id === client_info.parentClientId;
	            });
	            if (parent_client) {
	              client_name = parent_client.name;
	              bu_name = client_info.name;
	            }
	          }
	          var requestParams = this.state.requestParams;
	          var fromDate = requestParams.fromDate,
	              toDate = requestParams.toDate,
	              keyword = requestParams.keyword;
	
	          if (this.state.onCsvReportDownload) {
	            var title_line = "AudienceAnywhere Campaign List Report ,,,,,\r\n";
	            var date_line = "Today's Date," + (0, _momentTimezone2.default)().format("MM/DD/YY") + ",,,,\r\n";
	            var client_line = "Client," + client_name + ",,,,\r\n";
	            var business_unit_line = (0, _isEmpty2.default)(bu_name) ? "\r\n" : "Business Unit," + bu_name + ",,,,\r\n";
	            var split_line = ",,,,,\r\n";
	            var from_date = "From Date," + (0, _momentTimezone2.default)(fromDate).format("MM/DD/YY") + ",,,,\r\n";
	            var to_date = toDate ? "To Date," + (0, _momentTimezone2.default)(toDate).format("MM/DD/YY") + ",,,,\r\n" : "To Date,,,,,\r\n";
	            var search_criteria = keyword ? "Search Criteria," + keyword + ",,,,\r\n" : "Search Criteria,,,,,";
	            var campaign_table_title_line = "Campaign Group Name,Campaign Group ID,Client Campaign ID,Campaign Group Status,Campaign Group Start Date,Campaign Group End Date\r\n";
	
	            var resultString = title_line + date_line + client_line + business_unit_line + split_line + from_date + to_date + search_criteria + split_line + campaign_table_title_line;
	            (0, _map2.default)(nextProps.csvData.data, function (data) {
	              var str = data.name + ",\"" + data.campaignId + "\", " + (data.clientCampaignId ? data.clientCampaignId : "") + "," + data.status + "," + (0, _momentTimezone2.default)(data.startDate).format("MM/DD/YYYY") + "," + (0, _momentTimezone2.default)(data.endDate).format("MM/DD/YYYY") + "\r\n";
	              resultString += str;
	            });
	            var csvFileName = bu_name === "" ? "Campaign_List_Report_" + client_name + "_" + (0, _momentTimezone2.default)().format("YYYYMMDD") : "Campaign_List_Report_" + bu_name + "_" + (0, _momentTimezone2.default)().format("YYYYMMDD");
	
	            (0, _utility.downLoadCSVFunc)(resultString, csvFileName);
	            setTimeout(function () {
	              this.setState({ onCsvReportDownload: false });
	            }.bind(this), 2000);
	          }
	          if (this.state.onPdfReportDownload) {
	            var pdfFileName = bu_name === "" ? "Campaign_List_Report_" + client_name + "_" + (0, _momentTimezone2.default)().format("YYYYMMDD") + ".pdf" : "Campaign_List_Report_" + bu_name + "_" + (0, _momentTimezone2.default)().format("YYYYMMDD") + ".pdf";
	
	            var pdf = new pdfConverter("p", "mm", "a4");
	            pdf.setFont("Helvetica");
	            pdf.setFontType("normal");
	            pdf.setFontSize(9);
	            var pageWidth = 186;
	
	            var el_date_picker = document.getElementsByClassName("date-picker")[0];
	            var el_tables = document.getElementsByClassName("common-wrapper")[0];
	            var spreadTable = document.getElementsByClassName("spread-table")[0];
	
	            var canvasDatePicker = null;
	            var canvasTable = null;
	            var isCanvasDatePickerReady = false;
	            var isCanvasTableReady = false;
	            var oriWidth = el_date_picker.offsetWidth;
	            document.getElementsByClassName("spread-table")[0].style.maxHeight = "unset";
	            document.getElementsByClassName("page")[0].style.display = "none";
	            document.getElementsByClassName("icon")[0].style.display = "none";
	            if (document.getElementsByClassName("campaigns-create").length > 0) document.getElementsByClassName("campaigns-create")[0].style.display = "none";
	            document.getElementsByClassName("apply")[0].style.display = "none";
	            document.getElementsByName("campaign_search")[0].placeholder = "";
	            document.getElementsByClassName("tooltip-container")[0].style.display = "none";
	            var datepickerIcons = document.getElementsByClassName("react-datepicker__close-icon");
	            if (datepickerIcons.length > 0) datepickerIcons[0].style.display = "none";
	
	            el_date_picker.style.width = "1024px";
	            setTimeout(function () {
	              html2canvas(el_date_picker, { logging: false }).then(function (canvas) {
	                canvasDatePicker = canvas;
	                isCanvasDatePickerReady = true;
	                el_date_picker.style.width = oriWidth + "px";
	              });
	            }, 50);
	            var linkColor = null;
	            var campaignLinks = document.getElementsByClassName("campaign-name-link");
	            setTimeout(function () {
	              if (campaignLinks.length > 0) {
	                linkColor = campaignLinks[0].style.color;
	                (0, _forEach2.default)(campaignLinks, function (el) {
	                  el.style.color = "#000";
	                });
	              }
	              html2canvas(el_tables, { logging: false }).then(function (canvas) {
	                canvasTable = canvas;
	                isCanvasTableReady = true;
	                el_tables.style.width = oriWidth + "px";
	                document.getElementsByClassName("spread-table")[0].style.maxHeight = "500px"; //document.getElementsByClassName("spread-table").style.maxHeight = '290px'
	              });
	            }, 50);
	
	            var top = 32;
	            var left = 12;
	            var intervalId = setInterval(function () {
	              if (isCanvasDatePickerReady === false || isCanvasTableReady === false) {
	                console.log("PDF Generating...");
	              } else {
	                clearInterval(intervalId);
	                setTimeout(function () {
	                  this._addPdfHeader(pdf, client_name, bu_name);
	
	                  pdf.addImage(canvasDatePicker.toDataURL(), "PNG", left, top, pageWidth, 0);
	                  top += canvasDatePicker.height * pageWidth / canvasDatePicker.width + 4;
	                  pdf.addImage(canvasTable.toDataURL(), "PNG", left, top, pageWidth, 0);
	                  (0, _utility.addPdfFooter)(pdf);
	                  document.getElementsByClassName("page")[0].style.display = "block";
	                  document.getElementsByClassName("icon")[0].style.display = "block";
	                  if (document.getElementsByClassName("campaigns-create").length > 0) document.getElementsByClassName("campaigns-create")[0].style.display = "block";
	                  document.getElementsByClassName("apply")[0].style.display = "inline-block";
	                  document.getElementsByName("campaign_search")[0].placeholder = "Search by Campaign Name or ID";
	                  document.getElementsByClassName("tooltip-container")[0].style.display = "block";
	                  if (datepickerIcons.length > 0) datepickerIcons[0].style.display = "block";
	                  if (campaignLinks.length > 0) {
	                    (0, _forEach2.default)(campaignLinks, function (el) {
	                      el.style.color = linkColor;
	                    });
	                  }
	                  pdf.save(pdfFileName);
	                  this.props.clearCampaignCsvData();
	                  this.setState({ onPdfReportDownload: false });
	                }.bind(this), 100);
	              }
	            }.bind(this), 50);
	          }
	        }
	      }
	    }
	  }, {
	    key: "handleStartDateChange",
	    value: function handleStartDateChange(date) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          fromDate: date
	        })
	      });
	    }
	  }, {
	    key: "handleEndDateChange",
	    value: function handleEndDateChange(date) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          toDate: date
	        })
	      });
	    }
	  }, {
	    key: "handleApplyBeClick",
	    value: function handleApplyBeClick() {
	      this.props.setCampaignFilterValue(this.state.requestParams.keyword);
	      this.props.setCampaignFilterStartDate(this.state.requestParams.fromDate);
	      this.props.setCampaignFilterEndDate(this.state.requestParams.toDate);
	      this.props.getTables(this.state.requestParams);
	    }
	  }, {
	    key: "downloadCsvReport",
	    value: function downloadCsvReport() {
	      this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	    }
	  }, {
	    key: "downloadPdfReport",
	    value: function downloadPdfReport() {
	      this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
	    }
	  }, {
	    key: "handleBtnClick",
	    value: function handleBtnClick(e) {
	      e.preventDefault();
	      this.setState({ showDownloadDialog: true });
	    }
	  }, {
	    key: "handleDownload",
	    value: function handleDownload(e) {
	      e.preventDefault();
	      this.props.clearCampaignCsvData();
	      setTimeout(function () {
	        this.props.getCampaignCsvData({
	          clientId: this.state.requestParams.clientId,
	          pageNumber: 1,
	          pageSize: 99999,
	          sortColumn: this.state.requestParams.sortColumn,
	          order: this.state.requestParams.order,
	          fromDate: this.state.requestParams.fromDate,
	          toDate: this.state.requestParams.toDate,
	          keyword: this.state.requestParams.keyword
	        });
	      }.bind(this), 2000);
	
	      if (this.refs.cbPDF.state.switched) {
	        this.downloadPdfReport();
	      }
	
	      if (this.refs.cbCSV.state.switched) {
	        this.downloadCsvReport();
	      }
	    }
	  }, {
	    key: "cbPDFChange",
	    value: function cbPDFChange(e, isInputChecked) {
	      var result = !this.refs.cbCSV.state.switched && !isInputChecked;
	      this.setState({ disabledDlBtn: result });
	    }
	  }, {
	    key: "cbCSVChange",
	    value: function cbCSVChange(e, isInputChecked) {
	      var result = !this.refs.cbPDF.state.switched && !isInputChecked;
	      this.setState({ disabledDlBtn: result });
	    }
	  }, {
	    key: "onSearchChange",
	    value: function onSearchChange(e) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          keyword: e.target.value.trim()
	        })
	      });
	    }
	  }, {
	    key: "handleSearch",
	    value: function handleSearch(e) {
	      e.preventDefault();
	      this.props.setCampaignFilterValue(this.state.requestParams.keyword);
	      this.props.setCampaignFilterStartDate(this.state.requestParams.fromDate);
	      this.props.setCampaignFilterEndDate(this.state.requestParams.toDate);
	      this.props.getTables(this.state.requestParams);
	    }
	  }, {
	    key: "searchWithSort",
	    value: function searchWithSort(sortField, sortDesc) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          sortColumn: sortField,
	          order: sortDesc ? "desc" : "asc"
	        })
	      });
	
	      this.props.getTables(Object.assign({}, this.state.requestParams, {
	        sortColumn: sortField,
	        order: sortDesc ? "desc" : "asc"
	      }));
	    }
	  }, {
	    key: "handleCreateCampaign",
	    value: function handleCreateCampaign() {
	      this.props.clearCampaignDetail();
	      this.props.history.push("/campaigns/create");
	    }
	  }, {
	    key: "nextBeClick",
	    value: function nextBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: "previousBeClick",
	    value: function previousBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: "goToPage",
	    value: function goToPage(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: "pageAbleFunc",
	    value: function pageAbleFunc(val) {
	      var _this3 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageNumber: val,
	          pageSize: 7
	        })
	      }, function () {
	        _this3.props.getTables(_this3.state.requestParams);
	      });
	    }
	  }, {
	    key: "onClickEditCampaign",
	    value: function onClickEditCampaign(e, id) {
	      e.preventDefault();
	      this.props.getCampaignById(id, this.props.client_id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          campaignDataOnLoading = _props2.campaignDataOnLoading,
	          tables = _props2.tables,
	          campaignDataLoadErrorMessage = _props2.campaignDataLoadErrorMessage,
	          roleId = _props2.roleId;
	
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "campaigns subscription-info" },
	          _react2.default.createElement(
	            "div",
	            { className: "campaigns-btn clearfix" },
	            _react2.default.createElement(
	              "div",
	              { className: "wrapper" },
	              _react2.default.createElement(_Button2.default, {
	                title: "Download Report",
	                handleClick: function handleClick(e) {
	                  return _this4.handleBtnClick(e);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "date-picker" },
	            _react2.default.createElement(_Date2.default, {
	              key: "campaign-date-filter",
	              defaultStartDate: this.props.campaignFilterStartDate,
	              defaultEndDate: this.props.campaignFilterEndDate,
	              startDateChange: function startDateChange(date) {
	                return _this4.handleStartDateChange(date);
	              },
	              endDateChange: function endDateChange(date) {
	                return _this4.handleEndDateChange(date);
	              },
	              handleApplyBeClick: function handleApplyBeClick() {
	                return _this4.handleApplyBeClick();
	              },
	              timezone: this.props.clients_tz
	            }),
	            (campaignDataOnLoading === false && ((0, _isEmpty2.default)(tables) || (0, _isEmpty2.default)(tables.data)) || campaignDataLoadErrorMessage) && _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "no-margin no-padding-top pl-10",
	                style: { background: "#FFFFFF" }
	              },
	              _react2.default.createElement(
	                "span",
	                { style: { color: "#FF0000" } },
	                _react2.default.createElement("i", { className: "icon-warning2 pr-10" }),
	                campaignDataLoadErrorMessage ? campaignDataLoadErrorMessage : "No campaigns found within date range selected"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "common-wrapper mt-20" },
	            _react2.default.createElement(
	              "h2",
	              { style: { position: "absolute" } },
	              "Campaigns"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { marginLeft: "150px", height: "24px" } },
	              this.props.campaignDataOnLoading && _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "pull-right tooltip-container" },
	                _react2.default.createElement(
	                  _rcTooltip2.default,
	                  {
	                    placement: "right",
	                    overlayClassName: "campaign-report-legend",
	                    overlayStyle: { width: "345px" },
	                    overlay: _react2.default.createElement(
	                      "div",
	                      { className: "legend-overlay-container" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "border-bottom pb-5 mb-5" },
	                        _react2.default.createElement(
	                          "strong",
	                          null,
	                          "Campaign Group Status Definitions"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Draft - "
	                      ),
	                      "Campaign Group has been created but no",
	                      _react2.default.createElement("br", null),
	                      "channel campaigns have been associated to the group",
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Scheduled - "
	                      ),
	                      " Campaigns are associated to the",
	                      _react2.default.createElement("br", null),
	                      "campaign group with a start date in the future",
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Active - "
	                      ),
	                      " Campaign(s) are in process",
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Completed - "
	                      ),
	                      " Campaign end date(s) have",
	                      " ",
	                      _react2.default.createElement("br", null),
	                      "been reached"
	                    ),
	                    arrowContent: _react2.default.createElement("div", { className: "rc-tooltip-arrow-inner" })
	                  },
	                  _react2.default.createElement(_infoOutline2.default, {
	                    style: {
	                      color: "black",
	                      width: "24px",
	                      height: "24px",
	                      marginTop: "0px",
	                      marginLeft: "0px",
	                      cursor: "pointer"
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "search-wrapper clearfix" },
	              _react2.default.createElement(
	                "span",
	                { className: "search-tit" },
	                "Search"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "search-bar" },
	                _react2.default.createElement("input", {
	                  placeholder: "Search by Campaign Name or ID",
	                  name: "campaign_search",
	                  style: { width: "100%", lineHeight: "25px", border: "none" },
	                  defaultValue: this.props.campaignFilterValue,
	                  onChange: this.onSearchChange.bind(this)
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "icon" },
	                _react2.default.createElement(
	                  "button",
	                  { onClick: this.handleSearch.bind(this) },
	                  _react2.default.createElement(_search2.default, {
	                    style: {
	                      color: "white",
	                      marginLeft: "-4px",
	                      marginTop: "2px"
	                    }
	                  })
	                )
	              ),
	              (roleId === 1 || roleId === 5) && _react2.default.createElement(
	                "div",
	                { className: "campaigns-create" },
	                _react2.default.createElement(_Button2.default, {
	                  title: "Create Campaign Group",
	                  handleClick: function handleClick() {
	                    return _this4.handleCreateCampaign();
	                  }
	                })
	              )
	            ),
	            !campaignDataOnLoading && ((0, _isEmpty2.default)(tables) || (0, _isEmpty2.default)(tables.data)) && !(0, _isEmpty2.default)(this.state.requestParams.keyword) && _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "no-margin no-padding-left no-padding-bottom",
	                style: { background: "#FFFFFF" }
	              },
	              _react2.default.createElement(
	                "span",
	                { style: { color: "#FF0000", marginLeft: "-10px" } },
	                _react2.default.createElement("i", { className: "icon-warning2 pr-10" }),
	                "No search results found",
	                " "
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "campaigns-table" },
	              _react2.default.createElement(_CampaignsTable2.default, {
	                tableHeaderArr: [{ label: "Campaign Group \nName", value: 0 }, { label: "Campaign Group \nID", value: 1 }, { label: "Client Campaign \nID", value: 2 }, { label: "Campaign Group \nStatus", value: 3 }, { label: "Campaign Group \nStart Date", value: 4 }, { label: "Campaign Group \nEnd Date", value: 5 }, { label: "", value: 6 }],
	                bodyDataArr: !(0, _isEmpty2.default)(this.props.csvData) && this.state.onPdfReportDownload ? this.props.csvData.data : this.props.tables ? this.props.tables.data : [],
	                tableHeaderWidthStyle: ["20%", "16%", "15%", "16%", "15%", "15%"],
	                handleClickEditCampaign: this.onClickEditCampaign.bind(this),
	                canEdit: (this.props.roleId === 1 || this.props.roleId === 5) && (0, _isEmpty2.default)(this.props.csvData),
	                handleSearch: this.searchWithSort.bind(this)
	              }),
	              _react2.default.createElement(_Page2.default, {
	                nextBeClick: function nextBeClick(page) {
	                  return _this4.nextBeClick(page);
	                },
	                pageNumber: !(0, _isEmpty2.default)(this.props.csvData) ? this.props.csvData.pageNumber : this.props.tables && this.props.tables.pageNumber,
	                pageCount: !(0, _isEmpty2.default)(this.props.csvData) ? this.props.csvData.pageCount : this.props.tables && this.props.tables.pageCount,
	                pageSize: !(0, _isEmpty2.default)(this.props.csvData) ? this.props.csvData.pageSize : this.props.tables && this.props.tables.pageSize,
	                nextGroupBeClick: function nextGroupBeClick(page) {
	                  return _this4.nextGroupBeClick(page);
	                },
	                previousGroupBeClick: function previousGroupBeClick(page) {
	                  return _this4.previousGroupBeClick(page);
	                },
	                previousBeClick: function previousBeClick(page) {
	                  return _this4.previousBeClick(page);
	                },
	                pageBeClick: function pageBeClick(page) {
	                  return _this4.pageBeClick(page);
	                },
	                total: !(0, _isEmpty2.default)(this.props.csvData) ? this.props.csvData.total : this.props.tables && this.props.tables.total,
	                hasNext: !(0, _isEmpty2.default)(this.props.csvData) ? this.props.csvData.hasNext : this.props.tables && this.props.tables.hasNext,
	                hasPrevious: !(0, _isEmpty2.default)(this.props.csvDta) ? this.props.csvData.hasPrevious : this.props.tables && this.props.tables.hasPrevious,
	                pagePlus: true,
	                selectRows: function selectRows(page, row) {
	                  return _this4.selectRows(page, row);
	                },
	                goToPage: function goToPage(page) {
	                  return _this4.goToPage(page);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Dialog2.default,
	            {
	              open: this.state.onCsvReportDownload,
	              style: { top: "-1.8em" },
	              modal: true,
	              contentStyle: { width: "500px" },
	              overlayStyle: { opacity: 0.9, backgroundColor: "#666666" }
	            },
	            _react2.default.createElement(
	              _Grid.Row,
	              { className: "mt-20" },
	              _react2.default.createElement(
	                _Grid.Col,
	                {
	                  offsetXs: "1",
	                  offsetSm: "1",
	                  offsetMd: "1",
	                  offsetLg: "1",
	                  xs: "7",
	                  sm: "7",
	                  md: "7",
	                  lg: "7",
	                  className: "text-right"
	                },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Downloading, please wait..."
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "1", sm: "1", md: "1", lg: "1" },
	                _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Dialog2.default,
	            {
	              open: this.state.onPdfReportDownload,
	              style: { top: "-1.8em" },
	              modal: true,
	              contentStyle: { width: "500px" },
	              overlayStyle: { opacity: 0.9, backgroundColor: "#666666" }
	            },
	            _react2.default.createElement(
	              _Grid.Row,
	              { className: "mt-20" },
	              _react2.default.createElement(
	                _Grid.Col,
	                {
	                  offsetXs: "1",
	                  offsetSm: "1",
	                  offsetMd: "1",
	                  offsetLg: "1",
	                  xs: "7",
	                  sm: "7",
	                  md: "7",
	                  lg: "7",
	                  className: "text-right"
	                },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Downloading, please wait..."
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "1", sm: "1", md: "1", lg: "1" },
	                _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Dialog2.default,
	            {
	              open: this.state.showDownloadDialog,
	              style: { top: "-1.8em" },
	              modal: true,
	              contentStyle: { width: "440px" }
	            },
	            _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "no-margin-top no-padding text-center",
	                style: { fontSize: "16px", color: "#000" }
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Choose the type of file you would like to download"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "no-padding-top no-padding-right no-padding-bottom no-margin-bottom",
	                style: { paddingLeft: "150px" }
	              },
	              _react2.default.createElement(_Checkbox2.default, {
	                iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	                label: "PDF File",
	                labelStyle: { fontSize: "13px" },
	                defaultChecked: false,
	                ref: "cbPDF",
	                onCheck: function onCheck(e, isInputChecked) {
	                  return _this4.cbPDFChange(e, isInputChecked);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "no-padding-top no-padding-right no-padding-bottom",
	                style: { paddingLeft: "150px" }
	              },
	              _react2.default.createElement(_Checkbox2.default, {
	                iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	                label: "CSV File",
	                labelStyle: { fontSize: "13px" },
	                defaultChecked: true,
	                ref: "cbCSV",
	                onCheck: function onCheck(e, isInputChecked) {
	                  return _this4.cbCSVChange(e, isInputChecked);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding no-margin-bottom mt-20 text-center" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  onClick: function onClick() {
	                    return _this4.setState({ showDownloadDialog: false });
	                  },
	                  className: "btn btn-default btn-aa-info mr-20"
	                },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  onClick: this.handleDownload.bind(this),
	                  disabled: this.state.disabledDlBtn,
	                  className: "btn btn-default btn-aa-default"
	                },
	                "Download File"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Campaigns;
	}(_react.Component);
	
	exports.default = Campaigns;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _utility = __webpack_require__(14);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
		tableHeaderStyle: {
			border: 'none',
			background: '#F5F5F5 '
		},
		tableHeaderColumn: {
			height: '35px',
			color: 'black',
			cursor: 'pointer',
			fontWeight: 'bolder',
			paddingLeft: '10px',
			position: 'relative',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		},
		tableTd: {
			paddingLeft: '10px',
			height: '30px',
			borderBottom: '1px solid black',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}
	};
	
	var AggregatedTable = function (_Component) {
		_inherits(AggregatedTable, _Component);
	
		function AggregatedTable(props) {
			_classCallCheck(this, AggregatedTable);
	
			var _this = _possibleConstructorReturn(this, (AggregatedTable.__proto__ || Object.getPrototypeOf(AggregatedTable)).call(this, props));
	
			_this.state = {
				activeIndex: props.activeIndex,
				arrowActive: 'down',
				data: props.data
			};
			return _this;
		}
	
		_createClass(AggregatedTable, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!(0, _isEqual2.default)(nextProps.data.slice().sort(), this.props.data.slice().sort())) {
					this.setState({
						data: nextProps.data
					});
				}
			}
		}, {
			key: 'showChannel',
			value: function showChannel(channel) {
				var _props$parentCampaign = this.props.parentCampaignDetail,
				    emailDeployments = _props$parentCampaign.emailDeployments,
				    socialDeployments = _props$parentCampaign.socialDeployments,
				    displayDeployments = _props$parentCampaign.displayDeployments;
	
				switch (channel) {
					case "email":
						return emailDeployments && emailDeployments.length > 0;
					case "social":
						return socialDeployments && socialDeployments.length > 0;
					case "display":
						return displayDeployments && displayDeployments.length > 0;
					default:
						return false;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var data = this.props.data;
	
				var emailCount = (0, _find2.default)(data, { channel: "Email" });
				var socialCount = (0, _find2.default)(data, { channel: "Social" });
				var displayCount = (0, _find2.default)(data, { channel: "Display" });
				var totalCount = (0, _find2.default)(data, { channel: "total" });
	
				return _react2.default.createElement(
					'div',
					{ className: 'spread-table pl-20 mt-20' },
					_react2.default.createElement(
						'table',
						{ style: { width: '100%' } },
						_react2.default.createElement(
							'thead',
							{ style: styles.tableHeaderStyle },
							_react2.default.createElement(
								'tr',
								{ style: { height: '42px' } },
								_react2.default.createElement(
									'th',
									{ style: Object.assign({ width: '23%' }, styles.tableHeaderColumn) },
									'Activity'
								),
								_react2.default.createElement(
									'th',
									{ style: Object.assign({ width: '21%' }, styles.tableHeaderColumn) },
									this.showChannel("email") && emailCount && _react2.default.createElement(
										_reactRouterDom.Link,
										{ className: 'agg-title-link', to: '/campaigns/report/' + this.props.campaignId + '/email/aggregated' },
										'Email'
									)
								),
								_react2.default.createElement(
									'th',
									{ style: Object.assign({ width: '21%' }, styles.tableHeaderColumn) },
									this.showChannel("social") && socialCount && _react2.default.createElement(
										_reactRouterDom.Link,
										{ className: 'agg-title-link', to: '/campaigns/report/' + this.props.campaignId + '/social/aggregated' },
										'Social'
									)
								),
								_react2.default.createElement(
									'th',
									{ style: Object.assign({ width: '21%' }, styles.tableHeaderColumn) },
									this.showChannel("display") && displayCount && _react2.default.createElement(
										_reactRouterDom.Link,
										{ className: 'agg-title-link', to: '/campaigns/report/' + this.props.campaignId + '/display/aggregated' },
										'Display'
									)
								),
								_react2.default.createElement(
									'th',
									{ style: Object.assign({ width: '13%', paddingRight: '20px', textAlign: "right" }, styles.tableHeaderColumn) },
									'Total'
								)
							)
						),
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								{ style: { height: '42px' } },
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Messages'
									)
								),
								_react2.default.createElement(
									'td',
									null,
									this.showChannel("email") && emailCount && (0, _utility.splitNumber)(emailCount.messages)()
								),
								_react2.default.createElement(
									'td',
									null,
									this.showChannel("social") && socialCount && (0, _utility.splitNumber)(socialCount.messages)()
								),
								_react2.default.createElement(
									'td',
									null,
									this.showChannel("display") && displayCount && (0, _utility.splitNumber)(displayCount.messages)()
								),
								_react2.default.createElement(
									'td',
									{ style: { textAlign: "right" } },
									totalCount && totalCount.messages && (0, _utility.splitNumber)(totalCount.messages)()
								)
							),
							_react2.default.createElement(
								'tr',
								{ style: { height: "42px" } },
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Engagement'
									)
								),
								_react2.default.createElement(
									'td',
									null,
									this.showChannel("email") && emailCount && (0, _utility.splitNumber)(emailCount.engagement)()
								),
								_react2.default.createElement(
									'td',
									null,
									this.showChannel("social") && socialCount && (0, _utility.splitNumber)(socialCount.engagement)()
								),
								_react2.default.createElement(
									'td',
									null,
									this.showChannel("display") && displayCount && (0, _utility.splitNumber)(displayCount.engagement)()
								),
								_react2.default.createElement(
									'td',
									{ style: { textAlign: "right" } },
									totalCount && totalCount.engagement && (0, _utility.splitNumber)(totalCount.engagement)()
								)
							)
						)
					)
				);
			}
		}]);
	
		return AggregatedTable;
	}(_react.Component);
	
	AggregatedTable.propTypes = {
		data: _react2.default.PropTypes.array.isRequired,
		campaignId: _react2.default.PropTypes.string.isRequired,
		parentCampaignDetail: _react2.default.PropTypes.object.isRequired
	};
	
	AggregatedTable.defaultProps = {
		data: [],
		parentCampaignDetail: {},
		campaignId: 0
	};
	
	exports.default = AggregatedTable;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Title = __webpack_require__(166);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Grid = __webpack_require__(19);
	
	var _LineGraphic = __webpack_require__(256);
	
	var _LineGraphic2 = _interopRequireDefault(_LineGraphic);
	
	var _PieGraphic = __webpack_require__(353);
	
	var _PieGraphic2 = _interopRequireDefault(_PieGraphic);
	
	var _TopLocationSection = __webpack_require__(354);
	
	var _TopLocationSection2 = _interopRequireDefault(_TopLocationSection);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _forEach = __webpack_require__(185);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _utility = __webpack_require__(14);
	
	var _momentTimezone = __webpack_require__(110);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(220);
	
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	var styles = {
	  statsListItem: {
	    width: '50%',
	    padding: '5px 0',
	    borderTop: "solid 1px #000"
	  },
	  tableHeaderStyle: {
	    border: 'none',
	    background: '#F5F5F5',
	    fontSize: '12px',
	    fontWeight: "bold"
	  },
	  tableHeaderColumn: {
	    height: '35px',
	    color: 'black',
	    cursor: 'pointer',
	    fontWeight: 'bolder',
	    paddingLeft: '10px',
	    position: 'relative',
	    whiteSpace: 'nowrap',
	    textOverflow: 'ellipsis'
	  },
	  tableTd: {
	    paddingLeft: '10px',
	    height: '30px',
	    borderBottom: '1px solid black',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  }
	};
	var TOP_LINK_STATS_COUNT = 5;
	
	var DisplayChannelReport = function (_AcquireWebComponent) {
	  _inherits(DisplayChannelReport, _AcquireWebComponent);
	
	  function DisplayChannelReport(props) {
	    _classCallCheck(this, DisplayChannelReport);
	
	    var _this = _possibleConstructorReturn(this, (DisplayChannelReport.__proto__ || Object.getPrototypeOf(DisplayChannelReport)).call(this, props));
	
	    var list = [];
	    var segmentList = [];
	    if (props.campaignDetail) {
	      if (props.campaignDetail.displayDeployments.length > 1) {
	        list.push({ value: "aggregated", label: "Aggregate" });
	      }
	      (0, _map2.default)(props.campaignDetail.displayDeployments, function (campaign) {
	        list.push({ value: campaign.id, label: campaign.name });
	      });
	      if (props.campaignDetail.displayDeployments.length > 0 && props.match.params.channelCampaignId !== "aggregated") {
	        var source = (0, _find2.default)(props.campaignDetail.displayDeployments, function (dep) {
	          return parseInt(dep.id, 10) === parseInt(props.match.params.channelCampaignId);
	        });
	        (0, _map2.default)(source.channelCampaigns, function (channelCampaign) {
	          segmentList.push({ value: channelCampaign.id, label: channelCampaign.name });
	        });
	
	        if (segmentList.length > 1) {
	          segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	        }
	      }
	    }
	    _this.state = {
	      groupCampaignId: props.match.params.id,
	      emailCampaignList: list,
	      emailSegmentList: segmentList,
	      showDownloadDialog: false,
	      onPdfReportDownload: false,
	      onCsvReportDownload: false,
	      disabledBtnDownload: false,
	      sectionWidth: '601px'
	    };
	
	    props.getCampaignById(props.match.params.id);
	    if (props.segmentId) {
	      props.getDisplayChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange, props.segmentId);
	      props.getDisplayChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange, props.segmentId);
	    } else {
	      props.getDisplayChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	      props.getDisplayChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	    }
	
	    if (props.match.params.channelCampaignId !== "aggregated") {
	      if (props.segmentId && props.segmentId !== "aggregated") {
	        _this.props.getCampaignTopLinkStats(props.match.params.id, props.segmentId, props.reportDateRange, TOP_LINK_STATS_COUNT);
	        _this.props.getCampaignTopLocationClickStats(props.match.params.id, props.segmentId, props.reportDateRange, TOP_LINK_STATS_COUNT);
	      }
	    }
	
	    if (props.match.params.channelCampaignId === "aggregated" && list.length === 1) {
	      props.setChannelCampaignId({ value: list[0].value });
	      props.history.push('/campaigns/report/' + props.match.params.id + '/display/' + list[0].value);
	    } else {
	      props.setChannelCampaignId({ value: props.match.params.channelCampaignId });
	    }
	    return _this;
	  }
	
	  _createClass(DisplayChannelReport, [{
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var containerEls = document.getElementsByClassName("campaign-graph-container");
	      if (containerEls.length > 0) {
	        var w = containerEls[0].offsetWidth / 2 - 10;
	        this.setState({
	          sectionWidth: w + 'px'
	        });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions.bind(this));
	    }
	  }, {
	    key: 'handleDownload',
	    value: function handleDownload(e) {
	      e.preventDefault();
	
	      if (this.refs.cbPDF.state.switched) {
	        this.downloadPdfReport();
	      }
	
	      if (this.refs.cbCSV.state.switched) {
	        this.downloadCsvReport();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.campaignDetail) {
	        this.props.getCampaignById(this.props.match.params.id);
	        this.props.getDisplayChannelAggregatedReport(this.props.match.params.id, this.props.match.params.channelCampaignId, this.props.reportDateRange);
	        this.props.getDisplayChannelStatsAggregated(this.props.match.params.id, this.props.match.params.channelCampaignId, this.props.reportDateRange);
	        this.props.setChannelCampaignId({ value: this.props.match.params.channelCampaignId });
	        if (this.props.match.params.channelCampaignId !== "aggregated") {
	          if (this.props.segmentId && this.props.segmentId !== "aggregated") {
	            this.props.getCampaignTopLinkStats(this.props.match.params.id, this.props.segmentId, this.props.reportDateRange, TOP_LINK_STATS_COUNT);
	            this.props.getCampaignTopLocationClickStats(this.props.match.params.id, this.props.segmentId, this.props.reportDateRange, TOP_LINK_STATS_COUNT);
	          }
	        }
	      }
	
	      window.addEventListener("resize", this.updateDimensions.bind(this));
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!(0, _isEqual2.default)(nextProps.campaignDetail, this.props.campaignDetail)) {
	        var list = nextProps.campaignDetail.displayDeployments.length > 1 ? [{ value: "aggregated", label: "Aggregate" }] : [];
	        (0, _map2.default)(nextProps.campaignDetail.displayDeployments, function (campaign) {
	          list.push({ value: campaign.id, label: campaign.name });
	        });
	        this.props.selectClient(nextProps.campaignDetail.clientId);
	        this.setState({
	          emailCampaignList: list
	        });
	        if (this.props.match.params.channelCampaignId !== "aggregatted") {
	          var dep = (0, _find2.default)(nextProps.campaignDetail.displayDeployments, function (deploy) {
	            return parseInt(deploy.id, 10) === parseInt(_this2.props.match.params.channelCampaignId, 10);
	          });
	          if (dep) {
	            var segmentList = [];
	            (0, _map2.default)(dep.channelCampaigns, function (campaign) {
	              segmentList.push({ value: campaign.id, label: campaign.name });
	            });
	            if (segmentList.length > 1) {
	              segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	            }
	            this.setState({ emailSegmentList: segmentList });
	            this.props.setSegmentId({ value: segmentList[0].value });
	          }
	        }
	      }
	      if (nextProps.reportDateRange !== this.props.reportDateRange || nextProps.channelCampaignId !== this.props.channelCampaignId || nextProps.segmentId !== this.props.segmentId) {
	        var channelCampaignId = nextProps.channelCampaignId ? nextProps.channelCampaignId : this.props.match.params.channelCampaignId;
	
	        if (channelCampaignId !== "aggregated") {
	          if (nextProps.campaignDetail) {
	            var _dep = (0, _find2.default)(nextProps.campaignDetail.displayDeployments, function (deploy) {
	              return parseInt(deploy.id, 10) === parseInt(channelCampaignId, 10);
	            });
	            if (_dep) {
	              var _segmentList = [];
	              (0, _map2.default)(_dep.channelCampaigns, function (campaign) {
	                _segmentList.push({ value: campaign.id, label: campaign.name });
	              });
	              if (_segmentList.length > 1) {
	                _segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	              }
	              var sid = nextProps.channelCampaignId !== this.props.channelCampaignId ? _segmentList[0].value : nextProps.segmentId;
	              this.setState({ emailSegmentList: _segmentList });
	              this.props.setSegmentId({ value: sid });
	
	              if (sid !== "aggregated") {
	                this.props.getCampaignTopLinkStats(this.props.match.params.id, sid, nextProps.reportDateRange, TOP_LINK_STATS_COUNT);
	                this.props.getCampaignTopLocationClickStats(this.props.match.params.id, sid, nextProps.reportDateRange, TOP_LINK_STATS_COUNT);
	              }
	
	              this.props.getDisplayChannelStatsAggregated(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange, sid);
	              this.props.getDisplayChannelAggregatedReport(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange, sid);
	            }
	          }
	        } else {
	          this.setState({ emailSegmentList: [] });
	          this.props.getDisplayChannelStatsAggregated(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange);
	          this.props.getDisplayChannelAggregatedReport(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange);
	        }
	      }
	      /*
	      if (nextProps.client_id !== this.props.client_id && (this.props.client_id))  {
	      this.props.history.push("/campaigns");
	      }*/
	    }
	  }, {
	    key: 'dateItem',
	    value: function dateItem() {
	      return [{ value: "life-of-campaign", label: "Life of Campaign" }, { value: "yesterday", label: "Yesterday" }, { value: "today", label: "Today" }, { value: "last-7-days", label: "Last 7 Days" }, { value: "last-30-days", label: "Last 30 Days" }];
	    }
	  }, {
	    key: 'reportDateFilter',
	    value: function reportDateFilter(dayRange) {
	      var result = "";
	      switch (dayRange) {
	        case "yesterday":
	          result = "Yesterday";
	          break;
	        case "today":
	          result = "Today";
	          break;
	        case "last-7-days":
	          result = "Last 7 Days";
	          break;
	        case "last-30-days":
	          result = "Last 30 Days";
	          break;
	        case "life-of-campaign":
	        default:
	          result = "Life of Campaign";
	          break;
	      }
	      return result;
	    }
	  }, {
	    key: 'formatTopLinkRate',
	    value: function formatTopLinkRate(obj) {
	      if (obj && obj.clickrate) {
	        var result = obj.clickrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) + "";
	        return result;
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'topLinkStatsChart',
	    value: function topLinkStatsChart(props) {
	      var topLinkStats = props.topLinkStats;
	
	      var channelCampaignId = props.match.params.channelCampaignId;
	      if (channelCampaignId !== "aggregated" && !(0, _isUndefined2.default)(topLinkStats)) {
	        return _react2.default.createElement(_PieGraphic2.default, { title: "Top Links Clicked", key: 'top-link-stats-section',
	          data: topLinkStats, hideOverflow: true, fieldDisplayFunc: this.formatTopLinkRate,
	          showGraphic: true,
	          footer: _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'section-link', to: '/campaigns/report/' + this.props.match.params.id + '/display/' + this.props.channelCampaignId + '/' + this.props.segmentId + '/top-links-click' },
	            'View More Top Links'
	          )
	        });
	      }
	
	      return "";
	    }
	  }, {
	    key: 'topLocationStats',
	    value: function topLocationStats(props) {
	      var topLocationOpensStats = props.topLocationOpensStats;
	
	      return _react2.default.createElement(_TopLocationSection2.default, { title: "Top Locations by Clicks", key: 'top-locations-by-opens', data: topLocationOpensStats });
	    }
	  }, {
	    key: 'statsList',
	    value: function statsList(props) {
	      if (props.displayAggregatedStats) {
	        var container = _react2.default.createElement(
	          _Grid.FullRow,
	          { style: { fontSize: "16px" }, className: 'light-grey-border no-margin-left no-margin-right no-padding mb-20 pb-20 pr-10 campaign-stats-container' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'pl-10', style: { fontSize: '24px', fontWeight: 'bold' } },
	            'Google Ads Campaign Statistics'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: '25px', right: '12px' }, className: 'tooltip-container' },
	            _react2.default.createElement(
	              _rcTooltip2.default,
	              { placement: 'right',
	                overlayClassName: 'campaign-report-legend',
	                overlayStyle: { width: "265px" },
	                overlay: _react2.default.createElement(
	                  'div',
	                  { className: 'legend-overlay-container' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mb-10', style: { fontSize: '13px' } },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      'Impressions - '
	                    ),
	                    'Each time your ad is shown on a search result page or other site on the Google Network it\'s counted as one impression.'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mb-10', style: { fontSize: '13px' } },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      'Clicks: '
	                    ),
	                    'Every time your ad is clicked on, like on the blue headline of a text ad, Google Ads counts that as a click.'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mb-10', style: { fontSize: '13px' } },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      'Click-Through Rate: '
	                    ),
	                    'The number of clicks that your ad receives divided by the number of times your ad is shown: clicks / impressions = CTR. For example, if you had 5 clicks and 100 impressions, then your CTR would be 5%.'
	                  )
	                ),
	                arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' })
	              },
	              _react2.default.createElement(_infoOutline2.default, {
	                style: { color: 'black', width: '24px', height: '24px', marginTop: '0px', marginLeft: '0px', cursor: 'pointer' }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'spread-table mt-20 ml-10' },
	            _react2.default.createElement(
	              'table',
	              { style: { width: "98%", marginLeft: '10px' } },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    { style: { padding: "10px 0px 10px 20px", width: "45%" } },
	                    'Impressions'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { padding: " 10px 0px", width: "20%" } },
	                    'Clicks'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { padding: " 10px 0px", width: "18%", paddingRight: "20px" } },
	                    'Click Through Rate'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { width: "17%", padding: "10px 0px 10px 20px" } },
	                    '\xA0'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { style: { padding: "10px 0px 10px 20px", width: "45%" } },
	                    (0, _utility.splitNumber)(props.displayAggregatedStats.impressions)()
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { style: { padding: " 10px 0px", width: "20%" } },
	                    (0, _utility.splitNumber)(props.displayAggregatedStats.clicks)()
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { style: { padding: " 10px 0px", width: "18%" } },
	                    props.displayAggregatedStats.clickthroughrate ? props.displayAggregatedStats.clickthroughrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) : "0%"
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { style: { width: "17%", padding: "10px 0px 10px 20px" } },
	                    '\xA0'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-margin-bottom no-padding-bottom definition-container', style: { display: "none" } },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'DEFINITIONS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Impressions - '
	              ),
	              'Each time your ad is shown on a search result page or other site on the Google Network it\'s counted as one impression.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Clicks: '
	              ),
	              'Every time your ad is clicked on, like on the blue headline of a text ad, Google Ads counts that as a click.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Click-Through Rate: '
	              ),
	              'The number of clicks that your ad receives divided by the number of times your ad is shown: clicks / impressions = CTR. For example, if you had 5 clicks and 100 impressions, then your CTR would be 5%.'
	            )
	          )
	        );
	        return container;
	      }
	
	      return "";
	    }
	  }, {
	    key: 'downloadPdfReport',
	    value: function downloadPdfReport() {
	      this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
	      this.handlePdfDownload();
	    }
	  }, {
	    key: 'downloadCsvReport',
	    value: function downloadCsvReport() {
	      this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	      this.handleCsvDownload();
	    }
	  }, {
	    key: '_addPdfHeader',
	    value: function _addPdfHeader(pdf, client_name, bu_name, campaignDetail) {
	      pdf.setFillColor(127, 127, 127);
	      pdf.rect(0, 15, 210, 10, 'F');
	
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(9);
	      pdf.setFontType('bold');
	      pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), 'PNG', 10.5, 3, 60, 0);
	      pdf.text(198, 8, (0, _momentTimezone2.default)().format('MMMM DD, YYYY'), null, null, 'right');
	
	      pdf.setTextColor(255, 255, 255);
	      pdf.setFontType('bold');
	      pdf.text(12, 21, 'Client:');
	      //const lenClientName = getTextSize(client_name.trim(), 'helvetica') 
	      pdf.setFontType('normal');
	      pdf.text(26, 21, client_name ? client_name.trim() : "");
	      //cm to inches
	      var start = 90; //46 + lenClientName.width * 0.3937 + 0.4
	      if (!(0, _isEmpty2.default)(bu_name)) {
	        pdf.setFontType('bold');
	        pdf.text(start, 21, 'Business Unit:');
	        start += 26.5;
	        pdf.setFontType('normal');
	        pdf.text(start, 21, bu_name ? bu_name.trim() : '');
	      }
	      pdf.setFillColor(255);
	      start = 12;
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(10);
	      pdf.text(12, 30, 'Campaigns  >  ' + campaignDetail.name);
	    }
	  }, {
	    key: 'handlePdfDownload',
	    value: function handlePdfDownload() {
	      var _props = this.props,
	          clients = _props.clients,
	          client_info = _props.client_info,
	          channelCampaignId = _props.channelCampaignId,
	          campaignDetail = _props.campaignDetail,
	          segmentId = _props.segmentId;
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	      var deployment = channelCampaignId === "aggregated" ? null : campaignDetail.displayDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var channelCampaignName = channelCampaignId === "aggregated" ? "Aggregated" : deployment.name;
	      var pdfFileName = campaignDetail.name + "_GoogleAds_";
	
	      if (channelCampaignName !== "Aggregated") {
	        if (segmentId === "aggregated") {
	          pdfFileName += "Segment_Aggregagte";
	        } else {
	          var emailCampaignDetail = (0, _find2.default)(deployment.channelCampaigns, function (campaign) {
	            return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
	          });
	          pdfFileName += emailCampaignDetail.name;
	        }
	      } else {
	        pdfFileName += "Deployment_Aggregate";
	      }
	      var pdf = new pdfConverter('p', 'mm', [210, 320]);
	      pdf.setFont("Helvetica");
	      pdf.setFontType("normal");
	      pdf.setFontSize(9);
	      var pageWidth = 186;
	
	      var el_selector_container = document.getElementsByClassName("selector-container")[0];
	      var el_campaign_top_link_container = document.getElementsByClassName("campaign-top-links-container")[0];
	      var el_campaign_top_link_stats_container = document.getElementsByClassName("top-links-stats")[0];
	      var el_campaign_top_location_stats_container = document.getElementsByClassName("top-location-stats")[0];
	
	      var el_campaign_graph = document.getElementsByClassName("campaign-graph-container")[0];
	      var el_campaign_stats = document.getElementsByClassName("campaign-stats-container")[0];
	      var el_email_campaign_detail = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? null : document.getElementsByClassName("email-campaign-detail-container")[0];
	
	      var canvasTopLinkContainer = null;
	      var canvasSelectorContainer = null;
	      var canvasGraph = null;
	      var canvasSummary = null;
	      var canvasEmailCampaignDetail = null;
	      var isCanvasSelectorReady = false;
	      var isCanvasTopLinkReady = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? true : false;
	      var isCanvasGraphReady = false;
	      var isCanvasSummaryReady = false;
	      var isCanvasEmailCampaignReady = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? true : false;
	      var oriWidth = el_campaign_graph.offsetWidth;
	      var oriTopLinkWidth = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? 0 : el_campaign_top_link_container.offsetWidth;
	
	      document.getElementsByClassName("nav-btn-download-report")[0].style.display = "none";
	      document.getElementsByClassName("definition-container")[0].style.display = "block";
	      document.getElementsByClassName("tooltip-container")[0].style.display = "none";
	      if (document.getElementsByClassName("section-link").length > 0) document.getElementsByClassName("section-link")[0].style.display = "none";
	      var tableLinks = document.getElementsByClassName("agg-title-link");
	      var linkColor = null;
	      if (tableLinks.length > 0) {
	        linkColor = tableLinks[0].style.color;
	        (0, _forEach2.default)(tableLinks, function (el) {
	          el.style.color = "#000";
	        });
	      }
	
	      el_selector_container.style.width = "1024px";
	      if (el_campaign_top_link_container) el_campaign_top_link_container.style.width = "1034px";
	      if (el_campaign_top_link_stats_container) el_campaign_top_link_stats_container.style.width = "507px";
	      if (el_campaign_top_location_stats_container) el_campaign_top_location_stats_container.style.width = "507px";
	
	      el_campaign_graph.style.width = "1024px";
	      el_campaign_stats.style.width = "1024px";
	      if (el_email_campaign_detail) {
	        el_email_campaign_detail.style.width = "1024px";
	      }
	
	      setTimeout(function () {
	        html2canvas(el_selector_container, { logging: false }).then(function (canvas) {
	          canvasSelectorContainer = canvas;
	          isCanvasSelectorReady = true;
	          el_selector_container.style.width = oriWidth + 'px';
	        });
	      }, 50);
	      if (channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") {
	        setTimeout(function () {
	          html2canvas(el_campaign_top_link_container, { logging: false }).then(function (canvas) {
	            canvasTopLinkContainer = canvas;
	            isCanvasTopLinkReady = true;
	            el_campaign_top_link_container.style.width = oriTopLinkWidth + 'px';
	            el_campaign_top_link_stats_container.style.width = oriTopLinkWidth / 2 - 10 + 'px';
	            if (el_campaign_top_location_stats_container) el_campaign_top_location_stats_container.style.width = oriTopLinkWidth / 2 - 10 + 'px';
	          });
	        }, 50);
	        setTimeout(function () {
	          html2canvas(el_email_campaign_detail, { logging: false }).then(function (canvas) {
	            canvasEmailCampaignDetail = canvas;
	            isCanvasEmailCampaignReady = true;
	            el_email_campaign_detail.style.width = oriWidth + 'px';
	          });
	        }, 50);
	      }
	
	      setTimeout(function () {
	        html2canvas(el_campaign_graph, { logging: false }).then(function (canvas) {
	          canvasGraph = canvas;
	          isCanvasGraphReady = true;
	          el_campaign_graph.style.width = oriWidth + 'px';
	        });
	      }, 50);
	      setTimeout(function () {
	        html2canvas(el_campaign_stats, { logging: false }).then(function (canvas) {
	          canvasSummary = canvas;
	          isCanvasSummaryReady = true;
	          el_campaign_stats.style.width = oriWidth + 'px';
	        });
	      }, 50);
	
	      var top = 37;
	      var left = 12;
	      var intervalId = setInterval(function () {
	        if (isCanvasTopLinkReady === false || isCanvasSummaryReady === false || isCanvasGraphReady === false || isCanvasEmailCampaignReady === false) {
	          console.log("PDF Generating...");
	        } else {
	          clearInterval(intervalId);
	          setTimeout(function () {
	            this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
	
	            top = 35;
	            pdf.addImage(canvasSelectorContainer.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            top += canvasSelectorContainer.height * pageWidth / canvasSelectorContainer.width + 3;
	            if (channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") {
	              pdf.addImage(canvasEmailCampaignDetail.toDataURL(), "PNG", left, top, pageWidth, 0);
	              top += canvasEmailCampaignDetail.height * pageWidth / canvasEmailCampaignDetail.width + 3;
	            }
	            pdf.addImage(canvasGraph.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            top += canvasGraph.height * pageWidth / canvasGraph.width + 3;
	            pdf.addImage(canvasSummary.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            if (channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") {
	              top += canvasSummary.height * pageWidth / canvasSummary.width + 3;
	              pdf.addImage(canvasTopLinkContainer.toDataURL(), 'PNG', left - 2, top, pageWidth + 2, 0);
	            }
	
	            this._addPdfFooter(pdf, 322);
	            // pdf.setFillColor(35, 47, 58)
	            //      pdf.rect(0, 310, 210, 15, 'F')
	            //      pdf.addImage(pdfReportFooterDataUri(), 'PNG', 15, 312, 18, 0)
	            // pdf.setTextColor(255, 255, 255)
	            // pdf.setFontSize(9)
	            // pdf.setFontType('bold')
	            // pdf.text(65, 315, moment().format('YYYY') + " Claritas, LLC. All rights reserved")
	
	            document.getElementsByClassName("nav-btn-download-report")[0].style.display = "block";
	            document.getElementsByClassName("definition-container")[0].style.display = "none";
	            document.getElementsByClassName("tooltip-container")[0].style.display = "block";
	            if (document.getElementsByClassName("section-link").length > 0) document.getElementsByClassName("section-link")[0].style.display = "block";
	            if (tableLinks.length > 0) {
	              (0, _forEach2.default)(tableLinks, function (el) {
	                el.style.color = linkColor;
	              });
	            }
	            pdfFileName = pdfFileName.replace(new RegExp(' ', 'g'), '_') + "_" + (0, _momentTimezone2.default)().format("YYYYMMDD") + ".pdf";
	            pdf.save(pdfFileName);
	            this.setState({ onPdfReportDownload: false });
	          }.bind(this), 100);
	        }
	      }.bind(this), 50);
	    }
	  }, {
	    key: '_addPdfFooter',
	    value: function _addPdfFooter(pdf, pageHeight) {
	      pdf.setFillColor(127, 127, 127);
	      var top = pageHeight - 12;
	      pdf.rect(0, top, 210, 15, "F");
	      pdf.addImage((0, _utility.pdfReportFooterDataUri)(), "PNG", 15, top + 3, 20, 0);
	      pdf.setTextColor(255, 255, 255);
	      pdf.setFontSize(9);
	      pdf.setFontType("bold");
	      pdf.text(65, top + 6, "Copyright © " + (0, _momentTimezone2.default)().format("YYYY") + " Claritas, LLC. All rights reserved");
	    }
	  }, {
	    key: 'handleCsvDownload',
	    value: function handleCsvDownload() {
	      var _props2 = this.props,
	          clients = _props2.clients,
	          client_info = _props2.client_info,
	          channelCampaignId = _props2.channelCampaignId,
	          campaignDetail = _props2.campaignDetail,
	          reportDateRange = _props2.reportDateRange,
	          displayAggregatedReport = _props2.displayAggregatedReport,
	          displayAggregatedStats = _props2.displayAggregatedStats,
	          segmentId = _props2.segmentId;
	      var impressions = displayAggregatedStats.impressions,
	          clicks = displayAggregatedStats.clicks,
	          clickthroughrate = displayAggregatedStats.clickthroughrate;
	
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	
	      var deployment = channelCampaignId === "aggregated" ? null : campaignDetail.displayDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var channelCampaignName = deployment ? deployment.name : "Aggregated";
	      var csvFileName = campaignDetail.name + "_GoogleAds_";
	      if (channelCampaignName !== "Aggregated") {
	        if (segmentId === "aggregated") {
	          csvFileName += "Segment_Aggregagte";
	        }
	      } else {
	        csvFileName += "Deployment_Aggregate";
	      }
	
	      var title_line = channelCampaignName === "Aggregated" ? 'AudienceAnywhere Aggregate Google Ads Deployment Report  ,,,,,,,,\r\n' : segmentId && segmentId !== "aggregated" ? 'AudienceAnywhere Google Ads Segment Campaign Report  ,,,,,,,,\r\n' : 'AudienceAnywhere Aggregate Google Ads Segment Campaign Report  ,,,,,,,,\r\n';
	
	      var date_line = "Today's Date," + (0, _momentTimezone2.default)().format("MM/DD/YY") + ",,,,,,,\r\n";
	      var client_line = "Client," + client_name + ",,,,,,,\r\n";
	      var business_unit_line = (0, _isEmpty2.default)(bu_name) ? "" : "Business Unit," + bu_name + ",,,,,,,\r\n";
	      var date_filter_line = "Date Filter," + this.reportDateFilter(reportDateRange) + ",,,,,,,\r\n";
	      var split_line = ",,,,,,,,\r\n";
	      var campaign_group_name_line = "Campaign Group Name," + campaignDetail.name + ",,,,,,,\r\n";
	      if (channelCampaignName !== "Aggregated" && segmentId !== "aggregated") {
	        var displayCampaignDetail = (0, _find2.default)(deployment.channelCampaigns, function (campaign) {
	          return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
	        });
	        csvFileName += displayCampaignDetail.name;
	        var email_campaign_name = "Google Ads Segment Name," + displayCampaignDetail.name + ",,,,,,,\r\n";
	        var email_campaign_status = "Status," + displayCampaignDetail.status + ",,,,,,,\r\n";
	        var email_campaign_start_date = "Start Date," + (0, _momentTimezone2.default)(displayCampaignDetail.startDate).format("MM/DD/YYYY") + ",,,,,,,\r\n";
	        var email_campaign_end_date = displayCampaignDetail.endDate ? "End Date," + (0, _momentTimezone2.default)(displayCampaignDetail.endDate).format("MM/DD/YYYY") + ",,,,,,,\r\n" : "End Date,,,,,,,,\r\n";
	        campaign_group_name_line += "Google Ads Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
	        campaign_group_name_line += email_campaign_name;
	        campaign_group_name_line += email_campaign_status;
	        campaign_group_name_line += email_campaign_start_date;
	        campaign_group_name_line += email_campaign_end_date;
	        campaign_group_name_line += ",,,,,,,,\r\n";
	      } else {
	        if (channelCampaignName !== "Aggregated") {
	          campaign_group_name_line += "Google Ads Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
	        }
	      }
	
	      var campaign_grouped_title = "Google Ads Impressions and Clicks,,,,,,,,\r\n,";
	      var campaign_grouped_impressions_row = "Impressions,";
	      var campaign_grouped_click_row = "Clicks,";
	      if (displayAggregatedReport) {
	        displayAggregatedReport.forEach(function (data) {
	          campaign_grouped_title += data.time + ",";
	          campaign_grouped_impressions_row += data.impressions + ",";
	          campaign_grouped_click_row += data.clicks + ",";
	        });
	      }
	      campaign_grouped_title += "\r\n";
	      campaign_grouped_impressions_row += "\r\n";
	      campaign_grouped_click_row += "\r\n";
	      var aggregated_email_campaign_stats_title = channelCampaignName === "Aggregated" ? "Aggregate Google Ads Deployment Statistics,,,,,,,,\r\n" : segmentId && segmentId === "aggregated" ? "Aggregate Google Ads Segment Statistics,,,,,,,,\r\n" : "Google Ads Segment Statistics,,,,,,,,\r\n";
	      var stats_impressions_row = "Impressions, " + impressions + ",,,,,,,\r\n";
	      var stats_clicks_row = "Clicks," + clicks + ",,,,,,,\r\n";
	      var stats_clicks_through_rate_row = clickthroughrate ? "Click Through Rate," + clickthroughrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) + ",,,,,,,\r\n" : "Engagement Rate,,,,,,,,\r\n";
	
	      var definition_title = "Definitions,,,,,,,,\r\n";
	
	      var define_impressions_line = "Impressions: Each time your ad is shown on a search result page or other site on the Google Network it's counted as one impression.         ,,,,,,,,\r\n";
	      var define_clicks_line = '"Clicks : Every time your ad is clicked on, like on the blue headline of a text ad, Google Ads counts that as a click.",,,,,,,,\r\n';
	      var define_post_engagement_line = '"Click-Through Rate: The number of clicks that your ad receives divided by the number of times your ad is shown: clicks / impressions = CTR. For example, if you had 5 clicks and 100 impressions, then your CTR would be 5%.",,,,,,,,\r\n';
	
	      var resultString = title_line + date_line + client_line + business_unit_line + date_filter_line + split_line + campaign_group_name_line + split_line + campaign_grouped_title + campaign_grouped_impressions_row + campaign_grouped_click_row + split_line + aggregated_email_campaign_stats_title + stats_impressions_row + stats_clicks_row + stats_clicks_through_rate_row + split_line + split_line + definition_title + define_impressions_line + define_clicks_line + define_post_engagement_line + split_line;
	
	      if (channelCampaignName !== "Aggregated" && segmentId !== 'aggregated') {
	        resultString += ",,,,,,,,      \r\n";
	        resultString += "Top Links Clicked,,,,,,,,\r\n";
	        resultString += "Link,Pct. Clicked,,,,,,,\r\n";
	        if (this.props.topLinkStats) {
	          (0, _map2.default)(this.props.topLinkStats, function (stat) {
	            resultString += stat.linkurl + "," + stat.clickrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) + ",,,,,,,\r\n";
	          });
	        }
	
	        resultString += ",,,,,,,,      \r\n";
	        resultString += "Top Locations by Clicks,,,,,,,,\r\n";
	        if (this.props.topLocationOpensStats) {
	          (0, _map2.default)(this.props.topLocationOpensStats, function (stat) {
	            resultString += stat.state + "," + stat.clicks + ",,,,,,,\r\n";
	          });
	        }
	      }
	      csvFileName += "_" + (0, _momentTimezone2.default)().format("YYYYMMDD");
	      csvFileName = csvFileName.replace(new RegExp(' ', 'g'), '_');
	      (0, _utility.downLoadCSVFunc)(resultString, csvFileName);
	      setTimeout(function () {
	        this.setState({ onCsvReportDownload: false });
	      }.bind(this), 2000);
	    }
	  }, {
	    key: 'setChannelCampaignId',
	    value: function setChannelCampaignId(data) {
	      this.props.setChannelCampaignId(data);
	      var match = this.props.match;
	
	
	      if (data.value !== "aggregated") {
	        var deployment = (0, _find2.default)(this.props.campaignDetail.displayDeployments, function (deployment) {
	          return deployment.id === data.value;
	        });
	        if (deployment) {
	          var segmentList = [];
	          (0, _map2.default)(deployment.channelCampaigns, function (channelCampaign) {
	            segmentList.push({ value: channelCampaign.id, label: channelCampaign.name });
	          });
	          if (segmentList.length > 1) {
	            segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	          }
	          this.setState({ emailSegmentList: segmentList });
	
	          this.props.getDisplayChannelAggregatedReport(match.params.id, data.value, this.props.reportDateRange, segmentList[0].value);
	          this.props.getDisplayChannelStatsAggregated(match.params.id, data.value, this.props.reportDateRange, segmentList[0].value);
	        }
	      } else {
	        this.props.getDisplayChannelStatsAggregated(match.params.id, data.value, this.props.reportDateRange);
	        this.props.getDisplayChannelAggregatedReport(match.params.id, data.value, this.props.reportDateRange);
	      }
	      this.props.history.push('/campaigns/report/' + match.params.id + '/display/' + data.value);
	    }
	  }, {
	    key: 'setSegmentId',
	    value: function setSegmentId(data) {
	      this.props.setSegmentId(data);
	    }
	  }, {
	    key: 'cbPDFChange',
	    value: function cbPDFChange(e, isInputChecked) {
	      var result = !this.refs.cbCSV.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: 'cbCSVChange',
	    value: function cbCSVChange(e, isInputChecked) {
	      var result = !this.refs.cbPDF.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          match = _props3.match,
	          campaignDetail = _props3.campaignDetail,
	          reportDateRange = _props3.reportDateRange,
	          displayAggregatedReport = _props3.displayAggregatedReport,
	          setReportDateRange = _props3.setReportDateRange,
	          client_info = _props3.client_info,
	          segmentId = _props3.segmentId;
	
	      var showTopLocationOpens = client_info && client_info.clientReportDetailSetting && client_info.clientReportDetailSetting.topLocationChannelReport === true;
	      var channelCampaignId = match.params.channelCampaignId;
	      var lineData = [];
	      if (displayAggregatedReport) {
	        displayAggregatedReport.forEach(function (data) {
	          lineData.push({ time: data.time, impressions: data.impressions, clicks: data.clicks });
	        });
	      }
	      var tableSubTitle = "Date: ";
	      var tableSubTitleText = this.reportDateFilter(reportDateRange);
	      var crumbs = [];
	      var crumbsLink = [];
	      var channelCampaignDetail = channelCampaignId === "aggregated" || !campaignDetail ? null : campaignDetail.displayDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var segment = undefined;
	
	      if (campaignDetail && campaignDetail.displayDeployments) {
	        crumbs.push(campaignDetail.name);
	        crumbsLink.push('/campaigns/report/' + campaignDetail.id);
	        if (channelCampaignId === undefined || channelCampaignId === "aggregated") {
	          crumbs.push("Google Ads Campaign: Aggregate");
	        } else {
	          (0, _map2.default)(campaignDetail.displayDeployments, function (dep) {
	            if (parseInt(dep.id, 10) === parseInt(channelCampaignId, 10)) {
	              if (segmentId) {
	                segment = (0, _find2.default)(dep.channelCampaigns, function (s) {
	                  return parseInt(s.id, 10) === parseInt(segmentId, 10);
	                });
	              }
	              crumbs.push("Google Ads ");
	            }
	          });
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'campaign-report-container', style: { background: "#FFFFFF", fontSize: '16px' } },
	        _react2.default.createElement(_Title2.default, {
	          crumbs: crumbs,
	          crumbsLink: crumbsLink,
	          linkName: 'Campaigns', showDownloadBtn: true,
	          handleDownload: function handleDownload() {
	            _this3.setState({ showDownloadDialog: true });
	          },
	          selected_client: this.props.client_id
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'light-grey-border mt-20 selector-container' },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'pt-10, no-margin-bottom', style: { fontWeight: "bold", fontSize: '24px' } },
	            'Google Ads Selection'
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'no-padding-top no-margin-bottom' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Google Ads Deployment'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(_reactSelect2.default, { className: 'campaign-selector left-10 z-index-199',
	                value: channelCampaignId ? channelCampaignId : (0, _isEmpty2.default)(this.state.emailCampaignList) ? "" : this.state.emailCampaignList.length > 1 ? "aggregated" : this.state.emailCampaignList[0].value,
	                clearable: false,
	                searchable: false,
	                options: this.state.emailCampaignList,
	                placeholder: "Select Campaign",
	                onChange: this.setChannelCampaignId.bind(this)
	              })
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '2', sm: '2', md: '2', lg: '2', className: 'no-padding' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Google Ads Segment'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '4', sm: '4', md: '4', lg: '4' },
	              this.state.emailSegmentList.length > 0 && _react2.default.createElement(_reactSelect2.default, { className: 'campaign-selector left-10 z-index-199',
	                value: segmentId ? segmentId : this.state.emailSegmentList.length > 0 ? this.state.emailSegmentList[0].value : 0,
	                clearable: false,
	                searchable: false,
	                options: this.state.emailSegmentList,
	                placeholder: "Select Segment",
	                onChange: this.setSegmentId.bind(this)
	              })
	            )
	          ),
	          _react2.default.createElement('hr', { style: { margin: "-10px 20px 20px" } }),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'no-padding-top no-margin-bottom' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Date'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(_reactSelect2.default, { className: 'report-date-selector left-10 z-index-198',
	                value: reportDateRange,
	                clearable: false,
	                searchable: false,
	                options: this.dateItem(),
	                placeholder: "Select Day",
	                onChange: setReportDateRange.bind(this)
	              })
	            )
	          )
	        ),
	        channelCampaignDetail && segmentId !== "aggregated" && _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'light-grey-border mt-20 no-margin-left no-margin-right no-padding mb-20 pr-10 email-campaign-detail-container' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'pl-10 mt-10', style: { fontSize: '24px', fontWeight: 'bold' } },
	            'Google Ads Segment Details'
	          ),
	          _react2.default.createElement(
	            'table',
	            { style: { width: "98%", marginLeft: '10px' } },
	            _react2.default.createElement(
	              'thead',
	              { style: styles.tableHeaderStyle },
	              _react2.default.createElement(
	                'tr',
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '45%', paddingLeft: "20px" } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment Name'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '20%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment Status'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '18%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment Start Date'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '17%', paddingRight: "20px", textAlign: 'right' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment End Date'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '45%', paddingLeft: "20px", paddingRight: "50px", wordBreak: "break-word" } },
	                  segment ? segment.name : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '20%' } },
	                  segment ? segment.status : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '18%' } },
	                  segment ? (0, _momentTimezone2.default)(segment.startDate).format("MM/DD/YY") : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '17%', paddingRight: "20px", textAlign: 'right' } },
	                  segment && segment.endDate ? (0, _momentTimezone2.default)(segment.endDate).format("MM/DD/YY") : ""
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'light-grey-border no-margin-left no-margin-right no-padding mt-20 mb-20 pb-20 pr-20 pl-10 campaign-graph-container' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'pl-10', style: { fontSize: '24px', fontWeight: 'bold' } },
	            'Google Ads - Impressions and Clicks'
	          ),
	          _react2.default.createElement(_LineGraphic2.default, { animation: false, key: 'line-section', dataNames: ["Impressions", "Clicks"],
	            dataKeys: ['impressions', 'clicks'], title: '', data: lineData, subTitle: tableSubTitle, subTitleText: tableSubTitleText })
	        ),
	        this.statsList(this.props),
	        channelCampaignId !== "aggregated" && segmentId !== "aggregated" && _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'no-margin-right no-padding campaign-top-links-container' },
	          !(0, _isUndefined2.default)(this.props.topLinkStats) && _react2.default.createElement(
	            _Grid.Col,
	            { xs: '6', sm: '6', md: '6', lg: '', className: 'light-grey-border p-20 no-margin-left top-links-stats', style: { width: this.state.sectionWidth } },
	            this.topLinkStatsChart(this.props)
	          ),
	          showTopLocationOpens && _react2.default.createElement(
	            _Grid.Col,
	            { xs: '6', sm: '6', md: '6', lg: '6', className: 'light-grey-border p-20 top-location-stats', style: { float: "right", width: this.state.sectionWidth } },
	            this.topLocationStats(this.props)
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { open: this.state.onCsvReportDownload, style: { top: '-1.8em' }, modal: true, contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: '#666666' } },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'mt-20' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { offsetXs: '1', offsetSm: '1', offsetMd: '1', offsetLg: '1', xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
	              _react2.default.createElement(
	                'div',
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '1', sm: '1', md: '1', lg: '1' },
	              _react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { open: this.state.onPdfReportDownload, style: { top: '-1.8em' }, modal: true, contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: '#666666' } },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'mt-20' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { offsetXs: '1', offsetSm: '1', offsetMd: '1', offsetLg: '1', xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
	              _react2.default.createElement(
	                'div',
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '1', sm: '1', md: '1', lg: '1' },
	              _react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { open: this.state.showDownloadDialog, style: { top: '-1.8em' }, modal: true,
	            contentStyle: { width: "440px" } },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-margin-top no-padding', style: { fontSize: '16px', color: "#000" } },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Choose the type of file you would like to download'
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-padding-top no-padding-right no-padding-bottom no-margin-bottom',
	              style: { paddingLeft: "150px" } },
	            _react2.default.createElement(_Checkbox2.default, { iconStyle: { fill: "#47A1AB", marginRight: '10px' }, label: "PDF File", labelStyle: { fontSize: '13px' },
	              defaultChecked: false, ref: 'cbPDF', onCheck: function onCheck(e, isInputChecked) {
	                return _this3.cbPDFChange(e, isInputChecked);
	              } })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-padding-top no-padding-right no-padding-bottom', style: { paddingLeft: "150px" } },
	            _react2.default.createElement(_Checkbox2.default, { iconStyle: { fill: "#47A1AB", marginRight: '10px' }, label: "CSV File", labelStyle: { fontSize: '13px' },
	              defaultChecked: true, ref: 'cbCSV', onCheck: function onCheck(e, isInputChecked) {
	                return _this3.cbCSVChange(e, isInputChecked);
	              } })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-padding no-margin-bottom mt-20 text-center' },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onClick: function onClick() {
	                  return _this3.setState({ showDownloadDialog: false });
	                },
	                className: 'btn btn-default btn-aa-info mr-20' },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onClick: this.handleDownload.bind(this), disabled: this.state.disabledBtnDownload,
	                className: 'btn btn-default btn-aa-default' },
	              'Download File'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DisplayChannelReport;
	}(_MaterialUI2.default);
	
	exports.default = DisplayChannelReport;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Title = __webpack_require__(166);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Grid = __webpack_require__(19);
	
	var _LineGraphic = __webpack_require__(256);
	
	var _LineGraphic2 = _interopRequireDefault(_LineGraphic);
	
	var _PieGraphic = __webpack_require__(353);
	
	var _PieGraphic2 = _interopRequireDefault(_PieGraphic);
	
	var _TopLocationSection = __webpack_require__(354);
	
	var _TopLocationSection2 = _interopRequireDefault(_TopLocationSection);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _forEach = __webpack_require__(185);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _utility = __webpack_require__(14);
	
	var _momentTimezone = __webpack_require__(110);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(220);
	
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	var styles = {
	  statsListItem: {
	    width: '50%',
	    padding: '5px 0',
	    borderTop: "solid 1px #000"
	  },
	  tableHeaderStyle: {
	    border: 'none',
	    background: '#F5F5F5',
	    fontSize: '16px',
	    fontWeight: "bold"
	  },
	  tableHeaderColumn: {
	    height: '35px',
	    color: 'black',
	    cursor: 'pointer',
	    fontWeight: 'bolder',
	    paddingLeft: '10px',
	    position: 'relative',
	    whiteSpace: 'nowrap',
	    textOverflow: 'ellipsis'
	  },
	  tableTd: {
	    paddingLeft: '10px',
	    height: '30px',
	    borderBottom: '1px solid black',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  }
	};
	var TOP_LINK_STATS_COUNT = 5;
	
	var EmailChannelReport = function (_AcquireWebComponent) {
	  _inherits(EmailChannelReport, _AcquireWebComponent);
	
	  function EmailChannelReport(props) {
	    _classCallCheck(this, EmailChannelReport);
	
	    var _this = _possibleConstructorReturn(this, (EmailChannelReport.__proto__ || Object.getPrototypeOf(EmailChannelReport)).call(this, props));
	
	    var list = [];
	    var segmentList = [];
	    if (props.campaignDetail) {
	      if (props.campaignDetail.emailDeployments.length > 1) {
	        list.push({ value: "aggregated", label: "Aggregate" });
	      }
	      (0, _map2.default)(props.campaignDetail.emailDeployments, function (campaign) {
	        list.push({ value: campaign.id, label: campaign.name });
	      });
	      if (props.campaignDetail.emailDeployments.length > 0 && props.match.params.channelCampaignId !== "aggregated") {
	        var source = (0, _find2.default)(props.campaignDetail.emailDeployments, function (dep) {
	          return parseInt(dep.id, 10) === parseInt(props.match.params.channelCampaignId);
	        });
	        (0, _map2.default)(source.channelCampaigns, function (channelCampaign) {
	          segmentList.push({ value: channelCampaign.id, label: channelCampaign.name });
	        });
	
	        if (segmentList.length > 1) {
	          segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	        }
	      }
	    }
	
	    props.getCampaignById(props.match.params.id);
	    if (props.segmentId) {
	      if (props.match.params.channelCampaignId === "aggregated") {
	        var _source = (0, _find2.default)(props.campaignDetail.emailDeployments, function (dep) {
	          return (0, _find2.default)(dep.channelCampaigns, function (campaign) {
	            return parseInt(campaign.id, 10) === parseInt(props.segmentId, 10);
	          });
	        });
	        if (_source && _source.channelCampaigns.length > 0) {
	          (0, _map2.default)(_source.channelCampaigns, function (channelCampaign) {
	            segmentList.push({ value: channelCampaign.id, label: channelCampaign.name });
	          });
	
	          if (segmentList.length > 1) {
	            segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	          }
	          props.getEmailChannelAggregatedReport(props.match.params.id, _source.id, props.reportDateRange, props.segmentId);
	          props.getEmailChannelStatsAggregated(props.match.params.id, _source.id, props.reportDateRange, props.segmentId);
	        } else {
	          props.getEmailChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	          props.getEmailChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	        }
	      } else {
	        props.getEmailChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange, props.segmentId);
	        props.getEmailChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange, props.segmentId);
	      }
	    } else {
	      props.getEmailChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	      props.getEmailChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	    }
	
	    _this.state = {
	      groupCampaignId: props.match.params.id,
	      emailCampaignList: list,
	      emailSegmentList: segmentList,
	      showDownloadDialog: false,
	      onPdfReportDownload: false,
	      onCsvReportDownload: false,
	      disabledBtnDownload: false,
	      sectionWidth: '601px'
	    };
	
	    if (props.match.params.channelCampaignId !== "aggregated") {
	      if (props.segmentId && props.segmentId !== "aggregated") {
	        _this.props.getCampaignTopLinkStats(props.match.params.id, props.segmentId, props.reportDateRange, TOP_LINK_STATS_COUNT);
	        _this.props.getCampaignTopLocationClickStats(props.match.params.id, props.segmentId, props.reportDateRange, TOP_LINK_STATS_COUNT);
	      }
	    }
	
	    if (props.match.params.channelCampaignId === "aggregated" && list.length === 1) {
	      props.setChannelCampaignId({ value: list[0].value });
	      props.history.push('/campaigns/report/' + props.match.params.id + '/email/' + list[0].value);
	    } else {
	      if (props.match.params.channelCampaignId !== "aggregated") props.setChannelCampaignId({ value: props.match.params.channelCampaignId });
	    }
	    return _this;
	  }
	
	  _createClass(EmailChannelReport, [{
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var containerEls = document.getElementsByClassName("campaign-graph-container");
	      if (containerEls.length > 0) {
	        var w = containerEls[0].offsetWidth / 2 - 10;
	        this.setState({
	          sectionWidth: w + 'px'
	        });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions.bind(this));
	      this.setSegmentId({ value: undefined });
	    }
	  }, {
	    key: 'handleDownload',
	    value: function handleDownload(e) {
	      e.preventDefault();
	
	      if (this.refs.cbPDF.state.switched) {
	        this.downloadPdfReport();
	      }
	
	      if (this.refs.cbCSV.state.switched) {
	        this.downloadCsvReport();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.campaignDetail) {
	        this.props.getCampaignById(this.props.match.params.id);
	
	        this.props.getEmailChannelAggregatedReport(this.props.match.params.id, this.props.match.params.channelCampaignId, this.props.reportDateRange);
	        this.props.getEmailChannelStatsAggregated(this.props.match.params.id, this.props.match.params.channelCampaignId, this.props.reportDateRange);
	        this.props.setChannelCampaignId({ value: this.props.match.params.channelCampaignId });
	        if (this.props.match.params.channelCampaignId !== "aggregated") {
	          if (this.props.segmentId && this.props.segmentId !== "aggregated") {
	            this.props.getCampaignTopLinkStats(this.props.match.params.id, this.props.segmentId, this.props.reportDateRange, TOP_LINK_STATS_COUNT);
	            this.props.getCampaignTopLocationClickStats(this.props.match.params.id, this.props.segmentId, this.props.reportDateRange, TOP_LINK_STATS_COUNT);
	          }
	        }
	      }
	
	      window.addEventListener("resize", this.updateDimensions.bind(this));
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!(0, _isEqual2.default)(nextProps.campaignDetail, this.props.campaignDetail)) {
	        var list = nextProps.campaignDetail.emailDeployments.length > 1 ? [{ value: "aggregated", label: "Aggregate" }] : [];
	        (0, _map2.default)(nextProps.campaignDetail.emailDeployments, function (campaign) {
	          list.push({ value: campaign.id, label: campaign.name });
	        });
	        this.props.selectClient(nextProps.campaignDetail.clientId);
	        this.setState({
	          emailCampaignList: list
	        });
	        if (this.props.match.params.channelCampaignId !== "aggregatted") {
	          var dep = (0, _find2.default)(nextProps.campaignDetail.emailDeployments, function (deploy) {
	            return parseInt(deploy.id, 10) === parseInt(_this2.props.match.params.channelCampaignId, 10);
	          });
	          if (dep) {
	            var segmentList = [];
	            (0, _map2.default)(dep.channelCampaigns, function (campaign) {
	              segmentList.push({ value: campaign.id, label: campaign.name });
	            });
	            if (segmentList.length > 1) {
	              segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	            }
	            this.setState({ emailSegmentList: segmentList });
	            this.props.setSegmentId({ value: segmentList[0].value });
	          }
	        }
	      }
	      if (nextProps.reportDateRange !== this.props.reportDateRange || nextProps.channelCampaignId !== this.props.channelCampaignId || nextProps.match.params.channelCampaignId !== this.props.match.params.channelCampaignId || nextProps.segmentId !== this.props.segmentId) {
	        var channelCampaignId = nextProps.match.params.channelCampaignId ? nextProps.match.params.channelCampaignId : this.props.match.params.channelCampaignId;
	
	        if (channelCampaignId !== "aggregated") {
	          if (nextProps.campaignDetail) {
	            var _dep = (0, _find2.default)(nextProps.campaignDetail.emailDeployments, function (deploy) {
	              return parseInt(deploy.id, 10) === parseInt(channelCampaignId, 10);
	            });
	            if (_dep) {
	              var _segmentList = [];
	              (0, _map2.default)(_dep.channelCampaigns, function (campaign) {
	                _segmentList.push({ value: campaign.id, label: campaign.name });
	              });
	              if (_segmentList.length > 1) {
	                _segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	              }
	              var sid = channelCampaignId !== this.props.channelCampaignId || !nextProps.segmentId ? _segmentList[0].value : nextProps.segmentId;
	
	              this.setState({ emailSegmentList: _segmentList });
	              this.props.setSegmentId({ value: nextProps.segmentId ? nextProps.segmentId : sid });
	
	              if (sid !== "aggregated") {
	                this.props.getCampaignTopLinkStats(this.props.match.params.id, sid, nextProps.reportDateRange, TOP_LINK_STATS_COUNT);
	                this.props.getCampaignTopLocationClickStats(this.props.match.params.id, sid, nextProps.reportDateRange, TOP_LINK_STATS_COUNT);
	              }
	              this.props.getEmailChannelStatsAggregated(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange, sid);
	              this.props.getEmailChannelAggregatedReport(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange, sid);
	            }
	          }
	        } else {
	          this.setState({ emailSegmentList: [] });
	          this.props.getEmailChannelStatsAggregated(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange);
	          this.props.getEmailChannelAggregatedReport(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange);
	        }
	      }
	      /*
	      if (nextProps.client_id !== this.props.client_id && (this.props.client_id))  {
	      this.props.history.push("/campaigns");
	      }*/
	    }
	  }, {
	    key: 'dateItem',
	    value: function dateItem() {
	      return [{ value: "life-of-campaign", label: "Life of Campaign" }, { value: "yesterday", label: "Yesterday" }, { value: "today", label: "Today" }, { value: "last-7-days", label: "Last 7 Days" }, { value: "last-30-days", label: "Last 30 Days" }];
	    }
	  }, {
	    key: 'reportDateFilter',
	    value: function reportDateFilter(dayRange) {
	      var result = "";
	      switch (dayRange) {
	        case "yesterday":
	          result = "Yesterday";
	          break;
	        case "today":
	          result = "Today";
	          break;
	        case "last-7-days":
	          result = "Last 7 Days";
	          break;
	        case "last-30-days":
	          result = "Last 30 Days";
	          break;
	        case "life-of-campaign":
	        default:
	          result = "Life of Campaign";
	          break;
	      }
	      return result;
	    }
	  }, {
	    key: 'formatTopLinkRate',
	    value: function formatTopLinkRate(obj) {
	      if (obj && obj.clickrate) {
	        var result = obj.clickrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) + "";
	        return result;
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'topLinkStatsChart',
	    value: function topLinkStatsChart(props) {
	      var topLinkStats = props.topLinkStats;
	
	      var channelCampaignId = props.match.params.channelCampaignId;
	      if (channelCampaignId !== "aggregated" && !(0, _isUndefined2.default)(topLinkStats)) {
	        return _react2.default.createElement(_PieGraphic2.default, { title: "Top Links Clicked", key: 'top-link-stats-section',
	          data: topLinkStats, hideOverflow: true, fieldDisplayFunc: this.formatTopLinkRate,
	          showGraphic: true,
	          footer: _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'section-link', to: '/campaigns/report/' + this.props.match.params.id + '/email/' + this.props.channelCampaignId + '/' + this.props.segmentId + '/top-links-click' },
	            'View More Top Links'
	          )
	        });
	      }
	
	      return "";
	    }
	  }, {
	    key: 'topLocationStats',
	    value: function topLocationStats(props) {
	      var topLocationOpensStats = props.topLocationOpensStats;
	
	      return _react2.default.createElement(_TopLocationSection2.default, { title: "Top Locations by Opens", key: 'top-locations-by-opens', data: topLocationOpensStats });
	    }
	  }, {
	    key: 'statsList',
	    value: function statsList(props) {
	      if (props.emailAggregatedStats) {
	        var _props$emailAggregate = props.emailAggregatedStats,
	            delivered = _props$emailAggregate.delivered,
	            distinctindividuals = _props$emailAggregate.distinctindividuals,
	            opens = _props$emailAggregate.opens,
	            clicks = _props$emailAggregate.clicks,
	            unsubs = _props$emailAggregate.unsubs,
	            uniqueclicks = _props$emailAggregate.uniqueclicks,
	            clickrate = _props$emailAggregate.clickrate,
	            uniqueopens = _props$emailAggregate.uniqueopens,
	            openrate = _props$emailAggregate.openrate;
	
	
	        var container = _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'light-grey-border no-margin-left no-margin-right no-padding mb-20 pb-20 pr-10 campaign-stats-container' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'pl-10', style: { fontSize: '24px', fontWeight: 'bold' } },
	            'Email Statistics'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: '25px', right: '12px' }, className: 'tooltip-container' },
	            _react2.default.createElement(
	              _rcTooltip2.default,
	              { placement: 'right',
	                overlayClassName: 'campaign-report-legend',
	                overlayStyle: { width: "589px" },
	                overlay: _react2.default.createElement(
	                  'div',
	                  { className: 'legend-overlay-container' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Email Campaign Statistics Definitions'
	                  ),
	                  _react2.default.createElement('hr', { className: 'black-hr' }),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Delivered - '
	                  ),
	                  'The number of messages accepted by the receiving server',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Opens - '
	                  ),
	                  'The total number of times a recipient opened the email where a message is opened and images are enabled, the image calls the server allowing the message to be counted as an open',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Unique Opens - '
	                  ),
	                  'The number of distinct recipients that opened the email',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Open Rate - '
	                  ),
	                  'The percentage of unique recipients who opened the email compared to how many were delivered',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Clicks - '
	                  ),
	                  'The total number of times a recipient clicks on a link within the email. If the same subscriber clicks multiple times, each occurrence gets counted',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Unique Clicks - '
	                  ),
	                  'The total number of distinct recipients who clicked on links. Each recipient is only counted once in this figure, regardless of how many links they click',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Click to Open Rate - '
	                  ),
	                  'The percentage of unique recipients who clicked compared to the unique recipients who opened',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Unsubscribed - '
	                  ),
	                  'The number of recipients that clicked on the advertiser opt-out link'
	                ),
	                arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' })
	              },
	              _react2.default.createElement(_infoOutline2.default, {
	                style: { color: 'black', width: '24px', height: '24px', marginTop: '0px', marginLeft: '0px', cursor: 'pointer' }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'text-center mb-20' },
	            this.props.campaignDetail && this.props.campaignDetail.emailReportDelivered && _react2.default.createElement(
	              'span',
	              { className: 'light-grey-border', style: { fontWeight: "bold", fontSize: "16px", padding: '15px' } },
	              'Delivered - ',
	              delivered ? (0, _utility.splitNumber)(delivered + "")() : "N/A"
	            ),
	            this.props.campaignDetail && this.props.campaignDetail.emailReportDistinctIndividuals && _react2.default.createElement(
	              'span',
	              { className: 'light-grey-border ml-20', style: { fontWeight: "bold", fontSize: "16px", padding: '15px' } },
	              'Distinct Individuals - ',
	              distinctindividuals ? (0, _utility.splitNumber)(distinctindividuals + "")() : "N/A"
	            )
	          ),
	          _react2.default.createElement(
	            'table',
	            { style: { width: "98%", marginLeft: '10px' } },
	            _react2.default.createElement(
	              'thead',
	              { style: styles.tableHeaderStyle },
	              _react2.default.createElement(
	                'tr',
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '16%', paddingLeft: "20px" } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Opens'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '14%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Unique Opens'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '14%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Open Rate'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '14%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Clicks'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '14%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Unique Clicks'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '14%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Click Rate'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { paddingRight: "20px", textAlign: 'right' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Unsubscribed'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '16%', paddingLeft: "20px" } },
	                  opens ? (0, _utility.splitNumber)(opens)() : "N/A"
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '16%' } },
	                  uniqueopens ? (0, _utility.splitNumber)(uniqueopens)() : "N/A"
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '14%' } },
	                  openrate ? openrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) : "N/A"
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '12%' } },
	                  clicks ? (0, _utility.splitNumber)(clicks)() : "N/A"
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '14%' } },
	                  uniqueclicks ? (0, _utility.splitNumber)(uniqueclicks)() : "N/A"
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '14%' } },
	                  clickrate ? clickrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) : "N/A"
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { paddingRight: "20px", textAlign: 'right' } },
	                  unsubs ? (0, _utility.splitNumber)(unsubs)() : "N/A"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-margin-bottom no-padding-bottom definition-container', style: { display: "none" } },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'DEFINITIONS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Delivered - '
	              ),
	              'The number of messages accepted by the receiving server .'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Opens - '
	              ),
	              'The total number of times a recipient opened the email where a message is opened and images are enabled, the image calls the server allowing the message to be counted as an open'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Unique Opens - '
	              ),
	              'The number of distinct recipients that opened the email'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Open Rate - '
	              ),
	              'The percentage of unique recipients who opened the email compared to how many were delivered'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Clicks - '
	              ),
	              'The total number of times a recipient clicks on a link within the email. If the same subscriber clicks multiple times, each occurrence gets counted'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Unique Clicks - '
	              ),
	              'The total number of distinct recipients who clicked on links. Each recipient is only counted once in this figure, regardless of how many links they click'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Click to Open Rate - '
	              ),
	              'The percentage of unique recipients who clicked compared to the unique recipients who opened'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Unsubscribed - '
	              ),
	              'The number of recipients that clicked on the advertiser opt-out link'
	            )
	          )
	        );
	        return container;
	      }
	
	      return "";
	    }
	  }, {
	    key: 'downloadPdfReport',
	    value: function downloadPdfReport() {
	      this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
	      this.handlePdfDownload();
	    }
	  }, {
	    key: 'downloadCsvReport',
	    value: function downloadCsvReport() {
	      this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	      this.handleCsvDownload();
	    }
	  }, {
	    key: '_addPdfHeader',
	    value: function _addPdfHeader(pdf, client_name, bu_name, campaignDetail) {
	      pdf.setFillColor(127, 127, 127);
	      pdf.rect(0, 15, 210, 10, 'F');
	
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(9);
	      pdf.setFontType('bold');
	      pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), 'PNG', 10.5, 3, 60, 0);
	      pdf.text(198, 8, (0, _momentTimezone2.default)().format('MMMM DD, YYYY'), null, null, 'right');
	
	      pdf.setTextColor(255, 255, 255);
	      pdf.setFontType('bold');
	      pdf.text(12, 21, 'Client:');
	      //const lenClientName = getTextSize(client_name.trim(), 'helvetica') 
	      pdf.setFontType('normal');
	      pdf.text(26, 21, client_name ? client_name.trim() : "");
	      //cm to inches
	      var start = 90; //46 + lenClientName.width * 0.3937 + 0.4
	      if (!(0, _isEmpty2.default)(bu_name)) {
	        pdf.setFontType('bold');
	        pdf.text(start, 21, 'Business Unit:');
	        start += 26.5;
	        pdf.setFontType('normal');
	        pdf.text(start, 21, bu_name ? bu_name.trim() : '');
	      }
	      pdf.setFillColor(255);
	      start = 12;
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(10);
	      pdf.text(12, 30, 'Campaigns  >  ' + campaignDetail.name);
	    }
	  }, {
	    key: 'handlePdfDownload',
	    value: function handlePdfDownload() {
	      var _props = this.props,
	          clients = _props.clients,
	          client_info = _props.client_info,
	          channelCampaignId = _props.channelCampaignId,
	          campaignDetail = _props.campaignDetail,
	          segmentId = _props.segmentId;
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	      //const dateRangeStr = this.dateItem().filter((data)=>{return data.value === reportDateRange})[0].label;
	      var deployment = channelCampaignId === "aggregated" ? null : campaignDetail.emailDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var channelCampaignName = channelCampaignId === "aggregated" ? "Aggregated" : deployment.name;
	      var pdfFileName = campaignDetail.name + "_Email_";
	
	      if (channelCampaignName !== "Aggregated") {
	        if (segmentId === "aggregated") {
	          pdfFileName += "Segment_Aggregagte";
	        } else {
	          var emailCampaignDetail = (0, _find2.default)(deployment.channelCampaigns, function (campaign) {
	            return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
	          });
	          pdfFileName += emailCampaignDetail.name;
	        }
	      } else {
	        pdfFileName += "Deployment_Aggregate";
	      }
	
	      var pdf = new pdfConverter('p', 'mm', 'a4');
	      pdf.setFont("Helvetica");
	      pdf.setFontType("normal");
	      pdf.setFontSize(9);
	      var pageWidth = 186;
	
	      var el_selector_container = document.getElementsByClassName("selector-container")[0];
	      var el_campaign_top_link_container = document.getElementsByClassName("campaign-top-links-container")[0];
	      var el_campaign_top_link_stats_container = document.getElementsByClassName("top-links-stats")[0];
	      var el_campaign_top_location_stats_container = document.getElementsByClassName("top-location-stats")[0];
	
	      var el_campaign_graph = document.getElementsByClassName("campaign-graph-container")[0];
	      var el_campaign_stats = document.getElementsByClassName("campaign-stats-container")[0];
	      var el_email_campaign_detail = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? null : document.getElementsByClassName("email-campaign-detail-container")[0];
	
	      var canvasSelectorContainer = null;
	      var canvasTopLinkContainer = null;
	      var canvasGraph = null;
	      var canvasSummary = null;
	      var canvasEmailCampaignDetail = null;
	      var isCanvasSelectorReady = false;
	      var isCanvasTopLinkReady = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? true : false;
	      var isCanvasGraphReady = false;
	      var isCanvasSummaryReady = false;
	      var isCanvasEmailCampaignReady = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? true : false;
	      var oriWidth = el_campaign_graph.offsetWidth;
	      var oriTopLinkWidth = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? 0 : el_campaign_top_link_container.offsetWidth;
	
	      document.getElementsByClassName("nav-btn-download-report")[0].style.display = "none";
	      document.getElementsByClassName("definition-container")[0].style.display = "block";
	      document.getElementsByClassName("tooltip-container")[0].style.display = "none";
	      if (document.getElementsByClassName("section-link").length > 0) document.getElementsByClassName("section-link")[0].style.display = "none";
	      var tableLinks = document.getElementsByClassName("agg-title-link");
	      var linkColor = null;
	      if (tableLinks.length > 0) {
	        linkColor = tableLinks[0].style.color;
	        (0, _forEach2.default)(tableLinks, function (el) {
	          el.style.color = "#000";
	        });
	      }
	
	      if (el_campaign_top_link_container) el_campaign_top_link_container.style.width = "1034px";
	      if (el_campaign_top_link_stats_container) el_campaign_top_link_stats_container.style.width = "507px";
	      if (el_campaign_top_location_stats_container) el_campaign_top_location_stats_container.style.width = "507px";
	
	      el_selector_container.style.width = "1024px";
	      el_campaign_graph.style.width = "1024px";
	      el_campaign_stats.style.width = "1024px";
	      if (el_email_campaign_detail) {
	        el_email_campaign_detail.style.width = "1024px";
	      }
	
	      setTimeout(function () {
	        html2canvas(el_selector_container, { logging: false }).then(function (canvas) {
	          canvasSelectorContainer = canvas;
	          isCanvasSelectorReady = true;
	          el_selector_container.style.width = oriWidth + 'px';
	        });
	      }, 50);
	      if (channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") {
	        setTimeout(function () {
	          html2canvas(el_campaign_top_link_container, { logging: false }).then(function (canvas) {
	            canvasTopLinkContainer = canvas;
	            isCanvasTopLinkReady = true;
	            el_campaign_top_link_container.style.width = oriTopLinkWidth + 'px';
	            el_campaign_top_link_stats_container.style.width = oriTopLinkWidth / 2 - 10 + 'px';
	            if (el_campaign_top_location_stats_container) el_campaign_top_location_stats_container.style.width = oriTopLinkWidth / 2 - 10 + 'px';
	          });
	        }, 50);
	        setTimeout(function () {
	          html2canvas(el_email_campaign_detail, { logging: false }).then(function (canvas) {
	            canvasEmailCampaignDetail = canvas;
	            isCanvasEmailCampaignReady = true;
	            el_email_campaign_detail.style.width = oriWidth + 'px';
	          });
	        }, 50);
	      }
	
	      setTimeout(function () {
	        html2canvas(el_campaign_graph, { logging: false }).then(function (canvas) {
	          canvasGraph = canvas;
	          isCanvasGraphReady = true;
	          el_campaign_graph.style.width = oriWidth + 'px';
	        });
	      }, 50);
	      setTimeout(function () {
	        html2canvas(el_campaign_stats, { logging: false }).then(function (canvas) {
	          canvasSummary = canvas;
	          isCanvasSummaryReady = true;
	          el_campaign_stats.style.width = oriWidth + 'px';
	        });
	      }, 50);
	
	      var top = 37;
	      var left = 12;
	      var intervalId = setInterval(function () {
	        if (isCanvasTopLinkReady === false || isCanvasSummaryReady === false || isCanvasGraphReady === false || isCanvasEmailCampaignReady === false || isCanvasSelectorReady === false) {
	          console.log("PDF Generating...");
	        } else {
	          clearInterval(intervalId);
	          setTimeout(function () {
	            this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
	
	            top = 35;
	            pdf.addImage(canvasSelectorContainer.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            top += canvasSelectorContainer.height * pageWidth / canvasSelectorContainer.width + 3;
	            //pdf.addImage(canvasDatePicker.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            //top += (canvasDatePicker.height * pageWidth / canvasDatePicker.width);
	            if (channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") {
	              pdf.addImage(canvasEmailCampaignDetail.toDataURL(), "PNG", left, top, pageWidth, 0);
	              top += canvasEmailCampaignDetail.height * pageWidth / canvasEmailCampaignDetail.width + 3;
	            }
	            pdf.addImage(canvasGraph.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            top += canvasGraph.height * pageWidth / canvasGraph.width + 3;
	            pdf.addImage(canvasSummary.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            if (channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") {
	              (0, _utility.addPdfFooter)(pdf);
	              pdf.addPage('a4', 'p');
	              this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
	              top = 35;
	              //top += (canvasSummary.height * pageWidth / canvasSummary.width) + 3;
	              pdf.addImage(canvasTopLinkContainer.toDataURL(), 'PNG', left - 2, top, pageWidth + 2, 0);
	            }
	
	            (0, _utility.addPdfFooter)(pdf);
	
	            document.getElementsByClassName("nav-btn-download-report")[0].style.display = "block";
	            document.getElementsByClassName("definition-container")[0].style.display = "none";
	            document.getElementsByClassName("tooltip-container")[0].style.display = "block";
	            if (document.getElementsByClassName("section-link").length > 0) document.getElementsByClassName("section-link")[0].style.display = "block";
	            if (tableLinks.length > 0) {
	              (0, _forEach2.default)(tableLinks, function (el) {
	                el.style.color = linkColor;
	              });
	            }
	            pdfFileName = pdfFileName.replace(new RegExp(' ', 'g'), '_') + "_" + (0, _momentTimezone2.default)().format("YYYYMMDD") + ".pdf";
	            pdf.save(pdfFileName);
	            this.setState({ onPdfReportDownload: false });
	          }.bind(this), 100);
	        }
	      }.bind(this), 50);
	    }
	  }, {
	    key: 'handleCsvDownload',
	    value: function handleCsvDownload() {
	      var _props2 = this.props,
	          clients = _props2.clients,
	          client_info = _props2.client_info,
	          channelCampaignId = _props2.channelCampaignId,
	          campaignDetail = _props2.campaignDetail,
	          reportDateRange = _props2.reportDateRange,
	          emailAggregatedReport = _props2.emailAggregatedReport,
	          emailAggregatedStats = _props2.emailAggregatedStats,
	          segmentId = _props2.segmentId;
	      var delivered = emailAggregatedStats.delivered,
	          distinctindividuals = emailAggregatedStats.distinctindividuals,
	          opens = emailAggregatedStats.opens,
	          clicks = emailAggregatedStats.clicks,
	          unsubs = emailAggregatedStats.unsubs,
	          uniqueclicks = emailAggregatedStats.uniqueclicks,
	          clickrate = emailAggregatedStats.clickrate,
	          uniqueopens = emailAggregatedStats.uniqueopens,
	          openrate = emailAggregatedStats.openrate;
	
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	
	      var deployment = channelCampaignId === "aggregated" ? null : campaignDetail.emailDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var channelCampaignName = deployment ? deployment.name : "Aggregated";
	      var csvFileName = campaignDetail.name + "_Email_";
	
	      if (channelCampaignName !== "Aggregated") {
	        if (segmentId === "aggregated") {
	          csvFileName += "Segment_Aggregagte";
	        }
	      } else {
	        csvFileName += "Deployment_Aggregate";
	      }
	
	      var title_line = channelCampaignName === "Aggregated" ? 'AudienceAnywhere Aggregate Email Deployment Report  ,,,,,,,,\r\n' : segmentId && segmentId !== "aggregated" ? 'AudienceAnywhere Email Segment Campaign Report  ,,,,,,,,\r\n' : 'AudienceAnywhere Aggregate Email Segment Campaign Report  ,,,,,,,,\r\n';
	
	      var date_line = "Today's Date," + (0, _momentTimezone2.default)().format("MM/DD/YY") + ",,,,,,,\r\n";
	      var client_line = "Client," + client_name + ",,,,,,,\r\n";
	      var business_unit_line = (0, _isEmpty2.default)(bu_name) ? "" : "Business Unit," + bu_name + ",,,,,,,\r\n";
	      var date_filter_line = "Date Filter," + this.reportDateFilter(reportDateRange) + ",,,,,,,\r\n";
	      var split_line = ",,,,,,,,\r\n";
	      var campaign_group_name_line = "Campaign Group Name," + campaignDetail.name + ",,,,,,,\r\n";
	      if (channelCampaignName !== "Aggregated" && segmentId !== "aggregated") {
	        var emailCampaignDetail = (0, _find2.default)(deployment.channelCampaigns, function (campaign) {
	          return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
	        });
	        csvFileName += emailCampaignDetail.name;
	        var email_campaign_name = "Email Segment Name," + emailCampaignDetail.name + ",,,,,,,\r\n";
	        var email_campaign_status = "Email Segment Status," + emailCampaignDetail.status + ",,,,,,,\r\n";
	        var email_campaign_start_date = "Email Segment Start Date," + (0, _momentTimezone2.default)(emailCampaignDetail.startDate).format("MM/DD/YYYY") + ",,,,,,,\r\n";
	        var email_campaign_end_date = emailCampaignDetail.endDate ? "Email Segment End Date," + (0, _momentTimezone2.default)(emailCampaignDetail.endDate).format("MM/DD/YYYY") + ",,,,,,,\r\n" : "Email Segment End Date,,,,,,,,\r\n";
	        campaign_group_name_line += "Email Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
	        campaign_group_name_line += email_campaign_name;
	        campaign_group_name_line += email_campaign_status;
	        campaign_group_name_line += email_campaign_start_date;
	        campaign_group_name_line += email_campaign_end_date;
	        campaign_group_name_line += ",,,,,,,,\r\n";
	      } else {
	        if (channelCampaignName !== "Aggregated") {
	          campaign_group_name_line += "Email Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
	        }
	      }
	
	      var campaign_grouped_title = "Opens and Clicks,,,,,,,,\r\n,";
	      var campaign_grouped_open_row = "Opens,";
	      var campaign_grouped_click_row = "Clicks,";
	      if (emailAggregatedReport) {
	        emailAggregatedReport.forEach(function (data) {
	          campaign_grouped_title += data.time + ",";
	          campaign_grouped_open_row += data.opens + ",";
	          campaign_grouped_click_row += data.clicks + ",";
	        });
	      }
	      campaign_grouped_title += "\r\n";
	      campaign_grouped_open_row += "\r\n";
	      campaign_grouped_click_row += "\r\n";
	      var aggregated_email_campaign_stats_title = channelCampaignName === "Aggregated" ? "Aggregate Email Deployment Statistics,,,,,,,,\r\n" : segmentId && segmentId === "aggregated" ? "Aggregate Email Segment Statistics,,,,,,,,\r\n" : "Email Segment Statistics,,,,,,,,\r\n";
	
	      var stats_delivered_row = campaignDetail.emailReportDelivered ? "Delivered, " + delivered + ",,,,,,,\r\n" : "";
	      var stats_distinct_row = campaignDetail.emailReportDistinctIndividuals ? "Distinct Individuals, " + distinctindividuals + ",,,,,,,\r\n" : "";
	
	      var stats_opens_row = "Opens," + opens + ",,,,,,,\r\n";
	      var stats_unique_open_row = "Unique Open," + uniqueopens + ",,,,,,,\r\n";
	      var stats_open_rate_row = openrate ? "Open Rate," + openrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) + ",,,,,,,\r\n" : "Open Rate,,,,,,,,\r\n";
	      var stats_clicks_row = "Clicks," + clicks + ",,,,,,,\r\n";
	      var stats_unique_clicks_row = "Unique Clicks," + uniqueclicks + ",,,,,,,\r\n";
	      var stats_click_rate_row = clickrate ? "Click to Open Rate," + clickrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) + ",,,,,,,\r\n" : "Click to Open Rate,,,,,,,,\r\n";
	      var stats_unsubscribed_row = "Unsubscribed," + unsubs + ",,,,,,,\r\n";
	
	      var definition_title = "Definitions,,,,,,,,\r\n";
	      var define_delivered_line = "Delivered: The number of messages accepted by the receiving server ,,,,,,,,\r\n";
	      var define_open_line = '"Opens: The total number of times a recipient opened the email where a message is opened and images are enabled, the image calls the server allowing the message to be counted as an open",,,,,,,,\r\n';
	      var define_unique_opens_line = "Unique Opens: The number of distinct recipients that opened the email,,,,,,,,\r\n";
	      var define_open_rate_line = "Open Rate: The percentage of unique recipients who opened the email compared to how many were delivered,,,,,,,,\r\n";
	      var define_clicks_line = "Clicks: The total number of times a recipient clicks on a link within the email. If the same subscriber clicks multiple times, each occurrence gets counted,,,,,,,,\r\n";
	      var define_unique_clicks_line = "Unique Clicks: The total number of distinct recipients who clicked on links. Each recipient is only counted once in this figure, regardless of how many links they click,,,,,,,,\r\n";
	      var define_click_rate_line = "Click to Open Rate: The percentage of unique recipients who clicked compared to the unique recipients who opened,,,,,,,,\r\n";
	      var define_unsubscribed_line = "Unsubscribed: The number of recipients that clicked on the advertiser opt-out link,,,,,,,,\r\n";
	
	      var resultString = title_line + date_line + client_line + business_unit_line + date_filter_line + split_line + campaign_group_name_line + split_line + campaign_grouped_title + campaign_grouped_open_row + campaign_grouped_click_row + split_line + aggregated_email_campaign_stats_title + stats_delivered_row + stats_distinct_row + stats_opens_row + stats_unique_open_row + stats_open_rate_row + stats_clicks_row + stats_unique_clicks_row + stats_click_rate_row + stats_unsubscribed_row + split_line + definition_title + define_delivered_line + define_open_line + define_unique_opens_line + define_open_rate_line + define_clicks_line + define_unique_clicks_line + define_click_rate_line + define_unsubscribed_line;
	      if (channelCampaignName !== "Aggregated" && segmentId !== 'aggregated') {
	        resultString += ",,,,,,,,      \r\n";
	        resultString += "Top Links Clicked,,,,,,,,\r\n";
	        resultString += "Link,Pct. Clicked,,,,,,,\r\n";
	        if (this.props.topLinkStats) {
	          (0, _map2.default)(this.props.topLinkStats, function (stat) {
	            resultString += stat.linkurl + "," + stat.clickrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) + ",,,,,,,\r\n";
	          });
	        }
	        if (client_info && client_info.clientReportDetailSetting && client_info.clientReportDetailSetting.topLocationChannelReport === true) {
	          if (this.props.topLocationOpensStats) {
	            resultString += ",,,,,,,,      \r\n";
	            resultString += "Top Locations By Opens,,,,,,,,\r\n";
	            (0, _map2.default)(this.props.topLocationOpensStats, function (stat) {
	              resultString += stat.state + "," + stat.opens + ",,,,,,,\r\n";
	            });
	          }
	        }
	      }
	      csvFileName += "_" + (0, _momentTimezone2.default)().format("YYYYMMDD");
	      csvFileName = csvFileName.replace(new RegExp(' ', 'g'), '_');
	      (0, _utility.downLoadCSVFunc)(resultString, csvFileName);
	      setTimeout(function () {
	        this.setState({ onCsvReportDownload: false });
	      }.bind(this), 2000);
	    }
	  }, {
	    key: 'setChannelCampaignId',
	    value: function setChannelCampaignId(data) {
	      this.props.setChannelCampaignId(data);
	      var match = this.props.match;
	
	
	      if (data.value !== "aggregated") {
	        var deployment = (0, _find2.default)(this.props.campaignDetail.emailDeployments, function (deployment) {
	          return deployment.id === data.value;
	        });
	        if (deployment) {
	          var segmentList = [];
	          (0, _map2.default)(deployment.channelCampaigns, function (channelCampaign) {
	            segmentList.push({ value: channelCampaign.id, label: channelCampaign.name });
	          });
	          if (segmentList.length > 1) {
	            segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	            this.props.setSegmentId({ value: "aggregated" });
	          } else {
	            this.props.setSegmentId({ value: segmentList[0].id });
	          }
	          this.setState({ emailSegmentList: segmentList });
	
	          this.props.getEmailChannelAggregatedReport(match.params.id, data.value, this.props.reportDateRange, segmentList[0].value);
	          this.props.getEmailChannelStatsAggregated(match.params.id, data.value, this.props.reportDateRange, segmentList[0].value);
	        }
	      } else {
	        this.props.getEmailChannelStatsAggregated(match.params.id, data.value, this.props.reportDateRange);
	        this.props.getEmailChannelAggregatedReport(match.params.id, data.value, this.props.reportDateRange);
	      }
	      this.props.history.push('/campaigns/report/' + match.params.id + '/email/' + data.value);
	    }
	  }, {
	    key: 'setSegmentId',
	    value: function setSegmentId(data) {
	      this.props.setSegmentId(data);
	    }
	  }, {
	    key: 'cbPDFChange',
	    value: function cbPDFChange(e, isInputChecked) {
	      var result = !this.refs.cbCSV.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: 'cbCSVChange',
	    value: function cbCSVChange(e, isInputChecked) {
	      var result = !this.refs.cbPDF.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          match = _props3.match,
	          campaignDetail = _props3.campaignDetail,
	          reportDateRange = _props3.reportDateRange,
	          emailAggregatedReport = _props3.emailAggregatedReport,
	          setReportDateRange = _props3.setReportDateRange,
	          client_info = _props3.client_info,
	          segmentId = _props3.segmentId;
	
	      var showTopLocationOpens = client_info && client_info.clientReportDetailSetting && client_info.clientReportDetailSetting.topLocationChannelReport === true;
	      var channelCampaignId = match.params.channelCampaignId;
	      var lineData = [];
	      if (emailAggregatedReport) {
	        emailAggregatedReport.forEach(function (data) {
	          lineData.push({ time: data.time, opens: data.opens, clicks: data.clicks });
	        });
	      }
	      var tableSubTitle = "Date: ";
	      var tableSubTitleText = this.reportDateFilter(reportDateRange);
	      var crumbs = [];
	      var crumbsLink = [];
	      var channelCampaignDetail = channelCampaignId === "aggregated" || !campaignDetail ? null : campaignDetail.emailDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var segment = undefined;
	
	      if (campaignDetail && campaignDetail.emailDeployments) {
	        crumbs.push(campaignDetail.name);
	        crumbsLink.push('/campaigns/report/' + campaignDetail.id);
	        if (channelCampaignId === undefined || channelCampaignId === "aggregated") {
	          crumbs.push("Email Campaign: Aggregate");
	        } else {
	          (0, _map2.default)(campaignDetail.emailDeployments, function (dep) {
	            if (parseInt(dep.id, 10) === parseInt(channelCampaignId, 10)) {
	              if (segmentId) {
	                segment = (0, _find2.default)(dep.channelCampaigns, function (s) {
	                  return parseInt(s.id, 10) === parseInt(segmentId, 10);
	                });
	              }
	              crumbs.push("Email ");
	            }
	          });
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'campaign-report-container', style: { background: "#FFFFFF", fontSize: '16px' } },
	        _react2.default.createElement(_Title2.default, {
	          crumbs: crumbs,
	          crumbsLink: crumbsLink,
	          linkName: 'Campaigns', showDownloadBtn: true,
	          handleDownload: function handleDownload() {
	            _this3.setState({ showDownloadDialog: true });
	          },
	          selected_client: this.props.client_id
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'light-grey-border mt-20 selector-container' },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'pt-10, no-margin-bottom', style: { fontWeight: "bold", fontSize: '24px' } },
	            'Email Selection'
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'no-padding-top no-margin-bottom' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Email Deployment'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(_reactSelect2.default, { className: 'campaign-selector left-10 z-index-199',
	                value: channelCampaignId ? channelCampaignId : (0, _isEmpty2.default)(this.state.emailCampaignList) ? "" : this.state.emailCampaignList.length > 1 ? "aggregated" : this.state.emailCampaignList[0].value,
	                clearable: false,
	                searchable: false,
	                options: this.state.emailCampaignList,
	                placeholder: "Select Campaign",
	                onChange: this.setChannelCampaignId.bind(this)
	              })
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '2', sm: '2', md: '2', lg: '2' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Email Segment'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '4', sm: '4', md: '4', lg: '4' },
	              this.state.emailSegmentList.length > 0 && _react2.default.createElement(_reactSelect2.default, { className: 'campaign-selector left-10 z-index-199',
	                value: segmentId ? segmentId : this.state.emailSegmentList.length > 0 ? this.state.emailSegmentList[0].value : 0,
	                clearable: false,
	                searchable: false,
	                options: this.state.emailSegmentList,
	                placeholder: "Select Segment",
	                onChange: this.setSegmentId.bind(this)
	              })
	            )
	          ),
	          _react2.default.createElement('hr', { style: { margin: "-10px 20px 20px" } }),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'no-padding-top no-margin-bottom' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Date'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(_reactSelect2.default, { className: 'report-date-selector left-10 z-index-198',
	                value: reportDateRange,
	                clearable: false,
	                searchable: false,
	                options: this.dateItem(),
	                placeholder: "Select Day",
	                onChange: setReportDateRange.bind(this)
	              })
	            )
	          )
	        ),
	        channelCampaignDetail && segmentId !== "aggregated" && _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'light-grey-border mt-20 no-margin-left no-margin-right no-padding mb-20 pr-10 email-campaign-detail-container' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'pl-10 mt-10', style: { fontSize: '24px', fontWeight: 'bold' } },
	            'Email Segment Details'
	          ),
	          _react2.default.createElement(
	            'table',
	            { style: { width: "98%", marginLeft: '10px' } },
	            _react2.default.createElement(
	              'thead',
	              { style: styles.tableHeaderStyle },
	              _react2.default.createElement(
	                'tr',
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '47%', paddingLeft: "20px", wordBreak: "break-word" } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment Name'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '18%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment Status'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '16%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment Start Date'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '16%', textAlign: "right", paddingRight: "20px" } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment End Date'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '47%', paddingLeft: "20px", paddingRight: "50px", wordBreak: "break-word" } },
	                  segment ? segment.name : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '18%' } },
	                  segment ? segment.status : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '16%' } },
	                  segment ? (0, _momentTimezone2.default)(segment.startDate).format("MM/DD/YY") : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '16%', textAlign: 'right', paddingRight: "20px" } },
	                  segment && segment.endDate ? (0, _momentTimezone2.default)(segment.endDate).format("MM/DD/YY") : ""
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'light-grey-border no-margin-left no-margin-right no-padding mt-20 mb-20 pb-20 pr-20 pl-10 campaign-graph-container' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'pl-10', style: { fontSize: '24px', fontWeight: 'bold' } },
	            'Email Opens and Clicks'
	          ),
	          _react2.default.createElement(_LineGraphic2.default, { animation: false, key: 'line-section', dataNames: ["Opens", "Clicks"], dataKeys: ['opens', 'clicks'],
	            title: '', data: lineData, subTitle: tableSubTitle, subTitleText: tableSubTitleText })
	        ),
	        this.statsList(this.props),
	        channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated" && _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'no-margin-right no-padding campaign-top-links-container' },
	          !(0, _isUndefined2.default)(this.props.topLinkStats) && _react2.default.createElement(
	            _Grid.Col,
	            { xs: '6', sm: '6', md: '6', lg: '', className: 'light-grey-border p-20 no-margin-left top-links-stats', style: { width: this.state.sectionWidth } },
	            this.topLinkStatsChart(this.props)
	          ),
	          showTopLocationOpens && _react2.default.createElement(
	            _Grid.Col,
	            { xs: '6', sm: '6', md: '6', lg: '6', className: 'light-grey-border p-20 top-location-stats', style: { float: "right", width: this.state.sectionWidth } },
	            this.topLocationStats(this.props)
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { open: this.state.onCsvReportDownload, style: { top: '-1.8em' }, modal: true, contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: '#666666' } },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'mt-20' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { offsetXs: '1', offsetSm: '1', offsetMd: '1', offsetLg: '1', xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
	              _react2.default.createElement(
	                'div',
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '1', sm: '1', md: '1', lg: '1' },
	              _react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { open: this.state.onPdfReportDownload, style: { top: '-1.8em' }, modal: true, contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: '#666666' } },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'mt-20' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { offsetXs: '1', offsetSm: '1', offsetMd: '1', offsetLg: '1', xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
	              _react2.default.createElement(
	                'div',
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '1', sm: '1', md: '1', lg: '1' },
	              _react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { open: this.state.showDownloadDialog, style: { top: '-1.8em' }, modal: true,
	            contentStyle: { width: "440px" } },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-margin-top no-padding', style: { fontSize: '16px', color: "#000" } },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Choose the type of file you would like to download'
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-padding-top no-padding-right no-padding-bottom no-margin-bottom',
	              style: { paddingLeft: "150px" } },
	            _react2.default.createElement(_Checkbox2.default, { iconStyle: { fill: "#47A1AB", marginRight: '10px' }, label: "PDF File", labelStyle: { fontSize: '13px' },
	              defaultChecked: false, ref: 'cbPDF', onCheck: function onCheck(e, isInputChecked) {
	                return _this3.cbPDFChange(e, isInputChecked);
	              } })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-padding-top no-padding-right no-padding-bottom', style: { paddingLeft: "150px" } },
	            _react2.default.createElement(_Checkbox2.default, { iconStyle: { fill: "#47A1AB", marginRight: '10px' }, label: "CSV File", labelStyle: { fontSize: '13px' },
	              defaultChecked: true, ref: 'cbCSV', onCheck: function onCheck(e, isInputChecked) {
	                return _this3.cbCSVChange(e, isInputChecked);
	              } })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-padding no-margin-bottom mt-20 text-center' },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onClick: function onClick() {
	                  return _this3.setState({ showDownloadDialog: false });
	                },
	                className: 'btn btn-default btn-aa-info mr-20' },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onClick: this.handleDownload.bind(this), disabled: this.state.disabledBtnDownload,
	                className: 'btn btn-default btn-aa-default' },
	              'Download File'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EmailChannelReport;
	}(_MaterialUI2.default);
	
	exports.default = EmailChannelReport;

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Title = __webpack_require__(166);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Grid = __webpack_require__(19);
	
	var _LineGraphic = __webpack_require__(256);
	
	var _LineGraphic2 = _interopRequireDefault(_LineGraphic);
	
	var _PieGraphic = __webpack_require__(353);
	
	var _PieGraphic2 = _interopRequireDefault(_PieGraphic);
	
	var _TopLocationSection = __webpack_require__(354);
	
	var _TopLocationSection2 = _interopRequireDefault(_TopLocationSection);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _forEach = __webpack_require__(185);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _utility = __webpack_require__(14);
	
	var _momentTimezone = __webpack_require__(110);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(220);
	
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	var styles = {
	  statsListItem: {
	    width: '50%',
	    padding: '5px 0',
	    borderTop: "solid 1px #000"
	  },
	  tableHeaderStyle: {
	    border: 'none',
	    background: '#F5F5F5',
	    fontSize: '12px',
	    fontWeight: "bold"
	  },
	  tableHeaderColumn: {
	    height: '35px',
	    color: 'black',
	    cursor: 'pointer',
	    fontWeight: 'bolder',
	    paddingLeft: '10px',
	    position: 'relative',
	    whiteSpace: 'nowrap',
	    textOverflow: 'ellipsis'
	  },
	  tableTd: {
	    paddingLeft: '10px',
	    height: '30px',
	    borderBottom: '1px solid black',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  }
	};
	var TOP_LINK_STATS_COUNT = 5;
	
	var SocialChannelReport = function (_AcquireWebComponent) {
	  _inherits(SocialChannelReport, _AcquireWebComponent);
	
	  function SocialChannelReport(props) {
	    _classCallCheck(this, SocialChannelReport);
	
	    var _this = _possibleConstructorReturn(this, (SocialChannelReport.__proto__ || Object.getPrototypeOf(SocialChannelReport)).call(this, props));
	
	    var list = [];
	    var segmentList = [];
	    if (props.campaignDetail) {
	      if (props.campaignDetail.socialDeployments.length > 1) {
	        list.push({ value: "aggregated", label: "Aggregate" });
	      }
	      (0, _map2.default)(props.campaignDetail.socialDeployments, function (campaign) {
	        list.push({ value: campaign.id, label: campaign.name });
	      });
	      if (props.campaignDetail.socialDeployments.length > 0 && props.match.params.channelCampaignId !== "aggregated") {
	        var source = (0, _find2.default)(props.campaignDetail.socialDeployments, function (dep) {
	          return parseInt(dep.id, 10) === parseInt(props.match.params.channelCampaignId, 10);
	        });
	        (0, _map2.default)(source.channelCampaigns, function (channelCampaign) {
	          segmentList.push({ value: channelCampaign.id, label: channelCampaign.name });
	        });
	
	        if (segmentList.length > 1) {
	          segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	        }
	      }
	    }
	
	    props.getCampaignById(props.match.params.id);
	    if (props.segmentId) {
	      if (props.match.params.channelCampaignId === "aggregated") {
	        var _source = (0, _find2.default)(props.campaignDetail.socialDeployments, function (dep) {
	          return (0, _find2.default)(dep.channelCampaigns, function (campaign) {
	            return parseInt(campaign.id, 10) === parseInt(props.segmentId, 10);
	          });
	        });
	        if (_source && _source.channelCampaigns.length === 1) {
	          (0, _map2.default)(_source.channelCampaigns, function (channelCampaign) {
	            segmentList.push({ value: channelCampaign.id, label: channelCampaign.name });
	          });
	
	          if (segmentList.length > 1) {
	            segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	          }
	          props.getSocialChannelAggregatedReport(props.match.params.id, _source.id, props.reportDateRange, props.segmentId);
	          props.getSocialChannelStatsAggregated(props.match.params.id, _source.id, props.reportDateRange, props.segmentId);
	        } else {
	          props.getSocialChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	          props.getSocialChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	        }
	      } else {
	        props.getSocialChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange, props.segmentId);
	        props.getSocialChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange, props.segmentId);
	      }
	    } else {
	      props.getSocialChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	      props.getSocialChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
	    }
	    _this.state = {
	      groupCampaignId: props.match.params.id,
	      emailCampaignList: list,
	      emailSegmentList: segmentList,
	      showDownloadDialog: false,
	      onPdfReportDownload: false,
	      onCsvReportDownload: false,
	      disabledBtnDownload: false,
	      sectionWidth: '601px'
	    };
	
	    if (props.match.params.channelCampaignId !== "aggregated") {
	      if (props.segmentId && props.segmentId !== "aggregated") {
	        _this.props.getCampaignTopLinkStats(props.match.params.id, props.segmentId, props.reportDateRange, TOP_LINK_STATS_COUNT);
	        _this.props.getCampaignTopLocationClickStats(props.match.params.id, props.segmentId, props.reportDateRange, TOP_LINK_STATS_COUNT);
	      }
	    }
	
	    if (props.match.params.channelCampaignId === "aggregated" && list.length === 1) {
	      props.setChannelCampaignId({ value: list[0].value });
	      props.history.push('/campaigns/report/' + props.match.params.id + '/social/' + list[0].value);
	    } else {
	      if (props.match.params.channelCampaignId !== "aggregated") props.setChannelCampaignId({ value: props.match.params.channelCampaignId });
	    }
	    return _this;
	  }
	
	  _createClass(SocialChannelReport, [{
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var containerEls = document.getElementsByClassName("campaign-graph-container");
	      if (containerEls.length > 0) {
	        var w = containerEls[0].offsetWidth / 2 - 10;
	        this.setState({
	          sectionWidth: w + 'px'
	        });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions.bind(this));
	      this.setSegmentId({ value: undefined });
	    }
	  }, {
	    key: 'handleDownload',
	    value: function handleDownload(e) {
	      e.preventDefault();
	
	      if (this.refs.cbPDF.state.switched) {
	        this.downloadPdfReport();
	      }
	
	      if (this.refs.cbCSV.state.switched) {
	        this.downloadCsvReport();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.campaignDetail) {
	        this.props.getCampaignById(this.props.match.params.id);
	        this.props.getSocialChannelAggregatedReport(this.props.match.params.id, this.props.match.params.channelCampaignId, this.props.reportDateRange);
	        this.props.getSocialChannelStatsAggregated(this.props.match.params.id, this.props.match.params.channelCampaignId, this.props.reportDateRange);
	        this.props.setChannelCampaignId({ value: this.props.match.params.channelCampaignId });
	        if (this.props.match.params.channelCampaignId !== "aggregated") {
	          if (this.props.segmentId && this.props.segmentId !== "aggregated") {
	            this.props.getCampaignTopLinkStats(this.props.match.params.id, this.props.segmentId, this.props.reportDateRange, TOP_LINK_STATS_COUNT);
	            this.props.getCampaignTopLocationClickStats(this.props.match.params.id, this.props.segmentId, this.props.reportDateRange, TOP_LINK_STATS_COUNT);
	          }
	        }
	      }
	
	      window.addEventListener("resize", this.updateDimensions.bind(this));
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!(0, _isEqual2.default)(nextProps.campaignDetail, this.props.campaignDetail)) {
	        var list = nextProps.campaignDetail.socialDeployments.length > 1 ? [{ value: "aggregated", label: "Aggregate" }] : [];
	        (0, _map2.default)(nextProps.campaignDetail.socialDeployments, function (campaign) {
	          list.push({ value: campaign.id, label: campaign.name });
	        });
	        this.props.selectClient(nextProps.campaignDetail.clientId);
	        this.setState({
	          emailCampaignList: list
	        });
	        if (this.props.match.params.channelCampaignId !== "aggregatted") {
	          var dep = (0, _find2.default)(nextProps.campaignDetail.socialDeployments, function (deploy) {
	            return parseInt(deploy.id, 10) === parseInt(_this2.props.match.params.channelCampaignId, 10);
	          });
	          if (dep) {
	            var segmentList = [];
	            (0, _map2.default)(dep.channelCampaigns, function (campaign) {
	              segmentList.push({ value: campaign.id, label: campaign.name });
	            });
	            if (segmentList.length > 1) {
	              segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	            }
	            this.setState({ emailSegmentList: segmentList });
	            this.props.setSegmentId({ value: segmentList[0].value });
	          }
	        }
	      }
	      if (nextProps.reportDateRange !== this.props.reportDateRange || nextProps.channelCampaignId !== this.props.channelCampaignId || nextProps.match.params.channelCampaignId !== this.props.match.params.channelCampaignId || nextProps.segmentId !== this.props.segmentId) {
	        var channelCampaignId = nextProps.match.params.channelCampaignId ? nextProps.match.params.channelCampaignId : this.props.match.params.channelCampaignId;
	        if (channelCampaignId !== "aggregated") {
	          if (nextProps.campaignDetail) {
	            var _dep = (0, _find2.default)(nextProps.campaignDetail.socialDeployments, function (deploy) {
	              return parseInt(deploy.id, 10) === parseInt(channelCampaignId, 10);
	            });
	            if (_dep) {
	              var _segmentList = [];
	              (0, _map2.default)(_dep.channelCampaigns, function (campaign) {
	                _segmentList.push({ value: campaign.id, label: campaign.name });
	              });
	              if (_segmentList.length > 1) {
	                _segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	              }
	              var sid = parseInt(channelCampaignId, 10) !== parseInt(this.props.channelCampaignId, 10) || !nextProps.segmentId ? _segmentList[0].value : nextProps.segmentId;
	              this.setState({ emailSegmentList: _segmentList });
	              this.props.setSegmentId({ value: nextProps.segmentId ? nextProps.segmentId : sid });
	
	              if (sid !== "aggregated") {
	                this.props.getCampaignTopLinkStats(this.props.match.params.id, sid, nextProps.reportDateRange, TOP_LINK_STATS_COUNT);
	                this.props.getCampaignTopLocationClickStats(this.props.match.params.id, sid, nextProps.reportDateRange, TOP_LINK_STATS_COUNT);
	              }
	
	              this.props.getSocialChannelStatsAggregated(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange, sid);
	              this.props.getSocialChannelAggregatedReport(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange, sid);
	            }
	          }
	        } else {
	          this.setState({ emailSegmentList: [] });
	          this.props.getSocialChannelStatsAggregated(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange);
	          this.props.getSocialChannelAggregatedReport(this.props.match.params.id, channelCampaignId, nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange);
	        }
	      }
	      /*
	      if (nextProps.client_id !== this.props.client_id && (this.props.client_id))  {
	      this.props.history.push("/campaigns");
	      }*/
	    }
	  }, {
	    key: 'dateItem',
	    value: function dateItem() {
	      return [{ value: "life-of-campaign", label: "Life of Campaign" }, { value: "yesterday", label: "Yesterday" }, { value: "today", label: "Today" }, { value: "last-7-days", label: "Last 7 Days" }, { value: "last-30-days", label: "Last 30 Days" }];
	    }
	  }, {
	    key: 'reportDateFilter',
	    value: function reportDateFilter(dayRange) {
	      var result = "";
	      switch (dayRange) {
	        case "yesterday":
	          result = "Yesterday";
	          break;
	        case "today":
	          result = "Today";
	          break;
	        case "last-7-days":
	          result = "Last 7 Days";
	          break;
	        case "last-30-days":
	          result = "Last 30 Days";
	          break;
	        case "life-of-campaign":
	        default:
	          result = "Life of Campaign";
	          break;
	      }
	      return result;
	    }
	  }, {
	    key: 'formatTopLinkRate',
	    value: function formatTopLinkRate(obj) {
	      if (obj && obj.clickrate) {
	        var result = obj.clickrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) + "";
	        return result;
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'topLinkStatsChart',
	    value: function topLinkStatsChart(props) {
	      var topLinkStats = props.topLinkStats;
	
	      var channelCampaignId = props.match.params.channelCampaignId;
	      if (channelCampaignId !== "aggregated" && !(0, _isUndefined2.default)(topLinkStats)) {
	        return _react2.default.createElement(_PieGraphic2.default, { title: "Top Links Clicked", key: 'top-link-stats-section',
	          data: topLinkStats, hideOverflow: true, fieldDisplayFunc: this.formatTopLinkRate,
	          showGraphic: true,
	          footer: _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'section-link', to: '/campaigns/report/' + this.props.match.params.id + '/social/' + this.props.channelCampaignId + '/' + this.props.segmentId + '/top-links-click' },
	            'View More Top Links'
	          )
	        });
	      }
	
	      return "";
	    }
	  }, {
	    key: 'topLocationStats',
	    value: function topLocationStats(props) {
	      var topLocationOpensStats = props.topLocationOpensStats;
	
	      return _react2.default.createElement(_TopLocationSection2.default, { title: "Top Locations by Clicks", key: 'top-locations-by-opens', data: topLocationOpensStats });
	    }
	  }, {
	    key: 'statsList',
	    value: function statsList(props) {
	      if (props.socialAggregatedStats) {
	        var segmentId = props.segmentId;
	        var channelCampaignId = props.match.params.channelCampaignId;
	
	        var container = _react2.default.createElement(
	          _Grid.FullRow,
	          { style: { fontSize: "16px" }, className: 'light-grey-border no-margin-left no-margin-right no-padding mb-20 pb-20 pr-10 campaign-stats-container' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'pl-10', style: { fontSize: '24px', fontWeight: 'bold' } },
	            'Facebook Campaign Statistics'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: '25px', right: '12px' }, className: 'tooltip-container' },
	            _react2.default.createElement(
	              _rcTooltip2.default,
	              { placement: 'right',
	                overlayClassName: 'campaign-report-legend',
	                overlayStyle: { width: "288px" },
	                overlay: _react2.default.createElement(
	                  'div',
	                  { className: 'legend-overlay-container' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Facebook Campaign Statistics Definitions'
	                  ),
	                  _react2.default.createElement('hr', { className: 'black-hr' }),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Reach: '
	                  ),
	                  'The number of unique people who saw your ad',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Impressions: '
	                  ),
	                  'The number of times an instance of your ad is on screen',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Frequency: '
	                  ),
	                  'The average number of times each person saw your ad',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Clicks - '
	                  ),
	                  'The number of clicks on links within the ad that led to destinations or experiences, on or off Facebook',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Post Engagements: '
	                  ),
	                  'The total number of actions that people take involving your ads while they\'re running. Actions can include clicking on a link, commenting on or sharing the ads, claiming an offer, viewing a photo or video.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Engagement Rate: '
	                  ),
	                  'The percentage of times people saw your ad and performed either a link click, reaction, shares, forward, or comment.'
	                ),
	                arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' })
	              },
	              _react2.default.createElement(_infoOutline2.default, {
	                style: { color: 'black', width: '24px', height: '24px', marginTop: '0px', marginLeft: '0px', cursor: 'pointer' }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'spread-table mt-20 ml-10' },
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  segmentId && segmentId !== "aggregated" && _react2.default.createElement(
	                    'th',
	                    { style: { padding: "10px 20px" } },
	                    'Reach'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { padding: "10px" } },
	                    'Impressions'
	                  ),
	                  segmentId && segmentId !== "aggregated" && _react2.default.createElement(
	                    'th',
	                    { style: { padding: "10px" } },
	                    'Frequency'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { padding: "10px" } },
	                    'Clicks'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { padding: "10px" } },
	                    'Post Engagements'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { padding: "10px", paddingRight: "20px", textAlign: 'right' } },
	                    'Engagement Rate'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  channelCampaignId.toLowerCase() !== "aggregated" && segmentId && segmentId !== "aggregated" && _react2.default.createElement(
	                    'td',
	                    { style: { paddingLeft: "20px" } },
	                    (0, _utility.splitNumber)(props.socialAggregatedStats.reach)()
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _utility.splitNumber)(props.socialAggregatedStats.impressions)()
	                  ),
	                  channelCampaignId.toLowerCase() !== "aggregated" && segmentId && segmentId !== "aggregated" && props.socialAggregatedStats.frequency && _react2.default.createElement(
	                    'td',
	                    null,
	                    props.socialAggregatedStats.frequency.toLocaleString()
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _utility.splitNumber)(props.socialAggregatedStats.fbclicks)()
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _utility.splitNumber)(props.socialAggregatedStats.postengagements)()
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { style: { paddingRight: "20px", textAlign: 'right' } },
	                    props.socialAggregatedStats.engagementrate ? props.socialAggregatedStats.engagementrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) : ""
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-margin-bottom no-padding-bottom definition-container', style: { display: "none" } },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'DEFINITIONS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Reach: '
	              ),
	              'The number of unique people who saw your ad'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Impressions: '
	              ),
	              'The number of times an instance of your ad is on screen'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Frequency: '
	              ),
	              'The average number of times each person saw your ad'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Clicks - '
	              ),
	              'The number of clicks on links within the ad that led to destinations or experiences, on or off Facebook'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-10', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Post Engagements: '
	              ),
	              'The total number of actions that people take involving your ads while they\'re running. Actions can include clicking on a link, commenting on or sharing the ads, claiming an offer, viewing a photo or video.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'no-margin-bottom', style: { fontSize: '13px' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Engagement Rate: '
	              ),
	              'The percentage of times people saw your ad and performed either a link click, reaction, share, forward, or comment.'
	            )
	          )
	        );
	        return container;
	      }
	      return "";
	    }
	  }, {
	    key: 'downloadPdfReport',
	    value: function downloadPdfReport() {
	      this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
	      this.handlePdfDownload();
	    }
	  }, {
	    key: 'downloadCsvReport',
	    value: function downloadCsvReport() {
	      this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	      this.handleCsvDownload();
	    }
	  }, {
	    key: '_addPdfHeader',
	    value: function _addPdfHeader(pdf, client_name, bu_name, campaignDetail) {
	      pdf.setFillColor(127, 127, 127);
	      pdf.rect(0, 15, 210, 10, 'F');
	
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(9);
	      pdf.setFontType('bold');
	      pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), 'PNG', 10.5, 3, 60, 0);
	      pdf.text(198, 8, (0, _momentTimezone2.default)().format('MMMM DD, YYYY'), null, null, 'right');
	
	      pdf.setTextColor(255, 255, 255);
	      pdf.setFontType('bold');
	      pdf.text(12, 21, 'Client:');
	      //const lenClientName = getTextSize(client_name.trim(), 'helvetica') 
	      pdf.setFontType('normal');
	      pdf.text(26, 21, client_name ? client_name.trim() : "");
	      //cm to inches
	      var start = 90; //46 + lenClientName.width * 0.3937 + 0.4
	      if (!(0, _isEmpty2.default)(bu_name)) {
	        pdf.setFontType('bold');
	        pdf.text(start, 21, 'Business Unit:');
	        start += 26.5;
	        pdf.setFontType('normal');
	        pdf.text(start, 21, bu_name ? bu_name.trim() : '');
	      }
	      pdf.setFillColor(255);
	      start = 12;
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(10);
	      pdf.text(12, 30, 'Campaigns  >  ' + campaignDetail.name);
	    }
	  }, {
	    key: 'handlePdfDownload',
	    value: function handlePdfDownload() {
	      var _props = this.props,
	          clients = _props.clients,
	          client_info = _props.client_info,
	          channelCampaignId = _props.channelCampaignId,
	          campaignDetail = _props.campaignDetail,
	          segmentId = _props.segmentId;
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	      //const dateRangeStr = this.dateItem().filter((data)=>{return data.value === reportDateRange})[0].label;
	      var deployment = channelCampaignId === "aggregated" ? null : campaignDetail.socialDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var channelCampaignName = channelCampaignId === "aggregated" ? "Aggregated" : deployment.name;
	      var pdfFileName = campaignDetail.name + "_Facebook_";
	
	      if (channelCampaignName !== "Aggregated") {
	        if (segmentId === "aggregated") {
	          pdfFileName += "Segment_Aggregagte";
	        } else {
	          var emailCampaignDetail = (0, _find2.default)(deployment.channelCampaigns, function (campaign) {
	            return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
	          });
	          pdfFileName += emailCampaignDetail.name;
	        }
	      } else {
	        pdfFileName += "Deployment_Aggregate";
	      }
	
	      var pdf = new pdfConverter('p', 'mm', 'a4');
	      pdf.setFont("Helvetica");
	      pdf.setFontType("normal");
	      pdf.setFontSize(9);
	      var pageWidth = 186;
	
	      var el_selector_container = document.getElementsByClassName("selector-container")[0];
	      var el_campaign_top_link_container = document.getElementsByClassName("campaign-top-links-container")[0];
	      var el_campaign_top_link_stats_container = document.getElementsByClassName("top-links-stats")[0];
	      var el_campaign_top_location_stats_container = document.getElementsByClassName("top-location-stats")[0];
	
	      var el_campaign_graph = document.getElementsByClassName("campaign-graph-container")[0];
	      var el_campaign_stats = document.getElementsByClassName("campaign-stats-container")[0];
	      var el_email_campaign_detail = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? null : document.getElementsByClassName("email-campaign-detail-container")[0];
	
	      var canvasSelectorContainer = null;
	      var canvasTopLinkContainer = null;
	      var canvasGraph = null;
	      var canvasSummary = null;
	      var canvasEmailCampaignDetail = null;
	      var isCanvasSelectorReady = false;
	      var isCanvasTopLinkReady = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? true : false;
	      var isCanvasGraphReady = false;
	      var isCanvasSummaryReady = false;
	      var isCanvasEmailCampaignReady = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? true : false;
	      var oriWidth = el_campaign_graph.offsetWidth;
	      var oriTopLinkWidth = channelCampaignId === "aggregated" || segmentId && segmentId === "aggregated" ? 0 : el_campaign_top_link_container.offsetWidth;
	
	      document.getElementsByClassName("nav-btn-download-report")[0].style.display = "none";
	      document.getElementsByClassName("definition-container")[0].style.display = "block";
	      document.getElementsByClassName("tooltip-container")[0].style.display = "none";
	      if (document.getElementsByClassName("section-link").length > 0) document.getElementsByClassName("section-link")[0].style.display = "none";
	      var tableLinks = document.getElementsByClassName("agg-title-link");
	      var linkColor = null;
	      if (tableLinks.length > 0) {
	        linkColor = tableLinks[0].style.color;
	        (0, _forEach2.default)(tableLinks, function (el) {
	          el.style.color = "#000";
	        });
	      }
	
	      if (el_campaign_top_link_container) el_campaign_top_link_container.style.width = "1034px";
	      if (el_campaign_top_link_stats_container) el_campaign_top_link_stats_container.style.width = "507px";
	      if (el_campaign_top_location_stats_container) el_campaign_top_location_stats_container.style.width = "507px";
	
	      el_selector_container.style.width = "1024px";
	      el_campaign_graph.style.width = "1024px";
	      el_campaign_stats.style.width = "1024px";
	      if (el_email_campaign_detail) {
	        el_email_campaign_detail.style.width = "1024px";
	      }
	
	      setTimeout(function () {
	        html2canvas(el_selector_container, { logging: false }).then(function (canvas) {
	          canvasSelectorContainer = canvas;
	          isCanvasSelectorReady = true;
	          el_selector_container.style.width = oriWidth + 'px';
	        });
	      }, 50);
	      if (channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") {
	        setTimeout(function () {
	          html2canvas(el_campaign_top_link_container, { logging: false }).then(function (canvas) {
	            canvasTopLinkContainer = canvas;
	            isCanvasTopLinkReady = true;
	            el_campaign_top_link_container.style.width = oriTopLinkWidth + 'px';
	            if (el_campaign_top_link_stats_container) el_campaign_top_link_stats_container.style.width = oriTopLinkWidth / 2 - 10 + 'px';
	            if (el_campaign_top_location_stats_container) el_campaign_top_location_stats_container.style.width = oriTopLinkWidth / 2 - 10 + 'px';
	          });
	        }, 50);
	        setTimeout(function () {
	          html2canvas(el_email_campaign_detail, { logging: false }).then(function (canvas) {
	            canvasEmailCampaignDetail = canvas;
	            isCanvasEmailCampaignReady = true;
	            el_email_campaign_detail.style.width = oriWidth + 'px';
	          });
	        }, 50);
	      }
	
	      setTimeout(function () {
	        html2canvas(el_campaign_graph, { logging: false }).then(function (canvas) {
	          canvasGraph = canvas;
	          isCanvasGraphReady = true;
	          el_campaign_graph.style.width = oriWidth + 'px';
	        });
	      }, 50);
	      setTimeout(function () {
	        html2canvas(el_campaign_stats, { logging: false }).then(function (canvas) {
	          canvasSummary = canvas;
	          isCanvasSummaryReady = true;
	          el_campaign_stats.style.width = oriWidth + 'px';
	        });
	      }, 50);
	
	      var top = 37;
	      var left = 12;
	      var intervalId = setInterval(function () {
	        if (isCanvasTopLinkReady === false || isCanvasSummaryReady === false || isCanvasGraphReady === false || isCanvasEmailCampaignReady === false || isCanvasSelectorReady === false) {
	          console.log("PDF Generating...");
	        } else {
	          clearInterval(intervalId);
	          setTimeout(function () {
	            this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
	            top = 35;
	            pdf.addImage(canvasSelectorContainer.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            top += canvasSelectorContainer.height * pageWidth / canvasSelectorContainer.width + 3;
	            //pdf.addImage(canvasDatePicker.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            //top += (canvasDatePicker.height * pageWidth / canvasDatePicker.width);
	            if (channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") {
	              pdf.addImage(canvasEmailCampaignDetail.toDataURL(), "PNG", left, top, pageWidth, 0);
	              top += canvasEmailCampaignDetail.height * pageWidth / canvasEmailCampaignDetail.width + 3;
	            }
	            pdf.addImage(canvasGraph.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            top += canvasGraph.height * pageWidth / canvasGraph.width + 3;
	            pdf.addImage(canvasSummary.toDataURL(), 'PNG', left, top, pageWidth, 0);
	            if (channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") {
	              (0, _utility.addPdfFooter)(pdf);
	              pdf.addPage('a4', 'p');
	              this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
	              top = 35;
	              //top += (canvasSummary.height * pageWidth / canvasSummary.width) + 3;
	              pdf.addImage(canvasTopLinkContainer.toDataURL(), 'PNG', left - 2, top, pageWidth + 2, 0);
	            }
	            (0, _utility.addPdfFooter)(pdf);
	
	            document.getElementsByClassName("nav-btn-download-report")[0].style.display = "block";
	            document.getElementsByClassName("definition-container")[0].style.display = "none";
	            document.getElementsByClassName("tooltip-container")[0].style.display = "block";
	            if (document.getElementsByClassName("section-link").length > 0) document.getElementsByClassName("section-link")[0].style.display = "block";
	            if (tableLinks.length > 0) {
	              (0, _forEach2.default)(tableLinks, function (el) {
	                el.style.color = linkColor;
	              });
	            }
	            pdfFileName = pdfFileName.replace(new RegExp(' ', 'g'), '_') + "_" + (0, _momentTimezone2.default)().format("YYYYMMDD") + ".pdf";
	            pdf.save(pdfFileName);
	            this.setState({ onPdfReportDownload: false });
	          }.bind(this), 100);
	        }
	      }.bind(this), 50);
	    }
	  }, {
	    key: 'handleCsvDownload',
	    value: function handleCsvDownload() {
	      var _props2 = this.props,
	          clients = _props2.clients,
	          client_info = _props2.client_info,
	          channelCampaignId = _props2.channelCampaignId,
	          campaignDetail = _props2.campaignDetail,
	          reportDateRange = _props2.reportDateRange,
	          socialAggregatedReport = _props2.socialAggregatedReport,
	          socialAggregatedStats = _props2.socialAggregatedStats,
	          segmentId = _props2.segmentId;
	      var impressions = socialAggregatedStats.impressions,
	          fbclicks = socialAggregatedStats.fbclicks,
	          postengagements = socialAggregatedStats.postengagements,
	          engagementrate = socialAggregatedStats.engagementrate,
	          reach = socialAggregatedStats.reach,
	          frequency = socialAggregatedStats.frequency;
	
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	
	      var deployment = channelCampaignId === "aggregated" ? null : campaignDetail.socialDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var channelCampaignName = deployment ? deployment.name : "Aggregated";
	      var csvFileName = campaignDetail.name + "_Facebook_";
	      if (channelCampaignName !== "Aggregated") {
	        if (segmentId === "aggregated") {
	          csvFileName += "Segment_Aggregagte";
	        }
	      } else {
	        csvFileName += "Deployment_Aggregate";
	      }
	
	      var title_line = channelCampaignName === "Aggregated" ? 'AudienceAnywhere Aggregate Facebook Deployment Report  ,,,,,,,,\r\n' : segmentId && segmentId !== "aggregated" ? 'AudienceAnywhere Facebook Segment Campaign Report  ,,,,,,,,\r\n' : 'AudienceAnywhere Aggregate Facebook Segment Campaign Report  ,,,,,,,,\r\n';
	
	      var date_line = "Today's Date," + (0, _momentTimezone2.default)().format("MM/DD/YY") + ",,,,,,,\r\n";
	      var client_line = "Client," + client_name + ",,,,,,,\r\n";
	      var business_unit_line = (0, _isEmpty2.default)(bu_name) ? "" : "Business Unit," + bu_name + ",,,,,,,\r\n";
	      var date_filter_line = "Date Filter," + this.reportDateFilter(reportDateRange) + ",,,,,,,\r\n";
	      var split_line = ",,,,,,,,\r\n";
	      var campaign_group_name_line = "Campaign Group Name," + campaignDetail.name + ",,,,,,,\r\n";
	      if (channelCampaignName !== "Aggregated" && segmentId !== "aggregated") {
	        var socialCampaignDetail = (0, _find2.default)(deployment.channelCampaigns, function (campaign) {
	          return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
	        });
	        csvFileName += socialCampaignDetail.name;
	        var email_campaign_name = "Facebook Segment Name," + socialCampaignDetail.name + ",,,,,,,\r\n";
	        var email_campaign_status = "Facebook Segment Status," + socialCampaignDetail.status + ",,,,,,,\r\n";
	        var email_campaign_start_date = "Facebook Segment Start Date," + (0, _momentTimezone2.default)(socialCampaignDetail.startDate).format("MM/DD/YYYY") + ",,,,,,,\r\n";
	        var email_campaign_end_date = socialCampaignDetail.endDate ? "Facebook Segment End Date," + (0, _momentTimezone2.default)(socialCampaignDetail.endDate).format("MM/DD/YYYY") + ",,,,,,,\r\n" : "Facebook Segment End Date,,,,,,,,\r\n";
	        campaign_group_name_line += "Facebook Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
	        campaign_group_name_line += email_campaign_name;
	        campaign_group_name_line += email_campaign_status;
	        campaign_group_name_line += email_campaign_start_date;
	        campaign_group_name_line += email_campaign_end_date;
	        campaign_group_name_line += ",,,,,,,,\r\n";
	      } else {
	        if (channelCampaignName !== "Aggregated") {
	          campaign_group_name_line += "Facebook Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
	        }
	      }
	
	      var campaign_grouped_title = "Facebook Impressions and Clicks,,,,,,,,\r\n,";
	      var campaign_grouped_impressions_row = "Impressions,";
	      var campaign_grouped_click_row = "Clicks,";
	      var campaign_grouped_post_engagements_row = "Engagement Rate,";
	      if (socialAggregatedReport) {
	        socialAggregatedReport.forEach(function (data) {
	          campaign_grouped_title += data.time + ",";
	          campaign_grouped_impressions_row += !(0, _isUndefined2.default)(data.impressions) ? data.impressions + "," : ",";
	          campaign_grouped_click_row += !(0, _isUndefined2.default)(data.fbclicks) ? data.fbclicks + "," : ",";
	          campaign_grouped_post_engagements_row += !(0, _isUndefined2.default)(data.postengagements) ? data.postengagements + "," : ",";
	        });
	      }
	      campaign_grouped_title += "\r\n";
	      campaign_grouped_impressions_row += "\r\n";
	      campaign_grouped_click_row += "\r\n";
	      campaign_grouped_post_engagements_row += "\r\n";
	
	      var aggregated_email_campaign_stats_title = channelCampaignName === "Aggregated" ? "Aggregate Facebook Deployment Statistics,,,,,,,,\r\n" : segmentId && segmentId === "aggregated" ? "Aggregate Facebook Segment Statistics,,,,,,,,\r\n" : "Facebook Segment Statistics,,,,,,,,\r\n";
	      var stats_reach_row = segmentId && segmentId !== "aggregated" ? "Reach, " + reach + ",,,,,,,\r\n" : "";
	      var stats_impressions_row = "Impressions, " + impressions + ",,,,,,,\r\n";
	      var stats_frequency_row = segmentId && segmentId !== "aggregated" ? "Frequency, " + frequency.toLocaleString() + ",,,,,,,\r\n" : "";
	      var stats_clicks_row = "Clicks," + fbclicks + ",,,,,,,\r\n";
	      var stats_post_engagements_row = "Post Engagements," + postengagements + ",,,,,,,\r\n";
	      var stats_engagement_rate_row = engagementrate ? "Engagement Rate," + engagementrate.toLocaleString("en-US", { style: "percent", maximumFractionDigits: 2 }) + ",,,,,,,\r\n" : "Engagement Rate,,,,,,,,\r\n";
	
	      var definition_title = "Definitions,,,,,,,,\r\n";
	      var define_reach_line = segmentId && segmentId !== "aggregated" ? "Reach: The number of unique people who saw your ad ,,,,,,,,\r\n" : "";
	      var define_impressions_line = "Impressions: The number of times an instance of your ad is on screen ,,,,,,,,\r\n";
	      var define_frequency_line = segmentId && segmentId !== "aggregated" ? "Frequency: The average number of times each person saw your ad ,,,,,,,,\r\n" : "";
	      var define_clicks_line = '"Clicks (Link): The number of clicks on links within the ad that led to destinations or experiences, on or off Facebook ",,,,,,,,\r\n';
	      var define_post_engagement_line = '"Post Engagements: The total number of actions that people take involving your ads while they are running. Actions can include clicking on a link, commenting on or sharing ads, claiming an offer, viewing a photo or video",,,,,,,,\r\n';
	      var define_engagement_rate_line = '"Engagement Rate: The percentage of times people saw your ad and performed either a link click, reaction, shares, forward, or comment",,,,,,,,\r\n';
	
	      var resultString = title_line + date_line + client_line + business_unit_line + date_filter_line + split_line + campaign_group_name_line + split_line + campaign_grouped_title + campaign_grouped_impressions_row + campaign_grouped_click_row + campaign_grouped_post_engagements_row + split_line + aggregated_email_campaign_stats_title + stats_reach_row + stats_impressions_row + stats_frequency_row + stats_clicks_row + stats_post_engagements_row + stats_engagement_rate_row + split_line + split_line + definition_title + define_reach_line + define_impressions_line + define_frequency_line + define_clicks_line + define_post_engagement_line + define_engagement_rate_line + split_line;
	
	      if (channelCampaignName !== "Aggregated" || segmentId !== 'aggregated') {
	        resultString += ",,,,,,,,      \r\n";
	        resultString += "Top Location by Clicks,,,,,,,,\r\n";
	        if (this.props.topLocationOpensStats) {
	          (0, _map2.default)(this.props.topLocationOpensStats, function (stat) {
	            resultString += stat.state + "," + stat.clicks + ",,,,,,,\r\n";
	          });
	        }
	      }
	      csvFileName += "_" + (0, _momentTimezone2.default)().format("YYYYMMDD");
	      csvFileName = csvFileName.replace(new RegExp(' ', 'g'), '_');
	      (0, _utility.downLoadCSVFunc)(resultString, csvFileName);
	      setTimeout(function () {
	        this.setState({ onCsvReportDownload: false });
	      }.bind(this), 2000);
	    }
	  }, {
	    key: 'setChannelCampaignId',
	    value: function setChannelCampaignId(data) {
	      this.props.setChannelCampaignId(data);
	      var match = this.props.match;
	
	
	      if (data.value !== "aggregated") {
	        var deployment = (0, _find2.default)(this.props.campaignDetail.socialDeployments, function (deployment) {
	          return deployment.id === data.value;
	        });
	        if (deployment) {
	          var segmentList = [];
	          (0, _map2.default)(deployment.channelCampaigns, function (channelCampaign) {
	            segmentList.push({ value: channelCampaign.id, label: channelCampaign.name });
	          });
	          if (segmentList.length > 1) {
	            segmentList.unshift({ value: "aggregated", label: "Aggregate" });
	            this.props.setSegmentId({ value: "aggregated" });
	          } else {
	            this.props.setSegmentId({ value: segmentList[0].id });
	          }
	          this.setState({ emailSegmentList: segmentList });
	
	          this.props.getSocialChannelAggregatedReport(match.params.id, data.value, this.props.reportDateRange, segmentList[0].value);
	          this.props.getSocialChannelStatsAggregated(match.params.id, data.value, this.props.reportDateRange, segmentList[0].value);
	        }
	      } else {
	        this.props.getSocialChannelStatsAggregated(match.params.id, data.value, this.props.reportDateRange);
	        this.props.getSocialChannelAggregatedReport(match.params.id, data.value, this.props.reportDateRange);
	      }
	      this.props.history.push('/campaigns/report/' + match.params.id + '/social/' + data.value);
	    }
	  }, {
	    key: 'setSegmentId',
	    value: function setSegmentId(data) {
	      this.props.setSegmentId(data);
	    }
	  }, {
	    key: 'cbPDFChange',
	    value: function cbPDFChange(e, isInputChecked) {
	      var result = !this.refs.cbCSV.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: 'cbCSVChange',
	    value: function cbCSVChange(e, isInputChecked) {
	      var result = !this.refs.cbPDF.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          match = _props3.match,
	          campaignDetail = _props3.campaignDetail,
	          reportDateRange = _props3.reportDateRange,
	          socialAggregatedReport = _props3.socialAggregatedReport,
	          setReportDateRange = _props3.setReportDateRange,
	          client_info = _props3.client_info,
	          segmentId = _props3.segmentId;
	
	      var showTopLocationOpens = client_info && client_info.clientReportDetailSetting && client_info.clientReportDetailSetting.topLocationChannelReport === true;
	      var channelCampaignId = match.params.channelCampaignId;
	      var lineData = [];
	      if (socialAggregatedReport) {
	        socialAggregatedReport.forEach(function (data) {
	          lineData.push({ time: data.time, postengagements: data.postengagements, fbclicks: data.fbclicks,
	            impressions: data.impressions });
	        });
	      }
	      var tableSubTitle = "Date: ";
	      var tableSubTitleText = this.reportDateFilter(reportDateRange);
	      var crumbs = [];
	      var crumbsLink = [];
	      var channelCampaignDetail = channelCampaignId === "aggregated" || !campaignDetail ? null : campaignDetail.socialDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var segment = undefined;
	
	      if (campaignDetail && campaignDetail.socialDeployments) {
	        crumbs.push(campaignDetail.name);
	        crumbsLink.push('/campaigns/report/' + campaignDetail.id);
	        if (channelCampaignId === undefined || channelCampaignId === "aggregated") {
	          crumbs.push("Facebook Campaign: Aggregate");
	        } else {
	          (0, _map2.default)(campaignDetail.socialDeployments, function (dep) {
	            if (parseInt(dep.id, 10) === parseInt(channelCampaignId, 10)) {
	              if (segmentId) {
	                segment = (0, _find2.default)(dep.channelCampaigns, function (s) {
	                  return parseInt(s.id, 10) === parseInt(segmentId, 10);
	                });
	              }
	              crumbs.push("Facebook ");
	            }
	          });
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'campaign-report-container', style: { background: "#FFFFFF", fontSize: '16px' } },
	        _react2.default.createElement(_Title2.default, {
	          crumbs: crumbs,
	          crumbsLink: crumbsLink,
	          linkName: 'Campaigns', showDownloadBtn: true,
	          handleDownload: function handleDownload() {
	            _this3.setState({ showDownloadDialog: true });
	          },
	          selected_client: this.props.client_id
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'light-grey-border mt-20 selector-container' },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'pt-10, no-margin-bottom', style: { fontWeight: "bold", fontSize: '24px' } },
	            'Facebook Selection'
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'no-padding-top no-margin-bottom ' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3', className: 'no-padding-right' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Facebook Deployment'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(_reactSelect2.default, { className: 'campaign-selector left-10 z-index-199',
	                value: channelCampaignId ? channelCampaignId : (0, _isEmpty2.default)(this.state.emailCampaignList) ? "" : this.state.emailCampaignList.length > 1 ? "aggregated" : this.state.emailCampaignList[0].value,
	                clearable: false,
	                searchable: false,
	                options: this.state.emailCampaignList,
	                placeholder: "Select Campaign",
	                onChange: this.setChannelCampaignId.bind(this)
	              })
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '2', sm: '2', md: '2', lg: '2', className: 'no-padding' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Facebook Segment'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '4', sm: '4', md: '4', lg: '4' },
	              this.state.emailSegmentList.length > 0 && _react2.default.createElement(_reactSelect2.default, { className: 'campaign-selector left-10 z-index-199',
	                value: segmentId ? segmentId : this.state.emailSegmentList.length > 0 ? this.state.emailSegmentList[0].value : 0,
	                clearable: false,
	                searchable: false,
	                options: this.state.emailSegmentList,
	                placeholder: "Select Segment",
	                onChange: this.setSegmentId.bind(this)
	              })
	            )
	          ),
	          _react2.default.createElement('hr', { style: { margin: "-10px 20px 20px" } }),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'no-padding-top no-margin-bottom' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Date'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '3', sm: '3', md: '3', lg: '3' },
	              _react2.default.createElement(_reactSelect2.default, { className: 'report-date-selector left-10 z-index-198',
	                value: reportDateRange,
	                clearable: false,
	                searchable: false,
	                options: this.dateItem(),
	                placeholder: "Select Day",
	                onChange: setReportDateRange.bind(this)
	              })
	            )
	          )
	        ),
	        channelCampaignDetail && segmentId !== "aggregated" && _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'light-grey-border mt-20 no-margin-left no-margin-right no-padding mb-20 pr-10 email-campaign-detail-container' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'pl-10 mt-10', style: { fontSize: '24px', fontWeight: 'bold' } },
	            'Facebook Segment Details'
	          ),
	          _react2.default.createElement(
	            'table',
	            { style: { width: "98%", marginLeft: '10px' } },
	            _react2.default.createElement(
	              'thead',
	              { style: styles.tableHeaderStyle },
	              _react2.default.createElement(
	                'tr',
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '45%', paddingLeft: "20px" } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment Name'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '20%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment Status'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '18%' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment Start Date'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { style: { width: '17%', paddingRight: "20px", textAlign: 'right' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Segment End Date'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '45%', paddingLeft: "20px", paddingReft: "50px", wordBreak: "break-word" } },
	                  segment ? segment.name : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '20%' } },
	                  segment ? segment.status : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '18%' } },
	                  segment ? (0, _momentTimezone2.default)(segment.startDate).format("MM/DD/YY") : ""
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { style: { width: '17%', paddingRight: "20px", textAlign: 'right' } },
	                  segment && segment.endDate ? (0, _momentTimezone2.default)(segment.endDate).format("MM/DD/YY") : ""
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'light-grey-border no-margin-left no-margin-right no-padding mt-20 mb-20 pb-20 pr-20 pl-10 campaign-graph-container' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'pl-10', style: { fontSize: '24px', fontWeight: 'bold' } },
	            'Facebook - Impressions, Clicks, and Post Engagements'
	          ),
	          _react2.default.createElement(_LineGraphic2.default, { animation: false, key: 'line-section', dataNames: ["Impressions", "Clicks", "Post Engagements"], dataKeys: ['impressions', 'fbclicks', 'postengagements'],
	            title: '', data: lineData, subTitle: tableSubTitle, subTitleText: tableSubTitleText })
	        ),
	        this.statsList(this.props),
	        channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated" && _react2.default.createElement(
	          _Grid.FullRow,
	          { className: 'no-margin-right no-padding campaign-top-links-container' },
	          showTopLocationOpens && _react2.default.createElement(
	            _Grid.Col,
	            { xs: '6', sm: '6', md: '6', lg: '6', className: 'light-grey-border p-20 top-location-stats', style: { width: this.state.sectionWidth } },
	            this.topLocationStats(this.props)
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { open: this.state.onCsvReportDownload, style: { top: '-1.8em' }, modal: true, contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: '#666666' } },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'mt-20' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { offsetXs: '1', offsetSm: '1', offsetMd: '1', offsetLg: '1', xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
	              _react2.default.createElement(
	                'div',
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '1', sm: '1', md: '1', lg: '1' },
	              _react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { open: this.state.onPdfReportDownload, style: { top: '-1.8em' }, modal: true, contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: '#666666' } },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: 'mt-20' },
	            _react2.default.createElement(
	              _Grid.Col,
	              { offsetXs: '1', offsetSm: '1', offsetMd: '1', offsetLg: '1', xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
	              _react2.default.createElement(
	                'div',
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: '1', sm: '1', md: '1', lg: '1' },
	              _react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { open: this.state.showDownloadDialog, style: { top: '-1.8em' }, modal: true,
	            contentStyle: { width: "440px" } },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-margin-top no-padding', style: { fontSize: '16px', color: "#000" } },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Choose the type of file you would like to download'
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-padding-top no-padding-right no-padding-bottom no-margin-bottom',
	              style: { paddingLeft: "150px" } },
	            _react2.default.createElement(_Checkbox2.default, { iconStyle: { fill: "#47A1AB", marginRight: '10px' }, label: "PDF File", labelStyle: { fontSize: '13px' },
	              defaultChecked: false, ref: 'cbPDF', onCheck: function onCheck(e, isInputChecked) {
	                return _this3.cbPDFChange(e, isInputChecked);
	              } })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-padding-top no-padding-right no-padding-bottom', style: { paddingLeft: "150px" } },
	            _react2.default.createElement(_Checkbox2.default, { iconStyle: { fill: "#47A1AB", marginRight: '10px' }, label: "CSV File", labelStyle: { fontSize: '13px' },
	              defaultChecked: true, ref: 'cbCSV', onCheck: function onCheck(e, isInputChecked) {
	                return _this3.cbCSVChange(e, isInputChecked);
	              } })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: 'no-padding no-margin-bottom mt-20 text-center' },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onClick: function onClick() {
	                  return _this3.setState({ showDownloadDialog: false });
	                },
	                className: 'btn btn-default btn-aa-info mr-20' },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onClick: this.handleDownload.bind(this), disabled: this.state.disabledBtnDownload,
	                className: 'btn btn-default btn-aa-default' },
	              'Download File'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SocialChannelReport;
	}(_MaterialUI2.default);
	
	exports.default = SocialChannelReport;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Title = __webpack_require__(166);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Grid = __webpack_require__(19);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _utility = __webpack_require__(14);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _momentTimezone = __webpack_require__(110);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(220);
	
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	var styles = {
	  subHead: {
	    fontSize: "24px",
	    height: "18px",
	    lineHead: "18px",
	    fontWeight: "bold",
	    paddingLeft: "10px"
	  },
	  flextContainer: {
	    display: "flex",
	    borderBottom: "solid 1px #EEEFF2",
	    height: "16px",
	    lineHeight: "15px",
	    paddingBottom: "30px",
	    marginTop: "30px"
	  },
	  flexDataRow: {
	    display: "flex",
	    borderBottom: "solid 1px #EEEFF2",
	    height: "20px",
	    fontSize: "16px",
	    lineHeight: "18px",
	    paddingBottom: "35px",
	    marginTop: "15px"
	  },
	  urlCell: {
	    flex: "1 1",
	    whiteSpace: "nowrap",
	    textOverflow: "ellipsis",
	    overflow: "hidden",
	    height: "25px"
	  },
	  clickDataCell: {
	    flex: "0 0 120px",
	    textAlign: "center"
	  }
	};
	
	var TopLinksClick = function (_AcquireWebComponent) {
	  _inherits(TopLinksClick, _AcquireWebComponent);
	
	  function TopLinksClick(props) {
	    _classCallCheck(this, TopLinksClick);
	
	    var _this = _possibleConstructorReturn(this, (TopLinksClick.__proto__ || Object.getPrototypeOf(TopLinksClick)).call(this, props));
	
	    var list = [];
	
	    if (props.match && props.match.params) {
	      if (props.campaignDetail) {
	        var deployments = void 0;
	        switch (props.match.params.channelType) {
	          case "email":
	          default:
	            deployments = props.campaignDetail.emailDeployments;
	            break;
	          case "display":
	            deployments = props.campaignDetail.displayDeployments;
	        }
	        (0, _map2.default)(deployments, function (dep) {
	          if (parseInt(dep.id, 10) === parseInt(props.match.params.channelCampaignId, 10)) (0, _map2.default)(dep.channelCampaigns, function (campaign) {
	            list.push({ value: campaign.id, label: campaign.name });
	          });
	        });
	        _this.state = {
	          groupCampaignId: props.match.params.id,
	          channelCampaignList: list,
	          height: 0,
	          showDownloadDialog: false,
	          onPdfReportDownload: false,
	          disabledBtnDownload: false,
	          onCsvReportDownload: false
	        };
	        props.getCampaignTopLinkStats(props.match.params.id, props.match.params.segmentId, props.reportDateRange);
	        props.setChannelCampaignId({
	          value: props.match.params.channelCampaignId
	        });
	        props.setSegmentId(props.match.params.segmentId);
	      } else {
	        props.getCampaignById(props.match.params.id);
	        props.setChannelCampaignId({
	          value: props.match.params.channelCampaignId
	        });
	        props.setSegmentId(props.match.params.segmentId);
	        props.getCampaignTopLinkStats(props.match.params.id, props.match.params.segmentId, props.reportDateRange);
	        _this.state = {
	          groupCampaignId: undefined,
	          channelCampaignList: [],
	          height: 0,
	          showDownloadDialog: false,
	          onPdfReportDownload: false,
	          disabledBtnDownload: false,
	          onCsvReportDownload: false
	        };
	      }
	    }
	    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(TopLinksClick, [{
	    key: "updateWindowDimensions",
	    value: function updateWindowDimensions() {
	      this.setState({ height: window.innerHeight });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.getCampaignById(this.props.match.params.id);
	      this.props.setChannelCampaignId({
	        value: this.props.match.params.channelCampaignId
	      });
	      this.props.setSegmentId({ value: this.props.match.params.segmentId });
	      this.props.getCampaignTopLinkStats(this.props.match.params.id, this.props.match.params.segmentId, this.props.reportDateRange, "");
	      this.updateWindowDimensions();
	      window.addEventListener("resize", this.updateWindowDimensions);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateWindowDimensions);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!(0, _isEqual2.default)(nextProps.campaignDetail, this.props.campaignDetail)) {
	        var list = [];
	        var deployments = void 0;
	        switch (this.props.match.params.channelType) {
	          case "email":
	          default:
	            deployments = nextProps.campaignDetail.emailDeployments;
	            break;
	          case "display":
	            deployments = nextProps.campaignDetail.displayDeployments;
	        }
	        (0, _map2.default)(deployments, function (dep) {
	          if (parseInt(dep.id, 10) === parseInt(_this2.props.match.params.channelCampaignId, 10)) (0, _map2.default)(dep.channelCampaigns, function (campaign) {
	            list.push({ value: campaign.id, label: campaign.name });
	          });
	        });
	        this.setState({
	          channelCampaignList: list
	        });
	        if (nextProps.segmentId) {
	          this.props.getCampaignTopLinkStats(this.props.match.params.id, nextProps.segmentId, nextProps.reportDateRange, "");
	        } else {
	          this.props.getCampaignTopLinkStats(this.props.match.params.id, this.props.match.params.segmentId, nextProps.reportDateRange, "");
	        }
	      }
	      if (nextProps.reportDateRange !== this.props.reportDateRange) {
	        this.props.getCampaignTopLinkStats(this.props.match.params.id, this.props.match.params.segmentId, nextProps.reportDateRange, "");
	      }
	      if (nextProps.match && nextProps.match.params && nextProps.match.params.segmentId !== this.props.match.params.segmentId) {
	        this.props.getCampaignTopLinkStats(this.props.match.params.id, nextProps.match.params.segmentId, nextProps.reportDateRange, "");
	      }
	
	      if (nextProps.client_id !== this.props.client_id && this.props.client_id) {
	        this.props.history.push("/campaigns");
	      }
	    }
	  }, {
	    key: "dateItem",
	    value: function dateItem() {
	      return [{ value: "life-of-campaign", label: "Life of Campaign" }, { value: "yesterday", label: "Yesterday" }, { value: "today", label: "Today" }, { value: "last-7-days", label: "Last 7 Days" }, { value: "last-30-days", label: "Last 30 Days" }];
	    }
	  }, {
	    key: "reportDateFilter",
	    value: function reportDateFilter(dayRange) {
	      var result = "";
	      switch (dayRange) {
	        case "yesterday":
	          result = "Yesterday";
	          break;
	        case "today":
	          result = "Today";
	          break;
	        case "last-7-days":
	          result = "Last 7 Days";
	          break;
	        case "last-30-days":
	          result = "Last 30 Days";
	          break;
	        case "life-of-campaign":
	        default:
	          result = "Life of Campaign";
	          break;
	      }
	      return result;
	    }
	  }, {
	    key: "cbPDFChange",
	    value: function cbPDFChange(e, isInputChecked) {
	      var result = !this.refs.cbCSV.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: "cbCSVChange",
	    value: function cbCSVChange(e, isInputChecked) {
	      var result = !this.refs.cbPDF.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: "downloadCsvReport",
	    value: function downloadCsvReport() {
	      this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	      this.handleCsvDownload();
	    }
	  }, {
	    key: "downloadPdfReport",
	    value: function downloadPdfReport() {
	      this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
	      this.handlePdfDownload();
	    }
	  }, {
	    key: "handleCsvDownload",
	    value: function handleCsvDownload() {
	      var _props = this.props,
	          clients = _props.clients,
	          client_info = _props.client_info,
	          campaignDetail = _props.campaignDetail,
	          reportDateRange = _props.reportDateRange,
	          channelCampaignId = _props.channelCampaignId;
	      var segmentId = this.props.match.params.segmentId;
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return c.id === client_info.parentClientId;
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	
	      var channelType = this.props.match.params.channelType.charAt(0).toUpperCase() + this.props.match.params.channelType.slice(1);
	      var channelCampaigns = channelType === "Email" ? campaignDetail.emailDeployments : campaignDetail.displayDeployments;
	      var deployment = channelType.toLowerCase() === "display" ? campaignDetail.displayDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0] : campaignDetail.emailDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	
	      var channelPrix = channelType === "Display" ? "Google Ads" : channelType;
	      var report_sub_title = "_" + channelPrix + "_Campaign_Report_";
	      var channelCampaignName = deployment ? deployment.name : "Aggregated";
	
	      var csvFileName = channelType === "Email" ? campaignDetail.name + "_Email_" : campaignDetail.name + "_GoogleAds_";
	
	      if (channelCampaignName !== "Aggregated") {
	        if (segmentId === "aggregated") {
	          csvFileName += "Segment_Aggregagted";
	        } else {
	          var _emailCampaignDetail = (0, _find2.default)(deployment.channelCampaigns, function (campaign) {
	            return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
	          });
	          csvFileName += _emailCampaignDetail.name;
	        }
	      } else {
	        csvFileName += "Deployment_Aggregate";
	      }
	      csvFileName += "_Top_Links_";
	      var title_line = "AudienceAnywhere " + channelPrix + " Segment Campaign Report,\r\n";
	      var date_line = "Today's Date," + (0, _momentTimezone2.default)().format("MM/DD/YY") + "\r\n";
	      var client_line = "Client," + client_name + "\r\n";
	      var business_unit_line = "Business Unit," + bu_name + "\r\n";
	      var date_filter_line = "Date Filter," + this.reportDateFilter(reportDateRange) + "\r\n";
	      var split_line = ",\r\n";
	      var emailCampaignDetail = (0, _find2.default)(deployment.channelCampaigns, function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
	      });
	      var campaign_group_name_line = "Campaign Group Name," + campaignDetail.name + ",,,,,,,\r\n";
	
	      var email_campaign_name = channelType === "Email" ? "Email Segment Name," + emailCampaignDetail.name + ",,,,,,,\r\n" : "Google Ads Segment Name," + emailCampaignDetail.name + ",,,,,,,\r\n";
	      var email_campaign_status = "Status," + emailCampaignDetail.status + ",,,,,,,\r\n";
	      var email_campaign_start_date = "Start Date," + (0, _momentTimezone2.default)(emailCampaignDetail.startDate).format("MM/DD/YYYY") + ",,,,,,,\r\n";
	      var email_campaign_end_date = emailCampaignDetail.endDate ? "End Date," + (0, _momentTimezone2.default)(emailCampaignDetail.endDate).format("MM/DD/YYYY") + ",,,,,,,\r\n" : "End Date,,,,,,,,\r\n";
	      if (channelType === "Email") campaign_group_name_line += "Email Deployment Name," + channelCampaignName + ",,,,,,,\r\n";else campaign_group_name_line += "Google Ads Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
	
	      campaign_group_name_line += email_campaign_name;
	      campaign_group_name_line += email_campaign_status;
	      campaign_group_name_line += email_campaign_start_date;
	      campaign_group_name_line += email_campaign_end_date;
	      campaign_group_name_line += ",,,,,,,,\r\n";
	
	      var top_links_title = ",\r\n,\r\nTop Links Clicked,\r\n";
	      //const top_links_table_head = 'Link,Pct. Clicked\r\n';
	      var top_links_table_head = "Link,Total Clicks, Unique Clicks\r\n";
	      var top_links_table_rows = "";
	      (0, _map2.default)(this.props.topLinkStats, function (stat) {
	        top_links_table_rows += stat.linkurl + "," + stat.clicks + "," + stat.uniqueclicks + "\r\n";
	        //stat.clickrate.toLocaleString("en-US",{ style:"percent", maximumFractionDigits: 2 }) + "\r\n";
	      });
	      var resultString = title_line + date_line + client_line + business_unit_line + date_filter_line + split_line + campaign_group_name_line + top_links_title + top_links_table_head + top_links_table_rows;
	
	      csvFileName += (0, _momentTimezone2.default)().format("YYYYMMDD");
	      csvFileName = csvFileName.replace(new RegExp(" ", "g"), "_");
	      (0, _utility.downLoadCSVFunc)(resultString, csvFileName);
	      setTimeout(function () {
	        this.setState({ onCsvReportDownload: false });
	      }.bind(this), 2000);
	    }
	  }, {
	    key: "handlePdfDownload",
	    value: function handlePdfDownload() {
	      var _props2 = this.props,
	          clients = _props2.clients,
	          client_info = _props2.client_info,
	          campaignDetail = _props2.campaignDetail,
	          channelCampaignId = _props2.channelCampaignId,
	          reportDateRange = _props2.reportDateRange;
	      var segmentId = this.props.match.params.segmentId;
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	
	      var channelType = this.props.match.params.channelType.charAt(0).toUpperCase() + this.props.match.params.channelType.slice(1);
	
	      var deployment = channelCampaignId === "aggregated" ? null : channelType.toLowerCase() === "display" ? campaignDetail.displayDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0] : campaignDetail.emailDeployments.filter(function (campaign) {
	        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10);
	      })[0];
	      var channelCampaignName = channelCampaignId === "aggregated" ? "Aggregated" : deployment.name;
	
	      var pdfFileName = channelType === "Email" ? campaignDetail.name + "_Email_" : campaignDetail.name + "_GoogleAds_";
	
	      if (channelCampaignName !== "Aggregated") {
	        if (segmentId === "aggregated") {
	          pdfFileName += "Segment_Aggregagted";
	        } else {
	          var emailCampaignDetail = (0, _find2.default)(deployment.channelCampaigns, function (campaign) {
	            return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
	          });
	          pdfFileName += emailCampaignDetail.name;
	        }
	      } else {
	        pdfFileName += "Deployment_Aggregate";
	      }
	      pdfFileName += "_Top_Links_";
	      var pdf = new pdfConverter("p", "mm", "a4");
	      pdf.setFont("Helvetica");
	      pdf.setFontType("normal");
	      pdf.setFontSize(9);
	      var pageWidth = 186;
	
	      var el_campaign_list = document.getElementsByClassName("top-links-list-container")[0];
	      var el_campaign_detail = document.getElementsByClassName("email-campaign-detail-container")[0];
	      var el_select_control = document.getElementsByClassName("Select-control")[1];
	      var el_select_arrow = document.getElementsByClassName("Select-arrow")[1];
	      var el_top_links = document.getElementsByClassName("top-link-url");
	      (0, _map2.default)(el_top_links, function (link) {
	        link.style["word-break"] = "break-all";
	        link.style["white-space"] = "unset";
	      });
	
	      var canvasList = null;
	      var isCanvasListReady = false;
	      var canvasDetail = null;
	      var isCanvasDetailReady = false;
	      var oriWidth = el_campaign_list.offsetWidth;
	      document.getElementsByClassName("nav-btn-download-report")[0].style.display = "none";
	
	      el_campaign_list.style.width = "1024px";
	      el_campaign_detail.style.width = "1024px";
	      el_select_control.style["border"] = "solid 0px #D3D3D3";
	      el_select_control.style["margin-left"] = "-10px";
	      el_select_arrow.style["border-style"] = "none";
	
	      setTimeout(function () {
	        html2canvas(el_campaign_list, { logging: false }).then(function (canvas) {
	          canvasList = canvas;
	          isCanvasListReady = true;
	          el_campaign_list.style.width = oriWidth + "px";
	        });
	      }, 100);
	
	      setTimeout(function () {
	        html2canvas(el_campaign_detail, { logging: false }).then(function (canvas) {
	          canvasDetail = canvas;
	          isCanvasDetailReady = true;
	          el_campaign_detail.style.width = oriWidth + "px";
	          el_select_control.style.border = "solid 1px #D3D3D3";
	          el_select_control.style["margin-left"] = "0px";
	          el_select_arrow.style["border-style"] = "solid";
	
	          (0, _map2.default)(el_top_links, function (link) {
	            link.style["white-space"] = "nowrap";
	          });
	        });
	      }, 100);
	
	      var top = 37;
	      var left = 12;
	      var intervalId = setInterval(function () {
	        if (isCanvasListReady === false || isCanvasDetailReady === false) {
	          console.log("PDF Generating...");
	        } else {
	          clearInterval(intervalId);
	          setTimeout(function () {
	            pdf.setFillColor(127, 127, 127);
	            pdf.rect(0, 15, 210, 10, "F");
	
	            pdf.setTextColor(0, 0, 0);
	            pdf.setFontSize(9);
	            pdf.setFontType("bold");
	            pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), "PNG", 10.5, 3, 60, 0);
	            pdf.text(198, 8, (0, _momentTimezone2.default)().format("MMMM DD, YYYY"), null, null, "right");
	
	            pdf.setTextColor(255, 255, 255);
	            pdf.setFontType("bold");
	            pdf.text(12, 21, "Client:");
	            //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
	            pdf.setFontType("normal");
	            pdf.text(26, 21, client_name ? client_name.trim() : "");
	            //cm to inches
	            var start = 90; //46 + lenClientName.width * 0.3937 + 0.4
	            if (!(0, _isEmpty2.default)(bu_name)) {
	              pdf.setFontType("bold");
	              pdf.text(start, 21, "Business Unit:");
	              start += 26.5;
	              pdf.setFontType("normal");
	              pdf.text(start, 21, bu_name ? bu_name.trim() : "");
	            }
	            pdf.setFillColor(255);
	            start = 12;
	            pdf.setTextColor(0, 0, 0);
	            pdf.setFontSize(10);
	            var navText = channelType === "Email" ? "Campaigns  >  " + campaignDetail.name + "  >   " + "Email  " + " > Email Top Links Clicked" : "Campaigns  >  " + campaignDetail.name + "  >   " + "Google Ads " + " > Google Ads Top Links Clicked";
	            pdf.text(12, 34, navText);
	
	            top = 50;
	            pdf.addImage(canvasDetail.toDataURL(), "PNG", left, top, pageWidth, 0);
	            top += canvasDetail.height * pageWidth / canvasDetail.width + 4;
	            pdf.addImage(canvasList.toDataURL(), "PNG", left, top, pageWidth, 0);
	            top += canvasList.height * pageWidth / canvasList.width + 4;
	            (0, _utility.addPdfFooter)(pdf);
	
	            document.getElementsByClassName("nav-btn-download-report")[0].style.display = "block";
	
	            pdfFileName = pdfFileName.replace(new RegExp(" ", "g"), "_") + (0, _momentTimezone2.default)().format("YYYYMMDD") + ".pdf";
	            pdf.save(pdfFileName);
	            this.setState({ onPdfReportDownload: false });
	          }.bind(this), 100);
	        }
	      }.bind(this), 50);
	    }
	  }, {
	    key: "handleDownload",
	    value: function handleDownload(e) {
	      e.preventDefault();
	
	      if (this.refs.cbPDF.state.switched) {
	        this.downloadPdfReport();
	      }
	
	      if (this.refs.cbCSV.state.switched) {
	        this.downloadCsvReport();
	      }
	    }
	  }, {
	    key: "onChangeSegment",
	    value: function onChangeSegment(data) {
	      this.props.setSegmentId(data);
	      this.props.history.push("/campaigns/report/" + this.props.match.params.id + "/email/" + this.props.match.params.channelCampaignId + "/" + data.value + "/top-links-click");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          channelCampaignId = _props3.channelCampaignId,
	          campaignDetail = _props3.campaignDetail,
	          reportDateRange = _props3.reportDateRange,
	          topLinkStats = _props3.topLinkStats,
	          setReportDateRange = _props3.setReportDateRange,
	          loadingTopLinkStats = _props3.loadingTopLinkStats;
	
	      var crumbs = [];
	      var crumbsLink = [];
	      var channelCampaigns = void 0;
	      //let channelCampaignTitle = "";
	      var showUniqClicks = true;
	      var deploymentName = "";
	      var selectSegment = this.props.match ? (0, _find2.default)(this.state.channelCampaignList, function (segment) {
	        return segment.value == _this3.props.match.params.segmentId;
	      }) : undefined;
	
	      switch (this.props.match.params.channelType) {
	        case "email":
	        default:
	          channelCampaigns = campaignDetail ? campaignDetail.emailDeployments : null;
	          //channelCampaignTitle = "Email Segment Name";
	          showUniqClicks = true;
	          break;
	        case "display":
	          channelCampaigns = campaignDetail ? campaignDetail.displayDeployments : null;
	          //channelCampaignTitle = "Google Ads Campaign";
	          showUniqClicks = false;
	          break;
	      }
	      if (channelCampaigns) {
	        crumbs.push(campaignDetail.name);
	        crumbsLink.push("/campaigns/report/" + campaignDetail.id);
	        if (channelCampaignId === undefined || channelCampaignId === "aggregated") {
	          crumbs.push("Email Deployment: Aggregate");
	        } else {
	          (0, _map2.default)(channelCampaigns, function (campaign) {
	            if (parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10)) {
	              switch (_this3.props.match.params.channelType) {
	                case "email":
	                  crumbs.push("Email ");
	                  deploymentName = campaignDetail.name;
	                  crumbsLink.push("/campaigns/report/" + campaignDetail.id + "/email/" + _this3.props.match.params.channelCampaignId);
	                  crumbs.push("Email Top Links Clicked");
	                  break;
	                case "display":
	                default:
	                  crumbs.push("Google Ads ");
	                  deploymentName = campaignDetail.name;
	                  crumbsLink.push("/campaigns/report/" + campaignDetail.id + "/display/" + _this3.props.match.params.channelCampaignId);
	                  crumbs.push("Google Ads Top Links Clicked");
	                  break;
	              }
	            }
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "campaign-report-container",
	          style: { background: "#FFFFFF", fontFamily: "Arial" }
	        },
	        _react2.default.createElement(_Title2.default, {
	          crumbs: crumbs,
	          crumbsLink: crumbsLink,
	          linkName: "Campaigns",
	          showDownloadBtn: true,
	          handleDownload: function handleDownload() {
	            _this3.setState({ showDownloadDialog: true });
	          },
	          selected_client: this.props.client_id
	        }),
	        _react2.default.createElement(
	          _Grid.FullRow,
	          { className: "light-grey-border mt-20 no-margin-left no-margin-right no-padding-left no-padding-top mb-20 pr-10 email-campaign-detail-container" },
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "pl-10 mt-10",
	              style: { fontSize: "24px", fontWeight: "bold" }
	            },
	            showUniqClicks ? "Email Selection" : "Google Ads Selection"
	          ),
	          _react2.default.createElement(
	            "table",
	            { style: { width: "98%", marginLeft: "10px" } },
	            _react2.default.createElement(
	              "thead",
	              { style: styles.tableHeaderStyle },
	              _react2.default.createElement(
	                "tr",
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  "th",
	                  { style: { width: "40%", paddingLeft: "20px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    showUniqClicks ? "Email Deployment" : "Google Ads Deployment"
	                  )
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    showUniqClicks ? "Email Segment" : "Google Ads Segment"
	                  )
	                ),
	                _react2.default.createElement(
	                  "th",
	                  { style: { paddingRight: "20px", width: "200px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Date"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(
	                "tr",
	                { style: { height: "60px" } },
	                _react2.default.createElement(
	                  "td",
	                  {
	                    style: {
	                      width: "40%",
	                      paddingLeft: "20px",
	                      paddingRight: "50px",
	                      wordBreak: "break-word"
	                    }
	                  },
	                  deploymentName
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    style: {
	                      wordBreak: "break-word",
	                      overflowWrap: "break-word",
	                      paddingRight: "20px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    selectSegment ? selectSegment.label : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { style: { paddingRight: "20px", minWidth: "200px" } },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    className: "top-link-report-date-selector left-10 z-index-199",
	                    value: reportDateRange,
	                    clearable: false,
	                    searchable: false,
	                    options: this.dateItem(),
	                    placeholder: "Select Day",
	                    onChange: setReportDateRange.bind(this)
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.FullRow,
	          {
	            className: "light-grey-border no-margin-left no-margin-right pr-10 pt-10 no-padding-left pb-20 top-links-list-container",
	            style: {
	              /*minHeight: this.state.height ? this.state.height - 200 : 250,*/fontSize: "16px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: styles.subHead },
	            showUniqClicks ? "Email" : "Google Ads",
	            " Top Links Clicked"
	          ),
	          _react2.default.createElement(
	            "table",
	            {
	              style: {
	                width: "98%",
	                marginLeft: "10px",
	                marginTop: "40px",
	                tableLayout: "fixed"
	              }
	            },
	            _react2.default.createElement(
	              "thead",
	              { style: styles.tableHeaderStyle },
	              _react2.default.createElement(
	                "tr",
	                { style: { height: "42px" } },
	                _react2.default.createElement(
	                  "th",
	                  { style: { width: "72%", paddingLeft: "20px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Top Links"
	                  )
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Total Clicks"
	                  )
	                ),
	                _react2.default.createElement(
	                  "th",
	                  { style: { width: "120px", paddingRight: "20px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Unique Clicks"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              (0, _map2.default)(topLinkStats, function (stat) {
	                return _react2.default.createElement(
	                  "tr",
	                  { key: "row-" + stat.linkurl, style: { height: "42px" } },
	                  _react2.default.createElement(
	                    "td",
	                    {
	                      style: {
	                        width: "72%",
	                        paddingLeft: "20px",
	                        paddingRight: "50px",
	                        whiteSpace: "nowrap",
	                        textOverflow: "ellipsis",
	                        overflow: "hidden",
	                        dispaly: "block"
	                      },
	                      className: "top-link-url"
	                    },
	                    _react2.default.createElement(
	                      "a",
	                      { href: stat.linkurl, target: "_blank" },
	                      stat.linkurl
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    stat.clicks
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    {
	                      style: {
	                        width: "117px",
	                        paddingRight: "20px",
	                        textAlign: "right"
	                      }
	                    },
	                    stat.uniqueclicks
	                  )
	                );
	              }),
	              (0, _isEmpty2.default)(topLinkStats) && loadingTopLinkStats !== true && _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "td",
	                  { colSpan: "3" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "pt-20 pb-20",
	                      style: {
	                        textAlign: "center",
	                        fontSize: "2em",
	                        color: "#CCCCCC"
	                      }
	                    },
	                    "No Data"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.onCsvReportDownload,
	            style: { top: "-1.8em" },
	            modal: true,
	            contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: "#666666" }
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "mt-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                offsetXs: "1",
	                offsetSm: "1",
	                offsetMd: "1",
	                offsetLg: "1",
	                xs: "7",
	                sm: "7",
	                md: "7",
	                lg: "7",
	                className: "text-right"
	              },
	              _react2.default.createElement(
	                "div",
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "1", sm: "1", md: "1", lg: "1" },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.onPdfReportDownload,
	            style: { top: "-1.8em" },
	            modal: true,
	            contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: "#666666" }
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "mt-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                offsetXs: "1",
	                offsetSm: "1",
	                offsetMd: "1",
	                offsetLg: "1",
	                xs: "7",
	                sm: "7",
	                md: "7",
	                lg: "7",
	                className: "text-right"
	              },
	              _react2.default.createElement(
	                "div",
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "1", sm: "1", md: "1", lg: "1" },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.showDownloadDialog,
	            style: { top: "-1.8em" },
	            modal: true,
	            contentStyle: { width: "440px" }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-margin-top no-padding",
	              style: { fontSize: "16px", color: "#000" }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Choose the type of file you would like to download"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-padding-top no-padding-right no-padding-bottom no-margin-bottom",
	              style: { paddingLeft: "150px" }
	            },
	            _react2.default.createElement(_Checkbox2.default, {
	              iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	              label: "PDF File",
	              labelStyle: { fontSize: "13px" },
	              defaultChecked: false,
	              ref: "cbPDF",
	              onCheck: function onCheck(e, isInputChecked) {
	                return _this3.cbPDFChange(e, isInputChecked);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-padding-top no-padding-right no-padding-bottom",
	              style: { paddingLeft: "150px" }
	            },
	            _react2.default.createElement(_Checkbox2.default, {
	              iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	              label: "CSV File",
	              labelStyle: { fontSize: "13px" },
	              defaultChecked: true,
	              ref: "cbCSV",
	              onCheck: function onCheck(e, isInputChecked) {
	                return _this3.cbCSVChange(e, isInputChecked);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding no-margin-bottom mt-20 text-center" },
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                onClick: function onClick() {
	                  return _this3.setState({ showDownloadDialog: false });
	                },
	                className: "btn btn-default btn-aa-info mr-20"
	              },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                onClick: this.handleDownload.bind(this),
	                disabled: this.state.disabledBtnDownload,
	                className: "btn btn-default btn-aa-default"
	              },
	              "Download File"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TopLinksClick;
	}(_MaterialUI2.default);
	
	exports.default = TopLinksClick;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Title = __webpack_require__(166);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Grid = __webpack_require__(19);
	
	var _LineGraphic = __webpack_require__(256);
	
	var _LineGraphic2 = _interopRequireDefault(_LineGraphic);
	
	var _AggregatedTable = __webpack_require__(1064);
	
	var _AggregatedTable2 = _interopRequireDefault(_AggregatedTable);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _forEach = __webpack_require__(185);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _utility = __webpack_require__(14);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _momentTimezone = __webpack_require__(110);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(220);
	
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	var styles = {
		tableHeaderStyle: {
			border: 'none',
			background: '#F5F5F5',
			fontSize: '12px',
			fontWeight: "bold"
		}
	};
	
	var CampaignReport = function (_AcquireWebComponent) {
		_inherits(CampaignReport, _AcquireWebComponent);
	
		function CampaignReport(props) {
			_classCallCheck(this, CampaignReport);
	
			var _this = _possibleConstructorReturn(this, (CampaignReport.__proto__ || Object.getPrototypeOf(CampaignReport)).call(this, props));
	
			_this.state = {
				showDownloadDialog: false,
				onPdfReportDownload: false,
				onCsvReportDownload: false,
				disabledBtnDownload: false
			};
			return _this;
		}
	
		_createClass(CampaignReport, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var match = this.props.match;
	
				if (match && match.params) {
					this.props.getCampaignById(match.params.id);
					this.props.setReportDateRange("life-of-campaign");
					this.props.getCampaignGroupAggregated(match.params.id, "life-of-campaign");
					this.props.getCampaignChannelAggregated(match.params.id, "life-of-campaign");
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.client_tz && nextProps.client_tz !== this.props.client_tz) {
					_momentTimezone2.default.tz.setDefault(nextProps.client_tz);
				}
	
				if (nextProps.reportDateRange && nextProps.reportDateRange !== this.props.reportDateRange) {
					this.props.getCampaignGroupAggregated(nextProps.match.params.id, nextProps.reportDateRange);
					this.props.getCampaignChannelAggregated(nextProps.match.params.id, nextProps.reportDateRange);
				}
	
				if (nextProps.campaignDetail !== this.props.campaignDetail && nextProps.campaignDetail) {
					if (nextProps.campaignDetail.clientId !== this.props.client_id) {
						this.props.selectClient(nextProps.campaignDetail.clientId);
					}
				}
	
				if (nextProps.client_id !== this.props.client_id && this.props.client_id) {
					this.props.selectClient(nextProps.client_id);
				}
			}
		}, {
			key: 'dateItem',
			value: function dateItem() {
				return [{ value: "life-of-campaign", label: "Life of Campaign" }, { value: "yesterday", label: "Yesterday" }, { value: "today", label: "Today" }, { value: "last-7-days", label: "Last 7 Days" }, { value: "last-30-days", label: "Last 30 Days" }];
			}
		}, {
			key: 'downloadCsvReport',
			value: function downloadCsvReport() {
				this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
				this.handleCsvDownload();
			}
		}, {
			key: 'downloadPdfReport',
			value: function downloadPdfReport() {
				this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
				this.handlePdfDownload();
			}
		}, {
			key: 'isReportWithChannel',
			value: function isReportWithChannel(data) {
				var emailCount = (0, _find2.default)(data, { channel: "Email" });
				var socialCount = (0, _find2.default)(data, { channel: "Social" });
				var displayCount = (0, _find2.default)(data, { channel: "Display" });
				return !(0, _isEmpty2.default)(emailCount) || !(0, _isEmpty2.default)(socialCount) || !(0, _isEmpty2.default)(displayCount);
			}
		}, {
			key: 'handleCsvDownload',
			value: function handleCsvDownload() {
				var _props = this.props,
				    clients = _props.clients,
				    client_info = _props.client_info,
				    campaignDetail = _props.campaignDetail,
				    reportDateRange = _props.reportDateRange,
				    campaignAggregatedReport = _props.campaignAggregatedReport,
				    campaignChannelAggregatedReport = _props.campaignChannelAggregatedReport;
	
				var client_name = client_info.name;
				var bu_name = "";
				if (client_info.parentClientId) {
					var parent_client = (0, _find2.default)(clients, function (c) {
						return c.id === client_info.parentClientId;
					});
					if (parent_client) {
						client_name = parent_client.name;
						bu_name = client_info.name;
					}
				}
				var report_sub_title = this.isReportWithChannel(campaignChannelAggregatedReport) ? "_Aggregate_Campaign_Report_WithChannel_" : "_Aggregate_Campaign_Report_";
	
				var csvFileName = bu_name === "" ? client_name + report_sub_title + campaignDetail.name : bu_name + report_sub_title + campaignDetail.name;
	
				var title_line = 'AudienceAnywhere Aggregate Campaign Report  ,,,,,,,,\r\n';
				var date_line = "Today's Date," + (0, _momentTimezone2.default)().format("MM/DD/YY") + ",,,,,,,\r\n";
				var client_line = "Client," + client_name + ",,,,,,,\r\n";
				var business_unit_line = (0, _isEmpty2.default)(bu_name) ? "" : "Business Unit," + bu_name + ",,,,,,,\r\n";
				var date_filter_line = "Date Filter," + this.reportDateFilter(reportDateRange) + ",,,,,,,\r\n";
				var split_line = ",,,,,,,,\r\n";
				var campaign_group_name_line = "Campaign Group Name," + campaignDetail.name + ",,,,,,,\r\n";
				var campaign_group_id_line = "Campaign Group ID," + campaignDetail.campaignId + ",,,,,,,\r\n";
				var client_campaign_id_line = "Client Campaign ID," + campaignDetail.clientCampaignId + ",,,,,,,\r\n";
				var campaign_group_status_line = "Campaign Group Status," + campaignDetail.status + ",,,,,,,\r\n";
				var campaign_group_start_date = "Campaign Group Start Date," + (0, _momentTimezone2.default)(campaignDetail.startDate).format("MM/DD/YY") + ",,,,,,,\r\n";
				var campaign_group_end_date = "Campaign Group End Date," + (0, _momentTimezone2.default)(campaignDetail.endDate).format("MM/DD/YY") + ",,,,,,,\r\n";
	
				var aggregate_table_tile_line = ",";
				var aggregate_table_messages_line = "Messages,";
				var aggregate_table_engagement_line = "Engagement,";
				if (campaignAggregatedReport) {
					campaignAggregatedReport.forEach(function (data) {
						aggregate_table_tile_line += data.time + ",";
						aggregate_table_messages_line += data.messages + ",";
						aggregate_table_engagement_line += data.engagement + ",";
					});
				}
				aggregate_table_tile_line += "\r\n";
				aggregate_table_messages_line += "\r\n";
				aggregate_table_engagement_line += "\r\n";
	
				var total_activity_line = "Total Activity,";
				var total_messages_line = "Messages,";
				var total_engagement_line = "Engagement,";
				if (campaignChannelAggregatedReport) {
					campaignChannelAggregatedReport.forEach(function (data) {
						var channel = data.channel.charAt(0).toUpperCase() + data.channel.substr(1);
						total_activity_line += channel + ",";
						total_messages_line += data.messages + ",";
						total_engagement_line += data.engagement + ",";
					});
				}
				total_activity_line += "\r\n";
				total_messages_line += "\r\n";
				total_engagement_line += "\r\n";
	
				var messages_definition_line = "Messages: The total number of marketing messages delivered across all channels to the respective audience.,,,,,,,,\r\n";
				//const engagement_definition_line = "Engagement: The number of times a user takes action within the message delivered; e.g. clicks,,,,,,,,\r\n";
				var engagement_definition_line = "Any type of measured activitiy taken by the user against a delivered ad or email. This includes clicks, comments, shares, likes, video views....\r\n";
				var resultString = title_line + date_line + client_line + business_unit_line + date_filter_line + split_line + campaign_group_name_line + campaign_group_id_line + client_campaign_id_line + campaign_group_status_line + campaign_group_start_date + campaign_group_end_date + split_line + aggregate_table_tile_line + aggregate_table_messages_line + aggregate_table_engagement_line + split_line + total_activity_line + total_messages_line + total_engagement_line + split_line + messages_definition_line + engagement_definition_line;
	
				csvFileName += "_" + this.reportDateFilter(reportDateRange);
				csvFileName = csvFileName.replace(new RegExp(' ', 'g'), '_');
				(0, _utility.downLoadCSVFunc)(resultString, csvFileName);
				setTimeout(function () {
					this.setState({ onCsvReportDownload: false });
				}.bind(this), 2000);
			}
		}, {
			key: 'handlePdfDownload',
			value: function handlePdfDownload() {
				var _props2 = this.props,
				    clients = _props2.clients,
				    client_info = _props2.client_info,
				    campaignDetail = _props2.campaignDetail,
				    campaignChannelAggregatedReport = _props2.campaignChannelAggregatedReport;
	
				var client_name = client_info.name;
				var bu_name = "";
				if (client_info.parentClientId) {
					var parent_client = (0, _find2.default)(clients, function (c) {
						return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
					});
					if (parent_client) {
						client_name = parent_client.name;
						bu_name = client_info.name;
					}
				}
	
				var report_sub_title = this.isReportWithChannel(campaignChannelAggregatedReport) ? "_Aggregate_Campaign_Report_WithChannel_" : "_Aggregate_Campaign_Report_";
	
				var pdfFileName = bu_name === "" ? client_name + report_sub_title + campaignDetail.name : bu_name + report_sub_title + campaignDetail.name;
	
				var pdf = new pdfConverter('p', 'mm', 'a4');
				pdf.setFont("Helvetica");
				pdf.setFontType("normal");
				pdf.setFontSize(9);
				var pageWidth = 186;
	
				var el_date_picker = document.getElementsByClassName("date-picker-container")[0];
				var el_campaign_graph = document.getElementsByClassName("campaign-graph-container")[0];
				var el_campaign_summary = document.getElementsByClassName("campaign-summary-container")[0];
	
				var canvasDatePicker = null;
				var canvasGraph = null;
				var canvasSummary = null;
				var isCanvasDatePickerReady = false;
				var isCanvasGraphReady = false;
				var isCanvasSummaryReady = false;
				var oriWidth = el_campaign_graph.offsetWidth;
				var oriDatePickerWidth = el_date_picker.offsetWidth;
				document.getElementsByClassName("nav-btn-download-report")[0].style.display = "none";
				document.getElementsByClassName("definition-container")[0].style.display = "block";
				document.getElementsByClassName("tooltip-container")[0].style.display = "none";
				var tableLinks = document.getElementsByClassName("agg-title-link");
				var linkColor = null;
				if (tableLinks.length > 0) {
					linkColor = tableLinks[0].style.color;
					(0, _forEach2.default)(tableLinks, function (el) {
						el.style.color = "#000";
					});
				}
	
				el_date_picker.style.width = "1024px";
				el_campaign_graph.style.width = "1024px";
				el_campaign_summary.style.width = "1024px";
				setTimeout(function () {
					html2canvas(el_date_picker, { logging: false }).then(function (canvas) {
						canvasDatePicker = canvas;
						isCanvasDatePickerReady = true;
						el_date_picker.style.width = oriDatePickerWidth + 'px';
					});
				}, 50);
				setTimeout(function () {
					html2canvas(el_campaign_summary, { logging: false }).then(function (canvas) {
						canvasSummary = canvas;
						isCanvasSummaryReady = true;
						el_campaign_summary.style.width = oriWidth + 'px';
					});
				}, 50);
				setTimeout(function () {
					html2canvas(el_campaign_graph, { logging: false }).then(function (canvas) {
						canvasGraph = canvas;
						isCanvasGraphReady = true;
						el_campaign_graph.style.width = oriWidth + 'px';
					});
				}, 50);
	
				var top = 34;
				var left = 12;
				var intervalId = setInterval(function () {
					if (isCanvasDatePickerReady === false || isCanvasSummaryReady === false || isCanvasGraphReady === false) {
						console.log("PDF Generating...");
					} else {
						clearInterval(intervalId);
						setTimeout(function () {
							pdf.setFillColor(127, 127, 127);
							pdf.rect(0, 15, 210, 10, 'F');
	
							pdf.setTextColor(0, 0, 0);
							pdf.setFontSize(9);
							pdf.setFontType('bold');
							pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), 'PNG', 10.5, 3, 60, 0);
							pdf.text(198, 8, (0, _momentTimezone2.default)().format('MMMM DD, YYYY'), null, null, 'right');
	
							pdf.setTextColor(255, 255, 255);
							pdf.setFontType('bold');
							pdf.text(12, 21, 'Client:');
							//const lenClientName = getTextSize(client_name.trim(), 'helvetica') 
							pdf.setFontType('normal');
							pdf.text(26, 21, client_name ? client_name.trim() : "");
							//cm to inches
							var start = 90; //46 + lenClientName.width * 0.3937 + 0.4
							if (!(0, _isEmpty2.default)(bu_name)) {
								pdf.setFontType('bold');
								pdf.text(start, 21, 'Business Unit:');
								start += 26.5;
								pdf.setFontType('normal');
								pdf.text(start, 21, bu_name ? bu_name.trim() : '');
							}
							pdf.setTextColor(0, 0, 0);
							//pdf.setLineWidth(0.05)
							//pdf.line(0, 27, 210, 27)
							pdf.text(12, 30, 'Campaigns > ' + campaignDetail.name);
	
							pdf.addImage(canvasDatePicker.toDataURL(), 'PNG', left, top, pageWidth, 0);
							top += canvasDatePicker.height * pageWidth / canvasDatePicker.width;
							pdf.addImage(canvasSummary.toDataURL(), 'PNG', left, top, pageWidth, 0);
							top += canvasSummary.height * pageWidth / canvasSummary.width + 4;
							pdf.addImage(canvasGraph.toDataURL(), 'PNG', left, top, pageWidth, 0);
							(0, _utility.addPdfFooter)(pdf);
	
							document.getElementsByClassName("nav-btn-download-report")[0].style.display = "block";
							document.getElementsByClassName("definition-container")[0].style.display = "none";
							document.getElementsByClassName("tooltip-container")[0].style.display = "block";
							if (tableLinks.length > 0) {
								(0, _forEach2.default)(tableLinks, function (el) {
									el.style.color = linkColor;
								});
							}
							pdfFileName = pdfFileName.replace(new RegExp(' ', 'g'), '_') + ".pdf";
							pdf.save(pdfFileName);
							this.setState({ onPdfReportDownload: false });
						}.bind(this), 100);
					}
				}.bind(this), 50);
			}
		}, {
			key: 'handleDownload',
			value: function handleDownload(e) {
				e.preventDefault();
	
				if (this.refs.cbPDF.state.switched) {
					this.downloadPdfReport();
				}
	
				if (this.refs.cbCSV.state.switched) {
					this.downloadCsvReport();
				}
			}
		}, {
			key: 'reportDateFilter',
			value: function reportDateFilter(dayRange) {
				var result = "";
				switch (dayRange) {
					case "yesterday":
						result = "Yesterday";
						break;
					case "today":
						result = "Today";
						break;
					case "last-7-days":
						result = "Last 7 Days";
						break;
					case "last-30-days":
						result = "Last 30 Days";
						break;
					case "life-of-campaign":
					default:
						result = "Life of Campaign";
						break;
				}
				return result;
			}
		}, {
			key: 'cbPDFChange',
			value: function cbPDFChange(e, isInputChecked) {
				var result = !this.refs.cbCSV.state.switched && !isInputChecked;
				this.setState({ disabledBtnDownload: result });
			}
		}, {
			key: 'cbCSVChange',
			value: function cbCSVChange(e, isInputChecked) {
				var result = !this.refs.cbPDF.state.switched && !isInputChecked;
				this.setState({ disabledBtnDownload: result });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props3 = this.props,
				    campaignDetail = _props3.campaignDetail,
				    campaignAggregatedReport = _props3.campaignAggregatedReport,
				    campaignChannelAggregatedReport = _props3.campaignChannelAggregatedReport,
				    reportDateRange = _props3.reportDateRange,
				    setReportDateRange = _props3.setReportDateRange;
	
				var lineData = [];
				if (campaignAggregatedReport) {
					campaignAggregatedReport.forEach(function (data) {
						lineData.push({ time: data.time, messages: data.messages, engagement: data.engagement });
					});
				}
	
				var tableSubTitle = "Date: " + this.reportDateFilter(reportDateRange);
				return _react2.default.createElement(
					'div',
					{ className: 'campaign-report-container', style: { background: "#FFFFFF", fontSize: "16px" } },
					_react2.default.createElement(_Title2.default, {
						crumb: campaignDetail ? campaignDetail.name : "Create Campaign",
						linkName: 'Campaigns', showDownloadBtn: true,
						handleDownload: function handleDownload() {
							_this2.setState({ showDownloadDialog: true });
						},
						selected_client: this.props.client_id
					}),
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'light-grey-border-top mt-20 no-margin-left no-margin-right no-margin-bottom no-padding-left no-padding-right date-picker-container' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '1', sm: '1', md: '1', lg: '1', className: 'no-padding-left no-padding-right' },
							_react2.default.createElement(
								'strong',
								null,
								'Date'
							)
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '3', sm: '3', md: '3', lg: '3', style: { marginLeft: "-50px" } },
							_react2.default.createElement(_reactSelect2.default, { className: 'report-date-selector left-10 z-index-199',
								value: reportDateRange,
								clearable: false,
								searchable: false,
								options: this.dateItem(),
								placeholder: "Select Day",
								onChange: setReportDateRange.bind(this)
							})
						)
					),
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'light-grey-border no-margin-left no-margin-right no-padding mb-20 campaign-summary-container' },
						_react2.default.createElement(
							'h3',
							{ className: 'pl-10', style: { fontSize: '24px', fontWeight: 'bold' } },
							'Campaign Group'
						),
						_react2.default.createElement(
							'table',
							{ style: { width: "98%", marginLeft: '10px', marginBottom: "20px" } },
							_react2.default.createElement(
								'thead',
								{ style: styles.tableHeaderStyle },
								_react2.default.createElement(
									'tr',
									{ style: { height: "42px" } },
									_react2.default.createElement(
										'th',
										{ style: { width: '16%', paddingLeft: "20px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Group Name'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '14%', paddingRight: "10px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Group ID'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '14%', paddingRight: "10px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Client Campaign ID'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '14%', paddingRight: "10px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Group Status'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '14%', paddingRight: "10px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign Start Date'
										)
									),
									_react2.default.createElement(
										'th',
										{ style: { width: '14%', paddingRight: "10px" } },
										_react2.default.createElement(
											'strong',
											null,
											'Campaign End Date'
										)
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								_react2.default.createElement(
									'tr',
									{ style: { height: "42px" } },
									_react2.default.createElement(
										'td',
										{ style: { width: '16%', paddingLeft: "20px" } },
										campaignDetail && campaignDetail.name
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '16%', paddingRight: "10px" } },
										campaignDetail && campaignDetail.campaignId
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '14%', paddingRight: "10px" } },
										campaignDetail && campaignDetail.clientCampaignId
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '12%', paddingRight: "10px" } },
										campaignDetail && campaignDetail.status
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '14%', paddingRight: "10px" } },
										campaignDetail && (0, _momentTimezone2.default)(campaignDetail.startDate).format("MM/DD/YY")
									),
									_react2.default.createElement(
										'td',
										{ style: { width: '14%', paddingRight: "10px" } },
										campaignDetail && (0, _momentTimezone2.default)(campaignDetail.endDate).format("MM/DD/YY")
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'light-grey-border no-margin-left no-margin-right no-padding mb-20 pb-20 pr-10 campaign-graph-container' },
						_react2.default.createElement(
							'h3',
							{ className: 'pl-10', style: { fontSize: '24px', fontWeight: 'bold' } },
							'Aggregated Results'
						),
						_react2.default.createElement(
							'div',
							{ style: { position: "absolute", top: '25px', right: '12px' }, className: 'tooltip-container' },
							_react2.default.createElement(
								_rcTooltip2.default,
								{ placement: 'right',
									overlayClassName: 'campaign-report-legend',
									overlayStyle: { width: "254px" },
									overlay: _react2.default.createElement(
										'div',
										{ className: 'legend-overlay-container' },
										_react2.default.createElement(
											'strong',
											null,
											'Messages - '
										),
										'The total number of ',
										_react2.default.createElement('br', null),
										'marketing messages delivered across ',
										_react2.default.createElement('br', null),
										'all channels to the respective audience.',
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'strong',
											null,
											'Engagement - '
										),
										'Any type of measured ',
										_react2.default.createElement('br', null),
										'activity taken by the user against',
										_react2.default.createElement('br', null),
										'a delivered ad or email. ',
										_react2.default.createElement('br', null),
										'This includes clicks, comments, ',
										_react2.default.createElement('br', null),
										'shares, likes, video views....'
									),
									arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' })
								},
								_react2.default.createElement(_infoOutline2.default, {
									style: { color: 'black', width: '24px', height: '24px', marginTop: '0px', marginLeft: '0px', cursor: 'pointer' }
								})
							)
						),
						_react2.default.createElement(_LineGraphic2.default, { animation: false, key: 'line-section', title: '', data: lineData, subTitle: tableSubTitle }),
						_react2.default.createElement(_AggregatedTable2.default, { data: campaignChannelAggregatedReport, campaignId: this.props.match.params.id,
							parentCampaignDetail: campaignDetail }),
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-margin-bottom no-padding-bottom definition-container', style: { display: "none" } },
							_react2.default.createElement(
								'h3',
								null,
								'DEFINITIONS'
							),
							_react2.default.createElement(
								'div',
								{ className: 'mb-10', style: { fontSize: '13px' } },
								_react2.default.createElement(
									'strong',
									null,
									'Messages - '
								),
								'The total number of marketing messages delivered across all channels to the respective audience.'
							),
							_react2.default.createElement(
								'div',
								{ style: { fontSize: '13px' } },
								_react2.default.createElement(
									'strong',
									null,
									'Engagement - '
								),
								'Any type of measured activity taken by the user against a delivered ad or email. This includes clicks, comments, shares, likes, video views....'
							)
						)
					),
					_react2.default.createElement(
						_Dialog2.default,
						{ open: this.state.onCsvReportDownload, style: { top: '-1.8em' }, modal: true, contentStyle: { width: "500px" },
							overlayStyle: { opacity: 0.9, backgroundColor: '#666666' } },
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'mt-20' },
							_react2.default.createElement(
								_Grid.Col,
								{ offsetXs: '1', offsetSm: '1', offsetMd: '1', offsetLg: '1', xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
								_react2.default.createElement(
									'div',
									null,
									"Downloading, please wait..."
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '1', sm: '1', md: '1', lg: '1' },
								_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
							)
						)
					),
					_react2.default.createElement(
						_Dialog2.default,
						{ open: this.state.onPdfReportDownload, style: { top: '-1.8em' }, modal: true, contentStyle: { width: "500px" },
							overlayStyle: { opacity: 0.9, backgroundColor: '#666666' } },
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'mt-20' },
							_react2.default.createElement(
								_Grid.Col,
								{ offsetXs: '1', offsetSm: '1', offsetMd: '1', offsetLg: '1', xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
								_react2.default.createElement(
									'div',
									null,
									"Downloading, please wait..."
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '1', sm: '1', md: '1', lg: '1' },
								_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
							)
						)
					),
					_react2.default.createElement(
						_Dialog2.default,
						{ open: this.state.showDownloadDialog, style: { top: '-1.8em' }, modal: true,
							contentStyle: { width: "440px" } },
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-margin-top no-padding', style: { fontSize: '16px', color: "#000" } },
							_react2.default.createElement(
								'strong',
								null,
								'Choose the type of file you would like to download'
							)
						),
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-padding-top no-padding-right no-padding-bottom no-margin-bottom',
								style: { paddingLeft: "150px" } },
							_react2.default.createElement(_Checkbox2.default, { iconStyle: { fill: "#47A1AB", marginRight: '10px' }, label: "PDF File", labelStyle: { fontSize: '13px' },
								defaultChecked: false, ref: 'cbPDF', onCheck: function onCheck(e, isInputChecked) {
									return _this2.cbPDFChange(e, isInputChecked);
								} })
						),
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-padding-top no-padding-right no-padding-bottom', style: { paddingLeft: "150px" } },
							_react2.default.createElement(_Checkbox2.default, { iconStyle: { fill: "#47A1AB", marginRight: '10px' }, label: "CSV File", labelStyle: { fontSize: '13px' },
								defaultChecked: true, ref: 'cbCSV', onCheck: function onCheck(e, isInputChecked) {
									return _this2.cbCSVChange(e, isInputChecked);
								} })
						),
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-padding no-margin-bottom mt-20 text-center' },
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: function onClick() {
										return _this2.setState({ showDownloadDialog: false });
									},
									className: 'btn btn-default btn-aa-info mr-20' },
								'Cancel'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: this.handleDownload.bind(this), disabled: this.state.disabledBtnDownload,
									className: 'btn btn-default btn-aa-default' },
								'Download File'
							)
						)
					)
				);
			}
		}]);
	
		return CampaignReport;
	}(_MaterialUI2.default);
	
	exports.default = CampaignReport;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Title = __webpack_require__(212);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _SubscriptionList = __webpack_require__(258);
	
	var _SubscriptionList2 = _interopRequireDefault(_SubscriptionList);
	
	var _SearchBar = __webpack_require__(259);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _Index = __webpack_require__(1071);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Page = __webpack_require__(103);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utility = __webpack_require__(14);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientBusinessInfo = function (_Component) {
	  _inherits(ClientBusinessInfo, _Component);
	
	  function ClientBusinessInfo(props) {
	    _classCallCheck(this, ClientBusinessInfo);
	
	    var _this = _possibleConstructorReturn(this, (ClientBusinessInfo.__proto__ || Object.getPrototypeOf(ClientBusinessInfo)).call(this, props));
	
	    _this.throttle = true;
	    _this.state = {
	      requestParams: {
	        clientId: "",
	        pageNumber: 1,
	        pageSize: 15,
	        sortColumn: "clientName",
	        order: "asc"
	      }
	    };
	    return _this;
	  }
	
	  _createClass(ClientBusinessInfo, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.getClientBusinessTotal();
	      this.props.clientBusinessSearch(this.state.requestParams);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.search_results.clients && this.throttle) {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            pageSize: nextProps.search_results.clients.total
	          })
	        }, function () {
	          _this2.props.getAllSearch(_this2.state.requestParams);
	        });
	        this.throttle = false;
	      }
	    }
	  }, {
	    key: "handleSearch",
	    value: function handleSearch(selectedItem) {
	      var _this3 = this;
	
	      var obj = {};
	      if (selectedItem === "") {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: "",
	            pageNumber: 1,
	            pageSize: 15
	          })
	        };
	        this.goToPage(1);
	      } else {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: selectedItem,
	            pageNumber: 1,
	            pageSize: 15
	          })
	        };
	      }
	      this.setState(obj, function () {
	        _this3.props.clientBusinessSearch(_this3.state.requestParams);
	      });
	    }
	  }, {
	    key: "nextBeClick",
	    value: function nextBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: "previousBeClick",
	    value: function previousBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: "goToPage",
	    value: function goToPage(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: "pageAbleFunc",
	    value: function pageAbleFunc(val) {
	      var _this4 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageNumber: val,
	          pageSize: 15
	        })
	      }, function () {
	        _this4.props.clientBusinessSearch(_this4.state.requestParams);
	      });
	    }
	  }, {
	    key: "handleSortByClientName",
	    value: function handleSortByClientName() {
	      var _this5 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageSize: 15,
	          order: this.state.requestParams.order === "desc" ? "asc" : "desc"
	        })
	      }, function () {
	        _this5.props.clientBusinessSearch(_this5.state.requestParams);
	      });
	    }
	  }, {
	    key: "handleDownload",
	    value: function handleDownload() {
	      var title = "AudienceAnywhere Clients and Business Units,,,,,\r\n";
	      var clients = "Clients," + this.props.client_business_total[0].value + ",,,,\r\n";
	      var join = "Joined last 30 days," + this.props.client_business_total[1].value + ",,,,\r\n";
	      var business = "Business Units," + this.props.client_business_total[2].value + ",,,,\r\n";
	      var bsjoin = "Joined last 30 days," + this.props.client_business_total[3].value + ",,,,\r\n";
	      var data = "";
	      var childrenLoop = function childrenLoop(item) {
	        data += "\"" + item.clientName + "\"," + (item.bizUnitName || "") + ",\"" + (item.industry.name || "") + "\",\"\"," + ((0, _moment2.default)(item.createdTime).format("M/DD/YY") || "") + "," + (item.status || "") + "\r\n";
	      };
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.props.all_search_results.clients.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          if (v.children) {
	            data += "\"" + v.clientName + "\"," + (v.bizUnitName || "") + ",\"" + (v.industry.name || "") + "\",\"" + (v.accountManagers[0] ? v.accountManagers[0].firstName : "") + " " + (v.accountManagers[0] ? v.accountManagers[0].lastName : "") + "\"," + ((0, _moment2.default)(v.createdTime).format("M/DD/YY") || "") + "," + (v.status || "") + "\r\n";
	            v.children.forEach(childrenLoop);
	          } else {
	            data += "\"" + v.clientName + "\"," + (v.bizUnitName || "") + ",\"" + (v.industry.name || "") + "\",\"" + (v.accountManagers[0] ? v.accountManagers[0].firstName : "") + " " + (v.accountManagers[0] ? v.accountManagers[0].lastName : "") + "\"," + ((0, _moment2.default)(v.createdTime).format("M/DD/YY") || "") + "," + (v.status || "") + "\r\n";
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var csv_string = title + clients + join + business + bsjoin + ",,,,,\r\n" + "Client Name,Business Unit Name,Industry,Account Manager,Profile Creation Date,Status\r\n" + data;
	      (0, _utility.downLoadCSVFunc)(csv_string.trim(), "AA_Client_Business_" + (0, _moment2.default)().format("YYYYMMDD"));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      var clientsBizListData = [];
	      var client_business_total = this.props.client_business_total;
	
	      if (!(0, _isEmpty2.default)(client_business_total)) {
	        clientsBizListData.push(client_business_total.find(function (data) {
	          return data.item === "totalClients";
	        }));
	        clientsBizListData.push(client_business_total.find(function (data) {
	          return data.item === "totalBizUnit";
	        }));
	        clientsBizListData.push(client_business_total.find(function (data) {
	          return data.item === "clientsJoinLastMonth";
	        }));
	        clientsBizListData.push(client_business_total.find(function (data) {
	          return data.item === "bizUnitJoinLastMonth";
	        }));
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "subscription-info" },
	        _react2.default.createElement(
	          "div",
	          { className: "title-wrapper" },
	          _react2.default.createElement(_Title2.default, {
	            crumb: "Client/Business Unit",
	            handleDownload: function handleDownload() {
	              return _this6.handleDownload();
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "sub-info-container" },
	          _react2.default.createElement(
	            "div",
	            { className: "common-wrapper" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "TOTAL NUMBER OF CLIENT/BUSINESS UNITS"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "list" },
	              _react2.default.createElement(_SubscriptionList2.default, { hiddenMiddleBorder: true, data: clientsBizListData })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "common-wrapper mt-20" },
	            _react2.default.createElement(
	              "h2",
	              { className: "border-title" },
	              "CLIENT/BUSINESS UNIT"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "search-bar" },
	              _react2.default.createElement(_SearchBar2.default, {
	                clients: this.props.clients,
	                handleSearch: function handleSearch(selectedItem) {
	                  return _this6.handleSearch(selectedItem);
	                }
	              }),
	              _react2.default.createElement(
	                "div",
	                { className: "spread-table-wrapper" },
	                _react2.default.createElement(_Index2.default, {
	                  handleSortByClientName: function handleSortByClientName() {
	                    return _this6.handleSortByClientName();
	                  },
	                  tableHeaderArr: [{ label: "Client Name", value: 0 }, { label: "Business Unit Name", value: 1 }, { label: "Industry", value: 2 },
	                  // {label: 'Account Manager', value: 3},
	                  { label: "Profile Creation Date", value: 4 }, { label: "Status", value: 5 }],
	                  tableHeaderWidthStyle: ["25%", "23%", "25%", "14%", "8%"],
	                  bodyDataArr: this.props.search_results.clients ? this.props.search_results.clients.data : [],
	                  renderCols: {
	                    addCol: "",
	                    cols: ["clientName", "bizUnitName", "industry", "createdTime", "status"]
	                  }
	                }),
	                _react2.default.createElement(_Page2.default, {
	                  nextBeClick: function nextBeClick(page) {
	                    return _this6.nextBeClick(page);
	                  },
	                  pageNumber: this.props.search_results.clients && this.props.search_results.clients.pageNumber,
	                  pageCount: this.props.search_results.clients && this.props.search_results.clients.pageCount,
	                  pageSize: this.props.search_results.clients && this.props.search_results.clients.pageSize,
	                  nextGroupBeClick: function nextGroupBeClick(page) {
	                    return _this6.nextGroupBeClick(page);
	                  },
	                  previousGroupBeClick: function previousGroupBeClick(page) {
	                    return _this6.previousGroupBeClick(page);
	                  },
	                  previousBeClick: function previousBeClick(page) {
	                    return _this6.previousBeClick(page);
	                  },
	                  pageBeClick: function pageBeClick(page) {
	                    return _this6.pageBeClick(page);
	                  },
	                  total: this.props.search_results.clients && this.props.search_results.clients.total,
	                  hasNext: this.props.search_results.clients && this.props.search_results.clients.hasNext,
	                  hasPrevious: this.props.search_results.clients && this.props.search_results.clients.hasPrevious,
	                  pagePlus: true,
	                  selectRows: function selectRows(page, row) {
	                    return _this6.selectRows(page, row);
	                  },
	                  goToPage: function goToPage(page) {
	                    return _this6.goToPage(page);
	                  }
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClientBusinessInfo;
	}(_react.Component);
	
	exports.default = ClientBusinessInfo;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1405);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _playArrow = __webpack_require__(156);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author chargoyao
	 * @property tableHeaderArr {array} table header array.
	 * [{label: 'ClientName', value: 'ClientName'}]
	 * @property renderCols {obj} render data column
	 * {
	 *  addedCol: 'xxx',
	 *  cols: ['xxx', 'xxxx']
	 * }
	 *
	 * @property bodyDataArr {array} remote data
	 * [{
	 *  clientName: 'Deluth Trading',
	 *  bizUnitName: 'Monsanto',
	 *  deploymentType: 'WebProperty',
	 *  domain: 'www.abc.com',
	 *  uuid: 291923-11,
	 *  activeStatus: Inactive
	 *  }, {
	 *    clientName: 'Deluth Trading',
	 *    bizUnitName: 'Monsanto',
	 *    deploymentType: 'WebProperty',
	 *    domain: 'www.abc.com',
	 *    uuid: 291923-11,
	 *    activeStatus: Inactive
	 *    children: [
	 *    ]
	 *  }]
	 *  @property tableHeaderWidthStyle {array} table Width style
	 *  ['22%', '12%']
	 */
	var arrowStyles = {
	  position: 'absolute',
	  right: 0,
	  top: 0
	};
	
	var SpreadTable = function (_Component) {
	  _inherits(SpreadTable, _Component);
	
	  function SpreadTable(props) {
	    _classCallCheck(this, SpreadTable);
	
	    var _this = _possibleConstructorReturn(this, (SpreadTable.__proto__ || Object.getPrototypeOf(SpreadTable)).call(this, props));
	
	    _this.state = {
	      activeIndex: 0,
	      arrowActive: 'down'
	    };
	    return _this;
	  }
	
	  _createClass(SpreadTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'handleClick',
	    value: function handleClick(label, index) {
	      this.setState({
	        activeIndex: index
	      });
	      if (+index === this.state.activeIndex) {
	        if (this.state.arrowActive === 'down') {
	          this.setState({
	            arrowActive: 'up'
	          });
	        } else {
	          this.setState({
	            arrowActive: 'down'
	          });
	        }
	      } else {
	        this.setState({
	          arrowActive: 'down'
	        });
	      }
	      if (index === 0) {
	        this.props.handleSortByClientName();
	      }
	    }
	  }, {
	    key: 'spreadTr',
	    value: function spreadTr(index) {
	      if (this.state['spread' + index]) {
	        this.setState(_defineProperty({}, 'spread' + index, false));
	      } else {
	        this.setState(_defineProperty({}, 'spread' + index, true));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'spread-table' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              this.props.tableHeaderArr.map(function (item, index) {
	                var widthStyle = '';
	                switch (index) {
	                  case 0:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[0];
	                    break;
	                  case 1:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[1];
	                    break;
	                  case 2:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[2];
	                    break;
	                  case 3:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[3];
	                    break;
	                  case 4:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[4];
	                    break;
	                  default:
	                    widthStyle = '';
	                    break;
	                }
	                return _react2.default.createElement(
	                  'th',
	                  { key: item.value,
	                    className: _this2.state.activeIndex === index && index === 0 ? 'active' : '',
	                    onClick: function onClick() {
	                      if (item.label === 'Client Name') _this2.handleClick(item.label, index);
	                    },
	                    style: { width: widthStyle }
	                  },
	                  item.label,
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'down' && index === 0 && _react2.default.createElement(_arrowDropDown2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  }),
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'up' && index === 0 && _react2.default.createElement(_arrowDropUp2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  })
	                );
	              })
	            ),
	            this.props.bodyDataArr.map(function (item, index) {
	              if (!item.children) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: index },
	                  _this2.props.renderCols.cols.map(function (list, idx) {
	                    if (list === 'uuid') {
	                      return _react2.default.createElement(
	                        'td',
	                        { className: 'uuid', key: 'uuid-n' },
	                        item[list].substring(0, 6) + '...',
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          item[list]
	                        )
	                      );
	                    } else if (list === 'industry') {
	                      return _react2.default.createElement(
	                        'td',
	                        { key: 'industry-n' },
	                        item[list]['name']
	                      );
	                    } else if (list === 'createdTime') {
	                      return _react2.default.createElement(
	                        'td',
	                        { key: 'createdTime-n' },
	                        (0, _moment2.default)(item[list]).format('M/DD/YY')
	                      );
	                    } else {
	                      return _react2.default.createElement(
	                        'td',
	                        { key: idx + '-addCol', style: { paddingLeft: idx === 0 ? 0 : '' } },
	                        item[list] || _this2.props.renderCols.addCol.length > 0 && item[_this2.props.renderCols.addCol]
	                      );
	                    }
	                  })
	                );
	              } else {
	                var obj = [];
	                if (item.children.length >= 1) {
	                  obj.push(_react2.default.createElement(
	                    'tr',
	                    { key: index, onClick: function onClick() {
	                        return _this2.spreadTr(index);
	                      } },
	                    _react2.default.createElement(
	                      'td',
	                      { style: { paddingLeft: '20px', cursor: 'pointer' } },
	                      _this2.state['spread' + index] ? _react2.default.createElement(_arrowDropDown2.default, {
	                        style: { position: 'absolute', left: '-7px', top: '2px' }
	                      }) : _react2.default.createElement(_playArrow2.default, {
	                        style: { position: 'absolute', left: '-5px', top: '6px', width: '16px', height: '16px' }
	                      }),
	                      item.clientName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.bizUnitName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.industry.name
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      (0, _moment2.default)(item.createdTime).format('M/DD/YY')
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.status
	                    )
	                  ));
	                }
	
	                var _loop = function _loop(_, v) {
	                  obj.push(_react2.default.createElement(
	                    'tr',
	                    { style: { display: _this2.state['spread' + index] ? 'table-row' : 'none' } },
	                    _this2.props.renderCols.cols.map(function (list, index) {
	                      if (list === 'uuid') {
	                        return _react2.default.createElement(
	                          'td',
	                          { className: 'uuid', key: 'uuid-c' },
	                          v[list].substring(0, 6) + '...',
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            v[list]
	                          )
	                        );
	                      } else if (list === 'industry') {
	                        return _react2.default.createElement(
	                          'td',
	                          { key: 'industry-c' },
	                          v[list]['name']
	                        );
	                      } else if (list === 'createdTime') {
	                        return _react2.default.createElement(
	                          'td',
	                          { key: 'createdTime-c' },
	                          (0, _moment2.default)(v[list]).format('M/DD/YY')
	                        );
	                      } else {
	                        return _react2.default.createElement(
	                          'td',
	                          { style: { paddingLeft: index === 0 ? '49px' : '' }, key: '' + v[list] + index },
	                          v[list] || _this2.props.renderCols.addCol.length > 0 && v[_this2.props.renderCols.addCol]
	                        );
	                      }
	                    })
	                  ));
	                };
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                  for (var _iterator = item.children.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _ref = _step.value;
	
	                    var _ref2 = _slicedToArray(_ref, 2);
	
	                    var _ = _ref2[0];
	                    var v = _ref2[1];
	
	                    _loop(_, v);
	                  }
	                } catch (err) {
	                  _didIteratorError = true;
	                  _iteratorError = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                      _iterator.return();
	                    }
	                  } finally {
	                    if (_didIteratorError) {
	                      throw _iteratorError;
	                    }
	                  }
	                }
	
	                return obj;
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SpreadTable;
	}(_react.Component);
	
	SpreadTable.defaultProps = {
	  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
	  bodyDataArr: [],
	  renderCols: {
	    addCol: '',
	    cols: []
	  }
	};
	
	exports.default = SpreadTable;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _Nav = __webpack_require__(1073);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Index = __webpack_require__(1070);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(1074);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	__webpack_require__(1408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientBusinessInfoAndUser = function (_Component) {
	  _inherits(ClientBusinessInfoAndUser, _Component);
	
	  function ClientBusinessInfoAndUser() {
	    _classCallCheck(this, ClientBusinessInfoAndUser);
	
	    return _possibleConstructorReturn(this, (ClientBusinessInfoAndUser.__proto__ || Object.getPrototypeOf(ClientBusinessInfoAndUser)).apply(this, arguments));
	  }
	
	  _createClass(ClientBusinessInfoAndUser, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'client-business-user-wrapper' },
	          _react2.default.createElement(_Nav2.default, {
	            params: this.props.match.params
	          }),
	          this.props.match.params.type === 'client-business-info' && _react2.default.createElement(_Index2.default, this.props),
	          this.props.match.params.type === 'users' && _react2.default.createElement(_Index4.default, this.props)
	        )
	      );
	    }
	  }]);
	
	  return ClientBusinessInfoAndUser;
	}(_react.Component);
	
	exports.default = ClientBusinessInfoAndUser;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	__webpack_require__(1406);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    _classCallCheck(this, Nav);
	
	    return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
	  }
	
	  _createClass(Nav, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'client-business-info-nav clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              'li',
	              { className: this.props.params.type === 'client-business-info' ? 'active' : '' },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/dashboard/clients/client-business-info' },
	                'CLIENT/BUSINESS UNIT'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: this.props.params.type === 'users' ? 'active' : '' },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/dashboard/clients/users' },
	                'USERS'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Nav;
	}(_react.Component);
	
	exports.default = Nav;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Title = __webpack_require__(212);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _SubscriptionList = __webpack_require__(258);
	
	var _SubscriptionList2 = _interopRequireDefault(_SubscriptionList);
	
	var _AsyncSearchBar = __webpack_require__(1160);
	
	var _AsyncSearchBar2 = _interopRequireDefault(_AsyncSearchBar);
	
	var _Page = __webpack_require__(103);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _UsersTable = __webpack_require__(1075);
	
	var _UsersTable2 = _interopRequireDefault(_UsersTable);
	
	__webpack_require__(1407);
	
	var _utility = __webpack_require__(14);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Users = function (_Component) {
	  _inherits(Users, _Component);
	
	  function Users(props) {
	    _classCallCheck(this, Users);
	
	    var _this = _possibleConstructorReturn(this, (Users.__proto__ || Object.getPrototypeOf(Users)).call(this, props));
	
	    _this.throttle = true;
	    _this.state = {
	      requestParams: {
	        clientId: '',
	        pageNumber: 1,
	        pageSize: 15,
	        sortColumn: 'clientName',
	        order: 'asc'
	      },
	      resultExpand: false
	    };
	    return _this;
	  }
	
	  _createClass(Users, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getClientBusinessTotal();
	      this.props.usersSearch(this.state.requestParams);
	      this.props.usersAll();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.users_results.clientUsers && this.throttle) {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            pageSize: nextProps.users_results.clientUsers.total
	          })
	        }, function () {
	          _this2.props.getAllUsersSearch(_this2.state.requestParams);
	        });
	        this.throttle = false;
	      }
	    }
	  }, {
	    key: 'nextBeClick',
	    value: function nextBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: 'previousBeClick',
	    value: function previousBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: 'goToPage',
	    value: function goToPage(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: 'pageAbleFunc',
	    value: function pageAbleFunc(val) {
	      var _this3 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageNumber: val,
	          pageSize: 15
	        })
	      }, function () {
	        _this3.props.usersSearch(_this3.state.requestParams);
	      });
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(selectedItem) {
	      var _this4 = this;
	
	      var obj = {};
	      if (selectedItem === '') {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: '',
	            pageNumber: 1,
	            pageSize: 15
	          }),
	          resultExpand: false
	        };
	        this.goToPage(1);
	      } else {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: selectedItem,
	            pageNumber: 1,
	            pageSize: 15
	          }),
	          resultExpand: true
	        };
	      }
	      this.props.clearUsersSearch();
	      this.setState(obj, function () {
	        _this4.props.usersSearch(_this4.state.requestParams);
	      });
	    }
	  }, {
	    key: 'handleDownload',
	    value: function handleDownload() {
	      var title = 'AudienceAnywhere Clients and Business Units Users ,,,,,,\r\n';
	      var clients = 'Client Users,' + this.props.client_users_total[0].value + ',,,,\r\n';
	      var join = 'Business Unit Users,' + this.props.client_users_total[1].value + ',,,,\r\n';
	      var data = '';
	      var childrenFun = function childrenFun(item) {
	        data += '"' + item.clientName + '",' + (item.bizUnitName || '') + ',' + (item.user.username || '') + ',' + (item.user ? item.user.role.name : '') + ',' + (item.user ? item.user.email : '') + ',' + (item.user.status || '') + ',' + (item.user ? (0, _moment2.default)(item.user.lastLoggedonDatetime).format('M/DD/YY') : '') + '\r\n';
	      };
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.props.all_users_results.clientUsers.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          if (v.children) {
	            data += '"' + v.clientName + '",' + (v.bizUnitName || '') + ',' + (v.user ? v.user.username : '') + ',' + (v.user ? v.user.role.name : '') + ',' + (v.user ? v.user.email : '') + ',' + (v.user.status || '') + ',' + (v.user ? (0, _moment2.default)(v.user.lastLoggedonDatetime).format('M/DD/YY') : '') + '\r\n';
	            v.children.forEach(childrenFun);
	          } else {
	            data += '"' + v.clientName + '",' + (v.bizUnitName || '') + ',' + (v.user ? v.user.username : '') + ',' + (v.user ? v.user.role.name : '') + ',' + (v.user ? v.user.email : '') + ',' + (v.user.status || '') + ',' + (v.user ? (0, _moment2.default)(v.user.lastLoggedonDatetime).format('M/DD/YY') : '') + '\r\n';
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var csv_string = title + clients + join + ',,,,,\r\n' + 'Client Name,Business Unit Name,User name,Role,Email,Status,Last Logged On\r\n' + data;
	      (0, _utility.downLoadCSVFunc)(csv_string.trim(), 'AA_Client_Business_Users_' + (0, _moment2.default)().format("YYYYMMDD"));
	    }
	  }, {
	    key: 'handleSortByClientName',
	    value: function handleSortByClientName() {
	      var _this5 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageSize: 15,
	          order: this.state.requestParams.order === 'desc' ? 'asc' : 'desc'
	        })
	      }, function () {
	        _this5.props.usersSearch(_this5.state.requestParams);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dashboard-user-info subscription-info' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title-wrapper' },
	          _react2.default.createElement(_Title2.default, {
	            crumb: 'Users',
	            handleDownload: function handleDownload() {
	              return _this6.handleDownload();
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dashboard-user-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'common-wrapper' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'TOTAL NUMBER OF CLIENT/BUSINESS UNITS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'list' },
	              _react2.default.createElement(_SubscriptionList2.default, {
	                data: this.props.client_users_total
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'common-wrapper mt-20' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'border-title' },
	              'USERS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'search-bar' },
	              _react2.default.createElement(_AsyncSearchBar2.default, {
	                clients: this.props.clients,
	                handleSearch: function handleSearch(selectedItem) {
	                  return _this6.handleSearch(selectedItem);
	                },
	                token: this.props.token,
	                resultSet: this.props.all_users_results
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'spread-table-wrapper' },
	                _react2.default.createElement(_UsersTable2.default, {
	                  expandAll: this.state.resultExpand,
	                  handleSortByClientName: function handleSortByClientName() {
	                    return _this6.handleSortByClientName();
	                  },
	                  tableHeaderArr: [{ label: 'Client Name', value: 0 }, { label: 'Business Unit Name', value: 1 }, { label: 'User Name', value: 2 }, { label: 'Role', value: 3 }, { label: 'Email', value: 4 }, { label: 'Status', value: 5 }, { label: 'Last Logged On', value: 6 }],
	                  tableHeaderWidthStyle: ['18%', '16%', '12%', '14%', '18%', '10%', '10%'],
	                  bodyDataArr: this.props.users_results.clientUsers ? this.props.users_results.clientUsers.data : [],
	                  renderCols: {
	                    addCol: '',
	                    cols: ['clientName', 'bizUnitName', 'industry', 'createdTime', 'status']
	                  }
	                }),
	                _react2.default.createElement(_Page2.default, {
	                  nextBeClick: function nextBeClick(page) {
	                    return _this6.nextBeClick(page);
	                  },
	                  pageNumber: this.props.users_results.clientUsers && this.props.users_results.clientUsers.pageNumber,
	                  pageCount: this.props.users_results.clientUsers && this.props.users_results.clientUsers.pageCount,
	                  pageSize: this.props.users_results.clientUsers && this.props.users_results.clientUsers.pageSize,
	                  nextGroupBeClick: function nextGroupBeClick(page) {
	                    return _this6.nextGroupBeClick(page);
	                  },
	                  previousGroupBeClick: function previousGroupBeClick(page) {
	                    return _this6.previousGroupBeClick(page);
	                  },
	                  previousBeClick: function previousBeClick(page) {
	                    return _this6.previousBeClick(page);
	                  },
	                  pageBeClick: function pageBeClick(page) {
	                    return _this6.pageBeClick(page);
	                  },
	                  total: this.props.users_results.clientUsers && this.props.users_results.clientUsers.total,
	                  hasNext: this.props.users_results.clientUsers && this.props.users_results.clientUsers.hasNext,
	                  hasPrevious: this.props.users_results.clientUsers && this.props.users_results.clientUsers.hasPrevious,
	                  pagePlus: true,
	                  selectRows: function selectRows(page, row) {
	                    return _this6.selectRows(page, row);
	                  },
	                  goToPage: function goToPage(page) {
	                    return _this6.goToPage(page);
	                  }
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Users;
	}(_react.Component);
	
	exports.default = Users;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(222);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _playArrow = __webpack_require__(156);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author chargoyao
	 * @property tableHeaderArr {array} table header array.
	 * [{label: 'ClientName', value: 'ClientName'}]
	 * @property renderCols {obj} render data column
	 * {
	 *  addedCol: 'xxx',
	 *  cols: ['xxx', 'xxxx']
	 * }
	 *
	 * @property bodyDataArr {array} remote data
	 * [{
	 *  clientName: 'Deluth Trading',
	 *  bizUnitName: 'Monsanto',
	 *  deploymentType: 'WebProperty',
	 *  domain: 'www.abc.com',
	 *  uuid: 291923-11,
	 *  activeStatus: Inactive
	 *  }, {
	 *    clientName: 'Deluth Trading',
	 *    bizUnitName: 'Monsanto',
	 *    deploymentType: 'WebProperty',
	 *    domain: 'www.abc.com',
	 *    uuid: 291923-11,
	 *    activeStatus: Inactive
	 *    children: [
	 *    ]
	 *  }]
	 *  @property tableHeaderWidthStyle {array} table Width style
	 *  ['22%', '12%']
	 */
	var arrowStyles = {
	  position: 'absolute',
	  right: 0,
	  top: '7px'
	};
	
	var UsersTable = function (_Component) {
	  _inherits(UsersTable, _Component);
	
	  function UsersTable(props) {
	    _classCallCheck(this, UsersTable);
	
	    var _this = _possibleConstructorReturn(this, (UsersTable.__proto__ || Object.getPrototypeOf(UsersTable)).call(this, props));
	
	    _this.state = {
	      activeIndex: 0,
	      arrowActive: 'down',
	      expandAll: false
	    };
	    return _this;
	  }
	
	  _createClass(UsersTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.expandAll === true) {
	        this.setState({ expandAll: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.expandAll !== this.props.expandAll) {
	        this.setState({ expandAll: nextProps.expandAll === true });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(label, index) {
	      this.setState({
	        activeIndex: index
	      });
	      if (+index === this.state.activeIndex) {
	        if (this.state.arrowActive === 'down') {
	          this.setState({
	            arrowActive: 'up'
	          });
	        } else {
	          this.setState({
	            arrowActive: 'down'
	          });
	        }
	      } else {
	        this.setState({
	          arrowActive: 'down'
	        });
	      }
	      if (index === 0) {
	        this.props.handleSortByClientName();
	      }
	    }
	  }, {
	    key: 'spreadTr',
	    value: function spreadTr(index) {
	      if (this.state['spread' + index]) {
	        var _setState;
	
	        this.setState((_setState = {}, _defineProperty(_setState, 'spread' + index, false), _defineProperty(_setState, 'expandAll', false), _setState));
	      } else {
	        var _setState2;
	
	        this.setState((_setState2 = {}, _defineProperty(_setState2, 'spread' + index, true), _defineProperty(_setState2, 'expandAll', false), _setState2));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'spread-table' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              this.props.tableHeaderArr.map(function (item, index) {
	                var widthStyle = '';
	                switch (index) {
	                  case 0:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[0];
	                    break;
	                  case 1:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[1];
	                    break;
	                  case 2:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[2];
	                    break;
	                  case 3:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[3];
	                    break;
	                  case 4:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[4];
	                    break;
	                  case 5:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[5];
	                    break;
	                  case 6:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[6];
	                    break;
	                  default:
	                    widthStyle = '';
	                    break;
	                }
	                return _react2.default.createElement(
	                  'th',
	                  { key: item.value,
	                    className: _this2.state.activeIndex === index && index === 0 ? 'active' : '',
	                    onClick: function onClick() {
	                      if (item.label === 'Client Name') _this2.handleClick(item.label, index);
	                    },
	                    style: { width: widthStyle, whiteSpace: 'pre-wrap' }
	                  },
	                  item.label,
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'down' && index === 0 && _react2.default.createElement(_arrowDropDown2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  }),
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'up' && index === 0 && _react2.default.createElement(_arrowDropUp2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  })
	                );
	              })
	            ),
	            this.props.bodyDataArr.map(function (item, index) {
	              if (item.children.length === 0) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: index },
	                  _react2.default.createElement(
	                    'td',
	                    { style: { paddingLeft: 0 } },
	                    item.clientName
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.bizUnitName
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.user && item.user.username
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.user && item.user.role.name
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.user && item.user.email
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.user && item.user.status
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.user && item.user.lastLoggedonDatetime && (0, _moment2.default)(item.user.lastLoggedonDatetime).format('M/DD/YY')
	                  )
	                );
	              } else {
	                var obj = [];
	                if (item.children.length >= 1) {
	                  obj.push(_react2.default.createElement(
	                    'tr',
	                    { key: index, onClick: function onClick() {
	                        return _this2.spreadTr(index);
	                      } },
	                    _react2.default.createElement(
	                      'td',
	                      { style: { paddingLeft: '20px', cursor: 'pointer' } },
	                      _this2.state['spread' + index] || _this2.state.expandAll ? _react2.default.createElement(_arrowDropDown2.default, {
	                        style: { position: 'absolute', left: '-7px', top: '2px' }
	                      }) : _react2.default.createElement(_playArrow2.default, {
	                        style: { position: 'absolute', left: '-5px', top: '6px', width: '16px', height: '16px' }
	                      }),
	                      item.clientName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.bizUnitName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.user && item.user.username
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.user && item.user.role.name
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.user && item.user.email
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.user && item.user.status
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.user ? (0, _moment2.default)(item.user.lastLoggedonDatetime).format('M/DD/YY') : ''
	                    )
	                  ));
	                }
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                  for (var _iterator = item.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var v = _step.value;
	
	                    obj.push(_react2.default.createElement(
	                      'tr',
	                      { style: { display: _this2.state['spread' + index] || _this2.state.expandAll ? 'table-row' : 'none' } },
	                      _react2.default.createElement(
	                        'td',
	                        { style: { paddingLeft: '49px' } },
	                        v.clientName
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.bizUnitName
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.user && v.user.username
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.user && v.user.role.name
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.user && v.user.email
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.user && v.user.status
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.user ? (0, _moment2.default)(v.user.lastLoggedonDatetime).format('M/DD/YY') : ''
	                      )
	                    ));
	                  }
	                } catch (err) {
	                  _didIteratorError = true;
	                  _iteratorError = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                      _iterator.return();
	                    }
	                  } finally {
	                    if (_didIteratorError) {
	                      throw _iteratorError;
	                    }
	                  }
	                }
	
	                return obj;
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return UsersTable;
	}(_react.Component);
	
	UsersTable.defaultProps = {
	  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
	  bodyDataArr: [],
	  renderCols: {
	    addCol: '',
	    cols: []
	  }
	};
	
	exports.default = UsersTable;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Table = __webpack_require__(236);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _Page = __webpack_require__(103);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Industry = __webpack_require__(1083);
	
	var _Industry2 = _interopRequireDefault(_Industry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  tableHeaderStyle: {
	    border: "none",
	    background: "#F5F5F5",
	    fontSize: "16px"
	  },
	  arrowStyle: {
	    position: "absolute",
	    top: "10px"
	  },
	  tableHeaderColumn: {
	    height: "55px",
	    color: "#000",
	    cursor: "pointer",
	    fontWeight: "bold",
	    fontSize: "16px",
	    paddingLeft: "20px",
	    paddingRight: "20px"
	  },
	  tableHeaderSortedColumn: {
	    height: "55px",
	    color: "#000",
	    cursor: "pointer",
	    fontWeight: "bold",
	    fontSize: "16px",
	    backgroundColor: "#E3E3E3",
	    paddingLeft: "20px",
	    paddingRight: "20px",
	    backgroundClip: "padding-box"
	  },
	  tableRowColumn: {
	    position: "relative",
	    paddingLeft: "20px",
	    paddingRight: "20px",
	    height: "55px",
	    fontSize: "16px"
	  },
	  settingStyle: {
	    position: "absolute",
	    right: "6em",
	    top: "0.9em",
	    cursor: "pointer"
	  }
	};
	
	var ClientsTable = function (_Component) {
	  _inherits(ClientsTable, _Component);
	
	  function ClientsTable(props) {
	    _classCallCheck(this, ClientsTable);
	
	    var _this = _possibleConstructorReturn(this, (ClientsTable.__proto__ || Object.getPrototypeOf(ClientsTable)).call(this, props));
	
	    _this.state = {
	      requestParams: {
	        pageNumber: 1,
	        pageSize: 10,
	        sortColumn: "name", //support name , role, email, status field
	        order: "desc", // asc or desc
	        keyword: "" // optional
	      },
	      requestInvitationClientParams: {
	        roleId: "",
	        title: "",
	        firstName: "",
	        lastName: "",
	        email: "",
	        companyName: "",
	        industryId: "",
	        subscriptionTierId: "",
	        accountNumber: "",
	        accountManagerUserIds: [""]
	      }
	    };
	    return _this;
	  }
	
	  _createClass(ClientsTable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.getClientsTable(this.state.requestParams);
	      this.props.getAllClientsTable({
	        pageNumber: 1,
	        pageSize: 9999,
	        sortColumn: "name", //support name , role, email, status field
	        order: "desc", // asc or desc
	        keyword: "" // optional
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {}
	    // below is callback for page component
	
	  }, {
	    key: "nextBeClick",
	    value: function nextBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "nextGroupBeClick",
	    value: function nextGroupBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "previousGroupBeClick",
	    value: function previousGroupBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "previousBeClick",
	    value: function previousBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "pageBeClick",
	    value: function pageBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "selectRows",
	    value: function selectRows(page, row) {
	      var _this2 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageSize: row
	        })
	      }, function () {
	        _this2.dispatchPageAction(page);
	      });
	    }
	  }, {
	    key: "goToPage",
	    value: function goToPage(page) {
	      if (page > this.props.tableData.pageCount) {
	        return;
	      } else {
	        this.dispatchPageAction(page);
	      }
	    }
	  }, {
	    key: "dispatchPageAction",
	    value: function dispatchPageAction(page) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageNumber: page
	        })
	      });
	      this.props.getClientsTable({
	        pageNumber: page,
	        pageSize: this.state.requestParams.pageSize,
	        sortColumn: this.state.requestParams.sortColumn, //support name , role, email, status field
	        order: this.state.requestParams.order // asc or desc
	      });
	    }
	  }, {
	    key: "handleHeaderClick",
	    value: function handleHeaderClick(e) {
	      var _this3 = this;
	
	      this.setState({
	        cache_sortColumn: e.target.innerText
	      });
	      var params = {
	        order: this.state.requestParams.order === "desc" && this.state.cache_sortColumn === e.target.innerText ? "asc" : "desc",
	        sortColumn: "name"
	      };
	
	      switch (e.target.innerText) {
	        case "Client Name":
	          params.sortColumn = "name";
	          break;
	        case "Industry Type":
	          params.sortColumn = "industry";
	          break;
	        case "Status":
	          params.sortColumn = "status";
	          break;
	        case "Subscription Tier":
	          params.sortColumn = "tier";
	          break;
	        case "Business Unit Name":
	          params.sortColumn = "name";
	          break;
	        default:
	          return;
	      }
	      this.setState({
	        requestParams: {
	          order: params.order,
	          sortColumn: params.sortColumn
	        }
	      }, function () {
	        _this3.props.getClientsTable(_this3.state.requestParams);
	      });
	    }
	  }, {
	    key: "handleSearch",
	    value: function handleSearch(keyword, industryId) {
	      var _this4 = this;
	
	      if (keyword !== "") {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            pageNumber: 1
	          })
	        }, function () {
	          _this4.props.search_clients(Object.assign({}, _this4.state.requestParams, {
	            industryId: industryId.value,
	            keyword: keyword
	          }));
	        });
	      } else if (keyword === "") {
	        this.setState({
	          pageNumber: 1,
	          pageSize: 10,
	          sortColumn: "name", //support name , role, email, status field
	          order: "desc", // asc or desc
	          keyword: "" // optional
	        }, function () {
	          _this4.props.search_clients(_this4.state.requestParams);
	        });
	      }
	    }
	  }, {
	    key: "handleIconClick",
	    value: function handleIconClick(targetName) {
	      var _this5 = this;
	
	      var params = {
	        order: this.state.requestParams.order === "desc" ? "asc" : "desc",
	        sortColumn: "name"
	      };
	
	      switch (targetName) {
	        case "Client Name":
	          params.sortColumn = "name";
	          break;
	        case "Industry Type":
	          params.sortColumn = "industry";
	          break;
	        case "Status":
	          params.sortColumn = "status";
	          break;
	        case "Subscription Tier":
	          params.sortColumn = "tier";
	          break;
	        default:
	          return;
	      }
	
	      this.setState({
	        requestParams: {
	          order: params.order,
	          sortColumn: params.sortColumn
	        }
	      }, function () {
	        _this5.props.getClientsTable(_this5.state.requestParams);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      var isClientAdmin = /^(account manager|administrator|team member|system administrator)/gi.test(this.props.roleName);
	      var nameTitle = /^(account manager|system administrator)/gi.test(this.props.roleName) ? "Client Name" : "Business Unit Name";
	      return _react2.default.createElement(
	        "div",
	        { className: "clients-table-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "industry-wrapper clearfix" },
	          _react2.default.createElement(_Industry2.default, {
	            style: { float: "left" },
	            getIndustryOptions: this.props.getIndustryOptions,
	            industryOptions: this.props.industryOptions,
	            roleName: this.props.roleName,
	            tableAllData: this.props.tableAllData,
	            handleSearch: function handleSearch(keyword, industryId) {
	              return _this6.handleSearch(keyword, industryId);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "clients-table", onClick: function onClick(e) {
	              return _this6.handleHeaderClick(e);
	            } },
	          // no data
	          this.props.tableData === "empty" && _react2.default.createElement(
	            "section",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "You have not invited any clients."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Send an invite to a client for platform access."
	            )
	          ),
	          _typeof(this.props.tableData) === "object" && _react2.default.createElement(
	            _Table.Table,
	            { style: { fontFamily: "Arial" } },
	            _react2.default.createElement(
	              _Table.TableHeader,
	              {
	                displaySelectAll: false,
	                style: styles.tableHeaderStyle,
	                adjustForCheckbox: false
	              },
	              _react2.default.createElement(
	                _Table.TableRow,
	                {
	                  displayBorder: false,
	                  style: { height: "55px", fontSize: "16px" }
	                },
	                [{ name: nameTitle, value: "name" }, { name: "Industry Type", value: "industry" }, { name: "Status", value: "status" }, { name: "Subscription Tier", value: "tier" }].map(function (item, index) {
	                  if (index === 2) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        style: Object.assign({}, _this6.state.requestParams.sortColumn === item.value ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn),
	                        key: index
	                      },
	                      item.name,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this6.handleIconClick(item.name);
	                        },
	                        "data-value": item.name,
	                        style: {
	                          display: _this6.state.requestParams.order === "desc" && _this6.state.requestParams.sortColumn === item.value ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this6.handleIconClick(item.name);
	                        },
	                        style: {
	                          display: _this6.state.requestParams.order === "asc" && _this6.state.requestParams.sortColumn === item.value ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  }
	                  if (index === 0) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        style: Object.assign({}, _this6.state.requestParams.sortColumn === item.value ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          width: "30%"
	                        }),
	                        key: index
	                      },
	                      item.name,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this6.handleIconClick(item.name);
	                        },
	                        "data-value": item.name,
	                        style: {
	                          display: _this6.state.requestParams.order === "desc" && _this6.state.requestParams.sortColumn === item.value ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this6.handleIconClick(item.name);
	                        },
	                        style: {
	                          display: _this6.state.requestParams.order === "asc" && _this6.state.requestParams.sortColumn === item.value ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  }
	                  if (index === 1) {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        style: Object.assign({}, _this6.state.requestParams.sortColumn === item.value ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, {
	                          width: "35%"
	                        }),
	                        key: index
	                      },
	                      item.name,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this6.handleIconClick(item.name);
	                        },
	                        "data-value": item.name,
	                        style: {
	                          display: _this6.state.requestParams.order === "desc" && _this6.state.requestParams.sortColumn === item.value ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this6.handleIconClick(item.name);
	                        },
	                        style: {
	                          display: _this6.state.requestParams.order === "asc" && _this6.state.requestParams.sortColumn === item.value ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      {
	                        style: Object.assign({}, _this6.state.requestParams.sortColumn === item.value ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn),
	                        key: index
	                      },
	                      item.name,
	                      _react2.default.createElement(_arrowDropDown2.default, {
	                        onClick: function onClick() {
	                          return _this6.handleIconClick(item.name);
	                        },
	                        "data-value": item.name,
	                        style: {
	                          display: _this6.state.requestParams.order === "desc" && _this6.state.requestParams.sortColumn === item.value ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      }),
	                      _react2.default.createElement(_arrowDropUp2.default, {
	                        onClick: function onClick() {
	                          return _this6.handleIconClick(item.name);
	                        },
	                        style: {
	                          display: _this6.state.requestParams.order === "asc" && _this6.state.requestParams.sortColumn === item.value ? "inline-block" : "none",
	                          position: "absolute",
	                          top: "10px",
	                          right: "0"
	                        }
	                      })
	                    );
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _Table.TableBody,
	              { displayRowCheckbox: false },
	              this.props.tableData.data.map(function (item, index) {
	                return _react2.default.createElement(
	                  _Table.TableRow,
	                  {
	                    selectable: false,
	                    key: item.id,
	                    style: {
	                      height: "55px",
	                      fontSize: "16px",
	                      borderBottom: "solid 1px #e8ebef"
	                    }
	                  },
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: Object.assign({}, styles.tableRowColumn, {
	                        color: "#0997F7",
	                        cursor: "pointer",
	                        width: "30%"
	                      })
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      isClientAdmin ? _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/clients/edit/Client-Profile/" + item.id + "?name=" + item.name
	                        },
	                        item.name
	                      ) : item.name
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                      style: Object.assign({}, styles.tableRowColumn, { width: "35%" })
	                    },
	                    item.industry.name
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { style: Object.assign({}, styles.tableRowColumn) },
	                    item.status
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { style: styles.tableRowColumn },
	                    item.subscription && item.subscription.name
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(_Page2.default, {
	            nextBeClick: function nextBeClick(page) {
	              return _this6.nextBeClick(page);
	            },
	            pageCount: this.props.tableData.pageCount,
	            pageSize: this.props.tableData.pageSize,
	            nextGroupBeClick: function nextGroupBeClick(page) {
	              return _this6.nextGroupBeClick(page);
	            },
	            previousGroupBeClick: function previousGroupBeClick(page) {
	              return _this6.previousGroupBeClick(page);
	            },
	            previousBeClick: function previousBeClick(page) {
	              return _this6.previousBeClick(page);
	            },
	            pageBeClick: function pageBeClick(page) {
	              return _this6.pageBeClick(page);
	            },
	            total: this.props.tableData.total,
	            hasNext: this.props.tableData.hasNext,
	            hasPrevious: this.props.tableData.hasPrevious,
	            pagePlus: true,
	            selectRows: function selectRows(page, row) {
	              return _this6.selectRows(page, row);
	            },
	            goToPage: function goToPage(page) {
	              return _this6.goToPage(page);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return ClientsTable;
	}(_react.Component);
	
	exports.default = ClientsTable;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IndustryDialog = __webpack_require__(514);
	
	var _IndustryDialog2 = _interopRequireDefault(_IndustryDialog);
	
	var _ClientProfile = __webpack_require__(512);
	
	var _ClientProfile2 = _interopRequireDefault(_ClientProfile);
	
	var _lodash = __webpack_require__(18);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// client profile
	
	// css
	
	
	var styles = {
	  tableHeaderStyle: {
	    border: "none",
	    background: "#F5F5F5",
	    fontSize: "16px"
	  },
	  arrowStyle: {
	    position: "absolute",
	    top: "10px"
	  },
	  tableHeaderColumn: {
	    height: "55px",
	    color: "#000",
	    cursor: "pointer",
	    fontWeight: "bold",
	    fontSize: "16px",
	    paddingLeft: "20px",
	    paddingRight: "20px"
	  },
	  tableTd: {
	    paddingLeft: "20px",
	    paddingRight: "20px",
	    height: "55px",
	    fontSize: "16px",
	    borderBottom: "solid 1px #EBE8EF"
	  },
	  tableHeaderSortedColumn: {
	    height: "55px",
	    color: "#000",
	    cursor: "pointer",
	    fontWeight: "bold",
	    fontSize: "16px",
	    backgroundColor: "#E3E3E3",
	    paddingLeft: "20px",
	    paddingRight: "20px",
	    backgroundClip: "padding-box"
	  },
	  tableRowColumn: {
	    position: "relative"
	  },
	  settingStyle: {
	    position: "absolute",
	    right: "6em",
	    top: "0.9em",
	    cursor: "pointer"
	  }
	};
	
	var BusinessUnits = function (_Component) {
	  _inherits(BusinessUnits, _Component);
	
	  function BusinessUnits(props) {
	    _classCallCheck(this, BusinessUnits);
	
	    var _this = _possibleConstructorReturn(this, (BusinessUnits.__proto__ || Object.getPrototypeOf(BusinessUnits)).call(this, props));
	
	    _this.state = {
	      open: false,
	      showClientProfile: false
	    };
	    return _this;
	  }
	
	  _createClass(BusinessUnits, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.getClientProfile(this.props.match.params.id); // when user click back button from business detail page get the client detail.
	      this.props.getTierOptions();
	      this.props.getClientBusiness(this.props.match.params.id);
	      this.props.get_client_options();
	      this.props.getIndustryOptions();
	      this.props.getTeamMember(this.props.match.params.id); // get business assign to data for ClientProfile
	      this.props.getBusinessUnitOptions(); //get business units options for industry dialog component
	    }
	  }, {
	    key: "handleOpenDialog",
	    value: function handleOpenDialog() {
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: "handleCloseDialog",
	    value: function handleCloseDialog() {
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: "handleSendInvite",
	    value: function handleSendInvite() {}
	  }, {
	    key: "handleInviteAnotherClient",
	    value: function handleInviteAnotherClient() {
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: "handleCreateClientProfile",
	    value: function handleCreateClientProfile() {
	      this.setState({
	        showClientProfile: true
	      });
	    }
	  }, {
	    key: "clientProfileCancel",
	    value: function clientProfileCancel() {
	      this.setState({
	        showClientProfile: false
	      });
	
	      this.props.getClientBusiness(this.props.match.params.id);
	      this.props.getBusinessUnitOptions(); // get business unit options
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "business-units" },
	        !this.state.showClientProfile ? _react2.default.createElement(
	          "div",
	          { className: "business" },
	          _react2.default.createElement(
	            "h1",
	            null,
	            this.props.edit_client_profile.name !== undefined && (0, _utility.toCapitalize)(this.props.edit_client_profile.name),
	            " ",
	            "Business Units"
	          ),
	          _react2.default.createElement(
	            "table",
	            { style: { width: "100%" } },
	            _react2.default.createElement(
	              "thead",
	              { style: styles.tableHeaderStyle },
	              _react2.default.createElement(
	                "tr",
	                null,
	                [{ name: "Name", value: "name" }, { name: "Location", value: "location" }, { name: "Status", value: "status" }, { name: "Subscription Tier", value: "tier" }].map(function (item, index) {
	                  if (index === 0) {
	                    return _react2.default.createElement(
	                      "th",
	                      {
	                        style: Object.assign({}, styles.tableHeaderColumn, { width: "30%" }),
	                        key: index
	                      },
	                      item.name
	                    );
	                  } else if (index === 1) {
	                    return _react2.default.createElement(
	                      "th",
	                      {
	                        style: Object.assign({}, styles.tableHeaderColumn, { width: "25%" }),
	                        key: index
	                      },
	                      item.name
	                    );
	                  } else if (index === 2) {
	                    return _react2.default.createElement(
	                      "th",
	                      {
	                        style: Object.assign({}, styles.tableHeaderColumn, { width: "23%" }),
	                        key: index
	                      },
	                      item.name
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      "th",
	                      { style: Object.assign({}, styles.tableHeaderColumn), key: index },
	                      item.name
	                    );
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              this.props.business_units_list.map(function (item) {
	                return _react2.default.createElement(
	                  "tr",
	                  { key: item.id },
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.tableTd },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "/clients/edit/Business-Units/detail/" + _this2.props.match.params.id + "/" + encodeURIComponent(item.name) + "/" + item.id
	                      },
	                      item.name
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.tableTd },
	                    item.city.length > 0 ? item.city + "," : "",
	                    " ",
	                    item.state
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.tableTd },
	                    item.status
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { style: styles.tableTd },
	                    item.subscription && item.subscription.name
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "btns" },
	            _react2.default.createElement(
	              "button",
	              {
	                style: { background: (0, _utility.buttonBlueColor)(), fontSize: "16px" },
	                onClick: function onClick() {
	                  return _this2.handleCreateClientProfile();
	                }
	              },
	              "Create Business Unit Profile"
	            )
	          ),
	          _react2.default.createElement(_IndustryDialog2.default, {
	            open: this.state.open,
	            roleName: "administrator",
	            handleCloseDialog: function handleCloseDialog() {
	              return _this2.handleCloseDialog();
	            },
	            ifSendInvitationSuccess: this.props.ifSendInvitationSuccess,
	            handleSendInvite: function handleSendInvite() {
	              return _this2.handleSendInvite();
	            },
	            industryOptions: this.props.industryOptions,
	            tier_options: this.props.tier_options,
	            account_manager: this.props.account_manager,
	            send_invitation: this.props.send_invitation,
	            send_invitation_error_msg: this.props.send_invitation_error_msg,
	            invitation_client: this.props.invitation_client,
	            client_options: /^(team member)/gi.test(this.props.roleName) ? [{ value: 51, label: "Administrator" }, { value: 52, label: "Team Member" }, { value: 53, label: "Business Unit Member" }] : this.props.client_options,
	            handleInviteAnotherClient: function handleInviteAnotherClient() {
	              return _this2.handleInviteAnotherClient();
	            },
	            rollbackStatus: this.props.rollbackStatus,
	            client_names: this.props.client_names,
	            businessUnitOptions: this.props.businessUnitOptions,
	            inviteBusinessMember: this.props.inviteBusinessMember
	          })
	        ) : _react2.default.createElement(_ClientProfile2.default, {
	          ifCreateClientProfileSuccessBasic: this.props.ifCreateClientProfileSuccessBasic,
	          clientId: this.props.clientId,
	          configInsightsStandard: this.props.configInsightsStandard,
	          roleInfo: this.props.roleName,
	          path: this.props.match.path,
	          getStates: this.props.getStates,
	          allstates: this.props.allstates,
	          getTimezone: this.props.getTimezone,
	          timezone: this.props.timezone,
	          getRoles: this.props.getRoles,
	          roles: this.props.roles,
	          clientProfileCancel: function clientProfileCancel() {
	            return _this2.clientProfileCancel();
	          },
	          ifUpdateSuccess: this.props.ifUpdateSuccess,
	          loginUserDetail: this.props.loginUserDetail,
	          tier_options: this.props.tier_options,
	          industryOptions: this.props.industryOptions,
	          token: this.props.token,
	          roleName: "administrator",
	          account_manager: this.props.account_manager,
	          createClientProfile: (0, _lodash.isEmpty)(this.props.match.params.id) ? this.props.createClientProfile : this.props.createClientBusinessUnit,
	          createClientProfileMessage: this.props.createClientProfileMessage,
	          ifCreateClientProfileSuccess: this.props.ifCreateClientProfileSuccess,
	          rollbackProfileStatus: this.props.rollbackProfileStatus,
	          paramId: this.props.match.params.id,
	          teamMember_options: this.props.teamMember_options // for business assign array data
	        })
	      );
	    }
	  }]);
	
	  return BusinessUnits;
	}(_react.Component);
	
	exports.default = BusinessUnits;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _RadioButton = __webpack_require__(107);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	__webpack_require__(395);
	
	var _clear = __webpack_require__(109);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _groupBy = __webpack_require__(150);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _CustomSelect = __webpack_require__(260);
	
	var _CustomSelect2 = _interopRequireDefault(_CustomSelect);
	
	var _Grid = __webpack_require__(19);
	
	var _reactTextMask = __webpack_require__(247);
	
	var _reactTextMask2 = _interopRequireDefault(_reactTextMask);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BusinessUnitsDetail = __webpack_require__(513);
	
	var _BusinessUnitsDetail2 = _interopRequireDefault(_BusinessUnitsDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// add business unit detail component
	
	
	var validator = __webpack_require__(393);
	
	var suspendDialogStyle = {
	  cancel: {
	    height: "30px",
	    background: "white",
	    color: "black",
	    border: "1px solid black",
	    fontWeight: "bold",
	    marginRight: "10px",
	    padding: "0 10px",
	    fontSize: "12px"
	  },
	  suspend: {
	    height: "30px",
	    background: "#DD0000",
	    color: "white",
	    border: "none",
	    fontWeight: "bold",
	    padding: "0 10px",
	    fontSize: "12px"
	  }
	};
	var styles = {
	  iconStyle: {
	    fill: "#000000",
	    transform: "scale(0.9)",
	    WebkitTransform: "scale(0.9)",
	    MsTransform: "scale(0.9)",
	    MozTransform: "scale(0.9)",
	    marginRight: "13px",
	    marginLeft: "-1px"
	  },
	  labelStyle: {
	    fontSize: "16px",
	    lineHeight: "15px",
	    marginBottom: 0,
	    paddingTop: "3px",
	    fontWeight: "normal"
	  }
	};
	
	var ClientProfile = function (_Component) {
	  _inherits(ClientProfile, _Component);
	
	  function ClientProfile(props) {
	    _classCallCheck(this, ClientProfile);
	
	    var _this = _possibleConstructorReturn(this, (ClientProfile.__proto__ || Object.getPrototypeOf(ClientProfile)).call(this, props));
	
	    _this.throttle = true;
	    _this.state = {
	      showDowngradeConfirm: false,
	      ifShowSuspend: false,
	      ifHiddenTopEdit: true,
	      ifShowBusinessDetail: false, // when administrator login in the value will be trued
	      timezoneValue: "",
	      stateValue: "",
	      industryGroupObj: [{ label: "", options: [] }],
	      status: "",
	      campaignReportPreference: "",
	      audienceResolutionGranularity: "Scale",
	      industry: {
	        id: "",
	        name: ""
	      },
	      subscription: {
	        id: "",
	        name: ""
	      },
	      accountManagers: [{
	        id: "",
	        firstName: "",
	        lastName: ""
	      }],
	      requestParams: {
	        name: "",
	        address1: "",
	        address2: "",
	        city: "",
	        state: "",
	        zipCode: "",
	        phone: "",
	        timezone: "",
	        industryId: "",
	        subscriptionTierId: "",
	        accountManagerUserIds: [""],
	        campaignReportPreference: ""
	      }
	    };
	    return _this;
	  }
	
	  _createClass(ClientProfile, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.getClientProfile(this.props.match.params.id);
	      // set localStorage for Index.jsx edit/client-team-member url
	      localStorage.setItem("editClientId", this.props.match.params.id);
	      this.props.getTimezone();
	      this.props.getIndustryOptions();
	      this.props.getTierOptions();
	      if (/^(system administrator|account manager)/gi.test(JSON.parse(localStorage.getItem("session")).roleName)) {
	        this.props.getAccountManage();
	      }
	      this.props.getStates();
	      if (this.props.edit_client_profile.subscriptionTierId >= 3) {
	        this.props.getConfigInsightsStandard(this.props.match.params.id);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.edit_client_profile.subscriptionTierId >= 3 && nextProps.edit_client_profile.subscriptionTierId != 5 && nextProps.insights_standard_config === "") {
	        nextProps.getConfigInsightsStandard(nextProps.match.params.id);
	      }
	      if (nextProps.industryOptions.length > 0) {
	        var industryGroup = (0, _groupBy2.default)(nextProps.industryOptions, "group");
	        var obj = [];
	        for (var x in industryGroup) {
	          obj.push({
	            label: x,
	            options: industryGroup[x]
	          });
	        }
	        this.setState({
	          industryGroupObj: obj
	        });
	      }
	
	      if (nextProps.edit_client_profile.name) {
	        var _nextProps$edit_clien = nextProps.edit_client_profile,
	            name = _nextProps$edit_clien.name,
	            address1 = _nextProps$edit_clien.address1,
	            address2 = _nextProps$edit_clien.address2,
	            city = _nextProps$edit_clien.city,
	            state = _nextProps$edit_clien.state,
	            status = _nextProps$edit_clien.status,
	            zipCode = _nextProps$edit_clien.zipCode,
	            phone = _nextProps$edit_clien.phone,
	            timezone = _nextProps$edit_clien.timezone,
	            industryId = _nextProps$edit_clien.industryId,
	            subscriptionTierId = _nextProps$edit_clien.subscriptionTierId,
	            accountManagerUserIds = _nextProps$edit_clien.accountManagerUserIds,
	            industry = _nextProps$edit_clien.industry,
	            accountNumber = _nextProps$edit_clien.accountNumber,
	            subscription = _nextProps$edit_clien.subscription,
	            accountManagers = _nextProps$edit_clien.accountManagers,
	            contractNumber = _nextProps$edit_clien.contractNumber,
	            campaignReportPreference = _nextProps$edit_clien.campaignReportPreference,
	            clientReportDetailSetting = _nextProps$edit_clien.clientReportDetailSetting,
	            audienceResolutionGranularity = _nextProps$edit_clien.audienceResolutionGranularity,
	            email = _nextProps$edit_clien.email,
	            salesForceId = _nextProps$edit_clien.salesForceId;
	
	        if (nextProps.allstates.length > 0) {
	          var stateValue = nextProps.allstates.filter(function (item) {
	            return item.value === state;
	          }).length !== 0 && nextProps.allstates.filter(function (item) {
	            return item.value === state;
	          })[0].label;
	          this.setState({
	            stateValue: stateValue
	          });
	        }
	        if (timezone.length > 0) {
	          var timezoneValue = nextProps.timezone.filter(function (item) {
	            return item.value === timezone;
	          }).length !== 0 && nextProps.timezone.filter(function (item) {
	            return item.value === timezone;
	          })[0].label;
	          this.setState({
	            timezoneValue: timezoneValue
	          });
	        }
	        this.setState({
	          status: status, // status can ben suspend or active,
	          industry: typeof industry !== "undefined" && industry,
	          subscription: typeof subscription !== "undefined" && subscription,
	          accountManagers: typeof accountManagers !== "undefined" && accountManagers,
	          audienceResolutionGranularity: audienceResolutionGranularity,
	          requestParams: Object.assign({}, this.state.requestParams, {
	            name: name,
	            address1: address1,
	            address2: address2,
	            city: city,
	            state: state,
	            status: status,
	            zipCode: zipCode,
	            phone: phone,
	            timezone: timezone,
	            industryId: industryId,
	            accountNumber: accountNumber,
	            subscriptionTierId: subscriptionTierId,
	            accountManagerUserIds: accountManagerUserIds,
	            campaignReportPreference: campaignReportPreference,
	            email: email,
	            contractNumber: typeof contractNumber === "undefined" ? "" : contractNumber,
	            salesForceId: salesForceId,
	            clientReportDetailSetting: clientReportDetailSetting
	          })
	        });
	      }
	    }
	  }, {
	    key: "handleEdit",
	    value: function handleEdit() {
	      // if (/^(account manager|system administrator|administrator|team member)/gi.test(this.props.roleName)) {
	      //   if (!this.state.ifHiddenTopEdit) {
	      //     this.props.getClientProfile(this.props.match.params.id);
	      //   }
	      //   this.setState({
	      //     ifHiddenTopEdit: !this.state.ifHiddenTopEdit
	      //   })
	      // }
	      if (/^(account manager|system administrator|administrator|team member)/gi.test(this.props.roleName)) {
	        this.setState({
	          ifShowBusinessDetail: true,
	          ifHiddenTopEdit: false
	        });
	      }
	    }
	  }, {
	    key: "handleTimeZoneChange",
	    value: function handleTimeZoneChange(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          timezone: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleIndustryChange",
	    value: function handleIndustryChange(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          industryId: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleSubscriptionTierChange",
	    value: function handleSubscriptionTierChange(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          subscriptionTierId: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleReassignTo",
	    value: function handleReassignTo(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          accountManagerUserIds: [value]
	        })
	      });
	    }
	  }, {
	    key: "handleUpdate",
	    value: function handleUpdate() {
	      if (this.props.edit_client_profile.subscriptionTierId >= 3 && this.props.edit_client_profile.subscriptionTierId != 5 && this.state.requestParams.subscriptionTierId === 2) {
	        var requestParams = this.state.requestParams;
	
	        requestParams.insightsStandardConfig["segmentationSystem"] = null;
	        requestParams.insightsStandardConfig["appendSegmentation"] = null;
	        requestParams.insightsStandardConfig["segmentationLicenseNumber"] = null;
	        requestParams.insightsStandardConfig["licenseExpirationDate"] = null;
	        this.setState({
	          showDowngradeConfirm: true
	        });
	      } else {
	        console.log(this.state.requestParams);
	        if (this.state.requestParams.subscriptionTierId === 5) {
	          this.setState({
	            requiredEmailText: ""
	          });
	          if (this.state.requestParams.email.trim().length === 0) {
	            this.setState({
	              requiredEmailText: "Please enter email address"
	            });
	            return;
	          } else {
	            if (!validator.validate(this.state.requestParams.email.trim())) {
	              this.setState({
	                requiredEmailText: "Invalid email address"
	              });
	              return;
	            }
	          }
	        }
	        var _requestParams = this.state.requestParams;
	
	        if (_requestParams.subscriptionTierId === 4) {
	          _requestParams.insightsStandardConfig["segmentationSystem"] = this.state.segmentationSystem ? this.state.segmentationSystem : "prizm_premier";
	          _requestParams.insightsStandardConfig["appendSegmentation"] = this.state.appendSegmentation ? this.state.appendSegmentation : false;
	          if (this.state.appendSegmentation === true) {
	            _requestParams.insightsStandardConfig["segmentationLicenseNumber"] = this.state.licenseNum;
	            _requestParams.insightsStandardConfig["licenseExpirationDate"] = this.state.expYear + "-" + this.state.expMonth + "-01";
	          } else {
	            _requestParams.insightsStandardConfig["segmentationLicenseNumber"] = null;
	            _requestParams.insightsStandardConfig["licenseExpirationDate"] = null;
	          }
	        }
	        if (_requestParams.accountManagerUserIds && _requestParams.accountManagerUserIds.length > 0 && _requestParams.accountManagerUserIds[0] === "") {
	          _requestParams.accountManagerUserIds = undefined;
	        } else {
	          var vals = (0, _map2.default)(_requestParams.accountManagerUserIds[0], "value");
	          _requestParams.accountManagerUserIds = vals;
	        }
	
	        this.props.updateClientProfile(this.props.match.params.id, this.state.requestParams);
	      }
	    }
	  }, {
	    key: "handleClose",
	    value: function handleClose() {
	      this.props.getClientProfile(this.props.match.params.id);
	      this.setState({
	        ifHiddenTopEdit: true
	      });
	      this.props.rollbackProfileStatus();
	    }
	  }, {
	    key: "handleAddress1",
	    value: function handleAddress1(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address1: value
	        })
	      });
	    }
	  }, {
	    key: "handleAddress2",
	    value: function handleAddress2(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address2: value
	        })
	      });
	    }
	  }, {
	    key: "handleCity",
	    value: function handleCity(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          city: value
	        })
	      });
	    }
	  }, {
	    key: "handleState",
	    value: function handleState(value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          state: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleZipCode",
	    value: function handleZipCode(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          zipCode: value
	        })
	      });
	    }
	  }, {
	    key: "handlePhone",
	    value: function handlePhone(e) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          phone: e.target.value
	        })
	      });
	    }
	  }, {
	    key: "handleSuspendUser",
	    value: function handleSuspendUser() {
	      this.setState({
	        ifShowSuspend: true
	      });
	    }
	  }, {
	    key: "handleCancelSuspend",
	    value: function handleCancelSuspend() {
	      this.setState({
	        ifShowSuspend: false
	      });
	    }
	  }, {
	    key: "suspendUser",
	    value: function suspendUser() {
	      var clientId = this.props.match.params.id;
	      var status = void 0;
	      if (this.state.status === "Suspended") {
	        status = "reactivate";
	      } else if (this.state.status === "Active") {
	        status = "suspend";
	      }
	      this.props.suspendAndReactivate(clientId, status);
	    }
	  }, {
	    key: "handleTitle",
	    value: function handleTitle(e, value) {
	      //e.preventDefault();
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          name: value
	        })
	      });
	    }
	  }, {
	    key: "handleAccountNumber",
	    value: function handleAccountNumber(e, value) {
	      e.preventDefault();
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          accountNumber: value
	        })
	      });
	    }
	  }, {
	    key: "handleCancel",
	    value: function handleCancel() {
	      /*
	      this.setState({
	        ifShowBusinessDetail: false
	      })*/
	      window.location.reload();
	    }
	  }, {
	    key: "handleTopLocationReportCheck",
	    value: function handleTopLocationReportCheck(e, isChecked) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          clientReportDetailSetting: {
	            topLocationChannelReport: isChecked ? 1 : 0
	          }
	        })
	      });
	    }
	  }, {
	    key: "handleEmail",
	    value: function handleEmail(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          email: value
	        })
	      });
	    }
	  }, {
	    key: "handleChangeEmail",
	    value: function handleChangeEmail(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          email: value
	        })
	      });
	    }
	  }, {
	    key: "ifShowAssignTo",
	    value: function ifShowAssignTo() {
	      var ds = /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname) && /^administrator/gi.test(this.props.roleName) ? this.props.teamMember_options : this.props.account_manager;
	
	      if (/^(system administrator)/gi.test(this.props.roleName)) {
	        return true && !(0, _isEmpty2.default)(ds);
	      }
	      if (/^account manager/gi.test(this.props.roleName) && /^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname)) {
	        return true && !(0, _isEmpty2.default)(ds);
	      }
	      if (/^administrator/gi.test(this.props.roleName) && (/^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname) || /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname))) {
	        return true && !(0, _isEmpty2.default)(ds);
	      }
	
	      if (/^team member/gi.test(this.props.roleName) && /^\/clients\/edit\/Business-Units\/detail/g.test(this.props.location.pathname)) {
	        return false;
	      }
	    }
	  }, {
	    key: "saveDowngradeClient",
	    value: function saveDowngradeClient(e) {
	      e.preventDefault();
	      this.props.updateClientProfile(this.props.match.params.id, this.state.requestParams);
	      this.setState({ showDowngradeConfirm: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "edit-client-profile" },
	        !this.state.ifShowBusinessDetail && _react2.default.createElement(
	          "div",
	          { className: "edit-client-box" },
	          this.state.ifHiddenTopEdit && _react2.default.createElement("div", { className: "edit-client-shadow" }),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: /^(account manager|system administrator)/gi.test(this.props.roleName) ? "Client Name" : "Business Unit Name",
	              onChange: function onChange(e, value) {
	                _this2.handleTitle(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.name,
	              hintText: this.state.requestParams.name,
	              ifRequireField: true,
	              borderColor: "#B1B0B0",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "40px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "profile-fn-wrapper clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "none",
	                marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  float: "left",
	                  fontSize: "16px",
	                  fontWeight: "bolder",
	                  width: "30%"
	                }
	              },
	              "Profile Creation Date"
	            ),
	            _react2.default.createElement(
	              "strong",
	              {
	                style: {
	                  float: "left",
	                  paddingLeft: "10px",
	                  fontWeight: "normal"
	                }
	              },
	              this.props.edit_client_profile.createdTime && (0, _moment2.default)(this.props.edit_client_profile.createdTime).format("M/D/YYYY")
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "profile-fn-wrapper clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "none",
	                marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  float: "left",
	                  fontSize: "16px",
	                  fontWeight: "bolder",
	                  width: "30%"
	                }
	              },
	              "Status"
	            ),
	            _react2.default.createElement(
	              "strong",
	              {
	                style: {
	                  float: "left",
	                  paddingLeft: "10px",
	                  fontWeight: "normal"
	                }
	              },
	              this.state.requestParams.status
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: /^(account manager|system administrator)/gi.test(this.props.roleName) ? "Client Address 1" : "Business Unit Address 1",
	              onChange: function onChange(e, value) {
	                return _this2.handleAddress1(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.address1,
	              hintText: this.state.requestParams.address1,
	              borderColor: "black",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "40px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: /^(account manager|system administrator)/gi.test(this.props.roleName) ? "Client Address 2" : "Business Unit Address 2",
	              onChange: function onChange(e, value) {
	                return _this2.handleAddress2(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.address2,
	              hintText: this.state.requestParams.address2,
	              borderColor: "black",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "40px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: "City",
	              onChange: function onChange(e, value) {
	                return _this2.handleCity(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.city,
	              hintText: this.state.requestParams.city,
	              borderColor: "black",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "40px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "State"
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "68%" } },
	              this.state.stateValue
	            ) : _react2.default.createElement(_reactSelect2.default, {
	              className: "client-profile-timezone edit-state",
	              value: this.state.requestParams.state,
	              clearable: false,
	              options: this.props.allstates,
	              onChange: function onChange(value) {
	                return _this2.handleState(value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: "Zip Code",
	              onChange: function onChange(e, value) {
	                return _this2.handleZipCode(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.zipCode,
	              hintText: this.state.requestParams.zipCode,
	              borderColor: "black",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "40px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Time Zone",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "68%" } },
	              this.state.timezoneValue
	            ) : _react2.default.createElement(_reactSelect2.default, {
	              className: "client-profile-timezone edit-timezone",
	              value: this.state.requestParams.timezone,
	              clearable: false,
	              options: this.props.timezone,
	              onChange: function onChange(value) {
	                return _this2.handleTimeZoneChange(value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "profile-mobile-phone-number clearfix",
	              style: {
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                style: { marginTop: this.state.ifHiddenTopEdit ? "" : "10px" }
	              },
	              "Mobile Phone Number"
	            ),
	            _react2.default.createElement(_reactTextMask2.default, {
	              className: "mp-mask",
	              guide: false,
	              value: this.state.requestParams.phone,
	              style: {
	                border: this.state.ifHiddenTopEdit ? "" : "1px solid #E8EBEF",
	                height: this.state.ifHiddenTopEdit ? "" : "32px"
	              },
	              mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
	              onChange: function onChange(e) {
	                return _this2.handlePhone(e);
	              }
	            })
	          ),
	          /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(this.props.roleName) && _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Subscription Tier",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "68%" } },
	              this.state.subscription.name
	            ) :
	            /*<Select
	                className="client-profile-stimezone edit-subscription"
	                value={this.state.requestParams.subscriptionTierId}
	                clearable={false}
	                options={this.props.tier_options}
	                onChange={(value) => this.handleSubscriptionTierChange(value)}
	              />*/
	            _react2.default.createElement(
	              _RadioButton.RadioButtonGroup,
	              {
	                name: "clientTier",
	                valueSelected: this.state.requestParams.subscriptionTierId,
	                onChange: function onChange(e, value) {
	                  return _this2.handleSubscriptionTierChange(value);
	                }
	              },
	              _react2.default.createElement(_RadioButton.RadioButton, {
	                value: 2,
	                label: "Basic",
	                iconStyle: {
	                  fill: "black",
	                  width: "20px",
	                  height: "20px"
	                }
	              }),
	              _react2.default.createElement(_RadioButton.RadioButton, {
	                value: 3,
	                label: "Standard",
	                iconStyle: {
	                  fill: "black",
	                  width: "20px",
	                  height: "20px"
	                }
	              }),
	              _react2.default.createElement(_RadioButton.RadioButton, {
	                value: 4,
	                label: "Professional1",
	                iconStyle: {
	                  fill: "black",
	                  width: "20px",
	                  height: "20px"
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              key: "account-num-input",
	              labelTitle: "Account Number",
	              onChange: function onChange(e, value) {
	                return _this2.handleAccountNumber(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.accountNumber,
	              hintText: this.state.requestParams.accountNumber,
	              ifRequireField: false,
	              borderColor: "black",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "40px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          /^(account manager|system administrator)/gi.test(this.props.roleName) && _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: "Contract Number",
	              onChange: function onChange(e, value) {
	                return _this2.handleTitle(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.contractNumber,
	              hintText: this.state.requestParams.contractNumber,
	              ifRequireField: /^(account manager)/gi.test(this.props.roleName),
	              borderColor: "black",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "40px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              maxLength: 20,
	              labelTitle: "Salesforce ID",
	              onChange: function onChange(e, value) {
	                return _this2.handleTitle(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.salesForceId,
	              hintText: this.state.requestParams.salesForceId,
	              ifRequireField: false,
	              borderColor: "black",
	              labelStyle: {
	                float: "left",
	                fontSize: "16px",
	                fontWeight: "bolder",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "40px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            })
	          ),
	          /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName) && _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Subscription Tier",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "68%" } },
	              this.state.subscription.name
	            ) : _react2.default.createElement(_reactSelect2.default, {
	              className: "client-profile-stimezone edit-subscription",
	              value: this.state.requestParams.subscriptionTierId,
	              clearable: false,
	              options: this.props.tier_options,
	              onChange: function onChange(value) {
	                return _this2.handleSubscriptionTierChange(value);
	              }
	            })
	          ),
	          /^(system administrator|account manager)/gi.test(this.props.roleName) && this.state.requestParams.subscriptionTierId === 5 && _react2.default.createElement(
	            "div",
	            { className: "profile-fn-wrapper" },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: "Email",
	              maxLength: 120,
	              handleOnBlur: function handleOnBlur(e, value) {
	                return _this2.handleEmail(e, value);
	              },
	              onChange: function onChange(e, value) {
	                return _this2.handleChangeEmail(e, value);
	              },
	              ifHasBorder: this.state.ifHiddenTopEdit,
	              initValue: this.state.requestParams.email === null ? "" : this.state.requestParams.email,
	              ifRequireField: true,
	              borderCorlor: "black",
	              labelStyle: {
	                float: "left",
	                fontWeight: "bolder",
	                fontSize: "16px",
	                width: "30%",
	                margin: 0
	              },
	              inputContainerId: "firstName",
	              style: {
	                lineHeight: "40px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	              }
	            }),
	            this.state.requiredEmailText && _react2.default.createElement(
	              "p",
	              { className: "create-account-field-error clearfix" },
	              _react2.default.createElement(Error, { style: { float: "left" }, color: "red" }),
	              _react2.default.createElement(
	                "span",
	                null,
	                this.state.requiredEmailText
	              )
	            )
	          ),
	          /^(system administrator|account manager)/gi.test(this.props.roleName) && this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId < 5 && _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "31.3%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Account Download Options",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { float: "left" } },
	              this.state.audienceResolutionGranularity
	            )
	          ),
	          /^(system administrator|account manager)/gi.test(this.props.roleName) && (this.state.requestParams.subscriptionTierId >= 3 && this.state.requestParams.subscriptionTierId != 5 || this.state.requestParams.subscriptionTierId === 1) && _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "31.3%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Data Source",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { float: "left" } },
	              _react2.default.createElement(
	                "section",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Consumer"
	                ),
	                " -",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  this.props.insights_standard_config !== "" && this.props.insights_standard_config.consumerDataSource
	                )
	              ),
	              _react2.default.createElement(
	                "section",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Business"
	                ),
	                " -",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  this.props.insights_standard_config !== "" && this.props.insights_standard_config.businessDataSource
	                )
	              )
	            )
	          ),
	          /^(system administrator|account manager)/gi.test(this.props.roleName) && _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: this.state.ifHiddenTopEdit ? {
	                lineHeight: "42px",
	                borderBottom: "1px solid #E8EBEF",
	                marginBottom: "0px"
	              } : { lineHeight: "32px", marginBottom: "30px" }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Campaign Reporting ",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "ml-10 pull-left" },
	              this.state.requestParams.campaignReportPreference && (this.state.requestParams.campaignReportPreference === "Detailed" ? "Detailed Campaign Reporting" : "Aggregate")
	            ) : _react2.default.createElement(
	              "div",
	              {
	                style: { float: "left", minWidth: "400px", width: "68%" }
	              },
	              _react2.default.createElement(
	                _RadioButton.RadioButtonGroup,
	                {
	                  name: "reportType",
	                  valueSelected: this.state.requestParams.campaignReportPreference,
	                  onChange: function onChange(e, value) {
	                    e.preventDefault();
	                  }
	                },
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: "Aggregated",
	                  label: "Aggregate",
	                  iconStyle: {
	                    fill: "black",
	                    width: "20px",
	                    height: "20px"
	                  }
	                }),
	                _react2.default.createElement(_RadioButton.RadioButton, {
	                  value: "Detailed",
	                  label: "Detailed Campaign Reporting",
	                  iconStyle: {
	                    fill: "black",
	                    width: "20px",
	                    height: "20px"
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "pt-10",
	                  style: {
	                    borderTop: "solid 1px #000000",
	                    display: this.state.requestParams.campaignReportPreference === "Detailed" ? "block" : "none"
	                  }
	                },
	                _react2.default.createElement(_Checkbox2.default, {
	                  label: "Display Top Locations on Channel Reports",
	                  checked: this.state.requestParams.clientReportDetailSetting && this.state.requestParams.clientReportDetailSetting.topLocationChannelReport,
	                  onCheck: function onCheck(e, isInputChecked) {
	                    return _this2.handleTopLocationReportCheck(e, isInputChecked);
	                  },
	                  iconStyle: styles.iconStyle,
	                  labelStyle: styles.labelStyle
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              "Industry Type",
	              _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "68%" } },
	              this.state.industry.name
	            ) : _react2.default.createElement(_CustomSelect2.default, {
	              placeholder: "Select Industry Type",
	              options: this.state.industryGroupObj,
	              rootStyles: {
	                float: "left",
	                width: "68%",
	                border: "1px solid #E8EBEF"
	              },
	              onChange: function onChange(value) {
	                return _this2.handleIndustryChange(value);
	              },
	              initValue: this.state.requestParams.industryId
	            })
	          ),
	          this.ifShowAssignTo() && _react2.default.createElement(
	            "div",
	            {
	              className: "role clearfix",
	              style: {
	                lineHeight: "42px",
	                borderBottom: this.state.ifHiddenTopEdit ? "1px solid #E8EBEF" : "",
	                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  fontSize: "16px",
	                  float: "left",
	                  width: "30%",
	                  margin: 0,
	                  fontWeight: "bolder"
	                }
	              },
	              /^(administrator|team member)/gi.test(this.props.roleName) ? "Assign Business Unit to" : "Assign Client to",
	              /^system administrator/gi.test(this.props.roleName) && _react2.default.createElement(
	                "em",
	                { style: { color: "red" } },
	                "*"
	              )
	            ),
	            this.state.ifHiddenTopEdit ? _react2.default.createElement(
	              "div",
	              { className: "pull-left pl-10", style: { width: "68%" } },
	              (0, _map2.default)(this.state.accountManagers, function (data) {
	                return data.firstName + " " + data.lastName;
	              }).join(", ")
	            ) : _react2.default.createElement(_reactSelect2.default, {
	              className: "client-profile-timezone",
	              value: this.state.requestParams.accountManagerUserIds,
	              clearable: false,
	              options: this.props.account_manager,
	              multi: true,
	              simpleValue: true,
	              onChange: function onChange(value) {
	                return _this2.handleReassignTo(value);
	              }
	            })
	          ),
	          this.state.ifHiddenTopEdit ? _react2.default.createElement(
	            "div",
	            { className: "btns" },
	            _react2.default.createElement(
	              "button",
	              { className: "edit", onClick: function onClick() {
	                  return _this2.handleEdit();
	                } },
	              "EDIT"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "suspend",
	                onClick: function onClick() {
	                  return _this2.handleSuspendUser();
	                }
	              },
	              this.state.status === "Active" && "SUSPEND",
	              this.state.status === "Suspended" && "REACTIVATE",
	              " ",
	              /^(account manager|system administrator)/gi.test(this.props.roleName) ? "CLIENT" : "BUSINESS UNIT"
	            )
	          ) : _react2.default.createElement(
	            "div",
	            { className: "btns" },
	            _react2.default.createElement(
	              "button",
	              { className: "cancel", onClick: function onClick() {
	                  return _this2.handleEdit();
	                } },
	              "CANCEL"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "save",
	                disabled: !this.state.accountManagerUserIds,
	                onClick: function onClick() {
	                  return _this2.handleUpdate();
	                }
	              },
	              "SAVE"
	            )
	          )
	        ),
	        this.state.ifShowBusinessDetail && _react2.default.createElement(_BusinessUnitsDetail2.default, Object.assign({}, this.props, {
	          editMode: true,
	          handleCancel: function handleCancel() {
	            return _this2.handleCancel();
	          },
	          match: {
	            params: {
	              businessUnitId: this.props.match.params.id
	            }
	          }
	        })),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            modal: true,
	            contentStyle: { width: "40%" },
	            open: this.props.ifEditClientProfileSuccess,
	            bodyStyle: { padding: "20px" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "clearfix", style: { position: "relative" } },
	            _react2.default.createElement(_clear2.default, {
	              style: {
	                position: "absolute",
	                right: "0em",
	                cursor: "pointer",
	                top: "0em"
	              },
	              onClick: function onClick() {
	                return _this2.handleClose();
	              }
	            }),
	            _react2.default.createElement(
	              "h2",
	              {
	                style: {
	                  fontSize: "16px",
	                  fontWeight: "bolder",
	                  color: "black",
	                  marginTop: "0"
	                }
	              },
	              "UPDATE CLIENT PROFILE"
	            ),
	            this.props.ifEditClientProfileSuccess && _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  textAlign: "center",
	                  color: "black",
	                  marginTop: "1.2em"
	                }
	              },
	              "The profile was updated successfully."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form-btns clearfix", style: { marginTop: "19px" } },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-link pull-right ",
	                  id: "userStatusA",
	                  style: {
	                    marginLeft: "-1.3em",
	                    border: "1px solid black",
	                    fontWeight: "bolder",
	                    padding: "7px 17px",
	                    borderRadius: "0",
	                    marginRight: "0.8em"
	                  },
	                  onClick: function onClick(e) {
	                    return _this2.handleClose();
	                  }
	                },
	                "Close"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          { modal: false, open: this.state.ifShowSuspend },
	          _react2.default.createElement(
	            "p",
	            { style: { textAlign: "center", color: "black" } },
	            "Are you sure you would like to",
	            " ",
	            this.state.status === "Active" ? "suspend" : "reactivate",
	            " this",
	            " ",
	            /^(administrator|team member)/gi.test(this.props.roleName) ? "business unit" : "client",
	            "?"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "btns", style: { textAlign: "center" } },
	            _react2.default.createElement(
	              "button",
	              {
	                style: suspendDialogStyle.cancel,
	                onClick: function onClick() {
	                  return _this2.handleCancelSuspend();
	                }
	              },
	              "CANCEL"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                style: suspendDialogStyle.suspend,
	                onClick: function onClick() {
	                  return _this2.suspendUser();
	                }
	              },
	              this.state.status === "Active" ? "SUSPEND" : "REACTIVATE",
	              " ",
	              /^(administrator|team member)/gi.test(this.props.roleName) ? "BUSINESS UNIT" : "CLIENT"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.showDowngradeConfirm,
	            contentStyle: { width: "435px", padding: "20px" }
	          },
	          _react2.default.createElement(
	            "p",
	            { style: { fontWeight: "bold", color: "#000" } },
	            "Changing the subscription tier to Basic will stop file exports, limit some reporting views, and limit the number of segments that can be saved."
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "text-center no-padding-bottom no-margin-bottom" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-default btn-aa-info",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this2.setState({ showDowngradeConfirm: false });
	                }
	              },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-default btn-aa-warning ml-20",
	                onClick: this.saveDowngradeClient.bind(this)
	              },
	              "Continue"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClientProfile;
	}(_react.Component);
	
	exports.default = ClientProfile;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _editClientProfile = __webpack_require__(1189);
	
	var _editClientProfile2 = _interopRequireDefault(_editClientProfile);
	
	var _editBusinessUnits = __webpack_require__(1187);
	
	var _editBusinessUnits2 = _interopRequireDefault(_editBusinessUnits);
	
	var _TeamMembers = __webpack_require__(1186);
	
	var _TeamMembers2 = _interopRequireDefault(_TeamMembers);
	
	var _userStatus = __webpack_require__(535);
	
	var _userStatus2 = _interopRequireDefault(_userStatus);
	
	var _editBusinessUnitsDetail = __webpack_require__(1188);
	
	var _editBusinessUnitsDetail2 = _interopRequireDefault(_editBusinessUnitsDetail);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _editTeamMemberDetail = __webpack_require__(1191);
	
	var _editTeamMemberDetail2 = _interopRequireDefault(_editTeamMemberDetail);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _qs = __webpack_require__(192);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(395);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// css
	
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).apply(this, arguments));
	  }
	
	  _createClass(Index, [{
	    key: "getUrlParams",
	    value: function getUrlParams() {
	      var urlArrayLike = this.props.location.pathname.split("/");
	      if (/cid/g.test(this.props.location.search)) {
	        return this.props.location.search.split("=")[1];
	      } else if (urlArrayLike.length >= 6) {
	        if (isNaN(+this.props.location.pathname.split("/")[5])) {
	          return this.props.location.pathname.split("/")[6];
	        } else {
	          return this.props.location.pathname.split("/")[5];
	        }
	      } else {
	        return this.props.location.pathname.split("/")[4];
	      }
	    }
	  }, {
	    key: "showRouteBread",
	    value: function showRouteBread() {
	      var ifShowName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var urlLinkArray = this.props.location.pathname.split("/");
	      var roleName = JSON.parse(localStorage.getItem("session")).roleName;
	      if (urlLinkArray.length >= 4 && !ifShowName) {
	        if (/^(administrator|team member)/gi.test(roleName) && urlLinkArray[3] === "Client-Profile") {
	          return "Business Unit Information";
	        } else {
	          if (/^(administrator|team member)/gi.test(roleName) && urlLinkArray[3] === "Client-Team-Members") {
	            return "Business Unit Team Members";
	          } else {
	            return urlLinkArray[3].split("-").join(" ");
	          }
	        }
	      }
	    }
	  }, {
	    key: "controlBreadStyle",
	    value: function controlBreadStyle() {
	      if (/^(\/clients\/edit\/Business-Units\/)[0-9]{1,}$/g.test(this.props.location.pathname)) {
	        return "0 13%";
	      } else if (/^\/clients\/edit\/Business-Units\/detail\/\d/g.test(this.props.location.pathname)) {
	        return "0 13%";
	      } else if (/^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname)) {
	        return "";
	      } else if (/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname)) {
	        return "0 10%";
	      } else if (/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Member/g.test(this.props.location.pathname)) {
	        return "0 10%";
	      }
	    }
	  }, {
	    key: "showDetailRouter",
	    value: function showDetailRouter(text) {
	      var regText = "/clients/edit/" + text + "/user-status";
	      var regDetailText = "/clients/edit/" + text + "/detail";
	      var regTx = "/clients/edit/" + text;
	      var reg = new RegExp(regText, "g");
	      var regT = new RegExp(regTx, "g");
	      if (new RegExp(regDetailText, "g").test(this.props.location.pathname)) {
	        return _react2.default.createElement(
	          "li",
	          { key: "li-detail" },
	          _react2.default.createElement(
	            "a",
	            { href: "/clients/edit/" + text + "/" + this.getUrlParams() },
	            this.showRouteBread()
	          )
	        );
	      }
	      if (reg.test(this.props.location.pathname)) {
	        // for system administrator | account manager CLIENT TEAM MEMBERS tab
	        if (/^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(JSON.parse(localStorage.getItem("session")).roleName)) {
	          return [_react2.default.createElement(
	            "li",
	            { key: "li-clients-list" },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "/clients/edit/" + text + "/" + _qs2.default.parse(this.props.location.search.split("?")[1]).cid + "?name=" + localStorage.getItem("clientTeamMemberName")
	              },
	              this.showRouteBread()
	            )
	          ), _react2.default.createElement(
	            "li",
	            { key: "li-pre-us" },
	            " > "
	          ), _react2.default.createElement(
	            "li",
	            { key: "li-user-status" },
	            localStorage.getItem("clientTeamMemberName")
	          )];
	        } else if (/^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(JSON.parse(localStorage.getItem("session")).roleName)) {
	          return [_react2.default.createElement(
	            "li",
	            { key: "li-clients-list" },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "/clients/edit/" + text + "/" + _qs2.default.parse(this.props.location.search.split("?")[1]).cid + "?name=" + _qs2.default.parse(this.props.location.search.split("?")[1]).name
	              },
	              this.showRouteBread()
	            )
	          ), _react2.default.createElement(
	            "li",
	            { key: "li-pre-us" },
	            " > "
	          ), _react2.default.createElement(
	            "li",
	            { key: "li-user-status" },
	            localStorage.getItem("clientTeamMemberName")
	          )];
	        } else {
	          return [_react2.default.createElement(
	            "li",
	            { key: "li-clients-list" },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "/clients/edit/" + text + "/" + this.props.location.search.replace("?cid=", "")
	              },
	              this.showRouteBread()
	            )
	          ), _react2.default.createElement(
	            "li",
	            { key: "li-pre-us" },
	            " > "
	          ), _react2.default.createElement(
	            "li",
	            { key: "li-user-status" },
	            "User Status"
	          )];
	        }
	      } else if (regT.test(this.props.location.pathname)) {
	        return _react2.default.createElement(
	          "li",
	          { key: "li-" + this.props.location.pathname },
	          this.showRouteBread()
	        );
	      }
	    }
	  }, {
	    key: "showChildCrumb",
	    value: function showChildCrumb() {
	      if (!/^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname)) {
	        if (/^\/clients\/edit\/(Business-Units|Client-Team-Members)\/detail\/\d/g.test(this.props.location.pathname)) {
	          return _react2.default.createElement(
	            "li",
	            null,
	            this.props.location.pathname.split("/")[6]
	          );
	        } else {
	          var id = this.props.location.pathname.split("/")[6];
	          var query = _qs2.default.parse(this.props.location.search.split("?")[1]);
	          if (/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname)) {
	            return _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "/clients/edit/Business-Units/detail/Team Members/" + id + "?name=" + _qs2.default.parse(this.props.location.search.split("?")[1]).businessUnitName + "&id=" + query.id
	                },
	                "Business Unit Team Members"
	              )
	            );
	          } else if (/^\/clients\/edit\/Business-Units\/detail\/Team Members/g.test(this.props.location.pathname)) {
	            return _react2.default.createElement(
	              "li",
	              null,
	              "Business Unit Team Members"
	            );
	          } else {
	            return _react2.default.createElement(
	              "li",
	              null,
	              this.props.location.pathname.split("/")[5]
	            );
	          }
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _lodash.isEmpty)(this.props.location.search)) {
	        this.props.location.search.replace("?cid=", "");
	      }
	      var roleName = JSON.parse(localStorage.getItem("session")).roleName;
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "edit-profile" },
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "edit-profile-curmb",
	              style: {
	                padding: this.controlBreadStyle()
	              }
	            },
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "/clients" },
	                /^(account manager|system administrator)/gi.test(roleName) ? "Clients" : "Business Units"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              ">"
	            ),
	            this.showDetailRouter("Client-Profile"),
	            this.showDetailRouter("Business-Units"),
	            this.showDetailRouter("Client-Team-Members"),
	            /^\/clients\/edit\/(Business-Units|Client-Team-Members)\/detail/g.test(this.props.location.pathname) && _react2.default.createElement(
	              "li",
	              { style: { margin: "0 0.4em" } },
	              ">"
	            ),
	            this.showChildCrumb(),
	            /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) && _react2.default.createElement(
	              "li",
	              { style: { margin: "0 0.4em" } },
	              ">"
	            ),
	            /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) && _react2.default.createElement(
	              "li",
	              null,
	              _qs2.default.parse(this.props.location.search.split("?")[1]).name
	            )
	          ),
	          _react2.default.createElement(
	            "nav",
	            null,
	            _react2.default.createElement(
	              "ul",
	              null,
	              _react2.default.createElement(
	                "li",
	                {
	                  className: /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname) ? "active" : ""
	                },
	                _react2.default.createElement(
	                  _reactRouterDom.NavLink,
	                  {
	                    activeClassName: "editActive",
	                    to: "/clients/edit/Client-Profile/" + this.getUrlParams() + "?name=" + _qs2.default.parse(this.props.location.search.split("?")[1]).name
	                  },
	                  /^(account manager|system administrator)/gi.test(roleName) ? "Client" : "Business Unit",
	                  " ",
	                  "Profile"
	                )
	              ),
	              this.props.edit_client_profile && this.props.edit_client_profile.subscriptionTierId !== 5 && _react2.default.createElement(
	                "li",
	                {
	                  className: /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) ? "active" : ""
	                },
	                _react2.default.createElement(
	                  _reactRouterDom.NavLink,
	                  {
	                    activeClassName: "editActive",
	                    to: "/clients/edit/Client-Team-Members/" + JSON.parse(localStorage.getItem("editClientId")) + "?name=" + _qs2.default.parse(this.props.location.search.split("?")[1]).name
	                  },
	                  /^(account manager|system administrator)/gi.test(roleName) ? "Client" : "Business Unit",
	                  " ",
	                  "Team Members"
	                )
	              ),
	              /^(account manager|system administrator)/gi.test(roleName) && this.props.edit_client_profile && this.props.edit_client_profile.subscriptionTierId !== 5 && _react2.default.createElement(
	                "li",
	                {
	                  className: /^\/clients\/edit\/Business-Unit/g.test(this.props.location.pathname) ? "active" : ""
	                },
	                _react2.default.createElement(
	                  _reactRouterDom.NavLink,
	                  {
	                    activeClassName: "editActive",
	                    to: "/clients/edit/Business-Units/" + this.getUrlParams()
	                  },
	                  "Business Units"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement("div", null),
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Redirect, {
	              exact: true,
	              from: "/clients/edit",
	              to: "/clients/edit/Client-Profile"
	            })
	          ),
	          _react2.default.createElement(_reactRouterDom.Route, {
	            exact: true,
	            path: "/clients/edit/Client-Profile/:id",
	            component: _editClientProfile2.default
	          }),
	          _react2.default.createElement(_reactRouterDom.Route, {
	            exact: true,
	            path: "/clients/edit/Business-Units/:id",
	            component: _editBusinessUnits2.default
	          }),
	          _react2.default.createElement(_reactRouterDom.Route, {
	            exact: true,
	            path: "/clients/edit/Client-Team-Members/:id",
	            component: _TeamMembers2.default
	          }),
	          _react2.default.createElement(_reactRouterDom.Route, {
	            exact: true,
	            path: "/clients/edit/Client-Team-Members/detail/:id/:name/:memberId",
	            component: _editTeamMemberDetail2.default
	          }),
	          _react2.default.createElement(_reactRouterDom.Route, {
	            path: "/Clients/edit/Client-Team-Members/user-status/:id/:pageNumber/:sortColumn/:order",
	            exact: true,
	            component: _userStatus2.default
	          }),
	          _react2.default.createElement(_reactRouterDom.Route, {
	            exact: true,
	            path: "/clients/edit/Business-Units/detail/:id/:name/:businessUnitId",
	            component: _editBusinessUnitsDetail2.default
	          }),
	          _react2.default.createElement(_reactRouterDom.Route, {
	            exact: true,
	            path: "/clients/edit/Business-Units/detail/Team Members/:id",
	            component: _TeamMembers2.default
	          }),
	          _react2.default.createElement(_reactRouterDom.Route, {
	            exact: true,
	            path: "/clients/edit/Business-Units/detail/Business Unit Team Members/:id",
	            component: _userStatus2.default
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserStatus = __webpack_require__(517);
	
	var _UserStatus2 = _interopRequireDefault(_UserStatus);
	
	__webpack_require__(1410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//css
	
	
	var TeamMemberDetail = function (_Component) {
	  _inherits(TeamMemberDetail, _Component);
	
	  function TeamMemberDetail() {
	    _classCallCheck(this, TeamMemberDetail);
	
	    return _possibleConstructorReturn(this, (TeamMemberDetail.__proto__ || Object.getPrototypeOf(TeamMemberDetail)).apply(this, arguments));
	  }
	
	  _createClass(TeamMemberDetail, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-member-detail' },
	        _react2.default.createElement(_UserStatus2.default, Object.assign({}, this.props, {
	          editModeId: this.props.location.search.split('=')[1],
	          roleId: '51',
	          ifForInternalPage: true,
	          selected_client: this.props.match.params.id,
	          userId: this.props.match.params.id
	        }))
	      );
	    }
	  }]);
	
	  return TeamMemberDetail;
	}(_react.Component);
	
	exports.default = TeamMemberDetail;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClientUsers = __webpack_require__(515);
	
	var _ClientUsers2 = _interopRequireDefault(_ClientUsers);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(1411);
	
	var _qs = __webpack_require__(192);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamMembers = function (_Component) {
	  _inherits(TeamMembers, _Component);
	
	  function TeamMembers() {
	    _classCallCheck(this, TeamMembers);
	
	    return _possibleConstructorReturn(this, (TeamMembers.__proto__ || Object.getPrototypeOf(TeamMembers)).apply(this, arguments));
	  }
	
	  _createClass(TeamMembers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if ((0, _lodash.isEmpty)(this.props.clientRoles)) this.props.getClientRoles();
	    }
	  }, {
	    key: 'showTableTitle',
	    value: function showTableTitle() {
	      if (/^(\/clients\/edit\/Business-Units\/detail\/Team Members)/g.test(this.props.location.pathname)) {
	        if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
	          return _react2.default.createElement(
	            'h3',
	            { className: 'mb-20', style: { fontSize: '16px', fontWeight: 'bolder' } },
	            _qs2.default.parse(this.props.location.search.split('?')[1]).name.toUpperCase(),
	            ' BUSINESS UNIT TEAM MEMBERS'
	          );
	        }
	      }
	      if (/^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname)) {
	        if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
	          return _react2.default.createElement(
	            'h3',
	            { className: 'mb-20', style: { fontSize: '16px', fontWeight: 'bolder' } },
	            /^(administrator|team member)/gi.test(this.props.roleName) ? 'BUSINESS UNIT' : 'CLIENT',
	            ' TEAM MEMBERS'
	          );
	        }
	        if (/^(administrator|team member)/gi.test(this.props.roleName)) {
	          return _react2.default.createElement(
	            'h3',
	            { className: 'mb-20', style: { fontSize: '16px', fontWeight: 'bolder' } },
	            _qs2.default.parse(this.props.location.search.split('?')[1]).name.toUpperCase(),
	            ' BUSINESS UNIT TEAM MEMBERS'
	          );
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'team-members-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'team-members-main' },
	          this.showTableTitle(),
	          _react2.default.createElement(_ClientUsers2.default, Object.assign({
	            tableList: this.props.tableList,
	            getTableList: /^(\/clients\/edit\/Business-Units\/detail\/Team Members)/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName) ? this.props.getBusinessUnitTeamMembers : /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(this.props.roleName) ? this.props.getBusinessUnitTeamMembers : this.props.getClientUsers,
	            ifSendInviteSuccess: this.props.ifSendInviteSuccess
	          }, this.props, {
	            // for system administrator | account manager
	            suspendOrReactivate: /^(\/clients\/edit\/Business-Units\/detail\/Team Members)/g.test(this.props.location.pathname),
	            selected_client: this.props.match.params.id,
	            clientId: this.props.match.params.id,
	            roles: this.props.clientRoles,
	            roleName: this.props.roleName,
	            rollbackStatus: this.props.rollbackStatus
	          }))
	        )
	      );
	    }
	  }]);
	
	  return TeamMembers;
	}(_react.Component);
	
	exports.default = TeamMembers;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _getMuiTheme = __webpack_require__(108);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _IndustryDialog = __webpack_require__(514);
	
	var _IndustryDialog2 = _interopRequireDefault(_IndustryDialog);
	
	var _ClientsTable = __webpack_require__(1076);
	
	var _ClientsTable2 = _interopRequireDefault(_ClientsTable);
	
	var _utility = __webpack_require__(14);
	
	var _ClientProfile = __webpack_require__(512);
	
	var _ClientProfile2 = _interopRequireDefault(_ClientProfile);
	
	__webpack_require__(1413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Industry
	// import dialog
	
	// import common dialog for successing invited.
	
	// table
	
	
	// client profile
	
	// css
	
	
	var Client = function (_Component) {
	  _inherits(Client, _Component);
	
	  function Client(props) {
	    _classCallCheck(this, Client);
	
	    var _this = _possibleConstructorReturn(this, (Client.__proto__ || Object.getPrototypeOf(Client)).call(this, props));
	
	    _this.throttle = true;
	    _this.throttle_clientName = true;
	    _this.throttle_accountManager = true;
	    _this.throttle_client_options = true;
	    _this.state = {
	      open: false, // if open dialog
	      showClientProfile: false
	    };
	    return _this;
	  }
	
	  _createClass(Client, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.getIndustryOptions(); // get industry option for clientProfile
	      this.props.getTierOptions(); // get tier options for industry dialog component.
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.roleId === 5) {
	        if (this.throttle) {
	          nextProps.history.push("/");
	          this.throttle = false;
	        }
	      }
	
	      if (/^(system administrator|account manager|operations manager|administrator)/gi.test(this.props.roleName) && this.throttle_client_options) {
	        this.props.get_client_options(); // get role optionss for industry dialog component.
	        this.throttle_client_options = false;
	      }
	      if (/^system administrator/gi.test(this.props.roleName) && this.throttle_accountManager) {
	        this.props.getAccountManage();
	        this.throttle_accountManager = false;
	      }
	      if (/^(administrator|team member)/gi.test(this.props.roleName)) {
	        // request one time
	        if (this.throttle) {
	          if (nextProps.loginUserDetail) {
	            nextProps.getBusinessUnitOptions(); // get business unit options
	            nextProps.getTeamMember(nextProps.loginUserDetail.client.id); // get business assign to data for ClientProfile component.
	            this.throttle = false;
	          }
	        }
	      }
	
	      if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        if (this.throttle_clientName) {
	          nextProps.getClientName(); // get client names for IndustryDialog component.
	          this.throttle_clientName = false;
	        }
	      }
	      if (nextProps.ifSendInvitationSuccess) {
	        this.setState({
	          open: false
	        });
	      }
	
	      if (nextProps.roleId === 5) {
	        this.props.history.push("/");
	      }
	
	      if (nextProps.roleId === 53) {
	        this.props.history.push("/");
	      }
	    }
	  }, {
	    key: "handleCloseDialog",
	    value: function handleCloseDialog() {
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: "handleOpenDialog",
	    value: function handleOpenDialog() {
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: "handleSendInvite",
	    value: function handleSendInvite() {}
	  }, {
	    key: "handleInviteAnotherClient",
	    value: function handleInviteAnotherClient(selectedItem, clients) {
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: "handleCreateClientProfile",
	    value: function handleCreateClientProfile() {
	      this.setState({
	        showClientProfile: true
	      });
	    }
	  }, {
	    key: "clientProfileCancel",
	    value: function clientProfileCancel() {
	      this.setState({
	        showClientProfile: false
	      });
	
	      if (/^(system administrator|account manager|operations manager|administrator)/gi.test(this.props.roleName)) {
	        this.props.get_client_options(); // get role optionss for industry dialog component.
	        this.throttle_client_options = false;
	      }
	      if (/^system administrator/gi.test(this.props.roleName)) {
	        this.props.getAccountManage();
	      }
	      if (/^(administrator|team member)/gi.test(this.props.roleName)) {
	        this.props.getTeamMember(); // get business assign to data for ClientProfile component.
	        this.props.getBusinessUnitOptions(); // get business unit options
	      }
	      if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        this.props.getClientName();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var muiTheme = (0, _getMuiTheme2.default)({
	        menuItem: {
	          hoverColor: (0, _utility.buttonBlueColor)()
	        }
	      });
	
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: muiTheme },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "ac-clients",
	            style: { padding: this.state.showClientProfile ? "0" : "" }
	          },
	          !this.state.showClientProfile ? _react2.default.createElement(
	            "div",
	            { className: "ac-clients-lines" },
	            _react2.default.createElement(_ClientsTable2.default, {
	              getClientsTable: this.props.getClientsTable,
	              tableData: this.props.tableData,
	              getIndustryOptions: this.props.getIndustryOptions,
	              industryOptions: this.props.industryOptions,
	              search_clients: this.props.getClientsTable,
	              roleName: this.props.roleName,
	              getAllClientsTable: this.props.getAllClientsTable,
	              tableAllData: this.props.tableAllData
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "btns" },
	              /^(administrator|team member)/gi.test(this.props.roleName) && _react2.default.createElement(_FlatButton2.default, {
	                label: "Invite Business Unit Team Member",
	                backgroundColor: (0, _utility.buttonBlueColor)(),
	                labelStyle: {
	                  color: "white",
	                  fontWeight: "normal",
	                  fontSize: "16px",
	                  textTransform: "capitalize",
	                  padding: 20
	                },
	                hoverColor: (0, _utility.buttonBlueColor)(),
	                style: {
	                  marginRight: "10px",
	                  height: "40px",
	                  lineHeight: "auto",
	                  padding: "0 9px"
	                },
	                onClick: function onClick() {
	                  return _this2.handleOpenDialog();
	                }
	              }),
	              _react2.default.createElement(_FlatButton2.default, {
	                label: /^(administrator|team member)/gi.test(this.props.roleName) ? "Create Business Unit Profile" : "Create  Client Profile",
	                labelStyle: {
	                  fontWeight: "normal",
	                  color: "white",
	                  padding: 20,
	                  fontSize: "16px",
	                  textTransform: "capitalize"
	                },
	                hoverColor: (0, _utility.buttonBlueColor)(),
	                backgroundColor: (0, _utility.buttonBlueColor)(),
	                style: {
	                  fontWeight: "normal",
	                  lineHeight: "auto",
	                  height: "40px",
	                  padding: "0 9px"
	                },
	                onClick: function onClick() {
	                  return _this2.handleCreateClientProfile();
	                }
	              })
	            ),
	            _react2.default.createElement(_IndustryDialog2.default, {
	              open: this.state.open,
	              roleName: this.props.roleName,
	              handleCloseDialog: function handleCloseDialog() {
	                return _this2.handleCloseDialog();
	              },
	              ifSendInvitationSuccess: this.props.ifSendInvitationSuccess,
	              handleSendInvite: function handleSendInvite() {
	                return _this2.handleSendInvite();
	              },
	              industryOptions: this.props.industryOptions,
	              tier_options: this.props.tier_options,
	              account_manager: this.props.account_manager,
	              send_invitation: this.props.send_invitation,
	              send_invitation_error_msg: this.props.send_invitation_error_msg,
	              invitation_client: this.props.invitation_client,
	              client_options: /^(team member)/gi.test(this.props.roleName) ? [{ value: 51, label: "Administrator" }, { value: 52, label: "Team Member" }, { value: 53, label: "Business Unit Team Member" }] : this.props.client_options,
	              handleInviteAnotherClient: function handleInviteAnotherClient() {
	                return _this2.handleInviteAnotherClient();
	              },
	              rollbackStatus: this.props.rollbackStatus,
	              client_names: this.props.client_names,
	              businessUnitOptions: this.props.businessUnitOptions,
	              inviteBusinessMember: this.props.inviteBusinessMember
	            })
	          ) : _react2.default.createElement(_ClientProfile2.default, {
	            ifCreateClientProfileSuccessBasic: this.props.ifCreateClientProfileSuccessBasic,
	            clientId: this.props.clientId,
	            configInsightsStandard: this.props.configInsightsStandard,
	            getConfigInsightsStandard: this.props.getConfigInsightsStandard,
	            path: this.props.match.path,
	            roleInfo: this.props.roleName,
	            getStates: this.props.getStates,
	            allstates: this.props.allstates,
	            getTimezone: this.props.getTimezone,
	            timezone: this.props.timezone,
	            getRoles: this.props.getRoles,
	            roles: this.props.roles,
	            clientProfileCancel: function clientProfileCancel() {
	              return _this2.clientProfileCancel();
	            },
	            ifUpdateSuccess: this.props.ifUpdateSuccess,
	            loginUserDetail: this.props.loginUserDetail,
	            tier_options: this.props.tier_options,
	            industryOptions: this.props.industryOptions,
	            token: this.props.token,
	            roleName: this.props.roleName,
	            account_manager: this.props.account_manager,
	            createClientProfile: this.props.createClientProfile,
	            createClientProfileMessage: this.props.createClientProfileMessage,
	            ifCreateClientProfileSuccess: this.props.ifCreateClientProfileSuccess,
	            rollbackProfileStatus: this.props.rollbackProfileStatus,
	            teamMember_options: this.props.teamMember_options // for business assign array data
	          })
	        )
	      );
	    }
	  }]);
	
	  return Client;
	}(_react.Component);
	
	exports.default = Client;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	var _reactSelectPlus = __webpack_require__(3020);
	
	var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);
	
	var _groupBy = __webpack_require__(150);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _search = __webpack_require__(155);
	
	var _search2 = _interopRequireDefault(_search);
	
	__webpack_require__(596);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Industry = function (_Component) {
	  _inherits(Industry, _Component);
	
	  function Industry(props) {
	    _classCallCheck(this, Industry);
	
	    var _this = _possibleConstructorReturn(this, (Industry.__proto__ || Object.getPrototypeOf(Industry)).call(this, props));
	
	    _this.state = {
	      value: "",
	      industryGroupObj: [{ label: "", options: [] }],
	      searchKeyword: "",
	      searchBoxWidth: "30%"
	    };
	    return _this;
	  }
	
	  _createClass(Industry, [{
	    key: "updateDimensions",
	    value: function updateDimensions() {
	      var els = document.getElementsByClassName("industry-label");
	      var searchEls = document.getElementsByClassName("search");
	      var inEls = document.getElementsByClassName("ac-client-in");
	      var containerEls = document.getElementsByClassName("ac-clients-industry");
	      if (containerEls.length > 0) {
	        var w = containerEls[0].offsetWidth - 130 - els[0].offsetWidth - searchEls[0].offsetWidth - inEls[0].offsetWidth;
	        this.setState({
	          searchBoxWidth: w + "px"
	        });
	      } else {
	        this.setState({
	          searchBoxWidth: "30%"
	        });
	      }
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.updateDimensions();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      window.addEventListener("resize", this.updateDimensions.bind(this));
	      this.updateDimensions();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions.bind(this));
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.industryOptions.length > 0) {
	        this.setState({
	          value: ""
	        });
	
	        var industryGroup = (0, _groupBy2.default)(nextProps.industryOptions, "group");
	        var obj = [];
	        obj.push({
	          label: "All Industries",
	          options: [{
	            label: "All Industries",
	            value: ""
	          }]
	        });
	        for (var x in industryGroup) {
	          obj.push({
	            label: x,
	            options: industryGroup[x]
	          });
	        }
	        this.setState({
	          industryGroupObj: obj,
	          value: obj[0]
	        });
	      }
	    }
	  }, {
	    key: "handleChange",
	    value: function handleChange(value) {
	      this.setState({
	        value: value
	      });
	    }
	  }, {
	    key: "handleKeywordChange",
	    value: function handleKeywordChange(item) {
	      this.setState({
	        searchKeyword: typeof item[0] !== "undefined" ? item[0].name : ""
	      });
	    }
	  }, {
	    key: "handleSearch",
	    value: function handleSearch() {
	      this.props.handleSearch(this.state.searchKeyword, this.state.value);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.props.tableAllData;
	      return _react2.default.createElement(
	        "div",
	        { className: "ac-clients-industry clearfix" },
	        _react2.default.createElement(
	          "label",
	          { htmlFor: "", className: "industry-label" },
	          /^administrator/gi.test(this.props.roleName) ? "Business Unit Search" : "Client Search"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "search" },
	          _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	            key: "city_search_box",
	            labelKey: "name",
	            multiple: false,
	            options: data || [{ name: "" }],
	            placeholder: "Find a Client",
	            onChange: function onChange(selectedItem) {
	              return _this2.handleKeywordChange(selectedItem);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "span",
	          {
	            className: "ac-client-in",
	            style: {
	              margin: /^administrator/gi.test(this.props.roleName) ? "1em 0.3em 0" : ""
	            }
	          },
	          "in"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "ac-clients-select-filed",
	            style: { border: "none", width: this.state.searchBoxWidth }
	          },
	          _react2.default.createElement(_reactSelectPlus2.default, {
	            className: "industry-group-index",
	            clearable: false,
	            onChange: function onChange(value) {
	              return _this2.handleChange(value);
	            },
	            options: this.state.industryGroupObj,
	            value: this.state.value
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            key: "city_search_text",
	            className: "search-button",
	            onClick: function onClick() {
	              return _this2.handleSearch();
	            }
	          },
	          _react2.default.createElement(_search2.default, { style: { color: "white" } })
	        )
	      );
	    }
	  }]);
	
	  return Industry;
	}(_react.Component);
	
	exports.default = Industry;

/***/ },
/* 1084 */
528,
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(108);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _reactDropzone = __webpack_require__(242);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _done = __webpack_require__(307);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _utility = __webpack_require__(14);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(1414);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Done from 'material-ui/svg-icons/action/done';
	
	// import Dialog from 'material-ui/Dialog';
	
	// button color
	
	
	var CreateAccount = function (_Component) {
	  _inherits(CreateAccount, _Component);
	
	  function CreateAccount(props) {
	    _classCallCheck(this, CreateAccount);
	
	    var _this = _possibleConstructorReturn(this, (CreateAccount.__proto__ || Object.getPrototypeOf(CreateAccount)).call(this, props));
	
	    _this.flag = true;
	    _this.flagBase = true;
	    _this.flagPhoto = true;
	    _this.state = {
	      ifHiddenTopEdit: false, // if show top form edit
	      ifHiddenBottomEdit: true,
	      requiredFirstNameText: '', // requied field firset name tip text
	      requiredLastNameText: '', // required field last name tip text
	      requiredEmailText: '', // required field email tip text
	      ifLogoUploadButtonEnable: false, // if upload button enable for logo
	      ifPhotoUploadButtonEnable: false, // if uploda button enable for photo
	      logoFileName: 'No file chosen',
	      photoFileName: 'No file chosen',
	      roleValue: '',
	      stateValue: '',
	      timezoneValue: '',
	      departmentValue: '',
	      clientId: '', // client id for upload
	      companyLogoErrorText: '',
	      profilePhotoErrorText: '',
	      companyLogoUuid: '', // logo uuid
	      userAvatarUuid: '',
	      roleInfo: '', //store role object information
	      requestParams: {
	        username: '',
	        password: '',
	        confirmPassword: '',
	        title: '',
	        firstName: '',
	        lastName: '',
	        email: '',
	        companyName: '',
	        departmentId: '',
	        address1: '',
	        address2: '',
	        city: '',
	        state: '',
	        zipCode: '',
	        timezone: '',
	        officePhone: '',
	        mobilePhone: '',
	        companyLogoUuid: ''
	      },
	      imgDataBase64: '', // for company logo
	      // password_error_tip_show: false,
	      newLogoBase64: '',
	      newPhotoBase64: '',
	      showNewPwError: false,
	      showConfirmPwError: false
	    };
	    return _this;
	  }
	
	  _createClass(CreateAccount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getInvitationByCode(this.props.match.params.id);
	      localStorage.setItem('newPhotoBase64', '');
	      this.props.logout();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // change blob to base64 for photo
	      if (nextProps.get_invitation_by_code.invitation) {
	        var _nextProps$get_invita = nextProps.get_invitation_by_code.invitation,
	            firstName = _nextProps$get_invita.firstName,
	            lastName = _nextProps$get_invita.lastName,
	            email = _nextProps$get_invita.email,
	            role = _nextProps$get_invita.role,
	            id = _nextProps$get_invita.id;
	
	        this.setState({
	          clientId: id
	        });
	        // implement one time.
	        // if (this.flag) {
	        //   this.props.getCompanyLogo(nextProps.loginUserDetail.client.id); // get logo img
	        //   //this.props.getUserAvatar(nextProps.loginUserDetail.avatar); // get photo img
	        //   this.flag = false;
	        // }
	
	        this.setState({
	          // roleValue: role.id,
	          // stateValue: state,
	          roleInfo: role,
	          requestParams: Object.assign({}, this.state.requestParams, {
	            firstName: firstName,
	            lastName: lastName,
	            email: email
	          })
	        });
	      }
	    }
	  }, {
	    key: 'handleItemsChange',
	    value: function handleItemsChange(e, index, value) {
	      this.setState({
	        roleValue: value
	      });
	    }
	  }, {
	    key: 'handleDepartmentChange',
	    value: function handleDepartmentChange(value) {
	      this.setState({
	        departmentValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          departmentId: value.value
	        })
	      });
	    }
	  }, {
	    key: 'handleStateChange',
	    value: function handleStateChange(value) {
	      this.setState({
	        stateValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          state: value.value
	        })
	
	      });
	    }
	  }, {
	    key: 'handleTimeZoneChange',
	    value: function handleTimeZoneChange(value) {
	      this.setState({
	        timezoneValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          timezone: value.value
	        })
	      });
	    }
	  }, {
	    key: 'handleTitle',
	    value: function handleTitle(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          title: value
	        })
	      });
	    }
	  }, {
	    key: 'handleFirstName',
	    value: function handleFirstName(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          firstName: value
	        })
	      });
	    }
	  }, {
	    key: 'handleLastName',
	    value: function handleLastName(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          lastName: value
	        })
	      });
	    }
	  }, {
	    key: 'handleEmail',
	    value: function handleEmail(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          email: value
	        })
	      });
	    }
	  }, {
	    key: 'handleUsername',
	    value: function handleUsername(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          username: value
	        })
	      });
	    }
	  }, {
	    key: 'handleCompanyAdd1',
	    value: function handleCompanyAdd1(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address1: value
	        })
	      });
	    }
	  }, {
	    key: 'handleCompanyAdd2',
	    value: function handleCompanyAdd2(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address2: value
	        })
	      });
	    }
	  }, {
	    key: 'handleCity',
	    value: function handleCity(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          city: value
	        })
	      });
	    }
	  }, {
	    key: 'handleZipCode',
	    value: function handleZipCode(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          zipCode: value
	        })
	      });
	    }
	  }, {
	    key: 'handleOfficePhoneNumber',
	    value: function handleOfficePhoneNumber(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          officePhone: value
	        })
	      });
	    }
	  }, {
	    key: 'handleMobilePhoneNumber',
	    value: function handleMobilePhoneNumber(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          mobilePhone: value
	        })
	      });
	    }
	  }, {
	    key: 'handleCompanyName',
	    value: function handleCompanyName(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          companyName: value
	        })
	      });
	    }
	  }, {
	    key: 'handleDrop',
	    value: function handleDrop(files, accept, reject) {
	      this.setState({
	        logoFileName: files[0],
	        ifLogoUploadButtonEnable: true,
	        companyLogoErrorText: ''
	      });
	    }
	  }, {
	    key: 'handleDropProfile',
	    value: function handleDropProfile(files, accept, reject) {
	      this.setState({
	        photoFileName: files[0],
	        ifPhotoUploadButtonEnable: true,
	        profilePhotoErrorText: ''
	      });
	    }
	  }, {
	    key: 'onDropRejected',
	    value: function onDropRejected() {
	      this.setState({
	        companyLogoErrorText: 'Only jpg, png, and gif file with maximum size of 1MB is allowed'
	      });
	    }
	  }, {
	    key: 'onDropProfileRejected',
	    value: function onDropProfileRejected() {
	      this.setState({
	        profilePhotoErrorText: 'Only jpg, png, and gif file with maximum size of 1MB is allowed'
	      });
	    }
	  }, {
	    key: 'handleUpdateProfile',
	    value: function handleUpdateProfile() {
	      if (this.state.requestParams.firstName.trim().length === 0) {
	        this.setState({
	          requiredFirstNameText: 'Please enter your first name'
	        });
	      } else {
	        this.setState({
	          requiredFirstNameText: ''
	        });
	      }
	      if (this.state.requestParams.lastName.trim().length === 0) {
	        this.setState({
	          requiredLastNameText: 'Please enter your last name'
	        });
	      } else {
	        this.setState({
	          requiredLastNameText: ''
	        });
	      }
	      if (this.state.requestParams.email.trim().length === 0) {
	        this.setState({
	          requiredEmailText: 'Please enter your email'
	        });
	      } else {
	        this.setState({
	          requiredEmailText: ''
	        });
	      }
	      if (this.state.requestParams.firstName.trim().length > 0 && this.state.requestParams.lastName.trim().length > 0 && this.state.requestParams.email.trim().length > 0) {
	        this.props.register(this.props.match.params.id, this.state.requestParams);
	      }
	    }
	  }, {
	    key: 'handleCloseDialog',
	    value: function handleCloseDialog() {
	      // reload redux
	      this.props.setStatus(false);
	      this.props.getCurrentUserProfile(); // request my profile again
	      this.flag = true;
	      this.flagBase = true;
	      this.flagPhoto = true;
	      this.setState({
	        ifHiddenTopEdit: false, // if show top form edit
	        ifHiddenBottomEdit: true,
	        requiredFirstNameText: '',
	        requiredLastNameText: '',
	        requiredEmailText: '',
	        ifLogoUploadButtonEnable: false,
	        ifPhotoUploadButtonEnable: false,
	        logoFileName: 'No file chosen',
	        photoFileName: 'No file chosen',
	        roleValue: '',
	        stateValue: '',
	        timezoneValue: '',
	        departmentValue: '',
	        clientId: '', // client id for upload
	        companyLogoErrorText: '',
	        profilePhotoErrorText: '',
	        companyLogoUuid: '', // logo uuid
	        userAvatarUuid: '', // avatar uuid
	        requestParams: {
	          username: '',
	          password: '',
	          confirmPassword: '',
	          title: '',
	          firstName: '',
	          lastName: '',
	          email: '',
	          companyName: '',
	          departmentId: '',
	          address1: '',
	          address2: '',
	          city: '',
	          state: '',
	          zipCode: '',
	          timezone: '',
	          officePhone: '',
	          mobilePhone: '',
	          companyLogoUuid: ''
	        },
	        imgDataBase64: '', // for company logo
	        newLogoBase64: '',
	        newPhotoBase64: ''
	      });
	    }
	  }, {
	    key: 'handlePhotoLogo',
	    value: function handlePhotoLogo() {
	      var _this2 = this;
	
	      if (this.state.ifPhotoUploadButtonEnable) {
	        var formData = new FormData();
	        formData.append('avatar', this.state.photoFileName);
	        // call api
	        fetch('/api/avatars/' + this.props.match.params.id + '/upload', {
	          method: 'POST',
	          body: formData
	        }).then(function (res) {
	          if (res.status === 200) {
	            _this2.setState({
	              profilePhotoErrorText: '',
	              newPhotoBase64: _this2.state.photoFileName.preview,
	              requestParams: Object.assign({}, _this2.state.requestParams, {
	                avatar: _this2.state.photoFileName.name
	              })
	            });
	          } else {
	            res.json().then(function (json) {
	              _this2.setState({
	                profilePhotoErrorText: json.message
	              });
	            });
	          }
	        }, function () {}).catch(function (err) {
	          alert(err);
	        });
	      }
	    }
	  }, {
	    key: 'handleUploadLogo',
	    value: function handleUploadLogo() {
	      var _this3 = this;
	
	      if (this.state.ifLogoUploadButtonEnable) {
	        var formData = new FormData();
	        formData.append('logo', this.state.logoFileName);
	        // call api
	        fetch('/api/invitations/with/' + this.props.match.params.id + '/logo/upload', {
	          method: 'POST',
	          body: formData
	          // headers: new Headers({
	          //   'Authorization': this.props.token
	          // })
	        }).then(function (res) {
	          if (res.status === 200) {
	            return res.json();
	          } else {
	            res.json().then(function (json) {
	              _this3.setState({
	                companyLogoErrorText: json.message
	              });
	            });
	          }
	        }, function () {}).then(function (json) {
	          if (typeof json !== 'undefined') {
	            _this3.setState({
	              companyLogoErrorText: '',
	              requestParams: Object.assign({}, _this3.state.requestParams, {
	                companyLogoUuid: json.uuid
	              }),
	              newLogoBase64: _this3.state.logoFileName.preview
	            });
	          }
	        }).catch(function (err) {
	          alert(err);
	        });
	      }
	    }
	  }, {
	    key: 'handleNewPassword',
	    value: function handleNewPassword(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          password: value
	        }),
	        showNewPwError: false
	      });
	    }
	  }, {
	    key: 'handleConfirmPassword',
	    value: function handleConfirmPassword(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          confirmPassword: value
	        }),
	        showConfirmPwError: false
	      });
	    }
	  }, {
	    key: '_pwdInputKeyDown',
	    value: function _pwdInputKeyDown(e) {
	      if (e.keyCode === 32) e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var muiTheme = (0, _getMuiTheme2.default)({
	        menuItem: {
	          hoverColor: (0, _utility.buttonBlueColor)()
	        }
	      });
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: muiTheme },
	        _react2.default.createElement(
	          'div',
	          { className: 'profile', style: { marginTop: '2em' } },
	          this.props.invitation_error_message !== '' && _react2.default.createElement(
	            'p',
	            { style: { fontSize: '16px', color: 'black', fontWeight: 'bolder', padding: '25px 0', textAlign: 'center' } },
	            this.props.invitation_error_message
	          ),
	          !this.props.ifRequestSuccess && this.props.invitation_error_message === '' && _react2.default.createElement(
	            'div',
	            { className: 'profile-wrapper', style: { minWidth: '568px' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'profile-form-top' },
	              _react2.default.createElement(
	                'h1',
	                { style: { border: 'none', marginTop: '0.5em', marginBottom: '0.5em' } },
	                'MY PROFILE'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'role-intro clearfix', style: { border: !this.state.ifHiddenTopEdit ? 'none' : '', marginBottom: '17px' } },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Role'
	                ),
	                _react2.default.createElement(
	                  'small',
	                  null,
	                  this.state.roleInfo.name
	                ),
	                _react2.default.createElement(
	                  _rcTooltip2.default,
	                  {
	                    placement: 'right',
	                    overlayClassName: 'profile-role-info',
	                    overlayStyle: { width: "36%" },
	                    overlay: _react2.default.createElement(
	                      'div',
	                      { className: 'profile-overlay-container' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        this.state.roleInfo.name
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        this.state.roleInfo !== '' && this.state.roleInfo.capabilities.map(function (item, index) {
	                          return _react2.default.createElement(
	                            'li',
	                            { className: 'clearfix', key: index },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'icon', style: { background: (0, _utility.buttonBlueColor)() } },
	                              _react2.default.createElement(_done2.default, {
	                                style: { width: '14px', height: '14px', color: 'white' }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'section',
	                              null,
	                              item
	                            )
	                          );
	                        })
	                      )
	                    ),
	                    arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' })
	                  },
	                  _react2.default.createElement(_infoOutline2.default, {
	                    style: { color: 'black', width: '25px', height: '25px', marginTop: '9px', marginLeft: '10px', cursor: 'pointer' }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'profile-form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'top' },
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: 'Title',
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    onChange: function onChange(e, value) {
	                      return _this4.handleTitle(e, value);
	                    },
	                    inputContainerId: 'companyAddress1',
	                    borderColor: 'black',
	                    style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-fn-wrapper', style: { marginTop: '1.5em' } },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: 'First Name',
	                      ifRequireField: true,
	                      onChange: function onChange(e, value) {
	                        return _this4.handleFirstName(e, value);
	                      },
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      initValue: this.state.requestParams.firstName,
	                      borderColor: 'black',
	                      labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                      inputContainerId: 'firstName',
	                      style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	
	                    }),
	                    this.state.requiredFirstNameText && _react2.default.createElement(
	                      'p',
	                      { className: 'create-account-field-error clearfix' },
	                      _react2.default.createElement(_error2.default, {
	                        style: { float: 'left' },
	                        color: 'red'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        this.state.requiredFirstNameText
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-fn-wrapper', style: { marginTop: '1.5em' } },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: 'Last Name',
	                      ifRequireField: true,
	                      onChange: function onChange(e, value) {
	                        return _this4.handleLastName(e, value);
	                      },
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      initValue: this.state.requestParams.lastName,
	                      borderColor: 'black',
	                      labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                      inputContainerId: 'firstName',
	                      style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	
	                    }),
	                    this.state.requiredLastNameText && _react2.default.createElement(
	                      'p',
	                      { className: 'create-account-field-error clearfix' },
	                      _react2.default.createElement(_error2.default, {
	                        style: { float: 'left' },
	                        color: 'red'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        this.state.requiredLastNameText
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-email-wrapper' },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: 'E-mail Address',
	                      ifRequireField: true,
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                      onChange: function onChange(e, value) {
	                        return _this4.handleEmail(e, value);
	                      },
	                      initValue: this.state.requestParams.email,
	                      inputContainerId: 'emailAddress',
	                      borderColor: 'black',
	                      style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                    }),
	                    this.state.requiredEmailText && _react2.default.createElement(
	                      'p',
	                      { className: 'create-account-field-error clearfix' },
	                      _react2.default.createElement(_error2.default, {
	                        style: { float: 'left' },
	                        color: 'red'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        this.state.requiredEmailText
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-username' },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: 'Username',
	                      labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      onChange: function onChange(e, value) {
	                        return _this4.handleUsername(e, value);
	                      },
	                      inputContainerId: 'username',
	                      borderColor: 'black',
	                      style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'role clearfix', style: { lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 } },
	                    _react2.default.createElement(
	                      'p',
	                      { style: { color: 'black', fontSize: '14px', float: 'left', width: '30%', margin: 0, fontWeight: 'bolder' } },
	                      'Department'
	                    ),
	                    _react2.default.createElement(_reactSelect2.default, {
	                      className: 'cp-dropdown ',
	                      value: this.state.departmentValue,
	                      clearable: false,
	                      options: this.props.get_invitation_by_code.departments,
	                      onChange: function onChange(value) {
	                        return _this4.handleDepartmentChange(value);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: 'Mobile Phone Number',
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    onChange: function onChange(e, value) {
	                      return _this4.handleMobilePhoneNumber(e, value);
	                    },
	                    inputContainerId: 'mobileNumber',
	                    borderColor: 'black',
	                    style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                  }),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: 'Office Phone Number',
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    onChange: function onChange(e, value) {
	                      return _this4.handleOfficePhoneNumber(e, value);
	                    },
	                    inputContainerId: 'officeNumber',
	                    borderColor: 'black',
	                    style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                  }),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: 'Company Name',
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    onChange: function onChange(e, value) {
	                      return _this4.handleCompanyName(e, value);
	                    },
	                    inputContainerId: 'officeNumber',
	                    borderColor: 'black',
	                    style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                  }),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: 'Company Address 1',
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    onChange: function onChange(e, value) {
	                      return _this4.handleCompanyAdd1(e, value);
	                    },
	                    inputContainerId: 'companyAddress1',
	                    borderColor: 'black',
	                    style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                  }),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: 'Company Address 2',
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    onChange: function onChange(e, value) {
	                      return _this4.handleCompanyAdd2(e, value);
	                    },
	                    inputContainerId: 'companyAddress1',
	                    borderColor: 'black',
	                    style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                  }),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: 'City',
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    onChange: function onChange(e, value) {
	                      return _this4.handleCity(e, value);
	                    },
	                    inputContainerId: 'city',
	                    borderColor: 'black',
	                    style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'role clearfix', style: { lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 } },
	                    _react2.default.createElement(
	                      'p',
	                      { style: { color: 'black', fontSize: '14px', float: 'left', width: '30%', margin: 0, fontWeight: 'bolder' } },
	                      'State'
	                    ),
	                    _react2.default.createElement(_reactSelect2.default, {
	                      className: 'cp-dropdown state-dropdown',
	                      value: this.state.stateValue,
	                      clearable: false,
	                      options: this.props.get_invitation_by_code.states,
	                      onChange: function onChange(value) {
	                        return _this4.handleStateChange(value);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: 'Zip Code',
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    onChange: function onChange(e, value) {
	                      return _this4.handleZipCode(e, value);
	                    },
	                    inputContainerId: 'zipCode',
	                    borderColor: 'black',
	                    style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 }
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'role clearfix', style: { lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px' : 0 } },
	                    _react2.default.createElement(
	                      'p',
	                      { style: { color: 'black', fontSize: '14px', float: 'left', width: '30%', margin: 0, fontWeight: 'bolder' } },
	                      'Time Zone ',
	                      _react2.default.createElement(
	                        'em',
	                        { style: { color: 'red' } },
	                        '*'
	                      )
	                    ),
	                    _react2.default.createElement(_reactSelect2.default, {
	                      className: 'cp-dropdown ',
	                      value: this.state.timezoneValue,
	                      clearable: false,
	                      options: this.props.get_invitation_by_code.timezones,
	                      onChange: function onChange(value) {
	                        return _this4.handleTimeZoneChange(value);
	                      }
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'profile-logo-wrapper' },
	              /^system Administrator|admin/gi.test(this.state.roleInfo.name) && _react2.default.createElement(
	                'div',
	                { className: 'profile-logo profile-company-logo clearfix' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'title clearfix' },
	                    _react2.default.createElement(
	                      'span',
	                      { id: 'profile-subtit' },
	                      'Logo'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'review' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'profile-edit-img' },
	                      _react2.default.createElement(
	                        'section',
	                        { className: 'section' },
	                        'Select a logo to upload'
	                      ),
	                      _react2.default.createElement(
	                        _reactDropzone2.default,
	                        {
	                          onDrop: function onDrop(files, accept, reject) {
	                            return _this4.handleDrop(files, accept, reject);
	                          },
	                          style: { width: '100%' },
	                          accept: 'image/jpeg, image/png, image/jpg, image/gif',
	                          maxSize: 1048576,
	                          onDropRejected: function onDropRejected() {
	                            return _this4.onDropRejected();
	                          },
	                          name: 'logo'
	                        },
	                        _react2.default.createElement(
	                          'p',
	                          { style: { textAlign: 'center', display: 'inline-block', width: '20%', height: '20px', fontSize: '12px', border: '1px solid grey', color: 'black', borderRadius: '6px', lineHeight: '20px', marginTop: '10px' } },
	                          'Choose File'
	                        ),
	                        _react2.default.createElement(
	                          'i',
	                          { style: { fontStyle: 'normal', marginLeft: '6px' } },
	                          this.state.logoFileName !== undefined && this.state.logoFileName.name || 'No file chosen'
	                        ),
	                        _react2.default.createElement(
	                          'section',
	                          { className: 'spec' },
	                          '(Only jpg, png, and gif file with maximum size of 1MB is allowed)'
	                        )
	                      ),
	                      _react2.default.createElement('img', { src: this.state.newLogoBase64, alt: '' }),
	                      _react2.default.createElement(
	                        'button',
	                        { style: { background: (0, _utility.buttonBlueColor)() }, onClick: function onClick() {
	                            return _this4.handleUploadLogo();
	                          } },
	                        'UPLOAD LOGO'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'error', style: { bottom: '10px' } },
	                  this.state.companyLogoErrorText
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'profile-logo profile-photo clearfix' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'title clearfix' },
	                    _react2.default.createElement(
	                      'span',
	                      { id: 'profile-subtit' },
	                      'Profile Photo'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'review' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'profile-edit-img' },
	                      _react2.default.createElement(
	                        'section',
	                        { className: 'section' },
	                        'Select a photo to upload'
	                      ),
	                      _react2.default.createElement(
	                        _reactDropzone2.default,
	                        {
	                          onDrop: function onDrop(files, accept, reject) {
	                            return _this4.handleDropProfile(files, accept, reject);
	                          },
	                          style: { width: '100%' },
	                          accept: 'image/jpeg, image/png, image/jpg, image/gif',
	                          maxSize: 1048576,
	                          onDropRejected: function onDropRejected() {
	                            return _this4.onDropProfileRejected();
	                          },
	                          name: 'avatar'
	                        },
	                        _react2.default.createElement(
	                          'p',
	                          { style: { textAlign: 'center', display: 'inline-block', width: '20%', height: '20px', fontSize: '12px', border: '1px solid grey', color: 'black', borderRadius: '6px', lineHeight: '20px', marginTop: '10px' } },
	                          'Choose File'
	                        ),
	                        _react2.default.createElement(
	                          'i',
	                          { style: { fontStyle: 'normal', marginLeft: '6px' } },
	                          this.state.photoFileName !== undefined && this.state.photoFileName.name || 'No file chosen'
	                        ),
	                        _react2.default.createElement(
	                          'section',
	                          { className: 'spec' },
	                          '(Only jpg, png, and gif file with maximum size of 1MB is allowed)'
	                        )
	                      ),
	                      _react2.default.createElement('img', { src: this.state.newPhotoBase64, alt: '' }),
	                      _react2.default.createElement(
	                        'button',
	                        { style: { background: (0, _utility.buttonBlueColor)() }, onClick: function onClick() {
	                            return _this4.handlePhotoLogo();
	                          } },
	                        'UPLOAD PHOTO'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'error', style: { bottom: '10px' } },
	                  this.props.update_photo_msg || this.state.profilePhotoErrorText
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'profile-change-pw', style: { minWidth: '568px' } },
	              _react2.default.createElement(
	                'h1',
	                { style: { border: this.state.ifHiddenChangePw ? '' : 'none' } },
	                'CREATE YOUR PASSWORD'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'tip', style: { display: this.state.ifHiddenChangePw ? 'none' : 'block' } },
	                'Enter a combination of at least 6 numbers, letters, and special characters'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'profile-username' },
	                this.state.showNewPwError && _react2.default.createElement(
	                  'p',
	                  { className: 'profile-fn-error' },
	                  this.props.change_password_error_msg
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'profile-fn-wrapper' },
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: this.state.ifHiddenChangePw ? 'Password' : 'New Password',
	                    ifHasBorder: this.state.ifHiddenChangePw,
	                    inputType: 'password',
	                    ifRequireField: true,
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    inputContainerId: 'change-password',
	                    borderColor: 'black',
	                    onKeyDown: this._pwdInputKeyDown,
	                    onChange: function onChange(e, value) {
	                      return _this4.handleNewPassword(e, value);
	                    },
	                    style: { height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenChangePw ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenChangePw ? '49px' : 0 }
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'profile-fn-wrapper' },
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: 'Confirm Password',
	                    ifHasBorder: this.state.ifHiddenChangePw,
	                    inputType: 'password',
	                    ifRequireField: true,
	                    onKeyDown: this._pwdInputKeyDown,
	                    labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                    inputContainerId: 'change-password',
	                    borderColor: 'black',
	                    onChange: function onChange(e, value) {
	                      return _this4.handleConfirmPassword(e, value);
	                    },
	                    style: { display: this.state.ifHiddenChangePw ? 'none' : 'block', height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenChangePw ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenChangePw ? '40px' : 0 }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'profile-edit clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'save-group clearfix' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'save', style: { background: (0, _utility.buttonBlueColor)() }, onClick: function onClick() {
	                      return _this4.handleUpdateProfile();
	                    } },
	                  'SAVE'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: { float: 'left', color: 'red', lineHeight: '30px', marginTop: '1em' } },
	                this.props.error
	              )
	            )
	          ),
	          this.props.ifRequestSuccess && _react2.default.createElement(
	            'div',
	            { className: 'create-account-success' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Your have successfully created your profile'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-wrapper' },
	              _react2.default.createElement(
	                'a',
	                { href: '/login' },
	                'LOGIN'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateAccount;
	}(_react.Component);
	
	exports.default = CreateAccount;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CreateYourPassword = __webpack_require__(1164);
	
	var _CreateYourPassword2 = _interopRequireDefault(_CreateYourPassword);
	
	var _ImgUpload = __webpack_require__(1166);
	
	var _ImgUpload2 = _interopRequireDefault(_ImgUpload);
	
	var _RoleExplainTip = __webpack_require__(1172);
	
	var _RoleExplainTip2 = _interopRequireDefault(_RoleExplainTip);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _reactTextMask = __webpack_require__(247);
	
	var _reactTextMask2 = _interopRequireDefault(_reactTextMask);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1415);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// css
	
	
	var CreateClientAccount = function (_Component) {
	  _inherits(CreateClientAccount, _Component);
	
	  function CreateClientAccount(props) {
	    _classCallCheck(this, CreateClientAccount);
	
	    var _this = _possibleConstructorReturn(this, (CreateClientAccount.__proto__ || Object.getPrototypeOf(CreateClientAccount)).call(this, props));
	
	    _this.state = {
	      roleName: '',
	      requiredFirstNameText: '',
	      requiredLastNameText: '',
	      requiredEmailText: '',
	      requestParams: {
	        username: '',
	        password: '',
	        confirmPassword: '',
	        title: '',
	        firstName: '',
	        lastName: '',
	        email: '',
	        officePhone: '',
	        mobilePhone: ''
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CreateClientAccount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.logout();
	
	      this.props.getInvitationByCode(this.props.match.params.code);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.get_invitation_by_code.invitation) {
	        var _nextProps$get_invita = nextProps.get_invitation_by_code.invitation,
	            firstName = _nextProps$get_invita.firstName,
	            lastName = _nextProps$get_invita.lastName,
	            email = _nextProps$get_invita.email;
	
	        this.setState({
	          roleName: nextProps.get_invitation_by_code.invitation.role.name,
	          requestParams: Object.assign({}, this.state.requestParams, {
	            firstName: firstName,
	            lastName: lastName,
	            email: email
	          })
	        });
	      }
	    }
	  }, {
	    key: 'handleFirstName',
	    value: function handleFirstName(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          firstName: value
	        })
	      });
	    }
	  }, {
	    key: 'handleLastName',
	    value: function handleLastName(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          lastName: value
	        })
	      });
	    }
	  }, {
	    key: 'handleEmail',
	    value: function handleEmail(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          email: value
	        })
	      });
	    }
	  }, {
	    key: 'getUploadJson',
	    value: function getUploadJson(json) {
	      var _this2 = this;
	
	      json.then(function (json) {
	        _this2.setState({
	          requestParams: Object.assign({}, _this2.state.requestParams, {
	            companyLogoUuid: json.uuid
	          })
	        });
	      });
	    }
	  }, {
	    key: 'newPasswordOnChange',
	    value: function newPasswordOnChange(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          password: value
	        })
	      });
	    }
	  }, {
	    key: 'confirmPasswordOnChange',
	    value: function confirmPasswordOnChange(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          confirmPassword: value
	        })
	      });
	    }
	  }, {
	    key: 'handleTitle',
	    value: function handleTitle(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          title: value
	        })
	      });
	    }
	  }, {
	    key: 'handleUsername',
	    value: function handleUsername(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          username: value
	        })
	      });
	    }
	  }, {
	    key: 'handleMobilePhone',
	    value: function handleMobilePhone(e) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          mobilePhone: e.target.value
	        })
	      });
	    }
	  }, {
	    key: 'handleOfficePhone',
	    value: function handleOfficePhone(e) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          officePhone: e.target.value
	        })
	      });
	    }
	  }, {
	    key: 'getUploadPhotoJson',
	    value: function getUploadPhotoJson(json) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          avatar: json.name
	        })
	      });
	    }
	  }, {
	    key: 'handleRegister',
	    value: function handleRegister() {
	      // if register for business unit memeber
	      var isInviteBusinessMember = /^\/create-business-unit-member-account/gi.test(this.props.location.pathname);
	      if (this.state.requestParams.firstName.trim().length === 0) {
	        this.setState({
	          requiredFirstNameText: 'Please enter your first name'
	        });
	      } else {
	        this.setState({
	          requiredFirstNameText: ''
	        });
	      }
	      if (this.state.requestParams.lastName.trim().length === 0) {
	        this.setState({
	          requiredLastNameText: 'Please enter your last name'
	        });
	      } else {
	        this.setState({
	          requiredLastNameText: ''
	        });
	      }
	      if (this.state.requestParams.email.trim().length === 0) {
	        this.setState({
	          requiredEmailText: 'Please enter your email'
	        });
	      } else {
	        this.setState({
	          requiredEmailText: ''
	        });
	      }
	      if (this.state.requestParams.firstName.trim().length > 0 && this.state.requestParams.lastName.trim().length > 0 && this.state.requestParams.email.trim().length > 0) {
	        isInviteBusinessMember ? this.props.register(this.props.match.params.code, this.state.requestParams, 'businessUnitMemberRegister') : this.props.register(this.props.match.params.code, this.state.requestParams, 'clientRegister');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var isInviteBusinessMember = /^\/create-business-unit-member-account/gi.test(this.props.location.pathname);
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'create-client-account' },
	          this.props.invitation_error_message !== '' && _react2.default.createElement(
	            'div',
	            { className: 'create-account-success', style: { width: '100%', border: 'none' } },
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '16px', color: 'black', fontWeight: 'bolder', padding: '25px 0', textAlign: 'center' } },
	              this.props.invitation_error_message
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center' }, className: 'btn-wrapper' },
	              _react2.default.createElement(
	                'a',
	                { href: '/login', style: { height: '30px', padding: '0 10px', background: (0, _utility.buttonBlueColor)(), color: 'white', border: 'none' } },
	                'CLOSE'
	              )
	            )
	          ),
	          this.props.ifRegisterSuccess && _react2.default.createElement(
	            'div',
	            { className: 'create-account-success', style: { margin: '2em auto 3em' } },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Your have successfully created your profile'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-wrapper' },
	              _react2.default.createElement(
	                'a',
	                { href: '/login' },
	                'LOGIN'
	              )
	            )
	          ),
	          !this.props.ifRegisterSuccess && this.props.invitation_error_message === '' && _react2.default.createElement(
	            'div',
	            { className: 'create-client-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'create-client-account-field-wrapper' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'MY PROFILE'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'client-name' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  isInviteBusinessMember ? 'Business Unit Name' : 'Client Name'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  typeof this.props.get_invitation_by_code.invitation !== 'undefined' && this.props.get_invitation_by_code.invitation.client.name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'explain' },
	                _react2.default.createElement(_RoleExplainTip2.default, {
	                  role: typeof this.props.get_invitation_by_code.invitation !== 'undefined' && this.props.get_invitation_by_code.invitation.role
	                })
	              ),
	              _react2.default.createElement(_InputField2.default, {
	                labelTitle: 'Title',
	                onChange: function onChange(e, value) {
	                  return _this3.handleTitle(e, value);
	                },
	                borderColor: 'black',
	                labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                inputContainerId: 'title',
	                style: { height: '32px', lineHeight: '32px', marginBottom: '30px' }
	              }),
	              _react2.default.createElement(_InputField2.default, {
	                labelTitle: 'First Name',
	                ifRequireField: true,
	                initValue: this.state.requestParams.firstName,
	                hintText: this.state.requestParams.firstName,
	                onChange: function onChange(e, value) {
	                  return _this3.handleFirstName(e, value);
	                },
	                borderColor: 'black',
	                labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                inputContainerId: 'firstName',
	                style: { height: '32px', lineHeight: '32px', marginBottom: '30px' }
	              }),
	              this.state.requiredFirstNameText && _react2.default.createElement(
	                'p',
	                { className: 'create-account-field-error clearfix' },
	                _react2.default.createElement(_error2.default, {
	                  style: { float: 'left' },
	                  color: 'red'
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this.state.requiredFirstNameText
	                )
	              ),
	              _react2.default.createElement(_InputField2.default, {
	                labelTitle: 'Last Name',
	                ifRequireField: true,
	                initValue: this.state.requestParams.lastName,
	                hintText: this.state.requestParams.lastName,
	                onChange: function onChange(e, value) {
	                  return _this3.handleLastName(e, value);
	                },
	                borderColor: 'black',
	                labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                inputContainerId: 'lastName',
	                style: { height: '32px', lineHeight: '32px', marginBottom: '30px' }
	              }),
	              this.state.requiredLastNameText && _react2.default.createElement(
	                'p',
	                { className: 'create-account-field-error clearfix' },
	                _react2.default.createElement(_error2.default, {
	                  style: { float: 'left' },
	                  color: 'red'
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this.state.requiredLastNameText
	                )
	              ),
	              _react2.default.createElement(_InputField2.default, {
	                labelTitle: 'E-mail Address',
	                ifRequireField: true,
	                initValue: this.state.requestParams.email,
	                hintText: this.state.requestParams.email,
	                onChange: function onChange(e, value) {
	                  return _this3.handleEmail(e, value);
	                },
	                borderColor: 'black',
	                labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                inputContainerId: 'email',
	                style: { height: '32px', lineHeight: '32px', marginBottom: '30px' }
	              }),
	              this.state.requiredEmailText && _react2.default.createElement(
	                'p',
	                { className: 'create-account-field-error clearfix' },
	                _react2.default.createElement(_error2.default, {
	                  style: { float: 'left' },
	                  color: 'red'
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this.state.requiredEmailText
	                )
	              ),
	              _react2.default.createElement(_InputField2.default, {
	                labelTitle: 'Username',
	                onChange: function onChange(e, value) {
	                  return _this3.handleUsername(e, value);
	                },
	                borderColor: 'black',
	                labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	                inputContainerId: 'username',
	                style: { height: '32px', lineHeight: '32px', marginBottom: '30px' }
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'profile-mobile-phone-number clearfix', style: { marginBottom: '30px' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { marginTop: this.state.ifHiddenTopEdit ? '' : '10px' } },
	                  'Mobile Phone Number'
	                ),
	                _react2.default.createElement(_reactTextMask2.default, {
	                  className: 'mp-mask',
	                  guide: false,
	                  style: { border: '1px solid black', height: '32px' },
	                  mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	                  onChange: function onChange(e) {
	                    return _this3.handleMobilePhone(e);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'profile-mobile-phone-number clearfix', style: { marginBottom: '30px' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { marginTop: this.state.ifHiddenTopEdit ? '' : '10px' } },
	                  'Office Phone Number'
	                ),
	                _react2.default.createElement(_reactTextMask2.default, {
	                  className: 'mp-mask',
	                  guide: false,
	                  style: { border: '1px solid black', height: '32px' },
	                  mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	                  onChange: function onChange(e) {
	                    return _this3.handleOfficePhone(e);
	                  }
	                })
	              )
	            ),
	            (!/Team Member/gi.test(this.state.roleName) || isInviteBusinessMember) && _react2.default.createElement(_ImgUpload2.default, {
	              title: 'Logo',
	              fieldName: 'logo',
	              buttonLable: 'UPLOAD LOGO',
	              getUploadJson: function getUploadJson(json) {
	                return _this3.getUploadJson(json);
	              },
	              url: '/api/invitations/with/' + this.props.match.params.code + '/logo/upload',
	              subTitle: 'Select a logo to upload'
	            }),
	            _react2.default.createElement(_ImgUpload2.default, {
	              title: 'PROFILE PHOTO',
	              fieldName: 'avatar',
	              buttonLable: 'UPLOAD PHOTO',
	              getUploadJson: function getUploadJson(json) {
	                return _this3.getUploadPhotoJson(json);
	              },
	              url: '/api/avatars/' + this.props.match.params.code + '/upload',
	              subTitle: 'Select a photo to upload'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'create-client-account-pw' },
	              _react2.default.createElement(_CreateYourPassword2.default, {
	                newPasswordOnChange: function newPasswordOnChange(e, value) {
	                  return _this3.newPasswordOnChange(e, value);
	                },
	                confirmPasswordOnChange: function confirmPasswordOnChange(e, value) {
	                  return _this3.confirmPasswordOnChange(e, value);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'btns clearfix' },
	              _react2.default.createElement(
	                'p',
	                { style: { float: 'left', color: 'red', lineHeight: '30px', width: '42em' } },
	                this.props.error_message
	              ),
	              _react2.default.createElement(
	                'button',
	                { onClick: function onClick() {
	                    return _this3.handleRegister();
	                  } },
	                'SAVE'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateClientAccount;
	}(_react.Component);
	
	exports.default = CreateClientAccount;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientUnits = function (_AcquireWebComponent) {
		_inherits(ClientUnits, _AcquireWebComponent);
	
		function ClientUnits() {
			_classCallCheck(this, ClientUnits);
	
			return _possibleConstructorReturn(this, (ClientUnits.__proto__ || Object.getPrototypeOf(ClientUnits)).apply(this, arguments));
		}
	
		_createClass(ClientUnits, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    title = _props.title,
				    data = _props.data,
				    footer = _props.footer;
	
				if ((0, _isEmpty2.default)(data)) {
					return _react2.default.createElement(
						'div',
						{ style: { float: "left", width: "100%", position: "relative" } },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '16px', lineHeight: '18px', fontWeight: 'bold' } },
							title
						),
						_react2.default.createElement(
							'div',
							{ style: { width: '100%', minHeight: '190px', textAlign: 'center', paddingTop: '50px', color: "#CDCDCD" } },
							_react2.default.createElement(
								'div',
								{ style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
								'No Data'
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'client-units-container' },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '24px', lineHeight: '28px', fontWeight: 'bold' }, className: 'mb-10' },
							title
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'no-padding-left pt-10', style: { fontSize: '16px' } },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '6', sm: '6', md: '6', lg: '6', className: 'light-grey-right-border pr-20' },
								_react2.default.createElement(
									'div',
									{ style: { height: '18px', marginBottom: '20px' } },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Total Clients:'
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										(0, _utility.splitNumber)(data.totalClients)()
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { height: '18px', marginBottom: '20px' } },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Join Last 30 Days: '
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										(0, _utility.splitNumber)(data.clientsJoinLastMonth)()
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { lineHeight: '16px' }, className: 'light-grey-bottom-border pt-15 pb-15 light-grey-top-border' },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Client Users:'
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										(0, _utility.splitNumber)(data.clientUsers)()
									)
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '6', sm: '6', md: '6', lg: '6', className: 'pl-20' },
								_react2.default.createElement(
									'div',
									{ style: { height: '18px', marginBottom: '20px' } },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Total Business Units:'
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										(0, _utility.splitNumber)(data.totalBizUnit)()
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { height: '18px', marginBottom: '20px' } },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Join Last 30 Days: '
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										(0, _utility.splitNumber)(data.bizUnitJoinLastMonth)()
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { lineHeight: '18px' }, className: 'light-grey-bottom-border pt-15 pb-15 light-grey-top-border ' },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Business unit Users:'
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										(0, _utility.splitNumber)(data.bizUnitUsers)()
									)
								)
							)
						),
						footer && _react2.default.createElement(
							_Grid.FullRow,
							{ className: 'pl-10' },
							footer
						)
					);
				}
			}
		}]);
	
		return ClientUnits;
	}(_MaterialUI2.default);
	
	exports.default = ClientUnits;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _materialUi = __webpack_require__(38);
	
	var _releaseNote = __webpack_require__(1090);
	
	var _releaseNote2 = _interopRequireDefault(_releaseNote);
	
	var _ListGraphicClarita = __webpack_require__(1097);
	
	var _ListGraphicClarita2 = _interopRequireDefault(_ListGraphicClarita);
	
	var _utility = __webpack_require__(14);
	
	var _clientUnits = __webpack_require__(1087);
	
	var _clientUnits2 = _interopRequireDefault(_clientUnits);
	
	var _reactRouterDom = __webpack_require__(32);
	
	__webpack_require__(1416);
	
	var _insightAudienceData = __webpack_require__(1089);
	
	var _insightAudienceData2 = _interopRequireDefault(_insightAudienceData);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _reverse = __webpack_require__(675);
	
	var _reverse2 = _interopRequireDefault(_reverse);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dashboard = function (_AcquireWebComponent) {
	  _inherits(Dashboard, _AcquireWebComponent);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    var cid = (0, _utility.getUrlParameterByName)("cid");
	    if (cid && !isNaN(cid)) {
	      _this.props.selectClient(parseInt(cid, 10));
	    }
	    _this.state = {
	      insightOpen: false,
	      graphOpen: false,
	      clientWidth: 508,
	      statsPeriod: "month2Date"
	    };
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: "handleClose",
	    value: function handleClose(e) {
	      e.preventDefault();
	
	      this.setState({
	        insightOpen: false,
	        graphOpen: false
	      });
	    }
	  }, {
	    key: "handleInsightClick",
	    value: function handleInsightClick(e) {
	      e.preventDefault();
	      this.setState({
	        insightOpen: true
	      });
	    }
	  }, {
	    key: "handleGraphClick",
	    value: function handleGraphClick(e) {
	      e.preventDefault();
	      this.setState({
	        graphOpen: true
	      });
	    }
	  }, {
	    key: "updateDimensions",
	    value: function updateDimensions() {
	      var width = 520;
	      try {
	        width = document.getElementsByClassName("dashboard-container")[0].clientWidth * 0.8 / 2;
	      } catch (e) {
	        width = 520;
	      }
	      this.setState({ clientWidth: width - 10 });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      window.addEventListener("resize", this.updateDimensions.bind(this));
	
	      if (this.props.roleId && this.props.roleId < 51) {
	        this.props.getClientStats();
	        this.props.getClientSubscriptionStats();
	        this.props.getClientTagStats();
	        this.props.getInsightsStats(this.state.statsPeriod);
	      }
	      this.updateDimensions();
	      this.props.getDisabledFeatures();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions.bind(this));
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.roleId !== this.props.roleId && nextProps.roleId < 51) {
	        this.props.getClientStats();
	        this.props.getClientSubscriptionStats();
	        this.props.getClientTagStats();
	        this.props.getInsightsStats(this.state.statsPeriod);
	      }
	    }
	  }, {
	    key: "handlePeriodChanged",
	    value: function handlePeriodChanged(e) {
	      this.props.getInsightsStats(e.value);
	      this.setState({ statsPeriod: e.value });
	    }
	  }, {
	    key: "statsContent",
	    value: function statsContent() {
	      if (this.props.roleId < 51) {
	        var clientUnits = this.props.client_stats;
	        var clientSubs = [];
	        var clientTags = [];
	        var _props = this.props,
	            client_subscription_stats = _props.client_subscription_stats,
	            client_tag_stats = _props.client_tag_stats,
	            insights_stats = _props.insights_stats;
	
	        if (client_subscription_stats) {
	          client_subscription_stats.forEach(function (stats) {
	            clientSubs.push({ name: stats.key, value: stats.value });
	          });
	        }
	        clientSubs = (0, _reverse2.default)((0, _sortBy2.default)(clientSubs, function (item) {
	          return item.value;
	        }));
	        if (client_tag_stats) {
	          //clientTags.push({name:'Total', value:client_tag_stats.total})
	          clientTags.push({ name: "Active", value: client_tag_stats.active });
	          clientTags.push({ name: "Inactive", value: client_tag_stats.inactive });
	        }
	        return [_react2.default.createElement(
	          _Grid.Row,
	          {
	            key: "dashboard-stats-row-1",
	            style: { margin: "20px 10%", minWidth: "1024px" },
	            className: "no-padding"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border pt-20 pl-20 bg-white",
	              style: {
	                float: "left",
	                width: this.state.clientWidth + "px",
	                minWidth: "500px",
	                height: "300px",
	                position: "relative"
	              }
	            },
	            _react2.default.createElement(_ListGraphicClarita2.default, {
	              title: "Subscriptions",
	              key: "dashboard-subscriptions",
	              data: clientSubs,
	              showGraphic: true,
	              footer: _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  style: { bottom: "0px", fontSize: "16px" },
	                  className: "section-link",
	                  to: "/dashboard/subscription"
	                },
	                "View More Subscription"
	              )
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border pt-20 pl-20 bg-white",
	              style: {
	                float: "right",
	                width: this.state.clientWidth + "px",
	                minWidth: "500px",
	                position: "relative",
	                height: "300px"
	              }
	            },
	            _react2.default.createElement(_clientUnits2.default, {
	              title: "Clients/Business Units",
	              footer: _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  className: "section-link",
	                  to: "/dashboard/clients/client-business-info"
	                },
	                "View More Information"
	              ),
	              data: clientUnits
	            })
	          )
	        ), _react2.default.createElement(
	          _Grid.Row,
	          {
	            key: "dashboard-stats-row-2",
	            style: { margin: "20px 10%", minWidth: "1024px" },
	            className: "no-padding"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border pt-20 pl-20 bg-white",
	              style: {
	                float: "left",
	                width: this.state.clientWidth + "px",
	                minWidth: "500px",
	                height: "300px",
	                position: "relative"
	              }
	            },
	            _react2.default.createElement(_ListGraphicClarita2.default, {
	              title: "Tags",
	              key: "dashboard-tags",
	              data: clientTags,
	              showGraphic: true,
	              footer: _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  className: "section-link",
	                  style: { bottom: "80px", fontSize: "16px" },
	                  to: "/dashboard/tags"
	                },
	                "View More Information"
	              )
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border pt-20 pl-20 bg-white",
	              style: {
	                float: "right",
	                width: this.state.clientWidth + "px",
	                minWidth: "500px",
	                position: "relative",
	                height: "300px"
	              }
	            },
	            _react2.default.createElement(_insightAudienceData2.default, {
	              title: "Data",
	              data: insights_stats,
	              period: this.state.statsPeriod,
	              handlePeriodChanged: this.handlePeriodChanged.bind(this),
	              footer: _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  style: { bottom: "0" },
	                  className: "section-link",
	                  to: "/dashboard/data/insights"
	                },
	                "View More Information"
	              )
	            })
	          )
	        )];
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var showMain = Boolean(this.props.loginUserDetail && !this.props.loginUserDetail.baroUid || this.props.optimizeUserDetail && this.props.optimizeUserDetail.aaUser && parseInt(this.props.optimizeUserDetail.aaUser.subscriptionTierId, 10) !== 5 || this.props.loginUserDetail && this.props.loginUserDetail.baroUid && !this.props.optimizeUserDetail && this.props.client_info && parseInt(this.props.client_info.subscriptionTierId, 10) !== 5 || this.props.loginUserDetail && this.props.loginUserDetail.baroUid && !this.props.optimizeUserDetail && !this.props.client_info && isNaN(this.props.selected_client) && this.props.selected_client.indexOf("r-") >= 0);
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "dashboard-container",
	          style: {
	            background: "#FFFFFF",
	            marginTop: "-20px",
	            paddingTop: "20px",
	            marginBottom: "-20px",
	            paddingBottom: "20px",
	            minWidth: "1480px"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              textAlign: "center",
	              fontSize: "24px",
	              marginTop: "200px",
	              height: "500px",
	              display: showMain ? "none" : "display"
	            }
	          },
	          "Data loading...",
	          " ",
	          _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              margin: "20px 10%",
	              background: "#FFFFFF",
	              display: showMain ? "block" : "none"
	            },
	            className: "light-grey-border"
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-padding-bottom mb-5 pt-20 text-center",
	              style: { minWidth: "1024px" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "no-margin-top no-margin-bottom dashboard-title" },
	              "Welcome to your AudienceAnywhere Dashboard!"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "dashboard-title-line mt-10 mb-20" },
	              "Be sure to access your dashboard often to view platform metrics."
	            )
	          )
	        ),
	        showMain && this.statsContent(),
	        _react2.default.createElement(
	          _Grid.Row,
	          {
	            key: "release-note-and-video",
	            style: {
	              margin: "20px 10%",
	              minWidth: "1024px",
	              display: showMain ? "block" : "none"
	            },
	            className: "no-padding"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border pt-20 pl-20 pr-20 bg-white",
	              style: {
	                float: "left",
	                width: this.state.clientWidth + "px",
	                minWidth: "500px",
	                height: "300px",
	                position: "relative",
	                overflowY: "auto"
	              }
	            },
	            _react2.default.createElement(_releaseNote2.default, null)
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border pt-20 pl-20 pr-20 bg-white",
	              style: {
	                float: "right",
	                width: this.state.clientWidth + "px",
	                minWidth: "500px",
	                position: "relative",
	                height: "300px"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { margin: "0", background: "#fff" } },
	              _react2.default.createElement(
	                "h5",
	                {
	                  className: "no-margin-top no-margin-bottom mb-20",
	                  style: { fontWeight: "bold", fontSize: "24px" }
	                },
	                "Videos"
	              ),
	              _react2.default.createElement(
	                _Grid.Row,
	                { className: "no-margin-bottom no-padding" },
	                _react2.default.createElement(
	                  _Grid.Col,
	                  { xs: "6", sm: "6", md: "6", lg: "6" },
	                  _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                      modal: false,
	                      open: this.state.insightOpen,
	                      onRequestClose: this.handleClose.bind(this),
	                      ref: function ref(el) {
	                        return _this2._insightVideoBox = el;
	                      },
	                      bodyClassName: "insight-video-body",
	                      bodyStyle: { padding: "0 0 0 0", maxHeight: "433px" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "video-box-title" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          onClick: function onClick(e) {
	                            _this2.handleClose(e);
	                          }
	                        },
	                        "X"
	                      )
	                    ),
	                    _react2.default.createElement("iframe", {
	                      src: "https://player.vimeo.com/video/196499808?autoplay=1&hd=1&show_title=1&show_byline=1&show_portrait=0&fullscreen=1",
	                      width: "770",
	                      height: "433",
	                      frameBorder: "0",
	                      allowFullScreen: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "#",
	                      target: "_blank",
	                      onClick: function onClick(e) {
	                        _this2.handleInsightClick(e);
	                      }
	                    },
	                    _react2.default.createElement("img", {
	                      className: "aw-image",
	                      src: "/images/acquireinsight.jpg",
	                      alt: ""
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Col,
	                  { cs: "6", sm: "6", md: "6", lg: "6" },
	                  _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                      modal: false,
	                      open: this.state.graphOpen,
	                      onRequestClose: this.handleClose.bind(this),
	                      ref: function ref(el) {
	                        return _this2._graphVideoBox = el;
	                      },
	                      bodyStyle: { padding: "0 0 0 0" },
	                      bodyClassName: "graph-video-body"
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "video-box-title" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          onClick: function onClick(e) {
	                            _this2.handleClose(e);
	                          }
	                        },
	                        "X"
	                      )
	                    ),
	                    _react2.default.createElement("iframe", {
	                      src: "https://player.vimeo.com/video/189844803?autoplay=1&hd=1&show_title=1&show_byline=1&show_portrait=0&fullscreen=1",
	                      width: "770",
	                      height: "433",
	                      frameBorder: "0",
	                      allowFullScreen: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "#",
	                      target: "_blank",
	                      onClick: function onClick(e) {
	                        _this2.handleGraphClick(e);
	                      }
	                    },
	                    _react2.default.createElement("img", {
	                      className: "aw-image",
	                      src: "/images/acquiregraph.jpg",
	                      alt: ""
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Row,
	          {
	            key: "notification-support-section",
	            style: {
	              margin: "20px 10% 30px",
	              minWidth: "1024px",
	              display: showMain ? "block" : "none"
	            },
	            className: "no-padding"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border pt-20 pl-20 pr-20 bg-white",
	              style: {
	                float: "left",
	                width: this.state.clientWidth + "px",
	                minWidth: "500px",
	                height: "180px",
	                position: "relative",
	                overflowY: "auto"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  margin: "0px",
	                  fontWeight: "350",
	                  padding: "0px",
	                  height: "150px",
	                  background: "#fff"
	                }
	              },
	              _react2.default.createElement(
	                "h5",
	                {
	                  className: "no-margin-top",
	                  style: { fontWeight: "bold", fontSize: "24px" }
	                },
	                "Notifications"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border pt-20 pl-20 pr-20 bg-white",
	              style: {
	                float: "right",
	                width: this.state.clientWidth + "px",
	                minWidth: "500px",
	                position: "relative",
	                height: "180px"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  margin: "0",
	                  fontWeight: "350",
	                  padding: "0px",
	                  height: "150px",
	                  background: "#fff",
	                  fontSize: "16px"
	                }
	              },
	              _react2.default.createElement(
	                "h5",
	                {
	                  className: "no-margin-top mb-10",
	                  style: { fontWeight: "bold", fontSize: "24px" }
	                },
	                "Support"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "mb-10", style: { fontWeight: "600" } },
	                "Contact"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "mb-10" },
	                "Business Hours: 8:00 AM - 5:00 PM CST"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "aa-color",
	                  href: "mailto:AudienceAnywhere@claritas.com"
	                },
	                "AudienceAnywhere@claritas.com"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_MaterialUI2.default);
	
	exports.default = Dashboard;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsightAudienceData = function (_AcquireWebComponent) {
		_inherits(InsightAudienceData, _AcquireWebComponent);
	
		function InsightAudienceData() {
			_classCallCheck(this, InsightAudienceData);
	
			return _possibleConstructorReturn(this, (InsightAudienceData.__proto__ || Object.getPrototypeOf(InsightAudienceData)).apply(this, arguments));
		}
	
		_createClass(InsightAudienceData, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    title = _props.title,
				    data = _props.data,
				    footer = _props.footer;
	
				if ((0, _isEmpty2.default)(data)) {
					return _react2.default.createElement(
						'div',
						{ style: { float: "left", width: "100%", position: "relative" } },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '16px', lineHeight: '18px', fontWeight: 'bold' } },
							title
						),
						_react2.default.createElement(
							'div',
							{ style: { width: '100%', minHeight: '190px', textAlign: 'center', paddingTop: '50px', color: "#CDCDCD" } },
							_react2.default.createElement(
								'div',
								{ style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
								'No Data'
							)
						)
					);
				} else {
					var options = [{ value: 'month2Date', label: 'Month to Date' }, { value: 'year2Date', label: 'Year to Date' }];
					return _react2.default.createElement(
						'div',
						{ className: 'insights-container' },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '24px', lineHeight: '28px', fontWeight: 'bold' } },
							title
						),
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-padding-left pt-10 pb-10 no-margin-bottom', style: { fontSize: '16px' } },
							_react2.default.createElement(
								'div',
								{ style: { position: 'absolute', top: '10px' } },
								'View Data'
							),
							_react2.default.createElement(_reactSelect2.default, { style: { width: '140px' },
								name: '',
								value: this.props.period,
								clearable: false,
								options: options,
								onChange: this.props.handlePeriodChanged
							})
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'no-padding-left pt-10 pb-10', style: { fontSize: '16px' } },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '6', sm: '6', md: '6', lg: '6', className: 'light-grey-right-border pr-20' },
								_react2.default.createElement(
									'div',
									{ style: { lineHeight: '18px' }, className: 'mb-5 pb-10 light-grey-bottom-border' },
									_react2.default.createElement(
										'strong',
										null,
										'Insights Records Delivered'
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { lineHeight: '18px' }, className: 'light-grey-bottom-border pb-10 mb-5 pt-5' },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Consumer: '
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										data.deliveredConsumers ? (0, _utility.splitNumber)(data.deliveredConsumers)() : '0'
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { lineHeight: '18px' }, className: 'light-grey-bottom-border pt-5 pb-10 ' },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Business:'
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										data.deliveredBusinesses ? (0, _utility.splitNumber)(data.deliveredBusinesses)() : '0'
									)
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '6', sm: '6', md: '6', lg: '6', className: 'pl-20' },
								_react2.default.createElement(
									'div',
									{ style: { lineHeight: '18px' }, className: 'mb-5 pb-10 light-grey-bottom-border' },
									_react2.default.createElement(
										'strong',
										null,
										'Audience Records Created'
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { lineHeight: '18px' }, className: 'light-grey-bottom-border pb-10 mb-5 pt-5' },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Consumer: '
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										(0, _utility.splitNumber)(data.createdConsumers)()
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { lineHeight: '18px' }, className: 'light-grey-bottom-border pt-5 pb-10' },
									_react2.default.createElement(
										'span',
										{ style: { width: '60%', textAlign: 'left' } },
										'Business:'
									),
									_react2.default.createElement(
										'span',
										{ style: { width: '40%' }, className: 'text-right pull-right' },
										(0, _utility.splitNumber)(data.createdBusinesses)()
									)
								)
							)
						),
						footer && _react2.default.createElement(
							_Grid.FullRow,
							{ className: 'pl-10' },
							footer
						)
					);
				}
			}
		}]);
	
		return InsightAudienceData;
	}(_MaterialUI2.default);
	
	exports.default = InsightAudienceData;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var supportContainerStyle = {
	  margin: "0px",
	  fontWeight: "400",
	  fontSize: "16px",
	  padding: "0px",
	  overflowY: "hidden",
	  position: "relative"
	};
	
	var tableHead = {
	  display: "inline-flex",
	  background: "#273347",
	  color: "#FFF",
	  width: "100%",
	  padding: "10px",
	  borderTop: "solid 1px #EEEFF2",
	  borderBottom: "solid 1px #EEEFF2",
	  lineHeight: "10px",
	  fontWeight: "bold"
	};
	var tableBodyRow = {
	  display: "inline-flex",
	  background: "#FFF",
	  width: "100%",
	  padding: "10px"
	};
	
	var basicTierCell = {
	  width: "26%",
	  textAlign: "center",
	  borderLeft: "solid 1px #9C9FA4",
	  borderRight: "solid 1px #9C9FA4"
	};
	
	var rowFirstCell = {
	  width: "15%",
	  background: "#9C9FA4",
	  color: "#FFF",
	  textAlign: "center",
	  fontWeight: "bold",
	  verticalAlign: "middle"
	};
	
	var ReleaseNote = function (_AcquireWebComponent) {
	  _inherits(ReleaseNote, _AcquireWebComponent);
	
	  function ReleaseNote() {
	    _classCallCheck(this, ReleaseNote);
	
	    return _possibleConstructorReturn(this, (ReleaseNote.__proto__ || Object.getPrototypeOf(ReleaseNote)).apply(this, arguments));
	  }
	
	  _createClass(ReleaseNote, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.state = {
	        collapsed: true,
	        showTierInfoDialog: false
	      };
	    }
	  }, {
	    key: "clickReadMore",
	    value: function clickReadMore(e) {
	      e.preventDefault();
	
	      if (this.state.collapsed === true) this.setState({
	        collapsed: false
	      });else this.setState({
	        collapsed: true
	      });
	    }
	  }, {
	    key: "showTierClick",
	    value: function showTierClick(e) {
	      this.setState({
	        showTierInfoDialog: true
	      });
	    }
	  }, {
	    key: "hideTierClick",
	    value: function hideTierClick(e) {
	      e.preventDefault();
	      this.setState({
	        showTierInfoDialog: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var actions = [_react2.default.createElement(
	        "a",
	        {
	          className: "btn btn-claritas-default",
	          onClick: this.hideTierClick.bind(this)
	        },
	        "Close"
	      )];
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({}, supportContainerStyle, { background: "#fff" }) },
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.showTierInfoDialog,
	            autoScrollBodyContent: true,
	            contentStyle: { width: "640px", maxWidth: "1024px" },
	            bodyStyle: { border: "none", color: "#000", fontSize: "16px" },
	            style: { zIndex: "1600", paddingRight: "5%" },
	            actions: actions,
	            actionsContainerStyle: {
	              border: "none",
	              textAlign: "right",
	              marginTop: "-20px",
	              padding: "20px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { fontSize: "16px" }, className: "mb-10" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "SUBSCRIPTION TIERS"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: "-5px", marginBottom: "10px" } },
	            _react2.default.createElement(
	              "a",
	              { href: "mailto:AudienceAnywhere@claritas.com" },
	              "Contact support"
	            ),
	            " ",
	            "for pricing information"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: tableHead },
	            _react2.default.createElement("div", { style: { width: "15%" } }),
	            _react2.default.createElement("div", { style: { width: "40%" } }),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "23%", textAlign: "center" } },
	              "Basic"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "32%", textAlign: "center" } },
	              "Standard"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: Object.assign({}, tableBodyRow, { padding: "0" }) },
	            _react2.default.createElement(
	              "div",
	              { style: rowFirstCell },
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "25px" } },
	                "Audience"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: { width: "85%", display: "inline-flex", flexWrap: "wrap" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10 bg-aa-grey"
	                },
	                "Quick Counts"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: basicTierCell, className: "p-10 bg-aa-grey" },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10 bg-aa-grey"
	                },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10"
	                },
	                "Saved Segments Allowed"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: basicTierCell, className: "p-10" },
	                "Up to 10"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10"
	                },
	                "Unlimited"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: Object.assign({}, tableBodyRow, {
	                padding: "0",
	                borderTop: "solid 1px #FFF",
	                borderBottom: "solid 1px #FFF"
	              })
	            },
	            _react2.default.createElement(
	              "div",
	              { style: rowFirstCell },
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "30px" } },
	                "Campaigns"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: { width: "85%", display: "inline-flex", flexWrap: "wrap" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10 bg-aa-grey"
	                },
	                "Aggregated Reporting"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: basicTierCell, className: "p-10 bg-aa-grey" },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10 bg-aa-grey"
	                },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10"
	                },
	                "Detailed Reporting"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: basicTierCell, className: "p-10" },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10"
	                },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: Object.assign({}, tableBodyRow, { padding: "0" }) },
	            _react2.default.createElement(
	              "div",
	              { style: rowFirstCell },
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: "130px" } },
	                "Insights"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: { width: "85%", display: "inline-flex", flexWrap: "wrap" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10 bg-aa-grey"
	                },
	                "Dashboard View"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: basicTierCell, className: "p-10 bg-aa-grey" },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10 bg-aa-grey"
	                },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10"
	                },
	                "Top Attributes"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: basicTierCell, className: "p-10" },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10"
	                },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10 bg-aa-grey"
	                },
	                "Detailed Attributes"
	              ),
	              _react2.default.createElement("div", { style: basicTierCell, className: "p-10 bg-aa-grey" }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10 bg-aa-grey"
	                },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10"
	                },
	                "Top 20 Businesses"
	              ),
	              _react2.default.createElement("div", { style: basicTierCell, className: "p-10" }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10"
	                },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10 bg-aa-grey"
	                },
	                "Custom Variables"
	              ),
	              _react2.default.createElement("div", { style: basicTierCell, className: "p-10 bg-aa-grey" }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10 bg-aa-grey"
	                },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10"
	                },
	                "Page Level Detail"
	              ),
	              _react2.default.createElement("div", { style: basicTierCell, className: "p-10" }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10"
	                },
	                _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400 " })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "40%", fontWeight: "bold" },
	                  className: "p-10 bg-aa-grey pt-20"
	                },
	                "File Output"
	              ),
	              _react2.default.createElement("div", { style: basicTierCell, className: "p-10 bg-aa-grey" }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "34%", textAlign: "center" },
	                  className: "p-10 bg-aa-grey"
	                },
	                "500 Consumers Records",
	                _react2.default.createElement("br", null),
	                "200 Businesses Records"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h5",
	          {
	            className: "no-margin-top no-margin-bottom",
	            style: { fontWeight: "bold", fontSize: "24px" }
	          },
	          "Current Release Notes"
	        ),
	        _react2.default.createElement(
	          _Grid.Row,
	          {
	            className: "no-margin-bottom no-margin-top no-padding-left no-padding-bottom light-grey-bottom-border",
	            style: { paddingTop: "15px", margin: 0, paddingRight: 0 }
	          },
	          _react2.default.createElement(
	            _Grid.Col,
	            {
	              xs: "12",
	              sm: "12",
	              md: "12",
	              lg: "12",
	              style: { fontWeight: "350", paddingLeft: "5px", paddingRight: 0 }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "mb-10",
	                style: {
	                  height: this.state.collapsed === true ? "168px" : "auto",
	                  overflow: this.state.collapsed === true ? "hidden" : "auto"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "line" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Release Notes 4/10/25"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-10 mt-10" },
	                  "Audience Builder Update:"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "The Audience module has been updated with new options for Audience building. Users can select from geographic, demographic and lifestyle options to define a desired audience. Count estimates are provided for direct mail, email, social and display campaigns."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-10 mt-10" },
	                  "Insights Update:"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "We have begun an update of the Insights module which will temporarily remove some demographic descriptors that were previously visible on these pages. Key descriptors like PRIZM Premier, P$YCLE Premier and ConneXions segment distributions remain available."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "line" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Release Notes 3/9/2020"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-10 mt-10" },
	                  "Audience Builder Update:"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Additional selections are now available in the Geography category. New selections include",
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "DMA"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "County"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "As with other geographies, the counts displayed in AudienceAnywhere are for Email, Social, and Display channels"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "line" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Release Notes 2/18/2020"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Counts for the household matching to Zip +6 and Zip +4 have been added to the Segment Distribution module."
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "The match flag enables users to better understand the granularity of a zip assignment to traffic data, and present a better assessment of targeting options for a digital marketing campaign.",
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Precision: Data at Z+6 will be populated for the following areas",
	                        _react2.default.createElement(
	                          "ul",
	                          null,
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Media Channel Reach counts"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Segment details, device details, and CultureCodes"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "When sending an Audience of Website Visitors to the Audience Builder (Pro Tier)"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "At Scale: Z+6 to Z+4 fallback methodology",
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Media Channel Reach counts in Site Analytics and Segment Distribution reflect the Z+6 to Z+4 fallback methodology"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "When sending and Audience of Website Visitors to the Audience Builder all matches from Z+6 and Z+4 are saved to that audience."
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "line" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Release Notes 1/7/2020"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-10 mt-10" },
	                  "The Precision or Scale selections are now available in the Insights module in the Granularity drop down."
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "When selecting Precision: Only data at Z+6 will be populated for the following areas:"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Audience Reach counts in Site Analytics and Segment Distribution will reflect Z+6 matches"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Segment details, device details, and CultureCodes will only display households matched at Z+6"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "When sending an Audience of Website Visitors to the Audience Builder (Pro Tier) only the Z+6 matched data migrated if the Precision option is selected at the time of saving the audience of website visitors and visitors at scale."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-10 mb-10" },
	                  "At Scale: Z+6 to Z+4 fallback methodology"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Reach counts in Site Analytics and Segment Distribution reflect the Z+6 to Z+4 fallback methodology"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "The Audience Builder reach counts will continue to contain a mix of Individual, Z+6, and Z+4 data"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "When sending and Audience of Website Visitors to the Audience Builder all matches from Z+6 and Z+4 are saved to that audience."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "line" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Release Notes 12/15"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Standard & Professional Tier:"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Introducing Precision and Scale options for the consumer address records provided with your AudienceAnywhere subscription"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Choose \u2018Precision\u2019 if you are interested in only receiving addresses that were resolved at the Zip +6 level"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Choose \u2018Scale' to receive Zip+6 matches with a Zip+ 4 fall-back resolution to fulfill your account quota"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "All accounts will default to Scale, so please talk to your account manager about which option is right for you"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Improvements have been made to holding selections as users navigate between Insights pages. Selections made to date range, measure, top segments will now be maintained until changes are made or the session is ended"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Audience Builder:"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Using the new tool-tip hover function in the Audience Builder, users can now better understand the geo-levels for every selection. Use this function to build an audience that is relevant to your targeting needs.",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Available levels are:"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Individual"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Household"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Zip+6"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Zip+4"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "line" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Release Notes 12/3"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Professional Tier:"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "CultureCode data is now available in the Segment Distribution dashboard for Pro Tier subscribers"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "With CultureCode gain insights on anonymous website visitors in the following categories:"
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Ethnicity"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Region"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Acculturation"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "A heatmap of the traffic can now be viewed by specific top segments or for the traffic on the entire domain."
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Click view on map under the Top States chart in Segment Distribution"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Functionality has been added to reactivate an archived audience of website visitors"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Audiences created from website visitors will automatically be archived 90 days after they are created"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Release Notes 11/15"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Professional Tier"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Save an audience from actual website visitors for further refinement in the Audience Builder module"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Users can now target website visitors or their preferred segments at scale using the Create Audience button in the Insights Segmentation Distribution module"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Site Analytics"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "A left rail has been introduced on the main site analytics page with individual tabs for Total, Consumer, and Business"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "The Total tab allows users to better understand all traffic identified by the pixel fire"
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Total traffic is the combination of Consumer, Business, and Other non-routable traffic"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "The Other category includes: Proxy, Wireless, Foreign, and Bot traffic"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "line" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Release Notes 10/31"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "PDF Report downloads are now available for the following Site Analytics Consumer Pages"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Overview Page"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Demographics"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Devices"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Most Popular Pages Report"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "line" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Release Notes 10/18 "
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: "0px" } },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "The Insights Site Analytics pages are updated with a new user interface and additional functionality"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "A left rail has been introduced in Site Analytics to allow users to quickly understand insights about both Consumer and Business traffic"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "View up to the top 100 Popular Pages for both Consumer and Business Traffic"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "The Audience Builder now features a \u201CTarget Households Only\u201D button allowing for reach numbers to be calculated in real time for the Household records."
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Leave this button unchecked if targeting at scale and want to market to the maximum audience that the system can provide"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-10 mb-10" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Q3 Release Updates"
	                  )
	                ),
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Segment Distribution Module"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "View visitors for specific pages through the lens of Claritas Syndicated Segmentation"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "The 100 most popular pages can now be viewed in the Insights Dashboard"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "This functionality was previously only available at the domain level"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Add up to 20 Favorite Pages to track and view in the Insights Dashboard"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "View favorite pages through the lens of Claritas Syndicated Segmentation"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "The list of 20 pages can be edited at any time"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Easily add popular pages to your favorites list by clicking the star from the popular pages view"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Search and add any page from your domain to your favorites list"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Choose up to 10 top segments or select \u2018All\u2019 to view insights about all site visitors and download the data as a PDF or CSV"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Top segments can be viewed either as an Index or % of Household Visitors"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Choose up to 10 top segments or select \u2018All\u2019 to view insights about all visitors to the domain"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Introducing the ability to choose the measure by which you view anonymous traffic. The new \u2018Measure\u2019 drop-down enables users to select:"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "% of Household Visitors"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Index"
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "The Index measure helps client hone-in on their best audience by comparing the % of Household Visitors from a given segment to the Claritas data on the % of the total U.S population that the segment represents."
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Consumer Address File"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Top segments by the measure and Claritas Syndicated Segmentation system of your choice can now inform the Consumer Address File download for Professional Tier subscribers"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "For example, the 500 default records can now be derived from the top number of PRIZM Premier segments that the user selects. The system will only provide addresses from the top segments until the quota on the account is reached."
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Talk to your account manager about increasing the amount of records available on your profile"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Standard tier functionality remains the same where the 500 records will be pulled at random from the site traffic"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "The consumer address file download has been updated to provide only the Primary Decision Maker (PDM) record for the household on file. This update allows the user to maximize the number of addresses received in their specified quota."
	                  )
	                ),
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Audience Builder"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Geoscape CultureCodes data is now available in the Audience Builder Module"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Refine your audience by"
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Ethnicity"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Region & Locale"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Acculturation"
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      null,
	                      "Language Segments"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "read-more-container" },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "aa-color",
	              href: "#",
	              onClick: this.clickReadMore.bind(this)
	            },
	            this.state.collapsed === true ? "...Read more" : "...Show less"
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReleaseNote;
	}(_MaterialUI2.default);
	
	exports.default = ReleaseNote;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(108);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _ClientUsers = __webpack_require__(515);
	
	var _ClientUsers2 = _interopRequireDefault(_ClientUsers);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author chargoyao
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * UpdateAdminUserTip Component
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props UpdateAdminUserTipDialogOpen {boolean} if open tip.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props closeUpdateAdminUserTipDialog {function} when user click `close` button function.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props continue {function} when user click the `confirmation` button go ahead to do something.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props continueLabel {string} confirmation button label string.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @props children {node} the node which you want to append.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// confirmation
	
	
	var Employees = function (_Component) {
	  _inherits(Employees, _Component);
	
	  function Employees(props) {
	    _classCallCheck(this, Employees);
	
	    var _this = _possibleConstructorReturn(this, (Employees.__proto__ || Object.getPrototypeOf(Employees)).call(this, props));
	
	    _this.throttle = true;
	    _this.state = {
	      open: false,
	      value: "", // for table list dialog role value
	      rolesValue: "", // role value for invite component
	      openInviteUser: false,
	      requestParams: {
	        pageNumber: 1,
	        pageSize: 10,
	        sortColumn: "name", //support name , role, email, status field
	        order: "desc" // asc or desc
	      },
	      employeeName: "", // name of employee
	      suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
	      ifReassignClientUIDispaly: false, // weather display re-assign client.
	      ifDisplayConfirmation: false,
	      ifDisplayUpdateAdminUser: true, // default display update admin user view
	      archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
	      ifArchiveOverlayDisplay: false, // archive overlay
	      ifDisplayArchiveUserLink: false, // if archive link click
	      updateParams: {
	        firstName: "",
	        lastName: "",
	        email: "",
	        roleId: 1
	      },
	      employeeId: "",
	      ifUpdateButtonDisable: true
	    };
	    return _this;
	  }
	
	  _createClass(Employees, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.roleId === 5)
	        //operation manager
	        this.props.history.push("/");
	      // get role data
	      var params = {
	        pageNumber: 1,
	        pageSize: 10,
	        sortColumn: "name", //support name , role, email, status field
	        order: "desc" // asc or desc
	      };
	      if (this.props.roleId > 50) {
	        this.props.getClientRoles();
	        this.props.getTableList(params, this.props.selected_client);
	      } else if (this.props.roleId > 0) {
	        this.props.getRoles();
	        this.props.getTableList(params);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.roleId === 5) this.props.history.push("/");
	      if (nextProps.updateErrorText === "") {
	        this.setState({
	          open: false
	        });
	      }
	      var params = {
	        pageNumber: 1,
	        pageSize: 10,
	        sortColumn: "name", //support name , role, email, status field
	        order: "desc" // asc or desc
	      };
	
	      if (nextProps.roleId !== this.props.roleId) {
	        if (nextProps.roleId > 50) {
	          this.props.getClientRoles();
	          if (nextProps.selected_client > 0) this.props.getTableList(params, nextProps.selected_client);
	        } else if (nextProps.roleId > 0) {
	          this.props.getRoles();
	          this.props.getTableList(params);
	        }
	      }
	
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (nextProps.roleId > 50) {
	          if (nextProps.selected_client > 0) this.props.getTableList(params, nextProps.selected_client);
	        } else if (nextProps.roleId > 0) {
	          this.props.getTableList(params);
	        }
	      }
	    }
	  }, {
	    key: "handleDialogShow",
	    value: function handleDialogShow(e, employeeName) {
	      this.props.history.push("/employees/user-status/" + employeeName.id + "/" + this.state.requestParams.pageNumber + "/" + this.state.requestParams.sortColumn + "/" + this.state.requestParams.order);
	    }
	
	    // below is callback for page component
	
	  }, {
	    key: "nextBeClick",
	    value: function nextBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "nextGroupBeClick",
	    value: function nextGroupBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "previousGroupBeClick",
	    value: function previousGroupBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "previousBeClick",
	    value: function previousBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "pageBeClick",
	    value: function pageBeClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "goToPage",
	    value: function goToPage(page) {
	      if (page > this.props.tableList.pageCount) {
	        return;
	      } else {
	        this.dispatchPageAction(page);
	      }
	    }
	  }, {
	    key: "handleIconClick",
	    value: function handleIconClick(targetName) {
	      var params = {
	        order: this.state.requestParams.order === "desc" ? "asc" : "desc",
	        sortColumn: "name"
	      };
	
	      switch (targetName) {
	        case "Role":
	          params.sortColumn = "role";
	          break;
	        case "Email":
	          params.sortColumn = "email";
	          break;
	        case "Status":
	          params.sortColumn = "status";
	          break;
	        case "Name":
	          params.sortColumn = "name";
	          break;
	        default:
	          return;
	      }
	      this.setState({
	        requestParams: {
	          order: params.order,
	          sortColumn: params.sortColumn
	        }
	      });
	      this.props.roleId > 50 ? this.props.getTableList(params, this.props.selected_client) : this.props.getTableList(params);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var muiTheme = (0, _getMuiTheme2.default)({
	        menuItem: {
	          hoverColor: (0, _utility.buttonBlueColor)()
	        }
	      });
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: muiTheme },
	        _react2.default.createElement(
	          "div",
	          { className: "employees" },
	          _react2.default.createElement(_ClientUsers2.default, this.props)
	        )
	      );
	    }
	  }]);
	
	  return Employees;
	}(_react.Component);
	
	exports.default = Employees;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _clear = __webpack_require__(109);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _utility = __webpack_require__(14);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _qs = __webpack_require__(192);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	__webpack_require__(1419);
	
	var _materialUi = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InviteUser = function (_Component) {
	  _inherits(InviteUser, _Component);
	
	  function InviteUser(props) {
	    _classCallCheck(this, InviteUser);
	
	    var _this = _possibleConstructorReturn(this, (InviteUser.__proto__ || Object.getPrototypeOf(InviteUser)).call(this, props));
	
	    _this.state = {
	      ifInviteButtonDisable: true,
	      isPrimaryContact: false
	    };
	    return _this;
	  }
	
	  _createClass(InviteUser, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.openInviteUser) {
	        setTimeout(function () {
	          if (/^(\/clients\/edit\/Business-Units\/detail\/Team Member|\/clients\/edit\/Client-Team-Members)/g.test(nextProps.location.pathname)) {
	            if (_this2.refs.businessUnitName) {
	              _this2.refs.businessUnitName.value = _qs2.default.parse(nextProps.location.search.split('?')[1]).name;
	            }
	          }
	        }, 0);
	      }
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog() {
	      this.setState({
	        isPrimaryContact: false
	      });
	      this.props.rollbackStatus();
	      this.props.closeInviteDialog();
	    }
	  }, {
	    key: 'handleFirstName',
	    value: function handleFirstName() {
	      this.checkButtonEnable();
	    }
	  }, {
	    key: 'handleLastName',
	    value: function handleLastName() {
	      this.checkButtonEnable();
	    }
	  }, {
	    key: 'handleEmail',
	    value: function handleEmail() {
	      this.checkButtonEnable();
	    }
	  }, {
	    key: 'handleSendInvite',
	    value: function handleSendInvite() {
	      var isBusinessUnitTeamMember = /^(\/clients\/edit\/Business-Units\/detail\/Team Member|\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname);
	      var obj = {
	        // roleId: {
	        //   id: this.props.rolesValue
	        //   name: item[0].label // use the number of value to get labe string.
	        // },
	        // roleId: isBusinessUnitTeamMember && /^(administrator|team member)/gi.test(this.props.roleName) ? 53 : this.props.rolesValue,
	        firstName: this.refs.firstName.value,
	        lastName: this.refs.lastName.value,
	        email: this.refs.email.value
	      };
	      if (/^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(this.props.roleName)) {
	        obj.roleId = 53;
	      } else if (/^(\/clients\/edit\/Business-Units\/detail\/Team Member)/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        obj.roleId = 53;
	      } else if (/^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        obj.roleId = this.props.rolesValue;
	      } else {
	        obj.roleId = this.props.rolesValue;
	      }
	      if (isBusinessUnitTeamMember && this.refs.title.value.length > 0) {
	        obj.title = this.refs.title.value; // set title value for bussiness-units/detail/team member router.
	      }
	
	      if (this.props.clientId && !isBusinessUnitTeamMember) {
	        obj.clientId = parseInt(this.props.clientId, 10);
	      } else {
	        if (/^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname)) {
	          // for administrator invite business team member
	          obj.clientId = this.props.match.params.id;
	        } else {
	          obj.clientId = _qs2.default.parse(this.props.location.search.split('?')[1]).id;
	        }
	      }
	
	      obj.primaryContact = this.state.isPrimaryContact;
	      this.props.sendInvite(obj);
	    }
	  }, {
	    key: 'inviteAnotherUser',
	    value: function inviteAnotherUser() {
	      this.setState({
	        ifInviteButtonDisable: true
	      });
	      this.props.rollBackStatus();
	      this.refs.firstName.value = '';
	      this.refs.lastName.value = '';
	      this.refs.email.value = '';
	      this.refs.title.value = '';
	    }
	  }, {
	    key: 'checkButtonEnable',
	    value: function checkButtonEnable() {
	      var re = /^(([^<>()\\\\.,;:\s@"]+(\.[^<>()\\\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      if (/^([A-z]{1,}\s?)*[A-z]$/g.test(this.refs.firstName.value) && /^[A-z]+(\s?(-){0,1}\s?[A-z])+$/g.test(this.refs.lastName.value) && re.test(this.refs.email.value)) {
	        this.setState({
	          ifInviteButtonDisable: false
	        });
	      } else {
	        this.setState({
	          ifInviteButtonDisable: true
	        });
	      }
	    }
	  }, {
	    key: 'handleItemsChange',
	    value: function handleItemsChange(value) {
	      this.props.handleItemsChange(value);
	    }
	  }, {
	    key: 'showRoleField',
	    value: function showRoleField() {
	      if (/^\/employees/.test(this.props.location.pathname)) {
	        return _react2.default.createElement(_reactSelect2.default, {
	          className: 'iv-role-selector ',
	          value: this.props.rolesValue,
	          clearable: false,
	          options: this.props.roles,
	          onChange: this.handleItemsChange.bind(this)
	        });
	      }
	      if (/^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        return _react2.default.createElement(_reactSelect2.default, {
	          className: 'iv-role-selector ',
	          value: this.props.rolesValue,
	          clearable: false,
	          options: this.props.roles,
	          onChange: this.handleItemsChange.bind(this)
	        });
	      }
	      if (/^\/clients\/edit\/Business-Units\/detail\/Team Members/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'input-border', style: { width: '19em', height: '32px', border: '1px solid black', float: 'right' } },
	          _react2.default.createElement('input', { disabled: true, type: 'text', style: { border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black' }, ref: 'role', value: 'Business Unit Team Member' })
	        );
	      }
	      if (/^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(this.props.roleName)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'input-border', style: { width: '19em', height: '32px', border: '1px solid black', float: 'right' } },
	          _react2.default.createElement('input', { disabled: true, type: 'text', style: { border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black' }, ref: 'role', value: 'Business Unit Team Member' })
	        );
	      }
	    }
	  }, {
	    key: 'showTitle',
	    value: function showTitle() {
	      if (this.props.ifSendInviteSuccess) {
	        return "";
	      } else {
	        if (/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname)) {
	          return 'INVITE BUSINESS UNIT TEAM MEMBER';
	        } else if (/^(system administrator|account manager)/gi.test(this.props.roleName) && /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname)) {
	          return 'INVITE TEAM MEMBER';
	        } else if (/^(administrator|team member)/gi.test(this.props.roleName) && /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname)) {
	          return 'INVITE BUSINESS UNIT TEAM MEMBER';
	        } else {
	          return 'INVITE TEAM MEMBER';
	        }
	      }
	    }
	  }, {
	    key: 'updateIsPrimayContact',
	    value: function updateIsPrimayContact() {
	      this.setState({
	        isPrimaryContact: !this.state.isPrimaryContact
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'invite-user' },
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            autoDetectWindowHeight: false,
	            title: this.showTitle(),
	            titleStyle: { fontSize: '18px', border: 'none', marginLeft: "5%", paddingLeft: 0, fontWeight: 'bolder' },
	            open: this.props.openInviteUser,
	            contentStyle: { width: this.props.ifSendInviteSuccess ? '40%' : '33%', height: '470px', minWidth: '520px', maxWidth: '520px' },
	            autoScrollBodyContent: true
	          },
	          _react2.default.createElement(_clear2.default, {
	            style: { position: 'absolute', right: '1.2em', cursor: 'pointer', top: '1.7em' },
	            onClick: function onClick() {
	              return _this3.closeDialog();
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'form', style: { display: !this.props.ifSendInviteSuccess ? 'block' : 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'role clearfix', style: { marginBottom: '0.7em' } },
	              _react2.default.createElement(
	                'p',
	                { style: { color: 'black', fontSize: '14px', float: 'left', fontWeight: 'bolder', marginTop: '0.6em' } },
	                'Role'
	              ),
	              this.showRoleField()
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'common-input clearfix', style: { marginBottom: '0.8em' } },
	              _react2.default.createElement(
	                'p',
	                { style: { color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '0.5em', fontWeight: 'bolder' } },
	                'Title'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-border', style: { width: '19em', height: '32px', border: '1px solid black', float: 'right' } },
	                _react2.default.createElement('input', { type: 'text', style: { border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black' }, ref: 'title' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'common-input clearfix', style: { marginBottom: '0.8em' } },
	              _react2.default.createElement(
	                'p',
	                { style: { color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '0.5em', fontWeight: 'bolder' } },
	                'First Name',
	                _react2.default.createElement(
	                  'em',
	                  { style: { color: 'red' } },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-border', style: { width: '19em', height: '32px', border: '1px solid black', float: 'right' } },
	                _react2.default.createElement('input', { type: 'text', style: { border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black' }, ref: 'firstName', onKeyUp: function onKeyUp() {
	                    return _this3.handleFirstName();
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'common-input clearfix', style: { marginBottom: '0.8em' } },
	              _react2.default.createElement(
	                'p',
	                { style: { color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '0.5em', fontWeight: 'bolder' } },
	                'Last Name',
	                _react2.default.createElement(
	                  'em',
	                  { style: { color: 'red' } },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-border', style: { width: '19em', height: '32px', border: '1px solid black', float: 'right' } },
	                _react2.default.createElement('input', { type: 'text', style: { border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black' }, ref: 'lastName', onKeyUp: function onKeyUp() {
	                    return _this3.handleLastName();
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'common-input clearfix', style: { marginBottom: '0.8em' } },
	              _react2.default.createElement(
	                'p',
	                { style: { color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '0.5em', fontWeight: 'bolder' } },
	                'E-mail',
	                _react2.default.createElement(
	                  'em',
	                  { style: { color: 'red' } },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-border', style: { width: '19em', height: '32px', border: '1px solid black', float: 'right' } },
	                _react2.default.createElement('input', { type: 'text', style: { border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black' }, ref: 'email', onKeyUp: function onKeyUp() {
	                    return _this3.handleEmail();
	                  } })
	              )
	            ),
	            /^(\/clients\/edit\/Business-Units\/detail\/Team Member)/g.test(this.props.location.pathname) && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'common-input clearfix', style: { marginBottom: '15px', height: '40px' } },
	                _react2.default.createElement(
	                  'p',
	                  { style: { color: '#000', fontSize: '14px', marginTop: '0px', fontWeight: 'bolder', position: 'absolute' } },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Primay Business ',
	                    _react2.default.createElement('br', null),
	                    'Unit Contact'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { position: 'absolute', top: '5px', right: '-6.2em' } },
	                    _react2.default.createElement(_materialUi.Checkbox, { iconStyle: { fill: '#000', fillOpacity: '0.7' },
	                      checked: this.state.isPrimaryContact, onCheck: this.updateIsPrimayContact.bind(this) })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'common-input clearfix', style: { marginBottom: '0.8em' } },
	                _react2.default.createElement(
	                  'p',
	                  { style: { color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '-0.2em', width: '5.7em', fontWeight: 'bolder' } },
	                  'Business Unit Name',
	                  _react2.default.createElement(
	                    'em',
	                    { style: { color: 'red' } },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-border', style: { width: '19em', height: '32px', border: '1px solid black', float: 'right' } },
	                  _react2.default.createElement('input', { type: 'text', disabled: true, style: { border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black' }, ref: 'businessUnitName', onKeyUp: function onKeyUp() {
	                      return _this3.handleBusinessUnitName();
	                    } })
	                )
	              )
	            ),
	            /^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(this.props.roleName) && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'common-input clearfix', style: { marginBottom: '15px', height: '40px' } },
	                _react2.default.createElement(
	                  'p',
	                  { style: { color: '#000', fontSize: '14px', marginTop: '0px', fontWeight: 'bolder', position: 'absolute' } },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Primay Business ',
	                    _react2.default.createElement('br', null),
	                    'Unit Contact'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { position: 'absolute', top: '5px', right: '-6.2em' } },
	                    _react2.default.createElement(_materialUi.Checkbox, { iconStyle: { fill: '#000', fillOpacity: '0.7' },
	                      checked: this.state.isPrimaryContact, onCheck: this.updateIsPrimayContact.bind(this) })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'common-input clearfix', style: { marginBottom: '0.8em' } },
	                _react2.default.createElement(
	                  'p',
	                  { style: { color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '-0.2em', width: '5.7em', fontWeight: 'bolder' } },
	                  'Business Unit Name',
	                  _react2.default.createElement(
	                    'em',
	                    { style: { color: 'red' } },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-border', style: { width: '19em', height: '32px', border: '1px solid black', float: 'right' } },
	                  _react2.default.createElement('input', { type: 'text', disabled: true, style: { border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black' }, ref: 'businessUnitName', onKeyUp: function onKeyUp() {
	                      return _this3.handleBusinessUnitName();
	                    } })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-btns clearfix', style: { marginTop: '20px' } },
	              _react2.default.createElement(_FlatButton2.default, {
	                label: 'SEND INVITE',
	                style: { fontSize: '13px', color: 'white ', float: 'right' },
	                backgroundColor: (0, _utility.buttonBlueColor)(),
	                hoverColor: (0, _utility.buttonBlueColor)(),
	                onClick: function onClick() {
	                  return _this3.handleSendInvite();
	                },
	                disabled: this.state.ifInviteButtonDisable
	              }),
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-link pull-right ', style: { marginLeft: '-1.3em', border: '1px solid black', fontWeight: 'bolder', padding: '7px 17px', borderRadius: '0', marginRight: '0.8em', fontSize: '13px' },
	                  onClick: function onClick(e) {
	                    return _this3.closeDialog();
	                  } },
	                'Cancel'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { color: 'red', textAlign: 'center', fontSize: '12px', marginTop: '1em' } },
	              this.props.sendInvite_error_message || this.props.send_invitation_error_msg
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'invite-user-success', style: { display: this.props.ifSendInviteSuccess ? 'block' : 'none' } },
	            _react2.default.createElement(
	              'p',
	              { style: { fontWeight: 'bolder', color: 'black', textAlign: 'center' } },
	              'Your invitation email has been sent.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'invite-user-success-btns' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-link', style: { marginLeft: '-1em', color: 'white', background: (0, _utility.buttonBlueColor)() },
	                  onClick: function onClick(e) {
	                    _this3.closeDialog();
	                  } },
	                'CLOSE'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InviteUser;
	}(_react.Component);
	
	exports.default = InviteUser;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _clear = __webpack_require__(109);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1420);
	
	var _remove = __webpack_require__(188);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _orderBy = __webpack_require__(673);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styleSheet = {
	  table_th: {
	    fontSize: "14px"
	  },
	  table: {
	    width: "100%",
	    color: "black"
	  },
	  table_tr: {
	    height: "30px"
	  },
	  thead: {},
	  checkbox: {
	    display: "inline-block",
	    border: "1px solid #827e7e",
	    background: "white",
	    width: "15px",
	    height: "15px",
	    cursor: "pointer",
	    marginTop: "4px",
	    position: "relative"
	  },
	  firstTh: {
	    width: "28px",
	    textAlign: "center"
	  },
	  icon: {
	    position: "absolute",
	    left: "2px",
	    top: "-3px",
	    fontSize: "13px",
	    fontWeight: "normal"
	  }
	};
	
	var ReassignClientDialog = function (_Component) {
	  _inherits(ReassignClientDialog, _Component);
	
	  function ReassignClientDialog(props) {
	    _classCallCheck(this, ReassignClientDialog);
	
	    var _this = _possibleConstructorReturn(this, (ReassignClientDialog.__proto__ || Object.getPrototypeOf(ReassignClientDialog)).call(this, props));
	
	    _this.state = {
	      assignClientValue: "",
	      assignClientLabel: "",
	      ifAssignDisabled: true,
	      copy_client_assignments: [], // this array for assign button changing
	      controlAllSelected: false,
	      selectedRow: "none",
	      originalAccountManagerName: "",
	      ifDisabledSaveButton: true
	    };
	    _this.arr_for_index = []; // record the index of selected
	    _this.flag = true; // control all selection
	    return _this;
	  }
	
	  _createClass(ReassignClientDialog, [{
	    key: "closeDialog",
	    value: function closeDialog() {
	      // reset the table data
	      this.arr_for_index = []; // reset
	      if (this.props.ifReassignSuccess) {
	        this.props.getClientAssignmentsAgain();
	      }
	      var arr1 = this.state.copy_client_assignments;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.state.copy_client_assignments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          v.accountManagerName = this.state.originalAccountManagerName;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var len = this.state.copy_client_assignments.length;
	      var a = "list";
	      for (var i = 0; i < len; i++) {
	        this.setState(_defineProperty({}, a + i, ""));
	      }
	      this.setState({
	        controlAllSelected: false,
	        selectedRow: "none",
	        copy_client_assignments: arr1,
	        ifDisabledSaveButton: true,
	        ifAssignDisabled: true
	      });
	      this.props.closeDialog();
	      this.props.rollBackReassign();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        originalAccountManagerName: nextProps.client_assignments.length > 0 && nextProps.client_assignments[0].accountManagerName,
	        copy_client_assignments: (0, _orderBy2.default)(nextProps.client_assignments, ["clientName"], ["asc"])
	      });
	    }
	  }, {
	    key: "handleAssignClient",
	    value: function handleAssignClient(val) {
	      this.setState({
	        assignClientValue: val.value,
	        assignClientLabel: val.label
	      });
	    }
	  }, {
	    key: "handleAssign",
	    value: function handleAssign(e) {
	      // assign button
	      e.stopPropagation();
	      e.nativeEvent.stopImmediatePropagation();
	      if (this.state.assignClientLabel !== "" && this.state.selectedRow !== "none") {
	        if (this.state.selectedRow === "all") {
	          // this.setState({
	          //   copy_client_assignments: this.props.client_assignments.forEach((item) => item.accountManagerName = this.state.assignClientLable)
	          // })
	          var obj = [];
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = this.state.copy_client_assignments[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var i = _step2.value;
	
	              i.accountManagerName = this.state.assignClientLabel;
	              obj.push(i);
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          this.setState({
	            copy_client_assignments: obj,
	            ifDisabledSaveButton: false
	          });
	        } else if (this.state.selectedRow.length > 0) {
	          var _obj = [];
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = this.state.copy_client_assignments.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var _ref = _step3.value;
	
	              var _ref2 = _slicedToArray(_ref, 2);
	
	              var key = _ref2[0];
	              var value = _ref2[1];
	              var _iteratorNormalCompletion4 = true;
	              var _didIteratorError4 = false;
	              var _iteratorError4 = undefined;
	
	              try {
	                for (var _iterator4 = this.state.selectedRow[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                  var v = _step4.value;
	
	                  if (v === key) {
	                    value.accountManagerName = this.state.assignClientLabel;
	                  }
	                  _obj.push(value);
	                }
	              } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                    _iterator4.return();
	                  }
	                } finally {
	                  if (_didIteratorError4) {
	                    throw _iteratorError4;
	                  }
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          this.setState({
	            copy_client_assignments: this.translateSetToArray(_obj),
	            ifDisabledSaveButton: false
	          });
	        }
	      }
	    }
	  }, {
	    key: "handleAllCheck",
	    value: function handleAllCheck() {
	      if (this.flag) {
	        if (this.state.copy_client_assignments.length === 0) {
	          this.setState({
	            ifAssignDisabled: true
	          });
	        } else {
	          this.setState({
	            controlAllSelected: true,
	            selectedRow: "all",
	            ifAssignDisabled: false
	          });
	        }
	        this.flag = false;
	      } else {
	        var arr1 = this.state.copy_client_assignments;
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	          for (var _iterator5 = this.state.copy_client_assignments[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var v = _step5.value;
	
	            v.accountManagerName = this.state.originalAccountManagerName;
	          }
	        } catch (err) {
	          _didIteratorError5 = true;
	          _iteratorError5 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	              _iterator5.return();
	            }
	          } finally {
	            if (_didIteratorError5) {
	              throw _iteratorError5;
	            }
	          }
	        }
	
	        var len = this.state.copy_client_assignments.length;
	        var a = "list";
	        for (var i = 0; i < len; i++) {
	          this.setState(_defineProperty({}, a + i, ""));
	        }
	        this.setState({
	          controlAllSelected: false,
	          selectedRow: "none",
	          ifAssignDisabled: true,
	          ifDisabledSaveButton: true,
	          copy_client_assignments: arr1
	        });
	        this.flag = true;
	      }
	    }
	  }, {
	    key: "translateSetToArray",
	    value: function translateSetToArray(arr) {
	      return [].concat(_toConsumableArray(new Set(arr)));
	    }
	  }, {
	    key: "handleListCheckbox",
	    value: function handleListCheckbox(idx) {
	      var _this2 = this;
	
	      if (this.state.selectedRow === "all") {
	        return false;
	      }
	      var a = "list";
	      if (typeof this.state[a + idx] !== "number") {
	        var _setState3;
	
	        this.arr_for_index.push(idx);
	        var arr = this.translateSetToArray(this.arr_for_index.sort());
	        this.setState((_setState3 = {}, _defineProperty(_setState3, a + idx, idx), _defineProperty(_setState3, "selectedRow", arr), _defineProperty(_setState3, "ifAssignDisabled", false), _setState3));
	      } else if (typeof this.state[a + idx] === "number") {
	        var _setState4;
	
	        (0, _remove2.default)(this.arr_for_index, function (n) {
	          return n === idx;
	        });
	        var arr1 = this.state.copy_client_assignments;
	        arr1[idx].accountManagerName = this.state.originalAccountManagerName;
	        this.setState((_setState4 = {}, _defineProperty(_setState4, a + idx, ""), _defineProperty(_setState4, "selectedRow", this.arr_for_index.length === 0 ? "none" : this.arr_for_index), _defineProperty(_setState4, "copy_client_assignments", arr1), _setState4), function () {
	          if (_this2.state.selectedRow === "none") {
	            _this2.setState({
	              ifAssignDisabled: true,
	              ifDisabledSaveButton: true
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: "handleSave",
	    value: function handleSave() {
	      var obj = [];
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = this.state.selectedRow[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var v = _step6.value;
	
	          var $obj = {};
	          $obj.clientId = this.state.copy_client_assignments[v].clientId;
	          $obj.accountManagerUserIds = [this.state.assignClientValue];
	          obj.push($obj);
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	
	      this.props.reassingAccountManager(this.props.originAccountManagerUserId, obj);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "reassign-client" },
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            modal: true,
	            contentStyle: { width: "45%" },
	            open: this.props.open,
	            bodyStyle: { overflow: "visible" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "wrapper" },
	            _react2.default.createElement(_clear2.default, {
	              style: {
	                position: "absolute",
	                right: "1em",
	                cursor: "pointer",
	                top: "1em"
	              },
	              onClick: function onClick() {
	                return _this3.closeDialog();
	              }
	            }),
	            !this.props.ifReassignSuccess ? _react2.default.createElement(
	              "div",
	              { className: "reassign-box" },
	              /^system administrator/gi.test(this.props.roleName) && _react2.default.createElement(
	                "h2",
	                {
	                  style: {
	                    fontSize: "16px",
	                    fontWeight: "bolder",
	                    color: "black"
	                  }
	                },
	                "REASSIGN CLIENTS"
	              ),
	              /^(administrator)/gi.test(this.props.roleName) && _react2.default.createElement(
	                "h2",
	                {
	                  style: {
	                    fontSize: "16px",
	                    fontWeight: "bolder",
	                    color: "black"
	                  }
	                },
	                "REASSIGN BUSINESS UNITS"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "table-wrapper",
	                  style: { border: "1px solid black", overflow: "hidden" },
	                  ref: "tableWrapper"
	                },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "table",
	                    { style: styleSheet.table },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        {
	                          style: Object.assign({}, styleSheet.table_tr, {
	                            background: "#e4e4e4",
	                            borderBottom: "1px solid black"
	                          })
	                        },
	                        _react2.default.createElement(
	                          "th",
	                          { style: styleSheet.firstTh },
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              style: styleSheet.checkbox,
	                              onClick: function onClick() {
	                                return _this3.handleAllCheck();
	                              }
	                            },
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                style: Object.assign({}, styleSheet.icon, {
	                                  display: this.state.controlAllSelected ? "inline-block" : "none"
	                                })
	                              },
	                              "X"
	                            )
	                          )
	                        ),
	                        /^system administrator/gi.test(this.props.roleName) && _react2.default.createElement(
	                          "th",
	                          {
	                            style: Object.assign({}, styleSheet.table_th, { width: "46.8%" })
	                          },
	                          "Clients"
	                        ),
	                        /^(administrator)/gi.test(this.props.roleName) && _react2.default.createElement(
	                          "th",
	                          {
	                            style: Object.assign({}, styleSheet.table_th, { width: "46.8%" })
	                          },
	                          "Business Units"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { style: Object.assign({}, styleSheet.table_th, { width: "48%" }) },
	                          "Assigned"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "table-box",
	                    style: { maxHeight: "300px", overflowY: "scroll" }
	                  },
	                  _react2.default.createElement(
	                    "table",
	                    { className: "table-reassign", style: styleSheet.table },
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      this.state.copy_client_assignments.map(function (item, index) {
	                        return _react2.default.createElement(
	                          "tr",
	                          {
	                            key: index,
	                            style: Object.assign({}, styleSheet.table_tr, {
	                              background: _this3.state["list" + index] === index || _this3.state.controlAllSelected ? "lightgrey" : ""
	                            })
	                          },
	                          _react2.default.createElement(
	                            "td",
	                            { style: styleSheet.firstTh },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                style: styleSheet.checkbox,
	                                onClick: function onClick() {
	                                  return _this3.handleListCheckbox(index);
	                                }
	                              },
	                              _react2.default.createElement(
	                                "span",
	                                {
	                                  style: Object.assign({}, styleSheet.icon, {
	                                    display: _this3.state["list" + index] === index || _this3.state.controlAllSelected ? "inline-block" : "none"
	                                  })
	                                },
	                                "X"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            {
	                              style: Object.assign({}, styleSheet.table_th, {
	                                width: "47.9%"
	                              })
	                            },
	                            item.clientName
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            {
	                              style: Object.assign({}, styleSheet.table_th, {
	                                width: "46.7%"
	                              })
	                            },
	                            item.accountManagerName
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "assign-client-to clearfix",
	                  style: {
	                    marginTop: "1em",
	                    paddingBottom: "1em",
	                    borderBottom: "2px solid black"
	                  }
	                },
	                /^system administrator/gi.test(this.props.roleName) && _react2.default.createElement(
	                  "span",
	                  {
	                    style: {
	                      float: "left",
	                      marginTop: "0.6em",
	                      color: "black"
	                    }
	                  },
	                  "Assign Clients to"
	                ),
	                /^(administrator)/gi.test(this.props.roleName) && _react2.default.createElement(
	                  "span",
	                  {
	                    style: {
	                      float: "left",
	                      marginTop: "0.6em",
	                      color: "black"
	                    }
	                  },
	                  "Assign Business Units to"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "box",
	                    style: { float: "left", width: "13.6em" },
	                    id: "box"
	                  },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    className: "reassign-client-select",
	                    value: this.state.assignClientValue,
	                    clearable: false,
	                    options: this.props.account_manager,
	                    style: { float: "left" },
	                    onChange: function onChange(val) {
	                      return _this3.handleAssignClient(val);
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: this.state.ifAssignDisabled,
	                    onClick: function onClick(e) {
	                      return _this3.handleAssign(e);
	                    },
	                    style: {
	                      float: "left",
	                      marginLeft: "0.5em",
	                      fontSize: "12px",
	                      color: "white",
	                      height: "30px",
	                      marginTop: "5px",
	                      background: (0, _utility.buttonBlueColor)(),
	                      border: "none"
	                    }
	                  },
	                  "ASSIGN"
	                )
	              )
	            ) : _react2.default.createElement(
	              "p",
	              { style: { color: "black", textAlign: "center" } },
	              /^system administrator/gi.test(this.props.roleName) ? "Reassign clients success" : "Reassign business units success"
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "btns",
	                style: {
	                  display: "flex",
	                  flexDirection: "row",
	                  justifyContent: "space-between",
	                  marginTop: "2em"
	                }
	              },
	              _react2.default.createElement("p", { style: { fontSize: "12px", color: "red" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: function onClick() {
	                      return _this3.closeDialog();
	                    },
	                    style: {
	                      background: "white",
	                      color: "black",
	                      border: "1px solid black",
	                      fontSize: "14px",
	                      padding: "0.3em 0.5em",
	                      marginRight: "0.4em"
	                    }
	                  },
	                  this.props.ifReassignSuccess ? "CLOSE" : "CANCEL"
	                ),
	                !this.props.ifReassignSuccess && _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: this.state.ifDisabledSaveButton,
	                    onClick: function onClick() {
	                      return _this3.handleSave();
	                    },
	                    style: {
	                      background: (0, _utility.buttonBlueColor)(),
	                      color: "white",
	                      border: "none",
	                      fontSize: "14px",
	                      padding: "0.3em 0.5em"
	                    }
	                  },
	                  "SAVE"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReassignClientDialog;
	}(_react.Component);
	
	exports.default = ReassignClientDialog;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuspendUser = function (_Component) {
	  _inherits(SuspendUser, _Component);
	
	  function SuspendUser(props) {
	    _classCallCheck(this, SuspendUser);
	
	    var _this = _possibleConstructorReturn(this, (SuspendUser.__proto__ || Object.getPrototypeOf(SuspendUser)).call(this, props));
	
	    _this.state = {
	      ifDisabledBtn: false
	    };
	    return _this;
	  }
	
	  _createClass(SuspendUser, [{
	    key: 'handleClose',
	    value: function handleClose() {
	      this.props.closeSuspendUser();
	      this.props.clearSuspendError();
	      this.setState({
	        ifDisabledBtn: false
	      });
	    }
	  }, {
	    key: 'handleSuspendUser',
	    value: function handleSuspendUser() {
	      // the second param canbe suspend or reactivate, this action will call window.location.reload() to reload page in the employees actions's file.
	      // notice: the default value of isClientUser was judged via pathname, which is `/employees/user-status/`.
	      if (!this.props.suspended) {
	        this.props.suspendUser(this.props.suspendUserId, 'suspend', !this.props.isClientUser);
	      } else {
	        this.props.suspendUser(this.props.suspendUserId, 'reactivate', !this.props.isClientUser);
	      }
	      this.setState({
	        ifDisabledBtn: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'suspend-user' },
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            modal: true,
	            contentStyle: { width: '45%' },
	            open: this.props.open
	          },
	          _react2.default.createElement(
	            'p',
	            { style: { textAlign: 'center', color: 'black', fontWeight: 'bolder' } },
	            'Are you sure you would like to  ',
	            this.props.suspended ? 'reactivate' : 'suspend',
	            ' this user?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'btns', style: { textAlign: 'center' } },
	            _react2.default.createElement(
	              'button',
	              { onClick: function onClick() {
	                  return _this2.handleClose();
	                }, style: { marginRight: '1em', padding: '4px 9px', font: 'black', border: '1px solid black', borderRadius: '0', color: 'black', fontSize: '14px' } },
	              'CANCEL'
	            ),
	            _react2.default.createElement(
	              'button',
	              { disabled: this.state.ifDisabledBtn, onClick: function onClick() {
	                  return _this2.handleSuspendUser();
	                }, style: { border: this.state.ifDisabledBtn ? 'none' : '1px solid #e22121', padding: '0.3em 0.4em', color: 'white', background: '#e22121', borderRadius: '0', fontSize: '14px' } },
	              this.props.suspended ? this.props.businessUnitTeamMemberPage ? 'REACTIVATE BUSINESS UNIT TEAM MEMBER' : /^(administrator|team member)/gi.test(this.props.roleName) && /^\/clients\/edit\/Client-Team-Members/.test(this.props.location.pathname) ? 'REACTIVATE BUSINESS UNIT TEAM MEMBER' : 'REACTIVATE USER' : this.props.businessUnitTeamMemberPage ? 'SUSPEND BUSINESS UNIT TEAM MEMBER' : /^(administrator|team member)/gi.test(this.props.roleName) && /^\/clients\/edit\/Client-Team-Members/.test(this.props.location.pathname) ? 'SUSPEND BUSINESS UNIT TEAM MEMBER' : 'SUSPEND USER'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: { color: 'red', textAlign: 'center', marginTop: '0.4em', fontSize: '12px' } },
	            this.props.suspend_error
	          )
	        )
	      );
	    }
	  }]);
	
	  return SuspendUser;
	}(_react.Component);
	
	exports.default = SuspendUser;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(18);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _env = __webpack_require__(85);
	
	__webpack_require__(1423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import css style
	
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	
	    _this.handleClose = function () {
	      _this.setState({
	        open: false,
	        defaultValue: ""
	      });
	    };
	
	    _this.state = {
	      ifShowError: false,
	      inputValue: "",
	      open: false, // open material ui dialog
	      defaultValue: ""
	    };
	    return _this;
	  }
	
	  _createClass(Footer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!this.props.apiBuildNumber) {
	        this.props.getAPIBuildNumber();
	      }
	    }
	  }, {
	    key: "handleEmailInput",
	    value: function handleEmailInput(e) {
	      this.setState({
	        inputValue: e.target.value,
	        ifShowError: false,
	        defaultValue: e.target.value
	      });
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick() {
	      if (!/^(([^<>()\\]\\.,;:\s@"]+(\.[^<>()\\\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.inputValue)) {
	        this.setState({
	          ifShowError: true
	        });
	      } else {
	        this.setState({
	          open: true
	        });
	        // window.setTimeout(() => {
	        //   this.setState({
	        //     open: false,
	        //     defaultValue: ''
	        //   })
	        // }, 5000)
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          apiBuildNumber = _props.apiBuildNumber,
	          client_info = _props.client_info,
	          roleId = _props.roleId,
	          selected_client = _props.selected_client;
	
	
	      var disableSegmentListLink = roleId > 3 ? (0, _lodash.isEmpty)(client_info) || client_info.subscription.id > 3 || roleId === 5 : !(selected_client > 0);
	      var disableSegmentCreateLink = (0, _lodash.isEmpty)(client_info) || disableSegmentListLink;
	      var curYear = (0, _moment2.default)().format("YYYY");
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        label: "Close",
	        primary: true,
	        onTouchTap: this.handleClose,
	        style: { background: "black" },
	        labelStyle: { color: "white" },
	        hoverColor: "black",
	        backgroundColor: "black"
	      })];
	
	      if (this.props.hideFooter === true) return null;
	      if (this.props.loginUserDetail && !this.props.loginUserDetail.baroUid || this.props.optimizeUserDetail && this.props.optimizeUserDetail.aaUser && parseInt(this.props.optimizeUserDetail.aaUser.subscriptionTierId, 10) !== 5) {
	        return _react2.default.createElement(
	          _MuiThemeProvider2.default,
	          null,
	          _react2.default.createElement(
	            "footer",
	            { className: "acquire-footer" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "wrapper row",
	                style: { margin: 0, padding: "10px 0px" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-3 col-md-3 col-sm-3 col-lg-3 email" },
	                _react2.default.createElement("img", {
	                  alt: "",
	                  src: "/images/claritas-logo.png",
	                  style: { display: "inline-table", height: "28px" }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "email mt-20" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row-1" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "E-mail: "
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      { href: "mailto:AudienceAnywhere@claritas.com" },
	                      "AudienceAnywhere@claritas.com"
	                    )
	                  ),
	                  _react2.default.createElement("div", { className: "row-2" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row-5" },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://www.facebook.com/acquireweb/",
	                        target: "_blank"
	                      },
	                      _react2.default.createElement("i", { className: "share facebook" })
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      { href: "https://twitter.com/AcquireWeb", target: "_blank" },
	                      _react2.default.createElement("i", { className: "share twitter" })
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://www.linkedin.com/company/139383/",
	                        target: "_blank"
	                      },
	                      _react2.default.createElement("i", { className: "share linkedin" })
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://plus.google.com/108494344907614937182",
	                        target: "_blank"
	                      },
	                      _react2.default.createElement("i", { className: "share google-plus" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row-6" },
	                    "Copyright \xA9",
	                    curYear,
	                    " Claritas, LLC.",
	                    _react2.default.createElement("br", null),
	                    " All rights reserved."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-3 col-md-3 col-sm-3 col-lg-3 services clearfix" },
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Audience"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "email" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row-1" },
	                    disableSegmentListLink ? _react2.default.createElement(
	                      "span",
	                      { style: { color: "#6c6c6c" } },
	                      "My Audience Segments"
	                    ) : _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { to: "/segments/list/active" },
	                      "My Audience Segments",
	                      " "
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row-2" },
	                    disableSegmentCreateLink ? _react2.default.createElement(
	                      "span",
	                      { style: { color: "#6c6c6c" } },
	                      "Create an ",
	                      _react2.default.createElement("br", null),
	                      "Audience Segment"
	                    ) : _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { to: "/segment/create" },
	                      "Create an ",
	                      _react2.default.createElement("br", null),
	                      "Audience Segment",
	                      " "
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "h2",
	                    { style: { marginTop: "20px", marginBottom: "10px" } },
	                    "Insights"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { fontSize: "16px", letterSpacing: "1px" } },
	                    roleId === 5 ? _react2.default.createElement(
	                      "span",
	                      { style: { color: "#6c6c6c" } },
	                      "Insights and Analytics"
	                    ) : _react2.default.createElement(
	                      "a",
	                      { href: "/insights/summary?cid=" + selected_client },
	                      "Insights and Analytics"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-2 col-md-2 col-sm-2 col-lg-2 quick-links clearfix" },
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Quick Links"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: " email" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row-1" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "mailto:AudienceAnywhere@claritas.com" },
	                      "Support"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row-2 mb-10" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "http://acquireweb.com/about-us", target: "_blank" },
	                      "About Us"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row-6" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "http://acquireweb.com/careers", target: "_blank" },
	                      "Careers"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-2 col-md-2 col-sm-2 col-lg-2 policies clearfix" },
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Policies"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "email" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row-1" },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://www.claritas.com/sites/default/files/files/Claritas%20Comprehensive%20Privacy%20Policy%20-%20Jan%202019.pdf",
	                        target: "_blank"
	                      },
	                      "Privacy Policy"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-3 col-md-3 col-sm-3 col-lg-3 emial reg clearfix" },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    { style: { letterSpacing: "0.4px" } },
	                    "Sign up to our newsletter/updates"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row-4 clearfix mt-20" },
	                  _react2.default.createElement(
	                    "div",
	                    { id: "mc_embed_signup" },
	                    _react2.default.createElement(
	                      "form",
	                      {
	                        action: "https://acquireweb.us14.list-manage.com/subscribe/post?u=d336fb8ecf2556001ac378ba5&id=4957a5c6bc",
	                        method: "post",
	                        id: "mc-embedded-subscribe-form",
	                        name: "mc-embedded-subscribe-form",
	                        className: "validate",
	                        target: "_blank",
	                        noValidate: true
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { id: "mc_embed_signup_scroll" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          value: this.state.defaultValue,
	                          onChange: function onChange(e) {
	                            return _this2.handleEmailInput(e);
	                          },
	                          name: "EMAIL",
	                          className: "email",
	                          id: "mce-EMAIL",
	                          placeholder: "email address",
	                          required: true
	                        }),
	                        _react2.default.createElement(
	                          "div",
	                          { style: { position: "absolute", left: "-5000px" } },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            name: "b_d336fb8ecf2556001ac378ba5_4957a5c6bc",
	                            tabIndex: "-1",
	                            value: ""
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "clear mt-20" },
	                          _react2.default.createElement("input", {
	                            type: "submit",
	                            value: "Sign Up",
	                            name: "subscribe",
	                            id: "mc-embedded-subscribe",
	                            className: "button btn-signup-email"
	                          })
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "copy-right" },
	                  _env.uiBuildNumber && apiBuildNumber && _react2.default.createElement(
	                    "span",
	                    {
	                      className: "pull-right text-right",
	                      style: { fontSize: "0.6em" }
	                    },
	                    _react2.default.createElement(
	                      "small",
	                      null,
	                      "UI Build #",
	                      _env.uiBuildNumber
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "small",
	                      null,
	                      "API Build #",
	                      apiBuildNumber
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Dialog2.default,
	              {
	                actions: actions,
	                modal: false,
	                open: this.state.open,
	                onRequestClose: this.handleClose,
	                actionsContainerStyle: {
	                  marginTop: "-2em",
	                  paddingBottom: "4em",
	                  paddingRight: "32.2em"
	                }
	              },
	              _react2.default.createElement(
	                "p",
	                {
	                  style: {
	                    width: "16.1em",
	                    textAlign: "center",
	                    margin: "4em auto 4em"
	                  }
	                },
	                "Thanks for signing up to receive our e-newsletters!"
	              )
	            ),
	            _react2.default.createElement(
	              _Dialog2.default,
	              {
	                actions: actions,
	                modal: false,
	                open: this.state.open,
	                onRequestClose: this.handleClose,
	                actionsContainerStyle: {
	                  marginTop: "-2em",
	                  paddingBottom: "4em",
	                  paddingRight: "32.2em"
	                }
	              },
	              _react2.default.createElement(
	                "p",
	                {
	                  style: {
	                    width: "16.1em",
	                    textAlign: "center",
	                    margin: "4em auto 4em"
	                  }
	                },
	                "Thanks for signing up to receive our e-newsletters!"
	              )
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _isNull = __webpack_require__(1639);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsightBreadcrumb = function (_AcquireWebComponent) {
	  _inherits(InsightBreadcrumb, _AcquireWebComponent);
	
	  function InsightBreadcrumb() {
	    _classCallCheck(this, InsightBreadcrumb);
	
	    return _possibleConstructorReturn(this, (InsightBreadcrumb.__proto__ || Object.getPrototypeOf(InsightBreadcrumb)).apply(this, arguments));
	  }
	
	  _createClass(InsightBreadcrumb, [{
	    key: "render",
	    value: function render() {
	      var url = new URL(window.location.href);
	      var page = url.searchParams.get("pop_url");
	
	      var _props = this.props,
	          src = _props.src,
	          kindOfReport = _props.kindOfReport,
	          clientId = _props.clientId,
	          popUrl = _props.popUrl;
	
	      var popUrlElement = null;
	      if (popUrl) {
	        popUrlElement = popUrl;
	      }
	      var reportLinkContainer = undefined;
	      var reportKindContainer = undefined;
	      switch (kindOfReport) {
	        case "map":
	          reportKindContainer = _react2.default.createElement(
	            "span",
	            { key: "span-report-kind" },
	            " Geographic Traffic "
	          );
	          break;
	        case "top":
	          reportKindContainer = _react2.default.createElement(
	            "span",
	            { key: "span-report-kind" },
	            " ",
	            src === "consumer" ? "Top Attributes" : "Frequency Visits",
	            " "
	          );
	          break;
	        case "popular":
	          reportKindContainer = _react2.default.createElement(
	            "span",
	            { key: "span-report-kind" },
	            " Most Popular Pages"
	          );
	          break;
	        case "frequents":
	          reportKindContainer = _react2.default.createElement(
	            "span",
	            { key: "span-report-kind" },
	            " Frequent Visits"
	          );
	          break;
	        default:
	          reportKindContainer = page ? [] : undefined;
	          break;
	      }
	
	      switch (src) {
	        case "consumer":
	          if (this.props.nav === "pop") {
	            if (popUrl) {
	              reportLinkContainer = _react2.default.createElement(
	                "span",
	                { key: "span-report-type" },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: "/insights/consumer?cid=" + clientId + "&nav=pop" },
	                  " ",
	                  "Most Popular Pages",
	                  " "
	                )
	              );
	            } else {
	              reportLinkContainer = _react2.default.createElement(
	                "span",
	                { key: "span-report-type" },
	                " Consumer Information "
	              );
	            }
	          } else {
	            reportLinkContainer = (0, _isUndefined2.default)(kindOfReport) && (0, _isNull2.default)(page) ? _react2.default.createElement(
	              "span",
	              { key: "span-report-type" },
	              " Consumer Information "
	            ) : _react2.default.createElement(
	              "span",
	              { key: "span-report-type" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "/insights/consumer?cid=" + clientId },
	                "Consumer Information"
	              )
	            );
	          }
	          /*
	          if (page) {
	            reportKindContainer.push(
	              <span>
	                <Link to={"/insights/consumer?nav=pop&cid=" + clientId}>
	                  Most Popular Pages
	                </Link>
	              </span>,
	            );
	            reportKindContainer.push(
	              <span
	                key="span-insights-breadcrumb-divider3"
	                className="ml-10 mr-10"
	              >
	                >
	              </span>,
	            );
	            reportKindContainer.push(<span> {page} </span>);
	          }*/
	          return _react2.default.createElement(
	            "div",
	            { className: "page-breadcrumb" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/insights/summary?cid=" + clientId },
	              "Insights Dashboard"
	            ),
	            _react2.default.createElement(
	              "span",
	              {
	                key: "span-insights-breadcrumb-divider1",
	                className: "ml-10 mr-10"
	              },
	              ">"
	            ),
	            reportLinkContainer,
	            reportKindContainer ? [_react2.default.createElement(
	              "span",
	              {
	                key: "span-insights-breadcrumb-divider2",
	                className: "ml-10 mr-10"
	              },
	              ">"
	            ), reportKindContainer] : [],
	            popUrlElement
	          );
	        default:
	          reportLinkContainer = (0, _isUndefined2.default)(kindOfReport) && (0, _isNull2.default)(page) ? _react2.default.createElement(
	            "span",
	            { key: "span-report-type" },
	            " Business Information "
	          ) : _react2.default.createElement(
	            "span",
	            { key: "span-report-type" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/insights/business?cid=" + clientId },
	              "Business Information"
	            )
	          );
	
	          return _react2.default.createElement(
	            "div",
	            { className: "page-breadcrumb" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/insights/summary" },
	              "Insights Dashboard"
	            ),
	            _react2.default.createElement(
	              "span",
	              {
	                key: "span-insights-breadcrumb-divider1",
	                className: "ml-10 mr-10"
	              },
	              ">"
	            ),
	            reportLinkContainer,
	            reportKindContainer ? [_react2.default.createElement(
	              "span",
	              {
	                key: "span-insights-breadcrumb-divider2",
	                className: "ml-10 mr-10"
	              },
	              ">"
	            ), reportKindContainer] : [],
	            popUrlElement
	          );
	      }
	    }
	  }]);
	
	  return InsightBreadcrumb;
	}(_MaterialUI2.default);
	
	exports.default = InsightBreadcrumb;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _lodash = __webpack_require__(18);
	
	var _recharts = __webpack_require__(101);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderActiveShape = function renderActiveShape(props) {
		var cx = props.cx,
		    cy = props.cy,
		    innerRadius = props.innerRadius,
		    outerRadius = props.outerRadius,
		    startAngle = props.startAngle,
		    endAngle = props.endAngle,
		    fill = props.fill;
	
		return _react2.default.createElement(
			'g',
			null,
			_react2.default.createElement(_recharts.Sector, {
				cx: cx,
				cy: cy,
				innerRadius: innerRadius,
				outerRadius: outerRadius,
				startAngle: startAngle,
				endAngle: endAngle,
				fill: fill
			}),
			_react2.default.createElement(_recharts.Sector, {
				cx: cx,
				cy: cy,
				startAngle: startAngle,
				endAngle: endAngle,
				innerRadius: outerRadius + 2,
				outerRadius: outerRadius + 10,
				fill: '#CCC'
			})
		);
	};
	
	var CustomizedTooltip = _react2.default.createClass({
		displayName: 'CustomizedTooltip',
		render: function render() {
			var _props = this.props,
			    stroke = _props.stroke,
			    name = _props.name,
			    value = _props.value,
			    fieldName = _props.fieldName;
	
			return _react2.default.createElement(
				'div',
				{ className: 'recharts-default-tootip no-margin pt-5 pl-10 pr-10 pb-5', style: { background: '#FFFCDC', border: "solid 1px #ccc" } },
				_react2.default.createElement('p', { className: 'recharts-tooltip-label no-margin' }),
				_react2.default.createElement(
					'ul',
					{ className: 'recharts-tooltip-item-list no-padding no-margin' },
					_react2.default.createElement(
						'li',
						{ className: 'recharts-tooltip-item',
							style: { display: "block", paddingTop: "4px", paddingBottom: "4px", stroke: stroke } },
						name && _react2.default.createElement(
							'span',
							{ className: 'recharts-tooltip-item-name text-capital' },
							_react2.default.createElement(
								'strong',
								null,
								name
							)
						),
						name && _react2.default.createElement('hr', { style: { borderTop: "1px solid #000", height: '1px', display: 'block', margin: "5px 0" } }),
						_react2.default.createElement(
							'span',
							{ className: 'recharts-tooltip-item-value ', style: { fontWeight: 300 } },
							fieldName,
							' ',
							_react2.default.createElement(
								'strong',
								null,
								'- ',
								(0, _utility.splitNumber)(value)()
							)
						)
					)
				)
			);
		}
	});
	
	var styles = {
		textOverflow: {
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}
	};
	
	var ListGraphicSection = function (_AcquireWebComponent) {
		_inherits(ListGraphicSection, _AcquireWebComponent);
	
		function ListGraphicSection(props) {
			_classCallCheck(this, ListGraphicSection);
	
			var _this = _possibleConstructorReturn(this, (ListGraphicSection.__proto__ || Object.getPrototypeOf(ListGraphicSection)).call(this, props));
	
			_this.state = { activeIndex: undefined };
			return _this;
		}
	
		_createClass(ListGraphicSection, [{
			key: 'onPieEnter',
			value: function onPieEnter(data, index) {
				this.setState({
					activeIndex: index,
					tooltip_name: data.payload.uniqueVisits ? data.payload.name : undefined,
					tooltip_field_name: data.payload.uniqueVisits ? 'Unique Visit' : data.payload.name,
					tooltip_value: data.payload.uniqueVisits ? data.payload.uniqueVisits : data.payload.value,
					tooltip_stroke: data.payload.fill
				});
				var tooltips = _reactDom2.default.findDOMNode(this).getElementsByClassName('recharts-tooltip-wrapper');
				if (tooltips && tooltips.length > 0) {
					var el = tooltips[0];
					el.style['visibility'] = "visible";
					el.style['padding-bottom'] = '0px';
				}
			}
		}, {
			key: 'onPieLeave',
			value: function onPieLeave() {
				this.setState({
					activeIndex: -1
				});
				var tooltips = _reactDom2.default.findDOMNode(this).getElementsByClassName('recharts-tooltip-wrapper');
				if (tooltips && tooltips.length > 0) {
					var el = tooltips[0];
					el.style['visibility'] = "hidden";
				}
			}
		}, {
			key: 'render',
			value: function render() {
				//		const COLORS = ['#050505', '#0E222C', '#1C4456', '#2A6581', '#3888AB', '#609FBD', '#609FBD', '#87B7CD', '#AFCFDD', '#D6E7EF'];
				//const COLORS = ['#050505', '#1C4456',  '#3888AB',  '#87B7CD',  '#AFCFDD'];
				var COLORS = ['#216E69', '#32A59D', '#56CBC4', '#99DFDD', '#BBEAE7'];
				var _props2 = this.props,
				    title = _props2.title,
				    data = _props2.data,
				    footer = _props2.footer,
				    subTitle = _props2.subTitle,
				    showGraphic = _props2.showGraphic,
				    fieldDisplayFunc = _props2.fieldDisplayFunc;
	
				var sortedData = (0, _lodash.orderBy)(data, ['value'], ['desc']);
				var hideOverflowText = this.props.hideOverflow === true;
	
				var coloredData = {};
				if (showGraphic === true) {
					(0, _lodash.map)(sortedData, function (data, index) {
						coloredData[data.name] = COLORS[index % COLORS.length];
					});
				}
				if ((0, _lodash.isEmpty)(data)) {
					return _react2.default.createElement(
						'div',
						{ style: { float: "left", width: "100%", position: "relative" } },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '16px', lineHeight: '18px', fontWeight: 'bold' } },
							title
						),
						_react2.default.createElement(
							'div',
							{ style: { width: '100%', minHeight: '200px', textAlign: 'center', paddingTop: '60px', color: "#CDCDCD" } },
							_react2.default.createElement(
								'div',
								{ style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
								'No Data'
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ style: { float: "left", width: "100%", position: "relative" } },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '24px', lineHeight: '28px', fontWeight: 'bold', textTransform: 'capitalize' }, className: 'mb-10' },
							title
						),
						_react2.default.createElement(
							'div',
							{ className: 'light-grey-bottom-border', style: { width: showGraphic === true ? '50%' : '100%', position: "relative", float: "left", paddingBottom: '10px', marginBottom: '30px' } },
							subTitle && _react2.default.createElement(
								'div',
								{ className: 'text-right mt-10 mb-10', style: { color: subTitle === "&nbsp;" ? "#FFF" : "inherit", fontSize: "9pt" } },
								_react2.default.createElement(
									'strong',
									null,
									subTitle
								)
							),
							(0, _lodash.map)(data, function (obj, idx) {
								return _react2.default.createElement(
									'div',
									{ key: "list-" + idx, className: 'light-grey-top-border mt-10 pt-15', style: { height: "40px", fontSize: '16px' } },
									_react2.default.createElement(
										'div',
										{ className: 'pull-left', style: hideOverflowText ? Object.assign({ width: '88%' }, styles.textOverflow) : {} },
										!(0, _lodash.isEmpty)(coloredData) && _react2.default.createElement(
											'span',
											{ className: 'insights-span-legend', style: { background: coloredData[obj.name] } },
											'\xA0'
										),
										_react2.default.createElement(
											'span',
											null,
											obj.link ? _react2.default.createElement(
												'a',
												{ href: obj.link },
												obj.name
											) : obj.name
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'pull-right' },
										fieldDisplayFunc ? fieldDisplayFunc(obj.value) : obj.value
									)
								);
							})
						),
						_react2.default.createElement(
							'div',
							{ style: { width: '50%', marginTop: '-10px', minHeight: '250px', display: showGraphic === true ? "block" : "none", position: "relative", float: "left" } },
							_react2.default.createElement(
								_recharts.ResponsiveContainer,
								{ width: '100%', height: '80%', minHeight: 250 },
								_react2.default.createElement(
									_recharts.PieChart,
									null,
									_react2.default.createElement(
										_recharts.Pie,
										{ onMouseLeave: this.onPieLeave.bind(this), onMouseEnter: this.onPieEnter.bind(this), activeShape: renderActiveShape, data: sortedData, fill: '#8884d8', activeIndex: this.state.activeIndex,
											dataKey: 'value', isAnimationActive: false },
										sortedData.map(function (entry, index) {
											return _react2.default.createElement(_recharts.Cell, { key: "insight-graphic-cell-" + index, fill: COLORS[index % COLORS.length] });
										})
									),
									_react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(CustomizedTooltip, null), name: this.state.tooltip_name,
										value: this.state.tooltip_value, stroke: this.state.stroke,
										fieldName: this.state.tooltip_field_name })
								)
							)
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						sortedData.length === 5 && title === "DEMOGRAPHIC" && _react2.default.createElement(
							'div',
							{ className: 'mb-15' },
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null)
						),
						_react2.default.createElement(
							'div',
							{ className: 'mt-10 list-chart-footer' },
							footer ? footer : _react2.default.createElement('br', null)
						)
					);
				}
			}
		}]);
	
		return ListGraphicSection;
	}(_MaterialUI2.default);
	
	ListGraphicSection.propTypes = {
		title: _react2.default.PropTypes.string.isRequired,
		subTitle: _react2.default.PropTypes.string,
		data: _react2.default.PropTypes.array,
		showGraphic: _react2.default.PropTypes.bool,
		fieldDisplayFunc: _react2.default.PropTypes.func,
		footer: _react2.default.PropTypes.element
	};
	exports.default = ListGraphicSection;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _utility = __webpack_require__(14);
	
	var _lodash = __webpack_require__(18);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PopularPageListSection = function (_AcquireWebComponent) {
		_inherits(PopularPageListSection, _AcquireWebComponent);
	
		function PopularPageListSection() {
			_classCallCheck(this, PopularPageListSection);
	
			return _possibleConstructorReturn(this, (PopularPageListSection.__proto__ || Object.getPrototypeOf(PopularPageListSection)).apply(this, arguments));
		}
	
		_createClass(PopularPageListSection, [{
			key: 'redirect',
			value: function redirect(e, page) {
				e.preventDefault();
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    title = _props.title,
				    subTitle = _props.subTitle,
				    data = _props.data,
				    reportType = _props.reportType,
				    tier = _props.tier;
	
	
				if ((0, _lodash.isEmpty)(data)) {
					return _react2.default.createElement(
						'div',
						{ className: 'pb-10 bg-white', key: "key-" + title.replace(" ", "-") },
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-padding-bottom no-margin-bottom' },
							_react2.default.createElement(
								'div',
								{ style: { fontWeight: 'bold', fontSize: '16px', letterSpacing: '-0.015em' } },
								title
							)
						),
						_react2.default.createElement(
							_Grid.FullRow,
							null,
							_react2.default.createElement(
								'div',
								{ style: { width: '100%', minHeight: '200px', textAlign: 'center', paddingTop: '60px', color: "#CDCDCD" } },
								_react2.default.createElement(
									'div',
									{ style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
									'No Data'
								)
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'pb-10 bg-white', key: "key-" + title.replace(" ", "-") },
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-padding-bottom no-margin-bottom' },
							_react2.default.createElement(
								'div',
								{ style: { fontWeight: 'bold', fontSize: '16px', letterSpacing: '-0.015em' } },
								title
							)
						),
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'black-bottom-border no-padding no-margin-bottom ml-20 mr-20 pb-5' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '10', sm: '10', md: '10', lg: '10' },
								'\xA0'
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '2', sm: '2', md: '2', lg: '2', className: 'text-right no-padding-right' },
								subTitle
							)
						),
						(0, _lodash.map)(data, function (obj, index) {
							return _react2.default.createElement(
								_Grid.Row,
								{ key: "top-visits-item-" + obj.name + "-" + obj.value, style: { fontWeight: 300 },
									className: 'black-bottom-border no-padding no-margin-bottom ml-20 mr-20 pb-5 pt-5' },
								_react2.default.createElement(
									_Grid.Col,
									{ xs: '10', sm: '10', md: '10', lg: '10', className: 'no-padding-left' },
									parseInt(tier, 10) < 3 ? obj.name : _react2.default.createElement(
										_reactRouterDom.Link,
										{ to: '/insights/' + reportType + '?p=' + obj.name },
										obj.name
									)
								),
								_react2.default.createElement(
									_Grid.Col,
									{ xs: '2', sm: '2', md: '2', lg: '2', style: { textAlign: "right", paddingRight: '0' } },
									(0, _utility.splitNumber)(obj.value)()
								)
							);
						})
					);
				}
			}
		}]);
	
		return PopularPageListSection;
	}(_MaterialUI2.default);
	
	PopularPageListSection.default = {
		tier: 3
	};
	exports.default = PopularPageListSection;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _materialUi = __webpack_require__(38);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ServiceContact = function (_AcquireWebComponent) {
	  _inherits(ServiceContact, _AcquireWebComponent);
	
	  function ServiceContact(props) {
	    _classCallCheck(this, ServiceContact);
	
	    var _this = _possibleConstructorReturn(this, (ServiceContact.__proto__ || Object.getPrototypeOf(ServiceContact)).call(this, props));
	
	    _this.state = {
	      openContactForm: false,
	      subject: "",
	      comments: "",
	      showSuccessSendForm: false
	    };
	    return _this;
	  }
	
	  _createClass(ServiceContact, [{
	    key: "onContactFormSubmit",
	    value: function onContactFormSubmit(e) {
	      e.preventDefault();
	      var postData = {
	        clientId: this.props.selected_client,
	        subject: this.state.subject.trim(),
	        comment: this.state.comments.trim(),
	        originationPage: this.props.pageSource
	      };
	
	      this.props.sendAssistRequest(postData);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.request_assist_successful === true && (0, _isUndefined2.default)(this.props.request_assist_successful) && this.state.openContactForm) {
	        this.setState({
	          subject: undefined,
	          comments: undefined,
	          showSuccessSendForm: true,
	          openContactForm: false
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var actionButtons = [this.props.send_assist_request_error && _react2.default.createElement(
	        "div",
	        {
	          className: "pull-left ml-20 mt-5",
	          style: { fontWeight: "bold", color: "#FF0000" }
	        },
	        this.props.send_assist_request_error
	      ), _react2.default.createElement(
	        "button",
	        {
	          onClick: function onClick() {
	            _this2.setState({ openContactForm: false });
	          },
	          className: "btn btn-default btn-aa-info mr-10"
	        },
	        "Cancel"
	      ), (0, _isEmpty2.default)(this.state.comments) || (0, _isEmpty2.default)(this.state.subject) ? _react2.default.createElement(
	        "button",
	        { disabled: true, className: "btn btn-default btn-aa-info mr-10" },
	        "Submit"
	      ) : _react2.default.createElement(
	        "button",
	        {
	          onClick: function onClick(e) {
	            _this2.onContactFormSubmit(e);
	          },
	          className: "btn btn-aa-default mr-10"
	        },
	        "Submit"
	      )];
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	
	      return _react2.default.createElement(
	        "div",
	        { className: className, style: style, id: "cs_contact_form" },
	        _react2.default.createElement(
	          "a",
	          {
	            onClick: function onClick(e) {
	              e.preventDefault();
	              _this2.setState({ openContactForm: true });
	            }
	          },
	          "Click here"
	        ),
	        " ",
	        this.props.messageText || "to contact your client services representative to discuss ways to engage this audience.",
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            open: this.state.openContactForm,
	            contentStyle: { width: "540px" },
	            titleClassName: "support-form-title",
	            bodyClassName: "support-form-body",
	            actionsContainerClassName: "support-form-action-container",
	            title: "CONTACT US",
	            modal: true,
	            actions: actionButtons
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-left no-padding-right no-padding-bottom pt-10 no-margin-bottom" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3", className: "pt-10" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Subject"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "9", sm: "9", md: "9", lg: "9" },
	              _react2.default.createElement("input", {
	                type: "text",
	                style: { width: "100%" },
	                value: this.state.subject,
	                maxLength: "65",
	                onChange: function onChange(e) {
	                  _this2.setState({ subject: e.target.value });
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-left no-padding-right no-padding-bottom no-margin-bottom" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3", className: "pt-10" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Comments"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "9", sm: "9", md: "9", lg: "9" },
	              _react2.default.createElement("textarea", {
	                className: "comment-box",
	                value: this.state.comments,
	                maxLength: "500",
	                onChange: function onChange(e) {
	                  _this2.setState({ comments: e.target.value });
	                }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            open: this.state.showSuccessSendForm,
	            onRequestClose: function onRequestClose() {
	              _this2.setState({ showSuccessSendForm: false });
	            },
	            contentStyle: { width: "350px", padding: "20px" },
	            modal: true
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: { fontSize: "16px", fontFamily: "Arial", color: "#000" },
	              className: "text-center"
	            },
	            "Your message has been sent."
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: { fontSize: "15px", fontFamily: "Arial", color: "#000" },
	              className: "text-center mt-10"
	            },
	            "Your client services representative will contact you within one business day."
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "text-center mt-20" },
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-aa-default",
	                onClick: function onClick() {
	                  _this2.setState({ showSuccessSendForm: false });
	                }
	              },
	              "CLOSE"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ServiceContact;
	}(_MaterialUI2.default);
	
	exports.default = ServiceContact;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _fileDownload = __webpack_require__(720);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _utility = __webpack_require__(14);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	__webpack_require__(597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AudienceFilesDownload = function (_AcquireWebComponent) {
	  _inherits(AudienceFilesDownload, _AcquireWebComponent);
	
	  function AudienceFilesDownload(props) {
	    _classCallCheck(this, AudienceFilesDownload);
	
	    var _this = _possibleConstructorReturn(this, (AudienceFilesDownload.__proto__ || Object.getPrototypeOf(AudienceFilesDownload)).call(this, props));
	
	    _this.state = { collapsed: false, downloadFileId: undefined };
	    return _this;
	  }
	
	  _createClass(AudienceFilesDownload, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.blobData && (0, _isUndefined2.default)(this.props.blobData)) {
	        var FileSaver = __webpack_require__(1467);
	        if (this.props.datas && this.props.datas.length > 0) {
	          var data = (0, _find2.default)(this.props.datas, function (data) {
	            return data.id === _this2.state.downloadFileId;
	          });
	          if (data) {
	            var fileName = data.fileName;
	
	            var arrs = fileName.split("/");
	            FileSaver.saveAs(nextProps.blobData, arrs[arrs.length - 1].replace(".gz", ".zip"));
	          }
	        }
	      }
	    }
	  }, {
	    key: "downloadFile",
	    value: function downloadFile(e, id) {
	      e.preventDefault();
	      this.setState({ downloadFileId: id });
	      this.props.downloadFile(id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var datas = this.props.datas;
	
	      if (!datas) {
	        return _react2.default.createElement(
	          "div",
	          { className: "light-grey-border bg-white p-20 af-summary-container" },
	          "Loading..."
	        );
	      }
	      if ((0, _isEmpty2.default)(datas)) {
	        return _react2.default.createElement("div", null);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "light-grey-border bg-white p-20 af-summary-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "aa-title" },
	          "DOWNLOAD AUDIENCE FILES"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "pt-10" },
	          "Files will be kept on the system for 30 days after which time they will be removed"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border-top light-grey-border-bottom mt-20 list-sub-title " },
	          _react2.default.createElement(
	            "span",
	            {
	              style: {
	                width: "40%",
	                display: "inline-block",
	                paddingLeft: "10px"
	              }
	            },
	            "File(s)"
	          ),
	          _react2.default.createElement(
	            "span",
	            {
	              style: {
	                width: "30%",
	                display: "inline-block",
	                paddingLeft: "20px"
	              }
	            },
	            "File Creation Date"
	          ),
	          _react2.default.createElement(
	            "span",
	            {
	              style: {
	                display: "inline-block",
	                textAlign: "right",
	                width: "30%",
	                paddingRight: "20px"
	              }
	            },
	            "Download Audience File"
	          )
	        ),
	        (0, _map2.default)(datas, function (data) {
	          var id = data.id,
	              startDatetime = data.startDatetime,
	              consumerRecords = data.consumerRecords,
	              businessRecords = data.businessRecords;
	
	          var dt = _moment2.default.unix(startDatetime / 1000).format("M/D/YY");
	          return _react2.default.createElement(
	            "div",
	            { key: "audience-file-section-" + id },
	            _react2.default.createElement(
	              "div",
	              {
	                key: "audience-file-item-" + id,
	                className: "light-grey-border-bottom list-item ",
	                style: { position: "relative", paddingLeft: "20px" }
	              },
	              _react2.default.createElement(
	                "span",
	                {
	                  className: "download-files-table-col",
	                  onClick: function onClick(e) {
	                    e.preventDefault();
	                    _this3.setState(_defineProperty({}, "collapsed" + id, !_this3.state["collapsed" + id]));
	                  }
	                },
	                _react2.default.createElement("div", {
	                  className: _this3.state["collapsed" + id] ? "arrow-right" : "arrow-down"
	                }),
	                "Consumer and Business Files"
	              ),
	              _react2.default.createElement(
	                "span",
	                {
	                  style: {
	                    width: "30%",
	                    display: "inline-block",
	                    paddingLeft: "20px"
	                  }
	                },
	                dt
	              ),
	              _react2.default.createElement(
	                "span",
	                {
	                  style: {
	                    width: "30%",
	                    display: "inline-block",
	                    textAlign: "right",
	                    height: "13px",
	                    paddingRight: "10px"
	                  }
	                },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    onClick: function onClick(e) {
	                      _this3.downloadFile(e, id);
	                    },
	                    download: "aa.zip"
	                  },
	                  _react2.default.createElement(_fileDownload2.default, {
	                    style: { height: "20px", width: "20px", float: "right" }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: _this3.state["collapsed" + id] ? "panel-collapse collapse" : ""
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  key: "audience-file-item-consumer-" + id,
	                  className: "light-grey-border-bottom list-item ml-20 pl-10 no-padding-left "
	                },
	                "Consumer Records -",
	                " ",
	                (0, _isUndefined2.default)(consumerRecords) ? "0" : (0, _utility.splitNumber)(consumerRecords)(),
	                " ",
	                "Records"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  key: "audience-file-item-business-" + id,
	                  className: "light-grey-border-bottom list-item ml-20 pl-10 "
	                },
	                "Business Records -",
	                " ",
	                (0, _isUndefined2.default)(businessRecords) ? "0" : (0, _utility.splitNumber)(businessRecords)(),
	                " ",
	                "Records"
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return AudienceFilesDownload;
	}(_MaterialUI2.default);
	
	exports.default = AudienceFilesDownload;
	
	
	AudienceFilesDownload.propTypes = {
	  datas: _react.PropTypes.array,
	  downloadFile: _react.PropTypes.func
	};

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _utility = __webpack_require__(14);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AudienceSummary = function (_AcquireWebComponent) {
	  _inherits(AudienceSummary, _AcquireWebComponent);
	
	  function AudienceSummary() {
	    _classCallCheck(this, AudienceSummary);
	
	    return _possibleConstructorReturn(this, (AudienceSummary.__proto__ || Object.getPrototypeOf(AudienceSummary)).apply(this, arguments));
	  }
	
	  _createClass(AudienceSummary, [{
	    key: "render",
	    value: function render() {
	      var data = this.props.data;
	
	      if (!data) {
	        return _react2.default.createElement(
	          "div",
	          { className: "light-grey-border bg-white p-20 af-summary-container" },
	          "Loading..."
	        );
	      }
	      var startDatetime = data.startDatetime,
	          currentMonthConsumerRecords = data.currentMonthConsumerRecords,
	          currentMonthBusinessRecords = data.currentMonthBusinessRecords,
	          totalConsumerRecords = data.totalConsumerRecords,
	          totalBusinessRecords = data.totalBusinessRecords;
	
	      var startDateTimeText = startDatetime ? _moment2.default.unix(startDatetime / 1000).format("M/D/YY") : "";
	      return _react2.default.createElement(
	        "div",
	        { className: "light-grey-border bg-white p-20 af-summary-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "aa-title" },
	          "AUDIENCE SUMMARY"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border-top light-grey-border-bottom mt-20 list-sub-title " },
	          "Records Delivered Since Start Date of ",
	          startDateTimeText
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border-bottom list-item " },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Consumer"
	          ),
	          " -",
	          " ",
	          totalConsumerRecords ? (0, _utility.splitNumber)(totalConsumerRecords)() : "0"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border-bottom list-item " },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Business"
	          ),
	          " -",
	          " ",
	          totalBusinessRecords ? (0, _utility.splitNumber)(totalBusinessRecords)() : "0"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border-top light-grey-border-bottom mt-20 list-sub-title " },
	          "Records Delivered Month to Date"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border-bottom list-item " },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Consumer"
	          ),
	          " -",
	          " ",
	          currentMonthConsumerRecords ? (0, _utility.splitNumber)(currentMonthConsumerRecords)() : "0",
	          " ",
	          "Records"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border-bottom list-item " },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Business"
	          ),
	          " -",
	          " ",
	          currentMonthBusinessRecords ? (0, _utility.splitNumber)(currentMonthBusinessRecords)() : "0",
	          " ",
	          "Records"
	        )
	      );
	    }
	  }]);
	
	  return AudienceSummary;
	}(_MaterialUI2.default);
	
	exports.default = AudienceSummary;
	
	
	AudienceSummary.propTypes = {
	  data: _react.PropTypes.object
	  /*
	  addAttribute: PropTypes.func.required,
	  attributes: PropTypes.object.required, 
	  attributesList: PropTypes.array.required, 
	  chosenAttributes: PropTypes.array, 
	  chosenLookup: PropTypes.object, 
	  clearErrorMessage: PropTypes.func, 
	  dashboardKey: PropTypes.string,
	  dealType: PropTypes.string,
	  errorMessage: PropTypes.string, */
	};

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _SiteDateSelector = __webpack_require__(102);
	
	var _SiteDateSelector2 = _interopRequireDefault(_SiteDateSelector);
	
	var _InsightNav = __webpack_require__(355);
	
	var _InsightNav2 = _interopRequireDefault(_InsightNav);
	
	var _AudienceSummary = __webpack_require__(1101);
	
	var _AudienceSummary2 = _interopRequireDefault(_AudienceSummary);
	
	var _AudienceFilesDownload = __webpack_require__(1100);
	
	var _AudienceFilesDownload2 = _interopRequireDefault(_AudienceFilesDownload);
	
	var _utility = __webpack_require__(14);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AudienceFilesIndex = function (_AcquireWebComponent) {
	  _inherits(AudienceFilesIndex, _AcquireWebComponent);
	
	  function AudienceFilesIndex() {
	    _classCallCheck(this, AudienceFilesIndex);
	
	    return _possibleConstructorReturn(this, (AudienceFilesIndex.__proto__ || Object.getPrototypeOf(AudienceFilesIndex)).apply(this, arguments));
	  }
	
	  _createClass(AudienceFilesIndex, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      if (tagId > 0 && clientId > 0) {
	        this.props.getTagDetail(clientId, tagId);
	        this.props.getClientSites(clientId);
	        this.props.setWebsiteId(tagId);
	        this.props.selectClient(clientId);
	        this.props.getAudienceFilesData(tagId);
	        this.props.getTagAudienceFiles(tagId);
	      } else if (clientId > 0 && (0, _isEmpty2.default)(tagId)) {
	        if (this.props.websiteId) {
	          this.props.getTagDetail(clientId, this.props.websiteId);
	          this.props.getAudienceFilesData(this.props.websiteId);
	          this.props.getTagAudienceFiles(this.props.websiteId);
	        }
	        this.props.getClientSites(clientId);
	        this.props.selectClient(clientId);
	      } else {
	        this.props.selectClient(this.props.selected_client);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (nextProps.selected_client !== clientId && nextProps.selected_client > 1) {
	          window.location.href = "/insights/audience?cid=" + nextProps.selected_client;
	        }
	      }
	      if (nextProps.websiteId !== this.props.websiteId) {
	        if (nextProps.websiteId > 0) {
	          if (tagId !== nextProps.websiteId) {
	            window.location.href = "/insights/audience?cid=" + clientId + "&tag=" + nextProps.websiteId;
	          } else {
	            this.props.getAudienceFilesData(nextProps.websiteId);
	            this.props.getTagAudienceFiles(nextProps.websiteId);
	          }
	        }
	      }
	      if ((0, _isUndefined2.default)(nextProps.websiteId) && tagId > 0) {
	        this.props.setWebsiteId(tagId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var websiteId = this.props.websiteId;
	
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      return _react2.default.createElement(
	        "div",
	        { id: "website-visits-container" },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              padding: "0 10%",
	              marginTop: "-20px",
	              marginBottom: "-10px",
	              background: "#FFF",
	              fontSize: "16px"
	            }
	          },
	          _react2.default.createElement(_SiteDateSelector2.default, {
	            key: "audience-files-site-selector-" + new Date().getTime(),
	            websiteIdChanged: this.props.setWebsiteId,
	            siteId: tagId ? tagId : websiteId,
	            sites: this.props.client_sites,
	            type: "larger"
	          })
	        ),
	        _react2.default.createElement(_InsightNav2.default, {
	          activeIndex: 5,
	          clientId: this.props.selected_client
	        }),
	        websiteId ? _react2.default.createElement(
	          "div",
	          {
	            className: "website-visits-content bg-white",
	            style: { background: "#FFF" }
	          },
	          _react2.default.createElement(_AudienceSummary2.default, { data: this.props.audience_file_data }),
	          _react2.default.createElement(
	            "div",
	            { style: { height: "20px" } },
	            "\xA0"
	          ),
	          _react2.default.createElement(_AudienceFilesDownload2.default, {
	            datas: this.props.audience_files,
	            downloadFile: this.props.downloadTagAudienceFile,
	            blobData: this.props.audience_file_blob
	          })
	        ) : _react2.default.createElement(
	          "div",
	          { className: "website-visits-content" },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "100%",
	                minHeight: "200px",
	                textAlign: "center",
	                paddingTop: "60px",
	                color: "#CDCDCD"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: { color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" }
	              },
	              "No Data"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AudienceFilesIndex;
	}(_MaterialUI2.default);
	
	exports.default = AudienceFilesIndex;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _sumBy = __webpack_require__(677);
	
	var _sumBy2 = _interopRequireDefault(_sumBy);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HighestOpportunityAudience = function (_AcquireWebComponent) {
	  _inherits(HighestOpportunityAudience, _AcquireWebComponent);
	
	  function HighestOpportunityAudience() {
	    _classCallCheck(this, HighestOpportunityAudience);
	
	    return _possibleConstructorReturn(this, (HighestOpportunityAudience.__proto__ || Object.getPrototypeOf(HighestOpportunityAudience)).apply(this, arguments));
	  }
	
	  _createClass(HighestOpportunityAudience, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          type = _props.type,
	          data = _props.data,
	          systems = _props.systems,
	          total = _props.total,
	          orderType = _props.orderType,
	          topCount = _props.topCount,
	          printMode = _props.printMode;
	
	      var sortedData = orderType === "index" ? (0, _sortBy2.default)(data, function (d) {
	        return d.segmentIndex;
	      }).reverse().slice(0, topCount === 0 ? data.length : topCount) : (0, _sortBy2.default)(data, function (d) {
	        return d.householdVisitors / total;
	      }).reverse().slice(0, topCount === 0 ? data.length : topCount);
	      var sumIndex = (0, _sumBy2.default)(sortedData, function (d) {
	        return d.segmentIndex;
	      });
	      var sumHouseholdVisitors = (0, _sumBy2.default)(sortedData, function (d) {
	        return d.householdVisitors;
	      });
	      var sumHouseholdPercentage = (0, _sumBy2.default)(sortedData, function (d) {
	        return d.householdPercentage;
	      });
	
	      var reportType = "";
	      var system = (0, _find2.default)(systems, function (s) {
	        return parseInt(s.id, 10) === parseInt(type, 10);
	      });
	      if (system) reportType = system.name;
	
	      var showIndex = orderType === "index" || printMode === true;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "light-grey-border pt-20 pl-20 pr-20",
	          style: { fontSize: "16px" }
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h1",
	            { className: "no-margin" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Highest Opportunity Audiences"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: { padding: "20px", background: "#D9DBDD", marginTop: "20px" }
	          },
	          reportType.split(" ").length > 1 && reportType.split(" ")[0] !== "Purple" ? _react2.default.createElement(
	            "strong",
	            null,
	            reportType.split(" ")[0],
	            _react2.default.createElement("i", { className: "symbol symbol-tm" }),
	            " ",
	            reportType.split(" ")[1],
	            " ",
	            "Segments"
	          ) : _react2.default.createElement(
	            "strong",
	            null,
	            reportType,
	            " ",
	            _react2.default.createElement("i", { className: "symbol symbol-tm" }),
	            " ",
	            " Segments"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: { padding: "20px", background: "#F5F5F5", display: "flex" }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: reportType === "Metro Target" || reportType === "VOLKSeg" ? "25%" : "10%",
	                paddingTop: "10px"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Segment"
	            )
	          ),
	          reportType !== "Metro Target" && reportType !== "VOLKSeg" && _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: showIndex ? "35%" : "40%",
	                paddingTop: "10px"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Segment Name"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: reportType === "Metro Target" || reportType === "VOLKSeg" ? showIndex ? "30%" : "40%" : "25%"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Segment Percent of",
	              _react2.default.createElement("br", null),
	              " U.S. Households"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: showIndex ? "30%" : "auto"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Percent of ",
	              _react2.default.createElement("br", null),
	              " Household Visitors"
	            )
	          ),
	          showIndex && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Index"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "hightest-audience-list",
	            style: topCount === 0 && sortedData.length >= 10 ? {
	              height: "650px",
	              overflowY: "auto"
	            } : {
	              height: "auto"
	            }
	          },
	          sortedData && sortedData.length > 0 ? (0, _map2.default)(sortedData, function (d) {
	            return _react2.default.createElement(
	              "div",
	              {
	                key: "highest-row-" + d.segmentCode,
	                style: { padding: "20px", display: "flex" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  key: "div-segment-code-" + d.segmentCode,
	                  style: {
	                    width: reportType === "Metro Target" || reportType === "VOLKSeg" ? "25%" : "10%"
	                  }
	                },
	                d.segmentCode
	              ),
	              reportType !== "Metro Target" && reportType !== "VOLKSeg" && _react2.default.createElement(
	                "div",
	                {
	                  key: "div-segment-name-" + d.segmentCode,
	                  style: {
	                    width: showIndex ? "35%" : "40%"
	                  }
	                },
	                d.segmentName
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  key: "div-segment-place-holder-" + d.segmentCode,
	                  style: {
	                    width: reportType === "Metro Target" || reportType === "VOLKSeg" ? showIndex ? "30%" : "40%" : "25%"
	                  }
	                },
	                d.householdPercentage.toLocaleString(undefined, {
	                  style: "percent",
	                  minimumFractionDigits: 2
	                }),
	                " "
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  key: "div-segment-percentage-" + d.segmentCode,
	                  style: {
	                    width: showIndex ? "30%" : "auto"
	                  }
	                },
	                (d.householdVisitors / _this2.props.total).toLocaleString(undefined, {
	                  style: "percent",
	                  minimumFractionDigits: 2
	                })
	              ),
	              showIndex && _react2.default.createElement(
	                "div",
	                { key: "div-segment-index-" + d.segmentCode },
	                d.segmentIndex
	              )
	            );
	          }) : _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border text-center p-10 mb-20",
	              id: "contact-div",
	              style: { color: "#DD0000" }
	            },
	            "No data to display"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              padding: topCount === 0 && sortedData.length >= 10 ? "10px 30px 10px 20px" : "10px 20px",
	              marginBottom: "20px",
	              background: "#F5F5F5",
	              display: sortedData && sortedData.length > 0 ? "flex" : "none"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: reportType === "Metro Target" || reportType === "VOLKSeg" ? "25%" : "10%"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Total"
	            )
	          ),
	          reportType !== "Metro Target" && reportType !== "VOLKSeg" && _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: showIndex ? "35%" : "40%"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "\xA0"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: reportType === "Metro Target" || reportType === "VOLKSeg" ? showIndex ? "30%" : "40%" : "25%"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              sumHouseholdPercentage.toLocaleString(undefined, {
	                style: "percent",
	                minimumFractionDigits: 2
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: showIndex ? "30%" : "auto"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              (sumHouseholdVisitors / this.props.total).toLocaleString(undefined, {
	                style: "percent",
	                minimumFractionDigits: 2
	              })
	            )
	          ),
	          showIndex && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              parseInt(sumHouseholdVisitors / this.props.total / sumHouseholdPercentage * 100, 10)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HighestOpportunityAudience;
	}(_MaterialUI2.default);
	
	exports.default = HighestOpportunityAudience;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _PieChartHighlight = __webpack_require__(521);
	
	var _PieChartHighlight2 = _interopRequireDefault(_PieChartHighlight);
	
	var _VerticalBarChart = __webpack_require__(522);
	
	var _VerticalBarChart2 = _interopRequireDefault(_VerticalBarChart);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(270);
	
	var SegmentCultureReport = function (_AcquireWebComponent) {
	  _inherits(SegmentCultureReport, _AcquireWebComponent);
	
	  function SegmentCultureReport() {
	    _classCallCheck(this, SegmentCultureReport);
	
	    return _possibleConstructorReturn(this, (SegmentCultureReport.__proto__ || Object.getPrototypeOf(SegmentCultureReport)).apply(this, arguments));
	  }
	
	  _createClass(SegmentCultureReport, [{
	    key: "formatData",
	    value: function formatData(arr) {
	      if (!arr || !(arr instanceof Array) || arr.length === 0) return [];
	      var allCount = arr.reduce(function (a, b) {
	        if (typeof a !== "number") return a.value + b.value;else return a + b.value;
	      });
	      arr.forEach(function (it) {
	        it.percentage = it.value / allCount;
	      });
	      return arr;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var data = this.props.data || {};
	      var json = Object.keys(data).join();
	      var aaAcculturation = [];
	      var hhAcculturation = [];
	      data.acculturation && data.acculturation.values && data.acculturation.values.forEach(function (it) {
	        var keyName = it.key.split(":");
	        it._key = keyName[0];
	        it.middleVal = keyName[1];
	        if (it.key.includes("AA")) {
	          aaAcculturation.push(it);
	        } else {
	          hhAcculturation.push(it);
	        }
	      });
	      var acculturation = this.formatData(data.acculturation && data.acculturation.values);
	      var aa = this.formatData(aaAcculturation).filter(function (it) {
	        return Math.round(it.percentage * 10000) > 0;
	      });
	      var hh = this.formatData(hhAcculturation).filter(function (it) {
	        return Math.round(it.percentage * 10000) > 0;
	      });
	      var ethnicity = this.formatData(data.ethnicity && data.ethnicity.values).filter(function (it) {
	        return Math.round(it.percentage * 10000) > 0;
	      });
	      var region = this.formatData(data.region && data.region.values).filter(function (it) {
	        return Math.round(it.percentage * 10000) > 0;
	      });
	      var _region = !this.props.onPdfReportDownload ? region : region.map(function (it) {
	        return Object.assign({}, it, {
	          key: ""
	        });
	      });
	      var colStyle = {
	        width: "50%"
	      };
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "none",
	              padding: "20px",
	              background: "#D9DBDD",
	              color: "#000",
	              fontWeight: "bold",
	              marginTop: "20px"
	            },
	            className: "pdf-extra-container"
	          },
	          "Culture Codes"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "segment-culture-report",
	            style: Object.assign({}, this.props.style, { paddingTop: "20px" })
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "left-col",
	              style: Object.assign({}, colStyle, { paddingRight: "10px" })
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border" },
	              ethnicity && ethnicity.length > 0 && _react2.default.createElement(_PieChartHighlight2.default, {
	                data: ethnicity,
	                title: data.ethnicity.name,
	                dataKey: "value",
	                stateName: "Ethnicity",
	                fieldTitle: "Percent",
	                showList: true,
	                showDetail: true,
	                showPercentage: true
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border mt-20" },
	              acculturation && acculturation.length > 0 && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_PieChartHighlight2.default, {
	                  data: hh,
	                  title: data.acculturation ? data.acculturation.name : "",
	                  dataKey: "value",
	                  stateName: "Code",
	                  middleKey: "Hispanicity",
	                  fieldTitle: "Percent",
	                  showList: true,
	                  showDetail: true,
	                  showPercentage: true
	                }),
	                _react2.default.createElement(_PieChartHighlight2.default, {
	                  data: aa,
	                  title: "",
	                  dataKey: "value",
	                  stateName: "Code",
	                  middleKey: "Asianicity",
	                  fieldTitle: "Percent",
	                  showList: true,
	                  showDetail: true,
	                  showPercentage: true
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "right-col",
	              style: Object.assign({}, colStyle, { paddingLeft: "10px" })
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border mb-20 culture-region" },
	              region && region.length > 0 && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { style: { position: "relative" } },
	                  _react2.default.createElement(_VerticalBarChart2.default, {
	                    data: _region,
	                    title: data.region.name,
	                    chartMargin: {
	                      top: 0,
	                      right: 20,
	                      left: 20,
	                      bottom: 20
	                    },
	                    yMirror: true,
	                    yTickHide: true,
	                    yAxisWidth: 300,
	                    height: 74 * region.length + "px"
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "extra-vertical-bar-chart-y-axis pdf-extra-container",
	                      style: {
	                        position: "absolute",
	                        top: "0px",
	                        bottom: "0px",
	                        left: "0px",
	                        right: "0px",
	                        padding: "86px 0 60px 30px",
	                        display: "none"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: {
	                          display: "flex",
	                          flexDirection: "column",
	                          justifyContent: "space-around",
	                          width: "100%",
	                          height: "100%"
	                        }
	                      },
	                      region.map(function (it) {
	                        return _react2.default.createElement(
	                          "div",
	                          {
	                            key: it.key,
	                            className: "extra-y-axis",
	                            style: {
	                              height: "17.39px",
	                              transform: "translateY(-20px)"
	                            }
	                          },
	                          it.key
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-20 mb-20" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        padding: "10px 20px",
	                        margin: "-20px 20px -5px",
	                        background: "#F5F5F5",
	                        fontWeight: "bold"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { style: { display: "flex" } },
	                      _react2.default.createElement(
	                        "div",
	                        { style: { flex: "1 1 50%" } },
	                        "Region"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { style: { flex: "1 1 50%", textAlign: "right" } },
	                        "Percent"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        padding: "0",
	                        margin: "0px 20px",
	                        height: "5px",
	                        borderBottom: "solid 1px #EEEFF2 "
	                      }
	                    },
	                    "\xA0"
	                  ),
	                  (0, _sortBy2.default)(region, "percentage").reverse().map(function (entry, idx) {
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        key: "sortdata-" + idx,
	                        style: {
	                          display: "flex",
	                          padding: "10px 20px",
	                          margin: "0px 20px",
	                          borderBottom: "solid 1px #EEEFF2 "
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            width: "80%",
	                            paddingLeft: "0px"
	                          }
	                        },
	                        entry.key
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { style: { width: "20%", textAlign: "right" } },
	                        parseFloat((entry.percentage * 100).toFixed(2)) + "%"
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SegmentCultureReport;
	}(_MaterialUI2.default);
	
	exports.default = SegmentCultureReport;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _VerticalBarChart = __webpack_require__(522);
	
	var _VerticalBarChart2 = _interopRequireDefault(_VerticalBarChart);
	
	var _PieChartHighlight = __webpack_require__(521);
	
	var _PieChartHighlight2 = _interopRequireDefault(_PieChartHighlight);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(270);
	
	var SegmentDetailReport = function (_AcquireWebComponent) {
	  _inherits(SegmentDetailReport, _AcquireWebComponent);
	
	  function SegmentDetailReport() {
	    _classCallCheck(this, SegmentDetailReport);
	
	    return _possibleConstructorReturn(this, (SegmentDetailReport.__proto__ || Object.getPrototypeOf(SegmentDetailReport)).apply(this, arguments));
	  }
	
	  _createClass(SegmentDetailReport, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          data = _props.data,
	          printTitle = _props.printTitle;
	
	      var urls = window.location.href.split("?");
	      if (this.props.loading) return _react2.default.createElement(
	        "div",
	        {
	          className: "text-center",
	          style: { marginTop: "50px", marginBottom: "40px" }
	        },
	        _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "48px" } })
	      );
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "none",
	              padding: "20px",
	              background: "#D9DBDD",
	              color: "#000",
	              fontWeight: "bold",
	              marginTop: "20px"
	            },
	            className: "pdf-extra-container"
	          },
	          printTitle
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: style, className: "segment-detail-container" },
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "100%" } },
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border mb-20" },
	              data && data.state && [_react2.default.createElement(_PieChartHighlight2.default, {
	                key: "1",
	                data: data.state.values,
	                title: "Top States",
	                dataKey: "value",
	                fieldTitle: "Unique Visitors",
	                showList: true,
	                showDetail: true,
	                showPercentage: true
	              }), _react2.default.createElement(
	                "div",
	                { className: "ml-20 mb-5 nav-clickable", key: "2" },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  {
	                    to: "/segment-distribution?" + urls[1] + "&heatmap=true"
	                  },
	                  "View on map"
	                )
	              )]
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border" },
	              data && data.maritalStatus && _react2.default.createElement(_PieChartHighlight2.default, {
	                data: data.maritalStatus.values,
	                showHeader: false,
	                showHighlight: true,
	                title: "Marital Status",
	                dataKey: "value",
	                showDetail: true,
	                fieldTitle: ""
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SegmentDetailReport;
	}(_MaterialUI2.default);
	
	exports.default = SegmentDetailReport;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _PieChartTable = __webpack_require__(356);
	
	var _PieChartTable2 = _interopRequireDefault(_PieChartTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(270);
	
	var SegmentDeviceReport = function (_AcquireWebComponent) {
	  _inherits(SegmentDeviceReport, _AcquireWebComponent);
	
	  function SegmentDeviceReport() {
	    _classCallCheck(this, SegmentDeviceReport);
	
	    return _possibleConstructorReturn(this, (SegmentDeviceReport.__proto__ || Object.getPrototypeOf(SegmentDeviceReport)).apply(this, arguments));
	  }
	
	  _createClass(SegmentDeviceReport, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          top5OSBreakDown = _props.top5OSBreakDown,
	          deviceModelData = _props.deviceModelData,
	          deviceTypeData = _props.deviceTypeData,
	          printTitle = _props.printTitle;
	
	      if (deviceTypeData) return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "none",
	              padding: "20px",
	              background: "#D9DBDD",
	              color: "#000",
	              fontWeight: "bold",
	              marginTop: "20px"
	            },
	            className: "pdf-extra-container"
	          },
	          printTitle
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: style, id: "device-report-container" },
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "50%" } },
	            this.props.loadDeviceTypeReport && _react2.default.createElement(
	              "div",
	              {
	                className: "text-center",
	                style: { marginTop: "50px", marginBottom: "40px" }
	              },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "48px" } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border mb-10" },
	              deviceTypeData && _react2.default.createElement(_PieChartTable2.default, {
	                data: deviceTypeData.values,
	                dataKey: "value",
	                title: "Device Type Breakdown",
	                tableTitle: deviceTypeData.name
	              })
	            ),
	            this.props.loadDeviceModelReport && _react2.default.createElement(
	              "div",
	              {
	                className: "text-center",
	                style: { marginTop: "50px", marginBottom: "40px" }
	              },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "48px" } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border" },
	              deviceModelData && _react2.default.createElement(_PieChartTable2.default, {
	                data: deviceModelData.values,
	                dataKey: "value",
	                title: "Model Breakdown",
	                tableTitle: deviceModelData.name
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "20px" } },
	            "\xA0"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "50%" } },
	            this.props.loadingTop5OSBreakdown && _react2.default.createElement(
	              "div",
	              {
	                className: "text-center",
	                style: { marginTop: "50px", marginBottom: "40px" }
	              },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "48px" } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border" },
	              top5OSBreakDown && _react2.default.createElement(_PieChartTable2.default, {
	                data: top5OSBreakDown.values,
	                dataKey: "value",
	                title: "OS Breakdown",
	                tableTitle: top5OSBreakDown.name
	              })
	            )
	          )
	        )
	      );else return _react2.default.createElement(
	        "div",
	        { style: style, id: "device-report-container" },
	        "\xA0"
	      );
	    }
	  }]);
	
	  return SegmentDeviceReport;
	}(_MaterialUI2.default);
	
	exports.default = SegmentDeviceReport;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _utility = __webpack_require__(14);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _recharts = __webpack_require__(101);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomTooltip = function CustomTooltip(_ref) {
	  var active = _ref.active,
	      payload = _ref.payload,
	      total = _ref.total,
	      type = _ref.type,
	      measure = _ref.measure;
	
	  if (active) {
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "recharts-default-tootip no-margin pt-10 pl-20 pr-20 pb-15",
	        style: { background: "#000", border: "solid 1px #000", color: "#FFF" }
	      },
	      _react2.default.createElement("p", { className: "recharts-tooltip-label no-margin" }),
	      _react2.default.createElement(
	        "ul",
	        { className: "recharts-tooltip-item-list no-padding no-margin" },
	        _react2.default.createElement(
	          "li",
	          {
	            className: "recharts-tooltip-item",
	            style: {
	              display: "inline",
	              paddingTop: "4px",
	              paddingBottom: "4px",
	              width: "100%"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "auto",
	                height: "25px",
	                display: "block",
	                overflow: "overlap",
	                whiteSpace: "nowrap",
	                textOverflow: "unset",
	                borderBottom: "solid 1px #CCC"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "recharts-tooltip-label no-margin-left no-margin-top no-margin-right mb-5" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                payload[0].payload.segmentName
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          {
	            className: "recharts-tooltip-item",
	            style: {
	              display: "inline",
	              paddingTop: "4px",
	              paddingBottom: "4px",
	              width: "100%"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "auto",
	                height: "20px",
	                display: "block",
	                overflow: "overlap",
	                whiteSpace: "nowrap",
	                textOverflow: "unset"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              { className: "recharts-tooltip-label no-margin-bottom no-margin-left no-margin-right mt-5" },
	              "Segment - ",
	              payload[0].payload.segmentCode
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          {
	            className: "recharts-tooltip-item",
	            style: {
	              display: "inline",
	              paddingTop: "4px",
	              paddingBottom: "4px",
	              width: "100%"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "auto",
	                height: "20px",
	                display: "block",
	                overflow: "overlap",
	                whiteSpace: "nowrap",
	                textOverflow: "unset"
	              }
	            },
	            measure === 0 ? _react2.default.createElement(
	              "p",
	              { className: "recharts-tooltip-label no-margin-left no-margin-right mt-10" },
	              "Pct. of HH Visitors -",
	              " ",
	              (payload[0].payload.householdVisitors / total).toLocaleString(undefined, {
	                style: "percent",
	                minimumFractionDigits: 2
	              })
	            ) : _react2.default.createElement(
	              "p",
	              { className: "recharts-tooltip-label no-margin-left no-margin-right mt-10" },
	              "Index - ",
	              payload[0].payload.segmentIndex + 100
	            )
	          )
	        ),
	        type === "psycle_premier" && _react2.default.createElement(
	          "li",
	          {
	            className: "recharts-tooltip-item",
	            style: {
	              display: "inline",
	              paddingTop: "4px",
	              paddingBottom: "4px",
	              width: "100%"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "auto",
	                height: "20px",
	                display: "block",
	                overflow: "overlap",
	                whiteSpace: "nowrap",
	                textOverflow: "unset"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              { className: "recharts-tooltip-label no-margin-left no-margin-right mt-10" },
	              "IPA - ",
	              payload[0].payload.ipa
	            )
	          )
	        ),
	        type === "connexions" && _react2.default.createElement(
	          "li",
	          {
	            className: "recharts-tooltip-item",
	            style: {
	              display: "inline",
	              paddingTop: "4px",
	              paddingBottom: "4px",
	              width: "100%"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                width: "auto",
	                height: "20px",
	                display: "block",
	                overflow: "overlap",
	                whiteSpace: "nowrap",
	                textOverflow: "unset"
	              }
	            },
	            _react2.default.createElement(
	              "p",
	              { className: "recharts-tooltip-label no-margin-left no-margin-right mt-10" },
	              "Technodoption Class - ",
	              payload[0].payload.technodoptionClass
	            )
	          )
	        )
	      )
	    );
	  }
	
	  return null;
	};
	var AxisLabel = function AxisLabel(_ref2) {
	  var axisType = _ref2.axisType,
	      x = _ref2.x,
	      y = _ref2.y,
	      width = _ref2.width,
	      height = _ref2.height,
	      stroke = _ref2.stroke,
	      children = _ref2.children;
	
	  var isVert = axisType === "yAxis";
	  var cx = isVert ? x : x + width / 2;
	  var cy = isVert ? height / 2 + y : y + height + 10;
	  var rot = isVert ? "270 " + cx + " " + cy : 0;
	  return _react2.default.createElement(
	    "text",
	    {
	      x: cx,
	      y: cy,
	      transform: "rotate(" + rot + ")",
	      fontWeight: "bold",
	      textAnchor: "middle",
	      stroke: stroke
	    },
	    children
	  );
	};
	var CustomizedLabel = _react2.default.createClass({
	  displayName: "CustomizedLabel",
	  render: function render() {
	    var _props = this.props,
	        viewBox = _props.viewBox,
	        value = _props.value;
	
	
	    return _react2.default.createElement(
	      "text",
	      {
	        x: viewBox.x,
	        y: viewBox.height / 2 + viewBox.y,
	        fontSize: 10,
	        textAnchor: "middle"
	      },
	      value
	    );
	  }
	});
	
	var SegmentHouseHold = function (_AcquireWebComponent) {
	  _inherits(SegmentHouseHold, _AcquireWebComponent);
	
	  function SegmentHouseHold(props) {
	    _classCallCheck(this, SegmentHouseHold);
	
	    var _this = _possibleConstructorReturn(this, (SegmentHouseHold.__proto__ || Object.getPrototypeOf(SegmentHouseHold)).call(this, props));
	
	    _this.state = {
	      activeIndex: -1,
	      measureIndex: props.measure === "index" ? 1 : 0,
	      topIndex: props.topCount,
	      topCount: props.topCount
	    };
	    return _this;
	  }
	
	  _createClass(SegmentHouseHold, [{
	    key: "handleMeasureChanged",
	    value: function handleMeasureChanged(e) {
	      this.setState({
	        measureIndex: e.value
	      });
	      this.props.changeMeasure(e.value === 1 ? "index" : "hh");
	    }
	  }, {
	    key: "handleTopNumberChange",
	    value: function handleTopNumberChange(e) {
	      var _this2 = this;
	
	      this.setState({
	        topCount: e.value,
	        topIndex: e.value
	      }, function () {
	        _this2.props.changeTopCount(e.value);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          totalHouseholdVisitors = _props2.totalHouseholdVisitors,
	          totalVisits = _props2.totalVisits,
	          type = _props2.type,
	          systems = _props2.systems,
	          zip11Households = _props2.zip11Households,
	          zip9Households = _props2.zip9Households;
	
	      var sysType = type === "default" ? (0, _utility.getUrlParameterByName)("type") : type;
	      var system = (0, _find2.default)(systems, function (s) {
	        return parseInt(s.id, 10) === parseInt(sysType, 10);
	      });
	      var prevSortData = (0, _sortBy2.default)(data, "segmentCode");
	      var measureOptions = [{ value: 0, label: "Household Visitors" }, { value: 1, label: "Index" }];
	      var topCountOptions = [{ value: 1, label: "1" }, { value: 2, label: "2" }, { value: 3, label: "3" }, { value: 4, label: "4" }, { value: 5, label: "5" }, { value: 6, label: "6" }, { value: 7, label: "7" }, { value: 8, label: "8" }, { value: 9, label: "9" }, { value: 10, label: "10" }, { value: 0, label: "All" }];
	      var sortData = [];
	      var segment_title_name = system ? system.name : "";
	      var segment_title_right = " Segment"; /*
	                                            segment_title_name.toLowerCase().indexOf("connexions") >= 0
	                                            ? " Segment"
	                                            : " Premier Segment";*/
	
	      if (segment_title_name.split(" ").length > 1 && segment_title_name.split(" ")[0] !== "Purple") {
	        var s = segment_title_name.split(" ")[1];
	        segment_title_name = segment_title_name.split(" ")[0];
	        segment_title_right = s + " Segment";
	      }
	      (0, _lodash.map)(prevSortData, function (data) {
	        sortData.push(Object.assign({}, data, {
	          total: totalHouseholdVisitors,
	          pctHouseholdVisitors: (data.householdVisitors / totalHouseholdVisitors * 100).toFixed(2),
	          segmentIndex: data.segmentIndex - 100
	        }));
	      });
	      var highLightIds = (0, _lodash.map)((0, _sortBy2.default)(data, this.state.measureIndex === 0 ? "householdVisitors" : "segmentIndex").reverse(), "segmentCode").slice(0, this.state.topIndex === 0 ? data.length : this.state.topIndex);
	      return _react2.default.createElement(
	        "div",
	        {
	          style: { position: "relative", fontSize: "16px" },
	          className: this.state.measureIndex === 0 ? "house-hold-chart" : "house-hold-index-chart"
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: { display: "flex", height: "60px" },
	            className: "segment-household-nav-container"
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "1 1" } },
	            "View",
	            " ",
	            _react2.default.createElement(_reactSelect2.default, {
	              value: this.state.topCount,
	              name: "",
	              clearable: false,
	              options: topCountOptions,
	              searchable: false,
	              className: "top-segment-count-select",
	              onChange: this.handleTopNumberChange.bind(this)
	            }),
	            " ",
	            "top segments",
	            " " /*
	                <button
	                href="#"
	                onClick={() => {
	                this.refreshStatData();
	                }}
	                disabled={this.state.topIndex === this.state.topCount}
	                className="btn-aa-claritas btn-claritas ml-10"
	                >
	                Submit
	                </button>*/
	
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "1 1" } },
	            _react2.default.createElement(_reactSelect2.default, {
	              value: this.state.measureIndex,
	              name: "",
	              clearable: false,
	              options: measureOptions,
	              searchable: false,
	              className: "measure-select",
	              onChange: this.handleMeasureChanged.bind(this)
	            }),
	            _react2.default.createElement(
	              "strong",
	              { style: { float: "right", marginTop: "10px" } },
	              "Measure"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: { height: "30px", display: "none" },
	            className: "sgemnt-household-pdf-nav ml-20 mb-10 mr-20 light-grey-border-bottom"
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "0 0 40%" } },
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                " ",
	                this.state.topCount === 0 ? "All Segments" : "Top " + this.state.topCount + " Segments"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "1 1 50%", textAlign: "right" } },
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Measure: "
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "ml-20" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                this.state.measureIndex === 0 ? "Household Visitors" : "Index"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              zIndex: "2000",
	              textAlign: "center",
	              minHeight: "58px",
	              marginTop: "-15px",
	              marginBottom: "20px",
	              display: "flex",
	              justifyContent: "center",
	              alignItems: "center"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontSize: "55px",
	                color: "#00A3AD",
	                fontWeight: "bold"
	              }
	            },
	            (0, _utility.splitNumber)(totalVisits)()
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontSize: "18px",
	                margin: "0 10px",
	                flexShrink: 0
	              }
	            },
	            " ",
	            "Visits by"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontSize: "55px",
	                color: "#00A3AD",
	                fontWeight: "bold"
	              }
	            },
	            " ",
	            (0, _utility.splitNumber)(totalHouseholdVisitors)()
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontSize: "18px",
	                marginLeft: "10px",
	                marginRight: "10px",
	                textAlign: "left"
	              }
	            },
	            " ",
	            "Visitor Households Matched to ",
	            segment_title_name,
	            _react2.default.createElement("i", { className: "symbol symbol-tm" }),
	            " ",
	            segment_title_right
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              background: "#F5F5F5",
	              display: "flex",
	              marginBottom: "20px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { padding: "20px", background: "#D9DBDD" } },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Household Match Flag"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "p-20 pr-10" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Zip + 6"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pt-20 pb-20" },
	            (0, _utility.splitNumber)(zip11Households)()
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "p-20 pr-10" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Zip + 4"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pt-20 pb-20" },
	            (0, _utility.splitNumber)(zip9Households)()
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { position: "relative" } },
	          _react2.default.createElement(
	            _recharts.ResponsiveContainer,
	            { width: "100%", height: 360 },
	            _react2.default.createElement(
	              _recharts.BarChart,
	              {
	                data: sortData,
	                margin: {
	                  top: 20,
	                  right: 0,
	                  left: 17,
	                  bottom: 20
	                },
	                maxBarSize: 20
	              },
	              _react2.default.createElement(_recharts.CartesianGrid, { vertical: false, strokeDasharray: "3 3" }),
	              _react2.default.createElement(_recharts.XAxis, {
	                dataKey: "segmentCode"
	                /*
	                label={
	                  <CustomizedLabel value="test" />
	                }*/
	
	                , label: {
	                  value: segment_title_name + "® " + segment_title_right,
	                  position: "bottom"
	                }
	              }),
	              _react2.default.createElement(_recharts.YAxis, {
	                tickFormatter: function tickFormatter(item) {
	                  if (_this3.state.measureIndex === 0) return item === 0 ? item : item + "%";else return parseInt(item, 10) + 100;
	                },
	                domain: this.state.measureIndex === 1 ? [function (dataMin) {
	                  return dataMin >= 0 ? -50 : dataMin;
	                }, "auto"] : [0, "auto"],
	                label: _react2.default.createElement(
	                  AxisLabel,
	                  {
	                    axisType: "yAxis",
	                    x: 15,
	                    y: 170,
	                    width: 0,
	                    height: 0
	                  },
	                  this.state.measureIndex === 0 ? "Percent of Household Visitors" : "Index"
	                )
	              }),
	              _react2.default.createElement(_recharts.Tooltip, {
	                content: _react2.default.createElement(CustomTooltip, {
	                  total: totalHouseholdVisitors,
	                  type: sysType,
	                  measure: this.state.measureIndex
	                }),
	                cursor: false
	              }),
	              _react2.default.createElement(
	                _recharts.Bar,
	                {
	                  dataKey: this.state.measureIndex === 0 ? "pctHouseholdVisitors" : "segmentIndex",
	                  onMouseEnter: function onMouseEnter(data, index) {
	                    _this3.setState({ activeIndex: index });
	                  },
	                  onMouseLeave: function onMouseLeave() {
	                    _this3.setState({ activeIndex: -1 });
	                  }
	                },
	                sortData.map(function (entry, index) {
	                  return _react2.default.createElement(_recharts.Cell, {
	                    cursor: "pointer",
	                    fill: highLightIds.indexOf(entry.segmentCode) >= 0 ? "#E56E2C" : "#47a1ab",
	                    key: "household-segment-cell-" + index
	                  });
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              id: "chart-x-title",
	              style: {
	                position: "absolute",
	                bottom: "0",
	                height: "25px",
	                left: 0,
	                right: 0,
	                fontWeight: "bold",
	                background: "white",
	                paddingLeft: "70px",
	                textAlign: "center",
	                display: "none"
	              }
	            },
	            segment_title_name + segment_title_right + " ®"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "text-right pr-10",
	            style: { fontSize: "16px", position: "relative" }
	          },
	          _react2.default.createElement(
	            "span",
	            {
	              style: {
	                width: "16px",
	                height: "16px",
	                background: "#E56E2C",
	                position: "absolute",
	                right: "120px",
	                top: "5px"
	              }
	            },
	            "\xA0"
	          ),
	          "Top Segments"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "light-grey-border-top mt-20 text-center pt-20",
	            style: { paddingLeft: "70px" }
	          },
	          "Click for more information on",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "http://www.mybestsegments.com/",
	              target: "_blank",
	              className: "claritas_link"
	            },
	            "MyBestSegments"
	          ),
	          " "
	        )
	      );
	    }
	  }]);
	
	  return SegmentHouseHold;
	}(_MaterialUI2.default);
	
	exports.default = SegmentHouseHold;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _SiteDateSelector = __webpack_require__(102);
	
	var _SiteDateSelector2 = _interopRequireDefault(_SiteDateSelector);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _RadioButton = __webpack_require__(425);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _RadioButtonGroup = __webpack_require__(426);
	
	var _RadioButtonGroup2 = _interopRequireDefault(_RadioButtonGroup);
	
	var _SegmentHouseHold = __webpack_require__(1107);
	
	var _SegmentHouseHold2 = _interopRequireDefault(_SegmentHouseHold);
	
	var _HighestOpportunityAudience = __webpack_require__(1103);
	
	var _HighestOpportunityAudience2 = _interopRequireDefault(_HighestOpportunityAudience);
	
	var _momentTimezone = __webpack_require__(110);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _Grid = __webpack_require__(19);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _querystring = __webpack_require__(309);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _pdfHelper = __webpack_require__(1109);
	
	var _SegmentDetailReport = __webpack_require__(1105);
	
	var _SegmentDetailReport2 = _interopRequireDefault(_SegmentDetailReport);
	
	var _SegmentDeviceReport = __webpack_require__(1106);
	
	var _SegmentDeviceReport2 = _interopRequireDefault(_SegmentDeviceReport);
	
	var _SegmentCultureReport = __webpack_require__(1104);
	
	var _SegmentCultureReport2 = _interopRequireDefault(_SegmentCultureReport);
	
	var _utility = __webpack_require__(14);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _svgIcons = __webpack_require__(2490);
	
	var _checkCircle = __webpack_require__(432);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _materialUi = __webpack_require__(38);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _HeatMap = __webpack_require__(518);
	
	var _HeatMap2 = _interopRequireDefault(_HeatMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(270);
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	var SegmentDistribution = function (_AcquireWebComponent) {
	  _inherits(SegmentDistribution, _AcquireWebComponent);
	
	  function SegmentDistribution(props) {
	    _classCallCheck(this, SegmentDistribution);
	
	    var _this = _possibleConstructorReturn(this, (SegmentDistribution.__proto__ || Object.getPrototypeOf(SegmentDistribution)).call(this, props));
	
	    var type = window.localStorage.getItem("__segmentSysId__") || ((0, _utility.getUrlParameterByName)("type") ? (0, _utility.getUrlParameterByName)("type") : "default");
	    var segmentTop = window.localStorage.getItem("__segmentTop__");
	    var granularity = window.localStorage.getItem("__granularity__");
	    _this.state = {
	      type: type,
	      openContactUs: false,
	      showSuccessForm: false,
	      ppType: "detail",
	      subject: "",
	      comments: "",
	      showDownloadDialog: false,
	      onPdfReportDownload: false,
	      disabledBtnDownload: false,
	      segmentTop: segmentTop ? +segmentTop : 5,
	      printMode: false,
	      showEmptyError: false,
	      showCreateAudienceDialog: false,
	      audienceType: "scale",
	      audienceName: "",
	      granularity: granularity || "scale", // Precision or Scale
	      measure: window.localStorage.getItem("__segmentMeasure__") || ((0, _utility.getUrlParameterByName)("measure") && ((0, _utility.getUrlParameterByName)("measure") === "hh" || (0, _utility.getUrlParameterByName)("measure") === "index") ? (0, _utility.getUrlParameterByName)("measure") : "hh")
	    };
	    props.setGranularity(granularity);
	    return _this;
	  }
	
	  _createClass(SegmentDistribution, [{
	    key: "submitContactRequest",
	    value: function submitContactRequest(e) {
	      e.preventDefault();
	      var oriPage = "";
	      var type = (0, _utility.getUrlParameterByName)("type");
	      var source = (0, _utility.getUrlParameterByName)("source");
	      var isHeatMap = Boolean((0, _utility.getUrlParameterByName)("heatmap"));
	      var segmentDistributionSystems = this.props.segmentDistributionSystems;
	
	
	      var system = (0, _find2.default)(segmentDistributionSystems, function (s) {
	        return parseInt(s.id, 10) === parseInt(type, 10);
	      });
	      if (system) oriPage = system.name;
	
	      if (source) {
	        oriPage = source === "pop" ? oriPage + " Most Popular Page" : oriPage + " Favorite Page";
	        if (isHeatMap) {
	          oriPage += " : Geographic Traffic Page";
	        }
	        var page = (0, _utility.getUrlParameterByName)("page");
	        if (page) {
	          oriPage += " : " + page;
	        }
	      } else {
	        if (isHeatMap) {
	          oriPage += " Geographic Traffic Page";
	        } else {
	          oriPage = this.state.ppType === "detail" ? oriPage + " Segment Details Page" : oriPage + " Device Details Page";
	        }
	      }
	      var postData = {
	        clientId: this.props.selected_client,
	        subject: this.state.subject.trim(),
	        comment: this.state.comments.trim(),
	        originationPage: oriPage
	      };
	      this.props.sendAssistRequest(postData);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.clearCreateScaleAudienceInfo();
	      this.props.clearCreateVisitorsAudienceInfo();
	      this.setState({
	        showCreateAudienceDialog: false,
	        audienceName: ""
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var tagId = this.getTagId();
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      var type = (0, _utility.getUrlParameterByName)("type");
	      var heatmap = (0, _utility.getUrlParameterByName)("heatmap");
	      var page = (0, _utility.getUrlParameterByName)("page");
	      if (heatmap && this.props.segmentDistributionHouseHold && this.props.dayRange) {
	        this.getDistributionData(tagId, page, this.props.segmentDistributionHouseHold, this.props.dayRange, "heatmap");
	      }
	      if ((0, _utility.getUrlParameterByName)("type")) {
	        this.setState({
	          type: (0, _utility.getUrlParameterByName)("type")
	        });
	      }
	      if (tagId > 0 && clientId > 0) {
	        this.props.getClientSites(clientId);
	        this.props.setWebsiteId(tagId);
	        this.props.selectClient(clientId);
	        this.props.getSegmentDistributionSystems(tagId, function () {
	          _this2.getSegmentDistributionData(tagId, type, _this2.props.dayRange);
	        });
	      } else if (clientId > 0 && (0, _isEmpty2.default)(tagId)) {
	        this.props.getClientSites(clientId);
	        this.props.getClientTags(clientId);
	        this.props.selectClient(clientId);
	        if (this.props.websiteId) {
	          // const url =
	          //   "/segment-distribution?cid=" +
	          //   clientId +
	          //   "&tag=" +
	          //   this.props.websiteId +
	          //   "&type=" +
	          //   this.state.type;
	          // window.location.href = url;
	          this.props.getSegmentDistributionSystems(this.props.websiteId, function (segmentDistributionSystems) {
	            var nowType = _this2.state.type;
	            var has = false;
	            segmentDistributionSystems && segmentDistributionSystems.forEach(function (it) {
	              if (Number(nowType) === Number(it.id)) {
	                has = true;
	              }
	            });
	            var url = "/segment-distribution?cid=" + clientId + "&tag=" + _this2.props.websiteId + "&type=" + (has && nowType ? nowType : segmentDistributionSystems[0].id);
	            window.location.href = url;
	          });
	        }
	      } else {
	        this.props.selectClient(this.props.selected_client);
	      }
	    }
	  }, {
	    key: "changeMeasure",
	    value: function changeMeasure(val) {
	      var _this3 = this;
	
	      var tagId = this.getTagId();
	      window.localStorage.setItem("__segmentMeasure__", val);
	      this.setState({ measure: val }, function () {
	        var page = (0, _utility.getUrlParameterByName)("page");
	        _this3.getDistributionData(tagId, page, _this3.props.segmentDistributionHouseHold, _this3.props.dayRange, "culture");
	        // this.getCultureReport(
	        //   tagId,
	        //   page,
	        //   this.props.segmentDistributionHouseHold,
	        //   this.props.dayRange,
	        // );
	
	        _this3.updateDistributionData(tagId, _this3.state.type, _this3.props.dayRange, _this3.props.segmentDistributionHouseHold);
	      });
	    }
	  }, {
	    key: "changeTopCount",
	    value: function changeTopCount(val) {
	      var _this4 = this;
	
	      var tagId = this.getTagId();
	      // window.__segmentTop__ = val;
	      window.localStorage.setItem("__segmentTop__", val);
	      this.setState({ segmentTop: val }, function () {
	        _this4.updateDistributionData(tagId, _this4.state.type, _this4.props.dayRange, _this4.props.segmentDistributionHouseHold);
	        var page = (0, _utility.getUrlParameterByName)("page");
	        _this4.getDistributionData(tagId, page, _this4.props.segmentDistributionHouseHold, _this4.props.dayRange, "culture");
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this5 = this;
	
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      var tagId = this.getTagId();
	      var type = (0, _utility.getUrlParameterByName)("type");
	      var page = (0, _utility.getUrlParameterByName)("page");
	      var pageChange = !!page !== !!this.hasPage;
	      if (nextProps.client_info) {
	        if (nextProps.client_info.subscriptionTierId < 4) {
	          this.props.history.push("/");
	        }
	      }
	
	      this.hasPage = !!page;
	      if (!this.props.websiteId && nextProps.websiteId) {
	        this.props.getSegmentDistributionSystems(nextProps.websiteId, function (segmentDistributionSystems) {
	          var nowType = _this5.state.type;
	          var has = false;
	          segmentDistributionSystems && segmentDistributionSystems.forEach(function (it) {
	            if (Number(nowType) === Number(it.id)) {
	              has = true;
	            }
	          });
	          var url = "/segment-distribution?cid=" + clientId + "&tag=" + nextProps.websiteId + "&type=" + (has && nowType ? nowType : segmentDistributionSystems[0].id);
	          window.location.href = url;
	        });
	      }
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (nextProps.selected_client !== clientId && nextProps.selected_client > 1) {
	          window.location.href = "/segment-distribution?cid=" + nextProps.selected_client;
	        }
	        this.props.getClientInfo(nextProps.selected_client);
	        this.props.getClientTags(nextProps.selected_client);
	      }
	      if (nextProps.request_assist_successful === true && (0, _isUndefined2.default)(this.props.request_assist_successful)) {
	        this.setState({
	          subject: undefined,
	          comments: undefined,
	          showSuccessForm: true,
	          openContactUs: false
	        });
	      }
	
	      if ((0, _isUndefined2.default)(nextProps.websiteId) && tagId > 0) {
	        this.props.setWebsiteId(tagId);
	      }
	      if (nextProps.dayRange !== this.props.dayRange && tagId || pageChange && tagId || nextProps.granularity !== this.props.granularity && tagId) {
	        this.setState({
	          showEmptyError: false
	        });
	        this.getSegmentDistributionData(tagId, this.state.type, nextProps.dayRange, page);
	      }
	
	      if (!(0, _isEqual2.default)(nextProps.segmentDistributionHouseHold, this.props.segmentDistributionHouseHold) && nextProps.segmentDistributionHouseHold || pageChange && nextProps.segmentDistributionHouseHold) {
	        this.updateDistributionData(tagId, this.state.type, nextProps.dayRange, nextProps.segmentDistributionHouseHold);
	        this.getDistributionData(tagId, page, nextProps.segmentDistributionHouseHold, nextProps.dayRange, "culture");
	      }
	      if (Boolean(nextProps.loadingDistributionDetailReport) !== Boolean(this.props.loadingDistributionDetailReport)) {
	        if (!nextProps.loadingDistributionDetailReport && this.props.loadingDistributionDetailReport) {
	          this.setState({
	            showEmptyError: !nextProps.segmentDistributionHouseHold || (0, _isEmpty2.default)(nextProps.segmentDistributionHouseHold.distributions)
	          });
	        } else {
	          this.setState({
	            showEmptyError: false
	          });
	        }
	      }
	      if (nextProps.location.search !== this.props.location.search) {
	        this.updateDistributionData(tagId, this.state.type, nextProps.dayRange, nextProps.segmentDistributionHouseHold);
	      }
	      if (!(0, _isEqual2.default)(nextProps.segmentDistributionSystems, this.props.segmentDistributionSystems)) {
	        if (type === "default" && nextProps.segmentDistributionSystems) {
	          var url = "/segment-distribution?cid=" + nextProps.selected_client + "&tagId=" + tagId + "&type=" + nextProps.segmentDistributionSystems[0].id;
	          if (page) {
	            url += "&page=" + page;
	          }
	          var source = (0, _utility.getUrlParameterByName)("source");
	          if (source) {
	            url += "&source=" + source;
	          }
	          this.props.history.push(url);
	        }
	      }
	    }
	  }, {
	    key: "getTagId",
	    value: function getTagId() {
	      return (0, _utility.getUrlParameterByName)("tag") ? parseInt((0, _utility.getUrlParameterByName)("tag"), 10) : parseInt((0, _utility.getUrlParameterByName)("tagId"), 10);
	    }
	  }, {
	    key: "getDistributionData",
	    value: function getDistributionData(tagid, page, segmentDistributionHouseHold, dayRange, reportType) {
	      var _this6 = this;
	
	      var granularity = this.props.granularity ? this.props.granularity : this.state.granularity;
	      //getCultureReport(tagId, page, segmentDistributionHouseHold, dayRange) {
	      segmentDistributionHouseHold = segmentDistributionHouseHold || this.props.segmentDistributionHouseHold;
	      dayRange = dayRange || this.props.dayRange;
	      var segmentIds = (0, _map2.default)((0, _sortBy2.default)(segmentDistributionHouseHold.distributions, function (d) {
	        if (_this6.state.measure === "index") return d.segmentIndex;else return d.householdVisitors / segmentDistributionHouseHold.totalHouseholdVisitors;
	      }), "segmentCode").reverse().slice(0, this.state.segmentTop).join(",");
	      var type = (0, _utility.getUrlParameterByName)("type") || this.state.type;
	      if (reportType === "culture") this.props.getCultureCodeReport(tagid || this.getTagId(), type, dayRange, segmentIds, page || (0, _utility.getUrlParameterByName)("page"), granularity);
	      if (reportType === "heatmap") this.props.getDistributionHeatMapData(tagid || this.getTagId(), type, dayRange, segmentIds, page || (0, _utility.getUrlParameterByName)("page"), granularity);
	    }
	  }, {
	    key: "getSegmentDistributionData",
	    value: function getSegmentDistributionData(tagId, type, period) {
	      var _props = this.props,
	          websiteId = _props.websiteId,
	          dayRange = _props.dayRange,
	          granularity = _props.granularity;
	
	      var tag_id = tagId ? tagId : websiteId;
	      var day_range = period ? period : dayRange;
	      var page = (0, _utility.getUrlParameterByName)("page");
	      if (type === "default") {
	        if (this.props.segmentDistributionSystems) {
	          type = this.props.segmentDistributionSystems[0].id;
	        }
	      }
	      this.props.getSegmentDistribution(tag_id, type, day_range, granularity ? granularity : this.state.granularity, page);
	    }
	  }, {
	    key: "updateDistributionData",
	    value: function updateDistributionData(tagId, type, period, segmentDistributionHouseHold) {
	      var _this7 = this;
	
	      var _props2 = this.props,
	          websiteId = _props2.websiteId,
	          dayRange = _props2.dayRange;
	
	      var granularity = this.props.granularity ? this.props.granularity : this.state.granularity;
	      var tag_id = tagId ? tagId : websiteId;
	      var day_range = period ? period : dayRange;
	      var page = (0, _utility.getUrlParameterByName)("page");
	      if (type === "default") {
	        if (this.props.segmentDistributionSystems) {
	          type = this.props.segmentDistributionSystems[0].id;
	        }
	      }
	      var heatmap = (0, _utility.getUrlParameterByName)("heatmap");
	
	      if (this.state.segmentTop === 0 || !segmentDistributionHouseHold) {
	        this.props.getSegmentReportTop5OS(tag_id, type, day_range, undefined, granularity, page);
	        this.props.getSegmentDistributionDetailReport(tag_id, type, day_range, undefined, page, granularity);
	        this.props.getSegmentDistributionDeviceModelReport(tag_id, type, day_range, undefined, granularity, page);
	        this.props.getSegmentDistributionDeviceTypeReport(tag_id, type, day_range, undefined, granularity, page);
	        if (heatmap) {
	          this.props.getDistributionHeatMapData(tag_id, type, day_range, undefined, page, granularity);
	        }
	      } else {
	        var data = segmentDistributionHouseHold.distributions;
	        var segmentIds = (0, _map2.default)((0, _sortBy2.default)(data, function (d) {
	          if (_this7.state.measure === "index") return d.segmentIndex;else return d.householdVisitors / segmentDistributionHouseHold.totalHouseholdVisitors;
	        }), "segmentCode").reverse().slice(0, this.state.segmentTop).join(",");
	        this.props.getSegmentReportTop5OS(tag_id, type, day_range, segmentIds, granularity, page);
	        this.props.getSegmentDistributionDetailReport(tag_id, type, day_range, segmentIds, page, granularity);
	        this.props.getSegmentDistributionDeviceModelReport(tag_id, type, day_range, segmentIds, granularity, page);
	        this.props.getSegmentDistributionDeviceTypeReport(tag_id, type, day_range, segmentIds, granularity, page);
	        if (heatmap) {
	          this.props.getDistributionHeatMapData(tag_id, type, day_range, segmentIds, page, granularity);
	        }
	      }
	    }
	  }, {
	    key: "_addPdfHeader",
	    value: function _addPdfHeader(pdf, client_name, bu_name) {
	      pdf.setFillColor(127, 127, 127);
	      pdf.rect(0, 15, 210, 10, "F");
	
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(9);
	      pdf.setFontType("bold");
	      pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), "PNG", 10.5, 3, 60, 0);
	      pdf.text(198, 8, (0, _momentTimezone2.default)().format("MMMM DD, YYYY"), null, null, "right");
	
	      pdf.setTextColor(255, 255, 255);
	      pdf.setFontType("bold");
	      pdf.text(12, 21, "Client:");
	      //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
	      pdf.setFontType("normal");
	      pdf.text(26, 21, client_name ? client_name.trim() : "");
	      //cm to inches
	      var start = 90; //46 + lenClientName.width * 0.3937 + 0.4
	      if (!(0, _isEmpty2.default)(bu_name)) {
	        pdf.setFontType("bold");
	        pdf.text(start, 21, "Business Unit:");
	        start += 26.5;
	        pdf.setFontType("normal");
	        pdf.text(start, 21, bu_name ? bu_name.trim() : "");
	      }
	      pdf.setFillColor(255);
	      start = 12;
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(10);
	      //pdf.text(12, 30, "Campaigns  >  " + campaignDetail.name);
	    }
	  }, {
	    key: "_addPdfFooter",
	    value: function _addPdfFooter(pdf, pageHeight) {
	      pdf.setFillColor(127, 127, 127);
	      var top = pageHeight - 12;
	      pdf.rect(0, top, 210, 15, "F");
	      pdf.addImage((0, _utility.pdfReportFooterDataUri)(), "PNG", 15, top + 3, 20, 0);
	      pdf.setTextColor(255, 255, 255);
	      pdf.setFontSize(9);
	      pdf.setFontType("bold");
	      pdf.text(65, top + 6, "Copyright © " + (0, _momentTimezone2.default)().format("YYYY") + " Claritas, LLC. All rights reserved");
	    }
	  }, {
	    key: "fileName",
	    value: function fileName(type) {
	      var _props3 = this.props,
	          client_tags = _props3.client_tags,
	          websiteId = _props3.websiteId,
	          dayRange = _props3.dayRange;
	
	      var page = (0, _utility.getUrlParameterByName)("page");
	
	      var tag = client_tags ? client_tags.find(function (it) {
	        return it.id === websiteId;
	      }) : null;
	      var domain = tag && tag.domain ? tag.domain : "Unknown";
	      var dayRangeTitle = (0, _utility.getDayRangeTitle)(dayRange).replace(/\s+/g, "");
	      var time = (0, _momentTimezone2.default)().format("YYYYMMDD");
	      return page ? domain + "_" + page + "_" + dayRangeTitle + "_" + type + "_" + time : domain + "_" + dayRangeTitle + "_" + type + "_" + time;
	    }
	  }, {
	    key: "handlePdfDownload",
	    value: function handlePdfDownload() {
	      this.setState({
	        onPdfReportDownload: true,
	        showDownloadDialog: false
	      });
	      var _props4 = this.props,
	          clients = _props4.clients,
	          client_info = _props4.client_info,
	          websiteId = _props4.websiteId,
	          dayRange = _props4.dayRange,
	          client_sites = _props4.client_sites;
	      var _state = this.state,
	          type = _state.type,
	          ppType = _state.ppType,
	          measure = _state.measure,
	          segmentTop = _state.segmentTop;
	
	      var page = (0, _utility.getUrlParameterByName)("page");
	      var measureTitle = measure === "hh" ? "HH_Visitors" : "Index";
	      var reportType = "PRIZM Premier";
	      var segmentDistributionSystems = this.props.segmentDistributionSystems;
	
	      var system = (0, _find2.default)(segmentDistributionSystems, function (s) {
	        return parseInt(s.id, 10) === parseInt(type, 10);
	      });
	      if (system) reportType = system.name;
	
	      var deviceType = ppType === "detail" ? "Segments" : "Devices";
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	      var s = client_sites.find(function (site) {
	        return site.value === websiteId;
	      });
	      /*
	      let pdfFileName =
	        s && s.label
	          ? s.label +
	            "_" +
	            getDayRangeTitle(dayRange) +
	            "_" +
	            reportType +
	            "_" +
	            measureTitle +
	            "_"
	          : "Unknown_" +
	            getDayRangeTitle(dayRange) +
	            "_" +
	            reportType +
	            "_" +
	            measureTitle +
	            "_";
	      if (page) {
	        pdfFileName += page + "-";
	      }
	      pdfFileName += moment().format("YYYYMMDD") + ".pdf";*/
	      var pdfFileName = this.fileName(reportType + "-" + measureTitle) + ".pdf";
	      var chartXTitle = document.getElementById("chart-x-title");
	      chartXTitle && (chartXTitle.style.display = "block");
	      var el_left_nav = document.getElementById("left-nav");
	      var el_contact_div = document.getElementById("contact-div");
	      var el_report_main = document.getElementById("report-main");
	      var el_segment_household_container = document.getElementsByClassName("segment-household-nav-container")[0];
	      var el_segment_household_pdf_container = document.getElementsByClassName("sgemnt-household-pdf-nav")[0];
	      var el_top_navigator = document.getElementsByClassName("top-navigator")[0];
	      var segment_detail_container = document.getElementsByClassName("segment-detail-container")[0];
	      var device_report_container = document.getElementById("device-report-container");
	      var segment_culture_container = document.getElementsByClassName("segment-culture-report")[0];
	      var extra_print_container = document.getElementsByClassName("pdf-extra-container");
	      var hidden_print_container = document.getElementsByClassName("pdf-hidden-container");
	      var highest_audience_container = document.getElementsByClassName("hightest-audience-list")[0];
	      if (segmentTop === 0) {
	        highest_audience_container.style.height = "auto";
	      }
	      for (var i = 0; i < extra_print_container.length; i++) {
	        extra_print_container[i].style.display = "block";
	      }
	      for (var i = 0; i < hidden_print_container.length; i++) {
	        hidden_print_container[i].style.display = "none";
	      }
	      var origin_segment_container_display = segment_detail_container.style.display;
	      var origin_device_container_display = device_report_container.style.display;
	      var origin_segment_culture_container_display = segment_culture_container.style.display;
	      device_report_container.style.display = "flex";
	      segment_detail_container.style.display = "flex";
	      segment_culture_container.style.display = "flex";
	      var pageHeight = ppType === "detail" ? el_report_main.offsetHeight / (el_report_main.offsetWidth / 205) : el_report_main.offsetHeight / (el_report_main.offsetWidth / 213);
	      var pdf = new pdfConverter("p", "mm", [210, pageHeight]);
	      (0, _utility.addPdfFont)(pdf);
	      pdf.setFont("Helvetica");
	      pdf.setFontType("normal");
	      pdf.setFontSize(9);
	      var pageWidth = 186;
	      document.getElementsByClassName("prizm-premier-inactive")[0].style.display = "none";
	      el_report_main.style.flex = "0 1";
	      el_left_nav.style.display = "none";
	      el_contact_div.style.display = "none";
	      el_segment_household_pdf_container.style.display = "flex";
	      el_segment_household_container.style.display = "none";
	      el_top_navigator.style.display = "none";
	      //el_report_main.style.width = "1024px";
	      var mainCanvas = null;
	      var isMainCanvas = false;
	      setTimeout(function () {
	        html2canvas(el_report_main, { logging: false }).then(function (canvas) {
	          mainCanvas = canvas;
	          isMainCanvas = true;
	          el_left_nav.style.display = "block";
	          el_contact_div.style.display = "block";
	          document.getElementsByClassName("prizm-premier-inactive")[0].style.display = "block";
	          el_report_main.style.flex = "1 0";
	          el_segment_household_pdf_container.style.display = "none";
	          el_segment_household_container.style.display = "flex";
	          el_top_navigator.style.display = "flex";
	          device_report_container.style.display = origin_device_container_display;
	          segment_detail_container.style.display = origin_segment_container_display;
	          segment_culture_container.style.display = origin_segment_culture_container_display;
	          if (segmentTop === 0) {
	            highest_audience_container.style.height = "650px";
	          }
	          for (var i = 0; i < extra_print_container.length; i++) {
	            extra_print_container[i].style.display = "none";
	          }
	          for (var i = 0; i < hidden_print_container.length; i++) {
	            hidden_print_container[i].style.display = "block";
	          }
	        });
	      }, 2000);
	      var top = 32;
	      var left = 12;
	      var intervalId = setInterval(function () {
	        if (isMainCanvas === false) {
	          console.log("PDF Generating...");
	        } else {
	          clearInterval(intervalId);
	          setTimeout(function () {
	            this._addPdfHeader(pdf, client_name, bu_name);
	            var start = left;
	            pdf.setFontType("bold");
	            pdf.text(start, top, "WEBSITE NAME:");
	            start += 30;
	            pdf.setFontType("normal");
	            pdf.text(start, top, s && s.label ? s.label.trim() : "");
	            start += s && s.label ? (0, _utility.getTextSize)(s.label.trim(), "helvetica").width * 0.3937 + 0.4 : 1;
	            pdf.setFontType("bold");
	            pdf.text(start, top, "Date:");
	            pdf.setFontType("normal");
	            start += (0, _utility.getTextSize)("Date:", "helvetica").width * 0.3937 + 0.4;
	            pdf.text(start, top, (0, _utility.getDayRangeTitle)(dayRange));
	            pdf.setFillColor(221, 245, 243);
	            top += 5;
	            pdf.rect(left, top, 185, 10, "F");
	            pdf.setFontType("bold");
	            pdf.setFontSize(11);
	            if (page) {
	              pdf.setFontSize(9);
	              pdf.text(15, top + 6, page);
	              pdf.setFontSize(10);
	              pdf.setFont("Proxima-Nova");
	              // pdf.setFontType("normal");
	              // if (ppType === "detail")
	              pdf.text(195, top + 6, reportType + " Segment Distribution", null, null, "right");
	              // else
	              //   pdf.text(
	              //     195,
	              //     top + 6,
	              //     reportType + " Segment Distribution", //  - Device Details",
	              //     null,
	              //     null,
	              //     "right",
	              //   );
	              pdf.setFontSize(11);
	            } else {
	              pdf.setFont("Proxima-Nova");
	              // pdf.setFontType("normal");
	              // if (ppType === "detail")
	              pdf.text(15, top + 6, reportType + " Segment Distribution");
	              // else
	              //   pdf.text(
	              //     15,
	              //     top + 6,
	              //     reportType + " Segment Distribution", //  - Device Details",
	              //   );
	            }
	            pdf.setFont("Helvetica");
	            pdf.setFontType("normal");
	            pdf.setFontSize(10);
	            top += 10;
	            pdf.addImage(mainCanvas.toDataURL(), "PNG", left, top, pageWidth, 0);
	
	            this._addPdfFooter(pdf, pageHeight);
	
	            pdf.save(pdfFileName.replace(/ /g, "_"));
	            chartXTitle && (chartXTitle.style.display = "none");
	            this.setState({ onPdfReportDownload: false });
	          }.bind(this), 100);
	        }
	      }.bind(this), 50);
	    }
	  }, {
	    key: "handleCsvDownload",
	    value: function handleCsvDownload() {
	      this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	      var page = (0, _utility.getUrlParameterByName)("page");
	      var _props5 = this.props,
	          clients = _props5.clients,
	          client_info = _props5.client_info,
	          websiteId = _props5.websiteId,
	          dayRange = _props5.dayRange,
	          client_sites = _props5.client_sites,
	          cultureCodeReport = _props5.cultureCodeReport;
	      var _state2 = this.state,
	          type = _state2.type,
	          ppType = _state2.ppType,
	          measure = _state2.measure;
	
	      var measureTitle = measure === "hh" ? "HH_Visitors" : "Index";
	      var reportType = "PRIZM Premier";
	      var segmentDistributionSystems = this.props.segmentDistributionSystems;
	
	      var system = (0, _find2.default)(segmentDistributionSystems, function (s) {
	        return parseInt(s.id, 10) === parseInt(type, 10);
	      });
	      if (system) reportType = system.name;
	
	      var deviceType = ppType === "detail" ? "Segments" : "Devices";
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _find2.default)(clients, function (c) {
	          return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	      var hhDataSet = [];
	      var segmentDistributionHouseHold = this.props.segmentDistributionHouseHold;
	
	      (0, _map2.default)(segmentDistributionHouseHold.distributions, function (dist) {
	        measure === "hh" ? hhDataSet.push({
	          segmentCode: dist.segmentCode,
	          segmentName: dist.segmentName,
	          householdPect: dist.householdPercentage,
	          vistorPect: dist.householdVisitors / segmentDistributionHouseHold.totalHouseholdVisitors
	        }) : hhDataSet.push({
	          segmentCode: dist.segmentCode,
	          segmentName: dist.segmentName,
	          householdPect: dist.householdPercentage,
	          vistorPect: dist.householdVisitors / segmentDistributionHouseHold.totalHouseholdVisitors,
	          segmentIndex: dist.segmentIndex
	        });
	      });
	      var sortedDS = measure === "hh" ? (0, _sortBy2.default)(hhDataSet, function (d) {
	        return d.vistorPect;
	      }).reverse() : (0, _sortBy2.default)(hhDataSet, function (d) {
	        return d.segmentIndex;
	      }).reverse();
	      var s = client_sites.find(function (site) {
	        return site.value === websiteId;
	      });
	      var csvFileName = s && s.label ? s.label + "_" + (0, _utility.getDayRangeTitle)(dayRange) + "_" + reportType + "_" + measureTitle + "_" : "Unknown_" + (0, _utility.getDayRangeTitle)(dayRange) + "_" + reportType + "_" + measureTitle + "_";
	      if (page) {
	        csvFileName += page + "-";
	      }
	      csvFileName += (0, _momentTimezone2.default)().format("YYYYMMDD");
	      var title_line = "Report Details,\r\n";
	      /*
	      let report_name_line =
	        ppType === "detail"
	          ? s.label + " " + reportType + " Segment Distribution Report"
	          : s.label + " " + reportType + " Device Insights Report";*/
	      var report_name_line = s.label + " " + reportType + " Segment Distribution Report";
	
	      report_name_line += ",\r\n";
	      var report_date_line = "Date," + (0, _momentTimezone2.default)().format("MM/DD/YY") + ",\r\n";
	      var client_name_line = "Client Name," + client_name + ",\r\n";
	      var bu_name_line = (0, _isEmpty2.default)(bu_name) ? "" : "Business Name," + bu_name + ",\r\n";
	      var date_filter_line = "Campaign Date Filter," + (0, _utility.getDayRangeTitle)(dayRange) + ",\r\n";
	      var page_name_line = page ? "Page, " + page + ",\r\n" : "";
	      var measure_line = measure == "hh" ? "Measure, Household Visitors,\r\n\r\n" : "Measure, Index,\r\n\r\n";
	      var total_households_matched_line = "Total U.S Households Matched to " + reportType + " Segments" +
	      /*deviceType +*/
	      "," + this.props.segmentDistributionHouseHold.totalHouseholdVisitors + ",\r\n\r\n";
	      var highest_oppo_audience_line = measure === "hh" ? "Highest Opportunity Audiences,,\r\nCode,Segment Name,Segment % of U.S Households,% of HH Visitors\r\n" : "Highest Opportunity Audiences,,\r\nCode,Segment Name,Segment % of U.S Households,% of HH Visitors,Index\r\n";
	      var segment_visitors_arr = [];
	      var hhPect = 0;
	      var vistPect = 0;
	      (0, _map2.default)(sortedDS, function (dist) {
	        hhPect += dist.householdPect;
	        vistPect += dist.vistorPect;
	        var str = dist.segmentCode + ',"' + dist.segmentName + '",' + dist.householdPect.toLocaleString(undefined, {
	          style: "percent",
	          minimumFractionDigits: 2
	        }) + "," + dist.vistorPect.toLocaleString(undefined, {
	          style: "percent",
	          minimumFractionDigits: 2
	        }) + ",";
	        if (measure !== "hh") {
	          str += dist.segmentIndex + ",";
	        }
	        str += "\r\n";
	        segment_visitors_arr.push(str);
	      });
	      if (vistPect > 0) {
	        var totalStr = "Total,," + hhPect.toLocaleString(undefined, {
	          style: "percent",
	          minimumFractionDigits: 2
	        }) + "," + vistPect.toLocaleString(undefined, {
	          style: "percent",
	          minimumFractionDigits: 2
	        }) + ",";
	        if (measure !== "hh") {
	          totalStr += parseInt(vistPect / hhPect * 100, 10);
	          totalStr += ",";
	        }
	        totalStr += "\r\n";
	        segment_visitors_arr.push(totalStr);
	      }
	
	      var props = this.props;
	
	      var resultString = title_line + report_name_line + report_date_line + client_name_line + bu_name_line + date_filter_line + page_name_line + measure_line + total_households_matched_line + highest_oppo_audience_line + segment_visitors_arr.join("");
	      var granularity = this.props.granularity ? this.props.granularity : this.state.granularity;
	      resultString += "\r\n\r\nGranularity," + granularity.charAt(0).toUpperCase() + granularity.slice(1) + "\r\n\r\n";
	      resultString += (0, _pdfHelper._getSegmentDistributeCsv)(props, this.state.segmentTop);
	      resultString += "\r\n\r\nDevice Insights,\r\n";
	      resultString += (0, _pdfHelper._getDeviceDistributeCsv)(props, this.state.segmentTop);
	      resultString += "\r\n\r\nCulture Codes,\r\n";
	      resultString += (0, _pdfHelper._getCultureCsv)(props);
	      (0, _utility.downLoadCSVFunc)(resultString, csvFileName.replace(new RegExp(" ", "g"), "_"));
	      setTimeout(function () {
	        this.setState({ onCsvReportDownload: false });
	      }.bind(this), 2000);
	    }
	  }, {
	    key: "cbPDFChange",
	    value: function cbPDFChange(e, isInputChecked) {
	      var result = !this.refs.cbCSV.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: "cbCSVChange",
	    value: function cbCSVChange(e, isInputChecked) {
	      var result = !this.refs.cbPDF.state.switched && !isInputChecked;
	      this.setState({ disabledBtnDownload: result });
	    }
	  }, {
	    key: "downloadCsvReport",
	    value: function downloadCsvReport() {
	      this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	      this.handleCsvDownload();
	    }
	  }, {
	    key: "downloadPdfReport",
	    value: function downloadPdfReport() {
	      this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
	      this.handlePdfDownload();
	    }
	  }, {
	    key: "handleDownload",
	    value: function handleDownload(e) {
	      e.preventDefault();
	
	      if (this.refs.cbPDF.state.switched) {
	        this.downloadPdfReport();
	      }
	
	      if (this.refs.cbCSV.state.switched) {
	        this.downloadCsvReport();
	      }
	    }
	  }, {
	    key: "getTabTitleContent",
	    value: function getTabTitleContent(tabType, topCountTitle) {
	      var segmentDistributionSystems = this.props.segmentDistributionSystems;
	
	      var type = this.state.type === "default" ? (0, _utility.getUrlParameterByName)("type") : this.state.type;
	      var system = (0, _find2.default)(segmentDistributionSystems, function (s) {
	        return parseInt(s.id, 10) === parseInt(type, 10);
	      });
	      if (system) {
	        var sysType = system.name;
	        var arr = sysType.split(" ");
	        if (arr.length > 0 && arr[0] !== "Purple") {
	          return _react2.default.createElement(
	            "span",
	            null,
	            topCountTitle,
	            " ",
	            arr[0],
	            _react2.default.createElement("i", { className: "symbol symbol-tm" }),
	            " ",
	            arr[1],
	            " ",
	            tabType,
	            " Details"
	          );
	        } else {
	          return _react2.default.createElement(
	            "span",
	            null,
	            topCountTitle,
	            " ",
	            sysType,
	            _react2.default.createElement("i", { className: "symbol symbol-tm" }),
	            " ",
	            tabType,
	            " Details"
	          );
	        }
	      }
	      return _react2.default.createElement(
	        "span",
	        null,
	        topCountTitle,
	        " Details"
	      );
	
	      switch (this.state.type) {
	        case "prizm_premier":
	          return _react2.default.createElement(
	            "span",
	            null,
	            topCountTitle,
	            " PRIZM Premier",
	            _react2.default.createElement("i", { className: "symbol symbol-tm" }),
	            " ",
	            tabType,
	            " Details"
	          );
	        case "psycle_premier":
	          return _react2.default.createElement(
	            "span",
	            null,
	            topCountTitle,
	            " P$YCLE Premier",
	            _react2.default.createElement("i", { className: "symbol symbol-tm" }),
	            " ",
	            tabType,
	            " Details"
	          );
	        default:
	          return _react2.default.createElement(
	            "span",
	            null,
	            topCountTitle,
	            " ConneXions",
	            _react2.default.createElement("i", { className: "symbol symbol-tm" }),
	            " ",
	            tabType,
	            " Details"
	          );
	      }
	    }
	  }, {
	    key: "showPageNavigation",
	    value: function showPageNavigation(urlParams) {
	      var _this8 = this;
	
	      var page = (0, _utility.getUrlParameterByName)("page");
	      var tagId = this.getTagId();
	      var cid = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      var type = (0, _utility.getUrlParameterByName)("type");
	      var source = (0, _utility.getUrlParameterByName)("source");
	      var heatmap = (0, _utility.getUrlParameterByName)("heatmap");
	
	      if (page) {
	        return _react2.default.createElement(
	          "div",
	          { className: "pt-20", style: { fontSize: "16px" } },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              {
	                className: "nav-clickable",
	                onClick: function onClick() {
	                  {
	                    /*window.location.href = type
	                    ? "/segment-distribution?tag=" +
	                      tagId +
	                      "&cid=" +
	                      cid +
	                      "&type=" +
	                      type
	                    : "/segment-distribution?tag=" + tagId + "&cid=" + cid;*/
	                  }
	                  _this8.props.history.push(type ? "/segment-distribution?tag=" + tagId + "&cid=" + cid + "&type=" + type : "/segment-distribution?tag=" + tagId + "&cid=" + cid);
	                }
	              },
	              "Segment Distribution"
	            ),
	            _react2.default.createElement(
	              "span",
	              { style: { margin: "0 15px" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                ">"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              {
	                className: "nav-clickable",
	                onClick: function onClick() {
	                  _this8.props.history.push(source === "fav" ? "/distribution/pages/favorite?cid=" + cid + "&tag=" + tagId + "&type=" + type : "/distribution/pages/popular?cid=" + cid + "&tag=" + tagId + "&type=" + type);
	                }
	              },
	              source === "fav" ? "Favorite Pages" : "Most Popular Page"
	            ),
	            _react2.default.createElement(
	              "span",
	              { style: { margin: "0 15px" } },
	              ">"
	            ),
	            heatmap && [_react2.default.createElement(
	              "span",
	              {
	                className: "nav-clickable",
	                onClick: function onClick() {
	                  delete urlParams["heatmap"];
	                  _this8.props.history.push(("/segment-distribution" + _querystring2.default.stringify(urlParams)).replace("%3F", "?"));
	                }
	              },
	              page
	            ), _react2.default.createElement(
	              "span",
	              { style: { margin: "0 15px" } },
	              ">"
	            ), _react2.default.createElement(
	              "span",
	              null,
	              "Top states on map"
	            )]
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                padding: "15px 20px",
	                marginTop: "20px",
	                background: "#BAE7FF"
	              }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              page
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "light-grey-border-bottom" },
	            "\xA0"
	          )
	        );
	      } else if (heatmap) {
	        return _react2.default.createElement(
	          "div",
	          { className: "pt-20", style: { fontSize: "16px" } },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              {
	                className: "nav-clickable",
	                onClick: function onClick() {
	                  {
	                    /*window.location.href = type
	                    ? "/segment-distribution?tag=" +
	                    tagId +
	                    "&cid=" +
	                    cid +
	                    "&type=" +
	                    type
	                    : "/segment-distribution?tag=" + tagId + "&cid=" + cid;*/
	                  }
	                  _this8.props.history.push(type ? "/segment-distribution?tag=" + tagId + "&cid=" + cid + "&type=" + type : "/segment-distribution?tag=" + tagId + "&cid=" + cid);
	                }
	              },
	              "Segment Distribution"
	            ),
	            _react2.default.createElement(
	              "span",
	              { style: { margin: "0 15px" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                ">"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              "Top states on map"
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: "saveAudience",
	    value: function saveAudience() {
	      var _this9 = this;
	
	      var tagId = this.getTagId();
	      console.log('props.granularity = ' + this.props.granularity);
	      console.log('state.granularity = ' + this.state.granularity);
	      var granularity = this.props.granularity || this.state.granularity;
	      var segmentDistributionHouseHold = this.props.segmentDistributionHouseHold;
	
	      var page = (0, _utility.getUrlParameterByName)("page");
	
	      if (this.state.segmentTop === 0 || !segmentDistributionHouseHold) {
	        if (this.state.audienceType === "scale") {
	          this.props.createScaleAudience(this.state.audienceName, tagId, this.state.type, this.props.dayRange, []);
	        } else {
	          this.props.createVisitorAudience(this.state.audienceName, tagId, this.state.type, this.props.dayRange, [], granularity, page);
	        }
	      } else {
	        var data = segmentDistributionHouseHold.distributions;
	        var segmentIds = (0, _map2.default)((0, _sortBy2.default)(data, function (d) {
	          if (_this9.state.measure === "index") return d.segmentIndex;else return d.householdVisitors / segmentDistributionHouseHold.totalHouseholdVisitors;
	        }), "segmentCode").reverse().slice(0, this.state.segmentTop).join(",");
	        if (this.state.audienceType === "scale") {
	          this.props.createScaleAudience(this.state.audienceName, tagId, this.state.type, this.props.dayRange, segmentIds);
	        } else {
	          this.props.createVisitorAudience(this.state.audienceName, tagId, this.state.type, this.props.dayRange, segmentIds, granularity, page);
	        }
	      }
	    }
	  }, {
	    key: "onWebSiteIdChanged",
	    value: function onWebSiteIdChanged(id) {
	      var _this10 = this;
	
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      this.props.setWebsiteId(id);
	      this.props.getSegmentDistributionSystems(id, function (segmentDistributionSystems) {
	        var type = segmentDistributionSystems && segmentDistributionSystems[0] ? segmentDistributionSystems[0].id : _this10.state.type;
	        var url = "/segment-distribution?cid=" + clientId + "&tag=" + id + "&type=" + type;
	        window.location.href = url;
	      });
	
	      // window.location.href =
	      //   "/segment-distribution?cid=" +
	      //   clientId +
	      //   "&tag=" +
	      //   id +
	      //   "&type=" +
	      //   this.state.type;
	    }
	  }, {
	    key: "renderLeftRailMenu",
	    value: function renderLeftRailMenu(urlParams) {
	      var _this11 = this;
	
	      var segmentDistributionSystems = this.props.segmentDistributionSystems;
	
	      delete urlParams["heatmap"];
	      return _react2.default.createElement(
	        "div",
	        { className: "light-grey-border" },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              height: "48px",
	              padding: "15px 20px",
	              position: "relative",
	              background: "#F5F5F5"
	            }
	          },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Segment Distribution"
	          )
	        ),
	        (0, _map2.default)(segmentDistributionSystems, function (sys) {
	          return _react2.default.createElement(
	            "div",
	            {
	              key: sys.id,
	              onClick: function onClick() {
	                if (parseInt(_this11.state.type, 10) !== sys.id) {
	                  _this11.setState({
	                    type: parseInt(sys.id, 10),
	                    showEmptyError: false
	                  });
	                  urlParams["type"] = parseInt(sys.id);
	                  _this11.props.history.push(("/segment-distribution" + _querystring2.default.stringify(urlParams)).replace("%3F", "?"));
	                  _this11.getSegmentDistributionData(undefined, sys.id, undefined);
	                  _this11.props.clearCreateScaleAudienceInfo();
	                  _this11.props.clearCreateVisitorsAudienceInfo();
	                }
	              },
	              style: { height: "58px", padding: "15px 20px 15px 35px" },
	              className: parseInt(_this11.state.type, 10) === sys.id || _this11.state.type === "default" && sys.id === segmentDistributionSystems[0].id ? "distribution-type-active" : "distribution-type"
	            },
	            sys.name.split(" ").length > 0 && sys.name.split(" ")[0] !== "Purple" ? _react2.default.createElement(
	              "span",
	              null,
	              sys.name.split(" ")[0],
	              _react2.default.createElement("i", { className: "symbol symbol-tm" }),
	              " ",
	              sys.name.split(" ")[1]
	            ) : _react2.default.createElement(
	              "span",
	              null,
	              sys.name,
	              _react2.default.createElement("i", { className: "symbol symbol-tm" })
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: "getAudienceName",
	    value: function getAudienceName(type) {
	      var _props6 = this.props,
	          websiteId = _props6.websiteId,
	          dayRange = _props6.dayRange,
	          client_sites = _props6.client_sites,
	          segmentDistributionSystems = _props6.segmentDistributionSystems;
	
	      var reportType = "PRIZM Premier";
	      var paramType = (0, _utility.getUrlParameterByName)("type");
	      var system = (0, _find2.default)(segmentDistributionSystems, function (s) {
	        return parseInt(s.id, 10) === parseInt(paramType, 10);
	      });
	      var source = (0, _utility.getUrlParameterByName)("source");
	      var page = (0, _utility.getUrlParameterByName)("page");
	      if (system) reportType = system.name;
	      var s = client_sites.find(function (site) {
	        return site.value === websiteId;
	      });
	      var audienceName = s && s.label ? s.label + "_" : "";
	      if ((source === "pop" || source === "fav") && page) {
	        audienceName += page.replace(/[/. ]/g, "_") + "_";
	      }
	      if (type === "scale") {
	        audienceName += "at_scale_";
	      } else {
	        audienceName += "website_visitors_";
	      }
	      audienceName += (0, _utility.getDayRangeTitle)(dayRange);
	      audienceName += "_" + reportType;
	      audienceName += this.state.segmentTop === 0 ? "_allSeg" : "_top" + this.state.segmentTop + "Seg";
	      audienceName += "_" + (0, _momentTimezone2.default)().format("YYYYMMDD");
	
	      return audienceName.replace(new RegExp(" ", "g"), "_");
	    }
	  }, {
	    key: "handleAudienceTypeChange",
	    value: function handleAudienceTypeChange(e, value) {
	      this.setState({
	        audienceName: this.getAudienceName(value),
	        audienceType: value
	      });
	    }
	  }, {
	    key: "granularityChangeHandle",
	    value: function granularityChangeHandle() {
	      var _props7 = this.props,
	          websiteId = _props7.websiteId,
	          dayRange = _props7.dayRange,
	          segmentDistributionHouseHold = _props7.segmentDistributionHouseHold,
	          granularity = _props7.granularity;
	      var _state3 = this.state,
	          type = _state3.type,
	          measure = _state3.measure,
	          segmentTop = _state3.segmentTop;
	
	      var page = (0, _utility.getUrlParameterByName)("page");
	      var tagId = this.getTagId();
	      var heatmap = (0, _utility.getUrlParameterByName)("heatmap");
	      var segmentIds = (0, _map2.default)((0, _sortBy2.default)(segmentDistributionHouseHold.distributions, function (d) {
	        if (measure === "index") return d.segmentIndex;else return d.householdVisitors / segmentDistributionHouseHold.totalHouseholdVisitors;
	      }), "segmentCode").reverse().slice(0, segmentTop).join(",");
	      this.props.getSegmentDistributionDetailReport(tagId || websiteId, type, dayRange, undefined, page, granularity);
	
	      if (!heatmap) {
	        this.props.getCultureCodeReport(tagId, type, dayRange, segmentIds, page, granularity);
	      } else {
	        this.props.getDistributionHeatMapData(tagId, type, dayRange, segmentIds, page, granularity);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this12 = this;
	
	      var _props8 = this.props,
	          websiteId = _props8.websiteId,
	          setDateRange = _props8.setDateRange,
	          dayRange = _props8.dayRange,
	          granularity = _props8.granularity,
	          setGranularity = _props8.setGranularity,
	          client_sites = _props8.client_sites,
	          savingScaleAudience = _props8.savingScaleAudience,
	          savingScaleAudienceResult = _props8.savingScaleAudienceResult,
	          savingScaleAudienceError = _props8.savingScaleAudienceError,
	          savingVisitorsAudienceResult = _props8.savingVisitorsAudienceResult,
	          savingVisitorsAudienceError = _props8.savingVisitorsAudienceError,
	          savingVisitorsAudience = _props8.savingVisitorsAudience,
	          segmentDistributionHouseHold = _props8.segmentDistributionHouseHold,
	          segmentDistributionSystems = _props8.segmentDistributionSystems;
	
	      var tagId = this.getTagId();
	      var clientId = (0, _utility.getUrlParameterByName)("cid") ? parseInt((0, _utility.getUrlParameterByName)("cid"), 10) : this.props.websiteId;
	
	      var page = (0, _utility.getUrlParameterByName)("page");
	      var type = (0, _utility.getUrlParameterByName)("type");
	      var urlParams = _querystring2.default.parse(this.props.location.search);
	      var topCountTitle = this.state.segmentTop === 0 ? "All " : "Top " + this.state.segmentTop + " ";
	      var heatmap = (0, _utility.getUrlParameterByName)("heatmap");
	      var source = (0, _utility.getUrlParameterByName)("source");
	      var randomStr = new Date().getTime();
	      var heatMapData = [];
	      if (heatmap) {
	        (0, _map2.default)(this.props.distributionHeatmapData, function (point) {
	          heatMapData.push({
	            position: [point.lon, point.lat],
	            weight: parseInt(point.u, 10)
	          });
	        });
	      }
	      return _react2.default.createElement(
	        "div",
	        { id: "segment-distribution-container" },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              margin: "-20px 10% 0px",
	              fontSize: "16px"
	            }
	          },
	          this.showPageNavigation(urlParams),
	          _react2.default.createElement(_SiteDateSelector2.default, {
	            type: "larger",
	            key: "segment-distribution-site-selector-" + new Date().getTime(),
	            websiteIdChanged: page ? undefined : this.onWebSiteIdChanged.bind(this),
	            siteId: tagId ? tagId : websiteId,
	            sites: client_sites,
	            dayRangeChanged: setDateRange,
	            dayRange: dayRange /*
	                               granularity={granularity}
	                               granularityChanged={setGranularity}*/
	            , handlePdfDownload: heatmap ? null : function () {
	              return _this12.setState({ showDownloadDialog: true });
	            },
	            handleSegmentCreation: segmentDistributionHouseHold && !(0, _isEmpty2.default)(segmentDistributionHouseHold.distributions) && !this.state.showEmptyError ? tagId && !heatmap ? function () {
	              _this12.setState({
	                audienceName: _this12.getAudienceName(_this12.state.audienceType),
	                showCreateAudienceDialog: true
	              });
	            } : null : null,
	            downloadBtnText: heatmap ? null : "Download Report"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", padding: "10px 10%", fontSize: "16px" } },
	          _react2.default.createElement(
	            "div",
	            { id: "left-nav", style: { flex: "0 0 220px" } },
	            this.renderLeftRailMenu(urlParams),
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border mt-20" },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    height: "48px",
	                    padding: "15px 20px",
	                    position: "relative",
	                    background: "#F5F5F5"
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Page Insights"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  onClick: function onClick() {
	                    type ? _this12.props.history.push("/distribution/pages/popular?tag=" + tagId + "&cid=" + clientId + "&type=" + type) : _this12.props.history.push("/distribution/pages/popular?tag=" + tagId + "&cid=" + clientId);
	                  },
	                  style: { height: "58px", padding: "15px 20px 15px 35px" },
	                  className: "distribution-type"
	                },
	                "Most Popular Pages"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  onClick: function onClick() {
	                    type ? _this12.props.history.push("/distribution/pages/favorite?tag=" + tagId + "&cid=" + clientId + "&type=" + type) : _this12.props.history.push("/distribution/pages/favorite?tag=" + tagId + "&cid=" + clientId);
	                  },
	                  style: { height: "58px", padding: "15px 20px 15px 35px" },
	                  className: "distribution-type"
	                },
	                "Favorite Pages"
	              )
	            )
	          ),
	          this.props.segmentDistributionHouseHold && !(0, _isEmpty2.default)(this.props.segmentDistributionHouseHold.distributions) ? _react2.default.createElement(
	            "div",
	            {
	              id: "report-main",
	              className: "ml-20",
	              style: { width: "100%", flex: "1 0" }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "light-grey-border text-center p-10",
	                id: "contact-div"
	              },
	              _react2.default.createElement(
	                "small",
	                {
	                  onClick: function onClick() {
	                    _this12.setState({ openContactUs: true });
	                  },
	                  className: "link"
	                },
	                "Click here"
	              ),
	              " ",
	              "to engage and activate these audiences across online and offline channels."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "mt-20" },
	              this.props.segmentDistributionHouseHold && _react2.default.createElement(_SegmentHouseHold2.default, {
	                data: this.props.segmentDistributionHouseHold.distributions,
	                systems: this.props.segmentDistributionSystems,
	                totalHouseholdVisitors: this.props.segmentDistributionHouseHold.totalHouseholdVisitors,
	                totalVisits: this.props.segmentDistributionHouseHold.totalVisits,
	                zip9Households: this.props.segmentDistributionHouseHold.zip9Households,
	                zip11Households: this.props.segmentDistributionHouseHold.zip11Households,
	                type: this.state.type,
	                measure: this.state.measure,
	                topCount: this.state.segmentTop,
	                changeMeasure: this.changeMeasure.bind(this),
	                changeTopCount: this.changeTopCount.bind(this)
	              })
	            ),
	            heatmap && _react2.default.createElement(_HeatMap2.default, {
	              key: "overview-geographic-" + randomStr,
	              width: 960,
	              height: 600,
	              title: "Geographic Traffic",
	              data: null,
	              onLoading: this.props.distributionHeatmapLoading,
	              pointsData: heatMapData
	            }),
	            !heatmap && _react2.default.createElement(
	              "div",
	              { className: "mt-20" },
	              this.props.loadingSegmentDistribution && _react2.default.createElement(
	                "div",
	                {
	                  className: "text-center",
	                  style: { height: "350px", marginTop: "120px" }
	                },
	                _react2.default.createElement("img", {
	                  alt: "",
	                  src: "/Spinner.gif",
	                  style: { height: "48px" }
	                })
	              ),
	              this.props.segmentDistributionHouseHold && _react2.default.createElement(_HighestOpportunityAudience2.default, {
	                orderType: this.state.measure,
	                type: this.state.type === "default" ? (0, _utility.getUrlParameterByName)("type") : this.state.type,
	                systems: this.props.segmentDistributionSystems,
	                data: this.props.segmentDistributionHouseHold.distributions,
	                total: this.props.segmentDistributionHouseHold.totalHouseholdVisitors,
	                topCount: this.state.segmentTop,
	                printMode: this.state.printMode
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "mt-20 light-grey-border-bottom top-navigator",
	                style: {
	                  display: heatmap ? "none" : "flex",
	                  fontSize: "16px"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: this.state.ppType == "detail" ? "light-grey-border prizm-premier-active" : "light-grey-border prizm-premier-inactive",
	                  onClick: function onClick() {
	                    _this12.setState({ ppType: "detail" });
	                  },
	                  style: { width: "auto" }
	                },
	                this.getTabTitleContent("Segment", topCountTitle)
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: this.state.ppType == "device" ? "light-grey-border prizm-premier-active" : "light-grey-border prizm-premier-inactive",
	                  onClick: function onClick() {
	                    _this12.setState({ ppType: "device" });
	                  },
	                  style: { width: "auto" }
	                },
	                this.getTabTitleContent("Device", topCountTitle)
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: this.state.ppType == "culture" ? "light-grey-border prizm-premier-active" : "light-grey-border prizm-premier-inactive",
	                  onClick: function onClick() {
	                    {
	                      /*this.getCultureReport();*/
	                    }
	                    _this12.setState({
	                      ppType: "culture"
	                    });
	                  },
	                  style: { width: "auto" }
	                },
	                "Culture Codes"
	              )
	            ),
	            heatmap ? [] : [_react2.default.createElement(_SegmentDetailReport2.default, { key: "segment-detail-report",
	              style: {
	                display: this.state.ppType === "detail" ? "flex" : "none",
	                fontSize: "16px",
	                marginTop: "20px",
	                minWidth: "440px",
	                minHeight: "400px"
	              },
	              printTitle: this.getTabTitleContent("Segment", topCountTitle),
	              data: this.props.detailDistributionReport,
	              loading: this.props.loadingDistributionDetailReport
	            }), _react2.default.createElement(_SegmentDeviceReport2.default, { key: "segment-device-report",
	              printTitle: this.getTabTitleContent("Device", topCountTitle),
	              top5OSBreakDown: this.props.top5OSBreakDown,
	              loadingTop5OSBreakdown: this.props.loadingTop5OSBreakdown,
	              deviceModelData: this.props.deviceModelReport,
	              loadDeviceModelReport: this.props.loadDeviceModelReport,
	              deviceTypeData: this.props.deviceTypeReport,
	              loadDeviceTypeReport: this.props.loadDeviceTypeReport,
	              style: {
	                display: this.state.ppType === "device" ? "flex" : "none",
	                fontSize: "16px",
	                marginTop: "20px",
	                width: "100%",
	                minWidth: "440px",
	                minHeight: "400px"
	              }
	            }), _react2.default.createElement(_SegmentCultureReport2.default, { key: "segment-culture-report",
	              style: {
	                display: this.state.ppType === "culture" ? "flex" : "none"
	              },
	              data: this.props.cultureCodeReport,
	              onPdfReportDownload: this.state.onPdfReportDownload
	            })]
	          ) : _react2.default.createElement(
	            "div",
	            {
	              id: "report-main",
	              className: "ml-20",
	              style: { width: "100%", flex: "1 0" }
	            },
	            this.state.showEmptyError === true || !tagId ? _react2.default.createElement(
	              "div",
	              {
	                className: "light-grey-border text-center p-10",
	                id: "contact-div",
	                style: { color: "#DD0000" }
	              },
	              _react2.default.createElement(_svgIcons.AlertError, {
	                style: {
	                  fill: "#DD0000",
	                  width: "16px",
	                  height: "16px"
	                }
	              }),
	              " ",
	              "No data to display try a different date range"
	            ) : _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  textAlign: "center",
	                  fontSize: "24px",
	                  marginTop: "50px"
	                }
	              },
	              "Page loading...",
	              " ",
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            title: "Contact Us",
	            modal: false,
	            autoDetectWindowHeight: false,
	            autoScrollBodyContent: true,
	            titleStyle: { fontWeight: "bold", fontSize: "24px", padding: "20px" },
	            open: this.state.openContactUs,
	            onRequestClose: function onRequestClose() {
	              _this12.setState({ openContactUs: false });
	            },
	            bodyStyle: {
	              color: "#000",
	              fontWeight: "normal",
	              fontSize: "16px",
	              paddingTop: "0px",
	              paddingBottom: "20px",
	              textAlign: "left",
	              overflowY: "auto",
	              height: "1080px",
	              borderTop: "solid 0px #EEEFF2"
	            },
	            contentStyle: {
	              width: "960px",
	              maxWidth: "960px",
	              height: "1080px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  paddingBottom: "20px",
	                  marginBottom: "20px",
	                  borderBottom: "solid 1px #EEEFF2"
	                }
	              },
	              "Claritas can help you activate and target your audiences across both offline and online channels. We offer multiple delivery paths to support your business needs:"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "pt-20", style: { display: "flex" } },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "280px", borderRight: "solid 1px #EEEFF2" } },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Claritas Full Campaign Execution"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { display: "flex" } },
	                  _react2.default.createElement(
	                    "div",
	                    { style: { padding: " 20px 10px 20px 0px" } },
	                    _react2.default.createElement("img", { src: "/images/claritas-email-logo.png" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "pt-10 text-center" },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Email"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { padding: " 20px 10px 0px" } },
	                    _react2.default.createElement("img", { src: "/images/claritas-social-logo.png" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "pt-10 text-center" },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Social"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { padding: " 20px 0px 20px 10px" } },
	                    _react2.default.createElement("img", { src: "/images/claritas-display-logo.png" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "pt-10 text-center" },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Display"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "600px", marginLeft: "20px" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-center" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Claritas can provide audiences for campaign execution:"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      borderBottom: "solid 1px #EEEFF2",
	                      paddingBottom: "20px",
	                      paddingTop: "20px",
	                      display: "flex"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { style: { width: "75px" } },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Email - "
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    "Under certain circumstances, we will deliver active email addresses for campaign execution"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      borderBottom: "solid 1px #EEEFF2",
	                      paddingBottom: "20px",
	                      paddingTop: "20px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Social - "
	                  ),
	                  " We onboard audiences to your social platform of choice"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      borderBottom: "solid 1px #EEEFF2",
	                      paddingBottom: "20px",
	                      paddingTop: "20px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Display - "
	                  ),
	                  " We deliver audiences to your platform of choice for programmatic buying"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      paddingBottom: "20px",
	                      paddingTop: "20px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Direct Mail - "
	                  ),
	                  " We deliver full name and postal addresses of your audience"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginTop: "20px",
	                  marginBottom: "20px",
	                  paddingTop: "20px",
	                  paddingBottom: "20px",
	                  borderTop: "solid 1px #EEEFF2",
	                  textAlign: "center"
	                }
	              },
	              "Find PRIZM\xAE Premier, P$YCLE\xAE Premier, and ConneXions\xAE segments available today across our vast digital partner network:"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { display: "flex", marginTop: "40px" } },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "150px" } },
	                "\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "180px" } },
	                _react2.default.createElement("img", { src: "/images/liveRamp-logo.png" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "160px" } },
	                _react2.default.createElement("img", { src: "/images/google-logo.png" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "140px" } },
	                _react2.default.createElement("img", { src: "/images/oauth-logo.png" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "150px" } },
	                _react2.default.createElement("img", { src: "/images/adobe-logo.png" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "10%" } },
	                "\xA0"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "flex",
	                  marginTop: "40px",
	                  paddingBottom: "20px",
	                  borderBottom: "solid 1px #EEEFF2"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "180px" } },
	                "\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "250px" } },
	                _react2.default.createElement("img", { src: "/images/theTradeDesk-logo.png" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "170px", marginTop: "-10px" } },
	                _react2.default.createElement("img", { src: "/images/mediaMath-logo.png" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "150px" } },
	                _react2.default.createElement("img", { src: "/images/oracle-logo.png" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "10%" } },
	                "\xA0"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { padding: "20px 0 0" } },
	              _react2.default.createElement(
	                "div",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Contact us to discuss options and next steps"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { display: "flex", padding: "20px 0" } },
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "100px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Subject"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "780px" } },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    style: {
	                      width: "100%",
	                      border: "solid 1px",
	                      padding: "10px"
	                    },
	                    value: this.state.subject,
	                    maxLength: "65",
	                    onChange: function onChange(e) {
	                      _this12.setState({ subject: e.target.value });
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { display: "flex", padding: "10px 0 20px" } },
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "100px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Comments"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "780px" } },
	                  _react2.default.createElement("textarea", {
	                    className: "comment-box",
	                    rows: "6",
	                    style: {
	                      width: "100%",
	                      padding: "10px",
	                      overflowY: "auto"
	                    },
	                    value: this.state.comments,
	                    maxLength: "500",
	                    onChange: function onChange(e) {
	                      _this12.setState({ comments: e.target.value });
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "right" } },
	              this.props.send_assist_request_error && _react2.default.createElement(
	                "div",
	                {
	                  className: "pull-left ml-20 mt-5",
	                  style: { fontWeight: "bold", color: "#FF0000" }
	                },
	                this.props.send_assist_request_error
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "btn ",
	                  onClick: function onClick() {
	                    _this12.setState({ openContactUs: false });
	                  }
	                },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: (0, _isEmpty2.default)(this.state.comments) || (0, _isEmpty2.default)(this.state.subject),
	                  className: "btn btn-claritas-default ml-20",
	                  onClick: function onClick(e) {
	                    _this12.submitContactRequest(e);
	                  }
	                },
	                "Submit"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.showSuccessForm,
	            onRequestClose: function onRequestClose() {
	              _this12.setState({ showSuccessForm: false });
	            },
	            contentStyle: { width: "350px", padding: "20px" },
	            modal: true
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: { fontSize: "16px", fontFamily: "Arial", color: "#000" },
	              className: "text-center"
	            },
	            "Your message has been sent."
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: { fontSize: "15px", fontFamily: "Arial", color: "#000" },
	              className: "text-center mt-10"
	            },
	            "Your client services representative will contact you within one business day."
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "text-center mt-20" },
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-aa-default",
	                onClick: function onClick() {
	                  _this12.setState({ showSuccessForm: false });
	                }
	              },
	              "CLOSE"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.onPdfReportDownload,
	            style: { top: "-1.8em" },
	            modal: true,
	            contentStyle: { width: "500px" },
	            overlayStyle: { opacity: 0.9, backgroundColor: "#666666" }
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "mt-20" },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                offsetXs: "1",
	                offsetSm: "1",
	                offsetMd: "1",
	                offsetLg: "1",
	                xs: "7",
	                sm: "7",
	                md: "7",
	                lg: "7",
	                className: "text-right"
	              },
	              _react2.default.createElement(
	                "div",
	                null,
	                "Downloading, please wait..."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "1", sm: "1", md: "1", lg: "1" },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.showCreateAudienceDialog,
	            style: { top: "-1.8em" },
	            modal: true,
	            contentStyle: { width: "460px" }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: { display: savingVisitorsAudienceResult ? "block" : "none" }
	            },
	            _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "no-margin-top no-padding  text-center",
	                style: { fontSize: "16px", color: "#000" }
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Your audience segment has been saved."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "pt-10 no-padding-bottom no-padding-right pl-10",
	                style: { color: "#000" }
	              },
	              "The file is being processed and will be available in the",
	              " ",
	              _react2.default.createElement(
	                "span",
	                {
	                  className: "nav-clickable",
	                  onClick: function onClick() {
	                    _this12.props.history.push("/segments/list/active?cid=" + _this12.props.selected_client);
	                  }
	                },
	                "audience library"
	              ),
	              " ",
	              "when it is ready."
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "text-center no-padding-bottom no-margin-bottom" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-default btn-aa-default",
	                  onClick: function onClick() {
	                    _this12.props.clearCreateScaleAudienceInfo();
	                    _this12.props.clearCreateVisitorsAudienceInfo();
	                    _this12.setState({
	                      showCreateAudienceDialog: false,
	                      audienceName: ""
	                    });
	                  }
	                },
	                "Close"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: { display: savingScaleAudienceResult ? "block" : "none" }
	            },
	            _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "no-margin-top no-padding  text-center",
	                style: { fontSize: "16px", color: "#000" }
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Your audience segment has been saved."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "pt-10 no-padding-bottom no-padding-right pl-10",
	                style: { color: "#000" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "mb-20" },
	                _react2.default.createElement(_checkCircle2.default, {
	                  style: { width: "20px", height: "20px", color: "#347eb0" }
	                }),
	                "   ",
	                "It has been added to your",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  {
	                    className: "nav-clickable",
	                    onClick: function onClick() {
	                      _this12.props.history.push("/segments/list/active?cid=" + _this12.props.selected_client);
	                    }
	                  },
	                  "audience library"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_checkCircle2.default, {
	                  style: { width: "20px", height: "20px", color: "#347eb0" }
	                }),
	                "   ",
	                "View attribute breakdown in your",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  {
	                    className: "nav-clickable",
	                    onClick: function onClick() {
	                      _this12.props.history.push("/segments/list/detail/" + savingScaleAudienceResult.id);
	                    }
	                  },
	                  "audience details"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "text-center no-padding-bottom no-margin-bottom" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-default btn-aa-default",
	                  onClick: function onClick() {
	                    _this12.props.clearCreateScaleAudienceInfo();
	                    _this12.props.clearCreateVisitorsAudienceInfo();
	                    _this12.setState({
	                      showCreateAudienceDialog: false,
	                      audienceName: ""
	                    });
	                  }
	                },
	                "Close"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: savingScaleAudienceResult || savingVisitorsAudienceResult ? "none" : "block"
	              }
	            },
	            _react2.default.createElement(
	              _Grid.FullRow,
	              {
	                className: "no-margin-top no-padding",
	                style: { fontSize: "16px", color: "#000" }
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Choose the type of audience you would like to save."
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              null,
	              _react2.default.createElement(
	                _RadioButtonGroup2.default,
	                {
	                  style: { paddingLeft: "50px" },
	                  name: "createAudienceType",
	                  valueSelected: this.state.audienceType,
	                  onChange: this.handleAudienceTypeChange.bind(this)
	                },
	                _react2.default.createElement(_RadioButton2.default, {
	                  value: "visitor",
	                  label: "Save audience from website visitors",
	                  iconStyle: { fill: "black", width: "20px", height: "20px" }
	                }),
	                _react2.default.createElement(_RadioButton2.default, {
	                  value: "scale",
	                  label: "Create a target audience at scale",
	                  iconStyle: { fill: "black", width: "20px", height: "20px" }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "light-grey-bottom-border mb-20",
	                  style: { marginTop: "-10px" }
	                },
	                "\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { color: "#000" } },
	                _react2.default.createElement(
	                  "span",
	                  { className: "mr-20" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Name"
	                  )
	                ),
	                _react2.default.createElement(_materialUi.TextField, {
	                  underlineShow: false,
	                  className: "light-grey-border pl-10 pr-10",
	                  style: { width: "305px" },
	                  maxLength: 100,
	                  value: this.state.audienceName,
	                  onChange: function onChange(e, newVal) {
	                    _this12.setState({ audienceName: newVal });
	                  }
	                })
	              )
	            ),
	            savingScaleAudienceError && _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding-top no-padding-bottom no-margin-bottom" },
	              _react2.default.createElement(
	                "div",
	                { style: { color: "red" } },
	                savingScaleAudienceError.message
	              )
	            ),
	            savingVisitorsAudienceError && _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding-top no-padding-bottom no-margin-bottom" },
	              _react2.default.createElement(
	                "div",
	                { style: { color: "red" } },
	                savingVisitorsAudienceError.message
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "no-padding-bottom no-margin-bottom no-padding-top" },
	              (savingScaleAudience || savingVisitorsAudience) && _react2.default.createElement("img", {
	                alt: "",
	                src: "/Spinner.gif",
	                style: { height: "24px", float: "left" }
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-default btn-aa-default pull-right",
	                  disabled: (0, _isEmpty2.default)(this.state.audienceName),
	                  onClick: function onClick() {
	                    _this12.saveAudience();
	                  }
	                },
	                "Save"
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "pull-right btn btn-aa-info mr-10",
	                  onClick: function onClick() {
	                    _this12.setState({
	                      showCreateAudienceDialog: false,
	                      audienceName: ""
	                    });
	                  }
	                },
	                "Cancel"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.showDownloadDialog,
	            style: { top: "-1.8em" },
	            modal: true,
	            contentStyle: { width: "440px" }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-margin-top no-padding",
	              style: { fontSize: "16px", color: "#000" }
	            },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Choose the type of file you would like to download"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-padding-top no-padding-right no-padding-bottom no-margin-bottom",
	              style: { paddingLeft: "150px" }
	            },
	            _react2.default.createElement(_Checkbox2.default, {
	              iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	              label: "PDF File",
	              labelStyle: { fontSize: "13px" },
	              defaultChecked: true,
	              ref: "cbPDF",
	              onCheck: function onCheck(e, isInputChecked) {
	                return _this12.cbPDFChange(e, isInputChecked);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-padding-top no-padding-right no-padding-bottom",
	              style: { paddingLeft: "150px" }
	            },
	            _react2.default.createElement(_Checkbox2.default, {
	              iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	              label: "CSV File",
	              labelStyle: { fontSize: "13px" },
	              defaultChecked: false,
	              ref: "cbCSV",
	              onCheck: function onCheck(e, isInputChecked) {
	                return _this12.cbCSVChange(e, isInputChecked);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding no-margin-bottom mt-20 text-center" },
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                onClick: function onClick() {
	                  return _this12.setState({ showDownloadDialog: false });
	                },
	                className: "btn btn-default btn-aa-info mr-20"
	              },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                onClick: this.handleDownload.bind(this),
	                disabled: this.state.disabledBtnDownload || !this.props.detailDistributionReport,
	                className: "btn btn-default btn-aa-default"
	              },
	              "Download File"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SegmentDistribution;
	}(_MaterialUI2.default);
	
	exports.default = SegmentDistribution;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._getDeviceDistributeCsv = _getDeviceDistributeCsv;
	exports._getSegmentDistributeCsv = _getSegmentDistributeCsv;
	exports._getCultureCsv = _getCultureCsv;
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reduce = __webpack_require__(299);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getDeviceDistributeCsv(props, count) {
	  var top5OSBreakDown = props.top5OSBreakDown,
	      deviceModelReport = props.deviceModelReport,
	      deviceTypeReport = props.deviceTypeReport;
	
	  var device_type_arr = ["\r\nDevice Type\r\n"];
	  var device_type_sum = (0, _reduce2.default)(deviceTypeReport.values, function (sum, d) {
	    return sum + d.value;
	  }, 0);
	  (0, _map2.default)(deviceTypeReport.values, function (v) {
	    var strDeviceType = device_type_sum > 0 ? '"' + v.key + '",' + (v.value / device_type_sum * 100).toFixed(2) + "%,\r\n" : '"' + v.key + '",' + "N/A, \r\n";
	    device_type_arr.push(strDeviceType);
	  });
	
	  var device_model_arr = ["\r\nDevice Model\r\n"];
	  var device_model_sum = (0, _reduce2.default)(deviceModelReport.values, function (sum, d) {
	    return sum + d.value;
	  }, 0);
	  (0, _map2.default)(deviceModelReport.values, function (v) {
	    var strDeviceModel = device_model_sum > 0 ? '"' + v.key + '",' + (v.value / device_model_sum * 100).toFixed(2) + "%,\r\n" : '"' + v.key + '",' + "N/A, \r\n";
	    device_model_arr.push(strDeviceModel);
	  });
	
	  var op_sys_arr = ["\r\nOperating System\r\n"];
	  if (top5OSBreakDown && top5OSBreakDown.values) {
	    var op_sys_sum = (0, _reduce2.default)(top5OSBreakDown.values, function (sum, d) {
	      return sum + d.value;
	    }, 0);
	    (0, _map2.default)(top5OSBreakDown.values, function (v) {
	      var strSystem = op_sys_sum > 0 ? '"' + v.key + '",' + (v.value / op_sys_sum * 100).toFixed(2) + "%,\r\n" : '"' + v.key + '",' + "N/A, \r\n";
	      op_sys_arr.push(strSystem);
	    });
	  }
	
	  return device_type_arr.join("") + op_sys_arr.join("") + device_model_arr.join("");
	}
	
	function _getSegmentDistributeCsv(props, count) {
	  var _props$detailDistribu = props.detailDistributionReport,
	      lengthOfResidence = _props$detailDistribu.lengthOfResidence,
	      state = _props$detailDistribu.state;
	
	
	  (0, _reduce2.default)(lengthOfResidence.values, function (sum, d) {
	    return sum + d.value;
	  }, 0);
	  var top_5_state_arr = ["\r\nTop States\r\n"];
	  var statesSum = (0, _reduce2.default)(state.values, function (sum, d) {
	    return sum + d.value;
	  }, 0);
	  var topStateValues = (0, _sortBy2.default)(state.values, function (d) {
	    return -d.value;
	  });
	  (0, _map2.default)(topStateValues, function (v) {
	    var strState = '"' + v.key + '",' + (v.value / statesSum * 100).toFixed(2) + "%,\r\n";
	    top_5_state_arr.push(strState);
	  });
	
	  if (count === 0) {
	    return "\r\nAll Segment Details \r\n" + top_5_state_arr.join("");
	  } else {
	    return "\r\nTop " + count + " Segment Details \r\n" + top_5_state_arr.join("");
	  }
	}
	
	function _getCultureCsv(props) {
	  var formatData = function formatData(arr) {
	    if (!arr || !(arr instanceof Array) || arr.length === 0) return [];
	    var allCount = arr.reduce(function (a, b) {
	      if (typeof a !== "number") return a.value + b.value;else return a + b.value;
	    });
	    arr.forEach(function (it) {
	      it.percentage = it.value / allCount;
	    });
	    return arr;
	  };
	  var data = props.cultureCodeReport || {};
	  var json = Object.keys(data).join();
	  var aaAcculturation = [];
	  var hhAcculturation = [];
	  data.acculturation && data.acculturation.values && data.acculturation.values.forEach(function (it) {
	    var keyName = it.key.split(":");
	    it._key = keyName[0];
	    it.middleVal = keyName[1];
	    if (it.key.includes("AA")) {
	      aaAcculturation.push(it);
	    } else {
	      hhAcculturation.push(it);
	    }
	  });
	  var acculturation = formatData(data.acculturation && data.acculturation.values);
	  var aa = formatData(aaAcculturation);
	  var hh = formatData(hhAcculturation);
	  var ethnicity = formatData(data.ethnicity && data.ethnicity.values);
	  var region = formatData(data.region && data.region.values);
	  var str = "\r\nEthnicity,\r\n";
	  str += "\r\n";
	  (0, _sortBy2.default)(ethnicity, "value").reverse().forEach(function (it) {
	    var val = Math.round(it.percentage * 10000);
	    if (val > 0) {
	      str += it.key + "," + (val / 100 + "%") + ",\r\n";
	    }
	  });
	  str += "\r\nRegion,\r\n";
	  str += "\r\n";
	  (0, _sortBy2.default)(region, "value").reverse().forEach(function (it) {
	    var val = Math.round(it.percentage * 10000);
	    if (val > 0) {
	      str += it.key + "," + (val / 100 + "%") + ",\r\n";
	    }
	  });
	  str += "\r\nAcculturation,\r\n";
	  str += "\r\nHispanicity\r\n\r\n";
	  (0, _sortBy2.default)(hh, "value").reverse().forEach(function (it) {
	    var val = Math.round(it.percentage * 10000);
	    if (val > 0) {
	      str += it._key + "," + (val / 100 + "%") + ",\r\n";
	    }
	  });
	
	  str += "\r\nAsianicity\r\n\r\n";
	  (0, _sortBy2.default)(aa, "value").reverse().forEach(function (it) {
	    var val = Math.round(it.percentage * 10000);
	    if (val > 0) {
	      str += it._key + "," + (val / 100 + "%") + ",\r\n";
	    }
	  });
	
	  return str;
	}

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _WebsiteVisits = __webpack_require__(1203);
	
	var _WebsiteVisits2 = _interopRequireDefault(_WebsiteVisits);
	
	var _Summary = __webpack_require__(1201);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _AudienceFiles = __webpack_require__(1197);
	
	var _AudienceFiles2 = _interopRequireDefault(_AudienceFiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsightIndex = function (_AcquireWebComponent) {
		_inherits(InsightIndex, _AcquireWebComponent);
	
		function InsightIndex() {
			_classCallCheck(this, InsightIndex);
	
			return _possibleConstructorReturn(this, (InsightIndex.__proto__ || Object.getPrototypeOf(InsightIndex)).apply(this, arguments));
		}
	
		_createClass(InsightIndex, [{
			key: 'render',
			value: function render() {
				var reportType = this.props.match.params.type;
				var kindOfReport = this.props.match.params.kind;
	
				var _props = this.props,
				    location = _props.location,
				    history = _props.history;
	
				switch (reportType) {
					case "summary":
						return _react2.default.createElement(_Summary2.default, { kindOfReport: kindOfReport, history: history });
					case "audience":
						return _react2.default.createElement(_AudienceFiles2.default, null);
					default:
						return _react2.default.createElement(_WebsiteVisits2.default, { location: location, reportType: reportType, kindOfReport: kindOfReport, history: history });
				}
			}
		}]);
	
		return InsightIndex;
	}(_MaterialUI2.default);
	
	exports.default = InsightIndex;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewNavigator = function (_AcquireWebComponent) {
	  _inherits(NewNavigator, _AcquireWebComponent);
	
	  function NewNavigator() {
	    _classCallCheck(this, NewNavigator);
	
	    return _possibleConstructorReturn(this, (NewNavigator.__proto__ || Object.getPrototypeOf(NewNavigator)).apply(this, arguments));
	  }
	
	  _createClass(NewNavigator, [{
	    key: 'nullHandle',
	    value: function nullHandle() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var options = this.props.options;
	      return _react2.default.createElement(
	        'div',
	        { style: {
	            display: 'flex',
	            flexWrap: 'wrap'
	          } },
	        options.map(function (it, idx) {
	          var active = it.event !== undefined;
	          return [_react2.default.createElement(
	            'div',
	            { className: '_nav', key: it.name, style: {
	                color: active ? '#017FB5' : '#000000'
	              }, onClick: function onClick() {
	                it.event && it.event();
	              } },
	            it.name
	          ), _react2.default.createElement(
	            'div',
	            { style: {
	                display: idx !== options.length - 1 ? 'block' : 'none',
	                padding: '0 10px'
	              } },
	            '>'
	          )];
	        }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return NewNavigator;
	}(_MaterialUI2.default);
	
	exports.default = NewNavigator;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _SiteDateSelector = __webpack_require__(102);
	
	var _SiteDateSelector2 = _interopRequireDefault(_SiteDateSelector);
	
	var _utility = __webpack_require__(14);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _remove = __webpack_require__(188);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _isomorphicFetch = __webpack_require__(621);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _querystring = __webpack_require__(309);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _env = __webpack_require__(85);
	
	var _highlightOff = __webpack_require__(715);
	
	var _highlightOff2 = _interopRequireDefault(_highlightOff);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _find = __webpack_require__(47);
	
	var _find2 = _interopRequireDefault(_find);
	
	__webpack_require__(141);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ASYNC_DELAY = 500;
	
	var InsightFavoritePagesIndex = function (_AcquireWebComponent) {
	  _inherits(InsightFavoritePagesIndex, _AcquireWebComponent);
	
	  function InsightFavoritePagesIndex(props) {
	    _classCallCheck(this, InsightFavoritePagesIndex);
	
	    var _this = _possibleConstructorReturn(this, (InsightFavoritePagesIndex.__proto__ || Object.getPrototypeOf(InsightFavoritePagesIndex)).call(this, props));
	
	    _this.state = {
	      filter: "",
	      editMode: false,
	      favoritePages: [],
	      showMaxiumError: false
	    };
	    return _this;
	  }
	
	  _createClass(InsightFavoritePagesIndex, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      if (tagId > 0 && clientId > 0) {
	        this.props.getClientSites(clientId);
	        this.props.setWebsiteId(tagId);
	        this.props.selectClient(clientId);
	        this.props.fetchFavoritePages(tagId);
	      } else if (clientId > 0 && (0, _isEmpty2.default)(tagId)) {
	        this.props.getClientSites(clientId);
	        this.props.selectClient(clientId);
	        if (this.props.websiteId) {
	          this.props.fetchFavoritePages(this.props.websiteId);
	        }
	      } else {
	        this.props.selectClient(this.props.selected_client);
	      }
	    }
	  }, {
	    key: "getPages",
	    value: function getPages(input) {
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      if (!input || input.length < 3) {
	        return Promise.resolve({ options: [] });
	      }
	
	      return (0, _isomorphicFetch2.default)(_env.apiBaseUrl + "/insights/" + tagId + "/visited-url-paths?keyword=" + input, {
	        method: "GET",
	        headers: {
	          "Content-Type": "application/json",
	          Accept: "application/json",
	          Authorization: this.props.token,
	          "Cache-Control": "no-cache",
	          "max-age": 0
	        }
	      }).then(function (response) {
	        return response.json();
	      }).then(function (json) {
	        return {
	          options: (0, _map2.default)(json, function (item) {
	            return { label: item, value: item };
	          })
	        };
	      });
	    }
	  }, {
	    key: "filterOptions",
	    value: function filterOptions(options, filter, currentValues) {
	      var _this2 = this;
	
	      // Do no filtering, just return all options
	
	      if (options) {
	        var result = [];
	        (0, _map2.default)(options, function (option) {
	          if ((0, _find2.default)(_this2.state.favoritePages, function (p) {
	            return p.pageUrl === option.value;
	          }) === undefined) {
	            result.push({ label: option.label, value: option.value });
	          }
	        });
	        return result;
	      }
	      return options;
	    }
	  }, {
	    key: "onPageFilterChange",
	    value: function onPageFilterChange(value) {
	      if (!value) return;
	
	      var favoritePages = this.state.favoritePages;
	
	      var showMaxiumError = false;
	      if (favoritePages.length < 20 && favoritePages.indexOf(value.value) < 0) {
	        favoritePages.push({ pageUrl: value.value });
	      } else {
	        showMaxiumError = true;
	      }
	      this.setState({
	        filter: value,
	        favoritePages: favoritePages,
	        editMode: true,
	        showMaxiumError: showMaxiumError
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	
	      var alreadyFetch = false;
	      if (nextProps.client_info) {
	        if (nextProps.client_info.subscriptionTierId < 4) {
	          this.props.history.push("/");
	        }
	      }
	
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (nextProps.selected_client !== clientId && nextProps.selected_client > 1) {
	          window.location.href = "/distribution/pages/favorite?cid=" + nextProps.selected_client;
	        }
	        this.props.getClientInfo(nextProps.selected_client);
	      }
	
	      if ((0, _isUndefined2.default)(nextProps.websiteId) && tagId > 0) {
	        this.props.setWebsiteId(tagId);
	      }
	      /*
	      if (nextProps.websiteId !== this.props.websiteId) {
	        if (nextProps.websiteId > 0) {
	          if (tagId !== nextProps.websiteId) {
	            const url =
	              "/distribution/pages/favorite?cid=" +
	              clientId +
	              "&tag=" +
	              nextProps.websiteId;
	            window.location.href = url;
	          } else {
	            alreadyFetch = true;
	            this.props.fetchFavoritePages(tagId);
	          }
	        }
	      }*/
	
	      if (!(0, _isEqual2.default)(nextProps.favoritePages, this.props.favoritePages)) {
	        this.setState({
	          favoritePages: Object.assign([], nextProps.favoritePages)
	          /*
	          editMode: !(
	            nextProps.favoritePages && nextProps.favoritePages.length > 0
	          ),*/
	        });
	      }
	    }
	  }, {
	    key: "onWebSiteIdChanged",
	    value: function onWebSiteIdChanged(id) {
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      this.props.setWebsiteId(clientId);
	      window.location.href = "/distribution/pages/favorite?cid=" + clientId + "&tag=" + id;
	    }
	  }, {
	    key: "cancelEdit",
	    value: function cancelEdit() {
	      this.setState({
	        favoritePages: Object.assign([], this.props.favoritePages),
	        editMode: false,
	        showMaxiumError: false,
	        filter: ""
	      });
	    }
	  }, {
	    key: "removePage",
	    value: function removePage(pageUrl) {
	      var favoritePages = this.state.favoritePages;
	
	      (0, _remove2.default)(favoritePages, function (page) {
	        return page.pageUrl === pageUrl;
	      });
	      this.setState({
	        favoritePages: favoritePages,
	        showMaxiumError: false
	      });
	    }
	  }, {
	    key: "savePages",
	    value: function savePages() {
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      var favoritePages = this.state.favoritePages;
	
	      var pages = (0, _map2.default)(favoritePages, function (p) {
	        return { pageUrl: p.pageUrl };
	      });
	      this.props.saveFavoritePage(tagId, pages);
	      this.setState({
	        editMode: false,
	        showMaxiumError: false,
	        filter: ""
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          websiteId = _props.websiteId,
	          client_sites = _props.client_sites;
	      var favoritePages = this.state.favoritePages;
	
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      var urlParams = _querystring2.default.parse(this.props.location.search);
	      var cid = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      var type = (0, _utility.getUrlParameterByName)("type") ? (0, _utility.getUrlParameterByName)("type") : "default";
	
	      return _react2.default.createElement(
	        "div",
	        { id: "segment-distribution-container" },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              margin: "-20px 10% 20px",
	              fontSize: "16px",
	              borderBottom: "solid 1px #EEEFF2"
	            }
	          },
	          _react2.default.createElement(_SiteDateSelector2.default, {
	            type: "larger",
	            key: "segment-distribution-site-selector-" + new Date().getTime(),
	            websiteIdChanged: this.onWebSiteIdChanged.bind(this),
	            siteId: tagId ? tagId : websiteId,
	            sites: client_sites
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", padding: "10px 10%", fontSize: "16px" } },
	          _react2.default.createElement(
	            "div",
	            { id: "left-nav", style: { flex: "0 0 260px" } },
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border" },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    height: "48px",
	                    padding: "15px 20px",
	                    position: "relative",
	                    background: "#F5F5F5"
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Page Insights"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  onClick: function onClick() {
	                    _this3.props.history.push(("/distribution/pages/popular" + _querystring2.default.stringify(urlParams)).replace("%3F", "?"));
	                  },
	                  style: { height: "58px", padding: "15px 20px " },
	                  className: "distribution-type"
	                },
	                "Most Popular Pages"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  onClick: function onClick() {},
	                  style: { height: "58px", padding: "15px 20px" },
	                  className: "distribution-type-active"
	                },
	                "Favorite Pages"
	              )
	            )
	          ),
	          this.props.websiteId ? _react2.default.createElement(
	            "div",
	            { style: { width: "100%", flex: "1 0" } },
	            _react2.default.createElement(
	              "div",
	              { id: "report-main", className: "ml-20 light-grey-border p-20" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "h1",
	                  { className: "no-margin" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Favorite Pages"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "inline-block",
	                      marginRight: "10px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Choose a favorite page"
	                  )
	                ),
	                _react2.default.createElement(_reactSelect2.default.Async, {
	                  className: "pop-pages-selector",
	                  value: this.state.filter,
	                  loadOptions: this.getPages.bind(this),
	                  onChange: this.onPageFilterChange.bind(this),
	                  filterOptions: this.filterOptions.bind(this)
	                }),
	                this.state.editMode && this.state.showMaxiumError && _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      color: "red",
	                      paddingLeft: "200px",
	                      paddingTop: "10px"
	                    }
	                  },
	                  _react2.default.createElement(_error2.default, {
	                    style: {
	                      fill: "#DD0000",
	                      width: "16px",
	                      height: "16px"
	                    }
	                  }),
	                  "Maximum of 20 favorited pages. Please remove a favorited page below to continue"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "ml-20 light-grey-border p-20 mt-20" },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    padding: "20px 20px 20px",
	                    background: "#F5F5F5",
	                    display: "flex"
	                  }
	                },
	                this.state.editMode === true && _react2.default.createElement(
	                  "div",
	                  { style: { width: "100px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Remove"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Page Name"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    height: "400px",
	                    paddingTop: "150px",
	                    textAlign: "center",
	                    display: this.props.loadingFavoritePages ? "block" : "none"
	                  }
	                },
	                this.props.loadingFavoritePages && _react2.default.createElement(
	                  "h1",
	                  { style: { display: "inline-block" } },
	                  "Data loading, Please waiting..."
	                ),
	                this.props.loadingFavoritePages && _react2.default.createElement("img", {
	                  src: "/Spinner.gif",
	                  style: { marginLeft: "10px", height: "24px" }
	                })
	              ),
	              (0, _map2.default)((0, _sortBy2.default)(favoritePages, function (page) {
	                return page.pageUrl.substring(1);
	              }), function (page) {
	                return _react2.default.createElement(
	                  "div",
	                  {
	                    key: "page-" + page.pageUrl,
	                    className: "light-grey-border-bottom",
	                    style: { padding: "20px 20px 10px", display: "flex" }
	                  },
	                  _this3.state.editMode === true && _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        width: "100px",
	                        paddingRight: "40px",
	                        textAlign: "center",
	                        cursor: "pointer"
	                      }
	                    },
	                    _react2.default.createElement(_highlightOff2.default, {
	                      style: { fill: "red" },
	                      onClick: function onClick() {
	                        _this3.removePage(page.pageUrl);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        to: "/segment-distribution?cid=" + cid + "&tag=" + tagId + "&page=" + page.pageUrl + "&type=" + type + "&source=fav"
	                      },
	                      page.pageUrl
	                    )
	                  )
	                );
	              })
	            ),
	            this.state.editMode ? _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  textAlign: "right",
	                  marginTop: "20px",
	                  marginBottom: "10px"
	                }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "aw-btn",
	                  onClick: function onClick() {
	                    _this3.savePages();
	                  }
	                },
	                "Save"
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "aw-btn-cancel ml-10 ",
	                  onClick: function onClick() {
	                    _this3.cancelEdit();
	                  }
	                },
	                "Cancel"
	              )
	            ) : _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  textAlign: "right",
	                  marginTop: "20px",
	                  marginBottom: "10px"
	                }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "aw-btn",
	                  onClick: function onClick() {
	                    _this3.setState({ editMode: true });
	                  }
	                },
	                "Edit"
	              )
	            )
	          ) : _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border text-center p-20 ml-20 mb-20",
	              id: "contact-div",
	              style: {
	                color: "#DD0000",
	                width: "100%",
	                flex: "1 0",
	                height: "450px"
	              }
	            },
	            _react2.default.createElement(_error2.default, {
	              style: {
	                fill: "#DD0000",
	                width: "16px",
	                height: "16px"
	              }
	            }),
	            " ",
	            "No data to display try a different client"
	          )
	        )
	      );
	    }
	  }]);
	
	  return InsightFavoritePagesIndex;
	}(_MaterialUI2.default);
	
	exports.default = InsightFavoritePagesIndex;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isNil = __webpack_require__(56);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrequencyVisitorList = function (_AcquireWebComponent) {
	  _inherits(FrequencyVisitorList, _AcquireWebComponent);
	
	  function FrequencyVisitorList() {
	    _classCallCheck(this, FrequencyVisitorList);
	
	    return _possibleConstructorReturn(this, (FrequencyVisitorList.__proto__ || Object.getPrototypeOf(FrequencyVisitorList)).apply(this, arguments));
	  }
	
	  _createClass(FrequencyVisitorList, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          data = _props.data;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "pb-20 bg-white", key: "key-" + title.replace(" ", "-") },
	        _react2.default.createElement(
	          _Grid.FullRow,
	          { className: "no-padding-bottom mb-20" },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontWeight: "bold",
	                fontSize: "24px",
	                letterSpacing: "-0.015em"
	              }
	            },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Row,
	          {
	            className: "no-margin-bottom ml-20 mr-20",
	            style: { background: "#F5F5F5" }
	          },
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "2", sm: "2", md: "2", lg: "2", className: "pl-10" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Company ",
	              _react2.default.createElement("br", null),
	              "Name"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "4", sm: "4", md: "4", lg: "4" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Industry"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "2", sm: "2", md: "2", lg: "2" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Annual Revenue"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "2", sm: "2", md: "2", lg: "2" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Number of Employees"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "2", sm: "2", md: "2", lg: "2", className: "text-right" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Age of Business"
	            ),
	            _react2.default.createElement("br", null),
	            "(in years)"
	          )
	        ),
	        (0, _map2.default)(data, function (obj, index) {
	          return _react2.default.createElement(
	            _Grid.Row,
	            _defineProperty({
	              key: "frequency-visits-item-" + index,
	              style: { fontWeight: 300 },
	              className: "no-margin-bottom ml-20 mr-20 pb-15 pt-15"
	            }, "style", { borderBottom: "1px solid #f5f5f5" }),
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "2",
	                sm: "2",
	                md: "2",
	                lg: "2",
	                className: "pl-10",
	                style: { color: "#017FB5" }
	              },
	              obj.companyName.substring(0, 2) + "******"
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4" },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { width: "100%" },
	                  className: "ellipse-cell",
	                  "data-text": obj.industry
	                },
	                obj.industry
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "2", sm: "2", md: "2", lg: "2" },
	              (0, _isNil2.default)(obj.revenue) ? "-" : "$" + (0, _utility.splitNumber)(obj.revenue)()
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "2", sm: "2", md: "2", lg: "2" },
	              (0, _isNil2.default)(obj.employees) ? "-" : (0, _utility.splitNumber)(obj.employees)()
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "2",
	                sm: "2",
	                md: "2",
	                lg: "2",
	                className: "text-right",
	                style: { paddingRight: "80px" }
	              },
	              obj.age ? obj.age : "-"
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return FrequencyVisitorList;
	}(_MaterialUI2.default);
	
	FrequencyVisitorList.propTypes = {
	  title: _react2.default.PropTypes.string.isRequired,
	  data: _react2.default.PropTypes.array
	};
	exports.default = FrequencyVisitorList;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _SiteDateSelector = __webpack_require__(102);
	
	var _SiteDateSelector2 = _interopRequireDefault(_SiteDateSelector);
	
	var _utility = __webpack_require__(14);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _take = __webpack_require__(678);
	
	var _take2 = _interopRequireDefault(_take);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _querystring = __webpack_require__(309);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _reactHighlightWords = __webpack_require__(950);
	
	var _reactHighlightWords2 = _interopRequireDefault(_reactHighlightWords);
	
	var _reactRouterDom = __webpack_require__(32);
	
	__webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsightPopularPagesIndex = function (_AcquireWebComponent) {
	  _inherits(InsightPopularPagesIndex, _AcquireWebComponent);
	
	  function InsightPopularPagesIndex(props) {
	    _classCallCheck(this, InsightPopularPagesIndex);
	
	    var _this = _possibleConstructorReturn(this, (InsightPopularPagesIndex.__proto__ || Object.getPrototypeOf(InsightPopularPagesIndex)).call(this, props));
	
	    _this.state = {
	      pageCount: 20,
	      filter: "",
	      errorKey: "",
	      mostPopularPages: undefined,
	      showEmptyError: false
	    };
	    return _this;
	  }
	
	  _createClass(InsightPopularPagesIndex, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      if (tagId > 0 && clientId > 0) {
	        this.props.getClientSites(clientId);
	        this.props.selectClient(clientId);
	        this.props.setWebsiteId(tagId);
	        this.props.fetchMostPopularPages(tagId, this.props.dayRange);
	      } else if (clientId > 0 && (0, _isEmpty2.default)(tagId)) {
	        this.props.getClientSites(clientId);
	        this.props.selectClient(clientId);
	        if (this.props.websiteId && this.props.fetchFavoritePages) {
	          this.props.fetchFavoritePages(this.props.websiteId);
	        }
	      } else {
	        this.props.selectClient(this.props.selected_client);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      var alreadyFetch = false;
	      if (nextProps.client_info) {
	        if (nextProps.client_info.subscriptionTierId < 4) {
	          this.props.history.push("/");
	        }
	      }
	
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (nextProps.selected_client !== clientId && nextProps.selected_client > 1) {
	          window.location.href = "/distribution/pages/popular?cid=" + nextProps.selected_client;
	        }
	        this.props.getClientInfo(nextProps.selected_client);
	      }
	      /*
	      if (nextProps.websiteId !== this.props.websiteId) {
	        if (nextProps.websiteId > 0) {
	          if (tagId !== nextProps.websiteId) {
	            const url =
	              "/distribution/pages/popular?cid=" +
	              clientId +
	              "&tag=" +
	              nextProps.websiteId;
	            window.location.href = url;
	          } else {
	            if (this.props.dayRange) {
	              alreadyFetch = true;
	              this.props.fetchMostPopularPages(tagId, nextProps.dayRange);
	            }
	          }
	        }
	      }*/
	
	      if ((0, _isUndefined2.default)(nextProps.websiteId) && tagId > 0) {
	        this.props.setWebsiteId(tagId);
	      }
	
	      if (!(0, _isEqual2.default)(nextProps.mostPopularPages, this.props.mostPopularPages)) {
	        this.setState({
	          filter: "",
	          pageCount: 20
	        });
	      }
	
	      if (nextProps.dayRange !== this.props.dayRange) {
	        this.props.fetchMostPopularPages(tagId, nextProps.dayRange);
	      }
	
	      if (!(0, _isEqual2.default)(nextProps.mostPopularPages, this.props.mostPopularPages)) {
	        this.setState({ mostPopularPages: nextProps.mostPopularPages });
	      }
	      if (nextProps.favoriting !== this.props.favoriting) {
	        if (!nextProps.favoriting && this.state.errorKey) {
	          var pages = nextProps.mostPopularPages;
	          for (var i = 0; i < pages.length; i++) {
	            if (pages[i].pageUrl === this.state.errorKey && !nextProps.setFavoriteError) {
	              pages[i].favorite = !pages[i].favorite;
	            }
	          }
	          this.setState({ mostPopularPages: pages });
	        }
	      }
	      if (nextProps.loadingPopularPages !== this.props.loadingPopularPages) {
	        if (!nextProps.loadingPopularPages && this.props.loadingPopularPages) this.setState({
	          showEmptyError: true
	        });else this.setState({
	          showEmptyError: false
	        });
	      }
	    }
	  }, {
	    key: "onWebSiteIdChanged",
	    value: function onWebSiteIdChanged(id) {
	      var clientId = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      this.props.setWebsiteId(clientId);
	      window.location.href = "/distribution/pages/popular?cid=" + clientId + "&tag=" + id;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          websiteId = _props.websiteId,
	          setDateRange = _props.setDateRange,
	          dayRange = _props.dayRange,
	          client_sites = _props.client_sites,
	          loadingPopularPages = _props.loadingPopularPages,
	          loadingPopularPagesError = _props.loadingPopularPagesError,
	          favoriting = _props.favoriting,
	          setFavoriteError = _props.setFavoriteError;
	
	      var pages = (0, _take2.default)(this.state.mostPopularPages, this.state.pageCount);
	      var pageList = (0, _map2.default)(pages, function (page) {
	        return { value: page.pageUrl, label: page.pageUrl };
	      });
	      var filterPages = (0, _isEmpty2.default)(this.state.filter) ? pages : (0, _filter2.default)(pages, function (page) {
	        return page.pageUrl.indexOf(_this2.state.filter) >= 0;
	      });
	
	      var tagId = parseInt((0, _utility.getUrlParameterByName)("tag"), 10);
	      var cid = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      var type = (0, _utility.getUrlParameterByName)("type") ? (0, _utility.getUrlParameterByName)("type") : "default";
	      var urlParams = _querystring2.default.parse(this.props.location.search);
	      var containerheight = this.state.pageCount === 20 ? "auto" : "800px";
	      return _react2.default.createElement(
	        "div",
	        { id: "segment-distribution-container" },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              margin: "-20px 10% 20px",
	              fontSize: "16px",
	              borderBottom: "solid 1px #EEEFF2"
	            }
	          },
	          _react2.default.createElement(_SiteDateSelector2.default, {
	            type: "larger",
	            key: "segment-distribution-site-selector-" + new Date().getTime(),
	            websiteIdChanged: this.onWebSiteIdChanged.bind(this),
	            siteId: tagId ? tagId : websiteId,
	            sites: client_sites,
	            dayRangeChanged: setDateRange,
	            dayRange: dayRange
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", padding: "10px 10%", fontSize: "16px" } },
	          _react2.default.createElement(
	            "div",
	            { id: "left-nav", style: { flex: "0 0 260px" } },
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border" },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    height: "48px",
	                    padding: "15px 20px",
	                    position: "relative",
	                    background: "#F5F5F5"
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Page Insights"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  onClick: function onClick() {
	                    _this2.props.history.push("/distribution/pages/popular?tag=" + tagId + "&cid=" + cid);
	                  },
	                  style: { height: "58px", padding: "15px 20px " },
	                  className: "distribution-type-active"
	                },
	                "Most Popular Pages"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  onClick: function onClick() {
	                    _this2.props.history.push(("/distribution/pages/favorite" + _querystring2.default.stringify(urlParams)).replace("%3F", "?"));
	                  },
	                  style: { height: "58px", padding: "15px 20px" },
	                  className: "distribution-type"
	                },
	                "Favorite Pages"
	              )
	            )
	          ),
	          pageList && pageList.length > 0 || loadingPopularPages ? _react2.default.createElement(
	            "div",
	            {
	              id: "report-main",
	              className: "ml-20 light-grey-border p-20",
	              style: { width: "100%", flex: "1 0" }
	            },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "h1",
	                { className: "no-margin" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Most Popular Pages"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { display: "flex", marginTop: "20px" } },
	              _react2.default.createElement(
	                "div",
	                { style: { flex: "1 1 420px" } },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "inline-block",
	                      marginRight: "10px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Popular page search"
	                  )
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  onChange: function onChange(e) {
	                    _this2.setState({ filter: e ? e.target.value : "" });
	                  },
	                  style: {
	                    width: "250px",
	                    border: "solid 1px #BDBDBD",
	                    marginTop: "5px",
	                    marginLeft: "10px",
	                    padding: "5px 10px",
	                    lineHieght: "20px"
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { flex: "1 1 200px", textAlign: "right" } },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "inline-block",
	                      marginRight: "0px"
	                    }
	                  },
	                  "View"
	                ),
	                _react2.default.createElement(_reactSelect2.default, {
	                  className: "pop-pages-count-selector",
	                  name: "",
	                  value: this.state.pageCount,
	                  clearable: false,
	                  searchable: false,
	                  onChange: function onChange(e) {
	                    _this2.setState({ pageCount: e.value });
	                  },
	                  options: [{ value: 20, label: "20" }, { value: 50, label: "50" }, { value: 100, label: "100" }]
	                }),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "inline-block",
	                      marginLeft: "20px"
	                    }
	                  },
	                  "Popular Pages"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  marginTop: "20px",
	                  padding: "10px 20px 20px",
	                  background: "#F5F5F5",
	                  display: "flex"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "60%", paddingTop: "10px" } },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Page Name"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "20%", paddingTop: "10px" } },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Total Visits"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "18%", paddingTop: "10px" } },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Add to Favorites"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  height: "400px",
	                  paddingTop: "150px",
	                  textAlign: "center",
	                  display: loadingPopularPages || loadingPopularPagesError ? "block" : "none"
	                }
	              },
	              loadingPopularPages && _react2.default.createElement(
	                "h1",
	                { style: { display: "inline-block" } },
	                "Data loading, Please waiting..."
	              ),
	              loadingPopularPages && _react2.default.createElement("img", {
	                src: "/Spinner.gif",
	                style: { marginLeft: "10px", height: "24px" }
	              }),
	              loadingPopularPagesError && _react2.default.createElement(
	                "h3",
	                { style: { color: "red" } },
	                "Can not load popular pages, ",
	                loadingPopularPagesError
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  overflowY: containerheight === "auto" ? "hidden" : "auto",
	                  height: containerheight,
	                  display: loadingPopularPages || loadingPopularPagesError ? "none" : "block"
	                }
	              },
	              (0, _map2.default)(filterPages, function (page) {
	                return [_react2.default.createElement(
	                  "div",
	                  {
	                    key: "page-" + page.pageUrl,
	                    className: !(0, _isUndefined2.default)(setFavoriteError) && _this2.state.errorKey === page.pageUrl ? "" : "light-grey-border-bottom",
	                    style: { padding: "10px 20px 20px", display: "flex" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        width: "60%",
	                        paddingTop: "10px",
	                        paddingRight: "20px",
	                        overflow: "hidden",
	                        whiteSpace: "nowrap",
	                        textOverflow: "ellipsis"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        to: "/segment-distribution?cid=" + cid + "&tag=" + tagId + "&page=" + page.pageUrl + "&type=" + type + "&source=pop"
	                      },
	                      (0, _isEmpty2.default)(_this2.state.filter) ? _react2.default.createElement(
	                        "span",
	                        { className: "nav-clickable" },
	                        page.pageUrl
	                      ) : _react2.default.createElement(_reactHighlightWords2.default, {
	                        highlightClassName: "clickable",
	                        className: "nav-clickable",
	                        searchWords: [_this2.state.filter],
	                        autoEscape: true,
	                        textToHighlight: page.pageUrl
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { width: "20%", paddingTop: "10px" } },
	                    (0, _utility.splitNumber)(page.totalVisits + "")()
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        width: "12%",
	                        marginTop: "5px",
	                        fontSize: "20px",
	                        textAlign: "center"
	                      }
	                    },
	                    _react2.default.createElement("i", {
	                      className: page.favorite ? "fa fa-star clickable" : "fa fa-star-o clickable",
	                      style: {
	                        color: page.favorite ? "#FFD700" : "#000000"
	                      },
	                      onClick: function onClick() {
	                        _this2.setState({ errorKey: page.pageUrl });
	                        _this2.props.setPageFavorite(tagId, _this2.props.dayRange, page.pageUrl, !page.favorite);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { width: "5%" } },
	                    favoriting && _this2.state.errorKey === page.pageUrl && _react2.default.createElement("img", {
	                      src: "/Spinner.gif",
	                      style: {
	                        height: "24px",
	                        marginTop: "10px"
	                      }
	                    })
	                  )
	                ), _react2.default.createElement(
	                  "div",
	                  {
	                    key: "page-favorite-error-" + page.pageUrl,
	                    className: (0, _isUndefined2.default)(setFavoriteError) ? "" : "light-grey-border-bottom pb-10",
	                    style: {
	                      width: "100%",
	                      textAlign: "right",
	                      paddingRight: "80px",
	                      display: page.pageUrl === _this2.state.errorKey ? "block" : "none"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    { style: { color: "red" } },
	                    setFavoriteError && _react2.default.createElement(_error2.default, {
	                      style: {
	                        fill: "#DD0000",
	                        width: "16px",
	                        height: "16px"
	                      }
	                    }),
	                    " ",
	                    setFavoriteError
	                  )
	                )];
	              }),
	              !(0, _isEmpty2.default)(this.state.filter) && (0, _isEmpty2.default)(filterPages) && _react2.default.createElement(
	                "div",
	                { className: "light-grey-border-bottom text-center p-20" },
	                "No Results Found for \"",
	                this.state.filter,
	                "\".Please try another search."
	              )
	            )
	          ) : _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border text-center p-20 ml-20 mb-20",
	              id: "contact-div",
	              style: {
	                color: "#DD0000",
	                width: "100%",
	                flex: "1 0",
	                height: "400px",
	                display: this.state.showEmptyError ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(_error2.default, {
	              style: {
	                fill: "#DD0000",
	                width: "16px",
	                height: "16px"
	              }
	            }),
	            " ",
	            "No data to display try a different date range"
	          )
	        )
	      );
	    }
	  }]);
	
	  return InsightPopularPagesIndex;
	}(_MaterialUI2.default);
	
	exports.default = InsightPopularPagesIndex;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopAttributeListSection = function (_AcquireWebComponent) {
		_inherits(TopAttributeListSection, _AcquireWebComponent);
	
		function TopAttributeListSection() {
			_classCallCheck(this, TopAttributeListSection);
	
			return _possibleConstructorReturn(this, (TopAttributeListSection.__proto__ || Object.getPrototypeOf(TopAttributeListSection)).apply(this, arguments));
		}
	
		_createClass(TopAttributeListSection, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    title = _props.title,
				    subTitle = _props.subTitle,
				    data = _props.data;
				// const COLORS = ['#050505', '#0E222C', '#1C4456', '#2A6581', '#3888AB', '#609FBD', '#609FBD', '#87B7CD', '#AFCFDD', '#D6E7EF'];
	
				var AttributeTitle = { fontWeight: 'bold', lineHeight: '50px', background: '#f5f5f5' };
				var valueStyle = { lineHeight: '40px' };
	
				return _react2.default.createElement(
					'div',
					{ className: 'pb-20 bg-white', key: "key-" + title.replace(" ", "-") },
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'no-padding-bottom no-margin-bottom', style: { paddingTop: '0px' } },
						_react2.default.createElement(
							'div',
							{ style: {
									fontSize: '24px',
									lineHeight: '70px',
									letterSpacing: '-0.015em'
								} },
							_react2.default.createElement(
								'strong',
								null,
								title
							)
						)
					),
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'no-padding no-margin-bottom ml-20 mr-20 pb-5' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '3', sm: '3', md: '3', lg: '3', style: AttributeTitle },
							_react2.default.createElement(
								'strong',
								null,
								'Attribute'
							)
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '4', sm: '4', md: '4', lg: '4', style: AttributeTitle },
							_react2.default.createElement(
								'strong',
								null,
								'Value Pair'
							)
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '3', sm: '3', md: '3', lg: '3', style: AttributeTitle },
							_react2.default.createElement(
								'strong',
								null,
								subTitle
							)
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '2', sm: '2', md: '2', lg: '2', style: AttributeTitle },
							'\xA0'
						)
					),
					!data || data.length === 0 ? _react2.default.createElement(
						'div',
						{ style: {
								textAlign: 'center',
								color: '#ccc',
								fontSize: '24px',
								padding: '10px'
							} },
						'No Data.'
					) : null,
					(0, _lodash.map)(data, function (obj, index) {
						return _react2.default.createElement(
							_Grid.Row,
							{ key: "top-visits-item-" + obj.name + "-" + obj.value, style: { fontWeight: 300, borderBottom: '1px solid #E8EBEF' },
								className: 'gray-bottom-border no-padding no-margin-bottom ml-20 mr-20 pb-5 pt-5' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', style: valueStyle },
								obj.name
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '4', sm: '4', md: '4', lg: '4', style: valueStyle },
								obj.value
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '3', sm: '3', md: '3', lg: '3', style: valueStyle },
								(obj.visits * 100).toFixed(2) + '%'
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '2', sm: '2', md: '2', lg: '2', style: { height: '40px', display: 'flex', alignItems: 'center' } },
								_react2.default.createElement(
									'span',
									{ style: { display: "inline-block", background: '#216E69',
											width: (obj.visits * 100).toFixed(2) + '%', height: '22px' } },
									'\xA0'
								)
							)
						);
					})
				);
			}
		}]);
	
		return TopAttributeListSection;
	}(_MaterialUI2.default);
	
	TopAttributeListSection.propTypes = {
		title: _react2.default.PropTypes.string.isRequired,
		data: _react2.default.PropTypes.array,
		subTitle: _react2.default.PropTypes.string.isRequired
	};
	exports.default = TopAttributeListSection;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OtherTraffic;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1424);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OtherTraffic(props) {
	  var fontSize = props.total > 100000 || props.unique > 100000 ? '52px' : '62px';
	  return _react2.default.createElement(
	    'div',
	    { className: 'summary other-traffic light-grey-border' },
	    _react2.default.createElement(
	      'div',
	      { className: 'other-traffic-title' },
	      _react2.default.createElement(
	        'strong',
	        null,
	        props.title || 'Other Traffic'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'other-traffic-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'other-traffic-total' },
	        _react2.default.createElement(
	          'div',
	          { className: 'other-traffic-subtitle' },
	          props.totalTitle || 'Total Other'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'blue-count', style: { fontSize: fontSize } },
	          (0, _utility.splitNumber)('' + props.total)()
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'other-traffic-unique' },
	        _react2.default.createElement(
	          'div',
	          { className: 'other-traffic-subtitle' },
	          props.uniqueTitle || 'Unique Other'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'blue-count', style: { fontSize: fontSize } },
	          (0, _utility.splitNumber)('' + props.unique)()
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'other-traffic-description' },
	        props.discription || 'Other traffic includes traffic derived from wireless, proxy, foreign, bots and other non-routable traffic'
	      )
	    )
	  );
	}

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _utility = __webpack_require__(14);
	
	var _LineGraphic = __webpack_require__(519);
	
	var _LineGraphic2 = _interopRequireDefault(_LineGraphic);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(141);
	
	var TrafficSummary = function (_AcquireWebComponent) {
	  _inherits(TrafficSummary, _AcquireWebComponent);
	
	  function TrafficSummary() {
	    _classCallCheck(this, TrafficSummary);
	
	    return _possibleConstructorReturn(this, (TrafficSummary.__proto__ || Object.getPrototypeOf(TrafficSummary)).apply(this, arguments));
	  }
	
	  _createClass(TrafficSummary, [{
	    key: "onClickContact",
	    value: function onClickContact(e) {
	      e.preventDefault();
	      if (this.props.handleContactSupport) {
	        this.props.handleContactSupport();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          dateRange = _props.dateRange,
	          hideTraffic = _props.hideTraffic,
	          chartTitle = _props.chartTitle,
	          client_profile = _props.client_profile;
	
	      if ((0, _isUndefined2.default)(data)) {
	        return _react2.default.createElement(
	          "div",
	          {
	            style: {
	              border: "solid 1px black",
	              color: "#5C5C5C",
	              background: "#FFF"
	            }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            {
	              className: "no-margin-bottom p-20",
	              style: { fontWeight: "300" }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  float: "left",
	                  height: "200px",
	                  width: "100%",
	                  position: "relative",
	                  padding: "20px"
	                }
	              },
	              _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } }),
	              "\xA0loading..."
	            )
	          )
	        );
	      }
	
	      if ((0, _isEmpty2.default)(data)) {
	        return _react2.default.createElement(
	          "div",
	          {
	            style: {
	              border: "solid 1px black",
	              color: "#5C5C5C",
	              background: "#FFF",
	              fontSize: "16px"
	            }
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-margin-bottom pt-20 pb-20" },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  width: "100%",
	                  minHeight: "200px",
	                  textAlign: "center",
	                  paddingTop: "60px",
	                  color: "#CDCDCD"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { color: "#CDCDCD", fontSize: "36px", opacity: "0.8" }
	                },
	                "No Data"
	              )
	            )
	          )
	        );
	      }
	      var totalVisitsCount = data.totalVisitsCount,
	          uniqueVisitsCount = data.uniqueVisitsCount,
	          detailVisitsCount = data.detailVisitsCount;
	
	      var fontSize = totalVisitsCount > 100000 || uniqueVisitsCount > 100000 ? "48px" : "58px";
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            color: "#000",
	            background: "#FFF",
	            fontSize: "16px"
	          }
	        },
	        hideTraffic ? null : _react2.default.createElement(
	          "div",
	          { className: "light-grey-border" },
	          _react2.default.createElement(
	            "div",
	            { className: "mt-20 ml-20", style: { height: "16px" } },
	            _react2.default.createElement(
	              "p",
	              {
	                style: { fontSize: "24px", height: "16px", fontWeight: "bold" }
	              },
	              "Traffic"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "no-margin-bottom pt-10 pb-20",
	              style: { fontWeight: "300", display: "flex" }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  flexShrink: "0",
	                  flexGrow: 1,
	                  minWidth: "20%"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    color: "#000",
	                    marginTop: "20px",
	                    textAlign: "center"
	                  }
	                },
	                "Total Visits"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    fontSize: fontSize,
	                    fontWeight: "normal",
	                    color: "#32A59D",
	                    padding: "0 20px",
	                    textAlign: "center",
	                    lineHeight: 1
	                  }
	                },
	                (0, _utility.splitNumber)(totalVisitsCount + "")()
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "pr-20 pl-20 light-grey-left-border",
	                style: { flexGrow: 1, minWidth: "40%" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    width: "100%",
	                    textAlign: "center",
	                    padding: "20px",
	                    lineHeight: "18px",
	                    background: "#F5F5F5",
	                    marginBottom: "10px",
	                    fontWeight: "bold"
	                  }
	                },
	                "Traffic Breakdown"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "flex",
	                    justifyContent: "space-between"
	                  }
	                },
	                (0, _map2.default)(detailVisitsCount, function (value, key) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      className: "stats-summary-count",
	                      key: "stats-summary-" + key,
	                      style: { whiteSpace: "nowrap" }
	                    },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      key
	                    ),
	                    ": ",
	                    value
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "light-grey-left-border pt-5",
	                style: {
	                  justifyContent: "flex-end",
	                  flexShrink: "0",
	                  flexGrow: 1,
	                  minWidth: "20%"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    color: "#000",
	                    marginTop: "20px",
	                    textAlign: "center"
	                  }
	                },
	                "Unique Visits"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    fontSize: fontSize,
	                    fontWeight: "normal",
	                    color: "#32A59D",
	                    padding: "0 20px",
	                    textAlign: "center",
	                    lineHeight: 1
	                  }
	                },
	                (0, _utility.splitNumber)(uniqueVisitsCount + "")()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "no-margin-bottom light-grey-border mt-20 p-20 " },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontSize: "24px",
	                fontWeight: "bold",
	                marginBottom: "40px"
	              }
	            },
	            chartTitle || "Total U.S. Domestic Traffic (includes Consumer and Business)"
	          ),
	          _react2.default.createElement(_LineGraphic2.default, {
	            type: "business",
	            animation: false,
	            key: "triffice-summary-section",
	            title: "",
	            data: this.props.lineData,
	            subTitle: client_profile && client_profile.timezone ? dateRange + " - " + (0, _utility.timezonLabel)(client_profile.timezone) : "" + dateRange
	          })
	        )
	      );
	    }
	  }]);
	
	  return TrafficSummary;
	}(_MaterialUI2.default);
	
	TrafficSummary.propTypes = {
	  data: _react2.default.PropTypes.object,
	  lineData: _react2.default.PropTypes.array,
	  dateRange: _react2.default.PropTypes.string,
	  handleContactSupport: _react2.default.PropTypes.func
	};
	
	exports.default = TrafficSummary;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _utility = __webpack_require__(14);
	
	var _TrafficSummary = __webpack_require__(1117);
	
	var _TrafficSummary2 = _interopRequireDefault(_TrafficSummary);
	
	var _SiteDateSelector = __webpack_require__(102);
	
	var _SiteDateSelector2 = _interopRequireDefault(_SiteDateSelector);
	
	var _ListGraphic = __webpack_require__(520);
	
	var _ListGraphic2 = _interopRequireDefault(_ListGraphic);
	
	var _OtherTraffic = __webpack_require__(1116);
	
	var _OtherTraffic2 = _interopRequireDefault(_OtherTraffic);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _materialUi = __webpack_require__(38);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _findIndex = __webpack_require__(414);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _cloneDeep = __webpack_require__(1632);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jspdf = __webpack_require__(72);
	
	var _jspdf2 = _interopRequireDefault(_jspdf);
	
	var _html2canvas = __webpack_require__(71);
	
	var _html2canvas2 = _interopRequireDefault(_html2canvas);
	
	__webpack_require__(1425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsightSummary = function (_AcquireWebComponent) {
		_inherits(InsightSummary, _AcquireWebComponent);
	
		function InsightSummary(props) {
			_classCallCheck(this, InsightSummary);
	
			var _this = _possibleConstructorReturn(this, (InsightSummary.__proto__ || Object.getPrototypeOf(InsightSummary)).call(this, props));
	
			var cid = (0, _utility.getUrlParameterByName)("cid");
			if (cid && (!props.selected_client || props.selected_client === '0')) {
				_this.props.selectClient(parseInt(cid, 10));
				_this.props.getClientSites(parseInt(cid, 10));
			}
			if (!_this.props.client_sites) {
				if (cid && (!props.selected_client || props.selected_client === '0')) {
					_this.props.getClientSites(parseInt(cid, 10));
				} else {
					_this.props.getClientSites(props.selected_client);
				}
			}
			_this.state = {
				openContactForm: false,
				state: 960,
				subject: "",
				comments: "",
				showSuccessForm: false,
				showLoadingDialog: false,
				granularity: window.localStorage.getItem('__granularity__') || 'scale'
			};
			_this.props.setGranularity(window.localStorage.getItem('__granularity__') || 'scale');
			return _this;
		}
	
		_createClass(InsightSummary, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var width = document.getElementById('insights-summary-container').clientWidth;
				this.setState({ width: width });
	
				var _props = this.props,
				    websiteId = _props.websiteId,
				    dayRange = _props.dayRange,
				    selected_client = _props.selected_client,
				    getClientSites = _props.getClientSites,
				    kindOfReport = _props.kindOfReport,
				    getClientProfile = _props.getClientProfile;
	
				if (websiteId) {
					this.props.getOverviewTrafficeReport(websiteId, dayRange);
					this.props.getDomesticConsumerStats(websiteId, dayRange, this.props.granularity);
					this.props.getStatsByTime(websiteId, dayRange, undefined, kindOfReport);
					this.props.getDomesticBusinessStats(websiteId, this.props.granularity, dayRange);
				} else {
					if (selected_client) {
						getClientSites(selected_client);
						getClientProfile(selected_client);
					}
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.selected_client !== this.props.selected_client) {
					if (nextProps.selected_client > 1) {
						this.props.getClientSites(nextProps.selected_client);
						this.props.getClientProfile(nextProps.selected_client);
						this.props.clearAllDomesticStats();
						//this.props.history.push("/insights/summary?cid="+nextProps.selected_client)
					}
				}
				if (nextProps.request_assist_successful === true && (0, _isUndefined2.default)(this.props.request_assist_successful)) {
					this.setState({
						subject: undefined, comments: undefined, showSuccessForm: true, openContactForm: false
					});
				}
				var change = nextProps.websiteId !== this.props.websiteId || nextProps.dayRange !== this.props.dayRange || nextProps.granularity !== this.props.granularity;
				if (change) {
					if (nextProps.websiteId) {
						this.props.getOverviewTrafficeReport(nextProps.websiteId, nextProps.dayRange);
						this.props.getDomesticConsumerStats(nextProps.websiteId, nextProps.dayRange, nextProps.granularity);
						this.props.getStatsByTime(nextProps.websiteId, nextProps.dayRange, undefined, nextProps.kindOfReport);
						this.props.getDomesticBusinessStats(nextProps.websiteId, nextProps.granularity, nextProps.dayRange);
					}
				} else if (nextProps.kindOfReport !== this.props.kindOfReport && nextProps.websiteId) {
					if (nextProps.websiteId) {
						this.props.getStatsByTime(nextProps.websiteId, nextProps.dayRange, undefined, nextProps.kindOfReport);
					}
				}
			}
		}, {
			key: 'getDayRangeTitle',
			value: function getDayRangeTitle(key) {
				switch (key) {
					case 'today':
						return "Today";
					case 'yesterday':
						return "Yesterday";
					case 'last-7-days':
						return 'Last 7 Days';
					case 'last-30-days':
						return 'Last 30 Days';
					case 'last-60-days':
						return 'Last 60 Days';
					case 'last-90-days':
						return 'Last 90 days';
					default:
						return '';
				}
			}
		}, {
			key: 'getContent',
			value: function getContent() {
				var _this2 = this;
	
				var addPercentSign = function addPercentSign(val) {
					return val.toFixed(2) + '%';
				};
				var _props2 = this.props,
				    kindOfReport = _props2.kindOfReport,
				    overviewTrafficReport = _props2.overviewTrafficReport,
				    domesticConsumerVisitsReport = _props2.domesticConsumerVisitsReport,
				    domesticBusinessVisitsReport = _props2.domesticBusinessVisitsReport,
				    dayRange = _props2.dayRange,
				    statsByTime = _props2.statsByTime,
				    client_info = _props2.client_info;
	
	
				var summaryData = {
					totalVisitsCount: 0,
					uniqueVisitsCount: 0,
					detailVisitsCount: {}
				};
	
				var otherTrafficData = {
					total: 0,
					unique: 0
				};
	
				if (overviewTrafficReport) {
					otherTrafficData.total = overviewTrafficReport.totalVisits || 0;
					otherTrafficData.unique = overviewTrafficReport.uniqueVisits || 0;
					summaryData.totalVisitsCount = overviewTrafficReport.totalVisits;
					summaryData.uniqueVisitsCount = overviewTrafficReport.uniqueVisits;
					summaryData.detailVisitsCount = {};
					(0, _map2.default)(overviewTrafficReport.stats, function (stats) {
						summaryData.detailVisitsCount[stats.type] = (stats.totalPercentage * 100).toFixed(2) + "%";
					});
				}
	
				var timeTraffic = [];
				if (statsByTime) {
					(0, _map2.default)(statsByTime.stats, function (obj) {
						var timeStr = '';
						switch (dayRange) {
							case 'yesterday':
							case 'today':
								timeStr = (0, _moment2.default)(obj.type).format("hA");
								break;
							default:
								timeStr = (0, _moment2.default)(obj.type, 'YYYY-MM-DD').format("MMM-DD");
						}
						var item = { time: timeStr, totalVisits: obj.total, uniqueVisits: obj.unique };
						timeTraffic.push(item);
					});
				}
	
				var consumerData = [];
				if (domesticConsumerVisitsReport) {
					consumerData = [];
					(0, _map2.default)(domesticConsumerVisitsReport, function (stat, key) {
						if (key === 'maritalStats') return;
						var title = (0, _utility.getDemographicText)(key.replace("Stats", ""));
						if (key === "totalVisits") title = "Total Consumer Visits";
						if (key === "uniqueVisits") title = "Unique Consumer Visits";
						var valText = '';
						if (Array.isArray(stat)) {
							if (stat.length > 1) {
								stat.forEach(function (item) {
									switch (key) {
										case "genderStats":
											if ((0, _isEmpty2.default)(valText)) valText = addPercentSign(item.value * 100) + ' (' + item.key + ') - ';
											break;
										default:
											valText += addPercentSign(item.value * 100) + ' (' + item.key + ') - ';
									}
								});
								valText = valText.substring(0, valText.length - 2);
							} else {
								valText = stat.length > 0 ? key === 'genderStats' ? addPercentSign(stat[0].value * 100) + ' (' + stat[0].key + ')' : addPercentSign(stat[0].value * 100) : "";
							}
						} else {
							switch (key) {
								case 'medianAge':
									valText = Math.round(stat) + '';
									break;
								case 'medianNumberOfPeople':
									valText = Math.round(stat * 10) / 10 + '';
									break;
								case 'medianIncome':
									valText = '$' + (0, _utility.splitNumber)(Math.round(stat))();
									break;
								case 'totalVisits':
								case 'uniqueVisits':
									valText = (0, _utility.splitNumber)(stat)();
									break;
								default:
									valText = stat + '';
							}
						}
						if (valText === "0" || (0, _isEmpty2.default)(valText) || valText === 'null' || valText === "$0") {
							valText = 'N/A';
							if (_this2.props.client_sites && Array.isArray(_this2.props.client_sites) && _this2.props.client_sites.length > 0) {
								var site_name = _this2.props.client_sites[0].label;
								if (site_name === 'Auto Inc.') {
									switch (key) {
										case 'medianAge':
											valText = '50';
											break;
										case 'medianNumberOfPeople':
											valText = '2.3';
											break;
										case 'medianIncome':
											valText = '$' + (0, _utility.splitNumber)(47965)();
											break;
										case 'homeOwnershipStats':
											valText = '52.56%';
											break;
										case 'genderStats':
											valText = '46.30% (M)';
											break;
										default:
											valText = '';
											break;
									}
								}
							}
						}
						consumerData.push({ name: title, value: valText });
					});
					var total = domesticConsumerVisitsReport.totalVisits || 0;
					var unique = domesticConsumerVisitsReport.uniqueVisits || 0;
					otherTrafficData.total = otherTrafficData.total - total;
					otherTrafficData.unique = otherTrafficData.unique - unique;
					if (kindOfReport === 'consumer') {
						otherTrafficData.total = total;
						otherTrafficData.unique = unique;
					}
				}
	
				var businessData = [];
				var initData = [{ name: "Total Business Visits", value: "Unknown" }, { name: "Unique Business Visits", value: "Unknown" }, { name: "Top Industry", value: "Unknown" }, { name: "Average Annual Company Revenue", value: 'Unknown' }, { name: "Average Number of Company Employees", value: 'Unknown' }, { name: "Average Age of Business", value: "Unknown" }, { name: "Home Business", value: "Unknown" }];
				if (domesticBusinessVisitsReport) {
					businessData = (0, _cloneDeep2.default)(initData);
					var _total = domesticBusinessVisitsReport.totalVisits || 0;
					var _unique = domesticBusinessVisitsReport.uniqueVisits || 0;
					if (kindOfReport === 'business') {
						otherTrafficData.total = _total;
						otherTrafficData.unique = _unique;
					} else if (kindOfReport !== 'consumer') {
						otherTrafficData.total = otherTrafficData.total - _total;
						otherTrafficData.unique = otherTrafficData.unique - _unique;
					}
					(0, _map2.default)(domesticBusinessVisitsReport, function (stats, key) {
						var title = "";
						var valText = "";
						switch (key) {
							case 'totalVisits':
								title = 'Total Business Visits';
								valText = (0, _utility.splitNumber)(stats)();
								break;
							case 'uniqueVisits':
								title = 'Unique Business Visits';
								valText = (0, _utility.splitNumber)(stats)();
								break;
							case 'topIndustry':
								title = 'Top Industry';
								valText = stats;
								break;
							case 'averageBizAge':
								title = 'Average Age of Business';
								valText = stats ? stats.toFixed(2) + " years" : "N/A";
								break;
							case 'averageEmployees':
								title = 'Average Number of Company Employees';
								valText = stats ? isNaN(stats) ? "N/A" : (0, _utility.splitNumber)(parseInt(stats, 10))() : "N/A";
								break;
							case 'averageRevenue':
								title = 'Average Annual Company Revenue';
								valText = stats ? isNaN(stats) ? "N/A" : "$" + (0, _utility.splitNumber)(stats)() : "N/A";
								break;
							case 'homeBizPercentage':
								title = "Home Business";
								valText = stats === 0 ? "Unknown" : addPercentSign(stats * 100);
								break;
							default:
								title = "";
						}
						if (valText === "0" || (0, _isEmpty2.default)(valText)) valText = "Unknown";
						var idx = (0, _findIndex2.default)(businessData, { name: title });
						businessData.splice(idx, 1, { name: title, value: valText });
					});
	
					if ((0, _isEqual2.default)(businessData, initData)) {
						businessData = [];
					}
				}
	
				if (kindOfReport === 'consumer') {
					return _react2.default.createElement(
						'div',
						{ className: 'website-visits-content summary-consumer', style: { padding: 0 } },
						_react2.default.createElement(_OtherTraffic2.default, Object.assign({}, otherTrafficData, {
							totalTitle: 'Total Visits',
							uniqueTitle: 'Unique Visits',
							title: 'Domestic Consumer Site Traffic',
							discription: 'Domestic consumer traffic only, excludes foreign and bot traffic'
						})),
						_react2.default.createElement(
							'div',
							{ className: 'total-visit-section' },
							this.state.showLoadingDialog === true ? _react2.default.createElement(_TrafficSummary2.default, { client_profile: client_info, data: summaryData, hideTraffic: true, chartTitle: 'Total U.S. Domestic Consumer Traffic', lineData: timeTraffic, key: 'total-visit-section', dateRange: this.getDayRangeTitle(this.props.dayRange) }) : _react2.default.createElement(_TrafficSummary2.default, { client_profile: client_info, data: summaryData, hideTraffic: true, chartTitle: 'Total U.S. Domestic Consumer Traffic', lineData: timeTraffic, handleContactSupport: function handleContactSupport() {
									_this2.setState({ openContactForm: true });
								},
								key: 'total-visit-section', dateRange: this.getDayRangeTitle(this.props.dayRange) })
						),
						_react2.default.createElement(
							'div',
							{ className: 'light-grey-border mb-20 pb-20 mt-20 clear-float' },
							_react2.default.createElement(
								'div',
								{ className: 'p-20' },
								_react2.default.createElement(_ListGraphic2.default, { data: consumerData,
									footer: this.state.showLoadingDialog === true ? null : _react2.default.createElement(
										_reactRouterDom.Link,
										{ className: 'traffic-link', style: { position: "absolute", left: "0px", bottom: "-5px" }, to: "/insights/consumer?nav=overview&cid=" + this.props.selected_client },
										'View More Consumer Information'
									),
									title: "Domestic Consumer Traffic" })
							)
						)
					);
				} else if (kindOfReport === 'business') {
					return _react2.default.createElement(
						'div',
						{ className: 'website-visits-content summary-business', style: { padding: 0 } },
						_react2.default.createElement(_OtherTraffic2.default, Object.assign({}, otherTrafficData, {
							totalTitle: 'Total Visits',
							uniqueTitle: 'Unique Visits',
							title: 'Domestic Business Site Traffic',
							discription: 'Domestic business traffic only, excludes foreign and bot traffic'
						})),
						_react2.default.createElement(
							'div',
							{ className: 'total-visit-section' },
							this.state.showLoadingDialog === true ? _react2.default.createElement(_TrafficSummary2.default, { client_profile: client_info, data: summaryData, hideTraffic: true, chartTitle: 'Total U.S. Domestic Business Traffic', lineData: timeTraffic, key: 'total-visit-section', dateRange: this.getDayRangeTitle(this.props.dayRange) }) : _react2.default.createElement(_TrafficSummary2.default, { client_profile: client_info, data: summaryData, hideTraffic: true, chartTitle: 'Total U.S. Domestic Business Traffic', lineData: timeTraffic, handleContactSupport: function handleContactSupport() {
									_this2.setState({ openContactForm: true });
								},
								key: 'total-visit-section', dateRange: this.getDayRangeTitle(this.props.dayRange) })
						),
						_react2.default.createElement(
							'div',
							{ className: 'light-grey-border mb-20 pb-20 mt-20 clear-float' },
							_react2.default.createElement(
								'div',
								{ className: 'p-20' },
								_react2.default.createElement(_ListGraphic2.default, { data: businessData, title: "Domestic Business Traffic",
									footer: this.state.showLoadingDialog === true ? null : _react2.default.createElement(
										_reactRouterDom.Link,
										{ className: 'traffic-link', style: { position: "absolute", left: "0px", bottom: "-5px" }, to: "/insights/business?nav=overview&cid=" + this.props.selected_client },
										'View More Business Information'
									)
								})
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'website-visits-content', style: { padding: 0 } },
						_react2.default.createElement(
							'div',
							{ className: 'total-visit-section' },
							this.state.showLoadingDialog === true ? _react2.default.createElement(_TrafficSummary2.default, { client_profile: client_info, data: summaryData, lineData: timeTraffic, key: 'total-visit-section', dateRange: this.getDayRangeTitle(this.props.dayRange) }) : _react2.default.createElement(_TrafficSummary2.default, { client_profile: client_info, data: summaryData, lineData: timeTraffic, handleContactSupport: function handleContactSupport() {
									_this2.setState({ openContactForm: true });
								},
								key: 'total-visit-section', dateRange: this.getDayRangeTitle(this.props.dayRange) })
						),
						_react2.default.createElement(
							'div',
							{ className: ' bg-white demo-geo-section' },
							_react2.default.createElement(
								_Grid.Row,
								{ className: 'pt-20 pb-20 pr-10 pl-10 no-margin-bottom', style: { minHeight: '250px', display: "flex" } },
								_react2.default.createElement(
									'div',
									{ className: 'p-20 light-grey-border', style: { flex: "1 1" } },
									_react2.default.createElement(_ListGraphic2.default, { data: consumerData,
										footer: this.state.showLoadingDialog === true ? null : _react2.default.createElement(
											_reactRouterDom.Link,
											{ className: 'traffic-link', style: { position: "absolute", left: "0px", bottom: "-5px" }, to: "/insights/consumer?nav=overview&cid=" + this.props.selected_client },
											'View More Consumer Information'
										),
										title: "Domestic Consumer Traffic" })
								),
								_react2.default.createElement('div', { style: { width: "20px" } }),
								_react2.default.createElement(
									'div',
									{ className: 'p-20 light-grey-border', style: { flex: "1 1" } },
									_react2.default.createElement(_ListGraphic2.default, { data: businessData, title: "Domestic Business Traffic",
										footer: this.state.showLoadingDialog === true ? null : _react2.default.createElement(
											_reactRouterDom.Link,
											{ className: 'traffic-link', style: { position: "absolute", left: "0px", bottom: "-5px" }, to: "/insights/business?nav=overview&cid=" + this.props.selected_client },
											'View More Business Information'
										)
									})
								)
							)
						),
						_react2.default.createElement(_OtherTraffic2.default, otherTrafficData)
					);
				}
			}
		}, {
			key: 'onContactFormSubmit',
			value: function onContactFormSubmit(e) {
				e.preventDefault();
				var postData = {
					"clientId": this.props.selected_client,
					"subject": this.state.subject.trim(),
					"comment": this.state.comments.trim(),
					"originationPage": "Main Insights Dashboard"
				};
	
				this.props.sendAssistRequest(postData);
			}
		}, {
			key: 'downloadAsPdf',
			value: function downloadAsPdf() {
				this.setState({ showLoadingDialog: true });
	
				var _props3 = this.props,
				    selected_client = _props3.selected_client,
				    client_sites = _props3.client_sites,
				    websiteId = _props3.websiteId,
				    clients = _props3.clients,
				    dayRange = _props3.dayRange;
	
				var c = clients.find(function (client) {
					return parseInt(client.id, 10) === parseInt(selected_client, 10);
				});
				if (!c) {
					clients.forEach(function (cl) {
						if (cl.businessUnits) {
							cl.businessUnits.forEach(function (b) {
								if (parseInt(b.id, 10) === parseInt(selected_client, 10)) c = b;
							});
						}
					});
				}
	
				var clientName = c && c.name ? c.name : "";
				var s = client_sites.find(function (site) {
					return site.value === websiteId;
				});
	
				var fileName = clientName + '_insights_' + dayRange.replace(/-/g, '_') + '_' + (0, _moment2.default)().format('YYYYMMDD') + '.pdf';
	
				var pdf = new _jspdf2.default('p', 'mm', 'a4');
				pdf.setFont("helvetica");
				pdf.setFontType("normal");
				pdf.setFontSize(9);
				var pageWidth = 186;
				var totalVisitsCanva = null,
				    listDataCanva = null;
				var isTotalVisitReady = false,
				    isListDataReady = false;
	
				var els = document.getElementsByClassName("total-visit-section");
				if (els.length > 0) {
					var el = els[0];
					var tvWidth = el.offsetWidth;
					el.style.width = '1024px';
					setTimeout(function () {
						(0, _html2canvas2.default)(el, { logging: false }).then(function (canvas) {
							totalVisitsCanva = canvas;
							isTotalVisitReady = true;
							el.style.width = tvWidth + 'px';
						});
					}, 50);
				}
	
				els = document.getElementsByClassName("demo-geo-section");
				if (els.length > 0) {
					var _el = els[0];
					var _tvWidth = _el.offsetWidth;
					_el.style.width = '1024px';
					setTimeout(function () {
						(0, _html2canvas2.default)(_el, { logging: false }).then(function (canvas) {
							listDataCanva = canvas;
							isListDataReady = true;
							_el.style.width = _tvWidth + 'px';
						});
					}, 50);
				}
	
				var top = 10;
				var intervalId = setInterval(function () {
					if (isTotalVisitReady === false || isListDataReady === false) {
						console.log('PDF generating...');
					} else {
						clearInterval(intervalId);
						//pdf.setDrawColor(0, 123, 99)
						setTimeout(function () {
							/*
	      pdf.setFillColor(232,232,232)
	      pdf.rect(0, 12 , 210, 15, 'F')
	      
	      pdf.setTextColor(255, 255, 255)
	      //pdf.rect(0, 0, 210, 15, 'F')
	      pdf.setFontSize(9)
	      pdf.addImage(insightHeaderDataUri(), 'PNG', 0, 0, 210, 0)
	      pdf.text(198, 8, moment().format('MMMM DD, YYYY'), null, null, 'right')*/
							pdf.setFillColor(127, 127, 127);
							pdf.rect(0, 15, 210, 10, 'F');
	
							pdf.setTextColor(0, 0, 0);
							pdf.setFontSize(9);
							pdf.setFontType('bold');
							pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), 'PNG', 10.5, 3, 60, 0);
							pdf.text(198, 8, (0, _moment2.default)().format('MMMM DD, YYYY'), null, null, 'right');
	
							pdf.setTextColor(255, 255, 255);
							pdf.setFontType('bold');
							pdf.text(12, 21, 'Client:');
							var lenClientName = (0, _utility.getTextSize)(clientName.trim(), 'helvetica');
							pdf.setFontType('normal');
							pdf.text(23, 21, clientName.trim());
							//cm to inches
							var start = 23 + lenClientName.width * 0.3937 + 0.4;
							pdf.setFontType('bold');
							pdf.text(start, 21, 'WEBSITE NAME:');
							start += 26.5;
							pdf.setFontType('normal');
							pdf.text(start, 21, s && s.label ? s.label.trim() : '');
							start += s && s.label ? (0, _utility.getTextSize)(s.label.trim(), 'helvetica').width * 0.3937 + 0.4 : 1;
							pdf.setFontType('bold');
							pdf.text(start, 21, 'Date:');
							pdf.setFontType('normal');
							start += (0, _utility.getTextSize)('Date:', 'helvetica').width * 0.3937 + 0.4;
							pdf.text(start, 21, this.getDayRangeTitle(dayRange));
	
							pdf.setFillColor(255);
							pdf.setLineWidth(0.1);
							pdf.line(0, 27, 210, 27);
							top = 32;
	
							pdf.addImage(totalVisitsCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0);
							pdf.setLineWidth(0.03);
							var h1 = totalVisitsCanva.height * pageWidth / totalVisitsCanva.width;
							top += h1 + 5;
	
							pdf.addImage(listDataCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0);
							var h2 = listDataCanva.height * pageWidth / listDataCanva.width;
							top += h2 + 5;
							/*
	      pdf.setFillColor(35, 47, 58)
	      pdf.rect(0, 280, 210, 20, 'F')
	      pdf.addImage(pdfReportFooterDataUri(), 'PNG', 15, 290, 20, 0)
	      	pdf.setTextColor(255, 255, 255)
	      pdf.setFontSize(9)
	      pdf.setFontType('bold')
	      pdf.text(65, 290, moment().format('YYYY') + " Claritas, LLC. All rights reserved")*/
							(0, _utility.addPdfFooter)(pdf);
							pdf.save(fileName);
	
							this.setState({ showLoadingDialog: false });
						}.bind(this), 100);
					}
				}.bind(this), 50);
			}
		}, {
			key: 'handleNavClick',
			value: function handleNavClick(nav) {
				var kindOfReport = this.props.kindOfReport;
	
				var cid = (0, _utility.getUrlParameterByName)("cid");
				var cidUrl = cid ? '?cid=' + cid : '';
				if (nav === 'total' && kindOfReport !== undefined) {
					this.props.history.push('/insights/summary' + cidUrl);
				} else if (nav === 'consumer' && kindOfReport !== 'consumer') {
					this.props.history.push('/insights/summary/consumer' + cidUrl);
				} else if (nav === 'business' && kindOfReport !== 'business') {
					this.props.history.push('/insights/summary/business' + cidUrl);
				}
			}
		}, {
			key: 'randerNavClass',
			value: function randerNavClass(nav) {
				var kindOfReport = this.props.kindOfReport;
	
				if (nav === kindOfReport) {
					return 'nav nav-active';
				} else {
					return 'nav';
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props4 = this.props,
				    websiteId = _props4.websiteId,
				    client_sites = _props4.client_sites,
				    loadingOverviewTraffic = _props4.loadingOverviewTraffic,
				    loadingDomesticBusiness = _props4.loadingDomesticBusiness,
				    kindOfReport = _props4.kindOfReport,
				    loadingDomesticConsumerVisits = _props4.loadingDomesticConsumerVisits,
				    loadingStatsByTime = _props4.loadingStatsByTime;
	
				var dataLoading = !!loadingDomesticConsumerVisits || !!loadingOverviewTraffic || !!loadingDomesticBusiness || !!loadingStatsByTime;
				var actionButtons = [this.props.send_assist_request_error && _react2.default.createElement(
					'div',
					{ className: 'pull-left ml-20 mt-5', style: { fontWeight: "bold", color: "#FF0000" } },
					this.props.send_assist_request_error
				), _react2.default.createElement(
					'button',
					{ onClick: function onClick() {
							_this3.setState({ openContactForm: false });
						}, className: 'btn btn-default btn-aa-info mr-10' },
					'Cancel'
				), (0, _isEmpty2.default)(this.state.comments) || (0, _isEmpty2.default)(this.state.subject) ? _react2.default.createElement(
					'button',
					{ disabled: true, className: 'btn btn-default btn-aa-info mr-10' },
					'Submit'
				) : _react2.default.createElement(
					'button',
					{ onClick: function onClick(e) {
							_this3.onContactFormSubmit(e);
						}, className: 'btn btn-aa-default mr-10' },
					'Submit'
				)];
				return _react2.default.createElement(
					'div',
					{ id: 'insights-summary-container', style: { fontFamily: "Arial", fontSize: "16px" } },
					_react2.default.createElement(
						'div',
						{ style: { padding: '0', margin: "-20px auto 10px", width: '80vw' } },
						_react2.default.createElement(_SiteDateSelector2.default, { showGranularity: kindOfReport === 'consumer', granularityChanged: this.props.setGranularity,
							granularity: this.props.granularity,
							websiteIdChanged: this.props.setWebsiteId, siteId: websiteId, type: "larger",
							sites: this.props.client_sites, dayRangeChanged: this.props.setDateRange, dayRange: this.props.dayRange })
					),
					_react2.default.createElement(
						'div',
						{ className: 'summary-content' },
						_react2.default.createElement(
							'ul',
							{ className: 'nav-list light-grey-border' },
							_react2.default.createElement(
								'li',
								{ className: this.randerNavClass(), onClick: this.handleNavClick.bind(this, 'total') },
								'Total'
							),
							_react2.default.createElement(
								'li',
								{ className: this.randerNavClass('consumer'), onClick: this.handleNavClick.bind(this, 'consumer') },
								'Consumer'
							),
							_react2.default.createElement(
								'li',
								{ className: this.randerNavClass('business'), onClick: this.handleNavClick.bind(this, 'business') },
								'Business'
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { flexGrow: 1 } },
							this.getContent()
						)
					),
					_react2.default.createElement(
						_materialUi.Dialog,
						{ open: this.state.showLoadingDialog || dataLoading === true,
							style: { top: '-1.8em' },
							overlayStyle: { opacity: 0.9, backgroundColor: '#666666' },
							modal: true },
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'mt-20' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
								_react2.default.createElement(
									'div',
									null,
									dataLoading ? "Loading" : "Downloading",
									', please wait...'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '1', sm: '1', md: '1', lg: '1' },
								_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
							)
						)
					)
				);
			}
		}]);
	
		return InsightSummary;
	}(_MaterialUI2.default);
	
	exports.default = InsightSummary;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	__webpack_require__(124);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomTagVariables = function (_AcquireWebComponent) {
		_inherits(CustomTagVariables, _AcquireWebComponent);
	
		function CustomTagVariables() {
			_classCallCheck(this, CustomTagVariables);
	
			return _possibleConstructorReturn(this, (CustomTagVariables.__proto__ || Object.getPrototypeOf(CustomTagVariables)).apply(this, arguments));
		}
	
		_createClass(CustomTagVariables, [{
			key: 'getTypeTitle',
			value: function getTypeTitle() {
				var varType = this.props.varType;
	
				switch (varType) {
					default:
						return _react2.default.createElement('div', null);
					case "page":
						return _react2.default.createElement(
							'div',
							{ className: 'input-group' },
							_react2.default.createElement(
								'span',
								null,
								"Page Reference"
							),
							_react2.default.createElement(
								'span',
								{ className: 'input-group-addon no-padding-left' },
								_react2.default.createElement(
									_rcTooltip2.default,
									{ placement: 'right',
										overlayClassName: 'overlay-bg-yellow',
										overlay: (0, _utility.text_definition)("custom_variable_tip"),
										arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' }) },
									_react2.default.createElement(_infoOutline2.default, { style: { height: '20px', widht: '20px', marginTop: '-10px' } })
								)
							)
						);
					case "passthrough":
						return _react2.default.createElement(
							'div',
							{ className: 'input-group' },
							_react2.default.createElement(
								'span',
								null,
								"Pass Through"
							),
							_react2.default.createElement(
								'span',
								{ className: 'input-group-addon no-padding-left' },
								_react2.default.createElement(
									_rcTooltip2.default,
									{ placement: 'right',
										overlayClassName: 'overlay-bg-yellow',
										overlay: (0, _utility.text_definition)("passthrough_variable_tip"),
										arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' }) },
									_react2.default.createElement(_infoOutline2.default, { style: { height: '20px', widht: '20px', marginTop: '-10px' } })
								)
							)
						);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    varType = _props.varType,
				    variables = _props.variables,
				    addVariable = _props.addVariable,
				    removeVariable = _props.removeVariable,
				    varChanged = _props.varChanged;
	
				return _react2.default.createElement(
					_Grid.FullRow,
					{ className: 'black-border p-10 no-margin-left no-margin-right mb-20' },
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'pl-10 pt-10 no-padding-top no-padding-bottom no-padding-right' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '5', md: '5', sm: '5', lg: '5', className: 'no-padding-left no-padding-right' },
							_react2.default.createElement(
								'strong',
								null,
								'Variable Type'
							)
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '4', md: '4', sm: '4', lg: '4', className: 'no-padding-left' },
							this.getTypeTitle()
						)
					),
					variables.map(function (item, index) {
						return _react2.default.createElement(
							_Grid.Row,
							{ key: 'cvar-' + index, className: 'pl-10 no-padding-top pb-10 no-padding-right' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '5', md: '5', sm: '5', lg: '5', className: 'no-padding-left no-padding-right pt-5' },
								_react2.default.createElement(
									'strong',
									null,
									varType === "page" ? "Reference Name" : "Pass Through Name",
									' ',
									index + 1
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '6', md: '6', sm: '6', lg: '6', className: 'no-padding-left no-padding-right' },
								_react2.default.createElement('input', { type: 'text', value: item, maxLength: 36, onChange: function onChange(e) {
										varChanged(e, index);
									},
									style: { border: 'solid 1px #000', width: '100%', lineHeight: '28px', paddingLeft: '5px' } })
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '1', md: '1', sm: '1', lg: '1', className: 'no-padding-left text-right',
									style: { display: index === variables.length - 1 ? 'block' : 'none' } },
								_react2.default.createElement(
									'a',
									{ onClick: function onClick(e) {
											e.preventDefault();removeVariable();
										} },
									_react2.default.createElement('i', { className: 'icon-cancel-circle2', style: { color: "red" } })
								)
							)
						);
					}),
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'text-right no-padding-top no-padding-right no-padding-bottom' },
						_react2.default.createElement(
							'button',
							{ type: 'button', className: 'btn btn-default legitRipple btn-aa-default ',
								onClick: function onClick(e) {
									e.preventDefault();addVariable();
								} },
							' Add Reference Name'
						)
					)
				);
			}
		}]);
	
		return CustomTagVariables;
	}(_MaterialUI2.default);
	
	exports.default = CustomTagVariables;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HashedEmailVariables = function (_AcquireWebComponent) {
		_inherits(HashedEmailVariables, _AcquireWebComponent);
	
		function HashedEmailVariables() {
			_classCallCheck(this, HashedEmailVariables);
	
			return _possibleConstructorReturn(this, (HashedEmailVariables.__proto__ || Object.getPrototypeOf(HashedEmailVariables)).apply(this, arguments));
		}
	
		_createClass(HashedEmailVariables, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    hashCase = _props.hashCase,
				    hashFormat = _props.hashFormat;
	
				return _react2.default.createElement(
					_Grid.FullRow,
					{ className: 'black-border p-10 no-margin-left no-margin-right mb-20' },
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'pl-10 pt-10 no-padding-top no-padding-bottom' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '4', md: '4', sm: '4', lg: '4', className: 'no-padding-left' },
							_react2.default.createElement(
								'strong',
								null,
								'Variable Type'
							)
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '4', md: '4', sm: '4', lg: '4', className: 'no-padding-left' },
							_react2.default.createElement(
								'div',
								{ className: 'input-group' },
								_react2.default.createElement(
									'span',
									null,
									'Hashed Email'
								)
							)
						)
					),
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'no-padding-top no-padding-bottom pl-10' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '8', sm: '8', md: '8', lg: '8', style: { background: "#F6F6F6" } },
							_react2.default.createElement(
								_Grid.Row,
								{ className: 'black-border no-padding-left no-padding-right pt-10 no-margin-bottom' },
								_react2.default.createElement(
									_Grid.Col,
									{ xs: '5', sm: '5', md: '5', lg: '5' },
									_react2.default.createElement(
										'strong',
										null,
										'Hash Format'
									),
									_react2.default.createElement(
										'div',
										{ className: 'mt-5' },
										_react2.default.createElement('input', { type: 'checkbox', name: 'hast_format_md5',
											value: "MD5",
											checked: hashFormat.indexOf("MD5") >= 0,
											onChange: this.props.handleHashFormatChanged
										}),
										'\xA0\xA0MD5',
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mt-5' },
										_react2.default.createElement('input', { type: 'checkbox', name: 'hast_format_md5',
											value: "SHA1",
											checked: hashFormat.indexOf("SHA1") >= 0,
											onChange: this.props.handleHashFormatChanged
										}),
										'\xA0\xA0SHA1',
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mt-5' },
										_react2.default.createElement('input', { type: 'checkbox', name: 'hast_format_md5',
											value: "SHA256",
											checked: hashFormat.indexOf("SHA256") >= 0,
											onChange: this.props.handleHashFormatChanged
										}),
										'\xA0\xA0SHA256',
										_react2.default.createElement('br', null)
									)
								),
								_react2.default.createElement(
									_Grid.Col,
									{ xs: '6', sm: '6', md: '6', lg: '6', style: { color: hashFormat.length > 0 ? "#000" : "#9C9C9C" } },
									_react2.default.createElement(
										'strong',
										null,
										'Hash Case'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'div',
										{ className: 'mt-5' },
										_react2.default.createElement('input', { type: 'radio', name: 'hash_case_upper', disabled: hashFormat.length <= 0,
											value: "upper",
											checked: hashCase === "upper",
											onChange: this.props.handleHashCaseChanged
										}),
										'\xA0\xA0All Upper-case',
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mt-5' },
										_react2.default.createElement('input', { type: 'radio', name: 'hash_case_lower', disabled: hashFormat.length <= 0,
											value: "lower",
											checked: hashCase === "lower",
											onChange: this.props.handleHashCaseChanged
										}),
										'\xA0\xA0All Lower-case',
										_react2.default.createElement('br', null)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return HashedEmailVariables;
	}(_MaterialUI2.default);
	
	exports.default = HashedEmailVariables;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _InsightNav = __webpack_require__(355);
	
	var _InsightNav2 = _interopRequireDefault(_InsightNav);
	
	var _SiteDateSelector = __webpack_require__(102);
	
	var _SiteDateSelector2 = _interopRequireDefault(_SiteDateSelector);
	
	var _lodash = __webpack_require__(18);
	
	var _Grid = __webpack_require__(19);
	
	__webpack_require__(124);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(1426);
	
	var _WebTagsTable = __webpack_require__(527);
	
	var _WebTagsTable2 = _interopRequireDefault(_WebTagsTable);
	
	var _EmailTagsTable = __webpack_require__(524);
	
	var _EmailTagsTable2 = _interopRequireDefault(_EmailTagsTable);
	
	var _EmailTagDetail = __webpack_require__(523);
	
	var _EmailTagDetail2 = _interopRequireDefault(_EmailTagDetail);
	
	var _HtmlTagDetail = __webpack_require__(525);
	
	var _HtmlTagDetail2 = _interopRequireDefault(_HtmlTagDetail);
	
	var _TagCreation = __webpack_require__(526);
	
	var _TagCreation2 = _interopRequireDefault(_TagCreation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagIndex = function (_AcquireWebComponent) {
	  _inherits(TagIndex, _AcquireWebComponent);
	
	  function TagIndex() {
	    _classCallCheck(this, TagIndex);
	
	    return _possibleConstructorReturn(this, (TagIndex.__proto__ || Object.getPrototypeOf(TagIndex)).apply(this, arguments));
	  }
	
	  _createClass(TagIndex, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.state = {
	        clientName: "",
	        buName: "",
	        clientId: undefined,
	        tag_type: "Web",
	        filter_tag_type: "Web"
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.clearInsightTagInfo();
	      this.props.clearTagError();
	      if (this.props.selected_client && this.props.selected_client > 1) {
	        this.props.getClientSites(this.props.selected_client);
	        this.props.getClientTags(this.props.selected_client);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (nextProps.selected_client > 1) {
	          this.props.getClientSites(nextProps.selected_client);
	          this.props.getClientTags(nextProps.selected_client);
	        }
	      }
	      if (nextProps.tag_info && (0, _lodash.isUndefined)(this.props.tag_info)) {
	        var clientName = nextProps.client_info ? nextProps.client_info.name : "";
	        var buName = "";
	        if (nextProps.client_info && nextProps.client_info.parentClientId) {
	          buName = nextProps.client_info.name;
	          var c = (0, _lodash.find)(nextProps.clients, function (c) {
	            return c.id === nextProps.client_info.parentClientId;
	          });
	          clientName = c ? c.name : "";
	        }
	        this.setState({
	          clientName: clientName,
	          buName: buName
	        });
	      }
	    }
	  }, {
	    key: "backToListClick",
	    value: function backToListClick(e) {
	      e.preventDefault();
	      var client_info = this.props.client_info;
	
	      this.props.clearInsightTagInfoAndRefreh(client_info.id);
	    }
	  }, {
	    key: "clickCreateTag",
	    value: function clickCreateTag(e) {
	      e.preventDefault();
	      this.props.createNewTag();
	    }
	  }, {
	    key: "tagDetailContent",
	    value: function tagDetailContent(type) {
	      return _react2.default.createElement(_HtmlTagDetail2.default, Object.assign({
	        type: type,
	        clientName: this.state.clientName,
	        buName: this.state.buName,
	        imgTagName: this.state.imgTagName,
	        backToListClick: this.backToListClick.bind(this)
	      }, this.props));
	    }
	  }, {
	    key: "handleFilterTagTypeChanged",
	    value: function handleFilterTagTypeChanged(e) {
	      this.setState({
	        filter_tag_type: e.value
	      });
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      var _this2 = this;
	
	      var _props = this.props,
	          match = _props.match,
	          clients = _props.clients,
	          client_info = _props.client_info,
	          tag_info = _props.tag_info;
	
	      var showCreateTagBtn = this.props.roleId < 53 && this.props.roleId !== 5;
	      var tagDevOptions = [{ value: "Web", label: "Web Property" }, {
	        value: "Email",
	        label: "HTML Email" /*,
	                            { value: 'Mobile', label: 'Year to date' }*/
	      }];
	      switch (match.params.action) {
	        case "detail":
	          if (!(0, _lodash.isUndefined)(tag_info)) {
	            if (tag_info.deploymentType === "Web") return this.tagDetailContent("detail");else return _react2.default.createElement(_EmailTagDetail2.default, Object.assign({
	              clientName: this.state.clientName,
	              buName: this.state.buName,
	              type: "detail",
	              backToListClick: this.backToListClick.bind(this)
	            }, this.props));
	          }
	          this.props.history.push("/insights/tags/list");
	          break;
	        case "create":
	          var clientName = client_info ? client_info.name : "";
	          var buName = "";
	          if (client_info && client_info.parentClientId) {
	            buName = client_info.name;
	            var c = (0, _lodash.find)(clients, function (c) {
	              return c.id === client_info.parentClientId;
	            });
	            clientName = c ? c.name : "";
	          }
	          if ((0, _lodash.isNil)(tag_info)) {
	            return _react2.default.createElement(_TagCreation2.default, Object.assign({
	              clientName: clientName,
	              buName: buName,
	              tagDevOptions: tagDevOptions,
	              tag_variables: [],
	              tag_vars_deploy: "unique",
	              pass_variables: [],
	              hash_format: [],
	              hash_case: "upper"
	            }, this.props));
	          } else {
	            if (tag_info.deploymentType === "Web") return this.tagDetailContent("create");else return _react2.default.createElement(_EmailTagDetail2.default, Object.assign({
	              clientName: this.state.clientName,
	              backToListClick: this.backToListClick.bind(this),
	              buName: this.state.buName,
	              type: "create"
	            }, this.props));
	          }
	        default:
	          return _react2.default.createElement(
	            "div",
	            { className: "website-visits-content" },
	            _react2.default.createElement(
	              _Grid.Row,
	              { className: "no-padding mb-20 no-margin-top text-right" },
	              _react2.default.createElement(_Grid.Col, { xs: "8", sm: "8", md: "8", lg: "8" }),
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "4", sm: "4", md: "4", lg: "4", className: "text-right" },
	                showCreateTagBtn && _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-default legitRipple btn-aa-default"
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      onClick: function onClick(e) {
	                        _this2.clickCreateTag(e);
	                      }
	                    },
	                    "GENERATE INSIGHTS TAG"
	                  )
	                )
	              )
	            ),
	            (0, _lodash.isEmpty)(this.props.client_tags) ? _react2.default.createElement(
	              "div",
	              {
	                className: "black-border pb-10 text-center",
	                style: { minHeight: "200px", paddingTop: "80px" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { color: "#000", fontSize: "11pt", opacity: "0.8" }
	                },
	                "No insights data currently available."
	              )
	            ) : _react2.default.createElement(
	              "div",
	              {
	                className: "black-border pb-20 pl-20 pr-20",
	                style: { background: "#fff", minHeight: "200px" }
	              },
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "mt-20",
	                  style: { fontSize: "16px", fontWeight: "bold" }
	                },
	                "TAGS"
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "no-padding mb-20" },
	                _react2.default.createElement(
	                  "span",
	                  {
	                    style: {
	                      fontWeight: "bold",
	                      position: "absolute",
	                      top: "10px"
	                    }
	                  },
	                  "Tag Deployment Type"
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { style: { width: "180px", display: "inline-block" } },
	                  "\xA0"
	                ),
	                _react2.default.createElement(_reactSelect2.default, {
	                  value: this.state.filter_tag_type,
	                  name: "",
	                  clearable: false,
	                  options: tagDevOptions,
	                  searchable: false,
	                  onChange: this.handleFilterTagTypeChanged.bind(this)
	                })
	              ),
	              this.state.filter_tag_type === "Web" ? _react2.default.createElement(_WebTagsTable2.default, {
	                client_tags: this.props.client_tags,
	                getTagDetail: this.props.getTagDetail,
	                client_info: this.props.client_info
	              }) : _react2.default.createElement(_EmailTagsTable2.default, {
	                client_tags: this.props.client_tags,
	                getTagDetail: this.props.getTagDetail,
	                client_info: this.props.client_info
	              })
	            )
	          );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var websiteId = this.props.websiteId;
	
	
	      return _react2.default.createElement(
	        "div",
	        { id: "website-visits-container", style: { background: "#fafafa" } },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              padding: "0 10%",
	              marginTop: "-20px",
	              marginBottom: "-10px",
	              background: "#FAFAFA"
	            }
	          },
	          _react2.default.createElement(_SiteDateSelector2.default, {
	            key: "map-site-date-selector-" + new Date().getTime(),
	            websiteIdChanged: this.props.setWebsiteId,
	            siteId: websiteId,
	            sites: this.props.client_sites,
	            dayRangeChanged: this.props.setDateRange,
	            dayRange: this.props.dayRange
	          })
	        ),
	        _react2.default.createElement(_InsightNav2.default, {
	          activeIndex: 4,
	          clientId: this.props.selected_client,
	          tagId: websiteId
	        }),
	        this.getContent()
	      );
	    }
	  }]);
	
	  return TagIndex;
	}(_MaterialUI2.default);
	
	exports.default = TagIndex;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Grid = __webpack_require__(19);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkStyle = {
	  color: "#215E9B"
	};
	
	var BasicTierUpgradeInform = function (_AcquireWebComponent) {
	  _inherits(BasicTierUpgradeInform, _AcquireWebComponent);
	
	  function BasicTierUpgradeInform(props) {
	    _classCallCheck(this, BasicTierUpgradeInform);
	
	    var _this = _possibleConstructorReturn(this, (BasicTierUpgradeInform.__proto__ || Object.getPrototypeOf(BasicTierUpgradeInform)).call(this, props));
	
	    _this.state = {
	      subject: undefined,
	      comments: undefined,
	      openBasicTierContactForm: false,
	      showBasicTierSuccessForm: false
	    };
	    return _this;
	  }
	
	  _createClass(BasicTierUpgradeInform, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.request_assist_successful === true && (0, _isUndefined2.default)(this.props.request_assist_successful) && this.state.openBasicTierContactForm) {
	        this.setState({
	          subject: undefined,
	          comments: undefined,
	          showBasicTierSuccessForm: true,
	          openBasicTierContactForm: false
	        });
	      }
	    }
	  }, {
	    key: "btnContactClick",
	    value: function btnContactClick(e) {
	      e.preventDefault();
	      this.setState({
	        subject: undefined,
	        comments: undefined,
	        openBasicTierContactForm: true,
	        showBasicTierSuccessForm: false
	      });
	    }
	  }, {
	    key: "btnSubmitClick",
	    value: function btnSubmitClick(e) {
	      e.preventDefault();
	      var postData = {
	        clientId: this.props.selected_client,
	        subject: this.state.subject.trim(),
	        comment: this.state.comments.trim(),
	        originationPage: this.props.originationPage,
	        type: "upgrade"
	      };
	      this.props.onContactFormSubmit(postData);
	    }
	  }, {
	    key: "btnGobackClick",
	    value: function btnGobackClick(e) {
	      e.preventDefault();
	      this.props.closeDialog();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var actionButtons = [this.props.send_assist_request_error && _react2.default.createElement(
	        "div",
	        {
	          className: "pull-left ml-20 mt-5",
	          style: { fontWeight: "bold", color: "#FF0000" }
	        },
	        this.props.send_assist_request_error
	      ), _react2.default.createElement(
	        "button",
	        {
	          onClick: function onClick() {
	            _this2.setState({ openBasicTierContactForm: false });
	            if (_this2.props.onCancel) {
	              _this2.props.onCancel();
	            }
	          },
	          className: "btn btn-default btn-aa-info mr-10"
	        },
	        "Cancel"
	      ), (0, _isEmpty2.default)(this.state.comments) || (0, _isEmpty2.default)(this.state.subject) ? _react2.default.createElement(
	        "button",
	        { disabled: true, className: "btn btn-default btn-aa-info mr-10" },
	        "Submit"
	      ) : _react2.default.createElement(
	        "button",
	        {
	          onClick: this.btnSubmitClick.bind(this),
	          className: "btn btn-aa-default mr-10"
	        },
	        "Submit"
	      )];
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.props.showUpgradeInfoDialog && !this.state.openBasicTierContactForm && !this.state.showBasicTierSuccessForm,
	            contentStyle: { width: "450px", maxWidth: "500px" },
	            bodyStyle: {
	              border: "none",
	              color: "#000",
	              fontSize: "13px",
	              fontWeight: "bold",
	              padding: "20px 20px 10px"
	            },
	            actions: [_react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-default btn-aa-info",
	                style: { fontWeight: "bold" },
	                onClick: this.btnGobackClick.bind(this)
	              },
	              "CANCEL"
	            )],
	            actionsContainerStyle: {
	              textAlign: "center",
	              paddingBottom: "20px",
	              fontWeight: "bold"
	            },
	            style: { zIndex: "1600", paddingRight: "5%" }
	          },
	          this.props.roleId > 50 ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontFamily: "Arial",
	                fontSize: "16px",
	                lineHeight: "20px"
	              }
	            },
	            "Your subscription tier does not support this option. Please",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { style: linkStyle, onClick: this.btnContactClick.bind(this) },
	              "click here"
	            ),
	            " ",
	            "to contact your client services representative to discuss upgrading your account."
	          ) : _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontFamily: "Arial",
	                fontSize: "16px",
	                lineHeight: "20px"
	              }
	            },
	            "Your subscription tier does not support this option. Please contact your client services representative to discuss upgrading your account."
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.openBasicTierContactForm,
	            contentStyle: { width: "540px" },
	            titleClassName: "support-form-title",
	            bodyClassName: "support-form-body",
	            actionsContainerClassName: "support-form-action-container",
	            title: "CONTACT US",
	            modal: true,
	            actions: actionButtons
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-left no-padding-right no-padding-bottom pt-10 no-margin-bottom" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3", className: "pt-10" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Subject"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "9", sm: "9", md: "9", lg: "9" },
	              _react2.default.createElement("input", {
	                type: "text",
	                style: { width: "100%" },
	                value: this.state.subject,
	                maxLength: "65",
	                onChange: function onChange(e) {
	                  _this2.setState({ subject: e.target.value });
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-left no-padding-right no-padding-bottom no-margin-bottom" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "3", sm: "3", md: "3", lg: "3", className: "pt-10" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Comments"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "9", sm: "9", md: "9", lg: "9" },
	              _react2.default.createElement("textarea", {
	                className: "comment-box",
	                value: this.state.comments,
	                maxLength: "500",
	                onChange: function onChange(e) {
	                  _this2.setState({ comments: e.target.value });
	                }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            open: this.state.showBasicTierSuccessForm,
	            onRequestClose: function onRequestClose() {
	              _this2.setState({ showBasicTierSuccessForm: false });
	            },
	            contentStyle: { width: "350px", padding: "20px" },
	            modal: true
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: { fontSize: "16px", fontFamily: "Arial", color: "#000" },
	              className: "text-center"
	            },
	            "Your message has been sent."
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: { fontSize: "15px", fontFamily: "Arial", color: "#000" },
	              className: "text-center mt-10"
	            },
	            "Your client services representative will contact you within one business day."
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "text-center mt-20" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-default btn-aa-default",
	                onClick: this.btnGobackClick.bind(this)
	              },
	              "CLOSE"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BasicTierUpgradeInform;
	}(_MaterialUI2.default);
	
	BasicTierUpgradeInform.propTypes = {
	  send_assist_request_error: _propTypes2.default.string,
	  showUpgradeInfoDialog: _propTypes2.default.bool,
	  onContactFormSubmit: _propTypes2.default.func,
	  selected_client: _propTypes2.default.number,
	  originationPage: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  request_assist_successful: _propTypes2.default.bool,
	  roleId: _propTypes2.default.number
	};
	
	BasicTierUpgradeInform.default = {
	  showUpgradeInfoDialog: false
	};
	
	exports.default = BasicTierUpgradeInform;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PieChartTable = __webpack_require__(356);
	
	var _PieChartTable2 = _interopRequireDefault(_PieChartTable);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(271);
	
	var DeviceInsights = function (_AcquireWebComponent) {
	  _inherits(DeviceInsights, _AcquireWebComponent);
	
	  function DeviceInsights() {
	    _classCallCheck(this, DeviceInsights);
	
	    return _possibleConstructorReturn(this, (DeviceInsights.__proto__ || Object.getPrototypeOf(DeviceInsights)).apply(this, arguments));
	  }
	
	  _createClass(DeviceInsights, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          deviceModelData = _props.deviceModelData,
	          deviceTypeData = _props.deviceTypeData,
	          top5OSBreakDown = _props.top5OSBreakDown;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "mt-20", style: { display: "flex" } },
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "50%" } },
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border mb-10", id: "device-pdf-part1" },
	              deviceTypeData && _react2.default.createElement(_PieChartTable2.default, {
	                data: deviceTypeData.values,
	                showUniqVisitsTitle: true,
	                dataKey: "value",
	                title: "Device Breakdown",
	                tableTitle: deviceTypeData.name
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border", id: "device-pdf-part2" },
	              deviceModelData && _react2.default.createElement(_PieChartTable2.default, {
	                data: deviceModelData.values,
	                showUniqVisitsTitle: true,
	                dataKey: "value",
	                title: "Model Breakdown",
	                tableTitle: deviceModelData.name
	              })
	            )
	          ),
	          _react2.default.createElement("div", { style: { flex: "20px" } }),
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "50%" } },
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border", id: "device-pdf-part3" },
	              top5OSBreakDown && _react2.default.createElement(_PieChartTable2.default, {
	                data: top5OSBreakDown.values,
	                showUniqVisitsTitle: true,
	                dataKey: "value",
	                title: "OS Breakdown",
	                tableTitle: top5OSBreakDown.name
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DeviceInsights;
	}(_MaterialUI2.default);
	
	exports.default = DeviceInsights;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListGraphicV2 = function (_AcquireWebComponent) {
	  _inherits(ListGraphicV2, _AcquireWebComponent);
	
	  function ListGraphicV2() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ListGraphicV2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListGraphicV2.__proto__ || Object.getPrototypeOf(ListGraphicV2)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function () {
	      var wrapValue = function wrapValue(val) {
	        if (val === "N/A") {
	          return "Unknown";
	        }
	        if (val === "0.00%") {
	          return "Unknown";
	        }
	        return val;
	      };
	      return function (obj, idx) {
	        return _react2.default.createElement(
	          "div",
	          {
	            key: "list-" + idx,
	            className: "light-grey-top-border pb-15 pt-15 pr-20",
	            style: { display: "flex", justifyContent: "space-between" }
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              obj.name
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "pl-20" },
	              wrapValue(obj.value)
	            )
	          )
	        );
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ListGraphicV2, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          data = _props.data,
	          footer = _props.footer,
	          subTitle = _props.subTitle;
	
	
	      if ((0, _lodash.isEmpty)(data)) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: { fontSize: "24px", fontWeight: "bold", textTransform: 'capitalize' } },
	            title
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                minHeight: "200px",
	                textAlign: "center",
	                paddingTop: "60px",
	                color: "#CDCDCD"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#CDCDCD", fontSize: "24px", opacity: "0.8" } },
	              "No Data"
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "list-title", style: {
	              fontSize: '24px',
	              fontWeight: 'bold',
	              textTransform: 'capitalize'
	            } },
	          title
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "text-right mt-10 mb-10",
	            style: {
	              fontSize: "16px",
	              background: "#F5F5F5",
	              padding: "15px 20px"
	            }
	          },
	          _react2.default.createElement(
	            "strong",
	            null,
	            subTitle
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          (0, _lodash.map)(data, this.renderItem())
	        ),
	        footer && _react2.default.createElement(
	          "div",
	          null,
	          footer
	        )
	      );
	    }
	  }]);
	
	  return ListGraphicV2;
	}(_MaterialUI2.default);
	
	exports.default = ListGraphicV2;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _take = __webpack_require__(678);
	
	var _take2 = _interopRequireDefault(_take);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactHighlightWords = __webpack_require__(950);
	
	var _reactHighlightWords2 = _interopRequireDefault(_reactHighlightWords);
	
	var _utility = __webpack_require__(14);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(271);
	
	var MostPopularPageInsights = function (_AcquireWebComponent) {
	  _inherits(MostPopularPageInsights, _AcquireWebComponent);
	
	  function MostPopularPageInsights(props) {
	    _classCallCheck(this, MostPopularPageInsights);
	
	    var _this = _possibleConstructorReturn(this, (MostPopularPageInsights.__proto__ || Object.getPrototypeOf(MostPopularPageInsights)).call(this, props));
	
	    _this.state = {
	      pageCount: 20,
	      filter: "",
	      errorKey: "",
	      mostPopularPages: undefined,
	      showEmptyError: false
	    };
	    return _this;
	  }
	
	  _createClass(MostPopularPageInsights, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      if (!(0, _isEqual2.default)(nextProps.data, this.props.data)) {
	        this.setState({
	          mostPopularPages: nextProps.data
	        });
	      }
	    }
	  }, {
	    key: "renderNoDate",
	    value: function renderNoDate() {
	      return _react2.default.createElement(
	        "div",
	        { style: { width: '100%', minHeight: '180px', textAlign: 'center', paddingTop: '80px', color: "#CDCDCD" } },
	        _react2.default.createElement(
	          "div",
	          { style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
	          "No Data"
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          loadingPopularPages = _props.loadingPopularPages,
	          loadingPopularPagesError = _props.loadingPopularPagesError,
	          client_info = _props.client_info,
	          pdfCreating = _props.pdfCreating;
	
	      var containerheight = this.state.pageCount === 20 ? "auto" : "800px";
	      var pages = (0, _take2.default)(this.state.mostPopularPages, this.state.pageCount);
	
	      var filterPages = (0, _isEmpty2.default)(this.state.filter) ? pages : (0, _filter2.default)(pages, function (page) {
	        return page.pageUrl.indexOf(_this2.state.filter) >= 0;
	      });
	
	      var route = window.location.pathname + window.location.search;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "mt-20 p-20 light-grey-border", id: "most-popular-pdf-mark" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h1",
	            { className: "no-margin popular-pdf-part", style: { fontWeight: 'bold' } },
	            "Most Popular Pages"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", marginTop: "20px" } },
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "1 1 420px" } },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "inline-block",
	                  marginRight: "10px"
	                }
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Popular page search"
	              )
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: function onChange(e) {
	                _this2.setState({ filter: e ? e.target.value : "" });
	              },
	              style: {
	                width: "250px",
	                border: "solid 1px #BDBDBD",
	                marginTop: "5px",
	                marginLeft: "10px",
	                padding: "5px 10px",
	                lineHieght: "20px"
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "1 1 200px", textAlign: "right" } },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "inline-block",
	                  marginRight: "0px"
	                }
	              },
	              "View"
	            ),
	            client_info && parseInt(client_info.subscriptionTierId, 10) >= 3 ? _react2.default.createElement(_reactSelect2.default, {
	              className: "pop-pages-count-selector",
	              name: "",
	              value: this.state.pageCount,
	              clearable: false,
	              searchable: false,
	              onChange: function onChange(e) {
	                _this2.setState({ pageCount: e.value });
	              },
	              options: [{ value: 20, label: "20" }, { value: 50, label: "50" }, { value: 100, label: "100" }]
	            }) : _react2.default.createElement(
	              "span",
	              { className: "ml-10", style: { marginRight: "-10px" } },
	              "20"
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "inline-block",
	                  marginLeft: "20px"
	                }
	              },
	              "Popular Pages"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "popular-pdf-part",
	            style: {
	              marginTop: "20px",
	              padding: "10px 20px 20px",
	              background: "#F5F5F5",
	              display: "flex",
	              justifyContent: "space-between"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { width: "85%", paddingTop: "10px" } },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Page Name"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { width: "15%", paddingTop: "10px" } },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Total Visits"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              textAlign: "left"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                overflowY: containerheight === "auto" ? "hidden" : "auto",
	                height: containerheight,
	                display: loadingPopularPages || loadingPopularPagesError ? "none" : "block"
	              }
	            },
	            filterPages && filterPages.length > 0 ? (0, _map2.default)(filterPages, function (page) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: "page-" + page.pageUrl,
	                  className: "light-grey-border-bottom popular-pdf-part",
	                  style: { padding: "10px 20px 20px", display: "flex" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      width: "85%",
	                      paddingTop: "10px",
	                      paddingRight: "20px",
	                      overflow: "hidden",
	                      whiteSpace: "nowrap",
	                      textOverflow: "ellipsis"
	                    }
	                  },
	                  client_info && parseInt(client_info.subscriptionTierId, 10) >= 3 ? _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: route + "&pop_url=" + encodeURIComponent(page.pageUrl)
	                    },
	                    (0, _isEmpty2.default)(_this2.state.filter) ? page.pageUrl : _react2.default.createElement(_reactHighlightWords2.default, {
	                      highlightClassName: "clickable",
	                      searchWords: [_this2.state.filter],
	                      autoEscape: true,
	                      textToHighlight: page.pageUrl
	                    })
	                  ) : _react2.default.createElement(_reactHighlightWords2.default, {
	                    highlightClassName: "clickable",
	                    searchWords: [_this2.state.filter],
	                    autoEscape: true,
	                    textToHighlight: page.pageUrl
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "15%", paddingTop: "10px" } },
	                  (0, _utility.splitNumber)(page.totalVisits + "")()
	                )
	              );
	            }) : this.renderNoDate()
	          )
	        )
	      );
	    }
	  }]);
	
	  return MostPopularPageInsights;
	}(_MaterialUI2.default);
	
	exports.default = MostPopularPageInsights;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _PieChartTable = __webpack_require__(356);
	
	var _PieChartTable2 = _interopRequireDefault(_PieChartTable);
	
	var _LineGraphic = __webpack_require__(519);
	
	var _LineGraphic2 = _interopRequireDefault(_LineGraphic);
	
	var _utility = __webpack_require__(14);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _HeatMap = __webpack_require__(518);
	
	var _HeatMap2 = _interopRequireDefault(_HeatMap);
	
	var _ListGraphic = __webpack_require__(520);
	
	var _ListGraphic2 = _interopRequireDefault(_ListGraphic);
	
	var _ListGraphic3 = __webpack_require__(1124);
	
	var _ListGraphic4 = _interopRequireDefault(_ListGraphic3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(271);
	
	var google = window.google;
	
	var OverviewInsights = function (_AcquireWebComponent) {
	  _inherits(OverviewInsights, _AcquireWebComponent);
	
	  function OverviewInsights() {
	    _classCallCheck(this, OverviewInsights);
	
	    return _possibleConstructorReturn(this, (OverviewInsights.__proto__ || Object.getPrototypeOf(OverviewInsights)).apply(this, arguments));
	  }
	
	  _createClass(OverviewInsights, [{
	    key: "businessOverview",
	    value: function businessOverview(totalVisitsCount, uniqueVisitsCount, reachSum) {
	      return _react2.default.createElement(
	        "div",
	        { className: "light-grey-border" },
	        _react2.default.createElement(
	          "div",
	          { className: "mt-20 ml-20", style: { height: "16px" } },
	          _react2.default.createElement(
	            "p",
	            { style: { fontSize: "24px", height: "16px", fontWeight: "bold" } },
	            "Domestic Business Information"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "no-margin-bottom pt-20 pb-20 mt-20",
	            style: { fontWeight: "300", display: "flex" }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                flex: "1 1",
	                paddingLeft: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  color: "#000",
	                  marginTop: "20px",
	                  marginRight: "20px",
	                  textAlign: "left"
	                }
	              },
	              "Total Visits"
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: "60px",
	                  fontWeight: "normal",
	                  color: "#32A59D",
	                  paddingRight: "20px",
	                  textAlign: "left"
	                }
	              },
	              (0, _utility.splitNumber)(totalVisitsCount + "")()
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "pr-10 pl-20 light-grey-left-border",
	              style: {
	                width: "40%",
	                display: "flex",
	                alignItems: "center"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  width: "100%",
	                  textAlign: "left",
	                  padding: "20px",
	                  lineHeight: "18px",
	                  marginBottom: "10px"
	                }
	              },
	              "We can reach at least",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                reachSum ? (0, _utility.splitNumber)(reachSum.total + "")() : 0
	              ),
	              " ",
	              "of these unique business"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "ml-10 light-grey-left-border pl-20 pt-5",
	              style: {
	                justifyContent: "flex-end",
	                flex: "1 1"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  color: "#000",
	                  marginTop: "20px",
	                  marginRight: "20px",
	                  textAlign: "left"
	                }
	              },
	              "Unique Visits"
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: "60px",
	                  fontWeight: "normal",
	                  marginTop: "-3px",
	                  color: "#32A59D",
	                  marginRight: "20px",
	                  textAlign: "left"
	                }
	              },
	              (0, _utility.splitNumber)(uniqueVisitsCount + "")()
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          visitsByTime = _props.visitsByTime,
	          _props$geoTrafficeDat = _props.geoTrafficeData,
	          geoTrafficeData = _props$geoTrafficeDat === undefined ? [] : _props$geoTrafficeDat,
	          timeTraffic = _props.timeTraffic,
	          timeTrafficStatsTitle = _props.timeTrafficStatsTitle,
	          visitsSummary = _props.visitsSummary,
	          selected_client = _props.selected_client,
	          kindOfReport = _props.kindOfReport,
	          statsByRegionalTraffic = _props.statsByRegionalTraffic,
	          heatMapData = _props.heatMapData,
	          loadingStatsByRegionalTraffic = _props.loadingStatsByRegionalTraffic,
	          reportType = _props.reportType,
	          deviceTypeData = _props.deviceTypeData,
	          demoData = _props.demoData,
	          popUrl = _props.popUrl,
	          statsByPopularPages = _props.statsByPopularPages,
	          pdfCreating = _props.pdfCreating;
	
	      var randomStr = new Date().getTime();
	
	      if (kindOfReport === "map") {
	        return _react2.default.createElement(
	          "div",
	          { className: "p-20 light-grey-border" },
	          _react2.default.createElement(_HeatMap2.default, {
	            key: "overview-geographic-" + randomStr,
	            width: 960,
	            height: 600,
	            title: "Geographic Traffic",
	            data: statsByRegionalTraffic,
	            onLoading: loadingStatsByRegionalTraffic,
	            pointsData: heatMapData
	          })
	        );
	      }
	      if ((0, _isUndefined2.default)(visitsSummary)) {
	        return _react2.default.createElement(
	          "div",
	          {
	            className: "overview-insights-container",
	            style: { fontSize: "16px" }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                float: "left",
	                height: "200px",
	                width: "100%",
	                position: "relative",
	                padding: "20px"
	              }
	            },
	            _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } }),
	            "\xA0loading..."
	          )
	        );
	      }
	      var reachStats = visitsSummary.reachStats,
	          totalVisitsCount = visitsSummary.totalVisitsCount,
	          uniqueVisitsCount = visitsSummary.uniqueVisitsCount;
	
	      return _react2.default.createElement(
	        "div",
	        { id: "overview-container-box" },
	        reportType === "business" ? this.businessOverview(totalVisitsCount, uniqueVisitsCount, reachStats) : _react2.default.createElement(
	          "div",
	          {
	            className: "mt-20 p-20 light-grey-border",
	            id: "consumer-overflow-pdf-part2"
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { fontSize: "24px", fontWeight: "bold" } },
	            "Overview"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "mt-20", style: { display: "flex" } },
	            _react2.default.createElement(
	              "div",
	              {
	                style: { width: '100%' },
	                className: "light-grey-right-border"
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { textAlign: "center" } },
	                "Total Visits"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "light-grey-bottom-border",
	                  style: {
	                    fontSize: "64px",
	                    color: "#32A59D",
	                    textAlign: "center"
	                  }
	                },
	                (0, _utility.splitNumber)(totalVisitsCount + "")()
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "mt-20", style: { textAlign: "center" } },
	                "Unique Visits"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "pb-20",
	                  style: {
	                    fontSize: "64px",
	                    color: "#32A59D",
	                    textAlign: "center"
	                  }
	                },
	                (0, _utility.splitNumber)(uniqueVisitsCount + "")()
	              )
	            )
	          )
	        ),
	        reportType === "business" && _react2.default.createElement(
	          "div",
	          { className: "mt-20 light-grey-border", key: "1" },
	          _react2.default.createElement(
	            "div",
	            { style: { padding: "20px" } },
	            _react2.default.createElement(_ListGraphic2.default, {
	              title: "Business Firmographic",
	              mode: "business",
	              data: demoData,
	              key: "demographic-section-2",
	              footer: this.props.popUrl || pdfCreating ? undefined : _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/insights/business?nav=fir&cid=" + selected_client
	                },
	                "View Frequent Visitors"
	              )
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "pb-10" },
	              geoTrafficeData && _react2.default.createElement(_PieChartTable2.default, {
	                data: geoTrafficeData,
	                showUniqVisitsTitle: true,
	                dataKey: "value",
	                title: "Geographic Traffic",
	                tableTitle: "States",
	                inLine: true,
	                footer: !pdfCreating && !this.props.popUrl && _react2.default.createElement(
	                  "div",
	                  { style: { padding: "15px 0 5px 30px" } },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: this.props.reportType + "/map?cid=" + selected_client
	                    },
	                    "View on a Map"
	                  )
	                )
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "mt-20",
	            id: "consumer-overflow-pdf-part3",
	            style: { display: "flex", justifyContent: "space-between" }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { width: "49%" } },
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border" },
	              visitsByTime && _react2.default.createElement(_PieChartTable2.default, {
	                data: visitsByTime,
	                showUniqVisitsTitle: true,
	                dataKey: "value",
	                title: "Visits by Time of Day",
	                tableTitle: "Time of Day"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { width: "49%" } },
	            _react2.default.createElement(
	              "div",
	              { className: "light-grey-border" },
	              reportType === "business" ? deviceTypeData && _react2.default.createElement(_PieChartTable2.default, {
	                data: deviceTypeData.values,
	                showUniqVisitsTitle: true,
	                dataKey: "value",
	                title: "Device",
	                tableTitle: deviceTypeData.name
	              }) : geoTrafficeData && [_react2.default.createElement(_PieChartTable2.default, {
	                key: "11",
	                data: geoTrafficeData,
	                showUniqVisitsTitle: true,
	                dataKey: "value",
	                title: "Geographic Traffic",
	                tableTitle: "States"
	              }), geoTrafficeData && geoTrafficeData.length > 0 && !pdfCreating && !this.props.popUrl && _react2.default.createElement(
	                "div",
	                { key: "12", className: "mb-20" },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  {
	                    className: "ml-20",
	                    to: this.props.reportType + "/map?cid=" + selected_client
	                  },
	                  "View on a Map"
	                )
	              )]
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "p-20 mt-20 light-grey-border",
	            id: "consumer-overflow-pdf-part4"
	          },
	          _react2.default.createElement(_LineGraphic2.default, {
	            animation: false,
	            key: "time-traffic-section",
	            title: reportType === "business" ? "Traffic" : "Consumer Traffic",
	            data: timeTraffic,
	            type: reportType,
	            subTitle: timeTrafficStatsTitle + " - " + (0, _utility.timezonLabel)(this.props.client_info.timezone)
	          })
	        ),
	        reportType === "business" && !popUrl && _react2.default.createElement(
	          "div",
	          { className: "mt-20" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "light-grey-border p-20",
	              style: { display: "inline-block", minWidth: "50%" }
	            },
	            statsByPopularPages && _react2.default.createElement(_ListGraphic4.default, {
	              title: "Most Popular Pages",
	              data: statsByPopularPages,
	              key: "demographic-section-pop-pages",
	              subTitle: "Unique Visits",
	              footer: pdfCreating ? null : _react2.default.createElement(
	                "div",
	                { className: "pt-20 light-grey-top-border" },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  {
	                    to: "/insights/business?cid=" + this.props.selected_client + "&nav=pop"
	                  },
	                  "View More Page Information"
	                )
	              )
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return OverviewInsights;
	}(_MaterialUI2.default);
	
	exports.default = OverviewInsights;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(271);
	
	var SideBar = function (_AcquireWebComponent) {
	  _inherits(SideBar, _AcquireWebComponent);
	
	  function SideBar(props) {
	    _classCallCheck(this, SideBar);
	
	    return _possibleConstructorReturn(this, (SideBar.__proto__ || Object.getPrototypeOf(SideBar)).call(this, props));
	  }
	
	  _createClass(SideBar, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          mainFlexStyle = _props.mainFlexStyle,
	          clientId = _props.clientId,
	          _props$reportType = _props.reportType,
	          reportType = _props$reportType === undefined ? "consumer" : _props$reportType,
	          pageUrl = _props.pageUrl;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          id: "left-nav",
	          style: { flex: mainFlexStyle ? mainFlexStyle : "0 0 280px" }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-border" },
	          _react2.default.createElement(
	            "div",
	            {
	              onClick: function onClick() {
	                _this2.props.history.push("/insights/" + reportType + "?cid=" + clientId + "&nav=overview");
	              },
	              style: { height: "58px", padding: "15px 20px 15px 35px" },
	              className: this.props.type === "overview" ? "side-bar-item-active" : "side-bar-item"
	            },
	            "Overview"
	          ),
	          reportType === "consumer" ? [_react2.default.createElement(
	            "div",
	            {
	              key: "3",
	              onClick: function onClick() {
	                _this2.props.history.push("/insights/consumer?cid=" + clientId + "&nav=device");
	              },
	              style: { height: "58px", padding: "15px 20px 15px 35px" },
	              className: this.props.type === "device" ? "side-bar-item-active" : "side-bar-item"
	            },
	            "Devices"
	          )] : _react2.default.createElement(
	            "div",
	            {
	              key: "3",
	              onClick: function onClick() {
	                _this2.props.history.push("/insights/business?cid=" + clientId + "&nav=fir");
	              },
	              style: { height: "58px", padding: "15px 20px 15px 35px" },
	              className: this.props.type === "fir" ? "side-bar-item-active" : "side-bar-item"
	            },
	            "Business Firmographic"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              onClick: function onClick() {
	                _this2.props.history.push("/insights/" + reportType + "?cid=" + clientId + "&nav=pop");
	              },
	              style: { height: "58px", padding: "15px 20px 15px 35px" },
	              className: this.props.type === "pop" ? "distribution-type-active" : "distribution-type"
	            },
	            "Most Popular Pages"
	          )
	        )
	      );
	    }
	  }]);
	
	  return SideBar;
	}(_MaterialUI2.default);
	
	exports.default = SideBar;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createCsvFile;
	
	var _utility = __webpack_require__(14);
	
	var _lodash = __webpack_require__(18);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createCsvFile() {
	  var nav = (0, _utility.getUrlParameterByName)("nav") || "overview";
	  var popUrl = (0, _utility.getUrlParameterByName)("pop_url");
	  switch (nav) {
	    case "overview":
	      {
	        overview.call(this);
	        break;
	      }
	    case "pop":
	      {
	        if (popUrl) {
	          popularPage.call(this, popUrl);
	        }
	        break;
	      }
	    case "demographics":
	      {
	        demographics.call(this);
	        break;
	      }
	    case "additional-demographics":
	      {
	        addDemo.call(this);
	        break;
	      }
	    case "device":
	      {
	        device.call(this);
	        break;
	      }
	  }
	}
	
	function createFilename(d, type) {
	  var _props = this.props,
	      client_tags = _props.client_tags,
	      websiteId = _props.websiteId;
	
	  var tag = client_tags ? client_tags.find(function (it) {
	    return it.id === websiteId;
	  }) : null;
	  var domain = tag && tag.domain ? tag.domain : "Unknown";
	  var dayRange = this.getDayRangeTitle(d).replace(/\s+/g, "");
	  var time = (0, _moment2.default)().format("YYYYMMDD");
	  return domain + "_" + dayRange + "_" + type + "_" + time;
	}
	
	function device() {
	  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	  var _props2 = this.props,
	      statsByDevice = _props2.statsByDevice,
	      statsByOsType = _props2.statsByOsType,
	      statsByDeviceModel = _props2.statsByDeviceModel,
	      client_info = _props2.client_info,
	      client_sites = _props2.client_sites,
	      websiteId = _props2.websiteId,
	      dayRange = _props2.dayRange;
	
	  var client_name = client_info.name;
	  var websiteName = "";
	  if (client_sites && client_sites.length > 0) {
	    for (var i = 0; i < client_sites.length; i++) {
	      if (Number(client_sites[i].value) === Number(websiteId)) {
	        websiteName = client_sites[i].label;
	        break;
	      }
	    }
	  }
	  var s = client_sites.find(function (site) {
	    return site.value === websiteId;
	  });
	  var csvFileName = createFilename.call(this, dayRange, "Site Analytics Devices");
	  var title = "Report Details,\r\n";
	  var title_line = (websiteName ? websiteName + " " : "") + "Site Analytics Devices Report,\r\n";
	  var report_date_line = "Date," + (0, _moment2.default)().format("MM/DD/YYYY") + ",\r\n";
	  var client_name_line = "Client Name," + client_name + ",\r\n";
	  var date_filter_line = "Campaign Date Filter," + (0, _utility.getDayRangeTitle)(dayRange) + ",\r\n";
	  // let pageName = `Page Name,${popUrl},,,,,,\r\n`;
	  var breakLine = ",,,,,,,\r\n";
	  function formatNumber(num, total) {
	    return total > 0 ? Math.round(num / total * 10000, 10) / 100 + "%" : "-";
	  }
	  function reduce(values) {
	    return values.reduce(function (a, b) {
	      if (typeof a === "number") return a + b.value;else return a.value + b.value;
	    });
	  }
	  function formatLine(data) {
	    if (data && data.length > 0) {
	      var line_str = "";
	      var total = reduce(data);
	      data.forEach(function (it) {
	        line_str += it.key + "," + formatNumber(it.value, total) + ",\r\n";
	      });
	      return line_str;
	    } else {
	      return "";
	    }
	  }
	  function sort(data) {
	    if (data && data.length > 0) {
	      data.sort(function (a, b) {
	        return b.value - a.value;
	      });
	    }
	    return data;
	  }
	  var device_line = "Device Insights,\r\n";
	  device_line += "Device Type,\r\n";
	  device_line += formatLine(sort(statsByDevice && statsByDevice.values));
	  var type_line = "Operating System,\r\n";
	  type_line += formatLine(sort(statsByOsType && statsByOsType.values));
	  var model_line = "Device Model,\r\n";
	  model_line += formatLine(sort(statsByDeviceModel && statsByDeviceModel.values));
	
	  var data = title + title_line + report_date_line + client_name_line + date_filter_line + breakLine + device_line + breakLine + type_line + breakLine + model_line;
	  (0, _utility.downLoadCSVFunc)(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
	  setTimeout(function () {
	    this.setState({ onCsvReportDownload: false });
	  }.bind(this), 2000);
	}
	
	function addDemo() {
	  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	  var _props3 = this.props,
	      statsTopAttributes = _props3.statsTopAttributes,
	      client_info = _props3.client_info,
	      client_sites = _props3.client_sites,
	      websiteId = _props3.websiteId,
	      dayRange = _props3.dayRange;
	
	  var client_name = client_info.name;
	  var websiteName = "";
	  if (client_sites && client_sites.length > 0) {
	    for (var i = 0; i < client_sites.length; i++) {
	      if (Number(client_sites[i].value) === Number(websiteId)) {
	        websiteName = client_sites[i].label;
	        break;
	      }
	    }
	  }
	  var s = client_sites.find(function (site) {
	    return site.value === websiteId;
	  });
	  var csvFileName = createFilename.call(this, dayRange, "Site Analytics Demographic and Behavior");
	  var title = "Report Details,\r\n";
	  var title_line = (websiteName ? websiteName + " " : "") + "Site Analytics Demographics and Behaviors Report,\r\n";
	  var report_date_line = "Date," + (0, _moment2.default)().format("MM/DD/YYYY") + ",\r\n";
	  var client_name_line = "Client Name," + client_name + ",\r\n";
	  var date_filter_line = "Campaign Date Filter," + (0, _utility.getDayRangeTitle)(dayRange) + ",\r\n";
	  // let pageName = `Page Name,${popUrl},,,,,,\r\n`;
	  var breakLine = ",,,,,,,\r\n";
	  var behavioral = statsTopAttributes.behavioral,
	      demographic = statsTopAttributes.demographic;
	
	  function formatNumber(num) {
	    return (num * 100).toFixed(2) + "%";
	  }
	  function formatLine(data) {
	    if (data && data.length > 0) {
	      var line_str = "";
	      data.forEach(function (it) {
	        line_str += it.name + "," + it.label + "," + formatNumber(it.visitorPercentage) + ",\r\n";
	      });
	      return line_str;
	    } else {
	      return "";
	    }
	  }
	  function sort(data) {
	    if (data && data.length > 0) {
	      data.sort(function (a, b) {
	        return b.visitors - a.visitors;
	      });
	    }
	    return data;
	  }
	  var line1 = "Popular Demographic/Household Attributes,\r\n";
	  line1 += "Attribute,Value Pair,Unique Visits,\r\n";
	  line1 += formatLine(sort(demographic));
	  var line2 = "Popular Behavioral Attributes,\r\n";
	  line2 += "Attribute,Value Pair,Unique Visits\r\n";
	  line2 += formatLine(sort(behavioral));
	  var data = title + title_line + report_date_line + client_name_line + date_filter_line + breakLine + line1 + breakLine + line2;
	  (0, _utility.downLoadCSVFunc)(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
	  setTimeout(function () {
	    this.setState({ onCsvReportDownload: false });
	  }.bind(this), 2000);
	}
	
	function demographics() {
	  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	  var _props4 = this.props,
	      client_info = _props4.client_info,
	      client_sites = _props4.client_sites,
	      websiteId = _props4.websiteId,
	      dayRange = _props4.dayRange;
	
	  var client_name = client_info.name;
	  var websiteName = "";
	  if (client_sites && client_sites.length > 0) {
	    for (var i = 0; i < client_sites.length; i++) {
	      if (Number(client_sites[i].value) === Number(websiteId)) {
	        websiteName = client_sites[i].label;
	        break;
	      }
	    }
	  }
	  var s = client_sites.find(function (site) {
	    return site.value === websiteId;
	  });
	  var csvFileName = createFilename.call(this, dayRange, "Site Analytics Demographics");
	  var title = "Report Details,\r\n";
	  var title_line = (websiteName ? websiteName + " " : "") + "Site Anayltics Report,\r\n";
	  var report_date_line = "Date," + (0, _moment2.default)().format("MM/DD/YYYY") + ",\r\n";
	  var client_name_line = "Client Name," + client_name + ",\r\n";
	  var date_filter_line = "Campaign Date Filter," + (0, _utility.getDayRangeTitle)(dayRange) + ",\r\n";
	  // let pageName = `Page Name,${popUrl},,,,,,\r\n`;
	  var breakLine = ",,,,,,,\r\n";
	
	  function formatNumber(num, total) {
	    return Math.round(num / total * 10000, 10) / 100 + "%";
	  }
	  function reduce(values) {
	    return values.reduce(function (a, b) {
	      if (typeof a === "number") return a + b.value;else return a.value + b.value;
	    });
	  }
	  function formatLine(data) {
	    if (data && data.values.length > 0) {
	      var line_str = "";
	      var total = reduce(data.values);
	      data.values.forEach(function (it) {
	        line_str += it.key + "," + formatNumber(it.value, total) + ",\r\n";
	      });
	      return line_str;
	    } else {
	      return "";
	    }
	  }
	  function sort(data) {
	    if (data && data.values.length > 0) {
	      data.values.sort(function (a, b) {
	        return b.value - a.value;
	      });
	    }
	    return data;
	  }
	
	  var data = title + title_line + report_date_line + client_name_line + date_filter_line + (0, _utility.downLoadCSVFunc)(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
	  setTimeout(function () {
	    this.setState({ onCsvReportDownload: false });
	  }.bind(this), 2000);
	}
	
	function overview() {
	  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	  var _props5 = this.props,
	      clients = _props5.clients,
	      client_info = _props5.client_info,
	      websiteId = _props5.websiteId,
	      dayRange = _props5.dayRange,
	      client_sites = _props5.client_sites,
	      domesticVisitsSummary = _props5.domesticVisitsSummary,
	      statsByTimeOfDay = _props5.statsByTimeOfDay,
	      states = _props5.states,
	      kindOfReport = _props5.kindOfReport;
	
	  var client_name = client_info.name;
	  var websiteName = "";
	  if (client_sites && client_sites.length > 0) {
	    for (var i = 0; i < client_sites.length; i++) {
	      if (Number(client_sites[i].value) === Number(websiteId)) {
	        websiteName = client_sites[i].label;
	        break;
	      }
	    }
	  }
	  var s = client_sites.find(function (site) {
	    return site.value === websiteId;
	  });
	  var csvFileName = createFilename.call(this, dayRange, kindOfReport === "map" ? "Consumer Geographic Traffic" : "Site Analytics Overview");
	  var title = "Report Details,\r\n";
	  var title_line = (websiteName ? websiteName + " " : "") + "Site Anayltics Report,\r\n";
	  var report_date_line = "Date," + (0, _moment2.default)().format("MM/DD/YYYY") + ",\r\n";
	  var client_name_line = "Client Name," + client_name + ",\r\n";
	  var date_filter_line = "Campaign Date Filter," + (0, _utility.getDayRangeTitle)(dayRange) + ",\r\n";
	  // let pageName = `Page Name,${popUrl},,,,,,\r\n`;
	  var breakLine = ",,,,,,,\r\n";
	  var overview_line = "Total Visits," + parseInt(domesticVisitsSummary.totalVisits) + ",,,,,,\r\n";
	  overview_line += "Unique Visits," + parseInt(domesticVisitsSummary.uniqueVisits) + ",,,,,,\r\n";
	  // let channel_reach_line = "Media Reach,,,,,,,\r\n";
	  // channel_reach_line += "Direct Mail," + reachByChannels[0].value + ",,,,,,\r\n";
	  // channel_reach_line += "Email," + reachByChannels[1].value + ",,,,,,\r\n";
	  // channel_reach_line += "Social," + reachByChannels[2].value + ",,,,,,\r\n";
	  // channel_reach_line += "Display," + reachByChannels[3].value + ",,,,,,\r\n";
	  var visits_by_time_line = "Visits by Time of Day,,,,,,,\r\n";
	  if (statsByTimeOfDay && statsByTimeOfDay.stats) {
	    var timeTotal = (0, _lodash.sumBy)(statsByTimeOfDay.stats, function (val) {
	      return val.unique;
	    });
	    (0, _lodash.map)(statsByTimeOfDay.stats, function (stat) {
	      visits_by_time_line += stat.type + "," + (stat.unique / timeTotal).toLocaleString(undefined, {
	        style: "percent",
	        minimumFractionDigits: 2
	      }) + ",,,,,,\r\n";
	    });
	  }
	  var geographic_traffic_line = "Geographic Traffic,,,,,,,\r\n";
	  if (states) {
	    var total = (0, _lodash.sumBy)(states, function (val) {
	      return val.unique;
	    });
	    var _states = (0, _lodash.sortBy)(states, function (state) {
	      return -state.unique;
	    });
	    (0, _lodash.map)(_states, function (state) {
	      geographic_traffic_line += state.type + "," + (state.unique / total).toLocaleString(undefined, {
	        style: "percent",
	        minimumFractionDigits: 2
	      }) + ",,,,,,\r\n";
	    });
	  }
	
	  var data = title + title_line + report_date_line + client_name_line + date_filter_line + breakLine + overview_line + breakLine + visits_by_time_line + breakLine + geographic_traffic_line;
	  (0, _utility.downLoadCSVFunc)(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
	  setTimeout(function () {
	    this.setState({ onCsvReportDownload: false });
	  }.bind(this), 2000);
	}
	
	function popularPage(popUrl) {
	  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
	  var _props6 = this.props,
	      clients = _props6.clients,
	      client_info = _props6.client_info,
	      websiteId = _props6.websiteId,
	      dayRange = _props6.dayRange,
	      client_sites = _props6.client_sites,
	      domesticVisitsSummary = _props6.domesticVisitsSummary,
	      statsByTimeOfDay = _props6.statsByTimeOfDay,
	      states = _props6.states;
	
	  var client_name = client_info.name;
	  var websiteName = "";
	  if (client_sites && client_sites.length > 0) {
	    for (var i = 0; i < client_sites.length; i++) {
	      if (Number(client_sites[i].value) === Number(websiteId)) {
	        websiteName = client_sites[i].label;
	        break;
	      }
	    }
	  }
	  var s = client_sites.find(function (site) {
	    return site.value === websiteId;
	  });
	  var csvFileName = createFilename.call(this, dayRange, "Site Analytics_Most Popular Pages");
	  var title = "Report Details,\r\n";
	  var title_line = (websiteName ? websiteName + " " : "") + "Site Anayltics Popular Pages Report,\r\n";
	  var report_date_line = "Date," + (0, _moment2.default)().format("MM/DD/YYYY") + ",\r\n";
	  var client_name_line = "Client Name," + client_name + ",\r\n";
	  var date_filter_line = "Campaign Date Filter," + (0, _utility.getDayRangeTitle)(dayRange) + ",\r\n";
	  var pageName = "Page Name," + popUrl + ",,,,,,\r\n";
	  var breakLine = ",,,,,,,\r\n";
	  var overview_line = "Total Visits," + parseInt(domesticVisitsSummary.totalVisits) + ",,,,,,\r\n";
	  overview_line += "Unique Visits," + parseInt(domesticVisitsSummary.uniqueVisits) + ",,,,,,\r\n";
	  // let channel_reach_line = "Media Reach,,,,,,,\r\n";
	  // channel_reach_line += "Direct Mail," + reachByChannels[0].value + ",,,,,,\r\n";
	  // channel_reach_line += "Email," + reachByChannels[1].value + ",,,,,,\r\n";
	  // channel_reach_line += "Social," + reachByChannels[2].value + ",,,,,,\r\n";
	  // channel_reach_line += "Display," + reachByChannels[3].value + ",,,,,,\r\n";
	  var visits_by_time_line = "Visits by Time of Day,,,,,,,\r\n";
	  if (statsByTimeOfDay && statsByTimeOfDay.stats) {
	    var timeTotal = (0, _lodash.sumBy)(statsByTimeOfDay.stats, function (val) {
	      return val.unique;
	    });
	    (0, _lodash.map)(statsByTimeOfDay.stats, function (stat) {
	      visits_by_time_line += stat.type + "," + (stat.unique / timeTotal).toLocaleString(undefined, {
	        style: "percent",
	        minimumFractionDigits: 2
	      }) + ",,,,,,\r\n";
	    });
	  }
	  var geographic_traffic_line = "Geographic Traffic,,,,,,,\r\n";
	  if (states) {
	    var total = (0, _lodash.sumBy)(states, function (val) {
	      return val.unique;
	    });
	    var _states = (0, _lodash.sortBy)(states, function (state) {
	      return -state.unique;
	    });
	    (0, _lodash.map)(_states, function (state) {
	      geographic_traffic_line += state.type + "," + (state.unique / total).toLocaleString(undefined, {
	        style: "percent",
	        minimumFractionDigits: 2
	      }) + ",,,,,,\r\n";
	    });
	  }
	
	  var data = title + title_line + report_date_line + client_name_line + date_filter_line + pageName + breakLine + overview_line + breakLine + visits_by_time_line + breakLine + geographic_traffic_line;
	  (0, _utility.downLoadCSVFunc)(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
	  setTimeout(function () {
	    this.setState({ onCsvReportDownload: false });
	  }.bind(this), 2000);
	}

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = downloadAsPdf;
	
	var _utility = __webpack_require__(14);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _env = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	var oWidth = 0;
	var oWidth2 = 0;
	var s = null;
	
	function mapHtml2CanvasWithgmap(eleId) {
	  return new Promise(function (resolve, reject) {
	    var ele = document.getElementById(eleId);
	    oWidth = oWidth || ele.offsetWidth;
	    ele.style.width = "1024px";
	    setTimeout(function () {
	      var gmStyle = document.getElementsByClassName("gm-style");
	      var p = gmStyle[0].childNodes[0].childNodes[0];
	      var t = p.childNodes[4].childNodes[0];
	      var t1 = p.childNodes[0].childNodes[0].childNodes[0];
	      var t2 = p.childNodes[1].childNodes[0].childNodes[0];
	      [t, t1, t2].forEach(function (o) {
	        if (o) {
	          var transform = o.style.transform;
	          var comp = transform.split(","); //split up the transform matrix
	          var mapleft = parseFloat(comp[4]); //get left value
	          var maptop = parseFloat(comp[5]); //get top value
	          o.style.transform = "none";
	          o.style.left = mapleft + "px";
	          o.style.top = maptop + "px";
	        }
	      });
	      html2canvas(ele, {
	        proxy: _env.apiBaseUrl + "/proxy/images",
	        logging: false,
	        svgRendering: true,
	        useCORS: true,
	        allowTraint: false
	      }).then(function (canvas) {
	        ele.style.width = oWidth + "px";
	        resolve({ canvas: canvas });
	      }).catch(reject);
	    }, 2000);
	  });
	}
	function mapHtml2Canvas(eleId) {
	  return new Promise(function (resolve, reject) {
	    var ele = document.getElementById(eleId);
	    oWidth = oWidth || ele.offsetWidth;
	    ele.style.width = "1024px";
	    setTimeout(function () {
	      html2canvas(ele, { logging: false }).then(function (canvas) {
	        ele.style.width = oWidth + "px";
	        resolve({ canvas: canvas });
	      }).catch(reject);
	    }, 200);
	  });
	}
	
	function mapHtml2Canvas2(ele) {
	  return new Promise(function (resolve, reject) {
	    ele.style.width = "500px";
	    setTimeout(function () {
	      html2canvas(ele, { logging: false }).then(function (canvas) {
	        resolve({ canvas: canvas });
	      }).catch(reject);
	    }, 200);
	  });
	}
	
	function createFilename(d, type, popUrl, BusinessUnit) {
	  var _props = this.props,
	      client_tags = _props.client_tags,
	      websiteId = _props.websiteId;
	
	  var tag = client_tags ? client_tags.find(function (it) {
	    return +it.id === +websiteId;
	  }) : null;
	  var domain = tag && tag.domain ? tag.domain : "Unknown";
	  var dayRange = this.getDayRangeTitle(d).replace(/\s+/g, "");
	  var time = (0, _moment2.default)().format("YYYYMMDD");
	  if (popUrl) {
	    type = popUrl.replace(/^\/|\/$/, "").replace(/\//g, "_");
	  }
	  return "" + (BusinessUnit ? BusinessUnit + "_" : "") + domain + "_" + dayRange + "_" + type + "_" + time + ".pdf";
	}
	
	function _addPdfFooter(pdf, pageHeight) {
	  pdf.setFillColor(127, 127, 127);
	  var top = pageHeight - 12;
	  pdf.rect(0, top, 210, 15, "F");
	  pdf.addImage((0, _utility.pdfReportFooterDataUri)(), "PNG", 15, top + 3, 20, 0);
	  pdf.setTextColor(255, 255, 255);
	  pdf.setFontSize(9);
	  pdf.setFontType("bold");
	  pdf.text(65, top + 6, "Copyright © " + (0, _moment2.default)().format("YYYY") + " Claritas, LLC. All rights reserved");
	}
	
	function downloadAsPdf(nav) {
	  var reportType = this.props.reportType;
	
	  var popUrl = (0, _utility.getUrlParameterByName)("pop_url");
	  this.setState({
	    showLoadingDialog: true,
	    pdfCreating: true,
	    showDownloadDialog: false
	  });
	  var _props2 = this.props,
	      selected_client = _props2.selected_client,
	      client_sites = _props2.client_sites,
	      websiteId = _props2.websiteId,
	      clients = _props2.clients,
	      client_info = _props2.client_info,
	      dayRange = _props2.dayRange;
	
	
	  var bu_name = "";
	  if (client_info.parentClientId) {
	    var parent_client = clients.find(function (c) {
	      return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
	    });
	    if (parent_client) {
	      // client_name = parent_client.name;
	      bu_name = client_info.name;
	    }
	  }
	  var c = clients.find(function (client) {
	    return parseInt(client.id, 10) === parseInt(selected_client, 10);
	  });
	  if (!c) {
	    clients.forEach(function (cl) {
	      if (cl.businessUnits) {
	        cl.businessUnits.forEach(function (b) {
	          if (parseInt(b.id, 10) === parseInt(selected_client, 10)) c = b;
	        });
	      }
	    });
	  }
	
	  var clientName = c && c.name ? c.name : "";
	
	  s = client_sites.find(function (site) {
	    return site.value === websiteId;
	  });
	  var pdf = null;
	  var isBusiness = this.props.reportType === "business";
	  var className = "overview-dashboard";
	  if (isBusiness && nav === "overflow") {
	    className = "overview-dashboard";
	  }
	  var main = document.getElementById(className);
	  var pageHeight = 0;
	  if (popUrl && nav === "pop" || isBusiness && nav !== "map") {
	    var serviceContact = document.getElementById("service-contact");
	    if (serviceContact) serviceContact.style.display = "none";
	    pageHeight = main.offsetHeight / (main.offsetWidth / 230) + 10;
	    pdf = new pdfConverter("p", "mm", [210, pageHeight]);
	  } else {
	    pdf = new pdfConverter("p", "mm", "a4");
	  }
	  pdf.setFont("helvetica");
	  pdf.setFontType("normal");
	  pdf.setFontSize(9);
	
	  pdf.setFillColor(127, 127, 127);
	  pdf.rect(0, 15, 210, 10, "F");
	
	  pdf.setTextColor(0, 0, 0);
	  pdf.setFontSize(9);
	  pdf.setFontType("bold");
	  pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), "PNG", 10.5, 3, 60, 0);
	  pdf.text(198, 8, (0, _moment2.default)().format("MMMM DD, YYYY"), null, null, "right");
	
	  pdf.setTextColor(255, 255, 255);
	  pdf.setFontType("bold");
	  var textTop = 21;
	  pdf.text(12, textTop, "Client:");
	  var lenClientName = (0, _utility.getTextSize)(clientName.trim(), "helvetica");
	  pdf.setFontType("normal");
	  pdf.text(23, textTop, clientName.trim());
	  //cm to inches
	  if (bu_name) {
	    var start = 23 + lenClientName.width * 0.3937 + 3.4;
	    pdf.setFontType("bold");
	    pdf.text(start, textTop, "Business Unit:");
	    start += 24.5;
	    pdf.setFontType("normal");
	    pdf.text(start, textTop, bu_name.trim());
	  }
	  // pdf.setFontType('bold')
	  // pdf.text(start, textTop, 'Date:')
	  // pdf.setFontType('normal')
	  // start += (getTextSize('Date:', 'helvetica')).width * 0.3937 + 0.4
	  // pdf.text(start, textTop, this.getDayRangeTitle(dayRange))
	  pdf.setTextColor(0, 0, 0);
	  pdf.setFontType("normal");
	  var menu_text = "Insights Dashboard  >  Consumer Information  >  Overview";
	  if (this.props.reportType === "business") {
	    if (nav === "overview") {
	      menu_text = "Insights Dashboard  >  Business Information";
	    } else if (nav === "map") {
	      menu_text = "Insights Dashboard  >  Business Information  >  Geographic Traffic";
	    } else if (nav === "pop" && popUrl) {
	      menu_text = "Insights Dashboard  >  Business Information > " + popUrl;
	    }
	  } else {
	    if (nav === "demographics") {
	      menu_text = "Insights Dashboard  >  Consumer Information  >  Demographics";
	    } else if (nav === "device") {
	      menu_text = "Insights Dashboard  >  Consumer Information  >  Devices";
	    } else if (nav === "pop") {
	      menu_text = "Insights Dashboard  >  Consumer Information  >  Most Popular Pages";
	    } else if (nav === "additional-demographics") {
	      menu_text = "Insights Dashboard  >  Consumer Information  >  Additional Demographics and Behaviors";
	    } else if (nav === "map") {
	      menu_text = "Insights Dashboard  >  Consumer Information  >  Geographic Traffic";
	    }
	    if (nav === "pop" && popUrl) {
	      menu_text = menu_text + "  >  " + popUrl;
	    }
	  }
	
	  pdf.text(12, 35, menu_text);
	  pdf.setFillColor(255);
	
	  // pdf.setLineWidth(0.05)
	  if (isBusiness) {
	    if (!nav || nav === "overview") {
	      BusinessOverview.call(this, pdf, dayRange, main, pageHeight, bu_name ? bu_name.trim() : clientName.trim());
	    } else if (nav === "map") {
	      // consumer map
	      ConsumerMap.call(this, pdf, dayRange);
	    } else if (nav === "pop" && popUrl) {
	      BusinessTargetPopularPage.call(this, pdf, dayRange, main, pageHeight, bu_name ? bu_name.trim() : clientName.trim());
	    }
	    return;
	  }
	  if (!nav || nav === "overview") {
	    ConsumerOverview.call(this, pdf, dayRange);
	  } else if (nav === "demographics") {
	    ConsumerDemographics.call(this, pdf, dayRange);
	  } else if (nav === "device") {
	    ConsumerDevice.call(this, pdf, dayRange);
	  } else if (nav === "pop") {
	    if (popUrl) {
	      ConsumerPopularPage.call(this, pdf, dayRange, main, pageHeight, popUrl);
	    } else {
	      ConsumerPopular.call(this, pdf, dayRange);
	    }
	  } else if (nav === "additional-demographics") {
	    ConsumerDemoBehaviors.call(this, pdf, dayRange);
	  } else if (nav === "map") {
	    // consumer map
	    ConsumerMap.call(this, pdf, dayRange);
	  }
	}
	
	function ConsumerMap(pdf, dayRange) {
	  var _this = this;
	
	  var fileName = createFilename.call(this, dayRange, this.props.reportType === "business" ? "business_map" : "consumer_map");
	  var pageWidth = 186;
	
	  return Promise.all([mapHtml2CanvasWithgmap("overview-dashboard")]).then(function (parts) {
	    var top = 42;
	    for (var i = 0; i < parts.length; i++) {
	      var canvas = parts[i].canvas;
	
	      var h = canvas.height * pageWidth / canvas.width;
	      if (top + h > 290) {
	        pdf.addPage("a4", "p");
	        top = 15;
	      }
	      pdf.addImage(canvas.toDataURL("image/png"), "PNG", 12, top, 186, 0);
	      top += h + 5;
	    }
	    oWidth = 0;
	    (0, _utility.addPdfFooter)(pdf);
	    pdf.save(fileName);
	    _this.setState({
	      showLoadingDialog: false,
	      pdfCreating: false
	    });
	  });
	}
	
	function BusinessTargetPopularPage(pdf, dayRange, main, pageHeight, businessUnit) {
	  var _this2 = this;
	
	  var fileName = createFilename.call(this, dayRange, "Business", undefined, businessUnit);
	  var _width = main.offsetWidth;
	  main.style.width = "1024px";
	  setTimeout(function () {
	    html2canvas(main, { logging: false }).then(function (canvas) {
	      var serviceContact = document.getElementById("service-contact");
	      if (serviceContact) serviceContact.style.display = "block";
	      main.style.width = _width + "px";
	      pdf.addImage(canvas.toDataURL(), "PNG", 12, 42, 186, 0);
	      _addPdfFooter(pdf, pageHeight);
	      pdf.save(fileName);
	      _this2.setState({
	        showLoadingDialog: false,
	        pdfCreating: false
	      });
	    });
	  }, 200);
	}
	
	function BusinessOverview(pdf, dayRange, main, pageHeight, businessUnit) {
	  var _this3 = this;
	
	  var fileName = createFilename.call(this, dayRange, "Business", undefined, businessUnit);
	  var _width = main.offsetWidth;
	  main.style.width = "1024px";
	  setTimeout(function () {
	    html2canvas(main, { logging: false }).then(function (canvas) {
	      var serviceContact = document.getElementById("service-contact");
	      if (serviceContact) serviceContact.style.display = "block";
	      main.style.width = _width + "px";
	      pdf.addImage(canvas.toDataURL(), "PNG", 12, 42, 186, 0);
	      _addPdfFooter(pdf, pageHeight);
	      pdf.save(fileName);
	      _this3.setState({
	        showLoadingDialog: false,
	        pdfCreating: false
	      });
	    });
	  }, 200);
	}
	
	function ConsumerPopularPage(pdf, dayRange, main, pageHeight, popUrl) {
	  var _this4 = this;
	
	  var fileName = createFilename.call(this, dayRange, undefined, popUrl);
	  var _width = main.offsetWidth;
	  main.style.width = "1024px";
	  setTimeout(function () {
	    html2canvas(main, { logging: false }).then(function (canvas) {
	      var serviceContact = document.getElementById("service-contact");
	      serviceContact.style.display = "block";
	      main.style.width = _width + "px";
	      pdf.addImage(canvas.toDataURL(), "PNG", 12, 42, 186, 0);
	      _addPdfFooter(pdf, pageHeight);
	      pdf.save(fileName);
	      _this4.setState({
	        showLoadingDialog: false,
	        pdfCreating: false
	      });
	    });
	  }, 200);
	}
	
	function ConsumerOverview(pdf, dayRange) {
	  var _this5 = this;
	
	  var fileName = createFilename.call(this, dayRange, "Consumer");
	  var pageWidth = 186;
	
	  return Promise.all([mapHtml2Canvas("consumer-overflow-pdf-part1"), mapHtml2Canvas("consumer-overflow-pdf-part2"), mapHtml2Canvas("consumer-overflow-pdf-part3"), mapHtml2Canvas("consumer-overflow-pdf-part4")]).then(function (parts) {
	    var top = 42;
	    for (var i = 0; i < parts.length; i++) {
	      var canvas = parts[i].canvas;
	
	      var h = canvas.height * pageWidth / canvas.width;
	      if (top + h > 290) {
	        pdf.addPage("a4", "p");
	        top = 15;
	      }
	      pdf.addImage(canvas.toDataURL(), "PNG", 12, top, 186, 0);
	      top += h + 5;
	    }
	    oWidth = 0;
	    (0, _utility.addPdfFooter)(pdf);
	    pdf.save(fileName);
	    _this5.setState({
	      showLoadingDialog: false,
	      pdfCreating: false
	    });
	  });
	}
	
	function ConsumerDemographics(pdf, dayRange) {
	  var _this6 = this;
	
	  var fileName = createFilename.call(this, dayRange, "Demographics");
	  var pageWidth = 186;
	  var pieEle = document.getElementsByClassName("_pie-chart");
	  var pieWidth = 0;
	  if (pieEle[0]) pieWidth = pieEle[0].getBoundingClientRect().width;
	  function getWidth(list) {
	    var ws = [];
	    var eles = [];
	    for (var i = 0; i < list.length; i++) {
	      var ele = document.getElementById(list[i]);
	      if (!ele) break;
	
	      var _ele$getBoundingClien = ele.getBoundingClientRect(),
	          width = _ele$getBoundingClien.width;
	
	      ws.push(width);
	      eles.push(ele);
	    }
	    return Promise.all(eles.map(mapHtml2Canvas2)).then(function (res) {
	      for (var _i = 0; _i < res.length; _i++) {
	        eles[_i].style.width = ws[_i] + "px";
	      }
	      return res;
	    });
	  }
	  getWidth(["demograpic-part1", "demograpic-part2", "demograpic-part3", "demograpic-part4", "demograpic-part5"]).then(function (res) {
	    return mapHtml2Canvas("consumer-overflow-pdf-part1").then(function (head) {
	      return [head].concat(_toConsumableArray(res));
	    });
	  }).then(function (parts) {
	    var parts1 = [parts[1], parts[2]];
	    var parts2 = [parts[3], parts[4], parts[5]];
	    var _parts1 = [];
	    var _parts2 = [];
	    var p = [parts1, parts2];
	    var offsetX = 12;
	    var hCanvas = parts[0].canvas;
	    pdf.addImage(hCanvas.toDataURL(), "PNG", offsetX, 42, pageWidth, 0);
	    var t = 42 + hCanvas.height * pageWidth / hCanvas.width + 5;
	    for (var x = 0; x < p.length; x++) {
	      var top = t;
	      for (var i = 0; i < p[x].length; i++) {
	        var canvas = p[x][i].canvas;
	
	        var h = canvas.height * (pageWidth / 2) / canvas.width;
	        if (top + h > 290) {
	          // pdf.addPage('a4', 'p');
	          // top = 15;
	          if (x === 0) _parts1.push(canvas);else _parts2.push(canvas);
	        } else {
	          pdf.addImage(canvas.toDataURL(), "PNG", offsetX, top, 90, 0);
	          top += h + 5;
	        }
	      }
	      offsetX += 95;
	    }
	    if (_parts1.length > 0 || _parts2.length > 0) {
	      pdf.addPage("a4", "p");
	      var _offsetX = 12;
	      var p2 = [_parts1, _parts2];
	      for (var _x = 0; _x < p2.length; _x++) {
	        var _top = 15;
	        for (var _i2 = 0; _i2 < p2[_x].length; _i2++) {
	          var _canvas = p2[_x][_i2];
	          var _h = _canvas.height * (pageWidth / 2) / _canvas.width;
	          pdf.addImage(_canvas.toDataURL(), "PNG", _offsetX, _top, 90, 0);
	          _top += _h + 5;
	        }
	        _offsetX += 95;
	      }
	      _offsetX += 95;
	    }
	    oWidth = 0;
	    oWidth2 = 0;
	    (0, _utility.addPdfFooter)(pdf);
	    pdf.save(fileName);
	    for (var _i3 = 0; _i3 < pieEle.length; _i3++) {
	      pieEle[_i3].style.width = pieWidth + "px";
	    }
	    _this6.setState({
	      showLoadingDialog: false,
	      pdfCreating: false
	    });
	  });
	}
	
	function ConsumerDevice(pdf, dayRange) {
	  var _this7 = this;
	
	  var fileName = createFilename.call(this, dayRange, "Devices");
	  var pageWidth = 186;
	  var pieEle = document.getElementsByClassName("_pie-chart");
	  var pieWidth = 0;
	  if (pieEle[0]) pieWidth = pieEle[0].getBoundingClientRect().width;
	  function getWidth(list) {
	    var ws = [];
	    var eles = [];
	    for (var i = 0; i < list.length; i++) {
	      var ele = document.getElementById(list[i]);
	      if (!ele) break;
	
	      var _ele$getBoundingClien2 = ele.getBoundingClientRect(),
	          width = _ele$getBoundingClien2.width;
	
	      ws.push(width);
	      eles.push(ele);
	    }
	    return Promise.all(eles.map(mapHtml2Canvas2)).then(function (res) {
	      for (var _i4 = 0; _i4 < res.length; _i4++) {
	        eles[_i4].style.width = ws[_i4] + "px";
	      }
	      return res;
	    });
	  }
	  getWidth(["device-pdf-part1", "device-pdf-part2", "device-pdf-part3"]).then(function (res) {
	    return mapHtml2Canvas("consumer-overflow-pdf-part1").then(function (head) {
	      return [head].concat(_toConsumableArray(res));
	    });
	  }).then(function (parts) {
	    var parts1 = [parts[1], parts[2]];
	    var parts2 = [parts[3]];
	    var _parts1 = [];
	    var _parts2 = [];
	    var p = [parts1, parts2];
	    var offsetX = 12;
	    var hCanvas = parts[0].canvas;
	    pdf.addImage(hCanvas.toDataURL(), "PNG", offsetX, 42, pageWidth, 0);
	    var t = 42 + hCanvas.height * pageWidth / hCanvas.width + 5;
	    for (var x = 0; x < p.length; x++) {
	      var top = t;
	      for (var i = 0; i < p[x].length; i++) {
	        var canvas = p[x][i].canvas;
	
	        var h = canvas.height * (pageWidth / 2) / canvas.width;
	        if (top + h > 290) {
	          // pdf.addPage('a4', 'p');
	          // top = 15;
	          if (x === 0) _parts1.push(canvas);else _parts2.push(canvas);
	        } else {
	          pdf.addImage(canvas.toDataURL(), "PNG", offsetX, top, 90, 0);
	          top += h + 5;
	        }
	      }
	      offsetX += 95;
	    }
	    if (_parts1.length > 0 || _parts2.length > 0) {
	      pdf.addPage("a4", "p");
	      var _offsetX2 = 12;
	      var p2 = [_parts1, _parts2];
	      for (var _x2 = 0; _x2 < p2.length; _x2++) {
	        var _top2 = 15;
	        for (var _i5 = 0; _i5 < p2[_x2].length; _i5++) {
	          var _canvas2 = p2[_x2][_i5];
	          var _h2 = _canvas2.height * (pageWidth / 2) / _canvas2.width;
	          pdf.addImage(_canvas2.toDataURL(), "PNG", _offsetX2, _top2, 90, 0);
	          _top2 += _h2 + 5;
	        }
	        _offsetX2 += 95;
	      }
	      _offsetX2 += 95;
	    }
	    oWidth = 0;
	    oWidth2 = 0;
	    (0, _utility.addPdfFooter)(pdf);
	    pdf.save(fileName);
	    for (var _i6 = 0; _i6 < pieEle.length; _i6++) {
	      pieEle[_i6].style.width = pieWidth + "px";
	    }
	    _this7.setState({
	      showLoadingDialog: false,
	      pdfCreating: false
	    });
	  });
	}
	
	function ConsumerPopular(pdf, dayRange) {
	  var _this8 = this;
	
	  var fileName = createFilename.call(this, dayRange, "Popular");
	  var pageWidth = 186;
	  var oWidth = 0;
	  var top = 42;
	  var head = document.getElementById("consumer-overflow-pdf-part1");
	
	  return new Promise(function (resolve) {
	    oWidth = head.offsetWidth;
	    head.style.width = "1024px";
	    setTimeout(function () {
	      html2canvas(head, { logging: false }).then(function (canvas) {
	        resolve(canvas);
	      });
	    }, 200);
	  }).then(function (head) {
	    pdf.addImage(head.toDataURL(), "PNG", 12, top, 186, 0);
	    top += head.height * pageWidth / head.width + 5;
	    var parts = document.getElementsByClassName("popular-pdf-part");
	    return Promise.all(Array.prototype.map.call(parts, function (it) {
	      return html2canvas(it, { logging: false });
	    }));
	  }).then(function (canvass) {
	    pdf.setLineWidth(0.1);
	    pdf.setDrawColor("#eeeff2");
	    var startTop = top;
	    pdf.line(12, startTop, 186 + 12, startTop);
	    top += 5;
	    for (var i = 0; i < canvass.length; i++) {
	      // imageData, format, x, y, width, height, alias, compression, rotation
	      pdf.addImage(canvass[i].toDataURL(), "PNG", 16, top, 178, 0);
	      top += canvass[i].height * 178 / canvass[i].width;
	      if (i === 0) top += 5;
	      if (top > 270) {
	        pdf.line(12, startTop, 12, top);
	        pdf.line(186 + 12, startTop, 186 + 12, top);
	        pdf.line(12, top, 186 + 12, top);
	        pdf.addPage("a4", "p");
	        top = 15.5;
	        pdf.setLineWidth(0.1);
	        pdf.setDrawColor("#eeeff2");
	        pdf.line(12, 15, 186 + 12, 15);
	      }
	    }
	    pdf.line(12, 15, 12, top);
	    pdf.line(186 + 12, 15, 186 + 12, top);
	    pdf.line(12, top, 186 + 12, top);
	    (0, _utility.addPdfFooter)(pdf);
	    // pdf.stroke();
	    pdf.save(fileName);
	    head.style.width = oWidth + "px";
	    _this8.setState({
	      showLoadingDialog: false,
	      pdfCreating: false
	    });
	  });
	}
	
	function ConsumerDemoBehaviors(pdf, dayRange) {
	  var _this9 = this;
	
	  var fileName = createFilename.call(this, dayRange, "Demo_Behavior");
	  var pageWidth = 186;
	
	  return Promise.all([mapHtml2Canvas("consumer-overflow-pdf-part1"), mapHtml2Canvas("demo-behaviors-part1"), mapHtml2Canvas("demo-behaviors-part2")]).then(function (parts) {
	    var top = 42;
	    for (var i = 0; i < parts.length; i++) {
	      var canvas = parts[i].canvas;
	
	      var h = canvas.height * pageWidth / canvas.width;
	      if (top + h > 290) {
	        pdf.addPage("a4", "p");
	        top = 15;
	      }
	      pdf.addImage(canvas.toDataURL(), "PNG", 12, top, 186, 0);
	      top += h + 5;
	    }
	    oWidth = 0;
	    (0, _utility.addPdfFooter)(pdf);
	    pdf.save(fileName);
	    _this9.setState({
	      showLoadingDialog: false,
	      pdfCreating: false
	    });
	  });
	}

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Grid = __webpack_require__(19);
	
	var _utility = __webpack_require__(14);
	
	var _SiteDateSelector = __webpack_require__(102);
	
	var _SiteDateSelector2 = _interopRequireDefault(_SiteDateSelector);
	
	var _newNavigator = __webpack_require__(1111);
	
	var _newNavigator2 = _interopRequireDefault(_newNavigator);
	
	var _TopAttributeList = __webpack_require__(1115);
	
	var _TopAttributeList2 = _interopRequireDefault(_TopAttributeList);
	
	var _PopularPageList = __webpack_require__(1098);
	
	var _PopularPageList2 = _interopRequireDefault(_PopularPageList);
	
	var _InsightNav = __webpack_require__(355);
	
	var _InsightNav2 = _interopRequireDefault(_InsightNav);
	
	var _InsightBreadcrumb = __webpack_require__(1096);
	
	var _InsightBreadcrumb2 = _interopRequireDefault(_InsightBreadcrumb);
	
	var _FrequencyVisitorList = __webpack_require__(1113);
	
	var _FrequencyVisitorList2 = _interopRequireDefault(_FrequencyVisitorList);
	
	var _BasicTierUpgradeInform = __webpack_require__(1122);
	
	var _BasicTierUpgradeInform2 = _interopRequireDefault(_BasicTierUpgradeInform);
	
	var _ServiceContact = __webpack_require__(1099);
	
	var _ServiceContact2 = _interopRequireDefault(_ServiceContact);
	
	var _Device = __webpack_require__(1123);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _SideBar = __webpack_require__(1127);
	
	var _SideBar2 = _interopRequireDefault(_SideBar);
	
	var _OverviewInsights = __webpack_require__(1126);
	
	var _OverviewInsights2 = _interopRequireDefault(_OverviewInsights);
	
	var _materialUi = __webpack_require__(38);
	
	var _url3 = __webpack_require__(1030);
	
	var _lodash = __webpack_require__(18);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(141);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _reduce = __webpack_require__(299);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _querystring = __webpack_require__(309);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _MostPopularPage = __webpack_require__(1125);
	
	var _MostPopularPage2 = _interopRequireDefault(_MostPopularPage);
	
	var _createPDF = __webpack_require__(1129);
	
	var _createPDF2 = _interopRequireDefault(_createPDF);
	
	var _createCSV = __webpack_require__(1128);
	
	var _createCSV2 = _interopRequireDefault(_createCSV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	
	var WebsiteVisits = function (_AcquireWebComponent) {
		_inherits(WebsiteVisits, _AcquireWebComponent);
	
		function WebsiteVisits(props) {
			_classCallCheck(this, WebsiteVisits);
	
			var _this = _possibleConstructorReturn(this, (WebsiteVisits.__proto__ || Object.getPrototypeOf(WebsiteVisits)).call(this, props));
	
			var granularity = window.localStorage.getItem('__granularity__');
	
			_this.state = {
				clientWidth: 0,
				showLoadingDialog: false,
				showUpgradeInfoDialog: false,
				showContactDialog: false,
				showDownloadDialog: false,
				disabledBtnDownload: false,
				onCsvReportDownload: false,
				pdfCreating: false,
				granularity: granularity || 'scale'
			};
			if (props.client_info) {
				if (parseInt(props.client_info.subscriptionTierId, 10) < 3) {
					_this.state = {
						clientWidth: 0,
						showLoadingDialog: false,
						showUpgradeInfoDialog: true,
						showContactDialog: false
					};
				}
			}
			var cid = (0, _utility.getUrlParameterByName)("cid");
			if (cid) {
				_this.props.selectClient(parseInt(cid, 10));
			}
			if (props.client_info && props.client_info.id !== undefined) {
				_this.props.getClientTags(props.client_info.id);
			}
			if (_this.props.setGranularity) {
				_this.props.setGranularity(granularity);
			}
			return _this;
		}
	
		_createClass(WebsiteVisits, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps, preProps) {
				var nav = (0, _utility.getUrlParameterByName)('nav') || 'overview';
				var popUrl = (0, _utility.getUrlParameterByName)('pop_url');
				var reportType = nextProps.reportType;
				var client_info = nextProps.client_info;
				var preClientInfo = this.props.client_info || {};
				if (client_info && client_info.id !== preClientInfo.id) {
					this.props.getClientTags(client_info.id);
				}
				if (nextProps.selected_client !== this.props.selected_client) {
					if (nextProps.selected_client > 1) {
						this.props.getClientSites(nextProps.selected_client);
						this.props.getClientInfo(nextProps.selected_client);
						var url = "/insights/" + this.props.reportType + "?cid=" + nextProps.selected_client + "&nav=" + nav;
						if (popUrl) {
							url += '&pop_url=' + encodeURIComponent(popUrl);
						}
						this.props.history.push(url);
					}
					if (popUrl && nav === "pop") {
						this.props.getClientSites(nextProps.selected_client);
						this.props.getClientInfo(nextProps.selected_client);
						var _url = "/insights/" + this.props.reportType + "?cid=" + nextProps.selected_client + "&nav=" + nav + "&pop_url=" + encodeURIComponent(popUrl);
						this.props.history.push(_url);
					}
				}
				if (nextProps.websiteId !== this.props.websiteId || nextProps.dayRange !== this.props.dayRange || nextProps.granularity !== this.props.granularity || this.nav !== nav || this.popUrl !== popUrl || nextProps.location.pathname !== this.props.location.pathname || nextProps.location.hash !== this.props.location.hash) {
					this.nav = nav;
					this.popUrl = popUrl;
					if (nextProps.websiteId && nextProps.dayRange) {
						var kindOfReport = nextProps.kindOfReport;
	
						this.props.clearAllStats();
						var _url2 = new _url3.URL(window.location.href);
						var page = _url2.searchParams.get("p");
						if (nav && (nav === "device" || nav === "overview") || reportType === 'business' && nav !== 'fir') {
							this.props.getStatsByDeviceType(nextProps.websiteId, nextProps.dayRange, this.props.reportType, popUrl);
							this.props.getStatsByDeviceModel(nextProps.websiteId, nextProps.dayRange, this.props.reportType);
							this.props.getStatsByOsType(nextProps.websiteId, nextProps.dayRange, this.props.reportType);
						}
						if ((0, _isUndefined2.default)(kindOfReport) && nav !== 'fir') {
							//this.props.getStatsByPrimaryDevices(nextProps.websiteId, nextProps.dayRange, page)
							this.props.getStatsByTime(nextProps.websiteId, nextProps.dayRange, page || popUrl, this.props.reportType);
							!popUrl && this.props.getStatsByPopularPages(nextProps.websiteId, nextProps.dayRange, this.props.reportType);
							this.props.getStatsByRegionalTraffic(nextProps.websiteId, nextProps.dayRange, page || popUrl, this.props.reportType);
							this.props.getStatsByTimeOfDay(nextProps.websiteId, nextProps.dayRange, page || popUrl, this.props.reportType);
							reportType === 'business' && this.props.getStatsByDemographic(nextProps.websiteId, nextProps.dayRange, page || popUrl, this.props.reportType, nextProps.granularity);
							this.props.getDomesticVisits(nextProps.websiteId, nextProps.dayRange, this.props.reportType, page || popUrl);
							this.props.getStates(nextProps.websiteId, nextProps.dayRange, popUrl, this.props.reportType);
	
							if (this.props.reportType && nav === 'overview') {
								this.props.getDomesticBusinessStats(nextProps.websiteId, nextProps.granularity, nextProps.dayRange);
							}
						}
						if (kindOfReport === "map") {
							this.props.getHeatMapData(nextProps.websiteId, nextProps.dayRange, page || popUrl, this.props.reportType);
						}
						if (kindOfReport === "popular") {
							this.props.getStatsByPopularPages(nextProps.websiteId, nextProps.dayRange, this.props.reportType);
						}
						if (kindOfReport === "top") {
							this.props.getStatsTopAttributes(nextProps.websiteId, nextProps.dayRange, page, undefined, nextProps.granularity);
						}
						if (kindOfReport === "frequents" || nav === 'fir') {
							this.props.getTop20FrequencyBusiness(nextProps.websiteId, nextProps.dayRange);
						}
					}
				}
				if (nextProps.client_info && nextProps.client_info !== this.props.client_info) {
					if (parseInt(nextProps.client_info.subscriptionTierId, 10) < 3) {
						this.setState({
							showUpgradeInfoDialog: true
						});
					} else if (this.state.showUpgradeInfoDialog) {
						this.setState({ showUpgradeInfoDialog: false });
					}
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var urlParams = _querystring2.default.parse(this.props.location.search);
				var nav = (0, _utility.getUrlParameterByName)('nav') || 'overview';
				var popUrl = (0, _utility.getUrlParameterByName)('pop_url');
				this.updateDimensions();
				/*
	   if (this.props.selected_client && this.props.selected_client > 1) {
	   	this.props.getClientSites(this.props.selected_client);
	   }*/
				window.addEventListener("resize", this.updateDimensions.bind(this));
				var _props = this.props,
				    kindOfReport = _props.kindOfReport,
				    dayRange = _props.dayRange,
				    websiteId = _props.websiteId,
				    reportType = _props.reportType,
				    client_info = _props.client_info;
	
				var page = (0, _utility.getUrlParameterByName)("p");
				if (client_info) {
					if (parseInt(client_info.subscriptionTierId, 10) < 3) {
						this.setState({
							showUpgradeInfoDialog: true
						});
					}
				}
	
				if (this.props.websiteId && this.props.dayRange) {
					var _props2 = this.props,
					    _kindOfReport = _props2.kindOfReport,
					    _dayRange = _props2.dayRange,
					    _websiteId = _props2.websiteId,
					    _reportType = _props2.reportType,
					    granularity = _props2.granularity;
	
					this.props.clearAllStats();
					var url = new _url3.URL(window.location.href);
					var _page = url.searchParams.get("p");
					if (nav === "device" || nav === "overview" || _reportType === 'business' && nav !== 'fir') {
						this.props.getStatsByDeviceType(_websiteId, _dayRange, _reportType, popUrl);
						this.props.getStatsByDeviceModel(_websiteId, _dayRange, _reportType);
						this.props.getStatsByOsType(_websiteId, _dayRange, _reportType);
					}
					if ((0, _isUndefined2.default)(_kindOfReport) && nav !== 'fir') {
						//this.props.getStatsByPrimaryDevices(nextProps.websiteId, nextProps.dayRange, page)
						this.props.getStatsByTime(_websiteId, _dayRange, _page || popUrl, _reportType);
						!popUrl && this.props.getStatsByPopularPages(_websiteId, _dayRange, _reportType);
						this.props.getStatsByRegionalTraffic(_websiteId, _dayRange, _page || popUrl, _reportType);
						this.props.getStatsByTimeOfDay(_websiteId, _dayRange, _page || popUrl, _reportType);
						_reportType === 'business' && this.props.getStatsByDemographic(_websiteId, _dayRange, _page || popUrl, _reportType, this.props.granularity);
						this.props.getDomesticVisits(_websiteId, _dayRange, _reportType, _page);
						this.props.getStates(_websiteId, _dayRange, popUrl, _reportType);
						if (this.props.reportType === "business") {
							this.props.getDomesticBusinessStats(_websiteId, this.props.granularity, _dayRange);
						}
					}
					if (_kindOfReport === "map") {
						this.props.getHeatMapData(_websiteId, _dayRange, _page || popUrl, _reportType);
					}
					if (_kindOfReport === "popular") {
						this.props.getStatsByPopularPages(_websiteId, _dayRange, _reportType);
					}
					if (_kindOfReport === "top" || urlParams.type === 'additional-demographics') {
						this.props.getStatsTopAttributes(_websiteId, _dayRange, _page, undefined, this.props.granularity);
					}
					if (_kindOfReport === "frequents" || nav === 'fir') {
						this.props.getTop20FrequencyBusiness(_websiteId, _dayRange);
					}
				} else {
					if (kindOfReport === "map") {
						this.props.getHeatMapData(websiteId, dayRange, page || popUrl, reportType);
					}
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				window.removeEventListener("resize", this.updateDimensions);
			}
		}, {
			key: 'updateDimensions',
			value: function updateDimensions() {
				var width = document.getElementsByClassName('website-visits-content')[0].clientWidth * 0.8 / 2;
				this.setState({ clientWidth: width });
			}
		}, {
			key: 'handleDownload',
			value: function handleDownload(e) {
				e.preventDefault();
				if (this.refs.cbPDF.state.switched) {
					//   this.downloadAsPdf(false);
					_createPDF2.default.call(this, (0, _utility.getUrlParameterByName)("nav") ? (0, _utility.getUrlParameterByName)("nav") : "map");
				}
	
				if (this.refs.cbCSV.state.switched) {
					// const nav = getUrlParameterByName('nav') || 'overview';
					// if (nav === 'overview') {
					//     this.handleCsvDownload();
					//    } else {
					_createCSV2.default.call(this);
					// }
				}
			}
		}, {
			key: 'downloadTopAsPdf',
			value: function downloadTopAsPdf(isPageVisit) {
				this.setState({ showLoadingDialog: true });
	
				var _props3 = this.props,
				    selected_client = _props3.selected_client,
				    client_sites = _props3.client_sites,
				    websiteId = _props3.websiteId,
				    clients = _props3.clients,
				    dayRange = _props3.dayRange;
	
				var c = clients.find(function (client) {
					return parseInt(client.id, 10) === parseInt(selected_client, 10);
				});
				if (!c) {
					clients.forEach(function (cl) {
						if (cl.businessUnits) {
							cl.businessUnits.forEach(function (b) {
								if (parseInt(b.id, 10) === parseInt(selected_client, 10)) c = b;
							});
						}
					});
				}
	
				var clientName = c && c.name ? c.name : "";
				var s = client_sites.find(function (site) {
					return site.value === websiteId;
				});
	
				var fileName = clientName + '_insights_top_attributes_' + dayRange.replace(/-/g, '_') + '_' + (0, _moment2.default)().format('YYYYMMDD') + '.pdf';
	
				var pdf = new pdfConverter('p', 'mm', 'a4');
				pdf.setFont("helvetica");
				pdf.setFontType("normal");
				pdf.setFontSize(9);
				var pageWidth = 186;
	
				var el_demogrphic = document.getElementsByClassName("top-demographics")[0];
				var el_behavior = document.getElementsByClassName("top-behaviors")[0];
	
				var canvasDemographic = null;
				var canvasBehavor = null;
				var isDemogrphicReady = false;
				var isBehaviorReady = false;
				var oriWidth = el_demogrphic.offsetWidth;
				el_demogrphic.style.width = "1024px";
				setTimeout(function () {
					html2canvas(el_demogrphic, { logging: false }).then(function (canvas) {
						canvasDemographic = canvas;
						isDemogrphicReady = true;
						el_demogrphic.style.width = oriWidth + 'px';
					});
				}, 50);
	
				el_behavior.style.width = "1024px";
				setTimeout(function () {
					html2canvas(el_behavior, { logging: false }).then(function (canvas) {
						canvasBehavor = canvas;
						isBehaviorReady = true;
						el_behavior.style.width = oriWidth + 'px';
					});
				}, 50);
	
				var top = 10;
				var intervalId = setInterval(function () {
					if (isDemogrphicReady === false || isBehaviorReady === false) {
						console.log('PDF generating...');
					} else {
						clearInterval(intervalId);
						setTimeout(function () {
							pdf.setFillColor(127, 127, 127);
							pdf.rect(0, 15, 210, 10, 'F');
							pdf.setTextColor(0, 0, 0);
							pdf.setFontSize(9);
							pdf.setFontType('bold');
							pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), 'PNG', 10.5, 3, 60, 0);
							pdf.text(198, 8, (0, _moment2.default)().format('MMMM DD, YYYY'), null, null, 'right');
							pdf.setTextColor(255, 255, 255);
							pdf.setFontType('bold');
							pdf.text(12, 19, 'Client:');
							var lenClientName = (0, _utility.getTextSize)(clientName.trim(), 'helvetica');
							pdf.setFontType('normal');
							pdf.text(23, 19, clientName.trim());
							//cm to inches
							var start = 23 + lenClientName.width * 0.3937 + 0.4;
							pdf.setFontType('bold');
							pdf.text(start, 19, 'WEBSITE NAME:');
							start += 26.5;
							pdf.setFontType('normal');
							pdf.text(start, 19, s && s.label ? s.label.trim() : '');
							start += s && s.label ? (0, _utility.getTextSize)(s.label.trim(), 'helvetica').width * 0.3937 + 0.4 : 1;
							pdf.setFontType('bold');
							pdf.text(start, 19, 'Date:');
							pdf.setFontType('normal');
							start += (0, _utility.getTextSize)('Date:', 'helvetica').width * 0.3937 + 0.4;
							pdf.text(start, 19, this.getDayRangeTitle(dayRange));
	
							pdf.setFillColor(255);
							pdf.setLineWidth(0.05);
							//pdf.line(0, isPageVisit ? 32 : 27, 210, isPageVisit ? 32 : 27)
							//pdf.line(0, isPageVisit ? 27: 22, 210, isPageVisit ? 27: 22)
							//top = isPageVisit ? 37 : 32
							top = isPageVisit ? 32 : 27;
	
							pdf.addImage(canvasDemographic.toDataURL(), 'PNG', 12, top, pageWidth, 0);
							var h1 = canvasDemographic.height * pageWidth / canvasDemographic.width;
							//pdf.line(123, top+2, 123, top + h1 - 2)
							//top += h1 + 5
							top += h1 + 3.5;
							pdf.addImage(canvasBehavor.toDataURL(), 'PNG', 12, top, pageWidth, 0);
							(0, _utility.addPdfFooter)(pdf);
							pdf.save(fileName);
							this.setState({ showLoadingDialog: false });
						}.bind(this), 100);
					}
				}.bind(this), 50);
			}
		}, {
			key: 'downloadCsvReport',
			value: function downloadCsvReport(isPageVisit) {
				this.setState({ showLoadingDialog: true });
	
				var _props4 = this.props,
				    selected_client = _props4.selected_client,
				    client_sites = _props4.client_sites,
				    websiteId = _props4.websiteId,
				    clients = _props4.clients,
				    dayRange = _props4.dayRange;
	
				var c = clients.find(function (client) {
					return parseInt(client.id, 10) === parseInt(selected_client, 10);
				});
				if (!c) {
					clients.forEach(function (cl) {
						if (cl.businessUnits) {
							cl.businessUnits.forEach(function (b) {
								if (parseInt(b.id, 10) === parseInt(selected_client, 10)) c = b;
							});
						}
					});
				}
	
				var clientName = c && c.name ? c.name : "";
				var s = client_sites.find(function (site) {
					return site.value === websiteId;
				});
	
				var fileName = clientName + '_insights_' + dayRange.replace(/-/g, '_') + '_' + (0, _moment2.default)().format('YYYYMMDD') + '.pdf';
	
				var pdf = new pdfConverter('p', 'mm', 'a4');
				pdf.setFont("helvetica");
				pdf.setFontType("normal");
				pdf.setFontSize(9);
				var pageWidth = 186;
	
				var els = document.getElementsByClassName("total-visit-section");
				var totalVisitsCanva = null,
				    demoGeoCanva = null,
				    timeTrafficCanva = null,
				    timeDeviceCanva = null,
				    mostPopularCanva = null;
	
				var isTotalVisitReady = false;
				if (els.length > 0) {
					var el = els[0];
					var tvWidth = el.offsetWidth;
					el.style.width = '1024px';
					document.getElementById("cs_contact_form").style.display = "none";
					var colHeight = document.getElementById("visits_overview_col1").style.height;
					if (this.props.reportType === "consumer") document.getElementById("visits_overview_col1").style.height = "170px";else document.getElementById("visits_overview_col1").style.height = "auto";
					setTimeout(function () {
						html2canvas(el, { logging: false }).then(function (canvas) {
							totalVisitsCanva = canvas;
							isTotalVisitReady = true;
							el.style.width = tvWidth + 'px';
							document.getElementById("cs_contact_form").style.display = "block";
							document.getElementById("visits_overview_col1").style.height = colHeight;
						});
					}, 50);
				}
				els = document.getElementsByClassName("demo-geo-section");
				var isDemoGeoReady = false;
				if (els.length > 0) {
					var _el = els[0];
					/*
	    			if (isPageVisit){
	    				el.classList.remove("p-10")
	    				el.classList.remove("mt-10")
	    				el.classList.add("no-padding")
	    				const e1_width = el.children[0].offsetWidth
	    				const e2_width = el.children[1].offsetWidth
	    				const tdWidth = el.offsetWidth
	    				el.style.width = '1024px'
	    				el.children[0].style.width = '502px'
	    				el.children[1].style.width = '502px'
	    				setTimeout(function () {
	    					html2canvas(el,{logging:false}).then(function (canva) {
	    						demoGeoCanva = canva
	    						isDemoGeoReady = true
	    						el.children[0].style.width = e1_width + 'px'
	    						el.children[1].style.width = e2_width + 'px'
	    						el.style.width = tdWidth + 'px'
	    						el.classList.add("p-10")
	    						el.classList.add("mt-10")
	    						el.classList.remove("no-padding")
	    					})
	    				}, 50)
	    			}else{*/
					_el.children[0].style['min-height'] = 'inherit';
					var dgWidth = _el.offsetWidth;
					_el.style.width = '1024px';
					setTimeout(function () {
						html2canvas(_el, { logging: false }).then(function (canva) {
							demoGeoCanva = canva;
							isDemoGeoReady = true;
							_el.children[0].style['min-height'] = '250px';
							_el.style.width = dgWidth + 'px';
						});
					}, 50);
					//}
				}
				els = document.getElementsByClassName("time-device-section");
				var isTimeDeviceReady = false;
				if (els.length > 0) {
					var _el2 = els[0];
					_el2.classList.remove("p-10");
					_el2.classList.remove("mt-10");
					_el2.classList.add("no-padding");
					var tdWidth = _el2.offsetWidth;
					_el2.style.width = '1024px';
					_el2.children[0].style.width = '50%';
					_el2.children[1].style.width = '50%';
					setTimeout(function () {
						html2canvas(_el2, { logging: false }).then(function (canva) {
							timeDeviceCanva = canva;
							isTimeDeviceReady = true;
							_el2.children[0].style.width = '50%'; //e2_width + 'px'
							_el2.children[1].style.width = '50%'; //e2_width + 'px'
							_el2.style.width = tdWidth + 'px';
							_el2.classList.add("p-10");
							_el2.classList.add("mt-10");
							_el2.classList.remove("no-padding");
						});
					}, 50);
				}
				els = document.getElementsByClassName("time-traffic-section");
				var isTimeTrafficeReady = false;
				if (els.length > 0) {
					var _el3 = els[0];
					var ttWidth = _el3.offsetWidth;
					_el3.style.width = '1024px';
					setTimeout(function () {
						html2canvas(_el3, { logging: false }).then(function (canvas) {
							timeTrafficCanva = canvas;
							isTimeTrafficeReady = true;
							_el3.style.width = ttWidth + 'px';
						});
					}, 100);
				}
				els = document.getElementsByClassName("most-popular-section");
				var isMostPopularReady = isPageVisit ? true : false;
				if (els.length > 0 && !isPageVisit) {
					var _el4 = els[0];
					var mpWidth = _el4.offsetWidth;
					var w1 = _el4.children[0].offsetWidth;
					_el4.children[0].style.width = '502px';
					_el4.style.width = '1024px';
					_el4.classList.remove("pl-10");
					_el4.classList.add("no-padding-left");
					setTimeout(function () {
						html2canvas(_el4, { logging: false }).then(function (canva) {
							mostPopularCanva = canva;
							isMostPopularReady = true;
							_el4.classList.add("pl-10");
							_el4.classList.remove("no-padding-left");
							_el4.children[0].style.width = w1 + 'px';
							_el4.style.width = mpWidth + 'px';
						});
					}, 50);
				}
				var top = 10;
				var url = new _url3.URL(window.location.href);
				var page = url.searchParams.get("p");
				var intervalId = setInterval(function () {
					if (isDemoGeoReady === false || isTotalVisitReady === false || isTimeDeviceReady === false || isTimeTrafficeReady === false || isMostPopularReady === false) {
						console.log('PDF generating...');
					} else {
						clearInterval(intervalId);
						//pdf.setDrawColor(0, 123, 99)
						setTimeout(function () {
							pdf.setFillColor(127, 127, 127);
							pdf.rect(0, 15, 210, 10, 'F');
	
							pdf.setTextColor(0, 0, 0);
							pdf.setFontSize(9);
							pdf.setFontType('bold');
							pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), 'PNG', 10.5, 3, 60, 0);
							pdf.text(198, 8, (0, _moment2.default)().format('MMMM DD, YYYY'), null, null, 'right');
	
							pdf.setTextColor(255, 255, 255);
							pdf.setFontType('bold');
							pdf.text(12, 19, 'Client:');
							var lenClientName = (0, _utility.getTextSize)(clientName.trim(), 'helvetica');
							pdf.setFontType('normal');
							pdf.text(23, 19, clientName.trim());
							//cm to inches
							var start = 23 + lenClientName.width * 0.3937 + 0.4;
							pdf.setFontType('bold');
							pdf.text(start, 19, 'WEBSITE NAME:');
							start += 26.5;
							pdf.setFontType('normal');
							pdf.text(start, 19, s && s.label ? s.label.trim() : '');
							start += s && s.label ? (0, _utility.getTextSize)(s.label.trim(), 'helvetica').width * 0.3937 + 0.4 : 1;
							pdf.setFontType('bold');
							pdf.text(start, 19, 'Date:');
							pdf.setFontType('normal');
							start += (0, _utility.getTextSize)('Date:', 'helvetica').width * 0.3937 + 0.4;
							pdf.text(start, 19, this.getDayRangeTitle(dayRange));
							if (isPageVisit) {
								pdf.setFontType('bold');
								pdf.text(12, 24, 'Page:');
								pdf.setFontType('normal');
								pdf.text(22, 24, page);
							}
	
							pdf.setFillColor(255);
							pdf.setLineWidth(0.05);
							//pdf.line(0, isPageVisit ? 32 : 27, 210, isPageVisit ? 32 : 27)
							//pdf.line(0, isPageVisit ? 27: 22, 210, isPageVisit ? 27: 22)
							//top = isPageVisit ? 37 : 32
							top = isPageVisit ? 32 : 27;
	
							pdf.addImage(totalVisitsCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0);
							pdf.setLineWidth(0.03);
							var h1 = totalVisitsCanva.height * pageWidth / totalVisitsCanva.width;
							//pdf.line(123, top+2, 123, top + h1 - 2)
							//top += h1 + 5
							top += h1 + 3.5;
							pdf.addImage(demoGeoCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0);
							var h2 = demoGeoCanva.height * pageWidth / demoGeoCanva.width;
							pdf.setLineWidth(0.1);
							//pdf.line(92, top+2, 92, top + h2 - 2)
							//pdf.line(15.5, top + h2 - 5, 88, top + h2 - 5)
							//pdf.line(95, top + h2 - 5, 147, top + h2 -5)
							top += h2 + 5;
	
							pdf.addImage(timeDeviceCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0);
							pdf.setLineWidth(0.1);
							//pdf.line(15.5, top + h3 - 5.5, 59, top + h3 - 5.5)
							//pdf.line(110.5, top + h3 - 5.5, 154, top + h3 - 5.5)
	
							top += timeDeviceCanva.height * pageWidth / timeDeviceCanva.width + 5;
	
							var imgHeight = timeTrafficCanva.height * pageWidth / timeTrafficCanva.width;
							pdf.addImage(timeTrafficCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0);
							top += imgHeight + 3;
	
							if (!isPageVisit) pdf.addImage(mostPopularCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0);
							//top += mostPopularCanva.height * pageWidth / mostPopularCanva.width + 5
	
							(0, _utility.addPdfFooter)(pdf);
							pdf.save(fileName);
							/*
	      setTimeout(function(){
	      	map(listChartFooters, function(el){
	      		el.style['display'] = 'block'
	      	})
	      }, 8000)*/
							this.setState({ showLoadingDialog: false });
						}.bind(this), 100);
					}
				}.bind(this), 50);
			}
		}, {
			key: 'getDayRangeTitle',
			value: function getDayRangeTitle(key) {
	
				switch (key) {
					case 'today':
						return "Today";
					case 'yesterday':
						return "Yesterday";
					case 'last-7-days':
						return 'Last 7 Days';
					case 'last-30-days':
						return 'Last 30 Days';
					case 'last-60-days':
						return 'Last 60 Days';
					case 'last-90-days':
						return 'Last 90 days';
					default:
						return '';
				}
			}
		}, {
			key: 'handleDownloadBtn',
			value: function handleDownloadBtn() {
				var _this2 = this;
	
				var nav = (0, _utility.getUrlParameterByName)('nav') || 'overview';
				var popUrl = (0, _utility.getUrlParameterByName)('pop_url');
				var reportType = this.props.reportType;
				if (reportType !== 'business') {
					return function () {
						return _this2.setState({ showDownloadDialog: true });
					};
				} else {
					if (nav === 'overview' || nav === 'pop' && popUrl) {
						return function () {
							return _this2.setState({ showDownloadDialog: true });
						};
					}
				}
				return null;
			}
		}, {
			key: 'cbPDFChange',
			value: function cbPDFChange(e, isInputChecked) {
				var result = !this.refs.cbCSV.state.switched && !isInputChecked;
				this.setState({ disabledBtnDownload: result });
			}
		}, {
			key: 'cbCSVChange',
			value: function cbCSVChange(e, isInputChecked) {
				var result = !this.refs.cbPDF.state.switched && !isInputChecked;
				this.setState({ disabledDlBtn: result });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props5 = this.props,
				    location = _props5.location,
				    statsByDevice = _props5.statsByDevice,
				    statsByTime = _props5.statsByTime,
				    statsByRegionalTraffic = _props5.statsByRegionalTraffic,
				    statsByPopularPages = _props5.statsByPopularPages,
				    top20FrequencyBusinesses = _props5.top20FrequencyBusinesses,
				    statsByDemographic = _props5.statsByDemographic,
				    client_sites = _props5.client_sites,
				    statsByTimeOfDay = _props5.statsByTimeOfDay,
				    domesticVisitsSummary = _props5.domesticVisitsSummary,
				    domesticBusinessVisitsReport = _props5.domesticBusinessVisitsReport,
				    websiteId = _props5.websiteId,
				    statsTopAttributes = _props5.statsTopAttributes,
				    dayRange = _props5.dayRange,
				    heatMapPoints = _props5.heatMapPoints,
				    loadingDomesticVisitsSummary = _props5.loadingDomesticVisitsSummary,
				    client_info = _props5.client_info,
				    loadingStatsByDemographic = _props5.loadingStatsByDemographic,
				    loadingStatsByDeviceType = _props5.loadingStatsByDeviceType,
				    loadingStatsByTime = _props5.loadingStatsByTime,
				    kindOfReport = _props5.kindOfReport,
				    loadingStatsByPopularPage = _props5.loadingStatsByPopularPage,
				    loadingStatsByRegionalTraffic = _props5.loadingStatsByRegionalTraffic,
				    loadingStatsByTimeOfDay = _props5.loadingStatsByTimeOfDay,
				    loadingStatsTopAttributes = _props5.loadingStatsTopAttributes,
				    loadingStatsByPrimaryDevices = _props5.loadingStatsByPrimaryDevices,
				    statsByDeviceModel = _props5.statsByDeviceModel,
				    statsByOsType = _props5.statsByOsType,
				    states = _props5.states;
	
				var dataOnLoading = loadingDomesticVisitsSummary || loadingStatsByDemographic || loadingStatsByDeviceType || loadingStatsByTime || loadingStatsByPopularPage || loadingStatsByRegionalTraffic || loadingStatsByTimeOfDay || loadingStatsTopAttributes || loadingStatsByPrimaryDevices;
				var pathname = location.pathname,
				    search = location.search;
	
				var isPageVisit = pathname === '/insights/page-visits' || search.indexOf("type=pop-pages") >= 0 || search.indexOf("tag=page") >= 0 || search.indexOf("p=") >= 0;
				if ((0, _lodash.isEmpty)(client_sites)) {
					return _react2.default.createElement(
						'div',
						{ id: 'website-visits-container' },
						_react2.default.createElement(
							'div',
							{ style: { padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" } },
							_react2.default.createElement(_SiteDateSelector2.default, { type: 'larger', key: 'map-site-date-selector-' + new Date().getTime(),
								websiteIdChanged: this.props.setWebsiteId,
								siteId: websiteId, sites: this.props.client_sites, dayRangeChanged: this.props.setDateRange, dayRange: this.props.dayRange })
						),
						_react2.default.createElement(_InsightNav2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'website-visits-content' },
							_react2.default.createElement(
								'div',
								{ style: { width: '100%', minHeight: '280px', textAlign: 'center', paddingTop: '150px', color: "#CDCDCD" } },
								_react2.default.createElement(
									'div',
									{ style: { color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' } },
									'No Data'
								)
							)
						)
					);
				}
	
				var url = new _url3.URL(window.location.href);
				var page = url.searchParams.get("p");
				var nav = (0, _utility.getUrlParameterByName)('nav') || 'overview';
				var popUrl = (0, _utility.getUrlParameterByName)('pop_url');
	
				var sendRequestSource = "";
				if (this.props.reportType === "consumer") {
					if (popUrl) sendRequestSource = "Consumer > Most Popular Pages > " + popUrl;else {
						sendRequestSource = nav === "pop" ? "Consumer most popular page" : "Consumer " + nav + " page";
					}
				}
				if (this.props.reportType === "business") {
					if (nav === "pop") {
						if (popUrl) sendRequestSource = "Business > Most Popular Pages > " + popUrl;else sendRequestSource = "Business > Most Popular Pages";
					} else sendRequestSource = kindOfReport === "map" ? "Business > Geographic Traffic " : "Business overview page";
				}
				var visitDevices = statsByDevice ? [] : undefined;
				var timeTraffic = statsByTime ? [] : undefined;
				var popularPages = statsByPopularPages ? [] : undefined;
				var visitsByTime = statsByTimeOfDay ? [] : undefined;
				var geoTrafficeData = (0, _lodash.isEmpty)(states) ? undefined : [];
				var heatMapData = [];
	
				var addPercentSign = function addPercentSign(val) {
					return val.toFixed(2) + '%';
				};
	
				//const demoData = statsByDemographic ? [] : undefined
				var demoData = undefined;
				if (this.props.reportType === "consumer") {
					if (statsByDemographic) {
						demoData = [];
						(0, _lodash.map)(statsByDemographic, function (stat, key) {
							if (key === 'maritalStats') return;
							var title = (0, _utility.getDemographicText)(key.replace("Stats", ""));
							var valText = '';
							if (Array.isArray(stat)) {
								if (stat.length > 1) {
									stat.forEach(function (item) {
										switch (key) {
											case "genderStats":
												/*if (item.key !== 'U')
	           	valText += addPercentSign(item.value * 100) + ' (' + item.key + ') - '
	           */
												if ((0, _lodash.isEmpty)(valText)) valText = addPercentSign(item.value * 100) + ' (' + item.key + ') - ';
												break;
											case "maritalStats":
												/*
	           if (item.key === 'M')
	           	valText += addPercentSign(item.value * 100) + '  '*/
												break;
											default:
												valText += addPercentSign(item.value * 100) + ' (' + item.key + ') - ';
										}
									});
									valText = valText.substring(0, valText.length - 2);
								} else {
									valText = key === stat.length > 0 ? 'genderStats' ? addPercentSign(stat[0].value * 100) + ' (' + stat[0].key + ')' : addPercentSign(stat[0].value * 100) : "";
								}
							} else {
								switch (key) {
									case 'medianAge':
										valText = Math.round(stat) + '';
										break;
									case 'medianNumberOfPeople':
										valText = Math.round(stat * 10) / 10 + '';
										break;
									case 'medianIncome':
										valText = '$' + (0, _utility.splitNumber)(Math.round(stat))();
										break;
									default:
										valText = stat + '';
								}
							}
							if (valText === "0" || (0, _lodash.isEmpty)(valText) || valText === 'null' || valText === "$0") {
								valText = 'UnKnown';
								if (_this3.props.client_sites && Array.isArray(_this3.props.client_sites) && _this3.props.client_sites.length > 0) {
									var site_name = _this3.props.client_sites[0].label;
									if (site_name === 'Auto Inc.') {
										switch (key) {
											case 'medianAge':
												valText = '50';
												break;
											case 'medianNumberOfPeople':
												valText = '2.3';
												break;
											case 'medianIncome':
												valText = '$' + (0, _utility.splitNumber)(47965)();
												break;
											case 'homeOwnershipStats':
												valText = '52.56%';
												break;
											case 'genderStats':
												valText = '46.30% (M)';
												break;
											default:
												valText = '';
										}
									}
								}
							}
							demoData.push({ name: title, value: valText });
						});
					}
				} else {
					if (domesticBusinessVisitsReport) {
						demoData = [{ name: "Top Industry", value: "Unknown" }, { name: "Average Annual Company Revenue", value: 'Unknown' }, { name: "Average Number of Company Employees", value: 'Unknown' }, { name: "Average Age of Business", value: "Unknown" }, { name: "Home Business", value: "Unknown" }];
						(0, _lodash.map)(domesticBusinessVisitsReport, function (stats, key) {
							var title = "";
							var valText = "";
							switch (key) {
								case 'totalVisits':
								case 'uniqueVisits':
									title = 'Unique Business Visits';
									valText = (0, _utility.splitNumber)(stats)();
									break;
								case 'topIndustry':
									title = 'Top Industry';
									valText = stats;
									break;
								case 'averageBizAge':
									title = 'Average Age of Business';
									valText = stats ? stats.toFixed(2) + " years" : "";
									break;
								case 'averageEmployees':
									title = 'Average Number of Company Employees';
									valText = stats ? isNaN(stats) ? "N/A" : (0, _utility.splitNumber)(parseInt(stats, 10))() : "N/A";
									break;
								case 'averageRevenue':
									title = 'Average Annual Company Revenue';
									valText = stats ? isNaN(stats) ? "N/A" : "$" + (0, _utility.splitNumber)(stats)() : "N/A";
									break;
								case 'homeBizPercentage':
									title = "Home Business";
									valText = stats === 0 ? "Unknown" : addPercentSign(stats * 100);
									break;
								default:
									title = "";
							}
							if (valText === "0" || (0, _lodash.isEmpty)(valText)) valText = "Unknown";
							var idx = (0, _lodash.findIndex)(demoData, { name: title });
							if (idx >= 0) demoData.splice(idx, 1, { name: title, value: valText });
						});
					}
				}
	
				if (statsByTimeOfDay) {
					(0, _lodash.map)(statsByTimeOfDay.stats, function (stat) {
						visitsByTime.push({
							name: stat.type,
							value: stat.uniquePercentage * 100,
							uniqueVisits: stat.unique
						});
					});
				}
				var visitsSummary = undefined;
				if (domesticVisitsSummary) {
					visitsSummary = {
						totalVisitsCount: 0,
						uniqueVisitsCount: 0,
						reachStats: {}
					};
	
					visitsSummary.totalVisitsCount = domesticVisitsSummary.totalVisits;
					visitsSummary.uniqueVisitsCount = domesticVisitsSummary.uniqueVisits;
					visitsSummary.reachStats = domesticVisitsSummary.reachStats;
				}
	
				if (statsByDevice) {
					(0, _lodash.map)(statsByDevice.stats, function (obj) {
						var device = { name: obj.type, value: obj.uniquePercentage * 100, uniqueVisits: obj.unique };
						visitDevices.push(device);
					});
				}
	
				var timeTrafficStatsTitle = '';
				timeTrafficStatsTitle = '' + this.getDayRangeTitle(dayRange);
	
				if (statsByTime) {
					(0, _lodash.map)(statsByTime.stats, function (obj) {
						var timeStr = '';
						switch (dayRange) {
							case 'yesterday':
							case 'today':
								timeStr = (0, _moment2.default)(obj.type).format("hA");
								break;
							default:
								timeStr = (0, _moment2.default)(obj.type, 'YYYY-MM-DD').format("MMM-DD");
						}
						var item = { time: timeStr, totalVisits: obj.total, uniqueVisits: obj.unique };
						timeTraffic.push(item);
					});
				}
				if (states && !(0, _lodash.isEmpty)(states)) {
					var values = states;
					var sum = (0, _reduce2.default)(values, function (sum, d) {
						return sum + d.unique;
					}, 0);
					(0, _lodash.map)(values, function (obj) {
						geoTrafficeData.push({
							name: obj.type,
							value: obj.unique / sum * 100,
							uniqueVisits: obj.unique
						});
					});
					geoTrafficeData = (0, _sortBy2.default)(geoTrafficeData, "value").reverse();
				}
				if (heatMapPoints) {
					(0, _lodash.map)(heatMapPoints, function (point) {
						heatMapData.push({
							position: [point.lon, point.lat],
							weight: parseInt(point.u, 10)
						});
					});
				}
	
				if (statsByPopularPages) {
					(0, _lodash.map)(statsByPopularPages, function (stat) {
						popularPages.push({
							name: stat.pageUrl,
							value: stat.totalVisits
						});
					});
				}
	
				if (kindOfReport === "popular") {
					if ((0, _lodash.isNil)(popularPages)) {
						return _react2.default.createElement(
							'div',
							{ id: 'website-visits-container' },
							_react2.default.createElement(
								'div',
								{ style: { padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" } },
								_react2.default.createElement(_SiteDateSelector2.default, { type: 'larger', key: 'top-pages-date-selector-' + new Date().getTime(), websiteIdChanged: this.props.setWebsiteId,
									siteId: websiteId, sites: this.props.client_sites, dayRangeChanged: this.props.setDateRange, dayRange: this.props.dayRange })
							),
							_react2.default.createElement(_InsightNav2.default, { activeIndex: isPageVisit ? 1 : 0,
								clientId: this.props.selected_client, tagId: this.props.websiteId }),
							_react2.default.createElement(
								'div',
								{ className: 'website-visits-content' },
								_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } }),
								'\xA0loading...'
							)
						);
					} else {
						return _react2.default.createElement(
							'div',
							{ id: 'website-visits-container' },
							_react2.default.createElement(
								'div',
								{ style: { padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" } },
								_react2.default.createElement(_SiteDateSelector2.default, { type: 'larger', key: 'top-page-date-selector-' + new Date().getTime(), websiteIdChanged: this.props.setWebsiteId,
									siteId: websiteId, sites: this.props.client_sites, dayRangeChanged: this.props.setDateRange, dayRange: this.props.dayRange })
							),
							_react2.default.createElement(_InsightNav2.default, { activeIndex: isPageVisit ? 1 : 0,
								clientId: this.props.selected_client, tagId: this.props.websiteId }),
							_react2.default.createElement(
								'div',
								{ className: 'website-visits-content' },
								_react2.default.createElement(
									_Grid.FullRow,
									{ className: 'no-padding mb-20 no-margin-top' },
									_react2.default.createElement(_InsightBreadcrumb2.default, { src: this.props.reportType, clientId: this.props.selected_client,
										tagId: this.props.websiteId, kindOfReport: this.props.kindOfReport })
								),
								_react2.default.createElement(
									'div',
									{ className: 'black-border pb-10 bg-white' },
									_react2.default.createElement(_PopularPageList2.default, { key: '', title: 'MOST POPULAR PAGES', reportType: this.props.reportType,
										subTitle: 'Total Visits', data: popularPages, tier: client_info.subscriptionTierId })
								)
							)
						);
					}
				}
				var navFirEle = _react2.default.createElement(
					'div',
					{ className: 'nav-frequents', style: { height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
					_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } }),
					'\xA0loading...'
				);
				if (top20FrequencyBusinesses) {
					navFirEle = _react2.default.createElement(
						'div',
						{ className: 'light-grey-border no-padding-bottom' },
						_react2.default.createElement(_FrequencyVisitorList2.default, { key: 'freq-visitors-container', title: 'Top 20 Companies that have Visited',
							data: top20FrequencyBusinesses })
					);
				}
	
				if (kindOfReport === "frequents") {
					if ((0, _isUndefined2.default)(top20FrequencyBusinesses)) {
						return _react2.default.createElement(
							'div',
							{ id: 'website-visits-container' },
							_react2.default.createElement(
								'div',
								{ style: { padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" } },
								_react2.default.createElement(_SiteDateSelector2.default, { key: 'top-pages-date-selector-' + new Date().getTime(), websiteIdChanged: this.props.setWebsiteId,
									siteId: websiteId, sites: this.props.client_sites, dayRangeChanged: this.props.setDateRange, dayRange: this.props.dayRange })
							),
							_react2.default.createElement(_InsightNav2.default, { activeIndex: isPageVisit ? 1 : 0,
								clientId: this.props.selected_client, tagId: this.props.websiteId }),
							_react2.default.createElement(
								'div',
								{ className: 'website-visits-content' },
								_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } }),
								'\xA0loading...'
							)
						);
					}
					if (top20FrequencyBusinesses) {
						return _react2.default.createElement(
							'div',
							{ id: 'website-visits-container' },
							_react2.default.createElement(_BasicTierUpgradeInform2.default, {
								showUpgradeInfoDialog: Boolean(this.state.showUpgradeInfoDialog),
								onContactFormSubmit: this.props.sendAssistRequest.bind(this),
								send_assist_request_error: this.props.send_assist_request_error,
								selected_client: this.props.selected_client,
								request_assist_successful: this.props.request_assist_successful,
								type: this.props.reportType,
								roleId: this.props.roleId,
								originationPage: this.props.reportType === "consumer" ? "Main Consumer Insights Dashboard - Static Page" : "Main Business Insights Dashboard - Static Page",
								history: this.props.history,
								closeDialog: function closeDialog() {
									return _this3.props.history.push("/insights/" + _this3.props.reportType + "?cid=" + _this3.props.selected_client);
								} }),
							_react2.default.createElement(
								'div',
								{ style: { padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" } },
								_react2.default.createElement(_SiteDateSelector2.default, { key: 'top-page-date-selector-' + new Date().getTime(),
									websiteIdChanged: this.props.setWebsiteId,
									siteId: websiteId, sites: this.props.client_sites,
									dayRangeChanged: this.props.setDateRange,
									dayRange: this.props.dayRange })
							),
							_react2.default.createElement(_InsightNav2.default, { activeIndex: isPageVisit ? 1 : 0,
								clientId: this.props.selected_client, tagId: this.props.websiteId }),
							_react2.default.createElement(
								'div',
								{ className: 'website-visits-content' },
								_react2.default.createElement(
									_Grid.FullRow,
									{ className: 'no-padding mb-20 no-margin-top' },
									_react2.default.createElement(_InsightBreadcrumb2.default, { src: this.props.reportType, clientId: this.props.selected_client,
										tagId: this.props.websiteId, kindOfReport: this.props.kindOfReport })
								),
								_react2.default.createElement(
									'div',
									{ className: 'light-grey-border no-padding-bottom', style: { minWidth: "1000px" } },
									_react2.default.createElement(_FrequencyVisitorList2.default, { key: 'freq-visitors-container', title: 'TOP 20 COMPANIES THAT HAVE VISITED',
										data: top20FrequencyBusinesses })
								)
							)
						);
					}
				}
				var formatAddDemoData = function formatAddDemoData() {
					var demographic = statsTopAttributes.demographic,
					    behavioral = statsTopAttributes.behavioral;
	
					var demoDatas = [];
					(0, _lodash.map)((0, _lodash.orderBy)(demographic, ['visitorPercentage'], ['desc']), function (item) {
						demoDatas.push({
							name: item.name,
							value: item.label,
							visits: item.visitorPercentage
						});
					});
	
					var behavioralDatas = [];
					(0, _lodash.map)((0, _lodash.orderBy)(behavioral, ['visitorPercentage'], ['desc']), function (item) {
						behavioralDatas.push({
							name: item.name,
							value: item.label,
							visits: item.visitorPercentage
						});
					});
					return [demoDatas, behavioralDatas];
				};
				if (kindOfReport === "top") {
					if (!statsTopAttributes) {
						return _react2.default.createElement(
							'div',
							{ id: 'website-visits-container' },
							_react2.default.createElement(
								'div',
								{ style: { padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" } },
								_react2.default.createElement(_SiteDateSelector2.default, { key: 'top-pages-date-selector-' + new Date().getTime(), websiteIdChanged: this.props.setWebsiteId,
									siteId: websiteId, sites: this.props.client_sites, dayRangeChanged: this.props.setDateRange, dayRange: this.props.dayRange })
							),
							_react2.default.createElement(_InsightNav2.default, { activeIndex: isPageVisit ? 1 : 0,
								clientId: this.props.selected_client, tagId: this.props.websiteId }),
							_react2.default.createElement(
								'div',
								{ className: 'website-visits-content' },
								_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } }),
								'\xA0loading...'
							)
						);
					}
	
					var _formatAddDemoData = formatAddDemoData(),
					    _formatAddDemoData2 = _slicedToArray(_formatAddDemoData, 2),
					    demoDatas = _formatAddDemoData2[0],
					    behavioralDatas = _formatAddDemoData2[1];
	
					return _react2.default.createElement(
						'div',
						{ id: 'website-visits-container' },
						_react2.default.createElement(
							_materialUi.Dialog,
							{ open: this.state.showLoadingDialog || !!dataOnLoading,
								style: { top: '-1.8em' },
								overlayStyle: { opacity: 0.9, backgroundColor: '#666666' },
								modal: true },
							_react2.default.createElement(
								_Grid.Row,
								{ className: 'mt-20' },
								_react2.default.createElement(
									_Grid.Col,
									{ xs: '7', sm: '7', md: '7', lg: '6', className: 'text-right' },
									_react2.default.createElement(
										'div',
										null,
										dataOnLoading ? "Data loading, please wait..." : "Downloading, please wait..."
									)
								),
								_react2.default.createElement(
									_Grid.Col,
									{ xs: '2', sm: '2', md: '2', lg: '2' },
									_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { padding: '0 10%', marginTop: "-20px", marginBottom: "-10px", background: "#FAFAFA" } },
							_react2.default.createElement(_SiteDateSelector2.default, { key: 'top-page-date-selector-' + new Date().getTime(),
								showGranularity: true,
								websiteIdChanged: this.props.setWebsiteId,
								siteId: websiteId, sites: this.props.client_sites,
								downloadBtnText: 'Download Report',
								dayRangeChanged: this.props.setDateRange,
								dayRange: this.props.dayRange,
								granularity: this.props.granularity,
								granularityChanged: this.props.setGranularity
							})
						),
						_react2.default.createElement(_InsightNav2.default, { activeIndex: isPageVisit ? 1 : 0,
							clientId: this.props.selected_client, tagId: this.props.websiteId }),
						_react2.default.createElement(
							'div',
							{ className: 'website-visits-content' },
							_react2.default.createElement(
								'div',
								{ className: 'no-padding mb-20 no-margin-top' },
								_react2.default.createElement(_InsightBreadcrumb2.default, { src: this.props.reportType, clientId: this.props.selected_client,
									tagId: this.props.websiteId, kindOfReport: this.props.kindOfReport })
							),
							_react2.default.createElement(
								'div',
								{ className: 'black-border no-padding-bottom top-demographics' },
								_react2.default.createElement(_TopAttributeList2.default, { key: '', title: 'TOP DEMOGRAPHIC / HOUSEHOLD ATTRIBUTES',
									subTitle: 'Unique Visits', data: demoDatas })
							),
							_react2.default.createElement(
								'div',
								{ className: 'black-border mt-20 no-padding-bottom top-behaviors' },
								_react2.default.createElement(_TopAttributeList2.default, { title: 'TOP BEHAVIORAL ATTRIBUTES',
									subTitle: 'Unique Visits', data: behavioralDatas })
							)
						)
					);
				}
				var reportType = this.props.reportType;
				var showGranularity = false;
				return _react2.default.createElement(
					'div',
					{ id: 'website-visits-container' },
					_react2.default.createElement(
						_materialUi.Dialog,
						{ open: this.state.showLoadingDialog || !!dataOnLoading,
							style: { top: '-1.8em' },
							overlayStyle: { opacity: 0.9, backgroundColor: '#666666' },
							modal: true },
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'mt-20' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '6', sm: '6', md: '6', lg: '6', className: 'text-right' },
								_react2.default.createElement(
									'div',
									null,
									dataOnLoading ? "Data loading, please wait..." : "Downloading, please wait..."
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '2', sm: '2', md: '2', lg: '2' },
								_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
							)
						)
					),
					(nav && nav !== "overview" && nav !== "demographics" && nav !== "device" && nav !== "pop" || kindOfReport === "map" || kindOfReport === "frequents" || nav === 'fir') && _react2.default.createElement(_BasicTierUpgradeInform2.default, {
						showUpgradeInfoDialog: Boolean(this.state.showUpgradeInfoDialog),
						onContactFormSubmit: this.props.sendAssistRequest.bind(this),
						send_assist_request_error: this.props.send_assist_request_error,
						selected_client: this.props.selected_client,
						request_assist_successful: this.props.request_assist_successful,
						type: this.props.reportType,
						roleId: this.props.roleId,
						closeDialog: function closeDialog() {
							_this3.props.history.push("/insights/" + _this3.props.reportType + "?cid=" + _this3.props.selected_client);
						},
						originationPage: this.props.reportType === "consumer" ? "Main Consumer Insights Dashboard - Static Page" : "Main Business Insights Dashboard - Static Page",
						history: this.props.history }),
					showGranularity ? _react2.default.createElement(
						'div',
						{ className: 'new-insight-navigator mb-20', style: {
								padding: '0 10% 20px',
								borderBottom: '1px solid #b1b0b0'
							} },
						_react2.default.createElement(_newNavigator2.default, { siteId: websiteId, options: nav === 'overview' ? [{ name: 'Insights', event: function event() {
									_this3.props.history.push('/insights/summary?cid=' + _this3.props.selected_client);
								} }, { name: 'Site Analytics', event: function event() {
									_this3.props.history.push('/insights/summary?cid=' + _this3.props.selected_client);
								} }, { name: 'Overview', event: undefined }] : [{ name: 'Insights', event: function event() {
									_this3.props.history.push('/insights/summary?cid=' + _this3.props.selected_client);
								} }, { name: 'Site Analytics', event: function event() {
									_this3.props.history.push('/insights/summary?cid=' + _this3.props.selected_client);
								} }, { name: 'Most Popular Pages', event: function event() {
									_this3.props.history.push('/insights/consumer?nav=pop&cid=' + _this3.props.selected_client);
								} }, { name: popUrl, event: undefined }] })
					) : null,
					_react2.default.createElement(
						'div',
						{ style: { padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" } },
						_react2.default.createElement(_SiteDateSelector2.default, {
							type: 'larger',
							showGranularity: reportType === "consumer" && kindOfReport !== "map" && nav && (nav === "overview" || nav === "pop" && popUrl),
							key: 'web-stats-date-selector-' + new Date().getTime(),
							websiteIdChanged: this.props.setWebsiteId,
							siteId: websiteId, sites: this.props.client_sites,
							downloadBtnText: 'Download Report',
							handlePdfDownload: this.handleDownloadBtn(),
							dayRangeChanged: this.props.setDateRange, dayRange: this.props.dayRange,
							granularity: this.props.granularity,
							granularityChanged: this.props.setGranularity })
					),
					_react2.default.createElement(_InsightNav2.default, { activeIndex: isPageVisit ? 1 : 0,
						clientId: this.props.selected_client, tagId: this.props.websiteId }),
					_react2.default.createElement(
						'div',
						{ className: 'website-visits-content' },
						search.indexOf("type=") < 0 && !showGranularity && _react2.default.createElement(
							'div',
							{ className: 'no-padding mb-20 no-margin-top' },
							_react2.default.createElement(_InsightBreadcrumb2.default, {
								src: this.props.reportType,
								kindOfReport: this.props.kindOfReport,
								clientId: this.props.selected_client,
								tagId: this.props.websiteId,
								popUrl: popUrl,
								nav: nav
							})
						),
						_react2.default.createElement(
							'div',
							{ style: { display: "flex" } },
							_react2.default.createElement(_SideBar2.default, {
								type: nav ? nav : "overview",
								history: this.props.history,
								clientId: this.props.selected_client,
								pageUrl: popUrl,
								reportType: this.props.reportType }),
							_react2.default.createElement(
								'div',
								{ className: 'ml-20', style: { flex: "1 1" } },
								_react2.default.createElement(
									'div',
									{ className: 'overview-insights-container', id: 'overview-dashboard', style: { fontSize: "16px" } },
									(this.props.kindOfReport !== "map" && this.props.reportType !== "business" || this.props.reportType === "business" && nav === "pop") && [_react2.default.createElement(
										'div',
										{ key: '1', id: 'consumer-overflow-pdf-part1',
											style: {
												background: "#F5F5F5",
												fontSize: "24px",
												fontWeight: "bold",
												padding: "15px 20px",
												marginBottom: '20px'
											}
										},
										this.props.reportType === 'business' ? 'Business' : 'Consumer',
										' Site Traffic'
									), _react2.default.createElement(
										'div',
										{ key: '2', id: 'service-contact', className: "mt-20 p-20 light-grey-border" + (this.props.reportType === 'business' && nav === 'pop' && popUrl ? ' mb-20' : ''), style: { display: 'block' } },
										_react2.default.createElement(
											'div',
											{ style: { textAlign: "center" } },
											_react2.default.createElement(_ServiceContact2.default, { className: 'no-padding', sendAssistRequest: this.props.sendAssistRequest,
												style: { fontSize: '16px', textAlign: "center" },
												messageText: this.props.reportType === 'business' && nav === 'pop' && popUrl && 'to engage and activate these audiences across online and offline channels.',
												send_assist_request_error: this.props.send_assist_request_error,
												request_assist_successful: this.props.request_assist_successful,
												selected_client: this.props.selected_client, pageSource: sendRequestSource })
										)
									)],
									(!nav || nav === 'overview') && this.props.reportType === 'business' && _react2.default.createElement(
										'div',
										{ className: 'mb-20 p-20 light-grey-border', id: 'service-contact', style: { display: 'block' } },
										_react2.default.createElement(
											'div',
											{ style: { textAlign: "center" } },
											_react2.default.createElement(_ServiceContact2.default, { className: 'no-padding', sendAssistRequest: this.props.sendAssistRequest,
												style: { fontSize: '16px', textAlign: "center" },
												messageText: 'to engage and activate these audiences across online and offline channels.',
												send_assist_request_error: this.props.send_assist_request_error,
												request_assist_successful: this.props.request_assist_successful,
												selected_client: this.props.selected_client, pageSource: sendRequestSource })
										)
									),
									(!nav || nav === "overview" || nav === 'pop' && popUrl) && _react2.default.createElement(_OverviewInsights2.default, {
										visitsByTime: visitsByTime,
										geoTrafficeData: geoTrafficeData,
										timeTraffic: timeTraffic,
										timeTrafficStatsTitle: timeTrafficStatsTitle, visitsSummary: visitsSummary, kindOfReport: kindOfReport,
										selected_client: this.props.selected_client,
										heatMapData: heatMapData, loadingStatsByRegionalTraffic: loadingStatsByRegionalTraffic,
										reportType: this.props.reportType,
										deviceTypeData: statsByDevice,
										popUrl: popUrl,
										sendAssistRequest: this.props.sendAssistRequest,
										send_assist_request_error: this.props.send_assist_request_error,
										request_assist_successful: this.props.request_assist_successful,
										pageSource: sendRequestSource,
										statsByPopularPages: popularPages ? popularPages.slice(0, 5) : undefined,
										demoData: demoData,
										pdfCreating: this.state.pdfCreating,
										client_info: this.props.client_info
									}),
									nav && nav === "device" && _react2.default.createElement(_Device2.default, { deviceTypeData: statsByDevice, deviceModelData: statsByDeviceModel,
										top5OSBreakDown: statsByOsType }),
									nav === "pop" && !popUrl && _react2.default.createElement(_MostPopularPage2.default, {
										data: statsByPopularPages,
										client_info: this.props.client_info
									}),
									nav === 'fir' && navFirEle
								)
							)
						)
					),
					_react2.default.createElement(
						_materialUi.Dialog,
						{
							open: !!this.state.showDownloadDialog,
							style: { top: "-1.8em" },
							modal: true,
							contentStyle: { width: "440px" }
						},
						_react2.default.createElement(
							_Grid.FullRow,
							{
								className: 'no-margin-top no-padding',
								style: { fontSize: "16px", color: "#000" }
							},
							_react2.default.createElement(
								'strong',
								null,
								'Choose the type of file you would like to download'
							)
						),
						_react2.default.createElement(
							_Grid.FullRow,
							{
								className: 'no-padding-top no-padding-right no-padding-bottom no-margin-bottom',
								style: { paddingLeft: "150px" }
							},
							_react2.default.createElement(_Checkbox2.default, {
								iconStyle: { fill: "#47A1AB", marginRight: "10px" },
								label: "PDF File",
								labelStyle: { fontSize: "13px" },
								defaultChecked: true,
								ref: 'cbPDF',
								onCheck: function onCheck(e, isInputChecked) {
									return _this3.cbPDFChange(e, isInputChecked);
								}
							})
						),
						_react2.default.createElement(
							_Grid.FullRow,
							{
								className: 'no-padding-top no-padding-right no-padding-bottom',
								style: { paddingLeft: "150px" }
							},
							_react2.default.createElement(_Checkbox2.default, {
								iconStyle: { fill: "#47A1AB", marginRight: "10px" },
								label: "CSV File",
								labelStyle: { fontSize: "13px" },
								defaultChecked: !(nav === 'pop' && !popUrl) && this.props.reportType !== 'business',
								disabled: nav === 'pop' && !popUrl || this.props.reportType === 'business',
								ref: 'cbCSV',
								onCheck: function onCheck(e, isInputChecked) {
									return _this3.cbCSVChange(e, isInputChecked);
								}
							})
						),
						_react2.default.createElement(
							_Grid.FullRow,
							{ className: 'no-padding no-margin-bottom mt-20 text-center' },
							_react2.default.createElement(
								'button',
								{
									type: 'button',
									onClick: function onClick() {
										return _this3.setState({ showDownloadDialog: false, disabledBtnDownload: false });
									},
									className: 'btn btn-default btn-aa-info mr-20'
								},
								'Cancel'
							),
							_react2.default.createElement(
								'button',
								{
									type: 'button',
									onClick: this.handleDownload.bind(this),
									disabled: this.state.disabledBtnDownload,
									className: 'btn btn-default btn-aa-default'
								},
								'Download File'
							)
						)
					)
				);
			}
		}]);
	
		return WebsiteVisits;
	}(_MaterialUI2.default);
	
	exports.default = WebsiteVisits;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatepicker = __webpack_require__(440);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(269);
	
	__webpack_require__(1427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateSelection = function (_Component) {
	  _inherits(DateSelection, _Component);
	
	  function DateSelection(props) {
	    _classCallCheck(this, DateSelection);
	
	    var _this = _possibleConstructorReturn(this, (DateSelection.__proto__ || Object.getPrototypeOf(DateSelection)).call(this, props));
	
	    _this.state = {
	      startDate: (0, _moment2.default)().startOf('month'),
	      endDate: (0, _moment2.default)(),
	      activeMonth: true,
	      activeMonthEnd: true,
	      compareStartDate: (0, _moment2.default)().startOf('month'),
	      compareEndDate: (0, _moment2.default)()
	    };
	    return _this;
	  }
	
	  _createClass(DateSelection, [{
	    key: 'handleStartDateChange',
	    value: function handleStartDateChange(startDate) {
	      this.props.startDateChange(startDate.format('YYYY-MM-DD'));
	      this.handleChange({ startDate: startDate });
	    }
	  }, {
	    key: 'handleEndDateChange',
	    value: function handleEndDateChange(endDate) {
	      this.props.endDateChange(endDate.format('YYYY-MM-DD'));
	      this.handleChange({ endDate: endDate });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(_ref) {
	      var startDate = _ref.startDate,
	          endDate = _ref.endDate;
	
	      startDate = startDate || this.state.startDate;
	      endDate = endDate || this.state.endDate;
	
	      if (startDate.isAfter(endDate)) {
	        endDate = startDate;
	        this.setState({
	          compareEndDate: startDate
	        });
	      }
	
	      this.setState({
	        startDate: startDate,
	        endDate: endDate
	      });
	    }
	  }, {
	    key: 'handleClickDateWrapper',
	    value: function handleClickDateWrapper() {
	      var eles = document.querySelectorAll('.react-datepicker__day-name');
	      // change month name
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = eles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          v.innerText = v.innerText.substring(0, 1);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'handleOnMonthChange',
	    value: function handleOnMonthChange(date) {
	      this.setState({
	        compareStartDate: date
	      });
	    }
	  }, {
	    key: 'handleOnEndMonthChange',
	    value: function handleOnEndMonthChange(date) {
	      this.setState({
	        compareEndDate: date
	      });
	    }
	
	    /**
	     * this callback of apply button
	     */
	
	  }, {
	    key: 'handleApplyBeClick',
	    value: function handleApplyBeClick() {
	      this.props.handleApplyBeClick();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'date-selection' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'DATE SELECTION'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Select the time period you are interested in viewing.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content clearfix' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'From:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'start-date clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-wrapper' },
	              _react2.default.createElement('i', { className: 'far fa-calendar-alt' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'date-wrapper', onClick: function onClick() {
	                  return _this2.handleClickDateWrapper();
	                } },
	              _react2.default.createElement(_reactDatepicker2.default, {
	                dateFormat: 'MM-DD-YYYY',
	                calendarClassName: 'calendar-left',
	                className: 'date-con',
	                selected: this.state.startDate,
	                startDate: this.state.startDate,
	                filterDate: function filterDate(date) {
	                  return date.format('M') === _this2.state.compareStartDate.format('M');
	                },
	                onMonthChange: function onMonthChange(date) {
	                  return _this2.handleOnMonthChange(date);
	                },
	                onChange: function onChange(date) {
	                  return _this2.handleStartDateChange(date);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement('strong', { className: 'line' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'To:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'end-date' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-wrapper' },
	              _react2.default.createElement('i', { className: 'far fa-calendar-alt' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'date-wrapper', onClick: function onClick() {
	                  return _this2.handleClickDateWrapper();
	                } },
	              _react2.default.createElement(_reactDatepicker2.default, {
	                dateFormat: 'MM-DD-YYYY',
	                calendarClassName: 'calendar-left',
	                className: 'date-con',
	                endDate: this.state.endDate,
	                selected: this.state.endDate,
	                filterDate: function filterDate(date) {
	                  return date.format('M') === _this2.state.compareEndDate.format('M');
	                },
	                onMonthChange: function onMonthChange(date) {
	                  return _this2.handleOnEndMonthChange(date);
	                },
	                onChange: function onChange(date) {
	                  return _this2.handleEndDateChange(date);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'apply', onClick: function onClick() {
	                return _this2.handleApplyBeClick();
	              } },
	            'APPLY'
	          )
	        )
	      );
	    }
	  }]);
	
	  return DateSelection;
	}(_react.Component);
	
	exports.default = DateSelection;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _Nav = __webpack_require__(1135);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Index = __webpack_require__(1133);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsightsInfo = function (_Component) {
	  _inherits(InsightsInfo, _Component);
	
	  function InsightsInfo() {
	    _classCallCheck(this, InsightsInfo);
	
	    return _possibleConstructorReturn(this, (InsightsInfo.__proto__ || Object.getPrototypeOf(InsightsInfo)).apply(this, arguments));
	  }
	
	  _createClass(InsightsInfo, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'insights-info' },
	          _react2.default.createElement(_Nav2.default, {
	            params: this.props.match.params,
	            rootStyle: {
	              height: '52px'
	            },
	            liStyle: {
	              height: '52px',
	              lineHeight: '52px'
	            }
	          }),
	          this.props.match.params.type === 'insights' && _react2.default.createElement(_Index2.default, this.props)
	        )
	      );
	    }
	  }]);
	
	  return InsightsInfo;
	}(_react.Component);
	
	exports.default = InsightsInfo;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Title = __webpack_require__(212);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Date = __webpack_require__(1131);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	var _SearchBar = __webpack_require__(259);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _insightsTable = __webpack_require__(1134);
	
	var _insightsTable2 = _interopRequireDefault(_insightsTable);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Page = __webpack_require__(103);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1428);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// css
	
	
	var Insights = function (_Component) {
	  _inherits(Insights, _Component);
	
	  function Insights(props) {
	    _classCallCheck(this, Insights);
	
	    var _this = _possibleConstructorReturn(this, (Insights.__proto__ || Object.getPrototypeOf(Insights)).call(this, props));
	
	    _this.throttle = true;
	    _this.state = {
	      requestParams: {
	        clientId: '',
	        pageNumber: 1,
	        pageSize: 15,
	        sortColumn: 'clientName',
	        order: 'asc',
	        dateFrom: (0, _moment2.default)().startOf('month').format('YYYY-MM-DD'),
	        dateTo: (0, _moment2.default)().format('YYYY-MM-DD')
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Insights, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getSearch(this.state.requestParams);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.search_results.insightTags && this.props.search_results !== nextProps.search_results) {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            pageSize: nextProps.search_results.insightTags.total
	          })
	        }, function () {
	          _this2.props.getAllSearch(_this2.state.requestParams);
	        });
	      }
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(selectedItem) {
	      var _this3 = this;
	
	      this.props.resetData();
	      var obj = {};
	      if (selectedItem === '') {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: '',
	            pageNumber: 1,
	            pageSize: 15
	          })
	        };
	        this.goToPage(1);
	      } else {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: selectedItem,
	            pageNumber: 1,
	            pageSize: 15
	          })
	        };
	      }
	      this.setState(obj, function () {
	        _this3.props.getSearch(_this3.state.requestParams);
	      });
	    }
	  }, {
	    key: 'handleStartDateChange',
	    value: function handleStartDateChange(date) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          dateFrom: date
	        })
	      });
	    }
	  }, {
	    key: 'handleEndDateChange',
	    value: function handleEndDateChange(date) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          dateTo: date
	        })
	      });
	    }
	  }, {
	    key: 'nextBeClick',
	    value: function nextBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: 'previousBeClick',
	    value: function previousBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: 'goToPage',
	    value: function goToPage(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: 'pageAbleFunc',
	    value: function pageAbleFunc(val) {
	      var _this4 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageNumber: val,
	          pageSize: 15
	        })
	      }, function () {
	        _this4.props.getSearch(_this4.state.requestParams);
	      });
	    }
	  }, {
	    key: 'handleSortByClientName',
	    value: function handleSortByClientName() {
	      var _this5 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageSize: 15,
	          order: this.state.requestParams.order === 'desc' ? 'asc' : 'desc'
	        })
	      }, function () {
	        _this5.pros.getSearch(_this5.state.requestParams);
	      });
	    }
	  }, {
	    key: 'handleApplyBeClick',
	    value: function handleApplyBeClick() {
	      var _this6 = this;
	
	      var obj = {
	        requestParams: Object.assign({}, this.state.requestParams, {
	          clientId: '',
	          pageNumber: 1,
	          pageSize: 15
	        })
	      };
	      this.setState(obj, function () {
	        _this6.props.getSearch(_this6.state.requestParams);
	      });
	    }
	  }, {
	    key: 'handleDownload',
	    value: function handleDownload() {
	      var title = 'AudienceAnywhere insights Records Delivered,,,,,\r\n';
	      var _subTitle = 'Tine Period,,,,,\r\n';
	      var from = 'From,' + (0, _moment2.default)(this.state.requestParams.dateFrom).format('M/D/YY') + ',,,,\r\n';
	      var to = 'To,' + (0, _moment2.default)(this.state.requestParams.dateTo).format('M/D/YY') + ',,,,\r\n';
	      var data = '';
	      var fn = function fn(item) {
	        data += '"' + item.clientName + '",' + (item.bizUnitName || '') + ',' + (item.domain || '') + ',' + item.consumerRecords + ',' + item.businessRecords + '\r\n';
	      };
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.props.all_search_results.insightTags.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          if (v.children) {
	            data += '"' + v.clientName + '",,,,,\r\n';
	            v.children.forEach(fn);
	          } else {
	            data += '"' + v.clientName + '",' + (v.bizUnitName || '') + ',' + (v.domain || '') + ',' + v.consumerRecords + ',' + v.businessRecords + '\r\n';
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var csv_string = title + _subTitle + from + to + ',,,,,\r\n' + ',,,,,\r\n' + 'Client Name,Business Unit Name,Web Property,Consumer Records Delivered,Business Records Delivered,\r\n' + data;
	      (0, _utility.downLoadCSVFunc)(csv_string.trim(), 'AA_Insights_Records_Delivered_' + (0, _moment2.default)().format("YYYYMMDD"));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'insights-info-s subscription-info' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title-wrapper' },
	          _react2.default.createElement(_Title2.default, {
	            crumb: 'Data - Insights',
	            handleDownload: function handleDownload() {
	              return _this7.handleDownload();
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'date-picker' },
	          _react2.default.createElement(_Date2.default, {
	            startDateChange: function startDateChange(date) {
	              return _this7.handleStartDateChange(date);
	            },
	            endDateChange: function endDateChange(date) {
	              return _this7.handleEndDateChange(date);
	            },
	            handleApplyBeClick: function handleApplyBeClick() {
	              return _this7.handleApplyBeClick();
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'common-wrapper mt-20' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'border-title' },
	            'INSIGHTS RECORDS DELIVERED BY CLIENT/BUSINESS UNIT'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'search-bar' },
	            _react2.default.createElement(_SearchBar2.default, {
	              clients: this.props.clients,
	              handleSearch: function handleSearch(selectedItem) {
	                return _this7.handleSearch(selectedItem);
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'tag-info-table-wrapper' },
	              _react2.default.createElement(_insightsTable2.default, {
	                handleSortByClientName: function handleSortByClientName() {
	                  return _this7.handleSortByClientName();
	                },
	                tableHeaderArr: [{ label: 'Client Name', value: 0 }, { label: 'Business Unit Name', value: 1 }, { label: 'Web Property', value: 2 }, { label: 'Consumer Records Delivered', value: 3 }, { label: 'Business Records Delivered', value: 4 }],
	                bodyDataArr: this.props.search_results.insightTags ? this.props.search_results.insightTags.data : [],
	                tableHeaderWidthStyle: ['22%', '20%', '14%', '22%']
	              }),
	              _react2.default.createElement(_Page2.default, {
	                nextBeClick: function nextBeClick(page) {
	                  return _this7.nextBeClick(page);
	                },
	                pageNumber: this.props.search_results.insightTags && this.props.search_results.insightTags.pageNumber,
	                pageCount: this.props.search_results.insightTags && this.props.search_results.insightTags.pageCount,
	                pageSize: this.props.search_results.insightTags && this.props.search_results.insightTags.pageSize,
	                nextGroupBeClick: function nextGroupBeClick(page) {
	                  return _this7.nextGroupBeClick(page);
	                },
	                previousGroupBeClick: function previousGroupBeClick(page) {
	                  return _this7.previousGroupBeClick(page);
	                },
	                previousBeClick: function previousBeClick(page) {
	                  return _this7.previousBeClick(page);
	                },
	                pageBeClick: function pageBeClick(page) {
	                  return _this7.pageBeClick(page);
	                },
	                total: this.props.search_results.insightTags && this.props.search_results.insightTags.total,
	                hasNext: this.props.search_results.insightTags && this.props.search_results.insightTags.hasNext,
	                hasPrevious: this.props.search_results.insightTags && this.props.search_results.insightTags.hasPrevious,
	                pagePlus: true,
	                selectRows: function selectRows(page, row) {
	                  return _this7.selectRows(page, row);
	                },
	                goToPage: function goToPage(page) {
	                  return _this7.goToPage(page);
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Insights;
	}(_react.Component);
	
	exports.default = Insights;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(222);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _playArrow = __webpack_require__(156);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author chargoyao
	 * @property tableHeaderArr {array} table header array.
	 * [{label: 'ClientName', value: 'ClientName'}]
	 * @property renderCols {obj} render data column
	 * {
	 *  addedCol: 'xxx',
	 *  cols: ['xxx', 'xxxx']
	 * }
	 *
	 * @property bodyDataArr {array} remote data
	 * [{
	 *  clientName: 'Deluth Trading',
	 *  bizUnitName: 'Monsanto',
	 *  deploymentType: 'WebProperty',
	 *  domain: 'www.abc.com',
	 *  uuid: 291923-11,
	 *  activeStatus: Inactive
	 *  }, {
	 *    clientName: 'Deluth Trading',
	 *    bizUnitName: 'Monsanto',
	 *    deploymentType: 'WebProperty',
	 *    domain: 'www.abc.com',
	 *    uuid: 291923-11,
	 *    activeStatus: Inactive
	 *    children: [
	 *    ]
	 *  }]
	 *  @property tableHeaderWidthStyle {array} table Width style
	 *  ['22%', '12%']
	 */
	var arrowStyles = {
	  position: 'absolute',
	  right: 0,
	  top: '0px'
	};
	
	var UsersTable = function (_Component) {
	  _inherits(UsersTable, _Component);
	
	  function UsersTable(props) {
	    _classCallCheck(this, UsersTable);
	
	    var _this = _possibleConstructorReturn(this, (UsersTable.__proto__ || Object.getPrototypeOf(UsersTable)).call(this, props));
	
	    _this.state = {
	      activeIndex: 0,
	      arrowActive: 'down',
	      expandAll: false
	    };
	    return _this;
	  }
	
	  _createClass(UsersTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.expandAll === true) {
	        this.setState({ expandAll: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.expandAll !== this.props.expandAll) {
	        this.setState({ expandAll: nextProps.expandAll === true });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(label, index) {
	      this.setState({
	        activeIndex: index
	      });
	      if (+index === this.state.activeIndex) {
	        if (this.state.arrowActive === 'down') {
	          this.setState({
	            arrowActive: 'up'
	          });
	        } else {
	          this.setState({
	            arrowActive: 'down'
	          });
	        }
	      } else {
	        this.setState({
	          arrowActive: 'down'
	        });
	      }
	      if (index === 0) {
	        this.props.handleSortByClientName();
	      }
	    }
	  }, {
	    key: 'spreadTr',
	    value: function spreadTr(index) {
	      if (this.state['spread' + index]) {
	        var _setState;
	
	        this.setState((_setState = {}, _defineProperty(_setState, 'spread' + index, false), _defineProperty(_setState, 'expandAll', false), _setState));
	      } else {
	        var _setState2;
	
	        this.setState((_setState2 = {}, _defineProperty(_setState2, 'spread' + index, true), _defineProperty(_setState2, 'expandAll', false), _setState2));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'spread-table' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              this.props.tableHeaderArr.map(function (item, index) {
	                var widthStyle = '';
	                switch (index) {
	                  case 0:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[0];
	                    break;
	                  case 1:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[1];
	                    break;
	                  case 2:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[2];
	                    break;
	                  case 3:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[3];
	                    break;
	                  case 4:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[4];
	                    break;
	                  case 5:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[5];
	                    break;
	                  case 6:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[6];
	                    break;
	                  default:
	                    widthStyle = '';
	                    break;
	                }
	                return _react2.default.createElement(
	                  'th',
	                  { key: item.value,
	                    className: _this2.state.activeIndex === index && index === 0 ? 'active' : '',
	                    onClick: function onClick() {
	                      if (item.label === 'Client Name') _this2.handleClick(item.label, index);
	                    },
	                    style: { width: widthStyle, whiteSpace: 'pre-wrap' }
	                  },
	                  item.label,
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'down' && index === 0 && _react2.default.createElement(_arrowDropDown2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  }),
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'up' && index === 0 && _react2.default.createElement(_arrowDropUp2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  })
	                );
	              })
	            ),
	            this.props.bodyDataArr.map(function (item, index) {
	              if (item.children.length === 0) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: index },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.clientName
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.bizUnitName
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.domain
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.consumerRecords
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    item.businessRecords
	                  )
	                );
	              } else {
	                var obj = [];
	                if (item.children.length >= 1) {
	                  obj.push(_react2.default.createElement(
	                    'tr',
	                    { key: index, onClick: function onClick() {
	                        return _this2.spreadTr(index);
	                      } },
	                    _react2.default.createElement(
	                      'td',
	                      { style: { paddingLeft: '20px', cursor: 'pointer' } },
	                      _this2.state['spread' + index] || _this2.state.expandAll ? _react2.default.createElement(_arrowDropDown2.default, {
	                        style: { position: 'absolute', left: '-7px', top: '2px' }
	                      }) : _react2.default.createElement(_playArrow2.default, {
	                        style: { position: 'absolute', left: '-5px', top: '6px', width: '16px', height: '16px' }
	                      }),
	                      item.clientName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.bizUnitName
	                    ),
	                    _react2.default.createElement('td', { style: { cursor: 'pointer' } }),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.consumerRecords
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.businessRecords
	                    )
	                  ));
	                }
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                  for (var _iterator = item.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var v = _step.value;
	
	                    obj.push(_react2.default.createElement(
	                      'tr',
	                      { style: { display: _this2.state['spread' + index] || _this2.state.expandAll ? 'table-row' : 'none' } },
	                      _react2.default.createElement(
	                        'td',
	                        { style: { paddingLeft: '49px' } },
	                        v.clientName
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.bizUnitName
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.domain
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.consumerRecords
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.businessRecords
	                      )
	                    ));
	                  }
	                } catch (err) {
	                  _didIteratorError = true;
	                  _iteratorError = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                      _iterator.return();
	                    }
	                  } finally {
	                    if (_didIteratorError) {
	                      throw _iteratorError;
	                    }
	                  }
	                }
	
	                return obj;
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return UsersTable;
	}(_react.Component);
	
	UsersTable.defaultProps = {
	  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
	  bodyDataArr: [],
	  renderCols: {
	    addCol: '',
	    cols: []
	  }
	};
	
	exports.default = UsersTable;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	__webpack_require__(1429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @property rootStyle {object} root element styles
	 * @property liStyle {object} li element styles
	 */
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    _classCallCheck(this, Nav);
	
	    return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
	  }
	
	  _createClass(Nav, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'client-business-info-nav clearfix', style: this.props.rootStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              'li',
	              { className: this.props.params.type === 'insights' ? 'active' : '', style: this.props.liStyle },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/dashboard/data/insights' },
	                'INSIGHTS'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Nav;
	}(_react.Component);
	
	exports.default = Nav;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(108);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _done = __webpack_require__(307);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _reactDropzone = __webpack_require__(242);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(18);
	
	var _CustomSelect = __webpack_require__(260);
	
	var _CustomSelect2 = _interopRequireDefault(_CustomSelect);
	
	var _groupBy = __webpack_require__(150);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _reactTextMask = __webpack_require__(247);
	
	var _reactTextMask2 = _interopRequireDefault(_reactTextMask);
	
	var _utility = __webpack_require__(14);
	
	var _Spinner = __webpack_require__(3140);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	__webpack_require__(1430);
	
	var _worker = __webpack_require__(528);
	
	var _worker2 = _interopRequireDefault(_worker);
	
	var _image_not_available = __webpack_require__(1029);
	
	var _image_not_available2 = _interopRequireDefault(_image_not_available);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import SelectField from 'material-ui/SelectField';
	// import MenuItem from 'material-ui/MenuItem';
	
	// button color
	
	
	// import web workers;
	
	
	// default img
	
	
	// icon
	// import ArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
	
	
	var Profile = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile(props) {
	    _classCallCheck(this, Profile);
	
	    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));
	
	    _this.flag = true;
	    _this.flagBase = true;
	    _this.flagPhoto = true;
	    _this.myProfile_worker = new Worker(_worker2.default);
	    _this.throttle_getRole = true;
	    _this.state = {
	      ifHiddenTopEdit: true, // if show top form edit
	      ifHiddenBottomEdit: true,
	      ifHiddenLogoEdit: true,
	      ifHiddenPhototEdit: true,
	      ifHiddenChangePw: true,
	      requiredFirstNameText: "", // requied field firset name tip text
	      requiredLastNameText: "", // required field last name tip text
	      requiredEmailText: "", // required field email tip text
	      requiredIndustryIdText: "",
	      requiredTimezoneText: "",
	      ifLogoUploadButtonEnable: false, // if upload button enable for logo
	      ifPhotoUploadButtonEnable: false, // if uploda button enable for photo
	      ifLogoSaveBtnEnable: false, // if logo save button can be request api
	      ifPhotoSaveBtnEnable: false, // if photo save button can be request api
	      logoFileName: "No file chosen",
	      photoFileName: "No file chosen",
	      logoUploadSuccess: false,
	      photoUploadSucess: false,
	      roleValue: "",
	      stateValue: "",
	      timezoneValue: "",
	      departmentValue: "",
	      industryValue: "",
	      clientId: "", // client id for upload
	      companyLogoErrorText: "",
	      profilePhotoErrorText: "",
	      companyLogoUuid: "", // logo uuid
	      userAvatarUuid: "",
	      roleInfo: "", // store role object information
	      industryGroupObj: [], // for industry type selection
	      showCityValueTypeTip: false,
	      requestParams: {
	        title: "",
	        companyName: "",
	        firstName: "",
	        lastName: "",
	        email: "",
	        username: "",
	        address1: "",
	        address2: "",
	        city: "",
	        zipCode: "",
	        officePhone: "",
	        mobilePhone: "",
	        timezone: ""
	      },
	      passwordRequestParams: {
	        password: Math.random().toString(36).substr(2),
	        confirmPassword: ""
	      },
	      imgDataBase64: "", // for company logo
	      imgPhotoDataBase64: "", // for photo,
	      // password_error_tip_show: false,
	      newLogoBase64: "",
	      newPhotoBase64: "",
	      showNewPwError: false,
	      showConfirmPwError: false,
	      showBaseInfoError: false
	    };
	    return _this;
	  }
	
	  _createClass(Profile, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.getDepartment();
	      this.props.getStates();
	      this.props.getTimezone();
	      this.props.getIndustryOptions();
	      localStorage.setItem("newLogoBase64", "");
	      localStorage.setItem("newPhotoBase64", "");
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      // default img
	      if (/^SYSTEM ADMINISTRATOR/.test(nextProps.rolesName) && this.throttle_getRole) {
	        this.props.getRoles();
	        this.throttle_getRole = false;
	      }
	      if (nextProps.company_logo !== "" && nextProps.loginUserDetail.client.logo !== "logo.png") {
	        // change blob to base64 for img element. and implement one time.
	
	        if (this.flagBase) {
	          this.myProfile_worker.postMessage(nextProps.company_logo);
	          this.myProfile_worker.onmessage = function (e) {
	            _this2.setState({
	              imgDataBase64: e.data
	            });
	          };
	        }
	      } else {
	        this.setState({
	          imgDataBase64: _image_not_available2.default
	        });
	      }
	
	      // change blob to base64 for photo
	      if (typeof nextProps.avatar !== "undefined" && nextProps.loginUserDetail.avatar !== "avatar.png") {
	        if (this.flagPhoto) {
	          var reader = new FileReader();
	          reader.readAsDataURL(nextProps.avatar);
	          reader.onload = function () {
	            _this2.setState({
	              imgPhotoDataBase64: reader.result
	            });
	          };
	        }
	      } else {
	        this.setState({
	          imgPhotoDataBase64: _image_not_available2.default
	        });
	      }
	
	      if (nextProps.industryOptions.length > 0) {
	        this.setState({
	          industryValue: ""
	        });
	        var industryGroup = (0, _groupBy2.default)(nextProps.industryOptions, "group");
	        var obj = [];
	        // obj.push({label: 'All Industries', options: [
	        //   {
	        //     label: 'All Industries',
	        //     value: ''
	        //   }
	        // ]})
	        for (var x in industryGroup) {
	          obj.push({
	            label: x,
	            options: industryGroup[x]
	          });
	        }
	        this.setState({
	          industryGroupObj: obj
	        });
	      }
	
	      if (nextProps.loginUserDetail) {
	        var _nextProps$loginUserD = nextProps.loginUserDetail,
	            firstName = _nextProps$loginUserD.firstName,
	            lastName = _nextProps$loginUserD.lastName,
	            email = _nextProps$loginUserD.email,
	            role = _nextProps$loginUserD.role,
	            username = _nextProps$loginUserD.username,
	            department = _nextProps$loginUserD.department,
	            state = _nextProps$loginUserD.state,
	            id = _nextProps$loginUserD.id,
	            address1 = _nextProps$loginUserD.address1,
	            address2 = _nextProps$loginUserD.address2,
	            city = _nextProps$loginUserD.city,
	            zipCode = _nextProps$loginUserD.zipCode,
	            officePhone = _nextProps$loginUserD.officePhone,
	            mobilePhone = _nextProps$loginUserD.mobilePhone,
	            timezone = _nextProps$loginUserD.timezone,
	            title = _nextProps$loginUserD.title,
	            companyName = _nextProps$loginUserD.companyName,
	            client = _nextProps$loginUserD.client;
	
	        this.setState({
	          clientId: id
	        });
	        // implement one time.
	        if (this.flag) {
	          this.props.getCompanyLogo(nextProps.loginUserDetail.client.id); // get logo img
	          // this.props.getUserAvatar(nextProps.loginUserDetail.avatar); // get photo img
	          this.flag = false;
	        }
	
	        this.setState({
	          roleValue: role.id,
	          departmentValue: department.id,
	          industryValue: client.industry.id,
	          stateValue: state,
	          timezoneValue: timezone,
	          roleInfo: role,
	          requestParams: Object.assign({}, this.state.requestParams, {
	            firstName: firstName,
	            lastName: lastName,
	            email: email,
	            title: title,
	            username: username || "",
	            // state: state || nextProps.allstates[0].value,
	            // departmentId: department.id || nextProps.department[0].value,
	            address1: address1 || "",
	            address2: address2 || "",
	            city: city || "",
	            zipCode: zipCode || "",
	            officePhone: officePhone || "",
	            mobilePhone: mobilePhone || "",
	            timezone: timezone || nextProps.timezone[0].value,
	            companyName: companyName || "",
	            industryId: client.industry.id || ""
	          })
	        });
	      }
	    }
	  }, {
	    key: "getTimezoneText",
	    value: function getTimezoneText(tz) {
	      var timezone = this.props.timezone;
	
	      var idx = (0, _lodash.findIndex)(timezone, function (o) {
	        return o.value === tz;
	      });
	      var t = timezone[idx];
	      return t && t.label ? t.label : "";
	    }
	  }, {
	    key: "getDepartmentText",
	    value: function getDepartmentText(id) {
	      var department = this.props.department;
	
	      var idx = (0, _lodash.findIndex)(department, function (o) {
	        return o.value === id;
	      });
	      var d = department[idx];
	      return d && d.label ? d.label : "";
	    }
	  }, {
	    key: "getStateText",
	    value: function getStateText(abbr) {
	      var allstates = this.props.allstates;
	
	      var idx = (0, _lodash.findIndex)(allstates, function (o) {
	        return o.value === abbr;
	      });
	      var s = allstates[idx];
	
	      return s && s.label ? s.label : "";
	    }
	  }, {
	    key: "handleTopCreate",
	    value: function handleTopCreate() {
	      this.setState({
	        ifHiddenTopEdit: false
	      });
	    }
	  }, {
	    key: "handleCancelEdit",
	    value: function handleCancelEdit() {
	      var _props$loginUserDetai = this.props.loginUserDetail,
	          title = _props$loginUserDetai.title,
	          firstName = _props$loginUserDetai.firstName,
	          lastName = _props$loginUserDetai.lastName,
	          email = _props$loginUserDetai.email,
	          role = _props$loginUserDetai.role,
	          username = _props$loginUserDetai.username,
	          department = _props$loginUserDetai.department,
	          state = _props$loginUserDetai.state,
	          address1 = _props$loginUserDetai.address1,
	          address2 = _props$loginUserDetai.address2,
	          city = _props$loginUserDetai.city,
	          zipCode = _props$loginUserDetai.zipCode,
	          officePhone = _props$loginUserDetai.officePhone,
	          mobilePhone = _props$loginUserDetai.mobilePhone,
	          timezone = _props$loginUserDetai.timezone,
	          companyName = _props$loginUserDetai.companyName,
	          client = _props$loginUserDetai.client;
	
	      this.setState({
	        ifHiddenTopEdit: true,
	        roleValue: role.id,
	        departmentValue: department.id,
	        stateValue: state,
	        timezoneValue: timezone,
	        industryValue: client.industry.id,
	        roleInfo: role,
	        showBaseInfoError: false,
	        requiredFirstNameText: "", // requied field firset name tip text
	        requiredLastNameText: "", // required field last name tip text
	        requiredEmailText: "", // required field email tip text
	        requiredIndustryIdText: "",
	        requiredTimezoneText: "",
	        requestParams: Object.assign({}, this.state.requestParams, {
	          firstName: firstName,
	          lastName: lastName,
	          email: email,
	          username: username || "",
	          state: state || this.props.allstates[0].value,
	          departmentId: department.id || this.props.department[0].value,
	          address1: address1 || "",
	          address2: address2 || "",
	          city: city || "",
	          zipCode: zipCode || "",
	          officePhone: officePhone || "",
	          mobilePhone: mobilePhone || "",
	          companyName: companyName || "",
	          timezone: timezone || this.props.timezone[0].value,
	          title: title || "",
	          industryId: client.industry.id || ""
	        })
	      });
	    }
	  }, {
	    key: "handleItemsChange",
	    value: function handleItemsChange(e, index, value) {
	      this.setState({
	        roleValue: value
	      });
	    }
	  }, {
	    key: "handleDepartmentChange",
	    value: function handleDepartmentChange(value) {
	      this.setState({
	        departmentValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          departmentId: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleStateChange",
	    value: function handleStateChange(value) {
	      this.setState({
	        stateValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          state: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleTimeZoneChange",
	    value: function handleTimeZoneChange(value) {
	      this.setState({
	        timezoneValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          timezone: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleTitle",
	    value: function handleTitle(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          title: value
	        })
	      });
	    }
	  }, {
	    key: "handleFirstName",
	    value: function handleFirstName(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          firstName: value
	        })
	      });
	    }
	  }, {
	    key: "handleLastName",
	    value: function handleLastName(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          lastName: value
	        })
	      });
	    }
	  }, {
	    key: "handleEmail",
	    value: function handleEmail(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          email: value
	        })
	      });
	    }
	  }, {
	    key: "handleUsername",
	    value: function handleUsername(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          username: value
	        })
	      });
	    }
	  }, {
	    key: "handleCompanyAdd1",
	    value: function handleCompanyAdd1(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address1: value
	        })
	      });
	    }
	  }, {
	    key: "handleCompanyAdd2",
	    value: function handleCompanyAdd2(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          address2: value
	        })
	      });
	    }
	  }, {
	    key: "handleCity",
	    value: function handleCity(e, value) {
	      if (/^\d/g.test(value)) {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            city: ""
	          }),
	          showCityValueTypeTip: true
	        });
	      } else {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            city: value
	          }),
	          showCityValueTypeTip: false
	        });
	      }
	    }
	  }, {
	    key: "handleZipCode",
	    value: function handleZipCode(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          zipCode: value
	        })
	      });
	    }
	  }, {
	    key: "handleOfficePhoneNumber",
	    value: function handleOfficePhoneNumber(e) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          officePhone: e.target.value
	        })
	      });
	    }
	  }, {
	    key: "handleCompanyName",
	    value: function handleCompanyName(e, value) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          companyName: value
	        })
	      });
	    }
	  }, {
	    key: "handleMobilePhoneNumber",
	    value: function handleMobilePhoneNumber(e) {
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          mobilePhone: e.target.value
	        })
	      });
	    }
	  }, {
	    key: "handleDrop",
	    value: function handleDrop(files, accept, reject) {
	      this.setState({
	        logoFileName: files[0],
	        ifLogoUploadButtonEnable: true,
	        companyLogoErrorText: ""
	      });
	    }
	  }, {
	    key: "handleDropProfile",
	    value: function handleDropProfile(files, accept, reject) {
	      this.setState({
	        photoFileName: files[0],
	        ifPhotoUploadButtonEnable: true,
	        profilePhotoErrorText: ""
	      });
	    }
	  }, {
	    key: "onDropRejected",
	    value: function onDropRejected() {
	      this.setState({
	        companyLogoErrorText: "Only jpg, png, and gif file with maximum size of 1MB is allowed"
	      });
	    }
	  }, {
	    key: "onDropProfileRejected",
	    value: function onDropProfileRejected() {
	      this.setState({
	        profilePhotoErrorText: "Only jpg, png, and gif file with maximum size of 1MB is allowed"
	      });
	    }
	  }, {
	    key: "handleUpdateProfile",
	    value: function handleUpdateProfile() {
	      if (this.state.requestParams.firstName.trim().length === 0) {
	        this.setState({
	          requiredFirstNameText: "Please enter your first name"
	        });
	      } else {
	        this.setState({
	          requiredFirstNameText: ""
	        });
	      }
	      if (this.state.requestParams.lastName.trim().length === 0) {
	        this.setState({
	          requiredLastNameText: "Please enter your last name"
	        });
	      } else {
	        this.setState({
	          requiredLastNameText: ""
	        });
	      }
	      if (this.state.requestParams.email.trim().length === 0) {
	        this.setState({
	          requiredEmailText: "Please enter your email"
	        });
	      } else {
	        this.setState({
	          requiredEmailText: ""
	        });
	      }
	      if (typeof this.state.requestParams.industryId === "string") {
	        this.setState({
	          requiredIndustryIdText: "Please select your industry type"
	        });
	      } else {
	        this.setState({
	          requiredIndustryIdText: ""
	        });
	      }
	      if (typeof this.state.requestParams.timezone === "string") {
	        this.setState({
	          requiredTimezoneText: "Please select your timezone"
	        });
	      } else {
	        this.setState({
	          requiredTimezoneText: ""
	        });
	      }
	      if (this.state.requestParams.firstName.trim().length > 0 && this.state.requestParams.lastName.trim().length > 0 && this.state.requestParams.email.trim().length > 0 && typeof this.state.requestParams.industryId === "number") {
	        this.props.updateProfile(this.state.requestParams);
	        this.setState({
	          showBaseInfoError: true
	        });
	      }
	    }
	  }, {
	    key: "handleCloseDialog",
	    value: function handleCloseDialog() {
	      // reload redux
	      this.props.setStatus(false);
	      this.props.getCurrentUserProfile(); // request my profile again
	      this.flag = true;
	      this.flagBase = true;
	      this.flagPhoto = true;
	      this.setState({
	        ifHiddenTopEdit: true, // if show top form edit
	        ifHiddenBottomEdit: true,
	        ifHiddenLogoEdit: true,
	        ifHiddenPhototEdit: true,
	        ifHiddenChangePw: true,
	        ifLogoSaveBtnEnable: false,
	        ifPhotoSaveBtnEnable: false,
	        logoUploadSuccess: false,
	        photoUploadSucess: false,
	        requiredFirstNameText: "",
	        requiredLastNameText: "",
	        requiredEmailText: "",
	        requiredIndustryIdText: "",
	        requiredTimezoneText: "",
	        ifLogoUploadButtonEnable: false,
	        ifPhotoUploadButtonEnable: false,
	        logoFileName: "No file chosen",
	        photoFileName: "No file chosen",
	        roleValue: "",
	        stateValue: "",
	        timezoneValue: "",
	        industryValue: "",
	        departmentValue: "",
	        clientId: "", // client id for upload
	        companyLogoErrorText: "",
	        profilePhotoErrorText: "",
	        companyLogoUuid: "", // logo uuid
	        userAvatarUuid: "", // avatar uuid
	        industryGroupObj: [],
	        showCityValueTypeTip: false,
	        requestParams: {
	          title: "",
	          firstName: "",
	          lastName: "",
	          email: "",
	          username: "",
	          address1: "",
	          address2: "",
	          companyName: "",
	          city: "",
	          zipCode: "",
	          officePhone: "",
	          mobilePhone: "",
	          timezone: ""
	        },
	        passwordRequestParams: {
	          password: Math.random().toString(36).substr(2),
	          confirmPassword: ""
	        },
	        imgDataBase64: "", // for company logo
	        imgPhotoDataBase64: "", // for photo
	        newLogoBase64: "",
	        newPhotoBase64: "",
	        showBaseInfoError: false
	      });
	    }
	  }, {
	    key: "handleLogoEdit",
	    value: function handleLogoEdit() {
	      this.setState({
	        ifHiddenLogoEdit: false
	      });
	    }
	  }, {
	    key: "handlePhotoEdit",
	    value: function handlePhotoEdit() {
	      this.setState({
	        ifHiddenPhototEdit: false
	      });
	    }
	  }, {
	    key: "handlePhotoLogo",
	    value: function handlePhotoLogo() {
	      var _this3 = this;
	
	      if (this.state.ifPhotoUploadButtonEnable) {
	        var formData = new FormData();
	        formData.append("avatar", this.state.photoFileName);
	        // call api
	        fetch("/api/users/my-profile/photo/upload", {
	          method: "POST",
	          body: formData,
	          headers: new Headers({
	            Authorization: this.props.token
	          })
	        }).then(function (res) {
	          if (res.status === 200) {
	            return res.json();
	          } else {
	            res.json().then(function (json) {
	              _this3.setState({
	                profilePhotoErrorText: json.message
	              });
	            });
	          }
	        }, function () {}).then(function (json) {
	          if (typeof json !== "undefined") {
	            localStorage.setItem("newPhotoBase64", _this3.state.photoFileName.preview);
	            _this3.setState({
	              profilePhotoErrorText: "",
	              ifPhotoSaveBtnEnable: true,
	              photoUploadSucess: true,
	              userAvatarUuid: json.uuid,
	              newPhotoBase64: _this3.state.photoFileName.preview
	            });
	          }
	        }).catch(function (err) {
	          alert(err);
	        });
	        // this.setState({
	        //   imgProfileDataBase64: this.state.photoFileName.preview
	        // });
	      }
	    }
	  }, {
	    key: "handleUploadLogo",
	    value: function handleUploadLogo() {
	      var _this4 = this;
	
	      if (this.state.ifLogoUploadButtonEnable) {
	        var formData = new FormData();
	        formData.append("logo", this.state.logoFileName);
	        // call api
	        fetch("/api/clients/" + this.props.loginUserDetail.client.id + "/logo/upload", {
	          method: "POST",
	          body: formData,
	          headers: new Headers({
	            Authorization: this.props.token
	          })
	        }).then(function (res) {
	          if (res.status === 200) {
	            return res.json();
	          } else {
	            res.json().then(function (json) {
	              _this4.setState({
	                companyLogoErrorText: json.message
	              });
	            });
	          }
	        }, function () {}).then(function (json) {
	          if (typeof json !== "undefined") {
	            localStorage.setItem("newLogoBase64", _this4.state.logoFileName.preview);
	            _this4.setState({
	              companyLogoErrorText: "",
	              ifLogoSaveBtnEnable: true,
	              logoUploadSuccess: true,
	              companyLogoUuid: json.uuid,
	              newLogoBase64: _this4.state.logoFileName.preview
	            });
	          }
	        }).catch(function (err) {
	          alert(err);
	        });
	      }
	    }
	  }, {
	    key: "handleCancelLogoEdit",
	    value: function handleCancelLogoEdit() {
	      this.setState({
	        ifHiddenLogoEdit: true,
	        newLogoBase64: "",
	        logoFileName: "No file chosen"
	      });
	      localStorage.setItem("newLogoBase64", "");
	    }
	  }, {
	    key: "handleIndustryChange",
	    value: function handleIndustryChange(value) {
	      this.setState({
	        industryValue: value.value,
	        requestParams: Object.assign({}, this.state.requestParams, {
	          industryId: value.value
	        })
	      });
	    }
	  }, {
	    key: "handleUpdatelogo",
	    value: function handleUpdatelogo() {
	      if (this.state.ifLogoSaveBtnEnable) {
	        this.props.updateLogo(this.props.loginUserDetail.client.id, this.state.companyLogoUuid);
	      }
	    }
	  }, {
	    key: "handleUpdatePhoto",
	    value: function handleUpdatePhoto() {
	      if (this.state.ifPhotoSaveBtnEnable) {
	        this.props.updatePhoto(this.state.userAvatarUuid);
	      }
	    }
	  }, {
	    key: "handleCancelPhotoEdit",
	    value: function handleCancelPhotoEdit() {
	      this.setState({
	        ifHiddenPhototEdit: true,
	        newPhotoBase64: "",
	        photoFileName: "No file chosen"
	      });
	      localStorage.setItem("newPhotoBase64", "");
	    }
	  }, {
	    key: "handlChangePwEdit",
	    value: function handlChangePwEdit() {
	      this.setState({
	        ifHiddenChangePw: false,
	        passwordRequestParams: Object.assign({}, this.state.passwordRequestParams, {
	          password: ""
	        })
	      });
	    }
	  }, {
	    key: "handleNewPassword",
	    value: function handleNewPassword(e, value) {
	      this.setState({
	        passwordRequestParams: Object.assign({}, this.state.passwordRequestParams, {
	          password: value.trim()
	        }),
	        showNewPwError: false
	      });
	    }
	  }, {
	    key: "handleConfirmPassword",
	    value: function handleConfirmPassword(e, value) {
	      this.setState({
	        passwordRequestParams: Object.assign({}, this.state.passwordRequestParams, {
	          confirmPassword: value.trim()
	        }),
	        showConfirmPwError: false
	      });
	    }
	  }, {
	    key: "handleChangePwSave",
	    value: function handleChangePwSave() {
	      if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(this.state.passwordRequestParams.password) && /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(this.state.passwordRequestParams.confirmPassword)) {
	        this.setState({
	          showNewPwError: true
	        });
	      } else if (/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(this.state.passwordRequestParams.password) && !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(this.state.passwordRequestParams.confirmPassword)) {
	        this.setState({
	          showConfirmPwError: true
	        });
	      } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(this.state.passwordRequestParams.password) && !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(this.state.passwordRequestParams.confirmPassword)) {
	        this.setState({
	          showConfirmPwError: true,
	          showNewPwError: true
	        });
	      } else {
	        this.setState({
	          showConfirmPwError: true
	        });
	      }
	
	      this.props.changePassword(this.state.passwordRequestParams);
	    }
	  }, {
	    key: "handleCancelPwEdit",
	    value: function handleCancelPwEdit() {
	      this.setState({
	        ifHiddenChangePw: true,
	        showNewPwError: false,
	        showConfirmPwError: false,
	        passwordRequestParams: {
	          password: Math.random().toString(36).substr(2),
	          confirmPassword: ""
	        }
	      });
	    }
	  }, {
	    key: "_pwdInputKeyDown",
	    value: function _pwdInputKeyDown(e) {
	      if (e.keyCode === 32) e.preventDefault();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        className: "btn-aa-info",
	        label: "Close",
	        primary: true,
	        backgroundColor: (0, _utility.buttonBlueColor)(),
	        labelStyle: { color: "white" },
	        hoverColor: (0, _utility.buttonBlueColor)(),
	        onClick: function onClick() {
	          return _this5.handleCloseDialog();
	        }
	      })];
	      var muiTheme = (0, _getMuiTheme2.default)({
	        menuItem: {
	          hoverColor: (0, _utility.buttonBlueColor)()
	        }
	      });
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: muiTheme },
	        _react2.default.createElement(
	          "div",
	          { className: "profile" },
	          _react2.default.createElement(
	            "div",
	            { className: "profile-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "profile-form-top" },
	              _react2.default.createElement(
	                "h1",
	                {
	                  style: {
	                    borderBottom: this.state.ifHiddenTopEdit ? "" : "none"
	                  }
	                },
	                "MY PROFILE"
	              ),
	              /^(administrator|team member|Business Unit Team Member)/gi.test(this.props.roleName) && _react2.default.createElement(
	                "div",
	                {
	                  className: "profile-fn-wrapper clearfix",
	                  style: {
	                    lineHeight: "32px",
	                    borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : ""
	                  }
	                },
	                _react2.default.createElement(
	                  "span",
	                  {
	                    style: {
	                      float: "left",
	                      fontSize: "13px",
	                      fontWeight: "bolder",
	                      width: "30%"
	                    }
	                  },
	                  /^(Business Unit Team Member)/gi.test(this.props.roleName) ? "Bussiness Unit Name" : "ClientName"
	                ),
	                _react2.default.createElement(
	                  "strong",
	                  {
	                    style: {
	                      fontWeight: "normal",
	                      fontSize: "13px",
	                      paddingLeft: this.state.ifHiddenTopEdit ? "10px" : ""
	                    }
	                  },
	                  this.props.loginUserDetail && this.props.loginUserDetail.client.name
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "role-intro clearfix",
	                  style: { border: !this.state.ifHiddenTopEdit ? "none" : "" }
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Role"
	                ),
	                _react2.default.createElement(
	                  "small",
	                  {
	                    style: {
	                      paddingLeft: this.state.ifHiddenTopEdit ? "10px" : ""
	                    }
	                  },
	                  typeof this.props.loginUserDetail !== "undefined" && this.props.loginUserDetail.role.name
	                ),
	                _react2.default.createElement(
	                  _rcTooltip2.default,
	                  {
	                    placement: "right",
	                    overlayClassName: "profile-role-info",
	                    overlayStyle: { width: "37%" },
	                    overlay: _react2.default.createElement(
	                      "div",
	                      { className: "profile-overlay-container" },
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        this.state.roleInfo.name
	                      ),
	                      _react2.default.createElement(
	                        "ul",
	                        null,
	                        this.state.roleInfo !== "" && this.state.roleInfo.capabilities.map(function (item, index) {
	                          return _react2.default.createElement(
	                            "li",
	                            { className: "clearfix", key: index },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                className: "icon",
	                                style: { background: (0, _utility.buttonBlueColor)() }
	                              },
	                              _react2.default.createElement(_done2.default, {
	                                style: {
	                                  width: "13px",
	                                  height: "13px",
	                                  color: "white"
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "section",
	                              null,
	                              item
	                            )
	                          );
	                        })
	                      )
	                    ),
	                    arrowContent: _react2.default.createElement("div", { className: "rc-tooltip-arrow-inner" })
	                  },
	                  _react2.default.createElement(_infoOutline2.default, {
	                    style: {
	                      color: "black",
	                      width: "25px",
	                      height: "25px",
	                      marginTop: "9px",
	                      marginLeft: "10px",
	                      cursor: "pointer"
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "profile-form" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "top" },
	                  _react2.default.createElement("div", {
	                    className: "top-shadow",
	                    style: {
	                      display: this.state.ifHiddenTopEdit ? "block" : "none"
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-fn-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: "Title",
	                      onChange: function onChange(e, value) {
	                        return _this5.handleTitle(e, value);
	                      },
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      initValue: this.state.requestParams.title,
	                      borderColor: "black",
	                      labelStyle: {
	                        float: "left",
	                        fontSize: "13px",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0
	                      },
	                      inputContainerId: "firstName",
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-fn-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: "First Name",
	                      ifRequireField: true,
	                      onChange: function onChange(e, value) {
	                        return _this5.handleFirstName(e, value);
	                      },
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      initValue: this.state.requestParams.firstName,
	                      hintText: this.state.requestParams.firstName,
	                      borderColor: "black",
	                      labelStyle: {
	                        float: "left",
	                        fontSize: "13px",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0
	                      },
	                      inputContainerId: "firstName",
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                      }
	                    }),
	                    this.state.requiredFirstNameText && _react2.default.createElement(
	                      "p",
	                      { className: "create-account-field-error clearfix" },
	                      _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        this.state.requiredFirstNameText
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-ln-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: "Last Name",
	                      ifRequireField: true,
	                      onChange: function onChange(e, value) {
	                        return _this5.handleLastName(e, value);
	                      },
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      labelStyle: {
	                        float: "left",
	                        fontSize: "13px",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0
	                      },
	                      inputContainerId: "lastName",
	                      initValue: this.state.requestParams.lastName,
	                      hintText: this.state.requestParams.lastName,
	                      borderColor: "black",
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                      }
	                    }),
	                    this.state.requiredLastNameText && _react2.default.createElement(
	                      "p",
	                      { className: "create-account-field-error clearfix" },
	                      _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        this.state.requiredLastNameText
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-email-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: "E-mail Address",
	                      ifRequireField: true,
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      labelStyle: {
	                        float: "left",
	                        fontSize: "13px",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0
	                      },
	                      onChange: function onChange(e, value) {
	                        return _this5.handleEmail(e, value);
	                      },
	                      initValue: this.state.requestParams.email,
	                      hintText: this.state.requestParams.email,
	                      inputContainerId: "emailAddress",
	                      borderColor: "black",
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                      }
	                    }),
	                    this.state.requiredEmailText && _react2.default.createElement(
	                      "p",
	                      { className: "create-account-field-error clearfix" },
	                      _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        this.state.requiredEmailText
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-username" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: "Username",
	                      labelStyle: {
	                        float: "left",
	                        fontSize: "13px",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0
	                      },
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      initValue: this.state.requestParams.username,
	                      hintText: this.state.requestParams.username,
	                      onChange: function onChange(e, value) {
	                        return _this5.handleUsername(e, value);
	                      },
	                      inputContainerId: "username",
	                      borderColor: "black",
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                      }
	                    })
	                  ),
	                  !/^(administrator|team member|Business Unit Team Member)/gi.test(this.props.roleName) && _react2.default.createElement(
	                    "div",
	                    {
	                      className: "role clearfix",
	                      style: {
	                        lineHeight: "32px",
	                        height: this.state.ifHiddenTopEdit ? "" : "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                      }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          color: "black",
	                          fontSize: "13px",
	                          float: "left",
	                          width: "30%",
	                          margin: 0,
	                          fontWeight: "bolder"
	                        }
	                      },
	                      "Department"
	                    ),
	                    this.state.ifHiddenTopEdit ? _react2.default.createElement(
	                      "div",
	                      {
	                        className: "pull-left pl-10",
	                        style: { width: "68%" }
	                      },
	                      this.getDepartmentText(this.state.departmentValue)
	                    ) : _react2.default.createElement(_reactSelect2.default, {
	                      className: "cp-dropdown ",
	                      value: this.state.departmentValue,
	                      clearable: false,
	                      options: this.props.department,
	                      onChange: function onChange(value) {
	                        return _this5.handleDepartmentChange(value);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "profile-mobile-phone-number clearfix",
	                      style: {
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        style: {
	                          marginTop: this.state.ifHiddenTopEdit ? "" : "10px"
	                        }
	                      },
	                      "Mobile Phone Number"
	                    ),
	                    _react2.default.createElement(_reactTextMask2.default, {
	                      className: "mp-mask",
	                      guide: false,
	                      value: this.state.requestParams.mobilePhone,
	                      style: {
	                        border: this.state.ifHiddenTopEdit ? "" : "1px solid black",
	                        height: this.state.ifHiddenTopEdit ? "" : "32px"
	                      },
	                      mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
	                      onChange: function onChange(e) {
	                        return _this5.handleMobilePhoneNumber(e);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "profile-mobile-phone-number clearfix",
	                      style: {
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        style: {
	                          marginTop: this.state.ifHiddenTopEdit ? "" : "10px"
	                        }
	                      },
	                      "Office Phone Number"
	                    ),
	                    _react2.default.createElement(_reactTextMask2.default, {
	                      className: "mp-mask",
	                      guide: false,
	                      value: this.state.requestParams.officePhone,
	                      style: {
	                        border: this.state.ifHiddenTopEdit ? "" : "1px solid black",
	                        height: this.state.ifHiddenTopEdit ? "" : "32px"
	                      },
	                      mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
	                      onChange: function onChange(e) {
	                        return _this5.handleOfficePhoneNumber(e);
	                      }
	                    })
	                  ),
	                  !/^(administrator|team member|Business Unit Team Member)/gi.test(this.props.roleName) && _react2.default.createElement(_InputField2.default, {
	                    labelTitle: "Company Name",
	                    labelStyle: {
	                      float: "left",
	                      fontSize: "13px",
	                      fontWeight: "bolder",
	                      width: "30%",
	                      margin: 0
	                    },
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    onChange: function onChange(e, value) {
	                      return _this5.handleCompanyName(e, value);
	                    },
	                    initValue: this.state.requestParams.companyName,
	                    hintText: this.state.requestParams.companyName,
	                    inputContainerId: "officeNumber",
	                    borderColor: "black",
	                    style: {
	                      lineHeight: "32px",
	                      borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                    }
	                  }),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: /^(administrator|team member|Business Unit Team Member)/gi.test(this.props.roleName) ? /^(Business Unit Team Member)/gi.test(this.props.roleName) ? "Bussiness Unit Address1" : "Client Address 1" : "Company Address 1",
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    labelStyle: {
	                      float: "left",
	                      fontSize: "13px",
	                      fontWeight: "bolder",
	                      width: "30%",
	                      margin: 0
	                    },
	                    onChange: function onChange(e, value) {
	                      return _this5.handleCompanyAdd1(e, value);
	                    },
	                    initValue: this.state.requestParams.address1,
	                    hintText: this.state.requestParams.address1,
	                    inputContainerId: "companyAddress1",
	                    borderColor: "black",
	                    style: {
	                      lineHeight: "32px",
	                      borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                    }
	                  }),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: /^(administrator|team member|Business Unit Team Member)/gi.test(this.props.roleName) ? /^(Business Unit Team Member)/gi.test(this.props.roleName) ? "Bussiness Unit Address2" : "Client Address 2" : "Company Address 2",
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    labelStyle: {
	                      float: "left",
	                      fontSize: "13px",
	                      fontWeight: "bolder",
	                      width: "30%",
	                      margin: 0
	                    },
	                    onChange: function onChange(e, value) {
	                      return _this5.handleCompanyAdd2(e, value);
	                    },
	                    initValue: this.state.requestParams.address2,
	                    hintText: this.state.requestParams.address2,
	                    inputContainerId: "companyAddress1",
	                    borderColor: "black",
	                    style: {
	                      lineHeight: "32px",
	                      borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-city-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: "City",
	                      ifHasBorder: this.state.ifHiddenTopEdit,
	                      labelStyle: {
	                        float: "left",
	                        fontSize: "13px",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0
	                      },
	                      onChange: function onChange(e, value) {
	                        return _this5.handleCity(e, value);
	                      },
	                      initValue: this.state.requestParams.city,
	                      hintText: this.state.requestParams.city,
	                      inputContainerId: "city",
	                      borderColor: "black",
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                      }
	                    }),
	                    this.state.showCityValueTypeTip && _react2.default.createElement(
	                      "p",
	                      { className: "profile-city-error" },
	                      "City field should be text only."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "role clearfix",
	                      style: {
	                        lineHeight: "32px",
	                        height: this.state.ifHiddenTopEdit ? "" : "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                      }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          color: "black",
	                          fontSize: "13px",
	                          float: "left",
	                          width: "30%",
	                          margin: 0,
	                          fontWeight: "bolder"
	                        }
	                      },
	                      "State"
	                    ),
	                    this.state.ifHiddenTopEdit ? _react2.default.createElement(
	                      "div",
	                      { className: "pull-left pl-10", style: { width: "68%" } },
	                      this.getStateText(this.state.stateValue)
	                    ) : _react2.default.createElement(_reactSelect2.default, {
	                      className: "cp-dropdown z-index-199",
	                      value: this.state.stateValue,
	                      clearable: false,
	                      options: this.props.allstates,
	                      onChange: function onChange(value) {
	                        return _this5.handleStateChange(value);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(_InputField2.default, {
	                    labelTitle: "Zip Code",
	                    ifHasBorder: this.state.ifHiddenTopEdit,
	                    labelStyle: {
	                      float: "left",
	                      fontSize: "13px",
	                      fontWeight: "bolder",
	                      width: "30%",
	                      margin: 0
	                    },
	                    onChange: function onChange(e, value) {
	                      return _this5.handleZipCode(e, value);
	                    },
	                    initValue: this.state.requestParams.zipCode,
	                    hintText: this.state.requestParams.zipCode,
	                    inputContainerId: "zipCode",
	                    borderColor: "black",
	                    style: {
	                      lineHeight: "32px",
	                      borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0
	                    }
	                  }),
	                  /^(administrator|Business Unit Team Member)/gi.test(this.props.roleName) && _react2.default.createElement(
	                    "div",
	                    {
	                      className: "role clearfix",
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : "",
	                        marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          color: "black",
	                          fontSize: "13px",
	                          float: "left",
	                          width: "30%",
	                          margin: 0,
	                          fontWeight: "bolder"
	                        }
	                      },
	                      "Industry Type",
	                      _react2.default.createElement(
	                        "em",
	                        { style: { color: "red" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "ac-clients-select-filed",
	                        id: "industryType",
	                        style: {
	                          width: "68%",
	                          height: "34px",
	                          border: this.state.ifHiddenTopEdit ? "none" : "1px solid black"
	                        }
	                      },
	                      _react2.default.createElement(_CustomSelect2.default, {
	                        placeholder: "Select Industry Type",
	                        options: this.state.industryGroupObj,
	                        initValue: this.state.industryValue,
	                        onChange: function onChange(value) {
	                          return _this5.handleIndustryChange(value);
	                        }
	                      })
	                    )
	                  ),
	                  /^(administrator|team member)/gi.test(this.props.roleName) && this.state.requiredIndustryIdText && _react2.default.createElement(
	                    "p",
	                    { className: "create-account-field-error clearfix" },
	                    _react2.default.createElement(_error2.default, { style: { float: "left" }, color: "red" }),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.requiredIndustryIdText
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "role clearfix",
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenTopEdit ? "2px solid grey" : ""
	                      }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: {
	                          color: "black",
	                          fontSize: "13px",
	                          float: "left",
	                          width: "30%",
	                          margin: 0,
	                          fontWeight: "bolder"
	                        }
	                      },
	                      "Time Zone ",
	                      _react2.default.createElement(
	                        "em",
	                        { style: { color: "red" } },
	                        "*"
	                      )
	                    ),
	                    this.state.ifHiddenTopEdit ? _react2.default.createElement(
	                      "div",
	                      { className: "pull-left pl-10", style: { width: "68%" } },
	                      this.getTimezoneText(this.state.timezoneValue)
	                    ) : _react2.default.createElement(_reactSelect2.default, {
	                      className: "cp-dropdown z-index-198 ",
	                      value: this.state.timezoneValue,
	                      clearable: false,
	                      options: this.props.timezone,
	                      onChange: function onChange(value) {
	                        return _this5.handleTimeZoneChange(value);
	                      }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "profile-edit clearfix" },
	                this.state.showBaseInfoError && _react2.default.createElement(
	                  "p",
	                  { className: "profile-baseinfo-error" },
	                  this.props.update_error_message
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "edit-button",
	                    style: {
	                      background: (0, _utility.buttonBlueColor)(),
	                      display: this.state.ifHiddenTopEdit ? "block" : "none"
	                    },
	                    onClick: function onClick() {
	                      return _this5.handleTopCreate();
	                    }
	                  },
	                  "EDIT"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "save-group clearfix",
	                    style: {
	                      display: this.state.ifHiddenTopEdit ? "none" : "block"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: this.state.ifHiddenTopEdit ? "save" : "add-margin save",
	                      style: { background: (0, _utility.buttonBlueColor)() },
	                      onClick: function onClick() {
	                        return _this5.handleUpdateProfile();
	                      }
	                    },
	                    "SAVE"
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "cancel",
	                      onClick: function onClick() {
	                        return _this5.handleCancelEdit();
	                      },
	                      style: { marginRight: "10px" }
	                    },
	                    "CANCEL"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "profile-logo-wrapper" },
	              typeof this.props.loginUserDetail !== "undefined" && /^(account manager|operations manager|team member)/gi.test(this.props.loginUserDetail.role.name) ? "" : _react2.default.createElement(
	                "div",
	                { className: "profile-logo profile-company-logo clearfix" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "clearfix" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "title clearfix" },
	                    _react2.default.createElement(
	                      "span",
	                      { id: "profile-subtit" },
	                      "LOGO"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "review" },
	                    _react2.default.createElement("img", {
	                      src: localStorage.getItem("newLogoBase64") !== "" ? localStorage.getItem("newLogoBase64") : this.state.imgDataBase64 || _Spinner2.default,
	                      alt: "",
	                      style: {
	                        display: this.state.ifHiddenLogoEdit ? "inline-block" : "none"
	                      }
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "profile-edit-img",
	                        style: {
	                          display: this.state.ifHiddenLogoEdit ? "none" : "block"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "section" },
	                        "Select a logo to upload"
	                      ),
	                      _react2.default.createElement(
	                        _reactDropzone2.default,
	                        {
	                          onDrop: function onDrop(files, accept, reject) {
	                            return _this5.handleDrop(files, accept, reject);
	                          },
	                          style: { width: "100%" },
	                          accept: "image/jpeg, image/png, image/jpg, image/gif",
	                          maxSize: 1048576,
	                          onDropRejected: function onDropRejected() {
	                            return _this5.onDropRejected();
	                          },
	                          name: "logo"
	                        },
	                        _react2.default.createElement(
	                          "p",
	                          {
	                            style: {
	                              textAlign: "center",
	                              display: "inline-block",
	                              width: "20%",
	                              height: "20px",
	                              fontSize: "12px",
	                              border: "1px solid grey",
	                              color: "black",
	                              borderRadius: "6px",
	                              lineHeight: "20px",
	                              marginTop: "10px"
	                            }
	                          },
	                          "Choose File"
	                        ),
	                        _react2.default.createElement(
	                          "i",
	                          { style: { fontStyle: "normal", marginLeft: "6px" } },
	                          this.state.logoFileName !== undefined && this.state.logoFileName.name || "No file chosen"
	                        ),
	                        _react2.default.createElement(
	                          "section",
	                          { className: "spec" },
	                          "(Only jpg, png, and gif file with maximum size of 1MB is allowed)"
	                        )
	                      ),
	                      _react2.default.createElement("img", { src: this.state.newLogoBase64, alt: "" }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          style: { background: (0, _utility.buttonBlueColor)() },
	                          onClick: function onClick() {
	                            return _this5.handleUploadLogo();
	                          }
	                        },
	                        "UPLOAD LOGO"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "error" },
	                  this.props.update_logo_msg || this.state.companyLogoErrorText
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "profile-edit clearfix" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "edit-button",
	                      style: {
	                        background: (0, _utility.buttonBlueColor)(),
	                        display: this.state.ifHiddenLogoEdit ? "block" : "none"
	                      },
	                      onClick: function onClick() {
	                        return _this5.handleLogoEdit();
	                      }
	                    },
	                    "EDIT"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "save-group clearfix",
	                      style: {
	                        display: this.state.ifHiddenLogoEdit ? "none" : "block"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: this.state.ifHiddenTopEdit ? "save" : "add-margin save",
	                        disabled: this.state.logoUploadSuccess ? "" : "disabled",
	                        style: { background: (0, _utility.buttonBlueColor)() },
	                        onClick: function onClick() {
	                          return _this5.handleUpdatelogo();
	                        }
	                      },
	                      "SAVE"
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: "cancel",
	                        onClick: function onClick() {
	                          return _this5.handleCancelLogoEdit();
	                        }
	                      },
	                      "CANCEL"
	                    )
	                  )
	                )
	              ),
	              typeof this.props.loginUserDetail !== "undefined" && _react2.default.createElement(
	                "div",
	                { className: "profile-logo profile-photo clearfix" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "clearfix" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "title clearfix" },
	                    _react2.default.createElement(
	                      "span",
	                      { id: "profile-subtit" },
	                      "PROFILE PHOTO"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "review" },
	                    _react2.default.createElement("img", {
	                      src: localStorage.getItem("newPhotoBase64") !== "" ? localStorage.getItem("newPhotoBase64") : this.state.imgPhotoDataBase64 || _Spinner2.default,
	                      alt: "",
	                      style: {
	                        display: this.state.ifHiddenPhototEdit ? "inline-block" : "none"
	                      }
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "profile-edit-img",
	                        style: {
	                          display: this.state.ifHiddenPhototEdit ? "none" : "block"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "section" },
	                        "Select a photo to upload"
	                      ),
	                      _react2.default.createElement(
	                        _reactDropzone2.default,
	                        {
	                          onDrop: function onDrop(files, accept, reject) {
	                            return _this5.handleDropProfile(files, accept, reject);
	                          },
	                          style: { width: "100%" },
	                          accept: "image/jpeg, image/png, image/jpg, image/gif",
	                          maxSize: 1048576,
	                          onDropRejected: function onDropRejected() {
	                            return _this5.onDropProfileRejected();
	                          },
	                          name: "avatar"
	                        },
	                        _react2.default.createElement(
	                          "p",
	                          {
	                            style: {
	                              textAlign: "center",
	                              display: "inline-block",
	                              width: "20%",
	                              height: "20px",
	                              fontSize: "12px",
	                              border: "1px solid grey",
	                              color: "black",
	                              borderRadius: "6px",
	                              lineHeight: "20px",
	                              marginTop: "10px"
	                            }
	                          },
	                          "Choose File"
	                        ),
	                        _react2.default.createElement(
	                          "i",
	                          { style: { fontStyle: "normal", marginLeft: "6px" } },
	                          this.state.photoFileName !== undefined && this.state.photoFileName.name || "No file chosen"
	                        ),
	                        _react2.default.createElement(
	                          "section",
	                          { className: "spec" },
	                          "(Only jpg, png, and gif file with maximum size of 1MB is allowed)"
	                        )
	                      ),
	                      _react2.default.createElement("img", { src: this.state.newPhotoBase64, alt: "" }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          style: { background: (0, _utility.buttonBlueColor)() },
	                          onClick: function onClick() {
	                            return _this5.handlePhotoLogo();
	                          }
	                        },
	                        "UPLOAD PHOTO"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "error" },
	                  this.props.update_photo_msg || this.state.profilePhotoErrorText
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "profile-edit clearfix" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "edit-button",
	                      style: {
	                        background: (0, _utility.buttonBlueColor)(),
	                        display: this.state.ifHiddenPhototEdit ? "block" : "none"
	                      },
	                      onClick: function onClick() {
	                        return _this5.handlePhotoEdit();
	                      }
	                    },
	                    "EDIT"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "save-group clearfix",
	                      style: {
	                        display: this.state.ifHiddenPhototEdit ? "none" : "block"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: this.state.ifHiddenTopEdit ? "save" : "add-margin save",
	                        disabled: this.state.photoUploadSucess ? "" : "disabled",
	                        style: { background: (0, _utility.buttonBlueColor)() },
	                        onClick: function onClick() {
	                          return _this5.handleUpdatePhoto();
	                        }
	                      },
	                      "SAVE"
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: "cancel",
	                        onClick: function onClick() {
	                          return _this5.handleCancelPhotoEdit();
	                        },
	                        style: { marginRight: "10px" }
	                      },
	                      "CANCEL"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "profile-change-pw" },
	                _react2.default.createElement(
	                  "h1",
	                  {
	                    style: { border: this.state.ifHiddenChangePw ? "" : "none" }
	                  },
	                  "CHANGE YOUR PASSWORD"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  {
	                    className: "tip",
	                    style: {
	                      display: this.state.ifHiddenChangePw ? "none" : "block"
	                    }
	                  },
	                  "Enter a combination of at least 6 numbers, letters, and special characters"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "profile-username" },
	                  _react2.default.createElement("div", {
	                    className: "pw-shadow",
	                    style: {
	                      display: this.state.ifHiddenTopEdit ? "block" : "none"
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-fn-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: this.state.ifHiddenChangePw ? "Password" : "New Password",
	                      ifHasBorder: this.state.ifHiddenChangePw,
	                      initValue: this.state.passwordRequestParams.password,
	                      onKeyDown: this._pwdInputKeyDown,
	                      ifRequireField: true,
	                      inputType: "password",
	                      labelStyle: {
	                        float: "left",
	                        fontSize: "13px",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0
	                      },
	                      inputContainerId: "change-password",
	                      borderColor: "black",
	                      onChange: function onChange(e, value) {
	                        return _this5.handleNewPassword(e, value);
	                      },
	                      style: {
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenChangePw ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenChangePw ? "49px" : 0
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "profile-fn-wrapper" },
	                    _react2.default.createElement(_InputField2.default, {
	                      labelTitle: "Confirm Password",
	                      ifHasBorder: this.state.ifHiddenChangePw,
	                      inputType: "password",
	                      onKeyDown: this._pwdInputKeyDown,
	                      ifRequireField: true,
	                      initValue: this.state.passwordRequestParams.confirmPassword,
	                      labelStyle: {
	                        float: "left",
	                        fontSize: "13px",
	                        fontWeight: "bolder",
	                        width: "30%",
	                        margin: 0
	                      },
	                      inputContainerId: "change-password",
	                      borderColor: "black",
	                      onChange: function onChange(e, value) {
	                        return _this5.handleConfirmPassword(e, value);
	                      },
	                      style: {
	                        display: this.state.ifHiddenChangePw ? "none" : "block",
	                        lineHeight: "32px",
	                        borderBottom: this.state.ifHiddenChangePw ? "2px solid grey" : "",
	                        marginBottom: !this.state.ifHiddenChangePw ? "40px" : 0
	                      }
	                    })
	                  )
	                ),
	                this.state.showNewPwError && _react2.default.createElement(
	                  "p",
	                  {
	                    className: "profile-fn-error",
	                    style: { paddingLeft: "30%" }
	                  },
	                  this.props.change_password_error_msg
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "profile-edit clearfix" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "edit-button",
	                      style: {
	                        background: (0, _utility.buttonBlueColor)(),
	                        display: this.state.ifHiddenChangePw ? "block" : "none"
	                      },
	                      onClick: function onClick() {
	                        return _this5.handlChangePwEdit();
	                      }
	                    },
	                    "EDIT"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "save-group clearfix",
	                      style: {
	                        display: this.state.ifHiddenChangePw ? "none" : "block"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: "save",
	                        style: { background: (0, _utility.buttonBlueColor)() },
	                        onClick: function onClick() {
	                          return _this5.handleChangePwSave();
	                        }
	                      },
	                      "SAVE"
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: "cancel",
	                        onClick: function onClick() {
	                          return _this5.handleCancelPwEdit();
	                        }
	                      },
	                      "CANCEL"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Dialog2.default,
	            {
	              actions: actions,
	              modal: false,
	              open: this.props.ifUpdateSuccess
	            },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Update successfully"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Profile;
	}(_react.Component);
	
	exports.default = Profile;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _navigator = __webpack_require__(529);
	
	var _navigator2 = _interopRequireDefault(_navigator);
	
	var _lodash = __webpack_require__(18);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(1432);
	
	var _SiteDateSelector = __webpack_require__(102);
	
	var _SiteDateSelector2 = _interopRequireDefault(_SiteDateSelector);
	
	var _WebTagsTable = __webpack_require__(527);
	
	var _WebTagsTable2 = _interopRequireDefault(_WebTagsTable);
	
	var _EmailTagsTable = __webpack_require__(524);
	
	var _EmailTagsTable2 = _interopRequireDefault(_EmailTagsTable);
	
	var _EmailTagDetail = __webpack_require__(523);
	
	var _EmailTagDetail2 = _interopRequireDefault(_EmailTagDetail);
	
	var _HtmlTagDetail = __webpack_require__(525);
	
	var _HtmlTagDetail2 = _interopRequireDefault(_HtmlTagDetail);
	
	var _TagCreation = __webpack_require__(526);
	
	var _TagCreation2 = _interopRequireDefault(_TagCreation);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MySettings = function (_AcquireWebComponent) {
	  _inherits(MySettings, _AcquireWebComponent);
	
	  function MySettings(props) {
	    _classCallCheck(this, MySettings);
	
	    var _this = _possibleConstructorReturn(this, (MySettings.__proto__ || Object.getPrototypeOf(MySettings)).call(this, props));
	
	    _this.state = {
	      clientName: "",
	      buName: "",
	      clientId: undefined,
	      tag_type: "Web",
	      filter_tag_type: "Web"
	    };
	    var cid = (0, _utility.getUrlParameterByName)("cid");
	    if (cid && parseInt(cid, 10) > 1) {
	      _this.props.selectClient(parseInt(cid, 10));
	      _this.props.getClientSites(parseInt(cid, 10));
	      _this.props.getClientTags(parseInt(cid, 10));
	    }
	    return _this;
	  }
	
	  _createClass(MySettings, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (parseInt(nextProps.selected_client, 10) > 1) {
	          this.props.getClientSites(nextProps.selected_client);
	          this.props.getClientTags(nextProps.selected_client);
	          this.props.history.push("/settings/tags/list?cid=" + nextProps.selected_client);
	        }
	      }
	      //if ((nextProps.tag_info) && (isUndefined(this.props.tag_info))) {
	      if (nextProps.client_info !== this.props.client_info) {
	        var clientName = nextProps.client_info ? nextProps.client_info.name : "";
	        var buName = "";
	        if (nextProps.client_info && nextProps.client_info.parentClientId) {
	          buName = nextProps.client_info.name;
	          var c = (0, _lodash.find)(this.props.clients, function (c) {
	            return c.id === nextProps.client_info.parentClientId;
	          });
	          clientName = c ? c.name : "";
	        }
	        this.setState({
	          clientName: clientName,
	          buName: buName
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.clearInsightTagInfo();
	      this.props.clearTagError();
	      if (this.props.selected_client && this.props.selected_client > 1) {
	        //if (this.props.clients.length === 0) {
	        this.props.getClientSites(this.props.selected_client);
	        //}
	        this.props.getClientTags(this.props.selected_client);
	      } else {
	        if (this.props.selected_client && String(this.props.selected_client).indexOf("r-") >= 0) {
	          if (this.props.clients.length > 0) {
	            if (this.props.clients[0].id === 1 && this.props.clients.length > 1) {
	              this.props.selectClient(this.props.clients[1].id);
	            } else {
	              if (this.props.clients[0].id !== 1) {
	                this.props.selectClient(this.props.clients[0].id);
	              } else {
	                window.location = "/";
	              }
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: "backToListClick",
	    value: function backToListClick(e) {
	      e.preventDefault();
	      var client_info = this.props.client_info;
	
	      this.props.clearInsightTagInfoAndRefreh(client_info.id);
	    }
	  }, {
	    key: "clickCreateTag",
	    value: function clickCreateTag(e) {
	      e.preventDefault();
	      this.props.createNewTag();
	    }
	  }, {
	    key: "tagDetailContent",
	    value: function tagDetailContent(type) {
	      return _react2.default.createElement(_HtmlTagDetail2.default, Object.assign({
	        type: type,
	        clientName: this.state.clientName,
	        buName: this.state.buName,
	        imgTagName: this.state.imgTagName,
	        backToListClick: this.backToListClick.bind(this),
	        style: { padding: "0 20px" }
	      }, this.props));
	    }
	  }, {
	    key: "handleFilterTagTypeChanged",
	    value: function handleFilterTagTypeChanged(e) {
	      this.setState({
	        filter_tag_type: e.value
	      });
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      var _this2 = this;
	
	      var _props = this.props,
	          match = _props.match,
	          clients = _props.clients,
	          client_info = _props.client_info,
	          tag_info = _props.tag_info,
	          websiteId = _props.websiteId,
	          client_sites = _props.client_sites;
	
	      var siteId = websiteId ? websiteId : client_sites && client_sites.length > 0 ? client_sites[0].value : null;
	      var tagDevOptions = [{ value: "Web", label: "Web Property" }, {
	        value: "Email",
	        label: "HTML Email" /*,
	                            { value: 'Mobile', label: 'Year to date' }*/
	      }];
	      var showCreateTagBtn = this.props.roleId < 53 && this.props.roleId !== 5;
	      switch (match.params.action) {
	        case "detail":
	          if (!(0, _lodash.isUndefined)(tag_info)) {
	            if (tag_info.deploymentType === "Web") return this.tagDetailContent("detail");else return _react2.default.createElement(_EmailTagDetail2.default, Object.assign({
	              clientName: this.state.clientName,
	              style: { padding: "0 20px" },
	              buName: this.state.buName,
	              type: "detail",
	              backToListClick: this.backToListClick.bind(this)
	            }, this.props));
	          }
	          this.props.history.push("/settings/tags/list");
	          break;
	        case "create":
	          var clientName = client_info ? client_info.name : "";
	          var buName = "";
	          if (client_info && client_info.parentClientId) {
	            buName = client_info.name;
	            var c = (0, _lodash.find)(clients, function (c) {
	              return c.id === client_info.parentClientId;
	            });
	            clientName = c ? c.name : "";
	          }
	          if ((0, _lodash.isNil)(tag_info)) {
	            return _react2.default.createElement(_TagCreation2.default, Object.assign({
	              clientName: clientName,
	              buName: buName,
	              tagDevOptions: tagDevOptions,
	              tag_variables: [],
	              style: { padding: "0 20%" },
	              tag_vars_deploy: "unique",
	              pass_variables: [],
	              hash_format: [],
	              hash_case: "upper"
	            }, this.props));
	          } else {
	            if (tag_info.deploymentType === "Web") return this.tagDetailContent("create");else return _react2.default.createElement(_EmailTagDetail2.default, Object.assign({
	              clientName: this.state.clientName,
	              backToListClick: this.backToListClick.bind(this),
	              buName: this.state.buName,
	              type: "create",
	              style: { padding: "0 20px" }
	            }, this.props));
	          }
	        case "edit":
	          clientName = client_info ? client_info.name : "";
	          buName = "";
	          if (client_info && client_info.parentClientId) {
	            buName = client_info.name;
	            var _c = (0, _lodash.find)(clients, function (c) {
	              return c.id === client_info.parentClientId;
	            });
	            clientName = _c ? _c.name : "";
	          }
	          if (this.props.tag_info) {
	            var _props$tag_info = this.props.tag_info,
	                tagParams = _props$tag_info.tagParams,
	                dynamic = _props$tag_info.dynamic,
	                campaignName = _props$tag_info.campaignName,
	                deploymentType = _props$tag_info.deploymentType,
	                siteName = _props$tag_info.siteName,
	                domain = _props$tag_info.domain,
	                id = _props$tag_info.id;
	
	            var _props2 = this.props,
	                website_name = _props2.website_name,
	                website_url = _props2.website_url,
	                campaign_name = _props2.campaign_name,
	                hash_case = _props2.hash_case,
	                tag_variables = _props2.tag_variables,
	                _tag_info = _props2.tag_info,
	                rest = _objectWithoutProperties(_props2, ["website_name", "website_url", "campaign_name", "hash_case", "tag_variables", "tag_info"]);
	
	            return _react2.default.createElement(_TagCreation2.default, Object.assign({
	              clientName: clientName,
	              buName: buName,
	              tag_type: deploymentType,
	              website_name: siteName,
	              website_url: domain,
	              id: id,
	              campaign_name: campaignName,
	              tagDevOptions: tagDevOptions,
	              style: { padding: "0 20%" },
	              tag_variables: tagParams ? tagParams.pageReferences : [],
	              tag_vars_deploy: dynamic ? "dynamic" : "unique",
	              pass_variables: tagParams ? tagParams.passThroughs : [],
	              hash_format: tagParams ? tagParams.hashedEmails : [],
	              hash_case: tagParams && tagParams.upperCase ? "upper" : "lower"
	            }, rest));
	          }
	          this.props.history.push("/settings/tags/list");
	          break;
	        default:
	          return _react2.default.createElement(
	            "div",
	            { className: "mysettings-tag-content" },
	            _react2.default.createElement(
	              _Grid.Row,
	              { className: "no-padding mb-20 no-margin-top text-right" },
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "12", sm: "12", md: "12", lg: "12", className: "text-right" },
	                showCreateTagBtn && _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-default legitRipple btn-aa-default"
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      onClick: function onClick(e) {
	                        _this2.clickCreateTag(e);
	                      }
	                    },
	                    "GENERATE INSIGHTS TAG"
	                  )
	                )
	              )
	            ),
	            (0, _lodash.isEmpty)(this.props.client_tags) ? _react2.default.createElement(
	              "div",
	              {
	                className: "black-border pb-10 text-center",
	                style: { minHeight: "200px", paddingTop: "80px" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { color: "#000", fontSize: "11pt", opacity: "0.8" }
	                },
	                "No tags currently available."
	              )
	            ) : _react2.default.createElement(
	              "div",
	              {
	                className: "black-border pb-20 pl-20 pr-20",
	                style: { background: "#fff", minHeight: "200px" }
	              },
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "mt-20",
	                  style: { fontSize: "16px", fontWeight: "bold" }
	                },
	                "TAGS"
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "no-padding mb-20" },
	                _react2.default.createElement(
	                  "span",
	                  {
	                    style: {
	                      fontWeight: "bold",
	                      position: "absolute",
	                      top: "10px"
	                    }
	                  },
	                  "Tag Deployment Type"
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { style: { width: "180px", display: "inline-block" } },
	                  "\xA0"
	                ),
	                _react2.default.createElement(_reactSelect2.default, {
	                  value: this.state.filter_tag_type,
	                  name: "",
	                  className: "tag-dev-type-selection",
	                  clearable: false,
	                  options: tagDevOptions,
	                  searchable: false,
	                  onChange: this.handleFilterTagTypeChanged.bind(this)
	                })
	              ),
	              this.state.filter_tag_type === "Web" ? _react2.default.createElement(_WebTagsTable2.default, {
	                client_tags: this.props.client_tags,
	                getTagDetail: this.props.getTagDetail,
	                client_info: this.props.client_info,
	                redirectUrl: "/settings/tags/detail"
	              }) : _react2.default.createElement(_EmailTagsTable2.default, {
	                client_tags: this.props.client_tags,
	                getTagDetail: this.props.getTagDetail,
	                client_info: this.props.client_info,
	                redirectUrl: "/settings/tags/detail"
	              })
	            )
	          );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          websiteId = _props3.websiteId,
	          client_sites = _props3.client_sites,
	          match = _props3.match;
	
	      var siteId = websiteId ? websiteId : client_sites && client_sites.length > 0 ? client_sites[0].value : null;
	      return _react2.default.createElement(
	        "div",
	        { id: "mysettings-container" },
	        ["list", "detail", "edit", "create"].indexOf(match.params.action) < 0 && _react2.default.createElement(
	          "div",
	          { style: { padding: "10px 10%", fontSize: "16px" } },
	          _react2.default.createElement(_SiteDateSelector2.default, {
	            type: "larger",
	            websiteIdChanged: this.props.setWebsiteId,
	            siteId: siteId,
	            sites: client_sites,
	            style: {
	              paddingTop: "0px",
	              paddingBottom: "0px",
	              marginBottom: "0px"
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", padding: "10px 10%", fontSize: "16px" } },
	          _react2.default.createElement(_navigator2.default, {
	            activeIndex: 0,
	            history: this.props.history,
	            client: this.props.client_info,
	            selected_client: this.props.selected_client
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "mysettings-content" },
	            this.getContent()
	          )
	        )
	      );
	    }
	  }]);
	
	  return MySettings;
	}(_MaterialUI2.default);
	
	exports.default = MySettings;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _navigator = __webpack_require__(529);
	
	var _navigator2 = _interopRequireDefault(_navigator);
	
	var _SiteDateSelector = __webpack_require__(102);
	
	var _SiteDateSelector2 = _interopRequireDefault(_SiteDateSelector);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _materialUi = __webpack_require__(38);
	
	var _lodash = __webpack_require__(18);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _RadioButton = __webpack_require__(107);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	__webpack_require__(1431);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsightsFileSettings = function (_AcquireWebComponent) {
	  _inherits(InsightsFileSettings, _AcquireWebComponent);
	
	  function InsightsFileSettings(props) {
	    _classCallCheck(this, InsightsFileSettings);
	
	    var _this = _possibleConstructorReturn(this, (InsightsFileSettings.__proto__ || Object.getPrototypeOf(InsightsFileSettings)).call(this, props));
	
	    _this.state = {
	      width: 1024,
	      deliveryDay: null,
	      deliveryWeekly: null,
	      deliveryMonthly: null,
	      showSaveSuccessDialog: false,
	      showCancelSaveDialog: false,
	      inEditMode: false,
	      initMode: true,
	      showOnSavingDialog: false,
	      showTagsOnLoading: false,
	      changeFrequency: false, // change Frequency dialog
	      selectedRadio: "",
	      defaultValue: "", // selection default value for frequency
	      selectedMeasure: null,
	      selectedTopSegment: null
	    };
	    return _this;
	  }
	
	  _createClass(InsightsFileSettings, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (nextProps.selected_client > 1) {
	          this.props.getClientSites(nextProps.selected_client);
	          this.props.getClientTags(nextProps.selected_client);
	          this.props.setWebsiteId(null);
	        }
	      }
	      if (nextProps.client_info !== this.props.client_info) {
	        if (nextProps.client_info) {
	          var showInsightsFileSetup = nextProps.client_info && nextProps.client_info.subscription && nextProps.client_info.subscription.name.toLowerCase().indexOf("basic") < 0;
	          if (!showInsightsFileSetup) this.props.history.push("/settings/tags/list");
	        }
	      }
	      if (nextProps.websiteId !== this.props.websiteId) {
	        this.setState({ deliveryDay: null });
	      }
	      if (nextProps.insights_file_save_success !== this.props.insights_file_save_success && nextProps.insights_file_save_success === true) {
	        this.setState({
	          showSaveSuccessDialog: true,
	          deliveryDay: null,
	          inEditMode: false,
	          defaultValue: ""
	        });
	      }
	      if (typeof nextProps.websiteId === "number") {
	        this.getDefaultlValue(nextProps.client_tags, nextProps.websiteId);
	      } else {
	        if (nextProps.client_sites && nextProps.client_sites.length > 0) this.getDefaultlValue(nextProps.client_tags, nextProps.client_sites[0].value);
	      }
	      if (nextProps.insights_file_on_saving !== this.props.insights_file_on_saving) {
	        this.setState({ showOnSavingDialog: nextProps.insights_file_on_saving });
	      }
	      if (nextProps.client_tags_on_loading !== this.props.client_tags_on_loading) {
	        this.setState({ showTagsOnLoading: nextProps.client_tags_on_loading });
	      }
	      if (!(0, _lodash.isEqual)(nextProps.client_tags, this.props.client_tags)) {
	        if (nextProps.websiteId) this.getDefaultlValue(nextProps.client_tags, nextProps.websiteId);else if (nextProps.client_sites && nextProps.client_sites.length > 0) this.getDefaultlValue(nextProps.client_tags, nextProps.client_sites[0].value);
	      }
	    }
	  }, {
	    key: "getDefaultlValue",
	    value: function getDefaultlValue(tags, val) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          if (v.id === val) {
	            if (!v.insightFrequencyType && v.insightsMeasurement && v.insightsTopSegments) {
	              this.setState({
	                initMode: false,
	                inEditMode: false,
	                selectedMeasure: v.insightsMeasurement,
	                selectedTopSegment: v.insightsTopSegments,
	                selectedRadio: "None",
	                defaultValue: "None"
	              });
	            }
	            if (v.insightFrequencyType === "Weekly") {
	              var weekLabel = void 0;
	              var _iteratorNormalCompletion2 = true;
	              var _didIteratorError2 = false;
	              var _iteratorError2 = undefined;
	
	              try {
	                for (var _iterator2 = this.week()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                  var item = _step2.value;
	
	                  if (item.value === +v.insightsFileDeliveryDate) {
	                    weekLabel = item.label;
	                  }
	                }
	              } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                  }
	                } finally {
	                  if (_didIteratorError2) {
	                    throw _iteratorError2;
	                  }
	                }
	              }
	
	              this.setState({
	                initMode: false,
	                selectedMeasure: v.insightsMeasurement,
	                selectedTopSegment: v.insightsTopSegments,
	                inEditMode: false,
	                defaultValue: v.insightFrequencyType ? v.insightFrequencyType : "None",
	                selectedRadio: v.insightFrequencyType ? v.insightFrequencyType : "None",
	                deliveryWeekly: v.insightFrequencyType === "Weekly" ? { value: v.insightsFileDeliveryDate, label: weekLabel } : null
	              });
	            }
	            if (v.insightFrequencyType === "Daily") {
	              // let weekLabel;
	              // for (const item of this.week()) {
	              //   if (item.value === +v.insightsFileDeliveryDate) {
	              //     weekLabel = item.label;
	              //   }
	              // }
	              this.setState({
	                initMode: false,
	                inEditMode: false,
	                defaultValue: v.insightFrequencyType,
	                deliveryDay: v.insightFrequencyType,
	                selectedRadio: v.insightFrequencyType,
	                selectedMeasure: v.insightsMeasurement,
	                selectedTopSegment: v.insightsTopSegments
	              });
	            }
	            if (v.insightFrequencyType === "Monthly") {
	              this.setState({
	                initMode: v.insightsFileDeliveryDate ? false : true,
	                inEditMode: v.insightsFileDeliveryDate ? false : true,
	                selectedMeasure: v.insightsMeasurement,
	                selectedTopSegment: v.insightsTopSegments,
	                defaultValue: v.insightsFileDeliveryDate ? v.insightFrequencyType : undefined,
	                selectedRadio: v.insightsFileDeliveryDate ? v.insightFrequencyType : undefined,
	                deliveryMonthly: v.insightsFileDeliveryDate ? v.insightsFileDeliveryDate : undefined
	              });
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var width = document.getElementById("mysettings-container").clientWidth;
	      if (this.props.selected_client && this.props.selected_client > 1) {
	        this.props.getClientInfo(this.props.selected_client);
	      }
	
	      this.setState({ width: width });
	    }
	  }, {
	    key: "handleDayRangeChange",
	    value: function handleDayRangeChange(val) {
	      this.setState({ deliveryMonthly: val.value });
	    }
	  }, {
	    key: "days",
	    value: function days() {
	      var result = [];
	      for (var i = 0; i < 31; i++) {
	        result.push({ value: i + 1, label: i + 1 });
	      }
	      return result;
	    }
	  }, {
	    key: "onBtnSaveClick",
	    value: function onBtnSaveClick(e, siteId) {
	      e.preventDefault();
	      var obj = {
	        type: this.state.selectedRadio === "None" ? null : this.state.selectedRadio,
	        insightsMeasurement: this.state.selectedMeasure ? this.state.selectedMeasure : "index", // should match ["index"|"visitors"], required
	        insightsTopSegments: this.state.selectedTopSegment ? parseInt(this.state.selectedTopSegment, 10) : 5 //[5, 10, 20, 99], 99 means All Segments
	      };
	      switch (this.state.selectedRadio) {
	        case "Daily":
	          obj = Object.assign({}, obj);
	          break;
	        case "Weekly":
	          obj = Object.assign({}, obj, {
	            deliveryDate: this.state.deliveryWeekly.value
	          });
	          break;
	        case "Monthly":
	          obj = Object.assign({}, obj, {
	            deliveryDate: this.state.deliveryMonthly
	          });
	          break;
	        default:
	          obj = Object.assign({}, obj);
	      }
	      this.props.saveInsightsFileSetup(this.props.selected_client, siteId, obj);
	    }
	  }, {
	    key: "onBtnEditClick",
	    value: function onBtnEditClick(e, insightsFileDeliveryDate) {
	      e.preventDefault();
	      this.props.clearInsightsFileSettingsSaveError();
	      this.setState({
	        changeFrequency: true,
	        deliveryDay: insightsFileDeliveryDate
	      });
	    }
	  }, {
	    key: "onBtnLeavePageClick",
	    value: function onBtnLeavePageClick() {
	      this.getDefaultlValue(this.props.client_tags, this.props.websiteId ? this.props.websiteId : this.props.client_sites[0].value);
	      if (this.props.selected_client && this.props.selected_client > 1) {
	        this.props.getClientInfo(this.props.selected_client);
	      }
	      this.setState({
	        deliveryDay: null,
	        inEditMode: false,
	        showCancelSaveDialog: false
	      });
	      this.props.clearInsightsFileSettingsSaveError();
	    }
	  }, {
	    key: "handleChangeFrequency",
	    value: function handleChangeFrequency(e, value) {
	      e.preventDefault();
	
	      this.setState({
	        //changeFrequency: this.state.initMode || (this.state.defaultValue === value) ? false :  true,
	        selectedRadio: value,
	        initMode: false
	      });
	      switch (value) {
	        case "Daily":
	          this.setState({ deliveryDay: value });
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: "handleChangeMeasure",
	    value: function handleChangeMeasure(e, value) {
	      e.preventDefault();
	
	      this.setState({
	        selectedMeasure: value
	      });
	    }
	  }, {
	    key: "handleChangeTopSegments",
	    value: function handleChangeTopSegments(e, value) {
	      e.preventDefault();
	
	      this.setState({
	        selectedTopSegment: value
	      });
	    }
	  }, {
	    key: "continueChange",
	    value: function continueChange(e) {
	      e.preventDefault();
	      this.setState({
	        changeFrequency: false,
	        inEditMode: true
	      });
	    }
	  }, {
	    key: "handleCancelChange",
	    value: function handleCancelChange(e) {
	      e.preventDefault();
	      this.setState({
	        changeFrequency: false,
	        selectedRadio: this.state.defaultValue
	      });
	    }
	  }, {
	    key: "handleWeekRangeChange",
	    value: function handleWeekRangeChange(val) {
	      this.setState({
	        deliveryWeekly: val
	      });
	    }
	  }, {
	    key: "week",
	    value: function week() {
	      return [{ value: 2, label: "Monday" }, { value: 3, label: "Tuesday" }, { value: 4, label: "Wednesday" }, { value: 5, label: "Thursday" }, { value: 6, label: "Friday" }, { value: 7, label: "Saturday" }, { value: 1, label: "Sunday" }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          websiteId = _props.websiteId,
	          client_sites = _props.client_sites,
	          client_info = _props.client_info,
	          client_tags = _props.client_tags,
	          insights_file_save_success = _props.insights_file_save_success,
	          insights_file_save_error_message = _props.insights_file_save_error_message;
	      var _state = this.state,
	          selectedRadio = _state.selectedRadio,
	          deliveryMonthly = _state.deliveryMonthly,
	          deliveryWeekly = _state.deliveryWeekly;
	
	      var sites = (0, _filter2.default)(client_sites, function (site) {
	        return site.enabled === true;
	      });
	      var siteId = websiteId ? websiteId : sites && sites.length > 0 ? sites[0].value : null;
	      var currentTag = (0, _lodash.find)(client_tags, function (tag) {
	        return tag.id === siteId;
	      });
	      var insightsFileDeliveryDate = currentTag ? currentTag.insightsFileDeliveryDate : undefined;
	      var disabledButton = client_info && client_info.subscriptionTierId > 3 ? (0, _lodash.isNil)(this.state.selectedMeasure) && this.state.selectedRadio !== "None" || (0, _lodash.isNil)(this.state.selectedTopSegment) && this.state.selectedRadio !== "None" || (0, _lodash.isNil)(this.state.selectedRadio) || selectedRadio === "Weekly" && !deliveryWeekly || selectedRadio === "Monthly" && !deliveryMonthly : (0, _lodash.isNil)(this.state.selectedRadio) || selectedRadio === "Weekly" && !deliveryWeekly || selectedRadio === "Monthly" && !deliveryMonthly;
	      return sites && sites.length > 0 ? _react2.default.createElement(
	        "div",
	        { id: "mysettings-container" },
	        _react2.default.createElement(
	          "div",
	          { style: { padding: "10px 10%", fontSize: "16px" } },
	          _react2.default.createElement(_SiteDateSelector2.default, {
	            type: "larger",
	            websiteIdChanged: this.props.setWebsiteId,
	            siteId: siteId,
	            sites: client_sites,
	            style: {
	              paddingTop: "0px",
	              paddingBottom: "0px",
	              marginBottom: "0px"
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", padding: "10px 10%", fontSize: "16px" } },
	          _react2.default.createElement(_navigator2.default, {
	            activeIndex: 1,
	            history: this.props.history,
	            client: this.props.client_info,
	            selected_client: this.props.selected_client
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "ml-20", style: { width: "100%", flex: "1 0" } },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "insights-file-settings-content",
	                style: { paddingLeft: "20px", paddingRight: "20px" }
	              },
	              client_info && client_info.subscription && (client_info.subscription.name === "Professional" ? _react2.default.createElement(
	                "div",
	                { className: "light-grey-border p-20 bg-white" },
	                "The Insights Professional subscription tier also allows you to receive a default of 500 consumer records per month and 200 business records. The Professional Tier gives you added ability to base the download on the segmentation system of your choice, the top segments, the measure of your choice. Clients that currently license Claritas segmentation data also have the option to have the segment code appended directly to the audience file. ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Your files will be available for 30 days from the date they are created after which time they will be removed from the system.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Add our address,",
	                " ",
	                _react2.default.createElement(
	                  "em",
	                  { style: { color: "#3487AD", fontStyle: "normal" } },
	                  "AudienceAnywhere@claritas.com"
	                ),
	                ", to your email safe sender list, address book, or contact list."
	              ) : _react2.default.createElement(
	                "div",
	                { className: "light-grey-border p-20 bg-white" },
	                "The Insights Standard subscription tier allows you to receive a default of 500 consumer records and 200 business records each month base on your site traffic. Your files will be created based on the selection you make below. When your files are ready, you will receive an email with a link to download your files. ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Your files will be available for 30 days from the date they are created after which time they will be removed from the system.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Add our address,",
	                " ",
	                _react2.default.createElement(
	                  "em",
	                  { style: { color: "#3487AD", fontStyle: "normal" } },
	                  "AudienceAnywhere@claritas.com"
	                ),
	                ", to your email safe sender list, address book, or contact list."
	              )),
	              _react2.default.createElement(
	                "div",
	                { className: "light-grey-border mt-20 p-20 bg-white" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "raido-tit" },
	                  _react2.default.createElement(
	                    "h2",
	                    null,
	                    "File Settings"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { display: "flex" } },
	                    _react2.default.createElement(
	                      "div",
	                      { style: { flex: "0 0 180px" } },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Delivery Frequency"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { style: { flex: "1 1", paddingLeft: "10px" } },
	                      _react2.default.createElement(
	                        _RadioButton.RadioButtonGroup,
	                        {
	                          name: "consumer",
	                          defaultSelected: this.state.defaultValue,
	                          valueSelected: this.state.selectedRadio,
	                          onChange: function onChange(e, value) {
	                            return _this2.handleChangeFrequency(e, value);
	                          }
	                        },
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          disabled: this.state.inEditMode === false,
	                          style: { marginBottom: "5px" },
	                          value: "None",
	                          label: "None",
	                          iconStyle: {
	                            fill: "black",
	                            marginRight: "10px",
	                            width: "20px",
	                            height: "20px",
	                            marginTop: "0px"
	                          }
	                        }),
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          disabled: this.state.inEditMode === false,
	                          style: { marginBottom: "5px" },
	                          value: "Daily",
	                          label: "Daily",
	                          iconStyle: {
	                            fill: "black",
	                            marginRight: "10px",
	                            width: "20px",
	                            height: "20px",
	                            marginTop: "0px"
	                          }
	                        }),
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          disabled: this.state.inEditMode === false,
	                          style: { marginBottom: "5px" },
	                          value: "Weekly",
	                          label: "Weekly",
	                          iconStyle: {
	                            fill: "black",
	                            width: "20px",
	                            height: "20px",
	                            marginRight: "10px",
	                            marginTop: "0px"
	                          }
	                        }),
	                        _react2.default.createElement(_RadioButton.RadioButton, {
	                          disabled: this.state.inEditMode === false,
	                          style: { marginBottom: "5px" },
	                          value: "Monthly",
	                          label: "Monthly",
	                          iconStyle: {
	                            fill: "black",
	                            width: "20px",
	                            height: "20px",
	                            marginRight: "10px",
	                            marginTop: "0px"
	                          }
	                        })
	                      )
	                    )
	                  )
	                ),
	                this.state.defaultValue === "Daily" && !this.state.inEditMode && _react2.default.createElement(
	                  "div",
	                  {
	                    className: "mt-20 light-grey-border p-5 pl-10 pr-10",
	                    style: { background: "#E2E2E2", fontWeight: "bold" }
	                  },
	                  "Your files will be delivered every day by 10:00 AM."
	                ),
	                this.state.inEditMode && this.state.selectedRadio === "Daily" && this.state.initMode === false && _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "mt-20 light-grey-border p-5 pl-10 pr-10",
	                      style: { background: "#E2E2E2", fontWeight: "bold" }
	                    },
	                    "Your files will be delivered every day by 10:00 AM."
	                  )
	                ),
	                this.state.defaultValue === "Weekly" && !this.state.inEditMode && _react2.default.createElement(
	                  "div",
	                  { className: "success-weekly" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "wrapper" },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Delivery Day:"
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.deliveryWeekly && this.state.deliveryWeekly.label
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "mt-20 light-grey-border p-5 pl-10 pr-10",
	                      style: { background: "#E2E2E2", fontWeight: "bold" }
	                    },
	                    "Your files will be delivered on",
	                    " ",
	                    this.state.deliveryWeekly && this.state.deliveryWeekly.label,
	                    " ",
	                    "by 10:00 AM."
	                  )
	                ),
	                this.state.inEditMode && this.state.selectedRadio === "Weekly" && _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "p",
	                    { className: "frequency-tips" },
	                    "Please select the day you wish to receive your audience files. Your files will be created and delivered weekly on the day you select."
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mt-20" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: this.state.inEditMode ? "pull-left mt-10" : "pull-left"
	                      },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Delivery Day"
	                      )
	                    ),
	                    this.state.inEditMode ? _react2.default.createElement(_reactSelect2.default, {
	                      className: "insights-site-selector width-100 left-30",
	                      value: this.state.deliveryWeekly,
	                      clearable: false,
	                      searchable: false,
	                      options: this.week(),
	                      placeholder: "Select Day",
	                      onChange: this.handleWeekRangeChange.bind(this)
	                    }) : _react2.default.createElement(
	                      "span",
	                      { className: "width-100 ml-20" },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        insightsFileDeliveryDate
	                      )
	                    )
	                  )
	                ),
	                this.state.defaultValue === "Monthly" && !this.state.inEditMode && _react2.default.createElement(
	                  "div",
	                  { className: "success-weekly" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "wrapper" },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Delivery Day:"
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.deliveryMonthly
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "mt-20 light-grey-border p-5 pl-10 pr-10",
	                      style: { background: "#E2E2E2", fontWeight: "bold" }
	                    },
	                    "Your files will be delivered the",
	                    " ",
	                    this.state.deliveryMonthly,
	                    "th day of every month by 10:00 AM."
	                  )
	                ),
	                this.state.inEditMode && this.state.selectedRadio === "Monthly" && _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "p",
	                    { className: "frequency-tips" },
	                    "Please select the day of the month and time you wish to receive your audience files."
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mt-20" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: this.state.inEditMode ? "pull-left mt-10" : "pull-left"
	                      },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Delivery Day"
	                      )
	                    ),
	                    this.state.inEditMode ? _react2.default.createElement(_reactSelect2.default, {
	                      className: "insights-site-selector width-100 left-30",
	                      value: this.state.deliveryMonthly,
	                      clearable: false,
	                      options: this.days(),
	                      placeholder: "Select Day",
	                      onChange: this.handleDayRangeChange.bind(this)
	                    }) : _react2.default.createElement(
	                      "span",
	                      { className: "width-100 ml-20" },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        insightsFileDeliveryDate
	                      )
	                    )
	                  )
	                ),
	                this.state.initMode === true && disabledButton && _react2.default.createElement(
	                  "div",
	                  {
	                    className: "mt-20",
	                    style: { color: "#DD0000", position: "relative" }
	                  },
	                  _react2.default.createElement(_error2.default, {
	                    style: { fill: "#DD0000", width: "18px", height: "18px" }
	                  }),
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        position: "absolute",
	                        top: "0px",
	                        marginLeft: "10px"
	                      }
	                    },
	                    "Please select a delivery frequency."
	                  )
	                ),
	                insights_file_save_success === false && !(0, _lodash.isNil)(insights_file_save_error_message) && _react2.default.createElement(
	                  "div",
	                  {
	                    className: "mt-20",
	                    style: { color: "#DD0000", position: "relative" }
	                  },
	                  _react2.default.createElement(_error2.default, {
	                    style: {
	                      fill: "#DD0000",
	                      width: "18px",
	                      height: "18px"
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        position: "absolute",
	                        top: "0px",
	                        marginLeft: "10px"
	                      }
	                    },
	                    insights_file_save_error_message
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: client_info && client_info.subscriptionTierId > 3 && this.state.selectedRadio !== "None" ? "block" : "none"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "light-grey-border mt-20 p-20 bg-white" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "raido-tit" },
	                    _react2.default.createElement(
	                      "h2",
	                      null,
	                      "Professional Tier Settings"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { style: { display: "flex" } },
	                      _react2.default.createElement(
	                        "div",
	                        { style: { flex: "0 0 180px" } },
	                        _react2.default.createElement(
	                          "strong",
	                          null,
	                          "Measure"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { style: { flex: "1 1", paddingLeft: "10px" } },
	                        _react2.default.createElement(
	                          _RadioButton.RadioButtonGroup,
	                          {
	                            name: "consumer",
	                            valueSelected: this.state.selectedMeasure,
	                            onChange: function onChange(e, value) {
	                              return _this2.handleChangeMeasure(e, value);
	                            }
	                          },
	                          _react2.default.createElement(_RadioButton.RadioButton, {
	                            disabled: this.state.inEditMode === false,
	                            style: { marginBottom: "5px" },
	                            value: "index",
	                            label: "Index",
	                            iconStyle: {
	                              fill: "black",
	                              marginRight: "10px",
	                              width: "20px",
	                              height: "20px",
	                              marginTop: "0px"
	                            }
	                          }),
	                          _react2.default.createElement(_RadioButton.RadioButton, {
	                            disabled: this.state.inEditMode === false,
	                            style: { marginBottom: "5px" },
	                            value: "visitors",
	                            label: "% of HH visitors",
	                            iconStyle: {
	                              fill: "black",
	                              marginRight: "10px",
	                              width: "20px",
	                              height: "20px",
	                              marginTop: "0px"
	                            }
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { style: { display: "flex", marginTop: "20px" } },
	                      _react2.default.createElement(
	                        "div",
	                        { style: { flex: "0 0 180px" } },
	                        _react2.default.createElement(
	                          "strong",
	                          null,
	                          "Audience File Based on Top Segments"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { style: { flex: "1 1", paddingLeft: "10px" } },
	                        _react2.default.createElement(
	                          _RadioButton.RadioButtonGroup,
	                          {
	                            name: "consumer",
	                            valueSelected: this.state.selectedTopSegment,
	                            onChange: function onChange(e, value) {
	                              return _this2.handleChangeTopSegments(e, value);
	                            }
	                          },
	                          _react2.default.createElement(_RadioButton.RadioButton, {
	                            disabled: this.state.inEditMode === false,
	                            style: { marginBottom: "5px" },
	                            value: 5,
	                            label: "Up to top 5 segments",
	                            iconStyle: {
	                              fill: "black",
	                              marginRight: "10px",
	                              width: "20px",
	                              height: "20px",
	                              marginTop: "0px"
	                            }
	                          }),
	                          _react2.default.createElement(_RadioButton.RadioButton, {
	                            disabled: this.state.inEditMode === false,
	                            style: { marginBottom: "5px" },
	                            value: 10,
	                            label: "Up to top 10 segments",
	                            iconStyle: {
	                              fill: "black",
	                              marginRight: "10px",
	                              width: "20px",
	                              height: "20px",
	                              marginTop: "0px"
	                            }
	                          }),
	                          _react2.default.createElement(_RadioButton.RadioButton, {
	                            disabled: this.state.inEditMode === false,
	                            style: { marginBottom: "5px" },
	                            value: 20,
	                            label: "Up to top 20 segments",
	                            iconStyle: {
	                              fill: "black",
	                              marginRight: "10px",
	                              width: "20px",
	                              height: "20px",
	                              marginTop: "0px"
	                            }
	                          }),
	                          _react2.default.createElement(_RadioButton.RadioButton, {
	                            disabled: this.state.inEditMode === false,
	                            style: { marginBottom: "5px" },
	                            value: 99,
	                            label: "All segments",
	                            iconStyle: {
	                              fill: "black",
	                              marginRight: "10px",
	                              width: "20px",
	                              height: "20px",
	                              marginTop: "0px"
	                            }
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "pr-20" },
	              this.state.inEditMode ? _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "text-right no-padding mt-20 no-margin-bottom" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-aa-info mr-10",
	                    disabled: disabledButton && this.initMode,
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this2.setState({ showCancelSaveDialog: true });
	                    }
	                  },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Cancel"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-default btn-aa-default",
	                    disabled: disabledButton,
	                    onClick: function onClick(e) {
	                      _this2.onBtnSaveClick(e, siteId);
	                    }
	                  },
	                  "Save"
	                )
	              ) : _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "text-right no-padding mt-20 no-margin-bottom" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "aw-btn",
	                    onClick: function onClick(e) {
	                      _this2.onBtnEditClick(e, insightsFileDeliveryDate);
	                    }
	                  },
	                  "Edit"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _materialUi.Dialog,
	              {
	                open: this.state.showSaveSuccessDialog,
	                bodyStyle: { color: "#000" },
	                contentStyle: {
	                  width: "482px",
	                  textAlign: "center",
	                  padding: "10px"
	                },
	                actionsContainerStyle: {
	                  textAlign: "center",
	                  padding: "0 10px 20px"
	                },
	                actions: [_react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-default btn-aa-default",
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this2.setState({
	                        showSaveSuccessDialog: false,
	                        inEditMode: false
	                      });
	                    }
	                  },
	                  "Close"
	                )]
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "You have successfully scheduled your audience files."
	              )
	            ),
	            _react2.default.createElement(
	              _materialUi.Dialog,
	              {
	                open: this.state.changeFrequency,
	                bodyStyle: { color: "#000" },
	                contentStyle: {
	                  width: "482px",
	                  textAlign: "center",
	                  padding: "10px"
	                },
	                actionsContainerStyle: {
	                  textAlign: "center",
	                  padding: "0 10px 20px"
	                },
	                actions: [_react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-aa-info mr-10 text-bold",
	                    onClick: function onClick(e) {
	                      return _this2.handleCancelChange(e);
	                    }
	                  },
	                  "CANCEL"
	                ), _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-aa-warning text-bold",
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this2.continueChange(e);
	                    }
	                  },
	                  "CONTINUE"
	                )]
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Changing your file return frequency may result in date coverage gaps in your return file(s)."
	              )
	            ),
	            _react2.default.createElement(
	              _materialUi.Dialog,
	              {
	                style: { top: "-1.8em" },
	                open: this.state.showOnSavingDialog,
	                overlayStyle: { opacity: 0.9, backgroundColor: "#666666" },
	                modal: true
	              },
	              _react2.default.createElement(
	                _Grid.Row,
	                { className: "mt-20" },
	                _react2.default.createElement(
	                  _Grid.Col,
	                  { xs: "7", sm: "7", md: "7", lg: "7", className: "text-right" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    "Saving tag data, please wait..."
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Col,
	                  { xs: "1", sm: "1", md: "1", lg: "1" },
	                  _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _materialUi.Dialog,
	              {
	                style: { top: "-1.8em" },
	                open: /*this.state.showTagsOnLoading*/false,
	                overlayStyle: { opacity: 0.9, backgroundColor: "#666666" },
	                modal: true
	              },
	              _react2.default.createElement(
	                _Grid.Row,
	                { className: "mt-20" },
	                _react2.default.createElement(
	                  _Grid.Col,
	                  { xs: "7", sm: "7", md: "7", lg: "7", className: "text-right" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    "Loading tags, please wait..."
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Col,
	                  { xs: "1", sm: "1", md: "1", lg: "1" },
	                  _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _materialUi.Dialog,
	              {
	                open: this.state.showCancelSaveDialog,
	                bodyStyle: { color: "#000" },
	                contentStyle: {
	                  width: "482px",
	                  textAlign: "center",
	                  padding: "10px"
	                },
	                actionsContainerStyle: {
	                  textAlign: "center",
	                  padding: "0 10px 20px"
	                },
	                actions: [_react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-aa-info mr-10 text-bold",
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this2.setState({ showCancelSaveDialog: false });
	                    }
	                  },
	                  "CANCEL"
	                ), _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-aa-warning text-bold",
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this2.onBtnLeavePageClick(e);
	                    }
	                  },
	                  "LEAVE PAGE"
	                )]
	              },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Are you sure you would like to leave this page?"
	              )
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        "div",
	        { id: "mysettings-container" },
	        _react2.default.createElement(
	          "div",
	          { style: { padding: "10px 10%", fontSize: "16px" } },
	          _react2.default.createElement(_SiteDateSelector2.default, {
	            type: "larger",
	            websiteIdChanged: this.props.setWebsiteId,
	            siteId: siteId,
	            sites: client_sites,
	            style: {
	              paddingTop: "0px",
	              paddingBottom: "0px",
	              marginBottom: "0px"
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", padding: "10px 10%", fontSize: "16px" } },
	          _react2.default.createElement(_navigator2.default, {
	            activeIndex: 1,
	            history: this.props.history,
	            client: this.props.client_info,
	            selected_client: this.props.selected_client
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "ml-20", style: { width: "100%", flex: "1 0" } },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "insights-file-settings-content text-center",
	                style: {
	                  color: "#9C9C9C",
	                  paddingTop: "100px"
	                }
	              },
	              _react2.default.createElement(
	                "h1",
	                null,
	                "No tags currently available."
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InsightsFileSettings;
	}(_MaterialUI2.default);
	
	exports.default = InsightsFileSettings;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivateAudienceDialog = function (_AcquireWebComponent) {
	  _inherits(ActivateAudienceDialog, _AcquireWebComponent);
	
	  function ActivateAudienceDialog(props) {
	    _classCallCheck(this, ActivateAudienceDialog);
	
	    var _this = _possibleConstructorReturn(this, (ActivateAudienceDialog.__proto__ || Object.getPrototypeOf(ActivateAudienceDialog)).call(this, props));
	
	    _this.state = {
	      subject: props.segment_summary ? "Activate " + props.segment_summary.name : "",
	      comments: ""
	    };
	    return _this;
	  }
	
	  _createClass(ActivateAudienceDialog, [{
	    key: "submitActivation",
	    value: function submitActivation() {
	      this.props.submitActivateRequest(this.props.segment_summary.id, this.props.segment_summary.clientId, this.state.subject, this.state.comments);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.request_success !== this.props.request_success && this.props.request_success === true) {
	        this.props.onRequestActivationClose();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          title: "Activate Audience",
	          modal: false,
	          autoDetectWindowHeight: false,
	          autoScrollBodyContent: true,
	          titleStyle: { fontWeight: "bold", fontSize: "24px", padding: "20px" },
	          open: this.props.open,
	          onRequestClose: function onRequestClose() {
	            _this2.props.onRequestActivationClose();
	          },
	          bodyStyle: {
	            color: "#000",
	            fontWeight: "normal",
	            fontSize: "16px",
	            paddingTop: "0px",
	            paddingBottom: "20px",
	            textAlign: "left",
	            overflowY: "auto",
	            height: "1080px",
	            borderTop: "solid 0px #EEEFF2"
	          },
	          contentStyle: {
	            width: "960px",
	            maxWidth: "960px",
	            height: "1080px"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                paddingBottom: "20px",
	                marginBottom: "20px",
	                borderBottom: "solid 1px #EEEFF2"
	              }
	            },
	            "Claritas can help you activate and target your audiences across both offline and online channels. We offer multiple delivery paths to support your business needs:"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pt-20", style: { display: "flex" } },
	            _react2.default.createElement(
	              "div",
	              { style: { width: "280px", borderRight: "solid 1px #EEEFF2" } },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Claritas Full Campaign Execution"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { display: "flex" } },
	                _react2.default.createElement(
	                  "div",
	                  { style: { padding: " 20px 10px 20px 0px" } },
	                  _react2.default.createElement("img", { src: "/images/claritas-email-logo.png", alt: "" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "pt-10 text-center" },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Email"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { padding: " 20px 10px 0px" } },
	                  _react2.default.createElement("img", { src: "/images/claritas-social-logo.png", alt: "" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "pt-10 text-center" },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Social"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { padding: " 20px 0px 20px 10px" } },
	                  _react2.default.createElement("img", { src: "/images/claritas-display-logo.png", alt: "" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "pt-10 text-center" },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Display"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "600px", marginLeft: "20px" } },
	              _react2.default.createElement(
	                "div",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Claritas can provide audiences for campaign execution:"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    borderBottom: "solid 1px #EEEFF2",
	                    paddingBottom: "20px",
	                    paddingTop: "20px",
	                    display: "flex"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "75px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Email - "
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Under certain circumstances, we will deliver active email addresses for campaign execution"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    borderBottom: "solid 1px #EEEFF2",
	                    paddingBottom: "20px",
	                    paddingTop: "20px"
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Social - "
	                ),
	                " We onboard audiences to your social platform of choice"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    borderBottom: "solid 1px #EEEFF2",
	                    paddingBottom: "20px",
	                    paddingTop: "20px"
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Display - "
	                ),
	                " We deliver audiences to your platform of choice for programmatic buying"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    paddingBottom: "20px",
	                    paddingTop: "20px"
	                  }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Direct Mail - "
	                ),
	                " We deliver full name and postal addresses of your audience"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                marginTop: "20px",
	                marginBottom: "20px",
	                paddingTop: "20px",
	                paddingBottom: "20px",
	                borderTop: "solid 1px #EEEFF2",
	                textAlign: "center"
	              }
	            },
	            "Find PRIZM\xAE Premier , P$YCLE\xAE Premier , and ConneXions\xAE segments available today across our vast digital partner network:"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { display: "flex", marginTop: "40px" } },
	            _react2.default.createElement(
	              "div",
	              { style: { width: "150px" } },
	              "\xA0"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "180px" } },
	              _react2.default.createElement("img", { src: "/images/liveRamp-logo.png", alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "160px" } },
	              _react2.default.createElement("img", { src: "/images/google-logo.png", alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "140px" } },
	              _react2.default.createElement("img", { src: "/images/oauth-logo.png", alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "150px" } },
	              _react2.default.createElement("img", { src: "/images/adobe-logo.png", alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "10%" } },
	              "\xA0"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "flex",
	                marginTop: "40px",
	                paddingBottom: "20px",
	                borderBottom: "solid 1px #EEEFF2"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { width: "180px" } },
	              "\xA0"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "250px" } },
	              _react2.default.createElement("img", { src: "/images/theTradeDesk-logo.png", alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "170px", marginTop: "-10px" } },
	              _react2.default.createElement("img", { src: "/images/mediaMath-logo.png", alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "150px" } },
	              _react2.default.createElement("img", { src: "/images/oracle-logo.png", alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { width: "10%" } },
	              "\xA0"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { padding: "20px 0 0" } },
	            _react2.default.createElement(
	              "div",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Contact us to discuss options and next steps"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { display: "flex", padding: "20px 0" } },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "100px" } },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Subject"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "780px" } },
	                _react2.default.createElement("input", {
	                  type: "text",
	                  style: {
	                    width: "100%",
	                    border: "solid 1px",
	                    padding: "10px"
	                  },
	                  value: this.state.subject,
	                  maxLength: "65",
	                  onChange: function onChange(e) {
	                    _this2.setState({ subject: e.target.value });
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { display: "flex", padding: "10px 0 20px" } },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "100px" } },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Comments"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "780px" } },
	                _react2.default.createElement("textarea", {
	                  className: "comment-box",
	                  rows: "6",
	                  style: {
	                    width: "100%",
	                    padding: "10px",
	                    overflowY: "auto"
	                  },
	                  value: this.state.comments,
	                  maxLength: "500",
	                  onChange: function onChange(e) {
	                    _this2.setState({ comments: e.target.value });
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "right", paddingRight: "10px" } },
	            this.props.request_error && _react2.default.createElement(
	              "div",
	              {
	                className: "pull-left ml-20 mt-5",
	                style: { fontWeight: "bold", color: "#FF0000" }
	              },
	              this.props.request_error
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn ",
	                onClick: function onClick() {
	                  _this2.props.onRequestActivationClose();
	                }
	              },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                disabled: (0, _isEmpty2.default)(this.state.comments) || (0, _isEmpty2.default)(this.state.subject),
	                className: "btn btn-claritas-default ml-20 mr-20",
	                onClick: this.submitActivation.bind(this)
	              },
	              "Submit"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActivateAudienceDialog;
	}(_MaterialUI2.default);
	
	exports.default = ActivateAudienceDialog;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(213);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _List = __webpack_require__(1141);
	
	var _List2 = _interopRequireDefault(_List);
	
	__webpack_require__(1433);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utility = __webpack_require__(14);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _lodash = __webpack_require__(18);
	
	var _reactGoogleMaps = __webpack_require__(243);
	
	var _Grid = __webpack_require__(19);
	
	var _CreateCampaign = __webpack_require__(531);
	
	var _CreateCampaign2 = _interopRequireDefault(_CreateCampaign);
	
	var _ActivateAudienceDialog = __webpack_require__(1139);
	
	var _ActivateAudienceDialog2 = _interopRequireDefault(_ActivateAudienceDialog);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _env = __webpack_require__(85);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pdfConverter = __webpack_require__(72);
	var html2canvas = __webpack_require__(71);
	var google = window.google;
	var PAGE_WIDTH = 186;
	
	var SegmentDetail = function (_Component) {
	  _inherits(SegmentDetail, _Component);
	
	  function SegmentDetail(props) {
	    _classCallCheck(this, SegmentDetail);
	
	    var _this = _possibleConstructorReturn(this, (SegmentDetail.__proto__ || Object.getPrototypeOf(SegmentDetail)).call(this, props));
	
	    _this.state = {
	      itemKey: ["Archive Date", "Creation Date", "Client", "Business Unit", "Attributes Selected", "Audience", "Reach by channel"],
	      list: [],
	      showDataLoadingDialog: false,
	      loadingText: "Segment data loading...",
	      ifCreateAudienceFile: false, // pop out the create audience file
	      openCreateCampaignDialog: false,
	      openArchiveDialog: false,
	      ifShowEmailSubCheckbox: false, // when email checkbox is selected change the value to `true`
	      ifReturnEmailChecked: false, // when `return file as hashed emails` checkbox is selected set value to `true`
	      ifSocialMediaChecked: false, // when `Social Media` checkbox is selected set value to `true`
	      socialMediaFacebook: false, // when `the social media's selection facebook` checkbox is selected set value to `true`
	      socialMediaGoogle: false, // when `the social media's selection google` checkbox is selected set value to `true`
	      ifDisplayChecked: false, // when `Display Advertising` checkbox is selected set value to `true`
	      createCampaign_segment_id: "",
	      createCampaign_clientId: "", // the client id for create campaign component
	      gmapIsReady: false,
	      disabledDlBtn: false,
	      showDownloadDialog: false,
	      showActivateDialog: false
	    };
	    return _this;
	  }
	
	  _createClass(SegmentDetail, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.props.clearSegmentSummary();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.fetchSegmentSummary(this.props.match.params.id);
	      if (parseInt(this.props.selected_client > 0)) {
	        this.props.loadAttributes(this.props.selected_client);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.clearSegmentSummary();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var itemobj = [];
	      var list = []; // for final array
	
	      if (nextProps.selected_client !== this.props.selected_client) {
	        this.props.loadAttributes(nextProps.selected_client);
	      }
	      if (nextProps.segment_summary) {
	        if (this.props.segment_summary) {
	          if (this.props.segment_summary.id !== nextProps.segment_summary.id) this.props.selectClient(nextProps.segment_summary.clientId);
	        } else {
	          this.props.selectClient(nextProps.segment_summary.clientId);
	          var rules = [];
	          (0, _lodash.map)(nextProps.segment_summary.rules, function (rule) {
	            rules.push({
	              attributeId: rule.attributeId,
	              values: rule.values
	            });
	          });
	          this.props.getSegmentRulesCounts({
	            rules: rules,
	            filtered: {
	              targetHouseholdsOnly: Boolean(nextProps.segment_summary.targetHouseholdsOnly)
	            }
	          }, nextProps.segment_summary.id);
	          this.props.getSegmentTotalCounts({
	            rules: rules,
	            filtered: {
	              targetHouseholdsOnly: Boolean(nextProps.segment_summary.targetHouseholdsOnly)
	            }
	          }, nextProps.segment_summary.id);
	        }
	        this.setState({
	          createCampaign_segment_id: nextProps.segment_summary.id,
	          createCampaign_clientId: nextProps.segment_summary.clientId
	        });
	      }
	      if (!(0, _lodash.isEmpty)(nextProps.active_segment_attributes)) {
	        var rawData = JSON.parse(nextProps.active_segment_attributes.rawData);
	        nextProps.segment_active_creation.selected_segments = rawData.selected_segments;
	        nextProps.segment_active_creation.plotted_values = rawData.plotted_values;
	        nextProps.segment_active_creation.selected_city = rawData.selected_city;
	        nextProps.segment_active_creation.selected_state = rawData.selected_state;
	        nextProps.segment_active_creation.selected_county = rawData.selected_county;
	        nextProps.segment_active_creation.selected_dma = rawData.selected_dma;
	        nextProps.segment_active_creation.zipcode = rawData.zipcode;
	        nextProps.segment_active_creation.segment_name = rawData.name;
	        nextProps.active_segment_attributes.rules.forEach(function (item) {
	          nextProps.segment_active_creation.rules_id.push({
	            id: item.id,
	            attributeId: item.attributeId
	          });
	        });
	        nextProps.segment_active_creation.segment_id = nextProps.active_segment_attributes.id;
	      }
	      if (nextProps.segment_summary && nextProps.value_typehead && nextProps.rules_count && (!this.props.segment_summary || !this.props.value_typehead || !this.props.rules_count) || !(0, _isEqual2.default)(nextProps.categories, this.props.categories)) {
	        nextProps.value_typehead.forEach(function (item) {
	          var obj = nextProps.segment_summary ? JSON.parse(nextProps.segment_summary.rawData) : null;
	          if (obj && obj.selected_segments) {
	            var queryArr = obj.selected_segments;
	            queryArr.forEach(function (id) {
	              if (item.id === id) {
	                itemobj.push(item);
	              }
	            });
	          }
	        });
	        if (nextProps.categories) {
	          nextProps.categories.forEach(function (item) {
	            item.attributes.forEach(function (attr) {
	              if (attr.values) {
	                var obj = JSON.parse(nextProps.segment_summary.rawData);
	                if (obj && obj.selected_segments) {
	                  attr.values.forEach(function (value) {
	                    obj.selected_segments.forEach(function (id) {
	                      var attributes = [];
	                      var attributes_values = [];
	                      if (parseInt(value.id, 10) === parseInt(id, 10)) {
	                        attributes_values.push(value);
	                        attributes.push({
	                          id: attr.id,
	                          name: attr.name,
	                          awId: attr.awId,
	                          values: attributes_values
	                        });
	                        var segmentAttr = (0, _lodash.find)(list, function (m) {
	                          return parseInt(m.id, 10) === parseInt(item.id, 10);
	                        });
	                        if (segmentAttr === undefined) {
	                          list.push({
	                            id: item.id,
	                            name: item.name,
	                            attributes: attributes
	                          });
	                        } else {
	                          var _attr = (0, _lodash.find)(segmentAttr.attributes, function (sattr) {
	                            return sattr.id === attr.id;
	                          });
	                          if (_attr === undefined) segmentAttr.attributes = segmentAttr.attributes.concat(attributes);else _attr.values = _attr.values.concat(attributes[0].values);
	                        }
	                      }
	                    });
	                  });
	                }
	              }
	              if (attr.subAttributes) {
	                var subAttributes = [];
	                var subAttributes_values = [];
	                attr.subAttributes.forEach(function (attr1) {
	                  attr1.values.forEach(function (value) {
	                    var obj = JSON.parse(nextProps.segment_summary.rawData);
	                    if (obj && obj.selected_segments) {
	                      obj.selected_segments.forEach(function (id) {
	                        if (value.id === id) {
	                          subAttributes_values.push({
	                            label: attr1.name + " - " + value.label,
	                            total: value.total,
	                            id: value.id
	                          });
	                          subAttributes.push({
	                            id: attr1.id,
	                            name: attr.name,
	                            parentId: attr1.parentId,
	                            values: subAttributes_values
	                          });
	                        }
	                      });
	                    }
	                  });
	                });
	                if (!(0, _lodash.isEmpty)(subAttributes)) {
	                  list.push({
	                    id: item.id,
	                    name: item.name,
	                    attributes: (0, _lodash.uniqBy)((0, _lodash.uniqBy)(subAttributes, function (att) {
	                      return att.id;
	                    }), function (attr) {
	                      return attr.parentId;
	                    })
	                  });
	                }
	              }
	            });
	          });
	          (0, _lodash.map)(list, function (l) {
	            (0, _lodash.map)(l.attributes, function (attr) {
	              var total = 0;
	              (0, _lodash.map)(attr.values, function (v) {
	                var vid = v.id.toString().substring(0, 3);
	                if (vid === "140" || vid === "150") {
	                  vid = v.id.toString().substring(0, 4);
	                }
	                var vCount = _this2.getAttributeCount(parseInt(vid, 10), v.label, nextProps);
	                v.total = vCount;
	                total += vCount;
	              });
	              attr["total"] = total;
	            });
	          });
	          //Auto make and model
	          (0, _lodash.map)(list, function (l) {
	            if (l.id === 7) {
	              (0, _lodash.map)(l.attributes, function (attr) {
	                if (attr.id === 605 || attr.id === 606) {
	                  var _l = (0, _lodash.find)(list, function (l) {
	                    return l.id === "605606";
	                  });
	                  if (_l) {
	                    _l.attributes.push(Object.assign({}, attr));
	                  } else {
	                    list.push(Object.assign({}, {
	                      id: "605606",
	                      name: attr.name,
	                      attributes: [Object.assign({}, attr)]
	                    }));
	                  }
	                }
	              });
	              (0, _lodash.remove)(l.attributes, function (attr) {
	                return attr.id === 605 || attr.id === 606;
	              });
	            }
	          });
	          (0, _lodash.remove)(list, function (l) {
	            return l.id === 7 && (0, _lodash.isEmpty)(l.attributes);
	          });
	          //dedup
	          var resultList = [];
	          (0, _lodash.forEach)((0, _lodash.groupBy)(list, function (l) {
	            return l.id;
	          }), function (val, key) {
	            var attrs = [];
	            (0, _lodash.map)(val, function (v) {
	              attrs = attrs.concat(v.attributes);
	            });
	            resultList.push({
	              id: parseInt(key, 10),
	              name: val[0].name,
	              attributes: attrs
	            });
	          });
	          this.setState({
	            list: resultList
	          });
	        }
	        this.setState({ showDataLoadingDialog: false });
	      } else {
	        if (!this.props.segment_summary || !this.props.rules_count) {
	          this.setState({
	            showDataLoadingDialog: true,
	            loadingText: "Segment data loading..."
	          });
	        }
	      }
	    }
	  }, {
	    key: "noRepeatArr",
	    value: function noRepeatArr(arr) {
	      return [].concat(_toConsumableArray(new Set(arr)));
	    }
	  }, {
	    key: "handleListClick",
	    value: function handleListClick(e) {
	      var parentNode = null;
	      if (e.target.nodeName === "SPAN" || e.target.nodeName === "STRONG") {
	        parentNode = e.target.parentNode.parentNode;
	      } else if (e.target.nodeName === "SECTION") {
	        parentNode = e.target.parentNode;
	      } else {
	        return;
	      }
	      if (parentNode.classList) {
	        parentNode.classList.toggle("active");
	      }
	    }
	  }, {
	    key: "handleMapMounted",
	    value: function handleMapMounted(map) {
	      this._map = map;
	      if (this._map && this._vector) {
	        try {
	          this._map.fitBounds(this._vector.getBounds());
	        } catch (ex) {}
	      }
	    }
	  }, {
	    key: "generateGeoContent",
	    value: function generateGeoContent() {
	      var result = "";
	      var segment_summary = this.props.segment_summary;
	
	      if (segment_summary) {
	        var rawData = JSON.parse(segment_summary.rawData);
	        if (rawData.plotted_values) {
	          var _rawData$plotted_valu = rawData.plotted_values,
	              addressLabel = _rawData$plotted_valu.addressLabel,
	              radius = _rawData$plotted_valu.radius,
	              driveTime = _rawData$plotted_valu.driveTime;
	
	
	          if (radius && addressLabel) {
	            result = radius + " MILE(S) FROM " + addressLabel;
	          }
	          if (driveTime && addressLabel) {
	            result = driveTime + " HOUR(S) DRIVE FROM " + addressLabel;
	          }
	          result = result.replace(",USA", "").replace(", USA", "").replace("USA", "");
	        }
	      }
	      return result;
	    }
	  }, {
	    key: "handleGoogleIdle",
	    value: function handleGoogleIdle() {
	      if (!this.state.gmapIsReady) {
	        this.setState({
	          gmapIsReady: true
	        });
	      }
	    }
	  }, {
	    key: "generateMapContent",
	    value: function generateMapContent() {
	      var _this3 = this;
	
	      var PlottedRadiusMap = null;
	      var segment_summary = this.props.segment_summary;
	
	      if (!segment_summary) return;
	      var raw = JSON.parse(segment_summary.rawData);
	      var doms = [];
	      if (!(0, _lodash.isEmpty)(raw.plotted_values)) {
	        var addressLabel = raw.plotted_values.addressLabel;
	
	        if (addressLabel) {
	          // geoText = driveTime ? 'GEOGRAPHIC : Drive ' + driveTime + ' Hour(s) From ' + addressLabel.replace(", United States", "") :
	          //   'GEOGRAPHIC : ' + radius + ' Mile(s) From ' + addressLabel.replace(", United States", "")
	        } else {
	          // geoText = "GEOGRAPHIC : AREA SELECTED"
	          var vector = null;
	          var plottedRadius = raw.plotted_values;
	          switch (plottedRadius.type) {
	            case "circle":
	              vector = _react2.default.createElement(_reactGoogleMaps.Circle, {
	                ref: function ref(elm) {
	                  return _this3._vector = elm;
	                },
	                center: plottedRadius.center,
	                radius: plottedRadius.radius,
	                options: (0, _utility.getMapVectorOptions)()
	              });
	              break;
	            case "polygon":
	              vector = _react2.default.createElement(_reactGoogleMaps.Polygon, {
	                ref: function ref(elm) {
	                  return _this3._vector = elm;
	                },
	                path: typeof plottedRadius.path === "string" ? google.maps.geometry.encoding.decodePath(plottedRadius.path) : plottedRadius.path,
	                options: (0, _utility.getMapVectorOptions)()
	              });
	              break;
	            case "rectangle":
	            default:
	              vector = _react2.default.createElement(_reactGoogleMaps.Rectangle, {
	                ref: function ref(elm) {
	                  return _this3._vector = elm;
	                },
	                bounds: plottedRadius.bounds,
	                radius: plottedRadius.radius,
	                options: (0, _utility.getMapVectorOptions)()
	              });
	              break;
	          }
	          if (vector) {
	            PlottedRadiusMap = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
	              return _react2.default.createElement(
	                _reactGoogleMaps.GoogleMap,
	                {
	                  zoom: plottedRadius.zoom,
	                  center: plottedRadius.center,
	                  onIdle: _this3.handleGoogleIdle.bind(_this3),
	                  defaultOptions: {
	                    streetViewControl: false,
	                    mapTypeControl: false,
	                    zoomControl: false,
	                    scrollwheel: false,
	                    draggable: false
	                  },
	                  ref: _this3.handleMapMounted.bind(_this3)
	                },
	                vector
	              );
	            });
	          }
	        }
	
	        var row = _react2.default.createElement(
	          "div",
	          { key: "geo-text-container", style: { width: "100%" } },
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              className: "no-padding geo-map-row-container",
	              style: { padding: 0 }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "12",
	                sm: "12",
	                md: "12",
	                lg: "12",
	                className: PlottedRadiusMap && "google_map_container no-padding",
	                style: { height: "228px" }
	              },
	              PlottedRadiusMap ? _react2.default.createElement(PlottedRadiusMap, {
	                containerElement: _react2.default.createElement("div", { style: { height: "100%" } }),
	                mapElement: _react2.default.createElement("div", { style: { height: "100%" } })
	              }) : null
	            )
	          )
	        );
	        doms.unshift(row);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          key: "map-view-container",
	          style: {
	            maxHeight: this.props && this.props.width > 1400 ? "480px" : "300px",
	            overflowX: "hidden",
	            overflowY: "auto",
	            width: "80%",
	            height: "230px",
	            lineHeight: "unset",
	            paddingLeft: "0px",
	            marginLeft: "-50px",
	            marginTop: "10px"
	          }
	        },
	        doms
	      );
	    }
	  }, {
	    key: "generateAutoContent",
	    value: function generateAutoContent(item) {
	      var _this4 = this;
	
	      var COLORS = ["#050505", "#1A4457", "#3487AD", "#5D9FBE", "#85B7CE", "#D6E7EF"];
	      var attrCount = (0, _lodash.reduce)(item.attributes, function (sum, attr) {
	        return sum += attr.values.length;
	      }, 0);
	      var result = item.attributes[0].values;
	      if (item.attributes.length < 1) return;
	      if (item.attributes.length > 1) {
	        result = item.attributes[0].values.concat(item.attributes[1].values);
	      } else {
	        result = item.attributes[0].values;
	      }
	      (0, _lodash.map)(result, function (o) {
	        var attrId = o.id.toString().startsWith("605") ? 605 : 606;
	        o.total = _this4.getAttributeCount(attrId, o.label);
	      });
	      return _react2.default.createElement(
	        "div",
	        { className: "demographic base", key: item.id },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "AUTO MAKE/MODEL (",
	          attrCount,
	          ")"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          result.map(function (item, index) {
	            return _react2.default.createElement(
	              "li",
	              {
	                className: "auto-make-list",
	                key: "li-" + item.id,
	                style: { marginTop: "-1px" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  key: "div-" + item.id,
	                  style: { height: "53px", marginBottom: "1px" }
	                },
	                _react2.default.createElement(
	                  "p",
	                  { className: "clearfix", ref: "pElement" },
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      className: "color-indicator",
	                      style: { background: COLORS[index % COLORS.length] }
	                    },
	                    "\xA0"
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "pull-left" },
	                    item.label
	                  ),
	                  _react2.default.createElement(
	                    "strong",
	                    { className: "pull-right" },
	                    (0, _utility.splitNumber)(item.total)()
	                  )
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: "getAttributeCount",
	    value: function getAttributeCount(attrId, attrVal, props) {
	      //attrId: 1: state, 3: city, 605: auto make, 606: automodel
	      var _ref = props ? props : this.props,
	          rules_count = _ref.rules_count;
	
	      var obj = (0, _lodash.find)(rules_count, function (el) {
	        return el.attributeId === attrId;
	      });
	      if (obj && obj.counts) {
	        if (attrId === 90 || attrId === 91)
	          //drive time/plotted radius
	          return obj.counts[0].value;
	        var countObj = (0, _lodash.find)(obj.counts, function (o) {
	          return o.key === attrVal || obj.attributeName + " - " + o.key === attrVal;
	        });
	        if (countObj) return countObj.value;
	      }
	      return 0;
	    }
	  }, {
	    key: "generateGeoAttributesContent",
	    value: function generateGeoAttributesContent() {
	      //return this.generateGeoContent()
	      var segment_summary = this.props.segment_summary;
	
	      if (segment_summary) {
	        var rawData = JSON.parse(this.props.segment_summary.rawData);
	        var plotted_values = rawData.plotted_values,
	            selected_city = rawData.selected_city,
	            selected_state = rawData.selected_state,
	            selected_county = rawData.selected_county,
	            selected_dma = rawData.selected_dma,
	            zipcode = rawData.zipcode;
	
	        if ((0, _lodash.isEmpty)(plotted_values) && (0, _lodash.isEmpty)(selected_city) && (0, _lodash.isEmpty)(selected_state) && (0, _lodash.isEmpty)(selected_county) && (0, _lodash.isEmpty)(selected_dma) && (0, _lodash.isEmpty)(zipcode)) return null;
	        if ((0, _lodash.isEmpty)(rawData.plotted_values)) {
	          var cityItems = selected_city.map(function (v) {
	            return _react2.default.createElement(
	              "div",
	              { key: v.id, style: { height: "53px", marginBottom: "1px" } },
	              _react2.default.createElement(
	                "p",
	                { className: "clearfix pl-10", ref: "pElement" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "pull-left", style: { fontWeight: "bold" } },
	                  v.state + " - " + v.label
	                )
	              )
	            );
	          });
	
	          var stateItems = selected_state.map(function (v) {
	            return _react2.default.createElement(
	              "div",
	              { key: v.id, style: { height: "53px", marginBottom: "1px" } },
	              _react2.default.createElement(
	                "p",
	                { className: "clearfix pl-10", ref: "pElement" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "pull-left", style: { fontWeight: "bold" } },
	                  v.label
	                )
	              )
	            );
	          });
	          var countyItems = selected_county.map(function (v) {
	            return _react2.default.createElement(
	              "div",
	              { key: v.id, style: { height: "53px", marginBottom: "1px" } },
	              _react2.default.createElement(
	                "p",
	                { className: "clearfix pl-10", ref: "pElement" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "pull-left", style: { fontWeight: "bold" } },
	                  v.label
	                )
	              )
	            );
	          });
	          var dmaItems = selected_dma.map(function (v) {
	            return _react2.default.createElement(
	              "div",
	              { key: v.id, style: { height: "53px", marginBottom: "1px" } },
	              _react2.default.createElement(
	                "p",
	                { className: "clearfix pl-10", ref: "pElement" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "pull-left", style: { fontWeight: "bold" } },
	                  v.value + " - " + v.label
	                )
	              )
	            );
	          });
	
	          var zipItems = zipcode.map(function (v) {
	            return _react2.default.createElement(
	              "div",
	              {
	                key: v.zipcode,
	                style: { height: "53px", marginBottom: "1px" }
	              },
	              _react2.default.createElement(
	                "p",
	                { className: "clearfix pl-10", ref: "pElement" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "pull-left", style: { fontWeight: "bold" } },
	                  v.zipcode
	                )
	              )
	            );
	          });
	          return _react2.default.createElement(
	            "div",
	            { className: "demographic base ", key: "geo-city-state-container" },
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Geography"
	            ),
	            _react2.default.createElement(
	              "ul",
	              null,
	              _react2.default.createElement(
	                "li",
	                {
	                  className: "active",
	                  key: "cities-li",
	                  style: {
	                    marginTop: "-1px",
	                    display: (0, _lodash.isEmpty)(selected_city) ? "none" : "block"
	                  }
	                },
	                _react2.default.createElement(
	                  "section",
	                  { className: "clearfix" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "pull-left" },
	                    "CITIES (",
	                    cityItems.length,
	                    ")"
	                  )
	                ),
	                cityItems,
	                _react2.default.createElement("div", { className: "arrow-down" })
	              ),
	              _react2.default.createElement(
	                "li",
	                {
	                  className: "active",
	                  key: "states-li",
	                  style: {
	                    marginTop: "-1px",
	                    display: (0, _lodash.isEmpty)(selected_state) ? "none" : "block"
	                  }
	                },
	                _react2.default.createElement(
	                  "section",
	                  { className: "clearfix" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "pull-left" },
	                    "STATES  (",
	                    stateItems.length,
	                    ")"
	                  )
	                ),
	                stateItems,
	                _react2.default.createElement("div", { className: "arrow-down" })
	              ),
	              _react2.default.createElement(
	                "li",
	                {
	                  className: "active",
	                  key: "counties-li",
	                  style: {
	                    marginTop: "-1px",
	                    display: (0, _lodash.isEmpty)(selected_county) ? "none" : "block"
	                  }
	                },
	                _react2.default.createElement(
	                  "section",
	                  { className: "clearfix" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "pull-left" },
	                    "COUNTIES (",
	                    countyItems.length,
	                    ")"
	                  )
	                ),
	                countyItems,
	                _react2.default.createElement("div", { className: "arrow-down" })
	              ),
	              _react2.default.createElement(
	                "li",
	                {
	                  className: "active",
	                  key: "dmas-li",
	                  style: {
	                    marginTop: "-1px",
	                    display: (0, _lodash.isEmpty)(selected_dma) ? "none" : "block"
	                  }
	                },
	                _react2.default.createElement(
	                  "section",
	                  { className: "clearfix" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "pull-left" },
	                    "DMA (",
	                    dmaItems.length,
	                    ")"
	                  )
	                ),
	                dmaItems,
	                _react2.default.createElement("div", { className: "arrow-down" })
	              ),
	              _react2.default.createElement(
	                "li",
	                {
	                  className: "active",
	                  key: "zipcode-li",
	                  style: {
	                    marginTop: "-1px",
	                    display: (0, _lodash.isEmpty)(zipcode) ? "none" : "block"
	                  }
	                },
	                _react2.default.createElement(
	                  "section",
	                  { className: "clearfix" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "pull-left" },
	                    "ZIPCODES  (",
	                    zipcode.length,
	                    ")"
	                  )
	                ),
	                zipItems,
	                _react2.default.createElement("div", { className: "arrow-down" })
	              )
	            )
	          );
	        } else {
	          var addressLabel = rawData.plotted_values.addressLabel;
	
	          if (!(0, _lodash.isNil)(addressLabel)) {
	            return _react2.default.createElement(
	              "div",
	              {
	                className: "demographic geography base",
	                key: "geo-address-container"
	              },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Geography"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  _List2.default,
	                  { itemName: "Location" },
	                  this.generateGeoContent()
	                )
	              )
	            );
	          } else {
	            return _react2.default.createElement(
	              "div",
	              {
	                className: " demographic base google-map no-padding-bottom",
	                key: "geo-plotted-radius-container"
	              },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Geography"
	              ),
	              _react2.default.createElement(
	                "li",
	                {
	                  className: "active",
	                  key: "plotted-values-map",
	                  style: { marginTop: "-1px" }
	                },
	                _react2.default.createElement(
	                  "section",
	                  { className: "clearfix no-border-bottom" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "pull-left" },
	                    "Plotted Radius"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: { height: "250px", width: "100%" } },
	                  this.generateMapContent()
	                ),
	                _react2.default.createElement("div", { className: "arrow-down" })
	              )
	            );
	          }
	        }
	      }
	    }
	  }, {
	    key: "_addPdfElements",
	    value: function _addPdfElements(attrsCanvas, pdf, top, pageWidth, fileName, ratio, client_name, bu_name, height, callback) {
	      (0, _lodash.map)(attrsCanvas, function (canva) {
	        /*
	        const canvaHeight = canva.height / ratio + top + 3;
	        if (canvaHeight >= 280) {
	          addPdfFooter(pdf);
	          pdf.addPage("a4", "p");
	          this._addPdfHeader(pdf, client_name, bu_name);
	          top = 30;
	          setTimeout(function() {
	            pdf.addImage(canva.toDataURL(), "PNG", 12, top, pageWidth, 0);
	            top += (canva.height * PAGE_WIDTH) / canva.width + 4;
	          }, 200);
	        } else {*/
	        pdf.addImage(canva.toDataURL(), "PNG", 12, top, pageWidth, 0);
	        top += canva.height * PAGE_WIDTH / canva.width + 4;
	        //}
	      });
	
	      if (height > 296) {
	        (0, _utility.addPdfFooter)(pdf, height - 15);
	      } else {
	        (0, _utility.addPdfFooter)(pdf);
	      }
	      setTimeout(function () {
	        pdf.save(fileName);
	        this.setState({ showDataLoadingDialog: false });
	        callback && callback();
	      }.bind(this), 5000);
	    }
	  }, {
	    key: "_addPdfHeader",
	    value: function _addPdfHeader(pdf, client_name, bu_name) {
	      pdf.setFillColor(127, 127, 127);
	      pdf.rect(0, 15, 210, 10, "F");
	
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(9);
	      pdf.setFontType("bold");
	      pdf.addImage((0, _utility.pdfReportHeaderDataUri)(), "PNG", 10.5, 3, 60, 0);
	      pdf.text(198, 8, (0, _moment2.default)().format("MMMM DD, YYYY"), null, null, "right");
	
	      pdf.setTextColor(255, 255, 255);
	      pdf.setFontType("bold");
	      pdf.text(12, 21, "Client:");
	      //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
	      pdf.setFontType("normal");
	      pdf.text(26, 21, client_name ? client_name.trim() : "");
	      //cm to inches
	      var start = 90; //46 + lenClientName.width * 0.3937 + 0.4
	      if (!(0, _lodash.isEmpty)(bu_name)) {
	        pdf.setFontType("bold");
	        pdf.text(start, 21, "Business Unit:");
	        start += 26.5;
	        pdf.setFontType("normal");
	        pdf.text(start, 21, bu_name ? bu_name.trim() : "");
	      }
	      pdf.setFillColor(255);
	      start = 12;
	      pdf.setTextColor(0, 0, 0);
	      pdf.setFontSize(10);
	      //pdf.text(12, 30, 'Campaigns  >  ' + campaignDetail.name );
	    }
	  }, {
	    key: "_downloadAsPDF",
	    value: function _downloadAsPDF() {
	      var _props = this.props,
	          segment_summary = _props.segment_summary,
	          clients = _props.clients,
	          client_info = _props.client_info;
	      //const clientName = client_info && client_info.name ? client_info.name : ""
	
	      var client_name = client_info.name;
	      var bu_name = "";
	      if (client_info.parentClientId) {
	        var parent_client = (0, _lodash.find)(clients, function (c) {
	          return c.id === client_info.parentClientId;
	        });
	        if (parent_client) {
	          client_name = parent_client.name;
	          bu_name = client_info.name;
	        }
	      }
	
	      var fileName = segment_summary.name + "_chart_report.pdf";
	      this.setState({
	        showDataLoadingDialog: true,
	        showDownloadDialog: false,
	        loadingText: "Downloading, please wait..."
	      });
	      var box = document.getElementById("main-box");
	      var viewportWidth = box.offsetWidth;
	      box.style.width = 1024 + "px";
	      //pdf.setFontSize(9);
	      var pageWidth = 186;
	      var summaryCanva = null;
	
	      var els = document.getElementsByClassName("base-info");
	      var isSummaryCanvaReady = false;
	      if (els.length > 0) {
	        var el = els[0];
	        // const tvWidth = viewportWidth;
	        // el.style.width = "1024px";
	        setTimeout(function () {
	          html2canvas(el, { logging: false }).then(function (canvas) {
	            summaryCanva = canvas;
	            isSummaryCanvaReady = true;
	            // el.style.width = tvWidth + "px";
	          });
	        }, 200);
	      }
	
	      var demoEls = document.getElementsByClassName("demographic");
	      var attrsCanvas = [];
	      var isAttrsCanvasReady = [];
	      (0, _lodash.map)((0, _lodash.filter)(demoEls, function (el) {
	        return !el.classList.contains("google-map");
	      }), function (el) {
	        if (!el.classList.contains("google-map")) {
	          isAttrsCanvasReady.push(false);
	          // const width = viewportWidth;
	          // el.style.width = "1024px";
	          setTimeout(function () {
	            html2canvas(el, { logging: false }).then(function (canva) {
	              attrsCanvas.push(canva);
	              isAttrsCanvasReady.shift();
	            });
	          }, 200);
	          // setTimeout(function() {
	          // el.style.width = width + "px";
	          // }, 100);
	        }
	      });
	      var _els = document.getElementsByClassName("google-map");
	
	      var height = 30;
	      if (els && els[0]) height += els[0].offsetHeight * PAGE_WIDTH / els[0].offsetWidth + 4;
	      if (_els && _els.length > 0) {
	        var _el = _els[0];
	        height += _el.offsetHeight * PAGE_WIDTH / _el.offsetWidth + 4;
	      }
	      (0, _lodash.map)(attrsCanvas, function (canva) {
	        height += canva.offsetHeight / (canva.offsetWidth / pageWidth) + 4;
	      });
	      (0, _lodash.map)(demoEls, function (canva) {
	        height += canva.offsetHeight / (canva.offsetWidth / pageWidth) + 4;
	      });
	      height += 30;
	      // if (viewportWidth < 1024) {
	      //   box.style.width = viewportWidth + 'px';
	      // }
	      var pdf = new pdfConverter("p", "mm", "a4");
	      if (height > 295) pdf = new pdfConverter("p", "mm", [210, height]);
	      pdf.setFont("helvetica");
	      pdf.setFontType("normal");
	
	      var top = 10;
	      var intervalId = setInterval(function () {
	        if (isSummaryCanvaReady === false || !(0, _lodash.isEmpty)(isAttrsCanvasReady)) {
	          console.log("PDF generating...");
	        } else {
	          clearInterval(intervalId);
	          pdf.setDrawColor(0, 123, 99);
	          setTimeout(function () {
	            this._addPdfHeader(pdf, client_name, bu_name);
	            top = 30;
	            pdf.addImage(summaryCanva.toDataURL(), "PNG", 12, top, pageWidth, 0);
	            var ratio = summaryCanva.height > 330 ? 1024 / pageWidth * 2 : summaryCanva.height > 300 ? 1024 / pageWidth * 1.2 : 1024 / pageWidth;
	            top += summaryCanva.height * PAGE_WIDTH / summaryCanva.width + 4;
	
	            if (_els.length > 0) {
	              var _el2 = _els[0];
	              // const w = viewportWidth;
	              // el.style.width = "1024px";
	
	              //FIX for gmap API > 3.33
	              var gmStyle = document.getElementsByClassName("gm-style");
	              var p = gmStyle[0].childNodes[0].childNodes[0];
	              var t = p.childNodes[4].childNodes[0];
	              var t1 = p.childNodes[0].childNodes[0].childNodes[0];
	              var t2 = p.childNodes[1].childNodes[0].childNodes[0];
	              [t, t1, t2].forEach(function (o) {
	                if (o) {
	                  var transform = o.style.transform;
	                  var comp = transform.split(","); //split up the transform matrix
	                  var mapleft = parseFloat(comp[4]); //get left value
	                  var maptop = parseFloat(comp[5]); //get top value
	                  o.style.transform = "none";
	                  o.style.left = mapleft + "px";
	                  o.style.top = maptop + "px";
	                }
	              });
	
	              html2canvas(_el2, {
	                proxy: _env.apiBaseUrl + "/proxy/images",
	                logging: false,
	                svgRendering: true,
	                useCORS: true,
	                allowTraint: false
	              }).then(function (canvas) {
	                pdf.addImage(canvas.toDataURL("image/png"), "PNG", 12, top, pageWidth, 0);
	                // el.style.width = w + "px";
	                top += canvas.height * PAGE_WIDTH / canvas.width + 4;
	
	                this._addPdfElements(attrsCanvas, pdf, top, pageWidth, fileName, ratio, client_name, bu_name, height, function () {
	                  box.style.width = viewportWidth + "px";
	                });
	              }.bind(this));
	            } else {
	              this._addPdfElements(attrsCanvas, pdf, top, pageWidth, fileName, ratio, client_name, bu_name, height, function () {
	                box.style.width = viewportWidth + "px";
	              });
	            }
	          }.bind(this), 100);
	        }
	      }.bind(this), 1000);
	    }
	  }, {
	    key: "transformArray",
	    value: function transformArray(array) {
	      var arr = [];
	      var rules_count = this.props.rules_count;
	
	      (0, _lodash.map)(array, function (item) {
	        var str = "";
	        var sub_str = "";
	        var name = "";
	        if (item.id === 605606) {
	          var count = 0;
	          var ds = "";
	          (0, _lodash.map)(item.attributes, function (attr) {
	            count += attr.values.length;
	            var rule = (0, _lodash.find)(rules_count, function (r) {
	              return r.attributeId === attr.id;
	            });
	            ds = rule.dataSource;
	            (0, _lodash.map)(attr.values, function (v) {
	              sub_str += "\"" + v.label + "\",\"" + v.total + "\", " + ds + "\r\n";
	            });
	          });
	          str = "AUTO MAKE/MODEL (" + count + "),Source Name,\r\n";
	          arr.push(str + sub_str + "\r\n");
	        } else {
	          name = item.name + ",,Source Name\r\n";
	          var result = name;
	          (0, _lodash.map)(item.attributes, function (attr) {
	            var rule = (0, _lodash.find)(rules_count, function (r) {
	              return r.attributeId === attr.id;
	            });
	            str = attr.name + "(" + (attr.values && attr.values.length) + "),\"" + attr.total + "\"," + rule.dataSource + "\r\n";
	            (0, _lodash.map)(attr.values, function (v) {
	              sub_str += "\"" + v.label + "\",\"" + v.total + "\"," + rule.dataSource + "\r\n";
	            });
	            result += str;
	            result += sub_str;
	            str = "";
	            sub_str = "";
	          });
	          arr.push(result + "\r\n");
	        }
	      });
	
	      return arr.join("");
	    }
	  }, {
	    key: "generateGeoString",
	    value: function generateGeoString() {
	      var _this5 = this;
	
	      var rules_count = this.props.rules_count;
	
	      var arr = [];
	      var ds = "";
	      (0, _lodash.map)(rules_count, function (r) {
	        var str = "";
	        var sub_str = "";
	        if (r.attributeId === 1 || r.attributeId === 2 || r.attributeId === 3 || r.attributeId === 4 || r.attributeId === 7) {
	          var audienceCount = 0;
	          (0, _lodash.map)(r.counts, function (count) {
	            sub_str += "\"" + count.key.replace(",", " ") + "\",\"" + count.value + "\", " + r.dataSource + "\r\n";
	            audienceCount += count.value;
	          });
	          str = r.attributeName + " (" + r.counts.length + "),\"" + audienceCount + "\"\r\n";
	          arr.push(str + sub_str + "\r\n");
	        }
	        if (r.attributeId === 90 || r.attributeId === 91) {
	          var segment_summary = _this5.props.segment_summary;
	
	          var rawData = JSON.parse(segment_summary.rawData);
	          var _rawData$plotted_valu2 = rawData.plotted_values,
	              addressLabel = _rawData$plotted_valu2.addressLabel,
	              radius = _rawData$plotted_valu2.radius,
	              driveTime = _rawData$plotted_valu2.driveTime;
	
	          if (r.attributeId === 91) {
	            str = " Custom Radius";
	          } else {
	            if (radius && addressLabel) {
	              str = radius + " MILE(S) FROM " + addressLabel;
	            }
	            if (driveTime && addressLabel) {
	              str = driveTime + " HOUR(S) DRIVE FROM " + addressLabel;
	            }
	            str = str.replace(",USA", "").replace(", USA", "").replace("USA", "");
	          }
	          str = "Location,\"" + str + "\"\nAudience Size,\"" + r.counts[0].value + "\"," + r.dataSource;
	          ds = r.dataSource;
	          arr.push(str + "\r\n");
	        }
	      });
	      if ((0, _lodash.isEmpty)(arr)) {
	        return "";
	      }
	      return "Geography,,Source Name,\r\n" + arr.join("");
	    }
	  }, {
	    key: "_downloadAsCSV",
	    value: function _downloadAsCSV() {
	      this.setState({
	        showDataLoadingDialog: true,
	        showDownloadDialog: false
	      });
	      var newLine = window.navigator.msSaveOrOpenBlob ? "\r\n" : "\n";
	      var csv_string = "";
	      var _props2 = this.props,
	          audience_total_count = _props2.audience_total_count,
	          segment_summary = _props2.segment_summary,
	          parent_client = _props2.parent_client;
	
	      var segmentName = "Audience Name," + this.formatNameTime(segment_summary.name) + newLine;
	      var creteDate = "Creation Date," + (0, _moment2.default)(segment_summary.createdTime).format("DD-MMM-YY") + newLine;
	      var client = "Client," + (segment_summary && (0, _lodash.isNil)(parent_client) ? segment_summary.clientName : (0, _lodash.isNil)(parent_client) ? "" : parent_client.name) + newLine;
	      var businessUnit = "Business Unit," + (parent_client ? segment_summary.clientName : "") + newLine;
	      var attributes = "Attributes Selected, " + segment_summary.rules.length + newLine;
	      var pdmLine = "Primary Decision Maker Selected, " + (segment_summary.targetHouseholdsOnly ? "Yes" : "No") + newLine;
	
	      var audience = "Audience, " + audience_total_count.total + newLine;
	      var reachByChannel = "Reach By Channel," + newLine;
	      var email = "Email, " + audience_total_count.email + newLine;
	      var social = "Social, " + audience_total_count.social + newLine;
	      var display = "Display, " + audience_total_count.display + newLine;
	
	      csv_string += segmentName;
	      csv_string += creteDate + client + businessUnit + attributes + pdmLine + audience + reachByChannel + email + social + display;
	      //  'Geography,\n' + location + audience + ',\n'
	      csv_string += "\r\n";
	      csv_string += this.generateGeoString();
	      csv_string += "\r\n";
	      csv_string += this.transformArray(this.state.list);
	      if (window.navigator.msSaveOrOpenBlob) {
	        csv_string = "\uFEFF" + csv_string;
	        var blob = new Blob([csv_string], {
	          type: "text/csv;charset=utf-8"
	        });
	        navigator.msSaveOrOpenBlob(blob, this.props.segment_summary.name + ".csv");
	      } else {
	        csv_string = "data:text/csv;charset=utf-8,\uFEFF" + encodeURIComponent(csv_string);
	        //let encodeUri = encodeURI(csv_string);
	        var link = document.createElement("a");
	
	        link.setAttribute("href", csv_string);
	        link.setAttribute("download", this.props.segment_summary.name + ".csv");
	        document.body.appendChild(link);
	        link.click();
	      }
	      this.setState({
	        showDataLoadingDialog: false
	      });
	    }
	  }, {
	    key: "handleConfirmArchive",
	    value: function handleConfirmArchive() {
	      var _this6 = this;
	
	      // for the multiple segment archived.
	      this.props.archiveSegment(this.props.segment_summary.id);
	      // set timeout for async call back.
	      window.setTimeout(function () {
	        _this6.props.getSegmentList(Object.assign({}, _this6.props.recordActiveQueryParamsObj, {
	          clientId: parseInt(_this6.props.selected_client, 10) >= 0 ? _this6.props.selected_client : null
	        }));
	        // when use `clear` as the only parameter, empty the arrary.
	        _this6.props.selectedSegment("clear");
	        _this6.props.history.push("/segments/list/archive");
	      }, 800);
	    }
	  }, {
	    key: "createAudienceFile",
	    value: function createAudienceFile() {
	      this.setState({
	        openCreateCampaignDialog: true
	      });
	    }
	  }, {
	    key: "closeCreateCampaignDialog",
	    value: function closeCreateCampaignDialog() {
	      this.setState({
	        openCreateCampaignDialog: false,
	        ifShowEmailSubCheckbox: false,
	        ifReturnEmailChecked: false,
	        ifSocialMediaChecked: false,
	        ifDisplayChecked: false,
	        socialMediaFacebook: false, // when `the social media's selection facebook` checkbox is selected set value to `true`
	        socialMediaGoogle: false
	      });
	      // rollback ifRequestSuccess value
	      this.props.rollbackRequestSuccessToFalse(false);
	      this.setState({
	        ifCreateAudienceFile: false
	      });
	    }
	  }, {
	    key: "handleEmailChecked",
	    value: function handleEmailChecked(e, isInputChecked) {
	      if (!isInputChecked) {
	        this.setState({
	          ifShowEmailSubCheckbox: isInputChecked,
	          ifReturnEmailChecked: isInputChecked
	        });
	      }
	      this.setState({
	        ifShowEmailSubCheckbox: isInputChecked
	      });
	    }
	  }, {
	    key: "handleReturnEmail",
	    value: function handleReturnEmail(e, isInputChecked) {
	      this.setState({
	        ifReturnEmailChecked: isInputChecked
	      });
	    }
	  }, {
	    key: "handleSocialMedia",
	    value: function handleSocialMedia(e, isInputChecked) {
	      this.setState({
	        ifSocialMediaChecked: isInputChecked
	      });
	      if (!isInputChecked) {
	        this.setState({
	          socialMediaFacebook: false,
	          socialMediaGoogle: false
	        });
	      } else {
	        this.setState({
	          socialMediaFacebook: true,
	          socialMediaGoogle: true
	        });
	      }
	    }
	  }, {
	    key: "handleSocialMediaAllChecked",
	    value: function handleSocialMediaAllChecked() {
	      this.setState({
	        socialMediaFacebook: true,
	        socialMediaGoogle: true
	      });
	    }
	  }, {
	    key: "handleFacebookCheck",
	    value: function handleFacebookCheck(e, isInputChecked) {
	      this.setState({
	        socialMediaFacebook: isInputChecked
	      });
	    }
	  }, {
	    key: "handleGoogleCheck",
	    value: function handleGoogleCheck(e, isInputChecked) {
	      this.setState({
	        socialMediaGoogle: isInputChecked
	      });
	    }
	  }, {
	    key: "handleDisplayCheck",
	    value: function handleDisplayCheck(e, isInputChecked) {
	      this.setState({
	        ifDisplayChecked: isInputChecked
	      });
	    }
	  }, {
	    key: "handleSelectAllCheckbox",
	    value: function handleSelectAllCheckbox() {
	      this.setState({
	        ifShowEmailSubCheckbox: true,
	        ifSocialMediaChecked: true,
	        ifDisplayChecked: true
	      });
	    }
	  }, {
	    key: "cbPDFChange",
	    value: function cbPDFChange(e, isInputChecked) {
	      var result = !this.refs.cbCSV.state.switched && !isInputChecked;
	      this.setState({ disabledDlBtn: result });
	    }
	  }, {
	    key: "cbCSVChange",
	    value: function cbCSVChange(e, isInputChecked) {
	      var result = !this.refs.cbPDF.state.switched && !isInputChecked;
	      this.setState({ disabledDlBtn: result });
	    }
	  }, {
	    key: "handleDownload",
	    value: function handleDownload(e) {
	      e.preventDefault();
	
	      if (this.refs.cbPDF.state.switched) {
	        this._downloadAsPDF();
	      }
	
	      if (this.refs.cbCSV.state.switched) {
	        this._downloadAsCSV();
	      }
	    }
	  }, {
	    key: "onRequestActivationClose",
	    value: function onRequestActivationClose() {
	      this.setState({
	        showActivateDialog: false
	      });
	    }
	  }, {
	    key: "formatNameTime",
	    value: function formatNameTime(name) {
	      if (typeof name !== "string") return name;
	      var originNames = name.match(/.*_(\d+)$/);
	      if (!originNames || !originNames[1] || originNames[1].length !== 8) return name;
	      var originName = originNames[1];
	      var year = originName.substr(0, 4);
	      var month = originName.substr(4, 2);
	      var day = originName.substr(6);
	      return name.replace(originName, "" + month + day + year);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      var _props3 = this.props,
	          audience_total_count = _props3.audience_total_count,
	          segment_summary = _props3.segment_summary;
	
	      var hasGmap = document.getElementsByClassName("geo-map-row-container").length > 0;
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "segment-detail", key: "segment-detail-key" },
	          _react2.default.createElement(
	            "div",
	            { id: "main-box" },
	            _react2.default.createElement(
	              "div",
	              { className: "segment-btns clearfix mb-20 text-right" },
	              _react2.default.createElement(
	                "div",
	                { className: "wrapper" },
	                _react2.default.createElement(_Button2.default, {
	                  title: "Download Report",
	                  handleClick: function handleClick(e) {
	                    e.preventDefault();
	                    _this7.setState({ showDownloadDialog: true });
	                  }
	                }),
	                _react2.default.createElement(_Button2.default, {
	                  title: "Activate Audience",
	                  handleClick: function handleClick(e) {
	                    e.preventDefault();
	                    _this7.setState({ showActivateDialog: true });
	                  },
	                  className: "ml-20"
	                }),
	                parseInt(this.props.roleId, 10) === 1 && _react2.default.createElement(_Button2.default, {
	                  title: "Create Audience File",
	                  handleClick: function handleClick(e) {
	                    e.preventDefault();
	                    _this7.createAudienceFile();
	                  },
	                  className: "ml-20"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "base-info base" },
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Audience"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  _List2.default,
	                  { itemName: "Audience Name" },
	                  this.props.segment_summary && this.props.segment_summary.name ? this.formatNameTime(this.props.segment_summary.name) : ""
	                ),
	                _react2.default.createElement(
	                  _List2.default,
	                  { itemName: "Creation Date" },
	                  this.props.segment_summary && this.props.segment_summary.createdTime && (0, _moment2.default)(this.props.segment_summary.createdTime).format("MMMM DD, YYYY")
	                ),
	                _react2.default.createElement(
	                  _List2.default,
	                  { itemName: "Archive Date" },
	                  segment_summary && segment_summary.archivedTime && (0, _moment2.default)(segment_summary.archivedTime).format("MMMM DD, YYYY")
	                ),
	                _react2.default.createElement(
	                  _List2.default,
	                  { itemName: "Client" },
	                  this.props.segment_summary && (0, _lodash.isNil)(this.props.parent_client) ? this.props.segment_summary.clientName : (0, _lodash.isNil)(this.props.parent_client) ? "" : this.props.parent_client.name
	                ),
	                _react2.default.createElement(
	                  _List2.default,
	                  { itemName: "Business Unit" },
	                  this.props.parent_client && this.props.segment_summary && this.props.segment_summary.clientName
	                ),
	                _react2.default.createElement(
	                  _List2.default,
	                  { itemName: "Attributes Selected" },
	                  this.props.segment_summary && this.props.segment_summary.rules.length
	                ),
	                _react2.default.createElement(
	                  _List2.default,
	                  { itemName: "Reach By Channel" },
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    _react2.default.createElement(
	                      "small",
	                      null,
	                      "Email: "
	                    ),
	                    audience_total_count && (0, _utility.splitNumber)(audience_total_count.email)()
	                  ),
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    _react2.default.createElement(
	                      "small",
	                      null,
	                      "Social/Display: "
	                    ),
	                    audience_total_count && (0, _utility.splitNumber)(audience_total_count.social)()
	                  ),
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    _react2.default.createElement(
	                      "small",
	                      null,
	                      "Direct Mail: "
	                    ),
	                    audience_total_count && (0, _utility.splitNumber)(audience_total_count.directMail)()
	                  )
	                )
	              )
	            ),
	            this.generateGeoAttributesContent(),
	            this.state.list.map(function (item) {
	              if (parseInt(item.id, 10) === 605606) {
	                return _this7.generateAutoContent(item);
	              } else return _react2.default.createElement(
	                "div",
	                { className: "demographic base", key: item.id },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  item.name
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  item.attributes.map(function (list, index) {
	                    return _react2.default.createElement(
	                      "li",
	                      {
	                        className: "active",
	                        key: list.id,
	                        style: { marginTop: "-1px" }
	                      },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "clearfix" },
	                        _react2.default.createElement(
	                          "span",
	                          { className: "pull-left" },
	                          list.name,
	                          " (",
	                          list.values && list.values.length || list.subAttributes && list.subAttributes.length,
	                          ")"
	                        )
	                      ),
	                      list.values && list.values.map(function (v) {
	                        var id = v.id.toString().substring(0, 3);
	                        if (id === "140" || id === "150") {
	                          id = v.id.toString().substring(0, 4);
	                        }
	                        return _react2.default.createElement(
	                          "div",
	                          {
	                            className: "attr-item",
	                            key: v.id,
	                            style: {
	                              height: "53px",
	                              marginBottom: "1px"
	                            }
	                          },
	                          _react2.default.createElement(
	                            "p",
	                            { className: "clearfix pl-10", ref: "pElement" },
	                            _react2.default.createElement(
	                              "span",
	                              { className: "pull-left" },
	                              v.label
	                            )
	                          )
	                        );
	                      }),
	                      _react2.default.createElement("div", { className: "arrow-down" })
	                    );
	                  })
	                )
	              );
	            }),
	            _react2.default.createElement(_CreateCampaign2.default, {
	              openCreateCampaignDialog: this.state.openCreateCampaignDialog,
	              closeCreateCampaignDialog: function closeCreateCampaignDialog() {
	                return _this7.closeCreateCampaignDialog();
	              },
	              ifShowEmailSubCheckbox: this.state.ifShowEmailSubCheckbox,
	              ifReturnEmailChecked: this.state.ifReturnEmailChecked,
	              handleEmailChecked: function handleEmailChecked(e, isInputChecked) {
	                return _this7.handleEmailChecked(e, isInputChecked);
	              },
	              handleReturnEmail: function handleReturnEmail(e, isInputChecked) {
	                return _this7.handleReturnEmail(e, isInputChecked);
	              },
	              handleSocialMedia: function handleSocialMedia(e, isInputChecked) {
	                return _this7.handleSocialMedia(e, isInputChecked);
	              },
	              ifSocialMediaChecked: this.state.ifSocialMediaChecked,
	              socialMediaFacebook: this.state.socialMediaFacebook,
	              socialMediaGoogle: this.state.socialMediaGoogle,
	              handleSocialMediaAllChecked: function handleSocialMediaAllChecked() {
	                return _this7.handleSocialMediaAllChecked();
	              },
	              handleFacebookCheck: function handleFacebookCheck(e, isInputChecked) {
	                return _this7.handleFacebookCheck(e, isInputChecked);
	              },
	              handleGoogleCheck: function handleGoogleCheck(e, isInputChecked) {
	                return _this7.handleGoogleCheck(e, isInputChecked);
	              },
	              handleDisplayCheck: function handleDisplayCheck(e, isInputChecked) {
	                return _this7.handleDisplayCheck(e, isInputChecked);
	              },
	              ifDisplayChecked: this.state.ifDisplayChecked,
	              handleSelectAllCheckbox: function handleSelectAllCheckbox() {
	                return _this7.handleSelectAllCheckbox();
	              },
	              createCampaign_segment_id: this.state.createCampaign_segment_id,
	              getCreateCampaign: this.props.getCreateCampaign // create campaign api function
	              , createCampaign_clientId: this.state.createCampaign_clientId,
	              create_campaign: this.props.create_campaign,
	              rollbackRequestSuccessToFalse: this.props.rollbackRequestSuccessToFalse
	            }),
	            _react2.default.createElement(
	              _Dialog2.default,
	              {
	                open: this.state.showDataLoadingDialog || hasGmap && !this.state.gmapIsReady,
	                style: { top: "-1.8em" },
	                overlayStyle: { opacity: 0.9, backgroundColor: "#666666" },
	                modal: true
	              },
	              _react2.default.createElement(
	                _Grid.Row,
	                { className: "mt-20" },
	                _react2.default.createElement(
	                  _Grid.Col,
	                  { xs: "7", sm: "7", md: "7", lg: "7", className: "text-right" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    this.state.loadingText
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Col,
	                  { xs: "1", sm: "1", md: "1", lg: "1" },
	                  _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Dialog2.default,
	              {
	                open: this.state.showDownloadDialog,
	                style: { top: "-1.8em" },
	                modal: true,
	                contentStyle: { width: "440px" }
	              },
	              _react2.default.createElement(
	                _Grid.FullRow,
	                {
	                  className: "no-margin-top no-padding text-center",
	                  style: { fontSize: "16px", color: "#000" }
	                },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Choose the type of file you would like to download"
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                {
	                  className: "no-padding-top no-padding-right no-padding-bottom no-margin-bottom",
	                  style: { paddingLeft: "150px" }
	                },
	                _react2.default.createElement(_Checkbox2.default, {
	                  iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	                  label: "PDF File",
	                  labelStyle: { fontSize: "14px" },
	                  defaultChecked: true,
	                  ref: "cbPDF",
	                  onCheck: function onCheck(e, isInputChecked) {
	                    return _this7.cbPDFChange(e, isInputChecked);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                {
	                  className: "no-padding-top no-padding-right no-padding-bottom",
	                  style: { paddingLeft: "150px" }
	                },
	                _react2.default.createElement(_Checkbox2.default, {
	                  iconStyle: { fill: "#47A1AB", marginRight: "10px" },
	                  label: "CSV File",
	                  labelStyle: { fontSize: "13px" },
	                  defaultChecked: false,
	                  ref: "cbCSV",
	                  onCheck: function onCheck(e, isInputChecked) {
	                    return _this7.cbCSVChange(e, isInputChecked);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "no-padding no-margin-bottom mt-20 text-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    onClick: function onClick() {
	                      return _this7.setState({ showDownloadDialog: false });
	                    },
	                    className: "btn btn-default btn-aa-info mr-20"
	                  },
	                  "Cancel"
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    onClick: this.handleDownload.bind(this),
	                    disabled: this.state.disabledDlBtn,
	                    className: "btn btn-default btn-aa-default"
	                  },
	                  "Download File"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Dialog2.default,
	              {
	                modal: false,
	                open: this.state.openArchiveDialog,
	                onRequestClose: function onRequestClose() {
	                  _this7.setState({ openArchiveDialog: false });
	                },
	                contentStyle: { width: "39%" }
	              },
	              _react2.default.createElement(
	                "p",
	                {
	                  style: {
	                    color: "black",
	                    textAlign: "center",
	                    fontSize: "16px",
	                    fontWeight: "bold"
	                  }
	                },
	                "Click confirm to archive this audience"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "btns",
	                  style: { textAlign: "center", marginTop: "1em" }
	                },
	                _react2.default.createElement(_FlatButton2.default, {
	                  label: "CANCEL",
	                  backgroundColor: "#FFF",
	                  labelStyle: { color: "black" },
	                  onClick: function onClick() {
	                    return _this7.setState({ openArchiveDialog: false });
	                  },
	                  hoverColor: "#FFF",
	                  className: "btn-aa-info mr-20"
	                }),
	                _react2.default.createElement(_FlatButton2.default, {
	                  label: "ARCHIVE SEGMENT",
	                  backgroundColor: "#DD0000",
	                  labelStyle: {
	                    color: "#FFF",
	                    padding: 0,
	                    verticalAlign: "inherit"
	                  },
	                  onClick: function onClick() {
	                    return _this7.handleConfirmArchive();
	                  },
	                  hoverColor: "#DD0000",
	                  className: "btn-aa-warning btn-aa-default btn-aa"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.FullRow,
	              { className: "text-right no-padding-top no-padding-right" },
	              _react2.default.createElement(_Button2.default, {
	                title: "Archive",
	                handleClick: function handleClick(e) {
	                  e.preventDefault();
	                  _this7.setState({ openArchiveDialog: true });
	                }
	              }),
	              _react2.default.createElement(_Button2.default, {
	                title: "Edit",
	                className: "ml-20",
	                handleClick: function handleClick(e) {
	                  e.preventDefault();
	                  _this7.props.getSegmentWithRules(_this7.props.segment_summary.id);
	                  _this7.props.selectClient(_this7.props.segment_summary.clientId);
	                },
	                disabled: this.props.roleId === 5
	              })
	            ),
	            _react2.default.createElement(_ActivateAudienceDialog2.default, {
	              open: this.state.showActivateDialog,
	              segment_summary: this.props.segment_summary,
	              request_error: this.props.request_activation_error,
	              request_success: this.props.request_activation_success,
	              key: this.props.segment_summary ? this.props.segment_summary.id : undefined,
	              submitActivateRequest: this.props.requestActivation,
	              onRequestActivationClose: this.onRequestActivationClose.bind(this)
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SegmentDetail;
	}(_react.Component);
	
	exports.default = SegmentDetail;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property itemName {string} item name
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property DOM
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List() {
	    _classCallCheck(this, List);
	
	    return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
	  }
	
	  _createClass(List, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "li",
	        { className: "segment-detail-list" },
	        _react2.default.createElement(
	          "span",
	          { style: { width: "180px" } },
	          this.props.itemName
	        ),
	        _react2.default.createElement(
	          "section",
	          { style: { textAlign: "right" } },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	exports.default = List;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(19);
	
	var _Expire = __webpack_require__(1165);
	
	var _Expire2 = _interopRequireDefault(_Expire);
	
	var _LinkButton = __webpack_require__(1167);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _SelectedAttrs = __webpack_require__(257);
	
	var _SelectedAttrs2 = _interopRequireDefault(_SelectedAttrs);
	
	var _moreHoriz = __webpack_require__(434);
	
	var _moreHoriz2 = _interopRequireDefault(_moreHoriz);
	
	var _materialUi = __webpack_require__(38);
	
	var _LimitExceeded = __webpack_require__(530);
	
	var _LimitExceeded2 = _interopRequireDefault(_LimitExceeded);
	
	var _lodash = __webpack_require__(18);
	
	var _utility = __webpack_require__(14);
	
	var _segment_util = __webpack_require__(261);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	__webpack_require__(124);
	
	__webpack_require__(1434);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Confirm = function (_Component) {
	  _inherits(Confirm, _Component);
	
	  function Confirm(props) {
	    _classCallCheck(this, Confirm);
	
	    var _this = _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call(this, props));
	
	    _this.state = {
	      width: 0,
	      editNameMode: false,
	      delay: 5,
	      openCancel: false,
	      segment_name: _this.props.segment_name,
	      disabledSaveBtn: false,
	      showSaveErrorDialog: false,
	      openContactForm: false,
	      showSuccessForm: false,
	      subject: "",
	      comments: ""
	    };
	    return _this;
	  }
	
	  _createClass(Confirm, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!this.props.selected_segments) window.location = "/segment/create";
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!this.props.selected_client || parseInt(this.props.selected_client, 10) < 1) {
	        window.location.href = "/";
	      }
	      var width = document.getElementById("Segment").clientWidth;
	      this.setState({ width: width });
	      if (!this.props.demoAttributes) {
	        this.props.loadAttributes(this.props.selected_client);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.save_segment_success === false && this.props.save_segment_success !== nextProps.save_segment_success) {
	        if (String(nextProps.save_segment_error_errorNo) === "422004") this.setState({
	          showSaveErrorDialog: true,
	          subject: "",
	          comments: "",
	          openContactForm: false
	        });
	      }
	      if (nextProps.request_assist_successful !== this.props.request_assist_successful) {
	        if (nextProps.request_assist_successful === true) {
	          this.setState({
	            showSuccessForm: true,
	            openContactForm: false,
	            showSaveErrorDialog: false
	          });
	        }
	      }
	    }
	  }, {
	    key: "removeSelectedVal",
	    value: function removeSelectedVal(id) {
	      var selected_segments = this.props.selected_segments;
	
	      var idx = selected_segments.indexOf(id);
	      if (idx >= 0) {
	        selected_segments.splice(idx, 1);
	        this.props.selectSegment(selected_segments);
	      }
	    }
	  }, {
	    key: "saveSegmentName",
	    value: function saveSegmentName(e) {
	      e.preventDefault();
	
	      this.props.verifySegmentName(this.props.selected_client, this.state.segment_name);
	      this.setState({ errorVisible: false });
	
	      setTimeout(function () {
	        if (this.props.isNameDuplicated === false) {
	          this.setState({
	            editNameMode: false,
	            delay: 2000,
	            errorVisible: false
	          });
	          this.props.setSegmentName(this.state.segment_name);
	        } else {
	          this.setState({ errorVisible: true, editNameMode: true });
	        }
	      }.bind(this), 1500);
	    }
	  }, {
	    key: "cancelSegmentNameUpdate",
	    value: function cancelSegmentNameUpdate(e) {
	      e.preventDefault();
	      this.setState({ editNameMode: false, delay: 5 });
	    }
	  }, {
	    key: "segmentNameComponent",
	    value: function segmentNameComponent() {
	      var _this2 = this;
	
	      if (this.state.editNameMode === true) {
	        return [_react2.default.createElement(
	          _Grid.Col,
	          {
	            key: "segment_name_update_1",
	            xs: "2",
	            sm: "2",
	            md: "2",
	            lg: "2",
	            className: "text-right",
	            style: { paddingRight: "12px" }
	          },
	          _react2.default.createElement(
	            _rcTooltip2.default,
	            {
	              visible: this.state.errorVisible,
	              animation: "zoom",
	              trigger: [],
	              arrowContent: _react2.default.createElement("div", { className: "rc-tooltip-arrow-inner" }),
	              placement: "top",
	              overlayStyle: { zIndex: 1000 },
	              overlay: _react2.default.createElement(
	                "span",
	                null,
	                "This segment name already exists, please enter a unique segment name to continue"
	              )
	            },
	            _react2.default.createElement("input", {
	              className: "pl-10",
	              placeholder: " Name this Segment",
	              style: { width: "100%" },
	              onFocus: function onFocus(e) {
	                e.preventDefault();
	                _this2.setState({ errorVisible: false });
	              },
	              onChange: function onChange(e) {
	                _this2.setState({ segment_name: e.target.value });
	              },
	              value: this.state.segment_name
	            })
	          )
	        ), _react2.default.createElement(
	          _Grid.Col,
	          {
	            key: "segment_name_update_2",
	            xs: "1",
	            sm: "1",
	            md: "1",
	            lg: "1",
	            className: "no-padding-left"
	          },
	          "\xA0\xA0",
	          _react2.default.createElement(
	            "a",
	            {
	              className: "text-size-small",
	              onClick: this.saveSegmentName.bind(this)
	            },
	            "Save"
	          ),
	          "\xA0\xA0",
	          _react2.default.createElement(
	            "a",
	            {
	              className: "text-size-small",
	              onClick: this.cancelSegmentNameUpdate.bind(this)
	            },
	            "Cancel"
	          )
	        )];
	      } else {
	        return [_react2.default.createElement(
	          _Grid.Col,
	          {
	            key: "segment_name_display_col",
	            xs: "2",
	            sm: "2",
	            md: "2",
	            lg: "2",
	            style: { overflow: "hidden", paddingRight: "12px" },
	            className: "text-right no-padding-left"
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { float: "right" }, className: "break-word-element" },
	            "\xA0\xA0",
	            this.props.segment_name
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                marginTop: "-10px",
	                overflow: "hidden",
	                borderBottom: "1px gray dashed"
	              }
	            },
	            "\xA0"
	          )
	        ), _react2.default.createElement(
	          _Grid.Col,
	          {
	            key: "segment_name_action_col",
	            xs: "1",
	            sm: "1",
	            md: "1",
	            lg: "1",
	            className: "no-padding-left"
	          },
	          _react2.default.createElement(
	            _Expire2.default,
	            { delay: this.state.delay, hasContainer: true },
	            _react2.default.createElement("i", { className: "icon-checkmark4 text-teal-400" }),
	            "\xA0\xA0\xA0\xA0"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this2.setState({ editNameMode: true });
	              }
	            },
	            _react2.default.createElement("i", { className: "icon-pencil4 text-teal-400" })
	          )
	        )];
	      }
	    }
	  }, {
	    key: "handleOpenCancelDialog",
	    value: function handleOpenCancelDialog(e, status) {
	      e.preventDefault();
	      this.setState({
	        openCancel: status,
	        cancelAnchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "calTotalAudience",
	    value: function calTotalAudience() {
	      var _props = this.props,
	          audience_total_count = _props.audience_total_count,
	          demoAttributes = _props.demoAttributes,
	          selected_segments = _props.selected_segments,
	          plotted_values = _props.plotted_values,
	          selected_state = _props.selected_state,
	          selected_city = _props.selected_city,
	          selected_dma = _props.selected_dma,
	          selected_county = _props.selected_county,
	          zipcode = _props.zipcode,
	          active_segment_attributes = _props.active_segment_attributes;
	
	      if (audience_total_count) return audience_total_count;
	      if (!(0, _lodash.isEmpty)(active_segment_attributes)) {
	        return {
	          total: active_segment_attributes.count,
	          email: active_segment_attributes.email,
	          display: active_segment_attributes.display,
	          social: active_segment_attributes.social
	        };
	      }
	      var result = { total: 0, email: 0, display: 0, social: 0 };
	      (0, _lodash.forEach)(selected_segments, function (sid) {
	        (0, _lodash.map)(demoAttributes, function (cat) {
	          (0, _lodash.map)(cat.attributes, function (segment) {
	            (0, _lodash.map)(segment.values, function (val) {
	              if (val.id === sid) {
	                result.total += parseInt(val.total, 10);
	                result.email += parseInt(val.email, 10);
	                result.social += parseInt(val.social, 10);
	                result.display += parseInt(val.display, 10);
	              }
	            });
	            (0, _lodash.map)(segment.subAttributes, function (subAttr) {
	              (0, _lodash.map)(subAttr.values, function (val) {
	                if (val.id === sid) {
	                  result.total += parseInt(val.total, 10);
	                  result.email += parseInt(val.email, 10);
	                  result.social += parseInt(val.social, 10);
	                  result.display += parseInt(val.display, 10);
	                }
	              });
	            });
	          });
	        });
	      });
	
	      if (plotted_values && plotted_values.audienceCount) {
	        result.total += parseInt(plotted_values.audienceCount.total, 10);
	        result.email += parseInt(plotted_values.audienceCount.email, 10);
	        result.social += parseInt(plotted_values.audienceCount.social, 10);
	        result.display += parseInt(plotted_values.audienceCount.display, 10);
	      }
	
	      result.total += this.computedStateOrCityAttibute(selected_state, "total") + this.computedStateOrCityAttibute(selected_city, "total") + this.computedStateOrCityAttibute(zipcode, "total") + this.computedStateOrCityAttibute(selected_county, "total") + this.computedStateOrCityAttibute(selected_dma, "total");
	      result.email += this.computedStateOrCityAttibute(selected_state, "email") + this.computedStateOrCityAttibute(selected_city, "email") + this.computedStateOrCityAttibute(zipcode, "email") + this.computedStateOrCityAttibute(selected_county, "email") + this.computedStateOrCityAttibute(selected_dma, "email");
	      result.social += this.computedStateOrCityAttibute(selected_state, "social") + this.computedStateOrCityAttibute(selected_city, "social") + this.computedStateOrCityAttibute(zipcode, "social") + this.computedStateOrCityAttibute(selected_county, "social") + this.computedStateOrCityAttibute(selected_dma, "social");
	      result.display += this.computedStateOrCityAttibute(selected_state, "display") + this.computedStateOrCityAttibute(selected_city, "display") + this.computedStateOrCityAttibute(zipcode, "display") + this.computedStateOrCityAttibute(selected_county, "display") + this.computedStateOrCityAttibute(selected_dma, "display");
	
	      return result;
	    }
	  }, {
	    key: "computedStateOrCityAttibute",
	    value: function computedStateOrCityAttibute(storeData, property) {
	      return storeData ? storeData.reduce(function (acc, curr) {
	        return acc + curr[property];
	      }, 0) : 0;
	    }
	  }, {
	    key: "saveSegment",
	    value: function saveSegment() {
	      if (this.state.disabledSaveBtn === true) return;else this.setState({ disabledSaveBtn: true });
	
	      var segmentName = this.props.segment_name;
	      var client_name = this.props.selected_client_name.split(" ").join("_");
	
	      if (this.props.segment_name.indexOf(client_name) < 0) segmentName = (client_name + "_" + this.props.segment_name + "_" + (0, _moment2.default)().format("YYYYMMDD")).split(" ").join("_");
	      var newSegment = (0, _segment_util.parseSegment)(this.props, segmentName);
	      this.props.setSegmentName(segmentName);
	      this.props.saveSegment(newSegment);
	    }
	  }, {
	    key: "removePlottedVal",
	    value: function removePlottedVal() {
	      this.props.setPlotValues({});
	    }
	  }, {
	    key: "openContactFormClick",
	    value: function openContactFormClick(e) {
	      e.preventDefault();
	      this.setState({
	        openContactForm: true,
	        showSaveErrorDialog: false
	      });
	    }
	  }, {
	    key: "onContactFormSubmit",
	    value: function onContactFormSubmit(e, subject, comments) {
	      e.preventDefault();
	      var postData = {
	        clientId: this.props.selected_client,
	        subject: subject.trim(),
	        comment: comments.trim(),
	        type: "upgrade",
	        originationPage: "Audience Segment Maximum Threshold Overlay Message"
	      };
	
	      this.props.sendAssistRequest(postData);
	    }
	  }, {
	    key: "cancelContactForm",
	    value: function cancelContactForm(e) {
	      e.preventDefault();
	      this.setState({
	        openContactForm: false,
	        showSaveErrorDialog: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          selected_segments = _props2.selected_segments,
	          plotted_values = _props2.plotted_values,
	          selected_state = _props2.selected_state,
	          selected_city = _props2.selected_city,
	          selected_dma = _props2.selected_dma,
	          selected_county = _props2.selected_county,
	          zipcode = _props2.zipcode;
	
	      var sltAttrCount = 0;
	      if (selected_segments) sltAttrCount += selected_segments.length;
	      if (!(0, _lodash.isEmpty)(plotted_values)) sltAttrCount += 1;
	      sltAttrCount += selected_state.length;
	      sltAttrCount += selected_city.length;
	      sltAttrCount += zipcode.length;
	      if (selected_county) sltAttrCount += selected_county.length;
	      if (selected_dma) sltAttrCount += selected_dma.length;
	      var hasSelectedSegments = sltAttrCount > 0;
	      var disabledSaveBtn = !hasSelectedSegments || this.props.segment_name === "" || this.state.editNameMode === true;
	      var isWideScreen = this.state.width > 1900;
	      return _react2.default.createElement(
	        "div",
	        { className: "no-padding no-margin" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Create an Audience Segment"
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "font-12em" },
	          "Review your inputs and selections you've made"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: isWideScreen ? "pl-20 pr-20 mt-20 pt-10 light-grey-background" : "pl-20 mt-20 pt-10 light-grey-background"
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-margin-bottom no-padding-bottom font-1em" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4", className: "no-padding-right" },
	              _react2.default.createElement(
	                "div",
	                { style: { float: "left" }, className: "text-teal-400" },
	                "Audience Segment\xA0\xA0\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "-10px",
	                    overflow: "hidden",
	                    borderBottom: "1px gray dashed"
	                  }
	                },
	                "\xA0"
	              )
	            ),
	            this.segmentNameComponent()
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-bottom no-margon-top pl-20 pr-20 font-1em" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4", className: "no-padding-right" },
	              _react2.default.createElement(
	                "div",
	                { style: { float: "left" }, className: "text-teal-400" },
	                "Client\xA0\xA0\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "-10px",
	                    overflow: "hidden",
	                    borderBottom: "1px gray dashed"
	                  }
	                },
	                "\xA0"
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "2",
	                sm: "2",
	                md: "2",
	                lg: "2",
	                className: "text-right no-padding-left",
	                style: { paddingRight: "12px", overflow: "hidden" }
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { float: "right" } },
	                "\xA0\xA0",
	                this.props.selected_client_name
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    marginTop: "-10px",
	                    overflow: "hidden",
	                    borderBottom: "1px gray dashed"
	                  }
	                },
	                "\xA0"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding no-margin" },
	            _react2.default.createElement("hr", null)
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: isWideScreen ? "pl-20 pr-20 light-grey-background" : "pl-20 light-grey-background"
	          },
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding-bottom no-margin-bottom no-margin-top no-padding-top" },
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Attributes",
	              _react2.default.createElement(
	                "span",
	                { className: "ml-5", style: { fontSize: "0.8em" } },
	                "(",
	                sltAttrCount,
	                ")"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding-bottom no-margin-bottom no-margin-top no-padding-top text-grey" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "5", sm: "5", md: "5", lg: "5" },
	              "ATTRIBUTE"
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "1",
	                sm: "1",
	                md: "1",
	                lg: "1",
	                className: "text-right",
	                style: { paddingRight: "12px" }
	              },
	              "COUNT"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "light-grey-background font-1em" },
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding no-margin" },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8", className: "no-padding-left" },
	              _react2.default.createElement(_SelectedAttrs2.default, {
	                selected_state: this.props.selected_state,
	                selected_city: this.props.selected_city,
	                selected_county: this.props.selected_county,
	                selected_dma: this.props.selected_dma,
	                clearAllSelectedState: this.props.clearAllSelectedState,
	                clearAllSelectedCity: this.props.clearAllSelectedCity,
	                clearAllCounty: this.props.clearAllCounty,
	                clearAllDMA: this.props.clearAllDMA,
	                selectState: this.props.selectState,
	                selectCity: this.props.selectCity,
	                selectCounty: this.props.selectCounty,
	                selectDMA: this.props.selectDMA,
	                selectedAttrs: this.props.selected_segments,
	                plottedRadius: this.props.plotted_values,
	                categories: this.props.demoAttributes,
	                width: this.state.width,
	                hideTitle: true,
	                removeAttribute: this.removeSelectedVal.bind(this),
	                removePlottedVal: this.removePlottedVal.bind(this),
	                zipcode: this.props.zipcode,
	                clearAllZipCode: this.props.clearAllZipCode,
	                clearZipCode: this.props.clearZipCode
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.FullRow,
	            { className: "no-padding no-margin pl-20 pr-20" },
	            _react2.default.createElement("hr", null)
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            { className: "no-padding no-margin pt-20 pl-20 " },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4", className: "pl-20" },
	              _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  "label",
	                  null,
	                  "Audience"
	                )
	              ),
	              _react2.default.createElement(_materialUi.Checkbox, {
	                style: {
	                  marginLeft: "40px",
	                  position: "absolute",
	                  display: "inline"
	                },
	                label: "Target Primary Decision Maker",
	                labelStyle: { width: "115%" },
	                defaultChecked: Boolean(this.props.targetHouseholdsOnly),
	                disabled: true
	              })
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "2",
	                sm: "2",
	                md: "2",
	                lg: "2",
	                className: "no-padding-left text-right",
	                style: { paddingRight: "20px" }
	              },
	              _react2.default.createElement(
	                "span",
	                { className: "text-default text-bold font-12em" },
	                (0, _utility.splitNumber)(this.calTotalAudience().total + "")()
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "2",
	                sm: "2",
	                md: "2",
	                lg: "2",
	                style: { marginLeft: "-10px" },
	                className: "no-padding-left text-center"
	              },
	              "Reach by Channel"
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4" },
	              _react2.default.createElement(
	                _Grid.Row,
	                { className: "no-padding pr-20" },
	                _react2.default.createElement(
	                  _Grid.Col,
	                  {
	                    xs: "4",
	                    sm: "4",
	                    md: "4",
	                    lg: "4",
	                    className: "no-padding-left no-padding-right"
	                  },
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    _react2.default.createElement("i", { className: "icon-envelope" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "ml-5 text-default text-bold" },
	                      (0, _utility.splitNumber)(this.calTotalAudience()["email"] + "")()
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Col,
	                  {
	                    xs: "4",
	                    sm: "4",
	                    md: "4",
	                    lg: "4",
	                    className: "no-padding-left no-padding-right"
	                  },
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    _react2.default.createElement("i", { className: "icon-share3" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "ml-5 text-default text-bold" },
	                      (0, _utility.splitNumber)(this.calTotalAudience()["social"] + "")()
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Col,
	                  {
	                    xs: "4",
	                    sm: "4",
	                    md: "4",
	                    lg: "4",
	                    className: "no-padding-left no-padding-right"
	                  },
	                  _react2.default.createElement(
	                    "p",
	                    { className: "pull-left" },
	                    _react2.default.createElement("i", { className: "icon-display4" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "ml-5 text-default text-bold" },
	                      (0, _utility.splitNumber)(this.calTotalAudience()["display"] + "")()
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                      className: "pull-right no-margin no-padding",
	                      style: { width: "24px", height: "24px" }
	                    },
	                    _react2.default.createElement(_moreHoriz2.default, {
	                      className: "text-grey-400",
	                      style: { width: "24px", height: "24px" }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Row,
	          { className: "pt-20" },
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "3", sm: "3", md: "3", lg: "3", style: { paddingLeft: "20px" } },
	            _react2.default.createElement(_LinkButton2.default, {
	              to: "/segment/create",
	              backgroundColor: (0, _utility.primaryColor)(),
	              labelColor: "#FFF",
	              label: "<\xA0Previous",
	              style: {
	                float: "left",
	                marginRight: "10px",
	                marginBottom: "10px",
	                marginTop: "20px",
	                backgroundColor: (0, _utility.primaryColor)()
	              }
	            }),
	            _react2.default.createElement(
	              _materialUi.Popover,
	              {
	                open: this.state.openCancel,
	                anchorEl: this.state.cancelAnchorEl,
	                anchorOrigin: { horizontal: "right", vertical: "top" },
	                targetOrigin: { horizontal: "left", vertical: "center" },
	                onRequestClose: this.handleRequestClose
	              },
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "text-default" },
	                "Are you sure you want to exit?",
	                _react2.default.createElement("br", null),
	                "Any selections you have made will not be saved",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "btn btn-link btn-sm cancel-btn mr-20",
	                    onClick: function onClick(e) {
	                      _this3.handleOpenCancelDialog(e, false);
	                    }
	                  },
	                  "Close"
	                ),
	                "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "btn btn-default btn-round btn-sm btn-aa-primary ml-20",
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      window.sessionStorage.setItem("clearAll", true);
	                      window.location = "/segments/list/active?cid=" + _this3.props.selected_client;
	                    }
	                  },
	                  "Yes, exit"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-link pull-left ",
	                style: { marginLeft: "10px" },
	                onClick: function onClick(e) {
	                  _this3.handleOpenCancelDialog(e, true);
	                }
	              },
	              "Cancel"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "9", sm: "9", md: "9", lg: "9", className: "text-right pr-20" },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              disabled: disabledSaveBtn || this.state.disabledSaveBtn,
	              backgroundColor: (0, _utility.primaryColor)(),
	              labelColor: "#FFF",
	              disabledBackgroundColor: "gray",
	              disabledLabelColor: "lightGray",
	              onTouchTap: this.saveSegment.bind(this),
	              style: { marginBottom: "10px", backgroundColor: (0, _utility.primaryColor)() },
	              label: "Save"
	            })
	          )
	        ),
	        _react2.default.createElement(_LimitExceeded2.default, {
	          showSaveErrorDialog: this.state.showSaveErrorDialog,
	          history: this.props.history,
	          showSuccessForm: this.state.showSuccessForm,
	          openContactForm: this.state.openContactForm,
	          roleId: this.props.roleId,
	          openContactFormClick: this.openContactFormClick.bind(this),
	          cancelContactForm: this.cancelContactForm.bind(this),
	          onContactFormSubmit: this.onContactFormSubmit.bind(this)
	        })
	      );
	    }
	  }]);
	
	  return Confirm;
	}(_react.Component);
	
	exports.default = Confirm;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _utility = __webpack_require__(14);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	var _uniq = __webpack_require__(301);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	__webpack_require__(1435);
	
	var _reactTooltipLite = __webpack_require__(339);
	
	var _reactTooltipLite2 = _interopRequireDefault(_reactTooltipLite);
	
	var _worker = __webpack_require__(1144);
	
	var _worker2 = _interopRequireDefault(_worker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// worker
	
	
	var styles = {
	  iconStyle: {
	    fill: (0, _utility.primaryColor)()
	  }
	};
	
	var AutoMake = function (_Component) {
	  _inherits(AutoMake, _Component);
	
	  function AutoMake(props) {
	    _classCallCheck(this, AutoMake);
	
	    var _this = _possibleConstructorReturn(this, (AutoMake.__proto__ || Object.getPrototypeOf(AutoMake)).call(this, props));
	
	    _this.myWorker = new Worker(_worker2.default);
	    _this.state = {
	      ifShowStyle: false,
	      activeBrandIndex: "",
	      clickedMakeLabel: "",
	      beSearchedMakeId: "",
	      beSearchedModelId: "",
	      ifAllModelSelected: false,
	      make_active_arr: [] // store make label match model
	    };
	    return _this;
	  }
	
	  _createClass(AutoMake, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var autoMake = this.props.demoAttributes.filter(function (item) {
	        return item.name === "Auto";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Auto Make/Model";
	      })[0].values;
	
	      // filter model for each brand
	      var model = this.props.demoAttributes.filter(function (item) {
	        return item.name === "Auto";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Auto Model";
	      })[0].values;
	      // .filter((item) => item.label.split(' - ')[0].toLowerCase() === this.state.clickedMakeLabel.toLowerCase())
	
	      // check have model be selected
	      var arr = [];
	      model.forEach(function (item) {
	        _this2.props.selected_segments.forEach(function (id) {
	          if (item.id === id) {
	            arr.push(item.label.split(" - ")[0]);
	          }
	        });
	      });
	      this.props.addMakeActive((0, _uniq2.default)(arr));
	
	      // filter the make from model list in arr array in index 0
	      var model_filter = [];
	      if ((0, _uniq2.default)(arr).length > 0) {
	        model_filter = model.filter(function (item) {
	          return item.label.split(" - ")[0].toLowerCase() === (0, _uniq2.default)(arr)[0].toLowerCase();
	        });
	      }
	      var make_index = [];
	      var model_index = [];
	      autoMake.forEach(function (item, index) {
	        _this2.props.selected_segments.forEach(function (makeId) {
	          if (makeId === item.id) {
	            make_index.push(index);
	          }
	        });
	      });
	
	      var makeObj = {
	        id: "",
	        label: ""
	      };
	      if (model_filter.length > 0) {
	        autoMake.forEach(function (make, index) {
	          if (make.label.split(" - ")[0].toLowerCase() === model_filter[0].label.split(" - ")[0].toLowerCase()) {
	            model_index.push(index);
	            makeObj.id = make.id;
	            makeObj.label = make.label;
	          }
	        });
	      }
	
	      // if make checkbox selected index lower
	      var liHeight = this.refs.autoMakeList.clientHeight;
	      if (make_index[0] < model_index[0]) {
	        this.refs.makeUl.scrollTop = liHeight * make_index[0];
	      } else if (make_index[0] > model_index[0]) {
	        // if make have model and index lower
	        this.refs.makeUl.scrollTop = liHeight * model_index[0];
	        this.handleBrandClick({
	          target: {
	            type: "text"
	          }
	        }, make_index[0], makeObj.label, makeObj.id);
	      }
	    }
	  }, {
	    key: "handleBrandClick",
	    value: function handleBrandClick(e, index, makeLabel, makeId) {
	      var _this3 = this;
	
	      // console.log(index)
	      // console.log(makeLabel)
	      // console.log(makeId)
	
	      if (e.target.type !== "checkbox") {
	        this.setState({
	          ifShowStyle: true,
	          activeBrandIndex: index,
	          clickedMakeLabel: makeLabel,
	          beSearchedMakeId: makeId
	        });
	        if (this.props.selected_make.some(function (item) {
	          return item.id === makeId;
	        })) {
	          this.setState({
	            ifAllModelSelected: true
	          });
	        } else {
	          this.setState({
	            ifAllModelSelected: false
	          });
	        }
	        var model = this.props.demoAttributes.filter(function (item) {
	          return item.name === "Auto";
	        })[0].attributes.filter(function (item) {
	          return item.name === "Auto Model";
	        })[0].values.filter(function (item) {
	          return item.label.split(" - ")[0].toLowerCase() === makeLabel.toLowerCase();
	        });
	
	        if (this.props.selected_segments.length > 0 && model.length > 0) {
	          var selected_model_position_index = [];
	          var model_position_id = [];
	          model.forEach(function (model, index) {
	            if (_this3.props.selected_segments.some(function (item) {
	              return item === model.id;
	            })) {
	              model_position_id.push(model.id);
	              selected_model_position_index.push(index);
	            }
	          });
	          window.setTimeout(function () {
	            var liHeight = _this3.refs["modelList"].clientHeight;
	            _this3.refs.modelUl.scrollTop = selected_model_position_index[0] * liHeight;
	            _this3.setState({
	              beSearchedModelId: model_position_id[0]
	            });
	          }, 300);
	        }
	      }
	    }
	  }, {
	    key: "chooseSegmentValues",
	    value: function chooseSegmentValues(id, ifAdd) {
	      var selected = this.props.selected_segments ? this.props.selected_segments : [];
	
	      if (ifAdd) {
	        selected.push(id);
	      } else {
	        var idx = selected ? selected.indexOf(id) : -1;
	        if (idx >= 0) {
	          selected.splice(idx, 1);
	        }
	      }
	      this.props.selectSegment(selected);
	    }
	    // handle automake check
	
	  }, {
	    key: "handleBrandSelected",
	    value: function handleBrandSelected(e, isInputChecked, makeObj) {
	      var _this4 = this;
	
	      this.props.selectMake(makeObj, isInputChecked);
	      this.chooseSegmentValues(makeObj.id, isInputChecked);
	
	      // const model = this.props.demoAttributes
	      //   .filter((item) => item.name === 'AUTO/TRANSPORT')[0].attributes
	      //   .filter((item) => item.name === 'Auto Model')[0].values
	      //   .filter((item) => item.label.split(' - ')[0].toLowerCase() === makeObj.label.toLowerCase())
	      if (isInputChecked) {
	        this.setState({
	          ifShowStyle: false,
	          beSearchedMakeId: ""
	        });
	        // web worker
	        this.myWorker.postMessage({
	          demoAttributes: this.props.demoAttributes,
	          makeObj: makeObj,
	          selected_segments: this.props.selected_segments
	        });
	        this.myWorker.onmessage = function (e) {
	          _this4.props.selectSegment(e.data);
	        };
	        // model.map((item) => {
	        //   this.chooseSegmentValues(item.id, !isInputChecked)
	        // })
	
	        this.props.addMakeActive(this.props.make_active_arr.filter(function (item) {
	          return item.toLowerCase() !== makeObj.label.toLowerCase();
	        }));
	      } else if (!isInputChecked) {
	        this.setState({
	          ifShowStyle: false
	        });
	      }
	    }
	    /**
	     * @param {Object} data the data of search
	     * @param {string} listTarget the value of ref for li element
	     * @param {string} parentTarget the value of ref for ul element
	     * @param {string} searchId the state's property for make/model
	     * @returns {null}
	     */
	
	  }, {
	    key: "handleMakeOrModelChange",
	    value: function handleMakeOrModelChange(selectedItem, data, listTarget, parentTarget, searchId) {
	      var _this5 = this;
	
	      var liHeight = this.refs[listTarget].clientHeight;
	      if (selectedItem.length > 0) {
	        data.forEach(function (make, index) {
	          if (make.id === selectedItem[0].id) {
	            // compute scrollTop
	            _this5.refs[parentTarget].scrollTop = index * liHeight;
	            if (searchId === "beSearchedMakeId") {
	              _this5.setState({
	                beSearchedMakeId: selectedItem[0].id
	              });
	            }
	            if (searchId === "beSearchedModelId") {
	              _this5.setState({
	                beSearchedModelId: selectedItem[0].id
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "handleModelSelected",
	    value: function handleModelSelected(e, isInputChecked, modelObj) {
	      var _this6 = this;
	
	      this.props.selectModel(modelObj, isInputChecked);
	      this.chooseSegmentValues(modelObj.id, isInputChecked);
	      this.setState({
	        beSearchedModelId: ""
	      });
	      var autoParent = this.props.demoAttributes.filter(function (item) {
	        return item.name === "Auto";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Auto Model";
	      })[0].values;
	      var arr = [];
	      autoParent.forEach(function (item) {
	        _this6.props.selected_segments.forEach(function (id) {
	          if (item.id === id) {
	            arr.push(item.label.split(" - ")[0]);
	          }
	        });
	      });
	      this.props.addMakeActive((0, _uniq2.default)(arr));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      // filter automake from demoAttributes
	      var autoMake = this.props.demoAttributes.filter(function (item) {
	        return item.name === "Auto";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Auto Make/Model";
	      })[0].values;
	      var makeGranularity = this.props.demoAttributes.filter(function (item) {
	        return item.name === "Auto";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Auto Make/Model";
	      })[0].granularity;
	      var modelGranularity = this.props.demoAttributes.filter(function (item) {
	        return item.name === "Auto";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Auto Model";
	      })[0].granularity;
	      // filter model for each brand
	      var model = this.props.demoAttributes.filter(function (item) {
	        return item.name === "Auto";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Auto Model";
	      })[0].values.filter(function (item) {
	        return item.label.split(" - ")[0].toLowerCase() === _this7.state.clickedMakeLabel.toLowerCase();
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "auto-make" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-6 col-md-6 col-sm-6 col-lg-6" },
	            _react2.default.createElement(
	              "div",
	              { className: "search clearfix" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-xs-11 col-md-11 col-sm-11 col-lg-11",
	                  style: { padding: 0, marginTop: "-5px" }
	                },
	                _react2.default.createElement(
	                  "span",
	                  { className: "input-group", style: { width: "100%" } },
	                  _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	                    labelKey: "label",
	                    multiple: false,
	                    placeholder: "Find an Auto Make",
	                    options: autoMake,
	                    onChange: function onChange(selectedItem) {
	                      return _this7.handleMakeOrModelChange(selectedItem, autoMake, "autoMakeList", "makeUl", "beSearchedMakeId");
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "form-control-feedback",
	                      style: { width: "54px" }
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-uppercase no-padding no-margin" },
	                      "search"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "brand-wrapper", ref: "makeUl" },
	              autoMake.map(function (item, index) {
	                return _react2.default.createElement(
	                  "li",
	                  {
	                    key: item.id,
	                    onClick: function onClick(e) {
	                      return _this7.handleBrandClick(e, index, item.label, item.id);
	                    },
	                    ref: "autoMakeList",
	                    className: item.id === _this7.state["beSearchedMakeId"] ? "active" : ""
	                  },
	                  _react2.default.createElement(_Checkbox2.default, {
	                    onCheck: function onCheck(e, isInputChecked) {
	                      return _this7.handleBrandSelected(e, isInputChecked, item);
	                    },
	                    label: _react2.default.createElement(
	                      _reactTooltipLite2.default,
	                      {
	                        content: _react2.default.createElement(
	                          "div",
	                          {
	                            className: "p-10 black-border",
	                            style: { background: "#FFF" }
	                          },
	                          makeGranularity
	                        ),
	                        direction: "right"
	                      },
	                      item.label
	                    ),
	                    iconStyle: styles.iconStyle,
	                    inputStyle: { width: "35px" },
	                    labelStyle: {
	                      fontSize: "15.6px",
	                      width: "auto",
	                      padding: "0 10px"
	                    },
	                    checked: _this7.props.selected_segments.some(function (list) {
	                      return list === item.id;
	                    })
	                  }),
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      className: "text-teal-400",
	                      style: {
	                        position: "absolute",
	                        top: "0",
	                        right: "3.1em",
	                        display: _this7.props.make_active_arr.some(function (list) {
	                          return list.toLowerCase() === item.label.toLowerCase();
	                        }) ? "inline" : "none"
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "icon-checkmark4 " })
	                  ),
	                  _react2.default.createElement(
	                    "small",
	                    {
	                      style: {
	                        display: _this7.state.activeBrandIndex === index && _this7.state.ifShowStyle ? "none" : "inline"
	                      }
	                    },
	                    ">"
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-xs-6 col-md-6 col-sm-6 col-lg-6",
	              style: { display: this.state.ifShowStyle ? "block" : "none" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "search clearfix" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-xs-12 col-md-12 col-sm-12 col-lg-12",
	                  style: { padding: 0, marginTop: "-5px" }
	                },
	                _react2.default.createElement(
	                  "span",
	                  { className: "input-group", style: { width: "100%" } },
	                  _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	                    labelKey: "label",
	                    multiple: false,
	                    placeholder: "Find " + ((0, _utility.isVowel)(this.state.clickedMakeLabel) ? "an" : "a") + " " + this.state.clickedMakeLabel + " Model",
	                    options: model,
	                    onChange: function onChange(selectedItem) {
	                      return _this7.handleMakeOrModelChange(selectedItem, model, "modelList", "modelUl", "beSearchedModelId");
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "form-control-feedback",
	                      style: { width: "54px" }
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-uppercase no-padding no-margin" },
	                      "search"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "model-wrapper", ref: "modelUl" },
	              model.map(function (item) {
	                return _react2.default.createElement(
	                  "li",
	                  {
	                    key: item.id,
	                    ref: "modelList",
	                    className: item.id === _this7.state["beSearchedModelId"] ? "active" : ""
	                  },
	                  _react2.default.createElement(_Checkbox2.default, {
	                    onCheck: function onCheck(e, isInputChecked) {
	                      return _this7.handleModelSelected(e, isInputChecked, item);
	                    },
	                    inputStyle: { width: "35px" },
	                    label: _react2.default.createElement(
	                      _reactTooltipLite2.default,
	                      {
	                        content: _react2.default.createElement(
	                          "div",
	                          {
	                            className: "p-10 black-border",
	                            style: { background: "#FFF" }
	                          },
	                          modelGranularity
	                        ),
	                        direction: "right"
	                      },
	                      item.label
	                    ),
	                    iconStyle: styles.iconStyle,
	                    labelStyle: { fontSize: "15.6px", width: "auto" },
	                    checked: _this7.props.selected_segments.some(function (model) {
	                      return model === item.id;
	                    }) || _this7.state.ifAllModelSelected
	                  })
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AutoMake;
	}(_react.Component);
	
	exports.default = AutoMake;

/***/ },
/* 1144 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var workercode = function workercode() {
	  self.onmessage = function (e) {
	    var model = e.data.demoAttributes.filter(function (item) {
	      return item.name === "Auto";
	    })[0].attributes.filter(function (item) {
	      return item.name === "Auto Model";
	    })[0].values.filter(function (item) {
	      return item.label.split(" - ")[0].toLowerCase() === e.data.makeObj.label.toLowerCase();
	    });
	
	    var selected = e.data.selected_segments ? e.data.selected_segments : [];
	
	    function chooseSegmentValues(id, ifAdd) {
	      if (ifAdd) {
	        selected.push(id);
	      } else {
	        var idx = selected ? selected.indexOf(id) : -1;
	        if (idx >= 0) {
	          selected.splice(idx, 1);
	        }
	      }
	    }
	
	    model.forEach(function (item) {
	      chooseSegmentValues(item.id, false);
	    });
	
	    self.postMessage(selected);
	  };
	};
	
	var code = workercode.toString();
	code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
	
	var blob = new Blob([code], { type: "application/javascript" });
	var worker_script = URL.createObjectURL(blob);
	
	exports.default = worker_script;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _utility = __webpack_require__(14);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	var _uniq = __webpack_require__(301);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	__webpack_require__(1436);
	
	var _worker = __webpack_require__(1146);
	
	var _worker2 = _interopRequireDefault(_worker);
	
	var _reactTooltipLite = __webpack_require__(339);
	
	var _reactTooltipLite2 = _interopRequireDefault(_reactTooltipLite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  iconStyle: {
	    fill: (0, _utility.primaryColor)()
	  }
	};
	
	var CultureCode = function (_Component) {
	  _inherits(CultureCode, _Component);
	
	  function CultureCode(props) {
	    _classCallCheck(this, CultureCode);
	
	    var _this = _possibleConstructorReturn(this, (CultureCode.__proto__ || Object.getPrototypeOf(CultureCode)).call(this, props));
	
	    _this.state = {
	      ifShowStyle: false,
	      activeBrandIndex: "",
	      clickedMakeLabel: "",
	      clickedValue: "",
	      beSearchedMakeId: "",
	      beSearchedModelId: "",
	      ifAllModelSelected: false,
	      make_active_arr: [] // store make label match model
	    };
	    return _this;
	  }
	
	  _createClass(CultureCode, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var autoMake = this.props.demoAttributes.filter(function (item) {
	        return item.name === "CultureCodes";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Region";
	      })[0].values;
	      // filter model for each brand
	      var model = this.props.demoAttributes.filter(function (item) {
	        return item.name === "CultureCodes";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Locale";
	      })[0].values;
	      // .filter((item) => item.label.split(' - ')[0].toLowerCase() === this.state.clickedMakeLabel.toLowerCase())
	
	      // check have model be selected
	      var arr = [];
	      model.forEach(function (item) {
	        _this2.props.selected_segments.forEach(function (id) {
	          if (item.id === id) {
	            arr.push(item.value);
	          }
	        });
	      });
	      this.props.addMakeActive((0, _uniq2.default)(arr));
	
	      // filter the make from model list in arr array in index 0
	      var model_filter = [];
	      if ((0, _uniq2.default)(arr).length > 0) {
	        model_filter = model.filter(function (item) {
	          return item.label.toLowerCase() === (0, _uniq2.default)(arr)[0].toLowerCase();
	        });
	      }
	      var make_index = [];
	      var model_index = [];
	      autoMake.forEach(function (item, index) {
	        _this2.props.selected_segments.forEach(function (makeId) {
	          if (makeId === item.id) {
	            make_index.push(index);
	          }
	        });
	      });
	
	      var makeObj = {
	        id: "",
	        label: ""
	      };
	      if (model_filter.length > 0) {
	        autoMake.forEach(function (make, index) {
	          if (make.label.split(" - ")[0].toLowerCase() === model_filter[0].label.split(" - ")[0].toLowerCase()) {
	            model_index.push(index);
	            makeObj.id = make.id;
	            makeObj.label = make.label;
	          }
	        });
	      }
	
	      // if make checkbox selected index lower
	      var liHeight = this.refs.autoMakeList.clientHeight;
	      if (make_index[0] < model_index[0]) {
	        this.refs.makeUl.scrollTop = liHeight * make_index[0];
	      } else if (make_index[0] > model_index[0]) {
	        // if make have model and index lower
	        this.refs.makeUl.scrollTop = liHeight * model_index[0];
	        this.handleBrandClick({
	          target: {
	            type: "text"
	          }
	        }, make_index[0], makeObj.label, makeObj.value, makeObj.id);
	      }
	    }
	  }, {
	    key: "handleBrandClick",
	    value: function handleBrandClick(e, index, makeLabel, makeValue, makeId) {
	      var _this3 = this;
	
	      // console.log(index)
	      // console.log(makeLabel)
	      // console.log(makeId)
	      if (e.target.type !== "checkbox") {
	        this.setState({
	          ifShowStyle: true,
	          activeBrandIndex: index,
	          clickedMakeLabel: makeLabel,
	          clickedValue: makeValue,
	          beSearchedMakeId: makeId
	        });
	        if (this.props.selected_make.some(function (item) {
	          return item.id === makeId;
	        })) {
	          this.setState({
	            ifAllModelSelected: true
	          });
	        } else {
	          this.setState({
	            ifAllModelSelected: false
	          });
	        }
	        var model = this.props.demoAttributes.filter(function (item) {
	          return item.name === "CultureCodes";
	        })[0].attributes.filter(function (item) {
	          return item.name === "Locale";
	        })[0].values.filter(function (item) {
	          return item.label.split(" - ")[0].toLowerCase() === makeLabel.toLowerCase();
	        });
	
	        if (this.props.selected_segments.length > 0 && model.length > 0) {
	          var selected_model_position_index = [];
	          var model_position_id = [];
	          model.forEach(function (model, index) {
	            if (_this3.props.selected_segments.some(function (item) {
	              return item === model.id;
	            })) {
	              model_position_id.push(model.id);
	              selected_model_position_index.push(index);
	            }
	          });
	          window.setTimeout(function () {
	            var liHeight = _this3.refs["modelList"].clientHeight;
	            _this3.refs.modelUl.scrollTop = selected_model_position_index[0] * liHeight;
	            _this3.setState({
	              beSearchedModelId: model_position_id[0]
	            });
	          }, 300);
	        }
	      }
	    }
	  }, {
	    key: "chooseSegmentValues",
	    value: function chooseSegmentValues(id, ifAdd) {
	      var selected = this.props.selected_segments ? this.props.selected_segments : [];
	
	      if (ifAdd) {
	        selected.push(id);
	      } else {
	        var idx = selected ? selected.indexOf(id) : -1;
	        if (idx >= 0) {
	          selected.splice(idx, 1);
	        }
	      }
	      this.props.selectSegment(selected);
	    }
	    // handle automake check
	
	  }, {
	    key: "handleBrandSelected",
	    value: function handleBrandSelected(e, isInputChecked, makeObj) {
	      var _this4 = this;
	
	      this.props.selectMake(makeObj, isInputChecked);
	      this.chooseSegmentValues(makeObj.id, isInputChecked);
	
	      // const model = this.props.demoAttributes
	      //   .filter((item) => item.name === 'AUTO/TRANSPORT')[0].attributes
	      //   .filter((item) => item.name === 'Auto Model')[0].values
	      //   .filter((item) => item.label.split(' - ')[0].toLowerCase() === makeObj.label.toLowerCase())
	      if (isInputChecked) {
	        this.setState({
	          ifShowStyle: false,
	          beSearchedMakeId: ""
	        });
	        this.props.selectSegment(e.data);
	
	        // web worker
	
	        this.myWorker.postMessage({
	          demoAttributes: this.props.demoAttributes,
	          makeObj: makeObj,
	          selected_segments: this.props.selected_segments
	        });
	        this.myWorker.onmessage = function (e) {
	          _this4.props.selectSegment(e.data);
	        };
	        // model.map((item) => {
	        //   this.chooseSegmentValues(item.id, !isInputChecked)
	        // })
	
	        this.props.addMakeActive(this.props.make_active_arr.filter(function (item) {
	          return item.toLowerCase() !== makeObj.label.toLowerCase();
	        }));
	      } else if (!isInputChecked) {
	        this.setState({
	          ifShowStyle: false
	        });
	      }
	    }
	    /**
	     * @param {Object} data the data of search
	     * @param {string} listTarget the value of ref for li element
	     * @param {string} parentTarget the value of ref for ul element
	     * @param {string} searchId the state's property for make/model
	     * @returns {null}
	     */
	
	  }, {
	    key: "handleMakeOrModelChange",
	    value: function handleMakeOrModelChange(selectedItem, data, listTarget, parentTarget, searchId) {
	      var _this5 = this;
	
	      var liHeight = this.refs[listTarget].clientHeight;
	      if (selectedItem.length > 0) {
	        data.forEach(function (make, index) {
	          if (make.id === selectedItem[0].id) {
	            // compute scrollTop
	            _this5.refs[parentTarget].scrollTop = index * liHeight;
	            if (searchId === "beSearchedMakeId") {
	              _this5.setState({
	                beSearchedMakeId: selectedItem[0].id
	              });
	            }
	            if (searchId === "beSearchedModelId") {
	              _this5.setState({
	                beSearchedModelId: selectedItem[0].id
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "handleModelSelected",
	    value: function handleModelSelected(e, isInputChecked, modelObj) {
	      var _this6 = this;
	
	      this.props.selectModel(modelObj, isInputChecked);
	      this.chooseSegmentValues(modelObj.id, isInputChecked);
	      this.setState({
	        beSearchedModelId: ""
	      });
	      var autoParent = this.props.demoAttributes.filter(function (item) {
	        return item.name === "CultureCodes";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Locale";
	      })[0].values;
	      var arr = [];
	      autoParent.forEach(function (item) {
	        _this6.props.selected_segments.forEach(function (id) {
	          if (item.id === id) {
	            arr.push(item.value.split(" - ")[0]);
	          }
	        });
	      });
	      this.props.addMakeActive((0, _uniq2.default)(arr));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      // filter automake from demoAttributes
	      var autoMake = this.props.demoAttributes.filter(function (item) {
	        return item.name === "CultureCodes";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Region";
	      })[0].values;
	      // filter model for each brand
	      var model = this.props.demoAttributes.filter(function (item) {
	        return item.name === "CultureCodes";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Locale";
	      })[0].values.filter(function (item) {
	        return item.value.split(" - ")[0] === _this7.state.clickedValue;
	      });
	      var regionGranularity = this.props.demoAttributes.filter(function (item) {
	        return item.name === "CultureCodes";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Region";
	      })[0].granularity;
	      var localeGranularity = this.props.demoAttributes.filter(function (item) {
	        return item.name === "CultureCodes";
	      })[0].attributes.filter(function (item) {
	        return item.name === "Locale";
	      })[0].granularity;
	      return _react2.default.createElement(
	        "div",
	        { className: "culture-code" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-6 col-md-6 col-sm-6 col-lg-6" },
	            _react2.default.createElement(
	              "div",
	              { className: "search clearfix" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-xs-11 col-md-11 col-sm-11 col-lg-11",
	                  style: { padding: 0, marginTop: "-5px" }
	                },
	                _react2.default.createElement(
	                  "span",
	                  { className: "input-group", style: { width: "100%" } },
	                  _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	                    labelKey: "label",
	                    multiple: false,
	                    placeholder: "Find a Region",
	                    options: autoMake,
	                    onChange: function onChange(selectedItem) {
	                      return _this7.handleMakeOrModelChange(selectedItem, autoMake, "autoMakeList", "makeUl", "beSearchedMakeId");
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-xs-1 col-md-1 col-sm-1 col-lg-1",
	                  style: { padding: 0, marginTop: "-5px" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "form-control-feedback",
	                    style: { width: "54px" }
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "text-uppercase no-padding no-margin" },
	                    "search"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "brand-wrapper", ref: "makeUl" },
	              autoMake.map(function (item, index) {
	                return _react2.default.createElement(
	                  "li",
	                  {
	                    key: item.id,
	                    onClick: function onClick(e) {
	                      return _this7.handleBrandClick(e, index, item.label, item.value, item.id);
	                    },
	                    ref: "autoMakeList",
	                    className: item.id === _this7.state["beSearchedMakeId"] ? "active" : ""
	                  },
	                  _react2.default.createElement(_Checkbox2.default, {
	                    onCheck: function onCheck(e, isInputChecked) {
	                      return _this7.handleBrandSelected(e, isInputChecked, item);
	                    },
	                    label: _react2.default.createElement(
	                      _reactTooltipLite2.default,
	                      {
	                        content: _react2.default.createElement(
	                          "div",
	                          {
	                            className: "p-10 black-border",
	                            style: { background: "#FFF" }
	                          },
	                          regionGranularity
	                        ),
	                        direction: "right"
	                      },
	                      item.label
	                    ),
	                    iconStyle: styles.iconStyle,
	                    inputStyle: { width: "35px" },
	                    labelStyle: {
	                      fontSize: "15.6px",
	                      width: "auto",
	                      padding: "0 10px"
	                    },
	                    checked: _this7.props.selected_segments.some(function (list) {
	                      return list === item.id;
	                    })
	                  }),
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      className: "text-teal-400",
	                      style: {
	                        position: "absolute",
	                        top: "0",
	                        right: "3.1em",
	                        display: _this7.props.make_active_arr.some(function (list) {
	                          return list.split(" - ")[0].toLowerCase() === item.value.toLowerCase();
	                        }) ? "inline" : "none"
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "icon-checkmark4 " })
	                  ),
	                  _react2.default.createElement(
	                    "small",
	                    {
	                      style: {
	                        display: _this7.state.activeBrandIndex === index && _this7.state.ifShowStyle ? "none" : "inline"
	                      }
	                    },
	                    ">"
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-xs-6 col-md-6 col-sm-6 col-lg-6",
	              style: { display: this.state.ifShowStyle ? "block" : "none" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "search clearfix" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-xs-9 col-md-9 col-sm-9 col-lg-9",
	                  style: { padding: 0, marginTop: "-5px" }
	                },
	                _react2.default.createElement(
	                  "span",
	                  { className: "input-group", style: { width: "100%" } },
	                  _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	                    labelKey: "label",
	                    multiple: false,
	                    placeholder: "Find " + ((0, _utility.isVowel)(this.state.clickedMakeLabel) ? "an" : "a") + " " + this.state.clickedMakeLabel + " Locale",
	                    options: model,
	                    onChange: function onChange(selectedItem) {
	                      return _this7.handleMakeOrModelChange(selectedItem, model, "modelList", "modelUl", "beSearchedModelId");
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-xs-3 col-md-3 col-sm-3 col-lg-3",
	                  style: { padding: 0, marginTop: "-5px" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "form-control-feedback",
	                    style: { width: "54px" }
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "text-uppercase no-padding no-margin" },
	                    "search"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "model-wrapper", ref: "modelUl" },
	              model.map(function (item) {
	                return _react2.default.createElement(
	                  "li",
	                  {
	                    key: item.id,
	                    ref: "modelList",
	                    className: item.id === _this7.state["beSearchedModelId"] ? "active" : ""
	                  },
	                  _react2.default.createElement(_Checkbox2.default, {
	                    onCheck: function onCheck(e, isInputChecked) {
	                      return _this7.handleModelSelected(e, isInputChecked, item);
	                    },
	                    label: _react2.default.createElement(
	                      _reactTooltipLite2.default,
	                      {
	                        content: _react2.default.createElement(
	                          "div",
	                          {
	                            className: "p-10 black-border",
	                            style: { background: "#FFF" }
	                          },
	                          localeGranularity
	                        ),
	                        direction: "right"
	                      },
	                      item.label
	                    ),
	                    iconStyle: styles.iconStyle,
	                    labelStyle: { fontSize: "15.6px", width: "auto" },
	                    inputStyle: { width: "35px" },
	                    checked: _this7.props.selected_segments.some(function (model) {
	                      return model === item.id;
	                    }) || _this7.state.ifAllModelSelected
	                  })
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CultureCode;
	}(_react.Component);
	
	exports.default = CultureCode;

/***/ },
/* 1146 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var workercode = function workercode() {
	  self.onmessage = function (e) {
	    var model = e.data.demoAttributes.filter(function (item) {
	      return item.name === "CultureCodes";
	    })[0].attributes.filter(function (item) {
	      return item.name === "Auto Model";
	    })[0].values.filter(function (item) {
	      return item.label.split(" - ")[0].toLowerCase() === e.data.makeObj.label.toLowerCase();
	    });
	
	    var selected = e.data.selected_segments ? e.data.selected_segments : [];
	
	    function chooseSegmentValues(id, ifAdd) {
	      if (ifAdd) {
	        selected.push(id);
	      } else {
	        var idx = selected ? selected.indexOf(id) : -1;
	        if (idx >= 0) {
	          selected.splice(idx, 1);
	        }
	      }
	    }
	
	    model.forEach(function (item) {
	      chooseSegmentValues(item.id, false);
	    });
	
	    self.postMessage(selected);
	  };
	};
	
	var code = workercode.toString();
	code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
	
	var blob = new Blob([code], { type: "application/javascript" });
	var worker_script = URL.createObjectURL(blob);
	
	exports.default = worker_script;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RadioButton = __webpack_require__(107);
	
	var _TextField = __webpack_require__(154);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Checkbox = __webpack_require__(41);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _RaisedButton = __webpack_require__(304);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	var _remove = __webpack_require__(188);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _uniq = __webpack_require__(301);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _groupBy = __webpack_require__(150);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _difference = __webpack_require__(663);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	var _utility = __webpack_require__(14);
	
	var _CircularProgress = __webpack_require__(690);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	__webpack_require__(1437);
	
	var _constants = __webpack_require__(1516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// primary color for material-ui
	
	// progress
	
	
	//performance
	
	var styles = {
	  raidoIcon: {
	    color: "black"
	  },
	  divider: {
	    borderBottom: "1px solid black",
	    marginBottom: "6px"
	  },
	  iconStyle: {
	    fill: (0, _utility.primaryColor)()
	  },
	  textareaUnderlineStyle: {
	    borderBottom: "1px solid red"
	  },
	  rootElementStyle: {
	    height: "400px"
	  },
	  btnStyle: {
	    background: (0, _utility.primaryColor)(),
	    color: "#FFF"
	  },
	  searchStyle: {
	    borderColor: (0, _utility.primaryColor)()
	  }
	};
	
	var AddLocation = function (_Component) {
	  _inherits(AddLocation, _Component);
	
	  function AddLocation(props) {
	    _classCallCheck(this, AddLocation);
	
	    var _this = _possibleConstructorReturn(this, (AddLocation.__proto__ || Object.getPrototypeOf(AddLocation)).call(this, props));
	
	    _this.flag = true; // controll state bg for first time
	    _this.state = {
	      checkedState: !(0, _isEmpty2.default)(props.selected_state) || !(0, _isEmpty2.default)(props.selected_city),
	      checkedZip: !(0, _isEmpty2.default)(props.zipcode),
	      checkedDMA: !(0, _isEmpty2.default)(props.selected_dma),
	      checkedCounty: !(0, _isEmpty2.default)(props.selected_county),
	      stateActiveIndex: "",
	      ifShowRightPanel: "", // show right panel when middle panel was selected
	      beSearchedCityId: "",
	      selectedStateLabel: "", // for searchbar placeholder
	      stateCounties: [],
	      stateDMAs: [],
	      selectedStateId: "",
	      ifallCitiesSelected: false,
	      ifZipcodeValid: true,
	      zipcode: "",
	      checkUserSelectedState: [],
	      stateAndCityTipStatus: false,
	      inValidZips: [],
	      selectedStateCounties: []
	    };
	    return _this;
	  }
	
	  _createClass(AddLocation, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.state.checkedCounty && this.props.selected_county.length > 0) {}
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      // when selected_city length > 0 implement filter function
	      if (nextProps.all_state_cities.length > 0 && (nextProps.selected_city.length > 0 || nextProps.selected_state.length > 0)) {
	        this.citySelectedStateChecked(nextProps);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // if (this.props.selected_city.length === 0) {
	      //   this.flag = false
	      // }
	      setTimeout(function () {
	        if (this.state.checkedState) this.refs.stateUI.style.borderBottom = "1px solid black";else if (this.state.checkedCounty) this.refs.countyUI.style.borderBottom = "1px solid black";else if (this.state.checkedDMA) this.refs.dmaUI.style.borderBottom = "1px solid black";
	      }.bind(this), 900);
	      if (this.props.selected_city.length > 0 || this.props.selected_state.length > 0) {
	        this.setState({
	          checkedState: true
	        });
	      }
	      if (this.props.zipcode.length > 0) {
	        this.setState({
	          checkedZip: true
	        });
	      }
	      var arr = [];
	      // filter the selected state for segment list
	      var all_state_cities = this.props.all_state_cities;
	      if (all_state_cities && all_state_cities instanceof Array) {
	        all_state_cities.forEach(function (item) {
	          _this2.props.selected_city.forEach(function (city) {
	            item.cities.forEach(function (index) {
	              if (index.id === city.id) {
	                arr.push(item.state);
	              }
	            });
	          });
	        });
	      }
	
	      var state_index = []; // for state select
	      var state_city_index = []; // for select city
	      if (this.props.allStates) {
	        this.props.allstates.forEach(function (item, index) {
	          _this2.props.selected_state.forEach(function (list) {
	            if (list.id === item.id) {
	              state_index.push(index);
	            }
	          });
	          arr.forEach(function (list) {
	            if (list.id === item.id) {
	              state_city_index.push(index);
	            }
	          });
	        });
	      }
	
	      if (state_index[0] > state_city_index[0] || typeof state_index[0] === "undefined" && typeof state_city_index[0] === "number") {
	        // state has city in the front and call click function
	        this.handleShowStateCities({
	          target: {
	            value: "text"
	          }
	        }, arr[0].id, arr[0].label, state_city_index[0], arr);
	      } else if (state_index[0] < state_city_index[0] || typeof state_index[0] === "number" && typeof state_city_index[0] === "undefined") {
	        // state select in the front and call click function
	        this.handleShowStateCities({
	          target: {
	            value: "text"
	          }
	        }, this.props.selected_state[0].id, this.props.selected_state[0].label, state_index[0]);
	      }
	    }
	  }, {
	    key: "citySelectedStateChecked",
	    value: function citySelectedStateChecked(_ref) {
	      var _this3 = this;
	
	      var all_state_cities = _ref.all_state_cities,
	          selected_city = _ref.selected_city;
	
	      var arr = [];
	      // filter the selected state for segment list
	      all_state_cities.forEach(function (item) {
	        selected_city.forEach(function (city) {
	          item.cities.forEach(function (index) {
	            if (index.id === city.id) {
	              arr.push(item.state.id);
	            }
	          });
	        });
	      });
	      this.setState({
	        checkUserSelectedState: arr
	      }, function () {
	        // position state list
	        var state_index = []; // for state select
	        var state_city_index = []; // for select city
	        _this3.props.allstates.forEach(function (item, index) {
	          _this3.props.selected_state.forEach(function (list) {
	            if (list.id === item.id) {
	              state_index.push(index);
	            }
	          });
	          _this3.state.checkUserSelectedState.forEach(function (list) {
	            if (list === item.id) {
	              state_city_index.push(index);
	            }
	          });
	        });
	        var liHeight = _this3.refs.stateList.clientHeight;
	
	        if (state_index[0] > state_city_index[0] || typeof state_index[0] === "undefined" && typeof state_city_index[0] === "number") {
	          // when city selected
	          if (_this3.flag) {
	            _this3.setState({
	              stateActiveIndex: state_city_index[0], // add background for state label when city has been selected
	              ifShowRightPanel: true
	            });
	            if (_this3.state.checkedState) {
	              _this3.refs.stateUI.scrollTop = liHeight * state_city_index[0];
	            } else if (_this3.state.checkedCounty) {
	              _this3.refs.countyUI.scrollTop = liHeight * state_city_index[0];
	            } else if (_this3.state.checkedDMA) {
	              _this3.refs.dmaUI.scrollTop = liHeight * state_city_index[0];
	            }
	            _this3.flag = false;
	          }
	        } else if (state_index[0] < state_city_index[0] || typeof state_index[0] === "number" && typeof state_city_index[0] === "undefined") {
	          // when state selected
	          if (_this3.flag) {
	            _this3.setState({
	              stateActiveIndex: "",
	              ifShowRightPanel: false
	            });
	            if (_this3.state.checkedState) {
	              _this3.refs.stateUI.scrollTop = liHeight * state_index[0];
	            } else if (_this3.state.checkedCounty) {
	              _this3.refs.countyUI.scrollTop = liHeight * state_index[0];
	            } else if (_this3.state.checkedDMA) {
	              _this3.refs.dmaUI.scrollTop = liHeight * state_index[0];
	            }
	            _this3.flag = false;
	          }
	        }
	      });
	    }
	  }, {
	    key: "handleRadio",
	    value: function handleRadio(e) {
	      e.stopPropagation();
	      switch (e.target.value) {
	        case "state":
	          this.setState({
	            checkedState: true,
	            checkedZip: false,
	            checkedCounty: false,
	            checkedDMA: false,
	            stateAndCityTipStatus: true,
	            selectedStateLabel: "",
	            selectedStateId: ""
	          });
	          this.props.clearAllZipCode();
	          this.props.clearMapPlotted();
	          this.props.clearAllDMA();
	          this.props.clearAllCounty();
	          break;
	        case "zip":
	          this.setState({
	            checkedZip: true,
	            checkedState: false,
	            checkedCounty: false,
	            checkedDMA: false,
	            ifShowRightPanel: "",
	            stateAndCityTipStatus: false,
	            selectedStateLabel: "",
	            selectedStateId: ""
	          });
	          this.props.clearMapPlotted();
	          this.props.clearAllSelectedState();
	          this.props.clearAllSelectedCity();
	          this.props.clearAllZipCode();
	          this.props.clearAllDMA();
	          this.props.clearAllCounty();
	          break;
	        case "county":
	          this.setState({
	            checkedState: false,
	            checkedZip: false,
	            checkedCounty: true,
	            checkedDMA: false,
	            stateAndCityTipStatus: true,
	            selectedStateLabel: "",
	            selectedStateId: ""
	          });
	          this.props.clearAllZipCode();
	          this.props.clearMapPlotted();
	          this.props.clearAllSelectedState();
	          this.props.clearAllSelectedCity();
	          this.props.clearAllDMA();
	          break;
	        case "dma":
	          this.setState({
	            checkedState: false,
	            checkedZip: false,
	            checkedCounty: false,
	            checkedDMA: true,
	            stateAndCityTipStatus: true,
	            selectedStateLabel: "",
	            selectedStateId: ""
	          });
	          this.props.clearAllZipCode();
	          this.props.clearMapPlotted();
	          this.props.clearAllSelectedState();
	          this.props.clearAllSelectedCity();
	          this.props.clearAllCounty();
	          break;
	        default:
	          return;
	      }
	    }
	  }, {
	    key: "handleStateSelected",
	    value: function handleStateSelected(e, isInputChecked, stateObj) {
	      var _this4 = this;
	
	      if (this.state.checkedState) {
	        this.props.selectState(stateObj, isInputChecked);
	        if (isInputChecked) {
	          var activeAllcities = this.props.all_state_cities.find(function (item) {
	            return item.state.id === stateObj.id;
	          }) || { cities: [] };
	          activeAllcities.cities.forEach(function (item) {
	            (0, _remove2.default)(_this4.props.selected_city, function (n) {
	              return n.id === item.id;
	            });
	          });
	          var rc = (0, _uniq2.default)(this.state.checkUserSelectedState).filter(function (item) {
	            return item !== stateObj.id;
	          });
	          this.setState({
	            checkUserSelectedState: rc,
	            stateAndCityTipStatus: false // author chargo 2015-8-16 close tips when click state's checkbox
	          });
	        }
	        this.setState({
	          ifShowRightPanel: false,
	          stateActiveIndex: ""
	        });
	      } else if (this.state.checkedCounty) {
	        var stateVal = stateObj.value;
	        (0, _map2.default)(this.props.counties, function (c) {
	          if (c.label.indexOf(stateVal) > 0) {
	            _this4.props.selectCounty(c, stateObj.label, isInputChecked);
	          }
	        });
	        setTimeout(function () {
	          this.props.reCalculateTotal();
	        }.bind(this), 200);
	      } else if (this.state.checkedDMA) {
	        var _stateVal = stateObj.value;
	        (0, _map2.default)(this.props.dmas, function (c) {
	          if (c.label.indexOf(_stateVal) > 0) {
	            _this4.props.selectDMA(c, stateObj.label, isInputChecked);
	          }
	        });
	        setTimeout(function () {
	          this.props.reCalculateTotal();
	        }.bind(this), 200);
	      }
	    }
	  }, {
	    key: "handleShowStateItems",
	    value: function handleShowStateItems(e, stateId, stateLabel, index) {
	      var _this5 = this;
	
	      var mockCheckUserSelectedState = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	      // when click state text area
	      if (e.target.type !== "checkbox") {
	        this.refs.cityUl.scrollTop = 0;
	        this.setState({
	          ifShowRightPanel: true,
	          stateActiveIndex: index,
	          selectedStateLabel: stateLabel,
	          selectedStateId: stateId,
	          stateAndCityTipStatus: false // author charg 2015-8-16 close tips, when click state's text
	        });
	        // this.props.loading();
	        if (this.state.checkedState) {
	          this.props.getCities(stateId);
	          if (this.props.selected_state.some(function (obj) {
	            return obj.id === stateId;
	          })) {
	            this.setState({
	              ifallCitiesSelected: true
	            });
	          } else {
	            this.setState({
	              ifallCitiesSelected: false
	            });
	          }
	          if ((this.state.checkUserSelectedState.some(function (item) {
	            return item === stateId;
	          }) || mockCheckUserSelectedState.some(function (item) {
	            return item.id === stateId;
	          })) && !this.props.ifLoading) {
	            var activeAllcities = this.props.all_state_cities.find(function (item) {
	              return item.state.id === stateId;
	            });
	            var selected_city_index = [];
	            var activeId = [];
	            activeAllcities.cities.forEach(function (city, index) {
	              if (_this5.props.selected_city.some(function (item) {
	                return item.id === city.id;
	              })) {
	                activeId.push(city.id);
	                selected_city_index.push(index);
	              }
	            });
	            window.setTimeout(function () {
	              var liHeight = _this5.refs.cityList.clientHeight;
	              _this5.refs.cityUl.scrollTop = selected_city_index[0] * liHeight;
	              _this5.setState({
	                beSearchedCityId: activeId[0]
	              });
	            }, localStorage.getItem("spareTime"));
	          }
	        }
	        if (this.state.checkedCounty) {
	          var subItems = (0, _filter2.default)(this.props.counties, function (c) {
	            return c.label.indexOf(stateLabel) >= 0;
	          });
	          this.setState({
	            stateCounties: subItems
	          });
	        }
	        if (this.state.checkedDMA) {
	          var _subItems = (0, _filter2.default)(this.props.dmas, function (d) {
	            return d.label.indexOf(stateLabel) >= 0 || d.value === "999";
	          });
	          this.setState({
	            stateDMAs: _subItems
	          });
	        }
	      }
	      // when click checkbox
	      if (e.target.type === "checkbox") {
	        this.setState({
	          checkboxStateIndex: index
	        });
	      }
	    }
	  }, {
	    key: "handleCitySelected",
	    value: function handleCitySelected(e, isInputChecked, index, cityObj) {
	      var _this6 = this;
	
	      this.setState({
	        checkboxCityIndex: index,
	        beSearchedCityId: "" // cancel active class name for city list
	      });
	      var arr = [];
	      if (this.state.checkedState) {
	        if (!isInputChecked) {
	          if (this.state.checkedState) {
	            this.props.all_state_cities.forEach(function (item) {
	              _this6.props.selected_city.forEach(function (city) {
	                item.cities.forEach(function (index) {
	                  if (index.id === city.id) {
	                    arr.filter(function (n) {
	                      return n !== item.state.id;
	                    });
	                  }
	                });
	              });
	            });
	          }
	
	          this.setState({
	            checkUserSelectedState: arr
	          });
	        }
	
	        this.props.selectCity(cityObj, this.state.selectedStateLabel, isInputChecked);
	      }
	      if (this.state.checkedCounty) {
	        this.props.selectCounty(cityObj, this.state.selectedStateLabel, isInputChecked);
	        setTimeout(function () {
	          this.props.reCalculateTotal();
	        }.bind(this), 50);
	      }
	      if (this.state.checkedDMA) {
	        this.props.selectDMA(cityObj, this.state.selectedStateLabel, isInputChecked);
	        setTimeout(function () {
	          this.props.reCalculateTotal();
	        }.bind(this), 50);
	      }
	    }
	  }, {
	    key: "handleCityChange",
	    value: function handleCityChange(selectedItem, cities) {
	      var _this7 = this;
	
	      // compute search result position
	      var liHeight = this.refs.cityList.clientHeight;
	      if (selectedItem.length > 0) {
	        cities.forEach(function (city, index) {
	          if (city.id === selectedItem[0].id) {
	            // compute scrollTop
	            _this7.refs.cityUl.scrollTop = index * liHeight;
	            _this7.setState({
	              beSearchedCityId: selectedItem[0].id
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: "showTypeahead",
	    value: function showTypeahead(items) {
	      var _this8 = this;
	
	      var textType = this.state.checkedState ? "city" : this.state.checkedCounty ? "county" : this.state.checkedDMA ? "DMA" : "";
	
	      return [_react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	        key: "city_search_box",
	        labelKey: "label",
	        multiple: false,
	        options: items,
	        placeholder: "Find " + textType + " in " + this.state.selectedStateLabel,
	        onChange: function onChange(selectedItem) {
	          return _this8.handleCityChange(selectedItem, items);
	        }
	      }), _react2.default.createElement(
	        "div",
	        {
	          key: "city_search_text",
	          className: "form-control-feedback",
	          style: { width: "54px" }
	        },
	        _react2.default.createElement(
	          "span",
	          { className: "text-uppercase no-padding no-margin" },
	          "search"
	        )
	      )];
	    }
	  }, {
	    key: "handleZipCode",
	    value: function handleZipCode(e, newValue) {
	      var matchArrs = newValue.match(/\b\d{5}\b/g);
	      var arrs = newValue.split(",");
	      var diff = (0, _difference2.default)(arrs, matchArrs);
	      if ((0, _isEmpty2.default)(diff)) {
	        this.setState({
	          ifZipcodeValid: false,
	          zipcode: newValue,
	          inValidZips: []
	        });
	      } else {
	        this.setState({
	          ifZipcodeValid: true,
	          inValidZips: diff
	        });
	      }
	      /*
	      if (/((^\d{5}|^\d{5}-\d{5})(,(\d{5}|\d{5}-\d{5}))*$)/.test(newValue)) {
	        this.setState({
	          ifZipcodeValid: false,
	          zipcode: newValue,
	        });
	      } else {
	        this.setState({
	          ifZipcodeValid: true,
	        });
	      }*/
	    }
	  }, {
	    key: "handleApplyClick",
	    value: function handleApplyClick(e) {
	      if (!this.state.ifZipcodeValid) {
	        var zipcodes = (0, _uniq2.default)(this.state.zipcode.split(","));
	        this.props.addZipCode(zipcodes.join(","));
	        this.setState({
	          checkedZip: true,
	          checkedState: false,
	          checkedDMA: false,
	          checkedCounty: false,
	          zipcode: "",
	          ifZipcodeValid: true
	        });
	        document.getElementById(this.refs.textarea.uniqueId).value = "";
	      }
	    }
	  }, {
	    key: "renderStates",
	    value: function renderStates(allstates, selected_state) {
	      var _this9 = this;
	
	      if (typeof allstates === "undefined") return "";
	      var result = [];
	      var countyStates = (0, _groupBy2.default)(this.props.selected_county, function (c) {
	        return c.label.split(",")[1].trim();
	      });
	      var allCountyStates = (0, _groupBy2.default)(this.props.counties, function (c) {
	        return c.label.split(",")[1].trim();
	      });
	      var dmaStates = (0, _groupBy2.default)(this.props.selected_dma, function (d) {
	        return d.label.indexOf(",") >= 0 && d.label.split(",")[1].trim();
	      });
	      var allDMAStates = (0, _groupBy2.default)(this.props.dmas, function (d) {
	        if (d.label.indexOf(",") >= 0) return d.label.split(",")[1].trim();
	      });
	
	      allstates.map(function (item, index) {
	        var showCheckIcon = false;
	        var isStateChecked = false;
	
	        if (_this9.state.checkedState) {
	          showCheckIcon = _this9.state.checkUserSelectedState.some(function (stateId) {
	            return stateId === item.id;
	          });
	          isStateChecked = selected_state.some(function (state) {
	            return state.id === item.id;
	          });
	        }
	        if (_this9.state.checkedCounty) {
	          showCheckIcon = Object.keys(countyStates).indexOf(item.value) >= 0;
	          isStateChecked = countyStates[item.value] && allCountyStates[item.value] && countyStates[item.value].length === allCountyStates[item.value].length;
	        }
	        if (_this9.state.checkedDMA) {
	          showCheckIcon = _this9.props.selected_dma.some(function (d) {
	            return d.label.indexOf(item.value) >= 0;
	          });
	          isStateChecked = dmaStates[item.value] && allDMAStates[item.value] && dmaStates[item.value].length === allDMAStates[item.value].length;
	        }
	        result.push(_react2.default.createElement(
	          "li",
	          {
	            key: item.awId,
	            ref: "stateList",
	            onClick: function onClick(e) {
	              _this9.handleShowStateItems(e, item.id, item.value, index);
	            },
	            className: _this9.state.stateActiveIndex === index ? "active" : ""
	          },
	          _react2.default.createElement(_Checkbox2.default, {
	            onCheck: function onCheck(e, isInputChecked) {
	              return _this9.handleStateSelected(e, isInputChecked, item);
	            },
	            label: item.label,
	            iconStyle: styles.iconStyle,
	            inputStyle: { width: "10%" },
	            labelStyle: { fontSize: "15.6px" },
	            checked: isStateChecked
	          }),
	          _react2.default.createElement(
	            "span",
	            {
	              className: "text-teal-400",
	              style: {
	                position: "absolute",
	                top: "0",
	                right: "4em",
	                display: showCheckIcon ? "inline" : "none"
	              }
	            },
	            _react2.default.createElement("i", { className: "icon-checkmark4 " })
	          ),
	          _react2.default.createElement(
	            "small",
	            {
	              style: {
	                display: _this9.state.stateActiveIndex === index ? "none" : "inline"
	              }
	            },
	            ">"
	          )
	        ));
	      });
	      return result;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this10 = this;
	
	      var _props = this.props,
	          allstates = _props.allstates,
	          selected_city = _props.selected_city,
	          allcities = _props.allcities,
	          selected_state = _props.selected_state,
	          selected_county = _props.selected_county,
	          selected_dma = _props.selected_dma;
	
	      var subItems = this.state.checkedState ? allcities : this.state.checkedCounty ? this.state.stateCounties : this.state.checkedDMA ? this.state.stateDMAs : undefined;
	      var selected_subitems = this.state.checkedState ? selected_city : this.state.checkedCounty ? selected_county : this.state.checkedDMA ? selected_dma : undefined;
	      var geographicText = _react2.default.createElement(
	        "section",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          "Selectiong Geographic Attributes:"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          "US States and Cities"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          "When selecting geographic attributes,"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          "remember:"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "You can build your segment by selecting"
	        ),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "either US States/Cities or US Zip Codes"
	        ),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "If you make one radio button selection"
	        ),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "and select attributes for that category.any"
	        ),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "selections made will be deleted if you then"
	        ),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "select the other radio button"
	        ),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "To select an entire state,select that state's"
	        ),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "checkbox"
	        ),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "To display a state's cities,select that state's"
	        ),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          "row."
	        )
	      );
	      return _react2.default.createElement(
	        "div",
	        { className: "add-location" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: this.state.checkedZip ? "col-xs-12 col-md-12 col-sm-10 col-lg-12" : "col-xs-6 col-md-6 col-sm-6 col-lg-6 states"
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "radio-button-group",
	                onClick: function onClick(e) {
	                  return _this10.handleRadio(e);
	                }
	              },
	              _react2.default.createElement(
	                _rcTooltip2.default,
	                {
	                  placement: "right",
	                  overlay: geographicText,
	                  arrowContent: _react2.default.createElement("div", { className: "rc-tooltip-arrow-inner" })
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "inline-block",
	                      color: "#1E88E5",
	                      cursor: "pointer",
	                      marginBottom: "1em"
	                    }
	                  },
	                  "Tips"
	                )
	              ),
	              _react2.default.createElement(
	                "section",
	                {
	                  className: "city-state-radio-tips",
	                  style: {
	                    display: this.state.stateAndCityTipStatus ? "block" : "none"
	                  }
	                },
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "To select an entire state. ",
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "last-p" },
	                  "select that state's checkbox. ",
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "To display a state's CITIES,COUNTIES or DMA. ",
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "select that state's row. ",
	                  _react2.default.createElement("br", null)
	                )
	              ),
	              _react2.default.createElement(_RadioButton.RadioButton, {
	                value: "state",
	                label: "US CITY/STATE",
	                inputStyle: styles.raidoIcon,
	                checked: this.state.checkedState,
	                iconStyle: styles.iconStyle,
	                labelStyle: { fontSize: "14px" }
	              }),
	              _react2.default.createElement(
	                "ul",
	                {
	                  className: "state-wrapper",
	                  ref: "stateUI",
	                  style: {
	                    height: this.state.checkedState ? "384px" : "0",
	                    opacity: this.state.checkedState ? "1" : "0"
	                  }
	                },
	                this.renderStates(allstates, selected_state)
	              ),
	              _react2.default.createElement(_RadioButton.RadioButton, {
	                value: "county",
	                label: "COUNTY",
	                checked: this.state.checkedCounty,
	                iconStyle: styles.iconStyle,
	                labelStyle: { fontSize: "14px" }
	              }),
	              _react2.default.createElement(
	                "ul",
	                {
	                  className: "state-wrapper",
	                  ref: "countyUI",
	                  style: {
	                    height: this.state.checkedCounty ? "384px" : "0",
	                    opacity: this.state.checkedCounty ? "1" : "0"
	                  }
	                },
	                this.renderStates(allstates, selected_state)
	              ),
	              _react2.default.createElement(_RadioButton.RadioButton, {
	                value: "dma",
	                label: "DMA",
	                checked: this.state.checkedDMA,
	                iconStyle: styles.iconStyle,
	                labelStyle: { fontSize: "14px" }
	              }),
	              _react2.default.createElement(
	                "ul",
	                {
	                  className: "state-wrapper",
	                  ref: "dmaUI",
	                  style: {
	                    height: this.state.checkedDMA ? "384px" : "0",
	                    opacity: this.state.checkedDMA ? "1" : "0"
	                  }
	                },
	                this.renderStates(allstates, selected_state)
	              ),
	              _react2.default.createElement(_RadioButton.RadioButton, {
	                value: "zip",
	                label: "ZIP CODE",
	                checked: this.state.checkedZip,
	                iconStyle: styles.iconStyle,
	                labelStyle: { fontSize: "14px" }
	              }),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "show-zipcode clearfix",
	                  style: {
	                    width: "95%",
	                    display: this.props.zipcode.length > 0 ? "block" : "none"
	                  }
	                },
	                this.props.zipcode.map(function (item, index) {
	                  return _react2.default.createElement(
	                    "span",
	                    {
	                      className: "text-muted text-light ml-10",
	                      style: { float: "left" },
	                      key: index
	                    },
	                    _react2.default.createElement(
	                      "small",
	                      null,
	                      item.zipcode
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  "span",
	                  { className: "text-teal-400 ml-10", style: { float: "left" } },
	                  _react2.default.createElement("i", { className: "icon-checkmark4 text-size-md " })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "zip-code-wrapper",
	                  style: { height: this.state.checkedZip ? "360px" : "0" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-area" },
	                  _react2.default.createElement(_TextField2.default, {
	                    fullWidth: true,
	                    multiLine: true,
	                    rows: 1,
	                    rowsMax: 11,
	                    underlineShow: false,
	                    hintText: "Enter Zip Code(s) or Zip Code Range(s)",
	                    onChange: function onChange(e, newValue) {
	                      return _this10.handleZipCode(e, newValue);
	                    },
	                    errorText: this.state.errorText,
	                    ref: "textarea"
	                  })
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "tips" },
	                  "If entering multiple zip codes or zip code ranges, separate each with a comma"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(_RaisedButton2.default, {
	                    label: "Apply",
	                    buttonStyle: styles.btnStyle,
	                    labelColor: "#FFF",
	                    disabled: this.state.ifZipcodeValid,
	                    onTouchTap: function onTouchTap(e) {
	                      return _this10.handleApplyClick(e);
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "ml-10", style: { color: "#FF0000" } },
	                    !(0, _isEmpty2.default)(this.state.inValidZips) && "Some invalid zipcodes: " + this.state.inValidZips.join(",")
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-xs-6 col-md-6 col-sm-6 col-lg-6 search-box",
	              style: { display: this.state.ifShowRightPanel ? "block" : "none" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "search-bar clearfix" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-xs-12 col-md-12 col-sm-12 col-lg-12",
	                  style: { padding: 0, marginTop: "-5px" }
	                },
	                _react2.default.createElement(
	                  "span",
	                  { className: "input-group", style: { width: "100%" } },
	                  typeof subItems !== "undefined" && this.showTypeahead(subItems)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "city-selection-scrollable" },
	              this.state.checkedDMA && _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    height: "40px",
	                    paddingTop: "10px",
	                    background: "rgb(232, 232, 232)",
	                    marginLeft: "40px",
	                    marginBottom: "20px"
	                  }
	                },
	                _react2.default.createElement(
	                  "span",
	                  { style: { marginLeft: "10px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Code"
	                  )
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { style: { marginLeft: "60px" } },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "DMA"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "city-selection-parent", ref: "cityUl" },
	                typeof subItems !== "undefined" && subItems.map(function (item, index) {
	                  if (index === 0) {
	                    _this10.startRenderTime = new Date().getTime();
	                  }
	
	                  if (index === allcities.length - 1) {
	                    _this10.endRenderTime = new Date().getTime();
	                  }
	                  return _react2.default.createElement(
	                    "li",
	                    {
	                      key: item.id,
	                      ref: "cityList",
	                      className: item.id === _this10.state.beSearchedCityId ? "active" : ""
	                    },
	                    _react2.default.createElement(_Checkbox2.default, {
	                      onCheck: function onCheck(e, isInputChecked) {
	                        return _this10.handleCitySelected(e, isInputChecked, index, item);
	                      },
	                      label: _this10.state.checkedDMA ? [_react2.default.createElement(
	                        "span",
	                        {
	                          style: {
	                            marginLeft: "10px",
	                            marginRight: "30px"
	                          }
	                        },
	                        item.value
	                      ), _react2.default.createElement(
	                        "span",
	                        { style: { whiteSpace: "nowrap" } },
	                        item.label
	                      )] : item.label,
	                      iconStyle: styles.iconStyle
	                      // defaultChecked={(typeof selected_city !== 'undefined' && selected_city.some((value) => value === city.id)) || this.state.ifallCitiesSelected}
	                      , labelStyle: { fontSize: "15.6px" },
	                      checked: typeof selected_subitems !== "undefined" && selected_subitems.some(function (value) {
	                        return value.id === item.id;
	                      }) || _this10.state.ifallCitiesSelected
	                    })
	                  );
	                })
	              ),
	              (typeof allcities === "undefined" || this.props.ifLoading) && _react2.default.createElement(
	                "div",
	                { className: "progress-city" },
	                _react2.default.createElement(_CircularProgress2.default, { style: { top: "40%" } })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddLocation;
	}(_react.Component);
	
	AddLocation.defaultProps = {
	  selected_city: [],
	  selected_state: [],
	  all_state_cities: [],
	  allcities: [],
	  ifLoading: true
	};
	exports.default = AddLocation;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactTooltipLite = __webpack_require__(339);
	
	var _reactTooltipLite2 = _interopRequireDefault(_reactTooltipLite);
	
	var _Grid = __webpack_require__(19);
	
	var _materialUi = __webpack_require__(38);
	
	var _AddLocation = __webpack_require__(1147);
	
	var _AddLocation2 = _interopRequireDefault(_AddLocation);
	
	var _AutoMake = __webpack_require__(1143);
	
	var _AutoMake2 = _interopRequireDefault(_AutoMake);
	
	var _CultureCode = __webpack_require__(1145);
	
	var _CultureCode2 = _interopRequireDefault(_CultureCode);
	
	var _SelectedAttrs = __webpack_require__(257);
	
	var _SelectedAttrs2 = _interopRequireDefault(_SelectedAttrs);
	
	var _Map = __webpack_require__(1156);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _LimitExceeded = __webpack_require__(530);
	
	var _LimitExceeded2 = _interopRequireDefault(_LimitExceeded);
	
	var _lodash = __webpack_require__(18);
	
	var _utility = __webpack_require__(14);
	
	var _segment_util = __webpack_require__(261);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _moreHoriz = __webpack_require__(434);
	
	var _moreHoriz2 = _interopRequireDefault(_moreHoriz);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	__webpack_require__(1438);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  tooltipStyle: {
	    textAlign: "left",
	    cursor: "pointer",
	    fontSize: "12px",
	    fontWeight: "200",
	    padding: "20px 30px"
	  },
	  helpIconStyle: {
	    marginTop: "-25px",
	    width: "28px",
	    height: "28px"
	  },
	  checkbox: {
	    fontSize: "1.1em",
	    fill: "#26A69A"
	  },
	  checkboxLabel: {
	    color: "black",
	    width: "auto",
	    fontSize: "1.2em"
	  },
	  checkboxHighlightLabel: {
	    color: "black",
	    fontSize: "1.2em",
	    width: "auto",
	    backgroundColor: "lightgrey"
	  }
	};
	var MenuDivider = function MenuDivider(props) {
	  return _react2.default.createElement("li", { className: "divider", role: "separator" });
	};
	var MenuHeader = function MenuHeader(props) {
	  return _react2.default.createElement("li", Object.assign({}, props, { className: "dropdown-header" }));
	};
	
	var Creation = function (_Component) {
	  _inherits(Creation, _Component);
	
	  function Creation(props) {
	    _classCallCheck(this, Creation);
	
	    var _this = _possibleConstructorReturn(this, (Creation.__proto__ || Object.getPrototypeOf(Creation)).call(this, props));
	
	    _this.handleOpen = function () {
	      _this.setState({ openValuesDialog: true });
	    };
	
	    _this.handleClose = function () {
	      _this.setState({ openValuesDialog: false });
	    };
	
	    _this.handleCancel = function () {
	      _this.setState({
	        openValuesDialog: false,
	        selected_segments: _this.props.selected_segments ? _this.props.selected_segments.slice() : []
	      });
	    };
	
	    _this.toggleSelectedAttrDialog = function (e) {
	      e.preventDefault();
	      var display = !_this.state.openSelectedDialog;
	      _this.setState({
	        openSelectedDialog: display,
	        sltAttrAnchorEl: e.currentTarget
	      });
	    };
	
	    _this.closeSelectedAttrDialog = function () {
	      _this.setState({ openSelectedDialog: false });
	    };
	
	    _this.closeMapSelectDialog = function () {
	      _this.setState({ openMapDialog: false, plotted_values: null });
	      _this.props.clearAudienceCount();
	    };
	
	    _this.state = {
	      pairKeys: {},
	      key: "",
	      openValuesDialog: false,
	      openSelectedDialog: false,
	      openMapDialog: false,
	      openCancel: false,
	      openReset: false,
	      selectKeyPair: {},
	      selected_segments: [],
	      highlightId: 0,
	      highlightAid: 0,
	      hightlightCid: 0,
	      ifShowState: "", // if show state/city selection
	      ifShowAutoMake: false,
	      ifShowCultureRegion: false,
	      errorVisible: false,
	      toolTipStatus: false,
	      resetAllCount: false,
	      mapKey: Math.floor(Date.now() / 1000),
	      showSaveErrorDialog: false,
	      openContactForm: false,
	      showSuccessForm: false
	    };
	    if (!props.demoAttributes) {
	      props.loadAttributes((0, _utility.getUrlParameterByName)("cid"));
	    }
	    if (!props.segment_name) {
	      props.clearAudienceCount();
	    }
	    /*
	    if (!props.selected_client || parseInt(props.selected_client, 10) < 1) {
	      window.location.href = "/";
	    }*/
	    var cid = (0, _utility.getUrlParameterByName)("cid");
	    if (cid) {
	      _this.props.selectClient(parseInt(cid, 10));
	    }
	    return _this;
	  }
	
	  _createClass(Creation, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var width = document.getElementById("CreateSegment").clientWidth;
	      this.setState({ width: width, isNameDuplicated: false });
	      this.props.getAllStates(); //get all states
	      this.props.getAllStateCities(); // get all states and cities
	      this.props.loadCounties();
	      this.props.loadDMAs();
	      if (this.props.selected_city && this.props.selected_city.length > 0 || this.props.selected_state && this.props.selected_state.length > 0 || this.props.selected_county && this.props.selected_county.length > 0 || this.props.selected_dma && this.props.selected_dma.length > 0 || this.props.zipcode && this.props.zipcode.length > 0 || this.props.plotted_values) {
	        document.getElementById("cat-geography-item-group_link").click();
	        if (this.props.selected_city && this.props.selected_city.length > 0 || this.props.selected_state && this.props.selected_state.length > 0 || this.props.selected_county && this.props.selected_county.length > 0 || this.props.selected_dma && this.props.selected_dma.length > 0 || this.props.zipcode && this.props.zipcode.length > 0) this.setState({ ifShowState: true });
	      } else {
	        var _props = this.props,
	            selected_segments = _props.selected_segments,
	            demoAttributes = _props.demoAttributes;
	
	        if (this.props.selected_segments && this.props.selected_segments.length > 0) {
	          (0, _lodash.map)(demoAttributes, function (cat) {
	            var group_id = "cat-attr-" + cat.id + "-item-group";
	            var link_id = group_id + "_link";
	            var hit = false;
	            var attrId = 0;
	            (0, _lodash.map)(cat.attributes, function (attr) {
	              (0, _lodash.map)(attr.values, function (val) {
	                if (selected_segments.indexOf(val.id) >= 0) {
	                  hit = true;
	                  attrId = attr.id;
	                  _this2.setState({
	                    highlightAid: val.id,
	                    hightlightCid: cat.id,
	                    selectKeyPair: attr
	                  });
	                }
	              });
	              (0, _lodash.map)(attr.subAttributes, function (subAttr) {
	                (0, _lodash.map)(subAttr.values, function (val) {
	                  if (selected_segments.indexOf(val.id) >= 0) {
	                    hit = true;
	                    attrId = attr.id;
	                    _this2.setState({
	                      highlightAid: val.id,
	                      hightlightCid: cat.id,
	                      selectKeyPair: attr
	                    });
	                  }
	                });
	              });
	            });
	
	            if (hit === true) {
	              document.getElementById(link_id).click();
	              if (attrId === 605 || attrId === 606) {
	                //auto make / auto model
	                _this2.setState({
	                  ifShowAutoMake: true,
	                  ifShowCultureRegion: false,
	                  ifShowState: false
	                });
	              } else if (attrId === 1502 || attrId === 1503) {
	                _this2.setState({
	                  ifShowAutoMake: false,
	                  ifShowCultureRegion: true,
	                  ifShowState: false
	                });
	              } else {
	                _this2.setState({
	                  ifShowCultureRegion: false,
	                  ifShowState: false,
	                  ifShowAutoMake: false // close auto make panel
	                });
	              }
	              return;
	            }
	          });
	        }
	      }
	
	      var clearAll = window.sessionStorage.getItem("clearAll");
	      if (clearAll) {
	        window.sessionStorage.removeItem("clearAll");
	        this.clearAllSelected();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (nextProps.selected_client > 1) {
	          var url = "/segment/create?cid=" + nextProps.selected_client;
	          this.props.history.push(url);
	        }
	      }
	      if (nextProps.isNameDuplicated === true) {
	        if (!this.state.errorVisible) this.setState({ errorVisible: true });
	      } else {
	        if (this.state.errorVisible === true) this.setState({ errorVisible: false });
	      }
	
	      if (nextProps.audience_total_count !== this.props.audience_total_count) {
	        this.setState({
	          onCalculating: false
	        });
	      }
	
	      if (nextProps.save_segment_success === false && this.props.save_segment_success !== nextProps.save_segment_success) {
	        if (String(nextProps.save_segment_error_errorNo) === "422004") this.setState({
	          showSaveErrorDialog: true,
	          openContactForm: false
	        });
	      }
	
	      if (nextProps.request_assist_successful !== this.props.request_assist_successful) {
	        if (nextProps.request_assist_successful === true) {
	          this.setState({
	            showSuccessForm: true,
	            openContactForm: false,
	            showSaveErrorDialog: false
	          });
	        }
	      }
	
	      if (nextProps.check_client_limit === true && nextProps.check_client_limit !== this.props.check_client_limit) {
	        this.props.verifySegmentNameAndContinue(this.props.selected_client, this.props.segment_name);
	      }
	
	      if (nextProps.targetHouseholdsOnly !== this.props.targetHouseholdsOnly) {
	        this.reCalculateTotal(nextProps.targetHouseholdsOnly);
	      }
	    }
	  }, {
	    key: "loadValues",
	    value: function loadValues(key) {
	      var _props2 = this.props,
	          demoAttributes = _props2.demoAttributes,
	          selected_segments = _props2.selected_segments;
	
	      if (demoAttributes) {
	        this.setState({
	          pairKeys: (0, _lodash.sortBy)(demoAttributes[key].segments, function (segment) {
	            return segment.label;
	          }),
	          key: key,
	          selected_segments: selected_segments ? selected_segments.slice() : []
	        });
	      }
	    }
	  }, {
	    key: "getLanguageGroup",
	    value: function getLanguageGroup(val) {
	      if (val.indexOf("HL") >= 0) {
	        return "Hispanic Language Usage";
	      }
	      if (val.indexOf("AL_CN") >= 0) {
	        return "Chinese Language Usage";
	      }
	      if (val.indexOf("AL_IN") >= 0) {
	        return "Indic Language Usage";
	      }
	      if (val.indexOf("AL_JP") >= 0) {
	        return "Japanese Language Usage";
	      }
	      if (val.indexOf("AL_VN") >= 0) {
	        return "Vietnamese Language Usage";
	      }
	      if (val.indexOf("AL_KR") >= 0) {
	        return "Korean Language Usage";
	      }
	      if (val.indexOf("HA") >= 0) {
	        return "Hispanicity";
	      }
	      if (val.indexOf("AA") >= 0) {
	        return "Asianicity";
	      }
	    }
	  }, {
	    key: "displayAttrValues",
	    value: function displayAttrValues() {
	      var _this3 = this;
	
	      var values = this.state.selectKeyPair.values ? this.state.selectKeyPair.values : null;
	      var subAttributes = this.state.selectKeyPair.subAttributes ? this.state.selectKeyPair.subAttributes : null;
	      if (values == null && subAttributes == null) return;
	      var rows = [];
	      var selected_segments = this.props.selected_segments;
	      var granularity = "";
	
	      if (values) {
	        (0, _lodash.map)(this.props.demoAttributes, function (cat) {
	          (0, _lodash.map)(cat.attributes, function (attr) {
	            if (parseInt(attr.id, 10) === parseInt(_this3.state.selectKeyPair.id, 10)) {
	              granularity = attr.granularity;
	            }
	          });
	        });
	        (0, _lodash.map)(values, function (val) {
	          var cols = [];
	          var id = val.id;
	          var _checked = selected_segments && selected_segments.indexOf(id) >= 0;
	
	          cols.push(_react2.default.createElement(
	            _Grid.Col,
	            { key: "select-key-pair-" + id, xs: "10", md: "10", sm: "10", lg: "10" },
	            _react2.default.createElement(_materialUi.Checkbox, {
	              autoFocus: _this3.state.highlightId === id,
	              inputStyle: { width: "35px" },
	              label: id.toString().indexOf("140") === 0 && id.toString().indexOf("1407") < 0 && id.toString().indexOf("1408") < 0 || id.toString().indexOf("1505") === 0 || id.toString().indexOf("1504") === 0 ? _react2.default.createElement(
	                _reactTooltipLite2.default,
	                {
	                  content: _react2.default.createElement(
	                    "div",
	                    {
	                      className: "p-10 black-border",
	                      style: { background: "#FFF" }
	                    },
	                    granularity
	                  ),
	                  direction: "right"
	                },
	                _react2.default.createElement(
	                  "div",
	                  { style: { paddingLeft: "20px", display: "flex" } },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        width: id.toString().indexOf("1504") === 0 ? "30px" : "60px",
	                        display: id.toString().indexOf("1505") === 0 ? "inline-block" : "inline"
	                      }
	                    },
	                    val.value
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        marginLeft: id.toString().indexOf("1505") === 0 ? "40px" : "60px"
	                      }
	                    },
	                    val.label
	                  )
	                )
	              ) : _react2.default.createElement(
	                _reactTooltipLite2.default,
	                {
	                  content: _react2.default.createElement(
	                    "div",
	                    {
	                      className: "p-10 black-border",
	                      style: { background: "#FFF" }
	                    },
	                    granularity
	                  ),
	                  direction: "right"
	                },
	                _react2.default.createElement(
	                  "span",
	                  { className: "ml-20" },
	                  val.label
	                )
	              ),
	              labelStyle: _this3.state.highlightId === id ? styles.checkboxHighlightLabel : styles.checkboxLabel,
	              defaultChecked: _checked,
	              iconStyle: styles.checkbox,
	              onCheck: function onCheck(e) {
	                _this3.chooseSegmentValues(id);
	              }
	            })
	          ));
	
	          cols.push(_react2.default.createElement(
	            _Grid.Col,
	            { xs: "2", md: "2", sm: "2", lg: "2", key: "value-pairs-col-" + id },
	            _react2.default.createElement(
	              "p",
	              {
	                className: "text-default text-size-large",
	                style: { fontSize: "1.2em" }
	              },
	              "\xA0"
	            )
	          ));
	          if (id.toString().indexOf("140") === 0 && rows.length <= 0) {
	            rows.push(_react2.default.createElement(
	              _Grid.Row,
	              {
	                style: {
	                  /*padding: 0, margin: "20px 20px 0 20px"*/marginBottom: "-20px"
	                },
	                key: "select-key-pair-row-" + id
	              },
	              _react2.default.createElement(
	                _Grid.Col,
	                {
	                  key: "key-pair-title-" + id,
	                  xs: "10",
	                  md: "10",
	                  sm: "10",
	                  lg: "10",
	                  className: "mb-20"
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      height: "40px",
	                      paddingTop: "10px",
	                      background: "#E8E8E8",
	                      marginLeft: "40px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    { style: { marginLeft: "20px" } },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      id.toString().indexOf("1504") === 0 ? "Code" : "Segment"
	                    )
	                  ),
	                  id.toString().indexOf("1408") < 0 && id.toString().indexOf("1407") < 0 && _react2.default.createElement(
	                    "span",
	                    { style: { marginLeft: "60px" } },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Segment Name"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "2", md: "2", sm: "2", lg: "2", key: "key-pairs-title2-" + id },
	                _react2.default.createElement(
	                  "p",
	                  {
	                    className: "text-default text-size-large",
	                    style: { fontSize: "1.2em" }
	                  },
	                  "\xA0"
	                )
	              ),
	              cols
	            ));
	          } else {
	            if ((id.toString().indexOf("1505") === 0 || id.toString().indexOf("1504") === 0) && val.value.endsWith("1")) {
	              rows.push(_react2.default.createElement(
	                _Grid.Row,
	                {
	                  style: { marginBottom: "-20px" },
	                  key: "select-key-pair-row-" + id + "-title"
	                },
	                _react2.default.createElement(
	                  _Grid.Col,
	                  {
	                    key: "key-pair-title-" + id + val.value,
	                    xs: "10",
	                    md: "10",
	                    sm: "10",
	                    lg: "10",
	                    className: "mb-20"
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        height: "40px",
	                        paddingTop: "10px",
	                        background: "#E8E8E8",
	                        marginLeft: "40px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { style: { marginLeft: "20px" } },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Code"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { style: { marginLeft: "60px" } },
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        _this3.getLanguageGroup(val.value)
	                      )
	                    )
	                  )
	                ),
	                cols
	              ));
	            } else {
	              rows.push(_react2.default.createElement(
	                _Grid.Row,
	                {
	                  style: { marginBottom: "-20px" },
	                  key: "select-key-pair-row-" + id
	                },
	                cols
	              ));
	            }
	          }
	        });
	      }
	      if (subAttributes) {
	        (0, _lodash.map)(subAttributes, function (subAttr) {
	          var cols = [];
	          cols.push(_react2.default.createElement(
	            _Grid.Col,
	            { xs: "4", md: "4", sm: "4", lg: "4", key: "sub-attr-col-" + subAttr.id },
	            _react2.default.createElement(
	              "p",
	              { className: "text-default text-size-large" },
	              subAttr.name
	            )
	          ));
	
	          var subAttrRows = [];
	          granularity = subAttr.granularity;
	          (0, _lodash.map)(subAttr.values, function (subAttrVal) {
	            var id = subAttrVal.id;
	            var _checked = selected_segments && selected_segments.indexOf(id) >= 0;
	            subAttrRows.push(_react2.default.createElement(
	              _Grid.FullRow,
	              {
	                key: "select-key-pair-row-" + id,
	                className: "no-padding no-margin"
	              },
	              _react2.default.createElement(_materialUi.Checkbox, {
	                autoFocus: _this3.state.highlightId === id,
	                inputStyle: { width: "35px" },
	                label: _react2.default.createElement(
	                  _reactTooltipLite2.default,
	                  {
	                    content: _react2.default.createElement(
	                      "div",
	                      {
	                        className: "p-10 black-border",
	                        style: { background: "#FFF" }
	                      },
	                      granularity
	                    ),
	                    direction: "right"
	                  },
	                  subAttrVal.label
	                ),
	                labelStyle: _this3.state.highlightId === id ? styles.checkboxHighlightLabel : styles.checkboxLabel,
	                defaultChecked: _checked,
	                iconStyle: styles.checkbox,
	                onCheck: function onCheck(e) {
	                  _this3.chooseSegmentValues(id);
	                }
	              })
	            ));
	          });
	          cols.push(_react2.default.createElement(
	            _Grid.Col,
	            {
	              xs: "8",
	              md: "8",
	              sm: "8",
	              lg: "8",
	              key: "sub-attr-values-col-" + subAttr.id
	            },
	            subAttrRows
	          ));
	          rows.push(_react2.default.createElement(
	            _Grid.Row,
	            {
	              style: { marginBottom: "-20px" },
	              key: "select-key-pair-row-" + subAttr.id
	            },
	            cols
	          ));
	        });
	      }
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            padding: "90px 5px 0 5px",
	            height: "500px",
	            overflowX: "hidden",
	            overflowY: "scroll"
	          }
	        },
	        rows
	      );
	    }
	  }, {
	    key: "chooseSegmentValues",
	    value: function chooseSegmentValues(id) {
	      var selected = this.props.selected_segments ? this.props.selected_segments : [];
	
	      var idx = selected ? selected.indexOf(id) : -1;
	      if (idx >= 0) {
	        selected.splice(idx, 1);
	      } else {
	        selected.push(id);
	      }
	      this.props.selectSegment(selected);
	
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 20);
	    }
	  }, {
	    key: "handleOpenCancelDialog",
	    value: function handleOpenCancelDialog(e, status) {
	      e.preventDefault();
	      this.setState({
	        openCancel: status,
	        cancelAnchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "clearAllSelected",
	    value: function clearAllSelected() {
	      var _this4 = this;
	
	      this.setState({
	        highlightId: 0,
	        highlightAid: 0,
	        hightlightCid: 0,
	        selectKeyPair: {},
	        search_input: undefined
	      });
	      this.props.selectSegment([]);
	      this.setState({
	        selected_segments: [],
	        mapKey: Math.floor(Date.now() / 1000)
	      });
	      this.props.clearAllSelectedState();
	      this.props.clearAllSelectedCity();
	      this.props.clearAllZipCode();
	      this.props.setPlotValues({});
	      this.props.setSegmentName("");
	      var segmentNameInput = _reactDom2.default.findDOMNode(this.refs.segmentNameInput);
	      segmentNameInput.value = "";
	
	      this.typeahead.getInstance().clear();
	      // author chargo
	      this.props.clearAudienceCount();
	      var targetHouseholdsOnly = _reactDom2.default.findDOMNode(this.refs.targetHouseholdsOnly);
	      targetHouseholdsOnly.checked = false;
	      this.props.setTargetHouseholdOnly(false);
	      // author chargo
	      var demoAttributes = this.props.demoAttributes;
	
	      (0, _lodash.map)(demoAttributes, function (cat) {
	        var group_id = "cat-attr-" + cat.id + "-item-group";
	        var link_id = group_id + "_link";
	        var node = _reactDom2.default.findDOMNode(_this4.refs[group_id]);
	        if (node.classList.contains("in")) {
	          document.getElementById(link_id).click();
	        }
	      });
	      setTimeout(function () {
	        var group_id = "cat-geography-item-group";
	        var link_id = group_id + "_link";
	        var node = _reactDom2.default.findDOMNode(_this4.refs[group_id]);
	        if (node.classList.contains("in")) document.getElementById(link_id).click();
	      }, 0);
	      this.setState({
	        ifShowState: false
	      }, function () {
	        window.scrollTo(0, 0);
	      });
	    }
	  }, {
	    key: "removeSelectedVal",
	    value: function removeSelectedVal(id) {
	      var selected_segments = this.props.selected_segments;
	
	      var idx = selected_segments.indexOf(id);
	      if (idx >= 0) {
	        selected_segments.splice(idx, 1);
	        this.props.selectSegment(selected_segments);
	      }
	
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 20);
	    }
	  }, {
	    key: "removePlottedVal",
	    value: function removePlottedVal() {
	      var _this5 = this;
	
	      this.props.setPlotValues({});
	      setTimeout(function () {
	        _this5.reCalculateTotal();
	      }, 20);
	    }
	  }, {
	    key: "handleOpenResetDialog",
	    value: function handleOpenResetDialog(e, status) {
	      e.preventDefault();
	      this.setState({
	        openReset: status,
	        resetAnchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "calTotalAudience",
	    value: function calTotalAudience() {
	      var _props3 = this.props,
	          audience_total_count = _props3.audience_total_count,
	          demoAttributes = _props3.demoAttributes,
	          selected_segments = _props3.selected_segments,
	          plotted_values = _props3.plotted_values,
	          selected_state = _props3.selected_state,
	          selected_city = _props3.selected_city,
	          selected_county = _props3.selected_county,
	          selected_dma = _props3.selected_dma,
	          zipcode = _props3.zipcode,
	          active_segment_attributes = _props3.active_segment_attributes;
	      // author chargo
	
	      if (audience_total_count) return audience_total_count;
	      if (!(0, _lodash.isEmpty)(active_segment_attributes)) {
	        return {
	          total: active_segment_attributes.count,
	          email: active_segment_attributes.email,
	          display: active_segment_attributes.display,
	          social: active_segment_attributes.social,
	          directMail: active_segment_attributes.directMail
	        };
	      }
	      var plottedValues = this.state.plotted_values ? this.state.plotted_values : plotted_values;
	      var result = { total: 0, email: 0, display: 0, social: 0, directMail: 0 };
	
	      (0, _lodash.forEach)(selected_segments, function (sid) {
	        (0, _lodash.map)(demoAttributes, function (cat) {
	          (0, _lodash.map)(cat.attributes, function (segment) {
	            (0, _lodash.map)(segment.values, function (val) {
	              if (val.id === sid) {
	                result.total += parseInt(val.total, 10);
	                result.email += parseInt(val.email, 10);
	                result.social += parseInt(val.social, 10);
	                result.display += parseInt(val.display, 10);
	                result.directMail += parseInt(val.directMail, 10);
	              }
	            });
	            (0, _lodash.map)(segment.subAttributes, function (subAttr) {
	              (0, _lodash.map)(subAttr.values, function (val) {
	                if (val.id === sid) {
	                  result.total += parseInt(val.total, 10);
	                  result.email += parseInt(val.email, 10);
	                  result.social += parseInt(val.social, 10);
	                  result.display += parseInt(val.display, 10);
	                  result.directMail += parseInt(val.directMail, 10);
	                }
	              });
	            });
	          });
	        });
	      });
	      if (plottedValues && plottedValues.audienceCount) {
	        result.total += parseInt(plottedValues.audienceCount.total, 10);
	        result.email += parseInt(plottedValues.audienceCount.email, 10);
	        result.social += parseInt(plottedValues.audienceCount.social, 10);
	        result.display += parseInt(plottedValues.audienceCount.display, 10);
	        result.directMail += parseInt(plottedValues.audienceCount.directMail, 10);
	      } else {
	        result.total += this.computedStateOrCityAttibute(selected_state, "total") + this.computedStateOrCityAttibute(selected_city, "total") + this.computedStateOrCityAttibute(zipcode, "total");
	        this.computedStateOrCityAttibute(selected_county, "total");
	        this.computedStateOrCityAttibute(selected_dma, "total");
	        result.email += this.computedStateOrCityAttibute(selected_state, "email") + this.computedStateOrCityAttibute(selected_city, "email") + this.computedStateOrCityAttibute(zipcode, "email");
	        this.computedStateOrCityAttibute(selected_county, "email");
	        this.computedStateOrCityAttibute(selected_dma, "email");
	        result.social += this.computedStateOrCityAttibute(selected_state, "social") + this.computedStateOrCityAttibute(selected_city, "social") + this.computedStateOrCityAttibute(zipcode, "social");
	        this.computedStateOrCityAttibute(selected_county, "social");
	        this.computedStateOrCityAttibute(selected_dma, "social");
	        result.display += this.computedStateOrCityAttibute(selected_state, "display") + this.computedStateOrCityAttibute(selected_city, "display") + this.computedStateOrCityAttibute(zipcode, "display");
	        this.computedStateOrCityAttibute(selected_county, "display");
	        this.computedStateOrCityAttibute(selected_dma, "display");
	        result.directMail += this.computedStateOrCityAttibute(selected_state, "directMail") + this.computedStateOrCityAttibute(selected_city, "directMail") + this.computedStateOrCityAttibute(zipcode, "directMail");
	        this.computedStateOrCityAttibute(selected_county, "directMail");
	        this.computedStateOrCityAttibute(selected_dma, "directMail");
	      }
	      /*
	      if (selected_make && selected_make.length > 0){
	      result.total += this.computedStateOrCityAttibute(selected_make, 'total')
	      result.email += this.computedStateOrCityAttibute(selected_make, 'email')
	      result.social += this.computedStateOrCityAttibute(selected_make, 'social')
	      result.display += this.computedStateOrCityAttibute(selected_make, 'display')
	      }
	      if (selected_model && selected_model.length > 0){
	      result.total += this.computedStateOrCityAttibute(selected_model, 'total')
	      result.email += this.computedStateOrCityAttibute(selected_model, 'email')
	      result.social += this.computedStateOrCityAttibute(selected_model, 'social')
	      result.display += this.computedStateOrCityAttibute(selected_model, 'display')
	      }
	      */
	      return result;
	    }
	  }, {
	    key: "generateClutureRegionItem",
	    value: function generateClutureRegionItem(selected, attrCultureRegion, attrClutureLocale) {
	      var _this6 = this;
	
	      var selected_segments = this.props.selected_segments; //this.state.selected_segments
	
	      var already_select = false;
	      var count = 0;
	      (0, _lodash.forEach)(selected_segments, function (sid) {
	        (0, _lodash.map)(attrCultureRegion.values, function (val) {
	          if (val.id === sid) {
	            already_select = true;
	            count += val.total;
	          }
	        });
	        (0, _lodash.map)(attrClutureLocale.values, function (val) {
	          if (val.id === sid) {
	            already_select = true;
	            count += val.total;
	          }
	        });
	      });
	
	      return _react2.default.createElement(
	        _Grid.Row,
	        {
	          key: "attribute-" + attrCultureRegion.id,
	          className: "no-padding no-margin"
	        },
	        _react2.default.createElement(
	          _Grid.Col,
	          {
	            xs: "9",
	            sm: "9",
	            md: "9",
	            lg: "9",
	            style: { paddingLeft: "25px", paddingRight: "0px" }
	          },
	          _react2.default.createElement(
	            "a",
	            {
	              className: selected ? "font-12em text-teal " : "font-12em",
	              onClick: function onClick(e) {
	                return _this6.handleAttributeItemClick(e, attrCultureRegion);
	              },
	              style: { width: "100%" }
	            },
	            "Region/Locale"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "text-muted text-light ml-10" },
	            _react2.default.createElement(
	              "small",
	              null,
	              count > 0 ? (0, _utility.splitNumber)(count + "")() : ""
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { xs: "3", sm: "3", md: "3", lg: "3" },
	          _react2.default.createElement(
	            "div",
	            { className: selected ? "pull-right hide" : "pull-right" },
	            ">"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "text-teal-400" },
	            already_select && _react2.default.createElement("i", { className: "icon-checkmark4 text-size-md " })
	          )
	        )
	      );
	    }
	  }, {
	    key: "generateAutoMakeItem",
	    value: function generateAutoMakeItem(selected, attrAutoMake, attrAutoModel) {
	      var _this7 = this;
	
	      var selected_segments = this.props.selected_segments; //this.state.selected_segments
	
	      var already_select = false;
	      var count = 0;
	      (0, _lodash.forEach)(selected_segments, function (sid) {
	        (0, _lodash.map)(attrAutoMake.values, function (val) {
	          if (val.id === sid) {
	            already_select = true;
	            count += val.total;
	          }
	        });
	        (0, _lodash.map)(attrAutoModel.values, function (val) {
	          if (val.id === sid) {
	            already_select = true;
	            count += val.total;
	          }
	        });
	      });
	
	      return _react2.default.createElement(
	        _Grid.Row,
	        {
	          key: "attribute-" + attrAutoMake.id,
	          className: "no-padding no-margin"
	        },
	        _react2.default.createElement(
	          _Grid.Col,
	          {
	            xs: "9",
	            sm: "9",
	            md: "9",
	            lg: "9",
	            style: { paddingLeft: "25px", paddingRight: "0px" }
	          },
	          _react2.default.createElement(
	            "a",
	            {
	              className: selected ? "font-12em text-teal " : "font-12em",
	              onClick: function onClick(e) {
	                return _this7.handleAttributeItemClick(e, attrAutoMake);
	              },
	              style: { width: "100%" }
	            },
	            "Auto Make/Model"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "text-muted text-light ml-10" },
	            _react2.default.createElement(
	              "small",
	              null,
	              count > 0 ? (0, _utility.splitNumber)(count + "")() : ""
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { xs: "3", sm: "3", md: "3", lg: "3" },
	          _react2.default.createElement(
	            "div",
	            { className: selected ? "pull-right hide" : "pull-right" },
	            ">"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "text-teal-400" },
	            already_select && _react2.default.createElement("i", { className: "icon-checkmark4 text-size-md " })
	          )
	        )
	      );
	    }
	  }, {
	    key: "generateItem",
	    value: function generateItem(selected, attr, categoryId) {
	      var _this8 = this;
	
	      // filter `Auto Model`
	      if (attr.id === 605 || attr.id === 606 || attr.id === 1502 || attr.id === 1503) {
	        return;
	      }
	      var selected_segments = this.props.selected_segments; //this.state.selected_segments
	
	      var attrSelectedSegments = [];
	      var already_select = false;
	      var count = 0;
	      (0, _lodash.forEach)(selected_segments, function (sid) {
	        (0, _lodash.map)(attr.values, function (val) {
	          if (val.id === sid) {
	            already_select = true;
	            count += val.total;
	            attrSelectedSegments.push(sid);
	          }
	        });
	        if (attr.subAttributes) {
	          (0, _lodash.map)(attr.subAttributes, function (subAttr) {
	            (0, _lodash.map)(subAttr.values, function (val) {
	              if (val.id === sid) {
	                already_select = true;
	                count += val.total;
	                attrSelectedSegments.push(sid);
	              }
	            });
	          });
	        }
	      });
	      if (attrSelectedSegments.length > 1) {
	        var rules = (0, _segment_util.attr2Rules)(attrSelectedSegments, this.props.demoAttributes, []);
	        if (rules.length > 1) {
	          //this.props.getCategoryAudienceCount(attr.id, rules)
	          count = this.props.catAudienceCounts ? this.props.catAudienceCounts[attr.id] : 0;
	        }
	      }
	      if (attr.name === "Auto Make") {
	        attr.name = "Auto Make/Model";
	      }
	      return _react2.default.createElement(
	        _Grid.Row,
	        { key: "attribute-" + attr.id, className: "no-padding no-margin" },
	        _react2.default.createElement(
	          _Grid.Col,
	          {
	            xs: "9",
	            sm: "9",
	            md: "9",
	            lg: "9",
	            style: { paddingLeft: "25px", paddingRight: "0px" }
	          },
	          _react2.default.createElement(
	            "a",
	            {
	              className: selected ? "font-12em text-teal " : "font-12em",
	              onClick: function onClick(e) {
	                return _this8.handleAttributeItemClick(e, attr);
	              },
	              style: { width: "100%" }
	            },
	            attr.name
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "text-muted text-light ml-10" },
	            _react2.default.createElement(
	              "small",
	              null,
	              already_select && count ? (0, _utility.splitNumber)(count + "")() : ""
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { xs: "3", sm: "3", md: "3", lg: "3" },
	          _react2.default.createElement(
	            "div",
	            { className: selected ? "pull-right hide" : "pull-right" },
	            ">"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "text-teal-400" },
	            already_select && _react2.default.createElement("i", { className: "icon-checkmark4 text-size-md " })
	          )
	        )
	      );
	    }
	  }, {
	    key: "onSearchInputChange",
	    value: function onSearchInputChange(text) {
	      this.setState({
	        search_input: text
	      });
	    }
	  }, {
	    key: "renderSearchMenu",
	    value: function renderSearchMenu(results, menuProps) {
	      var _this9 = this;
	
	      var idx = 0;
	
	      var equal_results = [];
	      var other_results = [];
	      (0, _lodash.map)(results, function (result) {
	        if (result.label.toUpperCase() === _this9.state.search_input.toUpperCase()) equal_results.push(result);else other_results.push(result);
	      });
	
	      var match_grouped = (0, _lodash.groupBy)(equal_results, function (r) {
	        return r.parent;
	      });
	      var match_items = Object.keys(match_grouped).sort().map(function (parent) {
	        return [!!idx && _react2.default.createElement(MenuDivider, { key: parent + "-divider" }), _react2.default.createElement(
	          MenuHeader,
	          { key: parent + "-header" },
	          parent
	        ), (0, _lodash.map)(match_grouped[parent], function (obj) {
	          var item = _react2.default.createElement(
	            _reactBootstrapTypeahead.MenuItem,
	            { key: idx, option: obj, position: idx },
	            obj.label
	          );
	
	          idx++;
	          return item;
	        })];
	      });
	
	      var grouped = (0, _lodash.groupBy)(other_results, function (r) {
	        return r.parent;
	      });
	      var items = Object.keys(grouped).sort().map(function (parent) {
	        return [!!idx && _react2.default.createElement(MenuDivider, { key: parent + "-divider" }), _react2.default.createElement(
	          MenuHeader,
	          { key: parent + "-header" },
	          parent
	        ), (0, _lodash.map)(grouped[parent], function (obj) {
	          var item = _react2.default.createElement(
	            _reactBootstrapTypeahead.MenuItem,
	            { key: idx, option: obj, position: idx },
	            obj.label
	          );
	
	          idx++;
	          return item;
	        })];
	      });
	
	      return _react2.default.createElement(
	        _reactBootstrapTypeahead.Menu,
	        menuProps,
	        [match_items, items]
	      );
	    }
	  }, {
	    key: "handleSearchChange",
	    value: function handleSearchChange(e) {
	      var _this10 = this;
	
	      this.setState({
	        highlightId: 0,
	        highlightAid: 0,
	        hightlightCid: 0,
	        selectKeyPair: {}
	      });
	      if (e) {
	        var result = e[0];
	        if (result) {
	          this.setState({ highlightId: result["id"] });
	          var demoAttributes = this.props.demoAttributes;
	
	
	          (0, _lodash.map)(demoAttributes, function (cat) {
	            var group_id = "cat-attr-" + cat.id + "-item-group";
	
	            (0, _lodash.map)((0, _lodash.flattenDeep)(cat.attributes), function (attr) {
	              if (attr.id === result["id"]) {
	                _this10.setState({ selectKeyPair: attr, hightlightCid: cat.id });
	                _reactDom2.default.findDOMNode(_this10.refs[group_id]).style.height = "auto";
	              }
	              (0, _lodash.map)(attr.values, function (val) {
	                if (val.id === result["id"]) {
	                  _this10.setState({
	                    highlightAid: val.id,
	                    hightlightCid: cat.id,
	                    selectKeyPair: attr
	                  });
	                  _reactDom2.default.findDOMNode(_this10.refs[group_id]).style.height = "auto";
	                }
	              });
	              (0, _lodash.map)(attr.subAttributes, function (subAttr) {
	                (0, _lodash.map)(subAttr.values, function (val) {
	                  if (val.id === result["id"]) {
	                    _this10.setState({
	                      highlightAid: val.id,
	                      hightlightCid: cat.id,
	                      selectKeyPair: attr
	                    });
	                    _reactDom2.default.findDOMNode(_this10.refs[group_id]).style.height = "auto";
	                  }
	                });
	              });
	            });
	          });
	        }
	      }
	    }
	  }, {
	    key: "generateCatNode",
	    value: function generateCatNode(category, group_items) {
	      var group_id = "cat-attr-" + category.id + "-item-group";
	      var highlightBySearch = this.state.hightlightCid === category.id;
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "list-group-item attr-cat-item ",
	          key: "group-div-" + group_id
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "panel-heading ", style: { padding: "0px" } },
	          _react2.default.createElement(
	            "p",
	            { className: "panel-title font-1em" },
	            _react2.default.createElement(
	              "a",
	              {
	                "data-toggle": "collapse",
	                id: group_id + "_link",
	                "data-parent": "#accordion-control",
	                href: "#" + group_id,
	                "aria-expanded": highlightBySearch ? "true" : "false",
	                className: highlightBySearch ? "" : "collapsed"
	              },
	              category.name
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            id: group_id,
	            ref: group_id,
	            "aria-expanded": highlightBySearch ? "true" : "false",
	            className: highlightBySearch ? "panel-collapse collapse in" : "panel-collapse collapse"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "panel-body pt-5 pt-5  pr-5",
	              style: { paddingLeft: "0px" }
	            },
	            group_items
	          )
	        )
	      );
	    }
	  }, {
	    key: "displayCategoryNodes",
	    value: function displayCategoryNodes() {
	      var _this11 = this;
	
	      var demoAttributes = this.props.demoAttributes;
	
	      var result = [];
	
	      (0, _lodash.map)(demoAttributes, function (category) {
	        var group_items = [];
	        /*
	        if (
	          category.id === 14 &&
	          this.props.client_info &&
	          this.props.client_info.subscriptionTierId !== 4
	        ) {
	          return;
	        }*/
	        var attributes = category.attributes;
	        (0, _lodash.forEach)(attributes, function (attr) {
	          var already_selected = _this11.state.selectKeyPair && _this11.state.selectKeyPair.id === attr.id;
	          if (attr.id === 605) {
	            attr.name = "Auto Make/Model";
	            var attrAutoMake = attributes.find(function (item) {
	              return item.id === 605;
	            });
	            var attrAutoModel = attributes.find(function (item) {
	              return item.id === 606;
	            });
	            var auto_item_element = _this11.generateAutoMakeItem(already_selected, attrAutoMake, attrAutoModel);
	
	            group_items.push(auto_item_element);
	          } else if (attr.id === 1502) {
	            var attrCultureRegion = attributes.find(function (item) {
	              return item.id === 1502;
	            });
	            var attrCultureLocale = attributes.find(function (item) {
	              return item.id === 1503;
	            });
	            var _auto_item_element = _this11.generateClutureRegionItem(already_selected, attrCultureRegion, attrCultureLocale);
	
	            group_items.push(_auto_item_element);
	          } else {
	            var item_element = _this11.generateItem(already_selected, attr, attr.id);
	
	            group_items.push(item_element);
	          }
	        });
	
	        var node_element = _this11.generateCatNode(category, group_items);
	        result.push(node_element);
	        if (category !== (0, _lodash.last)(demoAttributes)) {
	          result.push(_react2.default.createElement("div", {
	            key: "cat-divider-" + category.id,
	            className: "list-group-divider"
	          }));
	        }
	      });
	      return result;
	    }
	  }, {
	    key: "_handleCancelPlotted",
	    value: function _handleCancelPlotted() {
	      this.setState({
	        plotted_values: null
	      });
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 50);
	    }
	  }, {
	    key: "handleApplyPlotted",
	    value: function handleApplyPlotted(val) {
	      this.props.clearAllSelectedState();
	      this.props.clearAllSelectedCity();
	      this.props.clearAllZipCode();
	      this.props.setPlotValues(val);
	      this.setState({
	        plotted_values: null
	      });
	      var plottedRules = [];
	      var rule = (0, _segment_util.parsePlottedValues)(val);
	      if (rule) {
	        plottedRules.push(rule);
	        setTimeout(function () {
	          this.props.getPlottedAudienceCount({
	            rules: plottedRules,
	            filtered: {
	              targetHouseholdsOnly: Boolean(this.props.targetHouseholdsOnly)
	            }
	          }, this.props.segment_id);
	        }.bind(this), 100);
	      }
	
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 100);
	    }
	  }, {
	    key: "nextStep",
	    value: function nextStep() {
	      this.props.selectSegment(this.state.selected_segments);
	    }
	  }, {
	    key: "handleAddLocation",
	    value: function handleAddLocation(e) {
	      e.preventDefault();
	      this.setState({
	        ifShowState: true
	      });
	    }
	  }, {
	    key: "reCalculateTotal",
	    value: function reCalculateTotal(targetOnly) {
	      if (this.props.zipcode.length > 0) {
	        this.setState({
	          onCalculating: true
	        });
	        var _newSegment = (0, _segment_util.parseZipcode)(this.props, this.props.segment_name);
	        this.props.getZipcodeAudienceCount({
	          rules: _newSegment.rules,
	          filtered: {
	            targetHouseholdsOnly: !(0, _lodash.isUndefined)(targetOnly) ? Boolean(targetOnly) : Boolean(this.props.targetHouseholdsOnly)
	          }
	        }, this.props.segment_id);
	      }
	
	      var newSegment = (0, _segment_util.parseSegment)(this.props, this.props.segment_name, this.state.plotted_values);
	
	      if (newSegment.rules.length > 0 || this.props.selected_city.length > 0 || this.props.selected_state.length > 0 || this.props.zipcode.length > 0 || this.props.selected_dma.length > 0 || this.props.selected_county.length > 0 || !(0, _lodash.isEmpty)(this.props.plotted_values)) {
	        var _props4 = this.props,
	            demoAttributes = _props4.demoAttributes,
	            getCategoryAudienceCount = _props4.getCategoryAudienceCount,
	            targetHouseholdsOnly = _props4.targetHouseholdsOnly,
	            segment_id = _props4.segment_id;
	
	
	        this.setState({
	          onCalculating: true
	        });
	        this.props.getAudienceCount({
	          rules: newSegment.rules,
	          filtered: {
	            targetHouseholdsOnly: !(0, _lodash.isUndefined)(targetOnly) ? Boolean(targetOnly) : Boolean(targetHouseholdsOnly)
	          }
	        }, this.props.segment_id);
	
	        demoAttributes.forEach(function (cat) {
	          cat.attributes.forEach(function (attr) {
	            var parentId = attr.id;
	            var catRules = [];
	            if (attr.subAttributes) {
	              attr.subAttributes.forEach(function (subAttr) {
	                var _r = newSegment.rules.find(function (rule) {
	                  return rule.attributeId === subAttr.id;
	                });
	                if (_r) catRules.push(_r);
	              });
	            }
	            if (catRules.length > 0) {
	              getCategoryAudienceCount({
	                rules: catRules,
	                categoryId: parentId,
	                filtered: {
	                  targetHouseholdsOnly: !(0, _lodash.isUndefined)(targetOnly) ? Boolean(targetOnly) : Boolean(targetHouseholdsOnly)
	                }
	              }, segment_id);
	            }
	          });
	        });
	      } else {
	        if (this.state.plotted_values || this.props.zipcode.length > 0) {
	          this.setState({
	            onCalculating: true
	          });
	          var _newSegment2 = (0, _segment_util.parseSegment)(this.props, this.props.segment_name, this.state.plotted_values);
	          this.props.getAudienceCount({
	            rules: _newSegment2.rules,
	            filtered: {
	              targetHouseholdsOnly: !(0, _lodash.isUndefined)(targetOnly) ? Boolean(targetOnly) : Boolean(this.props.targetHouseholdsOnly)
	            }
	          }, this.props.segment_id);
	        } else {
	          this.props.clearAudienceCount();
	        }
	      }
	    }
	  }, {
	    key: "calCatetoryAudience",
	    value: function calCatetoryAudience(categoryId, selectedAttr) {}
	  }, {
	    key: "handleCountySelected",
	    value: function handleCountySelected(countyObj, label, isChecked) {
	      this.props.selectCounty(countyObj, label, isChecked);
	    }
	  }, {
	    key: "handleDMASelected",
	    value: function handleDMASelected(dmaObj, label, isChecked) {
	      this.props.selectDMA(dmaObj, label, isChecked);
	    }
	  }, {
	    key: "handleCitySelected",
	    value: function handleCitySelected(cityObj, label, isChecked) {
	      this.props.selectCity(cityObj, label, isChecked);
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 100);
	    }
	  }, {
	    key: "handleStateSelected",
	    value: function handleStateSelected(stateObj, isChecked) {
	      this.props.selectState(stateObj, isChecked);
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 100);
	    }
	  }, {
	    key: "handleZipcodeAdded",
	    value: function handleZipcodeAdded(zipcode) {
	      this.props.addZipCode(zipcode);
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 100);
	    }
	  }, {
	    key: "handleAutoMakeSelected",
	    value: function handleAutoMakeSelected(makeObj, isChecked) {
	      this.props.selectMake(makeObj, isChecked);
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 200);
	    }
	  }, {
	    key: "handleAutoModelSelected",
	    value: function handleAutoModelSelected(modelObj, isChecked) {
	      this.props.selectModel(modelObj, isChecked);
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 200);
	    }
	  }, {
	    key: "handleCultureRegionSelected",
	    value: function handleCultureRegionSelected(obj, isChecked) {
	      this.props.selectCultureRegion(obj, isChecked);
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 200);
	    }
	  }, {
	    key: "handleCultureLocaleSelected",
	    value: function handleCultureLocaleSelected(obj, isChecked) {
	      this.props.selectCultureLocale(obj, isChecked);
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 200);
	    }
	    // filter right panel 111
	
	  }, {
	    key: "displayRightPanel",
	    value: function displayRightPanel() {
	      var _this12 = this;
	
	      if (this.state.ifShowState) {
	        return _react2.default.createElement(_AddLocation2.default, {
	          allstates: this.props.allstates,
	          selected_city: this.props.selected_city,
	          selected_county: this.props.selected_county,
	          selected_dma: this.props.selected_dma,
	          selected_state: this.props.selected_state,
	          selectCity: this.handleCitySelected.bind(this),
	          selectCounty: this.handleCountySelected.bind(this),
	          reCalculateTotal: this.reCalculateTotal.bind(this),
	          selectDMA: this.handleDMASelected.bind(this),
	          selectState: this.handleStateSelected.bind(this),
	          getCities: this.props.getCities,
	          counties: this.props.counties,
	          dmas: this.props.dmas,
	          allcities: this.props.allcities,
	          addZipCode: this.handleZipcodeAdded.bind(this),
	          zipcode: this.props.zipcode,
	          clearAllSelectedState: this.props.clearAllSelectedState,
	          clearAllSelectedCity: this.props.clearAllSelectedCity,
	          clearAllDMA: this.props.clearAllDMA,
	          clearAllCounty: this.props.clearAllCounty,
	          clearAllZipCode: this.props.clearAllZipCode,
	          clearMapPlotted: function clearMapPlotted() {
	            _this12.props.setPlotValues({});
	          },
	          all_state_cities: this.props.all_state_cities,
	          ifLoading: this.props.ifLoading
	        });
	      } else if (this.state.ifShowAutoMake) {
	        return _react2.default.createElement(_AutoMake2.default, {
	          demoAttributes: this.props.demoAttributes,
	          selectMake: this.handleAutoMakeSelected.bind(this),
	          selected_make: this.props.selected_make,
	          selectModel: this.handleAutoModelSelected.bind(this),
	          selected_model: this.props.selected_model,
	          selectSegment: this.props.selectSegment,
	          selected_segments: this.props.selected_segments,
	          make_active_arr: this.props.make_active_arr,
	          addMakeActive: this.props.addMakeActive
	        });
	      } else if (this.state.ifShowCultureRegion) {
	        return _react2.default.createElement(_CultureCode2.default, {
	          demoAttributes: this.props.demoAttributes,
	          selectMake: this.handleCultureLocaleSelected.bind(this),
	          selected_make: this.props.selected_culture_locale,
	          selectModel: this.handleCultureRegionSelected.bind(this),
	          selected_model: this.props.selected_culture_region,
	          selectSegment: this.props.selectSegment,
	          selected_segments: this.props.selected_segments,
	          make_active_arr: this.props.region_active_arr,
	          addMakeActive: this.props.addRegionActive
	        });
	      } else {
	        return this.displayAttrValues();
	      }
	    }
	    // control the Auto make been clicked
	
	  }, {
	    key: "handleAttributeItemClick",
	    value: function handleAttributeItemClick(e, attr) {
	      if (e.target.innerText === "Auto Make/Model") {
	        this.setState({
	          ifShowAutoMake: true,
	          ifShowState: false,
	          ifShowCultureRegion: false,
	          selectKeyPair: attr
	        });
	      } else if (e.target.innerText == "Region/Locale") {
	        this.setState({
	          ifShowAutoMake: false,
	          ifShowState: false,
	          ifShowCultureRegion: true,
	          selectKeyPair: attr
	        });
	      } else {
	        this.setState({
	          selectKeyPair: attr,
	          ifShowState: false,
	          ifShowCultureRegion: false,
	          ifShowAutoMake: false // close auto make panel
	        });
	      }
	    }
	  }, {
	    key: "computedStateOrCityAttibute",
	    value: function computedStateOrCityAttibute(storeData, property) {
	      return storeData ? storeData.reduce(function (acc, curr) {
	        return acc + curr[property];
	      }, 0) : 0;
	    }
	  }, {
	    key: "gotoNext",
	    value: function gotoNext(e) {
	      e.preventDefault();
	      if (this.props.segment_id && this.props.segment_id !== "") {
	        this.props.verifySegmentNameAndContinue(this.props.selected_client, this.props.segment_name, this.props.segment_id);
	      } else {
	        this.props.verifyAndContinue(this.props.selected_client, this.props.segment_name);
	      }
	    }
	  }, {
	    key: "updateAudienceCountWithPlotted",
	    value: function updateAudienceCountWithPlotted(plottedRadius) {
	      this.setState({
	        plotted_values: plottedRadius
	      });
	      setTimeout(function () {
	        this.reCalculateTotal();
	      }.bind(this), 20);
	    }
	  }, {
	    key: "handleSegmentNameChange",
	    value: function handleSegmentNameChange(e) {
	      this.props.setSegmentName(e.target.value);
	    }
	  }, {
	    key: "nextButtonHover",
	    value: function nextButtonHover(hasSelectedSegments) {
	      if (!hasSelectedSegments || this.state.plotted_values != null) {
	        this.setState({
	          toolTipStatus: true
	        });
	      }
	    }
	  }, {
	    key: "nextButtonMouseOut",
	    value: function nextButtonMouseOut() {
	      this.setState({
	        toolTipStatus: false
	      });
	    }
	  }, {
	    key: "openContactFormClick",
	    value: function openContactFormClick(e) {
	      e.preventDefault();
	      this.setState({
	        openContactForm: true,
	        showSaveErrorDialog: false
	      });
	    }
	  }, {
	    key: "onContactFormSubmit",
	    value: function onContactFormSubmit(e, subject, comments) {
	      e.preventDefault();
	      var postData = {
	        clientId: this.props.selected_client,
	        subject: subject.trim(),
	        comment: comments.trim(),
	        type: "upgrade",
	        originationPage: "Audience Segment Maximum Threshold Overlay Message"
	      };
	
	      this.props.sendAssistRequest(postData);
	    }
	  }, {
	    key: "cancelContactForm",
	    value: function cancelContactForm(e) {
	      e.preventDefault();
	      this.setState({
	        openContactForm: false,
	        showSaveErrorDialog: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this13 = this;
	
	      var _props5 = this.props,
	          selected_city = _props5.selected_city,
	          selected_state = _props5.selected_state,
	          selected_county = _props5.selected_county,
	          selected_dma = _props5.selected_dma;
	
	      var viewSltAttrBtn = _react2.default.createElement("i", {
	        className: this.state.openSelectedDialog ? "glyphicon glyphicon-chevron-down" : "glyphicon glyphicon-chevron-up"
	      });
	      var segmentNameOnChange = (0, _utility.debounceEventHandler)(this.handleSegmentNameChange.bind(this), 500);
	      var sltAttrCount = 0;
	      if (this.props.selected_segments && this.props.selected_segments.length > 0) sltAttrCount = this.props.selected_segments.length;
	      if (!(0, _lodash.isEmpty)(this.props.plotted_values)) sltAttrCount += 1;
	      if (this.props.selected_state && this.props.selected_state.length > 0) sltAttrCount += this.props.selected_state.length;
	      if (this.props.selected_city && this.props.selected_city.length > 0) sltAttrCount += this.props.selected_city.length;
	      if (this.props.zipcode && this.props.zipcode.length > 0) sltAttrCount += this.props.zipcode.length;
	      if (this.props.selected_county && this.props.selected_county.length > 0) sltAttrCount += this.props.selected_county.length;
	      if (this.props.selected_dma && this.props.selected_dma.length > 0) sltAttrCount += this.props.selected_dma.length;
	      var hasSelectedSegments = sltAttrCount > 0; //this.props.selected_segments && this.props.selected_segments.length > 0
	      return _react2.default.createElement(
	        "div",
	        { id: "CreateSegment" },
	        _react2.default.createElement(
	          _Grid.FullRow,
	          {
	            style: {
	              marginTop: "-60px",
	              marginLeft: "-30px",
	              paddingBottom: "0px"
	            }
	          },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Create an Audience Segment"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "font-12em no-margin-bottom" },
	            "Select a combination of geographic and demographic attributes for your audience segment."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              minHeight: "500px",
	              backgroundColor: "#CCC",
	              padding: "10px 40px",
	              marginTop: "15px"
	            }
	          },
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              style: {
	                margin: "0px",
	                padding: "0px 0px 10px 0px",
	                marginRight: "-20px"
	              }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "8", sm: "8", md: "8", lg: "8" },
	              "\xA0"
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "4", sm: "4", md: "4", lg: "4" },
	              _react2.default.createElement(
	                "div",
	                { className: "pull-right" },
	                sltAttrCount > 0 ? _react2.default.createElement(
	                  "a",
	                  { onClick: this.toggleSelectedAttrDialog },
	                  "Attributes Added ",
	                  sltAttrCount,
	                  "\xA0\xA0",
	                  viewSltAttrBtn
	                ) : "Attributes Added "
	              )
	            ),
	            _react2.default.createElement(
	              _materialUi.Dialog,
	              {
	                open: this.state.openSelectedDialog,
	                onRequestClose: this.closeSelectedAttrDialog,
	                modal: false,
	                autoScrollBodyContent: true,
	                contentStyle: {
	                  width: this.state.width + "px",
	                  maxWidth: "none"
	                },
	                actions: [_react2.default.createElement(
	                  "a",
	                  {
	                    className: "btn btn-default btn-xlg legitRipple bg-teal-400",
	                    style: { marginRight: "56px" },
	                    onClick: this.closeSelectedAttrDialog
	                  },
	                  "Close"
	                )]
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "text-default no-padding no-margin",
	                  style: { marginTop: "-40px !important" }
	                },
	                _react2.default.createElement(_SelectedAttrs2.default, {
	                  selectedAttrs: this.props.selected_segments,
	                  plottedRadius: this.props.plotted_values,
	                  selected_state: this.props.selected_state,
	                  selected_city: this.props.selected_city,
	                  selected_county: this.props.selected_county,
	                  selected_dma: this.props.selected_dma,
	                  categories: this.props.demoAttributes,
	                  clearAllSelectedCity: this.props.clearAllSelectedCity,
	                  clearAllZipCode: this.props.clearAllZipCode,
	                  clearZipCode: this.props.clearZipCode,
	                  clearAllCounty: this.props.clearAllCounty,
	                  clearAllDMA: this.props.clearAllDMA,
	                  selectState: this.props.selectState,
	                  selectCity: this.props.selectCity,
	                  selectCounty: this.props.selectCounty,
	                  selectDMA: this.props.selectDMA,
	                  zipcode: this.props.zipcode,
	                  width: this.state.width,
	                  removeAttribute: this.removeSelectedVal.bind(this),
	                  removePlottedVal: this.removePlottedVal.bind(this),
	                  selected_make: this.props.selected_make,
	                  selected_model: this.props.selected_model
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "pull-right",
	                  style: {
	                    position: "absolute",
	                    top: "40px",
	                    left: this.state.width - 80 + "px"
	                  }
	                },
	                _react2.default.createElement(
	                  "a",
	                  { onClick: this.closeSelectedAttrDialog },
	                  _react2.default.createElement("i", { className: "icon-cancel-square text-teal-400" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              className: "no-padding",
	              style: {
	                backgroundColor: "#FFF",
	                display: this.state.openMapDialog ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "panel-body no-padding",
	                style: { maxHeight: "480px", overflow: "auto" }
	              },
	              _react2.default.createElement(_Map2.default, {
	                key: this.state.mapKey,
	                onClose: this.closeMapSelectDialog,
	                getAudienceCount: this.props.getAudienceCount,
	                clearAudienceCount: this.props.clearAudienceCount,
	                onUpdateAudienceCount: this.updateAudienceCountWithPlotted.bind(this),
	                onApplyChanges: this.handleApplyPlotted.bind(this),
	                onCancelChanges: this._handleCancelPlotted.bind(this),
	                plottedValue: this.props.plotted_values
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              style: {
	                backgroundColor: "#FFF",
	                display: this.state.openMapDialog ? "none" : "block"
	              }
	            },
	            _react2.default.createElement(
	              _Grid.Col,
	              { xs: "5", sm: "5", md: "5", lg: "5" },
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "no-margin no-padding pb-20 " },
	                _react2.default.createElement(
	                  "span",
	                  {
	                    className: "input-group mt-5",
	                    style: { width: "100%", marginLeft: "-10px" }
	                  },
	                  _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	                    labelKey: "label",
	                    options: this.props.value_typehead,
	                    placeholder: "Find an Attribute",
	                    minLength: 1,
	                    renderMenu: this.renderSearchMenu.bind(this),
	                    onChange: this.handleSearchChange.bind(this),
	                    onInputChange: this.onSearchInputChange.bind(this),
	                    ref: function ref(typeahead) {
	                      return _this13.typeahead = typeahead;
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "form-control-feedback ",
	                      style: { width: "54px" }
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-uppercase no-padding no-margin" },
	                      "search"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "panel-body border-right-slate border-right",
	                  style: {
	                    maxHeight: "480px",
	                    overflow: "auto",
	                    paddingTop: "0px",
	                    marginTop: "-20px",
	                    paddingLeft: "0px"
	                  }
	                },
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Category"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "list-group panel-group-control mt-10",
	                    style: { fontSize: "1.2em !important" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "list-group-item attr-cat-item " },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "panel-heading", style: { padding: "0px" } },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "panel-title font-1em" },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            "data-toggle": "collapse",
	                            id: "cat-geography-item-group_link",
	                            "data-parent": "#accordion-control",
	                            href: "#geograph_parent",
	                            "aria-expanded": "false",
	                            className: "collapsed full-width"
	                          },
	                          "Geography",
	                          _react2.default.createElement(
	                            "span",
	                            { className: "pull-right category-tips" },
	                            _react2.default.createElement(
	                              _reactTooltipLite2.default,
	                              {
	                                direction: "right",
	                                content: _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "p-10 black-border",
	                                    style: { background: "#FFFF" }
	                                  },
	                                  (0, _utility.text_definition)("state_category_tips")
	                                )
	                              },
	                              _react2.default.createElement(
	                                "span",
	                                { className: "text-blue" },
	                                "Tips"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        id: "geograph_parent",
	                        className: "panel-collapse collapse",
	                        "aria-expanded": "false",
	                        ref: "cat-geography-item-group"
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "panel-body pt-5 pb-10 pr-5",
	                          style: { paddingLeft: "25px" }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "add-location-parent clearfix" },
	                          _react2.default.createElement(
	                            _Grid.Col,
	                            {
	                              xs: "9",
	                              sm: "9",
	                              md: "9",
	                              lg: "9",
	                              style: { paddingLeft: 0 }
	                            },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                onClick: function onClick(e) {
	                                  return _this13.handleAddLocation(e);
	                                },
	                                className: "font-12em"
	                              },
	                              "Add a Location"
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "text-muted text-light ml-10",
	                                style: {
	                                  display: this.props.selected_state && this.props.selected_state.length > 0 || this.props.selected_city && this.props.selected_city.length > 0 || this.props.zipcode && this.props.zipcode.length > 0 || this.props.selected_county && this.props.selected_county.length > 0 || this.props.selected_dma && this.props.selected_dma.length > 0 ? "inline" : "none"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "small",
	                                null,
	                                this.props.zipcode_audience_count ? (0, _utility.splitNumber)(this.props.zipcode_audience_count.total)() : (0, _utility.splitNumber)(this.computedStateOrCityAttibute(selected_state, "total") + this.computedStateOrCityAttibute(selected_city, "total") + this.computedStateOrCityAttibute(selected_county, "total") + this.computedStateOrCityAttibute(selected_dma, "total"))()
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _Grid.Col,
	                            {
	                              xs: "3",
	                              sm: "3",
	                              md: "3",
	                              lg: "3",
	                              style: { paddingLeft: "5px" }
	                            },
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "text-teal-400",
	                                style: {
	                                  display: this.props.selected_state.length > 0 || this.props.selected_city.length > 0 || this.props.zipcode.length > 0 || this.props.selected_county && this.props.selected_county.length > 0 || (this.props.selected_dma && this.props.selected_dma.length) > 0 ? "inline" : "none"
	                                }
	                              },
	                              _react2.default.createElement("i", { className: "icon-checkmark4 " })
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "pull-right",
	                                style: {
	                                  display: this.state.ifShowState ? "none" : "block"
	                                }
	                              },
	                              ">"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "plot-radius-parent" },
	                          _react2.default.createElement(
	                            _Grid.Col,
	                            {
	                              xs: "9",
	                              sm: "9",
	                              md: "9",
	                              lg: "9",
	                              style: { paddingLeft: 0 }
	                            },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                onClick: function onClick(e) {
	                                  e.preventDefault();
	                                  _this13.setState({
	                                    openMapDialog: true,
	                                    ifShowState: false
	                                  });
	                                },
	                                className: "font-12em",
	                                style: { float: "left" }
	                              },
	                              "Plot a Custom Radius"
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "text-muted text-light ml-10",
	                                style: {
	                                  display: this.props.plotted_values && this.props.plotted_values.audienceCount ? "inline" : "none"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "small",
	                                null,
	                                this.props.plotted_values && this.props.plotted_values.audienceCount && (0, _utility.splitNumber)(this.props.plotted_values.audienceCount.total + "")()
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _Grid.Col,
	                            {
	                              xs: "3",
	                              sm: "3",
	                              md: "3",
	                              lg: "3",
	                              style: { paddingLeft: "5px" }
	                            },
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "text-teal-400",
	                                style: {
	                                  display: this.props.plotted_values && this.props.plotted_values.audienceCount ? "inline" : "none"
	                                }
	                              },
	                              _react2.default.createElement("i", { className: "icon-checkmark4 " })
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              { className: "pull-right" },
	                              ">"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement("div", { className: "list-group-divider" }),
	                  this.displayCategoryNodes()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Grid.Col,
	              {
	                xs: "7",
	                sm: "7",
	                md: "7",
	                lg: "7",
	                className: "value-list",
	                style: { paddingRight: "0px" }
	              },
	              this.displayRightPanel()
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "flex",
	                marginLeft: "-10px",
	                marginRight: "-10px",
	                padding: "20px 0"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  width: "33%",
	                  paddingRight: "20px",
	                  flexShrink: "1"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "target-primary-box" },
	                _react2.default.createElement(_materialUi.Checkbox, {
	                  ref: "targetHouseholdsOnly",
	                  label: "Target Primary Decision Maker",
	                  labelStyle: { width: "115%" },
	                  defaultChecked: this.props.targetHouseholdsOnly,
	                  onCheck: function onCheck(e) {
	                    _this13.props.setTargetHouseholdOnly(e.target.checked);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "audience-box" },
	                _react2.default.createElement(
	                  "label",
	                  null,
	                  "Audience"
	                ),
	                this.state.onCalculating === true ? _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } }) : _react2.default.createElement("input", {
	                  className: "full-width input-md text-default text-bold pl-5",
	                  readOnly: true,
	                  value: this.state.resetAllCount ? 0 : (0, _utility.splitNumber)(this.calTotalAudience().total + "")()
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  flexGrow: "1"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "reach-by-channel" },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Reach by Channel"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "channel-icon-btn" },
	                  _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                      className: "pull-right no-margin no-padding",
	                      style: { width: "24px", height: "24px" }
	                    },
	                    _react2.default.createElement(_moreHoriz2.default, {
	                      className: "text-grey-400",
	                      style: { width: "24px", height: "24px" }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "channel-items" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "channel-col" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "channel-item" },
	                    _react2.default.createElement("img", {
	                      className: "channel-icon",
	                      src: "/images/channel-icon1.png"
	                    }),
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Display:"
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.resetAllCount ? 0 : this.state.onCalculating === true ? "" : (0, _utility.splitNumber)(this.calTotalAudience()["display"] + "")()
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "channel-col" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "channel-item" },
	                    _react2.default.createElement("img", {
	                      className: "channel-icon",
	                      src: "/images/channel-icon2.png"
	                    }),
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Social:"
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.resetAllCount ? 0 : this.state.onCalculating === true ? "" : (0, _utility.splitNumber)(this.calTotalAudience()["social"] + "")()
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "channel-col", style: { paddingRight: 0 } },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "channel-item" },
	                    _react2.default.createElement("img", {
	                      className: "channel-icon",
	                      src: "/images/channel-icon3.png"
	                    }),
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "Email:"
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      this.state.resetAllCount ? 0 : this.state.onCalculating === true ? "" : (0, _utility.splitNumber)(this.calTotalAudience()["email"] + "")()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Row,
	            {
	              style: { margin: "-20px -20px -30px -30px", paddingRight: "0px" },
	              className: "border-top border-top-white "
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  color: "#ff0000",
	                  display: this.state.errorVisible ? "block" : "none"
	                }
	              },
	              "This segment name already exists, please enter a unique segment name to continue"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-20" },
	              _react2.default.createElement("input", {
	                ref: "segmentNameInput",
	                className: "full-width input-lg pl-10",
	                placeholder: " Name this Segment",
	                maxLength: 60,
	                onFocus: function onFocus(e) {
	                  _this13.setState({ errorVisible: false });
	                },
	                onChange: segmentNameOnChange.bind(this),
	                defaultValue: this.props.segment_name
	              }),
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-addon" },
	                _react2.default.createElement(
	                  _reactTooltipLite2.default,
	                  {
	                    direction: "left",
	                    content: _react2.default.createElement(
	                      "div",
	                      {
	                        className: "p-10 black-border",
	                        style: { background: "#FFFF" }
	                      },
	                      (0, _utility.text_definition)("segment_info")
	                    )
	                  },
	                  _react2.default.createElement(_infoOutline2.default, null)
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Row,
	          { className: "no-margin-bottom pb-10" },
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: "1", sm: "1", md: "1", lg: "1" },
	            _react2.default.createElement(
	              _materialUi.Popover,
	              {
	                open: this.state.openCancel,
	                anchorEl: this.state.cancelAnchorEl,
	                anchorOrigin: { horizontal: "right", vertical: "top" },
	                targetOrigin: { horizontal: "left", vertical: "center" },
	                onRequestClose: this.handleRequestClose
	              },
	              _react2.default.createElement(
	                _Grid.FullRow,
	                { className: "text-default" },
	                "Are you sure you want to exit?",
	                _react2.default.createElement("br", null),
	                "Any selections you have made will not be saved",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "btn btn-link btn-sm cancel-btn mr-20 text-bold",
	                    onClick: function onClick(e) {
	                      _this13.handleOpenCancelDialog(e, false);
	                    }
	                  },
	                  "Close"
	                ),
	                "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "btn btn-default btn-round btn-sm btn-aa-primary ml-20",
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      window.location = "/segments/list/active" + (_this13.props.selected_client ? "?cid=" + _this13.props.selected_client : "");
	                    }
	                  },
	                  "Yes, exit"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-link cancel-btn ",
	                style: { marginLeft: "-5px" },
	                onClick: function onClick(e) {
	                  _this13.handleOpenCancelDialog(e, true);
	                }
	              },
	              "Cancel"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            {
	              xs: "11",
	              sm: "11",
	              md: "11",
	              lg: "11",
	              className: "text-right",
	              style: { position: "relative" }
	            },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              disabled: !(this.props.plotted_values || hasSelectedSegments) || !this.props.segment_name || this.props.segment_name === "" && this.props.copy_segment_name.length > 0,
	              backgroundColor: (0, _utility.primaryColor)(),
	              labelColor: "#FFF",
	              onClick: this.gotoNext.bind(this),
	              onMouseOver: function onMouseOver() {
	                return _this13.nextButtonHover(hasSelectedSegments);
	              } // author chargo
	              , onMouseOut: function onMouseOut() {
	                return _this13.nextButtonMouseOut();
	              } // author chargo
	              , style: {
	                marginRight: "3em",
	                marginBottom: "10px",
	                backgroundColor: (0, _utility.primaryColor)()
	              },
	              label: "Next"
	            }),
	            this.state.toolTipStatus && !this.state.plotted_values && _react2.default.createElement(
	              "div",
	              {
	                className: "tool-tip",
	                style: {
	                  position: "absolute",
	                  fontSize: "12px",
	                  textAlign: "left",
	                  top: 0,
	                  width: "18em",
	                  right: "13em",
	                  padding: "6px",
	                  border: "1px solid rgb(211, 211, 211)",
	                  borderRadius: "0.2em"
	                }
	              },
	              "You must select at least one attribute and name this segment to continue."
	            ),
	            this.state.plotted_values != null && this.state.toolTipStatus && _react2.default.createElement(
	              "div",
	              {
	                className: "tool-tip",
	                style: {
	                  position: "absolute",
	                  fontSize: "12px",
	                  textAlign: "left",
	                  top: 0,
	                  width: "18em",
	                  right: "13em",
	                  padding: "6px",
	                  border: "1px solid rgb(211, 211, 211)",
	                  borderRadius: "0.2em"
	                }
	              },
	              "Please apply your change of plotted radius."
	            )
	          )
	        ),
	        _react2.default.createElement(_LimitExceeded2.default, {
	          showSaveErrorDialog: this.state.showSaveErrorDialog,
	          history: this.props.history,
	          showSuccessForm: this.state.showSuccessForm,
	          openContactForm: this.state.openContactForm,
	          roleId: this.props.roleId,
	          openContactFormClick: this.openContactFormClick.bind(this),
	          cancelContactForm: this.cancelContactForm.bind(this),
	          onContactFormSubmit: this.onContactFormSubmit.bind(this)
	        })
	      );
	    }
	  }]);
	
	  return Creation;
	}(_react.Component);
	
	exports.default = Creation;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(19);
	
	var _SelectedAttrs = __webpack_require__(257);
	
	var _SelectedAttrs2 = _interopRequireDefault(_SelectedAttrs);
	
	var _utility = __webpack_require__(14);
	
	var _reactGoogleMaps = __webpack_require__(243);
	
	var _recharts = __webpack_require__(101);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(1439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
	var google = window.google;
	var CustomTooltip = _react2.default.createClass({
		displayName: 'CustomTooltip',
	
		propTypes: {
			datas: _propTypes2.default.array
		},
	
		render: function render() {
			var active = this.props.active;
	
	
			if (active) {
				var _props = this.props,
				    datas = _props.datas,
				    payload = _props.payload;
	
				var data = datas.find(function (obj) {
					return obj.name === payload[0].name;
				});
				var total = datas.reduce(function (sum, obj) {
					return sum + obj.value;
				}, 0);
				var percent = data ? data.value / total : 0;
	
				return _react2.default.createElement(
					'div',
					{ className: 'bg-white pl-20 pr-20 pt-10 pb-10', style: { width: "420px" } },
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'no-padding-left no-padding-bottom no-padding-top font-12em text-bold' },
						data.name
					),
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'no-padding-left no-padding-bottom no-padding-top text-black' },
						(percent * 100).toFixed(2) + '%'
					),
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'no-padding-left no-padding-bottom' },
						'Reach by Channel'
					),
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'no-padding no-padding-top' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '4', sm: '4', md: '4', lg: '4' },
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement('i', { className: 'icon-envelope', style: { fontSize: '1.2em' } }),
								_react2.default.createElement(
									'span',
									{ className: 'ml-10 text-default text-bold' },
									(0, _utility.splitNumber)(data.email + '')()
								)
							)
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '4', sm: '4', md: '4', lg: '4', style: { paddingRight: 0 } },
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement('i', { className: 'icon-share3', style: { fontSize: '1.2em' } }),
								_react2.default.createElement(
									'span',
									{ className: 'ml-10 text-default text-bold' },
									(0, _utility.splitNumber)(data.social + '')()
								)
							)
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '4', sm: '4', md: '4', lg: '4' },
							_react2.default.createElement(
								'p',
								{ className: 'pull-left' },
								_react2.default.createElement('i', { className: 'icon-display4', style: { fontSize: '1.2em' } }),
								_react2.default.createElement(
									'span',
									{ className: 'ml-10 text-default text-bold' },
									(0, _utility.splitNumber)(data.display + '')()
								)
							)
						)
					)
				);
			}
	
			return null;
		}
	});
	
	var SegmentAttribute = function (_Component) {
		_inherits(SegmentAttribute, _Component);
	
		function SegmentAttribute() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SegmentAttribute);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SegmentAttribute.__proto__ || Object.getPrototypeOf(SegmentAttribute)).call.apply(_ref, [this].concat(args))), _this), _this.renderCustomizedLabel = function (_ref2) {
				var cx = _ref2.cx,
				    cy = _ref2.cy,
				    midAngle = _ref2.midAngle,
				    innerRadius = _ref2.innerRadius,
				    outerRadius = _ref2.outerRadius,
				    percent = _ref2.percent,
				    index = _ref2.index;
	
				var radius = innerRadius + (outerRadius - innerRadius) * 0.5;
				var RADIAN = Math.PI / 180;
				var x = cx + radius * Math.cos(-midAngle * RADIAN);
				var y = cy + radius * Math.sin(-midAngle * RADIAN);
	
				return _react2.default.createElement(
					'text',
					{ x: x, y: y, fill: '#FFFFFF', textAnchor: x > cx ? 'start' : 'end', dominantBaseline: 'central' },
					(percent * 100).toFixed(0) + '%'
				);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SegmentAttribute, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.state = {
					viewMode: "chart"
				};
			}
		}, {
			key: 'handleMapMounted',
			value: function handleMapMounted(map) {
				this._map = map;
				if (this._map && this._vector) {
					try {
						this._map.fitBounds(this._vector.getBounds());
					} catch (ex) {}
				}
			}
		}, {
			key: 'getContent',
			value: function getContent(data) {
				var _this2 = this;
	
				if (this.state.viewMode === "chart") {
					var doms = [];
					(0, _lodash.map)(data, function (item, key) {
						if (key > 100) {
							var attrLabel = item.label;
							var attrTotal = item.total;
							var pairValueCount = 0;
							var subItems = [];
							(0, _lodash.map)(item, function (subItem, itemKey) {
								if ((typeof subItem === 'undefined' ? 'undefined' : _typeof(subItem)) === "object" && subItem !== null) {
									pairValueCount += 1;
									subItems.push({
										name: subItem.label, value: subItem.total,
										email: subItem.email,
										display: subItem.display.toString(),
										social: subItem.social
									});
								}
							});
							var dom = _react2.default.createElement(
								'div',
								{ key: "pair-values-panel-" + key, className: 'panel panel-flat bg-grey-300 segment-attr-panel', style: { backgroundColor: "#CCC", color: "#777" } },
								_react2.default.createElement(
									'div',
									{ className: 'panel-heading right-margin ', style: { padding: "0.5em 1em" } },
									pairValueCount > 1 ? attrLabel + ' (' + pairValueCount + ')' : attrLabel
								),
								_react2.default.createElement(
									'div',
									{ className: 'panel-body border-top right-margin no-padding-bottom ', style: { paddingRight: "3em", borderColor: "#E3E3D3" } },
									_react2.default.createElement(
										_Grid.Row,
										{ style: { padding: 0 } },
										_react2.default.createElement(
											_Grid.Col,
											{ xs: '4', sm: '4', md: '4', lg: '4', style: { paddingTop: '20px', paddingLeft: "50px" } },
											pairValueCount > 1 && _react2.default.createElement(
												_recharts.PieChart,
												{ width: 200, height: 150 },
												_react2.default.createElement(
													_recharts.Pie,
													{ dataKey: 'value', data: subItems, cx: 70, cy: 70,
														innerRadius: 30, outerRadius: 60, fill: '#26A69A' },
													subItems.map(function (entry, index) {
														return _react2.default.createElement(_recharts.Cell, { key: 'pie-cell-' + index, fill: COLORS[index % COLORS.length] });
													})
												),
												_react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(CustomTooltip, { datas: subItems }) })
											)
										),
										_react2.default.createElement(
											_Grid.Col,
											{ xs: '8', sm: '8', md: '8', lg: '8', className: 'pt-20' },
											(0, _lodash.map)(subItems, function (subItem, index) {
												return _react2.default.createElement(
													_Grid.Row,
													{ key: "pair-values-row-div-" + index, className: "no-margin-bottom pt-10", style: { padding: 0 } },
													_react2.default.createElement(
														_Grid.Col,
														{ xs: '8', md: '8', sm: '8', lg: '8', className: 'no-padding-right no-padding-left', style: { overflow: "hidden" } },
														_react2.default.createElement(
															'div',
															{ style: { float: "left" } },
															pairValueCount > 1 ? _react2.default.createElement(
																'span',
																{ className: 'span-legend', style: { background: COLORS[index % COLORS.length] } },
																'\xA0'
															) : "",
															subItem.name,
															'\xA0\xA0\xA0'
														),
														_react2.default.createElement(
															'div',
															{ style: { marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' } },
															'\xA0'
														)
													),
													_react2.default.createElement(
														_Grid.Col,
														{ xs: '4', md: '4', sm: '4', lg: '4', className: 'text-right no-padding-right no-padding-left', style: { overflow: "hidden" } },
														_react2.default.createElement(
															'div',
															{ style: { float: "right" } },
															'\xA0\xA0\xA0',
															(0, _utility.splitNumber)(subItem.value + '')()
														),
														_react2.default.createElement(
															'div',
															{ style: { marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' } },
															'\xA0'
														)
													)
												);
											}),
											_react2.default.createElement(
												_Grid.Row,
												{ style: { paddingLeft: 0, paddingRight: 0 } },
												_react2.default.createElement(
													_Grid.Col,
													{ xs: '6', sm: '6', md: '6', lg: '6', className: 'no-padding-left text-black ' },
													_react2.default.createElement(
														'strong',
														{ style: { color: "black" } },
														'Total Count'
													)
												),
												_react2.default.createElement(
													_Grid.Col,
													{ xs: '6', sm: '6', md: '6', lg: '6', className: 'text-right no-padding-right text-black' },
													_react2.default.createElement(
														'strong',
														{ style: { color: "black" } },
														(0, _utility.splitNumber)(attrTotal + '')()
													)
												)
											)
										)
									)
								)
							);
							doms.push(dom);
						}
					});
	
					if (this.props.rawData) {
						var raw = JSON.parse(this.props.rawData);
						if (raw.selected_city.length > 0 || raw.selected_state.length > 0 || raw.zipcode.length > 0) {
							var city_states = [];
							var zipcodes = [];
							var total_count = 0;
							(0, _lodash.map)(raw.selected_state, function (state) {
								city_states.push({ name: state.label, value: state.total, email: state.email, social: state.social, display: state.display });
								total_count += state.total;
							});
							(0, _lodash.map)(raw.selected_city, function (city) {
								city_states.push({ name: city.value + ", " + city.state, value: city.total, email: city.email, social: city.social, display: city.display });
								total_count += city.total;
							});
							(0, _lodash.map)(raw.zipcode, function (zipcode) {
								zipcodes.push({ name: zipcode.zipcode, value: zipcode.total, email: zipcode.email, social: zipcode.social, display: zipcode.display });
								total_count += zipcode.total;
							});
							if (city_states.length > 0) {
								var row = _react2.default.createElement(
									'div',
									{ key: 'city-state-panel', className: 'panel panel-flat bg-grey-300 city-state-panel', style: { backgroundColor: "#CCC", color: "#777" } },
									_react2.default.createElement(
										'div',
										{ className: 'panel-heading text-uppercase right-margin ', style: { padding: "0.5em 1em" } },
										city_states.length > 1 ? "US STATE/CITY (" + city_states.length + ")" : "US STATE/CITY"
									),
									_react2.default.createElement(
										'div',
										{ className: 'panel-body border-top right-margin  no-padding-bottom ', style: { paddingRight: "3em", borderColor: "#E3E3D3" } },
										_react2.default.createElement(
											_Grid.Row,
											{ className: 'no-padding-bottom', style: { padding: 0 } },
											_react2.default.createElement(
												_Grid.Col,
												{ xs: '4', sm: '4', md: '4', lg: '4', style: { height: "180px" } },
												city_states.length > 1 && _react2.default.createElement(
													_recharts.PieChart,
													{ width: 200, height: 150 },
													_react2.default.createElement(
														_recharts.Pie,
														{ dataKey: 'value', data: city_states, cx: 70, cy: 70,
															innerRadius: 30, outerRadius: 60, fill: '#26A69A' },
														city_states.map(function (entry, index) {
															return _react2.default.createElement(_recharts.Cell, { key: 'citystate-pie-cell-' + index, fill: COLORS[index % COLORS.length] });
														})
													),
													_react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(CustomTooltip, { datas: city_states }) })
												)
											),
											_react2.default.createElement(
												_Grid.Col,
												{ xs: '8', sm: '8', md: '8', lg: '8', className: 'pt-20' },
												(0, _lodash.map)(city_states, function (subItem, index) {
													return _react2.default.createElement(
														_Grid.Row,
														{ key: "city-state-row-div-" + index, className: "no-margin-bottom pt-10", style: { padding: 0 } },
														_react2.default.createElement(
															_Grid.Col,
															{ xs: '8', md: '8', sm: '8', lg: '8', className: 'no-padding-right no-padding-left', style: { overflow: "hidden" } },
															_react2.default.createElement(
																'div',
																{ style: { float: "left" } },
																city_states.length > 1 ? _react2.default.createElement(
																	'span',
																	{ className: 'span-legend', style: { background: COLORS[index % COLORS.length] } },
																	'\xA0'
																) : "",
																subItem.name,
																'\xA0\xA0\xA0'
															),
															_react2.default.createElement(
																'div',
																{ style: { marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' } },
																'\xA0'
															)
														),
														_react2.default.createElement(
															_Grid.Col,
															{ xs: '4', md: '4', sm: '4', lg: '4', className: 'text-right no-padding-right no-padding-left', style: { overflow: "hidden" } },
															_react2.default.createElement(
																'div',
																{ style: { float: "right" } },
																'\xA0\xA0\xA0',
																(0, _utility.splitNumber)(subItem.value + '')()
															),
															_react2.default.createElement(
																'div',
																{ style: { marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' } },
																'\xA0'
															)
														)
													);
												}),
												_react2.default.createElement(
													_Grid.Row,
													{ className: 'no-padding-left no-padding-right' },
													_react2.default.createElement(
														_Grid.Col,
														{ xs: '6', sm: '6', md: '6', lg: '6', className: 'no-padding-left text-black' },
														_react2.default.createElement(
															'strong',
															{ style: { color: "black" } },
															'Total Count'
														)
													),
													_react2.default.createElement(
														_Grid.Col,
														{ xs: '6', sm: '6', md: '6', lg: '6', className: 'text-right no-padding-right text-black' },
														_react2.default.createElement(
															'strong',
															{ style: { color: "black" } },
															(0, _utility.splitNumber)(total_count + '')()
														)
													)
												)
											)
										)
									)
								);
								doms.unshift(row);
							}
							if (zipcodes.length > 0) {
								var _row = _react2.default.createElement(
									'div',
									{ key: 'zipcode-panel', className: 'panel panel-flat bg-grey-300 zipcode-panel', style: { backgroundColor: "#CCC", color: "#777" } },
									_react2.default.createElement(
										'div',
										{ className: 'panel-heading text-uppercase right-margin ', style: { padding: "0.5em 1em" } },
										zipcodes.length > 1 ? "Zipcodes (" + zipcodes.length + ")" : "Zipcode"
									),
									_react2.default.createElement(
										'div',
										{ className: 'panel-body border-top right-margin  no-padding-bottom ', style: { paddingRight: "3em", borderColor: "#E3E3D3" } },
										_react2.default.createElement(
											_Grid.Row,
											{ className: 'no-padding-bottom', style: { padding: 0 } },
											_react2.default.createElement(
												_Grid.Col,
												{ xs: '4', sm: '4', md: '4', lg: '4', style: { height: "180px" } },
												zipcodes.length > 1 && _react2.default.createElement(
													_recharts.PieChart,
													{ width: 200, height: 150 },
													_react2.default.createElement(
														_recharts.Pie,
														{ dataKey: 'value', data: zipcodes, cx: 70, cy: 70,
															innerRadius: 30, outerRadius: 60, fill: '#26A69A' },
														zipcodes.map(function (entry, index) {
															return _react2.default.createElement(_recharts.Cell, { key: 'citystate-pie-cell-' + index, fill: COLORS[index % COLORS.length] });
														})
													),
													_react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(CustomTooltip, { datas: zipcodes }) })
												)
											),
											_react2.default.createElement(
												_Grid.Col,
												{ xs: '8', sm: '8', md: '8', lg: '8', className: 'pt-20' },
												(0, _lodash.map)(zipcodes, function (subItem, index) {
													return _react2.default.createElement(
														_Grid.Row,
														{ key: "city-state-row-div-" + index, className: "no-margin-bottom pt-10", style: { padding: 0 } },
														_react2.default.createElement(
															_Grid.Col,
															{ xs: '8', md: '8', sm: '8', lg: '8', className: 'no-padding-right no-padding-left', style: { overflow: "hidden" } },
															_react2.default.createElement(
																'div',
																{ style: { float: "left" } },
																city_states.length > 1 ? _react2.default.createElement(
																	'span',
																	{ className: 'span-legend', style: { background: COLORS[index % COLORS.length] } },
																	'\xA0'
																) : "",
																subItem.name,
																'\xA0\xA0\xA0'
															),
															_react2.default.createElement(
																'div',
																{ style: { marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' } },
																'\xA0'
															)
														),
														_react2.default.createElement(
															_Grid.Col,
															{ xs: '4', md: '4', sm: '4', lg: '4', className: 'text-right no-padding-right no-padding-left', style: { overflow: "hidden" } },
															_react2.default.createElement(
																'div',
																{ style: { float: "right" } },
																'\xA0\xA0\xA0',
																(0, _utility.splitNumber)(subItem.value + '')()
															),
															_react2.default.createElement(
																'div',
																{ style: { marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' } },
																'\xA0'
															)
														)
													);
												}),
												_react2.default.createElement(
													_Grid.Row,
													{ style: { paddingLeft: 0 } },
													_react2.default.createElement(
														_Grid.Col,
														{ xs: '6', sm: '6', md: '6', lg: '6', className: 'no-padding-left text-black' },
														_react2.default.createElement(
															'strong',
															{ style: { color: "black" } },
															'Total Count'
														)
													),
													_react2.default.createElement(
														_Grid.Col,
														{ xs: '6', sm: '6', md: '6', lg: '6', className: 'text-right no-padding-right text-black' },
														_react2.default.createElement(
															'strong',
															{ style: { color: "black" } },
															(0, _utility.splitNumber)(total_count + '')()
														)
													)
												)
											)
										)
									)
								);
								doms.unshift(_row);
							}
						}
	
						var PlottedRadiusMap = null;
	
						if (!(0, _lodash.isEmpty)(raw.plotted_values)) {
							var _raw$plotted_values = raw.plotted_values,
							    radius = _raw$plotted_values.radius,
							    addressLabel = _raw$plotted_values.addressLabel,
							    audienceCount = _raw$plotted_values.audienceCount,
							    driveTime = _raw$plotted_values.driveTime;
	
							var geoText = "";
							if (addressLabel) {
								geoText = driveTime ? 'GEOGRAPHIC : Drive ' + driveTime + ' Hour(s) From ' + addressLabel.replace(", United States", "") : 'GEOGRAPHIC : ' + radius + ' Mile(s) From ' + addressLabel.replace(", United States", "");
							} else {
								geoText = "GEOGRAPHIC : AREA SELECTED";
								var vector = null;
								var plottedRadius = raw.plotted_values;
								switch (plottedRadius.type) {
									case "circle":
										vector = _react2.default.createElement(_reactGoogleMaps.Circle, { ref: function ref(elm) {
												return _this2._vector = elm;
											}, center: plottedRadius.center, radius: plottedRadius.radius, options: (0, _utility.getMapVectorOptions)() });
										break;
									case "polygon":
										vector = _react2.default.createElement(_reactGoogleMaps.Polygon, { ref: function ref(elm) {
												return _this2._vector = elm;
											},
											path: typeof plottedRadius.path === "string" ? google.maps.geometry.encoding.decodePath(plottedRadius.path) : plottedRadius.path,
											options: (0, _utility.getMapVectorOptions)() });
										break;
									case "rectangle":
									default:
										vector = _react2.default.createElement(_reactGoogleMaps.Rectangle, { ref: function ref(elm) {
												return _this2._vector = elm;
											}, bounds: plottedRadius.bounds, radius: plottedRadius.radius, options: (0, _utility.getMapVectorOptions)() });
										break;
								}
								if (vector) {
									PlottedRadiusMap = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
										return _react2.default.createElement(
											_reactGoogleMaps.GoogleMap,
											{
												zoom: plottedRadius.zoom,
												center: plottedRadius.center,
												defaultOptions: {
													streetViewControl: false,
													mapTypeControl: false,
													zoomControl: false,
													scrollwheel: false,
													draggable: false
												},
												ref: _this2.handleMapMounted.bind(_this2)
											},
											vector
										);
									});
								}
							}
	
							var _row2 = _react2.default.createElement(
								'div',
								{ key: 'geo-text-container', className: 'panel panel-flat bg-grey-300', style: { backgroundColor: "#CCC", color: "#777" } },
								_react2.default.createElement(
									'div',
									{ className: 'panel-heading text-uppercase right-margin ', style: { padding: "0.5em 1em" } },
									geoText
								),
								_react2.default.createElement(
									'div',
									{ className: 'panel-body border-top right-margin  no-padding-bottom ', style: { paddingRight: "3em", borderColor: "#E3E3D3" } },
									_react2.default.createElement(
										_Grid.Row,
										{ className: 'no-padding-bottom', style: { padding: 0 } },
										_react2.default.createElement(
											_Grid.Col,
											{ xs: '4', sm: '4', md: '4', lg: '4', className: PlottedRadiusMap && "google_map_container", style: { height: "180px" } },
											PlottedRadiusMap ? _react2.default.createElement(PlottedRadiusMap, {
												containerElement: _react2.default.createElement('div', { style: { height: '100%' } }),
												mapElement: _react2.default.createElement('div', { style: { height: '100%' } })
											}) : null
										),
										_react2.default.createElement(
											_Grid.Col,
											{ xs: '8', sm: '8', md: '8', lg: '8', className: 'pt-20' },
											_react2.default.createElement(
												_Grid.Row,
												null,
												_react2.default.createElement(
													_Grid.Col,
													{ xs: '6', sm: '6', md: '6', lg: '6', className: 'no-padding-left text-black' },
													_react2.default.createElement(
														'strong',
														{ style: { color: "black" } },
														'Total Count'
													)
												),
												_react2.default.createElement(
													_Grid.Col,
													{ xs: '6', sm: '6', md: '6', lg: '6', className: 'text-right no-padding-right text-black' },
													_react2.default.createElement(
														'strong',
														{ style: { color: "black" } },
														(0, _utility.splitNumber)(audienceCount.total + '')()
													)
												)
											)
										)
									)
								)
							);
							doms.unshift(_row2);
						}
					}
					return _react2.default.createElement(
						'div',
						{ className: 'chart-view-container', style: {
								maxHeight: this.props && this.props.width > 1400 ? "480px" : "300px",
								overflowX: "hidden", overflowY: "auto"
							} },
						doms
					);
				} else {
					//const raw = JSON.parse(this.props.rawData)
					var locationRows = [];
					var _raw = JSON.parse(this.props.rawData);
					var locationDom = _react2.default.createElement(
						'div',
						{ className: 'panel-flat ', style: { color: "#777" } },
						_react2.default.createElement(
							'div',
							{ className: 'panel-body no-padding-top  no-padding-bottom ', style: { paddingRight: "3em", borderColor: "#E3E3D3" } },
							locationRows
						)
					);
					return [locationRows.length > 0 ? locationDom : null, _react2.default.createElement(
						'div',
						{ key: 'select_attrs_container' },
						_react2.default.createElement(_SelectedAttrs2.default, {
							selectedAttrs: _raw.selected_segments,
							plottedRadius: _raw.plotted_values,
							selected_state: _raw.selected_state,
							selected_city: _raw.selected_city,
							selected_county: _raw.selected_county,
							selected_dma: _raw.selected_dma,
							categories: this.props.demoAttributes,
							zipcode: _raw.zipcode,
							width: this.props.width,
							listMode: true
						})
					)];
				}
			}
		}, {
			key: 'changeReportView',
			value: function changeReportView(type) {
				this.setState({
					viewMode: type
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var data = this.props.data;
	
	
				return _react2.default.createElement(
					'div',
					{ id: 'segment-attrs-container', style: { width: '90%', padding: '0', margin: '0 auto' } },
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'pl-10 pr-20 no-padding-bottom no-margin-bottom pt-5' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '6', sm: '6', md: '6', lg: '6', style: { paddingLeft: "2em" } },
							'ATTRIBUTE'
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '6', sm: '6', md: '6', lg: '6', className: 'text-right', style: { paddingRight: "3em" } },
							'COUNT'
						)
					),
					_react2.default.createElement('hr', { className: 'mt-5 mb-10' }),
					_react2.default.createElement(
						_Grid.FullRow,
						{ className: 'no-padding-bottom no-padding-top no-padding-right', style: { marginBottom: '2em' } },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '6', sm: '6', md: '6', lg: '6' },
							'\xA0'
						),
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '6', sm: '6', md: '6', lg: '6', className: 'text-right', style: { paddingRight: "3em" } },
							this.state.viewMode === "chart" ? _react2.default.createElement(
								'i',
								{ className: this.state.viewMode === 'chart' ? 'icon-pie-chart4 text-teal-400 font-15em active' : 'icon-pie-chart4 text-teal-400 font-15em' },
								'\xA0'
							) : _react2.default.createElement(
								'a',
								{ onClick: this.changeReportView.bind(this, "chart") },
								_react2.default.createElement(
									'i',
									{ className: 'icon-pie-chart4 text-grey font-15em' },
									'\xA0'
								)
							),
							this.state.viewMode === "list" ? _react2.default.createElement(
								'i',
								{ className: this.state.viewMode === 'list' ? 'icon-menu6 text-teal-400 font-15em active' : 'icon-menu6 text-teal-400 font-15em' },
								'\xA0'
							) : _react2.default.createElement(
								'a',
								{ onClick: this.changeReportView.bind(this, "list") },
								_react2.default.createElement(
									'i',
									{ className: 'icon-menu6 text-grey font-15em' },
									'\xA0'
								)
							)
						)
					),
					this.getContent(data)
				);
			}
		}]);
	
		return SegmentAttribute;
	}(_react.Component);
	
	SegmentAttribute.propTypes = {
		data: _propTypes2.default.object.isRequired,
		rawData: _propTypes2.default.string.isRequired
	};
	exports.default = SegmentAttribute;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	__webpack_require__(124);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SegmentAttribute = __webpack_require__(1149);
	
	var _SegmentAttribute2 = _interopRequireDefault(_SegmentAttribute);
	
	var _settings = __webpack_require__(433);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _utility = __webpack_require__(14);
	
	var _Grid = __webpack_require__(19);
	
	var _materialUi = __webpack_require__(38);
	
	var _NavList = __webpack_require__(532);
	
	var _NavList2 = _interopRequireDefault(_NavList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SegmentSummary = function (_Component) {
		_inherits(SegmentSummary, _Component);
	
		function SegmentSummary() {
			_classCallCheck(this, SegmentSummary);
	
			return _possibleConstructorReturn(this, (SegmentSummary.__proto__ || Object.getPrototypeOf(SegmentSummary)).apply(this, arguments));
		}
	
		_createClass(SegmentSummary, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.state = {
					clientWidth: 0,
					clientHeight: 0,
					hasArchived: false,
					loaded: true
				};
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (!this.props.segment_summary) {
					this.props.fetchSegmentDetail(this.props.segment_id);
				}
				var width = document.getElementById('segment-summary-container').clientWidth;
				var height = document.getElementById("segment-summary-container").clientHeight;
				this.setState({
					clientWidth: width,
					clientHeight: height
				});
			}
		}, {
			key: 'handleConfirmArchive',
			value: function handleConfirmArchive(id) {
				var _this2 = this;
	
				this.setState({
					archivedId: id
				});
				this.props.archiveSegment(id);
	
				window.setTimeout(function () {
					_this2.setState({
						hasArchived: true
					}, function () {
						_this2.props.updateSegmentList(_this2.state.activeIndex); // update segment list when archive success
					});
				}, 2000);
			}
		}, {
			key: 'handleCancelArchive',
			value: function handleCancelArchive(e) {
				this.setState({
					popout: false
				});
			}
		}, {
			key: 'handleCreateRedirect',
			value: function handleCreateRedirect() {
				var _props = this.props,
				    segment_summary = _props.segment_summary,
				    handleActiveRedirectCreate = _props.handleActiveRedirectCreate;
	
				handleActiveRedirectCreate(segment_summary.id, segment_summary.clientId);
			}
		}, {
			key: 'getContent',
			value: function getContent() {
				var _this3 = this;
	
				var _props2 = this.props,
				    segment_summary = _props2.segment_summary,
				    segment_attributes = _props2.segment_attributes,
				    demoAttributes = _props2.demoAttributes,
				    geoAttributes = _props2.geoAttributes;
	
				return [_react2.default.createElement(
					'div',
					{ key: 'segment-summary-div', className: 'top-copy-archive clearfix', style: { paddingLeft: '6.5%' } },
					_react2.default.createElement(
						'span',
						{ className: 'font-12em', style: { fontWeight: 'bolder' } },
						segment_summary.name,
						this.state.clientWidth,
						'-',
						this.state.clientHeight
					),
					_react2.default.createElement(
						_rcTooltip2.default,
						{
							ref: function ref(node) {
								return _this3._tooltip = node;
							},
							hideAction: ['click', 'hover'],
							placement: 'right',
							overlay: _react2.default.createElement(_NavList2.default, {
								visible: !this.props.showLoadingDialog,
								handleActiveRedirectCreate: this.handleCreateRedirect.bind(this),
								popout: this.props.popout,
								handleConfirmArchive: function handleConfirmArchive() {
									return _this3.handleConfirmArchive(segment_summary.id);
								},
								popoutTip: function popoutTip() {
									return _this3.props.popoutTip();
								},
								handleCancelArchive: function handleCancelArchive() {
									return _this3.props.handleCancelArchive();
								},
								ifShowPdfDownload: true,
								createCampaignPopover: function createCampaignPopover() {
									return _this3.props.createCampaignPopover(segment_summary.id, segment_summary.clientId);
								},
								_handleDownloadPDF: function _handleDownloadPDF() {
									return _this3.props._handleDownloadPDF(segment_summary, segment_attributes, demoAttributes, geoAttributes);
								}
							}),
							defaultVisible: false,
							arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' })
						},
						_react2.default.createElement(_settings2.default, { style: { float: 'left' } })
					)
				), _react2.default.createElement(
					'ul',
					{ key: 'segment-summary-list', className: 'copy-archive-ul clearfix', style: { width: "92%" } },
					_react2.default.createElement(
						'li',
						{ className: 'clearfix', style: { marginLeft: "2em" } },
						_react2.default.createElement(
							'span',
							null,
							'Date'
						),
						_react2.default.createElement(
							'strong',
							null,
							_react2.default.createElement(
								'em',
								null,
								(0, _moment2.default)(segment_summary.createdTime, 'x').format('MMMM D, YYYY')
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'clearfix', style: { marginRight: "1em" } },
						_react2.default.createElement(
							'span',
							null,
							'Attributes'
						),
						_react2.default.createElement(
							'strong',
							{ style: { width: "78%" } },
							_react2.default.createElement(
								'em',
								null,
								segment_attributes
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'clearfix', style: { marginLeft: "2em" } },
						_react2.default.createElement(
							'span',
							null,
							'Client'
						),
						_react2.default.createElement(
							'strong',
							null,
							_react2.default.createElement(
								'em',
								null,
								segment_summary.clientName
							)
						)
					)
				), _react2.default.createElement(
					_Grid.Row,
					{ className: 'pt-10 no-padding-bottom no-padding-left ',
						style: {
							marginLeft: '5%', marginRight: '5.5%', fontSize: '10pt', marginBottom: '30px',
							borderTop: "solid 1px #C3C3C3", borderBottom: 'solid 1px #C3C3C3'
						} },
					_react2.default.createElement(
						'div',
						{ key: 'summany-audience-count', style: { float: 'left', width: '48%', paddingLeft: '5px' } },
						_react2.default.createElement(
							'span',
							{ className: 'ml-10 text-default text-bold' },
							'Audience: ',
							(0, _utility.splitNumber)(segment_summary.count + '')()
						)
					),
					_react2.default.createElement(
						'div',
						{ key: 'label-channel', style: { float: 'left', width: '14%', textAlign: 'right' } },
						'Reach by Channel'
					),
					_react2.default.createElement(
						'div',
						{ key: 'summary-email-count', style: { float: 'left', width: '12%', textAlign: 'right' } },
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement('i', { className: 'icon-envelope', style: { fontSize: '1.2em' } }),
							_react2.default.createElement(
								'span',
								{ className: 'ml-10 text-default text-bold' },
								(0, _utility.splitNumber)(segment_summary.email + '')()
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ key: 'summary-social-count', style: { float: 'left', width: '12%', textAlign: 'right' } },
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement('i', { className: 'icon-share3', style: { fontSize: '1.2em' } }),
							_react2.default.createElement(
								'span',
								{ className: 'ml-10 text-default text-bold' },
								(0, _utility.splitNumber)(segment_summary.social + '')()
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ key: 'summary-display-count', style: { float: 'left', width: '12%', textAlign: 'right' } },
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement('i', { className: 'icon-display4', style: { fontSize: '1.2em' } }),
							_react2.default.createElement(
								'span',
								{ className: 'ml-10 text-default text-bold' },
								(0, _utility.splitNumber)(segment_summary.display + '')()
							)
						)
					)
				)];
			}
		}, {
			key: 'render',
			value: function render() {
				var _props3 = this.props,
				    segment_summary = _props3.segment_summary,
				    demoAttributes = _props3.demoAttributes,
				    geoAttributes = _props3.geoAttributes;
	
				var datas = this.props._generateSelectData(segment_summary);
	
				return this.state.hasArchived === true ? _react2.default.createElement(
					'div',
					null,
					'The segment has been archived. ',
					_react2.default.createElement(
						'a',
						{ href: 'archive' },
						'View Archive'
					)
				) : _react2.default.createElement(
					'div',
					{ id: 'segment-summary-container' },
					segment_summary ? this.getContent() : "loading...",
					_react2.default.createElement(
						_materialUi.Dialog,
						{ open: this.props.showLoadingDialog,
							style: { top: '-1.8em' },
							modal: true },
						_react2.default.createElement(
							_Grid.Row,
							{ className: 'mt-20' },
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '7', sm: '7', md: '7', lg: '7', className: 'text-right' },
								_react2.default.createElement(
									'div',
									null,
									'Downloading, please wait...'
								)
							),
							_react2.default.createElement(
								_Grid.Col,
								{ xs: '1', sm: '1', md: '1', lg: '1' },
								_react2.default.createElement('img', { alt: '', src: '/Spinner.gif', style: { height: "24px" } })
							)
						)
					),
					_react2.default.createElement(_SegmentAttribute2.default, { data: datas, rawData: segment_summary ? segment_summary.rawData : "",
						demoAttributes: demoAttributes, geoAttributes: geoAttributes, width: this.state.clientWidth })
				);
			}
		}]);
	
		return SegmentSummary;
	}(_react.Component);
	
	SegmentSummary.propTypes = {
		segment_summary: _propTypes2.default.object,
		segment_id: _propTypes2.default.number.isRequired,
		fetchSegmentDetail: _propTypes2.default.func.isRequired
	};
	
	exports.default = SegmentSummary;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _search = __webpack_require__(155);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _reactBootstrapTypeahead = __webpack_require__(98);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _Grid = __webpack_require__(19);
	
	var _lodash = __webpack_require__(18);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1440);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property ifShowSegmentAction {boolean}  if show segment action, default is true
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property ifHideSearch {boolean} if hide search bar.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property ifFromDetail {boolean} if from detail.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ActionAndSearch = function (_Component) {
	  _inherits(ActionAndSearch, _Component);
	
	  function ActionAndSearch() {
	    _classCallCheck(this, ActionAndSearch);
	
	    var _this = _possibleConstructorReturn(this, (ActionAndSearch.__proto__ || Object.getPrototypeOf(ActionAndSearch)).call(this));
	
	    _this.throttle = false;
	    _this.state = {
	      stateValue: "",
	      showDataLoadingDialog: false,
	      open: false, // if open popout
	      nameOpts: [{ label: "", value: "" }],
	      selectOptions: [{ label: "Edit Audience", value: 1 }, { label: "Archive Audience", value: 2 }, { label: "Download as a PDF", value: 3 }, { label: "Download as a CSV File", value: 4 }, { label: "Create Audience File", value: 5 }],
	      sourceType: "",
	      sourceTypeOptions: [{ label: "All", value: "" }, { label: "Audience Builder", value: "AudienceBuilder" }, {
	        label: "Segment - Website Visitors",
	        value: "SegmentWebsiteVisitors"
	      }, {
	        label: "Segment - Audience at Scale",
	        value: "SegmentAudienceAtScale"
	      }],
	      selectedItem: [{ label: "", value: "" }], // record the selection of user in the input
	      ifStartDownloadCSV: false
	    };
	    return _this;
	  }
	
	  _createClass(ActionAndSearch, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedSegmentSetArray && nextProps.selectedSegmentSetArray.length >= 2) {
	        this.setState({
	          selectOptions: this.state.selectOptions.map(function (item) {
	            item.disabled = !(item.label === "Archive Segment");
	            return item;
	          })
	        });
	      } else {
	        if (nextProps.selectedSegmentSetArray && nextProps.selectedSegmentSetArray.length === 0 && !this.props.ifFromDetail) {
	          this.setState({
	            selectOptions: [{ label: "Edit Audience", value: 1, disabled: true }, { label: "Archive Audience", value: 2, disabled: true },
	            // {label: "Download as a CSV File", value: 4, disabled: true},
	            { label: "Create Audience File", value: 5, disabled: true }]
	          });
	        } else {
	          this.props.ifFromDetail ? this.setState({
	            selectOptions: [{
	              label: "Edit Audience",
	              value: 1,
	              disabled: this.props.roleId === 5
	            }, { label: "Archive Audience", value: 2 }, { label: "Download as a PDF", value: 3 }, { label: "Download as a CSV File", value: 4 }, {
	              label: "Create Audience File",
	              value: 5,
	              disabled: this.props.roleId !== 1 && this.props.roleId !== 5
	            }]
	          }) : this.setState({
	            selectOptions: [{
	              label: "Edit Audience",
	              value: 1,
	              disabled: this.props.roleId === 5
	            }, { label: "Archive Audience", value: 2 },
	            // {label: "Download as a CSV File", value: 4, disabled: true},
	            {
	              label: "Create Audience File",
	              value: 5,
	              disabled: this.props.roleId !== 1 && this.props.roleId !== 5
	            }]
	          });
	        }
	      }
	    }
	  }, {
	    key: "transformArray",
	    value: function transformArray(array) {
	      var arr = [];
	      (0, _lodash.map)(array, function (item) {
	        var str = "";
	        var sub_str = "";
	        var name = "";
	        if (item.id === 605606) {
	          var count = 0;
	          (0, _lodash.map)(item.attributes, function (attr) {
	            count += attr.values.length;
	            (0, _lodash.map)(attr.values, function (v) {
	              sub_str += "\"" + v.label + "\",\"" + v.total + "\"\r\n";
	            });
	          });
	          str = "AUTO MAKE/MODEL (" + count + "),\r\n";
	          arr.push(str + sub_str + "\r\n");
	        } else {
	          name = item.name + ",\r\n";
	          var result = name;
	          (0, _lodash.map)(item.attributes, function (attr) {
	            str = attr.name + "(" + (attr.values && attr.values.length) + "),\"" + attr.total + "\"\r\n";
	            (0, _lodash.map)(attr.values, function (v) {
	              sub_str += "\"" + v.label + "\",\"" + v.total + "\"\r\n";
	            });
	            result += str;
	            result += sub_str;
	            str = "";
	            sub_str = "";
	          });
	          arr.push(result + "\r\n");
	        }
	      });
	
	      return arr.join("");
	    }
	  }, {
	    key: "generateGeoString",
	    value: function generateGeoString() {
	      var _this2 = this;
	
	      var rules_count = this.props.rules_count;
	
	      var arr = [];
	      (0, _lodash.map)(rules_count, function (r) {
	        var str = "";
	        var sub_str = "";
	        if (r.attributeId === 1 || r.attributeId === 3 || r.attributeId === 7) {
	          var audienceCount = 0;
	          (0, _lodash.map)(r.counts, function (count) {
	            sub_str += count.key + ",\"" + count.value + "\"\r\n";
	            audienceCount += count.value;
	          });
	          str = r.attributeName + " (" + r.counts.length + "),\"" + audienceCount + "\"\r\n";
	          arr.push(str + sub_str + "\r\n");
	        }
	        if (r.attributeId === 90 || r.attributeId === 91) {
	          var segment_summary = _this2.props.segment_summary;
	
	          var rawData = JSON.parse(segment_summary.rawData);
	          var _rawData$plotted_valu = rawData.plotted_values,
	              addressLabel = _rawData$plotted_valu.addressLabel,
	              radius = _rawData$plotted_valu.radius,
	              driveTime = _rawData$plotted_valu.driveTime;
	
	          if (r.attributeId === 91) {
	            str = " Custom Radius";
	          } else {
	            if (radius && addressLabel) {
	              str = radius + " MILE(S) FROM " + addressLabel;
	            }
	            if (driveTime && addressLabel) {
	              str = driveTime + " HOUR(S) DRIVE FROM " + addressLabel;
	            }
	            str = str.replace(",USA", "").replace(", USA", "").replace("USA", "");
	          }
	          str = "Location,\"" + str + "\"\nAudience Size,\"" + r.counts[0].value + "\"";
	          arr.push(str + "\r\n");
	        }
	      });
	      if ((0, _lodash.isEmpty)(arr)) {
	        return "";
	      }
	      return "Geography,\r\n" + arr.join("");
	    }
	  }, {
	    key: "handleSourceTypeChange",
	    value: function handleSourceTypeChange(value, e) {
	      var _this3 = this;
	
	      this.props.onSourceTypeChange(value.value);
	      this.setState({
	        sourceType: value.value,
	        selectedItem: [{ label: "", value: "" }],
	        nameOpts: []
	      }, function () {
	        _this3.handleSearch();
	      });
	    }
	  }, {
	    key: "handleActionChange",
	    value: function handleActionChange(value, e) {
	      var _this4 = this;
	
	      switch (value.label) {
	        case "Edit Audience":
	          // this.setState({showDataLoadingDialog: true})
	          if (this.props.selectedSegmentSetArray.length === 1) {
	            // action edit segment from audience
	            this.props.getSegmentWithRules(this.props.selectedSegmentSetArray[0]);
	            this.props.segment_list_active.data.forEach(function (item) {
	              if (item.id === _this4.props.selectedSegmentSetArray[0]) {
	                _this4.props.selectedClientChanged(item.clientId);
	              }
	            });
	          } else if (this.props.match) {
	            // redirect to edit segment from detail
	            this.props.getSegmentWithRules(this.props.segment_summary.id);
	            this.props.selectedClientChanged(this.props.segment_summary.clientId);
	          }
	          break;
	        case "Archive Audience":
	          this.setState({
	            open: true
	          });
	          break;
	        case "Download as a PDF":
	          this.props.downloadAsPDF();
	          break;
	        case "Download as a CSV File":
	          if (this.props.selectedSegmentSetArray.length === 1 || this.props.ifFromDetail) {
	            this.setState({
	              showDataLoadingDialog: true
	            });
	            var newLine = window.navigator.msSaveOrOpenBlob ? "\r\n" : "\n";
	            window.setTimeout(function () {
	              if (_this4.props.list && _this4.props.segment_summary !== undefined && _this4.props.segment_summary.name) {
	                var csv_string = "";
	                var _props = _this4.props,
	                    audience_total_count = _props.audience_total_count,
	                    segment_summary = _props.segment_summary,
	                    parent_client = _props.parent_client;
	
	                var segmentName = "Segment Name," + segment_summary.name + newLine;
	                var creteDate = "Creation Date," + (0, _moment2.default)(segment_summary.createdTime).format("DD-MMM-YY") + newLine;
	                var client = "Client," + (segment_summary && (0, _lodash.isNil)(parent_client) ? segment_summary.clientName : (0, _lodash.isNil)(parent_client) ? "" : parent_client.name) + newLine;
	                var businessUnit = "Business Unit," + (parent_client ? segment_summary.clientName : "") + newLine;
	                var attributes = "Attributes Selected, " + segment_summary.rules.length + newLine;
	                var audience = "Audience, " + audience_total_count.total + newLine;
	                var reachByChannel = "Reach By Channel," + newLine;
	                var email = "Email, " + audience_total_count.email + newLine;
	                var social = "Social, " + audience_total_count.social + newLine;
	                var display = "Display, " + audience_total_count.display + newLine;
	
	                csv_string += segmentName;
	                csv_string += creteDate + client + businessUnit + attributes + audience + reachByChannel + email + social + display;
	                //  'Geography,\n' + location + audience + ',\n'
	                csv_string += "\r\n";
	                csv_string += _this4.generateGeoString();
	                csv_string += "\r\n";
	                csv_string += _this4.transformArray(_this4.props.list);
	                if (window.navigator.msSaveOrOpenBlob) {
	                  csv_string = "\uFEFF" + csv_string;
	                  var blob = new Blob([csv_string], {
	                    type: "text/csv;charset=utf-8"
	                  });
	                  navigator.msSaveOrOpenBlob(blob, _this4.props.segment_summary.name + ".csv");
	                } else {
	                  csv_string = "data:text/csv;charset=utf-8,\uFEFF" + encodeURIComponent(csv_string);
	                  //let encodeUri = encodeURI(csv_string);
	                  var link = document.createElement("a");
	
	                  link.setAttribute("href", csv_string);
	                  link.setAttribute("download", _this4.props.segment_summary.name + ".csv");
	                  document.body.appendChild(link);
	                  link.click();
	                }
	                _this4.setState({
	                  showDataLoadingDialog: false
	                });
	              }
	            }, 800);
	          }
	          break;
	        case "Create Audience File":
	          if (this.props.selectedSegmentSetArray.length === 1) {
	            this.props.createAudienceFile();
	          }
	          if (this.props.ifFromDetail) {
	            this.props.createAudienceFile();
	          }
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: "handleKeywordChange",
	    value: function handleKeywordChange(selectedItem) {
	      if (selectedItem.length > 0 && selectedItem[0].label.length > 0) {
	        this.setState({
	          selectedItem: selectedItem
	        });
	      } else {
	        this.setState({
	          selectedItem: [{ label: "", value: "" }]
	        });
	      }
	    }
	  }, {
	    key: "inputChange",
	    value: function inputChange(text) {
	      if (this.props.client_info) {
	        if (this.props.sourceType) this.props.searchByName({
	          keyword: text,
	          clientId: this.props.client_info.id,
	          status: this.props.ifShowSegmentAction ? "Active" : "Archived",
	          source: this.props.sourceType
	        });else {
	          this.props.searchByName({
	            keyword: text,
	            clientId: this.props.client_info.id,
	            status: this.props.ifShowSegmentAction ? "Active" : "Archived"
	          });
	        }
	        if (this.props.searchByNameResult && this.props.searchByNameResult.length > 0) {
	          var pars = [];
	          this.props.searchByNameResult.forEach(function (item, index) {
	            var child = {
	              label: item,
	              value: index
	            };
	            pars.push(child);
	          });
	          this.setState({
	            nameOpts: pars
	          });
	        } else {
	          this.setState({
	            nameOpts: []
	          });
	        }
	      }
	    }
	  }, {
	    key: "handleSearch",
	    value: function handleSearch() {
	      var paramsObj = {
	        clientId: this.props.client_info.id,
	        pageNumber: 1,
	        status: this.props.ifShowSegmentAction ? "Active" : "Archived", // if ifShowSegmentAction is false use `Archive`
	        order: "desc",
	        sortColumn: this.props.sortColumn
	      };
	      if (!(0, _lodash.isEmpty)(this.props.sourceType)) {
	        paramsObj["source"] = this.props.sourceType;
	      }
	      if (this.state.selectedItem[0].label.length > 0) {
	        paramsObj.name = this.state.selectedItem[0].label;
	      }
	      this.props.getSegmentList(paramsObj);
	    }
	  }, {
	    key: "handleCloseTips",
	    value: function handleCloseTips() {
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: "handleConfirmArchive",
	    value: function handleConfirmArchive() {
	      this.setState({
	        open: false
	      });
	      this.props.handleConfirmArchive();
	    }
	  }, {
	    key: "optionRenderer",
	    value: function optionRenderer(options) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        options.label
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "segment-action-and-search clearfix" },
	          _react2.default.createElement(
	            "div",
	            { style: { display: "flex", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { style: { flex: "1 1" }, className: "source-type-selection" },
	              _react2.default.createElement(
	                "span",
	                { className: "mr-20" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Source Type"
	                )
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                value: this.props.sourceType,
	                clearable: false,
	                placeholder: "Please select",
	                options: this.state.sourceTypeOptions,
	                onChange: function onChange(value, e) {
	                  return _this5.handleSourceTypeChange(value, e);
	                },
	                searchable: false,
	                multi: false,
	                id: "actionInput"
	              })
	            ),
	            !this.props.ifHideSearch && _react2.default.createElement(
	              "div",
	              { className: "searching clearfix", style: { flex: "1 1" } },
	              _react2.default.createElement(
	                "label",
	                { htmlFor: "" },
	                "Search"
	              ),
	              _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, {
	                key: "city_search_box",
	                className: "search-typeahead",
	                multiple: false,
	                options: this.state.nameOpts,
	                placeholder: "Search by Audience Name",
	                onInputChange: function onInputChange(text) {
	                  return _this5.inputChange(text);
	                },
	                onChange: function onChange(selectedItem) {
	                  return _this5.handleKeywordChange(selectedItem);
	                }
	              }),
	              _react2.default.createElement(
	                "span",
	                { className: "search-btn" },
	                _react2.default.createElement(_search2.default, {
	                  onClick: function onClick() {
	                    return _this5.handleSearch();
	                  },
	                  style: {
	                    color: "#FFF",
	                    maginTop: "6px",
	                    fontWeight: "bolder"
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Dialog2.default,
	            {
	              modal: false,
	              open: this.state.open,
	              onRequestClose: this.handleClose,
	              contentStyle: { width: "39%" }
	            },
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "black",
	                  textAlign: "center",
	                  fontSize: "16px",
	                  fontWeight: "bold"
	                }
	              },
	              "Click confirm to archive this audience"
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "btns",
	                style: { textAlign: "center", marginTop: "1em" }
	              },
	              _react2.default.createElement(_FlatButton2.default, {
	                label: "CANCEL",
	                backgroundColor: "#FFF",
	                labelStyle: { color: "black" },
	                onClick: function onClick() {
	                  return _this5.handleCloseTips();
	                },
	                hoverColor: "#FFF",
	                className: "btn-aa-info mr-20"
	              }),
	              _react2.default.createElement(_FlatButton2.default, {
	                label: "ARCHIVE SEGMENT",
	                backgroundColor: "#DD0000",
	                labelStyle: {
	                  color: "#FFF",
	                  padding: 0,
	                  verticalAlign: "inherit"
	                },
	                onClick: function onClick() {
	                  return _this5.handleConfirmArchive();
	                },
	                hoverColor: "#DD0000",
	                className: "btn-aa-warning"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Dialog2.default,
	            {
	              open: this.state.showDataLoadingDialog,
	              style: { top: "-1.8em" },
	              overlayStyle: { opacity: 0.9, backgroundColor: "#666666" },
	              modal: true
	            },
	            _react2.default.createElement(
	              _Grid.Row,
	              { className: "mt-20" },
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "7", sm: "7", md: "7", lg: "7", className: "text-right" },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Downloading, please wait..."
	                )
	              ),
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: "1", sm: "1", md: "1", lg: "1" },
	                _react2.default.createElement("img", { alt: "", src: "/Spinner.gif", style: { height: "24px" } })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActionAndSearch;
	}(_react.Component);
	
	ActionAndSearch.defaultProps = {
	  ifShowSegmentAction: true,
	  ifHideSearch: false,
	  ifFromDetail: false
	};
	
	exports.default = ActionAndSearch;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Table = __webpack_require__(533);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	__webpack_require__(221);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Active = function (_Component) {
	  _inherits(Active, _Component);
	
	  function Active(props) {
	    _classCallCheck(this, Active);
	
	    var _this = _possibleConstructorReturn(this, (Active.__proto__ || Object.getPrototypeOf(Active)).call(this, props));
	
	    _this.state = {
	      sortOrder: "desc",
	      sortName: "Date Created",
	      sortColumn: "createdTime",
	      tableHeadData: ["DATE", "AUDIENCE SEGMENTS", "COUNT", "CLIENT"],
	      showNoSegment: "",
	      pageNumber: 1
	    };
	    _this.throttle = true;
	    return _this;
	  }
	
	  _createClass(Active, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.clearReactiveStatus();
	      if (!(0, _utility.getUrlParameterByName)("cid")) {
	        this.props.getSegmentList({
	          source: this.props.sourceType,
	          clientId: this.props.selected_client,
	          pageNumber: 1,
	          sortColumn: "createdTime",
	          pageSize: 10,
	          status: "Active",
	          order: "desc"
	        });
	        this.props.history.push("/segments/list/active?cid=" + this.props.selected_client);
	      }
	      var cid = parseInt((0, _utility.getUrlParameterByName)("cid"), 10);
	      if (cid > 0) {
	        this.props.selectClient(cid);
	        this.props.getSegmentList({
	          source: this.props.sourceType,
	          clientId: cid,
	          pageNumber: 1,
	          sortColumn: "createdTime",
	          pageSize: 10,
	          status: "Active",
	          order: "desc"
	        });
	      }
	
	      if (!this.props.demoAttributes) {
	        this.props.loadAttributes(cid);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selected_client === "0") {
	        this.setState({
	          tableHeadData: ["DATE", "AUDIENCE SEGMENTS", "COUNT", "CLIENT"]
	        });
	      } else {
	        this.setState({
	          tableHeadData: ["Select", "Audience Name", "Date Created", "Source", "Status"]
	        });
	      }
	      if (nextProps.selected_client !== this.props.selected_client) {
	        if (typeof nextProps.selected_client === "string" && nextProps.selected_client.indexOf("r-") < 0 || parseInt(nextProps.selected_client, 10) > 0) this.props.getSegmentList({
	          source: this.props.sourceType,
	          clientId: parseInt(nextProps.selected_client, 10) >= 0 ? nextProps.selected_client : null,
	          pageNumber: this.state.pageNumber,
	          sortColumn: "createdTime",
	          pageSize: 10,
	          status: "Active",
	          order: "desc"
	        });
	        this.props.history.push("/segments/list/active?cid=" + nextProps.selected_client);
	      }
	
	      if (nextProps.segment_list_active.data.length > 0) {
	        this.setState({
	          showNoSegment: false
	        });
	      } else {
	        this.setState({
	          showNoSegment: true
	        });
	      }
	      if (nextProps.sourceType !== this.props.sourceType) {
	        this.setState({
	          sortColumn: "createdTime",
	          cache_sortColumn: "createdTime",
	          sortName: "Date Created"
	        });
	      }
	      // console.log(nextProps.segment_list_active.data.length)
	    }
	  }, {
	    key: "handleHeaderClick",
	    value: function handleHeaderClick(targetText, pageIndex) {
	      var _this2 = this;
	
	      this.setState({
	        cache_sortColumn: targetText
	      });
	      var obj = {
	        sortOrder: this.state.sortOrder === "desc" && this.state.cache_sortColumn === targetText ? "asc" : "desc",
	        sortName: targetText
	      };
	      switch (targetText) {
	        case "Date Created":
	          obj = Object.assign({}, obj, {
	            sortColumn: "createdTime"
	          });
	          break;
	        case "Audience Name":
	          obj = Object.assign({}, obj, {
	            sortColumn: "name"
	          });
	          break;
	        case "Status":
	          obj = Object.assign({}, obj, {
	            sortColumn: "status"
	          });
	          break;
	        case "Source":
	          obj = Object.assign({}, obj, {
	            sortColumn: "source"
	          });
	          break;
	        case "CLIENT":
	          obj = Object.assign({}, obj, {
	            sortColumn: "clientId"
	          });
	          break;
	        default:
	          return;
	      }
	
	      this.setState(obj, function () {
	        _this2.dispatchPageAction(pageIndex);
	      });
	    }
	  }, {
	    key: "handlePageClick",
	    value: function handlePageClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "goNext",
	    value: function goNext(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "goPrevious",
	    value: function goPrevious(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "selectRows",
	    value: function selectRows(page, row) {
	      var _this3 = this;
	
	      this.setState({
	        pageSize: row
	      }, function () {
	        _this3.dispatchPageAction(page);
	      });
	    }
	  }, {
	    key: "goToPage",
	    value: function goToPage(page) {
	      if (page > this.props.segment_list_active.pageCount) {
	        return;
	      } else {
	        this.dispatchPageAction(page);
	      }
	    }
	  }, {
	    key: "dispatchPageAction",
	    value: function dispatchPageAction(page) {
	      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	      this.setState({
	        pageNumber: page
	      });
	      this.props.recordActiveQueryParams({
	        sortColumn: this.state.sortColumn,
	        pageNumber: page,
	        pageSize: this.state.pageSize,
	        order: this.state.sortOrder
	      });
	      this.props.getSegmentList({
	        source: this.props.sourceType,
	        clientId: parseInt(this.props.selected_client, 10) > 0 ? this.props.selected_client : null,
	        sortColumn: this.state.sortColumn,
	        pageNumber: page,
	        pageSize: this.state.pageSize,
	        status: "Active",
	        order: this.state.sortOrder
	      });
	    }
	  }, {
	    key: "nextGroup",
	    value: function nextGroup(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "previousGroup",
	    value: function previousGroup(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "handleArchiveSegment",
	    value: function handleArchiveSegment(id) {
	      this.props.archiveSegment(id);
	    }
	  }, {
	    key: "updateSegmentList",
	    value: function updateSegmentList(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "handleCreateSegmentClick",
	    value: function handleCreateSegmentClick() {
	      this.props.history.push("/segment/create");
	    }
	  }, {
	    key: "handleIconClick",
	    value: function handleIconClick(targetText, pageIndex) {
	      var _this4 = this;
	
	      var obj = {
	        sortOrder: this.state.sortOrder === "desc" ? "asc" : "desc",
	        sortName: targetText
	      };
	      switch (targetText) {
	        case "Date Created":
	          obj = Object.assign({}, obj, {
	            sortColumn: "createdTime"
	          });
	          break;
	        case "Audience Name":
	          obj = Object.assign({}, obj, {
	            sortColumn: "name"
	          });
	          break;
	        case "Status":
	          obj = Object.assign({}, obj, {
	            sortColumn: "status"
	          });
	          break;
	        case "Source":
	          obj = Object.assign({}, obj, {
	            sortColumn: "source"
	          });
	          break;
	        case "CLIENT":
	          obj = Object.assign({}, obj, {
	            sortColumn: "clientId"
	          });
	          break;
	        default:
	          return;
	      }
	
	      this.setState(obj, function () {
	        _this4.dispatchPageAction(pageIndex);
	      });
	    }
	  }, {
	    key: "closeCreateCampaignDialog",
	    value: function closeCreateCampaignDialog() {
	      // close create audience file pop out
	      this.props.closeCreateCampaignDialog();
	    }
	  }, {
	    key: "checkBoxBeClick",
	    value: function checkBoxBeClick() {
	      this.props.checkBoxBeClick();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          segment_list_active = _props.segment_list_active,
	          archive_success = _props.archive_success,
	          segment_attributes = _props.segment_attributes,
	          segment_summary = _props.segment_summary,
	          fetchSegmentDetail = _props.fetchSegmentDetail,
	          clearSegmentSummary = _props.clearSegmentSummary,
	          demoAttributes = _props.demoAttributes,
	          geoAttributes = _props.geoAttributes;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "segment-active" },
	        !this.state.showNoSegment ? _react2.default.createElement(_Table2.default, {
	          checkBoxBeClick: function checkBoxBeClick() {
	            return _this5.checkBoxBeClick();
	          },
	          selectedSegment: this.props.selectedSegment,
	          ifCreateAudienceFile: this.props.ifCreateAudienceFile,
	          closeCreateCampaignDialog: function closeCreateCampaignDialog() {
	            return _this5.closeCreateCampaignDialog();
	          },
	          tableHeaderArray: this.state.tableHeadData,
	          client_info: this.props.client_info,
	          data: segment_list_active,
	          demoAttributes: demoAttributes,
	          geoAttributes: geoAttributes,
	          fetchSegmentDetail: fetchSegmentDetail,
	          clearSegmentSummary: clearSegmentSummary,
	          segment_summary: segment_summary,
	          headerBeClick: function headerBeClick(text, pageIndex) {
	            return _this5.handleHeaderClick(text, pageIndex);
	          },
	          pageBeClick: function pageBeClick(page) {
	            return _this5.handlePageClick(page);
	          },
	          nextBeClick: function nextBeClick(page) {
	            return _this5.goNext(page);
	          },
	          previousBeClick: function previousBeClick(page) {
	            return _this5.goPrevious(page);
	          },
	          nextGroupBeClick: function nextGroupBeClick(page) {
	            return _this5.nextGroup(page);
	          },
	          previousGroupBeClick: function previousGroupBeClick(page) {
	            return _this5.previousGroup(page);
	          },
	          selectRows: function selectRows(page, row) {
	            return _this5.selectRows(page, row);
	          },
	          goToPage: function goToPage(page) {
	            return _this5.goToPage(page);
	          },
	          segment_attributes: segment_attributes,
	          sort: this.state.sortOrder,
	          sortName: this.state.sortName,
	          archiveSegment: function archiveSegment(id) {
	            return _this5.handleArchiveSegment(id);
	          },
	          ifArchiveSuccess: archive_success,
	          history: this.props.history,
	          getSegmentWithRules: this.props.getSegmentWithRules,
	          segment_active_creation: this.props.segment_active_creation // create segment state
	          , active_segment_attributes: this.props.active_segment_attributes // use selected attributes
	          , flag: "active",
	          updateSegmentList: function updateSegmentList(page) {
	            return _this5.updateSegmentList(page);
	          },
	          save_segment_report_id: this.props.save_segment_report_id,
	          getCreateCampaign: this.props.getCreateCampaign // create campaign api function
	          , create_campaign: this.props.create_campaign,
	          rollbackRequestSuccessToFalse: this.props.rollbackRequestSuccessToFalse,
	          roleName: this.props.roleName,
	          selectedSegmentSetArray: this.props.selectedSegmentSetArray,
	          selectedClientChanged: this.props.selectClient,
	          handleIconClick: function handleIconClick(targetName, targetIndex) {
	            return _this5.handleIconClick(targetName, targetIndex);
	          },
	          handleConfirmArchive: function handleConfirmArchive() {
	            return _this5.props.handleConfirmArchive();
	          }
	        }) : _react2.default.createElement(
	          "section",
	          { style: { textAlign: "center", fontSize: "1.5em" } },
	          "You have no saved segments."
	        ),
	        _react2.default.createElement("div", null)
	      );
	    }
	  }]);
	
	  return Active;
	}(_react.Component);
	
	exports.default = Active;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Table = __webpack_require__(533);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	__webpack_require__(221);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Archive = function (_Component) {
	  _inherits(Archive, _Component);
	
	  function Archive(props) {
	    _classCallCheck(this, Archive);
	
	    var _this = _possibleConstructorReturn(this, (Archive.__proto__ || Object.getPrototypeOf(Archive)).call(this, props));
	
	    _this.state = {
	      sortOrder: "desc",
	      sortName: "Date Archived",
	      sortColumn: "archivedTime",
	      tableHeadData: ["Select", "ARCHIVE DATE", "AUDIENCE SEGMENTS", "COUNT", "CLIENT", "DATE CREATED"],
	      pageNumber: 1
	    };
	    return _this;
	  }
	
	  _createClass(Archive, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var cid = (0, _utility.getUrlParameterByName)("cid");
	      if (cid) {
	        this.props.selectClient(parseInt(cid, 10));
	        this.props.getSegmentList({
	          clientId: parseInt(cid, 10),
	          pageNumber: 1,
	          sortColumn: "archivedTime",
	          pageSize: 10,
	          status: "Archived",
	          order: "desc"
	        });
	      } else {
	        this.props.getSegmentList({
	          clientId: this.props.selected_client,
	          pageNumber: 1,
	          sortColumn: "archivedTime",
	          pageSize: 10,
	          status: "Archived",
	          order: "desc"
	        });
	        this.props.history.push("/segments/list/archive?cid=" + this.props.selected_client);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selected_client === "0") {
	        this.setState({
	          tableHeadData: ["Select", "ARCHIVE DATE", "AUDIENCE SEGMENTS", "COUNT", "CLIENT", "DATE CREATED"]
	        });
	      } else {
	        this.setState({
	          tableHeadData: ["Select", "Audience Segment", "Date Archived", "Source", "Status"]
	        });
	      }
	
	      if (nextProps.selected_client !== this.props.selected_client) {
	        this.props.getSegmentList({
	          clientId: parseInt(nextProps.selected_client, 10) >= 0 ? nextProps.selected_client : null,
	          pageNumber: this.state.pageNumber,
	          sortColumn: "archivedTime",
	          pageSize: 10,
	          status: "Archived",
	          order: "desc"
	        });
	        this.props.history.push("/segments/list/archive?cid=" + nextProps.selected_client);
	      } /*
	        if (nextProps.roleId === 5) {
	        window.location = "/"
	        }*/
	      if (nextProps.sourceType !== this.props.sourceType) {
	        this.setState({
	          sortColumn: "archivedTime",
	          cache_sortColumn: "archivedTime",
	          sortName: "Date Archived"
	        });
	      }
	    }
	  }, {
	    key: "handleHeaderClick",
	    value: function handleHeaderClick(targetText, pageIndex) {
	      var _this2 = this;
	
	      this.setState({
	        cache_sortColumn: targetText
	      });
	      var obj = {
	        sortOrder: this.state.sortOrder === "desc" && this.state.cache_sortColumn === targetText ? "asc" : "desc",
	        sortName: targetText
	      };
	      switch (targetText) {
	        case "Date Archived":
	          obj = Object.assign({}, obj, {
	            sortColumn: "archivedTime"
	          });
	          break;
	        case "Audience Segment":
	          obj = Object.assign({}, obj, {
	            sortColumn: "name"
	          });
	          break;
	        case "DATE CREATED":
	          obj = Object.assign({}, obj, {
	            sortColumn: "createdTime"
	          });
	          break;
	        case "CLIENT":
	          obj = Object.assign({}, obj, {
	            sortColumn: "clientId"
	          });
	          break;
	        case "Status":
	          obj = Object.assign({}, obj, {
	            sortColumn: "status"
	          });
	          break;
	        case "Source":
	          obj = Object.assign({}, obj, {
	            sortColumn: "sourcce"
	          });
	          break;
	        default:
	          return;
	      }
	
	      this.setState(obj, function () {
	        _this2.dispatchPageAction(pageIndex);
	      });
	    }
	  }, {
	    key: "handlePageClick",
	    value: function handlePageClick(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "goNext",
	    value: function goNext(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "goPrevious",
	    value: function goPrevious(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "selectRows",
	    value: function selectRows(page, row) {
	      var _this3 = this;
	
	      this.setState({
	        pageSize: row
	      }, function () {
	        _this3.dispatchPageAction(page);
	      });
	    }
	  }, {
	    key: "goToPage",
	    value: function goToPage(page) {
	      if (page > this.props.segment_list_archive.pageCount) {
	        return;
	      } else {
	        this.dispatchPageAction(page);
	      }
	    }
	  }, {
	    key: "dispatchPageAction",
	    value: function dispatchPageAction(page) {
	      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	      this.setState({
	        pageNumber: page
	      });
	      this.props.getSegmentList({
	        clientId: parseInt(this.props.selected_client, 10) >= 0 ? this.props.selected_client : null,
	        sortColumn: this.state.sortColumn,
	        pageNumber: page,
	        pageSize: this.state.pageSize,
	        status: "Archived",
	        order: this.state.sortOrder
	      });
	    }
	  }, {
	    key: "nextGroup",
	    value: function nextGroup(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "previousGroup",
	    value: function previousGroup(page) {
	      this.dispatchPageAction(page);
	    }
	  }, {
	    key: "handleCreateSegmentClick",
	    value: function handleCreateSegmentClick() {
	      this.props.history.push("/segment/create");
	    }
	  }, {
	    key: "handleIconClick",
	    value: function handleIconClick(targetText, pageIndex) {
	      var _this4 = this;
	
	      var obj = {
	        sortOrder: this.state.sortOrder === "desc" ? "asc" : "desc",
	        sortName: targetText
	      };
	      switch (targetText) {
	        case "Date Archived":
	          obj = Object.assign({}, obj, {
	            sortColumn: "archivedTime"
	          });
	          break;
	        case "Audience Segment":
	          obj = Object.assign({}, obj, {
	            sortColumn: "name"
	          });
	          break;
	        case "DATE CREATED":
	          obj = Object.assign({}, obj, {
	            sortColumn: "createdTime"
	          });
	          break;
	        case "CLIENT":
	          obj = Object.assign({}, obj, {
	            sortColumn: "clientId"
	          });
	          break;
	        case "Status":
	          obj = Object.assign({}, obj, {
	            sortColumn: "status"
	          });
	          break;
	        case "Source":
	          obj = Object.assign({}, obj, {
	            sortColumn: "sourcce"
	          });
	          break;
	        default:
	          return;
	      }
	
	      this.setState(obj, function () {
	        _this4.dispatchPageAction(pageIndex);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          segment_list_archive = _props.segment_list_archive,
	          segment_attributes = _props.segment_attributes,
	          getAttributes = _props.getAttributes,
	          segment_summary = _props.segment_summary,
	          fetchSegmentDetail = _props.fetchSegmentDetail,
	          clearSegmentSummary = _props.clearSegmentSummary;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "segment-archive" },
	        _react2.default.createElement(_Table2.default, {
	          tableHeaderArray: this.state.tableHeadData,
	          data: segment_list_archive,
	          fetchSegmentDetail: fetchSegmentDetail,
	          clearSegmentSummary: clearSegmentSummary,
	          segment_summary: segment_summary,
	          headerBeClick: function headerBeClick(text, pageIndex) {
	            return _this5.handleHeaderClick(text, pageIndex);
	          },
	          pageBeClick: function pageBeClick(page) {
	            return _this5.handlePageClick(page);
	          },
	          nextBeClick: function nextBeClick(page) {
	            return _this5.goNext(page);
	          },
	          previousBeClick: function previousBeClick(page) {
	            return _this5.goPrevious(page);
	          },
	          nextGroupBeClick: function nextGroupBeClick(page) {
	            return _this5.nextGroup(page);
	          },
	          previousGroupBeClick: function previousGroupBeClick(page) {
	            return _this5.previousGroup(page);
	          },
	          selectRows: function selectRows(page, row) {
	            return _this5.selectRows(page, row);
	          },
	          goToPage: function goToPage(page) {
	            return _this5.goToPage(page);
	          },
	          sort: this.state.sortOrder,
	          sortName: this.state.sortName,
	          segment_attributes: segment_attributes,
	          getAttributes: getAttributes,
	          copySegmentRedirect: this.props.copySegment,
	          copy_segment: this.props.copy_segment,
	          segment_edit_creation: this.props.segment_edit_creation,
	          selectedSegmentSetArray: this.props.selectedSegmentSetArray,
	          flag: "archive",
	          selectedClientChanged: this.props.selectClient,
	          handleIconClick: function handleIconClick(targetText, targetIndex) {
	            return _this5.handleIconClick(targetText, targetIndex);
	          },
	          reactiveSegment: this.props.reactiveSegment,
	          reactive_success: this.props.reactive_success,
	          reactive_on_progress: this.props.reactive_on_progress,
	          history: this.props.history
	        }),
	        _react2.default.createElement("div", null)
	      );
	    }
	  }]);
	
	  return Archive;
	}(_react.Component);
	
	exports.default = Archive;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property title {string} title
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var CommonNav = function (_Component) {
	  _inherits(CommonNav, _Component);
	
	  function CommonNav() {
	    _classCallCheck(this, CommonNav);
	
	    return _possibleConstructorReturn(this, (CommonNav.__proto__ || Object.getPrototypeOf(CommonNav)).apply(this, arguments));
	  }
	
	  _createClass(CommonNav, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "segment-list-title clearfix" },
	        _react2.default.createElement(
	          "span",
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "nav" },
	          _react2.default.createElement(
	            "ul",
	            { className: "link clearfix" },
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                {
	                  exact: true,
	                  to: "/segments/list/active",
	                  activeClassName: "active"
	                },
	                "Active"
	              )
	            ),
	            _react2.default.createElement("li", null),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                {
	                  exact: true,
	                  to: "/segments/list/archive",
	                  activeClassName: "active"
	                },
	                "Archive"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CommonNav;
	}(_react.Component);
	
	exports.default = CommonNav;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _Active = __webpack_require__(1211);
	
	var _Active2 = _interopRequireDefault(_Active);
	
	var _Archive = __webpack_require__(1212);
	
	var _Archive2 = _interopRequireDefault(_Archive);
	
	var _CommonNav = __webpack_require__(1154);
	
	var _CommonNav2 = _interopRequireDefault(_CommonNav);
	
	var _ActionAndSearch = __webpack_require__(1151);
	
	var _ActionAndSearch2 = _interopRequireDefault(_ActionAndSearch);
	
	__webpack_require__(221);
	
	var _lodash = __webpack_require__(18);
	
	var _isEqual = __webpack_require__(31);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _utility = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.throttle = true;
	    _this.state = {
	      ifCreateAudienceFile: false, // pop out the create audience file
	      list: [],
	      showLoading: false,
	      segment_summary: "",
	      record: "",
	      sourceType: ""
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.loadAttributes((0, _utility.getUrlParameterByName)("cid"));
	      this.props.getSegmentArchiveData({
	        clientId: parseInt(this.props.selected_client, 10) >= 0 ? this.props.selected_client : null,
	        pageNumber: 1,
	        sortColumn: "archivedTime",
	        pageSize: 10,
	        status: "Archived",
	        order: "desc"
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        segment_summary: nextProps.segment_summary
	      });
	      if (nextProps.selectedSegmentSetArray.length === 1 && this.throttle) {
	        nextProps.fetchSegmentSummary(nextProps.selectedSegmentSetArray[0]);
	        this.throttle = false;
	      }
	      if (nextProps.clients !== this.props.clients) {
	        if (nextProps.clients.length === 1 && nextProps.clients[0].id <= 1) if (nextProps.roleId === 1) this.props.history.push("/employees");else this.props.history.push("/clients");
	      }
	      if (nextProps.roleId !== this.props.roleId) {
	        if (nextProps.roleId > 5) {
	          if (this.props.client_info) {
	            if (this.props.client_info.subscription.id > 4) this.props.history.push("/insights");
	          }
	        }
	      }
	      if (nextProps.client_info !== this.props.client_info) {
	        if (this.props.roleId > 5) {
	          if (nextProps.client_info && nextProps.client_info.subscription.id > 4) {
	            this.props.history.push("/insights");
	          }
	        }
	      }
	
	      var itemobj = [];
	      var list = []; // for final array
	      if (nextProps.segment_summary) {
	        if (this.props.segment_summary) {
	          if (this.props.segment_summary.id !== nextProps.segment_summary.id) this.props.selectClient(nextProps.segment_summary.clientId);
	        } else {
	          this.props.selectClient(nextProps.segment_summary.clientId);
	        }
	      }
	      if (!(0, _lodash.isEmpty)(nextProps.active_segment_attributes)) {
	        var rawData = JSON.parse(nextProps.active_segment_attributes.rawData);
	        nextProps.segment_active_creation.selected_segments = rawData.selected_segments;
	        nextProps.segment_active_creation.plotted_values = rawData.plotted_values;
	        nextProps.segment_active_creation.selected_city = rawData.selected_city;
	        nextProps.segment_active_creation.selected_state = rawData.selected_state;
	        nextProps.segment_active_creation.selected_county = rawData.selected_county;
	        nextProps.segment_active_creation.selected_dma = rawData.selected_dma;
	        nextProps.segment_active_creation.zipcode = rawData.zipcode;
	        nextProps.segment_active_creation.segment_name = rawData.name;
	        nextProps.active_segment_attributes.rules.forEach(function (item) {
	          nextProps.segment_active_creation.rules_id.push({
	            id: item.id,
	            attributeId: item.attributeId
	          });
	        });
	        nextProps.segment_active_creation.segment_id = nextProps.active_segment_attributes.id;
	      }
	      if (nextProps.segment_summary && nextProps.value_typehead) {
	        nextProps.value_typehead.forEach(function (item) {
	          var queryArr = JSON.parse(nextProps.segment_summary.rawData).selected_segments;
	          queryArr.forEach(function (id) {
	            if (item.id === id) {
	              itemobj.push(item);
	            }
	          });
	        });
	
	        if (nextProps.categories && !(0, _isEqual2.default)(nextProps.categories, this.props.categories)) {
	          nextProps.categories.forEach(function (item) {
	            item.attributes.forEach(function (attr) {
	              if (attr.values) {
	                attr.values.forEach(function (value) {
	                  JSON.parse(nextProps.segment_summary.rawData).selected_segments.forEach(function (id) {
	                    var attributes = [];
	                    var attributes_values = [];
	                    if (value.id === id) {
	                      attributes_values.push(value);
	                      attributes.push({
	                        id: attr.id,
	                        name: attr.name,
	                        awId: attr.awId,
	                        values: attributes_values
	                      });
	                      var segmentAttr = (0, _lodash.find)(list, function (m) {
	                        return m.id === item.id;
	                      });
	                      if (segmentAttr === undefined) {
	                        list.push({
	                          id: item.id,
	                          name: item.name,
	                          attributes: attributes
	                        });
	                      } else {
	                        var _attr = (0, _lodash.find)(segmentAttr.attributes, function (sattr) {
	                          return sattr.id === attr.id;
	                        });
	                        if (_attr === undefined) segmentAttr.attributes = segmentAttr.attributes.concat(attributes);else _attr.values = _attr.values.concat(attributes[0].values);
	                      }
	                    }
	                  });
	                });
	              }
	              if (attr.subAttributes) {
	                var subAttributes = [];
	                var subAttributes_values = [];
	                attr.subAttributes.forEach(function (attr1) {
	                  attr1.values.forEach(function (value) {
	                    JSON.parse(nextProps.segment_summary.rawData).selected_segments.forEach(function (id) {
	                      if (value.id === id) {
	                        subAttributes_values.push({
	                          label: attr1.name + " - " + value.label,
	                          total: value.total,
	                          id: value.id
	                        });
	                        subAttributes.push({
	                          id: attr1.id,
	                          name: attr.name,
	                          parentId: attr1.parentId,
	                          values: subAttributes_values
	                        });
	                      }
	                    });
	                  });
	                });
	                if (!(0, _lodash.isEmpty)(subAttributes)) {
	                  list.push({
	                    id: item.id,
	                    name: item.name,
	                    attributes: (0, _lodash.uniqBy)(subAttributes, function (att) {
	                      return att.id;
	                    })
	                  });
	                }
	              }
	            });
	          });
	          (0, _lodash.map)(list, function (l) {
	            (0, _lodash.map)(l.attributes, function (attr) {
	              var total = (0, _lodash.reduce)(attr.values, function (sum, val) {
	                return sum += val.total;
	              }, 0);
	              attr["total"] = total;
	            });
	          });
	          this.setState({
	            list: list
	          });
	        }
	      }
	    }
	  }, {
	    key: "handleConfirmArchive",
	    value: function handleConfirmArchive() {
	      var _this2 = this;
	
	      // for the multiple segment archived.
	      this.props.selectedSegmentSetArray.forEach(function (id) {
	        _this2.props.archiveSegment(id);
	      });
	      // set timeout for async call back.
	      window.setTimeout(function () {
	        _this2.props.getSegmentList(Object.assign({}, _this2.props.recordActiveQueryParamsObj, {
	          clientId: parseInt(_this2.props.selected_client, 10) >= 0 ? _this2.props.selected_client : null
	        }));
	        // when use `clear` as the only parameter, empty the arrary.
	        _this2.props.selectedSegment("clear");
	      }, 800);
	    }
	  }, {
	    key: "createAudienceFile",
	    value: function createAudienceFile() {
	      this.setState({
	        ifCreateAudienceFile: true
	      });
	    }
	  }, {
	    key: "closeCreateCampaignDialog",
	    value: function closeCreateCampaignDialog() {
	      this.setState({
	        ifCreateAudienceFile: false
	      });
	    }
	  }, {
	    key: "checkBoxBeClick",
	    value: function checkBoxBeClick() {
	      this.throttle = true;
	    }
	    // when click edit segment
	
	  }, {
	    key: "getComponent",
	    value: function getComponent() {
	      var _this3 = this;
	
	      switch (this.props.match.params.type) {
	        case "active":
	          return _react2.default.createElement(
	            "div",
	            { className: "segment-list-wrapper" },
	            _react2.default.createElement(_CommonNav2.default, {
	              title: "ACTIVE AUDIENCES",
	              selected_client: this.props.selected_client
	            }),
	            _react2.default.createElement(_ActionAndSearch2.default, {
	              sourceType: this.state.sourceType,
	              ifShowSegmentAction: true,
	              onSourceTypeChange: function onSourceTypeChange(type) {
	                _this3.setState({
	                  sourceType: type
	                });
	              },
	              sortColumn: "createdTime",
	              searchByName: this.props.searchByName,
	              searchByNameResult: this.props.searchByNameResult,
	              client_info: this.props.client_info,
	              getSegmentList: this.props.getSegmentList,
	              selectedClientChanged: this.props.selectClient,
	              selectedSegmentSetArray: this.props.selectedSegmentSetArray,
	              getSegmentWithRules: this.props.getSegmentWithRules,
	              segment_list_active: this.props.segment_list_active,
	              handleConfirmArchive: function handleConfirmArchive() {
	                return _this3.handleConfirmArchive();
	              },
	              createAudienceFile: function createAudienceFile() {
	                return _this3.createAudienceFile();
	              },
	              segment_active_creation: this.props.segment_active_creation,
	              active_segment_attributes: this.props.active_segment_attributes,
	              list: this.state.list,
	              segment_summary: this.state.segment_summary,
	              roleId: this.props.roleId
	            }),
	            _react2.default.createElement(_Active2.default, {
	              sourceType: this.state.sourceType === "" ? undefined : this.state.sourceType,
	              history: this.props.history,
	              save_segment_report_id: this.props.match.params.id,
	              roleName: this.props.roleName,
	              closeCreateCampaignDialog: function closeCreateCampaignDialog() {
	                return _this3.closeCreateCampaignDialog();
	              },
	              roleId: this.props.roleId,
	              handleActiveRedirectCreate: function handleActiveRedirectCreate(id, clientId) {
	                return _this3.handleActiveRedirectCreate(id, clientId);
	              },
	              getCreateCampaign: this.props.getCreateCampaign,
	              create_campaign: this.props.create_campaign,
	              ifCreateAudienceFile: this.state.ifCreateAudienceFile,
	              rollbackRequestSuccessToFalse: this.props.rollbackRequestSuccessToFalse,
	              handleConfirmArchive: function handleConfirmArchive() {
	                return _this3.handleConfirmArchive();
	              },
	              checkBoxBeClick: function checkBoxBeClick() {
	                return _this3.checkBoxBeClick();
	              }
	            })
	          );
	        case "archive":
	          return _react2.default.createElement(
	            "div",
	            { className: "segment-list-wrapper" },
	            _react2.default.createElement(_CommonNav2.default, {
	              title: "ARCHIVED SEGMENTS",
	              selected_client: this.props.selected_client
	            }),
	            _react2.default.createElement(_ActionAndSearch2.default, {
	              sourceType: this.state.sourceType,
	              onSourceTypeChange: function onSourceTypeChange(type) {
	                _this3.setState({
	                  sourceType: type
	                });
	              },
	              ifShowSegmentAction: false,
	              history: this.props.history,
	              searchByName: this.props.searchByName,
	              client_info: this.props.client_info,
	              getSegmentList: this.props.getSegmentList,
	              searchByNameResult: this.props.searchByNameResult,
	              roleId: this.props.roleId,
	              sortColumn: "archivedTime"
	            }),
	            _react2.default.createElement(_Archive2.default, {
	              history: this.props.history,
	              selectedSegmentSetArray: this.props.selectedSegmentSetArray,
	              sourceType: this.state.sourceType === undefined ? "all" : this.state.sourceType
	            })
	          );
	        default:
	          return _react2.default.createElement(
	            "div",
	            { className: "segment-list-wrapper" },
	            _react2.default.createElement(_Active2.default, {
	              roleName: this.props.roleName,
	              sourceType: this.state.sourceType === "" ? undefined : this.state.sourceType,
	              history: this.props.history,
	              roleId: this.props.roleId,
	              save_segment_report_id: this.props.match.params.id,
	              getCreateCampaign: this.props.getCreateCampaign,
	              createCampaign: this.props.createCampaign,
	              rollbackRequestSuccessToFalse: this.props.rollbackRequestSuccessToFalse
	            })
	          );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var hideCreateButton = parseInt(this.props.selected_client, 10) <= 0 || this.props.roleId === 5; /*||
	                                                                                                       (this.props.roleId > 3 &&
	                                                                                                       this.props.client_info &&
	                                                                                                       this.props.client_info.subscription &&
	                                                                                                       this.props.client_info.subscription.id > 3)*/
	      return _react2.default.createElement(
	        "div",
	        { className: "segment-list" },
	        _react2.default.createElement(
	          "div",
	          { className: "segment-list-btn" },
	          hideCreateButton ? _react2.default.createElement(
	            "button",
	            { disabled: true, className: "" },
	            "Create an Audience Segment"
	          ) : _react2.default.createElement(
	            "a",
	            {
	              href: "/segments/builder?cid=" + this.props.selected_client,
	              className: "btn btn-default btn-aa-default"
	            },
	            "Create an Audience"
	          )
	        ),
	        this.getComponent()
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleMaps = __webpack_require__(243);
	
	var _DrawingManager = __webpack_require__(915);
	
	var _DrawingManager2 = _interopRequireDefault(_DrawingManager);
	
	var _materialUi = __webpack_require__(38);
	
	var _utility = __webpack_require__(14);
	
	var _Grid = __webpack_require__(19);
	
	var _reactGeosuggest = __webpack_require__(913);
	
	var _reactGeosuggest2 = _interopRequireDefault(_reactGeosuggest);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _rcSlider = __webpack_require__(870);
	
	var _rcSlider2 = _interopRequireDefault(_rcSlider);
	
	__webpack_require__(124);
	
	__webpack_require__(594);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(1441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-undef */
	
	var INITIAL_CENTER = { lat: 42.87, lng: -97.38 };
	var radioButtonStyle = {
	  labeStyle: {
	    color: "#EDEDED",
	    fontSize: "0.9em"
	  },
	  inputStyle: {
	    fill: "#EDEDED",
	    height: "16px",
	    width: "16px",
	    marginLeft: "4px",
	    marginRight: "8px",
	    marginTop: "2px"
	  },
	  firstRadioStyle: {
	    width: "35%",
	    float: "left"
	  },
	  secondRadioStyle: {
	    width: "60%",
	    float: "left"
	  }
	};
	
	//reference https://developers.google.com/maps/documentation/geocoding/intro#Types
	var addressTypes = ["street_address", "premise", "subpremise", "airport", "park", "neighborhood", "floor", "point_of_interest", "establishment", "parking", "post_box", "room", "street_number", "bus_station", "train_station", "transit_station"];
	
	var MapSelector = function (_Component) {
	  _inherits(MapSelector, _Component);
	
	  function MapSelector(props) {
	    _classCallCheck(this, MapSelector);
	
	    var _this = _possibleConstructorReturn(this, (MapSelector.__proto__ || Object.getPrototypeOf(MapSelector)).call(this, props));
	
	    _this.overlayComplete = function (e) {
	      var overlay = e.overlay;
	      switch (e.type) {
	        case "circle":
	          var radius = e.overlay.getRadius();
	          var center = e.overlay.getCenter();
	          var c = {
	            center: center,
	            radius: radius,
	            visible: true
	          };
	          _this.setState({
	            circle: c,
	            readyApply: true
	          });
	          break;
	        case "rectangle":
	          var bounds = e.overlay.getBounds();
	          _this.setState({
	            rect: {
	              bounds: bounds,
	              visible: true
	            },
	            readyApply: true
	          });
	          break;
	        //case "polygon":
	        default:
	          _this.setState({
	            polygon: {
	              path: e.overlay.getPath(),
	              visible: true
	            },
	            readyApply: true
	          });
	          break;
	      }
	
	      _this.setState({
	        defaultDrawingMode: null,
	        onDrawing: false
	      });
	      _this.calTotalAudience();
	      _this.applySelect(true);
	      google.maps.event.clearInstanceListeners(overlay);
	      overlay.setMap(null);
	    };
	
	    _this._getPolygonNewPaths = function (polygon) {
	      if (!_this.state.readyApply) _this.setState({
	        readyApply: true
	      });
	
	      var polygonPaths = [];
	      polygon.getArray().forEach(function (path, index) {
	        var line = {
	          lat: path.lat(),
	          lng: path.lng()
	        };
	        polygonPaths.push(line);
	      });
	
	      _this.calTotalAudience();
	      _this.applySelect(true);
	    };
	
	    _this.state = {
	      showDrawingTool: false,
	      defaultDrawingMode: null,
	      circles: [],
	      openReset: false,
	      circle: {
	        center: null,
	        radius: 0,
	        visible: false
	      },
	      rect: {
	        bounds: null,
	        visiable: false
	      },
	      polygon: {
	        path: [],
	        visiable: false
	      },
	      zoom: 4,
	      bounds: null,
	      center: INITIAL_CENTER,
	      audienceCount: {
	        total: 0,
	        email: 0,
	        display: 0,
	        social: 0
	      }
	    };
	    return _this;
	  }
	
	  _createClass(MapSelector, [{
	    key: "onStartDrawing",
	    value: function onStartDrawing(type) {
	      this.setState({
	        circle: {
	          center: null,
	          radius: 0,
	          visible: false
	        },
	        rect: {
	          bounds: null,
	          visiable: false
	        },
	        polygon: {
	          path: [],
	          visiable: false
	        },
	        zoom: this._map.getZoom(),
	        center: this._map.getCenter(),
	        onDrawing: false,
	        readyApply: false
	      });
	      switch (type) {
	        case "circle":
	          this.setState({
	            defaultDrawingMode: google.maps.drawing.OverlayType.CIRCLE
	          });
	          //this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE)
	          break;
	        case "rectangle":
	          this.setState({
	            defaultDrawingMode: google.maps.drawing.OverlayType.RECTANGLE
	          });
	          //this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE)
	          break;
	        //case "polygon":
	        default:
	          this.setState({
	            defaultDrawingMode: google.maps.drawing.OverlayType.POLYGON
	          });
	          //this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON)
	          break;
	      }
	    }
	  }, {
	    key: "handleMapMounted",
	    value: function handleMapMounted(map) {
	      this._map = map;
	    }
	  }, {
	    key: "handleCenterChanged",
	    value: function handleCenterChanged() {
	      var nextCenter = this._map.getCenter();
	      if (nextCenter.equals(new google.maps.LatLng(INITIAL_CENTER))) {
	        return;
	      }
	
	      this.setState({
	        center: nextCenter
	      });
	    }
	  }, {
	    key: "handleZoomChanged",
	    value: function handleZoomChanged() {
	      this.setState({
	        zoom: this._map.getZoom(),
	        center: this._map.getCenter()
	      });
	    }
	  }, {
	    key: "calTotalAudience",
	    value: function calTotalAudience() {
	      var result = { total: 0, email: 0, display: 0, social: 0 };
	      this.setState({
	        audienceCount: result
	      });
	    }
	  }, {
	    key: "handleBoundsChanged",
	    value: function handleBoundsChanged() {
	      this.setState({
	        bounds: this._map.getBounds(),
	        center: this._map.getCenter()
	      });
	    }
	  }, {
	    key: "isAddress",
	    value: function isAddress(suggest) {
	      return suggest && suggest.gmaps && suggest.gmaps.types && addressTypes.findIndex(function (o) {
	        return suggest.gmaps.types.indexOf(o) > -1;
	      }) > -1;
	    }
	  }, {
	    key: "handleSuggestSelect",
	    value: function handleSuggestSelect(suggest) {
	      if (suggest) {
	        var isAddress = this.isAddress(suggest);
	        this.setState({
	          center: suggest.location,
	          updateComponent: true,
	          search_suggest: suggest,
	          radiusVal: null,
	          driveRadiusVal: null,
	          driveTimeVal: null
	        });
	        if (isAddress) {
	          this.setState({
	            marker: {
	              position: {
	                lat: suggest.location.lat,
	                lng: suggest.location.lng
	              },
	              key: "address"
	            }
	          });
	          if (this.state.zoom < 15) this.setState({ zoom: 15 });
	        } else {
	          if (this.state.zoom < 13) this.setState({ zoom: 13 });
	        }
	      }
	    }
	  }, {
	    key: "handleOpenResetDialog",
	    value: function handleOpenResetDialog(e, status) {
	      e.preventDefault();
	      this.setState({
	        openReset: status,
	        resetAnchorEl: e.currentTarget
	      });
	    }
	  }, {
	    key: "handleStartOverDialog",
	    value: function handleStartOverDialog(e, status) {
	      if (e) {
	        e.preventDefault();
	        this.setState({
	          openStartOver: status,
	          startOverAnchorEl: e.currentTarget
	        });
	      } else {
	        this.setState({
	          openStartOver: status
	        });
	      }
	    }
	  }, {
	    key: "handleAddressStartOverDialog",
	    value: function handleAddressStartOverDialog(e, status) {
	      if (e) {
	        e.preventDefault();
	        this.setState({
	          openAddressStartOver: status,
	          openStartOver: false,
	          addressOpenOverAnchorEl: e.currentTarget
	        });
	      } else {
	        this.setState({
	          openStartOver: false,
	          openAddressStartOver: status
	        });
	      }
	    }
	  }, {
	    key: "clearAllDrawing",
	    value: function clearAllDrawing() {
	      this.setState({
	        circle: {
	          center: null,
	          radius: 0,
	          visible: false
	        },
	        rect: {
	          bounds: null,
	          visiable: false
	        },
	        polygon: {
	          path: [],
	          visiable: false
	        },
	        readyApply: false,
	        onDrawing: false,
	        search_suggest: null,
	        radiusVal: null,
	        driveRadiusVal: null,
	        driveTimeVal: null,
	        audienceCount: { total: 0, email: 0, display: 0, social: 0 },
	        marker: {}
	      });
	      this.props.onApplyChanges({});
	    }
	  }, {
	    key: "updateCircleInfo",
	    value: function updateCircleInfo() {
	      this.setState({
	        circle: {
	          center: this._circle.getCenter(),
	          radius: this._circle.getRadius(),
	          visible: true
	        },
	        readyApply: true
	      });
	      this.calTotalAudience();
	      this.applySelect(true);
	    }
	  }, {
	    key: "updateRectInfo",
	    value: function updateRectInfo() {
	      var bounds = null;
	      try {
	        bounds = this._rectangle.getBounds();
	      } catch (ex) {}
	
	      if (bounds !== null) {
	        this.setState({
	          rect: {
	            bounds: this._rectangle.getBounds(),
	            visible: true
	          },
	          readyApply: true
	        });
	        this.calTotalAudience();
	        this.applySelect(true);
	      }
	    }
	  }, {
	    key: "preparePolygonInfo",
	    value: function preparePolygonInfo() {
	      var _this2 = this;
	
	      google.maps.event.addListener(this._polygon, "set_at", function () {
	        _this2._getPolygonNewPaths(_this2._polygon);
	      });
	      google.maps.event.addListener(this._polygon, "insert_at", function () {
	        _this2._getPolygonNewPaths(_this2._polygon);
	      });
	      google.maps.event.addListener(this._polygon, "remove_at", function () {
	        _this2._getPolygonNewPaths(_this2._polygon);
	      });
	    }
	  }, {
	    key: "updatePolygonInfo",
	    value: function updatePolygonInfo(e) {
	      this.setState({ onDraging: true });
	      this.calTotalAudience();
	      this.applySelect(true);
	      this.setState({ onDraging: false });
	    }
	  }, {
	    key: "handleStartOver",
	    value: function handleStartOver() {
	      this.setState({
	        showDrawingTool: false,
	        defaultDrawingMode: null,
	        onDrawing: false,
	        readyApply: false,
	        width: this.state.width,
	        circles: [],
	        openReset: false,
	        circle: {
	          center: null,
	          radius: 0,
	          visible: false
	        },
	        rect: {
	          bounds: null,
	          visiable: false
	        },
	        polygon: {
	          path: [],
	          visiable: false
	        },
	        zoom: 4,
	        bounds: null,
	        marker: {},
	        search_suggest: null,
	        center: INITIAL_CENTER,
	        audienceCount: {
	          total: 0,
	          email: 0,
	          display: 0,
	          social: 0
	        }
	      });
	      this._geoSuggest.clear();
	      this.props.onApplyChanges({});
	    }
	  }, {
	    key: "applySelect",
	    value: function applySelect(updateCountOnly) {
	      if (this.isAddress(this.state.search_suggest)) {
	        var address = null;
	        this.props.onUpdateAudienceCount(null);
	
	        switch (this.state.drawAddrType) {
	          case "radius":
	            address = {
	              type: "address_radius",
	              addressLabel: this.state.search_suggest.label,
	              center: this.state.search_suggest.location,
	              radius: this.state.radiusVal,
	              zoom: this.state.zoom,
	              audienceCount: this.state.audienceCount
	            };
	            break;
	          //case "drive":
	          default:
	            address = {
	              type: "address_drive",
	              zoom: this.state.zoom,
	              addressLabel: this.state.search_suggest.label,
	              center: this.state.search_suggest.location,
	              driveTime: this.state.driveTimeVal,
	              driveRadius: this.state.driveRadiusVal,
	              audienceCount: this.state.audienceCount
	            };
	            break;
	        }
	        if (address !== null) {
	          if (updateCountOnly) this.props.onUpdateAudienceCount(address);else this.props.onApplyChanges(address);
	        }
	      } else {
	        this.props.onUpdateAudienceCount(null);
	        if (this.state.circle.visible === true) {
	          var circle = {
	            center: this.state.circle.center,
	            radius: this.state.circle.radius,
	            type: "circle",
	            zoom: this.state.zoom,
	            audienceCount: this.state.audienceCount
	          };
	          if (updateCountOnly) this.props.onUpdateAudienceCount(circle);else this.props.onApplyChanges(circle);
	        }
	        if (this.state.rect.visible === true) {
	          var ne = this.state.rect.bounds.getNorthEast();
	          var sw = this.state.rect.bounds.getSouthWest();
	          var rectBound = new google.maps.LatLngBounds(sw, ne);
	          var rectangle = {
	            bounds: this.state.rect.bounds,
	            center: rectBound.getCenter(),
	            type: "rectangle",
	            zoom: this.state.zoom,
	            audienceCount: this.state.audienceCount
	          };
	          if (updateCountOnly) this.props.onUpdateAudienceCount(rectangle);else this.props.onApplyChanges(rectangle);
	        }
	        if (this.state.polygon.visible === true) {
	          var polygonBounds = new google.maps.LatLngBounds();
	          var polygonPath = this._polygon.getPath();
	          polygonPath.forEach(function (element, index) {
	            polygonBounds.extend(element);
	          });
	          var polygon = {
	            path: polygonPath,
	            encode_path: google.maps.geometry.encoding.encodePath(polygonPath),
	            center: polygonBounds.getCenter(), //this._map.getCenter(),
	            type: "polygon",
	            zoom: this.state.zoom,
	            audienceCount: this.state.audienceCount
	          };
	          if (updateCountOnly) this.props.onUpdateAudienceCount(polygon);else this.props.onApplyChanges(polygon);
	        }
	      }
	      if (!updateCountOnly) {
	        this.setState({ readyApply: false, onDraging: false });
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "handleRadioChange",
	    value: function handleRadioChange(e, value) {
	      e.preventDefault();
	      if (this.state.drawAddrType !== value) {
	        this.setState({
	          drawAddrType: value,
	          radiusVal: 0,
	          driveRadiusVal: 0,
	          driveTimeVal: 0,
	          audienceCount: { total: 0, email: 0, display: 0, social: 0 }
	        });
	        this.props.onApplyChanges({});
	      }
	    }
	  }, {
	    key: "_onRadiusAfterChange",
	    value: function _onRadiusAfterChange(value) {
	      if (this.state.readyApply === false) {
	        if (value > 0) {
	          setTimeout(function () {
	            this._map.fitBounds(this._addressCircle.getBounds());
	          }.bind(this), 200);
	          setTimeout(function () {
	            this.applySelect(true);
	            this.setState({
	              readyApply: true
	            });
	          }.bind(this), 200);
	        } else {
	          setTimeout(function () {
	            this.setState({ zoom: 15, readyApply: true });
	          }.bind(this), 200);
	          this.applySelect(true);
	        }
	        this.calTotalAudience();
	      }
	    }
	  }, {
	    key: "_handleRadiusChange",
	    value: function _handleRadiusChange(value) {
	      this.setState({
	        radiusVal: value,
	        readyApply: false
	      });
	    }
	  }, {
	    key: "_handleDriveTimeChange",
	    value: function _handleDriveTimeChange(value) {
	      this.setState({
	        driveTimeVal: value,
	        readyApply: false
	      });
	    }
	  }, {
	    key: "_onDriveTimeAfterChange",
	    value: function _onDriveTimeAfterChange(value) {
	      if (this.state.readyApply === false) {
	        this.calTotalAudience();
	        var radius = (0, _utility.getCityAvgSpeed)(this.state.search_suggest.label) * value / 1000 * 0.6;
	        this.setState({
	          driveTimeVal: value,
	          driveRadiusVal: radius,
	          radiusVal: radius,
	          readyApply: false
	        });
	        if (value > 0) {
	          setTimeout(function () {
	            this._map.fitBounds(this._driveCircle.getBounds());
	          }.bind(this), 200);
	          setTimeout(function () {
	            this.applySelect(true);
	            this.setState({
	              readyApply: true
	            });
	          }.bind(this), 300);
	        } else {
	          setTimeout(function () {
	            this.setState({ zoom: 15, readyApply: true });
	          }.bind(this), 200);
	          this.applySelect(true);
	        }
	      }
	    }
	  }, {
	    key: "_handleClose",
	    value: function _handleClose(e) {
	      e.preventDefault();
	      this.setState({ readyApply: false, onDraging: false });
	
	      setTimeout(function () {
	        this.props.onClose();
	      }.bind(this), 50);
	    }
	  }, {
	    key: "_initMap",
	    value: function _initMap(plottedValue) {
	      this.setState({
	        circle: {
	          center: null,
	          radius: 0,
	          visible: false
	        },
	        rect: {
	          bounds: null,
	          visiable: false
	        },
	        polygon: {
	          path: [],
	          visiable: false
	        },
	        readyApply: false,
	        onDrawing: false,
	        search_suggest: null,
	        radiusVal: null,
	        driveRadiusVal: null,
	        driveTimeVal: null,
	        audienceCount: { total: 0, email: 0, display: 0, social: 0 },
	        marker: {}
	      });
	
	      switch (plottedValue.type) {
	        case "address_radius":
	        case "address_drive":
	          this.setState({
	            center: plottedValue.center,
	            zoom: plottedValue.zoom,
	            updateComponent: true,
	            search_suggest: {
	              gmaps: { types: ["street_address"] },
	              label: plottedValue.addressLabel,
	              location: plottedValue.center
	            },
	            radiusVal: plottedValue.radius,
	            driveTimeVal: plottedValue.driveTime,
	            driveRadiusVal: plottedValue.driveRadius,
	            drawAddrType: plottedValue.type === "address_radius" ? "radius" : "drive"
	          });
	          this.setState({
	            marker: {
	              position: {
	                lat: plottedValue.center.lat,
	                lng: plottedValue.center.lng
	              },
	              key: "address"
	            }
	          });
	          break;
	        case "rectangle":
	          this.setState({
	            center: plottedValue.center,
	            zoom: plottedValue.zoom,
	            rect: {
	              bounds: plottedValue.bounds,
	              visiable: true
	            }
	          });
	          break;
	        case "circle":
	        default:
	          this.setState({
	            center: plottedValue.center,
	            zoom: plottedValue.zoom,
	            circle: {
	              center: plottedValue.center,
	              radius: plottedValue.radius,
	              visiable: true
	            }
	          });
	          break;
	        case "polygon":
	          this.setState({
	            center: plottedValue.center,
	            zoom: plottedValue.zoom,
	            polygon: {
	              path: typeof plottedValue.path === "string" ? google.maps.geometry.encoding.decodePath(plottedValue.path) : plottedValue.path,
	              visiable: true
	            }
	          });
	
	          break;
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var width = document.getElementById("CreateSegment") ? document.getElementById("CreateSegment").clientWidth : null;
	      this.setState({ width: width ? width : 1280 });
	      var plottedValue = this.props.plottedValue;
	
	      if (!(0, _lodash.isEmpty)(plottedValue)) {
	        this._initMap(plottedValue);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.onDraging === true || this.state.onDraging === true) return false;
	
	      return true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var btnStartOver = _react2.default.createElement(
	        _rcTooltip2.default,
	        {
	          visible: this.state.openStartOver,
	          overlayStyle: { zIndex: 9999 },
	          animation: "zoom",
	          onVisibleChange: function onVisibleChange(visible) {
	            return _this3.handleStartOverDialog(null, visible);
	          },
	          trigger: "click",
	          overlay: [_react2.default.createElement(
	            _Grid.FullRow,
	            {
	              key: "so-text-row",
	              className: "text-default no-padding-bottom no-margin-bottom"
	            },
	            "Are you sure you want to start over?",
	            _react2.default.createElement("br", null),
	            "Any selections you have made will not be saved",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ), _react2.default.createElement(
	            _Grid.FullRow,
	            { key: "so-btn-row", className: "no-padding-bottom" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-link btn-sm text-teal-400 mr-20",
	                onClick: function onClick(e) {
	                  _this3.handleStartOverDialog(e, false);
	                }
	              },
	              "Close"
	            ),
	            "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0",
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-aa-default btn-round btn-sm bg-grey text-white ml-20",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this3.handleStartOver();
	                  _this3.handleStartOverDialog(e, false);
	                }
	              },
	              "Yes, reset"
	            )
	          )]
	        },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "btn btn-link no-padding pt-10 ml-10 text-capitalize text-size-small text-white",
	            onClick: function onClick(e) {
	              _this3.handleStartOverDialog(e, true);
	            }
	          },
	          "Start over"
	        )
	      );
	
	      var btnAddressStartOver = _react2.default.createElement(
	        _rcTooltip2.default,
	        {
	          visible: this.state.openAddressStartOver,
	          overlayStyle: { zIndex: 9999 },
	          animation: "zoom",
	          onVisibleChange: function onVisibleChange(visible) {
	            return _this3.handleAddressStartOverDialog(null, visible);
	          },
	          trigger: "click",
	          overlay: [_react2.default.createElement(
	            _Grid.FullRow,
	            {
	              key: "so-text-row",
	              className: "text-default no-padding-bottom no-margin-bottom"
	            },
	            "Are you sure you want to start over?",
	            _react2.default.createElement("br", null),
	            "Any selections you have made will not be saved",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ), _react2.default.createElement(
	            _Grid.FullRow,
	            { key: "so-btn-row", className: "no-padding-bottom" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-link btn-sm text-teal-400 mr-20",
	                onClick: function onClick(e) {
	                  _this3.handleAddressStartOverDialog(e, false);
	                }
	              },
	              "Close"
	            ),
	            "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0",
	            _react2.default.createElement(
	              "a",
	              {
	                className: "btn btn-aa-default btn-round btn-sm bg-grey text-white ml-20",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this3.handleStartOver();
	                  _this3.handleAddressStartOverDialog(e, false);
	                }
	              },
	              "Yes, reset"
	            )
	          )]
	        },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "btn btn-link no-padding pt-10 ml-10 text-capitalize text-size-small text-white mt-10",
	            onClick: function onClick(e) {
	              _this3.handleStartOverDialog(e, true);
	            }
	          },
	          "Start over"
	        )
	      );
	
	      var circle_options = (0, _utility.getMapVectorOptions)();
	      var onClose = this.props.onClose;
	
	      var drawingBtnClass = "btn btn-icon pt-10 no-padding mr-20 ";
	      var removeDrawingBtnClass = "btn btn-icon pt-10 no-padding mr-20 text-white ";
	      var applyBtnClass = this.state.readyApply === true ? "btn btn-rounded btn-xs text-uppercase bg-teal-400" : "btn btn-rounded disabled btn-xs text-uppercase bg-teal-400 ";
	      if (this.state.onDrawing === true || this.state.readyApply === true) drawingBtnClass += " disabled";else removeDrawingBtnClass += " disabled";
	      var SegmentGoogleMap = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
	        return _react2.default.createElement(
	          _reactGoogleMaps.GoogleMap,
	          {
	            defaultCenter: _this3.state.center,
	            defaultOptions: {
	              streetViewControl: false,
	              mapTypeControl: false
	            },
	            ref: props.onMapLoad,
	            defaultZoom: 4,
	            onZoomChanged: props.onZoomChanged,
	            zoom: props.zoom,
	            center: props.center
	          },
	          _react2.default.createElement(_DrawingManager2.default, {
	            ref: function ref(elm) {
	              return _this3.drawingManager = elm;
	            },
	            defaultDrawingMode: null,
	            defaultOptions: {
	              drawingControl: false,
	              drawingControlOptions: {
	                position: google.maps.ControlPosition.TOP_CENTER,
	                drawingModes: [google.maps.drawing.OverlayType.CIRCLE, google.maps.drawing.OverlayType.POLYGON, google.maps.drawing.OverlayType.RECTANGLE]
	              },
	              circleOptions: circle_options,
	              rectangleOptions: circle_options,
	              polymgonOptions: circle_options
	            },
	            drawingMode: _this3.state.defaultDrawingMode,
	            onOverlayComplete: _this3.overlayComplete.bind(_this3)
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Circle, {
	            center: _this3.state.circle.center,
	            ref: function ref(circle) {
	              return _this3._circle = circle;
	            },
	            radius: _this3.state.circle.radius,
	            visiable: _this3.state.circle.visible,
	            editable: true,
	            draggable: false,
	            options: circle_options,
	            onCenterChanged: _this3.updateCircleInfo.bind(_this3),
	            onRadiusChanged: _this3.updateCircleInfo.bind(_this3)
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Circle, {
	            center: _this3.state.search_suggest ? _this3.state.search_suggest.location : null,
	            ref: function ref(circle) {
	              return _this3._addressCircle = circle;
	            },
	            radius: _this3.state.radiusVal * 1609.34,
	            visible: _this3.state.drawAddrType === "radius",
	            editable: false,
	            draggable: false,
	            options: (0, _utility.getMutableCircleOptions)()
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Circle, {
	            center: _this3.state.search_suggest ? _this3.state.search_suggest.location : null,
	            ref: function ref(circle) {
	              return _this3._driveCircle = circle;
	            },
	            radius: _this3.state.driveRadiusVal * 1609.34,
	            visible: _this3.state.drawAddrType === "drive",
	            editable: false,
	            draggable: false,
	            options: (0, _utility.getMutableCircleOptions)()
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Rectangle, {
	            bounds: _this3.state.rect.bounds,
	            visiable: _this3.state.rect.visible,
	            ref: function ref(rectangle) {
	              return _this3._rectangle = rectangle;
	            },
	            editable: true,
	            draggable: true,
	            options: circle_options,
	            onDragEnd: function onDragEnd() {
	              _this3.setState({ onDraging: false });
	            },
	            onDragStart: function onDragStart() {
	              _this3.setState({ onDraging: true });
	            }
	            //onMouseDown={()=>{this.setState({onDraging: true})}}
	            //onMouseUp={()=>{this.setState({onDraging: false})}}
	            , onBoundsChanged: _this3.updateRectInfo.bind(_this3)
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Polygon, {
	            path: _this3.state.polygon.path,
	            visiable: _this3.state.polygon.visible,
	            ref: function ref(polygon) {
	              return _this3._polygon = polygon;
	            }
	            //onMouseDown={this.preparePolygonInfo.bind(this)}
	            , editable: true,
	            draggable: true,
	            options: circle_options,
	            onMouseUp: _this3.updatePolygonInfo.bind(_this3)
	          }),
	          _react2.default.createElement(_reactGoogleMaps.Marker, _this3.state.marker)
	        );
	      });
	
	      var showAddressTool = this.isAddress(this.state.search_suggest);
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(SegmentGoogleMap, {
	          containerElement: _react2.default.createElement("div", { style: { height: "100%", minHeight: "480px" } }),
	          mapElement: _react2.default.createElement("div", { style: { height: "100%", minHeight: "480px" } }),
	          zoom: this.state.zoom,
	          center: this.state.center,
	          onMapLoad: this.handleMapMounted.bind(this),
	          onBoundsChanged: this.handleBoundsChanged.bind(this),
	          onZoomChanged: this.handleZoomChanged.bind(this),
	          bounds: this.state.bounds
	        }),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "pl-20 pr-20 pb-10 pt-15",
	            style: {
	              color: "white",
	              width: "600px",
	              height: "55px",
	              position: "absolute",
	              left: this.state.width ? (this.state.width - 680) / 2 : 200,
	              top: 5,
	              backgroundColor: "rgba(0,0,0, 0.6)",
	              display: this.state.zoom < 5 && !showAddressTool ? "block" : "none"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "pull-left mr-10 pt-5" },
	            "ZOOM-IN OR "
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "pull-left text-grey", style: { width: "420px" } },
	            _react2.default.createElement(_reactGeosuggest2.default, {
	              ref: function ref(el) {
	                return _this3._geoSuggest = el;
	              },
	              onSuggestSelect: this.handleSuggestSelect.bind(this),
	              suggestsClassName: "find-address-suggest",
	              suggestItemClassName: "find-address-suggest-item",
	              suggestItemActiveClassName: "find-address-suggest-active-item",
	              placeholder: "Find a Place",
	              types: ["geocode"],
	              country: "us"
	            })
	          ),
	          _react2.default.createElement(
	            "span",
	            {
	              className: "pull-left",
	              style: { marginLeft: "-20px", marginTop: "3px", color: "grey" }
	            },
	            _react2.default.createElement("i", { className: "icon-search4" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pull-right" },
	            _react2.default.createElement(
	              "a",
	              { onClick: this._handleClose.bind(this) },
	              _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "pl-20 pr-20 pb-10",
	            style: {
	              color: "white",
	              width: "600px",
	              paddingTop: "5px",
	              height: "70px",
	              position: "absolute",
	              left: this.state.width ? (this.state.width - 680) / 2 : 200,
	              top: 5,
	              backgroundColor: "rgba(0,0,0, 0.6)",
	              display: this.state.zoom < 5 || showAddressTool ? "none" : "block"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            "Select a drawing tool to plot a radius"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pull-right" },
	            _react2.default.createElement(
	              "a",
	              { onClick: this._handleClose.bind(this) },
	              _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400" })
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            {
	              className: drawingBtnClass,
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this3.onStartDrawing("circle");
	              }
	            },
	            _react2.default.createElement("i", { className: "icon-circle text-white" })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: drawingBtnClass,
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this3.onStartDrawing("rectangle");
	              }
	            },
	            _react2.default.createElement("i", { className: " icon-checkbox-unchecked text-white" })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: drawingBtnClass,
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this3.onStartDrawing("polygon");
	              }
	            },
	            _react2.default.createElement("i", { className: " icon-stats-growth2 text-white" })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: removeDrawingBtnClass,
	              style: { textTransform: "capitalize" },
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this3.clearAllDrawing();
	              }
	            },
	            "X Delete Radius"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              style: {
	                padding: "3px 10px",
	                marginTop: "5px",
	                marginLeft: "90px"
	              },
	              className: applyBtnClass,
	              onClick: this.applySelect.bind(this, false)
	            },
	            "Apply Map Selection",
	            " "
	          ),
	          btnStartOver
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "pl-20 pr-20 pb-10 pt-10",
	            style: {
	              color: "white",
	              width: "680px",
	              paddingTop: "5px",
	              height: "140px",
	              position: "absolute",
	              left: this.state.width ? (this.state.width - 680) / 2 : 200,
	              top: 5,
	              backgroundColor: "rgba(0,0,0, 0.6)",
	              display: showAddressTool ? "block" : "none"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "text-grey pull-left", style: { width: "380px" } },
	            _react2.default.createElement("input", {
	              className: "no-border pl-5 pr-5 pt-5 pb-5 ",
	              type: "text",
	              readOnly: true,
	              style: { width: "100%" },
	              value: this.state.search_suggest ? this.state.search_suggest.label : ""
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "text-grey ml-20",
	              style: { width: "220px", display: "inline-block" }
	            },
	            _react2.default.createElement(
	              _materialUi.RadioButtonGroup,
	              {
	                name: "radio_group_address",
	                onChange: this.handleRadioChange.bind(this),
	                valueSelected: this.state.drawAddrType
	              },
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "radius",
	                label: "RADIUS",
	                labelStyle: radioButtonStyle.labeStyle,
	                iconStyle: radioButtonStyle.inputStyle,
	                style: radioButtonStyle.firstRadioStyle
	              }),
	              _react2.default.createElement(_materialUi.RadioButton, {
	                value: "drive",
	                label: "DRIVE TIME",
	                labelStyle: radioButtonStyle.labeStyle,
	                iconStyle: radioButtonStyle.inputStyle,
	                style: radioButtonStyle.secondRadioStyle
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pull-right", style: { marginTop: "-10px" } },
	            _react2.default.createElement(
	              "a",
	              { onClick: onClose },
	              _react2.default.createElement("i", { className: "icon-cancel-circle2 text-teal-400 mt-10" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: this.state.drawAddrType === "radius" ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(_rcSlider2.default, {
	              className: "slider-radius",
	              min: 0,
	              max: 100,
	              included: true,
	              step: 1,
	              onChange: this._handleRadiusChange.bind(this),
	              value: this.state.radiusVal,
	              onAfterChange: this._onRadiusAfterChange.bind(this),
	              marks: {
	                5: "5",
	                10: "10",
	                25: "25",
	                50: "50",
	                75: "75",
	                100: "100"
	              }
	            }),
	            _react2.default.createElement("input", {
	              type: "text",
	              readOnly: true,
	              style: { width: "100px" },
	              value: this.state.radiusVal ? this.state.radiusVal : "",
	              className: "no-border pl-5 pr-5 pt-5 pb-5 text-teal-400"
	            }),
	            " ",
	            "\xA0 Miles"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: this.state.drawAddrType === "drive" ? "block" : "none"
	              }
	            },
	            _react2.default.createElement(_rcSlider2.default, {
	              className: "slider-radius",
	              min: 0,
	              max: 4,
	              included: true,
	              step: 0.5,
	              onChange: this._handleDriveTimeChange.bind(this),
	              onAfterChange: this._onDriveTimeAfterChange.bind(this),
	              value: this.state.driveTimeVal,
	              marks: {
	                0.5: "0.5",
	                1: "1",
	                1.5: "1.5",
	                2: "2",
	                2.5: "2.5",
	                3: "3",
	                3.5: "3.5",
	                4: "4"
	              }
	            }),
	            _react2.default.createElement("input", {
	              type: "text",
	              readOnly: true,
	              style: { width: "100px" },
	              value: this.state.driveTimeVal ? this.state.driveTimeVal : "",
	              className: "no-border pl-5 pr-5 pt-5 pb-5 text-teal-400"
	            }),
	            " ",
	            "\xA0 HR(S)"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "a",
	              {
	                style: { padding: "3px 10px", marginTop: "20px" },
	                className: applyBtnClass,
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this3.applySelect(false);
	                }
	              },
	              "Apply"
	            ),
	            "\xA0\xA0\xA0",
	            btnAddressStartOver
	          )
	        )
	      );
	    }
	  }]);
	
	  return MapSelector;
	}(_react.Component);
	
	exports.default = MapSelector;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _Grid = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SaveSuccess = function (_Component) {
		_inherits(SaveSuccess, _Component);
	
		function SaveSuccess() {
			_classCallCheck(this, SaveSuccess);
	
			return _possibleConstructorReturn(this, (SaveSuccess.__proto__ || Object.getPrototypeOf(SaveSuccess)).apply(this, arguments));
		}
	
		_createClass(SaveSuccess, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.clearSegmentWithRules();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'mt-20' },
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'no-margin-bottom' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '5', sm: '5', md: '5', lg: '5', offsetXs: '4', offsetSm: '4', offsetMd: '4', offsetLg: '4' },
							_react2.default.createElement(
								'h3',
								null,
								_react2.default.createElement(
									'bold',
									null,
									'Your audience segment has been saved!'
								)
							)
						)
					),
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'no-margin-top no-padding-top no-margin-bottom font-12em' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '7', sm: '7', md: '7', lg: '7', offsetXs: '4', offsetSm: '4', offsetMd: '4', offsetLg: '4' },
							_react2.default.createElement(
								'span',
								{ className: 'pr-10', style: { display: "table-cell" } },
								_react2.default.createElement('i', { className: 'icon-checkmark4 text-teal-400 ' })
							),
							_react2.default.createElement(
								'span',
								{ style: { display: "table-cell" } },
								this.props.segment_name,
								' has been added to your ',
								_react2.default.createElement(
									_reactRouterDom.Link,
									{ to: '/segments/list/active' },
									'audience segment list '
								)
							)
						)
					),
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'no-margin-top no-padding-top no-margin-bottom font-12em' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '7', sm: '7', md: '7', lg: '7', offsetXs: '4', offsetSm: '4', offsetMd: '4', offsetLg: '4' },
							_react2.default.createElement(
								'span',
								{ className: 'mr-10' },
								_react2.default.createElement('i', { className: 'icon-checkmark4 text-teal-400 ' })
							),
							'View atttribute breakdown in your ',
							_react2.default.createElement(
								'a',
								{ href: "/segments/list/detail/" + this.props.save_segment_report_id },
								'audience segment report '
							)
						)
					),
					_react2.default.createElement(
						_Grid.Row,
						{ className: 'font-12em' },
						_react2.default.createElement(
							_Grid.Col,
							{ xs: '7', sm: '7', md: '7', lg: '7', offsetXs: '4', offsetSm: '4', offsetMd: '4', offsetLg: '4' },
							_react2.default.createElement(
								'div',
								{ style: { width: '100%', paddingLeft: "25px" } },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-default legitRipple bg-teal-400' },
									_react2.default.createElement(
										_reactRouterDom.Link,
										{ to: '/segment/create', style: { color: '#FFF' } },
										'Create an Audience Segment'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return SaveSuccess;
	}(_react.Component);
	
	exports.default = SaveSuccess;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _SegmentCreation = __webpack_require__(1209);
	
	var _SegmentCreation2 = _interopRequireDefault(_SegmentCreation);
	
	var _SegmentConfirm = __webpack_require__(1208);
	
	var _SegmentConfirm2 = _interopRequireDefault(_SegmentConfirm);
	
	var _SegmentSaveSuccess = __webpack_require__(1210);
	
	var _SegmentSaveSuccess2 = _interopRequireDefault(_SegmentSaveSuccess);
	
	var _SegmentNav = __webpack_require__(1173);
	
	var _SegmentNav2 = _interopRequireDefault(_SegmentNav);
	
	var _Grid = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Segment = function (_AcquireWebComponent) {
		_inherits(Segment, _AcquireWebComponent);
	
		function Segment() {
			_classCallCheck(this, Segment);
	
			return _possibleConstructorReturn(this, (Segment.__proto__ || Object.getPrototypeOf(Segment)).apply(this, arguments));
		}
	
		_createClass(Segment, [{
			key: 'getComponent',
			value: function getComponent() {
				var history = this.props.history;
	
				switch (this.props.match.params.step) {
					case "create":
						return _react2.default.createElement(_SegmentCreation2.default, { history: history });
					case "confirm":
						return _react2.default.createElement(_SegmentConfirm2.default, { history: history });
					case "save_success":
						return _react2.default.createElement(_SegmentSaveSuccess2.default, null);
					default:
						return "";
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.state = {
					marginLeft: 0
				};
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var container = document.getElementById("steps-uid-0-t-0");
	
				this.setState({ marginLeft: container ? container.clientWidth / 2 - 40 : 0 });
			}
		}, {
			key: 'getNavBar',
			value: function getNavBar() {
				var ml = '-' + this.state.marginLeft + 'px';
				return this.props.location.pathname !== '/segment' && this.props.match.params.step !== 'save_success' && _react2.default.createElement(
					_Grid.Row,
					null,
					_react2.default.createElement(
						_Grid.Col,
						{ xs: '7', sm: '7', md: '7', lg: '7', style: { paddingLeft: '0px', marginLeft: ml } },
						_react2.default.createElement(_SegmentNav2.default, this.props)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ id: 'Segment', style: { padding: "0 10%" } },
					this.getNavBar(),
					this.getComponent()
				);
			}
		}]);
	
		return Segment;
	}(_MaterialUI2.default);
	
	exports.default = Segment;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Title = __webpack_require__(212);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _SubscriptionList = __webpack_require__(258);
	
	var _SubscriptionList2 = _interopRequireDefault(_SubscriptionList);
	
	var _SearchBar = __webpack_require__(259);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _SubTable = __webpack_require__(1161);
	
	var _SubTable2 = _interopRequireDefault(_SubTable);
	
	var _Page = __webpack_require__(103);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _orderBy = __webpack_require__(673);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	__webpack_require__(598);
	
	var _utility = __webpack_require__(14);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubscriptionsInfo = function (_Component) {
	  _inherits(SubscriptionsInfo, _Component);
	
	  function SubscriptionsInfo(props) {
	    _classCallCheck(this, SubscriptionsInfo);
	
	    var _this = _possibleConstructorReturn(this, (SubscriptionsInfo.__proto__ || Object.getPrototypeOf(SubscriptionsInfo)).call(this, props));
	
	    _this.throttle = true;
	    _this.state = {
	      requestParams: {
	        clientId: '',
	        pageNumber: 1,
	        pageSize: 15,
	        sortColumn: 'clientName',
	        order: 'asc'
	      }
	    };
	    return _this;
	  }
	
	  _createClass(SubscriptionsInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getSubStats();
	      this.props.getSearchData(this.state.requestParams);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.search_results.clients && this.throttle) {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            pageSize: nextProps.search_results.clients.total
	          })
	        }, function () {
	          _this2.props.getAllSearchData(_this2.state.requestParams);
	        });
	        this.throttle = false;
	      }
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(selectedItem) {
	      var _this3 = this;
	
	      var obj = {};
	      if (selectedItem === '') {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: '',
	            pageNumber: 1,
	            pageSize: 15
	          })
	        };
	        this.goToPage(1);
	      } else {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: selectedItem,
	            pageNumber: 1,
	            pageSize: 15
	          })
	        };
	      }
	      this.setState(obj, function () {
	        _this3.props.getSearchData(_this3.state.requestParams);
	      });
	    }
	  }, {
	    key: 'nextBeClick',
	    value: function nextBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: 'previousBeClick',
	    value: function previousBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: 'goToPage',
	    value: function goToPage(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: 'pageAbleFunc',
	    value: function pageAbleFunc(val) {
	      var _this4 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageNumber: val,
	          pageSize: 15
	        })
	      }, function () {
	        _this4.props.getSearchData(_this4.state.requestParams);
	      });
	    }
	  }, {
	    key: 'handleSortByClientName',
	    value: function handleSortByClientName() {
	      var _this5 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageSize: 15,
	          order: this.state.requestParams.order === 'desc' ? 'asc' : 'desc'
	        })
	      }, function () {
	        _this5.props.getSearchData(_this5.state.requestParams);
	      });
	    }
	  }, {
	    key: 'handleDownload',
	    value: function handleDownload() {
	      var title = 'AudienceAnywhere Subscripions,,,\r\n';
	      var total = this.props.subscription_total[0].label + ',' + this.props.subscription_total[0].value + ',,\r\n';
	      var active = this.props.subscription_total[1].label + ',' + this.props.subscription_total[1].value + ',,\r\n';
	      var data = '';
	      var itemFun = function itemFun(item) {
	        data += '"' + item.clientName + '",' + (item.bizUnitName || '') + ',' + (item.subscription && item.subscription.name || '') + ',' + ((0, _moment2.default)(item.createdTime).format('M/DD/YY') || '') + '\r\n';
	      };
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.props.all_search_results.clients.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          if (v.children) {
	            data += '"' + v.clientName + '",,' + (v.subscription && v.subscription.name || '') + ',' + ((0, _moment2.default)(v.createdTime).format('M/DD/YY') || '') + '\r\n';
	            v.children.forEach(itemFun);
	          } else {
	            data += '"' + v.clientName + '",' + (v.bizUnitName || '') + ',' + (v.subscription && v.subscription.name || '') + ',' + ((0, _moment2.default)(v.createdTime).format('M/DD/YY') || '') + '\r\n';
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var csv_string = title + total + active + ',,,\r\n' + 'Client Name,Business Unit Name,Subscription,Subscription Start Date\r\n' + data;
	      (0, _utility.downLoadCSVFunc)(csv_string.trim(), 'AA_Subscriptions_' + (0, _moment2.default)().format("YYYYMMDD"));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'subscription-info', style: { marginTop: '-20px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'title-wrapper' },
	            _react2.default.createElement(_Title2.default, {
	              handleDownload: function handleDownload() {
	                return _this6.handleDownload();
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sub-info-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'common-wrapper' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'TOTAL NUMBER OF SUBSCRIPTIONS BY TIER'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'list' },
	                _react2.default.createElement(_SubscriptionList2.default, {
	                  data: (0, _orderBy2.default)(this.props.subscription_total, ["label"], ["desc"])
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'common-wrapper mt-20' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'border-title' },
	                'SUBSCRIPTIONS'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'search-bar' },
	                _react2.default.createElement(_SearchBar2.default, {
	                  clients: this.props.clients,
	                  handleSearch: function handleSearch(selectedItem) {
	                    return _this6.handleSearch(selectedItem);
	                  }
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tag-info-table-wrapper' },
	                  _react2.default.createElement(_SubTable2.default, {
	                    handleSortByClientName: function handleSortByClientName() {
	                      return _this6.handleSortByClientName();
	                    },
	                    tableHeaderArr: [{ label: 'Client Name', value: 0 }, { label: 'Business Unit Name', value: 1 }, { label: 'Subscription', value: 2 }, { label: 'Subscription Start Date', value: 3 }],
	                    bodyDataArr: this.props.search_results.clients ? this.props.search_results.clients.data : [],
	                    tableHeaderWidthStyle: ['22%', '22%', '22%', '16%'],
	                    renderCols: {
	                      cols: ['clientName', 'bizUnitName', 'subscription', 'subscriptionTierStartTime']
	                    }
	                  }),
	                  _react2.default.createElement(_Page2.default, {
	                    nextBeClick: function nextBeClick(page) {
	                      return _this6.nextBeClick(page);
	                    },
	                    pageNumber: this.props.search_results.clients && this.props.search_results.clients.pageNumber,
	                    pageCount: this.props.search_results.clients && this.props.search_results.clients.pageCount,
	                    pageSize: this.props.search_results.clients && this.props.search_results.clients.pageSize,
	                    nextGroupBeClick: function nextGroupBeClick(page) {
	                      return _this6.nextGroupBeClick(page);
	                    },
	                    previousGroupBeClick: function previousGroupBeClick(page) {
	                      return _this6.previousGroupBeClick(page);
	                    },
	                    previousBeClick: function previousBeClick(page) {
	                      return _this6.previousBeClick(page);
	                    },
	                    pageBeClick: function pageBeClick(page) {
	                      return _this6.pageBeClick(page);
	                    },
	                    total: this.props.search_results.clients && this.props.search_results.clients.total,
	                    hasNext: this.props.search_results.clients && this.props.search_results.clients.hasNext,
	                    hasPrevious: this.props.search_results.clients && this.props.search_results.clients.hasPrevious,
	                    pagePlus: true,
	                    selectRows: function selectRows(page, row) {
	                      return _this6.selectRows(page, row);
	                    },
	                    goToPage: function goToPage(page) {
	                      return _this6.goToPage(page);
	                    }
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SubscriptionsInfo;
	}(_react.Component);
	
	exports.default = SubscriptionsInfo;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MaterialUI = __webpack_require__(15);
	
	var _MaterialUI2 = _interopRequireDefault(_MaterialUI);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _search = __webpack_require__(155);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _env = __webpack_require__(85);
	
	var _sortBy = __webpack_require__(67);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _remove = __webpack_require__(188);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _filter = __webpack_require__(61);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _findIndex = __webpack_require__(414);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncSearchBar = function (_AcquireWebComponent) {
		_inherits(AsyncSearchBar, _AcquireWebComponent);
	
		function AsyncSearchBar(props) {
			_classCallCheck(this, AsyncSearchBar);
	
			var _this = _possibleConstructorReturn(this, (AsyncSearchBar.__proto__ || Object.getPrototypeOf(AsyncSearchBar)).call(this, props));
	
			_this.state = {
				optionsArr: [],
				selectedItem: undefined,
				disabledAllClientsOption: true,
				isSearching: false
			};
			return _this;
		}
	
		_createClass(AsyncSearchBar, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.clients !== nextProps.clients) {
					this.initializeClientList(this.state.disabledAllClientsOption, nextProps.clients);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.clients) this.initializeClientList(this.state.disabledAllClientsOption, this.props.clients);
			}
		}, {
			key: 'processClientList',
			value: function processClientList(clients, filterIds, input) {
				var clientsList = [];
				if (input) input = input.trim();
				if (clients) {
					var sortedClients = (0, _sortBy2.default)(clients, function (c) {
						return c.name.toLowerCase();
					});
	
					if (clients.length === 1 && clients[0].id <= 1) {
						clientsList = (0, _remove2.default)(clientsList, function (c) {
							return c.id !== 0;
						});
					}
					sortedClients.forEach(function (item) {
						if (item.id > 1) {
							clientsList.push({ id: item.id, name: item.name });
							if (!(0, _isEmpty2.default)(item.businessUnits)) {
								var sortedSubClients = (0, _sortBy2.default)(item.businessUnits, function (c) {
									return c.name.toLowerCase();
								});
								sortedSubClients.forEach(function (sc) {
									clientsList.push({ id: sc.id, name: '      ' + sc.name });
								});
							}
						}
					});
	
					if (filterIds) {
						var result = (0, _filter2.default)(clientsList, function (c) {
							return filterIds.indexOf(c.id) >= 0;
						});
						if (input) {
							var _props$resultSet = this.props.resultSet,
							    bizUnitUsers = _props$resultSet.bizUnitUsers,
							    clientUsers = _props$resultSet.clientUsers;
	
							(0, _map2.default)(clientUsers.data, function (item, key) {
								if (item.clientName.indexOf(input) < 0) {
									var user = item.user;
	
									if (user.username.indexOf(input) >= 0) {
										var idx = (0, _findIndex2.default)(result, { id: item.clientId });
										result.splice(idx, 1, { id: item.clientId, name: user.username });
									} else if (user.email.indexOf(input) >= 0) {
										var _idx = (0, _findIndex2.default)(result, { id: item.clientId });
										result.splice(_idx, 1, { id: item.clientId, name: item.user.email });
									}
								}
							});
							(0, _map2.default)(bizUnitUsers, function (users, key) {
								var usersResult = (0, _filter2.default)(users, function (u) {
									return u.clientName.indexOf(input) < 0 && (!u.bizUnitName || u.bizUnitName.indexOf(input) < 0);
								});
								(0, _map2.default)(usersResult, function (item) {
									if (item.user.username.indexOf(input) >= 0) {
										var idx = (0, _findIndex2.default)(result, { id: item.clientId });
										result.splice(idx, 1, { id: item.clientId, name: item.user.username });
									} else if (item.user.email.indexOf(input) >= 0) {
										var _idx2 = (0, _findIndex2.default)(result, { id: item.clientId });
										result.splice(_idx2, 1, { id: item.clientId, name: item.user.email });
									}
								});
							});
						}
	
						return result;
					}
				}
				return clientsList;
			}
		}, {
			key: 'initializeClientList',
			value: function initializeClientList(disabledAllClientsOption, clients) {
				disabledAllClientsOption = true;
				var clientsList = this.processClientList(clients);
	
				this.setState({
					optionsArr: clientsList,
					clientAdminMode: this.props.roleId > 1 && this.props.roleId < 10,
					businessUserMode: this.props.roleId > 50,
					businessAdminMode: this.props.roleId === 51
				});
				if (disabledAllClientsOption === true && parseInt(this.props.selected_client, 10) === 0 && clientsList.length > 1 || this.props.roleId > 50 && parseInt(this.props.selected_client, 10) === 0) {
					if (clientsList.length > 1) {
						this.setState({ optionVal: clientsList[1].id });
						this.props.selectClient(clientsList[1].id);
					}
				}
			}
		}, {
			key: 'filterOption',
			value: function filterOption(option, filterString) {
				return option;
			}
		}, {
			key: 'optionRenderer',
			value: function optionRenderer(option) {
				return _react2.default.createElement(
					'span',
					null,
					option.label
				);
			}
		}, {
			key: 'handleOnChange',
			value: function handleOnChange(selectedItem) {
				if (selectedItem === null) {
					this.setState({
						selectedItem: undefined
					});
				} else {
					this.setState({
						selectedItem: selectedItem
					});
				}
			}
		}, {
			key: 'getClients',
			value: function getClients(input) {
				var _this2 = this;
	
				if (!input || input.length < 3) {
					return Promise.resolve({ options: [] });
				}
				var header = {
					'Content-Type': 'application/json',
					'Accept': 'application/json',
					'Authorization': this.props.token,
					'Cache-Control': 'no-cache',
					'max-age': 0
				};
				var url = _env.apiBaseUrl + '/clients/search?q=' + encodeURIComponent(input);
				return fetch(url, { method: "GET", headers: header }).then(function (response) {
					return response.json();
				}).then(function (json) {
					var result = _this2.processClientList(_this2.props.clients, json.clientIds, input);
					var clientOptions = [];
					result.forEach(function (item, index) {
						clientOptions.push({ value: item.id.toString(), label: item.name });
					});
					return { options: clientOptions };
				});
			}
		}, {
			key: 'handleSearch',
			value: function handleSearch() {
				if (this.state.selectedItem) this.props.handleSearch(this.state.selectedItem.value);else this.props.handleSearch("");
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'subscription-typeahead clearfix' },
					_react2.default.createElement(
						'span',
						{ className: 's' },
						'Search'
					),
					_react2.default.createElement(
						'div',
						{ className: 'type-ahead-container' },
						_react2.default.createElement(_reactSelect2.default.Async, {
							name: '',
							placeholder: '',
							multi: false,
							value: this.state.selectedItem,
							clearable: false,
							optionRenderer: function optionRenderer(val) {
								return _this3.optionRenderer(val);
							},
							onChange: function onChange(val) {
								return _this3.handleOnChange(val);
							},
							filterOption: this.filterOption.bind(this),
							loadOptions: this.getClients.bind(this),
							valueKey: "value",
							labelKey: "label"
						})
					),
					_react2.default.createElement(
						'button',
						{ onClick: function onClick() {
								return _this3.handleSearch();
							}, style: { cursor: 'pointer' } },
						_react2.default.createElement(_search2.default, {
							style: { color: 'white' }
						})
					)
				);
			}
		}]);
	
		return AsyncSearchBar;
	}(_MaterialUI2.default);
	
	exports.default = AsyncSearchBar;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(222);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _playArrow = __webpack_require__(156);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author chargoyao
	 * @property tableHeaderArr {array} table header array.
	 * [{label: 'ClientName', value: 'ClientName'}]
	 * @property renderCols {obj} render data column
	 * {
	 *  addedCol: 'xxx',
	 *  cols: ['xxx', 'xxxx']
	 * }
	 *
	 * @property bodyDataArr {array} remote data
	 * [{
	 *  clientName: 'Deluth Trading',
	 *  bizUnitName: 'Monsanto',
	 *  deploymentType: 'WebProperty',
	 *  domain: 'www.abc.com',
	 *  uuid: 291923-11,
	 *  activeStatus: Inactive
	 *  }, {
	 *    clientName: 'Deluth Trading',
	 *    bizUnitName: 'Monsanto',
	 *    deploymentType: 'WebProperty',
	 *    domain: 'www.abc.com',
	 *    uuid: 291923-11,
	 *    activeStatus: Inactive
	 *    children: [
	 *    ]
	 *  }]
	 *  @property tableHeaderWidthStyle {array} table Width style
	 *  ['22%', '12%']
	 */
	var arrowStyles = {
	  position: 'absolute',
	  right: 0,
	  top: 0
	};
	
	var SpreadTable = function (_Component) {
	  _inherits(SpreadTable, _Component);
	
	  function SpreadTable(props) {
	    _classCallCheck(this, SpreadTable);
	
	    var _this = _possibleConstructorReturn(this, (SpreadTable.__proto__ || Object.getPrototypeOf(SpreadTable)).call(this, props));
	
	    _this.state = {
	      activeIndex: 0,
	      arrowActive: 'down'
	    };
	    return _this;
	  }
	
	  _createClass(SpreadTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'handleClick',
	    value: function handleClick(label, index) {
	      this.setState({
	        activeIndex: index
	      });
	      if (+index === this.state.activeIndex) {
	        if (this.state.arrowActive === 'down') {
	          this.setState({
	            arrowActive: 'up'
	          });
	        } else {
	          this.setState({
	            arrowActive: 'down'
	          });
	        }
	      } else {
	        this.setState({
	          arrowActive: 'down'
	        });
	      }
	      if (index === 0) {
	        this.props.handleSortByClientName();
	      }
	    }
	  }, {
	    key: 'spreadTr',
	    value: function spreadTr(index) {
	      if (this.state['spread' + index]) {
	        this.setState(_defineProperty({}, 'spread' + index, false));
	      } else {
	        this.setState(_defineProperty({}, 'spread' + index, true));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'spread-table' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              this.props.tableHeaderArr.map(function (item, index) {
	                var widthStyle = '';
	                switch (index) {
	                  case 0:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[0];
	                    break;
	                  case 1:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[1];
	                    break;
	                  case 2:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[2];
	                    break;
	                  case 3:
	                    widthStyle = _this2.props.tableHeaderWidthStyle[3];
	                    break;
	                  default:
	                    widthStyle = '';
	                    break;
	                }
	                return _react2.default.createElement(
	                  'th',
	                  { key: item.value,
	                    className: _this2.state.activeIndex === index && index === 0 ? 'active' : '',
	                    onClick: function onClick() {
	                      if (item.label === 'Client Name') _this2.handleClick(item.label, index);
	                    },
	                    style: { width: widthStyle }
	                  },
	                  item.label,
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'down' && index === 0 && _react2.default.createElement(_arrowDropDown2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  }),
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'up' && index === 0 && _react2.default.createElement(_arrowDropUp2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  })
	                );
	              })
	            ),
	            this.props.bodyDataArr.map(function (item, index) {
	              if (!item.children) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: index },
	                  _this2.props.renderCols.cols.map(function (list, idx) {
	                    if (list === 'uuid') {
	                      return _react2.default.createElement(
	                        'td',
	                        { className: 'uuid', key: 'uuid-n' },
	                        item[list].substring(0, 6) + '...',
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          item[list]
	                        )
	                      );
	                    } else if (list === 'subscription') {
	                      return _react2.default.createElement(
	                        'td',
	                        { key: 'industry-n' },
	                        item[list]['name']
	                      );
	                    } else if (list === 'subscriptionTierStartTime') {
	                      return _react2.default.createElement(
	                        'td',
	                        { key: 'createdTime-n' },
	                        (0, _moment2.default)(item[list]).format('M/DD/YY')
	                      );
	                    } else {
	                      return _react2.default.createElement(
	                        'td',
	                        { key: item[list] + 'addCol', style: { paddingLeft: idx === 0 ? 0 : '' } },
	                        item[list]
	                      );
	                    }
	                  })
	                );
	              } else {
	                var obj = [];
	                if (item.children.length >= 1) {
	                  obj.push(_react2.default.createElement(
	                    'tr',
	                    { key: index, onClick: function onClick() {
	                        return _this2.spreadTr(index);
	                      } },
	                    _react2.default.createElement(
	                      'td',
	                      { style: { paddingLeft: '20px', cursor: 'pointer' } },
	                      _this2.state['spread' + index] ? _react2.default.createElement(_arrowDropDown2.default, {
	                        style: { position: 'absolute', left: '-7px', top: '2px' }
	                      }) : _react2.default.createElement(_playArrow2.default, {
	                        style: { position: 'absolute', left: '-5px', top: '6px', width: '16px', height: '16px' }
	                      }),
	                      item.clientName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.bizUnitName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      item.subscription.name
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { cursor: 'pointer' } },
	                      (0, _moment2.default)(item.subscriptionTierStartTime).format('M/DD/YY')
	                    )
	                  ));
	                }
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                  for (var _iterator = item.children.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _ref = _step.value;
	
	                    var _ref2 = _slicedToArray(_ref, 2);
	
	                    var _ = _ref2[0];
	                    var v = _ref2[1];
	
	                    obj.push(_react2.default.createElement(
	                      'tr',
	                      { style: { display: _this2.state['spread' + index] ? 'table-row' : 'none' } },
	                      _react2.default.createElement(
	                        'td',
	                        { style: { paddingLeft: '49px' }, key: 'clientName' },
	                        v.clientName
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { key: 'bizUnitName' },
	                        v.bizUnitName
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { key: 'subscription' },
	                        v.subscription && v.subscription.name
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { key: 'subscriptionTierStartTime' },
	                        (0, _moment2.default)(v.subscriptionTierStartTime).format("M/DD/YY")
	                      )
	                    ));
	                  }
	                } catch (err) {
	                  _didIteratorError = true;
	                  _iteratorError = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                      _iterator.return();
	                    }
	                  } finally {
	                    if (_didIteratorError) {
	                      throw _iteratorError;
	                    }
	                  }
	                }
	
	                return obj;
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SpreadTable;
	}(_react.Component);
	
	SpreadTable.defaultProps = {
	  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
	  bodyDataArr: [],
	  renderCols: {
	    addCol: '',
	    cols: []
	  }
	};
	
	exports.default = SpreadTable;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _Title = __webpack_require__(212);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _SubscriptionList = __webpack_require__(258);
	
	var _SubscriptionList2 = _interopRequireDefault(_SubscriptionList);
	
	var _SearchBar = __webpack_require__(259);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _tagInfoTable = __webpack_require__(1163);
	
	var _tagInfoTable2 = _interopRequireDefault(_tagInfoTable);
	
	var _Page = __webpack_require__(103);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _map = __webpack_require__(23);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(598);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// css
	
	
	//
	
	
	/**
	 * use the component of SubscriptionInfo
	 */
	var TagInfo = function (_Component) {
	  _inherits(TagInfo, _Component);
	
	  function TagInfo(props) {
	    _classCallCheck(this, TagInfo);
	
	    var _this = _possibleConstructorReturn(this, (TagInfo.__proto__ || Object.getPrototypeOf(TagInfo)).call(this, props));
	
	    _this.throttle = true;
	    _this.state = {
	      requestParams: {
	        clientId: "",
	        pageNumber: 1,
	        pageSize: 15,
	        sortColumn: "clientName",
	        order: "asc"
	      }
	    };
	    return _this;
	  }
	
	  _createClass(TagInfo, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.getTagsTotal();
	      this.props.tagsSearch(this.state.requestParams);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.search_results.clients && this.throttle) {
	        this.setState({
	          requestParams: Object.assign({}, this.state.requestParams, {
	            pageSize: nextProps.search_results.clients.total
	          })
	        }, function () {
	          _this2.props.tagsAllSearch(_this2.state.requestParams);
	        });
	        this.throttle = false;
	      }
	    }
	  }, {
	    key: "handleSearch",
	    value: function handleSearch(selectedItem) {
	      var _this3 = this;
	
	      var obj = {};
	      if (selectedItem === "") {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: "",
	            pageNumber: 1,
	            pageSize: 15
	          })
	        };
	        this.goToPage(1);
	      } else {
	        obj = {
	          requestParams: Object.assign({}, this.state.requestParams, {
	            clientId: selectedItem,
	            pageNumber: 1,
	            pageSize: 15
	          })
	        };
	      }
	      this.setState(obj, function () {
	        _this3.props.tagsSearch(_this3.state.requestParams);
	      });
	    }
	  }, {
	    key: "nextBeClick",
	    value: function nextBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: "previousBeClick",
	    value: function previousBeClick(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: "goToPage",
	    value: function goToPage(page) {
	      this.pageAbleFunc(page);
	    }
	  }, {
	    key: "pageAbleFunc",
	    value: function pageAbleFunc(val) {
	      var _this4 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageNumber: val,
	          pageSize: 15
	        })
	      }, function () {
	        _this4.props.tagsSearch(_this4.state.requestParams);
	      });
	    }
	  }, {
	    key: "handleSortByClientName",
	    value: function handleSortByClientName() {
	      var _this5 = this;
	
	      this.setState({
	        requestParams: Object.assign({}, this.state.requestParams, {
	          pageSize: 15,
	          order: this.state.requestParams.order === "desc" ? "asc" : "desc"
	        })
	      }, function () {
	        _this5.props.tagsSearch(_this5.state.requestParams);
	      });
	    }
	  }, {
	    key: "handleDownload",
	    value: function handleDownload() {
	      var title = "AudienceAnywhere Tags,,,,,\r\n";
	      var active = this.props.tags_total[0].label + "," + this.props.tags_total[0].value + ",,,,\r\n";
	      var inactive = this.props.tags_total[1].label + "," + this.props.tags_total[1].value + ",,,,\r\n";
	      //let total = `${this.props.tags_total[0].label},${this.props.tags_total[0].value},,,,\r\n`;
	
	      var data = "";
	      var itemFun = function itemFun(v) {
	        return function (item) {
	          data += "\"" + item.clientName + "\"," + (item.bizUnitName || "") + ",\"\"," + (item.deploymentType || "") + "," + (item.domain || item.campaignName || "") + "," + (item.uuid || "") + "," + (item.activeStatus || "") + "," + ((0, _moment2.default)(item.createdDatetime).format("M/DD/YY") || "") + "\r\n";
	        };
	      };
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.props.all_search_results.clients.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var v = _step.value;
	
	          var managerName = (0, _isEmpty2.default)(v.accountManagers) ? "" : (0, _map2.default)(v.accountManagers, function (user) {
	            return user.firstName + " " + user.lastName;
	          }).join(",");
	
	          if (v.children) {
	            data += "\"" + v.clientName + "\",\"\"," + managerName + ",,,,,,\r\n";
	            v.children.forEach(itemFun(v));
	          } else {
	            data += "\"" + v.clientName + "\"," + (v.bizUnitName || "") + "," + managerName + "," + (v.deploymentType || "") + "," + (v.domain || v.campaignName || "") + "," + (v.uuid || "") + "," + (v.activeStatus || "") + "," + ((0, _moment2.default)(v.createdDatetime).format("M/DD/YY") || "") + "\r\n";
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var csv_string = title +
	      //total +
	      active + inactive + ",,,,,\r\n" + "Client Name,Business Unit Name,Account Manager,Tag Type,Domain/Campaign Name,Tag ID,Active/Inactive,Tag Creation Date\r\n" + data;
	      (0, _utility.downLoadCSVFunc)(csv_string.trim(), "AA_Tags_" + (0, _moment2.default)().format("YYYYMMDD"));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "subscription-info dashboard-tag-info" },
	          _react2.default.createElement(
	            "div",
	            { className: "title-wrapper" },
	            _react2.default.createElement(_Title2.default, { crumb: "Tags", handleDownload: function handleDownload() {
	                return _this6.handleDownload();
	              } })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "tag-info-container" },
	            _react2.default.createElement(
	              "div",
	              { className: "common-wrapper" },
	              _react2.default.createElement(
	                "h2",
	                null,
	                "TOTAL NUMBER OF TAGS"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "list" },
	                _react2.default.createElement(_SubscriptionList2.default, { data: this.props.tags_total })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "common-wrapper mt-20" },
	              _react2.default.createElement(
	                "h2",
	                { className: "border-title" },
	                "TAGS"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "search-bar" },
	                this.props.clients && this.props.clients.length > 0 && _react2.default.createElement(_SearchBar2.default, {
	                  clients: this.props.clients,
	                  handleSearch: function handleSearch(selectedItem) {
	                    return _this6.handleSearch(selectedItem);
	                  }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "tag-info-table-wrapper" },
	                  _react2.default.createElement(_tagInfoTable2.default, {
	                    handleSortByClientName: function handleSortByClientName() {
	                      return _this6.handleSortByClientName();
	                    },
	                    tableHeaderArr: [{ label: "Client Name", value: 0 }, { label: "Business Unit Name", value: 1 },
	                    // {label: 'Account Manager', value: 2},
	                    { label: "Tag Type", value: 3 }, { label: "Domain/Campaign Name", value: 4 }, { label: "Tag ID", value: 5 }, { label: "Active/Inactive", value: 6 }],
	                    bodyDataArr: this.props.search_results.clients ? this.props.search_results.clients.data : [],
	                    renderCols: {
	                      addCol: "campaignName",
	                      cols: ["clientName", "bizUnitName", "deploymentType", "domain", "uuid", "activeStatus"]
	                    }
	                  }),
	                  _react2.default.createElement(_Page2.default, {
	                    nextBeClick: function nextBeClick(page) {
	                      return _this6.nextBeClick(page);
	                    },
	                    pageNumber: this.props.search_results.clients && this.props.search_results.clients.pageNumber,
	                    pageCount: this.props.search_results.clients && this.props.search_results.clients.pageCount,
	                    pageSize: this.props.search_results.clients && this.props.search_results.clients.pageSize,
	                    nextGroupBeClick: function nextGroupBeClick(page) {
	                      return _this6.nextGroupBeClick(page);
	                    },
	                    previousGroupBeClick: function previousGroupBeClick(page) {
	                      return _this6.previousGroupBeClick(page);
	                    },
	                    previousBeClick: function previousBeClick(page) {
	                      return _this6.previousBeClick(page);
	                    },
	                    pageBeClick: function pageBeClick(page) {
	                      return _this6.pageBeClick(page);
	                    },
	                    total: this.props.search_results.clients && this.props.search_results.clients.total,
	                    hasNext: this.props.search_results.clients && this.props.search_results.clients.hasNext,
	                    hasPrevious: this.props.search_results.clients && this.props.search_results.clients.hasPrevious,
	                    pagePlus: true,
	                    selectRows: function selectRows(page, row) {
	                      return _this6.selectRows(page, row);
	                    },
	                    goToPage: function goToPage(page) {
	                      return _this6.goToPage(page);
	                    }
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TagInfo;
	}(_react.Component);
	
	exports.default = TagInfo;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _playArrow = __webpack_require__(156);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var arrowStyles = {
	  position: 'absolute',
	  right: 0,
	  top: 0
	};
	
	var TagInfoTable = function (_Component) {
	  _inherits(TagInfoTable, _Component);
	
	  function TagInfoTable(props) {
	    _classCallCheck(this, TagInfoTable);
	
	    var _this = _possibleConstructorReturn(this, (TagInfoTable.__proto__ || Object.getPrototypeOf(TagInfoTable)).call(this, props));
	
	    _this.state = {
	      activeIndex: 0,
	      arrowActive: 'down'
	    };
	    return _this;
	  }
	
	  _createClass(TagInfoTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'handleClick',
	    value: function handleClick(label, index) {
	      this.setState({
	        activeIndex: index
	      });
	      if (+index === this.state.activeIndex) {
	        if (this.state.arrowActive === 'down') {
	          this.setState({
	            arrowActive: 'up'
	          });
	        } else {
	          this.setState({
	            arrowActive: 'down'
	          });
	        }
	      } else {
	        this.setState({
	          arrowActive: 'down'
	        });
	      }
	      if (index === 0) {
	        this.props.handleSortByClientName();
	      }
	    }
	  }, {
	    key: 'spreadTr',
	    value: function spreadTr(index) {
	      if (this.state['spread' + index]) {
	        this.setState(_defineProperty({}, 'spread' + index, false));
	      } else {
	        this.setState(_defineProperty({}, 'spread' + index, true));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'tag-info-table' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              this.props.tableHeaderArr.map(function (item, index) {
	                var widthStyle = '';
	                switch (index) {
	                  case 0:
	                    widthStyle = '22%';
	                    break;
	                  case 1:
	                    widthStyle = '15%';
	                    break;
	                  case 2:
	                    widthStyle = '15%';
	                    break;
	                  case 3:
	                    widthStyle = '18%';
	                    break;
	                  case 4:
	                    widthStyle = '9%';
	                    break;
	                  case 5:
	                    widthStyle = '9%';
	                    break;
	                  default:
	                    widthStyle = '';
	                    break;
	                }
	                return _react2.default.createElement(
	                  'th',
	                  { key: item.value,
	                    className: _this2.state.activeIndex === index && index === 0 ? 'active' : '',
	                    onClick: function onClick() {
	                      if (item.label === 'Client Name') _this2.handleClick(item.label, index);
	                    },
	                    style: { width: widthStyle }
	                  },
	                  item.label,
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'down' && index === 0 && _react2.default.createElement(_arrowDropDown2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  }),
	                  _this2.state.activeIndex === index && _this2.state.arrowActive === 'up' && index === 0 && _react2.default.createElement(_arrowDropUp2.default, {
	                    style: Object.assign({}, arrowStyles)
	                  })
	                );
	              })
	            ),
	            this.props.bodyDataArr.map(function (item, index) {
	              if (!item.children) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: index },
	                  [_react2.default.createElement(
	                    'td',
	                    { key: index + '0' },
	                    item.clientName
	                  ), _react2.default.createElement(
	                    'td',
	                    { key: index + '1' },
	                    item.bizUnitName
	                  ), _react2.default.createElement(
	                    'td',
	                    { key: index + '2' },
	                    item.deploymentType
	                  ), _react2.default.createElement(
	                    'td',
	                    { key: index + '3' },
	                    item.domain
	                  ), _react2.default.createElement(
	                    'td',
	                    { key: index + '4' },
	                    item.uuid
	                  ), _react2.default.createElement(
	                    'td',
	                    { key: index + '5' },
	                    item.activeStatus
	                  )]
	                );
	              } else {
	                var obj = [];
	                if (item.children.length > 1) {
	                  obj.push(_react2.default.createElement(
	                    'tr',
	                    { key: index, onClick: function onClick() {
	                        return _this2.spreadTr(index);
	                      } },
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: _this2.props.tableHeaderArr.length, style: { paddingLeft: '20px', cursor: 'pointer' } },
	                      _this2.state['spread' + index] ? _react2.default.createElement(_arrowDropDown2.default, {
	                        style: { position: 'absolute', left: '-7px', top: '2px' }
	                      }) : _react2.default.createElement(_playArrow2.default, {
	                        style: { position: 'absolute', left: '-5px', top: '6px', width: '16px', height: '16px' }
	                      }),
	                      item.clientName
	                    )
	                  ));
	                }
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                  for (var _iterator = item.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var v = _step.value;
	
	                    obj.push(_react2.default.createElement(
	                      'tr',
	                      { style: { display: _this2.state['spread' + index] || item.children.length === 1 ? 'table-row' : 'none' } },
	                      _react2.default.createElement(
	                        'td',
	                        { style: item.children.length > 1 ? { paddingLeft: '49px' } : {} },
	                        v.clientName
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.bizUnitName
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.deploymentType
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.domain || v.campaignName
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'uuid' },
	                        v.uuid.substring(0, 6) + '...',
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          v.uuid
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        v.activeStatus
	                      )
	                    ));
	                  }
	                } catch (err) {
	                  _didIteratorError = true;
	                  _iteratorError = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                      _iterator.return();
	                    }
	                  } finally {
	                    if (_didIteratorError) {
	                      throw _iteratorError;
	                    }
	                  }
	                }
	
	                return obj;
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TagInfoTable;
	}(_react.Component);
	
	exports.default = TagInfoTable;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputField = __webpack_require__(77);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property titleStyle {obj} title style
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property tipText {text} tip text
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property newPasswordOnChange {function} params: 1.event object, 2, value. callback of new password field value change
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property confirmPasswordOnChange {function} params: 1.event object, 2, value. callback of confirm password field value change
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var CreateYourPassword = function (_Component) {
	  _inherits(CreateYourPassword, _Component);
	
	  function CreateYourPassword() {
	    _classCallCheck(this, CreateYourPassword);
	
	    return _possibleConstructorReturn(this, (CreateYourPassword.__proto__ || Object.getPrototypeOf(CreateYourPassword)).apply(this, arguments));
	  }
	
	  _createClass(CreateYourPassword, [{
	    key: 'handleNewPassword',
	    value: function handleNewPassword(e, value) {
	      this.props.newPasswordOnChange(e, value);
	    }
	  }, {
	    key: 'handleConfirmPassword',
	    value: function handleConfirmPassword(e, value) {
	      this.props.confirmPasswordOnChange(e, value);
	    }
	  }, {
	    key: '_pwdInputKeyDown',
	    value: function _pwdInputKeyDown(e) {
	      if (e.keyCode === 32) e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var initTitStyle = {
	        fontSize: '18px',
	        fontWeight: 'bolder'
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'profile-change-pw' },
	        _react2.default.createElement(
	          'h1',
	          { style: Object.assign({}, initTitStyle, this.props.titleStyle) },
	          'CHANGE YOUR PASSWORD'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'tip' },
	          'Enter a combination of at least 6 numbers, letters, and special characters'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'profile-username' },
	          _react2.default.createElement(
	            'div',
	            { className: 'profile-fn-wrapper' },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: 'New Password',
	              ifRequireField: true,
	              inputType: 'password',
	              labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	              inputContainerId: 'change-password',
	              borderColor: 'black',
	              onKeyDown: this._pwdInputKeyDown,
	              onChange: function onChange(e, value) {
	                return _this2.handleNewPassword(e, value);
	              },
	              style: { height: '32px', lineHeight: '32px', marginBottom: '49px' }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'profile-fn-wrapper' },
	            _react2.default.createElement(_InputField2.default, {
	              labelTitle: 'Confirm Password',
	              ifRequireField: true,
	              inputType: 'password',
	              labelStyle: { float: 'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0 },
	              inputContainerId: 'change-password',
	              borderColor: 'black',
	              onKeyDown: this._pwdInputKeyDown,
	              onChange: function onChange(e, value) {
	                return _this2.handleConfirmPassword(e, value);
	              },
	              style: { height: '32px', lineHeight: '32px', marginBottom: '40px' }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateYourPassword;
	}(_react.Component);
	
	exports.default = CreateYourPassword;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Expire = function (_Component) {
		_inherits(Expire, _Component);
	
		function Expire() {
			_classCallCheck(this, Expire);
	
			return _possibleConstructorReturn(this, (Expire.__proto__ || Object.getPrototypeOf(Expire)).apply(this, arguments));
		}
	
		_createClass(Expire, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.state = {
					visible: true
				};
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				// reset the timer if children are changed
				if (nextProps.children !== this.props.children) {
					this.setTimer();
					this.setState({ visible: true });
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setTimer();
			}
		}, {
			key: 'setTimer',
			value: function setTimer() {
				// clear any existing timer
				if (this._timer != null) clearTimeout(this._timer);
	
				// hide after `delay` milliseconds
				this._timer = setTimeout(function () {
					this.setState({ visible: false });
					this._timer = null;
				}.bind(this), this.props.delay);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    children = _props.children,
				    hasContainer = _props.hasContainer;
	
				return this.state.visible ? hasContainer === true ? _react2.default.createElement(
					'span',
					null,
					children
				) : _react2.default.createElement(children[1].type, children[1].props) : _react2.default.createElement('span', null);
			}
		}]);
	
		return Expire;
	}(_react.Component);
	
	Expire.defaultProps = {
		delay: 100
	};
	exports.default = Expire;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utility = __webpack_require__(14);
	
	var _reactDropzone = __webpack_require__(242);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property title {string} component title name
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property subTitle {string} sub title
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property getUploadJson {function} the callback of upload function, which will pass promise object by param.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property url {string} upload url
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property fieldName {string} field name for img
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property buttonLable {string} button label
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ImgUpload = function (_Component) {
	  _inherits(ImgUpload, _Component);
	
	  function ImgUpload(props) {
	    _classCallCheck(this, ImgUpload);
	
	    var _this = _possibleConstructorReturn(this, (ImgUpload.__proto__ || Object.getPrototypeOf(ImgUpload)).call(this, props));
	
	    _this.state = {
	      companyLogoErrorText: '',
	      fileName: '',
	      ifButtonEnable: false,
	      newLogoBase64: ''
	    };
	    return _this;
	  }
	
	  _createClass(ImgUpload, [{
	    key: 'handleDrop',
	    value: function handleDrop(files, accept, reject) {
	      this.setState({
	        fileName: files[0],
	        ifButtonEnable: true,
	        companyLogoErrorText: ''
	      });
	    }
	  }, {
	    key: 'onDropRejected',
	    value: function onDropRejected() {
	      this.setState({
	        companyLogoErrorText: 'Only jpg, png, and gif file with maximum size of 1MB is allowed'
	      });
	    }
	  }, {
	    key: 'successCb',
	    value: function successCb(uploadFileName) {
	      this.props.successCb(uploadFileName);
	    }
	  }, {
	    key: 'handleUpload',
	    value: function handleUpload() {
	      var _this2 = this;
	
	      if (this.state.ifButtonEnable) {
	        var formData = new FormData();
	        formData.append(this.props.fieldName, this.state.fileName);
	        // call api
	        fetch(this.props.url, {
	          method: 'POST',
	          body: formData
	        }).then(function (res) {
	          if (res.status === 200) {
	            _this2.props.fieldName === 'avatar' ? _this2.props.getUploadJson(_this2.state.fileName) : _this2.props.getUploadJson(res.json());
	            _this2.setState({
	              companyLogoErrorText: '',
	              newLogoBase64: _this2.state.fileName.preview
	            });
	          } else {
	            res.json().then(function (json) {
	              _this2.setState({
	                companyLogoErrorText: json.message
	              });
	            });
	          }
	        }, function () {})
	        // .then((json) => {
	        //   if(typeof json !== 'undefined') {
	        //     this.props.getUploadJson(json);
	        //     this.setState({
	        //       companyLogoErrorText: '',
	        //       newLogoBase64: this.state.fileName.preview
	        //     })
	        //   }
	        // })
	        .catch(function (err) {
	          alert(err);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'profile-logo profile-logo-wrapper profile-company-logo clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title clearfix' },
	            _react2.default.createElement(
	              'span',
	              { id: 'profile-subtit' },
	              this.props.title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'review' },
	            _react2.default.createElement(
	              'div',
	              { className: 'profile-edit-img' },
	              _react2.default.createElement(
	                'section',
	                { className: 'section' },
	                this.props.subTitle
	              ),
	              _react2.default.createElement(
	                _reactDropzone2.default,
	                {
	                  onDrop: function onDrop(files, accept, reject) {
	                    return _this3.handleDrop(files, accept, reject);
	                  },
	                  style: { width: '100%' },
	                  accept: 'image/jpeg, image/png, image/jpg, image/gif',
	                  maxSize: 1048576,
	                  onDropRejected: function onDropRejected() {
	                    return _this3.onDropRejected();
	                  },
	                  name: 'logo'
	                },
	                _react2.default.createElement(
	                  'p',
	                  { style: { textAlign: 'center', display: 'inline-block', width: '20%', height: '20px', fontSize: '12px', border: '1px solid grey', color: 'black', borderRadius: '6px', lineHeight: '20px', marginTop: '10px' } },
	                  'Choose File'
	                ),
	                _react2.default.createElement(
	                  'i',
	                  { style: { fontStyle: 'normal', marginLeft: '6px' } },
	                  this.state.fileName !== undefined && this.state.fileName.name || 'No file chosen'
	                ),
	                _react2.default.createElement(
	                  'section',
	                  { className: 'spec' },
	                  '(Only jpg, png, and gif file with maximum size of 1MB is allowed)'
	                )
	              ),
	              _react2.default.createElement('img', { src: this.state.newLogoBase64, alt: '' }),
	              _react2.default.createElement(
	                'button',
	                { style: { background: (0, _utility.buttonBlueColor)() }, onClick: function onClick() {
	                    return _this3.handleUpload();
	                  } },
	                this.props.buttonLable
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'error', style: { bottom: '12px' } },
	          this.state.companyLogoErrorText
	        )
	      );
	    }
	  }]);
	
	  return ImgUpload;
	}(_react.Component);
	
	ImgUpload.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  subTitle: _propTypes2.default.string.isRequired
	};
	
	exports.default = ImgUpload;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.whiteButton = exports.disabledLinkStyles = exports.linkStyles = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _merge = __webpack_require__(671);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _materialUi = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkStyles = exports.linkStyles = {
	  top: 0,
	  bottom: 0,
	  left: 0,
	  right: 0,
	  position: 'absolute',
	  width: '100%',
	  height: '100%'
	};
	
	var disabledLinkStyles = exports.disabledLinkStyles = {
	  pointerEvents: 'none',
	  cursor: 'default'
	};
	
	var whiteButton = exports.whiteButton = {
	  color: '#ffffff',
	  fontWeight: 100,
	  letterSpacing: '1'
	};
	
	var LinkButton = function (_Component) {
	  _inherits(LinkButton, _Component);
	
	  function LinkButton() {
	    _classCallCheck(this, LinkButton);
	
	    return _possibleConstructorReturn(this, (LinkButton.__proto__ || Object.getPrototypeOf(LinkButton)).apply(this, arguments));
	  }
	
	  _createClass(LinkButton, [{
	    key: 'getLinkStyles',
	    value: function getLinkStyles(buttonDisabled) {
	      return buttonDisabled ? disabledLinkStyles : linkStyles;
	    }
	  }, {
	    key: 'chooseButton',
	    value: function chooseButton() {
	      if (this.props.buttonType === 'flat') return _materialUi.FlatButton;
	
	      return _materialUi.RaisedButton;
	    }
	  }, {
	    key: 'chooseLink',
	    value: function chooseLink() {
	      if (this.props.linkType === 'index') return _reactRouterDom.IndexLink;
	
	      return _reactRouterDom.Link;
	    }
	  }, {
	    key: 'handleButtonClick',
	    value: function handleButtonClick() {
	      if (!this.disabled) {
	        var link = (0, _reactDom.findDOMNode)(this.link);
	        link.click();
	      }
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      if (this.props.style) {
	        return this.props.lowercase ? (0, _merge2.default)(this.props.style, { textTransform: 'none' }) : this.props.style;
	      }
	      return this.props.lowercase ? (0, _merge2.default)({}, { textTransform: 'none' }) : {};
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var Button = this.chooseButton();
	      var Link = this.chooseLink();
	
	      var style = this.getStyle();
	      return _react2.default.createElement(
	        Button,
	        Object.assign({ className: 'no-margin' }, this.props, { onClick: this.handleButtonClick.bind(this), style: style,
	          disabledBackgroundColor: 'gray', disabledLabelColor: 'lightGray' }),
	        _react2.default.createElement(Link, { style: this.getLinkStyles(this.props.disabled), to: this.props.to, ref: function ref(el) {
	            return _this2.link = el;
	          } })
	      );
	    }
	  }]);
	
	  return LinkButton;
	}(_react.Component);
	
	LinkButton.propTypes = {
	  buttonType: _react2.default.PropTypes.string,
	  linkType: _react2.default.PropTypes.string,
	  to: _react2.default.PropTypes.string.isRequired,
	  disabled: _react2.default.PropTypes.bool.isRequired,
	  lowercase: _react2.default.PropTypes.bool,
	  style: _react2.default.PropTypes.object
	};
	
	LinkButton.defaultProps = {
	  onClick: function onClick() {},
	  disabled: false
	};
	
	exports.default = LinkButton;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isNil = __webpack_require__(56);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _isObject = __webpack_require__(53);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocalStorage = function (_Component) {
	  _inherits(LocalStorage, _Component);
	
	  function LocalStorage(props) {
	    _classCallCheck(this, LocalStorage);
	
	    var _this = _possibleConstructorReturn(this, (LocalStorage.__proto__ || Object.getPrototypeOf(LocalStorage)).call(this, props));
	
	    _this.webStorage = window.localStorage;
	    return _this;
	  }
	
	  _createClass(LocalStorage, [{
	    key: 'render',
	    value: function render() {
	      if (!(0, _isNil2.default)(this.props.store)) {
	        this.save(this.props.store);
	      }
	
	      if (this.props.onRetrieve) {
	        this.props.onRetrieve(this.retrieve(this.props.retrieve));
	      }
	
	      return _react2.default.createElement('div', { id: 'aaLocalStorage' });
	    }
	  }, {
	    key: 'save',
	    value: function save(object) {
	      var now = new Date();
	
	      if ((0, _isNil2.default)(object.key && object.val)) return;
	
	      if ((0, _isObject2.default)(object.val)) {
	        object.val = JSON.stringify(object.val);
	      }
	
	      this.webStorage.setItem(object.key, object.val);
	      this.webStorage.setItem(object.key + '_timestamp', now);
	    }
	  }, {
	    key: 'retrieve',
	    value: function retrieve(key) {
	      return this.webStorage.getItem(key);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(key) {
	      this.webStorage.removeItem(key);
	      this.webStorage.removeItem(key + '_timestamp');
	    }
	  }, {
	    key: 'clearAll',
	    value: function clearAll() {
	      this.webStorage.clear();
	    }
	  }]);
	
	  return LocalStorage;
	}(_react.Component);
	
	exports.default = LocalStorage;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _localSegmentSelecttion = __webpack_require__(536);
	
	var _localSegmentSelecttion2 = _interopRequireDefault(_localSegmentSelecttion);
	
	__webpack_require__(1449);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Container, Col, Row } from '../Grid';
	//import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
	//import placeholder from '../../../assets/images/placeholder.jpg'
	
	
	var MainNav = function (_Component) {
	  _inherits(MainNav, _Component);
	
	  function MainNav(props) {
	    _classCallCheck(this, MainNav);
	
	    var _this = _possibleConstructorReturn(this, (MainNav.__proto__ || Object.getPrototypeOf(MainNav)).call(this, props));
	
	    _this.state = {
	      optionsArr: [{ id: "r-" + props.roleId, name: props.roleName }],
	      optionVal: props.selected_client,
	      ifShowSelection: false,
	      clientAdminMode: props.roleId > 1 && props.roleId < 10,
	      businessUserMode: props.roleId > 50,
	      SystemAdminMode: isNaN(props.selected_client),
	      businessAdminMode: props.roleId === 51,
	      disabledAllClientsOption: true,
	      sltWidth: "50px",
	      iframeSrc: undefined
	    };
	    return _this;
	  }
	
	  _createClass(MainNav, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.userId !== this.props.userId) {
	        if (!/\/create-internal-account/g.test(this.props.location.path)) {
	          this.props.getUserDetail(nextProps.userId);
	          if (this.props.loginUserDetail && this.props.loginUserDetail.baroUid) this.props.getOptimizeUserDetail();
	
	          //this.props.getUserClients(nextProps.userId)
	          this.props.getCurrentUserClients();
	        }
	      }
	      if (nextProps.loginUserDetail !== this.props.loginUserDetail) {
	        this.props.getUserAvatar(nextProps.loginUserDetail ? nextProps.loginUserDetail.avatar : this.props.loginUserDetail.avatar);
	        if (nextProps.loginUserDetail && nextProps.loginUserDetail.baroUid && !this.props.optimizeUserDetail) {
	          this.props.getOptimizeUserDetail();
	        }
	      }
	      if (typeof nextProps.selected_client === "number" && nextProps.selected_client !== this.props.selected_client) {
	        this.props.getClientInfo(nextProps.selected_client);
	        this.setState({
	          optionVal: nextProps.selected_client
	        });
	      }
	
	      if (nextProps.selected_client !== this.props.selected_client) {
	        this.props.getDisabledFeatures();
	
	        this.setState({
	          clientAdminMode: nextProps.roleId > 1 && nextProps.roleId < 10,
	          businessUserMode: nextProps.roleId > 50,
	          businessAdminMode: nextProps.roleId === 51,
	          SystemAdminMode: isNaN(nextProps.selected_client),
	          optionVal: nextProps.selected_client
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.setState({
	        iframeSrc: undefined
	      });
	    }
	  }, {
	    key: "handleLogOut",
	    value: function handleLogOut() {
	      var optimizeHost = window.location.hostname.indexOf("audienceanywhere.com") >= 0 ? "https://optimize-" + window.location.hostname : "https://optimize-qa.audienceanywhere.com";
	      optimizeHost = optimizeHost.replace("optimize-app", "optimize");
	
	      this.setState({
	        iframeSrc: optimizeHost + "?action=logout"
	      });
	      _localSegmentSelecttion2.default.clearLocalData();
	      var handleLogout = this.props.handleLogout;
	
	      setTimeout(function () {
	        handleLogout();
	      }, 2000);
	      /*
	      setTimeout(function () {
	        const optimizeHost =
	          window.location.hostname.indexOf("audienceanywhere.com") >= 0
	            ? "https://optimize-" + window.location.hostname
	            : "https://optimize-qa.audienceanywhere.com";
	         window.location = `${optimizeHost}?action=logout`;
	      }, 100);*/
	    }
	  }, {
	    key: "gotoOptimizeSite",
	    value: function gotoOptimizeSite(subpage) {
	      var optimizeHost = window.location.hostname.indexOf("audienceanywhere.com") >= 0 ? "https://optimize-" + window.location.hostname : "https://optimize-qa.audienceanywhere.com";
	      optimizeHost = optimizeHost.replace("optimize-app", "optimize");
	      var token = localStorage.getItem("aa_access_token");
	      if (subpage) optimizeHost += "/" + subpage;
	      window.location.href = token ? subpage ? optimizeHost + "?token=" + token.replace("Bearer ", "") : optimizeHost + "?token=" + token.replace("Bearer ", "") + "&path=" + subpage : subpage ? optimizeHost + "?path=" + subpage : subpage;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var path = this.props.location.path ? this.props.location.path : "";
	      var _props = this.props,
	          roleId = _props.roleId,
	          client_info = _props.client_info,
	          loginUserDetail = _props.loginUserDetail,
	          selected_client = _props.selected_client,
	          optimizeUserDetail = _props.optimizeUserDetail;
	
	      var hideAudienceTab = roleId > 3 && client_info && client_info.subscription.id > 4;
	      var hideAAMenu = loginUserDetail && loginUserDetail.baroUid && optimizeUserDetail && optimizeUserDetail.aaUser && optimizeUserDetail.aaUser.subscriptionTierId && parseInt(optimizeUserDetail.aaUser.subscriptionTierId, 10) === 5;
	      if (this.props.display && this.props.display === "none") return "";
	      var showContainer = loginUserDetail && !loginUserDetail.baroUid || this.props.optimizeUserDetail && this.props.optimizeUserDetail.aaUser && parseInt(this.props.optimizeUserDetail.aaUser.subscriptionTierId, 10) !== 5 || loginUserDetail && loginUserDetail.baroUid && !this.props.optimizeUserDetail && this.props.client_info && parseInt(this.props.client_info.subscriptionTierId, 10) !== 5 || loginUserDetail && loginUserDetail.baroUid && !this.props.optimizeUserDetail && !this.props.client_info && this.props.selected_client && this.props.selected_client && isNaN(this.props.selected_client) && this.props.selected_client.indexOf("r-") >= 0 || this.props.loginUserDetail && this.props.loginUserDetail.baroUid && this.props.optimizeUserDetail && parseInt(this.props.optimizeUserDetail.aaUser.subscriptionTierId, 10) === 5 && (!this.props.disabledFeatures || (0, _lodash.isEmpty)(this.props.disabledFeatures));
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "navbar no-border-radius",
	          style: {
	            padding: "0 10%",
	            height: "60px",
	            display: showContainer ? "block" : "none"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "navbar-header mt-10" },
	          this.state.iframeSrc && _react2.default.createElement("iframe", { src: this.state.iframeSrc, width: "1", height: "1" }),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/", className: "navbar-brand " },
	            _react2.default.createElement("img", {
	              alt: "",
	              src: "/images/logo.png",
	              style: {
	                display: "inline-table",
	                marginTop: "-12px",
	                marginRight: "10px",
	                height: "35px"
	              }
	            })
	          ),
	          _react2.default.createElement(
	            "ul",
	            { className: "nav navbar-nav pull-right visible-xs-block" },
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                { "data-toggle": "collapse", "data-target": "#navbar-mobile" },
	                _react2.default.createElement("i", { className: "icon-tree5" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "navbar-collapse collapse mt-10" },
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "nav navbar-nav navbar-right aa-navbar ml-5",
	              style: {
	                display: /(\/create-internal-account|\/create-client-account|\/create-business-unit-member-account)/g.test(this.props.location.path) ? "none" : "block"
	              }
	            },
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                { className: "dropdown-toggle", "data-toggle": "dropdown" },
	                _react2.default.createElement("img", { src: "/images/profile.png", alt: "" })
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-menu-right aa-dropdown-menu" },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: "short", to: "/myProfile" },
	                    " ",
	                    "My Profile"
	                  )
	                ),
	                _react2.default.createElement("li", { className: "divider nav-divider" }),
	                !hideAAMenu && _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      className: "short",
	                      to: "/settings/tags/list?cid=" + selected_client
	                    },
	                    "Settings"
	                  )
	                ),
	                _react2.default.createElement("li", { className: "divider nav-divider" }),
	                _react2.default.createElement("li", { className: "divider nav-divider" }),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "short",
	                      href: "#",
	                      onClick: function onClick(e) {
	                        e.preventDefault();
	                        _this2.handleLogOut();
	                      }
	                    },
	                    "Sign Out"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "nav navbar-nav navbar-right navbar-nav-material mr-5",
	              style: { marginTop: "0px" }
	            },
	            !hideAAMenu && [_react2.default.createElement(
	              "li",
	              { key: "nav-dashboard",
	                className: path.startsWith("/dashboard") ? "active home-nav-li" : "home-nav-li"
	              },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "/dashboard?cid=" + this.props.selected_client },
	                "Dashboard"
	              )
	            ), _react2.default.createElement(
	              "li",
	              { key: "nav-team",
	                className: path.startsWith("/employees") ? "active home-nav-li" : "home-nav-li",
	                style: {
	                  display: this.state.SystemAdminMode && (this.state.businessAdminMode || this.props.roleId === 1) && !this.state.clientAdminMode ? "block" : "none"
	                }
	              },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "/employees" },
	                "Team"
	              )
	            ), _react2.default.createElement(
	              "li",
	              { key: "nav-clients",
	                className: path.startsWith("/clients") ? "active home-nav-li" : "home-nav-li",
	                style: {
	                  display: this.state.SystemAdminMode && this.props.roleId !== 53 && this.props.roleId !== 5 ? "block" : "none"
	                }
	              },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "/clients" },
	                this.state.businessUserMode ? "Business Units" : "Clients"
	              )
	            ), _react2.default.createElement(
	              "li",
	              { key: "nav-audience",
	                className: path.startsWith("/segments") ? "active home-nav-li" : "home-nav-li",
	                style: {
	                  display: !this.state.SystemAdminMode && !hideAudienceTab ? "block" : "none"
	                }
	              },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "/segments/list/active" },
	                "Audience "
	              )
	            ), _react2.default.createElement(
	              "li",
	              { key: "nav-insights",
	                className: path.startsWith("/insights") ? "active home-nav-li" : "home-nav-li",
	                style: {
	                  display: !this.state.SystemAdminMode && this.props.roleId !== 5 ? "block" : "none"
	                }
	              },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "#",
	                  className: "dropdown-toggle legitRipple",
	                  "data-toggle": "dropdown"
	                },
	                "Insights",
	                _react2.default.createElement("span", { className: "caret" })
	              ),
	              _react2.default.createElement(
	                "ul",
	                {
	                  className: "dropdown-menu dropdown-menu-left border-grey aa-dropdown-menu",
	                  style: { marginTop: "5px", borderColor: "#EAEBE8" }
	                },
	                client_info && client_info.subscriptionTierId === 4 && _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      className: "short",
	                      to: "/segment-distribution?cid=" + this.state.optionVal
	                    },
	                    "Segment Distribution"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      className: "short",
	                      to: "/insights/summary?cid=" + this.props.selected_client
	                    },
	                    "Site Analytics"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      className: "short",
	                      to: "/insights/audience?cid=" + this.state.optionVal
	                    },
	                    "Audience Files"
	                  )
	                )
	              )
	            )],
	            _react2.default.createElement(
	              "li",
	              { key: "nav-optimize",
	                className: "home-nav-li",
	                style: {
	                  display:
	                  //this.props.optimizeUserDetail &&
	                  this.props.disabledFeatures && this.props.loginUserDetail && this.props.loginUserDetail.baroUid ? "block" : "none"
	                }
	              },
	              _react2.default.createElement(
	                "a",
	                {
	                  onClick: function onClick() {
	                    _this2.gotoOptimizeSite();
	                  }
	                },
	                "Optimize"
	              )
	            ),
	            !hideAAMenu && _react2.default.createElement(
	              "li",
	              { key: "nav-campaigns",
	                className: path.startsWith("/campaigns") ? "active home-nav-li" : "home-nav-li",
	                style: {
	                  display: !this.state.SystemAdminMode ? "block" : "none"
	                }
	              },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "/campaigns?cid=" + this.props.selected_client },
	                "Campaigns"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MainNav;
	}(_react.Component);
	
	exports.default = MainNav;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _colors = __webpack_require__(306);
	
	var _colorManipulator = __webpack_require__(97);
	
	var _spacing = __webpack_require__(713);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _zIndex = __webpack_require__(714);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		spacing: _spacing2.default,
		zIndex: _zIndex2.default,
		fontFamily: 'Noto, sans-serif',
		palette: {
			/*
	  primary1Color: '#26A69A',
	  primary2Color: '#26A69A',
	  primary3Color: '#26A69A',*/
			primary1Color: '#47A1AB',
			primary2Color: '#47A1AB',
			primary3Color: '#47A1AB',
			accent1Color: '#043471',
			accent2Color: '#043471',
			accent3Color: _colors.grey500,
			textColor: _colors.darkBlack,
			alternateTextColor: _colors.darkBlack,
			canvasColor: _colors.white,
			borderColor: _colors.grey300,
			disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
			pickerHeaderColor: '#154C95'
		}
	};

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MuiThemeProvider = __webpack_require__(48);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _reactSelect = __webpack_require__(36);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(18);
	
	__webpack_require__(599);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeNav = function (_Component) {
	  _inherits(HomeNav, _Component);
	
	  function HomeNav(props) {
	    _classCallCheck(this, HomeNav);
	
	    var _this = _possibleConstructorReturn(this, (HomeNav.__proto__ || Object.getPrototypeOf(HomeNav)).call(this, props));
	
	    _this.state = {
	      optionsArr: [{ id: "r-" + props.roleId, name: props.roleName }],
	      optionVal: props.selected_client,
	      ifShowSelection: false,
	      SystemAdminMode: false,
	      clientAdminMode: false,
	      businessUserMode: false,
	      businessAdminMode: false,
	      disabledAllClientsOption: true,
	      sltWidth: "50px"
	    };
	    return _this;
	  }
	
	  _createClass(HomeNav, [{
	    key: "initializeClientList",
	    value: function initializeClientList(disabledAllClientsOption, clients) {
	      /*
	      let clientsList = disabledAllClientsOption === true || this.props.roleId > 50 ? [
	          {id: 'r-' + this.props.roleId, name: this.props.roleName}
	        ] :
	        [
	          {id: 'r-' + this.props.roleId, name: this.props.roleName},
	          {name:'All Clients', id:0}
	        ]*/
	      //disabled all clients
	      disabledAllClientsOption = true;
	      var clientsList = [{ id: "r-" + this.props.roleId, name: this.props.roleName }];
	      if (clients) {
	        var sortedClients = (0, _lodash.sortBy)(clients, function (c) {
	          return c.name.toLowerCase();
	        });
	
	        if (clients.length === 1 && clients[0].id <= 1) {
	          clientsList = (0, _lodash.remove)(clientsList, function (c) {
	            return c.id !== 0;
	          });
	        }
	        sortedClients.forEach(function (item) {
	          if (item.id > 1) {
	            /*
	            if (isClientUser){
	              if (!isEmpty(item.businessUnits)){
	                const sortedSubClients = sortBy(item.businessUnits, function(c){
	                  return c.name.toLowerCase()
	                })
	                sortedSubClients.forEach(function(sc){
	                  clientsList.push({id: sc.id, name: sc.name})
	                })
	              }
	            }else{*/
	            clientsList.push({ id: item.id, name: item.name });
	            if (!(0, _lodash.isEmpty)(item.businessUnits)) {
	              var sortedSubClients = (0, _lodash.sortBy)(item.businessUnits, function (c) {
	                return c.name.toLowerCase();
	              });
	              sortedSubClients.forEach(function (sc) {
	                clientsList.push({ id: sc.id, name: "      " + sc.name });
	              });
	            }
	            //}
	          }
	        });
	      }
	
	      this.setState({
	        optionsArr: clientsList,
	        clientAdminMode: this.props.roleId > 1 && this.props.roleId < 10,
	        businessUserMode: this.props.roleId > 50,
	        businessAdminMode: this.props.roleId === 51
	      });
	      if (disabledAllClientsOption === true && parseInt(this.props.selected_client, 10) === 0 && clientsList.length > 1 || this.props.roleId > 50 && parseInt(this.props.selected_client, 10) === 0) {
	        if (clientsList.length > 1) {
	          this.setState({ optionVal: clientsList[1].id });
	          this.props.selectClient(clientsList[1].id);
	        }
	      }
	      if (/^\/clients/.test(this.props.location.path) || /^\/employees/.test(this.props.location.path)) {
	        if (this.props.roleId) {
	          var val = "r-" + this.props.roleId;
	
	          this.setState({ optionVal: val, SystemAdminMode: true });
	          this.props.selectClient(val);
	        }
	      } else {
	        if (parseInt(this.props.selected_client, 10) === 0) {
	          if (clientsList.length > 1) {
	            this.setState({ optionVal: clientsList[1].id });
	            this.props.selectClient(clientsList[1].id);
	          }
	        }
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      //const path = nextProps.location.path
	      if (typeof nextProps.selected_client === "number" && nextProps.selected_client !== this.props.selected_client) {
	        this.props.getClientInfo(nextProps.selected_client);
	        this.setState({
	          optionVal: nextProps.selected_client
	        });
	      }
	      if (this.props.clients !== nextProps.clients) {
	        this.initializeClientList(this.state.disabledAllClientsOption, nextProps.clients);
	      }
	
	      // when router is `/segments/active or /segments/archive` show 'All Clients'
	      /*
	      if (path === '/segments/list/archive' || path === '/segments/list/active') {
	        this.setState({
	          optionsArr: ['System Administrator', 'All Clients', 'Acquire Web']
	      })
	      }*/
	      if (nextProps.roleId !== this.props.roleId) {
	        var val = "r-" + nextProps.roleId;
	        if (/^\/clients/.test(nextProps.location.path) || /^\/employees/.test(nextProps.location.path)) {
	          this.setState({ optionVal: val });
	          this.props.selectClient(val);
	        }
	      }
	      if (nextProps.location.path !== this.props.location.path) {
	        if (/^\/segments/.test(nextProps.location.path)) {
	          if (!/^\/segments/.test(this.props.location.path)) {
	            this.setState({ disabledAllClientsOption: true });
	
	            this.initializeClientList(false, this.props.clients);
	          }
	        } else if (/^\/segment\//.test(nextProps.location.path)) {
	          this.setState({ disabledAllClientsOption: true });
	          this.initializeClientList(true, this.props.clients);
	          if (parseInt(this.props.selected_client, 10) === 0 && this.state.optionsArr && this.state.optionsArr.length > 1) {
	            this.props.selectClient(this.state.optionsArr[1].id);
	          }
	        } else if (/^\/insights/.test(nextProps.location.path)) {
	          this.setState({ disabledAllClientsOption: true });
	          this.initializeClientList(true, this.props.clients);
	        }
	      }
	    }
	  }, {
	    key: "handleOptionsChange",
	    value: function handleOptionsChange(val) {
	      if ((0, _lodash.isEmpty)(val)) return;
	      this.props.selectClient(String(val.value));
	      if (parseInt(val.value, 10) > 0) {
	        this.props.getClientInfo(+val.value);
	      } else {
	        this.props.clearClientInfo();
	      }
	      var location = this.props.location;
	      var path = location.path;
	
	      this.setState({
	        optionVal: val && val.value ? val.value : null,
	        ifShowSelection: false,
	        SystemAdminMode: isNaN(val.value)
	      });
	      if (isNaN(val.value)) {
	        var rid = parseInt(val.value.replace("r-", ""), 10);
	        if (rid > 1 && rid < 10) {
	          // no system admin
	          this.setState({ clientAdminMode: true });
	          if (rid === 3 || rid === 5) this.props.history.push("/dashboard");
	        } else if (rid === 1 || rid === 51) {
	          this.setState({ clientAdminMode: false });
	          this.props.history.push("/dashboard");
	        } else if (rid > 51) {
	          this.setState({ clientAdminMode: false });
	          //this.props.history.push( rid === 53 ? '/dashboard' : '/clients')
	          this.props.history.push("/dashboard");
	        }
	      } else {
	        if (path.indexOf("/employees") >= 0 || path.indexOf("/clients") >= 0) {
	          this.props.history.push("/");
	        }
	        if (path === "/insights") this.props.history.push(path);
	        if (path.indexOf("/dashboard") >= 0) {
	          this.props.history.push("/");
	        }
	      }
	      // when select any other option clear selected segment id
	      this.props.selectedSegment("clear");
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        disabledAllClientsOption: true,
	        businessUserMode: this.props.roleId > 50,
	        businessAdminMode: this.props.roleId === 51
	      });
	
	      // when the path is '/segments' change the state of selected_client to `All Clients`
	      /*
	      if (/^\/segments/.test(this.props.location.path)) {
	      this.setState({optionVal: 0})
	        this.props.selectClient('0')
	      }else if (/^\/segment\//.test(this.props.location.path)) {
	        this.setState({ disabledAllClientsOption : true })
	         if ((parseInt(this.props.selected_client, 10) === 0) && (this.state.optionsArr) &&
	            (this.state.optionsArr.length > 1)){
	            this.props.selectClient(this.state.optionsArr[1].id)
	        }
	      }*/
	      document.body.addEventListener("click", function () {
	        _this2.setState({
	          ifShowSelection: false
	        });
	      }, false);
	
	      if (/^\/insights/.test(this.props.location.path)) {
	        this.setState({ disabledAllClientsOption: true });
	        this.initializeClientList(true, this.props.clients);
	      }
	    }
	  }, {
	    key: "showList",
	    value: function showList() {
	      this.setState({
	        ifShowSelection: true
	      });
	    }
	  }, {
	    key: "handleJump",
	    value: function handleJump() {
	      this.setState({ disabledAllClientsOption: true });
	      this.initializeClientList(true, this.props.clients);
	      this.props.history.push("/segment/create");
	    }
	  }, {
	    key: "optionRenderer",
	    value: function optionRenderer(option) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        option.label
	      );
	    }
	  }, {
	    key: "filterOption",
	    value: function filterOption(option, filterString) {
	      if ((0, _lodash.isEmpty)(filterString)) return option;
	      //if ((option.value === '0') || (option.value.indexOf('r-') >= 0))
	      //  return option
	      if (option.label.toLowerCase().indexOf(filterString.toLowerCase()) >= 0) return option;
	
	      var clients = this.props.clients;
	
	      var sltClients = (0, _lodash.filter)(clients, function (c) {
	        return c.name.toLowerCase().indexOf(filterString) >= 0 && !(0, _lodash.isEmpty)(c.businessUnits);
	      });
	      var hit = false;
	      sltClients.forEach(function (c) {
	        if ((0, _lodash.findIndex)(c.businessUnits, function (item) {
	          return item.id.toString() === option.value;
	        }) >= 0) {
	          hit = true;
	          return;
	        }
	      });
	      if (hit) return option;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      //const path = this.props.location.path ? this.props.location.path : ""
	      var sltClient = this.state.optionsArr.find(function (item) {
	        if (isNaN(_this3.state.optionVal)) return item.id === _this3.state.optionVal;else return parseInt(item.id, 10) === parseInt(_this3.state.optionVal, 10);
	      });
	
	      var clientOptions = [];
	      this.state.optionsArr.forEach(function (item, index) {
	        clientOptions.push({ value: item.id.toString(), label: item.name });
	      });
	      var _props = this.props,
	          optimizeUserDetail = _props.optimizeUserDetail,
	          loginUserDetail = _props.loginUserDetail;
	
	      if (this.props.display && this.props.display === "none") return "";
	      var showClientSelector = optimizeUserDetail ? loginUserDetail && loginUserDetail.baroUid && optimizeUserDetail && parseInt(optimizeUserDetail.aaUser.subscriptionTierId, 10) !== 5 : true;
	      //const {roleId, client_info} = this.props
	      //const hideAudienceTab = (roleId > 3) && (client_info) && (client_info.subscription.id > 3)
	      return loginUserDetail && !loginUserDetail.baroUid || optimizeUserDetail && optimizeUserDetail.aaUser && optimizeUserDetail.aaUser.subscriptionTierId != 5 || loginUserDetail && loginUserDetail.baroUid && !optimizeUserDetail && this.props.client_info && parseInt(this.props.client_info.subscriptionTierId, 10) !== 5 || loginUserDetail && loginUserDetail.baroUid && !optimizeUserDetail && !this.props.client_info && this.props.selected_client && isNaN(this.props.selected_client) && this.props.selected_client.indexOf("r-") >= 0 || loginUserDetail && loginUserDetail.baroUid && optimizeUserDetail && parseInt(optimizeUserDetail.aaUser.subscriptionTierId, 10) === 5 && (!this.props.disabledFeatures || (0, _lodash.isEmpty)(this.props.disabledFeatures)) ? _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            className: "panel panel-flat no-border-radius",
	            style: {
	              backgroundColor: "#444444",
	              padding: "0px 10%",
	              height: "60px",
	              display: /(\/create-internal-account|\/create-client-account|\/create-business-unit-member-account)/g.test(this.props.location.path) ? "none" : "block"
	            }
	          },
	          showClientSelector && _react2.default.createElement(
	            "div",
	            {
	              className: "mt-10",
	              style: { position: "absolute", left: "10%" }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  color: "#FFF",
	                  position: "absolute",
	                  top: "10px",
	                  left: "0",
	                  fontSize: "16px"
	                }
	              },
	              this.state.businessUserMode === true ? "Business Unit" : "Client"
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              className: this.state.businessUserMode === true ? "left-90" : "left-47",
	              name: "",
	              value: sltClient ? sltClient.id.toString() : 0,
	              clearable: false,
	              options: clientOptions,
	              optionRenderer: this.optionRenderer.bind(this),
	              onChange: this.handleOptionsChange.bind(this),
	              filterOption: this.filterOption.bind(this)
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "navbar navbar-default no-border no-shadow pull-right no-padding-right",
	              id: "navbar-second",
	              style: { paddingLeft: "0px", backgroundColor: "#273246" }
	            },
	            _react2.default.createElement(
	              "ul",
	              { className: "nav navbar-nav no-border visible-xs-block" },
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "text-center collapsed",
	                    "data-toggle": "collapse",
	                    "data-target": "#navbar-second-toggle"
	                  },
	                  _react2.default.createElement("i", { className: "icon-menu7" })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "navbar-collapse no-border collapse",
	                id: "navbar-second-toggle",
	                style: { marginLeft: "-35px" }
	              },
	              _react2.default.createElement("ul", { className: "nav navbar-nav navbar-nav-material" })
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        null,
	        _react2.default.createElement("div", {
	          className: "panel panel-flat no-border-radius",
	          style: {
	            backgroundColor: "#444444",
	            padding: "0px 10%",
	            height: "60px",
	            display: "none"
	          }
	        })
	      );
	    }
	  }]);
	
	  return HomeNav;
	}(_react.Component);
	
	exports.default = HomeNav;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _done = __webpack_require__(307);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _utility = __webpack_require__(14);
	
	__webpack_require__(1451);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * this component base on `My Profile` UI's role
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property role {object} role information object
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var RoleExplainTip = function (_Component) {
	  _inherits(RoleExplainTip, _Component);
	
	  function RoleExplainTip() {
	    _classCallCheck(this, RoleExplainTip);
	
	    return _possibleConstructorReturn(this, (RoleExplainTip.__proto__ || Object.getPrototypeOf(RoleExplainTip)).apply(this, arguments));
	  }
	
	  _createClass(RoleExplainTip, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'role-explain clearfix' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Role'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.role.name
	        ),
	        _react2.default.createElement(
	          _rcTooltip2.default,
	          {
	            placement: 'right',
	            overlayClassName: 'profile-role-info',
	            overlayStyle: { width: "36%" },
	            overlay: _react2.default.createElement(
	              'div',
	              { className: 'profile-overlay-container' },
	              _react2.default.createElement(
	                'p',
	                null,
	                this.props.role.name
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                this.props.role.capabilities !== undefined && this.props.role.capabilities.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { className: 'clearfix', key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'icon', style: { background: (0, _utility.buttonBlueColor)() } },
	                      _react2.default.createElement(_done2.default, {
	                        style: { width: '14px', height: '14px', color: 'white' }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'section',
	                      null,
	                      item
	                    )
	                  );
	                })
	              )
	            ),
	            arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' })
	          },
	          _react2.default.createElement(_infoOutline2.default, {
	            style: { color: 'black', width: '25px', height: '25px', marginTop: '3px', marginLeft: '10px', cursor: 'pointer' }
	          })
	        )
	      );
	    }
	  }]);
	
	  return RoleExplainTip;
	}(_react.Component);
	
	exports.default = RoleExplainTip;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _forEach = __webpack_require__(185);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SegmentNav = function (_Component) {
		_inherits(SegmentNav, _Component);
	
		function SegmentNav() {
			_classCallCheck(this, SegmentNav);
	
			return _possibleConstructorReturn(this, (SegmentNav.__proto__ || Object.getPrototypeOf(SegmentNav)).apply(this, arguments));
		}
	
		_createClass(SegmentNav, [{
			key: 'getCurrentSteps',
			value: function getCurrentSteps() {
				var _this2 = this;
	
				var currentSteps = {};
	
				var steps = {
					'create': function create() {
						return true;
					},
					'confirm': function confirm() {
						return false;
					}
				};
	
				(0, _forEach2.default)(steps, function (check, step) {
					currentSteps[step] = true;
					if (step === _this2.props.match.params.step) return false;
					/*
	    if (currentSegment && currentSegment.id && true) return check(currentSegment);
	    // otherwise, use the current step to check progress
	    else if (step === this.props.match.params.step) return false;*/
				});
	
				return currentSteps;
			}
			/*
	  	getCurrentBreadcrumb(currentSteps) {
	  		return currentSteps ? Object.keys(currentSteps).indexOf(this.props.location.queryStep) : 0;
	  	}
	  */
	
		}, {
			key: 'render',
			value: function render() {
				var currentSteps = this.getCurrentSteps();
				return _react2.default.createElement(
					'div',
					{ className: 'steps-basic wizard clearfix color-grey-400' },
					_react2.default.createElement(
						'div',
						{ className: 'steps clearfix' },
						_react2.default.createElement(
							'ul',
							{ role: 'tablist' },
							_react2.default.createElement(
								'li',
								{ role: 'tab', className: !currentSteps.confirm || currentSteps.confirm === false ? "first current" : "first", 'aria-selected': 'true', 'aria-disabled': 'false' },
								_react2.default.createElement(
									_reactRouterDom.Link,
									{ id: 'steps-uid-0-t-0', to: '/segment/create', 'aria-controls': 'step-uid-0-p-0' },
									_react2.default.createElement(
										'span',
										{ className: 'current-info audible' },
										'current step: '
									),
									_react2.default.createElement(
										'span',
										{ className: 'number' },
										'1'
									),
									'Select Attributes'
								)
							),
							_react2.default.createElement(
								'li',
								{ role: 'tab', className: currentSteps.confirm === true ? "current" : "disabled", 'aria-disabled': 'True' },
								_react2.default.createElement(
									_reactRouterDom.Link,
									{ id: 'steps-uid-0-t-1', to: '/segment/confirm', 'aria-controls': 'step-uid-0-p-1' },
									_react2.default.createElement(
										'span',
										{ className: 'number' },
										'2'
									),
									'Verify and Save'
								)
							)
						)
					)
				);
			}
		}]);
	
		return SegmentNav;
	}(_react.Component);
	
	exports.default = SegmentNav;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _App = __webpack_require__(1045);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _tail = __webpack_require__(418);
	
	var _tail2 = _interopRequireDefault(_tail);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _App3 = __webpack_require__(27);
	
	var _SegmentList = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  var _state$app = state.app,
	      loginDialog = _state$app.loginDialog,
	      forgotPassword = _state$app.forgotPassword,
	      loggedIn = _state$app.loggedIn,
	      email = _state$app.email,
	      password = _state$app.password,
	      userId = _state$app.userId,
	      token = _state$app.token,
	      roleId = _state$app.roleId,
	      roleName = _state$app.roleName,
	      loginErrorMessage = _state$app.loginErrorMessage,
	      loadingOptimizeUserDetail = _state$app.loadingOptimizeUserDetail,
	      tokenExpirationTime = _state$app.tokenExpirationTime,
	      clients = _state$app.clients,
	      selected_client = _state$app.selected_client,
	      loginUserDetail = _state$app.loginUserDetail,
	      optimizeUserDetail = _state$app.optimizeUserDetail,
	      avatar = _state$app.avatar,
	      client_info = _state$app.client_info,
	      apiBuildNumber = _state$app.apiBuildNumber,
	      disabledFeatures = _state$app.disabledFeatures;
	  var categories = state.segmentCreation.categories;
	
	  var demographic = categories ? (0, _tail2.default)(categories) : undefined;
	  return {
	    loginDialog: loginDialog,
	    disabledFeatures: disabledFeatures,
	    forgotPassword: forgotPassword,
	    email: email,
	    demoAttributes: demographic,
	    password: password,
	    loggedIn: loggedIn,
	    userId: userId,
	    roleId: roleId,
	    roleName: roleName,
	    clients: clients,
	    selected_client: selected_client,
	    token: token,
	    loginUserDetail: loginUserDetail,
	    optimizeUserDetail: optimizeUserDetail,
	    loadingOptimizeUserDetail: loadingOptimizeUserDetail,
	    getUserAvatar: _App3.getUserAvatar,
	    tokenExpirationTime: tokenExpirationTime,
	    loginErrorMessage: loginErrorMessage,
	    avatar: avatar,
	    client_info: client_info,
	    apiBuildNumber: apiBuildNumber,
	    location: {
	      path: state.routing.location.pathname,
	      queryStep: state.routing.location.match ? state.routing.location.match.params.step : "",
	      query: state.routing.location.match ? state.routing.location.match.params : null
	    }
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    getDisabledFeatures: function getDisabledFeatures() {
	      dispatch((0, _App3.getDisabledFeatures)());
	    },
	    mountSession: function mountSession(session) {
	      dispatch((0, _App3.mountSession)(session));
	    },
	
	    handleLoginClose: function handleLoginClose() {
	      dispatch((0, _App3.closeLoginDialog)());
	    },
	
	    handleLoginSubmit: function handleLoginSubmit(email, password) {
	      dispatch((0, _App3.sendLogin)(email, password));
	    },
	
	    handleLogout: function handleLogout() {
	      window.localStorage.clear();
	      dispatch((0, _App3.logout)());
	    },
	
	    handleForgotPassword: function handleForgotPassword() {
	      dispatch((0, _App3.showForgotPassword)());
	    },
	
	    handleForgotPasswordSubmit: function handleForgotPasswordSubmit(email) {
	      dispatch((0, _App3.forgotPassword)(email));
	    },
	
	    handleResetPassword: function handleResetPassword(token, email, password) {
	      dispatch((0, _App3.resetPassword)(token, email, password));
	    },
	
	    setEmail: function setEmail(email) {
	      dispatch((0, _App3.setEmail)(email));
	    },
	
	    setPassword: function setPassword(password) {
	      dispatch((0, _App3.setPassword)(password));
	    },
	
	    validateSession: function validateSession() {
	      dispatch((0, _App3.validateSession)());
	    },
	
	    selectClient: function selectClient(value) {
	      dispatch((0, _App3.selectClient)(value));
	    },
	    showLoginDialog: function showLoginDialog() {
	      dispatch((0, _App3.showLoginDialog)());
	    },
	    getUserClients: function getUserClients(id) {
	      dispatch((0, _App3.getUserClients)(id));
	    },
	    getUserDetail: function getUserDetail(id) {
	      dispatch((0, _App3.getCurrentUserProfile)());
	    },
	    getOptimizeUserDetail: function getOptimizeUserDetail() {
	      dispatch((0, _App3.getCurrentUserOptimizeDetail)());
	    },
	    getUserAvatar: function getUserAvatar(filerName) {
	      dispatch((0, _App3.getUserAvatar)(filerName));
	    },
	    getCurrentUserClients: function getCurrentUserClients() {
	      dispatch((0, _App3.getCurrentUserClients)());
	    },
	    getClientInfo: function getClientInfo(id) {
	      dispatch((0, _App3.getClientInfo)(id));
	    },
	    clearClientInfo: function clearClientInfo() {
	      dispatch((0, _App3.clearClientInfo)());
	    },
	    getAPIBuildNumber: function getAPIBuildNumber() {
	      dispatch((0, _App3.getAPIBuildNumber)());
	    },
	    selectedSegment: function selectedSegment(value) {
	      dispatch((0, _SegmentList.selectedSegment)(value));
	    },
	    loadAttributes: function loadAttributes(cid) {
	      dispatch((0, _SegmentCreation.loadAttributes)(cid));
	    }
	  };
	}
	
	var AppContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_App2.default);
	
	exports.default = AppContainer;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _ChangePassword = __webpack_require__(1054);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
		var _state$app = state.app,
		    loginDialog = _state$app.loginDialog,
		    forgotPassword = _state$app.forgotPassword,
		    loggedIn = _state$app.loggedIn,
		    email = _state$app.email,
		    password = _state$app.password,
		    userId = _state$app.userId,
		    token = _state$app.token,
		    roleId = _state$app.roleId,
		    roleName = _state$app.roleName,
		    clients = _state$app.clients,
		    selected_client = _state$app.selected_client,
		    loginUserDetail = _state$app.loginUserDetail,
		    apiBuildNumber = _state$app.apiBuildNumber,
		    resetPasswordSuccess = _state$app.resetPasswordSuccess,
		    resetPasswordFailMessage = _state$app.resetPasswordFailMessage;
	
		return {
			loginDialog: loginDialog,
			forgotPassword: forgotPassword,
			email: email,
			password: password,
			loggedIn: loggedIn,
			userId: userId,
			roleId: roleId,
			roleName: roleName,
			clients: clients,
			selected_client: selected_client,
			token: token,
			loginUserDetail: loginUserDetail,
			apiBuildNumber: apiBuildNumber,
			resetPasswordSuccess: resetPasswordSuccess,
			resetPasswordFailMessage: resetPasswordFailMessage,
			location: {
				path: state.routing.location.pathname,
				queryStep: state.routing.location.match ? state.routing.location.match.params.step : '',
				query: state.routing.location.match ? state.routing.location.match.params : null,
				search: state.routing.location.search
			}
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			resetPassword: function resetPassword(pwd, rePwd, secretKey) {
				dispatch((0, _App.resetPassword)(pwd, rePwd, secretKey));
			},
			getAPIBuildNumber: function getAPIBuildNumber() {
				dispatch((0, _App.getAPIBuildNumber)());
			}
		};
	}
	
	var ChangePasswordContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ChangePassword2.default);
	
	exports.default = ChangePasswordContainer;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Login = __webpack_require__(1055);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  var _state$app = state.app,
	      loginDialog = _state$app.loginDialog,
	      forgotPassword = _state$app.forgotPassword,
	      loggedIn = _state$app.loggedIn,
	      email = _state$app.email,
	      password = _state$app.password,
	      userId = _state$app.userId,
	      token = _state$app.token,
	      roleId = _state$app.roleId,
	      roleName = _state$app.roleName,
	      apiBuildNumber = _state$app.apiBuildNumber,
	      loginErrorMessage = _state$app.loginErrorMessage,
	      tokenExpirationTime = _state$app.tokenExpirationTime,
	      clients = _state$app.clients,
	      selected_client = _state$app.selected_client,
	      loginUserDetail = _state$app.loginUserDetail,
	      avatar = _state$app.avatar;
	
	  return {
	    loginDialog: loginDialog,
	    forgotPassword: forgotPassword,
	    email: email,
	    password: password,
	    loggedIn: loggedIn,
	    userId: userId,
	    roleId: roleId,
	    roleName: roleName,
	    clients: clients,
	    selected_client: selected_client,
	    token: token,
	    loginUserDetail: loginUserDetail,
	    tokenExpirationTime: tokenExpirationTime,
	    loginErrorMessage: loginErrorMessage,
	    avatar: avatar,
	    apiBuildNumber: apiBuildNumber,
	    location: {
	      path: state.routing.location.pathname,
	      queryStep: state.routing.location.match ? state.routing.location.match.params.step : "",
	      query: state.routing.location.match ? state.routing.location.match.params : null
	    }
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    mountSession: function mountSession(session) {
	      dispatch((0, _App.mountSession)(session));
	    },
	
	    handleLoginSubmit: function handleLoginSubmit(email, password) {
	      dispatch((0, _App.sendLogin)(email, password));
	    },
	
	    handleLogout: function handleLogout() {
	      window.localStorage.removeItem("session");
	      window.localStorage.clear();
	      dispatch((0, _App.logout)());
	    },
	
	    handleForgotPassword: function handleForgotPassword() {
	      dispatch((0, _App.showForgotPassword)());
	    },
	
	    handleForgotPasswordSubmit: function handleForgotPasswordSubmit(email) {
	      dispatch((0, _App.forgotPassword)(email));
	    },
	
	    handleResetPassword: function handleResetPassword(token, email, password) {
	      dispatch((0, _App.resetPassword)(token, email, password));
	    },
	
	    setEmail: function setEmail(email) {
	      dispatch((0, _App.setEmail)(email));
	    },
	
	    setPassword: function setPassword(password) {
	      dispatch((0, _App.setPassword)(password));
	    },
	    getAPIBuildNumber: function getAPIBuildNumber() {
	      dispatch((0, _App.getAPIBuildNumber)());
	    }
	  };
	}
	
	var UserLogin = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Login2.default);
	
	exports.default = UserLogin;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _ResetPassword = __webpack_require__(1056);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
		var _state$app = state.app,
		    loginDialog = _state$app.loginDialog,
		    forgotPassword = _state$app.forgotPassword,
		    loggedIn = _state$app.loggedIn,
		    email = _state$app.email,
		    password = _state$app.password,
		    userId = _state$app.userId,
		    token = _state$app.token,
		    roleId = _state$app.roleId,
		    roleName = _state$app.roleName,
		    clients = _state$app.clients,
		    selected_client = _state$app.selected_client,
		    loginUserDetail = _state$app.loginUserDetail,
		    apiBuildNumber = _state$app.apiBuildNumber,
		    sendRecoveryEmailSuccess = _state$app.sendRecoveryEmailSuccess,
		    sendRecoveryEmailFailMessage = _state$app.sendRecoveryEmailFailMessage;
	
		return {
			loginDialog: loginDialog,
			forgotPassword: forgotPassword,
			email: email,
			password: password,
			loggedIn: loggedIn,
			userId: userId,
			roleId: roleId,
			roleName: roleName,
			clients: clients,
			selected_client: selected_client,
			apiBuildNumber: apiBuildNumber,
			token: token,
			loginUserDetail: loginUserDetail,
			sendRecoveryEmailFailMessage: sendRecoveryEmailFailMessage,
			sendRecoveryEmailSuccess: sendRecoveryEmailSuccess,
			location: {
				path: state.routing.location.pathname,
				queryStep: state.routing.location.match ? state.routing.location.match.params.step : '',
				query: state.routing.location.match ? state.routing.location.match.params : null
			}
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			mountSession: function mountSession(session) {
				dispatch((0, _App.mountSession)(session));
			},
	
			handleLoginSubmit: function handleLoginSubmit(email, password) {
				dispatch((0, _App.sendLogin)(email, password));
			},
	
			handleLogout: function handleLogout() {
				window.localStorage.clear();
				dispatch((0, _App.logout)());
				dispatch((0, _reactRouterRedux.push)("/"));
			},
	
			handleForgotPassword: function handleForgotPassword() {
				dispatch((0, _App.showForgotPassword)());
			},
	
			handleForgotPasswordSubmit: function handleForgotPasswordSubmit(email) {
				dispatch((0, _App.forgotPassword)(email));
			},
	
			handleResetPassword: function handleResetPassword(token, email, password) {
				dispatch((0, _App.resetPassword)(token, email, password));
			},
	
			setEmail: function setEmail(email) {
				dispatch((0, _App.setEmail)(email));
			},
	
			setPassword: function setPassword(password) {
				dispatch((0, _App.setPassword)(password));
			},
	
			sendPasswordRecoveryEmail: function sendPasswordRecoveryEmail(email, secretKey) {
				dispatch((0, _App.sendPasswordRecoveryEmail)(email, secretKey));
			},
			getAPIBuildNumber: function getAPIBuildNumber() {
				dispatch((0, _App.getAPIBuildNumber)());
			}
		};
	}
	
	var ResetPasswordContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ResetPassword2.default);
	
	exports.default = ResetPasswordContainer;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Campaign = __webpack_require__(117);
	
	var _App = __webpack_require__(27);
	
	var _Report = __webpack_require__(1069);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
		var _state$campaigns = state.campaigns,
		    campaignAggregatedReport = _state$campaigns.campaignAggregatedReport,
		    campaignChannelAggregatedReport = _state$campaigns.campaignChannelAggregatedReport,
		    campaignDetail = _state$campaigns.campaignDetail,
		    reportDateRange = _state$campaigns.reportDateRange;
		var clients = state.app.clients;
	
		return {
			campaignDetail: campaignDetail,
			campaignAggregatedReport: campaignAggregatedReport,
			campaignChannelAggregatedReport: campaignChannelAggregatedReport,
			reportDateRange: reportDateRange ? reportDateRange : "life-of-campaign",
			client_id: state.app.client_info && state.app.client_info.id,
			client_tz: state.app.client_info && state.app.client_info.timezone,
			client_info: state.app.client_info,
			clients: clients
		};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			getCampaignById: function getCampaignById(id) {
				dispatch((0, _Campaign.getCampaignById)(id, false));
			},
			getCampaignGroupAggregated: function getCampaignGroupAggregated(id, dateRange) {
				dispatch((0, _Campaign.getCampaignGroupAggregated)(id, dateRange));
			},
			getCampaignChannelAggregated: function getCampaignChannelAggregated(id, dateRange) {
				dispatch((0, _Campaign.getCampaignChannelAggregated)(id, dateRange));
			},
			setReportDateRange: function setReportDateRange(range) {
				dispatch((0, _Campaign.setReportDateRange)(range.value));
			},
			selectClient: function selectClient(cid) {
				dispatch((0, _App.selectClient)(cid));
			}
		};
	};
	
	var CampaignReportContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Report2.default);
	
	exports.default = CampaignReportContainer;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Campaign = __webpack_require__(117);
	
	var _App = __webpack_require__(27);
	
	var _DisplayChannelReport = __webpack_require__(1065);
	
	var _DisplayChannelReport2 = _interopRequireDefault(_DisplayChannelReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var clients = state.app.clients;
	  var _state$campaigns = state.campaigns,
	      displayAggregatedReport = _state$campaigns.displayAggregatedReport,
	      displayAggregatedStats = _state$campaigns.displayAggregatedStats,
	      reportDateRange = _state$campaigns.reportDateRange,
	      campaignDetail = _state$campaigns.campaignDetail,
	      topLinkStats = _state$campaigns.topLinkStats,
	      topLocationOpensStats = _state$campaigns.topLocationOpensStats,
	      channelCampaignId = _state$campaigns.channelCampaignId,
	      segmentId = _state$campaigns.segmentId;
	
	  return {
	    displayAggregatedReport: displayAggregatedReport,
	    displayAggregatedStats: displayAggregatedStats,
	    campaignDetail: campaignDetail,
	    channelCampaignId: channelCampaignId,
	    topLocationOpensStats: topLocationOpensStats,
	    topLinkStats: topLinkStats,
	    segmentId: segmentId,
	    reportDateRange: reportDateRange ? reportDateRange : "life-of-campaign",
	    client_id: state.app.client_info && state.app.client_info.id,
	    client_tz: state.app.client_info && state.app.client_info.timezone,
	    client_info: state.app.client_info,
	    clients: clients
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getCampaignById: function getCampaignById(id) {
	      dispatch((0, _Campaign.getCampaignById)(id, false));
	    },
	    selectClient: function selectClient(cid) {
	      dispatch((0, _App.selectClient)(cid));
	    },
	    getDisplayChannelAggregatedReport: function getDisplayChannelAggregatedReport(groupCampaignId, deploymentid, dateRange, channelCampaignId) {
	      dispatch((0, _Campaign.getDisplayChannelAggregated)(groupCampaignId, deploymentid, dateRange, channelCampaignId));
	    },
	    getDisplayChannelStatsAggregated: function getDisplayChannelStatsAggregated(groupCampaignId, deploymentid, dateRange, channelCampaignId) {
	      dispatch((0, _Campaign.getDisplayChannelStatsAggregated)(groupCampaignId, deploymentid, dateRange, channelCampaignId));
	    },
	    getCampaignTopLinkStats: function getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit) {
	      dispatch((0, _Campaign.getCampaignTopLinkStats)(groupCampaignId, campaignid, dateRanges, limit, "display"));
	    },
	    getCampaignTopLocationClickStats: function getCampaignTopLocationClickStats(groupCampaignId, campaignId, dateRange, limit) {
	      dispatch((0, _Campaign.getCampaignTopLocationClickStats)(groupCampaignId, campaignId, dateRange, limit, "display"));
	    },
	    setReportDateRange: function setReportDateRange(dateRange) {
	      dispatch((0, _Campaign.setReportDateRange)(dateRange.value));
	    },
	    setChannelCampaignId: function setChannelCampaignId(data) {
	      dispatch((0, _Campaign.setChannelCampaignId)(data.value));
	    },
	    setSegmentId: function setSegmentId(data) {
	      dispatch((0, _Campaign.setSegmentId)(data.value));
	    },
	    cleanCampaignInfo: function cleanCampaignInfo(cid) {
	      dispatch((0, _Campaign.clearCampaignDetail)(cid));
	    }
	  };
	};
	
	var DisplayChannelContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DisplayChannelReport2.default);
	
	exports.default = DisplayChannelContainer;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Campaign = __webpack_require__(117);
	
	var _App = __webpack_require__(27);
	
	var _EmailChannelReport = __webpack_require__(1066);
	
	var _EmailChannelReport2 = _interopRequireDefault(_EmailChannelReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var clients = state.app.clients;
	  var _state$campaigns = state.campaigns,
	      emailAggregatedReport = _state$campaigns.emailAggregatedReport,
	      emailAggregatedStats = _state$campaigns.emailAggregatedStats,
	      reportDateRange = _state$campaigns.reportDateRange,
	      campaignDetail = _state$campaigns.campaignDetail,
	      topLinkStats = _state$campaigns.topLinkStats,
	      topLocationOpensStats = _state$campaigns.topLocationOpensStats,
	      channelCampaignId = _state$campaigns.channelCampaignId,
	      segmentId = _state$campaigns.segmentId;
	
	  return {
	    emailAggregatedReport: emailAggregatedReport,
	    emailAggregatedStats: emailAggregatedStats,
	    campaignDetail: campaignDetail,
	    channelCampaignId: channelCampaignId,
	    segmentId: segmentId,
	    topLocationOpensStats: topLocationOpensStats,
	    topLinkStats: topLinkStats,
	    reportDateRange: reportDateRange ? reportDateRange : "life-of-campaign",
	    client_id: state.app.client_info && state.app.client_info.id,
	    client_tz: state.app.client_info && state.app.client_info.timezone,
	    client_info: state.app.client_info,
	    clients: clients
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getCampaignById: function getCampaignById(id) {
	      dispatch((0, _Campaign.getCampaignById)(id, false));
	    },
	    selectClient: function selectClient(cid) {
	      dispatch((0, _App.selectClient)(cid));
	    },
	    getEmailChannelAggregatedReport: function getEmailChannelAggregatedReport(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	      dispatch((0, _Campaign.getEmailChannelAggregated)(groupCampaignId, deploymentId, dateRange, channelCampaignId));
	    },
	    getEmailChannelStatsAggregated: function getEmailChannelStatsAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	      dispatch((0, _Campaign.getEmailChannelStatsAggregated)(groupCampaignId, deploymentId, dateRange, channelCampaignId));
	    },
	    getCampaignTopLinkStats: function getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit) {
	      dispatch((0, _Campaign.getCampaignTopLinkStats)(groupCampaignId, campaignid, dateRanges, limit, "email"));
	    },
	    getCampaignTopLocationClickStats: function getCampaignTopLocationClickStats(groupCampaignId, campaignId, dateRange, limit) {
	      dispatch((0, _Campaign.getCampaignTopLocationClickStats)(groupCampaignId, campaignId, dateRange, limit, "email"));
	    },
	    setReportDateRange: function setReportDateRange(dateRange) {
	      dispatch((0, _Campaign.setReportDateRange)(dateRange.value));
	    },
	    setChannelCampaignId: function setChannelCampaignId(data) {
	      dispatch((0, _Campaign.setChannelCampaignId)(data.value));
	    },
	    setSegmentId: function setSegmentId(data) {
	      dispatch((0, _Campaign.setSegmentId)(data.value));
	    },
	    cleanCampaignInfo: function cleanCampaignInfo(cid) {
	      dispatch((0, _Campaign.clearCampaignDetail)(cid));
	    }
	  };
	};
	
	var EmailChannelContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EmailChannelReport2.default);
	
	exports.default = EmailChannelContainer;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Campaign = __webpack_require__(117);
	
	var _App = __webpack_require__(27);
	
	var _SocialChannelReport = __webpack_require__(1067);
	
	var _SocialChannelReport2 = _interopRequireDefault(_SocialChannelReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var clients = state.app.clients;
	  var _state$campaigns = state.campaigns,
	      socialAggregatedReport = _state$campaigns.socialAggregatedReport,
	      socialAggregatedStats = _state$campaigns.socialAggregatedStats,
	      reportDateRange = _state$campaigns.reportDateRange,
	      campaignDetail = _state$campaigns.campaignDetail,
	      topLinkStats = _state$campaigns.topLinkStats,
	      topLocationOpensStats = _state$campaigns.topLocationOpensStats,
	      channelCampaignId = _state$campaigns.channelCampaignId,
	      segmentId = _state$campaigns.segmentId;
	
	  return {
	    socialAggregatedReport: socialAggregatedReport,
	    socialAggregatedStats: socialAggregatedStats,
	    campaignDetail: campaignDetail,
	    channelCampaignId: channelCampaignId,
	    topLocationOpensStats: topLocationOpensStats,
	    topLinkStats: topLinkStats,
	    segmentId: segmentId,
	    reportDateRange: reportDateRange ? reportDateRange : "life-of-campaign",
	    client_id: state.app.client_info && state.app.client_info.id,
	    client_tz: state.app.client_info && state.app.client_info.timezone,
	    client_info: state.app.client_info,
	    clients: clients
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getCampaignById: function getCampaignById(id) {
	      dispatch((0, _Campaign.getCampaignById)(id, false));
	    },
	    selectClient: function selectClient(cid) {
	      dispatch((0, _App.selectClient)(cid));
	    },
	    getSocialChannelAggregatedReport: function getSocialChannelAggregatedReport(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	      dispatch((0, _Campaign.getSocialChannelAggregated)(groupCampaignId, deploymentId, dateRange, channelCampaignId));
	    },
	    getSocialChannelStatsAggregated: function getSocialChannelStatsAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
	      dispatch((0, _Campaign.getSocialChannelStatsAggregated)(groupCampaignId, deploymentId, dateRange, channelCampaignId));
	    },
	    getCampaignTopLinkStats: function getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit) {
	      dispatch((0, _Campaign.getCampaignTopLinkStats)(groupCampaignId, campaignid, dateRanges, limit, "social"));
	    },
	    getCampaignTopLocationClickStats: function getCampaignTopLocationClickStats(groupCampaignId, campaignId, dateRange, limit) {
	      dispatch((0, _Campaign.getCampaignTopLocationClickStats)(groupCampaignId, campaignId, dateRange, limit, "social"));
	    },
	    setReportDateRange: function setReportDateRange(dateRange) {
	      dispatch((0, _Campaign.setReportDateRange)(dateRange.value));
	    },
	    setChannelCampaignId: function setChannelCampaignId(data) {
	      dispatch((0, _Campaign.setChannelCampaignId)(data.value));
	    },
	    setSegmentId: function setSegmentId(data) {
	      dispatch((0, _Campaign.setSegmentId)(data.value));
	    },
	    cleanCampaignInfo: function cleanCampaignInfo(cid) {
	      dispatch((0, _Campaign.clearCampaignDetail)(cid));
	    }
	  };
	};
	
	var SocialChannelContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SocialChannelReport2.default);
	
	exports.default = SocialChannelContainer;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Campaign = __webpack_require__(117);
	
	var _App = __webpack_require__(27);
	
	var _TopLinksClick = __webpack_require__(1068);
	
	var _TopLinksClick2 = _interopRequireDefault(_TopLinksClick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var clients = state.app.clients;
	  var _state$campaigns = state.campaigns,
	      emailAggregatedReport = _state$campaigns.emailAggregatedReport,
	      emailAggregatedStats = _state$campaigns.emailAggregatedStats,
	      reportDateRange = _state$campaigns.reportDateRange,
	      campaignDetail = _state$campaigns.campaignDetail,
	      topLinkStats = _state$campaigns.topLinkStats,
	      channelCampaignId = _state$campaigns.channelCampaignId,
	      loadingTopLinkStats = _state$campaigns.loadingTopLinkStats;
	
	  return {
	    emailAggregatedReport: emailAggregatedReport,
	    emailAggregatedStats: emailAggregatedStats,
	    campaignDetail: campaignDetail,
	    channelCampaignId: channelCampaignId,
	    topLinkStats: topLinkStats,
	    loadingTopLinkStats: loadingTopLinkStats,
	    reportDateRange: reportDateRange ? reportDateRange : "life-of-campaign",
	    client_id: state.app.client_info && state.app.client_info.id,
	    client_tz: state.app.client_info && state.app.client_info.timezone,
	    client_info: state.app.client_info,
	    clients: clients
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getCampaignById: function getCampaignById(id) {
	      dispatch((0, _Campaign.getCampaignById)(id, false));
	    },
	    selectClient: function selectClient(cid) {
	      dispatch((0, _App.selectClient)(cid));
	    },
	    getEmailChannelAggregatedReport: function getEmailChannelAggregatedReport(groupCampaignId, campaignId, dateRange) {
	      dispatch((0, _Campaign.getEmailChannelAggregated)(groupCampaignId, campaignId, dateRange));
	    },
	    getEmailChannelStatsAggregated: function getEmailChannelStatsAggregated(groupCampaignId, campaignId, dateRange) {
	      dispatch((0, _Campaign.getEmailChannelStatsAggregated)(groupCampaignId, campaignId, dateRange === "aggregated" ? "aggregate" : dateRange));
	    },
	    getCampaignTopLinkStats: function getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit) {
	      dispatch((0, _Campaign.getCampaignTopLinkStats)(groupCampaignId, campaignid, dateRanges, limit));
	    },
	    setReportDateRange: function setReportDateRange(dateRange) {
	      dispatch((0, _Campaign.setReportDateRange)(dateRange.value));
	    },
	    setSegmentId: function setSegmentId(data) {
	      dispatch((0, _Campaign.setSegmentId)(data.value));
	    },
	    setChannelCampaignId: function setChannelCampaignId(data) {
	      dispatch((0, _Campaign.setChannelCampaignId)(data.value));
	    }
	  };
	};
	
	var TopLinksClicksContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TopLinksClick2.default);
	
	exports.default = TopLinksClicksContainer;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Campaign = __webpack_require__(117);
	
	var _App = __webpack_require__(27);
	
	var _CreateCampaigns = __webpack_require__(1061);
	
	var _CreateCampaigns2 = _interopRequireDefault(_CreateCampaigns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$campaigns = state.campaigns,
	      emailChannelCampaigns = _state$campaigns.emailChannelCampaigns,
	      socialChannelCampaigns = _state$campaigns.socialChannelCampaigns,
	      onSavingCampaign = _state$campaigns.onSavingCampaign,
	      savingCampaignErrorMessage = _state$campaigns.savingCampaignErrorMessage,
	      displayChannelCampaigns = _state$campaigns.displayChannelCampaigns,
	      campaignDetail = _state$campaigns.campaignDetail;
	
	  return {
	    emailChannelCampaigns: emailChannelCampaigns,
	    socialChannelCampaigns: socialChannelCampaigns,
	    displayChannelCampaigns: displayChannelCampaigns,
	    client_id: state.app.client_info && state.app.client_info.id,
	    client_tz: state.app.client_info && state.app.client_info.timezone,
	    client_info: state.app.client_info,
	    clients: state.app.clients,
	    onSavingCampaign: onSavingCampaign,
	    savingCampaignErrorMessage: savingCampaignErrorMessage,
	    campaignDetail: campaignDetail
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getChannelCampaigns: function getChannelCampaigns(channel, startDate, endDate) {
	      dispatch((0, _Campaign.getChannelCampaignList)(channel, startDate, endDate));
	    },
	    saveCampaignGroup: function saveCampaignGroup(data) {
	      dispatch((0, _Campaign.saveCampaignGroup)(data));
	    },
	    getCampaignById: function getCampaignById(id) {
	      dispatch((0, _Campaign.getCampaignById)(id, false));
	    },
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    },
	    clearSaveCampaignErrorMessage: function clearSaveCampaignErrorMessage() {
	      dispatch((0, _Campaign.clearSaveCampaignErrorMessage)());
	    }
	  };
	};
	
	var CreateCampaigns = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_CreateCampaigns2.default);
	
	exports.default = CreateCampaigns;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1063);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Campaign = __webpack_require__(117);
	
	var _App = __webpack_require__(27);
	
	var _reactRedux = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$campaigns = state.campaigns,
	      tables = _state$campaigns.tables,
	      emailChannelCampaigns = _state$campaigns.emailChannelCampaigns,
	      socialChannelCampaigns = _state$campaigns.socialChannelCampaigns,
	      campaignDataOnLoading = _state$campaigns.campaignDataOnLoading,
	      csvData = _state$campaigns.csvData,
	      campaignDataLoadErrorMessage = _state$campaigns.campaignDataLoadErrorMessage,
	      campaignFilterStartDate = _state$campaigns.campaignFilterStartDate,
	      campaignFilterEndDate = _state$campaigns.campaignFilterEndDate,
	      campaignFilterValue = _state$campaigns.campaignFilterValue;
	  var roleId = state.app.roleId;
	
	  return {
	    client_id: state.app.client_info && state.app.client_info.id,
	    client_tz: state.app.client_info && state.app.client_info.timezone,
	    client_info: state.app.client_info,
	    clients: state.app.clients,
	    tables: tables,
	    csvData: csvData,
	    campaignDataOnLoading: campaignDataOnLoading,
	    emailChannelCampaigns: emailChannelCampaigns,
	    socialChannelCampaigns: socialChannelCampaigns,
	    campaignDataLoadErrorMessage: campaignDataLoadErrorMessage,
	    campaignFilterStartDate: campaignFilterStartDate,
	    campaignFilterEndDate: campaignFilterEndDate,
	    campaignFilterValue: campaignFilterValue,
	    roleId: roleId
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getTables: function getTables(obj) {
	      if (!obj.fromDate && !obj.toDate) obj.status = "Active";else obj.status = undefined;
	      dispatch((0, _Campaign.getTables)(obj));
	    },
	
	    getCampaignById: function getCampaignById(id, clientId) {
	      dispatch((0, _Campaign.getCampaignById)(id, true, clientId));
	    },
	
	    clearCampaignDetail: function clearCampaignDetail() {
	      dispatch((0, _Campaign.clearCampaignDetail)());
	    },
	
	    clearCampaignCsvData: function clearCampaignCsvData() {
	      dispatch((0, _Campaign.clearCampaignCsvData)());
	    },
	
	    getCampaignCsvData: function getCampaignCsvData(obj) {
	      if (!obj.fromDate && !obj.toDate) obj.status = "Active";else obj.status = undefined;
	      dispatch((0, _Campaign.getCampaignCSV)(obj));
	    },
	
	    setCampaignFilterStartDate: function setCampaignFilterStartDate(date) {
	      dispatch((0, _Campaign.setCampaignFilterStartDate)(date));
	    },
	
	    setCampaignFilterEndDate: function setCampaignFilterEndDate(date) {
	      dispatch((0, _Campaign.setCampaignFilterEndDate)(date));
	    },
	
	    setCampaignFilterValue: function setCampaignFilterValue(filterValue) {
	      dispatch((0, _Campaign.setCampaignFilterValue)(filterValue));
	    },
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    }
	  };
	};
	
	var Campaigns = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = Campaigns;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1072);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _reactRedux = __webpack_require__(20);
	
	var _ClientBusinessInfoAndUser = __webpack_require__(504);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$clientBusiness = state.clientBusinessAndUser,
	      client_business_total = _state$clientBusiness.client_business_total,
	      search_results = _state$clientBusiness.search_results,
	      all_search_results = _state$clientBusiness.all_search_results,
	      client_users_total = _state$clientBusiness.client_users_total,
	      users_results = _state$clientBusiness.users_results,
	      all_users_results = _state$clientBusiness.all_users_results;
	  var token = state.app.token;
	
	  return {
	    client_business_total: client_business_total,
	    client_users_total: client_users_total,
	    search_results: search_results,
	    all_search_results: all_search_results,
	    users_results: users_results,
	    all_users_results: all_users_results,
	    clients: state.app.clients,
	    token: token
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientBusinessTotal: function getClientBusinessTotal() {
	      dispatch((0, _ClientBusinessInfoAndUser.getClientBusinessTotal)());
	    },
	    clientBusinessSearch: function clientBusinessSearch(obj) {
	      dispatch((0, _ClientBusinessInfoAndUser.clientBusinessSearch)(obj));
	    },
	    getAllSearch: function getAllSearch(obj) {
	      dispatch((0, _ClientBusinessInfoAndUser.getAllSearch)(obj));
	    },
	    usersSearch: function usersSearch(obj) {
	      dispatch((0, _ClientBusinessInfoAndUser.usersSearch)(obj));
	    },
	    usersAll: function usersAll() {
	      dispatch((0, _ClientBusinessInfoAndUser.usersSearchAll)({
	        clientId: '',
	        pageNumber: 1,
	        pageSize: 500,
	        sortColumn: 'clientName',
	        order: 'asc'
	      }));
	    },
	    getAllUsersSearch: function getAllUsersSearch(obj) {
	      dispatch((0, _ClientBusinessInfoAndUser.getAllUsersSearch)(obj));
	    },
	    clearUsersSearch: function clearUsersSearch() {
	      dispatch((0, _ClientBusinessInfoAndUser.clearUsersSearch)());
	    },
	    searchClientsWithKeyword: function searchClientsWithKeyword(keyword) {
	      dispatch((0, _ClientBusinessInfoAndUser.searchClientsWithKeyword)(keyword));
	    }
	  };
	};
	
	var ClientBusinessAndUser = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = ClientBusinessAndUser;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _TeamMembers = __webpack_require__(1081);
	
	var _TeamMembers2 = _interopRequireDefault(_TeamMembers);
	
	var _Clients = __webpack_require__(49);
	
	var _lodash = __webpack_require__(18);
	
	var _employees = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var client_team_members = state.clients.client_team_members;
	  var _state$employees = state.employees,
	      roles = _state$employees.roles,
	      clientRoles = _state$employees.clientRoles,
	      ifUpdateSuccess = _state$employees.ifUpdateSuccess,
	      updateErrorText = _state$employees.updateErrorText,
	      sendInvite_error_message = _state$employees.sendInvite_error_message;
	  var _state$clients = state.clients,
	      ifSendInvitationSuccess = _state$clients.ifSendInvitationSuccess,
	      send_invitation_error_msg = _state$clients.send_invitation_error_msg,
	      business_unit_team_members = _state$clients.business_unit_team_members,
	      ifInviteBusinessUnitMemberSuccess = _state$clients.ifInviteBusinessUnitMemberSuccess;
	  var _state$app = state.app,
	      userId = _state$app.userId,
	      roleId = _state$app.roleId,
	      roleName = _state$app.roleName;
	
	  return {
	    roles: roleId > 50 ? clientRoles.filter(function (item) {
	      return item.value !== 53;
	    }) : roles,
	    clientRoles: (0, _lodash.initial)(clientRoles),
	    ifSendInviteSuccess: ifSendInvitationSuccess,
	    ifUpdateSuccess: ifUpdateSuccess,
	    updateErrorText: updateErrorText,
	    userId: userId,
	    roleId: roleId,
	    sendInvite_error_message: sendInvite_error_message,
	    tableList: client_team_members !== undefined && client_team_members.data ? client_team_members.data : client_team_members,
	    origin_tableList: client_team_members,
	    ifSendInvitationSuccess: ifSendInvitationSuccess,
	    send_invitation_error_msg: send_invitation_error_msg,
	    roleName: roleName,
	    business_unit_team_members: business_unit_team_members,
	    ifInviteBusinessUnitMemberSuccess: ifInviteBusinessUnitMemberSuccess
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getRoles: function getRoles() {
	      dispatch((0, _employees.getRoles)());
	    },
	    getClientRoles: function getClientRoles() {
	      dispatch((0, _employees.getClientRoles)());
	    },
	    sendInvite: function sendInvite(obj) {
	      dispatch((0, _Clients.send_invitation)(obj));
	    },
	    sendClientInvite: function sendClientInvite(obj) {
	      dispatch((0, _employees.sendClientUserInvite)(obj));
	    },
	    rollbackStatus: function rollbackStatus() {
	      dispatch((0, _Clients.rollbackStatus)());
	    },
	    updateProfile: function updateProfile(id, obj) {
	      dispatch((0, _employees.updateProfile)(id, obj));
	    },
	    rollBackUpdateStatus: function rollBackUpdateStatus() {
	      dispatch((0, _employees.rollBackUpdateStatus)());
	    },
	    getClientUsers: function getClientUsers(req, clientId) {
	      dispatch((0, _Clients.getClientUsers)(clientId, req));
	    },
	    inviteBusinessMember: function inviteBusinessMember(obj) {
	      dispatch((0, _Clients.inviteBusinessMember)(obj));
	    },
	    getBusinessUnitTeamMembers: function getBusinessUnitTeamMembers(clientId, businessId) {
	      dispatch((0, _Clients.getBusinessUnitTeamMembers)(clientId, businessId));
	    },
	    sendInviteBusinessUnitMember: function sendInviteBusinessUnitMember(obj) {
	      dispatch((0, _Clients.sendInviteBusinessUnitMember)(obj));
	    }
	  };
	};
	
	var ClientTeamMembers = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TeamMembers2.default);
	
	exports.default = ClientTeamMembers;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BusinessUnits = __webpack_require__(1077);
	
	var _BusinessUnits2 = _interopRequireDefault(_BusinessUnits);
	
	var _reactRedux = __webpack_require__(20);
	
	var _Clients = __webpack_require__(49);
	
	var _Profile = __webpack_require__(164);
	
	var _employees = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$clients = state.clients,
	      business_units_list = _state$clients.business_units_list,
	      edit_client_profile = _state$clients.edit_client_profile,
	      ifSendInvitationSuccess = _state$clients.ifSendInvitationSuccess,
	      industryOptions = _state$clients.industryOptions,
	      tier_options = _state$clients.tier_options,
	      account_manager = _state$clients.account_manager,
	      send_invitation = _state$clients.send_invitation,
	      send_invitation_error_msg = _state$clients.send_invitation_error_msg,
	      invitation_client = _state$clients.invitation_client,
	      client_options = _state$clients.client_options,
	      rollbackStatus = _state$clients.rollbackStatus,
	      client_names = _state$clients.client_names,
	      businessUnitOptions = _state$clients.businessUnitOptions,
	      inviteBusinessMember = _state$clients.inviteBusinessMember,
	      createClientProfileMessage = _state$clients.createClientProfileMessage,
	      teamMember_options = _state$clients.teamMember_options,
	      ifCreateClientProfileSuccess = _state$clients.ifCreateClientProfileSuccess,
	      clientId = _state$clients.clientId,
	      ifCreateClientProfileSuccessBasic = _state$clients.ifCreateClientProfileSuccessBasic;
	  var _state$myProfile = state.myProfile,
	      allstates = _state$myProfile.allstates,
	      timezone = _state$myProfile.timezone,
	      ifUpdateSuccess = _state$myProfile.ifUpdateSuccess;
	  var _state$app = state.app,
	      loginUserDetail = _state$app.loginUserDetail,
	      token = _state$app.token,
	      roleName = _state$app.roleName;
	
	  return {
	    roleName: roleName,
	    business_units_list: business_units_list,
	    edit_client_profile: edit_client_profile,
	    ifSendInvitationSuccess: ifSendInvitationSuccess,
	    industryOptions: industryOptions,
	    tier_options: tier_options,
	    account_manager: account_manager,
	    send_invitation: send_invitation,
	    send_invitation_error_msg: send_invitation_error_msg,
	    invitation_client: invitation_client,
	    client_options: client_options,
	    rollbackStatus: rollbackStatus,
	    client_names: client_names,
	    businessUnitOptions: businessUnitOptions,
	    inviteBusinessMember: inviteBusinessMember,
	    allstates: allstates,
	    timezone: timezone,
	    ifUpdateSuccess: ifUpdateSuccess,
	    loginUserDetail: loginUserDetail,
	    token: token,
	    createClientProfileMessage: createClientProfileMessage,
	    teamMember_options: teamMember_options,
	    ifCreateClientProfileSuccess: ifCreateClientProfileSuccess,
	    clientId: clientId,
	    ifCreateClientProfileSuccessBasic: ifCreateClientProfileSuccessBasic
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientBusiness: function getClientBusiness(id) {
	      dispatch((0, _Clients.getClientBusiness)(id));
	    },
	    getBusinessUnitOptions: function getBusinessUnitOptions() {
	      dispatch((0, _Clients.getBusinessUnitOptions)());
	    },
	    getTierOptions: function getTierOptions() {
	      dispatch((0, _Clients.getTierOptions)());
	    },
	    get_client_options: function get_client_options() {
	      dispatch((0, _Clients.get_client_options)());
	    },
	    inviteBusinessMember: function inviteBusinessMember(obj) {
	      dispatch((0, _Clients.inviteBusinessMember)(obj));
	    },
	    getStates: function getStates() {
	      dispatch((0, _Profile.getStates)());
	    },
	    getTimezone: function getTimezone() {
	      dispatch((0, _Profile.getTimezone)());
	    },
	    getRoles: function getRoles() {
	      dispatch((0, _employees.getRoles)());
	    },
	    createClientProfile: function createClientProfile(obj, id) {
	      dispatch((0, _Clients.createClientProfile)(obj, id));
	    },
	    createClientBusinessUnit: function createClientBusinessUnit(obj, cid) {
	      dispatch((0, _Clients.createClientBusinessUnit)(obj, cid));
	    },
	    rollbackProfileStatus: function rollbackProfileStatus(value) {
	      dispatch((0, _Clients.rollbackProfileStatus)(value));
	    },
	    getTeamMember: function getTeamMember(id) {
	      dispatch((0, _Clients.getTeamMember)(id));
	    },
	    getIndustryOptions: function getIndustryOptions() {
	      dispatch((0, _Clients.getIndustryOptions)());
	    },
	    getClientProfile: function getClientProfile(id) {
	      dispatch((0, _Clients.getClientProfile)(id));
	    },
	    configInsightsStandard: function configInsightsStandard(id, obj) {
	      dispatch((0, _Clients.configInsightsStandard)(id, obj));
	    }
	  };
	};
	
	var BusinessUnits = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BusinessUnits2.default);
	
	exports.default = BusinessUnits;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _BusinessUnitsDetail = __webpack_require__(513);
	
	var _BusinessUnitsDetail2 = _interopRequireDefault(_BusinessUnitsDetail);
	
	var _Clients = __webpack_require__(49);
	
	var _Profile = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$clients = state.clients,
	      edit_client_profile = _state$clients.edit_client_profile,
	      industryOptions = _state$clients.industryOptions,
	      tier_options = _state$clients.tier_options,
	      ifEditClientProfileSuccess = _state$clients.ifEditClientProfileSuccess,
	      teamMember_options = _state$clients.teamMember_options,
	      insights_standard_config = _state$clients.insights_standard_config,
	      clientProfileUpdateError = _state$clients.clientProfileUpdateError;
	  var _state$myProfile = state.myProfile,
	      company_logo = _state$myProfile.company_logo,
	      allstates = _state$myProfile.allstates;
	  var _state$app = state.app,
	      roleName = _state$app.roleName,
	      token = _state$app.token,
	      loginUserDetail = _state$app.loginUserDetail;
	  var _state$myProfile2 = state.myProfile,
	      timezone = _state$myProfile2.timezone,
	      ifUpdateSuccess = _state$myProfile2.ifUpdateSuccess;
	  var account_manager = state.employees.account_manager;
	
	
	  return {
	    edit_client_profile: edit_client_profile,
	    timezone: timezone,
	    industryOptions: industryOptions,
	    tier_options: tier_options,
	    roleName: roleName,
	    token: token,
	    ifEditClientProfileSuccess: ifEditClientProfileSuccess,
	    teamMember_options: teamMember_options,
	    company_logo: company_logo,
	    ifUpdateSuccess: ifUpdateSuccess,
	    allstates: allstates,
	    loginUserDetail: loginUserDetail,
	    account_manager: account_manager,
	    insights_standard_config: insights_standard_config,
	    clientProfileUpdateError: clientProfileUpdateError
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientProfile: function getClientProfile(id) {
	      dispatch((0, _Clients.getClientProfile)(id));
	    },
	    getTimezone: function getTimezone() {
	      dispatch((0, _Profile.getTimezone)());
	    },
	    getIndustryOptions: function getIndustryOptions() {
	      dispatch((0, _Clients.getIndustryOptions)());
	    },
	    getTierOptions: function getTierOptions() {
	      dispatch((0, _Clients.getTierOptions)());
	    },
	    updateClientProfile: function updateClientProfile(id, obj) {
	      dispatch((0, _Clients.updateClientProfile)(id, obj));
	    },
	    rollbackProfileStatus: function rollbackProfileStatus() {
	      dispatch((0, _Clients.rollbackProfileStatus)());
	    },
	    suspendAndReactivate: function suspendAndReactivate(clientId, status) {
	      dispatch((0, _Clients.suspendAndReactivate)(clientId, status));
	    },
	    getTeamMember: function getTeamMember(id) {
	      dispatch((0, _Clients.getTeamMember)(id));
	    },
	    getAccountManage: function getAccountManage() {
	      dispatch((0, _Clients.getAccountManage)());
	    },
	    getCompanyLogo: function getCompanyLogo(id) {
	      dispatch((0, _Profile.getCompanyLogo)(id));
	    },
	    updateLogo: function updateLogo(id, uuid) {
	      dispatch((0, _Profile.updateLogo)(id, uuid));
	    },
	    setStatus: function setStatus(value) {
	      dispatch((0, _Profile.setStatus)(value));
	    },
	    getClientBusiness: function getClientBusiness(id) {
	      dispatch((0, _Clients.getClientBusiness)(id));
	    },
	    getStates: function getStates() {
	      dispatch((0, _Profile.getStates)());
	    },
	    configInsightsStandard: function configInsightsStandard(id, obj) {
	      dispatch((0, _Clients.configInsightsStandard)(id, obj));
	    },
	    getConfigInsightsStandard: function getConfigInsightsStandard(id) {
	      dispatch((0, _Clients.getConfigInsightsStandard)(id));
	    },
	    resetStandardConfig: function resetStandardConfig() {
	      dispatch((0, _Clients.resetStandardConfig)());
	    }
	  };
	};
	
	var BusinessUnitsDetail = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BusinessUnitsDetail2.default);
	
	exports.default = BusinessUnitsDetail;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _ClientProfile = __webpack_require__(1078);
	
	var _ClientProfile2 = _interopRequireDefault(_ClientProfile);
	
	var _Clients = __webpack_require__(49);
	
	var _Profile = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$clients = state.clients,
	      edit_client_profile = _state$clients.edit_client_profile,
	      industryOptions = _state$clients.industryOptions,
	      tier_options = _state$clients.tier_options,
	      ifEditClientProfileSuccess = _state$clients.ifEditClientProfileSuccess,
	      ifCreateClientProfileSuccessBasic = _state$clients.ifCreateClientProfileSuccessBasic,
	      teamMember_options = _state$clients.teamMember_options,
	      insights_standard_config = _state$clients.insights_standard_config,
	      clientProfileUpdateError = _state$clients.clientProfileUpdateError;
	  var _state$app = state.app,
	      roleName = _state$app.roleName,
	      token = _state$app.token,
	      loginUserDetail = _state$app.loginUserDetail;
	  var account_manager = state.employees.account_manager;
	  var _state$myProfile = state.myProfile,
	      timezone = _state$myProfile.timezone,
	      allstates = _state$myProfile.allstates,
	      ifUpdateSuccess = _state$myProfile.ifUpdateSuccess,
	      company_logo = _state$myProfile.company_logo;
	
	  return {
	    edit_client_profile: edit_client_profile,
	    timezone: timezone,
	    industryOptions: industryOptions,
	    tier_options: tier_options,
	    account_manager: account_manager,
	    roleName: roleName,
	    ifEditClientProfileSuccess: ifEditClientProfileSuccess,
	    allstates: allstates,
	    ifUpdateSuccess: ifUpdateSuccess,
	    token: token,
	    company_logo: company_logo,
	    teamMember_options: teamMember_options,
	    loginUserDetail: loginUserDetail,
	    insights_standard_config: insights_standard_config,
	    ifCreateClientProfileSuccessBasic: ifCreateClientProfileSuccessBasic,
	    clientProfileUpdateError: clientProfileUpdateError
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientProfile: function getClientProfile(id) {
	      dispatch((0, _Clients.getClientProfile)(id));
	    },
	    getTimezone: function getTimezone() {
	      dispatch((0, _Profile.getTimezone)());
	    },
	    getIndustryOptions: function getIndustryOptions() {
	      dispatch((0, _Clients.getIndustryOptions)());
	    },
	    getTierOptions: function getTierOptions() {
	      dispatch((0, _Clients.getTierOptions)());
	    },
	    getAccountManage: function getAccountManage() {
	      dispatch((0, _Clients.getAccountManage)());
	    },
	    updateClientProfile: function updateClientProfile(id, obj) {
	      dispatch((0, _Clients.updateClientProfile)(id, obj));
	    },
	    rollbackProfileStatus: function rollbackProfileStatus() {
	      dispatch((0, _Clients.rollbackProfileStatus)());
	    },
	    suspendAndReactivate: function suspendAndReactivate(clientId, status) {
	      dispatch((0, _Clients.suspendAndReactivate)(clientId, status));
	    },
	    getStates: function getStates() {
	      dispatch((0, _Profile.getStates)());
	    },
	    getTeamMember: function getTeamMember(id) {
	      dispatch((0, _Clients.getTeamMember)(id));
	    },
	    getCompanyLogo: function getCompanyLogo(id) {
	      dispatch((0, _Profile.getCompanyLogo)(id));
	    },
	    updateLogo: function updateLogo(id, uuid) {
	      dispatch((0, _Profile.updateLogo)(id, uuid));
	    },
	    setStatus: function setStatus(value) {
	      dispatch((0, _Profile.setStatus)(value));
	    },
	    configInsightsStandard: function configInsightsStandard(id, obj) {
	      dispatch((0, _Clients.configInsightsStandard)(id, obj));
	    },
	    getConfigInsightsStandard: function getConfigInsightsStandard(id) {
	      dispatch((0, _Clients.getConfigInsightsStandard)(id));
	    },
	    resetStandardConfig: function resetStandardConfig() {
	      dispatch((0, _Clients.resetStandardConfig)());
	    }
	  };
	};
	
	var ClientProfile = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ClientProfile2.default);
	
	exports.default = ClientProfile;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Index = __webpack_require__(1079);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var edit_client_profile = state.clients.edit_client_profile;
	  var roleName = state.app.roleName;
	
	  return {
	    edit_client_profile: edit_client_profile,
	    roleName: roleName
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var EditIndexContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = EditIndexContainer;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _TeamMemberDetail = __webpack_require__(1080);
	
	var _TeamMemberDetail2 = _interopRequireDefault(_TeamMemberDetail);
	
	var _employees = __webpack_require__(119);
	
	var _Api = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$employees = state.employees,
	      tableList = _state$employees.tableList,
	      account_manager = _state$employees.account_manager,
	      roles = _state$employees.roles,
	      clientRoles = _state$employees.clientRoles,
	      ifUpdateRoleSuccess = _state$employees.ifUpdateRoleSuccess,
	      client_assignments = _state$employees.client_assignments,
	      ifReassignSuccess = _state$employees.ifReassignSuccess,
	      suspend_error = _state$employees.suspend_error,
	      client_assignments_error = _state$employees.client_assignments_error,
	      team_member_options = _state$employees.team_member_options;
	  var _state$app = state.app,
	      clients = _state$app.clients,
	      roleId = _state$app.roleId,
	      roleName = _state$app.roleName;
	
	  return {
	    roles: roleId > 50 ? clientRoles : roles,
	    tableList: tableList,
	    ifUpdateRoleSuccess: ifUpdateRoleSuccess,
	    // roleId,
	    // userId,
	    roleName: roleName,
	    suspend_error: suspend_error,
	    account_manager: account_manager.filter(function (item) {
	      return item.id !== 53;
	    }),
	    client_assignments: client_assignments,
	    ifReassignSuccess: ifReassignSuccess,
	    client_assignments_error: client_assignments_error,
	    team_member_options: team_member_options,
	    clients: clients
	    // selected_client: (clients !== undefined && isAdminSelect) && clients[0].id
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getRoles: function getRoles() {
	      dispatch((0, _employees.getRoles)());
	    },
	    getClientRoles: function getClientRoles() {
	      dispatch((0, _employees.getClientRoles)());
	    },
	    updateRole: function updateRole(userId, roleId) {
	      dispatch((0, _employees.updateRole)(userId, roleId));
	    },
	    rollBackUpdateStatus: function rollBackUpdateStatus() {
	      dispatch((0, _employees.rollBackUpdateStatus)());
	    },
	    getTableList: function getTableList(obj, clientId) {
	      dispatch((0, _employees.getTableList)(obj, clientId));
	    },
	    getAccountManage: function getAccountManage(id) {
	      dispatch((0, _employees.getAccountManage)(id));
	    },
	    suspendUser: function suspendUser(userId, status) {
	      // just for the '/edit/Client-Team-Members/detail'
	      // when use `system administrator` log in
	      dispatch(function (dispatch, getState) {
	        var url = 'users/' + userId + '/' + status + '/client';
	
	        (0, _Api.callApi)(dispatch, getState, 'SUSPEND_USER', url, {
	          method: 'POST'
	        });
	      });
	    },
	    getClientAssignments: function getClientAssignments(id) {
	      dispatch((0, _employees.getClientAssignments)(id));
	    },
	    reassingAccountManager: function reassingAccountManager(id, obj) {
	      dispatch((0, _employees.reassingAccountManager)(id, obj));
	    },
	    rollBackReassign: function rollBackReassign() {
	      dispatch((0, _employees.rollBackReassign)());
	    },
	    clearSuspendError: function clearSuspendError() {
	      dispatch((0, _employees.clearSuspendError)());
	    }
	  };
	};
	
	var TeamMemberDetail = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TeamMemberDetail2.default);
	
	exports.default = TeamMemberDetail;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Index = __webpack_require__(1082);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Clients = __webpack_require__(49);
	
	var _Profile = __webpack_require__(164);
	
	var _CreateAccount = __webpack_require__(210);
	
	var _employees = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$clients = state.clients,
	      tableData = _state$clients.tableData,
	      tableAllData = _state$clients.tableAllData,
	      ifInvitationClientSuccess = _state$clients.ifInvitationClientSuccess,
	      invitation_client_msg = _state$clients.invitation_client_msg,
	      industryOptions = _state$clients.industryOptions,
	      ifSendInvitationSuccess = _state$clients.ifSendInvitationSuccess,
	      send_invitation_error_msg = _state$clients.send_invitation_error_msg,
	      tier_options = _state$clients.tier_options,
	      account_manager = _state$clients.account_manager,
	      client_options = _state$clients.client_options,
	      client_names = _state$clients.client_names,
	      ifCreateClientProfileSuccess = _state$clients.ifCreateClientProfileSuccess,
	      createClientProfileMessage = _state$clients.createClientProfileMessage,
	      teamMember_options = _state$clients.teamMember_options,
	      businessUnitOptions = _state$clients.businessUnitOptions,
	      clientId = _state$clients.clientId,
	      ifCreateClientProfileSuccessBasic = _state$clients.ifCreateClientProfileSuccessBasic;
	  var _state$myProfile = state.myProfile,
	      allstates = _state$myProfile.allstates,
	      timezone = _state$myProfile.timezone,
	      ifUpdateSuccess = _state$myProfile.ifUpdateSuccess;
	  var roles = state.employees.roles;
	  var department = state.create_account.department;
	  var _state$app = state.app,
	      loginUserDetail = _state$app.loginUserDetail,
	      token = _state$app.token,
	      roleId = _state$app.roleId,
	      roleName = _state$app.roleName;
	
	  return {
	    clientId: clientId,
	    tableData: tableData,
	    tableAllData: tableAllData,
	    ifInvitationClientSuccess: ifInvitationClientSuccess,
	    invitation_client_msg: invitation_client_msg,
	    industryOptions: industryOptions,
	    ifSendInvitationSuccess: ifSendInvitationSuccess,
	    send_invitation_error_msg: send_invitation_error_msg,
	    tier_options: tier_options,
	    account_manager: account_manager,
	    client_options: client_options,
	    allstates: allstates,
	    timezone: timezone,
	    department: department,
	    roles: roles,
	    ifUpdateSuccess: ifUpdateSuccess,
	    loginUserDetail: loginUserDetail,
	    client_names: client_names,
	    token: token,
	    ifCreateClientProfileSuccess: ifCreateClientProfileSuccess,
	    createClientProfileMessage: createClientProfileMessage,
	    roleId: roleId,
	    roleName: roleName,
	    teamMember_options: teamMember_options,
	    businessUnitOptions: businessUnitOptions,
	    ifCreateClientProfileSuccessBasic: ifCreateClientProfileSuccessBasic
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientsTable: function getClientsTable(obj) {
	      dispatch((0, _Clients.getClientsTable)(obj));
	    },
	    getAllClientsTable: function getAllClientsTable(obj) {
	      dispatch((0, _Clients.getAllClientsTable)(obj));
	    },
	    invitation_client: function invitation_client(obj) {
	      dispatch((0, _Clients.invitation_client)(obj));
	    },
	    getIndustryOptions: function getIndustryOptions() {
	      dispatch((0, _Clients.getIndustryOptions)());
	    },
	    send_invitation: function send_invitation(obj) {
	      dispatch((0, _Clients.send_invitation)(obj));
	    },
	    inviteBusinessMember: function inviteBusinessMember(obj) {
	      dispatch((0, _Clients.inviteBusinessMember)(obj));
	    },
	    getTierOptions: function getTierOptions() {
	      dispatch((0, _Clients.getTierOptions)());
	    },
	    getAccountManage: function getAccountManage() {
	      dispatch((0, _Clients.getAccountManage)());
	    },
	    get_client_options: function get_client_options() {
	      dispatch((0, _Clients.get_client_options)());
	    },
	    rollbackStatus: function rollbackStatus() {
	      dispatch((0, _Clients.rollbackStatus)());
	    },
	    rollbackProfileStatus: function rollbackProfileStatus(value) {
	      dispatch((0, _Clients.rollbackProfileStatus)(value));
	    },
	    search_clients: function search_clients(obj) {
	      dispatch((0, _Clients.search_clients)(obj));
	    },
	    getStates: function getStates() {
	      dispatch((0, _Profile.getStates)());
	    },
	    getTimezone: function getTimezone() {
	      dispatch((0, _Profile.getTimezone)());
	    },
	    getDepartment: function getDepartment() {
	      dispatch((0, _CreateAccount.getDepartment)());
	    },
	    getRoles: function getRoles() {
	      dispatch((0, _employees.getRoles)());
	    },
	    getClientName: function getClientName() {
	      dispatch((0, _Clients.getClientName)());
	    },
	    createClientProfile: function createClientProfile(obj) {
	      dispatch((0, _Clients.createClientProfile)(obj));
	    },
	    getTeamMember: function getTeamMember(id) {
	      dispatch((0, _Clients.getTeamMember)(id));
	    },
	    getBusinessUnitOptions: function getBusinessUnitOptions() {
	      dispatch((0, _Clients.getBusinessUnitOptions)());
	    },
	    configInsightsStandard: function configInsightsStandard(id, obj) {
	      dispatch((0, _Clients.configInsightsStandard)(id, obj));
	    },
	    getConfigInsightsStandard: function getConfigInsightsStandard(id) {
	      dispatch((0, _Clients.getConfigInsightsStandard)(id));
	    }
	  };
	};
	
	var Clients = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = Clients;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Index = __webpack_require__(1085);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _CreateAccount = __webpack_require__(210);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$create_account = state.create_account,
	      ifRequestSuccess = _state$create_account.ifRequestSuccess,
	      department = _state$create_account.department,
	      get_invitation_by_code = _state$create_account.get_invitation_by_code,
	      error = _state$create_account.error,
	      successResponse = _state$create_account.successResponse,
	      uploadSuccessResponse = _state$create_account.uploadSuccessResponse,
	      uploadErrorMsg = _state$create_account.uploadErrorMsg,
	      invitation_error_message = _state$create_account.invitation_error_message;
	
	
	  return {
	    ifRequestSuccess: ifRequestSuccess,
	    department: department,
	    get_invitation_by_code: get_invitation_by_code,
	    error: error,
	    successResponse: successResponse,
	    uploadSuccessResponse: uploadSuccessResponse,
	    uploadErrorMsg: uploadErrorMsg,
	    invitation_error_message: invitation_error_message
	  };
	};
	
	var mapDispathToProps = function mapDispathToProps(dispatch) {
	  return {
	    getInvitationByCode: function getInvitationByCode(code) {
	      dispatch((0, _CreateAccount.getInvitationByCode)(code));
	    },
	    register: function register(code, obj) {
	      dispatch((0, _CreateAccount.register)(code, obj));
	    },
	    upload: function upload(formData, code) {
	      dispatch((0, _CreateAccount.upload)(formData, code));
	    },
	    logout: function logout() {
	      window.localStorage.clear();
	      dispatch((0, _App.logout)());
	    }
	  };
	};
	
	var CreateAccount = (0, _reactRedux.connect)(mapStateToProps, mapDispathToProps)(_Index2.default);
	
	exports.default = CreateAccount;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _App = __webpack_require__(27);
	
	var _CreateAccount = __webpack_require__(210);
	
	var _Index = __webpack_require__(1086);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _CreateClientAccount = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$create_account = state.create_account,
	      get_invitation_by_code = _state$create_account.get_invitation_by_code,
	      invitation_error_message = _state$create_account.invitation_error_message;
	  var _state$create_client_ = state.create_client_account,
	      ifRegisterSuccess = _state$create_client_.ifRegisterSuccess,
	      error_message = _state$create_client_.error_message;
	
	
	  return {
	    get_invitation_by_code: get_invitation_by_code,
	    ifRegisterSuccess: ifRegisterSuccess,
	    error_message: error_message,
	    invitation_error_message: invitation_error_message
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    logout: function logout() {
	      window.localStorage.clear();
	      dispatch((0, _App.logout)());
	    },
	    getInvitationByCode: function getInvitationByCode(code) {
	      dispatch((0, _CreateAccount.getInvitationByCode)(code));
	    },
	    register: function register(code, obj, status) {
	      dispatch((0, _CreateClientAccount.register)(code, obj, status));
	    }
	  };
	};
	
	var CreateClientAccount = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = CreateClientAccount;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Index = __webpack_require__(1091);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _lodash = __webpack_require__(18);
	
	var _employees = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$employees = state.employees,
	      roles = _state$employees.roles,
	      clientRoles = _state$employees.clientRoles,
	      ifSendInviteSuccess = _state$employees.ifSendInviteSuccess,
	      tableList = _state$employees.tableList,
	      ifUpdateSuccess = _state$employees.ifUpdateSuccess,
	      updateErrorText = _state$employees.updateErrorText,
	      sendInvite_error_message = _state$employees.sendInvite_error_message;
	  var _state$app = state.app,
	      userId = _state$app.userId,
	      clients = _state$app.clients,
	      roleId = _state$app.roleId,
	      selected_client = _state$app.selected_client;
	
	  var isAdminSelect = typeof selected_client === "string" && selected_client.indexOf("r-") >= 0;
	  return {
	    roles: roleId > 50 ? clientRoles.filter(function (item) {
	      return item.value !== 53;
	    }) : roles,
	    clientRoles: (0, _lodash.initial)(clientRoles),
	    ifSendInviteSuccess: ifSendInviteSuccess,
	    tableList: tableList.data,
	    origin_tableList: tableList,
	    ifUpdateSuccess: ifUpdateSuccess,
	    updateErrorText: updateErrorText,
	    userId: userId,
	    roleId: roleId,
	    selected_client: isAdminSelect ? clients ? clients[0].id : selected_client : selected_client,
	    sendInvite_error_message: sendInvite_error_message
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getRoles: function getRoles() {
	      dispatch((0, _employees.getRoles)());
	    },
	    getClientRoles: function getClientRoles() {
	      dispatch((0, _employees.getClientRoles)());
	    },
	    sendInvite: function sendInvite(obj) {
	      dispatch((0, _employees.sendInvite)(obj));
	    },
	    sendClientInvite: function sendClientInvite(obj) {
	      dispatch((0, _employees.sendClientUserInvite)(obj));
	    },
	    rollBackStatus: function rollBackStatus() {
	      dispatch((0, _employees.rollBackStatus)());
	    },
	    getTableList: function getTableList(obj, clientId) {
	      dispatch((0, _employees.getTableList)(obj, clientId));
	    },
	    updateProfile: function updateProfile(id, obj) {
	      dispatch((0, _employees.updateProfile)(id, obj));
	    },
	    rollBackUpdateStatus: function rollBackUpdateStatus() {
	      dispatch((0, _employees.rollBackUpdateStatus)());
	    }
	  };
	};
	
	var Employees = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = Employees;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Footer = __webpack_require__(1095);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _App = __webpack_require__(27);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$app = state.app,
	      apiBuildNumber = _state$app.apiBuildNumber,
	      client_info = _state$app.client_info,
	      roleId = _state$app.roleId,
	      selected_client = _state$app.selected_client,
	      optimizeUserDetail = _state$app.optimizeUserDetail,
	      loginUserDetail = _state$app.loginUserDetail;
	  var categories = state.segmentCreation.categories;
	
	  var demographic = categories ? (0, _lodash.tail)(categories) : undefined;
	
	  return {
	    location: {
	      path: state.routing.location.pathname,
	      queryStep: state.routing.location.match ? state.routing.location.match.params.step : "",
	      query: state.routing.location.match ? state.routing.location.match.params : null
	    },
	    apiBuildNumber: apiBuildNumber,
	    client_info: client_info,
	    roleId: roleId,
	    demoAttributes: demographic,
	    selected_client: selected_client,
	    loginUserDetail: loginUserDetail,
	    optimizeUserDetail: optimizeUserDetail,
	    hideFooter: /^\/login/g.test(state.routing.location.pathname) || /^\/resetpassword/g.test(state.routing.location.pathname) || /^\/changepassword/g.test(state.routing.location.pathname)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getAPIBuildNumber: function getAPIBuildNumber() {
	      dispatch((0, _App.getAPIBuildNumber)());
	    }
	  };
	};
	
	var FooterContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Footer2.default);
	
	exports.default = FooterContainer;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _index = __webpack_require__(1102);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Insights = __webpack_require__(58);
	
	var _App = __webpack_require__(27);
	
	var _tags = __webpack_require__(211);
	
	var _Clients = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
		var _state$insights = state.insights,
		    websiteId = _state$insights.websiteId,
		    audience_file_data = _state$insights.audience_file_data,
		    audience_files = _state$insights.audience_files,
		    audience_file_blob = _state$insights.audience_file_blob,
		    tag_info = _state$insights.tag_info,
		    audience_file_error = _state$insights.audience_file_error;
		var client_sites = state.clients.client_sites;
		var _state$app = state.app,
		    selected_client = _state$app.selected_client,
		    clients = _state$app.clients;
	
	
		return {
			websiteId: websiteId,
			client_sites: client_sites,
			selected_client: selected_client,
			audience_file_data: audience_file_data,
			audience_files: audience_files,
			audience_file_blob: audience_file_blob,
			audience_file_error: audience_file_error,
			tag_info: tag_info,
			clients: clients
		};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			getAudienceFilesData: function getAudienceFilesData(tagId) {
				dispatch((0, _Insights.getAudienceFilesData)(tagId));
			},
	
			getTagAudienceFiles: function getTagAudienceFiles(tagId) {
				dispatch((0, _Insights.getTagAudienceFiles)(tagId));
			},
	
			getClientSites: function getClientSites(cid) {
				dispatch((0, _Clients.getClientSites)(cid, true));
			},
	
			setWebsiteId: function setWebsiteId(id) {
				dispatch((0, _Insights.setReportWebSiteId)(id));
			},
	
			downloadTagAudienceFile: function downloadTagAudienceFile(fileId) {
				dispatch((0, _Insights.downloadTagAudienceFile)(fileId));
			},
	
			getTagDetail: function getTagDetail(clientId, tagId) {
				dispatch((0, _tags.fetchTagDetail)(clientId, tagId));
			},
	
			selectClient: function selectClient(clientId) {
				dispatch((0, _App.selectClient)(clientId));
			}
		};
	};
	
	var InsightsAudienceFiles = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_index2.default);
	
	exports.default = InsightsAudienceFiles;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _App = __webpack_require__(27);
	
	var _Clients = __webpack_require__(49);
	
	var _Insights = __webpack_require__(58);
	
	var _FavoritePages = __webpack_require__(1112);
	
	var _FavoritePages2 = _interopRequireDefault(_FavoritePages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$insights = state.insights,
	      websiteId = _state$insights.websiteId,
	      favoritePages = _state$insights.favoritePages,
	      mostPopularPages = _state$insights.mostPopularPages,
	      loadingPopularPages = _state$insights.loadingPopularPages,
	      loadingFavoritePages = _state$insights.loadingFavoritePages,
	      loadingFavoritePagesError = _state$insights.loadingFavoritePagesError;
	  var client_sites = state.clients.client_sites;
	  var _state$app = state.app,
	      selected_client = _state$app.selected_client,
	      clients = _state$app.clients,
	      client_info = _state$app.client_info,
	      token = _state$app.token;
	
	  return {
	    websiteId: websiteId,
	    client_info: client_info,
	    client_sites: client_sites,
	    selected_client: selected_client,
	    clients: clients,
	    location: state.routing.location,
	    favoritePages: favoritePages,
	    loadingFavoritePages: loadingFavoritePages,
	    loadingFavoritePagesError: loadingFavoritePagesError,
	    mostPopularPages: mostPopularPages,
	    loadingPopularPages: loadingPopularPages,
	    token: token
	  };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientInfo: function getClientInfo(cid) {
	      dispatch((0, _App.getClientInfo)(cid));
	    },
	
	    getClientSites: function getClientSites(cid) {
	      dispatch((0, _Clients.getClientSites)(cid, true));
	    },
	
	    setWebsiteId: function setWebsiteId(id) {
	      dispatch((0, _Insights.setReportWebSiteId)(id));
	    },
	
	    selectClient: function selectClient(clientId) {
	      dispatch((0, _App.selectClient)(clientId));
	    },
	
	    fetchFavoritePages: function fetchFavoritePages(tagId) {
	      dispatch((0, _Insights.getFavoritePages)(tagId));
	    },
	
	    fetchMostPopularPages: function fetchMostPopularPages(tagId, dateRange) {
	      dispatch((0, _Insights.getInsightsMostPopularPages)(tagId, dateRange));
	    },
	
	    saveFavoritePage: function saveFavoritePage(tagId, pages) {
	      dispatch((0, _Insights.saveFavoritePage)(tagId, pages));
	    }
	  };
	};
	
	var FavoritePagesContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FavoritePages2.default);
	
	exports.default = FavoritePagesContainer;

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _App = __webpack_require__(27);
	
	var _Clients = __webpack_require__(49);
	
	var _Insights = __webpack_require__(58);
	
	var _PopularPages = __webpack_require__(1114);
	
	var _PopularPages2 = _interopRequireDefault(_PopularPages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$insights = state.insights,
	      websiteId = _state$insights.websiteId,
	      dayRange = _state$insights.dayRange,
	      mostPopularPages = _state$insights.mostPopularPages,
	      loadingPopularPages = _state$insights.loadingPopularPages,
	      loadingPopularPagesError = _state$insights.loadingPopularPagesError,
	      favoriting = _state$insights.favoriting,
	      setFavoriteError = _state$insights.setFavoriteError;
	  var client_sites = state.clients.client_sites;
	  var _state$app = state.app,
	      selected_client = _state$app.selected_client,
	      clients = _state$app.clients,
	      client_info = _state$app.client_info;
	
	  return {
	    websiteId: websiteId,
	    client_info: client_info,
	    client_sites: client_sites,
	    selected_client: selected_client,
	    clients: clients,
	    dayRange: dayRange,
	    location: state.routing.location,
	    mostPopularPages: mostPopularPages,
	    loadingPopularPages: loadingPopularPages,
	    loadingPopularPagesError: loadingPopularPagesError,
	    favoriting: favoriting,
	    setFavoriteError: setFavoriteError
	  };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientInfo: function getClientInfo(cid) {
	      dispatch((0, _App.getClientInfo)(cid));
	    },
	    setDateRange: function setDateRange(str) {
	      dispatch((0, _Insights.setReportDayRange)(str));
	    },
	
	    getClientSites: function getClientSites(cid) {
	      dispatch((0, _Clients.getClientSites)(cid, true));
	    },
	
	    setWebsiteId: function setWebsiteId(id) {
	      dispatch((0, _Insights.setReportWebSiteId)(id));
	    },
	
	    selectClient: function selectClient(clientId) {
	      dispatch((0, _App.selectClient)(clientId));
	    },
	
	    fetchMostPopularPages: function fetchMostPopularPages(tagId, dateRange) {
	      dispatch((0, _Insights.getInsightsMostPopularPages)(tagId, dateRange));
	    },
	
	    fetchFavoritePages: function fetchFavoritePages(tagId) {
	      dispatch((0, _Insights.getFavoritePages)(tagId));
	    },
	
	    setPageFavorite: function setPageFavorite(tagId, dateRange, pageUrl, favorited) {
	      dispatch((0, _Insights.setPageFavorite)(tagId, dateRange, pageUrl, favorited));
	    }
	  };
	};
	
	var PopularPagesContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PopularPages2.default);
	
	exports.default = PopularPagesContainer;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(1108);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactRedux = __webpack_require__(20);
	
	var _Insights = __webpack_require__(58);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _App = __webpack_require__(27);
	
	var _tags = __webpack_require__(211);
	
	var _Clients = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$insights = state.insights,
	      websiteId = _state$insights.websiteId,
	      dayRange = _state$insights.dayRange,
	      granularity = _state$insights.granularity,
	      audience_file_data = _state$insights.audience_file_data,
	      audience_files = _state$insights.audience_files,
	      audience_file_blob = _state$insights.audience_file_blob,
	      tag_info = _state$insights.tag_info,
	      audience_file_error = _state$insights.audience_file_error,
	      segmentDistributionHouseHold = _state$insights.segmentDistributionHouseHold,
	      loadingSegmentDistribution = _state$insights.loadingSegmentDistribution,
	      top5OSBreakDown = _state$insights.top5OSBreakDown,
	      loadingTop5OSBreakdown = _state$insights.loadingTop5OSBreakdown,
	      loadingDistributionDetailReport = _state$insights.loadingDistributionDetailReport,
	      detailDistributionReport = _state$insights.detailDistributionReport,
	      loadDeviceModelReport = _state$insights.loadDeviceModelReport,
	      deviceModelReport = _state$insights.deviceModelReport,
	      loadDeviceTypeReport = _state$insights.loadDeviceTypeReport,
	      deviceTypeReport = _state$insights.deviceTypeReport,
	      send_assist_request_error = _state$insights.send_assist_request_error,
	      request_assist_successful = _state$insights.request_assist_successful,
	      savingScaleAudience = _state$insights.savingScaleAudience,
	      savingScaleAudienceResult = _state$insights.savingScaleAudienceResult,
	      savingScaleAudienceError = _state$insights.savingScaleAudienceError,
	      segmentDistributionSystems = _state$insights.segmentDistributionSystems,
	      savingVisitorsAudienceResult = _state$insights.savingVisitorsAudienceResult,
	      savingVisitorsAudienceError = _state$insights.savingVisitorsAudienceError,
	      savingVisitorsAudience = _state$insights.savingVisitorsAudience,
	      cultureCodeReport = _state$insights.cultureCodeReport,
	      distributionHeatmapData = _state$insights.distributionHeatmapData,
	      distributionHeatmapLoading = _state$insights.distributionHeatmapLoading;
	  var _state$clients = state.clients,
	      client_sites = _state$clients.client_sites,
	      client_tags = _state$clients.client_tags;
	  var _state$app = state.app,
	      selected_client = _state$app.selected_client,
	      clients = _state$app.clients,
	      client_info = _state$app.client_info;
	
	  return {
	    websiteId: websiteId,
	    client_info: client_info,
	    client_sites: client_sites,
	    client_tags: client_tags,
	    selected_client: selected_client,
	    audience_file_data: audience_file_data,
	    audience_files: audience_files,
	    audience_file_blob: audience_file_blob,
	    audience_file_error: audience_file_error,
	    tag_info: tag_info,
	    clients: clients,
	    dayRange: dayRange,
	    granularity: granularity,
	    loadingSegmentDistribution: loadingSegmentDistribution,
	    segmentDistributionHouseHold: segmentDistributionHouseHold,
	    top5OSBreakDown: top5OSBreakDown,
	    loadingTop5OSBreakdown: loadingTop5OSBreakdown,
	    detailDistributionReport: detailDistributionReport,
	    loadingDistributionDetailReport: loadingDistributionDetailReport,
	    loadDeviceModelReport: loadDeviceModelReport,
	    deviceModelReport: deviceModelReport,
	    loadDeviceTypeReport: loadDeviceTypeReport,
	    deviceTypeReport: deviceTypeReport,
	    send_assist_request_error: send_assist_request_error,
	    request_assist_successful: request_assist_successful,
	    location: state.routing.location,
	    savingScaleAudience: savingScaleAudience,
	    savingScaleAudienceResult: savingScaleAudienceResult,
	    savingScaleAudienceError: savingScaleAudienceError,
	    savingVisitorsAudience: savingVisitorsAudience,
	    savingVisitorsAudienceResult: savingVisitorsAudienceResult,
	    savingVisitorsAudienceError: savingVisitorsAudienceError,
	    segmentDistributionSystems: segmentDistributionSystems,
	    cultureCodeReport: cultureCodeReport,
	    distributionHeatmapData: distributionHeatmapData,
	    distributionHeatmapLoading: distributionHeatmapLoading
	  };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    clearCreateScaleAudienceInfo: function clearCreateScaleAudienceInfo() {
	      dispatch((0, _SegmentCreation.clearCreateScaleAudienceInfo)());
	    },
	    clearCreateVisitorsAudienceInfo: function clearCreateVisitorsAudienceInfo() {
	      dispatch((0, _SegmentCreation.clearCreateVisitorsAudienceInfo)());
	    },
	    createScaleAudience: function createScaleAudience(name, tagId, segmentId, dateRange, segments) {
	      dispatch((0, _SegmentCreation.createScaleAudience)(name, tagId, segmentId, dateRange, segments));
	    },
	    createVisitorAudience: function createVisitorAudience(name, tagId, segmentId, dateRange, segments, granularity, page) {
	      dispatch((0, _SegmentCreation.createVisitorAudience)(name, tagId, segmentId, dateRange, segments, granularity, page));
	    },
	    getClientInfo: function getClientInfo(cid) {
	      dispatch((0, _App.getClientInfo)(cid));
	    },
	    getClientTags: function getClientTags(clientId) {
	      dispatch((0, _Clients.getClientTags)(clientId));
	    },
	    getAudienceFilesData: function getAudienceFilesData(tagId) {
	      dispatch((0, _Insights.getAudienceFilesData)(tagId));
	    },
	    setDateRange: function setDateRange(str) {
	      dispatch((0, _Insights.setReportDayRange)(str));
	    },
	    setGranularity: function setGranularity(str) {
	      dispatch((0, _Insights.setReportGranularity)(str));
	    },
	    getTagAudienceFiles: function getTagAudienceFiles(tagId) {
	      dispatch((0, _Insights.getTagAudienceFiles)(tagId));
	    },
	
	    getClientSites: function getClientSites(cid) {
	      dispatch((0, _Clients.getClientSites)(cid, true));
	    },
	
	    setWebsiteId: function setWebsiteId(id) {
	      dispatch((0, _Insights.setReportWebSiteId)(id));
	    },
	
	    downloadTagAudienceFile: function downloadTagAudienceFile(fileId) {
	      dispatch((0, _Insights.downloadTagAudienceFile)(fileId));
	    },
	
	    getTagDetail: function getTagDetail(clientId, tagId) {
	      dispatch((0, _tags.fetchTagDetail)(clientId, tagId));
	    },
	
	    selectClient: function selectClient(clientId) {
	      dispatch((0, _App.selectClient)(clientId));
	    },
	
	    getSegmentDistribution: function getSegmentDistribution(tagId, segment, dateRange, granularity, page) {
	      dispatch((0, _Insights.getSegmentDistribution)(tagId, segment, dateRange, granularity, page));
	    },
	    getSegmentReportTop5OS: function getSegmentReportTop5OS(tagId, segment, dateRange, segmentIds, granularity, page) {
	      dispatch((0, _Insights.getSegmentReportTop5OS)(tagId, segment, dateRange, segmentIds, granularity, page));
	    },
	    getSegmentDistributionDetailReport: function getSegmentDistributionDetailReport(tagId, segment, dateRange, segmentIds, page, granularity) {
	      dispatch((0, _Insights.getSegmentDistributionDetailReport)(tagId, segment, dateRange, segmentIds, page, granularity));
	    },
	    getSegmentDistributionDeviceModelReport: function getSegmentDistributionDeviceModelReport(tagId, segment, dateRange, segmentIds, granularity, page) {
	      dispatch((0, _Insights.getSegmentDistributionDeviceModelReport)(tagId, segment, dateRange, segmentIds, granularity, page));
	    },
	    getSegmentDistributionDeviceTypeReport: function getSegmentDistributionDeviceTypeReport(tagId, segment, dateRange, segmentIds, granularity, page) {
	      dispatch((0, _Insights.getSegmentDistributionDeviceTypeReport)(tagId, segment, dateRange, segmentIds, granularity, page));
	    },
	    sendAssistRequest: function sendAssistRequest(data) {
	      dispatch((0, _Insights.sendAssistRequest)(data));
	    },
	    getSegmentDistributionSystems: function getSegmentDistributionSystems(tagId, callback) {
	      dispatch((0, _Insights.getSegmentDistributionSystems)(tagId, callback));
	    },
	    getCultureCodeReport: function getCultureCodeReport(tagId, segment, dateRange, segmentIds, page, granularity) {
	      dispatch((0, _Insights.getCultureCodeReport)(tagId, segment, dateRange, segmentIds, page, granularity));
	    },
	    getDistributionHeatMapData: function getDistributionHeatMapData(tagId, segment, dateRange, segmentIds, page, granularity) {
	      dispatch((0, _Insights.getDistributionHeatMapData)(tagId, segment, dateRange, segmentIds, page, granularity));
	    }
	  };
	};
	
	var SegmentDistributionContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_index2.default);
	
	exports.default = SegmentDistributionContainer;

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _summary = __webpack_require__(1118);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _App = __webpack_require__(27);
	
	var _reactRedux = __webpack_require__(20);
	
	var _Clients = __webpack_require__(49);
	
	var _Insights = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$insights = state.insights,
	      websiteId = _state$insights.websiteId,
	      dayRange = _state$insights.dayRange,
	      granularity = _state$insights.granularity,
	      send_assist_request_error = _state$insights.send_assist_request_error,
	      overviewTrafficReport = _state$insights.overviewTrafficReport,
	      statsByTime = _state$insights.statsByTime,
	      request_assist_successful = _state$insights.request_assist_successful,
	      domesticConsumerVisitsReport = _state$insights.domesticConsumerVisitsReport,
	      domesticBusinessVisitsReport = _state$insights.domesticBusinessVisitsReport,
	      loadingOverviewTraffic = _state$insights.loadingOverviewTraffic,
	      loadingDomesticConsumerVisits = _state$insights.loadingDomesticConsumerVisits,
	      loadingDomesticBusiness = _state$insights.loadingDomesticBusiness,
	      loadingStatsByTime = _state$insights.loadingStatsByTime;
	  var _state$app = state.app,
	      selected_client = _state$app.selected_client,
	      clients = _state$app.clients,
	      client_info = _state$app.client_info;
	  var client_sites = state.clients.client_sites;
	
	  return {
	    websiteId: websiteId,
	    dayRange: dayRange,
	    granularity: granularity,
	    selected_client: selected_client,
	    clients: clients,
	    client_sites: client_sites,
	    send_assist_request_error: send_assist_request_error,
	    request_assist_successful: request_assist_successful,
	    overviewTrafficReport: overviewTrafficReport,
	    domesticConsumerVisitsReport: domesticConsumerVisitsReport,
	    statsByTime: statsByTime,
	    domesticBusinessVisitsReport: domesticBusinessVisitsReport,
	    loadingOverviewTraffic: loadingOverviewTraffic,
	    loadingDomesticBusiness: loadingDomesticBusiness,
	    loadingDomesticConsumerVisits: loadingDomesticConsumerVisits,
	    loadingStatsByTime: loadingStatsByTime,
	    client_info: client_info
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientSites: function getClientSites(cid) {
	      dispatch((0, _Clients.getClientSites)(cid, true));
	    },
	
	    getClientProfile: function getClientProfile(cid) {
	      dispatch((0, _Clients.getClientProfile)(cid));
	    },
	
	    setWebsiteId: function setWebsiteId(id) {
	      dispatch((0, _Insights.setReportWebSiteId)(id));
	      dispatch((0, _Insights.clearAllDomesticStats)());
	    },
	    selectClient: function selectClient(clientId) {
	      dispatch((0, _App.selectClient)(clientId));
	    },
	    setDateRange: function setDateRange(str) {
	      dispatch((0, _Insights.setReportDayRange)(str));
	      dispatch((0, _Insights.clearAllDomesticStats)());
	    },
	    setGranularity: function setGranularity(str) {
	      dispatch((0, _Insights.setReportGranularity)(str));
	    },
	    sendAssistRequest: function sendAssistRequest(data) {
	      dispatch((0, _Insights.sendAssistRequest)(data));
	    },
	
	    getOverviewTrafficeReport: function getOverviewTrafficeReport(tagId, dateRange) {
	      dispatch((0, _Insights.getOverviewTrafficeReport)(tagId, dateRange));
	    },
	
	    getDomesticConsumerStats: function getDomesticConsumerStats(tagId, dateRange, granularity) {
	      dispatch((0, _Insights.getDomesticConsumerStats)(tagId, dateRange, granularity));
	    },
	
	    getStatsByTime: function getStatsByTime(wid, dateRange, page, type) {
	      dispatch((0, _Insights.getStatsByTime)(wid, dateRange, page, type));
	    },
	
	    getDomesticBusinessStats: function getDomesticBusinessStats(tagId, granularity, dateRange) {
	      dispatch((0, _Insights.getDomesticBusinessStats)(tagId, dateRange, granularity));
	    },
	
	    clearAllDomesticStats: function clearAllDomesticStats() {
	      dispatch((0, _Insights.clearAllDomesticStats)());
	    }
	  };
	};
	
	var InsightSummaryContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_summary2.default);
	
	exports.default = InsightSummaryContainer;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tags = __webpack_require__(1121);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _reactRedux = __webpack_require__(20);
	
	var _Insights = __webpack_require__(58);
	
	var _tags3 = __webpack_require__(211);
	
	var _Clients = __webpack_require__(49);
	
	var _App = __webpack_require__(27);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$insights = state.insights,
	      websiteId = _state$insights.websiteId,
	      dayRange = _state$insights.dayRange,
	      website_name = _state$insights.website_name,
	      website_url = _state$insights.website_url,
	      tag_info = _state$insights.tag_info,
	      tag_error_message = _state$insights.tag_error_message,
	      tag_variables = _state$insights.tag_variables,
	      campaign_name = _state$insights.campaign_name;
	  var _state$app = state.app,
	      selected_client = _state$app.selected_client,
	      client_info = _state$app.client_info,
	      clients = _state$app.clients,
	      roleId = _state$app.roleId;
	  var _state$clients = state.clients,
	      client_sites = _state$clients.client_sites,
	      client_tags = _state$clients.client_tags;
	
	  return {
	    websiteId: websiteId,
	    selected_client: selected_client,
	    client_sites: client_sites,
	    dayRange: dayRange,
	    client_info: client_info,
	    clients: clients,
	    website_name: website_name,
	    website_url: website_url,
	    campaign_name: campaign_name,
	    tag_info: tag_info,
	    tag_variables: tag_variables,
	    tag_error_message: tag_error_message,
	    client_tags: client_tags,
	    roleId: roleId
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientSites: function getClientSites(cid) {
	      dispatch((0, _Clients.getClientSites)(cid, true));
	    },
	
	    setWebsiteId: function setWebsiteId(id) {
	      dispatch((0, _Insights.setReportWebSiteId)(id));
	    },
	
	    setDateRange: function setDateRange(str) {
	      dispatch((0, _Insights.setReportDayRange)(str));
	    },
	
	    setTagWebsiteName: function setTagWebsiteName(val) {
	      dispatch((0, _tags3.setTagWebsiteName)(val));
	    },
	
	    setTagWebsiteURL: function setTagWebsiteURL(val) {
	      dispatch((0, _tags3.setTagWebsiteURL)(val));
	    },
	
	    setTagCampaignName: function setTagCampaignName(val) {
	      dispatch((0, _tags3.setTagCampaignName)(val));
	    },
	
	    generateTag: function generateTag(clientId, val) {
	      dispatch((0, _tags3.clearTagError)());
	      dispatch((0, _tags3.generateTag)(clientId, val));
	    },
	
	    saveTag: function saveTag(clientId, uuid, val) {
	      //dispatch(saveTag(clientId, uuid, val))
	      dispatch((0, _Clients.getClientTags)(clientId));
	      dispatch((0, _reactRouterRedux.push)('/insights/tags/list'));
	    },
	
	    clearInsightTagInfo: function clearInsightTagInfo() {
	      dispatch((0, _tags3.clearInsightTagInfo)());
	    },
	
	    clearInsightTagInfoAndRefreh: function clearInsightTagInfoAndRefreh(clientId) {
	      dispatch((0, _tags3.clearInsightTagInfo)());
	      dispatch((0, _Clients.getClientTags)(clientId));
	      dispatch((0, _reactRouterRedux.push)('/insights/tags/list'));
	    },
	
	    getClientTags: function getClientTags(clientId) {
	      dispatch((0, _Clients.getClientTags)(clientId));
	    },
	    clearTagError: function clearTagError() {
	      dispatch((0, _tags3.clearTagError)());
	    },
	    createNewTag: function createNewTag() {
	      dispatch((0, _tags3.clearTagError)());
	      dispatch((0, _tags3.clearInsightTagInfo)());
	      dispatch((0, _reactRouterRedux.push)('/insights/tags/create'));
	    },
	    getTagDetail: function getTagDetail(clientId, tagId) {
	      dispatch((0, _tags3.getTagDetail)(clientId, tagId, undefined));
	    },
	    getClientInfo: function getClientInfo(id) {
	      dispatch((0, _App.getClientInfo)(id));
	    }
	  };
	};
	
	var InsightTagsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_tags2.default);
	
	exports.default = InsightTagsContainer;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _website = __webpack_require__(1130);
	
	var _website2 = _interopRequireDefault(_website);
	
	var _reactRedux = __webpack_require__(20);
	
	var _Insights = __webpack_require__(58);
	
	var _Clients = __webpack_require__(49);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$insights = state.insights,
	      statsByDevice = _state$insights.statsByDevice,
	      statsByDeviceModel = _state$insights.statsByDeviceModel,
	      statsByOsType = _state$insights.statsByOsType,
	      statsByTime = _state$insights.statsByTime,
	      statsByPopularPages = _state$insights.statsByPopularPages,
	      statsByRegionalTraffic = _state$insights.statsByRegionalTraffic,
	      statsByTimeOfDay = _state$insights.statsByTimeOfDay,
	      domesticVisitsSummary = _state$insights.domesticVisitsSummary,
	      statsByPrimaryDevices = _state$insights.statsByPrimaryDevices,
	      statsByDemographic = _state$insights.statsByDemographic,
	      statsTopAttributes = _state$insights.statsTopAttributes,
	      websiteId = _state$insights.websiteId,
	      dayRange = _state$insights.dayRange,
	      granularity = _state$insights.granularity,
	      heatMapPoints = _state$insights.heatMapPoints,
	      send_assist_request_error = _state$insights.send_assist_request_error,
	      request_assist_successful = _state$insights.request_assist_successful,
	      domesticBusinessVisitsReport = _state$insights.domesticBusinessVisitsReport,
	      top20FrequencyBusinesses = _state$insights.top20FrequencyBusinesses,
	      loadingDomesticVisitsSummary = _state$insights.loadingDomesticVisitsSummary,
	      loadingStatsByDeviceType = _state$insights.loadingStatsByDeviceType,
	      loadingStatsByTime = _state$insights.loadingStatsByTime,
	      loadingStatsByPopularPage = _state$insights.loadingStatsByPopularPage,
	      loadingStatsByRegionalTraffic = _state$insights.loadingStatsByRegionalTraffic,
	      loadingStatsByTimeOfDay = _state$insights.loadingStatsByTimeOfDay,
	      loadingStatsByDemographic = _state$insights.loadingStatsByDemographic,
	      loadingStatsByPrimaryDevices = _state$insights.loadingStatsByPrimaryDevices,
	      loadingStatsTopAttributes = _state$insights.loadingStatsTopAttributes,
	      loadingTop20FrequencyBusinesses = _state$insights.loadingTop20FrequencyBusinesses,
	      loadingStatsByDeviceModel = _state$insights.loadingStatsByDeviceModel,
	      loadingStatsByOsType = _state$insights.loadingStatsByOsType,
	      states = _state$insights.states;
	  var _state$app = state.app,
	      selected_client = _state$app.selected_client,
	      clients = _state$app.clients,
	      client_info = _state$app.client_info,
	      roleId = _state$app.roleId;
	  var _state$clients = state.clients,
	      client_sites = _state$clients.client_sites,
	      client_tags = _state$clients.client_tags;
	
	  return {
	    websiteId: websiteId,
	    client_info: client_info,
	    selected_client: selected_client,
	    clients: clients,
	    client_sites: client_sites,
	    client_tags: client_tags,
	    dayRange: dayRange,
	    granularity: granularity,
	    statsByDevice: statsByDevice,
	    statsByDeviceModel: statsByDeviceModel,
	    statsByOsType: statsByOsType,
	    statsByTime: statsByTime,
	    statsByPopularPages: statsByPopularPages,
	    statsByRegionalTraffic: statsByRegionalTraffic,
	    statsByTimeOfDay: statsByTimeOfDay,
	    statsByDemographic: statsByDemographic,
	    statsByPrimaryDevices: statsByPrimaryDevices,
	    statsTopAttributes: statsTopAttributes,
	    heatMapPoints: heatMapPoints,
	    domesticVisitsSummary: domesticVisitsSummary,
	    domesticBusinessVisitsReport: domesticBusinessVisitsReport,
	    send_assist_request_error: send_assist_request_error,
	    request_assist_successful: request_assist_successful,
	    top20FrequencyBusinesses: top20FrequencyBusinesses,
	    loadingDomesticVisitsSummary: loadingDomesticVisitsSummary,
	    loadingStatsByDemographic: loadingStatsByDemographic,
	    loadingStatsByDeviceType: loadingStatsByDeviceType,
	    loadingStatsByTime: loadingStatsByTime,
	    loadingStatsByPopularPage: loadingStatsByPopularPage,
	    loadingStatsByRegionalTraffic: loadingStatsByRegionalTraffic,
	    loadingStatsByTimeOfDay: loadingStatsByTimeOfDay,
	    loadingStatsTopAttributes: loadingStatsTopAttributes,
	    loadingStatsByPrimaryDevices: loadingStatsByPrimaryDevices,
	    loadingTop20FrequencyBusinesses: loadingTop20FrequencyBusinesses,
	    loadingStatsByOsType: loadingStatsByOsType,
	    loadingStatsByDeviceModel: loadingStatsByDeviceModel,
	    roleId: roleId,
	    states: states
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    },
	    getClientInfo: function getClientInfo(id) {
	      dispatch((0, _App.getClientInfo)(id));
	    },
	    getClientTags: function getClientTags(clientId) {
	      dispatch((0, _Clients.getClientTags)(clientId));
	    },
	    getStatsByDeviceType: function getStatsByDeviceType(wid, dateRange, type, popUrl) {
	      dispatch((0, _Insights.getStatsByDeviceType)(wid, dateRange, type, popUrl));
	    },
	
	    getStatsByDeviceModel: function getStatsByDeviceModel(wid, dateRange, type) {
	      dispatch((0, _Insights.getStatsByDeviceModel)(wid, dateRange, type));
	    },
	
	    getStatsByOsType: function getStatsByOsType(wid, dateRange, type) {
	      dispatch((0, _Insights.getStatsByOsType)(wid, dateRange, type));
	    },
	
	    getStatsByTime: function getStatsByTime(wid, dateRange, page, type) {
	      dispatch((0, _Insights.getStatsByTime)(wid, dateRange, page, type));
	    },
	
	    getStatsByPopularPages: function getStatsByPopularPages(wid, dateRange, type) {
	      dispatch((0, _Insights.getStatsByPopularPage)(wid, dateRange, type));
	    },
	
	    getStatsByRegionalTraffic: function getStatsByRegionalTraffic(wid, dateRange, page, type) {
	      dispatch((0, _Insights.getStatsByRegionalTraffic)(wid, dateRange, page, type));
	    },
	
	    getStatsByTimeOfDay: function getStatsByTimeOfDay(wid, dateRange, page, type) {
	      dispatch((0, _Insights.getStatsByTimeofDay)(wid, dateRange, page, type));
	    },
	
	    getStatsByDemographic: function getStatsByDemographic(wid, dateRange, page, type, granularity) {
	      dispatch((0, _Insights.getStatsByDemographic)(wid, dateRange, page, type, granularity));
	    },
	
	    getStatsByPrimaryDevices: function getStatsByPrimaryDevices(wid, dateRange, page) {
	      dispatch((0, _Insights.getStatsByPrimaryDevices)(wid, dateRange, page));
	    },
	
	    getStatsTopAttributes: function getStatsTopAttributes(wid, dateRange, page, type, granularity) {
	      dispatch((0, _Insights.getStatsTopAttributes)(wid, dateRange, page, type, granularity));
	    },
	
	    getClientSites: function getClientSites(cid) {
	      dispatch((0, _Clients.getClientSites)(cid, true));
	    },
	
	    clearAllStats: function clearAllStats() {
	      dispatch((0, _Insights.clearAllStats)());
	    },
	
	    setWebsiteId: function setWebsiteId(id) {
	      dispatch((0, _Insights.setReportWebSiteId)(id));
	    },
	
	    setDateRange: function setDateRange(str) {
	      dispatch((0, _Insights.setReportDayRange)(str));
	    },
	
	    setGranularity: function setGranularity(str) {
	      dispatch((0, _Insights.setReportGranularity)(str));
	    },
	
	    getHeatMapData: function getHeatMapData(wid, dateRange, page, type) {
	      dispatch((0, _Insights.getHeatMapData)(wid, dateRange, page, type));
	    },
	
	    getDomesticVisits: function getDomesticVisits(tagId, dateRange, type, page) {
	      dispatch((0, _Insights.getDomesticVisits)(tagId, dateRange, type, page));
	    },
	
	    sendAssistRequest: function sendAssistRequest(data) {
	      dispatch((0, _Insights.sendAssistRequest)(data));
	    },
	
	    getDomesticBusinessStats: function getDomesticBusinessStats(tagId, granularity, dateRange) {
	      dispatch((0, _Insights.getDomesticBusinessStats)(tagId, dateRange, granularity));
	    },
	
	    getTop20FrequencyBusiness: function getTop20FrequencyBusiness(tagId, dateRange) {
	      dispatch((0, _Insights.getTop20FrequencyBusiness)(tagId, dateRange));
	    },
	    getStates: function getStates(siteId, dateRange, page, reportType) {
	      dispatch((0, _Insights.getStates)(siteId, dateRange, page, reportType));
	    }
	  };
	};
	
	var WebsiteVisitsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_website2.default);
	
	exports.default = WebsiteVisitsContainer;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _InsightsInfo = __webpack_require__(507);
	
	var _Index = __webpack_require__(1132);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$insightsInfo = state.insightsInfo,
	      search_results = _state$insightsInfo.search_results,
	      all_search_results = _state$insightsInfo.all_search_results;
	
	  return {
	    clients: state.app.clients,
	    search_results: search_results,
	    all_search_results: all_search_results
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getSearch: function getSearch(obj) {
	      dispatch((0, _InsightsInfo.getSearch)(obj));
	    },
	    getAllSearch: function getAllSearch(obj) {
	      dispatch((0, _InsightsInfo.getAllSearch)(obj));
	    },
	    resetData: function resetData() {
	      dispatch((0, _InsightsInfo.resetData)());
	    }
	  };
	};
	
	var InsightsInfo = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = InsightsInfo;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Index = __webpack_require__(1140);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _SegmentDetail = __webpack_require__(165);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _SegmentList = __webpack_require__(118);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$segmentDetail = state.segmentDetail,
	      segment_summary = _state$segmentDetail.segment_summary,
	      rules_count = _state$segmentDetail.rules_count,
	      request_activation_error = _state$segmentDetail.request_activation_error,
	      request_activation_success = _state$segmentDetail.request_activation_success;
	  var _state$segmentCreatio = state.segmentCreation,
	      categories = _state$segmentCreatio.categories,
	      value_typehead = _state$segmentCreatio.value_typehead,
	      audience_total_count = _state$segmentCreatio.audience_total_count;
	  var _state$segmentList = state.segmentList,
	      selectedSegmentSetArray = _state$segmentList.selectedSegmentSetArray,
	      segment_list_active = _state$segmentList.segment_list_active,
	      active_segment_attributes = _state$segmentList.active_segment_attributes,
	      recordActiveQueryParamsObj = _state$segmentList.recordActiveQueryParamsObj,
	      create_campaign = _state$segmentList.create_campaign;
	  var _state$app = state.app,
	      client_info = _state$app.client_info,
	      parent_client = _state$app.parent_client,
	      roleId = _state$app.roleId;
	  var selected_client = state.app.selected_client;
	
	  return {
	    segment_summary: segment_summary,
	    categories: categories,
	    client_info: client_info,
	    parent_client: parent_client,
	    value_typehead: value_typehead,
	    selectedSegmentSetArray: selectedSegmentSetArray,
	    segment_list_active: segment_list_active,
	    active_segment_attributes: active_segment_attributes,
	    segment_active_creation: state.segmentCreation,
	    selected_client: selected_client,
	    recordActiveQueryParamsObj: recordActiveQueryParamsObj,
	    create_campaign: create_campaign,
	    rules_count: rules_count,
	    audience_total_count: audience_total_count,
	    roleId: roleId,
	    request_activation_error: request_activation_error,
	    request_activation_success: request_activation_success
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchSegmentSummary: function fetchSegmentSummary(id) {
	      dispatch((0, _SegmentDetail.fetchSegmentSummary)(id));
	    },
	    loadAttributes: function loadAttributes(cid) {
	      dispatch((0, _SegmentCreation.loadAttributes)(cid));
	    },
	    getSegmentWithRules: function getSegmentWithRules(id) {
	      dispatch((0, _SegmentList.getSegmentWithRules)(id));
	    },
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    },
	    getClientInfo: function getClientInfo(id) {
	      dispatch((0, _App.getClientInfo)(id));
	    },
	    clearSegmentSummary: function clearSegmentSummary() {
	      dispatch((0, _SegmentDetail.clearSegmentSummary)());
	    },
	    archiveSegment: function archiveSegment(id) {
	      dispatch((0, _SegmentList.archiveSegment)(id));
	    },
	    getSegmentList: function getSegmentList(data) {
	      dispatch((0, _SegmentList.getSegmentList)(data));
	    },
	    selectedSegment: function selectedSegment(setArray) {
	      dispatch((0, _SegmentList.selectedSegment)(setArray));
	    },
	    getCreateCampaign: function getCreateCampaign(id, data) {
	      dispatch((0, _SegmentList.getCreateCampaign)(id, data));
	    },
	    rollbackRequestSuccessToFalse: function rollbackRequestSuccessToFalse(val) {
	      return dispatch((0, _SegmentList.rollbackRequestSuccessToFalse)(val));
	    },
	    getSegmentRulesCounts: function getSegmentRulesCounts(data, sid) {
	      dispatch((0, _SegmentDetail.getSegmentRulesCounts)(data, sid));
	    },
	    getSegmentTotalCounts: function getSegmentTotalCounts(data, sid) {
	      dispatch((0, _SegmentCreation.getAudienceCount)(data, sid));
	    },
	    requestActivation: function requestActivation(id, clientId, subject, comment) {
	      dispatch((0, _SegmentDetail.requestActivation)(id, clientId, subject, comment));
	    }
	  };
	};
	
	var SegmentDetail = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = SegmentDetail;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(1136);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactRedux = __webpack_require__(20);
	
	var _Profile = __webpack_require__(164);
	
	var _Clients = __webpack_require__(49);
	
	var _CreateAccount = __webpack_require__(210);
	
	var _employees = __webpack_require__(119);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$myProfile = state.myProfile,
	      data = _state$myProfile.data,
	      allstates = _state$myProfile.allstates,
	      timezone = _state$myProfile.timezone,
	      company_logo = _state$myProfile.company_logo,
	      ifUpdateSuccess = _state$myProfile.ifUpdateSuccess,
	      update_logo_msg = _state$myProfile.update_logo_msg,
	      update_photo_msg = _state$myProfile.update_photo_msg,
	      change_password_error_msg = _state$myProfile.change_password_error_msg,
	      update_error_message = _state$myProfile.update_error_message;
	  var department = state.create_account.department;
	  var roles = state.employees.roles;
	  var _state$app = state.app,
	      loginUserDetail = _state$app.loginUserDetail,
	      token = _state$app.token,
	      avatar = _state$app.avatar,
	      roleName = _state$app.roleName;
	  var industryOptions = state.clients.industryOptions;
	
	  return {
	    data: data,
	    roles: roles,
	    department: department,
	    loginUserDetail: loginUserDetail,
	    allstates: allstates,
	    timezone: timezone,
	    company_logo: company_logo,
	    token: token,
	    ifUpdateSuccess: ifUpdateSuccess,
	    avatar: avatar,
	    update_logo_msg: update_logo_msg,
	    update_photo_msg: update_photo_msg,
	    change_password_error_msg: change_password_error_msg,
	    update_error_message: update_error_message,
	    roleName: roleName,
	    industryOptions: industryOptions
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getDepartment: function getDepartment() {
	      dispatch((0, _CreateAccount.getDepartment)());
	    },
	    getRoles: function getRoles() {
	      dispatch((0, _employees.getRoles)());
	    },
	    getStates: function getStates() {
	      dispatch((0, _Profile.getStates)());
	    },
	    getTimezone: function getTimezone() {
	      dispatch((0, _Profile.getTimezone)());
	    },
	    getCompanyLogo: function getCompanyLogo(id) {
	      dispatch((0, _Profile.getCompanyLogo)(id));
	    },
	    updateProfile: function updateProfile(obj) {
	      dispatch((0, _Profile.updateProfile)(obj));
	    },
	    setStatus: function setStatus(value) {
	      dispatch((0, _Profile.setStatus)(value));
	    },
	    getUserAvatar: function getUserAvatar(imgFilename) {
	      dispatch((0, _App.getUserAvatar)(imgFilename));
	    },
	    getCurrentUserProfile: function getCurrentUserProfile() {
	      dispatch((0, _App.getCurrentUserProfile)());
	    },
	    updateLogo: function updateLogo(id, uuid) {
	      dispatch((0, _Profile.updateLogo)(id, uuid));
	    },
	    updatePhoto: function updatePhoto(uuid) {
	      dispatch((0, _Profile.updatePhoto)(uuid));
	    },
	    changePassword: function changePassword(obj) {
	      dispatch((0, _Profile.changePassword)(obj));
	    },
	    getIndustryOptions: function getIndustryOptions() {
	      dispatch((0, _Clients.getIndustryOptions)());
	    }
	  };
	};
	
	var Myprofile = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_index2.default);
	
	exports.default = Myprofile;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _index = __webpack_require__(1053);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _isEmpty = __webpack_require__(22);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _SegmentDetail = __webpack_require__(165);
	
	var _SegmentList = __webpack_require__(118);
	
	var _Insights = __webpack_require__(58);
	
	var _App = __webpack_require__(27);
	
	var _tail = __webpack_require__(418);
	
	var _tail2 = _interopRequireDefault(_tail);
	
	var _uniqBy = __webpack_require__(302);
	
	var _uniqBy2 = _interopRequireDefault(_uniqBy);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$segmentCreatio = state.segmentCreation,
	      categories = _state$segmentCreatio.categories,
	      value_typehead = _state$segmentCreatio.value_typehead,
	      selected_segments = _state$segmentCreatio.selected_segments,
	      segment_name = _state$segmentCreatio.segment_name,
	      allstates = _state$segmentCreatio.allstates,
	      userSelectedInfo = _state$segmentCreatio.userSelectedInfo,
	      selected_city = _state$segmentCreatio.selected_city,
	      selected_county = _state$segmentCreatio.selected_county,
	      selected_dma = _state$segmentCreatio.selected_dma,
	      isNameDuplicated = _state$segmentCreatio.isNameDuplicated,
	      selected_state = _state$segmentCreatio.selected_state,
	      allcities = _state$segmentCreatio.allcities,
	      plotted_values = _state$segmentCreatio.plotted_values,
	      zipcode = _state$segmentCreatio.zipcode,
	      catAudienceCounts = _state$segmentCreatio.catAudienceCounts,
	      selected_make = _state$segmentCreatio.selected_make,
	      selected_model = _state$segmentCreatio.selected_model,
	      selected_culture_region = _state$segmentCreatio.selected_culture_region,
	      selected_culture_locale = _state$segmentCreatio.selected_culture_locale,
	      copy_segment_name = _state$segmentCreatio.copy_segment_name,
	      segment_id = _state$segmentCreatio.segment_id,
	      rules_id = _state$segmentCreatio.rules_id,
	      all_state_cities = _state$segmentCreatio.all_state_cities,
	      ifLoading = _state$segmentCreatio.ifLoading,
	      make_active_arr = _state$segmentCreatio.make_active_arr,
	      region_active_arr = _state$segmentCreatio.region_active_arr,
	      audience_total_count = _state$segmentCreatio.audience_total_count,
	      zipcode_audience_count = _state$segmentCreatio.zipcode_audience_count,
	      save_segment_success = _state$segmentCreatio.save_segment_success,
	      save_segment_error_errorNo = _state$segmentCreatio.save_segment_error_errorNo,
	      send_assist_request_error = _state$segmentCreatio.send_assist_request_error,
	      request_assist_successful = _state$segmentCreatio.request_assist_successful,
	      save_segment_error_message = _state$segmentCreatio.save_segment_error_message,
	      check_client_limit = _state$segmentCreatio.check_client_limit,
	      targetHouseholdsOnly = _state$segmentCreatio.targetHouseholdsOnly,
	      counties = _state$segmentCreatio.counties,
	      dmas = _state$segmentCreatio.dmas;
	  var active_segment_attributes = state.segmentList.active_segment_attributes;
	  var _state$app = state.app,
	      selected_client = _state$app.selected_client,
	      userId = _state$app.userId,
	      roleId = _state$app.roleId,
	      clients = _state$app.clients;
	
	  var demographic = categories ? (0, _tail2.default)(categories) : undefined;
	  var geographic = categories ? categories[0] : undefined;
	  var selectedClient = (0, _isEmpty2.default)(clients) ? [] : clients.find(function (item) {
	    return parseInt(item.id, 10) === parseInt(selected_client, 10);
	  });
	  return {
	    clients: clients,
	    client_info: state.app.client_info,
	    geoAttributes: geographic,
	    demoAttributes: (0, _uniqBy2.default)(demographic, function (d) {
	      return d.id;
	    }),
	    selected_segments: selected_segments,
	    userId: userId,
	    roleId: roleId,
	    selected_client: selected_client,
	    selected_client_name: selectedClient ? selectedClient.name : "",
	    allstates: allstates,
	    userSelectedInfo: userSelectedInfo,
	    selected_city: selected_city,
	    selected_state: selected_state,
	    selected_county: selected_county,
	    selected_dma: selected_dma,
	    segment_name: segment_name,
	    value_typehead: value_typehead,
	    allcities: allcities,
	    plotted_values: plotted_values,
	    zipcode: zipcode,
	    catAudienceCounts: catAudienceCounts,
	    selected_make: selected_make,
	    selected_model: selected_model,
	    selected_culture_region: selected_culture_region,
	    selected_culture_locale: selected_culture_locale,
	    isNameDuplicated: isNameDuplicated,
	    copy_segment_name: copy_segment_name,
	    segment_id: segment_id,
	    rules_id: rules_id,
	    all_state_cities: all_state_cities,
	    ifLoading: ifLoading,
	    make_active_arr: make_active_arr,
	    region_active_arr: region_active_arr,
	    audience_total_count: audience_total_count,
	    zipcode_audience_count: zipcode_audience_count,
	    active_segment_attributes: active_segment_attributes,
	    save_segment_success: save_segment_success,
	    save_segment_error_errorNo: save_segment_error_errorNo,
	    send_assist_request_error: send_assist_request_error,
	    request_assist_successful: request_assist_successful,
	    save_segment_error_message: save_segment_error_message,
	    check_client_limit: check_client_limit,
	    segment_active_creation: state.segmentCreation,
	    counties: counties,
	    dmas: dmas,
	    targetHouseholdsOnly: (0, _isUndefined2.default)(targetHouseholdsOnly) && active_segment_attributes ? active_segment_attributes.targetHouseholdsOnly : targetHouseholdsOnly
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    },
	    sendAssistRequest: function sendAssistRequest(data) {
	      dispatch((0, _Insights.sendAssistRequest)(data));
	    },
	    loadAttributes: function loadAttributes(cid) {
	      dispatch((0, _SegmentCreation.loadAttributes)(cid));
	    },
	    selectSegment: function selectSegment(val) {
	      dispatch((0, _SegmentCreation.selectSegment)(val));
	    },
	    getAllStates: function getAllStates() {
	      dispatch((0, _SegmentCreation.getAllStates)());
	    },
	    getCities: function getCities(cityId) {
	      dispatch((0, _SegmentCreation.getCities)(cityId));
	    },
	    clearAllSelectedState: function clearAllSelectedState() {
	      dispatch((0, _SegmentCreation.clearAllSelectedState)());
	    },
	    clearAllSelectedCity: function clearAllSelectedCity() {
	      dispatch((0, _SegmentCreation.clearAllSelectedCity)());
	    },
	    clearAllZipCode: function clearAllZipCode() {
	      dispatch((0, _SegmentCreation.clearAllZipCode)());
	    },
	    clearAllCounty: function clearAllCounty() {
	      dispatch((0, _SegmentCreation.clearAllCounty)());
	    },
	    clearAllDMA: function clearAllDMA() {
	      dispatch((0, _SegmentCreation.clearAllDMA)());
	    },
	    clearZipCode: function clearZipCode(val) {
	      dispatch((0, _SegmentCreation.clearZipCode)(val));
	    },
	    addZipCode: function addZipCode(value) {
	      dispatch((0, _SegmentCreation.addZipCode)(value));
	    },
	    selectCity: function selectCity(cityObj, stateLabel, flag) {
	      return dispatch((0, _SegmentCreation.selectCity)(cityObj, stateLabel, flag));
	    },
	    selectState: function selectState(id, flag) {
	      return dispatch((0, _SegmentCreation.selectState)(id, flag));
	    },
	    selectMake: function selectMake(makeObj, flag) {
	      return dispatch((0, _SegmentCreation.selectMake)(makeObj, flag));
	    },
	    selectModel: function selectModel(modelObj, flag) {
	      return dispatch((0, _SegmentCreation.selectModel)(modelObj, flag));
	    },
	    selectCultureRegion: function selectCultureRegion(obj, flag) {
	      return dispatch((0, _SegmentCreation.selectCultureRegion)(obj, flag));
	    },
	    selectCultureLocale: function selectCultureLocale(obj, flag) {
	      return dispatch((0, _SegmentCreation.selectCultureLocale)(obj, flag));
	    },
	    setSegmentName: function setSegmentName(val) {
	      dispatch((0, _SegmentCreation.setSegmentName)(val));
	    },
	    setPlotValues: function setPlotValues(val) {
	      dispatch((0, _SegmentCreation.setPlotValues)(val));
	    },
	    verifySegmentNameAndContinue: function verifySegmentNameAndContinue(clientId, name, id) {
	      dispatch((0, _SegmentCreation.verifySegmentNameAndContinue)(clientId, name, id));
	    },
	    verifySegmentName: function verifySegmentName(clientId, name, id) {
	      dispatch((0, _SegmentCreation.verifySegmentNameAndContinue)(clientId, name, id, "/segments/builder?step=confirm"));
	    },
	    verifyAndContinue: function verifyAndContinue(clientId, name) {
	      dispatch((0, _SegmentCreation.verifyAndContinue)(clientId, name));
	    },
	    getAllStateCities: function getAllStateCities() {
	      dispatch((0, _SegmentCreation.getAllStateCities)());
	    },
	    addMakeActive: function addMakeActive(value) {
	      dispatch((0, _SegmentCreation.addMakeActive)(value));
	    },
	    addRegionActive: function addRegionActive(value) {
	      dispatch((0, _SegmentCreation.addRegionActive)(value));
	    },
	    getAudienceCount: function getAudienceCount(data, sid) {
	      dispatch((0, _SegmentCreation.getAudienceCount)(data, sid));
	    },
	    getPlottedAudienceCount: function getPlottedAudienceCount(data, sid) {
	      dispatch((0, _SegmentCreation.getPlottedAudienceCount)(data, sid));
	    },
	    clearAudienceCount: function clearAudienceCount() {
	      dispatch((0, _SegmentCreation.clearAudienceCount)());
	    },
	    getZipcodeAudienceCount: function getZipcodeAudienceCount(data, sid) {
	      dispatch((0, _SegmentCreation.getZipcodeAudienceCount)(data, sid));
	      dispatch((0, _SegmentCreation.getZipcodeDetailCounts)(data, sid));
	    },
	    clearZipcodeCounts: function clearZipcodeCounts() {
	      dispatch((0, _SegmentCreation.clearZipcodeCounts)());
	    },
	    getCategoryAudienceCount: function getCategoryAudienceCount(rules, sid) {
	      dispatch((0, _SegmentCreation.getCategoryAudienceCounts)(rules, sid));
	    },
	    clearCategoryAudienceCounts: function clearCategoryAudienceCounts(categoryId) {
	      dispatch((0, _SegmentCreation.clearCategoryAudienceCounts)(categoryId));
	    },
	    checkSegmentLimitExceeded: function checkSegmentLimitExceeded(clientId) {
	      dispatch((0, _SegmentCreation.checkSegmentLimitExceeded)(clientId));
	    },
	    setTargetHouseholdOnly: function setTargetHouseholdOnly(checked) {
	      dispatch((0, _SegmentCreation.setTargetHouseholdOnly)(checked));
	    },
	    loadCounties: function loadCounties() {
	      dispatch((0, _SegmentCreation.getCounties)());
	    },
	    loadDMAs: function loadDMAs() {
	      dispatch((0, _SegmentCreation.getDMAs)());
	    },
	    selectCounty: function selectCounty(countyObj, stateLabel, flag) {
	      return dispatch((0, _SegmentCreation.selectCounty)(countyObj, stateLabel, flag));
	    },
	    selectDMA: function selectDMA(dmaObj, stateLabel, flag) {
	      dispatch((0, _SegmentCreation.selectDMA)(dmaObj, stateLabel, flag));
	    },
	    saveSegment: function saveSegment(data) {
	      dispatch((0, _SegmentCreation.saveSegment)(data));
	    },
	    selectAllState: function selectAllState(val, flag) {
	      dispatch((0, _SegmentCreation.selectAllState)(val, flag));
	    },
	    getSegmentDetail: function getSegmentDetail(id, cid) {
	      dispatch((0, _SegmentList.getSegmentWithRules)(id, cid));
	      //dispatch(getSegmentCounts(id));
	    },
	    clearAllAutoSelected: function clearAllAutoSelected() {
	      dispatch((0, _SegmentCreation.clearAllAutoSelected)());
	    },
	    clearAllRegionSelected: function clearAllRegionSelected() {
	      dispatch((0, _SegmentCreation.clearAllRegionSelected)());
	    }
	  };
	};
	
	var AudienceBuilderContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_index2.default);
	exports.default = AudienceBuilderContainer;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Confirm = __webpack_require__(1142);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _Insights = __webpack_require__(58);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$segmentCreatio = state.segmentCreation,
	      categories = _state$segmentCreatio.categories,
	      selected_segments = _state$segmentCreatio.selected_segments,
	      segment_name = _state$segmentCreatio.segment_name,
	      plotted_values = _state$segmentCreatio.plotted_values,
	      selected_city = _state$segmentCreatio.selected_city,
	      selected_county = _state$segmentCreatio.selected_county,
	      selected_dma = _state$segmentCreatio.selected_dma,
	      selected_state = _state$segmentCreatio.selected_state,
	      zipcode = _state$segmentCreatio.zipcode,
	      isNameDuplicated = _state$segmentCreatio.isNameDuplicated,
	      segment_id = _state$segmentCreatio.segment_id,
	      rules_id = _state$segmentCreatio.rules_id,
	      audience_total_count = _state$segmentCreatio.audience_total_count,
	      save_segment_success = _state$segmentCreatio.save_segment_success,
	      save_segment_error_errorNo = _state$segmentCreatio.save_segment_error_errorNo,
	      send_assist_request_error = _state$segmentCreatio.send_assist_request_error,
	      request_assist_successful = _state$segmentCreatio.request_assist_successful,
	      save_segment_error_message = _state$segmentCreatio.save_segment_error_message,
	      targetHouseholdsOnly = _state$segmentCreatio.targetHouseholdsOnly;
	  var active_segment_attributes = state.segmentList.active_segment_attributes;
	  var _state$app = state.app,
	      userId = _state$app.userId,
	      selected_client = _state$app.selected_client,
	      clients = _state$app.clients,
	      roleId = _state$app.roleId;
	
	  var demographic = categories ? (0, _lodash.tail)(categories) : undefined;
	  var geographic = categories ? categories[0] : undefined;
	  var selectedClient = (0, _lodash.isEmpty)(clients) ? [] : clients.find(function (item) {
	    return parseInt(item.id, 10) === parseInt(selected_client, 10);
	  });
	  return {
	    geoAttributes: geographic,
	    demoAttributes: demographic,
	    selected_segments: selected_segments,
	    userId: userId,
	    roleId: roleId,
	    selected_client: selected_client,
	    selected_client_name: selectedClient ? selectedClient.name : "",
	    segment_name: segment_name,
	    plotted_values: plotted_values,
	    selected_city: selected_city,
	    selected_state: selected_state,
	    selected_county: selected_county,
	    selected_dma: selected_dma,
	    zipcode: zipcode,
	    segment_id: segment_id,
	    isNameDuplicated: isNameDuplicated,
	    rules_id: rules_id,
	    audience_total_count: audience_total_count,
	    active_segment_attributes: active_segment_attributes,
	    save_segment_error_errorNo: save_segment_error_errorNo,
	    save_segment_error_message: save_segment_error_message,
	    save_segment_success: save_segment_success,
	    send_assist_request_error: send_assist_request_error,
	    request_assist_successful: request_assist_successful,
	    targetHouseholdsOnly: targetHouseholdsOnly
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    sendAssistRequest: function sendAssistRequest(data) {
	      dispatch((0, _Insights.sendAssistRequest)(data));
	    },
	    loadAttributes: function loadAttributes(cid) {
	      dispatch((0, _SegmentCreation.loadAttributes)(cid));
	    },
	    selectSegment: function selectSegment(val) {
	      dispatch((0, _SegmentCreation.selectSegment)(val));
	    },
	    setSegmentName: function setSegmentName(val) {
	      dispatch((0, _SegmentCreation.setSegmentName)(val));
	    },
	    saveSegment: function saveSegment(data) {
	      dispatch((0, _SegmentCreation.saveSegment)(data));
	    },
	    verifySegmentName: function verifySegmentName(clientId, name, id) {
	      dispatch((0, _SegmentCreation.verifySegmentName)(clientId, name, id));
	    },
	    setPlotValues: function setPlotValues(val) {
	      dispatch((0, _SegmentCreation.setPlotValues)(val));
	    },
	    clearAllSelectedState: function clearAllSelectedState() {
	      dispatch((0, _SegmentCreation.clearAllSelectedState)());
	    },
	    clearAllSelectedCity: function clearAllSelectedCity() {
	      dispatch((0, _SegmentCreation.clearAllSelectedCity)());
	    },
	    clearAllZipCode: function clearAllZipCode() {
	      dispatch((0, _SegmentCreation.clearAllZipCode)());
	    },
	    clearZipCode: function clearZipCode(val) {
	      dispatch((0, _SegmentCreation.clearZipCode)(val));
	    },
	    selectCity: function selectCity(id, flag) {
	      return dispatch((0, _SegmentCreation.selectCity)(id, flag));
	    },
	    selectState: function selectState(id, flag) {
	      return dispatch((0, _SegmentCreation.selectState)(id, flag));
	    }
	  };
	};
	
	var SegmentConfirm = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Confirm2.default);
	
	exports.default = SegmentConfirm;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Creation = __webpack_require__(1148);
	
	var _Creation2 = _interopRequireDefault(_Creation);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _Insights = __webpack_require__(58);
	
	var _App = __webpack_require__(27);
	
	var _tail = __webpack_require__(418);
	
	var _tail2 = _interopRequireDefault(_tail);
	
	var _uniqBy = __webpack_require__(302);
	
	var _uniqBy2 = _interopRequireDefault(_uniqBy);
	
	var _isUndefined = __webpack_require__(50);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$segmentCreatio = state.segmentCreation,
	      categories = _state$segmentCreatio.categories,
	      value_typehead = _state$segmentCreatio.value_typehead,
	      selected_segments = _state$segmentCreatio.selected_segments,
	      segment_name = _state$segmentCreatio.segment_name,
	      allstates = _state$segmentCreatio.allstates,
	      userSelectedInfo = _state$segmentCreatio.userSelectedInfo,
	      selected_city = _state$segmentCreatio.selected_city,
	      selected_county = _state$segmentCreatio.selected_county,
	      selected_dma = _state$segmentCreatio.selected_dma,
	      isNameDuplicated = _state$segmentCreatio.isNameDuplicated,
	      selected_state = _state$segmentCreatio.selected_state,
	      allcities = _state$segmentCreatio.allcities,
	      plotted_values = _state$segmentCreatio.plotted_values,
	      zipcode = _state$segmentCreatio.zipcode,
	      catAudienceCounts = _state$segmentCreatio.catAudienceCounts,
	      selected_make = _state$segmentCreatio.selected_make,
	      selected_model = _state$segmentCreatio.selected_model,
	      selected_culture_region = _state$segmentCreatio.selected_culture_region,
	      selected_culture_locale = _state$segmentCreatio.selected_culture_locale,
	      copy_segment_name = _state$segmentCreatio.copy_segment_name,
	      segment_id = _state$segmentCreatio.segment_id,
	      rules_id = _state$segmentCreatio.rules_id,
	      all_state_cities = _state$segmentCreatio.all_state_cities,
	      ifLoading = _state$segmentCreatio.ifLoading,
	      make_active_arr = _state$segmentCreatio.make_active_arr,
	      region_active_arr = _state$segmentCreatio.region_active_arr,
	      audience_total_count = _state$segmentCreatio.audience_total_count,
	      zipcode_audience_count = _state$segmentCreatio.zipcode_audience_count,
	      save_segment_success = _state$segmentCreatio.save_segment_success,
	      save_segment_error_errorNo = _state$segmentCreatio.save_segment_error_errorNo,
	      send_assist_request_error = _state$segmentCreatio.send_assist_request_error,
	      request_assist_successful = _state$segmentCreatio.request_assist_successful,
	      save_segment_error_message = _state$segmentCreatio.save_segment_error_message,
	      check_client_limit = _state$segmentCreatio.check_client_limit,
	      targetHouseholdsOnly = _state$segmentCreatio.targetHouseholdsOnly,
	      counties = _state$segmentCreatio.counties,
	      dmas = _state$segmentCreatio.dmas;
	  var active_segment_attributes = state.segmentList.active_segment_attributes;
	  var _state$app = state.app,
	      selected_client = _state$app.selected_client,
	      userId = _state$app.userId,
	      roleId = _state$app.roleId,
	      clients = _state$app.clients;
	
	  var demographic = categories ? (0, _tail2.default)(categories) : undefined;
	  var geographic = categories ? categories[0] : undefined;
	
	  return {
	    clients: clients,
	    client_info: state.app.client_info,
	    geoAttributes: geographic,
	    demoAttributes: (0, _uniqBy2.default)(demographic, function (d) {
	      return d.id;
	    }),
	    selected_segments: selected_segments,
	    userId: userId,
	    roleId: roleId,
	    selected_client: selected_client,
	    allstates: allstates,
	    userSelectedInfo: userSelectedInfo,
	    selected_city: selected_city,
	    selected_state: selected_state,
	    selected_county: selected_county,
	    selected_dma: selected_dma,
	    segment_name: segment_name,
	    value_typehead: value_typehead,
	    allcities: allcities,
	    plotted_values: plotted_values,
	    zipcode: zipcode,
	    catAudienceCounts: catAudienceCounts,
	    selected_make: selected_make,
	    selected_model: selected_model,
	    selected_culture_region: selected_culture_region,
	    selected_culture_locale: selected_culture_locale,
	    isNameDuplicated: isNameDuplicated,
	    copy_segment_name: copy_segment_name,
	    segment_id: segment_id,
	    rules_id: rules_id,
	    all_state_cities: all_state_cities,
	    ifLoading: ifLoading,
	    make_active_arr: make_active_arr,
	    region_active_arr: region_active_arr,
	    audience_total_count: audience_total_count,
	    zipcode_audience_count: zipcode_audience_count,
	    active_segment_attributes: active_segment_attributes,
	    save_segment_success: save_segment_success,
	    save_segment_error_errorNo: save_segment_error_errorNo,
	    send_assist_request_error: send_assist_request_error,
	    request_assist_successful: request_assist_successful,
	    save_segment_error_message: save_segment_error_message,
	    check_client_limit: check_client_limit,
	    counties: counties,
	    dmas: dmas,
	    targetHouseholdsOnly: (0, _isUndefined2.default)(targetHouseholdsOnly) && active_segment_attributes ? active_segment_attributes.targetHouseholdsOnly : targetHouseholdsOnly
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    },
	    sendAssistRequest: function sendAssistRequest(data) {
	      dispatch((0, _Insights.sendAssistRequest)(data));
	    },
	    loadAttributes: function loadAttributes(cid) {
	      dispatch((0, _SegmentCreation.loadAttributes)(cid));
	    },
	    selectSegment: function selectSegment(val) {
	      dispatch((0, _SegmentCreation.selectSegment)(val));
	    },
	    getAllStates: function getAllStates() {
	      dispatch((0, _SegmentCreation.getAllStates)());
	    },
	    getCities: function getCities(cityId) {
	      dispatch((0, _SegmentCreation.getCities)(cityId));
	    },
	    clearAllSelectedState: function clearAllSelectedState() {
	      dispatch((0, _SegmentCreation.clearAllSelectedState)());
	    },
	    clearAllSelectedCity: function clearAllSelectedCity() {
	      dispatch((0, _SegmentCreation.clearAllSelectedCity)());
	    },
	    clearAllZipCode: function clearAllZipCode() {
	      dispatch((0, _SegmentCreation.clearAllZipCode)());
	    },
	    clearAllCounty: function clearAllCounty() {
	      dispatch((0, _SegmentCreation.clearAllCounty)());
	    },
	    clearAllDMA: function clearAllDMA() {
	      dispatch((0, _SegmentCreation.clearAllDMA)());
	    },
	    clearZipCode: function clearZipCode(val) {
	      dispatch((0, _SegmentCreation.clearZipCode)(val));
	    },
	    addZipCode: function addZipCode(value) {
	      dispatch((0, _SegmentCreation.addZipCode)(value));
	    },
	    selectCity: function selectCity(cityObj, stateLabel, flag) {
	      return dispatch((0, _SegmentCreation.selectCity)(cityObj, stateLabel, flag));
	    },
	    selectState: function selectState(id, flag) {
	      return dispatch((0, _SegmentCreation.selectState)(id, flag));
	    },
	    selectMake: function selectMake(makeObj, flag) {
	      return dispatch((0, _SegmentCreation.selectMake)(makeObj, flag));
	    },
	    selectModel: function selectModel(modelObj, flag) {
	      return dispatch((0, _SegmentCreation.selectModel)(modelObj, flag));
	    },
	    selectCultureRegion: function selectCultureRegion(obj, flag) {
	      return dispatch((0, _SegmentCreation.selectCultureRegion)(obj, flag));
	    },
	    selectCultureLocale: function selectCultureLocale(obj, flag) {
	      return dispatch((0, _SegmentCreation.selectCultureLocale)(obj, flag));
	    },
	    setSegmentName: function setSegmentName(val) {
	      dispatch((0, _SegmentCreation.setSegmentName)(val));
	    },
	    setPlotValues: function setPlotValues(val) {
	      dispatch((0, _SegmentCreation.setPlotValues)(val));
	    },
	    verifySegmentNameAndContinue: function verifySegmentNameAndContinue(clientId, name, id) {
	      dispatch((0, _SegmentCreation.verifySegmentNameAndContinue)(clientId, name, id));
	    },
	    verifyAndContinue: function verifyAndContinue(clientId, name) {
	      dispatch((0, _SegmentCreation.verifyAndContinue)(clientId, name));
	    },
	    getAllStateCities: function getAllStateCities() {
	      dispatch((0, _SegmentCreation.getAllStateCities)());
	    },
	    addMakeActive: function addMakeActive(value) {
	      dispatch((0, _SegmentCreation.addMakeActive)(value));
	    },
	    addRegionActive: function addRegionActive(value) {
	      dispatch((0, _SegmentCreation.addRegionActive)(value));
	    },
	    getAudienceCount: function getAudienceCount(data, sid) {
	      dispatch((0, _SegmentCreation.getAudienceCount)(data, sid));
	    },
	    getPlottedAudienceCount: function getPlottedAudienceCount(data, sid) {
	      dispatch((0, _SegmentCreation.getPlottedAudienceCount)(data, sid));
	    },
	    clearAudienceCount: function clearAudienceCount() {
	      dispatch((0, _SegmentCreation.clearAudienceCount)());
	    },
	    getZipcodeAudienceCount: function getZipcodeAudienceCount(data, sid) {
	      dispatch((0, _SegmentCreation.getZipcodeAudienceCount)(data, sid));
	      dispatch((0, _SegmentCreation.getZipcodeDetailCounts)(data, sid));
	    },
	    clearZipcodeCounts: function clearZipcodeCounts() {
	      dispatch((0, _SegmentCreation.clearZipcodeCounts)());
	    },
	    getCategoryAudienceCount: function getCategoryAudienceCount(rules, sid) {
	      dispatch((0, _SegmentCreation.getCategoryAudienceCounts)(rules, sid));
	    },
	    clearCategoryAudienceCounts: function clearCategoryAudienceCounts(categoryId) {
	      dispatch((0, _SegmentCreation.clearCategoryAudienceCounts)(categoryId));
	    },
	    checkSegmentLimitExceeded: function checkSegmentLimitExceeded(clientId) {
	      dispatch((0, _SegmentCreation.checkSegmentLimitExceeded)(clientId));
	    },
	    setTargetHouseholdOnly: function setTargetHouseholdOnly(checked) {
	      dispatch((0, _SegmentCreation.setTargetHouseholdOnly)(checked));
	    },
	    loadCounties: function loadCounties() {
	      dispatch((0, _SegmentCreation.getCounties)());
	    },
	    loadDMAs: function loadDMAs() {
	      dispatch((0, _SegmentCreation.getDMAs)());
	    },
	    selectCounty: function selectCounty(countyObj, stateLabel, flag) {
	      return dispatch((0, _SegmentCreation.selectCounty)(countyObj, stateLabel, flag));
	    },
	    selectDMA: function selectDMA(dmaObj, stateLabel, flag) {
	      dispatch((0, _SegmentCreation.selectDMA)(dmaObj, stateLabel, flag));
	    }
	  };
	};
	
	var SegmentCreation = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Creation2.default);
	
	exports.default = SegmentCreation;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _SaveSuccess = __webpack_require__(1157);
	
	var _SaveSuccess2 = _interopRequireDefault(_SaveSuccess);
	
	var _SegmentList = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
		var _state$segmentCreatio = state.segmentCreation,
		    selected_segments = _state$segmentCreatio.selected_segments,
		    segment_name = _state$segmentCreatio.segment_name,
		    save_segment_report_id = _state$segmentCreatio.save_segment_report_id;
	
		return {
			selected_segments: selected_segments,
			segment_name: segment_name,
			save_segment_report_id: save_segment_report_id
		};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			clearSegmentWithRules: function clearSegmentWithRules() {
				dispatch((0, _SegmentList.clearSegmentWithRules)());
			}
		};
	};
	
	var SegmentSaveSuccess = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SaveSuccess2.default);
	
	exports.default = SegmentSaveSuccess;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Active = __webpack_require__(1152);
	
	var _Active2 = _interopRequireDefault(_Active);
	
	var _SegmentDetail = __webpack_require__(165);
	
	var _SegmentList = __webpack_require__(118);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _App = __webpack_require__(27);
	
	var _lodash = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$segmentDetail = state.segmentDetail,
	      segment_summary = _state$segmentDetail.segment_summary,
	      segment_counts = _state$segmentDetail.segment_counts;
	  var _state$segmentList = state.segmentList,
	      segment_list_active = _state$segmentList.segment_list_active,
	      archive_success = _state$segmentList.archive_success,
	      segment_attributes = _state$segmentList.segment_attributes,
	      active_segment_attributes = _state$segmentList.active_segment_attributes,
	      selectedSegmentSetArray = _state$segmentList.selectedSegmentSetArray;
	  var categories = state.segmentCreation.categories;
	  var _state$app = state.app,
	      roleName = _state$app.roleName,
	      client_info = _state$app.client_info,
	      roleId = _state$app.roleId,
	      selected_client = _state$app.selected_client;
	
	  var demographic = categories ? (0, _lodash.tail)(categories) : undefined;
	  var geographic = categories ? categories[0] : undefined;
	
	  var segment_detail = segment_summary;
	  if (segment_detail) segment_detail.audiences = segment_counts;
	  return {
	    segment_summary: segment_detail,
	    segment_list_active: segment_list_active,
	    archive_success: archive_success,
	    segment_attributes: segment_attributes,
	    geoAttributes: geographic,
	    demoAttributes: demographic,
	    selected_client: selected_client,
	    segment_active_creation: state.segmentCreation,
	    active_segment_attributes: active_segment_attributes,
	    roleName: roleName,
	    roleId: roleId,
	    client_info: client_info,
	    selectedSegmentSetArray: selectedSegmentSetArray
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    loadAttributes: function loadAttributes(cid) {
	      dispatch((0, _SegmentCreation.loadAttributes)(cid));
	    },
	    clearReactiveStatus: function clearReactiveStatus() {
	      dispatch((0, _SegmentList.clearReactiveStatus)());
	    },
	    getSegmentList: function getSegmentList(data) {
	      dispatch((0, _SegmentList.getSegmentList)(data));
	    },
	    // archiveSegment: (id) => {
	    //   dispatch(archiveSegment(id))
	    // },
	    fetchSegmentDetail: function fetchSegmentDetail(id) {
	      dispatch((0, _SegmentDetail.getSegmentCounts)(id));
	      dispatch((0, _SegmentDetail.fetchSegmentSummary)(id));
	      dispatch((0, _SegmentList.getAttributes)(id));
	    },
	    clearSegmentSummary: function clearSegmentSummary() {
	      dispatch((0, _SegmentDetail.clearSegmentSummary)());
	    },
	    getSegmentWithRules: function getSegmentWithRules(id) {
	      dispatch((0, _SegmentList.getSegmentWithRules)(id));
	    },
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    },
	    selectedSegment: function selectedSegment(setArray) {
	      dispatch((0, _SegmentList.selectedSegment)(setArray));
	    },
	    recordActiveQueryParams: function recordActiveQueryParams(obj) {
	      dispatch((0, _SegmentList.recordActiveQueryParams)(obj));
	    }
	  };
	};
	
	var SegmentActive = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Active2.default);
	
	exports.default = SegmentActive;

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Archive = __webpack_require__(1153);
	
	var _Archive2 = _interopRequireDefault(_Archive);
	
	var _SegmentDetail = __webpack_require__(165);
	
	var _SegmentList = __webpack_require__(118);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var segment_summary = state.segmentDetail.segment_summary;
	  var _state$segmentList = state.segmentList,
	      segment_list_archive = _state$segmentList.segment_list_archive,
	      segment_attributes = _state$segmentList.segment_attributes,
	      copy_segment = _state$segmentList.copy_segment,
	      searchByNameResult = _state$segmentList.searchByNameResult,
	      reactive_success = _state$segmentList.reactive_success,
	      reactive_on_progress = _state$segmentList.reactive_on_progress;
	  var _state$app = state.app,
	      roleName = _state$app.roleName,
	      client_info = _state$app.client_info,
	      roleId = _state$app.roleId;
	
	  return {
	    segment_summary: segment_summary,
	    segment_list_archive: segment_list_archive,
	    selected_client: state.app.selected_client,
	    segment_attributes: segment_attributes,
	    copy_segment: copy_segment,
	    roleName: roleName,
	    client_info: client_info,
	    roleId: roleId,
	    segment_edit_creation: state.segmentCreation,
	    searchByNameResult: searchByNameResult,
	    reactive_success: reactive_success,
	    reactive_on_progress: reactive_on_progress
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    reactiveSegment: function reactiveSegment(id) {
	      dispatch((0, _SegmentList.reactiveSegment)(id));
	    },
	    getSegmentList: function getSegmentList(data) {
	      dispatch((0, _SegmentList.getSegmentList)(data));
	    },
	    fetchSegmentDetail: function fetchSegmentDetail(id) {
	      dispatch((0, _SegmentDetail.fetchSegmentSummary)(id));
	      dispatch((0, _SegmentList.getAttributes)(id));
	    },
	    clearSegmentSummary: function clearSegmentSummary() {
	      dispatch((0, _SegmentDetail.clearSegmentSummary)());
	    },
	    getAttributes: function getAttributes(id) {
	      dispatch((0, _SegmentList.getAttributes)(id));
	    },
	    copySegment: function copySegment(id) {
	      dispatch((0, _SegmentList.copySegment)(id));
	    },
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    },
	    searchByName: function searchByName(obj) {
	      dispatch((0, _SegmentList.searchByName)(obj));
	    }
	  };
	};
	
	var SegmentActive = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Archive2.default);
	
	exports.default = SegmentActive;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Index = __webpack_require__(1155);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _SegmentList = __webpack_require__(118);
	
	var _App = __webpack_require__(27);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _SegmentDetail = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$segmentList = state.segmentList,
	      segment_archive_data = _state$segmentList.segment_archive_data,
	      create_campaign = _state$segmentList.create_campaign,
	      searchByNameResult = _state$segmentList.searchByNameResult,
	      selectedSegmentSetArray = _state$segmentList.selectedSegmentSetArray,
	      segment_list_active = _state$segmentList.segment_list_active,
	      recordActiveQueryParamsObj = _state$segmentList.recordActiveQueryParamsObj;
	  var segment_summary = state.segmentDetail.segment_summary;
	  var _state$segmentCreatio = state.segmentCreation,
	      categories = _state$segmentCreatio.categories,
	      value_typehead = _state$segmentCreatio.value_typehead;
	  var selected_client = state.app.selected_client;
	  var _state$app = state.app,
	      roleId = _state$app.roleId,
	      clients = _state$app.clients,
	      roleName = _state$app.roleName,
	      client_info = _state$app.client_info;
	
	  return {
	    // segment_list,
	    segment_archive_data: segment_archive_data,
	    create_campaign: create_campaign,
	    selected_client: selected_client,
	    roleId: roleId,
	    clients: clients,
	    client_info: client_info,
	    roleName: roleName,
	    searchByNameResult: searchByNameResult,
	    selectedSegmentSetArray: selectedSegmentSetArray,
	    segment_list_active: segment_list_active,
	    recordActiveQueryParamsObj: recordActiveQueryParamsObj,
	    segment_summary: segment_summary,
	    categories: categories,
	    value_typehead: value_typehead
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getSegmentList: function getSegmentList(data) {
	      dispatch((0, _SegmentList.getSegmentList)(data));
	    },
	    getSegmentArchiveData: function getSegmentArchiveData(data) {
	      dispatch((0, _SegmentList.getSegmentArchiveData)(data));
	    },
	    getCreateCampaign: function getCreateCampaign(id, data) {
	      dispatch((0, _SegmentList.getCreateCampaign)(id, data));
	    },
	    rollbackRequestSuccessToFalse: function rollbackRequestSuccessToFalse(val) {
	      dispatch((0, _SegmentList.rollbackRequestSuccessToFalse)(val));
	    },
	    searchByName: function searchByName(obj) {
	      dispatch((0, _SegmentList.searchByName)(obj));
	    },
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    },
	    getSegmentWithRules: function getSegmentWithRules(id) {
	      dispatch((0, _SegmentList.getSegmentWithRules)(id));
	    },
	    archiveSegment: function archiveSegment(id) {
	      dispatch((0, _SegmentList.archiveSegment)(id));
	    },
	    selectedSegment: function selectedSegment(setArray) {
	      dispatch((0, _SegmentList.selectedSegment)(setArray));
	    },
	    loadAttributes: function loadAttributes(cid) {
	      dispatch((0, _SegmentCreation.loadAttributes)(cid));
	    },
	    fetchSegmentSummary: function fetchSegmentSummary(id) {
	      dispatch((0, _SegmentDetail.fetchSegmentSummary)(id));
	    }
	  };
	};
	
	var SegmentIndex = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = SegmentIndex;

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _insightsFile = __webpack_require__(1138);
	
	var _insightsFile2 = _interopRequireDefault(_insightsFile);
	
	var _reactRedux = __webpack_require__(20);
	
	var _Insights = __webpack_require__(58);
	
	var _settings = __webpack_require__(351);
	
	var _Clients = __webpack_require__(49);
	
	var _App = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
		var _state$app = state.app,
		    selected_client = _state$app.selected_client,
		    client_info = _state$app.client_info,
		    clients = _state$app.clients;
		var _state$settings = state.settings,
		    insights_file_save_success = _state$settings.insights_file_save_success,
		    insights_file_save_error_message = _state$settings.insights_file_save_error_message,
		    insights_file_on_saving = _state$settings.insights_file_on_saving;
		var websiteId = state.insights.websiteId;
		var _state$clients = state.clients,
		    client_sites = _state$clients.client_sites,
		    client_tags = _state$clients.client_tags,
		    client_tags_on_loading = _state$clients.client_tags_on_loading;
	
	
		return {
			websiteId: websiteId,
			selected_client: selected_client,
			client_info: client_info,
			client_sites: client_sites,
			client_tags: client_tags,
			clients: clients,
			insights_file_save_success: insights_file_save_success,
			insights_file_save_error_message: insights_file_save_error_message,
			insights_file_on_saving: insights_file_on_saving,
			client_tags_on_loading: client_tags_on_loading
		};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			getClientSites: function getClientSites(cid) {
				dispatch((0, _Clients.getClientSites)(cid));
			},
			getClientTags: function getClientTags(clientId) {
				dispatch((0, _Clients.getClientTags)(clientId));
			},
			setWebsiteId: function setWebsiteId(id) {
				dispatch((0, _Insights.setReportWebSiteId)(id));
				dispatch((0, _settings.setSettingsWebsiteId)(id));
			},
			saveInsightsFileSetup: function saveInsightsFileSetup(clientId, tagId, obj) {
				dispatch((0, _settings.saveInsightsFileSetup)(clientId, tagId, obj));
			},
			getClientInfo: function getClientInfo(id) {
				dispatch((0, _App.getClientInfo)(id));
			},
			clearInsightsFileSettingsSaveError: function clearInsightsFileSettingsSaveError() {
				dispatch((0, _settings.clearInsightsFileSettingsSaveError)());
			}
		};
	};
	
	var InsightsFileSettingsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_insightsFile2.default);
	
	exports.default = InsightsFileSettingsContainer;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(1137);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactRedux = __webpack_require__(20);
	
	var _Insights = __webpack_require__(58);
	
	var _tags = __webpack_require__(211);
	
	var _App = __webpack_require__(27);
	
	var _settings = __webpack_require__(351);
	
	var _Clients = __webpack_require__(49);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$insights = state.insights,
	      websiteId = _state$insights.websiteId,
	      website_name = _state$insights.website_name,
	      website_url = _state$insights.website_url,
	      tag_info = _state$insights.tag_info,
	      tag_updated_success = _state$insights.tag_updated_success,
	      tag_error_message = _state$insights.tag_error_message,
	      tag_variables = _state$insights.tag_variables,
	      campaign_name = _state$insights.campaign_name;
	  var _state$app = state.app,
	      selected_client = _state$app.selected_client,
	      client_info = _state$app.client_info,
	      clients = _state$app.clients,
	      roleId = _state$app.roleId;
	  var _state$clients = state.clients,
	      client_sites = _state$clients.client_sites,
	      client_tags = _state$clients.client_tags;
	
	
	  return {
	    websiteId: websiteId,
	    selected_client: selected_client,
	    client_sites: client_sites,
	    client_info: client_info,
	    clients: clients,
	    website_name: website_name,
	    website_url: website_url,
	    campaign_name: campaign_name,
	    tag_info: tag_info,
	    tag_variables: tag_variables,
	    tag_error_message: tag_error_message,
	    tag_updated_success: tag_updated_success,
	    client_tags: client_tags,
	    roleId: roleId
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getClientSites: function getClientSites(cid) {
	      dispatch((0, _Clients.getClientSites)(cid));
	    },
	
	    setWebsiteId: function setWebsiteId(id) {
	      dispatch((0, _Insights.setReportWebSiteId)(id));
	      dispatch((0, _settings.setSettingsWebsiteId)(id));
	    },
	
	    setTagWebsiteName: function setTagWebsiteName(val) {
	      dispatch((0, _tags.setTagWebsiteName)(val));
	    },
	
	    setTagWebsiteURL: function setTagWebsiteURL(val) {
	      dispatch((0, _tags.setTagWebsiteURL)(val));
	    },
	
	    setTagCampaignName: function setTagCampaignName(val) {
	      dispatch((0, _tags.setTagCampaignName)(val));
	    },
	
	    generateTag: function generateTag(clientId, val) {
	      dispatch((0, _tags.clearTagError)());
	      dispatch((0, _tags.generateTag)(clientId, val));
	    },
	
	    saveTag: function saveTag(clientId, uuid, val) {
	      //dispatch(saveTag(clientId, uuid, val))
	      dispatch((0, _Clients.getClientTags)(clientId));
	      dispatch((0, _reactRouterRedux.push)("/settings/tags/list"));
	    },
	
	    clearInsightTagInfo: function clearInsightTagInfo() {
	      dispatch((0, _tags.clearInsightTagInfo)());
	    },
	
	    clearInsightTagInfoAndRefreh: function clearInsightTagInfoAndRefreh(clientId) {
	      dispatch((0, _tags.clearInsightTagInfo)());
	      dispatch((0, _Clients.getClientTags)(clientId));
	      dispatch((0, _reactRouterRedux.push)("/settings/tags/list"));
	    },
	
	    getClientTags: function getClientTags(clientId) {
	      dispatch((0, _Clients.getClientTags)(clientId));
	    },
	    clearTagError: function clearTagError() {
	      dispatch((0, _tags.clearTagError)());
	    },
	    createNewTag: function createNewTag() {
	      dispatch((0, _tags.clearTagError)());
	      dispatch((0, _tags.clearInsightTagInfo)());
	      dispatch((0, _reactRouterRedux.push)("/settings/tags/create"));
	    },
	    getTagDetail: function getTagDetail(clientId, tagId, url) {
	      dispatch((0, _tags.getTagDetail)(clientId, tagId, url));
	    },
	    getClientInfo: function getClientInfo(id) {
	      dispatch((0, _App.getClientInfo)(id));
	    },
	    selectClient: function selectClient(id) {
	      dispatch((0, _App.selectClient)(id));
	    }
	  };
	};
	
	var MySettingsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_index2.default);
	
	exports.default = MySettingsContainer;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1159);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _reactRedux = __webpack_require__(20);
	
	var _SubscriptionInfo = __webpack_require__(508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$subscriptionIn = state.subscriptionInfo,
	      subscription_total = _state$subscriptionIn.subscription_total,
	      search_results = _state$subscriptionIn.search_results,
	      all_search_results = _state$subscriptionIn.all_search_results;
	
	  return {
	    subscription_total: subscription_total,
	    search_results: search_results,
	    all_search_results: all_search_results,
	    clients: state.app.clients
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getSubStats: function getSubStats() {
	      dispatch((0, _SubscriptionInfo.getSubStats)());
	    },
	    getSearchData: function getSearchData(obj) {
	      dispatch((0, _SubscriptionInfo.getSearchData)(obj));
	    },
	    getAllSearchData: function getAllSearchData(obj) {
	      dispatch((0, _SubscriptionInfo.getAllSearchData)(obj));
	    }
	  };
	};
	
	var SubscriptionInfo = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = SubscriptionInfo;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(20);
	
	var _Index = __webpack_require__(1162);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _TagInfo = __webpack_require__(509);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$tagsInfo = state.tagsInfo,
	      tags_total = _state$tagsInfo.tags_total,
	      tags_tree = _state$tagsInfo.tags_tree,
	      search_results = _state$tagsInfo.search_results,
	      all_search_results = _state$tagsInfo.all_search_results;
	  // let arr = [];
	  // if (Array.isArray(state.app.clients)) {
	  //   for (const list of state.app.clients) {
	  //     let item = Object.assign({}, {
	  //       label: list.name,
	  //       value: list.id
	  //     });
	  //     arr.push(item);
	  //   }
	  // }
	
	  return {
	    tags_total: tags_total,
	    tags_tree: tags_tree,
	    search_results: search_results,
	    all_search_results: all_search_results,
	    clients: state.app.clients,
	    clientId: state.app.loginUserDetail && state.app.loginUserDetail.client.id
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getTagsTotal: function getTagsTotal() {
	      dispatch((0, _TagInfo.getTagsTotal)());
	    },
	    getClientTree: function getClientTree(obj) {
	      dispatch((0, _TagInfo.getClientTree)(obj));
	    },
	    tagsSearch: function tagsSearch(obj) {
	      dispatch((0, _TagInfo.tagsSearch)(obj));
	    },
	    tagsAllSearch: function tagsAllSearch(obj) {
	      dispatch((0, _TagInfo.tagsAllSearch)(obj));
	    }
	  };
	};
	
	var TagsInfo = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Index2.default);
	
	exports.default = TagsInfo;

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(20);
	
	var _reactRouter = __webpack_require__(967);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	var _createBrowserHistory = __webpack_require__(604);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _App = __webpack_require__(1174);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Dashboard = __webpack_require__(534);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Segment = __webpack_require__(1158);
	
	var _Segment2 = _interopRequireDefault(_Segment);
	
	var _Insights = __webpack_require__(1110);
	
	var _Insights2 = _interopRequireDefault(_Insights);
	
	var _Footer = __webpack_require__(1196);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _index = __webpack_require__(1195);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _userStatus = __webpack_require__(535);
	
	var _userStatus2 = _interopRequireDefault(_userStatus);
	
	var _index3 = __webpack_require__(1193);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _Clients = __webpack_require__(1192);
	
	var _Clients2 = _interopRequireDefault(_Clients);
	
	var _editIndex = __webpack_require__(1190);
	
	var _editIndex2 = _interopRequireDefault(_editIndex);
	
	var _Profile = __webpack_require__(1206);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Login = __webpack_require__(1176);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _ResetPassword = __webpack_require__(1177);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _ChangePassword = __webpack_require__(1175);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _index5 = __webpack_require__(1194);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _Tags = __webpack_require__(1202);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _MySettings = __webpack_require__(1215);
	
	var _MySettings2 = _interopRequireDefault(_MySettings);
	
	var _InsightsFile = __webpack_require__(1214);
	
	var _InsightsFile2 = _interopRequireDefault(_InsightsFile);
	
	var _Index = __webpack_require__(1213);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(1205);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _SubscriptionsInfo = __webpack_require__(1216);
	
	var _SubscriptionsInfo2 = _interopRequireDefault(_SubscriptionsInfo);
	
	var _TagsInfo = __webpack_require__(1217);
	
	var _TagsInfo2 = _interopRequireDefault(_TagsInfo);
	
	var _ClientBusinessInfoAndUser = __webpack_require__(1185);
	
	var _ClientBusinessInfoAndUser2 = _interopRequireDefault(_ClientBusinessInfoAndUser);
	
	var _Index5 = __webpack_require__(1204);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _index7 = __webpack_require__(1184);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _createCampaigns = __webpack_require__(1183);
	
	var _createCampaigns2 = _interopRequireDefault(_createCampaigns);
	
	var _CampaignReport = __webpack_require__(1178);
	
	var _CampaignReport2 = _interopRequireDefault(_CampaignReport);
	
	var _EmailChannelReport = __webpack_require__(1180);
	
	var _EmailChannelReport2 = _interopRequireDefault(_EmailChannelReport);
	
	var _SocialChannelReport = __webpack_require__(1181);
	
	var _SocialChannelReport2 = _interopRequireDefault(_SocialChannelReport);
	
	var _DisplayChannelReport = __webpack_require__(1179);
	
	var _DisplayChannelReport2 = _interopRequireDefault(_DisplayChannelReport);
	
	var _TopLinksClicks = __webpack_require__(1182);
	
	var _TopLinksClicks2 = _interopRequireDefault(_TopLinksClicks);
	
	var _SegmentDistribution = __webpack_require__(1200);
	
	var _SegmentDistribution2 = _interopRequireDefault(_SegmentDistribution);
	
	var _PopularPages = __webpack_require__(1199);
	
	var _PopularPages2 = _interopRequireDefault(_PopularPages);
	
	var _FavoritePages = __webpack_require__(1198);
	
	var _FavoritePages2 = _interopRequireDefault(_FavoritePages);
	
	var _AudienceBuilderContainer = __webpack_require__(1207);
	
	var _AudienceBuilderContainer2 = _interopRequireDefault(_AudienceBuilderContainer);
	
	var _stores = __webpack_require__(1237);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	__webpack_require__(1452);
	
	__webpack_require__(1397);
	
	__webpack_require__(1393);
	
	__webpack_require__(1396);
	
	__webpack_require__(1395);
	
	__webpack_require__(1394);
	
	__webpack_require__(1453);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var history = (0, _createBrowserHistory2.default)();
	var reduxDevState = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
	var store = (0, _stores2.default)(history, reduxDevState);
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(
	    _reactRouterRedux.ConnectedRouter,
	    { onUpdate: function onUpdate() {
	        return window.scrollTo(0, 0);
	      }, history: history },
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactRouter.Switch,
	        null,
	        _react2.default.createElement(_reactRouter.Redirect, { exact: true, from: "/", to: "/dashboard" })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: "/", component: _App2.default }),
	      _react2.default.createElement(_reactRouter.Route, { exact: true, path: "/dashboard", component: _Dashboard2.default }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/dashboard/subscription",
	        render: function render(props) {
	          return JSON.parse(localStorage.getItem("session")).roleId < 51 ? _react2.default.createElement(_SubscriptionsInfo2.default, props) : _react2.default.createElement(_reactRouter.Redirect, { to: "/dahboard" });
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/dashboard/tags",
	        render: function render(props) {
	          return JSON.parse(localStorage.getItem("session")).roleId < 51 ? _react2.default.createElement(_TagsInfo2.default, props) : _react2.default.createElement(_reactRouter.Redirect, { to: "/dashboard" });
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/dashboard/clients/:type",
	        render: function render(props) {
	          return JSON.parse(localStorage.getItem("session")).roleId < 51 ? _react2.default.createElement(_ClientBusinessInfoAndUser2.default, props) : _react2.default.createElement(_reactRouter.Redirect, { to: "/dashboard" });
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/dashboard/data/:type",
	        render: function render(props) {
	          return JSON.parse(localStorage.getItem("session")).roleId < 51 ? _react2.default.createElement(_Index6.default, props) : _react2.default.createElement(_reactRouter.Redirect, { to: "/dashboard" });
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/segments/builder",
	        component: _AudienceBuilderContainer2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, { exact: true, path: "/segment/:step", component: _Segment2.default }),
	      _react2.default.createElement(_reactRouter.Route, { exact: true, path: "/segments/list/:type", component: _Index2.default }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/segments/list/detail/:id",
	        component: _Index4.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/segments/list/active/:id", component: _Index2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/employees", exact: true, component: _index2.default }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "/employees/user-status/:id/:pageNumber/:sortColumn/:order",
	        exact: true,
	        component: _userStatus2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/create-internal-account/:id", component: _index4.default }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "/create-client-account/:code",
	        component: _index6.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "/create-business-unit-member-account/:code",
	        component: _index6.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, { exact: true, path: "/clients", component: _Clients2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/clients/edit", component: _editIndex2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/login", component: _Login2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/logout", component: _Login2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/resetpassword", component: _ResetPassword2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/changepassword", component: _ChangePassword2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/myProfile", component: _Profile2.default }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/segment-distribution",
	        component: _SegmentDistribution2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/distribution/pages/popular",
	        component: _PopularPages2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/distribution/pages/favorite",
	        component: _FavoritePages2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, { exact: true, path: "/insights", component: _Insights2.default }),
	      _react2.default.createElement(_reactRouter.Route, { exact: true, path: "/insights/:type", component: _Insights2.default }),
	      _react2.default.createElement(_reactRouter.Route, { exact: true, path: "/insights/:type/:kind", component: _Insights2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/insights/tags/:action", component: _Tags2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: "/settings/tags/:action", component: _MySettings2.default }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "/settings/insights",
	        component: _InsightsFile2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, { exact: true, path: "/campaigns", component: _index8.default }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/campaigns/create",
	        render: function render(props) {
	          return JSON.parse(localStorage.getItem("session")).roleId === 1 || JSON.parse(localStorage.getItem("session")).roleId === 5 ? _react2.default.createElement(_createCampaigns2.default, props) : _react2.default.createElement(_reactRouter.Redirect, { to: "/dashboard" });
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/campaigns/edit/:id",
	        render: function render(props) {
	          return JSON.parse(localStorage.getItem("session")).roleId === 1 || JSON.parse(localStorage.getItem("session")).roleId === 5 ? _react2.default.createElement(_createCampaigns2.default, props) : _react2.default.createElement(_reactRouter.Redirect, { to: "/dashboard" });
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/campaigns/report/:id",
	        render: function render(props) {
	          return _react2.default.createElement(_CampaignReport2.default, props);
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/campaigns/report/:id/:channelType/:channelCampaignId/:segmentId/top-links-click",
	        render: function render(props) {
	          return _react2.default.createElement(_TopLinksClicks2.default, props);
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/campaigns/report/:id/email/:channelCampaignId",
	        render: function render(props) {
	          return _react2.default.createElement(_EmailChannelReport2.default, props);
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/campaigns/report/:id/social/:channelCampaignId",
	        render: function render(props) {
	          return _react2.default.createElement(_SocialChannelReport2.default, props);
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        exact: true,
	        path: "/campaigns/report/:id/display/:channelCampaignId",
	        render: function render(props) {
	          return _react2.default.createElement(_DisplayChannelReport2.default, props);
	        }
	      }),
	      _react2.default.createElement(_Footer2.default, null)
	    )
	  )
	), document.getElementById("root"));

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.app = undefined;
	
	var _helpers = __webpack_require__(54);
	
	var _utility = __webpack_require__(14);
	
	var _immutable = __webpack_require__(617);
	
	var _lodash = __webpack_require__(18);
	
	var _App = __webpack_require__(27);
	
	var app = exports.app = function app() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    selected_client: "0",
	    sendRecoveryEmailSuccess: false,
	    sendRecoveryEmailFailMessage: undefined
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.request)(_App.GET_DISABLED_FEATURES):
	      return Object.assign({}, state, {
	        disabledFeatures: action.payload,
	        loadingDisabledFeatures: true
	      });
	    case (0, _helpers.success)(_App.GET_DISABLED_FEATURES):
	      return Object.assign({}, state, {
	        disabledFeatures: action.payload,
	        loadingDisabledFeatures: false
	      });
	    case _App.SHOW_LOGIN_DIALOG:
	      return Object.assign({}, state, {
	        loginDialog: true
	      });
	    case _App.CLOSE_LOGIN_DIALOG:
	      return Object.assign({}, state, {
	        loginDialog: false,
	        incorrectLogin: false
	      });
	    case _App.SET_LOGIN_ERROR_MESSAGE:
	      return Object.assign({}, state, {
	        loginErrorMessage: action.value
	      });
	    case (0, _helpers.request)(_App.LOGIN):
	      return Object.assign({}, state, {
	        loginErrorMessage: null
	      });
	    case (0, _helpers.success)(_App.LOGIN):
	      var expirationTime = (0, _utility.today)().add(action.payload.expires_in_minutes, "minutes").valueOf();
	      delete state.password;
	      window.localStorage.setItem("aa_access_token", action.payload.token);
	
	      return Object.assign({}, state, {
	        loggedIn: true,
	        clients: null,
	        userId: action.payload.userId,
	        roleId: action.payload.roleId,
	        roleName: action.payload.roleName,
	        token: action.payload.token,
	        tokenExpirationTime: expirationTime,
	        loginDialog: false,
	        loginErrorMessage: null
	      });
	    case (0, _helpers.failure)(_App.LOGIN):
	      return Object.assign({}, state, {
	        loggedIn: false,
	        loginDialog: true,
	        loginErrorMessage: "Incorrect username / password."
	      });
	    case _App.LOGOUT:
	      state = (0, _immutable.fromJS)(state);
	      return state.set("loginDialog", false).set("userId", null).set("token", null).toJS();
	    case _App.MOUNT_SESSION:
	      return Object.assign({}, state, {
	        userId: action.value.userId,
	        roleId: action.value.roleId,
	        roleName: action.value.roleName,
	        token: action.value.token,
	        tokenExpirationTime: action.value.tokenExpirationTime,
	        loginTime: action.value.loginTime,
	        apiBuildNumber: action.value.apiBuildNumber
	      });
	    case (0, _helpers.success)(_App.USER_CLIENTS):
	      return Object.assign({}, state, {
	        clients: action.payload
	      });
	    case (0, _helpers.success)(_App.USER_AVATAR):
	      return Object.assign({}, state, {
	        avatar: action.payload
	      });
	    case (0, _helpers.success)(_App.LOGIN_USER_DETAIL):
	      return Object.assign({}, state, {
	        loginUserDetail: action.payload
	      });
	    case (0, _helpers.success)(_App.OPTIMIZE_USER_DETAIL):
	      return Object.assign({}, state, {
	        loadingOptimizeUserDetail: false,
	        optimizeUserDetail: action.payload
	      });
	    case (0, _helpers.request)(_App.OPTIMIZE_USER_DETAIL):
	      return Object.assign({}, state, {
	        loadingOptimizeUserDetail: true
	      });
	    case (0, _helpers.failure)(_App.OPTIMIZE_USER_DETAIL):
	    case (0, _helpers.invalid)(_App.OPTIMIZE_USER_DETAIL):
	    case (0, _helpers.unauthorized)(_App.OPTIMIZE_USER_DETAIL):
	      return Object.assign({}, state, {
	        loadingOptimizeUserDetail: false,
	        optimizeUserDetail: undefined
	      });
	    case (0, _helpers.unauthorized)((0, _helpers.clean)(action.type)):
	      var message = action.payload && action.payload.message ? action.payload.message : "Incorrect username/password";
	      return Object.assign({}, state, {
	        loggedIn: false,
	        loginDialog: true,
	        loginErrorMessage: message
	      });
	    case _App.SET_EMAIL:
	      return Object.assign({}, state, {
	        email: action.value
	      });
	    case _App.SET_PASSWORD:
	      return Object.assign({}, state, {
	        password: action.value
	      });
	    case _App.SELECT_CLIENT:
	      return Object.assign({}, state, {
	        selected_client: action.value
	      });
	    case (0, _helpers.success)(_App.SEND_PASSWORD_RECOVERY):
	      return Object.assign({}, state, {
	        sendRecoveryEmailSuccess: true,
	        sendRecoveryEmailFailMessage: undefined
	      });
	    case (0, _helpers.invalid)(_App.SEND_PASSWORD_RECOVERY):
	    case (0, _helpers.failure)(_App.SEND_PASSWORD_RECOVERY):
	      return Object.assign({}, state, {
	        sendRecoveryEmailSuccess: false,
	        sendRecoveryEmailFailMessage: action.payload.message
	      });
	    case (0, _helpers.success)(_App.GET_API_BUILD_NUMBER):
	      return Object.assign({}, state, {
	        apiBuildNumber: action.payload
	      });
	    case (0, _helpers.success)(_App.RESET_PASSWORD):
	      return Object.assign({}, state, {
	        resetPasswordSuccess: true,
	        resetPasswordFailMessage: undefined
	      });
	    case (0, _helpers.invalid)(_App.RESET_PASSWORD):
	    case (0, _helpers.failure)(_App.RESET_PASSWORD):
	      return Object.assign({}, state, {
	        resetPasswordSuccess: false,
	        resetPasswordFailMessage: action.payload.message
	      });
	    case (0, _helpers.success)(_App.GET_CLIENT_BYID):
	      var pid = action.payload.parentClientId;
	      var isBU = false;
	      var parentClient = undefined;
	      if (pid) {
	        parentClient = (0, _lodash.find)(state["clients"], function (client) {
	          return client.id === pid;
	        });
	        if (!(0, _lodash.isNil)(parentClient)) isBU = true;
	      }
	      if (isBU === true) {
	        return Object.assign({}, state, {
	          client_info: action.payload,
	          parent_client: parentClient
	        });
	      } else {
	        state = (0, _immutable.fromJS)(state);
	        return state.set("client_info", action.payload).remove("parent_client").toJS();
	      }
	
	    case (0, _helpers.failure)(_App.GET_CLIENT_BYID):
	      return Object.assign({}, state, {
	        client_info: ""
	      });
	    case _App.CLEAR_CLIENT_INFO:
	      return Object.assign({}, state, {
	        client_info: undefined
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = app;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _helpers = __webpack_require__(54);
	
	var _Campaign = __webpack_require__(117);
	
	var initialState = exports.initialState = {
	  tables: {}
	};
	var campaigns = function campaigns() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _Campaign.CLEAR_CAMPAIGN_DETAIL:
	      return Object.assign({}, state, {
	        campaignDetail: undefined,
	        campaignDataOnLoading: false,
	        campaignDataLoadErrorMessage: undefined,
	        channelCampaigns: undefined,
	        savingCampaignErrorMessage: undefined
	      });
	    case _Campaign.CLEAR_CMAPAIGNS_CSV_DATA:
	      return Object.assign({}, state, {
	        csvData: undefined
	      });
	    case _Campaign.SET_CAMPAIGN_FILTER_START_DATE:
	      return Object.assign({}, state, {
	        campaignFilterStartDate: action.value
	      });
	    case _Campaign.SET_CAMPAIGN_FILTER_END_DATE:
	      return Object.assign({}, state, {
	        campaignFilterEndDate: action.value
	      });
	    case _Campaign.SET_CAMPAIGN_FILTER_VALUE:
	      return Object.assign({}, state, {
	        campaignFilterValue: action.value
	      });
	    case (0, _helpers.request)(_Campaign.GET_CAMPAIGNS_TABLES):
	      return Object.assign({}, state, {
	        tables: [],
	        campaignDataOnLoading: true,
	        campaignDataLoadErrorMessage: undefined,
	        savingCampaignErrorMessage: undefined
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGNS_CSV_DATA):
	      return Object.assign({}, state, {
	        csvData: action.payload
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGNS_TABLES):
	      return Object.assign({}, state, {
	        tables: action.payload,
	        campaignDataOnLoading: false,
	        campaignDataLoadErrorMessage: undefined
	      });
	    case (0, _helpers.failure)(_Campaign.GET_CAMPAIGNS_TABLES):
	    case (0, _helpers.invalid)(_Campaign.GET_CAMPAIGNS_TABLES):
	      return Object.assign({}, state, {
	        tables: [],
	        campaignDataOnLoading: false,
	        campaignDataLoadErrorMessage: action.payload.message
	      });
	
	    case (0, _helpers.request)(_Campaign.GET_EMAIL_CAMPAIGN_LIST):
	      return Object.assign({}, state, {
	        emailChannelCampaigns: undefined
	      });
	    case (0, _helpers.success)(_Campaign.GET_EMAIL_CAMPAIGN_LIST):
	      return Object.assign({}, state, {
	        emailChannelCampaigns: action.payload
	      });
	    case (0, _helpers.request)(_Campaign.GET_SOCIAL_CAMPAIGN_LIST):
	      return Object.assign({}, state, {
	        socialChannelCampaigns: undefined
	      });
	    case (0, _helpers.success)(_Campaign.GET_SOCIAL_CAMPAIGN_LIST):
	      return Object.assign({}, state, {
	        socialChannelCampaigns: action.payload
	      });
	    case (0, _helpers.request)(_Campaign.GET_DISPLAY_CAMPAIGN_LIST):
	      return Object.assign({}, state, {
	        displayChannelCampaigns: undefined
	      });
	    case (0, _helpers.success)(_Campaign.GET_DISPLAY_CAMPAIGN_LIST):
	      return Object.assign({}, state, {
	        displayChannelCampaigns: action.payload
	      });
	    case (0, _helpers.request)(_Campaign.SAVE_CAMPAIGN_GROUP):
	      return Object.assign({}, state, {
	        onSavingCampaign: true,
	        savingCampaignErrorMessage: undefined
	      });
	    case (0, _helpers.success)(_Campaign.SAVE_CAMPAIGN_GROUP):
	      return Object.assign({}, state, {
	        onSavingCampaign: false,
	        savingCampaignErrorMessage: undefined
	      });
	    case (0, _helpers.failure)(_Campaign.SAVE_CAMPAIGN_GROUP):
	    case (0, _helpers.invalid)(_Campaign.SAVE_CAMPAIGN_GROUP):
	      return Object.assign({}, state, {
	        onSavingCampaign: false,
	        savingCampaignErrorMessage: action.payload.message
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_DETAIL):
	      return Object.assign({}, state, {
	        campaignDetail: action.payload
	      });
	    case (0, _helpers.failure)(_Campaign.GET_CAMPAIGN_TOP_LINK_STATS):
	    case (0, _helpers.invalid)(_Campaign.GET_CAMPAIGN_TOP_LINK_STATS):
	      return Object.assign({}, state, {
	        loadingTopLinkStats: undefined,
	        topLinkStats: undefined
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_TOP_LINK_STATS):
	      return Object.assign({}, state, {
	        loadingTopLinkStats: false,
	        topLinkStats: action.payload
	      });
	    case (0, _helpers.request)(_Campaign.GET_CAMPAIGN_TOP_LINK_STATS):
	      return Object.assign({}, state, {
	        loadingTopLinkStats: true,
	        topLinkStats: undefined
	      });
	    case _Campaign.SET_REPORT_DATE_RANGE:
	      return Object.assign({}, state, {
	        reportDateRange: action.value
	      });
	    case _Campaign.SET_CHANNEL_CAMPAIGN_ID:
	      return Object.assign({}, state, {
	        channelCampaignId: action.value
	      });
	    case _Campaign.SET_SEGMENT_ID:
	      return Object.assign({}, state, {
	        segmentId: action.value
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_GROUP_AGGREGATED):
	      return Object.assign({}, state, {
	        campaignAggregatedReport: action.payload
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_AGGREGATED_BY_CHANNEL):
	      return Object.assign({}, state, {
	        campaignChannelAggregatedReport: action.payload
	      });
	    case (0, _helpers.request)(_Campaign.GET_CAMPAIGN_EMAIL_AGGREGATED):
	      return Object.assign({}, state, {
	        emailAggregatedReport: undefined
	      });
	    case (0, _helpers.request)(_Campaign.GET_CAMPAIGN_EMAIL_STATS_AGGREGATED):
	      return Object.assign({}, state, {
	        emailAggregatedStats: undefined
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_EMAIL_AGGREGATED):
	      return Object.assign({}, state, {
	        emailAggregatedReport: action.payload
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_EMAIL_STATS_AGGREGATED):
	      return Object.assign({}, state, {
	        emailAggregatedStats: action.payload
	      });
	    case (0, _helpers.request)(_Campaign.GET_CAMPAIGN_SOCIAL_AGGREGATED):
	      return Object.assign({}, state, {
	        socialAggregatedReport: undefined
	      });
	    case (0, _helpers.request)(_Campaign.GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED):
	      return Object.assign({}, state, {
	        socialAggregatedStats: undefined
	      });
	    case (0, _helpers.request)(_Campaign.GET_CAMPAIGN_DISPLAY_AGGREGATED):
	      return Object.assign({}, state, {
	        displayAggregatedReport: undefined
	      });
	    case (0, _helpers.request)(_Campaign.GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED):
	      return Object.assign({}, state, {
	        displayAggregatedStats: undefined
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_SOCIAL_AGGREGATED):
	      return Object.assign({}, state, {
	        socialAggregatedReport: action.payload
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED):
	      return Object.assign({}, state, {
	        socialAggregatedStats: action.payload
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_DISPLAY_AGGREGATED):
	      return Object.assign({}, state, {
	        displayAggregatedReport: action.payload
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED):
	      return Object.assign({}, state, {
	        displayAggregatedStats: action.payload
	      });
	    case (0, _helpers.request)(_Campaign.GET_CAMPAIGN_TOP_LOCATION_STATS):
	    case (0, _helpers.failure)(_Campaign.GET_CAMPAIGN_TOP_LOCATION_STATS):
	    case (0, _helpers.invalid)(_Campaign.GET_CAMPAIGN_TOP_LOCATION_STATS):
	      return Object.assign({}, state, {
	        topLocationOpensStats: undefined
	      });
	    case (0, _helpers.success)(_Campaign.GET_CAMPAIGN_TOP_LOCATION_STATS):
	      return Object.assign({}, state, {
	        topLocationOpensStats: action.payload
	      });
	    case _Campaign.CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE:
	      return Object.assign({}, state, {
	        savingCampaignErrorMessage: undefined
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  campaigns: campaigns
	};

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clientBusinessAndUser = exports.initialState = undefined;
	
	var _helpers = __webpack_require__(54);
	
	var _ClientBusinessInfoAndUser = __webpack_require__(504);
	
	var initialState = exports.initialState = {
	  client_business_total: [],
	  search_results: [],
	  all_search_results: [],
	  client_users_total: [],
	  users_results: [],
	  users_all: [],
	  all_users_results: []
	};
	var clientBusinessAndUser = exports.clientBusinessAndUser = function clientBusinessAndUser() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.success)(_ClientBusinessInfoAndUser.GET_CLIENT_BUSINESS_TOTAL):
	      var obj = [];
	      var $obj = [];
	      var len = Object.keys(action.payload);
	      var temp = '';
	      temp = len[1];
	      len[1] = len[2];
	      len[2] = temp;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = len[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var item = _step.value;
	
	          var label = '';
	          var list = '';
	          var $list = '';
	          switch (item) {
	            case 'totalClients':
	              label = 'Total Clients';
	              break;
	            case 'totalBizUnit':
	              label = 'Total Business Units';
	              break;
	            case 'clientsJoinLastMonth':
	              label = 'Joined Last 30 Days';
	              break;
	            case 'bizUnitJoinLastMonth':
	              label = 'Joined Last 30 Days';
	              break;
	            case 'clientUsers':
	              label = 'Client Users';
	              break;
	            case 'bizUnitUsers':
	              label = 'Business Unit Users';
	              break;
	            default:
	              return;
	          }
	          if (label === 'Client Users' || label === 'Business Unit Users') {
	            $list = Object.assign({}, {
	              label: '' + label,
	              value: action.payload[item],
	              item: item
	            });
	            $obj.push($list);
	          } else {
	            list = Object.assign({}, {
	              label: '' + label,
	              value: action.payload[item],
	              item: item
	            });
	            obj.push(list);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        client_business_total: obj,
	        client_users_total: $obj
	      });
	    case (0, _helpers.success)(_ClientBusinessInfoAndUser.CLIENT_BUSINESS_SEARCH):
	      var filterPayload = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = filterPayload.clients.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _list = _step2.value;
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = Object.keys(filterPayload.bizUnits)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var id = _step3.value;
	
	              if (_list.id === parseInt(id, 10)) {
	                _list['children'] = filterPayload.bizUnits[id];
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        search_results: filterPayload
	      });
	    case (0, _helpers.success)(_ClientBusinessInfoAndUser.USERS_SEARCH):
	      var filterP = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = filterP.clientUsers.data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var _list2 = _step4.value;
	          var _iteratorNormalCompletion5 = true;
	          var _didIteratorError5 = false;
	          var _iteratorError5 = undefined;
	
	          try {
	            for (var _iterator5 = Object.keys(filterP.bizUnitUsers)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	              var _id = _step5.value;
	
	              if (_list2.clientId === parseInt(_id, 10)) {
	                _list2['children'] = filterP.bizUnitUsers[_id];
	              }
	            }
	          } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	              }
	            } finally {
	              if (_didIteratorError5) {
	                throw _iteratorError5;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        users_results: filterP
	      });
	    case _ClientBusinessInfoAndUser.CLEAR_USERS_SEARCH:
	      return Object.assign({}, state, {
	        users_results: []
	      });
	    case (0, _helpers.success)(_ClientBusinessInfoAndUser.USERS_SEARCH_ALL_RESULT):
	      var filter_all_result = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = filter_all_result.clientUsers.data[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var _list3 = _step6.value;
	          var _iteratorNormalCompletion7 = true;
	          var _didIteratorError7 = false;
	          var _iteratorError7 = undefined;
	
	          try {
	            for (var _iterator7 = Object.keys(filter_all_result.bizUnitUsers)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	              var _id2 = _step7.value;
	
	              if (_list3.clientId === parseInt(_id2, 10)) {
	                _list3['children'] = filter_all_result.bizUnitUsers[_id2];
	              }
	            }
	          } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                _iterator7.return();
	              }
	            } finally {
	              if (_didIteratorError7) {
	                throw _iteratorError7;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        users_all: filter_all_result
	      });
	    case (0, _helpers.success)(_ClientBusinessInfoAndUser.ALL_SEARCH):
	      var $filterPayload = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion8 = true;
	      var _didIteratorError8 = false;
	      var _iteratorError8 = undefined;
	
	      try {
	        for (var _iterator8 = $filterPayload.clients.data[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	          var _list4 = _step8.value;
	          var _iteratorNormalCompletion9 = true;
	          var _didIteratorError9 = false;
	          var _iteratorError9 = undefined;
	
	          try {
	            for (var _iterator9 = Object.keys($filterPayload.bizUnits)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	              var _id3 = _step9.value;
	
	              if (_list4.id === parseInt(_id3, 10)) {
	                _list4['children'] = $filterPayload.bizUnits[_id3];
	              }
	            }
	          } catch (err) {
	            _didIteratorError9 = true;
	            _iteratorError9 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                _iterator9.return();
	              }
	            } finally {
	              if (_didIteratorError9) {
	                throw _iteratorError9;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError8 = true;
	        _iteratorError8 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion8 && _iterator8.return) {
	            _iterator8.return();
	          }
	        } finally {
	          if (_didIteratorError8) {
	            throw _iteratorError8;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        all_search_results: $filterPayload
	      });
	    case (0, _helpers.success)(_ClientBusinessInfoAndUser.ALL_USERS_SEARCH):
	      var $filterP = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion10 = true;
	      var _didIteratorError10 = false;
	      var _iteratorError10 = undefined;
	
	      try {
	        for (var _iterator10 = $filterP.clientUsers.data[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	          var _list5 = _step10.value;
	          var _iteratorNormalCompletion11 = true;
	          var _didIteratorError11 = false;
	          var _iteratorError11 = undefined;
	
	          try {
	            for (var _iterator11 = Object.keys($filterP.bizUnitUsers)[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	              var _id4 = _step11.value;
	
	              if (_list5.clientId === parseInt(_id4, 10)) {
	                _list5['children'] = $filterP.bizUnitUsers[_id4];
	              }
	            }
	          } catch (err) {
	            _didIteratorError11 = true;
	            _iteratorError11 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                _iterator11.return();
	              }
	            } finally {
	              if (_didIteratorError11) {
	                throw _iteratorError11;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError10 = true;
	        _iteratorError10 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion10 && _iterator10.return) {
	            _iterator10.return();
	          }
	        } finally {
	          if (_didIteratorError10) {
	            throw _iteratorError10;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        all_users_results: $filterP
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  clientBusinessAndUser: clientBusinessAndUser
	};

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(54);
	
	var _Clients = __webpack_require__(49);
	
	var _lodash = __webpack_require__(18);
	
	var initialState = {
	  tableData: "",
	  ifInvitationClientSuccess: false,
	  invitation_client_msg: "",
	  industryOptions: [],
	  ifSendInvitationSuccess: false,
	  // for `invitations/client`
	  send_invitation_error_msg: "",
	  tier_options: [],
	  account_manager: [],
	  client_options: [],
	  client_names: [],
	  tableAllData: [],
	  ifCreateClientProfileSuccess: false, // if create client profile success
	  createClientProfileMessage: "", // create client profile error message
	  teamMember_options: [], // business assign to
	  businessUnitOptions: [],
	  edit_client_profile: [],
	  ifEditClientProfileSuccess: false,
	  business_units_list: [], // for edit/Business-Units page
	  ifInviteBusinessUnitMemberSuccess: false,
	  ifCreateClientProfileSuccessBasic: false,
	  insights_standard_config: "",
	  clientId: "",
	  clientProfileUpdateError: ""
	};
	
	var clients = function clients() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.success)(_Clients.GET_CLIENTS_TABLE):
	      if (action.payload.data.length > 0) {
	        return Object.assign({}, state, {
	          tableData: action.payload
	        });
	      } else {
	        return Object.assign({}, state, {
	          tableData: "empty"
	        });
	      }
	    case (0, _helpers.success)(_Clients.GET_ALL_CLIENTS_TABLE):
	      return Object.assign({}, state, {
	        tableAllData: action.payload.data
	      });
	    case (0, _helpers.success)(_Clients.SEARCH_CLIENTS):
	      if (action.payload.data.length > 0) {
	        return Object.assign({}, state, {
	          tableData: action.payload
	        });
	      } else {
	        return Object.assign({}, state, {
	          tableData: "empty"
	        });
	      }
	    case (0, _helpers.success)(_Clients.INVITATION_CLIENT):
	      return Object.assign({}, state, {
	        ifInvitationClientSuccess: true
	      });
	    case (0, _helpers.invalid)(_Clients.INVITATION_CLIENT):
	      return Object.assign({}, state, {
	        invitation_client_msg: action.payload.message
	      });
	    case (0, _helpers.success)(_Clients.GET_INDUSTRY_OPTIONS):
	      return Object.assign({}, state, {
	        industryOptions: action.payload
	      });
	
	    // for `invitations/client`
	    case (0, _helpers.success)(_Clients.SEND_INVITATION):
	      return Object.assign({}, state, {
	        ifSendInvitationSuccess: true,
	        send_invitation_error_msg: ""
	      });
	    case (0, _helpers.success)(_Clients.INVITE_BUSINESS_MEMBER):
	      return Object.assign({}, state, {
	        ifSendInvitationSuccess: true,
	        send_invitation_error_msg: ""
	      });
	    // for `invitations/client`
	    case (0, _helpers.invalid)(_Clients.SEND_INVITATION):
	      return Object.assign({}, state, {
	        send_invitation_error_msg: action.payload.message
	      });
	    case (0, _helpers.invalid)(_Clients.INVITE_BUSINESS_MEMBER):
	      return Object.assign({}, state, {
	        send_invitation_error_msg: action.payload.message
	      });
	    case (0, _helpers.success)(_Clients.TIER_OPTIONS):
	      return Object.assign({}, state, {
	        tier_options: action.payload
	      });
	    case (0, _helpers.success)(_Clients.ACCOUNT_MANAGER):
	      return Object.assign({}, state, {
	        account_manager: action.payload
	      });
	    case (0, _helpers.success)(_Clients.CLIENT_OPTIONS):
	      return Object.assign({}, state, {
	        client_options: action.payload
	      });
	    case (0, _helpers.success)(_Clients.GET_CLIENT_SITES):
	      var sites = [];
	      (0, _lodash.map)(action.payload, function (site) {
	        sites.push({
	          label: site.label === "Cars.com" ? "auto.com" : site.label,
	          value: site.value,
	          enabled: site.disabled === false
	        });
	      });
	      return Object.assign({}, state, {
	        client_sites: sites
	      });
	    case _Clients.ROLLBACK_STATUS:
	      return Object.assign({}, state, {
	        ifSendInvitationSuccess: action.value,
	        ifInviteBusinessUnitMemberSuccess: action.value,
	        send_invitation_error_msg: ""
	      });
	    case _Clients.ROLLBACK_PROFILE_STATUS:
	      return Object.assign({}, state, {
	        ifCreateClientProfileSuccess: false,
	        ifCreateClientProfileSuccessBasic: false,
	        // for the edit/Client-Profile page
	        ifEditClientProfileSuccess: false,
	        createClientProfileMessage: null
	      });
	    case (0, _helpers.success)(_Clients.CLIENT_NAME):
	      return Object.assign({}, state, {
	        client_names: action.payload
	      });
	    case (0, _helpers.success)(_Clients.CREATE_CLIENT_PROFILE):
	      return Object.assign({}, state, {
	        ifCreateClientProfileSuccessBasic: true,
	        // ifCreateClientProfileSuccess: true,
	        createClientProfileMessage: "",
	        clientId: action.payload.clientId
	      });
	    case (0, _helpers.invalid)(_Clients.CREATE_CLIENT_PROFILE):
	    case (0, _helpers.failure)(_Clients.CREATE_CLIENT_PROFILE):
	      return Object.assign({}, state, {
	        createClientProfileMessage: action.payload.message
	      });
	    case (0, _helpers.success)(_Clients.TEAM_MEMBER):
	      return Object.assign({}, state, {
	        teamMember_options: action.payload
	      });
	    case (0, _helpers.success)(_Clients.BUSINESS_UNIT_OPTIONS):
	      return Object.assign({}, state, {
	        businessUnitOptions: action.payload
	      });
	    // for edit/client-profile/:id
	    case (0, _helpers.success)(_Clients.GET_CLIENT_PROFILE):
	      return Object.assign({}, state, {
	        edit_client_profile: action.payload
	      });
	    case (0, _helpers.success)(_Clients.UPDATE_CLIENT_PROFILE):
	      return Object.assign({}, state, {
	        ifEditClientProfileSuccess: true,
	        clientProfileUpdateError: ""
	      });
	    case (0, _helpers.invalid)(_Clients.UPDATE_CLIENT_PROFILE):
	      return Object.assign({}, state, {
	        ifEditClientProfileSuccess: false,
	        clientProfileUpdateError: action.payload.message
	      });
	    case (0, _helpers.success)(_Clients.SUSPEND_AND_REACTIVATE):
	      window.location.reload();
	      return Object.assign({}, state);
	    case (0, _helpers.success)(_Clients.BUSINESS_UNITS_LIST):
	      return Object.assign({}, state, {
	        business_units_list: action.payload
	      });
	    case (0, _helpers.success)(_Clients.CLIENT_USERS):
	      return Object.assign({}, state, {
	        client_team_members: action.payload
	      });
	    case (0, _helpers.success)(_Clients.GET_BUSINESS_UNIT_TEAM_MEMBER):
	      return Object.assign({}, state, {
	        client_team_members: action.payload
	      });
	    case (0, _helpers.success)(_Clients.INVITATE_BUSINESS_UNIT_MEMBER):
	      return Object.assign({}, state, {
	        ifInviteBusinessUnitMemberSuccess: true
	      });
	    case (0, _helpers.invalid)(_Clients.INVITATE_BUSINESS_UNIT_MEMBER):
	      return Object.assign({}, state, {
	        send_invitation_error_msg: action.payload.message
	      });
	    case (0, _helpers.request)(_Clients.GET_CLIENT_TAGS):
	      return Object.assign({}, state, {
	        client_tags_on_loading: true
	      });
	    case (0, _helpers.success)(_Clients.GET_CLIENT_TAGS):
	      return Object.assign({}, state, {
	        client_tags: action.payload,
	        client_tags_on_loading: false
	      });
	    case (0, _helpers.success)(_Clients.INSIGHTS_STANDARD_CONFIG):
	      return Object.assign({}, state, {
	        clientId: "",
	        ifCreateClientProfileSuccess: true
	      });
	    case (0, _helpers.success)(_Clients.GET_INSIGHTS_STANDARD_CONFIG):
	      return Object.assign({}, state, {
	        insights_standard_config: action.payload
	      });
	    case _Clients.RESET_STANDARD_CONFIG:
	      return Object.assign({}, state, {
	        insights_standard_config: ""
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  clients: clients
	};

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(54);
	
	var _CreateAccount = __webpack_require__(210);
	
	var initialState = {
	  ifRequestSuccess: false,
	  all_state: [],
	  department: [],
	  get_invitation_by_code: {
	    departments: [],
	    states: [],
	    timezones: []
	  },
	  error: '', // for register error
	  successResponse: '',
	  uploadSuccessResponse: '',
	  uploadErrorMsg: '', // for upload error,
	  // for error when inviation code is invalid
	  invitation_error_message: ''
	};
	
	var create_account = function create_account() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _CreateAccount.CREATE_ACCOUNT:
	      return Object.assign({}, state);
	    case (0, _helpers.success)(_CreateAccount.GET_DEPARTMENT):
	      return Object.assign({}, state, {
	        department: action.payload
	      });
	    case (0, _helpers.success)(_CreateAccount.GETINVITATIONBYCODE):
	      return Object.assign({}, state, {
	        get_invitation_by_code: action.payload
	      });
	    case (0, _helpers.invalid)(_CreateAccount.GETINVITATIONBYCODE):
	      return Object.assign({}, state, {
	        invitation_error_message: action.payload.message
	      });
	    case (0, _helpers.success)(_CreateAccount.REGISTER):
	      return Object.assign({}, state, {
	        ifRequestSuccess: true,
	        error: '',
	        successResponse: action.payload
	      });
	    case (0, _helpers.invalid)(_CreateAccount.REGISTER):
	      return Object.assign({}, state, {
	        error: action.payload.message
	      });
	    case (0, _helpers.success)(_CreateAccount.UPLOAD):
	      return Object.assign({}, state, {
	        uploadSuccessResponse: action.payload
	      });
	    case (0, _helpers.failure)(_CreateAccount.UPLOAD):
	      return Object.assign({}, state, {
	        uploadErrorMsg: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  create_account: create_account
	};

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(54);
	
	var _CreateClientAccount = __webpack_require__(505);
	
	var initialState = {
	  ifRegisterSuccess: false,
	  error_message: ''
	};
	
	var create_client_account = function create_client_account() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.success)(_CreateClientAccount.REGISTER):
	      return Object.assign({}, state, {
	        ifRegisterSuccess: true,
	        error_message: ''
	      });
	    case (0, _helpers.invalid)(_CreateClientAccount.REGISTER):
	      return Object.assign({}, state, {
	        ifRegisterSuccess: false,
	        error_message: action.payload.message
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  create_client_account: create_client_account
	};

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.dashboard = undefined;
	
	var _helpers = __webpack_require__(54);
	
	var _Dashboard = __webpack_require__(506);
	
	var initializeState = {
		client_subscription_stats: undefined,
		client_stats: undefined,
		client_tag_stats: undefined,
		insights_stats: undefined
	};
	var dashboard = exports.dashboard = function dashboard() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeState;
		var action = arguments[1];
	
		switch (action.type) {
			case (0, _helpers.success)(_Dashboard.GET_CLIENT_SUBSCRIPTION_STATS):
				return Object.assign({}, state, {
					client_subscription_stats: action.payload
				});
			case (0, _helpers.success)(_Dashboard.GET_CLIENT_STATS):
				return Object.assign({}, state, {
					client_stats: action.payload
				});
			case (0, _helpers.success)(_Dashboard.GET_CLIENT_TAG_STATS):
				return Object.assign({}, state, {
					client_tag_stats: action.payload
				});
			case (0, _helpers.success)(_Dashboard.GET_INSIGHTS_PERIOD_STATS):
				return Object.assign({}, state, {
					insights_stats: action.payload
				});
			case _Dashboard.CLEAR_DASHBOARD_STATS:
				return Object.assign({}, initializeState);
			default:
				return state;
		}
	};
	
	exports.default = {
		dashboard: dashboard
	};

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(54);
	
	var _employees = __webpack_require__(119);
	
	var initialState = {
	  roles: [],
	  clientRoles: [],
	  ifSendInviteSuccess: false,
	  tableList: {},
	  ifUpdateSuccess: false,
	  updateErrorText: '',
	  sendInvite_error_message: '',
	  ifUpdateRoleSuccess: false,
	  client_assignments: [],
	  ifReassignSuccess: false,
	  suspend_error: '',
	  client_assignments_error: '',
	  team_member_options: [],
	  account_manager: []
	};
	
	var employees = function employees() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.success)(_employees.GETROLE):
	      return Object.assign({}, state, {
	        roles: action.payload
	      });
	    case (0, _helpers.success)(_employees.GETCLIENTROLES):
	      return Object.assign({}, state, {
	        clientRoles: action.payload
	      });
	    case (0, _helpers.success)(_employees.ACCOUNT_MANAGER):
	      return Object.assign({}, state, {
	        account_manager: action.payload
	      });
	    case (0, _helpers.success)(_employees.SENDINVITE):
	      return Object.assign({}, state, {
	        ifSendInviteSuccess: true,
	        sendInvite_error_message: ''
	      });
	    case (0, _helpers.invalid)(_employees.SENDINVITE):
	      return Object.assign({}, state, {
	        sendInvite_error_message: action.payload.message
	      });
	    case (0, _helpers.failure)(_employees.SENDINVITE):
	      {
	        return Object.assign({}, state, {
	          sendInvite_error_message: action.payload.message
	        });
	      }
	    case (0, _helpers.success)(_employees.SENDCLIENTINVITE):
	      return Object.assign({}, state, {
	        ifSendInviteSuccess: true,
	        sendInvite_error_message: ''
	      });
	    case (0, _helpers.invalid)(_employees.SENDCLIENTINVITE):
	      return Object.assign({}, state, {
	        sendInvite_error_message: action.payload.message
	      });
	    case _employees.SET_STATUS_TO_FALSE:
	      return Object.assign({}, state, {
	        ifSendInviteSuccess: action.value,
	        sendInvite_error_message: null
	      });
	    case (0, _helpers.success)(_employees.GET_TABLE_LIST):
	      return Object.assign({}, state, {
	        tableList: action.payload
	      });
	    case (0, _helpers.success)(_employees.UPDATE_PROFILE):
	      return Object.assign({}, state, {
	        ifUpdateSuccess: true,
	        updateErrorText: ''
	      });
	    case (0, _helpers.failure)(_employees.UPDATE_PROFILE):
	      return Object.assign({}, state, {
	        updateErrorText: action.payload.message
	      });
	    case (0, _helpers.invalid)(_employees.UPDATE_PROFILE):
	      return Object.assign({}, state, {
	        updateErrorText: action.payload.message
	      });
	    case _employees.ROLLBACK_UPDATE_STATUS:
	      return Object.assign({}, state, {
	        ifUpdateSuccess: action.value,
	        ifUpdateRoleSuccess: action.value
	      });
	    case (0, _helpers.success)(_employees.UPDATE_ROLE):
	      return Object.assign({}, state, {
	        ifUpdateRoleSuccess: true
	      });
	    case (0, _helpers.success)(_employees.SUSPEND_USER):
	      window.location.reload();
	      return Object.assign({}, state);
	    case (0, _helpers.invalid)(_employees.SUSPEND_USER):
	      return Object.assign({}, state, {
	        suspend_error: action.payload.message
	      });
	    case _employees.CLEAR_SUSPEND_ERROR:
	      return Object.assign({}, state, {
	        suspend_error: ''
	      });
	    case (0, _helpers.success)(_employees.CLIENT_ASSIGNMENTS):
	      return Object.assign({}, state, {
	        client_assignments: action.payload,
	        client_assignments_error: ''
	      });
	    case (0, _helpers.invalid)(_employees.CLIENT_ASSIGNMENTS):
	      return Object.assign({}, state, {
	        client_assignments_error: 'You are not a account manager'
	      });
	    case (0, _helpers.success)(_employees.REASSIGN_ACCOUNT_MANAGER):
	      return Object.assign({}, state, {
	        ifReassignSuccess: true
	      });
	    case _employees.REASSIGN_ROLL_BACK:
	      return Object.assign({}, state, {
	        ifReassignSuccess: false
	      });
	    case _employees.TEAM_MEMBER_OPTIONS:
	      return Object.assign({}, state, {
	        team_member_options: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  employees: employees
	};

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(1631);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _redux = __webpack_require__(501);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	var _segment = __webpack_require__(1231);
	
	var _segment2 = _interopRequireDefault(_segment);
	
	var _segmentList = __webpack_require__(1232);
	
	var _segmentList2 = _interopRequireDefault(_segmentList);
	
	var _employees = __webpack_require__(1226);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _insights = __webpack_require__(1228);
	
	var _insights2 = _interopRequireDefault(_insights);
	
	var _createAccount = __webpack_require__(1223);
	
	var _createAccount2 = _interopRequireDefault(_createAccount);
	
	var _createClientAccount = __webpack_require__(1224);
	
	var _createClientAccount2 = _interopRequireDefault(_createClientAccount);
	
	var _clients = __webpack_require__(1222);
	
	var _clients2 = _interopRequireDefault(_clients);
	
	var _app = __webpack_require__(1219);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _settings = __webpack_require__(1233);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _App = __webpack_require__(27);
	
	var _profile = __webpack_require__(1230);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _dashboard = __webpack_require__(1225);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _tagsInfo = __webpack_require__(1235);
	
	var _tagsInfo2 = _interopRequireDefault(_tagsInfo);
	
	var _clientBusinessAndUser = __webpack_require__(1221);
	
	var _clientBusinessAndUser2 = _interopRequireDefault(_clientBusinessAndUser);
	
	var _subscriptionInfo = __webpack_require__(1234);
	
	var _subscriptionInfo2 = _interopRequireDefault(_subscriptionInfo);
	
	var _insightsInfo = __webpack_require__(1229);
	
	var _insightsInfo2 = _interopRequireDefault(_insightsInfo);
	
	var _campaigns = __webpack_require__(1220);
	
	var _campaigns2 = _interopRequireDefault(_campaigns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reducers = (0, _assign2.default)({
	  routing: _reactRouterRedux.routerReducer,
	  app: _app2.default
	}, _segment2.default, _segmentList2.default, _employees2.default, _createAccount2.default, _createClientAccount2.default, _clients2.default, _insights2.default, _profile2.default, _settings2.default, _dashboard2.default, _tagsInfo2.default, _clientBusinessAndUser2.default, _subscriptionInfo2.default, _insightsInfo2.default, _campaigns2.default);
	
	var combinedReducers = (0, _redux.combineReducers)(reducers);
	
	exports.default = function (state, action) {
	  if (action.type === _App.LOGOUT) {
	    var _state = state,
	        routing = _state.routing;
	
	    state = { routing: routing };
	  }
	  return combinedReducers(state, action);
	};

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.insights = undefined;
	
	var _helpers = __webpack_require__(54);
	
	var _Insights = __webpack_require__(58);
	
	var _tags = __webpack_require__(211);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var localWebsiteId = window.localStorage.getItem("__websiteId__");
	var initialState = {
	  tag_variables: [],
	  dayRange: window.localStorage.getItem("dayRange"),
	  granularity: window.localStorage.getItem("granularity"),
	  websiteId: localWebsiteId !== undefined ? +localWebsiteId : undefined
	};
	
	var mockTopAttrStr = '{"demographic":[{"id":203,"name":"Dwelling Type","valueId":2030001,"value":"S","label":"Single Family","visitors":121,"visitorPercentage":0.8402778},{"id":113,"name":"Preferred Channel","valueId":1130011,"value":"K","label":"Brick/Mortar","visitors":109,"visitorPercentage":0.13374233},{"id":108,"name":"Ethnicity","valueId":1080011,"value":"K","label":"Western European","visitors":105,"visitorPercentage":0.7},{"id":113,"name":"Preferred Channel","valueId":1130001,"value":"A","label":"Broadcast/Cable TV","visitors":99,"visitorPercentage":0.121472396},{"id":201,"name":"Home Owner","valueId":2010001,"value":"Y","label":"Yes","visitors":98,"visitorPercentage":0.80991733},{"id":113,"name":"Preferred Channel","valueId":1130004,"value":"D","label":"Internet Radio","visitors":93,"visitorPercentage":0.11411043},{"id":113,"name":"Preferred Channel","valueId":1130010,"value":"J","label":"Satellite Radio","visitors":91,"visitorPercentage":0.11165644},{"id":113,"name":"Preferred Channel","valueId":1130008,"value":"H","label":"Online Streaming TV","visitors":89,"visitorPercentage":0.10920245},{"id":112,"name":"Membership","valueId":1120002,"value":"B","label":"Union Member","visitors":88,"visitorPercentage":0.6875},{"id":113,"name":"Preferred Channel","valueId":1130013,"value":"M","label":"E-tailer","visitors":87,"visitorPercentage":0.10674847}],"behavioral":[{"id":460,"name":"Travel","valueId":4600004,"value":"D","label":"Frequent Cruise","visitors":91,"visitorPercentage":0.18019801},{"id":460,"name":"Travel","valueId":4600001,"value":"A","label":"Frequent Domestic Vacation","visitors":91,"visitorPercentage":0.18019801},{"id":402,"name":"Online Buyer","valueId":4020023,"value":"W","label":"Tools/Automotive","visitors":90,"visitorPercentage":0.06451613},{"id":460,"name":"Travel","valueId":4600005,"value":"E","label":"Frequent Flyer","visitors":87,"visitorPercentage":0.17227723},{"id":460,"name":"Travel","valueId":4600006,"value":"F","label":"Hotel Program Members","visitors":87,"visitorPercentage":0.17227723},{"id":460,"name":"Travel","valueId":4600003,"value":"C","label":"Frequent Business Travel","visitors":87,"visitorPercentage":0.17227723},{"id":407,"name":"Movies","valueId":4070001,"value":"A","label":"Attended in Last 6 months","visitors":85,"visitorPercentage":0.4314721},{"id":422,"name":"Restaurant Style","valueId":4220001,"value":"A","label":"Eats Family Style","visitors":84,"visitorPercentage":0.54901963},{"id":423,"name":"Reading","valueId":4230001,"value":"A","label":"Book Reader","visitors":83,"visitorPercentage":0.38967136},{"id":402,"name":"Online Buyer","valueId":4020005,"value":"E","label":"Food and Beverage","visitors":82,"visitorPercentage":0.058781363}]}';
	var mockHeatMapStr = '[{"lon":-95.9374,"lat":41.2596,"u":8},{"lon":-71.4133,"lat":41.8238,"u":1},{"lon":-95.9374,"lat":41.2596,"u":1},{"lon":-87.9067,"lat":43.0386,"u":1},{"lon":-84.3884,"lat":33.7486,"u":3},{"lon":-84.4567,"lat":39.5538,"u":1},{"lon":-84.7632,"lat":42.7448,"u":1},{"lon":-86.4201,"lat":37.1031,"u":1},{"lon":-117.6848,"lat":33.649,"u":1},{"lon":-95.9374,"lat":41.2596,"u":1},{"lon":-95.9374,"lat":41.2596,"u":1},{"lon":-97.1183,"lat":32.6288,"u":1},{"lon":-122.773,"lat":38.2181,"u":1}]';
	var top20Buisiness = "[]";
	//'[{"companyId":367197654,"companyName":"Mo******","industry":"Professional, Scientific, and Technical Services","revenue":66744000,"employees":150,"age":26},{"companyId":393134143,"companyName":"Go******","industry":"Information","revenue":827000,"employees":3,"age":null},{"companyId":545492985,"companyName":"So******","industry":"Construction","revenue":46457000,"employees":200,"age":null},{"companyId":427222250,"companyName":"Sn******","industry":"Professional, Scientific, and Technical Services","revenue":509000,"employees":2,"age":null},{"companyId":711379982,"companyName":"Ac******","industry":"Information","revenue":null,"employees":1500,"age":49},{"companyId":725787613,"companyName":"Lu******","industry":"Finance and Insurance","revenue":598000,"employees":2,"age":38}]';
	var insights = exports.insights = function insights() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.request)(_Insights.STATS_BY_DEVICE_TYPE):
	      return Object.assign({}, state, {
	        loadingStatsByDeviceType: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_BY_DEVICE_TYPE):
	      return Object.assign({}, state, {
	        statsByDevice: action.payload,
	        loadingStatsByDeviceType: false
	      });
	    case (0, _helpers.request)(_Insights.STATS_BY_DEVICE_MODEL):
	      return Object.assign({}, state, {
	        loadingStatsByDeviceModel: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_BY_DEVICE_MODEL):
	      return Object.assign({}, state, {
	        statsByDeviceModel: action.payload,
	        loadingStatsByDeviceModel: false
	      });
	    case (0, _helpers.request)(_Insights.STATS_BY_OS_TYPE):
	      return Object.assign({}, state, {
	        loadingStatsByOsType: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_BY_OS_TYPE):
	      return Object.assign({}, state, {
	        statsByOsType: action.payload,
	        loadingStatsByOsType: false
	      });
	    case (0, _helpers.request)(_Insights.STATS_BY_TIME):
	      return Object.assign({}, state, {
	        loadingStatsByTime: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_BY_TIME):
	      return Object.assign({}, state, {
	        statsByTime: action.payload,
	        loadingStatsByTime: false
	      });
	    case (0, _helpers.request)(_Insights.STATS_BY_POPULAR_PAGE):
	      return Object.assign({}, state, {
	        loadingStatsByPopularPage: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_BY_POPULAR_PAGE):
	      return Object.assign({}, state, {
	        statsByPopularPages: action.payload,
	        loadingStatsByPopularPage: false
	      });
	    case (0, _helpers.request)(_Insights.STATS_BY_REGIONAL_TRAFFIC):
	      return Object.assign({}, state, {
	        loadingStatsByRegionalTraffic: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_BY_REGIONAL_TRAFFIC):
	      return Object.assign({}, state, {
	        statsByRegionalTraffic: action.payload,
	        loadingStatsByRegionalTraffic: false
	      });
	    case (0, _helpers.request)(_Insights.STATS_BY_TIME_OF_DAY):
	      return Object.assign({}, state, {
	        loadingStatsByTimeOfDay: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_BY_TIME_OF_DAY):
	      return Object.assign({}, state, {
	        statsByTimeOfDay: action.payload,
	        loadingStatsByTimeOfDay: false
	      });
	    case (0, _helpers.request)(_Insights.STATS_BY_DEMOGRAPHIC):
	      return Object.assign({}, state, {
	        loadingStatsByDemographic: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_BY_DEMOGRAPHIC):
	      return Object.assign({}, state, {
	        statsByDemographic: action.payload,
	        loadingStatsByDemographic: false
	      });
	    case (0, _helpers.request)(_Insights.STATS_BY_PRIMARY_DEVICES):
	      return Object.assign({}, state, {
	        loadingStatsByPrimaryDevices: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_BY_PRIMARY_DEVICES):
	      return Object.assign({}, state, {
	        statsByPrimaryDevices: action.payload,
	        loadingStatsByPrimaryDevices: false
	      });
	    case (0, _helpers.request)(_Insights.STATS_TOP_ATTRIBUTES):
	      return Object.assign({}, state, {
	        loadingStatsTopAttributes: true
	      });
	    case (0, _helpers.success)(_Insights.STATS_TOP_ATTRIBUTES):
	      return Object.assign({}, state, {
	        statsTopAttributes: action.payload,
	        loadingStatsTopAttributes: false
	      });
	    case (0, _helpers.invalid)(_Insights.STATS_TOP_ATTRIBUTES):
	    case (0, _helpers.failure)(_Insights.STATS_TOP_ATTRIBUTES):
	      return Object.assign({}, state, {
	        statsTopAttributes: JSON.parse(mockTopAttrStr),
	        loadingStatsTopAttributes: false
	      });
	    case _Insights.CLEAR_ALL_STATS:
	      return Object.assign({}, state, {
	        statsByDemographic: undefined,
	        statsByDevice: undefined,
	        statsByPopularPages: undefined,
	        statsByRegionalTraffic: undefined,
	        statsByTime: undefined,
	        statsByTimeOfDay: undefined,
	        statsTopAttributes: undefined,
	        statsByPrimaryDevices: undefined,
	        heatMapPoints: undefined
	      });
	    case _Insights.SET_REPORT_DAY_RANGE:
	      window.localStorage.setItem("dayRange", action.value);
	      return Object.assign({}, state, {
	        dayRange: action.value
	      });
	    case _Insights.SET_REPORT_GRANULARITY:
	      window.localStorage.setItem("granularity", action.value);
	      return Object.assign({}, state, {
	        granularity: action.value
	      });
	    case _Insights.SET_REPORT_WEBSITE_ID:
	      window.localStorage.setItem("__websiteId__", action.value);
	      return Object.assign({}, state, {
	        websiteId: action.value
	      });
	    case (0, _helpers.request)(_Insights.GET_HEAT_MAP_DATA):
	      return Object.assign({}, state, {
	        loadingStatsByRegionalTraffic: true
	      });
	    case (0, _helpers.success)(_Insights.GET_HEAT_MAP_DATA):
	      return Object.assign({}, state, {
	        heatMapPoints: action.payload,
	        loadingStatsByRegionalTraffic: false
	      });
	    case (0, _helpers.invalid)(_Insights.GET_HEAT_MAP_DATA):
	    case (0, _helpers.failure)(_Insights.GET_HEAT_MAP_DATA):
	      return Object.assign({}, state, {
	        loadingStatsByRegionalTraffic: false,
	        heatMapPoints: JSON.parse(mockHeatMapStr)
	      });
	    case _tags.TAG_WEBSITE_NAME:
	      return Object.assign({}, state, {
	        website_name: action.value
	      });
	    case _tags.TAG_WEBSITE_URL:
	      return Object.assign({}, state, {
	        website_url: action.value
	      });
	    case _tags.TAG_CAMPAIGN_NAME:
	      return Object.assign({}, state, {
	        campaign_name: action.value
	      });
	    case (0, _helpers.success)(_tags.GENERATE_TAG):
	      return Object.assign({}, state, {
	        tag_info: action.payload,
	        tag_error_message: undefined,
	        tag_variables: []
	      });
	    case (0, _helpers.success)(_tags.UPDATE_TAG):
	      return Object.assign({}, state, {
	        tag_info: action.payload,
	        tag_error_message: undefined,
	        tag_variables: [],
	        tag_updated_success: true
	      });
	    case (0, _helpers.request)(_tags.UPDATE_TAG):
	      return Object.assign({}, state, {
	        tag_updated_success: undefined
	      });
	    case (0, _helpers.invalid)(_tags.GENERATE_TAG):
	    case (0, _helpers.failure)(_tags.GENERATE_TAG):
	      return Object.assign({}, state, {
	        tag_info: undefined,
	        tag_error_message: action.payload.message
	      });
	    case (0, _helpers.invalid)(_tags.UPDATE_TAG):
	    case (0, _helpers.failure)(_tags.UPDATE_TAG):
	      return Object.assign({}, state, {
	        tag_info: undefined,
	        tag_error_message: action.payload.message,
	        tag_updated_success: undefined
	      });
	    case (0, _helpers.success)(_tags.SAVE_TAG):
	      return Object.assign({}, state, {
	        tag_info: undefined,
	        website_name: undefined,
	        website_url: undefined,
	        tag_error_message: undefined
	      });
	    case (0, _helpers.invalid)(_tags.SAVE_TAG):
	    case (0, _helpers.failure)(_tags.SAVE_TAG):
	      return Object.assign({}, state, {
	        tag_error_message: action.payload.message
	      });
	
	    case _tags.CLEAR_INSIGHT_TAG_INFO:
	      return Object.assign({}, state, {
	        tag_id: undefined,
	        tag_js_code: undefined,
	        tag_info: undefined,
	        website_name: undefined,
	        website_url: undefined,
	        campaign_name: undefined
	      });
	
	    case _tags.CLEAR_TAG_ERROR:
	      return Object.assign({}, state, {
	        tag_error_message: undefined,
	        tag_updated_success: undefined
	      });
	    case (0, _helpers.success)(_tags.GET_TAG_DETAIL):
	      return Object.assign({}, state, {
	        tag_info: action.payload
	      });
	    case _Insights.CLEAR_AUDIENCE_FILES_DATA:
	      return Object.assign({}, state, {
	        audience_file_data: undefined
	      });
	    /*
	    case ADD_TAG_VARIABLE:
	    const vars = state.tag_variables
	    if (vars.length < 5)
	    vars.push("")
	    return{
	    ...state,
	    tag_variables: vars
	    }*/
	    case (0, _helpers.success)(_Insights.GET_AUDIENCE_FILES_DATA):
	      return Object.assign({}, state, {
	        audience_file_data: action.payload
	      });
	    case (0, _helpers.success)(_Insights.GET_TAG_AUDIENCE_FILES):
	      return Object.assign({}, state, {
	        audience_files: action.payload
	      });
	    case (0, _helpers.request)(_Insights.DOWNLOAD_AUDIENCE_FILES):
	      return Object.assign({}, state, {
	        audience_file_error: undefined,
	        audience_file_blob: undefined
	      });
	    case (0, _helpers.success)(_Insights.DOWNLOAD_AUDIENCE_FILES):
	      return Object.assign({}, state, {
	        audience_file_blob: action.payload
	      });
	    case (0, _helpers.invalid)(_Insights.DOWNLOAD_AUDIENCE_FILES):
	    case (0, _helpers.failure)(_Insights.DOWNLOAD_AUDIENCE_FILES):
	      return Object.assign({}, state, {
	        audience_file_error: action.payload ? action.payload.message : "Error when download audience file, please try again"
	      });
	    case (0, _helpers.request)(_Insights.SEND_ASSIST_REQUEST):
	      return Object.assign({}, state, {
	        send_assist_request_error: undefined,
	        request_assist_successful: undefined
	      });
	    case (0, _helpers.success)(_Insights.SEND_ASSIST_REQUEST):
	      return Object.assign({}, state, {
	        send_assist_request_error: undefined,
	        request_assist_successful: true
	      });
	    case (0, _helpers.invalid)(_Insights.SEND_ASSIST_REQUEST):
	    case (0, _helpers.failure)(_Insights.SEND_ASSIST_REQUEST):
	      return Object.assign({}, state, {
	        send_assist_request_error: "Message send failure. Please try again later...",
	        request_assist_successful: false
	      });
	    case (0, _helpers.request)(_Insights.OVERVIEW_TRAFFIC_REPORT):
	      return Object.assign({}, state, {
	        loadingOverviewTraffic: true,
	        overviewTrafficReport: undefined
	      });
	    case (0, _helpers.success)(_Insights.OVERVIEW_TRAFFIC_REPORT):
	      return Object.assign({}, state, {
	        loadingOverviewTraffic: false,
	        overviewTrafficReport: action.payload
	      });
	    case (0, _helpers.invalid)(_Insights.OVERVIEW_TRAFFIC_REPORT):
	    case (0, _helpers.failure)(_Insights.OVERVIEW_TRAFFIC_REPORT):
	      return Object.assign({}, state, {
	        loadingOverviewTraffic: false,
	        overviewTrafficReport: undefined
	      });
	    case (0, _helpers.request)(_Insights.DOMESTIC_CONSUMER_VISITS_REPORT):
	      return Object.assign({}, state, {
	        loadingDomesticConsumerVisits: true,
	        domesticConsumerVisitsReport: undefined
	      });
	    case (0, _helpers.success)(_Insights.DOMESTIC_CONSUMER_VISITS_REPORT):
	      return Object.assign({}, state, {
	        loadingDomesticConsumerVisits: false,
	        domesticConsumerVisitsReport: action.payload
	      });
	    case (0, _helpers.invalid)(_Insights.DOMESTIC_CONSUMER_VISITS_REPORT):
	    case (0, _helpers.failure)(_Insights.DOMESTIC_CONSUMER_VISITS_REPORT):
	      return Object.assign({}, state, {
	        loadingDomesticConsumerVisits: false,
	        domesticConsumerVisitsReport: undefined
	      });
	    case (0, _helpers.request)(_Insights.DOMESTIC_BUSINESS_STATS):
	      return Object.assign({}, state, {
	        loadingDomesticBusiness: true,
	        domesticBusinessVisitsReport: undefined
	      });
	    case (0, _helpers.success)(_Insights.DOMESTIC_BUSINESS_STATS):
	      return Object.assign({}, state, {
	        loadingDomesticBusiness: false,
	        domesticBusinessVisitsReport: action.payload
	      });
	    case (0, _helpers.invalid)(_Insights.DOMESTIC_BUSINESS_STATS):
	    case (0, _helpers.failure)(_Insights.DOMESTIC_BUSINESS_STATS):
	      return Object.assign({}, state, {
	        loadingDomesticBusiness: false,
	        domesticBusinessVisitsReport: undefined
	      });
	    case _Insights.CLEAR_ALL_DOMESTIC_STATS:
	      return Object.assign({}, state, {
	        overviewTrafficReport: undefined,
	        statsByTime: undefined,
	        domesticBusinessVisitsReport: undefined,
	        domesticConsumerVisitsReport: undefined
	      });
	    case (0, _helpers.request)(_Insights.GET_DOMESTIC_VISITS):
	      return Object.assign({}, state, {
	        loadingDomesticVisitsSummary: true
	      });
	    case (0, _helpers.success)(_Insights.GET_DOMESTIC_VISITS):
	      return Object.assign({}, state, {
	        domesticVisitsSummary: action.payload,
	        loadingDomesticVisitsSummary: false
	      });
	    case (0, _helpers.request)(_Insights.GET_TOP_20_FREQUENCY_BUSINESSES):
	      return Object.assign({}, state, {
	        loadingTop20FrequencyBusinesses: true,
	        top20FrequencyBusinesses: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_TOP_20_FREQUENCY_BUSINESSES):
	      return Object.assign({}, state, {
	        loadingTop20FrequencyBusinesses: false,
	        top20FrequencyBusinesses: action.payload
	      });
	    case (0, _helpers.failure)(_Insights.GET_TOP_20_FREQUENCY_BUSINESSES):
	    case (0, _helpers.invalid)(_Insights.GET_TOP_20_FREQUENCY_BUSINESSES):
	      return Object.assign({}, state, {
	        loadingTop20FrequencyBusinesses: false,
	        top20FrequencyBusinesses: JSON.parse(top20Buisiness)
	      });
	    case (0, _helpers.request)(_Insights.GET_SEGMENT_DISTRIBUTION):
	      return Object.assign({}, state, {
	        loadingSegmentDistribution: true,
	        segmentDistributionHouseHold: undefined,
	        top5OSBreakDown: undefined,
	        detailDistributionReport: undefined,
	        deviceModelReport: undefined,
	        deviceTypeReport: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_SEGMENT_DISTRIBUTION):
	      return Object.assign({}, state, {
	        loadingSegmentDistribution: false,
	        segmentDistributionHouseHold: action.payload
	      });
	    case (0, _helpers.failure)(_Insights.GET_SEGMENT_DISTRIBUTION):
	    case (0, _helpers.invalid)(_Insights.GET_SEGMENT_DISTRIBUTION):
	      return Object.assign({}, state, {
	        loadingSegmentDistribution: false,
	        segmentDistributionHouseHold: undefined
	      });
	    case (0, _helpers.request)(_Insights.GET_TOP_5_OS_BREAKDOWN_REPORT):
	      return Object.assign({}, state, {
	        loadingTop5OSBreakdown: true,
	        top5OSBreakDown: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_TOP_5_OS_BREAKDOWN_REPORT):
	      return Object.assign({}, state, {
	        loadingTop5OSBreakdown: false,
	        top5OSBreakDown: action.payload
	      });
	    case (0, _helpers.failure)(_Insights.GET_TOP_5_OS_BREAKDOWN_REPORT):
	    case (0, _helpers.invalid)(_Insights.GET_TOP_5_OS_BREAKDOWN_REPORT):
	      return Object.assign({}, state, {
	        loadingTop5OSBreakdown: false,
	        top5OSBreakDown: undefined
	      });
	    case (0, _helpers.request)(_Insights.GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT):
	      return Object.assign({}, state, {
	        loadingDistributionDetailReport: true,
	        detailDistributionReport: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT):
	      return Object.assign({}, state, {
	        loadingDistributionDetailReport: false,
	        detailDistributionReport: action.payload
	      });
	    case (0, _helpers.failure)(_Insights.GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT):
	    case (0, _helpers.invalid)(_Insights.GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT):
	      return Object.assign({}, state, {
	        loadingDistributionDetailReport: false,
	        detailDistributionReport: undefined
	      });
	    case (0, _helpers.request)(_Insights.GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT):
	      return Object.assign({}, state, {
	        loadDeviceModelReport: true,
	        deviceModelReport: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT):
	      return Object.assign({}, state, {
	        loadDeviceModelReport: false,
	        deviceModelReport: action.payload
	      });
	    case (0, _helpers.failure)(_Insights.GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT):
	    case (0, _helpers.invalid)(_Insights.GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT):
	      return Object.assign({}, state, {
	        loadDeviceModelReport: false,
	        deviceModelReport: undefined
	      });
	    case (0, _helpers.request)(_Insights.GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT):
	      return Object.assign({}, state, {
	        loadDeviceTypeReport: true,
	        deviceTypeReport: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT):
	      return Object.assign({}, state, {
	        loadDeviceTypeReport: false,
	        deviceTypeReport: action.payload
	      });
	    case (0, _helpers.failure)(_Insights.GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT):
	    case (0, _helpers.invalid)(_Insights.GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT):
	      return Object.assign({}, state, {
	        loadDeviceTypeReport: false,
	        deviceTypeReport: undefined
	      });
	    case (0, _helpers.request)(_Insights.GET_INSIGHTS_POPULAR_PAGES):
	      return Object.assign({}, state, {
	        loadingPopularPages: true,
	        mostPopularPages: undefined,
	        loadingPopularPagesError: undefined,
	        setFavoriteError: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_INSIGHTS_POPULAR_PAGES):
	      return Object.assign({}, state, {
	        loadingPopularPages: false,
	        mostPopularPages: action.payload,
	        loadingPopularPagesError: undefined
	      });
	    case (0, _helpers.invalid)(_Insights.GET_INSIGHTS_POPULAR_PAGES):
	    case (0, _helpers.failure)(_Insights.GET_INSIGHTS_POPULAR_PAGES):
	      return Object.assign({}, state, {
	        loadingPopularPages: false,
	        mostPopularPages: undefined,
	        loadingPopularPagesError: action.payload.message
	      });
	    case (0, _helpers.request)(_Insights.SET_PAGE_FAVORITE):
	      return Object.assign({}, state, {
	        favoriting: true,
	        setFavoriteError: undefined
	      });
	    case (0, _helpers.success)(_Insights.SET_PAGE_FAVORITE):
	      return Object.assign({}, state, {
	        favoriting: false,
	        setFavoriteError: undefined
	      });
	    case (0, _helpers.invalid)(_Insights.SET_PAGE_FAVORITE):
	    case (0, _helpers.failure)(_Insights.SET_PAGE_FAVORITE):
	      return Object.assign({}, state, {
	        favoriting: false,
	        setFavoriteError: action.payload.message
	      });
	    case (0, _helpers.request)(_Insights.GET_FAVORITE_PAGES):
	      return Object.assign({}, state, {
	        loadingFavoritePages: true,
	        favoritePages: undefined,
	        loadingFavoritePagesError: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_FAVORITE_PAGES):
	      return Object.assign({}, state, {
	        loadingFavoritePages: false,
	        favoritePages: action.payload,
	        loadingFavoritePagesError: undefined
	      });
	    case (0, _helpers.invalid)(_Insights.GET_FAVORITE_PAGES):
	    case (0, _helpers.failure)(_Insights.GET_FAVORITE_PAGES):
	      return Object.assign({}, state, {
	        loadingFavoritePages: false,
	        favoritePages: undefined,
	        loadingFavoritePagesError: action.payload.message
	      });
	    case _SegmentCreation.CLEAR_CREATE_SCALE_AUDIENCE_INFO:
	      return Object.assign({}, state, {
	        savingScaleAudience: undefined,
	        savingScaleAudienceResult: undefined,
	        savingScaleAudienceError: undefined
	      });
	    case _SegmentCreation.CLEAR_CREATE_VISITORS_AUDIENCE_INFO:
	      return Object.assign({}, state, {
	        savingVisitorsAudience: undefined,
	        savingVisitorsAudienceResult: undefined,
	        savingVisitorsAudienceError: undefined
	      });
	    case (0, _helpers.request)(_SegmentCreation.CREATE_AUDIENCE_AT_SCALE):
	      return Object.assign({}, state, {
	        savingScaleAudience: true,
	        savingScaleAudienceResult: undefined,
	        savingScaleAudienceError: undefined
	      });
	    case (0, _helpers.success)(_SegmentCreation.CREATE_AUDIENCE_AT_SCALE):
	      return Object.assign({}, state, {
	        savingScaleAudience: false,
	        savingScaleAudienceResult: action.payload,
	        savingScaleAudienceError: undefined
	      });
	    case (0, _helpers.invalid)(_SegmentCreation.CREATE_AUDIENCE_AT_SCALE):
	    case (0, _helpers.failure)(_SegmentCreation.CREATE_AUDIENCE_AT_SCALE):
	      return Object.assign({}, state, {
	        savingScaleAudience: false,
	        savingScaleAudienceResult: undefined,
	        savingScaleAudienceError: action.payload
	      });
	    case (0, _helpers.request)(_SegmentCreation.CREATE_AUDIENCE_AT_VISITORS):
	      return Object.assign({}, state, {
	        savingVisitorsAudience: true,
	        savingVisitorsAudienceResult: undefined,
	        savingVisitorsAudienceError: undefined
	      });
	    case (0, _helpers.success)(_SegmentCreation.CREATE_AUDIENCE_AT_VISITORS):
	      return Object.assign({}, state, {
	        savingVisitorsAudience: undefined,
	        savingVisitorsAudienceResult: action.payload,
	        savingVisitorsAudienceError: undefined
	      });
	    case (0, _helpers.invalid)(_SegmentCreation.CREATE_AUDIENCE_AT_VISITORS):
	    case (0, _helpers.failure)(_SegmentCreation.CREATE_AUDIENCE_AT_VISITORS):
	      return Object.assign({}, state, {
	        savingVisitorsAudience: false,
	        savingVisitorsAudienceResult: undefined,
	        savingVisitorsAudienceError: action.payload
	      });
	    case (0, _helpers.success)(_Insights.GET_BY_STATES):
	      return Object.assign({}, state, {
	        states: action.payload
	      });
	    case (0, _helpers.request)(_Insights.GET_SEGMENT_DISTRIBUTION_SYSTEMS):
	      return Object.assign({}, state, {
	        segmentDistributionSystems: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_SEGMENT_DISTRIBUTION_SYSTEMS):
	      return Object.assign({}, state, {
	        segmentDistributionSystems: action.payload
	      });
	    case (0, _helpers.request)(_Insights.GET_CULTURE_CODE_REPORT):
	      return Object.assign({}, state, {
	        cultureCodeReport: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_CULTURE_CODE_REPORT):
	      return Object.assign({}, state, {
	        cultureCodeReport: action.payload
	      });
	    case (0, _helpers.request)(_Insights.GET_HEATMAP_DATA):
	      return Object.assign({}, state, {
	        distributionHeatmapLoading: true,
	        distributionHeatmapData: undefined
	      });
	    case (0, _helpers.success)(_Insights.GET_HEATMAP_DATA):
	      return Object.assign({}, state, {
	        distributionHeatmapLoading: undefined,
	        distributionHeatmapData: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  insights: insights
	};

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.insightsInfo = undefined;
	
	var _InsightsInfo = __webpack_require__(507);
	
	var _helpers = __webpack_require__(54);
	
	var initialState = {
	  search_results: [],
	  all_search_results: []
	};
	var insightsInfo = exports.insightsInfo = function insightsInfo() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.success)(_InsightsInfo.GET_INSIGHTS_SEARCH_RESULTS):
	      var filterPayload = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = filterPayload.insightTags.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var list = _step.value;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = Object.keys(filterPayload.bizUnits)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var id = _step2.value;
	
	              if (list.clientId === parseInt(id, 10)) {
	                list['children'] = filterPayload.bizUnits[id];
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        search_results: filterPayload
	      });
	    case (0, _helpers.success)(_InsightsInfo.GET_ALL_INSIGHTS_SEARCH_RESULTS):
	      var $filterPayload = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = $filterPayload.insightTags.data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var _list = _step3.value;
	          var _iteratorNormalCompletion4 = true;
	          var _didIteratorError4 = false;
	          var _iteratorError4 = undefined;
	
	          try {
	            for (var _iterator4 = Object.keys($filterPayload.bizUnits)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	              var _id = _step4.value;
	
	              if (_list.clientId === parseInt(_id, 10)) {
	                _list['children'] = $filterPayload.bizUnits[_id];
	              }
	            }
	          } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                _iterator4.return();
	              }
	            } finally {
	              if (_didIteratorError4) {
	                throw _iteratorError4;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        all_search_results: $filterPayload
	      });
	    case _InsightsInfo.RESET_DATA:
	      return Object.assign({}, state, {
	        search_results: []
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  insightsInfo: insightsInfo
	};

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.myProfile = undefined;
	
	var _helpers = __webpack_require__(54);
	
	var _Profile = __webpack_require__(164);
	
	var initialState = {
	  data: [],
	  allstates: [],
	  timezone: [],
	  company_logo: '',
	  photo: '',
	  ifUpdateSuccess: false,
	  update_error_message: '',
	  update_logo_msg: '',
	  update_photo_msg: '',
	  change_password_error_msg: ''
	};
	
	var myProfile = exports.myProfile = function myProfile() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.success)(_Profile.GET_STATES):
	      return Object.assign({}, state, {
	        allstates: action.payload
	      });
	    case (0, _helpers.success)(_Profile.GET_TIMEZONE):
	      return Object.assign({}, state, {
	        timezone: action.payload
	      });
	
	    case (0, _helpers.success)(_Profile.GET_COMPANY_LOGO):
	      return Object.assign({}, state, {
	        company_logo: action.payload
	      });
	
	    case (0, _helpers.success)(_Profile.GET_PHOTO):
	      return Object.assign({}, state, {
	        photo: action.payload
	      });
	    case (0, _helpers.success)(_Profile.UPDATE_PROFILE):
	      return Object.assign({}, state, {
	        ifUpdateSuccess: true,
	        update_error_message: ''
	      });
	    case (0, _helpers.invalid)(_Profile.UPDATE_PROFILE):
	      return Object.assign({}, state, {
	        ifUpdateSuccess: false,
	        update_error_message: action.payload.message
	      });
	    case _Profile.SET_STATUS:
	      return Object.assign({}, state, {
	        ifUpdateSuccess: action.value
	      });
	    case (0, _helpers.success)(_Profile.UPDATE_LOGO):
	      return Object.assign({}, state, {
	        ifUpdateSuccess: true,
	        update_logo_msg: ''
	      });
	    case (0, _helpers.invalid)(_Profile.UPDATE_LOGO):
	      return Object.assign({}, state, {
	        update_logo_msg: action.payload.message
	      });
	    case (0, _helpers.failure)(_Profile.UPDATE_LOGO):
	      return Object.assign({}, state, {
	        update_logo_msg: action.payload.message
	      });
	    case (0, _helpers.success)(_Profile.UPDATE_PHOTOT):
	      return Object.assign({}, state, {
	        ifUpdateSuccess: true,
	        update_photo_msg: ''
	      });
	    case (0, _helpers.invalid)(_Profile.UPDATE_PHOTOT):
	      return Object.assign({}, state, {
	        update_photo_msg: action.payload.message
	      });
	    case (0, _helpers.failure)(_Profile.UPDATE_PHOTOT):
	      return Object.assign({}, state, {
	        update_photo_msg: action.payload.message
	      });
	    case (0, _helpers.success)(_Profile.CHANGE_PASSWORD):
	      return Object.assign({}, state, {
	        ifUpdateSuccess: true,
	        change_password_error_msg: ''
	      });
	    case (0, _helpers.invalid)(_Profile.CHANGE_PASSWORD):
	      return Object.assign({}, state, {
	        change_password_error_msg: action.payload.message
	      });
	    case (0, _helpers.failure)(_Profile.CHANGE_PASSWORD):
	      return Object.assign({}, state, {
	        change_password_error_msg: action.payload.message
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  myProfile: myProfile
	};

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.segmentDetail = exports.segmentCreation = undefined;
	
	var _immutable = __webpack_require__(617);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _Insights = __webpack_require__(58);
	
	var _SegmentDetail = __webpack_require__(165);
	
	var _helpers = __webpack_require__(54);
	
	var _lodash = __webpack_require__(18);
	
	var _sortedUniq = __webpack_require__(1649);
	
	var _sortedUniq2 = _interopRequireDefault(_sortedUniq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  selected_segments: [],
	  selected_city: [],
	  selected_county: [],
	  selected_dma: [],
	  selected_state: [],
	  zipcode: [],
	  selected_make: [],
	  selected_model: [],
	  selected_culture_region: [],
	  selected_culture_locale: [],
	  copy_segment_name: "",
	  segment_id: "",
	  rules_id: [],
	  all_state_cities: [],
	  ifLoading: false,
	  value_typehead: [{ id: "", label: "", parent: "" }],
	  make_active_arr: [],
	  region_active_arr: [],
	  save_segment_report_id: "",
	  segment_counts: 0,
	  audience_total_count: 0,
	  plotted_values: null,
	  allstates: [],
	  save_segment_success: undefined,
	  save_segment_error_message: undefined,
	  send_assist_request_error: undefined,
	  request_assist_successful: undefined,
	  check_client_limit: undefined,
	  targetHouseholdsOnly: undefined
	};
	
	var segmentCreation = exports.segmentCreation = function segmentCreation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var catAudienceCounts = {};
	  switch (action.type) {
	    case _SegmentCreation.SEGMENTS_ATTR:
	    case (0, _helpers.success)(_SegmentCreation.SEGMENTS_ATTR):
	      state = (0, _immutable.fromJS)(state);
	      var categories = action.payload;
	      var value_typehead = [];
	      var demographic = categories ? (0, _lodash.tail)(categories) : undefined;
	      if (demographic) {
	        (0, _lodash.map)(demographic, function (cat) {
	          (0, _lodash.map)(cat.attributes, function (attr) {
	            value_typehead.push({
	              id: attr.id,
	              label: attr.name,
	              parent: cat.name
	            });
	            (0, _lodash.map)(attr.values, function (val) {
	              var obj = { id: 0, label: "", parent: "" };
	              obj.id = val.id;
	              obj.label = val.label;
	              obj.parent = attr.name;
	              value_typehead.push(obj);
	            });
	            (0, _lodash.map)(attr.subAttributes, function (subAttr) {
	              var obj = { id: 0, label: "", parent: "" };
	              obj.id = subAttr.id;
	              obj.label = subAttr.name;
	              obj.parent = attr.name;
	              value_typehead.push(obj);
	              (0, _lodash.map)(subAttr.values, function (val) {
	                var obj = { id: 0, label: "", parent: "" };
	                obj.id = val.id;
	                obj.label = val.label;
	                obj.parent = subAttr.name;
	                value_typehead.push(obj);
	              });
	            });
	          });
	        });
	      }
	      return state.set("categories", categories).set("value_typehead", value_typehead).toJS();
	    case _SegmentCreation.SELECT_SEGMENT:
	      var segments = state["selected_segments"] || [];
	      if (action.value instanceof Array) {
	        segments = action.value.slice();
	      } else {
	        if (segments.indexOf(action.value) >= 0) {
	          (0, _lodash.remove)(segments, function (n) {
	            return n === action.value;
	          });
	        } else {
	          segments.push(action.value);
	        }
	      }
	      state = (0, _immutable.fromJS)(state);
	      return state.set("selected_segments", segments).toJS();
	    case (0, _helpers.success)(_SegmentCreation.ALLSTATES):
	      return Object.assign({}, state, { allstates: action.payload });
	    case (0, _helpers.success)(_SegmentCreation.GET_CITY):
	      return Object.assign({}, state, {
	        allcities: action.payload
	      });
	    case _SegmentCreation.SELECTED_CITY:
	      var city = state["selected_city"] || [];
	      if (action.flag) {
	        action.value["state"] = action.stateLabel;
	        city.push(action.value);
	      } else if (!action.flag) {
	        (0, _lodash.remove)(city, function (n) {
	          return n.id === action.value.id;
	        });
	      }
	      return Object.assign({}, state, {
	        selected_city: (0, _sortedUniq2.default)(city)
	      });
	    case _SegmentCreation.SELECTED_COUNTY:
	      var county = state["selected_county"] || [];
	      if (action.flag) {
	        //action.value["state"] = action.stateLabel;
	        county.push(action.value);
	      } else if (!action.flag) {
	        (0, _lodash.remove)(county, function (n) {
	          return n.id === action.value.id;
	        });
	      }
	      return Object.assign({}, state, {
	        selected_county: (0, _sortedUniq2.default)(county)
	      });
	    case _SegmentCreation.SELECTED_DMA:
	      var dma = state["selected_dma"] || [];
	      if (action.flag) {
	        //action.value["state"] = action.stateLabel;
	        dma.push(action.value);
	      } else if (!action.flag) {
	        (0, _lodash.remove)(dma, function (n) {
	          return n.id === action.value.id;
	        });
	      }
	      return Object.assign({}, state, {
	        selected_dma: (0, _sortedUniq2.default)(dma)
	      });
	    case _SegmentCreation.CLEAR_CITYS:
	      return Object.assign({}, state, {
	        selected_city: [],
	        zipcode_audience_count: null
	      });
	    case _SegmentCreation.CLEAR_COUNTY:
	      return Object.assign({}, state, {
	        selected_county: []
	      });
	    case _SegmentCreation.CLEAR_DMA:
	      return Object.assign({}, state, {
	        selected_dma: []
	      });
	    case _SegmentCreation.SELECTED_STATE:
	      var sta = state["selected_state"] || [];
	      if (action.flag) {
	        sta.push(action.value);
	      } else if (!action.flag) {
	        (0, _lodash.remove)(sta, function (n) {
	          return n.id === action.value.id;
	        });
	      }
	      return Object.assign({}, state, {
	        selected_state: (0, _sortedUniq2.default)(sta)
	      });
	    case _SegmentCreation.SELECTED_ALL_STATE:
	      sta = state["selected_state"] || [];
	      if (action.flag) {
	        sta = action.value;
	      } else if (!action.flag) {
	        sta = [];
	      }
	      return Object.assign({}, state, {
	        selected_state: (0, _sortedUniq2.default)(sta),
	        selected_city: []
	      });
	    case _SegmentCreation.CLEAR_STATES:
	      return Object.assign({}, state, {
	        selected_state: [],
	        zipcode_audience_count: null
	      });
	    case _SegmentCreation.ADD_ZIPCODE:
	      var zipcode = state["zipcode"] ? state["zipcode"] : [];
	      var splitZipCode = action.value.split(",");
	
	      (0, _lodash.map)(splitZipCode, function (zip) {
	        var item = {
	          zipcode: zip
	        };
	        zipcode.push({
	          zipcode: item.zipcode
	        });
	      });
	
	      return Object.assign({}, state, {
	        zipcode: zipcode
	      });
	    case _SegmentCreation.SET_PLOT_VALUES:
	      state = (0, _immutable.fromJS)(state);
	      return state.set("plotted_values", action.value).toJS();
	    case _SegmentCreation.CLEAR_ALL_ZIPCODE:
	      return Object.assign({}, state, {
	        zipcode: [],
	        zipcode_audience_count: null
	      });
	    case _SegmentCreation.CLEAR_ZIPCODE:
	      var zipco = state["zipcode"];
	      (0, _lodash.remove)(zipco, function (val) {
	        return val.zipcode === action.value;
	      });
	      return Object.assign({}, state, {
	        zipcode: zipco
	      });
	    case _SegmentCreation.SET_SEGMENT_NAME:
	      state = (0, _immutable.fromJS)(state);
	      return state.remove("isNameDuplicated").set("segment_name", action.value).toJS();
	
	    case _SegmentCreation.SELECTED_MAKE:
	      var make = state["selected_make"];
	      if (action.flag) {
	        make.push(action.value);
	      } else if (!action.flag) {
	        (0, _lodash.remove)(make, function (n) {
	          return n.id === action.value.id;
	        });
	      }
	      return Object.assign({}, state, {
	        selected_make: (0, _sortedUniq2.default)(make)
	      });
	    case _SegmentCreation.CLEAR_ALL_AUTO:
	      return Object.assign({}, state, {
	        selected_model: [],
	        selected_make: []
	      });
	    case _SegmentCreation.SELECTED_MODEL:
	      var model = state["selected_model"];
	      if (action.flag) {
	        model.push(action.value);
	      } else if (!action.flag) {
	        (0, _lodash.remove)(model, function (n) {
	          return n.id === action.value.id;
	        });
	      }
	      return Object.assign({}, state, {
	        selected_model: (0, _sortedUniq2.default)(model)
	      });
	    case _SegmentCreation.SELECTED_CC_REGION:
	      var region = state["selected_culture_region"];
	      if (action.flag) {
	        region.push(action.value);
	      } else if (!action.flag) {
	        (0, _lodash.remove)(region, function (n) {
	          return n.id === action.value.id;
	        });
	      }
	      return Object.assign({}, state, {
	        selected_culture_region: (0, _sortedUniq2.default)(region)
	      });
	    case _SegmentCreation.SELECTED_CC_LOCALE:
	      var locale = state["selected_culture_locale"];
	      if (action.flag) {
	        locale.push(action.value);
	      } else if (!action.flag) {
	        (0, _lodash.remove)(locale, function (n) {
	          return n.id === action.value.id;
	        });
	      }
	      return Object.assign({}, state, {
	        selected_culture_locale: (0, _sortedUniq2.default)(locale)
	      });
	    case _SegmentCreation.CLEAR_ALL_REGION:
	      return Object.assign({}, state, {
	        selected_culture_region: [],
	        selected_culture_locale: []
	      });
	    case (0, _helpers.success)(_SegmentCreation.VERIFY_SEGMENT_NAME):
	      state = (0, _immutable.fromJS)(state);
	      return state.set("isNameDuplicated", false).toJS();
	    case (0, _helpers.failure)(_SegmentCreation.VERIFY_SEGMENT_NAME):
	      state = (0, _immutable.fromJS)(state);
	      return state.set("isNameDuplicated", true).toJS();
	    case (0, _helpers.success)(_SegmentCreation.GET_ALL_STATE_CITIES):
	      return Object.assign({}, state, {
	        all_state_cities: action.payload
	      });
	    case (0, _helpers.success)(_SegmentCreation.GET_COUNTY):
	      return Object.assign({}, state, {
	        counties: action.payload
	      });
	    case (0, _helpers.success)(_SegmentCreation.GET_DMAS):
	      return Object.assign({}, state, {
	        dmas: action.payload
	      });
	    case _SegmentCreation.LOADING:
	      return Object.assign({}, state, {
	        ifLoading: action.value
	      });
	    case _SegmentCreation.ADD_MAKE_ACTIVE:
	      return Object.assign({}, state, {
	        make_active_arr: action.value
	      });
	    case _SegmentCreation.ADD_REGION_ACTIVE:
	      return Object.assign({}, state, {
	        region_active_arr: action.value
	      });
	    case (0, _helpers.request)(_SegmentCreation.CHECK_SEGMENT_LIMIT):
	      return Object.assign({}, state, {
	        save_segment_success: undefined,
	        check_client_limit: undefined,
	        save_segment_error_message: undefined,
	        save_segment_error_errorNo: undefined
	      });
	    case (0, _helpers.success)(_SegmentCreation.CHECK_SEGMENT_LIMIT):
	      return Object.assign({}, state, {
	        save_segment_success: true,
	        check_client_limit: true,
	        save_segment_error_message: undefined,
	        save_segment_error_errorNo: undefined
	      });
	    case (0, _helpers.failure)(_SegmentCreation.CHECK_SEGMENT_LIMIT):
	    case (0, _helpers.invalid)(_SegmentCreation.CHECK_SEGMENT_LIMIT):
	      return Object.assign({}, state, {
	        save_segment_success: false,
	        check_client_limit: false,
	        save_segment_error_message: action.payload.message,
	        save_segment_error_errorNo: action.payload.errorNo
	      });
	    case (0, _helpers.request)(_SegmentCreation.SAVE_SEGMENT):
	      return Object.assign({}, initialState, {
	        save_segment_success: undefined,
	        save_segment_error_message: undefined,
	        save_segment_error_errorNo: undefined
	      });
	    case (0, _helpers.success)(_SegmentCreation.SAVE_SEGMENT):
	      return Object.assign({}, initialState, {
	        save_segment_success: true,
	        save_segment_error_message: undefined,
	        save_segment_error_errorNo: undefined,
	        save_segment_report_id: action.payload.segment.id
	      });
	    case (0, _helpers.failure)(_SegmentCreation.SAVE_SEGMENT):
	    case (0, _helpers.invalid)(_SegmentCreation.SAVE_SEGMENT):
	      return Object.assign({}, initialState, {
	        save_segment_success: false,
	        save_segment_error_message: action.payload.message,
	        save_segment_error_errorNo: action.payload.errorNo,
	        save_segment_report_id: undefined
	      });
	    case (0, _helpers.request)(_Insights.SEND_ASSIST_REQUEST):
	      return Object.assign({}, state, {
	        send_assist_request_error: undefined,
	        request_assist_successful: undefined
	      });
	    case (0, _helpers.success)(_Insights.SEND_ASSIST_REQUEST):
	      return Object.assign({}, state, {
	        send_assist_request_error: undefined,
	        request_assist_successful: true
	      });
	    case (0, _helpers.invalid)(_Insights.SEND_ASSIST_REQUEST):
	    case (0, _helpers.failure)(_Insights.SEND_ASSIST_REQUEST):
	      return Object.assign({}, state, {
	        send_assist_request_error: "Message send failure. Please try again later...",
	        request_assist_successful: false
	      });
	    case (0, _helpers.success)(_SegmentCreation.GET_AUDIENCE_COUNT):
	      return Object.assign({}, state, {
	        audience_total_count: action.payload
	      });
	    case _SegmentCreation.CLEAR_AUDIENCE_COUNT:
	      state = (0, _immutable.fromJS)(state);
	      return state.remove("audience_total_count").toJS();
	    case (0, _helpers.success)(_SegmentCreation.GET_PLOTTED_AUDIENCE_COUNT):
	      var obj = state["plotted_values"];
	      obj.audienceCount.total = action.payload.total;
	      obj.audienceCount.email = action.payload.email;
	      obj.audienceCount.display = action.payload.display;
	      obj.audienceCount.social = action.payload.social;
	      return Object.assign({}, state, {
	        plotted_values: obj
	      });
	    case (0, _helpers.success)(_SegmentCreation.GET_ZIPCODE_AUDIENCE_COUNT):
	      return Object.assign({}, state, {
	        zipcode_audience_count: {
	          total: action.payload.total,
	          email: action.payload.email,
	          display: action.payload.display,
	          social: action.payload.social
	        }
	      });
	    case (0, _helpers.success)(_SegmentCreation.GET_ZIPCODE_DETAIL_COUNTS):
	      var zipcodes = state["zipcode"] ? state["zipcode"] : [];
	      var zipcodes_with_counts = [];
	      (0, _lodash.map)(zipcodes, function (zip) {
	        var counts = action.payload[zip.zipcode];
	        zipcodes_with_counts.push({
	          zipcode: zip.zipcode,
	          total: counts.total,
	          email: counts.email,
	          social: counts.social,
	          display: counts.display
	        });
	      });
	      return Object.assign({}, state, {
	        zipcode: zipcodes_with_counts
	      });
	    case (0, _helpers.success)(_SegmentCreation.CATEGORY_AUDIENCE_COUNTS):
	      catAudienceCounts = state["catAudienceCounts"] === undefined ? {} : state["catAudienceCounts"];
	
	      catAudienceCounts[action.payload.categoryId] = action.payload.total;
	      return Object.assign({}, state, {
	        catAudienceCounts: catAudienceCounts
	      });
	    case _SegmentCreation.CLEAR_CATEGORY_AUDIENCE_COUNTS:
	      state = (0, _immutable.fromJS)(state);
	      catAudienceCounts = state["catAudienceCounts"];
	      if (catAudienceCounts) {
	        delete catAudienceCounts[action.value];
	      }
	      return state.set("catAudienceCounts", catAudienceCounts).toJS();
	    case _SegmentCreation.SET_TARGET_HOUSEHOLD_ONLY:
	      return Object.assign({}, state, {
	        targetHouseholdsOnly: Boolean(action.value)
	      });
	    default:
	      return state;
	  }
	};
	
	var segmentDetail = exports.segmentDetail = function segmentDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  state = (0, _immutable.fromJS)(state);
	  switch (action.type) {
	    case (0, _helpers.success)(_SegmentDetail.SEGMENT_SUMMARY):
	      return state.set("segment_summary", action.payload).toJS();
	    case _SegmentDetail.CLEAR_SEGMENT_SUMMARY:
	      return state.remove("segment_summary").remove("segment_counts").remove("rules_count").toJS();
	    case (0, _helpers.success)(_SegmentDetail.SEGMENT_COUNTS):
	      return state.set("segment_counts", action.payload).toJS();
	    case (0, _helpers.success)(_SegmentDetail.SEGMENT_ATTR_COUNTS):
	      return state.set("rules_count", action.payload).toJS();
	    case _SegmentDetail.CLEAR_SEGMENT_ATTR_COUNTS:
	      return state.remove("rules_count").toJS();
	    case (0, _helpers.request)(_SegmentDetail.REQUEST_ACTIVATION):
	      return state.remove("request_activation_error").remove("request_activation_success").toJS();
	    case (0, _helpers.failure)(_SegmentDetail.REQUEST_ACTIVATION):
	    case (0, _helpers.invalid)(_SegmentDetail.REQUEST_ACTIVATION):
	      return state.set("request_activation_error", action.payload.message).toJS();
	    case (0, _helpers.success)(_SegmentDetail.REQUEST_ACTIVATION):
	      return state.set("request_activation_success", true).remove("request_activation_error").toJS();
	    default:
	      return state.toJS();
	  }
	};
	exports.default = {
	  segmentCreation: segmentCreation,
	  segmentDetail: segmentDetail
	};

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.segmentList = undefined;
	
	var _helpers = __webpack_require__(54);
	
	var _SegmentList = __webpack_require__(118);
	
	var _SegmentCreation = __webpack_require__(84);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  segment_list_active: {
	    data: []
	  },
	  segment_list_archive: {
	    data: []
	  },
	  segment_archive_data: [],
	  archive_success: [],
	  reactive_success: undefined,
	  reactive_on_progress: undefined,
	  segment_attributes: "",
	  copy_segment: {},
	  create_campaign: {
	    segment_id: "",
	    ifRequestSuccess: false,
	    error: false,
	    error_payload: ""
	  },
	  searchByNameResult: [],
	  selectedSegmentSetArray: [],
	  recordActiveQueryParamsObj: {
	    pageNumber: 1,
	    sortColumn: "createdTime",
	    pageSize: 10,
	    status: "Active",
	    order: "desc"
	  }
	};
	var segmentList = exports.segmentList = function segmentList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _SegmentList.CLEAR_REACTIVE_STATUS:
	      return Object.assign({}, state, {
	        reactive_on_progress: undefined,
	        reactive_success: undefined
	      });
	    case (0, _helpers.success)(_SegmentList.SEGMENT_LIST):
	      action.payload.data.forEach(function (item) {
	        item.createdTime = (0, _moment2.default)(item.createdTime).format("MM/DD/YYYY");
	      });
	      action.payload.data.forEach(function (item) {
	        item.archivedTime = (0, _moment2.default)(item.archivedTime).format("MM/DD/YYYY");
	      });
	      // mock pageCount
	      if (/\/segments\/list\/active/g.test(window.location.href)) {
	        return Object.assign({}, state, {
	          searchByNameResult: undefined,
	          segment_list_active: action.payload,
	          selectedSegmentSetArray: []
	        });
	      }
	
	      if (/\/segments\/list\/archive/g.test(window.location.href)) {
	        return Object.assign({}, state, {
	          searchByNameResult: undefined,
	          segment_list_archive: action.payload
	        });
	      }
	      return Object.assign({}, state, {
	        searchByNameResult: undefined
	      });
	    case (0, _helpers.success)(_SegmentList.SEGMENT_ARCHIVE):
	      return Object.assign({}, state, {
	        segment_archive_data: action.payload.data
	      });
	    case (0, _helpers.success)(_SegmentList.ARCHIVE_SEGMENT):
	      return Object.assign({}, state);
	    case (0, _helpers.request)(_SegmentList.REACTIVATE_SEGMENT):
	      return Object.assign({}, state, {
	        reactive_on_progress: true,
	        reactive_success: false
	      });
	    case (0, _helpers.success)(_SegmentList.REACTIVATE_SEGMENT):
	      return Object.assign({}, state, {
	        reactive_on_progress: false,
	        reactive_success: true
	      });
	    case _SegmentList.IF_ARCHIVE_SUCCESS:
	      var arr = [];
	      arr.push(action.value);
	      return Object.assign({}, state, {
	        archive_success: arr
	      });
	    case (0, _helpers.success)(_SegmentList.GET_ATTRIBUTES):
	      return Object.assign({}, state, {
	        segment_attributes: action.payload.attributes
	      });
	    case (0, _helpers.success)(_SegmentList.COPY_SEGMENT):
	      // let rawData = JSON.parse(action.payload.rawData);
	      return Object.assign({}, state, {
	        copy_segment: action.payload
	      });
	
	    case (0, _helpers.success)(_SegmentList.SEGMENT_WITH_RULES):
	      // let rawData_active = JSON.parse(action.payload.rawData);
	      return Object.assign({}, state, {
	        active_segment_attributes: action.payload
	      });
	    case _SegmentCreation.CLEAR_AUDIENCE_COUNT:
	    case _SegmentList.CLEAR_SEGMENT_WITH_RULES:
	      return Object.assign({}, state, {
	        active_segment_attributes: {}
	      });
	    case (0, _helpers.success)(_SegmentList.CREATE_CAMPAIGN):
	      return Object.assign({}, state, {
	        create_campaign: {
	          segment_id: action.payload,
	          ifRequestSuccess: true,
	          error: false
	        }
	      });
	    case (0, _helpers.invalid)(_SegmentList.CREATE_CAMPAIGN):
	      return Object.assign({}, state, {
	        create_campaign: {
	          ifRequestSuccess: false,
	          error: true,
	          error_payload: action.payload.message
	        }
	      });
	    case _SegmentList.ROLLBACK_VALUE:
	      return Object.assign({}, state, {
	        create_campaign: Object.assign({}, state.create_campaign, {
	          ifRequestSuccess: action.value,
	          error: false,
	          error_payload: ""
	        })
	      });
	    case (0, _helpers.failure)(_SegmentList.CREATE_CAMPAIGN):
	      return Object.assign({}, state, {
	        create_campaign: {
	          error: true,
	          error_payload: action.payload.message,
	          ifRequestSuccess: false
	        }
	      });
	    case (0, _helpers.success)(_SegmentList.SEARCH_BY_NAME):
	      return Object.assign({}, state, {
	        searchByNameResult: action.payload
	      });
	    case _SegmentList.SELECTED_SEGMENT:
	      if (action.value === "clear") {
	        return Object.assign({}, state, {
	          selectedSegmentSetArray: []
	        });
	      } else {
	        return Object.assign({}, state, {
	          selectedSegmentSetArray: action.value
	        });
	      }
	    case _SegmentList.RECORD_ACTIVE_QUERY_PARAMS:
	      return Object.assign({}, state, {
	        recordActiveQueryParamsObj: Object.assign({}, state.recordActiveQueryParamsObj, {
	          pageNumber: action.value.pageNumber,
	          sortColumn: action.value.sortColumn,
	          pageSize: action.value.pageSize,
	          order: action.value.order
	        })
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  segmentList: segmentList
	};

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.settings = undefined;
	
	var _helpers = __webpack_require__(54);
	
	var _settings = __webpack_require__(351);
	
	var settings = exports.settings = function settings() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case (0, _helpers.request)(_settings.SAVE_INSIGHTS_FILE_SETUP):
				return Object.assign({}, state, {
					insights_file_save_success: undefined,
					insights_file_on_saving: true
				});
			case (0, _helpers.success)(_settings.SAVE_INSIGHTS_FILE_SETUP):
				return Object.assign({}, state, {
					insights_file_save_success: true,
					insights_file_on_saving: false
				});
			case (0, _helpers.failure)(_settings.SAVE_INSIGHTS_FILE_SETUP):
			case (0, _helpers.invalid)(_settings.SAVE_INSIGHTS_FILE_SETUP):
				return Object.assign({}, state, {
					insights_file_save_success: false,
					insights_file_on_saving: false,
					insights_file_save_error_message: action.payload.message
				});
			case _settings.CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR:
				return Object.assign({}, state, {
					insights_file_save_success: false,
					insights_file_save_error_message: undefined
				});
			case _settings.SET_SETTINGS_WEBSITE_ID:
				return Object.assign({}, state, {
					insights_file_save_success: undefined,
					websiteId: action.value
				});
			default:
				return state;
		}
	};
	
	exports.default = {
		settings: settings
	};

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subscriptionInfo = undefined;
	
	var _SubscriptionInfo = __webpack_require__(508);
	
	var _helpers = __webpack_require__(54);
	
	var initialState = {
	  subscription_total: [],
	  search_results: [],
	  all_search_results: []
	};
	
	var subscriptionInfo = exports.subscriptionInfo = function subscriptionInfo() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.success)(_SubscriptionInfo.GET_SUB_STATS):
	      var arr = action.payload.map(function (item) {
	        return Object.assign({}, {
	          label: item.key,
	          value: item.value
	        });
	      });
	      return Object.assign({}, state, {
	        subscription_total: arr
	      });
	    case (0, _helpers.success)(_SubscriptionInfo.GET_SEARCH_RESULTS):
	      var filterPayload = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = filterPayload.clients.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var list = _step.value;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = Object.keys(filterPayload.bizUnits)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var id = _step2.value;
	
	              if (list.id === parseInt(id, 10)) {
	                list['children'] = filterPayload.bizUnits[id];
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        search_results: action.payload
	      });
	    case (0, _helpers.success)(_SubscriptionInfo.GET_ALL_SEARCH_RESULTS):
	      var $filterPayload = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = $filterPayload.clients.data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var _list = _step3.value;
	          var _iteratorNormalCompletion4 = true;
	          var _didIteratorError4 = false;
	          var _iteratorError4 = undefined;
	
	          try {
	            for (var _iterator4 = Object.keys($filterPayload.bizUnits)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	              var _id = _step4.value;
	
	              if (_list.id === parseInt(_id, 10)) {
	                _list['children'] = $filterPayload.bizUnits[_id];
	              }
	            }
	          } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                _iterator4.return();
	              }
	            } finally {
	              if (_didIteratorError4) {
	                throw _iteratorError4;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        all_search_results: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  subscriptionInfo: subscriptionInfo
	};

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tagsInfo = undefined;
	
	var _helpers = __webpack_require__(54);
	
	var _TagInfo = __webpack_require__(509);
	
	var initialState = {
	  tags_total: '',
	  tags_tree: [],
	  search_results: [],
	  all_serach_results: []
	};
	var tagsInfo = exports.tagsInfo = function tagsInfo() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case (0, _helpers.success)(_TagInfo.GET_TAGS_TOTAL):
	      var obj = [];
	      var len = Object.keys(action.payload);
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = len[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var item = _step.value;
	
	          var list = Object.assign({}, {
	            label: '' + item.substring(0, 1).toUpperCase() + item.substring(1),
	            value: action.payload[item]
	          });
	          obj.push(list);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        tags_total: obj
	      });
	    case (0, _helpers.success)(_TagInfo.GET_CLIENTS_TREE):
	      return Object.assign({}, state, {
	        tags_tree: action.payload
	      });
	    case (0, _helpers.success)(_TagInfo.TAGS_SEARCH):
	      var filterPayload = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = filterPayload.clients.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _list = _step2.value;
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = Object.keys(filterPayload.tags)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var id = _step3.value;
	
	              if (_list.id === parseInt(id, 10)) {
	                _list['children'] = filterPayload.tags[id];
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        search_results: filterPayload
	      });
	    case (0, _helpers.success)(_TagInfo.ALL_TAGS_SEARCH):
	      var $filterPayload = Object.assign({}, action.payload);
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = $filterPayload.clients.data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var _list2 = _step4.value;
	          var _iteratorNormalCompletion5 = true;
	          var _didIteratorError5 = false;
	          var _iteratorError5 = undefined;
	
	          try {
	            for (var _iterator5 = Object.keys($filterPayload.tags)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	              var _id = _step5.value;
	
	              if (_list2.id === parseInt(_id, 10)) {
	                _list2['children'] = $filterPayload.tags[_id];
	              }
	            }
	          } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	              }
	            } finally {
	              if (_didIteratorError5) {
	                throw _iteratorError5;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      return Object.assign({}, state, {
	        all_search_results: $filterPayload
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = {
	  tagsInfo: tagsInfo
	};

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reduxApiMiddleware = __webpack_require__(1009);
	
	var authMiddleware = function authMiddleware(_ref) {
		var getState = _ref.getState;
	
		return function (next) {
			return function (action) {
				if (!(0, _reduxApiMiddleware.isRSAA)(action)) {
					return next(action);
				}
				var state = getState();
				var callAPI = action[_reduxApiMiddleware.CALL_API];
				var headers = callAPI.headers;
	
	
				headers = headers || {};
				if (state.app.token) {
					headers['Authorization'] = '{state.app.token}';
				}
				callAPI.headers = headers;
				next(action);
			};
		};
	};
	
	exports.default = authMiddleware;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = configureStore;
	
	var _reducers = __webpack_require__(1227);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _redux = __webpack_require__(501);
	
	var _reactRouterRedux = __webpack_require__(92);
	
	var _reduxThunk = __webpack_require__(3130);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxApiMiddleware = __webpack_require__(1009);
	
	var _authMiddleware = __webpack_require__(1236);
	
	var _authMiddleware2 = _interopRequireDefault(_authMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(history, initialState) {
		var middleware = [_authMiddleware2.default, _reduxApiMiddleware.apiMiddleware, _reduxThunk2.default, _reduxThunk2.default];
		middleware.push((0, _reactRouterRedux.routerMiddleware)(history));
	
		var createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
		var store = createStoreWithMiddleware(_reducers2.default, initialState);
		if (false) {
			// Enable Webpack hot module replacement for reducers
			module.hot.accept('../reducers', function () {
				var nextReducer = require('../reducers');
				store.replaceReducer(nextReducer);
			});
		}
	
		return store;
	}

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1253), __esModule: true };

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1254), __esModule: true };

/***/ },
/* 1240 */
[3142, 544],
/* 1241 */
[3143, 545],
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1255), __esModule: true };

/***/ },
/* 1243 */
[3144, 548],
/* 1244 */
[3145, 549],
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(550), __esModule: true };

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(1242);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ },
/* 1247 */
/***/ function(module, exports) {

	module.exports = function blacklist (src) {
	  var copy = {}
	  var filter = arguments[1]
	
	  if (typeof filter === 'string') {
	    filter = {}
	    for (var i = 1; i < arguments.length; i++) {
	      filter[arguments[i]] = true
	    }
	  }
	
	  for (var key in src) {
	    // blacklist?
	    if (filter[key]) continue
	
	    copy[key] = src[key]
	  }
	
	  return copy
	}


/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(502)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)(o|0)s/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/Whale/i.test(ua)) {
	      result = {
	        name: 'NAVER Whale browser'
	        , whale: t
	        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/MZBrowser/i.test(ua)) {
	      result = {
	        name: 'MZ Browser'
	        , mzbrowser: t
	        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/focus/i.test(ua)) {
	      result = {
	        name: 'Focus'
	        , focus: t
	        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
	        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
	        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ },
/* 1249 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var deselectCurrent = __webpack_require__(3139);
	
	var defaultMessage = 'Copy to clipboard: #{key}, Enter';
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug, message, reselectPrevious, range, selection, mark, success = false;
	  if (!options) { options = {}; }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement('span');
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = 'unset';
	    // prevents scrolling to the end of the page
	    mark.style.position = 'fixed';
	    mark.style.top = 0;
	    mark.style.clip = 'rect(0, 0, 0, 0)';
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = 'pre';
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = 'text';
	    mark.style.MozUserSelect = 'text';
	    mark.style.msUserSelect = 'text';
	    mark.style.userSelect = 'text';
	
	    document.body.appendChild(mark);
	
	    range.selectNode(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand('copy');
	    if (!successful) {
	      throw new Error('copy command was unsuccessful');
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error('unable to copy using execCommand: ', err);
	    debug && console.warn('trying IE specific stuff');
	    try {
	      window.clipboardData.setData('text', text);
	      success = true;
	    } catch (err) {
	      debug && console.error('unable to copy using clipboardData: ', err);
	      debug && console.error('falling back to prompt');
	      message = format('message' in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == 'function') {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1310);
	__webpack_require__(1311);
	__webpack_require__(1312);
	__webpack_require__(1313);
	__webpack_require__(1314);
	__webpack_require__(1315);
	__webpack_require__(1316);
	__webpack_require__(1317);
	__webpack_require__(1318);
	__webpack_require__(1319);
	__webpack_require__(1320);
	__webpack_require__(1321);
	__webpack_require__(1322);
	__webpack_require__(1323);
	__webpack_require__(1324);
	__webpack_require__(1325);
	__webpack_require__(1326);
	module.exports = __webpack_require__(217).Math;


/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1327);
	__webpack_require__(1337);
	__webpack_require__(1338);
	__webpack_require__(1328);
	__webpack_require__(1329);
	__webpack_require__(1330);
	__webpack_require__(1331);
	__webpack_require__(1332);
	__webpack_require__(1333);
	__webpack_require__(1334);
	__webpack_require__(1335);
	__webpack_require__(1336);
	module.exports = __webpack_require__(217).Number;


/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(374);
	__webpack_require__(265);
	module.exports = __webpack_require__(1276);


/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(374);
	__webpack_require__(265);
	module.exports = __webpack_require__(1277);


/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1283);
	var $Object = __webpack_require__(55).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1285);
	module.exports = __webpack_require__(55).Object.keys;


/***/ },
/* 1257 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 1258 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1259 */
[3153, 137, 560, 1275],
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(122);
	var createDesc = __webpack_require__(215);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(214);
	var gOPS = __webpack_require__(365);
	var pIE = __webpack_require__(263);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 1262 */
[3158, 121],
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(171);
	var ITERATOR = __webpack_require__(86)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(359);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(134);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(363);
	var descriptor = __webpack_require__(215);
	var setToStringTag = __webpack_require__(367);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(169)(IteratorPrototype, __webpack_require__(86)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(86)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 1268 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(264)('meta');
	var isObject = __webpack_require__(170);
	var has = __webpack_require__(136);
	var setDesc = __webpack_require__(122).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(168)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(214);
	var gOPS = __webpack_require__(365);
	var pIE = __webpack_require__(263);
	var toObject = __webpack_require__(216);
	var IObject = __webpack_require__(554);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(168)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 1271 */
[3163, 122, 134, 214, 135],
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(137);
	var gOPN = __webpack_require__(556).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 1273 */
[3168, 170, 134, 360, 364],
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(370);
	var defined = __webpack_require__(361);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 1275 */
[3171, 370],
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(134);
	var get = __webpack_require__(561);
	module.exports = __webpack_require__(55).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(551);
	var ITERATOR = __webpack_require__(86)('iterator');
	var Iterators = __webpack_require__(171);
	module.exports = __webpack_require__(55).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(360);
	var $export = __webpack_require__(120);
	var toObject = __webpack_require__(216);
	var call = __webpack_require__(1265);
	var isArrayIter = __webpack_require__(1263);
	var toLength = __webpack_require__(560);
	var createProperty = __webpack_require__(1260);
	var getIterFn = __webpack_require__(561);
	
	$export($export.S + $export.F * !__webpack_require__(1267)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1258);
	var step = __webpack_require__(1268);
	var Iterators = __webpack_require__(171);
	var toIObject = __webpack_require__(137);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(555)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(120);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1270) });


/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(120);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(363) });


/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(120);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(135), 'Object', { defineProperty: __webpack_require__(122).f });


/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(137);
	var $getOwnPropertyDescriptor = __webpack_require__(364).f;
	
	__webpack_require__(366)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(216);
	var $getPrototypeOf = __webpack_require__(557);
	
	__webpack_require__(366)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(216);
	var $keys = __webpack_require__(214);
	
	__webpack_require__(366)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(120);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1273).set });


/***/ },
/* 1287 */
1025,
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(121);
	var has = __webpack_require__(136);
	var DESCRIPTORS = __webpack_require__(135);
	var $export = __webpack_require__(120);
	var redefine = __webpack_require__(559);
	var META = __webpack_require__(1269).KEY;
	var $fails = __webpack_require__(168);
	var shared = __webpack_require__(369);
	var setToStringTag = __webpack_require__(367);
	var uid = __webpack_require__(264);
	var wks = __webpack_require__(86);
	var wksExt = __webpack_require__(373);
	var wksDefine = __webpack_require__(372);
	var enumKeys = __webpack_require__(1261);
	var isArray = __webpack_require__(1264);
	var anObject = __webpack_require__(134);
	var isObject = __webpack_require__(170);
	var toIObject = __webpack_require__(137);
	var toPrimitive = __webpack_require__(371);
	var createDesc = __webpack_require__(215);
	var _create = __webpack_require__(363);
	var gOPNExt = __webpack_require__(1272);
	var $GOPD = __webpack_require__(364);
	var $DP = __webpack_require__(122);
	var $keys = __webpack_require__(214);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(556).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(263).f = $propertyIsEnumerable;
	  __webpack_require__(365).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(262)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(169)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(372)('asyncIterator');


/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(372)('observable');


/***/ },
/* 1291 */
1257,
/* 1292 */
[3153, 383, 1309, 1308],
/* 1293 */
[3158, 104],
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(173);
	var setPrototypeOf = __webpack_require__(1305).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 1295 */
[3160, 375],
/* 1296 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(379);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 1298 */
[3161, 266, 1299, 377, 573, 564, 1293],
/* 1299 */
[3163, 380, 266, 1301, 172],
/* 1300 */
[3165, 570, 377],
/* 1301 */
[3167, 570, 377],
/* 1302 */
263,
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(104).parseFloat;
	var $trim = __webpack_require__(381).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(382) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(104).parseInt;
	var $trim = __webpack_require__(381).trim;
	var ws = __webpack_require__(382);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 1305 */
[3168, 173, 266, 563, 569],
/* 1306 */
[3170, 217, 104, 1296],
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(268);
	var defined = __webpack_require__(376);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 1308 */
[3171, 268],
/* 1309 */
[3173, 268],
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(33);
	var log1p = __webpack_require__(568);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(33);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(33);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(33);
	var sign = __webpack_require__(379);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(33);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(33);
	var $expm1 = __webpack_require__(378);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Math', { fround: __webpack_require__(1297) });


/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(33);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(33);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(123)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(568) });


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Math', { sign: __webpack_require__(379) });


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(33);
	var expm1 = __webpack_require__(378);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(123)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(33);
	var expm1 = __webpack_require__(378);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(104);
	var has = __webpack_require__(267);
	var cof = __webpack_require__(375);
	var inheritIfRequired = __webpack_require__(1294);
	var toPrimitive = __webpack_require__(384);
	var fails = __webpack_require__(123);
	var gOPN = __webpack_require__(1300).f;
	var gOPD = __webpack_require__(569).f;
	var dP = __webpack_require__(380).f;
	var $trim = __webpack_require__(381).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(1298)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(172) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(572)(global, NUMBER, $Number);
	}


/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(33);
	var _isFinite = __webpack_require__(104).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(567) });


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(33);
	var isInteger = __webpack_require__(567);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(33);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(33);
	var $parseFloat = __webpack_require__(1303);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(33);
	var $parseInt = __webpack_require__(1304);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(33);
	var toInteger = __webpack_require__(268);
	var aNumberValue = __webpack_require__(562);
	var repeat = __webpack_require__(1307);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(123)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(33);
	var $fails = __webpack_require__(123);
	var aNumberValue = __webpack_require__(562);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 1339 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var START_EVENT_NAME_MAP = {
	  transitionstart: {
	    transition: 'transitionstart',
	    WebkitTransition: 'webkitTransitionStart',
	    MozTransition: 'mozTransitionStart',
	    OTransition: 'oTransitionStart',
	    msTransition: 'MSTransitionStart'
	  },
	
	  animationstart: {
	    animation: 'animationstart',
	    WebkitAnimation: 'webkitAnimationStart',
	    MozAnimation: 'mozAnimationStart',
	    OAnimation: 'oAnimationStart',
	    msAnimation: 'MSAnimationStart'
	  }
	};
	
	var END_EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var startEvents = [];
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete START_EVENT_NAME_MAP.animationstart.animation;
	    delete END_EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete START_EVENT_NAME_MAP.transitionstart.transition;
	    delete END_EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  function process(EVENT_NAME_MAP, events) {
	    for (var baseEventName in EVENT_NAME_MAP) {
	      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	        var baseEvents = EVENT_NAME_MAP[baseEventName];
	        for (var styleName in baseEvents) {
	          if (styleName in style) {
	            events.push(baseEvents[styleName]);
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  process(START_EVENT_NAME_MAP, startEvents);
	  process(END_EVENT_NAME_MAP, endEvents);
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  // Start events
	  startEvents: startEvents,
	
	  addStartEventListener: function addStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      addEventListener(node, startEvent, eventListener);
	    });
	  },
	  removeStartEventListener: function removeStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      removeEventListener(node, startEvent, eventListener);
	    });
	  },
	
	
	  // End events
	  endEvents: endEvents,
	
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(167);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(1339);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(541);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LineBreaker = exports.inlineBreakOpportunities = exports.lineBreakAtIndex = exports.codePointsToCharacterClasses = exports.UnicodeTrie = exports.BREAK_ALLOWED = exports.BREAK_NOT_ALLOWED = exports.BREAK_MANDATORY = exports.classes = exports.LETTER_NUMBER_MODIFIER = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Trie = __webpack_require__(1342);
	
	var _linebreakTrie = __webpack_require__(1344);
	
	var _linebreakTrie2 = _interopRequireDefault(_linebreakTrie);
	
	var _Util = __webpack_require__(387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LETTER_NUMBER_MODIFIER = exports.LETTER_NUMBER_MODIFIER = 50;
	
	// Non-tailorable Line Breaking Classes
	var BK = 1; //  Cause a line break (after)
	var CR = 2; //  Cause a line break (after), except between CR and LF
	var LF = 3; //  Cause a line break (after)
	var CM = 4; //  Prohibit a line break between the character and the preceding character
	var NL = 5; //  Cause a line break (after)
	var SG = 6; //  Do not occur in well-formed text
	var WJ = 7; //  Prohibit line breaks before and after
	var ZW = 8; //  Provide a break opportunity
	var GL = 9; //  Prohibit line breaks before and after
	var SP = 10; // Enable indirect line breaks
	var ZWJ = 11; // Prohibit line breaks within joiner sequences
	// Break Opportunities
	var B2 = 12; //  Provide a line break opportunity before and after the character
	var BA = 13; //  Generally provide a line break opportunity after the character
	var BB = 14; //  Generally provide a line break opportunity before the character
	var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
	var CB = 16; //   Provide a line break opportunity contingent on additional information
	// Characters Prohibiting Certain Breaks
	var CL = 17; //  Prohibit line breaks before
	var CP = 18; //  Prohibit line breaks before
	var EX = 19; //  Prohibit line breaks before
	var IN = 20; //  Allow only indirect line breaks between pairs
	var NS = 21; //  Allow only indirect line breaks before
	var OP = 22; //  Prohibit line breaks after
	var QU = 23; //  Act like they are both opening and closing
	// Numeric Context
	var IS = 24; //  Prevent breaks after any and before numeric
	var NU = 25; //  Form numeric expressions for line breaking purposes
	var PO = 26; //  Do not break following a numeric expression
	var PR = 27; //  Do not break in front of a numeric expression
	var SY = 28; //  Prevent a break before; and allow a break after
	// Other Characters
	var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
	var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
	var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
	var EB = 32; //  Do not break from following Emoji Modifier
	var EM = 33; //  Do not break from preceding Emoji Base
	var H2 = 34; //  Form Korean syllable blocks
	var H3 = 35; //  Form Korean syllable blocks
	var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
	var ID = 37; //  Break before or after; except in some numeric context
	var JL = 38; //  Form Korean syllable blocks
	var JV = 39; //  Form Korean syllable blocks
	var JT = 40; //  Form Korean syllable blocks
	var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
	var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
	var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
	
	var classes = exports.classes = {
	    BK: BK,
	    CR: CR,
	    LF: LF,
	    CM: CM,
	    NL: NL,
	    SG: SG,
	    WJ: WJ,
	    ZW: ZW,
	    GL: GL,
	    SP: SP,
	    ZWJ: ZWJ,
	    B2: B2,
	    BA: BA,
	    BB: BB,
	    HY: HY,
	    CB: CB,
	    CL: CL,
	    CP: CP,
	    EX: EX,
	    IN: IN,
	    NS: NS,
	    OP: OP,
	    QU: QU,
	    IS: IS,
	    NU: NU,
	    PO: PO,
	    PR: PR,
	    SY: SY,
	    AI: AI,
	    AL: AL,
	    CJ: CJ,
	    EB: EB,
	    EM: EM,
	    H2: H2,
	    H3: H3,
	    HL: HL,
	    ID: ID,
	    JL: JL,
	    JV: JV,
	    JT: JT,
	    RI: RI,
	    SA: SA,
	    XX: XX
	};
	
	var BREAK_MANDATORY = exports.BREAK_MANDATORY = '!';
	var BREAK_NOT_ALLOWED = exports.BREAK_NOT_ALLOWED = '×';
	var BREAK_ALLOWED = exports.BREAK_ALLOWED = '÷';
	var UnicodeTrie = exports.UnicodeTrie = (0, _Trie.createTrieFromBase64)(_linebreakTrie2.default);
	
	var ALPHABETICS = [AL, HL];
	var HARD_LINE_BREAKS = [BK, CR, LF, NL];
	var SPACE = [SP, ZW];
	var PREFIX_POSTFIX = [PR, PO];
	var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
	var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
	var HYPHEN = [HY, BA];
	
	var codePointsToCharacterClasses = exports.codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints) {
	    var lineBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'strict';
	
	    var types = [];
	    var indicies = [];
	    var categories = [];
	    codePoints.forEach(function (codePoint, index) {
	        var classType = UnicodeTrie.get(codePoint);
	        if (classType > LETTER_NUMBER_MODIFIER) {
	            categories.push(true);
	            classType -= LETTER_NUMBER_MODIFIER;
	        } else {
	            categories.push(false);
	        }
	
	        if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
	            // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
	            if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
	                indicies.push(index);
	                return types.push(CB);
	            }
	        }
	
	        if (classType === CM || classType === ZWJ) {
	            // LB10 Treat any remaining combining mark or ZWJ as AL.
	            if (index === 0) {
	                indicies.push(index);
	                return types.push(AL);
	            }
	
	            // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
	            // the base character in all of the following rules. Treat ZWJ as if it were CM.
	            var prev = types[index - 1];
	            if (LINE_BREAKS.indexOf(prev) === -1) {
	                indicies.push(indicies[index - 1]);
	                return types.push(prev);
	            }
	            indicies.push(index);
	            return types.push(AL);
	        }
	
	        indicies.push(index);
	
	        if (classType === CJ) {
	            return types.push(lineBreak === 'strict' ? NS : ID);
	        }
	
	        if (classType === SA) {
	            return types.push(AL);
	        }
	
	        if (classType === AI) {
	            return types.push(AL);
	        }
	
	        // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
	        // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
	        // to take into account the actual line breaking properties for these characters.
	        if (classType === XX) {
	            if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) {
	                return types.push(ID);
	            } else {
	                return types.push(AL);
	            }
	        }
	
	        types.push(classType);
	    });
	
	    return [indicies, types, categories];
	};
	
	var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
	    var current = classTypes[currentIndex];
	    if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
	        var i = currentIndex;
	        while (i <= classTypes.length) {
	            i++;
	            var next = classTypes[i];
	
	            if (next === b) {
	                return true;
	            }
	
	            if (next !== SP) {
	                break;
	            }
	        }
	    }
	
	    if (current === SP) {
	        var _i = currentIndex;
	
	        while (_i > 0) {
	            _i--;
	            var prev = classTypes[_i];
	
	            if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
	                var n = currentIndex;
	                while (n <= classTypes.length) {
	                    n++;
	                    var _next = classTypes[n];
	
	                    if (_next === b) {
	                        return true;
	                    }
	
	                    if (_next !== SP) {
	                        break;
	                    }
	                }
	            }
	
	            if (prev !== SP) {
	                break;
	            }
	        }
	    }
	    return false;
	};
	
	var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
	    var i = currentIndex;
	    while (i >= 0) {
	        var type = classTypes[i];
	        if (type === SP) {
	            i--;
	        } else {
	            return type;
	        }
	    }
	    return 0;
	};
	
	var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
	    if (indicies[index] === 0) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    var currentIndex = index - 1;
	    if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    var beforeIndex = currentIndex - 1;
	    var afterIndex = currentIndex + 1;
	    var current = classTypes[currentIndex];
	
	    // LB4 Always break after hard line breaks.
	    // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
	    var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
	    var next = classTypes[afterIndex];
	
	    if (current === CR && next === LF) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
	        return BREAK_MANDATORY;
	    }
	
	    // LB6 Do not break before hard line breaks.
	    if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB7 Do not break before spaces or zero width space.
	    if (SPACE.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
	    if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
	        return BREAK_ALLOWED;
	    }
	
	    // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
	    if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB11 Do not break before or after Word joiner and related characters.
	    if (current === WJ || next === WJ) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB12 Do not break after NBSP and related characters.
	    if (current === GL) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
	    if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
	    if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB14 Do not break after ‘[’, even after spaces.
	    if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB15 Do not break within ‘”[’, even with intervening spaces.
	    if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
	    if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB17 Do not break within ‘——’, even with intervening spaces.
	    if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB18 Break after spaces.
	    if (current === SP) {
	        return BREAK_ALLOWED;
	    }
	
	    // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
	    if (current === QU || next === QU) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB20 Break before and after unresolved CB.
	    if (next === CB || current === CB) {
	        return BREAK_ALLOWED;
	    }
	
	    // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
	    if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB21a Don't break after Hebrew + Hyphen.
	    if (before === HL && HYPHEN.indexOf(current) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB21b Don’t break between Solidus and Hebrew letters.
	    if (current === SY && next === HL) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
	    if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB23 Do not break between digits and letters.
	    if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
	    if (current === PR && [ID, EB, EM].indexOf(next) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next === PO) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
	    if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB25 Do not break between the following pairs of classes relevant to numbers:
	    if (
	    // (PR | PO) × ( OP | HY )? NU
	    [PR, PO].indexOf(current) !== -1 && (next === NU || [OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) ||
	    // ( OP | HY ) × NU
	    [OP, HY].indexOf(current) !== -1 && next === NU ||
	    // NU ×	(NU | SY | IS)
	    current === NU && [NU, SY, IS].indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
	    if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
	        var prevIndex = currentIndex;
	        while (prevIndex >= 0) {
	            var type = classTypes[prevIndex];
	            if (type === NU) {
	                return BREAK_NOT_ALLOWED;
	            } else if ([SY, IS].indexOf(type) !== -1) {
	                prevIndex--;
	            } else {
	                break;
	            }
	        }
	    }
	
	    // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
	    if ([PR, PO].indexOf(next) !== -1) {
	        var _prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
	        while (_prevIndex >= 0) {
	            var _type = classTypes[_prevIndex];
	            if (_type === NU) {
	                return BREAK_NOT_ALLOWED;
	            } else if ([SY, IS].indexOf(_type) !== -1) {
	                _prevIndex--;
	            } else {
	                break;
	            }
	        }
	    }
	
	    // LB26 Do not break a Korean syllable.
	    if (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1 || [JT, H3].indexOf(current) !== -1 && next === JT) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB27 Treat a Korean Syllable Block the same as ID.
	    if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB28 Do not break between alphabetics (“at”).
	    if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
	    if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
	    if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
	    // indicators preceding the position of the break.
	    if (current === RI && next === RI) {
	        var i = indicies[currentIndex];
	        var count = 1;
	        while (i > 0) {
	            i--;
	            if (classTypes[i] === RI) {
	                count++;
	            } else {
	                break;
	            }
	        }
	        if (count % 2 !== 0) {
	            return BREAK_NOT_ALLOWED;
	        }
	    }
	
	    // LB30b Do not break between an emoji base and an emoji modifier.
	    if (current === EB && next === EM) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    return BREAK_ALLOWED;
	};
	
	var lineBreakAtIndex = exports.lineBreakAtIndex = function lineBreakAtIndex(codePoints, index) {
	    // LB2 Never break at the start of text.
	    if (index === 0) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB3 Always break at the end of text.
	    if (index >= codePoints.length) {
	        return BREAK_MANDATORY;
	    }
	
	    var _codePointsToCharacte = codePointsToCharacterClasses(codePoints),
	        _codePointsToCharacte2 = _slicedToArray(_codePointsToCharacte, 2),
	        indicies = _codePointsToCharacte2[0],
	        classTypes = _codePointsToCharacte2[1];
	
	    return _lineBreakAtIndex(codePoints, classTypes, indicies, index);
	};
	
	var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
	    if (!options) {
	        options = { lineBreak: 'normal', wordBreak: 'normal' };
	    }
	
	    var _codePointsToCharacte3 = codePointsToCharacterClasses(codePoints, options.lineBreak),
	        _codePointsToCharacte4 = _slicedToArray(_codePointsToCharacte3, 3),
	        indicies = _codePointsToCharacte4[0],
	        classTypes = _codePointsToCharacte4[1],
	        isLetterNumber = _codePointsToCharacte4[2];
	
	    if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
	        classTypes = classTypes.map(function (type) {
	            return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
	        });
	    }
	
	    var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function (isLetterNumber, i) {
	        return isLetterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
	    }) : null;
	
	    return [indicies, classTypes, forbiddenBreakpoints];
	};
	
	var inlineBreakOpportunities = exports.inlineBreakOpportunities = function inlineBreakOpportunities(str, options) {
	    var codePoints = (0, _Util.toCodePoints)(str);
	    var output = BREAK_NOT_ALLOWED;
	
	    var _cssFormattedClasses = cssFormattedClasses(codePoints, options),
	        _cssFormattedClasses2 = _slicedToArray(_cssFormattedClasses, 3),
	        indicies = _cssFormattedClasses2[0],
	        classTypes = _cssFormattedClasses2[1],
	        forbiddenBreakpoints = _cssFormattedClasses2[2];
	
	    codePoints.forEach(function (codePoint, i) {
	        output += (0, _Util.fromCodePoint)(codePoint) + (i >= codePoints.length - 1 ? BREAK_MANDATORY : _lineBreakAtIndex(codePoints, classTypes, indicies, i + 1, forbiddenBreakpoints));
	    });
	
	    return output;
	};
	
	var Break = function () {
	    function Break(codePoints, lineBreak, start, end) {
	        _classCallCheck(this, Break);
	
	        this._codePoints = codePoints;
	        this.required = lineBreak === BREAK_MANDATORY;
	        this.start = start;
	        this.end = end;
	    }
	
	    _createClass(Break, [{
	        key: 'slice',
	        value: function slice() {
	            return _Util.fromCodePoint.apply(undefined, _toConsumableArray(this._codePoints.slice(this.start, this.end)));
	        }
	    }]);
	
	    return Break;
	}();
	
	var LineBreaker = exports.LineBreaker = function LineBreaker(str, options) {
	    var codePoints = (0, _Util.toCodePoints)(str);
	
	    var _cssFormattedClasses3 = cssFormattedClasses(codePoints, options),
	        _cssFormattedClasses4 = _slicedToArray(_cssFormattedClasses3, 3),
	        indicies = _cssFormattedClasses4[0],
	        classTypes = _cssFormattedClasses4[1],
	        forbiddenBreakpoints = _cssFormattedClasses4[2];
	
	    var length = codePoints.length;
	    var lastEnd = 0;
	    var nextIndex = 0;
	
	    return {
	        next: function next() {
	            if (nextIndex >= length) {
	                return { done: true };
	            }
	            var lineBreak = BREAK_NOT_ALLOWED;
	            while (nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED) {}
	
	            if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
	                var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
	                lastEnd = nextIndex;
	                return { value: value, done: false };
	            }
	
	            return { done: true };
	        }
	    };
	};

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Trie = exports.createTrieFromBase64 = exports.UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_DATA_MASK = exports.UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_SHIFT_1_2 = exports.UTRIE2_INDEX_SHIFT = exports.UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_2 = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Util = __webpack_require__(387);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** Shift size for getting the index-2 table offset. */
	var UTRIE2_SHIFT_2 = exports.UTRIE2_SHIFT_2 = 5;
	
	/** Shift size for getting the index-1 table offset. */
	var UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_1 = 6 + 5;
	
	/**
	 * Shift size for shifting left the index array values.
	 * Increases possible data size with 16-bit index values at the cost
	 * of compactability.
	 * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
	 */
	var UTRIE2_INDEX_SHIFT = exports.UTRIE2_INDEX_SHIFT = 2;
	
	/**
	 * Difference between the two shift sizes,
	 * for getting an index-1 offset from an index-2 offset. 6=11-5
	 */
	var UTRIE2_SHIFT_1_2 = exports.UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
	
	/**
	 * The part of the index-2 table for U+D800..U+DBFF stores values for
	 * lead surrogate code _units_ not code _points_.
	 * Values for lead surrogate code _points_ are indexed with this portion of the table.
	 * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
	 */
	var UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
	
	/** Number of entries in a data block. 32=0x20 */
	var UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
	/** Mask for getting the lower bits for the in-data-block offset. */
	var UTRIE2_DATA_MASK = exports.UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
	
	var UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
	/** Count the lengths of both BMP pieces. 2080=0x820 */
	var UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
	/**
	 * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
	 * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
	 */
	var UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
	var UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
	/**
	 * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
	 * Variable length, for code points up to highStart, where the last single-value range starts.
	 * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
	 * (For 0x100000 supplementary code points U+10000..U+10ffff.)
	 *
	 * The part of the index-2 table for supplementary code points starts
	 * after this index-1 table.
	 *
	 * Both the index-1 table and the following part of the index-2 table
	 * are omitted completely if there is only BMP data.
	 */
	var UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
	
	/**
	 * Number of index-1 entries for the BMP. 32=0x20
	 * This part of the index-1 table is omitted from the serialized form.
	 */
	var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
	
	/** Number of entries in an index-2 block. 64=0x40 */
	var UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
	/** Mask for getting the lower bits for the in-index-2-block offset. */
	var UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
	
	var createTrieFromBase64 = exports.createTrieFromBase64 = function createTrieFromBase64(base64) {
	    var buffer = (0, _Util.decode)(base64);
	    var view32 = Array.isArray(buffer) ? (0, _Util.polyUint32Array)(buffer) : new Uint32Array(buffer);
	    var view16 = Array.isArray(buffer) ? (0, _Util.polyUint16Array)(buffer) : new Uint16Array(buffer);
	    var headerLength = 24;
	
	    var index = view16.slice(headerLength / 2, view32[4] / 2);
	    var data = view32[5] === 2 ? view16.slice((headerLength + view32[4]) / 2) : view32.slice(Math.ceil((headerLength + view32[4]) / 4));
	
	    return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
	};
	
	var Trie = exports.Trie = function () {
	    function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
	        _classCallCheck(this, Trie);
	
	        this.initialValue = initialValue;
	        this.errorValue = errorValue;
	        this.highStart = highStart;
	        this.highValueIndex = highValueIndex;
	        this.index = index;
	        this.data = data;
	    }
	
	    /**
	     * Get the value for a code point as stored in the Trie.
	     *
	     * @param codePoint the code point
	     * @return the value
	     */
	
	
	    _createClass(Trie, [{
	        key: 'get',
	        value: function get(codePoint) {
	            var ix = void 0;
	            if (codePoint >= 0) {
	                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
	                    // Ordinary BMP code point, excluding leading surrogates.
	                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
	                    // 16 bit data is stored in the index array itself.
	                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	
	                if (codePoint <= 0xffff) {
	                    // Lead Surrogate Code Point.  A Separate index section is stored for
	                    // lead surrogate code units and code points.
	                    //   The main index has the code unit data.
	                    //   For this function, we need the code point data.
	                    // Note: this expression could be refactored for slightly improved efficiency, but
	                    //       surrogate code points will be so rare in practice that it's not worth it.
	                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	
	                if (codePoint < this.highStart) {
	                    // Supplemental code point, use two-level lookup.
	                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
	                    ix = this.index[ix];
	                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
	                    ix = this.index[ix];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	                if (codePoint <= 0x10ffff) {
	                    return this.data[this.highValueIndex];
	                }
	            }
	
	            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
	            return this.errorValue;
	        }
	    }]);
	
	    return Trie;
	}();

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Util = __webpack_require__(387);
	
	Object.defineProperty(exports, 'toCodePoints', {
	  enumerable: true,
	  get: function get() {
	    return _Util.toCodePoints;
	  }
	});
	Object.defineProperty(exports, 'fromCodePoint', {
	  enumerable: true,
	  get: function get() {
	    return _Util.fromCodePoint;
	  }
	});
	
	var _LineBreak = __webpack_require__(1341);
	
	Object.defineProperty(exports, 'LineBreaker', {
	  enumerable: true,
	  get: function get() {
	    return _LineBreak.LineBreaker;
	  }
	});

/***/ },
/* 1344 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = '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';

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.2.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex3 = /^#([0-9a-f]{3})$/,
	    reHex6 = /^#([0-9a-f]{6})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	function formatDecimal(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  this.fill = match[1] || " ";
	  this.align = match[2] || ">";
	  this.sign = match[3] || "-";
	  this.symbol = match[4] || "";
	  this.zero = !!match[5];
	  this.width = match[6] && +match[6];
	  this.comma = !!match[7];
	  this.precision = match[8] && +match[8].slice(1);
	  this.trim = !!match[9];
	  this.type = match[10] || "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision == null && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1347)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function array(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHue = hue$1;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.1.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(578)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(1361)
	
	var MILLISECONDS_IN_MINUTE = 60000
	var MILLISECONDS_IN_DAY = 86400000
	
	/**
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 */
	function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
	  var startOfDayLeft = startOfDay(dirtyDateLeft)
	  var startOfDayRight = startOfDay(dirtyDateRight)
	
	  var timestampLeft = startOfDayLeft.getTime() -
	    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	  var timestampRight = startOfDayRight.getTime() -
	    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
	}
	
	module.exports = differenceInCalendarDays


/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	var getDayOfYear = __webpack_require__(1354)
	var getISOWeek = __webpack_require__(1355)
	var getISOYear = __webpack_require__(579)
	var parse = __webpack_require__(138)
	var isValid = __webpack_require__(1356)
	var enLocale = __webpack_require__(1360)
	
	/**
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 *
	 * Accepted tokens:
	 * | Unit                    | Token | Result examples                  |
	 * |-------------------------|-------|----------------------------------|
	 * | Month                   | M     | 1, 2, ..., 12                    |
	 * |                         | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         | MM    | 01, 02, ..., 12                  |
	 * |                         | MMM   | Jan, Feb, ..., Dec               |
	 * |                         | MMMM  | January, February, ..., December |
	 * | Quarter                 | Q     | 1, 2, 3, 4                       |
	 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Day of month            | D     | 1, 2, ..., 31                    |
	 * |                         | Do    | 1st, 2nd, ..., 31st              |
	 * |                         | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | DDD   | 1, 2, ..., 366                   |
	 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         | DDDD  | 001, 002, ..., 366               |
	 * | Day of week             | d     | 0, 1, ..., 6                     |
	 * |                         | do    | 0th, 1st, ..., 6th               |
	 * |                         | dd    | Su, Mo, ..., Sa                  |
	 * |                         | ddd   | Sun, Mon, ..., Sat               |
	 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	 * | ISO week                | W     | 1, 2, ..., 53                    |
	 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         | WW    | 01, 02, ..., 53                  |
	 * | Year                    | YY    | 00, 01, ..., 99                  |
	 * |                         | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	 * |                         | GGGG  | 1900, 1901, ..., 2099            |
	 * | AM/PM                   | A     | AM, PM                           |
	 * |                         | a     | am, pm                           |
	 * |                         | aa    | a.m., p.m.                       |
	 * | Hour                    | H     | 0, 1, ... 23                     |
	 * |                         | HH    | 00, 01, ... 23                   |
	 * |                         | h     | 1, 2, ..., 12                    |
	 * |                         | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | m     | 0, 1, ..., 59                    |
	 * |                         | mm    | 00, 01, ..., 59                  |
	 * | Second                  | s     | 0, 1, ..., 59                    |
	 * |                         | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | X     | 512969520                        |
	 * | Milliseconds timestamp  | x     | 512969520900                     |
	 *
	 * The characters wrapped in square brackets are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
	 * @param {Object} [options] - the object with options
	 * @param {Object} [options.locale=enLocale] - the locale object
	 * @returns {String} the formatted date string
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(
	 *   new Date(2014, 1, 11),
	 *   'MM/DD/YYYY'
	 * )
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = format(
	 *   new Date(2014, 6, 2),
	 *   'Do [de] MMMM YYYY',
	 *   {locale: eoLocale}
	 * )
	 * //=> '2-a de julio 2014'
	 */
	function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
	  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
	  var options = dirtyOptions || {}
	
	  var locale = options.locale
	  var localeFormatters = enLocale.format.formatters
	  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
	  if (locale && locale.format && locale.format.formatters) {
	    localeFormatters = locale.format.formatters
	
	    if (locale.format.formattingTokensRegExp) {
	      formattingTokensRegExp = locale.format.formattingTokensRegExp
	    }
	  }
	
	  var date = parse(dirtyDate)
	
	  if (!isValid(date)) {
	    return 'Invalid Date'
	  }
	
	  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)
	
	  return formatFn(date)
	}
	
	var formatters = {
	  // Month: 1, 2, ..., 12
	  'M': function (date) {
	    return date.getMonth() + 1
	  },
	
	  // Month: 01, 02, ..., 12
	  'MM': function (date) {
	    return addLeadingZeros(date.getMonth() + 1, 2)
	  },
	
	  // Quarter: 1, 2, 3, 4
	  'Q': function (date) {
	    return Math.ceil((date.getMonth() + 1) / 3)
	  },
	
	  // Day of month: 1, 2, ..., 31
	  'D': function (date) {
	    return date.getDate()
	  },
	
	  // Day of month: 01, 02, ..., 31
	  'DD': function (date) {
	    return addLeadingZeros(date.getDate(), 2)
	  },
	
	  // Day of year: 1, 2, ..., 366
	  'DDD': function (date) {
	    return getDayOfYear(date)
	  },
	
	  // Day of year: 001, 002, ..., 366
	  'DDDD': function (date) {
	    return addLeadingZeros(getDayOfYear(date), 3)
	  },
	
	  // Day of week: 0, 1, ..., 6
	  'd': function (date) {
	    return date.getDay()
	  },
	
	  // Day of ISO week: 1, 2, ..., 7
	  'E': function (date) {
	    return date.getDay() || 7
	  },
	
	  // ISO week: 1, 2, ..., 53
	  'W': function (date) {
	    return getISOWeek(date)
	  },
	
	  // ISO week: 01, 02, ..., 53
	  'WW': function (date) {
	    return addLeadingZeros(getISOWeek(date), 2)
	  },
	
	  // Year: 00, 01, ..., 99
	  'YY': function (date) {
	    return addLeadingZeros(date.getFullYear(), 4).substr(2)
	  },
	
	  // Year: 1900, 1901, ..., 2099
	  'YYYY': function (date) {
	    return addLeadingZeros(date.getFullYear(), 4)
	  },
	
	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': function (date) {
	    return String(getISOYear(date)).substr(2)
	  },
	
	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': function (date) {
	    return getISOYear(date)
	  },
	
	  // Hour: 0, 1, ... 23
	  'H': function (date) {
	    return date.getHours()
	  },
	
	  // Hour: 00, 01, ..., 23
	  'HH': function (date) {
	    return addLeadingZeros(date.getHours(), 2)
	  },
	
	  // Hour: 1, 2, ..., 12
	  'h': function (date) {
	    var hours = date.getHours()
	    if (hours === 0) {
	      return 12
	    } else if (hours > 12) {
	      return hours % 12
	    } else {
	      return hours
	    }
	  },
	
	  // Hour: 01, 02, ..., 12
	  'hh': function (date) {
	    return addLeadingZeros(formatters['h'](date), 2)
	  },
	
	  // Minute: 0, 1, ..., 59
	  'm': function (date) {
	    return date.getMinutes()
	  },
	
	  // Minute: 00, 01, ..., 59
	  'mm': function (date) {
	    return addLeadingZeros(date.getMinutes(), 2)
	  },
	
	  // Second: 0, 1, ..., 59
	  's': function (date) {
	    return date.getSeconds()
	  },
	
	  // Second: 00, 01, ..., 59
	  'ss': function (date) {
	    return addLeadingZeros(date.getSeconds(), 2)
	  },
	
	  // 1/10 of second: 0, 1, ..., 9
	  'S': function (date) {
	    return Math.floor(date.getMilliseconds() / 100)
	  },
	
	  // 1/100 of second: 00, 01, ..., 99
	  'SS': function (date) {
	    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
	  },
	
	  // Millisecond: 000, 001, ..., 999
	  'SSS': function (date) {
	    return addLeadingZeros(date.getMilliseconds(), 3)
	  },
	
	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': function (date) {
	    return formatTimezone(date.getTimezoneOffset(), ':')
	  },
	
	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': function (date) {
	    return formatTimezone(date.getTimezoneOffset())
	  },
	
	  // Seconds timestamp: 512969520
	  'X': function (date) {
	    return Math.floor(date.getTime() / 1000)
	  },
	
	  // Milliseconds timestamp: 512969520900
	  'x': function (date) {
	    return date.getTime()
	  }
	}
	
	function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
	  var array = formatStr.match(formattingTokensRegExp)
	  var length = array.length
	
	  var i
	  var formatter
	  for (i = 0; i < length; i++) {
	    formatter = localeFormatters[array[i]] || formatters[array[i]]
	    if (formatter) {
	      array[i] = formatter
	    } else {
	      array[i] = removeFormattingTokens(array[i])
	    }
	  }
	
	  return function (date) {
	    var output = ''
	    for (var i = 0; i < length; i++) {
	      if (array[i] instanceof Function) {
	        output += array[i](date, formatters)
	      } else {
	        output += array[i]
	      }
	    }
	    return output
	  }
	}
	
	function removeFormattingTokens (input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '')
	  }
	  return input.replace(/\\/g, '')
	}
	
	function formatTimezone (offset, delimeter) {
	  delimeter = delimeter || ''
	  var sign = offset > 0 ? '-' : '+'
	  var absOffset = Math.abs(offset)
	  var hours = Math.floor(absOffset / 60)
	  var minutes = absOffset % 60
	  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
	}
	
	function addLeadingZeros (number, targetLength) {
	  var output = Math.abs(number).toString()
	  while (output.length < targetLength) {
	    output = '0' + output
	  }
	  return output
	}
	
	module.exports = format


/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(138)
	var startOfYear = __webpack_require__(1364)
	var differenceInCalendarDays = __webpack_require__(1352)
	
	/**
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the day of year
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * var result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var diff = differenceInCalendarDays(date, startOfYear(date))
	  var dayOfYear = diff + 1
	  return dayOfYear
	}
	
	module.exports = getDayOfYear


/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(138)
	var startOfISOWeek = __webpack_require__(389)
	var startOfISOYear = __webpack_require__(1362)
	
	var MILLISECONDS_IN_WEEK = 604800000
	
	/**
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the ISO week
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * var result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	function getISOWeek (dirtyDate) {
	  var date = parse(dirtyDate)
	  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
	}
	
	module.exports = getISOWeek


/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	var isDate = __webpack_require__(580)
	
	/**
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {Date} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} argument must be an instance of Date
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid (dirtyDate) {
	  if (isDate(dirtyDate)) {
	    return !isNaN(dirtyDate)
	  } else {
	    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
	  }
	}
	
	module.exports = isValid


/***/ },
/* 1357 */
/***/ function(module, exports) {

	var commonFormatterKeys = [
	  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
	  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
	  'H', 'HH', 'h', 'hh', 'm', 'mm',
	  's', 'ss', 'S', 'SS', 'SSS',
	  'Z', 'ZZ', 'X', 'x'
	]
	
	function buildFormattingTokensRegExp (formatters) {
	  var formatterKeys = []
	  for (var key in formatters) {
	    if (formatters.hasOwnProperty(key)) {
	      formatterKeys.push(key)
	    }
	  }
	
	  var formattingTokens = commonFormatterKeys
	    .concat(formatterKeys)
	    .sort()
	    .reverse()
	  var formattingTokensRegExp = new RegExp(
	    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
	  )
	
	  return formattingTokensRegExp
	}
	
	module.exports = buildFormattingTokensRegExp


/***/ },
/* 1358 */
/***/ function(module, exports) {

	function buildDistanceInWordsLocale () {
	  var distanceInWordsLocale = {
	    lessThanXSeconds: {
	      one: 'less than a second',
	      other: 'less than {{count}} seconds'
	    },
	
	    xSeconds: {
	      one: '1 second',
	      other: '{{count}} seconds'
	    },
	
	    halfAMinute: 'half a minute',
	
	    lessThanXMinutes: {
	      one: 'less than a minute',
	      other: 'less than {{count}} minutes'
	    },
	
	    xMinutes: {
	      one: '1 minute',
	      other: '{{count}} minutes'
	    },
	
	    aboutXHours: {
	      one: 'about 1 hour',
	      other: 'about {{count}} hours'
	    },
	
	    xHours: {
	      one: '1 hour',
	      other: '{{count}} hours'
	    },
	
	    xDays: {
	      one: '1 day',
	      other: '{{count}} days'
	    },
	
	    aboutXMonths: {
	      one: 'about 1 month',
	      other: 'about {{count}} months'
	    },
	
	    xMonths: {
	      one: '1 month',
	      other: '{{count}} months'
	    },
	
	    aboutXYears: {
	      one: 'about 1 year',
	      other: 'about {{count}} years'
	    },
	
	    xYears: {
	      one: '1 year',
	      other: '{{count}} years'
	    },
	
	    overXYears: {
	      one: 'over 1 year',
	      other: 'over {{count}} years'
	    },
	
	    almostXYears: {
	      one: 'almost 1 year',
	      other: 'almost {{count}} years'
	    }
	  }
	
	  function localize (token, count, options) {
	    options = options || {}
	
	    var result
	    if (typeof distanceInWordsLocale[token] === 'string') {
	      result = distanceInWordsLocale[token]
	    } else if (count === 1) {
	      result = distanceInWordsLocale[token].one
	    } else {
	      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
	    }
	
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'in ' + result
	      } else {
	        return result + ' ago'
	      }
	    }
	
	    return result
	  }
	
	  return {
	    localize: localize
	  }
	}
	
	module.exports = buildDistanceInWordsLocale


/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	var buildFormattingTokensRegExp = __webpack_require__(1357)
	
	function buildFormatLocale () {
	  // Note: in English, the names of days of the week and months are capitalized.
	  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
	  // Generally, formatted dates should look like they are in the middle of a sentence,
	  // e.g. in Spanish language the weekdays and months should be in the lowercase.
	  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
	  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
	  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
	  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	  var meridiemUppercase = ['AM', 'PM']
	  var meridiemLowercase = ['am', 'pm']
	  var meridiemFull = ['a.m.', 'p.m.']
	
	  var formatters = {
	    // Month: Jan, Feb, ..., Dec
	    'MMM': function (date) {
	      return months3char[date.getMonth()]
	    },
	
	    // Month: January, February, ..., December
	    'MMMM': function (date) {
	      return monthsFull[date.getMonth()]
	    },
	
	    // Day of week: Su, Mo, ..., Sa
	    'dd': function (date) {
	      return weekdays2char[date.getDay()]
	    },
	
	    // Day of week: Sun, Mon, ..., Sat
	    'ddd': function (date) {
	      return weekdays3char[date.getDay()]
	    },
	
	    // Day of week: Sunday, Monday, ..., Saturday
	    'dddd': function (date) {
	      return weekdaysFull[date.getDay()]
	    },
	
	    // AM, PM
	    'A': function (date) {
	      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
	    },
	
	    // am, pm
	    'a': function (date) {
	      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
	    },
	
	    // a.m., p.m.
	    'aa': function (date) {
	      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
	    }
	  }
	
	  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
	  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
	  ordinalFormatters.forEach(function (formatterToken) {
	    formatters[formatterToken + 'o'] = function (date, formatters) {
	      return ordinal(formatters[formatterToken](date))
	    }
	  })
	
	  return {
	    formatters: formatters,
	    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
	  }
	}
	
	function ordinal (number) {
	  var rem100 = number % 100
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st'
	      case 2:
	        return number + 'nd'
	      case 3:
	        return number + 'rd'
	    }
	  }
	  return number + 'th'
	}
	
	module.exports = buildFormatLocale


/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	var buildDistanceInWordsLocale = __webpack_require__(1358)
	var buildFormatLocale = __webpack_require__(1359)
	
	/**
	 * @category Locales
	 * @summary English locale.
	 */
	module.exports = {
	  distanceInWords: buildDistanceInWordsLocale(),
	  format: buildFormatLocale()
	}


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(138)
	
	/**
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a day
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfDay


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(579)
	var startOfISOWeek = __webpack_require__(389)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of an ISO year
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * var result = startOfISOYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOYear (dirtyDate) {
	  var year = getISOYear(dirtyDate)
	  var fourthOfJanuary = new Date(0)
	  fourthOfJanuary.setFullYear(year, 0, 4)
	  fourthOfJanuary.setHours(0, 0, 0, 0)
	  var date = startOfISOWeek(fourthOfJanuary)
	  return date
	}
	
	module.exports = startOfISOYear


/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(138)
	
	/**
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek (dirtyDate, dirtyOptions) {
	  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
	
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn
	
	  date.setDate(date.getDate() - diff)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfWeek


/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(138)
	
	/**
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a year
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear (dirtyDate) {
	  var cleanDate = parse(dirtyDate)
	  var date = new Date(0)
	  date.setFullYear(cleanDate.getFullYear(), 0, 1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfYear


/***/ },
/* 1365 */
/***/ function(module, exports) {

	/**
	 * Returns a function, that, as long as it continues to be invoked, will not
	 * be triggered. The function will be called after it stops being called for
	 * N milliseconds. If `immediate` is passed, trigger the function on the
	 * leading edge, instead of the trailing. The function also has a property 'clear' 
	 * that is a function which will clear the timer to prevent previously scheduled executions. 
	 *
	 * @source underscore.js
	 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
	 * @param {Function} function to wrap
	 * @param {Number} timeout in ms (`100`)
	 * @param {Boolean} whether to execute at the beginning (`false`)
	 * @api public
	 */
	function debounce(func, wait, immediate){
	  var timeout, args, context, timestamp, result;
	  if (null == wait) wait = 100;
	
	  function later() {
	    var last = Date.now() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	    }
	  };
	
	  var debounced = function(){
	    context = this;
	    args = arguments;
	    timestamp = Date.now();
	    var callNow = immediate && !timeout;
	    if (!timeout) timeout = setTimeout(later, wait);
	    if (callNow) {
	      result = func.apply(context, args);
	      context = args = null;
	    }
	
	    return result;
	  };
	
	  debounced.clear = function() {
	    if (timeout) {
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	  
	  debounced.flush = function() {
	    if (timeout) {
	      result = func.apply(context, args);
	      context = args = null;
	      
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	
	  return debounced;
	};
	
	// Adds compatibility for ES modules
	debounce.debounce = debounce;
	
	module.exports = debounce;


/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(139);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = _utils2['default'].clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return _utils2['default'].mix(pos, size);
	}
	
	exports['default'] = adjustForViewport;
	module.exports = exports['default'];

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _align = __webpack_require__(582);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _getOffsetParent = __webpack_require__(583);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _getVisibleRectForElement = __webpack_require__(585);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _getRegion = __webpack_require__(584);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isOutOfVisibleRect(target) {
	  var visibleRect = (0, _getVisibleRectForElement2['default'])(target);
	  var targetRegion = (0, _getRegion2['default'])(target);
	
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	
	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = (0, _getRegion2['default'])(target);
	
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);
	
	  return (0, _align2['default'])(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}
	
	alignElement.__getOffsetParent = _getOffsetParent2['default'];
	
	alignElement.__getVisibleRectForElement = _getVisibleRectForElement2['default'];
	
	exports['default'] = alignElement;
	module.exports = exports['default'];

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(139);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _align = __webpack_require__(582);
	
	var _align2 = _interopRequireDefault(_align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */
	
	function alignPoint(el, tgtPoint, align) {
	  var pageX = void 0;
	  var pageY = void 0;
	
	  var doc = _utils2['default'].getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	
	  var scrollX = _utils2['default'].getWindowScrollLeft(win);
	  var scrollY = _utils2['default'].getWindowScrollTop(win);
	  var viewportWidth = _utils2['default'].viewportWidth(win);
	  var viewportHeight = _utils2['default'].viewportHeight(win);
	
	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }
	
	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }
	
	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
	
	  // Provide default target point
	  var points = [align.points[0], 'cc'];
	
	  return (0, _align2['default'])(el, tgtRegion, _extends({}, align, { points: points }), pointInView);
	}
	
	exports['default'] = alignPoint;
	module.exports = exports['default'];

/***/ },
/* 1369 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	
	  var x = region.left;
	  var y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	exports['default'] = getAlignOffset;
	module.exports = exports['default'];

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAlignOffset = __webpack_require__(1369);
	
	var _getAlignOffset2 = _interopRequireDefault(_getAlignOffset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = (0, _getAlignOffset2['default'])(refNodeRegion, points[1]);
	  var p2 = (0, _getAlignOffset2['default'])(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	
	  return {
	    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
	    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
	  };
	}
	
	exports['default'] = getElFuturePos;
	module.exports = exports['default'];

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.alignPoint = exports.alignElement = undefined;
	
	var _alignElement = __webpack_require__(1367);
	
	var _alignElement2 = _interopRequireDefault(_alignElement);
	
	var _alignPoint = __webpack_require__(1368);
	
	var _alignPoint2 = _interopRequireDefault(_alignPoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.alignElement = _alignElement2['default'];
	exports.alignPoint = _alignPoint2['default'];
	exports['default'] = _alignElement2['default'];

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isAncestorFixed;
	
	var _utils = __webpack_require__(139);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isAncestorFixed(element) {
	  if (_utils2['default'].isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	
	  var doc = _utils2['default'].getDocument(element);
	  var body = doc.body;
	  var parent = null;
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    var positionStyle = _utils2['default'].css(parent, 'position');
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 1373 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransformName = getTransformName;
	exports.setTransitionProperty = setTransitionProperty;
	exports.getTransitionProperty = getTransitionProperty;
	exports.getTransformXY = getTransformXY;
	exports.setTransformXY = setTransformXY;
	var vendorPrefix = void 0;
	
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
	}
	
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr = void 0;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, 'matrix(' + arr.join(',') + ')');
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
	    }
	  } else {
	    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
	  }
	}

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(174));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(586));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(588));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(587));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(140));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1377 */
475,
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(174));
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc && doc.defaultView || doc.parentWindow;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = height;
	
	var _offset = _interopRequireDefault(__webpack_require__(219));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(218));
	
	function height(node, client) {
	  var win = (0, _isWindow.default)(node);
	  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset.default)(node).height;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(1377));
	
	var _offset = _interopRequireDefault(__webpack_require__(219));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(590));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(391));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(1381));
	
	var _style = _interopRequireDefault(__webpack_require__(392));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(218));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(592));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1383 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1384 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1385 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1386 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(1386));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(46);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(140));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.5+7f2b526d
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = void 0;
	var customSchedulerFn = void 0;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var vertx = Function('return this')().require('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	
	  if (_state) {
	    var callback = arguments[_state - 1];
	    asap(function () {
	      return invokeCallback(_state, child, callback, parent._result);
	    });
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(2);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var TRY_CATCH_ERROR = { error: null };
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    TRY_CATCH_ERROR.error = error;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === TRY_CATCH_ERROR) {
	      reject(promise, TRY_CATCH_ERROR.error);
	      TRY_CATCH_ERROR.error = null;
	    } else if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = void 0,
	      error = void 0,
	      succeeded = void 0,
	      failed = void 0;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value.error = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	    resolve(promise, value);
	  } else if (failed) {
	    reject(promise, error);
	  } else if (settled === FULFILLED) {
	    fulfill(promise, value);
	  } else if (settled === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop);
	
	    if (!this.promise[PROMISE_ID]) {
	      makePromise(this.promise);
	    }
	
	    if (isArray(input)) {
	      this.length = input.length;
	      this._remaining = input.length;
	
	      this._result = new Array(this.length);
	
	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate(input);
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, validationError());
	    }
	  }
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    for (var i = 0; this._state === PENDING && i < input.length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	
	    if (resolve$$1 === resolve$1) {
	      var _then = getThen(entry);
	
	      if (_then === then && entry._state !== PENDING) {
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof _then !== 'function') {
	        this._remaining--;
	        this._result[i] = entry;
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        handleMaybeThenable(promise, entry, _then);
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	
	    if (promise._state === PENDING) {
	      this._remaining--;
	
	      if (state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = value;
	      }
	    }
	
	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {Function} resolver
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise$1 = function () {
	  function Promise(resolver) {
	    this[PROMISE_ID] = nextId();
	    this._result = this._state = undefined;
	    this._subscribers = [];
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  /**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	   ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	   Chaining
	  --------
	   The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	   ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	   findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we're unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	   ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	   Assimilation
	  ------------
	   Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	   If the assimliated promise rejects, then the downstream promise will also reject.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	   Simple Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let result;
	   try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	   Advanced Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let author, books;
	   try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	   function foundBooks(books) {
	   }
	   function failure(reason) {
	   }
	   findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	   @method then
	  @param {Function} onFulfilled
	  @param {Function} onRejected
	  Useful for tooling.
	  @return {Promise}
	  */
	
	  /**
	  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	  as the catch block of a try/catch statement.
	  ```js
	  function findAuthor(){
	  throw new Error('couldn't find that author');
	  }
	  // synchronous
	  try {
	  findAuthor();
	  } catch(reason) {
	  // something went wrong
	  }
	  // async with promises
	  findAuthor().catch(function(reason){
	  // something went wrong
	  });
	  ```
	  @method catch
	  @param {Function} onRejection
	  Useful for tooling.
	  @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection) {
	    return this.then(null, onRejection);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuther();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuther();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    if (isFunction(callback)) {
	      return promise.then(function (value) {
	        return constructor.resolve(callback()).then(function () {
	          return value;
	        });
	      }, function (reason) {
	        return constructor.resolve(callback()).then(function () {
	          throw reason;
	        });
	      });
	    }
	
	    return promise.then(callback, callback);
	  };
	
	  return Promise;
	}();
	
	Promise$1.prototype.then = then;
	Promise$1.all = all;
	Promise$1.race = race;
	Promise$1.resolve = resolve$1;
	Promise$1.reject = reject$1;
	Promise$1._setScheduler = setScheduler;
	Promise$1._setAsap = setAsap;
	Promise$1._asap = asap;
	
	/*global self*/
	function polyfill() {
	  var local = void 0;
	
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	
	  var P = local.Promise;
	
	  if (P) {
	    var promiseToString = null;
	    try {
	      promiseToString = Object.prototype.toString.call(P.resolve());
	    } catch (e) {
	      // silently ignored
	    }
	
	    if (promiseToString === '[object Promise]' && !P.cast) {
	      return;
	    }
	  }
	
	  local.Promise = Promise$1;
	}
	
	// Strange compat..
	Promise$1.polyfill = polyfill;
	Promise$1.Promise = Promise$1;
	
	return Promise$1;
	
	})));
	
	
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191), (function() { return this; }())))

/***/ },
/* 1390 */
/***/ function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ },
/* 1391 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 1392 */
124,
/* 1393 */
124,
/* 1394 */
124,
/* 1395 */
124,
/* 1396 */
124,
/* 1397 */
124,
/* 1398 */
124,
/* 1399 */
124,
/* 1400 */
124,
/* 1401 */
124,
/* 1402 */
124,
/* 1403 */
124,
/* 1404 */
124,
/* 1405 */
124,
/* 1406 */
124,
/* 1407 */
124,
/* 1408 */
124,
/* 1409 */
124,
/* 1410 */
124,
/* 1411 */
124,
/* 1412 */
124,
/* 1413 */
124,
/* 1414 */
124,
/* 1415 */
124,
/* 1416 */
124,
/* 1417 */
124,
/* 1418 */
124,
/* 1419 */
124,
/* 1420 */
124,
/* 1421 */
124,
/* 1422 */
124,
/* 1423 */
124,
/* 1424 */
124,
/* 1425 */
124,
/* 1426 */
124,
/* 1427 */
124,
/* 1428 */
124,
/* 1429 */
124,
/* 1430 */
124,
/* 1431 */
124,
/* 1432 */
124,
/* 1433 */
124,
/* 1434 */
124,
/* 1435 */
124,
/* 1436 */
124,
/* 1437 */
124,
/* 1438 */
124,
/* 1439 */
124,
/* 1440 */
124,
/* 1441 */
124,
/* 1442 */
124,
/* 1443 */
124,
/* 1444 */
124,
/* 1445 */
124,
/* 1446 */
124,
/* 1447 */
124,
/* 1448 */
124,
/* 1449 */
124,
/* 1450 */
124,
/* 1451 */
124,
/* 1452 */
124,
/* 1453 */
124,
/* 1454 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1454);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1464);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(59);
	
	var createArrayFromMixed = __webpack_require__(1457);
	var getMarkupWrap = __webpack_require__(1459);
	var invariant = __webpack_require__(21);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(59);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1460 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1461 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1461);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1463 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1463);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1465 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 1466 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(502) !== null) && (__webpack_require__(1031) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(272);
	
	var _PathUtils = __webpack_require__(224);
	
	var _createTransitionManager = __webpack_require__(396);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(603);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(224);
	
	var _LocationUtils = __webpack_require__(272);
	
	var _createTransitionManager = __webpack_require__(396);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 1470 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1471 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ANGLE = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;
	
	var parseAngle = exports.parseAngle = function parseAngle(angle) {
	    var match = angle.match(ANGLE);
	
	    if (match) {
	        var value = parseFloat(match[1]);
	        switch (match[2].toLowerCase()) {
	            case 'deg':
	                return Math.PI * value / 180;
	            case 'grad':
	                return Math.PI / 200 * value;
	            case 'rad':
	                return value;
	            case 'turn':
	                return Math.PI * 2 * value;
	        }
	    }
	
	    return null;
	};

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cloneWindow = exports.DocumentCloner = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Bounds = __webpack_require__(142);
	
	var _Proxy = __webpack_require__(608);
	
	var _ResourceLoader = __webpack_require__(1477);
	
	var _ResourceLoader2 = _interopRequireDefault(_ResourceLoader);
	
	var _Util = __webpack_require__(178);
	
	var _background = __webpack_require__(225);
	
	var _CanvasRenderer = __webpack_require__(615);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _PseudoNodeContent = __webpack_require__(1475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
	
	var DocumentCloner = exports.DocumentCloner = function () {
	    function DocumentCloner(element, options, logger, copyInline, renderer) {
	        _classCallCheck(this, DocumentCloner);
	
	        this.referenceElement = element;
	        this.scrolledElements = [];
	        this.copyStyles = copyInline;
	        this.inlineImages = copyInline;
	        this.logger = logger;
	        this.options = options;
	        this.renderer = renderer;
	        this.resourceLoader = new _ResourceLoader2.default(options, logger, window);
	        this.pseudoContentData = {
	            counters: {},
	            quoteDepth: 0
	        };
	        // $FlowFixMe
	        this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
	    }
	
	    _createClass(DocumentCloner, [{
	        key: 'inlineAllImages',
	        value: function inlineAllImages(node) {
	            var _this = this;
	
	            if (this.inlineImages && node) {
	                var style = node.style;
	                Promise.all((0, _background.parseBackgroundImage)(style.backgroundImage).map(function (backgroundImage) {
	                    if (backgroundImage.method === 'url') {
	                        return _this.resourceLoader.inlineImage(backgroundImage.args[0]).then(function (img) {
	                            return img && typeof img.src === 'string' ? 'url("' + img.src + '")' : 'none';
	                        }).catch(function (e) {
	                            if (false) {
	                                _this.logger.log('Unable to load image', e);
	                            }
	                        });
	                    }
	                    return Promise.resolve('' + backgroundImage.prefix + backgroundImage.method + '(' + backgroundImage.args.join(',') + ')');
	                })).then(function (backgroundImages) {
	                    if (backgroundImages.length > 1) {
	                        // TODO Multiple backgrounds somehow broken in Chrome
	                        style.backgroundColor = '';
	                    }
	                    style.backgroundImage = backgroundImages.join(',');
	                });
	
	                if (node instanceof HTMLImageElement) {
	                    this.resourceLoader.inlineImage(node.src).then(function (img) {
	                        if (img && node instanceof HTMLImageElement && node.parentNode) {
	                            var parentNode = node.parentNode;
	                            var clonedChild = (0, _Util.copyCSSStyles)(node.style, img.cloneNode(false));
	                            parentNode.replaceChild(clonedChild, node);
	                        }
	                    }).catch(function (e) {
	                        if (false) {
	                            _this.logger.log('Unable to load image', e);
	                        }
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'inlineFonts',
	        value: function inlineFonts(document) {
	            var _this2 = this;
	
	            return Promise.all(Array.from(document.styleSheets).map(function (sheet) {
	                if (sheet.href) {
	                    return fetch(sheet.href).then(function (res) {
	                        return res.text();
	                    }).then(function (text) {
	                        return createStyleSheetFontsFromText(text, sheet.href);
	                    }).catch(function (e) {
	                        if (false) {
	                            _this2.logger.log('Unable to load stylesheet', e);
	                        }
	                        return [];
	                    });
	                }
	                return getSheetFonts(sheet, document);
	            })).then(function (fonts) {
	                return fonts.reduce(function (acc, font) {
	                    return acc.concat(font);
	                }, []);
	            }).then(function (fonts) {
	                return Promise.all(fonts.map(function (font) {
	                    return fetch(font.formats[0].src).then(function (response) {
	                        return response.blob();
	                    }).then(function (blob) {
	                        return new Promise(function (resolve, reject) {
	                            var reader = new FileReader();
	                            reader.onerror = reject;
	                            reader.onload = function () {
	                                // $FlowFixMe
	                                var result = reader.result;
	                                resolve(result);
	                            };
	                            reader.readAsDataURL(blob);
	                        });
	                    }).then(function (dataUri) {
	                        font.fontFace.setProperty('src', 'url("' + dataUri + '")');
	                        return '@font-face {' + font.fontFace.cssText + ' ';
	                    });
	                }));
	            }).then(function (fontCss) {
	                var style = document.createElement('style');
	                style.textContent = fontCss.join('\n');
	                _this2.documentElement.appendChild(style);
	            });
	        }
	    }, {
	        key: 'createElementClone',
	        value: function createElementClone(node) {
	            var _this3 = this;
	
	            if (this.copyStyles && node instanceof HTMLCanvasElement) {
	                var img = node.ownerDocument.createElement('img');
	                try {
	                    img.src = node.toDataURL();
	                    return img;
	                } catch (e) {
	                    if (false) {
	                        this.logger.log('Unable to clone canvas contents, canvas is tainted');
	                    }
	                }
	            }
	
	            if (node instanceof HTMLIFrameElement) {
	                var tempIframe = node.cloneNode(false);
	                var iframeKey = generateIframeKey();
	                tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);
	
	                var _parseBounds = (0, _Bounds.parseBounds)(node, 0, 0),
	                    width = _parseBounds.width,
	                    height = _parseBounds.height;
	
	                this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(node, this.options).then(function (documentElement) {
	                    return _this3.renderer(documentElement, {
	                        async: _this3.options.async,
	                        allowTaint: _this3.options.allowTaint,
	                        backgroundColor: '#ffffff',
	                        canvas: null,
	                        imageTimeout: _this3.options.imageTimeout,
	                        logging: _this3.options.logging,
	                        proxy: _this3.options.proxy,
	                        removeContainer: _this3.options.removeContainer,
	                        scale: _this3.options.scale,
	                        foreignObjectRendering: _this3.options.foreignObjectRendering,
	                        useCORS: _this3.options.useCORS,
	                        target: new _CanvasRenderer2.default(),
	                        width: width,
	                        height: height,
	                        x: 0,
	                        y: 0,
	                        windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
	                        windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
	                        scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
	                        scrollY: documentElement.ownerDocument.defaultView.pageYOffset
	                    }, _this3.logger.child(iframeKey));
	                }).then(function (canvas) {
	                    return new Promise(function (resolve, reject) {
	                        var iframeCanvas = document.createElement('img');
	                        iframeCanvas.onload = function () {
	                            return resolve(canvas);
	                        };
	                        iframeCanvas.onerror = reject;
	                        iframeCanvas.src = canvas.toDataURL();
	                        if (tempIframe.parentNode) {
	                            tempIframe.parentNode.replaceChild((0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node), iframeCanvas), tempIframe);
	                        }
	                    });
	                });
	                return tempIframe;
	            }
	
	            if (node instanceof HTMLStyleElement && node.sheet && node.sheet.cssRules) {
	                var css = [].slice.call(node.sheet.cssRules, 0).reduce(function (css, rule) {
	                    try {
	                        if (rule && rule.cssText) {
	                            return css + rule.cssText;
	                        }
	                        return css;
	                    } catch (err) {
	                        _this3.logger.log('Unable to access cssText property', rule.name);
	                        return css;
	                    }
	                }, '');
	                var style = node.cloneNode(false);
	                style.textContent = css;
	                return style;
	            }
	
	            return node.cloneNode(false);
	        }
	    }, {
	        key: 'cloneNode',
	        value: function cloneNode(node) {
	            var clone = node.nodeType === Node.TEXT_NODE ? document.createTextNode(node.nodeValue) : this.createElementClone(node);
	
	            var window = node.ownerDocument.defaultView;
	            var style = node instanceof window.HTMLElement ? window.getComputedStyle(node) : null;
	            var styleBefore = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':before') : null;
	            var styleAfter = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':after') : null;
	
	            if (this.referenceElement === node && clone instanceof window.HTMLElement) {
	                this.clonedReferenceElement = clone;
	            }
	
	            if (clone instanceof window.HTMLBodyElement) {
	                createPseudoHideStyles(clone);
	            }
	
	            var counters = (0, _PseudoNodeContent.parseCounterReset)(style, this.pseudoContentData);
	            var contentBefore = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleBefore, this.pseudoContentData);
	
	            for (var child = node.firstChild; child; child = child.nextSibling) {
	                if (child.nodeType !== Node.ELEMENT_NODE || child.nodeName !== 'SCRIPT' &&
	                // $FlowFixMe
	                !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' ||
	                // $FlowFixMe
	                !this.options.ignoreElements(child))) {
	                    if (!this.copyStyles || child.nodeName !== 'STYLE') {
	                        clone.appendChild(this.cloneNode(child));
	                    }
	                }
	            }
	
	            var contentAfter = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleAfter, this.pseudoContentData);
	            (0, _PseudoNodeContent.popCounters)(counters, this.pseudoContentData);
	
	            if (node instanceof window.HTMLElement && clone instanceof window.HTMLElement) {
	                if (styleBefore) {
	                    this.inlineAllImages(inlinePseudoElement(node, clone, styleBefore, contentBefore, PSEUDO_BEFORE));
	                }
	                if (styleAfter) {
	                    this.inlineAllImages(inlinePseudoElement(node, clone, styleAfter, contentAfter, PSEUDO_AFTER));
	                }
	                if (style && this.copyStyles && !(node instanceof HTMLIFrameElement)) {
	                    (0, _Util.copyCSSStyles)(style, clone);
	                }
	                this.inlineAllImages(clone);
	                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
	                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
	                }
	                switch (node.nodeName) {
	                    case 'CANVAS':
	                        if (!this.copyStyles) {
	                            cloneCanvasContents(node, clone);
	                        }
	                        break;
	                    case 'TEXTAREA':
	                    case 'SELECT':
	                        clone.value = node.value;
	                        break;
	                }
	            }
	            return clone;
	        }
	    }]);
	
	    return DocumentCloner;
	}();
	
	var getSheetFonts = function getSheetFonts(sheet, document) {
	    // $FlowFixMe
	    return (sheet.cssRules ? Array.from(sheet.cssRules) : []).filter(function (rule) {
	        return rule.type === CSSRule.FONT_FACE_RULE;
	    }).map(function (rule) {
	        var src = (0, _background.parseBackgroundImage)(rule.style.getPropertyValue('src'));
	        var formats = [];
	        for (var i = 0; i < src.length; i++) {
	            if (src[i].method === 'url' && src[i + 1] && src[i + 1].method === 'format') {
	                var a = document.createElement('a');
	                a.href = src[i].args[0];
	                if (document.body) {
	                    document.body.appendChild(a);
	                }
	
	                var font = {
	                    src: a.href,
	                    format: src[i + 1].args[0]
	                };
	                formats.push(font);
	            }
	        }
	
	        return {
	            // TODO select correct format for browser),
	
	            formats: formats.filter(function (font) {
	                return (/^woff/i.test(font.format)
	                );
	            }),
	            fontFace: rule.style
	        };
	    }).filter(function (font) {
	        return font.formats.length;
	    });
	};
	
	var createStyleSheetFontsFromText = function createStyleSheetFontsFromText(text, baseHref) {
	    var doc = document.implementation.createHTMLDocument('');
	    var base = document.createElement('base');
	    // $FlowFixMe
	    base.href = baseHref;
	    var style = document.createElement('style');
	
	    style.textContent = text;
	    if (doc.head) {
	        doc.head.appendChild(base);
	    }
	    if (doc.body) {
	        doc.body.appendChild(style);
	    }
	
	    return style.sheet ? getSheetFonts(style.sheet, doc) : [];
	};
	
	var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
	    if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
	        ownerDocument.defaultView.scrollTo(x, y);
	    }
	};
	
	var cloneCanvasContents = function cloneCanvasContents(canvas, clonedCanvas) {
	    try {
	        if (clonedCanvas) {
	            clonedCanvas.width = canvas.width;
	            clonedCanvas.height = canvas.height;
	            var ctx = canvas.getContext('2d');
	            var clonedCtx = clonedCanvas.getContext('2d');
	            if (ctx) {
	                clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
	            } else {
	                clonedCtx.drawImage(canvas, 0, 0);
	            }
	        }
	    } catch (e) {}
	};
	
	var inlinePseudoElement = function inlinePseudoElement(node, clone, style, contentItems, pseudoElt) {
	    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
	        return;
	    }
	
	    var anonymousReplacedElement = clone.ownerDocument.createElement('html2canvaspseudoelement');
	    (0, _Util.copyCSSStyles)(style, anonymousReplacedElement);
	
	    if (contentItems) {
	        var len = contentItems.length;
	        for (var i = 0; i < len; i++) {
	            var item = contentItems[i];
	            switch (item.type) {
	                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.IMAGE:
	                    var img = clone.ownerDocument.createElement('img');
	                    img.src = (0, _background.parseBackgroundImage)('url(' + item.value + ')')[0].args[0];
	                    img.style.opacity = '1';
	                    anonymousReplacedElement.appendChild(img);
	                    break;
	                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.TEXT:
	                    anonymousReplacedElement.appendChild(clone.ownerDocument.createTextNode(item.value));
	                    break;
	            }
	        }
	    }
	
	    anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	    clone.className += pseudoElt === PSEUDO_BEFORE ? ' ' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	    if (pseudoElt === PSEUDO_BEFORE) {
	        clone.insertBefore(anonymousReplacedElement, clone.firstChild);
	    } else {
	        clone.appendChild(anonymousReplacedElement);
	    }
	
	    return anonymousReplacedElement;
	};
	
	var URL_REGEXP = /^url\((.+)\)$/i;
	var PSEUDO_BEFORE = ':before';
	var PSEUDO_AFTER = ':after';
	var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
	var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
	
	var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
	
	var createPseudoHideStyles = function createPseudoHideStyles(body) {
	    createStyles(body, '.' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + '\n         .' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
	};
	
	var createStyles = function createStyles(body, styles) {
	    var style = body.ownerDocument.createElement('style');
	    style.innerHTML = styles;
	    body.appendChild(style);
	};
	
	var initNode = function initNode(_ref) {
	    var _ref2 = _slicedToArray(_ref, 3),
	        element = _ref2[0],
	        x = _ref2[1],
	        y = _ref2[2];
	
	    element.scrollLeft = x;
	    element.scrollTop = y;
	};
	
	var generateIframeKey = function generateIframeKey() {
	    return Math.ceil(Date.now() + Math.random() * 10000000).toString(16);
	};
	
	var DATA_URI_REGEXP = /^data:text\/(.+);(base64)?,(.*)$/i;
	
	var getIframeDocumentElement = function getIframeDocumentElement(node, options) {
	    try {
	        return Promise.resolve(node.contentWindow.document.documentElement);
	    } catch (e) {
	        return options.proxy ? (0, _Proxy.Proxy)(node.src, options).then(function (html) {
	            var match = html.match(DATA_URI_REGEXP);
	            if (!match) {
	                return Promise.reject();
	            }
	
	            return match[2] === 'base64' ? window.atob(decodeURIComponent(match[3])) : decodeURIComponent(match[3]);
	        }).then(function (html) {
	            return createIframeContainer(node.ownerDocument, (0, _Bounds.parseBounds)(node, 0, 0)).then(function (cloneIframeContainer) {
	                var cloneWindow = cloneIframeContainer.contentWindow;
	                var documentClone = cloneWindow.document;
	
	                documentClone.open();
	                documentClone.write(html);
	                var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
	                    return documentClone.documentElement;
	                });
	
	                documentClone.close();
	                return iframeLoad;
	            });
	        }) : Promise.reject();
	    }
	};
	
	var createIframeContainer = function createIframeContainer(ownerDocument, bounds) {
	    var cloneIframeContainer = ownerDocument.createElement('iframe');
	
	    cloneIframeContainer.className = 'html2canvas-container';
	    cloneIframeContainer.style.visibility = 'hidden';
	    cloneIframeContainer.style.position = 'fixed';
	    cloneIframeContainer.style.left = '-10000px';
	    cloneIframeContainer.style.top = '0px';
	    cloneIframeContainer.style.border = '0';
	    cloneIframeContainer.width = bounds.width.toString();
	    cloneIframeContainer.height = bounds.height.toString();
	    cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
	    cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
	    if (!ownerDocument.body) {
	        return Promise.reject( false ? 'Body element not found in Document that is getting rendered' : '');
	    }
	
	    ownerDocument.body.appendChild(cloneIframeContainer);
	
	    return Promise.resolve(cloneIframeContainer);
	};
	
	var iframeLoader = function iframeLoader(cloneIframeContainer) {
	    var cloneWindow = cloneIframeContainer.contentWindow;
	    var documentClone = cloneWindow.document;
	
	    return new Promise(function (resolve, reject) {
	        cloneWindow.onload = cloneIframeContainer.onload = documentClone.onreadystatechange = function () {
	            var interval = setInterval(function () {
	                if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
	                    clearInterval(interval);
	                    resolve(cloneIframeContainer);
	                }
	            }, 50);
	        };
	    });
	};
	
	var cloneWindow = exports.cloneWindow = function cloneWindow(ownerDocument, bounds, referenceElement, options, logger, renderer) {
	    var cloner = new DocumentCloner(referenceElement, options, logger, false, renderer);
	    var scrollX = ownerDocument.defaultView.pageXOffset;
	    var scrollY = ownerDocument.defaultView.pageYOffset;
	
	    return createIframeContainer(ownerDocument, bounds).then(function (cloneIframeContainer) {
	        var cloneWindow = cloneIframeContainer.contentWindow;
	        var documentClone = cloneWindow.document;
	
	        /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
	             if window url is about:blank, we can assign the url to current by writing onto the document
	             */
	
	        var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
	            cloner.scrolledElements.forEach(initNode);
	            cloneWindow.scrollTo(bounds.left, bounds.top);
	            if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== bounds.top || cloneWindow.scrollX !== bounds.left)) {
	                documentClone.documentElement.style.top = -bounds.top + 'px';
	                documentClone.documentElement.style.left = -bounds.left + 'px';
	                documentClone.documentElement.style.position = 'absolute';
	            }
	
	            var result = Promise.resolve([cloneIframeContainer, cloner.clonedReferenceElement, cloner.resourceLoader]);
	
	            var onclone = options.onclone;
	
	            return cloner.clonedReferenceElement instanceof cloneWindow.HTMLElement || cloner.clonedReferenceElement instanceof ownerDocument.defaultView.HTMLElement || cloner.clonedReferenceElement instanceof HTMLElement ? typeof onclone === 'function' ? Promise.resolve().then(function () {
	                return onclone(documentClone);
	            }).then(function () {
	                return result;
	            }) : result : Promise.reject( false ? 'Error finding the ' + referenceElement.nodeName + ' in the cloned document' : '');
	        });
	
	        documentClone.open();
	        documentClone.write(serializeDoctype(document.doctype) + '<html></html>');
	        // Chrome scrolls the parent document for some reason after the write to the cloned window???
	        restoreOwnerScroll(referenceElement.ownerDocument, scrollX, scrollY);
	        documentClone.replaceChild(documentClone.adoptNode(cloner.documentElement), documentClone.documentElement);
	        documentClone.close();
	
	        return iframeLoad;
	    });
	};
	
	var serializeDoctype = function serializeDoctype(doctype) {
	    var str = '';
	    if (doctype) {
	        str += '<!DOCTYPE ';
	        if (doctype.name) {
	            str += doctype.name;
	        }
	
	        if (doctype.internalSubset) {
	            str += doctype.internalSubset;
	        }
	
	        if (doctype.publicId) {
	            str += '"' + doctype.publicId + '"';
	        }
	
	        if (doctype.systemId) {
	            str += '"' + doctype.systemId + '"';
	        }
	
	        str += '>';
	    }
	
	    return str;
	};

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.transformWebkitRadialGradientArgs = exports.parseGradient = exports.RadialGradient = exports.LinearGradient = exports.RADIAL_GRADIENT_SHAPE = exports.GRADIENT_TYPE = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _NodeContainer = __webpack_require__(177);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _Angle = __webpack_require__(1471);
	
	var _Color = __webpack_require__(125);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Length = __webpack_require__(143);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	var _Util = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SIDE_OR_CORNER = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i;
	var PERCENTAGE_ANGLES = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i;
	var ENDS_WITH_LENGTH = /(px)|%|( 0)$/i;
	var FROM_TO_COLORSTOP = /^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i;
	var RADIAL_SHAPE_DEFINITION = /^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i;
	
	var GRADIENT_TYPE = exports.GRADIENT_TYPE = {
	    LINEAR_GRADIENT: 0,
	    RADIAL_GRADIENT: 1
	};
	
	var RADIAL_GRADIENT_SHAPE = exports.RADIAL_GRADIENT_SHAPE = {
	    CIRCLE: 0,
	    ELLIPSE: 1
	};
	
	var LENGTH_FOR_POSITION = {
	    left: new _Length2.default('0%'),
	    top: new _Length2.default('0%'),
	    center: new _Length2.default('50%'),
	    right: new _Length2.default('100%'),
	    bottom: new _Length2.default('100%')
	};
	
	var LinearGradient = exports.LinearGradient = function LinearGradient(colorStops, direction) {
	    _classCallCheck(this, LinearGradient);
	
	    this.type = GRADIENT_TYPE.LINEAR_GRADIENT;
	    this.colorStops = colorStops;
	    this.direction = direction;
	};
	
	var RadialGradient = exports.RadialGradient = function RadialGradient(colorStops, shape, center, radius) {
	    _classCallCheck(this, RadialGradient);
	
	    this.type = GRADIENT_TYPE.RADIAL_GRADIENT;
	    this.colorStops = colorStops;
	    this.shape = shape;
	    this.center = center;
	    this.radius = radius;
	};
	
	var parseGradient = exports.parseGradient = function parseGradient(container, _ref, bounds) {
	    var args = _ref.args,
	        method = _ref.method,
	        prefix = _ref.prefix;
	
	    if (method === 'linear-gradient') {
	        return parseLinearGradient(args, bounds, !!prefix);
	    } else if (method === 'gradient' && args[0] === 'linear') {
	        // TODO handle correct angle
	        return parseLinearGradient(['to bottom'].concat(transformObsoleteColorStops(args.slice(3))), bounds, !!prefix);
	    } else if (method === 'radial-gradient') {
	        return parseRadialGradient(container, prefix === '-webkit-' ? transformWebkitRadialGradientArgs(args) : args, bounds);
	    } else if (method === 'gradient' && args[0] === 'radial') {
	        return parseRadialGradient(container, transformObsoleteColorStops(transformWebkitRadialGradientArgs(args.slice(1))), bounds);
	    }
	};
	
	var parseColorStops = function parseColorStops(args, firstColorStopIndex, lineLength) {
	    var colorStops = [];
	
	    for (var i = firstColorStopIndex; i < args.length; i++) {
	        var value = args[i];
	        var HAS_LENGTH = ENDS_WITH_LENGTH.test(value);
	        var lastSpaceIndex = value.lastIndexOf(' ');
	        var _color = new _Color2.default(HAS_LENGTH ? value.substring(0, lastSpaceIndex) : value);
	        var _stop = HAS_LENGTH ? new _Length2.default(value.substring(lastSpaceIndex + 1)) : i === firstColorStopIndex ? new _Length2.default('0%') : i === args.length - 1 ? new _Length2.default('100%') : null;
	        colorStops.push({ color: _color, stop: _stop });
	    }
	
	    var absoluteValuedColorStops = colorStops.map(function (_ref2) {
	        var color = _ref2.color,
	            stop = _ref2.stop;
	
	        var absoluteStop = lineLength === 0 ? 0 : stop ? stop.getAbsoluteValue(lineLength) / lineLength : null;
	
	        return {
	            color: color,
	            // $FlowFixMe
	            stop: absoluteStop
	        };
	    });
	
	    var previousColorStop = absoluteValuedColorStops[0].stop;
	    for (var _i = 0; _i < absoluteValuedColorStops.length; _i++) {
	        if (previousColorStop !== null) {
	            var _stop2 = absoluteValuedColorStops[_i].stop;
	            if (_stop2 === null) {
	                var n = _i;
	                while (absoluteValuedColorStops[n].stop === null) {
	                    n++;
	                }
	                var steps = n - _i + 1;
	                var nextColorStep = absoluteValuedColorStops[n].stop;
	                var stepSize = (nextColorStep - previousColorStop) / steps;
	                for (; _i < n; _i++) {
	                    previousColorStop = absoluteValuedColorStops[_i].stop = previousColorStop + stepSize;
	                }
	            } else {
	                previousColorStop = _stop2;
	            }
	        }
	    }
	
	    return absoluteValuedColorStops;
	};
	
	var parseLinearGradient = function parseLinearGradient(args, bounds, hasPrefix) {
	    var angle = (0, _Angle.parseAngle)(args[0]);
	    var HAS_SIDE_OR_CORNER = SIDE_OR_CORNER.test(args[0]);
	    var HAS_DIRECTION = HAS_SIDE_OR_CORNER || angle !== null || PERCENTAGE_ANGLES.test(args[0]);
	    var direction = HAS_DIRECTION ? angle !== null ? calculateGradientDirection(
	    // if there is a prefix, the 0° angle points due East (instead of North per W3C)
	    hasPrefix ? angle - Math.PI * 0.5 : angle, bounds) : HAS_SIDE_OR_CORNER ? parseSideOrCorner(args[0], bounds) : parsePercentageAngle(args[0], bounds) : calculateGradientDirection(Math.PI, bounds);
	    var firstColorStopIndex = HAS_DIRECTION ? 1 : 0;
	
	    // TODO: Fix some inaccuracy with color stops with px values
	    var lineLength = Math.min((0, _Util.distance)(Math.abs(direction.x0) + Math.abs(direction.x1), Math.abs(direction.y0) + Math.abs(direction.y1)), bounds.width * 2, bounds.height * 2);
	
	    return new LinearGradient(parseColorStops(args, firstColorStopIndex, lineLength), direction);
	};
	
	var parseRadialGradient = function parseRadialGradient(container, args, bounds) {
	    var m = args[0].match(RADIAL_SHAPE_DEFINITION);
	    var shape = m && (m[1] === 'circle' || // explicit shape specification
	    m[3] !== undefined && m[5] === undefined) // only one radius coordinate
	    ? RADIAL_GRADIENT_SHAPE.CIRCLE : RADIAL_GRADIENT_SHAPE.ELLIPSE;
	    var radius = {};
	    var center = {};
	
	    if (m) {
	        // Radius
	        if (m[3] !== undefined) {
	            radius.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[3], m[4]).getAbsoluteValue(bounds.width);
	        }
	
	        if (m[5] !== undefined) {
	            radius.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[5], m[6]).getAbsoluteValue(bounds.height);
	        }
	
	        // Position
	        if (m[7]) {
	            center.x = LENGTH_FOR_POSITION[m[7].toLowerCase()];
	        } else if (m[8] !== undefined) {
	            center.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[8], m[9]);
	        }
	
	        if (m[10]) {
	            center.y = LENGTH_FOR_POSITION[m[10].toLowerCase()];
	        } else if (m[11] !== undefined) {
	            center.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[11], m[12]);
	        }
	    }
	
	    var gradientCenter = {
	        x: center.x === undefined ? bounds.width / 2 : center.x.getAbsoluteValue(bounds.width),
	        y: center.y === undefined ? bounds.height / 2 : center.y.getAbsoluteValue(bounds.height)
	    };
	    var gradientRadius = calculateRadius(m && m[2] || 'farthest-corner', shape, gradientCenter, radius, bounds);
	
	    return new RadialGradient(parseColorStops(args, m ? 1 : 0, Math.min(gradientRadius.x, gradientRadius.y)), shape, gradientCenter, gradientRadius);
	};
	
	var calculateGradientDirection = function calculateGradientDirection(radian, bounds) {
	    var width = bounds.width;
	    var height = bounds.height;
	    var HALF_WIDTH = width * 0.5;
	    var HALF_HEIGHT = height * 0.5;
	    var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
	    var HALF_LINE_LENGTH = lineLength / 2;
	
	    var x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH;
	    var y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH;
	    var x1 = width - x0;
	    var y1 = height - y0;
	
	    return { x0: x0, x1: x1, y0: y0, y1: y1 };
	};
	
	var parseTopRight = function parseTopRight(bounds) {
	    return Math.acos(bounds.width / 2 / ((0, _Util.distance)(bounds.width, bounds.height) / 2));
	};
	
	var parseSideOrCorner = function parseSideOrCorner(side, bounds) {
	    switch (side) {
	        case 'bottom':
	        case 'to top':
	            return calculateGradientDirection(0, bounds);
	        case 'left':
	        case 'to right':
	            return calculateGradientDirection(Math.PI / 2, bounds);
	        case 'right':
	        case 'to left':
	            return calculateGradientDirection(3 * Math.PI / 2, bounds);
	        case 'top right':
	        case 'right top':
	        case 'to bottom left':
	        case 'to left bottom':
	            return calculateGradientDirection(Math.PI + parseTopRight(bounds), bounds);
	        case 'top left':
	        case 'left top':
	        case 'to bottom right':
	        case 'to right bottom':
	            return calculateGradientDirection(Math.PI - parseTopRight(bounds), bounds);
	        case 'bottom left':
	        case 'left bottom':
	        case 'to top right':
	        case 'to right top':
	            return calculateGradientDirection(parseTopRight(bounds), bounds);
	        case 'bottom right':
	        case 'right bottom':
	        case 'to top left':
	        case 'to left top':
	            return calculateGradientDirection(2 * Math.PI - parseTopRight(bounds), bounds);
	        case 'top':
	        case 'to bottom':
	        default:
	            return calculateGradientDirection(Math.PI, bounds);
	    }
	};
	
	var parsePercentageAngle = function parsePercentageAngle(angle, bounds) {
	    var _angle$split$map = angle.split(' ').map(parseFloat),
	        _angle$split$map2 = _slicedToArray(_angle$split$map, 2),
	        left = _angle$split$map2[0],
	        top = _angle$split$map2[1];
	
	    var ratio = left / 100 * bounds.width / (top / 100 * bounds.height);
	
	    return calculateGradientDirection(Math.atan(isNaN(ratio) ? 1 : ratio) + Math.PI / 2, bounds);
	};
	
	var findCorner = function findCorner(bounds, x, y, closest) {
	    var corners = [{ x: 0, y: 0 }, { x: 0, y: bounds.height }, { x: bounds.width, y: 0 }, { x: bounds.width, y: bounds.height }];
	
	    // $FlowFixMe
	    return corners.reduce(function (stat, corner) {
	        var d = (0, _Util.distance)(x - corner.x, y - corner.y);
	        if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
	            return {
	                optimumCorner: corner,
	                optimumDistance: d
	            };
	        }
	
	        return stat;
	    }, {
	        optimumDistance: closest ? Infinity : -Infinity,
	        optimumCorner: null
	    }).optimumCorner;
	};
	
	var calculateRadius = function calculateRadius(extent, shape, center, radius, bounds) {
	    var x = center.x;
	    var y = center.y;
	    var rx = 0;
	    var ry = 0;
	
	    switch (extent) {
	        case 'closest-side':
	            // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
	            // If the shape is an ellipse, it exactly meets the closest side in each dimension.
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.min(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                rx = Math.min(Math.abs(x), Math.abs(x - bounds.width));
	                ry = Math.min(Math.abs(y), Math.abs(y - bounds.height));
	            }
	            break;
	
	        case 'closest-corner':
	            // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
	            // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.min((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                // Compute the ratio ry/rx (which is to be the same as for "closest-side")
	                var c = Math.min(Math.abs(y), Math.abs(y - bounds.height)) / Math.min(Math.abs(x), Math.abs(x - bounds.width));
	                var corner = findCorner(bounds, x, y, true);
	                rx = (0, _Util.distance)(corner.x - x, (corner.y - y) / c);
	                ry = c * rx;
	            }
	            break;
	
	        case 'farthest-side':
	            // Same as closest-side, except the ending shape is sized based on the farthest side(s)
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.max(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                rx = Math.max(Math.abs(x), Math.abs(x - bounds.width));
	                ry = Math.max(Math.abs(y), Math.abs(y - bounds.height));
	            }
	            break;
	
	        case 'farthest-corner':
	            // Same as closest-corner, except the ending shape is sized based on the farthest corner.
	            // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.max((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
	                var _c = Math.max(Math.abs(y), Math.abs(y - bounds.height)) / Math.max(Math.abs(x), Math.abs(x - bounds.width));
	                var _corner = findCorner(bounds, x, y, false);
	                rx = (0, _Util.distance)(_corner.x - x, (_corner.y - y) / _c);
	                ry = _c * rx;
	            }
	            break;
	
	        default:
	            // pixel or percentage values
	            rx = radius.x || 0;
	            ry = radius.y !== undefined ? radius.y : rx;
	            break;
	    }
	
	    return {
	        x: rx,
	        y: ry
	    };
	};
	
	var transformWebkitRadialGradientArgs = exports.transformWebkitRadialGradientArgs = function transformWebkitRadialGradientArgs(args) {
	    var shape = '';
	    var radius = '';
	    var extent = '';
	    var position = '';
	    var idx = 0;
	
	    var POSITION = /^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i;
	    var SHAPE_AND_EXTENT = /^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i;
	    var RADIUS = /^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i;
	
	    var matchStartPosition = args[idx].match(POSITION);
	    if (matchStartPosition) {
	        idx++;
	    }
	
	    var matchShapeExtent = args[idx].match(SHAPE_AND_EXTENT);
	    if (matchShapeExtent) {
	        shape = matchShapeExtent[1] || '';
	        extent = matchShapeExtent[2] || '';
	        if (extent === 'contain') {
	            extent = 'closest-side';
	        } else if (extent === 'cover') {
	            extent = 'farthest-corner';
	        }
	        idx++;
	    }
	
	    var matchStartRadius = args[idx].match(RADIUS);
	    if (matchStartRadius) {
	        idx++;
	    }
	
	    var matchEndPosition = args[idx].match(POSITION);
	    if (matchEndPosition) {
	        idx++;
	    }
	
	    var matchEndRadius = args[idx].match(RADIUS);
	    if (matchEndRadius) {
	        idx++;
	    }
	
	    var matchPosition = matchEndPosition || matchStartPosition;
	    if (matchPosition && matchPosition[1]) {
	        position = matchPosition[1] + (/^\d+$/.test(matchPosition[1]) ? 'px' : '');
	        if (matchPosition[2]) {
	            position += ' ' + matchPosition[2] + (/^\d+$/.test(matchPosition[2]) ? 'px' : '');
	        }
	    }
	
	    var matchRadius = matchEndRadius || matchStartRadius;
	    if (matchRadius) {
	        radius = matchRadius[0];
	        if (!matchRadius[1]) {
	            radius += 'px';
	        }
	    }
	
	    if (position && !shape && !radius && !extent) {
	        radius = position;
	        position = '';
	    }
	
	    if (position) {
	        position = 'at ' + position;
	    }
	
	    return [[shape, extent, radius, position].filter(function (s) {
	        return !!s;
	    }).join(' ')].concat(args.slice(idx));
	};
	
	var transformObsoleteColorStops = function transformObsoleteColorStops(args) {
	    return args.map(function (color) {
	        return color.match(FROM_TO_COLORSTOP);
	    })
	    // $FlowFixMe
	    .map(function (v, index) {
	        if (!v) {
	            return args[index];
	        }
	
	        switch (v[1]) {
	            case 'from':
	                return v[4] + ' 0%';
	            case 'to':
	                return v[4] + ' 100%';
	            case 'color-stop':
	                if (v[3] === '%') {
	                    return v[4] + ' ' + v[2];
	                }
	                return v[4] + ' ' + parseFloat(v[2]) * 100 + '%';
	        }
	    });
	};

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NodeParser = undefined;
	
	var _StackingContext = __webpack_require__(1478);
	
	var _StackingContext2 = _interopRequireDefault(_StackingContext);
	
	var _NodeContainer = __webpack_require__(177);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _TextContainer = __webpack_require__(274);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _Input = __webpack_require__(606);
	
	var _ListItem = __webpack_require__(397);
	
	var _listStyle = __webpack_require__(277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodeParser = exports.NodeParser = function NodeParser(node, resourceLoader, logger) {
	    if (false) {
	        logger.log('Starting node parsing');
	    }
	
	    var index = 0;
	
	    var container = new _NodeContainer2.default(node, null, resourceLoader, index++);
	    var stack = new _StackingContext2.default(container, null, true);
	
	    parseNodeTree(node, container, stack, resourceLoader, index);
	
	    if (false) {
	        logger.log('Finished parsing node tree');
	    }
	
	    return stack;
	};
	
	var IGNORED_NODE_NAMES = ['SCRIPT', 'HEAD', 'TITLE', 'OBJECT', 'BR', 'OPTION'];
	
	var parseNodeTree = function parseNodeTree(node, parent, stack, resourceLoader, index) {
	    if (false) {
	        throw new Error('Recursion error while parsing node tree');
	    }
	
	    for (var childNode = node.firstChild, nextNode; childNode; childNode = nextNode) {
	        nextNode = childNode.nextSibling;
	        var defaultView = childNode.ownerDocument.defaultView;
	        if (childNode instanceof defaultView.Text || childNode instanceof Text || defaultView.parent && childNode instanceof defaultView.parent.Text) {
	            if (childNode.data.trim().length > 0) {
	                parent.childNodes.push(_TextContainer2.default.fromTextNode(childNode, parent));
	            }
	        } else if (childNode instanceof defaultView.HTMLElement || childNode instanceof HTMLElement || defaultView.parent && childNode instanceof defaultView.parent.HTMLElement) {
	            if (IGNORED_NODE_NAMES.indexOf(childNode.nodeName) === -1) {
	                var container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
	                if (container.isVisible()) {
	                    if (childNode.tagName === 'INPUT') {
	                        // $FlowFixMe
	                        (0, _Input.inlineInputElement)(childNode, container);
	                    } else if (childNode.tagName === 'TEXTAREA') {
	                        // $FlowFixMe
	                        (0, _Input.inlineTextAreaElement)(childNode, container);
	                    } else if (childNode.tagName === 'SELECT') {
	                        // $FlowFixMe
	                        (0, _Input.inlineSelectElement)(childNode, container);
	                    } else if (container.style.listStyle && container.style.listStyle.listStyleType !== _listStyle.LIST_STYLE_TYPE.NONE) {
	                        (0, _ListItem.inlineListItemElement)(childNode, container, resourceLoader);
	                    }
	
	                    var SHOULD_TRAVERSE_CHILDREN = childNode.tagName !== 'TEXTAREA';
	                    var treatAsRealStackingContext = createsRealStackingContext(container, childNode);
	                    if (treatAsRealStackingContext || createsStackingContext(container)) {
	                        // for treatAsRealStackingContext:false, any positioned descendants and descendants
	                        // which actually create a new stacking context should be considered part of the parent stacking context
	                        var parentStack = treatAsRealStackingContext || container.isPositioned() ? stack.getRealParentStackingContext() : stack;
	                        var childStack = new _StackingContext2.default(container, parentStack, treatAsRealStackingContext);
	                        parentStack.contexts.push(childStack);
	                        if (SHOULD_TRAVERSE_CHILDREN) {
	                            parseNodeTree(childNode, container, childStack, resourceLoader, index);
	                        }
	                    } else {
	                        stack.children.push(container);
	                        if (SHOULD_TRAVERSE_CHILDREN) {
	                            parseNodeTree(childNode, container, stack, resourceLoader, index);
	                        }
	                    }
	                }
	            }
	        } else if (childNode instanceof defaultView.SVGSVGElement || childNode instanceof SVGSVGElement || defaultView.parent && childNode instanceof defaultView.parent.SVGSVGElement) {
	            var _container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
	            var _treatAsRealStackingContext = createsRealStackingContext(_container, childNode);
	            if (_treatAsRealStackingContext || createsStackingContext(_container)) {
	                // for treatAsRealStackingContext:false, any positioned descendants and descendants
	                // which actually create a new stacking context should be considered part of the parent stacking context
	                var _parentStack = _treatAsRealStackingContext || _container.isPositioned() ? stack.getRealParentStackingContext() : stack;
	                var _childStack = new _StackingContext2.default(_container, _parentStack, _treatAsRealStackingContext);
	                _parentStack.contexts.push(_childStack);
	            } else {
	                stack.children.push(_container);
	            }
	        }
	    }
	};
	
	var createsRealStackingContext = function createsRealStackingContext(container, node) {
	    return container.isRootElement() || container.isPositionedWithZIndex() || container.style.opacity < 1 || container.isTransformed() || isBodyWithTransparentRoot(container, node);
	};
	
	var createsStackingContext = function createsStackingContext(container) {
	    return container.isPositioned() || container.isFloating();
	};
	
	var isBodyWithTransparentRoot = function isBodyWithTransparentRoot(container, node) {
	    return node.nodeName === 'BODY' && container.parent instanceof _NodeContainer2.default && container.parent.style.background.backgroundColor.isTransparent();
	};

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseContent = exports.resolvePseudoContent = exports.popCounters = exports.parseCounterReset = exports.TOKEN_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _ListItem = __webpack_require__(397);
	
	var _listStyle = __webpack_require__(277);
	
	var PSEUDO_CONTENT_ITEM_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = {
	    TEXT: 0,
	    IMAGE: 1
	};
	
	var TOKEN_TYPE = exports.TOKEN_TYPE = {
	    STRING: 0,
	    ATTRIBUTE: 1,
	    URL: 2,
	    COUNTER: 3,
	    COUNTERS: 4,
	    OPENQUOTE: 5,
	    CLOSEQUOTE: 6
	};
	
	var parseCounterReset = exports.parseCounterReset = function parseCounterReset(style, data) {
	    if (!style || !style.counterReset || style.counterReset === 'none') {
	        return [];
	    }
	
	    var counterNames = [];
	    var counterResets = style.counterReset.split(/\s*,\s*/);
	    var lenCounterResets = counterResets.length;
	
	    for (var i = 0; i < lenCounterResets; i++) {
	        var _counterResets$i$spli = counterResets[i].split(/\s+/),
	            _counterResets$i$spli2 = _slicedToArray(_counterResets$i$spli, 2),
	            counterName = _counterResets$i$spli2[0],
	            initialValue = _counterResets$i$spli2[1];
	
	        counterNames.push(counterName);
	        var counter = data.counters[counterName];
	        if (!counter) {
	            counter = data.counters[counterName] = [];
	        }
	        counter.push(parseInt(initialValue || 0, 10));
	    }
	
	    return counterNames;
	};
	
	var popCounters = exports.popCounters = function popCounters(counterNames, data) {
	    var lenCounters = counterNames.length;
	    for (var i = 0; i < lenCounters; i++) {
	        data.counters[counterNames[i]].pop();
	    }
	};
	
	var resolvePseudoContent = exports.resolvePseudoContent = function resolvePseudoContent(node, style, data) {
	    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
	        return null;
	    }
	
	    var tokens = parseContent(style.content);
	
	    var len = tokens.length;
	    var contentItems = [];
	    var s = '';
	
	    // increment the counter (if there is a "counter-increment" declaration)
	    var counterIncrement = style.counterIncrement;
	    if (counterIncrement && counterIncrement !== 'none') {
	        var _counterIncrement$spl = counterIncrement.split(/\s+/),
	            _counterIncrement$spl2 = _slicedToArray(_counterIncrement$spl, 2),
	            counterName = _counterIncrement$spl2[0],
	            incrementValue = _counterIncrement$spl2[1];
	
	        var counter = data.counters[counterName];
	        if (counter) {
	            counter[counter.length - 1] += incrementValue === undefined ? 1 : parseInt(incrementValue, 10);
	        }
	    }
	
	    // build the content string
	    for (var i = 0; i < len; i++) {
	        var token = tokens[i];
	        switch (token.type) {
	            case TOKEN_TYPE.STRING:
	                s += token.value || '';
	                break;
	
	            case TOKEN_TYPE.ATTRIBUTE:
	                if (node instanceof HTMLElement && token.value) {
	                    s += node.getAttribute(token.value) || '';
	                }
	                break;
	
	            case TOKEN_TYPE.COUNTER:
	                var _counter = data.counters[token.name || ''];
	                if (_counter) {
	                    s += formatCounterValue([_counter[_counter.length - 1]], '', token.format);
	                }
	                break;
	
	            case TOKEN_TYPE.COUNTERS:
	                var _counters = data.counters[token.name || ''];
	                if (_counters) {
	                    s += formatCounterValue(_counters, token.glue, token.format);
	                }
	                break;
	
	            case TOKEN_TYPE.OPENQUOTE:
	                s += getQuote(style, true, data.quoteDepth);
	                data.quoteDepth++;
	                break;
	
	            case TOKEN_TYPE.CLOSEQUOTE:
	                data.quoteDepth--;
	                s += getQuote(style, false, data.quoteDepth);
	                break;
	
	            case TOKEN_TYPE.URL:
	                if (s) {
	                    contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
	                    s = '';
	                }
	                contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.IMAGE, value: token.value || '' });
	                break;
	        }
	    }
	
	    if (s) {
	        contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
	    }
	
	    return contentItems;
	};
	
	var parseContent = exports.parseContent = function parseContent(content, cache) {
	    if (cache && cache[content]) {
	        return cache[content];
	    }
	
	    var tokens = [];
	    var len = content.length;
	
	    var isString = false;
	    var isEscaped = false;
	    var isFunction = false;
	    var str = '';
	    var functionName = '';
	    var args = [];
	
	    for (var i = 0; i < len; i++) {
	        var c = content.charAt(i);
	
	        switch (c) {
	            case "'":
	            case '"':
	                if (isEscaped) {
	                    str += c;
	                } else {
	                    isString = !isString;
	                    if (!isFunction && !isString) {
	                        tokens.push({ type: TOKEN_TYPE.STRING, value: str });
	                        str = '';
	                    }
	                }
	                break;
	
	            case '\\':
	                if (isEscaped) {
	                    str += c;
	                    isEscaped = false;
	                } else {
	                    isEscaped = true;
	                }
	                break;
	
	            case '(':
	                if (isString) {
	                    str += c;
	                } else {
	                    isFunction = true;
	                    functionName = str;
	                    str = '';
	                    args = [];
	                }
	                break;
	
	            case ')':
	                if (isString) {
	                    str += c;
	                } else if (isFunction) {
	                    if (str) {
	                        args.push(str);
	                    }
	
	                    switch (functionName) {
	                        case 'attr':
	                            if (args.length > 0) {
	                                tokens.push({ type: TOKEN_TYPE.ATTRIBUTE, value: args[0] });
	                            }
	                            break;
	
	                        case 'counter':
	                            if (args.length > 0) {
	                                var counter = {
	                                    type: TOKEN_TYPE.COUNTER,
	                                    name: args[0]
	                                };
	                                if (args.length > 1) {
	                                    counter.format = args[1];
	                                }
	                                tokens.push(counter);
	                            }
	                            break;
	
	                        case 'counters':
	                            if (args.length > 0) {
	                                var _counters2 = {
	                                    type: TOKEN_TYPE.COUNTERS,
	                                    name: args[0]
	                                };
	                                if (args.length > 1) {
	                                    _counters2.glue = args[1];
	                                }
	                                if (args.length > 2) {
	                                    _counters2.format = args[2];
	                                }
	                                tokens.push(_counters2);
	                            }
	                            break;
	
	                        case 'url':
	                            if (args.length > 0) {
	                                tokens.push({ type: TOKEN_TYPE.URL, value: args[0] });
	                            }
	                            break;
	                    }
	
	                    isFunction = false;
	                    str = '';
	                }
	                break;
	
	            case ',':
	                if (isString) {
	                    str += c;
	                } else if (isFunction) {
	                    args.push(str);
	                    str = '';
	                }
	                break;
	
	            case ' ':
	            case '\t':
	                if (isString) {
	                    str += c;
	                } else if (str) {
	                    addOtherToken(tokens, str);
	                    str = '';
	                }
	                break;
	
	            default:
	                str += c;
	        }
	
	        if (c !== '\\') {
	            isEscaped = false;
	        }
	    }
	
	    if (str) {
	        addOtherToken(tokens, str);
	    }
	
	    if (cache) {
	        cache[content] = tokens;
	    }
	
	    return tokens;
	};
	
	var addOtherToken = function addOtherToken(tokens, identifier) {
	    switch (identifier) {
	        case 'open-quote':
	            tokens.push({ type: TOKEN_TYPE.OPENQUOTE });
	            break;
	        case 'close-quote':
	            tokens.push({ type: TOKEN_TYPE.CLOSEQUOTE });
	            break;
	    }
	};
	
	var getQuote = function getQuote(style, isOpening, quoteDepth) {
	    var quotes = style.quotes ? style.quotes.split(/\s+/) : ["'\"'", "'\"'"];
	    var idx = quoteDepth * 2;
	    if (idx >= quotes.length) {
	        idx = quotes.length - 2;
	    }
	    if (!isOpening) {
	        ++idx;
	    }
	    return quotes[idx].replace(/^["']|["']$/g, '');
	};
	
	var formatCounterValue = function formatCounterValue(counter, glue, format) {
	    var len = counter.length;
	    var result = '';
	
	    for (var i = 0; i < len; i++) {
	        if (i > 0) {
	            result += glue || '';
	        }
	        result += (0, _ListItem.createCounterText)(counter[i], (0, _listStyle.parseListStyleType)(format || 'decimal'), false);
	    }
	
	    return result;
	};

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Bounds = __webpack_require__(142);
	
	var _Font = __webpack_require__(605);
	
	var _Gradient = __webpack_require__(1473);
	
	var _TextContainer = __webpack_require__(274);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _background = __webpack_require__(225);
	
	var _border = __webpack_require__(398);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Renderer = function () {
	    function Renderer(target, options) {
	        _classCallCheck(this, Renderer);
	
	        this.target = target;
	        this.options = options;
	        target.render(options);
	    }
	
	    _createClass(Renderer, [{
	        key: 'renderNode',
	        value: function renderNode(container) {
	            if (container.isVisible()) {
	                this.renderNodeBackgroundAndBorders(container);
	                this.renderNodeContent(container);
	            }
	        }
	    }, {
	        key: 'renderNodeContent',
	        value: function renderNodeContent(container) {
	            var _this = this;
	
	            var callback = function callback() {
	                if (container.childNodes.length) {
	                    container.childNodes.forEach(function (child) {
	                        if (child instanceof _TextContainer2.default) {
	                            var style = child.parent.style;
	                            _this.target.renderTextNode(child.bounds, style.color, style.font, style.textDecoration, style.textShadow);
	                        } else {
	                            _this.target.drawShape(child, container.style.color);
	                        }
	                    });
	                }
	
	                if (container.image) {
	                    var _image = _this.options.imageStore.get(container.image);
	                    if (_image) {
	                        var contentBox = (0, _Bounds.calculateContentBox)(container.bounds, container.style.padding, container.style.border);
	                        var _width = typeof _image.width === 'number' && _image.width > 0 ? _image.width : contentBox.width;
	                        var _height = typeof _image.height === 'number' && _image.height > 0 ? _image.height : contentBox.height;
	                        if (_width > 0 && _height > 0) {
	                            _this.target.clip([(0, _Bounds.calculatePaddingBoxPath)(container.curvedBounds)], function () {
	                                _this.target.drawImage(_image, new _Bounds.Bounds(0, 0, _width, _height), contentBox);
	                            });
	                        }
	                    }
	                }
	            };
	            var paths = container.getClipPaths();
	            if (paths.length) {
	                this.target.clip(paths, callback);
	            } else {
	                callback();
	            }
	        }
	    }, {
	        key: 'renderNodeBackgroundAndBorders',
	        value: function renderNodeBackgroundAndBorders(container) {
	            var _this2 = this;
	
	            var HAS_BACKGROUND = !container.style.background.backgroundColor.isTransparent() || container.style.background.backgroundImage.length;
	
	            var hasRenderableBorders = container.style.border.some(function (border) {
	                return border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent();
	            });
	
	            var callback = function callback() {
	                var backgroundPaintingArea = (0, _background.calculateBackgroungPaintingArea)(container.curvedBounds, container.style.background.backgroundClip);
	
	                if (HAS_BACKGROUND) {
	                    _this2.target.clip([backgroundPaintingArea], function () {
	                        if (!container.style.background.backgroundColor.isTransparent()) {
	                            _this2.target.fill(container.style.background.backgroundColor);
	                        }
	
	                        _this2.renderBackgroundImage(container);
	                    });
	                }
	
	                container.style.border.forEach(function (border, side) {
	                    if (border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent()) {
	                        _this2.renderBorder(border, side, container.curvedBounds);
	                    }
	                });
	            };
	
	            if (HAS_BACKGROUND || hasRenderableBorders) {
	                var paths = container.parent ? container.parent.getClipPaths() : [];
	                if (paths.length) {
	                    this.target.clip(paths, callback);
	                } else {
	                    callback();
	                }
	            }
	        }
	    }, {
	        key: 'renderBackgroundImage',
	        value: function renderBackgroundImage(container) {
	            var _this3 = this;
	
	            container.style.background.backgroundImage.slice(0).reverse().forEach(function (backgroundImage) {
	                if (backgroundImage.source.method === 'url' && backgroundImage.source.args.length) {
	                    _this3.renderBackgroundRepeat(container, backgroundImage);
	                } else if (/gradient/i.test(backgroundImage.source.method)) {
	                    _this3.renderBackgroundGradient(container, backgroundImage);
	                }
	            });
	        }
	    }, {
	        key: 'renderBackgroundRepeat',
	        value: function renderBackgroundRepeat(container, background) {
	            var image = this.options.imageStore.get(background.source.args[0]);
	            if (image) {
	                var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
	                var backgroundImageSize = (0, _background.calculateBackgroundSize)(background, image, backgroundPositioningArea);
	                var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
	                var _path = (0, _background.calculateBackgroundRepeatPath)(background, position, backgroundImageSize, backgroundPositioningArea, container.bounds);
	
	                var _offsetX = Math.round(backgroundPositioningArea.left + position.x);
	                var _offsetY = Math.round(backgroundPositioningArea.top + position.y);
	                this.target.renderRepeat(_path, image, backgroundImageSize, _offsetX, _offsetY);
	            }
	        }
	    }, {
	        key: 'renderBackgroundGradient',
	        value: function renderBackgroundGradient(container, background) {
	            var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
	            var backgroundImageSize = (0, _background.calculateGradientBackgroundSize)(background, backgroundPositioningArea);
	            var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
	            var gradientBounds = new _Bounds.Bounds(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y), backgroundImageSize.width, backgroundImageSize.height);
	
	            var gradient = (0, _Gradient.parseGradient)(container, background.source, gradientBounds);
	            if (gradient) {
	                switch (gradient.type) {
	                    case _Gradient.GRADIENT_TYPE.LINEAR_GRADIENT:
	                        // $FlowFixMe
	                        this.target.renderLinearGradient(gradientBounds, gradient);
	                        break;
	                    case _Gradient.GRADIENT_TYPE.RADIAL_GRADIENT:
	                        // $FlowFixMe
	                        this.target.renderRadialGradient(gradientBounds, gradient);
	                        break;
	                }
	            }
	        }
	    }, {
	        key: 'renderBorder',
	        value: function renderBorder(border, side, curvePoints) {
	            this.target.drawShape((0, _Bounds.parsePathForBorder)(curvePoints, side), border.borderColor);
	        }
	    }, {
	        key: 'renderStack',
	        value: function renderStack(stack) {
	            var _this4 = this;
	
	            if (stack.container.isVisible()) {
	                var _opacity = stack.getOpacity();
	                if (_opacity !== this._opacity) {
	                    this.target.setOpacity(stack.getOpacity());
	                    this._opacity = _opacity;
	                }
	
	                var _transform = stack.container.style.transform;
	                if (_transform !== null) {
	                    this.target.transform(stack.container.bounds.left + _transform.transformOrigin[0].value, stack.container.bounds.top + _transform.transformOrigin[1].value, _transform.transform, function () {
	                        return _this4.renderStackContent(stack);
	                    });
	                } else {
	                    this.renderStackContent(stack);
	                }
	            }
	        }
	    }, {
	        key: 'renderStackContent',
	        value: function renderStackContent(stack) {
	            var _splitStackingContext = splitStackingContexts(stack),
	                _splitStackingContext2 = _slicedToArray(_splitStackingContext, 5),
	                negativeZIndex = _splitStackingContext2[0],
	                zeroOrAutoZIndexOrTransformedOrOpacity = _splitStackingContext2[1],
	                positiveZIndex = _splitStackingContext2[2],
	                nonPositionedFloats = _splitStackingContext2[3],
	                nonPositionedInlineLevel = _splitStackingContext2[4];
	
	            var _splitDescendants = splitDescendants(stack),
	                _splitDescendants2 = _slicedToArray(_splitDescendants, 2),
	                inlineLevel = _splitDescendants2[0],
	                nonInlineLevel = _splitDescendants2[1];
	
	            // https://www.w3.org/TR/css-position-3/#painting-order
	            // 1. the background and borders of the element forming the stacking context.
	
	
	            this.renderNodeBackgroundAndBorders(stack.container);
	            // 2. the child stacking contexts with negative stack levels (most negative first).
	            negativeZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
	            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
	            this.renderNodeContent(stack.container);
	            nonInlineLevel.forEach(this.renderNode, this);
	            // 4. All non-positioned floating descendants, in tree order. For each one of these,
	            // treat the element as if it created a new stacking context, but any positioned descendants and descendants
	            // which actually create a new stacking context should be considered part of the parent stacking context,
	            // not this new one.
	            nonPositionedFloats.forEach(this.renderStack, this);
	            // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
	            nonPositionedInlineLevel.forEach(this.renderStack, this);
	            inlineLevel.forEach(this.renderNode, this);
	            // 6. All positioned, opacity or transform descendants, in tree order that fall into the following categories:
	            //  All positioned descendants with 'z-index: auto' or 'z-index: 0', in tree order.
	            //  For those with 'z-index: auto', treat the element as if it created a new stacking context,
	            //  but any positioned descendants and descendants which actually create a new stacking context should be
	            //  considered part of the parent stacking context, not this new one. For those with 'z-index: 0',
	            //  treat the stacking context generated atomically.
	            //
	            //  All opacity descendants with opacity less than 1
	            //
	            //  All transform descendants with transform other than none
	            zeroOrAutoZIndexOrTransformedOrOpacity.forEach(this.renderStack, this);
	            // 7. Stacking contexts formed by positioned descendants with z-indices greater than or equal to 1 in z-index
	            // order (smallest first) then tree order.
	            positiveZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
	        }
	    }, {
	        key: 'render',
	        value: function render(stack) {
	            var _this5 = this;
	
	            if (this.options.backgroundColor) {
	                this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor);
	            }
	            this.renderStack(stack);
	            var target = this.target.getTarget();
	            if (false) {
	                return target.then(function (output) {
	                    _this5.options.logger.log('Render completed');
	                    return output;
	                });
	            }
	            return target;
	        }
	    }]);
	
	    return Renderer;
	}();
	
	exports.default = Renderer;
	
	
	var splitDescendants = function splitDescendants(stack) {
	    var inlineLevel = [];
	    var nonInlineLevel = [];
	
	    var length = stack.children.length;
	    for (var i = 0; i < length; i++) {
	        var child = stack.children[i];
	        if (child.isInlineLevel()) {
	            inlineLevel.push(child);
	        } else {
	            nonInlineLevel.push(child);
	        }
	    }
	    return [inlineLevel, nonInlineLevel];
	};
	
	var splitStackingContexts = function splitStackingContexts(stack) {
	    var negativeZIndex = [];
	    var zeroOrAutoZIndexOrTransformedOrOpacity = [];
	    var positiveZIndex = [];
	    var nonPositionedFloats = [];
	    var nonPositionedInlineLevel = [];
	    var length = stack.contexts.length;
	    for (var i = 0; i < length; i++) {
	        var child = stack.contexts[i];
	        if (child.container.isPositioned() || child.container.style.opacity < 1 || child.container.isTransformed()) {
	            if (child.container.style.zIndex.order < 0) {
	                negativeZIndex.push(child);
	            } else if (child.container.style.zIndex.order > 0) {
	                positiveZIndex.push(child);
	            } else {
	                zeroOrAutoZIndexOrTransformedOrOpacity.push(child);
	            }
	        } else {
	            if (child.container.isFloating()) {
	                nonPositionedFloats.push(child);
	            } else {
	                nonPositionedInlineLevel.push(child);
	            }
	        }
	    }
	    return [negativeZIndex, zeroOrAutoZIndexOrTransformedOrOpacity, positiveZIndex, nonPositionedFloats, nonPositionedInlineLevel];
	};
	
	var sortByZIndex = function sortByZIndex(a, b) {
	    if (a.container.style.zIndex.order > b.container.style.zIndex.order) {
	        return 1;
	    } else if (a.container.style.zIndex.order < b.container.style.zIndex.order) {
	        return -1;
	    }
	
	    return a.container.index > b.container.index ? 1 : -1;
	};

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResourceStore = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Feature = __webpack_require__(273);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Proxy = __webpack_require__(608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResourceLoader = function () {
	    function ResourceLoader(options, logger, window) {
	        _classCallCheck(this, ResourceLoader);
	
	        this.options = options;
	        this._window = window;
	        this.origin = this.getOrigin(window.location.href);
	        this.cache = {};
	        this.logger = logger;
	        this._index = 0;
	    }
	
	    _createClass(ResourceLoader, [{
	        key: 'loadImage',
	        value: function loadImage(src) {
	            var _this = this;
	
	            if (this.hasResourceInCache(src)) {
	                return src;
	            }
	            if (isBlobImage(src)) {
	                this.cache[src] = _loadImage(src, this.options.imageTimeout || 0);
	                return src;
	            }
	
	            if (!isSVG(src) || _Feature2.default.SUPPORT_SVG_DRAWING) {
	                if (this.options.allowTaint === true || isInlineImage(src) || this.isSameOrigin(src)) {
	                    return this.addImage(src, src, false);
	                } else if (!this.isSameOrigin(src)) {
	                    if (typeof this.options.proxy === 'string') {
	                        this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
	                            return _loadImage(src, _this.options.imageTimeout || 0);
	                        });
	                        return src;
	                    } else if (this.options.useCORS === true && _Feature2.default.SUPPORT_CORS_IMAGES) {
	                        return this.addImage(src, src, true);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'inlineImage',
	        value: function inlineImage(src) {
	            var _this2 = this;
	
	            if (isInlineImage(src)) {
	                return _loadImage(src, this.options.imageTimeout || 0);
	            }
	            if (this.hasResourceInCache(src)) {
	                return this.cache[src];
	            }
	            if (!this.isSameOrigin(src) && typeof this.options.proxy === 'string') {
	                return this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
	                    return _loadImage(src, _this2.options.imageTimeout || 0);
	                });
	            }
	
	            return this.xhrImage(src);
	        }
	    }, {
	        key: 'xhrImage',
	        value: function xhrImage(src) {
	            var _this3 = this;
	
	            this.cache[src] = new Promise(function (resolve, reject) {
	                var xhr = new XMLHttpRequest();
	                xhr.onreadystatechange = function () {
	                    if (xhr.readyState === 4) {
	                        if (xhr.status !== 200) {
	                            reject('Failed to fetch image ' + src.substring(0, 256) + ' with status code ' + xhr.status);
	                        } else {
	                            var reader = new FileReader();
	                            reader.addEventListener('load', function () {
	                                // $FlowFixMe
	                                var result = reader.result;
	                                resolve(result);
	                            }, false);
	                            reader.addEventListener('error', function (e) {
	                                return reject(e);
	                            }, false);
	                            reader.readAsDataURL(xhr.response);
	                        }
	                    }
	                };
	                xhr.responseType = 'blob';
	                if (_this3.options.imageTimeout) {
	                    var timeout = _this3.options.imageTimeout;
	                    xhr.timeout = timeout;
	                    xhr.ontimeout = function () {
	                        return reject( false ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
	                    };
	                }
	                xhr.open('GET', src, true);
	                xhr.send();
	            }).then(function (src) {
	                return _loadImage(src, _this3.options.imageTimeout || 0);
	            });
	
	            return this.cache[src];
	        }
	    }, {
	        key: 'loadCanvas',
	        value: function loadCanvas(node) {
	            var key = String(this._index++);
	            this.cache[key] = Promise.resolve(node);
	            return key;
	        }
	    }, {
	        key: 'hasResourceInCache',
	        value: function hasResourceInCache(key) {
	            return typeof this.cache[key] !== 'undefined';
	        }
	    }, {
	        key: 'addImage',
	        value: function addImage(key, src, useCORS) {
	            var _this4 = this;
	
	            if (false) {
	                this.logger.log('Added image ' + key.substring(0, 256));
	            }
	
	            var imageLoadHandler = function imageLoadHandler(supportsDataImages) {
	                return new Promise(function (resolve, reject) {
	                    var img = new Image();
	                    img.onload = function () {
	                        return resolve(img);
	                    };
	                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
	                    if (!supportsDataImages || useCORS) {
	                        img.crossOrigin = 'anonymous';
	                    }
	
	                    img.onerror = reject;
	                    img.src = src;
	                    if (img.complete === true) {
	                        // Inline XML images may fail to parse, throwing an Error later on
	                        setTimeout(function () {
	                            resolve(img);
	                        }, 500);
	                    }
	                    if (_this4.options.imageTimeout) {
	                        var timeout = _this4.options.imageTimeout;
	                        setTimeout(function () {
	                            return reject( false ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
	                        }, timeout);
	                    }
	                });
	            };
	
	            this.cache[key] = isInlineBase64Image(src) && !isSVG(src) ? // $FlowFixMe
	            _Feature2.default.SUPPORT_BASE64_DRAWING(src).then(imageLoadHandler) : imageLoadHandler(true);
	            return key;
	        }
	    }, {
	        key: 'isSameOrigin',
	        value: function isSameOrigin(url) {
	            return this.getOrigin(url) === this.origin;
	        }
	    }, {
	        key: 'getOrigin',
	        value: function getOrigin(url) {
	            var link = this._link || (this._link = this._window.document.createElement('a'));
	            link.href = url;
	            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
	            return link.protocol + link.hostname + link.port;
	        }
	    }, {
	        key: 'ready',
	        value: function ready() {
	            var _this5 = this;
	
	            var keys = Object.keys(this.cache);
	            var values = keys.map(function (str) {
	                return _this5.cache[str].catch(function (e) {
	                    if (false) {
	                        _this5.logger.log('Unable to load image', e);
	                    }
	                    return null;
	                });
	            });
	            return Promise.all(values).then(function (images) {
	                if (false) {
	                    _this5.logger.log('Finished loading ' + images.length + ' images', images);
	                }
	                return new ResourceStore(keys, images);
	            });
	        }
	    }]);
	
	    return ResourceLoader;
	}();
	
	exports.default = ResourceLoader;
	
	var ResourceStore = exports.ResourceStore = function () {
	    function ResourceStore(keys, resources) {
	        _classCallCheck(this, ResourceStore);
	
	        this._keys = keys;
	        this._resources = resources;
	    }
	
	    _createClass(ResourceStore, [{
	        key: 'get',
	        value: function get(key) {
	            var index = this._keys.indexOf(key);
	            return index === -1 ? null : this._resources[index];
	        }
	    }]);
	
	    return ResourceStore;
	}();
	
	var INLINE_SVG = /^data:image\/svg\+xml/i;
	var INLINE_BASE64 = /^data:image\/.*;base64,/i;
	var INLINE_IMG = /^data:image\/.*/i;
	
	var isInlineImage = function isInlineImage(src) {
	    return INLINE_IMG.test(src);
	};
	var isInlineBase64Image = function isInlineBase64Image(src) {
	    return INLINE_BASE64.test(src);
	};
	var isBlobImage = function isBlobImage(src) {
	    return src.substr(0, 4) === 'blob';
	};
	
	var isSVG = function isSVG(src) {
	    return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
	};
	
	var _loadImage = function _loadImage(src, timeout) {
	    return new Promise(function (resolve, reject) {
	        var img = new Image();
	        img.onload = function () {
	            return resolve(img);
	        };
	        img.onerror = reject;
	        img.src = src;
	        if (img.complete === true) {
	            // Inline XML images may fail to parse, throwing an Error later on
	            setTimeout(function () {
	                resolve(img);
	            }, 500);
	        }
	        if (timeout) {
	            setTimeout(function () {
	                return reject( false ? 'Timed out (' + timeout + 'ms) loading image' : '');
	            }, timeout);
	        }
	    });
	};

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NodeContainer = __webpack_require__(177);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _position = __webpack_require__(613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StackingContext = function () {
	    function StackingContext(container, parent, treatAsRealStackingContext) {
	        _classCallCheck(this, StackingContext);
	
	        this.container = container;
	        this.parent = parent;
	        this.contexts = [];
	        this.children = [];
	        this.treatAsRealStackingContext = treatAsRealStackingContext;
	    }
	
	    _createClass(StackingContext, [{
	        key: 'getOpacity',
	        value: function getOpacity() {
	            return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
	        }
	    }, {
	        key: 'getRealParentStackingContext',
	        value: function getRealParentStackingContext() {
	            return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
	        }
	    }]);
	
	    return StackingContext;
	}();
	
	exports.default = StackingContext;

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.renderElement = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Logger = __webpack_require__(607);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _NodeParser = __webpack_require__(1474);
	
	var _Renderer = __webpack_require__(1476);
	
	var _Renderer2 = _interopRequireDefault(_Renderer);
	
	var _ForeignObjectRenderer = __webpack_require__(616);
	
	var _ForeignObjectRenderer2 = _interopRequireDefault(_ForeignObjectRenderer);
	
	var _Feature = __webpack_require__(273);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Bounds = __webpack_require__(142);
	
	var _Clone = __webpack_require__(1472);
	
	var _Font = __webpack_require__(605);
	
	var _Color = __webpack_require__(125);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderElement = exports.renderElement = function renderElement(element, options, logger) {
	    var ownerDocument = element.ownerDocument;
	
	    var windowBounds = new _Bounds.Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
	
	    // http://www.w3.org/TR/css3-background/#special-backgrounds
	    var documentBackgroundColor = ownerDocument.documentElement ? new _Color2.default(getComputedStyle(ownerDocument.documentElement).backgroundColor) : _Color.TRANSPARENT;
	    var bodyBackgroundColor = ownerDocument.body ? new _Color2.default(getComputedStyle(ownerDocument.body).backgroundColor) : _Color.TRANSPARENT;
	
	    var backgroundColor = element === ownerDocument.documentElement ? documentBackgroundColor.isTransparent() ? bodyBackgroundColor.isTransparent() ? options.backgroundColor ? new _Color2.default(options.backgroundColor) : null : bodyBackgroundColor : documentBackgroundColor : options.backgroundColor ? new _Color2.default(options.backgroundColor) : null;
	
	    return (options.foreignObjectRendering ? // $FlowFixMe
	    _Feature2.default.SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(false)).then(function (supportForeignObject) {
	        return supportForeignObject ? function (cloner) {
	            if (false) {
	                logger.log('Document cloned, using foreignObject rendering');
	            }
	
	            return cloner.inlineFonts(ownerDocument).then(function () {
	                return cloner.resourceLoader.ready();
	            }).then(function () {
	                var renderer = new _ForeignObjectRenderer2.default(cloner.documentElement);
	
	                var defaultView = ownerDocument.defaultView;
	                var scrollX = defaultView.pageXOffset;
	                var scrollY = defaultView.pageYOffset;
	
	                var isDocument = element.tagName === 'HTML' || element.tagName === 'BODY';
	
	                var _ref = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(element, scrollX, scrollY),
	                    width = _ref.width,
	                    height = _ref.height,
	                    left = _ref.left,
	                    top = _ref.top;
	
	                return renderer.render({
	                    backgroundColor: backgroundColor,
	                    logger: logger,
	                    scale: options.scale,
	                    x: typeof options.x === 'number' ? options.x : left,
	                    y: typeof options.y === 'number' ? options.y : top,
	                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
	                    height: typeof options.height === 'number' ? options.height : Math.ceil(height),
	                    windowWidth: options.windowWidth,
	                    windowHeight: options.windowHeight,
	                    scrollX: options.scrollX,
	                    scrollY: options.scrollY
	                });
	            });
	        }(new _Clone.DocumentCloner(element, options, logger, true, renderElement)) : (0, _Clone.cloneWindow)(ownerDocument, windowBounds, element, options, logger, renderElement).then(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 3),
	                container = _ref3[0],
	                clonedElement = _ref3[1],
	                resourceLoader = _ref3[2];
	
	            if (false) {
	                logger.log('Document cloned, using computed rendering');
	            }
	
	            var stack = (0, _NodeParser.NodeParser)(clonedElement, resourceLoader, logger);
	            var clonedDocument = clonedElement.ownerDocument;
	
	            if (backgroundColor === stack.container.style.background.backgroundColor) {
	                stack.container.style.background.backgroundColor = _Color.TRANSPARENT;
	            }
	
	            return resourceLoader.ready().then(function (imageStore) {
	                var fontMetrics = new _Font.FontMetrics(clonedDocument);
	                if (false) {
	                    logger.log('Starting renderer');
	                }
	
	                var defaultView = clonedDocument.defaultView;
	                var scrollX = defaultView.pageXOffset;
	                var scrollY = defaultView.pageYOffset;
	
	                var isDocument = clonedElement.tagName === 'HTML' || clonedElement.tagName === 'BODY';
	
	                var _ref4 = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(clonedElement, scrollX, scrollY),
	                    width = _ref4.width,
	                    height = _ref4.height,
	                    left = _ref4.left,
	                    top = _ref4.top;
	
	                var renderOptions = {
	                    backgroundColor: backgroundColor,
	                    fontMetrics: fontMetrics,
	                    imageStore: imageStore,
	                    logger: logger,
	                    scale: options.scale,
	                    x: typeof options.x === 'number' ? options.x : left,
	                    y: typeof options.y === 'number' ? options.y : top,
	                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
	                    height: typeof options.height === 'number' ? options.height : Math.ceil(height)
	                };
	
	                if (Array.isArray(options.target)) {
	                    return Promise.all(options.target.map(function (target) {
	                        var renderer = new _Renderer2.default(target, renderOptions);
	                        return renderer.render(stack);
	                    }));
	                } else {
	                    var renderer = new _Renderer2.default(options.target, renderOptions);
	                    var canvas = renderer.render(stack);
	                    if (options.removeContainer === true) {
	                        if (container.parentNode) {
	                            container.parentNode.removeChild(container);
	                        } else if (false) {
	                            logger.log('Cannot detach cloned iframe as it is not in the DOM anymore');
	                        }
	                    }
	
	                    return canvas;
	                }
	            });
	        });
	    });
	};

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Path = __webpack_require__(275);
	
	var _Vector = __webpack_require__(276);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var lerp = function lerp(a, b, t) {
	    return new _Vector2.default(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
	};
	
	var BezierCurve = function () {
	    function BezierCurve(start, startControl, endControl, end) {
	        _classCallCheck(this, BezierCurve);
	
	        this.type = _Path.PATH.BEZIER_CURVE;
	        this.start = start;
	        this.startControl = startControl;
	        this.endControl = endControl;
	        this.end = end;
	    }
	
	    _createClass(BezierCurve, [{
	        key: 'subdivide',
	        value: function subdivide(t, firstHalf) {
	            var ab = lerp(this.start, this.startControl, t);
	            var bc = lerp(this.startControl, this.endControl, t);
	            var cd = lerp(this.endControl, this.end, t);
	            var abbc = lerp(ab, bc, t);
	            var bccd = lerp(bc, cd, t);
	            var dest = lerp(abbc, bccd, t);
	            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
	        }
	    }, {
	        key: 'reverse',
	        value: function reverse() {
	            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
	        }
	    }]);
	
	    return BezierCurve;
	}();
	
	exports.default = BezierCurve;

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Path = __webpack_require__(275);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Circle = function Circle(x, y, radius) {
	    _classCallCheck(this, Circle);
	
	    this.type = _Path.PATH.CIRCLE;
	    this.x = x;
	    this.y = y;
	    this.radius = radius;
	    if (false) {
	        if (isNaN(x)) {
	            console.error('Invalid x value given for Circle');
	        }
	        if (isNaN(y)) {
	            console.error('Invalid y value given for Circle');
	        }
	        if (isNaN(radius)) {
	            console.error('Invalid radius value given for Circle');
	        }
	    }
	};
	
	exports.default = Circle;

/***/ },
/* 1482 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Size = function Size(width, height) {
	    _classCallCheck(this, Size);
	
	    this.width = width;
	    this.height = height;
	};
	
	exports.default = Size;

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBorderRadius = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Length = __webpack_require__(143);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIDES = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];
	
	var parseBorderRadius = exports.parseBorderRadius = function parseBorderRadius(style) {
	    return SIDES.map(function (side) {
	        var value = style.getPropertyValue('border-' + side + '-radius');
	
	        var _value$split$map = value.split(' ').map(_Length2.default.create),
	            _value$split$map2 = _slicedToArray(_value$split$map, 2),
	            horizontal = _value$split$map2[0],
	            vertical = _value$split$map2[1];
	
	        return typeof vertical === 'undefined' ? [horizontal, horizontal] : [horizontal, vertical];
	    });
	};

/***/ },
/* 1484 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DISPLAY = exports.DISPLAY = {
	    NONE: 1 << 0,
	    BLOCK: 1 << 1,
	    INLINE: 1 << 2,
	    RUN_IN: 1 << 3,
	    FLOW: 1 << 4,
	    FLOW_ROOT: 1 << 5,
	    TABLE: 1 << 6,
	    FLEX: 1 << 7,
	    GRID: 1 << 8,
	    RUBY: 1 << 9,
	    SUBGRID: 1 << 10,
	    LIST_ITEM: 1 << 11,
	    TABLE_ROW_GROUP: 1 << 12,
	    TABLE_HEADER_GROUP: 1 << 13,
	    TABLE_FOOTER_GROUP: 1 << 14,
	    TABLE_ROW: 1 << 15,
	    TABLE_CELL: 1 << 16,
	    TABLE_COLUMN_GROUP: 1 << 17,
	    TABLE_COLUMN: 1 << 18,
	    TABLE_CAPTION: 1 << 19,
	    RUBY_BASE: 1 << 20,
	    RUBY_TEXT: 1 << 21,
	    RUBY_BASE_CONTAINER: 1 << 22,
	    RUBY_TEXT_CONTAINER: 1 << 23,
	    CONTENTS: 1 << 24,
	    INLINE_BLOCK: 1 << 25,
	    INLINE_LIST_ITEM: 1 << 26,
	    INLINE_TABLE: 1 << 27,
	    INLINE_FLEX: 1 << 28,
	    INLINE_GRID: 1 << 29
	};
	
	var parseDisplayValue = function parseDisplayValue(display) {
	    switch (display) {
	        case 'block':
	            return DISPLAY.BLOCK;
	        case 'inline':
	            return DISPLAY.INLINE;
	        case 'run-in':
	            return DISPLAY.RUN_IN;
	        case 'flow':
	            return DISPLAY.FLOW;
	        case 'flow-root':
	            return DISPLAY.FLOW_ROOT;
	        case 'table':
	            return DISPLAY.TABLE;
	        case 'flex':
	            return DISPLAY.FLEX;
	        case 'grid':
	            return DISPLAY.GRID;
	        case 'ruby':
	            return DISPLAY.RUBY;
	        case 'subgrid':
	            return DISPLAY.SUBGRID;
	        case 'list-item':
	            return DISPLAY.LIST_ITEM;
	        case 'table-row-group':
	            return DISPLAY.TABLE_ROW_GROUP;
	        case 'table-header-group':
	            return DISPLAY.TABLE_HEADER_GROUP;
	        case 'table-footer-group':
	            return DISPLAY.TABLE_FOOTER_GROUP;
	        case 'table-row':
	            return DISPLAY.TABLE_ROW;
	        case 'table-cell':
	            return DISPLAY.TABLE_CELL;
	        case 'table-column-group':
	            return DISPLAY.TABLE_COLUMN_GROUP;
	        case 'table-column':
	            return DISPLAY.TABLE_COLUMN;
	        case 'table-caption':
	            return DISPLAY.TABLE_CAPTION;
	        case 'ruby-base':
	            return DISPLAY.RUBY_BASE;
	        case 'ruby-text':
	            return DISPLAY.RUBY_TEXT;
	        case 'ruby-base-container':
	            return DISPLAY.RUBY_BASE_CONTAINER;
	        case 'ruby-text-container':
	            return DISPLAY.RUBY_TEXT_CONTAINER;
	        case 'contents':
	            return DISPLAY.CONTENTS;
	        case 'inline-block':
	            return DISPLAY.INLINE_BLOCK;
	        case 'inline-list-item':
	            return DISPLAY.INLINE_LIST_ITEM;
	        case 'inline-table':
	            return DISPLAY.INLINE_TABLE;
	        case 'inline-flex':
	            return DISPLAY.INLINE_FLEX;
	        case 'inline-grid':
	            return DISPLAY.INLINE_GRID;
	    }
	
	    return DISPLAY.NONE;
	};
	
	var setDisplayBit = function setDisplayBit(bit, display) {
	    return bit | parseDisplayValue(display);
	};
	
	var parseDisplay = exports.parseDisplay = function parseDisplay(display) {
	    return display.split(' ').reduce(setDisplayBit, 0);
	};

/***/ },
/* 1485 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var FLOAT = exports.FLOAT = {
	    NONE: 0,
	    LEFT: 1,
	    RIGHT: 2,
	    INLINE_START: 3,
	    INLINE_END: 4
	};
	
	var parseCSSFloat = exports.parseCSSFloat = function parseCSSFloat(float) {
	    switch (float) {
	        case 'left':
	            return FLOAT.LEFT;
	        case 'right':
	            return FLOAT.RIGHT;
	        case 'inline-start':
	            return FLOAT.INLINE_START;
	        case 'inline-end':
	            return FLOAT.INLINE_END;
	    }
	    return FLOAT.NONE;
	};

/***/ },
/* 1486 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var parseFontWeight = function parseFontWeight(weight) {
	    switch (weight) {
	        case 'normal':
	            return 400;
	        case 'bold':
	            return 700;
	    }
	
	    var value = parseInt(weight, 10);
	    return isNaN(value) ? 400 : value;
	};
	
	var parseFont = exports.parseFont = function parseFont(style) {
	    var fontFamily = style.fontFamily;
	    var fontSize = style.fontSize;
	    var fontStyle = style.fontStyle;
	    var fontVariant = style.fontVariant;
	    var fontWeight = parseFontWeight(style.fontWeight);
	
	    return {
	        fontFamily: fontFamily,
	        fontSize: fontSize,
	        fontStyle: fontStyle,
	        fontVariant: fontVariant,
	        fontWeight: fontWeight
	    };
	};

/***/ },
/* 1487 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var parseLetterSpacing = exports.parseLetterSpacing = function parseLetterSpacing(letterSpacing) {
	    if (letterSpacing === 'normal') {
	        return 0;
	    }
	    var value = parseFloat(letterSpacing);
	    return isNaN(value) ? 0 : value;
	};

/***/ },
/* 1488 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LINE_BREAK = exports.LINE_BREAK = {
	    NORMAL: 'normal',
	    STRICT: 'strict'
	};
	
	var parseLineBreak = exports.parseLineBreak = function parseLineBreak(wordBreak) {
	    switch (wordBreak) {
	        case 'strict':
	            return LINE_BREAK.STRICT;
	        case 'normal':
	        default:
	            return LINE_BREAK.NORMAL;
	    }
	};

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseMargin = undefined;
	
	var _Length = __webpack_require__(143);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIDES = ['top', 'right', 'bottom', 'left'];
	
	var parseMargin = exports.parseMargin = function parseMargin(style) {
	    return SIDES.map(function (side) {
	        return new _Length2.default(style.getPropertyValue('margin-' + side));
	    });
	};

/***/ },
/* 1490 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OVERFLOW = exports.OVERFLOW = {
	    VISIBLE: 0,
	    HIDDEN: 1,
	    SCROLL: 2,
	    AUTO: 3
	};
	
	var parseOverflow = exports.parseOverflow = function parseOverflow(overflow) {
	    switch (overflow) {
	        case 'hidden':
	            return OVERFLOW.HIDDEN;
	        case 'scroll':
	            return OVERFLOW.SCROLL;
	        case 'auto':
	            return OVERFLOW.AUTO;
	        case 'visible':
	        default:
	            return OVERFLOW.VISIBLE;
	    }
	};

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTextShadow = undefined;
	
	var _Color = __webpack_require__(125);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NUMBER = /^([+-]|\d|\.)$/i;
	
	var parseTextShadow = exports.parseTextShadow = function parseTextShadow(textShadow) {
	    if (textShadow === 'none' || typeof textShadow !== 'string') {
	        return null;
	    }
	
	    var currentValue = '';
	    var isLength = false;
	    var values = [];
	    var shadows = [];
	    var numParens = 0;
	    var color = null;
	
	    var appendValue = function appendValue() {
	        if (currentValue.length) {
	            if (isLength) {
	                values.push(parseFloat(currentValue));
	            } else {
	                color = new _Color2.default(currentValue);
	            }
	        }
	        isLength = false;
	        currentValue = '';
	    };
	
	    var appendShadow = function appendShadow() {
	        if (values.length && color !== null) {
	            shadows.push({
	                color: color,
	                offsetX: values[0] || 0,
	                offsetY: values[1] || 0,
	                blur: values[2] || 0
	            });
	        }
	        values.splice(0, values.length);
	        color = null;
	    };
	
	    for (var i = 0; i < textShadow.length; i++) {
	        var c = textShadow[i];
	        switch (c) {
	            case '(':
	                currentValue += c;
	                numParens++;
	                break;
	            case ')':
	                currentValue += c;
	                numParens--;
	                break;
	            case ',':
	                if (numParens === 0) {
	                    appendValue();
	                    appendShadow();
	                } else {
	                    currentValue += c;
	                }
	                break;
	            case ' ':
	                if (numParens === 0) {
	                    appendValue();
	                } else {
	                    currentValue += c;
	                }
	                break;
	            default:
	                if (currentValue.length === 0 && NUMBER.test(c)) {
	                    isLength = true;
	                }
	                currentValue += c;
	        }
	    }
	
	    appendValue();
	    appendShadow();
	
	    if (shadows.length === 0) {
	        return null;
	    }
	
	    return shadows;
	};

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTransform = undefined;
	
	var _Length = __webpack_require__(143);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toFloat = function toFloat(s) {
	    return parseFloat(s.trim());
	};
	
	var MATRIX = /(matrix|matrix3d)\((.+)\)/;
	
	var parseTransform = exports.parseTransform = function parseTransform(style) {
	    var transform = parseTransformMatrix(style.transform || style.webkitTransform || style.mozTransform ||
	    // $FlowFixMe
	    style.msTransform ||
	    // $FlowFixMe
	    style.oTransform);
	    if (transform === null) {
	        return null;
	    }
	
	    return {
	        transform: transform,
	        transformOrigin: parseTransformOrigin(style.transformOrigin || style.webkitTransformOrigin || style.mozTransformOrigin ||
	        // $FlowFixMe
	        style.msTransformOrigin ||
	        // $FlowFixMe
	        style.oTransformOrigin)
	    };
	};
	
	// $FlowFixMe
	var parseTransformOrigin = function parseTransformOrigin(origin) {
	    if (typeof origin !== 'string') {
	        var v = new _Length2.default('0');
	        return [v, v];
	    }
	    var values = origin.split(' ').map(_Length2.default.create);
	    return [values[0], values[1]];
	};
	
	// $FlowFixMe
	var parseTransformMatrix = function parseTransformMatrix(transform) {
	    if (transform === 'none' || typeof transform !== 'string') {
	        return null;
	    }
	
	    var match = transform.match(MATRIX);
	    if (match) {
	        if (match[1] === 'matrix') {
	            var matrix = match[2].split(',').map(toFloat);
	            return [matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]];
	        } else {
	            var matrix3d = match[2].split(',').map(toFloat);
	            return [matrix3d[0], matrix3d[1], matrix3d[4], matrix3d[5], matrix3d[12], matrix3d[13]];
	        }
	    }
	    return null;
	};

/***/ },
/* 1493 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VISIBILITY = exports.VISIBILITY = {
	    VISIBLE: 0,
	    HIDDEN: 1,
	    COLLAPSE: 2
	};
	
	var parseVisibility = exports.parseVisibility = function parseVisibility(visibility) {
	    switch (visibility) {
	        case 'hidden':
	            return VISIBILITY.HIDDEN;
	        case 'collapse':
	            return VISIBILITY.COLLAPSE;
	        case 'visible':
	        default:
	            return VISIBILITY.VISIBLE;
	    }
	};

/***/ },
/* 1494 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var WORD_BREAK = exports.WORD_BREAK = {
	    NORMAL: 'normal',
	    BREAK_ALL: 'break-all',
	    KEEP_ALL: 'keep-all'
	};
	
	var parseWordBreak = exports.parseWordBreak = function parseWordBreak(wordBreak) {
	    switch (wordBreak) {
	        case 'break-all':
	            return WORD_BREAK.BREAK_ALL;
	        case 'keep-all':
	            return WORD_BREAK.KEEP_ALL;
	        case 'normal':
	        default:
	            return WORD_BREAK.NORMAL;
	    }
	};

/***/ },
/* 1495 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var parseZIndex = exports.parseZIndex = function parseZIndex(zIndex) {
	    var auto = zIndex === 'auto';
	    return {
	        auto: auto,
	        order: auto ? 0 : parseInt(zIndex, 10)
	    };
	};

/***/ },
/* 1496 */
/***/ function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createPrefixer;
	
	var _getBrowserInformation = __webpack_require__(1513);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(1514);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(400);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _addNewValuesOnly = __webpack_require__(618);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(619);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _prefixValue = __webpack_require__(620);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
	    return style;
	  };
	
	  return function () {
	    /**
	    * Instantiante a new prefixer
	    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	    * @param {string} keepUnprefixed - keeps unprefixed properties and values
	    */
	    function Prefixer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _classCallCheck(this, Prefixer);
	
	      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	      this._userAgent = options.userAgent || defaultUserAgent;
	      this._keepUnprefixed = options.keepUnprefixed || false;
	
	      if (this._userAgent) {
	        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	      }
	
	      // Checks if the userAgent was resolved correctly
	      if (this._browserInfo && this._browserInfo.cssPrefix) {
	        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
	      } else {
	        this._useFallback = true;
	        return false;
	      }
	
	      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
	      if (prefixData) {
	        this._requiresPrefix = {};
	
	        for (var property in prefixData) {
	          if (prefixData[property] >= this._browserInfo.browserVersion) {
	            this._requiresPrefix[property] = true;
	          }
	        }
	
	        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	      } else {
	        this._useFallback = true;
	      }
	
	      this._metaData = {
	        browserVersion: this._browserInfo.browserVersion,
	        browserName: this._browserInfo.browserName,
	        cssPrefix: this._browserInfo.cssPrefix,
	        jsPrefix: this._browserInfo.jsPrefix,
	        keepUnprefixed: this._keepUnprefixed,
	        requiresPrefix: this._requiresPrefix
	      };
	    }
	
	    _createClass(Prefixer, [{
	      key: 'prefix',
	      value: function prefix(style) {
	        // use static prefixer as fallback if userAgent can not be resolved
	        if (this._useFallback) {
	          return fallback(style);
	        }
	
	        // only add prefixes if needed
	        if (!this._hasPropsRequiringPrefix) {
	          return style;
	        }
	
	        return this._prefixStyle(style);
	      }
	    }, {
	      key: '_prefixStyle',
	      value: function _prefixStyle(style) {
	        for (var property in style) {
	          var value = style[property];
	
	          // handle nested objects
	          if ((0, _isObject2.default)(value)) {
	            style[property] = this.prefix(value);
	            // handle array values
	          } else if (Array.isArray(value)) {
	            var combinedValue = [];
	
	            for (var i = 0, len = value.length; i < len; ++i) {
	              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
	              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	            }
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (combinedValue.length > 0) {
	              style[property] = combinedValue;
	            }
	          } else {
	            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (_processedValue) {
	              style[property] = _processedValue;
	            }
	
	            // add prefixes to properties
	            if (this._requiresPrefix.hasOwnProperty(property)) {
	              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	              if (!this._keepUnprefixed) {
	                delete style[property];
	              }
	            }
	          }
	        }
	
	        return style;
	      }
	
	      /**
	      * Returns a prefixed version of the style object using all vendor prefixes
	      * @param {Object} styles - Style object that gets prefixed properties added
	      * @returns {Object} - Style object with prefixed properties and values
	      */
	
	    }], [{
	      key: 'prefixAll',
	      value: function prefixAll(styles) {
	        return fallback(styles);
	      }
	    }]);
	
	    return Prefixer;
	  }();
	}
	module.exports = exports['default'];

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(179);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(179);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  flex: true,
	  'inline-flex': true
	};
	function flex(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(179);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(179);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      if (value.indexOf('column') > -1) {
	        style.WebkitBoxOrient = 'vertical';
	      } else {
	        style.WebkitBoxOrient = 'horizontal';
	      }
	      if (value.indexOf('reverse') > -1) {
	        style.WebkitBoxDirection = 'reverse';
	      } else {
	        style.WebkitBoxDirection = 'normal';
	      }
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(179);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	function gradient(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(179);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	
	  // TODO: chrome & opera support it
	};function sizing(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(576);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var requiresPrefixDashCased = void 0;
	
	function transition(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    // memoize the prefix array for later use
	    if (!requiresPrefixDashCased) {
	      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateProperty2.default)(prop);
	      });
	    }
	
	    // only split multi values, not cubic beziers
	    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	    requiresPrefixDashCased.forEach(function (prop) {
	      multipleValues.forEach(function (val, index) {
	        if (val.indexOf(prop) > -1 && prop !== 'order') {
	          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
	        }
	      });
	    });
	
	    return multipleValues.join(',');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(1515);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(620);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(618);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(619);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(386);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1507 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1508 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1509 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(386);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1511 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(576);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(386);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(400);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBrowserInformation;
	
	var _bowser = __webpack_require__(1248);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixByBrowser = {
	  chrome: 'Webkit',
	  safari: 'Webkit',
	  ios: 'Webkit',
	  android: 'Webkit',
	  phantom: 'Webkit',
	  opera: 'Webkit',
	  webos: 'Webkit',
	  blackberry: 'Webkit',
	  bada: 'Webkit',
	  tizen: 'Webkit',
	  chromium: 'Webkit',
	  vivaldi: 'Webkit',
	  firefox: 'Moz',
	  seamoney: 'Moz',
	  sailfish: 'Moz',
	  msie: 'ms',
	  msedge: 'ms'
	};
	
	
	var browserByCanIuseAlias = {
	  chrome: 'chrome',
	  chromium: 'chrome',
	  safari: 'safari',
	  firfox: 'firefox',
	  msedge: 'edge',
	  opera: 'opera',
	  vivaldi: 'opera',
	  msie: 'ie'
	};
	
	function getBrowserName(browserInfo) {
	  if (browserInfo.firefox) {
	    return 'firefox';
	  }
	
	  if (browserInfo.mobile || browserInfo.tablet) {
	    if (browserInfo.ios) {
	      return 'ios_saf';
	    } else if (browserInfo.android) {
	      return 'android';
	    } else if (browserInfo.opera) {
	      return 'op_mini';
	    }
	  }
	
	  for (var browser in browserByCanIuseAlias) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      return browserByCanIuseAlias[browser];
	    }
	  }
	}
	
	/**
	 * Uses bowser to get default browser browserInformation such as version and name
	 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	function getBrowserInformation(userAgent) {
	  var browserInfo = _bowser2.default._detect(userAgent);
	
	  if (browserInfo.yandexbrowser) {
	    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
	  }
	
	  for (var browser in prefixByBrowser) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      var prefix = prefixByBrowser[browser];
	
	      browserInfo.jsPrefix = prefix;
	      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
	      break;
	    }
	  }
	
	  browserInfo.browserName = getBrowserName(browserInfo);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  if (browserInfo.version) {
	    browserInfo.browserVersion = parseFloat(browserInfo.version);
	  } else {
	    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
	  }
	
	  browserInfo.osVersion = parseFloat(browserInfo.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
	    browserInfo.browserName = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // Samsung browser are basically build on Chrome > 44
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
	  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
	    browserInfo.browserName = 'and_chr';
	    browserInfo.browserVersion = 44;
	  }
	
	  return browserInfo;
	}
	module.exports = exports['default'];

/***/ },
/* 1514 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedKeyframes;
	function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
	  var prefixedKeyframes = 'keyframes';
	
	  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
	    return cssPrefix + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	}
	module.exports = exports['default'];

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(400);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1516 */
/***/ function(module, exports) {

	module.exports = {
		"O_RDONLY": 0,
		"O_WRONLY": 1,
		"O_RDWR": 2,
		"S_IFMT": 61440,
		"S_IFREG": 32768,
		"S_IFDIR": 16384,
		"S_IFCHR": 8192,
		"S_IFBLK": 24576,
		"S_IFIFO": 4096,
		"S_IFLNK": 40960,
		"S_IFSOCK": 49152,
		"O_CREAT": 512,
		"O_EXCL": 2048,
		"O_NOCTTY": 131072,
		"O_TRUNC": 1024,
		"O_APPEND": 8,
		"O_DIRECTORY": 1048576,
		"O_NOFOLLOW": 256,
		"O_SYNC": 128,
		"O_SYMLINK": 2097152,
		"O_NONBLOCK": 4,
		"S_IRWXU": 448,
		"S_IRUSR": 256,
		"S_IWUSR": 128,
		"S_IXUSR": 64,
		"S_IRWXG": 56,
		"S_IRGRP": 32,
		"S_IWGRP": 16,
		"S_IXGRP": 8,
		"S_IRWXO": 7,
		"S_IROTH": 4,
		"S_IWOTH": 2,
		"S_IXOTH": 1,
		"E2BIG": 7,
		"EACCES": 13,
		"EADDRINUSE": 48,
		"EADDRNOTAVAIL": 49,
		"EAFNOSUPPORT": 47,
		"EAGAIN": 35,
		"EALREADY": 37,
		"EBADF": 9,
		"EBADMSG": 94,
		"EBUSY": 16,
		"ECANCELED": 89,
		"ECHILD": 10,
		"ECONNABORTED": 53,
		"ECONNREFUSED": 61,
		"ECONNRESET": 54,
		"EDEADLK": 11,
		"EDESTADDRREQ": 39,
		"EDOM": 33,
		"EDQUOT": 69,
		"EEXIST": 17,
		"EFAULT": 14,
		"EFBIG": 27,
		"EHOSTUNREACH": 65,
		"EIDRM": 90,
		"EILSEQ": 92,
		"EINPROGRESS": 36,
		"EINTR": 4,
		"EINVAL": 22,
		"EIO": 5,
		"EISCONN": 56,
		"EISDIR": 21,
		"ELOOP": 62,
		"EMFILE": 24,
		"EMLINK": 31,
		"EMSGSIZE": 40,
		"EMULTIHOP": 95,
		"ENAMETOOLONG": 63,
		"ENETDOWN": 50,
		"ENETRESET": 52,
		"ENETUNREACH": 51,
		"ENFILE": 23,
		"ENOBUFS": 55,
		"ENODATA": 96,
		"ENODEV": 19,
		"ENOENT": 2,
		"ENOEXEC": 8,
		"ENOLCK": 77,
		"ENOLINK": 97,
		"ENOMEM": 12,
		"ENOMSG": 91,
		"ENOPROTOOPT": 42,
		"ENOSPC": 28,
		"ENOSR": 98,
		"ENOSTR": 99,
		"ENOSYS": 78,
		"ENOTCONN": 57,
		"ENOTDIR": 20,
		"ENOTEMPTY": 66,
		"ENOTSOCK": 38,
		"ENOTSUP": 45,
		"ENOTTY": 25,
		"ENXIO": 6,
		"EOPNOTSUPP": 102,
		"EOVERFLOW": 84,
		"EPERM": 1,
		"EPIPE": 32,
		"EPROTO": 100,
		"EPROTONOSUPPORT": 43,
		"EPROTOTYPE": 41,
		"ERANGE": 34,
		"EROFS": 30,
		"ESPIPE": 29,
		"ESRCH": 3,
		"ESTALE": 70,
		"ETIME": 101,
		"ETIMEDOUT": 60,
		"ETXTBSY": 26,
		"EWOULDBLOCK": 35,
		"EXDEV": 18,
		"SIGHUP": 1,
		"SIGINT": 2,
		"SIGQUIT": 3,
		"SIGILL": 4,
		"SIGTRAP": 5,
		"SIGABRT": 6,
		"SIGIOT": 6,
		"SIGBUS": 10,
		"SIGFPE": 8,
		"SIGKILL": 9,
		"SIGUSR1": 30,
		"SIGSEGV": 11,
		"SIGUSR2": 31,
		"SIGPIPE": 13,
		"SIGALRM": 14,
		"SIGTERM": 15,
		"SIGCHLD": 20,
		"SIGCONT": 19,
		"SIGSTOP": 17,
		"SIGTSTP": 18,
		"SIGTTIN": 21,
		"SIGTTOU": 22,
		"SIGURG": 16,
		"SIGXCPU": 24,
		"SIGXFSZ": 25,
		"SIGVTALRM": 26,
		"SIGPROF": 27,
		"SIGWINCH": 28,
		"SIGIO": 23,
		"SIGSYS": 12,
		"SSL_OP_ALL": 2147486719,
		"SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION": 262144,
		"SSL_OP_CIPHER_SERVER_PREFERENCE": 4194304,
		"SSL_OP_CISCO_ANYCONNECT": 32768,
		"SSL_OP_COOKIE_EXCHANGE": 8192,
		"SSL_OP_CRYPTOPRO_TLSEXT_BUG": 2147483648,
		"SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS": 2048,
		"SSL_OP_EPHEMERAL_RSA": 0,
		"SSL_OP_LEGACY_SERVER_CONNECT": 4,
		"SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER": 32,
		"SSL_OP_MICROSOFT_SESS_ID_BUG": 1,
		"SSL_OP_MSIE_SSLV2_RSA_PADDING": 0,
		"SSL_OP_NETSCAPE_CA_DN_BUG": 536870912,
		"SSL_OP_NETSCAPE_CHALLENGE_BUG": 2,
		"SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG": 1073741824,
		"SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG": 8,
		"SSL_OP_NO_COMPRESSION": 131072,
		"SSL_OP_NO_QUERY_MTU": 4096,
		"SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION": 65536,
		"SSL_OP_NO_SSLv2": 16777216,
		"SSL_OP_NO_SSLv3": 33554432,
		"SSL_OP_NO_TICKET": 16384,
		"SSL_OP_NO_TLSv1": 67108864,
		"SSL_OP_NO_TLSv1_1": 268435456,
		"SSL_OP_NO_TLSv1_2": 134217728,
		"SSL_OP_PKCS1_CHECK_1": 0,
		"SSL_OP_PKCS1_CHECK_2": 0,
		"SSL_OP_SINGLE_DH_USE": 1048576,
		"SSL_OP_SINGLE_ECDH_USE": 524288,
		"SSL_OP_SSLEAY_080_CLIENT_DH_BUG": 128,
		"SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG": 0,
		"SSL_OP_TLS_BLOCK_PADDING_BUG": 512,
		"SSL_OP_TLS_D5_BUG": 256,
		"SSL_OP_TLS_ROLLBACK_BUG": 8388608,
		"ENGINE_METHOD_DSA": 2,
		"ENGINE_METHOD_DH": 4,
		"ENGINE_METHOD_RAND": 8,
		"ENGINE_METHOD_ECDH": 16,
		"ENGINE_METHOD_ECDSA": 32,
		"ENGINE_METHOD_CIPHERS": 64,
		"ENGINE_METHOD_DIGESTS": 128,
		"ENGINE_METHOD_STORE": 256,
		"ENGINE_METHOD_PKEY_METHS": 512,
		"ENGINE_METHOD_PKEY_ASN1_METHS": 1024,
		"ENGINE_METHOD_ALL": 65535,
		"ENGINE_METHOD_NONE": 0,
		"DH_CHECK_P_NOT_SAFE_PRIME": 2,
		"DH_CHECK_P_NOT_PRIME": 1,
		"DH_UNABLE_TO_CHECK_GENERATOR": 4,
		"DH_NOT_SUITABLE_GENERATOR": 8,
		"NPN_ENABLED": 1,
		"RSA_PKCS1_PADDING": 1,
		"RSA_SSLV23_PADDING": 2,
		"RSA_NO_PADDING": 3,
		"RSA_PKCS1_OAEP_PADDING": 4,
		"RSA_X931_PADDING": 5,
		"RSA_PKCS1_PSS_PADDING": 6,
		"POINT_CONVERSION_COMPRESSED": 2,
		"POINT_CONVERSION_UNCOMPRESSED": 4,
		"POINT_CONVERSION_HYBRID": 6,
		"F_OK": 0,
		"R_OK": 4,
		"W_OK": 2,
		"X_OK": 1,
		"UV_UDP_REUSEADDR": 4
	};

/***/ },
/* 1517 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ },
/* 1518 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(1517),
	    isArguments = __webpack_require__(623),
	    keysIn = __webpack_require__(1520);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(623),
	    isArray = __webpack_require__(1518);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(132)(module)))

/***/ },
/* 1522 */
[3175, 149, 88],
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1593),
	    hashDelete = __webpack_require__(1594),
	    hashGet = __webpack_require__(1595),
	    hashHas = __webpack_require__(1596),
	    hashSet = __webpack_require__(1597);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1524 */
[3177, 149, 88],
/* 1525 */
[3182, 149, 88],
/* 1526 */
462,
/* 1527 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 1528 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 1529 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 1530 */
/***/ function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(145);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(148),
	    keys = __webpack_require__(152);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(148),
	    keysIn = __webpack_require__(297);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(279),
	    arrayIncludes = __webpack_require__(403),
	    arrayIncludesWith = __webpack_require__(404),
	    arrayMap = __webpack_require__(144),
	    baseUnary = __webpack_require__(147),
	    cacheHas = __webpack_require__(288);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(145);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(145);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 1538 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1539 */
[3189, 634, 1545, 1627],
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(279),
	    arrayIncludes = __webpack_require__(403),
	    arrayIncludesWith = __webpack_require__(404),
	    arrayMap = __webpack_require__(144),
	    baseUnary = __webpack_require__(147),
	    cacheHas = __webpack_require__(288);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(105),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(280),
	    equalArrays = __webpack_require__(648),
	    equalByTag = __webpack_require__(1587),
	    equalObjects = __webpack_require__(1588),
	    getTag = __webpack_require__(228),
	    isArray = __webpack_require__(29),
	    isBuffer = __webpack_require__(232),
	    isTypedArray = __webpack_require__(296);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(228),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(280),
	    baseIsEqual = __webpack_require__(405);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1545 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1546 */
[3190, 28, 1602, 53, 662],
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(105),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObjectLike(value) && baseGetTag(value) == regexpTag;
	}
	
	module.exports = baseIsRegExp;


/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(228),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(105),
	    isLength = __webpack_require__(415),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53),
	    isPrototype = __webpack_require__(230),
	    nativeKeysIn = __webpack_require__(1616);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1551 */
[3193, 1544, 1589, 657],
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(405),
	    get = __webpack_require__(186),
	    hasIn = __webpack_require__(666),
	    isKey = __webpack_require__(411),
	    isStrictComparable = __webpack_require__(656),
	    matchesStrictComparable = __webpack_require__(657),
	    toKey = __webpack_require__(183);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(280),
	    assignMergeValue = __webpack_require__(631),
	    baseFor = __webpack_require__(635),
	    baseMergeDeep = __webpack_require__(1554),
	    isObject = __webpack_require__(53),
	    keysIn = __webpack_require__(297),
	    safeGet = __webpack_require__(660);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(631),
	    cloneBuffer = __webpack_require__(644),
	    cloneTypedArray = __webpack_require__(645),
	    copyArray = __webpack_require__(408),
	    initCloneObject = __webpack_require__(655),
	    isArguments = __webpack_require__(231),
	    isArray = __webpack_require__(29),
	    isArrayLikeObject = __webpack_require__(292),
	    isBuffer = __webpack_require__(232),
	    isFunction = __webpack_require__(28),
	    isObject = __webpack_require__(53),
	    isPlainObject = __webpack_require__(126),
	    isTypedArray = __webpack_require__(296),
	    safeGet = __webpack_require__(660),
	    toPlainObject = __webpack_require__(1654);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(1556),
	    hasIn = __webpack_require__(666);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(285),
	    baseSet = __webpack_require__(1562),
	    castPath = __webpack_require__(181);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 1557 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1558 */
[3194, 285],
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	var baseUnset = __webpack_require__(643),
	    isIndex = __webpack_require__(229);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAt` without support for individual
	 * indexes or capturing the removed elements.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {number[]} indexes The indexes of elements to remove.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAt(array, indexes) {
	  var length = array ? indexes.length : 0,
	      lastIndex = length - 1;
	
	  while (length--) {
	    var index = indexes[length];
	    if (length == lastIndex || index !== previous) {
	      var previous = index;
	      if (isIndex(index)) {
	        splice.call(array, index, 1);
	      } else {
	        baseUnset(array, index);
	      }
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAt;


/***/ },
/* 1560 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 1561 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(282),
	    castPath = __webpack_require__(181),
	    isIndex = __webpack_require__(229),
	    isObject = __webpack_require__(53),
	    toKey = __webpack_require__(183);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1634),
	    defineProperty = __webpack_require__(647),
	    identity = __webpack_require__(151);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(145);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 1565 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(184);
	
	/**
	 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseSortedUniq(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    if (!index || !eq(computed, seen)) {
	      var seen = computed;
	      result[resIndex++] = value === 0 ? 0 : value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseSortedUniq;


/***/ },
/* 1567 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 1568 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(292);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(151);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(286);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(407);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 1573 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(180);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(187);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1575);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(148),
	    getSymbols = __webpack_require__(410);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(148),
	    getSymbolsIn = __webpack_require__(653);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 1579 */
[3197, 88],
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(1527),
	    baseAggregator = __webpack_require__(1531),
	    baseIteratee = __webpack_require__(60),
	    isArray = __webpack_require__(29);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 1581 */
[3199, 106],
/* 1582 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(60),
	    isArrayLike = __webpack_require__(106),
	    keys = __webpack_require__(152);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(1560),
	    isIterateeCall = __webpack_require__(182),
	    toFinite = __webpack_require__(679);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(625),
	    noop = __webpack_require__(298),
	    setToArray = __webpack_require__(412);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(126);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(180),
	    Uint8Array = __webpack_require__(626),
	    eq = __webpack_require__(184),
	    equalArrays = __webpack_require__(648),
	    mapToArray = __webpack_require__(1613),
	    setToArray = __webpack_require__(412);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(651);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1589 */
[3202, 656, 152],
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(180);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1591 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(181),
	    isArguments = __webpack_require__(231),
	    isArray = __webpack_require__(29),
	    isIndex = __webpack_require__(229),
	    isLength = __webpack_require__(415),
	    toKey = __webpack_require__(183);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1593 */
[3204, 290],
/* 1594 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1595 */
[3205, 290],
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(290);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1597 */
[3206, 290],
/* 1598 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(407),
	    cloneDataView = __webpack_require__(1572),
	    cloneRegExp = __webpack_require__(1573),
	    cloneSymbol = __webpack_require__(1574),
	    cloneTypedArray = __webpack_require__(645);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 1600 */
[3207, 180, 231, 29],
/* 1601 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1602 */
[3210, 1579],
/* 1603 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1604 */
[3212, 283],
/* 1605 */
[3213, 283],
/* 1606 */
[3214, 283],
/* 1607 */
[3215, 283],
/* 1608 */
[3216, 1523, 278, 401],
/* 1609 */
[3217, 289],
/* 1610 */
[3218, 289],
/* 1611 */
[3219, 289],
/* 1612 */
[3220, 289],
/* 1613 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1614 */
[3221, 1644],
/* 1615 */
[3223, 658],
/* 1616 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1617 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(285),
	    baseSlice = __webpack_require__(286);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 1619 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1620 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1621 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1622 */
[3227, 278],
/* 1623 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1624 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1625 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1626 */
[3228, 278, 401, 402],
/* 1627 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(1530),
	    hasUnicode = __webpack_require__(654),
	    unicodeToArray = __webpack_require__(1630);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1614);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1630 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ },
/* 1631 */
[3230, 282, 148, 646, 106, 230, 152],
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(633);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(281),
	    baseFlatten = __webpack_require__(146),
	    copyArray = __webpack_require__(408),
	    isArray = __webpack_require__(29);
	
	/**
	 * Creates a new array concatenating `array` with any additional arrays
	 * and/or values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to concatenate.
	 * @param {...*} [values] The values to concatenate.
	 * @returns {Array} Returns the new concatenated array.
	 * @example
	 *
	 * var array = [1];
	 * var other = _.concat(array, 2, [3], [[4]]);
	 *
	 * console.log(other);
	 * // => [1, 2, 3, [4]]
	 *
	 * console.log(array);
	 * // => [1]
	 */
	function concat() {
	  var length = arguments.length;
	  if (!length) {
	    return [];
	  }
	  var args = Array(length - 1),
	      array = arguments[0],
	      index = length;
	
	  while (index--) {
	    args[index - 1] = arguments[index];
	  }
	  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	}
	
	module.exports = concat;


/***/ },
/* 1634 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(632),
	    baseToString = __webpack_require__(287),
	    toInteger = __webpack_require__(300),
	    toString = __webpack_require__(233);
	
	/**
	 * Checks if `string` ends with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=string.length] The position to search up to.
	 * @returns {boolean} Returns `true` if `string` ends with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.endsWith('abc', 'c');
	 * // => true
	 *
	 * _.endsWith('abc', 'b');
	 * // => false
	 *
	 * _.endsWith('abc', 'b', 2);
	 * // => true
	 */
	function endsWith(string, target, position) {
	  string = toString(string);
	  target = baseToString(target);
	
	  var length = string.length;
	  position = position === undefined
	    ? length
	    : baseClamp(toInteger(position), 0, length);
	
	  var end = position;
	  position -= target.length;
	  return position >= 0 && string.slice(position, end) == target;
	}
	
	module.exports = endsWith;


/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(146);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(146);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Recursively flattens `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flattenDeep([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, 3, 4, 5]
	 */
	function flattenDeep(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, INFINITY) : [];
	}
	
	module.exports = flattenDeep;


/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1543),
	    baseUnary = __webpack_require__(147),
	    nodeUtil = __webpack_require__(291);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 1639 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsRegExp = __webpack_require__(1547),
	    baseUnary = __webpack_require__(147),
	    nodeUtil = __webpack_require__(291);
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;


/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1548),
	    baseUnary = __webpack_require__(147),
	    nodeUtil = __webpack_require__(291);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },
/* 1642 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeJoin = arrayProto.join;
	
	/**
	 * Converts all elements in `array` into a string separated by `separator`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to convert.
	 * @param {string} [separator=','] The element separator.
	 * @returns {string} Returns the joined string.
	 * @example
	 *
	 * _.join(['a', 'b', 'c'], '~');
	 * // => 'a~b~c'
	 */
	function join(array, separator) {
	  return array == null ? '' : nativeJoin.call(array, separator);
	}
	
	module.exports = join;


/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(226),
	    baseForOwn = __webpack_require__(636),
	    baseIteratee = __webpack_require__(60);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(402);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(284),
	    baseIteratee = __webpack_require__(60),
	    baseLt = __webpack_require__(640);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(88);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(1555),
	    flatRest = __webpack_require__(649);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 1648 */
[3237, 1557, 1558, 411, 183],
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedUniq = __webpack_require__(1566);
	
	/**
	 * This method is like `_.uniq` except that it's designed and optimized
	 * for sorted arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.sortedUniq([1, 1, 2]);
	 * // => [1, 2]
	 */
	function sortedUniq(array) {
	  return (array && array.length)
	    ? baseSortedUniq(array)
	    : [];
	}
	
	module.exports = sortedUniq;


/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(287),
	    castSlice = __webpack_require__(1571),
	    hasUnicode = __webpack_require__(654),
	    isIterateeCall = __webpack_require__(182),
	    isRegExp = __webpack_require__(1640),
	    stringToArray = __webpack_require__(1628),
	    toString = __webpack_require__(233);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Splits `string` by `separator`.
	 *
	 * **Note:** This method is based on
	 * [`String#split`](https://mdn.io/String/split).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to split.
	 * @param {RegExp|string} separator The separator pattern to split by.
	 * @param {number} [limit] The length to truncate results to.
	 * @returns {Array} Returns the string segments.
	 * @example
	 *
	 * _.split('a-b-c', '-', 2);
	 * // => ['a', 'b']
	 */
	function split(string, separator, limit) {
	  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	    separator = limit = undefined;
	  }
	  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	  if (!limit) {
	    return [];
	  }
	  string = toString(string);
	  if (string && (
	        typeof separator == 'string' ||
	        (separator != null && !isRegExp(separator))
	      )) {
	    separator = baseToString(separator);
	    if (!separator && hasUnicode(string)) {
	      return castSlice(stringToArray(string), 0, limit);
	    }
	  }
	  return string.split(separator, limit);
	}
	
	module.exports = split;


/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(632),
	    baseToString = __webpack_require__(287),
	    toInteger = __webpack_require__(300),
	    toString = __webpack_require__(233);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = position == null
	    ? 0
	    : baseClamp(toInteger(position), 0, string.length);
	
	  target = baseToString(target);
	  return string.slice(position, position + target.length) == target;
	}
	
	module.exports = startsWith;


/***/ },
/* 1652 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(413),
	    isObject = __webpack_require__(53);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(148),
	    keysIn = __webpack_require__(297);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(233);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(539);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getStyles = getStyles;
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(189);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _menu = __webpack_require__(730);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      appBar = _context$muiTheme.appBar,
	      iconButtonSize = _context$muiTheme.button.iconButtonSize,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var flatButtonSize = 36;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      zIndex: zIndex.appBar,
	      width: '100%',
	      display: 'flex',
	      backgroundColor: appBar.color,
	      paddingLeft: appBar.padding,
	      paddingRight: appBar.padding
	    },
	    title: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      margin: 0,
	      paddingTop: 0,
	      letterSpacing: 0,
	      fontSize: 24,
	      fontWeight: appBar.titleFontWeight,
	      color: appBar.textColor,
	      height: appBar.height,
	      lineHeight: appBar.height + 'px'
	    },
	    mainElement: {
	      boxFlex: 1,
	      flex: '1'
	    },
	    iconButtonStyle: {
	      marginTop: (appBar.height - iconButtonSize) / 2,
	      marginRight: 8,
	      marginLeft: -16
	    },
	    iconButtonIconStyle: {
	      fill: appBar.textColor,
	      color: appBar.textColor
	    },
	    flatButton: {
	      color: appBar.textColor,
	      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
	    }
	  };
	
	  return styles;
	}
	
	var AppBar = function (_Component) {
	  (0, _inherits3.default)(AppBar, _Component);
	
	  function AppBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppBar.__proto__ || (0, _getPrototypeOf2.default)(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapLeftIconButton = function (event) {
	      if (_this.props.onLeftIconButtonTouchTap) {
	        _this.props.onLeftIconButtonTouchTap(event);
	      }
	    }, _this.handleTouchTapRightIconButton = function (event) {
	      if (_this.props.onRightIconButtonTouchTap) {
	        _this.props.onRightIconButtonTouchTap(event);
	      }
	    }, _this.handleTitleTouchTap = function (event) {
	      if (_this.props.onTitleTouchTap) {
	        _this.props.onTitleTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AppBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Material-UI: Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;
	
	       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Material-UI: Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          titleStyle = _props.titleStyle,
	          iconStyleLeft = _props.iconStyleLeft,
	          iconStyleRight = _props.iconStyleRight,
	          onTitleTouchTap = _props.onTitleTouchTap,
	          showMenuIconButton = _props.showMenuIconButton,
	          iconElementLeft = _props.iconElementLeft,
	          iconElementRight = _props.iconElementRight,
	          iconClassNameLeft = _props.iconClassNameLeft,
	          iconClassNameRight = _props.iconClassNameRight,
	          onLeftIconButtonTouchTap = _props.onLeftIconButtonTouchTap,
	          onRightIconButtonTouchTap = _props.onRightIconButtonTouchTap,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleTouchTap', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonTouchTap', 'onRightIconButtonTouchTap', 'className', 'style', 'zDepth', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var menuElementLeft = void 0;
	      var menuElementRight = void 0;
	
	      // If the title is a string, wrap in an h1 tag.
	      // If not, wrap in a div tag.
	      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';
	
	      var titleElement = _react2.default.createElement(titleComponent, {
	        onClick: this.handleTitleTouchTap,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
	      }, title);
	
	      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);
	
	      if (showMenuIconButton) {
	        if (iconElementLeft) {
	          var iconElementLeftProps = {};
	
	          if (iconElementLeft.type.muiName === 'IconButton') {
	            var iconElemLeftChildren = iconElementLeft.props.children;
	            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementLeftProps.iconStyle = (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle);
	          }
	
	          if (!iconElementLeft.props.onClick && this.props.onLeftIconButtonTouchTap) {
	            iconElementLeftProps.onClick = this.handleTouchTapLeftIconButton;
	          }
	
	          menuElementLeft = _react2.default.createElement(
	            'div',
	            { style: prepareStyles(iconLeftStyle) },
	            (0, _keys2.default)(iconElementLeftProps).length > 0 ? (0, _react.cloneElement)(iconElementLeft, iconElementLeftProps) : iconElementLeft
	          );
	        } else {
	          menuElementLeft = _react2.default.createElement(
	            _IconButton2.default,
	            {
	              style: iconLeftStyle,
	              iconStyle: styles.iconButtonIconStyle,
	              iconClassName: iconClassNameLeft,
	              onClick: this.handleTouchTapLeftIconButton
	            },
	            iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) })
	          );
	        }
	      }
	
	      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
	        marginRight: -16,
	        marginLeft: 'auto'
	      }, iconStyleRight);
	
	      if (iconElementRight) {
	        var iconElementRightProps = {};
	
	        switch (iconElementRight.type.muiName) {
	          case 'IconMenu':
	          case 'IconButton':
	            var iconElemRightChildren = iconElementRight.props.children;
	            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementRightProps.iconStyle = (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle);
	            break;
	
	          case 'FlatButton':
	            iconElementRightProps.style = (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style);
	            break;
	
	          default:
	        }
	
	        if (!iconElementRight.props.onClick && this.props.onRightIconButtonTouchTap) {
	          iconElementRightProps.onClick = this.handleTouchTapRightIconButton;
	        }
	
	        menuElementRight = _react2.default.createElement(
	          'div',
	          { style: prepareStyles(iconRightStyle) },
	          (0, _keys2.default)(iconElementRightProps).length > 0 ? (0, _react.cloneElement)(iconElementRight, iconElementRightProps) : iconElementRight
	        );
	      } else if (iconClassNameRight) {
	        menuElementRight = _react2.default.createElement(_IconButton2.default, {
	          style: iconRightStyle,
	          iconStyle: styles.iconButtonIconStyle,
	          iconClassName: iconClassNameRight,
	          onClick: this.handleTouchTapRightIconButton
	        });
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, {
	          rounded: false,
	          className: className,
	          style: (0, _simpleAssign2.default)({}, styles.root, style),
	          zDepth: zDepth
	        }),
	        menuElementLeft,
	        titleElement,
	        menuElementRight,
	        children
	      );
	    }
	  }]);
	  return AppBar;
	}(_react.Component);
	
	AppBar.muiName = 'AppBar';
	AppBar.defaultProps = {
	  showMenuIconButton: true,
	  title: '',
	  zDepth: 1
	};
	AppBar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	AppBar.propTypes =  false ? {
	  /**
	   * Can be used to render a tab inside an app bar for instance.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Applied to the app bar's root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The classname of the icon on the left of the app bar.
	   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	   */
	  iconClassNameLeft: _propTypes2.default.string,
	  /**
	   * Similiar to the iconClassNameLeft prop except that
	   * it applies to the icon displayed on the right of the app bar.
	   */
	  iconClassNameRight: _propTypes2.default.string,
	  /**
	   * The custom element to be displayed on the left side of the
	   * app bar such as an SvgIcon.
	   */
	  iconElementLeft: _propTypes2.default.element,
	  /**
	   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	   */
	  iconElementRight: _propTypes2.default.element,
	  /**
	   * Override the inline-styles of the element displayed on the left side of the app bar.
	   */
	  iconStyleLeft: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the element displayed on the right side of the app bar.
	   */
	  iconStyleRight: _propTypes2.default.object,
	  /**
	   * Callback function for when the left icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the left `IconButton`.
	   */
	  onLeftIconButtonTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function for when the right icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the right `IconButton`.
	   */
	  onRightIconButtonTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function for when the title text is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the `title` node.
	   */
	  onTitleTouchTap: _propTypes2.default.func,
	  /**
	   * Determines whether or not to display the Menu icon next to the title.
	   * Setting this prop to false will hide the icon.
	   */
	  showMenuIconButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The title to display on the app bar.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the app bar's title element.
	   */
	  titleStyle: _propTypes2.default.object,
	  /**
	   * The zDepth of the component.
	   * The shadow of the app bar is also dependent on this property.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = AppBar;

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AppBar = __webpack_require__(1656);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppBar2.default;

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(167);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _TextField = __webpack_require__(154);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Menu = __webpack_require__(695);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(235);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(691);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Popover = __webpack_require__(190);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var anchorEl = state.anchorEl;
	  var fullWidth = props.fullWidth;
	
	
	  var styles = {
	    root: {
	      display: 'inline-block',
	      position: 'relative',
	      width: fullWidth ? '100%' : 256
	    },
	    menu: {
	      width: '100%'
	    },
	    list: {
	      display: 'block',
	      width: fullWidth ? '100%' : 256
	    },
	    innerDiv: {
	      overflow: 'hidden'
	    }
	  };
	
	  if (anchorEl && fullWidth) {
	    styles.popover = {
	      width: anchorEl.clientWidth
	    };
	  }
	
	  return styles;
	}
	
	var AutoComplete = function (_Component) {
	  (0, _inherits3.default)(AutoComplete, _Component);
	
	  function AutoComplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoComplete.__proto__ || (0, _getPrototypeOf2.default)(AutoComplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      focusTextField: true,
	      open: false,
	      searchText: undefined
	    }, _this.handleRequestClose = function () {
	      // Only take into account the Popover clickAway when we are
	      // not focusing the TextField.
	      if (!_this.state.focusTextField) {
	        _this.close();
	      }
	    }, _this.handleMouseDown = function (event) {
	      // Keep the TextField focused
	      event.preventDefault();
	    }, _this.handleItemTouchTap = function (event, child) {
	      var dataSource = _this.props.dataSource;
	      var index = parseInt(child.key, 10);
	      var chosenRequest = dataSource[index];
	      var searchText = _this.chosenRequestText(chosenRequest);
	
	      var updateInput = function updateInput() {
	        return _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'click'
	        });
	      };
	      _this.timerTouchTapCloseId = function () {
	        return setTimeout(function () {
	          _this.timerTouchTapCloseId = null;
	          _this.close();
	          _this.props.onNewRequest(chosenRequest, index);
	        }, _this.props.menuCloseDelay);
	      };
	
	      if (typeof _this.props.searchText !== 'undefined') {
	        updateInput();
	        _this.timerTouchTapCloseId();
	      } else {
	        _this.setState({
	          searchText: searchText
	        }, function () {
	          updateInput();
	          _this.timerTouchTapCloseId();
	        });
	      }
	    }, _this.chosenRequestText = function (chosenRequest) {
	      if (typeof chosenRequest === 'string') {
	        return chosenRequest;
	      } else {
	        return chosenRequest[_this.props.dataSourceConfig.text];
	      }
	    }, _this.handleEscKeyDown = function () {
	      _this.close();
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.close();
	          var searchText = _this.state.searchText;
	          if (searchText !== '') {
	            _this.props.onNewRequest(searchText, -1);
	          }
	          break;
	
	        case 'esc':
	          _this.close();
	          break;
	
	        case 'down':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            focusTextField: false,
	            anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	          });
	          break;
	
	        default:
	          break;
	      }
	    }, _this.handleChange = function (event) {
	      var searchText = event.target.value;
	
	      // Make sure that we have a new searchText.
	      // Fix an issue with a Cordova Webview
	      if (searchText === _this.state.searchText) {
	        return;
	      }
	
	      var state = {
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	      };
	
	      if (_this.props.searchText === undefined) {
	        state.searchText = searchText;
	      }
	
	      _this.setState(state);
	
	      _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	        source: 'change'
	      });
	    }, _this.handleBlur = function (event) {
	      if (_this.state.focusTextField && _this.timerTouchTapCloseId === null) {
	        _this.timerBlurClose = setTimeout(function () {
	          _this.close();
	        }, 0);
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      if (!_this.state.open && _this.props.openOnFocus) {
	        _this.setState({
	          open: true,
	          anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	        });
	      }
	
	      _this.setState({
	        focusTextField: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoComplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.requestsList = [];
	      this.setState({
	        open: this.props.open,
	        searchText: this.props.searchText || ''
	      });
	      this.timerTouchTapCloseId = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.searchText !== nextProps.searchText) {
	        this.setState({
	          searchText: nextProps.searchText
	        });
	      }
	      if (this.props.open !== nextProps.open) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: _reactDom2.default.findDOMNode(this.refs.searchTextField)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerTouchTapCloseId);
	      clearTimeout(this.timerBlurClose);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        open: false,
	        anchorEl: null
	      });
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.refs.searchTextField.blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.searchTextField.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          animated = _props.animated,
	          animation = _props.animation,
	          dataSource = _props.dataSource,
	          dataSourceConfig = _props.dataSourceConfig,
	          disableFocusRipple = _props.disableFocusRipple,
	          errorStyle = _props.errorStyle,
	          floatingLabelText = _props.floatingLabelText,
	          filter = _props.filter,
	          fullWidth = _props.fullWidth,
	          style = _props.style,
	          hintText = _props.hintText,
	          maxSearchResults = _props.maxSearchResults,
	          menuCloseDelay = _props.menuCloseDelay,
	          textFieldStyle = _props.textFieldStyle,
	          menuStyle = _props.menuStyle,
	          menuProps = _props.menuProps,
	          listStyle = _props.listStyle,
	          targetOrigin = _props.targetOrigin,
	          onBlur = _props.onBlur,
	          onClose = _props.onClose,
	          onFocus = _props.onFocus,
	          onKeyDown = _props.onKeyDown,
	          onNewRequest = _props.onNewRequest,
	          onUpdateInput = _props.onUpdateInput,
	          openOnFocus = _props.openOnFocus,
	          popoverProps = _props.popoverProps,
	          searchTextProp = _props.searchText,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'animated', 'animation', 'dataSource', 'dataSourceConfig', 'disableFocusRipple', 'errorStyle', 'floatingLabelText', 'filter', 'fullWidth', 'style', 'hintText', 'maxSearchResults', 'menuCloseDelay', 'textFieldStyle', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin', 'onBlur', 'onClose', 'onFocus', 'onKeyDown', 'onNewRequest', 'onUpdateInput', 'openOnFocus', 'popoverProps', 'searchText']);
	
	      var _ref2 = popoverProps || {},
	          popoverStyle = _ref2.style,
	          popoverOther = (0, _objectWithoutProperties3.default)(_ref2, ['style']);
	
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl,
	          searchText = _state.searchText,
	          focusTextField = _state.focusTextField;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var requestsList = [];
	
	      dataSource.every(function (item, index) {
	        switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) {
	          case 'string':
	            if (filter(searchText, item, item)) {
	              requestsList.push({
	                text: item,
	                value: _react2.default.createElement(_MenuItem2.default, {
	                  innerDivStyle: styles.innerDiv,
	                  value: item,
	                  primaryText: item,
	                  disableFocusRipple: disableFocusRipple,
	                  key: index
	                })
	              });
	            }
	            break;
	
	          case 'object':
	            if (item && typeof item[_this2.props.dataSourceConfig.text] === 'string') {
	              var itemText = item[_this2.props.dataSourceConfig.text];
	              if (!_this2.props.filter(searchText, itemText, item)) break;
	
	              var itemValue = item[_this2.props.dataSourceConfig.value];
	              if (itemValue.type && (itemValue.type.muiName === _MenuItem2.default.muiName || itemValue.type.muiName === _Divider2.default.muiName)) {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.cloneElement(itemValue, {
	                    key: index,
	                    disableFocusRipple: disableFocusRipple
	                  })
	                });
	              } else {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.createElement(_MenuItem2.default, {
	                    innerDivStyle: styles.innerDiv,
	                    primaryText: itemText,
	                    disableFocusRipple: disableFocusRipple,
	                    key: index
	                  })
	                });
	              }
	            }
	            break;
	
	          default:
	          // Do nothing
	        }
	
	        return !(maxSearchResults && maxSearchResults > 0 && requestsList.length === maxSearchResults);
	      });
	
	      this.requestsList = requestsList;
	
	      var menu = open && requestsList.length > 0 && _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({
	          ref: 'menu',
	          autoWidth: false,
	          disableAutoFocus: focusTextField,
	          onEscKeyDown: this.handleEscKeyDown,
	          initiallyKeyboardFocused: true,
	          onItemTouchTap: this.handleItemTouchTap,
	          onMouseDown: this.handleMouseDown,
	          style: (0, _simpleAssign2.default)(styles.menu, menuStyle),
	          listStyle: (0, _simpleAssign2.default)(styles.list, listStyle)
	        }, menuProps),
	        requestsList.map(function (i) {
	          return i.value;
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({
	          ref: 'searchTextField',
	          autoComplete: 'off',
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          floatingLabelText: floatingLabelText,
	          hintText: hintText,
	          fullWidth: fullWidth,
	          multiLine: false,
	          errorStyle: errorStyle,
	          style: textFieldStyle
	        }, other, {
	          // value and onChange are idiomatic properties often leaked.
	          // We prevent their overrides in order to reduce potential bugs.
	          value: searchText,
	          onChange: this.handleChange
	        })),
	        _react2.default.createElement(
	          _Popover2.default,
	          (0, _extends3.default)({
	            style: (0, _simpleAssign2.default)({}, styles.popover, popoverStyle),
	            canAutoPosition: false,
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation
	          }, popoverOther),
	          menu
	        )
	      );
	    }
	  }]);
	  return AutoComplete;
	}(_react.Component);
	
	AutoComplete.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  dataSourceConfig: {
	    text: 'text',
	    value: 'value'
	  },
	  disableFocusRipple: true,
	  filter: function filter(searchText, key) {
	    return searchText !== '' && key.indexOf(searchText) !== -1;
	  },
	  fullWidth: false,
	  open: false,
	  openOnFocus: false,
	  onUpdateInput: function onUpdateInput() {},
	  onNewRequest: function onNewRequest() {},
	  menuCloseDelay: 300,
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	AutoComplete.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	AutoComplete.propTypes =  false ? {
	  /**
	   * Location of the anchor for the auto complete.
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the auto complete is animated as it is toggled.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * Array of strings or nodes used to populate the list.
	   */
	  dataSource: _propTypes2.default.array.isRequired,
	  /**
	   * Config for objects list dataSource.
	   *
	   * @typedef {Object} dataSourceConfig
	   *
	   * @property {string} text `dataSource` element key used to find a string to be matched for search
	   * and shown as a `TextField` input value after choosing the result.
	   * @property {string} value `dataSource` element key used to find a string to be shown in search results.
	   */
	  dataSourceConfig: _propTypes2.default.object,
	  /**
	   * Disables focus ripple when true.
	   */
	  disableFocusRipple: _propTypes2.default.bool,
	  /**
	   * Override style prop for error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * Callback function used to filter the auto complete.
	   *
	   * @param {string} searchText The text to search for within `dataSource`.
	   * @param {string} key `dataSource` element, or `text` property on that element if it's not a string.
	   * @returns {boolean} `true` indicates the auto complete list will include `key` when the input is `searchText`.
	   */
	  filter: _propTypes2.default.func,
	  /**
	   * The content to use for adding floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property `width: 100%`.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * Override style for list.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The max number of search results to be shown.
	   * By default it shows all the items which matches filter.
	   */
	  maxSearchResults: _propTypes2.default.number,
	  /**
	   * Delay for closing time of the menu.
	   */
	  menuCloseDelay: _propTypes2.default.number,
	  /**
	   * Props to be passed to menu.
	   */
	  menuProps: _propTypes2.default.object,
	  /**
	   * Override style for menu.
	   */
	  menuStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when a list item is selected, or enter is pressed in the `TextField`.
	   *
	   * @param {string} chosenRequest Either the `TextField` input value, if enter is pressed in the `TextField`,
	   * or the dataSource object corresponding to the list item that was selected.
	   * @param {number} index The index in `dataSource` of the list item selected, or `-1` if enter is pressed in the
	   * `TextField`.
	   */
	  onNewRequest: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the user updates the `TextField`.
	   *
	   * @param {string} searchText The auto-complete's `searchText` value.
	   * @param {array} dataSource The auto-complete's `dataSource` array.
	   * @param {object} params Additional information linked the update.
	   */
	  onUpdateInput: _propTypes2.default.func,
	  /**
	   * Auto complete menu is open if true.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * If true, the list item is showed when a focus event triggers.
	   */
	  openOnFocus: _propTypes2.default.bool,
	  /**
	   * Props to be passed to popover.
	   */
	  popoverProps: _propTypes2.default.object,
	  /**
	   * Text being input to auto complete.
	   */
	  searchText: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Origin for location of target.
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Override the inline-styles of AutoComplete's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object
	} : {};
	
	
	AutoComplete.levenshteinDistance = function (searchText, key) {
	  var current = [];
	  var prev = void 0;
	  var value = void 0;
	
	  for (var i = 0; i <= key.length; i++) {
	    for (var j = 0; j <= searchText.length; j++) {
	      if (i && j) {
	        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
	      } else {
	        value = i + j;
	      }
	      prev = current[j];
	      current[j] = value;
	    }
	  }
	  return current.pop();
	};
	
	AutoComplete.noFilter = function () {
	  return true;
	};
	
	AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
	  return searchText !== '' && key.indexOf(searchText) !== -1;
	};
	
	AutoComplete.caseInsensitiveFilter = function (searchText, key) {
	  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	};
	
	AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
	  if (distanceLessThan === undefined) {
	    return AutoComplete.levenshteinDistance;
	  } else if (typeof distanceLessThan !== 'number') {
	    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
	  }
	
	  return function (s, k) {
	    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
	  };
	};
	
	AutoComplete.fuzzyFilter = function (searchText, key) {
	  var compareString = key.toLowerCase();
	  searchText = searchText.toLowerCase();
	
	  var searchTextIndex = 0;
	  for (var index = 0; index < key.length; index++) {
	    if (compareString[index] === searchText[searchTextIndex]) {
	      searchTextIndex += 1;
	    }
	  }
	
	  return searchTextIndex === searchText.length;
	};
	
	AutoComplete.Item = _MenuItem2.default;
	AutoComplete.Divider = _Divider2.default;
	
	exports.default = AutoComplete;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AutoComplete = __webpack_require__(1658);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoComplete2.default;

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var backgroundColor = props.backgroundColor,
	      color = props.color,
	      size = props.size;
	  var avatar = context.muiTheme.avatar;
	
	
	  var styles = {
	    root: {
	      color: color || avatar.color,
	      backgroundColor: backgroundColor || avatar.backgroundColor,
	      userSelect: 'none',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      fontSize: size / 2,
	      borderRadius: '50%',
	      height: size,
	      width: size
	    },
	    icon: {
	      color: color || avatar.color,
	      width: size * 0.6,
	      height: size * 0.6,
	      fontSize: size * 0.6,
	      margin: size * 0.2
	    }
	  };
	
	  return styles;
	}
	
	var Avatar = function (_Component) {
	  (0, _inherits3.default)(Avatar, _Component);
	
	  function Avatar() {
	    (0, _classCallCheck3.default)(this, Avatar);
	    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          src = _props.src,
	          style = _props.style,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      if (src) {
	        return _react2.default.createElement('img', (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other, {
	          src: src,
	          className: className
	        }));
	      } else {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
	            className: className
	          }),
	          icon && _react2.default.cloneElement(icon, {
	            color: styles.icon.color,
	            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	          }),
	          this.props.children
	        );
	      }
	    }
	  }]);
	  return Avatar;
	}(_react.Component);
	
	Avatar.muiName = 'Avatar';
	Avatar.defaultProps = {
	  size: 40
	};
	Avatar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Avatar.propTypes =  false ? {
	  /**
	   * The backgroundColor of the avatar. Does not apply to image avatars.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Can be used, for instance, to render a letter inside the avatar.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root `div` or `img` element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The icon or letter's color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the SvgIcon or FontIcon to be used inside the avatar.
	   */
	  icon: _propTypes2.default.element,
	  /**
	   * This is the size of the avatar in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	   */
	  src: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Avatar;

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var primary = props.primary,
	      secondary = props.secondary;
	  var badge = context.muiTheme.badge;
	
	
	  var badgeBackgroundColor = void 0;
	  var badgeTextColor = void 0;
	
	  if (primary) {
	    badgeBackgroundColor = badge.primaryColor;
	    badgeTextColor = badge.primaryTextColor;
	  } else if (secondary) {
	    badgeBackgroundColor = badge.secondaryColor;
	    badgeTextColor = badge.secondaryTextColor;
	  } else {
	    badgeBackgroundColor = badge.color;
	    badgeTextColor = badge.textColor;
	  }
	
	  var radius = 12;
	  var radius2x = Math.floor(2 * radius);
	
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      fontWeight: badge.fontWeight,
	      fontSize: radius,
	      width: radius2x,
	      height: radius2x,
	      borderRadius: '50%',
	      backgroundColor: badgeBackgroundColor,
	      color: badgeTextColor
	    }
	  };
	}
	
	var Badge = function (_Component) {
	  (0, _inherits3.default)(Badge, _Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, (Badge.__proto__ || (0, _getPrototypeOf2.default)(Badge)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          badgeContent = _props.badgeContent,
	          badgeStyle = _props.badgeStyle,
	          children = _props.children,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
	          badgeContent
	        )
	      );
	    }
	  }]);
	  return Badge;
	}(_react.Component);
	
	Badge.defaultProps = {
	  primary: false,
	  secondary: false
	};
	Badge.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Badge.propTypes =  false ? {
	  /**
	   * This is the content rendered within the badge.
	   */
	  badgeContent: _propTypes2.default.node.isRequired,
	  /**
	   * Override the inline-styles of the badge element.
	   */
	  badgeStyle: _propTypes2.default.object,
	  /**
	   * The badge will be added relativelty to this node.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the badge will use the primary badge colors.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * If true, the badge will use the secondary badge colors.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Badge;

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Badge = __webpack_require__(1661);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge2.default;

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      width: '100%',
	      display: 'flex',
	      justifyContent: 'center',
	      backgroundColor: bottomNavigation.backgroundColor,
	      height: bottomNavigation.height
	    },
	    item: {
	      flex: '1'
	    }
	  };
	
	  return styles;
	}
	
	var BottomNavigation = function BottomNavigation(props, context) {
	  var children = props.children,
	      style = props.style,
	      selectedIndex = props.selectedIndex,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'style', 'selectedIndex']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var preparedChildren = _react.Children.map(children, function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      style: (0, _simpleAssign2.default)({}, styles.item, child.props.style),
	      selected: index === selectedIndex
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	    preparedChildren
	  );
	};
	
	BottomNavigation.propTypes =  false ? {
	  /**
	   * The `BottomNavigationItem`s to populate the element with.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The index of the currently selected navigation item.
	   */
	  selectedIndex: _propTypes2.default.number,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	BottomNavigation.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = BottomNavigation;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BottomNavigationItem = exports.BottomNavigation = undefined;
	
	var _BottomNavigation2 = __webpack_require__(1663);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(682);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.default = _BottomNavigation3.default;

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CardExpandable = __webpack_require__(684);
	
	var _CardExpandable2 = _interopRequireDefault(_CardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _this.handleExpanding = function (event) {
	      event.preventDefault();
	      var newExpandedState = !_this.state.expanded;
	      // no automatic state update when the component is controlled
	      if (_this.props.expanded === null) {
	        _this.setState({ expanded: newExpandedState });
	      }
	      if (_this.props.onExpandChange) {
	        _this.props.onExpandChange(newExpandedState);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          containerStyle = _props.containerStyle,
	          children = _props.children,
	          expandable = _props.expandable,
	          expandedProp = _props.expanded,
	          initiallyExpanded = _props.initiallyExpanded,
	          onExpandChange = _props.onExpandChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);
	
	
	      var lastElement = void 0;
	      var expanded = this.state.expanded;
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        var doClone = false;
	        var newChild = undefined;
	        var newProps = {};
	        var element = currentChild;
	        if (!currentChild || !currentChild.props) {
	          return null;
	        }
	        if (expanded === false && currentChild.props.expandable === true) return;
	        if (currentChild.props.actAsExpander === true) {
	          doClone = true;
	          newProps.onClick = _this2.handleExpanding;
	          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
	        }
	        if (currentChild.props.showExpandableButton === true) {
	          doClone = true;
	          newChild = _react2.default.createElement(_CardExpandable2.default, {
	            closeIcon: currentChild.props.closeIcon,
	            expanded: expanded,
	            onExpanding: _this2.handleExpanding,
	            openIcon: currentChild.props.openIcon,
	            iconStyle: currentChild.props.iconStyle
	          });
	        }
	        if (doClone) {
	          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	        }
	        lastElement = element;
	        return element;
	      }, this);
	
	      // If the last element is text or a title we should add
	      // 8px padding to the bottom of the card
	      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        zIndex: 1
	      }, style);
	      var containerMergedStyles = (0, _simpleAssign2.default)({
	        paddingBottom: addBottomPadding ? 8 : 0
	      }, containerStyle);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, { style: mergedStyles }),
	        _react2.default.createElement(
	          'div',
	          { style: containerMergedStyles },
	          newChildren
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card.defaultProps = {
	  expandable: false,
	  expanded: null,
	  initiallyExpanded: false
	};
	Card.propTypes =  false ? {
	  /**
	   * Can be used to render elements inside the Card.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If true, this card component is expandable. Can be set on any child of the `Card` component.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Whether this card is expanded.
	   * If `true` or `false` the component is controlled.
	   * if `null` the component is uncontrolled.
	   */
	  expanded: _propTypes2.default.bool,
	  /**
	   * Whether this card is initially expanded.
	   */
	  initiallyExpanded: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `expandable` state of the card has changed.
	   *
	   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
	   */
	  onExpandChange: _propTypes2.default.func,
	  /**
	   * If true, this card component will include a button to expand the card. `CardTitle`,
	   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
	   * of `Card` can implements `showExpandableButton` or forwards the property to a child
	   * component supporting it.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Card;

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(1665);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardHeader2 = __webpack_require__(685);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardTitle2 = __webpack_require__(688);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(686);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardText2 = __webpack_require__(687);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActions2 = __webpack_require__(683);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardExpandable2 = __webpack_require__(684);
	
	var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardText = _CardText3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardExpandable = _CardExpandable3.default;
	exports.default = _Card3.default;

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedSwitch = __webpack_require__(429);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(731);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(732);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
	    },
	    boxWhenSwitched: {
	      opacity: 0,
	      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
	      fill: checkbox.checkedColor
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          checked = _props.checked,
	          defaultChecked = _props.defaultChecked,
	          valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          iconStyle = _props2.iconStyle,
	          onCheck = _props2.onCheck,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Checkbox.propTypes =  false ? {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _propTypes2.default.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _propTypes2.default.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = Checkbox;

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _colorManipulator = __webpack_require__(97);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _cancel = __webpack_require__(723);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var chip = context.muiTheme.chip;
	
	
	  var backgroundColor = props.backgroundColor || chip.backgroundColor;
	  var focusColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.08);
	  var pressedColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.12);
	
	  return {
	    avatar: {
	      marginRight: -4
	    },
	    deleteIcon: {
	      color: state.deleteHovered ? (0, _colorManipulator.fade)(chip.deleteIconColor, 0.4) : chip.deleteIconColor,
	      cursor: 'pointer',
	      margin: '4px 4px 0px -8px'
	    },
	    label: {
	      color: props.labelColor || chip.textColor,
	      fontSize: chip.fontSize,
	      fontWeight: chip.fontWeight,
	      lineHeight: '32px',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap'
	    },
	    root: {
	      backgroundColor: state.clicked ? pressedColor : state.focused || state.hovered ? focusColor : backgroundColor,
	      borderRadius: 16,
	      boxShadow: state.clicked ? chip.shadow : null,
	      cursor: props.onClick ? 'pointer' : 'default',
	      display: 'flex',
	      whiteSpace: 'nowrap',
	      width: 'fit-content'
	    }
	  };
	}
	
	var Chip = function (_Component) {
	  (0, _inherits3.default)(Chip, _Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clicked: false,
	      deleteHovered: false,
	      focused: false,
	      hovered: false
	    }, _this.handleBlur = function (event) {
	      _this.setState({ clicked: false, focused: false });
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (_this.props.onClick || _this.props.onRequestDelete) {
	        _this.setState({ focused: true });
	      }
	      _this.props.onFocus(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused) {
	        _this.handleFocus();
	        _this.props.onFocus(event);
	      } else {
	        _this.handleBlur();
	      }
	
	      _this.props.onKeyboardFocus(event, keyboardFocused);
	    }, _this.handleKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'backspace') {
	        event.preventDefault();
	        if (_this.props.onRequestDelete) {
	          _this.props.onRequestDelete(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleMouseDown = function (event) {
	      // Only listen to left clicks
	      if (event.button === 0) {
	        event.stopPropagation();
	        if (_this.props.onClick) {
	          _this.setState({ clicked: true });
	        }
	      }
	      _this.props.onMouseDown(event);
	    }, _this.handleMouseEnter = function (event) {
	      if (_this.props.onClick) {
	        _this.setState({ hovered: true });
	      }
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseEnterDeleteIcon = function () {
	      _this.setState({ deleteHovered: true });
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({
	        clicked: false,
	        hovered: false
	      });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseLeaveDeleteIcon = function () {
	      _this.setState({ deleteHovered: false });
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onMouseUp(event);
	    }, _this.handleTouchTapDeleteIcon = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      _this.props.onRequestDelete(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onTouchEnd(event);
	    }, _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      if (_this.props.onClick) {
	        _this.setState({ clicked: true });
	      }
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Chip, [{
	    key: 'render',
	    value: function render() {
	      var buttonEventHandlers = {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchStart: this.handleTouchStart,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          containerElement = _props.containerElement,
	          style = _props.style,
	          className = _props.className,
	          deleteIconStyle = _props.deleteIconStyle,
	          labelStyle = _props.labelStyle,
	          labelColor = _props.labelColor,
	          backgroundColor = _props.backgroundColor,
	          onRequestDelete = _props.onRequestDelete,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'containerElement', 'style', 'className', 'deleteIconStyle', 'labelStyle', 'labelColor', 'backgroundColor', 'onRequestDelete']);
	
	
	      var deletable = this.props.onRequestDelete;
	      var avatar = null;
	
	      var deleteIcon = deletable ? _react2.default.createElement(_cancel2.default, {
	        color: styles.deleteIcon.color,
	        style: (0, _simpleAssign2.default)(styles.deleteIcon, deleteIconStyle),
	        onClick: this.handleTouchTapDeleteIcon,
	        onMouseEnter: this.handleMouseEnterDeleteIcon,
	        onMouseLeave: this.handleMouseLeaveDeleteIcon
	      }) : null;
	
	      var children = childrenProp;
	      var childCount = _react2.default.Children.count(children);
	
	      // If the first child is an avatar, extract it and style it
	      if (childCount > 1) {
	        children = _react2.default.Children.toArray(children);
	
	        if (_react2.default.isValidElement(children[0]) && children[0].type.muiName === 'Avatar') {
	          avatar = children.shift();
	
	          avatar = _react2.default.cloneElement(avatar, {
	            style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style),
	            size: 32
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, buttonEventHandlers, {
	          className: className,
	          containerElement: containerElement,
	          disableTouchRipple: true,
	          disableFocusRipple: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	          children
	        ),
	        deleteIcon
	      );
	    }
	  }]);
	  return Chip;
	}(_react.Component);
	
	Chip.defaultProps = {
	  containerElement: 'div', // Firefox doesn't support nested buttons
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {}
	};
	Chip.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
	Chip.propTypes =  false ? {
	  /**
	   * Override the background color of the chip.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Used to render elements inside the Chip.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * CSS `className` of the root element.
	   */
	  className: _propTypes2.default.node,
	  /**
	   * The element to use as the container for the Chip. Either a string to
	   * use a DOM element or a ReactElement.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Override the inline-styles of the delete icon.
	   */
	  deleteIconStyle: _propTypes2.default.object,
	  /**
	   * Override the label color.
	   */
	  labelColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `Chip` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the element.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /** @ignore */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
	   * @param {object} event `click` event targeting the element.
	   */
	  onRequestDelete: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Chip;

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autoPrefix = __webpack_require__(157);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return clampedValue / (max - min);
	}
	
	function getArcLength(fraction, props) {
	  return fraction * Math.PI * (props.size - props.thickness);
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      size = props.size,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      width: size,
	      height: size
	    },
	    wrapper: {
	      width: size,
	      height: size,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      width: size,
	      height: size,
	      position: 'relative'
	    },
	    path: {
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  (0, _inherits3.default)(CircularProgress, _Component);
	
	  function CircularProgress() {
	    (0, _classCallCheck3.default)(this, CircularProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path) {
	      var _this2 = this;
	
	      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-1, this.props);
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          innerStyle = _props.innerStyle,
	          size = _props.size,
	          thickness = _props.thickness,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            {
	              viewBox: '0 0 ' + size + ' ' + size,
	              style: prepareStyles(styles.svg)
	            },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: size / 2,
	              cy: size / 2,
	              r: (size - thickness) / 2,
	              fill: 'none',
	              strokeWidth: thickness,
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 40,
	  thickness: 3.5
	};
	CircularProgress.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CircularProgress.propTypes =  false ? {
	  /**
	   * Override the progress's color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _propTypes2.default.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _propTypes2.default.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _propTypes2.default.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The diameter of the progress in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Stroke width in pixels.
	   */
	  thickness: _propTypes2.default.number,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _propTypes2.default.number
	} : {};
	exports.default = CircularProgress;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(112);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _CalendarActionButtons = __webpack_require__(1671);
	
	var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);
	
	var _CalendarMonth = __webpack_require__(1672);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarYear = __webpack_require__(1674);
	
	var _CalendarYear2 = _interopRequireDefault(_CalendarYear);
	
	var _CalendarToolbar = __webpack_require__(1673);
	
	var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);
	
	var _DateDisplay = __webpack_require__(1675);
	
	var _DateDisplay2 = _interopRequireDefault(_DateDisplay);
	
	var _SlideIn = __webpack_require__(431);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	var _dateUtils = __webpack_require__(234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var daysArray = [].concat((0, _toConsumableArray3.default)(Array(7)));
	
	var Calendar = function (_Component) {
	  (0, _inherits3.default)(Calendar, _Component);
	
	  function Calendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      displayDate: undefined,
	      displayMonthDay: undefined,
	      selectedDate: undefined,
	      transitionDirection: 'left',
	      transitionEnter: true
	    }, _this.calendarRefs = {}, _this.handleTouchTapDay = function (event, date) {
	      _this.setSelectedDate(date);
	      if (_this.props.onTouchTapDay) _this.props.onTouchTapDay(event, date);
	    }, _this.handleMonthChange = function (months) {
	      var nextDirection = _this.context.muiTheme.isRtl ? 'right' : 'left';
	      var prevDirection = _this.context.muiTheme.isRtl ? 'left' : 'right';
	      var direction = months >= 0 ? nextDirection : prevDirection;
	      _this.setState({
	        transitionDirection: direction,
	        displayDate: _this.props.utils.addMonths(_this.state.displayDate, months)
	      });
	    }, _this.handleTouchTapYear = function (event, year) {
	      _this.setSelectedDate(_this.props.utils.setYear(_this.state.selectedDate, year), event);
	      _this.handleTouchTapDateDisplayMonthDay();
	    }, _this.handleTouchTapDateDisplayMonthDay = function () {
	      _this.setState({
	        displayMonthDay: true
	      });
	    }, _this.handleTouchTapDateDisplayYear = function () {
	      _this.setState({
	        displayMonthDay: false
	      });
	    }, _this.handleWindowKeyDown = function (event) {
	      if (_this.props.open) {
	        var nextArrow = _this.context.muiTheme.isRtl ? 'left' : 'right';
	        var prevArrow = _this.context.muiTheme.isRtl ? 'right' : 'left';
	        switch ((0, _keycode2.default)(event)) {
	          case 'up':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-7);
	            }
	            break;
	
	          case 'down':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(7);
	            }
	            break;
	
	          case nextArrow:
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(1);
	            }
	            break;
	
	          case prevArrow:
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-1);
	            }
	            break;
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Calendar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        displayDate: this.props.utils.getFirstDayOfMonth(this.props.initialDate),
	        selectedDate: this.props.initialDate,
	        displayMonthDay: !this.props.openToYearSelection
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.initialDate !== this.props.initialDate) {
	        var date = nextProps.initialDate || new Date();
	        this.setState({
	          displayDate: this.props.utils.getFirstDayOfMonth(date),
	          selectedDate: date
	        });
	      }
	    }
	  }, {
	    key: 'getMinDate',
	    value: function getMinDate() {
	      return this.props.minDate || this.props.utils.addYears(new Date(), -100);
	    }
	  }, {
	    key: 'getMaxDate',
	    value: function getMaxDate() {
	      return this.props.maxDate || this.props.utils.addYears(new Date(), 100);
	    }
	  }, {
	    key: 'getSelectedDate',
	    value: function getSelectedDate() {
	      return this.state.selectedDate;
	    }
	  }, {
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      if (!this.state.displayMonthDay) {
	        return false;
	      }
	
	      if (this.calendarRefs.calendar) {
	        return this.calendarRefs.calendar.isSelectedDateDisabled();
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'addSelectedDays',
	    value: function addSelectedDays(days) {
	      this.setSelectedDate(this.props.utils.addDays(this.state.selectedDate, days));
	    }
	  }, {
	    key: 'addSelectedMonths',
	    value: function addSelectedMonths(months) {
	      this.setSelectedDate(this.props.utils.addMonths(this.state.selectedDate, months));
	    }
	  }, {
	    key: 'addSelectedYears',
	    value: function addSelectedYears(years) {
	      this.setSelectedDate(this.props.utils.addYears(this.state.selectedDate, years));
	    }
	  }, {
	    key: 'setDisplayDate',
	    value: function setDisplayDate(date, newSelectedDate) {
	      var newDisplayDate = this.props.utils.getFirstDayOfMonth(date);
	
	      if (newDisplayDate !== this.state.displayDate) {
	        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
	        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
	        var direction = newDisplayDate > this.state.displayDate ? nextDirection : prevDirection;
	        this.setState({
	          displayDate: newDisplayDate,
	          transitionDirection: direction,
	          selectedDate: newSelectedDate || this.state.selectedDate
	        });
	      }
	    }
	  }, {
	    key: 'setSelectedDate',
	    value: function setSelectedDate(date) {
	      var adjustedDate = date;
	      var minDate = this.getMinDate();
	      var maxDate = this.getMaxDate();
	      if ((0, _dateUtils.isBeforeDate)(date, minDate)) {
	        adjustedDate = minDate;
	      } else if ((0, _dateUtils.isAfterDate)(date, maxDate)) {
	        adjustedDate = maxDate;
	      }
	
	      var newDisplayDate = this.props.utils.getFirstDayOfMonth(adjustedDate);
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setDisplayDate(newDisplayDate, adjustedDate);
	      } else {
	        this.setState({
	          selectedDate: adjustedDate
	        });
	      }
	    }
	  }, {
	    key: 'getToolbarInteractions',
	    value: function getToolbarInteractions() {
	      return {
	        prevMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMinDate()) > 0,
	        nextMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMaxDate()) < 0
	      };
	    }
	  }, {
	    key: 'yearSelector',
	    value: function yearSelector() {
	      if (!this.props.disableYearSelection) {
	        return _react2.default.createElement(_CalendarYear2.default, {
	          key: 'years',
	          DateTimeFormat: this.props.DateTimeFormat,
	          locale: this.props.locale,
	          onTouchTapYear: this.handleTouchTapYear,
	          selectedDate: this.state.selectedDate,
	          minDate: this.getMinDate(),
	          maxDate: this.getMaxDate(),
	          utils: this.props.utils
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var hideCalendarDate = this.props.hideCalendarDate;
	
	      var toolbarInteractions = this.getToolbarInteractions();
	      var isLandscape = this.props.mode === 'landscape';
	      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;
	
	
	      var styles = {
	        root: {
	          color: calendarTextColor,
	          userSelect: 'none',
	          width: !hideCalendarDate && isLandscape ? 479 : 310
	        },
	        calendar: {
	          display: 'flex',
	          flexDirection: 'column'
	        },
	        calendarContainer: {
	          display: 'flex',
	          alignContent: 'space-between',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          fontSize: 12,
	          fontWeight: 400,
	          padding: '0px 8px',
	          transition: _transitions2.default.easeOut()
	        },
	        yearContainer: {
	          display: 'flex',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          height: 272,
	          marginTop: 10,
	          overflow: 'hidden',
	          width: 310
	        },
	        weekTitle: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'space-between',
	          fontWeight: '500',
	          height: 20,
	          lineHeight: '15px',
	          opacity: '0.5',
	          textAlign: 'center'
	        },
	        weekTitleDay: {
	          width: 42
	        },
	        transitionSlide: {
	          height: 214
	        }
	      };
	
	      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);
	
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          DateTimeFormat = _props.DateTimeFormat,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          okLabel = _props.okLabel,
	          onTouchTapCancel = _props.onTouchTapCancel,
	          onTouchTapOk = _props.onTouchTapOk,
	          utils = _props.utils;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleWindowKeyDown
	        }),
	        !hideCalendarDate && _react2.default.createElement(_DateDisplay2.default, {
	          DateTimeFormat: DateTimeFormat,
	          disableYearSelection: this.props.disableYearSelection,
	          onTouchTapMonthDay: this.handleTouchTapDateDisplayMonthDay,
	          onTouchTapYear: this.handleTouchTapDateDisplayYear,
	          locale: locale,
	          monthDaySelected: this.state.displayMonthDay,
	          mode: this.props.mode,
	          selectedDate: this.state.selectedDate
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.calendar) },
	          this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.calendarContainer) },
	            _react2.default.createElement(_CalendarToolbar2.default, {
	              DateTimeFormat: DateTimeFormat,
	              locale: locale,
	              displayDate: this.state.displayDate,
	              onMonthChange: this.handleMonthChange,
	              prevMonth: toolbarInteractions.prevMonth,
	              nextMonth: toolbarInteractions.nextMonth
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.weekTitle) },
	              daysArray.map(function (event, i) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: i, style: weekTitleDayStyle },
	                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _SlideIn2.default,
	              { direction: this.state.transitionDirection, style: styles.transitionSlide },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                DateTimeFormat: DateTimeFormat,
	                locale: locale,
	                displayDate: this.state.displayDate,
	                firstDayOfWeek: this.props.firstDayOfWeek,
	                key: this.state.displayDate.toDateString(),
	                minDate: this.getMinDate(),
	                maxDate: this.getMaxDate(),
	                onTouchTapDay: this.handleTouchTapDay,
	                ref: function ref(_ref2) {
	                  return _this2.calendarRefs.calendar = _ref2;
	                },
	                selectedDate: this.state.selectedDate,
	                shouldDisableDate: this.props.shouldDisableDate,
	                utils: utils
	              })
	            )
	          ),
	          !this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.yearContainer) },
	            this.yearSelector()
	          ),
	          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
	            autoOk: this.props.autoOk,
	            cancelLabel: cancelLabel,
	            okLabel: okLabel,
	            onTouchTapCancel: onTouchTapCancel,
	            onTouchTapOk: onTouchTapOk
	          })
	        )
	      );
	    }
	  }]);
	  return Calendar;
	}(_react.Component);
	
	Calendar.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  disableYearSelection: false,
	  initialDate: new Date(),
	  locale: 'en-US',
	  utils: _dateUtils.defaultUtils
	};
	Calendar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Calendar.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  disableYearSelection: _propTypes2.default.bool,
	  firstDayOfWeek: _propTypes2.default.number,
	  hideCalendarDate: _propTypes2.default.bool,
	  initialDate: _propTypes2.default.object,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  okLabel: _propTypes2.default.node,
	  onTouchTapCancel: _propTypes2.default.func,
	  onTouchTapDay: _propTypes2.default.func,
	  onTouchTapOk: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  openToYearSelection: _propTypes2.default.bool,
	  shouldDisableDate: _propTypes2.default.func,
	  utils: _propTypes2.default.object
	} : {};
	exports.default = Calendar;

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarActionButton = function (_Component) {
	  (0, _inherits3.default)(CalendarActionButton, _Component);
	
	  function CalendarActionButton() {
	    (0, _classCallCheck3.default)(this, CalendarActionButton);
	    return (0, _possibleConstructorReturn3.default)(this, (CalendarActionButton.__proto__ || (0, _getPrototypeOf2.default)(CalendarActionButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CalendarActionButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          okLabel = _props.okLabel;
	
	
	      var styles = {
	        root: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'flex-end',
	          margin: 0,
	          maxHeight: 48,
	          padding: 0
	        },
	        flatButtons: {
	          fontsize: 14,
	          margin: '4px 8px 8px 0px',
	          maxHeight: 36,
	          minWidth: 64,
	          padding: 0
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_FlatButton2.default, {
	          label: cancelLabel,
	          onClick: this.props.onTouchTapCancel,
	          primary: true,
	          style: styles.flatButtons
	        }),
	        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
	          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	          label: okLabel,
	          onClick: this.props.onTouchTapOk,
	          primary: true,
	          style: styles.flatButtons
	        })
	      );
	    }
	  }]);
	  return CalendarActionButton;
	}(_react.Component);
	
	CalendarActionButton.propTypes =  false ? {
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  okLabel: _propTypes2.default.node,
	  onTouchTapCancel: _propTypes2.default.func,
	  onTouchTapOk: _propTypes2.default.func
	} : {};
	exports.default = CalendarActionButton;

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateUtils = __webpack_require__(234);
	
	var _DayButton = __webpack_require__(1678);
	
	var _DayButton2 = _interopRequireDefault(_DayButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'flex-start',
	    fontWeight: 400,
	    height: 228,
	    lineHeight: 2,
	    position: 'relative',
	    textAlign: 'center',
	    MozPaddingStart: 0
	  },
	  week: {
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-around',
	    height: 34,
	    marginBottom: 2
	  }
	};
	
	var CalendarMonth = function (_Component) {
	  (0, _inherits3.default)(CalendarMonth, _Component);
	
	  function CalendarMonth() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarMonth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonth.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonth)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapDay = function (event, date) {
	      if (_this.props.onTouchTapDay) {
	        _this.props.onTouchTapDay(event, date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarMonth, [{
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      return this.selectedDateDisabled;
	    }
	  }, {
	    key: 'shouldDisableDate',
	    value: function shouldDisableDate(day) {
	      if (day === null) return false;
	      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
	      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	      return disabled;
	    }
	  }, {
	    key: 'getWeekElements',
	    value: function getWeekElements() {
	      var _this2 = this;
	
	      var weekArray = this.props.utils.getWeekArray(this.props.displayDate, this.props.firstDayOfWeek);
	
	      return weekArray.map(function (week, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: styles.week },
	          _this2.getDayElements(week, i)
	        );
	      }, this);
	    }
	  }, {
	    key: 'getDayElements',
	    value: function getDayElements(week, i) {
	      var _this3 = this;
	
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          selectedDate = _props.selectedDate;
	
	
	      return week.map(function (day, j) {
	        var isSameDate = (0, _dateUtils.isEqualDate)(selectedDate, day);
	        var disabled = _this3.shouldDisableDate(day);
	        var selected = !disabled && isSameDate;
	
	        if (isSameDate) {
	          _this3.selectedDateDisabled = disabled;
	        }
	
	        return _react2.default.createElement(_DayButton2.default, {
	          DateTimeFormat: DateTimeFormat,
	          locale: locale,
	          date: day,
	          disabled: disabled,
	          key: 'db' + (i + j),
	          onClick: _this3.handleTouchTapDay,
	          selected: selected
	        });
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        this.getWeekElements()
	      );
	    }
	  }]);
	  return CalendarMonth;
	}(_react.Component);
	
	CalendarMonth.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  autoOk: _propTypes2.default.bool,
	  displayDate: _propTypes2.default.object.isRequired,
	  firstDayOfWeek: _propTypes2.default.number,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  onTouchTapDay: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  shouldDisableDate: _propTypes2.default.func,
	  utils: _propTypes2.default.object.isRequired
	} : {};
	exports.default = CalendarMonth;

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(189);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _chevronLeft = __webpack_require__(725);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(726);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _SlideIn = __webpack_require__(431);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    backgroundColor: 'inherit',
	    height: 48
	  },
	  titleDiv: {
	    fontSize: 14,
	    fontWeight: '500',
	    textAlign: 'center',
	    width: '100%'
	  },
	  titleText: {
	    height: 'inherit',
	    paddingTop: 12
	  }
	};
	
	var CalendarToolbar = function (_Component) {
	  (0, _inherits3.default)(CalendarToolbar, _Component);
	
	  function CalendarToolbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarToolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarToolbar.__proto__ || (0, _getPrototypeOf2.default)(CalendarToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _this.handleTouchTapPrevMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(-1);
	      }
	    }, _this.handleTouchTapNextMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(1);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarToolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.displayDate !== this.props.displayDate) {
	        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
	        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
	        var direction = nextProps.displayDate > this.props.displayDate ? nextDirection : prevDirection;
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          displayDate = _props.displayDate;
	
	
	      var dateTimeFormatted = new DateTimeFormat(locale, {
	        month: 'long',
	        year: 'numeric'
	      }).format(displayDate);
	
	      var nextButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronLeft2.default, null) : _react2.default.createElement(_chevronRight2.default, null);
	      var prevButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronRight2.default, null) : _react2.default.createElement(_chevronLeft2.default, null);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.prevMonth,
	            onClick: this.handleTouchTapPrevMonth
	          },
	          prevButtonIcon
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            direction: this.state.transitionDirection,
	            style: styles.titleDiv
	          },
	          _react2.default.createElement(
	            'div',
	            { key: dateTimeFormatted, style: styles.titleText },
	            dateTimeFormatted
	          )
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.nextMonth,
	            onClick: this.handleTouchTapNextMonth
	          },
	          nextButtonIcon
	        )
	      );
	    }
	  }]);
	  return CalendarToolbar;
	}(_react.Component);
	
	CalendarToolbar.defaultProps = {
	  nextMonth: true,
	  prevMonth: true
	};
	CalendarToolbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CalendarToolbar.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  displayDate: _propTypes2.default.object.isRequired,
	  locale: _propTypes2.default.string.isRequired,
	  nextMonth: _propTypes2.default.bool,
	  onMonthChange: _propTypes2.default.func,
	  prevMonth: _propTypes2.default.bool
	} : {};
	exports.default = CalendarToolbar;

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _YearButton = __webpack_require__(1679);
	
	var _YearButton2 = _interopRequireDefault(_YearButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarYear = function (_Component) {
	  (0, _inherits3.default)(CalendarYear, _Component);
	
	  function CalendarYear() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarYear);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarYear.__proto__ || (0, _getPrototypeOf2.default)(CalendarYear)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapYear = function (event, year) {
	      if (_this.props.onTouchTapYear) {
	        _this.props.onTouchTapYear(event, year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarYear, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'getYears',
	    value: function getYears() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          selectedDate = _props.selectedDate,
	          utils = _props.utils;
	
	
	      var minYear = utils.getYear(minDate);
	      var maxYear = utils.getYear(maxDate);
	      var years = [];
	
	      for (var year = minYear; year <= maxYear; year++) {
	        var selected = utils.getYear(selectedDate) === year;
	        var selectedProps = {};
	        if (selected) {
	          selectedProps.ref = 'selectedYearButton';
	        }
	
	        var yearFormated = new DateTimeFormat(locale, {
	          year: 'numeric'
	        }).format(utils.setYear(selectedDate, year));
	
	        var yearButton = _react2.default.createElement(
	          _YearButton2.default,
	          (0, _extends3.default)({
	            key: 'yb' + year,
	            onClick: this.handleTouchTapYear,
	            selected: selected,
	            year: year,
	            utils: utils
	          }, selectedProps),
	          yearFormated
	        );
	
	        years.push(yearButton);
	      }
	
	      return years;
	    }
	  }, {
	    key: 'scrollToSelectedYear',
	    value: function scrollToSelectedYear() {
	      if (this.refs.selectedYearButton === undefined) {
	        return;
	      }
	
	      var container = _reactDom2.default.findDOMNode(this);
	      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);
	
	      var containerHeight = container.clientHeight;
	      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	      container.scrollTop = scrollYOffset;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          calendarYearBackgroundColor = _context$muiTheme.datePicker.calendarYearBackgroundColor;
	
	
	      var styles = {
	        root: {
	          backgroundColor: calendarYearBackgroundColor,
	          height: 'inherit',
	          lineHeight: '35px',
	          overflowX: 'hidden',
	          overflowY: 'scroll',
	          position: 'relative'
	        },
	        child: {
	          display: 'flex',
	          flexDirection: 'column',
	          justifyContent: 'center',
	          minHeight: '100%'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.child) },
	          this.getYears()
	        )
	      );
	    }
	  }]);
	  return CalendarYear;
	}(_react.Component);
	
	CalendarYear.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CalendarYear.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object.isRequired,
	  minDate: _propTypes2.default.object.isRequired,
	  onTouchTapYear: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  utils: _propTypes2.default.object.isRequired,
	  wordings: _propTypes2.default.object
	} : {};
	exports.default = CalendarYear;

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _SlideIn = __webpack_require__(431);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var datePicker = context.muiTheme.datePicker;
	  var selectedYear = state.selectedYear;
	
	  var isLandscape = props.mode === 'landscape';
	
	  var styles = {
	    root: {
	      width: isLandscape ? 165 : '100%',
	      height: isLandscape ? 330 : 'auto',
	      float: isLandscape ? 'left' : 'none',
	      fontWeight: 700,
	      display: 'inline-block',
	      backgroundColor: datePicker.headerColor,
	      borderTopLeftRadius: 2,
	      borderTopRightRadius: isLandscape ? 0 : 2,
	      borderBottomLeftRadius: isLandscape ? 2 : 0,
	      color: datePicker.textColor,
	      padding: 20,
	      boxSizing: 'border-box'
	    },
	    monthDay: {
	      display: 'block',
	      fontSize: 36,
	      lineHeight: '36px',
	      height: props.mode === 'landscape' ? '100%' : 38,
	      opacity: selectedYear ? 0.7 : 1,
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      fontWeight: '500'
	    },
	    monthDayTitle: {
	      cursor: !selectedYear ? 'default' : 'pointer',
	      width: '100%',
	      display: 'block'
	    },
	    year: {
	      margin: 0,
	      fontSize: 16,
	      fontWeight: '500',
	      lineHeight: '16px',
	      height: 16,
	      opacity: selectedYear ? 1 : 0.7,
	      transition: _transitions2.default.easeOut(),
	      marginBottom: 10
	    },
	    yearTitle: {
	      cursor: props.disableYearSelection || selectedYear ? 'default' : 'pointer'
	    }
	  };
	
	  return styles;
	}
	
	var DateDisplay = function (_Component) {
	  (0, _inherits3.default)(DateDisplay, _Component);
	
	  function DateDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DateDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDisplay.__proto__ || (0, _getPrototypeOf2.default)(DateDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedYear: false,
	      transitionDirection: 'up'
	    }, _this.handleTouchTapMonthDay = function () {
	      if (_this.props.onTouchTapMonthDay && _this.state.selectedYear) {
	        _this.props.onTouchTapMonthDay();
	      }
	
	      _this.setState({ selectedYear: false });
	    }, _this.handleTouchTapYear = function () {
	      if (_this.props.onTouchTapYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
	        _this.props.onTouchTapYear();
	      }
	
	      if (!_this.props.disableYearSelection) {
	        _this.setState({ selectedYear: true });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DateDisplay, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.monthDaySelected) {
	        this.setState({ selectedYear: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedDate !== this.props.selectedDate) {
	        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	
	      if (nextProps.monthDaySelected !== undefined) {
	        this.setState({
	          selectedYear: !nextProps.monthDaySelected
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          disableYearSelection = _props.disableYearSelection,
	          locale = _props.locale,
	          mode = _props.mode,
	          monthDaySelected = _props.monthDaySelected,
	          onTouchTapMonthDay = _props.onTouchTapMonthDay,
	          onTouchTapYear = _props.onTouchTapYear,
	          selectedDate = _props.selectedDate,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onTouchTapMonthDay', 'onTouchTapYear', 'selectedDate', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var year = new DateTimeFormat(locale, {
	        year: 'numeric'
	      }).format(selectedDate);
	
	      var dateTime = new DateTimeFormat(locale, {
	        month: 'short',
	        weekday: 'short',
	        day: '2-digit'
	      }).format(selectedDate);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root, style) }),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.year, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            { key: year, style: styles.yearTitle, onClick: this.handleTouchTapYear },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.monthDay, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            {
	              key: dateTime,
	              onClick: this.handleTouchTapMonthDay,
	              style: styles.monthDayTitle
	            },
	            dateTime
	          )
	        )
	      );
	    }
	  }]);
	  return DateDisplay;
	}(_react.Component);
	
	DateDisplay.defaultProps = {
	  disableYearSelection: false,
	  monthDaySelected: true
	};
	DateDisplay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DateDisplay.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  disableYearSelection: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  monthDaySelected: _propTypes2.default.bool,
	  onTouchTapMonthDay: _propTypes2.default.func,
	  onTouchTapYear: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  style: _propTypes2.default.object
	} : {};
	exports.default = DateDisplay;

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateUtils = __webpack_require__(234);
	
	var _DatePickerDialog = __webpack_require__(1677);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _TextField = __webpack_require__(154);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePicker = function (_Component) {
	  (0, _inherits3.default)(DatePicker, _Component);
	
	  function DatePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      date: undefined
	    }, _this.handleAccept = function (date) {
	      if (!_this.isControlled()) {
	        _this.setState({
	          date: date
	        });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(null, date);
	      }
	    }, _this.handleFocus = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	
	      if (!_this.props.disabled) {
	        setTimeout(function () {
	          _this.openDialog();
	        }, 0);
	      }
	    }, _this.formatDate = function (date) {
	      if (_this.props.locale) {
	        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
	        return new DateTimeFormat(_this.props.locale, {
	          day: 'numeric',
	          month: 'numeric',
	          year: 'numeric'
	        }).format(date);
	      } else {
	        return (0, _dateUtils.formatIso)(date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isControlled()) {
	        var newDate = this.getControlledDate(nextProps);
	        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
	          this.setState({
	            date: newDate
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate() {
	      return this.state.date;
	    }
	
	    /**
	     * Open the date-picker dialog programmatically from a parent.
	     */
	
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      /**
	       * if the date is not selected then set it to new date
	       * (get the current system date while doing so)
	       * else set it to the currently selected date
	       */
	      if (this.state.date !== undefined) {
	        this.setState({
	          dialogDate: this.getDate()
	        }, this.refs.dialogWindow.show);
	      } else {
	        this.setState({
	          dialogDate: new Date()
	        }, this.refs.dialogWindow.show);
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'getControlledDate',
	    value: function getControlledDate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      if (props.value instanceof Date) {
	        return props.value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          className = _props.className,
	          container = _props.container,
	          defaultDate = _props.defaultDate,
	          dialogContainerStyle = _props.dialogContainerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          formatDateProp = _props.formatDate,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onDismiss = _props.onDismiss,
	          onFocus = _props.onFocus,
	          onShow = _props.onShow,
	          onClick = _props.onClick,
	          openToYearSelection = _props.openToYearSelection,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onClick', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'textFieldStyle', 'utils']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var formatDate = formatDateProp || this.formatDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          onFocus: this.handleFocus,
	          onClick: this.handleTouchTap,
	          ref: 'input',
	          style: textFieldStyle,
	          value: this.state.date ? formatDate(this.state.date) : ''
	        })),
	        _react2.default.createElement(_DatePickerDialog2.default, {
	          DateTimeFormat: DateTimeFormat,
	          autoOk: autoOk,
	          cancelLabel: cancelLabel,
	          container: container,
	          containerStyle: dialogContainerStyle,
	          disableYearSelection: disableYearSelection,
	          firstDayOfWeek: firstDayOfWeek,
	          initialDate: this.state.dialogDate,
	          locale: locale,
	          maxDate: maxDate,
	          minDate: minDate,
	          mode: mode,
	          okLabel: okLabel,
	          onAccept: this.handleAccept,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          ref: 'dialogWindow',
	          shouldDisableDate: shouldDisableDate,
	          hideCalendarDate: hideCalendarDate,
	          openToYearSelection: openToYearSelection,
	          utils: utils
	        })
	      );
	    }
	  }]);
	  return DatePicker;
	}(_react.Component);
	
	DatePicker.defaultProps = {
	  autoOk: false,
	  container: 'dialog',
	  disabled: false,
	  disableYearSelection: false,
	  firstDayOfWeek: 1,
	  hideCalendarDate: false,
	  style: {},
	  openToYearSelection: false
	};
	DatePicker.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DatePicker.propTypes =  false ? {
	  /**
	   * Constructor for date formatting for the specified `locale`.
	   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
	   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
	   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
	   *
	   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
	   */
	  DateTimeFormat: _propTypes2.default.func,
	  /**
	   * If true, automatically accept and close the picker on select a date.
	   */
	  autoOk: _propTypes2.default.bool,
	  /**
	   * Override the default text of the 'Cancel' button.
	   */
	  cancelLabel: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Used to control how the Date Picker will be displayed when the input field is focused.
	   * `dialog` (default) displays the DatePicker as a dialog with a modal.
	   * `inline` displays the DatePicker below the input field (similar to auto complete).
	   */
	  container: _propTypes2.default.oneOf(['dialog', 'inline']),
	  /**
	   * This is the initial date value of the component.
	   * If either `value` or `valueLink` is provided they will override this
	   * prop with `value` taking precedence.
	   */
	  defaultDate: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of DatePickerDialog's Container element.
	   */
	  dialogContainerStyle: _propTypes2.default.object,
	  /**
	   * Disables the year selection in the date picker.
	   */
	  disableYearSelection: _propTypes2.default.bool,
	  /**
	   * Disables the DatePicker.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Used to change the first day of week. It varies from
	   * Saturday to Monday between different locales.
	   * The allowed range is 0 (Sunday) to 6 (Saturday).
	   * The default is `1`, Monday, as per ISO 8601.
	   */
	  firstDayOfWeek: _propTypes2.default.number,
	  /**
	   * This function is called to format the date displayed in the input field, and should return a string.
	   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
	   *
	   * @param {object} date Date object to be formatted.
	   * @returns {any} The formatted date.
	   */
	  formatDate: _propTypes2.default.func,
	  /**
	   * Hide date display
	   */
	  hideCalendarDate: _propTypes2.default.bool,
	  /**
	   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
	   * must provide a `DateTimeFormat` that supports the chosen `locale`.
	   */
	  locale: _propTypes2.default.string,
	  /**
	   * The ending of a range of valid dates. The range includes the endDate.
	   * The default value is current date + 100 years.
	   */
	  maxDate: _propTypes2.default.object,
	  /**
	   * The beginning of a range of valid dates. The range includes the startDate.
	   * The default value is current date - 100 years.
	   */
	  minDate: _propTypes2.default.object,
	  /**
	   * Tells the component to display the picker in portrait or landscape mode.
	   */
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  /**
	   * Override the default text of the 'OK' button.
	   */
	  okLabel: _propTypes2.default.node,
	  /**
	   * Callback function that is fired when the date value changes.
	   *
	   * @param {null} null Since there is no particular event associated with the change,
	   * the first argument will always be null.
	   * @param {object} date The new date.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when a touch tap event occurs on the Date Picker's `TextField`.
	   *
	   * @param {object} event TouchTap event targeting the `TextField`.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is dismissed.
	   */
	  onDismiss: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's `TextField` gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is shown.
	   */
	  onShow: _propTypes2.default.func,
	  /**
	   * If true sets the datepicker to open to year selection first.
	   */
	  openToYearSelection: _propTypes2.default.bool,
	  /**
	   * Callback function used to determine if a day's entry should be disabled on the calendar.
	   *
	   * @param {object} day Date object of a day.
	   * @returns {boolean} Indicates whether the day should be disabled.
	   */
	  shouldDisableDate: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of DatePicker's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object,
	  /**
	   * This object should contain methods needed to build the calendar system.
	   *
	   * Useful for building a custom calendar system. Refer to the
	   * [source code](https://github.com/callemall/material-ui/blob/master/src/DatePicker/dateUtils.js)
	   * and an [example implementation](https://github.com/alitaheri/material-ui-persian-date-picker-utils)
	   * for more information.
	   */
	  utils: _propTypes2.default.object,
	  /**
	   * Sets the date for the Date Picker programmatically.
	   */
	  value: _propTypes2.default.object
	} : {};
	exports.default = DatePicker;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(112);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Calendar = __webpack_require__(1670);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Popover = __webpack_require__(190);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(424);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _dateUtils = __webpack_require__(234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerDialog = function (_Component) {
	  (0, _inherits3.default)(DatePickerDialog, _Component);
	
	  function DatePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(DatePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.show = function () {
	      if (_this.props.onShow && !_this.state.open) {
	        _this.props.onShow();
	      }
	
	      _this.setState({
	        open: true
	      });
	    }, _this.dismiss = function () {
	      if (_this.props.onDismiss && _this.state.open) {
	        _this.props.onDismiss();
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleTouchTapDay = function () {
	      if (_this.props.autoOk) {
	        setTimeout(_this.handleTouchTapOk, 300);
	      }
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOk = function () {
	      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
	        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleWindowKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOk();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePickerDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          container = _props.container,
	          containerStyle = _props.containerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          initialDate = _props.initialDate,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onAccept = _props.onAccept,
	          onDismiss = _props.onDismiss,
	          onShow = _props.onShow,
	          openToYearSelection = _props.openToYearSelection,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          animation = _props.animation,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'animation', 'utils']);
	      var open = this.state.open;
	
	
	      var styles = {
	        dialogContent: {
	          width: !hideCalendarDate && mode === 'landscape' ? 479 : 310
	        },
	        dialogBodyContent: {
	          padding: 0,
	          minHeight: hideCalendarDate || mode === 'landscape' ? 330 : 434,
	          minWidth: hideCalendarDate || mode !== 'landscape' ? 310 : 479
	        }
	      };
	
	      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'root' }),
	        _react2.default.createElement(
	          Container,
	          {
	            anchorEl: this.refs.root // For Popover
	            , animation: animation || _PopoverAnimationVertical2.default // For Popover
	            , bodyStyle: styles.dialogBodyContent,
	            contentStyle: styles.dialogContent,
	            ref: 'dialog',
	            repositionOnUpdate: true,
	            open: open,
	            onRequestClose: this.handleRequestClose,
	            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
	          },
	          _react2.default.createElement(_reactEventListener2.default, {
	            target: 'window',
	            onKeyUp: this.handleWindowKeyUp
	          }),
	          _react2.default.createElement(_Calendar2.default, {
	            autoOk: autoOk,
	            DateTimeFormat: DateTimeFormat,
	            cancelLabel: cancelLabel,
	            disableYearSelection: disableYearSelection,
	            firstDayOfWeek: firstDayOfWeek,
	            initialDate: initialDate,
	            locale: locale,
	            onTouchTapDay: this.handleTouchTapDay,
	            maxDate: maxDate,
	            minDate: minDate,
	            mode: mode,
	            open: open,
	            ref: 'calendar',
	            onTouchTapCancel: this.handleTouchTapCancel,
	            onTouchTapOk: this.handleTouchTapOk,
	            okLabel: okLabel,
	            openToYearSelection: openToYearSelection,
	            shouldDisableDate: shouldDisableDate,
	            hideCalendarDate: hideCalendarDate,
	            utils: utils
	          })
	        )
	      );
	    }
	  }]);
	  return DatePickerDialog;
	}(_react.Component);
	
	DatePickerDialog.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  cancelLabel: 'Cancel',
	  container: 'dialog',
	  locale: 'en-US',
	  okLabel: 'OK',
	  openToYearSelection: false
	};
	DatePickerDialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DatePickerDialog.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func,
	  animation: _propTypes2.default.func,
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  container: _propTypes2.default.oneOf(['dialog', 'inline']),
	  containerStyle: _propTypes2.default.object,
	  disableYearSelection: _propTypes2.default.bool,
	  firstDayOfWeek: _propTypes2.default.number,
	  hideCalendarDate: _propTypes2.default.bool,
	  initialDate: _propTypes2.default.object,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  okLabel: _propTypes2.default.node,
	  onAccept: _propTypes2.default.func,
	  onDismiss: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  openToYearSelection: _propTypes2.default.bool,
	  shouldDisableDate: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  utils: _propTypes2.default.object
	} : {};
	exports.default = DatePickerDialog;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _dateUtils = __webpack_require__(234);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var date = props.date,
	      disabled = props.disabled,
	      selected = props.selected;
	  var hover = state.hover;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	
	
	  var labelColor = baseTheme.palette.textColor;
	  var buttonStateOpacity = 0;
	  var buttonStateTransform = 'scale(0)';
	
	  if (hover || selected) {
	    labelColor = datePicker.selectTextColor;
	    buttonStateOpacity = selected ? 1 : 0.6;
	    buttonStateTransform = 'scale(1)';
	  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
	    labelColor = datePicker.color;
	  }
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      fontWeight: '400',
	      opacity: disabled && '0.4',
	      padding: '4px 0px',
	      position: 'relative',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      width: 42
	    },
	    label: {
	      color: labelColor,
	      fontWeight: '400',
	      position: 'relative'
	    },
	    buttonState: {
	      backgroundColor: datePicker.selectColor,
	      borderRadius: '50%',
	      height: 34,
	      left: 4,
	      opacity: buttonStateOpacity,
	      position: 'absolute',
	      top: 0,
	      transform: buttonStateTransform,
	      transition: _transitions2.default.easeOut(),
	      width: 34
	    }
	  };
	}
	
	var DayButton = function (_Component) {
	  (0, _inherits3.default)(DayButton, _Component);
	
	  function DayButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DayButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DayButton.__proto__ || (0, _getPrototypeOf2.default)(DayButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this.handleMouseLeave = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (!_this.props.disabled && _this.props.onClick) {
	        _this.props.onClick(event, _this.props.date);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          date = _props.date,
	          disabled = _props.disabled,
	          locale = _props.locale,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'date', 'disabled', 'locale', 'onClick', 'selected']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return date ? _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onClick: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          new DateTimeFormat(locale, {
	            day: 'numeric'
	          }).format(date)
	        )
	      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
	    }
	  }]);
	  return DayButton;
	}(_react.Component);
	
	DayButton.defaultProps = {
	  selected: false,
	  disabled: false
	};
	DayButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DayButton.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  date: _propTypes2.default.object,
	  disabled: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func,
	  onKeyboardFocus: _propTypes2.default.func,
	  selected: _propTypes2.default.bool
	} : {};
	exports.default = DayButton;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var selected = props.selected,
	      year = props.year,
	      utils = props.utils;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	  var hover = state.hover;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      color: year === utils.getYear(new Date()) && datePicker.color,
	      display: 'block',
	      fontSize: 14,
	      margin: '0 auto',
	      position: 'relative',
	      textAlign: 'center',
	      lineHeight: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated)
	    },
	    label: {
	      alignSelf: 'center',
	      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
	      fontSize: selected ? 26 : 17,
	      fontWeight: hover ? 450 : selected ? 500 : 400,
	      position: 'relative',
	      top: -1
	    }
	  };
	}
	
	var YearButton = function (_Component) {
	  (0, _inherits3.default)(YearButton, _Component);
	
	  function YearButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, YearButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = YearButton.__proto__ || (0, _getPrototypeOf2.default)(YearButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hover: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hover: false });
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(YearButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          year = _props.year,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onClick', 'selected', 'year', 'utils']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onClick: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          children
	        )
	      );
	    }
	  }]);
	  return YearButton;
	}(_react.Component);
	
	YearButton.defaultProps = {
	  selected: false
	};
	YearButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	YearButton.propTypes =  false ? {
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  selected: _propTypes2.default.bool,
	  utils: _propTypes2.default.object.isRequired,
	  year: _propTypes2.default.number.isRequired
	} : {};
	exports.default = YearButton;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DatePicker = __webpack_require__(1676);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DatePicker2.default;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(112);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(709);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(710);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TransitionGroup = __webpack_require__(248);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransitionItem = function (_Component) {
	  (0, _inherits3.default)(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate(0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TransitionItem.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : {};
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent,
	      open = props.open;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      spacing = _context$muiTheme$bas.spacing,
	      palette = _context$muiTheme$bas.palette,
	      dialog = _context$muiTheme.dialog,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden',
	      borderTop: autoScrollBodyContent ? borderScroll : 'none',
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  (0, _inherits3.default)(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    (0, _classCallCheck3.default)(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
	  }
	
	  (0, _createClass3.default)(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
	          autoScrollBodyContent = _props2.autoScrollBodyContent,
	          bodyStyle = _props2.bodyStyle,
	          open = _props2.open,
	          repositionOnUpdate = _props2.repositionOnUpdate,
	          title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	        if (maxDialogContentHeight > dialogWindowHeight) {
	          dialogContent.style.borderBottom = 'none';
	          dialogContent.style.borderTop = 'none';
	        }
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          actionsContainerClassName = _props3.actionsContainerClassName,
	          actionsContainerStyle = _props3.actionsContainerStyle,
	          bodyClassName = _props3.bodyClassName,
	          bodyStyle = _props3.bodyStyle,
	          children = _props3.children,
	          className = _props3.className,
	          contentClassName = _props3.contentClassName,
	          contentStyle = _props3.contentStyle,
	          overlayClassName = _props3.overlayClassName,
	          overlayStyle = _props3.overlayStyle,
	          open = _props3.open,
	          paperClassName = _props3.paperClassName,
	          paperProps = _props3.paperProps,
	          style = _props3.style,
	          titleClassName = _props3.titleClassName,
	          titleStyle = _props3.titleStyle,
	          title = _props3.title;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _TransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              (0, _extends3.default)({ className: paperClassName, zDepth: 4 }, paperProps),
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onClick: this.handleTouchTapOverlay
	        })
	      );
	    }
	  }]);
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DialogInline.propTypes =  false ? {
	  actions: _propTypes2.default.node,
	  actionsContainerClassName: _propTypes2.default.string,
	  actionsContainerStyle: _propTypes2.default.object,
	  autoDetectWindowHeight: _propTypes2.default.bool,
	  autoScrollBodyContent: _propTypes2.default.bool,
	  bodyClassName: _propTypes2.default.string,
	  bodyStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  contentClassName: _propTypes2.default.string,
	  contentStyle: _propTypes2.default.object,
	  modal: _propTypes2.default.bool,
	  onRequestClose: _propTypes2.default.func,
	  open: _propTypes2.default.bool.isRequired,
	  overlayClassName: _propTypes2.default.string,
	  overlayStyle: _propTypes2.default.object,
	  paperClassName: _propTypes2.default.string,
	  paperProps: _propTypes2.default.object,
	  repositionOnUpdate: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  title: _propTypes2.default.node,
	  titleClassName: _propTypes2.default.string,
	  titleStyle: _propTypes2.default.object
	} : {};
	
	var Dialog = function (_Component3) {
	  (0, _inherits3.default)(Dialog, _Component3);
	
	  function Dialog() {
	    var _ref3;
	
	    var _temp3, _this3, _ret3;
	
	    (0, _classCallCheck3.default)(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
	  }
	
	  (0, _createClass3.default)(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	  return Dialog;
	}(_react.Component);
	
	Dialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	Dialog.propTypes =  false ? {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _propTypes2.default.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _propTypes2.default.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _propTypes2.default.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _propTypes2.default.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _propTypes2.default.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * The CSS class name of the `Paper` element.
	   */
	  paperClassName: _propTypes2.default.string,
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  paperProps: _propTypes2.default.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = Dialog;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      prepareStyles = _context$muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	
	Divider.propTypes =  false ? {
	  /**
	   * If true, the `Divider` will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	Divider.defaultProps = {
	  inset: false
	};
	
	Divider.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Divider;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(112);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _autoPrefix = __webpack_require__(157);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(709);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openNavEventHandler = null;
	
	var Drawer = function (_Component) {
	  (0, _inherits3.default)(Drawer, _Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapOverlay = function (event) {
	      event.preventDefault();
	      _this.close('clickaway');
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
	        _this.close('escape');
	      }
	    }, _this.onBodyTouchStart = function (event) {
	      var swipeAreaWidth = _this.props.swipeAreaWidth;
	
	      var touchStartX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
	      var touchStartY = event.touches[0].pageY;
	
	      // Open only if swiping from far left (or right) while closed
	      if (swipeAreaWidth !== null && !_this.state.open) {
	        if (_this.props.openSecondary) {
	          // If openSecondary is true calculate from the far right
	          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
	        } else {
	          // If openSecondary is false calculate from the far left
	          if (touchStartX > swipeAreaWidth) return;
	        }
	      }
	
	      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
	        return;
	      }
	
	      _this.maybeSwiping = true;
	      _this.touchStartX = touchStartX;
	      _this.touchStartY = touchStartY;
	
	      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _this.onBodyTouchMove = function (event) {
	      var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
	      var currentY = event.touches[0].pageY;
	
	      if (_this.state.swiping) {
	        event.preventDefault();
	        _this.setPosition(_this.getTranslateX(currentX));
	      } else if (_this.maybeSwiping) {
	        var dXAbs = Math.abs(currentX - _this.touchStartX);
	        var dYAbs = Math.abs(currentY - _this.touchStartY);
	        // If the user has moved his thumb ten pixels in either direction,
	        // we can safely make an assumption about whether he was intending
	        // to swipe or scroll.
	        var threshold = 10;
	
	        if (dXAbs > threshold && dYAbs <= threshold) {
	          _this.swipeStartX = currentX;
	          _this.setState({
	            swiping: _this.state.open ? 'closing' : 'opening'
	          });
	          _this.setPosition(_this.getTranslateX(currentX));
	        } else if (dXAbs <= threshold && dYAbs > threshold) {
	          _this.onBodyTouchEnd();
	        }
	      }
	    }, _this.onBodyTouchEnd = function (event) {
	      if (_this.state.swiping) {
	        var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
	        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();
	
	        _this.maybeSwiping = false;
	        var swiping = _this.state.swiping;
	        _this.setState({
	          swiping: null
	        });
	
	        // We have to open or close after setting swiping to null,
	        // because only then CSS transition is enabled.
	        if (translateRatio > 0.5) {
	          if (swiping === 'opening') {
	            _this.setPosition(_this.getMaxTranslateX());
	          } else {
	            _this.close('swipe');
	          }
	        } else {
	          if (swiping === 'opening') {
	            _this.open('swipe');
	          } else {
	            _this.setPosition(0);
	          }
	        }
	      } else {
	        _this.maybeSwiping = false;
	      }
	
	      _this.removeBodyTouchListeners();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.maybeSwiping = false;
	      this.touchStartX = null;
	      this.touchStartY = null;
	      this.swipeStartX = null;
	
	      this.setState({
	        open: this.props.open !== null ? this.props.open : this.props.docked,
	        swiping: null
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If controlled then the open prop takes precedence.
	      if (nextProps.open !== null) {
	        this.setState({
	          open: nextProps.open
	        });
	        // Otherwise, if docked is changed, change the open state for when uncontrolled.
	      } else if (this.props.docked !== nextProps.docked) {
	        this.setState({
	          open: nextProps.docked
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disableSwipeHandling();
	      this.removeBodyTouchListeners();
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var muiTheme = this.context.muiTheme;
	      var theme = muiTheme.drawer;
	
	      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());
	
	      var styles = {
	        root: {
	          height: '100%',
	          width: this.getTranslatedWidth() || theme.width,
	          position: 'fixed',
	          zIndex: muiTheme.zIndex.drawer,
	          left: 0,
	          top: 0,
	          transform: 'translate(' + x + 'px, 0)',
	          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
	          backgroundColor: theme.color,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch' // iOS momentum scrolling
	        },
	        overlay: {
	          zIndex: muiTheme.zIndex.drawerOverlay,
	          pointerEvents: this.state.open ? 'auto' : 'none' // Bypass mouse events when left nav is closing.
	        },
	        rootWhenOpenRight: {
	          left: 'auto',
	          right: 0
	        }
	      };
	
	      return styles;
	    }
	  }, {
	    key: 'shouldShow',
	    value: function shouldShow() {
	      return this.state.open || !!this.state.swiping; // component is swiping
	    }
	  }, {
	    key: 'close',
	    value: function close(reason) {
	      if (this.props.open === null) this.setState({ open: false });
	      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
	      return this;
	    }
	  }, {
	    key: 'open',
	    value: function open(reason) {
	      if (this.props.open === null) this.setState({ open: true });
	      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
	      return this;
	    }
	  }, {
	    key: 'getTranslatedWidth',
	    value: function getTranslatedWidth() {
	      if (typeof this.props.width === 'string') {
	        if (!/^\d+(\.\d+)?%$/.test(this.props.width)) {
	          throw new Error('Not a valid percentage format.');
	        }
	        var width = parseFloat(this.props.width) / 100.0;
	        // We are doing our best on the Server to render a consistent UI, hence the
	        // default value of 10000
	        return typeof window !== 'undefined' ? width * window.innerWidth : 10000;
	      } else {
	        return this.props.width;
	      }
	    }
	  }, {
	    key: 'getMaxTranslateX',
	    value: function getMaxTranslateX() {
	      var width = this.getTranslatedWidth() || this.context.muiTheme.drawer.width;
	      return width + 10;
	    }
	  }, {
	    key: 'getTranslateMultiplier',
	    value: function getTranslateMultiplier() {
	      return this.props.openSecondary ? 1 : -1;
	    }
	  }, {
	    key: 'enableSwipeHandling',
	    value: function enableSwipeHandling() {
	      if (!this.props.docked) {
	        document.body.addEventListener('touchstart', this.onBodyTouchStart);
	        if (!openNavEventHandler) {
	          openNavEventHandler = this.onBodyTouchStart;
	        }
	      } else {
	        this.disableSwipeHandling();
	      }
	    }
	  }, {
	    key: 'disableSwipeHandling',
	    value: function disableSwipeHandling() {
	      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
	      if (openNavEventHandler === this.onBodyTouchStart) {
	        openNavEventHandler = null;
	      }
	    }
	  }, {
	    key: 'removeBodyTouchListeners',
	    value: function removeBodyTouchListeners() {
	      document.body.removeEventListener('touchmove', this.onBodyTouchMove);
	      document.body.removeEventListener('touchend', this.onBodyTouchEnd);
	      document.body.removeEventListener('touchcancel', this.onBodyTouchEnd);
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(translateX) {
	      var rtlTranslateMultiplier = this.context.muiTheme.isRtl ? -1 : 1;
	      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	      var transformCSS = 'translate(' + this.getTranslateMultiplier() * rtlTranslateMultiplier * translateX + 'px, 0)';
	      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
	      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
	    }
	  }, {
	    key: 'getTranslateX',
	    value: function getTranslateX(currentX) {
	      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          containerClassName = _props.containerClassName,
	          containerStyle = _props.containerStyle,
	          docked = _props.docked,
	          openSecondary = _props.openSecondary,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = this.getStyles();
	
	      var overlay = void 0;
	      if (!docked) {
	        overlay = _react2.default.createElement(_Overlay2.default, {
	          ref: 'overlay',
	          show: this.shouldShow(),
	          className: overlayClassName,
	          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
	          transitionEnabled: !this.state.swiping,
	          onClick: this.handleTouchTapOverlay
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: style
	        },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        overlay,
	        _react2.default.createElement(
	          _Paper2.default,
	          {
	            ref: 'clickAwayableElement',
	            zDepth: zDepth,
	            rounded: false,
	            transitionEnabled: !this.state.swiping,
	            className: containerClassName,
	            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return Drawer;
	}(_react.Component);
	
	Drawer.defaultProps = {
	  disableSwipeToOpen: false,
	  docked: true,
	  open: null,
	  openSecondary: false,
	  swipeAreaWidth: 30,
	  width: null,
	  zDepth: 2
	};
	Drawer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Drawer.propTypes =  false ? {
	  /**
	   * The contents of the `Drawer`
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The CSS class name of the container element.
	   */
	  containerClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If true, swiping sideways when the `Drawer` is closed will not open it.
	   */
	  disableSwipeToOpen: _propTypes2.default.bool,
	  /**
	   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
	   * clicking on a menu item will not close the `Drawer`.
	   */
	  docked: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
	   *
	   * @param {boolean} open If true, the `Drawer` was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
	   * 'escape' (on escape key press), and 'swipe' for close requests.
	   */
	  onRequestChange: _propTypes2.default.func,
	  /**
	   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
	   * into a controlled component.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * If true, the `Drawer` is positioned to open from the opposite side.
	   */
	  openSecondary: _propTypes2.default.bool,
	  /**
	   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The width of the left most (or right most) area in pixels where the `Drawer` can be
	   * swiped open from. Setting this to `null` spans that area to the entire page
	   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
	   * swipeable `Tabs`: use at your own risk).
	   */
	  swipeAreaWidth: _propTypes2.default.number,
	  /**
	   * The width of the `Drawer` in pixels or percentage in string format ex. `50%` to fill
	   * half of the window or `100%` and so on. Defaults to using the values from theme.
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * The zDepth of the `Drawer`.
	   */
	  zDepth: _propTypes4.default.zDepth
	
	} : {};
	exports.default = Drawer;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Drawer = __webpack_require__(1683);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer2.default;

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(303);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(1744);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(190);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(424);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _events = __webpack_require__(308);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _IconButton = __webpack_require__(189);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
	    },
	    iconChildren: {
	      fill: 'inherit'
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      height: spacing.desktopToolbarHeight + 'px',
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      overflow: 'hidden',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
	      textOverflow: 'ellipsis',
	      top: 0,
	      whiteSpace: 'nowrap'
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  (0, _inherits3.default)(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.rootNode
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.close(false);
	    }, _this.handleEscKeyDownMenu = function () {
	      _this.close(true);
	    }, _this.handleKeyDown = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'up':
	        case 'down':
	        case 'space':
	        case 'enter':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            anchorEl: _this.rootNode
	          });
	          break;
	      }
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      if (_this.props.multiple) {
	        if (!_this.state.open) {
	          _this.setState({ open: true });
	        }
	      } else {
	        event.persist();
	        _this.setState({
	          open: false
	        }, function () {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, index, child.props.value);
	          }
	
	          _this.close(_events2.default.isKeyboard(event));
	        });
	      }
	    }, _this.handleChange = function (event, value) {
	      if (_this.props.multiple && _this.props.onChange) {
	        _this.props.onChange(event, undefined, value);
	      }
	    }, _this.close = function (isKeyboard) {
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	
	        if (isKeyboard) {
	          var dropArrow = _this.arrowNode;
	          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
	          dropNode.focus();
	          dropArrow.setKeyboardFocus(true);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  (0, _createClass3.default)(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.rootNode
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'getInputNode',
	
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var rootNode = this.rootNode;
	
	      rootNode.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.rootNode
	          });
	        }
	      };
	
	      return rootNode;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.rootNode;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          animation = _props.animation,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProp = _props.menuStyle,
	          selectionRenderer = _props.selectionRenderer,
	          onClose = _props.onClose,
	          openImmediately = _props.openImmediately,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          value = _props.value,
	          iconButton = _props.iconButton,
	          anchorOrigin = _props.anchorOrigin,
	          targetOrigin = _props.targetOrigin,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton', 'anchorOrigin', 'targetOrigin']);
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      if (!multiple) {
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value === child.props.value) {
	            if (selectionRenderer) {
	              displayValue = selectionRenderer(value, child);
	            } else {
	              // This will need to be improved (in case primaryText is a node)
	              displayValue = child.props.label || child.props.primaryText;
	            }
	          }
	        });
	      } else {
	        var values = [];
	        var selectionRendererChildren = [];
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value && value.indexOf(child.props.value) > -1) {
	            if (selectionRenderer) {
	              values.push(child.props.value);
	              selectionRendererChildren.push(child);
	            } else {
	              values.push(child.props.label || child.props.primaryText);
	            }
	          }
	        });
	
	        displayValue = [];
	        if (selectionRenderer) {
	          displayValue = selectionRenderer(values, selectionRendererChildren);
	        } else {
	          displayValue = values.join(', ');
	        }
	      }
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onClick: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
	            displayValue
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              disabled: disabled,
	              onKeyDown: this.handleKeyDown,
	              ref: function ref(node) {
	                _this4.arrowNode = node;
	              },
	              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
	              iconStyle: styles.iconChildren
	            },
	            iconButton
	          ),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              multiple: multiple,
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              onEscKeyDown: this.handleEscKeyDownMenu,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap,
	              onChange: this.handleChange,
	              menuItemStyle: menuItemStyle,
	              selectedMenuItemStyle: selectedMenuItemStyle,
	              autoWidth: autoWidth,
	              width: !autoWidth && menuStyle ? menuStyle.width : null
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
	  openImmediately: false,
	  maxHeight: 500,
	  multiple: false,
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DropDownMenu.propTypes =  false ? {
	  /**
	   * This is the point on the anchor that the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides default `SvgIcon` dropdown arrow component.
	   */
	  iconButton: _propTypes2.default.node,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   * @param {any} menuItem The selected `MenuItem`.
	   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = DropDownMenu;

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(97);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(1687);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  (0, _inherits3.default)(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          children = _props.children,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          hoverColor = _props.hoverColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	      var _context$muiTheme = this.context.muiTheme,
	          borderRadius = _context$muiTheme.borderRadius,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: fullWidth ? '100%' : buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: borderRadius,
	        userSelect: 'none',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles,
	          key: 'iconCloned'
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { key: 'labelElement', label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FlatButton.propTypes =  false ? {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The element to use as the container for the FlatButton. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * FlatButton in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _propTypes2.default.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = FlatButton;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  (0, _inherits3.default)(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    (0, _classCallCheck3.default)(this, FlatButtonLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FlatButtonLabel.propTypes =  false ? {
	  label: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : {};
	exports.default = FlatButtonLabel;

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(97);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(420);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _childUtils = __webpack_require__(735);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var floatingActionButton = context.muiTheme.floatingActionButton;
	
	
	  var backgroundColor = props.backgroundColor || floatingActionButton.color;
	  var iconColor = floatingActionButton.iconColor;
	
	  if (props.disabled) {
	    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
	    iconColor = floatingActionButton.disabledTextColor;
	  } else if (props.secondary) {
	    backgroundColor = floatingActionButton.secondaryColor;
	    iconColor = floatingActionButton.secondaryIconColor;
	  }
	
	  return {
	    root: {
	      transition: _transitions2.default.easeOut(),
	      display: 'inline-block',
	      backgroundColor: 'transparent'
	    },
	    container: {
	      backgroundColor: backgroundColor,
	      transition: _transitions2.default.easeOut(),
	      height: floatingActionButton.buttonSize,
	      width: floatingActionButton.buttonSize,
	      padding: 0,
	      overflow: 'hidden',
	      borderRadius: '50%',
	      textAlign: 'center',
	      verticalAlign: 'bottom'
	    },
	    containerWhenMini: {
	      height: floatingActionButton.miniSize,
	      width: floatingActionButton.miniSize
	    },
	    overlay: {
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    overlayWhenHovered: {
	      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
	    },
	    icon: {
	      height: floatingActionButton.buttonSize,
	      lineHeight: floatingActionButton.buttonSize + 'px',
	      fill: iconColor,
	      color: iconColor
	    },
	    iconWhenMini: {
	      height: floatingActionButton.miniSize,
	      lineHeight: floatingActionButton.miniSize + 'px'
	    }
	  };
	}
	
	var FloatingActionButton = function (_Component) {
	  (0, _inherits3.default)(FloatingActionButton, _Component);
	
	  function FloatingActionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FloatingActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touch: false,
	      zDepth: undefined
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	      }
	      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.container.isKeyboardFocused()) {
	        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth + 1
	      });
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth
	      });
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
	      } else if (!_this.state.hovered) {
	        _this.setState({ zDepth: _this.props.zDepth });
	        _this.refs.overlay.style.backgroundColor = 'transparent';
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FloatingActionButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        zDepth: this.props.disabled ? 0 : this.props.zDepth
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextState = {};
	
	      if (nextProps.disabled !== this.props.disabled) {
	        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
	      }
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          className = _props.className,
	          childrenProp = _props.children,
	          disabled = _props.disabled,
	          disabledColor = _props.disabledColor,
	          mini = _props.mini,
	          secondary = _props.secondary,
	          iconStyle = _props.iconStyle,
	          iconClassName = _props.iconClassName,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'disabledColor', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (iconClassName) {
	        iconElement = _react2.default.createElement(_FontIcon2.default, {
	          className: iconClassName,
	          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	        });
	      }
	
	      var children = void 0;
	
	      if (childrenProp) {
	        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
	          return {
	            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
	          };
	        });
	      }
	
	      var buttonEventHandlers = disabled ? null : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth,
	          circle: true
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	            focusRippleColor: styles.icon.color,
	            touchRippleColor: styles.icon.color
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
	            },
	            iconElement,
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return FloatingActionButton;
	}(_react.Component);
	
	FloatingActionButton.defaultProps = {
	  disabled: false,
	  mini: false,
	  secondary: false,
	  zDepth: 2
	};
	FloatingActionButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FloatingActionButton.propTypes =  false ? {
	  /**
	   * This value will override the default background color for the button.
	   * However it will not override the default disabled background color.
	   * This has to be set separately using the disabledColor attribute.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * This is what displayed inside the floating action button; for example, a SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * This value will override the default background color for the button when it is disabled.
	   */
	  disabledColor: _propTypes2.default.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * The icon within the FloatingActionButton is a FontIcon component.
	   * This property is the classname of the icon to be displayed inside the button.
	   * An alternative to adding an iconClassName would be to manually insert a
	   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	   */
	  iconClassName: _propTypes2.default.string,
	  /**
	   * This is the equivalent to iconClassName except that it is used for
	   * overriding the inline-styles of the FontIcon component.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will be a small floating action button.
	   */
	  mini: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * If true, the button will use the secondary button colors.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The zDepth of the underlying `Paper` component.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = FloatingActionButton;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FloatingActionButton = __webpack_require__(1688);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FloatingActionButton2.default;

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var color = props.color,
	      hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  (0, _inherits3.default)(FontIcon, _Component);
	
	  function FontIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hoverColor = _props.hoverColor,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FontIcon.propTypes =  false ? {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = FontIcon;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    root: {
	      display: 'flex',
	      flexWrap: 'wrap',
	      margin: -props.padding / 2
	    },
	    item: {
	      boxSizing: 'border-box',
	      padding: props.padding / 2
	    }
	  };
	}
	
	var GridList = function (_Component) {
	  (0, _inherits3.default)(GridList, _Component);
	
	  function GridList() {
	    (0, _classCallCheck3.default)(this, GridList);
	    return (0, _possibleConstructorReturn3.default)(this, (GridList.__proto__ || (0, _getPrototypeOf2.default)(GridList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cols = _props.cols,
	          padding = _props.padding,
	          cellHeight = _props.cellHeight,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (_react2.default.isValidElement(currentChild) && currentChild.type.muiName === 'Subheader') {
	          return currentChild;
	        }
	        var childCols = currentChild.props.cols || 1;
	        var childRows = currentChild.props.rows || 1;
	        var itemStyle = (0, _simpleAssign2.default)({}, styles.item, {
	          width: 100 / cols * childCols + '%',
	          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + padding
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { style: prepareStyles(itemStyle) },
	          currentChild
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles(mergedRootStyles) }, other),
	        wrappedChildren
	      );
	    }
	  }]);
	  return GridList;
	}(_react.Component);
	
	GridList.defaultProps = {
	  cols: 2,
	  padding: 4,
	  cellHeight: 180
	};
	GridList.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	GridList.propTypes =  false ? {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * Number of px for the padding/spacing between items.
	   */
	  padding: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = GridList;

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GridTile = exports.GridList = undefined;
	
	var _GridList2 = __webpack_require__(1691);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(693);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.default = _GridList3.default;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(420);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(711);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(735);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'default'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  (0, _inherits3.default)(IconButton, _Component);
	
	  function IconButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      // Not to be confonded with the touch property.
	      // This state is to determined if it's a mobile device.
	      touch: false,
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.button.isKeyboardFocused()) {
	        _this.hideTooltip();
	      }
	      _this.setState({ hovered: false });
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus,
	          onBlur = _this$props.onBlur,
	          onKeyboardFocus = _this$props.onKeyboardFocus;
	
	      if (isKeyboardFocused && !disabled) {
	        _this.showTooltip();
	        if (onFocus) {
	          onFocus(event);
	        }
	      } else {
	        _this.hideTooltip();
	        if (onBlur) {
	          onBlur(event);
	        }
	      }
	
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      if (onKeyboardFocus) {
	        onKeyboardFocus(event, isKeyboardFocused);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({ hovered: false });
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          hoveredStyle = _props.hoveredStyle,
	          disableTouchRipple = _props.disableTouchRipple,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipPositionProp = _props.tooltipPosition,
	          tooltipStyles = _props.tooltipStyles,
	          touch = _props.touch,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor,
	            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);
	
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          ref: function ref(_ref2) {
	            return _this2.button = _ref2;
	          }
	        }, other, {
	          centerRipple: true,
	          disabled: disabled,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	IconButton.propTypes =  false ? {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when the component is hovered.
	   */
	  hoveredStyle: _propTypes2.default.object,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the icon element.
	   * Note: you can specify iconHoverColor as a String inside this object.
	   */
	  iconStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseOut: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _propTypes2.default.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes4.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _propTypes2.default.object,
	  /**
	   * If true, increase the tooltip element's size. Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _propTypes2.default.bool
	} : {};
	exports.default = IconButton;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(308);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Menu = __webpack_require__(303);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Popover = __webpack_require__(190);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function (_Component) {
	  (0, _inherits3.default)(IconMenu, _Component);
	
	  function IconMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    }, _this.handleItemTouchTap = function (event, child) {
	      if (_this.props.touchTapCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
	        var isKeyboard = _events2.default.isKeyboard(event);
	        _this.timerCloseId = setTimeout(function () {
	          _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	        }, _this.props.touchTapCloseDelay);
	      }
	
	      _this.props.onItemTouchTap(event, child);
	    }, _this.handleRequestClose = function (reason) {
	      _this.close(reason);
	    }, _this.handleEscKeyDownMenu = function (event) {
	      _this.close('escape', event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open != null) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: this.refs.iconMenuContainer
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerCloseId);
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.state.open;
	    }
	  }, {
	    key: 'close',
	    value: function close(reason, isKeyboard) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        return;
	      }
	
	      if (this.props.open !== null) {
	        this.props.onRequestChange(false, reason);
	      } else {
	        this.setState({ open: false }, function () {
	          // Set focus on the icon button when the menu close
	          if (isKeyboard) {
	            var iconButton = _this2.refs.iconButton;
	            _reactDom2.default.findDOMNode(iconButton).focus();
	            iconButton.setKeyboardFocus();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(reason, event) {
	      if (this.props.open !== null) {
	        this.props.onRequestChange(true, reason);
	
	        return this.setState({
	          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	          anchorEl: event.currentTarget
	        });
	      }
	
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          className = _props.className,
	          animated = _props.animated,
	          animation = _props.animation,
	          iconButtonElement = _props.iconButtonElement,
	          iconStyle = _props.iconStyle,
	          onItemTouchTap = _props.onItemTouchTap,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseUp = _props.onMouseUp,
	          onRequestChange = _props.onRequestChange,
	          onClick = _props.onClick,
	          listStyle = _props.listStyle,
	          menuStyle = _props.menuStyle,
	          style = _props.style,
	          targetOrigin = _props.targetOrigin,
	          touchTapCloseDelay = _props.touchTapCloseDelay,
	          useLayerForClickAway = _props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onClick', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'touchTapCloseDelay', 'useLayerForClickAway']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl;
	
	
	      var styles = {
	        root: {
	          display: 'inline-block',
	          position: 'relative'
	        },
	        menu: {
	          position: 'relative'
	        }
	      };
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);
	
	       false ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;
	
	      var iconButtonProps = {
	        onKeyboardFocus: onKeyboardFocus,
	        onClick: function onClick(event) {
	          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
	          if (iconButtonElement.props.onClick) {
	            iconButtonElement.props.onClick(event);
	          }
	        },
	        ref: 'iconButton'
	      };
	      if (iconStyle || iconButtonElement.props.iconStyle) {
	        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
	      }
	      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, other, {
	          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	          onEscKeyDown: this.handleEscKeyDownMenu,
	          onItemTouchTap: this.handleItemTouchTap,
	          style: mergedMenuStyles,
	          listStyle: listStyle
	        }),
	        this.props.children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'iconMenuContainer',
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          onMouseUp: onMouseUp,
	          onClick: onClick,
	          style: prepareStyles(mergedRootStyles)
	        },
	        iconButton,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            childContextTypes: this.constructor.childContextTypes,
	            useLayerForClickAway: useLayerForClickAway,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation,
	            context: this.context
	          },
	          menu
	        )
	      );
	    }
	  }]);
	  return IconMenu;
	}(_react.Component);
	
	IconMenu.muiName = 'IconMenu';
	IconMenu.defaultProps = {
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  animated: true,
	  multiple: false,
	  open: null,
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseUp: function onMouseUp() {},
	  onRequestChange: function onRequestChange() {},
	  onClick: function onClick() {},
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  touchTapCloseDelay: 200,
	  useLayerForClickAway: false
	};
	IconMenu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	IconMenu.propTypes =  false ? {
	  /**
	   * This is the point on the icon where the menu
	   * `targetOrigin` will attach.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * Should be used to pass `MenuItem` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * This is the `IconButton` to render. This button will open the menu.
	   */
	  iconButtonElement: _propTypes2.default.element.isRequired,
	  /**
	   * Override the inline-styles of the underlying icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the menu element.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, the value can an be array and allow the menu to be a multi-select.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `IconButton` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the `IconButton` element.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is selected with a touch-tap.
	   *
	   * @param {object} event TouchTap event targeting the selected menu item element.
	   * @param {object} child The selected element.
	   */
	  onItemTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
	   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `open` state of the menu is requested to be changed.
	   *
	   * @param {boolean} open If true, the menu was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
	   * for close requests.
	   */
	  onRequestChange: _propTypes2.default.func,
	  /**
	   * If true, the `IconMenu` is opened.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the menu which will stick to the menu
	   * origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Sets the delay in milliseconds before closing the
	   * menu when an item is clicked.
	   * If set to 0 then the auto close functionality
	   * will be disabled.
	   */
	  touchTapCloseDelay: _propTypes2.default.number,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying elements.
	   */
	  useLayerForClickAway: _propTypes2.default.bool
	} : {};
	exports.default = IconMenu;

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.IconMenu = undefined;
	
	var _IconMenu2 = __webpack_require__(1694);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _MenuItem2 = __webpack_require__(423);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconMenu = _IconMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _IconMenu3.default;

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      value = props.value;
	  var _context$muiTheme = context.muiTheme,
	      palette = _context$muiTheme.baseTheme.palette,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      height: 4,
	      display: 'block',
	      width: '100%',
	      backgroundColor: palette.primary3Color,
	      borderRadius: borderRadius,
	      margin: 0,
	      overflow: 'hidden'
	    },
	    bar: {
	      height: '100%'
	    },
	    barFragment1: {},
	    barFragment2: {}
	  };
	
	  if (props.mode === 'indeterminate') {
	    styles.barFragment1 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
	    };
	
	    styles.barFragment2 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
	    };
	  } else {
	    styles.bar.backgroundColor = props.color || palette.primary1Color;
	    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
	    styles.bar.width = getRelativeValue(value, min, max) + '%';
	  }
	
	  return styles;
	}
	
	var LinearProgress = function (_Component) {
	  (0, _inherits3.default)(LinearProgress, _Component);
	
	  function LinearProgress() {
	    (0, _classCallCheck3.default)(this, LinearProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LinearProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timers = {};
	
	      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]], 0);
	
	      this.timers.bar2 = setTimeout(function () {
	        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]], 0);
	      }, 850);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timers.bar1);
	      clearTimeout(this.timers.bar2);
	    }
	  }, {
	    key: 'barUpdate',
	    value: function barUpdate(id, step, barElement, stepValues, timeToNextStep) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      timeToNextStep = timeToNextStep || 420;
	      step = step || 0;
	      step %= 4;
	
	      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
	      var left = this.context.muiTheme.isRtl ? 'right' : 'left';
	
	      if (step === 0) {
	        barElement.style[left] = stepValues[0][0] + '%';
	        barElement.style[right] = stepValues[0][1] + '%';
	      } else if (step === 1) {
	        barElement.style.transitionDuration = '840ms';
	      } else if (step === 2) {
	        barElement.style[left] = stepValues[1][0] + '%';
	        barElement.style[right] = stepValues[1][1] + '%';
	      } else if (step === 3) {
	        barElement.style.transitionDuration = '0ms';
	      }
	      this.timers[id] = setTimeout(function () {
	        return _this3.barUpdate(id, step + 1, barElement, stepValues);
	      }, timeToNextStep);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.bar) },
	          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
	          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
	        )
	      );
	    }
	  }]);
	  return LinearProgress;
	}(_react.Component);
	
	LinearProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100
	};
	LinearProgress.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	LinearProgress.propTypes =  false ? {
	  /**
	   * The color of the progress bar, defaults to
	   * primary color of theme.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _propTypes2.default.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _propTypes2.default.number,
	  /**
	   * The mode of show your progress, indeterminate for when
	   * there is no value for progress.
	   */
	  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _propTypes2.default.number
	} : {};
	exports.default = LinearProgress;

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinearProgress = __webpack_require__(1696);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinearProgress2.default;

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(421);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedList = function NestedList(props) {
	  var children = props.children,
	      open = props.open,
	      nestedLevel = props.nestedLevel,
	      style = props.style;
	
	
	  if (!open) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _List2.default,
	    { style: style },
	    _react.Children.map(children, function (child) {
	      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
	        nestedLevel: nestedLevel + 1
	      }) : child;
	    })
	  );
	};
	
	NestedList.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  nestedLevel: _propTypes2.default.number.isRequired,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = NestedList;

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeSelectable = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(421);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(422);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(694);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.default = _List3.default;

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HotKeyHolder = undefined;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  (0, _createClass3.default)(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	  return HotKeyHolder;
	}();

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Paper.propTypes =  false ? {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Set to true to generate a circular paper container.
	   */
	  circle: _propTypes2.default.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _propTypes2.default.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = Paper;

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(75);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverAnimationDefault = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationDefault, _Component);
	
	  function PopoverAnimationDefault() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationDefault, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return PopoverAnimationDefault;
	}(_react.Component);
	
	PopoverAnimationDefault.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationDefault.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	PopoverAnimationDefault.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = PopoverAnimationDefault;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;
	
	var _Popover2 = __webpack_require__(190);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _PopoverAnimationVertical2 = __webpack_require__(424);
	
	var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Popover = _Popover3.default;
	exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
	exports.default = _Popover3.default;

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(97);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      raisedButton = _context$muiTheme.raisedButton,
	      borderRadius = _context$muiTheme.borderRadius;
	  var disabled = props.disabled,
	      disabledBackgroundColor = props.disabledBackgroundColor,
	      disabledLabelColor = props.disabledLabelColor,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      label = props.label,
	      labelPosition = props.labelPosition,
	      primary = props.primary,
	      secondary = props.secondary,
	      style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  (0, _inherits3.default)(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          buttonStyle = _props.buttonStyle,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          disabledBackgroundColor = _props.disabledBackgroundColor,
	          disabledLabelColor = _props.disabledLabelColor,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          label = _props.label,
	          labelColor = _props.labelColor,
	          labelPosition = _props.labelPosition,
	          labelStyle = _props.labelStyle,
	          overlayStyle = _props.overlayStyle,
	          primary = _props.primary,
	          rippleStyle = _props.rippleStyle,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)), key: 'labelElement' },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style),
	        key: 'iconCloned'
	      });
	
	      // Place label before or after children.
	      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RaisedButton.propTypes =  false ? {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _propTypes2.default.object,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	    * The element to use as the container for the RaisedButton. Either a string to
	    * use a DOM element or a ReactElement. This is useful for wrapping the
	    * RaisedButton in a custom Link component. If a ReactElement is given, ensure
	    * that it passes all of its given props through to the underlying DOM
	    * element and renders its children prop for proper integration.
	    */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _propTypes2.default.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _propTypes2.default.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _propTypes2.default.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline style of the button overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = RaisedButton;

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _slicedToArray2 = __webpack_require__(357);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autoPrefix = __webpack_require__(157);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEWBOX_SIZE = 32;
	
	function getStyles(props) {
	  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
	  return {
	    root: {
	      position: 'absolute',
	      zIndex: 2,
	      width: props.size,
	      height: props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
	      opacity: props.status === 'hide' ? 0 : 1,
	      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
	    }
	  };
	}
	
	var RefreshIndicator = function (_Component) {
	  (0, _inherits3.default)(RefreshIndicator, _Component);
	
	  function RefreshIndicator() {
	    (0, _classCallCheck3.default)(this, RefreshIndicator);
	    return (0, _possibleConstructorReturn3.default)(this, (RefreshIndicator.__proto__ || (0, _getPrototypeOf2.default)(RefreshIndicator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RefreshIndicator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var paperSize = this.getPaperSize();
	
	      var childrenCmp = null;
	      if (this.props.status !== 'ready') {
	        var circleStyle = this.getCircleStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'div',
	          {
	            ref: 'wrapper',
	            style: prepareStyles({
	              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	              width: '100%',
	              height: '100%'
	            })
	          },
	          _react2.default.createElement(
	            'svg',
	            {
	              style: {
	                width: paperSize,
	                height: paperSize
	              },
	              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	            },
	            _react2.default.createElement('circle', (0, _extends3.default)({
	              ref: 'path',
	              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
	                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	              }))
	            }, circleStyle.attr))
	          )
	        );
	      } else {
	        var _circleStyle = this.getCircleStyle(paperSize);
	        var polygonStyle = this.getPolygonStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'svg',
	          {
	            style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2.default.createElement('circle', (0, _extends3.default)({
	            style: prepareStyles(_circleStyle.style)
	          }, _circleStyle.attr)),
	          _react2.default.createElement('polygon', (0, _extends3.default)({
	            style: prepareStyles(polygonStyle.style)
	          }, polygonStyle.attr))
	        );
	      }
	
	      return childrenCmp;
	    }
	  }, {
	    key: 'getTheme',
	    value: function getTheme() {
	      return this.context.muiTheme.refreshIndicator;
	    }
	  }, {
	    key: 'getPaddingSize',
	    value: function getPaddingSize() {
	      var padding = this.props.size * 0.1;
	      return padding;
	    }
	  }, {
	    key: 'getPaperSize',
	    value: function getPaperSize() {
	      return this.props.size - this.getPaddingSize() * 2;
	    }
	  }, {
	    key: 'getCircleAttr',
	    value: function getCircleAttr() {
	      return {
	        radiu: VIEWBOX_SIZE / 2 - 5,
	        originX: VIEWBOX_SIZE / 2,
	        originY: VIEWBOX_SIZE / 2,
	        strokeWidth: 3
	      };
	    }
	  }, {
	    key: 'getArcDeg',
	    value: function getArcDeg() {
	      var p = this.props.percentage / 100;
	
	      var beginDeg = p * 120;
	      var endDeg = p * 410;
	      return [beginDeg, endDeg];
	    }
	  }, {
	    key: 'getFactor',
	    value: function getFactor() {
	      var p = this.props.percentage / 100;
	      var p1 = Math.min(1, p / 0.4);
	
	      return p1;
	    }
	  }, {
	    key: 'getCircleStyle',
	    value: function getCircleStyle() {
	      var isLoading = this.props.status === 'loading';
	      var p1 = isLoading ? 1 : this.getFactor();
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	
	      var _getArcDeg = this.getArcDeg(),
	          _getArcDeg2 = (0, _slicedToArray3.default)(_getArcDeg, 2),
	          beginDeg = _getArcDeg2[0],
	          endDeg = _getArcDeg2[1];
	
	      var arcLen = (endDeg - beginDeg) * perimeter / 360;
	      var dashOffset = -beginDeg * perimeter / 360;
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	          strokeDashoffset: dashOffset,
	          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          strokeLinecap: 'round',
	          opacity: p1,
	          strokeWidth: circle.strokeWidth * p1,
	          fill: 'none'
	        },
	        attr: {
	          cx: circle.originX,
	          cy: circle.originY,
	          r: circle.radiu
	        }
	      };
	    }
	  }, {
	    key: 'getPolygonStyle',
	    value: function getPolygonStyle() {
	      var p1 = this.getFactor();
	      var circle = this.getCircleAttr();
	
	      var triangleCx = circle.originX + circle.radiu;
	      var triangleCy = circle.originY;
	      var dx = circle.strokeWidth * 7 / 4 * p1;
	      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	      var _getArcDeg3 = this.getArcDeg(),
	          _getArcDeg4 = (0, _slicedToArray3.default)(_getArcDeg3, 2),
	          endDeg = _getArcDeg4[1];
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          transform: 'rotate(' + endDeg + 'deg)',
	          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	          opacity: p1
	        },
	        attr: {
	          points: trianglePath
	        }
	      };
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      var currStep = (step || 0) % 3;
	
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	      var arcLen = perimeter * 0.64;
	
	      var strokeDasharray = void 0;
	      var strokeDashoffset = void 0;
	      var transitionDuration = void 0;
	
	      if (currStep === 0) {
	        strokeDasharray = '1, 200';
	        strokeDashoffset = 0;
	        transitionDuration = '0ms';
	      } else if (currStep === 1) {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -15;
	        transitionDuration = '750ms';
	      } else {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -(perimeter - 1);
	        transitionDuration = '850ms';
	      }
	
	      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
	      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
	      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, currStep + 1);
	      }, currStep ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', null);
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      this.rotateWrapperSecondTimer = setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          top = _props.top,
	          left = _props.left,
	          percentage = _props.percentage,
	          status = _props.status,
	          loadingColor = _props.loadingColor,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'top', 'left', 'percentage', 'status', 'loadingColor']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({
	          circle: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }, other),
	        this.renderChildren()
	      );
	    }
	  }]);
	  return RefreshIndicator;
	}(_react.Component);
	
	RefreshIndicator.defaultProps = {
	  percentage: 0,
	  size: 40,
	  status: 'hide'
	};
	RefreshIndicator.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RefreshIndicator.propTypes =  false ? {
	  /**
	   * Override the theme's color of the indicator while it's status is
	   * "ready" and it's percentage is less than 100.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * The absolute left position of the indicator in pixels.
	   */
	  left: _propTypes2.default.number.isRequired,
	  /**
	   * Override the theme's color of the indicator while
	   * it's status is "loading" or when it's percentage is 100.
	   */
	  loadingColor: _propTypes2.default.string,
	  /**
	   * The confirmation progress to fetch data. Max value is 100.
	   */
	  percentage: _propTypes2.default.number,
	  /**
	   * Size in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * The display status of the indicator. If the status is
	   * "ready", the indicator will display the ready state
	   * arrow. If the status is "loading", it will display
	   * the loading progress indicator. If the status is "hide",
	   * the indicator will be hidden.
	   */
	  status: _propTypes2.default.oneOf(['ready', 'loading', 'hide']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The absolute top position of the indicator in pixels.
	   */
	  top: _propTypes2.default.number.isRequired
	} : {};
	exports.default = RefreshIndicator;

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RefreshIndicator = __webpack_require__(1705);
	
	var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RefreshIndicator2.default;

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(154);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(692);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 8 : 0
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  (0, _inherits3.default)(SelectField, _Component);
	
	  function SelectField() {
	    (0, _classCallCheck3.default)(this, SelectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          iconStyle = _props.iconStyle,
	          id = _props.id,
	          underlineDisabledStyle = _props.underlineDisabledStyle,
	          underlineFocusStyle = _props.underlineFocusStyle,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          underlineStyle = _props.underlineStyle,
	          dropDownMenuProps = _props.dropDownMenuProps,
	          errorStyle = _props.errorStyle,
	          disabled = _props.disabled,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          hintStyle = _props.hintStyle,
	          hintText = _props.hintText,
	          fullWidth = _props.fullWidth,
	          errorText = _props.errorText,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyle = _props.menuStyle,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          selectionRenderer = _props.selectionRenderer,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'multiple', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'dropDownMenuProps', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'selectionRenderer', 'value']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        (0, _extends3.default)({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          (0, _extends3.default)({
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            menuItemStyle: menuItemStyle,
	            selectedMenuItemStyle: selectedMenuItemStyle,
	            underlineStyle: styles.hideDropDownUnderline,
	            listStyle: listStyle,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight,
	            multiple: multiple,
	            selectionRenderer: selectionRenderer
	          }, dropDownMenuProps),
	          children
	        )
	      );
	    }
	  }]);
	  return SelectField;
	}(_react.Component);
	
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false,
	  multiple: false
	};
	SelectField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SelectField.propTypes =  false ? {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Object that can handle and override any property of component DropDownMenu.
	   */
	  dropDownMenuProps: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item, or undefined
	   * if `multiple` is true.
	   * @param {any} payload If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Customize the rendering of the selected item.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   * @param {any} menuItem The selected `MenuItem`.
	   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = SelectField;

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(430);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    rest[_key2 - 3] = arguments[_key2];
	  }
	
	  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	var calculateAxis = function calculateAxis(axis, isRtl) {
	  if (isRtl) {
	    switch (axis) {
	      case 'x':
	        return 'x-reverse';
	      case 'x-reverse':
	        return 'x';
	    }
	  }
	  return axis;
	};
	
	function getPercent(value, min, max) {
	  var percent = (value - min) / (max - min);
	  if (isNaN(percent)) {
	    percent = 0;
	  }
	
	  return percent;
	}
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var axis = props.axis,
	      disabled = props.disabled,
	      max = props.max,
	      min = props.min;
	  var _context$muiTheme = context.muiTheme,
	      isRtl = _context$muiTheme.isRtl,
	      _context$muiTheme$sli = _context$muiTheme.slider,
	      handleColorZero = _context$muiTheme$sli.handleColorZero,
	      handleFillColor = _context$muiTheme$sli.handleFillColor,
	      handleSize = _context$muiTheme$sli.handleSize,
	      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
	      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
	      trackSize = _context$muiTheme$sli.trackSize,
	      trackColor = _context$muiTheme$sli.trackColor,
	      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
	      rippleColor = _context$muiTheme$sli.rippleColor,
	      selectionColor = _context$muiTheme$sli.selectionColor;
	
	
	  var fillGutter = handleSize / 2;
	  var disabledGutter = trackSize + handleSizeDisabled / 2;
	  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
	  var percent = getPercent(state.value, min, max);
	  var calculatedAxis = calculateAxis(axis, isRtl);
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[calculatedAxis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[calculatedAxis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[calculatedAxis], trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      directionInvariant: true,
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      directionInvariant: true,
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[calculatedAxis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
	      x: trackSize / 2 + 'px 0 0 0',
	      'x-reverse': trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
	    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: trackColor,
	      width: handleSizeDisabled,
	      height: handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: trackSize + 'px solid ' + handleColorZero,
	      backgroundColor: handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: handleSizeDisabled,
	      height: handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: trackSize + 'px solid ' + trackColorSelected
	    },
	    handleWhenActive: {
	      width: handleSizeActive,
	      height: handleSizeActive
	    },
	    ripple: {
	      height: handleSize,
	      width: handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -trackSize,
	      left: -trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -handleSize,
	      left: -handleSize
	    },
	    rippleColor: {
	      fill: percent === 0 ? handleColorZero : rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[calculatedAxis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[calculatedAxis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  (0, _inherits3.default)(Slider, _Component);
	
	  function Slider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slider);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      value: 0
	    }, _this.track = null, _this.handle = null, _this.resolveValue = function (value) {
	      var _this$props = _this.props,
	          max = _this$props.max,
	          min = _this$props.min;
	
	
	      if (value > max) {
	        return max;
	      }
	
	      if (value < min) {
	        return min;
	      }
	
	      return value;
	    }, _this.handleKeyDown = function (event) {
	      var _this$props2 = _this.props,
	          axis = _this$props2.axis,
	          min = _this$props2.min,
	          max = _this$props2.max,
	          step = _this$props2.step;
	      var isRtl = _this.context.muiTheme.isRtl;
	
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (calculatedAxis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (calculatedAxis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (calculatedAxis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (calculatedAxis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'min';
	          break;
	        case 'end':
	          action = 'max';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        switch (action) {
	          case 'decrease':
	            newValue = _this.state.value - step;
	            break;
	          case 'increase':
	            newValue = _this.state.value + step;
	            break;
	          case 'min':
	            newValue = min;
	            break;
	          case 'max':
	            newValue = max;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        newValue = _this.resolveValue(parseFloat(newValue.toFixed(5)));
	
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            value: newValue
	          });
	
	          if (_this.props.onChange) {
	            _this.props.onChange(event, newValue);
	          }
	        }
	      }
	    }, _this.handleDragMouseMove = function (event) {
	      _this.onDragUpdate(event, 'mouse');
	    }, _this.handleTouchMove = function (event) {
	      _this.onDragUpdate(event, 'touch');
	    }, _this.handleMouseEnd = function (event) {
	      document.removeEventListener('mousemove', _this.handleDragMouseMove);
	      document.removeEventListener('mouseup', _this.handleMouseEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchEnd = function (event) {
	      document.removeEventListener('touchmove', _this.handleTouchMove);
	      document.removeEventListener('touchup', _this.handleTouchEnd);
	      document.removeEventListener('touchend', _this.handleTouchEnd);
	      document.removeEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      var _this$props3 = _this.props,
	          axis = _this$props3.axis,
	          disabled = _this$props3.disabled;
	      var isRtl = _this.context.muiTheme.isRtl;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      var position = void 0;
	      if (isMouseControlInverted(calculatedAxis)) {
	        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]];
	      } else {
	        position = event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('touchmove', _this.handleTouchMove);
	      document.addEventListener('touchup', _this.handleTouchEnd);
	      document.addEventListener('touchend', _this.handleTouchEnd);
	      document.addEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.handleFocus = function (event) {
	      _this.setState({
	        focused: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      var _this$props4 = _this.props,
	          axis = _this$props4.axis,
	          disabled = _this$props4.disabled;
	      var isRtl = _this.context.muiTheme.isRtl;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      var position = void 0;
	      if (isMouseControlInverted(calculatedAxis)) {
	        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[calculatedAxis]];
	      } else {
	        position = event[mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('mousemove', _this.handleDragMouseMove);
	      document.addEventListener('mouseup', _this.handleMouseEnd);
	
	      // Cancel text selection
	      event.preventDefault();
	
	      // Set focus manually since we called preventDefault()
	      _this.handle.focus();
	
	      _this.onDragStart(event);
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({
	          active: false
	        });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({
	        hovered: true
	      });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({
	        hovered: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          valueProp = _props.value,
	          defaultValue = _props.defaultValue,
	          min = _props.min;
	
	
	      var value = valueProp;
	      if (value === undefined) {
	        value = defaultValue !== undefined ? defaultValue : min;
	      }
	
	      this.setState({
	        value: this.resolveValue(value)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        this.setState({
	          value: this.resolveValue(nextProps.value)
	        });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      return this.state.value;
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      this.setState({
	        value: this.props.min
	      });
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      var axis = this.props.axis;
	      var isRtl = this.context.muiTheme.isRtl;
	
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[calculatedAxis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, type) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          axis = _props2.axis,
	          disabled = _props2.disabled;
	      var isRtl = this.context.muiTheme.isRtl;
	
	
	      if (this.dragRunning) {
	        return;
	      }
	      this.dragRunning = true;
	
	      requestAnimationFrame(function () {
	        _this2.dragRunning = false;
	
	        var calculatedAxis = calculateAxis(axis, isRtl);
	        var source = type === 'touch' ? event.touches[0] : event;
	
	        var position = void 0;
	        if (isMouseControlInverted(calculatedAxis)) {
	          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[calculatedAxis]];
	        } else {
	          position = source[mainAxisClientOffsetProperty[calculatedAxis]] - _this2.getTrackOffset();
	        }
	
	        if (!disabled) {
	          _this2.setValueFromPosition(event, position);
	        }
	      });
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'setValueFromPosition',
	    value: function setValueFromPosition(event, position) {
	      var _props3 = this.props,
	          axis = _props3.axis,
	          step = _props3.step,
	          min = _props3.min,
	          max = _props3.max;
	      var isRtl = this.context.muiTheme.isRtl;
	
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	      var positionMax = this.track[mainAxisClientProperty[calculatedAxis]];
	
	      var value = void 0;
	
	      if (position <= 0) {
	        value = min;
	      } else if (position >= positionMax) {
	        value = max;
	      } else {
	        value = position / positionMax * (max - min);
	        value = Math.round(value / step) * step + min;
	        value = parseFloat(value.toFixed(5));
	      }
	
	      value = this.resolveValue(value);
	
	      if (this.state.value !== value) {
	        this.setState({
	          value: value
	        });
	
	        if (this.props.onChange) {
	          this.props.onChange(event, value);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          axis = _props4.axis,
	          disabled = _props4.disabled,
	          disableFocusRipple = _props4.disableFocusRipple,
	          max = _props4.max,
	          min = _props4.min,
	          name = _props4.name,
	          onBlur = _props4.onBlur,
	          onChange = _props4.onChange,
	          onDragStart = _props4.onDragStart,
	          onDragStop = _props4.onDragStop,
	          onFocus = _props4.onFocus,
	          required = _props4.required,
	          sliderStyle = _props4.sliderStyle,
	          step = _props4.step,
	          style = _props4.style,
	          propValue = _props4.value,
	          other = (0, _objectWithoutProperties3.default)(_props4, ['axis', 'disabled', 'disableFocusRipple', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style', 'value']);
	      var _state = this.state,
	          active = _state.active,
	          focused = _state.focused,
	          hovered = _state.hovered,
	          value = _state.value;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var percent = getPercent(value, min, max);
	
	      var handleStyles = {};
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart,
	            onKeyDown: !disabled && this.handleKeyDown
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(node) {
	                return _this3.track = node;
	              }, style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(node) {
	                  return _this3.handle = node;
	                },
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              },
	              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
	                style: rippleStyle,
	                innerStyle: styles.rippleInner,
	                show: (hovered || focused) && !active,
	                color: styles.rippleColor.fill
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          type: 'hidden',
	          name: name,
	          value: value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Slider.propTypes =  false ? {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _propTypes2.default.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event KeyDown event targeting the slider.
	   * @param {number} newValue The new value of the slider.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   *
	   * @param {object} event MouseDown or TouchStart event targeting the slider.
	   */
	  onDragStart: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slide has stopped moving.
	   *
	   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
	   */
	  onDragStop: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _propTypes2.default.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	} : {};
	exports.default = Slider;

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(1708);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ClickAwayListener = __webpack_require__(428);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _SnackbarBody = __webpack_require__(1711);
	
	var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
	      zIndex = _context$muiTheme.zIndex;
	  var open = state.open;
	
	
	  var styles = {
	    root: {
	      position: 'fixed',
	      left: '50%',
	      display: 'flex',
	      bottom: 0,
	      zIndex: zIndex.snackbar,
	      visibility: open ? 'visible' : 'hidden',
	      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
	      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
	    }
	  };
	
	  return styles;
	}
	
	var Snackbar = function (_Component) {
	  (0, _inherits3.default)(Snackbar, _Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
	      if (_this.timerTransitionId) {
	        // If transitioning, don't close the snackbar.
	        return;
	      }
	
	      if (_this.props.open !== null && _this.props.onRequestClose) {
	        _this.props.onRequestClose('clickaway');
	      } else {
	        _this.setState({ open: false });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open,
	        message: this.props.message,
	        action: this.props.action
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.open) {
	        this.setAutoHideTimer();
	        this.setTransitionTimer();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
	        this.setState({
	          open: false
	        });
	
	        clearTimeout(this.timerOneAtTheTimeId);
	        this.timerOneAtTheTimeId = setTimeout(function () {
	          _this2.setState({
	            message: nextProps.message,
	            action: nextProps.action,
	            open: true
	          });
	        }, 400);
	      } else {
	        var open = nextProps.open;
	
	        this.setState({
	          open: open !== null ? open : this.state.open,
	          message: nextProps.message,
	          action: nextProps.action
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.open !== this.state.open) {
	        if (this.state.open) {
	          this.setAutoHideTimer();
	          this.setTransitionTimer();
	        } else {
	          clearTimeout(this.timerAutoHideId);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHideId);
	      clearTimeout(this.timerTransitionId);
	      clearTimeout(this.timerOneAtTheTimeId);
	    }
	  }, {
	    key: 'setAutoHideTimer',
	
	
	    // Timer that controls delay before snackbar auto hides
	    value: function setAutoHideTimer() {
	      var _this3 = this;
	
	      var autoHideDuration = this.props.autoHideDuration;
	
	      if (autoHideDuration > 0) {
	        clearTimeout(this.timerAutoHideId);
	        this.timerAutoHideId = setTimeout(function () {
	          if (_this3.props.open !== null && _this3.props.onRequestClose) {
	            _this3.props.onRequestClose('timeout');
	          } else {
	            _this3.setState({ open: false });
	          }
	        }, autoHideDuration);
	      }
	    }
	
	    // Timer that controls delay before click-away events are captured (based on when animation completes)
	
	  }, {
	    key: 'setTransitionTimer',
	    value: function setTransitionTimer() {
	      var _this4 = this;
	
	      this.timerTransitionId = setTimeout(function () {
	        _this4.timerTransitionId = undefined;
	      }, 400);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHideDuration = _props.autoHideDuration,
	          contentStyle = _props.contentStyle,
	          bodyStyle = _props.bodyStyle,
	          messageProp = _props.message,
	          onRequestClose = _props.onRequestClose,
	          onActionTouchTap = _props.onActionTouchTap,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionTouchTap', 'style']);
	      var _state = this.state,
	          action = _state.action,
	          message = _state.message,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: open ? this.componentClickAway : null },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	          _react2.default.createElement(_SnackbarBody2.default, {
	            action: action,
	            contentStyle: contentStyle,
	            message: message,
	            open: open,
	            onActionTouchTap: onActionTouchTap,
	            style: bodyStyle
	          })
	        )
	      );
	    }
	  }]);
	  return Snackbar;
	}(_react.Component);
	
	Snackbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Snackbar.propTypes =  false ? {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * The number of milliseconds to wait before automatically dismissing.
	   * If no value is specified the snackbar will dismiss normally.
	   * If a value is provided the snackbar can still be dismissed normally.
	   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
	   */
	  autoHideDuration: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the body element.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _propTypes2.default.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _propTypes2.default.func,
	  /**
	   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
	   * `autoHideDuration` timer expires.
	   *
	   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
	   * `open` prop.
	   *
	   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Snackbar;

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SnackbarBody = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _withWidth = __webpack_require__(2688);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var open = props.open,
	      width = props.width;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
	      desktopGutter = _context$muiTheme$bas2.desktopGutter,
	      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
	      fontFamily = _context$muiTheme$bas.fontFamily,
	      _context$muiTheme$sna = _context$muiTheme.snackbar,
	      backgroundColor = _context$muiTheme$sna.backgroundColor,
	      textColor = _context$muiTheme$sna.textColor,
	      actionColor = _context$muiTheme$sna.actionColor,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var isSmall = width === _withWidth.SMALL;
	
	  var styles = {
	    root: {
	      fontFamily: fontFamily,
	      backgroundColor: backgroundColor,
	      padding: '0 ' + desktopGutter + 'px',
	      height: desktopSubheaderHeight,
	      lineHeight: desktopSubheaderHeight + 'px',
	      borderRadius: isSmall ? 0 : borderRadius,
	      maxWidth: isSmall ? 'inherit' : 568,
	      minWidth: isSmall ? 'inherit' : 288,
	      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
	      flexGrow: isSmall ? 1 : 0
	    },
	    content: {
	      fontSize: 14,
	      color: textColor,
	      opacity: open ? 1 : 0,
	      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
	    },
	    action: {
	      color: actionColor,
	      float: 'right',
	      marginTop: 6,
	      marginRight: -16,
	      marginLeft: desktopGutter,
	      backgroundColor: 'transparent'
	    }
	  };
	
	  return styles;
	}
	
	var SnackbarBody = function SnackbarBody(props, context) {
	  var action = props.action,
	      contentStyle = props.contentStyle,
	      message = props.message,
	      open = props.open,
	      onActionTouchTap = props.onActionTouchTap,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionTouchTap', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
	    style: styles.action,
	    label: action,
	    onClick: onActionTouchTap
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
	      _react2.default.createElement(
	        'span',
	        null,
	        message
	      ),
	      actionButton
	    )
	  );
	};
	
	exports.SnackbarBody = SnackbarBody;
	SnackbarBody.propTypes =  false ? {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _propTypes2.default.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Width of the screen.
	   */
	  width: _propTypes2.default.number.isRequired
	} : {};
	
	SnackbarBody.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Snackbar = __webpack_require__(1710);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Snackbar2.default;

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          completed = _this$props.completed,
	          disabled = _this$props.disabled,
	          index = _this$props.index,
	          last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          index = _props.index,
	          last = _props.last,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	Step.propTypes =  false ? {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _propTypes2.default.number,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Step;

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(697);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper,
	      backgroundColor = _context$muiTheme$ste.backgroundColor,
	      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  (0, _inherits3.default)(StepButton, _Component);
	
	  function StepButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          iconContainerStyle = _props.iconContainerStyle,
	          last = _props.last,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
	      );
	    }
	  }]);
	  return StepButton;
	}(_react.Component);
	
	StepButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	StepButton.propTypes =  false ? {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /** @ignore */
	  last: _propTypes2.default.bool,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = StepButton;

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme,
	      stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	StepConnector.propTypes =  false ? propTypes : {};
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ExpandTransition = __webpack_require__(1745);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  (0, _inherits3.default)(StepContent, _Component);
	
	  function StepContent() {
	    (0, _classCallCheck3.default)(this, StepContent);
	    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          last = _props.last,
	          style = _props.style,
	          transition = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	      var _context = this.context,
	          stepper = _context.stepper,
	          prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	  return StepContent;
	}(_react.Component);
	
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	StepContent.propTypes =  false ? {
	  /**
	   * Expands the content
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Step content
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _propTypes2.default.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _propTypes2.default.number
	} : {};
	exports.default = StepContent;

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StepConnector = __webpack_require__(1715);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  (0, _inherits3.default)(Stepper, _Component);
	
	  function Stepper() {
	    (0, _classCallCheck3.default)(this, Stepper);
	    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStep = _props.activeStep,
	          children = _props.children,
	          connector = _props.connector,
	          linear = _props.linear,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var numChildren = _react.Children.count(children);
	      var steps = _react.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === numChildren) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	  return Stepper;
	}(_react.Component);
	
	Stepper.defaultProps = {
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
	Stepper.childContextTypes = { stepper: _propTypes2.default.object };
	Stepper.propTypes =  false ? {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _propTypes2.default.number,
	  /**
	   * Should be two or more `<Step />` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _propTypes2.default.node,
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _propTypes2.default.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Stepper;

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children,
	      inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      prepareStyles = _context$muiTheme.prepareStyles,
	      subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	
	Subheader.propTypes =  false ? {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the `Subheader` will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	Subheader.defaultProps = {
	  inset: false
	};
	
	Subheader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Subheader;

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SvgIcon.propTypes =  false ? {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _propTypes2.default.string
	} : {};
	exports.default = SvgIcon;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      table = _context$muiTheme.table;
	
	
	  return {
	    root: {
	      backgroundColor: table.backgroundColor,
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      tableLayout: 'fixed',
	      fontFamily: baseTheme.fontFamily
	    },
	    bodyTable: {
	      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
	      overflowX: 'hidden',
	      overflowY: 'auto'
	    },
	    tableWrapper: {
	      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
	      overflow: 'auto'
	    }
	  };
	}
	
	var Table = function (_Component) {
	  (0, _inherits3.default)(Table, _Component);
	
	  function Table() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      allRowsSelected: false
	    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
	    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
	    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
	    }, _this.onRowHover = function (rowNumber) {
	      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
	    }, _this.onRowHoverExit = function (rowNumber) {
	      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
	    }, _this.onRowSelection = function (selectedRows) {
	      if (_this.state.allRowsSelected) {
	        _this.setState({ allRowsSelected: false });
	      }
	
	      if (_this.props.onRowSelection) {
	        _this.props.onRowSelection(selectedRows);
	      }
	    }, _this.onSelectAll = function () {
	      if (_this.props.onRowSelection) {
	        if (!_this.state.allRowsSelected) {
	          _this.props.onRowSelection('all');
	        } else {
	          _this.props.onRowSelection('none');
	        }
	      }
	
	      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.allRowsSelected) {
	        this.setState({ allRowsSelected: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        this.setState({ allRowsSelected: nextProps.allRowsSelected });
	      }
	    }
	  }, {
	    key: 'isScrollbarVisible',
	    value: function isScrollbarVisible() {
	      var tableDivHeight = this.refs.tableDiv.clientHeight;
	      var tableBodyHeight = this.refs.tableBody.clientHeight;
	
	      return tableBodyHeight > tableDivHeight;
	    }
	  }, {
	    key: 'createTableHeader',
	    value: function createTableHeader(base) {
	      return _react2.default.cloneElement(base, {
	        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	        onSelectAll: this.onSelectAll,
	        selectAllSelected: this.state.allRowsSelected
	      });
	    }
	  }, {
	    key: 'createTableBody',
	    value: function createTableBody(base) {
	      return _react2.default.cloneElement(base, {
	        allRowsSelected: this.state.allRowsSelected,
	        multiSelectable: this.props.multiSelectable,
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowSelection: this.onRowSelection,
	        selectable: this.props.selectable
	      });
	    }
	  }, {
	    key: 'createTableFooter',
	    value: function createTableFooter(base) {
	      return base;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          fixedFooter = _props.fixedFooter,
	          fixedHeader = _props.fixedHeader,
	          style = _props.style,
	          wrapperStyle = _props.wrapperStyle,
	          headerStyle = _props.headerStyle,
	          bodyStyle = _props.bodyStyle,
	          footerStyle = _props.footerStyle;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var tHead = void 0;
	      var tFoot = void 0;
	      var tBody = void 0;
	
	      _react2.default.Children.forEach(children, function (child) {
	        if (!_react2.default.isValidElement(child)) return;
	
	        var muiName = child.type.muiName;
	
	        if (muiName === 'TableBody') {
	          tBody = _this2.createTableBody(child);
	        } else if (muiName === 'TableHeader') {
	          tHead = _this2.createTableHeader(child);
	        } else if (muiName === 'TableFooter') {
	          tFoot = _this2.createTableFooter(child);
	        } else {
	           false ? (0, _warning2.default)(false, 'Material-UI: Children of the Table component must be TableBody or TableHeader or TableFooter.\n           Nothing is rendered.') : void 0;
	        }
	      });
	
	      // If we could not find a table-header and a table-body, do not attempt to display anything.
	      if (!tBody && !tHead) return null;
	
	      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var headerTable = void 0;
	      var footerTable = void 0;
	      var inlineHeader = void 0;
	      var inlineFooter = void 0;
	
	      if (fixedHeader) {
	        headerTable = _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle },
	            tHead
	          )
	        );
	      } else {
	        inlineHeader = tHead;
	      }
	
	      if (tFoot !== undefined) {
	        if (fixedFooter) {
	          footerTable = _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
	            _react2.default.createElement(
	              'table',
	              { className: className, style: prepareStyles(mergedTableStyle) },
	              tFoot
	            )
	          );
	        } else {
	          inlineFooter = tFoot;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
	        headerTable,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle, ref: 'tableBody' },
	            inlineHeader,
	            inlineFooter,
	            tBody
	          )
	        ),
	        footerTable
	      );
	    }
	  }]);
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  allRowsSelected: false,
	  fixedFooter: true,
	  fixedHeader: true,
	  height: 'inherit',
	  multiSelectable: false,
	  selectable: true
	};
	Table.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Table.propTypes =  false ? {
	  /**
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the body's table element.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * Children passed to table.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the footer will appear fixed below the table.
	   * The default value is true.
	   */
	  fixedFooter: _propTypes2.default.bool,
	  /**
	   * If true, the header will appear fixed above the table.
	   * The default value is true.
	   */
	  fixedHeader: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the footer's table element.
	   */
	  footerStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the header's table element.
	   */
	  headerStyle: _propTypes2.default.object,
	  /**
	   * The height of the table.
	   */
	  height: _propTypes2.default.string,
	  /**
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _propTypes2.default.bool,
	  /**
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * Called when a row is selected.
	   * selectedRows is an array of all row selections.
	   * IF all rows have been selected, the string "all"
	   * will be returned instead to indicate that all rows have been selected.
	   */
	  onRowSelection: _propTypes2.default.func,
	  /**
	   * If true, table rows can be selected.
	   * If multiple row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the table's wrapper element.
	   */
	  wrapperStyle: _propTypes2.default.object
	} : {};
	exports.default = Table;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      inkBar = _context$muiTheme.inkBar,
	      isRtl = _context$muiTheme.isRtl;
	
	
	  return {
	    root: {
	      left: props.left,
	      width: props.width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: props.color || inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', isRtl ? 'right' : 'left')
	    }
	  };
	}
	
	var InkBar = function (_Component) {
	  (0, _inherits3.default)(InkBar, _Component);
	
	  function InkBar() {
	    (0, _classCallCheck3.default)(this, InkBar);
	    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InkBar, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
	    }
	  }]);
	  return InkBar;
	}(_react.Component);
	
	InkBar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	InkBar.propTypes =  false ? {
	  color: _propTypes2.default.string,
	  left: _propTypes2.default.string.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  width: _propTypes2.default.string.isRequired
	} : {};
	exports.default = InkBar;

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  width: '100%',
	  position: 'relative',
	  textAlign: 'initial'
	};
	
	var TabTemplate = function TabTemplate(_ref) {
	  var children = _ref.children,
	      selected = _ref.selected,
	      style = _ref.style;
	
	  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
	  if (!selected) {
	    templateStyle.height = 0;
	    templateStyle.overflow = 'hidden';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: templateStyle },
	    children
	  );
	};
	
	TabTemplate.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  selected: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = TabTemplate;

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TabTemplate = __webpack_require__(1722);
	
	var _TabTemplate2 = _interopRequireDefault(_TabTemplate);
	
	var _InkBar = __webpack_require__(1721);
	
	var _InkBar2 = _interopRequireDefault(_InkBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    tabItemContainer: {
	      width: '100%',
	      backgroundColor: tabs.backgroundColor,
	      whiteSpace: 'nowrap',
	      display: 'flex'
	    }
	  };
	}
	
	var Tabs = function (_Component) {
	  (0, _inherits3.default)(Tabs, _Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
	      var valueLink = _this.getValueLink(_this.props);
	      var index = tab.props.index;
	
	      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
	        valueLink.requestChange(value, event, tab);
	      }
	
	      _this.setState({ selectedIndex: index });
	
	      if (tab.props.onActive) {
	        tab.props.onActive(tab);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueLink = this.getValueLink(this.props);
	      var initialIndex = this.props.initialSelectedIndex;
	
	      this.setState({
	        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps, nextContext) {
	      var valueLink = this.getValueLink(newProps);
	      var newState = {
	        muiTheme: nextContext.muiTheme || this.context.muiTheme
	      };
	
	      if (valueLink.value !== undefined) {
	        newState.selectedIndex = this.getSelectedIndex(newProps);
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var tabs = [];
	
	      _react.Children.forEach(props.children, function (tab) {
	        if ((0, _react.isValidElement)(tab)) {
	          tabs.push(tab);
	        }
	      });
	
	      return tabs;
	    }
	  }, {
	    key: 'getTabCount',
	    value: function getTabCount() {
	      return this.getTabs().length;
	    }
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	
	  }, {
	    key: 'getValueLink',
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props) {
	      var valueLink = this.getValueLink(props);
	      var selectedIndex = -1;
	
	      this.getTabs(props).forEach(function (tab, index) {
	        if (valueLink.value === tab.props.value) {
	          selectedIndex = index;
	        }
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected(tab, index) {
	      var valueLink = this.getValueLink(this.props);
	      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          contentContainerClassName = _props.contentContainerClassName,
	          contentContainerStyle = _props.contentContainerStyle,
	          initialSelectedIndex = _props.initialSelectedIndex,
	          inkBarStyle = _props.inkBarStyle,
	          onChange = _props.onChange,
	          style = _props.style,
	          tabItemContainerStyle = _props.tabItemContainerStyle,
	          tabTemplate = _props.tabTemplate,
	          tabTemplateStyle = _props.tabTemplateStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var valueLink = this.getValueLink(this.props);
	      var tabValue = valueLink.value;
	      var tabContent = [];
	      var width = 100 / this.getTabCount();
	
	      var tabs = this.getTabs().map(function (tab, index) {
	         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;
	
	         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;
	
	        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
	          key: index,
	          selected: _this2.getSelected(tab, index),
	          style: tabTemplateStyle
	        }, tab.props.children) : undefined);
	
	        return (0, _react.cloneElement)(tab, {
	          key: index,
	          index: index,
	          selected: _this2.getSelected(tab, index),
	          width: width + '%',
	          onClick: _this2.handleTabTouchTap
	        });
	      });
	
	      var realSelectedIndex = valueLink.value ? this.getSelectedIndex(this.props) : this.state.selectedIndex;
	
	      var inkBar = realSelectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
	        left: width * realSelectedIndex + '%',
	        width: width + '%',
	        style: inkBarStyle
	      }) : null;
	
	      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
	          tabs
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: inkBarContainerWidth } },
	          inkBar
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
	            className: contentContainerClassName
	          },
	          tabContent
	        )
	      );
	    }
	  }]);
	  return Tabs;
	}(_react.Component);
	
	Tabs.defaultProps = {
	  initialSelectedIndex: 0,
	  onChange: function onChange() {}
	};
	Tabs.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tabs.propTypes =  false ? {
	  /**
	   * Should be used to pass `Tab` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The css class name of the content's container.
	   */
	  contentContainerClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the content's container.
	   */
	  contentContainerStyle: _propTypes2.default.object,
	  /**
	   * Specify initial visible tab index.
	   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
	   * `initialSelectedIndex` will revert back to default.
	   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
	   */
	  initialSelectedIndex: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the InkBar.
	   */
	  inkBarStyle: _propTypes2.default.object,
	  /**
	   * Called when the selected value change.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the tab-labels container.
	   */
	  tabItemContainerStyle: _propTypes2.default.object,
	  /**
	   * Override the default tab template used to wrap the content of each tab element.
	   */
	  tabTemplate: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the tab template.
	   */
	  tabTemplateStyle: _propTypes2.default.object,
	  /**
	   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = Tabs;

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _Tab2 = __webpack_require__(703);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Tabs2 = __webpack_require__(1723);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab3.default;
	exports.Tabs = _Tabs3.default;
	exports.default = _Tabs3.default;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(112);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' // because the shadow has position: 'absolute'
	    },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'auto'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(_this.props.value, event);
	    }, _this.handleChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.syncHeightWithShadow(event.target.value);
	      }
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow(this.props.value);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
	        this.syncHeightWithShadow(nextProps.value, null, nextProps);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event, props) {
	      var shadow = this.refs.shadow;
	      var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? this.props.hintText : newValue;
	
	      if (displayText !== undefined) {
	        shadow.value = displayText;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      props = props || this.props;
	
	      if (props.rowsMax >= props.rows) {
	        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        var input = this.refs.input;
	        var cursorPosition = input.selectionStart;
	        this.setState({
	          height: newHeight
	        }, function () {
	          input.setSelectionRange(cursorPosition, cursorPosition);
	        });
	
	        if (props.onHeightChange) {
	          props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          hintText = _props.hintText,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'hintText', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	      var props = {};
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = valueLink.value;
	        props.valueLink = valueLink;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value
	        }, props)),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedTextarea.propTypes =  false ? {
	  defaultValue: _propTypes2.default.any,
	  disabled: _propTypes2.default.bool,
	  hintText: _propTypes2.default.node,
	  onChange: _propTypes2.default.func,
	  onHeightChange: _propTypes2.default.func,
	  rows: _propTypes2.default.number,
	  rowsMax: _propTypes2.default.number,
	  shadowStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  textareaStyle: _propTypes2.default.object,
	  value: _propTypes2.default.string,
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = EnhancedTextarea;

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(163);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(1725);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(1727);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(1728);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(1729);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitOpacity: 1,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated style).
	    },
	    inputNative: {
	      appearance: 'textfield' // Improve type search style.
	    }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.setState({ hasValue: isValid(event.target.value) });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled && !this.props.disabled) {
	        this.setState({
	          isFocused: false
	        });
	      }
	
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax,
	          hintText: hintText
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TextField.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _propTypes2.default.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _propTypes2.default.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _propTypes2.default.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * The value of the text field.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = TextField;

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	TextFieldHint.propTypes =  false ? {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _propTypes2.default.node
	} : {};
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onClick = props.onClick;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onClick: onClick
	    },
	    children
	  );
	};
	
	TextFieldLabel.propTypes =  false ? {
	  /**
	   * The label contents.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _propTypes2.default.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the text field label.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottomStyle: 'solid',
	      borderBottomWidth: 1,
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottomStyle: 'dotted',
	      borderBottomWidth: 2,
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottomStyle: 'solid',
	      borderBottomWidth: 2,
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(focusedUnderline) })
	  );
	};
	
	TextFieldUnderline.propTypes =  false ? propTypes : {};
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimeDisplay = __webpack_require__(1733);
	
	var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);
	
	var _ClockHours = __webpack_require__(1731);
	
	var _ClockHours2 = _interopRequireDefault(_ClockHours);
	
	var _ClockMinutes = __webpack_require__(1732);
	
	var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clock = function (_Component) {
	  (0, _inherits3.default)(Clock, _Component);
	
	  function Clock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Clock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Clock.__proto__ || (0, _getPrototypeOf2.default)(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedTime: null,
	      mode: 'hour'
	    }, _this.setMode = function (mode) {
	      setTimeout(function () {
	        _this.setState({
	          mode: mode
	        });
	      }, 100);
	    }, _this.handleSelectAffix = function (affix) {
	      if (affix === _this.getAffix()) return;
	
	      var hours = _this.state.selectedTime.getHours();
	
	      if (affix === 'am') {
	        _this.handleChangeHours(hours - 12, affix);
	        return;
	      }
	
	      _this.handleChangeHours(hours + 12, affix);
	    }, _this.handleChangeHours = function (hours, finished) {
	      var time = new Date(_this.state.selectedTime);
	      var affix = void 0;
	
	      if (typeof finished === 'string') {
	        affix = finished;
	        finished = undefined;
	      }
	      if (!affix) {
	        affix = _this.getAffix();
	      }
	      if (affix === 'pm' && hours < 12) {
	        hours += 12;
	      }
	
	      time.setHours(hours);
	      _this.setState({
	        selectedTime: time
	      });
	
	      if (finished) {
	        setTimeout(function () {
	          _this.setState({
	            mode: 'minute'
	          });
	
	          var onChangeHours = _this.props.onChangeHours;
	
	          if (onChangeHours) {
	            onChangeHours(time);
	          }
	        }, 100);
	      }
	    }, _this.handleChangeMinutes = function (minutes, finished) {
	      var time = new Date(_this.state.selectedTime);
	      time.setMinutes(minutes);
	      _this.setState({
	        selectedTime: time
	      });
	
	      var onChangeMinutes = _this.props.onChangeMinutes;
	
	      if (onChangeMinutes && finished) {
	        setTimeout(function () {
	          onChangeMinutes(time);
	        }, 0);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Clock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var selectedTime = this.props.initialTime || new Date();
	      var minutes = selectedTime.getMinutes();
	      selectedTime.setMinutes(minutes - minutes % this.props.minutesStep);
	
	      this.setState({
	        selectedTime: selectedTime
	      });
	    }
	  }, {
	    key: 'getAffix',
	    value: function getAffix() {
	      if (this.props.format !== 'ampm') return '';
	
	      var hours = this.state.selectedTime.getHours();
	      if (hours < 12) {
	        return 'am';
	      }
	
	      return 'pm';
	    }
	  }, {
	    key: 'getSelectedTime',
	    value: function getSelectedTime() {
	      return this.state.selectedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clock = null;
	
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          userSelect: 'none'
	        },
	        container: {
	          height: 280,
	          padding: 10,
	          position: 'relative',
	          boxSizing: 'content-box'
	        },
	        circle: {
	          position: 'absolute',
	          top: 20,
	          width: 260,
	          height: 260,
	          borderRadius: '100%',
	          backgroundColor: timePicker.clockCircleColor
	        }
	      };
	
	      if (this.state.mode === 'hour') {
	        clock = _react2.default.createElement(_ClockHours2.default, {
	          key: 'hours',
	          format: this.props.format,
	          onChange: this.handleChangeHours,
	          initialHours: this.state.selectedTime.getHours()
	        });
	      } else {
	        clock = _react2.default.createElement(_ClockMinutes2.default, {
	          key: 'minutes',
	          onChange: this.handleChangeMinutes,
	          initialMinutes: this.state.selectedTime.getMinutes(),
	          step: this.props.minutesStep
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_TimeDisplay2.default, {
	          selectedTime: this.state.selectedTime,
	          mode: this.state.mode,
	          format: this.props.format,
	          affix: this.getAffix(),
	          onSelectAffix: this.handleSelectAffix,
	          onSelectHour: this.setMode.bind(this, 'hour'),
	          onSelectMin: this.setMode.bind(this, 'minute')
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.container) },
	          _react2.default.createElement('div', { style: prepareStyles(styles.circle) }),
	          clock
	        )
	      );
	    }
	  }]);
	  return Clock;
	}(_react.Component);
	
	Clock.defaultProps = {
	  initialTime: new Date()
	};
	Clock.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Clock.propTypes =  false ? {
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialTime: _propTypes2.default.object,
	  minutesStep: _propTypes2.default.number,
	  onChangeHours: _propTypes2.default.func,
	  onChangeMinutes: _propTypes2.default.func
	} : {};
	exports.default = Clock;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ClockNumber = __webpack_require__(704);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(705);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockHours = function (_Component) {
	  (0, _inherits3.default)(ClockHours, _Component);
	
	  function ClockHours() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockHours);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockHours.__proto__ || (0, _getPrototypeOf2.default)(ClockHours)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) return;
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouchMove = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], false);
	    }, _this.handleTouchEnd = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], true);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockHours, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var hours = this.getHours(event.offsetX, event.offsetY);
	
	      this.props.onChange(hours, finish);
	    }
	  }, {
	    key: 'getHours',
	    value: function getHours(offsetX, offsetY) {
	      var step = 30;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      var delta = Math.pow(x, 2) + Math.pow(y, 2);
	      var distance = Math.sqrt(delta);
	
	      value = value || 12;
	      if (this.props.format === '24hr') {
	        if (distance < 90) {
	          value += 12;
	          value %= 24;
	        }
	      } else {
	        value %= 12;
	      }
	
	      return value;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      var hour = this.props.initialHours;
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      return hour;
	    }
	  }, {
	    key: 'getHourNumbers',
	    value: function getHourNumbers() {
	      var _this2 = this;
	
	      var style = {
	        pointerEvents: 'none'
	      };
	      var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	      var hours = [];
	      for (var i = 1; i <= hourSize; i++) {
	        hours.push(i % 24);
	      }
	
	      return hours.map(function (hour) {
	        var isSelected = _this2.getSelected() === hour;
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: hour,
	          style: style,
	          isSelected: isSelected,
	          type: 'hour',
	          value: hour
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var hours = this.getSelected();
	      var numbers = this.getHourNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
	        numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask', style: prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockHours;
	}(_react.Component);
	
	ClockHours.defaultProps = {
	  initialHours: new Date().getHours(),
	  onChange: function onChange() {},
	  format: 'ampm'
	};
	ClockHours.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockHours.propTypes =  false ? {
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialHours: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	} : {};
	exports.default = ClockHours;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClockNumber = __webpack_require__(704);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(705);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockMinutes = function (_Component) {
	  (0, _inherits3.default)(ClockMinutes, _Component);
	
	  function ClockMinutes() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockMinutes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockMinutes.__proto__ || (0, _getPrototypeOf2.default)(ClockMinutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) {
	        return;
	      }
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouch = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], event.type === 'touchend');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockMinutes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = this.refs.mask;
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var minutes = this.getMinutes(event.offsetX, event.offsetY);
	
	      this.props.onChange(minutes, finish);
	    }
	  }, {
	    key: 'getMinutes',
	    value: function getMinutes(offsetX, offsetY) {
	      var step = 6 * this.props.step;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      return value * this.props.step;
	    }
	  }, {
	    key: 'getMinuteNumbers',
	    value: function getMinuteNumbers() {
	      var minutes = [];
	      for (var i = 0; i < 12; i++) {
	        minutes.push(i * 5);
	      }
	      var selectedMinutes = this.props.initialMinutes;
	      var hasSelected = false;
	
	      var numbers = minutes.map(function (minute) {
	        var isSelected = selectedMinutes === minute;
	        if (isSelected) {
	          hasSelected = true;
	        }
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: minute,
	          isSelected: isSelected,
	          type: 'minute',
	          value: minute
	        });
	      });
	
	      return {
	        numbers: numbers,
	        hasSelected: hasSelected,
	        selected: selectedMinutes
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var minutes = this.getMinuteNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { value: minutes.selected, type: 'minute', hasSelected: minutes.hasSelected }),
	        minutes.numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask',
	          style: prepareStyles(styles.hitMask),
	          onTouchMove: this.handleTouch,
	          onTouchEnd: this.handleTouch,
	          onMouseUp: this.handleUp,
	          onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockMinutes;
	}(_react.Component);
	
	ClockMinutes.defaultProps = {
	  initialMinutes: new Date().getMinutes(),
	  onChange: function onChange() {},
	  step: 1
	};
	ClockMinutes.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockMinutes.propTypes =  false ? {
	  initialMinutes: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  step: _propTypes2.default.number
	} : {};
	exports.default = ClockMinutes;

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(357);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeDisplay = function (_Component) {
	  (0, _inherits3.default)(TimeDisplay, _Component);
	
	  function TimeDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimeDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimeDisplay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTime !== this.props.selectedTime) {
	        var direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'sanitizeTime',
	    value: function sanitizeTime() {
	      var hour = this.props.selectedTime.getHours();
	      var min = this.props.selectedTime.getMinutes().toString();
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      hour = hour.toString();
	      if (hour.length < 2) hour = '0' + hour;
	      if (min.length < 2) min = '0' + min;
	
	      return [hour, min];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          affix = _props.affix,
	          format = _props.format,
	          mode = _props.mode,
	          onSelectAffix = _props.onSelectAffix,
	          onSelectHour = _props.onSelectHour,
	          onSelectMin = _props.onSelectMin,
	          selectedTime = _props.selectedTime,
	          other = (0, _objectWithoutProperties3.default)(_props, ['affix', 'format', 'mode', 'onSelectAffix', 'onSelectHour', 'onSelectMin', 'selectedTime']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          padding: '14px 0',
	          borderTopLeftRadius: 2,
	          borderTopRightRadius: 2,
	          backgroundColor: timePicker.headerColor,
	          color: timePicker.textColor
	        },
	        text: {
	          margin: '6px 0',
	          lineHeight: '58px',
	          height: 58,
	          fontSize: 58,
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'baseline'
	        },
	        time: {
	          margin: '0 10px'
	        },
	        affix: {
	          flex: 1,
	          position: 'relative',
	          lineHeight: '17px',
	          height: 17,
	          fontSize: 17
	        },
	        affixTop: {
	          position: 'absolute',
	          top: -20,
	          left: 0
	        },
	        clickable: {
	          cursor: 'pointer'
	        },
	        inactive: {
	          opacity: 0.7
	        }
	      };
	
	      var _sanitizeTime = this.sanitizeTime(),
	          _sanitizeTime2 = (0, _slicedToArray3.default)(_sanitizeTime, 2),
	          hour = _sanitizeTime2[0],
	          min = _sanitizeTime2[1];
	
	      var buttons = [];
	      if (format === 'ampm') {
	        buttons = [_react2.default.createElement(
	          'div',
	          {
	            key: 'pm',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, affix === 'pm' ? {} : styles.inactive)),
	            onClick: function onClick() {
	              return onSelectAffix('pm');
	            }
	          },
	          'PM'
	        ), _react2.default.createElement(
	          'div',
	          {
	            key: 'am',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive)),
	            onClick: function onClick() {
	              return onSelectAffix('am');
	            }
	          },
	          'AM'
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.text) },
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.time) },
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'hour' ? {} : styles.inactive)),
	                onClick: onSelectHour
	              },
	              hour
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'minute' ? {} : styles.inactive)),
	                onClick: onSelectMin
	              },
	              min
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) },
	            buttons
	          )
	        )
	      );
	    }
	  }]);
	  return TimeDisplay;
	}(_react.Component);
	
	TimeDisplay.defaultProps = {
	  affix: '',
	  mode: 'hour'
	};
	TimeDisplay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TimeDisplay.propTypes =  false ? {
	  affix: _propTypes2.default.oneOf(['', 'pm', 'am']),
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  mode: _propTypes2.default.oneOf(['hour', 'minute']),
	  onSelectAffix: _propTypes2.default.func,
	  onSelectHour: _propTypes2.default.func,
	  onSelectMin: _propTypes2.default.func,
	  selectedTime: _propTypes2.default.object.isRequired
	} : {};
	exports.default = TimeDisplay;

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimePickerDialog = __webpack_require__(1735);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	var _TextField = __webpack_require__(154);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _timeUtils = __webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	emptyTime.setSeconds(0);
	emptyTime.setMilliseconds(0);
	
	var TimePicker = function (_Component) {
	  (0, _inherits3.default)(TimePicker, _Component);
	
	  function TimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePicker.__proto__ || (0, _getPrototypeOf2.default)(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      time: null,
	      dialogTime: new Date()
	    }, _this.handleAcceptDialog = function (time) {
	      _this.setState({
	        time: time
	      });
	      if (_this.props.onChange) _this.props.onChange(null, time);
	    }, _this.handleFocusInput = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTapInput = function (event) {
	      event.preventDefault();
	
	      if (!_this.props.disabled) {
	        _this.openDialog();
	      }
	
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        time: this.isControlled() ? this.getControlledTime() : this.props.defaultTime
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          time: this.getControlledTime(nextProps)
	        });
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      this.setState({
	        dialogTime: this.state.time
	      });
	      this.refs.dialogWindow.show();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.value !== null;
	    }
	  }, {
	    key: 'getControlledTime',
	    value: function getControlledTime() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var result = null;
	      if (props.value instanceof Date) {
	        result = props.value;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          defaultTime = _props.defaultTime,
	          dialogBodyStyle = _props.dialogBodyStyle,
	          dialogStyle = _props.dialogStyle,
	          format = _props.format,
	          okLabel = _props.okLabel,
	          onFocus = _props.onFocus,
	          onClick = _props.onClick,
	          onShow = _props.onShow,
	          onDismiss = _props.onDismiss,
	          pedantic = _props.pedantic,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          minutesStep = _props.minutesStep,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoOk', 'cancelLabel', 'defaultTime', 'dialogBodyStyle', 'dialogStyle', 'format', 'okLabel', 'onFocus', 'onClick', 'onShow', 'onDismiss', 'pedantic', 'style', 'textFieldStyle', 'minutesStep']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var time = this.state.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          style: textFieldStyle,
	          ref: 'input',
	          value: time === emptyTime ? null : (0, _timeUtils.formatTime)(time, format, pedantic),
	          onFocus: this.handleFocusInput,
	          onClick: this.handleTouchTapInput
	        })),
	        _react2.default.createElement(_TimePickerDialog2.default, {
	          ref: 'dialogWindow',
	          bodyStyle: dialogBodyStyle,
	          initialTime: this.state.dialogTime,
	          onAccept: this.handleAcceptDialog,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          format: format,
	          okLabel: okLabel,
	          cancelLabel: cancelLabel,
	          autoOk: autoOk,
	          style: dialogStyle,
	          minutesStep: minutesStep
	        })
	      );
	    }
	  }]);
	  return TimePicker;
	}(_react.Component);
	
	TimePicker.defaultProps = {
	  autoOk: false,
	  cancelLabel: 'Cancel',
	  defaultTime: null,
	  disabled: false,
	  format: 'ampm',
	  okLabel: 'OK',
	  pedantic: false,
	  style: {},
	  value: null,
	  minutesStep: 1
	};
	TimePicker.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TimePicker.propTypes =  false ? {
	  /**
	   * If true, automatically accept and close the picker on set minutes.
	   */
	  autoOk: _propTypes2.default.bool,
	  /**
	   * Override the label of the 'Cancel' button.
	   */
	  cancelLabel: _propTypes2.default.node,
	  /**
	   * The initial time value of the TimePicker.
	   */
	  defaultTime: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's body element.
	   */
	  dialogBodyStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's root element.
	   */
	  dialogStyle: _propTypes2.default.object,
	  /**
	   * If true, the TimePicker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Tells the component to display the picker in `ampm` (12hr) format or `24hr` format.
	   */
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  /**
	   * How many minutes should be added/subtracted when moving the clock pointer.
	   */
	  minutesStep: _propTypes2.default.number,
	  /**
	   * Override the label of the 'OK' button.
	   */
	  okLabel: _propTypes2.default.node,
	  /**
	   * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
	   * Since there is no particular event associated with the change the first argument will always be null
	   * and the second argument will be the new Date instance.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker is tapped or clicked.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker dialog is dismissed.
	   */
	  onDismiss: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker `TextField` gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker dialog is shown.
	   */
	  onShow: _propTypes2.default.func,
	  /**
	   * If true, uses ("noon" / "midnight") instead of ("12 a.m." / "12 p.m.").
	   *
	   * It's technically more correct to refer to "12 noon" and "12 midnight" rather than "12 a.m." and "12 p.m."
	   * and it avoids confusion between different locales. By default (for compatibility reasons) TimePicker uses
	   * ("12 a.m." / "12 p.m.").
	   */
	  pedantic: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePicker's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object,
	  /**
	   * Sets the time for the Time Picker programmatically.
	   */
	  value: _propTypes2.default.object
	} : {};
	exports.default = TimePicker;

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(112);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(80);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Clock = __webpack_require__(1730);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(51);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePickerDialog = function (_Component) {
	  (0, _inherits3.default)(TimePickerDialog, _Component);
	
	  function TimePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOK = function () {
	      if (_this.props.onAccept) {
	        _this.props.onAccept(_this.refs.clock.getSelectedTime());
	      }
	      _this.setState({
	        open: false
	      });
	    }, _this.handleKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOK();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePickerDialog, [{
	    key: 'show',
	    value: function show() {
	      if (this.props.onShow && !this.state.open) this.props.onShow();
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bodyStyle = _props.bodyStyle,
	          initialTime = _props.initialTime,
	          onAccept = _props.onAccept,
	          format = _props.format,
	          autoOk = _props.autoOk,
	          okLabel = _props.okLabel,
	          cancelLabel = _props.cancelLabel,
	          style = _props.style,
	          minutesStep = _props.minutesStep,
	          other = (0, _objectWithoutProperties3.default)(_props, ['bodyStyle', 'initialTime', 'onAccept', 'format', 'autoOk', 'okLabel', 'cancelLabel', 'style', 'minutesStep']);
	
	
	      var styles = {
	        root: {
	          fontSize: 14,
	          color: this.context.muiTheme.timePicker.clockColor
	        },
	        dialogContent: {
	          width: 280
	        },
	        body: {
	          padding: 0
	        }
	      };
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        key: 0,
	        label: cancelLabel,
	        primary: true,
	        onClick: this.handleTouchTapCancel
	      }), _react2.default.createElement(_FlatButton2.default, {
	        key: 1,
	        label: okLabel,
	        primary: true,
	        onClick: this.handleTouchTapOK
	      })];
	
	      var onClockChangeMinutes = autoOk === true ? this.handleTouchTapOK : undefined;
	      var open = this.state.open;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          bodyStyle: (0, _simpleAssign2.default)(styles.body, bodyStyle),
	          actions: actions,
	          contentStyle: styles.dialogContent,
	          repositionOnUpdate: false,
	          open: open,
	          onRequestClose: this.handleRequestClose
	        }),
	        open && _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        open && _react2.default.createElement(_Clock2.default, {
	          ref: 'clock',
	          format: format,
	          initialTime: initialTime,
	          onChangeMinutes: onClockChangeMinutes,
	          minutesStep: minutesStep
	        })
	      );
	    }
	  }]);
	  return TimePickerDialog;
	}(_react.Component);
	
	TimePickerDialog.defaultProps = {
	  okLabel: 'OK',
	  cancelLabel: 'Cancel'
	};
	TimePickerDialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TimePickerDialog.propTypes =  false ? {
	  autoOk: _propTypes2.default.bool,
	  bodyStyle: _propTypes2.default.object,
	  cancelLabel: _propTypes2.default.node,
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialTime: _propTypes2.default.object,
	  minutesStep: _propTypes2.default.number,
	  okLabel: _propTypes2.default.node,
	  onAccept: _propTypes2.default.func,
	  onDismiss: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  style: _propTypes2.default.object
	} : {};
	exports.default = TimePickerDialog;

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TimePicker = __webpack_require__(1734);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TimePicker2.default;

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(73);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _EnhancedSwitch = __webpack_require__(429);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var disabled = props.disabled,
	      elementStyle = props.elementStyle,
	      trackSwitchedStyle = props.trackSwitchedStyle,
	      thumbSwitchedStyle = props.thumbSwitchedStyle,
	      trackStyle = props.trackStyle,
	      thumbStyle = props.thumbStyle,
	      iconStyle = props.iconStyle,
	      rippleStyle = props.rippleStyle,
	      labelStyle = props.labelStyle;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toggle = _context$muiTheme.toggle;
	
	
	  var toggleSize = 20;
	  var toggleTrackWidth = 36;
	  var styles = {
	    icon: {
	      width: 36,
	      padding: '4px 0px 6px 2px'
	    },
	    ripple: {
	      top: -10,
	      left: -10,
	      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
	    },
	    toggleElement: {
	      width: toggleTrackWidth
	    },
	    track: {
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      height: 14,
	      borderRadius: 30,
	      backgroundColor: toggle.trackOffColor
	    },
	    thumb: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      top: 1,
	      left: 0,
	      width: toggleSize,
	      height: toggleSize,
	      lineHeight: '24px',
	      borderRadius: '50%',
	      backgroundColor: toggle.thumbOffColor
	    },
	    trackWhenSwitched: {
	      backgroundColor: toggle.trackOnColor
	    },
	    thumbWhenSwitched: {
	      backgroundColor: toggle.thumbOnColor,
	      left: '100%'
	    },
	    trackWhenDisabled: {
	      backgroundColor: toggle.trackDisabledColor
	    },
	    thumbWhenDisabled: {
	      backgroundColor: toggle.thumbDisabledColor
	    },
	    label: {
	      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
	      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
	    }
	  };
	
	  (0, _simpleAssign2.default)(styles.track, trackStyle, state.switched && styles.trackWhenSwitched, state.switched && trackSwitchedStyle, disabled && styles.trackWhenDisabled);
	
	  (0, _simpleAssign2.default)(styles.thumb, thumbStyle, state.switched && styles.thumbWhenSwitched, state.switched && thumbSwitchedStyle, disabled && styles.thumbWhenDisabled);
	
	  if (state.switched) {
	    styles.thumb.marginLeft = 0 - styles.thumb.width;
	  }
	
	  (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	  (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	  (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	  (0, _simpleAssign2.default)(styles.toggleElement, elementStyle);
	
	  return styles;
	}
	
	var Toggle = function (_Component) {
	  (0, _inherits3.default)(Toggle, _Component);
	
	  function Toggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Toggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleToggle = function (event, isInputChecked) {
	      if (_this.props.onToggle) {
	        _this.props.onToggle(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Toggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          toggled = _props.toggled,
	          defaultToggled = _props.defaultToggled,
	          valueLink = _props.valueLink;
	
	
	      if (toggled || defaultToggled || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'isToggled',
	    value: function isToggled() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setToggled',
	    value: function setToggled(newToggledValue) {
	      this.refs.enhancedSwitch.setSwitched(newToggledValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          defaultToggled = _props2.defaultToggled,
	          elementStyle = _props2.elementStyle,
	          onToggle = _props2.onToggle,
	          trackSwitchedStyle = _props2.trackSwitchedStyle,
	          thumbSwitchedStyle = _props2.thumbSwitchedStyle,
	          toggled = _props2.toggled,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'trackSwitchedStyle', 'thumbSwitchedStyle', 'toggled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var toggleElement = _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, styles.toggleElement)) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.track)) }),
	        _react2.default.createElement(_Paper2.default, { style: styles.thumb, circle: true, zDepth: 1 })
	      );
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switchElement: toggleElement,
	        rippleStyle: styles.ripple,
	        rippleColor: styles.ripple.color,
	        iconStyle: styles.icon,
	        trackStyle: styles.track,
	        thumbStyle: styles.thumb,
	        labelStyle: styles.label,
	        switched: this.state.switched,
	        onSwitch: this.handleToggle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      if (this.props.hasOwnProperty('toggled')) {
	        enhancedSwitchProps.checked = toggled;
	      } else if (this.props.hasOwnProperty('defaultToggled')) {
	        enhancedSwitchProps.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Toggle;
	}(_react.Component);
	
	Toggle.defaultProps = {
	  defaultToggled: false,
	  disabled: false,
	  labelPosition: 'left'
	};
	Toggle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Toggle.propTypes =  false ? {
	  /**
	   * Determines whether the Toggle is initially turned on.
	   * **Warning:** This cannot be used in conjunction with `toggled`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultToggled: _propTypes2.default.bool,
	  /**
	   * Will disable the toggle if true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides the inline-styles of the Toggle element.
	   */
	  elementStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the Icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * Label for toggle.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Where the label will be placed next to the toggle.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Toggle element label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function that is fired when the toggle switch is toggled.
	   *
	   * @param {object} event Change event targeting the toggle.
	   * @param {bool} isInputChecked The new value of the toggle.
	   */
	  onToggle: _propTypes2.default.func,
	  /**
	   * Override style of ripple.
	   */
	  rippleStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override style for thumb.
	   */
	  thumbStyle: _propTypes2.default.object,
	  /**
	  * Override the inline styles for thumb when the toggle switch is toggled on.
	  */
	  thumbSwitchedStyle: _propTypes2.default.object,
	  /**
	   * Toggled if set to true.
	   */
	  toggled: _propTypes2.default.bool,
	  /**
	   * Override style for track.
	   */
	  trackStyle: _propTypes2.default.object,
	  /**
	  * Override the inline styles for track when the toggle switch is toggled on.
	  */
	  trackSwitchedStyle: _propTypes2.default.object,
	  /**
	   * ValueLink prop for when using controlled toggle.
	   */
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = Toggle;

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Toggle = __webpack_require__(1737);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toggle2.default;

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var noGutter = props.noGutter;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      backgroundColor: toolbar.backgroundColor,
	      height: toolbar.height,
	      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
	      display: 'flex',
	      justifyContent: 'space-between'
	    }
	  };
	}
	
	var Toolbar = function (_Component) {
	  (0, _inherits3.default)(Toolbar, _Component);
	
	  function Toolbar() {
	    (0, _classCallCheck3.default)(this, Toolbar);
	    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          noGutter = _props.noGutter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Toolbar;
	}(_react.Component);
	
	Toolbar.defaultProps = {
	  noGutter: false
	};
	Toolbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Toolbar.propTypes =  false ? {
	  /**
	   * Can be a `ToolbarGroup` to render a group of related items.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Do not apply `desktopGutter` to the `Toolbar`.
	   */
	  noGutter: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Toolbar;

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(1739);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(706);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(707);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(708);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;
	exports.default = _Toolbar3.default;

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  (0, _inherits3.default)(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) {
	        this.preventScrolling();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) {
	        return;
	      }
	
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return AutoLockScrolling;
	}(_react.Component);
	
	AutoLockScrolling.propTypes =  false ? {
	  lock: _propTypes2.default.bool.isRequired
	} : {};
	exports.default = AutoLockScrolling;

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  (0, _inherits3.default)(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          beforeStyle = _props.beforeStyle,
	          afterStyle = _props.afterStyle,
	          beforeElementType = _props.beforeElementType,
	          afterElementType = _props.afterElementType,
	          elementType = _props.elementType,
	          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	BeforeAfterWrapper.propTypes =  false ? {
	  afterElementType: _propTypes2.default.string,
	  afterStyle: _propTypes2.default.object,
	  beforeElementType: _propTypes2.default.string,
	  beforeStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  elementType: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = BeforeAfterWrapper;

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(163);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(157);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CircleRipple.propTypes =  false ? {
	  aborted: _propTypes2.default.bool,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  touchGenerated: _propTypes2.default.bool
	} : {};
	exports.default = CircleRipple;

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BeforeAfterWrapper = __webpack_require__(1742);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    (0, _extends3.default)({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	ClearFix.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = ClearFix;

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(248);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(1746);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandTransition = function (_Component) {
	  (0, _inherits3.default)(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    (0, _classCallCheck3.default)(this, ExpandTransition);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration,
	          expandTransitionChildStyle = _props.expandTransitionChildStyle;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key,
	            style: expandTransitionChildStyle
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          enterDelay = _props2.enterDelay,
	          loading = _props2.loading,
	          open = _props2.open,
	          style = _props2.style,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration,
	          expandTransitionChildStyle = _props2.expandTransitionChildStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration', 'expandTransitionChildStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: 'auto'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ExpandTransition.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  expandTransitionChildStyle: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : {};
	exports.default = ExpandTransition;

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  (0, _inherits3.default)(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
	          style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          enterDelay = _props3.enterDelay,
	          style = _props3.style,
	          transitionDelay = _props3.transitionDelay,
	          transitionDuration = _props3.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ExpandTransitionChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : {};
	exports.default = ExpandTransitionChild;

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(248);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _ScaleInChild = __webpack_require__(1748);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ScaleIn.propTypes =  false ? {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ScaleIn;

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(157);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ScaleInChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = ScaleInChild;

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(12);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(157);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideInChild = function (_Component) {
	  (0, _inherits3.default)(SlideInChild, _Component);
	
	  function SlideInChild() {
	    (0, _classCallCheck3.default)(this, SlideInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (SlideInChild.__proto__ || (0, _getPrototypeOf2.default)(SlideInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SlideInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var direction = this.props.getLeaveDirection();
	      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          getLeaveDirection = _props.getLeaveDirection,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return SlideInChild;
	}(_react.Component);
	
	SlideInChild.defaultProps = {
	  enterDelay: 0
	};
	SlideInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SlideInChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  direction: _propTypes2.default.string,
	  enterDelay: _propTypes2.default.number,
	  // This callback is needed bacause the direction could change when leaving the DOM
	  getLeaveDirection: _propTypes2.default.func.isRequired,
	  style: _propTypes2.default.object
	} : {};
	exports.default = SlideInChild;

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(306);
	
	var _colorManipulator = __webpack_require__(97);
	
	var _spacing = __webpack_require__(713);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  borderRadius: 2,
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccessibility = function ActionAccessibility(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z' })
	  );
	};
	ActionAccessibility = (0, _pure2.default)(ActionAccessibility);
	ActionAccessibility.displayName = 'ActionAccessibility';
	ActionAccessibility.muiName = 'SvgIcon';
	
	exports.default = ActionAccessibility;

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccessible = function ActionAccessible(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '4', r: '2' }),
	    _react2.default.createElement('path', { d: 'M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z' })
	  );
	};
	ActionAccessible = (0, _pure2.default)(ActionAccessible);
	ActionAccessible.displayName = 'ActionAccessible';
	ActionAccessible.muiName = 'SvgIcon';
	
	exports.default = ActionAccessible;

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBalanceWallet = function ActionAccountBalanceWallet(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ActionAccountBalanceWallet = (0, _pure2.default)(ActionAccountBalanceWallet);
	ActionAccountBalanceWallet.displayName = 'ActionAccountBalanceWallet';
	ActionAccountBalanceWallet.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBalanceWallet;

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBalance = function ActionAccountBalance(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z' })
	  );
	};
	ActionAccountBalance = (0, _pure2.default)(ActionAccountBalance);
	ActionAccountBalance.displayName = 'ActionAccountBalance';
	ActionAccountBalance.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBalance;

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBox = function ActionAccountBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z' })
	  );
	};
	ActionAccountBox = (0, _pure2.default)(ActionAccountBox);
	ActionAccountBox.displayName = 'ActionAccountBox';
	ActionAccountBox.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBox;

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountCircle = function ActionAccountCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' })
	  );
	};
	ActionAccountCircle = (0, _pure2.default)(ActionAccountCircle);
	ActionAccountCircle.displayName = 'ActionAccountCircle';
	ActionAccountCircle.muiName = 'SvgIcon';
	
	exports.default = ActionAccountCircle;

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAddShoppingCart = function ActionAddShoppingCart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z' })
	  );
	};
	ActionAddShoppingCart = (0, _pure2.default)(ActionAddShoppingCart);
	ActionAddShoppingCart.displayName = 'ActionAddShoppingCart';
	ActionAddShoppingCart.muiName = 'SvgIcon';
	
	exports.default = ActionAddShoppingCart;

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarmAdd = function ActionAlarmAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
	  );
	};
	ActionAlarmAdd = (0, _pure2.default)(ActionAlarmAdd);
	ActionAlarmAdd.displayName = 'ActionAlarmAdd';
	ActionAlarmAdd.muiName = 'SvgIcon';
	
	exports.default = ActionAlarmAdd;

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarmOff = function ActionAlarmOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z' })
	  );
	};
	ActionAlarmOff = (0, _pure2.default)(ActionAlarmOff);
	ActionAlarmOff.displayName = 'ActionAlarmOff';
	ActionAlarmOff.muiName = 'SvgIcon';
	
	exports.default = ActionAlarmOff;

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarmOn = function ActionAlarmOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z' })
	  );
	};
	ActionAlarmOn = (0, _pure2.default)(ActionAlarmOn);
	ActionAlarmOn.displayName = 'ActionAlarmOn';
	ActionAlarmOn.muiName = 'SvgIcon';
	
	exports.default = ActionAlarmOn;

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarm = function ActionAlarm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	ActionAlarm = (0, _pure2.default)(ActionAlarm);
	ActionAlarm.displayName = 'ActionAlarm';
	ActionAlarm.muiName = 'SvgIcon';
	
	exports.default = ActionAlarm;

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAllOut = function ActionAllOut(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z' })
	  );
	};
	ActionAllOut = (0, _pure2.default)(ActionAllOut);
	ActionAllOut.displayName = 'ActionAllOut';
	ActionAllOut.muiName = 'SvgIcon';
	
	exports.default = ActionAllOut;

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAndroid = function ActionAndroid(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z' })
	  );
	};
	ActionAndroid = (0, _pure2.default)(ActionAndroid);
	ActionAndroid.displayName = 'ActionAndroid';
	ActionAndroid.muiName = 'SvgIcon';
	
	exports.default = ActionAndroid;

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAnnouncement = function ActionAnnouncement(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z' })
	  );
	};
	ActionAnnouncement = (0, _pure2.default)(ActionAnnouncement);
	ActionAnnouncement.displayName = 'ActionAnnouncement';
	ActionAnnouncement.muiName = 'SvgIcon';
	
	exports.default = ActionAnnouncement;

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAspectRatio = function ActionAspectRatio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
	  );
	};
	ActionAspectRatio = (0, _pure2.default)(ActionAspectRatio);
	ActionAspectRatio.displayName = 'ActionAspectRatio';
	ActionAspectRatio.muiName = 'SvgIcon';
	
	exports.default = ActionAspectRatio;

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssessment = function ActionAssessment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	ActionAssessment = (0, _pure2.default)(ActionAssessment);
	ActionAssessment.displayName = 'ActionAssessment';
	ActionAssessment.muiName = 'SvgIcon';
	
	exports.default = ActionAssessment;

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentInd = function ActionAssignmentInd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z' })
	  );
	};
	ActionAssignmentInd = (0, _pure2.default)(ActionAssignmentInd);
	ActionAssignmentInd.displayName = 'ActionAssignmentInd';
	ActionAssignmentInd.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentInd;

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentLate = function ActionAssignmentLate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	ActionAssignmentLate = (0, _pure2.default)(ActionAssignmentLate);
	ActionAssignmentLate.displayName = 'ActionAssignmentLate';
	ActionAssignmentLate.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentLate;

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentReturn = function ActionAssignmentReturn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z' })
	  );
	};
	ActionAssignmentReturn = (0, _pure2.default)(ActionAssignmentReturn);
	ActionAssignmentReturn.displayName = 'ActionAssignmentReturn';
	ActionAssignmentReturn.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentReturn;

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentReturned = function ActionAssignmentReturned(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z' })
	  );
	};
	ActionAssignmentReturned = (0, _pure2.default)(ActionAssignmentReturned);
	ActionAssignmentReturned.displayName = 'ActionAssignmentReturned';
	ActionAssignmentReturned.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentReturned;

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentTurnedIn = function ActionAssignmentTurnedIn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
	  );
	};
	ActionAssignmentTurnedIn = (0, _pure2.default)(ActionAssignmentTurnedIn);
	ActionAssignmentTurnedIn.displayName = 'ActionAssignmentTurnedIn';
	ActionAssignmentTurnedIn.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentTurnedIn;

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignment = function ActionAssignment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z' })
	  );
	};
	ActionAssignment = (0, _pure2.default)(ActionAssignment);
	ActionAssignment.displayName = 'ActionAssignment';
	ActionAssignment.muiName = 'SvgIcon';
	
	exports.default = ActionAssignment;

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAutorenew = function ActionAutorenew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z' })
	  );
	};
	ActionAutorenew = (0, _pure2.default)(ActionAutorenew);
	ActionAutorenew.displayName = 'ActionAutorenew';
	ActionAutorenew.muiName = 'SvgIcon';
	
	exports.default = ActionAutorenew;

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBackup = function ActionBackup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
	  );
	};
	ActionBackup = (0, _pure2.default)(ActionBackup);
	ActionBackup.displayName = 'ActionBackup';
	ActionBackup.muiName = 'SvgIcon';
	
	exports.default = ActionBackup;

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBook = function ActionBook(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
	  );
	};
	ActionBook = (0, _pure2.default)(ActionBook);
	ActionBook.displayName = 'ActionBook';
	ActionBook.muiName = 'SvgIcon';
	
	exports.default = ActionBook;

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBookmarkBorder = function ActionBookmarkBorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
	  );
	};
	ActionBookmarkBorder = (0, _pure2.default)(ActionBookmarkBorder);
	ActionBookmarkBorder.displayName = 'ActionBookmarkBorder';
	ActionBookmarkBorder.muiName = 'SvgIcon';
	
	exports.default = ActionBookmarkBorder;

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBookmark = function ActionBookmark(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionBookmark = (0, _pure2.default)(ActionBookmark);
	ActionBookmark.displayName = 'ActionBookmark';
	ActionBookmark.muiName = 'SvgIcon';
	
	exports.default = ActionBookmark;

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBugReport = function ActionBugReport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z' })
	  );
	};
	ActionBugReport = (0, _pure2.default)(ActionBugReport);
	ActionBugReport.displayName = 'ActionBugReport';
	ActionBugReport.muiName = 'SvgIcon';
	
	exports.default = ActionBugReport;

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBuild = function ActionBuild(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z' })
	  );
	};
	ActionBuild = (0, _pure2.default)(ActionBuild);
	ActionBuild.displayName = 'ActionBuild';
	ActionBuild.muiName = 'SvgIcon';
	
	exports.default = ActionBuild;

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCached = function ActionCached(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z' })
	  );
	};
	ActionCached = (0, _pure2.default)(ActionCached);
	ActionCached.displayName = 'ActionCached';
	ActionCached.muiName = 'SvgIcon';
	
	exports.default = ActionCached;

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCameraEnhance = function ActionCameraEnhance(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z' })
	  );
	};
	ActionCameraEnhance = (0, _pure2.default)(ActionCameraEnhance);
	ActionCameraEnhance.displayName = 'ActionCameraEnhance';
	ActionCameraEnhance.muiName = 'SvgIcon';
	
	exports.default = ActionCameraEnhance;

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCardGiftcard = function ActionCardGiftcard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
	  );
	};
	ActionCardGiftcard = (0, _pure2.default)(ActionCardGiftcard);
	ActionCardGiftcard.displayName = 'ActionCardGiftcard';
	ActionCardGiftcard.muiName = 'SvgIcon';
	
	exports.default = ActionCardGiftcard;

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCardMembership = function ActionCardMembership(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z' })
	  );
	};
	ActionCardMembership = (0, _pure2.default)(ActionCardMembership);
	ActionCardMembership.displayName = 'ActionCardMembership';
	ActionCardMembership.muiName = 'SvgIcon';
	
	exports.default = ActionCardMembership;

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCardTravel = function ActionCardTravel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z' })
	  );
	};
	ActionCardTravel = (0, _pure2.default)(ActionCardTravel);
	ActionCardTravel.displayName = 'ActionCardTravel';
	ActionCardTravel.muiName = 'SvgIcon';
	
	exports.default = ActionCardTravel;

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionChangeHistory = function ActionChangeHistory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z' })
	  );
	};
	ActionChangeHistory = (0, _pure2.default)(ActionChangeHistory);
	ActionChangeHistory.displayName = 'ActionChangeHistory';
	ActionChangeHistory.muiName = 'SvgIcon';
	
	exports.default = ActionChangeHistory;

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionChromeReaderMode = function ActionChromeReaderMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z' })
	  );
	};
	ActionChromeReaderMode = (0, _pure2.default)(ActionChromeReaderMode);
	ActionChromeReaderMode.displayName = 'ActionChromeReaderMode';
	ActionChromeReaderMode.muiName = 'SvgIcon';
	
	exports.default = ActionChromeReaderMode;

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionClass = function ActionClass(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
	  );
	};
	ActionClass = (0, _pure2.default)(ActionClass);
	ActionClass.displayName = 'ActionClass';
	ActionClass.muiName = 'SvgIcon';
	
	exports.default = ActionClass;

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCode = function ActionCode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' })
	  );
	};
	ActionCode = (0, _pure2.default)(ActionCode);
	ActionCode.displayName = 'ActionCode';
	ActionCode.muiName = 'SvgIcon';
	
	exports.default = ActionCode;

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCompareArrows = function ActionCompareArrows(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z' })
	  );
	};
	ActionCompareArrows = (0, _pure2.default)(ActionCompareArrows);
	ActionCompareArrows.displayName = 'ActionCompareArrows';
	ActionCompareArrows.muiName = 'SvgIcon';
	
	exports.default = ActionCompareArrows;

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCopyright = function ActionCopyright(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ActionCopyright = (0, _pure2.default)(ActionCopyright);
	ActionCopyright.displayName = 'ActionCopyright';
	ActionCopyright.muiName = 'SvgIcon';
	
	exports.default = ActionCopyright;

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCreditCard = function ActionCreditCard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
	  );
	};
	ActionCreditCard = (0, _pure2.default)(ActionCreditCard);
	ActionCreditCard.displayName = 'ActionCreditCard';
	ActionCreditCard.muiName = 'SvgIcon';
	
	exports.default = ActionCreditCard;

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDashboard = function ActionDashboard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z' })
	  );
	};
	ActionDashboard = (0, _pure2.default)(ActionDashboard);
	ActionDashboard.displayName = 'ActionDashboard';
	ActionDashboard.muiName = 'SvgIcon';
	
	exports.default = ActionDashboard;

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDateRange = function ActionDateRange(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z' })
	  );
	};
	ActionDateRange = (0, _pure2.default)(ActionDateRange);
	ActionDateRange.displayName = 'ActionDateRange';
	ActionDateRange.muiName = 'SvgIcon';
	
	exports.default = ActionDateRange;

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDeleteForever = function ActionDeleteForever(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z' })
	  );
	};
	ActionDeleteForever = (0, _pure2.default)(ActionDeleteForever);
	ActionDeleteForever.displayName = 'ActionDeleteForever';
	ActionDeleteForever.muiName = 'SvgIcon';
	
	exports.default = ActionDeleteForever;

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDelete = function ActionDelete(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
	  );
	};
	ActionDelete = (0, _pure2.default)(ActionDelete);
	ActionDelete.displayName = 'ActionDelete';
	ActionDelete.muiName = 'SvgIcon';
	
	exports.default = ActionDelete;

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDescription = function ActionDescription(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z' })
	  );
	};
	ActionDescription = (0, _pure2.default)(ActionDescription);
	ActionDescription.displayName = 'ActionDescription';
	ActionDescription.muiName = 'SvgIcon';
	
	exports.default = ActionDescription;

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDns = function ActionDns(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ActionDns = (0, _pure2.default)(ActionDns);
	ActionDns.displayName = 'ActionDns';
	ActionDns.muiName = 'SvgIcon';
	
	exports.default = ActionDns;

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDoneAll = function ActionDoneAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z' })
	  );
	};
	ActionDoneAll = (0, _pure2.default)(ActionDoneAll);
	ActionDoneAll.displayName = 'ActionDoneAll';
	ActionDoneAll.muiName = 'SvgIcon';
	
	exports.default = ActionDoneAll;

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDonutLarge = function ActionDonutLarge(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z' })
	  );
	};
	ActionDonutLarge = (0, _pure2.default)(ActionDonutLarge);
	ActionDonutLarge.displayName = 'ActionDonutLarge';
	ActionDonutLarge.muiName = 'SvgIcon';
	
	exports.default = ActionDonutLarge;

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDonutSmall = function ActionDonutSmall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z' })
	  );
	};
	ActionDonutSmall = (0, _pure2.default)(ActionDonutSmall);
	ActionDonutSmall.displayName = 'ActionDonutSmall';
	ActionDonutSmall.muiName = 'SvgIcon';
	
	exports.default = ActionDonutSmall;

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEject = function ActionEject(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 17h14v2H5zm7-12L5.33 15h13.34z' })
	  );
	};
	ActionEject = (0, _pure2.default)(ActionEject);
	ActionEject.displayName = 'ActionEject';
	ActionEject.muiName = 'SvgIcon';
	
	exports.default = ActionEject;

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEuroSymbol = function ActionEuroSymbol(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z' })
	  );
	};
	ActionEuroSymbol = (0, _pure2.default)(ActionEuroSymbol);
	ActionEuroSymbol.displayName = 'ActionEuroSymbol';
	ActionEuroSymbol.muiName = 'SvgIcon';
	
	exports.default = ActionEuroSymbol;

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEventSeat = function ActionEventSeat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z' })
	  );
	};
	ActionEventSeat = (0, _pure2.default)(ActionEventSeat);
	ActionEventSeat.displayName = 'ActionEventSeat';
	ActionEventSeat.muiName = 'SvgIcon';
	
	exports.default = ActionEventSeat;

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEvent = function ActionEvent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
	  );
	};
	ActionEvent = (0, _pure2.default)(ActionEvent);
	ActionEvent.displayName = 'ActionEvent';
	ActionEvent.muiName = 'SvgIcon';
	
	exports.default = ActionEvent;

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExitToApp = function ActionExitToApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionExitToApp = (0, _pure2.default)(ActionExitToApp);
	ActionExitToApp.displayName = 'ActionExitToApp';
	ActionExitToApp.muiName = 'SvgIcon';
	
	exports.default = ActionExitToApp;

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExplore = function ActionExplore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z' })
	  );
	};
	ActionExplore = (0, _pure2.default)(ActionExplore);
	ActionExplore.displayName = 'ActionExplore';
	ActionExplore.muiName = 'SvgIcon';
	
	exports.default = ActionExplore;

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExtension = function ActionExtension(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z' })
	  );
	};
	ActionExtension = (0, _pure2.default)(ActionExtension);
	ActionExtension.displayName = 'ActionExtension';
	ActionExtension.muiName = 'SvgIcon';
	
	exports.default = ActionExtension;

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFace = function ActionFace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z' })
	  );
	};
	ActionFace = (0, _pure2.default)(ActionFace);
	ActionFace.displayName = 'ActionFace';
	ActionFace.muiName = 'SvgIcon';
	
	exports.default = ActionFace;

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFavoriteBorder = function ActionFavoriteBorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z' })
	  );
	};
	ActionFavoriteBorder = (0, _pure2.default)(ActionFavoriteBorder);
	ActionFavoriteBorder.displayName = 'ActionFavoriteBorder';
	ActionFavoriteBorder.muiName = 'SvgIcon';
	
	exports.default = ActionFavoriteBorder;

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFavorite = function ActionFavorite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z' })
	  );
	};
	ActionFavorite = (0, _pure2.default)(ActionFavorite);
	ActionFavorite.displayName = 'ActionFavorite';
	ActionFavorite.muiName = 'SvgIcon';
	
	exports.default = ActionFavorite;

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFeedback = function ActionFeedback(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
	  );
	};
	ActionFeedback = (0, _pure2.default)(ActionFeedback);
	ActionFeedback.displayName = 'ActionFeedback';
	ActionFeedback.muiName = 'SvgIcon';
	
	exports.default = ActionFeedback;

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFindInPage = function ActionFindInPage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z' })
	  );
	};
	ActionFindInPage = (0, _pure2.default)(ActionFindInPage);
	ActionFindInPage.displayName = 'ActionFindInPage';
	ActionFindInPage.muiName = 'SvgIcon';
	
	exports.default = ActionFindInPage;

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFindReplace = function ActionFindReplace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z' })
	  );
	};
	ActionFindReplace = (0, _pure2.default)(ActionFindReplace);
	ActionFindReplace.displayName = 'ActionFindReplace';
	ActionFindReplace.muiName = 'SvgIcon';
	
	exports.default = ActionFindReplace;

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFingerprint = function ActionFingerprint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z' })
	  );
	};
	ActionFingerprint = (0, _pure2.default)(ActionFingerprint);
	ActionFingerprint.displayName = 'ActionFingerprint';
	ActionFingerprint.muiName = 'SvgIcon';
	
	exports.default = ActionFingerprint;

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlightLand = function ActionFlightLand(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z' })
	  );
	};
	ActionFlightLand = (0, _pure2.default)(ActionFlightLand);
	ActionFlightLand.displayName = 'ActionFlightLand';
	ActionFlightLand.muiName = 'SvgIcon';
	
	exports.default = ActionFlightLand;

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlightTakeoff = function ActionFlightTakeoff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z' })
	  );
	};
	ActionFlightTakeoff = (0, _pure2.default)(ActionFlightTakeoff);
	ActionFlightTakeoff.displayName = 'ActionFlightTakeoff';
	ActionFlightTakeoff.muiName = 'SvgIcon';
	
	exports.default = ActionFlightTakeoff;

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlipToBack = function ActionFlipToBack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z' })
	  );
	};
	ActionFlipToBack = (0, _pure2.default)(ActionFlipToBack);
	ActionFlipToBack.displayName = 'ActionFlipToBack';
	ActionFlipToBack.muiName = 'SvgIcon';
	
	exports.default = ActionFlipToBack;

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlipToFront = function ActionFlipToFront(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z' })
	  );
	};
	ActionFlipToFront = (0, _pure2.default)(ActionFlipToFront);
	ActionFlipToFront.displayName = 'ActionFlipToFront';
	ActionFlipToFront.muiName = 'SvgIcon';
	
	exports.default = ActionFlipToFront;

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGTranslate = function ActionGTranslate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z' })
	  );
	};
	ActionGTranslate = (0, _pure2.default)(ActionGTranslate);
	ActionGTranslate.displayName = 'ActionGTranslate';
	ActionGTranslate.muiName = 'SvgIcon';
	
	exports.default = ActionGTranslate;

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGavel = function ActionGavel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z' })
	  );
	};
	ActionGavel = (0, _pure2.default)(ActionGavel);
	ActionGavel.displayName = 'ActionGavel';
	ActionGavel.muiName = 'SvgIcon';
	
	exports.default = ActionGavel;

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGetApp = function ActionGetApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
	  );
	};
	ActionGetApp = (0, _pure2.default)(ActionGetApp);
	ActionGetApp.displayName = 'ActionGetApp';
	ActionGetApp.muiName = 'SvgIcon';
	
	exports.default = ActionGetApp;

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGif = function ActionGif(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z' })
	  );
	};
	ActionGif = (0, _pure2.default)(ActionGif);
	ActionGif.displayName = 'ActionGif';
	ActionGif.muiName = 'SvgIcon';
	
	exports.default = ActionGif;

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGrade = function ActionGrade(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
	  );
	};
	ActionGrade = (0, _pure2.default)(ActionGrade);
	ActionGrade.displayName = 'ActionGrade';
	ActionGrade.muiName = 'SvgIcon';
	
	exports.default = ActionGrade;

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGroupWork = function ActionGroupWork(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	ActionGroupWork = (0, _pure2.default)(ActionGroupWork);
	ActionGroupWork.displayName = 'ActionGroupWork';
	ActionGroupWork.muiName = 'SvgIcon';
	
	exports.default = ActionGroupWork;

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHelpOutline = function ActionHelpOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z' })
	  );
	};
	ActionHelpOutline = (0, _pure2.default)(ActionHelpOutline);
	ActionHelpOutline.displayName = 'ActionHelpOutline';
	ActionHelpOutline.muiName = 'SvgIcon';
	
	exports.default = ActionHelpOutline;

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHelp = function ActionHelp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
	  );
	};
	ActionHelp = (0, _pure2.default)(ActionHelp);
	ActionHelp.displayName = 'ActionHelp';
	ActionHelp.muiName = 'SvgIcon';
	
	exports.default = ActionHelp;

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHistory = function ActionHistory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
	  );
	};
	ActionHistory = (0, _pure2.default)(ActionHistory);
	ActionHistory.displayName = 'ActionHistory';
	ActionHistory.muiName = 'SvgIcon';
	
	exports.default = ActionHistory;

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHome = function ActionHome(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' })
	  );
	};
	ActionHome = (0, _pure2.default)(ActionHome);
	ActionHome.displayName = 'ActionHome';
	ActionHome.muiName = 'SvgIcon';
	
	exports.default = ActionHome;

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHourglassEmpty = function ActionHourglassEmpty(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z' })
	  );
	};
	ActionHourglassEmpty = (0, _pure2.default)(ActionHourglassEmpty);
	ActionHourglassEmpty.displayName = 'ActionHourglassEmpty';
	ActionHourglassEmpty.muiName = 'SvgIcon';
	
	exports.default = ActionHourglassEmpty;

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHourglassFull = function ActionHourglassFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z' })
	  );
	};
	ActionHourglassFull = (0, _pure2.default)(ActionHourglassFull);
	ActionHourglassFull.displayName = 'ActionHourglassFull';
	ActionHourglassFull.muiName = 'SvgIcon';
	
	exports.default = ActionHourglassFull;

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHttp = function ActionHttp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z' })
	  );
	};
	ActionHttp = (0, _pure2.default)(ActionHttp);
	ActionHttp.displayName = 'ActionHttp';
	ActionHttp.muiName = 'SvgIcon';
	
	exports.default = ActionHttp;

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHttps = function ActionHttps(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
	  );
	};
	ActionHttps = (0, _pure2.default)(ActionHttps);
	ActionHttps.displayName = 'ActionHttps';
	ActionHttps.muiName = 'SvgIcon';
	
	exports.default = ActionHttps;

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionImportantDevices = function ActionImportantDevices(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z' })
	  );
	};
	ActionImportantDevices = (0, _pure2.default)(ActionImportantDevices);
	ActionImportantDevices.displayName = 'ActionImportantDevices';
	ActionImportantDevices.muiName = 'SvgIcon';
	
	exports.default = ActionImportantDevices;

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInfo = function ActionInfo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
	  );
	};
	ActionInfo = (0, _pure2.default)(ActionInfo);
	ActionInfo.displayName = 'ActionInfo';
	ActionInfo.muiName = 'SvgIcon';
	
	exports.default = ActionInfo;

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInvertColors = function ActionInvertColors(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z' })
	  );
	};
	ActionInvertColors = (0, _pure2.default)(ActionInvertColors);
	ActionInvertColors.displayName = 'ActionInvertColors';
	ActionInvertColors.muiName = 'SvgIcon';
	
	exports.default = ActionInvertColors;

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLabelOutline = function ActionLabelOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z' })
	  );
	};
	ActionLabelOutline = (0, _pure2.default)(ActionLabelOutline);
	ActionLabelOutline.displayName = 'ActionLabelOutline';
	ActionLabelOutline.muiName = 'SvgIcon';
	
	exports.default = ActionLabelOutline;

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLabel = function ActionLabel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z' })
	  );
	};
	ActionLabel = (0, _pure2.default)(ActionLabel);
	ActionLabel.displayName = 'ActionLabel';
	ActionLabel.muiName = 'SvgIcon';
	
	exports.default = ActionLabel;

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLanguage = function ActionLanguage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z' })
	  );
	};
	ActionLanguage = (0, _pure2.default)(ActionLanguage);
	ActionLanguage.displayName = 'ActionLanguage';
	ActionLanguage.muiName = 'SvgIcon';
	
	exports.default = ActionLanguage;

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLaunch = function ActionLaunch(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
	  );
	};
	ActionLaunch = (0, _pure2.default)(ActionLaunch);
	ActionLaunch.displayName = 'ActionLaunch';
	ActionLaunch.muiName = 'SvgIcon';
	
	exports.default = ActionLaunch;

/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLightbulbOutline = function ActionLightbulbOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z' })
	  );
	};
	ActionLightbulbOutline = (0, _pure2.default)(ActionLightbulbOutline);
	ActionLightbulbOutline.displayName = 'ActionLightbulbOutline';
	ActionLightbulbOutline.muiName = 'SvgIcon';
	
	exports.default = ActionLightbulbOutline;

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLineStyle = function ActionLineStyle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z' })
	  );
	};
	ActionLineStyle = (0, _pure2.default)(ActionLineStyle);
	ActionLineStyle.displayName = 'ActionLineStyle';
	ActionLineStyle.muiName = 'SvgIcon';
	
	exports.default = ActionLineStyle;

/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLineWeight = function ActionLineWeight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z' })
	  );
	};
	ActionLineWeight = (0, _pure2.default)(ActionLineWeight);
	ActionLineWeight.displayName = 'ActionLineWeight';
	ActionLineWeight.muiName = 'SvgIcon';
	
	exports.default = ActionLineWeight;

/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionList = function ActionList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z' })
	  );
	};
	ActionList = (0, _pure2.default)(ActionList);
	ActionList.displayName = 'ActionList';
	ActionList.muiName = 'SvgIcon';
	
	exports.default = ActionList;

/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLockOpen = function ActionLockOpen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z' })
	  );
	};
	ActionLockOpen = (0, _pure2.default)(ActionLockOpen);
	ActionLockOpen.displayName = 'ActionLockOpen';
	ActionLockOpen.muiName = 'SvgIcon';
	
	exports.default = ActionLockOpen;

/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLockOutline = function ActionLockOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z' })
	  );
	};
	ActionLockOutline = (0, _pure2.default)(ActionLockOutline);
	ActionLockOutline.displayName = 'ActionLockOutline';
	ActionLockOutline.muiName = 'SvgIcon';
	
	exports.default = ActionLockOutline;

/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLock = function ActionLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
	  );
	};
	ActionLock = (0, _pure2.default)(ActionLock);
	ActionLock.displayName = 'ActionLock';
	ActionLock.muiName = 'SvgIcon';
	
	exports.default = ActionLock;

/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLoyalty = function ActionLoyalty(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z' })
	  );
	};
	ActionLoyalty = (0, _pure2.default)(ActionLoyalty);
	ActionLoyalty.displayName = 'ActionLoyalty';
	ActionLoyalty.muiName = 'SvgIcon';
	
	exports.default = ActionLoyalty;

/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionMarkunreadMailbox = function ActionMarkunreadMailbox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionMarkunreadMailbox = (0, _pure2.default)(ActionMarkunreadMailbox);
	ActionMarkunreadMailbox.displayName = 'ActionMarkunreadMailbox';
	ActionMarkunreadMailbox.muiName = 'SvgIcon';
	
	exports.default = ActionMarkunreadMailbox;

/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionMotorcycle = function ActionMotorcycle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z' })
	  );
	};
	ActionMotorcycle = (0, _pure2.default)(ActionMotorcycle);
	ActionMotorcycle.displayName = 'ActionMotorcycle';
	ActionMotorcycle.muiName = 'SvgIcon';
	
	exports.default = ActionMotorcycle;

/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionNoteAdd = function ActionNoteAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z' })
	  );
	};
	ActionNoteAdd = (0, _pure2.default)(ActionNoteAdd);
	ActionNoteAdd.displayName = 'ActionNoteAdd';
	ActionNoteAdd.muiName = 'SvgIcon';
	
	exports.default = ActionNoteAdd;

/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOfflinePin = function ActionOfflinePin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z' })
	  );
	};
	ActionOfflinePin = (0, _pure2.default)(ActionOfflinePin);
	ActionOfflinePin.displayName = 'ActionOfflinePin';
	ActionOfflinePin.muiName = 'SvgIcon';
	
	exports.default = ActionOfflinePin;

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpacity = function ActionOpacity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z' })
	  );
	};
	ActionOpacity = (0, _pure2.default)(ActionOpacity);
	ActionOpacity.displayName = 'ActionOpacity';
	ActionOpacity.muiName = 'SvgIcon';
	
	exports.default = ActionOpacity;

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenInBrowser = function ActionOpenInBrowser(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z' })
	  );
	};
	ActionOpenInBrowser = (0, _pure2.default)(ActionOpenInBrowser);
	ActionOpenInBrowser.displayName = 'ActionOpenInBrowser';
	ActionOpenInBrowser.muiName = 'SvgIcon';
	
	exports.default = ActionOpenInBrowser;

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenInNew = function ActionOpenInNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
	  );
	};
	ActionOpenInNew = (0, _pure2.default)(ActionOpenInNew);
	ActionOpenInNew.displayName = 'ActionOpenInNew';
	ActionOpenInNew.muiName = 'SvgIcon';
	
	exports.default = ActionOpenInNew;

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenWith = function ActionOpenWith(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z' })
	  );
	};
	ActionOpenWith = (0, _pure2.default)(ActionOpenWith);
	ActionOpenWith.displayName = 'ActionOpenWith';
	ActionOpenWith.muiName = 'SvgIcon';
	
	exports.default = ActionOpenWith;

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPageview = function ActionPageview(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z' })
	  );
	};
	ActionPageview = (0, _pure2.default)(ActionPageview);
	ActionPageview.displayName = 'ActionPageview';
	ActionPageview.muiName = 'SvgIcon';
	
	exports.default = ActionPageview;

/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPanTool = function ActionPanTool(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z' })
	  );
	};
	ActionPanTool = (0, _pure2.default)(ActionPanTool);
	ActionPanTool.displayName = 'ActionPanTool';
	ActionPanTool.muiName = 'SvgIcon';
	
	exports.default = ActionPanTool;

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPayment = function ActionPayment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
	  );
	};
	ActionPayment = (0, _pure2.default)(ActionPayment);
	ActionPayment.displayName = 'ActionPayment';
	ActionPayment.muiName = 'SvgIcon';
	
	exports.default = ActionPayment;

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermCameraMic = function ActionPermCameraMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z' })
	  );
	};
	ActionPermCameraMic = (0, _pure2.default)(ActionPermCameraMic);
	ActionPermCameraMic.displayName = 'ActionPermCameraMic';
	ActionPermCameraMic.muiName = 'SvgIcon';
	
	exports.default = ActionPermCameraMic;

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermContactCalendar = function ActionPermContactCalendar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z' })
	  );
	};
	ActionPermContactCalendar = (0, _pure2.default)(ActionPermContactCalendar);
	ActionPermContactCalendar.displayName = 'ActionPermContactCalendar';
	ActionPermContactCalendar.muiName = 'SvgIcon';
	
	exports.default = ActionPermContactCalendar;

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermDataSetting = function ActionPermDataSetting(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ActionPermDataSetting = (0, _pure2.default)(ActionPermDataSetting);
	ActionPermDataSetting.displayName = 'ActionPermDataSetting';
	ActionPermDataSetting.muiName = 'SvgIcon';
	
	exports.default = ActionPermDataSetting;

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermDeviceInformation = function ActionPermDeviceInformation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	ActionPermDeviceInformation = (0, _pure2.default)(ActionPermDeviceInformation);
	ActionPermDeviceInformation.displayName = 'ActionPermDeviceInformation';
	ActionPermDeviceInformation.muiName = 'SvgIcon';
	
	exports.default = ActionPermDeviceInformation;

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermIdentity = function ActionPermIdentity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
	  );
	};
	ActionPermIdentity = (0, _pure2.default)(ActionPermIdentity);
	ActionPermIdentity.displayName = 'ActionPermIdentity';
	ActionPermIdentity.muiName = 'SvgIcon';
	
	exports.default = ActionPermIdentity;

/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermMedia = function ActionPermMedia(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z' })
	  );
	};
	ActionPermMedia = (0, _pure2.default)(ActionPermMedia);
	ActionPermMedia.displayName = 'ActionPermMedia';
	ActionPermMedia.muiName = 'SvgIcon';
	
	exports.default = ActionPermMedia;

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermPhoneMsg = function ActionPermPhoneMsg(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z' })
	  );
	};
	ActionPermPhoneMsg = (0, _pure2.default)(ActionPermPhoneMsg);
	ActionPermPhoneMsg.displayName = 'ActionPermPhoneMsg';
	ActionPermPhoneMsg.muiName = 'SvgIcon';
	
	exports.default = ActionPermPhoneMsg;

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermScanWifi = function ActionPermScanWifi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z' })
	  );
	};
	ActionPermScanWifi = (0, _pure2.default)(ActionPermScanWifi);
	ActionPermScanWifi.displayName = 'ActionPermScanWifi';
	ActionPermScanWifi.muiName = 'SvgIcon';
	
	exports.default = ActionPermScanWifi;

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPets = function ActionPets(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '4.5', cy: '9.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '9', cy: '5.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '15', cy: '5.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '19.5', cy: '9.5', r: '2.5' }),
	    _react2.default.createElement('path', { d: 'M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z' })
	  );
	};
	ActionPets = (0, _pure2.default)(ActionPets);
	ActionPets.displayName = 'ActionPets';
	ActionPets.muiName = 'SvgIcon';
	
	exports.default = ActionPets;

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPictureInPictureAlt = function ActionPictureInPictureAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z' })
	  );
	};
	ActionPictureInPictureAlt = (0, _pure2.default)(ActionPictureInPictureAlt);
	ActionPictureInPictureAlt.displayName = 'ActionPictureInPictureAlt';
	ActionPictureInPictureAlt.muiName = 'SvgIcon';
	
	exports.default = ActionPictureInPictureAlt;

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPictureInPicture = function ActionPictureInPicture(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z' })
	  );
	};
	ActionPictureInPicture = (0, _pure2.default)(ActionPictureInPicture);
	ActionPictureInPicture.displayName = 'ActionPictureInPicture';
	ActionPictureInPicture.muiName = 'SvgIcon';
	
	exports.default = ActionPictureInPicture;

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPlayForWork = function ActionPlayForWork(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z' })
	  );
	};
	ActionPlayForWork = (0, _pure2.default)(ActionPlayForWork);
	ActionPlayForWork.displayName = 'ActionPlayForWork';
	ActionPlayForWork.muiName = 'SvgIcon';
	
	exports.default = ActionPlayForWork;

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPolymer = function ActionPolymer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z' })
	  );
	};
	ActionPolymer = (0, _pure2.default)(ActionPolymer);
	ActionPolymer.displayName = 'ActionPolymer';
	ActionPolymer.muiName = 'SvgIcon';
	
	exports.default = ActionPolymer;

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPowerSettingsNew = function ActionPowerSettingsNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z' })
	  );
	};
	ActionPowerSettingsNew = (0, _pure2.default)(ActionPowerSettingsNew);
	ActionPowerSettingsNew.displayName = 'ActionPowerSettingsNew';
	ActionPowerSettingsNew.muiName = 'SvgIcon';
	
	exports.default = ActionPowerSettingsNew;

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPregnantWoman = function ActionPregnantWoman(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z' })
	  );
	};
	ActionPregnantWoman = (0, _pure2.default)(ActionPregnantWoman);
	ActionPregnantWoman.displayName = 'ActionPregnantWoman';
	ActionPregnantWoman.muiName = 'SvgIcon';
	
	exports.default = ActionPregnantWoman;

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPrint = function ActionPrint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
	  );
	};
	ActionPrint = (0, _pure2.default)(ActionPrint);
	ActionPrint.displayName = 'ActionPrint';
	ActionPrint.muiName = 'SvgIcon';
	
	exports.default = ActionPrint;

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionQueryBuilder = function ActionQueryBuilder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
	  );
	};
	ActionQueryBuilder = (0, _pure2.default)(ActionQueryBuilder);
	ActionQueryBuilder.displayName = 'ActionQueryBuilder';
	ActionQueryBuilder.muiName = 'SvgIcon';
	
	exports.default = ActionQueryBuilder;

/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionQuestionAnswer = function ActionQuestionAnswer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
	  );
	};
	ActionQuestionAnswer = (0, _pure2.default)(ActionQuestionAnswer);
	ActionQuestionAnswer.displayName = 'ActionQuestionAnswer';
	ActionQuestionAnswer.muiName = 'SvgIcon';
	
	exports.default = ActionQuestionAnswer;

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionReceipt = function ActionReceipt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z' })
	  );
	};
	ActionReceipt = (0, _pure2.default)(ActionReceipt);
	ActionReceipt.displayName = 'ActionReceipt';
	ActionReceipt.muiName = 'SvgIcon';
	
	exports.default = ActionReceipt;

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRecordVoiceOver = function ActionRecordVoiceOver(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '9', cy: '9', r: '4' }),
	    _react2.default.createElement('path', { d: 'M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z' })
	  );
	};
	ActionRecordVoiceOver = (0, _pure2.default)(ActionRecordVoiceOver);
	ActionRecordVoiceOver.displayName = 'ActionRecordVoiceOver';
	ActionRecordVoiceOver.muiName = 'SvgIcon';
	
	exports.default = ActionRecordVoiceOver;

/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRedeem = function ActionRedeem(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
	  );
	};
	ActionRedeem = (0, _pure2.default)(ActionRedeem);
	ActionRedeem.displayName = 'ActionRedeem';
	ActionRedeem.muiName = 'SvgIcon';
	
	exports.default = ActionRedeem;

/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRemoveShoppingCart = function ActionRemoveShoppingCart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z' })
	  );
	};
	ActionRemoveShoppingCart = (0, _pure2.default)(ActionRemoveShoppingCart);
	ActionRemoveShoppingCart.displayName = 'ActionRemoveShoppingCart';
	ActionRemoveShoppingCart.muiName = 'SvgIcon';
	
	exports.default = ActionRemoveShoppingCart;

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionReorder = function ActionReorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z' })
	  );
	};
	ActionReorder = (0, _pure2.default)(ActionReorder);
	ActionReorder.displayName = 'ActionReorder';
	ActionReorder.muiName = 'SvgIcon';
	
	exports.default = ActionReorder;

/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionReportProblem = function ActionReportProblem(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
	  );
	};
	ActionReportProblem = (0, _pure2.default)(ActionReportProblem);
	ActionReportProblem.displayName = 'ActionReportProblem';
	ActionReportProblem.muiName = 'SvgIcon';
	
	exports.default = ActionReportProblem;

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRestorePage = function ActionRestorePage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z' })
	  );
	};
	ActionRestorePage = (0, _pure2.default)(ActionRestorePage);
	ActionRestorePage.displayName = 'ActionRestorePage';
	ActionRestorePage.muiName = 'SvgIcon';
	
	exports.default = ActionRestorePage;

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRestore = function ActionRestore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
	  );
	};
	ActionRestore = (0, _pure2.default)(ActionRestore);
	ActionRestore.displayName = 'ActionRestore';
	ActionRestore.muiName = 'SvgIcon';
	
	exports.default = ActionRestore;

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRoom = function ActionRoom(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	ActionRoom = (0, _pure2.default)(ActionRoom);
	ActionRoom.displayName = 'ActionRoom';
	ActionRoom.muiName = 'SvgIcon';
	
	exports.default = ActionRoom;

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRoundedCorner = function ActionRoundedCorner(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z' })
	  );
	};
	ActionRoundedCorner = (0, _pure2.default)(ActionRoundedCorner);
	ActionRoundedCorner.displayName = 'ActionRoundedCorner';
	ActionRoundedCorner.muiName = 'SvgIcon';
	
	exports.default = ActionRoundedCorner;

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRowing = function ActionRowing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z' })
	  );
	};
	ActionRowing = (0, _pure2.default)(ActionRowing);
	ActionRowing.displayName = 'ActionRowing';
	ActionRowing.muiName = 'SvgIcon';
	
	exports.default = ActionRowing;

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSchedule = function ActionSchedule(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
	  );
	};
	ActionSchedule = (0, _pure2.default)(ActionSchedule);
	ActionSchedule.displayName = 'ActionSchedule';
	ActionSchedule.muiName = 'SvgIcon';
	
	exports.default = ActionSchedule;

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsApplications = function ActionSettingsApplications(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z' })
	  );
	};
	ActionSettingsApplications = (0, _pure2.default)(ActionSettingsApplications);
	ActionSettingsApplications.displayName = 'ActionSettingsApplications';
	ActionSettingsApplications.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsApplications;

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsBackupRestore = function ActionSettingsBackupRestore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z' })
	  );
	};
	ActionSettingsBackupRestore = (0, _pure2.default)(ActionSettingsBackupRestore);
	ActionSettingsBackupRestore.displayName = 'ActionSettingsBackupRestore';
	ActionSettingsBackupRestore.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsBackupRestore;

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsBluetooth = function ActionSettingsBluetooth(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z' })
	  );
	};
	ActionSettingsBluetooth = (0, _pure2.default)(ActionSettingsBluetooth);
	ActionSettingsBluetooth.displayName = 'ActionSettingsBluetooth';
	ActionSettingsBluetooth.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsBluetooth;

/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsBrightness = function ActionSettingsBrightness(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z' })
	  );
	};
	ActionSettingsBrightness = (0, _pure2.default)(ActionSettingsBrightness);
	ActionSettingsBrightness.displayName = 'ActionSettingsBrightness';
	ActionSettingsBrightness.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsBrightness;

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsCell = function ActionSettingsCell(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z' })
	  );
	};
	ActionSettingsCell = (0, _pure2.default)(ActionSettingsCell);
	ActionSettingsCell.displayName = 'ActionSettingsCell';
	ActionSettingsCell.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsCell;

/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsEthernet = function ActionSettingsEthernet(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z' })
	  );
	};
	ActionSettingsEthernet = (0, _pure2.default)(ActionSettingsEthernet);
	ActionSettingsEthernet.displayName = 'ActionSettingsEthernet';
	ActionSettingsEthernet.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsEthernet;

/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputAntenna = function ActionSettingsInputAntenna(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z' })
	  );
	};
	ActionSettingsInputAntenna = (0, _pure2.default)(ActionSettingsInputAntenna);
	ActionSettingsInputAntenna.displayName = 'ActionSettingsInputAntenna';
	ActionSettingsInputAntenna.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputAntenna;

/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputComponent = function ActionSettingsInputComponent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
	  );
	};
	ActionSettingsInputComponent = (0, _pure2.default)(ActionSettingsInputComponent);
	ActionSettingsInputComponent.displayName = 'ActionSettingsInputComponent';
	ActionSettingsInputComponent.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputComponent;

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputComposite = function ActionSettingsInputComposite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
	  );
	};
	ActionSettingsInputComposite = (0, _pure2.default)(ActionSettingsInputComposite);
	ActionSettingsInputComposite.displayName = 'ActionSettingsInputComposite';
	ActionSettingsInputComposite.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputComposite;

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputHdmi = function ActionSettingsInputHdmi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z' })
	  );
	};
	ActionSettingsInputHdmi = (0, _pure2.default)(ActionSettingsInputHdmi);
	ActionSettingsInputHdmi.displayName = 'ActionSettingsInputHdmi';
	ActionSettingsInputHdmi.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputHdmi;

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputSvideo = function ActionSettingsInputSvideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
	  );
	};
	ActionSettingsInputSvideo = (0, _pure2.default)(ActionSettingsInputSvideo);
	ActionSettingsInputSvideo.displayName = 'ActionSettingsInputSvideo';
	ActionSettingsInputSvideo.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputSvideo;

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsOverscan = function ActionSettingsOverscan(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
	  );
	};
	ActionSettingsOverscan = (0, _pure2.default)(ActionSettingsOverscan);
	ActionSettingsOverscan.displayName = 'ActionSettingsOverscan';
	ActionSettingsOverscan.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsOverscan;

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsPhone = function ActionSettingsPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z' })
	  );
	};
	ActionSettingsPhone = (0, _pure2.default)(ActionSettingsPhone);
	ActionSettingsPhone.displayName = 'ActionSettingsPhone';
	ActionSettingsPhone.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsPhone;

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsPower = function ActionSettingsPower(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z' })
	  );
	};
	ActionSettingsPower = (0, _pure2.default)(ActionSettingsPower);
	ActionSettingsPower.displayName = 'ActionSettingsPower';
	ActionSettingsPower.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsPower;

/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsRemote = function ActionSettingsRemote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z' })
	  );
	};
	ActionSettingsRemote = (0, _pure2.default)(ActionSettingsRemote);
	ActionSettingsRemote.displayName = 'ActionSettingsRemote';
	ActionSettingsRemote.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsRemote;

/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsVoice = function ActionSettingsVoice(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z' })
	  );
	};
	ActionSettingsVoice = (0, _pure2.default)(ActionSettingsVoice);
	ActionSettingsVoice.displayName = 'ActionSettingsVoice';
	ActionSettingsVoice.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsVoice;

/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShopTwo = function ActionShopTwo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z' })
	  );
	};
	ActionShopTwo = (0, _pure2.default)(ActionShopTwo);
	ActionShopTwo.displayName = 'ActionShopTwo';
	ActionShopTwo.muiName = 'SvgIcon';
	
	exports.default = ActionShopTwo;

/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShop = function ActionShop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z' })
	  );
	};
	ActionShop = (0, _pure2.default)(ActionShop);
	ActionShop.displayName = 'ActionShop';
	ActionShop.muiName = 'SvgIcon';
	
	exports.default = ActionShop;

/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShoppingBasket = function ActionShoppingBasket(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ActionShoppingBasket = (0, _pure2.default)(ActionShoppingBasket);
	ActionShoppingBasket.displayName = 'ActionShoppingBasket';
	ActionShoppingBasket.muiName = 'SvgIcon';
	
	exports.default = ActionShoppingBasket;

/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShoppingCart = function ActionShoppingCart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	ActionShoppingCart = (0, _pure2.default)(ActionShoppingCart);
	ActionShoppingCart.displayName = 'ActionShoppingCart';
	ActionShoppingCart.muiName = 'SvgIcon';
	
	exports.default = ActionShoppingCart;

/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSpeakerNotesOff = function ActionSpeakerNotesOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionSpeakerNotesOff = (0, _pure2.default)(ActionSpeakerNotesOff);
	ActionSpeakerNotesOff.displayName = 'ActionSpeakerNotesOff';
	ActionSpeakerNotesOff.muiName = 'SvgIcon';
	
	exports.default = ActionSpeakerNotesOff;

/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSpeakerNotes = function ActionSpeakerNotes(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z' })
	  );
	};
	ActionSpeakerNotes = (0, _pure2.default)(ActionSpeakerNotes);
	ActionSpeakerNotes.displayName = 'ActionSpeakerNotes';
	ActionSpeakerNotes.muiName = 'SvgIcon';
	
	exports.default = ActionSpeakerNotes;

/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSpellcheck = function ActionSpellcheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z' })
	  );
	};
	ActionSpellcheck = (0, _pure2.default)(ActionSpellcheck);
	ActionSpellcheck.displayName = 'ActionSpellcheck';
	ActionSpellcheck.muiName = 'SvgIcon';
	
	exports.default = ActionSpellcheck;

/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionStars = function ActionStars(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z' })
	  );
	};
	ActionStars = (0, _pure2.default)(ActionStars);
	ActionStars.displayName = 'ActionStars';
	ActionStars.muiName = 'SvgIcon';
	
	exports.default = ActionStars;

/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionStore = function ActionStore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
	  );
	};
	ActionStore = (0, _pure2.default)(ActionStore);
	ActionStore.displayName = 'ActionStore';
	ActionStore.muiName = 'SvgIcon';
	
	exports.default = ActionStore;

/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSubject = function ActionSubject(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z' })
	  );
	};
	ActionSubject = (0, _pure2.default)(ActionSubject);
	ActionSubject.displayName = 'ActionSubject';
	ActionSubject.muiName = 'SvgIcon';
	
	exports.default = ActionSubject;

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSupervisorAccount = function ActionSupervisorAccount(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z' })
	  );
	};
	ActionSupervisorAccount = (0, _pure2.default)(ActionSupervisorAccount);
	ActionSupervisorAccount.displayName = 'ActionSupervisorAccount';
	ActionSupervisorAccount.muiName = 'SvgIcon';
	
	exports.default = ActionSupervisorAccount;

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapHoriz = function ActionSwapHoriz(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' })
	  );
	};
	ActionSwapHoriz = (0, _pure2.default)(ActionSwapHoriz);
	ActionSwapHoriz.displayName = 'ActionSwapHoriz';
	ActionSwapHoriz.muiName = 'SvgIcon';
	
	exports.default = ActionSwapHoriz;

/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapVert = function ActionSwapVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z' })
	  );
	};
	ActionSwapVert = (0, _pure2.default)(ActionSwapVert);
	ActionSwapVert.displayName = 'ActionSwapVert';
	ActionSwapVert.muiName = 'SvgIcon';
	
	exports.default = ActionSwapVert;

/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapVerticalCircle = function ActionSwapVerticalCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z' })
	  );
	};
	ActionSwapVerticalCircle = (0, _pure2.default)(ActionSwapVerticalCircle);
	ActionSwapVerticalCircle.displayName = 'ActionSwapVerticalCircle';
	ActionSwapVerticalCircle.muiName = 'SvgIcon';
	
	exports.default = ActionSwapVerticalCircle;

/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSystemUpdateAlt = function ActionSystemUpdateAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionSystemUpdateAlt = (0, _pure2.default)(ActionSystemUpdateAlt);
	ActionSystemUpdateAlt.displayName = 'ActionSystemUpdateAlt';
	ActionSystemUpdateAlt.muiName = 'SvgIcon';
	
	exports.default = ActionSystemUpdateAlt;

/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTabUnselected = function ActionTabUnselected(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z' })
	  );
	};
	ActionTabUnselected = (0, _pure2.default)(ActionTabUnselected);
	ActionTabUnselected.displayName = 'ActionTabUnselected';
	ActionTabUnselected.muiName = 'SvgIcon';
	
	exports.default = ActionTabUnselected;

/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTab = function ActionTab(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z' })
	  );
	};
	ActionTab = (0, _pure2.default)(ActionTab);
	ActionTab.displayName = 'ActionTab';
	ActionTab.muiName = 'SvgIcon';
	
	exports.default = ActionTab;

/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTheaters = function ActionTheaters(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
	  );
	};
	ActionTheaters = (0, _pure2.default)(ActionTheaters);
	ActionTheaters.displayName = 'ActionTheaters';
	ActionTheaters.muiName = 'SvgIcon';
	
	exports.default = ActionTheaters;

/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThreeDRotation = function ActionThreeDRotation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z' })
	  );
	};
	ActionThreeDRotation = (0, _pure2.default)(ActionThreeDRotation);
	ActionThreeDRotation.displayName = 'ActionThreeDRotation';
	ActionThreeDRotation.muiName = 'SvgIcon';
	
	exports.default = ActionThreeDRotation;

/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThumbDown = function ActionThumbDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z' })
	  );
	};
	ActionThumbDown = (0, _pure2.default)(ActionThumbDown);
	ActionThumbDown.displayName = 'ActionThumbDown';
	ActionThumbDown.muiName = 'SvgIcon';
	
	exports.default = ActionThumbDown;

/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThumbUp = function ActionThumbUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z' })
	  );
	};
	ActionThumbUp = (0, _pure2.default)(ActionThumbUp);
	ActionThumbUp.displayName = 'ActionThumbUp';
	ActionThumbUp.muiName = 'SvgIcon';
	
	exports.default = ActionThumbUp;

/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThumbsUpDown = function ActionThumbsUpDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z' })
	  );
	};
	ActionThumbsUpDown = (0, _pure2.default)(ActionThumbsUpDown);
	ActionThumbsUpDown.displayName = 'ActionThumbsUpDown';
	ActionThumbsUpDown.muiName = 'SvgIcon';
	
	exports.default = ActionThumbsUpDown;

/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTimeline = function ActionTimeline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z' })
	  );
	};
	ActionTimeline = (0, _pure2.default)(ActionTimeline);
	ActionTimeline.displayName = 'ActionTimeline';
	ActionTimeline.muiName = 'SvgIcon';
	
	exports.default = ActionTimeline;

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionToc = function ActionToc(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z' })
	  );
	};
	ActionToc = (0, _pure2.default)(ActionToc);
	ActionToc.displayName = 'ActionToc';
	ActionToc.muiName = 'SvgIcon';
	
	exports.default = ActionToc;

/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionToday = function ActionToday(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z' })
	  );
	};
	ActionToday = (0, _pure2.default)(ActionToday);
	ActionToday.displayName = 'ActionToday';
	ActionToday.muiName = 'SvgIcon';
	
	exports.default = ActionToday;

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionToll = function ActionToll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z' })
	  );
	};
	ActionToll = (0, _pure2.default)(ActionToll);
	ActionToll.displayName = 'ActionToll';
	ActionToll.muiName = 'SvgIcon';
	
	exports.default = ActionToll;

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTouchApp = function ActionTouchApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z' })
	  );
	};
	ActionTouchApp = (0, _pure2.default)(ActionTouchApp);
	ActionTouchApp.displayName = 'ActionTouchApp';
	ActionTouchApp.muiName = 'SvgIcon';
	
	exports.default = ActionTouchApp;

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrackChanges = function ActionTrackChanges(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z' })
	  );
	};
	ActionTrackChanges = (0, _pure2.default)(ActionTrackChanges);
	ActionTrackChanges.displayName = 'ActionTrackChanges';
	ActionTrackChanges.muiName = 'SvgIcon';
	
	exports.default = ActionTrackChanges;

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTranslate = function ActionTranslate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z' })
	  );
	};
	ActionTranslate = (0, _pure2.default)(ActionTranslate);
	ActionTranslate.displayName = 'ActionTranslate';
	ActionTranslate.muiName = 'SvgIcon';
	
	exports.default = ActionTranslate;

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrendingDown = function ActionTrendingDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z' })
	  );
	};
	ActionTrendingDown = (0, _pure2.default)(ActionTrendingDown);
	ActionTrendingDown.displayName = 'ActionTrendingDown';
	ActionTrendingDown.muiName = 'SvgIcon';
	
	exports.default = ActionTrendingDown;

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrendingFlat = function ActionTrendingFlat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 12l-4-4v3H3v2h15v3z' })
	  );
	};
	ActionTrendingFlat = (0, _pure2.default)(ActionTrendingFlat);
	ActionTrendingFlat.displayName = 'ActionTrendingFlat';
	ActionTrendingFlat.muiName = 'SvgIcon';
	
	exports.default = ActionTrendingFlat;

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrendingUp = function ActionTrendingUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z' })
	  );
	};
	ActionTrendingUp = (0, _pure2.default)(ActionTrendingUp);
	ActionTrendingUp.displayName = 'ActionTrendingUp';
	ActionTrendingUp.muiName = 'SvgIcon';
	
	exports.default = ActionTrendingUp;

/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTurnedInNot = function ActionTurnedInNot(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
	  );
	};
	ActionTurnedInNot = (0, _pure2.default)(ActionTurnedInNot);
	ActionTurnedInNot.displayName = 'ActionTurnedInNot';
	ActionTurnedInNot.muiName = 'SvgIcon';
	
	exports.default = ActionTurnedInNot;

/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTurnedIn = function ActionTurnedIn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionTurnedIn = (0, _pure2.default)(ActionTurnedIn);
	ActionTurnedIn.displayName = 'ActionTurnedIn';
	ActionTurnedIn.muiName = 'SvgIcon';
	
	exports.default = ActionTurnedIn;

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionUpdate = function ActionUpdate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z' })
	  );
	};
	ActionUpdate = (0, _pure2.default)(ActionUpdate);
	ActionUpdate.displayName = 'ActionUpdate';
	ActionUpdate.muiName = 'SvgIcon';
	
	exports.default = ActionUpdate;

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionVerifiedUser = function ActionVerifiedUser(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
	  );
	};
	ActionVerifiedUser = (0, _pure2.default)(ActionVerifiedUser);
	ActionVerifiedUser.displayName = 'ActionVerifiedUser';
	ActionVerifiedUser.muiName = 'SvgIcon';
	
	exports.default = ActionVerifiedUser;

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewAgenda = function ActionViewAgenda(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z' })
	  );
	};
	ActionViewAgenda = (0, _pure2.default)(ActionViewAgenda);
	ActionViewAgenda.displayName = 'ActionViewAgenda';
	ActionViewAgenda.muiName = 'SvgIcon';
	
	exports.default = ActionViewAgenda;

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewArray = function ActionViewArray(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z' })
	  );
	};
	ActionViewArray = (0, _pure2.default)(ActionViewArray);
	ActionViewArray.displayName = 'ActionViewArray';
	ActionViewArray.muiName = 'SvgIcon';
	
	exports.default = ActionViewArray;

/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewCarousel = function ActionViewCarousel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z' })
	  );
	};
	ActionViewCarousel = (0, _pure2.default)(ActionViewCarousel);
	ActionViewCarousel.displayName = 'ActionViewCarousel';
	ActionViewCarousel.muiName = 'SvgIcon';
	
	exports.default = ActionViewCarousel;

/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewColumn = function ActionViewColumn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z' })
	  );
	};
	ActionViewColumn = (0, _pure2.default)(ActionViewColumn);
	ActionViewColumn.displayName = 'ActionViewColumn';
	ActionViewColumn.muiName = 'SvgIcon';
	
	exports.default = ActionViewColumn;

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewDay = function ActionViewDay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z' })
	  );
	};
	ActionViewDay = (0, _pure2.default)(ActionViewDay);
	ActionViewDay.displayName = 'ActionViewDay';
	ActionViewDay.muiName = 'SvgIcon';
	
	exports.default = ActionViewDay;

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewHeadline = function ActionViewHeadline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z' })
	  );
	};
	ActionViewHeadline = (0, _pure2.default)(ActionViewHeadline);
	ActionViewHeadline.displayName = 'ActionViewHeadline';
	ActionViewHeadline.muiName = 'SvgIcon';
	
	exports.default = ActionViewHeadline;

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewList = function ActionViewList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z' })
	  );
	};
	ActionViewList = (0, _pure2.default)(ActionViewList);
	ActionViewList.displayName = 'ActionViewList';
	ActionViewList.muiName = 'SvgIcon';
	
	exports.default = ActionViewList;

/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewModule = function ActionViewModule(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z' })
	  );
	};
	ActionViewModule = (0, _pure2.default)(ActionViewModule);
	ActionViewModule.displayName = 'ActionViewModule';
	ActionViewModule.muiName = 'SvgIcon';
	
	exports.default = ActionViewModule;

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewQuilt = function ActionViewQuilt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z' })
	  );
	};
	ActionViewQuilt = (0, _pure2.default)(ActionViewQuilt);
	ActionViewQuilt.displayName = 'ActionViewQuilt';
	ActionViewQuilt.muiName = 'SvgIcon';
	
	exports.default = ActionViewQuilt;

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewStream = function ActionViewStream(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18h17v-6H4v6zM4 5v6h17V5H4z' })
	  );
	};
	ActionViewStream = (0, _pure2.default)(ActionViewStream);
	ActionViewStream.displayName = 'ActionViewStream';
	ActionViewStream.muiName = 'SvgIcon';
	
	exports.default = ActionViewStream;

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewWeek = function ActionViewWeek(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z' })
	  );
	};
	ActionViewWeek = (0, _pure2.default)(ActionViewWeek);
	ActionViewWeek.displayName = 'ActionViewWeek';
	ActionViewWeek.muiName = 'SvgIcon';
	
	exports.default = ActionViewWeek;

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionVisibilityOff = function ActionVisibilityOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z' })
	  );
	};
	ActionVisibilityOff = (0, _pure2.default)(ActionVisibilityOff);
	ActionVisibilityOff.displayName = 'ActionVisibilityOff';
	ActionVisibilityOff.muiName = 'SvgIcon';
	
	exports.default = ActionVisibilityOff;

/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionVisibility = function ActionVisibility(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	ActionVisibility = (0, _pure2.default)(ActionVisibility);
	ActionVisibility.displayName = 'ActionVisibility';
	ActionVisibility.muiName = 'SvgIcon';
	
	exports.default = ActionVisibility;

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionWatchLater = function ActionWatchLater(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z' })
	  );
	};
	ActionWatchLater = (0, _pure2.default)(ActionWatchLater);
	ActionWatchLater.displayName = 'ActionWatchLater';
	ActionWatchLater.muiName = 'SvgIcon';
	
	exports.default = ActionWatchLater;

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionWork = function ActionWork(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z' })
	  );
	};
	ActionWork = (0, _pure2.default)(ActionWork);
	ActionWork.displayName = 'ActionWork';
	ActionWork.muiName = 'SvgIcon';
	
	exports.default = ActionWork;

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionYoutubeSearchedFor = function ActionYoutubeSearchedFor(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z' })
	  );
	};
	ActionYoutubeSearchedFor = (0, _pure2.default)(ActionYoutubeSearchedFor);
	ActionYoutubeSearchedFor.displayName = 'ActionYoutubeSearchedFor';
	ActionYoutubeSearchedFor.muiName = 'SvgIcon';
	
	exports.default = ActionYoutubeSearchedFor;

/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionZoomIn = function ActionZoomIn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z' })
	  );
	};
	ActionZoomIn = (0, _pure2.default)(ActionZoomIn);
	ActionZoomIn.displayName = 'ActionZoomIn';
	ActionZoomIn.muiName = 'SvgIcon';
	
	exports.default = ActionZoomIn;

/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionZoomOut = function ActionZoomOut(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z' })
	  );
	};
	ActionZoomOut = (0, _pure2.default)(ActionZoomOut);
	ActionZoomOut.displayName = 'ActionZoomOut';
	ActionZoomOut.muiName = 'SvgIcon';
	
	exports.default = ActionZoomOut;

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertAddAlert = function AlertAddAlert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z' })
	  );
	};
	AlertAddAlert = (0, _pure2.default)(AlertAddAlert);
	AlertAddAlert.displayName = 'AlertAddAlert';
	AlertAddAlert.muiName = 'SvgIcon';
	
	exports.default = AlertAddAlert;

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertErrorOutline = function AlertErrorOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	AlertErrorOutline = (0, _pure2.default)(AlertErrorOutline);
	AlertErrorOutline.displayName = 'AlertErrorOutline';
	AlertErrorOutline.muiName = 'SvgIcon';
	
	exports.default = AlertErrorOutline;

/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertWarning = function AlertWarning(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
	  );
	};
	AlertWarning = (0, _pure2.default)(AlertWarning);
	AlertWarning.displayName = 'AlertWarning';
	AlertWarning.muiName = 'SvgIcon';
	
	exports.default = AlertWarning;

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAddToQueue = function AvAddToQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z' })
	  );
	};
	AvAddToQueue = (0, _pure2.default)(AvAddToQueue);
	AvAddToQueue.displayName = 'AvAddToQueue';
	AvAddToQueue.muiName = 'SvgIcon';
	
	exports.default = AvAddToQueue;

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAirplay = function AvAirplay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	AvAirplay = (0, _pure2.default)(AvAirplay);
	AvAirplay.displayName = 'AvAirplay';
	AvAirplay.muiName = 'SvgIcon';
	
	exports.default = AvAirplay;

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAlbum = function AvAlbum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
	  );
	};
	AvAlbum = (0, _pure2.default)(AvAlbum);
	AvAlbum.displayName = 'AvAlbum';
	AvAlbum.muiName = 'SvgIcon';
	
	exports.default = AvAlbum;

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvArtTrack = function AvArtTrack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z' })
	  );
	};
	AvArtTrack = (0, _pure2.default)(AvArtTrack);
	AvArtTrack.displayName = 'AvArtTrack';
	AvArtTrack.muiName = 'SvgIcon';
	
	exports.default = AvArtTrack;

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAvTimer = function AvAvTimer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z' })
	  );
	};
	AvAvTimer = (0, _pure2.default)(AvAvTimer);
	AvAvTimer.displayName = 'AvAvTimer';
	AvAvTimer.muiName = 'SvgIcon';
	
	exports.default = AvAvTimer;

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvBrandingWatermark = function AvBrandingWatermark(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z' })
	  );
	};
	AvBrandingWatermark = (0, _pure2.default)(AvBrandingWatermark);
	AvBrandingWatermark.displayName = 'AvBrandingWatermark';
	AvBrandingWatermark.muiName = 'SvgIcon';
	
	exports.default = AvBrandingWatermark;

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvCallToAction = function AvCallToAction(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z' })
	  );
	};
	AvCallToAction = (0, _pure2.default)(AvCallToAction);
	AvCallToAction.displayName = 'AvCallToAction';
	AvCallToAction.muiName = 'SvgIcon';
	
	exports.default = AvCallToAction;

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvClosedCaption = function AvClosedCaption(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z' })
	  );
	};
	AvClosedCaption = (0, _pure2.default)(AvClosedCaption);
	AvClosedCaption.displayName = 'AvClosedCaption';
	AvClosedCaption.muiName = 'SvgIcon';
	
	exports.default = AvClosedCaption;

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvEqualizer = function AvEqualizer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z' })
	  );
	};
	AvEqualizer = (0, _pure2.default)(AvEqualizer);
	AvEqualizer.displayName = 'AvEqualizer';
	AvEqualizer.muiName = 'SvgIcon';
	
	exports.default = AvEqualizer;

/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvExplicit = function AvExplicit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z' })
	  );
	};
	AvExplicit = (0, _pure2.default)(AvExplicit);
	AvExplicit.displayName = 'AvExplicit';
	AvExplicit.muiName = 'SvgIcon';
	
	exports.default = AvExplicit;

/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFastForward = function AvFastForward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z' })
	  );
	};
	AvFastForward = (0, _pure2.default)(AvFastForward);
	AvFastForward.displayName = 'AvFastForward';
	AvFastForward.muiName = 'SvgIcon';
	
	exports.default = AvFastForward;

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFastRewind = function AvFastRewind(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z' })
	  );
	};
	AvFastRewind = (0, _pure2.default)(AvFastRewind);
	AvFastRewind.displayName = 'AvFastRewind';
	AvFastRewind.muiName = 'SvgIcon';
	
	exports.default = AvFastRewind;

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFeaturedPlayList = function AvFeaturedPlayList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z' })
	  );
	};
	AvFeaturedPlayList = (0, _pure2.default)(AvFeaturedPlayList);
	AvFeaturedPlayList.displayName = 'AvFeaturedPlayList';
	AvFeaturedPlayList.muiName = 'SvgIcon';
	
	exports.default = AvFeaturedPlayList;

/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFeaturedVideo = function AvFeaturedVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z' })
	  );
	};
	AvFeaturedVideo = (0, _pure2.default)(AvFeaturedVideo);
	AvFeaturedVideo.displayName = 'AvFeaturedVideo';
	AvFeaturedVideo.muiName = 'SvgIcon';
	
	exports.default = AvFeaturedVideo;

/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberDvr = function AvFiberDvr(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z' })
	  );
	};
	AvFiberDvr = (0, _pure2.default)(AvFiberDvr);
	AvFiberDvr.displayName = 'AvFiberDvr';
	AvFiberDvr.muiName = 'SvgIcon';
	
	exports.default = AvFiberDvr;

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberManualRecord = function AvFiberManualRecord(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '8' })
	  );
	};
	AvFiberManualRecord = (0, _pure2.default)(AvFiberManualRecord);
	AvFiberManualRecord.displayName = 'AvFiberManualRecord';
	AvFiberManualRecord.muiName = 'SvgIcon';
	
	exports.default = AvFiberManualRecord;

/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberNew = function AvFiberNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z' })
	  );
	};
	AvFiberNew = (0, _pure2.default)(AvFiberNew);
	AvFiberNew.displayName = 'AvFiberNew';
	AvFiberNew.muiName = 'SvgIcon';
	
	exports.default = AvFiberNew;

/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberPin = function AvFiberPin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z' })
	  );
	};
	AvFiberPin = (0, _pure2.default)(AvFiberPin);
	AvFiberPin.displayName = 'AvFiberPin';
	AvFiberPin.muiName = 'SvgIcon';
	
	exports.default = AvFiberPin;

/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberSmartRecord = function AvFiberSmartRecord(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('circle', { cx: '9', cy: '12', r: '8' }),
	      _react2.default.createElement('path', { d: 'M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z' })
	    )
	  );
	};
	AvFiberSmartRecord = (0, _pure2.default)(AvFiberSmartRecord);
	AvFiberSmartRecord.displayName = 'AvFiberSmartRecord';
	AvFiberSmartRecord.muiName = 'SvgIcon';
	
	exports.default = AvFiberSmartRecord;

/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvForward10 = function AvForward10(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
	  );
	};
	AvForward10 = (0, _pure2.default)(AvForward10);
	AvForward10.displayName = 'AvForward10';
	AvForward10.muiName = 'SvgIcon';
	
	exports.default = AvForward10;

/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvForward30 = function AvForward30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z' })
	  );
	};
	AvForward30 = (0, _pure2.default)(AvForward30);
	AvForward30.displayName = 'AvForward30';
	AvForward30.muiName = 'SvgIcon';
	
	exports.default = AvForward30;

/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvForward5 = function AvForward5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z' })
	  );
	};
	AvForward5 = (0, _pure2.default)(AvForward5);
	AvForward5.displayName = 'AvForward5';
	AvForward5.muiName = 'SvgIcon';
	
	exports.default = AvForward5;

/***/ },
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvGames = function AvGames(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
	  );
	};
	AvGames = (0, _pure2.default)(AvGames);
	AvGames.displayName = 'AvGames';
	AvGames.muiName = 'SvgIcon';
	
	exports.default = AvGames;

/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvHd = function AvHd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z' })
	  );
	};
	AvHd = (0, _pure2.default)(AvHd);
	AvHd.displayName = 'AvHd';
	AvHd.muiName = 'SvgIcon';
	
	exports.default = AvHd;

/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvHearing = function AvHearing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z' })
	  );
	};
	AvHearing = (0, _pure2.default)(AvHearing);
	AvHearing.displayName = 'AvHearing';
	AvHearing.muiName = 'SvgIcon';
	
	exports.default = AvHearing;

/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvHighQuality = function AvHighQuality(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z' })
	  );
	};
	AvHighQuality = (0, _pure2.default)(AvHighQuality);
	AvHighQuality.displayName = 'AvHighQuality';
	AvHighQuality.muiName = 'SvgIcon';
	
	exports.default = AvHighQuality;

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLibraryAdd = function AvLibraryAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
	  );
	};
	AvLibraryAdd = (0, _pure2.default)(AvLibraryAdd);
	AvLibraryAdd.displayName = 'AvLibraryAdd';
	AvLibraryAdd.muiName = 'SvgIcon';
	
	exports.default = AvLibraryAdd;

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLibraryBooks = function AvLibraryBooks(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z' })
	  );
	};
	AvLibraryBooks = (0, _pure2.default)(AvLibraryBooks);
	AvLibraryBooks.displayName = 'AvLibraryBooks';
	AvLibraryBooks.muiName = 'SvgIcon';
	
	exports.default = AvLibraryBooks;

/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLibraryMusic = function AvLibraryMusic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z' })
	  );
	};
	AvLibraryMusic = (0, _pure2.default)(AvLibraryMusic);
	AvLibraryMusic.displayName = 'AvLibraryMusic';
	AvLibraryMusic.muiName = 'SvgIcon';
	
	exports.default = AvLibraryMusic;

/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLoop = function AvLoop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
	  );
	};
	AvLoop = (0, _pure2.default)(AvLoop);
	AvLoop.displayName = 'AvLoop';
	AvLoop.muiName = 'SvgIcon';
	
	exports.default = AvLoop;

/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMicNone = function AvMicNone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	AvMicNone = (0, _pure2.default)(AvMicNone);
	AvMicNone.displayName = 'AvMicNone';
	AvMicNone.muiName = 'SvgIcon';
	
	exports.default = AvMicNone;

/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMicOff = function AvMicOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z' })
	  );
	};
	AvMicOff = (0, _pure2.default)(AvMicOff);
	AvMicOff.displayName = 'AvMicOff';
	AvMicOff.muiName = 'SvgIcon';
	
	exports.default = AvMicOff;

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMic = function AvMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	AvMic = (0, _pure2.default)(AvMic);
	AvMic.displayName = 'AvMic';
	AvMic.muiName = 'SvgIcon';
	
	exports.default = AvMic;

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMovie = function AvMovie(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
	  );
	};
	AvMovie = (0, _pure2.default)(AvMovie);
	AvMovie.displayName = 'AvMovie';
	AvMovie.muiName = 'SvgIcon';
	
	exports.default = AvMovie;

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMusicVideo = function AvMusicVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z' })
	  );
	};
	AvMusicVideo = (0, _pure2.default)(AvMusicVideo);
	AvMusicVideo.displayName = 'AvMusicVideo';
	AvMusicVideo.muiName = 'SvgIcon';
	
	exports.default = AvMusicVideo;

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvNewReleases = function AvNewReleases(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z' })
	  );
	};
	AvNewReleases = (0, _pure2.default)(AvNewReleases);
	AvNewReleases.displayName = 'AvNewReleases';
	AvNewReleases.muiName = 'SvgIcon';
	
	exports.default = AvNewReleases;

/***/ },
/* 1999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvNotInterested = function AvNotInterested(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
	  );
	};
	AvNotInterested = (0, _pure2.default)(AvNotInterested);
	AvNotInterested.displayName = 'AvNotInterested';
	AvNotInterested.muiName = 'SvgIcon';
	
	exports.default = AvNotInterested;

/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvNote = function AvNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z' })
	  );
	};
	AvNote = (0, _pure2.default)(AvNote);
	AvNote.displayName = 'AvNote';
	AvNote.muiName = 'SvgIcon';
	
	exports.default = AvNote;

/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPauseCircleFilled = function AvPauseCircleFilled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z' })
	  );
	};
	AvPauseCircleFilled = (0, _pure2.default)(AvPauseCircleFilled);
	AvPauseCircleFilled.displayName = 'AvPauseCircleFilled';
	AvPauseCircleFilled.muiName = 'SvgIcon';
	
	exports.default = AvPauseCircleFilled;

/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPauseCircleOutline = function AvPauseCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z' })
	  );
	};
	AvPauseCircleOutline = (0, _pure2.default)(AvPauseCircleOutline);
	AvPauseCircleOutline.displayName = 'AvPauseCircleOutline';
	AvPauseCircleOutline.muiName = 'SvgIcon';
	
	exports.default = AvPauseCircleOutline;

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPause = function AvPause(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z' })
	  );
	};
	AvPause = (0, _pure2.default)(AvPause);
	AvPause.displayName = 'AvPause';
	AvPause.muiName = 'SvgIcon';
	
	exports.default = AvPause;

/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayCircleFilled = function AvPlayCircleFilled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z' })
	  );
	};
	AvPlayCircleFilled = (0, _pure2.default)(AvPlayCircleFilled);
	AvPlayCircleFilled.displayName = 'AvPlayCircleFilled';
	AvPlayCircleFilled.muiName = 'SvgIcon';
	
	exports.default = AvPlayCircleFilled;

/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayCircleOutline = function AvPlayCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	AvPlayCircleOutline = (0, _pure2.default)(AvPlayCircleOutline);
	AvPlayCircleOutline.displayName = 'AvPlayCircleOutline';
	AvPlayCircleOutline.muiName = 'SvgIcon';
	
	exports.default = AvPlayCircleOutline;

/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlaylistAddCheck = function AvPlaylistAddCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z' })
	  );
	};
	AvPlaylistAddCheck = (0, _pure2.default)(AvPlaylistAddCheck);
	AvPlaylistAddCheck.displayName = 'AvPlaylistAddCheck';
	AvPlaylistAddCheck.muiName = 'SvgIcon';
	
	exports.default = AvPlaylistAddCheck;

/***/ },
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlaylistAdd = function AvPlaylistAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z' })
	  );
	};
	AvPlaylistAdd = (0, _pure2.default)(AvPlaylistAdd);
	AvPlaylistAdd.displayName = 'AvPlaylistAdd';
	AvPlaylistAdd.muiName = 'SvgIcon';
	
	exports.default = AvPlaylistAdd;

/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlaylistPlay = function AvPlaylistPlay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z' })
	  );
	};
	AvPlaylistPlay = (0, _pure2.default)(AvPlaylistPlay);
	AvPlaylistPlay.displayName = 'AvPlaylistPlay';
	AvPlaylistPlay.muiName = 'SvgIcon';
	
	exports.default = AvPlaylistPlay;

/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvQueueMusic = function AvQueueMusic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z' })
	  );
	};
	AvQueueMusic = (0, _pure2.default)(AvQueueMusic);
	AvQueueMusic.displayName = 'AvQueueMusic';
	AvQueueMusic.muiName = 'SvgIcon';
	
	exports.default = AvQueueMusic;

/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvQueuePlayNext = function AvQueuePlayNext(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z' })
	  );
	};
	AvQueuePlayNext = (0, _pure2.default)(AvQueuePlayNext);
	AvQueuePlayNext.displayName = 'AvQueuePlayNext';
	AvQueuePlayNext.muiName = 'SvgIcon';
	
	exports.default = AvQueuePlayNext;

/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvQueue = function AvQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
	  );
	};
	AvQueue = (0, _pure2.default)(AvQueue);
	AvQueue.displayName = 'AvQueue';
	AvQueue.muiName = 'SvgIcon';
	
	exports.default = AvQueue;

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRadio = function AvRadio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z' })
	  );
	};
	AvRadio = (0, _pure2.default)(AvRadio);
	AvRadio.displayName = 'AvRadio';
	AvRadio.muiName = 'SvgIcon';
	
	exports.default = AvRadio;

/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRecentActors = function AvRecentActors(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z' })
	  );
	};
	AvRecentActors = (0, _pure2.default)(AvRecentActors);
	AvRecentActors.displayName = 'AvRecentActors';
	AvRecentActors.muiName = 'SvgIcon';
	
	exports.default = AvRecentActors;

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRemoveFromQueue = function AvRemoveFromQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z' })
	  );
	};
	AvRemoveFromQueue = (0, _pure2.default)(AvRemoveFromQueue);
	AvRemoveFromQueue.displayName = 'AvRemoveFromQueue';
	AvRemoveFromQueue.muiName = 'SvgIcon';
	
	exports.default = AvRemoveFromQueue;

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRepeatOne = function AvRepeatOne(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z' })
	  );
	};
	AvRepeatOne = (0, _pure2.default)(AvRepeatOne);
	AvRepeatOne.displayName = 'AvRepeatOne';
	AvRepeatOne.muiName = 'SvgIcon';
	
	exports.default = AvRepeatOne;

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRepeat = function AvRepeat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z' })
	  );
	};
	AvRepeat = (0, _pure2.default)(AvRepeat);
	AvRepeat.displayName = 'AvRepeat';
	AvRepeat.muiName = 'SvgIcon';
	
	exports.default = AvRepeat;

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay10 = function AvReplay10(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
	  );
	};
	AvReplay10 = (0, _pure2.default)(AvReplay10);
	AvReplay10.displayName = 'AvReplay10';
	AvReplay10.muiName = 'SvgIcon';
	
	exports.default = AvReplay10;

/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay30 = function AvReplay30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
	  );
	};
	AvReplay30 = (0, _pure2.default)(AvReplay30);
	AvReplay30.displayName = 'AvReplay30';
	AvReplay30.muiName = 'SvgIcon';
	
	exports.default = AvReplay30;

/***/ },
/* 2019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay5 = function AvReplay5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z' })
	  );
	};
	AvReplay5 = (0, _pure2.default)(AvReplay5);
	AvReplay5.displayName = 'AvReplay5';
	AvReplay5.muiName = 'SvgIcon';
	
	exports.default = AvReplay5;

/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay = function AvReplay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z' })
	  );
	};
	AvReplay = (0, _pure2.default)(AvReplay);
	AvReplay.displayName = 'AvReplay';
	AvReplay.muiName = 'SvgIcon';
	
	exports.default = AvReplay;

/***/ },
/* 2021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvShuffle = function AvShuffle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z' })
	  );
	};
	AvShuffle = (0, _pure2.default)(AvShuffle);
	AvShuffle.displayName = 'AvShuffle';
	AvShuffle.muiName = 'SvgIcon';
	
	exports.default = AvShuffle;

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSkipNext = function AvSkipNext(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z' })
	  );
	};
	AvSkipNext = (0, _pure2.default)(AvSkipNext);
	AvSkipNext.displayName = 'AvSkipNext';
	AvSkipNext.muiName = 'SvgIcon';
	
	exports.default = AvSkipNext;

/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSkipPrevious = function AvSkipPrevious(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z' })
	  );
	};
	AvSkipPrevious = (0, _pure2.default)(AvSkipPrevious);
	AvSkipPrevious.displayName = 'AvSkipPrevious';
	AvSkipPrevious.muiName = 'SvgIcon';
	
	exports.default = AvSkipPrevious;

/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSlowMotionVideo = function AvSlowMotionVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z' })
	  );
	};
	AvSlowMotionVideo = (0, _pure2.default)(AvSlowMotionVideo);
	AvSlowMotionVideo.displayName = 'AvSlowMotionVideo';
	AvSlowMotionVideo.muiName = 'SvgIcon';
	
	exports.default = AvSlowMotionVideo;

/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSnooze = function AvSnooze(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z' })
	  );
	};
	AvSnooze = (0, _pure2.default)(AvSnooze);
	AvSnooze.displayName = 'AvSnooze';
	AvSnooze.muiName = 'SvgIcon';
	
	exports.default = AvSnooze;

/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSortByAlpha = function AvSortByAlpha(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z' })
	  );
	};
	AvSortByAlpha = (0, _pure2.default)(AvSortByAlpha);
	AvSortByAlpha.displayName = 'AvSortByAlpha';
	AvSortByAlpha.muiName = 'SvgIcon';
	
	exports.default = AvSortByAlpha;

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvStop = function AvStop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 6h12v12H6z' })
	  );
	};
	AvStop = (0, _pure2.default)(AvStop);
	AvStop.displayName = 'AvStop';
	AvStop.muiName = 'SvgIcon';
	
	exports.default = AvStop;

/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSubscriptions = function AvSubscriptions(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z' })
	  );
	};
	AvSubscriptions = (0, _pure2.default)(AvSubscriptions);
	AvSubscriptions.displayName = 'AvSubscriptions';
	AvSubscriptions.muiName = 'SvgIcon';
	
	exports.default = AvSubscriptions;

/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSubtitles = function AvSubtitles(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z' })
	  );
	};
	AvSubtitles = (0, _pure2.default)(AvSubtitles);
	AvSubtitles.displayName = 'AvSubtitles';
	AvSubtitles.muiName = 'SvgIcon';
	
	exports.default = AvSubtitles;

/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSurroundSound = function AvSurroundSound(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	AvSurroundSound = (0, _pure2.default)(AvSurroundSound);
	AvSurroundSound.displayName = 'AvSurroundSound';
	AvSurroundSound.muiName = 'SvgIcon';
	
	exports.default = AvSurroundSound;

/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideoCall = function AvVideoCall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z' })
	  );
	};
	AvVideoCall = (0, _pure2.default)(AvVideoCall);
	AvVideoCall.displayName = 'AvVideoCall';
	AvVideoCall.muiName = 'SvgIcon';
	
	exports.default = AvVideoCall;

/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideoLabel = function AvVideoLabel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z' })
	  );
	};
	AvVideoLabel = (0, _pure2.default)(AvVideoLabel);
	AvVideoLabel.displayName = 'AvVideoLabel';
	AvVideoLabel.muiName = 'SvgIcon';
	
	exports.default = AvVideoLabel;

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideoLibrary = function AvVideoLibrary(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z' })
	  );
	};
	AvVideoLibrary = (0, _pure2.default)(AvVideoLibrary);
	AvVideoLibrary.displayName = 'AvVideoLibrary';
	AvVideoLibrary.muiName = 'SvgIcon';
	
	exports.default = AvVideoLibrary;

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideocamOff = function AvVideocamOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z' })
	  );
	};
	AvVideocamOff = (0, _pure2.default)(AvVideocamOff);
	AvVideocamOff.displayName = 'AvVideocamOff';
	AvVideocamOff.muiName = 'SvgIcon';
	
	exports.default = AvVideocamOff;

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideocam = function AvVideocam(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z' })
	  );
	};
	AvVideocam = (0, _pure2.default)(AvVideocam);
	AvVideocam.displayName = 'AvVideocam';
	AvVideocam.muiName = 'SvgIcon';
	
	exports.default = AvVideocam;

/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeDown = function AvVolumeDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z' })
	  );
	};
	AvVolumeDown = (0, _pure2.default)(AvVolumeDown);
	AvVolumeDown.displayName = 'AvVolumeDown';
	AvVolumeDown.muiName = 'SvgIcon';
	
	exports.default = AvVolumeDown;

/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeMute = function AvVolumeMute(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 9v6h4l5 5V4l-5 5H7z' })
	  );
	};
	AvVolumeMute = (0, _pure2.default)(AvVolumeMute);
	AvVolumeMute.displayName = 'AvVolumeMute';
	AvVolumeMute.muiName = 'SvgIcon';
	
	exports.default = AvVolumeMute;

/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeOff = function AvVolumeOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z' })
	  );
	};
	AvVolumeOff = (0, _pure2.default)(AvVolumeOff);
	AvVolumeOff.displayName = 'AvVolumeOff';
	AvVolumeOff.muiName = 'SvgIcon';
	
	exports.default = AvVolumeOff;

/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeUp = function AvVolumeUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' })
	  );
	};
	AvVolumeUp = (0, _pure2.default)(AvVolumeUp);
	AvVolumeUp.displayName = 'AvVolumeUp';
	AvVolumeUp.muiName = 'SvgIcon';
	
	exports.default = AvVolumeUp;

/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvWebAsset = function AvWebAsset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z' })
	  );
	};
	AvWebAsset = (0, _pure2.default)(AvWebAsset);
	AvWebAsset.displayName = 'AvWebAsset';
	AvWebAsset.muiName = 'SvgIcon';
	
	exports.default = AvWebAsset;

/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvWeb = function AvWeb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z' })
	  );
	};
	AvWeb = (0, _pure2.default)(AvWeb);
	AvWeb.displayName = 'AvWeb';
	AvWeb.muiName = 'SvgIcon';
	
	exports.default = AvWeb;

/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationBusiness = function CommunicationBusiness(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
	  );
	};
	CommunicationBusiness = (0, _pure2.default)(CommunicationBusiness);
	CommunicationBusiness.displayName = 'CommunicationBusiness';
	CommunicationBusiness.muiName = 'SvgIcon';
	
	exports.default = CommunicationBusiness;

/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallEnd = function CommunicationCallEnd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z' })
	  );
	};
	CommunicationCallEnd = (0, _pure2.default)(CommunicationCallEnd);
	CommunicationCallEnd.displayName = 'CommunicationCallEnd';
	CommunicationCallEnd.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallEnd;

/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMade = function CommunicationCallMade(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z' })
	  );
	};
	CommunicationCallMade = (0, _pure2.default)(CommunicationCallMade);
	CommunicationCallMade.displayName = 'CommunicationCallMade';
	CommunicationCallMade.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMade;

/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMerge = function CommunicationCallMerge(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
	  );
	};
	CommunicationCallMerge = (0, _pure2.default)(CommunicationCallMerge);
	CommunicationCallMerge.displayName = 'CommunicationCallMerge';
	CommunicationCallMerge.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMerge;

/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMissedOutgoing = function CommunicationCallMissedOutgoing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z' })
	  );
	};
	CommunicationCallMissedOutgoing = (0, _pure2.default)(CommunicationCallMissedOutgoing);
	CommunicationCallMissedOutgoing.displayName = 'CommunicationCallMissedOutgoing';
	CommunicationCallMissedOutgoing.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMissedOutgoing;

/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMissed = function CommunicationCallMissed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z' })
	  );
	};
	CommunicationCallMissed = (0, _pure2.default)(CommunicationCallMissed);
	CommunicationCallMissed.displayName = 'CommunicationCallMissed';
	CommunicationCallMissed.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMissed;

/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallReceived = function CommunicationCallReceived(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z' })
	  );
	};
	CommunicationCallReceived = (0, _pure2.default)(CommunicationCallReceived);
	CommunicationCallReceived.displayName = 'CommunicationCallReceived';
	CommunicationCallReceived.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallReceived;

/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallSplit = function CommunicationCallSplit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z' })
	  );
	};
	CommunicationCallSplit = (0, _pure2.default)(CommunicationCallSplit);
	CommunicationCallSplit.displayName = 'CommunicationCallSplit';
	CommunicationCallSplit.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallSplit;

/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCall = function CommunicationCall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
	  );
	};
	CommunicationCall = (0, _pure2.default)(CommunicationCall);
	CommunicationCall.displayName = 'CommunicationCall';
	CommunicationCall.muiName = 'SvgIcon';
	
	exports.default = CommunicationCall;

/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationChatBubbleOutline = function CommunicationChatBubbleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z' })
	  );
	};
	CommunicationChatBubbleOutline = (0, _pure2.default)(CommunicationChatBubbleOutline);
	CommunicationChatBubbleOutline.displayName = 'CommunicationChatBubbleOutline';
	CommunicationChatBubbleOutline.muiName = 'SvgIcon';
	
	exports.default = CommunicationChatBubbleOutline;

/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationChatBubble = function CommunicationChatBubble(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z' })
	  );
	};
	CommunicationChatBubble = (0, _pure2.default)(CommunicationChatBubble);
	CommunicationChatBubble.displayName = 'CommunicationChatBubble';
	CommunicationChatBubble.muiName = 'SvgIcon';
	
	exports.default = CommunicationChatBubble;

/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationChat = function CommunicationChat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z' })
	  );
	};
	CommunicationChat = (0, _pure2.default)(CommunicationChat);
	CommunicationChat.displayName = 'CommunicationChat';
	CommunicationChat.muiName = 'SvgIcon';
	
	exports.default = CommunicationChat;

/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationClearAll = function CommunicationClearAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z' })
	  );
	};
	CommunicationClearAll = (0, _pure2.default)(CommunicationClearAll);
	CommunicationClearAll.displayName = 'CommunicationClearAll';
	CommunicationClearAll.muiName = 'SvgIcon';
	
	exports.default = CommunicationClearAll;

/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationComment = function CommunicationComment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	CommunicationComment = (0, _pure2.default)(CommunicationComment);
	CommunicationComment.displayName = 'CommunicationComment';
	CommunicationComment.muiName = 'SvgIcon';
	
	exports.default = CommunicationComment;

/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationContactMail = function CommunicationContactMail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z' })
	  );
	};
	CommunicationContactMail = (0, _pure2.default)(CommunicationContactMail);
	CommunicationContactMail.displayName = 'CommunicationContactMail';
	CommunicationContactMail.muiName = 'SvgIcon';
	
	exports.default = CommunicationContactMail;

/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationContactPhone = function CommunicationContactPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z' })
	  );
	};
	CommunicationContactPhone = (0, _pure2.default)(CommunicationContactPhone);
	CommunicationContactPhone.displayName = 'CommunicationContactPhone';
	CommunicationContactPhone.muiName = 'SvgIcon';
	
	exports.default = CommunicationContactPhone;

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationContacts = function CommunicationContacts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z' })
	  );
	};
	CommunicationContacts = (0, _pure2.default)(CommunicationContacts);
	CommunicationContacts.displayName = 'CommunicationContacts';
	CommunicationContacts.muiName = 'SvgIcon';
	
	exports.default = CommunicationContacts;

/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationDialerSip = function CommunicationDialerSip(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
	  );
	};
	CommunicationDialerSip = (0, _pure2.default)(CommunicationDialerSip);
	CommunicationDialerSip.displayName = 'CommunicationDialerSip';
	CommunicationDialerSip.muiName = 'SvgIcon';
	
	exports.default = CommunicationDialerSip;

/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationDialpad = function CommunicationDialpad(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	CommunicationDialpad = (0, _pure2.default)(CommunicationDialpad);
	CommunicationDialpad.displayName = 'CommunicationDialpad';
	CommunicationDialpad.muiName = 'SvgIcon';
	
	exports.default = CommunicationDialpad;

/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationEmail = function CommunicationEmail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	CommunicationEmail = (0, _pure2.default)(CommunicationEmail);
	CommunicationEmail.displayName = 'CommunicationEmail';
	CommunicationEmail.muiName = 'SvgIcon';
	
	exports.default = CommunicationEmail;

/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationForum = function CommunicationForum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
	  );
	};
	CommunicationForum = (0, _pure2.default)(CommunicationForum);
	CommunicationForum.displayName = 'CommunicationForum';
	CommunicationForum.muiName = 'SvgIcon';
	
	exports.default = CommunicationForum;

/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationImportContacts = function CommunicationImportContacts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z' })
	  );
	};
	CommunicationImportContacts = (0, _pure2.default)(CommunicationImportContacts);
	CommunicationImportContacts.displayName = 'CommunicationImportContacts';
	CommunicationImportContacts.muiName = 'SvgIcon';
	
	exports.default = CommunicationImportContacts;

/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationImportExport = function CommunicationImportExport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z' })
	  );
	};
	CommunicationImportExport = (0, _pure2.default)(CommunicationImportExport);
	CommunicationImportExport.displayName = 'CommunicationImportExport';
	CommunicationImportExport.muiName = 'SvgIcon';
	
	exports.default = CommunicationImportExport;

/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationInvertColorsOff = function CommunicationInvertColorsOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z' })
	  );
	};
	CommunicationInvertColorsOff = (0, _pure2.default)(CommunicationInvertColorsOff);
	CommunicationInvertColorsOff.displayName = 'CommunicationInvertColorsOff';
	CommunicationInvertColorsOff.muiName = 'SvgIcon';
	
	exports.default = CommunicationInvertColorsOff;

/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationLiveHelp = function CommunicationLiveHelp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
	  );
	};
	CommunicationLiveHelp = (0, _pure2.default)(CommunicationLiveHelp);
	CommunicationLiveHelp.displayName = 'CommunicationLiveHelp';
	CommunicationLiveHelp.muiName = 'SvgIcon';
	
	exports.default = CommunicationLiveHelp;

/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationLocationOff = function CommunicationLocationOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z' })
	  );
	};
	CommunicationLocationOff = (0, _pure2.default)(CommunicationLocationOff);
	CommunicationLocationOff.displayName = 'CommunicationLocationOff';
	CommunicationLocationOff.muiName = 'SvgIcon';
	
	exports.default = CommunicationLocationOff;

/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationLocationOn = function CommunicationLocationOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	CommunicationLocationOn = (0, _pure2.default)(CommunicationLocationOn);
	CommunicationLocationOn.displayName = 'CommunicationLocationOn';
	CommunicationLocationOn.muiName = 'SvgIcon';
	
	exports.default = CommunicationLocationOn;

/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationMailOutline = function CommunicationMailOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z' })
	  );
	};
	CommunicationMailOutline = (0, _pure2.default)(CommunicationMailOutline);
	CommunicationMailOutline.displayName = 'CommunicationMailOutline';
	CommunicationMailOutline.muiName = 'SvgIcon';
	
	exports.default = CommunicationMailOutline;

/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationMessage = function CommunicationMessage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	CommunicationMessage = (0, _pure2.default)(CommunicationMessage);
	CommunicationMessage.displayName = 'CommunicationMessage';
	CommunicationMessage.muiName = 'SvgIcon';
	
	exports.default = CommunicationMessage;

/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationNoSim = function CommunicationNoSim(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
	  );
	};
	CommunicationNoSim = (0, _pure2.default)(CommunicationNoSim);
	CommunicationNoSim.displayName = 'CommunicationNoSim';
	CommunicationNoSim.muiName = 'SvgIcon';
	
	exports.default = CommunicationNoSim;

/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhone = function CommunicationPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
	  );
	};
	CommunicationPhone = (0, _pure2.default)(CommunicationPhone);
	CommunicationPhone.displayName = 'CommunicationPhone';
	CommunicationPhone.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhone;

/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkErase = function CommunicationPhonelinkErase(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
	  );
	};
	CommunicationPhonelinkErase = (0, _pure2.default)(CommunicationPhonelinkErase);
	CommunicationPhonelinkErase.displayName = 'CommunicationPhonelinkErase';
	CommunicationPhonelinkErase.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkErase;

/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkLock = function CommunicationPhonelinkLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z' })
	  );
	};
	CommunicationPhonelinkLock = (0, _pure2.default)(CommunicationPhonelinkLock);
	CommunicationPhonelinkLock.displayName = 'CommunicationPhonelinkLock';
	CommunicationPhonelinkLock.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkLock;

/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkRing = function CommunicationPhonelinkRing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z' })
	  );
	};
	CommunicationPhonelinkRing = (0, _pure2.default)(CommunicationPhonelinkRing);
	CommunicationPhonelinkRing.displayName = 'CommunicationPhonelinkRing';
	CommunicationPhonelinkRing.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkRing;

/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkSetup = function CommunicationPhonelinkSetup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
	  );
	};
	CommunicationPhonelinkSetup = (0, _pure2.default)(CommunicationPhonelinkSetup);
	CommunicationPhonelinkSetup.displayName = 'CommunicationPhonelinkSetup';
	CommunicationPhonelinkSetup.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkSetup;

/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPortableWifiOff = function CommunicationPortableWifiOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z' })
	  );
	};
	CommunicationPortableWifiOff = (0, _pure2.default)(CommunicationPortableWifiOff);
	CommunicationPortableWifiOff.displayName = 'CommunicationPortableWifiOff';
	CommunicationPortableWifiOff.muiName = 'SvgIcon';
	
	exports.default = CommunicationPortableWifiOff;

/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPresentToAll = function CommunicationPresentToAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z' })
	  );
	};
	CommunicationPresentToAll = (0, _pure2.default)(CommunicationPresentToAll);
	CommunicationPresentToAll.displayName = 'CommunicationPresentToAll';
	CommunicationPresentToAll.muiName = 'SvgIcon';
	
	exports.default = CommunicationPresentToAll;

/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationRingVolume = function CommunicationRingVolume(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z' })
	  );
	};
	CommunicationRingVolume = (0, _pure2.default)(CommunicationRingVolume);
	CommunicationRingVolume.displayName = 'CommunicationRingVolume';
	CommunicationRingVolume.muiName = 'SvgIcon';
	
	exports.default = CommunicationRingVolume;

/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationRssFeed = function CommunicationRssFeed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '6.18', cy: '17.82', r: '2.18' }),
	    _react2.default.createElement('path', { d: 'M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z' })
	  );
	};
	CommunicationRssFeed = (0, _pure2.default)(CommunicationRssFeed);
	CommunicationRssFeed.displayName = 'CommunicationRssFeed';
	CommunicationRssFeed.muiName = 'SvgIcon';
	
	exports.default = CommunicationRssFeed;

/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationScreenShare = function CommunicationScreenShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z' })
	  );
	};
	CommunicationScreenShare = (0, _pure2.default)(CommunicationScreenShare);
	CommunicationScreenShare.displayName = 'CommunicationScreenShare';
	CommunicationScreenShare.muiName = 'SvgIcon';
	
	exports.default = CommunicationScreenShare;

/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationSpeakerPhone = function CommunicationSpeakerPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z' })
	  );
	};
	CommunicationSpeakerPhone = (0, _pure2.default)(CommunicationSpeakerPhone);
	CommunicationSpeakerPhone.displayName = 'CommunicationSpeakerPhone';
	CommunicationSpeakerPhone.muiName = 'SvgIcon';
	
	exports.default = CommunicationSpeakerPhone;

/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayCurrentLandscape = function CommunicationStayCurrentLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
	  );
	};
	CommunicationStayCurrentLandscape = (0, _pure2.default)(CommunicationStayCurrentLandscape);
	CommunicationStayCurrentLandscape.displayName = 'CommunicationStayCurrentLandscape';
	CommunicationStayCurrentLandscape.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayCurrentLandscape;

/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayCurrentPortrait = function CommunicationStayCurrentPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	CommunicationStayCurrentPortrait = (0, _pure2.default)(CommunicationStayCurrentPortrait);
	CommunicationStayCurrentPortrait.displayName = 'CommunicationStayCurrentPortrait';
	CommunicationStayCurrentPortrait.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayCurrentPortrait;

/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayPrimaryLandscape = function CommunicationStayPrimaryLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
	  );
	};
	CommunicationStayPrimaryLandscape = (0, _pure2.default)(CommunicationStayPrimaryLandscape);
	CommunicationStayPrimaryLandscape.displayName = 'CommunicationStayPrimaryLandscape';
	CommunicationStayPrimaryLandscape.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayPrimaryLandscape;

/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayPrimaryPortrait = function CommunicationStayPrimaryPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	CommunicationStayPrimaryPortrait = (0, _pure2.default)(CommunicationStayPrimaryPortrait);
	CommunicationStayPrimaryPortrait.displayName = 'CommunicationStayPrimaryPortrait';
	CommunicationStayPrimaryPortrait.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayPrimaryPortrait;

/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStopScreenShare = function CommunicationStopScreenShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z' })
	  );
	};
	CommunicationStopScreenShare = (0, _pure2.default)(CommunicationStopScreenShare);
	CommunicationStopScreenShare.displayName = 'CommunicationStopScreenShare';
	CommunicationStopScreenShare.muiName = 'SvgIcon';
	
	exports.default = CommunicationStopScreenShare;

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationSwapCalls = function CommunicationSwapCalls(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z' })
	  );
	};
	CommunicationSwapCalls = (0, _pure2.default)(CommunicationSwapCalls);
	CommunicationSwapCalls.displayName = 'CommunicationSwapCalls';
	CommunicationSwapCalls.muiName = 'SvgIcon';
	
	exports.default = CommunicationSwapCalls;

/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationTextsms = function CommunicationTextsms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
	  );
	};
	CommunicationTextsms = (0, _pure2.default)(CommunicationTextsms);
	CommunicationTextsms.displayName = 'CommunicationTextsms';
	CommunicationTextsms.muiName = 'SvgIcon';
	
	exports.default = CommunicationTextsms;

/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationVoicemail = function CommunicationVoicemail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z' })
	  );
	};
	CommunicationVoicemail = (0, _pure2.default)(CommunicationVoicemail);
	CommunicationVoicemail.displayName = 'CommunicationVoicemail';
	CommunicationVoicemail.muiName = 'SvgIcon';
	
	exports.default = CommunicationVoicemail;

/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationVpnKey = function CommunicationVpnKey(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	CommunicationVpnKey = (0, _pure2.default)(CommunicationVpnKey);
	CommunicationVpnKey.displayName = 'CommunicationVpnKey';
	CommunicationVpnKey.muiName = 'SvgIcon';
	
	exports.default = CommunicationVpnKey;

/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAddBox = function ContentAddBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
	  );
	};
	ContentAddBox = (0, _pure2.default)(ContentAddBox);
	ContentAddBox.displayName = 'ContentAddBox';
	ContentAddBox.muiName = 'SvgIcon';
	
	exports.default = ContentAddBox;

/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAddCircleOutline = function ContentAddCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ContentAddCircleOutline = (0, _pure2.default)(ContentAddCircleOutline);
	ContentAddCircleOutline.displayName = 'ContentAddCircleOutline';
	ContentAddCircleOutline.muiName = 'SvgIcon';
	
	exports.default = ContentAddCircleOutline;

/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAddCircle = function ContentAddCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
	  );
	};
	ContentAddCircle = (0, _pure2.default)(ContentAddCircle);
	ContentAddCircle.displayName = 'ContentAddCircle';
	ContentAddCircle.muiName = 'SvgIcon';
	
	exports.default = ContentAddCircle;

/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAdd = function ContentAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
	  );
	};
	ContentAdd = (0, _pure2.default)(ContentAdd);
	ContentAdd.displayName = 'ContentAdd';
	ContentAdd.muiName = 'SvgIcon';
	
	exports.default = ContentAdd;

/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentBackspace = function ContentBackspace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z' })
	  );
	};
	ContentBackspace = (0, _pure2.default)(ContentBackspace);
	ContentBackspace.displayName = 'ContentBackspace';
	ContentBackspace.muiName = 'SvgIcon';
	
	exports.default = ContentBackspace;

/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentBlock = function ContentBlock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z' })
	  );
	};
	ContentBlock = (0, _pure2.default)(ContentBlock);
	ContentBlock.displayName = 'ContentBlock';
	ContentBlock.muiName = 'SvgIcon';
	
	exports.default = ContentBlock;

/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentCopy = function ContentContentCopy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' })
	  );
	};
	ContentContentCopy = (0, _pure2.default)(ContentContentCopy);
	ContentContentCopy.displayName = 'ContentContentCopy';
	ContentContentCopy.muiName = 'SvgIcon';
	
	exports.default = ContentContentCopy;

/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentCut = function ContentContentCut(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z' })
	  );
	};
	ContentContentCut = (0, _pure2.default)(ContentContentCut);
	ContentContentCut.displayName = 'ContentContentCut';
	ContentContentCut.muiName = 'SvgIcon';
	
	exports.default = ContentContentCut;

/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentPaste = function ContentContentPaste(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z' })
	  );
	};
	ContentContentPaste = (0, _pure2.default)(ContentContentPaste);
	ContentContentPaste.displayName = 'ContentContentPaste';
	ContentContentPaste.muiName = 'SvgIcon';
	
	exports.default = ContentContentPaste;

/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentDeleteSweep = function ContentDeleteSweep(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z' })
	  );
	};
	ContentDeleteSweep = (0, _pure2.default)(ContentDeleteSweep);
	ContentDeleteSweep.displayName = 'ContentDeleteSweep';
	ContentDeleteSweep.muiName = 'SvgIcon';
	
	exports.default = ContentDeleteSweep;

/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentDrafts = function ContentDrafts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z' })
	  );
	};
	ContentDrafts = (0, _pure2.default)(ContentDrafts);
	ContentDrafts.displayName = 'ContentDrafts';
	ContentDrafts.muiName = 'SvgIcon';
	
	exports.default = ContentDrafts;

/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFilterList = function ContentFilterList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' })
	  );
	};
	ContentFilterList = (0, _pure2.default)(ContentFilterList);
	ContentFilterList.displayName = 'ContentFilterList';
	ContentFilterList.muiName = 'SvgIcon';
	
	exports.default = ContentFilterList;

/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFlag = function ContentFlag(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
	  );
	};
	ContentFlag = (0, _pure2.default)(ContentFlag);
	ContentFlag.displayName = 'ContentFlag';
	ContentFlag.muiName = 'SvgIcon';
	
	exports.default = ContentFlag;

/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFontDownload = function ContentFontDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z' })
	  );
	};
	ContentFontDownload = (0, _pure2.default)(ContentFontDownload);
	ContentFontDownload.displayName = 'ContentFontDownload';
	ContentFontDownload.muiName = 'SvgIcon';
	
	exports.default = ContentFontDownload;

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentForward = function ContentForward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8V4l8 8-8 8v-4H4V8z' })
	  );
	};
	ContentForward = (0, _pure2.default)(ContentForward);
	ContentForward.displayName = 'ContentForward';
	ContentForward.muiName = 'SvgIcon';
	
	exports.default = ContentForward;

/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentGesture = function ContentGesture(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z' })
	  );
	};
	ContentGesture = (0, _pure2.default)(ContentGesture);
	ContentGesture.displayName = 'ContentGesture';
	ContentGesture.muiName = 'SvgIcon';
	
	exports.default = ContentGesture;

/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentInbox = function ContentInbox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z' })
	  );
	};
	ContentInbox = (0, _pure2.default)(ContentInbox);
	ContentInbox.displayName = 'ContentInbox';
	ContentInbox.muiName = 'SvgIcon';
	
	exports.default = ContentInbox;

/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLink = function ContentLink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
	  );
	};
	ContentLink = (0, _pure2.default)(ContentLink);
	ContentLink.displayName = 'ContentLink';
	ContentLink.muiName = 'SvgIcon';
	
	exports.default = ContentLink;

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLowPriority = function ContentLowPriority(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z' })
	  );
	};
	ContentLowPriority = (0, _pure2.default)(ContentLowPriority);
	ContentLowPriority.displayName = 'ContentLowPriority';
	ContentLowPriority.muiName = 'SvgIcon';
	
	exports.default = ContentLowPriority;

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentMail = function ContentMail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	ContentMail = (0, _pure2.default)(ContentMail);
	ContentMail.displayName = 'ContentMail';
	ContentMail.muiName = 'SvgIcon';
	
	exports.default = ContentMail;

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentMarkunread = function ContentMarkunread(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	ContentMarkunread = (0, _pure2.default)(ContentMarkunread);
	ContentMarkunread.displayName = 'ContentMarkunread';
	ContentMarkunread.muiName = 'SvgIcon';
	
	exports.default = ContentMarkunread;

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentMoveToInbox = function ContentMoveToInbox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z' })
	  );
	};
	ContentMoveToInbox = (0, _pure2.default)(ContentMoveToInbox);
	ContentMoveToInbox.displayName = 'ContentMoveToInbox';
	ContentMoveToInbox.muiName = 'SvgIcon';
	
	exports.default = ContentMoveToInbox;

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentNextWeek = function ContentNextWeek(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z' })
	  );
	};
	ContentNextWeek = (0, _pure2.default)(ContentNextWeek);
	ContentNextWeek.displayName = 'ContentNextWeek';
	ContentNextWeek.muiName = 'SvgIcon';
	
	exports.default = ContentNextWeek;

/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRedo = function ContentRedo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z' })
	  );
	};
	ContentRedo = (0, _pure2.default)(ContentRedo);
	ContentRedo.displayName = 'ContentRedo';
	ContentRedo.muiName = 'SvgIcon';
	
	exports.default = ContentRedo;

/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemoveCircleOutline = function ContentRemoveCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ContentRemoveCircleOutline = (0, _pure2.default)(ContentRemoveCircleOutline);
	ContentRemoveCircleOutline.displayName = 'ContentRemoveCircleOutline';
	ContentRemoveCircleOutline.muiName = 'SvgIcon';
	
	exports.default = ContentRemoveCircleOutline;

/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemoveCircle = function ContentRemoveCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
	  );
	};
	ContentRemoveCircle = (0, _pure2.default)(ContentRemoveCircle);
	ContentRemoveCircle.displayName = 'ContentRemoveCircle';
	ContentRemoveCircle.muiName = 'SvgIcon';
	
	exports.default = ContentRemoveCircle;

/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemove = function ContentRemove(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 13H5v-2h14v2z' })
	  );
	};
	ContentRemove = (0, _pure2.default)(ContentRemove);
	ContentRemove.displayName = 'ContentRemove';
	ContentRemove.muiName = 'SvgIcon';
	
	exports.default = ContentRemove;

/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentReplyAll = function ContentReplyAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
	  );
	};
	ContentReplyAll = (0, _pure2.default)(ContentReplyAll);
	ContentReplyAll.displayName = 'ContentReplyAll';
	ContentReplyAll.muiName = 'SvgIcon';
	
	exports.default = ContentReplyAll;

/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentReply = function ContentReply(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
	  );
	};
	ContentReply = (0, _pure2.default)(ContentReply);
	ContentReply.displayName = 'ContentReply';
	ContentReply.muiName = 'SvgIcon';
	
	exports.default = ContentReply;

/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentReport = function ContentReport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z' })
	  );
	};
	ContentReport = (0, _pure2.default)(ContentReport);
	ContentReport.displayName = 'ContentReport';
	ContentReport.muiName = 'SvgIcon';
	
	exports.default = ContentReport;

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSave = function ContentSave(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z' })
	  );
	};
	ContentSave = (0, _pure2.default)(ContentSave);
	ContentSave.displayName = 'ContentSave';
	ContentSave.muiName = 'SvgIcon';
	
	exports.default = ContentSave;

/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSelectAll = function ContentSelectAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z' })
	  );
	};
	ContentSelectAll = (0, _pure2.default)(ContentSelectAll);
	ContentSelectAll.displayName = 'ContentSelectAll';
	ContentSelectAll.muiName = 'SvgIcon';
	
	exports.default = ContentSelectAll;

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSend = function ContentSend(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' })
	  );
	};
	ContentSend = (0, _pure2.default)(ContentSend);
	ContentSend.displayName = 'ContentSend';
	ContentSend.muiName = 'SvgIcon';
	
	exports.default = ContentSend;

/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSort = function ContentSort(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z' })
	  );
	};
	ContentSort = (0, _pure2.default)(ContentSort);
	ContentSort.displayName = 'ContentSort';
	ContentSort.muiName = 'SvgIcon';
	
	exports.default = ContentSort;

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentTextFormat = function ContentTextFormat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z' })
	  );
	};
	ContentTextFormat = (0, _pure2.default)(ContentTextFormat);
	ContentTextFormat.displayName = 'ContentTextFormat';
	ContentTextFormat.muiName = 'SvgIcon';
	
	exports.default = ContentTextFormat;

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentUnarchive = function ContentUnarchive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z' })
	  );
	};
	ContentUnarchive = (0, _pure2.default)(ContentUnarchive);
	ContentUnarchive.displayName = 'ContentUnarchive';
	ContentUnarchive.muiName = 'SvgIcon';
	
	exports.default = ContentUnarchive;

/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentUndo = function ContentUndo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z' })
	  );
	};
	ContentUndo = (0, _pure2.default)(ContentUndo);
	ContentUndo.displayName = 'ContentUndo';
	ContentUndo.muiName = 'SvgIcon';
	
	exports.default = ContentUndo;

/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentWeekend = function ContentWeekend(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z' })
	  );
	};
	ContentWeekend = (0, _pure2.default)(ContentWeekend);
	ContentWeekend.displayName = 'ContentWeekend';
	ContentWeekend.muiName = 'SvgIcon';
	
	exports.default = ContentWeekend;

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAccessAlarm = function DeviceAccessAlarm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceAccessAlarm = (0, _pure2.default)(DeviceAccessAlarm);
	DeviceAccessAlarm.displayName = 'DeviceAccessAlarm';
	DeviceAccessAlarm.muiName = 'SvgIcon';
	
	exports.default = DeviceAccessAlarm;

/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAccessAlarms = function DeviceAccessAlarms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z' })
	  );
	};
	DeviceAccessAlarms = (0, _pure2.default)(DeviceAccessAlarms);
	DeviceAccessAlarms.displayName = 'DeviceAccessAlarms';
	DeviceAccessAlarms.muiName = 'SvgIcon';
	
	exports.default = DeviceAccessAlarms;

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAccessTime = function DeviceAccessTime(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
	  );
	};
	DeviceAccessTime = (0, _pure2.default)(DeviceAccessTime);
	DeviceAccessTime.displayName = 'DeviceAccessTime';
	DeviceAccessTime.muiName = 'SvgIcon';
	
	exports.default = DeviceAccessTime;

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAddAlarm = function DeviceAddAlarm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
	  );
	};
	DeviceAddAlarm = (0, _pure2.default)(DeviceAddAlarm);
	DeviceAddAlarm.displayName = 'DeviceAddAlarm';
	DeviceAddAlarm.muiName = 'SvgIcon';
	
	exports.default = DeviceAddAlarm;

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAirplanemodeActive = function DeviceAirplanemodeActive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.18 9' }),
	    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
	  );
	};
	DeviceAirplanemodeActive = (0, _pure2.default)(DeviceAirplanemodeActive);
	DeviceAirplanemodeActive.displayName = 'DeviceAirplanemodeActive';
	DeviceAirplanemodeActive.muiName = 'SvgIcon';
	
	exports.default = DeviceAirplanemodeActive;

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAirplanemodeInactive = function DeviceAirplanemodeInactive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z' })
	  );
	};
	DeviceAirplanemodeInactive = (0, _pure2.default)(DeviceAirplanemodeInactive);
	DeviceAirplanemodeInactive.displayName = 'DeviceAirplanemodeInactive';
	DeviceAirplanemodeInactive.muiName = 'SvgIcon';
	
	exports.default = DeviceAirplanemodeInactive;

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery20 = function DeviceBattery20(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z' }),
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z' })
	  );
	};
	DeviceBattery20 = (0, _pure2.default)(DeviceBattery20);
	DeviceBattery20.displayName = 'DeviceBattery20';
	DeviceBattery20.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery20;

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery30 = function DeviceBattery30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z' })
	  );
	};
	DeviceBattery30 = (0, _pure2.default)(DeviceBattery30);
	DeviceBattery30.displayName = 'DeviceBattery30';
	DeviceBattery30.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery30;

/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery50 = function DeviceBattery50(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z' })
	  );
	};
	DeviceBattery50 = (0, _pure2.default)(DeviceBattery50);
	DeviceBattery50.displayName = 'DeviceBattery50';
	DeviceBattery50.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery50;

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery60 = function DeviceBattery60(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z' })
	  );
	};
	DeviceBattery60 = (0, _pure2.default)(DeviceBattery60);
	DeviceBattery60.displayName = 'DeviceBattery60';
	DeviceBattery60.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery60;

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery80 = function DeviceBattery80(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z' })
	  );
	};
	DeviceBattery80 = (0, _pure2.default)(DeviceBattery80);
	DeviceBattery80.displayName = 'DeviceBattery80';
	DeviceBattery80.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery80;

/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery90 = function DeviceBattery90(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z' })
	  );
	};
	DeviceBattery90 = (0, _pure2.default)(DeviceBattery90);
	DeviceBattery90.displayName = 'DeviceBattery90';
	DeviceBattery90.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery90;

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryAlert = function DeviceBatteryAlert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z' })
	  );
	};
	DeviceBatteryAlert = (0, _pure2.default)(DeviceBatteryAlert);
	DeviceBatteryAlert.displayName = 'DeviceBatteryAlert';
	DeviceBatteryAlert.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryAlert;

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging20 = function DeviceBatteryCharging20(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z' }),
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryCharging20 = (0, _pure2.default)(DeviceBatteryCharging20);
	DeviceBatteryCharging20.displayName = 'DeviceBatteryCharging20';
	DeviceBatteryCharging20.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging20;

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging30 = function DeviceBatteryCharging30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z' })
	  );
	};
	DeviceBatteryCharging30 = (0, _pure2.default)(DeviceBatteryCharging30);
	DeviceBatteryCharging30.displayName = 'DeviceBatteryCharging30';
	DeviceBatteryCharging30.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging30;

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging50 = function DeviceBatteryCharging50(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z' }),
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryCharging50 = (0, _pure2.default)(DeviceBatteryCharging50);
	DeviceBatteryCharging50.displayName = 'DeviceBatteryCharging50';
	DeviceBatteryCharging50.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging50;

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging60 = function DeviceBatteryCharging60(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z' })
	  );
	};
	DeviceBatteryCharging60 = (0, _pure2.default)(DeviceBatteryCharging60);
	DeviceBatteryCharging60.displayName = 'DeviceBatteryCharging60';
	DeviceBatteryCharging60.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging60;

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging80 = function DeviceBatteryCharging80(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z' })
	  );
	};
	DeviceBatteryCharging80 = (0, _pure2.default)(DeviceBatteryCharging80);
	DeviceBatteryCharging80.displayName = 'DeviceBatteryCharging80';
	DeviceBatteryCharging80.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging80;

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging90 = function DeviceBatteryCharging90(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z' })
	  );
	};
	DeviceBatteryCharging90 = (0, _pure2.default)(DeviceBatteryCharging90);
	DeviceBatteryCharging90.displayName = 'DeviceBatteryCharging90';
	DeviceBatteryCharging90.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging90;

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryChargingFull = function DeviceBatteryChargingFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z' })
	  );
	};
	DeviceBatteryChargingFull = (0, _pure2.default)(DeviceBatteryChargingFull);
	DeviceBatteryChargingFull.displayName = 'DeviceBatteryChargingFull';
	DeviceBatteryChargingFull.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryChargingFull;

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryFull = function DeviceBatteryFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryFull = (0, _pure2.default)(DeviceBatteryFull);
	DeviceBatteryFull.displayName = 'DeviceBatteryFull';
	DeviceBatteryFull.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryFull;

/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryStd = function DeviceBatteryStd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryStd = (0, _pure2.default)(DeviceBatteryStd);
	DeviceBatteryStd.displayName = 'DeviceBatteryStd';
	DeviceBatteryStd.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryStd;

/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryUnknown = function DeviceBatteryUnknown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z' })
	  );
	};
	DeviceBatteryUnknown = (0, _pure2.default)(DeviceBatteryUnknown);
	DeviceBatteryUnknown.displayName = 'DeviceBatteryUnknown';
	DeviceBatteryUnknown.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryUnknown;

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetoothConnected = function DeviceBluetoothConnected(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z' })
	  );
	};
	DeviceBluetoothConnected = (0, _pure2.default)(DeviceBluetoothConnected);
	DeviceBluetoothConnected.displayName = 'DeviceBluetoothConnected';
	DeviceBluetoothConnected.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetoothConnected;

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetoothDisabled = function DeviceBluetoothDisabled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z' })
	  );
	};
	DeviceBluetoothDisabled = (0, _pure2.default)(DeviceBluetoothDisabled);
	DeviceBluetoothDisabled.displayName = 'DeviceBluetoothDisabled';
	DeviceBluetoothDisabled.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetoothDisabled;

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetoothSearching = function DeviceBluetoothSearching(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
	  );
	};
	DeviceBluetoothSearching = (0, _pure2.default)(DeviceBluetoothSearching);
	DeviceBluetoothSearching.displayName = 'DeviceBluetoothSearching';
	DeviceBluetoothSearching.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetoothSearching;

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetooth = function DeviceBluetooth(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z' })
	  );
	};
	DeviceBluetooth = (0, _pure2.default)(DeviceBluetooth);
	DeviceBluetooth.displayName = 'DeviceBluetooth';
	DeviceBluetooth.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetooth;

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessAuto = function DeviceBrightnessAuto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z' })
	  );
	};
	DeviceBrightnessAuto = (0, _pure2.default)(DeviceBrightnessAuto);
	DeviceBrightnessAuto.displayName = 'DeviceBrightnessAuto';
	DeviceBrightnessAuto.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessAuto;

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessHigh = function DeviceBrightnessHigh(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
	  );
	};
	DeviceBrightnessHigh = (0, _pure2.default)(DeviceBrightnessHigh);
	DeviceBrightnessHigh.displayName = 'DeviceBrightnessHigh';
	DeviceBrightnessHigh.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessHigh;

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessLow = function DeviceBrightnessLow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
	  );
	};
	DeviceBrightnessLow = (0, _pure2.default)(DeviceBrightnessLow);
	DeviceBrightnessLow.displayName = 'DeviceBrightnessLow';
	DeviceBrightnessLow.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessLow;

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessMedium = function DeviceBrightnessMedium(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
	  );
	};
	DeviceBrightnessMedium = (0, _pure2.default)(DeviceBrightnessMedium);
	DeviceBrightnessMedium.displayName = 'DeviceBrightnessMedium';
	DeviceBrightnessMedium.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessMedium;

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDataUsage = function DeviceDataUsage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z' })
	  );
	};
	DeviceDataUsage = (0, _pure2.default)(DeviceDataUsage);
	DeviceDataUsage.displayName = 'DeviceDataUsage';
	DeviceDataUsage.muiName = 'SvgIcon';
	
	exports.default = DeviceDataUsage;

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDeveloperMode = function DeviceDeveloperMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z' })
	  );
	};
	DeviceDeveloperMode = (0, _pure2.default)(DeviceDeveloperMode);
	DeviceDeveloperMode.displayName = 'DeviceDeveloperMode';
	DeviceDeveloperMode.muiName = 'SvgIcon';
	
	exports.default = DeviceDeveloperMode;

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDevices = function DeviceDevices(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
	  );
	};
	DeviceDevices = (0, _pure2.default)(DeviceDevices);
	DeviceDevices.displayName = 'DeviceDevices';
	DeviceDevices.muiName = 'SvgIcon';
	
	exports.default = DeviceDevices;

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDvr = function DeviceDvr(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z' })
	  );
	};
	DeviceDvr = (0, _pure2.default)(DeviceDvr);
	DeviceDvr.displayName = 'DeviceDvr';
	DeviceDvr.muiName = 'SvgIcon';
	
	exports.default = DeviceDvr;

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGpsFixed = function DeviceGpsFixed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceGpsFixed = (0, _pure2.default)(DeviceGpsFixed);
	DeviceGpsFixed.displayName = 'DeviceGpsFixed';
	DeviceGpsFixed.muiName = 'SvgIcon';
	
	exports.default = DeviceGpsFixed;

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGpsNotFixed = function DeviceGpsNotFixed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceGpsNotFixed = (0, _pure2.default)(DeviceGpsNotFixed);
	DeviceGpsNotFixed.displayName = 'DeviceGpsNotFixed';
	DeviceGpsNotFixed.muiName = 'SvgIcon';
	
	exports.default = DeviceGpsNotFixed;

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGpsOff = function DeviceGpsOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
	  );
	};
	DeviceGpsOff = (0, _pure2.default)(DeviceGpsOff);
	DeviceGpsOff.displayName = 'DeviceGpsOff';
	DeviceGpsOff.muiName = 'SvgIcon';
	
	exports.default = DeviceGpsOff;

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGraphicEq = function DeviceGraphicEq(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z' })
	  );
	};
	DeviceGraphicEq = (0, _pure2.default)(DeviceGraphicEq);
	DeviceGraphicEq.displayName = 'DeviceGraphicEq';
	DeviceGraphicEq.muiName = 'SvgIcon';
	
	exports.default = DeviceGraphicEq;

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceLocationDisabled = function DeviceLocationDisabled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
	  );
	};
	DeviceLocationDisabled = (0, _pure2.default)(DeviceLocationDisabled);
	DeviceLocationDisabled.displayName = 'DeviceLocationDisabled';
	DeviceLocationDisabled.muiName = 'SvgIcon';
	
	exports.default = DeviceLocationDisabled;

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceLocationSearching = function DeviceLocationSearching(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceLocationSearching = (0, _pure2.default)(DeviceLocationSearching);
	DeviceLocationSearching.displayName = 'DeviceLocationSearching';
	DeviceLocationSearching.muiName = 'SvgIcon';
	
	exports.default = DeviceLocationSearching;

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceNetworkCell = function DeviceNetworkCell(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M17 7L2 22h15z' })
	  );
	};
	DeviceNetworkCell = (0, _pure2.default)(DeviceNetworkCell);
	DeviceNetworkCell.displayName = 'DeviceNetworkCell';
	DeviceNetworkCell.muiName = 'SvgIcon';
	
	exports.default = DeviceNetworkCell;

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceNetworkWifi = function DeviceNetworkWifi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
	  );
	};
	DeviceNetworkWifi = (0, _pure2.default)(DeviceNetworkWifi);
	DeviceNetworkWifi.displayName = 'DeviceNetworkWifi';
	DeviceNetworkWifi.muiName = 'SvgIcon';
	
	exports.default = DeviceNetworkWifi;

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceNfc = function DeviceNfc(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z' })
	  );
	};
	DeviceNfc = (0, _pure2.default)(DeviceNfc);
	DeviceNfc.displayName = 'DeviceNfc';
	DeviceNfc.muiName = 'SvgIcon';
	
	exports.default = DeviceNfc;

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenLockLandscape = function DeviceScreenLockLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z' })
	  );
	};
	DeviceScreenLockLandscape = (0, _pure2.default)(DeviceScreenLockLandscape);
	DeviceScreenLockLandscape.displayName = 'DeviceScreenLockLandscape';
	DeviceScreenLockLandscape.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenLockLandscape;

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenLockPortrait = function DeviceScreenLockPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z' })
	  );
	};
	DeviceScreenLockPortrait = (0, _pure2.default)(DeviceScreenLockPortrait);
	DeviceScreenLockPortrait.displayName = 'DeviceScreenLockPortrait';
	DeviceScreenLockPortrait.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenLockPortrait;

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenLockRotation = function DeviceScreenLockRotation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z' })
	  );
	};
	DeviceScreenLockRotation = (0, _pure2.default)(DeviceScreenLockRotation);
	DeviceScreenLockRotation.displayName = 'DeviceScreenLockRotation';
	DeviceScreenLockRotation.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenLockRotation;

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenRotation = function DeviceScreenRotation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z' })
	  );
	};
	DeviceScreenRotation = (0, _pure2.default)(DeviceScreenRotation);
	DeviceScreenRotation.displayName = 'DeviceScreenRotation';
	DeviceScreenRotation.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenRotation;

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSdStorage = function DeviceSdStorage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
	  );
	};
	DeviceSdStorage = (0, _pure2.default)(DeviceSdStorage);
	DeviceSdStorage.displayName = 'DeviceSdStorage';
	DeviceSdStorage.muiName = 'SvgIcon';
	
	exports.default = DeviceSdStorage;

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSettingsSystemDaydream = function DeviceSettingsSystemDaydream(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
	  );
	};
	DeviceSettingsSystemDaydream = (0, _pure2.default)(DeviceSettingsSystemDaydream);
	DeviceSettingsSystemDaydream.displayName = 'DeviceSettingsSystemDaydream';
	DeviceSettingsSystemDaydream.muiName = 'SvgIcon';
	
	exports.default = DeviceSettingsSystemDaydream;

/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular0Bar = function DeviceSignalCellular0Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' })
	  );
	};
	DeviceSignalCellular0Bar = (0, _pure2.default)(DeviceSignalCellular0Bar);
	DeviceSignalCellular0Bar.displayName = 'DeviceSignalCellular0Bar';
	DeviceSignalCellular0Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular0Bar;

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular1Bar = function DeviceSignalCellular1Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M12 12L2 22h10z' })
	  );
	};
	DeviceSignalCellular1Bar = (0, _pure2.default)(DeviceSignalCellular1Bar);
	DeviceSignalCellular1Bar.displayName = 'DeviceSignalCellular1Bar';
	DeviceSignalCellular1Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular1Bar;

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular2Bar = function DeviceSignalCellular2Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M14 10L2 22h12z' })
	  );
	};
	DeviceSignalCellular2Bar = (0, _pure2.default)(DeviceSignalCellular2Bar);
	DeviceSignalCellular2Bar.displayName = 'DeviceSignalCellular2Bar';
	DeviceSignalCellular2Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular2Bar;

/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular3Bar = function DeviceSignalCellular3Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M17 7L2 22h15z' })
	  );
	};
	DeviceSignalCellular3Bar = (0, _pure2.default)(DeviceSignalCellular3Bar);
	DeviceSignalCellular3Bar.displayName = 'DeviceSignalCellular3Bar';
	DeviceSignalCellular3Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular3Bar;

/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular4Bar = function DeviceSignalCellular4Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 22h20V2z' })
	  );
	};
	DeviceSignalCellular4Bar = (0, _pure2.default)(DeviceSignalCellular4Bar);
	DeviceSignalCellular4Bar.displayName = 'DeviceSignalCellular4Bar';
	DeviceSignalCellular4Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular4Bar;

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet0Bar = function DeviceSignalCellularConnectedNoInternet0Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet0Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet0Bar);
	DeviceSignalCellularConnectedNoInternet0Bar.displayName = 'DeviceSignalCellularConnectedNoInternet0Bar';
	DeviceSignalCellularConnectedNoInternet0Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet0Bar;

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet1Bar = function DeviceSignalCellularConnectedNoInternet1Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet1Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet1Bar);
	DeviceSignalCellularConnectedNoInternet1Bar.displayName = 'DeviceSignalCellularConnectedNoInternet1Bar';
	DeviceSignalCellularConnectedNoInternet1Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet1Bar;

/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet2Bar = function DeviceSignalCellularConnectedNoInternet2Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet2Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet2Bar);
	DeviceSignalCellularConnectedNoInternet2Bar.displayName = 'DeviceSignalCellularConnectedNoInternet2Bar';
	DeviceSignalCellularConnectedNoInternet2Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet2Bar;

/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet3Bar = function DeviceSignalCellularConnectedNoInternet3Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet3Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet3Bar);
	DeviceSignalCellularConnectedNoInternet3Bar.displayName = 'DeviceSignalCellularConnectedNoInternet3Bar';
	DeviceSignalCellularConnectedNoInternet3Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet3Bar;

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet4Bar = function DeviceSignalCellularConnectedNoInternet4Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet4Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet4Bar);
	DeviceSignalCellularConnectedNoInternet4Bar.displayName = 'DeviceSignalCellularConnectedNoInternet4Bar';
	DeviceSignalCellularConnectedNoInternet4Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet4Bar;

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularNoSim = function DeviceSignalCellularNoSim(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
	  );
	};
	DeviceSignalCellularNoSim = (0, _pure2.default)(DeviceSignalCellularNoSim);
	DeviceSignalCellularNoSim.displayName = 'DeviceSignalCellularNoSim';
	DeviceSignalCellularNoSim.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularNoSim;

/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularNull = function DeviceSignalCellularNull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z' })
	  );
	};
	DeviceSignalCellularNull = (0, _pure2.default)(DeviceSignalCellularNull);
	DeviceSignalCellularNull.displayName = 'DeviceSignalCellularNull';
	DeviceSignalCellularNull.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularNull;

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularOff = function DeviceSignalCellularOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z' })
	  );
	};
	DeviceSignalCellularOff = (0, _pure2.default)(DeviceSignalCellularOff);
	DeviceSignalCellularOff.displayName = 'DeviceSignalCellularOff';
	DeviceSignalCellularOff.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularOff;

/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi0Bar = function DeviceSignalWifi0Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
	  );
	};
	DeviceSignalWifi0Bar = (0, _pure2.default)(DeviceSignalWifi0Bar);
	DeviceSignalWifi0Bar.displayName = 'DeviceSignalWifi0Bar';
	DeviceSignalWifi0Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi0Bar;

/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi1BarLock = function DeviceSignalWifi1BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
	    _react2.default.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
	    _react2.default.createElement('path', { d: 'M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z' })
	  );
	};
	DeviceSignalWifi1BarLock = (0, _pure2.default)(DeviceSignalWifi1BarLock);
	DeviceSignalWifi1BarLock.displayName = 'DeviceSignalWifi1BarLock';
	DeviceSignalWifi1BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi1BarLock;

/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi1Bar = function DeviceSignalWifi1Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z' })
	  );
	};
	DeviceSignalWifi1Bar = (0, _pure2.default)(DeviceSignalWifi1Bar);
	DeviceSignalWifi1Bar.displayName = 'DeviceSignalWifi1Bar';
	DeviceSignalWifi1Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi1Bar;

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi2BarLock = function DeviceSignalWifi2BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
	    _react2.default.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
	    _react2.default.createElement('path', { d: 'M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z' })
	  );
	};
	DeviceSignalWifi2BarLock = (0, _pure2.default)(DeviceSignalWifi2BarLock);
	DeviceSignalWifi2BarLock.displayName = 'DeviceSignalWifi2BarLock';
	DeviceSignalWifi2BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi2BarLock;

/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi2Bar = function DeviceSignalWifi2Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z' })
	  );
	};
	DeviceSignalWifi2Bar = (0, _pure2.default)(DeviceSignalWifi2Bar);
	DeviceSignalWifi2Bar.displayName = 'DeviceSignalWifi2Bar';
	DeviceSignalWifi2Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi2Bar;

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi3BarLock = function DeviceSignalWifi3BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { opacity: '.3', d: 'M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z' }),
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9' })
	  );
	};
	DeviceSignalWifi3BarLock = (0, _pure2.default)(DeviceSignalWifi3BarLock);
	DeviceSignalWifi3BarLock.displayName = 'DeviceSignalWifi3BarLock';
	DeviceSignalWifi3BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi3BarLock;

/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi3Bar = function DeviceSignalWifi3Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
	  );
	};
	DeviceSignalWifi3Bar = (0, _pure2.default)(DeviceSignalWifi3Bar);
	DeviceSignalWifi3Bar.displayName = 'DeviceSignalWifi3Bar';
	DeviceSignalWifi3Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi3Bar;

/***/ },
/* 2200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi4BarLock = function DeviceSignalWifi4BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z' })
	  );
	};
	DeviceSignalWifi4BarLock = (0, _pure2.default)(DeviceSignalWifi4BarLock);
	DeviceSignalWifi4BarLock.displayName = 'DeviceSignalWifi4BarLock';
	DeviceSignalWifi4BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi4BarLock;

/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi4Bar = function DeviceSignalWifi4Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
	  );
	};
	DeviceSignalWifi4Bar = (0, _pure2.default)(DeviceSignalWifi4Bar);
	DeviceSignalWifi4Bar.displayName = 'DeviceSignalWifi4Bar';
	DeviceSignalWifi4Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi4Bar;

/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifiOff = function DeviceSignalWifiOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z' })
	  );
	};
	DeviceSignalWifiOff = (0, _pure2.default)(DeviceSignalWifiOff);
	DeviceSignalWifiOff.displayName = 'DeviceSignalWifiOff';
	DeviceSignalWifiOff.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifiOff;

/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceStorage = function DeviceStorage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z' })
	  );
	};
	DeviceStorage = (0, _pure2.default)(DeviceStorage);
	DeviceStorage.displayName = 'DeviceStorage';
	DeviceStorage.muiName = 'SvgIcon';
	
	exports.default = DeviceStorage;

/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceUsb = function DeviceUsb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z' })
	  );
	};
	DeviceUsb = (0, _pure2.default)(DeviceUsb);
	DeviceUsb.displayName = 'DeviceUsb';
	DeviceUsb.muiName = 'SvgIcon';
	
	exports.default = DeviceUsb;

/***/ },
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWallpaper = function DeviceWallpaper(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z' })
	  );
	};
	DeviceWallpaper = (0, _pure2.default)(DeviceWallpaper);
	DeviceWallpaper.displayName = 'DeviceWallpaper';
	DeviceWallpaper.muiName = 'SvgIcon';
	
	exports.default = DeviceWallpaper;

/***/ },
/* 2206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWidgets = function DeviceWidgets(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z' })
	  );
	};
	DeviceWidgets = (0, _pure2.default)(DeviceWidgets);
	DeviceWidgets.displayName = 'DeviceWidgets';
	DeviceWidgets.muiName = 'SvgIcon';
	
	exports.default = DeviceWidgets;

/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWifiLock = function DeviceWifiLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
	  );
	};
	DeviceWifiLock = (0, _pure2.default)(DeviceWifiLock);
	DeviceWifiLock.displayName = 'DeviceWifiLock';
	DeviceWifiLock.muiName = 'SvgIcon';
	
	exports.default = DeviceWifiLock;

/***/ },
/* 2208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWifiTethering = function DeviceWifiTethering(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z' })
	  );
	};
	DeviceWifiTethering = (0, _pure2.default)(DeviceWifiTethering);
	DeviceWifiTethering.displayName = 'DeviceWifiTethering';
	DeviceWifiTethering.muiName = 'SvgIcon';
	
	exports.default = DeviceWifiTethering;

/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorAttachFile = function EditorAttachFile(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z' })
	  );
	};
	EditorAttachFile = (0, _pure2.default)(EditorAttachFile);
	EditorAttachFile.displayName = 'EditorAttachFile';
	EditorAttachFile.muiName = 'SvgIcon';
	
	exports.default = EditorAttachFile;

/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorAttachMoney = function EditorAttachMoney(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z' })
	  );
	};
	EditorAttachMoney = (0, _pure2.default)(EditorAttachMoney);
	EditorAttachMoney.displayName = 'EditorAttachMoney';
	EditorAttachMoney.muiName = 'SvgIcon';
	
	exports.default = EditorAttachMoney;

/***/ },
/* 2211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderAll = function EditorBorderAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z' })
	  );
	};
	EditorBorderAll = (0, _pure2.default)(EditorBorderAll);
	EditorBorderAll.displayName = 'EditorBorderAll';
	EditorBorderAll.muiName = 'SvgIcon';
	
	exports.default = EditorBorderAll;

/***/ },
/* 2212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderBottom = function EditorBorderBottom(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z' })
	  );
	};
	EditorBorderBottom = (0, _pure2.default)(EditorBorderBottom);
	EditorBorderBottom.displayName = 'EditorBorderBottom';
	EditorBorderBottom.muiName = 'SvgIcon';
	
	exports.default = EditorBorderBottom;

/***/ },
/* 2213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderClear = function EditorBorderClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
	  );
	};
	EditorBorderClear = (0, _pure2.default)(EditorBorderClear);
	EditorBorderClear.displayName = 'EditorBorderClear';
	EditorBorderClear.muiName = 'SvgIcon';
	
	exports.default = EditorBorderClear;

/***/ },
/* 2214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderColor = function EditorBorderColor(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z' }),
	    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' })
	  );
	};
	EditorBorderColor = (0, _pure2.default)(EditorBorderColor);
	EditorBorderColor.displayName = 'EditorBorderColor';
	EditorBorderColor.muiName = 'SvgIcon';
	
	exports.default = EditorBorderColor;

/***/ },
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderHorizontal = function EditorBorderHorizontal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z' })
	  );
	};
	EditorBorderHorizontal = (0, _pure2.default)(EditorBorderHorizontal);
	EditorBorderHorizontal.displayName = 'EditorBorderHorizontal';
	EditorBorderHorizontal.muiName = 'SvgIcon';
	
	exports.default = EditorBorderHorizontal;

/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderInner = function EditorBorderInner(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z' })
	  );
	};
	EditorBorderInner = (0, _pure2.default)(EditorBorderInner);
	EditorBorderInner.displayName = 'EditorBorderInner';
	EditorBorderInner.muiName = 'SvgIcon';
	
	exports.default = EditorBorderInner;

/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderLeft = function EditorBorderLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
	  );
	};
	EditorBorderLeft = (0, _pure2.default)(EditorBorderLeft);
	EditorBorderLeft.displayName = 'EditorBorderLeft';
	EditorBorderLeft.muiName = 'SvgIcon';
	
	exports.default = EditorBorderLeft;

/***/ },
/* 2218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderOuter = function EditorBorderOuter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z' })
	  );
	};
	EditorBorderOuter = (0, _pure2.default)(EditorBorderOuter);
	EditorBorderOuter.displayName = 'EditorBorderOuter';
	EditorBorderOuter.muiName = 'SvgIcon';
	
	exports.default = EditorBorderOuter;

/***/ },
/* 2219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderRight = function EditorBorderRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z' })
	  );
	};
	EditorBorderRight = (0, _pure2.default)(EditorBorderRight);
	EditorBorderRight.displayName = 'EditorBorderRight';
	EditorBorderRight.muiName = 'SvgIcon';
	
	exports.default = EditorBorderRight;

/***/ },
/* 2220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderStyle = function EditorBorderStyle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z' })
	  );
	};
	EditorBorderStyle = (0, _pure2.default)(EditorBorderStyle);
	EditorBorderStyle.displayName = 'EditorBorderStyle';
	EditorBorderStyle.muiName = 'SvgIcon';
	
	exports.default = EditorBorderStyle;

/***/ },
/* 2221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderTop = function EditorBorderTop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z' })
	  );
	};
	EditorBorderTop = (0, _pure2.default)(EditorBorderTop);
	EditorBorderTop.displayName = 'EditorBorderTop';
	EditorBorderTop.muiName = 'SvgIcon';
	
	exports.default = EditorBorderTop;

/***/ },
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderVertical = function EditorBorderVertical(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z' })
	  );
	};
	EditorBorderVertical = (0, _pure2.default)(EditorBorderVertical);
	EditorBorderVertical.displayName = 'EditorBorderVertical';
	EditorBorderVertical.muiName = 'SvgIcon';
	
	exports.default = EditorBorderVertical;

/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBubbleChart = function EditorBubbleChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '7.2', cy: '14.4', r: '3.2' }),
	    _react2.default.createElement('circle', { cx: '14.8', cy: '18', r: '2' }),
	    _react2.default.createElement('circle', { cx: '15.2', cy: '8.8', r: '4.8' })
	  );
	};
	EditorBubbleChart = (0, _pure2.default)(EditorBubbleChart);
	EditorBubbleChart.displayName = 'EditorBubbleChart';
	EditorBubbleChart.muiName = 'SvgIcon';
	
	exports.default = EditorBubbleChart;

/***/ },
/* 2224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorDragHandle = function EditorDragHandle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 9H4v2h16V9zM4 15h16v-2H4v2z' })
	  );
	};
	EditorDragHandle = (0, _pure2.default)(EditorDragHandle);
	EditorDragHandle.displayName = 'EditorDragHandle';
	EditorDragHandle.muiName = 'SvgIcon';
	
	exports.default = EditorDragHandle;

/***/ },
/* 2225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignCenter = function EditorFormatAlignCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z' })
	  );
	};
	EditorFormatAlignCenter = (0, _pure2.default)(EditorFormatAlignCenter);
	EditorFormatAlignCenter.displayName = 'EditorFormatAlignCenter';
	EditorFormatAlignCenter.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignCenter;

/***/ },
/* 2226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignJustify = function EditorFormatAlignJustify(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z' })
	  );
	};
	EditorFormatAlignJustify = (0, _pure2.default)(EditorFormatAlignJustify);
	EditorFormatAlignJustify.displayName = 'EditorFormatAlignJustify';
	EditorFormatAlignJustify.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignJustify;

/***/ },
/* 2227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignLeft = function EditorFormatAlignLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z' })
	  );
	};
	EditorFormatAlignLeft = (0, _pure2.default)(EditorFormatAlignLeft);
	EditorFormatAlignLeft.displayName = 'EditorFormatAlignLeft';
	EditorFormatAlignLeft.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignLeft;

/***/ },
/* 2228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignRight = function EditorFormatAlignRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z' })
	  );
	};
	EditorFormatAlignRight = (0, _pure2.default)(EditorFormatAlignRight);
	EditorFormatAlignRight.displayName = 'EditorFormatAlignRight';
	EditorFormatAlignRight.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignRight;

/***/ },
/* 2229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatBold = function EditorFormatBold(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z' })
	  );
	};
	EditorFormatBold = (0, _pure2.default)(EditorFormatBold);
	EditorFormatBold.displayName = 'EditorFormatBold';
	EditorFormatBold.muiName = 'SvgIcon';
	
	exports.default = EditorFormatBold;

/***/ },
/* 2230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatClear = function EditorFormatClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z' })
	  );
	};
	EditorFormatClear = (0, _pure2.default)(EditorFormatClear);
	EditorFormatClear.displayName = 'EditorFormatClear';
	EditorFormatClear.muiName = 'SvgIcon';
	
	exports.default = EditorFormatClear;

/***/ },
/* 2231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatColorFill = function EditorFormatColorFill(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z' }),
	    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' })
	  );
	};
	EditorFormatColorFill = (0, _pure2.default)(EditorFormatColorFill);
	EditorFormatColorFill.displayName = 'EditorFormatColorFill';
	EditorFormatColorFill.muiName = 'SvgIcon';
	
	exports.default = EditorFormatColorFill;

/***/ },
/* 2232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatColorReset = function EditorFormatColorReset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z' })
	  );
	};
	EditorFormatColorReset = (0, _pure2.default)(EditorFormatColorReset);
	EditorFormatColorReset.displayName = 'EditorFormatColorReset';
	EditorFormatColorReset.muiName = 'SvgIcon';
	
	exports.default = EditorFormatColorReset;

/***/ },
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatColorText = function EditorFormatColorText(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' }),
	    _react2.default.createElement('path', { d: 'M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z' })
	  );
	};
	EditorFormatColorText = (0, _pure2.default)(EditorFormatColorText);
	EditorFormatColorText.displayName = 'EditorFormatColorText';
	EditorFormatColorText.muiName = 'SvgIcon';
	
	exports.default = EditorFormatColorText;

/***/ },
/* 2234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatIndentDecrease = function EditorFormatIndentDecrease(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
	  );
	};
	EditorFormatIndentDecrease = (0, _pure2.default)(EditorFormatIndentDecrease);
	EditorFormatIndentDecrease.displayName = 'EditorFormatIndentDecrease';
	EditorFormatIndentDecrease.muiName = 'SvgIcon';
	
	exports.default = EditorFormatIndentDecrease;

/***/ },
/* 2235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatIndentIncrease = function EditorFormatIndentIncrease(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
	  );
	};
	EditorFormatIndentIncrease = (0, _pure2.default)(EditorFormatIndentIncrease);
	EditorFormatIndentIncrease.displayName = 'EditorFormatIndentIncrease';
	EditorFormatIndentIncrease.muiName = 'SvgIcon';
	
	exports.default = EditorFormatIndentIncrease;

/***/ },
/* 2236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatItalic = function EditorFormatItalic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z' })
	  );
	};
	EditorFormatItalic = (0, _pure2.default)(EditorFormatItalic);
	EditorFormatItalic.displayName = 'EditorFormatItalic';
	EditorFormatItalic.muiName = 'SvgIcon';
	
	exports.default = EditorFormatItalic;

/***/ },
/* 2237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatLineSpacing = function EditorFormatLineSpacing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z' })
	  );
	};
	EditorFormatLineSpacing = (0, _pure2.default)(EditorFormatLineSpacing);
	EditorFormatLineSpacing.displayName = 'EditorFormatLineSpacing';
	EditorFormatLineSpacing.muiName = 'SvgIcon';
	
	exports.default = EditorFormatLineSpacing;

/***/ },
/* 2238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatListBulleted = function EditorFormatListBulleted(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' })
	  );
	};
	EditorFormatListBulleted = (0, _pure2.default)(EditorFormatListBulleted);
	EditorFormatListBulleted.displayName = 'EditorFormatListBulleted';
	EditorFormatListBulleted.muiName = 'SvgIcon';
	
	exports.default = EditorFormatListBulleted;

/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatListNumbered = function EditorFormatListNumbered(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z' })
	  );
	};
	EditorFormatListNumbered = (0, _pure2.default)(EditorFormatListNumbered);
	EditorFormatListNumbered.displayName = 'EditorFormatListNumbered';
	EditorFormatListNumbered.muiName = 'SvgIcon';
	
	exports.default = EditorFormatListNumbered;

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatPaint = function EditorFormatPaint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z' })
	  );
	};
	EditorFormatPaint = (0, _pure2.default)(EditorFormatPaint);
	EditorFormatPaint.displayName = 'EditorFormatPaint';
	EditorFormatPaint.muiName = 'SvgIcon';
	
	exports.default = EditorFormatPaint;

/***/ },
/* 2241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatQuote = function EditorFormatQuote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z' })
	  );
	};
	EditorFormatQuote = (0, _pure2.default)(EditorFormatQuote);
	EditorFormatQuote.displayName = 'EditorFormatQuote';
	EditorFormatQuote.muiName = 'SvgIcon';
	
	exports.default = EditorFormatQuote;

/***/ },
/* 2242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatShapes = function EditorFormatShapes(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z' })
	  );
	};
	EditorFormatShapes = (0, _pure2.default)(EditorFormatShapes);
	EditorFormatShapes.displayName = 'EditorFormatShapes';
	EditorFormatShapes.muiName = 'SvgIcon';
	
	exports.default = EditorFormatShapes;

/***/ },
/* 2243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatSize = function EditorFormatSize(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z' })
	  );
	};
	EditorFormatSize = (0, _pure2.default)(EditorFormatSize);
	EditorFormatSize.displayName = 'EditorFormatSize';
	EditorFormatSize.muiName = 'SvgIcon';
	
	exports.default = EditorFormatSize;

/***/ },
/* 2244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatStrikethrough = function EditorFormatStrikethrough(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z' })
	  );
	};
	EditorFormatStrikethrough = (0, _pure2.default)(EditorFormatStrikethrough);
	EditorFormatStrikethrough.displayName = 'EditorFormatStrikethrough';
	EditorFormatStrikethrough.muiName = 'SvgIcon';
	
	exports.default = EditorFormatStrikethrough;

/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatTextdirectionLToR = function EditorFormatTextdirectionLToR(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z' })
	  );
	};
	EditorFormatTextdirectionLToR = (0, _pure2.default)(EditorFormatTextdirectionLToR);
	EditorFormatTextdirectionLToR.displayName = 'EditorFormatTextdirectionLToR';
	EditorFormatTextdirectionLToR.muiName = 'SvgIcon';
	
	exports.default = EditorFormatTextdirectionLToR;

/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatTextdirectionRToL = function EditorFormatTextdirectionRToL(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z' })
	  );
	};
	EditorFormatTextdirectionRToL = (0, _pure2.default)(EditorFormatTextdirectionRToL);
	EditorFormatTextdirectionRToL.displayName = 'EditorFormatTextdirectionRToL';
	EditorFormatTextdirectionRToL.muiName = 'SvgIcon';
	
	exports.default = EditorFormatTextdirectionRToL;

/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatUnderlined = function EditorFormatUnderlined(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z' })
	  );
	};
	EditorFormatUnderlined = (0, _pure2.default)(EditorFormatUnderlined);
	EditorFormatUnderlined.displayName = 'EditorFormatUnderlined';
	EditorFormatUnderlined.muiName = 'SvgIcon';
	
	exports.default = EditorFormatUnderlined;

/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFunctions = function EditorFunctions(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z' })
	  );
	};
	EditorFunctions = (0, _pure2.default)(EditorFunctions);
	EditorFunctions.displayName = 'EditorFunctions';
	EditorFunctions.muiName = 'SvgIcon';
	
	exports.default = EditorFunctions;

/***/ },
/* 2249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorHighlight = function EditorHighlight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z' })
	  );
	};
	EditorHighlight = (0, _pure2.default)(EditorHighlight);
	EditorHighlight.displayName = 'EditorHighlight';
	EditorHighlight.muiName = 'SvgIcon';
	
	exports.default = EditorHighlight;

/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertChart = function EditorInsertChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	EditorInsertChart = (0, _pure2.default)(EditorInsertChart);
	EditorInsertChart.displayName = 'EditorInsertChart';
	EditorInsertChart.muiName = 'SvgIcon';
	
	exports.default = EditorInsertChart;

/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertComment = function EditorInsertComment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	EditorInsertComment = (0, _pure2.default)(EditorInsertComment);
	EditorInsertComment.displayName = 'EditorInsertComment';
	EditorInsertComment.muiName = 'SvgIcon';
	
	exports.default = EditorInsertComment;

/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertDriveFile = function EditorInsertDriveFile(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z' })
	  );
	};
	EditorInsertDriveFile = (0, _pure2.default)(EditorInsertDriveFile);
	EditorInsertDriveFile.displayName = 'EditorInsertDriveFile';
	EditorInsertDriveFile.muiName = 'SvgIcon';
	
	exports.default = EditorInsertDriveFile;

/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertEmoticon = function EditorInsertEmoticon(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	EditorInsertEmoticon = (0, _pure2.default)(EditorInsertEmoticon);
	EditorInsertEmoticon.displayName = 'EditorInsertEmoticon';
	EditorInsertEmoticon.muiName = 'SvgIcon';
	
	exports.default = EditorInsertEmoticon;

/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertInvitation = function EditorInsertInvitation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
	  );
	};
	EditorInsertInvitation = (0, _pure2.default)(EditorInsertInvitation);
	EditorInsertInvitation.displayName = 'EditorInsertInvitation';
	EditorInsertInvitation.muiName = 'SvgIcon';
	
	exports.default = EditorInsertInvitation;

/***/ },
/* 2255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertLink = function EditorInsertLink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
	  );
	};
	EditorInsertLink = (0, _pure2.default)(EditorInsertLink);
	EditorInsertLink.displayName = 'EditorInsertLink';
	EditorInsertLink.muiName = 'SvgIcon';
	
	exports.default = EditorInsertLink;

/***/ },
/* 2256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertPhoto = function EditorInsertPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
	  );
	};
	EditorInsertPhoto = (0, _pure2.default)(EditorInsertPhoto);
	EditorInsertPhoto.displayName = 'EditorInsertPhoto';
	EditorInsertPhoto.muiName = 'SvgIcon';
	
	exports.default = EditorInsertPhoto;

/***/ },
/* 2257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorLinearScale = function EditorLinearScale(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z' })
	  );
	};
	EditorLinearScale = (0, _pure2.default)(EditorLinearScale);
	EditorLinearScale.displayName = 'EditorLinearScale';
	EditorLinearScale.muiName = 'SvgIcon';
	
	exports.default = EditorLinearScale;

/***/ },
/* 2258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMergeType = function EditorMergeType(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
	  );
	};
	EditorMergeType = (0, _pure2.default)(EditorMergeType);
	EditorMergeType.displayName = 'EditorMergeType';
	EditorMergeType.muiName = 'SvgIcon';
	
	exports.default = EditorMergeType;

/***/ },
/* 2259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorModeComment = function EditorModeComment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z' })
	  );
	};
	EditorModeComment = (0, _pure2.default)(EditorModeComment);
	EditorModeComment.displayName = 'EditorModeComment';
	EditorModeComment.muiName = 'SvgIcon';
	
	exports.default = EditorModeComment;

/***/ },
/* 2260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMonetizationOn = function EditorMonetizationOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z' })
	  );
	};
	EditorMonetizationOn = (0, _pure2.default)(EditorMonetizationOn);
	EditorMonetizationOn.displayName = 'EditorMonetizationOn';
	EditorMonetizationOn.muiName = 'SvgIcon';
	
	exports.default = EditorMonetizationOn;

/***/ },
/* 2261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMoneyOff = function EditorMoneyOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z' })
	  );
	};
	EditorMoneyOff = (0, _pure2.default)(EditorMoneyOff);
	EditorMoneyOff.displayName = 'EditorMoneyOff';
	EditorMoneyOff.muiName = 'SvgIcon';
	
	exports.default = EditorMoneyOff;

/***/ },
/* 2262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMultilineChart = function EditorMultilineChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z' })
	  );
	};
	EditorMultilineChart = (0, _pure2.default)(EditorMultilineChart);
	EditorMultilineChart.displayName = 'EditorMultilineChart';
	EditorMultilineChart.muiName = 'SvgIcon';
	
	exports.default = EditorMultilineChart;

/***/ },
/* 2263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorPieChartOutlined = function EditorPieChartOutlined(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z' })
	  );
	};
	EditorPieChartOutlined = (0, _pure2.default)(EditorPieChartOutlined);
	EditorPieChartOutlined.displayName = 'EditorPieChartOutlined';
	EditorPieChartOutlined.muiName = 'SvgIcon';
	
	exports.default = EditorPieChartOutlined;

/***/ },
/* 2264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorPieChart = function EditorPieChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z' })
	  );
	};
	EditorPieChart = (0, _pure2.default)(EditorPieChart);
	EditorPieChart.displayName = 'EditorPieChart';
	EditorPieChart.muiName = 'SvgIcon';
	
	exports.default = EditorPieChart;

/***/ },
/* 2265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorPublish = function EditorPublish(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z' })
	  );
	};
	EditorPublish = (0, _pure2.default)(EditorPublish);
	EditorPublish.displayName = 'EditorPublish';
	EditorPublish.muiName = 'SvgIcon';
	
	exports.default = EditorPublish;

/***/ },
/* 2266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorShortText = function EditorShortText(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 9h16v2H4zm0 4h10v2H4z' })
	  );
	};
	EditorShortText = (0, _pure2.default)(EditorShortText);
	EditorShortText.displayName = 'EditorShortText';
	EditorShortText.muiName = 'SvgIcon';
	
	exports.default = EditorShortText;

/***/ },
/* 2267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorShowChart = function EditorShowChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z' })
	  );
	};
	EditorShowChart = (0, _pure2.default)(EditorShowChart);
	EditorShowChart.displayName = 'EditorShowChart';
	EditorShowChart.muiName = 'SvgIcon';
	
	exports.default = EditorShowChart;

/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorSpaceBar = function EditorSpaceBar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 9v4H6V9H4v6h16V9z' })
	  );
	};
	EditorSpaceBar = (0, _pure2.default)(EditorSpaceBar);
	EditorSpaceBar.displayName = 'EditorSpaceBar';
	EditorSpaceBar.muiName = 'SvgIcon';
	
	exports.default = EditorSpaceBar;

/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorStrikethroughS = function EditorStrikethroughS(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z' })
	  );
	};
	EditorStrikethroughS = (0, _pure2.default)(EditorStrikethroughS);
	EditorStrikethroughS.displayName = 'EditorStrikethroughS';
	EditorStrikethroughS.muiName = 'SvgIcon';
	
	exports.default = EditorStrikethroughS;

/***/ },
/* 2270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorTextFields = function EditorTextFields(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z' })
	  );
	};
	EditorTextFields = (0, _pure2.default)(EditorTextFields);
	EditorTextFields.displayName = 'EditorTextFields';
	EditorTextFields.muiName = 'SvgIcon';
	
	exports.default = EditorTextFields;

/***/ },
/* 2271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorTitle = function EditorTitle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 4v3h5.5v12h3V7H19V4z' })
	  );
	};
	EditorTitle = (0, _pure2.default)(EditorTitle);
	EditorTitle.displayName = 'EditorTitle';
	EditorTitle.muiName = 'SvgIcon';
	
	exports.default = EditorTitle;

/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorVerticalAlignBottom = function EditorVerticalAlignBottom(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z' })
	  );
	};
	EditorVerticalAlignBottom = (0, _pure2.default)(EditorVerticalAlignBottom);
	EditorVerticalAlignBottom.displayName = 'EditorVerticalAlignBottom';
	EditorVerticalAlignBottom.muiName = 'SvgIcon';
	
	exports.default = EditorVerticalAlignBottom;

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorVerticalAlignCenter = function EditorVerticalAlignCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z' })
	  );
	};
	EditorVerticalAlignCenter = (0, _pure2.default)(EditorVerticalAlignCenter);
	EditorVerticalAlignCenter.displayName = 'EditorVerticalAlignCenter';
	EditorVerticalAlignCenter.muiName = 'SvgIcon';
	
	exports.default = EditorVerticalAlignCenter;

/***/ },
/* 2274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorVerticalAlignTop = function EditorVerticalAlignTop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z' })
	  );
	};
	EditorVerticalAlignTop = (0, _pure2.default)(EditorVerticalAlignTop);
	EditorVerticalAlignTop.displayName = 'EditorVerticalAlignTop';
	EditorVerticalAlignTop.muiName = 'SvgIcon';
	
	exports.default = EditorVerticalAlignTop;

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorWrapText = function EditorWrapText(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z' })
	  );
	};
	EditorWrapText = (0, _pure2.default)(EditorWrapText);
	EditorWrapText.displayName = 'EditorWrapText';
	EditorWrapText.muiName = 'SvgIcon';
	
	exports.default = EditorWrapText;

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileAttachment = function FileAttachment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z' })
	  );
	};
	FileAttachment = (0, _pure2.default)(FileAttachment);
	FileAttachment.displayName = 'FileAttachment';
	FileAttachment.muiName = 'SvgIcon';
	
	exports.default = FileAttachment;

/***/ },
/* 2277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudCircle = function FileCloudCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z' })
	  );
	};
	FileCloudCircle = (0, _pure2.default)(FileCloudCircle);
	FileCloudCircle.displayName = 'FileCloudCircle';
	FileCloudCircle.muiName = 'SvgIcon';
	
	exports.default = FileCloudCircle;

/***/ },
/* 2278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudDone = function FileCloudDone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z' })
	  );
	};
	FileCloudDone = (0, _pure2.default)(FileCloudDone);
	FileCloudDone.displayName = 'FileCloudDone';
	FileCloudDone.muiName = 'SvgIcon';
	
	exports.default = FileCloudDone;

/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudDownload = function FileCloudDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z' })
	  );
	};
	FileCloudDownload = (0, _pure2.default)(FileCloudDownload);
	FileCloudDownload.displayName = 'FileCloudDownload';
	FileCloudDownload.muiName = 'SvgIcon';
	
	exports.default = FileCloudDownload;

/***/ },
/* 2280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudOff = function FileCloudOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z' })
	  );
	};
	FileCloudOff = (0, _pure2.default)(FileCloudOff);
	FileCloudOff.displayName = 'FileCloudOff';
	FileCloudOff.muiName = 'SvgIcon';
	
	exports.default = FileCloudOff;

/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudQueue = function FileCloudQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z' })
	  );
	};
	FileCloudQueue = (0, _pure2.default)(FileCloudQueue);
	FileCloudQueue.displayName = 'FileCloudQueue';
	FileCloudQueue.muiName = 'SvgIcon';
	
	exports.default = FileCloudQueue;

/***/ },
/* 2282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudUpload = function FileCloudUpload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
	  );
	};
	FileCloudUpload = (0, _pure2.default)(FileCloudUpload);
	FileCloudUpload.displayName = 'FileCloudUpload';
	FileCloudUpload.muiName = 'SvgIcon';
	
	exports.default = FileCloudUpload;

/***/ },
/* 2283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloud = function FileCloud(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z' })
	  );
	};
	FileCloud = (0, _pure2.default)(FileCloud);
	FileCloud.displayName = 'FileCloud';
	FileCloud.muiName = 'SvgIcon';
	
	exports.default = FileCloud;

/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCreateNewFolder = function FileCreateNewFolder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z' })
	  );
	};
	FileCreateNewFolder = (0, _pure2.default)(FileCreateNewFolder);
	FileCreateNewFolder.displayName = 'FileCreateNewFolder';
	FileCreateNewFolder.muiName = 'SvgIcon';
	
	exports.default = FileCreateNewFolder;

/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFileUpload = function FileFileUpload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z' })
	  );
	};
	FileFileUpload = (0, _pure2.default)(FileFileUpload);
	FileFileUpload.displayName = 'FileFileUpload';
	FileFileUpload.muiName = 'SvgIcon';
	
	exports.default = FileFileUpload;

/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFolderOpen = function FileFolderOpen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z' })
	  );
	};
	FileFolderOpen = (0, _pure2.default)(FileFolderOpen);
	FileFolderOpen.displayName = 'FileFolderOpen';
	FileFolderOpen.muiName = 'SvgIcon';
	
	exports.default = FileFolderOpen;

/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFolderShared = function FileFolderShared(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z' })
	  );
	};
	FileFolderShared = (0, _pure2.default)(FileFolderShared);
	FileFolderShared.displayName = 'FileFolderShared';
	FileFolderShared.muiName = 'SvgIcon';
	
	exports.default = FileFolderShared;

/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFolder = function FileFolder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' })
	  );
	};
	FileFolder = (0, _pure2.default)(FileFolder);
	FileFolder.displayName = 'FileFolder';
	FileFolder.muiName = 'SvgIcon';
	
	exports.default = FileFolder;

/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareCastConnected = function HardwareCastConnected(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	HardwareCastConnected = (0, _pure2.default)(HardwareCastConnected);
	HardwareCastConnected.displayName = 'HardwareCastConnected';
	HardwareCastConnected.muiName = 'SvgIcon';
	
	exports.default = HardwareCastConnected;

/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareCast = function HardwareCast(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z' })
	  );
	};
	HardwareCast = (0, _pure2.default)(HardwareCast);
	HardwareCast.displayName = 'HardwareCast';
	HardwareCast.muiName = 'SvgIcon';
	
	exports.default = HardwareCast;

/***/ },
/* 2291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareComputer = function HardwareComputer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
	  );
	};
	HardwareComputer = (0, _pure2.default)(HardwareComputer);
	HardwareComputer.displayName = 'HardwareComputer';
	HardwareComputer.muiName = 'SvgIcon';
	
	exports.default = HardwareComputer;

/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDesktopMac = function HardwareDesktopMac(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z' })
	  );
	};
	HardwareDesktopMac = (0, _pure2.default)(HardwareDesktopMac);
	HardwareDesktopMac.displayName = 'HardwareDesktopMac';
	HardwareDesktopMac.muiName = 'SvgIcon';
	
	exports.default = HardwareDesktopMac;

/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDesktopWindows = function HardwareDesktopWindows(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z' })
	  );
	};
	HardwareDesktopWindows = (0, _pure2.default)(HardwareDesktopWindows);
	HardwareDesktopWindows.displayName = 'HardwareDesktopWindows';
	HardwareDesktopWindows.muiName = 'SvgIcon';
	
	exports.default = HardwareDesktopWindows;

/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDeveloperBoard = function HardwareDeveloperBoard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z' })
	  );
	};
	HardwareDeveloperBoard = (0, _pure2.default)(HardwareDeveloperBoard);
	HardwareDeveloperBoard.displayName = 'HardwareDeveloperBoard';
	HardwareDeveloperBoard.muiName = 'SvgIcon';
	
	exports.default = HardwareDeveloperBoard;

/***/ },
/* 2295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDeviceHub = function HardwareDeviceHub(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z' })
	  );
	};
	HardwareDeviceHub = (0, _pure2.default)(HardwareDeviceHub);
	HardwareDeviceHub.displayName = 'HardwareDeviceHub';
	HardwareDeviceHub.muiName = 'SvgIcon';
	
	exports.default = HardwareDeviceHub;

/***/ },
/* 2296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDevicesOther = function HardwareDevicesOther(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z' })
	  );
	};
	HardwareDevicesOther = (0, _pure2.default)(HardwareDevicesOther);
	HardwareDevicesOther.displayName = 'HardwareDevicesOther';
	HardwareDevicesOther.muiName = 'SvgIcon';
	
	exports.default = HardwareDevicesOther;

/***/ },
/* 2297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDock = function HardwareDock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z' })
	  );
	};
	HardwareDock = (0, _pure2.default)(HardwareDock);
	HardwareDock.displayName = 'HardwareDock';
	HardwareDock.muiName = 'SvgIcon';
	
	exports.default = HardwareDock;

/***/ },
/* 2298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareGamepad = function HardwareGamepad(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
	  );
	};
	HardwareGamepad = (0, _pure2.default)(HardwareGamepad);
	HardwareGamepad.displayName = 'HardwareGamepad';
	HardwareGamepad.muiName = 'SvgIcon';
	
	exports.default = HardwareGamepad;

/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareHeadsetMic = function HardwareHeadsetMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z' })
	  );
	};
	HardwareHeadsetMic = (0, _pure2.default)(HardwareHeadsetMic);
	HardwareHeadsetMic.displayName = 'HardwareHeadsetMic';
	HardwareHeadsetMic.muiName = 'SvgIcon';
	
	exports.default = HardwareHeadsetMic;

/***/ },
/* 2300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareHeadset = function HardwareHeadset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z' })
	  );
	};
	HardwareHeadset = (0, _pure2.default)(HardwareHeadset);
	HardwareHeadset.displayName = 'HardwareHeadset';
	HardwareHeadset.muiName = 'SvgIcon';
	
	exports.default = HardwareHeadset;

/***/ },
/* 2301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowLeft = function HardwareKeyboardArrowLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' })
	  );
	};
	HardwareKeyboardArrowLeft = (0, _pure2.default)(HardwareKeyboardArrowLeft);
	HardwareKeyboardArrowLeft.displayName = 'HardwareKeyboardArrowLeft';
	HardwareKeyboardArrowLeft.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowLeft;

/***/ },
/* 2302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowRight = function HardwareKeyboardArrowRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' })
	  );
	};
	HardwareKeyboardArrowRight = (0, _pure2.default)(HardwareKeyboardArrowRight);
	HardwareKeyboardArrowRight.displayName = 'HardwareKeyboardArrowRight';
	HardwareKeyboardArrowRight.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowRight;

/***/ },
/* 2303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardBackspace = function HardwareKeyboardBackspace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z' })
	  );
	};
	HardwareKeyboardBackspace = (0, _pure2.default)(HardwareKeyboardBackspace);
	HardwareKeyboardBackspace.displayName = 'HardwareKeyboardBackspace';
	HardwareKeyboardBackspace.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardBackspace;

/***/ },
/* 2304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardCapslock = function HardwareKeyboardCapslock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z' })
	  );
	};
	HardwareKeyboardCapslock = (0, _pure2.default)(HardwareKeyboardCapslock);
	HardwareKeyboardCapslock.displayName = 'HardwareKeyboardCapslock';
	HardwareKeyboardCapslock.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardCapslock;

/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardHide = function HardwareKeyboardHide(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z' })
	  );
	};
	HardwareKeyboardHide = (0, _pure2.default)(HardwareKeyboardHide);
	HardwareKeyboardHide.displayName = 'HardwareKeyboardHide';
	HardwareKeyboardHide.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardHide;

/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardReturn = function HardwareKeyboardReturn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z' })
	  );
	};
	HardwareKeyboardReturn = (0, _pure2.default)(HardwareKeyboardReturn);
	HardwareKeyboardReturn.displayName = 'HardwareKeyboardReturn';
	HardwareKeyboardReturn.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardReturn;

/***/ },
/* 2307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardTab = function HardwareKeyboardTab(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z' })
	  );
	};
	HardwareKeyboardTab = (0, _pure2.default)(HardwareKeyboardTab);
	HardwareKeyboardTab.displayName = 'HardwareKeyboardTab';
	HardwareKeyboardTab.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardTab;

/***/ },
/* 2308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardVoice = function HardwareKeyboardVoice(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	HardwareKeyboardVoice = (0, _pure2.default)(HardwareKeyboardVoice);
	HardwareKeyboardVoice.displayName = 'HardwareKeyboardVoice';
	HardwareKeyboardVoice.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardVoice;

/***/ },
/* 2309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboard = function HardwareKeyboard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z' })
	  );
	};
	HardwareKeyboard = (0, _pure2.default)(HardwareKeyboard);
	HardwareKeyboard.displayName = 'HardwareKeyboard';
	HardwareKeyboard.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboard;

/***/ },
/* 2310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptopChromebook = function HardwareLaptopChromebook(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z' })
	  );
	};
	HardwareLaptopChromebook = (0, _pure2.default)(HardwareLaptopChromebook);
	HardwareLaptopChromebook.displayName = 'HardwareLaptopChromebook';
	HardwareLaptopChromebook.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptopChromebook;

/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptopMac = function HardwareLaptopMac(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	HardwareLaptopMac = (0, _pure2.default)(HardwareLaptopMac);
	HardwareLaptopMac.displayName = 'HardwareLaptopMac';
	HardwareLaptopMac.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptopMac;

/***/ },
/* 2312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptopWindows = function HardwareLaptopWindows(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z' })
	  );
	};
	HardwareLaptopWindows = (0, _pure2.default)(HardwareLaptopWindows);
	HardwareLaptopWindows.displayName = 'HardwareLaptopWindows';
	HardwareLaptopWindows.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptopWindows;

/***/ },
/* 2313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptop = function HardwareLaptop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
	  );
	};
	HardwareLaptop = (0, _pure2.default)(HardwareLaptop);
	HardwareLaptop.displayName = 'HardwareLaptop';
	HardwareLaptop.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptop;

/***/ },
/* 2314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareMemory = function HardwareMemory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z' })
	  );
	};
	HardwareMemory = (0, _pure2.default)(HardwareMemory);
	HardwareMemory.displayName = 'HardwareMemory';
	HardwareMemory.muiName = 'SvgIcon';
	
	exports.default = HardwareMemory;

/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareMouse = function HardwareMouse(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z' })
	  );
	};
	HardwareMouse = (0, _pure2.default)(HardwareMouse);
	HardwareMouse.displayName = 'HardwareMouse';
	HardwareMouse.muiName = 'SvgIcon';
	
	exports.default = HardwareMouse;

/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhoneAndroid = function HardwarePhoneAndroid(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z' })
	  );
	};
	HardwarePhoneAndroid = (0, _pure2.default)(HardwarePhoneAndroid);
	HardwarePhoneAndroid.displayName = 'HardwarePhoneAndroid';
	HardwarePhoneAndroid.muiName = 'SvgIcon';
	
	exports.default = HardwarePhoneAndroid;

/***/ },
/* 2317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhoneIphone = function HardwarePhoneIphone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z' })
	  );
	};
	HardwarePhoneIphone = (0, _pure2.default)(HardwarePhoneIphone);
	HardwarePhoneIphone.displayName = 'HardwarePhoneIphone';
	HardwarePhoneIphone.muiName = 'SvgIcon';
	
	exports.default = HardwarePhoneIphone;

/***/ },
/* 2318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhonelinkOff = function HardwarePhonelinkOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z' })
	  );
	};
	HardwarePhonelinkOff = (0, _pure2.default)(HardwarePhonelinkOff);
	HardwarePhonelinkOff.displayName = 'HardwarePhonelinkOff';
	HardwarePhonelinkOff.muiName = 'SvgIcon';
	
	exports.default = HardwarePhonelinkOff;

/***/ },
/* 2319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhonelink = function HardwarePhonelink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
	  );
	};
	HardwarePhonelink = (0, _pure2.default)(HardwarePhonelink);
	HardwarePhonelink.displayName = 'HardwarePhonelink';
	HardwarePhonelink.muiName = 'SvgIcon';
	
	exports.default = HardwarePhonelink;

/***/ },
/* 2320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePowerInput = function HardwarePowerInput(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z' })
	  );
	};
	HardwarePowerInput = (0, _pure2.default)(HardwarePowerInput);
	HardwarePowerInput.displayName = 'HardwarePowerInput';
	HardwarePowerInput.muiName = 'SvgIcon';
	
	exports.default = HardwarePowerInput;

/***/ },
/* 2321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareRouter = function HardwareRouter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z' })
	  );
	};
	HardwareRouter = (0, _pure2.default)(HardwareRouter);
	HardwareRouter.displayName = 'HardwareRouter';
	HardwareRouter.muiName = 'SvgIcon';
	
	exports.default = HardwareRouter;

/***/ },
/* 2322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareScanner = function HardwareScanner(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z' })
	  );
	};
	HardwareScanner = (0, _pure2.default)(HardwareScanner);
	HardwareScanner.displayName = 'HardwareScanner';
	HardwareScanner.muiName = 'SvgIcon';
	
	exports.default = HardwareScanner;

/***/ },
/* 2323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSecurity = function HardwareSecurity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z' })
	  );
	};
	HardwareSecurity = (0, _pure2.default)(HardwareSecurity);
	HardwareSecurity.displayName = 'HardwareSecurity';
	HardwareSecurity.muiName = 'SvgIcon';
	
	exports.default = HardwareSecurity;

/***/ },
/* 2324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSimCard = function HardwareSimCard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z' })
	  );
	};
	HardwareSimCard = (0, _pure2.default)(HardwareSimCard);
	HardwareSimCard.displayName = 'HardwareSimCard';
	HardwareSimCard.muiName = 'SvgIcon';
	
	exports.default = HardwareSimCard;

/***/ },
/* 2325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSmartphone = function HardwareSmartphone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	HardwareSmartphone = (0, _pure2.default)(HardwareSmartphone);
	HardwareSmartphone.displayName = 'HardwareSmartphone';
	HardwareSmartphone.muiName = 'SvgIcon';
	
	exports.default = HardwareSmartphone;

/***/ },
/* 2326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSpeakerGroup = function HardwareSpeakerGroup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' }),
	    _react2.default.createElement('circle', { cx: '14', cy: '12.5', r: '2.5' }),
	    _react2.default.createElement('path', { d: 'M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z' })
	  );
	};
	HardwareSpeakerGroup = (0, _pure2.default)(HardwareSpeakerGroup);
	HardwareSpeakerGroup.displayName = 'HardwareSpeakerGroup';
	HardwareSpeakerGroup.muiName = 'SvgIcon';
	
	exports.default = HardwareSpeakerGroup;

/***/ },
/* 2327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSpeaker = function HardwareSpeaker(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	HardwareSpeaker = (0, _pure2.default)(HardwareSpeaker);
	HardwareSpeaker.displayName = 'HardwareSpeaker';
	HardwareSpeaker.muiName = 'SvgIcon';
	
	exports.default = HardwareSpeaker;

/***/ },
/* 2328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTabletAndroid = function HardwareTabletAndroid(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z' })
	  );
	};
	HardwareTabletAndroid = (0, _pure2.default)(HardwareTabletAndroid);
	HardwareTabletAndroid.displayName = 'HardwareTabletAndroid';
	HardwareTabletAndroid.muiName = 'SvgIcon';
	
	exports.default = HardwareTabletAndroid;

/***/ },
/* 2329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTabletMac = function HardwareTabletMac(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z' })
	  );
	};
	HardwareTabletMac = (0, _pure2.default)(HardwareTabletMac);
	HardwareTabletMac.displayName = 'HardwareTabletMac';
	HardwareTabletMac.muiName = 'SvgIcon';
	
	exports.default = HardwareTabletMac;

/***/ },
/* 2330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTablet = function HardwareTablet(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z' })
	  );
	};
	HardwareTablet = (0, _pure2.default)(HardwareTablet);
	HardwareTablet.displayName = 'HardwareTablet';
	HardwareTablet.muiName = 'SvgIcon';
	
	exports.default = HardwareTablet;

/***/ },
/* 2331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareToys = function HardwareToys(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z' })
	  );
	};
	HardwareToys = (0, _pure2.default)(HardwareToys);
	HardwareToys.displayName = 'HardwareToys';
	HardwareToys.muiName = 'SvgIcon';
	
	exports.default = HardwareToys;

/***/ },
/* 2332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTv = function HardwareTv(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z' })
	  );
	};
	HardwareTv = (0, _pure2.default)(HardwareTv);
	HardwareTv.displayName = 'HardwareTv';
	HardwareTv.muiName = 'SvgIcon';
	
	exports.default = HardwareTv;

/***/ },
/* 2333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareVideogameAsset = function HardwareVideogameAsset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	HardwareVideogameAsset = (0, _pure2.default)(HardwareVideogameAsset);
	HardwareVideogameAsset.displayName = 'HardwareVideogameAsset';
	HardwareVideogameAsset.muiName = 'SvgIcon';
	
	exports.default = HardwareVideogameAsset;

/***/ },
/* 2334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareWatch = function HardwareWatch(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z' })
	  );
	};
	HardwareWatch = (0, _pure2.default)(HardwareWatch);
	HardwareWatch.displayName = 'HardwareWatch';
	HardwareWatch.muiName = 'SvgIcon';
	
	exports.default = HardwareWatch;

/***/ },
/* 2335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAddAPhoto = function ImageAddAPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z' })
	  );
	};
	ImageAddAPhoto = (0, _pure2.default)(ImageAddAPhoto);
	ImageAddAPhoto.displayName = 'ImageAddAPhoto';
	ImageAddAPhoto.muiName = 'SvgIcon';
	
	exports.default = ImageAddAPhoto;

/***/ },
/* 2336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAddToPhotos = function ImageAddToPhotos(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
	  );
	};
	ImageAddToPhotos = (0, _pure2.default)(ImageAddToPhotos);
	ImageAddToPhotos.displayName = 'ImageAddToPhotos';
	ImageAddToPhotos.muiName = 'SvgIcon';
	
	exports.default = ImageAddToPhotos;

/***/ },
/* 2337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAdjust = function ImageAdjust(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z' })
	  );
	};
	ImageAdjust = (0, _pure2.default)(ImageAdjust);
	ImageAdjust.displayName = 'ImageAdjust';
	ImageAdjust.muiName = 'SvgIcon';
	
	exports.default = ImageAdjust;

/***/ },
/* 2338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAssistantPhoto = function ImageAssistantPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
	  );
	};
	ImageAssistantPhoto = (0, _pure2.default)(ImageAssistantPhoto);
	ImageAssistantPhoto.displayName = 'ImageAssistantPhoto';
	ImageAssistantPhoto.muiName = 'SvgIcon';
	
	exports.default = ImageAssistantPhoto;

/***/ },
/* 2339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAssistant = function ImageAssistant(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z' })
	  );
	};
	ImageAssistant = (0, _pure2.default)(ImageAssistant);
	ImageAssistant.displayName = 'ImageAssistant';
	ImageAssistant.muiName = 'SvgIcon';
	
	exports.default = ImageAssistant;

/***/ },
/* 2340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAudiotrack = function ImageAudiotrack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z' })
	  );
	};
	ImageAudiotrack = (0, _pure2.default)(ImageAudiotrack);
	ImageAudiotrack.displayName = 'ImageAudiotrack';
	ImageAudiotrack.muiName = 'SvgIcon';
	
	exports.default = ImageAudiotrack;

/***/ },
/* 2341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurCircular = function ImageBlurCircular(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
	  );
	};
	ImageBlurCircular = (0, _pure2.default)(ImageBlurCircular);
	ImageBlurCircular.displayName = 'ImageBlurCircular';
	ImageBlurCircular.muiName = 'SvgIcon';
	
	exports.default = ImageBlurCircular;

/***/ },
/* 2342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurLinear = function ImageBlurLinear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z' })
	  );
	};
	ImageBlurLinear = (0, _pure2.default)(ImageBlurLinear);
	ImageBlurLinear.displayName = 'ImageBlurLinear';
	ImageBlurLinear.muiName = 'SvgIcon';
	
	exports.default = ImageBlurLinear;

/***/ },
/* 2343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurOff = function ImageBlurOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z' })
	  );
	};
	ImageBlurOff = (0, _pure2.default)(ImageBlurOff);
	ImageBlurOff.displayName = 'ImageBlurOff';
	ImageBlurOff.muiName = 'SvgIcon';
	
	exports.default = ImageBlurOff;

/***/ },
/* 2344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurOn = function ImageBlurOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
	  );
	};
	ImageBlurOn = (0, _pure2.default)(ImageBlurOn);
	ImageBlurOn.displayName = 'ImageBlurOn';
	ImageBlurOn.muiName = 'SvgIcon';
	
	exports.default = ImageBlurOn;

/***/ },
/* 2345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness1 = function ImageBrightness1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' })
	  );
	};
	ImageBrightness1 = (0, _pure2.default)(ImageBrightness1);
	ImageBrightness1.displayName = 'ImageBrightness1';
	ImageBrightness1.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness1;

/***/ },
/* 2346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness2 = function ImageBrightness2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z' })
	  );
	};
	ImageBrightness2 = (0, _pure2.default)(ImageBrightness2);
	ImageBrightness2.displayName = 'ImageBrightness2';
	ImageBrightness2.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness2;

/***/ },
/* 2347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness3 = function ImageBrightness3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z' })
	  );
	};
	ImageBrightness3 = (0, _pure2.default)(ImageBrightness3);
	ImageBrightness3.displayName = 'ImageBrightness3';
	ImageBrightness3.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness3;

/***/ },
/* 2348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness4 = function ImageBrightness4(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
	  );
	};
	ImageBrightness4 = (0, _pure2.default)(ImageBrightness4);
	ImageBrightness4.displayName = 'ImageBrightness4';
	ImageBrightness4.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness4;

/***/ },
/* 2349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness5 = function ImageBrightness5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
	  );
	};
	ImageBrightness5 = (0, _pure2.default)(ImageBrightness5);
	ImageBrightness5.displayName = 'ImageBrightness5';
	ImageBrightness5.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness5;

/***/ },
/* 2350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness6 = function ImageBrightness6(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
	  );
	};
	ImageBrightness6 = (0, _pure2.default)(ImageBrightness6);
	ImageBrightness6.displayName = 'ImageBrightness6';
	ImageBrightness6.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness6;

/***/ },
/* 2351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness7 = function ImageBrightness7(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
	  );
	};
	ImageBrightness7 = (0, _pure2.default)(ImageBrightness7);
	ImageBrightness7.displayName = 'ImageBrightness7';
	ImageBrightness7.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness7;

/***/ },
/* 2352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrokenImage = function ImageBrokenImage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z' })
	  );
	};
	ImageBrokenImage = (0, _pure2.default)(ImageBrokenImage);
	ImageBrokenImage.displayName = 'ImageBrokenImage';
	ImageBrokenImage.muiName = 'SvgIcon';
	
	exports.default = ImageBrokenImage;

/***/ },
/* 2353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrush = function ImageBrush(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z' })
	  );
	};
	ImageBrush = (0, _pure2.default)(ImageBrush);
	ImageBrush.displayName = 'ImageBrush';
	ImageBrush.muiName = 'SvgIcon';
	
	exports.default = ImageBrush;

/***/ },
/* 2354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBurstMode = function ImageBurstMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z' })
	  );
	};
	ImageBurstMode = (0, _pure2.default)(ImageBurstMode);
	ImageBurstMode.displayName = 'ImageBurstMode';
	ImageBurstMode.muiName = 'SvgIcon';
	
	exports.default = ImageBurstMode;

/***/ },
/* 2355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraAlt = function ImageCameraAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	ImageCameraAlt = (0, _pure2.default)(ImageCameraAlt);
	ImageCameraAlt.displayName = 'ImageCameraAlt';
	ImageCameraAlt.muiName = 'SvgIcon';
	
	exports.default = ImageCameraAlt;

/***/ },
/* 2356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraFront = function ImageCameraFront(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z' })
	  );
	};
	ImageCameraFront = (0, _pure2.default)(ImageCameraFront);
	ImageCameraFront.displayName = 'ImageCameraFront';
	ImageCameraFront.muiName = 'SvgIcon';
	
	exports.default = ImageCameraFront;

/***/ },
/* 2357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraRear = function ImageCameraRear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z' })
	  );
	};
	ImageCameraRear = (0, _pure2.default)(ImageCameraRear);
	ImageCameraRear.displayName = 'ImageCameraRear';
	ImageCameraRear.muiName = 'SvgIcon';
	
	exports.default = ImageCameraRear;

/***/ },
/* 2358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraRoll = function ImageCameraRoll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z' })
	  );
	};
	ImageCameraRoll = (0, _pure2.default)(ImageCameraRoll);
	ImageCameraRoll.displayName = 'ImageCameraRoll';
	ImageCameraRoll.muiName = 'SvgIcon';
	
	exports.default = ImageCameraRoll;

/***/ },
/* 2359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCamera = function ImageCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z' })
	  );
	};
	ImageCamera = (0, _pure2.default)(ImageCamera);
	ImageCamera.displayName = 'ImageCamera';
	ImageCamera.muiName = 'SvgIcon';
	
	exports.default = ImageCamera;

/***/ },
/* 2360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCenterFocusStrong = function ImageCenterFocusStrong(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z' })
	  );
	};
	ImageCenterFocusStrong = (0, _pure2.default)(ImageCenterFocusStrong);
	ImageCenterFocusStrong.displayName = 'ImageCenterFocusStrong';
	ImageCenterFocusStrong.muiName = 'SvgIcon';
	
	exports.default = ImageCenterFocusStrong;

/***/ },
/* 2361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCenterFocusWeak = function ImageCenterFocusWeak(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ImageCenterFocusWeak = (0, _pure2.default)(ImageCenterFocusWeak);
	ImageCenterFocusWeak.displayName = 'ImageCenterFocusWeak';
	ImageCenterFocusWeak.muiName = 'SvgIcon';
	
	exports.default = ImageCenterFocusWeak;

/***/ },
/* 2362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCollectionsBookmark = function ImageCollectionsBookmark(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z' })
	  );
	};
	ImageCollectionsBookmark = (0, _pure2.default)(ImageCollectionsBookmark);
	ImageCollectionsBookmark.displayName = 'ImageCollectionsBookmark';
	ImageCollectionsBookmark.muiName = 'SvgIcon';
	
	exports.default = ImageCollectionsBookmark;

/***/ },
/* 2363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCollections = function ImageCollections(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
	  );
	};
	ImageCollections = (0, _pure2.default)(ImageCollections);
	ImageCollections.displayName = 'ImageCollections';
	ImageCollections.muiName = 'SvgIcon';
	
	exports.default = ImageCollections;

/***/ },
/* 2364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageColorLens = function ImageColorLens(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ImageColorLens = (0, _pure2.default)(ImageColorLens);
	ImageColorLens.displayName = 'ImageColorLens';
	ImageColorLens.muiName = 'SvgIcon';
	
	exports.default = ImageColorLens;

/***/ },
/* 2365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageColorize = function ImageColorize(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z' })
	  );
	};
	ImageColorize = (0, _pure2.default)(ImageColorize);
	ImageColorize.displayName = 'ImageColorize';
	ImageColorize.muiName = 'SvgIcon';
	
	exports.default = ImageColorize;

/***/ },
/* 2366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCompare = function ImageCompare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ImageCompare = (0, _pure2.default)(ImageCompare);
	ImageCompare.displayName = 'ImageCompare';
	ImageCompare.muiName = 'SvgIcon';
	
	exports.default = ImageCompare;

/***/ },
/* 2367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageControlPointDuplicate = function ImageControlPointDuplicate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z' })
	  );
	};
	ImageControlPointDuplicate = (0, _pure2.default)(ImageControlPointDuplicate);
	ImageControlPointDuplicate.displayName = 'ImageControlPointDuplicate';
	ImageControlPointDuplicate.muiName = 'SvgIcon';
	
	exports.default = ImageControlPointDuplicate;

/***/ },
/* 2368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageControlPoint = function ImageControlPoint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ImageControlPoint = (0, _pure2.default)(ImageControlPoint);
	ImageControlPoint.displayName = 'ImageControlPoint';
	ImageControlPoint.muiName = 'SvgIcon';
	
	exports.default = ImageControlPoint;

/***/ },
/* 2369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop169 = function ImageCrop169(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z' })
	  );
	};
	ImageCrop169 = (0, _pure2.default)(ImageCrop169);
	ImageCrop169.displayName = 'ImageCrop169';
	ImageCrop169.muiName = 'SvgIcon';
	
	exports.default = ImageCrop169;

/***/ },
/* 2370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop32 = function ImageCrop32(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z' })
	  );
	};
	ImageCrop32 = (0, _pure2.default)(ImageCrop32);
	ImageCrop32.displayName = 'ImageCrop32';
	ImageCrop32.muiName = 'SvgIcon';
	
	exports.default = ImageCrop32;

/***/ },
/* 2371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop54 = function ImageCrop54(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
	  );
	};
	ImageCrop54 = (0, _pure2.default)(ImageCrop54);
	ImageCrop54.displayName = 'ImageCrop54';
	ImageCrop54.muiName = 'SvgIcon';
	
	exports.default = ImageCrop54;

/***/ },
/* 2372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop75 = function ImageCrop75(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z' })
	  );
	};
	ImageCrop75 = (0, _pure2.default)(ImageCrop75);
	ImageCrop75.displayName = 'ImageCrop75';
	ImageCrop75.muiName = 'SvgIcon';
	
	exports.default = ImageCrop75;

/***/ },
/* 2373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropDin = function ImageCropDin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
	  );
	};
	ImageCropDin = (0, _pure2.default)(ImageCropDin);
	ImageCropDin.displayName = 'ImageCropDin';
	ImageCropDin.muiName = 'SvgIcon';
	
	exports.default = ImageCropDin;

/***/ },
/* 2374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropFree = function ImageCropFree(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ImageCropFree = (0, _pure2.default)(ImageCropFree);
	ImageCropFree.displayName = 'ImageCropFree';
	ImageCropFree.muiName = 'SvgIcon';
	
	exports.default = ImageCropFree;

/***/ },
/* 2375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropLandscape = function ImageCropLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
	  );
	};
	ImageCropLandscape = (0, _pure2.default)(ImageCropLandscape);
	ImageCropLandscape.displayName = 'ImageCropLandscape';
	ImageCropLandscape.muiName = 'SvgIcon';
	
	exports.default = ImageCropLandscape;

/***/ },
/* 2376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropOriginal = function ImageCropOriginal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z' })
	  );
	};
	ImageCropOriginal = (0, _pure2.default)(ImageCropOriginal);
	ImageCropOriginal.displayName = 'ImageCropOriginal';
	ImageCropOriginal.muiName = 'SvgIcon';
	
	exports.default = ImageCropOriginal;

/***/ },
/* 2377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropPortrait = function ImageCropPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z' })
	  );
	};
	ImageCropPortrait = (0, _pure2.default)(ImageCropPortrait);
	ImageCropPortrait.displayName = 'ImageCropPortrait';
	ImageCropPortrait.muiName = 'SvgIcon';
	
	exports.default = ImageCropPortrait;

/***/ },
/* 2378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropRotate = function ImageCropRotate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z' })
	  );
	};
	ImageCropRotate = (0, _pure2.default)(ImageCropRotate);
	ImageCropRotate.displayName = 'ImageCropRotate';
	ImageCropRotate.muiName = 'SvgIcon';
	
	exports.default = ImageCropRotate;

/***/ },
/* 2379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropSquare = function ImageCropSquare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z' })
	  );
	};
	ImageCropSquare = (0, _pure2.default)(ImageCropSquare);
	ImageCropSquare.displayName = 'ImageCropSquare';
	ImageCropSquare.muiName = 'SvgIcon';
	
	exports.default = ImageCropSquare;

/***/ },
/* 2380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop = function ImageCrop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z' })
	  );
	};
	ImageCrop = (0, _pure2.default)(ImageCrop);
	ImageCrop.displayName = 'ImageCrop';
	ImageCrop.muiName = 'SvgIcon';
	
	exports.default = ImageCrop;

/***/ },
/* 2381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageDehaze = function ImageDehaze(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z' })
	  );
	};
	ImageDehaze = (0, _pure2.default)(ImageDehaze);
	ImageDehaze.displayName = 'ImageDehaze';
	ImageDehaze.muiName = 'SvgIcon';
	
	exports.default = ImageDehaze;

/***/ },
/* 2382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageDetails = function ImageDetails(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z' })
	  );
	};
	ImageDetails = (0, _pure2.default)(ImageDetails);
	ImageDetails.displayName = 'ImageDetails';
	ImageDetails.muiName = 'SvgIcon';
	
	exports.default = ImageDetails;

/***/ },
/* 2383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageEdit = function ImageEdit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	ImageEdit = (0, _pure2.default)(ImageEdit);
	ImageEdit.displayName = 'ImageEdit';
	ImageEdit.muiName = 'SvgIcon';
	
	exports.default = ImageEdit;

/***/ },
/* 2384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposureNeg1 = function ImageExposureNeg1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z' })
	  );
	};
	ImageExposureNeg1 = (0, _pure2.default)(ImageExposureNeg1);
	ImageExposureNeg1.displayName = 'ImageExposureNeg1';
	ImageExposureNeg1.muiName = 'SvgIcon';
	
	exports.default = ImageExposureNeg1;

/***/ },
/* 2385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposureNeg2 = function ImageExposureNeg2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z' })
	  );
	};
	ImageExposureNeg2 = (0, _pure2.default)(ImageExposureNeg2);
	ImageExposureNeg2.displayName = 'ImageExposureNeg2';
	ImageExposureNeg2.muiName = 'SvgIcon';
	
	exports.default = ImageExposureNeg2;

/***/ },
/* 2386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposurePlus1 = function ImageExposurePlus1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z' })
	  );
	};
	ImageExposurePlus1 = (0, _pure2.default)(ImageExposurePlus1);
	ImageExposurePlus1.displayName = 'ImageExposurePlus1';
	ImageExposurePlus1.muiName = 'SvgIcon';
	
	exports.default = ImageExposurePlus1;

/***/ },
/* 2387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposurePlus2 = function ImageExposurePlus2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z' })
	  );
	};
	ImageExposurePlus2 = (0, _pure2.default)(ImageExposurePlus2);
	ImageExposurePlus2.displayName = 'ImageExposurePlus2';
	ImageExposurePlus2.muiName = 'SvgIcon';
	
	exports.default = ImageExposurePlus2;

/***/ },
/* 2388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposureZero = function ImageExposureZero(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z' })
	  );
	};
	ImageExposureZero = (0, _pure2.default)(ImageExposureZero);
	ImageExposureZero.displayName = 'ImageExposureZero';
	ImageExposureZero.muiName = 'SvgIcon';
	
	exports.default = ImageExposureZero;

/***/ },
/* 2389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposure = function ImageExposure(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z' })
	  );
	};
	ImageExposure = (0, _pure2.default)(ImageExposure);
	ImageExposure.displayName = 'ImageExposure';
	ImageExposure.muiName = 'SvgIcon';
	
	exports.default = ImageExposure;

/***/ },
/* 2390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter1 = function ImageFilter1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilter1 = (0, _pure2.default)(ImageFilter1);
	ImageFilter1.displayName = 'ImageFilter1';
	ImageFilter1.muiName = 'SvgIcon';
	
	exports.default = ImageFilter1;

/***/ },
/* 2391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter2 = function ImageFilter2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z' })
	  );
	};
	ImageFilter2 = (0, _pure2.default)(ImageFilter2);
	ImageFilter2.displayName = 'ImageFilter2';
	ImageFilter2.muiName = 'SvgIcon';
	
	exports.default = ImageFilter2;

/***/ },
/* 2392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter3 = function ImageFilter3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z' })
	  );
	};
	ImageFilter3 = (0, _pure2.default)(ImageFilter3);
	ImageFilter3.displayName = 'ImageFilter3';
	ImageFilter3.muiName = 'SvgIcon';
	
	exports.default = ImageFilter3;

/***/ },
/* 2393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter4 = function ImageFilter4(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilter4 = (0, _pure2.default)(ImageFilter4);
	ImageFilter4.displayName = 'ImageFilter4';
	ImageFilter4.muiName = 'SvgIcon';
	
	exports.default = ImageFilter4;

/***/ },
/* 2394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter5 = function ImageFilter5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z' })
	  );
	};
	ImageFilter5 = (0, _pure2.default)(ImageFilter5);
	ImageFilter5.displayName = 'ImageFilter5';
	ImageFilter5.muiName = 'SvgIcon';
	
	exports.default = ImageFilter5;

/***/ },
/* 2395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter6 = function ImageFilter6(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z' })
	  );
	};
	ImageFilter6 = (0, _pure2.default)(ImageFilter6);
	ImageFilter6.displayName = 'ImageFilter6';
	ImageFilter6.muiName = 'SvgIcon';
	
	exports.default = ImageFilter6;

/***/ },
/* 2396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter7 = function ImageFilter7(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z' })
	  );
	};
	ImageFilter7 = (0, _pure2.default)(ImageFilter7);
	ImageFilter7.displayName = 'ImageFilter7';
	ImageFilter7.muiName = 'SvgIcon';
	
	exports.default = ImageFilter7;

/***/ },
/* 2397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter8 = function ImageFilter8(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z' })
	  );
	};
	ImageFilter8 = (0, _pure2.default)(ImageFilter8);
	ImageFilter8.displayName = 'ImageFilter8';
	ImageFilter8.muiName = 'SvgIcon';
	
	exports.default = ImageFilter8;

/***/ },
/* 2398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter9Plus = function ImageFilter9Plus(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z' })
	  );
	};
	ImageFilter9Plus = (0, _pure2.default)(ImageFilter9Plus);
	ImageFilter9Plus.displayName = 'ImageFilter9Plus';
	ImageFilter9Plus.muiName = 'SvgIcon';
	
	exports.default = ImageFilter9Plus;

/***/ },
/* 2399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter9 = function ImageFilter9(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z' })
	  );
	};
	ImageFilter9 = (0, _pure2.default)(ImageFilter9);
	ImageFilter9.displayName = 'ImageFilter9';
	ImageFilter9.muiName = 'SvgIcon';
	
	exports.default = ImageFilter9;

/***/ },
/* 2400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterBAndW = function ImageFilterBAndW(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z' })
	  );
	};
	ImageFilterBAndW = (0, _pure2.default)(ImageFilterBAndW);
	ImageFilterBAndW.displayName = 'ImageFilterBAndW';
	ImageFilterBAndW.muiName = 'SvgIcon';
	
	exports.default = ImageFilterBAndW;

/***/ },
/* 2401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterCenterFocus = function ImageFilterCenterFocus(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	ImageFilterCenterFocus = (0, _pure2.default)(ImageFilterCenterFocus);
	ImageFilterCenterFocus.displayName = 'ImageFilterCenterFocus';
	ImageFilterCenterFocus.muiName = 'SvgIcon';
	
	exports.default = ImageFilterCenterFocus;

/***/ },
/* 2402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterDrama = function ImageFilterDrama(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z' })
	  );
	};
	ImageFilterDrama = (0, _pure2.default)(ImageFilterDrama);
	ImageFilterDrama.displayName = 'ImageFilterDrama';
	ImageFilterDrama.muiName = 'SvgIcon';
	
	exports.default = ImageFilterDrama;

/***/ },
/* 2403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterFrames = function ImageFilterFrames(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12' })
	  );
	};
	ImageFilterFrames = (0, _pure2.default)(ImageFilterFrames);
	ImageFilterFrames.displayName = 'ImageFilterFrames';
	ImageFilterFrames.muiName = 'SvgIcon';
	
	exports.default = ImageFilterFrames;

/***/ },
/* 2404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterHdr = function ImageFilterHdr(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
	  );
	};
	ImageFilterHdr = (0, _pure2.default)(ImageFilterHdr);
	ImageFilterHdr.displayName = 'ImageFilterHdr';
	ImageFilterHdr.muiName = 'SvgIcon';
	
	exports.default = ImageFilterHdr;

/***/ },
/* 2405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterNone = function ImageFilterNone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilterNone = (0, _pure2.default)(ImageFilterNone);
	ImageFilterNone.displayName = 'ImageFilterNone';
	ImageFilterNone.muiName = 'SvgIcon';
	
	exports.default = ImageFilterNone;

/***/ },
/* 2406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterTiltShift = function ImageFilterTiltShift(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z' })
	  );
	};
	ImageFilterTiltShift = (0, _pure2.default)(ImageFilterTiltShift);
	ImageFilterTiltShift.displayName = 'ImageFilterTiltShift';
	ImageFilterTiltShift.muiName = 'SvgIcon';
	
	exports.default = ImageFilterTiltShift;

/***/ },
/* 2407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterVintage = function ImageFilterVintage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
	  );
	};
	ImageFilterVintage = (0, _pure2.default)(ImageFilterVintage);
	ImageFilterVintage.displayName = 'ImageFilterVintage';
	ImageFilterVintage.muiName = 'SvgIcon';
	
	exports.default = ImageFilterVintage;

/***/ },
/* 2408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter = function ImageFilter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilter = (0, _pure2.default)(ImageFilter);
	ImageFilter.displayName = 'ImageFilter';
	ImageFilter.muiName = 'SvgIcon';
	
	exports.default = ImageFilter;

/***/ },
/* 2409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlare = function ImageFlare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z' })
	  );
	};
	ImageFlare = (0, _pure2.default)(ImageFlare);
	ImageFlare.displayName = 'ImageFlare';
	ImageFlare.muiName = 'SvgIcon';
	
	exports.default = ImageFlare;

/***/ },
/* 2410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlashAuto = function ImageFlashAuto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z' })
	  );
	};
	ImageFlashAuto = (0, _pure2.default)(ImageFlashAuto);
	ImageFlashAuto.displayName = 'ImageFlashAuto';
	ImageFlashAuto.muiName = 'SvgIcon';
	
	exports.default = ImageFlashAuto;

/***/ },
/* 2411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlashOff = function ImageFlashOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z' })
	  );
	};
	ImageFlashOff = (0, _pure2.default)(ImageFlashOff);
	ImageFlashOff.displayName = 'ImageFlashOff';
	ImageFlashOff.muiName = 'SvgIcon';
	
	exports.default = ImageFlashOff;

/***/ },
/* 2412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlashOn = function ImageFlashOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 2v11h3v9l7-12h-4l4-8z' })
	  );
	};
	ImageFlashOn = (0, _pure2.default)(ImageFlashOn);
	ImageFlashOn.displayName = 'ImageFlashOn';
	ImageFlashOn.muiName = 'SvgIcon';
	
	exports.default = ImageFlashOn;

/***/ },
/* 2413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlip = function ImageFlip(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z' })
	  );
	};
	ImageFlip = (0, _pure2.default)(ImageFlip);
	ImageFlip.displayName = 'ImageFlip';
	ImageFlip.muiName = 'SvgIcon';
	
	exports.default = ImageFlip;

/***/ },
/* 2414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGradient = function ImageGradient(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z' })
	  );
	};
	ImageGradient = (0, _pure2.default)(ImageGradient);
	ImageGradient.displayName = 'ImageGradient';
	ImageGradient.muiName = 'SvgIcon';
	
	exports.default = ImageGradient;

/***/ },
/* 2415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGrain = function ImageGrain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	ImageGrain = (0, _pure2.default)(ImageGrain);
	ImageGrain.displayName = 'ImageGrain';
	ImageGrain.muiName = 'SvgIcon';
	
	exports.default = ImageGrain;

/***/ },
/* 2416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGridOff = function ImageGridOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z' })
	  );
	};
	ImageGridOff = (0, _pure2.default)(ImageGridOff);
	ImageGridOff.displayName = 'ImageGridOff';
	ImageGridOff.muiName = 'SvgIcon';
	
	exports.default = ImageGridOff;

/***/ },
/* 2417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGridOn = function ImageGridOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z' })
	  );
	};
	ImageGridOn = (0, _pure2.default)(ImageGridOn);
	ImageGridOn.displayName = 'ImageGridOn';
	ImageGridOn.muiName = 'SvgIcon';
	
	exports.default = ImageGridOn;

/***/ },
/* 2418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrOff = function ImageHdrOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z' })
	  );
	};
	ImageHdrOff = (0, _pure2.default)(ImageHdrOff);
	ImageHdrOff.displayName = 'ImageHdrOff';
	ImageHdrOff.muiName = 'SvgIcon';
	
	exports.default = ImageHdrOff;

/***/ },
/* 2419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrOn = function ImageHdrOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z' })
	  );
	};
	ImageHdrOn = (0, _pure2.default)(ImageHdrOn);
	ImageHdrOn.displayName = 'ImageHdrOn';
	ImageHdrOn.muiName = 'SvgIcon';
	
	exports.default = ImageHdrOn;

/***/ },
/* 2420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrStrong = function ImageHdrStrong(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ImageHdrStrong = (0, _pure2.default)(ImageHdrStrong);
	ImageHdrStrong.displayName = 'ImageHdrStrong';
	ImageHdrStrong.muiName = 'SvgIcon';
	
	exports.default = ImageHdrStrong;

/***/ },
/* 2421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrWeak = function ImageHdrWeak(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
	  );
	};
	ImageHdrWeak = (0, _pure2.default)(ImageHdrWeak);
	ImageHdrWeak.displayName = 'ImageHdrWeak';
	ImageHdrWeak.muiName = 'SvgIcon';
	
	exports.default = ImageHdrWeak;

/***/ },
/* 2422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHealing = function ImageHealing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z' })
	  );
	};
	ImageHealing = (0, _pure2.default)(ImageHealing);
	ImageHealing.displayName = 'ImageHealing';
	ImageHealing.muiName = 'SvgIcon';
	
	exports.default = ImageHealing;

/***/ },
/* 2423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageImageAspectRatio = function ImageImageAspectRatio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z' })
	  );
	};
	ImageImageAspectRatio = (0, _pure2.default)(ImageImageAspectRatio);
	ImageImageAspectRatio.displayName = 'ImageImageAspectRatio';
	ImageImageAspectRatio.muiName = 'SvgIcon';
	
	exports.default = ImageImageAspectRatio;

/***/ },
/* 2424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageImage = function ImageImage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
	  );
	};
	ImageImage = (0, _pure2.default)(ImageImage);
	ImageImage.displayName = 'ImageImage';
	ImageImage.muiName = 'SvgIcon';
	
	exports.default = ImageImage;

/***/ },
/* 2425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageIso = function ImageIso(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z' })
	  );
	};
	ImageIso = (0, _pure2.default)(ImageIso);
	ImageIso.displayName = 'ImageIso';
	ImageIso.muiName = 'SvgIcon';
	
	exports.default = ImageIso;

/***/ },
/* 2426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLandscape = function ImageLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
	  );
	};
	ImageLandscape = (0, _pure2.default)(ImageLandscape);
	ImageLandscape.displayName = 'ImageLandscape';
	ImageLandscape.muiName = 'SvgIcon';
	
	exports.default = ImageLandscape;

/***/ },
/* 2427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLeakAdd = function ImageLeakAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z' })
	  );
	};
	ImageLeakAdd = (0, _pure2.default)(ImageLeakAdd);
	ImageLeakAdd.displayName = 'ImageLeakAdd';
	ImageLeakAdd.muiName = 'SvgIcon';
	
	exports.default = ImageLeakAdd;

/***/ },
/* 2428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLeakRemove = function ImageLeakRemove(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z' })
	  );
	};
	ImageLeakRemove = (0, _pure2.default)(ImageLeakRemove);
	ImageLeakRemove.displayName = 'ImageLeakRemove';
	ImageLeakRemove.muiName = 'SvgIcon';
	
	exports.default = ImageLeakRemove;

/***/ },
/* 2429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLens = function ImageLens(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z' })
	  );
	};
	ImageLens = (0, _pure2.default)(ImageLens);
	ImageLens.displayName = 'ImageLens';
	ImageLens.muiName = 'SvgIcon';
	
	exports.default = ImageLens;

/***/ },
/* 2430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLinkedCamera = function ImageLinkedCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '14', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6' }),
	    _react2.default.createElement('path', { d: 'M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	ImageLinkedCamera = (0, _pure2.default)(ImageLinkedCamera);
	ImageLinkedCamera.displayName = 'ImageLinkedCamera';
	ImageLinkedCamera.muiName = 'SvgIcon';
	
	exports.default = ImageLinkedCamera;

/***/ },
/* 2431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks3 = function ImageLooks3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z' })
	  );
	};
	ImageLooks3 = (0, _pure2.default)(ImageLooks3);
	ImageLooks3.displayName = 'ImageLooks3';
	ImageLooks3.muiName = 'SvgIcon';
	
	exports.default = ImageLooks3;

/***/ },
/* 2432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks4 = function ImageLooks4(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z' })
	  );
	};
	ImageLooks4 = (0, _pure2.default)(ImageLooks4);
	ImageLooks4.displayName = 'ImageLooks4';
	ImageLooks4.muiName = 'SvgIcon';
	
	exports.default = ImageLooks4;

/***/ },
/* 2433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks5 = function ImageLooks5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z' })
	  );
	};
	ImageLooks5 = (0, _pure2.default)(ImageLooks5);
	ImageLooks5.displayName = 'ImageLooks5';
	ImageLooks5.muiName = 'SvgIcon';
	
	exports.default = ImageLooks5;

/***/ },
/* 2434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks6 = function ImageLooks6(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z' })
	  );
	};
	ImageLooks6 = (0, _pure2.default)(ImageLooks6);
	ImageLooks6.displayName = 'ImageLooks6';
	ImageLooks6.muiName = 'SvgIcon';
	
	exports.default = ImageLooks6;

/***/ },
/* 2435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooksOne = function ImageLooksOne(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z' })
	  );
	};
	ImageLooksOne = (0, _pure2.default)(ImageLooksOne);
	ImageLooksOne.displayName = 'ImageLooksOne';
	ImageLooksOne.muiName = 'SvgIcon';
	
	exports.default = ImageLooksOne;

/***/ },
/* 2436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooksTwo = function ImageLooksTwo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z' })
	  );
	};
	ImageLooksTwo = (0, _pure2.default)(ImageLooksTwo);
	ImageLooksTwo.displayName = 'ImageLooksTwo';
	ImageLooksTwo.muiName = 'SvgIcon';
	
	exports.default = ImageLooksTwo;

/***/ },
/* 2437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks = function ImageLooks(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z' })
	  );
	};
	ImageLooks = (0, _pure2.default)(ImageLooks);
	ImageLooks.displayName = 'ImageLooks';
	ImageLooks.muiName = 'SvgIcon';
	
	exports.default = ImageLooks;

/***/ },
/* 2438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLoupe = function ImageLoupe(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ImageLoupe = (0, _pure2.default)(ImageLoupe);
	ImageLoupe.displayName = 'ImageLoupe';
	ImageLoupe.muiName = 'SvgIcon';
	
	exports.default = ImageLoupe;

/***/ },
/* 2439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMonochromePhotos = function ImageMonochromePhotos(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z' })
	  );
	};
	ImageMonochromePhotos = (0, _pure2.default)(ImageMonochromePhotos);
	ImageMonochromePhotos.displayName = 'ImageMonochromePhotos';
	ImageMonochromePhotos.muiName = 'SvgIcon';
	
	exports.default = ImageMonochromePhotos;

/***/ },
/* 2440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMovieCreation = function ImageMovieCreation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
	  );
	};
	ImageMovieCreation = (0, _pure2.default)(ImageMovieCreation);
	ImageMovieCreation.displayName = 'ImageMovieCreation';
	ImageMovieCreation.muiName = 'SvgIcon';
	
	exports.default = ImageMovieCreation;

/***/ },
/* 2441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMovieFilter = function ImageMovieFilter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z' })
	  );
	};
	ImageMovieFilter = (0, _pure2.default)(ImageMovieFilter);
	ImageMovieFilter.displayName = 'ImageMovieFilter';
	ImageMovieFilter.muiName = 'SvgIcon';
	
	exports.default = ImageMovieFilter;

/***/ },
/* 2442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMusicNote = function ImageMusicNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z' })
	  );
	};
	ImageMusicNote = (0, _pure2.default)(ImageMusicNote);
	ImageMusicNote.displayName = 'ImageMusicNote';
	ImageMusicNote.muiName = 'SvgIcon';
	
	exports.default = ImageMusicNote;

/***/ },
/* 2443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNaturePeople = function ImageNaturePeople(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z' })
	  );
	};
	ImageNaturePeople = (0, _pure2.default)(ImageNaturePeople);
	ImageNaturePeople.displayName = 'ImageNaturePeople';
	ImageNaturePeople.muiName = 'SvgIcon';
	
	exports.default = ImageNaturePeople;

/***/ },
/* 2444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNature = function ImageNature(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z' })
	  );
	};
	ImageNature = (0, _pure2.default)(ImageNature);
	ImageNature.displayName = 'ImageNature';
	ImageNature.muiName = 'SvgIcon';
	
	exports.default = ImageNature;

/***/ },
/* 2445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNavigateBefore = function ImageNavigateBefore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	ImageNavigateBefore = (0, _pure2.default)(ImageNavigateBefore);
	ImageNavigateBefore.displayName = 'ImageNavigateBefore';
	ImageNavigateBefore.muiName = 'SvgIcon';
	
	exports.default = ImageNavigateBefore;

/***/ },
/* 2446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNavigateNext = function ImageNavigateNext(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	ImageNavigateNext = (0, _pure2.default)(ImageNavigateNext);
	ImageNavigateNext.displayName = 'ImageNavigateNext';
	ImageNavigateNext.muiName = 'SvgIcon';
	
	exports.default = ImageNavigateNext;

/***/ },
/* 2447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePalette = function ImagePalette(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ImagePalette = (0, _pure2.default)(ImagePalette);
	ImagePalette.displayName = 'ImagePalette';
	ImagePalette.muiName = 'SvgIcon';
	
	exports.default = ImagePalette;

/***/ },
/* 2448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaFishEye = function ImagePanoramaFishEye(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ImagePanoramaFishEye = (0, _pure2.default)(ImagePanoramaFishEye);
	ImagePanoramaFishEye.displayName = 'ImagePanoramaFishEye';
	ImagePanoramaFishEye.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaFishEye;

/***/ },
/* 2449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaHorizontal = function ImagePanoramaHorizontal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z' })
	  );
	};
	ImagePanoramaHorizontal = (0, _pure2.default)(ImagePanoramaHorizontal);
	ImagePanoramaHorizontal.displayName = 'ImagePanoramaHorizontal';
	ImagePanoramaHorizontal.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaHorizontal;

/***/ },
/* 2450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaVertical = function ImagePanoramaVertical(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z' })
	  );
	};
	ImagePanoramaVertical = (0, _pure2.default)(ImagePanoramaVertical);
	ImagePanoramaVertical.displayName = 'ImagePanoramaVertical';
	ImagePanoramaVertical.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaVertical;

/***/ },
/* 2451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaWideAngle = function ImagePanoramaWideAngle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z' })
	  );
	};
	ImagePanoramaWideAngle = (0, _pure2.default)(ImagePanoramaWideAngle);
	ImagePanoramaWideAngle.displayName = 'ImagePanoramaWideAngle';
	ImagePanoramaWideAngle.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaWideAngle;

/***/ },
/* 2452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanorama = function ImagePanorama(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z' })
	  );
	};
	ImagePanorama = (0, _pure2.default)(ImagePanorama);
	ImagePanorama.displayName = 'ImagePanorama';
	ImagePanorama.muiName = 'SvgIcon';
	
	exports.default = ImagePanorama;

/***/ },
/* 2453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoAlbum = function ImagePhotoAlbum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z' })
	  );
	};
	ImagePhotoAlbum = (0, _pure2.default)(ImagePhotoAlbum);
	ImagePhotoAlbum.displayName = 'ImagePhotoAlbum';
	ImagePhotoAlbum.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoAlbum;

/***/ },
/* 2454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoCamera = function ImagePhotoCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	ImagePhotoCamera = (0, _pure2.default)(ImagePhotoCamera);
	ImagePhotoCamera.displayName = 'ImagePhotoCamera';
	ImagePhotoCamera.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoCamera;

/***/ },
/* 2455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoFilter = function ImagePhotoFilter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z' })
	  );
	};
	ImagePhotoFilter = (0, _pure2.default)(ImagePhotoFilter);
	ImagePhotoFilter.displayName = 'ImagePhotoFilter';
	ImagePhotoFilter.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoFilter;

/***/ },
/* 2456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoLibrary = function ImagePhotoLibrary(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
	  );
	};
	ImagePhotoLibrary = (0, _pure2.default)(ImagePhotoLibrary);
	ImagePhotoLibrary.displayName = 'ImagePhotoLibrary';
	ImagePhotoLibrary.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoLibrary;

/***/ },
/* 2457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoSizeSelectActual = function ImagePhotoSizeSelectActual(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z' })
	  );
	};
	ImagePhotoSizeSelectActual = (0, _pure2.default)(ImagePhotoSizeSelectActual);
	ImagePhotoSizeSelectActual.displayName = 'ImagePhotoSizeSelectActual';
	ImagePhotoSizeSelectActual.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoSizeSelectActual;

/***/ },
/* 2458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoSizeSelectLarge = function ImagePhotoSizeSelectLarge(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z' })
	  );
	};
	ImagePhotoSizeSelectLarge = (0, _pure2.default)(ImagePhotoSizeSelectLarge);
	ImagePhotoSizeSelectLarge.displayName = 'ImagePhotoSizeSelectLarge';
	ImagePhotoSizeSelectLarge.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoSizeSelectLarge;

/***/ },
/* 2459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoSizeSelectSmall = function ImagePhotoSizeSelectSmall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z' })
	  );
	};
	ImagePhotoSizeSelectSmall = (0, _pure2.default)(ImagePhotoSizeSelectSmall);
	ImagePhotoSizeSelectSmall.displayName = 'ImagePhotoSizeSelectSmall';
	ImagePhotoSizeSelectSmall.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoSizeSelectSmall;

/***/ },
/* 2460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhoto = function ImagePhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
	  );
	};
	ImagePhoto = (0, _pure2.default)(ImagePhoto);
	ImagePhoto.displayName = 'ImagePhoto';
	ImagePhoto.muiName = 'SvgIcon';
	
	exports.default = ImagePhoto;

/***/ },
/* 2461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePictureAsPdf = function ImagePictureAsPdf(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z' })
	  );
	};
	ImagePictureAsPdf = (0, _pure2.default)(ImagePictureAsPdf);
	ImagePictureAsPdf.displayName = 'ImagePictureAsPdf';
	ImagePictureAsPdf.muiName = 'SvgIcon';
	
	exports.default = ImagePictureAsPdf;

/***/ },
/* 2462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePortrait = function ImagePortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
	  );
	};
	ImagePortrait = (0, _pure2.default)(ImagePortrait);
	ImagePortrait.displayName = 'ImagePortrait';
	ImagePortrait.muiName = 'SvgIcon';
	
	exports.default = ImagePortrait;

/***/ },
/* 2463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRemoveRedEye = function ImageRemoveRedEye(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	ImageRemoveRedEye = (0, _pure2.default)(ImageRemoveRedEye);
	ImageRemoveRedEye.displayName = 'ImageRemoveRedEye';
	ImageRemoveRedEye.muiName = 'SvgIcon';
	
	exports.default = ImageRemoveRedEye;

/***/ },
/* 2464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRotate90DegreesCcw = function ImageRotate90DegreesCcw(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z' })
	  );
	};
	ImageRotate90DegreesCcw = (0, _pure2.default)(ImageRotate90DegreesCcw);
	ImageRotate90DegreesCcw.displayName = 'ImageRotate90DegreesCcw';
	ImageRotate90DegreesCcw.muiName = 'SvgIcon';
	
	exports.default = ImageRotate90DegreesCcw;

/***/ },
/* 2465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRotateLeft = function ImageRotateLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z' })
	  );
	};
	ImageRotateLeft = (0, _pure2.default)(ImageRotateLeft);
	ImageRotateLeft.displayName = 'ImageRotateLeft';
	ImageRotateLeft.muiName = 'SvgIcon';
	
	exports.default = ImageRotateLeft;

/***/ },
/* 2466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRotateRight = function ImageRotateRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z' })
	  );
	};
	ImageRotateRight = (0, _pure2.default)(ImageRotateRight);
	ImageRotateRight.displayName = 'ImageRotateRight';
	ImageRotateRight.muiName = 'SvgIcon';
	
	exports.default = ImageRotateRight;

/***/ },
/* 2467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSlideshow = function ImageSlideshow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
	  );
	};
	ImageSlideshow = (0, _pure2.default)(ImageSlideshow);
	ImageSlideshow.displayName = 'ImageSlideshow';
	ImageSlideshow.muiName = 'SvgIcon';
	
	exports.default = ImageSlideshow;

/***/ },
/* 2468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageStraighten = function ImageStraighten(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z' })
	  );
	};
	ImageStraighten = (0, _pure2.default)(ImageStraighten);
	ImageStraighten.displayName = 'ImageStraighten';
	ImageStraighten.muiName = 'SvgIcon';
	
	exports.default = ImageStraighten;

/***/ },
/* 2469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageStyle = function ImageStyle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z' })
	  );
	};
	ImageStyle = (0, _pure2.default)(ImageStyle);
	ImageStyle.displayName = 'ImageStyle';
	ImageStyle.muiName = 'SvgIcon';
	
	exports.default = ImageStyle;

/***/ },
/* 2470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSwitchCamera = function ImageSwitchCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
	  );
	};
	ImageSwitchCamera = (0, _pure2.default)(ImageSwitchCamera);
	ImageSwitchCamera.displayName = 'ImageSwitchCamera';
	ImageSwitchCamera.muiName = 'SvgIcon';
	
	exports.default = ImageSwitchCamera;

/***/ },
/* 2471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSwitchVideo = function ImageSwitchVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
	  );
	};
	ImageSwitchVideo = (0, _pure2.default)(ImageSwitchVideo);
	ImageSwitchVideo.displayName = 'ImageSwitchVideo';
	ImageSwitchVideo.muiName = 'SvgIcon';
	
	exports.default = ImageSwitchVideo;

/***/ },
/* 2472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTagFaces = function ImageTagFaces(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	ImageTagFaces = (0, _pure2.default)(ImageTagFaces);
	ImageTagFaces.displayName = 'ImageTagFaces';
	ImageTagFaces.muiName = 'SvgIcon';
	
	exports.default = ImageTagFaces;

/***/ },
/* 2473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTexture = function ImageTexture(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z' })
	  );
	};
	ImageTexture = (0, _pure2.default)(ImageTexture);
	ImageTexture.displayName = 'ImageTexture';
	ImageTexture.muiName = 'SvgIcon';
	
	exports.default = ImageTexture;

/***/ },
/* 2474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimelapse = function ImageTimelapse(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ImageTimelapse = (0, _pure2.default)(ImageTimelapse);
	ImageTimelapse.displayName = 'ImageTimelapse';
	ImageTimelapse.muiName = 'SvgIcon';
	
	exports.default = ImageTimelapse;

/***/ },
/* 2475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimer10 = function ImageTimer10(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z' })
	  );
	};
	ImageTimer10 = (0, _pure2.default)(ImageTimer10);
	ImageTimer10.displayName = 'ImageTimer10';
	ImageTimer10.muiName = 'SvgIcon';
	
	exports.default = ImageTimer10;

/***/ },
/* 2476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimer3 = function ImageTimer3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z' })
	  );
	};
	ImageTimer3 = (0, _pure2.default)(ImageTimer3);
	ImageTimer3.displayName = 'ImageTimer3';
	ImageTimer3.muiName = 'SvgIcon';
	
	exports.default = ImageTimer3;

/***/ },
/* 2477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimerOff = function ImageTimerOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z' })
	  );
	};
	ImageTimerOff = (0, _pure2.default)(ImageTimerOff);
	ImageTimerOff.displayName = 'ImageTimerOff';
	ImageTimerOff.muiName = 'SvgIcon';
	
	exports.default = ImageTimerOff;

/***/ },
/* 2478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimer = function ImageTimer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	ImageTimer = (0, _pure2.default)(ImageTimer);
	ImageTimer.displayName = 'ImageTimer';
	ImageTimer.muiName = 'SvgIcon';
	
	exports.default = ImageTimer;

/***/ },
/* 2479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTonality = function ImageTonality(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z' })
	  );
	};
	ImageTonality = (0, _pure2.default)(ImageTonality);
	ImageTonality.displayName = 'ImageTonality';
	ImageTonality.muiName = 'SvgIcon';
	
	exports.default = ImageTonality;

/***/ },
/* 2480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTransform = function ImageTransform(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z' })
	  );
	};
	ImageTransform = (0, _pure2.default)(ImageTransform);
	ImageTransform.displayName = 'ImageTransform';
	ImageTransform.muiName = 'SvgIcon';
	
	exports.default = ImageTransform;

/***/ },
/* 2481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTune = function ImageTune(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z' })
	  );
	};
	ImageTune = (0, _pure2.default)(ImageTune);
	ImageTune.displayName = 'ImageTune';
	ImageTune.muiName = 'SvgIcon';
	
	exports.default = ImageTune;

/***/ },
/* 2482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageViewComfy = function ImageViewComfy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z' })
	  );
	};
	ImageViewComfy = (0, _pure2.default)(ImageViewComfy);
	ImageViewComfy.displayName = 'ImageViewComfy';
	ImageViewComfy.muiName = 'SvgIcon';
	
	exports.default = ImageViewComfy;

/***/ },
/* 2483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageViewCompact = function ImageViewCompact(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z' })
	  );
	};
	ImageViewCompact = (0, _pure2.default)(ImageViewCompact);
	ImageViewCompact.displayName = 'ImageViewCompact';
	ImageViewCompact.muiName = 'SvgIcon';
	
	exports.default = ImageViewCompact;

/***/ },
/* 2484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageVignette = function ImageVignette(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z' })
	  );
	};
	ImageVignette = (0, _pure2.default)(ImageVignette);
	ImageVignette.displayName = 'ImageVignette';
	ImageVignette.muiName = 'SvgIcon';
	
	exports.default = ImageVignette;

/***/ },
/* 2485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbAuto = function ImageWbAuto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z' })
	  );
	};
	ImageWbAuto = (0, _pure2.default)(ImageWbAuto);
	ImageWbAuto.displayName = 'ImageWbAuto';
	ImageWbAuto.muiName = 'SvgIcon';
	
	exports.default = ImageWbAuto;

/***/ },
/* 2486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbCloudy = function ImageWbCloudy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z' })
	  );
	};
	ImageWbCloudy = (0, _pure2.default)(ImageWbCloudy);
	ImageWbCloudy.displayName = 'ImageWbCloudy';
	ImageWbCloudy.muiName = 'SvgIcon';
	
	exports.default = ImageWbCloudy;

/***/ },
/* 2487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbIncandescent = function ImageWbIncandescent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z' })
	  );
	};
	ImageWbIncandescent = (0, _pure2.default)(ImageWbIncandescent);
	ImageWbIncandescent.displayName = 'ImageWbIncandescent';
	ImageWbIncandescent.muiName = 'SvgIcon';
	
	exports.default = ImageWbIncandescent;

/***/ },
/* 2488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbIridescent = function ImageWbIridescent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z' })
	  );
	};
	ImageWbIridescent = (0, _pure2.default)(ImageWbIridescent);
	ImageWbIridescent.displayName = 'ImageWbIridescent';
	ImageWbIridescent.muiName = 'SvgIcon';
	
	exports.default = ImageWbIridescent;

/***/ },
/* 2489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbSunny = function ImageWbSunny(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z' })
	  );
	};
	ImageWbSunny = (0, _pure2.default)(ImageWbSunny);
	ImageWbSunny.displayName = 'ImageWbSunny';
	ImageWbSunny.muiName = 'SvgIcon';
	
	exports.default = ImageWbSunny;

/***/ },
/* 2490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleStar = exports.ToggleStarHalf = exports.ToggleStarBorder = exports.ToggleRadioButtonUnchecked = exports.ToggleRadioButtonChecked = exports.ToggleIndeterminateCheckBox = exports.ToggleCheckBox = exports.ToggleCheckBoxOutlineBlank = exports.SocialWhatshot = exports.SocialShare = exports.SocialSentimentVerySatisfied = exports.SocialSentimentVeryDissatisfied = exports.SocialSentimentSatisfied = exports.SocialSentimentNeutral = exports.SocialSentimentDissatisfied = exports.SocialSchool = exports.SocialPublic = exports.SocialPoll = exports.SocialPlusOne = exports.SocialPerson = exports.SocialPersonOutline = exports.SocialPersonAdd = exports.SocialPeople = exports.SocialPeopleOutline = exports.SocialPartyMode = exports.SocialPages = exports.SocialNotifications = exports.SocialNotificationsPaused = exports.SocialNotificationsOff = exports.SocialNotificationsNone = exports.SocialNotificationsActive = exports.SocialMood = exports.SocialMoodBad = exports.SocialLocationCity = exports.SocialGroup = exports.SocialGroupAdd = exports.SocialDomain = exports.SocialCake = exports.PlacesSpa = exports.PlacesSmokingRooms = exports.PlacesSmokeFree = exports.PlacesRvHookup = exports.PlacesRoomService = exports.PlacesPool = exports.PlacesKitchen = exports.PlacesHotTub = exports.PlacesGolfCourse = exports.PlacesFreeBreakfast = exports.PlacesFitnessCenter = exports.PlacesChildFriendly = exports.PlacesChildCare = exports.PlacesCasino = exports.PlacesBusinessCenter = exports.PlacesBeachAccess = exports.PlacesAllInclusive = exports.PlacesAirportShuttle = exports.PlacesAcUnit = exports.NotificationWifi = exports.NotificationWc = exports.NotificationVpnLock = exports.NotificationVoiceChat = undefined;
	exports.NotificationVibration = exports.NotificationTimeToLeave = exports.NotificationTapAndPlay = exports.NotificationSystemUpdate = exports.NotificationSync = exports.NotificationSyncProblem = exports.NotificationSyncDisabled = exports.NotificationSms = exports.NotificationSmsFailed = exports.NotificationSimCardAlert = exports.NotificationSdCard = exports.NotificationRvHookup = exports.NotificationPriorityHigh = exports.NotificationPower = exports.NotificationPhonePaused = exports.NotificationPhoneMissed = exports.NotificationPhoneLocked = exports.NotificationPhoneInTalk = exports.NotificationPhoneForwarded = exports.NotificationPhoneBluetoothSpeaker = exports.NotificationPersonalVideo = exports.NotificationOndemandVideo = exports.NotificationNoEncryption = exports.NotificationNetworkLocked = exports.NotificationNetworkCheck = exports.NotificationMore = exports.NotificationMms = exports.NotificationLiveTv = exports.NotificationFolderSpecial = exports.NotificationEventNote = exports.NotificationEventBusy = exports.NotificationEventAvailable = exports.NotificationEnhancedEncryption = exports.NotificationDriveEta = exports.NotificationDoNotDisturb = exports.NotificationDoNotDisturbOn = exports.NotificationDoNotDisturbOff = exports.NotificationDoNotDisturbAlt = exports.NotificationDiscFull = exports.NotificationConfirmationNumber = exports.NotificationBluetoothAudio = exports.NotificationAirlineSeatReclineNormal = exports.NotificationAirlineSeatReclineExtra = exports.NotificationAirlineSeatLegroomReduced = exports.NotificationAirlineSeatLegroomNormal = exports.NotificationAirlineSeatLegroomExtra = exports.NotificationAirlineSeatIndividualSuite = exports.NotificationAirlineSeatFlat = exports.NotificationAirlineSeatFlatAngled = exports.NotificationAdb = exports.NavigationArrowDropRight = exports.NavigationUnfoldMore = exports.NavigationUnfoldLess = exports.NavigationSubdirectoryArrowRight = exports.NavigationSubdirectoryArrowLeft = exports.NavigationRefresh = exports.NavigationMoreVert = exports.NavigationMoreHoriz = exports.NavigationMenu = exports.NavigationLastPage = exports.NavigationFullscreen = exports.NavigationFullscreenExit = exports.NavigationFirstPage = exports.NavigationExpandMore = exports.NavigationExpandLess = exports.NavigationClose = exports.NavigationChevronRight = exports.NavigationChevronLeft = exports.NavigationCheck = exports.NavigationCancel = exports.NavigationArrowUpward = exports.NavigationArrowForward = exports.NavigationArrowDropUp = exports.NavigationArrowDropDown = exports.NavigationArrowDropDownCircle = exports.NavigationArrowDownward = exports.NavigationArrowBack = exports.NavigationApps = exports.MapsZoomOutMap = exports.MapsTransferWithinAStation = exports.MapsTram = exports.MapsTrain = exports.MapsTraffic = exports.MapsTerrain = exports.MapsSubway = exports.MapsStreetview = exports.MapsStoreMallDirectory = exports.MapsSatellite = exports.MapsRestaurant = exports.MapsRestaurantMenu = exports.MapsRateReview = exports.MapsPlace = exports.MapsPinDrop = exports.MapsPersonPin = exports.MapsPersonPinCircle = exports.MapsNearMe = exports.MapsNavigation = exports.MapsMyLocation = exports.MapsMap = exports.MapsLocalTaxi = undefined;
	exports.MapsLocalShipping = exports.MapsLocalSee = exports.MapsLocalPrintshop = exports.MapsLocalPostOffice = exports.MapsLocalPlay = exports.MapsLocalPizza = exports.MapsLocalPhone = exports.MapsLocalPharmacy = exports.MapsLocalParking = exports.MapsLocalOffer = exports.MapsLocalMovies = exports.MapsLocalMall = exports.MapsLocalLibrary = exports.MapsLocalLaundryService = exports.MapsLocalHotel = exports.MapsLocalHospital = exports.MapsLocalGroceryStore = exports.MapsLocalGasStation = exports.MapsLocalFlorist = exports.MapsLocalDrink = exports.MapsLocalDining = exports.MapsLocalConvenienceStore = exports.MapsLocalCarWash = exports.MapsLocalCafe = exports.MapsLocalBar = exports.MapsLocalAtm = exports.MapsLocalAirport = exports.MapsLocalActivity = exports.MapsLayers = exports.MapsLayersClear = exports.MapsHotel = exports.MapsFlight = exports.MapsEvStation = exports.MapsEditLocation = exports.MapsDirections = exports.MapsDirectionsWalk = exports.MapsDirectionsTransit = exports.MapsDirectionsSubway = exports.MapsDirectionsRun = exports.MapsDirectionsRailway = exports.MapsDirectionsCar = exports.MapsDirectionsBus = exports.MapsDirectionsBoat = exports.MapsDirectionsBike = exports.MapsBeenhere = exports.MapsAddLocation = exports.ImageWbSunny = exports.ImageWbIridescent = exports.ImageWbIncandescent = exports.ImageWbCloudy = exports.ImageWbAuto = exports.ImageVignette = exports.ImageViewCompact = exports.ImageViewComfy = exports.ImageTune = exports.ImageTransform = exports.ImageTonality = exports.ImageTimer = exports.ImageTimerOff = exports.ImageTimer3 = exports.ImageTimer10 = exports.ImageTimelapse = exports.ImageTexture = exports.ImageTagFaces = exports.ImageSwitchVideo = exports.ImageSwitchCamera = exports.ImageStyle = exports.ImageStraighten = exports.ImageSlideshow = exports.ImageRotateRight = exports.ImageRotateLeft = exports.ImageRotate90DegreesCcw = exports.ImageRemoveRedEye = exports.ImagePortrait = exports.ImagePictureAsPdf = exports.ImagePhoto = exports.ImagePhotoSizeSelectSmall = exports.ImagePhotoSizeSelectLarge = exports.ImagePhotoSizeSelectActual = exports.ImagePhotoLibrary = exports.ImagePhotoFilter = exports.ImagePhotoCamera = exports.ImagePhotoAlbum = exports.ImagePanorama = exports.ImagePanoramaWideAngle = exports.ImagePanoramaVertical = exports.ImagePanoramaHorizontal = exports.ImagePanoramaFishEye = exports.ImagePalette = exports.ImageNavigateNext = exports.ImageNavigateBefore = exports.ImageNature = exports.ImageNaturePeople = exports.ImageMusicNote = exports.ImageMovieFilter = exports.ImageMovieCreation = exports.ImageMonochromePhotos = exports.ImageLoupe = exports.ImageLooks = exports.ImageLooksTwo = undefined;
	exports.ImageLooksOne = exports.ImageLooks6 = exports.ImageLooks5 = exports.ImageLooks4 = exports.ImageLooks3 = exports.ImageLinkedCamera = exports.ImageLens = exports.ImageLeakRemove = exports.ImageLeakAdd = exports.ImageLandscape = exports.ImageIso = exports.ImageImage = exports.ImageImageAspectRatio = exports.ImageHealing = exports.ImageHdrWeak = exports.ImageHdrStrong = exports.ImageHdrOn = exports.ImageHdrOff = exports.ImageGridOn = exports.ImageGridOff = exports.ImageGrain = exports.ImageGradient = exports.ImageFlip = exports.ImageFlashOn = exports.ImageFlashOff = exports.ImageFlashAuto = exports.ImageFlare = exports.ImageFilter = exports.ImageFilterVintage = exports.ImageFilterTiltShift = exports.ImageFilterNone = exports.ImageFilterHdr = exports.ImageFilterFrames = exports.ImageFilterDrama = exports.ImageFilterCenterFocus = exports.ImageFilterBAndW = exports.ImageFilter9 = exports.ImageFilter9Plus = exports.ImageFilter8 = exports.ImageFilter7 = exports.ImageFilter6 = exports.ImageFilter5 = exports.ImageFilter4 = exports.ImageFilter3 = exports.ImageFilter2 = exports.ImageFilter1 = exports.ImageExposure = exports.ImageExposureZero = exports.ImageExposurePlus2 = exports.ImageExposurePlus1 = exports.ImageExposureNeg2 = exports.ImageExposureNeg1 = exports.ImageEdit = exports.ImageDetails = exports.ImageDehaze = exports.ImageCrop = exports.ImageCropSquare = exports.ImageCropRotate = exports.ImageCropPortrait = exports.ImageCropOriginal = exports.ImageCropLandscape = exports.ImageCropFree = exports.ImageCropDin = exports.ImageCrop75 = exports.ImageCrop54 = exports.ImageCrop32 = exports.ImageCrop169 = exports.ImageControlPoint = exports.ImageControlPointDuplicate = exports.ImageCompare = exports.ImageColorize = exports.ImageColorLens = exports.ImageCollections = exports.ImageCollectionsBookmark = exports.ImageCenterFocusWeak = exports.ImageCenterFocusStrong = exports.ImageCamera = exports.ImageCameraRoll = exports.ImageCameraRear = exports.ImageCameraFront = exports.ImageCameraAlt = exports.ImageBurstMode = exports.ImageBrush = exports.ImageBrokenImage = exports.ImageBrightness7 = exports.ImageBrightness6 = exports.ImageBrightness5 = exports.ImageBrightness4 = exports.ImageBrightness3 = exports.ImageBrightness2 = exports.ImageBrightness1 = exports.ImageBlurOn = exports.ImageBlurOff = exports.ImageBlurLinear = exports.ImageBlurCircular = exports.ImageAudiotrack = exports.ImageAssistant = exports.ImageAssistantPhoto = exports.ImageAdjust = exports.ImageAddToPhotos = undefined;
	exports.ImageAddAPhoto = exports.HardwareWatch = exports.HardwareVideogameAsset = exports.HardwareTv = exports.HardwareToys = exports.HardwareTablet = exports.HardwareTabletMac = exports.HardwareTabletAndroid = exports.HardwareSpeaker = exports.HardwareSpeakerGroup = exports.HardwareSmartphone = exports.HardwareSimCard = exports.HardwareSecurity = exports.HardwareScanner = exports.HardwareRouter = exports.HardwarePowerInput = exports.HardwarePhonelink = exports.HardwarePhonelinkOff = exports.HardwarePhoneIphone = exports.HardwarePhoneAndroid = exports.HardwareMouse = exports.HardwareMemory = exports.HardwareLaptop = exports.HardwareLaptopWindows = exports.HardwareLaptopMac = exports.HardwareLaptopChromebook = exports.HardwareKeyboard = exports.HardwareKeyboardVoice = exports.HardwareKeyboardTab = exports.HardwareKeyboardReturn = exports.HardwareKeyboardHide = exports.HardwareKeyboardCapslock = exports.HardwareKeyboardBackspace = exports.HardwareKeyboardArrowUp = exports.HardwareKeyboardArrowRight = exports.HardwareKeyboardArrowLeft = exports.HardwareKeyboardArrowDown = exports.HardwareHeadset = exports.HardwareHeadsetMic = exports.HardwareGamepad = exports.HardwareDock = exports.HardwareDevicesOther = exports.HardwareDeviceHub = exports.HardwareDeveloperBoard = exports.HardwareDesktopWindows = exports.HardwareDesktopMac = exports.HardwareComputer = exports.HardwareCast = exports.HardwareCastConnected = exports.FileFolder = exports.FileFolderShared = exports.FileFolderOpen = exports.FileFileUpload = exports.FileFileDownload = exports.FileCreateNewFolder = exports.FileCloud = exports.FileCloudUpload = exports.FileCloudQueue = exports.FileCloudOff = exports.FileCloudDownload = exports.FileCloudDone = exports.FileCloudCircle = exports.FileAttachment = exports.EditorWrapText = exports.EditorVerticalAlignTop = exports.EditorVerticalAlignCenter = exports.EditorVerticalAlignBottom = exports.EditorTitle = exports.EditorTextFields = exports.EditorStrikethroughS = exports.EditorSpaceBar = exports.EditorShowChart = exports.EditorShortText = exports.EditorPublish = exports.EditorPieChart = exports.EditorPieChartOutlined = exports.EditorMultilineChart = exports.EditorMoneyOff = exports.EditorMonetizationOn = exports.EditorModeEdit = exports.EditorModeComment = exports.EditorMergeType = exports.EditorLinearScale = exports.EditorInsertPhoto = exports.EditorInsertLink = exports.EditorInsertInvitation = exports.EditorInsertEmoticon = exports.EditorInsertDriveFile = exports.EditorInsertComment = exports.EditorInsertChart = exports.EditorHighlight = exports.EditorFunctions = exports.EditorFormatUnderlined = exports.EditorFormatTextdirectionRToL = exports.EditorFormatTextdirectionLToR = exports.EditorFormatStrikethrough = exports.EditorFormatSize = exports.EditorFormatShapes = exports.EditorFormatQuote = exports.EditorFormatPaint = undefined;
	exports.EditorFormatListNumbered = exports.EditorFormatListBulleted = exports.EditorFormatLineSpacing = exports.EditorFormatItalic = exports.EditorFormatIndentIncrease = exports.EditorFormatIndentDecrease = exports.EditorFormatColorText = exports.EditorFormatColorReset = exports.EditorFormatColorFill = exports.EditorFormatClear = exports.EditorFormatBold = exports.EditorFormatAlignRight = exports.EditorFormatAlignLeft = exports.EditorFormatAlignJustify = exports.EditorFormatAlignCenter = exports.EditorDragHandle = exports.EditorBubbleChart = exports.EditorBorderVertical = exports.EditorBorderTop = exports.EditorBorderStyle = exports.EditorBorderRight = exports.EditorBorderOuter = exports.EditorBorderLeft = exports.EditorBorderInner = exports.EditorBorderHorizontal = exports.EditorBorderColor = exports.EditorBorderClear = exports.EditorBorderBottom = exports.EditorBorderAll = exports.EditorAttachMoney = exports.EditorAttachFile = exports.DeviceWifiTethering = exports.DeviceWifiLock = exports.DeviceWidgets = exports.DeviceWallpaper = exports.DeviceUsb = exports.DeviceStorage = exports.DeviceSignalWifiOff = exports.DeviceSignalWifi4Bar = exports.DeviceSignalWifi4BarLock = exports.DeviceSignalWifi3Bar = exports.DeviceSignalWifi3BarLock = exports.DeviceSignalWifi2Bar = exports.DeviceSignalWifi2BarLock = exports.DeviceSignalWifi1Bar = exports.DeviceSignalWifi1BarLock = exports.DeviceSignalWifi0Bar = exports.DeviceSignalCellularOff = exports.DeviceSignalCellularNull = exports.DeviceSignalCellularNoSim = exports.DeviceSignalCellularConnectedNoInternet4Bar = exports.DeviceSignalCellularConnectedNoInternet3Bar = exports.DeviceSignalCellularConnectedNoInternet2Bar = exports.DeviceSignalCellularConnectedNoInternet1Bar = exports.DeviceSignalCellularConnectedNoInternet0Bar = exports.DeviceSignalCellular4Bar = exports.DeviceSignalCellular3Bar = exports.DeviceSignalCellular2Bar = exports.DeviceSignalCellular1Bar = exports.DeviceSignalCellular0Bar = exports.DeviceSettingsSystemDaydream = exports.DeviceSdStorage = exports.DeviceScreenRotation = exports.DeviceScreenLockRotation = exports.DeviceScreenLockPortrait = exports.DeviceScreenLockLandscape = exports.DeviceNfc = exports.DeviceNetworkWifi = exports.DeviceNetworkCell = exports.DeviceLocationSearching = exports.DeviceLocationDisabled = exports.DeviceGraphicEq = exports.DeviceGpsOff = exports.DeviceGpsNotFixed = exports.DeviceGpsFixed = exports.DeviceDvr = exports.DeviceDevices = exports.DeviceDeveloperMode = exports.DeviceDataUsage = exports.DeviceBrightnessMedium = exports.DeviceBrightnessLow = exports.DeviceBrightnessHigh = exports.DeviceBrightnessAuto = exports.DeviceBluetooth = exports.DeviceBluetoothSearching = exports.DeviceBluetoothDisabled = exports.DeviceBluetoothConnected = exports.DeviceBatteryUnknown = exports.DeviceBatteryStd = exports.DeviceBatteryFull = exports.DeviceBatteryChargingFull = exports.DeviceBatteryCharging90 = exports.DeviceBatteryCharging80 = exports.DeviceBatteryCharging60 = exports.DeviceBatteryCharging50 = exports.DeviceBatteryCharging30 = exports.DeviceBatteryCharging20 = exports.DeviceBatteryAlert = exports.DeviceBattery90 = exports.DeviceBattery80 = undefined;
	exports.DeviceBattery60 = exports.DeviceBattery50 = exports.DeviceBattery30 = exports.DeviceBattery20 = exports.DeviceAirplanemodeInactive = exports.DeviceAirplanemodeActive = exports.DeviceAddAlarm = exports.DeviceAccessTime = exports.DeviceAccessAlarms = exports.DeviceAccessAlarm = exports.ContentWeekend = exports.ContentUndo = exports.ContentUnarchive = exports.ContentTextFormat = exports.ContentSort = exports.ContentSend = exports.ContentSelectAll = exports.ContentSave = exports.ContentReport = exports.ContentReply = exports.ContentReplyAll = exports.ContentRemove = exports.ContentRemoveCircle = exports.ContentRemoveCircleOutline = exports.ContentRedo = exports.ContentNextWeek = exports.ContentMoveToInbox = exports.ContentMarkunread = exports.ContentMail = exports.ContentLowPriority = exports.ContentLink = exports.ContentInbox = exports.ContentGesture = exports.ContentForward = exports.ContentFontDownload = exports.ContentFlag = exports.ContentFilterList = exports.ContentDrafts = exports.ContentDeleteSweep = exports.ContentCreate = exports.ContentContentPaste = exports.ContentContentCut = exports.ContentContentCopy = exports.ContentClear = exports.ContentBlock = exports.ContentBackspace = exports.ContentArchive = exports.ContentAdd = exports.ContentAddCircle = exports.ContentAddCircleOutline = exports.ContentAddBox = exports.CommunicationVpnKey = exports.CommunicationVoicemail = exports.CommunicationTextsms = exports.CommunicationSwapCalls = exports.CommunicationStopScreenShare = exports.CommunicationStayPrimaryPortrait = exports.CommunicationStayPrimaryLandscape = exports.CommunicationStayCurrentPortrait = exports.CommunicationStayCurrentLandscape = exports.CommunicationSpeakerPhone = exports.CommunicationScreenShare = exports.CommunicationRssFeed = exports.CommunicationRingVolume = exports.CommunicationPresentToAll = exports.CommunicationPortableWifiOff = exports.CommunicationPhonelinkSetup = exports.CommunicationPhonelinkRing = exports.CommunicationPhonelinkLock = exports.CommunicationPhonelinkErase = exports.CommunicationPhone = exports.CommunicationNoSim = exports.CommunicationMessage = exports.CommunicationMailOutline = exports.CommunicationLocationOn = exports.CommunicationLocationOff = exports.CommunicationLiveHelp = exports.CommunicationInvertColorsOff = exports.CommunicationImportExport = exports.CommunicationImportContacts = exports.CommunicationForum = exports.CommunicationEmail = exports.CommunicationDialpad = exports.CommunicationDialerSip = exports.CommunicationContacts = exports.CommunicationContactPhone = exports.CommunicationContactMail = exports.CommunicationComment = exports.CommunicationClearAll = exports.CommunicationChat = exports.CommunicationChatBubble = exports.CommunicationChatBubbleOutline = exports.CommunicationCall = exports.CommunicationCallSplit = exports.CommunicationCallReceived = exports.CommunicationCallMissed = exports.CommunicationCallMissedOutgoing = exports.CommunicationCallMerge = exports.CommunicationCallMade = exports.CommunicationCallEnd = undefined;
	exports.CommunicationBusiness = exports.AvWeb = exports.AvWebAsset = exports.AvVolumeUp = exports.AvVolumeOff = exports.AvVolumeMute = exports.AvVolumeDown = exports.AvVideocam = exports.AvVideocamOff = exports.AvVideoLibrary = exports.AvVideoLabel = exports.AvVideoCall = exports.AvSurroundSound = exports.AvSubtitles = exports.AvSubscriptions = exports.AvStop = exports.AvSortByAlpha = exports.AvSnooze = exports.AvSlowMotionVideo = exports.AvSkipPrevious = exports.AvSkipNext = exports.AvShuffle = exports.AvReplay = exports.AvReplay5 = exports.AvReplay30 = exports.AvReplay10 = exports.AvRepeat = exports.AvRepeatOne = exports.AvRemoveFromQueue = exports.AvRecentActors = exports.AvRadio = exports.AvQueue = exports.AvQueuePlayNext = exports.AvQueueMusic = exports.AvPlaylistPlay = exports.AvPlaylistAdd = exports.AvPlaylistAddCheck = exports.AvPlayCircleOutline = exports.AvPlayCircleFilled = exports.AvPlayArrow = exports.AvPause = exports.AvPauseCircleOutline = exports.AvPauseCircleFilled = exports.AvNote = exports.AvNotInterested = exports.AvNewReleases = exports.AvMusicVideo = exports.AvMovie = exports.AvMic = exports.AvMicOff = exports.AvMicNone = exports.AvLoop = exports.AvLibraryMusic = exports.AvLibraryBooks = exports.AvLibraryAdd = exports.AvHighQuality = exports.AvHearing = exports.AvHd = exports.AvGames = exports.AvForward5 = exports.AvForward30 = exports.AvForward10 = exports.AvFiberSmartRecord = exports.AvFiberPin = exports.AvFiberNew = exports.AvFiberManualRecord = exports.AvFiberDvr = exports.AvFeaturedVideo = exports.AvFeaturedPlayList = exports.AvFastRewind = exports.AvFastForward = exports.AvExplicit = exports.AvEqualizer = exports.AvClosedCaption = exports.AvCallToAction = exports.AvBrandingWatermark = exports.AvAvTimer = exports.AvArtTrack = exports.AvAlbum = exports.AvAirplay = exports.AvAddToQueue = exports.AlertWarning = exports.AlertError = exports.AlertErrorOutline = exports.AlertAddAlert = exports.ActionZoomOut = exports.ActionZoomIn = exports.ActionYoutubeSearchedFor = exports.ActionWork = exports.ActionWatchLater = exports.ActionVisibility = exports.ActionVisibilityOff = exports.ActionViewWeek = exports.ActionViewStream = exports.ActionViewQuilt = exports.ActionViewModule = exports.ActionViewList = exports.ActionViewHeadline = exports.ActionViewDay = exports.ActionViewColumn = undefined;
	exports.ActionViewCarousel = exports.ActionViewArray = exports.ActionViewAgenda = exports.ActionVerifiedUser = exports.ActionUpdate = exports.ActionTurnedIn = exports.ActionTurnedInNot = exports.ActionTrendingUp = exports.ActionTrendingFlat = exports.ActionTrendingDown = exports.ActionTranslate = exports.ActionTrackChanges = exports.ActionTouchApp = exports.ActionToll = exports.ActionToday = exports.ActionToc = exports.ActionTimeline = exports.ActionThumbsUpDown = exports.ActionThumbUp = exports.ActionThumbDown = exports.ActionThreeDRotation = exports.ActionTheaters = exports.ActionTab = exports.ActionTabUnselected = exports.ActionSystemUpdateAlt = exports.ActionSwapVerticalCircle = exports.ActionSwapVert = exports.ActionSwapHoriz = exports.ActionSupervisorAccount = exports.ActionSubject = exports.ActionStore = exports.ActionStars = exports.ActionSpellcheck = exports.ActionSpeakerNotes = exports.ActionSpeakerNotesOff = exports.ActionShoppingCart = exports.ActionShoppingBasket = exports.ActionShop = exports.ActionShopTwo = exports.ActionSettings = exports.ActionSettingsVoice = exports.ActionSettingsRemote = exports.ActionSettingsPower = exports.ActionSettingsPhone = exports.ActionSettingsOverscan = exports.ActionSettingsInputSvideo = exports.ActionSettingsInputHdmi = exports.ActionSettingsInputComposite = exports.ActionSettingsInputComponent = exports.ActionSettingsInputAntenna = exports.ActionSettingsEthernet = exports.ActionSettingsCell = exports.ActionSettingsBrightness = exports.ActionSettingsBluetooth = exports.ActionSettingsBackupRestore = exports.ActionSettingsApplications = exports.ActionSearch = exports.ActionSchedule = exports.ActionRowing = exports.ActionRoundedCorner = exports.ActionRoom = exports.ActionRestore = exports.ActionRestorePage = exports.ActionReportProblem = exports.ActionReorder = exports.ActionRemoveShoppingCart = exports.ActionRedeem = exports.ActionRecordVoiceOver = exports.ActionReceipt = exports.ActionQuestionAnswer = exports.ActionQueryBuilder = exports.ActionPrint = exports.ActionPregnantWoman = exports.ActionPowerSettingsNew = exports.ActionPolymer = exports.ActionPlayForWork = exports.ActionPictureInPicture = exports.ActionPictureInPictureAlt = exports.ActionPets = exports.ActionPermScanWifi = exports.ActionPermPhoneMsg = exports.ActionPermMedia = exports.ActionPermIdentity = exports.ActionPermDeviceInformation = exports.ActionPermDataSetting = exports.ActionPermContactCalendar = exports.ActionPermCameraMic = exports.ActionPayment = exports.ActionPanTool = exports.ActionPageview = exports.ActionOpenWith = exports.ActionOpenInNew = exports.ActionOpenInBrowser = exports.ActionOpacity = exports.ActionOfflinePin = exports.ActionNoteAdd = exports.ActionMotorcycle = exports.ActionMarkunreadMailbox = exports.ActionLoyalty = exports.ActionLock = undefined;
	exports.ActionLockOutline = exports.ActionLockOpen = exports.ActionList = exports.ActionLineWeight = exports.ActionLineStyle = exports.ActionLightbulbOutline = exports.ActionLaunch = exports.ActionLanguage = exports.ActionLabel = exports.ActionLabelOutline = exports.ActionInvertColors = exports.ActionInput = exports.ActionInfo = exports.ActionInfoOutline = exports.ActionImportantDevices = exports.ActionHttps = exports.ActionHttp = exports.ActionHourglassFull = exports.ActionHourglassEmpty = exports.ActionHome = exports.ActionHistory = exports.ActionHighlightOff = exports.ActionHelp = exports.ActionHelpOutline = exports.ActionGroupWork = exports.ActionGrade = exports.ActionGif = exports.ActionGetApp = exports.ActionGavel = exports.ActionGTranslate = exports.ActionFlipToFront = exports.ActionFlipToBack = exports.ActionFlightTakeoff = exports.ActionFlightLand = exports.ActionFingerprint = exports.ActionFindReplace = exports.ActionFindInPage = exports.ActionFeedback = exports.ActionFavorite = exports.ActionFavoriteBorder = exports.ActionFace = exports.ActionExtension = exports.ActionExplore = exports.ActionExitToApp = exports.ActionEvent = exports.ActionEventSeat = exports.ActionEuroSymbol = exports.ActionEject = exports.ActionDonutSmall = exports.ActionDonutLarge = exports.ActionDone = exports.ActionDoneAll = exports.ActionDns = exports.ActionDescription = exports.ActionDelete = exports.ActionDeleteForever = exports.ActionDateRange = exports.ActionDashboard = exports.ActionCreditCard = exports.ActionCopyright = exports.ActionCompareArrows = exports.ActionCode = exports.ActionClass = exports.ActionChromeReaderMode = exports.ActionCheckCircle = exports.ActionChangeHistory = exports.ActionCardTravel = exports.ActionCardMembership = exports.ActionCardGiftcard = exports.ActionCameraEnhance = exports.ActionCached = exports.ActionBuild = exports.ActionBugReport = exports.ActionBookmark = exports.ActionBookmarkBorder = exports.ActionBook = exports.ActionBackup = exports.ActionAutorenew = exports.ActionAssignment = exports.ActionAssignmentTurnedIn = exports.ActionAssignmentReturned = exports.ActionAssignmentReturn = exports.ActionAssignmentLate = exports.ActionAssignmentInd = exports.ActionAssessment = exports.ActionAspectRatio = exports.ActionAnnouncement = exports.ActionAndroid = exports.ActionAllOut = exports.ActionAlarm = exports.ActionAlarmOn = exports.ActionAlarmOff = exports.ActionAlarmAdd = exports.ActionAddShoppingCart = exports.ActionAccountCircle = exports.ActionAccountBox = exports.ActionAccountBalance = exports.ActionAccountBalanceWallet = exports.ActionAccessible = exports.ActionAccessibility = undefined;
	
	var _accessibility = __webpack_require__(1752);
	
	var _accessibility2 = _interopRequireDefault(_accessibility);
	
	var _accessible = __webpack_require__(1753);
	
	var _accessible2 = _interopRequireDefault(_accessible);
	
	var _accountBalanceWallet = __webpack_require__(1754);
	
	var _accountBalanceWallet2 = _interopRequireDefault(_accountBalanceWallet);
	
	var _accountBalance = __webpack_require__(1755);
	
	var _accountBalance2 = _interopRequireDefault(_accountBalance);
	
	var _accountBox = __webpack_require__(1756);
	
	var _accountBox2 = _interopRequireDefault(_accountBox);
	
	var _accountCircle = __webpack_require__(1757);
	
	var _accountCircle2 = _interopRequireDefault(_accountCircle);
	
	var _addShoppingCart = __webpack_require__(1758);
	
	var _addShoppingCart2 = _interopRequireDefault(_addShoppingCart);
	
	var _alarmAdd = __webpack_require__(1759);
	
	var _alarmAdd2 = _interopRequireDefault(_alarmAdd);
	
	var _alarmOff = __webpack_require__(1760);
	
	var _alarmOff2 = _interopRequireDefault(_alarmOff);
	
	var _alarmOn = __webpack_require__(1761);
	
	var _alarmOn2 = _interopRequireDefault(_alarmOn);
	
	var _alarm = __webpack_require__(1762);
	
	var _alarm2 = _interopRequireDefault(_alarm);
	
	var _allOut = __webpack_require__(1763);
	
	var _allOut2 = _interopRequireDefault(_allOut);
	
	var _android = __webpack_require__(1764);
	
	var _android2 = _interopRequireDefault(_android);
	
	var _announcement = __webpack_require__(1765);
	
	var _announcement2 = _interopRequireDefault(_announcement);
	
	var _aspectRatio = __webpack_require__(1766);
	
	var _aspectRatio2 = _interopRequireDefault(_aspectRatio);
	
	var _assessment = __webpack_require__(1767);
	
	var _assessment2 = _interopRequireDefault(_assessment);
	
	var _assignmentInd = __webpack_require__(1768);
	
	var _assignmentInd2 = _interopRequireDefault(_assignmentInd);
	
	var _assignmentLate = __webpack_require__(1769);
	
	var _assignmentLate2 = _interopRequireDefault(_assignmentLate);
	
	var _assignmentReturn = __webpack_require__(1770);
	
	var _assignmentReturn2 = _interopRequireDefault(_assignmentReturn);
	
	var _assignmentReturned = __webpack_require__(1771);
	
	var _assignmentReturned2 = _interopRequireDefault(_assignmentReturned);
	
	var _assignmentTurnedIn = __webpack_require__(1772);
	
	var _assignmentTurnedIn2 = _interopRequireDefault(_assignmentTurnedIn);
	
	var _assignment = __webpack_require__(1773);
	
	var _assignment2 = _interopRequireDefault(_assignment);
	
	var _autorenew = __webpack_require__(1774);
	
	var _autorenew2 = _interopRequireDefault(_autorenew);
	
	var _backup = __webpack_require__(1775);
	
	var _backup2 = _interopRequireDefault(_backup);
	
	var _book = __webpack_require__(1776);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _bookmarkBorder = __webpack_require__(1777);
	
	var _bookmarkBorder2 = _interopRequireDefault(_bookmarkBorder);
	
	var _bookmark = __webpack_require__(1778);
	
	var _bookmark2 = _interopRequireDefault(_bookmark);
	
	var _bugReport = __webpack_require__(1779);
	
	var _bugReport2 = _interopRequireDefault(_bugReport);
	
	var _build = __webpack_require__(1780);
	
	var _build2 = _interopRequireDefault(_build);
	
	var _cached = __webpack_require__(1781);
	
	var _cached2 = _interopRequireDefault(_cached);
	
	var _cameraEnhance = __webpack_require__(1782);
	
	var _cameraEnhance2 = _interopRequireDefault(_cameraEnhance);
	
	var _cardGiftcard = __webpack_require__(1783);
	
	var _cardGiftcard2 = _interopRequireDefault(_cardGiftcard);
	
	var _cardMembership = __webpack_require__(1784);
	
	var _cardMembership2 = _interopRequireDefault(_cardMembership);
	
	var _cardTravel = __webpack_require__(1785);
	
	var _cardTravel2 = _interopRequireDefault(_cardTravel);
	
	var _changeHistory = __webpack_require__(1786);
	
	var _changeHistory2 = _interopRequireDefault(_changeHistory);
	
	var _checkCircle = __webpack_require__(432);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _chromeReaderMode = __webpack_require__(1787);
	
	var _chromeReaderMode2 = _interopRequireDefault(_chromeReaderMode);
	
	var _class = __webpack_require__(1788);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _code = __webpack_require__(1789);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _compareArrows = __webpack_require__(1790);
	
	var _compareArrows2 = _interopRequireDefault(_compareArrows);
	
	var _copyright = __webpack_require__(1791);
	
	var _copyright2 = _interopRequireDefault(_copyright);
	
	var _creditCard = __webpack_require__(1792);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _dashboard = __webpack_require__(1793);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dateRange = __webpack_require__(1794);
	
	var _dateRange2 = _interopRequireDefault(_dateRange);
	
	var _deleteForever = __webpack_require__(1795);
	
	var _deleteForever2 = _interopRequireDefault(_deleteForever);
	
	var _delete = __webpack_require__(1796);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _description = __webpack_require__(1797);
	
	var _description2 = _interopRequireDefault(_description);
	
	var _dns = __webpack_require__(1798);
	
	var _dns2 = _interopRequireDefault(_dns);
	
	var _doneAll = __webpack_require__(1799);
	
	var _doneAll2 = _interopRequireDefault(_doneAll);
	
	var _done = __webpack_require__(307);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _donutLarge = __webpack_require__(1800);
	
	var _donutLarge2 = _interopRequireDefault(_donutLarge);
	
	var _donutSmall = __webpack_require__(1801);
	
	var _donutSmall2 = _interopRequireDefault(_donutSmall);
	
	var _eject = __webpack_require__(1802);
	
	var _eject2 = _interopRequireDefault(_eject);
	
	var _euroSymbol = __webpack_require__(1803);
	
	var _euroSymbol2 = _interopRequireDefault(_euroSymbol);
	
	var _eventSeat = __webpack_require__(1804);
	
	var _eventSeat2 = _interopRequireDefault(_eventSeat);
	
	var _event = __webpack_require__(1805);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _exitToApp = __webpack_require__(1806);
	
	var _exitToApp2 = _interopRequireDefault(_exitToApp);
	
	var _explore = __webpack_require__(1807);
	
	var _explore2 = _interopRequireDefault(_explore);
	
	var _extension = __webpack_require__(1808);
	
	var _extension2 = _interopRequireDefault(_extension);
	
	var _face = __webpack_require__(1809);
	
	var _face2 = _interopRequireDefault(_face);
	
	var _favoriteBorder = __webpack_require__(1810);
	
	var _favoriteBorder2 = _interopRequireDefault(_favoriteBorder);
	
	var _favorite = __webpack_require__(1811);
	
	var _favorite2 = _interopRequireDefault(_favorite);
	
	var _feedback = __webpack_require__(1812);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _findInPage = __webpack_require__(1813);
	
	var _findInPage2 = _interopRequireDefault(_findInPage);
	
	var _findReplace = __webpack_require__(1814);
	
	var _findReplace2 = _interopRequireDefault(_findReplace);
	
	var _fingerprint = __webpack_require__(1815);
	
	var _fingerprint2 = _interopRequireDefault(_fingerprint);
	
	var _flightLand = __webpack_require__(1816);
	
	var _flightLand2 = _interopRequireDefault(_flightLand);
	
	var _flightTakeoff = __webpack_require__(1817);
	
	var _flightTakeoff2 = _interopRequireDefault(_flightTakeoff);
	
	var _flipToBack = __webpack_require__(1818);
	
	var _flipToBack2 = _interopRequireDefault(_flipToBack);
	
	var _flipToFront = __webpack_require__(1819);
	
	var _flipToFront2 = _interopRequireDefault(_flipToFront);
	
	var _gTranslate = __webpack_require__(1820);
	
	var _gTranslate2 = _interopRequireDefault(_gTranslate);
	
	var _gavel = __webpack_require__(1821);
	
	var _gavel2 = _interopRequireDefault(_gavel);
	
	var _getApp = __webpack_require__(1822);
	
	var _getApp2 = _interopRequireDefault(_getApp);
	
	var _gif = __webpack_require__(1823);
	
	var _gif2 = _interopRequireDefault(_gif);
	
	var _grade = __webpack_require__(1824);
	
	var _grade2 = _interopRequireDefault(_grade);
	
	var _groupWork = __webpack_require__(1825);
	
	var _groupWork2 = _interopRequireDefault(_groupWork);
	
	var _helpOutline = __webpack_require__(1826);
	
	var _helpOutline2 = _interopRequireDefault(_helpOutline);
	
	var _help = __webpack_require__(1827);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _highlightOff = __webpack_require__(715);
	
	var _highlightOff2 = _interopRequireDefault(_highlightOff);
	
	var _history = __webpack_require__(1828);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _home = __webpack_require__(1829);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _hourglassEmpty = __webpack_require__(1830);
	
	var _hourglassEmpty2 = _interopRequireDefault(_hourglassEmpty);
	
	var _hourglassFull = __webpack_require__(1831);
	
	var _hourglassFull2 = _interopRequireDefault(_hourglassFull);
	
	var _http = __webpack_require__(1832);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _https = __webpack_require__(1833);
	
	var _https2 = _interopRequireDefault(_https);
	
	var _importantDevices = __webpack_require__(1834);
	
	var _importantDevices2 = _interopRequireDefault(_importantDevices);
	
	var _infoOutline = __webpack_require__(62);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _info = __webpack_require__(1835);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _input = __webpack_require__(716);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _invertColors = __webpack_require__(1836);
	
	var _invertColors2 = _interopRequireDefault(_invertColors);
	
	var _labelOutline = __webpack_require__(1837);
	
	var _labelOutline2 = _interopRequireDefault(_labelOutline);
	
	var _label = __webpack_require__(1838);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _language = __webpack_require__(1839);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _launch = __webpack_require__(1840);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _lightbulbOutline = __webpack_require__(1841);
	
	var _lightbulbOutline2 = _interopRequireDefault(_lightbulbOutline);
	
	var _lineStyle = __webpack_require__(1842);
	
	var _lineStyle2 = _interopRequireDefault(_lineStyle);
	
	var _lineWeight = __webpack_require__(1843);
	
	var _lineWeight2 = _interopRequireDefault(_lineWeight);
	
	var _list = __webpack_require__(1844);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _lockOpen = __webpack_require__(1845);
	
	var _lockOpen2 = _interopRequireDefault(_lockOpen);
	
	var _lockOutline = __webpack_require__(1846);
	
	var _lockOutline2 = _interopRequireDefault(_lockOutline);
	
	var _lock = __webpack_require__(1847);
	
	var _lock2 = _interopRequireDefault(_lock);
	
	var _loyalty = __webpack_require__(1848);
	
	var _loyalty2 = _interopRequireDefault(_loyalty);
	
	var _markunreadMailbox = __webpack_require__(1849);
	
	var _markunreadMailbox2 = _interopRequireDefault(_markunreadMailbox);
	
	var _motorcycle = __webpack_require__(1850);
	
	var _motorcycle2 = _interopRequireDefault(_motorcycle);
	
	var _noteAdd = __webpack_require__(1851);
	
	var _noteAdd2 = _interopRequireDefault(_noteAdd);
	
	var _offlinePin = __webpack_require__(1852);
	
	var _offlinePin2 = _interopRequireDefault(_offlinePin);
	
	var _opacity = __webpack_require__(1853);
	
	var _opacity2 = _interopRequireDefault(_opacity);
	
	var _openInBrowser = __webpack_require__(1854);
	
	var _openInBrowser2 = _interopRequireDefault(_openInBrowser);
	
	var _openInNew = __webpack_require__(1855);
	
	var _openInNew2 = _interopRequireDefault(_openInNew);
	
	var _openWith = __webpack_require__(1856);
	
	var _openWith2 = _interopRequireDefault(_openWith);
	
	var _pageview = __webpack_require__(1857);
	
	var _pageview2 = _interopRequireDefault(_pageview);
	
	var _panTool = __webpack_require__(1858);
	
	var _panTool2 = _interopRequireDefault(_panTool);
	
	var _payment = __webpack_require__(1859);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _permCameraMic = __webpack_require__(1860);
	
	var _permCameraMic2 = _interopRequireDefault(_permCameraMic);
	
	var _permContactCalendar = __webpack_require__(1861);
	
	var _permContactCalendar2 = _interopRequireDefault(_permContactCalendar);
	
	var _permDataSetting = __webpack_require__(1862);
	
	var _permDataSetting2 = _interopRequireDefault(_permDataSetting);
	
	var _permDeviceInformation = __webpack_require__(1863);
	
	var _permDeviceInformation2 = _interopRequireDefault(_permDeviceInformation);
	
	var _permIdentity = __webpack_require__(1864);
	
	var _permIdentity2 = _interopRequireDefault(_permIdentity);
	
	var _permMedia = __webpack_require__(1865);
	
	var _permMedia2 = _interopRequireDefault(_permMedia);
	
	var _permPhoneMsg = __webpack_require__(1866);
	
	var _permPhoneMsg2 = _interopRequireDefault(_permPhoneMsg);
	
	var _permScanWifi = __webpack_require__(1867);
	
	var _permScanWifi2 = _interopRequireDefault(_permScanWifi);
	
	var _pets = __webpack_require__(1868);
	
	var _pets2 = _interopRequireDefault(_pets);
	
	var _pictureInPictureAlt = __webpack_require__(1869);
	
	var _pictureInPictureAlt2 = _interopRequireDefault(_pictureInPictureAlt);
	
	var _pictureInPicture = __webpack_require__(1870);
	
	var _pictureInPicture2 = _interopRequireDefault(_pictureInPicture);
	
	var _playForWork = __webpack_require__(1871);
	
	var _playForWork2 = _interopRequireDefault(_playForWork);
	
	var _polymer = __webpack_require__(1872);
	
	var _polymer2 = _interopRequireDefault(_polymer);
	
	var _powerSettingsNew = __webpack_require__(1873);
	
	var _powerSettingsNew2 = _interopRequireDefault(_powerSettingsNew);
	
	var _pregnantWoman = __webpack_require__(1874);
	
	var _pregnantWoman2 = _interopRequireDefault(_pregnantWoman);
	
	var _print = __webpack_require__(1875);
	
	var _print2 = _interopRequireDefault(_print);
	
	var _queryBuilder = __webpack_require__(1876);
	
	var _queryBuilder2 = _interopRequireDefault(_queryBuilder);
	
	var _questionAnswer = __webpack_require__(1877);
	
	var _questionAnswer2 = _interopRequireDefault(_questionAnswer);
	
	var _receipt = __webpack_require__(1878);
	
	var _receipt2 = _interopRequireDefault(_receipt);
	
	var _recordVoiceOver = __webpack_require__(1879);
	
	var _recordVoiceOver2 = _interopRequireDefault(_recordVoiceOver);
	
	var _redeem = __webpack_require__(1880);
	
	var _redeem2 = _interopRequireDefault(_redeem);
	
	var _removeShoppingCart = __webpack_require__(1881);
	
	var _removeShoppingCart2 = _interopRequireDefault(_removeShoppingCart);
	
	var _reorder = __webpack_require__(1882);
	
	var _reorder2 = _interopRequireDefault(_reorder);
	
	var _reportProblem = __webpack_require__(1883);
	
	var _reportProblem2 = _interopRequireDefault(_reportProblem);
	
	var _restorePage = __webpack_require__(1884);
	
	var _restorePage2 = _interopRequireDefault(_restorePage);
	
	var _restore = __webpack_require__(1885);
	
	var _restore2 = _interopRequireDefault(_restore);
	
	var _room = __webpack_require__(1886);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _roundedCorner = __webpack_require__(1887);
	
	var _roundedCorner2 = _interopRequireDefault(_roundedCorner);
	
	var _rowing = __webpack_require__(1888);
	
	var _rowing2 = _interopRequireDefault(_rowing);
	
	var _schedule = __webpack_require__(1889);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _search = __webpack_require__(155);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _settingsApplications = __webpack_require__(1890);
	
	var _settingsApplications2 = _interopRequireDefault(_settingsApplications);
	
	var _settingsBackupRestore = __webpack_require__(1891);
	
	var _settingsBackupRestore2 = _interopRequireDefault(_settingsBackupRestore);
	
	var _settingsBluetooth = __webpack_require__(1892);
	
	var _settingsBluetooth2 = _interopRequireDefault(_settingsBluetooth);
	
	var _settingsBrightness = __webpack_require__(1893);
	
	var _settingsBrightness2 = _interopRequireDefault(_settingsBrightness);
	
	var _settingsCell = __webpack_require__(1894);
	
	var _settingsCell2 = _interopRequireDefault(_settingsCell);
	
	var _settingsEthernet = __webpack_require__(1895);
	
	var _settingsEthernet2 = _interopRequireDefault(_settingsEthernet);
	
	var _settingsInputAntenna = __webpack_require__(1896);
	
	var _settingsInputAntenna2 = _interopRequireDefault(_settingsInputAntenna);
	
	var _settingsInputComponent = __webpack_require__(1897);
	
	var _settingsInputComponent2 = _interopRequireDefault(_settingsInputComponent);
	
	var _settingsInputComposite = __webpack_require__(1898);
	
	var _settingsInputComposite2 = _interopRequireDefault(_settingsInputComposite);
	
	var _settingsInputHdmi = __webpack_require__(1899);
	
	var _settingsInputHdmi2 = _interopRequireDefault(_settingsInputHdmi);
	
	var _settingsInputSvideo = __webpack_require__(1900);
	
	var _settingsInputSvideo2 = _interopRequireDefault(_settingsInputSvideo);
	
	var _settingsOverscan = __webpack_require__(1901);
	
	var _settingsOverscan2 = _interopRequireDefault(_settingsOverscan);
	
	var _settingsPhone = __webpack_require__(1902);
	
	var _settingsPhone2 = _interopRequireDefault(_settingsPhone);
	
	var _settingsPower = __webpack_require__(1903);
	
	var _settingsPower2 = _interopRequireDefault(_settingsPower);
	
	var _settingsRemote = __webpack_require__(1904);
	
	var _settingsRemote2 = _interopRequireDefault(_settingsRemote);
	
	var _settingsVoice = __webpack_require__(1905);
	
	var _settingsVoice2 = _interopRequireDefault(_settingsVoice);
	
	var _settings = __webpack_require__(433);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _shopTwo = __webpack_require__(1906);
	
	var _shopTwo2 = _interopRequireDefault(_shopTwo);
	
	var _shop = __webpack_require__(1907);
	
	var _shop2 = _interopRequireDefault(_shop);
	
	var _shoppingBasket = __webpack_require__(1908);
	
	var _shoppingBasket2 = _interopRequireDefault(_shoppingBasket);
	
	var _shoppingCart = __webpack_require__(1909);
	
	var _shoppingCart2 = _interopRequireDefault(_shoppingCart);
	
	var _speakerNotesOff = __webpack_require__(1910);
	
	var _speakerNotesOff2 = _interopRequireDefault(_speakerNotesOff);
	
	var _speakerNotes = __webpack_require__(1911);
	
	var _speakerNotes2 = _interopRequireDefault(_speakerNotes);
	
	var _spellcheck = __webpack_require__(1912);
	
	var _spellcheck2 = _interopRequireDefault(_spellcheck);
	
	var _stars = __webpack_require__(1913);
	
	var _stars2 = _interopRequireDefault(_stars);
	
	var _store = __webpack_require__(1914);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _subject = __webpack_require__(1915);
	
	var _subject2 = _interopRequireDefault(_subject);
	
	var _supervisorAccount = __webpack_require__(1916);
	
	var _supervisorAccount2 = _interopRequireDefault(_supervisorAccount);
	
	var _swapHoriz = __webpack_require__(1917);
	
	var _swapHoriz2 = _interopRequireDefault(_swapHoriz);
	
	var _swapVert = __webpack_require__(1918);
	
	var _swapVert2 = _interopRequireDefault(_swapVert);
	
	var _swapVerticalCircle = __webpack_require__(1919);
	
	var _swapVerticalCircle2 = _interopRequireDefault(_swapVerticalCircle);
	
	var _systemUpdateAlt = __webpack_require__(1920);
	
	var _systemUpdateAlt2 = _interopRequireDefault(_systemUpdateAlt);
	
	var _tabUnselected = __webpack_require__(1921);
	
	var _tabUnselected2 = _interopRequireDefault(_tabUnselected);
	
	var _tab = __webpack_require__(1922);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _theaters = __webpack_require__(1923);
	
	var _theaters2 = _interopRequireDefault(_theaters);
	
	var _threeDRotation = __webpack_require__(1924);
	
	var _threeDRotation2 = _interopRequireDefault(_threeDRotation);
	
	var _thumbDown = __webpack_require__(1925);
	
	var _thumbDown2 = _interopRequireDefault(_thumbDown);
	
	var _thumbUp = __webpack_require__(1926);
	
	var _thumbUp2 = _interopRequireDefault(_thumbUp);
	
	var _thumbsUpDown = __webpack_require__(1927);
	
	var _thumbsUpDown2 = _interopRequireDefault(_thumbsUpDown);
	
	var _timeline = __webpack_require__(1928);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _toc = __webpack_require__(1929);
	
	var _toc2 = _interopRequireDefault(_toc);
	
	var _today = __webpack_require__(1930);
	
	var _today2 = _interopRequireDefault(_today);
	
	var _toll = __webpack_require__(1931);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _touchApp = __webpack_require__(1932);
	
	var _touchApp2 = _interopRequireDefault(_touchApp);
	
	var _trackChanges = __webpack_require__(1933);
	
	var _trackChanges2 = _interopRequireDefault(_trackChanges);
	
	var _translate = __webpack_require__(1934);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _trendingDown = __webpack_require__(1935);
	
	var _trendingDown2 = _interopRequireDefault(_trendingDown);
	
	var _trendingFlat = __webpack_require__(1936);
	
	var _trendingFlat2 = _interopRequireDefault(_trendingFlat);
	
	var _trendingUp = __webpack_require__(1937);
	
	var _trendingUp2 = _interopRequireDefault(_trendingUp);
	
	var _turnedInNot = __webpack_require__(1938);
	
	var _turnedInNot2 = _interopRequireDefault(_turnedInNot);
	
	var _turnedIn = __webpack_require__(1939);
	
	var _turnedIn2 = _interopRequireDefault(_turnedIn);
	
	var _update = __webpack_require__(1940);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _verifiedUser = __webpack_require__(1941);
	
	var _verifiedUser2 = _interopRequireDefault(_verifiedUser);
	
	var _viewAgenda = __webpack_require__(1942);
	
	var _viewAgenda2 = _interopRequireDefault(_viewAgenda);
	
	var _viewArray = __webpack_require__(1943);
	
	var _viewArray2 = _interopRequireDefault(_viewArray);
	
	var _viewCarousel = __webpack_require__(1944);
	
	var _viewCarousel2 = _interopRequireDefault(_viewCarousel);
	
	var _viewColumn = __webpack_require__(1945);
	
	var _viewColumn2 = _interopRequireDefault(_viewColumn);
	
	var _viewDay = __webpack_require__(1946);
	
	var _viewDay2 = _interopRequireDefault(_viewDay);
	
	var _viewHeadline = __webpack_require__(1947);
	
	var _viewHeadline2 = _interopRequireDefault(_viewHeadline);
	
	var _viewList = __webpack_require__(1948);
	
	var _viewList2 = _interopRequireDefault(_viewList);
	
	var _viewModule = __webpack_require__(1949);
	
	var _viewModule2 = _interopRequireDefault(_viewModule);
	
	var _viewQuilt = __webpack_require__(1950);
	
	var _viewQuilt2 = _interopRequireDefault(_viewQuilt);
	
	var _viewStream = __webpack_require__(1951);
	
	var _viewStream2 = _interopRequireDefault(_viewStream);
	
	var _viewWeek = __webpack_require__(1952);
	
	var _viewWeek2 = _interopRequireDefault(_viewWeek);
	
	var _visibilityOff = __webpack_require__(1953);
	
	var _visibilityOff2 = _interopRequireDefault(_visibilityOff);
	
	var _visibility = __webpack_require__(1954);
	
	var _visibility2 = _interopRequireDefault(_visibility);
	
	var _watchLater = __webpack_require__(1955);
	
	var _watchLater2 = _interopRequireDefault(_watchLater);
	
	var _work = __webpack_require__(1956);
	
	var _work2 = _interopRequireDefault(_work);
	
	var _youtubeSearchedFor = __webpack_require__(1957);
	
	var _youtubeSearchedFor2 = _interopRequireDefault(_youtubeSearchedFor);
	
	var _zoomIn = __webpack_require__(1958);
	
	var _zoomIn2 = _interopRequireDefault(_zoomIn);
	
	var _zoomOut = __webpack_require__(1959);
	
	var _zoomOut2 = _interopRequireDefault(_zoomOut);
	
	var _addAlert = __webpack_require__(1960);
	
	var _addAlert2 = _interopRequireDefault(_addAlert);
	
	var _errorOutline = __webpack_require__(1961);
	
	var _errorOutline2 = _interopRequireDefault(_errorOutline);
	
	var _error = __webpack_require__(96);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _warning = __webpack_require__(1962);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _addToQueue = __webpack_require__(1963);
	
	var _addToQueue2 = _interopRequireDefault(_addToQueue);
	
	var _airplay = __webpack_require__(1964);
	
	var _airplay2 = _interopRequireDefault(_airplay);
	
	var _album = __webpack_require__(1965);
	
	var _album2 = _interopRequireDefault(_album);
	
	var _artTrack = __webpack_require__(1966);
	
	var _artTrack2 = _interopRequireDefault(_artTrack);
	
	var _avTimer = __webpack_require__(1967);
	
	var _avTimer2 = _interopRequireDefault(_avTimer);
	
	var _brandingWatermark = __webpack_require__(1968);
	
	var _brandingWatermark2 = _interopRequireDefault(_brandingWatermark);
	
	var _callToAction = __webpack_require__(1969);
	
	var _callToAction2 = _interopRequireDefault(_callToAction);
	
	var _closedCaption = __webpack_require__(1970);
	
	var _closedCaption2 = _interopRequireDefault(_closedCaption);
	
	var _equalizer = __webpack_require__(1971);
	
	var _equalizer2 = _interopRequireDefault(_equalizer);
	
	var _explicit = __webpack_require__(1972);
	
	var _explicit2 = _interopRequireDefault(_explicit);
	
	var _fastForward = __webpack_require__(1973);
	
	var _fastForward2 = _interopRequireDefault(_fastForward);
	
	var _fastRewind = __webpack_require__(1974);
	
	var _fastRewind2 = _interopRequireDefault(_fastRewind);
	
	var _featuredPlayList = __webpack_require__(1975);
	
	var _featuredPlayList2 = _interopRequireDefault(_featuredPlayList);
	
	var _featuredVideo = __webpack_require__(1976);
	
	var _featuredVideo2 = _interopRequireDefault(_featuredVideo);
	
	var _fiberDvr = __webpack_require__(1977);
	
	var _fiberDvr2 = _interopRequireDefault(_fiberDvr);
	
	var _fiberManualRecord = __webpack_require__(1978);
	
	var _fiberManualRecord2 = _interopRequireDefault(_fiberManualRecord);
	
	var _fiberNew = __webpack_require__(1979);
	
	var _fiberNew2 = _interopRequireDefault(_fiberNew);
	
	var _fiberPin = __webpack_require__(1980);
	
	var _fiberPin2 = _interopRequireDefault(_fiberPin);
	
	var _fiberSmartRecord = __webpack_require__(1981);
	
	var _fiberSmartRecord2 = _interopRequireDefault(_fiberSmartRecord);
	
	var _forward = __webpack_require__(1982);
	
	var _forward2 = _interopRequireDefault(_forward);
	
	var _forward3 = __webpack_require__(1983);
	
	var _forward4 = _interopRequireDefault(_forward3);
	
	var _forward5 = __webpack_require__(1984);
	
	var _forward6 = _interopRequireDefault(_forward5);
	
	var _games = __webpack_require__(1985);
	
	var _games2 = _interopRequireDefault(_games);
	
	var _hd = __webpack_require__(1986);
	
	var _hd2 = _interopRequireDefault(_hd);
	
	var _hearing = __webpack_require__(1987);
	
	var _hearing2 = _interopRequireDefault(_hearing);
	
	var _highQuality = __webpack_require__(1988);
	
	var _highQuality2 = _interopRequireDefault(_highQuality);
	
	var _libraryAdd = __webpack_require__(1989);
	
	var _libraryAdd2 = _interopRequireDefault(_libraryAdd);
	
	var _libraryBooks = __webpack_require__(1990);
	
	var _libraryBooks2 = _interopRequireDefault(_libraryBooks);
	
	var _libraryMusic = __webpack_require__(1991);
	
	var _libraryMusic2 = _interopRequireDefault(_libraryMusic);
	
	var _loop = __webpack_require__(1992);
	
	var _loop2 = _interopRequireDefault(_loop);
	
	var _micNone = __webpack_require__(1993);
	
	var _micNone2 = _interopRequireDefault(_micNone);
	
	var _micOff = __webpack_require__(1994);
	
	var _micOff2 = _interopRequireDefault(_micOff);
	
	var _mic = __webpack_require__(1995);
	
	var _mic2 = _interopRequireDefault(_mic);
	
	var _movie = __webpack_require__(1996);
	
	var _movie2 = _interopRequireDefault(_movie);
	
	var _musicVideo = __webpack_require__(1997);
	
	var _musicVideo2 = _interopRequireDefault(_musicVideo);
	
	var _newReleases = __webpack_require__(1998);
	
	var _newReleases2 = _interopRequireDefault(_newReleases);
	
	var _notInterested = __webpack_require__(1999);
	
	var _notInterested2 = _interopRequireDefault(_notInterested);
	
	var _note = __webpack_require__(2000);
	
	var _note2 = _interopRequireDefault(_note);
	
	var _pauseCircleFilled = __webpack_require__(2001);
	
	var _pauseCircleFilled2 = _interopRequireDefault(_pauseCircleFilled);
	
	var _pauseCircleOutline = __webpack_require__(2002);
	
	var _pauseCircleOutline2 = _interopRequireDefault(_pauseCircleOutline);
	
	var _pause = __webpack_require__(2003);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _playArrow = __webpack_require__(156);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _playCircleFilled = __webpack_require__(2004);
	
	var _playCircleFilled2 = _interopRequireDefault(_playCircleFilled);
	
	var _playCircleOutline = __webpack_require__(2005);
	
	var _playCircleOutline2 = _interopRequireDefault(_playCircleOutline);
	
	var _playlistAddCheck = __webpack_require__(2006);
	
	var _playlistAddCheck2 = _interopRequireDefault(_playlistAddCheck);
	
	var _playlistAdd = __webpack_require__(2007);
	
	var _playlistAdd2 = _interopRequireDefault(_playlistAdd);
	
	var _playlistPlay = __webpack_require__(2008);
	
	var _playlistPlay2 = _interopRequireDefault(_playlistPlay);
	
	var _queueMusic = __webpack_require__(2009);
	
	var _queueMusic2 = _interopRequireDefault(_queueMusic);
	
	var _queuePlayNext = __webpack_require__(2010);
	
	var _queuePlayNext2 = _interopRequireDefault(_queuePlayNext);
	
	var _queue = __webpack_require__(2011);
	
	var _queue2 = _interopRequireDefault(_queue);
	
	var _radio = __webpack_require__(2012);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _recentActors = __webpack_require__(2013);
	
	var _recentActors2 = _interopRequireDefault(_recentActors);
	
	var _removeFromQueue = __webpack_require__(2014);
	
	var _removeFromQueue2 = _interopRequireDefault(_removeFromQueue);
	
	var _repeatOne = __webpack_require__(2015);
	
	var _repeatOne2 = _interopRequireDefault(_repeatOne);
	
	var _repeat = __webpack_require__(2016);
	
	var _repeat2 = _interopRequireDefault(_repeat);
	
	var _replay = __webpack_require__(2017);
	
	var _replay2 = _interopRequireDefault(_replay);
	
	var _replay3 = __webpack_require__(2018);
	
	var _replay4 = _interopRequireDefault(_replay3);
	
	var _replay5 = __webpack_require__(2019);
	
	var _replay6 = _interopRequireDefault(_replay5);
	
	var _replay7 = __webpack_require__(2020);
	
	var _replay8 = _interopRequireDefault(_replay7);
	
	var _shuffle = __webpack_require__(2021);
	
	var _shuffle2 = _interopRequireDefault(_shuffle);
	
	var _skipNext = __webpack_require__(2022);
	
	var _skipNext2 = _interopRequireDefault(_skipNext);
	
	var _skipPrevious = __webpack_require__(2023);
	
	var _skipPrevious2 = _interopRequireDefault(_skipPrevious);
	
	var _slowMotionVideo = __webpack_require__(2024);
	
	var _slowMotionVideo2 = _interopRequireDefault(_slowMotionVideo);
	
	var _snooze = __webpack_require__(2025);
	
	var _snooze2 = _interopRequireDefault(_snooze);
	
	var _sortByAlpha = __webpack_require__(2026);
	
	var _sortByAlpha2 = _interopRequireDefault(_sortByAlpha);
	
	var _stop = __webpack_require__(2027);
	
	var _stop2 = _interopRequireDefault(_stop);
	
	var _subscriptions = __webpack_require__(2028);
	
	var _subscriptions2 = _interopRequireDefault(_subscriptions);
	
	var _subtitles = __webpack_require__(2029);
	
	var _subtitles2 = _interopRequireDefault(_subtitles);
	
	var _surroundSound = __webpack_require__(2030);
	
	var _surroundSound2 = _interopRequireDefault(_surroundSound);
	
	var _videoCall = __webpack_require__(2031);
	
	var _videoCall2 = _interopRequireDefault(_videoCall);
	
	var _videoLabel = __webpack_require__(2032);
	
	var _videoLabel2 = _interopRequireDefault(_videoLabel);
	
	var _videoLibrary = __webpack_require__(2033);
	
	var _videoLibrary2 = _interopRequireDefault(_videoLibrary);
	
	var _videocamOff = __webpack_require__(2034);
	
	var _videocamOff2 = _interopRequireDefault(_videocamOff);
	
	var _videocam = __webpack_require__(2035);
	
	var _videocam2 = _interopRequireDefault(_videocam);
	
	var _volumeDown = __webpack_require__(2036);
	
	var _volumeDown2 = _interopRequireDefault(_volumeDown);
	
	var _volumeMute = __webpack_require__(2037);
	
	var _volumeMute2 = _interopRequireDefault(_volumeMute);
	
	var _volumeOff = __webpack_require__(2038);
	
	var _volumeOff2 = _interopRequireDefault(_volumeOff);
	
	var _volumeUp = __webpack_require__(2039);
	
	var _volumeUp2 = _interopRequireDefault(_volumeUp);
	
	var _webAsset = __webpack_require__(2040);
	
	var _webAsset2 = _interopRequireDefault(_webAsset);
	
	var _web = __webpack_require__(2041);
	
	var _web2 = _interopRequireDefault(_web);
	
	var _business = __webpack_require__(2042);
	
	var _business2 = _interopRequireDefault(_business);
	
	var _callEnd = __webpack_require__(2043);
	
	var _callEnd2 = _interopRequireDefault(_callEnd);
	
	var _callMade = __webpack_require__(2044);
	
	var _callMade2 = _interopRequireDefault(_callMade);
	
	var _callMerge = __webpack_require__(2045);
	
	var _callMerge2 = _interopRequireDefault(_callMerge);
	
	var _callMissedOutgoing = __webpack_require__(2046);
	
	var _callMissedOutgoing2 = _interopRequireDefault(_callMissedOutgoing);
	
	var _callMissed = __webpack_require__(2047);
	
	var _callMissed2 = _interopRequireDefault(_callMissed);
	
	var _callReceived = __webpack_require__(2048);
	
	var _callReceived2 = _interopRequireDefault(_callReceived);
	
	var _callSplit = __webpack_require__(2049);
	
	var _callSplit2 = _interopRequireDefault(_callSplit);
	
	var _call = __webpack_require__(2050);
	
	var _call2 = _interopRequireDefault(_call);
	
	var _chatBubbleOutline = __webpack_require__(2051);
	
	var _chatBubbleOutline2 = _interopRequireDefault(_chatBubbleOutline);
	
	var _chatBubble = __webpack_require__(2052);
	
	var _chatBubble2 = _interopRequireDefault(_chatBubble);
	
	var _chat = __webpack_require__(2053);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	var _clearAll = __webpack_require__(2054);
	
	var _clearAll2 = _interopRequireDefault(_clearAll);
	
	var _comment = __webpack_require__(2055);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _contactMail = __webpack_require__(2056);
	
	var _contactMail2 = _interopRequireDefault(_contactMail);
	
	var _contactPhone = __webpack_require__(2057);
	
	var _contactPhone2 = _interopRequireDefault(_contactPhone);
	
	var _contacts = __webpack_require__(2058);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _dialerSip = __webpack_require__(2059);
	
	var _dialerSip2 = _interopRequireDefault(_dialerSip);
	
	var _dialpad = __webpack_require__(2060);
	
	var _dialpad2 = _interopRequireDefault(_dialpad);
	
	var _email = __webpack_require__(2061);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _forum = __webpack_require__(2062);
	
	var _forum2 = _interopRequireDefault(_forum);
	
	var _importContacts = __webpack_require__(2063);
	
	var _importContacts2 = _interopRequireDefault(_importContacts);
	
	var _importExport = __webpack_require__(2064);
	
	var _importExport2 = _interopRequireDefault(_importExport);
	
	var _invertColorsOff = __webpack_require__(2065);
	
	var _invertColorsOff2 = _interopRequireDefault(_invertColorsOff);
	
	var _liveHelp = __webpack_require__(2066);
	
	var _liveHelp2 = _interopRequireDefault(_liveHelp);
	
	var _locationOff = __webpack_require__(2067);
	
	var _locationOff2 = _interopRequireDefault(_locationOff);
	
	var _locationOn = __webpack_require__(2068);
	
	var _locationOn2 = _interopRequireDefault(_locationOn);
	
	var _mailOutline = __webpack_require__(2069);
	
	var _mailOutline2 = _interopRequireDefault(_mailOutline);
	
	var _message = __webpack_require__(2070);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _noSim = __webpack_require__(2071);
	
	var _noSim2 = _interopRequireDefault(_noSim);
	
	var _phone = __webpack_require__(2072);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _phonelinkErase = __webpack_require__(2073);
	
	var _phonelinkErase2 = _interopRequireDefault(_phonelinkErase);
	
	var _phonelinkLock = __webpack_require__(2074);
	
	var _phonelinkLock2 = _interopRequireDefault(_phonelinkLock);
	
	var _phonelinkRing = __webpack_require__(2075);
	
	var _phonelinkRing2 = _interopRequireDefault(_phonelinkRing);
	
	var _phonelinkSetup = __webpack_require__(2076);
	
	var _phonelinkSetup2 = _interopRequireDefault(_phonelinkSetup);
	
	var _portableWifiOff = __webpack_require__(2077);
	
	var _portableWifiOff2 = _interopRequireDefault(_portableWifiOff);
	
	var _presentToAll = __webpack_require__(2078);
	
	var _presentToAll2 = _interopRequireDefault(_presentToAll);
	
	var _ringVolume = __webpack_require__(2079);
	
	var _ringVolume2 = _interopRequireDefault(_ringVolume);
	
	var _rssFeed = __webpack_require__(2080);
	
	var _rssFeed2 = _interopRequireDefault(_rssFeed);
	
	var _screenShare = __webpack_require__(2081);
	
	var _screenShare2 = _interopRequireDefault(_screenShare);
	
	var _speakerPhone = __webpack_require__(2082);
	
	var _speakerPhone2 = _interopRequireDefault(_speakerPhone);
	
	var _stayCurrentLandscape = __webpack_require__(2083);
	
	var _stayCurrentLandscape2 = _interopRequireDefault(_stayCurrentLandscape);
	
	var _stayCurrentPortrait = __webpack_require__(2084);
	
	var _stayCurrentPortrait2 = _interopRequireDefault(_stayCurrentPortrait);
	
	var _stayPrimaryLandscape = __webpack_require__(2085);
	
	var _stayPrimaryLandscape2 = _interopRequireDefault(_stayPrimaryLandscape);
	
	var _stayPrimaryPortrait = __webpack_require__(2086);
	
	var _stayPrimaryPortrait2 = _interopRequireDefault(_stayPrimaryPortrait);
	
	var _stopScreenShare = __webpack_require__(2087);
	
	var _stopScreenShare2 = _interopRequireDefault(_stopScreenShare);
	
	var _swapCalls = __webpack_require__(2088);
	
	var _swapCalls2 = _interopRequireDefault(_swapCalls);
	
	var _textsms = __webpack_require__(2089);
	
	var _textsms2 = _interopRequireDefault(_textsms);
	
	var _voicemail = __webpack_require__(2090);
	
	var _voicemail2 = _interopRequireDefault(_voicemail);
	
	var _vpnKey = __webpack_require__(2091);
	
	var _vpnKey2 = _interopRequireDefault(_vpnKey);
	
	var _addBox = __webpack_require__(2092);
	
	var _addBox2 = _interopRequireDefault(_addBox);
	
	var _addCircleOutline = __webpack_require__(2093);
	
	var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);
	
	var _addCircle = __webpack_require__(2094);
	
	var _addCircle2 = _interopRequireDefault(_addCircle);
	
	var _add = __webpack_require__(2095);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _archive = __webpack_require__(717);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	var _backspace = __webpack_require__(2096);
	
	var _backspace2 = _interopRequireDefault(_backspace);
	
	var _block = __webpack_require__(2097);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _clear = __webpack_require__(109);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _contentCopy = __webpack_require__(2098);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _contentCut = __webpack_require__(2099);
	
	var _contentCut2 = _interopRequireDefault(_contentCut);
	
	var _contentPaste = __webpack_require__(2100);
	
	var _contentPaste2 = _interopRequireDefault(_contentPaste);
	
	var _create = __webpack_require__(718);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _deleteSweep = __webpack_require__(2101);
	
	var _deleteSweep2 = _interopRequireDefault(_deleteSweep);
	
	var _drafts = __webpack_require__(2102);
	
	var _drafts2 = _interopRequireDefault(_drafts);
	
	var _filterList = __webpack_require__(2103);
	
	var _filterList2 = _interopRequireDefault(_filterList);
	
	var _flag = __webpack_require__(2104);
	
	var _flag2 = _interopRequireDefault(_flag);
	
	var _fontDownload = __webpack_require__(2105);
	
	var _fontDownload2 = _interopRequireDefault(_fontDownload);
	
	var _forward7 = __webpack_require__(2106);
	
	var _forward8 = _interopRequireDefault(_forward7);
	
	var _gesture = __webpack_require__(2107);
	
	var _gesture2 = _interopRequireDefault(_gesture);
	
	var _inbox = __webpack_require__(2108);
	
	var _inbox2 = _interopRequireDefault(_inbox);
	
	var _link = __webpack_require__(2109);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _lowPriority = __webpack_require__(2110);
	
	var _lowPriority2 = _interopRequireDefault(_lowPriority);
	
	var _mail = __webpack_require__(2111);
	
	var _mail2 = _interopRequireDefault(_mail);
	
	var _markunread = __webpack_require__(2112);
	
	var _markunread2 = _interopRequireDefault(_markunread);
	
	var _moveToInbox = __webpack_require__(2113);
	
	var _moveToInbox2 = _interopRequireDefault(_moveToInbox);
	
	var _nextWeek = __webpack_require__(2114);
	
	var _nextWeek2 = _interopRequireDefault(_nextWeek);
	
	var _redo = __webpack_require__(2115);
	
	var _redo2 = _interopRequireDefault(_redo);
	
	var _removeCircleOutline = __webpack_require__(2116);
	
	var _removeCircleOutline2 = _interopRequireDefault(_removeCircleOutline);
	
	var _removeCircle = __webpack_require__(2117);
	
	var _removeCircle2 = _interopRequireDefault(_removeCircle);
	
	var _remove = __webpack_require__(2118);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _replyAll = __webpack_require__(2119);
	
	var _replyAll2 = _interopRequireDefault(_replyAll);
	
	var _reply = __webpack_require__(2120);
	
	var _reply2 = _interopRequireDefault(_reply);
	
	var _report = __webpack_require__(2121);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _save = __webpack_require__(2122);
	
	var _save2 = _interopRequireDefault(_save);
	
	var _selectAll = __webpack_require__(2123);
	
	var _selectAll2 = _interopRequireDefault(_selectAll);
	
	var _send = __webpack_require__(2124);
	
	var _send2 = _interopRequireDefault(_send);
	
	var _sort = __webpack_require__(2125);
	
	var _sort2 = _interopRequireDefault(_sort);
	
	var _textFormat = __webpack_require__(2126);
	
	var _textFormat2 = _interopRequireDefault(_textFormat);
	
	var _unarchive = __webpack_require__(2127);
	
	var _unarchive2 = _interopRequireDefault(_unarchive);
	
	var _undo = __webpack_require__(2128);
	
	var _undo2 = _interopRequireDefault(_undo);
	
	var _weekend = __webpack_require__(2129);
	
	var _weekend2 = _interopRequireDefault(_weekend);
	
	var _accessAlarm = __webpack_require__(2130);
	
	var _accessAlarm2 = _interopRequireDefault(_accessAlarm);
	
	var _accessAlarms = __webpack_require__(2131);
	
	var _accessAlarms2 = _interopRequireDefault(_accessAlarms);
	
	var _accessTime = __webpack_require__(2132);
	
	var _accessTime2 = _interopRequireDefault(_accessTime);
	
	var _addAlarm = __webpack_require__(2133);
	
	var _addAlarm2 = _interopRequireDefault(_addAlarm);
	
	var _airplanemodeActive = __webpack_require__(2134);
	
	var _airplanemodeActive2 = _interopRequireDefault(_airplanemodeActive);
	
	var _airplanemodeInactive = __webpack_require__(2135);
	
	var _airplanemodeInactive2 = _interopRequireDefault(_airplanemodeInactive);
	
	var _battery = __webpack_require__(2136);
	
	var _battery2 = _interopRequireDefault(_battery);
	
	var _battery3 = __webpack_require__(2137);
	
	var _battery4 = _interopRequireDefault(_battery3);
	
	var _battery5 = __webpack_require__(2138);
	
	var _battery6 = _interopRequireDefault(_battery5);
	
	var _battery7 = __webpack_require__(2139);
	
	var _battery8 = _interopRequireDefault(_battery7);
	
	var _battery9 = __webpack_require__(2140);
	
	var _battery10 = _interopRequireDefault(_battery9);
	
	var _battery11 = __webpack_require__(2141);
	
	var _battery12 = _interopRequireDefault(_battery11);
	
	var _batteryAlert = __webpack_require__(2142);
	
	var _batteryAlert2 = _interopRequireDefault(_batteryAlert);
	
	var _batteryCharging = __webpack_require__(2143);
	
	var _batteryCharging2 = _interopRequireDefault(_batteryCharging);
	
	var _batteryCharging3 = __webpack_require__(2144);
	
	var _batteryCharging4 = _interopRequireDefault(_batteryCharging3);
	
	var _batteryCharging5 = __webpack_require__(2145);
	
	var _batteryCharging6 = _interopRequireDefault(_batteryCharging5);
	
	var _batteryCharging7 = __webpack_require__(2146);
	
	var _batteryCharging8 = _interopRequireDefault(_batteryCharging7);
	
	var _batteryCharging9 = __webpack_require__(2147);
	
	var _batteryCharging10 = _interopRequireDefault(_batteryCharging9);
	
	var _batteryCharging11 = __webpack_require__(2148);
	
	var _batteryCharging12 = _interopRequireDefault(_batteryCharging11);
	
	var _batteryChargingFull = __webpack_require__(2149);
	
	var _batteryChargingFull2 = _interopRequireDefault(_batteryChargingFull);
	
	var _batteryFull = __webpack_require__(2150);
	
	var _batteryFull2 = _interopRequireDefault(_batteryFull);
	
	var _batteryStd = __webpack_require__(2151);
	
	var _batteryStd2 = _interopRequireDefault(_batteryStd);
	
	var _batteryUnknown = __webpack_require__(2152);
	
	var _batteryUnknown2 = _interopRequireDefault(_batteryUnknown);
	
	var _bluetoothConnected = __webpack_require__(2153);
	
	var _bluetoothConnected2 = _interopRequireDefault(_bluetoothConnected);
	
	var _bluetoothDisabled = __webpack_require__(2154);
	
	var _bluetoothDisabled2 = _interopRequireDefault(_bluetoothDisabled);
	
	var _bluetoothSearching = __webpack_require__(2155);
	
	var _bluetoothSearching2 = _interopRequireDefault(_bluetoothSearching);
	
	var _bluetooth = __webpack_require__(2156);
	
	var _bluetooth2 = _interopRequireDefault(_bluetooth);
	
	var _brightnessAuto = __webpack_require__(2157);
	
	var _brightnessAuto2 = _interopRequireDefault(_brightnessAuto);
	
	var _brightnessHigh = __webpack_require__(2158);
	
	var _brightnessHigh2 = _interopRequireDefault(_brightnessHigh);
	
	var _brightnessLow = __webpack_require__(2159);
	
	var _brightnessLow2 = _interopRequireDefault(_brightnessLow);
	
	var _brightnessMedium = __webpack_require__(2160);
	
	var _brightnessMedium2 = _interopRequireDefault(_brightnessMedium);
	
	var _dataUsage = __webpack_require__(2161);
	
	var _dataUsage2 = _interopRequireDefault(_dataUsage);
	
	var _developerMode = __webpack_require__(2162);
	
	var _developerMode2 = _interopRequireDefault(_developerMode);
	
	var _devices = __webpack_require__(2163);
	
	var _devices2 = _interopRequireDefault(_devices);
	
	var _dvr = __webpack_require__(2164);
	
	var _dvr2 = _interopRequireDefault(_dvr);
	
	var _gpsFixed = __webpack_require__(2165);
	
	var _gpsFixed2 = _interopRequireDefault(_gpsFixed);
	
	var _gpsNotFixed = __webpack_require__(2166);
	
	var _gpsNotFixed2 = _interopRequireDefault(_gpsNotFixed);
	
	var _gpsOff = __webpack_require__(2167);
	
	var _gpsOff2 = _interopRequireDefault(_gpsOff);
	
	var _graphicEq = __webpack_require__(2168);
	
	var _graphicEq2 = _interopRequireDefault(_graphicEq);
	
	var _locationDisabled = __webpack_require__(2169);
	
	var _locationDisabled2 = _interopRequireDefault(_locationDisabled);
	
	var _locationSearching = __webpack_require__(2170);
	
	var _locationSearching2 = _interopRequireDefault(_locationSearching);
	
	var _networkCell = __webpack_require__(2171);
	
	var _networkCell2 = _interopRequireDefault(_networkCell);
	
	var _networkWifi = __webpack_require__(2172);
	
	var _networkWifi2 = _interopRequireDefault(_networkWifi);
	
	var _nfc = __webpack_require__(2173);
	
	var _nfc2 = _interopRequireDefault(_nfc);
	
	var _screenLockLandscape = __webpack_require__(2174);
	
	var _screenLockLandscape2 = _interopRequireDefault(_screenLockLandscape);
	
	var _screenLockPortrait = __webpack_require__(2175);
	
	var _screenLockPortrait2 = _interopRequireDefault(_screenLockPortrait);
	
	var _screenLockRotation = __webpack_require__(2176);
	
	var _screenLockRotation2 = _interopRequireDefault(_screenLockRotation);
	
	var _screenRotation = __webpack_require__(2177);
	
	var _screenRotation2 = _interopRequireDefault(_screenRotation);
	
	var _sdStorage = __webpack_require__(2178);
	
	var _sdStorage2 = _interopRequireDefault(_sdStorage);
	
	var _settingsSystemDaydream = __webpack_require__(2179);
	
	var _settingsSystemDaydream2 = _interopRequireDefault(_settingsSystemDaydream);
	
	var _signalCellular0Bar = __webpack_require__(2180);
	
	var _signalCellular0Bar2 = _interopRequireDefault(_signalCellular0Bar);
	
	var _signalCellular1Bar = __webpack_require__(2181);
	
	var _signalCellular1Bar2 = _interopRequireDefault(_signalCellular1Bar);
	
	var _signalCellular2Bar = __webpack_require__(2182);
	
	var _signalCellular2Bar2 = _interopRequireDefault(_signalCellular2Bar);
	
	var _signalCellular3Bar = __webpack_require__(2183);
	
	var _signalCellular3Bar2 = _interopRequireDefault(_signalCellular3Bar);
	
	var _signalCellular4Bar = __webpack_require__(2184);
	
	var _signalCellular4Bar2 = _interopRequireDefault(_signalCellular4Bar);
	
	var _signalCellularConnectedNoInternet0Bar = __webpack_require__(2185);
	
	var _signalCellularConnectedNoInternet0Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet0Bar);
	
	var _signalCellularConnectedNoInternet1Bar = __webpack_require__(2186);
	
	var _signalCellularConnectedNoInternet1Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet1Bar);
	
	var _signalCellularConnectedNoInternet2Bar = __webpack_require__(2187);
	
	var _signalCellularConnectedNoInternet2Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet2Bar);
	
	var _signalCellularConnectedNoInternet3Bar = __webpack_require__(2188);
	
	var _signalCellularConnectedNoInternet3Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet3Bar);
	
	var _signalCellularConnectedNoInternet4Bar = __webpack_require__(2189);
	
	var _signalCellularConnectedNoInternet4Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet4Bar);
	
	var _signalCellularNoSim = __webpack_require__(2190);
	
	var _signalCellularNoSim2 = _interopRequireDefault(_signalCellularNoSim);
	
	var _signalCellularNull = __webpack_require__(2191);
	
	var _signalCellularNull2 = _interopRequireDefault(_signalCellularNull);
	
	var _signalCellularOff = __webpack_require__(2192);
	
	var _signalCellularOff2 = _interopRequireDefault(_signalCellularOff);
	
	var _signalWifi0Bar = __webpack_require__(2193);
	
	var _signalWifi0Bar2 = _interopRequireDefault(_signalWifi0Bar);
	
	var _signalWifi1BarLock = __webpack_require__(2194);
	
	var _signalWifi1BarLock2 = _interopRequireDefault(_signalWifi1BarLock);
	
	var _signalWifi1Bar = __webpack_require__(2195);
	
	var _signalWifi1Bar2 = _interopRequireDefault(_signalWifi1Bar);
	
	var _signalWifi2BarLock = __webpack_require__(2196);
	
	var _signalWifi2BarLock2 = _interopRequireDefault(_signalWifi2BarLock);
	
	var _signalWifi2Bar = __webpack_require__(2197);
	
	var _signalWifi2Bar2 = _interopRequireDefault(_signalWifi2Bar);
	
	var _signalWifi3BarLock = __webpack_require__(2198);
	
	var _signalWifi3BarLock2 = _interopRequireDefault(_signalWifi3BarLock);
	
	var _signalWifi3Bar = __webpack_require__(2199);
	
	var _signalWifi3Bar2 = _interopRequireDefault(_signalWifi3Bar);
	
	var _signalWifi4BarLock = __webpack_require__(2200);
	
	var _signalWifi4BarLock2 = _interopRequireDefault(_signalWifi4BarLock);
	
	var _signalWifi4Bar = __webpack_require__(2201);
	
	var _signalWifi4Bar2 = _interopRequireDefault(_signalWifi4Bar);
	
	var _signalWifiOff = __webpack_require__(2202);
	
	var _signalWifiOff2 = _interopRequireDefault(_signalWifiOff);
	
	var _storage = __webpack_require__(2203);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _usb = __webpack_require__(2204);
	
	var _usb2 = _interopRequireDefault(_usb);
	
	var _wallpaper = __webpack_require__(2205);
	
	var _wallpaper2 = _interopRequireDefault(_wallpaper);
	
	var _widgets = __webpack_require__(2206);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	var _wifiLock = __webpack_require__(2207);
	
	var _wifiLock2 = _interopRequireDefault(_wifiLock);
	
	var _wifiTethering = __webpack_require__(2208);
	
	var _wifiTethering2 = _interopRequireDefault(_wifiTethering);
	
	var _attachFile = __webpack_require__(2209);
	
	var _attachFile2 = _interopRequireDefault(_attachFile);
	
	var _attachMoney = __webpack_require__(2210);
	
	var _attachMoney2 = _interopRequireDefault(_attachMoney);
	
	var _borderAll = __webpack_require__(2211);
	
	var _borderAll2 = _interopRequireDefault(_borderAll);
	
	var _borderBottom = __webpack_require__(2212);
	
	var _borderBottom2 = _interopRequireDefault(_borderBottom);
	
	var _borderClear = __webpack_require__(2213);
	
	var _borderClear2 = _interopRequireDefault(_borderClear);
	
	var _borderColor = __webpack_require__(2214);
	
	var _borderColor2 = _interopRequireDefault(_borderColor);
	
	var _borderHorizontal = __webpack_require__(2215);
	
	var _borderHorizontal2 = _interopRequireDefault(_borderHorizontal);
	
	var _borderInner = __webpack_require__(2216);
	
	var _borderInner2 = _interopRequireDefault(_borderInner);
	
	var _borderLeft = __webpack_require__(2217);
	
	var _borderLeft2 = _interopRequireDefault(_borderLeft);
	
	var _borderOuter = __webpack_require__(2218);
	
	var _borderOuter2 = _interopRequireDefault(_borderOuter);
	
	var _borderRight = __webpack_require__(2219);
	
	var _borderRight2 = _interopRequireDefault(_borderRight);
	
	var _borderStyle = __webpack_require__(2220);
	
	var _borderStyle2 = _interopRequireDefault(_borderStyle);
	
	var _borderTop = __webpack_require__(2221);
	
	var _borderTop2 = _interopRequireDefault(_borderTop);
	
	var _borderVertical = __webpack_require__(2222);
	
	var _borderVertical2 = _interopRequireDefault(_borderVertical);
	
	var _bubbleChart = __webpack_require__(2223);
	
	var _bubbleChart2 = _interopRequireDefault(_bubbleChart);
	
	var _dragHandle = __webpack_require__(2224);
	
	var _dragHandle2 = _interopRequireDefault(_dragHandle);
	
	var _formatAlignCenter = __webpack_require__(2225);
	
	var _formatAlignCenter2 = _interopRequireDefault(_formatAlignCenter);
	
	var _formatAlignJustify = __webpack_require__(2226);
	
	var _formatAlignJustify2 = _interopRequireDefault(_formatAlignJustify);
	
	var _formatAlignLeft = __webpack_require__(2227);
	
	var _formatAlignLeft2 = _interopRequireDefault(_formatAlignLeft);
	
	var _formatAlignRight = __webpack_require__(2228);
	
	var _formatAlignRight2 = _interopRequireDefault(_formatAlignRight);
	
	var _formatBold = __webpack_require__(2229);
	
	var _formatBold2 = _interopRequireDefault(_formatBold);
	
	var _formatClear = __webpack_require__(2230);
	
	var _formatClear2 = _interopRequireDefault(_formatClear);
	
	var _formatColorFill = __webpack_require__(2231);
	
	var _formatColorFill2 = _interopRequireDefault(_formatColorFill);
	
	var _formatColorReset = __webpack_require__(2232);
	
	var _formatColorReset2 = _interopRequireDefault(_formatColorReset);
	
	var _formatColorText = __webpack_require__(2233);
	
	var _formatColorText2 = _interopRequireDefault(_formatColorText);
	
	var _formatIndentDecrease = __webpack_require__(2234);
	
	var _formatIndentDecrease2 = _interopRequireDefault(_formatIndentDecrease);
	
	var _formatIndentIncrease = __webpack_require__(2235);
	
	var _formatIndentIncrease2 = _interopRequireDefault(_formatIndentIncrease);
	
	var _formatItalic = __webpack_require__(2236);
	
	var _formatItalic2 = _interopRequireDefault(_formatItalic);
	
	var _formatLineSpacing = __webpack_require__(2237);
	
	var _formatLineSpacing2 = _interopRequireDefault(_formatLineSpacing);
	
	var _formatListBulleted = __webpack_require__(2238);
	
	var _formatListBulleted2 = _interopRequireDefault(_formatListBulleted);
	
	var _formatListNumbered = __webpack_require__(2239);
	
	var _formatListNumbered2 = _interopRequireDefault(_formatListNumbered);
	
	var _formatPaint = __webpack_require__(2240);
	
	var _formatPaint2 = _interopRequireDefault(_formatPaint);
	
	var _formatQuote = __webpack_require__(2241);
	
	var _formatQuote2 = _interopRequireDefault(_formatQuote);
	
	var _formatShapes = __webpack_require__(2242);
	
	var _formatShapes2 = _interopRequireDefault(_formatShapes);
	
	var _formatSize = __webpack_require__(2243);
	
	var _formatSize2 = _interopRequireDefault(_formatSize);
	
	var _formatStrikethrough = __webpack_require__(2244);
	
	var _formatStrikethrough2 = _interopRequireDefault(_formatStrikethrough);
	
	var _formatTextdirectionLToR = __webpack_require__(2245);
	
	var _formatTextdirectionLToR2 = _interopRequireDefault(_formatTextdirectionLToR);
	
	var _formatTextdirectionRToL = __webpack_require__(2246);
	
	var _formatTextdirectionRToL2 = _interopRequireDefault(_formatTextdirectionRToL);
	
	var _formatUnderlined = __webpack_require__(2247);
	
	var _formatUnderlined2 = _interopRequireDefault(_formatUnderlined);
	
	var _functions = __webpack_require__(2248);
	
	var _functions2 = _interopRequireDefault(_functions);
	
	var _highlight = __webpack_require__(2249);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _insertChart = __webpack_require__(2250);
	
	var _insertChart2 = _interopRequireDefault(_insertChart);
	
	var _insertComment = __webpack_require__(2251);
	
	var _insertComment2 = _interopRequireDefault(_insertComment);
	
	var _insertDriveFile = __webpack_require__(2252);
	
	var _insertDriveFile2 = _interopRequireDefault(_insertDriveFile);
	
	var _insertEmoticon = __webpack_require__(2253);
	
	var _insertEmoticon2 = _interopRequireDefault(_insertEmoticon);
	
	var _insertInvitation = __webpack_require__(2254);
	
	var _insertInvitation2 = _interopRequireDefault(_insertInvitation);
	
	var _insertLink = __webpack_require__(2255);
	
	var _insertLink2 = _interopRequireDefault(_insertLink);
	
	var _insertPhoto = __webpack_require__(2256);
	
	var _insertPhoto2 = _interopRequireDefault(_insertPhoto);
	
	var _linearScale = __webpack_require__(2257);
	
	var _linearScale2 = _interopRequireDefault(_linearScale);
	
	var _mergeType = __webpack_require__(2258);
	
	var _mergeType2 = _interopRequireDefault(_mergeType);
	
	var _modeComment = __webpack_require__(2259);
	
	var _modeComment2 = _interopRequireDefault(_modeComment);
	
	var _modeEdit = __webpack_require__(719);
	
	var _modeEdit2 = _interopRequireDefault(_modeEdit);
	
	var _monetizationOn = __webpack_require__(2260);
	
	var _monetizationOn2 = _interopRequireDefault(_monetizationOn);
	
	var _moneyOff = __webpack_require__(2261);
	
	var _moneyOff2 = _interopRequireDefault(_moneyOff);
	
	var _multilineChart = __webpack_require__(2262);
	
	var _multilineChart2 = _interopRequireDefault(_multilineChart);
	
	var _pieChartOutlined = __webpack_require__(2263);
	
	var _pieChartOutlined2 = _interopRequireDefault(_pieChartOutlined);
	
	var _pieChart = __webpack_require__(2264);
	
	var _pieChart2 = _interopRequireDefault(_pieChart);
	
	var _publish = __webpack_require__(2265);
	
	var _publish2 = _interopRequireDefault(_publish);
	
	var _shortText = __webpack_require__(2266);
	
	var _shortText2 = _interopRequireDefault(_shortText);
	
	var _showChart = __webpack_require__(2267);
	
	var _showChart2 = _interopRequireDefault(_showChart);
	
	var _spaceBar = __webpack_require__(2268);
	
	var _spaceBar2 = _interopRequireDefault(_spaceBar);
	
	var _strikethroughS = __webpack_require__(2269);
	
	var _strikethroughS2 = _interopRequireDefault(_strikethroughS);
	
	var _textFields = __webpack_require__(2270);
	
	var _textFields2 = _interopRequireDefault(_textFields);
	
	var _title = __webpack_require__(2271);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _verticalAlignBottom = __webpack_require__(2272);
	
	var _verticalAlignBottom2 = _interopRequireDefault(_verticalAlignBottom);
	
	var _verticalAlignCenter = __webpack_require__(2273);
	
	var _verticalAlignCenter2 = _interopRequireDefault(_verticalAlignCenter);
	
	var _verticalAlignTop = __webpack_require__(2274);
	
	var _verticalAlignTop2 = _interopRequireDefault(_verticalAlignTop);
	
	var _wrapText = __webpack_require__(2275);
	
	var _wrapText2 = _interopRequireDefault(_wrapText);
	
	var _attachment = __webpack_require__(2276);
	
	var _attachment2 = _interopRequireDefault(_attachment);
	
	var _cloudCircle = __webpack_require__(2277);
	
	var _cloudCircle2 = _interopRequireDefault(_cloudCircle);
	
	var _cloudDone = __webpack_require__(2278);
	
	var _cloudDone2 = _interopRequireDefault(_cloudDone);
	
	var _cloudDownload = __webpack_require__(2279);
	
	var _cloudDownload2 = _interopRequireDefault(_cloudDownload);
	
	var _cloudOff = __webpack_require__(2280);
	
	var _cloudOff2 = _interopRequireDefault(_cloudOff);
	
	var _cloudQueue = __webpack_require__(2281);
	
	var _cloudQueue2 = _interopRequireDefault(_cloudQueue);
	
	var _cloudUpload = __webpack_require__(2282);
	
	var _cloudUpload2 = _interopRequireDefault(_cloudUpload);
	
	var _cloud = __webpack_require__(2283);
	
	var _cloud2 = _interopRequireDefault(_cloud);
	
	var _createNewFolder = __webpack_require__(2284);
	
	var _createNewFolder2 = _interopRequireDefault(_createNewFolder);
	
	var _fileDownload = __webpack_require__(720);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _fileUpload = __webpack_require__(2285);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _folderOpen = __webpack_require__(2286);
	
	var _folderOpen2 = _interopRequireDefault(_folderOpen);
	
	var _folderShared = __webpack_require__(2287);
	
	var _folderShared2 = _interopRequireDefault(_folderShared);
	
	var _folder = __webpack_require__(2288);
	
	var _folder2 = _interopRequireDefault(_folder);
	
	var _castConnected = __webpack_require__(2289);
	
	var _castConnected2 = _interopRequireDefault(_castConnected);
	
	var _cast = __webpack_require__(2290);
	
	var _cast2 = _interopRequireDefault(_cast);
	
	var _computer = __webpack_require__(2291);
	
	var _computer2 = _interopRequireDefault(_computer);
	
	var _desktopMac = __webpack_require__(2292);
	
	var _desktopMac2 = _interopRequireDefault(_desktopMac);
	
	var _desktopWindows = __webpack_require__(2293);
	
	var _desktopWindows2 = _interopRequireDefault(_desktopWindows);
	
	var _developerBoard = __webpack_require__(2294);
	
	var _developerBoard2 = _interopRequireDefault(_developerBoard);
	
	var _deviceHub = __webpack_require__(2295);
	
	var _deviceHub2 = _interopRequireDefault(_deviceHub);
	
	var _devicesOther = __webpack_require__(2296);
	
	var _devicesOther2 = _interopRequireDefault(_devicesOther);
	
	var _dock = __webpack_require__(2297);
	
	var _dock2 = _interopRequireDefault(_dock);
	
	var _gamepad = __webpack_require__(2298);
	
	var _gamepad2 = _interopRequireDefault(_gamepad);
	
	var _headsetMic = __webpack_require__(2299);
	
	var _headsetMic2 = _interopRequireDefault(_headsetMic);
	
	var _headset = __webpack_require__(2300);
	
	var _headset2 = _interopRequireDefault(_headset);
	
	var _keyboardArrowDown = __webpack_require__(721);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _keyboardArrowLeft = __webpack_require__(2301);
	
	var _keyboardArrowLeft2 = _interopRequireDefault(_keyboardArrowLeft);
	
	var _keyboardArrowRight = __webpack_require__(2302);
	
	var _keyboardArrowRight2 = _interopRequireDefault(_keyboardArrowRight);
	
	var _keyboardArrowUp = __webpack_require__(722);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardBackspace = __webpack_require__(2303);
	
	var _keyboardBackspace2 = _interopRequireDefault(_keyboardBackspace);
	
	var _keyboardCapslock = __webpack_require__(2304);
	
	var _keyboardCapslock2 = _interopRequireDefault(_keyboardCapslock);
	
	var _keyboardHide = __webpack_require__(2305);
	
	var _keyboardHide2 = _interopRequireDefault(_keyboardHide);
	
	var _keyboardReturn = __webpack_require__(2306);
	
	var _keyboardReturn2 = _interopRequireDefault(_keyboardReturn);
	
	var _keyboardTab = __webpack_require__(2307);
	
	var _keyboardTab2 = _interopRequireDefault(_keyboardTab);
	
	var _keyboardVoice = __webpack_require__(2308);
	
	var _keyboardVoice2 = _interopRequireDefault(_keyboardVoice);
	
	var _keyboard = __webpack_require__(2309);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _laptopChromebook = __webpack_require__(2310);
	
	var _laptopChromebook2 = _interopRequireDefault(_laptopChromebook);
	
	var _laptopMac = __webpack_require__(2311);
	
	var _laptopMac2 = _interopRequireDefault(_laptopMac);
	
	var _laptopWindows = __webpack_require__(2312);
	
	var _laptopWindows2 = _interopRequireDefault(_laptopWindows);
	
	var _laptop = __webpack_require__(2313);
	
	var _laptop2 = _interopRequireDefault(_laptop);
	
	var _memory = __webpack_require__(2314);
	
	var _memory2 = _interopRequireDefault(_memory);
	
	var _mouse = __webpack_require__(2315);
	
	var _mouse2 = _interopRequireDefault(_mouse);
	
	var _phoneAndroid = __webpack_require__(2316);
	
	var _phoneAndroid2 = _interopRequireDefault(_phoneAndroid);
	
	var _phoneIphone = __webpack_require__(2317);
	
	var _phoneIphone2 = _interopRequireDefault(_phoneIphone);
	
	var _phonelinkOff = __webpack_require__(2318);
	
	var _phonelinkOff2 = _interopRequireDefault(_phonelinkOff);
	
	var _phonelink = __webpack_require__(2319);
	
	var _phonelink2 = _interopRequireDefault(_phonelink);
	
	var _powerInput = __webpack_require__(2320);
	
	var _powerInput2 = _interopRequireDefault(_powerInput);
	
	var _router = __webpack_require__(2321);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _scanner = __webpack_require__(2322);
	
	var _scanner2 = _interopRequireDefault(_scanner);
	
	var _security = __webpack_require__(2323);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _simCard = __webpack_require__(2324);
	
	var _simCard2 = _interopRequireDefault(_simCard);
	
	var _smartphone = __webpack_require__(2325);
	
	var _smartphone2 = _interopRequireDefault(_smartphone);
	
	var _speakerGroup = __webpack_require__(2326);
	
	var _speakerGroup2 = _interopRequireDefault(_speakerGroup);
	
	var _speaker = __webpack_require__(2327);
	
	var _speaker2 = _interopRequireDefault(_speaker);
	
	var _tabletAndroid = __webpack_require__(2328);
	
	var _tabletAndroid2 = _interopRequireDefault(_tabletAndroid);
	
	var _tabletMac = __webpack_require__(2329);
	
	var _tabletMac2 = _interopRequireDefault(_tabletMac);
	
	var _tablet = __webpack_require__(2330);
	
	var _tablet2 = _interopRequireDefault(_tablet);
	
	var _toys = __webpack_require__(2331);
	
	var _toys2 = _interopRequireDefault(_toys);
	
	var _tv = __webpack_require__(2332);
	
	var _tv2 = _interopRequireDefault(_tv);
	
	var _videogameAsset = __webpack_require__(2333);
	
	var _videogameAsset2 = _interopRequireDefault(_videogameAsset);
	
	var _watch = __webpack_require__(2334);
	
	var _watch2 = _interopRequireDefault(_watch);
	
	var _addAPhoto = __webpack_require__(2335);
	
	var _addAPhoto2 = _interopRequireDefault(_addAPhoto);
	
	var _addToPhotos = __webpack_require__(2336);
	
	var _addToPhotos2 = _interopRequireDefault(_addToPhotos);
	
	var _adjust = __webpack_require__(2337);
	
	var _adjust2 = _interopRequireDefault(_adjust);
	
	var _assistantPhoto = __webpack_require__(2338);
	
	var _assistantPhoto2 = _interopRequireDefault(_assistantPhoto);
	
	var _assistant = __webpack_require__(2339);
	
	var _assistant2 = _interopRequireDefault(_assistant);
	
	var _audiotrack = __webpack_require__(2340);
	
	var _audiotrack2 = _interopRequireDefault(_audiotrack);
	
	var _blurCircular = __webpack_require__(2341);
	
	var _blurCircular2 = _interopRequireDefault(_blurCircular);
	
	var _blurLinear = __webpack_require__(2342);
	
	var _blurLinear2 = _interopRequireDefault(_blurLinear);
	
	var _blurOff = __webpack_require__(2343);
	
	var _blurOff2 = _interopRequireDefault(_blurOff);
	
	var _blurOn = __webpack_require__(2344);
	
	var _blurOn2 = _interopRequireDefault(_blurOn);
	
	var _brightness = __webpack_require__(2345);
	
	var _brightness2 = _interopRequireDefault(_brightness);
	
	var _brightness3 = __webpack_require__(2346);
	
	var _brightness4 = _interopRequireDefault(_brightness3);
	
	var _brightness5 = __webpack_require__(2347);
	
	var _brightness6 = _interopRequireDefault(_brightness5);
	
	var _brightness7 = __webpack_require__(2348);
	
	var _brightness8 = _interopRequireDefault(_brightness7);
	
	var _brightness9 = __webpack_require__(2349);
	
	var _brightness10 = _interopRequireDefault(_brightness9);
	
	var _brightness11 = __webpack_require__(2350);
	
	var _brightness12 = _interopRequireDefault(_brightness11);
	
	var _brightness13 = __webpack_require__(2351);
	
	var _brightness14 = _interopRequireDefault(_brightness13);
	
	var _brokenImage = __webpack_require__(2352);
	
	var _brokenImage2 = _interopRequireDefault(_brokenImage);
	
	var _brush = __webpack_require__(2353);
	
	var _brush2 = _interopRequireDefault(_brush);
	
	var _burstMode = __webpack_require__(2354);
	
	var _burstMode2 = _interopRequireDefault(_burstMode);
	
	var _cameraAlt = __webpack_require__(2355);
	
	var _cameraAlt2 = _interopRequireDefault(_cameraAlt);
	
	var _cameraFront = __webpack_require__(2356);
	
	var _cameraFront2 = _interopRequireDefault(_cameraFront);
	
	var _cameraRear = __webpack_require__(2357);
	
	var _cameraRear2 = _interopRequireDefault(_cameraRear);
	
	var _cameraRoll = __webpack_require__(2358);
	
	var _cameraRoll2 = _interopRequireDefault(_cameraRoll);
	
	var _camera = __webpack_require__(2359);
	
	var _camera2 = _interopRequireDefault(_camera);
	
	var _centerFocusStrong = __webpack_require__(2360);
	
	var _centerFocusStrong2 = _interopRequireDefault(_centerFocusStrong);
	
	var _centerFocusWeak = __webpack_require__(2361);
	
	var _centerFocusWeak2 = _interopRequireDefault(_centerFocusWeak);
	
	var _collectionsBookmark = __webpack_require__(2362);
	
	var _collectionsBookmark2 = _interopRequireDefault(_collectionsBookmark);
	
	var _collections = __webpack_require__(2363);
	
	var _collections2 = _interopRequireDefault(_collections);
	
	var _colorLens = __webpack_require__(2364);
	
	var _colorLens2 = _interopRequireDefault(_colorLens);
	
	var _colorize = __webpack_require__(2365);
	
	var _colorize2 = _interopRequireDefault(_colorize);
	
	var _compare = __webpack_require__(2366);
	
	var _compare2 = _interopRequireDefault(_compare);
	
	var _controlPointDuplicate = __webpack_require__(2367);
	
	var _controlPointDuplicate2 = _interopRequireDefault(_controlPointDuplicate);
	
	var _controlPoint = __webpack_require__(2368);
	
	var _controlPoint2 = _interopRequireDefault(_controlPoint);
	
	var _crop = __webpack_require__(2369);
	
	var _crop2 = _interopRequireDefault(_crop);
	
	var _crop3 = __webpack_require__(2370);
	
	var _crop4 = _interopRequireDefault(_crop3);
	
	var _crop5 = __webpack_require__(2371);
	
	var _crop6 = _interopRequireDefault(_crop5);
	
	var _crop7 = __webpack_require__(2372);
	
	var _crop8 = _interopRequireDefault(_crop7);
	
	var _cropDin = __webpack_require__(2373);
	
	var _cropDin2 = _interopRequireDefault(_cropDin);
	
	var _cropFree = __webpack_require__(2374);
	
	var _cropFree2 = _interopRequireDefault(_cropFree);
	
	var _cropLandscape = __webpack_require__(2375);
	
	var _cropLandscape2 = _interopRequireDefault(_cropLandscape);
	
	var _cropOriginal = __webpack_require__(2376);
	
	var _cropOriginal2 = _interopRequireDefault(_cropOriginal);
	
	var _cropPortrait = __webpack_require__(2377);
	
	var _cropPortrait2 = _interopRequireDefault(_cropPortrait);
	
	var _cropRotate = __webpack_require__(2378);
	
	var _cropRotate2 = _interopRequireDefault(_cropRotate);
	
	var _cropSquare = __webpack_require__(2379);
	
	var _cropSquare2 = _interopRequireDefault(_cropSquare);
	
	var _crop9 = __webpack_require__(2380);
	
	var _crop10 = _interopRequireDefault(_crop9);
	
	var _dehaze = __webpack_require__(2381);
	
	var _dehaze2 = _interopRequireDefault(_dehaze);
	
	var _details = __webpack_require__(2382);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _edit = __webpack_require__(2383);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _exposureNeg = __webpack_require__(2384);
	
	var _exposureNeg2 = _interopRequireDefault(_exposureNeg);
	
	var _exposureNeg3 = __webpack_require__(2385);
	
	var _exposureNeg4 = _interopRequireDefault(_exposureNeg3);
	
	var _exposurePlus = __webpack_require__(2386);
	
	var _exposurePlus2 = _interopRequireDefault(_exposurePlus);
	
	var _exposurePlus3 = __webpack_require__(2387);
	
	var _exposurePlus4 = _interopRequireDefault(_exposurePlus3);
	
	var _exposureZero = __webpack_require__(2388);
	
	var _exposureZero2 = _interopRequireDefault(_exposureZero);
	
	var _exposure = __webpack_require__(2389);
	
	var _exposure2 = _interopRequireDefault(_exposure);
	
	var _filter = __webpack_require__(2390);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _filter3 = __webpack_require__(2391);
	
	var _filter4 = _interopRequireDefault(_filter3);
	
	var _filter5 = __webpack_require__(2392);
	
	var _filter6 = _interopRequireDefault(_filter5);
	
	var _filter7 = __webpack_require__(2393);
	
	var _filter8 = _interopRequireDefault(_filter7);
	
	var _filter9 = __webpack_require__(2394);
	
	var _filter10 = _interopRequireDefault(_filter9);
	
	var _filter11 = __webpack_require__(2395);
	
	var _filter12 = _interopRequireDefault(_filter11);
	
	var _filter13 = __webpack_require__(2396);
	
	var _filter14 = _interopRequireDefault(_filter13);
	
	var _filter15 = __webpack_require__(2397);
	
	var _filter16 = _interopRequireDefault(_filter15);
	
	var _filter9Plus = __webpack_require__(2398);
	
	var _filter9Plus2 = _interopRequireDefault(_filter9Plus);
	
	var _filter17 = __webpack_require__(2399);
	
	var _filter18 = _interopRequireDefault(_filter17);
	
	var _filterBAndW = __webpack_require__(2400);
	
	var _filterBAndW2 = _interopRequireDefault(_filterBAndW);
	
	var _filterCenterFocus = __webpack_require__(2401);
	
	var _filterCenterFocus2 = _interopRequireDefault(_filterCenterFocus);
	
	var _filterDrama = __webpack_require__(2402);
	
	var _filterDrama2 = _interopRequireDefault(_filterDrama);
	
	var _filterFrames = __webpack_require__(2403);
	
	var _filterFrames2 = _interopRequireDefault(_filterFrames);
	
	var _filterHdr = __webpack_require__(2404);
	
	var _filterHdr2 = _interopRequireDefault(_filterHdr);
	
	var _filterNone = __webpack_require__(2405);
	
	var _filterNone2 = _interopRequireDefault(_filterNone);
	
	var _filterTiltShift = __webpack_require__(2406);
	
	var _filterTiltShift2 = _interopRequireDefault(_filterTiltShift);
	
	var _filterVintage = __webpack_require__(2407);
	
	var _filterVintage2 = _interopRequireDefault(_filterVintage);
	
	var _filter19 = __webpack_require__(2408);
	
	var _filter20 = _interopRequireDefault(_filter19);
	
	var _flare = __webpack_require__(2409);
	
	var _flare2 = _interopRequireDefault(_flare);
	
	var _flashAuto = __webpack_require__(2410);
	
	var _flashAuto2 = _interopRequireDefault(_flashAuto);
	
	var _flashOff = __webpack_require__(2411);
	
	var _flashOff2 = _interopRequireDefault(_flashOff);
	
	var _flashOn = __webpack_require__(2412);
	
	var _flashOn2 = _interopRequireDefault(_flashOn);
	
	var _flip = __webpack_require__(2413);
	
	var _flip2 = _interopRequireDefault(_flip);
	
	var _gradient = __webpack_require__(2414);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _grain = __webpack_require__(2415);
	
	var _grain2 = _interopRequireDefault(_grain);
	
	var _gridOff = __webpack_require__(2416);
	
	var _gridOff2 = _interopRequireDefault(_gridOff);
	
	var _gridOn = __webpack_require__(2417);
	
	var _gridOn2 = _interopRequireDefault(_gridOn);
	
	var _hdrOff = __webpack_require__(2418);
	
	var _hdrOff2 = _interopRequireDefault(_hdrOff);
	
	var _hdrOn = __webpack_require__(2419);
	
	var _hdrOn2 = _interopRequireDefault(_hdrOn);
	
	var _hdrStrong = __webpack_require__(2420);
	
	var _hdrStrong2 = _interopRequireDefault(_hdrStrong);
	
	var _hdrWeak = __webpack_require__(2421);
	
	var _hdrWeak2 = _interopRequireDefault(_hdrWeak);
	
	var _healing = __webpack_require__(2422);
	
	var _healing2 = _interopRequireDefault(_healing);
	
	var _imageAspectRatio = __webpack_require__(2423);
	
	var _imageAspectRatio2 = _interopRequireDefault(_imageAspectRatio);
	
	var _image = __webpack_require__(2424);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _iso = __webpack_require__(2425);
	
	var _iso2 = _interopRequireDefault(_iso);
	
	var _landscape = __webpack_require__(2426);
	
	var _landscape2 = _interopRequireDefault(_landscape);
	
	var _leakAdd = __webpack_require__(2427);
	
	var _leakAdd2 = _interopRequireDefault(_leakAdd);
	
	var _leakRemove = __webpack_require__(2428);
	
	var _leakRemove2 = _interopRequireDefault(_leakRemove);
	
	var _lens = __webpack_require__(2429);
	
	var _lens2 = _interopRequireDefault(_lens);
	
	var _linkedCamera = __webpack_require__(2430);
	
	var _linkedCamera2 = _interopRequireDefault(_linkedCamera);
	
	var _looks = __webpack_require__(2431);
	
	var _looks2 = _interopRequireDefault(_looks);
	
	var _looks3 = __webpack_require__(2432);
	
	var _looks4 = _interopRequireDefault(_looks3);
	
	var _looks5 = __webpack_require__(2433);
	
	var _looks6 = _interopRequireDefault(_looks5);
	
	var _looks7 = __webpack_require__(2434);
	
	var _looks8 = _interopRequireDefault(_looks7);
	
	var _looksOne = __webpack_require__(2435);
	
	var _looksOne2 = _interopRequireDefault(_looksOne);
	
	var _looksTwo = __webpack_require__(2436);
	
	var _looksTwo2 = _interopRequireDefault(_looksTwo);
	
	var _looks9 = __webpack_require__(2437);
	
	var _looks10 = _interopRequireDefault(_looks9);
	
	var _loupe = __webpack_require__(2438);
	
	var _loupe2 = _interopRequireDefault(_loupe);
	
	var _monochromePhotos = __webpack_require__(2439);
	
	var _monochromePhotos2 = _interopRequireDefault(_monochromePhotos);
	
	var _movieCreation = __webpack_require__(2440);
	
	var _movieCreation2 = _interopRequireDefault(_movieCreation);
	
	var _movieFilter = __webpack_require__(2441);
	
	var _movieFilter2 = _interopRequireDefault(_movieFilter);
	
	var _musicNote = __webpack_require__(2442);
	
	var _musicNote2 = _interopRequireDefault(_musicNote);
	
	var _naturePeople = __webpack_require__(2443);
	
	var _naturePeople2 = _interopRequireDefault(_naturePeople);
	
	var _nature = __webpack_require__(2444);
	
	var _nature2 = _interopRequireDefault(_nature);
	
	var _navigateBefore = __webpack_require__(2445);
	
	var _navigateBefore2 = _interopRequireDefault(_navigateBefore);
	
	var _navigateNext = __webpack_require__(2446);
	
	var _navigateNext2 = _interopRequireDefault(_navigateNext);
	
	var _palette = __webpack_require__(2447);
	
	var _palette2 = _interopRequireDefault(_palette);
	
	var _panoramaFishEye = __webpack_require__(2448);
	
	var _panoramaFishEye2 = _interopRequireDefault(_panoramaFishEye);
	
	var _panoramaHorizontal = __webpack_require__(2449);
	
	var _panoramaHorizontal2 = _interopRequireDefault(_panoramaHorizontal);
	
	var _panoramaVertical = __webpack_require__(2450);
	
	var _panoramaVertical2 = _interopRequireDefault(_panoramaVertical);
	
	var _panoramaWideAngle = __webpack_require__(2451);
	
	var _panoramaWideAngle2 = _interopRequireDefault(_panoramaWideAngle);
	
	var _panorama = __webpack_require__(2452);
	
	var _panorama2 = _interopRequireDefault(_panorama);
	
	var _photoAlbum = __webpack_require__(2453);
	
	var _photoAlbum2 = _interopRequireDefault(_photoAlbum);
	
	var _photoCamera = __webpack_require__(2454);
	
	var _photoCamera2 = _interopRequireDefault(_photoCamera);
	
	var _photoFilter = __webpack_require__(2455);
	
	var _photoFilter2 = _interopRequireDefault(_photoFilter);
	
	var _photoLibrary = __webpack_require__(2456);
	
	var _photoLibrary2 = _interopRequireDefault(_photoLibrary);
	
	var _photoSizeSelectActual = __webpack_require__(2457);
	
	var _photoSizeSelectActual2 = _interopRequireDefault(_photoSizeSelectActual);
	
	var _photoSizeSelectLarge = __webpack_require__(2458);
	
	var _photoSizeSelectLarge2 = _interopRequireDefault(_photoSizeSelectLarge);
	
	var _photoSizeSelectSmall = __webpack_require__(2459);
	
	var _photoSizeSelectSmall2 = _interopRequireDefault(_photoSizeSelectSmall);
	
	var _photo = __webpack_require__(2460);
	
	var _photo2 = _interopRequireDefault(_photo);
	
	var _pictureAsPdf = __webpack_require__(2461);
	
	var _pictureAsPdf2 = _interopRequireDefault(_pictureAsPdf);
	
	var _portrait = __webpack_require__(2462);
	
	var _portrait2 = _interopRequireDefault(_portrait);
	
	var _removeRedEye = __webpack_require__(2463);
	
	var _removeRedEye2 = _interopRequireDefault(_removeRedEye);
	
	var _rotate90DegreesCcw = __webpack_require__(2464);
	
	var _rotate90DegreesCcw2 = _interopRequireDefault(_rotate90DegreesCcw);
	
	var _rotateLeft = __webpack_require__(2465);
	
	var _rotateLeft2 = _interopRequireDefault(_rotateLeft);
	
	var _rotateRight = __webpack_require__(2466);
	
	var _rotateRight2 = _interopRequireDefault(_rotateRight);
	
	var _slideshow = __webpack_require__(2467);
	
	var _slideshow2 = _interopRequireDefault(_slideshow);
	
	var _straighten = __webpack_require__(2468);
	
	var _straighten2 = _interopRequireDefault(_straighten);
	
	var _style = __webpack_require__(2469);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _switchCamera = __webpack_require__(2470);
	
	var _switchCamera2 = _interopRequireDefault(_switchCamera);
	
	var _switchVideo = __webpack_require__(2471);
	
	var _switchVideo2 = _interopRequireDefault(_switchVideo);
	
	var _tagFaces = __webpack_require__(2472);
	
	var _tagFaces2 = _interopRequireDefault(_tagFaces);
	
	var _texture = __webpack_require__(2473);
	
	var _texture2 = _interopRequireDefault(_texture);
	
	var _timelapse = __webpack_require__(2474);
	
	var _timelapse2 = _interopRequireDefault(_timelapse);
	
	var _timer = __webpack_require__(2475);
	
	var _timer2 = _interopRequireDefault(_timer);
	
	var _timer3 = __webpack_require__(2476);
	
	var _timer4 = _interopRequireDefault(_timer3);
	
	var _timerOff = __webpack_require__(2477);
	
	var _timerOff2 = _interopRequireDefault(_timerOff);
	
	var _timer5 = __webpack_require__(2478);
	
	var _timer6 = _interopRequireDefault(_timer5);
	
	var _tonality = __webpack_require__(2479);
	
	var _tonality2 = _interopRequireDefault(_tonality);
	
	var _transform = __webpack_require__(2480);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	var _tune = __webpack_require__(2481);
	
	var _tune2 = _interopRequireDefault(_tune);
	
	var _viewComfy = __webpack_require__(2482);
	
	var _viewComfy2 = _interopRequireDefault(_viewComfy);
	
	var _viewCompact = __webpack_require__(2483);
	
	var _viewCompact2 = _interopRequireDefault(_viewCompact);
	
	var _vignette = __webpack_require__(2484);
	
	var _vignette2 = _interopRequireDefault(_vignette);
	
	var _wbAuto = __webpack_require__(2485);
	
	var _wbAuto2 = _interopRequireDefault(_wbAuto);
	
	var _wbCloudy = __webpack_require__(2486);
	
	var _wbCloudy2 = _interopRequireDefault(_wbCloudy);
	
	var _wbIncandescent = __webpack_require__(2487);
	
	var _wbIncandescent2 = _interopRequireDefault(_wbIncandescent);
	
	var _wbIridescent = __webpack_require__(2488);
	
	var _wbIridescent2 = _interopRequireDefault(_wbIridescent);
	
	var _wbSunny = __webpack_require__(2489);
	
	var _wbSunny2 = _interopRequireDefault(_wbSunny);
	
	var _addLocation = __webpack_require__(2491);
	
	var _addLocation2 = _interopRequireDefault(_addLocation);
	
	var _beenhere = __webpack_require__(2492);
	
	var _beenhere2 = _interopRequireDefault(_beenhere);
	
	var _directionsBike = __webpack_require__(2493);
	
	var _directionsBike2 = _interopRequireDefault(_directionsBike);
	
	var _directionsBoat = __webpack_require__(2494);
	
	var _directionsBoat2 = _interopRequireDefault(_directionsBoat);
	
	var _directionsBus = __webpack_require__(2495);
	
	var _directionsBus2 = _interopRequireDefault(_directionsBus);
	
	var _directionsCar = __webpack_require__(2496);
	
	var _directionsCar2 = _interopRequireDefault(_directionsCar);
	
	var _directionsRailway = __webpack_require__(2497);
	
	var _directionsRailway2 = _interopRequireDefault(_directionsRailway);
	
	var _directionsRun = __webpack_require__(2498);
	
	var _directionsRun2 = _interopRequireDefault(_directionsRun);
	
	var _directionsSubway = __webpack_require__(2499);
	
	var _directionsSubway2 = _interopRequireDefault(_directionsSubway);
	
	var _directionsTransit = __webpack_require__(2500);
	
	var _directionsTransit2 = _interopRequireDefault(_directionsTransit);
	
	var _directionsWalk = __webpack_require__(2501);
	
	var _directionsWalk2 = _interopRequireDefault(_directionsWalk);
	
	var _directions = __webpack_require__(2502);
	
	var _directions2 = _interopRequireDefault(_directions);
	
	var _editLocation = __webpack_require__(2503);
	
	var _editLocation2 = _interopRequireDefault(_editLocation);
	
	var _evStation = __webpack_require__(2504);
	
	var _evStation2 = _interopRequireDefault(_evStation);
	
	var _flight = __webpack_require__(2505);
	
	var _flight2 = _interopRequireDefault(_flight);
	
	var _hotel = __webpack_require__(2506);
	
	var _hotel2 = _interopRequireDefault(_hotel);
	
	var _layersClear = __webpack_require__(2507);
	
	var _layersClear2 = _interopRequireDefault(_layersClear);
	
	var _layers = __webpack_require__(2508);
	
	var _layers2 = _interopRequireDefault(_layers);
	
	var _localActivity = __webpack_require__(2509);
	
	var _localActivity2 = _interopRequireDefault(_localActivity);
	
	var _localAirport = __webpack_require__(2510);
	
	var _localAirport2 = _interopRequireDefault(_localAirport);
	
	var _localAtm = __webpack_require__(2511);
	
	var _localAtm2 = _interopRequireDefault(_localAtm);
	
	var _localBar = __webpack_require__(2512);
	
	var _localBar2 = _interopRequireDefault(_localBar);
	
	var _localCafe = __webpack_require__(2513);
	
	var _localCafe2 = _interopRequireDefault(_localCafe);
	
	var _localCarWash = __webpack_require__(2514);
	
	var _localCarWash2 = _interopRequireDefault(_localCarWash);
	
	var _localConvenienceStore = __webpack_require__(2515);
	
	var _localConvenienceStore2 = _interopRequireDefault(_localConvenienceStore);
	
	var _localDining = __webpack_require__(2516);
	
	var _localDining2 = _interopRequireDefault(_localDining);
	
	var _localDrink = __webpack_require__(2517);
	
	var _localDrink2 = _interopRequireDefault(_localDrink);
	
	var _localFlorist = __webpack_require__(2518);
	
	var _localFlorist2 = _interopRequireDefault(_localFlorist);
	
	var _localGasStation = __webpack_require__(2519);
	
	var _localGasStation2 = _interopRequireDefault(_localGasStation);
	
	var _localGroceryStore = __webpack_require__(2520);
	
	var _localGroceryStore2 = _interopRequireDefault(_localGroceryStore);
	
	var _localHospital = __webpack_require__(2521);
	
	var _localHospital2 = _interopRequireDefault(_localHospital);
	
	var _localHotel = __webpack_require__(2522);
	
	var _localHotel2 = _interopRequireDefault(_localHotel);
	
	var _localLaundryService = __webpack_require__(2523);
	
	var _localLaundryService2 = _interopRequireDefault(_localLaundryService);
	
	var _localLibrary = __webpack_require__(2524);
	
	var _localLibrary2 = _interopRequireDefault(_localLibrary);
	
	var _localMall = __webpack_require__(2525);
	
	var _localMall2 = _interopRequireDefault(_localMall);
	
	var _localMovies = __webpack_require__(2526);
	
	var _localMovies2 = _interopRequireDefault(_localMovies);
	
	var _localOffer = __webpack_require__(2527);
	
	var _localOffer2 = _interopRequireDefault(_localOffer);
	
	var _localParking = __webpack_require__(2528);
	
	var _localParking2 = _interopRequireDefault(_localParking);
	
	var _localPharmacy = __webpack_require__(2529);
	
	var _localPharmacy2 = _interopRequireDefault(_localPharmacy);
	
	var _localPhone = __webpack_require__(2530);
	
	var _localPhone2 = _interopRequireDefault(_localPhone);
	
	var _localPizza = __webpack_require__(2531);
	
	var _localPizza2 = _interopRequireDefault(_localPizza);
	
	var _localPlay = __webpack_require__(2532);
	
	var _localPlay2 = _interopRequireDefault(_localPlay);
	
	var _localPostOffice = __webpack_require__(2533);
	
	var _localPostOffice2 = _interopRequireDefault(_localPostOffice);
	
	var _localPrintshop = __webpack_require__(2534);
	
	var _localPrintshop2 = _interopRequireDefault(_localPrintshop);
	
	var _localSee = __webpack_require__(2535);
	
	var _localSee2 = _interopRequireDefault(_localSee);
	
	var _localShipping = __webpack_require__(2536);
	
	var _localShipping2 = _interopRequireDefault(_localShipping);
	
	var _localTaxi = __webpack_require__(2537);
	
	var _localTaxi2 = _interopRequireDefault(_localTaxi);
	
	var _map = __webpack_require__(2538);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _myLocation = __webpack_require__(2539);
	
	var _myLocation2 = _interopRequireDefault(_myLocation);
	
	var _navigation = __webpack_require__(2540);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _nearMe = __webpack_require__(2541);
	
	var _nearMe2 = _interopRequireDefault(_nearMe);
	
	var _personPinCircle = __webpack_require__(2542);
	
	var _personPinCircle2 = _interopRequireDefault(_personPinCircle);
	
	var _personPin = __webpack_require__(2543);
	
	var _personPin2 = _interopRequireDefault(_personPin);
	
	var _pinDrop = __webpack_require__(2544);
	
	var _pinDrop2 = _interopRequireDefault(_pinDrop);
	
	var _place = __webpack_require__(2545);
	
	var _place2 = _interopRequireDefault(_place);
	
	var _rateReview = __webpack_require__(2546);
	
	var _rateReview2 = _interopRequireDefault(_rateReview);
	
	var _restaurantMenu = __webpack_require__(2547);
	
	var _restaurantMenu2 = _interopRequireDefault(_restaurantMenu);
	
	var _restaurant = __webpack_require__(2548);
	
	var _restaurant2 = _interopRequireDefault(_restaurant);
	
	var _satellite = __webpack_require__(2549);
	
	var _satellite2 = _interopRequireDefault(_satellite);
	
	var _storeMallDirectory = __webpack_require__(2550);
	
	var _storeMallDirectory2 = _interopRequireDefault(_storeMallDirectory);
	
	var _streetview = __webpack_require__(2551);
	
	var _streetview2 = _interopRequireDefault(_streetview);
	
	var _subway = __webpack_require__(2552);
	
	var _subway2 = _interopRequireDefault(_subway);
	
	var _terrain = __webpack_require__(2553);
	
	var _terrain2 = _interopRequireDefault(_terrain);
	
	var _traffic = __webpack_require__(2554);
	
	var _traffic2 = _interopRequireDefault(_traffic);
	
	var _train = __webpack_require__(2555);
	
	var _train2 = _interopRequireDefault(_train);
	
	var _tram = __webpack_require__(2556);
	
	var _tram2 = _interopRequireDefault(_tram);
	
	var _transferWithinAStation = __webpack_require__(2557);
	
	var _transferWithinAStation2 = _interopRequireDefault(_transferWithinAStation);
	
	var _zoomOutMap = __webpack_require__(2558);
	
	var _zoomOutMap2 = _interopRequireDefault(_zoomOutMap);
	
	var _apps = __webpack_require__(2560);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _arrowBack = __webpack_require__(2561);
	
	var _arrowBack2 = _interopRequireDefault(_arrowBack);
	
	var _arrowDownward = __webpack_require__(2562);
	
	var _arrowDownward2 = _interopRequireDefault(_arrowDownward);
	
	var _arrowDropDownCircle = __webpack_require__(2563);
	
	var _arrowDropDownCircle2 = _interopRequireDefault(_arrowDropDownCircle);
	
	var _arrowDropDown = __webpack_require__(68);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(74);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _arrowForward = __webpack_require__(2564);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _arrowUpward = __webpack_require__(2565);
	
	var _arrowUpward2 = _interopRequireDefault(_arrowUpward);
	
	var _cancel = __webpack_require__(723);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	var _check = __webpack_require__(724);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _chevronLeft = __webpack_require__(725);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(726);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _close = __webpack_require__(727);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _expandLess = __webpack_require__(728);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(729);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _firstPage = __webpack_require__(2566);
	
	var _firstPage2 = _interopRequireDefault(_firstPage);
	
	var _fullscreenExit = __webpack_require__(2567);
	
	var _fullscreenExit2 = _interopRequireDefault(_fullscreenExit);
	
	var _fullscreen = __webpack_require__(2568);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _lastPage = __webpack_require__(2569);
	
	var _lastPage2 = _interopRequireDefault(_lastPage);
	
	var _menu = __webpack_require__(730);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _moreHoriz = __webpack_require__(434);
	
	var _moreHoriz2 = _interopRequireDefault(_moreHoriz);
	
	var _moreVert = __webpack_require__(2570);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _refresh = __webpack_require__(2571);
	
	var _refresh2 = _interopRequireDefault(_refresh);
	
	var _subdirectoryArrowLeft = __webpack_require__(2572);
	
	var _subdirectoryArrowLeft2 = _interopRequireDefault(_subdirectoryArrowLeft);
	
	var _subdirectoryArrowRight = __webpack_require__(2573);
	
	var _subdirectoryArrowRight2 = _interopRequireDefault(_subdirectoryArrowRight);
	
	var _unfoldLess = __webpack_require__(2574);
	
	var _unfoldLess2 = _interopRequireDefault(_unfoldLess);
	
	var _unfoldMore = __webpack_require__(2575);
	
	var _unfoldMore2 = _interopRequireDefault(_unfoldMore);
	
	var _navigationArrowDropRight = __webpack_require__(2559);
	
	var _navigationArrowDropRight2 = _interopRequireDefault(_navigationArrowDropRight);
	
	var _adb = __webpack_require__(2576);
	
	var _adb2 = _interopRequireDefault(_adb);
	
	var _airlineSeatFlatAngled = __webpack_require__(2577);
	
	var _airlineSeatFlatAngled2 = _interopRequireDefault(_airlineSeatFlatAngled);
	
	var _airlineSeatFlat = __webpack_require__(2578);
	
	var _airlineSeatFlat2 = _interopRequireDefault(_airlineSeatFlat);
	
	var _airlineSeatIndividualSuite = __webpack_require__(2579);
	
	var _airlineSeatIndividualSuite2 = _interopRequireDefault(_airlineSeatIndividualSuite);
	
	var _airlineSeatLegroomExtra = __webpack_require__(2580);
	
	var _airlineSeatLegroomExtra2 = _interopRequireDefault(_airlineSeatLegroomExtra);
	
	var _airlineSeatLegroomNormal = __webpack_require__(2581);
	
	var _airlineSeatLegroomNormal2 = _interopRequireDefault(_airlineSeatLegroomNormal);
	
	var _airlineSeatLegroomReduced = __webpack_require__(2582);
	
	var _airlineSeatLegroomReduced2 = _interopRequireDefault(_airlineSeatLegroomReduced);
	
	var _airlineSeatReclineExtra = __webpack_require__(2583);
	
	var _airlineSeatReclineExtra2 = _interopRequireDefault(_airlineSeatReclineExtra);
	
	var _airlineSeatReclineNormal = __webpack_require__(2584);
	
	var _airlineSeatReclineNormal2 = _interopRequireDefault(_airlineSeatReclineNormal);
	
	var _bluetoothAudio = __webpack_require__(2585);
	
	var _bluetoothAudio2 = _interopRequireDefault(_bluetoothAudio);
	
	var _confirmationNumber = __webpack_require__(2586);
	
	var _confirmationNumber2 = _interopRequireDefault(_confirmationNumber);
	
	var _discFull = __webpack_require__(2587);
	
	var _discFull2 = _interopRequireDefault(_discFull);
	
	var _doNotDisturbAlt = __webpack_require__(2588);
	
	var _doNotDisturbAlt2 = _interopRequireDefault(_doNotDisturbAlt);
	
	var _doNotDisturbOff = __webpack_require__(2589);
	
	var _doNotDisturbOff2 = _interopRequireDefault(_doNotDisturbOff);
	
	var _doNotDisturbOn = __webpack_require__(2590);
	
	var _doNotDisturbOn2 = _interopRequireDefault(_doNotDisturbOn);
	
	var _doNotDisturb = __webpack_require__(2591);
	
	var _doNotDisturb2 = _interopRequireDefault(_doNotDisturb);
	
	var _driveEta = __webpack_require__(2592);
	
	var _driveEta2 = _interopRequireDefault(_driveEta);
	
	var _enhancedEncryption = __webpack_require__(2593);
	
	var _enhancedEncryption2 = _interopRequireDefault(_enhancedEncryption);
	
	var _eventAvailable = __webpack_require__(2594);
	
	var _eventAvailable2 = _interopRequireDefault(_eventAvailable);
	
	var _eventBusy = __webpack_require__(2595);
	
	var _eventBusy2 = _interopRequireDefault(_eventBusy);
	
	var _eventNote = __webpack_require__(2596);
	
	var _eventNote2 = _interopRequireDefault(_eventNote);
	
	var _folderSpecial = __webpack_require__(2597);
	
	var _folderSpecial2 = _interopRequireDefault(_folderSpecial);
	
	var _liveTv = __webpack_require__(2598);
	
	var _liveTv2 = _interopRequireDefault(_liveTv);
	
	var _mms = __webpack_require__(2599);
	
	var _mms2 = _interopRequireDefault(_mms);
	
	var _more = __webpack_require__(2600);
	
	var _more2 = _interopRequireDefault(_more);
	
	var _networkCheck = __webpack_require__(2601);
	
	var _networkCheck2 = _interopRequireDefault(_networkCheck);
	
	var _networkLocked = __webpack_require__(2602);
	
	var _networkLocked2 = _interopRequireDefault(_networkLocked);
	
	var _noEncryption = __webpack_require__(2603);
	
	var _noEncryption2 = _interopRequireDefault(_noEncryption);
	
	var _ondemandVideo = __webpack_require__(2604);
	
	var _ondemandVideo2 = _interopRequireDefault(_ondemandVideo);
	
	var _personalVideo = __webpack_require__(2605);
	
	var _personalVideo2 = _interopRequireDefault(_personalVideo);
	
	var _phoneBluetoothSpeaker = __webpack_require__(2606);
	
	var _phoneBluetoothSpeaker2 = _interopRequireDefault(_phoneBluetoothSpeaker);
	
	var _phoneForwarded = __webpack_require__(2607);
	
	var _phoneForwarded2 = _interopRequireDefault(_phoneForwarded);
	
	var _phoneInTalk = __webpack_require__(2608);
	
	var _phoneInTalk2 = _interopRequireDefault(_phoneInTalk);
	
	var _phoneLocked = __webpack_require__(2609);
	
	var _phoneLocked2 = _interopRequireDefault(_phoneLocked);
	
	var _phoneMissed = __webpack_require__(2610);
	
	var _phoneMissed2 = _interopRequireDefault(_phoneMissed);
	
	var _phonePaused = __webpack_require__(2611);
	
	var _phonePaused2 = _interopRequireDefault(_phonePaused);
	
	var _power = __webpack_require__(2612);
	
	var _power2 = _interopRequireDefault(_power);
	
	var _priorityHigh = __webpack_require__(2613);
	
	var _priorityHigh2 = _interopRequireDefault(_priorityHigh);
	
	var _rvHookup = __webpack_require__(2614);
	
	var _rvHookup2 = _interopRequireDefault(_rvHookup);
	
	var _sdCard = __webpack_require__(2615);
	
	var _sdCard2 = _interopRequireDefault(_sdCard);
	
	var _simCardAlert = __webpack_require__(2616);
	
	var _simCardAlert2 = _interopRequireDefault(_simCardAlert);
	
	var _smsFailed = __webpack_require__(2617);
	
	var _smsFailed2 = _interopRequireDefault(_smsFailed);
	
	var _sms = __webpack_require__(2618);
	
	var _sms2 = _interopRequireDefault(_sms);
	
	var _syncDisabled = __webpack_require__(2619);
	
	var _syncDisabled2 = _interopRequireDefault(_syncDisabled);
	
	var _syncProblem = __webpack_require__(2620);
	
	var _syncProblem2 = _interopRequireDefault(_syncProblem);
	
	var _sync = __webpack_require__(2621);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _systemUpdate = __webpack_require__(2622);
	
	var _systemUpdate2 = _interopRequireDefault(_systemUpdate);
	
	var _tapAndPlay = __webpack_require__(2623);
	
	var _tapAndPlay2 = _interopRequireDefault(_tapAndPlay);
	
	var _timeToLeave = __webpack_require__(2624);
	
	var _timeToLeave2 = _interopRequireDefault(_timeToLeave);
	
	var _vibration = __webpack_require__(2625);
	
	var _vibration2 = _interopRequireDefault(_vibration);
	
	var _voiceChat = __webpack_require__(2626);
	
	var _voiceChat2 = _interopRequireDefault(_voiceChat);
	
	var _vpnLock = __webpack_require__(2627);
	
	var _vpnLock2 = _interopRequireDefault(_vpnLock);
	
	var _wc = __webpack_require__(2628);
	
	var _wc2 = _interopRequireDefault(_wc);
	
	var _wifi = __webpack_require__(2629);
	
	var _wifi2 = _interopRequireDefault(_wifi);
	
	var _acUnit = __webpack_require__(2630);
	
	var _acUnit2 = _interopRequireDefault(_acUnit);
	
	var _airportShuttle = __webpack_require__(2631);
	
	var _airportShuttle2 = _interopRequireDefault(_airportShuttle);
	
	var _allInclusive = __webpack_require__(2632);
	
	var _allInclusive2 = _interopRequireDefault(_allInclusive);
	
	var _beachAccess = __webpack_require__(2633);
	
	var _beachAccess2 = _interopRequireDefault(_beachAccess);
	
	var _businessCenter = __webpack_require__(2634);
	
	var _businessCenter2 = _interopRequireDefault(_businessCenter);
	
	var _casino = __webpack_require__(2635);
	
	var _casino2 = _interopRequireDefault(_casino);
	
	var _childCare = __webpack_require__(2636);
	
	var _childCare2 = _interopRequireDefault(_childCare);
	
	var _childFriendly = __webpack_require__(2637);
	
	var _childFriendly2 = _interopRequireDefault(_childFriendly);
	
	var _fitnessCenter = __webpack_require__(2638);
	
	var _fitnessCenter2 = _interopRequireDefault(_fitnessCenter);
	
	var _freeBreakfast = __webpack_require__(2639);
	
	var _freeBreakfast2 = _interopRequireDefault(_freeBreakfast);
	
	var _golfCourse = __webpack_require__(2640);
	
	var _golfCourse2 = _interopRequireDefault(_golfCourse);
	
	var _hotTub = __webpack_require__(2641);
	
	var _hotTub2 = _interopRequireDefault(_hotTub);
	
	var _kitchen = __webpack_require__(2642);
	
	var _kitchen2 = _interopRequireDefault(_kitchen);
	
	var _pool = __webpack_require__(2643);
	
	var _pool2 = _interopRequireDefault(_pool);
	
	var _roomService = __webpack_require__(2644);
	
	var _roomService2 = _interopRequireDefault(_roomService);
	
	var _rvHookup3 = __webpack_require__(2645);
	
	var _rvHookup4 = _interopRequireDefault(_rvHookup3);
	
	var _smokeFree = __webpack_require__(2646);
	
	var _smokeFree2 = _interopRequireDefault(_smokeFree);
	
	var _smokingRooms = __webpack_require__(2647);
	
	var _smokingRooms2 = _interopRequireDefault(_smokingRooms);
	
	var _spa = __webpack_require__(2648);
	
	var _spa2 = _interopRequireDefault(_spa);
	
	var _cake = __webpack_require__(2649);
	
	var _cake2 = _interopRequireDefault(_cake);
	
	var _domain = __webpack_require__(2650);
	
	var _domain2 = _interopRequireDefault(_domain);
	
	var _groupAdd = __webpack_require__(2651);
	
	var _groupAdd2 = _interopRequireDefault(_groupAdd);
	
	var _group = __webpack_require__(2652);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _locationCity = __webpack_require__(2653);
	
	var _locationCity2 = _interopRequireDefault(_locationCity);
	
	var _moodBad = __webpack_require__(2654);
	
	var _moodBad2 = _interopRequireDefault(_moodBad);
	
	var _mood = __webpack_require__(2655);
	
	var _mood2 = _interopRequireDefault(_mood);
	
	var _notificationsActive = __webpack_require__(2656);
	
	var _notificationsActive2 = _interopRequireDefault(_notificationsActive);
	
	var _notificationsNone = __webpack_require__(2657);
	
	var _notificationsNone2 = _interopRequireDefault(_notificationsNone);
	
	var _notificationsOff = __webpack_require__(2658);
	
	var _notificationsOff2 = _interopRequireDefault(_notificationsOff);
	
	var _notificationsPaused = __webpack_require__(2659);
	
	var _notificationsPaused2 = _interopRequireDefault(_notificationsPaused);
	
	var _notifications = __webpack_require__(2660);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _pages = __webpack_require__(2661);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _partyMode = __webpack_require__(2662);
	
	var _partyMode2 = _interopRequireDefault(_partyMode);
	
	var _peopleOutline = __webpack_require__(2663);
	
	var _peopleOutline2 = _interopRequireDefault(_peopleOutline);
	
	var _people = __webpack_require__(2664);
	
	var _people2 = _interopRequireDefault(_people);
	
	var _personAdd = __webpack_require__(2665);
	
	var _personAdd2 = _interopRequireDefault(_personAdd);
	
	var _personOutline = __webpack_require__(2666);
	
	var _personOutline2 = _interopRequireDefault(_personOutline);
	
	var _person = __webpack_require__(2667);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _plusOne = __webpack_require__(2668);
	
	var _plusOne2 = _interopRequireDefault(_plusOne);
	
	var _poll = __webpack_require__(2669);
	
	var _poll2 = _interopRequireDefault(_poll);
	
	var _public = __webpack_require__(2670);
	
	var _public2 = _interopRequireDefault(_public);
	
	var _school = __webpack_require__(2671);
	
	var _school2 = _interopRequireDefault(_school);
	
	var _sentimentDissatisfied = __webpack_require__(2672);
	
	var _sentimentDissatisfied2 = _interopRequireDefault(_sentimentDissatisfied);
	
	var _sentimentNeutral = __webpack_require__(2673);
	
	var _sentimentNeutral2 = _interopRequireDefault(_sentimentNeutral);
	
	var _sentimentSatisfied = __webpack_require__(2674);
	
	var _sentimentSatisfied2 = _interopRequireDefault(_sentimentSatisfied);
	
	var _sentimentVeryDissatisfied = __webpack_require__(2675);
	
	var _sentimentVeryDissatisfied2 = _interopRequireDefault(_sentimentVeryDissatisfied);
	
	var _sentimentVerySatisfied = __webpack_require__(2676);
	
	var _sentimentVerySatisfied2 = _interopRequireDefault(_sentimentVerySatisfied);
	
	var _share = __webpack_require__(2677);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _whatshot = __webpack_require__(2678);
	
	var _whatshot2 = _interopRequireDefault(_whatshot);
	
	var _checkBoxOutlineBlank = __webpack_require__(731);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(732);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	var _indeterminateCheckBox = __webpack_require__(2679);
	
	var _indeterminateCheckBox2 = _interopRequireDefault(_indeterminateCheckBox);
	
	var _radioButtonChecked = __webpack_require__(733);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	var _radioButtonUnchecked = __webpack_require__(734);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _starBorder = __webpack_require__(2680);
	
	var _starBorder2 = _interopRequireDefault(_starBorder);
	
	var _starHalf = __webpack_require__(2681);
	
	var _starHalf2 = _interopRequireDefault(_starHalf);
	
	var _star = __webpack_require__(2682);
	
	var _star2 = _interopRequireDefault(_star);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ActionAccessibility = _accessibility2.default;
	exports.ActionAccessible = _accessible2.default;
	exports.ActionAccountBalanceWallet = _accountBalanceWallet2.default;
	exports.ActionAccountBalance = _accountBalance2.default;
	exports.ActionAccountBox = _accountBox2.default;
	exports.ActionAccountCircle = _accountCircle2.default;
	exports.ActionAddShoppingCart = _addShoppingCart2.default;
	exports.ActionAlarmAdd = _alarmAdd2.default;
	exports.ActionAlarmOff = _alarmOff2.default;
	exports.ActionAlarmOn = _alarmOn2.default;
	exports.ActionAlarm = _alarm2.default;
	exports.ActionAllOut = _allOut2.default;
	exports.ActionAndroid = _android2.default;
	exports.ActionAnnouncement = _announcement2.default;
	exports.ActionAspectRatio = _aspectRatio2.default;
	exports.ActionAssessment = _assessment2.default;
	exports.ActionAssignmentInd = _assignmentInd2.default;
	exports.ActionAssignmentLate = _assignmentLate2.default;
	exports.ActionAssignmentReturn = _assignmentReturn2.default;
	exports.ActionAssignmentReturned = _assignmentReturned2.default;
	exports.ActionAssignmentTurnedIn = _assignmentTurnedIn2.default;
	exports.ActionAssignment = _assignment2.default;
	exports.ActionAutorenew = _autorenew2.default;
	exports.ActionBackup = _backup2.default;
	exports.ActionBook = _book2.default;
	exports.ActionBookmarkBorder = _bookmarkBorder2.default;
	exports.ActionBookmark = _bookmark2.default;
	exports.ActionBugReport = _bugReport2.default;
	exports.ActionBuild = _build2.default;
	exports.ActionCached = _cached2.default;
	exports.ActionCameraEnhance = _cameraEnhance2.default;
	exports.ActionCardGiftcard = _cardGiftcard2.default;
	exports.ActionCardMembership = _cardMembership2.default;
	exports.ActionCardTravel = _cardTravel2.default;
	exports.ActionChangeHistory = _changeHistory2.default;
	exports.ActionCheckCircle = _checkCircle2.default;
	exports.ActionChromeReaderMode = _chromeReaderMode2.default;
	exports.ActionClass = _class2.default;
	exports.ActionCode = _code2.default;
	exports.ActionCompareArrows = _compareArrows2.default;
	exports.ActionCopyright = _copyright2.default;
	exports.ActionCreditCard = _creditCard2.default;
	exports.ActionDashboard = _dashboard2.default;
	exports.ActionDateRange = _dateRange2.default;
	exports.ActionDeleteForever = _deleteForever2.default;
	exports.ActionDelete = _delete2.default;
	exports.ActionDescription = _description2.default;
	exports.ActionDns = _dns2.default;
	exports.ActionDoneAll = _doneAll2.default;
	exports.ActionDone = _done2.default;
	exports.ActionDonutLarge = _donutLarge2.default;
	exports.ActionDonutSmall = _donutSmall2.default;
	exports.ActionEject = _eject2.default;
	exports.ActionEuroSymbol = _euroSymbol2.default;
	exports.ActionEventSeat = _eventSeat2.default;
	exports.ActionEvent = _event2.default;
	exports.ActionExitToApp = _exitToApp2.default;
	exports.ActionExplore = _explore2.default;
	exports.ActionExtension = _extension2.default;
	exports.ActionFace = _face2.default;
	exports.ActionFavoriteBorder = _favoriteBorder2.default;
	exports.ActionFavorite = _favorite2.default;
	exports.ActionFeedback = _feedback2.default;
	exports.ActionFindInPage = _findInPage2.default;
	exports.ActionFindReplace = _findReplace2.default;
	exports.ActionFingerprint = _fingerprint2.default;
	exports.ActionFlightLand = _flightLand2.default;
	exports.ActionFlightTakeoff = _flightTakeoff2.default;
	exports.ActionFlipToBack = _flipToBack2.default;
	exports.ActionFlipToFront = _flipToFront2.default;
	exports.ActionGTranslate = _gTranslate2.default;
	exports.ActionGavel = _gavel2.default;
	exports.ActionGetApp = _getApp2.default;
	exports.ActionGif = _gif2.default;
	exports.ActionGrade = _grade2.default;
	exports.ActionGroupWork = _groupWork2.default;
	exports.ActionHelpOutline = _helpOutline2.default;
	exports.ActionHelp = _help2.default;
	exports.ActionHighlightOff = _highlightOff2.default;
	exports.ActionHistory = _history2.default;
	exports.ActionHome = _home2.default;
	exports.ActionHourglassEmpty = _hourglassEmpty2.default;
	exports.ActionHourglassFull = _hourglassFull2.default;
	exports.ActionHttp = _http2.default;
	exports.ActionHttps = _https2.default;
	exports.ActionImportantDevices = _importantDevices2.default;
	exports.ActionInfoOutline = _infoOutline2.default;
	exports.ActionInfo = _info2.default;
	exports.ActionInput = _input2.default;
	exports.ActionInvertColors = _invertColors2.default;
	exports.ActionLabelOutline = _labelOutline2.default;
	exports.ActionLabel = _label2.default;
	exports.ActionLanguage = _language2.default;
	exports.ActionLaunch = _launch2.default;
	exports.ActionLightbulbOutline = _lightbulbOutline2.default;
	exports.ActionLineStyle = _lineStyle2.default;
	exports.ActionLineWeight = _lineWeight2.default;
	exports.ActionList = _list2.default;
	exports.ActionLockOpen = _lockOpen2.default;
	exports.ActionLockOutline = _lockOutline2.default;
	exports.ActionLock = _lock2.default;
	exports.ActionLoyalty = _loyalty2.default;
	exports.ActionMarkunreadMailbox = _markunreadMailbox2.default;
	exports.ActionMotorcycle = _motorcycle2.default;
	exports.ActionNoteAdd = _noteAdd2.default;
	exports.ActionOfflinePin = _offlinePin2.default;
	exports.ActionOpacity = _opacity2.default;
	exports.ActionOpenInBrowser = _openInBrowser2.default;
	exports.ActionOpenInNew = _openInNew2.default;
	exports.ActionOpenWith = _openWith2.default;
	exports.ActionPageview = _pageview2.default;
	exports.ActionPanTool = _panTool2.default;
	exports.ActionPayment = _payment2.default;
	exports.ActionPermCameraMic = _permCameraMic2.default;
	exports.ActionPermContactCalendar = _permContactCalendar2.default;
	exports.ActionPermDataSetting = _permDataSetting2.default;
	exports.ActionPermDeviceInformation = _permDeviceInformation2.default;
	exports.ActionPermIdentity = _permIdentity2.default;
	exports.ActionPermMedia = _permMedia2.default;
	exports.ActionPermPhoneMsg = _permPhoneMsg2.default;
	exports.ActionPermScanWifi = _permScanWifi2.default;
	exports.ActionPets = _pets2.default;
	exports.ActionPictureInPictureAlt = _pictureInPictureAlt2.default;
	exports.ActionPictureInPicture = _pictureInPicture2.default;
	exports.ActionPlayForWork = _playForWork2.default;
	exports.ActionPolymer = _polymer2.default;
	exports.ActionPowerSettingsNew = _powerSettingsNew2.default;
	exports.ActionPregnantWoman = _pregnantWoman2.default;
	exports.ActionPrint = _print2.default;
	exports.ActionQueryBuilder = _queryBuilder2.default;
	exports.ActionQuestionAnswer = _questionAnswer2.default;
	exports.ActionReceipt = _receipt2.default;
	exports.ActionRecordVoiceOver = _recordVoiceOver2.default;
	exports.ActionRedeem = _redeem2.default;
	exports.ActionRemoveShoppingCart = _removeShoppingCart2.default;
	exports.ActionReorder = _reorder2.default;
	exports.ActionReportProblem = _reportProblem2.default;
	exports.ActionRestorePage = _restorePage2.default;
	exports.ActionRestore = _restore2.default;
	exports.ActionRoom = _room2.default;
	exports.ActionRoundedCorner = _roundedCorner2.default;
	exports.ActionRowing = _rowing2.default;
	exports.ActionSchedule = _schedule2.default;
	exports.ActionSearch = _search2.default;
	exports.ActionSettingsApplications = _settingsApplications2.default;
	exports.ActionSettingsBackupRestore = _settingsBackupRestore2.default;
	exports.ActionSettingsBluetooth = _settingsBluetooth2.default;
	exports.ActionSettingsBrightness = _settingsBrightness2.default;
	exports.ActionSettingsCell = _settingsCell2.default;
	exports.ActionSettingsEthernet = _settingsEthernet2.default;
	exports.ActionSettingsInputAntenna = _settingsInputAntenna2.default;
	exports.ActionSettingsInputComponent = _settingsInputComponent2.default;
	exports.ActionSettingsInputComposite = _settingsInputComposite2.default;
	exports.ActionSettingsInputHdmi = _settingsInputHdmi2.default;
	exports.ActionSettingsInputSvideo = _settingsInputSvideo2.default;
	exports.ActionSettingsOverscan = _settingsOverscan2.default;
	exports.ActionSettingsPhone = _settingsPhone2.default;
	exports.ActionSettingsPower = _settingsPower2.default;
	exports.ActionSettingsRemote = _settingsRemote2.default;
	exports.ActionSettingsVoice = _settingsVoice2.default;
	exports.ActionSettings = _settings2.default;
	exports.ActionShopTwo = _shopTwo2.default;
	exports.ActionShop = _shop2.default;
	exports.ActionShoppingBasket = _shoppingBasket2.default;
	exports.ActionShoppingCart = _shoppingCart2.default;
	exports.ActionSpeakerNotesOff = _speakerNotesOff2.default;
	exports.ActionSpeakerNotes = _speakerNotes2.default;
	exports.ActionSpellcheck = _spellcheck2.default;
	exports.ActionStars = _stars2.default;
	exports.ActionStore = _store2.default;
	exports.ActionSubject = _subject2.default;
	exports.ActionSupervisorAccount = _supervisorAccount2.default;
	exports.ActionSwapHoriz = _swapHoriz2.default;
	exports.ActionSwapVert = _swapVert2.default;
	exports.ActionSwapVerticalCircle = _swapVerticalCircle2.default;
	exports.ActionSystemUpdateAlt = _systemUpdateAlt2.default;
	exports.ActionTabUnselected = _tabUnselected2.default;
	exports.ActionTab = _tab2.default;
	exports.ActionTheaters = _theaters2.default;
	exports.ActionThreeDRotation = _threeDRotation2.default;
	exports.ActionThumbDown = _thumbDown2.default;
	exports.ActionThumbUp = _thumbUp2.default;
	exports.ActionThumbsUpDown = _thumbsUpDown2.default;
	exports.ActionTimeline = _timeline2.default;
	exports.ActionToc = _toc2.default;
	exports.ActionToday = _today2.default;
	exports.ActionToll = _toll2.default;
	exports.ActionTouchApp = _touchApp2.default;
	exports.ActionTrackChanges = _trackChanges2.default;
	exports.ActionTranslate = _translate2.default;
	exports.ActionTrendingDown = _trendingDown2.default;
	exports.ActionTrendingFlat = _trendingFlat2.default;
	exports.ActionTrendingUp = _trendingUp2.default;
	exports.ActionTurnedInNot = _turnedInNot2.default;
	exports.ActionTurnedIn = _turnedIn2.default;
	exports.ActionUpdate = _update2.default;
	exports.ActionVerifiedUser = _verifiedUser2.default;
	exports.ActionViewAgenda = _viewAgenda2.default;
	exports.ActionViewArray = _viewArray2.default;
	exports.ActionViewCarousel = _viewCarousel2.default;
	exports.ActionViewColumn = _viewColumn2.default;
	exports.ActionViewDay = _viewDay2.default;
	exports.ActionViewHeadline = _viewHeadline2.default;
	exports.ActionViewList = _viewList2.default;
	exports.ActionViewModule = _viewModule2.default;
	exports.ActionViewQuilt = _viewQuilt2.default;
	exports.ActionViewStream = _viewStream2.default;
	exports.ActionViewWeek = _viewWeek2.default;
	exports.ActionVisibilityOff = _visibilityOff2.default;
	exports.ActionVisibility = _visibility2.default;
	exports.ActionWatchLater = _watchLater2.default;
	exports.ActionWork = _work2.default;
	exports.ActionYoutubeSearchedFor = _youtubeSearchedFor2.default;
	exports.ActionZoomIn = _zoomIn2.default;
	exports.ActionZoomOut = _zoomOut2.default;
	exports.AlertAddAlert = _addAlert2.default;
	exports.AlertErrorOutline = _errorOutline2.default;
	exports.AlertError = _error2.default;
	exports.AlertWarning = _warning2.default;
	exports.AvAddToQueue = _addToQueue2.default;
	exports.AvAirplay = _airplay2.default;
	exports.AvAlbum = _album2.default;
	exports.AvArtTrack = _artTrack2.default;
	exports.AvAvTimer = _avTimer2.default;
	exports.AvBrandingWatermark = _brandingWatermark2.default;
	exports.AvCallToAction = _callToAction2.default;
	exports.AvClosedCaption = _closedCaption2.default;
	exports.AvEqualizer = _equalizer2.default;
	exports.AvExplicit = _explicit2.default;
	exports.AvFastForward = _fastForward2.default;
	exports.AvFastRewind = _fastRewind2.default;
	exports.AvFeaturedPlayList = _featuredPlayList2.default;
	exports.AvFeaturedVideo = _featuredVideo2.default;
	exports.AvFiberDvr = _fiberDvr2.default;
	exports.AvFiberManualRecord = _fiberManualRecord2.default;
	exports.AvFiberNew = _fiberNew2.default;
	exports.AvFiberPin = _fiberPin2.default;
	exports.AvFiberSmartRecord = _fiberSmartRecord2.default;
	exports.AvForward10 = _forward2.default;
	exports.AvForward30 = _forward4.default;
	exports.AvForward5 = _forward6.default;
	exports.AvGames = _games2.default;
	exports.AvHd = _hd2.default;
	exports.AvHearing = _hearing2.default;
	exports.AvHighQuality = _highQuality2.default;
	exports.AvLibraryAdd = _libraryAdd2.default;
	exports.AvLibraryBooks = _libraryBooks2.default;
	exports.AvLibraryMusic = _libraryMusic2.default;
	exports.AvLoop = _loop2.default;
	exports.AvMicNone = _micNone2.default;
	exports.AvMicOff = _micOff2.default;
	exports.AvMic = _mic2.default;
	exports.AvMovie = _movie2.default;
	exports.AvMusicVideo = _musicVideo2.default;
	exports.AvNewReleases = _newReleases2.default;
	exports.AvNotInterested = _notInterested2.default;
	exports.AvNote = _note2.default;
	exports.AvPauseCircleFilled = _pauseCircleFilled2.default;
	exports.AvPauseCircleOutline = _pauseCircleOutline2.default;
	exports.AvPause = _pause2.default;
	exports.AvPlayArrow = _playArrow2.default;
	exports.AvPlayCircleFilled = _playCircleFilled2.default;
	exports.AvPlayCircleOutline = _playCircleOutline2.default;
	exports.AvPlaylistAddCheck = _playlistAddCheck2.default;
	exports.AvPlaylistAdd = _playlistAdd2.default;
	exports.AvPlaylistPlay = _playlistPlay2.default;
	exports.AvQueueMusic = _queueMusic2.default;
	exports.AvQueuePlayNext = _queuePlayNext2.default;
	exports.AvQueue = _queue2.default;
	exports.AvRadio = _radio2.default;
	exports.AvRecentActors = _recentActors2.default;
	exports.AvRemoveFromQueue = _removeFromQueue2.default;
	exports.AvRepeatOne = _repeatOne2.default;
	exports.AvRepeat = _repeat2.default;
	exports.AvReplay10 = _replay2.default;
	exports.AvReplay30 = _replay4.default;
	exports.AvReplay5 = _replay6.default;
	exports.AvReplay = _replay8.default;
	exports.AvShuffle = _shuffle2.default;
	exports.AvSkipNext = _skipNext2.default;
	exports.AvSkipPrevious = _skipPrevious2.default;
	exports.AvSlowMotionVideo = _slowMotionVideo2.default;
	exports.AvSnooze = _snooze2.default;
	exports.AvSortByAlpha = _sortByAlpha2.default;
	exports.AvStop = _stop2.default;
	exports.AvSubscriptions = _subscriptions2.default;
	exports.AvSubtitles = _subtitles2.default;
	exports.AvSurroundSound = _surroundSound2.default;
	exports.AvVideoCall = _videoCall2.default;
	exports.AvVideoLabel = _videoLabel2.default;
	exports.AvVideoLibrary = _videoLibrary2.default;
	exports.AvVideocamOff = _videocamOff2.default;
	exports.AvVideocam = _videocam2.default;
	exports.AvVolumeDown = _volumeDown2.default;
	exports.AvVolumeMute = _volumeMute2.default;
	exports.AvVolumeOff = _volumeOff2.default;
	exports.AvVolumeUp = _volumeUp2.default;
	exports.AvWebAsset = _webAsset2.default;
	exports.AvWeb = _web2.default;
	exports.CommunicationBusiness = _business2.default;
	exports.CommunicationCallEnd = _callEnd2.default;
	exports.CommunicationCallMade = _callMade2.default;
	exports.CommunicationCallMerge = _callMerge2.default;
	exports.CommunicationCallMissedOutgoing = _callMissedOutgoing2.default;
	exports.CommunicationCallMissed = _callMissed2.default;
	exports.CommunicationCallReceived = _callReceived2.default;
	exports.CommunicationCallSplit = _callSplit2.default;
	exports.CommunicationCall = _call2.default;
	exports.CommunicationChatBubbleOutline = _chatBubbleOutline2.default;
	exports.CommunicationChatBubble = _chatBubble2.default;
	exports.CommunicationChat = _chat2.default;
	exports.CommunicationClearAll = _clearAll2.default;
	exports.CommunicationComment = _comment2.default;
	exports.CommunicationContactMail = _contactMail2.default;
	exports.CommunicationContactPhone = _contactPhone2.default;
	exports.CommunicationContacts = _contacts2.default;
	exports.CommunicationDialerSip = _dialerSip2.default;
	exports.CommunicationDialpad = _dialpad2.default;
	exports.CommunicationEmail = _email2.default;
	exports.CommunicationForum = _forum2.default;
	exports.CommunicationImportContacts = _importContacts2.default;
	exports.CommunicationImportExport = _importExport2.default;
	exports.CommunicationInvertColorsOff = _invertColorsOff2.default;
	exports.CommunicationLiveHelp = _liveHelp2.default;
	exports.CommunicationLocationOff = _locationOff2.default;
	exports.CommunicationLocationOn = _locationOn2.default;
	exports.CommunicationMailOutline = _mailOutline2.default;
	exports.CommunicationMessage = _message2.default;
	exports.CommunicationNoSim = _noSim2.default;
	exports.CommunicationPhone = _phone2.default;
	exports.CommunicationPhonelinkErase = _phonelinkErase2.default;
	exports.CommunicationPhonelinkLock = _phonelinkLock2.default;
	exports.CommunicationPhonelinkRing = _phonelinkRing2.default;
	exports.CommunicationPhonelinkSetup = _phonelinkSetup2.default;
	exports.CommunicationPortableWifiOff = _portableWifiOff2.default;
	exports.CommunicationPresentToAll = _presentToAll2.default;
	exports.CommunicationRingVolume = _ringVolume2.default;
	exports.CommunicationRssFeed = _rssFeed2.default;
	exports.CommunicationScreenShare = _screenShare2.default;
	exports.CommunicationSpeakerPhone = _speakerPhone2.default;
	exports.CommunicationStayCurrentLandscape = _stayCurrentLandscape2.default;
	exports.CommunicationStayCurrentPortrait = _stayCurrentPortrait2.default;
	exports.CommunicationStayPrimaryLandscape = _stayPrimaryLandscape2.default;
	exports.CommunicationStayPrimaryPortrait = _stayPrimaryPortrait2.default;
	exports.CommunicationStopScreenShare = _stopScreenShare2.default;
	exports.CommunicationSwapCalls = _swapCalls2.default;
	exports.CommunicationTextsms = _textsms2.default;
	exports.CommunicationVoicemail = _voicemail2.default;
	exports.CommunicationVpnKey = _vpnKey2.default;
	exports.ContentAddBox = _addBox2.default;
	exports.ContentAddCircleOutline = _addCircleOutline2.default;
	exports.ContentAddCircle = _addCircle2.default;
	exports.ContentAdd = _add2.default;
	exports.ContentArchive = _archive2.default;
	exports.ContentBackspace = _backspace2.default;
	exports.ContentBlock = _block2.default;
	exports.ContentClear = _clear2.default;
	exports.ContentContentCopy = _contentCopy2.default;
	exports.ContentContentCut = _contentCut2.default;
	exports.ContentContentPaste = _contentPaste2.default;
	exports.ContentCreate = _create2.default;
	exports.ContentDeleteSweep = _deleteSweep2.default;
	exports.ContentDrafts = _drafts2.default;
	exports.ContentFilterList = _filterList2.default;
	exports.ContentFlag = _flag2.default;
	exports.ContentFontDownload = _fontDownload2.default;
	exports.ContentForward = _forward8.default;
	exports.ContentGesture = _gesture2.default;
	exports.ContentInbox = _inbox2.default;
	exports.ContentLink = _link2.default;
	exports.ContentLowPriority = _lowPriority2.default;
	exports.ContentMail = _mail2.default;
	exports.ContentMarkunread = _markunread2.default;
	exports.ContentMoveToInbox = _moveToInbox2.default;
	exports.ContentNextWeek = _nextWeek2.default;
	exports.ContentRedo = _redo2.default;
	exports.ContentRemoveCircleOutline = _removeCircleOutline2.default;
	exports.ContentRemoveCircle = _removeCircle2.default;
	exports.ContentRemove = _remove2.default;
	exports.ContentReplyAll = _replyAll2.default;
	exports.ContentReply = _reply2.default;
	exports.ContentReport = _report2.default;
	exports.ContentSave = _save2.default;
	exports.ContentSelectAll = _selectAll2.default;
	exports.ContentSend = _send2.default;
	exports.ContentSort = _sort2.default;
	exports.ContentTextFormat = _textFormat2.default;
	exports.ContentUnarchive = _unarchive2.default;
	exports.ContentUndo = _undo2.default;
	exports.ContentWeekend = _weekend2.default;
	exports.DeviceAccessAlarm = _accessAlarm2.default;
	exports.DeviceAccessAlarms = _accessAlarms2.default;
	exports.DeviceAccessTime = _accessTime2.default;
	exports.DeviceAddAlarm = _addAlarm2.default;
	exports.DeviceAirplanemodeActive = _airplanemodeActive2.default;
	exports.DeviceAirplanemodeInactive = _airplanemodeInactive2.default;
	exports.DeviceBattery20 = _battery2.default;
	exports.DeviceBattery30 = _battery4.default;
	exports.DeviceBattery50 = _battery6.default;
	exports.DeviceBattery60 = _battery8.default;
	exports.DeviceBattery80 = _battery10.default;
	exports.DeviceBattery90 = _battery12.default;
	exports.DeviceBatteryAlert = _batteryAlert2.default;
	exports.DeviceBatteryCharging20 = _batteryCharging2.default;
	exports.DeviceBatteryCharging30 = _batteryCharging4.default;
	exports.DeviceBatteryCharging50 = _batteryCharging6.default;
	exports.DeviceBatteryCharging60 = _batteryCharging8.default;
	exports.DeviceBatteryCharging80 = _batteryCharging10.default;
	exports.DeviceBatteryCharging90 = _batteryCharging12.default;
	exports.DeviceBatteryChargingFull = _batteryChargingFull2.default;
	exports.DeviceBatteryFull = _batteryFull2.default;
	exports.DeviceBatteryStd = _batteryStd2.default;
	exports.DeviceBatteryUnknown = _batteryUnknown2.default;
	exports.DeviceBluetoothConnected = _bluetoothConnected2.default;
	exports.DeviceBluetoothDisabled = _bluetoothDisabled2.default;
	exports.DeviceBluetoothSearching = _bluetoothSearching2.default;
	exports.DeviceBluetooth = _bluetooth2.default;
	exports.DeviceBrightnessAuto = _brightnessAuto2.default;
	exports.DeviceBrightnessHigh = _brightnessHigh2.default;
	exports.DeviceBrightnessLow = _brightnessLow2.default;
	exports.DeviceBrightnessMedium = _brightnessMedium2.default;
	exports.DeviceDataUsage = _dataUsage2.default;
	exports.DeviceDeveloperMode = _developerMode2.default;
	exports.DeviceDevices = _devices2.default;
	exports.DeviceDvr = _dvr2.default;
	exports.DeviceGpsFixed = _gpsFixed2.default;
	exports.DeviceGpsNotFixed = _gpsNotFixed2.default;
	exports.DeviceGpsOff = _gpsOff2.default;
	exports.DeviceGraphicEq = _graphicEq2.default;
	exports.DeviceLocationDisabled = _locationDisabled2.default;
	exports.DeviceLocationSearching = _locationSearching2.default;
	exports.DeviceNetworkCell = _networkCell2.default;
	exports.DeviceNetworkWifi = _networkWifi2.default;
	exports.DeviceNfc = _nfc2.default;
	exports.DeviceScreenLockLandscape = _screenLockLandscape2.default;
	exports.DeviceScreenLockPortrait = _screenLockPortrait2.default;
	exports.DeviceScreenLockRotation = _screenLockRotation2.default;
	exports.DeviceScreenRotation = _screenRotation2.default;
	exports.DeviceSdStorage = _sdStorage2.default;
	exports.DeviceSettingsSystemDaydream = _settingsSystemDaydream2.default;
	exports.DeviceSignalCellular0Bar = _signalCellular0Bar2.default;
	exports.DeviceSignalCellular1Bar = _signalCellular1Bar2.default;
	exports.DeviceSignalCellular2Bar = _signalCellular2Bar2.default;
	exports.DeviceSignalCellular3Bar = _signalCellular3Bar2.default;
	exports.DeviceSignalCellular4Bar = _signalCellular4Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet0Bar = _signalCellularConnectedNoInternet0Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet1Bar = _signalCellularConnectedNoInternet1Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet2Bar = _signalCellularConnectedNoInternet2Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet3Bar = _signalCellularConnectedNoInternet3Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet4Bar = _signalCellularConnectedNoInternet4Bar2.default;
	exports.DeviceSignalCellularNoSim = _signalCellularNoSim2.default;
	exports.DeviceSignalCellularNull = _signalCellularNull2.default;
	exports.DeviceSignalCellularOff = _signalCellularOff2.default;
	exports.DeviceSignalWifi0Bar = _signalWifi0Bar2.default;
	exports.DeviceSignalWifi1BarLock = _signalWifi1BarLock2.default;
	exports.DeviceSignalWifi1Bar = _signalWifi1Bar2.default;
	exports.DeviceSignalWifi2BarLock = _signalWifi2BarLock2.default;
	exports.DeviceSignalWifi2Bar = _signalWifi2Bar2.default;
	exports.DeviceSignalWifi3BarLock = _signalWifi3BarLock2.default;
	exports.DeviceSignalWifi3Bar = _signalWifi3Bar2.default;
	exports.DeviceSignalWifi4BarLock = _signalWifi4BarLock2.default;
	exports.DeviceSignalWifi4Bar = _signalWifi4Bar2.default;
	exports.DeviceSignalWifiOff = _signalWifiOff2.default;
	exports.DeviceStorage = _storage2.default;
	exports.DeviceUsb = _usb2.default;
	exports.DeviceWallpaper = _wallpaper2.default;
	exports.DeviceWidgets = _widgets2.default;
	exports.DeviceWifiLock = _wifiLock2.default;
	exports.DeviceWifiTethering = _wifiTethering2.default;
	exports.EditorAttachFile = _attachFile2.default;
	exports.EditorAttachMoney = _attachMoney2.default;
	exports.EditorBorderAll = _borderAll2.default;
	exports.EditorBorderBottom = _borderBottom2.default;
	exports.EditorBorderClear = _borderClear2.default;
	exports.EditorBorderColor = _borderColor2.default;
	exports.EditorBorderHorizontal = _borderHorizontal2.default;
	exports.EditorBorderInner = _borderInner2.default;
	exports.EditorBorderLeft = _borderLeft2.default;
	exports.EditorBorderOuter = _borderOuter2.default;
	exports.EditorBorderRight = _borderRight2.default;
	exports.EditorBorderStyle = _borderStyle2.default;
	exports.EditorBorderTop = _borderTop2.default;
	exports.EditorBorderVertical = _borderVertical2.default;
	exports.EditorBubbleChart = _bubbleChart2.default;
	exports.EditorDragHandle = _dragHandle2.default;
	exports.EditorFormatAlignCenter = _formatAlignCenter2.default;
	exports.EditorFormatAlignJustify = _formatAlignJustify2.default;
	exports.EditorFormatAlignLeft = _formatAlignLeft2.default;
	exports.EditorFormatAlignRight = _formatAlignRight2.default;
	exports.EditorFormatBold = _formatBold2.default;
	exports.EditorFormatClear = _formatClear2.default;
	exports.EditorFormatColorFill = _formatColorFill2.default;
	exports.EditorFormatColorReset = _formatColorReset2.default;
	exports.EditorFormatColorText = _formatColorText2.default;
	exports.EditorFormatIndentDecrease = _formatIndentDecrease2.default;
	exports.EditorFormatIndentIncrease = _formatIndentIncrease2.default;
	exports.EditorFormatItalic = _formatItalic2.default;
	exports.EditorFormatLineSpacing = _formatLineSpacing2.default;
	exports.EditorFormatListBulleted = _formatListBulleted2.default;
	exports.EditorFormatListNumbered = _formatListNumbered2.default;
	exports.EditorFormatPaint = _formatPaint2.default;
	exports.EditorFormatQuote = _formatQuote2.default;
	exports.EditorFormatShapes = _formatShapes2.default;
	exports.EditorFormatSize = _formatSize2.default;
	exports.EditorFormatStrikethrough = _formatStrikethrough2.default;
	exports.EditorFormatTextdirectionLToR = _formatTextdirectionLToR2.default;
	exports.EditorFormatTextdirectionRToL = _formatTextdirectionRToL2.default;
	exports.EditorFormatUnderlined = _formatUnderlined2.default;
	exports.EditorFunctions = _functions2.default;
	exports.EditorHighlight = _highlight2.default;
	exports.EditorInsertChart = _insertChart2.default;
	exports.EditorInsertComment = _insertComment2.default;
	exports.EditorInsertDriveFile = _insertDriveFile2.default;
	exports.EditorInsertEmoticon = _insertEmoticon2.default;
	exports.EditorInsertInvitation = _insertInvitation2.default;
	exports.EditorInsertLink = _insertLink2.default;
	exports.EditorInsertPhoto = _insertPhoto2.default;
	exports.EditorLinearScale = _linearScale2.default;
	exports.EditorMergeType = _mergeType2.default;
	exports.EditorModeComment = _modeComment2.default;
	exports.EditorModeEdit = _modeEdit2.default;
	exports.EditorMonetizationOn = _monetizationOn2.default;
	exports.EditorMoneyOff = _moneyOff2.default;
	exports.EditorMultilineChart = _multilineChart2.default;
	exports.EditorPieChartOutlined = _pieChartOutlined2.default;
	exports.EditorPieChart = _pieChart2.default;
	exports.EditorPublish = _publish2.default;
	exports.EditorShortText = _shortText2.default;
	exports.EditorShowChart = _showChart2.default;
	exports.EditorSpaceBar = _spaceBar2.default;
	exports.EditorStrikethroughS = _strikethroughS2.default;
	exports.EditorTextFields = _textFields2.default;
	exports.EditorTitle = _title2.default;
	exports.EditorVerticalAlignBottom = _verticalAlignBottom2.default;
	exports.EditorVerticalAlignCenter = _verticalAlignCenter2.default;
	exports.EditorVerticalAlignTop = _verticalAlignTop2.default;
	exports.EditorWrapText = _wrapText2.default;
	exports.FileAttachment = _attachment2.default;
	exports.FileCloudCircle = _cloudCircle2.default;
	exports.FileCloudDone = _cloudDone2.default;
	exports.FileCloudDownload = _cloudDownload2.default;
	exports.FileCloudOff = _cloudOff2.default;
	exports.FileCloudQueue = _cloudQueue2.default;
	exports.FileCloudUpload = _cloudUpload2.default;
	exports.FileCloud = _cloud2.default;
	exports.FileCreateNewFolder = _createNewFolder2.default;
	exports.FileFileDownload = _fileDownload2.default;
	exports.FileFileUpload = _fileUpload2.default;
	exports.FileFolderOpen = _folderOpen2.default;
	exports.FileFolderShared = _folderShared2.default;
	exports.FileFolder = _folder2.default;
	exports.HardwareCastConnected = _castConnected2.default;
	exports.HardwareCast = _cast2.default;
	exports.HardwareComputer = _computer2.default;
	exports.HardwareDesktopMac = _desktopMac2.default;
	exports.HardwareDesktopWindows = _desktopWindows2.default;
	exports.HardwareDeveloperBoard = _developerBoard2.default;
	exports.HardwareDeviceHub = _deviceHub2.default;
	exports.HardwareDevicesOther = _devicesOther2.default;
	exports.HardwareDock = _dock2.default;
	exports.HardwareGamepad = _gamepad2.default;
	exports.HardwareHeadsetMic = _headsetMic2.default;
	exports.HardwareHeadset = _headset2.default;
	exports.HardwareKeyboardArrowDown = _keyboardArrowDown2.default;
	exports.HardwareKeyboardArrowLeft = _keyboardArrowLeft2.default;
	exports.HardwareKeyboardArrowRight = _keyboardArrowRight2.default;
	exports.HardwareKeyboardArrowUp = _keyboardArrowUp2.default;
	exports.HardwareKeyboardBackspace = _keyboardBackspace2.default;
	exports.HardwareKeyboardCapslock = _keyboardCapslock2.default;
	exports.HardwareKeyboardHide = _keyboardHide2.default;
	exports.HardwareKeyboardReturn = _keyboardReturn2.default;
	exports.HardwareKeyboardTab = _keyboardTab2.default;
	exports.HardwareKeyboardVoice = _keyboardVoice2.default;
	exports.HardwareKeyboard = _keyboard2.default;
	exports.HardwareLaptopChromebook = _laptopChromebook2.default;
	exports.HardwareLaptopMac = _laptopMac2.default;
	exports.HardwareLaptopWindows = _laptopWindows2.default;
	exports.HardwareLaptop = _laptop2.default;
	exports.HardwareMemory = _memory2.default;
	exports.HardwareMouse = _mouse2.default;
	exports.HardwarePhoneAndroid = _phoneAndroid2.default;
	exports.HardwarePhoneIphone = _phoneIphone2.default;
	exports.HardwarePhonelinkOff = _phonelinkOff2.default;
	exports.HardwarePhonelink = _phonelink2.default;
	exports.HardwarePowerInput = _powerInput2.default;
	exports.HardwareRouter = _router2.default;
	exports.HardwareScanner = _scanner2.default;
	exports.HardwareSecurity = _security2.default;
	exports.HardwareSimCard = _simCard2.default;
	exports.HardwareSmartphone = _smartphone2.default;
	exports.HardwareSpeakerGroup = _speakerGroup2.default;
	exports.HardwareSpeaker = _speaker2.default;
	exports.HardwareTabletAndroid = _tabletAndroid2.default;
	exports.HardwareTabletMac = _tabletMac2.default;
	exports.HardwareTablet = _tablet2.default;
	exports.HardwareToys = _toys2.default;
	exports.HardwareTv = _tv2.default;
	exports.HardwareVideogameAsset = _videogameAsset2.default;
	exports.HardwareWatch = _watch2.default;
	exports.ImageAddAPhoto = _addAPhoto2.default;
	exports.ImageAddToPhotos = _addToPhotos2.default;
	exports.ImageAdjust = _adjust2.default;
	exports.ImageAssistantPhoto = _assistantPhoto2.default;
	exports.ImageAssistant = _assistant2.default;
	exports.ImageAudiotrack = _audiotrack2.default;
	exports.ImageBlurCircular = _blurCircular2.default;
	exports.ImageBlurLinear = _blurLinear2.default;
	exports.ImageBlurOff = _blurOff2.default;
	exports.ImageBlurOn = _blurOn2.default;
	exports.ImageBrightness1 = _brightness2.default;
	exports.ImageBrightness2 = _brightness4.default;
	exports.ImageBrightness3 = _brightness6.default;
	exports.ImageBrightness4 = _brightness8.default;
	exports.ImageBrightness5 = _brightness10.default;
	exports.ImageBrightness6 = _brightness12.default;
	exports.ImageBrightness7 = _brightness14.default;
	exports.ImageBrokenImage = _brokenImage2.default;
	exports.ImageBrush = _brush2.default;
	exports.ImageBurstMode = _burstMode2.default;
	exports.ImageCameraAlt = _cameraAlt2.default;
	exports.ImageCameraFront = _cameraFront2.default;
	exports.ImageCameraRear = _cameraRear2.default;
	exports.ImageCameraRoll = _cameraRoll2.default;
	exports.ImageCamera = _camera2.default;
	exports.ImageCenterFocusStrong = _centerFocusStrong2.default;
	exports.ImageCenterFocusWeak = _centerFocusWeak2.default;
	exports.ImageCollectionsBookmark = _collectionsBookmark2.default;
	exports.ImageCollections = _collections2.default;
	exports.ImageColorLens = _colorLens2.default;
	exports.ImageColorize = _colorize2.default;
	exports.ImageCompare = _compare2.default;
	exports.ImageControlPointDuplicate = _controlPointDuplicate2.default;
	exports.ImageControlPoint = _controlPoint2.default;
	exports.ImageCrop169 = _crop2.default;
	exports.ImageCrop32 = _crop4.default;
	exports.ImageCrop54 = _crop6.default;
	exports.ImageCrop75 = _crop8.default;
	exports.ImageCropDin = _cropDin2.default;
	exports.ImageCropFree = _cropFree2.default;
	exports.ImageCropLandscape = _cropLandscape2.default;
	exports.ImageCropOriginal = _cropOriginal2.default;
	exports.ImageCropPortrait = _cropPortrait2.default;
	exports.ImageCropRotate = _cropRotate2.default;
	exports.ImageCropSquare = _cropSquare2.default;
	exports.ImageCrop = _crop10.default;
	exports.ImageDehaze = _dehaze2.default;
	exports.ImageDetails = _details2.default;
	exports.ImageEdit = _edit2.default;
	exports.ImageExposureNeg1 = _exposureNeg2.default;
	exports.ImageExposureNeg2 = _exposureNeg4.default;
	exports.ImageExposurePlus1 = _exposurePlus2.default;
	exports.ImageExposurePlus2 = _exposurePlus4.default;
	exports.ImageExposureZero = _exposureZero2.default;
	exports.ImageExposure = _exposure2.default;
	exports.ImageFilter1 = _filter2.default;
	exports.ImageFilter2 = _filter4.default;
	exports.ImageFilter3 = _filter6.default;
	exports.ImageFilter4 = _filter8.default;
	exports.ImageFilter5 = _filter10.default;
	exports.ImageFilter6 = _filter12.default;
	exports.ImageFilter7 = _filter14.default;
	exports.ImageFilter8 = _filter16.default;
	exports.ImageFilter9Plus = _filter9Plus2.default;
	exports.ImageFilter9 = _filter18.default;
	exports.ImageFilterBAndW = _filterBAndW2.default;
	exports.ImageFilterCenterFocus = _filterCenterFocus2.default;
	exports.ImageFilterDrama = _filterDrama2.default;
	exports.ImageFilterFrames = _filterFrames2.default;
	exports.ImageFilterHdr = _filterHdr2.default;
	exports.ImageFilterNone = _filterNone2.default;
	exports.ImageFilterTiltShift = _filterTiltShift2.default;
	exports.ImageFilterVintage = _filterVintage2.default;
	exports.ImageFilter = _filter20.default;
	exports.ImageFlare = _flare2.default;
	exports.ImageFlashAuto = _flashAuto2.default;
	exports.ImageFlashOff = _flashOff2.default;
	exports.ImageFlashOn = _flashOn2.default;
	exports.ImageFlip = _flip2.default;
	exports.ImageGradient = _gradient2.default;
	exports.ImageGrain = _grain2.default;
	exports.ImageGridOff = _gridOff2.default;
	exports.ImageGridOn = _gridOn2.default;
	exports.ImageHdrOff = _hdrOff2.default;
	exports.ImageHdrOn = _hdrOn2.default;
	exports.ImageHdrStrong = _hdrStrong2.default;
	exports.ImageHdrWeak = _hdrWeak2.default;
	exports.ImageHealing = _healing2.default;
	exports.ImageImageAspectRatio = _imageAspectRatio2.default;
	exports.ImageImage = _image2.default;
	exports.ImageIso = _iso2.default;
	exports.ImageLandscape = _landscape2.default;
	exports.ImageLeakAdd = _leakAdd2.default;
	exports.ImageLeakRemove = _leakRemove2.default;
	exports.ImageLens = _lens2.default;
	exports.ImageLinkedCamera = _linkedCamera2.default;
	exports.ImageLooks3 = _looks2.default;
	exports.ImageLooks4 = _looks4.default;
	exports.ImageLooks5 = _looks6.default;
	exports.ImageLooks6 = _looks8.default;
	exports.ImageLooksOne = _looksOne2.default;
	exports.ImageLooksTwo = _looksTwo2.default;
	exports.ImageLooks = _looks10.default;
	exports.ImageLoupe = _loupe2.default;
	exports.ImageMonochromePhotos = _monochromePhotos2.default;
	exports.ImageMovieCreation = _movieCreation2.default;
	exports.ImageMovieFilter = _movieFilter2.default;
	exports.ImageMusicNote = _musicNote2.default;
	exports.ImageNaturePeople = _naturePeople2.default;
	exports.ImageNature = _nature2.default;
	exports.ImageNavigateBefore = _navigateBefore2.default;
	exports.ImageNavigateNext = _navigateNext2.default;
	exports.ImagePalette = _palette2.default;
	exports.ImagePanoramaFishEye = _panoramaFishEye2.default;
	exports.ImagePanoramaHorizontal = _panoramaHorizontal2.default;
	exports.ImagePanoramaVertical = _panoramaVertical2.default;
	exports.ImagePanoramaWideAngle = _panoramaWideAngle2.default;
	exports.ImagePanorama = _panorama2.default;
	exports.ImagePhotoAlbum = _photoAlbum2.default;
	exports.ImagePhotoCamera = _photoCamera2.default;
	exports.ImagePhotoFilter = _photoFilter2.default;
	exports.ImagePhotoLibrary = _photoLibrary2.default;
	exports.ImagePhotoSizeSelectActual = _photoSizeSelectActual2.default;
	exports.ImagePhotoSizeSelectLarge = _photoSizeSelectLarge2.default;
	exports.ImagePhotoSizeSelectSmall = _photoSizeSelectSmall2.default;
	exports.ImagePhoto = _photo2.default;
	exports.ImagePictureAsPdf = _pictureAsPdf2.default;
	exports.ImagePortrait = _portrait2.default;
	exports.ImageRemoveRedEye = _removeRedEye2.default;
	exports.ImageRotate90DegreesCcw = _rotate90DegreesCcw2.default;
	exports.ImageRotateLeft = _rotateLeft2.default;
	exports.ImageRotateRight = _rotateRight2.default;
	exports.ImageSlideshow = _slideshow2.default;
	exports.ImageStraighten = _straighten2.default;
	exports.ImageStyle = _style2.default;
	exports.ImageSwitchCamera = _switchCamera2.default;
	exports.ImageSwitchVideo = _switchVideo2.default;
	exports.ImageTagFaces = _tagFaces2.default;
	exports.ImageTexture = _texture2.default;
	exports.ImageTimelapse = _timelapse2.default;
	exports.ImageTimer10 = _timer2.default;
	exports.ImageTimer3 = _timer4.default;
	exports.ImageTimerOff = _timerOff2.default;
	exports.ImageTimer = _timer6.default;
	exports.ImageTonality = _tonality2.default;
	exports.ImageTransform = _transform2.default;
	exports.ImageTune = _tune2.default;
	exports.ImageViewComfy = _viewComfy2.default;
	exports.ImageViewCompact = _viewCompact2.default;
	exports.ImageVignette = _vignette2.default;
	exports.ImageWbAuto = _wbAuto2.default;
	exports.ImageWbCloudy = _wbCloudy2.default;
	exports.ImageWbIncandescent = _wbIncandescent2.default;
	exports.ImageWbIridescent = _wbIridescent2.default;
	exports.ImageWbSunny = _wbSunny2.default;
	exports.MapsAddLocation = _addLocation2.default;
	exports.MapsBeenhere = _beenhere2.default;
	exports.MapsDirectionsBike = _directionsBike2.default;
	exports.MapsDirectionsBoat = _directionsBoat2.default;
	exports.MapsDirectionsBus = _directionsBus2.default;
	exports.MapsDirectionsCar = _directionsCar2.default;
	exports.MapsDirectionsRailway = _directionsRailway2.default;
	exports.MapsDirectionsRun = _directionsRun2.default;
	exports.MapsDirectionsSubway = _directionsSubway2.default;
	exports.MapsDirectionsTransit = _directionsTransit2.default;
	exports.MapsDirectionsWalk = _directionsWalk2.default;
	exports.MapsDirections = _directions2.default;
	exports.MapsEditLocation = _editLocation2.default;
	exports.MapsEvStation = _evStation2.default;
	exports.MapsFlight = _flight2.default;
	exports.MapsHotel = _hotel2.default;
	exports.MapsLayersClear = _layersClear2.default;
	exports.MapsLayers = _layers2.default;
	exports.MapsLocalActivity = _localActivity2.default;
	exports.MapsLocalAirport = _localAirport2.default;
	exports.MapsLocalAtm = _localAtm2.default;
	exports.MapsLocalBar = _localBar2.default;
	exports.MapsLocalCafe = _localCafe2.default;
	exports.MapsLocalCarWash = _localCarWash2.default;
	exports.MapsLocalConvenienceStore = _localConvenienceStore2.default;
	exports.MapsLocalDining = _localDining2.default;
	exports.MapsLocalDrink = _localDrink2.default;
	exports.MapsLocalFlorist = _localFlorist2.default;
	exports.MapsLocalGasStation = _localGasStation2.default;
	exports.MapsLocalGroceryStore = _localGroceryStore2.default;
	exports.MapsLocalHospital = _localHospital2.default;
	exports.MapsLocalHotel = _localHotel2.default;
	exports.MapsLocalLaundryService = _localLaundryService2.default;
	exports.MapsLocalLibrary = _localLibrary2.default;
	exports.MapsLocalMall = _localMall2.default;
	exports.MapsLocalMovies = _localMovies2.default;
	exports.MapsLocalOffer = _localOffer2.default;
	exports.MapsLocalParking = _localParking2.default;
	exports.MapsLocalPharmacy = _localPharmacy2.default;
	exports.MapsLocalPhone = _localPhone2.default;
	exports.MapsLocalPizza = _localPizza2.default;
	exports.MapsLocalPlay = _localPlay2.default;
	exports.MapsLocalPostOffice = _localPostOffice2.default;
	exports.MapsLocalPrintshop = _localPrintshop2.default;
	exports.MapsLocalSee = _localSee2.default;
	exports.MapsLocalShipping = _localShipping2.default;
	exports.MapsLocalTaxi = _localTaxi2.default;
	exports.MapsMap = _map2.default;
	exports.MapsMyLocation = _myLocation2.default;
	exports.MapsNavigation = _navigation2.default;
	exports.MapsNearMe = _nearMe2.default;
	exports.MapsPersonPinCircle = _personPinCircle2.default;
	exports.MapsPersonPin = _personPin2.default;
	exports.MapsPinDrop = _pinDrop2.default;
	exports.MapsPlace = _place2.default;
	exports.MapsRateReview = _rateReview2.default;
	exports.MapsRestaurantMenu = _restaurantMenu2.default;
	exports.MapsRestaurant = _restaurant2.default;
	exports.MapsSatellite = _satellite2.default;
	exports.MapsStoreMallDirectory = _storeMallDirectory2.default;
	exports.MapsStreetview = _streetview2.default;
	exports.MapsSubway = _subway2.default;
	exports.MapsTerrain = _terrain2.default;
	exports.MapsTraffic = _traffic2.default;
	exports.MapsTrain = _train2.default;
	exports.MapsTram = _tram2.default;
	exports.MapsTransferWithinAStation = _transferWithinAStation2.default;
	exports.MapsZoomOutMap = _zoomOutMap2.default;
	exports.NavigationApps = _apps2.default;
	exports.NavigationArrowBack = _arrowBack2.default;
	exports.NavigationArrowDownward = _arrowDownward2.default;
	exports.NavigationArrowDropDownCircle = _arrowDropDownCircle2.default;
	exports.NavigationArrowDropDown = _arrowDropDown2.default;
	exports.NavigationArrowDropUp = _arrowDropUp2.default;
	exports.NavigationArrowForward = _arrowForward2.default;
	exports.NavigationArrowUpward = _arrowUpward2.default;
	exports.NavigationCancel = _cancel2.default;
	exports.NavigationCheck = _check2.default;
	exports.NavigationChevronLeft = _chevronLeft2.default;
	exports.NavigationChevronRight = _chevronRight2.default;
	exports.NavigationClose = _close2.default;
	exports.NavigationExpandLess = _expandLess2.default;
	exports.NavigationExpandMore = _expandMore2.default;
	exports.NavigationFirstPage = _firstPage2.default;
	exports.NavigationFullscreenExit = _fullscreenExit2.default;
	exports.NavigationFullscreen = _fullscreen2.default;
	exports.NavigationLastPage = _lastPage2.default;
	exports.NavigationMenu = _menu2.default;
	exports.NavigationMoreHoriz = _moreHoriz2.default;
	exports.NavigationMoreVert = _moreVert2.default;
	exports.NavigationRefresh = _refresh2.default;
	exports.NavigationSubdirectoryArrowLeft = _subdirectoryArrowLeft2.default;
	exports.NavigationSubdirectoryArrowRight = _subdirectoryArrowRight2.default;
	exports.NavigationUnfoldLess = _unfoldLess2.default;
	exports.NavigationUnfoldMore = _unfoldMore2.default;
	exports.NavigationArrowDropRight = _navigationArrowDropRight2.default;
	exports.NotificationAdb = _adb2.default;
	exports.NotificationAirlineSeatFlatAngled = _airlineSeatFlatAngled2.default;
	exports.NotificationAirlineSeatFlat = _airlineSeatFlat2.default;
	exports.NotificationAirlineSeatIndividualSuite = _airlineSeatIndividualSuite2.default;
	exports.NotificationAirlineSeatLegroomExtra = _airlineSeatLegroomExtra2.default;
	exports.NotificationAirlineSeatLegroomNormal = _airlineSeatLegroomNormal2.default;
	exports.NotificationAirlineSeatLegroomReduced = _airlineSeatLegroomReduced2.default;
	exports.NotificationAirlineSeatReclineExtra = _airlineSeatReclineExtra2.default;
	exports.NotificationAirlineSeatReclineNormal = _airlineSeatReclineNormal2.default;
	exports.NotificationBluetoothAudio = _bluetoothAudio2.default;
	exports.NotificationConfirmationNumber = _confirmationNumber2.default;
	exports.NotificationDiscFull = _discFull2.default;
	exports.NotificationDoNotDisturbAlt = _doNotDisturbAlt2.default;
	exports.NotificationDoNotDisturbOff = _doNotDisturbOff2.default;
	exports.NotificationDoNotDisturbOn = _doNotDisturbOn2.default;
	exports.NotificationDoNotDisturb = _doNotDisturb2.default;
	exports.NotificationDriveEta = _driveEta2.default;
	exports.NotificationEnhancedEncryption = _enhancedEncryption2.default;
	exports.NotificationEventAvailable = _eventAvailable2.default;
	exports.NotificationEventBusy = _eventBusy2.default;
	exports.NotificationEventNote = _eventNote2.default;
	exports.NotificationFolderSpecial = _folderSpecial2.default;
	exports.NotificationLiveTv = _liveTv2.default;
	exports.NotificationMms = _mms2.default;
	exports.NotificationMore = _more2.default;
	exports.NotificationNetworkCheck = _networkCheck2.default;
	exports.NotificationNetworkLocked = _networkLocked2.default;
	exports.NotificationNoEncryption = _noEncryption2.default;
	exports.NotificationOndemandVideo = _ondemandVideo2.default;
	exports.NotificationPersonalVideo = _personalVideo2.default;
	exports.NotificationPhoneBluetoothSpeaker = _phoneBluetoothSpeaker2.default;
	exports.NotificationPhoneForwarded = _phoneForwarded2.default;
	exports.NotificationPhoneInTalk = _phoneInTalk2.default;
	exports.NotificationPhoneLocked = _phoneLocked2.default;
	exports.NotificationPhoneMissed = _phoneMissed2.default;
	exports.NotificationPhonePaused = _phonePaused2.default;
	exports.NotificationPower = _power2.default;
	exports.NotificationPriorityHigh = _priorityHigh2.default;
	exports.NotificationRvHookup = _rvHookup2.default;
	exports.NotificationSdCard = _sdCard2.default;
	exports.NotificationSimCardAlert = _simCardAlert2.default;
	exports.NotificationSmsFailed = _smsFailed2.default;
	exports.NotificationSms = _sms2.default;
	exports.NotificationSyncDisabled = _syncDisabled2.default;
	exports.NotificationSyncProblem = _syncProblem2.default;
	exports.NotificationSync = _sync2.default;
	exports.NotificationSystemUpdate = _systemUpdate2.default;
	exports.NotificationTapAndPlay = _tapAndPlay2.default;
	exports.NotificationTimeToLeave = _timeToLeave2.default;
	exports.NotificationVibration = _vibration2.default;
	exports.NotificationVoiceChat = _voiceChat2.default;
	exports.NotificationVpnLock = _vpnLock2.default;
	exports.NotificationWc = _wc2.default;
	exports.NotificationWifi = _wifi2.default;
	exports.PlacesAcUnit = _acUnit2.default;
	exports.PlacesAirportShuttle = _airportShuttle2.default;
	exports.PlacesAllInclusive = _allInclusive2.default;
	exports.PlacesBeachAccess = _beachAccess2.default;
	exports.PlacesBusinessCenter = _businessCenter2.default;
	exports.PlacesCasino = _casino2.default;
	exports.PlacesChildCare = _childCare2.default;
	exports.PlacesChildFriendly = _childFriendly2.default;
	exports.PlacesFitnessCenter = _fitnessCenter2.default;
	exports.PlacesFreeBreakfast = _freeBreakfast2.default;
	exports.PlacesGolfCourse = _golfCourse2.default;
	exports.PlacesHotTub = _hotTub2.default;
	exports.PlacesKitchen = _kitchen2.default;
	exports.PlacesPool = _pool2.default;
	exports.PlacesRoomService = _roomService2.default;
	exports.PlacesRvHookup = _rvHookup4.default;
	exports.PlacesSmokeFree = _smokeFree2.default;
	exports.PlacesSmokingRooms = _smokingRooms2.default;
	exports.PlacesSpa = _spa2.default;
	exports.SocialCake = _cake2.default;
	exports.SocialDomain = _domain2.default;
	exports.SocialGroupAdd = _groupAdd2.default;
	exports.SocialGroup = _group2.default;
	exports.SocialLocationCity = _locationCity2.default;
	exports.SocialMoodBad = _moodBad2.default;
	exports.SocialMood = _mood2.default;
	exports.SocialNotificationsActive = _notificationsActive2.default;
	exports.SocialNotificationsNone = _notificationsNone2.default;
	exports.SocialNotificationsOff = _notificationsOff2.default;
	exports.SocialNotificationsPaused = _notificationsPaused2.default;
	exports.SocialNotifications = _notifications2.default;
	exports.SocialPages = _pages2.default;
	exports.SocialPartyMode = _partyMode2.default;
	exports.SocialPeopleOutline = _peopleOutline2.default;
	exports.SocialPeople = _people2.default;
	exports.SocialPersonAdd = _personAdd2.default;
	exports.SocialPersonOutline = _personOutline2.default;
	exports.SocialPerson = _person2.default;
	exports.SocialPlusOne = _plusOne2.default;
	exports.SocialPoll = _poll2.default;
	exports.SocialPublic = _public2.default;
	exports.SocialSchool = _school2.default;
	exports.SocialSentimentDissatisfied = _sentimentDissatisfied2.default;
	exports.SocialSentimentNeutral = _sentimentNeutral2.default;
	exports.SocialSentimentSatisfied = _sentimentSatisfied2.default;
	exports.SocialSentimentVeryDissatisfied = _sentimentVeryDissatisfied2.default;
	exports.SocialSentimentVerySatisfied = _sentimentVerySatisfied2.default;
	exports.SocialShare = _share2.default;
	exports.SocialWhatshot = _whatshot2.default;
	exports.ToggleCheckBoxOutlineBlank = _checkBoxOutlineBlank2.default;
	exports.ToggleCheckBox = _checkBox2.default;
	exports.ToggleIndeterminateCheckBox = _indeterminateCheckBox2.default;
	exports.ToggleRadioButtonChecked = _radioButtonChecked2.default;
	exports.ToggleRadioButtonUnchecked = _radioButtonUnchecked2.default;
	exports.ToggleStarBorder = _starBorder2.default;
	exports.ToggleStarHalf = _starHalf2.default;
	exports.ToggleStar = _star2.default;

/***/ },
/* 2491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsAddLocation = function MapsAddLocation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z' })
	  );
	};
	MapsAddLocation = (0, _pure2.default)(MapsAddLocation);
	MapsAddLocation.displayName = 'MapsAddLocation';
	MapsAddLocation.muiName = 'SvgIcon';
	
	exports.default = MapsAddLocation;

/***/ },
/* 2492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsBeenhere = function MapsBeenhere(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z' })
	  );
	};
	MapsBeenhere = (0, _pure2.default)(MapsBeenhere);
	MapsBeenhere.displayName = 'MapsBeenhere';
	MapsBeenhere.muiName = 'SvgIcon';
	
	exports.default = MapsBeenhere;

/***/ },
/* 2493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsBike = function MapsDirectionsBike(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z' })
	  );
	};
	MapsDirectionsBike = (0, _pure2.default)(MapsDirectionsBike);
	MapsDirectionsBike.displayName = 'MapsDirectionsBike';
	MapsDirectionsBike.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsBike;

/***/ },
/* 2494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsBoat = function MapsDirectionsBoat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z' })
	  );
	};
	MapsDirectionsBoat = (0, _pure2.default)(MapsDirectionsBoat);
	MapsDirectionsBoat.displayName = 'MapsDirectionsBoat';
	MapsDirectionsBoat.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsBoat;

/***/ },
/* 2495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsBus = function MapsDirectionsBus(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z' })
	  );
	};
	MapsDirectionsBus = (0, _pure2.default)(MapsDirectionsBus);
	MapsDirectionsBus.displayName = 'MapsDirectionsBus';
	MapsDirectionsBus.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsBus;

/***/ },
/* 2496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsCar = function MapsDirectionsCar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
	  );
	};
	MapsDirectionsCar = (0, _pure2.default)(MapsDirectionsCar);
	MapsDirectionsCar.displayName = 'MapsDirectionsCar';
	MapsDirectionsCar.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsCar;

/***/ },
/* 2497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsRailway = function MapsDirectionsRailway(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z' })
	  );
	};
	MapsDirectionsRailway = (0, _pure2.default)(MapsDirectionsRailway);
	MapsDirectionsRailway.displayName = 'MapsDirectionsRailway';
	MapsDirectionsRailway.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsRailway;

/***/ },
/* 2498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsRun = function MapsDirectionsRun(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z' })
	  );
	};
	MapsDirectionsRun = (0, _pure2.default)(MapsDirectionsRun);
	MapsDirectionsRun.displayName = 'MapsDirectionsRun';
	MapsDirectionsRun.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsRun;

/***/ },
/* 2499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsSubway = function MapsDirectionsSubway(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
	  );
	};
	MapsDirectionsSubway = (0, _pure2.default)(MapsDirectionsSubway);
	MapsDirectionsSubway.displayName = 'MapsDirectionsSubway';
	MapsDirectionsSubway.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsSubway;

/***/ },
/* 2500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsTransit = function MapsDirectionsTransit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
	  );
	};
	MapsDirectionsTransit = (0, _pure2.default)(MapsDirectionsTransit);
	MapsDirectionsTransit.displayName = 'MapsDirectionsTransit';
	MapsDirectionsTransit.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsTransit;

/***/ },
/* 2501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsWalk = function MapsDirectionsWalk(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7' })
	  );
	};
	MapsDirectionsWalk = (0, _pure2.default)(MapsDirectionsWalk);
	MapsDirectionsWalk.displayName = 'MapsDirectionsWalk';
	MapsDirectionsWalk.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsWalk;

/***/ },
/* 2502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirections = function MapsDirections(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z' })
	  );
	};
	MapsDirections = (0, _pure2.default)(MapsDirections);
	MapsDirections.displayName = 'MapsDirections';
	MapsDirections.muiName = 'SvgIcon';
	
	exports.default = MapsDirections;

/***/ },
/* 2503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsEditLocation = function MapsEditLocation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z' })
	  );
	};
	MapsEditLocation = (0, _pure2.default)(MapsEditLocation);
	MapsEditLocation.displayName = 'MapsEditLocation';
	MapsEditLocation.muiName = 'SvgIcon';
	
	exports.default = MapsEditLocation;

/***/ },
/* 2504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsEvStation = function MapsEvStation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z' })
	  );
	};
	MapsEvStation = (0, _pure2.default)(MapsEvStation);
	MapsEvStation.displayName = 'MapsEvStation';
	MapsEvStation.muiName = 'SvgIcon';
	
	exports.default = MapsEvStation;

/***/ },
/* 2505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsFlight = function MapsFlight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.18 9' }),
	    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
	  );
	};
	MapsFlight = (0, _pure2.default)(MapsFlight);
	MapsFlight.displayName = 'MapsFlight';
	MapsFlight.muiName = 'SvgIcon';
	
	exports.default = MapsFlight;

/***/ },
/* 2506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsHotel = function MapsHotel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
	  );
	};
	MapsHotel = (0, _pure2.default)(MapsHotel);
	MapsHotel.displayName = 'MapsHotel';
	MapsHotel.muiName = 'SvgIcon';
	
	exports.default = MapsHotel;

/***/ },
/* 2507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLayersClear = function MapsLayersClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z' })
	  );
	};
	MapsLayersClear = (0, _pure2.default)(MapsLayersClear);
	MapsLayersClear.displayName = 'MapsLayersClear';
	MapsLayersClear.muiName = 'SvgIcon';
	
	exports.default = MapsLayersClear;

/***/ },
/* 2508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLayers = function MapsLayers(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z' })
	  );
	};
	MapsLayers = (0, _pure2.default)(MapsLayers);
	MapsLayers.displayName = 'MapsLayers';
	MapsLayers.muiName = 'SvgIcon';
	
	exports.default = MapsLayers;

/***/ },
/* 2509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalActivity = function MapsLocalActivity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
	  );
	};
	MapsLocalActivity = (0, _pure2.default)(MapsLocalActivity);
	MapsLocalActivity.displayName = 'MapsLocalActivity';
	MapsLocalActivity.muiName = 'SvgIcon';
	
	exports.default = MapsLocalActivity;

/***/ },
/* 2510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalAirport = function MapsLocalAirport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
	  );
	};
	MapsLocalAirport = (0, _pure2.default)(MapsLocalAirport);
	MapsLocalAirport.displayName = 'MapsLocalAirport';
	MapsLocalAirport.muiName = 'SvgIcon';
	
	exports.default = MapsLocalAirport;

/***/ },
/* 2511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalAtm = function MapsLocalAtm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z' })
	  );
	};
	MapsLocalAtm = (0, _pure2.default)(MapsLocalAtm);
	MapsLocalAtm.displayName = 'MapsLocalAtm';
	MapsLocalAtm.muiName = 'SvgIcon';
	
	exports.default = MapsLocalAtm;

/***/ },
/* 2512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalBar = function MapsLocalBar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z' })
	  );
	};
	MapsLocalBar = (0, _pure2.default)(MapsLocalBar);
	MapsLocalBar.displayName = 'MapsLocalBar';
	MapsLocalBar.muiName = 'SvgIcon';
	
	exports.default = MapsLocalBar;

/***/ },
/* 2513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalCafe = function MapsLocalCafe(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z' })
	  );
	};
	MapsLocalCafe = (0, _pure2.default)(MapsLocalCafe);
	MapsLocalCafe.displayName = 'MapsLocalCafe';
	MapsLocalCafe.muiName = 'SvgIcon';
	
	exports.default = MapsLocalCafe;

/***/ },
/* 2514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalCarWash = function MapsLocalCarWash(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z' })
	  );
	};
	MapsLocalCarWash = (0, _pure2.default)(MapsLocalCarWash);
	MapsLocalCarWash.displayName = 'MapsLocalCarWash';
	MapsLocalCarWash.muiName = 'SvgIcon';
	
	exports.default = MapsLocalCarWash;

/***/ },
/* 2515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalConvenienceStore = function MapsLocalConvenienceStore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z' })
	  );
	};
	MapsLocalConvenienceStore = (0, _pure2.default)(MapsLocalConvenienceStore);
	MapsLocalConvenienceStore.displayName = 'MapsLocalConvenienceStore';
	MapsLocalConvenienceStore.muiName = 'SvgIcon';
	
	exports.default = MapsLocalConvenienceStore;

/***/ },
/* 2516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalDining = function MapsLocalDining(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
	  );
	};
	MapsLocalDining = (0, _pure2.default)(MapsLocalDining);
	MapsLocalDining.displayName = 'MapsLocalDining';
	MapsLocalDining.muiName = 'SvgIcon';
	
	exports.default = MapsLocalDining;

/***/ },
/* 2517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalDrink = function MapsLocalDrink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z' })
	  );
	};
	MapsLocalDrink = (0, _pure2.default)(MapsLocalDrink);
	MapsLocalDrink.displayName = 'MapsLocalDrink';
	MapsLocalDrink.muiName = 'SvgIcon';
	
	exports.default = MapsLocalDrink;

/***/ },
/* 2518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalFlorist = function MapsLocalFlorist(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z' })
	  );
	};
	MapsLocalFlorist = (0, _pure2.default)(MapsLocalFlorist);
	MapsLocalFlorist.displayName = 'MapsLocalFlorist';
	MapsLocalFlorist.muiName = 'SvgIcon';
	
	exports.default = MapsLocalFlorist;

/***/ },
/* 2519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalGasStation = function MapsLocalGasStation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	MapsLocalGasStation = (0, _pure2.default)(MapsLocalGasStation);
	MapsLocalGasStation.displayName = 'MapsLocalGasStation';
	MapsLocalGasStation.muiName = 'SvgIcon';
	
	exports.default = MapsLocalGasStation;

/***/ },
/* 2520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalGroceryStore = function MapsLocalGroceryStore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	MapsLocalGroceryStore = (0, _pure2.default)(MapsLocalGroceryStore);
	MapsLocalGroceryStore.displayName = 'MapsLocalGroceryStore';
	MapsLocalGroceryStore.muiName = 'SvgIcon';
	
	exports.default = MapsLocalGroceryStore;

/***/ },
/* 2521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalHospital = function MapsLocalHospital(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z' })
	  );
	};
	MapsLocalHospital = (0, _pure2.default)(MapsLocalHospital);
	MapsLocalHospital.displayName = 'MapsLocalHospital';
	MapsLocalHospital.muiName = 'SvgIcon';
	
	exports.default = MapsLocalHospital;

/***/ },
/* 2522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalHotel = function MapsLocalHotel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
	  );
	};
	MapsLocalHotel = (0, _pure2.default)(MapsLocalHotel);
	MapsLocalHotel.displayName = 'MapsLocalHotel';
	MapsLocalHotel.muiName = 'SvgIcon';
	
	exports.default = MapsLocalHotel;

/***/ },
/* 2523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalLaundryService = function MapsLocalLaundryService(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
	  );
	};
	MapsLocalLaundryService = (0, _pure2.default)(MapsLocalLaundryService);
	MapsLocalLaundryService.displayName = 'MapsLocalLaundryService';
	MapsLocalLaundryService.muiName = 'SvgIcon';
	
	exports.default = MapsLocalLaundryService;

/***/ },
/* 2524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalLibrary = function MapsLocalLibrary(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z' })
	  );
	};
	MapsLocalLibrary = (0, _pure2.default)(MapsLocalLibrary);
	MapsLocalLibrary.displayName = 'MapsLocalLibrary';
	MapsLocalLibrary.muiName = 'SvgIcon';
	
	exports.default = MapsLocalLibrary;

/***/ },
/* 2525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalMall = function MapsLocalMall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z' })
	  );
	};
	MapsLocalMall = (0, _pure2.default)(MapsLocalMall);
	MapsLocalMall.displayName = 'MapsLocalMall';
	MapsLocalMall.muiName = 'SvgIcon';
	
	exports.default = MapsLocalMall;

/***/ },
/* 2526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalMovies = function MapsLocalMovies(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
	  );
	};
	MapsLocalMovies = (0, _pure2.default)(MapsLocalMovies);
	MapsLocalMovies.displayName = 'MapsLocalMovies';
	MapsLocalMovies.muiName = 'SvgIcon';
	
	exports.default = MapsLocalMovies;

/***/ },
/* 2527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalOffer = function MapsLocalOffer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z' })
	  );
	};
	MapsLocalOffer = (0, _pure2.default)(MapsLocalOffer);
	MapsLocalOffer.displayName = 'MapsLocalOffer';
	MapsLocalOffer.muiName = 'SvgIcon';
	
	exports.default = MapsLocalOffer;

/***/ },
/* 2528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalParking = function MapsLocalParking(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z' })
	  );
	};
	MapsLocalParking = (0, _pure2.default)(MapsLocalParking);
	MapsLocalParking.displayName = 'MapsLocalParking';
	MapsLocalParking.muiName = 'SvgIcon';
	
	exports.default = MapsLocalParking;

/***/ },
/* 2529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPharmacy = function MapsLocalPharmacy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z' })
	  );
	};
	MapsLocalPharmacy = (0, _pure2.default)(MapsLocalPharmacy);
	MapsLocalPharmacy.displayName = 'MapsLocalPharmacy';
	MapsLocalPharmacy.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPharmacy;

/***/ },
/* 2530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPhone = function MapsLocalPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
	  );
	};
	MapsLocalPhone = (0, _pure2.default)(MapsLocalPhone);
	MapsLocalPhone.displayName = 'MapsLocalPhone';
	MapsLocalPhone.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPhone;

/***/ },
/* 2531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPizza = function MapsLocalPizza(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	MapsLocalPizza = (0, _pure2.default)(MapsLocalPizza);
	MapsLocalPizza.displayName = 'MapsLocalPizza';
	MapsLocalPizza.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPizza;

/***/ },
/* 2532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPlay = function MapsLocalPlay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
	  );
	};
	MapsLocalPlay = (0, _pure2.default)(MapsLocalPlay);
	MapsLocalPlay.displayName = 'MapsLocalPlay';
	MapsLocalPlay.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPlay;

/***/ },
/* 2533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPostOffice = function MapsLocalPostOffice(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	MapsLocalPostOffice = (0, _pure2.default)(MapsLocalPostOffice);
	MapsLocalPostOffice.displayName = 'MapsLocalPostOffice';
	MapsLocalPostOffice.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPostOffice;

/***/ },
/* 2534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPrintshop = function MapsLocalPrintshop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
	  );
	};
	MapsLocalPrintshop = (0, _pure2.default)(MapsLocalPrintshop);
	MapsLocalPrintshop.displayName = 'MapsLocalPrintshop';
	MapsLocalPrintshop.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPrintshop;

/***/ },
/* 2535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalSee = function MapsLocalSee(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	MapsLocalSee = (0, _pure2.default)(MapsLocalSee);
	MapsLocalSee.displayName = 'MapsLocalSee';
	MapsLocalSee.muiName = 'SvgIcon';
	
	exports.default = MapsLocalSee;

/***/ },
/* 2536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalShipping = function MapsLocalShipping(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	MapsLocalShipping = (0, _pure2.default)(MapsLocalShipping);
	MapsLocalShipping.displayName = 'MapsLocalShipping';
	MapsLocalShipping.muiName = 'SvgIcon';
	
	exports.default = MapsLocalShipping;

/***/ },
/* 2537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalTaxi = function MapsLocalTaxi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
	  );
	};
	MapsLocalTaxi = (0, _pure2.default)(MapsLocalTaxi);
	MapsLocalTaxi.displayName = 'MapsLocalTaxi';
	MapsLocalTaxi.muiName = 'SvgIcon';
	
	exports.default = MapsLocalTaxi;

/***/ },
/* 2538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsMap = function MapsMap(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z' })
	  );
	};
	MapsMap = (0, _pure2.default)(MapsMap);
	MapsMap.displayName = 'MapsMap';
	MapsMap.muiName = 'SvgIcon';
	
	exports.default = MapsMap;

/***/ },
/* 2539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsMyLocation = function MapsMyLocation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	MapsMyLocation = (0, _pure2.default)(MapsMyLocation);
	MapsMyLocation.displayName = 'MapsMyLocation';
	MapsMyLocation.muiName = 'SvgIcon';
	
	exports.default = MapsMyLocation;

/***/ },
/* 2540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsNavigation = function MapsNavigation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z' })
	  );
	};
	MapsNavigation = (0, _pure2.default)(MapsNavigation);
	MapsNavigation.displayName = 'MapsNavigation';
	MapsNavigation.muiName = 'SvgIcon';
	
	exports.default = MapsNavigation;

/***/ },
/* 2541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsNearMe = function MapsNearMe(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z' })
	  );
	};
	MapsNearMe = (0, _pure2.default)(MapsNearMe);
	MapsNearMe.displayName = 'MapsNearMe';
	MapsNearMe.muiName = 'SvgIcon';
	
	exports.default = MapsNearMe;

/***/ },
/* 2542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPersonPinCircle = function MapsPersonPinCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z' })
	  );
	};
	MapsPersonPinCircle = (0, _pure2.default)(MapsPersonPinCircle);
	MapsPersonPinCircle.displayName = 'MapsPersonPinCircle';
	MapsPersonPinCircle.muiName = 'SvgIcon';
	
	exports.default = MapsPersonPinCircle;

/***/ },
/* 2543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPersonPin = function MapsPersonPin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z' })
	  );
	};
	MapsPersonPin = (0, _pure2.default)(MapsPersonPin);
	MapsPersonPin.displayName = 'MapsPersonPin';
	MapsPersonPin.muiName = 'SvgIcon';
	
	exports.default = MapsPersonPin;

/***/ },
/* 2544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPinDrop = function MapsPinDrop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z' })
	  );
	};
	MapsPinDrop = (0, _pure2.default)(MapsPinDrop);
	MapsPinDrop.displayName = 'MapsPinDrop';
	MapsPinDrop.muiName = 'SvgIcon';
	
	exports.default = MapsPinDrop;

/***/ },
/* 2545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPlace = function MapsPlace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	MapsPlace = (0, _pure2.default)(MapsPlace);
	MapsPlace.displayName = 'MapsPlace';
	MapsPlace.muiName = 'SvgIcon';
	
	exports.default = MapsPlace;

/***/ },
/* 2546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsRateReview = function MapsRateReview(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z' })
	  );
	};
	MapsRateReview = (0, _pure2.default)(MapsRateReview);
	MapsRateReview.displayName = 'MapsRateReview';
	MapsRateReview.muiName = 'SvgIcon';
	
	exports.default = MapsRateReview;

/***/ },
/* 2547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsRestaurantMenu = function MapsRestaurantMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
	  );
	};
	MapsRestaurantMenu = (0, _pure2.default)(MapsRestaurantMenu);
	MapsRestaurantMenu.displayName = 'MapsRestaurantMenu';
	MapsRestaurantMenu.muiName = 'SvgIcon';
	
	exports.default = MapsRestaurantMenu;

/***/ },
/* 2548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsRestaurant = function MapsRestaurant(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z' })
	  );
	};
	MapsRestaurant = (0, _pure2.default)(MapsRestaurant);
	MapsRestaurant.displayName = 'MapsRestaurant';
	MapsRestaurant.muiName = 'SvgIcon';
	
	exports.default = MapsRestaurant;

/***/ },
/* 2549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsSatellite = function MapsSatellite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z' })
	  );
	};
	MapsSatellite = (0, _pure2.default)(MapsSatellite);
	MapsSatellite.displayName = 'MapsSatellite';
	MapsSatellite.muiName = 'SvgIcon';
	
	exports.default = MapsSatellite;

/***/ },
/* 2550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsStoreMallDirectory = function MapsStoreMallDirectory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
	  );
	};
	MapsStoreMallDirectory = (0, _pure2.default)(MapsStoreMallDirectory);
	MapsStoreMallDirectory.displayName = 'MapsStoreMallDirectory';
	MapsStoreMallDirectory.muiName = 'SvgIcon';
	
	exports.default = MapsStoreMallDirectory;

/***/ },
/* 2551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsStreetview = function MapsStreetview(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z' }),
	    _react2.default.createElement('circle', { cx: '18', cy: '6', r: '5' }),
	    _react2.default.createElement('path', { d: 'M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z' })
	  );
	};
	MapsStreetview = (0, _pure2.default)(MapsStreetview);
	MapsStreetview.displayName = 'MapsStreetview';
	MapsStreetview.muiName = 'SvgIcon';
	
	exports.default = MapsStreetview;

/***/ },
/* 2552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsSubway = function MapsSubway(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '15.5', cy: '16', r: '1' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '16', r: '1' }),
	    _react2.default.createElement('path', { d: 'M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z' })
	  );
	};
	MapsSubway = (0, _pure2.default)(MapsSubway);
	MapsSubway.displayName = 'MapsSubway';
	MapsSubway.muiName = 'SvgIcon';
	
	exports.default = MapsSubway;

/***/ },
/* 2553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTerrain = function MapsTerrain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
	  );
	};
	MapsTerrain = (0, _pure2.default)(MapsTerrain);
	MapsTerrain.displayName = 'MapsTerrain';
	MapsTerrain.muiName = 'SvgIcon';
	
	exports.default = MapsTerrain;

/***/ },
/* 2554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTraffic = function MapsTraffic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z' })
	  );
	};
	MapsTraffic = (0, _pure2.default)(MapsTraffic);
	MapsTraffic.displayName = 'MapsTraffic';
	MapsTraffic.muiName = 'SvgIcon';
	
	exports.default = MapsTraffic;

/***/ },
/* 2555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTrain = function MapsTrain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	MapsTrain = (0, _pure2.default)(MapsTrain);
	MapsTrain.displayName = 'MapsTrain';
	MapsTrain.muiName = 'SvgIcon';
	
	exports.default = MapsTrain;

/***/ },
/* 2556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTram = function MapsTram(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z' })
	  );
	};
	MapsTram = (0, _pure2.default)(MapsTram);
	MapsTram.displayName = 'MapsTram';
	MapsTram.muiName = 'SvgIcon';
	
	exports.default = MapsTram;

/***/ },
/* 2557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTransferWithinAStation = function MapsTransferWithinAStation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75' })
	  );
	};
	MapsTransferWithinAStation = (0, _pure2.default)(MapsTransferWithinAStation);
	MapsTransferWithinAStation.displayName = 'MapsTransferWithinAStation';
	MapsTransferWithinAStation.muiName = 'SvgIcon';
	
	exports.default = MapsTransferWithinAStation;

/***/ },
/* 2558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsZoomOutMap = function MapsZoomOutMap(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z' })
	  );
	};
	MapsZoomOutMap = (0, _pure2.default)(MapsZoomOutMap);
	MapsZoomOutMap.displayName = 'MapsZoomOutMap';
	MapsZoomOutMap.muiName = 'SvgIcon';
	
	exports.default = MapsZoomOutMap;

/***/ },
/* 2559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropRight = function NavigationArrowDropRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.5,7l5,5l-5,5V7z' })
	  );
	};
	
	NavigationArrowDropRight = (0, _pure2.default)(NavigationArrowDropRight);
	NavigationArrowDropRight.displayName = 'NavigationArrowDropRight';
	NavigationArrowDropRight.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropRight;

/***/ },
/* 2560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationApps = function NavigationApps(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z' })
	  );
	};
	NavigationApps = (0, _pure2.default)(NavigationApps);
	NavigationApps.displayName = 'NavigationApps';
	NavigationApps.muiName = 'SvgIcon';
	
	exports.default = NavigationApps;

/***/ },
/* 2561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowBack = function NavigationArrowBack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
	  );
	};
	NavigationArrowBack = (0, _pure2.default)(NavigationArrowBack);
	NavigationArrowBack.displayName = 'NavigationArrowBack';
	NavigationArrowBack.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowBack;

/***/ },
/* 2562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDownward = function NavigationArrowDownward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' })
	  );
	};
	NavigationArrowDownward = (0, _pure2.default)(NavigationArrowDownward);
	NavigationArrowDownward.displayName = 'NavigationArrowDownward';
	NavigationArrowDownward.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDownward;

/***/ },
/* 2563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDownCircle = function NavigationArrowDropDownCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z' })
	  );
	};
	NavigationArrowDropDownCircle = (0, _pure2.default)(NavigationArrowDropDownCircle);
	NavigationArrowDropDownCircle.displayName = 'NavigationArrowDropDownCircle';
	NavigationArrowDropDownCircle.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDownCircle;

/***/ },
/* 2564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowForward = function NavigationArrowForward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z' })
	  );
	};
	NavigationArrowForward = (0, _pure2.default)(NavigationArrowForward);
	NavigationArrowForward.displayName = 'NavigationArrowForward';
	NavigationArrowForward.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowForward;

/***/ },
/* 2565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowUpward = function NavigationArrowUpward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z' })
	  );
	};
	NavigationArrowUpward = (0, _pure2.default)(NavigationArrowUpward);
	NavigationArrowUpward.displayName = 'NavigationArrowUpward';
	NavigationArrowUpward.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowUpward;

/***/ },
/* 2566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFirstPage = function NavigationFirstPage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z' })
	  );
	};
	NavigationFirstPage = (0, _pure2.default)(NavigationFirstPage);
	NavigationFirstPage.displayName = 'NavigationFirstPage';
	NavigationFirstPage.muiName = 'SvgIcon';
	
	exports.default = NavigationFirstPage;

/***/ },
/* 2567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFullscreenExit = function NavigationFullscreenExit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z' })
	  );
	};
	NavigationFullscreenExit = (0, _pure2.default)(NavigationFullscreenExit);
	NavigationFullscreenExit.displayName = 'NavigationFullscreenExit';
	NavigationFullscreenExit.muiName = 'SvgIcon';
	
	exports.default = NavigationFullscreenExit;

/***/ },
/* 2568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFullscreen = function NavigationFullscreen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z' })
	  );
	};
	NavigationFullscreen = (0, _pure2.default)(NavigationFullscreen);
	NavigationFullscreen.displayName = 'NavigationFullscreen';
	NavigationFullscreen.muiName = 'SvgIcon';
	
	exports.default = NavigationFullscreen;

/***/ },
/* 2569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationLastPage = function NavigationLastPage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z' })
	  );
	};
	NavigationLastPage = (0, _pure2.default)(NavigationLastPage);
	NavigationLastPage.displayName = 'NavigationLastPage';
	NavigationLastPage.muiName = 'SvgIcon';
	
	exports.default = NavigationLastPage;

/***/ },
/* 2570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMoreVert = function NavigationMoreVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
	NavigationMoreVert.displayName = 'NavigationMoreVert';
	NavigationMoreVert.muiName = 'SvgIcon';
	
	exports.default = NavigationMoreVert;

/***/ },
/* 2571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationRefresh = function NavigationRefresh(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z' })
	  );
	};
	NavigationRefresh = (0, _pure2.default)(NavigationRefresh);
	NavigationRefresh.displayName = 'NavigationRefresh';
	NavigationRefresh.muiName = 'SvgIcon';
	
	exports.default = NavigationRefresh;

/***/ },
/* 2572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationSubdirectoryArrowLeft = function NavigationSubdirectoryArrowLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z' })
	  );
	};
	NavigationSubdirectoryArrowLeft = (0, _pure2.default)(NavigationSubdirectoryArrowLeft);
	NavigationSubdirectoryArrowLeft.displayName = 'NavigationSubdirectoryArrowLeft';
	NavigationSubdirectoryArrowLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationSubdirectoryArrowLeft;

/***/ },
/* 2573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationSubdirectoryArrowRight = function NavigationSubdirectoryArrowRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z' })
	  );
	};
	NavigationSubdirectoryArrowRight = (0, _pure2.default)(NavigationSubdirectoryArrowRight);
	NavigationSubdirectoryArrowRight.displayName = 'NavigationSubdirectoryArrowRight';
	NavigationSubdirectoryArrowRight.muiName = 'SvgIcon';
	
	exports.default = NavigationSubdirectoryArrowRight;

/***/ },
/* 2574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationUnfoldLess = function NavigationUnfoldLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z' })
	  );
	};
	NavigationUnfoldLess = (0, _pure2.default)(NavigationUnfoldLess);
	NavigationUnfoldLess.displayName = 'NavigationUnfoldLess';
	NavigationUnfoldLess.muiName = 'SvgIcon';
	
	exports.default = NavigationUnfoldLess;

/***/ },
/* 2575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationUnfoldMore = function NavigationUnfoldMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z' })
	  );
	};
	NavigationUnfoldMore = (0, _pure2.default)(NavigationUnfoldMore);
	NavigationUnfoldMore.displayName = 'NavigationUnfoldMore';
	NavigationUnfoldMore.muiName = 'SvgIcon';
	
	exports.default = NavigationUnfoldMore;

/***/ },
/* 2576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAdb = function NotificationAdb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	NotificationAdb = (0, _pure2.default)(NotificationAdb);
	NotificationAdb.displayName = 'NotificationAdb';
	NotificationAdb.muiName = 'SvgIcon';
	
	exports.default = NotificationAdb;

/***/ },
/* 2577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatFlatAngled = function NotificationAirlineSeatFlatAngled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z' })
	  );
	};
	NotificationAirlineSeatFlatAngled = (0, _pure2.default)(NotificationAirlineSeatFlatAngled);
	NotificationAirlineSeatFlatAngled.displayName = 'NotificationAirlineSeatFlatAngled';
	NotificationAirlineSeatFlatAngled.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatFlatAngled;

/***/ },
/* 2578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatFlat = function NotificationAirlineSeatFlat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z' })
	  );
	};
	NotificationAirlineSeatFlat = (0, _pure2.default)(NotificationAirlineSeatFlat);
	NotificationAirlineSeatFlat.displayName = 'NotificationAirlineSeatFlat';
	NotificationAirlineSeatFlat.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatFlat;

/***/ },
/* 2579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatIndividualSuite = function NotificationAirlineSeatIndividualSuite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z' })
	  );
	};
	NotificationAirlineSeatIndividualSuite = (0, _pure2.default)(NotificationAirlineSeatIndividualSuite);
	NotificationAirlineSeatIndividualSuite.displayName = 'NotificationAirlineSeatIndividualSuite';
	NotificationAirlineSeatIndividualSuite.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatIndividualSuite;

/***/ },
/* 2580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatLegroomExtra = function NotificationAirlineSeatLegroomExtra(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z' })
	  );
	};
	NotificationAirlineSeatLegroomExtra = (0, _pure2.default)(NotificationAirlineSeatLegroomExtra);
	NotificationAirlineSeatLegroomExtra.displayName = 'NotificationAirlineSeatLegroomExtra';
	NotificationAirlineSeatLegroomExtra.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatLegroomExtra;

/***/ },
/* 2581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatLegroomNormal = function NotificationAirlineSeatLegroomNormal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z' })
	  );
	};
	NotificationAirlineSeatLegroomNormal = (0, _pure2.default)(NotificationAirlineSeatLegroomNormal);
	NotificationAirlineSeatLegroomNormal.displayName = 'NotificationAirlineSeatLegroomNormal';
	NotificationAirlineSeatLegroomNormal.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatLegroomNormal;

/***/ },
/* 2582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatLegroomReduced = function NotificationAirlineSeatLegroomReduced(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z' })
	  );
	};
	NotificationAirlineSeatLegroomReduced = (0, _pure2.default)(NotificationAirlineSeatLegroomReduced);
	NotificationAirlineSeatLegroomReduced.displayName = 'NotificationAirlineSeatLegroomReduced';
	NotificationAirlineSeatLegroomReduced.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatLegroomReduced;

/***/ },
/* 2583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatReclineExtra = function NotificationAirlineSeatReclineExtra(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z' })
	  );
	};
	NotificationAirlineSeatReclineExtra = (0, _pure2.default)(NotificationAirlineSeatReclineExtra);
	NotificationAirlineSeatReclineExtra.displayName = 'NotificationAirlineSeatReclineExtra';
	NotificationAirlineSeatReclineExtra.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatReclineExtra;

/***/ },
/* 2584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatReclineNormal = function NotificationAirlineSeatReclineNormal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z' })
	  );
	};
	NotificationAirlineSeatReclineNormal = (0, _pure2.default)(NotificationAirlineSeatReclineNormal);
	NotificationAirlineSeatReclineNormal.displayName = 'NotificationAirlineSeatReclineNormal';
	NotificationAirlineSeatReclineNormal.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatReclineNormal;

/***/ },
/* 2585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationBluetoothAudio = function NotificationBluetoothAudio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
	  );
	};
	NotificationBluetoothAudio = (0, _pure2.default)(NotificationBluetoothAudio);
	NotificationBluetoothAudio.displayName = 'NotificationBluetoothAudio';
	NotificationBluetoothAudio.muiName = 'SvgIcon';
	
	exports.default = NotificationBluetoothAudio;

/***/ },
/* 2586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationConfirmationNumber = function NotificationConfirmationNumber(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z' })
	  );
	};
	NotificationConfirmationNumber = (0, _pure2.default)(NotificationConfirmationNumber);
	NotificationConfirmationNumber.displayName = 'NotificationConfirmationNumber';
	NotificationConfirmationNumber.muiName = 'SvgIcon';
	
	exports.default = NotificationConfirmationNumber;

/***/ },
/* 2587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDiscFull = function NotificationDiscFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	NotificationDiscFull = (0, _pure2.default)(NotificationDiscFull);
	NotificationDiscFull.displayName = 'NotificationDiscFull';
	NotificationDiscFull.muiName = 'SvgIcon';
	
	exports.default = NotificationDiscFull;

/***/ },
/* 2588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturbAlt = function NotificationDoNotDisturbAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z' })
	  );
	};
	NotificationDoNotDisturbAlt = (0, _pure2.default)(NotificationDoNotDisturbAlt);
	NotificationDoNotDisturbAlt.displayName = 'NotificationDoNotDisturbAlt';
	NotificationDoNotDisturbAlt.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturbAlt;

/***/ },
/* 2589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturbOff = function NotificationDoNotDisturbOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 11v2h-1.46l4.68 4.68C21.34 16.07 22 14.11 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78C2.66 7.93 2 9.89 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z' })
	  );
	};
	NotificationDoNotDisturbOff = (0, _pure2.default)(NotificationDoNotDisturbOff);
	NotificationDoNotDisturbOff.displayName = 'NotificationDoNotDisturbOff';
	NotificationDoNotDisturbOff.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturbOff;

/***/ },
/* 2590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturbOn = function NotificationDoNotDisturbOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
	  );
	};
	NotificationDoNotDisturbOn = (0, _pure2.default)(NotificationDoNotDisturbOn);
	NotificationDoNotDisturbOn.displayName = 'NotificationDoNotDisturbOn';
	NotificationDoNotDisturbOn.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturbOn;

/***/ },
/* 2591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturb = function NotificationDoNotDisturb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
	  );
	};
	NotificationDoNotDisturb = (0, _pure2.default)(NotificationDoNotDisturb);
	NotificationDoNotDisturb.displayName = 'NotificationDoNotDisturb';
	NotificationDoNotDisturb.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturb;

/***/ },
/* 2592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDriveEta = function NotificationDriveEta(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
	  );
	};
	NotificationDriveEta = (0, _pure2.default)(NotificationDriveEta);
	NotificationDriveEta.displayName = 'NotificationDriveEta';
	NotificationDriveEta.muiName = 'SvgIcon';
	
	exports.default = NotificationDriveEta;

/***/ },
/* 2593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEnhancedEncryption = function NotificationEnhancedEncryption(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z' })
	  );
	};
	NotificationEnhancedEncryption = (0, _pure2.default)(NotificationEnhancedEncryption);
	NotificationEnhancedEncryption.displayName = 'NotificationEnhancedEncryption';
	NotificationEnhancedEncryption.muiName = 'SvgIcon';
	
	exports.default = NotificationEnhancedEncryption;

/***/ },
/* 2594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventAvailable = function NotificationEventAvailable(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
	  );
	};
	NotificationEventAvailable = (0, _pure2.default)(NotificationEventAvailable);
	NotificationEventAvailable.displayName = 'NotificationEventAvailable';
	NotificationEventAvailable.muiName = 'SvgIcon';
	
	exports.default = NotificationEventAvailable;

/***/ },
/* 2595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventBusy = function NotificationEventBusy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
	  );
	};
	NotificationEventBusy = (0, _pure2.default)(NotificationEventBusy);
	NotificationEventBusy.displayName = 'NotificationEventBusy';
	NotificationEventBusy.muiName = 'SvgIcon';
	
	exports.default = NotificationEventBusy;

/***/ },
/* 2596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventNote = function NotificationEventNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z' })
	  );
	};
	NotificationEventNote = (0, _pure2.default)(NotificationEventNote);
	NotificationEventNote.displayName = 'NotificationEventNote';
	NotificationEventNote.muiName = 'SvgIcon';
	
	exports.default = NotificationEventNote;

/***/ },
/* 2597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationFolderSpecial = function NotificationFolderSpecial(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z' })
	  );
	};
	NotificationFolderSpecial = (0, _pure2.default)(NotificationFolderSpecial);
	NotificationFolderSpecial.displayName = 'NotificationFolderSpecial';
	NotificationFolderSpecial.muiName = 'SvgIcon';
	
	exports.default = NotificationFolderSpecial;

/***/ },
/* 2598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationLiveTv = function NotificationLiveTv(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z' })
	  );
	};
	NotificationLiveTv = (0, _pure2.default)(NotificationLiveTv);
	NotificationLiveTv.displayName = 'NotificationLiveTv';
	NotificationLiveTv.muiName = 'SvgIcon';
	
	exports.default = NotificationLiveTv;

/***/ },
/* 2599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationMms = function NotificationMms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z' })
	  );
	};
	NotificationMms = (0, _pure2.default)(NotificationMms);
	NotificationMms.displayName = 'NotificationMms';
	NotificationMms.muiName = 'SvgIcon';
	
	exports.default = NotificationMms;

/***/ },
/* 2600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationMore = function NotificationMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	NotificationMore = (0, _pure2.default)(NotificationMore);
	NotificationMore.displayName = 'NotificationMore';
	NotificationMore.muiName = 'SvgIcon';
	
	exports.default = NotificationMore;

/***/ },
/* 2601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationNetworkCheck = function NotificationNetworkCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z' })
	  );
	};
	NotificationNetworkCheck = (0, _pure2.default)(NotificationNetworkCheck);
	NotificationNetworkCheck.displayName = 'NotificationNetworkCheck';
	NotificationNetworkCheck.muiName = 'SvgIcon';
	
	exports.default = NotificationNetworkCheck;

/***/ },
/* 2602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationNetworkLocked = function NotificationNetworkLocked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
	  );
	};
	NotificationNetworkLocked = (0, _pure2.default)(NotificationNetworkLocked);
	NotificationNetworkLocked.displayName = 'NotificationNetworkLocked';
	NotificationNetworkLocked.muiName = 'SvgIcon';
	
	exports.default = NotificationNetworkLocked;

/***/ },
/* 2603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationNoEncryption = function NotificationNoEncryption(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z' })
	  );
	};
	NotificationNoEncryption = (0, _pure2.default)(NotificationNoEncryption);
	NotificationNoEncryption.displayName = 'NotificationNoEncryption';
	NotificationNoEncryption.muiName = 'SvgIcon';
	
	exports.default = NotificationNoEncryption;

/***/ },
/* 2604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationOndemandVideo = function NotificationOndemandVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z' })
	  );
	};
	NotificationOndemandVideo = (0, _pure2.default)(NotificationOndemandVideo);
	NotificationOndemandVideo.displayName = 'NotificationOndemandVideo';
	NotificationOndemandVideo.muiName = 'SvgIcon';
	
	exports.default = NotificationOndemandVideo;

/***/ },
/* 2605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPersonalVideo = function NotificationPersonalVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z' })
	  );
	};
	NotificationPersonalVideo = (0, _pure2.default)(NotificationPersonalVideo);
	NotificationPersonalVideo.displayName = 'NotificationPersonalVideo';
	NotificationPersonalVideo.muiName = 'SvgIcon';
	
	exports.default = NotificationPersonalVideo;

/***/ },
/* 2606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneBluetoothSpeaker = function NotificationPhoneBluetoothSpeaker(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
	  );
	};
	NotificationPhoneBluetoothSpeaker = (0, _pure2.default)(NotificationPhoneBluetoothSpeaker);
	NotificationPhoneBluetoothSpeaker.displayName = 'NotificationPhoneBluetoothSpeaker';
	NotificationPhoneBluetoothSpeaker.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneBluetoothSpeaker;

/***/ },
/* 2607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneForwarded = function NotificationPhoneForwarded(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
	  );
	};
	NotificationPhoneForwarded = (0, _pure2.default)(NotificationPhoneForwarded);
	NotificationPhoneForwarded.displayName = 'NotificationPhoneForwarded';
	NotificationPhoneForwarded.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneForwarded;

/***/ },
/* 2608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneInTalk = function NotificationPhoneInTalk(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z' })
	  );
	};
	NotificationPhoneInTalk = (0, _pure2.default)(NotificationPhoneInTalk);
	NotificationPhoneInTalk.displayName = 'NotificationPhoneInTalk';
	NotificationPhoneInTalk.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneInTalk;

/***/ },
/* 2609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneLocked = function NotificationPhoneLocked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z' })
	  );
	};
	NotificationPhoneLocked = (0, _pure2.default)(NotificationPhoneLocked);
	NotificationPhoneLocked.displayName = 'NotificationPhoneLocked';
	NotificationPhoneLocked.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneLocked;

/***/ },
/* 2610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneMissed = function NotificationPhoneMissed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z' })
	  );
	};
	NotificationPhoneMissed = (0, _pure2.default)(NotificationPhoneMissed);
	NotificationPhoneMissed.displayName = 'NotificationPhoneMissed';
	NotificationPhoneMissed.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneMissed;

/***/ },
/* 2611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhonePaused = function NotificationPhonePaused(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z' })
	  );
	};
	NotificationPhonePaused = (0, _pure2.default)(NotificationPhonePaused);
	NotificationPhonePaused.displayName = 'NotificationPhonePaused';
	NotificationPhonePaused.muiName = 'SvgIcon';
	
	exports.default = NotificationPhonePaused;

/***/ },
/* 2612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPower = function NotificationPower(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z' })
	  );
	};
	NotificationPower = (0, _pure2.default)(NotificationPower);
	NotificationPower.displayName = 'NotificationPower';
	NotificationPower.muiName = 'SvgIcon';
	
	exports.default = NotificationPower;

/***/ },
/* 2613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPriorityHigh = function NotificationPriorityHigh(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '19', r: '2' }),
	    _react2.default.createElement('path', { d: 'M10 3h4v12h-4z' })
	  );
	};
	NotificationPriorityHigh = (0, _pure2.default)(NotificationPriorityHigh);
	NotificationPriorityHigh.displayName = 'NotificationPriorityHigh';
	NotificationPriorityHigh.muiName = 'SvgIcon';
	
	exports.default = NotificationPriorityHigh;

/***/ },
/* 2614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationRvHookup = function NotificationRvHookup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z' })
	  );
	};
	NotificationRvHookup = (0, _pure2.default)(NotificationRvHookup);
	NotificationRvHookup.displayName = 'NotificationRvHookup';
	NotificationRvHookup.muiName = 'SvgIcon';
	
	exports.default = NotificationRvHookup;

/***/ },
/* 2615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSdCard = function NotificationSdCard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
	  );
	};
	NotificationSdCard = (0, _pure2.default)(NotificationSdCard);
	NotificationSdCard.displayName = 'NotificationSdCard';
	NotificationSdCard.muiName = 'SvgIcon';
	
	exports.default = NotificationSdCard;

/***/ },
/* 2616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSimCardAlert = function NotificationSimCardAlert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z' })
	  );
	};
	NotificationSimCardAlert = (0, _pure2.default)(NotificationSimCardAlert);
	NotificationSimCardAlert.displayName = 'NotificationSimCardAlert';
	NotificationSimCardAlert.muiName = 'SvgIcon';
	
	exports.default = NotificationSimCardAlert;

/***/ },
/* 2617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSmsFailed = function NotificationSmsFailed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
	  );
	};
	NotificationSmsFailed = (0, _pure2.default)(NotificationSmsFailed);
	NotificationSmsFailed.displayName = 'NotificationSmsFailed';
	NotificationSmsFailed.muiName = 'SvgIcon';
	
	exports.default = NotificationSmsFailed;

/***/ },
/* 2618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSms = function NotificationSms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
	  );
	};
	NotificationSms = (0, _pure2.default)(NotificationSms);
	NotificationSms.displayName = 'NotificationSms';
	NotificationSms.muiName = 'SvgIcon';
	
	exports.default = NotificationSms;

/***/ },
/* 2619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSyncDisabled = function NotificationSyncDisabled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z' })
	  );
	};
	NotificationSyncDisabled = (0, _pure2.default)(NotificationSyncDisabled);
	NotificationSyncDisabled.displayName = 'NotificationSyncDisabled';
	NotificationSyncDisabled.muiName = 'SvgIcon';
	
	exports.default = NotificationSyncDisabled;

/***/ },
/* 2620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSyncProblem = function NotificationSyncProblem(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z' })
	  );
	};
	NotificationSyncProblem = (0, _pure2.default)(NotificationSyncProblem);
	NotificationSyncProblem.displayName = 'NotificationSyncProblem';
	NotificationSyncProblem.muiName = 'SvgIcon';
	
	exports.default = NotificationSyncProblem;

/***/ },
/* 2621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSync = function NotificationSync(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
	  );
	};
	NotificationSync = (0, _pure2.default)(NotificationSync);
	NotificationSync.displayName = 'NotificationSync';
	NotificationSync.muiName = 'SvgIcon';
	
	exports.default = NotificationSync;

/***/ },
/* 2622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSystemUpdate = function NotificationSystemUpdate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z' })
	  );
	};
	NotificationSystemUpdate = (0, _pure2.default)(NotificationSystemUpdate);
	NotificationSystemUpdate.displayName = 'NotificationSystemUpdate';
	NotificationSystemUpdate.muiName = 'SvgIcon';
	
	exports.default = NotificationSystemUpdate;

/***/ },
/* 2623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationTapAndPlay = function NotificationTapAndPlay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z' })
	  );
	};
	NotificationTapAndPlay = (0, _pure2.default)(NotificationTapAndPlay);
	NotificationTapAndPlay.displayName = 'NotificationTapAndPlay';
	NotificationTapAndPlay.muiName = 'SvgIcon';
	
	exports.default = NotificationTapAndPlay;

/***/ },
/* 2624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationTimeToLeave = function NotificationTimeToLeave(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
	  );
	};
	NotificationTimeToLeave = (0, _pure2.default)(NotificationTimeToLeave);
	NotificationTimeToLeave.displayName = 'NotificationTimeToLeave';
	NotificationTimeToLeave.muiName = 'SvgIcon';
	
	exports.default = NotificationTimeToLeave;

/***/ },
/* 2625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationVibration = function NotificationVibration(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z' })
	  );
	};
	NotificationVibration = (0, _pure2.default)(NotificationVibration);
	NotificationVibration.displayName = 'NotificationVibration';
	NotificationVibration.muiName = 'SvgIcon';
	
	exports.default = NotificationVibration;

/***/ },
/* 2626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationVoiceChat = function NotificationVoiceChat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z' })
	  );
	};
	NotificationVoiceChat = (0, _pure2.default)(NotificationVoiceChat);
	NotificationVoiceChat.displayName = 'NotificationVoiceChat';
	NotificationVoiceChat.muiName = 'SvgIcon';
	
	exports.default = NotificationVoiceChat;

/***/ },
/* 2627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationVpnLock = function NotificationVpnLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z' })
	  );
	};
	NotificationVpnLock = (0, _pure2.default)(NotificationVpnLock);
	NotificationVpnLock.displayName = 'NotificationVpnLock';
	NotificationVpnLock.muiName = 'SvgIcon';
	
	exports.default = NotificationVpnLock;

/***/ },
/* 2628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationWc = function NotificationWc(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z' })
	  );
	};
	NotificationWc = (0, _pure2.default)(NotificationWc);
	NotificationWc.displayName = 'NotificationWc';
	NotificationWc.muiName = 'SvgIcon';
	
	exports.default = NotificationWc;

/***/ },
/* 2629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationWifi = function NotificationWifi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z' })
	  );
	};
	NotificationWifi = (0, _pure2.default)(NotificationWifi);
	NotificationWifi.displayName = 'NotificationWifi';
	NotificationWifi.muiName = 'SvgIcon';
	
	exports.default = NotificationWifi;

/***/ },
/* 2630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesAcUnit = function PlacesAcUnit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z' })
	  );
	};
	PlacesAcUnit = (0, _pure2.default)(PlacesAcUnit);
	PlacesAcUnit.displayName = 'PlacesAcUnit';
	PlacesAcUnit.muiName = 'SvgIcon';
	
	exports.default = PlacesAcUnit;

/***/ },
/* 2631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesAirportShuttle = function PlacesAirportShuttle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z' })
	  );
	};
	PlacesAirportShuttle = (0, _pure2.default)(PlacesAirportShuttle);
	PlacesAirportShuttle.displayName = 'PlacesAirportShuttle';
	PlacesAirportShuttle.muiName = 'SvgIcon';
	
	exports.default = PlacesAirportShuttle;

/***/ },
/* 2632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesAllInclusive = function PlacesAllInclusive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z' })
	  );
	};
	PlacesAllInclusive = (0, _pure2.default)(PlacesAllInclusive);
	PlacesAllInclusive.displayName = 'PlacesAllInclusive';
	PlacesAllInclusive.muiName = 'SvgIcon';
	
	exports.default = PlacesAllInclusive;

/***/ },
/* 2633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesBeachAccess = function PlacesBeachAccess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z' })
	  );
	};
	PlacesBeachAccess = (0, _pure2.default)(PlacesBeachAccess);
	PlacesBeachAccess.displayName = 'PlacesBeachAccess';
	PlacesBeachAccess.muiName = 'SvgIcon';
	
	exports.default = PlacesBeachAccess;

/***/ },
/* 2634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesBusinessCenter = function PlacesBusinessCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z' })
	  );
	};
	PlacesBusinessCenter = (0, _pure2.default)(PlacesBusinessCenter);
	PlacesBusinessCenter.displayName = 'PlacesBusinessCenter';
	PlacesBusinessCenter.muiName = 'SvgIcon';
	
	exports.default = PlacesBusinessCenter;

/***/ },
/* 2635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesCasino = function PlacesCasino(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z' })
	  );
	};
	PlacesCasino = (0, _pure2.default)(PlacesCasino);
	PlacesCasino.displayName = 'PlacesCasino';
	PlacesCasino.muiName = 'SvgIcon';
	
	exports.default = PlacesCasino;

/***/ },
/* 2636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesChildCare = function PlacesChildCare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '14.5', cy: '10.5', r: '1.25' }),
	    _react2.default.createElement('circle', { cx: '9.5', cy: '10.5', r: '1.25' }),
	    _react2.default.createElement('path', { d: 'M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z' })
	  );
	};
	PlacesChildCare = (0, _pure2.default)(PlacesChildCare);
	PlacesChildCare.displayName = 'PlacesChildCare';
	PlacesChildCare.muiName = 'SvgIcon';
	
	exports.default = PlacesChildCare;

/***/ },
/* 2637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesChildFriendly = function PlacesChildFriendly(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z' })
	  );
	};
	PlacesChildFriendly = (0, _pure2.default)(PlacesChildFriendly);
	PlacesChildFriendly.displayName = 'PlacesChildFriendly';
	PlacesChildFriendly.muiName = 'SvgIcon';
	
	exports.default = PlacesChildFriendly;

/***/ },
/* 2638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesFitnessCenter = function PlacesFitnessCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z' })
	  );
	};
	PlacesFitnessCenter = (0, _pure2.default)(PlacesFitnessCenter);
	PlacesFitnessCenter.displayName = 'PlacesFitnessCenter';
	PlacesFitnessCenter.muiName = 'SvgIcon';
	
	exports.default = PlacesFitnessCenter;

/***/ },
/* 2639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesFreeBreakfast = function PlacesFreeBreakfast(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z' })
	  );
	};
	PlacesFreeBreakfast = (0, _pure2.default)(PlacesFreeBreakfast);
	PlacesFreeBreakfast.displayName = 'PlacesFreeBreakfast';
	PlacesFreeBreakfast.muiName = 'SvgIcon';
	
	exports.default = PlacesFreeBreakfast;

/***/ },
/* 2640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesGolfCourse = function PlacesGolfCourse(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '19.5', cy: '19.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z' })
	  );
	};
	PlacesGolfCourse = (0, _pure2.default)(PlacesGolfCourse);
	PlacesGolfCourse.displayName = 'PlacesGolfCourse';
	PlacesGolfCourse.muiName = 'SvgIcon';
	
	exports.default = PlacesGolfCourse;

/***/ },
/* 2641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesHotTub = function PlacesHotTub(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '7', cy: '6', r: '2' }),
	    _react2.default.createElement('path', { d: 'M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z' })
	  );
	};
	PlacesHotTub = (0, _pure2.default)(PlacesHotTub);
	PlacesHotTub.displayName = 'PlacesHotTub';
	PlacesHotTub.muiName = 'SvgIcon';
	
	exports.default = PlacesHotTub;

/***/ },
/* 2642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesKitchen = function PlacesKitchen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z' })
	  );
	};
	PlacesKitchen = (0, _pure2.default)(PlacesKitchen);
	PlacesKitchen.displayName = 'PlacesKitchen';
	PlacesKitchen.muiName = 'SvgIcon';
	
	exports.default = PlacesKitchen;

/***/ },
/* 2643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesPool = function PlacesPool(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z' }),
	    _react2.default.createElement('circle', { cx: '16.5', cy: '5.5', r: '2.5' })
	  );
	};
	PlacesPool = (0, _pure2.default)(PlacesPool);
	PlacesPool.displayName = 'PlacesPool';
	PlacesPool.muiName = 'SvgIcon';
	
	exports.default = PlacesPool;

/***/ },
/* 2644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesRoomService = function PlacesRoomService(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z' })
	  );
	};
	PlacesRoomService = (0, _pure2.default)(PlacesRoomService);
	PlacesRoomService.displayName = 'PlacesRoomService';
	PlacesRoomService.muiName = 'SvgIcon';
	
	exports.default = PlacesRoomService;

/***/ },
/* 2645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesRvHookup = function PlacesRvHookup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z' })
	  );
	};
	PlacesRvHookup = (0, _pure2.default)(PlacesRvHookup);
	PlacesRvHookup.displayName = 'PlacesRvHookup';
	PlacesRvHookup.muiName = 'SvgIcon';
	
	exports.default = PlacesRvHookup;

/***/ },
/* 2646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesSmokeFree = function PlacesSmokeFree(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z' })
	  );
	};
	PlacesSmokeFree = (0, _pure2.default)(PlacesSmokeFree);
	PlacesSmokeFree.displayName = 'PlacesSmokeFree';
	PlacesSmokeFree.muiName = 'SvgIcon';
	
	exports.default = PlacesSmokeFree;

/***/ },
/* 2647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesSmokingRooms = function PlacesSmokingRooms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z' })
	  );
	};
	PlacesSmokingRooms = (0, _pure2.default)(PlacesSmokingRooms);
	PlacesSmokingRooms.displayName = 'PlacesSmokingRooms';
	PlacesSmokingRooms.muiName = 'SvgIcon';
	
	exports.default = PlacesSmokingRooms;

/***/ },
/* 2648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesSpa = function PlacesSpa(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z' }),
	    _react2.default.createElement('path', { d: 'M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z' })
	  );
	};
	PlacesSpa = (0, _pure2.default)(PlacesSpa);
	PlacesSpa.displayName = 'PlacesSpa';
	PlacesSpa.muiName = 'SvgIcon';
	
	exports.default = PlacesSpa;

/***/ },
/* 2649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialCake = function SocialCake(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z' })
	  );
	};
	SocialCake = (0, _pure2.default)(SocialCake);
	SocialCake.displayName = 'SocialCake';
	SocialCake.muiName = 'SvgIcon';
	
	exports.default = SocialCake;

/***/ },
/* 2650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialDomain = function SocialDomain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
	  );
	};
	SocialDomain = (0, _pure2.default)(SocialDomain);
	SocialDomain.displayName = 'SocialDomain';
	SocialDomain.muiName = 'SvgIcon';
	
	exports.default = SocialDomain;

/***/ },
/* 2651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialGroupAdd = function SocialGroupAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z' })
	  );
	};
	SocialGroupAdd = (0, _pure2.default)(SocialGroupAdd);
	SocialGroupAdd.displayName = 'SocialGroupAdd';
	SocialGroupAdd.muiName = 'SvgIcon';
	
	exports.default = SocialGroupAdd;

/***/ },
/* 2652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialGroup = function SocialGroup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
	  );
	};
	SocialGroup = (0, _pure2.default)(SocialGroup);
	SocialGroup.displayName = 'SocialGroup';
	SocialGroup.muiName = 'SvgIcon';
	
	exports.default = SocialGroup;

/***/ },
/* 2653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialLocationCity = function SocialLocationCity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z' })
	  );
	};
	SocialLocationCity = (0, _pure2.default)(SocialLocationCity);
	SocialLocationCity.displayName = 'SocialLocationCity';
	SocialLocationCity.muiName = 'SvgIcon';
	
	exports.default = SocialLocationCity;

/***/ },
/* 2654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMoodBad = function SocialMoodBad(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
	  );
	};
	SocialMoodBad = (0, _pure2.default)(SocialMoodBad);
	SocialMoodBad.displayName = 'SocialMoodBad';
	SocialMoodBad.muiName = 'SvgIcon';
	
	exports.default = SocialMoodBad;

/***/ },
/* 2655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMood = function SocialMood(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	SocialMood = (0, _pure2.default)(SocialMood);
	SocialMood.displayName = 'SocialMood';
	SocialMood.muiName = 'SvgIcon';
	
	exports.default = SocialMood;

/***/ },
/* 2656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsActive = function SocialNotificationsActive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z' })
	  );
	};
	SocialNotificationsActive = (0, _pure2.default)(SocialNotificationsActive);
	SocialNotificationsActive.displayName = 'SocialNotificationsActive';
	SocialNotificationsActive.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsActive;

/***/ },
/* 2657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsNone = function SocialNotificationsNone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z' })
	  );
	};
	SocialNotificationsNone = (0, _pure2.default)(SocialNotificationsNone);
	SocialNotificationsNone.displayName = 'SocialNotificationsNone';
	SocialNotificationsNone.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsNone;

/***/ },
/* 2658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsOff = function SocialNotificationsOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z' })
	  );
	};
	SocialNotificationsOff = (0, _pure2.default)(SocialNotificationsOff);
	SocialNotificationsOff.displayName = 'SocialNotificationsOff';
	SocialNotificationsOff.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsOff;

/***/ },
/* 2659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsPaused = function SocialNotificationsPaused(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z' })
	  );
	};
	SocialNotificationsPaused = (0, _pure2.default)(SocialNotificationsPaused);
	SocialNotificationsPaused.displayName = 'SocialNotificationsPaused';
	SocialNotificationsPaused.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsPaused;

/***/ },
/* 2660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotifications = function SocialNotifications(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' })
	  );
	};
	SocialNotifications = (0, _pure2.default)(SocialNotifications);
	SocialNotifications.displayName = 'SocialNotifications';
	SocialNotifications.muiName = 'SvgIcon';
	
	exports.default = SocialNotifications;

/***/ },
/* 2661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPages = function SocialPages(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z' })
	  );
	};
	SocialPages = (0, _pure2.default)(SocialPages);
	SocialPages.displayName = 'SocialPages';
	SocialPages.muiName = 'SvgIcon';
	
	exports.default = SocialPages;

/***/ },
/* 2662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPartyMode = function SocialPartyMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z' })
	  );
	};
	SocialPartyMode = (0, _pure2.default)(SocialPartyMode);
	SocialPartyMode.displayName = 'SocialPartyMode';
	SocialPartyMode.muiName = 'SvgIcon';
	
	exports.default = SocialPartyMode;

/***/ },
/* 2663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPeopleOutline = function SocialPeopleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z' })
	  );
	};
	SocialPeopleOutline = (0, _pure2.default)(SocialPeopleOutline);
	SocialPeopleOutline.displayName = 'SocialPeopleOutline';
	SocialPeopleOutline.muiName = 'SvgIcon';
	
	exports.default = SocialPeopleOutline;

/***/ },
/* 2664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPeople = function SocialPeople(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
	  );
	};
	SocialPeople = (0, _pure2.default)(SocialPeople);
	SocialPeople.displayName = 'SocialPeople';
	SocialPeople.muiName = 'SvgIcon';
	
	exports.default = SocialPeople;

/***/ },
/* 2665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPersonAdd = function SocialPersonAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
	  );
	};
	SocialPersonAdd = (0, _pure2.default)(SocialPersonAdd);
	SocialPersonAdd.displayName = 'SocialPersonAdd';
	SocialPersonAdd.muiName = 'SvgIcon';
	
	exports.default = SocialPersonAdd;

/***/ },
/* 2666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPersonOutline = function SocialPersonOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
	  );
	};
	SocialPersonOutline = (0, _pure2.default)(SocialPersonOutline);
	SocialPersonOutline.displayName = 'SocialPersonOutline';
	SocialPersonOutline.muiName = 'SvgIcon';
	
	exports.default = SocialPersonOutline;

/***/ },
/* 2667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPerson = function SocialPerson(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
	  );
	};
	SocialPerson = (0, _pure2.default)(SocialPerson);
	SocialPerson.displayName = 'SocialPerson';
	SocialPerson.muiName = 'SvgIcon';
	
	exports.default = SocialPerson;

/***/ },
/* 2668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPlusOne = function SocialPlusOne(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z' })
	  );
	};
	SocialPlusOne = (0, _pure2.default)(SocialPlusOne);
	SocialPlusOne.displayName = 'SocialPlusOne';
	SocialPlusOne.muiName = 'SvgIcon';
	
	exports.default = SocialPlusOne;

/***/ },
/* 2669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPoll = function SocialPoll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	SocialPoll = (0, _pure2.default)(SocialPoll);
	SocialPoll.displayName = 'SocialPoll';
	SocialPoll.muiName = 'SvgIcon';
	
	exports.default = SocialPoll;

/***/ },
/* 2670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPublic = function SocialPublic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z' })
	  );
	};
	SocialPublic = (0, _pure2.default)(SocialPublic);
	SocialPublic.displayName = 'SocialPublic';
	SocialPublic.muiName = 'SvgIcon';
	
	exports.default = SocialPublic;

/***/ },
/* 2671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSchool = function SocialSchool(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z' })
	  );
	};
	SocialSchool = (0, _pure2.default)(SocialSchool);
	SocialSchool.displayName = 'SocialSchool';
	SocialSchool.muiName = 'SvgIcon';
	
	exports.default = SocialSchool;

/***/ },
/* 2672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentDissatisfied = function SocialSentimentDissatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z' })
	  );
	};
	SocialSentimentDissatisfied = (0, _pure2.default)(SocialSentimentDissatisfied);
	SocialSentimentDissatisfied.displayName = 'SocialSentimentDissatisfied';
	SocialSentimentDissatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentDissatisfied;

/***/ },
/* 2673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentNeutral = function SocialSentimentNeutral(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 14h6v1.5H9z' }),
	    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	SocialSentimentNeutral = (0, _pure2.default)(SocialSentimentNeutral);
	SocialSentimentNeutral.displayName = 'SocialSentimentNeutral';
	SocialSentimentNeutral.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentNeutral;

/***/ },
/* 2674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentSatisfied = function SocialSentimentSatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z' })
	  );
	};
	SocialSentimentSatisfied = (0, _pure2.default)(SocialSentimentSatisfied);
	SocialSentimentSatisfied.displayName = 'SocialSentimentSatisfied';
	SocialSentimentSatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentSatisfied;

/***/ },
/* 2675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentVeryDissatisfied = function SocialSentimentVeryDissatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
	  );
	};
	SocialSentimentVeryDissatisfied = (0, _pure2.default)(SocialSentimentVeryDissatisfied);
	SocialSentimentVeryDissatisfied.displayName = 'SocialSentimentVeryDissatisfied';
	SocialSentimentVeryDissatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentVeryDissatisfied;

/***/ },
/* 2676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentVerySatisfied = function SocialSentimentVerySatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	SocialSentimentVerySatisfied = (0, _pure2.default)(SocialSentimentVerySatisfied);
	SocialSentimentVerySatisfied.displayName = 'SocialSentimentVerySatisfied';
	SocialSentimentVerySatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentVerySatisfied;

/***/ },
/* 2677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialShare = function SocialShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z' })
	  );
	};
	SocialShare = (0, _pure2.default)(SocialShare);
	SocialShare.displayName = 'SocialShare';
	SocialShare.muiName = 'SvgIcon';
	
	exports.default = SocialShare;

/***/ },
/* 2678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialWhatshot = function SocialWhatshot(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z' })
	  );
	};
	SocialWhatshot = (0, _pure2.default)(SocialWhatshot);
	SocialWhatshot.displayName = 'SocialWhatshot';
	SocialWhatshot.muiName = 'SvgIcon';
	
	exports.default = SocialWhatshot;

/***/ },
/* 2679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleIndeterminateCheckBox = function ToggleIndeterminateCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' })
	  );
	};
	ToggleIndeterminateCheckBox = (0, _pure2.default)(ToggleIndeterminateCheckBox);
	ToggleIndeterminateCheckBox.displayName = 'ToggleIndeterminateCheckBox';
	ToggleIndeterminateCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleIndeterminateCheckBox;

/***/ },
/* 2680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleStarBorder = function ToggleStarBorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
	  );
	};
	ToggleStarBorder = (0, _pure2.default)(ToggleStarBorder);
	ToggleStarBorder.displayName = 'ToggleStarBorder';
	ToggleStarBorder.muiName = 'SvgIcon';
	
	exports.default = ToggleStarBorder;

/***/ },
/* 2681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleStarHalf = function ToggleStarHalf(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
	  );
	};
	ToggleStarHalf = (0, _pure2.default)(ToggleStarHalf);
	ToggleStarHalf.displayName = 'ToggleStarHalf';
	ToggleStarHalf.muiName = 'SvgIcon';
	
	exports.default = ToggleStarHalf;

/***/ },
/* 2682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleStar = function ToggleStar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
	  );
	};
	ToggleStar = (0, _pure2.default)(ToggleStar);
	ToggleStar.displayName = 'ToggleStar';
	ToggleStar.muiName = 'SvgIcon';
	
	exports.default = ToggleStar;

/***/ },
/* 2683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
	    var prefixer = new Prefixer({
	      userAgent: userAgent
	    });
	
	    return function (style) {
	      return prefixer.prefix(style);
	    };
	  }
	};
	
	var _createPrefixer = __webpack_require__(1505);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _createPrefixer3 = __webpack_require__(1497);
	
	var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);
	
	var _autoprefixerDynamic = __webpack_require__(2684);
	
	var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);
	
	var _autoprefixerStatic = __webpack_require__(2685);
	
	var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ },
/* 2684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1498);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(1499);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1500);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1501);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1502);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(1503);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1504);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
	}; /* eslint-disable */

/***/ },
/* 2685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1506);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(1507);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1508);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1509);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1510);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(1511);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1512);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
	}; /* eslint-disable */

/***/ },
/* 2686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ },
/* 2687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(539);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ },
/* 2688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withWidth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(112);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SMALL = exports.SMALL = 1;
	var MEDIUM = exports.MEDIUM = 2;
	var LARGE = exports.LARGE = 3;
	
	function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$largeWidth = options.largeWidth,
	      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
	      _options$mediumWidth = options.mediumWidth,
	      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
	      _options$resizeInterv = options.resizeInterval,
	      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  return function (MyComponent) {
	    return function (_Component) {
	      (0, _inherits3.default)(WithWidth, _Component);
	
	      function WithWidth() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, WithWidth);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: null
	        }, _this.handleResize = function () {
	          clearTimeout(_this.deferTimer);
	          _this.deferTimer = setTimeout(function () {
	            _this.updateWidth();
	          }, resizeInterval);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(WithWidth, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.deferTimer);
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth() {
	          var innerWidth = window.innerWidth;
	          var width = void 0;
	
	          if (innerWidth >= largeWidth) {
	            width = LARGE;
	          } else if (innerWidth >= mediumWidth) {
	            width = MEDIUM;
	          } else {
	            // innerWidth < 768
	            width = SMALL;
	          }
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var width = this.state.width;
	
	          /**
	           * When rendering the component on the server,
	           * we have no idea about the screen width.
	           * In order to prevent blinks and help the reconciliation
	           * we are not rendering the component.
	           *
	           * A better alternative would be to send client hints.
	           * But the browser support of this API is low:
	           * http://caniuse.com/#search=client%20hint
	           */
	          if (width === null) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            _react2.default.createElement(MyComponent, (0, _extends3.default)({
	              width: width
	            }, this.props))
	          );
	        }
	      }]);
	      return WithWidth;
	    }(_react.Component);
	  };
	}

/***/ },
/* 2689 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(2693);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 2690 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(2691);
		function inc(arr,val){
			for(var i=0;i<arr.length;i++)
				arr[i]+=val;
			return arr;
		}
		var token=['sin','cos','tan','pi','(',')','P','C',
			  'asin','acos','atan','7','8','9','int',
			  'cosh','acosh','ln','^','root','4','5','6','/','!',
			  'tanh','atanh','Mod','1','2','3','*',
			  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
		var show=['sin','cos','tan','&pi;','(',')','P','C',
			'asin','acos','atan','7','8','9','Int',
			'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
			'tanh','atanh',' Mod ','1','2','3','&times;',
			'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
		var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
			Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
			Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
			Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
			Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
		var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
		var type=[0,0,0,3,4,5,10,10,
			0,0,0,1,1,1,0,
			0,0,0,10,0,1,1,1,2,7,
			0,0,2,1,1,1,2,
			0,0,3,0,1,6,9,9,11,12,13,12,8];
		 /*
		0 : function with syntax function_name(Maths_exp)
		1 : numbers
		2 : binary operators like * / Mod left associate and same precedence
		3 : Math constant values like e,pi,Cruncher ans
		4 : opening bracket
		5 : closing bracket
		6 : decimal
		7 : function with syntax (Math_exp)function_name
		8: function with syntax function_name(Math_exp1,Math_exp2)
		9 : binary operator like +,-
		10: binary operator like P C or ^
		11: ,
		12: function with , seperated three parameters
		13: variable of Sigma function
		 */
		var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
		type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
		type_1={0:true,3:true,4:true,8:true,12:true,13:true},
		empty={},
		type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
		type6={1:true},
		newAr=[[],
				["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
				["pi","ln","Pi"],
				["sin","cos","tan","Del","int","Mod","log","pow"],
				["asin","acos","atan","cosh","root","tanh","sinh"],
				["acosh","atanh","asinh","Sigma"]];
		function match(str1,str2,i,x){
			for(var f=0;f<x;f++){
				if (str1[i+f]!==str2[f])
					return false;
			}
			return true;
		}
		Mexp.addToken=function(tokens){
			for(i=0;i<tokens.length;i++){
				x=tokens[i].token.length;
				var temp=-1;
	
				//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on
	
				if (x<newAr.length)	//match to check if token is really huge and not existing
									//if not checked it will break in next line as undefined index
					for(y=0;y<newAr[x].length;y++){
						if (tokens[i].token===newAr[x][y]){
							temp=token.indexOf(newAr[x][y]);
							break;
						}
					}
				if (temp===-1) {
					token.push(tokens[i].token);
					type.push(tokens[i].type);
					if(newAr.length<=tokens[i].token.length)
						newAr[tokens[i].token.length]=[];
					newAr[tokens[i].token.length].push(tokens[i].token);
					eva.push(tokens[i].value);
					show.push(tokens[i].show);
				}
				else {
					token[temp]=tokens[i].token;
					type[temp]=tokens[i].type;
					eva[temp]=tokens[i].value;
					show[temp]=tokens[i].show;
				}
			}
		};
		Mexp.lex=function(inp,tokens){
			'use strict';
			var str=[{type:4,value:"(",show:"(",pre:0}];
			var ptc=[];	//Parenthesis to close at the beginning is after one token
			var inpStr=inp;
			var key;
	        var pcounter=0;
			var allowed=type0;
			var bracToClose=0;
			var asterick=empty;
			var prevKey='';
			var i,x,y;
			if(typeof tokens!=="undefined")
				Mexp.addToken(tokens);
			var obj={};
			for(i=0;i<inpStr.length;i++){
				if (inpStr[i]==' ') {
					continue;
				}
				key='';
				sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
					for(y=0;y<newAr[x].length;y++){
						if (match(inpStr,newAr[x][y],i,x)){
							key=newAr[x][y];
							break sec;
						}
					}
				}
				i+=key.length-1;
				if(key===''){
					throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
				}
				var index=token.indexOf(key);
				var cToken=key;
				var cType=type[index];
				var cEv=eva[index];
				var cPre=preced[cType];
				var	cShow=show[index];
				var pre=str[str.length-1];
				for(j=ptc.length;j--;){	//loop over ptc
					if(ptc[j]===0){
						if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
							if(allowed[cType]!==true){
								throw(new Mexp.exception(key+" is not allowed after "+prevKey));
							}
							str.push({value:")",type:5,pre:0,show:")"});
							allowed=type1;
							asterick=type_3;
							inc(ptc,-1).pop();
						}
					}
				}
				if(allowed[cType]!==true){
					throw(new Mexp.exception(key+" is not allowed after "+prevKey));
				}
				if(asterick[cType]===true){
					cType=2;
					cEv=Mexp.math.mul;
					cShow="&times;";
					cPre=3;
					i=i-key.length;
			 	}
				obj={value:cEv,type:cType,pre:cPre,show:cShow};
				if(cType===0){
					allowed=type0;
					asterick=empty;
					inc(ptc,2).push(2);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===1){
					if(pre.type===1){
						pre.value+=cEv;
						inc(ptc,1);
					}
					else {
						str.push(obj);
					}
					allowed=type1;
					asterick=type_1;
				}
				else if(cType===2){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===3){//constant
					str.push(obj);
					allowed=type1;
					asterick=type_3;
				}
				else if(cType===4){
	                pcounter+=ptc.length;
	                ptc=[];
					bracToClose++;
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===5){
					if(!bracToClose){
						throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
					}
	                while(pcounter--){	//loop over ptc
	    						str.push({value:")",type:5,pre:0,show:")"});
	    			}
	                pcounter=0;
					bracToClose--;
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				else if(cType===6){
					if(pre.hasDec){
						throw(new Mexp.exception("Two decimals are not allowed in one number"));
					}
					if(pre.type!==1){
						pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
						str.push(pre);
						inc(ptc,-1);
					}
					allowed=type6;
					inc(ptc,1);
					asterick=empty;
					pre.value+=cEv;
					pre.hasDec=true;
				}
				else if(cType===7){
					allowed=type1;
					asterick=type_3;
					inc(ptc,1);
					str.push(obj);
				}
				if(cType===8){
					allowed=type0;
					asterick=empty;
					inc(ptc,4).push(4);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===9){
					if(pre.type===9){
						if(pre.value===Mexp.math.add){
							pre.value=cEv;
							pre.show=cShow;
							inc(ptc,1);
						}
						else if(pre.value===Mexp.math.sub&&cShow==='-'){
							pre.value=Mexp.math.add;
							pre.show='+';
							inc(ptc,1);
						}
					}
					else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
						if(cToken==='-'){//do nothing for + token
										//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
							allowed=type0;
							asterick=empty;
							inc(ptc,2).push(2);
							str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
							str.push({value:"(",type:4,pre:0,show:"("});
						}
					}
					else{
						str.push(obj);
						inc(ptc,2);
					}
					allowed=type0;
					asterick=empty;
				}
				else if(cType===10){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===11){
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===12){
					allowed=type0;
					asterick=empty;
					inc(ptc,6).push(6);
					str.push(obj);
					str.push({value:"(",type:4,pre:0});
				}
				else if(cType===13){
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				inc(ptc,-1);
				prevKey=key;
			}
			for(var j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
	
					str.push({value:")",show:")",type:5,pre:3});
					inc(ptc,-1).pop();
				}
			}
			if (allowed[5]!==true) {
				throw(new Mexp.exception("complete the expression"));
			}
			while(bracToClose--)
				str.push({value:")",show:")",type:5,pre:3});
	
			str.push({type:5,value:")",show:")",pre:0});
	//        console.log(str);
			return new Mexp(str);
		};
	    module.exports=Mexp;


/***/ },
/* 2691 */
/***/ function(module, exports) {

		var Mexp=function(parsed){
			this.value=parsed;
	
		};
	
		Mexp.math={
			isDegree:true, //mode of calculator
			acos:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
			},
			add:function(a,b){
				return a+b;
			},
			asin:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
			},
			atan:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
			},
			acosh:function(x){
				return Math.log(x+Math.sqrt(x*x-1));
			},
			asinh:function(x){
				return Math.log(x+Math.sqrt(x*x+1));
			},
			atanh:function(x){
				return Math.log((1+x)/(1-x));
			},
			C:function(n,r){
				var pro=1,other=n-r,choice=r;
				if(choice<other){
				choice=other;
				other=r;
				}
				for(var i=choice+1;i<=n;i++)
					pro*=i;
				return pro/Mexp.math.fact(other);
			},
			changeSign:function(x){
				return -x;
			},
			cos:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.cos(x);
			},
			cosh:function(x){
				return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
			},
			div:function(a,b){
			return a/b;
			},
			fact:function(n) {
			if(n%1!==0)return "NAN";
				var pro=1;
				for(var i=2;i<=n;i++)
					pro*=i;
				return pro;
			},
			inverse:function(x){
				return 1/x;
			},
			log:function(i){
				return Math.log(i)/Math.log(10);
			},
			mod:function(a,b){
			return a%b;
			},
			mul:function(a,b){
			return a*b;
			},
			P:function(n,r){var pro=1;
				 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
						pro*=i;
						return pro;
	
			},
			Pi:function(low,high,ex){
				var pro=1;
				for(var i=low;i<=high;i++){
					pro*=Number(ex.postfixEval({n:i}));
				}
				return pro;
			},
			pow10x:function(e){
				var x=1;
				while(e--){x*=10;}
				return x;
			},
			sigma:function(low,high,ex){
				var sum=0;
				for(var i=low;i<=high;i++){
					sum+=Number(ex.postfixEval({n:i}));
				}
				return sum;
			},
			sin:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.sin(x);
			},
			sinh:function(x){
				return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
			},
			sub:function(a,b){
			return a-b;
			},
			tan:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.tan(x);
			},
			tanh:function(x){
				return Mexp.sinha(x)/Mexp.cosha(x);
			},
			toRadian:function(x){
				return x*Math.PI/180;
			}
		};
		Mexp.exception=function(message){
			this.message=message;
		};
	    module.exports=Mexp;

/***/ },
/* 2692 */
/***/ function(module, exports, __webpack_require__) {

	
	    var Mexp=__webpack_require__(2690);
	
		Mexp.prototype.toPostfix = function () {
			'use strict';
			var post=[],elem,popped,prep,pre,ele;
	    	var stack=[{value:"(",type:4,pre:0}];
			var arr=this.value;
			for (var i=1; i < arr.length; i++) {
				if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
					if(arr[i].type===1)
						arr[i].value=Number(arr[i].value);
					post.push(arr[i]);
				}
				else if(arr[i].type===4){
					stack.push(arr[i]);
				}
				else if(arr[i].type===5){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
				}
				else if(arr[i].type===11){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
					stack.push(popped);
				}
				else {
					elem=arr[i];
					pre=elem.pre;
					ele=stack[stack.length-1];
					prep=ele.pre;
					var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
					if(pre>prep)stack.push(elem);
					else {
						while(prep>=pre&&!flag||flag&&pre<prep){
							popped=stack.pop();
							ele=stack[stack.length-1];
							post.push(popped);
							prep=ele.pre;
							flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
						}
						stack.push(elem);
					}
				}
			}
			return new Mexp(post);
		};
	    module.exports=Mexp;

/***/ },
/* 2693 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(2692);
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict';
		UserDefined=UserDefined||{};
		UserDefined.PI=Math.PI;
		UserDefined.E=Math.E;
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		var bool=(typeof UserDefined.n!=="undefined");
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1){
				stack.push({value:arr[i].value,type:1});
			}
			else if(arr[i].type===3){
				stack.push({value:UserDefined[arr[i].value],type:1});
			}
			else if(arr[i].type===0){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===7){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===8){
				pop1=stack.pop();
				pop2=stack.pop();
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
			else if(arr[i].type===10){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
					pop2.value=pop2.concat(pop1);
					pop2.value.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
	            }
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
	                console.log(pop2);
					pop2=pop2.concat(pop1);
					pop2.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
				}
			}
			else if(arr[i].type===12){
				pop1=stack.pop();
				if (typeof pop1.type!=="undefined") {
					pop1=[pop1];
				}
				pop2=stack.pop();
				pop3=stack.pop();
				stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
			}
			else if(arr[i].type===13){
				if(bool){
					stack.push({value:UserDefined[arr[i].value],type:3});
				}
				else stack.push([arr[i]]);
			}
		}
		if (stack.length>1) {
			throw(new Mexp.exception("Uncaught Syntax error"));
		}
		return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
	};
	Mexp.eval=function(str,tokens,obj){
		if (typeof tokens==="undefined") {
			return this.lex(str).toPostfix().postfixEval();
		}
		else if (typeof obj==="undefined") {
			if (typeof tokens.length!=="undefined") 
				return this.lex(str,tokens).toPostfix().postfixEval();
			else
				return this.lex(str).toPostfix().postfixEval(tokens);
		}
		else
			return this.lex(str,tokens).toPostfix().postfixEval(obj);
	};
	module.exports=Mexp;

/***/ },
/* 2694 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 737,
		"./af.js": 737,
		"./ar": 744,
		"./ar-dz": 738,
		"./ar-dz.js": 738,
		"./ar-kw": 739,
		"./ar-kw.js": 739,
		"./ar-ly": 740,
		"./ar-ly.js": 740,
		"./ar-ma": 741,
		"./ar-ma.js": 741,
		"./ar-sa": 742,
		"./ar-sa.js": 742,
		"./ar-tn": 743,
		"./ar-tn.js": 743,
		"./ar.js": 744,
		"./az": 745,
		"./az.js": 745,
		"./be": 746,
		"./be.js": 746,
		"./bg": 747,
		"./bg.js": 747,
		"./bm": 748,
		"./bm.js": 748,
		"./bn": 749,
		"./bn.js": 749,
		"./bo": 750,
		"./bo.js": 750,
		"./br": 751,
		"./br.js": 751,
		"./bs": 752,
		"./bs.js": 752,
		"./ca": 753,
		"./ca.js": 753,
		"./cs": 754,
		"./cs.js": 754,
		"./cv": 755,
		"./cv.js": 755,
		"./cy": 756,
		"./cy.js": 756,
		"./da": 757,
		"./da.js": 757,
		"./de": 760,
		"./de-at": 758,
		"./de-at.js": 758,
		"./de-ch": 759,
		"./de-ch.js": 759,
		"./de.js": 760,
		"./dv": 761,
		"./dv.js": 761,
		"./el": 762,
		"./el.js": 762,
		"./en-au": 763,
		"./en-au.js": 763,
		"./en-ca": 764,
		"./en-ca.js": 764,
		"./en-gb": 765,
		"./en-gb.js": 765,
		"./en-ie": 766,
		"./en-ie.js": 766,
		"./en-il": 767,
		"./en-il.js": 767,
		"./en-nz": 768,
		"./en-nz.js": 768,
		"./eo": 769,
		"./eo.js": 769,
		"./es": 772,
		"./es-do": 770,
		"./es-do.js": 770,
		"./es-us": 771,
		"./es-us.js": 771,
		"./es.js": 772,
		"./et": 773,
		"./et.js": 773,
		"./eu": 774,
		"./eu.js": 774,
		"./fa": 775,
		"./fa.js": 775,
		"./fi": 776,
		"./fi.js": 776,
		"./fo": 777,
		"./fo.js": 777,
		"./fr": 780,
		"./fr-ca": 778,
		"./fr-ca.js": 778,
		"./fr-ch": 779,
		"./fr-ch.js": 779,
		"./fr.js": 780,
		"./fy": 781,
		"./fy.js": 781,
		"./gd": 782,
		"./gd.js": 782,
		"./gl": 783,
		"./gl.js": 783,
		"./gom-latn": 784,
		"./gom-latn.js": 784,
		"./gu": 785,
		"./gu.js": 785,
		"./he": 786,
		"./he.js": 786,
		"./hi": 787,
		"./hi.js": 787,
		"./hr": 788,
		"./hr.js": 788,
		"./hu": 789,
		"./hu.js": 789,
		"./hy-am": 790,
		"./hy-am.js": 790,
		"./id": 791,
		"./id.js": 791,
		"./is": 792,
		"./is.js": 792,
		"./it": 793,
		"./it.js": 793,
		"./ja": 794,
		"./ja.js": 794,
		"./jv": 795,
		"./jv.js": 795,
		"./ka": 796,
		"./ka.js": 796,
		"./kk": 797,
		"./kk.js": 797,
		"./km": 798,
		"./km.js": 798,
		"./kn": 799,
		"./kn.js": 799,
		"./ko": 800,
		"./ko.js": 800,
		"./ky": 801,
		"./ky.js": 801,
		"./lb": 802,
		"./lb.js": 802,
		"./lo": 803,
		"./lo.js": 803,
		"./lt": 804,
		"./lt.js": 804,
		"./lv": 805,
		"./lv.js": 805,
		"./me": 806,
		"./me.js": 806,
		"./mi": 807,
		"./mi.js": 807,
		"./mk": 808,
		"./mk.js": 808,
		"./ml": 809,
		"./ml.js": 809,
		"./mn": 810,
		"./mn.js": 810,
		"./mr": 811,
		"./mr.js": 811,
		"./ms": 813,
		"./ms-my": 812,
		"./ms-my.js": 812,
		"./ms.js": 813,
		"./mt": 814,
		"./mt.js": 814,
		"./my": 815,
		"./my.js": 815,
		"./nb": 816,
		"./nb.js": 816,
		"./ne": 817,
		"./ne.js": 817,
		"./nl": 819,
		"./nl-be": 818,
		"./nl-be.js": 818,
		"./nl.js": 819,
		"./nn": 820,
		"./nn.js": 820,
		"./pa-in": 821,
		"./pa-in.js": 821,
		"./pl": 822,
		"./pl.js": 822,
		"./pt": 824,
		"./pt-br": 823,
		"./pt-br.js": 823,
		"./pt.js": 824,
		"./ro": 825,
		"./ro.js": 825,
		"./ru": 826,
		"./ru.js": 826,
		"./sd": 827,
		"./sd.js": 827,
		"./se": 828,
		"./se.js": 828,
		"./si": 829,
		"./si.js": 829,
		"./sk": 830,
		"./sk.js": 830,
		"./sl": 831,
		"./sl.js": 831,
		"./sq": 832,
		"./sq.js": 832,
		"./sr": 834,
		"./sr-cyrl": 833,
		"./sr-cyrl.js": 833,
		"./sr.js": 834,
		"./ss": 835,
		"./ss.js": 835,
		"./sv": 836,
		"./sv.js": 836,
		"./sw": 837,
		"./sw.js": 837,
		"./ta": 838,
		"./ta.js": 838,
		"./te": 839,
		"./te.js": 839,
		"./tet": 840,
		"./tet.js": 840,
		"./tg": 841,
		"./tg.js": 841,
		"./th": 842,
		"./th.js": 842,
		"./tl-ph": 843,
		"./tl-ph.js": 843,
		"./tlh": 844,
		"./tlh.js": 844,
		"./tr": 845,
		"./tr.js": 845,
		"./tzl": 846,
		"./tzl.js": 846,
		"./tzm": 848,
		"./tzm-latn": 847,
		"./tzm-latn.js": 847,
		"./tzm.js": 848,
		"./ug-cn": 849,
		"./ug-cn.js": 849,
		"./uk": 850,
		"./uk.js": 850,
		"./ur": 851,
		"./ur.js": 851,
		"./uz": 853,
		"./uz-latn": 852,
		"./uz-latn.js": 852,
		"./uz.js": 853,
		"./vi": 854,
		"./vi.js": 854,
		"./x-pseudo": 855,
		"./x-pseudo.js": 855,
		"./yo": 856,
		"./yo.js": 856,
		"./zh-cn": 857,
		"./zh-cn.js": 857,
		"./zh-hk": 858,
		"./zh-hk.js": 858,
		"./zh-tw": 859,
		"./zh-tw.js": 859
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2694;


/***/ },
/* 2695 */
1025,
/* 2696 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 2697 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191)))

/***/ },
/* 2698 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.14.6
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthOddness = reference.width % 2 === popper.width % 2;
	  var bothOddWidth = reference.width % 2 === 1 && popper.width % 2 === 1;
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthOddness ? Math.round : Math.floor;
	  var verticalToInteger = !shouldRound ? noRound : Math.round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ },
/* 2700 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          )
	
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 2701 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(864);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2702 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var assign = __webpack_require__(39);
	
	var ReactPropTypesSecret = __webpack_require__(864);
	var checkPropTypes = __webpack_require__(2700);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(866);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(val);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = utils.combine(obj[key], val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (!options.parseArrays && cleanRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'undefined' ? defaults.allowDots : !!options.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
	        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	    if (typeof options.charset === 'undefined') {
	        options.charset = defaults.charset;
	    }
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 2704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(866);
	var formats = __webpack_require__(865);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly,
	    charset
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            pushToArray(values, stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly,
	                charset
	            ));
	        } else {
	            pushToArray(values, stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly,
	                charset
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? defaults.allowDots : !!options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    var charset = options.charset || defaults.charset;
	    if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
	        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly,
	            charset
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 2705 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 2706 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 2707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(1371);
	
	var _addEventListener = __webpack_require__(311);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _util = __webpack_require__(2709);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElement(func) {
	  if (typeof func !== 'function' || !func) return null;
	  return func();
	}
	
	function getPoint(point) {
	  if (typeof point !== 'object' || !point) return null;
	  return point;
	}
	
	var Align = function (_Component) {
	  (0, _inherits3['default'])(Align, _Component);
	
	  function Align() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Align);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          target = _this$props.target,
	          align = _this$props.align,
	          onAlign = _this$props.onAlign;
	
	      if (!disabled && target) {
	        var source = _reactDom2['default'].findDOMNode(_this);
	
	        var result = void 0;
	        var element = getElement(target);
	        var point = getPoint(target);
	
	        if (element) {
	          result = (0, _domAlign.alignElement)(source, element, align);
	        } else if (point) {
	          result = (0, _domAlign.alignPoint)(source, point, align);
	        }
	
	        if (onAlign) {
	          onAlign(source, result);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Align.prototype.componentDidMount = function componentDidMount() {
	    var props = this.props;
	    // if parent ref not attached .... use document.getElementById
	    this.forceAlign();
	    if (!props.disabled && props.monitorWindowResize) {
	      this.startMonitorWindowResize();
	    }
	  };
	
	  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var reAlign = false;
	    var props = this.props;
	
	    if (!props.disabled) {
	      var source = _reactDom2['default'].findDOMNode(this);
	      var sourceRect = source ? source.getBoundingClientRect() : null;
	
	      if (prevProps.disabled) {
	        reAlign = true;
	      } else {
	        var lastElement = getElement(prevProps.target);
	        var currentElement = getElement(props.target);
	        var lastPoint = getPoint(prevProps.target);
	        var currentPoint = getPoint(props.target);
	
	        if ((0, _util.isWindow)(lastElement) && (0, _util.isWindow)(currentElement)) {
	          // Skip if is window
	          reAlign = false;
	        } else if (lastElement !== currentElement || // Element change
	        lastElement && !currentElement && currentPoint || // Change from element to point
	        lastPoint && currentPoint && currentElement || // Change from point to element
	        currentPoint && !(0, _util.isSamePoint)(lastPoint, currentPoint)) {
	          reAlign = true;
	        }
	
	        // If source element size changed
	        var preRect = this.sourceRect || {};
	        if (!reAlign && source && (preRect.width !== sourceRect.width || preRect.height !== sourceRect.height)) {
	          reAlign = true;
	        }
	      }
	
	      this.sourceRect = sourceRect;
	    }
	
	    if (reAlign) {
	      this.forceAlign();
	    }
	
	    if (props.monitorWindowResize && !props.disabled) {
	      this.startMonitorWindowResize();
	    } else {
	      this.stopMonitorWindowResize();
	    }
	  };
	
	  Align.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.stopMonitorWindowResize();
	  };
	
	  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
	    if (!this.resizeHandler) {
	      this.bufferMonitor = (0, _util.buffer)(this.forceAlign, this.props.monitorBufferTime);
	      this.resizeHandler = (0, _addEventListener2['default'])(window, 'resize', this.bufferMonitor);
	    }
	  };
	
	  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
	    if (this.resizeHandler) {
	      this.bufferMonitor.clear();
	      this.resizeHandler.remove();
	      this.resizeHandler = null;
	    }
	  };
	
	  Align.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        childrenProps = _props.childrenProps,
	        children = _props.children;
	
	    var child = _react2['default'].Children.only(children);
	    if (childrenProps) {
	      var newProps = {};
	      var propList = Object.keys(childrenProps);
	      propList.forEach(function (prop) {
	        newProps[prop] = _this2.props[childrenProps[prop]];
	      });
	
	      return _react2['default'].cloneElement(child, newProps);
	    }
	    return child;
	  };
	
	  return Align;
	}(_react.Component);
	
	Align.propTypes = {
	  childrenProps: _propTypes2['default'].object,
	  align: _propTypes2['default'].object.isRequired,
	  target: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].shape({
	    clientX: _propTypes2['default'].number,
	    clientY: _propTypes2['default'].number,
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })]),
	  onAlign: _propTypes2['default'].func,
	  monitorBufferTime: _propTypes2['default'].number,
	  monitorWindowResize: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any
	};
	Align.defaultProps = {
	  target: function target() {
	    return window;
	  },
	  monitorBufferTime: 50,
	  monitorWindowResize: false,
	  disabled: false
	};
	exports['default'] = Align;
	module.exports = exports['default'];

/***/ },
/* 2708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Align = __webpack_require__(2707);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Align2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 2709 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.buffer = buffer;
	exports.isSamePoint = isSamePoint;
	exports.isWindow = isWindow;
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;
	
	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }
	
	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }
	
	  return false;
	}
	
	function isWindow(obj) {
	  return obj && typeof obj === 'object' && obj.window === obj;
	}

/***/ },
/* 2710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ChildrenUtils = __webpack_require__(2712);
	
	var _AnimateChild = __webpack_require__(2711);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _animate = __webpack_require__(867);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  // eslint-disable-line
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.propTypes = {
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = Animate;
	module.exports = exports['default'];

/***/ },
/* 2711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(1340);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(867);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 2712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 2713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(3136);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _Track = __webpack_require__(868);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(869);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(436);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Range = function (_React$Component) {
	  (0, _inherits3['default'])(Range, _React$Component);
	
	  function Range(props) {
	    (0, _classCallCheck3['default'])(this, Range);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));
	
	    _this.onEnd = function () {
	      _this.setState({
	        handle: null
	      });
	      _this.removeDocumentEvents();
	      _this.props.onAfterChange(_this.getValue());
	    };
	
	    var count = props.count,
	        min = props.min,
	        max = props.max;
	
	    var initialValue = Array.apply(undefined, (0, _toConsumableArray3['default'])(Array(count + 1))).map(function () {
	      return min;
	    });
	    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
	    var value = props.value !== undefined ? props.value : defaultValue;
	    var bounds = value.map(function (v, i) {
	      return _this.trimAlignValue(v, i);
	    });
	    var recent = bounds[0] === max ? 0 : bounds.length - 1;
	
	    _this.state = {
	      handle: null,
	      recent: recent,
	      bounds: bounds
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Range, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
	      if (this.props.min === nextProps.min && this.props.max === nextProps.max && (0, _shallowequal2['default'])(this.props.value, nextProps.value)) {
	        return;
	      }
	
	      var bounds = this.state.bounds;
	
	      var value = nextProps.value || bounds;
	      var nextBounds = value.map(function (v, i) {
	        return _this2.trimAlignValue(v, i, nextProps);
	      });
	      if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
	        return v === bounds[i];
	      })) return;
	
	      this.setState({ bounds: nextBounds });
	
	      if (value.some(function (v) {
	        return utils.isValueOutOfRange(v, nextProps);
	      })) {
	        var newValues = value.map(function (v) {
	          return utils.ensureValueInRange(v, nextProps);
	        });
	        this.props.onChange(newValues);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(state) {
	      var props = this.props;
	      var isNotControlled = !('value' in props);
	      if (isNotControlled) {
	        this.setState(state);
	      } else if (state.handle !== undefined) {
	        this.setState({ handle: state.handle });
	      }
	
	      var data = (0, _extends3['default'])({}, this.state, state);
	      var changedValue = data.bounds;
	      props.onChange(changedValue);
	    }
	  }, {
	    key: 'onStart',
	    value: function onStart(position) {
	      var props = this.props;
	      var state = this.state;
	      var bounds = this.getValue();
	      props.onBeforeChange(bounds);
	
	      var value = this.calcValueByPos(position);
	      this.startValue = value;
	      this.startPosition = position;
	
	      var closestBound = this.getClosestBound(value);
	      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
	
	      this.setState({
	        handle: this.prevMovedHandleIndex,
	        recent: this.prevMovedHandleIndex
	      });
	
	      var prevValue = bounds[this.prevMovedHandleIndex];
	      if (value === prevValue) return;
	
	      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
	      nextBounds[this.prevMovedHandleIndex] = value;
	      this.onChange({ bounds: nextBounds });
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(e, position) {
	      utils.pauseEvent(e);
	      var state = this.state;
	
	      var value = this.calcValueByPos(position);
	      var oldValue = state.bounds[state.handle];
	      if (value === oldValue) return;
	
	      this.moveTo(value);
	    }
	  }, {
	    key: 'onKeyboard',
	    value: function onKeyboard(e) {
	      var valueMutator = utils.getKeyboardValueMutator(e);
	
	      if (valueMutator) {
	        utils.pauseEvent(e);
	        var state = this.state,
	            props = this.props;
	        var bounds = state.bounds,
	            handle = state.handle;
	
	        var oldValue = bounds[handle];
	        var mutatedValue = valueMutator(oldValue, props);
	        var value = this.trimAlignValue(mutatedValue);
	        if (value === oldValue) return;
	        var isFromKeyboardEvent = true;
	        this.moveTo(value, isFromKeyboardEvent);
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.bounds;
	    }
	  }, {
	    key: 'getClosestBound',
	    value: function getClosestBound(value) {
	      var bounds = this.state.bounds;
	
	      var closestBound = 0;
	      for (var i = 1; i < bounds.length - 1; ++i) {
	        if (value > bounds[i]) {
	          closestBound = i;
	        }
	      }
	      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
	        closestBound += 1;
	      }
	      return closestBound;
	    }
	  }, {
	    key: 'getBoundNeedMoving',
	    value: function getBoundNeedMoving(value, closestBound) {
	      var _state = this.state,
	          bounds = _state.bounds,
	          recent = _state.recent;
	
	      var boundNeedMoving = closestBound;
	      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
	
	      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
	        boundNeedMoving = recent;
	      }
	
	      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
	        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
	      }
	      return boundNeedMoving;
	    }
	  }, {
	    key: 'getLowerBound',
	    value: function getLowerBound() {
	      return this.state.bounds[0];
	    }
	  }, {
	    key: 'getUpperBound',
	    value: function getUpperBound() {
	      var bounds = this.state.bounds;
	
	      return bounds[bounds.length - 1];
	    }
	
	    /**
	     * Returns an array of possible slider points, taking into account both
	     * `marks` and `step`. The result is cached.
	     */
	
	  }, {
	    key: 'getPoints',
	    value: function getPoints() {
	      var _props = this.props,
	          marks = _props.marks,
	          step = _props.step,
	          min = _props.min,
	          max = _props.max;
	
	      var cache = this._getPointsCache;
	      if (!cache || cache.marks !== marks || cache.step !== step) {
	        var pointsObject = (0, _extends3['default'])({}, marks);
	        if (step !== null) {
	          for (var point = min; point <= max; point += step) {
	            pointsObject[point] = point;
	          }
	        }
	        var points = Object.keys(pointsObject).map(parseFloat);
	        points.sort(function (a, b) {
	          return a - b;
	        });
	        this._getPointsCache = { marks: marks, step: step, points: points };
	      }
	      return this._getPointsCache.points;
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(value, isFromKeyboardEvent) {
	      var _this3 = this;
	
	      var state = this.state,
	          props = this.props;
	
	      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
	      nextBounds[state.handle] = value;
	      var nextHandle = state.handle;
	      if (props.pushable !== false) {
	        this.pushSurroundingHandles(nextBounds, nextHandle);
	      } else if (props.allowCross) {
	        nextBounds.sort(function (a, b) {
	          return a - b;
	        });
	        nextHandle = nextBounds.indexOf(value);
	      }
	      this.onChange({
	        handle: nextHandle,
	        bounds: nextBounds
	      });
	      if (isFromKeyboardEvent) {
	        // known problem: because setState is async,
	        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
	        // cause onBeforeChange and onAfterChange receive wrong value.
	        // here use setState callback to hack，but not elegant
	        this.setState({}, function () {
	          _this3.handlesRefs[nextHandle].focus();
	        });
	      }
	    }
	  }, {
	    key: 'pushSurroundingHandles',
	    value: function pushSurroundingHandles(bounds, handle) {
	      var value = bounds[handle];
	      var threshold = this.props.pushable;
	
	      threshold = Number(threshold);
	
	      var direction = 0;
	      if (bounds[handle + 1] - value < threshold) {
	        direction = +1; // push to right
	      }
	      if (value - bounds[handle - 1] < threshold) {
	        direction = -1; // push to left
	      }
	
	      if (direction === 0) {
	        return;
	      }
	
	      var nextHandle = handle + direction;
	      var diffToNext = direction * (bounds[nextHandle] - value);
	      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	        // revert to original value if pushing is impossible
	        bounds[handle] = bounds[nextHandle] - direction * threshold;
	      }
	    }
	  }, {
	    key: 'pushHandle',
	    value: function pushHandle(bounds, handle, direction, amount) {
	      var originalValue = bounds[handle];
	      var currentValue = bounds[handle];
	      while (direction * (currentValue - originalValue) < amount) {
	        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
	          // can't push handle enough to create the needed `amount` gap, so we
	          // revert its position to the original value
	          bounds[handle] = originalValue;
	          return false;
	        }
	        currentValue = bounds[handle];
	      }
	      // the handle was pushed enough to create the needed `amount` gap
	      return true;
	    }
	  }, {
	    key: 'pushHandleOnePoint',
	    value: function pushHandleOnePoint(bounds, handle, direction) {
	      var points = this.getPoints();
	      var pointIndex = points.indexOf(bounds[handle]);
	      var nextPointIndex = pointIndex + direction;
	      if (nextPointIndex >= points.length || nextPointIndex < 0) {
	        // reached the minimum or maximum available point, can't push anymore
	        return false;
	      }
	      var nextHandle = handle + direction;
	      var nextValue = points[nextPointIndex];
	      var threshold = this.props.pushable;
	
	      var diffToNext = direction * (bounds[nextHandle] - nextValue);
	      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	        // couldn't push next handle, so we won't push this one either
	        return false;
	      }
	      // push the handle
	      bounds[handle] = nextValue;
	      return true;
	    }
	  }, {
	    key: 'trimAlignValue',
	    value: function trimAlignValue(v, handle) {
	      var nextProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
	      var valInRange = utils.ensureValueInRange(v, mergedProps);
	      var valNotConflict = this.ensureValueNotConflict(handle, valInRange, mergedProps);
	      return utils.ensureValuePrecision(valNotConflict, mergedProps);
	    }
	  }, {
	    key: 'ensureValueNotConflict',
	    value: function ensureValueNotConflict(handle, val, _ref) {
	      var allowCross = _ref.allowCross,
	          thershold = _ref.pushable;
	
	      var state = this.state || {};
	      var bounds = state.bounds;
	
	      handle = handle === undefined ? state.handle : handle;
	      thershold = Number(thershold);
	      /* eslint-disable eqeqeq */
	      if (!allowCross && handle != null && bounds !== undefined) {
	        if (handle > 0 && val <= bounds[handle - 1] + thershold) {
	          return bounds[handle - 1] + thershold;
	        }
	        if (handle < bounds.length - 1 && val >= bounds[handle + 1] - thershold) {
	          return bounds[handle + 1] - thershold;
	        }
	      }
	      /* eslint-enable eqeqeq */
	      return val;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          handle = _state2.handle,
	          bounds = _state2.bounds;
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          vertical = _props2.vertical,
	          included = _props2.included,
	          disabled = _props2.disabled,
	          min = _props2.min,
	          max = _props2.max,
	          handleGenerator = _props2.handle,
	          trackStyle = _props2.trackStyle,
	          handleStyle = _props2.handleStyle,
	          tabIndex = _props2.tabIndex;
	
	
	      var offsets = bounds.map(function (v) {
	        return _this4.calcOffset(v);
	      });
	
	      var handleClassName = prefixCls + '-handle';
	      var handles = bounds.map(function (v, i) {
	        var _classNames;
	
	        return handleGenerator({
	          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, handleClassName, true), (0, _defineProperty3['default'])(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
	          prefixCls: prefixCls,
	          vertical: vertical,
	          offset: offsets[i],
	          value: v,
	          dragging: handle === i,
	          index: i,
	          tabIndex: tabIndex[i] || 0,
	          min: min,
	          max: max,
	          disabled: disabled,
	          style: handleStyle[i],
	          ref: function ref(h) {
	            return _this4.saveHandle(i, h);
	          }
	        });
	      });
	
	      var tracks = bounds.slice(0, -1).map(function (_, index) {
	        var _classNames2;
	
	        var i = index + 1;
	        var trackClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
	        return _react2['default'].createElement(_Track2['default'], {
	          className: trackClassName,
	          vertical: vertical,
	          included: included,
	          offset: offsets[i - 1],
	          length: offsets[i] - offsets[i - 1],
	          style: trackStyle[index],
	          key: i
	        });
	      });
	
	      return { tracks: tracks, handles: handles };
	    }
	  }]);
	  return Range;
	}(_react2['default'].Component); /* eslint-disable react/prop-types */
	
	
	Range.displayName = 'Range';
	Range.propTypes = {
	  defaultValue: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  value: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  count: _propTypes2['default'].number,
	  pushable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
	  allowCross: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number
	};
	Range.defaultProps = {
	  count: 1,
	  allowCross: true,
	  pushable: false,
	  tabIndex: []
	};
	exports['default'] = (0, _createSlider2['default'])(Range);
	module.exports = exports['default'];

/***/ },
/* 2714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Track = __webpack_require__(868);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(869);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(436);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint-disable react/prop-types */
	var Slider = function (_React$Component) {
	  (0, _inherits3['default'])(Slider, _React$Component);
	
	  function Slider(props) {
	    (0, _classCallCheck3['default'])(this, Slider);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
	    _this.onEnd = function () {
	      _this.setState({ dragging: false });
	      _this.removeDocumentEvents();
	      _this.props.onAfterChange(_this.getValue());
	    };
	
	    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
	    var value = props.value !== undefined ? props.value : defaultValue;
	
	    _this.state = {
	      value: _this.trimAlignValue(value),
	      dragging: false
	    };
	    if (utils.isDev()) {
	      (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecate, please use trackStyle instead.');
	      (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecate, please use railStyle instead.');
	    }
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Slider, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          autoFocus = _props.autoFocus,
	          disabled = _props.disabled;
	
	      if (autoFocus && !disabled) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
	
	      var prevValue = this.state.value;
	      var value = nextProps.value !== undefined ? nextProps.value : prevValue;
	      var nextValue = this.trimAlignValue(value, nextProps);
	      if (nextValue === prevValue) return;
	
	      this.setState({ value: nextValue });
	      if (utils.isValueOutOfRange(value, nextProps)) {
	        this.props.onChange(nextValue);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(state) {
	      var props = this.props;
	      var isNotControlled = !('value' in props);
	      if (isNotControlled) {
	        this.setState(state);
	      }
	
	      var changedValue = state.value;
	      props.onChange(changedValue);
	    }
	  }, {
	    key: 'onStart',
	    value: function onStart(position) {
	      this.setState({ dragging: true });
	      var props = this.props;
	      var prevValue = this.getValue();
	      props.onBeforeChange(prevValue);
	
	      var value = this.calcValueByPos(position);
	      this.startValue = value;
	      this.startPosition = position;
	
	      if (value === prevValue) return;
	
	      this.prevMovedHandleIndex = 0;
	
	      this.onChange({ value: value });
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(e, position) {
	      utils.pauseEvent(e);
	      var oldValue = this.state.value;
	
	      var value = this.calcValueByPos(position);
	      if (value === oldValue) return;
	
	      this.onChange({ value: value });
	    }
	  }, {
	    key: 'onKeyboard',
	    value: function onKeyboard(e) {
	      var valueMutator = utils.getKeyboardValueMutator(e);
	
	      if (valueMutator) {
	        utils.pauseEvent(e);
	        var state = this.state;
	        var oldValue = state.value;
	        var mutatedValue = valueMutator(oldValue, this.props);
	        var value = this.trimAlignValue(mutatedValue);
	        if (value === oldValue) return;
	
	        this.onChange({ value: value });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.value;
	    }
	  }, {
	    key: 'getLowerBound',
	    value: function getLowerBound() {
	      return this.props.min;
	    }
	  }, {
	    key: 'getUpperBound',
	    value: function getUpperBound() {
	      return this.state.value;
	    }
	  }, {
	    key: 'trimAlignValue',
	    value: function trimAlignValue(v) {
	      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (v === null) {
	        return null;
	      }
	
	      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
	      var val = utils.ensureValueInRange(v, mergedProps);
	      return utils.ensureValuePrecision(val, mergedProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          vertical = _props2.vertical,
	          included = _props2.included,
	          disabled = _props2.disabled,
	          minimumTrackStyle = _props2.minimumTrackStyle,
	          trackStyle = _props2.trackStyle,
	          handleStyle = _props2.handleStyle,
	          tabIndex = _props2.tabIndex,
	          min = _props2.min,
	          max = _props2.max,
	          handleGenerator = _props2.handle;
	      var _state = this.state,
	          value = _state.value,
	          dragging = _state.dragging;
	
	      var offset = this.calcOffset(value);
	      var handle = handleGenerator({
	        className: prefixCls + '-handle',
	        prefixCls: prefixCls,
	        vertical: vertical,
	        offset: offset,
	        value: value,
	        dragging: dragging,
	        disabled: disabled,
	        min: min,
	        max: max,
	        index: 0,
	        tabIndex: tabIndex,
	        style: handleStyle[0] || handleStyle,
	        ref: function ref(h) {
	          return _this2.saveHandle(0, h);
	        }
	      });
	
	      var _trackStyle = trackStyle[0] || trackStyle;
	      var track = _react2['default'].createElement(_Track2['default'], {
	        className: prefixCls + '-track',
	        vertical: vertical,
	        included: included,
	        offset: 0,
	        length: offset,
	        style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
	      });
	
	      return { tracks: track, handles: handle };
	    }
	  }]);
	  return Slider;
	}(_react2['default'].Component);
	
	Slider.propTypes = {
	  defaultValue: _propTypes2['default'].number,
	  value: _propTypes2['default'].number,
	  disabled: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].number,
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number
	};
	exports['default'] = (0, _createSlider2['default'])(Slider);
	module.exports = exports['default'];

/***/ },
/* 2715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Marks = function Marks(_ref) {
	  var className = _ref.className,
	      vertical = _ref.vertical,
	      marks = _ref.marks,
	      included = _ref.included,
	      upperBound = _ref.upperBound,
	      lowerBound = _ref.lowerBound,
	      max = _ref.max,
	      min = _ref.min,
	      onClickLabel = _ref.onClickLabel;
	
	  var marksKeys = Object.keys(marks);
	  var marksCount = marksKeys.length;
	  var unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
	  var markWidth = unit * 0.9;
	
	  var range = max - min;
	  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
	    return a - b;
	  }).map(function (point) {
	    var _classNames;
	
	    var markPoint = marks[point];
	    var markPointIsObject = typeof markPoint === 'object' && !_react2['default'].isValidElement(markPoint);
	    var markLabel = markPointIsObject ? markPoint.label : markPoint;
	    if (!markLabel && markLabel !== 0) {
	      return null;
	    }
	
	    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var markClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className + '-text', true), (0, _defineProperty3['default'])(_classNames, className + '-text-active', isActive), _classNames));
	
	    var bottomStyle = {
	      marginBottom: '-50%',
	      bottom: (point - min) / range * 100 + '%'
	    };
	
	    var leftStyle = {
	      width: markWidth + '%',
	      marginLeft: -markWidth / 2 + '%',
	      left: (point - min) / range * 100 + '%'
	    };
	
	    var style = vertical ? bottomStyle : leftStyle;
	    var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
	    return _react2['default'].createElement(
	      'span',
	      {
	        className: markClassName,
	        style: markStyle,
	        key: point,
	        onMouseDown: function onMouseDown(e) {
	          return onClickLabel(e, point);
	        },
	        onTouchStart: function onTouchStart(e) {
	          return onClickLabel(e, point);
	        }
	      },
	      markLabel
	    );
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: className },
	    elements
	  );
	};
	
	Marks.propTypes = {
	  className: _propTypes2['default'].string,
	  vertical: _propTypes2['default'].bool,
	  marks: _propTypes2['default'].object,
	  included: _propTypes2['default'].bool,
	  upperBound: _propTypes2['default'].number,
	  lowerBound: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  min: _propTypes2['default'].number,
	  onClickLabel: _propTypes2['default'].func
	};
	
	exports['default'] = Marks;
	module.exports = exports['default'];

/***/ },
/* 2716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
	  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
	  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
	    return a - b;
	  });
	  if (dots) {
	    for (var i = min; i <= max; i += step) {
	      if (points.indexOf(i) === -1) {
	        points.push(i);
	      }
	    }
	  }
	  return points;
	};
	
	var Steps = function Steps(_ref) {
	  var prefixCls = _ref.prefixCls,
	      vertical = _ref.vertical,
	      marks = _ref.marks,
	      dots = _ref.dots,
	      step = _ref.step,
	      included = _ref.included,
	      lowerBound = _ref.lowerBound,
	      upperBound = _ref.upperBound,
	      max = _ref.max,
	      min = _ref.min,
	      dotStyle = _ref.dotStyle,
	      activeDotStyle = _ref.activeDotStyle;
	
	  var range = max - min;
	  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
	    var _classNames;
	
	    var offset = Math.abs(point - min) / range * 100 + '%';
	
	    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var style = vertical ? (0, _extends3['default'])({ bottom: offset }, dotStyle) : (0, _extends3['default'])({ left: offset }, dotStyle);
	    if (isActived) {
	      style = (0, _extends3['default'])({}, style, activeDotStyle);
	    }
	
	    var pointClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-active', isActived), _classNames));
	
	    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: prefixCls + '-step' },
	    elements
	  );
	};
	
	Steps.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  activeDotStyle: _propTypes2['default'].object,
	  dotStyle: _propTypes2['default'].object,
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  upperBound: _propTypes2['default'].number,
	  lowerBound: _propTypes2['default'].number,
	  included: _propTypes2['default'].bool,
	  dots: _propTypes2['default'].bool,
	  step: _propTypes2['default'].number,
	  marks: _propTypes2['default'].object,
	  vertical: _propTypes2['default'].bool
	};
	
	exports['default'] = Steps;
	module.exports = exports['default'];

/***/ },
/* 2717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(11);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = createSliderWithTooltip;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTooltip = __webpack_require__(42);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _Handle = __webpack_require__(435);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function createSliderWithTooltip(Component) {
	  var _class, _temp;
	
	  return _temp = _class = function (_React$Component) {
	    (0, _inherits3['default'])(ComponentWrapper, _React$Component);
	
	    function ComponentWrapper(props) {
	      (0, _classCallCheck3['default'])(this, ComponentWrapper);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call(this, props));
	
	      _this.handleTooltipVisibleChange = function (index, visible) {
	        _this.setState(function (prevState) {
	          return {
	            visibles: (0, _extends4['default'])({}, prevState.visibles, (0, _defineProperty3['default'])({}, index, visible))
	          };
	        });
	      };
	
	      _this.handleWithTooltip = function (_ref) {
	        var value = _ref.value,
	            dragging = _ref.dragging,
	            index = _ref.index,
	            disabled = _ref.disabled,
	            restProps = (0, _objectWithoutProperties3['default'])(_ref, ['value', 'dragging', 'index', 'disabled']);
	        var _this$props = _this.props,
	            tipFormatter = _this$props.tipFormatter,
	            tipProps = _this$props.tipProps,
	            handleStyle = _this$props.handleStyle;
	        var _tipProps$prefixCls = tipProps.prefixCls,
	            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
	            _tipProps$overlay = tipProps.overlay,
	            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
	            _tipProps$placement = tipProps.placement,
	            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
	            _tipProps$visible = tipProps.visible,
	            visible = _tipProps$visible === undefined ? false : _tipProps$visible,
	            restTooltipProps = (0, _objectWithoutProperties3['default'])(tipProps, ['prefixCls', 'overlay', 'placement', 'visible']);
	
	
	        var handleStyleWithIndex = void 0;
	        if (Array.isArray(handleStyle)) {
	          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
	        } else {
	          handleStyleWithIndex = handleStyle;
	        }
	
	        return _react2['default'].createElement(
	          _rcTooltip2['default'],
	          (0, _extends4['default'])({}, restTooltipProps, {
	            prefixCls: prefixCls,
	            overlay: overlay,
	            placement: placement,
	            visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
	            key: index
	          }),
	          _react2['default'].createElement(_Handle2['default'], (0, _extends4['default'])({}, restProps, {
	            style: (0, _extends4['default'])({}, handleStyleWithIndex),
	            value: value,
	            onMouseEnter: function onMouseEnter() {
	              return _this.handleTooltipVisibleChange(index, true);
	            },
	            onMouseLeave: function onMouseLeave() {
	              return _this.handleTooltipVisibleChange(index, false);
	            }
	          }))
	        );
	      };
	
	      _this.state = { visibles: {} };
	      return _this;
	    }
	
	    (0, _createClass3['default'])(ComponentWrapper, [{
	      key: 'render',
	      value: function render() {
	        return _react2['default'].createElement(Component, (0, _extends4['default'])({}, this.props, { handle: this.handleWithTooltip }));
	      }
	    }]);
	    return ComponentWrapper;
	  }(_react2['default'].Component), _class.propTypes = {
	    tipFormatter: _propTypes2['default'].func,
	    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    tipProps: _propTypes2['default'].object
	  }, _class.defaultProps = {
	    tipFormatter: function tipFormatter(value) {
	      return value;
	    },
	
	    handleStyle: [{}],
	    tipProps: {}
	  }, _temp;
	}
	module.exports = exports['default'];

/***/ },
/* 2718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Content = function (_React$Component) {
	  (0, _inherits3['default'])(Content, _React$Component);
	
	  function Content() {
	    (0, _classCallCheck3['default'])(this, Content);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Content.prototype.componentDidUpdate = function componentDidUpdate() {
	    var trigger = this.props.trigger;
	
	    if (trigger) {
	      trigger.forcePopupAlign();
	    }
	  };
	
	  Content.prototype.render = function render() {
	    var _props = this.props,
	        overlay = _props.overlay,
	        prefixCls = _props.prefixCls,
	        id = _props.id;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
	      typeof overlay === 'function' ? overlay() : overlay
	    );
	  };
	
	  return Content;
	}(_react2['default'].Component);
	
	Content.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  id: _propTypes2['default'].string,
	  trigger: _propTypes2['default'].any
	};
	exports['default'] = Content;
	module.exports = exports['default'];

/***/ },
/* 2719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(2728);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _placements = __webpack_require__(2720);
	
	var _Content = __webpack_require__(2718);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tooltip = function (_Component) {
	  (0, _inherits3['default'])(Tooltip, _Component);
	
	  function Tooltip() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
	      var _this$props = _this.props,
	          arrowContent = _this$props.arrowContent,
	          overlay = _this$props.overlay,
	          prefixCls = _this$props.prefixCls,
	          id = _this$props.id;
	
	      return [_react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-arrow', key: 'arrow' },
	        arrowContent
	      ), _react2['default'].createElement(_Content2['default'], {
	        key: 'content',
	        trigger: _this.trigger,
	        prefixCls: prefixCls,
	        id: id,
	        overlay: overlay
	      })];
	    }, _this.saveTrigger = function (node) {
	      _this.trigger = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Tooltip.prototype.render = function render() {
	    var _props = this.props,
	        overlayClassName = _props.overlayClassName,
	        trigger = _props.trigger,
	        mouseEnterDelay = _props.mouseEnterDelay,
	        mouseLeaveDelay = _props.mouseLeaveDelay,
	        overlayStyle = _props.overlayStyle,
	        prefixCls = _props.prefixCls,
	        children = _props.children,
	        onVisibleChange = _props.onVisibleChange,
	        afterVisibleChange = _props.afterVisibleChange,
	        transitionName = _props.transitionName,
	        animation = _props.animation,
	        placement = _props.placement,
	        align = _props.align,
	        destroyTooltipOnHide = _props.destroyTooltipOnHide,
	        defaultVisible = _props.defaultVisible,
	        getTooltipContainer = _props.getTooltipContainer,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = (0, _extends3['default'])({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      (0, _extends3['default'])({
	        popupClassName: overlayClassName,
	        ref: this.saveTrigger,
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        afterPopupVisibleChange: afterVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  };
	
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
	  trigger: _propTypes2['default'].any,
	  children: _propTypes2['default'].any,
	  defaultVisible: _propTypes2['default'].bool,
	  visible: _propTypes2['default'].bool,
	  placement: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  animation: _propTypes2['default'].any,
	  onVisibleChange: _propTypes2['default'].func,
	  afterVisibleChange: _propTypes2['default'].func,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  overlayStyle: _propTypes2['default'].object,
	  overlayClassName: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  getTooltipContainer: _propTypes2['default'].func,
	  destroyTooltipOnHide: _propTypes2['default'].bool,
	  align: _propTypes2['default'].object,
	  arrowContent: _propTypes2['default'].any,
	  id: _propTypes2['default'].string
	};
	Tooltip.defaultProps = {
	  prefixCls: 'rc-tooltip',
	  mouseEnterDelay: 0,
	  destroyTooltipOnHide: false,
	  mouseLeaveDelay: 0.1,
	  align: {},
	  placement: 'right',
	  trigger: ['hover'],
	  arrowContent: null
	};
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 2720 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ },
/* 2721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _toArray = __webpack_require__(239);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _reactLifecyclesCompat = __webpack_require__(160);
	
	var _contextTypes = __webpack_require__(872);
	
	var _util = __webpack_require__(873);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tree = function (_React$Component) {
	  (0, _inherits3['default'])(Tree, _React$Component);
	
	  function Tree() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Tree);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Tree.__proto__ || Object.getPrototypeOf(Tree)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      // TODO: Remove this eslint
	      posEntities: {}, // eslint-disable-line react/no-unused-state
	      keyEntities: {},
	
	      selectedKeys: [],
	      checkedKeys: [],
	      halfCheckedKeys: [],
	      loadedKeys: [],
	      loadingKeys: [],
	
	      treeNode: []
	    }, _this.onNodeDragStart = function (event, node) {
	      var expandedKeys = _this.state.expandedKeys;
	      var onDragStart = _this.props.onDragStart;
	      var _node$props = node.props,
	          eventKey = _node$props.eventKey,
	          children = _node$props.children;
	
	
	      _this.dragNode = node;
	
	      _this.setState({
	        dragNodesKeys: (0, _util.getDragNodesKeys)(children, node),
	        expandedKeys: (0, _util.arrDel)(expandedKeys, eventKey)
	      });
	
	      if (onDragStart) {
	        onDragStart({ event: event, node: node });
	      }
	    }, _this.onNodeDragEnter = function (event, node) {
	      var expandedKeys = _this.state.expandedKeys;
	      var onDragEnter = _this.props.onDragEnter;
	      var _node$props2 = node.props,
	          pos = _node$props2.pos,
	          eventKey = _node$props2.eventKey;
	
	
	      if (!_this.dragNode) return;
	
	      var dropPosition = (0, _util.calcDropPosition)(event, node);
	
	      // Skip if drag node is self
	      if (_this.dragNode.props.eventKey === eventKey && dropPosition === 0) {
	        _this.setState({
	          dragOverNodeKey: '',
	          dropPosition: null
	        });
	        return;
	      }
	
	      // Ref: https://github.com/react-component/tree/issues/132
	      // Add timeout to let onDragLevel fire before onDragEnter,
	      // so that we can clean drag props for onDragLeave node.
	      // Macro task for this:
	      // https://html.spec.whatwg.org/multipage/webappapis.html#clean-up-after-running-script
	      setTimeout(function () {
	        // Update drag over node
	        _this.setState({
	          dragOverNodeKey: eventKey,
	          dropPosition: dropPosition
	        });
	
	        // Side effect for delay drag
	        if (!_this.delayedDragEnterLogic) {
	          _this.delayedDragEnterLogic = {};
	        }
	        Object.keys(_this.delayedDragEnterLogic).forEach(function (key) {
	          clearTimeout(_this.delayedDragEnterLogic[key]);
	        });
	        _this.delayedDragEnterLogic[pos] = setTimeout(function () {
	          var newExpandedKeys = (0, _util.arrAdd)(expandedKeys, eventKey);
	          _this.setState({
	            expandedKeys: newExpandedKeys
	          });
	
	          if (onDragEnter) {
	            onDragEnter({ event: event, node: node, expandedKeys: newExpandedKeys });
	          }
	        }, 400);
	      }, 0);
	    }, _this.onNodeDragOver = function (event, node) {
	      var onDragOver = _this.props.onDragOver;
	      var eventKey = node.props.eventKey;
	
	      // Update drag position
	
	      if (_this.dragNode && eventKey === _this.state.dragOverNodeKey) {
	        var dropPosition = (0, _util.calcDropPosition)(event, node);
	
	        if (dropPosition === _this.state.dropPosition) return;
	
	        _this.setState({
	          dropPosition: dropPosition
	        });
	      }
	
	      if (onDragOver) {
	        onDragOver({ event: event, node: node });
	      }
	    }, _this.onNodeDragLeave = function (event, node) {
	      var onDragLeave = _this.props.onDragLeave;
	
	
	      _this.setState({
	        dragOverNodeKey: ''
	      });
	
	      if (onDragLeave) {
	        onDragLeave({ event: event, node: node });
	      }
	    }, _this.onNodeDragEnd = function (event, node) {
	      var onDragEnd = _this.props.onDragEnd;
	
	      _this.setState({
	        dragOverNodeKey: ''
	      });
	      if (onDragEnd) {
	        onDragEnd({ event: event, node: node });
	      }
	
	      _this.dragNode = null;
	    }, _this.onNodeDrop = function (event, node) {
	      var _this$state = _this.state,
	          _this$state$dragNodes = _this$state.dragNodesKeys,
	          dragNodesKeys = _this$state$dragNodes === undefined ? [] : _this$state$dragNodes,
	          dropPosition = _this$state.dropPosition;
	      var onDrop = _this.props.onDrop;
	      var _node$props3 = node.props,
	          eventKey = _node$props3.eventKey,
	          pos = _node$props3.pos;
	
	
	      _this.setState({
	        dragOverNodeKey: ''
	      });
	
	      if (dragNodesKeys.indexOf(eventKey) !== -1) {
	        (0, _warning2['default'])(false, 'Can not drop to dragNode(include it\'s children node)');
	        return;
	      }
	
	      var posArr = (0, _util.posToArr)(pos);
	
	      var dropResult = {
	        event: event,
	        node: node,
	        dragNode: _this.dragNode,
	        dragNodesKeys: dragNodesKeys.slice(),
	        dropPosition: dropPosition + Number(posArr[posArr.length - 1])
	      };
	
	      if (dropPosition !== 0) {
	        dropResult.dropToGap = true;
	      }
	
	      if (onDrop) {
	        onDrop(dropResult);
	      }
	
	      _this.dragNode = null;
	    }, _this.onNodeClick = function (e, treeNode) {
	      var onClick = _this.props.onClick;
	
	      if (onClick) {
	        onClick(e, treeNode);
	      }
	    }, _this.onNodeDoubleClick = function (e, treeNode) {
	      var onDoubleClick = _this.props.onDoubleClick;
	
	      if (onDoubleClick) {
	        onDoubleClick(e, treeNode);
	      }
	    }, _this.onNodeSelect = function (e, treeNode) {
	      var selectedKeys = _this.state.selectedKeys;
	      var keyEntities = _this.state.keyEntities;
	      var _this$props = _this.props,
	          onSelect = _this$props.onSelect,
	          multiple = _this$props.multiple;
	      var _treeNode$props = treeNode.props,
	          selected = _treeNode$props.selected,
	          eventKey = _treeNode$props.eventKey;
	
	      var targetSelected = !selected;
	
	      // Update selected keys
	      if (!targetSelected) {
	        selectedKeys = (0, _util.arrDel)(selectedKeys, eventKey);
	      } else if (!multiple) {
	        selectedKeys = [eventKey];
	      } else {
	        selectedKeys = (0, _util.arrAdd)(selectedKeys, eventKey);
	      }
	
	      // [Legacy] Not found related usage in doc or upper libs
	      var selectedNodes = selectedKeys.map(function (key) {
	        var entity = keyEntities[key];
	        if (!entity) return null;
	
	        return entity.node;
	      }).filter(function (node) {
	        return node;
	      });
	
	      _this.setUncontrolledState({ selectedKeys: selectedKeys });
	
	      if (onSelect) {
	        var eventObj = {
	          event: 'select',
	          selected: targetSelected,
	          node: treeNode,
	          selectedNodes: selectedNodes,
	          nativeEvent: e.nativeEvent
	        };
	        onSelect(selectedKeys, eventObj);
	      }
	    }, _this.onNodeCheck = function (e, treeNode, checked) {
	      var _this$state2 = _this.state,
	          keyEntities = _this$state2.keyEntities,
	          oriCheckedKeys = _this$state2.checkedKeys,
	          oriHalfCheckedKeys = _this$state2.halfCheckedKeys;
	      var _this$props2 = _this.props,
	          checkStrictly = _this$props2.checkStrictly,
	          onCheck = _this$props2.onCheck;
	      var eventKey = treeNode.props.eventKey;
	
	      // Prepare trigger arguments
	
	      var checkedObj = void 0;
	      var eventObj = {
	        event: 'check',
	        node: treeNode,
	        checked: checked,
	        nativeEvent: e.nativeEvent
	      };
	
	      if (checkStrictly) {
	        var checkedKeys = checked ? (0, _util.arrAdd)(oriCheckedKeys, eventKey) : (0, _util.arrDel)(oriCheckedKeys, eventKey);
	        var halfCheckedKeys = (0, _util.arrDel)(oriHalfCheckedKeys, eventKey);
	        checkedObj = { checked: checkedKeys, halfChecked: halfCheckedKeys };
	
	        eventObj.checkedNodes = checkedKeys.map(function (key) {
	          return keyEntities[key];
	        }).filter(function (entity) {
	          return entity;
	        }).map(function (entity) {
	          return entity.node;
	        });
	
	        _this.setUncontrolledState({ checkedKeys: checkedKeys });
	      } else {
	        var _conductCheck = (0, _util.conductCheck)([eventKey], checked, keyEntities, {
	          checkedKeys: oriCheckedKeys, halfCheckedKeys: oriHalfCheckedKeys
	        }),
	            _checkedKeys = _conductCheck.checkedKeys,
	            _halfCheckedKeys = _conductCheck.halfCheckedKeys;
	
	        checkedObj = _checkedKeys;
	
	        // [Legacy] This is used for `rc-tree-select`
	        eventObj.checkedNodes = [];
	        eventObj.checkedNodesPositions = [];
	        eventObj.halfCheckedKeys = _halfCheckedKeys;
	
	        _checkedKeys.forEach(function (key) {
	          var entity = keyEntities[key];
	          if (!entity) return;
	
	          var node = entity.node,
	              pos = entity.pos;
	
	
	          eventObj.checkedNodes.push(node);
	          eventObj.checkedNodesPositions.push({ node: node, pos: pos });
	        });
	
	        _this.setUncontrolledState({
	          checkedKeys: _checkedKeys,
	          halfCheckedKeys: _halfCheckedKeys
	        });
	      }
	
	      if (onCheck) {
	        onCheck(checkedObj, eventObj);
	      }
	    }, _this.onNodeLoad = function (treeNode) {
	      return new Promise(function (resolve) {
	        // We need to get the latest state of loading/loaded keys
	        _this.setState(function (_ref2) {
	          var _ref2$loadedKeys = _ref2.loadedKeys,
	              loadedKeys = _ref2$loadedKeys === undefined ? [] : _ref2$loadedKeys,
	              _ref2$loadingKeys = _ref2.loadingKeys,
	              loadingKeys = _ref2$loadingKeys === undefined ? [] : _ref2$loadingKeys;
	          var _this$props3 = _this.props,
	              loadData = _this$props3.loadData,
	              onLoad = _this$props3.onLoad;
	          var eventKey = treeNode.props.eventKey;
	
	
	          if (!loadData || loadedKeys.indexOf(eventKey) !== -1 || loadingKeys.indexOf(eventKey) !== -1) {
	            // react 15 will warn if return null
	            return {};
	          }
	
	          // Process load data
	          var promise = loadData(treeNode);
	          promise.then(function () {
	            var newLoadedKeys = (0, _util.arrAdd)(_this.state.loadedKeys, eventKey);
	            var newLoadingKeys = (0, _util.arrDel)(_this.state.loadingKeys, eventKey);
	
	            // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
	            // https://github.com/ant-design/ant-design/issues/12464
	            if (onLoad) {
	              var eventObj = {
	                event: 'load',
	                node: treeNode
	              };
	              onLoad(newLoadedKeys, eventObj);
	            }
	
	            _this.setUncontrolledState({
	              loadedKeys: newLoadedKeys
	            });
	            _this.setState({
	              loadingKeys: newLoadingKeys
	            });
	
	            resolve();
	          });
	
	          return {
	            loadingKeys: (0, _util.arrAdd)(loadingKeys, eventKey)
	          };
	        });
	      });
	    }, _this.onNodeExpand = function (e, treeNode) {
	      var expandedKeys = _this.state.expandedKeys;
	      var _this$props4 = _this.props,
	          onExpand = _this$props4.onExpand,
	          loadData = _this$props4.loadData;
	      var _treeNode$props2 = treeNode.props,
	          eventKey = _treeNode$props2.eventKey,
	          expanded = _treeNode$props2.expanded;
	
	      // Update selected keys
	
	      var index = expandedKeys.indexOf(eventKey);
	      var targetExpanded = !expanded;
	
	      (0, _warning2['default'])(expanded && index !== -1 || !expanded && index === -1, 'Expand state not sync with index check');
	
	      if (targetExpanded) {
	        expandedKeys = (0, _util.arrAdd)(expandedKeys, eventKey);
	      } else {
	        expandedKeys = (0, _util.arrDel)(expandedKeys, eventKey);
	      }
	
	      _this.setUncontrolledState({ expandedKeys: expandedKeys });
	
	      if (onExpand) {
	        onExpand(expandedKeys, {
	          node: treeNode,
	          expanded: targetExpanded,
	          nativeEvent: e.nativeEvent
	        });
	      }
	
	      // Async Load data
	      if (targetExpanded && loadData) {
	        var loadPromise = _this.onNodeLoad(treeNode);
	        return loadPromise ? loadPromise.then(function () {
	          // [Legacy] Refresh logic
	          _this.setUncontrolledState({ expandedKeys: expandedKeys });
	        }) : null;
	      }
	
	      return null;
	    }, _this.onNodeMouseEnter = function (event, node) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter({ event: event, node: node });
	      }
	    }, _this.onNodeMouseLeave = function (event, node) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave({ event: event, node: node });
	      }
	    }, _this.onNodeContextMenu = function (event, node) {
	      var onRightClick = _this.props.onRightClick;
	
	      if (onRightClick) {
	        event.preventDefault();
	        onRightClick({ event: event, node: node });
	      }
	    }, _this.setUncontrolledState = function (state) {
	      var needSync = false;
	      var newState = {};
	
	      Object.keys(state).forEach(function (name) {
	        if (name in _this.props) return;
	
	        needSync = true;
	        newState[name] = state[name];
	      });
	
	      if (needSync) {
	        _this.setState(newState);
	      }
	    }, _this.isKeyChecked = function (key) {
	      var _this$state$checkedKe = _this.state.checkedKeys,
	          checkedKeys = _this$state$checkedKe === undefined ? [] : _this$state$checkedKe;
	
	      return checkedKeys.indexOf(key) !== -1;
	    }, _this.renderTreeNode = function (child, index) {
	      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var _this$state3 = _this.state,
	          keyEntities = _this$state3.keyEntities,
	          _this$state3$expanded = _this$state3.expandedKeys,
	          expandedKeys = _this$state3$expanded === undefined ? [] : _this$state3$expanded,
	          _this$state3$selected = _this$state3.selectedKeys,
	          selectedKeys = _this$state3$selected === undefined ? [] : _this$state3$selected,
	          _this$state3$halfChec = _this$state3.halfCheckedKeys,
	          halfCheckedKeys = _this$state3$halfChec === undefined ? [] : _this$state3$halfChec,
	          _this$state3$loadedKe = _this$state3.loadedKeys,
	          loadedKeys = _this$state3$loadedKe === undefined ? [] : _this$state3$loadedKe,
	          _this$state3$loadingK = _this$state3.loadingKeys,
	          loadingKeys = _this$state3$loadingK === undefined ? [] : _this$state3$loadingK,
	          dragOverNodeKey = _this$state3.dragOverNodeKey,
	          dropPosition = _this$state3.dropPosition;
	
	      var pos = (0, _util.getPosition)(level, index);
	      var key = child.key || pos;
	
	      if (!keyEntities[key]) {
	        (0, _util.warnOnlyTreeNode)();
	        return null;
	      }
	
	      return _react2['default'].cloneElement(child, {
	        key: key,
	        eventKey: key,
	        expanded: expandedKeys.indexOf(key) !== -1,
	        selected: selectedKeys.indexOf(key) !== -1,
	        loaded: loadedKeys.indexOf(key) !== -1,
	        loading: loadingKeys.indexOf(key) !== -1,
	        checked: _this.isKeyChecked(key),
	        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
	        pos: pos,
	
	        // [Legacy] Drag props
	        dragOver: dragOverNodeKey === key && dropPosition === 0,
	        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
	        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
	      });
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Tree, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          selectable = _props.selectable,
	          showIcon = _props.showIcon,
	          icon = _props.icon,
	          draggable = _props.draggable,
	          checkable = _props.checkable,
	          checkStrictly = _props.checkStrictly,
	          disabled = _props.disabled,
	          loadData = _props.loadData,
	          filterTreeNode = _props.filterTreeNode,
	          openTransitionName = _props.openTransitionName,
	          openAnimation = _props.openAnimation,
	          switcherIcon = _props.switcherIcon;
	
	
	      return {
	        rcTree: {
	          // root: this,
	
	          prefixCls: prefixCls,
	          selectable: selectable,
	          showIcon: showIcon,
	          icon: icon,
	          switcherIcon: switcherIcon,
	          draggable: draggable,
	          checkable: checkable,
	          checkStrictly: checkStrictly,
	          disabled: disabled,
	          openTransitionName: openTransitionName,
	          openAnimation: openAnimation,
	
	          loadData: loadData,
	          filterTreeNode: filterTreeNode,
	          renderTreeNode: this.renderTreeNode,
	          isKeyChecked: this.isKeyChecked,
	
	          onNodeClick: this.onNodeClick,
	          onNodeDoubleClick: this.onNodeDoubleClick,
	          onNodeExpand: this.onNodeExpand,
	          onNodeSelect: this.onNodeSelect,
	          onNodeCheck: this.onNodeCheck,
	          onNodeLoad: this.onNodeLoad,
	          onNodeMouseEnter: this.onNodeMouseEnter,
	          onNodeMouseLeave: this.onNodeMouseLeave,
	          onNodeContextMenu: this.onNodeContextMenu,
	          onNodeDragStart: this.onNodeDragStart,
	          onNodeDragEnter: this.onNodeDragEnter,
	          onNodeDragOver: this.onNodeDragOver,
	          onNodeDragLeave: this.onNodeDragLeave,
	          onNodeDragEnd: this.onNodeDragEnd,
	          onNodeDrop: this.onNodeDrop
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var treeNode = this.state.treeNode;
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          className = _props2.className,
	          focusable = _props2.focusable,
	          showLine = _props2.showLine,
	          _props2$tabIndex = _props2.tabIndex,
	          tabIndex = _props2$tabIndex === undefined ? 0 : _props2$tabIndex;
	
	      var domProps = (0, _util.getDataAndAria)(this.props);
	
	      if (focusable) {
	        domProps.tabIndex = tabIndex;
	        domProps.onKeyDown = this.onKeyDown;
	      }
	
	      return _react2['default'].createElement(
	        'ul',
	        (0, _extends3['default'])({}, domProps, {
	          className: (0, _classnames2['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-show-line', showLine)),
	          role: 'tree',
	          unselectable: 'on'
	        }),
	        (0, _util.mapChildren)(treeNode, function (node, index) {
	          return _this2.renderTreeNode(node, index);
	        })
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(props, prevState) {
	      var prevProps = prevState.prevProps;
	
	      var newState = {
	        prevProps: props
	      };
	
	      function needSync(name) {
	        return !prevProps && name in props || prevProps && prevProps[name] !== props[name];
	      }
	
	      // ================== Tree Node ==================
	      var treeNode = null;
	
	      // Check if `treeData` or `children` changed and save into the state.
	      if (needSync('treeData')) {
	        treeNode = (0, _util.convertDataToTree)(props.treeData);
	      } else if (needSync('children')) {
	        treeNode = (0, _toArray2['default'])(props.children);
	      }
	
	      // Tree support filter function which will break the tree structure in the vdm.
	      // We cache the treeNodes in state so that we can return the treeNode in event trigger.
	      if (treeNode) {
	        newState.treeNode = treeNode;
	
	        // Calculate the entities data for quick match
	        var entitiesMap = (0, _util.convertTreeToEntities)(treeNode);
	        newState.posEntities = entitiesMap.posEntities;
	        newState.keyEntities = entitiesMap.keyEntities;
	      }
	
	      var keyEntities = newState.keyEntities || prevState.keyEntities;
	
	      // ================ expandedKeys =================
	      if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) {
	        newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, _util.conductExpandParent)(props.expandedKeys, keyEntities) : props.expandedKeys;
	      } else if (!prevProps && props.defaultExpandAll) {
	        newState.expandedKeys = Object.keys(keyEntities);
	      } else if (!prevProps && props.defaultExpandedKeys) {
	        newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, _util.conductExpandParent)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
	      }
	
	      // ================ selectedKeys =================
	      if (props.selectable) {
	        if (needSync('selectedKeys')) {
	          newState.selectedKeys = (0, _util.calcSelectedKeys)(props.selectedKeys, props);
	        } else if (!prevProps && props.defaultSelectedKeys) {
	          newState.selectedKeys = (0, _util.calcSelectedKeys)(props.defaultSelectedKeys, props);
	        }
	      }
	
	      // ================= checkedKeys =================
	      if (props.checkable) {
	        var checkedKeyEntity = void 0;
	
	        if (needSync('checkedKeys')) {
	          checkedKeyEntity = (0, _util.parseCheckedKeys)(props.checkedKeys) || {};
	        } else if (!prevProps && props.defaultCheckedKeys) {
	          checkedKeyEntity = (0, _util.parseCheckedKeys)(props.defaultCheckedKeys) || {};
	        } else if (treeNode) {
	          // If treeNode changed, we also need check it
	          checkedKeyEntity = {
	            checkedKeys: prevState.checkedKeys,
	            halfCheckedKeys: prevState.halfCheckedKeys
	          };
	        }
	
	        if (checkedKeyEntity) {
	          var _checkedKeyEntity = checkedKeyEntity,
	              _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys,
	              checkedKeys = _checkedKeyEntity$che === undefined ? [] : _checkedKeyEntity$che,
	              _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys,
	              halfCheckedKeys = _checkedKeyEntity$hal === undefined ? [] : _checkedKeyEntity$hal;
	
	
	          if (!props.checkStrictly) {
	            var conductKeys = (0, _util.conductCheck)(checkedKeys, true, keyEntities);
	            checkedKeys = conductKeys.checkedKeys;
	            halfCheckedKeys = conductKeys.halfCheckedKeys;
	          }
	
	          newState.checkedKeys = checkedKeys;
	          newState.halfCheckedKeys = halfCheckedKeys;
	        }
	      }
	      // ================= loadedKeys ==================
	      if (needSync('loadedKeys')) {
	        newState.loadedKeys = props.loadedKeys;
	      }
	
	      return newState;
	    }
	
	    /**
	     * [Legacy] Select handler is less small than node,
	     * so that this will trigger when drag enter node or select handler.
	     * This is a little tricky if customize css without padding.
	     * Better for use mouse move event to refresh drag state.
	     * But let's just keep it to avoid event trigger logic change.
	     */
	
	
	    /**
	     * Only update the value which is not in props
	     */
	
	
	    /**
	     * [Legacy] Original logic use `key` as tracking clue.
	     * We have to use `cloneElement` to pass `key`.
	     */
	
	  }]);
	  return Tree;
	}(_react2['default'].Component);
	
	Tree.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  children: _propTypes2['default'].any,
	  treeData: _propTypes2['default'].array, // Generate treeNode by children
	  showLine: _propTypes2['default'].bool,
	  showIcon: _propTypes2['default'].bool,
	  icon: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]),
	  focusable: _propTypes2['default'].bool,
	  selectable: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  multiple: _propTypes2['default'].bool,
	  checkable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	  checkStrictly: _propTypes2['default'].bool,
	  draggable: _propTypes2['default'].bool,
	  defaultExpandParent: _propTypes2['default'].bool,
	  autoExpandParent: _propTypes2['default'].bool,
	  defaultExpandAll: _propTypes2['default'].bool,
	  defaultExpandedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  expandedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  defaultCheckedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  checkedKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])), _propTypes2['default'].object]),
	  defaultSelectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  selectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  onClick: _propTypes2['default'].func,
	  onDoubleClick: _propTypes2['default'].func,
	  onExpand: _propTypes2['default'].func,
	  onCheck: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  onLoad: _propTypes2['default'].func,
	  loadData: _propTypes2['default'].func,
	  loadedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onRightClick: _propTypes2['default'].func,
	  onDragStart: _propTypes2['default'].func,
	  onDragEnter: _propTypes2['default'].func,
	  onDragOver: _propTypes2['default'].func,
	  onDragLeave: _propTypes2['default'].func,
	  onDragEnd: _propTypes2['default'].func,
	  onDrop: _propTypes2['default'].func,
	  filterTreeNode: _propTypes2['default'].func,
	  openTransitionName: _propTypes2['default'].string,
	  openAnimation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  switcherIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func])
	};
	Tree.childContextTypes = _contextTypes.treeContextTypes;
	Tree.defaultProps = {
	  prefixCls: 'rc-tree',
	  showLine: false,
	  showIcon: true,
	  selectable: true,
	  multiple: false,
	  checkable: false,
	  disabled: false,
	  checkStrictly: false,
	  draggable: false,
	  defaultExpandParent: true,
	  autoExpandParent: false,
	  defaultExpandAll: false,
	  defaultExpandedKeys: [],
	  defaultCheckedKeys: [],
	  defaultSelectedKeys: []
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Tree);
	
	exports['default'] = Tree;
	module.exports = exports['default'];

/***/ },
/* 2722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TreeNode = undefined;
	
	var _Tree = __webpack_require__(2721);
	
	var _Tree2 = _interopRequireDefault(_Tree);
	
	var _TreeNode = __webpack_require__(871);
	
	var _TreeNode2 = _interopRequireDefault(_TreeNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Tree2['default'].TreeNode = _TreeNode2['default'];
	
	exports.TreeNode = _TreeNode2['default'];
	exports['default'] = _Tree2['default'];

/***/ },
/* 2723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.genAnimate = genAnimate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(160);
	
	var _toArray = __webpack_require__(239);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _AnimateChild = __webpack_require__(874);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _util = __webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	var clonePropList = ['children'];
	
	/**
	 * Default use `AnimateChild` as component.
	 * Here can also pass customize `ChildComponent` for test usage.
	 */
	function genAnimate(ChildComponent) {
	  var Animate = function (_React$Component) {
	    (0, _inherits3['default'])(Animate, _React$Component);
	
	    function Animate() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3['default'])(this, Animate);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Animate.__proto__ || Object.getPrototypeOf(Animate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        appeared: true,
	        mergedChildren: []
	      }, _this.onChildLeaved = function (key) {
	        // Remove child which not exist anymore
	        if (!_this.hasChild(key)) {
	          var mergedChildren = _this.state.mergedChildren;
	
	          _this.setState({
	            mergedChildren: mergedChildren.filter(function (node) {
	              return node.key !== key;
	            })
	          });
	        }
	      }, _this.hasChild = function (key) {
	        var children = _this.props.children;
	
	
	        return (0, _toArray2['default'])(children).some(function (node) {
	          return node && node.key === key;
	        });
	      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	    }
	    // [Legacy] Not sure usage
	    // commit: https://github.com/react-component/animate/commit/0a1cbfd647407498b10a8c6602a2dea80b42e324
	    // eslint-disable-line
	
	    (0, _createClass3['default'])(Animate, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // No need to re-render
	        this.state.appeared = false;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            appeared = _state.appeared,
	            mergedChildren = _state.mergedChildren;
	        var _props = this.props,
	            Component = _props.component,
	            componentProps = _props.componentProps,
	            className = _props.className,
	            style = _props.style,
	            showProp = _props.showProp;
	
	
	        var $children = mergedChildren.map(function (node) {
	          if (mergedChildren.length > 1 && !node.key) {
	            (0, _warning2['default'])(false, 'must set key for <rc-animate> children');
	            return null;
	          }
	
	          var show = true;
	
	          if (!_this2.hasChild(node.key)) {
	            show = false;
	          } else if (showProp) {
	            show = node.props[showProp];
	          }
	
	          var key = node.key || defaultKey;
	
	          return _react2['default'].createElement(
	            ChildComponent,
	            (0, _extends3['default'])({}, _this2.props, {
	              appeared: appeared,
	              show: show,
	              className: node.props.className,
	              style: node.props.style,
	              key: key,
	
	              animateKey: node.key // Keep trans origin key
	              , onChildLeaved: _this2.onChildLeaved
	            }),
	            node
	          );
	        });
	
	        // Wrap with component
	        if (Component) {
	          var passedProps = this.props;
	          if (typeof Component === 'string') {
	            passedProps = (0, _extends3['default'])({
	              className: className,
	              style: style
	            }, componentProps);
	          }
	
	          return _react2['default'].createElement(
	            Component,
	            passedProps,
	            $children
	          );
	        }
	
	        return $children[0] || null;
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(nextProps, prevState) {
	        var _prevState$prevProps = prevState.prevProps,
	            prevProps = _prevState$prevProps === undefined ? {} : _prevState$prevProps;
	
	        var newState = {
	          prevProps: (0, _util.cloneProps)(nextProps, clonePropList)
	        };
	        var showProp = nextProps.showProp;
	
	
	        function processState(propName, updater) {
	          if (prevProps[propName] !== nextProps[propName]) {
	            updater(nextProps[propName]);
	            return true;
	          }
	          return false;
	        }
	
	        processState('children', function (children) {
	          var currentChildren = (0, _toArray2['default'])(children).filter(function (node) {
	            return node;
	          });
	          var prevChildren = prevState.mergedChildren.filter(function (node) {
	            // Remove prev child if not show anymore
	            if (currentChildren.every(function (_ref2) {
	              var key = _ref2.key;
	              return key !== node.key;
	            }) && showProp && !node.props[showProp]) {
	              return false;
	            }
	            return true;
	          });
	
	          // Merge prev children to keep the animation
	          newState.mergedChildren = (0, _util.mergeChildren)(prevChildren, currentChildren);
	        });
	
	        return newState;
	      }
	    }]);
	    return Animate;
	  }(_react2['default'].Component);
	
	  Animate.isAnimate = true;
	  Animate.propTypes = {
	    component: _propTypes2['default'].any,
	    componentProps: _propTypes2['default'].object,
	    animation: _propTypes2['default'].object,
	    transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    transitionEnter: _propTypes2['default'].bool,
	    transitionAppear: _propTypes2['default'].bool,
	    exclusive: _propTypes2['default'].bool,
	    transitionLeave: _propTypes2['default'].bool,
	    onEnd: _propTypes2['default'].func,
	    onEnter: _propTypes2['default'].func,
	    onLeave: _propTypes2['default'].func,
	    onAppear: _propTypes2['default'].func,
	    showProp: _propTypes2['default'].string,
	    children: _propTypes2['default'].node,
	    style: _propTypes2['default'].object,
	    className: _propTypes2['default'].string
	  };
	  Animate.defaultProps = {
	    animation: {},
	    component: 'span',
	    componentProps: {},
	    transitionEnter: true,
	    transitionLeave: true,
	    transitionAppear: false
	  };
	
	
	  (0, _reactLifecyclesCompat.polyfill)(Animate);
	
	  return Animate;
	}
	
	exports['default'] = genAnimate(_AnimateChild2['default']);

/***/ },
/* 2724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(78);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.genCSSMotion = genCSSMotion;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(160);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _raf = __webpack_require__(310);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _util = __webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var STATUS_NONE = 'none';
	var STATUS_APPEAR = 'appear';
	var STATUS_ENTER = 'enter';
	var STATUS_LEAVE = 'leave';
	
	/**
	 * `transitionSupport` is used for none transition test case.
	 * Default we use browser transition event support check.
	 */
	function genCSSMotion(transitionSupport) {
	  var CSSMotion = function (_React$Component) {
	    (0, _inherits3['default'])(CSSMotion, _React$Component);
	
	    function CSSMotion() {
	      (0, _classCallCheck3['default'])(this, CSSMotion);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));
	
	      _this.onDomUpdate = function () {
	        var _this$state = _this.state,
	            status = _this$state.status,
	            newStatus = _this$state.newStatus;
	        var _this$props = _this.props,
	            onAppearStart = _this$props.onAppearStart,
	            onEnterStart = _this$props.onEnterStart,
	            onLeaveStart = _this$props.onLeaveStart,
	            onAppearActive = _this$props.onAppearActive,
	            onEnterActive = _this$props.onEnterActive,
	            onLeaveActive = _this$props.onLeaveActive,
	            motionAppear = _this$props.motionAppear,
	            motionEnter = _this$props.motionEnter,
	            motionLeave = _this$props.motionLeave;
	
	
	        if (!transitionSupport) {
	          return;
	        }
	
	        // Event injection
	        var $ele = _reactDom2['default'].findDOMNode(_this);
	        if (_this.$ele !== $ele) {
	          _this.removeEventListener(_this.$ele);
	          _this.addEventListener($ele);
	          _this.$ele = $ele;
	        }
	
	        // Init status
	        if (newStatus && status === STATUS_APPEAR && motionAppear) {
	          _this.updateStatus(onAppearStart, null, null, function () {
	            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
	          });
	        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
	          _this.updateStatus(onEnterStart, null, null, function () {
	            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
	          });
	        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
	          _this.updateStatus(onLeaveStart, null, null, function () {
	            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
	          });
	        }
	      };
	
	      _this.onMotionEnd = function (event) {
	        var _this$state2 = _this.state,
	            status = _this$state2.status,
	            statusActive = _this$state2.statusActive;
	        var _this$props2 = _this.props,
	            onAppearEnd = _this$props2.onAppearEnd,
	            onEnterEnd = _this$props2.onEnterEnd,
	            onLeaveEnd = _this$props2.onLeaveEnd;
	
	        if (status === STATUS_APPEAR && statusActive) {
	          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_ENTER && statusActive) {
	          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_LEAVE && statusActive) {
	          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
	        }
	      };
	
	      _this.addEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.addEventListener(_util.transitionEndName, _this.onMotionEnd);
	        $ele.addEventListener(_util.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.removeEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.removeEventListener(_util.transitionEndName, _this.onMotionEnd);
	        $ele.removeEventListener(_util.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
	        var statusStyle = styleFunc ? styleFunc(_reactDom2['default'].findDOMNode(_this), event) : null;
	
	        if (statusStyle === false || _this._destroyed) return;
	
	        var nextStep = void 0;
	        if (callback) {
	          nextStep = function nextStep() {
	            _this.nextFrame(callback);
	          };
	        }
	
	        _this.setState((0, _extends3['default'])({
	          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
	          newStatus: false
	        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
	      };
	
	      _this.updateActiveStatus = function (styleFunc, currentStatus) {
	        // `setState` use `postMessage` to trigger at the end of frame.
	        // Let's use requestAnimationFrame to update new state in next frame.
	        _this.nextFrame(function () {
	          var status = _this.state.status;
	
	          if (status !== currentStatus) return;
	
	          _this.updateStatus(styleFunc, { statusActive: true });
	        });
	      };
	
	      _this.nextFrame = function (func) {
	        _this.cancelNextFrame();
	        _this.raf = (0, _raf2['default'])(func);
	      };
	
	      _this.cancelNextFrame = function () {
	        if (_this.raf) {
	          _raf2['default'].cancel(_this.raf);
	          _this.raf = null;
	        }
	      };
	
	      _this.state = {
	        status: STATUS_NONE,
	        statusActive: false,
	        newStatus: false,
	        statusStyle: null
	      };
	      _this.$ele = null;
	      _this.raf = null;
	      return _this;
	    }
	
	    (0, _createClass3['default'])(CSSMotion, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._destroyed = true;
	        this.removeEventListener(this.$ele);
	        this.cancelNextFrame();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classNames;
	
	        var _state = this.state,
	            status = _state.status,
	            statusActive = _state.statusActive,
	            statusStyle = _state.statusStyle;
	        var _props = this.props,
	            children = _props.children,
	            motionName = _props.motionName,
	            visible = _props.visible;
	
	
	        if (!children) return null;
	
	        if (status === STATUS_NONE || !transitionSupport) {
	          return visible ? children({}) : null;
	        }
	
	        return children({
	          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, (0, _util.getTransitionName)(motionName, status), status !== STATUS_NONE), (0, _defineProperty3['default'])(_classNames, (0, _util.getTransitionName)(motionName, status + '-active'), status !== STATUS_NONE && statusActive), (0, _defineProperty3['default'])(_classNames, motionName, typeof motionName === 'string'), _classNames)),
	          style: statusStyle
	        });
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(props, _ref) {
	        var prevProps = _ref.prevProps;
	
	        if (!transitionSupport) return {};
	
	        var visible = props.visible,
	            motionAppear = props.motionAppear,
	            motionEnter = props.motionEnter,
	            motionLeave = props.motionLeave,
	            motionLeaveImmediately = props.motionLeaveImmediately;
	
	        var newState = {
	          prevProps: props
	        };
	
	        // Appear
	        if (!prevProps && visible && motionAppear) {
	          newState.status = STATUS_APPEAR;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Enter
	        if (prevProps && !prevProps.visible && visible && motionEnter) {
	          newState.status = STATUS_ENTER;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Leave
	        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
	          newState.status = STATUS_LEAVE;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        return newState;
	      }
	    }]);
	    return CSSMotion;
	  }(_react2['default'].Component);
	
	  CSSMotion.propTypes = {
	    visible: _propTypes2['default'].bool,
	    children: _propTypes2['default'].func,
	    motionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    motionAppear: _propTypes2['default'].bool,
	    motionEnter: _propTypes2['default'].bool,
	    motionLeave: _propTypes2['default'].bool,
	    motionLeaveImmediately: _propTypes2['default'].bool, // Trigger leave motion immediately
	    onAppearStart: _propTypes2['default'].func,
	    onAppearActive: _propTypes2['default'].func,
	    onAppearEnd: _propTypes2['default'].func,
	    onEnterStart: _propTypes2['default'].func,
	    onEnterActive: _propTypes2['default'].func,
	    onEnterEnd: _propTypes2['default'].func,
	    onLeaveStart: _propTypes2['default'].func,
	    onLeaveActive: _propTypes2['default'].func,
	    onLeaveEnd: _propTypes2['default'].func
	  };
	  CSSMotion.defaultProps = {
	    visible: true,
	    motionEnter: true,
	    motionAppear: true,
	    motionLeave: true
	  };
	
	
	  (0, _reactLifecyclesCompat.polyfill)(CSSMotion);
	
	  return CSSMotion;
	}
	
	exports['default'] = genCSSMotion(_util.supportTransition);

/***/ },
/* 2725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CSSMotion = exports.AnimateChild = undefined;
	
	var _Animate = __webpack_require__(2723);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	var _AnimateChild = __webpack_require__(874);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _CSSMotion = __webpack_require__(2724);
	
	var _CSSMotion2 = _interopRequireDefault(_CSSMotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.AnimateChild = _AnimateChild2['default'];
	exports.CSSMotion = _CSSMotion2['default'];
	exports['default'] = _Animate2['default'];

/***/ },
/* 2726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(2708);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(2710);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(2727);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(875);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(876);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Used for stretch
	      stretchChecked: false,
	      targetWidth: undefined,
	      targetHeight: undefined
	    };
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	    this.setStretchSize();
	  };
	
	  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setStretchSize();
	  };
	
	  // Record size if stretch needed
	
	
	  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
	    return _reactDom2['default'].findDOMNode(this.popupInstance);
	  };
	
	  // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align
	
	
	  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getTransitionName = function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  };
	
	  Popup.prototype.getPopupElement = function getPopupElement() {
	    var _this2 = this;
	
	    var savePopupRef = this.savePopupRef;
	    var _state = this.state,
	        stretchChecked = _state.stretchChecked,
	        targetHeight = _state.targetHeight,
	        targetWidth = _state.targetWidth;
	    var _props = this.props,
	        align = _props.align,
	        visible = _props.visible,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        getClassNameFromAlign = _props.getClassNameFromAlign,
	        destroyPopupOnHide = _props.destroyPopupOnHide,
	        stretch = _props.stretch,
	        children = _props.children,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseLeave = _props.onMouseLeave,
	        onMouseDown = _props.onMouseDown,
	        onTouchStart = _props.onTouchStart;
	
	    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	
	    var sizeStyle = {};
	    if (stretch) {
	      // Stretch with target
	      if (stretch.indexOf('height') !== -1) {
	        sizeStyle.height = targetHeight;
	      } else if (stretch.indexOf('minHeight') !== -1) {
	        sizeStyle.minHeight = targetHeight;
	      }
	      if (stretch.indexOf('width') !== -1) {
	        sizeStyle.width = targetWidth;
	      } else if (stretch.indexOf('minWidth') !== -1) {
	        sizeStyle.minWidth = targetWidth;
	      }
	
	      // Delay force align to makes ui smooth
	      if (!stretchChecked) {
	        sizeStyle.visibility = 'hidden';
	        setTimeout(function () {
	          if (_this2.alignInstance) {
	            _this2.alignInstance.forceAlign();
	          }
	        }, 0);
	      }
	    }
	
	    var newStyle = (0, _extends3['default'])({}, sizeStyle, style, this.getZIndexStyle());
	
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: savePopupRef,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseDown: onMouseDown,
	      onTouchStart: onTouchStart,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getAlignTarget(),
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              visible: true
	            }, popupInnerProps),
	            children
	          )
	        ) : null
	      );
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2['default'].createElement(
	        _rcAlign2['default'],
	        {
	          target: this.getAlignTarget(),
	          key: 'popup',
	          ref: this.saveAlignRef,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2['default'].createElement(
	          _PopupInner2['default'],
	          (0, _extends3['default'])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          children
	        )
	      )
	    );
	  };
	
	  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  };
	
	  Popup.prototype.getMaskElement = function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  };
	
	  Popup.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  };
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  stretch: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  point: _propTypes2['default'].shape({
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this3.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this3.currentAlignClassName !== currentAlignClassName) {
	      _this3.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this3.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.setStretchSize = function () {
	    var _props2 = _this3.props,
	        stretch = _props2.stretch,
	        getRootDomNode = _props2.getRootDomNode,
	        visible = _props2.visible;
	    var _state2 = _this3.state,
	        stretchChecked = _state2.stretchChecked,
	        targetHeight = _state2.targetHeight,
	        targetWidth = _state2.targetWidth;
	
	
	    if (!stretch || !visible) {
	      if (stretchChecked) {
	        _this3.setState({ stretchChecked: false });
	      }
	      return;
	    }
	
	    var $ele = getRootDomNode();
	    if (!$ele) return;
	
	    var height = $ele.offsetHeight;
	    var width = $ele.offsetWidth;
	
	    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
	      _this3.setState({
	        stretchChecked: true,
	        targetHeight: height,
	        targetWidth: width
	      });
	    }
	  };
	
	  this.getTargetElement = function () {
	    return _this3.props.getRootDomNode();
	  };
	
	  this.getAlignTarget = function () {
	    var point = _this3.props.point;
	
	    if (point) {
	      return point;
	    }
	    return _this3.getTargetElement;
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ },
/* 2727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(875);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  PopupInner.prototype.render = function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        onMouseDown: props.onMouseDown,
	        onTouchStart: props.onTouchStart,
	        style: props.style
	      },
	      _react2['default'].createElement(
	        _LazyRenderBox2['default'],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  };
	
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 2728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _contains = __webpack_require__(2730);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(311);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ContainerRender = __webpack_require__(2729);
	
	var _ContainerRender2 = _interopRequireDefault(_ContainerRender);
	
	var _Portal = __webpack_require__(2732);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(876);
	
	var _Popup = __webpack_require__(2726);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var contextTypes = {
	  rcTrigger: _propTypes2['default'].shape({
	    onPopupMouseDown: _propTypes2['default'].func
	  })
	};
	
	var Trigger = function (_React$Component) {
	  (0, _inherits3['default'])(Trigger, _React$Component);
	
	  function Trigger(props) {
	    (0, _classCallCheck3['default'])(this, Trigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	
	    _this.prevPopupVisible = popupVisible;
	
	    _this.state = {
	      popupVisible: popupVisible
	    };
	    return _this;
	  }
	
	  Trigger.prototype.getChildContext = function getChildContext() {
	    return {
	      rcTrigger: {
	        onPopupMouseDown: this.onPopupMouseDown
	      }
	    };
	  };
	
	  Trigger.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this2['fire' + h] = function (e) {
	        _this2.fireEvents(h, e);
	      };
	    });
	  };
	
	  Trigger.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  };
	
	  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var popupVisible = _ref.popupVisible;
	
	    if (popupVisible !== undefined) {
	      this.setState({
	        popupVisible: popupVisible
	      });
	    }
	  };
	
	  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    };
	    if (!IS_REACT_16) {
	      this.renderComponent(null, triggerAfterPopupVisibleChange);
	    }
	
	    this.prevPopupVisible = prevState.popupVisible;
	
	    // We must listen to `mousedown` or `touchstart`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	        currentDocument = currentDocument || props.getDocument();
	        this.contextMenuOutsideHandler1 = (0, _addEventListener2['default'])(currentDocument, 'scroll', this.onContextMenuClose);
	      }
	      // close popup when trigger type contains 'onContextMenu' and window is blur.
	      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	        this.contextMenuOutsideHandler2 = (0, _addEventListener2['default'])(window, 'blur', this.onContextMenuClose);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  };
	
	  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	    clearTimeout(this.mouseDownTimeout);
	  };
	
	  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  };
	
	  Trigger.prototype.getPopupAlign = function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  };
	
	  /**
	   * @param popupVisible    Show or not the popup element
	   * @param event           SyntheticEvent, used for `pointAlign`
	   */
	  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
	    var alignPoint = this.props.alignPoint;
	
	
	    this.clearDelayTimer();
	
	    if (this.state.popupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({ popupVisible: popupVisible });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	
	    // Always record the point position since mouseEnterDelay will delay the show
	    if (alignPoint && event) {
	      this.setPoint(event);
	    }
	  };
	
	  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
	    var _this3 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
	      this.delayTimer = setTimeout(function () {
	        _this3.setPopupVisible(visible, point);
	        _this3.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible, event);
	    }
	  };
	
	  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  };
	
	  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.contextMenuOutsideHandler1) {
	      this.contextMenuOutsideHandler1.remove();
	      this.contextMenuOutsideHandler1 = null;
	    }
	
	    if (this.contextMenuOutsideHandler2) {
	      this.contextMenuOutsideHandler2.remove();
	      this.contextMenuOutsideHandler2 = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  };
	
	  Trigger.prototype.createTwoChains = function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  };
	
	  Trigger.prototype.isClickToShow = function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
	    var _props2 = this.props,
	        action = _props2.action,
	        showAction = _props2.showAction;
	
	    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	  };
	
	  Trigger.prototype.isClickToHide = function isClickToHide() {
	    var _props3 = this.props,
	        action = _props3.action,
	        hideAction = _props3.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
	    var _props4 = this.props,
	        action = _props4.action,
	        showAction = _props4.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  };
	
	  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
	    var _props5 = this.props,
	        action = _props5.action,
	        hideAction = _props5.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  };
	
	  Trigger.prototype.isFocusToShow = function isFocusToShow() {
	    var _props6 = this.props,
	        action = _props6.action,
	        showAction = _props6.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  };
	
	  Trigger.prototype.isBlurToHide = function isBlurToHide() {
	    var _props7 = this.props,
	        action = _props7.action,
	        hideAction = _props7.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  };
	
	  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  };
	
	  Trigger.prototype.fireEvents = function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  };
	
	  Trigger.prototype.close = function close() {
	    this.setPopupVisible(false);
	  };
	
	  Trigger.prototype.render = function render() {
	    var _this4 = this;
	
	    var popupVisible = this.state.popupVisible;
	    var _props8 = this.props,
	        children = _props8.children,
	        forceRender = _props8.forceRender,
	        alignPoint = _props8.alignPoint,
	        className = _props8.className;
	
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = { key: 'trigger' };
	
	    if (this.isContextMenuToShow()) {
	      newChildProps.onContextMenu = this.onContextMenu;
	    } else {
	      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	    }
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	      if (alignPoint) {
	        newChildProps.onMouseMove = this.onMouseMove;
	      }
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    var childrenClassName = (0, _classnames2['default'])(child && child.props && child.props.className, className);
	    if (childrenClassName) {
	      newChildProps.className = childrenClassName;
	    }
	    var trigger = _react2['default'].cloneElement(child, newChildProps);
	
	    if (!IS_REACT_16) {
	      return _react2['default'].createElement(
	        _ContainerRender2['default'],
	        {
	          parent: this,
	          visible: popupVisible,
	          autoMount: false,
	          forceRender: forceRender,
	          getComponent: this.getComponent,
	          getContainer: this.getContainer
	        },
	        function (_ref2) {
	          var renderComponent = _ref2.renderComponent;
	
	          _this4.renderComponent = renderComponent;
	          return trigger;
	        }
	      );
	    }
	
	    var portal = void 0;
	    // prevent unmounting after it's rendered
	    if (popupVisible || this._component || forceRender) {
	      portal = _react2['default'].createElement(
	        _Portal2['default'],
	        {
	          key: 'portal',
	          getContainer: this.getContainer,
	          didUpdate: this.handlePortalUpdate
	        },
	        this.getComponent()
	      );
	    }
	
	    return [trigger, portal];
	  };
	
	  return Trigger;
	}(_react2['default'].Component);
	
	Trigger.propTypes = {
	  children: _propTypes2['default'].any,
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  showAction: _propTypes2['default'].any,
	  hideAction: _propTypes2['default'].any,
	  getPopupClassNameFromAlign: _propTypes2['default'].any,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  afterPopupVisibleChange: _propTypes2['default'].func,
	  popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  popupStyle: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  builtinPlacements: _propTypes2['default'].object,
	  popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  popupAnimation: _propTypes2['default'].any,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  zIndex: _propTypes2['default'].number,
	  focusDelay: _propTypes2['default'].number,
	  blurDelay: _propTypes2['default'].number,
	  getPopupContainer: _propTypes2['default'].func,
	  getDocument: _propTypes2['default'].func,
	  forceRender: _propTypes2['default'].bool,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  mask: _propTypes2['default'].bool,
	  maskClosable: _propTypes2['default'].bool,
	  onPopupAlign: _propTypes2['default'].func,
	  popupAlign: _propTypes2['default'].object,
	  popupVisible: _propTypes2['default'].bool,
	  defaultPopupVisible: _propTypes2['default'].bool,
	  maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  maskAnimation: _propTypes2['default'].string,
	  stretch: _propTypes2['default'].string,
	  alignPoint: _propTypes2['default'].bool // Maybe we can support user pass position in the future
	};
	Trigger.contextTypes = contextTypes;
	Trigger.childContextTypes = contextTypes;
	Trigger.defaultProps = {
	  prefixCls: 'rc-trigger-popup',
	  getPopupClassNameFromAlign: returnEmptyString,
	  getDocument: returnDocument,
	  onPopupVisibleChange: noop,
	  afterPopupVisibleChange: noop,
	  onPopupAlign: noop,
	  popupClassName: '',
	  mouseEnterDelay: 0,
	  mouseLeaveDelay: 0.1,
	  focusDelay: 0,
	  blurDelay: 0.15,
	  popupStyle: {},
	  destroyPopupOnHide: false,
	  popupAlign: {},
	  defaultPopupVisible: false,
	  mask: false,
	  maskClosable: true,
	  action: [],
	  showAction: [],
	  hideAction: []
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.onMouseEnter = function (e) {
	    var mouseEnterDelay = _this5.props.mouseEnterDelay;
	
	    _this5.fireEvents('onMouseEnter', e);
	    _this5.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	  };
	
	  this.onMouseMove = function (e) {
	    _this5.fireEvents('onMouseMove', e);
	    _this5.setPoint(e);
	  };
	
	  this.onMouseLeave = function (e) {
	    _this5.fireEvents('onMouseLeave', e);
	    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
	  };
	
	  this.onPopupMouseEnter = function () {
	    _this5.clearDelayTimer();
	  };
	
	  this.onPopupMouseLeave = function (e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && (0, _contains2['default'])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
	  };
	
	  this.onFocus = function (e) {
	    _this5.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    _this5.clearDelayTimer();
	    if (_this5.isFocusToShow()) {
	      _this5.focusTime = Date.now();
	      _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
	    }
	  };
	
	  this.onMouseDown = function (e) {
	    _this5.fireEvents('onMouseDown', e);
	    _this5.preClickTime = Date.now();
	  };
	
	  this.onTouchStart = function (e) {
	    _this5.fireEvents('onTouchStart', e);
	    _this5.preTouchTime = Date.now();
	  };
	
	  this.onBlur = function (e) {
	    _this5.fireEvents('onBlur', e);
	    _this5.clearDelayTimer();
	    if (_this5.isBlurToHide()) {
	      _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
	    }
	  };
	
	  this.onContextMenu = function (e) {
	    e.preventDefault();
	    _this5.fireEvents('onContextMenu', e);
	    _this5.setPopupVisible(true, e);
	  };
	
	  this.onContextMenuClose = function () {
	    if (_this5.isContextMenuToShow()) {
	      _this5.close();
	    }
	  };
	
	  this.onClick = function (event) {
	    _this5.fireEvents('onClick', event);
	    // focus will trigger click
	    if (_this5.focusTime) {
	      var preTime = void 0;
	      if (_this5.preClickTime && _this5.preTouchTime) {
	        preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
	      } else if (_this5.preClickTime) {
	        preTime = _this5.preClickTime;
	      } else if (_this5.preTouchTime) {
	        preTime = _this5.preTouchTime;
	      }
	      if (Math.abs(preTime - _this5.focusTime) < 20) {
	        return;
	      }
	      _this5.focusTime = 0;
	    }
	    _this5.preClickTime = 0;
	    _this5.preTouchTime = 0;
	    if (event && event.preventDefault) {
	      event.preventDefault();
	    }
	    var nextVisible = !_this5.state.popupVisible;
	    if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
	      _this5.setPopupVisible(!_this5.state.popupVisible, event);
	    }
	  };
	
	  this.onPopupMouseDown = function () {
	    var _context$rcTrigger = _this5.context.rcTrigger,
	        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
	
	    _this5.hasPopupMouseDown = true;
	
	    clearTimeout(_this5.mouseDownTimeout);
	    _this5.mouseDownTimeout = setTimeout(function () {
	      _this5.hasPopupMouseDown = false;
	    }, 0);
	
	    if (rcTrigger.onPopupMouseDown) {
	      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
	    }
	  };
	
	  this.onDocumentClick = function (event) {
	    if (_this5.props.mask && !_this5.props.maskClosable) {
	      return;
	    }
	
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(_this5);
	    if (!(0, _contains2['default'])(root, target) && !_this5.hasPopupMouseDown) {
	      _this5.close();
	    }
	  };
	
	  this.getRootDomNode = function () {
	    return (0, _reactDom.findDOMNode)(_this5);
	  };
	
	  this.getPopupClassNameFromAlign = function (align) {
	    var className = [];
	    var _props9 = _this5.props,
	        popupPlacement = _props9.popupPlacement,
	        builtinPlacements = _props9.builtinPlacements,
	        prefixCls = _props9.prefixCls,
	        alignPoint = _props9.alignPoint,
	        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
	    }
	    if (getPopupClassNameFromAlign) {
	      className.push(getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  };
	
	  this.getComponent = function () {
	    var _props10 = _this5.props,
	        prefixCls = _props10.prefixCls,
	        destroyPopupOnHide = _props10.destroyPopupOnHide,
	        popupClassName = _props10.popupClassName,
	        action = _props10.action,
	        onPopupAlign = _props10.onPopupAlign,
	        popupAnimation = _props10.popupAnimation,
	        popupTransitionName = _props10.popupTransitionName,
	        popupStyle = _props10.popupStyle,
	        mask = _props10.mask,
	        maskAnimation = _props10.maskAnimation,
	        maskTransitionName = _props10.maskTransitionName,
	        zIndex = _props10.zIndex,
	        popup = _props10.popup,
	        stretch = _props10.stretch,
	        alignPoint = _props10.alignPoint;
	    var _state = _this5.state,
	        popupVisible = _state.popupVisible,
	        point = _state.point;
	
	
	    var align = _this5.getPopupAlign();
	
	    var mouseProps = {};
	    if (_this5.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
	    }
	    if (_this5.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
	    }
	
	    mouseProps.onMouseDown = _this5.onPopupMouseDown;
	    mouseProps.onTouchStart = _this5.onPopupMouseDown;
	
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: prefixCls,
	        destroyPopupOnHide: destroyPopupOnHide,
	        visible: popupVisible,
	        point: alignPoint && point,
	        className: popupClassName,
	        action: action,
	        align: align,
	        onAlign: onPopupAlign,
	        animation: popupAnimation,
	        getClassNameFromAlign: _this5.getPopupClassNameFromAlign
	      }, mouseProps, {
	        stretch: stretch,
	        getRootDomNode: _this5.getRootDomNode,
	        style: popupStyle,
	        mask: mask,
	        zIndex: zIndex,
	        transitionName: popupTransitionName,
	        maskAnimation: maskAnimation,
	        maskTransitionName: maskTransitionName,
	        ref: _this5.savePopup
	      }),
	      typeof popup === 'function' ? popup() : popup
	    );
	  };
	
	  this.getContainer = function () {
	    var props = _this5.props;
	
	    var popupContainer = document.createElement('div');
	    // Make sure default popup container will never cause scrollbar appearing
	    // https://github.com/react-component/trigger/issues/41
	    popupContainer.style.position = 'absolute';
	    popupContainer.style.top = '0';
	    popupContainer.style.left = '0';
	    popupContainer.style.width = '100%';
	    var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(_this5)) : props.getDocument().body;
	    mountNode.appendChild(popupContainer);
	    return popupContainer;
	  };
	
	  this.setPoint = function (point) {
	    var alignPoint = _this5.props.alignPoint;
	
	    if (!alignPoint || !point) return;
	
	    _this5.setState({
	      point: {
	        pageX: point.pageX,
	        pageY: point.pageY
	      }
	    });
	  };
	
	  this.handlePortalUpdate = function () {
	    if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
	      _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
	    }
	  };
	
	  this.savePopup = function (node) {
	    _this5._component = node;
	  };
	};
	
	exports['default'] = Trigger;
	module.exports = exports['default'];

/***/ },
/* 2729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ContainerRender = function (_React$Component) {
	  (0, _inherits3['default'])(ContainerRender, _React$Component);
	
	  function ContainerRender() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, ContainerRender);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
	      if (_this.container) {
	        _reactDom2['default'].unmountComponentAtNode(_this.container);
	        _this.container.parentNode.removeChild(_this.container);
	        _this.container = null;
	      }
	    }, _this.renderComponent = function (props, ready) {
	      var _this$props = _this.props,
	          visible = _this$props.visible,
	          getComponent = _this$props.getComponent,
	          forceRender = _this$props.forceRender,
	          getContainer = _this$props.getContainer,
	          parent = _this$props.parent;
	
	      if (visible || parent._component || forceRender) {
	        if (!_this.container) {
	          _this.container = getContainer();
	        }
	        _reactDom2['default'].unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
	          if (ready) {
	            ready.call(this);
	          }
	        });
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(ContainerRender, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.autoDestroy) {
	        this.removeContainer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        renderComponent: this.renderComponent,
	        removeContainer: this.removeContainer
	      });
	    }
	  }]);
	  return ContainerRender;
	}(_react2['default'].Component);
	
	ContainerRender.propTypes = {
	  autoMount: _propTypes2['default'].bool,
	  autoDestroy: _propTypes2['default'].bool,
	  visible: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  parent: _propTypes2['default'].any,
	  getComponent: _propTypes2['default'].func.isRequired,
	  getContainer: _propTypes2['default'].func.isRequired,
	  children: _propTypes2['default'].func.isRequired
	};
	ContainerRender.defaultProps = {
	  autoMount: true,
	  autoDestroy: true,
	  forceRender: false
	};
	exports['default'] = ContainerRender;
	module.exports = exports['default'];

/***/ },
/* 2730 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = contains;
	function contains(root, n) {
	  var node = n;
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 2731 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @ignore
	 * some key-codes definition and utils from closure-library
	 * @author yiminghe@gmail.com
	 */
	
	var KeyCode = {
	  /**
	   * MAC_ENTER
	   */
	  MAC_ENTER: 3,
	  /**
	   * BACKSPACE
	   */
	  BACKSPACE: 8,
	  /**
	   * TAB
	   */
	  TAB: 9,
	  /**
	   * NUMLOCK on FF/Safari Mac
	   */
	  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
	  /**
	   * ENTER
	   */
	  ENTER: 13,
	  /**
	   * SHIFT
	   */
	  SHIFT: 16,
	  /**
	   * CTRL
	   */
	  CTRL: 17,
	  /**
	   * ALT
	   */
	  ALT: 18,
	  /**
	   * PAUSE
	   */
	  PAUSE: 19,
	  /**
	   * CAPS_LOCK
	   */
	  CAPS_LOCK: 20,
	  /**
	   * ESC
	   */
	  ESC: 27,
	  /**
	   * SPACE
	   */
	  SPACE: 32,
	  /**
	   * PAGE_UP
	   */
	  PAGE_UP: 33, // also NUM_NORTH_EAST
	  /**
	   * PAGE_DOWN
	   */
	  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
	  /**
	   * END
	   */
	  END: 35, // also NUM_SOUTH_WEST
	  /**
	   * HOME
	   */
	  HOME: 36, // also NUM_NORTH_WEST
	  /**
	   * LEFT
	   */
	  LEFT: 37, // also NUM_WEST
	  /**
	   * UP
	   */
	  UP: 38, // also NUM_NORTH
	  /**
	   * RIGHT
	   */
	  RIGHT: 39, // also NUM_EAST
	  /**
	   * DOWN
	   */
	  DOWN: 40, // also NUM_SOUTH
	  /**
	   * PRINT_SCREEN
	   */
	  PRINT_SCREEN: 44,
	  /**
	   * INSERT
	   */
	  INSERT: 45, // also NUM_INSERT
	  /**
	   * DELETE
	   */
	  DELETE: 46, // also NUM_DELETE
	  /**
	   * ZERO
	   */
	  ZERO: 48,
	  /**
	   * ONE
	   */
	  ONE: 49,
	  /**
	   * TWO
	   */
	  TWO: 50,
	  /**
	   * THREE
	   */
	  THREE: 51,
	  /**
	   * FOUR
	   */
	  FOUR: 52,
	  /**
	   * FIVE
	   */
	  FIVE: 53,
	  /**
	   * SIX
	   */
	  SIX: 54,
	  /**
	   * SEVEN
	   */
	  SEVEN: 55,
	  /**
	   * EIGHT
	   */
	  EIGHT: 56,
	  /**
	   * NINE
	   */
	  NINE: 57,
	  /**
	   * QUESTION_MARK
	   */
	  QUESTION_MARK: 63, // needs localization
	  /**
	   * A
	   */
	  A: 65,
	  /**
	   * B
	   */
	  B: 66,
	  /**
	   * C
	   */
	  C: 67,
	  /**
	   * D
	   */
	  D: 68,
	  /**
	   * E
	   */
	  E: 69,
	  /**
	   * F
	   */
	  F: 70,
	  /**
	   * G
	   */
	  G: 71,
	  /**
	   * H
	   */
	  H: 72,
	  /**
	   * I
	   */
	  I: 73,
	  /**
	   * J
	   */
	  J: 74,
	  /**
	   * K
	   */
	  K: 75,
	  /**
	   * L
	   */
	  L: 76,
	  /**
	   * M
	   */
	  M: 77,
	  /**
	   * N
	   */
	  N: 78,
	  /**
	   * O
	   */
	  O: 79,
	  /**
	   * P
	   */
	  P: 80,
	  /**
	   * Q
	   */
	  Q: 81,
	  /**
	   * R
	   */
	  R: 82,
	  /**
	   * S
	   */
	  S: 83,
	  /**
	   * T
	   */
	  T: 84,
	  /**
	   * U
	   */
	  U: 85,
	  /**
	   * V
	   */
	  V: 86,
	  /**
	   * W
	   */
	  W: 87,
	  /**
	   * X
	   */
	  X: 88,
	  /**
	   * Y
	   */
	  Y: 89,
	  /**
	   * Z
	   */
	  Z: 90,
	  /**
	   * META
	   */
	  META: 91, // WIN_KEY_LEFT
	  /**
	   * WIN_KEY_RIGHT
	   */
	  WIN_KEY_RIGHT: 92,
	  /**
	   * CONTEXT_MENU
	   */
	  CONTEXT_MENU: 93,
	  /**
	   * NUM_ZERO
	   */
	  NUM_ZERO: 96,
	  /**
	   * NUM_ONE
	   */
	  NUM_ONE: 97,
	  /**
	   * NUM_TWO
	   */
	  NUM_TWO: 98,
	  /**
	   * NUM_THREE
	   */
	  NUM_THREE: 99,
	  /**
	   * NUM_FOUR
	   */
	  NUM_FOUR: 100,
	  /**
	   * NUM_FIVE
	   */
	  NUM_FIVE: 101,
	  /**
	   * NUM_SIX
	   */
	  NUM_SIX: 102,
	  /**
	   * NUM_SEVEN
	   */
	  NUM_SEVEN: 103,
	  /**
	   * NUM_EIGHT
	   */
	  NUM_EIGHT: 104,
	  /**
	   * NUM_NINE
	   */
	  NUM_NINE: 105,
	  /**
	   * NUM_MULTIPLY
	   */
	  NUM_MULTIPLY: 106,
	  /**
	   * NUM_PLUS
	   */
	  NUM_PLUS: 107,
	  /**
	   * NUM_MINUS
	   */
	  NUM_MINUS: 109,
	  /**
	   * NUM_PERIOD
	   */
	  NUM_PERIOD: 110,
	  /**
	   * NUM_DIVISION
	   */
	  NUM_DIVISION: 111,
	  /**
	   * F1
	   */
	  F1: 112,
	  /**
	   * F2
	   */
	  F2: 113,
	  /**
	   * F3
	   */
	  F3: 114,
	  /**
	   * F4
	   */
	  F4: 115,
	  /**
	   * F5
	   */
	  F5: 116,
	  /**
	   * F6
	   */
	  F6: 117,
	  /**
	   * F7
	   */
	  F7: 118,
	  /**
	   * F8
	   */
	  F8: 119,
	  /**
	   * F9
	   */
	  F9: 120,
	  /**
	   * F10
	   */
	  F10: 121,
	  /**
	   * F11
	   */
	  F11: 122,
	  /**
	   * F12
	   */
	  F12: 123,
	  /**
	   * NUMLOCK
	   */
	  NUMLOCK: 144,
	  /**
	   * SEMICOLON
	   */
	  SEMICOLON: 186, // needs localization
	  /**
	   * DASH
	   */
	  DASH: 189, // needs localization
	  /**
	   * EQUALS
	   */
	  EQUALS: 187, // needs localization
	  /**
	   * COMMA
	   */
	  COMMA: 188, // needs localization
	  /**
	   * PERIOD
	   */
	  PERIOD: 190, // needs localization
	  /**
	   * SLASH
	   */
	  SLASH: 191, // needs localization
	  /**
	   * APOSTROPHE
	   */
	  APOSTROPHE: 192, // needs localization
	  /**
	   * SINGLE_QUOTE
	   */
	  SINGLE_QUOTE: 222, // needs localization
	  /**
	   * OPEN_SQUARE_BRACKET
	   */
	  OPEN_SQUARE_BRACKET: 219, // needs localization
	  /**
	   * BACKSLASH
	   */
	  BACKSLASH: 220, // needs localization
	  /**
	   * CLOSE_SQUARE_BRACKET
	   */
	  CLOSE_SQUARE_BRACKET: 221, // needs localization
	  /**
	   * WIN_KEY
	   */
	  WIN_KEY: 224,
	  /**
	   * MAC_FF_META
	   */
	  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
	  /**
	   * WIN_IME
	   */
	  WIN_IME: 229
	};
	
	/*
	 whether text and modified key is entered at the same time.
	 */
	KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
	  var keyCode = e.keyCode;
	  if (e.altKey && !e.ctrlKey || e.metaKey ||
	  // Function keys don't generate text
	  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
	    return false;
	  }
	
	  // The following keys are quite harmless, even in combination with
	  // CTRL, ALT or SHIFT.
	  switch (keyCode) {
	    case KeyCode.ALT:
	    case KeyCode.CAPS_LOCK:
	    case KeyCode.CONTEXT_MENU:
	    case KeyCode.CTRL:
	    case KeyCode.DOWN:
	    case KeyCode.END:
	    case KeyCode.ESC:
	    case KeyCode.HOME:
	    case KeyCode.INSERT:
	    case KeyCode.LEFT:
	    case KeyCode.MAC_FF_META:
	    case KeyCode.META:
	    case KeyCode.NUMLOCK:
	    case KeyCode.NUM_CENTER:
	    case KeyCode.PAGE_DOWN:
	    case KeyCode.PAGE_UP:
	    case KeyCode.PAUSE:
	    case KeyCode.PRINT_SCREEN:
	    case KeyCode.RIGHT:
	    case KeyCode.SHIFT:
	    case KeyCode.UP:
	    case KeyCode.WIN_KEY:
	    case KeyCode.WIN_KEY_RIGHT:
	      return false;
	    default:
	      return true;
	  }
	};
	
	/*
	 whether character is entered.
	 */
	KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
	  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
	    return true;
	  }
	
	  // Safari sends zero key code for non-latin characters.
	  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
	    return true;
	  }
	
	  switch (keyCode) {
	    case KeyCode.SPACE:
	    case KeyCode.QUESTION_MARK:
	    case KeyCode.NUM_PLUS:
	    case KeyCode.NUM_MINUS:
	    case KeyCode.NUM_PERIOD:
	    case KeyCode.NUM_DIVISION:
	    case KeyCode.SEMICOLON:
	    case KeyCode.DASH:
	    case KeyCode.EQUALS:
	    case KeyCode.COMMA:
	    case KeyCode.PERIOD:
	    case KeyCode.SLASH:
	    case KeyCode.APOSTROPHE:
	    case KeyCode.SINGLE_QUOTE:
	    case KeyCode.OPEN_SQUARE_BRACKET:
	    case KeyCode.BACKSLASH:
	    case KeyCode.CLOSE_SQUARE_BRACKET:
	      return true;
	    default:
	      return false;
	  }
	};
	
	exports['default'] = KeyCode;
	module.exports = exports['default'];

/***/ },
/* 2732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Portal = function (_React$Component) {
	  (0, _inherits3['default'])(Portal, _React$Component);
	
	  function Portal() {
	    (0, _classCallCheck3['default'])(this, Portal);
	    return (0, _possibleConstructorReturn3['default'])(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createContainer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var didUpdate = this.props.didUpdate;
	
	      if (didUpdate) {
	        didUpdate(prevProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeContainer();
	    }
	  }, {
	    key: 'createContainer',
	    value: function createContainer() {
	      this._container = this.props.getContainer();
	      this.forceUpdate();
	    }
	  }, {
	    key: 'removeContainer',
	    value: function removeContainer() {
	      if (this._container) {
	        this._container.parentNode.removeChild(this._container);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this._container) {
	        return _reactDom2['default'].createPortal(this.props.children, this._container);
	      }
	      return null;
	    }
	  }]);
	  return Portal;
	}(_react2['default'].Component);
	
	Portal.propTypes = {
	  getContainer: _propTypes2['default'].func.isRequired,
	  children: _propTypes2['default'].node.isRequired,
	  didUpdate: _propTypes2['default'].func
	};
	exports['default'] = Portal;
	module.exports = exports['default'];

/***/ },
/* 2733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _asyncContainer = __webpack_require__(881);
	
	var _asyncContainer2 = _interopRequireDefault(_asyncContainer);
	
	var _Typeahead = __webpack_require__(880);
	
	var _Typeahead2 = _interopRequireDefault(_Typeahead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _asyncContainer2.default)(_Typeahead2.default);

/***/ },
/* 2734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * CloseButton
	 *
	 * http://getbootstrap.com/css/#helper-classes-close
	 */
	var ClearButton = function ClearButton(_ref) {
	  var bsSize = _ref.bsSize,
	      className = _ref.className,
	      onClick = _ref.onClick;
	  return _react2.default.createElement(
	    'button',
	    {
	      'aria-label': 'Close',
	      className: (0, _classnames2.default)('close', {
	        'close-lg': bsSize === 'large' || bsSize === 'lg'
	      }, className),
	      onClick: onClick,
	      type: 'button' },
	    _react2.default.createElement(
	      'span',
	      { 'aria-hidden': 'true' },
	      '\xD7'
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'sr-only' },
	      'Close'
	    )
	  );
	};
	
	ClearButton.displayName = 'ClearButton';
	ClearButton.propTypes = {
	  bsSize: _propTypes2.default.oneOf(['large', 'lg', 'small', 'sm'])
	};
	
	exports.default = ClearButton;

/***/ },
/* 2735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loader = function Loader(_ref) {
	  var bsSize = _ref.bsSize;
	  return _react2.default.createElement('div', {
	    className: (0, _classnames2.default)('bootstrap-typeahead-loader', {
	      'loader-lg': bsSize === 'large' || bsSize === 'lg',
	      'loader-sm': bsSize === 'small' || bsSize === 'sm'
	    })
	  });
	};
	
	Loader.propTypes = {
	  bsSize: _propTypes2.default.oneOf(['large', 'lg', 'small', 'sm'])
	};
	
	exports.default = Loader;

/***/ },
/* 2736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(31);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactOverlays = __webpack_require__(2754);
	
	var _componentOrElement = __webpack_require__(2982);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// When appending the overlay to `document.body`, clicking on it will register
	// as an "outside" click and immediately close the overlay. This classname tells
	// `react-onclickoutside` to ignore the click.
	var IGNORE_CLICK_OUTSIDE = 'ignore-react-onclickoutside';
	
	function isBody(container) {
	  return container === document.body;
	}
	
	/**
	 * Custom `Overlay` component, since the version in `react-overlays` doesn't
	 * work for our needs. Specifically, the `Position` component doesn't provide
	 * the customized placement we need.
	 */
	
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));
	
	    _this.displayName = 'Overlay';
	
	
	    _this._updatePosition = _this._updatePosition.bind(_this);
	
	    _this.state = {
	      bottom: 0,
	      left: 0,
	      right: 0,
	      top: 0
	    };
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._mounted = true;
	      this._updatePosition();
	
	      this._updatePositionThrottled = requestAnimationFrame.bind(null, this._updatePosition);
	
	      window.addEventListener('resize', this._updatePositionThrottled);
	      window.addEventListener('scroll', this._updatePositionThrottled, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this._updatePositionThrottled();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._mounted = false;
	      window.removeEventListener('resize', this._updatePositionThrottled);
	      window.removeEventListener('scroll', this._updatePositionThrottled);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.show) {
	        return null;
	      }
	
	      var _props = this.props,
	          container = _props.container,
	          children = _props.children;
	
	      var child = _react.Children.only(children);
	
	      // When not attaching the overlay to `document.body` treat the child as a
	      // simple inline element.
	      if (!isBody(container)) {
	        return child;
	      }
	
	      child = (0, _react.cloneElement)(child, _extends({}, child.props, {
	        className: (0, _classnames2.default)(child.props.className, IGNORE_CLICK_OUTSIDE),
	        style: this.state
	      }));
	
	      return _react2.default.createElement(
	        _reactOverlays.Portal,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: '_updatePosition',
	    value: function _updatePosition() {
	      // Positioning is only used when body is the container.
	      if (!this.props.show || !this._mounted || !isBody(this.props.container)) {
	        return;
	      }
	
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      var targetNode = (0, _reactDom.findDOMNode)(targetElement);
	
	      if (targetNode) {
	        var _window = window,
	            innerHeight = _window.innerHeight,
	            innerWidth = _window.innerWidth,
	            pageYOffset = _window.pageYOffset;
	
	        var _targetNode$getBoundi = targetNode.getBoundingClientRect(),
	            bottom = _targetNode$getBoundi.bottom,
	            left = _targetNode$getBoundi.left,
	            top = _targetNode$getBoundi.top,
	            width = _targetNode$getBoundi.width;
	
	        var newState = {
	          bottom: innerHeight - pageYOffset - top,
	          left: left,
	          right: innerWidth - left - width,
	          top: pageYOffset + bottom
	        };
	
	        // Don't update unless the target element position has changed.
	        if (!(0, _isEqual3.default)(this.state, newState)) {
	          this.setState(newState);
	        }
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = {
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]).isRequired,
	  show: _propTypes2.default.bool,
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]).isRequired
	};
	
	Overlay.defaultProps = {
	  show: false
	};
	
	exports.default = Overlay;

/***/ },
/* 2737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextInput = function (_React$Component) {
	  _inherits(TextInput, _React$Component);
	
	  function TextInput() {
	    _classCallCheck(this, TextInput);
	
	    return _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).apply(this, arguments));
	  }
	
	  _createClass(TextInput, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          bsSize = _props.bsSize,
	          className = _props.className,
	          hasAux = _props.hasAux,
	          otherProps = _objectWithoutProperties(_props, ['bsSize', 'className', 'hasAux']);
	
	      return _react2.default.createElement('input', _extends({}, otherProps, {
	        className: (0, _classnames2.default)('form-control', {
	          'has-aux': hasAux,
	          'input-lg': bsSize === 'large' || bsSize === 'lg',
	          'input-sm': bsSize === 'small' || bsSize === 'sm'
	        }, className),
	        ref: function ref(input) {
	          return _this2._input = input;
	        },
	        type: 'text'
	      }));
	    }
	  }, {
	    key: 'getInstance',
	    value: function getInstance() {
	      return this._input;
	    }
	  }]);
	
	  return TextInput;
	}(_react2.default.Component);
	
	TextInput.propTypes = {
	  /**
	   * Specify the size of the input.
	   */
	  bsSize: _propTypes2.default.oneOf(['large', 'lg', 'small', 'sm'])
	};
	
	exports.default = TextInput;

/***/ },
/* 2738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactInputAutosize = __webpack_require__(2980);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _Token = __webpack_require__(879);
	
	var _Token2 = _interopRequireDefault(_Token);
	
	var _getOptionLabel = __webpack_require__(193);
	
	var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);
	
	var _keyCode = __webpack_require__(312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * TokenizerInput
	 *
	 * Accepts multiple selections from a Typeahead component and renders them as
	 * tokens within an input.
	 */
	var TokenizerInput = function (_React$Component) {
	  _inherits(TokenizerInput, _React$Component);
	
	  function TokenizerInput(props) {
	    _classCallCheck(this, TokenizerInput);
	
	    var _this = _possibleConstructorReturn(this, (TokenizerInput.__proto__ || Object.getPrototypeOf(TokenizerInput)).call(this, props));
	
	    _this.displayName = 'TokenizerInput';
	
	
	    _this._handleBlur = _this._handleBlur.bind(_this);
	    _this._handleChange = _this._handleChange.bind(_this);
	    _this._handleInputFocus = _this._handleInputFocus.bind(_this);
	    _this._handleKeydown = _this._handleKeydown.bind(_this);
	    _this._renderToken = _this._renderToken.bind(_this);
	
	    _this.state = {
	      isFocused: false
	    };
	    return _this;
	  }
	
	  _createClass(TokenizerInput, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bsSize = _props.bsSize,
	          disabled = _props.disabled,
	          hasAux = _props.hasAux,
	          placeholder = _props.placeholder,
	          selected = _props.selected,
	          value = _props.value;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('bootstrap-tokenizer', 'clearfix', 'form-control', {
	            'focus': this.state.isFocused,
	            'has-aux': hasAux,
	            'input-lg': bsSize === 'large' || bsSize === 'lg',
	            'input-sm': bsSize === 'small' || bsSize === 'sm'
	          }),
	          disabled: disabled,
	          onClick: this._handleInputFocus,
	          onFocus: this._handleInputFocus,
	          style: {
	            cursor: 'text',
	            height: 'auto'
	          },
	          tabIndex: -1 },
	        selected.map(this._renderToken),
	        _react2.default.createElement(_reactInputAutosize2.default, {
	          className: 'bootstrap-tokenizer-input',
	          disabled: disabled,
	          inputClassName: 'bootstrap-typeahead-input-main',
	          inputStyle: {
	            backgroundColor: 'inherit',
	            border: 0,
	            boxShadow: 'none',
	            cursor: 'inherit',
	            outline: 'none',
	            padding: 0
	          },
	          onBlur: this._handleBlur,
	          onChange: this._handleChange,
	          onFocus: this.props.onFocus,
	          onKeyDown: this._handleKeydown,
	          placeholder: selected.length ? null : placeholder,
	          ref: 'input',
	          type: 'text',
	          value: value
	        })
	      );
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.refs.input.blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this._handleInputFocus();
	    }
	  }, {
	    key: '_renderToken',
	    value: function _renderToken(option, idx) {
	      var _props2 = this.props,
	          disabled = _props2.disabled,
	          labelKey = _props2.labelKey,
	          onRemove = _props2.onRemove,
	          renderToken = _props2.renderToken;
	
	      var onRemoveWrapped = function onRemoveWrapped() {
	        return onRemove(option);
	      };
	
	      if (renderToken) {
	        return renderToken(option, onRemoveWrapped, idx);
	      }
	
	      return _react2.default.createElement(
	        _Token2.default,
	        {
	          disabled: disabled,
	          key: idx,
	          onRemove: onRemoveWrapped },
	        (0, _getOptionLabel2.default)(option, labelKey)
	      );
	    }
	  }, {
	    key: '_handleBlur',
	    value: function _handleBlur(e) {
	      this.setState({ isFocused: false });
	      this.props.onBlur(e);
	    }
	  }, {
	    key: '_handleChange',
	    value: function _handleChange(e) {
	      this.props.onChange(e.target.value);
	    }
	  }, {
	    key: '_handleKeydown',
	    value: function _handleKeydown(e) {
	      switch (e.keyCode) {
	        case _keyCode.BACKSPACE:
	          var inputNode = (0, _reactDom.findDOMNode)(this.refs.input);
	          if (inputNode && inputNode.contains(document.activeElement) && !this.props.value) {
	            // If the input is selected and there is no text, select the last
	            // token when the user hits backspace.
	            var sibling = inputNode.previousSibling;
	            sibling && sibling.focus();
	
	            // Prevent browser "back" action.
	            e.preventDefault();
	          }
	          break;
	      }
	
	      this.props.onKeyDown(e);
	    }
	  }, {
	    key: '_handleInputFocus',
	    value: function _handleInputFocus(e) {
	      if (this.props.disabled) {
	        e.target.blur();
	        return;
	      }
	
	      // If the user clicks anywhere inside the tokenizer besides a token,
	      // focus the input.
	      this.refs.input.focus();
	      this.setState({ isFocused: true });
	    }
	  }]);
	
	  return TokenizerInput;
	}(_react2.default.Component);
	
	/**
	 * In addition to the propTypes below, the following props are automatically
	 * passed down by `Typeahead`:
	 *
	 *  - activeIndex
	 *  - hasAux
	 *  - labelKey
	 *  - onAdd
	 *  - onBlur
	 *  - onChange
	 *  - onClick
	 *  - onFocus
	 *  - onKeydown
	 *  - onRemove
	 *  - options
	 *  - selected
	 *  - value
	 */
	
	
	TokenizerInput.propTypes = {
	  /**
	   * Whether to disable the input and all selections.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Placeholder text for the input.
	   */
	  placeholder: _propTypes2.default.string,
	  /**
	   * Provides a hook for customized rendering of tokens when multiple
	   * selections are enabled.
	   */
	  renderToken: _propTypes2.default.func
	};
	
	exports.default = TokenizerInput;

/***/ },
/* 2739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _head2 = __webpack_require__(667);
	
	var _head3 = _interopRequireDefault(_head2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextInput = __webpack_require__(2737);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _keyCode = __webpack_require__(312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * TypeaheadInput
	 *
	 * Handles a single selection from the Typeahead component.
	 */
	var TypeaheadInput = function (_React$Component) {
	  _inherits(TypeaheadInput, _React$Component);
	
	  function TypeaheadInput(props) {
	    _classCallCheck(this, TypeaheadInput);
	
	    var _this = _possibleConstructorReturn(this, (TypeaheadInput.__proto__ || Object.getPrototypeOf(TypeaheadInput)).call(this, props));
	
	    _this.displayName = 'TypeaheadInput';
	
	
	    _this._handleBlur = _this._handleBlur.bind(_this);
	    _this._handleChange = _this._handleChange.bind(_this);
	    _this._handleInputFocus = _this._handleInputFocus.bind(_this);
	    _this._handleKeydown = _this._handleKeydown.bind(_this);
	
	    _this.state = {
	      isFocused: false
	    };
	    return _this;
	  }
	
	  _createClass(TypeaheadInput, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props,
	          activeIndex = _props.activeIndex,
	          value = _props.value;
	
	      if (activeIndex !== prevProps.activeIndex) {
	        this._input.getInstance().selectionStart = value.length;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          bsSize = _props2.bsSize,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          hasAux = _props2.hasAux,
	          hintText = _props2.hintText,
	          name = _props2.name,
	          onFocus = _props2.onFocus,
	          placeholder = _props2.placeholder,
	          selected = _props2.selected,
	          value = _props2.value;
	
	
	      var inputProps = {
	        bsSize: bsSize,
	        disabled: disabled,
	        hasAux: hasAux,
	        name: name,
	        onFocus: onFocus,
	        placeholder: placeholder,
	        value: value
	      };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('bootstrap-typeahead-input', className),
	          onClick: this._handleInputFocus,
	          onFocus: this._handleInputFocus,
	          style: {
	            outline: 'none',
	            position: 'relative'
	          },
	          tabIndex: -1 },
	        _react2.default.createElement(_TextInput2.default, _extends({}, inputProps, {
	          autoComplete: 'off',
	          className: (0, _classnames2.default)('bootstrap-typeahead-input-main', {
	            'has-selection': !!selected.length
	          }),
	          onBlur: this._handleBlur,
	          onChange: this._handleChange,
	          onKeyDown: this._handleKeydown,
	          ref: function ref(input) {
	            return _this2._input = input;
	          },
	          style: {
	            backgroundColor: !disabled && 'transparent',
	            display: 'block',
	            position: 'relative',
	            zIndex: 1
	          }
	        })),
	        _react2.default.createElement(_TextInput2.default, {
	          bsSize: bsSize,
	          className: (0, _classnames2.default)('bootstrap-typeahead-input-hint'),
	          hasAux: hasAux,
	          style: {
	            borderColor: 'transparent',
	            bottom: 0,
	            boxShadow: 'none',
	            color: '#a5a5a5',
	            display: 'block',
	            position: 'absolute',
	            top: 0,
	            width: '100%',
	            zIndex: 0
	          },
	          tabIndex: -1,
	          value: this.state.isFocused ? hintText : ''
	        })
	      );
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this._input.getInstance().blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this._handleInputFocus();
	    }
	  }, {
	    key: '_handleBlur',
	    value: function _handleBlur(e) {
	      this.setState({ isFocused: false });
	      this.props.onBlur(e);
	    }
	  }, {
	    key: '_handleChange',
	    value: function _handleChange(e) {
	      // Clear any selections when text is entered.
	      var _props3 = this.props,
	          onRemove = _props3.onRemove,
	          selected = _props3.selected;
	
	      !!selected.length && onRemove((0, _head3.default)(selected));
	
	      this.props.onChange(e.target.value);
	    }
	
	    /**
	     * If the containing parent div is focused or clicked, focus the input.
	     */
	
	  }, {
	    key: '_handleInputFocus',
	    value: function _handleInputFocus(e) {
	      this.setState({ isFocused: true });
	      this._input.getInstance().focus();
	    }
	  }, {
	    key: '_handleKeydown',
	    value: function _handleKeydown(e) {
	      var _props4 = this.props,
	          activeItem = _props4.activeItem,
	          hintText = _props4.hintText,
	          initialItem = _props4.initialItem,
	          onAdd = _props4.onAdd,
	          selected = _props4.selected,
	          value = _props4.value;
	
	
	      switch (e.keyCode) {
	        case _keyCode.RIGHT:
	        case _keyCode.TAB:
	          var cursorPos = this._input.getInstance().selectionStart;
	
	          // Autocomplete the selection if all of the following are true:
	          if (this.state.isFocused && (
	          // There's a hint or a menu item is highlighted.
	          hintText || activeItem) &&
	          // There's no current selection.
	          !selected.length &&
	          // The input cursor is at the end of the text string when the user
	          // hits the right arrow key.
	          !(e.keyCode === _keyCode.RIGHT && cursorPos !== value.length)) {
	            e.preventDefault();
	
	            var selectedOption = hintText ? initialItem : activeItem;
	
	            onAdd && onAdd(selectedOption);
	          }
	          break;
	      }
	
	      this.props.onKeyDown(e);
	    }
	  }]);
	
	  return TypeaheadInput;
	}(_react2.default.Component);
	
	/**
	 * In addition to the propTypes below, the following props are automatically
	 * passed down by `Typeahead`:
	 *
	 *  - activeIndex
	 *  - activeItem
	 *  - hasAux
	 *  - hintText
	 *  - labelKey
	 *  - onAdd
	 *  - onBlur
	 *  - onChange
	 *  - onClick
	 *  - onFocus
	 *  - onKeydown
	 *  - onRemove
	 *  - selected
	 *  - value
	 */
	
	
	TypeaheadInput.propTypes = {
	  /**
	   * Whether to disable the input and any selection, if present.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Name property for the input.
	   */
	  name: _propTypes2.default.string,
	  /**
	   * Placeholder text for the input.
	   */
	  placeholder: _propTypes2.default.string
	};
	
	exports.default = TypeaheadInput;

/***/ },
/* 2740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pick2 = __webpack_require__(1647);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactHighlighter = __webpack_require__(2975);
	
	var _reactHighlighter2 = _interopRequireDefault(_reactHighlighter);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Menu = __webpack_require__(878);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(438);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _getOptionLabel = __webpack_require__(193);
	
	var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MATCH_CLASS = 'bootstrap-typeahead-highlight';
	
	var TypeaheadMenu = function (_React$Component) {
	  _inherits(TypeaheadMenu, _React$Component);
	
	  function TypeaheadMenu(props) {
	    _classCallCheck(this, TypeaheadMenu);
	
	    var _this = _possibleConstructorReturn(this, (TypeaheadMenu.__proto__ || Object.getPrototypeOf(TypeaheadMenu)).call(this, props));
	
	    _this.displayName = 'TypeaheadMenu';
	
	
	    _this._renderMenuItem = _this._renderMenuItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(TypeaheadMenu, [{
	    key: 'render',
	    value: function render() {
	      var menuProps = (0, _pick3.default)(this.props, ['align', 'className', 'dropup', 'emptyLabel', 'maxHeight', 'onPaginate', 'paginate', 'paginationText', 'style']);
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        menuProps,
	        this.props.options.map(this._renderMenuItem)
	      );
	    }
	  }, {
	    key: '_renderMenuItem',
	    value: function _renderMenuItem(option, idx) {
	      var _props = this.props,
	          labelKey = _props.labelKey,
	          newSelectionPrefix = _props.newSelectionPrefix,
	          renderMenuItemChildren = _props.renderMenuItemChildren,
	          text = _props.text;
	
	
	      var menuItemProps = {
	        disabled: option.disabled,
	        key: idx,
	        option: option,
	        position: idx
	      };
	
	      if (option.customOption) {
	        return _react2.default.createElement(
	          _MenuItem2.default,
	          menuItemProps,
	          newSelectionPrefix,
	          _react2.default.createElement(
	            _reactHighlighter2.default,
	            { matchClass: MATCH_CLASS, search: text },
	            option[labelKey]
	          )
	        );
	      }
	
	      return renderMenuItemChildren ? _react2.default.createElement(
	        _MenuItem2.default,
	        menuItemProps,
	        renderMenuItemChildren(option, this.props, idx)
	      ) : _react2.default.createElement(
	        _MenuItem2.default,
	        menuItemProps,
	        _react2.default.createElement(
	          _reactHighlighter2.default,
	          { matchClass: MATCH_CLASS, search: text },
	          (0, _getOptionLabel2.default)(option, labelKey)
	        )
	      );
	    }
	  }]);
	
	  return TypeaheadMenu;
	}(_react2.default.Component);
	
	/**
	 * In addition to the propTypes below, the following props are automatically
	 * passed down by `Typeahead`:
	 *
	 *  - labelKey
	 *  - onPaginate
	 *  - options
	 *  - paginate
	 *  - text
	 */
	
	
	TypeaheadMenu.propTypes = {
	  /**
	   * Provides the ability to specify a prefix before the user-entered text to
	   * indicate that the selection will be new. No-op unless `allowNew={true}`.
	   */
	  newSelectionPrefix: _propTypes2.default.string,
	  /**
	   * Provides a hook for customized rendering of menu item contents.
	   */
	  renderMenuItemChildren: _propTypes2.default.func
	};
	
	TypeaheadMenu.defaultProps = {
	  newSelectionPrefix: 'New selection: '
	};
	
	exports.default = TypeaheadMenu;

/***/ },
/* 2741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uniqueId2 = __webpack_require__(1655);
	
	var _uniqueId3 = _interopRequireDefault(_uniqueId2);
	
	var _find2 = __webpack_require__(47);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _invariant = __webpack_require__(79);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _getOptionLabel = __webpack_require__(193);
	
	var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addCustomOption(results, text, labelKey) {
	  results = results.slice();
	
	  var exactMatchFound = (0, _find3.default)(results, function (o) {
	    return (0, _getOptionLabel2.default)(o, labelKey) === text;
	  });
	
	  if (!text.trim() || exactMatchFound) {
	    return results;
	  }
	
	  var newOption = {
	    id: (0, _uniqueId3.default)('new-id-'),
	    customOption: true
	  };
	
	  !(typeof labelKey === 'string') ?  false ? (0, _invariant2.default)(false, '`labelKey` must be a string when creating new options.') : (0, _invariant2.default)(false) : void 0;
	
	  newOption[labelKey] = text;
	  results.push(newOption);
	
	  return results;
	}
	
	exports.default = addCustomOption;

/***/ },
/* 2742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _some2 = __webpack_require__(153);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _isFunction2 = __webpack_require__(28);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	exports.default = defaultFilterBy;
	
	var _stripDiacritics = __webpack_require__(885);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _warn = __webpack_require__(886);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMatch(input, string, _ref) {
	  var caseSensitive = _ref.caseSensitive,
	      ignoreDiacritics = _ref.ignoreDiacritics;
	
	  if (!caseSensitive) {
	    input = input.toLowerCase();
	    string = string.toLowerCase();
	  }
	
	  if (ignoreDiacritics) {
	    input = (0, _stripDiacritics2.default)(input);
	    string = (0, _stripDiacritics2.default)(string);
	  }
	
	  return string.indexOf(input) !== -1;
	}
	
	/**
	 * Default algorithm for filtering results.
	 */
	function defaultFilterBy(option, text, labelKey, isTokenized, filterOptions) {
	  // Don't show selected options in the menu for the multi-select case.
	  if (isTokenized) {
	    return false;
	  }
	
	  var fields = filterOptions.fields.slice();
	
	  if ((0, _isFunction3.default)(labelKey) && isMatch(text, labelKey(option), filterOptions)) {
	    return true;
	  }
	
	  if (typeof labelKey === 'string') {
	    // Add the `labelKey` field to the list of fields if it isn't already there.
	    if (fields.indexOf(labelKey) === -1) {
	      fields.unshift(labelKey);
	    }
	  }
	
	  if (typeof option === 'string') {
	    (0, _warn2.default)(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');
	
	    return isMatch(text, option, filterOptions);
	  }
	
	  return (0, _some3.default)(fields, function (field) {
	    var value = option[field];
	
	    if (typeof value !== 'string') {
	      (0, _warn2.default)(false, 'Fields passed to `filterBy` should have string values. Value will ' + 'be converted to a string; results may be unexpected.');
	
	      // Coerce to string since `toString` isn't null-safe.
	      value = value + '';
	    }
	
	    return isMatch(text, value, filterOptions);
	  });
	}

/***/ },
/* 2743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getOptionLabel = __webpack_require__(193);
	
	var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);
	
	var _stripDiacritics = __webpack_require__(885);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getHintText(_ref) {
	  var activeItem = _ref.activeItem,
	      initialItem = _ref.initialItem,
	      labelKey = _ref.labelKey,
	      minLength = _ref.minLength,
	      selected = _ref.selected,
	      text = _ref.text;
	
	  // Don't display a hint under the following conditions:
	  if (
	  // No text entered.
	  !text ||
	  // Text doesn't meet `minLength` threshold.
	  text.length < minLength ||
	  // No item in the menu.
	  !initialItem ||
	  // The initial item is a custom option.
	  initialItem.customOption ||
	  // One of the menu items is active.
	  activeItem ||
	  // There's already a selection.
	  !!selected.length) {
	    return '';
	  }
	
	  var initialItemStr = (0, _getOptionLabel2.default)(initialItem, labelKey);
	
	  if (
	  // The input text corresponds to the beginning of the first option.
	  // Always strip accents and convert to lower case, since the options are
	  // already filtered at this point.
	  (0, _stripDiacritics2.default)(initialItemStr.toLowerCase()).indexOf((0, _stripDiacritics2.default)(text.toLowerCase())) !== 0) {
	    return '';
	  }
	
	  // Text matching is case- and accent-insensitive, so to display the hint
	  // correctly, splice the input text with the rest of the actual string.
	  return text + initialItemStr.slice(text.length, initialItemStr.length);
	}
	
	exports.default = getHintText;

/***/ },
/* 2744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _head2 = __webpack_require__(667);
	
	var _head3 = _interopRequireDefault(_head2);
	
	var _getOptionLabel = __webpack_require__(193);
	
	var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getInputText(_ref) {
	  var activeItem = _ref.activeItem,
	      labelKey = _ref.labelKey,
	      multiple = _ref.multiple,
	      selected = _ref.selected,
	      text = _ref.text;
	
	  if (multiple) {
	    return text;
	  }
	
	  if (activeItem) {
	    return (0, _getOptionLabel2.default)(activeItem, labelKey);
	  }
	
	  var selectedItem = !!selected.length && (0, _head3.default)(selected);
	  if (selectedItem) {
	    return (0, _getOptionLabel2.default)(selectedItem, labelKey);
	  }
	
	  return text;
	}
	
	exports.default = getInputText;

/***/ },
/* 2745 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Truncates the result set based on `maxResults` and returns the new set.
	 */
	function getTruncatedOptions(options, maxResults) {
	  if (!maxResults || maxResults >= options.length) {
	    return options;
	  }
	
	  return options.slice(0, maxResults);
	}
	
	exports.default = getTruncatedOptions;

/***/ },
/* 2746 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Partial polyfill for webkit `scrollIntoViewIfNeeded()` method. Addresses
	 * vertical scrolling only.
	 *
	 * Inspired by https://gist.github.com/hsablonniere/2581101, but uses
	 * `getBoundingClientRect`.
	 */
	function scrollIntoViewIfNeeded(node) {
	  // Webkit browsers
	  if (Element.prototype.scrollIntoViewIfNeeded) {
	    node.scrollIntoViewIfNeeded();
	    return;
	  }
	
	  // FF, IE, etc.
	  var rect = node.getBoundingClientRect();
	  var parent = node.parentNode;
	  var parentRect = parent.getBoundingClientRect();
	
	  var parentComputedStyle = window.getComputedStyle(parent, null);
	  var parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width'));
	
	  if (rect.top < parentRect.top || rect.bottom > parentRect.bottom) {
	    parent.scrollTop = node.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + node.clientHeight / 2;
	  }
	}
	
	exports.default = scrollIntoViewIfNeeded;

/***/ },
/* 2747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _offset = __webpack_require__(219);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _requestAnimationFrame = __webpack_require__(593);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(238);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Affix = __webpack_require__(887);
	
	var _Affix2 = _interopRequireDefault(_Affix);
	
	var _addEventListener = __webpack_require__(313);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _getContainer = __webpack_require__(240);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _getDocumentHeight = __webpack_require__(890);
	
	var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _ownerWindow = __webpack_require__(891);
	
	var _ownerWindow2 = _interopRequireDefault(_ownerWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var displayName = 'AutoAffix';
	
	var propTypes = _extends({}, _Affix2.default.propTypes, {
	  /**
	   * The logical container node or component for determining offset from bottom
	   * of viewport, or a function that returns it
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Automatically set width when affixed
	   */
	  autoWidth: _propTypes2.default.bool
	});
	
	// This intentionally doesn't inherit default props from `<Affix>`, so that the
	// auto-calculated offsets can apply.
	var defaultProps = {
	  viewportOffsetTop: 0,
	  autoWidth: true
	};
	
	/**
	 * The `<AutoAffix/>` component wraps `<Affix/>` to automatically calculate
	 * offsets in many common cases.
	 */
	
	var AutoAffix = function (_React$Component) {
	  _inherits(AutoAffix, _React$Component);
	
	  function AutoAffix(props, context) {
	    _classCallCheck(this, AutoAffix);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.onWindowScroll = function () {
	      _this.onUpdate();
	    };
	
	    _this.onWindowResize = function () {
	      if (_this.props.autoWidth) {
	        (0, _requestAnimationFrame2.default)(function () {
	          return _this.onUpdate();
	        });
	      }
	    };
	
	    _this.onDocumentClick = function () {
	      (0, _requestAnimationFrame2.default)(function () {
	        return _this.onUpdate();
	      });
	    };
	
	    _this.onUpdate = function () {
	      if (!_this._isMounted) {
	        return;
	      }
	
	      var _getOffset = (0, _offset2.default)(_this.positioner),
	          offsetTop = _getOffset.top,
	          width = _getOffset.width;
	
	      var container = (0, _getContainer2.default)(_this.props.container);
	      var offsetBottom = void 0;
	      if (container) {
	        var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));
	
	        var _getOffset2 = (0, _offset2.default)(container),
	            top = _getOffset2.top,
	            height = _getOffset2.height;
	
	        offsetBottom = documentHeight - top - height;
	      } else {
	        offsetBottom = null;
	      }
	
	      _this.updateState(offsetTop, offsetBottom, width);
	    };
	
	    _this.updateState = function (offsetTop, offsetBottom, width) {
	      if (offsetTop === _this.state.offsetTop && offsetBottom === _this.state.offsetBottom && width === _this.state.width) {
	        return;
	      }
	
	      _this.setState({ offsetTop: offsetTop, offsetBottom: offsetBottom, width: width });
	    };
	
	    _this.state = {
	      offsetTop: null,
	      offsetBottom: null,
	      width: null
	    };
	    return _this;
	  }
	
	  AutoAffix.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this._isMounted = true;
	
	    this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
	      return _this2.onWindowScroll();
	    });
	
	    this._windowResizeListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'resize', function () {
	      return _this2.onWindowResize();
	    });
	
	    this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
	      return _this2.onDocumentClick();
	    });
	
	    this.onUpdate();
	  };
	
	  AutoAffix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needPositionUpdate = true;
	  };
	
	  AutoAffix.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this._needPositionUpdate) {
	      this._needPositionUpdate = false;
	      this.onUpdate();
	    }
	  };
	
	  AutoAffix.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	
	    if (this._windowScrollListener) {
	      this._windowScrollListener.remove();
	    }
	    if (this._documentClickListener) {
	      this._documentClickListener.remove();
	    }
	    if (this._windowResizeListener) {
	      this._windowResizeListener.remove();
	    }
	  };
	
	  AutoAffix.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        autoWidth = _props.autoWidth,
	        viewportOffsetTop = _props.viewportOffsetTop,
	        children = _props.children,
	        props = _objectWithoutProperties(_props, ['autoWidth', 'viewportOffsetTop', 'children']);
	
	    var _state = this.state,
	        offsetTop = _state.offsetTop,
	        offsetBottom = _state.offsetBottom,
	        width = _state.width;
	
	
	    delete props.container;
	
	    var effectiveOffsetTop = Math.max(offsetTop, viewportOffsetTop || 0);
	
	    var _props2 = this.props,
	        affixStyle = _props2.affixStyle,
	        bottomStyle = _props2.bottomStyle;
	
	    if (autoWidth) {
	      affixStyle = _extends({ width: width }, affixStyle);
	      bottomStyle = _extends({ width: width }, bottomStyle);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('div', { ref: function ref(c) {
	          _this3.positioner = c;
	        } }),
	      _react2.default.createElement(
	        _Affix2.default,
	        _extends({}, props, {
	          offsetTop: effectiveOffsetTop,
	          viewportOffsetTop: viewportOffsetTop,
	          offsetBottom: offsetBottom,
	          affixStyle: affixStyle,
	          bottomStyle: bottomStyle
	        }),
	        children
	      )
	    );
	  };
	
	  return AutoAffix;
	}(_react2.default.Component);
	
	AutoAffix.displayName = displayName;
	AutoAffix.propTypes = propTypes;
	AutoAffix.defaultProps = defaultProps;
	
	exports.default = AutoAffix;
	module.exports = exports['default'];

/***/ },
/* 2748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(238);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(240);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 2749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(1374);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(390);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(140);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(238);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(2699);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(861);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(2750);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(439);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(2752);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(313);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(2755);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(240);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `<Transition/>` component to use for the dialog and backdrop components.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * The `timeout` of the dialog transition if specified. This number is used to ensure that
	   * transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  dialogTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * The `timeout` of the backdrop transition if specified. This number is used to
	   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  backdropTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.transition,
	        backdropTransitionTimeout = _props3.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': _this2.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 2750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(1375);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(392);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(1388);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(2757);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(2758);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 2751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(861);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(439);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(888);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(889);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleHidden = function () {
	      _this.setState({ exited: true });
	
	      if (_this.props.onExited) {
	        var _this$props;
	
	        (_this$props = _this.props).onExited.apply(_this$props, arguments);
	      }
	    };
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        container = _props.container,
	        containerPadding = _props.containerPadding,
	        target = _props.target,
	        placement = _props.placement,
	        shouldUpdatePosition = _props.shouldUpdatePosition,
	        rootClose = _props.rootClose,
	        children = _props.children,
	        Transition = _props.transition,
	        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	
	
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2.default.createElement(
	      _Position2.default,
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit,
	          onExiting = props.onExiting,
	          onEnter = props.onEnter,
	          onEntering = props.onEntering,
	          onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	
	      child = _react2.default.createElement(
	        Transition,
	        {
	          'in': props.show,
	          transitionAppear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2.default.createElement(
	        _RootCloseWrapper2.default,
	        { onRootClose: props.onHide },
	        child
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { container: container },
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _propTypes2.default.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 2752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ },
/* 2753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(589);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(591);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.updateStatus = function () {
	      if (_this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        _this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(_this);
	
	        if (_this.nextStatus === ENTERING) {
	          _this.props.onEnter(node);
	
	          _this.safeSetState({ status: ENTERING }, function () {
	            _this.props.onEntering(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: ENTERED }, function () {
	                _this.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          _this.props.onExit(node);
	
	          _this.safeSetState({ status: EXITING }, function () {
	            _this.props.onExiting(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: EXITED }, function () {
	                _this.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        _this.nextStatus = null;
	      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
	        _this.setState({ status: UNMOUNTED });
	      }
	    };
	
	    _this.cancelNextCallback = function () {
	      if (_this.nextCallback !== null) {
	        _this.nextCallback.cancel();
	        _this.nextCallback = null;
	      }
	    };
	
	    _this.safeSetState = function (nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      _this.setState(nextState, _this.setNextCallback(callback));
	    };
	
	    _this.setNextCallback = function (callback) {
	      var active = true;
	
	      _this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      _this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return _this.nextCallback;
	    };
	
	    _this.onTransitionEnd = function (node, handler) {
	      _this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
	        setTimeout(_this.nextCallback, _this.props.timeout);
	      } else {
	        setTimeout(_this.nextCallback, 0);
	      }
	    };
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var status = this.state.status;
	
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	    Object.keys(Transition.propTypes).forEach(function (key) {
	      return delete childProps[key];
	    });
	
	    var transitionClassName = void 0;
	    if (status === EXITED) {
	      transitionClassName = this.props.exitedClassName;
	    } else if (status === ENTERING) {
	      transitionClassName = this.props.enteringClassName;
	    } else if (status === ENTERED) {
	      transitionClassName = this.props.enteredClassName;
	    } else if (status === EXITING) {
	      transitionClassName = this.props.exitingClassName;
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, _extends({}, childProps, {
	      className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	    }));
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _propTypes2.default.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _propTypes2.default.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 2754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RootCloseWrapper = exports.Transition = exports.Position = exports.Portal = exports.Overlay = exports.Modal = exports.AutoAffix = exports.Affix = undefined;
	
	var _Affix2 = __webpack_require__(887);
	
	var _Affix3 = _interopRequireDefault(_Affix2);
	
	var _AutoAffix2 = __webpack_require__(2747);
	
	var _AutoAffix3 = _interopRequireDefault(_AutoAffix2);
	
	var _Modal2 = __webpack_require__(2749);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _Overlay2 = __webpack_require__(2751);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _Portal2 = __webpack_require__(439);
	
	var _Portal3 = _interopRequireDefault(_Portal2);
	
	var _Position2 = __webpack_require__(888);
	
	var _Position3 = _interopRequireDefault(_Position2);
	
	var _Transition2 = __webpack_require__(2753);
	
	var _Transition3 = _interopRequireDefault(_Transition2);
	
	var _RootCloseWrapper2 = __webpack_require__(889);
	
	var _RootCloseWrapper3 = _interopRequireDefault(_RootCloseWrapper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Affix = _Affix3.default;
	exports.AutoAffix = _AutoAffix3.default;
	exports.Modal = _Modal3.default;
	exports.Overlay = _Overlay3.default;
	exports.Portal = _Portal3.default;
	exports.Position = _Position3.default;
	exports.Transition = _Transition3.default;
	exports.RootCloseWrapper = _RootCloseWrapper3.default;

/***/ },
/* 2755 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 2756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(219);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1380);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(391);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 2757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(218);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(174);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 2758 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 2759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CopyToClipboard = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _copyToClipboard = __webpack_require__(1250);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CopyToClipboard = exports.CopyToClipboard = function (_React$PureComponent) {
	  _inherits(CopyToClipboard, _React$PureComponent);
	
	  function CopyToClipboard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CopyToClipboard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CopyToClipboard.__proto__ || Object.getPrototypeOf(CopyToClipboard)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
	      var _this$props = _this.props,
	          text = _this$props.text,
	          onCopy = _this$props.onCopy,
	          children = _this$props.children,
	          options = _this$props.options;
	
	
	      var elem = _react2.default.Children.only(children);
	
	      var result = (0, _copyToClipboard2.default)(text, options);
	
	      if (onCopy) {
	        onCopy(text, result);
	      }
	
	      // Bypass onClick if it was present
	      if (elem && elem.props && typeof elem.props.onClick === 'function') {
	        elem.props.onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CopyToClipboard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _text = _props.text,
	          _onCopy = _props.onCopy,
	          _options = _props.options,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['text', 'onCopy', 'options', 'children']);
	
	      var elem = _react2.default.Children.only(children);
	
	      return _react2.default.cloneElement(elem, _extends({}, props, { onClick: this.onClick }));
	    }
	  }]);
	
	  return CopyToClipboard;
	}(_react2.default.PureComponent);
	
	CopyToClipboard.defaultProps = {
	  onCopy: undefined,
	  options: undefined
	};

/***/ },
/* 2760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(17);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.props.disableOnClickOutside) return;
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
	        }
	      }
	
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ },
/* 2761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(4));
	var PopperJS = _interopDefault(__webpack_require__(2698));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var Manager = function (_Component) {
	  inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return react.createElement(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	  return Manager;
	}(react.Component);
	
	Manager.childContextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	Manager.propTypes =  false ? {
	  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	} : {};
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	
	Target.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	var placements = PopperJS.placements;
	
	var Popper = function (_Component) {
	  inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      if (_this.props.target) {
	        return _this.props.target;
	      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
	        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
	      }
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      return _extends({
	        position: data.offsets.popper.position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _this._handlePopperRef = function (node) {
	      _this._popperNode = node;
	      if (node) {
	        _this._createPopper();
	      } else {
	        _this._destroyPopper();
	      }
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this._scheduleUpdate = function () {
	      _this._popper && _this._popper.scheduleUpdate();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	      if (lastProps.children !== this.props.children) {
	        this._scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _this2 = this;
	
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	      if (this._arrowNode) {
	        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
	          element: this._arrowNode
	        });
	      }
	      this._popper = new PopperJS(this._getTargetNode(), this._popperNode, {
	        placement: placement,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
	      setTimeout(function () {
	        return _this2._scheduleUpdate();
	      });
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);
	
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var popperProps = {
	          ref: this._handlePopperRef,
	          style: popperStyle,
	          'data-placement': popperPlacement,
	          'data-x-out-of-boundaries': popperHide
	        };
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = this._handlePopperRef;
	      } else {
	        componentProps.innerRef = this._handlePopperRef;
	      }
	
	      return react.createElement(component, componentProps, children);
	    }
	  }]);
	  return Popper;
	}(react.Component);
	
	Popper.contextTypes = {
	  popperManager: PropTypes.object
	};
	Popper.childContextTypes = {
	  popper: PropTypes.object.isRequired
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  modifiers: {}
	};
	Popper.propTypes =  false ? {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  placement: PropTypes.oneOf(placements),
	  eventsEnabled: PropTypes.bool,
	  modifiers: PropTypes.object,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  target: PropTypes.oneOfType([
	  // the following check is needed for SSR
	  PropTypes.instanceOf(typeof Element !== 'undefined' ? Element : Object), PropTypes.shape({
	    getBoundingClientRect: PropTypes.func.isRequired,
	    clientWidth: PropTypes.number.isRequired,
	    clientHeight: PropTypes.number.isRequired
	  })])
	} : {};
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: PropTypes.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	exports.Manager = Manager;
	exports.Target = Target;
	exports.Popper = Popper;
	exports.placements = placements;
	exports.Arrow = Arrow;
	//# sourceMappingURL=react-popper.js.map


/***/ },
/* 2762 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
	};
	
	exports.default = getDisplayName;

/***/ },
/* 2763 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 2764 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var focusNode = __webpack_require__(601);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 2765 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(197);
	var ExecutionEnvironment = __webpack_require__(59);
	var FallbackCompositionState = __webpack_require__(2772);
	var SyntheticCompositionEvent = __webpack_require__(2809);
	var SyntheticInputEvent = __webpack_require__(2812);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 2766 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(893);
	var ExecutionEnvironment = __webpack_require__(59);
	var ReactInstrumentation = __webpack_require__(90);
	
	var camelizeStyleName = __webpack_require__(1455);
	var dangerousStyleValue = __webpack_require__(2818);
	var hyphenateStyleName = __webpack_require__(1462);
	var memoizeStringOnly = __webpack_require__(1466);
	var warning = __webpack_require__(34);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 2767 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(196);
	var EventPropagators = __webpack_require__(197);
	var ExecutionEnvironment = __webpack_require__(59);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(99);
	var SyntheticEvent = __webpack_require__(111);
	
	var inputValueTracking = __webpack_require__(908);
	var getEventTarget = __webpack_require__(453);
	var isEventSupported = __webpack_require__(454);
	var isTextInputElement = __webpack_require__(910);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 2768 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var DOMLazyTree = __webpack_require__(194);
	var ExecutionEnvironment = __webpack_require__(59);
	
	var createNodesFromMarkup = __webpack_require__(1458);
	var emptyFunction = __webpack_require__(87);
	var invariant = __webpack_require__(21);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 2769 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 2770 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(197);
	var ReactDOMComponentTree = __webpack_require__(44);
	var SyntheticMouseEvent = __webpack_require__(316);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 2771 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = {
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	};
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes
	};
	
	module.exports = EventConstants;

/***/ },
/* 2772 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var PooledClass = __webpack_require__(158);
	
	var getTextContentAccessor = __webpack_require__(907);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 2773 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(195);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 2774 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(198);
	
	var instantiateReactComponent = __webpack_require__(909);
	var KeyEscapeUtils = __webpack_require__(444);
	var shouldUpdateReactComponent = __webpack_require__(455);
	var traverseAllChildren = __webpack_require__(912);
	var warning = __webpack_require__(34);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(991);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191)))

/***/ },
/* 2775 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(441);
	var ReactDOMIDOperations = __webpack_require__(2782);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 2776 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(39);
	
	var React = __webpack_require__(201);
	var ReactComponentEnvironment = __webpack_require__(446);
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactErrorUtils = __webpack_require__(447);
	var ReactInstanceMap = __webpack_require__(241);
	var ReactInstrumentation = __webpack_require__(90);
	var ReactNodeTypes = __webpack_require__(903);
	var ReactReconciler = __webpack_require__(198);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(223);
	var invariant = __webpack_require__(21);
	var shallowEqual = __webpack_require__(175);
	var shouldUpdateReactComponent = __webpack_require__(455);
	var warning = __webpack_require__(34);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 2777 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDefaultInjection = __webpack_require__(2790);
	var ReactMount = __webpack_require__(902);
	var ReactReconciler = __webpack_require__(198);
	var ReactUpdates = __webpack_require__(99);
	var ReactVersion = __webpack_require__(2803);
	
	var findDOMNode = __webpack_require__(2819);
	var getHostComponentFromComposite = __webpack_require__(906);
	var renderSubtreeIntoContainer = __webpack_require__(2826);
	var warning = __webpack_require__(34);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 2778 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(39);
	
	var AutoFocusUtils = __webpack_require__(2764);
	var CSSPropertyOperations = __webpack_require__(2766);
	var DOMLazyTree = __webpack_require__(194);
	var DOMNamespaces = __webpack_require__(442);
	var DOMProperty = __webpack_require__(195);
	var DOMPropertyOperations = __webpack_require__(895);
	var EventPluginHub = __webpack_require__(196);
	var EventPluginRegistry = __webpack_require__(443);
	var ReactBrowserEventEmitter = __webpack_require__(315);
	var ReactDOMComponentFlags = __webpack_require__(896);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMInput = __webpack_require__(2783);
	var ReactDOMOption = __webpack_require__(2784);
	var ReactDOMSelect = __webpack_require__(897);
	var ReactDOMTextarea = __webpack_require__(2787);
	var ReactInstrumentation = __webpack_require__(90);
	var ReactMultiChild = __webpack_require__(2796);
	var ReactServerRenderingTransaction = __webpack_require__(2801);
	
	var emptyFunction = __webpack_require__(87);
	var escapeTextContentForBrowser = __webpack_require__(318);
	var invariant = __webpack_require__(21);
	var isEventSupported = __webpack_require__(454);
	var shallowEqual = __webpack_require__(175);
	var inputValueTracking = __webpack_require__(908);
	var validateDOMNesting = __webpack_require__(456);
	var warning = __webpack_require__(34);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 2779 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(456);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 2780 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var DOMLazyTree = __webpack_require__(194);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 2781 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 2782 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(441);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 2783 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(39);
	
	var DOMPropertyOperations = __webpack_require__(895);
	var LinkedValueUtils = __webpack_require__(445);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(99);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(34);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 2784 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var React = __webpack_require__(201);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMSelect = __webpack_require__(897);
	
	var warning = __webpack_require__(34);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 2785 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(59);
	
	var getNodeForCharacterOffset = __webpack_require__(2823);
	var getTextContentAccessor = __webpack_require__(907);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 2786 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(39);
	
	var DOMChildrenOperations = __webpack_require__(441);
	var DOMLazyTree = __webpack_require__(194);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var escapeTextContentForBrowser = __webpack_require__(318);
	var invariant = __webpack_require__(21);
	var validateDOMNesting = __webpack_require__(456);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 2787 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(39);
	
	var LinkedValueUtils = __webpack_require__(445);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(99);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(34);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 2788 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 2789 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var ReactUpdates = __webpack_require__(99);
	var Transaction = __webpack_require__(317);
	
	var emptyFunction = __webpack_require__(87);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 2790 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(2763);
	var BeforeInputEventPlugin = __webpack_require__(2765);
	var ChangeEventPlugin = __webpack_require__(2767);
	var DefaultEventPluginOrder = __webpack_require__(2769);
	var EnterLeaveEventPlugin = __webpack_require__(2770);
	var HTMLDOMPropertyConfig = __webpack_require__(2773);
	var ReactComponentBrowserEnvironment = __webpack_require__(2775);
	var ReactDOMComponent = __webpack_require__(2778);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMEmptyComponent = __webpack_require__(2780);
	var ReactDOMTreeTraversal = __webpack_require__(2788);
	var ReactDOMTextComponent = __webpack_require__(2786);
	var ReactDefaultBatchingStrategy = __webpack_require__(2789);
	var ReactEventListener = __webpack_require__(2793);
	var ReactInjection = __webpack_require__(2794);
	var ReactReconcileTransaction = __webpack_require__(2799);
	var SVGDOMPropertyConfig = __webpack_require__(2804);
	var SelectEventPlugin = __webpack_require__(2805);
	var SimpleEventPlugin = __webpack_require__(2806);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 2791 */
992,
/* 2792 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(196);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 2793 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var EventListener = __webpack_require__(600);
	var ExecutionEnvironment = __webpack_require__(59);
	var PooledClass = __webpack_require__(158);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(99);
	
	var getEventTarget = __webpack_require__(453);
	var getUnboundedScrollPosition = __webpack_require__(1460);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 2794 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(195);
	var EventPluginHub = __webpack_require__(196);
	var EventPluginUtils = __webpack_require__(314);
	var ReactComponentEnvironment = __webpack_require__(446);
	var ReactEmptyComponent = __webpack_require__(898);
	var ReactBrowserEventEmitter = __webpack_require__(315);
	var ReactHostComponent = __webpack_require__(900);
	var ReactUpdates = __webpack_require__(99);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 2795 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(2817);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 2796 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactComponentEnvironment = __webpack_require__(446);
	var ReactInstanceMap = __webpack_require__(241);
	var ReactInstrumentation = __webpack_require__(90);
	
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactReconciler = __webpack_require__(198);
	var ReactChildReconciler = __webpack_require__(2774);
	
	var emptyFunction = __webpack_require__(87);
	var flattenChildren = __webpack_require__(2820);
	var invariant = __webpack_require__(21);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 2797 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 2798 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 2799 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var CallbackQueue = __webpack_require__(894);
	var PooledClass = __webpack_require__(158);
	var ReactBrowserEventEmitter = __webpack_require__(315);
	var ReactInputSelection = __webpack_require__(901);
	var ReactInstrumentation = __webpack_require__(90);
	var Transaction = __webpack_require__(317);
	var ReactUpdateQueue = __webpack_require__(448);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 2800 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(2797);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 2801 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var PooledClass = __webpack_require__(158);
	var Transaction = __webpack_require__(317);
	var ReactInstrumentation = __webpack_require__(90);
	var ReactServerUpdateQueue = __webpack_require__(2802);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 2802 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(448);
	
	var warning = __webpack_require__(34);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 2803 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 2804 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 2805 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(197);
	var ExecutionEnvironment = __webpack_require__(59);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInputSelection = __webpack_require__(901);
	var SyntheticEvent = __webpack_require__(111);
	
	var getActiveElement = __webpack_require__(602);
	var isTextInputElement = __webpack_require__(910);
	var shallowEqual = __webpack_require__(175);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 2806 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var EventListener = __webpack_require__(600);
	var EventPropagators = __webpack_require__(197);
	var ReactDOMComponentTree = __webpack_require__(44);
	var SyntheticAnimationEvent = __webpack_require__(2807);
	var SyntheticClipboardEvent = __webpack_require__(2808);
	var SyntheticEvent = __webpack_require__(111);
	var SyntheticFocusEvent = __webpack_require__(2811);
	var SyntheticKeyboardEvent = __webpack_require__(2813);
	var SyntheticMouseEvent = __webpack_require__(316);
	var SyntheticDragEvent = __webpack_require__(2810);
	var SyntheticTouchEvent = __webpack_require__(2814);
	var SyntheticTransitionEvent = __webpack_require__(2815);
	var SyntheticUIEvent = __webpack_require__(199);
	var SyntheticWheelEvent = __webpack_require__(2816);
	
	var emptyFunction = __webpack_require__(87);
	var getEventCharCode = __webpack_require__(451);
	var invariant = __webpack_require__(21);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 2807 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 2808 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 2809 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 2810 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(316);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 2811 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(199);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 2812 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 2813 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(199);
	
	var getEventCharCode = __webpack_require__(451);
	var getEventKey = __webpack_require__(2821);
	var getEventModifierState = __webpack_require__(452);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 2814 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(199);
	
	var getEventModifierState = __webpack_require__(452);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 2815 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 2816 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(316);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 2817 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 2818 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(893);
	var warning = __webpack_require__(34);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 2819 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstanceMap = __webpack_require__(241);
	
	var getHostComponentFromComposite = __webpack_require__(906);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(34);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 2820 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(444);
	var traverseAllChildren = __webpack_require__(912);
	var warning = __webpack_require__(34);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(991);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191)))

/***/ },
/* 2821 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(451);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 2822 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 2823 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 2824 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(59);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 2825 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(318);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 2826 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(902);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 2827 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* istanbul ignore next */
	/**
	 * Default values
	 */
	exports.default = {
	  fixtures: [],
	  maxFixtures: 10,
	  initialValue: '',
	  placeholder: 'Search places',
	  disabled: false,
	  className: '',
	  inputClassName: '',
	  location: null,
	  radius: null,
	  bounds: null,
	  country: null,
	  types: null,
	  queryDelay: 250,
	  googleMaps: null,
	  highlightMatch: true,
	  onActivateSuggest: function onActivateSuggest() {},
	  onSuggestSelect: function onSuggestSelect() {},
	  onSuggestNoResults: function onSuggestNoResults() {},
	  onUpdateSuggests: function onUpdateSuggests() {},
	  onFocus: function onFocus() {},
	  onBlur: function onBlur() {},
	  onChange: function onChange() {},
	  skipSuggest: function skipSuggest() {},
	  getSuggestLabel: function getSuggestLabel(suggest) {
	    return suggest.description;
	  },
	  renderSuggestItem: null,
	  autoActivateFirstSuggest: false,
	  style: {
	    'input': {},
	    'suggests': {},
	    'suggestItem': {}
	  },
	  ignoreTab: false,
	  ignoreEnter: false,
	  minLength: 1
	};

/***/ },
/* 2828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(877);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _filterInputAttributes = __webpack_require__(914);
	
	var _filterInputAttributes2 = _interopRequireDefault(_filterInputAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars
	
	
	/**
	 * The input field
	 * @param {Object} props The component's props
	 * @return {JSX} The icon component.
	 */
	var Input = function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
	      _this.props.onChange(_this.input.value);
	    }, _this.onFocus = function () {
	      _this.props.onFocus();
	    }, _this.onBlur = function () {
	      _this.props.onBlur();
	    }, _this.onKeyPress = function (event) {
	      _this.props.onKeyPress(event);
	    }, _this.onInputKeyDown = function (event) {
	      // eslint-disable-line complexity
	      // Call props.onKeyDown if defined
	      // Gives the developer a little bit more control if needed
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(event);
	      }
	
	      switch (event.which) {
	        case 40:
	          // DOWN
	          if (!event.shiftKey) {
	            event.preventDefault();
	            _this.props.onNext();
	          }
	          break;
	        case 38:
	          // UP
	          if (!event.shiftKey) {
	            event.preventDefault();
	            _this.props.onPrev();
	          }
	          break;
	        case 13:
	          // ENTER
	          if (_this.props.doNotSubmitOnEnter) {
	            event.preventDefault();
	          }
	
	          if (!_this.props.ignoreEnter) {
	            _this.props.onSelect();
	          }
	          break;
	        case 9:
	          // TAB
	          if (!_this.props.ignoreTab) {
	            _this.props.onSelect();
	          }
	          break;
	        case 27:
	          // ESC
	          _this.props.onEscape();
	          break;
	        /* istanbul ignore next */
	        default:
	          break;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Input, [{
	    key: 'shouldComponentUpdate',
	
	    /**
	     * Whether or not the component should update
	     * @param {Object} nextProps The new properties
	     * @param {Object} nextState The new state
	     * @return {Boolean} Update or not?
	     */
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /**
	     * When the input got changed
	     */
	
	
	    /**
	     * When the input got focused
	     */
	
	
	    /**
	     * When the input loses focus
	     */
	
	
	    /**
	     * When a key gets pressed in the input
	     * @param  {Event} event The keypress event
	     */
	
	
	    /**
	     * When a key gets pressed in the input
	     * @param  {Event} event The keydown event
	     */
	
	  }, {
	    key: 'focus',
	
	
	    /**
	     * Focus the input
	     */
	    value: function focus() {
	      this.input.focus();
	    }
	
	    /**
	     * Blur the input
	     */
	
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.input.blur();
	    }
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var attributes = (0, _filterInputAttributes2.default)(this.props),
	          classes = (0, _classnames2.default)('geosuggest__input', this.props.className);
	
	      return _react2.default.createElement('input', _extends({ className: classes,
	        ref: function ref(i) {
	          return _this2.input = i;
	        },
	        type: 'text'
	      }, attributes, {
	        value: this.props.value,
	        style: this.props.style,
	        onKeyDown: this.onInputKeyDown,
	        onChange: this.onChange,
	        onKeyPress: this.onKeyPress,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur }));
	    }
	  }]);
	
	  return Input;
	}(_react2.default.Component);
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	
	
	Input.defaultProps = {
	  className: '',
	  value: '',
	  ignoreTab: false,
	  onKeyDown: function onKeyDown() {},
	  onKeyPress: function onKeyPress() {},
	  autoComplete: 'nope'
	};
	
	exports.default = Input;

/***/ },
/* 2829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Prop Types
	 */
	exports.default = {
	  fixtures: _propTypes2.default.array,
	  maxFixtures: _propTypes2.default.number,
	  initialValue: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  inputClassName: _propTypes2.default.string,
	  suggestsClassName: _propTypes2.default.string,
	  suggestsHiddenClassName: _propTypes2.default.string,
	  suggestItemClassName: _propTypes2.default.string,
	  suggestItemActiveClassName: _propTypes2.default.string,
	  location: _propTypes2.default.object,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  bounds: _propTypes2.default.object,
	  country: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
	  types: _propTypes2.default.array,
	  queryDelay: _propTypes2.default.number,
	  googleMaps: _propTypes2.default.object,
	  highlightMatch: _propTypes2.default.bool,
	  onSuggestSelect: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onKeyPress: _propTypes2.default.func,
	  onUpdateSuggests: _propTypes2.default.func,
	  skipSuggest: _propTypes2.default.func,
	  getSuggestLabel: _propTypes2.default.func,
	  renderSuggestItem: _propTypes2.default.func,
	  autoActivateFirstSuggest: _propTypes2.default.bool,
	  style: _propTypes2.default.shape({
	    input: _propTypes2.default.object,
	    suggests: _propTypes2.default.object,
	    suggestItem: _propTypes2.default.object
	  }),
	  ignoreTab: _propTypes2.default.bool,
	  ignoreEnter: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  autoComplete: _propTypes2.default.string,
	  minLength: _propTypes2.default.number
	};

/***/ },
/* 2830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(16);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A single Geosuggest item in the list
	 * @param {Object} props The component's props
	 * @return {JSX} The icon component.
	 */
	var SuggestItem = function (_React$Component) {
	  _inherits(SuggestItem, _React$Component);
	
	  function SuggestItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SuggestItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SuggestItem.__proto__ || Object.getPrototypeOf(SuggestItem)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
	      event.preventDefault();
	      _this.props.onSelect(_this.props.suggest);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SuggestItem, [{
	    key: 'makeBold',
	
	    /**
	     * Makes a text bold
	     * @param {String} element The element to wrap
	     * @param {String} key The key to set on the element
	     * @return {JSX} Bolder text
	     */
	    value: function makeBold(element, key) {
	      return _react2.default.createElement(
	        'b',
	        { className: 'geosuggest__item__matched-text', key: key },
	        element
	      );
	    }
	
	    /**
	     * Replace matched text with the same bold
	     * @param {Object} userInput Value from input
	     * @param {Object} suggest Data from google
	     * @return {String} Formatted string with highlighted matched text
	     */
	
	  }, {
	    key: 'formatMatchedText',
	    value: function formatMatchedText(userInput, suggest) {
	      if (!userInput || !suggest.matchedSubstrings) {
	        return suggest.label;
	      }
	
	      var start = suggest.matchedSubstrings.offset,
	          length = suggest.matchedSubstrings.length,
	          end = start + length,
	          boldPart = this.makeBold(suggest.label.substring(start, end), suggest.label);
	
	      var pre = '',
	          post = '';
	
	      if (start > 0) {
	        pre = suggest.label.slice(0, start);
	      }
	      if (end < suggest.label.length) {
	        post = suggest.label.slice(end);
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        pre,
	        boldPart,
	        post
	      );
	    }
	
	    /**
	     * Checking if item just became active and scrolling if needed.
	     * @param {Object} nextProps The new properties
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.isActive && !this.props.isActive) {
	        this.scrollIfNeeded();
	      }
	    }
	
	    /**
	     * Scrolling current item to the center of the list if item needs scrolling.
	     * Item is scrolled to the center of the list.
	     */
	
	  }, {
	    key: 'scrollIfNeeded',
	    value: function scrollIfNeeded() {
	      var el = this.ref,
	          parent = el.parentElement,
	          overTop = el.offsetTop - parent.offsetTop < parent.scrollTop,
	          overBottom = el.offsetTop - parent.offsetTop + el.clientHeight > parent.scrollTop + parent.clientHeight;
	
	      if (overTop || overBottom) {
	        parent.scrollTop = el.offsetTop - parent.offsetTop - parent.clientHeight / 2 + el.clientHeight / 2;
	      }
	    }
	
	    /**
	     * When the suggest item got clicked
	     * @param {Event} event The click event
	     */
	
	  }, {
	    key: 'render',
	
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	    value: function render() {
	      var _this2 = this;
	
	      var suggest = this.props.suggest,
	          classes = (0, _classnames3.default)('geosuggest__item', this.props.className, this.props.suggestItemClassName, { 'geosuggest__item--active': this.props.isActive }, _defineProperty({}, this.props.activeClassname, this.props.activeClassname ? this.props.isActive : null));
	
	      var content = suggest.label;
	
	      if (this.props.renderSuggestItem) {
	        content = this.props.renderSuggestItem(suggest, this.props.userInput);
	      } else if (this.props.isHighlightMatch) {
	        content = this.formatMatchedText(this.props.userInput, suggest);
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { className: classes,
	          ref: function ref(li) {
	            return _this2.ref = li;
	          },
	          style: this.props.style,
	          onMouseDown: this.props.onMouseDown,
	          onMouseOut: this.props.onMouseOut,
	          onClick: this.onClick },
	        content
	      );
	    }
	  }]);
	
	  return SuggestItem;
	}(_react2.default.Component);
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	
	
	exports.default = SuggestItem;
	SuggestItem.defaultProps = {
	  isActive: false,
	  className: '',
	  suggest: {}
	};

/***/ },
/* 2831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(877);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _classnames2 = __webpack_require__(16);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _suggestItem = __webpack_require__(2830);
	
	var _suggestItem2 = _interopRequireDefault(_suggestItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars
	
	
	/**
	 * The list with suggestions. Either from an API or provided as fixture
	 * @param {Object} props The component's props
	 * @return {JSX} The icon component.
	 */
	var SuggestList = function (_React$Component) {
	  _inherits(SuggestList, _React$Component);
	
	  function SuggestList() {
	    _classCallCheck(this, SuggestList);
	
	    return _possibleConstructorReturn(this, (SuggestList.__proto__ || Object.getPrototypeOf(SuggestList)).apply(this, arguments));
	  }
	
	  _createClass(SuggestList, [{
	    key: 'shouldComponentUpdate',
	
	    /**
	     * Whether or not the component should update
	     * @param {Object} nextProps The new properties
	     * @param {Object} nextState The new state
	     * @return {Boolean} Update or not?
	     */
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /**
	     * Whether or not it is hidden
	     * @return {Boolean} Hidden or not?
	     */
	
	  }, {
	    key: 'isHidden',
	    value: function isHidden() {
	      return this.props.isHidden || this.props.suggests.length === 0;
	    }
	
	    /**
	     * There are new properties available for the list
	     * @param {Object} nextProps The new properties
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.suggests !== this.props.suggests) {
	        if (nextProps.suggests.length === 0) {
	          this.props.onSuggestNoResults();
	        }
	      }
	    }
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var classes = (0, _classnames3.default)('geosuggest__suggests', this.props.suggestsClassName, { 'geosuggest__suggests--hidden': this.isHidden() }, _defineProperty({}, this.props.hiddenClassName, this.props.hiddenClassName ? this.isHidden() : null));
	
	      return _react2.default.createElement(
	        'ul',
	        { className: classes, style: this.props.style },
	        this.props.suggests.map(function (suggest) {
	          var isActive = _this2.props.activeSuggest && suggest.placeId === _this2.props.activeSuggest.placeId,
	              key = suggest.key || suggest.placeId;
	
	          return _react2.default.createElement(_suggestItem2.default, { key: key,
	            className: suggest.className,
	            userInput: _this2.props.userInput,
	            isHighlightMatch: _this2.props.isHighlightMatch,
	            suggest: suggest,
	            style: _this2.props.suggestItemStyle,
	            suggestItemClassName: _this2.props.suggestItemClassName,
	            isActive: isActive,
	            activeClassname: _this2.props.suggestItemActiveClassName,
	            onMouseDown: _this2.props.onSuggestMouseDown,
	            onMouseOut: _this2.props.onSuggestMouseOut,
	            onSelect: _this2.props.onSuggestSelect,
	            renderSuggestItem: _this2.props.renderSuggestItem });
	        })
	      );
	    }
	  }]);
	
	  return SuggestList;
	}(_react2.default.Component);
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	
	
	exports.default = SuggestList;
	SuggestList.defaultProps = {
	  isHidden: true,
	  suggests: []
	};

/***/ },
/* 2832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	  center: _propTypes2.default.any,
	  draggable: _propTypes2.default.bool,
	  editable: _propTypes2.default.bool,
	  options: _propTypes2.default.object,
	  radius: _propTypes2.default.number,
	  visible: _propTypes2.default.bool
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onCenterChanged: "center_changed",
	
	  onClick: "click",
	
	  onDblClick: "dblclick",
	
	  onDrag: "drag",
	
	  onDragEnd: "dragend",
	
	  onDragStart: "dragstart",
	
	  onMouseDown: "mousedown",
	
	  onMouseMove: "mousemove",
	
	  onMouseOut: "mouseout",
	
	  onMouseOver: "mouseover",
	
	  onMouseUp: "mouseup",
	
	  onRadiusChanged: "radius_changed",
	
	  onRightClick: "rightclick"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getBounds: function getBounds(circle) {
	    return circle.getBounds();
	  },
	  getCenter: function getCenter(circle) {
	    return circle.getCenter();
	  },
	  getDraggable: function getDraggable(circle) {
	    return circle.getDraggable();
	  },
	  getEditable: function getEditable(circle) {
	    return circle.getEditable();
	  },
	  getMap: function getMap(circle) {
	    return circle.getMap();
	  },
	  getRadius: function getRadius(circle) {
	    return circle.getRadius();
	  },
	  getVisible: function getVisible(circle) {
	    return circle.getVisible();
	  }
	};
	
	var controlledPropUpdaterMap = {
	  center: function center(circle, _center) {
	    circle.setCenter(_center);
	  },
	  draggable: function draggable(circle, _draggable) {
	    circle.setDraggable(_draggable);
	  },
	  editable: function editable(circle, _editable) {
	    circle.setEditable(_editable);
	  },
	  options: function options(circle, _options) {
	    circle.setOptions(_options);
	  },
	  radius: function radius(circle, _radius) {
	    circle.setRadius(_radius);
	  },
	  visible: function visible(circle, _visible) {
	    circle.setVisible(_visible);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.CIRCLE];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "Circle",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	    var circle = new google.maps.Circle((0, _extends3.default)({
	      map: this.context[_constants.MAP]
	    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	    return (0, _defineProperty3.default)({}, _constants.CIRCLE, circle);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var circle = getInstanceFromComponent(this);
	    if (circle) {
	      circle.setMap(null);
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 2833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	  directions: _propTypes2.default.any,
	  options: _propTypes2.default.object,
	  panel: _propTypes2.default.object,
	  routeIndex: _propTypes2.default.number
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onDirectionsChanged: "directions_changed"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getDirections: function getDirections(directionsRenderer) {
	    return directionsRenderer.getDirections();
	  },
	  getPanel: function getPanel(directionsRenderer) {
	    return directionsRenderer.getPanel();
	  },
	  getRouteIndex: function getRouteIndex(directionsRenderer) {
	    return directionsRenderer.getRouteIndex();
	  }
	};
	
	var controlledPropUpdaterMap = {
	  directions: function directions(directionsRenderer, _directions) {
	    directionsRenderer.setDirections(_directions);
	  },
	  options: function options(directionsRenderer, _options) {
	    directionsRenderer.setOptions(_options);
	  },
	  panel: function panel(directionsRenderer, _panel) {
	    directionsRenderer.setPanel(_panel);
	  },
	  routeIndex: function routeIndex(directionsRenderer, _routeIndex) {
	    directionsRenderer.setRouteIndex(_routeIndex);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.DIRECTIONS_RENDERER];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "DirectionsRenderer",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	    var directionsRenderer = new google.maps.DirectionsRenderer((0, _extends3.default)({
	      map: this.context[_constants.MAP]
	    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	    return (0, _defineProperty3.default)({}, _constants.DIRECTIONS_RENDERER, directionsRenderer);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var directionsRenderer = getInstanceFromComponent(this);
	    if (directionsRenderer) {
	      directionsRenderer.setMap(null);
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 2834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	    // NOTICE!!!!!!
	    //
	    // Only expose those with getters & setters in the table as controlled props.
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	    //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
	    options: _propTypes2.default.object
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	    onClick: "click"
	};
	
	var publicMethodMap = {
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	    //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	    // END - Public APIs
	};
	
	var controlledPropUpdaterMap = {
	    options: function options(fusionTablesLayer, _options) {
	        fusionTablesLayer.setOptions(_options);
	    }
	};
	
	function getInstanceFromComponent(component) {
	    return component.state[_constants.FUSION_TABLES_LAYER];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	    displayName: "FusionTablesLayer",
	
	    propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	    contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	    getInitialState: function getInitialState() {
	        var fusionTablesLayer = new google.maps.FusionTablesLayer((0, _extends3.default)({
	            map: this.context[_constants.MAP],
	            query: this.props.options.query
	        }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	
	        return (0, _defineProperty3.default)({}, _constants.FUSION_TABLES_LAYER, fusionTablesLayer);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        var fusionTablesLayer = getInstanceFromComponent(this);
	        if (fusionTablesLayer) {
	            fusionTablesLayer.setMap(null);
	        }
	    },
	    render: function render() {
	        return false;
	    }
	});

/***/ },
/* 2835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(2859);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _invariant = __webpack_require__(320);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	  center: _propTypes2.default.object,
	
	  heading: _propTypes2.default.number,
	
	  mapTypeId: _propTypes2.default.any,
	
	  options: _propTypes2.default.object,
	
	  streetView: _propTypes2.default.any,
	
	  tilt: _propTypes2.default.number,
	
	  zoom: _propTypes2.default.number
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onBoundsChanged: "bounds_changed",
	
	  onCenterChanged: "center_changed",
	
	  onClick: "click",
	
	  onDblClick: "dblclick",
	
	  onDrag: "drag",
	
	  onDragEnd: "dragend",
	
	  onDragStart: "dragstart",
	
	  onHeadingChanged: "heading_changed",
	
	  onIdle: "idle",
	
	  onMapTypeIdChanged: "maptypeid_changed",
	
	  onMouseMove: "mousemove",
	
	  onMouseOut: "mouseout",
	
	  onMouseOver: "mouseover",
	
	  onProjectionChanged: "projection_changed",
	
	  onResize: "resize",
	
	  onRightClick: "rightclick",
	
	  onTilesLoaded: "tilesloaded",
	
	  onTiltChanged: "tilt_changed",
	
	  onZoomChanged: "zoom_changed"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getBounds: function getBounds(map) {
	    return map.getBounds();
	  },
	  getCenter: function getCenter(map) {
	    return map.getCenter();
	  },
	  getDiv: function getDiv(map) {
	    return map.getDiv();
	  },
	  getHeading: function getHeading(map) {
	    return map.getHeading();
	  },
	  getMapTypeId: function getMapTypeId(map) {
	    return map.getMapTypeId();
	  },
	  getProjection: function getProjection(map) {
	    return map.getProjection();
	  },
	  getStreetView: function getStreetView(map) {
	    return map.getStreetView();
	  },
	  getTilt: function getTilt(map) {
	    return map.getTilt();
	  },
	  getZoom: function getZoom(map) {
	    return map.getZoom();
	  },
	
	  // END - Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	  //
	  // Public APIs - Use this carefully
	  // See discussion in https://github.com/tomchentw/react-google-maps/issues/62
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return !it.match(/^get/) && !it.match(/^set/) && !it.match(/Map$/); })
	  fitBounds: function fitBounds(map, args) {
	    return map.fitBounds.apply(map, (0, _toConsumableArray3.default)(args));
	  },
	  panBy: function panBy(map, args) {
	    return map.panBy.apply(map, (0, _toConsumableArray3.default)(args));
	  },
	  panTo: function panTo(map, args) {
	    return map.panTo.apply(map, (0, _toConsumableArray3.default)(args));
	  },
	  panToBounds: function panToBounds(map, args) {
	    return map.panToBounds.apply(map, (0, _toConsumableArray3.default)(args));
	  }
	};
	
	var controlledPropUpdaterMap = {
	  center: function center(map, _center) {
	    map.setCenter(_center);
	  },
	  heading: function heading(map, _heading) {
	    map.setHeading(_heading);
	  },
	  mapTypeId: function mapTypeId(map, _mapTypeId) {
	    map.setMapTypeId(_mapTypeId);
	  },
	  options: function options(map, _options) {
	    map.setOptions(_options);
	  },
	  streetView: function streetView(map, _streetView) {
	    map.setStreetView(_streetView);
	  },
	  tilt: function tilt(map, _tilt) {
	    map.setTilt(_tilt);
	  },
	  zoom: function zoom(map, _zoom) {
	    map.setZoom(_zoom);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.context[_constants.MAP];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "GoogleMap",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    var map = getInstanceFromComponent(this);
	
	    (0, _invariant2.default)(!!map, "Did you wrap <GoogleMap> component with withGoogleMap() HOC?");
	
	    map.setOptions((0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props));
	    return null;
	  },
	  render: function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      children
	    );
	  }
	});

/***/ },
/* 2836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _contextTypes; /* global google */
	
	
	var _invariant = __webpack_require__(320);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(17);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	  children: _propTypes2.default.element,
	  options: _propTypes2.default.object,
	  position: _propTypes2.default.any,
	  zIndex: _propTypes2.default.number
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onCloseClick: "closeclick",
	
	  onContentChanged: "content_changed",
	
	  onDomReady: "domready",
	
	  onPositionChanged: "position_changed",
	
	  onZIndexChanged: "zindex_changed"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getPosition: function getPosition(infoWindow) {
	    return infoWindow.getPosition();
	  },
	  getZIndex: function getZIndex(infoWindow) {
	    return infoWindow.getZIndex();
	  }
	};
	
	var controlledPropUpdaterMap = {
	  children: function children(infoWindow, _children, component) {
	    (0, _reactDom.unstable_renderSubtreeIntoContainer)(component, _react.Children.only(_children), infoWindow.getContent());
	  },
	  options: function options(infoWindow, _options) {
	    infoWindow.setOptions(_options);
	  },
	  position: function position(infoWindow, _position) {
	    infoWindow.setPosition(_position);
	  },
	  zIndex: function zIndex(infoWindow, _zIndex) {
	    infoWindow.setZIndex(_zIndex);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.INFO_WINDOW];
	}
	
	function openInfoWindow(context, infoWindow) {
	  var map = context[_constants.MAP];
	  var anchor = context[_constants.ANCHOR];
	  if (anchor) {
	    infoWindow.open(map, anchor);
	  } else if (infoWindow.getPosition()) {
	    infoWindow.open(map);
	  } else {
	    (0, _invariant2.default)(false, "You must provide either an anchor (typically a <Marker>) or a position for <InfoWindow>.");
	  }
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "InfoWindow",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (_contextTypes = {}, (0, _defineProperty3.default)(_contextTypes, _constants.MAP, _propTypes2.default.object), (0, _defineProperty3.default)(_contextTypes, _constants.ANCHOR, _propTypes2.default.object), _contextTypes),
	
	  getInitialState: function getInitialState() {
	    var map = this.context[_constants.MAP];
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	    var infoWindow = new google.maps.InfoWindow((0, _extends3.default)({
	      map: map
	    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props), {
	      // Override props of ReactElement type
	      content: undefined,
	      children: undefined
	    }));
	
	    openInfoWindow(this.context, infoWindow);
	    return (0, _defineProperty3.default)({}, _constants.INFO_WINDOW, infoWindow);
	  },
	  componentDidMount: function componentDidMount() {
	    var infoWindow = getInstanceFromComponent(this);
	    var content = document.createElement("div");
	
	    controlledPropUpdaterMap.children({
	      getContent: function getContent() {
	        return content;
	      }
	    }, this.props.children, this);
	    infoWindow.setContent(content);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var anchorChanged = this.context[_constants.ANCHOR] !== nextContext[_constants.ANCHOR];
	    if (anchorChanged) {
	      var infoWindow = getInstanceFromComponent(this);
	      openInfoWindow(nextContext, infoWindow);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var infoWindow = getInstanceFromComponent(this);
	    if (infoWindow) {
	      (0, _reactDom.unmountComponentAtNode)(infoWindow.getContent());
	      infoWindow.setMap(null);
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 2837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	  defaultViewport: _propTypes2.default.any,
	  options: _propTypes2.default.any,
	  metadata: _propTypes2.default.any,
	  status: _propTypes2.default.any,
	  url: _propTypes2.default.string,
	  zIndex: _propTypes2.default.number
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onClick: "click",
	
	  onDefaultViewportChanged: "defaultviewport_changed",
	
	  onStatusChanged: "status_changed"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getDefaultViewport: function getDefaultViewport(kmlLayer) {
	    return kmlLayer.getDefaultViewport();
	  },
	  getMetadata: function getMetadata(kmlLayer) {
	    return kmlLayer.getMetadata();
	  },
	  getOptions: function getOptions(kmlLayer) {
	    return kmlLayer.getOptions();
	  },
	  getStatus: function getStatus(kmlLayer) {
	    return kmlLayer.getStatus();
	  },
	  getUrl: function getUrl(kmlLayer) {
	    return kmlLayer.getUrl();
	  },
	  getZIndex: function getZIndex(kmlLayer) {
	    return kmlLayer.getZIndex();
	  }
	};
	
	var controlledPropUpdaterMap = {
	  defaultViewport: function defaultViewport(kmlLayer, _defaultViewport) {
	    kmlLayer.setDefaultViewport(_defaultViewport);
	  },
	  metadata: function metadata(kmlLayer, _metadata) {
	    kmlLayer.setMetadata(_metadata);
	  },
	  options: function options(kmlLayer, _options) {
	    kmlLayer.setOptions(_options);
	  },
	  status: function status(kmlLayer, _status) {
	    kmlLayer.setStatus(_status);
	  },
	  url: function url(kmlLayer, _url) {
	    kmlLayer.setUrl(_url);
	  },
	  zIndex: function zIndex(kmlLayer, _zIndex) {
	    kmlLayer.setZIndex(_zIndex);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.KML_LAYER];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "KmlLayer",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	    var kmlLayer = new google.maps.KmlLayer((0, _extends3.default)({
	      map: this.context[_constants.MAP]
	    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	    return (0, _defineProperty3.default)({}, _constants.KML_LAYER, kmlLayer);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var kmlLayer = getInstanceFromComponent(this);
	    if (kmlLayer) {
	      kmlLayer.setMap(null);
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 2838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _contextTypes; /* global google */
	
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	  animation: _propTypes2.default.any,
	
	  attribution: _propTypes2.default.any,
	
	  clickable: _propTypes2.default.bool,
	
	  cursor: _propTypes2.default.string,
	
	  draggable: _propTypes2.default.bool,
	
	  icon: _propTypes2.default.any,
	
	  label: _propTypes2.default.any,
	
	  markerWithLabel: _propTypes2.default.func,
	
	  labelClass: _propTypes2.default.string,
	
	  labelAnchor: _propTypes2.default.object,
	
	  labelContent: _propTypes2.default.string,
	
	  labelStyle: _propTypes2.default.object,
	
	  noRedraw: _propTypes2.default.bool,
	
	  opacity: _propTypes2.default.number,
	
	  options: _propTypes2.default.object,
	
	  place: _propTypes2.default.any,
	
	  position: _propTypes2.default.any,
	
	  shape: _propTypes2.default.any,
	
	  title: _propTypes2.default.string,
	
	  visible: _propTypes2.default.bool,
	
	  zIndex: _propTypes2.default.number
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onAnimationChanged: "animation_changed",
	
	  onClick: "click",
	
	  onClickableChanged: "clickable_changed",
	
	  onCursorChanged: "cursor_changed",
	
	  onDblClick: "dblclick",
	
	  onDrag: "drag",
	
	  onDragEnd: "dragend",
	
	  onDraggableChanged: "draggable_changed",
	
	  onDragStart: "dragstart",
	
	  onFlatChanged: "flat_changed",
	
	  onIconChanged: "icon_changed",
	
	  onMouseDown: "mousedown",
	
	  onMouseOut: "mouseout",
	
	  onMouseOver: "mouseover",
	
	  onMouseUp: "mouseup",
	
	  onPositionChanged: "position_changed",
	
	  onRightClick: "rightclick",
	
	  onShapeChanged: "shape_changed",
	
	  onTitleChanged: "title_changed",
	
	  onVisibleChanged: "visible_changed",
	
	  onZindexChanged: "zindex_changed"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getAnimation: function getAnimation(marker) {
	    return marker.getAnimation();
	  },
	  getAttribution: function getAttribution(marker) {
	    return marker.getAttribution();
	  },
	  getClickable: function getClickable(marker) {
	    return marker.getClickable();
	  },
	  getCursor: function getCursor(marker) {
	    return marker.getCursor();
	  },
	  getDraggable: function getDraggable(marker) {
	    return marker.getDraggable();
	  },
	  getIcon: function getIcon(marker) {
	    return marker.getIcon();
	  },
	  getLabel: function getLabel(marker) {
	    return marker.getLabel();
	  },
	  getOpacity: function getOpacity(marker) {
	    return marker.getOpacity();
	  },
	  getPlace: function getPlace(marker) {
	    return marker.getPlace();
	  },
	  getPosition: function getPosition(marker) {
	    return marker.getPosition();
	  },
	  getShape: function getShape(marker) {
	    return marker.getShape();
	  },
	  getTitle: function getTitle(marker) {
	    return marker.getTitle();
	  },
	  getVisible: function getVisible(marker) {
	    return marker.getVisible();
	  },
	  getZIndex: function getZIndex(marker) {
	    return marker.getZIndex();
	  },
	
	
	  // Public Api's
	  // https://github.com/printercu/google-maps-utility-library-v3-read-only/blob/master/markerwithlabel/src/markerwithlabel.js
	  getLabelContent: function getLabelContent(marker) {
	    return marker.get("labelContent");
	  }
	};
	
	var controlledPropUpdaterMap = {
	  animation: function animation(marker, _animation) {
	    marker.setAnimation(_animation);
	  },
	  attribution: function attribution(marker, _attribution) {
	    marker.setAttribution(_attribution);
	  },
	  clickable: function clickable(marker, _clickable) {
	    marker.setClickable(_clickable);
	  },
	  cursor: function cursor(marker, _cursor) {
	    marker.setCursor(_cursor);
	  },
	  draggable: function draggable(marker, _draggable) {
	    marker.setDraggable(_draggable);
	  },
	  icon: function icon(marker, _icon) {
	    marker.setIcon(_icon);
	  },
	  opacity: function opacity(marker, _opacity) {
	    marker.setOpacity(_opacity);
	  },
	  options: function options(marker, _options) {
	    marker.setOptions(_options);
	  },
	  place: function place(marker, _place) {
	    marker.setPlace(_place);
	  },
	  position: function position(marker, _position) {
	    marker.setPosition(_position);
	  },
	  shape: function shape(marker, _shape) {
	    marker.setShape(_shape);
	  },
	  title: function title(marker, _title) {
	    marker.setTitle(_title);
	  },
	  visible: function visible(marker, _visible) {
	    marker.setVisible(_visible);
	  },
	  zIndex: function zIndex(marker, _zIndex) {
	    marker.setZIndex(_zIndex);
	  },
	
	
	  // Public Api's
	  // https://github.com/printercu/google-maps-utility-library-v3-read-only/blob/master/markerwithlabel/src/markerwithlabel.js
	  labelContent: function labelContent(marker, label) {
	    marker.set("labelContent", label);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.MARKER];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "Marker",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (_contextTypes = {}, (0, _defineProperty3.default)(_contextTypes, _constants.MAP, _propTypes2.default.object), (0, _defineProperty3.default)(_contextTypes, _constants.MARKER_CLUSTERER, _propTypes2.default.object), _contextTypes),
	
	  childContextTypes: (0, _defineProperty3.default)({}, _constants.ANCHOR, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	    var Marker = this.props.markerWithLabel || google.maps.Marker;
	    var marker = new Marker((0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props));
	    var markerClusterer = this.context[_constants.MARKER_CLUSTERER];
	    if (markerClusterer) {
	      markerClusterer.addMarker(marker, !!this.props.noRedraw);
	    } else {
	      marker.setMap(this.context[_constants.MAP]);
	    }
	    return (0, _defineProperty3.default)({}, _constants.MARKER, marker);
	  },
	  getChildContext: function getChildContext() {
	    return (0, _defineProperty3.default)({}, _constants.ANCHOR, this.context[_constants.ANCHOR] || getInstanceFromComponent(this));
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var marker = getInstanceFromComponent(this);
	    if (marker) {
	      var markerClusterer = this.context[_constants.MARKER_CLUSTERER];
	      if (markerClusterer) {
	        markerClusterer.removeMarker(marker, !!this.props.noRedraw);
	      }
	      marker.setMap(null);
	    }
	  },
	  render: function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      children
	    );
	  }
	});

/***/ },
/* 2839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _delay2 = __webpack_require__(2958);
	
	var _delay3 = _interopRequireDefault(_delay2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	var _OverlayViewHelper = __webpack_require__(2845);
	
	var helpers = _interopRequireWildcard(_OverlayViewHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	  mapPaneName: _propTypes2.default.string,
	  position: _propTypes2.default.object,
	  bounds: _propTypes2.default.object
	}; /* global google */
	
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getPanes: function getPanes(overlayView) {
	    return overlayView.getPanes();
	  },
	  getProjection: function getProjection(overlayView) {
	    return overlayView.getProjection();
	  }
	};
	
	var controlledPropUpdaterMap = {};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.OVERLAY_VIEW];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "OverlayView",
	
	  statics: {
	    FLOAT_PANE: "floatPane",
	    MAP_PANE: "mapPane",
	    MARKER_LAYER: "markerLayer",
	    OVERLAY_LAYER: "overlayLayer",
	    OVERLAY_MOUSE_TARGET: "overlayMouseTarget"
	  },
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes, {
	    children: _propTypes2.default.node.isRequired,
	    getPixelPositionOffset: _propTypes2.default.func
	  }),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	    var overlayView = new google.maps.OverlayView();
	    // You must implement three methods: onAdd(), draw(), and onRemove().
	    overlayView.onAdd = this.onAdd;
	    overlayView.draw = this.draw;
	    overlayView.onRemove = this.onRemove;
	    // You must call setMap() with a valid Map object to trigger the call to
	    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
	    overlayView.setMap(this.context[_constants.MAP]);
	    return (0, _defineProperty3.default)({}, _constants.OVERLAY_VIEW, overlayView);
	  },
	  onAdd: function onAdd() {
	    this._containerElement = helpers.createContainerElement();
	  },
	  draw: function draw() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	    var overlayView = getInstanceFromComponent(this);
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
	    var mapPanes = overlayView.getPanes();
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
	    var mapCanvasProjection = overlayView.getProjection();
	    //
	    var props = (0, _extends3.default)({}, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props), {
	      children: this.props.children,
	      getPixelPositionOffset: this.props.getPixelPositionOffset
	    });
	    helpers.mountContainerElementToPane(mapPanes, this._containerElement, props);
	    helpers.renderChildToContainerElement(mapCanvasProjection, this._containerElement, props);
	  },
	  onRemove: function onRemove() {
	    helpers.unmountAndDestroyContainerElement(this._containerElement);
	    this._containerElement = null;
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    (0, _delay3.default)(this.draw);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var overlayView = getInstanceFromComponent(this);
	    if (overlayView) {
	      overlayView.setMap(null);
	      // You must implement three methods: onAdd(), draw(), and onRemove().
	      overlayView.onAdd = null;
	      overlayView.draw = null;
	      overlayView.onRemove = null;
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 2840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	  draggable: _propTypes2.default.bool,
	  editable: _propTypes2.default.bool,
	  options: _propTypes2.default.object,
	  path: _propTypes2.default.any,
	  paths: _propTypes2.default.any,
	  visible: _propTypes2.default.bool
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onClick: "click",
	
	  onDblClick: "dblclick",
	
	  onDrag: "drag",
	
	  onDragEnd: "dragend",
	
	  onDragStart: "dragstart",
	
	  onMouseDown: "mousedown",
	
	  onMouseMove: "mousemove",
	
	  onMouseOut: "mouseout",
	
	  onMouseOver: "mouseover",
	
	  onMouseUp: "mouseup",
	
	  onRightClick: "rightclick"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getDraggable: function getDraggable(polygon) {
	    return polygon.getDraggable();
	  },
	  getEditable: function getEditable(polygon) {
	    return polygon.getEditable();
	  },
	  getPath: function getPath(polygon) {
	    return polygon.getPath();
	  },
	  getPaths: function getPaths(polygon) {
	    return polygon.getPaths();
	  },
	  getVisible: function getVisible(polygon) {
	    return polygon.getVisible();
	  }
	};
	
	var controlledPropUpdaterMap = {
	  draggable: function draggable(polygon, _draggable) {
	    polygon.setDraggable(_draggable);
	  },
	  editable: function editable(polygon, _editable) {
	    polygon.setEditable(_editable);
	  },
	  options: function options(polygon, _options) {
	    polygon.setOptions(_options);
	  },
	  path: function path(polygon, _path) {
	    polygon.setPath(_path);
	  },
	  paths: function paths(polygon, _paths) {
	    polygon.setPaths(_paths);
	  },
	  visible: function visible(polygon, _visible) {
	    polygon.setVisible(_visible);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.POLYGON];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "Polygon",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	    var polygon = new google.maps.Polygon((0, _extends3.default)({
	      map: this.context[_constants.MAP]
	    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	    return (0, _defineProperty3.default)({}, _constants.POLYGON, polygon);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var polygon = getInstanceFromComponent(this);
	    if (polygon) {
	      polygon.setMap(null);
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 2841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	  draggable: _propTypes2.default.bool,
	  editable: _propTypes2.default.bool,
	  options: _propTypes2.default.object,
	  path: _propTypes2.default.any,
	  visible: _propTypes2.default.bool
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onClick: "click",
	
	  onDblClick: "dblclick",
	
	  onDrag: "drag",
	
	  onDragEnd: "dragend",
	
	  onDragStart: "dragstart",
	
	  onMouseDown: "mousedown",
	
	  onMouseMove: "mousemove",
	
	  onMouseOut: "mouseout",
	
	  onMouseOver: "mouseover",
	
	  onMouseUp: "mouseup",
	
	  onRightClick: "rightclick"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getDraggable: function getDraggable(polyline) {
	    return polyline.getDraggable();
	  },
	  getEditable: function getEditable(polyline) {
	    return polyline.getEditable();
	  },
	  getPath: function getPath(polyline) {
	    return polyline.getPath();
	  },
	  getVisible: function getVisible(polyline) {
	    return polyline.getVisible();
	  }
	};
	
	var controlledPropUpdaterMap = {
	  draggable: function draggable(polyline, _draggable) {
	    polyline.setDraggable(_draggable);
	  },
	  editable: function editable(polyline, _editable) {
	    polyline.setEditable(_editable);
	  },
	  options: function options(polyline, _options) {
	    polyline.setOptions(_options);
	  },
	  path: function path(polyline, _path) {
	    polyline.setPath(_path);
	  },
	  visible: function visible(polyline, _visible) {
	    polyline.setVisible(_visible);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.POLYLINE];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "Polyline",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	    var polyline = new google.maps.Polyline((0, _extends3.default)({
	      map: this.context[_constants.MAP]
	    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	    return (0, _defineProperty3.default)({}, _constants.POLYLINE, polyline);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var polyline = getInstanceFromComponent(this);
	    if (polyline) {
	      polyline.setMap(null);
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 2842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	  bounds: _propTypes2.default.any,
	  draggable: _propTypes2.default.bool,
	  editable: _propTypes2.default.bool,
	  options: _propTypes2.default.object,
	  visible: _propTypes2.default.bool
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onBoundsChanged: "bounds_changed",
	
	  onClick: "click",
	
	  onDblClick: "dblclick",
	
	  onDrag: "drag",
	
	  onDragEnd: "dragend",
	
	  onDragStart: "dragstart",
	
	  onMouseDown: "mousedown",
	
	  onMouseMove: "mousemove",
	
	  onMouseOut: "mouseout",
	
	  onMouseOver: "mouseover",
	
	  onMouseUp: "mouseup",
	
	  onRightClick: "rightclick"
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getBounds: function getBounds(rectangle) {
	    return rectangle.getBounds();
	  },
	  getDraggable: function getDraggable(rectangle) {
	    return rectangle.getDraggable();
	  },
	  getEditable: function getEditable(rectangle) {
	    return rectangle.getEditable();
	  },
	  getVisible: function getVisible(rectangle) {
	    return rectangle.getVisible();
	  }
	};
	
	var controlledPropUpdaterMap = {
	  bounds: function bounds(rectangle, _bounds) {
	    rectangle.setBounds(_bounds);
	  },
	  draggable: function draggable(rectangle, _draggable) {
	    rectangle.setDraggable(_draggable);
	  },
	  editable: function editable(rectangle, _editable) {
	    rectangle.setEditable(_editable);
	  },
	  options: function options(rectangle, _options) {
	    rectangle.setOptions(_options);
	  },
	  visible: function visible(rectangle, _visible) {
	    rectangle.setVisible(_visible);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.RECTANGLE];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "Rectangle",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	    var rectangle = new google.maps.Rectangle((0, _extends3.default)({
	      map: this.context[_constants.MAP]
	    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	    return (0, _defineProperty3.default)({}, _constants.RECTANGLE, rectangle);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var rectangle = getInstanceFromComponent(this);
	    if (rectangle) {
	      rectangle.setMap(null);
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 2843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
	  links: _propTypes2.default.array,
	  motionTracking: _propTypes2.default.bool,
	  options: _propTypes2.default.object,
	  pano: _propTypes2.default.string,
	  panoProvider: _propTypes2.default.func,
	  position: _propTypes2.default.object,
	  pov: _propTypes2.default.object,
	  visible: _propTypes2.default.bool,
	  zoom: _propTypes2.default.number
	}; /* global google */
	
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  onCloseClick: "closeclick",
	
	  onPanoChanged: "pano_changed",
	
	  onPositionChanged: "position_changed",
	
	  onLinksChanged: "links_changed",
	
	  onPovChanged: "pov_changed",
	
	  onResize: "resize",
	
	  onStatusChanged: "status_changed",
	
	  onVisibleChanged: "visible_changed",
	
	  onZoomChanged: "zoom_changed"
	
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  getLinks: function getLinks(streetViewPanorama) {
	    return streetViewPanorama.getLinks();
	  },
	  getLocation: function getLocation(streetViewPanorama) {
	    return streetViewPanorama.getLocation();
	  },
	  getMotionTracking: function getMotionTracking(streetViewPanorama) {
	    return streetViewPanorama.getMotionTracking();
	  },
	  getPano: function getPano(streetViewPanorama) {
	    return streetViewPanorama.getPano();
	  },
	  getPhotographerPov: function getPhotographerPov(streetViewPanorama) {
	    return streetViewPanorama.getPhotographerPov();
	  },
	  getPosition: function getPosition(streetViewPanorama) {
	    return streetViewPanorama.getPosition();
	  },
	  getPov: function getPov(streetViewPanorama) {
	    return streetViewPanorama.getPov();
	  },
	  getStatus: function getStatus(streetViewPanorama) {
	    return streetViewPanorama.getStatus();
	  },
	  getVisible: function getVisible(streetViewPanorama) {
	    return streetViewPanorama.getVisible();
	  },
	  getZoom: function getZoom(streetViewPanorama) {
	    return streetViewPanorama.getZoom();
	  }
	};
	
	var controlledPropUpdaterMap = {
	  links: function links(streetViewPanorama, _links) {
	    streetViewPanorama.setLinks(_links);
	  },
	  motionTracking: function motionTracking(streetViewPanorama, _motionTracking) {
	    streetViewPanorama.setMotionTracking(_motionTracking);
	  },
	  options: function options(streetViewPanorama, _options) {
	    streetViewPanorama.setOptions(_options);
	  },
	  pano: function pano(streetViewPanorama, _pano) {
	    streetViewPanorama.setPano(_pano);
	  },
	  panoProvider: function panoProvider(streetViewPanorama, _panoProvider) {
	    streetViewPanorama.registerPanoProvider(_panoProvider);
	  },
	  position: function position(streetViewPanorama, _position) {
	    streetViewPanorama.setPosition(_position);
	  },
	  pov: function pov(streetViewPanorama, _pov) {
	    streetViewPanorama.setPov(_pov);
	  },
	  visible: function visible(streetViewPanorama, _visible) {
	    streetViewPanorama.setVisible(_visible);
	  },
	  zoom: function zoom(streetViewPanorama, _zoom) {
	    streetViewPanorama.setZoom(_zoom);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.STREET_VIEW_PANORAMA];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "StreetViewPanorama",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  childContextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialOptions: function getInitialOptions() {
	    return (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props);
	  },
	  getChildContext: function getChildContext() {
	    return (0, _defineProperty3.default)({}, _constants.MAP, this.state[_constants.STREET_VIEW_PANORAMA]);
	  },
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
	    var streetViewPanorama = void 0;
	    if (!this.props.containerElement && this.context[_constants.MAP]) {
	      streetViewPanorama = this.context[_constants.MAP].getStreetView();
	      streetViewPanorama.setOptions(this.getInitialOptions());
	    }
	    if (!this.props.containerElement && !this.context[_constants.MAP]) {
	      throw new Error("You need to use the StreetViewPanorama in the context of `<GoogleMap>` or pass an `containerElement` for it to be rendered in.");
	    }
	    return (0, _defineProperty3.default)({}, _constants.STREET_VIEW_PANORAMA, streetViewPanorama);
	  },
	  handleComponentMount: function handleComponentMount(el) {
	    this.el = el;
	    if (this.el) {
	      var streetViewPanorama = new google.maps.StreetViewPanorama(this.el, (0, _extends3.default)({
	        map: this.context[_constants.MAP]
	      }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	      if (this.context[_constants.MAP]) {
	        this.context[_constants.MAP].setStreetView(streetViewPanorama);
	      }
	      this.setState((0, _defineProperty3.default)({}, _constants.STREET_VIEW_PANORAMA, streetViewPanorama));
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var streetViewPanorama = getInstanceFromComponent(this);
	    if (streetViewPanorama) {
	      streetViewPanorama.setVisible(false);
	    }
	  },
	  render: function render() {
	    if (this.props.containerElement) {
	      return _react2.default.cloneElement(this.props.containerElement, { ref: this.handleComponentMount }, this.props.children);
	    }
	    return _react2.default.createElement(
	      "div",
	      null,
	      this.props.children
	    );
	  }
	});

/***/ },
/* 2844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _flowRight2 = __webpack_require__(65);
	
	var _flowRight3 = _interopRequireDefault(_flowRight2);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(70);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(63);
	
	var _enhanceElement = __webpack_require__(69);
	
	var _enhanceElement2 = _interopRequireDefault(_enhanceElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	var controlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
	  options: _propTypes2.default.object
	};
	
	var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);
	
	var eventMap = {
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	};
	
	var publicMethodMap = {
	  // Public APIs
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	  // END - Public APIs
	};
	
	var controlledPropUpdaterMap = {
	  options: function options(trafficLayer, _options) {
	    trafficLayer.setOptions(_options);
	  }
	};
	
	function getInstanceFromComponent(component) {
	  return component.state[_constants.TRAFFIC_LAYER];
	}
	
	exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
	  displayName: "TrafficLayer",
	
	  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),
	
	  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),
	
	  getInitialState: function getInitialState() {
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
	    var trafficLayer = new google.maps.TrafficLayer((0, _extends3.default)({
	      map: this.context[_constants.MAP]
	    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
	    return (0, _defineProperty3.default)({}, _constants.TRAFFIC_LAYER, trafficLayer);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var trafficLayer = getInstanceFromComponent(this);
	    if (trafficLayer) {
	      trafficLayer.setMap(null);
	    }
	  },
	  render: function render() {
	    return false;
	  }
	});

/***/ },
/* 2845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(57);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign2 = __webpack_require__(2954);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _isFunction2 = __webpack_require__(331);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	exports.createContainerElement = createContainerElement;
	exports.mountContainerElementToPane = mountContainerElementToPane;
	exports.renderChildToContainerElement = renderChildToContainerElement;
	exports.unmountAndDestroyContainerElement = unmountAndDestroyContainerElement;
	
	var _invariant = __webpack_require__(320);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createContainerElement() {
	  var containerElement = document.createElement("div");
	  containerElement.style.position = "absolute";
	  return containerElement;
	} /* global google */
	function mountContainerElementToPane(mapPanes, containerElement, props) {
	  var mapPaneName = props.mapPaneName;
	
	  (0, _invariant2.default)(!!mapPaneName, "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s", mapPaneName);
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
	  mapPanes[mapPaneName].appendChild(containerElement);
	}
	
	function getOffsetOverride(containerElement, props) {
	  var getPixelPositionOffset = props.getPixelPositionOffset;
	  //
	  // Allows the component to control the visual position of the OverlayView
	  // relative to the LatLng pixel position.
	  //
	
	  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
	    return getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight);
	  } else {
	    return {};
	  }
	}
	
	function createLatLng(inst, Type) {
	  return new Type(inst.lat, inst.lng);
	}
	
	function createLatLngBounds(inst, Type) {
	  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
	}
	
	function ensureOfType(inst, type, factory) {
	  if (inst instanceof type) {
	    return inst;
	  } else {
	    return factory(inst, type);
	  }
	}
	
	function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
	  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
	  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
	  if (ne && sw) {
	    return {
	      left: sw.x + offset.x + "px",
	      top: ne.y + offset.y + "px",
	      width: ne.x - sw.x - offset.x + "px",
	      height: sw.y - ne.y - offset.y + "px"
	    };
	  }
	  return {
	    left: "-9999px",
	    top: "-9999px"
	  };
	}
	
	function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
	  var point = mapCanvasProjection.fromLatLngToDivPixel(position);
	  if (point) {
	    var x = point.x,
	        y = point.y;
	
	    return {
	      left: x + offset.x + "px",
	      top: y + offset.y + "px"
	    };
	  }
	  return {
	    left: "-9999px",
	    top: "-9999px"
	  };
	}
	
	function getLayoutStyles(mapCanvasProjection, offset, props) {
	  if (props.bounds) {
	    var bounds = ensureOfType(props.bounds, google.maps.LatLngBounds, createLatLngBounds);
	    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds);
	  } else {
	    var position = ensureOfType(props.position, google.maps.LatLng, createLatLng);
	    return getLayoutStylesByPosition(mapCanvasProjection, offset, position);
	  }
	}
	
	function renderChildToContainerElement(mapCanvasProjection, containerElement, props) {
	  var child = _react.Children.only(props.children);
	  (0, _reactDom.render)(child, containerElement, function () {
	    var offset = (0, _extends3.default)({
	      x: 0,
	      y: 0
	    }, getOffsetOverride(containerElement, props));
	    var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, props);
	    (0, _assign3.default)(containerElement.style, layoutStyles);
	  });
	}
	
	function unmountAndDestroyContainerElement(containerElement) {
	  containerElement.parentNode.removeChild(containerElement);
	  (0, _reactDom.unmountComponentAtNode)(containerElement);
	}

/***/ },
/* 2846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(2857);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(64);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(2850);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2854);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2855);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(2858);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(2856);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withGoogleMap;
	
	var _warning = __webpack_require__(37);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(320);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _reactDisplayName = __webpack_require__(2762);
	
	var _reactDisplayName2 = _interopRequireDefault(_reactDisplayName);
	
	var _propTypes = __webpack_require__(66);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google */
	function withGoogleMap(WrappedComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(Container, _Component);
	
	    function Container() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3.default)(this, Container);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Container.__proto__ || (0, _getPrototypeOf2.default)(Container)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        map: null
	      }, _this.handleComponentMount = _this.handleComponentMount.bind(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(Container, [{
	      key: "getChildContext",
	      value: function getChildContext() {
	        return (0, _defineProperty3.default)({}, _constants.MAP, this.state.map);
	      }
	    }, {
	      key: "componentWillMount",
	      value: function componentWillMount() {
	        var _props = this.props,
	            containerElement = _props.containerElement,
	            mapElement = _props.mapElement;
	
	        (0, _invariant2.default)(!!containerElement && !!mapElement, "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized.");
	      }
	    }, {
	      key: "handleComponentMount",
	      value: function handleComponentMount(node) {
	        if (this.state.map || node === null) {
	          return;
	        }
	        (0, _warning2.default)("undefined" !== typeof google, "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168");
	        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	        var map = new google.maps.Map(node);
	        this.setState({ map: map });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _props2 = this.props,
	            containerElement = _props2.containerElement,
	            mapElement = _props2.mapElement,
	            restProps = (0, _objectWithoutProperties3.default)(_props2, ["containerElement", "mapElement"]);
	        var map = this.state.map;
	
	
	        if (map) {
	          return _react2.default.cloneElement(containerElement, {}, _react2.default.cloneElement(mapElement, {
	            ref: this.handleComponentMount
	          }), _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(WrappedComponent, restProps)
	          ));
	        } else {
	          return _react2.default.cloneElement(containerElement, {}, _react2.default.cloneElement(mapElement, {
	            ref: this.handleComponentMount
	          }), _react2.default.createElement("div", null));
	        }
	      }
	    }]);
	    return Container;
	  }(_react.Component), _class.displayName = "withGoogleMap(" + (0, _reactDisplayName2.default)(WrappedComponent) + ")", _class.propTypes = {
	    containerElement: _propTypes2.default.node.isRequired,
	    mapElement: _propTypes2.default.node.isRequired
	  }, _class.childContextTypes = (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object), _temp2;
	}

/***/ },
/* 2847 */
537,
/* 2848 */
[3142, 544],
/* 2849 */
[3143, 545],
/* 2850 */
10,
/* 2851 */
[3144, 548],
/* 2852 */
[3145, 549],
/* 2853 */
1245,
/* 2854 */
6,
/* 2855 */
[3146, 916],
/* 2856 */
[3149, 2851, 2849, 917],
/* 2857 */
13,
/* 2858 */
[3150, 917],
/* 2859 */
[3151, 2847],
/* 2860 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(39);
	
	var emptyObject = __webpack_require__(223);
	var _invariant = __webpack_require__(21);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @nosideeffects
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function (Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function (Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function (Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	    },
	    contextTypes: function (Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function (Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function (Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function (Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function () {} };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	      }
	
	      return;
	    }
	
	    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
	    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
	
	      var isInherited = name in Constructor;
	      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function (newThis) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	        } else if (!args.length) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedMixin = {
	    componentDidMount: function () {
	      this.__isMounted = true;
	    },
	    componentWillUnmount: function () {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function (newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function () {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function () {};
	  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedMixin);
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 2861 */
[3175, 159, 82],
/* 2862 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(2913),
	    hashDelete = __webpack_require__(2914),
	    hashGet = __webpack_require__(2915),
	    hashHas = __webpack_require__(2916),
	    hashSet = __webpack_require__(2917);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 2863 */
[3177, 159, 82],
/* 2864 */
[3178, 159, 82],
/* 2865 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(460),
	    setCacheAdd = __webpack_require__(2942),
	    setCacheHas = __webpack_require__(2943);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 2866 */
[3181, 82],
/* 2867 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(2879);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 2868 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(2892),
	    isArguments = __webpack_require__(471),
	    isArray = __webpack_require__(91),
	    isIndex = __webpack_require__(325);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 2869 */
281,
/* 2870 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 2871 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 2872 */
/***/ function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The base implementation of `_.delay` and `_.defer` which accepts `args`
	 * to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {Array} args The arguments to provide to `func`.
	 * @returns {number|Object} Returns the timer id or timeout object.
	 */
	function baseDelay(func, wait, args) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return setTimeout(function() { func.apply(undefined, args); }, wait);
	}
	
	module.exports = baseDelay;


/***/ },
/* 2873 */
634,
/* 2874 */
[3186, 2869, 2919],
/* 2875 */
[3187, 2901],
/* 2876 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 2877 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ },
/* 2878 */
1538,
/* 2879 */
[3189, 2873, 2882, 2950],
/* 2880 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(918),
	    equalArrays = __webpack_require__(934),
	    equalByTag = __webpack_require__(2906),
	    equalObjects = __webpack_require__(2907),
	    getTag = __webpack_require__(2910),
	    isArray = __webpack_require__(91),
	    isTypedArray = __webpack_require__(2965);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 2881 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(918),
	    baseIsEqual = __webpack_require__(925);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 2882 */
1545,
/* 2883 */
[3190, 331, 2922, 128, 947],
/* 2884 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(472),
	    isObjectLike = __webpack_require__(246);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 2885 */
[3192, 939, 2937],
/* 2886 */
[3193, 2881, 2909, 941],
/* 2887 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(925),
	    get = __webpack_require__(2961),
	    hasIn = __webpack_require__(2963),
	    isKey = __webpack_require__(326),
	    isStrictComparable = __webpack_require__(940),
	    matchesStrictComparable = __webpack_require__(941),
	    toKey = __webpack_require__(329);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 2888 */
1557,
/* 2889 */
[3194, 924],
/* 2890 */
1561,
/* 2891 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(2956),
	    identity = __webpack_require__(244),
	    nativeDefineProperty = __webpack_require__(2936);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !nativeDefineProperty ? identity : function(func, string) {
	  return nativeDefineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 2892 */
1568,
/* 2893 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(461),
	    isSymbol = __webpack_require__(332);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 2894 */
147,
/* 2895 */
288,
/* 2896 */
[3196, 921, 463],
/* 2897 */
[3197, 82],
/* 2898 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 2899 */
[3198, 467, 2920],
/* 2900 */
[3199, 245],
/* 2901 */
1582,
/* 2902 */
/***/ function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(323),
	    root = __webpack_require__(82);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ },
/* 2903 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(462),
	    createCtor = __webpack_require__(323),
	    createHybrid = __webpack_require__(931),
	    createRecurry = __webpack_require__(932),
	    getHolder = __webpack_require__(469),
	    replaceHolders = __webpack_require__(328),
	    root = __webpack_require__(82);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ },
/* 2904 */
/***/ function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(458),
	    flatRest = __webpack_require__(2908),
	    getData = __webpack_require__(468),
	    getFuncName = __webpack_require__(936),
	    isArray = __webpack_require__(91),
	    isLaziable = __webpack_require__(938);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 &&
	          isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ },
/* 2905 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(462),
	    createCtor = __webpack_require__(323),
	    root = __webpack_require__(82);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ },
/* 2906 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(461),
	    Uint8Array = __webpack_require__(2866),
	    eq = __webpack_require__(330),
	    equalArrays = __webpack_require__(934),
	    mapToArray = __webpack_require__(2933),
	    setToArray = __webpack_require__(2944);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 2907 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(333);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 2908 */
[3200, 2959, 943, 470],
/* 2909 */
[3202, 940, 333],
/* 2910 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(2861),
	    Map = __webpack_require__(459),
	    Promise = __webpack_require__(2863),
	    Set = __webpack_require__(2864),
	    WeakMap = __webpack_require__(919),
	    baseGetTag = __webpack_require__(2876),
	    toSource = __webpack_require__(947);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 2911 */
1591,
/* 2912 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ },
/* 2913 */
[3204, 327],
/* 2914 */
1594,
/* 2915 */
[3205, 327],
/* 2916 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(327);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 2917 */
[3206, 327],
/* 2918 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ },
/* 2919 */
[3207, 461, 471, 91],
/* 2920 */
[3208, 330, 245, 325, 128],
/* 2921 */
1601,
/* 2922 */
[3210, 2897],
/* 2923 */
1603,
/* 2924 */
[3212, 322],
/* 2925 */
[3213, 322],
/* 2926 */
[3214, 322],
/* 2927 */
[3215, 322],
/* 2928 */
[3216, 2862, 321, 459],
/* 2929 */
[3217, 324],
/* 2930 */
[3218, 324],
/* 2931 */
[3219, 324],
/* 2932 */
[3220, 324],
/* 2933 */
1613,
/* 2934 */
[3221, 2967],
/* 2935 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(928),
	    composeArgsRight = __webpack_require__(929),
	    replaceHolders = __webpack_require__(328);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	    ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 2936 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(159);
	
	/* Built-in method references that are verified to be native. */
	var nativeDefineProperty = getNative(Object, 'defineProperty');
	
	module.exports = nativeDefineProperty;


/***/ },
/* 2937 */
[3223, 2939],
/* 2938 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(935);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)(module)))

/***/ },
/* 2939 */
658,
/* 2940 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 2941 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(930),
	    isIndex = __webpack_require__(325);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 2942 */
1619,
/* 2943 */
1620,
/* 2944 */
412,
/* 2945 */
[3227, 321],
/* 2946 */
1623,
/* 2947 */
1624,
/* 2948 */
1625,
/* 2949 */
[3228, 321, 459, 460],
/* 2950 */
1627,
/* 2951 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(2934),
	    toString = __webpack_require__(2972);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 2952 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(920),
	    arrayIncludes = __webpack_require__(2867);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256,
	    FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', ARY_FLAG],
	  ['bind', BIND_FLAG],
	  ['bindKey', BIND_KEY_FLAG],
	  ['curry', CURRY_FLAG],
	  ['curryRight', CURRY_RIGHT_FLAG],
	  ['flip', FLIP_FLAG],
	  ['partial', PARTIAL_FLAG],
	  ['partialRight', PARTIAL_RIGHT_FLAG],
	  ['rearg', REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ },
/* 2953 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(457),
	    LodashWrapper = __webpack_require__(458),
	    copyArray = __webpack_require__(930);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 2954 */
[3230, 921, 2896, 2899, 245, 939, 333],
/* 2955 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(467),
	    createWrap = __webpack_require__(933),
	    getHolder = __webpack_require__(469),
	    replaceHolders = __webpack_require__(328);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and `partials` prepended to the arguments it receives.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * function greet(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * }
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = baseRest(function(func, thisArg, partials) {
	  var bitmask = BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bind));
	    bitmask |= PARTIAL_FLAG;
	  }
	  return createWrap(func, bitmask, thisArg, partials, holders);
	});
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;


/***/ },
/* 2956 */
1634,
/* 2957 */
/***/ function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(933);
	
	/** Used to compose bitmasks for function metadata. */
	var CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ },
/* 2958 */
/***/ function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(2872),
	    baseRest = __webpack_require__(467),
	    toNumber = __webpack_require__(949);
	
	/**
	 * Invokes `func` after `wait` milliseconds. Any additional arguments are
	 * provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {...*} [args] The arguments to invoke `func` with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.delay(function(text) {
	 *   console.log(text);
	 * }, 1000, 'later');
	 * // => Logs 'later' after one second.
	 */
	var delay = baseRest(function(func, wait, args) {
	  return baseDelay(func, toNumber(wait) || 0, args);
	});
	
	module.exports = delay;


/***/ },
/* 2959 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(2874);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 2960 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(920),
	    baseEach = __webpack_require__(922),
	    baseIteratee = __webpack_require__(465),
	    isArray = __webpack_require__(91);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = forEach;


/***/ },
/* 2961 */
[3231, 924],
/* 2962 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(2877),
	    hasPath = __webpack_require__(937);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 2963 */
[3232, 2878, 937],
/* 2964 */
[3234, 245, 246],
/* 2965 */
[3235, 2884, 2894, 2938],
/* 2966 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(463),
	    baseForOwn = __webpack_require__(923),
	    baseIteratee = __webpack_require__(465);
	
	/**
	 * The opposite of `_.mapValues`; this method creates an object with the
	 * same values as `object` and keys generated by running each own enumerable
	 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	 * with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.8.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapValues
	 * @example
	 *
	 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   return key + value;
	 * });
	 * // => { 'a1': 1, 'b2': 2 }
	 */
	function mapKeys(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, iteratee(value, key, object), value);
	  });
	  return result;
	}
	
	module.exports = mapKeys;


/***/ },
/* 2967 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(460);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 2968 */
[3237, 2888, 2889, 326, 329],
/* 2969 */
[3238, 2870, 922, 465, 2890, 91],
/* 2970 */
[3239, 949],
/* 2971 */
[3240, 2970],
/* 2972 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(2893);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 2973 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(457),
	    LodashWrapper = __webpack_require__(458),
	    baseLodash = __webpack_require__(466),
	    isArray = __webpack_require__(91),
	    isObjectLike = __webpack_require__(246),
	    wrapperClone = __webpack_require__(2953);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array of at least `200` elements
	 * and any iteratees accept only one argument. The heuristic for whether a
	 * section qualifies for shortcut fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 2974 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(87);
	var invariant = __webpack_require__(21);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2975 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var RegExpPropType = __webpack_require__(2976);
	var escapeStringRegexp = __webpack_require__(1390);
	var blacklist = __webpack_require__(1247);
	var createReactClass = __webpack_require__(385);
	var PropTypes = __webpack_require__(4);
	
	function removeDiacritics(str, blacklist) {
	  if (!String.prototype.normalize) {
	    // Fall back to original string
	    return str;
	  }
	
	  if (!blacklist) {
	    // No blacklist, just remove all
	    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	  }
	  else {
	    var blacklistChars = blacklist.split('');
	
	    // Remove all diacritics that are not a part of a blacklisted character
	    // First char cannot be a diacritic
	    return str.normalize('NFD').replace(/.[\u0300-\u036f]+/g, function(m) {
	      return blacklistChars.indexOf(m.normalize()) > -1 ? m.normalize() : m[0];
	    });
	  }
	}
	
	var Highlighter = createReactClass({
	  displayName: 'Highlighter',
	  count: 0,
	  propTypes: {
	    search: PropTypes.oneOfType([
	      PropTypes.string,
	      PropTypes.number,
	      PropTypes.bool,
	      RegExpPropType
	    ]).isRequired,
	    caseSensitive: PropTypes.bool,
	    ignoreDiacritics: PropTypes.bool,
	    diacriticsBlacklist: PropTypes.string,
	    matchElement: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	    matchClass: PropTypes.string,
	    matchStyle: PropTypes.object
	  },
	
	  render: function() {
	    var props = blacklist(
	      this.props,
	      'search',
	      'caseSensitive',
	      'ignoreDiacritics',
	      'diacriticsBlacklist',
	      'matchElement',
	      'matchClass',
	      'matchStyle'
	    );
	
	    return React.createElement('span', props, this.renderElement(this.props.children));
	  },
	
	  /**
	   * A wrapper to the highlight method to determine when the highlighting
	   * process should occur.
	   *
	   * @param  {string} subject
	   *   The body of text that will be searched for highlighted words.
	   *
	   * @return {Array}
	   *   An array of ReactElements
	   */
	  renderElement: function(subject) {
	    if (this.isScalar() && this.hasSearch()) {
	      var search = this.getSearch();
	      return this.highlightChildren(subject, search);
	    }
	
	    return this.props.children;
	  },
	
	  /**
	   * Determine if props are valid types for processing.
	   *
	   * @return {Boolean}
	   */
	  isScalar: function() {
	    return (/string|number|boolean/).test(typeof this.props.children);
	  },
	
	  /**
	   * Determine if required search prop is defined and valid.
	   *
	   * @return {Boolean}
	   */
	  hasSearch: function() {
	    return (typeof this.props.search !== 'undefined') && this.props.search;
	  },
	
	  /**
	   * Get the search prop, but always in the form of a regular expression. Use
	   * this as a proxy to this.props.search for consistency.
	   *
	   * @return {RegExp}
	   */
	  getSearch: function() {
	    if (this.props.search instanceof RegExp) {
	      return this.props.search;
	    }
	
	    var flags = '';
	    if (!this.props.caseSensitive) {
	      flags +='i';
	    }
	
	    var search = this.props.search;
	    if (typeof this.props.search === 'string') {
	      search = escapeStringRegexp(search);
	    }
	
	    if (this.props.ignoreDiacritics) {
	      search = removeDiacritics(search, this.props.diacriticsBlacklist);
	    }
	
	    return new RegExp(search, flags);
	  },
	
	  /**
	   * Get the indexes of the first and last characters of the matched string.
	   *
	   * @param  {string} subject
	   *   The string to search against.
	   *
	   * @param  {RegExp} search
	   *   The regex search query.
	   *
	   * @return {Object}
	   *   An object consisting of "first" and "last" properties representing the
	   *   indexes of the first and last characters of a matching string.
	   */
	  getMatchBoundaries: function(subject, search) {
	    var matches = search.exec(subject);
	    if (matches) {
	      return {
	        first: matches.index,
	        last: matches.index + matches[0].length
	      };
	    }
	  },
	
	  /**
	   * Determines which strings of text should be highlighted or not.
	   *
	   * @param  {string} subject
	   *   The body of text that will be searched for highlighted words.
	   * @param  {string} search
	   *   The search used to search for highlighted words.
	   *
	   * @return {Array}
	   *   An array of ReactElements
	   */
	  highlightChildren: function(subject, search) {
	    var children = [];
	    var remaining = subject;
	
	    while (remaining) {
	      var remainingCleaned = (this.props.ignoreDiacritics
	        ? removeDiacritics(remaining, this.props.diacriticsBlacklist)
	        : remaining
	      );
	
	      if (!search.test(remainingCleaned)) {
	        children.push(this.renderPlain(remaining));
	        return children;
	      }
	
	      var boundaries = this.getMatchBoundaries(remainingCleaned, search);
	
	      if (boundaries.first === 0 && boundaries.last === 0) {
	        // Regex zero-width match
	        return children;
	      }
	
	      // Capture the string that leads up to a match...
	      var nonMatch = remaining.slice(0, boundaries.first);
	      if (nonMatch) {
	        children.push(this.renderPlain(nonMatch));
	      }
	
	      // Now, capture the matching string...
	      var match = remaining.slice(boundaries.first, boundaries.last);
	      if (match) {
	        children.push(this.renderHighlight(match));
	      }
	
	      // And if there's anything left over, recursively run this method again.
	      remaining = remaining.slice(boundaries.last);
	
	    }
	
	    return children;
	  },
	
	  /**
	   * Responsible for rending a non-highlighted element.
	   *
	   * @param  {string} string
	   *   A string value to wrap an element around.
	   *
	   * @return {ReactElement}
	   */
	  renderPlain: function(string) {
	    this.count++;
	    return React.createElement('span', { key: this.count, children: string });
	  },
	
	  /**
	   * Responsible for rending a highlighted element.
	   *
	   * @param  {string} string
	   *   A string value to wrap an element around.
	   *
	   * @return {ReactElement}
	   */
	  renderHighlight: function(string) {
	    this.count++;
	    return React.createElement(this.props.matchElement, {
	      key: this.count,
	      className: this.props.matchClass,
	      style: this.props.matchStyle,
	      children: string
	    });
	  }
	});
	
	Highlighter.defaultProps = {
	  caseSensitive: false,
	  ignoreDiacritics: false,
	  diacriticsBlacklist: '',
	  matchElement: 'mark',
	  matchClass: 'highlight',
	  matchStyle: {}
	};
	
	module.exports = Highlighter;


/***/ },
/* 2976 */
/***/ function(module, exports) {

	var regExpPropType = function (props, propName, componentName, location) {
	  if (!(props[propName] instanceof RegExp)) {
	    var propType = typeof props[propName];
	
	    return new Error(
	      ("Invalid " + location + " `" + propName + "` of type `" + propType + "` ") +
	        ("supplied to `" + componentName + "`, expected `RegExp`.")
	    );
	  }
	};
	
	module.exports = regExpPropType;


/***/ },
/* 2977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2979);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _format = __webpack_require__(1353);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * React Idle Timer
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Randy Lebeau
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @class   IdleTimer
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var IdleTimer = function (_Component) {
	  _inherits(IdleTimer, _Component);
	
	  function IdleTimer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IdleTimer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(IdleTimer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      idle: false,
	      oldDate: +new Date(),
	      lastActive: +new Date(),
	      remaining: null,
	      pageX: null,
	      pageY: null
	    }, _this.tId = null, _this._handleEvent = function (e) {
	
	      // Already idle, ignore events
	      if (_this.state.remaining) return;
	
	      // Mousemove event
	      if (e.type === 'mousemove') {
	        // if coord are same, it didn't move
	        if (e.pageX === _this.state.pageX && e.pageY === _this.state.pageY) return;
	        // if coord don't exist how could it move
	        if (typeof e.pageX === 'undefined' && typeof e.pageY === 'undefined') return;
	        // under 200 ms is hard to do, and you would have to stop, as continuous activity will bypass this
	        var elapsed = _this.getElapsedTime();
	        if (elapsed < 200) return;
	      }
	
	      // clear any existing timeout
	      clearTimeout(_this.tId
	
	      // if the idle timer is enabled, flip
	      );if (_this.state.idle) {
	        _this._toggleIdleState(e);
	      }
	
	      _this.setState({
	        lastActive: +new Date(), // store when user was last active
	        pageX: e.pageX, // update mouse coord
	        pageY: e.pageY
	      });
	
	      _this.tId = setTimeout(_this._toggleIdleState.bind(_this), _this.props.timeout // set a new timeout
	
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(IdleTimer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.props.events.forEach(function (e) {
	        return _this2.props.element.addEventListener(e, _this2._handleEvent);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.startOnLoad) {
	        this.reset();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      // Clear timeout to prevent delayed state changes
	      clearTimeout(this.tId);
	      // Unbind all events
	      this.props.events.forEach(function (e) {
	        return _this3.props.element.removeEventListener(e, _this3._handleEvent);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children ? this.props.children : null;
	    }
	
	    /////////////////////
	    // Private Methods //
	    /////////////////////
	
	    /**
	     * Toggles the idle state and calls the proper action
	     *
	     * @return {void}
	     *
	     */
	
	  }, {
	    key: '_toggleIdleState',
	    value: function _toggleIdleState() {
	      // Set the state
	      this.setState({
	        idle: !this.state.idle
	      });
	
	      // Fire the appropriate action
	      if (!this.state.idle) this.props.activeAction();else this.props.idleAction();
	    }
	
	    /**
	     * Event handler for supported event types
	     *
	     * @param  {Object} e event object
	     * @return {void}
	     *
	     */
	
	  }, {
	    key: 'reset',
	
	
	    ////////////////
	    // Public API //
	    ////////////////
	
	    /**
	     * Restore initial settings and restart timer
	     *
	     * @return {Void}
	     *
	     */
	
	    value: function reset() {
	      // reset timers
	      clearTimeout(this.tId);
	
	      // reset settings
	      this.setState({
	        idle: false,
	        oldDate: +new Date(),
	        lastActive: this.state.oldDate,
	        remaining: null
	      });
	
	      // Set timeout
	      this.tId = setTimeout(this._toggleIdleState.bind(this), this.props.timeout);
	    }
	
	    /**
	     * Store remaining time and stop timer.
	     * You can pause from idle or active state.
	     *
	     * @return {Void}
	     *
	     */
	
	  }, {
	    key: 'pause',
	    value: function pause() {
	      // this is already paused
	      if (this.state.remaining !== null) {
	        return;
	      }
	
	      console.log('pausing');
	
	      // clear any existing timeout
	      clearTimeout(this.tId
	
	      // define how much is left on the timer
	      );this.setState({
	        remaining: this.getRemainingTime()
	      });
	    }
	
	    /**
	     * Resumes a stopped timer
	     *
	     * @return {Void}
	     *
	     */
	
	  }, {
	    key: 'resume',
	    value: function resume() {
	      // this isn't paused yet
	      if (this.state.remaining === null) {
	        return;
	      }
	
	      // start timer and clear remaining
	      if (!this.state.idle) {
	        this.setState({
	          remaining: null
	        });
	        // Set a new timeout
	        this.tId = setTimeout(this._toggleIdleState.bind(this), this.state.remaining);
	      }
	    }
	
	    /**
	     * Time remaining before idle
	     *
	     * @return {Number} Milliseconds remaining
	     *
	     */
	
	  }, {
	    key: 'getRemainingTime',
	    value: function getRemainingTime() {
	      // If idle there is no time remaining
	      if (this.state.idle) {
	        return 0;
	      }
	
	      // If its paused just return that
	      if (this.state.remaining !== null) {
	        return this.state.remaining;
	      }
	
	      // Determine remaining, if negative idle didn't finish flipping, just return 0
	      var remaining = this.props.timeout - (+new Date() - this.state.lastActive);
	      if (remaining < 0) {
	        remaining = 0;
	      }
	
	      // If this is paused return that number, else return current remaining
	      return remaining;
	    }
	
	    /**
	     * How much time has elapsed
	     *
	     * @return {Timestamp}
	     *
	     */
	
	  }, {
	    key: 'getElapsedTime',
	    value: function getElapsedTime() {
	      return +new Date() - this.state.oldDate;
	    }
	
	    /**
	     * Last time the user was active
	     *
	     * @return {Timestamp}
	     *
	     */
	
	  }, {
	    key: 'getLastActiveTime',
	    value: function getLastActiveTime() {
	      if (this.props.format) {
	        return (0, _format2.default)(this.state.lastActive, this.props.format);
	      }
	      return this.state.lastActive;
	    }
	
	    /**
	     * Is the user idle
	     *
	     * @return {Boolean}
	     *
	     */
	
	  }, {
	    key: 'isIdle',
	    value: function isIdle() {
	      return this.state.idle;
	    }
	  }]);
	
	  return IdleTimer;
	}(_react.Component);
	
	IdleTimer.propTypes = {
	  timeout: _propTypes2.default.number, // Activity timeout
	  events: _propTypes2.default.arrayOf(_propTypes2.default.string), // Activity events to bind
	  idleAction: _propTypes2.default.func, // Action to call when user becomes inactive
	  activeAction: _propTypes2.default.func, // Action to call when user becomes active
	  element: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]), // Element ref to watch activty on
	  format: _propTypes2.default.string,
	  startOnLoad: _propTypes2.default.bool
	};
	IdleTimer.defaultProps = {
	  timeout: 1000 * 60 * 20, // 20 minutes
	  events: ['mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mouseWheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove'],
	  idleAction: function idleAction() {},
	  activeAction: function activeAction() {},
	  element: (typeof window === 'undefined' ? 'undefined' : typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' ? document : {},
	  startOnLoad: true
	};
	exports.default = IdleTimer;

/***/ },
/* 2978 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.6.1
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(39),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
	60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
	function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
	J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
	function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
	function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
	function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
	var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,Suspense:z,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;
	if(null!=b){void 0!==b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},isValidElement:O,version:"16.6.3",
	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,assign:k}};X.unstable_ConcurrentMode=x;X.unstable_Profiler=u;var Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 2979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2978);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(4);
	var createClass = __webpack_require__(385);
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var AutosizeInput = createClass({
		propTypes: {
			className: PropTypes.string, // className for the outer element
			defaultValue: PropTypes.any, // default field value
			inputClassName: PropTypes.string, // className for the input element
			inputRef: PropTypes.func, // ref callback for the input element
			inputStyle: PropTypes.object, // css styles for the input element
			minWidth: PropTypes.oneOfType([// minimum width for input element
			PropTypes.number, PropTypes.string]),
			onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
			onChange: PropTypes.func, // onChange handler: function(newValue) {}
			placeholder: PropTypes.string, // placeholder text
			placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
			style: PropTypes.object, // css styles for the outer element
			value: PropTypes.any },
		// field value
		getDefaultProps: function getDefaultProps() {
			return {
				minWidth: 1
			};
		},
		getInitialState: function getInitialState() {
			return {
				inputWidth: this.props.minWidth,
				inputId: '_' + Math.random().toString(36).substr(2, 12)
			};
		},
		componentDidMount: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		},
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		},
		componentWillUnmount: function componentWillUnmount() {
			this.mounted = false;
		},
		inputRef: function inputRef(el) {
			this.input = el;
			if (typeof this.props.inputRef === 'function') {
				this.props.inputRef(el);
			}
		},
		placeHolderSizerRef: function placeHolderSizerRef(el) {
			this.placeHolderSizer = el;
		},
		sizerRef: function sizerRef(el) {
			this.sizer = el;
		},
		copyInputStyles: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyle = this.input && window.getComputedStyle(this.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			widthNode.style.textTransform = inputStyle.textTransform;
			if (this.props.placeholder) {
				var placeholderNode = this.placeHolderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				placeholderNode.style.textTransform = inputStyle.textTransform;
			}
		},
		updateInputWidth: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = undefined;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		},
		getInput: function getInput() {
			return this.input;
		},
		focus: function focus() {
			this.input.focus();
		},
		blur: function blur() {
			this.input.blur();
		},
		select: function select() {
			this.input.select();
		},
		render: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});
	
			var wrapperStyle = this.props.style || {};
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';
			var inputProps = _extends({}, this.props);
			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.onAutosize;
			delete inputProps.placeholderIsMinWidth;
			delete inputProps.inputRef;
			return React.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				React.createElement('style', { dangerouslySetInnerHTML: {
						__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
					} }),
				React.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
				React.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? React.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	});
	
	module.exports = AutosizeInput;

/***/ },
/* 2981 */
/***/ function(module, exports) {

	/** @license React v16.6.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
	60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
	exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};


/***/ },
/* 2982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(2983);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },
/* 2983 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 2984 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.ReactRecaptcha=t(require("react")):e.ReactRecaptcha=t(e.React)}(this,function(e){return function(e){function t(r){if(a[r])return a[r].exports;var n=a[r]={exports:{},id:r,loaded:!1};return e[r].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var a={};return t.m=e,t.c=a,t.p="",t(0)}([function(e,t,a){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var a=0;a<t.length;a++){var r=t[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,a,r){return a&&e(t.prototype,a),r&&e(t,r),t}}(),s=a(6),c=r(s),p=a(4),u=r(p),d={className:u.default.string,onloadCallbackName:u.default.string,elementID:u.default.string,onloadCallback:u.default.func,verifyCallback:u.default.func,expiredCallback:u.default.func,render:u.default.oneOf(["onload","explicit"]),sitekey:u.default.string,theme:u.default.oneOf(["light","dark"]),type:u.default.string,verifyCallbackName:u.default.string,expiredCallbackName:u.default.string,size:u.default.oneOf(["invisible","compact","normal"]),tabindex:u.default.string,hl:u.default.string,badge:u.default.oneOf(["bottomright","bottomleft","inline"])},f={elementID:"g-recaptcha",className:"g-recaptcha",onloadCallback:void 0,onloadCallbackName:"onloadCallback",verifyCallback:void 0,verifyCallbackName:"verifyCallback",expiredCallback:void 0,expiredCallbackName:"expiredCallback",render:"onload",theme:"light",type:"image",size:"normal",tabindex:"0",hl:"en",badge:"bottomright"},h=function(){return"undefined"!=typeof window&&"undefined"!=typeof window.grecaptcha&&"function"==typeof window.grecaptcha.render},y=void 0,b=function(e){function t(e){n(this,t);var a=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return a._renderGrecaptcha=a._renderGrecaptcha.bind(a),a.reset=a.reset.bind(a),a.state={ready:h(),widget:null},a.state.ready||"undefined"==typeof window||(y=setInterval(a._updateReadyState.bind(a),1e3)),a}return i(t,e),l(t,[{key:"componentDidMount",value:function(){this.state.ready&&this._renderGrecaptcha()}},{key:"componentDidUpdate",value:function(e,t){var a=this.props,r=a.render,n=a.onloadCallback;"explicit"===r&&n&&this.state.ready&&!t.ready&&this._renderGrecaptcha()}},{key:"componentWillUnmount",value:function(){clearInterval(y)}},{key:"reset",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.reset(a)}},{key:"execute",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.execute(a)}},{key:"_updateReadyState",value:function(){h()&&(this.setState({ready:!0}),clearInterval(y))}},{key:"_renderGrecaptcha",value:function(){this.state.widget=grecaptcha.render(this.props.elementID,{sitekey:this.props.sitekey,callback:this.props.verifyCallback?this.props.verifyCallback:void 0,theme:this.props.theme,type:this.props.type,size:this.props.size,tabindex:this.props.tabindex,hl:this.props.hl,badge:this.props.badge,"expired-callback":this.props.expiredCallback?this.props.expiredCallback:void 0}),this.props.onloadCallback&&this.props.onloadCallback()}},{key:"render",value:function(){return"explicit"===this.props.render&&this.props.onloadCallback?c.default.createElement("div",{id:this.props.elementID,"data-onloadcallbackname":this.props.onloadCallbackName,"data-verifycallbackname":this.props.verifyCallbackName}):c.default.createElement("div",{id:this.props.elementID,className:this.props.className,"data-sitekey":this.props.sitekey,"data-theme":this.props.theme,"data-type":this.props.type,"data-size":this.props.size,"data-badge":this.props.badge,"data-tabindex":this.props.tabindex})}}]),t}(s.Component);t.default=b,b.propTypes=d,b.defaultProps=f,e.exports=t.default},function(e,t){"use strict";function a(e){return function(){return e}}var r=function(){};r.thatReturns=a,r.thatReturnsFalse=a(!1),r.thatReturnsTrue=a(!0),r.thatReturnsNull=a(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,a){"use strict";function r(e,t,a,r,o,i,l,s){if(n(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var p=[a,r,o,i,l,s],u=0;c=new Error(t.replace(/%s/g,function(){return p[u++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var n=function(e){};e.exports=r},function(e,t,a){"use strict";var r=a(1),n=a(2),o=a(5);e.exports=function(){function e(e,t,a,r,i,l){l!==o&&n(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var a={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return a.checkPropTypes=r,a.PropTypes=a,a}},function(e,t,a){e.exports=a(3)()},function(e,t){"use strict";var a="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=a},function(t,a){t.exports=e}])});

/***/ },
/* 2985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(956));
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PropTypes = __webpack_require__(954);
	
	var _warning = _interopRequireDefault(__webpack_require__(474));
	
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ },
/* 2986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(475));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(476));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(952));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(2994));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(2987));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(2988));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(2989));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(2990));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ },
/* 2987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(501);
	
	var _wrapMapToProps = __webpack_require__(953);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ },
/* 2988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(953);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ },
/* 2989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(475));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(955));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ },
/* 2990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(476));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(2991));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 2991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(100);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(474));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 2992 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 2993 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 2994 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 2995 */
1033,
/* 2996 */
/***/ function(module, exports) {

	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
	
	          if (desc.get || desc.set) {
	            Object.defineProperty(newObj, key, desc);
	          } else {
	            newObj[key] = obj[key];
	          }
	        }
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 2997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(473);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
	        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 2998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(3134);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _lodash = __webpack_require__(622);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(624);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };
	
	var styles = {
	  position: 'absolute',
	  width: 0,
	  height: 0,
	  visibility: 'hidden',
	  display: 'none'
	};
	
	var ResizeDetector = function (_PureComponent) {
	  _inherits(ResizeDetector, _PureComponent);
	
	  function ResizeDetector(props) {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));
	
	    _this.createResizeObserver = function (entries) {
	      var _this$props = _this.props,
	          handleWidth = _this$props.handleWidth,
	          handleHeight = _this$props.handleHeight,
	          onResize = _this$props.onResize;
	
	      entries.forEach(function (entry) {
	        var _entry$contentRect = entry.contentRect,
	            width = _entry$contentRect.width,
	            height = _entry$contentRect.height;
	
	        var notifyWidth = handleWidth && _this.width !== width;
	        var notifyHeight = handleHeight && _this.height !== height;
	        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
	          onResize(width, height);
	        }
	        _this.width = width;
	        _this.height = height;
	        _this.skipOnMount = false;
	      });
	    };
	
	    var skipOnMount = props.skipOnMount,
	        refreshMode = props.refreshMode,
	        refreshRate = props.refreshRate;
	
	
	    _this.width = undefined;
	    _this.height = undefined;
	    _this.skipOnMount = skipOnMount;
	
	    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;
	
	    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.observe(resizableElement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.unobserve(resizableElement);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('div', {
	        style: styles,
	        ref: function ref(el) {
	          _this2.el = el;
	        }
	      });
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.PureComponent);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  skipOnMount: _propTypes2.default.bool,
	  refreshRate: _propTypes2.default.number,
	  refreshMode: _propTypes2.default.string,
	  resizableElementId: _propTypes2.default.string,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  skipOnMount: false,
	  refreshRate: 1000,
	  refreshMode: undefined,
	  resizableElementId: '',
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ },
/* 2999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(2998);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ },
/* 3000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(959);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(176);
	
	var _Router = __webpack_require__(477);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 3001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(959);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(176);
	
	var _Router = __webpack_require__(477);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createHashHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(["hashbang", "noslash", "slash"]),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 3002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(962);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 3003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(958);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(957);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref["aria-current"],
	      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);
	
	  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;
	
	  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
	  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
	
	  return _react2.default.createElement(_Route2.default, {
	    path: escapedPath,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(" ") : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        "aria-current": isActive && ariaCurrent || null
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  "aria-current": _propTypes2.default.oneOf(["page", "step", "location", "date", "time", "true"])
	};
	
	NavLink.defaultProps = {
	  activeClassName: "active",
	  "aria-current": "page"
	};
	
	exports.default = NavLink;

/***/ },
/* 3004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(963);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 3005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(964);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 3006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(965);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 3007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(966);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 3008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _generatePath = __webpack_require__(479);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _generatePath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 3009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(335);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 3010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(968);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 3011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(967);
	
	var _reducer = __webpack_require__(961);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectedRouter = function (_Component) {
	  _inherits(ConnectedRouter, _Component);
	
	  function ConnectedRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConnectedRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
	      _this.store.dispatch({
	        type: _reducer.LOCATION_CHANGE,
	        payload: location
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        propsStore = _props.store,
	        history = _props.history;
	
	    this.store = propsStore || this.context.store;
	
	    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
	    this.handleLocationChange(history.location);
	  };
	
	  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
	  };
	
	  ConnectedRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, this.props);
	  };
	
	  return ConnectedRouter;
	}(_react.Component);
	
	ConnectedRouter.propTypes = {
	  store: _react.PropTypes.object,
	  history: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	ConnectedRouter.contextTypes = {
	  store: _react.PropTypes.object
	};
	exports.default = ConnectedRouter;

/***/ },
/* 3012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerMiddleware;
	
	var _actions = __webpack_require__(960);
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, args);
	      };
	    };
	  };
	}

/***/ },
/* 3013 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(3015).enable();
	  window.Promise = __webpack_require__(3014);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(3016);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(39);


/***/ },
/* 3014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(969);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 3015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(969);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 3016 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 3017 */
[3244, 970, 971, 336],
/* 3018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  function Dropdown() {
	    _classCallCheck(this, Dropdown);
	
	    return _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
	  }
	
	  _createClass(Dropdown, [{
	    key: 'render',
	    value: function render() {
	      // This component adds no markup
	      return this.props.children;
	    }
	  }]);
	
	  return Dropdown;
	}(_react2.default.Component);
	
	;
	
	Dropdown.propTypes = {
	  children: _propTypes2.default.node
	};
	
	exports.default = Dropdown;

/***/ },
/* 3019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OptionGroup = function (_React$Component) {
		_inherits(OptionGroup, _React$Component);
	
		function OptionGroup(props) {
			_classCallCheck(this, OptionGroup);
	
			var _this = _possibleConstructorReturn(this, (OptionGroup.__proto__ || Object.getPrototypeOf(OptionGroup)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(OptionGroup, [{
			key: 'blockEvent',
			value: function blockEvent(event) {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.tagName !== 'A' || !('href' in event.target)) {
					return;
				}
				if (event.target.target) {
					window.open(event.target.href, event.target.target);
				} else {
					window.location.href = event.target.href;
				}
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var option = this.props.option;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: this.blockEvent,
						onClick: this.blockEvent },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						title: option.title },
					_react2.default.createElement(
						'div',
						{ className: 'Select-option-group-label' },
						this.props.label
					),
					this.props.children
				);
			}
		}]);
	
		return OptionGroup;
	}(_react2.default.Component);
	
	;
	
	OptionGroup.propTypes = {
		children: _propTypes2.default.any,
		className: _propTypes2.default.string, // className (based on mouse position)
		label: _propTypes2.default.node, // the heading to show above the child options
		option: _propTypes2.default.object.isRequired // object that is base for that option group
	};
	
	exports.default = OptionGroup;

/***/ },
/* 3020 */
[3246, 336, 970, 3017, 971, 973, 972, 481, 974, 975, 480],
/* 3021 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 3022 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 3023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 3024 */
[3244, 977, 978, 337],
/* 3025 */
3021,
/* 3026 */
3022,
/* 3027 */
3023,
/* 3028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(988);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _AnimateGroupChild = _interopRequireDefault(__webpack_require__(3029));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function AnimateGroup(props) {
	  var component = props.component,
	      children = props.children,
	      appear = props.appear,
	      enter = props.enter,
	      leave = props.leave;
	  return _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: component
	  }, _react.Children.map(children, function (child, index) {
	    return _react.default.createElement(_AnimateGroupChild.default, {
	      appearOptions: appear,
	      enterOptions: enter,
	      leaveOptions: leave,
	      key: "child-".concat(index)
	    }, child);
	  }));
	}
	
	AnimateGroup.propTypes = {
	  appear: _propTypes.default.object,
	  enter: _propTypes.default.object,
	  leave: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.element]),
	  component: _propTypes.default.any
	};
	AnimateGroup.defaultProps = {
	  component: 'span'
	};
	var _default = AnimateGroup;
	exports.default = _default;

/***/ },
/* 3029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(294));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(988);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Animate = _interopRequireDefault(__webpack_require__(984));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var steps = options.steps,
	      duration = options.duration;
	
	  if (steps && steps.length) {
	    return steps.reduce(function (result, entry) {
	      return result + ((0, _isNumber2.default)(entry.duration) && entry.duration > 0 ? entry.duration : 0);
	    }, 0);
	  }
	
	  if ((0, _isNumber2.default)(duration)) {
	    return duration;
	  }
	
	  return 0;
	};
	
	var AnimateGroupChild =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimateGroupChild)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isActive: false
	    };
	
	    _this.handleEnter = function (node, isAppearing) {
	      var _this$props = _this.props,
	          appearOptions = _this$props.appearOptions,
	          enterOptions = _this$props.enterOptions;
	
	      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
	    };
	
	    _this.handleExit = function () {
	      _this.handleStyleActive(_this.props.leaveOptions);
	    };
	
	    return _this;
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: "handleStyleActive",
	    value: function handleStyleActive(style) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	        } : null;
	        this.setState(_objectSpread({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      }
	    }
	  }, {
	    key: "parseTimeout",
	    value: function parseTimeout() {
	      var _this$props2 = this.props,
	          appearOptions = _this$props2.appearOptions,
	          enterOptions = _this$props2.enterOptions,
	          leaveOptions = _this$props2.leaveOptions;
	      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          appearOptions = _this$props3.appearOptions,
	          enterOptions = _this$props3.enterOptions,
	          leaveOptions = _this$props3.leaveOptions,
	          props = _objectWithoutProperties(_this$props3, ["children", "appearOptions", "enterOptions", "leaveOptions"]);
	
	      return _react.default.createElement(_reactTransitionGroup.Transition, _extends({}, props, {
	        onEnter: this.handleEnter,
	        onExit: this.handleExit,
	        timeout: this.parseTimeout()
	      }), function () {
	        return _react.default.createElement(_Animate.default, _this2.state, _react.Children.only(children));
	      });
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component);
	
	AnimateGroupChild.propTypes = {
	  appearOptions: _propTypes.default.object,
	  enterOptions: _propTypes.default.object,
	  leaveOptions: _propTypes.default.object,
	  children: _propTypes.default.element
	};
	var _default = AnimateGroupChild;
	exports.default = _default;

/***/ },
/* 3030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAnimateManager;
	
	var _setRafTimeout = _interopRequireDefault(__webpack_require__(3033));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function createAnimateManager() {
	  var currStyle = {};
	
	  var handleChange = function handleChange() {
	    return null;
	  };
	
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout.default)(setStyle.bind(null, restStyles), curr);
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if (_typeof(_style) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ },
/* 3031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	exports.default = void 0;
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(126));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (_typeof(objA) !== 'object' || objA === null || _typeof(objB) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	
	  for (var i = 0; i < keysA.length; i++) {
	    var keyA = keysA[i];
	
	    if (objA[keyA] === objB[keyA]) {
	      continue;
	    } // special diff with Array or Object
	
	
	    if ((0, _isArray2.default)(objA[keyA])) {
	      if (!(0, _isArray2.default)(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
	        return false;
	      } else if (!(0, _isEqual2.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if ((0, _isPlainObject2.default)(objA[keyA])) {
	      if (!(0, _isPlainObject2.default)(objB[keyA]) || !(0, _isEqual2.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	function shouldComponentUpdate(nextProps, nextState) {
	  return shallowCompare(this, nextProps, nextState);
	}
	/* eslint-disable no-param-reassign */
	
	
	function pureRenderDecorator(component) {
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}
	
	var _default = pureRenderDecorator;
	exports.default = _default;

/***/ },
/* 3032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _filter2 = _interopRequireDefault(__webpack_require__(61));
	
	var _raf = _interopRequireWildcard(__webpack_require__(310));
	
	var _util = __webpack_require__(338);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	
	
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _objectSpread({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _objectSpread({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	}; // configure update function
	
	
	var _default = function _default(from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime;
	  var beginTime;
	
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter2.default)(stepperStyle, needContinue).length;
	  }; // stepper timing function like spring
	
	
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	    stepperStyle = calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, getCurrStyle(stepperStyle)));
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf.default)(update);
	    }
	  }; // t => val timing function like cubic-bezier
	
	
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(void 0, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(void 0, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	      render(_objectSpread({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method
	
	  return function () {
	    (0, _raf.default)(update); // return stop animation method
	
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};
	
	exports.default = _default;

/***/ },
/* 3033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = _interopRequireDefault(__webpack_require__(310));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf.default)(shouldUpdate);
	}

/***/ },
/* 3034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(4));
	
	var _addClass = _interopRequireDefault(__webpack_require__(586));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(588));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(986));
	
	var _PropTypes = __webpack_require__(989);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 3035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(17);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(987));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 3036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 3037 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(2771);
	var EventPluginUtils = __webpack_require__(314);
	var EventPropagators = __webpack_require__(197);
	var SyntheticUIEvent = __webpack_require__(199);
	var TouchEventUtils = __webpack_require__(3038);
	var ViewportMetrics = __webpack_require__(449);
	
	var keyOf = __webpack_require__(1465);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    'topTouchCancel',
	    'topTouchEnd',
	    'topTouchStart',
	    'topTouchMove'
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  'topTouchStart',
	  'topTouchCancel',
	  'topTouchEnd',
	  'topTouchMove',
	];
	
	var dependencies = [
	  'topMouseDown',
	  'topMouseMove',
	  'topMouseUp',
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ },
/* 3038 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ },
/* 3039 */
/***/ function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ },
/* 3040 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(21);
	var defaultClickRejectionStrategy = __webpack_require__(3039);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(196).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(3037)(shouldRejectClick)
	  });
	};


/***/ },
/* 3041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @class Portal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @description a portal element that puts the tooltip contents at the top of the document tree, outside the react app
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var instanceCounter = 0;
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
	
	    _this.portalElement = null;
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // generate a unique ID
	      instanceCounter += 1;
	      var portalId = 'react-tooltip-lite-instace-' + instanceCounter;
	
	      var el = document.getElementById(portalId);
	
	      // add the div to the body if not there.
	      if (!el) {
	        el = document.createElement('div');
	        el.id = portalId;
	        document.body.appendChild(el);
	      }
	
	      this.portalElement = el;
	      this.componentDidUpdate();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      _reactDom2.default.render(_react2.default.createElement(
	        'div',
	        { className: this.props.className },
	        this.props.children
	      ), this.portalElement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.body.removeChild(this.portalElement);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _react.PropTypes.node.isRequired
	};
	exports.default = Portal;

/***/ },
/* 3042 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDirection;
	/**
	 * Checks the intended tip direction and falls back if not enough space
	 */
	
	function checkLeftRightWidthSufficient(tip, target, distance, bodyPadding) {
	  var targetRect = target.getBoundingClientRect();
	  var deadSpace = Math.min(targetRect.left, document.documentElement.clientWidth - targetRect.right);
	
	  return tip.offsetWidth + target.offsetWidth + distance + bodyPadding + deadSpace < document.documentElement.clientWidth;
	}
	
	function checkHalfHeightVisible(target) {
	  var targetCenterFromWindow = target.getBoundingClientRect().top + Math.round(target.offsetHeight / 2);
	
	  return targetCenterFromWindow < window.innerHeight && targetCenterFromWindow > 0;
	}
	
	function getDirection(currentDirection, tip, target, distance, bodyPadding) {
	  // can't switch until target is rendered
	  if (!target) {
	    return currentDirection;
	  }
	
	  var targetRect = target.getBoundingClientRect();
	
	  switch (currentDirection) {
	    case 'right':
	      // if the window is not wide enough try top (which falls back to down)
	      if (!checkLeftRightWidthSufficient(tip, target, distance, bodyPadding) || !checkHalfHeightVisible(target)) {
	        return getDirection('up', tip, target, distance, bodyPadding);
	      }
	
	      if (document.documentElement.clientWidth - targetRect.right < tip.offsetWidth + distance + bodyPadding) {
	        return 'left';
	      }
	
	      return 'right';
	
	    case 'left':
	      // if the window is not wide enough try top (which falls back to down)
	      if (!checkLeftRightWidthSufficient(tip, target, distance, bodyPadding) || !checkHalfHeightVisible(target)) {
	        return getDirection('up', tip, target, distance, bodyPadding);
	      }
	
	      if (targetRect.left < tip.offsetWidth + distance + bodyPadding) {
	        return 'right';
	      }
	
	      return 'left';
	
	    case 'up':
	      if (targetRect.top < tip.offsetHeight + distance + bodyPadding) {
	        return 'down';
	      }
	
	      return 'up';
	
	    case 'down':
	    default:
	      if (window.innerHeight - targetRect.bottom < tip.offsetHeight + distance + bodyPadding) {
	        return 'up';
	      }
	
	      return 'down';
	  }
	}

/***/ },
/* 3043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @file positions.js
	                                                                                                                                                                                                                                                                   * @description some functions for position calculation
	                                                                                                                                                                                                                                                                   */
	
	exports.default = positions;
	
	var _getDirection = __webpack_require__(3042);
	
	var _getDirection2 = _interopRequireDefault(_getDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @TODO: consider which of these should be props that can be passed
	var distance = 10;
	var bodyPadding = 10;
	var minArrowPadding = 5;
	var arrowSize = 10;
	
	/**
	 * cross browser scroll positions
	 */
	function getScrollTop() {
	  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	}
	
	function getScrollLeft() {
	  return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
	}
	
	/**
	 * Sets tip max width safely for mobile
	 */
	function getTipMaxWidth() {
	  return typeof document !== 'undefined' ? document.documentElement.clientWidth - bodyPadding * 2 : 1000;
	}
	
	/**
	 * Gets wrapper's left position for top/bottom tooltips as well as needed width restriction
	 */
	function getUpDownPosition(tip, target, state, direction) {
	  var left = -10000000;
	  var top = void 0;
	
	  if (tip && state.showTip) {
	    // get wrapper left position
	    var targetRect = target.getBoundingClientRect();
	    var targetLeft = targetRect.left + getScrollLeft();
	
	    var halfTargetWidth = Math.round(target.offsetWidth / 2);
	    var tipWidth = Math.min(getTipMaxWidth(), tip.offsetWidth);
	
	    // default is centered, but must be higher than body padding
	    left = Math.max(targetLeft + halfTargetWidth - Math.round(tipWidth / 2), bodyPadding + getScrollLeft());
	
	    // check for right overhang
	    var rightOverhang = left + tipWidth + bodyPadding - document.documentElement.clientWidth;
	    if (rightOverhang > 0) {
	      left -= rightOverhang;
	    }
	
	    if (direction === 'up') {
	      top = targetRect.top + getScrollTop() - (tip.offsetHeight + distance);
	    } else {
	      top = targetRect.bottom + getScrollTop() + distance;
	    }
	  }
	
	  return {
	    left: left,
	    top: top
	  };
	}
	
	/**
	 * gets top position for left/right arrows
	 */
	function getLeftRightPosition(tip, target, state, direction) {
	  var left = -10000000;
	  var top = 0;
	
	  if (tip && state.showTip) {
	    var scrollTop = getScrollTop();
	    var targetRect = target.getBoundingClientRect();
	    var targetTop = targetRect.top + scrollTop;
	    var halfTargetHeight = Math.round(target.offsetHeight / 2);
	
	    // default to middle, but don't go below body
	    top = Math.max(targetTop + halfTargetHeight - Math.round(tip.offsetHeight / 2), bodyPadding + scrollTop);
	
	    // make sure it doesn't go below the arrow
	    var arrowTop = targetTop + halfTargetHeight - arrowSize;
	    top = Math.min(top, arrowTop - minArrowPadding);
	
	    // check for bottom overhang
	    var bottomOverhang = top - scrollTop + tip.offsetHeight + bodyPadding - window.innerHeight;
	    if (bottomOverhang > 0) {
	      // try to add the body padding below the tip, but don't offset too far from the arrow
	      var arrowBottom = targetRect.top + scrollTop + halfTargetHeight + arrowSize;
	      top = Math.max(top - bottomOverhang, arrowBottom + minArrowPadding - tip.offsetHeight);
	    }
	
	    if (direction === 'right') {
	      left = targetRect.right + distance;
	    } else {
	      left = targetRect.left - distance - tip.offsetWidth;
	    }
	  }
	
	  return {
	    left: left,
	    top: top
	  };
	}
	
	/**
	 * sets the Arrow styles based on direction
	 */
	function getArrowStyles(target, tip, direction, state, props) {
	  if (!target) {
	    return {
	      top: '0',
	      left: '-10000000px'
	    };
	  }
	
	  var targetRect = target.getBoundingClientRect();
	  var halfTargetHeight = Math.round(target.offsetHeight / 2);
	  var halfTargetWidth = Math.round(target.offsetWidth / 2);
	  var scrollTop = getScrollTop();
	  var scrollLeft = getScrollLeft();
	
	  switch (direction) {
	    case 'right':
	      return {
	        top: state.showTip && tip ? targetRect.top + scrollTop + halfTargetHeight - arrowSize : '-10000000px',
	        left: targetRect.right + scrollLeft,
	        borderRight: props.background !== '' ? '10px solid ' + props.background : '',
	        borderTop: '10px solid transparent',
	        borderBottom: '10px solid transparent'
	      };
	
	    case 'left':
	      return {
	        top: state.showTip && tip ? targetRect.top + scrollTop + halfTargetHeight - arrowSize : '-10000000px',
	        left: targetRect.left + scrollLeft - distance - 1,
	        borderLeft: props.background !== '' ? '10px solid ' + props.background : '',
	        borderTop: '10px solid transparent',
	        borderBottom: '10px solid transparent'
	      };
	
	    case 'up':
	      return {
	        left: state.showTip && tip ? targetRect.left + scrollLeft + halfTargetWidth - arrowSize : '-10000000px',
	        top: targetRect.top + scrollTop - distance,
	        borderTop: props.background !== '' ? '10px solid ' + props.background : '',
	        borderLeft: '10px solid transparent',
	        borderRight: '10px solid transparent'
	      };
	
	    case 'down':
	    default:
	      return {
	        left: state.showTip && tip ? targetRect.left + scrollLeft + halfTargetWidth - arrowSize : '-10000000px',
	        top: targetRect.bottom + scrollTop,
	        borderBottom: props.background !== '' ? '10px solid ' + props.background : '',
	        borderLeft: '10px solid transparent',
	        borderRight: '10px solid transparent'
	      };
	  }
	}
	
	/**
	 * Returns the positions style rules
	 */
	function positions(direction, tip, target, state, props) {
	  var realDirection = (0, _getDirection2.default)(direction, tip, target, distance, bodyPadding);
	  var maxWidth = getTipMaxWidth();
	
	  var tipPosition = realDirection === 'up' || realDirection === 'down' ? getUpDownPosition(tip, target, state, realDirection) : getLeftRightPosition(tip, target, state, realDirection);
	
	  return {
	    tip: _extends({}, tipPosition, {
	      maxWidth: maxWidth
	    }),
	    arrow: getArrowStyles(target, tip, realDirection, state, props),
	    realDirection: realDirection
	  };
	}

/***/ },
/* 3044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 3045 */
444,
/* 3046 */
[3242, 249],
/* 3047 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(3046);
	var ReactElement = __webpack_require__(202);
	
	var emptyFunction = __webpack_require__(87);
	var traverseAllChildren = __webpack_require__(3056);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 3048 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(202);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 3049 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(202),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(863);
	
	module.exports = factory(isValidElement);

/***/ },
/* 3050 */
2803,
/* 3051 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(990),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(202),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(993);
	var factory = __webpack_require__(575);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 3052 */
2822,
/* 3053 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 3054 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 3055 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(249);
	
	var ReactElement = __webpack_require__(202);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 3056 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(249);
	
	var ReactCurrentOwner = __webpack_require__(113);
	var REACT_ELEMENT_TYPE = __webpack_require__(992);
	
	var getIteratorFn = __webpack_require__(3052);
	var invariant = __webpack_require__(21);
	var KeyEscapeUtils = __webpack_require__(3045);
	var warning = __webpack_require__(34);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 3057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(581));
	
	var _utils = __webpack_require__(995);
	
	var _arithmetic = _interopRequireDefault(__webpack_require__(3059));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max; // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Decimal} roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Decimal} The step which is easy to understand between two ticks
	 */
	
	
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep.lte(0)) {
	    return new _decimal.default(0);
	  }
	
	  var digitCount = _arithmetic.default.getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	
	
	  var digitCountValue = new _decimal.default(10).pow(digitCount);
	  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
	
	  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
	  var amendStepRatio = new _decimal.default(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
	  var formatStep = amendStepRatio.mul(digitCountValue);
	  return allowDecimals ? formatStep : new _decimal.default(Math.ceil(formatStep));
	}
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	
	
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var step = 1; // calculate the middle value of ticks
	
	  var middle = new _decimal.default(value);
	
	  if (!middle.isint() && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = new _decimal.default(10).pow(_arithmetic.default.getDigitCount(value) - 1);
	      middle = new _decimal.default(Math.floor(middle.div(step).toNumber())).mul(step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = new _decimal.default(Math.floor(value));
	    }
	  } else if (value === 0) {
	    middle = new _decimal.default(Math.floor((tickCount - 1) / 2));
	  } else if (!allowDecimals) {
	    middle = new _decimal.default(Math.floor(value));
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return middle.add(new _decimal.default(n - middleIndex).mul(step)).toNumber();
	  }), _utils.range);
	  return fn(0, tickCount);
	}
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	
	
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // dirty hack (for recharts' test)
	  if (!Number.isFinite((max - min) / (tickCount - 1))) {
	    return {
	      step: new _decimal.default(0),
	      tickMin: new _decimal.default(0),
	      tickMax: new _decimal.default(0)
	    };
	  } // The step which is easy to understand between two ticks
	
	
	  var step = getFormatStep(new _decimal.default(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
	
	  var middle; // When 0 is inside the interval, 0 should be a tick
	
	  if (min <= 0 && max >= 0) {
	    middle = new _decimal.default(0);
	  } else {
	    // calculate the middle value
	    middle = new _decimal.default(min).add(max).div(2); // minus modulo value
	
	    middle = middle.sub(new _decimal.default(middle).mod(step));
	  }
	
	  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
	  var upCount = Math.ceil(new _decimal.default(max).sub(middle).div(step).toNumber());
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  }
	
	  if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: middle.sub(new _decimal.default(belowCount).mul(step)),
	    tickMax: middle.add(new _decimal.default(upCount).mul(step))
	  };
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks will be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return Infinity;
	    }))) : _toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return -Infinity;
	    })).concat([cormax]);
	
	    return min > max ? (0, _utils.reverse)(_values) : _values;
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  } // Get the step between two ticks
	
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic.default.rangeStep(tickMin, tickMax.add(new _decimal.default(0.1).mul(step)), step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return new _decimal.default(cormin).add(new _decimal.default(n).mul(step)).toNumber();
	  }), _utils.range);
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
	 * but the domain will be guaranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	
	  var values = _toConsumableArray(_arithmetic.default.rangeStep(new _decimal.default(cormin), new _decimal.default(cormax).sub(new _decimal.default(0.99).mul(step)), step)).concat([cormax]);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	exports.getNiceTickValues = getNiceTickValues;
	var getTickValues = (0, _utils.memoize)(getTickValuesFn);
	exports.getTickValues = getTickValues;
	var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);
	exports.getTickValuesFixedDomain = getTickValuesFixedDomain;

/***/ },
/* 3058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, "getNiceTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, "getTickValuesFixedDomain", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});
	
	var _getNiceTickValues = __webpack_require__(3057);

/***/ },
/* 3059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(581));
	
	var _utils = __webpack_require__(995);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	function getDigitCount(value) {
	  var result;
	
	  if (value === 0) {
	    result = 1;
	  } else {
	    result = Math.floor(new _decimal.default(value).abs().log(10).toNumber()) + 1;
	  }
	
	  return result;
	}
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Decimal} start 起点
	 * @param  {Decimal} end   终点，不包含该值
	 * @param  {Decimal} step  步长
	 * @return {Array}         若干数值
	 */
	
	
	function rangeStep(start, end, step) {
	  var num = new _decimal.default(start);
	  var result = [];
	
	  while (num.lt(end)) {
	    result.push(num.toNumber());
	    num = num.add(step);
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	
	
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	var _default = {
	  rangeStep: rangeStep,
	  getDigitCount: getDigitCount,
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};
	exports.default = _default;

/***/ },
/* 3060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _DataUtils = __webpack_require__(40);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianGrid = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(CartesianGrid, _Component);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianGrid).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: "renderHorizontal",
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	    value: function renderHorizontal(horizontalPoints) {
	      var _this = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          width = _this$props.width,
	          horizontal = _this$props.horizontal;
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this.constructor.renderLineItem(horizontal, props);
	      });
	      return _react.default.createElement("g", {
	        className: "recharts-cartesian-grid-horizontal"
	      }, items);
	    }
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: "renderVertical",
	    value: function renderVertical(verticalPoints) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          y = _this$props2.y,
	          height = _this$props2.height,
	          vertical = _this$props2.vertical;
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this2.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this2.constructor.renderLineItem(vertical, props);
	      });
	      return _react.default.createElement("g", {
	        className: "recharts-cartesian-grid-vertical"
	      }, items);
	    }
	    /**
	     * Draw vertical grid stripes filled by colors
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical stripes
	     */
	
	  }, {
	    key: "renderVerticalStripes",
	    value: function renderVerticalStripes(verticalPoints) {
	      var verticalFill = this.props.verticalFill;
	
	      if (!verticalFill || !verticalFill.length) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          fillOpacity = _this$props3.fillOpacity,
	          x = _this$props3.x,
	          y = _this$props3.y,
	          width = _this$props3.width,
	          height = _this$props3.height;
	      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (x !== verticalPointsUpdated[0]) {
	        verticalPointsUpdated.unshift(0);
	      }
	
	      var items = verticalPointsUpdated.map(function (entry, i) {
	        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
	
	        if (lineWidth <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % verticalFill.length;
	        return _react.default.createElement("rect", {
	          key: "react-".concat(i),
	          x: Math.round(entry + x - x),
	          y: y,
	          width: lineWidth,
	          height: height,
	          stroke: "none",
	          fill: verticalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react.default.createElement("g", {
	        className: "recharts-cartesian-gridstripes-vertical"
	      }, items);
	    }
	    /**
	     * Draw horizontal grid stripes filled by colors
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal stripes
	     */
	
	  }, {
	    key: "renderHorizontalStripes",
	    value: function renderHorizontalStripes(horizontalPoints) {
	      var horizontalFill = this.props.horizontalFill;
	
	      if (!horizontalFill || !horizontalFill.length) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          fillOpacity = _this$props4.fillOpacity,
	          x = _this$props4.x,
	          y = _this$props4.y,
	          width = _this$props4.width,
	          height = _this$props4.height;
	      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (y !== horizontalPointsUpdated[0]) {
	        horizontalPointsUpdated.unshift(0);
	      }
	
	      var items = horizontalPointsUpdated.map(function (entry, i) {
	        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
	
	        if (lineHeight <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % horizontalFill.length;
	        return _react.default.createElement("rect", {
	          key: "react-".concat(i),
	          y: Math.round(entry + y - y),
	          x: x,
	          height: lineHeight,
	          width: width,
	          stroke: "none",
	          fill: horizontalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react.default.createElement("g", {
	        className: "recharts-cartesian-gridstripes-horizontal"
	      }, items);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          fillOpacity = _this$props5.fillOpacity,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      return _react.default.createElement("rect", {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: "none",
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: "recharts-cartesian-grid-bg"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          horizontal = _this$props6.horizontal,
	          vertical = _this$props6.vertical,
	          horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator,
	          xAxis = _this$props6.xAxis,
	          yAxis = _this$props6.yAxis,
	          offset = _this$props6.offset,
	          chartWidth = _this$props6.chartWidth,
	          chartHeight = _this$props6.chartHeight;
	
	      if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0 || !(0, _DataUtils.isNumber)(x) || x !== +x || !(0, _DataUtils.isNumber)(y) || y !== +y) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          horizontalPoints = _this$props7.horizontalPoints,
	          verticalPoints = _this$props7.verticalPoints; // No horizontal points are specified
	
	      if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunction2.default)(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({
	          yAxis: yAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      } // No vertical points are specified
	
	
	      if ((!verticalPoints || !verticalPoints.length) && (0, _isFunction2.default)(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({
	          xAxis: xAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      }
	
	      return _react.default.createElement("g", {
	        className: "recharts-cartesian-grid"
	      }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
	    }
	  }], [{
	    key: "renderLineItem",
	    value: function renderLineItem(option, props) {
	      var lineItem;
	
	      if (_react.default.isValidElement(option)) {
	        lineItem = _react.default.cloneElement(option, props);
	      } else if ((0, _isFunction2.default)(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ["x1", "y1", "x2", "y2", "key"]);
	
	        lineItem = _react.default.createElement("line", _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: "none",
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.Component), _class2.displayName = 'CartesianGrid', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes.default.number,
	  y: _propTypes.default.number,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  horizontal: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element, _propTypes.default.func, _propTypes.default.bool]),
	  vertical: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element, _propTypes.default.func, _propTypes.default.bool]),
	  horizontalPoints: _propTypes.default.arrayOf(_propTypes.default.number),
	  verticalPoints: _propTypes.default.arrayOf(_propTypes.default.number),
	  horizontalCoordinatesGenerator: _propTypes.default.func,
	  verticalCoordinatesGenerator: _propTypes.default.func,
	  xAxis: _propTypes.default.object,
	  yAxis: _propTypes.default.object,
	  offset: _propTypes.default.object,
	  chartWidth: _propTypes.default.number,
	  chartHeight: _propTypes.default.number,
	  verticalFill: _propTypes.default.arrayOf(_propTypes.default.string),
	  horizontalFill: _propTypes.default.arrayOf(_propTypes.default.string)
	}), _class2.defaultProps = {
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	  stroke: '#ccc',
	  fill: 'none',
	  // The fill of colors of grid lines
	  verticalFill: [],
	  horizontalFill: []
	}, _temp)) || _class;
	
	var _default = CartesianGrid;
	exports.default = _default;

/***/ },
/* 3061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Area = _interopRequireDefault(__webpack_require__(484));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(203));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(204));
	
	var _CartesianUtils = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Area Chart
	 */
	var _default = (0, _generateCategoricalChart.default)({
	  chartName: 'AreaChart',
	  GraphicalChild: _Area.default,
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis.default
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis.default
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports.default = _default;

/***/ },
/* 3062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Bar = _interopRequireDefault(__webpack_require__(485));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(203));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(204));
	
	var _CartesianUtils = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Bar Chart
	 */
	var _default = (0, _generateCategoricalChart.default)({
	  chartName: 'BarChart',
	  GraphicalChild: _Bar.default,
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis.default
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis.default
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports.default = _default;

/***/ },
/* 3063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Area = _interopRequireDefault(__webpack_require__(484));
	
	var _Bar = _interopRequireDefault(__webpack_require__(485));
	
	var _Line = _interopRequireDefault(__webpack_require__(486));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(487));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(203));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(204));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(340));
	
	var _CartesianUtils = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Composed Chart
	 */
	var _default = (0, _generateCategoricalChart.default)({
	  chartName: 'ComposedChart',
	  GraphicalChild: [_Line.default, _Area.default, _Bar.default, _Scatter.default],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis.default
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis.default
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis.default
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports.default = _default;

/***/ },
/* 3064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Funnel = _interopRequireDefault(__webpack_require__(1001));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Funnel Chart
	 */
	var _default = (0, _generateCategoricalChart.default)({
	  chartName: 'FunnelChart',
	  GraphicalChild: _Funnel.default,
	  eventType: 'item',
	  axisComponents: [],
	  defaultProps: {
	    layout: 'centric'
	  },
	  propTypes: {
	    layout: _propTypes.default.oneOf(['centric'])
	  }
	});
	
	exports.default = _default;

/***/ },
/* 3065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Line = _interopRequireDefault(__webpack_require__(486));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(203));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(204));
	
	var _CartesianUtils = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Line Chart
	 */
	var _default = (0, _generateCategoricalChart.default)({
	  chartName: 'LineChart',
	  GraphicalChild: _Line.default,
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis.default
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis.default
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports.default = _default;

/***/ },
/* 3066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(342));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(343));
	
	var _PolarUtils = __webpack_require__(93);
	
	var _Pie = _interopRequireDefault(__webpack_require__(1002));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Pie Chart
	 */
	var _default = (0, _generateCategoricalChart.default)({
	  chartName: 'PieChart',
	  GraphicalChild: _Pie.default,
	  eventType: 'item',
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis.default
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis.default
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes.default.oneOf(['centric']),
	    startAngle: _propTypes.default.number,
	    endAngle: _propTypes.default.number,
	    cx: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    cy: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    innerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    outerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }
	});
	
	exports.default = _default;

/***/ },
/* 3067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Radar = _interopRequireDefault(__webpack_require__(1003));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(342));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(343));
	
	var _PolarUtils = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Radar Chart
	 */
	var _default = (0, _generateCategoricalChart.default)({
	  chartName: 'RadarChart',
	  GraphicalChild: _Radar.default,
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis.default
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis.default
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 90,
	    endAngle: -270,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes.default.oneOf(['centric']),
	    startAngle: _propTypes.default.number,
	    endAngle: _propTypes.default.number,
	    cx: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    cy: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    innerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    outerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }
	});
	
	exports.default = _default;

/***/ },
/* 3068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(342));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(343));
	
	var _PolarUtils = __webpack_require__(93);
	
	var _RadialBar = _interopRequireDefault(__webpack_require__(1004));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Radar Bar Chart
	 */
	var _default = (0, _generateCategoricalChart.default)({
	  chartName: 'RadialBarChart',
	  GraphicalChild: _RadialBar.default,
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis.default
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis.default
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'radial',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes.default.oneOf(['radial']),
	    startAngle: _propTypes.default.number,
	    endAngle: _propTypes.default.number,
	    cx: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    cy: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    innerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    outerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }
	});
	
	exports.default = _default;

/***/ },
/* 3069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _sumBy2 = _interopRequireDefault(__webpack_require__(677));
	
	var _min2 = _interopRequireDefault(__webpack_require__(672));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(416));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _Surface = _interopRequireDefault(__webpack_require__(251));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(341));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(207));
	
	var _PureRender = _interopRequireWildcard(__webpack_require__(26));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _ChartUtils = __webpack_require__(52);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultCoordinateOfTooltip = {
	  x: 0,
	  y: 0
	};
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return {
	    sourceNodes: sourceNodes,
	    sourceLinks: sourceLinks,
	    targetLinks: targetLinks,
	    targetNodes: targetNodes
	  };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	    return _objectSpread({}, entry, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	
	  var maxDepth = (0, _maxBy2.default)(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return {
	    tree: tree,
	    maxDepth: maxDepth
	  };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min2.default)(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy2.default)(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _objectSpread({}, link, {
	      dy: getValue(link) * yRatio
	    });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length; // Sort by the value of y
	
	    nodes.sort(ascendingY);
	    var y0 = 0;
	
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	  resolveCollisions(depthTree, height, nodePadding);
	  var alpha = 1;
	
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	    resolveCollisions(depthTree, height, nodePadding);
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	  return {
	    nodes: tree,
	    links: newLinks
	  };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return {
	      x: el.x + el.width / 2,
	      y: el.y + el.height / 2
	    };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _ChartUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  if (payload.source && payload.target) {
	    var sourceName = (0, _ChartUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _ChartUtils.getValueByDataKey)(payload.target, nameKey, '');
	    return [{
	      payload: el,
	      name: "".concat(sourceName, " - ").concat(targetName),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey(props) {
	    var _this;
	
	    _classCallCheck(this, Sankey);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sankey).call(this, props));
	    _this.state = _this.constructor.createDefaultState(props);
	    return _this;
	  }
	
	  _createClass(Sankey, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          height = _this$props.height,
	          margin = _this$props.margin,
	          iterations = _this$props.iterations,
	          nodeWidth = _this$props.nodeWidth,
	          nodePadding = _this$props.nodePadding,
	          nameKey = _this$props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _PureRender.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.constructor.createDefaultState(nextProps));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(el, type, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip.default);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(el, type, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: "renderLinks",
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          linkCurvature = _this$props4.linkCurvature,
	          linkContent = _this$props4.link,
	          margin = _this$props4.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-sankey-links",
	        key: "recharts-sankey-links"
	      }, links.map(function (link, i) {
	        var sourceRelativeY = link.sy,
	            targetRelativeY = link.ty,
	            linkWidth = link.dy;
	        var source = nodes[link.source];
	        var target = nodes[link.target];
	        var sourceX = source.x + source.dx + left;
	        var targetX = target.x + left;
	        var interpolationFunc = interpolationGenerator(sourceX, targetX);
	        var sourceControlX = interpolationFunc(linkCurvature);
	        var targetControlX = interpolationFunc(1 - linkCurvature);
	        var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	        var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	        var linkProps = _objectSpread({
	          sourceX: sourceX,
	          targetX: targetX,
	          sourceY: sourceY,
	          targetY: targetY,
	          sourceControlX: sourceControlX,
	          targetControlX: targetControlX,
	          sourceRelativeY: sourceRelativeY,
	          targetRelativeY: targetRelativeY,
	          linkWidth: linkWidth,
	          index: i,
	          payload: _objectSpread({}, link, {
	            source: source,
	            target: target
	          })
	        }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	
	        var events = {
	          onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	          onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
	        };
	        return _react.default.createElement(_Layer.default, _extends({
	          key: "link".concat(i)
	        }, events), _this2.constructor.renderLinkItem(linkContent, linkProps));
	      }));
	    }
	  }, {
	    key: "renderNodes",
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          nodeContent = _this$props5.node,
	          margin = _this$props5.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react.default.createElement(_Layer.default, {
	        className: "recharts-sankey-nodes",
	        key: "recharts-sankey-nodes"
	      }, nodes.map(function (node, i) {
	        var x = node.x,
	            y = node.y,
	            dx = node.dx,
	            dy = node.dy;
	
	        var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	          x: x + left,
	          y: y + top,
	          width: dx,
	          height: dy,
	          index: i,
	          payload: node
	        });
	
	        var events = {
	          onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	          onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
	        };
	        return _react.default.createElement(_Layer.default, _extends({
	          key: "node".concat(i)
	        }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps));
	      }));
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props6 = this.props,
	          children = _this$props6.children,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          nameKey = _this$props6.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeElement = _this$state.activeElement,
	          activeElementType = _this$state.activeElementType;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	      return _react.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          className = _this$props7.className,
	          style = _this$props7.style,
	          children = _this$props7.children,
	          others = _objectWithoutProperties(_this$props7, ["width", "height", "className", "style", "children"]);
	
	      var _this$state2 = this.state,
	          links = _this$state2.links,
	          nodes = _this$state2.nodes;
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react.default.createElement("div", {
	        className: (0, _classnames.default)('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react.default.createElement(_Surface.default, _extends({}, attrs, {
	        width: width,
	        height: height
	      }), (0, _ReactUtils.filterSvgElements)(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations,
	        nodeWidth: nodeWidth,
	        nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes,
	        links: links
	      };
	    }
	  }, {
	    key: "renderLinkItem",
	    value: function renderLinkItem(option, props) {
	      if (_react.default.isValidElement(option)) {
	        return _react.default.cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2.default)(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ["sourceX", "sourceY", "sourceControlX", "targetX", "targetY", "targetControlX", "linkWidth"]);
	
	      return _react.default.createElement("path", _extends({
	        className: "recharts-sankey-link",
	        d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
	        fill: "none",
	        stroke: "#333",
	        strokeWidth: linkWidth,
	        strokeOpacity: "0.2"
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: "renderNodeItem",
	    value: function renderNodeItem(option, props) {
	      if (_react.default.isValidElement(option)) {
	        return _react.default.cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2.default)(option)) {
	        return option(props);
	      }
	
	      return _react.default.createElement(_Rectangle.default, _extends({
	        className: "recharts-sankey-node",
	        fill: "#0088fe",
	        fillOpacity: "0.8"
	      }, props));
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component), _class2.displayName = 'Sankey', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  nameKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  data: _propTypes.default.shape({
	    nodes: _propTypes.default.array,
	    links: _propTypes.default.arrayOf(_propTypes.default.shape({
	      target: _propTypes.default.number,
	      source: _propTypes.default.number,
	      value: _propTypes.default.number
	    }))
	  }),
	  nodePadding: _propTypes.default.number,
	  nodeWidth: _propTypes.default.number,
	  linkCurvature: _propTypes.default.number,
	  iterations: _propTypes.default.number,
	  node: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element, _propTypes.default.func]),
	  link: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element, _propTypes.default.func]),
	  style: _propTypes.default.object,
	  className: _propTypes.default.string,
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  margin: _propTypes.default.shape({
	    top: _propTypes.default.number,
	    right: _propTypes.default.number,
	    bottom: _propTypes.default.number,
	    left: _propTypes.default.number
	  })
	}), _class2.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: {
	    top: 5,
	    right: 5,
	    bottom: 5,
	    left: 5
	  }
	}, _temp)) || _class;
	
	var _default = Sankey;
	exports.default = _default;

/***/ },
/* 3070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(487));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(203));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(204));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(340));
	
	var _CartesianUtils = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Scatter Chart
	 */
	var _default = (0, _generateCategoricalChart.default)({
	  chartName: 'ScatterChart',
	  GraphicalChild: _Scatter.default,
	  eventType: 'single',
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis.default
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis.default
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis.default
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports.default = _default;

/***/ },
/* 3071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(186));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(417));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(293));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(83));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _Surface = _interopRequireDefault(__webpack_require__(251));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(207));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(341));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(344));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _ChartUtils = __webpack_require__(52);
	
	var _Constants = __webpack_require__(3078);
	
	var _DOMUtils = __webpack_require__(346);
	
	var _DataUtils = __webpack_require__(40);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({
	      depth: childDepth,
	      node: child,
	      index: i,
	      valueKey: valueKey
	    });
	  }) : null;
	  var value;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = (0, _isNaN2.default)(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _objectSpread({}, node, {
	    children: computedChildren,
	    value: value,
	    depth: depth,
	    index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return {
	    x: node.x,
	    y: node.y,
	    width: node.width,
	    height: node.height
	  };
	}; // Compute the area for each child based on value & scale.
	
	
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	  return children.map(function (child) {
	    var area = child.value * ratio;
	    return _objectSpread({}, child, {
	      area: (0, _isNaN2.default)(area) || area <= 0 ? 0 : area
	    });
	  });
	}; // Computes the score for the specified row, as the worst aspect ratio.
	
	
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, {
	    min: Infinity,
	    max: 0
	  }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  } // what's z
	
	
	  child.z = true; // add the remain x to the last one of row
	
	  child.width += parentRect.x + parentRect.width - curX;
	  return _objectSpread({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	  return _objectSpread({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	}; // Recursively arranges the specified node's children into squarified rows.
	
	
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	
	    var child, score; // the current row score
	
	    var size = Math.min(rect.width, rect.height); // initial orientation
	
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      // eslint-disable-next-line prefer-destructuring
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	      score = getWorstScore(row, size, aspectRatio);
	
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _objectSpread({}, node, {
	      children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      })
	    });
	  }
	
	  return node;
	};
	
	var Treemap = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Treemap, _Component);
	
	  function Treemap() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Treemap)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = _this.constructor.createDefaultState();
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2.default)(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2.default)(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Treemap, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          width = _this$props.width,
	          height = _this$props.height,
	          data = _this$props.data,
	          dataKey = _this$props.dataKey,
	          aspectRatio = _this$props.aspectRatio;
	
	      var _this$computeRoot = this.computeRoot({
	        type: type,
	        width: width,
	        height: height,
	        data: data,
	        dataKey: dataKey,
	        aspectRatio: aspectRatio
	      }),
	          formatRoot = _this$computeRoot.formatRoot,
	          currentRoot = _this$computeRoot.currentRoot,
	          nestIndex = _this$computeRoot.nestIndex;
	
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: currentRoot,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "computeRoot",
	    value: function computeRoot(_ref2) {
	      var type = _ref2.type,
	          width = _ref2.width,
	          height = _ref2.height,
	          data = _ref2.data,
	          dataKey = _ref2.dataKey,
	          aspectRatio = _ref2.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: {
	          children: data,
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        },
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      var nestIndex = this.state.nestIndex;
	
	      if (type === 'nest') {
	        nestIndex.push(root);
	      }
	
	      return {
	        formatRoot: formatRoot,
	        currentRoot: root,
	        nestIndex: nestIndex
	      };
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var type = nextProps.type,
	          width = nextProps.width,
	          height = nextProps.height,
	          data = nextProps.data,
	          dataKey = nextProps.dataKey,
	          aspectRatio = nextProps.aspectRatio;
	
	      if (data !== this.props.data || type !== this.props.type || width !== this.props.width || height !== this.props.height || dataKey !== this.props.dataKey || aspectRatio !== this.props.aspectRatio) {
	        var nextRoot = this.computeRoot({
	          type: type,
	          width: width,
	          height: height,
	          data: data,
	          dataKey: dataKey,
	          aspectRatio: aspectRatio
	        });
	        this.setState(_objectSpread({}, this.constructor.createDefaultState(), nextRoot, {
	          nestIndex: [nextRoot.currentRoot]
	        }));
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(node, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(node, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(node) {
	      var _this$props4 = this.props,
	          onClick = _this$props4.onClick,
	          type = _this$props4.type;
	
	      if (type === 'nest' && node.children) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height,
	            dataKey = _this$props5.dataKey,
	            aspectRatio = _this$props5.aspectRatio;
	        var root = computeNode({
	          depth: 0,
	          node: _objectSpread({}, node, {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }),
	          index: 0,
	          valueKey: dataKey
	        });
	        var formatRoot = squarify(root, aspectRatio);
	        var nestIndex = this.state.nestIndex;
	        nestIndex.push(node);
	        this.setState({
	          formatRoot: formatRoot,
	          currentRoot: root,
	          nestIndex: nestIndex
	        });
	      }
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: "handleNestIndex",
	    value: function handleNestIndex(node, i) {
	      var nestIndex = this.state.nestIndex;
	      var _this$props6 = this.props,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          dataKey = _this$props6.dataKey,
	          aspectRatio = _this$props6.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: _objectSpread({}, node, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        }),
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      nestIndex = nestIndex.slice(0, i + 1);
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: node,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "renderItem",
	    value: function renderItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _this$props7 = this.props,
	          isAnimationActive = _this$props7.isAnimationActive,
	          animationBegin = _this$props7.animationBegin,
	          animationDuration = _this$props7.animationDuration,
	          animationEasing = _this$props7.animationEasing,
	          isUpdateAnimationActive = _this$props7.isUpdateAnimationActive,
	          type = _this$props7.type,
	          animationId = _this$props7.animationId,
	          colorPanel = _this$props7.colorPanel;
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y,
	          depth = nodeProps.depth;
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf || type === 'nest') {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      if (!isAnimationActive) {
	        return _react.default.createElement(_Layer.default, event, this.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	          isAnimationActive: false,
	          isUpdateAnimationActive: false,
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        }), type, colorPanel));
	      }
	
	      return _react.default.createElement(_reactSmooth.default, {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        key: "treemap-".concat(animationId),
	        from: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        to: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref3) {
	        var currX = _ref3.x,
	            currY = _ref3.y,
	            currWidth = _ref3.width,
	            currHeight = _ref3.height;
	        return _react.default.createElement(_reactSmooth.default, {
	          from: "translate(".concat(translateX, "px, ").concat(translateX, "px)"),
	          to: "translate(0, 0)",
	          attributeName: "transform",
	          begin: animationBegin,
	          easing: animationEasing,
	          isActive: isAnimationActive,
	          duration: animationDuration
	        }, _react.default.createElement(_Layer.default, event, function () {
	          // when animation Duration , only render depth=1 nodes
	          if (depth > 2 && !isAnimationFinished) {
	            return null;
	          }
	
	          return _this2.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	            isAnimationActive: isAnimationActive,
	            isUpdateAnimationActive: !isUpdateAnimationActive,
	            width: currWidth,
	            height: currHeight,
	            x: currX,
	            y: currY
	          }), type, colorPanel);
	        }()));
	      });
	    }
	  }, {
	    key: "renderNode",
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var _this$props8 = this.props,
	          content = _this$props8.content,
	          type = _this$props8.type;
	
	      var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), node, {
	        root: root
	      });
	
	      var isLeaf = !node.children || !node.children.length;
	      var currentRoot = this.state.currentRoot;
	      var isCurrentRootChild = (currentRoot.children || []).filter(function (item) {
	        return item.depth === node.depth && item.name === node.name;
	      });
	
	      if (!isCurrentRootChild.length && root.depth && type === 'nest') {
	        return null;
	      }
	
	      return _react.default.createElement(_Layer.default, {
	        key: "recharts-treemap-node-".concat(i),
	        className: "recharts-treemap-depth-".concat(node.depth)
	      }, this.renderItem(content, nodeProps, isLeaf), node.children && node.children.length ? node.children.map(function (child, index) {
	        return _this3.renderNode(node, child, index);
	      }) : null);
	    }
	  }, {
	    key: "renderAllNodes",
	    value: function renderAllNodes() {
	      var formatRoot = this.state.formatRoot;
	
	      if (!formatRoot) {
	        return null;
	      }
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props9 = this.props,
	          children = _this$props9.children,
	          nameKey = _this$props9.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$props10 = this.props,
	          width = _this$props10.width,
	          height = _this$props10.height,
	          dataKey = _this$props10.dataKey;
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeNode = _this$state.activeNode;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _ChartUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _ChartUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	      return _react.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    } // render nest treemap
	
	  }, {
	    key: "renderNestIndex",
	    value: function renderNestIndex() {
	      var _this4 = this;
	
	      var _this$props11 = this.props,
	          nameKey = _this$props11.nameKey,
	          nestIndexContent = _this$props11.nestIndexContent;
	      var nestIndex = this.state.nestIndex;
	      return _react.default.createElement("div", {
	        className: "recharts-treemap-nest-index-wrapper",
	        style: {
	          marginTop: '8px',
	          textAlign: 'center'
	        }
	      }, nestIndex.map(function (item, i) {
	        var name = (0, _get2.default)(item, nameKey, 'root');
	        var content = null;
	
	        if (_react.default.isValidElement(nestIndexContent)) {
	          content = _react.default.cloneElement(nestIndexContent, item, i);
	        }
	
	        if ((0, _isFunction2.default)(nestIndexContent)) {
	          content = nestIndexContent(item, i);
	        } else {
	          content = name;
	        }
	
	        return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events
	          _react.default.createElement("div", {
	            onClick: _this4.handleNestIndex.bind(_this4, item, i),
	            key: "nest-index-".concat((0, _DataUtils.uniqueId)()),
	            className: "recharts-treemap-nest-index-box",
	            style: {
	              cursor: 'pointer',
	              display: 'inline-block',
	              padding: '0 7px',
	              background: '#000',
	              color: '#fff',
	              marginRight: '3px'
	            }
	          }, content)
	        );
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props12 = this.props,
	          width = _this$props12.width,
	          height = _this$props12.height,
	          className = _this$props12.className,
	          style = _this$props12.style,
	          children = _this$props12.children,
	          type = _this$props12.type,
	          others = _objectWithoutProperties(_this$props12, ["width", "height", "className", "style", "children", "type"]);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react.default.createElement("div", {
	        className: (0, _classnames.default)('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react.default.createElement(_Surface.default, _extends({}, attrs, {
	        width: width,
	        height: type === 'nest' ? height - 30 : height
	      }), this.renderAllNodes(), (0, _ReactUtils.filterSvgElements)(children)), this.renderTooltip(), type === 'nest' && this.renderNestIndex());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        isAnimationFinished: false,
	        activeNode: null,
	        currentRoot: null,
	        formatRoot: null,
	        nestIndex: []
	      };
	    }
	  }, {
	    key: "renderContentItem",
	    value: function renderContentItem(content, nodeProps, type, colorPanel) {
	      if (_react.default.isValidElement(content)) {
	        return _react.default.cloneElement(content, nodeProps);
	      }
	
	      if ((0, _isFunction2.default)(content)) {
	        return content(nodeProps);
	      } // optimize default shape
	
	
	      var x = nodeProps.x,
	          y = nodeProps.y,
	          width = nodeProps.width,
	          height = nodeProps.height,
	          index = nodeProps.index;
	      var arrow = null;
	
	      if (width > 10 && height > 10 && nodeProps.children && type === 'nest') {
	        arrow = _react.default.createElement(_Polygon.default, {
	          points: [{
	            x: x + 2,
	            y: y + height / 2
	          }, {
	            x: x + 6,
	            y: y + height / 2 + 3
	          }, {
	            x: x + 2,
	            y: y + height / 2 + 6
	          }]
	        });
	      }
	
	      var text = null;
	      var nameSize = (0, _DOMUtils.getStringSize)(nodeProps.name);
	
	      if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) {
	        text = _react.default.createElement("text", {
	          x: x + 8,
	          y: y + height / 2 + 7,
	          fontSize: 14
	        }, nodeProps.name);
	      }
	
	      var colors = colorPanel || _Constants.COLOR_PANEL;
	      return _react.default.createElement("g", null, _react.default.createElement(_Rectangle.default, _extends({
	        fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
	        stroke: "#fff"
	      }, (0, _omit2.default)(nodeProps, 'children'))), arrow, text);
	    }
	  }]);
	
	  return Treemap;
	}(_react.Component), _class2.displayName = 'Treemap', _class2.propTypes = {
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  data: _propTypes.default.array,
	  style: _propTypes.default.object,
	  aspectRatio: _propTypes.default.number,
	  content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	  fill: _propTypes.default.string,
	  stroke: _propTypes.default.string,
	  className: _propTypes.default.string,
	  nameKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  dataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]),
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  // optional values flat/nest, flat show whole treemap, nest only show depth=1 node
	  type: _propTypes.default.oneOf(['flat', 'nest']),
	  colorPanel: _propTypes.default.array,
	  // customize nest index content
	  nestIndexContent: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	  onMouseEnter: _propTypes.default.func,
	  onMouseLeave: _propTypes.default.func,
	  onClick: _propTypes.default.func,
	  isAnimationActive: _propTypes.default.bool,
	  isUpdateAnimationActive: _propTypes.default.bool,
	  animationBegin: _propTypes.default.number,
	  animationDuration: _propTypes.default.number,
	  animationEasing: _propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}, _class2.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear',
	  type: 'flat'
	}, _temp)) || _class;
	
	var _default = Treemap;
	exports.default = _default;

/***/ },
/* 3072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Customized;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Layer = _interopRequireDefault(__webpack_require__(43));
	
	var _LogUtils = __webpack_require__(208);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	/**
	 * custom svg elements by rechart instance props and state.
	 * @returns {Object}   svg elements
	 */
	function Customized(_ref) {
	  var component = _ref.component,
	      props = _objectWithoutProperties(_ref, ["component"]);
	
	  var child;
	
	  if ((0, _react.isValidElement)(component)) {
	    child = (0, _react.cloneElement)(component, props);
	  } else if ((0, _isFunction2.default)(component)) {
	    child = component(props);
	  } else {
	    (0, _LogUtils.warn)(false, 'Customized\'s props `component` must be React.element or Function, but got %s.', _typeof(component));
	  }
	
	  return _react.default.createElement(_Layer.default, {
	    className: "recharts-customized-wrapper"
	  }, child);
	}
	
	Customized.displayName = 'Customized';
	Customized.propTypes = {
	  component: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]).isRequired
	};

/***/ },
/* 3073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _Surface = _interopRequireDefault(__webpack_require__(251));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(489));
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SIZE = 32;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DefaultLegendContent, _Component);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultLegendContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: "renderIcon",
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var inactiveColor = this.props.inactiveColor;
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	      var color = data.inactive ? inactiveColor : data.color;
	
	      if (data.type === 'plainline') {
	        return _react.default.createElement("line", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          strokeDasharray: data.payload.strokeDasharray,
	          x1: 0,
	          y1: halfSize,
	          x2: SIZE,
	          y2: halfSize,
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'line') {
	        return _react.default.createElement("path", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'rect') {
	        return _react.default.createElement("path", {
	          stroke: "none",
	          fill: color,
	          d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      return _react.default.createElement(_Symbols.default, {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: "diameter",
	        type: data.type
	      });
	    }
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this = this;
	
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          iconSize = _this$props.iconSize,
	          layout = _this$props.layout,
	          formatter = _this$props.formatter;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: SIZE,
	        height: SIZE
	      };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = {
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        marginRight: 4
	      };
	      return payload.map(function (entry, i) {
	        var _classNames;
	
	        var finalFormatter = entry.formatter || formatter;
	        var className = (0, _classnames.default)((_classNames = {
	          'recharts-legend-item': true
	        }, _defineProperty(_classNames, "legend-item-".concat(i), true), _defineProperty(_classNames, "inactive", entry.inactive), _classNames));
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react.default.createElement("li", _extends({
	          className: className,
	          style: itemStyle,
	          key: "legend-item-".concat(i)
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _react.default.createElement(_Surface.default, {
	          width: iconSize,
	          height: iconSize,
	          viewBox: viewBox,
	          style: svgStyle
	        }, _this.renderIcon(entry)), _react.default.createElement("span", {
	          className: "recharts-legend-item-text"
	        }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          payload = _this$props2.payload,
	          layout = _this$props2.layout,
	          align = _this$props2.align;
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	      return _react.default.createElement("ul", {
	        className: "recharts-default-legend",
	        style: finalStyle
	      }, this.renderItems());
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes.default.element,
	  iconSize: _propTypes.default.number,
	  iconType: _propTypes.default.oneOf(ICON_TYPES),
	  layout: _propTypes.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes.default.oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes.default.arrayOf(_propTypes.default.shape({
	    value: _propTypes.default.any,
	    id: _propTypes.default.any,
	    type: _propTypes.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  inactiveColor: _propTypes.default.string,
	  formatter: _propTypes.default.func,
	  onMouseEnter: _propTypes.default.func,
	  onMouseLeave: _propTypes.default.func,
	  onClick: _propTypes.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle',
	  inactiveColor: '#ccc'
	}, _temp)) || _class;
	
	var _default = DefaultLegendContent;
	exports.default = _default;

/***/ },
/* 3074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(67));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(29));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _DataUtils = __webpack_require__(40);
	
	var _class, _class2, _temp;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray2.default)(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DefaultTooltipContent, _Component);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultTooltipContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: "renderContent",
	    value: function renderContent() {
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          separator = _this$props.separator,
	          formatter = _this$props.formatter,
	          itemStyle = _this$props.itemStyle,
	          itemSorter = _this$props.itemSorter;
	
	      if (payload && payload.length) {
	        var listStyle = {
	          padding: 0,
	          margin: 0
	        };
	        var items = (itemSorter ? (0, _sortBy2.default)(payload, itemSorter) : payload).map(function (entry, i) {
	          if (entry.type === 'none') {
	            return null;
	          }
	
	          var finalItemStyle = _objectSpread({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	          var name = entry.name,
	              value = entry.value;
	
	          if (finalFormatter) {
	            var formatted = finalFormatter(value, name, entry, i);
	
	            if (Array.isArray(formatted)) {
	              var _formatted = _slicedToArray(formatted, 2);
	
	              value = _formatted[0];
	              name = _formatted[1];
	            } else {
	              value = formatted;
	            }
	          }
	
	          return _react.default.createElement("li", {
	            className: "recharts-tooltip-item",
	            key: "tooltip-item-".concat(i),
	            style: finalItemStyle
	          }, (0, _DataUtils.isNumOrStr)(name) ? _react.default.createElement("span", {
	            className: "recharts-tooltip-item-name"
	          }, name) : null, (0, _DataUtils.isNumOrStr)(name) ? _react.default.createElement("span", {
	            className: "recharts-tooltip-item-separator"
	          }, separator) : null, _react.default.createElement("span", {
	            className: "recharts-tooltip-item-value"
	          }, value), _react.default.createElement("span", {
	            className: "recharts-tooltip-item-unit"
	          }, entry.unit || ''));
	        });
	        return _react.default.createElement("ul", {
	          className: "recharts-tooltip-item-list",
	          style: listStyle
	        }, items);
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          wrapperClassName = _this$props2.wrapperClassName,
	          contentStyle = _this$props2.contentStyle,
	          labelClassName = _this$props2.labelClassName,
	          labelStyle = _this$props2.labelStyle,
	          label = _this$props2.label,
	          labelFormatter = _this$props2.labelFormatter;
	
	      var finalStyle = _objectSpread({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, contentStyle);
	
	      var finalLabelStyle = _objectSpread({
	        margin: 0
	      }, labelStyle);
	
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	      var wrapperCN = (0, _classnames.default)('recharts-default-tooltip', wrapperClassName);
	      var labelCN = (0, _classnames.default)('recharts-tooltip-label', labelClassName);
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react.default.createElement("div", {
	        className: wrapperCN,
	        style: finalStyle
	      }, _react.default.createElement("p", {
	        className: labelCN,
	        style: finalLabelStyle
	      }, finalLabel), this.renderContent());
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.Component), _class2.displayName = 'DefaultTooltipContent', _class2.propTypes = {
	  separator: _propTypes.default.string,
	  wrapperClassName: _propTypes.default.string,
	  labelClassName: _propTypes.default.string,
	  formatter: _propTypes.default.func,
	  contentStyle: _propTypes.default.object,
	  itemStyle: _propTypes.default.object,
	  labelStyle: _propTypes.default.object,
	  labelFormatter: _propTypes.default.func,
	  label: _propTypes.default.any,
	  payload: _propTypes.default.arrayOf(_propTypes.default.shape({
	    name: _propTypes.default.any,
	    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.array]),
	    unit: _propTypes.default.any
	  })),
	  itemSorter: _propTypes.default.func
	}, _class2.defaultProps = {
	  separator: ' : ',
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {}
	}, _temp)) || _class;
	
	var _default = DefaultTooltipContent;
	exports.default = _default;

/***/ },
/* 3075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _debounce2 = _interopRequireDefault(__webpack_require__(413));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(16));
	
	var _reactResizeDetector = _interopRequireDefault(__webpack_require__(2999));
	
	var _DataUtils = __webpack_require__(40);
	
	var _LogUtils = __webpack_require__(208);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ResponsiveContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    var _this;
	
	    _classCallCheck(this, ResponsiveContainer);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveContainer).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({
	            containerWidth: containerWidth,
	            containerHeight: containerHeight
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	    _this.handleResize = props.debounce > 0 ? (0, _debounce2.default)(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "getContainerSize",
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: "renderChart",
	    value: function renderChart() {
	      var _this$state2 = this.state,
	          containerWidth = _this$state2.containerWidth,
	          containerHeight = _this$state2.containerHeight;
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _this$props = this.props,
	          aspect = _this$props.aspect,
	          width = _this$props.width,
	          height = _this$props.height,
	          minWidth = _this$props.minWidth,
	          minHeight = _this$props.minHeight,
	          maxHeight = _this$props.maxHeight,
	          children = _this$props.children;
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        if (calculatedWidth) {
	          // Will default to using width for aspect ratio
	          calculatedHeight = calculatedWidth / aspect;
	        } else if (calculatedHeight) {
	          // But we should also take height into consideration
	          calculatedWidth = calculatedHeight * aspect;
	        } // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	
	
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	      return _react.default.cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          minWidth = _this$props2.minWidth,
	          minHeight = _this$props2.minHeight,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          maxHeight = _this$props2.maxHeight,
	          id = _this$props2.id,
	          className = _this$props2.className;
	      var style = {
	        width: width,
	        height: height,
	        minWidth: minWidth,
	        minHeight: minHeight,
	        maxHeight: maxHeight
	      };
	      return _react.default.createElement("div", {
	        id: id,
	        className: (0, _classnames.default)('recharts-responsive-container', className),
	        style: style,
	        ref: function ref(node) {
	          _this2.container = node;
	        }
	      }, this.renderChart(), _react.default.createElement(_reactResizeDetector.default, {
	        handleWidth: true,
	        handleHeight: true,
	        onResize: this.handleResize
	      }));
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component);
	
	ResponsiveContainer.displayName = 'ResponsiveContainer';
	ResponsiveContainer.propTypes = {
	  aspect: _propTypes.default.number,
	  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  minHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  minWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  maxHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  children: _propTypes.default.node.isRequired,
	  debounce: _propTypes.default.number,
	  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
	};
	ResponsiveContainer.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	};
	var _default = ResponsiveContainer;
	exports.default = _default;

/***/ },
/* 3076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PureRender = _interopRequireDefault(__webpack_require__(26));
	
	var _PolarUtils = __webpack_require__(93);
	
	var _ReactUtils = __webpack_require__(25);
	
	var _class, _class2, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarGrid = (0, _PureRender.default)(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(PolarGrid, _Component);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarGrid).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: "getPolygonPath",
	    value: function getPolygonPath(radius) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          polarAngles = _this$props.polarAngles;
	      var path = '';
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += "L ".concat(point.x, ",").concat(point.y);
	        } else {
	          path += "M ".concat(point.x, ",").concat(point.y);
	        }
	      });
	      path += 'Z';
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: "renderPolarAngles",
	    value: function renderPolarAngles() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          innerRadius = _this$props2.innerRadius,
	          outerRadius = _this$props2.outerRadius,
	          polarAngles = _this$props2.polarAngles;
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react.default.createElement("g", {
	        className: "recharts-polar-grid-angle"
	      }, polarAngles.map(function (entry, i) {
	        var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	        var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	        return _react.default.createElement("line", _extends({}, props, {
	          key: "line-".concat(i),
	          x1: start.x,
	          y1: start.y,
	          x2: end.x,
	          y2: end.y
	        }));
	      }));
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: "renderConcentricCircle",
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy;
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react.default.createElement("circle", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-circle",
	        key: "circle-".concat(index),
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: "renderConcentricPolygon",
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react.default.createElement("path", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-polygon",
	        key: "path-".concat(index),
	        d: this.getPolygonPath(radius)
	      }));
	    }
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: "renderConcentricPath",
	    value: function renderConcentricPath() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          polarRadius = _this$props4.polarRadius,
	          gridType = _this$props4.gridType;
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react.default.createElement("g", {
	        className: "recharts-polar-grid-concentric"
	      }, polarRadius.map(function (entry, i) {
	        return gridType === 'circle' ? _this.renderConcentricCircle(entry, i) : _this.renderConcentricPolygon(entry, i);
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react.default.createElement("g", {
	        className: "recharts-polar-grid"
	      }, this.renderPolarAngles(), this.renderConcentricPath());
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.Component), _class2.displayName = 'PolarGrid', _class2.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes.default.number,
	  cy: _propTypes.default.number,
	  innerRadius: _propTypes.default.number,
	  outerRadius: _propTypes.default.number,
	  polarAngles: _propTypes.default.arrayOf(_propTypes.default.number),
	  polarRadius: _propTypes.default.arrayOf(_propTypes.default.number),
	  gridType: _propTypes.default.oneOf(['polygon', 'circle'])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	}, _temp)) || _class;
	
	var _default = PolarGrid;
	exports.default = _default;

/***/ },
/* 3077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1251);
	
	__webpack_require__(1252);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ },
/* 3078 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.COLOR_PANEL = void 0;
	var COLOR_PANEL = ['#1890FF', '#66B5FF', '#41D9C7', '#2FC25B', '#6EDB8F', '#9AE65C', '#FACC14', '#E6965C', '#57AD71', '#223273', '#738AE6', '#7564CC', '#8543E0', '#A877ED', '#5C8EE6', '#13C2C2', '#70E0E0', '#5CA3E6', '#3436C7', '#8082FF', '#DD81E6', '#F04864', '#FA7D92', '#D598D9'];
	exports.COLOR_PANEL = COLOR_PANEL;

/***/ },
/* 3079 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generatePrefixStyle = void 0;
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (!name) {
	    return null;
	  }
	
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var result = PREFIX_LIST.reduce(function (res, entry) {
	    return _objectSpread({}, res, _defineProperty({}, entry + camelName, value));
	  }, {});
	  result[name] = value;
	  return result;
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;

/***/ },
/* 3080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = void 0;
	
	var _events = _interopRequireDefault(__webpack_require__(1391));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventCenter = new _events.default();
	exports.eventCenter = eventCenter;
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	var SYNC_EVENT = 'recharts.syncMouseEvents';
	exports.SYNC_EVENT = SYNC_EVENT;

/***/ },
/* 3081 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 3082 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ },
/* 3083 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ },
/* 3084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(1007);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(1008);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ },
/* 3085 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(540)
	var reduceFunctionCall = __webpack_require__(3086)
	var mexp = __webpack_require__(2689)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 3086 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(540)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 3087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(1016)['default'];
	
	var _regeneratorRuntime = __webpack_require__(1017)['default'];
	
	var _interopRequireDefault = __webpack_require__(492)['default'];
	
	exports.__esModule = true;
	
	var _isomorphicFetch = __webpack_require__(621);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _CALL_API = __webpack_require__(490);
	
	var _CALL_API2 = _interopRequireDefault(_CALL_API);
	
	var _validation = __webpack_require__(1011);
	
	var _errors = __webpack_require__(491);
	
	var _util = __webpack_require__(1010);
	
	/**
	 * A Redux middleware that processes RSAA actions.
	 *
	 * @type {ReduxMiddleware}
	 * @access public
	 */
	function apiMiddleware(_ref) {
	  var _this = this;
	
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function callee$2$0(action) {
	      var validationErrors, _callAPI, _requestType, callAPI, endpoint, headers, method, body, credentials, bailout, types, _normalizeTypeDescriptors, requestType, successType, failureType, res;
	
	      return _regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	        while (1) switch (context$3$0.prev = context$3$0.next) {
	          case 0:
	            if (_validation.isRSAA(action)) {
	              context$3$0.next = 2;
	              break;
	            }
	
	            return context$3$0.abrupt('return', next(action));
	
	          case 2:
	            validationErrors = _validation.validateRSAA(action);
	
	            if (!validationErrors.length) {
	              context$3$0.next = 7;
	              break;
	            }
	
	            _callAPI = action[_CALL_API2['default']];
	
	            if (_callAPI.types && Array.isArray(_callAPI.types)) {
	              _requestType = _callAPI.types[0];
	
	              if (_requestType && _requestType.type) {
	                _requestType = _requestType.type;
	              }
	              next({
	                type: _requestType,
	                payload: new _errors.InvalidRSAA(validationErrors),
	                error: true
	              });
	            }
	            return context$3$0.abrupt('return');
	
	          case 7:
	            callAPI = action[_CALL_API2['default']];
	            endpoint = callAPI.endpoint;
	            headers = callAPI.headers;
	            method = callAPI.method;
	            body = callAPI.body;
	            credentials = callAPI.credentials;
	            bailout = callAPI.bailout;
	            types = callAPI.types;
	            _normalizeTypeDescriptors = _util.normalizeTypeDescriptors(types);
	            requestType = _normalizeTypeDescriptors[0];
	            successType = _normalizeTypeDescriptors[1];
	            failureType = _normalizeTypeDescriptors[2];
	            context$3$0.prev = 19;
	
	            if (!(typeof bailout === 'boolean' && bailout || typeof bailout === 'function' && bailout(getState()))) {
	              context$3$0.next = 22;
	              break;
	            }
	
	            return context$3$0.abrupt('return');
	
	          case 22:
	            context$3$0.next = 30;
	            break;
	
	          case 24:
	            context$3$0.prev = 24;
	            context$3$0.t0 = context$3$0['catch'](19);
	            context$3$0.next = 28;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, requestType, {
	              payload: new _errors.RequestError('[CALL_API].bailout function failed'),
	              error: true
	            }), [action, getState()]));
	
	          case 28:
	            context$3$0.t1 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t1));
	
	          case 30:
	            if (!(typeof endpoint === 'function')) {
	              context$3$0.next = 41;
	              break;
	            }
	
	            context$3$0.prev = 31;
	
	            endpoint = endpoint(getState());
	            context$3$0.next = 41;
	            break;
	
	          case 35:
	            context$3$0.prev = 35;
	            context$3$0.t2 = context$3$0['catch'](31);
	            context$3$0.next = 39;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, requestType, {
	              payload: new _errors.RequestError('[CALL_API].endpoint function failed'),
	              error: true
	            }), [action, getState()]));
	
	          case 39:
	            context$3$0.t3 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t3));
	
	          case 41:
	            if (!(typeof headers === 'function')) {
	              context$3$0.next = 52;
	              break;
	            }
	
	            context$3$0.prev = 42;
	
	            headers = headers(getState());
	            context$3$0.next = 52;
	            break;
	
	          case 46:
	            context$3$0.prev = 46;
	            context$3$0.t4 = context$3$0['catch'](42);
	            context$3$0.next = 50;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, requestType, {
	              payload: new _errors.RequestError('[CALL_API].headers function failed'),
	              error: true
	            }), [action, getState()]));
	
	          case 50:
	            context$3$0.t5 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t5));
	
	          case 52:
	            context$3$0.next = 54;
	            return _regeneratorRuntime.awrap(_util.actionWith(requestType, [action, getState()]));
	
	          case 54:
	            context$3$0.t6 = context$3$0.sent;
	            next(context$3$0.t6);
	            context$3$0.prev = 56;
	            context$3$0.next = 59;
	            return _regeneratorRuntime.awrap(_isomorphicFetch2['default'](endpoint, { method: method, body: body, credentials: credentials, headers: headers || {} }));
	
	          case 59:
	            res = context$3$0.sent;
	            context$3$0.next = 68;
	            break;
	
	          case 62:
	            context$3$0.prev = 62;
	            context$3$0.t7 = context$3$0['catch'](56);
	            context$3$0.next = 66;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, requestType, {
	              payload: new _errors.RequestError(context$3$0.t7.message),
	              error: true
	            }), [action, getState()]));
	
	          case 66:
	            context$3$0.t8 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t8));
	
	          case 68:
	            if (!res.ok) {
	              context$3$0.next = 75;
	              break;
	            }
	
	            context$3$0.next = 71;
	            return _regeneratorRuntime.awrap(_util.actionWith(successType, [action, getState(), res]));
	
	          case 71:
	            context$3$0.t9 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t9));
	
	          case 75:
	            context$3$0.next = 77;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, failureType, {
	              error: true
	            }), [action, getState(), res]));
	
	          case 77:
	            context$3$0.t10 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t10));
	
	          case 79:
	          case 'end':
	            return context$3$0.stop();
	        }
	      }, null, _this, [[19, 24], [31, 35], [42, 46], [56, 62]]);
	    };
	  };
	}
	
	exports.apiMiddleware = apiMiddleware;
	
	// Do not process actions without a [CALL_API] property
	
	// Try to dispatch an error request FSA for invalid RSAAs
	
	// Parse the validated RSAA action
	
	// Should we bail out?
	
	// Process [CALL_API].endpoint function
	
	// Process [CALL_API].headers function
	
	// We can now dispatch the request FSA
	
	// Make the API call
	
	// The request was malformed, or there was a network error
	
	// Process the server response

/***/ },
/* 3088 */
[3142, 3092],
/* 3089 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 3090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$create = __webpack_require__(1012)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(1013)["default"];
	
	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	exports.__esModule = true;

/***/ },
/* 3091 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	"use strict";
	
	var _Symbol = __webpack_require__(1015)["default"];
	
	var _Object$create = __webpack_require__(1012)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(1013)["default"];
	
	var _Promise = __webpack_require__(1014)["default"];
	
	!(function (global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof _Symbol === "function" ? _Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = _Object$create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      prototype[method] = function (arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction ||
	    // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };
	
	  runtime.mark = function (genFun) {
	    if (_Object$setPrototypeOf) {
	      _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = _Object$create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function (arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return _Promise.resolve(value.arg).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return _Promise.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new _Promise(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	      // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	      // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
	
	    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" || method === "throw" && delegate.iterator[method] === undefined) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(delegate.iterator[method], delegate.iterator, arg);
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function () {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function () {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function (object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function reset(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function stop() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function dispatchException(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function complete(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	// Among the various tricks for obtaining a reference to the global
	// object, this seems to be the most reliable technique that does not
	// use indirect eval (which violates Content Security Policy).
	typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(191)))

/***/ },
/* 3092 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3124);
	module.exports = __webpack_require__(131).Object.assign;

/***/ },
/* 3093 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(76);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ },
/* 3094 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3125);
	module.exports = __webpack_require__(131).Object.setPrototypeOf;

/***/ },
/* 3095 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1025);
	__webpack_require__(3127);
	__webpack_require__(3129);
	__webpack_require__(3126);
	module.exports = __webpack_require__(131).Promise;

/***/ },
/* 3096 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3128);
	__webpack_require__(1025);
	module.exports = __webpack_require__(131).Symbol;

/***/ },
/* 3097 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 3098 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(348)
	  , document = __webpack_require__(116).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 3099 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(76);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ },
/* 3100 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(253)
	  , call        = __webpack_require__(3106)
	  , isArrayIter = __webpack_require__(3104)
	  , anObject    = __webpack_require__(209)
	  , toLength    = __webpack_require__(3120)
	  , getIterFn   = __webpack_require__(3122);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ },
/* 3101 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(350)
	  , getNames  = __webpack_require__(76).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ },
/* 3102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(116).document && document.documentElement;

/***/ },
/* 3103 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 3104 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(255)
	  , ITERATOR   = __webpack_require__(94)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 3105 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(252);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 3106 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(209);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 3107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(76)
	  , descriptor     = __webpack_require__(499)
	  , setToStringTag = __webpack_require__(349)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(497)(IteratorPrototype, __webpack_require__(94)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 3108 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(94)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 3109 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 3110 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(76)
	  , toIObject = __webpack_require__(350);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 3111 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(116)
	  , macrotask = __webpack_require__(3119).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(252)(process) == 'process'
	  , head, last, notify;
	
	var flush = function(){
	  var parent, domain, fn;
	  if(isNode && (parent = process.domain)){
	    process.domain = null;
	    parent.exit();
	  }
	  while(head){
	    domain = head.domain;
	    fn     = head.fn;
	    if(domain)domain.enter();
	    fn(); // <- currently we use it only for Promise - try / catch not required
	    if(domain)domain.exit();
	    head = head.next;
	  } last = undefined;
	  if(parent)parent.enter();
	};
	
	// Node.js
	if(isNode){
	  notify = function(){
	    process.nextTick(flush);
	  };
	// browsers with MutationObserver
	} else if(Observer){
	  var toggle = 1
	    , node   = document.createTextNode('');
	  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	  notify = function(){
	    node.data = toggle = -toggle;
	  };
	// environments with maybe non-completely correct, but existent Promise
	} else if(Promise && Promise.resolve){
	  notify = function(){
	    Promise.resolve().then(flush);
	  };
	// for other environments - macrotask based on:
	// - setImmediate
	// - MessageChannel
	// - window.postMessag
	// - onreadystatechange
	// - setTimeout
	} else {
	  notify = function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    macrotask.call(global, flush);
	  };
	}
	
	module.exports = function asap(fn){
	  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
	  if(last)last.next = task;
	  if(!head){
	    head = task;
	    notify();
	  } last = task;
	};

/***/ },
/* 3112 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(76)
	  , toObject = __webpack_require__(3121)
	  , IObject  = __webpack_require__(1019);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(495)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ },
/* 3113 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(500);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ },
/* 3114 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 3115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var core        = __webpack_require__(131)
	  , $           = __webpack_require__(76)
	  , DESCRIPTORS = __webpack_require__(347)
	  , SPECIES     = __webpack_require__(94)('species');
	
	module.exports = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 3116 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(209)
	  , aFunction = __webpack_require__(493)
	  , SPECIES   = __webpack_require__(94)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 3117 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ },
/* 3118 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(1023)
	  , defined   = __webpack_require__(494);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 3119 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(253)
	  , invoke             = __webpack_require__(3103)
	  , html               = __webpack_require__(3102)
	  , cel                = __webpack_require__(3098)
	  , global             = __webpack_require__(116)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listner = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(252)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listner, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 3120 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(1023)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 3121 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(494);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 3122 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(1018)
	  , ITERATOR  = __webpack_require__(94)('iterator')
	  , Iterators = __webpack_require__(255);
	module.exports = __webpack_require__(131).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 3123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(3097)
	  , step             = __webpack_require__(3109)
	  , Iterators        = __webpack_require__(255)
	  , toIObject        = __webpack_require__(350);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(1020)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 3124 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(254);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(3112)});

/***/ },
/* 3125 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(254);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(1021).set});

/***/ },
/* 3126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(76)
	  , LIBRARY    = __webpack_require__(498)
	  , global     = __webpack_require__(116)
	  , ctx        = __webpack_require__(253)
	  , classof    = __webpack_require__(1018)
	  , $export    = __webpack_require__(254)
	  , isObject   = __webpack_require__(348)
	  , anObject   = __webpack_require__(209)
	  , aFunction  = __webpack_require__(493)
	  , strictNew  = __webpack_require__(3117)
	  , forOf      = __webpack_require__(3100)
	  , setProto   = __webpack_require__(1021).set
	  , same       = __webpack_require__(3114)
	  , SPECIES    = __webpack_require__(94)('species')
	  , speciesConstructor = __webpack_require__(3116)
	  , asap       = __webpack_require__(3111)
	  , PROMISE    = 'Promise'
	  , process    = global.process
	  , isNode     = classof(process) == 'process'
	  , P          = global[PROMISE]
	  , empty      = function(){ /* empty */ }
	  , Wrapper;
	
	var testResolve = function(sub){
	  var test = new P(empty), promise;
	  if(sub)test.constructor = function(exec){
	    exec(empty, empty);
	  };
	  (promise = P.resolve(test))['catch'](empty);
	  return promise === test;
	};
	
	var USE_NATIVE = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = P && P.resolve && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && __webpack_require__(347)){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // library wrapper special case
	  if(LIBRARY && a === P && b === Wrapper)return true;
	  return same(a, b);
	};
	var getConstructor = function(C){
	  var S = anObject(C)[SPECIES];
	  return S != undefined ? S : C;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var PromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve),
	  this.reject  = aFunction(reject)
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(record, isReject){
	  if(record.n)return;
	  record.n = true;
	  var chain = record.c;
	  asap(function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , result, then;
	      try {
	        if(handler){
	          if(!ok)record.h = true;
	          result = handler === true ? value : handler(value);
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	    record.n = false;
	    if(isReject)setTimeout(function(){
	      var promise = record.p
	        , handler, console;
	      if(isUnhandled(promise)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      } record.a = undefined;
	    }, 1);
	  });
	};
	var isUnhandled = function(promise){
	  var record = promise._d
	    , chain  = record.a || record.c
	    , i      = 0
	    , reaction;
	  if(record.h)return false;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var $reject = function(value){
	  var record = this;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  notify(record, true);
	};
	var $resolve = function(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(record.p === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      asap(function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record, false);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    aFunction(executor);
	    var record = this._d = {
	      p: strictNew(this, P, PROMISE),         // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false,                               // <- handled rejection
	      n: false                                // <- notify
	    };
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(3113)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction = new PromiseCapability(speciesConstructor(this, P))
	        , promise  = reaction.promise
	        , record   = this._d;
	      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      record.c.push(reaction);
	      if(record.a)record.a.push(reaction);
	      if(record.s)notify(record, false);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
	__webpack_require__(349)(P, PROMISE);
	__webpack_require__(3115)(PROMISE);
	Wrapper = __webpack_require__(131)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = new PromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof P && sameConstructor(x.constructor, this))return x;
	    var capability = new PromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(3108)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject
	      , values     = [];
	    var abrupt = perform(function(){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        var alreadyCalled = false;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled = true;
	          results[index] = value;
	          --remaining || resolve(results);
	        }, reject);
	      });
	      else resolve(results);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 3127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(3118)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(1020)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 3128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(76)
	  , global         = __webpack_require__(116)
	  , has            = __webpack_require__(496)
	  , DESCRIPTORS    = __webpack_require__(347)
	  , $export        = __webpack_require__(254)
	  , redefine       = __webpack_require__(500)
	  , $fails         = __webpack_require__(495)
	  , shared         = __webpack_require__(1022)
	  , setToStringTag = __webpack_require__(349)
	  , uid            = __webpack_require__(1024)
	  , wks            = __webpack_require__(94)
	  , keyOf          = __webpack_require__(3110)
	  , $names         = __webpack_require__(3101)
	  , enumKeys       = __webpack_require__(3099)
	  , isArray        = __webpack_require__(3105)
	  , anObject       = __webpack_require__(209)
	  , toIObject      = __webpack_require__(350)
	  , createDesc     = __webpack_require__(499)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(498)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 3129 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3123);
	var Iterators = __webpack_require__(255);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ },
/* 3130 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 3131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(1026);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 3132 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 3133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(1027);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(1028);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 3134 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3135 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 3136 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 3137 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(3138);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(132)(module)))

/***/ },
/* 3138 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 3139 */
/***/ function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ },
/* 3140 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 3141 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 3142 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ },
/* 3143 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ },
/* 3144 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ },
/* 3145 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ },
/* 3146 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 3147 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 3148 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 3149 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 3150 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 3151 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 3152 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 3153 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 3154 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 3155 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 3156 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 3157 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 3158 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 3159 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 3160 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 3161 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 3162 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 3163 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 3164 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 3165 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 3166 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 3167 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 3168 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 3169 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 3170 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 3171 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 3172 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 3173 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 3174 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 3175 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 3176 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 3177 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 3178 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 3179 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__),
	    stackClear = __webpack_require__(__webpack_module_template_argument_1__),
	    stackDelete = __webpack_require__(__webpack_module_template_argument_2__),
	    stackGet = __webpack_require__(__webpack_module_template_argument_3__),
	    stackHas = __webpack_require__(__webpack_module_template_argument_4__),
	    stackSet = __webpack_require__(__webpack_module_template_argument_5__);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 3180 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 3181 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 3182 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 3183 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseAssignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    eq = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 3184 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var eq = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 3185 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseForOwn = __webpack_require__(__webpack_module_template_argument_0__),
	    createBaseEach = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 3186 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayPush = __webpack_require__(__webpack_module_template_argument_0__),
	    isFlattenable = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 3187 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var createBaseFor = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 3188 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseFor = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 3189 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseFindIndex = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIsNaN = __webpack_require__(__webpack_module_template_argument_1__),
	    strictIndexOf = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 3190 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
	    isMasked = __webpack_require__(__webpack_module_template_argument_1__),
	    isObject = __webpack_require__(__webpack_module_template_argument_2__),
	    toSource = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 3191 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var baseMatches = __webpack_require__(__webpack_module_template_argument_0__),
	    baseMatchesProperty = __webpack_require__(__webpack_module_template_argument_1__),
	    identity = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__),
	    property = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 3192 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isPrototype = __webpack_require__(__webpack_module_template_argument_0__),
	    nativeKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 3193 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsMatch = __webpack_require__(__webpack_module_template_argument_0__),
	    getMatchData = __webpack_require__(__webpack_module_template_argument_1__),
	    matchesStrictComparable = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 3194 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 3195 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var identity = __webpack_require__(__webpack_module_template_argument_0__),
	    overRest = __webpack_require__(__webpack_module_template_argument_1__),
	    setToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 3196 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var assignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    baseAssignValue = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 3197 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 3198 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseRest = __webpack_require__(__webpack_module_template_argument_0__),
	    isIterateeCall = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 3199 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isArrayLike = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 3200 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var flatten = __webpack_require__(__webpack_module_template_argument_0__),
	    overRest = __webpack_require__(__webpack_module_template_argument_1__),
	    setToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 3201 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isKeyable = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 3202 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isStrictComparable = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 3203 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsNative = __webpack_require__(__webpack_module_template_argument_0__),
	    getValue = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 3204 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 3205 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 3206 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 3207 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 3208 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var eq = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_2__),
	    isObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 3209 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isArray = __webpack_require__(__webpack_module_template_argument_0__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 3210 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var coreJsData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 3211 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 3212 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 3213 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 3214 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 3215 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 3216 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Hash = __webpack_require__(__webpack_module_template_argument_0__),
	    ListCache = __webpack_require__(__webpack_module_template_argument_1__),
	    Map = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 3217 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 3218 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 3219 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 3220 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 3221 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var memoize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 3222 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 3223 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 3224 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var apply = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 3225 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 3226 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseSetToString = __webpack_require__(__webpack_module_template_argument_0__),
	    shortOut = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 3227 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 3228 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__),
	    Map = __webpack_require__(__webpack_module_template_argument_1__),
	    MapCache = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 3229 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isSymbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 3230 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var assignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    copyObject = __webpack_require__(__webpack_module_template_argument_1__),
	    createAssigner = __webpack_require__(__webpack_module_template_argument_2__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_3__),
	    isPrototype = __webpack_require__(__webpack_module_template_argument_4__),
	    keys = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 3231 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 3232 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseHasIn = __webpack_require__(__webpack_module_template_argument_0__),
	    hasPath = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 3233 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
	    isLength = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 3234 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isArrayLike = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 3235 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsTypedArray = __webpack_require__(__webpack_module_template_argument_0__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_1__),
	    nodeUtil = __webpack_require__(__webpack_module_template_argument_2__);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 3236 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var arrayLikeKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    baseKeys = __webpack_require__(__webpack_module_template_argument_1__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 3237 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseProperty = __webpack_require__(__webpack_module_template_argument_0__),
	    basePropertyDeep = __webpack_require__(__webpack_module_template_argument_1__),
	    isKey = __webpack_require__(__webpack_module_template_argument_2__),
	    toKey = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 3238 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var arrayReduce = __webpack_require__(__webpack_module_template_argument_0__),
	    baseEach = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__),
	    baseReduce = __webpack_require__(__webpack_module_template_argument_3__),
	    isArray = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 3239 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toNumber = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 3240 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toFinite = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 3241 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 3242 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 3243 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 3244 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 3245 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 3246 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(__webpack_module_template_argument_9__);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 3247 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.f0aab915.js